import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Emailingnumeric: { input: any; output: any; }
  Emailingtimestamptz: { input: any; output: any; }
  Geodatabigint: { input: any; output: any; }
  Geodatageography: { input: any; output: any; }
  Geodatageometry: { input: any; output: any; }
  Geodatatimestamptz: { input: any; output: any; }
  Geodatauuid: { input: any; output: any; }
  Registrydate: { input: any; output: any; }
  Registryjsonb: { input: any; output: any; }
  Registrynumeric: { input: any; output: any; }
  Registrytimestamptz: { input: any; output: any; }
  Registryuuid: { input: any; output: any; }
  Taskjson: { input: any; output: any; }
  Taskjsonb: { input: any; output: any; }
  Tasktimestamptz: { input: any; output: any; }
  Telephonyjsonb: { input: any; output: any; }
  Telephonytimestamptz: { input: any; output: any; }
  json: { input: { [key: string]: any }; output: { [key: string]: any }; }
  jsonb: { input: { [key: string]: any }; output: { [key: string]: any }; }
  numeric: { input: number; output: number; }
  timestamp: { input: string | object; output: string; }
  timestamptz: { input: string | object; output: string; }
  timetz: { input: any; output: any; }
  uuid: { input: string; output: string; }
};

/** columns and relationships of "business.direction" */
export type ActivityDirection = {
  __typename?: 'ActivityDirection';
  value: Scalars['String']['output'];
};

/** aggregated selection of "business.direction" */
export type ActivityDirectionAggregate = {
  __typename?: 'ActivityDirectionAggregate';
  aggregate?: Maybe<ActivityDirectionAggregateFields>;
  nodes: Array<ActivityDirection>;
};

/** aggregate fields of "business.direction" */
export type ActivityDirectionAggregateFields = {
  __typename?: 'ActivityDirectionAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<ActivityDirectionMaxFields>;
  min?: Maybe<ActivityDirectionMinFields>;
};


/** aggregate fields of "business.direction" */
export type ActivityDirectionAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<ActivityDirectionSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.direction". All fields are combined with a logical 'AND'. */
export type ActivityDirectionBoolExp = {
  _and?: InputMaybe<Array<ActivityDirectionBoolExp>>;
  _not?: InputMaybe<ActivityDirectionBoolExp>;
  _or?: InputMaybe<Array<ActivityDirectionBoolExp>>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.direction" */
export type ActivityDirectionConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'direction_pkey'
  | '%future added value';

export type ActivityDirectionEnum =
  | 'INCOMING'
  | 'OUTGOING'
  | 'UNDEFINED'
  | '%future added value';

/** Boolean expression to compare columns of type "ActivityDirectionEnum". All fields are combined with logical 'AND'. */
export type ActivityDirectionEnumComparisonExp = {
  _eq?: InputMaybe<ActivityDirectionEnum>;
  _in?: InputMaybe<Array<ActivityDirectionEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<ActivityDirectionEnum>;
  _nin?: InputMaybe<Array<ActivityDirectionEnum>>;
};

/** input type for inserting data into table "business.direction" */
export type ActivityDirectionInsertInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ActivityDirectionMaxFields = {
  __typename?: 'ActivityDirectionMaxFields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ActivityDirectionMinFields = {
  __typename?: 'ActivityDirectionMinFields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.direction" */
export type ActivityDirectionMutationResponse = {
  __typename?: 'ActivityDirectionMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ActivityDirection>;
};

/** on_conflict condition type for table "business.direction" */
export type ActivityDirectionOnConflict = {
  constraint: ActivityDirectionConstraint;
  updateColumns?: Array<ActivityDirectionUpdateColumn>;
  where?: InputMaybe<ActivityDirectionBoolExp>;
};

/** Ordering options when selecting data from "business.direction". */
export type ActivityDirectionOrderBy = {
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.direction */
export type ActivityDirectionPkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "business.direction" */
export type ActivityDirectionSelectColumn =
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "business.direction" */
export type ActivityDirectionSetInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "ActivityDirection" */
export type ActivityDirectionStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ActivityDirectionStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ActivityDirectionStreamCursorValueInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.direction" */
export type ActivityDirectionUpdateColumn =
  /** column name */
  | 'value'
  | '%future added value';

export type ActivityDirectionUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ActivityDirectionSetInput>;
  /** filter the rows which have to be updated */
  where: ActivityDirectionBoolExp;
};

/** columns and relationships of "business.provider" */
export type ActivityProvider = {
  __typename?: 'ActivityProvider';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "business.provider" */
export type ActivityProviderAggregate = {
  __typename?: 'ActivityProviderAggregate';
  aggregate?: Maybe<ActivityProviderAggregateFields>;
  nodes: Array<ActivityProvider>;
};

/** aggregate fields of "business.provider" */
export type ActivityProviderAggregateFields = {
  __typename?: 'ActivityProviderAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<ActivityProviderMaxFields>;
  min?: Maybe<ActivityProviderMinFields>;
};


/** aggregate fields of "business.provider" */
export type ActivityProviderAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<ActivityProviderSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.provider". All fields are combined with a logical 'AND'. */
export type ActivityProviderBoolExp = {
  _and?: InputMaybe<Array<ActivityProviderBoolExp>>;
  _not?: InputMaybe<ActivityProviderBoolExp>;
  _or?: InputMaybe<Array<ActivityProviderBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.provider" */
export type ActivityProviderConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'provider_pkey'
  | '%future added value';

export type ActivityProviderEnum =
  /** CISCO */
  | 'CISCO'
  /** gmail integration */
  | 'GMAIL'
  /** outlook integration */
  | 'OUTLOOK'
  /** phonero */
  | 'PHONERO'
  /** telenor */
  | 'TELENOR'
  /** telia integration */
  | 'TELIA'
  /** youtello */
  | 'YOUTELLO'
  | '%future added value';

/** Boolean expression to compare columns of type "ActivityProviderEnum". All fields are combined with logical 'AND'. */
export type ActivityProviderEnumComparisonExp = {
  _eq?: InputMaybe<ActivityProviderEnum>;
  _in?: InputMaybe<Array<ActivityProviderEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<ActivityProviderEnum>;
  _nin?: InputMaybe<Array<ActivityProviderEnum>>;
};

/** input type for inserting data into table "business.provider" */
export type ActivityProviderInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ActivityProviderMaxFields = {
  __typename?: 'ActivityProviderMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ActivityProviderMinFields = {
  __typename?: 'ActivityProviderMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.provider" */
export type ActivityProviderMutationResponse = {
  __typename?: 'ActivityProviderMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ActivityProvider>;
};

/** on_conflict condition type for table "business.provider" */
export type ActivityProviderOnConflict = {
  constraint: ActivityProviderConstraint;
  updateColumns?: Array<ActivityProviderUpdateColumn>;
  where?: InputMaybe<ActivityProviderBoolExp>;
};

/** Ordering options when selecting data from "business.provider". */
export type ActivityProviderOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.provider */
export type ActivityProviderPkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "business.provider" */
export type ActivityProviderSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "business.provider" */
export type ActivityProviderSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "ActivityProvider" */
export type ActivityProviderStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ActivityProviderStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ActivityProviderStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.provider" */
export type ActivityProviderUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type ActivityProviderUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ActivityProviderSetInput>;
  /** filter the rows which have to be updated */
  where: ActivityProviderBoolExp;
};

/** Aktivitetsstatus */
export type ActivityStatus = {
  __typename?: 'ActivityStatus';
  /** An array relationship */
  activities: Array<domainActivity>;
  /** An aggregate relationship */
  activitiesAggregate: domainActivityAggregate;
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};


/** Aktivitetsstatus */
export type ActivityStatusactivitiesArgs = {
  distinctOn?: InputMaybe<Array<domainActivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainActivityOrderBy>>;
  where?: InputMaybe<domainActivityBoolExp>;
};


/** Aktivitetsstatus */
export type ActivityStatusactivitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<domainActivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainActivityOrderBy>>;
  where?: InputMaybe<domainActivityBoolExp>;
};

/** aggregated selection of "business.activity_status" */
export type ActivityStatusAggregate = {
  __typename?: 'ActivityStatusAggregate';
  aggregate?: Maybe<ActivityStatusAggregateFields>;
  nodes: Array<ActivityStatus>;
};

/** aggregate fields of "business.activity_status" */
export type ActivityStatusAggregateFields = {
  __typename?: 'ActivityStatusAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<ActivityStatusMaxFields>;
  min?: Maybe<ActivityStatusMinFields>;
};


/** aggregate fields of "business.activity_status" */
export type ActivityStatusAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<ActivityStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.activity_status". All fields are combined with a logical 'AND'. */
export type ActivityStatusBoolExp = {
  _and?: InputMaybe<Array<ActivityStatusBoolExp>>;
  _not?: InputMaybe<ActivityStatusBoolExp>;
  _or?: InputMaybe<Array<ActivityStatusBoolExp>>;
  activities?: InputMaybe<domainActivityBoolExp>;
  activitiesAggregate?: InputMaybe<domainActivityAggregateBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.activity_status" */
export type ActivityStatusConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'activity_status_pkey'
  | '%future added value';

export type ActivityStatusEnum =
  /** Assigned */
  | 'ASSIGNED'
  /** blocked */
  | 'BLOCKED'
  /** Done */
  | 'DONE'
  /** hidden from view */
  | 'HIDDEN'
  /** In progress */
  | 'INPROGRESS'
  /** logged */
  | 'LOGGED'
  /** Paused */
  | 'PAUSED'
  /** This item will be deleted from database */
  | 'SCHEDULED_FOR_DELETION'
  /** Unassigned */
  | 'UNASSIGNED'
  | '%future added value';

/** Boolean expression to compare columns of type "ActivityStatusEnum". All fields are combined with logical 'AND'. */
export type ActivityStatusEnumComparisonExp = {
  _eq?: InputMaybe<ActivityStatusEnum>;
  _in?: InputMaybe<Array<ActivityStatusEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<ActivityStatusEnum>;
  _nin?: InputMaybe<Array<ActivityStatusEnum>>;
};

/** input type for inserting data into table "business.activity_status" */
export type ActivityStatusInsertInput = {
  activities?: InputMaybe<domainActivityArrRelInsertInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ActivityStatusMaxFields = {
  __typename?: 'ActivityStatusMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ActivityStatusMinFields = {
  __typename?: 'ActivityStatusMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.activity_status" */
export type ActivityStatusMutationResponse = {
  __typename?: 'ActivityStatusMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ActivityStatus>;
};

/** input type for inserting object relation for remote table "business.activity_status" */
export type ActivityStatusObjRelInsertInput = {
  data: ActivityStatusInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ActivityStatusOnConflict>;
};

/** on_conflict condition type for table "business.activity_status" */
export type ActivityStatusOnConflict = {
  constraint: ActivityStatusConstraint;
  updateColumns?: Array<ActivityStatusUpdateColumn>;
  where?: InputMaybe<ActivityStatusBoolExp>;
};

/** Ordering options when selecting data from "business.activity_status". */
export type ActivityStatusOrderBy = {
  activitiesAggregate?: InputMaybe<domainActivityAggregateOrderBy>;
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.activity_status */
export type ActivityStatusPkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "business.activity_status" */
export type ActivityStatusSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "business.activity_status" */
export type ActivityStatusSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "ActivityStatus" */
export type ActivityStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ActivityStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ActivityStatusStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.activity_status" */
export type ActivityStatusUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type ActivityStatusUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ActivityStatusSetInput>;
  /** filter the rows which have to be updated */
  where: ActivityStatusBoolExp;
};

/** Aktivitetstype */
export type ActivityType = {
  __typename?: 'ActivityType';
  /** An array relationship */
  activities: Array<domainActivity>;
  /** An aggregate relationship */
  activitiesAggregate: domainActivityAggregate;
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};


/** Aktivitetstype */
export type ActivityTypeactivitiesArgs = {
  distinctOn?: InputMaybe<Array<domainActivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainActivityOrderBy>>;
  where?: InputMaybe<domainActivityBoolExp>;
};


/** Aktivitetstype */
export type ActivityTypeactivitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<domainActivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainActivityOrderBy>>;
  where?: InputMaybe<domainActivityBoolExp>;
};

/** aggregated selection of "business.activity_type" */
export type ActivityTypeAggregate = {
  __typename?: 'ActivityTypeAggregate';
  aggregate?: Maybe<ActivityTypeAggregateFields>;
  nodes: Array<ActivityType>;
};

/** aggregate fields of "business.activity_type" */
export type ActivityTypeAggregateFields = {
  __typename?: 'ActivityTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<ActivityTypeMaxFields>;
  min?: Maybe<ActivityTypeMinFields>;
};


/** aggregate fields of "business.activity_type" */
export type ActivityTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<ActivityTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.activity_type". All fields are combined with a logical 'AND'. */
export type ActivityTypeBoolExp = {
  _and?: InputMaybe<Array<ActivityTypeBoolExp>>;
  _not?: InputMaybe<ActivityTypeBoolExp>;
  _or?: InputMaybe<Array<ActivityTypeBoolExp>>;
  activities?: InputMaybe<domainActivityBoolExp>;
  activitiesAggregate?: InputMaybe<domainActivityAggregateBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.activity_type" */
export type ActivityTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'activity_type_pkey'
  | '%future added value';

export type ActivityTypeEnum =
  /** action */
  | 'ACTION'
  /** call */
  | 'CALL'
  /** callback task */
  | 'CALLBACK'
  /** call to */
  | 'CALLTO'
  /** conference */
  | 'CONFERENCE'
  /** draft type */
  | 'DRAFT'
  /** General */
  | 'GENERAL'
  /** received or sent */
  | 'MAIL'
  /** Messaging */
  | 'MESSAGING'
  /** reminder task */
  | 'REMINDER'
  /** sent */
  | 'SENT'
  /** Task */
  | 'TASK'
  | '%future added value';

/** Boolean expression to compare columns of type "ActivityTypeEnum". All fields are combined with logical 'AND'. */
export type ActivityTypeEnumComparisonExp = {
  _eq?: InputMaybe<ActivityTypeEnum>;
  _in?: InputMaybe<Array<ActivityTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<ActivityTypeEnum>;
  _nin?: InputMaybe<Array<ActivityTypeEnum>>;
};

/** input type for inserting data into table "business.activity_type" */
export type ActivityTypeInsertInput = {
  activities?: InputMaybe<domainActivityArrRelInsertInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ActivityTypeMaxFields = {
  __typename?: 'ActivityTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ActivityTypeMinFields = {
  __typename?: 'ActivityTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.activity_type" */
export type ActivityTypeMutationResponse = {
  __typename?: 'ActivityTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ActivityType>;
};

/** input type for inserting object relation for remote table "business.activity_type" */
export type ActivityTypeObjRelInsertInput = {
  data: ActivityTypeInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ActivityTypeOnConflict>;
};

/** on_conflict condition type for table "business.activity_type" */
export type ActivityTypeOnConflict = {
  constraint: ActivityTypeConstraint;
  updateColumns?: Array<ActivityTypeUpdateColumn>;
  where?: InputMaybe<ActivityTypeBoolExp>;
};

/** Ordering options when selecting data from "business.activity_type". */
export type ActivityTypeOrderBy = {
  activitiesAggregate?: InputMaybe<domainActivityAggregateOrderBy>;
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.activity_type */
export type ActivityTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "business.activity_type" */
export type ActivityTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "business.activity_type" */
export type ActivityTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "ActivityType" */
export type ActivityTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ActivityTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ActivityTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.activity_type" */
export type ActivityTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type ActivityTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ActivityTypeSetInput>;
  /** filter the rows which have to be updated */
  where: ActivityTypeBoolExp;
};

export type AddDomainUserToOrganizationOutput = {
  __typename?: 'AddDomainUserToOrganizationOutput';
  status: Scalars['String']['output'];
};

export type BlockUserOutput = {
  __typename?: 'BlockUserOutput';
  status?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type BooleanComparisonExp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type BusinessAddress = {
  __typename?: 'BusinessAddress';
  city?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "business.domain_activity_type" */
export type BusinessDomainActivityType = {
  __typename?: 'BusinessDomainActivityType';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "business.domain_activity_type" */
export type BusinessDomainActivityTypeAggregate = {
  __typename?: 'BusinessDomainActivityTypeAggregate';
  aggregate?: Maybe<BusinessDomainActivityTypeAggregateFields>;
  nodes: Array<BusinessDomainActivityType>;
};

/** aggregate fields of "business.domain_activity_type" */
export type BusinessDomainActivityTypeAggregateFields = {
  __typename?: 'BusinessDomainActivityTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BusinessDomainActivityTypeMaxFields>;
  min?: Maybe<BusinessDomainActivityTypeMinFields>;
};


/** aggregate fields of "business.domain_activity_type" */
export type BusinessDomainActivityTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<BusinessDomainActivityTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.domain_activity_type". All fields are combined with a logical 'AND'. */
export type BusinessDomainActivityTypeBoolExp = {
  _and?: InputMaybe<Array<BusinessDomainActivityTypeBoolExp>>;
  _not?: InputMaybe<BusinessDomainActivityTypeBoolExp>;
  _or?: InputMaybe<Array<BusinessDomainActivityTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.domain_activity_type" */
export type BusinessDomainActivityTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'domain_activity_type_pkey'
  | '%future added value';

/** input type for inserting data into table "business.domain_activity_type" */
export type BusinessDomainActivityTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type BusinessDomainActivityTypeMaxFields = {
  __typename?: 'BusinessDomainActivityTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type BusinessDomainActivityTypeMinFields = {
  __typename?: 'BusinessDomainActivityTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.domain_activity_type" */
export type BusinessDomainActivityTypeMutationResponse = {
  __typename?: 'BusinessDomainActivityTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BusinessDomainActivityType>;
};

/** on_conflict condition type for table "business.domain_activity_type" */
export type BusinessDomainActivityTypeOnConflict = {
  constraint: BusinessDomainActivityTypeConstraint;
  updateColumns?: Array<BusinessDomainActivityTypeUpdateColumn>;
  where?: InputMaybe<BusinessDomainActivityTypeBoolExp>;
};

/** Ordering options when selecting data from "business.domain_activity_type". */
export type BusinessDomainActivityTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.domain_activity_type */
export type BusinessDomainActivityTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "business.domain_activity_type" */
export type BusinessDomainActivityTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "business.domain_activity_type" */
export type BusinessDomainActivityTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "business_domain_activity_type" */
export type BusinessDomainActivityTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BusinessDomainActivityTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BusinessDomainActivityTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.domain_activity_type" */
export type BusinessDomainActivityTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type BusinessDomainActivityTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BusinessDomainActivityTypeSetInput>;
  /** filter the rows which have to be updated */
  where: BusinessDomainActivityTypeBoolExp;
};

/** columns and relationships of "business.feed_type" */
export type BusinessFeedType = {
  __typename?: 'BusinessFeedType';
  description?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

/** aggregated selection of "business.feed_type" */
export type BusinessFeedTypeAggregate = {
  __typename?: 'BusinessFeedTypeAggregate';
  aggregate?: Maybe<BusinessFeedTypeAggregateFields>;
  nodes: Array<BusinessFeedType>;
};

/** aggregate fields of "business.feed_type" */
export type BusinessFeedTypeAggregateFields = {
  __typename?: 'BusinessFeedTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BusinessFeedTypeMaxFields>;
  min?: Maybe<BusinessFeedTypeMinFields>;
};


/** aggregate fields of "business.feed_type" */
export type BusinessFeedTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<BusinessFeedTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.feed_type". All fields are combined with a logical 'AND'. */
export type BusinessFeedTypeBoolExp = {
  _and?: InputMaybe<Array<BusinessFeedTypeBoolExp>>;
  _not?: InputMaybe<BusinessFeedTypeBoolExp>;
  _or?: InputMaybe<Array<BusinessFeedTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.feed_type" */
export type BusinessFeedTypeConstraint =
  /** unique or primary key constraint on columns "type" */
  | 'feed_type_pkey'
  | '%future added value';

export type BusinessFeedTypeEnum =
  /** default if no other is set */
  | 'DEFAULT'
  /** Create a organizaton */
  | 'ORG_CREATE_ORG'
  /** Has created a organization */
  | 'ORG_CREATE_ORG_DONE'
  /** As admin you declined users invite */
  | 'ORG_DECLINE_INVITE_TO_ORG_ADMIN'
  /** A admin has declined your invite */
  | 'ORG_DECLINE_INVITE_TO_ORG_USER'
  /** A user has declined a invitation from your organization */
  | 'ORG_DELETE_INVITE_TO_ORG_ADMIN'
  /** You declined a invitation from a organization */
  | 'ORG_DELETE_INVITE_TO_ORG_USER'
  /** A user has accepted an invitation from your company */
  | 'ORG_INVITE_ACCEPTED_ADMIN'
  /** You accepted a invite from a organization */
  | 'ORG_INVITE_ACCEPTED_USER'
  /** Your organization wants someone to join your company */
  | 'ORG_INVITE_TO_ORG_ADMIN'
  /** A organization wants you to join their organization */
  | 'ORG_INVITE_TO_ORG_USER'
  /** Someone wants to join your organization */
  | 'ORG_REQUEST_TO_JOIN_ADMIN'
  /** You requested to join a organization */
  | 'ORG_REQUEST_TO_JOIN_USER'
  /** Integration activated */
  | 'PROVIDER_INTEGRATION_ACTIVATED'
  | '%future added value';

/** Boolean expression to compare columns of type "BusinessFeedTypeEnum". All fields are combined with logical 'AND'. */
export type BusinessFeedTypeEnumComparisonExp = {
  _eq?: InputMaybe<BusinessFeedTypeEnum>;
  _in?: InputMaybe<Array<BusinessFeedTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<BusinessFeedTypeEnum>;
  _nin?: InputMaybe<Array<BusinessFeedTypeEnum>>;
};

/** input type for inserting data into table "business.feed_type" */
export type BusinessFeedTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type BusinessFeedTypeMaxFields = {
  __typename?: 'BusinessFeedTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type BusinessFeedTypeMinFields = {
  __typename?: 'BusinessFeedTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.feed_type" */
export type BusinessFeedTypeMutationResponse = {
  __typename?: 'BusinessFeedTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BusinessFeedType>;
};

/** on_conflict condition type for table "business.feed_type" */
export type BusinessFeedTypeOnConflict = {
  constraint: BusinessFeedTypeConstraint;
  updateColumns?: Array<BusinessFeedTypeUpdateColumn>;
  where?: InputMaybe<BusinessFeedTypeBoolExp>;
};

/** Ordering options when selecting data from "business.feed_type". */
export type BusinessFeedTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.feed_type */
export type BusinessFeedTypePkColumnsInput = {
  type: Scalars['String']['input'];
};

/** select columns of table "business.feed_type" */
export type BusinessFeedTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'type'
  | '%future added value';

/** input type for updating data in table "business.feed_type" */
export type BusinessFeedTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "business_feed_type" */
export type BusinessFeedTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BusinessFeedTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BusinessFeedTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.feed_type" */
export type BusinessFeedTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'type'
  | '%future added value';

export type BusinessFeedTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BusinessFeedTypeSetInput>;
  /** filter the rows which have to be updated */
  where: BusinessFeedTypeBoolExp;
};

/** columns and relationships of "business.message_attachments" */
export type BusinessMessageAttachments = {
  __typename?: 'BusinessMessageAttachments';
  createdAt: Scalars['timestamptz']['output'];
  fileId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  messageId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "business.message_attachments" */
export type BusinessMessageAttachmentsAggregate = {
  __typename?: 'BusinessMessageAttachmentsAggregate';
  aggregate?: Maybe<BusinessMessageAttachmentsAggregateFields>;
  nodes: Array<BusinessMessageAttachments>;
};

export type BusinessMessageAttachmentsAggregateBoolExp = {
  count?: InputMaybe<businessMessageAttachmentsAggregateBoolExpCount>;
};

/** aggregate fields of "business.message_attachments" */
export type BusinessMessageAttachmentsAggregateFields = {
  __typename?: 'BusinessMessageAttachmentsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BusinessMessageAttachmentsMaxFields>;
  min?: Maybe<BusinessMessageAttachmentsMinFields>;
};


/** aggregate fields of "business.message_attachments" */
export type BusinessMessageAttachmentsAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<BusinessMessageAttachmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.message_attachments" */
export type BusinessMessageAttachmentsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BusinessMessageAttachmentsMaxOrderBy>;
  min?: InputMaybe<BusinessMessageAttachmentsMinOrderBy>;
};

/** input type for inserting array relation for remote table "business.message_attachments" */
export type BusinessMessageAttachmentsArrRelInsertInput = {
  data: Array<BusinessMessageAttachmentsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<BusinessMessageAttachmentsOnConflict>;
};

/** Boolean expression to filter rows from the table "business.message_attachments". All fields are combined with a logical 'AND'. */
export type BusinessMessageAttachmentsBoolExp = {
  _and?: InputMaybe<Array<BusinessMessageAttachmentsBoolExp>>;
  _not?: InputMaybe<BusinessMessageAttachmentsBoolExp>;
  _or?: InputMaybe<Array<BusinessMessageAttachmentsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  fileId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  messageId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "business.message_attachments" */
export type BusinessMessageAttachmentsConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'message_attachments_pkey'
  | '%future added value';

/** input type for inserting data into table "business.message_attachments" */
export type BusinessMessageAttachmentsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  messageId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type BusinessMessageAttachmentsMaxFields = {
  __typename?: 'BusinessMessageAttachmentsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  messageId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "business.message_attachments" */
export type BusinessMessageAttachmentsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  fileId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  messageId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BusinessMessageAttachmentsMinFields = {
  __typename?: 'BusinessMessageAttachmentsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  messageId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "business.message_attachments" */
export type BusinessMessageAttachmentsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  fileId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  messageId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "business.message_attachments" */
export type BusinessMessageAttachmentsMutationResponse = {
  __typename?: 'BusinessMessageAttachmentsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BusinessMessageAttachments>;
};

/** on_conflict condition type for table "business.message_attachments" */
export type BusinessMessageAttachmentsOnConflict = {
  constraint: BusinessMessageAttachmentsConstraint;
  updateColumns?: Array<BusinessMessageAttachmentsUpdateColumn>;
  where?: InputMaybe<BusinessMessageAttachmentsBoolExp>;
};

/** Ordering options when selecting data from "business.message_attachments". */
export type BusinessMessageAttachmentsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  fileId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  messageId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.message_attachments */
export type BusinessMessageAttachmentsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "business.message_attachments" */
export type BusinessMessageAttachmentsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'fileId'
  /** column name */
  | 'id'
  /** column name */
  | 'messageId'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "business.message_attachments" */
export type BusinessMessageAttachmentsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  messageId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "business_message_attachments" */
export type BusinessMessageAttachmentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BusinessMessageAttachmentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BusinessMessageAttachmentsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  messageId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "business.message_attachments" */
export type BusinessMessageAttachmentsUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'fileId'
  /** column name */
  | 'id'
  /** column name */
  | 'messageId'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type BusinessMessageAttachmentsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BusinessMessageAttachmentsSetInput>;
  /** filter the rows which have to be updated */
  where: BusinessMessageAttachmentsBoolExp;
};

/** columns and relationships of "business.organization_user_callback_answer" */
export type BusinessOrganizationUserCallbackAnswer = {
  __typename?: 'BusinessOrganizationUserCallbackAnswer';
  activeAnswer: Scalars['Boolean']['output'];
  answerLanguage?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  language?: Maybe<languages>;
  /** An object relationship */
  organizationUser?: Maybe<organizationUser>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "business.organization_user_callback_answer" */
export type BusinessOrganizationUserCallbackAnswerAggregate = {
  __typename?: 'BusinessOrganizationUserCallbackAnswerAggregate';
  aggregate?: Maybe<BusinessOrganizationUserCallbackAnswerAggregateFields>;
  nodes: Array<BusinessOrganizationUserCallbackAnswer>;
};

/** aggregate fields of "business.organization_user_callback_answer" */
export type BusinessOrganizationUserCallbackAnswerAggregateFields = {
  __typename?: 'BusinessOrganizationUserCallbackAnswerAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BusinessOrganizationUserCallbackAnswerMaxFields>;
  min?: Maybe<BusinessOrganizationUserCallbackAnswerMinFields>;
};


/** aggregate fields of "business.organization_user_callback_answer" */
export type BusinessOrganizationUserCallbackAnswerAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<BusinessOrganizationUserCallbackAnswerSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.organization_user_callback_answer". All fields are combined with a logical 'AND'. */
export type BusinessOrganizationUserCallbackAnswerBoolExp = {
  _and?: InputMaybe<Array<BusinessOrganizationUserCallbackAnswerBoolExp>>;
  _not?: InputMaybe<BusinessOrganizationUserCallbackAnswerBoolExp>;
  _or?: InputMaybe<Array<BusinessOrganizationUserCallbackAnswerBoolExp>>;
  activeAnswer?: InputMaybe<BooleanComparisonExp>;
  answerLanguage?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  language?: InputMaybe<languagesBoolExp>;
  organizationUser?: InputMaybe<organizationUserBoolExp>;
  organizationUserId?: InputMaybe<UuidComparisonExp>;
  text?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "business.organization_user_callback_answer" */
export type BusinessOrganizationUserCallbackAnswerConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'organization_user_callback_answer_pkey'
  | '%future added value';

/** input type for inserting data into table "business.organization_user_callback_answer" */
export type BusinessOrganizationUserCallbackAnswerInsertInput = {
  activeAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  answerLanguage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<languagesObjRelInsertInput>;
  organizationUser?: InputMaybe<organizationUserObjRelInsertInput>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type BusinessOrganizationUserCallbackAnswerMaxFields = {
  __typename?: 'BusinessOrganizationUserCallbackAnswerMaxFields';
  answerLanguage?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type BusinessOrganizationUserCallbackAnswerMinFields = {
  __typename?: 'BusinessOrganizationUserCallbackAnswerMinFields';
  answerLanguage?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "business.organization_user_callback_answer" */
export type BusinessOrganizationUserCallbackAnswerMutationResponse = {
  __typename?: 'BusinessOrganizationUserCallbackAnswerMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BusinessOrganizationUserCallbackAnswer>;
};

/** on_conflict condition type for table "business.organization_user_callback_answer" */
export type BusinessOrganizationUserCallbackAnswerOnConflict = {
  constraint: BusinessOrganizationUserCallbackAnswerConstraint;
  updateColumns?: Array<BusinessOrganizationUserCallbackAnswerUpdateColumn>;
  where?: InputMaybe<BusinessOrganizationUserCallbackAnswerBoolExp>;
};

/** Ordering options when selecting data from "business.organization_user_callback_answer". */
export type BusinessOrganizationUserCallbackAnswerOrderBy = {
  activeAnswer?: InputMaybe<OrderBy>;
  answerLanguage?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  language?: InputMaybe<languagesOrderBy>;
  organizationUser?: InputMaybe<organizationUserOrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  text?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.organization_user_callback_answer */
export type BusinessOrganizationUserCallbackAnswerPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "business.organization_user_callback_answer" */
export type BusinessOrganizationUserCallbackAnswerSelectColumn =
  /** column name */
  | 'activeAnswer'
  /** column name */
  | 'answerLanguage'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'text'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "business.organization_user_callback_answer" */
export type BusinessOrganizationUserCallbackAnswerSetInput = {
  activeAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  answerLanguage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "business_organization_user_callback_answer" */
export type BusinessOrganizationUserCallbackAnswerStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BusinessOrganizationUserCallbackAnswerStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BusinessOrganizationUserCallbackAnswerStreamCursorValueInput = {
  activeAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  answerLanguage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "business.organization_user_callback_answer" */
export type BusinessOrganizationUserCallbackAnswerUpdateColumn =
  /** column name */
  | 'activeAnswer'
  /** column name */
  | 'answerLanguage'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'text'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type BusinessOrganizationUserCallbackAnswerUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BusinessOrganizationUserCallbackAnswerSetInput>;
  /** filter the rows which have to be updated */
  where: BusinessOrganizationUserCallbackAnswerBoolExp;
};

/** https://docs.expo.dev/versions/latest/sdk/contacts/#email */
export type BusinessOrganizationUserEmail = {
  __typename?: 'BusinessOrganizationUserEmail';
  createdAt: Scalars['timestamptz']['output'];
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  isPrimary: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organizationUser: organizationUser;
  organizationUserId: Scalars['uuid']['output'];
  type: BusinessOrganizationUserEmailTypeEnum;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "business.organization_user_email" */
export type BusinessOrganizationUserEmailAggregate = {
  __typename?: 'BusinessOrganizationUserEmailAggregate';
  aggregate?: Maybe<BusinessOrganizationUserEmailAggregateFields>;
  nodes: Array<BusinessOrganizationUserEmail>;
};

export type BusinessOrganizationUserEmailAggregateBoolExp = {
  bool_and?: InputMaybe<businessOrganizationUserEmailAggregateBoolExpBool_and>;
  bool_or?: InputMaybe<businessOrganizationUserEmailAggregateBoolExpBool_or>;
  count?: InputMaybe<businessOrganizationUserEmailAggregateBoolExpCount>;
};

/** aggregate fields of "business.organization_user_email" */
export type BusinessOrganizationUserEmailAggregateFields = {
  __typename?: 'BusinessOrganizationUserEmailAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BusinessOrganizationUserEmailMaxFields>;
  min?: Maybe<BusinessOrganizationUserEmailMinFields>;
};


/** aggregate fields of "business.organization_user_email" */
export type BusinessOrganizationUserEmailAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<BusinessOrganizationUserEmailSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.organization_user_email" */
export type BusinessOrganizationUserEmailAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BusinessOrganizationUserEmailMaxOrderBy>;
  min?: InputMaybe<BusinessOrganizationUserEmailMinOrderBy>;
};

/** input type for inserting array relation for remote table "business.organization_user_email" */
export type BusinessOrganizationUserEmailArrRelInsertInput = {
  data: Array<BusinessOrganizationUserEmailInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<BusinessOrganizationUserEmailOnConflict>;
};

/** Boolean expression to filter rows from the table "business.organization_user_email". All fields are combined with a logical 'AND'. */
export type BusinessOrganizationUserEmailBoolExp = {
  _and?: InputMaybe<Array<BusinessOrganizationUserEmailBoolExp>>;
  _not?: InputMaybe<BusinessOrganizationUserEmailBoolExp>;
  _or?: InputMaybe<Array<BusinessOrganizationUserEmailBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserId?: InputMaybe<UuidComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isPrimary?: InputMaybe<BooleanComparisonExp>;
  label?: InputMaybe<StringComparisonExp>;
  organizationUser?: InputMaybe<organizationUserBoolExp>;
  organizationUserId?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<BusinessOrganizationUserEmailTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "business.organization_user_email" */
export type BusinessOrganizationUserEmailConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'organization_user_email_pkey'
  | '%future added value';

/** input type for inserting data into table "business.organization_user_email" */
export type BusinessOrganizationUserEmailInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  organizationUser?: InputMaybe<organizationUserObjRelInsertInput>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<BusinessOrganizationUserEmailTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type BusinessOrganizationUserEmailMaxFields = {
  __typename?: 'BusinessOrganizationUserEmailMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "business.organization_user_email" */
export type BusinessOrganizationUserEmailMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BusinessOrganizationUserEmailMinFields = {
  __typename?: 'BusinessOrganizationUserEmailMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "business.organization_user_email" */
export type BusinessOrganizationUserEmailMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "business.organization_user_email" */
export type BusinessOrganizationUserEmailMutationResponse = {
  __typename?: 'BusinessOrganizationUserEmailMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BusinessOrganizationUserEmail>;
};

/** on_conflict condition type for table "business.organization_user_email" */
export type BusinessOrganizationUserEmailOnConflict = {
  constraint: BusinessOrganizationUserEmailConstraint;
  updateColumns?: Array<BusinessOrganizationUserEmailUpdateColumn>;
  where?: InputMaybe<BusinessOrganizationUserEmailBoolExp>;
};

/** Ordering options when selecting data from "business.organization_user_email". */
export type BusinessOrganizationUserEmailOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isPrimary?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  organizationUser?: InputMaybe<organizationUserOrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.organization_user_email */
export type BusinessOrganizationUserEmailPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "business.organization_user_email" */
export type BusinessOrganizationUserEmailSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserId'
  /** column name */
  | 'email'
  /** column name */
  | 'id'
  /** column name */
  | 'isPrimary'
  /** column name */
  | 'label'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** select "businessOrganizationUserEmailAggregateBoolExpBool_andArgumentsColumns" columns of table "business.organization_user_email" */
export type BusinessOrganizationUserEmailSelectColumnBusinessOrganizationUserEmailAggregateBoolExpBool_andArgumentsColumns =
  /** column name */
  | 'isPrimary'
  | '%future added value';

/** select "businessOrganizationUserEmailAggregateBoolExpBool_orArgumentsColumns" columns of table "business.organization_user_email" */
export type BusinessOrganizationUserEmailSelectColumnBusinessOrganizationUserEmailAggregateBoolExpBool_orArgumentsColumns =
  /** column name */
  | 'isPrimary'
  | '%future added value';

/** input type for updating data in table "business.organization_user_email" */
export type BusinessOrganizationUserEmailSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<BusinessOrganizationUserEmailTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "business_organization_user_email" */
export type BusinessOrganizationUserEmailStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BusinessOrganizationUserEmailStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BusinessOrganizationUserEmailStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<BusinessOrganizationUserEmailTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "business.organization_user_email_type" */
export type BusinessOrganizationUserEmailType = {
  __typename?: 'BusinessOrganizationUserEmailType';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "business.organization_user_email_type" */
export type BusinessOrganizationUserEmailTypeAggregate = {
  __typename?: 'BusinessOrganizationUserEmailTypeAggregate';
  aggregate?: Maybe<BusinessOrganizationUserEmailTypeAggregateFields>;
  nodes: Array<BusinessOrganizationUserEmailType>;
};

/** aggregate fields of "business.organization_user_email_type" */
export type BusinessOrganizationUserEmailTypeAggregateFields = {
  __typename?: 'BusinessOrganizationUserEmailTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BusinessOrganizationUserEmailTypeMaxFields>;
  min?: Maybe<BusinessOrganizationUserEmailTypeMinFields>;
};


/** aggregate fields of "business.organization_user_email_type" */
export type BusinessOrganizationUserEmailTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<BusinessOrganizationUserEmailTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.organization_user_email_type". All fields are combined with a logical 'AND'. */
export type BusinessOrganizationUserEmailTypeBoolExp = {
  _and?: InputMaybe<Array<BusinessOrganizationUserEmailTypeBoolExp>>;
  _not?: InputMaybe<BusinessOrganizationUserEmailTypeBoolExp>;
  _or?: InputMaybe<Array<BusinessOrganizationUserEmailTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.organization_user_email_type" */
export type BusinessOrganizationUserEmailTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'organization_user_email_type_pkey'
  | '%future added value';

export type BusinessOrganizationUserEmailTypeEnum =
  /** Private email */
  | 'PRIVATE'
  /** Work email */
  | 'WORK'
  | '%future added value';

/** Boolean expression to compare columns of type "BusinessOrganizationUserEmailTypeEnum". All fields are combined with logical 'AND'. */
export type BusinessOrganizationUserEmailTypeEnumComparisonExp = {
  _eq?: InputMaybe<BusinessOrganizationUserEmailTypeEnum>;
  _in?: InputMaybe<Array<BusinessOrganizationUserEmailTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<BusinessOrganizationUserEmailTypeEnum>;
  _nin?: InputMaybe<Array<BusinessOrganizationUserEmailTypeEnum>>;
};

/** input type for inserting data into table "business.organization_user_email_type" */
export type BusinessOrganizationUserEmailTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type BusinessOrganizationUserEmailTypeMaxFields = {
  __typename?: 'BusinessOrganizationUserEmailTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type BusinessOrganizationUserEmailTypeMinFields = {
  __typename?: 'BusinessOrganizationUserEmailTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.organization_user_email_type" */
export type BusinessOrganizationUserEmailTypeMutationResponse = {
  __typename?: 'BusinessOrganizationUserEmailTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BusinessOrganizationUserEmailType>;
};

/** on_conflict condition type for table "business.organization_user_email_type" */
export type BusinessOrganizationUserEmailTypeOnConflict = {
  constraint: BusinessOrganizationUserEmailTypeConstraint;
  updateColumns?: Array<BusinessOrganizationUserEmailTypeUpdateColumn>;
  where?: InputMaybe<BusinessOrganizationUserEmailTypeBoolExp>;
};

/** Ordering options when selecting data from "business.organization_user_email_type". */
export type BusinessOrganizationUserEmailTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.organization_user_email_type */
export type BusinessOrganizationUserEmailTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "business.organization_user_email_type" */
export type BusinessOrganizationUserEmailTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "business.organization_user_email_type" */
export type BusinessOrganizationUserEmailTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "business_organization_user_email_type" */
export type BusinessOrganizationUserEmailTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BusinessOrganizationUserEmailTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BusinessOrganizationUserEmailTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.organization_user_email_type" */
export type BusinessOrganizationUserEmailTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type BusinessOrganizationUserEmailTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BusinessOrganizationUserEmailTypeSetInput>;
  /** filter the rows which have to be updated */
  where: BusinessOrganizationUserEmailTypeBoolExp;
};

/** update columns of table "business.organization_user_email" */
export type BusinessOrganizationUserEmailUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserId'
  /** column name */
  | 'email'
  /** column name */
  | 'id'
  /** column name */
  | 'isPrimary'
  /** column name */
  | 'label'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type BusinessOrganizationUserEmailUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BusinessOrganizationUserEmailSetInput>;
  /** filter the rows which have to be updated */
  where: BusinessOrganizationUserEmailBoolExp;
};

/** columns and relationships of "business.organization_user_request" */
export type BusinessOrganizationUserRequest = {
  __typename?: 'BusinessOrganizationUserRequest';
  city?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  extraData?: Maybe<Scalars['jsonb']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isCompleted: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationNumber?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organizationNumberJoin?: Maybe<organization>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organizations?: Maybe<organization>;
  permissionRole?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberCountryCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<BusinessUserRequestStatusEnum>;
  street?: Maybe<Scalars['String']['output']>;
  type?: Maybe<BusinessOrganizationUserRequestTypeEnum>;
  updatedAt: Scalars['timestamptz']['output'];
  userId: Scalars['uuid']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "business.organization_user_request" */
export type BusinessOrganizationUserRequestextraDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "business.organization_user_request" */
export type BusinessOrganizationUserRequestAggregate = {
  __typename?: 'BusinessOrganizationUserRequestAggregate';
  aggregate?: Maybe<BusinessOrganizationUserRequestAggregateFields>;
  nodes: Array<BusinessOrganizationUserRequest>;
};

export type BusinessOrganizationUserRequestAggregateBoolExp = {
  bool_and?: InputMaybe<businessOrganizationUserRequestAggregateBoolExpBool_and>;
  bool_or?: InputMaybe<businessOrganizationUserRequestAggregateBoolExpBool_or>;
  count?: InputMaybe<businessOrganizationUserRequestAggregateBoolExpCount>;
};

/** aggregate fields of "business.organization_user_request" */
export type BusinessOrganizationUserRequestAggregateFields = {
  __typename?: 'BusinessOrganizationUserRequestAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BusinessOrganizationUserRequestMaxFields>;
  min?: Maybe<BusinessOrganizationUserRequestMinFields>;
};


/** aggregate fields of "business.organization_user_request" */
export type BusinessOrganizationUserRequestAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<BusinessOrganizationUserRequestSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.organization_user_request" */
export type BusinessOrganizationUserRequestAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BusinessOrganizationUserRequestMaxOrderBy>;
  min?: InputMaybe<BusinessOrganizationUserRequestMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type BusinessOrganizationUserRequestAppendInput = {
  extraData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "business.organization_user_request" */
export type BusinessOrganizationUserRequestArrRelInsertInput = {
  data: Array<BusinessOrganizationUserRequestInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<BusinessOrganizationUserRequestOnConflict>;
};

/** Boolean expression to filter rows from the table "business.organization_user_request". All fields are combined with a logical 'AND'. */
export type BusinessOrganizationUserRequestBoolExp = {
  _and?: InputMaybe<Array<BusinessOrganizationUserRequestBoolExp>>;
  _not?: InputMaybe<BusinessOrganizationUserRequestBoolExp>;
  _or?: InputMaybe<Array<BusinessOrganizationUserRequestBoolExp>>;
  city?: InputMaybe<StringComparisonExp>;
  comment?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserId?: InputMaybe<UuidComparisonExp>;
  extraData?: InputMaybe<JsonbComparisonExp>;
  firstName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isCompleted?: InputMaybe<BooleanComparisonExp>;
  lastName?: InputMaybe<StringComparisonExp>;
  organizationId?: InputMaybe<UuidComparisonExp>;
  organizationName?: InputMaybe<StringComparisonExp>;
  organizationNumber?: InputMaybe<StringComparisonExp>;
  organizationNumberJoin?: InputMaybe<organizationBoolExp>;
  organizationUserId?: InputMaybe<UuidComparisonExp>;
  organizations?: InputMaybe<organizationBoolExp>;
  permissionRole?: InputMaybe<StringComparisonExp>;
  phoneNumber?: InputMaybe<StringComparisonExp>;
  phoneNumberCountryCode?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<BusinessUserRequestStatusEnumComparisonExp>;
  street?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<BusinessOrganizationUserRequestTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  zip?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.organization_user_request" */
export type BusinessOrganizationUserRequestConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'organization_user_request_pkey'
  /** unique or primary key constraint on columns "user_id", "organization_id" */
  | 'organization_user_request_user_id_organization_id_key'
  /** unique or primary key constraint on columns "organization_number", "user_id" */
  | 'organization_user_request_user_id_organization_number_key'
  | '%future added value';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type BusinessOrganizationUserRequestDeleteAtPathInput = {
  extraData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type BusinessOrganizationUserRequestDeleteElemInput = {
  extraData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type BusinessOrganizationUserRequestDeleteKeyInput = {
  extraData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "business.organization_user_request" */
export type BusinessOrganizationUserRequestInsertInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  extraData?: InputMaybe<Scalars['jsonb']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
  organizationNumberJoin?: InputMaybe<organizationObjRelInsertInput>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  organizations?: InputMaybe<organizationObjRelInsertInput>;
  permissionRole?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberCountryCode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BusinessUserRequestStatusEnum>;
  street?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BusinessOrganizationUserRequestTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type BusinessOrganizationUserRequestMaxFields = {
  __typename?: 'BusinessOrganizationUserRequestMaxFields';
  city?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationNumber?: Maybe<Scalars['String']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  permissionRole?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberCountryCode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "business.organization_user_request" */
export type BusinessOrganizationUserRequestMaxOrderBy = {
  city?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  organizationName?: InputMaybe<OrderBy>;
  organizationNumber?: InputMaybe<OrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  permissionRole?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  phoneNumberCountryCode?: InputMaybe<OrderBy>;
  street?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  zip?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BusinessOrganizationUserRequestMinFields = {
  __typename?: 'BusinessOrganizationUserRequestMinFields';
  city?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationNumber?: Maybe<Scalars['String']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  permissionRole?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberCountryCode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "business.organization_user_request" */
export type BusinessOrganizationUserRequestMinOrderBy = {
  city?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  organizationName?: InputMaybe<OrderBy>;
  organizationNumber?: InputMaybe<OrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  permissionRole?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  phoneNumberCountryCode?: InputMaybe<OrderBy>;
  street?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  zip?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "business.organization_user_request" */
export type BusinessOrganizationUserRequestMutationResponse = {
  __typename?: 'BusinessOrganizationUserRequestMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BusinessOrganizationUserRequest>;
};

/** on_conflict condition type for table "business.organization_user_request" */
export type BusinessOrganizationUserRequestOnConflict = {
  constraint: BusinessOrganizationUserRequestConstraint;
  updateColumns?: Array<BusinessOrganizationUserRequestUpdateColumn>;
  where?: InputMaybe<BusinessOrganizationUserRequestBoolExp>;
};

/** Ordering options when selecting data from "business.organization_user_request". */
export type BusinessOrganizationUserRequestOrderBy = {
  city?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  extraData?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isCompleted?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  organizationName?: InputMaybe<OrderBy>;
  organizationNumber?: InputMaybe<OrderBy>;
  organizationNumberJoin?: InputMaybe<organizationOrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  organizations?: InputMaybe<organizationOrderBy>;
  permissionRole?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  phoneNumberCountryCode?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  street?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  zip?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.organization_user_request */
export type BusinessOrganizationUserRequestPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type BusinessOrganizationUserRequestPrependInput = {
  extraData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "business.organization_user_request" */
export type BusinessOrganizationUserRequestSelectColumn =
  /** column name */
  | 'city'
  /** column name */
  | 'comment'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserId'
  /** column name */
  | 'extraData'
  /** column name */
  | 'firstName'
  /** column name */
  | 'id'
  /** column name */
  | 'isCompleted'
  /** column name */
  | 'lastName'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'organizationName'
  /** column name */
  | 'organizationNumber'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'permissionRole'
  /** column name */
  | 'phoneNumber'
  /** column name */
  | 'phoneNumberCountryCode'
  /** column name */
  | 'status'
  /** column name */
  | 'street'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  /** column name */
  | 'zip'
  | '%future added value';

/** select "businessOrganizationUserRequestAggregateBoolExpBool_andArgumentsColumns" columns of table "business.organization_user_request" */
export type BusinessOrganizationUserRequestSelectColumnBusinessOrganizationUserRequestAggregateBoolExpBool_andArgumentsColumns =
  /** column name */
  | 'isCompleted'
  | '%future added value';

/** select "businessOrganizationUserRequestAggregateBoolExpBool_orArgumentsColumns" columns of table "business.organization_user_request" */
export type BusinessOrganizationUserRequestSelectColumnBusinessOrganizationUserRequestAggregateBoolExpBool_orArgumentsColumns =
  /** column name */
  | 'isCompleted'
  | '%future added value';

/** input type for updating data in table "business.organization_user_request" */
export type BusinessOrganizationUserRequestSetInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  extraData?: InputMaybe<Scalars['jsonb']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  permissionRole?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberCountryCode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BusinessUserRequestStatusEnum>;
  street?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BusinessOrganizationUserRequestTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "business_organization_user_request" */
export type BusinessOrganizationUserRequestStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BusinessOrganizationUserRequestStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BusinessOrganizationUserRequestStreamCursorValueInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  extraData?: InputMaybe<Scalars['jsonb']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  permissionRole?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberCountryCode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BusinessUserRequestStatusEnum>;
  street?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BusinessOrganizationUserRequestTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "business.organization_user_request_type" */
export type BusinessOrganizationUserRequestType = {
  __typename?: 'BusinessOrganizationUserRequestType';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** aggregated selection of "business.organization_user_request_type" */
export type BusinessOrganizationUserRequestTypeAggregate = {
  __typename?: 'BusinessOrganizationUserRequestTypeAggregate';
  aggregate?: Maybe<BusinessOrganizationUserRequestTypeAggregateFields>;
  nodes: Array<BusinessOrganizationUserRequestType>;
};

/** aggregate fields of "business.organization_user_request_type" */
export type BusinessOrganizationUserRequestTypeAggregateFields = {
  __typename?: 'BusinessOrganizationUserRequestTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BusinessOrganizationUserRequestTypeMaxFields>;
  min?: Maybe<BusinessOrganizationUserRequestTypeMinFields>;
};


/** aggregate fields of "business.organization_user_request_type" */
export type BusinessOrganizationUserRequestTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<BusinessOrganizationUserRequestTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.organization_user_request_type". All fields are combined with a logical 'AND'. */
export type BusinessOrganizationUserRequestTypeBoolExp = {
  _and?: InputMaybe<Array<BusinessOrganizationUserRequestTypeBoolExp>>;
  _not?: InputMaybe<BusinessOrganizationUserRequestTypeBoolExp>;
  _or?: InputMaybe<Array<BusinessOrganizationUserRequestTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.organization_user_request_type" */
export type BusinessOrganizationUserRequestTypeConstraint =
  /** unique or primary key constraint on columns "name" */
  | 'organization_user_request_type_pkey'
  | '%future added value';

export type BusinessOrganizationUserRequestTypeEnum =
  /** Claim organization */
  | 'CLAIM'
  /** Invitation to join org */
  | 'INVITATION'
  /** Request to join org */
  | 'REQUEST'
  | '%future added value';

/** Boolean expression to compare columns of type "BusinessOrganizationUserRequestTypeEnum". All fields are combined with logical 'AND'. */
export type BusinessOrganizationUserRequestTypeEnumComparisonExp = {
  _eq?: InputMaybe<BusinessOrganizationUserRequestTypeEnum>;
  _in?: InputMaybe<Array<BusinessOrganizationUserRequestTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<BusinessOrganizationUserRequestTypeEnum>;
  _nin?: InputMaybe<Array<BusinessOrganizationUserRequestTypeEnum>>;
};

/** input type for inserting data into table "business.organization_user_request_type" */
export type BusinessOrganizationUserRequestTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type BusinessOrganizationUserRequestTypeMaxFields = {
  __typename?: 'BusinessOrganizationUserRequestTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type BusinessOrganizationUserRequestTypeMinFields = {
  __typename?: 'BusinessOrganizationUserRequestTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.organization_user_request_type" */
export type BusinessOrganizationUserRequestTypeMutationResponse = {
  __typename?: 'BusinessOrganizationUserRequestTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BusinessOrganizationUserRequestType>;
};

/** on_conflict condition type for table "business.organization_user_request_type" */
export type BusinessOrganizationUserRequestTypeOnConflict = {
  constraint: BusinessOrganizationUserRequestTypeConstraint;
  updateColumns?: Array<BusinessOrganizationUserRequestTypeUpdateColumn>;
  where?: InputMaybe<BusinessOrganizationUserRequestTypeBoolExp>;
};

/** Ordering options when selecting data from "business.organization_user_request_type". */
export type BusinessOrganizationUserRequestTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.organization_user_request_type */
export type BusinessOrganizationUserRequestTypePkColumnsInput = {
  name: Scalars['String']['input'];
};

/** select columns of table "business.organization_user_request_type" */
export type BusinessOrganizationUserRequestTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'name'
  | '%future added value';

/** input type for updating data in table "business.organization_user_request_type" */
export type BusinessOrganizationUserRequestTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "business_organization_user_request_type" */
export type BusinessOrganizationUserRequestTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BusinessOrganizationUserRequestTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BusinessOrganizationUserRequestTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.organization_user_request_type" */
export type BusinessOrganizationUserRequestTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'name'
  | '%future added value';

export type BusinessOrganizationUserRequestTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BusinessOrganizationUserRequestTypeSetInput>;
  /** filter the rows which have to be updated */
  where: BusinessOrganizationUserRequestTypeBoolExp;
};

/** update columns of table "business.organization_user_request" */
export type BusinessOrganizationUserRequestUpdateColumn =
  /** column name */
  | 'city'
  /** column name */
  | 'comment'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserId'
  /** column name */
  | 'extraData'
  /** column name */
  | 'firstName'
  /** column name */
  | 'id'
  /** column name */
  | 'isCompleted'
  /** column name */
  | 'lastName'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'organizationName'
  /** column name */
  | 'organizationNumber'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'permissionRole'
  /** column name */
  | 'phoneNumber'
  /** column name */
  | 'phoneNumberCountryCode'
  /** column name */
  | 'status'
  /** column name */
  | 'street'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  /** column name */
  | 'zip'
  | '%future added value';

export type BusinessOrganizationUserRequestUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<BusinessOrganizationUserRequestAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<BusinessOrganizationUserRequestDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<BusinessOrganizationUserRequestDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<BusinessOrganizationUserRequestDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<BusinessOrganizationUserRequestPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BusinessOrganizationUserRequestSetInput>;
  /** filter the rows which have to be updated */
  where: BusinessOrganizationUserRequestBoolExp;
};

/** columns and relationships of "business.organization_user_suggestion_type" */
export type BusinessOrganizationUserSuggestionType = {
  __typename?: 'BusinessOrganizationUserSuggestionType';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "business.organization_user_suggestion_type" */
export type BusinessOrganizationUserSuggestionTypeAggregate = {
  __typename?: 'BusinessOrganizationUserSuggestionTypeAggregate';
  aggregate?: Maybe<BusinessOrganizationUserSuggestionTypeAggregateFields>;
  nodes: Array<BusinessOrganizationUserSuggestionType>;
};

/** aggregate fields of "business.organization_user_suggestion_type" */
export type BusinessOrganizationUserSuggestionTypeAggregateFields = {
  __typename?: 'BusinessOrganizationUserSuggestionTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BusinessOrganizationUserSuggestionTypeMaxFields>;
  min?: Maybe<BusinessOrganizationUserSuggestionTypeMinFields>;
};


/** aggregate fields of "business.organization_user_suggestion_type" */
export type BusinessOrganizationUserSuggestionTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<BusinessOrganizationUserSuggestionTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.organization_user_suggestion_type". All fields are combined with a logical 'AND'. */
export type BusinessOrganizationUserSuggestionTypeBoolExp = {
  _and?: InputMaybe<Array<BusinessOrganizationUserSuggestionTypeBoolExp>>;
  _not?: InputMaybe<BusinessOrganizationUserSuggestionTypeBoolExp>;
  _or?: InputMaybe<Array<BusinessOrganizationUserSuggestionTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.organization_user_suggestion_type" */
export type BusinessOrganizationUserSuggestionTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'organization_user_suggestion_type_pkey'
  | '%future added value';

/** input type for inserting data into table "business.organization_user_suggestion_type" */
export type BusinessOrganizationUserSuggestionTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type BusinessOrganizationUserSuggestionTypeMaxFields = {
  __typename?: 'BusinessOrganizationUserSuggestionTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type BusinessOrganizationUserSuggestionTypeMinFields = {
  __typename?: 'BusinessOrganizationUserSuggestionTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.organization_user_suggestion_type" */
export type BusinessOrganizationUserSuggestionTypeMutationResponse = {
  __typename?: 'BusinessOrganizationUserSuggestionTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BusinessOrganizationUserSuggestionType>;
};

/** on_conflict condition type for table "business.organization_user_suggestion_type" */
export type BusinessOrganizationUserSuggestionTypeOnConflict = {
  constraint: BusinessOrganizationUserSuggestionTypeConstraint;
  updateColumns?: Array<BusinessOrganizationUserSuggestionTypeUpdateColumn>;
  where?: InputMaybe<BusinessOrganizationUserSuggestionTypeBoolExp>;
};

/** Ordering options when selecting data from "business.organization_user_suggestion_type". */
export type BusinessOrganizationUserSuggestionTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.organization_user_suggestion_type */
export type BusinessOrganizationUserSuggestionTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "business.organization_user_suggestion_type" */
export type BusinessOrganizationUserSuggestionTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "business.organization_user_suggestion_type" */
export type BusinessOrganizationUserSuggestionTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "business_organization_user_suggestion_type" */
export type BusinessOrganizationUserSuggestionTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BusinessOrganizationUserSuggestionTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BusinessOrganizationUserSuggestionTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.organization_user_suggestion_type" */
export type BusinessOrganizationUserSuggestionTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type BusinessOrganizationUserSuggestionTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BusinessOrganizationUserSuggestionTypeSetInput>;
  /** filter the rows which have to be updated */
  where: BusinessOrganizationUserSuggestionTypeBoolExp;
};

/** columns and relationships of "business.organization_user_suggestions" */
export type BusinessOrganizationUserSuggestions = {
  __typename?: 'BusinessOrganizationUserSuggestions';
  city?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  lastName: Scalars['String']['output'];
  /** An object relationship */
  organization: organization;
  organizationId: Scalars['uuid']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberCountryCode?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  sourceOfSuggestion?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  suggestionType: Scalars['String']['output'];
  triggerName: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  userId?: Maybe<Scalars['uuid']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "business.organization_user_suggestions" */
export type BusinessOrganizationUserSuggestionsAggregate = {
  __typename?: 'BusinessOrganizationUserSuggestionsAggregate';
  aggregate?: Maybe<BusinessOrganizationUserSuggestionsAggregateFields>;
  nodes: Array<BusinessOrganizationUserSuggestions>;
};

/** aggregate fields of "business.organization_user_suggestions" */
export type BusinessOrganizationUserSuggestionsAggregateFields = {
  __typename?: 'BusinessOrganizationUserSuggestionsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BusinessOrganizationUserSuggestionsMaxFields>;
  min?: Maybe<BusinessOrganizationUserSuggestionsMinFields>;
};


/** aggregate fields of "business.organization_user_suggestions" */
export type BusinessOrganizationUserSuggestionsAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<BusinessOrganizationUserSuggestionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.organization_user_suggestions". All fields are combined with a logical 'AND'. */
export type BusinessOrganizationUserSuggestionsBoolExp = {
  _and?: InputMaybe<Array<BusinessOrganizationUserSuggestionsBoolExp>>;
  _not?: InputMaybe<BusinessOrganizationUserSuggestionsBoolExp>;
  _or?: InputMaybe<Array<BusinessOrganizationUserSuggestionsBoolExp>>;
  city?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserId?: InputMaybe<UuidComparisonExp>;
  department?: InputMaybe<StringComparisonExp>;
  emailAddress?: InputMaybe<StringComparisonExp>;
  firstName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lastName?: InputMaybe<StringComparisonExp>;
  organization?: InputMaybe<organizationBoolExp>;
  organizationId?: InputMaybe<UuidComparisonExp>;
  phoneNumber?: InputMaybe<StringComparisonExp>;
  phoneNumberCountryCode?: InputMaybe<StringComparisonExp>;
  position?: InputMaybe<StringComparisonExp>;
  sourceOfSuggestion?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  street?: InputMaybe<StringComparisonExp>;
  suggestionType?: InputMaybe<StringComparisonExp>;
  triggerName?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  zip?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.organization_user_suggestions" */
export type BusinessOrganizationUserSuggestionsConstraint =
  /** unique or primary key constraint on columns "phone_number", "organization_id" */
  | 'organization_user_suggestions_phone_number_organization_id_key'
  /** unique or primary key constraint on columns "id" */
  | 'organization_user_suggestions_pkey'
  | '%future added value';

/** input type for inserting data into table "business.organization_user_suggestions" */
export type BusinessOrganizationUserSuggestionsInsertInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<organizationObjRelInsertInput>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberCountryCode?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  sourceOfSuggestion?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  suggestionType?: InputMaybe<Scalars['String']['input']>;
  triggerName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type BusinessOrganizationUserSuggestionsMaxFields = {
  __typename?: 'BusinessOrganizationUserSuggestionsMaxFields';
  city?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberCountryCode?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  sourceOfSuggestion?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  suggestionType?: Maybe<Scalars['String']['output']>;
  triggerName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type BusinessOrganizationUserSuggestionsMinFields = {
  __typename?: 'BusinessOrganizationUserSuggestionsMinFields';
  city?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberCountryCode?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  sourceOfSuggestion?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  suggestionType?: Maybe<Scalars['String']['output']>;
  triggerName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.organization_user_suggestions" */
export type BusinessOrganizationUserSuggestionsMutationResponse = {
  __typename?: 'BusinessOrganizationUserSuggestionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BusinessOrganizationUserSuggestions>;
};

/** on_conflict condition type for table "business.organization_user_suggestions" */
export type BusinessOrganizationUserSuggestionsOnConflict = {
  constraint: BusinessOrganizationUserSuggestionsConstraint;
  updateColumns?: Array<BusinessOrganizationUserSuggestionsUpdateColumn>;
  where?: InputMaybe<BusinessOrganizationUserSuggestionsBoolExp>;
};

/** Ordering options when selecting data from "business.organization_user_suggestions". */
export type BusinessOrganizationUserSuggestionsOrderBy = {
  city?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  department?: InputMaybe<OrderBy>;
  emailAddress?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  organization?: InputMaybe<organizationOrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  phoneNumberCountryCode?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  sourceOfSuggestion?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  street?: InputMaybe<OrderBy>;
  suggestionType?: InputMaybe<OrderBy>;
  triggerName?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  zip?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.organization_user_suggestions */
export type BusinessOrganizationUserSuggestionsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "business.organization_user_suggestions" */
export type BusinessOrganizationUserSuggestionsSelectColumn =
  /** column name */
  | 'city'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserId'
  /** column name */
  | 'department'
  /** column name */
  | 'emailAddress'
  /** column name */
  | 'firstName'
  /** column name */
  | 'id'
  /** column name */
  | 'lastName'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'phoneNumber'
  /** column name */
  | 'phoneNumberCountryCode'
  /** column name */
  | 'position'
  /** column name */
  | 'sourceOfSuggestion'
  /** column name */
  | 'status'
  /** column name */
  | 'street'
  /** column name */
  | 'suggestionType'
  /** column name */
  | 'triggerName'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  /** column name */
  | 'zip'
  | '%future added value';

/** input type for updating data in table "business.organization_user_suggestions" */
export type BusinessOrganizationUserSuggestionsSetInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberCountryCode?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  sourceOfSuggestion?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  suggestionType?: InputMaybe<Scalars['String']['input']>;
  triggerName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "business_organization_user_suggestions" */
export type BusinessOrganizationUserSuggestionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BusinessOrganizationUserSuggestionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BusinessOrganizationUserSuggestionsStreamCursorValueInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberCountryCode?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  sourceOfSuggestion?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  suggestionType?: InputMaybe<Scalars['String']['input']>;
  triggerName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.organization_user_suggestions" */
export type BusinessOrganizationUserSuggestionsUpdateColumn =
  /** column name */
  | 'city'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserId'
  /** column name */
  | 'department'
  /** column name */
  | 'emailAddress'
  /** column name */
  | 'firstName'
  /** column name */
  | 'id'
  /** column name */
  | 'lastName'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'phoneNumber'
  /** column name */
  | 'phoneNumberCountryCode'
  /** column name */
  | 'position'
  /** column name */
  | 'sourceOfSuggestion'
  /** column name */
  | 'status'
  /** column name */
  | 'street'
  /** column name */
  | 'suggestionType'
  /** column name */
  | 'triggerName'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  /** column name */
  | 'zip'
  | '%future added value';

export type BusinessOrganizationUserSuggestionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BusinessOrganizationUserSuggestionsSetInput>;
  /** filter the rows which have to be updated */
  where: BusinessOrganizationUserSuggestionsBoolExp;
};

/** columns and relationships of "business.organization_user_url_address" */
export type BusinessOrganizationUserUrlAddress = {
  __typename?: 'BusinessOrganizationUserUrlAddress';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  label?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organizationUser: organizationUser;
  organizationUserId: Scalars['uuid']['output'];
  type: BusinessOrganizationUserUrlAddressTypeEnum;
  updatedAt: Scalars['timestamptz']['output'];
  url: Scalars['String']['output'];
  /** An object relationship */
  urlType: BusinessOrganizationUserUrlAddressType;
};

/** aggregated selection of "business.organization_user_url_address" */
export type BusinessOrganizationUserUrlAddressAggregate = {
  __typename?: 'BusinessOrganizationUserUrlAddressAggregate';
  aggregate?: Maybe<BusinessOrganizationUserUrlAddressAggregateFields>;
  nodes: Array<BusinessOrganizationUserUrlAddress>;
};

export type BusinessOrganizationUserUrlAddressAggregateBoolExp = {
  count?: InputMaybe<businessOrganizationUserUrlAddressAggregateBoolExpCount>;
};

/** aggregate fields of "business.organization_user_url_address" */
export type BusinessOrganizationUserUrlAddressAggregateFields = {
  __typename?: 'BusinessOrganizationUserUrlAddressAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BusinessOrganizationUserUrlAddressMaxFields>;
  min?: Maybe<BusinessOrganizationUserUrlAddressMinFields>;
};


/** aggregate fields of "business.organization_user_url_address" */
export type BusinessOrganizationUserUrlAddressAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<BusinessOrganizationUserUrlAddressSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.organization_user_url_address" */
export type BusinessOrganizationUserUrlAddressAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BusinessOrganizationUserUrlAddressMaxOrderBy>;
  min?: InputMaybe<BusinessOrganizationUserUrlAddressMinOrderBy>;
};

/** input type for inserting array relation for remote table "business.organization_user_url_address" */
export type BusinessOrganizationUserUrlAddressArrRelInsertInput = {
  data: Array<BusinessOrganizationUserUrlAddressInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<BusinessOrganizationUserUrlAddressOnConflict>;
};

/** Boolean expression to filter rows from the table "business.organization_user_url_address". All fields are combined with a logical 'AND'. */
export type BusinessOrganizationUserUrlAddressBoolExp = {
  _and?: InputMaybe<Array<BusinessOrganizationUserUrlAddressBoolExp>>;
  _not?: InputMaybe<BusinessOrganizationUserUrlAddressBoolExp>;
  _or?: InputMaybe<Array<BusinessOrganizationUserUrlAddressBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  label?: InputMaybe<StringComparisonExp>;
  organizationUser?: InputMaybe<organizationUserBoolExp>;
  organizationUserId?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<BusinessOrganizationUserUrlAddressTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  url?: InputMaybe<StringComparisonExp>;
  urlType?: InputMaybe<BusinessOrganizationUserUrlAddressTypeBoolExp>;
};

/** unique or primary key constraints on table "business.organization_user_url_address" */
export type BusinessOrganizationUserUrlAddressConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'organization_user_url_address_pkey'
  /** unique or primary key constraint on columns "organization_user_id", "type" */
  | 'organization_user_url_address_type_organization_user_id_key'
  | '%future added value';

/** input type for inserting data into table "business.organization_user_url_address" */
export type BusinessOrganizationUserUrlAddressInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  organizationUser?: InputMaybe<organizationUserObjRelInsertInput>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<BusinessOrganizationUserUrlAddressTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  urlType?: InputMaybe<BusinessOrganizationUserUrlAddressTypeObjRelInsertInput>;
};

/** aggregate max on columns */
export type BusinessOrganizationUserUrlAddressMaxFields = {
  __typename?: 'BusinessOrganizationUserUrlAddressMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "business.organization_user_url_address" */
export type BusinessOrganizationUserUrlAddressMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BusinessOrganizationUserUrlAddressMinFields = {
  __typename?: 'BusinessOrganizationUserUrlAddressMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "business.organization_user_url_address" */
export type BusinessOrganizationUserUrlAddressMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "business.organization_user_url_address" */
export type BusinessOrganizationUserUrlAddressMutationResponse = {
  __typename?: 'BusinessOrganizationUserUrlAddressMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BusinessOrganizationUserUrlAddress>;
};

/** on_conflict condition type for table "business.organization_user_url_address" */
export type BusinessOrganizationUserUrlAddressOnConflict = {
  constraint: BusinessOrganizationUserUrlAddressConstraint;
  updateColumns?: Array<BusinessOrganizationUserUrlAddressUpdateColumn>;
  where?: InputMaybe<BusinessOrganizationUserUrlAddressBoolExp>;
};

/** Ordering options when selecting data from "business.organization_user_url_address". */
export type BusinessOrganizationUserUrlAddressOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  organizationUser?: InputMaybe<organizationUserOrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  urlType?: InputMaybe<BusinessOrganizationUserUrlAddressTypeOrderBy>;
};

/** primary key columns input for table: business.organization_user_url_address */
export type BusinessOrganizationUserUrlAddressPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "business.organization_user_url_address" */
export type BusinessOrganizationUserUrlAddressSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'label'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'url'
  | '%future added value';

/** input type for updating data in table "business.organization_user_url_address" */
export type BusinessOrganizationUserUrlAddressSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<BusinessOrganizationUserUrlAddressTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "business_organization_user_url_address" */
export type BusinessOrganizationUserUrlAddressStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BusinessOrganizationUserUrlAddressStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BusinessOrganizationUserUrlAddressStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<BusinessOrganizationUserUrlAddressTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "business.organization_user_url_address_type" */
export type BusinessOrganizationUserUrlAddressType = {
  __typename?: 'BusinessOrganizationUserUrlAddressType';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "business.organization_user_url_address_type" */
export type BusinessOrganizationUserUrlAddressTypeAggregate = {
  __typename?: 'BusinessOrganizationUserUrlAddressTypeAggregate';
  aggregate?: Maybe<BusinessOrganizationUserUrlAddressTypeAggregateFields>;
  nodes: Array<BusinessOrganizationUserUrlAddressType>;
};

/** aggregate fields of "business.organization_user_url_address_type" */
export type BusinessOrganizationUserUrlAddressTypeAggregateFields = {
  __typename?: 'BusinessOrganizationUserUrlAddressTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BusinessOrganizationUserUrlAddressTypeMaxFields>;
  min?: Maybe<BusinessOrganizationUserUrlAddressTypeMinFields>;
};


/** aggregate fields of "business.organization_user_url_address_type" */
export type BusinessOrganizationUserUrlAddressTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<BusinessOrganizationUserUrlAddressTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.organization_user_url_address_type". All fields are combined with a logical 'AND'. */
export type BusinessOrganizationUserUrlAddressTypeBoolExp = {
  _and?: InputMaybe<Array<BusinessOrganizationUserUrlAddressTypeBoolExp>>;
  _not?: InputMaybe<BusinessOrganizationUserUrlAddressTypeBoolExp>;
  _or?: InputMaybe<Array<BusinessOrganizationUserUrlAddressTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.organization_user_url_address_type" */
export type BusinessOrganizationUserUrlAddressTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'organization_user_url_address_type_pkey'
  | '%future added value';

export type BusinessOrganizationUserUrlAddressTypeEnum =
  /** Teams */
  | 'TEAMS_VIDEO'
  /** Whereby video */
  | 'WHEREBY_VIDEO'
  | '%future added value';

/** Boolean expression to compare columns of type "BusinessOrganizationUserUrlAddressTypeEnum". All fields are combined with logical 'AND'. */
export type BusinessOrganizationUserUrlAddressTypeEnumComparisonExp = {
  _eq?: InputMaybe<BusinessOrganizationUserUrlAddressTypeEnum>;
  _in?: InputMaybe<Array<BusinessOrganizationUserUrlAddressTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<BusinessOrganizationUserUrlAddressTypeEnum>;
  _nin?: InputMaybe<Array<BusinessOrganizationUserUrlAddressTypeEnum>>;
};

/** input type for inserting data into table "business.organization_user_url_address_type" */
export type BusinessOrganizationUserUrlAddressTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type BusinessOrganizationUserUrlAddressTypeMaxFields = {
  __typename?: 'BusinessOrganizationUserUrlAddressTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type BusinessOrganizationUserUrlAddressTypeMinFields = {
  __typename?: 'BusinessOrganizationUserUrlAddressTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.organization_user_url_address_type" */
export type BusinessOrganizationUserUrlAddressTypeMutationResponse = {
  __typename?: 'BusinessOrganizationUserUrlAddressTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BusinessOrganizationUserUrlAddressType>;
};

/** input type for inserting object relation for remote table "business.organization_user_url_address_type" */
export type BusinessOrganizationUserUrlAddressTypeObjRelInsertInput = {
  data: BusinessOrganizationUserUrlAddressTypeInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<BusinessOrganizationUserUrlAddressTypeOnConflict>;
};

/** on_conflict condition type for table "business.organization_user_url_address_type" */
export type BusinessOrganizationUserUrlAddressTypeOnConflict = {
  constraint: BusinessOrganizationUserUrlAddressTypeConstraint;
  updateColumns?: Array<BusinessOrganizationUserUrlAddressTypeUpdateColumn>;
  where?: InputMaybe<BusinessOrganizationUserUrlAddressTypeBoolExp>;
};

/** Ordering options when selecting data from "business.organization_user_url_address_type". */
export type BusinessOrganizationUserUrlAddressTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.organization_user_url_address_type */
export type BusinessOrganizationUserUrlAddressTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "business.organization_user_url_address_type" */
export type BusinessOrganizationUserUrlAddressTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "business.organization_user_url_address_type" */
export type BusinessOrganizationUserUrlAddressTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "business_organization_user_url_address_type" */
export type BusinessOrganizationUserUrlAddressTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BusinessOrganizationUserUrlAddressTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BusinessOrganizationUserUrlAddressTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.organization_user_url_address_type" */
export type BusinessOrganizationUserUrlAddressTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type BusinessOrganizationUserUrlAddressTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BusinessOrganizationUserUrlAddressTypeSetInput>;
  /** filter the rows which have to be updated */
  where: BusinessOrganizationUserUrlAddressTypeBoolExp;
};

/** update columns of table "business.organization_user_url_address" */
export type BusinessOrganizationUserUrlAddressUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'label'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'url'
  | '%future added value';

export type BusinessOrganizationUserUrlAddressUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BusinessOrganizationUserUrlAddressSetInput>;
  /** filter the rows which have to be updated */
  where: BusinessOrganizationUserUrlAddressBoolExp;
};

/** columns and relationships of "business.queue_item_alarm_type" */
export type BusinessQueueItemAlarmType = {
  __typename?: 'BusinessQueueItemAlarmType';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "business.queue_item_alarm_type" */
export type BusinessQueueItemAlarmTypeAggregate = {
  __typename?: 'BusinessQueueItemAlarmTypeAggregate';
  aggregate?: Maybe<BusinessQueueItemAlarmTypeAggregateFields>;
  nodes: Array<BusinessQueueItemAlarmType>;
};

/** aggregate fields of "business.queue_item_alarm_type" */
export type BusinessQueueItemAlarmTypeAggregateFields = {
  __typename?: 'BusinessQueueItemAlarmTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BusinessQueueItemAlarmTypeMaxFields>;
  min?: Maybe<BusinessQueueItemAlarmTypeMinFields>;
};


/** aggregate fields of "business.queue_item_alarm_type" */
export type BusinessQueueItemAlarmTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<BusinessQueueItemAlarmTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.queue_item_alarm_type". All fields are combined with a logical 'AND'. */
export type BusinessQueueItemAlarmTypeBoolExp = {
  _and?: InputMaybe<Array<BusinessQueueItemAlarmTypeBoolExp>>;
  _not?: InputMaybe<BusinessQueueItemAlarmTypeBoolExp>;
  _or?: InputMaybe<Array<BusinessQueueItemAlarmTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.queue_item_alarm_type" */
export type BusinessQueueItemAlarmTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'queue_item_alarm_type_pkey'
  | '%future added value';

export type BusinessQueueItemAlarmTypeEnum =
  /** Due date */
  | 'DUEDATE'
  /** Reminder */
  | 'REMINDER'
  | '%future added value';

/** Boolean expression to compare columns of type "BusinessQueueItemAlarmTypeEnum". All fields are combined with logical 'AND'. */
export type BusinessQueueItemAlarmTypeEnumComparisonExp = {
  _eq?: InputMaybe<BusinessQueueItemAlarmTypeEnum>;
  _in?: InputMaybe<Array<BusinessQueueItemAlarmTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<BusinessQueueItemAlarmTypeEnum>;
  _nin?: InputMaybe<Array<BusinessQueueItemAlarmTypeEnum>>;
};

/** input type for inserting data into table "business.queue_item_alarm_type" */
export type BusinessQueueItemAlarmTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type BusinessQueueItemAlarmTypeMaxFields = {
  __typename?: 'BusinessQueueItemAlarmTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type BusinessQueueItemAlarmTypeMinFields = {
  __typename?: 'BusinessQueueItemAlarmTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.queue_item_alarm_type" */
export type BusinessQueueItemAlarmTypeMutationResponse = {
  __typename?: 'BusinessQueueItemAlarmTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BusinessQueueItemAlarmType>;
};

/** on_conflict condition type for table "business.queue_item_alarm_type" */
export type BusinessQueueItemAlarmTypeOnConflict = {
  constraint: BusinessQueueItemAlarmTypeConstraint;
  updateColumns?: Array<BusinessQueueItemAlarmTypeUpdateColumn>;
  where?: InputMaybe<BusinessQueueItemAlarmTypeBoolExp>;
};

/** Ordering options when selecting data from "business.queue_item_alarm_type". */
export type BusinessQueueItemAlarmTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.queue_item_alarm_type */
export type BusinessQueueItemAlarmTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "business.queue_item_alarm_type" */
export type BusinessQueueItemAlarmTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "business.queue_item_alarm_type" */
export type BusinessQueueItemAlarmTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "business_queue_item_alarm_type" */
export type BusinessQueueItemAlarmTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BusinessQueueItemAlarmTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BusinessQueueItemAlarmTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.queue_item_alarm_type" */
export type BusinessQueueItemAlarmTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type BusinessQueueItemAlarmTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BusinessQueueItemAlarmTypeSetInput>;
  /** filter the rows which have to be updated */
  where: BusinessQueueItemAlarmTypeBoolExp;
};

/** columns and relationships of "business.queue_item_alarms" */
export type BusinessQueueItemAlarms = {
  __typename?: 'BusinessQueueItemAlarms';
  absoluteDate?: Maybe<Scalars['timestamptz']['output']>;
  alarmSelectionType: BusinessQueueItemAlarmTypeEnum;
  calendarId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  organizationUserId: Scalars['uuid']['output'];
  /** An object relationship */
  queueItem?: Maybe<queueItem>;
  queueItemId: Scalars['uuid']['output'];
  relativeOffset?: Maybe<Scalars['numeric']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "business.queue_item_alarms" */
export type BusinessQueueItemAlarmsAggregate = {
  __typename?: 'BusinessQueueItemAlarmsAggregate';
  aggregate?: Maybe<BusinessQueueItemAlarmsAggregateFields>;
  nodes: Array<BusinessQueueItemAlarms>;
};

export type BusinessQueueItemAlarmsAggregateBoolExp = {
  count?: InputMaybe<businessQueueItemAlarmsAggregateBoolExpCount>;
};

/** aggregate fields of "business.queue_item_alarms" */
export type BusinessQueueItemAlarmsAggregateFields = {
  __typename?: 'BusinessQueueItemAlarmsAggregateFields';
  avg?: Maybe<BusinessQueueItemAlarmsAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<BusinessQueueItemAlarmsMaxFields>;
  min?: Maybe<BusinessQueueItemAlarmsMinFields>;
  stddev?: Maybe<BusinessQueueItemAlarmsStddevFields>;
  stddevPop?: Maybe<BusinessQueueItemAlarmsStddevPopFields>;
  stddevSamp?: Maybe<BusinessQueueItemAlarmsStddevSampFields>;
  sum?: Maybe<BusinessQueueItemAlarmsSumFields>;
  varPop?: Maybe<BusinessQueueItemAlarmsVarPopFields>;
  varSamp?: Maybe<BusinessQueueItemAlarmsVarSampFields>;
  variance?: Maybe<BusinessQueueItemAlarmsVarianceFields>;
};


/** aggregate fields of "business.queue_item_alarms" */
export type BusinessQueueItemAlarmsAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<BusinessQueueItemAlarmsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.queue_item_alarms" */
export type BusinessQueueItemAlarmsAggregateOrderBy = {
  avg?: InputMaybe<BusinessQueueItemAlarmsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BusinessQueueItemAlarmsMaxOrderBy>;
  min?: InputMaybe<BusinessQueueItemAlarmsMinOrderBy>;
  stddev?: InputMaybe<BusinessQueueItemAlarmsStddevOrderBy>;
  stddevPop?: InputMaybe<BusinessQueueItemAlarmsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<BusinessQueueItemAlarmsStddevSampOrderBy>;
  sum?: InputMaybe<BusinessQueueItemAlarmsSumOrderBy>;
  varPop?: InputMaybe<BusinessQueueItemAlarmsVarPopOrderBy>;
  varSamp?: InputMaybe<BusinessQueueItemAlarmsVarSampOrderBy>;
  variance?: InputMaybe<BusinessQueueItemAlarmsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "business.queue_item_alarms" */
export type BusinessQueueItemAlarmsArrRelInsertInput = {
  data: Array<BusinessQueueItemAlarmsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<BusinessQueueItemAlarmsOnConflict>;
};

/** aggregate avg on columns */
export type BusinessQueueItemAlarmsAvgFields = {
  __typename?: 'BusinessQueueItemAlarmsAvgFields';
  relativeOffset?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "business.queue_item_alarms" */
export type BusinessQueueItemAlarmsAvgOrderBy = {
  relativeOffset?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "business.queue_item_alarms". All fields are combined with a logical 'AND'. */
export type BusinessQueueItemAlarmsBoolExp = {
  _and?: InputMaybe<Array<BusinessQueueItemAlarmsBoolExp>>;
  _not?: InputMaybe<BusinessQueueItemAlarmsBoolExp>;
  _or?: InputMaybe<Array<BusinessQueueItemAlarmsBoolExp>>;
  absoluteDate?: InputMaybe<TimestamptzComparisonExp>;
  alarmSelectionType?: InputMaybe<BusinessQueueItemAlarmTypeEnumComparisonExp>;
  calendarId?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organizationUserId?: InputMaybe<UuidComparisonExp>;
  queueItem?: InputMaybe<queueItemBoolExp>;
  queueItemId?: InputMaybe<UuidComparisonExp>;
  relativeOffset?: InputMaybe<NumericComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "business.queue_item_alarms" */
export type BusinessQueueItemAlarmsConstraint =
  /** unique or primary key constraint on columns "organizationUserId", "queueItemId", "alarmSelectionType" */
  | 'queue_item_alarms_alarmSelectionType_queueItemId_organizationUs'
  /** unique or primary key constraint on columns "id" */
  | 'queue_item_alarms_pkey'
  | '%future added value';

/** input type for incrementing numeric columns in table "business.queue_item_alarms" */
export type BusinessQueueItemAlarmsIncInput = {
  relativeOffset?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "business.queue_item_alarms" */
export type BusinessQueueItemAlarmsInsertInput = {
  absoluteDate?: InputMaybe<Scalars['timestamptz']['input']>;
  alarmSelectionType?: InputMaybe<BusinessQueueItemAlarmTypeEnum>;
  calendarId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  queueItem?: InputMaybe<queueItemObjRelInsertInput>;
  queueItemId?: InputMaybe<Scalars['uuid']['input']>;
  relativeOffset?: InputMaybe<Scalars['numeric']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type BusinessQueueItemAlarmsMaxFields = {
  __typename?: 'BusinessQueueItemAlarmsMaxFields';
  absoluteDate?: Maybe<Scalars['timestamptz']['output']>;
  calendarId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  queueItemId?: Maybe<Scalars['uuid']['output']>;
  relativeOffset?: Maybe<Scalars['numeric']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "business.queue_item_alarms" */
export type BusinessQueueItemAlarmsMaxOrderBy = {
  absoluteDate?: InputMaybe<OrderBy>;
  calendarId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  queueItemId?: InputMaybe<OrderBy>;
  relativeOffset?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BusinessQueueItemAlarmsMinFields = {
  __typename?: 'BusinessQueueItemAlarmsMinFields';
  absoluteDate?: Maybe<Scalars['timestamptz']['output']>;
  calendarId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  queueItemId?: Maybe<Scalars['uuid']['output']>;
  relativeOffset?: Maybe<Scalars['numeric']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "business.queue_item_alarms" */
export type BusinessQueueItemAlarmsMinOrderBy = {
  absoluteDate?: InputMaybe<OrderBy>;
  calendarId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  queueItemId?: InputMaybe<OrderBy>;
  relativeOffset?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "business.queue_item_alarms" */
export type BusinessQueueItemAlarmsMutationResponse = {
  __typename?: 'BusinessQueueItemAlarmsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BusinessQueueItemAlarms>;
};

/** on_conflict condition type for table "business.queue_item_alarms" */
export type BusinessQueueItemAlarmsOnConflict = {
  constraint: BusinessQueueItemAlarmsConstraint;
  updateColumns?: Array<BusinessQueueItemAlarmsUpdateColumn>;
  where?: InputMaybe<BusinessQueueItemAlarmsBoolExp>;
};

/** Ordering options when selecting data from "business.queue_item_alarms". */
export type BusinessQueueItemAlarmsOrderBy = {
  absoluteDate?: InputMaybe<OrderBy>;
  alarmSelectionType?: InputMaybe<OrderBy>;
  calendarId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  queueItem?: InputMaybe<queueItemOrderBy>;
  queueItemId?: InputMaybe<OrderBy>;
  relativeOffset?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.queue_item_alarms */
export type BusinessQueueItemAlarmsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "business.queue_item_alarms" */
export type BusinessQueueItemAlarmsSelectColumn =
  /** column name */
  | 'absoluteDate'
  /** column name */
  | 'alarmSelectionType'
  /** column name */
  | 'calendarId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserId'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'queueItemId'
  /** column name */
  | 'relativeOffset'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "business.queue_item_alarms" */
export type BusinessQueueItemAlarmsSetInput = {
  absoluteDate?: InputMaybe<Scalars['timestamptz']['input']>;
  alarmSelectionType?: InputMaybe<BusinessQueueItemAlarmTypeEnum>;
  calendarId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  queueItemId?: InputMaybe<Scalars['uuid']['input']>;
  relativeOffset?: InputMaybe<Scalars['numeric']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type BusinessQueueItemAlarmsStddevFields = {
  __typename?: 'BusinessQueueItemAlarmsStddevFields';
  relativeOffset?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "business.queue_item_alarms" */
export type BusinessQueueItemAlarmsStddevOrderBy = {
  relativeOffset?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type BusinessQueueItemAlarmsStddevPopFields = {
  __typename?: 'BusinessQueueItemAlarmsStddevPopFields';
  relativeOffset?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "business.queue_item_alarms" */
export type BusinessQueueItemAlarmsStddevPopOrderBy = {
  relativeOffset?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type BusinessQueueItemAlarmsStddevSampFields = {
  __typename?: 'BusinessQueueItemAlarmsStddevSampFields';
  relativeOffset?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "business.queue_item_alarms" */
export type BusinessQueueItemAlarmsStddevSampOrderBy = {
  relativeOffset?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "business_queue_item_alarms" */
export type BusinessQueueItemAlarmsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BusinessQueueItemAlarmsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BusinessQueueItemAlarmsStreamCursorValueInput = {
  absoluteDate?: InputMaybe<Scalars['timestamptz']['input']>;
  alarmSelectionType?: InputMaybe<BusinessQueueItemAlarmTypeEnum>;
  calendarId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  queueItemId?: InputMaybe<Scalars['uuid']['input']>;
  relativeOffset?: InputMaybe<Scalars['numeric']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type BusinessQueueItemAlarmsSumFields = {
  __typename?: 'BusinessQueueItemAlarmsSumFields';
  relativeOffset?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "business.queue_item_alarms" */
export type BusinessQueueItemAlarmsSumOrderBy = {
  relativeOffset?: InputMaybe<OrderBy>;
};

/** update columns of table "business.queue_item_alarms" */
export type BusinessQueueItemAlarmsUpdateColumn =
  /** column name */
  | 'absoluteDate'
  /** column name */
  | 'alarmSelectionType'
  /** column name */
  | 'calendarId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserId'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'queueItemId'
  /** column name */
  | 'relativeOffset'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type BusinessQueueItemAlarmsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BusinessQueueItemAlarmsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BusinessQueueItemAlarmsSetInput>;
  /** filter the rows which have to be updated */
  where: BusinessQueueItemAlarmsBoolExp;
};

/** aggregate varPop on columns */
export type BusinessQueueItemAlarmsVarPopFields = {
  __typename?: 'BusinessQueueItemAlarmsVarPopFields';
  relativeOffset?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "business.queue_item_alarms" */
export type BusinessQueueItemAlarmsVarPopOrderBy = {
  relativeOffset?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type BusinessQueueItemAlarmsVarSampFields = {
  __typename?: 'BusinessQueueItemAlarmsVarSampFields';
  relativeOffset?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "business.queue_item_alarms" */
export type BusinessQueueItemAlarmsVarSampOrderBy = {
  relativeOffset?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type BusinessQueueItemAlarmsVarianceFields = {
  __typename?: 'BusinessQueueItemAlarmsVarianceFields';
  relativeOffset?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "business.queue_item_alarms" */
export type BusinessQueueItemAlarmsVarianceOrderBy = {
  relativeOffset?: InputMaybe<OrderBy>;
};

/** columns and relationships of "business.queue_item_domain_users_view" */
export type BusinessQueueItemDomainUsersView = {
  __typename?: 'BusinessQueueItemDomainUsersView';
  category?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  domainOrganizationId?: Maybe<Scalars['uuid']['output']>;
  domainUserUuid?: Maybe<Scalars['uuid']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organizationUser?: Maybe<organizationUser>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  queItemId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  queueItem?: Maybe<queueItem>;
  relOrganizationUserId?: Maybe<Scalars['uuid']['output']>;
  spamScore?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  triggerName?: Maybe<Scalars['String']['output']>;
  triggerTime?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "business.queue_item_domain_users_view" */
export type BusinessQueueItemDomainUsersViewAggregate = {
  __typename?: 'BusinessQueueItemDomainUsersViewAggregate';
  aggregate?: Maybe<BusinessQueueItemDomainUsersViewAggregateFields>;
  nodes: Array<BusinessQueueItemDomainUsersView>;
};

export type BusinessQueueItemDomainUsersViewAggregateBoolExp = {
  count?: InputMaybe<businessQueueItemDomainUsersViewAggregateBoolExpCount>;
};

/** aggregate fields of "business.queue_item_domain_users_view" */
export type BusinessQueueItemDomainUsersViewAggregateFields = {
  __typename?: 'BusinessQueueItemDomainUsersViewAggregateFields';
  avg?: Maybe<BusinessQueueItemDomainUsersViewAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<BusinessQueueItemDomainUsersViewMaxFields>;
  min?: Maybe<BusinessQueueItemDomainUsersViewMinFields>;
  stddev?: Maybe<BusinessQueueItemDomainUsersViewStddevFields>;
  stddevPop?: Maybe<BusinessQueueItemDomainUsersViewStddevPopFields>;
  stddevSamp?: Maybe<BusinessQueueItemDomainUsersViewStddevSampFields>;
  sum?: Maybe<BusinessQueueItemDomainUsersViewSumFields>;
  varPop?: Maybe<BusinessQueueItemDomainUsersViewVarPopFields>;
  varSamp?: Maybe<BusinessQueueItemDomainUsersViewVarSampFields>;
  variance?: Maybe<BusinessQueueItemDomainUsersViewVarianceFields>;
};


/** aggregate fields of "business.queue_item_domain_users_view" */
export type BusinessQueueItemDomainUsersViewAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<BusinessQueueItemDomainUsersViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.queue_item_domain_users_view" */
export type BusinessQueueItemDomainUsersViewAggregateOrderBy = {
  avg?: InputMaybe<BusinessQueueItemDomainUsersViewAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BusinessQueueItemDomainUsersViewMaxOrderBy>;
  min?: InputMaybe<BusinessQueueItemDomainUsersViewMinOrderBy>;
  stddev?: InputMaybe<BusinessQueueItemDomainUsersViewStddevOrderBy>;
  stddevPop?: InputMaybe<BusinessQueueItemDomainUsersViewStddevPopOrderBy>;
  stddevSamp?: InputMaybe<BusinessQueueItemDomainUsersViewStddevSampOrderBy>;
  sum?: InputMaybe<BusinessQueueItemDomainUsersViewSumOrderBy>;
  varPop?: InputMaybe<BusinessQueueItemDomainUsersViewVarPopOrderBy>;
  varSamp?: InputMaybe<BusinessQueueItemDomainUsersViewVarSampOrderBy>;
  variance?: InputMaybe<BusinessQueueItemDomainUsersViewVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "business.queue_item_domain_users_view" */
export type BusinessQueueItemDomainUsersViewArrRelInsertInput = {
  data: Array<BusinessQueueItemDomainUsersViewInsertInput>;
};

/** aggregate avg on columns */
export type BusinessQueueItemDomainUsersViewAvgFields = {
  __typename?: 'BusinessQueueItemDomainUsersViewAvgFields';
  spamScore?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "business.queue_item_domain_users_view" */
export type BusinessQueueItemDomainUsersViewAvgOrderBy = {
  spamScore?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "business.queue_item_domain_users_view". All fields are combined with a logical 'AND'. */
export type BusinessQueueItemDomainUsersViewBoolExp = {
  _and?: InputMaybe<Array<BusinessQueueItemDomainUsersViewBoolExp>>;
  _not?: InputMaybe<BusinessQueueItemDomainUsersViewBoolExp>;
  _or?: InputMaybe<Array<BusinessQueueItemDomainUsersViewBoolExp>>;
  category?: InputMaybe<StringComparisonExp>;
  city?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  department?: InputMaybe<StringComparisonExp>;
  domainOrganizationId?: InputMaybe<UuidComparisonExp>;
  domainUserUuid?: InputMaybe<UuidComparisonExp>;
  emailAddress?: InputMaybe<StringComparisonExp>;
  firstName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lastName?: InputMaybe<StringComparisonExp>;
  organizationUser?: InputMaybe<organizationUserBoolExp>;
  organizationUserId?: InputMaybe<UuidComparisonExp>;
  phoneNumber?: InputMaybe<StringComparisonExp>;
  position?: InputMaybe<StringComparisonExp>;
  queItemId?: InputMaybe<UuidComparisonExp>;
  queueItem?: InputMaybe<queueItemBoolExp>;
  relOrganizationUserId?: InputMaybe<UuidComparisonExp>;
  spamScore?: InputMaybe<IntComparisonExp>;
  street?: InputMaybe<StringComparisonExp>;
  triggerName?: InputMaybe<StringComparisonExp>;
  triggerTime?: InputMaybe<TimestamptzComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  zip?: InputMaybe<StringComparisonExp>;
};

/** input type for inserting data into table "business.queue_item_domain_users_view" */
export type BusinessQueueItemDomainUsersViewInsertInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  domainOrganizationId?: InputMaybe<Scalars['uuid']['input']>;
  domainUserUuid?: InputMaybe<Scalars['uuid']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationUser?: InputMaybe<organizationUserObjRelInsertInput>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  queItemId?: InputMaybe<Scalars['uuid']['input']>;
  queueItem?: InputMaybe<queueItemObjRelInsertInput>;
  relOrganizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  spamScore?: InputMaybe<Scalars['Int']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  triggerName?: InputMaybe<Scalars['String']['input']>;
  triggerTime?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type BusinessQueueItemDomainUsersViewMaxFields = {
  __typename?: 'BusinessQueueItemDomainUsersViewMaxFields';
  category?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  domainOrganizationId?: Maybe<Scalars['uuid']['output']>;
  domainUserUuid?: Maybe<Scalars['uuid']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  queItemId?: Maybe<Scalars['uuid']['output']>;
  relOrganizationUserId?: Maybe<Scalars['uuid']['output']>;
  spamScore?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  triggerName?: Maybe<Scalars['String']['output']>;
  triggerTime?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "business.queue_item_domain_users_view" */
export type BusinessQueueItemDomainUsersViewMaxOrderBy = {
  category?: InputMaybe<OrderBy>;
  city?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  department?: InputMaybe<OrderBy>;
  domainOrganizationId?: InputMaybe<OrderBy>;
  domainUserUuid?: InputMaybe<OrderBy>;
  emailAddress?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  queItemId?: InputMaybe<OrderBy>;
  relOrganizationUserId?: InputMaybe<OrderBy>;
  spamScore?: InputMaybe<OrderBy>;
  street?: InputMaybe<OrderBy>;
  triggerName?: InputMaybe<OrderBy>;
  triggerTime?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  zip?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BusinessQueueItemDomainUsersViewMinFields = {
  __typename?: 'BusinessQueueItemDomainUsersViewMinFields';
  category?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  domainOrganizationId?: Maybe<Scalars['uuid']['output']>;
  domainUserUuid?: Maybe<Scalars['uuid']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  queItemId?: Maybe<Scalars['uuid']['output']>;
  relOrganizationUserId?: Maybe<Scalars['uuid']['output']>;
  spamScore?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  triggerName?: Maybe<Scalars['String']['output']>;
  triggerTime?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "business.queue_item_domain_users_view" */
export type BusinessQueueItemDomainUsersViewMinOrderBy = {
  category?: InputMaybe<OrderBy>;
  city?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  department?: InputMaybe<OrderBy>;
  domainOrganizationId?: InputMaybe<OrderBy>;
  domainUserUuid?: InputMaybe<OrderBy>;
  emailAddress?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  queItemId?: InputMaybe<OrderBy>;
  relOrganizationUserId?: InputMaybe<OrderBy>;
  spamScore?: InputMaybe<OrderBy>;
  street?: InputMaybe<OrderBy>;
  triggerName?: InputMaybe<OrderBy>;
  triggerTime?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  zip?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "business.queue_item_domain_users_view". */
export type BusinessQueueItemDomainUsersViewOrderBy = {
  category?: InputMaybe<OrderBy>;
  city?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  department?: InputMaybe<OrderBy>;
  domainOrganizationId?: InputMaybe<OrderBy>;
  domainUserUuid?: InputMaybe<OrderBy>;
  emailAddress?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  organizationUser?: InputMaybe<organizationUserOrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  queItemId?: InputMaybe<OrderBy>;
  queueItem?: InputMaybe<queueItemOrderBy>;
  relOrganizationUserId?: InputMaybe<OrderBy>;
  spamScore?: InputMaybe<OrderBy>;
  street?: InputMaybe<OrderBy>;
  triggerName?: InputMaybe<OrderBy>;
  triggerTime?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  zip?: InputMaybe<OrderBy>;
};

/** select columns of table "business.queue_item_domain_users_view" */
export type BusinessQueueItemDomainUsersViewSelectColumn =
  /** column name */
  | 'category'
  /** column name */
  | 'city'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'department'
  /** column name */
  | 'domainOrganizationId'
  /** column name */
  | 'domainUserUuid'
  /** column name */
  | 'emailAddress'
  /** column name */
  | 'firstName'
  /** column name */
  | 'id'
  /** column name */
  | 'lastName'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'phoneNumber'
  /** column name */
  | 'position'
  /** column name */
  | 'queItemId'
  /** column name */
  | 'relOrganizationUserId'
  /** column name */
  | 'spamScore'
  /** column name */
  | 'street'
  /** column name */
  | 'triggerName'
  /** column name */
  | 'triggerTime'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'zip'
  | '%future added value';

/** aggregate stddev on columns */
export type BusinessQueueItemDomainUsersViewStddevFields = {
  __typename?: 'BusinessQueueItemDomainUsersViewStddevFields';
  spamScore?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "business.queue_item_domain_users_view" */
export type BusinessQueueItemDomainUsersViewStddevOrderBy = {
  spamScore?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type BusinessQueueItemDomainUsersViewStddevPopFields = {
  __typename?: 'BusinessQueueItemDomainUsersViewStddevPopFields';
  spamScore?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "business.queue_item_domain_users_view" */
export type BusinessQueueItemDomainUsersViewStddevPopOrderBy = {
  spamScore?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type BusinessQueueItemDomainUsersViewStddevSampFields = {
  __typename?: 'BusinessQueueItemDomainUsersViewStddevSampFields';
  spamScore?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "business.queue_item_domain_users_view" */
export type BusinessQueueItemDomainUsersViewStddevSampOrderBy = {
  spamScore?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "business_queue_item_domain_users_view" */
export type BusinessQueueItemDomainUsersViewStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BusinessQueueItemDomainUsersViewStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BusinessQueueItemDomainUsersViewStreamCursorValueInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  domainOrganizationId?: InputMaybe<Scalars['uuid']['input']>;
  domainUserUuid?: InputMaybe<Scalars['uuid']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  queItemId?: InputMaybe<Scalars['uuid']['input']>;
  relOrganizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  spamScore?: InputMaybe<Scalars['Int']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  triggerName?: InputMaybe<Scalars['String']['input']>;
  triggerTime?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type BusinessQueueItemDomainUsersViewSumFields = {
  __typename?: 'BusinessQueueItemDomainUsersViewSumFields';
  spamScore?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "business.queue_item_domain_users_view" */
export type BusinessQueueItemDomainUsersViewSumOrderBy = {
  spamScore?: InputMaybe<OrderBy>;
};

/** aggregate varPop on columns */
export type BusinessQueueItemDomainUsersViewVarPopFields = {
  __typename?: 'BusinessQueueItemDomainUsersViewVarPopFields';
  spamScore?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "business.queue_item_domain_users_view" */
export type BusinessQueueItemDomainUsersViewVarPopOrderBy = {
  spamScore?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type BusinessQueueItemDomainUsersViewVarSampFields = {
  __typename?: 'BusinessQueueItemDomainUsersViewVarSampFields';
  spamScore?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "business.queue_item_domain_users_view" */
export type BusinessQueueItemDomainUsersViewVarSampOrderBy = {
  spamScore?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type BusinessQueueItemDomainUsersViewVarianceFields = {
  __typename?: 'BusinessQueueItemDomainUsersViewVarianceFields';
  spamScore?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "business.queue_item_domain_users_view" */
export type BusinessQueueItemDomainUsersViewVarianceOrderBy = {
  spamScore?: InputMaybe<OrderBy>;
};

/** columns and relationships of "business.queue_item_organization_users_view" */
export type BusinessQueueItemOrganizationUsersView = {
  __typename?: 'BusinessQueueItemOrganizationUsersView';
  /** An object relationship */
  company?: Maybe<organizationUser>;
  companyId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization?: Maybe<organization>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  queItemId?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user?: Maybe<user>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "business.queue_item_organization_users_view" */
export type BusinessQueueItemOrganizationUsersViewAggregate = {
  __typename?: 'BusinessQueueItemOrganizationUsersViewAggregate';
  aggregate?: Maybe<BusinessQueueItemOrganizationUsersViewAggregateFields>;
  nodes: Array<BusinessQueueItemOrganizationUsersView>;
};

export type BusinessQueueItemOrganizationUsersViewAggregateBoolExp = {
  count?: InputMaybe<businessQueueItemOrganizationUsersViewAggregateBoolExpCount>;
};

/** aggregate fields of "business.queue_item_organization_users_view" */
export type BusinessQueueItemOrganizationUsersViewAggregateFields = {
  __typename?: 'BusinessQueueItemOrganizationUsersViewAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BusinessQueueItemOrganizationUsersViewMaxFields>;
  min?: Maybe<BusinessQueueItemOrganizationUsersViewMinFields>;
};


/** aggregate fields of "business.queue_item_organization_users_view" */
export type BusinessQueueItemOrganizationUsersViewAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<BusinessQueueItemOrganizationUsersViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.queue_item_organization_users_view" */
export type BusinessQueueItemOrganizationUsersViewAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BusinessQueueItemOrganizationUsersViewMaxOrderBy>;
  min?: InputMaybe<BusinessQueueItemOrganizationUsersViewMinOrderBy>;
};

/** input type for inserting array relation for remote table "business.queue_item_organization_users_view" */
export type BusinessQueueItemOrganizationUsersViewArrRelInsertInput = {
  data: Array<BusinessQueueItemOrganizationUsersViewInsertInput>;
};

/** Boolean expression to filter rows from the table "business.queue_item_organization_users_view". All fields are combined with a logical 'AND'. */
export type BusinessQueueItemOrganizationUsersViewBoolExp = {
  _and?: InputMaybe<Array<BusinessQueueItemOrganizationUsersViewBoolExp>>;
  _not?: InputMaybe<BusinessQueueItemOrganizationUsersViewBoolExp>;
  _or?: InputMaybe<Array<BusinessQueueItemOrganizationUsersViewBoolExp>>;
  company?: InputMaybe<organizationUserBoolExp>;
  companyId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  department?: InputMaybe<StringComparisonExp>;
  emailAddress?: InputMaybe<StringComparisonExp>;
  firstName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lastName?: InputMaybe<StringComparisonExp>;
  organization?: InputMaybe<organizationBoolExp>;
  organizationId?: InputMaybe<UuidComparisonExp>;
  phoneNumber?: InputMaybe<StringComparisonExp>;
  position?: InputMaybe<StringComparisonExp>;
  queItemId?: InputMaybe<UuidComparisonExp>;
  role?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<userBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** input type for inserting data into table "business.queue_item_organization_users_view" */
export type BusinessQueueItemOrganizationUsersViewInsertInput = {
  company?: InputMaybe<organizationUserObjRelInsertInput>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<organizationObjRelInsertInput>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  queItemId?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<userObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type BusinessQueueItemOrganizationUsersViewMaxFields = {
  __typename?: 'BusinessQueueItemOrganizationUsersViewMaxFields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  queItemId?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "business.queue_item_organization_users_view" */
export type BusinessQueueItemOrganizationUsersViewMaxOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  department?: InputMaybe<OrderBy>;
  emailAddress?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  queItemId?: InputMaybe<OrderBy>;
  role?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BusinessQueueItemOrganizationUsersViewMinFields = {
  __typename?: 'BusinessQueueItemOrganizationUsersViewMinFields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  queItemId?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "business.queue_item_organization_users_view" */
export type BusinessQueueItemOrganizationUsersViewMinOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  department?: InputMaybe<OrderBy>;
  emailAddress?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  queItemId?: InputMaybe<OrderBy>;
  role?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "business.queue_item_organization_users_view". */
export type BusinessQueueItemOrganizationUsersViewOrderBy = {
  company?: InputMaybe<organizationUserOrderBy>;
  companyId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  department?: InputMaybe<OrderBy>;
  emailAddress?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  organization?: InputMaybe<organizationOrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  queItemId?: InputMaybe<OrderBy>;
  role?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<userOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** select columns of table "business.queue_item_organization_users_view" */
export type BusinessQueueItemOrganizationUsersViewSelectColumn =
  /** column name */
  | 'companyId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'department'
  /** column name */
  | 'emailAddress'
  /** column name */
  | 'firstName'
  /** column name */
  | 'id'
  /** column name */
  | 'lastName'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'phoneNumber'
  /** column name */
  | 'position'
  /** column name */
  | 'queItemId'
  /** column name */
  | 'role'
  /** column name */
  | 'status'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

/** Streaming cursor of the table "business_queue_item_organization_users_view" */
export type BusinessQueueItemOrganizationUsersViewStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BusinessQueueItemOrganizationUsersViewStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BusinessQueueItemOrganizationUsersViewStreamCursorValueInput = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  queItemId?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "business.queue_item_participant_channel_type" */
export type BusinessQueueItemParticipantChannelType = {
  __typename?: 'BusinessQueueItemParticipantChannelType';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "business.queue_item_participant_channel_type" */
export type BusinessQueueItemParticipantChannelTypeAggregate = {
  __typename?: 'BusinessQueueItemParticipantChannelTypeAggregate';
  aggregate?: Maybe<BusinessQueueItemParticipantChannelTypeAggregateFields>;
  nodes: Array<BusinessQueueItemParticipantChannelType>;
};

/** aggregate fields of "business.queue_item_participant_channel_type" */
export type BusinessQueueItemParticipantChannelTypeAggregateFields = {
  __typename?: 'BusinessQueueItemParticipantChannelTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BusinessQueueItemParticipantChannelTypeMaxFields>;
  min?: Maybe<BusinessQueueItemParticipantChannelTypeMinFields>;
};


/** aggregate fields of "business.queue_item_participant_channel_type" */
export type BusinessQueueItemParticipantChannelTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<BusinessQueueItemParticipantChannelTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.queue_item_participant_channel_type". All fields are combined with a logical 'AND'. */
export type BusinessQueueItemParticipantChannelTypeBoolExp = {
  _and?: InputMaybe<Array<BusinessQueueItemParticipantChannelTypeBoolExp>>;
  _not?: InputMaybe<BusinessQueueItemParticipantChannelTypeBoolExp>;
  _or?: InputMaybe<Array<BusinessQueueItemParticipantChannelTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.queue_item_participant_channel_type" */
export type BusinessQueueItemParticipantChannelTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'queue_item_participant_channel_type_pkey'
  | '%future added value';

export type BusinessQueueItemParticipantChannelTypeEnum =
  /** email */
  | 'EMAIL'
  /** Phone number */
  | 'PHONENUMBER'
  | '%future added value';

/** Boolean expression to compare columns of type "BusinessQueueItemParticipantChannelTypeEnum". All fields are combined with logical 'AND'. */
export type BusinessQueueItemParticipantChannelTypeEnumComparisonExp = {
  _eq?: InputMaybe<BusinessQueueItemParticipantChannelTypeEnum>;
  _in?: InputMaybe<Array<BusinessQueueItemParticipantChannelTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<BusinessQueueItemParticipantChannelTypeEnum>;
  _nin?: InputMaybe<Array<BusinessQueueItemParticipantChannelTypeEnum>>;
};

/** input type for inserting data into table "business.queue_item_participant_channel_type" */
export type BusinessQueueItemParticipantChannelTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type BusinessQueueItemParticipantChannelTypeMaxFields = {
  __typename?: 'BusinessQueueItemParticipantChannelTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type BusinessQueueItemParticipantChannelTypeMinFields = {
  __typename?: 'BusinessQueueItemParticipantChannelTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.queue_item_participant_channel_type" */
export type BusinessQueueItemParticipantChannelTypeMutationResponse = {
  __typename?: 'BusinessQueueItemParticipantChannelTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BusinessQueueItemParticipantChannelType>;
};

/** on_conflict condition type for table "business.queue_item_participant_channel_type" */
export type BusinessQueueItemParticipantChannelTypeOnConflict = {
  constraint: BusinessQueueItemParticipantChannelTypeConstraint;
  updateColumns?: Array<BusinessQueueItemParticipantChannelTypeUpdateColumn>;
  where?: InputMaybe<BusinessQueueItemParticipantChannelTypeBoolExp>;
};

/** Ordering options when selecting data from "business.queue_item_participant_channel_type". */
export type BusinessQueueItemParticipantChannelTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.queue_item_participant_channel_type */
export type BusinessQueueItemParticipantChannelTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "business.queue_item_participant_channel_type" */
export type BusinessQueueItemParticipantChannelTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "business.queue_item_participant_channel_type" */
export type BusinessQueueItemParticipantChannelTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "business_queue_item_participant_channel_type" */
export type BusinessQueueItemParticipantChannelTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BusinessQueueItemParticipantChannelTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BusinessQueueItemParticipantChannelTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.queue_item_participant_channel_type" */
export type BusinessQueueItemParticipantChannelTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type BusinessQueueItemParticipantChannelTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BusinessQueueItemParticipantChannelTypeSetInput>;
  /** filter the rows which have to be updated */
  where: BusinessQueueItemParticipantChannelTypeBoolExp;
};

/** columns and relationships of "business.queue_item_participants_view" */
export type BusinessQueueItemParticipantsView = {
  __typename?: 'BusinessQueueItemParticipantsView';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  queItemId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  queueItem?: Maybe<queueItem>;
  role?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "business.queue_item_participants_view" */
export type BusinessQueueItemParticipantsViewAggregate = {
  __typename?: 'BusinessQueueItemParticipantsViewAggregate';
  aggregate?: Maybe<BusinessQueueItemParticipantsViewAggregateFields>;
  nodes: Array<BusinessQueueItemParticipantsView>;
};

export type BusinessQueueItemParticipantsViewAggregateBoolExp = {
  count?: InputMaybe<businessQueueItemParticipantsViewAggregateBoolExpCount>;
};

/** aggregate fields of "business.queue_item_participants_view" */
export type BusinessQueueItemParticipantsViewAggregateFields = {
  __typename?: 'BusinessQueueItemParticipantsViewAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BusinessQueueItemParticipantsViewMaxFields>;
  min?: Maybe<BusinessQueueItemParticipantsViewMinFields>;
};


/** aggregate fields of "business.queue_item_participants_view" */
export type BusinessQueueItemParticipantsViewAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<BusinessQueueItemParticipantsViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.queue_item_participants_view" */
export type BusinessQueueItemParticipantsViewAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BusinessQueueItemParticipantsViewMaxOrderBy>;
  min?: InputMaybe<BusinessQueueItemParticipantsViewMinOrderBy>;
};

/** input type for inserting array relation for remote table "business.queue_item_participants_view" */
export type BusinessQueueItemParticipantsViewArrRelInsertInput = {
  data: Array<BusinessQueueItemParticipantsViewInsertInput>;
};

/** Boolean expression to filter rows from the table "business.queue_item_participants_view". All fields are combined with a logical 'AND'. */
export type BusinessQueueItemParticipantsViewBoolExp = {
  _and?: InputMaybe<Array<BusinessQueueItemParticipantsViewBoolExp>>;
  _not?: InputMaybe<BusinessQueueItemParticipantsViewBoolExp>;
  _or?: InputMaybe<Array<BusinessQueueItemParticipantsViewBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  department?: InputMaybe<StringComparisonExp>;
  emailAddress?: InputMaybe<StringComparisonExp>;
  firstName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lastName?: InputMaybe<StringComparisonExp>;
  organizationId?: InputMaybe<UuidComparisonExp>;
  phoneNumber?: InputMaybe<StringComparisonExp>;
  position?: InputMaybe<StringComparisonExp>;
  queItemId?: InputMaybe<UuidComparisonExp>;
  queueItem?: InputMaybe<queueItemBoolExp>;
  role?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** input type for inserting data into table "business.queue_item_participants_view" */
export type BusinessQueueItemParticipantsViewInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  queItemId?: InputMaybe<Scalars['uuid']['input']>;
  queueItem?: InputMaybe<queueItemObjRelInsertInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type BusinessQueueItemParticipantsViewMaxFields = {
  __typename?: 'BusinessQueueItemParticipantsViewMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  queItemId?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "business.queue_item_participants_view" */
export type BusinessQueueItemParticipantsViewMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  department?: InputMaybe<OrderBy>;
  emailAddress?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  queItemId?: InputMaybe<OrderBy>;
  role?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BusinessQueueItemParticipantsViewMinFields = {
  __typename?: 'BusinessQueueItemParticipantsViewMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  queItemId?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "business.queue_item_participants_view" */
export type BusinessQueueItemParticipantsViewMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  department?: InputMaybe<OrderBy>;
  emailAddress?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  queItemId?: InputMaybe<OrderBy>;
  role?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "business.queue_item_participants_view". */
export type BusinessQueueItemParticipantsViewOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  department?: InputMaybe<OrderBy>;
  emailAddress?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  queItemId?: InputMaybe<OrderBy>;
  queueItem?: InputMaybe<queueItemOrderBy>;
  role?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** select columns of table "business.queue_item_participants_view" */
export type BusinessQueueItemParticipantsViewSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'department'
  /** column name */
  | 'emailAddress'
  /** column name */
  | 'firstName'
  /** column name */
  | 'id'
  /** column name */
  | 'lastName'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'phoneNumber'
  /** column name */
  | 'position'
  /** column name */
  | 'queItemId'
  /** column name */
  | 'role'
  /** column name */
  | 'status'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

/** Streaming cursor of the table "business_queue_item_participants_view" */
export type BusinessQueueItemParticipantsViewStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BusinessQueueItemParticipantsViewStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BusinessQueueItemParticipantsViewStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  queItemId?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "business.queue_item_sub_type" */
export type BusinessQueueItemSubType = {
  __typename?: 'BusinessQueueItemSubType';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "business.queue_item_sub_type" */
export type BusinessQueueItemSubTypeAggregate = {
  __typename?: 'BusinessQueueItemSubTypeAggregate';
  aggregate?: Maybe<BusinessQueueItemSubTypeAggregateFields>;
  nodes: Array<BusinessQueueItemSubType>;
};

/** aggregate fields of "business.queue_item_sub_type" */
export type BusinessQueueItemSubTypeAggregateFields = {
  __typename?: 'BusinessQueueItemSubTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BusinessQueueItemSubTypeMaxFields>;
  min?: Maybe<BusinessQueueItemSubTypeMinFields>;
};


/** aggregate fields of "business.queue_item_sub_type" */
export type BusinessQueueItemSubTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<BusinessQueueItemSubTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.queue_item_sub_type". All fields are combined with a logical 'AND'. */
export type BusinessQueueItemSubTypeBoolExp = {
  _and?: InputMaybe<Array<BusinessQueueItemSubTypeBoolExp>>;
  _not?: InputMaybe<BusinessQueueItemSubTypeBoolExp>;
  _or?: InputMaybe<Array<BusinessQueueItemSubTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.queue_item_sub_type" */
export type BusinessQueueItemSubTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'queue_item_subtype_pkey'
  | '%future added value';

/** input type for inserting data into table "business.queue_item_sub_type" */
export type BusinessQueueItemSubTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type BusinessQueueItemSubTypeMaxFields = {
  __typename?: 'BusinessQueueItemSubTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type BusinessQueueItemSubTypeMinFields = {
  __typename?: 'BusinessQueueItemSubTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.queue_item_sub_type" */
export type BusinessQueueItemSubTypeMutationResponse = {
  __typename?: 'BusinessQueueItemSubTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BusinessQueueItemSubType>;
};

/** input type for inserting object relation for remote table "business.queue_item_sub_type" */
export type BusinessQueueItemSubTypeObjRelInsertInput = {
  data: BusinessQueueItemSubTypeInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<BusinessQueueItemSubTypeOnConflict>;
};

/** on_conflict condition type for table "business.queue_item_sub_type" */
export type BusinessQueueItemSubTypeOnConflict = {
  constraint: BusinessQueueItemSubTypeConstraint;
  updateColumns?: Array<BusinessQueueItemSubTypeUpdateColumn>;
  where?: InputMaybe<BusinessQueueItemSubTypeBoolExp>;
};

/** Ordering options when selecting data from "business.queue_item_sub_type". */
export type BusinessQueueItemSubTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.queue_item_sub_type */
export type BusinessQueueItemSubTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "business.queue_item_sub_type" */
export type BusinessQueueItemSubTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "business.queue_item_sub_type" */
export type BusinessQueueItemSubTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "business_queue_item_sub_type" */
export type BusinessQueueItemSubTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BusinessQueueItemSubTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BusinessQueueItemSubTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.queue_item_sub_type" */
export type BusinessQueueItemSubTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type BusinessQueueItemSubTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BusinessQueueItemSubTypeSetInput>;
  /** filter the rows which have to be updated */
  where: BusinessQueueItemSubTypeBoolExp;
};

/** columns and relationships of "business.user_contact_numbers" */
export type BusinessUserContactNumbers = {
  __typename?: 'BusinessUserContactNumbers';
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  digits?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  number?: Maybe<Scalars['String']['output']>;
  origId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  userContact: businessUserContacts;
  userContactId: Scalars['uuid']['output'];
};

/** aggregated selection of "business.user_contact_numbers" */
export type BusinessUserContactNumbersAggregate = {
  __typename?: 'BusinessUserContactNumbersAggregate';
  aggregate?: Maybe<BusinessUserContactNumbersAggregateFields>;
  nodes: Array<BusinessUserContactNumbers>;
};

export type BusinessUserContactNumbersAggregateBoolExp = {
  bool_and?: InputMaybe<businessUserContactNumbersAggregateBoolExpBool_and>;
  bool_or?: InputMaybe<businessUserContactNumbersAggregateBoolExpBool_or>;
  count?: InputMaybe<businessUserContactNumbersAggregateBoolExpCount>;
};

/** aggregate fields of "business.user_contact_numbers" */
export type BusinessUserContactNumbersAggregateFields = {
  __typename?: 'BusinessUserContactNumbersAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BusinessUserContactNumbersMaxFields>;
  min?: Maybe<BusinessUserContactNumbersMinFields>;
};


/** aggregate fields of "business.user_contact_numbers" */
export type BusinessUserContactNumbersAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<BusinessUserContactNumbersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.user_contact_numbers" */
export type BusinessUserContactNumbersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BusinessUserContactNumbersMaxOrderBy>;
  min?: InputMaybe<BusinessUserContactNumbersMinOrderBy>;
};

/** input type for inserting array relation for remote table "business.user_contact_numbers" */
export type BusinessUserContactNumbersArrRelInsertInput = {
  data: Array<BusinessUserContactNumbersInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<BusinessUserContactNumbersOnConflict>;
};

/** Boolean expression to filter rows from the table "business.user_contact_numbers". All fields are combined with a logical 'AND'. */
export type BusinessUserContactNumbersBoolExp = {
  _and?: InputMaybe<Array<BusinessUserContactNumbersBoolExp>>;
  _not?: InputMaybe<BusinessUserContactNumbersBoolExp>;
  _or?: InputMaybe<Array<BusinessUserContactNumbersBoolExp>>;
  countryCode?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  digits?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isPrimary?: InputMaybe<BooleanComparisonExp>;
  label?: InputMaybe<StringComparisonExp>;
  number?: InputMaybe<StringComparisonExp>;
  origId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userContact?: InputMaybe<businessUserContactsBoolExp>;
  userContactId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "business.user_contact_numbers" */
export type BusinessUserContactNumbersConstraint =
  /** unique or primary key constraint on columns "userContactId", "origId" */
  | 'user_contact_numbers_origId_userContactId_key'
  /** unique or primary key constraint on columns "id" */
  | 'user_contact_numbers_pkey'
  | '%future added value';

/** input type for inserting data into table "business.user_contact_numbers" */
export type BusinessUserContactNumbersInsertInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  digits?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  origId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userContact?: InputMaybe<businessUserContactsObjRelInsertInput>;
  userContactId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type BusinessUserContactNumbersMaxFields = {
  __typename?: 'BusinessUserContactNumbersMaxFields';
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  digits?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  origId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userContactId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "business.user_contact_numbers" */
export type BusinessUserContactNumbersMaxOrderBy = {
  countryCode?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  digits?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  number?: InputMaybe<OrderBy>;
  origId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userContactId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BusinessUserContactNumbersMinFields = {
  __typename?: 'BusinessUserContactNumbersMinFields';
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  digits?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  origId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userContactId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "business.user_contact_numbers" */
export type BusinessUserContactNumbersMinOrderBy = {
  countryCode?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  digits?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  number?: InputMaybe<OrderBy>;
  origId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userContactId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "business.user_contact_numbers" */
export type BusinessUserContactNumbersMutationResponse = {
  __typename?: 'BusinessUserContactNumbersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BusinessUserContactNumbers>;
};

/** on_conflict condition type for table "business.user_contact_numbers" */
export type BusinessUserContactNumbersOnConflict = {
  constraint: BusinessUserContactNumbersConstraint;
  updateColumns?: Array<BusinessUserContactNumbersUpdateColumn>;
  where?: InputMaybe<BusinessUserContactNumbersBoolExp>;
};

/** Ordering options when selecting data from "business.user_contact_numbers". */
export type BusinessUserContactNumbersOrderBy = {
  countryCode?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  digits?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isPrimary?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  number?: InputMaybe<OrderBy>;
  origId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userContact?: InputMaybe<businessUserContactsOrderBy>;
  userContactId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.user_contact_numbers */
export type BusinessUserContactNumbersPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "business.user_contact_numbers" */
export type BusinessUserContactNumbersSelectColumn =
  /** column name */
  | 'countryCode'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'digits'
  /** column name */
  | 'id'
  /** column name */
  | 'isPrimary'
  /** column name */
  | 'label'
  /** column name */
  | 'number'
  /** column name */
  | 'origId'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userContactId'
  | '%future added value';

/** select "businessUserContactNumbersAggregateBoolExpBool_andArgumentsColumns" columns of table "business.user_contact_numbers" */
export type BusinessUserContactNumbersSelectColumnBusinessUserContactNumbersAggregateBoolExpBool_andArgumentsColumns =
  /** column name */
  | 'isPrimary'
  | '%future added value';

/** select "businessUserContactNumbersAggregateBoolExpBool_orArgumentsColumns" columns of table "business.user_contact_numbers" */
export type BusinessUserContactNumbersSelectColumnBusinessUserContactNumbersAggregateBoolExpBool_orArgumentsColumns =
  /** column name */
  | 'isPrimary'
  | '%future added value';

/** input type for updating data in table "business.user_contact_numbers" */
export type BusinessUserContactNumbersSetInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  digits?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  origId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userContactId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "business_user_contact_numbers" */
export type BusinessUserContactNumbersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BusinessUserContactNumbersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BusinessUserContactNumbersStreamCursorValueInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  digits?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  origId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userContactId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "business.user_contact_numbers" */
export type BusinessUserContactNumbersUpdateColumn =
  /** column name */
  | 'countryCode'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'digits'
  /** column name */
  | 'id'
  /** column name */
  | 'isPrimary'
  /** column name */
  | 'label'
  /** column name */
  | 'number'
  /** column name */
  | 'origId'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userContactId'
  | '%future added value';

export type BusinessUserContactNumbersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BusinessUserContactNumbersSetInput>;
  /** filter the rows which have to be updated */
  where: BusinessUserContactNumbersBoolExp;
};

/** columns and relationships of "business.user_feed" */
export type BusinessUserFeed = {
  __typename?: 'BusinessUserFeed';
  completed?: Maybe<Scalars['Boolean']['output']>;
  count: Scalars['Boolean']['output'];
  createdAt: Scalars['timestamptz']['output'];
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  deletedAt?: Maybe<Scalars['timetz']['output']>;
  extraData?: Maybe<Scalars['jsonb']['output']>;
  feedSeen: Scalars['Boolean']['output'];
  feedType: BusinessFeedTypeEnum;
  id: Scalars['uuid']['output'];
  important: Scalars['Boolean']['output'];
  sourceId?: Maybe<Scalars['uuid']['output']>;
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: user;
  userId: Scalars['uuid']['output'];
};


/** columns and relationships of "business.user_feed" */
export type BusinessUserFeedextraDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "business.user_feed" */
export type BusinessUserFeedAggregate = {
  __typename?: 'BusinessUserFeedAggregate';
  aggregate?: Maybe<BusinessUserFeedAggregateFields>;
  nodes: Array<BusinessUserFeed>;
};

export type BusinessUserFeedAggregateBoolExp = {
  bool_and?: InputMaybe<businessUserFeedAggregateBoolExpBool_and>;
  bool_or?: InputMaybe<businessUserFeedAggregateBoolExpBool_or>;
  count?: InputMaybe<businessUserFeedAggregateBoolExpCount>;
};

/** aggregate fields of "business.user_feed" */
export type BusinessUserFeedAggregateFields = {
  __typename?: 'BusinessUserFeedAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BusinessUserFeedMaxFields>;
  min?: Maybe<BusinessUserFeedMinFields>;
};


/** aggregate fields of "business.user_feed" */
export type BusinessUserFeedAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<BusinessUserFeedSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.user_feed" */
export type BusinessUserFeedAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BusinessUserFeedMaxOrderBy>;
  min?: InputMaybe<BusinessUserFeedMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type BusinessUserFeedAppendInput = {
  extraData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "business.user_feed" */
export type BusinessUserFeedArrRelInsertInput = {
  data: Array<BusinessUserFeedInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<BusinessUserFeedOnConflict>;
};

/** Boolean expression to filter rows from the table "business.user_feed". All fields are combined with a logical 'AND'. */
export type BusinessUserFeedBoolExp = {
  _and?: InputMaybe<Array<BusinessUserFeedBoolExp>>;
  _not?: InputMaybe<BusinessUserFeedBoolExp>;
  _or?: InputMaybe<Array<BusinessUserFeedBoolExp>>;
  completed?: InputMaybe<BooleanComparisonExp>;
  count?: InputMaybe<BooleanComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserId?: InputMaybe<UuidComparisonExp>;
  deletedAt?: InputMaybe<TimetzComparisonExp>;
  extraData?: InputMaybe<JsonbComparisonExp>;
  feedSeen?: InputMaybe<BooleanComparisonExp>;
  feedType?: InputMaybe<BusinessFeedTypeEnumComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  important?: InputMaybe<BooleanComparisonExp>;
  sourceId?: InputMaybe<UuidComparisonExp>;
  subtitle?: InputMaybe<StringComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<userBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "business.user_feed" */
export type BusinessUserFeedConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'user_activityFeed_pkey'
  | '%future added value';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type BusinessUserFeedDeleteAtPathInput = {
  extraData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type BusinessUserFeedDeleteElemInput = {
  extraData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type BusinessUserFeedDeleteKeyInput = {
  extraData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "business.user_feed" */
export type BusinessUserFeedInsertInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  count?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  deletedAt?: InputMaybe<Scalars['timetz']['input']>;
  extraData?: InputMaybe<Scalars['jsonb']['input']>;
  feedSeen?: InputMaybe<Scalars['Boolean']['input']>;
  feedType?: InputMaybe<BusinessFeedTypeEnum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  important?: InputMaybe<Scalars['Boolean']['input']>;
  sourceId?: InputMaybe<Scalars['uuid']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<userObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type BusinessUserFeedMaxFields = {
  __typename?: 'BusinessUserFeedMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  deletedAt?: Maybe<Scalars['timetz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sourceId?: Maybe<Scalars['uuid']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "business.user_feed" */
export type BusinessUserFeedMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  sourceId?: InputMaybe<OrderBy>;
  subtitle?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BusinessUserFeedMinFields = {
  __typename?: 'BusinessUserFeedMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  deletedAt?: Maybe<Scalars['timetz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sourceId?: Maybe<Scalars['uuid']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "business.user_feed" */
export type BusinessUserFeedMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  sourceId?: InputMaybe<OrderBy>;
  subtitle?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "business.user_feed" */
export type BusinessUserFeedMutationResponse = {
  __typename?: 'BusinessUserFeedMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BusinessUserFeed>;
};

/** on_conflict condition type for table "business.user_feed" */
export type BusinessUserFeedOnConflict = {
  constraint: BusinessUserFeedConstraint;
  updateColumns?: Array<BusinessUserFeedUpdateColumn>;
  where?: InputMaybe<BusinessUserFeedBoolExp>;
};

/** Ordering options when selecting data from "business.user_feed". */
export type BusinessUserFeedOrderBy = {
  completed?: InputMaybe<OrderBy>;
  count?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  extraData?: InputMaybe<OrderBy>;
  feedSeen?: InputMaybe<OrderBy>;
  feedType?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  important?: InputMaybe<OrderBy>;
  sourceId?: InputMaybe<OrderBy>;
  subtitle?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<userOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.user_feed */
export type BusinessUserFeedPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type BusinessUserFeedPrependInput = {
  extraData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "business.user_feed" */
export type BusinessUserFeedSelectColumn =
  /** column name */
  | 'completed'
  /** column name */
  | 'count'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserId'
  /** column name */
  | 'deletedAt'
  /** column name */
  | 'extraData'
  /** column name */
  | 'feedSeen'
  /** column name */
  | 'feedType'
  /** column name */
  | 'id'
  /** column name */
  | 'important'
  /** column name */
  | 'sourceId'
  /** column name */
  | 'subtitle'
  /** column name */
  | 'title'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

/** select "businessUserFeedAggregateBoolExpBool_andArgumentsColumns" columns of table "business.user_feed" */
export type BusinessUserFeedSelectColumnBusinessUserFeedAggregateBoolExpBool_andArgumentsColumns =
  /** column name */
  | 'completed'
  /** column name */
  | 'count'
  /** column name */
  | 'feedSeen'
  /** column name */
  | 'important'
  | '%future added value';

/** select "businessUserFeedAggregateBoolExpBool_orArgumentsColumns" columns of table "business.user_feed" */
export type BusinessUserFeedSelectColumnBusinessUserFeedAggregateBoolExpBool_orArgumentsColumns =
  /** column name */
  | 'completed'
  /** column name */
  | 'count'
  /** column name */
  | 'feedSeen'
  /** column name */
  | 'important'
  | '%future added value';

/** input type for updating data in table "business.user_feed" */
export type BusinessUserFeedSetInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  count?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  deletedAt?: InputMaybe<Scalars['timetz']['input']>;
  extraData?: InputMaybe<Scalars['jsonb']['input']>;
  feedSeen?: InputMaybe<Scalars['Boolean']['input']>;
  feedType?: InputMaybe<BusinessFeedTypeEnum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  important?: InputMaybe<Scalars['Boolean']['input']>;
  sourceId?: InputMaybe<Scalars['uuid']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "business_user_feed" */
export type BusinessUserFeedStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BusinessUserFeedStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BusinessUserFeedStreamCursorValueInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  count?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  deletedAt?: InputMaybe<Scalars['timetz']['input']>;
  extraData?: InputMaybe<Scalars['jsonb']['input']>;
  feedSeen?: InputMaybe<Scalars['Boolean']['input']>;
  feedType?: InputMaybe<BusinessFeedTypeEnum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  important?: InputMaybe<Scalars['Boolean']['input']>;
  sourceId?: InputMaybe<Scalars['uuid']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "business.user_feed" */
export type BusinessUserFeedUpdateColumn =
  /** column name */
  | 'completed'
  /** column name */
  | 'count'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserId'
  /** column name */
  | 'deletedAt'
  /** column name */
  | 'extraData'
  /** column name */
  | 'feedSeen'
  /** column name */
  | 'feedType'
  /** column name */
  | 'id'
  /** column name */
  | 'important'
  /** column name */
  | 'sourceId'
  /** column name */
  | 'subtitle'
  /** column name */
  | 'title'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

export type BusinessUserFeedUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<BusinessUserFeedAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<BusinessUserFeedDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<BusinessUserFeedDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<BusinessUserFeedDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<BusinessUserFeedPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BusinessUserFeedSetInput>;
  /** filter the rows which have to be updated */
  where: BusinessUserFeedBoolExp;
};

/** columns and relationships of "business.user_request_status" */
export type BusinessUserRequestStatus = {
  __typename?: 'BusinessUserRequestStatus';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "business.user_request_status" */
export type BusinessUserRequestStatusAggregate = {
  __typename?: 'BusinessUserRequestStatusAggregate';
  aggregate?: Maybe<BusinessUserRequestStatusAggregateFields>;
  nodes: Array<BusinessUserRequestStatus>;
};

/** aggregate fields of "business.user_request_status" */
export type BusinessUserRequestStatusAggregateFields = {
  __typename?: 'BusinessUserRequestStatusAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BusinessUserRequestStatusMaxFields>;
  min?: Maybe<BusinessUserRequestStatusMinFields>;
};


/** aggregate fields of "business.user_request_status" */
export type BusinessUserRequestStatusAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<BusinessUserRequestStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.user_request_status". All fields are combined with a logical 'AND'. */
export type BusinessUserRequestStatusBoolExp = {
  _and?: InputMaybe<Array<BusinessUserRequestStatusBoolExp>>;
  _not?: InputMaybe<BusinessUserRequestStatusBoolExp>;
  _or?: InputMaybe<Array<BusinessUserRequestStatusBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.user_request_status" */
export type BusinessUserRequestStatusConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'user_request_status_pkey'
  | '%future added value';

export type BusinessUserRequestStatusEnum =
  /** User can access organization */
  | 'ACCEPTED'
  /** User wants to join */
  | 'ASK'
  /** Claim ownership of organization */
  | 'CLAIM'
  /** Admin wants user to join */
  | 'REQUEST'
  | '%future added value';

/** Boolean expression to compare columns of type "BusinessUserRequestStatusEnum". All fields are combined with logical 'AND'. */
export type BusinessUserRequestStatusEnumComparisonExp = {
  _eq?: InputMaybe<BusinessUserRequestStatusEnum>;
  _in?: InputMaybe<Array<BusinessUserRequestStatusEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<BusinessUserRequestStatusEnum>;
  _nin?: InputMaybe<Array<BusinessUserRequestStatusEnum>>;
};

/** input type for inserting data into table "business.user_request_status" */
export type BusinessUserRequestStatusInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type BusinessUserRequestStatusMaxFields = {
  __typename?: 'BusinessUserRequestStatusMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type BusinessUserRequestStatusMinFields = {
  __typename?: 'BusinessUserRequestStatusMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.user_request_status" */
export type BusinessUserRequestStatusMutationResponse = {
  __typename?: 'BusinessUserRequestStatusMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BusinessUserRequestStatus>;
};

/** on_conflict condition type for table "business.user_request_status" */
export type BusinessUserRequestStatusOnConflict = {
  constraint: BusinessUserRequestStatusConstraint;
  updateColumns?: Array<BusinessUserRequestStatusUpdateColumn>;
  where?: InputMaybe<BusinessUserRequestStatusBoolExp>;
};

/** Ordering options when selecting data from "business.user_request_status". */
export type BusinessUserRequestStatusOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.user_request_status */
export type BusinessUserRequestStatusPkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "business.user_request_status" */
export type BusinessUserRequestStatusSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "business.user_request_status" */
export type BusinessUserRequestStatusSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "business_user_request_status" */
export type BusinessUserRequestStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BusinessUserRequestStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BusinessUserRequestStatusStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.user_request_status" */
export type BusinessUserRequestStatusUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type BusinessUserRequestStatusUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BusinessUserRequestStatusSetInput>;
  /** filter the rows which have to be updated */
  where: BusinessUserRequestStatusBoolExp;
};

/** columns and relationships of "business.user_states" */
export type BusinessUserStates = {
  __typename?: 'BusinessUserStates';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  domainUser: domainUser;
  domainUserId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  queueItem?: Maybe<queueItem>;
  queueItemId?: Maybe<Scalars['uuid']['output']>;
  type: Scalars['String']['output'];
  /** An object relationship */
  user: user;
  userId: Scalars['uuid']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "business.user_states" */
export type BusinessUserStatesAggregate = {
  __typename?: 'BusinessUserStatesAggregate';
  aggregate?: Maybe<BusinessUserStatesAggregateFields>;
  nodes: Array<BusinessUserStates>;
};

export type BusinessUserStatesAggregateBoolExp = {
  count?: InputMaybe<businessUserStatesAggregateBoolExpCount>;
};

/** aggregate fields of "business.user_states" */
export type BusinessUserStatesAggregateFields = {
  __typename?: 'BusinessUserStatesAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BusinessUserStatesMaxFields>;
  min?: Maybe<BusinessUserStatesMinFields>;
};


/** aggregate fields of "business.user_states" */
export type BusinessUserStatesAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<BusinessUserStatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.user_states" */
export type BusinessUserStatesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BusinessUserStatesMaxOrderBy>;
  min?: InputMaybe<BusinessUserStatesMinOrderBy>;
};

/** input type for inserting array relation for remote table "business.user_states" */
export type BusinessUserStatesArrRelInsertInput = {
  data: Array<BusinessUserStatesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<BusinessUserStatesOnConflict>;
};

/** Boolean expression to filter rows from the table "business.user_states". All fields are combined with a logical 'AND'. */
export type BusinessUserStatesBoolExp = {
  _and?: InputMaybe<Array<BusinessUserStatesBoolExp>>;
  _not?: InputMaybe<BusinessUserStatesBoolExp>;
  _or?: InputMaybe<Array<BusinessUserStatesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  domainUser?: InputMaybe<domainUserBoolExp>;
  domainUserId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  queueItem?: InputMaybe<queueItemBoolExp>;
  queueItemId?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  user?: InputMaybe<userBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.user_states" */
export type BusinessUserStatesConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'user_states_pkey'
  /** unique or primary key constraint on columns "userId", "type" */
  | 'user_states_type_userId_key'
  | '%future added value';

/** input type for inserting data into table "business.user_states" */
export type BusinessUserStatesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  domainUser?: InputMaybe<domainUserObjRelInsertInput>;
  domainUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  queueItem?: InputMaybe<queueItemObjRelInsertInput>;
  queueItemId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<userObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type BusinessUserStatesMaxFields = {
  __typename?: 'BusinessUserStatesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  domainUserId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  queueItemId?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "business.user_states" */
export type BusinessUserStatesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  domainUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  queueItemId?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BusinessUserStatesMinFields = {
  __typename?: 'BusinessUserStatesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  domainUserId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  queueItemId?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "business.user_states" */
export type BusinessUserStatesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  domainUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  queueItemId?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "business.user_states" */
export type BusinessUserStatesMutationResponse = {
  __typename?: 'BusinessUserStatesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BusinessUserStates>;
};

/** on_conflict condition type for table "business.user_states" */
export type BusinessUserStatesOnConflict = {
  constraint: BusinessUserStatesConstraint;
  updateColumns?: Array<BusinessUserStatesUpdateColumn>;
  where?: InputMaybe<BusinessUserStatesBoolExp>;
};

/** Ordering options when selecting data from "business.user_states". */
export type BusinessUserStatesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  domainUser?: InputMaybe<domainUserOrderBy>;
  domainUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  queueItem?: InputMaybe<queueItemOrderBy>;
  queueItemId?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  user?: InputMaybe<userOrderBy>;
  userId?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.user_states */
export type BusinessUserStatesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "business.user_states" */
export type BusinessUserStatesSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'domainUserId'
  /** column name */
  | 'id'
  /** column name */
  | 'queueItemId'
  /** column name */
  | 'type'
  /** column name */
  | 'userId'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "business.user_states" */
export type BusinessUserStatesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  domainUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  queueItemId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "business_user_states" */
export type BusinessUserStatesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BusinessUserStatesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BusinessUserStatesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  domainUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  queueItemId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.user_states" */
export type BusinessUserStatesUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'domainUserId'
  /** column name */
  | 'id'
  /** column name */
  | 'queueItemId'
  /** column name */
  | 'type'
  /** column name */
  | 'userId'
  /** column name */
  | 'value'
  | '%future added value';

export type BusinessUserStatesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BusinessUserStatesSetInput>;
  /** filter the rows which have to be updated */
  where: BusinessUserStatesBoolExp;
};

export type ChangeOrganizationNameInput = {
  name: Scalars['String']['input'];
  organizationId: Scalars['uuid']['input'];
};

export type ChangeOrganizationNameOutput = {
  __typename?: 'ChangeOrganizationNameOutput';
  organizationId?: Maybe<Scalars['uuid']['output']>;
  organizationNumber?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type CheckOnetimeCodeOutput = {
  __typename?: 'CheckOnetimeCodeOutput';
  feedback?: Maybe<Scalars['String']['output']>;
};

export type CheckPhoneNumberOutput = {
  __typename?: 'CheckPhoneNumberOutput';
  country?: Maybe<Scalars['String']['output']>;
  formattedNumber?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type Content = {
  encoding?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userData?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSMSOutput = {
  __typename?: 'CreateSMSOutput';
  resultCode?: Maybe<Scalars['Int']['output']>;
};

/** columns and relationships of "crm.context" */
export type CrmContext = {
  __typename?: 'CrmContext';
  catalystId?: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  crmType?: Maybe<CrmCrmTypeEnum>;
  crmUrl?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<CrmUnifiedEntityTypeEnum>;
  id: Scalars['uuid']['output'];
  type?: Maybe<CrmContextTypeEnum>;
  updatedAt: Scalars['timestamptz']['output'];
  youtelloId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "crm.context" */
export type CrmContextAggregate = {
  __typename?: 'CrmContextAggregate';
  aggregate?: Maybe<CrmContextAggregateFields>;
  nodes: Array<CrmContext>;
};

/** aggregate fields of "crm.context" */
export type CrmContextAggregateFields = {
  __typename?: 'CrmContextAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<CrmContextMaxFields>;
  min?: Maybe<CrmContextMinFields>;
};


/** aggregate fields of "crm.context" */
export type CrmContextAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<CrmContextSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "crm.context". All fields are combined with a logical 'AND'. */
export type CrmContextBoolExp = {
  _and?: InputMaybe<Array<CrmContextBoolExp>>;
  _not?: InputMaybe<CrmContextBoolExp>;
  _or?: InputMaybe<Array<CrmContextBoolExp>>;
  catalystId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  crmType?: InputMaybe<CrmCrmTypeEnumComparisonExp>;
  crmUrl?: InputMaybe<StringComparisonExp>;
  entityType?: InputMaybe<CrmUnifiedEntityTypeEnumComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<CrmContextTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  youtelloId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "crm.context" */
export type CrmContextConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'context_pkey'
  | '%future added value';

/** input type for inserting data into table "crm.context" */
export type CrmContextInsertInput = {
  catalystId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  crmType?: InputMaybe<CrmCrmTypeEnum>;
  crmUrl?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<CrmUnifiedEntityTypeEnum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<CrmContextTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  youtelloId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type CrmContextMaxFields = {
  __typename?: 'CrmContextMaxFields';
  catalystId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  crmUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  youtelloId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type CrmContextMinFields = {
  __typename?: 'CrmContextMinFields';
  catalystId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  crmUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  youtelloId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "crm.context" */
export type CrmContextMutationResponse = {
  __typename?: 'CrmContextMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CrmContext>;
};

/** input type for inserting object relation for remote table "crm.context" */
export type CrmContextObjRelInsertInput = {
  data: CrmContextInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<CrmContextOnConflict>;
};

/** on_conflict condition type for table "crm.context" */
export type CrmContextOnConflict = {
  constraint: CrmContextConstraint;
  updateColumns?: Array<CrmContextUpdateColumn>;
  where?: InputMaybe<CrmContextBoolExp>;
};

/** Ordering options when selecting data from "crm.context". */
export type CrmContextOrderBy = {
  catalystId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  crmType?: InputMaybe<OrderBy>;
  crmUrl?: InputMaybe<OrderBy>;
  entityType?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  youtelloId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: crm.context */
export type CrmContextPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "crm.context" */
export type CrmContextSelectColumn =
  /** column name */
  | 'catalystId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'crmType'
  /** column name */
  | 'crmUrl'
  /** column name */
  | 'entityType'
  /** column name */
  | 'id'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'youtelloId'
  | '%future added value';

/** input type for updating data in table "crm.context" */
export type CrmContextSetInput = {
  catalystId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  crmType?: InputMaybe<CrmCrmTypeEnum>;
  crmUrl?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<CrmUnifiedEntityTypeEnum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<CrmContextTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  youtelloId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "crm_context" */
export type CrmContextStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CrmContextStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CrmContextStreamCursorValueInput = {
  catalystId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  crmType?: InputMaybe<CrmCrmTypeEnum>;
  crmUrl?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<CrmUnifiedEntityTypeEnum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<CrmContextTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  youtelloId?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "crm.context_type" */
export type CrmContextType = {
  __typename?: 'CrmContextType';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "crm.context_type" */
export type CrmContextTypeAggregate = {
  __typename?: 'CrmContextTypeAggregate';
  aggregate?: Maybe<CrmContextTypeAggregateFields>;
  nodes: Array<CrmContextType>;
};

/** aggregate fields of "crm.context_type" */
export type CrmContextTypeAggregateFields = {
  __typename?: 'CrmContextTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<CrmContextTypeMaxFields>;
  min?: Maybe<CrmContextTypeMinFields>;
};


/** aggregate fields of "crm.context_type" */
export type CrmContextTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<CrmContextTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "crm.context_type". All fields are combined with a logical 'AND'. */
export type CrmContextTypeBoolExp = {
  _and?: InputMaybe<Array<CrmContextTypeBoolExp>>;
  _not?: InputMaybe<CrmContextTypeBoolExp>;
  _or?: InputMaybe<Array<CrmContextTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "crm.context_type" */
export type CrmContextTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'context_type_pkey'
  | '%future added value';

export type CrmContextTypeEnum =
  /** CRM */
  | 'CRM'
  /** Trace */
  | 'TRACE'
  /** Youtello */
  | 'YOUTELLO'
  | '%future added value';

/** Boolean expression to compare columns of type "CrmContextTypeEnum". All fields are combined with logical 'AND'. */
export type CrmContextTypeEnumComparisonExp = {
  _eq?: InputMaybe<CrmContextTypeEnum>;
  _in?: InputMaybe<Array<CrmContextTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<CrmContextTypeEnum>;
  _nin?: InputMaybe<Array<CrmContextTypeEnum>>;
};

/** input type for inserting data into table "crm.context_type" */
export type CrmContextTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type CrmContextTypeMaxFields = {
  __typename?: 'CrmContextTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type CrmContextTypeMinFields = {
  __typename?: 'CrmContextTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "crm.context_type" */
export type CrmContextTypeMutationResponse = {
  __typename?: 'CrmContextTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CrmContextType>;
};

/** on_conflict condition type for table "crm.context_type" */
export type CrmContextTypeOnConflict = {
  constraint: CrmContextTypeConstraint;
  updateColumns?: Array<CrmContextTypeUpdateColumn>;
  where?: InputMaybe<CrmContextTypeBoolExp>;
};

/** Ordering options when selecting data from "crm.context_type". */
export type CrmContextTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: crm.context_type */
export type CrmContextTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "crm.context_type" */
export type CrmContextTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "crm.context_type" */
export type CrmContextTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "crm_context_type" */
export type CrmContextTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CrmContextTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CrmContextTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "crm.context_type" */
export type CrmContextTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type CrmContextTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CrmContextTypeSetInput>;
  /** filter the rows which have to be updated */
  where: CrmContextTypeBoolExp;
};

/** update columns of table "crm.context" */
export type CrmContextUpdateColumn =
  /** column name */
  | 'catalystId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'crmType'
  /** column name */
  | 'crmUrl'
  /** column name */
  | 'entityType'
  /** column name */
  | 'id'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'youtelloId'
  | '%future added value';

export type CrmContextUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CrmContextSetInput>;
  /** filter the rows which have to be updated */
  where: CrmContextBoolExp;
};

/** columns and relationships of "crm.creator_type" */
export type CrmCreatorType = {
  __typename?: 'CrmCreatorType';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "crm.creator_type" */
export type CrmCreatorTypeAggregate = {
  __typename?: 'CrmCreatorTypeAggregate';
  aggregate?: Maybe<CrmCreatorTypeAggregateFields>;
  nodes: Array<CrmCreatorType>;
};

/** aggregate fields of "crm.creator_type" */
export type CrmCreatorTypeAggregateFields = {
  __typename?: 'CrmCreatorTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<CrmCreatorTypeMaxFields>;
  min?: Maybe<CrmCreatorTypeMinFields>;
};


/** aggregate fields of "crm.creator_type" */
export type CrmCreatorTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<CrmCreatorTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "crm.creator_type". All fields are combined with a logical 'AND'. */
export type CrmCreatorTypeBoolExp = {
  _and?: InputMaybe<Array<CrmCreatorTypeBoolExp>>;
  _not?: InputMaybe<CrmCreatorTypeBoolExp>;
  _or?: InputMaybe<Array<CrmCreatorTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "crm.creator_type" */
export type CrmCreatorTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'creator_type_pkey'
  | '%future added value';

export type CrmCreatorTypeEnum =
  /** Catalyst */
  | 'CATALYST'
  /** Youtello */
  | 'YOUTELLO'
  | '%future added value';

/** Boolean expression to compare columns of type "CrmCreatorTypeEnum". All fields are combined with logical 'AND'. */
export type CrmCreatorTypeEnumComparisonExp = {
  _eq?: InputMaybe<CrmCreatorTypeEnum>;
  _in?: InputMaybe<Array<CrmCreatorTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<CrmCreatorTypeEnum>;
  _nin?: InputMaybe<Array<CrmCreatorTypeEnum>>;
};

/** input type for inserting data into table "crm.creator_type" */
export type CrmCreatorTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type CrmCreatorTypeMaxFields = {
  __typename?: 'CrmCreatorTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type CrmCreatorTypeMinFields = {
  __typename?: 'CrmCreatorTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "crm.creator_type" */
export type CrmCreatorTypeMutationResponse = {
  __typename?: 'CrmCreatorTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CrmCreatorType>;
};

/** on_conflict condition type for table "crm.creator_type" */
export type CrmCreatorTypeOnConflict = {
  constraint: CrmCreatorTypeConstraint;
  updateColumns?: Array<CrmCreatorTypeUpdateColumn>;
  where?: InputMaybe<CrmCreatorTypeBoolExp>;
};

/** Ordering options when selecting data from "crm.creator_type". */
export type CrmCreatorTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: crm.creator_type */
export type CrmCreatorTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "crm.creator_type" */
export type CrmCreatorTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "crm.creator_type" */
export type CrmCreatorTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "crm_creator_type" */
export type CrmCreatorTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CrmCreatorTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CrmCreatorTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "crm.creator_type" */
export type CrmCreatorTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type CrmCreatorTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CrmCreatorTypeSetInput>;
  /** filter the rows which have to be updated */
  where: CrmCreatorTypeBoolExp;
};

/** columns and relationships of "crm.crm_type" */
export type CrmCrmType = {
  __typename?: 'CrmCrmType';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "crm.crm_type" */
export type CrmCrmTypeAggregate = {
  __typename?: 'CrmCrmTypeAggregate';
  aggregate?: Maybe<CrmCrmTypeAggregateFields>;
  nodes: Array<CrmCrmType>;
};

/** aggregate fields of "crm.crm_type" */
export type CrmCrmTypeAggregateFields = {
  __typename?: 'CrmCrmTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<CrmCrmTypeMaxFields>;
  min?: Maybe<CrmCrmTypeMinFields>;
};


/** aggregate fields of "crm.crm_type" */
export type CrmCrmTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<CrmCrmTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "crm.crm_type". All fields are combined with a logical 'AND'. */
export type CrmCrmTypeBoolExp = {
  _and?: InputMaybe<Array<CrmCrmTypeBoolExp>>;
  _not?: InputMaybe<CrmCrmTypeBoolExp>;
  _or?: InputMaybe<Array<CrmCrmTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "crm.crm_type" */
export type CrmCrmTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'crm_type_pkey'
  | '%future added value';

export type CrmCrmTypeEnum =
  /** MS Dynamics */
  | 'DYNAMICS'
  /** PowerOffice */
  | 'POWEROFFICE'
  /** Superoffice */
  | 'SUPEROFFICE'
  /** Tripletex */
  | 'TRIPLETEX'
  | '%future added value';

/** Boolean expression to compare columns of type "CrmCrmTypeEnum". All fields are combined with logical 'AND'. */
export type CrmCrmTypeEnumComparisonExp = {
  _eq?: InputMaybe<CrmCrmTypeEnum>;
  _in?: InputMaybe<Array<CrmCrmTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<CrmCrmTypeEnum>;
  _nin?: InputMaybe<Array<CrmCrmTypeEnum>>;
};

/** input type for inserting data into table "crm.crm_type" */
export type CrmCrmTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type CrmCrmTypeMaxFields = {
  __typename?: 'CrmCrmTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type CrmCrmTypeMinFields = {
  __typename?: 'CrmCrmTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "crm.crm_type" */
export type CrmCrmTypeMutationResponse = {
  __typename?: 'CrmCrmTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CrmCrmType>;
};

/** on_conflict condition type for table "crm.crm_type" */
export type CrmCrmTypeOnConflict = {
  constraint: CrmCrmTypeConstraint;
  updateColumns?: Array<CrmCrmTypeUpdateColumn>;
  where?: InputMaybe<CrmCrmTypeBoolExp>;
};

/** Ordering options when selecting data from "crm.crm_type". */
export type CrmCrmTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: crm.crm_type */
export type CrmCrmTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "crm.crm_type" */
export type CrmCrmTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "crm.crm_type" */
export type CrmCrmTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "crm_crm_type" */
export type CrmCrmTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CrmCrmTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CrmCrmTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "crm.crm_type" */
export type CrmCrmTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type CrmCrmTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CrmCrmTypeSetInput>;
  /** filter the rows which have to be updated */
  where: CrmCrmTypeBoolExp;
};

/** columns and relationships of "crm.direction_type" */
export type CrmDirectionType = {
  __typename?: 'CrmDirectionType';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "crm.direction_type" */
export type CrmDirectionTypeAggregate = {
  __typename?: 'CrmDirectionTypeAggregate';
  aggregate?: Maybe<CrmDirectionTypeAggregateFields>;
  nodes: Array<CrmDirectionType>;
};

/** aggregate fields of "crm.direction_type" */
export type CrmDirectionTypeAggregateFields = {
  __typename?: 'CrmDirectionTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<CrmDirectionTypeMaxFields>;
  min?: Maybe<CrmDirectionTypeMinFields>;
};


/** aggregate fields of "crm.direction_type" */
export type CrmDirectionTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<CrmDirectionTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "crm.direction_type". All fields are combined with a logical 'AND'. */
export type CrmDirectionTypeBoolExp = {
  _and?: InputMaybe<Array<CrmDirectionTypeBoolExp>>;
  _not?: InputMaybe<CrmDirectionTypeBoolExp>;
  _or?: InputMaybe<Array<CrmDirectionTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "crm.direction_type" */
export type CrmDirectionTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'direction_type_pkey'
  | '%future added value';

/** input type for inserting data into table "crm.direction_type" */
export type CrmDirectionTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type CrmDirectionTypeMaxFields = {
  __typename?: 'CrmDirectionTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type CrmDirectionTypeMinFields = {
  __typename?: 'CrmDirectionTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "crm.direction_type" */
export type CrmDirectionTypeMutationResponse = {
  __typename?: 'CrmDirectionTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CrmDirectionType>;
};

/** on_conflict condition type for table "crm.direction_type" */
export type CrmDirectionTypeOnConflict = {
  constraint: CrmDirectionTypeConstraint;
  updateColumns?: Array<CrmDirectionTypeUpdateColumn>;
  where?: InputMaybe<CrmDirectionTypeBoolExp>;
};

/** Ordering options when selecting data from "crm.direction_type". */
export type CrmDirectionTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: crm.direction_type */
export type CrmDirectionTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "crm.direction_type" */
export type CrmDirectionTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "crm.direction_type" */
export type CrmDirectionTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "crm_direction_type" */
export type CrmDirectionTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CrmDirectionTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CrmDirectionTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "crm.direction_type" */
export type CrmDirectionTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type CrmDirectionTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CrmDirectionTypeSetInput>;
  /** filter the rows which have to be updated */
  where: CrmDirectionTypeBoolExp;
};

/** columns and relationships of "crm.entity" */
export type CrmEntity = {
  __typename?: 'CrmEntity';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  type?: Maybe<CrmUnifiedEntityTypeEnum>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "crm.entity" */
export type CrmEntityAggregate = {
  __typename?: 'CrmEntityAggregate';
  aggregate?: Maybe<CrmEntityAggregateFields>;
  nodes: Array<CrmEntity>;
};

/** aggregate fields of "crm.entity" */
export type CrmEntityAggregateFields = {
  __typename?: 'CrmEntityAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<CrmEntityMaxFields>;
  min?: Maybe<CrmEntityMinFields>;
};


/** aggregate fields of "crm.entity" */
export type CrmEntityAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<CrmEntitySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "crm.entity". All fields are combined with a logical 'AND'. */
export type CrmEntityBoolExp = {
  _and?: InputMaybe<Array<CrmEntityBoolExp>>;
  _not?: InputMaybe<CrmEntityBoolExp>;
  _or?: InputMaybe<Array<CrmEntityBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<CrmUnifiedEntityTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "crm.entity" */
export type CrmEntityConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'entity_pkey'
  | '%future added value';

/** input type for inserting data into table "crm.entity" */
export type CrmEntityInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<CrmUnifiedEntityTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type CrmEntityMaxFields = {
  __typename?: 'CrmEntityMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type CrmEntityMinFields = {
  __typename?: 'CrmEntityMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "crm.entity" */
export type CrmEntityMutationResponse = {
  __typename?: 'CrmEntityMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CrmEntity>;
};

/** on_conflict condition type for table "crm.entity" */
export type CrmEntityOnConflict = {
  constraint: CrmEntityConstraint;
  updateColumns?: Array<CrmEntityUpdateColumn>;
  where?: InputMaybe<CrmEntityBoolExp>;
};

/** Ordering options when selecting data from "crm.entity". */
export type CrmEntityOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: crm.entity */
export type CrmEntityPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "crm.entity" */
export type CrmEntitySelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "crm.entity" */
export type CrmEntitySetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<CrmUnifiedEntityTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "crm_entity" */
export type CrmEntityStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CrmEntityStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CrmEntityStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<CrmUnifiedEntityTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "crm.entity" */
export type CrmEntityUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type CrmEntityUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CrmEntitySetInput>;
  /** filter the rows which have to be updated */
  where: CrmEntityBoolExp;
};

/** columns and relationships of "crm.event" */
export type CrmEvent = {
  __typename?: 'CrmEvent';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  originatingSystem?: Maybe<CrmSystemTypeEnum>;
  type?: Maybe<CrmEventTypeEnum>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "crm.event" */
export type CrmEventAggregate = {
  __typename?: 'CrmEventAggregate';
  aggregate?: Maybe<CrmEventAggregateFields>;
  nodes: Array<CrmEvent>;
};

/** aggregate fields of "crm.event" */
export type CrmEventAggregateFields = {
  __typename?: 'CrmEventAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<CrmEventMaxFields>;
  min?: Maybe<CrmEventMinFields>;
};


/** aggregate fields of "crm.event" */
export type CrmEventAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<CrmEventSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "crm.event". All fields are combined with a logical 'AND'. */
export type CrmEventBoolExp = {
  _and?: InputMaybe<Array<CrmEventBoolExp>>;
  _not?: InputMaybe<CrmEventBoolExp>;
  _or?: InputMaybe<Array<CrmEventBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  originatingSystem?: InputMaybe<CrmSystemTypeEnumComparisonExp>;
  type?: InputMaybe<CrmEventTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "crm.event" */
export type CrmEventConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'event_pkey'
  | '%future added value';

/** input type for inserting data into table "crm.event" */
export type CrmEventInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  originatingSystem?: InputMaybe<CrmSystemTypeEnum>;
  type?: InputMaybe<CrmEventTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type CrmEventMaxFields = {
  __typename?: 'CrmEventMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type CrmEventMinFields = {
  __typename?: 'CrmEventMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "crm.event" */
export type CrmEventMutationResponse = {
  __typename?: 'CrmEventMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CrmEvent>;
};

/** input type for inserting object relation for remote table "crm.event" */
export type CrmEventObjRelInsertInput = {
  data: CrmEventInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<CrmEventOnConflict>;
};

/** on_conflict condition type for table "crm.event" */
export type CrmEventOnConflict = {
  constraint: CrmEventConstraint;
  updateColumns?: Array<CrmEventUpdateColumn>;
  where?: InputMaybe<CrmEventBoolExp>;
};

/** Ordering options when selecting data from "crm.event". */
export type CrmEventOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  originatingSystem?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: crm.event */
export type CrmEventPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "crm.event" */
export type CrmEventSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'originatingSystem'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "crm.event" */
export type CrmEventSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  originatingSystem?: InputMaybe<CrmSystemTypeEnum>;
  type?: InputMaybe<CrmEventTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "crm_event" */
export type CrmEventStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CrmEventStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CrmEventStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  originatingSystem?: InputMaybe<CrmSystemTypeEnum>;
  type?: InputMaybe<CrmEventTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "crm.event_type" */
export type CrmEventType = {
  __typename?: 'CrmEventType';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "crm.event_type" */
export type CrmEventTypeAggregate = {
  __typename?: 'CrmEventTypeAggregate';
  aggregate?: Maybe<CrmEventTypeAggregateFields>;
  nodes: Array<CrmEventType>;
};

/** aggregate fields of "crm.event_type" */
export type CrmEventTypeAggregateFields = {
  __typename?: 'CrmEventTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<CrmEventTypeMaxFields>;
  min?: Maybe<CrmEventTypeMinFields>;
};


/** aggregate fields of "crm.event_type" */
export type CrmEventTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<CrmEventTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "crm.event_type". All fields are combined with a logical 'AND'. */
export type CrmEventTypeBoolExp = {
  _and?: InputMaybe<Array<CrmEventTypeBoolExp>>;
  _not?: InputMaybe<CrmEventTypeBoolExp>;
  _or?: InputMaybe<Array<CrmEventTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "crm.event_type" */
export type CrmEventTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'event_type_pkey'
  | '%future added value';

export type CrmEventTypeEnum =
  /** Event created */
  | 'CREATED'
  /** Event deleted */
  | 'DELETED'
  /** Event updated */
  | 'UPDATED'
  | '%future added value';

/** Boolean expression to compare columns of type "CrmEventTypeEnum". All fields are combined with logical 'AND'. */
export type CrmEventTypeEnumComparisonExp = {
  _eq?: InputMaybe<CrmEventTypeEnum>;
  _in?: InputMaybe<Array<CrmEventTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<CrmEventTypeEnum>;
  _nin?: InputMaybe<Array<CrmEventTypeEnum>>;
};

/** input type for inserting data into table "crm.event_type" */
export type CrmEventTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type CrmEventTypeMaxFields = {
  __typename?: 'CrmEventTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type CrmEventTypeMinFields = {
  __typename?: 'CrmEventTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "crm.event_type" */
export type CrmEventTypeMutationResponse = {
  __typename?: 'CrmEventTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CrmEventType>;
};

/** on_conflict condition type for table "crm.event_type" */
export type CrmEventTypeOnConflict = {
  constraint: CrmEventTypeConstraint;
  updateColumns?: Array<CrmEventTypeUpdateColumn>;
  where?: InputMaybe<CrmEventTypeBoolExp>;
};

/** Ordering options when selecting data from "crm.event_type". */
export type CrmEventTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: crm.event_type */
export type CrmEventTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "crm.event_type" */
export type CrmEventTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "crm.event_type" */
export type CrmEventTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "crm_event_type" */
export type CrmEventTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CrmEventTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CrmEventTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "crm.event_type" */
export type CrmEventTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type CrmEventTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CrmEventTypeSetInput>;
  /** filter the rows which have to be updated */
  where: CrmEventTypeBoolExp;
};

/** update columns of table "crm.event" */
export type CrmEventUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'originatingSystem'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type CrmEventUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CrmEventSetInput>;
  /** filter the rows which have to be updated */
  where: CrmEventBoolExp;
};

/** columns and relationships of "crm.status_code" */
export type CrmStatusCode = {
  __typename?: 'CrmStatusCode';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "crm.status_code" */
export type CrmStatusCodeAggregate = {
  __typename?: 'CrmStatusCodeAggregate';
  aggregate?: Maybe<CrmStatusCodeAggregateFields>;
  nodes: Array<CrmStatusCode>;
};

/** aggregate fields of "crm.status_code" */
export type CrmStatusCodeAggregateFields = {
  __typename?: 'CrmStatusCodeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<CrmStatusCodeMaxFields>;
  min?: Maybe<CrmStatusCodeMinFields>;
};


/** aggregate fields of "crm.status_code" */
export type CrmStatusCodeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<CrmStatusCodeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "crm.status_code". All fields are combined with a logical 'AND'. */
export type CrmStatusCodeBoolExp = {
  _and?: InputMaybe<Array<CrmStatusCodeBoolExp>>;
  _not?: InputMaybe<CrmStatusCodeBoolExp>;
  _or?: InputMaybe<Array<CrmStatusCodeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "crm.status_code" */
export type CrmStatusCodeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'status_code_pkey'
  | '%future added value';

/** input type for inserting data into table "crm.status_code" */
export type CrmStatusCodeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type CrmStatusCodeMaxFields = {
  __typename?: 'CrmStatusCodeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type CrmStatusCodeMinFields = {
  __typename?: 'CrmStatusCodeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "crm.status_code" */
export type CrmStatusCodeMutationResponse = {
  __typename?: 'CrmStatusCodeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CrmStatusCode>;
};

/** on_conflict condition type for table "crm.status_code" */
export type CrmStatusCodeOnConflict = {
  constraint: CrmStatusCodeConstraint;
  updateColumns?: Array<CrmStatusCodeUpdateColumn>;
  where?: InputMaybe<CrmStatusCodeBoolExp>;
};

/** Ordering options when selecting data from "crm.status_code". */
export type CrmStatusCodeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: crm.status_code */
export type CrmStatusCodePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "crm.status_code" */
export type CrmStatusCodeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "crm.status_code" */
export type CrmStatusCodeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "crm_status_code" */
export type CrmStatusCodeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CrmStatusCodeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CrmStatusCodeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "crm.status_code" */
export type CrmStatusCodeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type CrmStatusCodeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CrmStatusCodeSetInput>;
  /** filter the rows which have to be updated */
  where: CrmStatusCodeBoolExp;
};

/** columns and relationships of "crm.system_type" */
export type CrmSystemType = {
  __typename?: 'CrmSystemType';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "crm.system_type" */
export type CrmSystemTypeAggregate = {
  __typename?: 'CrmSystemTypeAggregate';
  aggregate?: Maybe<CrmSystemTypeAggregateFields>;
  nodes: Array<CrmSystemType>;
};

/** aggregate fields of "crm.system_type" */
export type CrmSystemTypeAggregateFields = {
  __typename?: 'CrmSystemTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<CrmSystemTypeMaxFields>;
  min?: Maybe<CrmSystemTypeMinFields>;
};


/** aggregate fields of "crm.system_type" */
export type CrmSystemTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<CrmSystemTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "crm.system_type". All fields are combined with a logical 'AND'. */
export type CrmSystemTypeBoolExp = {
  _and?: InputMaybe<Array<CrmSystemTypeBoolExp>>;
  _not?: InputMaybe<CrmSystemTypeBoolExp>;
  _or?: InputMaybe<Array<CrmSystemTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "crm.system_type" */
export type CrmSystemTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'system_type_pkey'
  | '%future added value';

export type CrmSystemTypeEnum =
  /** Dynamics */
  | 'DYNAMICS'
  /** Poweroffice */
  | 'POWEROFFICE'
  /** Superoffice */
  | 'SUPEROFFICE'
  /** Tripletex */
  | 'TRIPLETEX'
  /** Youtello */
  | 'YOUTELLO'
  | '%future added value';

/** Boolean expression to compare columns of type "CrmSystemTypeEnum". All fields are combined with logical 'AND'. */
export type CrmSystemTypeEnumComparisonExp = {
  _eq?: InputMaybe<CrmSystemTypeEnum>;
  _in?: InputMaybe<Array<CrmSystemTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<CrmSystemTypeEnum>;
  _nin?: InputMaybe<Array<CrmSystemTypeEnum>>;
};

/** input type for inserting data into table "crm.system_type" */
export type CrmSystemTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type CrmSystemTypeMaxFields = {
  __typename?: 'CrmSystemTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type CrmSystemTypeMinFields = {
  __typename?: 'CrmSystemTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "crm.system_type" */
export type CrmSystemTypeMutationResponse = {
  __typename?: 'CrmSystemTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CrmSystemType>;
};

/** on_conflict condition type for table "crm.system_type" */
export type CrmSystemTypeOnConflict = {
  constraint: CrmSystemTypeConstraint;
  updateColumns?: Array<CrmSystemTypeUpdateColumn>;
  where?: InputMaybe<CrmSystemTypeBoolExp>;
};

/** Ordering options when selecting data from "crm.system_type". */
export type CrmSystemTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: crm.system_type */
export type CrmSystemTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "crm.system_type" */
export type CrmSystemTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "crm.system_type" */
export type CrmSystemTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "crm_system_type" */
export type CrmSystemTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CrmSystemTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CrmSystemTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "crm.system_type" */
export type CrmSystemTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type CrmSystemTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CrmSystemTypeSetInput>;
  /** filter the rows which have to be updated */
  where: CrmSystemTypeBoolExp;
};

/** columns and relationships of "crm.trace_context" */
export type CrmTraceContext = {
  __typename?: 'CrmTraceContext';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  spanId?: Maybe<Scalars['String']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "crm.trace_context" */
export type CrmTraceContextAggregate = {
  __typename?: 'CrmTraceContextAggregate';
  aggregate?: Maybe<CrmTraceContextAggregateFields>;
  nodes: Array<CrmTraceContext>;
};

/** aggregate fields of "crm.trace_context" */
export type CrmTraceContextAggregateFields = {
  __typename?: 'CrmTraceContextAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<CrmTraceContextMaxFields>;
  min?: Maybe<CrmTraceContextMinFields>;
};


/** aggregate fields of "crm.trace_context" */
export type CrmTraceContextAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<CrmTraceContextSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "crm.trace_context". All fields are combined with a logical 'AND'. */
export type CrmTraceContextBoolExp = {
  _and?: InputMaybe<Array<CrmTraceContextBoolExp>>;
  _not?: InputMaybe<CrmTraceContextBoolExp>;
  _or?: InputMaybe<Array<CrmTraceContextBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  spanId?: InputMaybe<StringComparisonExp>;
  traceId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "crm.trace_context" */
export type CrmTraceContextConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'trace_context_pkey'
  | '%future added value';

/** input type for inserting data into table "crm.trace_context" */
export type CrmTraceContextInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  spanId?: InputMaybe<Scalars['String']['input']>;
  traceId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type CrmTraceContextMaxFields = {
  __typename?: 'CrmTraceContextMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  spanId?: Maybe<Scalars['String']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type CrmTraceContextMinFields = {
  __typename?: 'CrmTraceContextMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  spanId?: Maybe<Scalars['String']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "crm.trace_context" */
export type CrmTraceContextMutationResponse = {
  __typename?: 'CrmTraceContextMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CrmTraceContext>;
};

/** input type for inserting object relation for remote table "crm.trace_context" */
export type CrmTraceContextObjRelInsertInput = {
  data: CrmTraceContextInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<CrmTraceContextOnConflict>;
};

/** on_conflict condition type for table "crm.trace_context" */
export type CrmTraceContextOnConflict = {
  constraint: CrmTraceContextConstraint;
  updateColumns?: Array<CrmTraceContextUpdateColumn>;
  where?: InputMaybe<CrmTraceContextBoolExp>;
};

/** Ordering options when selecting data from "crm.trace_context". */
export type CrmTraceContextOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  spanId?: InputMaybe<OrderBy>;
  traceId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: crm.trace_context */
export type CrmTraceContextPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "crm.trace_context" */
export type CrmTraceContextSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'spanId'
  /** column name */
  | 'traceId'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "crm.trace_context" */
export type CrmTraceContextSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  spanId?: InputMaybe<Scalars['String']['input']>;
  traceId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "crm_trace_context" */
export type CrmTraceContextStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CrmTraceContextStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CrmTraceContextStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  spanId?: InputMaybe<Scalars['String']['input']>;
  traceId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "crm.trace_context" */
export type CrmTraceContextUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'spanId'
  /** column name */
  | 'traceId'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type CrmTraceContextUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CrmTraceContextSetInput>;
  /** filter the rows which have to be updated */
  where: CrmTraceContextBoolExp;
};

/** columns and relationships of "crm.unified_entity_type" */
export type CrmUnifiedEntityType = {
  __typename?: 'CrmUnifiedEntityType';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "crm.unified_entity_type" */
export type CrmUnifiedEntityTypeAggregate = {
  __typename?: 'CrmUnifiedEntityTypeAggregate';
  aggregate?: Maybe<CrmUnifiedEntityTypeAggregateFields>;
  nodes: Array<CrmUnifiedEntityType>;
};

/** aggregate fields of "crm.unified_entity_type" */
export type CrmUnifiedEntityTypeAggregateFields = {
  __typename?: 'CrmUnifiedEntityTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<CrmUnifiedEntityTypeMaxFields>;
  min?: Maybe<CrmUnifiedEntityTypeMinFields>;
};


/** aggregate fields of "crm.unified_entity_type" */
export type CrmUnifiedEntityTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<CrmUnifiedEntityTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "crm.unified_entity_type". All fields are combined with a logical 'AND'. */
export type CrmUnifiedEntityTypeBoolExp = {
  _and?: InputMaybe<Array<CrmUnifiedEntityTypeBoolExp>>;
  _not?: InputMaybe<CrmUnifiedEntityTypeBoolExp>;
  _or?: InputMaybe<Array<CrmUnifiedEntityTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "crm.unified_entity_type" */
export type CrmUnifiedEntityTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'unified_entity_type_pkey'
  | '%future added value';

export type CrmUnifiedEntityTypeEnum =
  /** Address */
  | 'ADDRESS'
  /** Business customer */
  | 'BUSINESSCUSTOMER'
  /** Activity comment  */
  | 'COMMENT'
  /** General activity */
  | 'GENERALACTIVITY'
  /** Participant */
  | 'PARTICIPANT'
  /** Person customer */
  | 'PERSONCUSTOMER'
  /** Phone call */
  | 'PHONECALL'
  /** System user */
  | 'SYSTEMUSER'
  /** Tenant or organization */
  | 'TENANT'
  | '%future added value';

/** Boolean expression to compare columns of type "CrmUnifiedEntityTypeEnum". All fields are combined with logical 'AND'. */
export type CrmUnifiedEntityTypeEnumComparisonExp = {
  _eq?: InputMaybe<CrmUnifiedEntityTypeEnum>;
  _in?: InputMaybe<Array<CrmUnifiedEntityTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<CrmUnifiedEntityTypeEnum>;
  _nin?: InputMaybe<Array<CrmUnifiedEntityTypeEnum>>;
};

/** input type for inserting data into table "crm.unified_entity_type" */
export type CrmUnifiedEntityTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type CrmUnifiedEntityTypeMaxFields = {
  __typename?: 'CrmUnifiedEntityTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type CrmUnifiedEntityTypeMinFields = {
  __typename?: 'CrmUnifiedEntityTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "crm.unified_entity_type" */
export type CrmUnifiedEntityTypeMutationResponse = {
  __typename?: 'CrmUnifiedEntityTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CrmUnifiedEntityType>;
};

/** on_conflict condition type for table "crm.unified_entity_type" */
export type CrmUnifiedEntityTypeOnConflict = {
  constraint: CrmUnifiedEntityTypeConstraint;
  updateColumns?: Array<CrmUnifiedEntityTypeUpdateColumn>;
  where?: InputMaybe<CrmUnifiedEntityTypeBoolExp>;
};

/** Ordering options when selecting data from "crm.unified_entity_type". */
export type CrmUnifiedEntityTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: crm.unified_entity_type */
export type CrmUnifiedEntityTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "crm.unified_entity_type" */
export type CrmUnifiedEntityTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "crm.unified_entity_type" */
export type CrmUnifiedEntityTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "crm_unified_entity_type" */
export type CrmUnifiedEntityTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CrmUnifiedEntityTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CrmUnifiedEntityTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "crm.unified_entity_type" */
export type CrmUnifiedEntityTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type CrmUnifiedEntityTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CrmUnifiedEntityTypeSetInput>;
  /** filter the rows which have to be updated */
  where: CrmUnifiedEntityTypeBoolExp;
};

/** ordering argument of a cursor */
export type CursorOrdering =
  /** ascending ordering of the cursor */
  | 'ASC'
  /** descending ordering of the cursor */
  | 'DESC'
  | '%future added value';

export type CustomParameters = {
  moReferenceId?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['String']['input']>;
  platformPartnerId?: InputMaybe<Scalars['String']['input']>;
  queued?: InputMaybe<Scalars['String']['input']>;
  serviceCentreTimeStamp?: InputMaybe<Scalars['String']['input']>;
  suggestedOperator?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteRequestUserInput = {
  id: Scalars['String']['input'];
};

export type DeleteRequestUserOutput = {
  __typename?: 'DeleteRequestUserOutput';
  result: Scalars['jsonb']['output'];
};

export type DeleteUserInput = {
  id: Scalars['String']['input'];
};

export type DeleteUserOutput = {
  __typename?: 'DeleteUserOutput';
  result: Scalars['jsonb']['output'];
};

/** Boolean expression to compare columns of type "domainTypeEnum". All fields are combined with logical 'AND'. */
export type DomainTypeEnumComparisonExp = {
  _eq?: InputMaybe<domainTypeEnum>;
  _in?: InputMaybe<Array<domainTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<domainTypeEnum>;
  _nin?: InputMaybe<Array<domainTypeEnum>>;
};

/** Boolean expression to compare columns of type "domainUserCategoryEnum". All fields are combined with logical 'AND'. */
export type DomainUserCategoryEnumComparisonExp = {
  _eq?: InputMaybe<domainUserCategoryEnum>;
  _in?: InputMaybe<Array<domainUserCategoryEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<domainUserCategoryEnum>;
  _nin?: InputMaybe<Array<domainUserCategoryEnum>>;
};

/** Boolean expression to compare columns of type "activityParticipantRoleEnum". All fields are combined with logical 'AND'. */
export type EmailingActivityParticipantRoleEnumComparisonExp = {
  _eq?: InputMaybe<EmailingactivityParticipantRoleEnum>;
  _in?: InputMaybe<Array<EmailingactivityParticipantRoleEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<EmailingactivityParticipantRoleEnum>;
  _nin?: InputMaybe<Array<EmailingactivityParticipantRoleEnum>>;
};

/** ordering argument of a cursor */
export type EmailingCursorOrdering =
  /** ascending ordering of the cursor */
  | 'ASC'
  /** descending ordering of the cursor */
  | 'DESC'
  | '%future added value';

/** Boolean expression to compare columns of type "domainUserCategoryEnum". All fields are combined with logical 'AND'. */
export type EmailingDomainUserCategoryEnumComparisonExp = {
  _eq?: InputMaybe<EmailingdomainUserCategoryEnum>;
  _in?: InputMaybe<Array<EmailingdomainUserCategoryEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<EmailingdomainUserCategoryEnum>;
  _nin?: InputMaybe<Array<EmailingdomainUserCategoryEnum>>;
};

/** columns and relationships of "email.account_subscribers" */
export type EmailingEmailAccountSubscribers = {
  __typename?: 'EmailingEmailAccountSubscribers';
  createdAt: Scalars['Emailingtimestamptz']['output'];
  id: Scalars['uuid']['output'];
  providerAccount?: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['Emailingtimestamptz']['output'];
};

/** aggregated selection of "email.account_subscribers" */
export type EmailingEmailAccountSubscribersAggregate = {
  __typename?: 'EmailingEmailAccountSubscribersAggregate';
  aggregate?: Maybe<EmailingEmailAccountSubscribersAggregateFields>;
  nodes: Array<EmailingEmailAccountSubscribers>;
};

export type EmailingEmailAccountSubscribersAggregateBoolExp = {
  count?: InputMaybe<EmailingemailAccountSubscribersAggregateBoolExpCount>;
};

/** aggregate fields of "email.account_subscribers" */
export type EmailingEmailAccountSubscribersAggregateFields = {
  __typename?: 'EmailingEmailAccountSubscribersAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<EmailingEmailAccountSubscribersMaxFields>;
  min?: Maybe<EmailingEmailAccountSubscribersMinFields>;
};


/** aggregate fields of "email.account_subscribers" */
export type EmailingEmailAccountSubscribersAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<EmailingEmailAccountSubscribersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "email.account_subscribers" */
export type EmailingEmailAccountSubscribersAggregateOrderBy = {
  count?: InputMaybe<EmailingOrderBy>;
  max?: InputMaybe<EmailingEmailAccountSubscribersMaxOrderBy>;
  min?: InputMaybe<EmailingEmailAccountSubscribersMinOrderBy>;
};

/** input type for inserting array relation for remote table "email.account_subscribers" */
export type EmailingEmailAccountSubscribersArrRelInsertInput = {
  data: Array<EmailingEmailAccountSubscribersInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EmailingEmailAccountSubscribersOnConflict>;
};

/** Boolean expression to filter rows from the table "email.account_subscribers". All fields are combined with a logical 'AND'. */
export type EmailingEmailAccountSubscribersBoolExp = {
  _and?: InputMaybe<Array<EmailingEmailAccountSubscribersBoolExp>>;
  _not?: InputMaybe<EmailingEmailAccountSubscribersBoolExp>;
  _or?: InputMaybe<Array<EmailingEmailAccountSubscribersBoolExp>>;
  createdAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  providerAccount?: InputMaybe<TaskUuidComparisonExp>;
  updatedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "email.account_subscribers" */
export type EmailingEmailAccountSubscribersConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'account_subscribers_pkey'
  | '%future added value';

/** input type for inserting data into table "email.account_subscribers" */
export type EmailingEmailAccountSubscribersInsertInput = {
  createdAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  providerAccount?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
};

/** aggregate max on columns */
export type EmailingEmailAccountSubscribersMaxFields = {
  __typename?: 'EmailingEmailAccountSubscribersMaxFields';
  createdAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  providerAccount?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
};

/** order by max() on columns of table "email.account_subscribers" */
export type EmailingEmailAccountSubscribersMaxOrderBy = {
  createdAt?: InputMaybe<EmailingOrderBy>;
  id?: InputMaybe<EmailingOrderBy>;
  providerAccount?: InputMaybe<EmailingOrderBy>;
  updatedAt?: InputMaybe<EmailingOrderBy>;
};

/** aggregate min on columns */
export type EmailingEmailAccountSubscribersMinFields = {
  __typename?: 'EmailingEmailAccountSubscribersMinFields';
  createdAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  providerAccount?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
};

/** order by min() on columns of table "email.account_subscribers" */
export type EmailingEmailAccountSubscribersMinOrderBy = {
  createdAt?: InputMaybe<EmailingOrderBy>;
  id?: InputMaybe<EmailingOrderBy>;
  providerAccount?: InputMaybe<EmailingOrderBy>;
  updatedAt?: InputMaybe<EmailingOrderBy>;
};

/** response of any mutation on the table "email.account_subscribers" */
export type EmailingEmailAccountSubscribersMutationResponse = {
  __typename?: 'EmailingEmailAccountSubscribersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EmailingEmailAccountSubscribers>;
};

/** on_conflict condition type for table "email.account_subscribers" */
export type EmailingEmailAccountSubscribersOnConflict = {
  constraint: EmailingEmailAccountSubscribersConstraint;
  updateColumns?: Array<EmailingEmailAccountSubscribersUpdateColumn>;
  where?: InputMaybe<EmailingEmailAccountSubscribersBoolExp>;
};

/** Ordering options when selecting data from "email.account_subscribers". */
export type EmailingEmailAccountSubscribersOrderBy = {
  createdAt?: InputMaybe<EmailingOrderBy>;
  id?: InputMaybe<EmailingOrderBy>;
  providerAccount?: InputMaybe<EmailingOrderBy>;
  updatedAt?: InputMaybe<EmailingOrderBy>;
};

/** primary key columns input for table: email.account_subscribers */
export type EmailingEmailAccountSubscribersPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "email.account_subscribers" */
export type EmailingEmailAccountSubscribersSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'providerAccount'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "email.account_subscribers" */
export type EmailingEmailAccountSubscribersSetInput = {
  createdAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  providerAccount?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
};

/** Streaming cursor of the table "email_account_subscribers" */
export type EmailingEmailAccountSubscribersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EmailingEmailAccountSubscribersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<EmailingCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EmailingEmailAccountSubscribersStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  providerAccount?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
};

/** update columns of table "email.account_subscribers" */
export type EmailingEmailAccountSubscribersUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'providerAccount'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type EmailingEmailAccountSubscribersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EmailingEmailAccountSubscribersSetInput>;
  /** filter the rows which have to be updated */
  where: EmailingEmailAccountSubscribersBoolExp;
};

/** email type */
export type EmailingEmailActivityType = {
  __typename?: 'EmailingEmailActivityType';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "email.activity_type" */
export type EmailingEmailActivityTypeAggregate = {
  __typename?: 'EmailingEmailActivityTypeAggregate';
  aggregate?: Maybe<EmailingEmailActivityTypeAggregateFields>;
  nodes: Array<EmailingEmailActivityType>;
};

/** aggregate fields of "email.activity_type" */
export type EmailingEmailActivityTypeAggregateFields = {
  __typename?: 'EmailingEmailActivityTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<EmailingEmailActivityTypeMaxFields>;
  min?: Maybe<EmailingEmailActivityTypeMinFields>;
};


/** aggregate fields of "email.activity_type" */
export type EmailingEmailActivityTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<EmailingEmailActivityTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "email.activity_type". All fields are combined with a logical 'AND'. */
export type EmailingEmailActivityTypeBoolExp = {
  _and?: InputMaybe<Array<EmailingEmailActivityTypeBoolExp>>;
  _not?: InputMaybe<EmailingEmailActivityTypeBoolExp>;
  _or?: InputMaybe<Array<EmailingEmailActivityTypeBoolExp>>;
  description?: InputMaybe<TaskStringComparisonExp>;
  value?: InputMaybe<TaskStringComparisonExp>;
};

/** unique or primary key constraints on table "email.activity_type" */
export type EmailingEmailActivityTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'activity_type_pkey'
  | '%future added value';

export type EmailingEmailActivityTypeEnum =
  /** email draft */
  | 'DRAFT'
  /** incoming email */
  | 'INCOMING'
  /** outgoing email */
  | 'OUTGOING'
  | '%future added value';

/** Boolean expression to compare columns of type "EmailActivityTypeEnum". All fields are combined with logical 'AND'. */
export type EmailingEmailActivityTypeEnumComparisonExp = {
  _eq?: InputMaybe<EmailingEmailActivityTypeEnum>;
  _in?: InputMaybe<Array<EmailingEmailActivityTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<EmailingEmailActivityTypeEnum>;
  _nin?: InputMaybe<Array<EmailingEmailActivityTypeEnum>>;
};

/** input type for inserting data into table "email.activity_type" */
export type EmailingEmailActivityTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type EmailingEmailActivityTypeMaxFields = {
  __typename?: 'EmailingEmailActivityTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type EmailingEmailActivityTypeMinFields = {
  __typename?: 'EmailingEmailActivityTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "email.activity_type" */
export type EmailingEmailActivityTypeMutationResponse = {
  __typename?: 'EmailingEmailActivityTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EmailingEmailActivityType>;
};

/** on_conflict condition type for table "email.activity_type" */
export type EmailingEmailActivityTypeOnConflict = {
  constraint: EmailingEmailActivityTypeConstraint;
  updateColumns?: Array<EmailingEmailActivityTypeUpdateColumn>;
  where?: InputMaybe<EmailingEmailActivityTypeBoolExp>;
};

/** Ordering options when selecting data from "email.activity_type". */
export type EmailingEmailActivityTypeOrderBy = {
  description?: InputMaybe<EmailingOrderBy>;
  value?: InputMaybe<EmailingOrderBy>;
};

/** primary key columns input for table: email.activity_type */
export type EmailingEmailActivityTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "email.activity_type" */
export type EmailingEmailActivityTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "email.activity_type" */
export type EmailingEmailActivityTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "email_activity_type" */
export type EmailingEmailActivityTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EmailingEmailActivityTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<EmailingCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EmailingEmailActivityTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "email.activity_type" */
export type EmailingEmailActivityTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type EmailingEmailActivityTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EmailingEmailActivityTypeSetInput>;
  /** filter the rows which have to be updated */
  where: EmailingEmailActivityTypeBoolExp;
};

/** columns and relationships of "email.comment" */
export type EmailingEmailComment = {
  __typename?: 'EmailingEmailComment';
  /** An object relationship */
  activity: Emailingactivity;
  activityId: Scalars['uuid']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['Emailingtimestamptz']['output'];
  id: Scalars['uuid']['output'];
  updatedAt: Scalars['Emailingtimestamptz']['output'];
};

/** aggregated selection of "email.comment" */
export type EmailingEmailCommentAggregate = {
  __typename?: 'EmailingEmailCommentAggregate';
  aggregate?: Maybe<EmailingEmailCommentAggregateFields>;
  nodes: Array<EmailingEmailComment>;
};

export type EmailingEmailCommentAggregateBoolExp = {
  count?: InputMaybe<EmailingemailCommentAggregateBoolExpCount>;
};

/** aggregate fields of "email.comment" */
export type EmailingEmailCommentAggregateFields = {
  __typename?: 'EmailingEmailCommentAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<EmailingEmailCommentMaxFields>;
  min?: Maybe<EmailingEmailCommentMinFields>;
};


/** aggregate fields of "email.comment" */
export type EmailingEmailCommentAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<EmailingEmailCommentSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "email.comment" */
export type EmailingEmailCommentAggregateOrderBy = {
  count?: InputMaybe<EmailingOrderBy>;
  max?: InputMaybe<EmailingEmailCommentMaxOrderBy>;
  min?: InputMaybe<EmailingEmailCommentMinOrderBy>;
};

/** input type for inserting array relation for remote table "email.comment" */
export type EmailingEmailCommentArrRelInsertInput = {
  data: Array<EmailingEmailCommentInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EmailingEmailCommentOnConflict>;
};

/** Boolean expression to filter rows from the table "email.comment". All fields are combined with a logical 'AND'. */
export type EmailingEmailCommentBoolExp = {
  _and?: InputMaybe<Array<EmailingEmailCommentBoolExp>>;
  _not?: InputMaybe<EmailingEmailCommentBoolExp>;
  _or?: InputMaybe<Array<EmailingEmailCommentBoolExp>>;
  activity?: InputMaybe<EmailingactivityBoolExp>;
  activityId?: InputMaybe<TaskUuidComparisonExp>;
  content?: InputMaybe<TaskStringComparisonExp>;
  createdAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  updatedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "email.comment" */
export type EmailingEmailCommentConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'comment_pkey'
  | '%future added value';

/** input type for inserting data into table "email.comment" */
export type EmailingEmailCommentInsertInput = {
  activity?: InputMaybe<EmailingactivityObjRelInsertInput>;
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
};

/** aggregate max on columns */
export type EmailingEmailCommentMaxFields = {
  __typename?: 'EmailingEmailCommentMaxFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
};

/** order by max() on columns of table "email.comment" */
export type EmailingEmailCommentMaxOrderBy = {
  activityId?: InputMaybe<EmailingOrderBy>;
  content?: InputMaybe<EmailingOrderBy>;
  createdAt?: InputMaybe<EmailingOrderBy>;
  id?: InputMaybe<EmailingOrderBy>;
  updatedAt?: InputMaybe<EmailingOrderBy>;
};

/** aggregate min on columns */
export type EmailingEmailCommentMinFields = {
  __typename?: 'EmailingEmailCommentMinFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
};

/** order by min() on columns of table "email.comment" */
export type EmailingEmailCommentMinOrderBy = {
  activityId?: InputMaybe<EmailingOrderBy>;
  content?: InputMaybe<EmailingOrderBy>;
  createdAt?: InputMaybe<EmailingOrderBy>;
  id?: InputMaybe<EmailingOrderBy>;
  updatedAt?: InputMaybe<EmailingOrderBy>;
};

/** response of any mutation on the table "email.comment" */
export type EmailingEmailCommentMutationResponse = {
  __typename?: 'EmailingEmailCommentMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EmailingEmailComment>;
};

/** on_conflict condition type for table "email.comment" */
export type EmailingEmailCommentOnConflict = {
  constraint: EmailingEmailCommentConstraint;
  updateColumns?: Array<EmailingEmailCommentUpdateColumn>;
  where?: InputMaybe<EmailingEmailCommentBoolExp>;
};

/** Ordering options when selecting data from "email.comment". */
export type EmailingEmailCommentOrderBy = {
  activity?: InputMaybe<EmailingactivityOrderBy>;
  activityId?: InputMaybe<EmailingOrderBy>;
  content?: InputMaybe<EmailingOrderBy>;
  createdAt?: InputMaybe<EmailingOrderBy>;
  id?: InputMaybe<EmailingOrderBy>;
  updatedAt?: InputMaybe<EmailingOrderBy>;
};

/** primary key columns input for table: email.comment */
export type EmailingEmailCommentPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "email.comment" */
export type EmailingEmailCommentSelectColumn =
  /** column name */
  | 'activityId'
  /** column name */
  | 'content'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "email.comment" */
export type EmailingEmailCommentSetInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
};

/** Streaming cursor of the table "email_comment" */
export type EmailingEmailCommentStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EmailingEmailCommentStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<EmailingCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EmailingEmailCommentStreamCursorValueInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
};

/** update columns of table "email.comment" */
export type EmailingEmailCommentUpdateColumn =
  /** column name */
  | 'activityId'
  /** column name */
  | 'content'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type EmailingEmailCommentUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EmailingEmailCommentSetInput>;
  /** filter the rows which have to be updated */
  where: EmailingEmailCommentBoolExp;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type EmailingNumericComparisonExp = {
  _eq?: InputMaybe<Scalars['Emailingnumeric']['input']>;
  _gt?: InputMaybe<Scalars['Emailingnumeric']['input']>;
  _gte?: InputMaybe<Scalars['Emailingnumeric']['input']>;
  _in?: InputMaybe<Array<Scalars['Emailingnumeric']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Emailingnumeric']['input']>;
  _lte?: InputMaybe<Scalars['Emailingnumeric']['input']>;
  _neq?: InputMaybe<Scalars['Emailingnumeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['Emailingnumeric']['input']>>;
};

/** column ordering options */
export type EmailingOrderBy =
  /** in ascending order, nulls last */
  | 'ASC'
  /** in ascending order, nulls first */
  | 'ASC_NULLS_FIRST'
  /** in ascending order, nulls last */
  | 'ASC_NULLS_LAST'
  /** in descending order, nulls first */
  | 'DESC'
  /** in descending order, nulls first */
  | 'DESC_NULLS_FIRST'
  /** in descending order, nulls last */
  | 'DESC_NULLS_LAST'
  | '%future added value';

/** Boolean expression to compare columns of type "providerTypeEnum". All fields are combined with logical 'AND'. */
export type EmailingProviderTypeEnumComparisonExp = {
  _eq?: InputMaybe<EmailingproviderTypeEnum>;
  _in?: InputMaybe<Array<EmailingproviderTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<EmailingproviderTypeEnum>;
  _nin?: InputMaybe<Array<EmailingproviderTypeEnum>>;
};

/** columns and relationships of "email.activity" */
export type Emailingactivity = {
  __typename?: 'Emailingactivity';
  activityActivityUuid?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  activityParticipants: Array<EmailingactivityParticipant>;
  /** An aggregate relationship */
  activityParticipantsAggregate: EmailingactivityParticipantAggregate;
  /** An array relationship */
  comments: Array<EmailingEmailComment>;
  /** An aggregate relationship */
  commentsAggregate: EmailingEmailCommentAggregate;
  conversationId?: Maybe<Scalars['String']['output']>;
  conversationSize?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Emailingtimestamptz']['output'];
  direction?: Maybe<Scalars['String']['output']>;
  emailId?: Maybe<Scalars['String']['output']>;
  emailProviderType?: Maybe<EmailingproviderTypeEnum>;
  endedAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  fromAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  providerType?: Maybe<EmailingproviderType>;
  startedAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  toAddresses?: Maybe<Scalars['String']['output']>;
  type?: Maybe<EmailingEmailActivityTypeEnum>;
  updatedAt: Scalars['Emailingtimestamptz']['output'];
};


/** columns and relationships of "email.activity" */
export type EmailingactivityactivityParticipantsArgs = {
  distinctOn?: InputMaybe<Array<EmailingactivityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingactivityParticipantOrderBy>>;
  where?: InputMaybe<EmailingactivityParticipantBoolExp>;
};


/** columns and relationships of "email.activity" */
export type EmailingactivityactivityParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EmailingactivityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingactivityParticipantOrderBy>>;
  where?: InputMaybe<EmailingactivityParticipantBoolExp>;
};


/** columns and relationships of "email.activity" */
export type EmailingactivitycommentsArgs = {
  distinctOn?: InputMaybe<Array<EmailingEmailCommentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingEmailCommentOrderBy>>;
  where?: InputMaybe<EmailingEmailCommentBoolExp>;
};


/** columns and relationships of "email.activity" */
export type EmailingactivitycommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EmailingEmailCommentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingEmailCommentOrderBy>>;
  where?: InputMaybe<EmailingEmailCommentBoolExp>;
};

/** aggregated selection of "email.activity" */
export type EmailingactivityAggregate = {
  __typename?: 'EmailingactivityAggregate';
  aggregate?: Maybe<EmailingactivityAggregateFields>;
  nodes: Array<Emailingactivity>;
};

/** aggregate fields of "email.activity" */
export type EmailingactivityAggregateFields = {
  __typename?: 'EmailingactivityAggregateFields';
  avg?: Maybe<EmailingactivityAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<EmailingactivityMaxFields>;
  min?: Maybe<EmailingactivityMinFields>;
  stddev?: Maybe<EmailingactivityStddevFields>;
  stddevPop?: Maybe<EmailingactivityStddevPopFields>;
  stddevSamp?: Maybe<EmailingactivityStddevSampFields>;
  sum?: Maybe<EmailingactivitySumFields>;
  varPop?: Maybe<EmailingactivityVarPopFields>;
  varSamp?: Maybe<EmailingactivityVarSampFields>;
  variance?: Maybe<EmailingactivityVarianceFields>;
};


/** aggregate fields of "email.activity" */
export type EmailingactivityAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<EmailingactivitySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type EmailingactivityAvgFields = {
  __typename?: 'EmailingactivityAvgFields';
  conversationSize?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "email.activity". All fields are combined with a logical 'AND'. */
export type EmailingactivityBoolExp = {
  _and?: InputMaybe<Array<EmailingactivityBoolExp>>;
  _not?: InputMaybe<EmailingactivityBoolExp>;
  _or?: InputMaybe<Array<EmailingactivityBoolExp>>;
  activityActivityUuid?: InputMaybe<TaskUuidComparisonExp>;
  activityParticipants?: InputMaybe<EmailingactivityParticipantBoolExp>;
  activityParticipantsAggregate?: InputMaybe<TelephonyactivityParticipantAggregateBoolExp>;
  comments?: InputMaybe<EmailingEmailCommentBoolExp>;
  commentsAggregate?: InputMaybe<EmailingEmailCommentAggregateBoolExp>;
  conversationId?: InputMaybe<TaskStringComparisonExp>;
  conversationSize?: InputMaybe<TaskIntComparisonExp>;
  createdAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  direction?: InputMaybe<TaskStringComparisonExp>;
  emailId?: InputMaybe<TaskStringComparisonExp>;
  emailProviderType?: InputMaybe<EmailingProviderTypeEnumComparisonExp>;
  endedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  fromAddress?: InputMaybe<TaskStringComparisonExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  providerType?: InputMaybe<EmailingproviderTypeBoolExp>;
  startedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  subject?: InputMaybe<TaskStringComparisonExp>;
  toAddresses?: InputMaybe<TaskStringComparisonExp>;
  type?: InputMaybe<EmailingEmailActivityTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "email.activity" */
export type EmailingactivityConstraint =
  /** unique or primary key constraint on columns "email_id", "activity_activity_uuid" */
  | 'activity_email_id_activity_activity_uuid_key'
  /** unique or primary key constraint on columns "id" */
  | 'activity_pkey'
  | '%future added value';

/** input type for incrementing numeric columns in table "email.activity" */
export type EmailingactivityIncInput = {
  conversationSize?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "email.activity" */
export type EmailingactivityInsertInput = {
  activityActivityUuid?: InputMaybe<Scalars['uuid']['input']>;
  activityParticipants?: InputMaybe<EmailingactivityParticipantArrRelInsertInput>;
  comments?: InputMaybe<EmailingEmailCommentArrRelInsertInput>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  conversationSize?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  emailId?: InputMaybe<Scalars['String']['input']>;
  emailProviderType?: InputMaybe<EmailingproviderTypeEnum>;
  endedAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  fromAddress?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  providerType?: InputMaybe<EmailingproviderTypeObjRelInsertInput>;
  startedAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  toAddresses?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EmailingEmailActivityTypeEnum>;
  updatedAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
};

/** aggregate max on columns */
export type EmailingactivityMaxFields = {
  __typename?: 'EmailingactivityMaxFields';
  activityActivityUuid?: Maybe<Scalars['uuid']['output']>;
  conversationId?: Maybe<Scalars['String']['output']>;
  conversationSize?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  emailId?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  fromAddress?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  startedAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  toAddresses?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
};

/** aggregate min on columns */
export type EmailingactivityMinFields = {
  __typename?: 'EmailingactivityMinFields';
  activityActivityUuid?: Maybe<Scalars['uuid']['output']>;
  conversationId?: Maybe<Scalars['String']['output']>;
  conversationSize?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  emailId?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  fromAddress?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  startedAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  toAddresses?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
};

/** response of any mutation on the table "email.activity" */
export type EmailingactivityMutationResponse = {
  __typename?: 'EmailingactivityMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Emailingactivity>;
};

/** input type for inserting object relation for remote table "email.activity" */
export type EmailingactivityObjRelInsertInput = {
  data: EmailingactivityInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EmailingactivityOnConflict>;
};

/** on_conflict condition type for table "email.activity" */
export type EmailingactivityOnConflict = {
  constraint: EmailingactivityConstraint;
  updateColumns?: Array<EmailingactivityUpdateColumn>;
  where?: InputMaybe<EmailingactivityBoolExp>;
};

/** Ordering options when selecting data from "email.activity". */
export type EmailingactivityOrderBy = {
  activityActivityUuid?: InputMaybe<EmailingOrderBy>;
  activityParticipantsAggregate?: InputMaybe<EmailingactivityParticipantAggregateOrderBy>;
  commentsAggregate?: InputMaybe<EmailingEmailCommentAggregateOrderBy>;
  conversationId?: InputMaybe<EmailingOrderBy>;
  conversationSize?: InputMaybe<EmailingOrderBy>;
  createdAt?: InputMaybe<EmailingOrderBy>;
  direction?: InputMaybe<EmailingOrderBy>;
  emailId?: InputMaybe<EmailingOrderBy>;
  emailProviderType?: InputMaybe<EmailingOrderBy>;
  endedAt?: InputMaybe<EmailingOrderBy>;
  fromAddress?: InputMaybe<EmailingOrderBy>;
  id?: InputMaybe<EmailingOrderBy>;
  providerType?: InputMaybe<EmailingproviderTypeOrderBy>;
  startedAt?: InputMaybe<EmailingOrderBy>;
  subject?: InputMaybe<EmailingOrderBy>;
  toAddresses?: InputMaybe<EmailingOrderBy>;
  type?: InputMaybe<EmailingOrderBy>;
  updatedAt?: InputMaybe<EmailingOrderBy>;
};

/** columns and relationships of "email.activity_participant" */
export type EmailingactivityParticipant = {
  __typename?: 'EmailingactivityParticipant';
  /** An object relationship */
  activity?: Maybe<Emailingactivity>;
  activityActivityUuid?: Maybe<Scalars['uuid']['output']>;
  activityId?: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['Emailingtimestamptz']['output'];
  /** An object relationship */
  domainUser?: Maybe<EmailingdomainUser>;
  domainUserId?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  role?: Maybe<EmailingactivityParticipantRoleEnum>;
  updatedAt: Scalars['Emailingtimestamptz']['output'];
};

/** aggregated selection of "email.activity_participant" */
export type EmailingactivityParticipantAggregate = {
  __typename?: 'EmailingactivityParticipantAggregate';
  aggregate?: Maybe<EmailingactivityParticipantAggregateFields>;
  nodes: Array<EmailingactivityParticipant>;
};

/** aggregate fields of "email.activity_participant" */
export type EmailingactivityParticipantAggregateFields = {
  __typename?: 'EmailingactivityParticipantAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<EmailingactivityParticipantMaxFields>;
  min?: Maybe<EmailingactivityParticipantMinFields>;
};


/** aggregate fields of "email.activity_participant" */
export type EmailingactivityParticipantAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<EmailingactivityParticipantSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "email.activity_participant" */
export type EmailingactivityParticipantAggregateOrderBy = {
  count?: InputMaybe<EmailingOrderBy>;
  max?: InputMaybe<EmailingactivityParticipantMaxOrderBy>;
  min?: InputMaybe<EmailingactivityParticipantMinOrderBy>;
};

/** input type for inserting array relation for remote table "email.activity_participant" */
export type EmailingactivityParticipantArrRelInsertInput = {
  data: Array<EmailingactivityParticipantInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EmailingactivityParticipantOnConflict>;
};

/** Boolean expression to filter rows from the table "email.activity_participant". All fields are combined with a logical 'AND'. */
export type EmailingactivityParticipantBoolExp = {
  _and?: InputMaybe<Array<EmailingactivityParticipantBoolExp>>;
  _not?: InputMaybe<EmailingactivityParticipantBoolExp>;
  _or?: InputMaybe<Array<EmailingactivityParticipantBoolExp>>;
  activity?: InputMaybe<EmailingactivityBoolExp>;
  activityActivityUuid?: InputMaybe<TaskUuidComparisonExp>;
  activityId?: InputMaybe<TaskUuidComparisonExp>;
  createdAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  domainUser?: InputMaybe<EmailingdomainUserBoolExp>;
  domainUserId?: InputMaybe<TaskUuidComparisonExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  role?: InputMaybe<EmailingActivityParticipantRoleEnumComparisonExp>;
  updatedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "email.activity_participant" */
export type EmailingactivityParticipantConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'activity_participant_pkey'
  | '%future added value';

/** input type for inserting data into table "email.activity_participant" */
export type EmailingactivityParticipantInsertInput = {
  activity?: InputMaybe<EmailingactivityObjRelInsertInput>;
  activityActivityUuid?: InputMaybe<Scalars['uuid']['input']>;
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  domainUser?: InputMaybe<EmailingdomainUserObjRelInsertInput>;
  domainUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<EmailingactivityParticipantRoleEnum>;
  updatedAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
};

/** aggregate max on columns */
export type EmailingactivityParticipantMaxFields = {
  __typename?: 'EmailingactivityParticipantMaxFields';
  activityActivityUuid?: Maybe<Scalars['uuid']['output']>;
  activityId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  domainUserId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
};

/** order by max() on columns of table "email.activity_participant" */
export type EmailingactivityParticipantMaxOrderBy = {
  activityActivityUuid?: InputMaybe<EmailingOrderBy>;
  activityId?: InputMaybe<EmailingOrderBy>;
  createdAt?: InputMaybe<EmailingOrderBy>;
  domainUserId?: InputMaybe<EmailingOrderBy>;
  id?: InputMaybe<EmailingOrderBy>;
  updatedAt?: InputMaybe<EmailingOrderBy>;
};

/** aggregate min on columns */
export type EmailingactivityParticipantMinFields = {
  __typename?: 'EmailingactivityParticipantMinFields';
  activityActivityUuid?: Maybe<Scalars['uuid']['output']>;
  activityId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  domainUserId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
};

/** order by min() on columns of table "email.activity_participant" */
export type EmailingactivityParticipantMinOrderBy = {
  activityActivityUuid?: InputMaybe<EmailingOrderBy>;
  activityId?: InputMaybe<EmailingOrderBy>;
  createdAt?: InputMaybe<EmailingOrderBy>;
  domainUserId?: InputMaybe<EmailingOrderBy>;
  id?: InputMaybe<EmailingOrderBy>;
  updatedAt?: InputMaybe<EmailingOrderBy>;
};

/** response of any mutation on the table "email.activity_participant" */
export type EmailingactivityParticipantMutationResponse = {
  __typename?: 'EmailingactivityParticipantMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EmailingactivityParticipant>;
};

/** on_conflict condition type for table "email.activity_participant" */
export type EmailingactivityParticipantOnConflict = {
  constraint: EmailingactivityParticipantConstraint;
  updateColumns?: Array<EmailingactivityParticipantUpdateColumn>;
  where?: InputMaybe<EmailingactivityParticipantBoolExp>;
};

/** Ordering options when selecting data from "email.activity_participant". */
export type EmailingactivityParticipantOrderBy = {
  activity?: InputMaybe<EmailingactivityOrderBy>;
  activityActivityUuid?: InputMaybe<EmailingOrderBy>;
  activityId?: InputMaybe<EmailingOrderBy>;
  createdAt?: InputMaybe<EmailingOrderBy>;
  domainUser?: InputMaybe<EmailingdomainUserOrderBy>;
  domainUserId?: InputMaybe<EmailingOrderBy>;
  id?: InputMaybe<EmailingOrderBy>;
  role?: InputMaybe<EmailingOrderBy>;
  updatedAt?: InputMaybe<EmailingOrderBy>;
};

/** primary key columns input for table: email.activity_participant */
export type EmailingactivityParticipantPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "email.activity_participant_role" */
export type EmailingactivityParticipantRole = {
  __typename?: 'EmailingactivityParticipantRole';
  /** An array relationship */
  activityParticipants: Array<EmailingactivityParticipant>;
  /** An aggregate relationship */
  activityParticipantsAggregate: EmailingactivityParticipantAggregate;
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};


/** columns and relationships of "email.activity_participant_role" */
export type EmailingactivityParticipantRoleactivityParticipantsArgs = {
  distinctOn?: InputMaybe<Array<EmailingactivityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingactivityParticipantOrderBy>>;
  where?: InputMaybe<EmailingactivityParticipantBoolExp>;
};


/** columns and relationships of "email.activity_participant_role" */
export type EmailingactivityParticipantRoleactivityParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EmailingactivityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingactivityParticipantOrderBy>>;
  where?: InputMaybe<EmailingactivityParticipantBoolExp>;
};

/** aggregated selection of "email.activity_participant_role" */
export type EmailingactivityParticipantRoleAggregate = {
  __typename?: 'EmailingactivityParticipantRoleAggregate';
  aggregate?: Maybe<EmailingactivityParticipantRoleAggregateFields>;
  nodes: Array<EmailingactivityParticipantRole>;
};

/** aggregate fields of "email.activity_participant_role" */
export type EmailingactivityParticipantRoleAggregateFields = {
  __typename?: 'EmailingactivityParticipantRoleAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<EmailingactivityParticipantRoleMaxFields>;
  min?: Maybe<EmailingactivityParticipantRoleMinFields>;
};


/** aggregate fields of "email.activity_participant_role" */
export type EmailingactivityParticipantRoleAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<EmailingactivityParticipantRoleSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "email.activity_participant_role". All fields are combined with a logical 'AND'. */
export type EmailingactivityParticipantRoleBoolExp = {
  _and?: InputMaybe<Array<EmailingactivityParticipantRoleBoolExp>>;
  _not?: InputMaybe<EmailingactivityParticipantRoleBoolExp>;
  _or?: InputMaybe<Array<EmailingactivityParticipantRoleBoolExp>>;
  activityParticipants?: InputMaybe<EmailingactivityParticipantBoolExp>;
  activityParticipantsAggregate?: InputMaybe<TelephonyactivityParticipantAggregateBoolExp>;
  description?: InputMaybe<TaskStringComparisonExp>;
  value?: InputMaybe<TaskStringComparisonExp>;
};

/** unique or primary key constraints on table "email.activity_participant_role" */
export type EmailingactivityParticipantRoleConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'activity_participant_role_pkey'
  | '%future added value';

export type EmailingactivityParticipantRoleEnum =
  /** Customer */
  | 'CUSTOMER'
  /** Customer candidate */
  | 'CUSTOMER_CANDIDATE'
  /** Employee */
  | 'EMPLOYEE'
  /** Employee candidate */
  | 'EMPLOYEE_CANDIDATE'
  /** General */
  | 'GENERAL'
  | '%future added value';

/** input type for inserting data into table "email.activity_participant_role" */
export type EmailingactivityParticipantRoleInsertInput = {
  activityParticipants?: InputMaybe<EmailingactivityParticipantArrRelInsertInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type EmailingactivityParticipantRoleMaxFields = {
  __typename?: 'EmailingactivityParticipantRoleMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type EmailingactivityParticipantRoleMinFields = {
  __typename?: 'EmailingactivityParticipantRoleMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "email.activity_participant_role" */
export type EmailingactivityParticipantRoleMutationResponse = {
  __typename?: 'EmailingactivityParticipantRoleMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EmailingactivityParticipantRole>;
};

/** on_conflict condition type for table "email.activity_participant_role" */
export type EmailingactivityParticipantRoleOnConflict = {
  constraint: EmailingactivityParticipantRoleConstraint;
  updateColumns?: Array<EmailingactivityParticipantRoleUpdateColumn>;
  where?: InputMaybe<EmailingactivityParticipantRoleBoolExp>;
};

/** Ordering options when selecting data from "email.activity_participant_role". */
export type EmailingactivityParticipantRoleOrderBy = {
  activityParticipantsAggregate?: InputMaybe<EmailingactivityParticipantAggregateOrderBy>;
  description?: InputMaybe<EmailingOrderBy>;
  value?: InputMaybe<EmailingOrderBy>;
};

/** primary key columns input for table: email.activity_participant_role */
export type EmailingactivityParticipantRolePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "email.activity_participant_role" */
export type EmailingactivityParticipantRoleSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "email.activity_participant_role" */
export type EmailingactivityParticipantRoleSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "activityParticipantRole" */
export type EmailingactivityParticipantRoleStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EmailingactivityParticipantRoleStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<EmailingCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EmailingactivityParticipantRoleStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "email.activity_participant_role" */
export type EmailingactivityParticipantRoleUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type EmailingactivityParticipantRoleUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EmailingactivityParticipantRoleSetInput>;
  /** filter the rows which have to be updated */
  where: EmailingactivityParticipantRoleBoolExp;
};

/** select columns of table "email.activity_participant" */
export type EmailingactivityParticipantSelectColumn =
  /** column name */
  | 'activityActivityUuid'
  /** column name */
  | 'activityId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'domainUserId'
  /** column name */
  | 'id'
  /** column name */
  | 'role'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "email.activity_participant" */
export type EmailingactivityParticipantSetInput = {
  activityActivityUuid?: InputMaybe<Scalars['uuid']['input']>;
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  domainUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<EmailingactivityParticipantRoleEnum>;
  updatedAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
};

/** update columns of table "email.activity_participant" */
export type EmailingactivityParticipantUpdateColumn =
  /** column name */
  | 'activityActivityUuid'
  /** column name */
  | 'activityId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'domainUserId'
  /** column name */
  | 'id'
  /** column name */
  | 'role'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** primary key columns input for table: email.activity */
export type EmailingactivityPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "email.activity" */
export type EmailingactivitySelectColumn =
  /** column name */
  | 'activityActivityUuid'
  /** column name */
  | 'conversationId'
  /** column name */
  | 'conversationSize'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'direction'
  /** column name */
  | 'emailId'
  /** column name */
  | 'emailProviderType'
  /** column name */
  | 'endedAt'
  /** column name */
  | 'fromAddress'
  /** column name */
  | 'id'
  /** column name */
  | 'startedAt'
  /** column name */
  | 'subject'
  /** column name */
  | 'toAddresses'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "email.activity" */
export type EmailingactivitySetInput = {
  activityActivityUuid?: InputMaybe<Scalars['uuid']['input']>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  conversationSize?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  emailId?: InputMaybe<Scalars['String']['input']>;
  emailProviderType?: InputMaybe<EmailingproviderTypeEnum>;
  endedAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  fromAddress?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  startedAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  toAddresses?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EmailingEmailActivityTypeEnum>;
  updatedAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
};

/** aggregate stddev on columns */
export type EmailingactivityStddevFields = {
  __typename?: 'EmailingactivityStddevFields';
  conversationSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type EmailingactivityStddevPopFields = {
  __typename?: 'EmailingactivityStddevPopFields';
  conversationSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type EmailingactivityStddevSampFields = {
  __typename?: 'EmailingactivityStddevSampFields';
  conversationSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type EmailingactivitySumFields = {
  __typename?: 'EmailingactivitySumFields';
  conversationSize?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "email.activity" */
export type EmailingactivityUpdateColumn =
  /** column name */
  | 'activityActivityUuid'
  /** column name */
  | 'conversationId'
  /** column name */
  | 'conversationSize'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'direction'
  /** column name */
  | 'emailId'
  /** column name */
  | 'emailProviderType'
  /** column name */
  | 'endedAt'
  /** column name */
  | 'fromAddress'
  /** column name */
  | 'id'
  /** column name */
  | 'startedAt'
  /** column name */
  | 'subject'
  /** column name */
  | 'toAddresses'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** aggregate varPop on columns */
export type EmailingactivityVarPopFields = {
  __typename?: 'EmailingactivityVarPopFields';
  conversationSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type EmailingactivityVarSampFields = {
  __typename?: 'EmailingactivityVarSampFields';
  conversationSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type EmailingactivityVarianceFields = {
  __typename?: 'EmailingactivityVarianceFields';
  conversationSize?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "email.domain_organization" */
export type EmailingdomainOrganization = {
  __typename?: 'EmailingdomainOrganization';
  createdAt: Scalars['Emailingtimestamptz']['output'];
  /** An array relationship */
  domainUsers: Array<EmailingdomainUser>;
  /** An aggregate relationship */
  domainUsersAggregate: EmailingdomainUserAggregate;
  id: Scalars['uuid']['output'];
  organizationId?: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['Emailingtimestamptz']['output'];
};


/** columns and relationships of "email.domain_organization" */
export type EmailingdomainOrganizationdomainUsersArgs = {
  distinctOn?: InputMaybe<Array<EmailingdomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingdomainUserOrderBy>>;
  where?: InputMaybe<EmailingdomainUserBoolExp>;
};


/** columns and relationships of "email.domain_organization" */
export type EmailingdomainOrganizationdomainUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<EmailingdomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingdomainUserOrderBy>>;
  where?: InputMaybe<EmailingdomainUserBoolExp>;
};

/** aggregated selection of "email.domain_organization" */
export type EmailingdomainOrganizationAggregate = {
  __typename?: 'EmailingdomainOrganizationAggregate';
  aggregate?: Maybe<EmailingdomainOrganizationAggregateFields>;
  nodes: Array<EmailingdomainOrganization>;
};

export type EmailingdomainOrganizationAggregateBoolExp = {
  count?: InputMaybe<TelephonydomainOrganizationAggregateBoolExpCount>;
};

/** aggregate fields of "email.domain_organization" */
export type EmailingdomainOrganizationAggregateFields = {
  __typename?: 'EmailingdomainOrganizationAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<EmailingdomainOrganizationMaxFields>;
  min?: Maybe<EmailingdomainOrganizationMinFields>;
};


/** aggregate fields of "email.domain_organization" */
export type EmailingdomainOrganizationAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<EmailingdomainOrganizationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "email.domain_organization" */
export type EmailingdomainOrganizationAggregateOrderBy = {
  count?: InputMaybe<EmailingOrderBy>;
  max?: InputMaybe<EmailingdomainOrganizationMaxOrderBy>;
  min?: InputMaybe<EmailingdomainOrganizationMinOrderBy>;
};

/** input type for inserting array relation for remote table "email.domain_organization" */
export type EmailingdomainOrganizationArrRelInsertInput = {
  data: Array<EmailingdomainOrganizationInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EmailingdomainOrganizationOnConflict>;
};

/** Boolean expression to filter rows from the table "email.domain_organization". All fields are combined with a logical 'AND'. */
export type EmailingdomainOrganizationBoolExp = {
  _and?: InputMaybe<Array<EmailingdomainOrganizationBoolExp>>;
  _not?: InputMaybe<EmailingdomainOrganizationBoolExp>;
  _or?: InputMaybe<Array<EmailingdomainOrganizationBoolExp>>;
  createdAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  domainUsers?: InputMaybe<EmailingdomainUserBoolExp>;
  domainUsersAggregate?: InputMaybe<TelephonydomainUserAggregateBoolExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  organizationId?: InputMaybe<TaskUuidComparisonExp>;
  updatedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "email.domain_organization" */
export type EmailingdomainOrganizationConstraint =
  /** unique or primary key constraint on columns "organization_id" */
  | 'domain_organization_organization_id_key'
  /** unique or primary key constraint on columns "id" */
  | 'domain_organization_pkey'
  | '%future added value';

/** input type for inserting data into table "email.domain_organization" */
export type EmailingdomainOrganizationInsertInput = {
  createdAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  domainUsers?: InputMaybe<EmailingdomainUserArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
};

/** aggregate max on columns */
export type EmailingdomainOrganizationMaxFields = {
  __typename?: 'EmailingdomainOrganizationMaxFields';
  createdAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
};

/** order by max() on columns of table "email.domain_organization" */
export type EmailingdomainOrganizationMaxOrderBy = {
  createdAt?: InputMaybe<EmailingOrderBy>;
  id?: InputMaybe<EmailingOrderBy>;
  organizationId?: InputMaybe<EmailingOrderBy>;
  updatedAt?: InputMaybe<EmailingOrderBy>;
};

/** aggregate min on columns */
export type EmailingdomainOrganizationMinFields = {
  __typename?: 'EmailingdomainOrganizationMinFields';
  createdAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
};

/** order by min() on columns of table "email.domain_organization" */
export type EmailingdomainOrganizationMinOrderBy = {
  createdAt?: InputMaybe<EmailingOrderBy>;
  id?: InputMaybe<EmailingOrderBy>;
  organizationId?: InputMaybe<EmailingOrderBy>;
  updatedAt?: InputMaybe<EmailingOrderBy>;
};

/** response of any mutation on the table "email.domain_organization" */
export type EmailingdomainOrganizationMutationResponse = {
  __typename?: 'EmailingdomainOrganizationMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EmailingdomainOrganization>;
};

/** input type for inserting object relation for remote table "email.domain_organization" */
export type EmailingdomainOrganizationObjRelInsertInput = {
  data: EmailingdomainOrganizationInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EmailingdomainOrganizationOnConflict>;
};

/** on_conflict condition type for table "email.domain_organization" */
export type EmailingdomainOrganizationOnConflict = {
  constraint: EmailingdomainOrganizationConstraint;
  updateColumns?: Array<EmailingdomainOrganizationUpdateColumn>;
  where?: InputMaybe<EmailingdomainOrganizationBoolExp>;
};

/** Ordering options when selecting data from "email.domain_organization". */
export type EmailingdomainOrganizationOrderBy = {
  createdAt?: InputMaybe<EmailingOrderBy>;
  domainUsersAggregate?: InputMaybe<EmailingdomainUserAggregateOrderBy>;
  id?: InputMaybe<EmailingOrderBy>;
  organizationId?: InputMaybe<EmailingOrderBy>;
  updatedAt?: InputMaybe<EmailingOrderBy>;
};

/** primary key columns input for table: email.domain_organization */
export type EmailingdomainOrganizationPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "email.domain_organization" */
export type EmailingdomainOrganizationSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "email.domain_organization" */
export type EmailingdomainOrganizationSetInput = {
  createdAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
};

/** update columns of table "email.domain_organization" */
export type EmailingdomainOrganizationUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** columns and relationships of "email.domain_user" */
export type EmailingdomainUser = {
  __typename?: 'EmailingdomainUser';
  /** An array relationship */
  activityParticipants: Array<EmailingactivityParticipant>;
  /** An aggregate relationship */
  activityParticipantsAggregate: EmailingactivityParticipantAggregate;
  category?: Maybe<EmailingdomainUserCategoryEnum>;
  createdAt: Scalars['Emailingtimestamptz']['output'];
  /** An object relationship */
  domainOrganization: EmailingdomainOrganization;
  domainOrganizationId: Scalars['uuid']['output'];
  /** An object relationship */
  domainUserCategory?: Maybe<EmailingdomainUserCategory>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['Emailingtimestamptz']['output'];
};


/** columns and relationships of "email.domain_user" */
export type EmailingdomainUseractivityParticipantsArgs = {
  distinctOn?: InputMaybe<Array<EmailingactivityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingactivityParticipantOrderBy>>;
  where?: InputMaybe<EmailingactivityParticipantBoolExp>;
};


/** columns and relationships of "email.domain_user" */
export type EmailingdomainUseractivityParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EmailingactivityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingactivityParticipantOrderBy>>;
  where?: InputMaybe<EmailingactivityParticipantBoolExp>;
};

/** aggregated selection of "email.domain_user" */
export type EmailingdomainUserAggregate = {
  __typename?: 'EmailingdomainUserAggregate';
  aggregate?: Maybe<EmailingdomainUserAggregateFields>;
  nodes: Array<EmailingdomainUser>;
};

/** aggregate fields of "email.domain_user" */
export type EmailingdomainUserAggregateFields = {
  __typename?: 'EmailingdomainUserAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<EmailingdomainUserMaxFields>;
  min?: Maybe<EmailingdomainUserMinFields>;
};


/** aggregate fields of "email.domain_user" */
export type EmailingdomainUserAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<EmailingdomainUserSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "email.domain_user" */
export type EmailingdomainUserAggregateOrderBy = {
  count?: InputMaybe<EmailingOrderBy>;
  max?: InputMaybe<EmailingdomainUserMaxOrderBy>;
  min?: InputMaybe<EmailingdomainUserMinOrderBy>;
};

/** input type for inserting array relation for remote table "email.domain_user" */
export type EmailingdomainUserArrRelInsertInput = {
  data: Array<EmailingdomainUserInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EmailingdomainUserOnConflict>;
};

/** Boolean expression to filter rows from the table "email.domain_user". All fields are combined with a logical 'AND'. */
export type EmailingdomainUserBoolExp = {
  _and?: InputMaybe<Array<EmailingdomainUserBoolExp>>;
  _not?: InputMaybe<EmailingdomainUserBoolExp>;
  _or?: InputMaybe<Array<EmailingdomainUserBoolExp>>;
  activityParticipants?: InputMaybe<EmailingactivityParticipantBoolExp>;
  activityParticipantsAggregate?: InputMaybe<TelephonyactivityParticipantAggregateBoolExp>;
  category?: InputMaybe<EmailingDomainUserCategoryEnumComparisonExp>;
  createdAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  domainOrganization?: InputMaybe<EmailingdomainOrganizationBoolExp>;
  domainOrganizationId?: InputMaybe<TaskUuidComparisonExp>;
  domainUserCategory?: InputMaybe<EmailingdomainUserCategoryBoolExp>;
  emailAddress?: InputMaybe<TaskStringComparisonExp>;
  firstName?: InputMaybe<TaskStringComparisonExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  lastName?: InputMaybe<TaskStringComparisonExp>;
  organizationUserId?: InputMaybe<TaskUuidComparisonExp>;
  updatedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
};

/** columns and relationships of "email.domain_user_category" */
export type EmailingdomainUserCategory = {
  __typename?: 'EmailingdomainUserCategory';
  /** An array relationship */
  domainUsers: Array<EmailingdomainUser>;
  /** An aggregate relationship */
  domainUsersAggregate: EmailingdomainUserAggregate;
  text: Scalars['String']['output'];
  value: Scalars['String']['output'];
};


/** columns and relationships of "email.domain_user_category" */
export type EmailingdomainUserCategorydomainUsersArgs = {
  distinctOn?: InputMaybe<Array<EmailingdomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingdomainUserOrderBy>>;
  where?: InputMaybe<EmailingdomainUserBoolExp>;
};


/** columns and relationships of "email.domain_user_category" */
export type EmailingdomainUserCategorydomainUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<EmailingdomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingdomainUserOrderBy>>;
  where?: InputMaybe<EmailingdomainUserBoolExp>;
};

/** aggregated selection of "email.domain_user_category" */
export type EmailingdomainUserCategoryAggregate = {
  __typename?: 'EmailingdomainUserCategoryAggregate';
  aggregate?: Maybe<EmailingdomainUserCategoryAggregateFields>;
  nodes: Array<EmailingdomainUserCategory>;
};

/** aggregate fields of "email.domain_user_category" */
export type EmailingdomainUserCategoryAggregateFields = {
  __typename?: 'EmailingdomainUserCategoryAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<EmailingdomainUserCategoryMaxFields>;
  min?: Maybe<EmailingdomainUserCategoryMinFields>;
};


/** aggregate fields of "email.domain_user_category" */
export type EmailingdomainUserCategoryAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<EmailingdomainUserCategorySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "email.domain_user_category". All fields are combined with a logical 'AND'. */
export type EmailingdomainUserCategoryBoolExp = {
  _and?: InputMaybe<Array<EmailingdomainUserCategoryBoolExp>>;
  _not?: InputMaybe<EmailingdomainUserCategoryBoolExp>;
  _or?: InputMaybe<Array<EmailingdomainUserCategoryBoolExp>>;
  domainUsers?: InputMaybe<EmailingdomainUserBoolExp>;
  domainUsersAggregate?: InputMaybe<TelephonydomainUserAggregateBoolExp>;
  text?: InputMaybe<TaskStringComparisonExp>;
  value?: InputMaybe<TaskStringComparisonExp>;
};

/** unique or primary key constraints on table "email.domain_user_category" */
export type EmailingdomainUserCategoryConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'domain_user_category_pkey'
  /** unique or primary key constraint on columns "value" */
  | 'email_domain_user_category_pkey'
  | '%future added value';

export type EmailingdomainUserCategoryEnum =
  /** Customer */
  | 'CUSTOMER'
  /** Customer candidate */
  | 'CUSTOMER_CANDIDATE'
  /** Employee */
  | 'EMPLOYEE'
  /** Employee candidate */
  | 'EMPLOYEE_CANDIDATE'
  | '%future added value';

/** input type for inserting data into table "email.domain_user_category" */
export type EmailingdomainUserCategoryInsertInput = {
  domainUsers?: InputMaybe<EmailingdomainUserArrRelInsertInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type EmailingdomainUserCategoryMaxFields = {
  __typename?: 'EmailingdomainUserCategoryMaxFields';
  text?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type EmailingdomainUserCategoryMinFields = {
  __typename?: 'EmailingdomainUserCategoryMinFields';
  text?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "email.domain_user_category" */
export type EmailingdomainUserCategoryMutationResponse = {
  __typename?: 'EmailingdomainUserCategoryMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EmailingdomainUserCategory>;
};

/** input type for inserting object relation for remote table "email.domain_user_category" */
export type EmailingdomainUserCategoryObjRelInsertInput = {
  data: EmailingdomainUserCategoryInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EmailingdomainUserCategoryOnConflict>;
};

/** on_conflict condition type for table "email.domain_user_category" */
export type EmailingdomainUserCategoryOnConflict = {
  constraint: EmailingdomainUserCategoryConstraint;
  updateColumns?: Array<EmailingdomainUserCategoryUpdateColumn>;
  where?: InputMaybe<EmailingdomainUserCategoryBoolExp>;
};

/** Ordering options when selecting data from "email.domain_user_category". */
export type EmailingdomainUserCategoryOrderBy = {
  domainUsersAggregate?: InputMaybe<EmailingdomainUserAggregateOrderBy>;
  text?: InputMaybe<EmailingOrderBy>;
  value?: InputMaybe<EmailingOrderBy>;
};

/** primary key columns input for table: email.domain_user_category */
export type EmailingdomainUserCategoryPkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "email.domain_user_category" */
export type EmailingdomainUserCategorySelectColumn =
  /** column name */
  | 'text'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "email.domain_user_category" */
export type EmailingdomainUserCategorySetInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "domainUserCategory" */
export type EmailingdomainUserCategoryStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EmailingdomainUserCategoryStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<EmailingCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EmailingdomainUserCategoryStreamCursorValueInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "email.domain_user_category" */
export type EmailingdomainUserCategoryUpdateColumn =
  /** column name */
  | 'text'
  /** column name */
  | 'value'
  | '%future added value';

export type EmailingdomainUserCategoryUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EmailingdomainUserCategorySetInput>;
  /** filter the rows which have to be updated */
  where: EmailingdomainUserCategoryBoolExp;
};

/** unique or primary key constraints on table "email.domain_user" */
export type EmailingdomainUserConstraint =
  /** unique or primary key constraint on columns "domain_organization_id", "email_address" */
  | 'domain_user_domain_organization_id_email_address_key'
  /** unique or primary key constraint on columns "id" */
  | 'domain_user_pkey'
  /** unique or primary key constraint on columns "id" */
  | 'email_domain_user_pkey'
  | '%future added value';

/** input type for inserting data into table "email.domain_user" */
export type EmailingdomainUserInsertInput = {
  activityParticipants?: InputMaybe<EmailingactivityParticipantArrRelInsertInput>;
  category?: InputMaybe<EmailingdomainUserCategoryEnum>;
  createdAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  domainOrganization?: InputMaybe<EmailingdomainOrganizationObjRelInsertInput>;
  domainOrganizationId?: InputMaybe<Scalars['uuid']['input']>;
  domainUserCategory?: InputMaybe<EmailingdomainUserCategoryObjRelInsertInput>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
};

/** aggregate max on columns */
export type EmailingdomainUserMaxFields = {
  __typename?: 'EmailingdomainUserMaxFields';
  createdAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  domainOrganizationId?: Maybe<Scalars['uuid']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
};

/** order by max() on columns of table "email.domain_user" */
export type EmailingdomainUserMaxOrderBy = {
  createdAt?: InputMaybe<EmailingOrderBy>;
  domainOrganizationId?: InputMaybe<EmailingOrderBy>;
  emailAddress?: InputMaybe<EmailingOrderBy>;
  firstName?: InputMaybe<EmailingOrderBy>;
  id?: InputMaybe<EmailingOrderBy>;
  lastName?: InputMaybe<EmailingOrderBy>;
  organizationUserId?: InputMaybe<EmailingOrderBy>;
  updatedAt?: InputMaybe<EmailingOrderBy>;
};

/** aggregate min on columns */
export type EmailingdomainUserMinFields = {
  __typename?: 'EmailingdomainUserMinFields';
  createdAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  domainOrganizationId?: Maybe<Scalars['uuid']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
};

/** order by min() on columns of table "email.domain_user" */
export type EmailingdomainUserMinOrderBy = {
  createdAt?: InputMaybe<EmailingOrderBy>;
  domainOrganizationId?: InputMaybe<EmailingOrderBy>;
  emailAddress?: InputMaybe<EmailingOrderBy>;
  firstName?: InputMaybe<EmailingOrderBy>;
  id?: InputMaybe<EmailingOrderBy>;
  lastName?: InputMaybe<EmailingOrderBy>;
  organizationUserId?: InputMaybe<EmailingOrderBy>;
  updatedAt?: InputMaybe<EmailingOrderBy>;
};

/** response of any mutation on the table "email.domain_user" */
export type EmailingdomainUserMutationResponse = {
  __typename?: 'EmailingdomainUserMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EmailingdomainUser>;
};

/** input type for inserting object relation for remote table "email.domain_user" */
export type EmailingdomainUserObjRelInsertInput = {
  data: EmailingdomainUserInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EmailingdomainUserOnConflict>;
};

/** on_conflict condition type for table "email.domain_user" */
export type EmailingdomainUserOnConflict = {
  constraint: EmailingdomainUserConstraint;
  updateColumns?: Array<EmailingdomainUserUpdateColumn>;
  where?: InputMaybe<EmailingdomainUserBoolExp>;
};

/** Ordering options when selecting data from "email.domain_user". */
export type EmailingdomainUserOrderBy = {
  activityParticipantsAggregate?: InputMaybe<EmailingactivityParticipantAggregateOrderBy>;
  category?: InputMaybe<EmailingOrderBy>;
  createdAt?: InputMaybe<EmailingOrderBy>;
  domainOrganization?: InputMaybe<EmailingdomainOrganizationOrderBy>;
  domainOrganizationId?: InputMaybe<EmailingOrderBy>;
  domainUserCategory?: InputMaybe<EmailingdomainUserCategoryOrderBy>;
  emailAddress?: InputMaybe<EmailingOrderBy>;
  firstName?: InputMaybe<EmailingOrderBy>;
  id?: InputMaybe<EmailingOrderBy>;
  lastName?: InputMaybe<EmailingOrderBy>;
  organizationUserId?: InputMaybe<EmailingOrderBy>;
  updatedAt?: InputMaybe<EmailingOrderBy>;
};

/** primary key columns input for table: email.domain_user */
export type EmailingdomainUserPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "email.domain_user" */
export type EmailingdomainUserSelectColumn =
  /** column name */
  | 'category'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'domainOrganizationId'
  /** column name */
  | 'emailAddress'
  /** column name */
  | 'firstName'
  /** column name */
  | 'id'
  /** column name */
  | 'lastName'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "email.domain_user" */
export type EmailingdomainUserSetInput = {
  category?: InputMaybe<EmailingdomainUserCategoryEnum>;
  createdAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  domainOrganizationId?: InputMaybe<Scalars['uuid']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
};

/** update columns of table "email.domain_user" */
export type EmailingdomainUserUpdateColumn =
  /** column name */
  | 'category'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'domainOrganizationId'
  /** column name */
  | 'emailAddress'
  /** column name */
  | 'firstName'
  /** column name */
  | 'id'
  /** column name */
  | 'lastName'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type EmailingdomainUserUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EmailingdomainUserSetInput>;
  /** filter the rows which have to be updated */
  where: EmailingdomainUserBoolExp;
};

export type EmailingemailAccountSubscribersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EmailingEmailAccountSubscribersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EmailingEmailAccountSubscribersBoolExp>;
  predicate: TaskIntComparisonExp;
};

export type EmailingemailCommentAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EmailingEmailCommentSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EmailingEmailCommentBoolExp>;
  predicate: TaskIntComparisonExp;
};

/** columns and relationships of "email.event" */
export type Emailingevent = {
  __typename?: 'Emailingevent';
  body?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Emailingtimestamptz']['output'];
  emailId?: Maybe<Scalars['String']['output']>;
  emailProviderType?: Maybe<EmailingproviderTypeEnum>;
  hasAttachments: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  isDraft: Scalars['Boolean']['output'];
  isRead: Scalars['Boolean']['output'];
  lastModifiedAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  /** An object relationship */
  providerType?: Maybe<EmailingproviderType>;
  receivedAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  recipientEmailAddresses?: Maybe<Scalars['String']['output']>;
  senderEmailAddress: Scalars['String']['output'];
  sentAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['Emailingtimestamptz']['output'];
};

/** aggregated selection of "email.event" */
export type EmailingeventAggregate = {
  __typename?: 'EmailingeventAggregate';
  aggregate?: Maybe<EmailingeventAggregateFields>;
  nodes: Array<Emailingevent>;
};

/** aggregate fields of "email.event" */
export type EmailingeventAggregateFields = {
  __typename?: 'EmailingeventAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<EmailingeventMaxFields>;
  min?: Maybe<EmailingeventMinFields>;
};


/** aggregate fields of "email.event" */
export type EmailingeventAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<EmailingeventSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "email.event". All fields are combined with a logical 'AND'. */
export type EmailingeventBoolExp = {
  _and?: InputMaybe<Array<EmailingeventBoolExp>>;
  _not?: InputMaybe<EmailingeventBoolExp>;
  _or?: InputMaybe<Array<EmailingeventBoolExp>>;
  body?: InputMaybe<TaskStringComparisonExp>;
  conversationId?: InputMaybe<TaskStringComparisonExp>;
  createdAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  emailId?: InputMaybe<TaskStringComparisonExp>;
  emailProviderType?: InputMaybe<EmailingProviderTypeEnumComparisonExp>;
  hasAttachments?: InputMaybe<TelephonyBooleanComparisonExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  isDraft?: InputMaybe<TelephonyBooleanComparisonExp>;
  isRead?: InputMaybe<TelephonyBooleanComparisonExp>;
  lastModifiedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  providerType?: InputMaybe<EmailingproviderTypeBoolExp>;
  receivedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  recipientEmailAddresses?: InputMaybe<TaskStringComparisonExp>;
  senderEmailAddress?: InputMaybe<TaskStringComparisonExp>;
  sentAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  subject?: InputMaybe<TaskStringComparisonExp>;
  subscriptionId?: InputMaybe<TaskUuidComparisonExp>;
  updatedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "email.event" */
export type EmailingeventConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'event_id_key'
  /** unique or primary key constraint on columns "email_provider_type", "conversation_id", "is_draft", "sender_email_address" */
  | 'event_is_draft_conversation_id_provider_type_sender_email_addre'
  /** unique or primary key constraint on columns "id" */
  | 'event_pkey'
  /** unique or primary key constraint on columns "sent_at", "sender_email_address", "is_read" */
  | 'event_sender_email_address_is_read_sent_at_key'
  | '%future added value';

/** input type for inserting data into table "email.event" */
export type EmailingeventInsertInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  emailId?: InputMaybe<Scalars['String']['input']>;
  emailProviderType?: InputMaybe<EmailingproviderTypeEnum>;
  hasAttachments?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  providerType?: InputMaybe<EmailingproviderTypeObjRelInsertInput>;
  receivedAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  recipientEmailAddresses?: InputMaybe<Scalars['String']['input']>;
  senderEmailAddress?: InputMaybe<Scalars['String']['input']>;
  sentAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subscriptionId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
};

/** aggregate max on columns */
export type EmailingeventMaxFields = {
  __typename?: 'EmailingeventMaxFields';
  body?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  emailId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastModifiedAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  receivedAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  recipientEmailAddresses?: Maybe<Scalars['String']['output']>;
  senderEmailAddress?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
};

/** aggregate min on columns */
export type EmailingeventMinFields = {
  __typename?: 'EmailingeventMinFields';
  body?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  emailId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastModifiedAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  receivedAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  recipientEmailAddresses?: Maybe<Scalars['String']['output']>;
  senderEmailAddress?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
};

/** response of any mutation on the table "email.event" */
export type EmailingeventMutationResponse = {
  __typename?: 'EmailingeventMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Emailingevent>;
};

/** on_conflict condition type for table "email.event" */
export type EmailingeventOnConflict = {
  constraint: EmailingeventConstraint;
  updateColumns?: Array<EmailingeventUpdateColumn>;
  where?: InputMaybe<EmailingeventBoolExp>;
};

/** Ordering options when selecting data from "email.event". */
export type EmailingeventOrderBy = {
  body?: InputMaybe<EmailingOrderBy>;
  conversationId?: InputMaybe<EmailingOrderBy>;
  createdAt?: InputMaybe<EmailingOrderBy>;
  emailId?: InputMaybe<EmailingOrderBy>;
  emailProviderType?: InputMaybe<EmailingOrderBy>;
  hasAttachments?: InputMaybe<EmailingOrderBy>;
  id?: InputMaybe<EmailingOrderBy>;
  isDraft?: InputMaybe<EmailingOrderBy>;
  isRead?: InputMaybe<EmailingOrderBy>;
  lastModifiedAt?: InputMaybe<EmailingOrderBy>;
  providerType?: InputMaybe<EmailingproviderTypeOrderBy>;
  receivedAt?: InputMaybe<EmailingOrderBy>;
  recipientEmailAddresses?: InputMaybe<EmailingOrderBy>;
  senderEmailAddress?: InputMaybe<EmailingOrderBy>;
  sentAt?: InputMaybe<EmailingOrderBy>;
  subject?: InputMaybe<EmailingOrderBy>;
  subscriptionId?: InputMaybe<EmailingOrderBy>;
  updatedAt?: InputMaybe<EmailingOrderBy>;
};

/** primary key columns input for table: email.event */
export type EmailingeventPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "email.event" */
export type EmailingeventSelectColumn =
  /** column name */
  | 'body'
  /** column name */
  | 'conversationId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'emailId'
  /** column name */
  | 'emailProviderType'
  /** column name */
  | 'hasAttachments'
  /** column name */
  | 'id'
  /** column name */
  | 'isDraft'
  /** column name */
  | 'isRead'
  /** column name */
  | 'lastModifiedAt'
  /** column name */
  | 'receivedAt'
  /** column name */
  | 'recipientEmailAddresses'
  /** column name */
  | 'senderEmailAddress'
  /** column name */
  | 'sentAt'
  /** column name */
  | 'subject'
  /** column name */
  | 'subscriptionId'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "email.event" */
export type EmailingeventSetInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  emailId?: InputMaybe<Scalars['String']['input']>;
  emailProviderType?: InputMaybe<EmailingproviderTypeEnum>;
  hasAttachments?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  receivedAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  recipientEmailAddresses?: InputMaybe<Scalars['String']['input']>;
  senderEmailAddress?: InputMaybe<Scalars['String']['input']>;
  sentAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subscriptionId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
};

/** update columns of table "email.event" */
export type EmailingeventUpdateColumn =
  /** column name */
  | 'body'
  /** column name */
  | 'conversationId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'emailId'
  /** column name */
  | 'emailProviderType'
  /** column name */
  | 'hasAttachments'
  /** column name */
  | 'id'
  /** column name */
  | 'isDraft'
  /** column name */
  | 'isRead'
  /** column name */
  | 'lastModifiedAt'
  /** column name */
  | 'receivedAt'
  /** column name */
  | 'recipientEmailAddresses'
  /** column name */
  | 'senderEmailAddress'
  /** column name */
  | 'sentAt'
  /** column name */
  | 'subject'
  /** column name */
  | 'subscriptionId'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type EmailingeventUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EmailingeventSetInput>;
  /** filter the rows which have to be updated */
  where: EmailingeventBoolExp;
};

/** columns and relationships of "email.provider_account" */
export type EmailingproviderAccount = {
  __typename?: 'EmailingproviderAccount';
  /** An array relationship */
  accountSubscribers: Array<EmailingEmailAccountSubscribers>;
  /** An aggregate relationship */
  accountSubscribersAggregate: EmailingEmailAccountSubscribersAggregate;
  createdAt: Scalars['Emailingtimestamptz']['output'];
  /** An array relationship */
  domainOrganization: Array<EmailingdomainOrganization>;
  /** An aggregate relationship */
  domainOrganizationAggregate: EmailingdomainOrganizationAggregate;
  /** An object relationship */
  domainUser?: Maybe<EmailingdomainUser>;
  domainUserId?: Maybe<Scalars['uuid']['output']>;
  historyId?: Maybe<Scalars['Emailingnumeric']['output']>;
  id: Scalars['uuid']['output'];
  idToken: Scalars['String']['output'];
  linkedAddress: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['uuid']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  providerType?: Maybe<EmailingproviderType>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  subscriptionExpiration?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  subscriptionFolders?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
  type?: Maybe<EmailingproviderTypeEnum>;
  updatedAt: Scalars['Emailingtimestamptz']['output'];
  userId: Scalars['uuid']['output'];
};


/** columns and relationships of "email.provider_account" */
export type EmailingproviderAccountaccountSubscribersArgs = {
  distinctOn?: InputMaybe<Array<EmailingEmailAccountSubscribersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingEmailAccountSubscribersOrderBy>>;
  where?: InputMaybe<EmailingEmailAccountSubscribersBoolExp>;
};


/** columns and relationships of "email.provider_account" */
export type EmailingproviderAccountaccountSubscribersAggregateArgs = {
  distinctOn?: InputMaybe<Array<EmailingEmailAccountSubscribersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingEmailAccountSubscribersOrderBy>>;
  where?: InputMaybe<EmailingEmailAccountSubscribersBoolExp>;
};


/** columns and relationships of "email.provider_account" */
export type EmailingproviderAccountdomainOrganizationArgs = {
  distinctOn?: InputMaybe<Array<EmailingdomainOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingdomainOrganizationOrderBy>>;
  where?: InputMaybe<EmailingdomainOrganizationBoolExp>;
};


/** columns and relationships of "email.provider_account" */
export type EmailingproviderAccountdomainOrganizationAggregateArgs = {
  distinctOn?: InputMaybe<Array<EmailingdomainOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingdomainOrganizationOrderBy>>;
  where?: InputMaybe<EmailingdomainOrganizationBoolExp>;
};

/** aggregated selection of "email.provider_account" */
export type EmailingproviderAccountAggregate = {
  __typename?: 'EmailingproviderAccountAggregate';
  aggregate?: Maybe<EmailingproviderAccountAggregateFields>;
  nodes: Array<EmailingproviderAccount>;
};

/** aggregate fields of "email.provider_account" */
export type EmailingproviderAccountAggregateFields = {
  __typename?: 'EmailingproviderAccountAggregateFields';
  avg?: Maybe<EmailingproviderAccountAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<EmailingproviderAccountMaxFields>;
  min?: Maybe<EmailingproviderAccountMinFields>;
  stddev?: Maybe<EmailingproviderAccountStddevFields>;
  stddevPop?: Maybe<EmailingproviderAccountStddevPopFields>;
  stddevSamp?: Maybe<EmailingproviderAccountStddevSampFields>;
  sum?: Maybe<EmailingproviderAccountSumFields>;
  varPop?: Maybe<EmailingproviderAccountVarPopFields>;
  varSamp?: Maybe<EmailingproviderAccountVarSampFields>;
  variance?: Maybe<EmailingproviderAccountVarianceFields>;
};


/** aggregate fields of "email.provider_account" */
export type EmailingproviderAccountAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<EmailingproviderAccountSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "email.provider_account" */
export type EmailingproviderAccountAggregateOrderBy = {
  avg?: InputMaybe<EmailingproviderAccountAvgOrderBy>;
  count?: InputMaybe<EmailingOrderBy>;
  max?: InputMaybe<EmailingproviderAccountMaxOrderBy>;
  min?: InputMaybe<EmailingproviderAccountMinOrderBy>;
  stddev?: InputMaybe<EmailingproviderAccountStddevOrderBy>;
  stddevPop?: InputMaybe<EmailingproviderAccountStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EmailingproviderAccountStddevSampOrderBy>;
  sum?: InputMaybe<EmailingproviderAccountSumOrderBy>;
  varPop?: InputMaybe<EmailingproviderAccountVarPopOrderBy>;
  varSamp?: InputMaybe<EmailingproviderAccountVarSampOrderBy>;
  variance?: InputMaybe<EmailingproviderAccountVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "email.provider_account" */
export type EmailingproviderAccountArrRelInsertInput = {
  data: Array<EmailingproviderAccountInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EmailingproviderAccountOnConflict>;
};

/** aggregate avg on columns */
export type EmailingproviderAccountAvgFields = {
  __typename?: 'EmailingproviderAccountAvgFields';
  historyId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "email.provider_account" */
export type EmailingproviderAccountAvgOrderBy = {
  historyId?: InputMaybe<EmailingOrderBy>;
};

/** Boolean expression to filter rows from the table "email.provider_account". All fields are combined with a logical 'AND'. */
export type EmailingproviderAccountBoolExp = {
  _and?: InputMaybe<Array<EmailingproviderAccountBoolExp>>;
  _not?: InputMaybe<EmailingproviderAccountBoolExp>;
  _or?: InputMaybe<Array<EmailingproviderAccountBoolExp>>;
  accountSubscribers?: InputMaybe<EmailingEmailAccountSubscribersBoolExp>;
  accountSubscribersAggregate?: InputMaybe<EmailingEmailAccountSubscribersAggregateBoolExp>;
  createdAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  domainOrganization?: InputMaybe<EmailingdomainOrganizationBoolExp>;
  domainOrganizationAggregate?: InputMaybe<EmailingdomainOrganizationAggregateBoolExp>;
  domainUser?: InputMaybe<EmailingdomainUserBoolExp>;
  domainUserId?: InputMaybe<TaskUuidComparisonExp>;
  historyId?: InputMaybe<EmailingNumericComparisonExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  idToken?: InputMaybe<TaskStringComparisonExp>;
  linkedAddress?: InputMaybe<TaskStringComparisonExp>;
  organizationId?: InputMaybe<TaskUuidComparisonExp>;
  organizationUserId?: InputMaybe<TaskUuidComparisonExp>;
  providerType?: InputMaybe<EmailingproviderTypeBoolExp>;
  refreshToken?: InputMaybe<TaskStringComparisonExp>;
  subscriptionExpiration?: InputMaybe<TaskTimestamptzComparisonExp>;
  subscriptionFolders?: InputMaybe<TaskStringComparisonExp>;
  subscriptionId?: InputMaybe<TaskStringComparisonExp>;
  token?: InputMaybe<TaskStringComparisonExp>;
  type?: InputMaybe<EmailingProviderTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  userId?: InputMaybe<TaskUuidComparisonExp>;
};

/** unique or primary key constraints on table "email.provider_account" */
export type EmailingproviderAccountConstraint =
  /** unique or primary key constraint on columns "id_token" */
  | 'provider_account_id_token_key'
  /** unique or primary key constraint on columns "linked_address" */
  | 'provider_account_linked_address_key'
  /** unique or primary key constraint on columns "id" */
  | 'provider_account_pkey'
  /** unique or primary key constraint on columns "subscription_id" */
  | 'provider_account_subscription_id_key'
  /** unique or primary key constraint on columns "token" */
  | 'provider_account_token_key'
  | '%future added value';

/** input type for incrementing numeric columns in table "email.provider_account" */
export type EmailingproviderAccountIncInput = {
  historyId?: InputMaybe<Scalars['Emailingnumeric']['input']>;
};

/** input type for inserting data into table "email.provider_account" */
export type EmailingproviderAccountInsertInput = {
  accountSubscribers?: InputMaybe<EmailingEmailAccountSubscribersArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  domainOrganization?: InputMaybe<EmailingdomainOrganizationArrRelInsertInput>;
  domainUser?: InputMaybe<EmailingdomainUserObjRelInsertInput>;
  domainUserId?: InputMaybe<Scalars['uuid']['input']>;
  historyId?: InputMaybe<Scalars['Emailingnumeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idToken?: InputMaybe<Scalars['String']['input']>;
  linkedAddress?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  providerType?: InputMaybe<EmailingproviderTypeObjRelInsertInput>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  subscriptionExpiration?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  subscriptionFolders?: InputMaybe<Scalars['String']['input']>;
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EmailingproviderTypeEnum>;
  updatedAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type EmailingproviderAccountMaxFields = {
  __typename?: 'EmailingproviderAccountMaxFields';
  createdAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  domainUserId?: Maybe<Scalars['uuid']['output']>;
  historyId?: Maybe<Scalars['Emailingnumeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  idToken?: Maybe<Scalars['String']['output']>;
  linkedAddress?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  subscriptionExpiration?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  subscriptionFolders?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "email.provider_account" */
export type EmailingproviderAccountMaxOrderBy = {
  createdAt?: InputMaybe<EmailingOrderBy>;
  domainUserId?: InputMaybe<EmailingOrderBy>;
  historyId?: InputMaybe<EmailingOrderBy>;
  id?: InputMaybe<EmailingOrderBy>;
  idToken?: InputMaybe<EmailingOrderBy>;
  linkedAddress?: InputMaybe<EmailingOrderBy>;
  organizationId?: InputMaybe<EmailingOrderBy>;
  organizationUserId?: InputMaybe<EmailingOrderBy>;
  refreshToken?: InputMaybe<EmailingOrderBy>;
  subscriptionExpiration?: InputMaybe<EmailingOrderBy>;
  subscriptionFolders?: InputMaybe<EmailingOrderBy>;
  subscriptionId?: InputMaybe<EmailingOrderBy>;
  token?: InputMaybe<EmailingOrderBy>;
  updatedAt?: InputMaybe<EmailingOrderBy>;
  userId?: InputMaybe<EmailingOrderBy>;
};

/** aggregate min on columns */
export type EmailingproviderAccountMinFields = {
  __typename?: 'EmailingproviderAccountMinFields';
  createdAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  domainUserId?: Maybe<Scalars['uuid']['output']>;
  historyId?: Maybe<Scalars['Emailingnumeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  idToken?: Maybe<Scalars['String']['output']>;
  linkedAddress?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  subscriptionExpiration?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  subscriptionFolders?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Emailingtimestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "email.provider_account" */
export type EmailingproviderAccountMinOrderBy = {
  createdAt?: InputMaybe<EmailingOrderBy>;
  domainUserId?: InputMaybe<EmailingOrderBy>;
  historyId?: InputMaybe<EmailingOrderBy>;
  id?: InputMaybe<EmailingOrderBy>;
  idToken?: InputMaybe<EmailingOrderBy>;
  linkedAddress?: InputMaybe<EmailingOrderBy>;
  organizationId?: InputMaybe<EmailingOrderBy>;
  organizationUserId?: InputMaybe<EmailingOrderBy>;
  refreshToken?: InputMaybe<EmailingOrderBy>;
  subscriptionExpiration?: InputMaybe<EmailingOrderBy>;
  subscriptionFolders?: InputMaybe<EmailingOrderBy>;
  subscriptionId?: InputMaybe<EmailingOrderBy>;
  token?: InputMaybe<EmailingOrderBy>;
  updatedAt?: InputMaybe<EmailingOrderBy>;
  userId?: InputMaybe<EmailingOrderBy>;
};

/** response of any mutation on the table "email.provider_account" */
export type EmailingproviderAccountMutationResponse = {
  __typename?: 'EmailingproviderAccountMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EmailingproviderAccount>;
};

/** on_conflict condition type for table "email.provider_account" */
export type EmailingproviderAccountOnConflict = {
  constraint: EmailingproviderAccountConstraint;
  updateColumns?: Array<EmailingproviderAccountUpdateColumn>;
  where?: InputMaybe<EmailingproviderAccountBoolExp>;
};

/** Ordering options when selecting data from "email.provider_account". */
export type EmailingproviderAccountOrderBy = {
  accountSubscribersAggregate?: InputMaybe<EmailingEmailAccountSubscribersAggregateOrderBy>;
  createdAt?: InputMaybe<EmailingOrderBy>;
  domainOrganizationAggregate?: InputMaybe<EmailingdomainOrganizationAggregateOrderBy>;
  domainUser?: InputMaybe<EmailingdomainUserOrderBy>;
  domainUserId?: InputMaybe<EmailingOrderBy>;
  historyId?: InputMaybe<EmailingOrderBy>;
  id?: InputMaybe<EmailingOrderBy>;
  idToken?: InputMaybe<EmailingOrderBy>;
  linkedAddress?: InputMaybe<EmailingOrderBy>;
  organizationId?: InputMaybe<EmailingOrderBy>;
  organizationUserId?: InputMaybe<EmailingOrderBy>;
  providerType?: InputMaybe<EmailingproviderTypeOrderBy>;
  refreshToken?: InputMaybe<EmailingOrderBy>;
  subscriptionExpiration?: InputMaybe<EmailingOrderBy>;
  subscriptionFolders?: InputMaybe<EmailingOrderBy>;
  subscriptionId?: InputMaybe<EmailingOrderBy>;
  token?: InputMaybe<EmailingOrderBy>;
  type?: InputMaybe<EmailingOrderBy>;
  updatedAt?: InputMaybe<EmailingOrderBy>;
  userId?: InputMaybe<EmailingOrderBy>;
};

/** primary key columns input for table: email.provider_account */
export type EmailingproviderAccountPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "email.provider_account" */
export type EmailingproviderAccountSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'domainUserId'
  /** column name */
  | 'historyId'
  /** column name */
  | 'id'
  /** column name */
  | 'idToken'
  /** column name */
  | 'linkedAddress'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'refreshToken'
  /** column name */
  | 'subscriptionExpiration'
  /** column name */
  | 'subscriptionFolders'
  /** column name */
  | 'subscriptionId'
  /** column name */
  | 'token'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

/** input type for updating data in table "email.provider_account" */
export type EmailingproviderAccountSetInput = {
  createdAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  domainUserId?: InputMaybe<Scalars['uuid']['input']>;
  historyId?: InputMaybe<Scalars['Emailingnumeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idToken?: InputMaybe<Scalars['String']['input']>;
  linkedAddress?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  subscriptionExpiration?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  subscriptionFolders?: InputMaybe<Scalars['String']['input']>;
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EmailingproviderTypeEnum>;
  updatedAt?: InputMaybe<Scalars['Emailingtimestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type EmailingproviderAccountStddevFields = {
  __typename?: 'EmailingproviderAccountStddevFields';
  historyId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "email.provider_account" */
export type EmailingproviderAccountStddevOrderBy = {
  historyId?: InputMaybe<EmailingOrderBy>;
};

/** aggregate stddevPop on columns */
export type EmailingproviderAccountStddevPopFields = {
  __typename?: 'EmailingproviderAccountStddevPopFields';
  historyId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "email.provider_account" */
export type EmailingproviderAccountStddevPopOrderBy = {
  historyId?: InputMaybe<EmailingOrderBy>;
};

/** aggregate stddevSamp on columns */
export type EmailingproviderAccountStddevSampFields = {
  __typename?: 'EmailingproviderAccountStddevSampFields';
  historyId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "email.provider_account" */
export type EmailingproviderAccountStddevSampOrderBy = {
  historyId?: InputMaybe<EmailingOrderBy>;
};

/** aggregate sum on columns */
export type EmailingproviderAccountSumFields = {
  __typename?: 'EmailingproviderAccountSumFields';
  historyId?: Maybe<Scalars['Emailingnumeric']['output']>;
};

/** order by sum() on columns of table "email.provider_account" */
export type EmailingproviderAccountSumOrderBy = {
  historyId?: InputMaybe<EmailingOrderBy>;
};

/** update columns of table "email.provider_account" */
export type EmailingproviderAccountUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'domainUserId'
  /** column name */
  | 'historyId'
  /** column name */
  | 'id'
  /** column name */
  | 'idToken'
  /** column name */
  | 'linkedAddress'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'refreshToken'
  /** column name */
  | 'subscriptionExpiration'
  /** column name */
  | 'subscriptionFolders'
  /** column name */
  | 'subscriptionId'
  /** column name */
  | 'token'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

export type EmailingproviderAccountUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EmailingproviderAccountIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EmailingproviderAccountSetInput>;
  /** filter the rows which have to be updated */
  where: EmailingproviderAccountBoolExp;
};

/** aggregate varPop on columns */
export type EmailingproviderAccountVarPopFields = {
  __typename?: 'EmailingproviderAccountVarPopFields';
  historyId?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "email.provider_account" */
export type EmailingproviderAccountVarPopOrderBy = {
  historyId?: InputMaybe<EmailingOrderBy>;
};

/** aggregate varSamp on columns */
export type EmailingproviderAccountVarSampFields = {
  __typename?: 'EmailingproviderAccountVarSampFields';
  historyId?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "email.provider_account" */
export type EmailingproviderAccountVarSampOrderBy = {
  historyId?: InputMaybe<EmailingOrderBy>;
};

/** aggregate variance on columns */
export type EmailingproviderAccountVarianceFields = {
  __typename?: 'EmailingproviderAccountVarianceFields';
  historyId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "email.provider_account" */
export type EmailingproviderAccountVarianceOrderBy = {
  historyId?: InputMaybe<EmailingOrderBy>;
};

/** columns and relationships of "email.provider_type" */
export type EmailingproviderType = {
  __typename?: 'EmailingproviderType';
  description: Scalars['String']['output'];
  /** An array relationship */
  providerAccounts: Array<EmailingproviderAccount>;
  /** An aggregate relationship */
  providerAccountsAggregate: EmailingproviderAccountAggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "email.provider_type" */
export type EmailingproviderTypeproviderAccountsArgs = {
  distinctOn?: InputMaybe<Array<EmailingproviderAccountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingproviderAccountOrderBy>>;
  where?: InputMaybe<EmailingproviderAccountBoolExp>;
};


/** columns and relationships of "email.provider_type" */
export type EmailingproviderTypeproviderAccountsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EmailingproviderAccountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingproviderAccountOrderBy>>;
  where?: InputMaybe<EmailingproviderAccountBoolExp>;
};

/** aggregated selection of "email.provider_type" */
export type EmailingproviderTypeAggregate = {
  __typename?: 'EmailingproviderTypeAggregate';
  aggregate?: Maybe<EmailingproviderTypeAggregateFields>;
  nodes: Array<EmailingproviderType>;
};

/** aggregate fields of "email.provider_type" */
export type EmailingproviderTypeAggregateFields = {
  __typename?: 'EmailingproviderTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<EmailingproviderTypeMaxFields>;
  min?: Maybe<EmailingproviderTypeMinFields>;
};


/** aggregate fields of "email.provider_type" */
export type EmailingproviderTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<EmailingproviderTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "email.provider_type". All fields are combined with a logical 'AND'. */
export type EmailingproviderTypeBoolExp = {
  _and?: InputMaybe<Array<EmailingproviderTypeBoolExp>>;
  _not?: InputMaybe<EmailingproviderTypeBoolExp>;
  _or?: InputMaybe<Array<EmailingproviderTypeBoolExp>>;
  description?: InputMaybe<TaskStringComparisonExp>;
  providerAccounts?: InputMaybe<EmailingproviderAccountBoolExp>;
  providerAccountsAggregate?: InputMaybe<TelephonyproviderAccountAggregateBoolExp>;
  value?: InputMaybe<TaskStringComparisonExp>;
};

/** unique or primary key constraints on table "email.provider_type" */
export type EmailingproviderTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'provider_type_pkey'
  | '%future added value';

export type EmailingproviderTypeEnum =
  /** Gmail */
  | 'GMAIL'
  /** Microsoft */
  | 'MICROSOFT'
  | '%future added value';

/** input type for inserting data into table "email.provider_type" */
export type EmailingproviderTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  providerAccounts?: InputMaybe<EmailingproviderAccountArrRelInsertInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type EmailingproviderTypeMaxFields = {
  __typename?: 'EmailingproviderTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type EmailingproviderTypeMinFields = {
  __typename?: 'EmailingproviderTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "email.provider_type" */
export type EmailingproviderTypeMutationResponse = {
  __typename?: 'EmailingproviderTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EmailingproviderType>;
};

/** input type for inserting object relation for remote table "email.provider_type" */
export type EmailingproviderTypeObjRelInsertInput = {
  data: EmailingproviderTypeInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EmailingproviderTypeOnConflict>;
};

/** on_conflict condition type for table "email.provider_type" */
export type EmailingproviderTypeOnConflict = {
  constraint: EmailingproviderTypeConstraint;
  updateColumns?: Array<EmailingproviderTypeUpdateColumn>;
  where?: InputMaybe<EmailingproviderTypeBoolExp>;
};

/** Ordering options when selecting data from "email.provider_type". */
export type EmailingproviderTypeOrderBy = {
  description?: InputMaybe<EmailingOrderBy>;
  providerAccountsAggregate?: InputMaybe<EmailingproviderAccountAggregateOrderBy>;
  value?: InputMaybe<EmailingOrderBy>;
};

/** primary key columns input for table: email.provider_type */
export type EmailingproviderTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "email.provider_type" */
export type EmailingproviderTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "email.provider_type" */
export type EmailingproviderTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "providerType" */
export type EmailingproviderTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EmailingproviderTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<EmailingCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EmailingproviderTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "email.provider_type" */
export type EmailingproviderTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type EmailingproviderTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EmailingproviderTypeSetInput>;
  /** filter the rows which have to be updated */
  where: EmailingproviderTypeBoolExp;
};

export type EntryCategory =
  | 'COMPANY'
  | 'PERSON'
  | 'UNKNOWN'
  | '%future added value';

export type EntrySource =
  | 'COMBINED'
  | 'DB'
  | 'EIGHTEENEIGHTYONE'
  | 'FIS'
  | 'NONE'
  | 'TIMEOUT'
  | '%future added value';

export type File = {
  base64str: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type GateCustomParameters = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "address" */
export type GeodataAddress = {
  __typename?: 'GeodataAddress';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Geodatatimestamptz']['output'];
  id: Scalars['Geodatauuid']['output'];
  lat?: Maybe<Scalars['String']['output']>;
  long?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Geodatatimestamptz']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "address" */
export type GeodataAddressAggregate = {
  __typename?: 'GeodataAddressAggregate';
  aggregate?: Maybe<GeodataAddressAggregateFields>;
  nodes: Array<GeodataAddress>;
};

export type GeodataAddressAggregateBoolExp = {
  count?: InputMaybe<GeodataaddressAggregateBoolExpCount>;
};

/** aggregate fields of "address" */
export type GeodataAddressAggregateFields = {
  __typename?: 'GeodataAddressAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<GeodataAddressMaxFields>;
  min?: Maybe<GeodataAddressMinFields>;
};


/** aggregate fields of "address" */
export type GeodataAddressAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<GeodataAddressSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "address" */
export type GeodataAddressAggregateOrderBy = {
  count?: InputMaybe<GeodataOrderBy>;
  max?: InputMaybe<GeodataAddressMaxOrderBy>;
  min?: InputMaybe<GeodataAddressMinOrderBy>;
};

/** input type for inserting array relation for remote table "address" */
export type GeodataAddressArrRelInsertInput = {
  data: Array<GeodataAddressInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<GeodataAddressOnConflict>;
};

/** Boolean expression to filter rows from the table "address". All fields are combined with a logical 'AND'. */
export type GeodataAddressBoolExp = {
  _and?: InputMaybe<Array<GeodataAddressBoolExp>>;
  _not?: InputMaybe<GeodataAddressBoolExp>;
  _or?: InputMaybe<Array<GeodataAddressBoolExp>>;
  address?: InputMaybe<TaskStringComparisonExp>;
  city?: InputMaybe<TaskStringComparisonExp>;
  country?: InputMaybe<TaskStringComparisonExp>;
  createdAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  lat?: InputMaybe<TaskStringComparisonExp>;
  long?: InputMaybe<TaskStringComparisonExp>;
  number?: InputMaybe<TaskStringComparisonExp>;
  street?: InputMaybe<TaskStringComparisonExp>;
  updatedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  zip?: InputMaybe<TaskStringComparisonExp>;
};

/** unique or primary key constraints on table "address" */
export type GeodataAddressConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'address_pkey'
  | '%future added value';

/** input type for inserting data into table "address" */
export type GeodataAddressInsertInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Geodatatimestamptz']['input']>;
  id?: InputMaybe<Scalars['Geodatauuid']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  long?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Geodatatimestamptz']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type GeodataAddressMaxFields = {
  __typename?: 'GeodataAddressMaxFields';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Geodatatimestamptz']['output']>;
  id?: Maybe<Scalars['Geodatauuid']['output']>;
  lat?: Maybe<Scalars['String']['output']>;
  long?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Geodatatimestamptz']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "address" */
export type GeodataAddressMaxOrderBy = {
  address?: InputMaybe<GeodataOrderBy>;
  city?: InputMaybe<GeodataOrderBy>;
  country?: InputMaybe<GeodataOrderBy>;
  createdAt?: InputMaybe<GeodataOrderBy>;
  id?: InputMaybe<GeodataOrderBy>;
  lat?: InputMaybe<GeodataOrderBy>;
  long?: InputMaybe<GeodataOrderBy>;
  number?: InputMaybe<GeodataOrderBy>;
  street?: InputMaybe<GeodataOrderBy>;
  updatedAt?: InputMaybe<GeodataOrderBy>;
  zip?: InputMaybe<GeodataOrderBy>;
};

/** aggregate min on columns */
export type GeodataAddressMinFields = {
  __typename?: 'GeodataAddressMinFields';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Geodatatimestamptz']['output']>;
  id?: Maybe<Scalars['Geodatauuid']['output']>;
  lat?: Maybe<Scalars['String']['output']>;
  long?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Geodatatimestamptz']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "address" */
export type GeodataAddressMinOrderBy = {
  address?: InputMaybe<GeodataOrderBy>;
  city?: InputMaybe<GeodataOrderBy>;
  country?: InputMaybe<GeodataOrderBy>;
  createdAt?: InputMaybe<GeodataOrderBy>;
  id?: InputMaybe<GeodataOrderBy>;
  lat?: InputMaybe<GeodataOrderBy>;
  long?: InputMaybe<GeodataOrderBy>;
  number?: InputMaybe<GeodataOrderBy>;
  street?: InputMaybe<GeodataOrderBy>;
  updatedAt?: InputMaybe<GeodataOrderBy>;
  zip?: InputMaybe<GeodataOrderBy>;
};

/** response of any mutation on the table "address" */
export type GeodataAddressMutationResponse = {
  __typename?: 'GeodataAddressMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<GeodataAddress>;
};

/** on_conflict condition type for table "address" */
export type GeodataAddressOnConflict = {
  constraint: GeodataAddressConstraint;
  updateColumns?: Array<GeodataAddressUpdateColumn>;
  where?: InputMaybe<GeodataAddressBoolExp>;
};

/** Ordering options when selecting data from "address". */
export type GeodataAddressOrderBy = {
  address?: InputMaybe<GeodataOrderBy>;
  city?: InputMaybe<GeodataOrderBy>;
  country?: InputMaybe<GeodataOrderBy>;
  createdAt?: InputMaybe<GeodataOrderBy>;
  id?: InputMaybe<GeodataOrderBy>;
  lat?: InputMaybe<GeodataOrderBy>;
  long?: InputMaybe<GeodataOrderBy>;
  number?: InputMaybe<GeodataOrderBy>;
  street?: InputMaybe<GeodataOrderBy>;
  updatedAt?: InputMaybe<GeodataOrderBy>;
  zip?: InputMaybe<GeodataOrderBy>;
};

/** primary key columns input for table: address */
export type GeodataAddressPkColumnsInput = {
  id: Scalars['Geodatauuid']['input'];
};

/** select columns of table "address" */
export type GeodataAddressSelectColumn =
  /** column name */
  | 'address'
  /** column name */
  | 'city'
  /** column name */
  | 'country'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'lat'
  /** column name */
  | 'long'
  /** column name */
  | 'number'
  /** column name */
  | 'street'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'zip'
  | '%future added value';

/** input type for updating data in table "address" */
export type GeodataAddressSetInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Geodatatimestamptz']['input']>;
  id?: InputMaybe<Scalars['Geodatauuid']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  long?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Geodatatimestamptz']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "address" */
export type GeodataAddressStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GeodataAddressStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<GeodataCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GeodataAddressStreamCursorValueInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Geodatatimestamptz']['input']>;
  id?: InputMaybe<Scalars['Geodatauuid']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  long?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Geodatatimestamptz']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "address" */
export type GeodataAddressUpdateColumn =
  /** column name */
  | 'address'
  /** column name */
  | 'city'
  /** column name */
  | 'country'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'lat'
  /** column name */
  | 'long'
  /** column name */
  | 'number'
  /** column name */
  | 'street'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'zip'
  | '%future added value';

export type GeodataAddressUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GeodataAddressSetInput>;
  /** filter the rows which have to be updated */
  where: GeodataAddressBoolExp;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type GeodataBigintComparisonExp = {
  _eq?: InputMaybe<Scalars['Geodatabigint']['input']>;
  _gt?: InputMaybe<Scalars['Geodatabigint']['input']>;
  _gte?: InputMaybe<Scalars['Geodatabigint']['input']>;
  _in?: InputMaybe<Array<Scalars['Geodatabigint']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Geodatabigint']['input']>;
  _lte?: InputMaybe<Scalars['Geodatabigint']['input']>;
  _neq?: InputMaybe<Scalars['Geodatabigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['Geodatabigint']['input']>>;
};

/** ordering argument of a cursor */
export type GeodataCursorOrdering =
  /** ascending ordering of the cursor */
  | 'ASC'
  /** descending ordering of the cursor */
  | 'DESC'
  | '%future added value';

export type GeodataGeographyCastExp = {
  geometry?: InputMaybe<GeodataGeometryComparisonExp>;
};

/** Boolean expression to compare columns of type "geography". All fields are combined with logical 'AND'. */
export type GeodataGeographyComparisonExp = {
  _cast?: InputMaybe<GeodataGeographyCastExp>;
  _eq?: InputMaybe<Scalars['Geodatageography']['input']>;
  _gt?: InputMaybe<Scalars['Geodatageography']['input']>;
  _gte?: InputMaybe<Scalars['Geodatageography']['input']>;
  _in?: InputMaybe<Array<Scalars['Geodatageography']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Geodatageography']['input']>;
  _lte?: InputMaybe<Scalars['Geodatageography']['input']>;
  _neq?: InputMaybe<Scalars['Geodatageography']['input']>;
  _nin?: InputMaybe<Array<Scalars['Geodatageography']['input']>>;
  /** is the column within a given distance from the given geography value */
  _stDWithin?: InputMaybe<Geodatast_d_within_geography_input>;
  /** does the column spatially intersect the given geography value */
  _stIntersects?: InputMaybe<Scalars['Geodatageography']['input']>;
};

export type GeodataGeometryCastExp = {
  geography?: InputMaybe<GeodataGeographyComparisonExp>;
};

/** Boolean expression to compare columns of type "geometry". All fields are combined with logical 'AND'. */
export type GeodataGeometryComparisonExp = {
  _cast?: InputMaybe<GeodataGeometryCastExp>;
  _eq?: InputMaybe<Scalars['Geodatageometry']['input']>;
  _gt?: InputMaybe<Scalars['Geodatageometry']['input']>;
  _gte?: InputMaybe<Scalars['Geodatageometry']['input']>;
  _in?: InputMaybe<Array<Scalars['Geodatageometry']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Geodatageometry']['input']>;
  _lte?: InputMaybe<Scalars['Geodatageometry']['input']>;
  _neq?: InputMaybe<Scalars['Geodatageometry']['input']>;
  _nin?: InputMaybe<Array<Scalars['Geodatageometry']['input']>>;
  /** is the column within a given 3D distance from the given geometry value */
  _st3dDWithin?: InputMaybe<Geodatast_d_within_input>;
  /** does the column spatially intersect the given geometry value in 3D */
  _st3dIntersects?: InputMaybe<Scalars['Geodatageometry']['input']>;
  /** does the column contain the given geometry value */
  _stContains?: InputMaybe<Scalars['Geodatageometry']['input']>;
  /** does the column cross the given geometry value */
  _stCrosses?: InputMaybe<Scalars['Geodatageometry']['input']>;
  /** is the column within a given distance from the given geometry value */
  _stDWithin?: InputMaybe<Geodatast_d_within_input>;
  /** is the column equal to given geometry value (directionality is ignored) */
  _stEquals?: InputMaybe<Scalars['Geodatageometry']['input']>;
  /** does the column spatially intersect the given geometry value */
  _stIntersects?: InputMaybe<Scalars['Geodatageometry']['input']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _stOverlaps?: InputMaybe<Scalars['Geodatageometry']['input']>;
  /** does the column have atleast one point in common with the given geometry value */
  _stTouches?: InputMaybe<Scalars['Geodatageometry']['input']>;
  /** is the column contained in the given geometry value */
  _stWithin?: InputMaybe<Scalars['Geodatageometry']['input']>;
};

/** columns and relationships of "matrikkelenadresseleilighetsniva.adressetilleggsnavnkildekode" */
export type GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode';
  description?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "matrikkelenadresseleilighetsniva.adressetilleggsnavnkildekode" */
export type GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregate = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregate';
  aggregate?: Maybe<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregateFields>;
  nodes: Array<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode>;
};

/** aggregate fields of "matrikkelenadresseleilighetsniva.adressetilleggsnavnkildekode" */
export type GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregateFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMaxFields>;
  min?: Maybe<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMinFields>;
};


/** aggregate fields of "matrikkelenadresseleilighetsniva.adressetilleggsnavnkildekode" */
export type GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "matrikkelenadresseleilighetsniva.adressetilleggsnavnkildekode". All fields are combined with a logical 'AND'. */
export type GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeBoolExp = {
  _and?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeBoolExp>>;
  _not?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeBoolExp>;
  _or?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeBoolExp>>;
  description?: InputMaybe<TaskStringComparisonExp>;
  identifier?: InputMaybe<TaskStringComparisonExp>;
};

/** input type for inserting data into table "matrikkelenadresseleilighetsniva.adressetilleggsnavnkildekode" */
export type GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMaxFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMinFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "matrikkelenadresseleilighetsniva.adressetilleggsnavnkildekode" */
export type GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMutationResponse = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode>;
};

/** Ordering options when selecting data from "matrikkelenadresseleilighetsniva.adressetilleggsnavnkildekode". */
export type GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeOrderBy = {
  description?: InputMaybe<GeodataOrderBy>;
  identifier?: InputMaybe<GeodataOrderBy>;
};

/** select columns of table "matrikkelenadresseleilighetsniva.adressetilleggsnavnkildekode" */
export type GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'identifier'
  | '%future added value';

/** input type for updating data in table "matrikkelenadresseleilighetsniva.adressetilleggsnavnkildekode" */
export type GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "matrikkelenadresseleilighetsniva_adressetilleggsnavnkildekode" */
export type GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<GeodataCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
};

export type GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeSetInput>;
  /** filter the rows which have to be updated */
  where: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeBoolExp;
};

/** columns and relationships of "matrikkelenadresseleilighetsniva.atkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaAtkomst = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaAtkomst';
  adresseid?: Maybe<Scalars['Geodatabigint']['output']>;
  atkomstid?: Maybe<Scalars['Geodatabigint']['output']>;
  datauttaksdato?: Maybe<Scalars['Geodatatimestamptz']['output']>;
  navnerom?: Maybe<Scalars['String']['output']>;
  objid?: Maybe<Scalars['Int']['output']>;
  objtype?: Maybe<Scalars['String']['output']>;
  offisielladresseMatrikkeladressebruksenhetFk?: Maybe<Scalars['Geodatabigint']['output']>;
  offisielladresseVegadressebruksenhetFk?: Maybe<Scalars['Geodatabigint']['output']>;
  oppdateringsdato?: Maybe<Scalars['Geodatatimestamptz']['output']>;
  opphav?: Maybe<Scalars['String']['output']>;
  posisjon?: Maybe<Scalars['Geodatageometry']['output']>;
  typeatkomst?: Maybe<Scalars['String']['output']>;
  uuidadresse?: Maybe<Scalars['String']['output']>;
  uuidatkomst?: Maybe<Scalars['String']['output']>;
  versjonid?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "matrikkelenadresseleilighetsniva.atkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregate = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregate';
  aggregate?: Maybe<GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregateFields>;
  nodes: Array<GeodataMatrikkelenadresseleilighetsnivaAtkomst>;
};

/** aggregate fields of "matrikkelenadresseleilighetsniva.atkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregateFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregateFields';
  avg?: Maybe<GeodataMatrikkelenadresseleilighetsnivaAtkomstAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<GeodataMatrikkelenadresseleilighetsnivaAtkomstMaxFields>;
  min?: Maybe<GeodataMatrikkelenadresseleilighetsnivaAtkomstMinFields>;
  stddev?: Maybe<GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevFields>;
  stddevPop?: Maybe<GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevPopFields>;
  stddevSamp?: Maybe<GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevSampFields>;
  sum?: Maybe<GeodataMatrikkelenadresseleilighetsnivaAtkomstSumFields>;
  varPop?: Maybe<GeodataMatrikkelenadresseleilighetsnivaAtkomstVarPopFields>;
  varSamp?: Maybe<GeodataMatrikkelenadresseleilighetsnivaAtkomstVarSampFields>;
  variance?: Maybe<GeodataMatrikkelenadresseleilighetsnivaAtkomstVarianceFields>;
};


/** aggregate fields of "matrikkelenadresseleilighetsniva.atkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaAtkomstSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type GeodataMatrikkelenadresseleilighetsnivaAtkomstAvgFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaAtkomstAvgFields';
  adresseid?: Maybe<Scalars['Float']['output']>;
  atkomstid?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
  offisielladresseMatrikkeladressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
  offisielladresseVegadressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "matrikkelenadresseleilighetsniva.atkomst". All fields are combined with a logical 'AND'. */
export type GeodataMatrikkelenadresseleilighetsnivaAtkomstBoolExp = {
  _and?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaAtkomstBoolExp>>;
  _not?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaAtkomstBoolExp>;
  _or?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaAtkomstBoolExp>>;
  adresseid?: InputMaybe<GeodataBigintComparisonExp>;
  atkomstid?: InputMaybe<GeodataBigintComparisonExp>;
  datauttaksdato?: InputMaybe<TaskTimestamptzComparisonExp>;
  navnerom?: InputMaybe<TaskStringComparisonExp>;
  objid?: InputMaybe<TaskIntComparisonExp>;
  objtype?: InputMaybe<TaskStringComparisonExp>;
  offisielladresseMatrikkeladressebruksenhetFk?: InputMaybe<GeodataBigintComparisonExp>;
  offisielladresseVegadressebruksenhetFk?: InputMaybe<GeodataBigintComparisonExp>;
  oppdateringsdato?: InputMaybe<TaskTimestamptzComparisonExp>;
  opphav?: InputMaybe<TaskStringComparisonExp>;
  posisjon?: InputMaybe<GeodataGeometryComparisonExp>;
  typeatkomst?: InputMaybe<TaskStringComparisonExp>;
  uuidadresse?: InputMaybe<TaskStringComparisonExp>;
  uuidatkomst?: InputMaybe<TaskStringComparisonExp>;
  versjonid?: InputMaybe<TaskStringComparisonExp>;
};

/** input type for incrementing numeric columns in table "matrikkelenadresseleilighetsniva.atkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaAtkomstIncInput = {
  adresseid?: InputMaybe<Scalars['Geodatabigint']['input']>;
  atkomstid?: InputMaybe<Scalars['Geodatabigint']['input']>;
  objid?: InputMaybe<Scalars['Int']['input']>;
  offisielladresseMatrikkeladressebruksenhetFk?: InputMaybe<Scalars['Geodatabigint']['input']>;
  offisielladresseVegadressebruksenhetFk?: InputMaybe<Scalars['Geodatabigint']['input']>;
};

/** input type for inserting data into table "matrikkelenadresseleilighetsniva.atkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaAtkomstInsertInput = {
  adresseid?: InputMaybe<Scalars['Geodatabigint']['input']>;
  atkomstid?: InputMaybe<Scalars['Geodatabigint']['input']>;
  datauttaksdato?: InputMaybe<Scalars['Geodatatimestamptz']['input']>;
  navnerom?: InputMaybe<Scalars['String']['input']>;
  objid?: InputMaybe<Scalars['Int']['input']>;
  objtype?: InputMaybe<Scalars['String']['input']>;
  offisielladresseMatrikkeladressebruksenhetFk?: InputMaybe<Scalars['Geodatabigint']['input']>;
  offisielladresseVegadressebruksenhetFk?: InputMaybe<Scalars['Geodatabigint']['input']>;
  oppdateringsdato?: InputMaybe<Scalars['Geodatatimestamptz']['input']>;
  opphav?: InputMaybe<Scalars['String']['input']>;
  posisjon?: InputMaybe<Scalars['Geodatageometry']['input']>;
  typeatkomst?: InputMaybe<Scalars['String']['input']>;
  uuidadresse?: InputMaybe<Scalars['String']['input']>;
  uuidatkomst?: InputMaybe<Scalars['String']['input']>;
  versjonid?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type GeodataMatrikkelenadresseleilighetsnivaAtkomstMaxFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaAtkomstMaxFields';
  adresseid?: Maybe<Scalars['Geodatabigint']['output']>;
  atkomstid?: Maybe<Scalars['Geodatabigint']['output']>;
  datauttaksdato?: Maybe<Scalars['Geodatatimestamptz']['output']>;
  navnerom?: Maybe<Scalars['String']['output']>;
  objid?: Maybe<Scalars['Int']['output']>;
  objtype?: Maybe<Scalars['String']['output']>;
  offisielladresseMatrikkeladressebruksenhetFk?: Maybe<Scalars['Geodatabigint']['output']>;
  offisielladresseVegadressebruksenhetFk?: Maybe<Scalars['Geodatabigint']['output']>;
  oppdateringsdato?: Maybe<Scalars['Geodatatimestamptz']['output']>;
  opphav?: Maybe<Scalars['String']['output']>;
  typeatkomst?: Maybe<Scalars['String']['output']>;
  uuidadresse?: Maybe<Scalars['String']['output']>;
  uuidatkomst?: Maybe<Scalars['String']['output']>;
  versjonid?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type GeodataMatrikkelenadresseleilighetsnivaAtkomstMinFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaAtkomstMinFields';
  adresseid?: Maybe<Scalars['Geodatabigint']['output']>;
  atkomstid?: Maybe<Scalars['Geodatabigint']['output']>;
  datauttaksdato?: Maybe<Scalars['Geodatatimestamptz']['output']>;
  navnerom?: Maybe<Scalars['String']['output']>;
  objid?: Maybe<Scalars['Int']['output']>;
  objtype?: Maybe<Scalars['String']['output']>;
  offisielladresseMatrikkeladressebruksenhetFk?: Maybe<Scalars['Geodatabigint']['output']>;
  offisielladresseVegadressebruksenhetFk?: Maybe<Scalars['Geodatabigint']['output']>;
  oppdateringsdato?: Maybe<Scalars['Geodatatimestamptz']['output']>;
  opphav?: Maybe<Scalars['String']['output']>;
  typeatkomst?: Maybe<Scalars['String']['output']>;
  uuidadresse?: Maybe<Scalars['String']['output']>;
  uuidatkomst?: Maybe<Scalars['String']['output']>;
  versjonid?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "matrikkelenadresseleilighetsniva.atkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaAtkomstMutationResponse = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaAtkomstMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<GeodataMatrikkelenadresseleilighetsnivaAtkomst>;
};

/** Ordering options when selecting data from "matrikkelenadresseleilighetsniva.atkomst". */
export type GeodataMatrikkelenadresseleilighetsnivaAtkomstOrderBy = {
  adresseid?: InputMaybe<GeodataOrderBy>;
  atkomstid?: InputMaybe<GeodataOrderBy>;
  datauttaksdato?: InputMaybe<GeodataOrderBy>;
  navnerom?: InputMaybe<GeodataOrderBy>;
  objid?: InputMaybe<GeodataOrderBy>;
  objtype?: InputMaybe<GeodataOrderBy>;
  offisielladresseMatrikkeladressebruksenhetFk?: InputMaybe<GeodataOrderBy>;
  offisielladresseVegadressebruksenhetFk?: InputMaybe<GeodataOrderBy>;
  oppdateringsdato?: InputMaybe<GeodataOrderBy>;
  opphav?: InputMaybe<GeodataOrderBy>;
  posisjon?: InputMaybe<GeodataOrderBy>;
  typeatkomst?: InputMaybe<GeodataOrderBy>;
  uuidadresse?: InputMaybe<GeodataOrderBy>;
  uuidatkomst?: InputMaybe<GeodataOrderBy>;
  versjonid?: InputMaybe<GeodataOrderBy>;
};

/** select columns of table "matrikkelenadresseleilighetsniva.atkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaAtkomstSelectColumn =
  /** column name */
  | 'adresseid'
  /** column name */
  | 'atkomstid'
  /** column name */
  | 'datauttaksdato'
  /** column name */
  | 'navnerom'
  /** column name */
  | 'objid'
  /** column name */
  | 'objtype'
  /** column name */
  | 'offisielladresseMatrikkeladressebruksenhetFk'
  /** column name */
  | 'offisielladresseVegadressebruksenhetFk'
  /** column name */
  | 'oppdateringsdato'
  /** column name */
  | 'opphav'
  /** column name */
  | 'posisjon'
  /** column name */
  | 'typeatkomst'
  /** column name */
  | 'uuidadresse'
  /** column name */
  | 'uuidatkomst'
  /** column name */
  | 'versjonid'
  | '%future added value';

/** input type for updating data in table "matrikkelenadresseleilighetsniva.atkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaAtkomstSetInput = {
  adresseid?: InputMaybe<Scalars['Geodatabigint']['input']>;
  atkomstid?: InputMaybe<Scalars['Geodatabigint']['input']>;
  datauttaksdato?: InputMaybe<Scalars['Geodatatimestamptz']['input']>;
  navnerom?: InputMaybe<Scalars['String']['input']>;
  objid?: InputMaybe<Scalars['Int']['input']>;
  objtype?: InputMaybe<Scalars['String']['input']>;
  offisielladresseMatrikkeladressebruksenhetFk?: InputMaybe<Scalars['Geodatabigint']['input']>;
  offisielladresseVegadressebruksenhetFk?: InputMaybe<Scalars['Geodatabigint']['input']>;
  oppdateringsdato?: InputMaybe<Scalars['Geodatatimestamptz']['input']>;
  opphav?: InputMaybe<Scalars['String']['input']>;
  posisjon?: InputMaybe<Scalars['Geodatageometry']['input']>;
  typeatkomst?: InputMaybe<Scalars['String']['input']>;
  uuidadresse?: InputMaybe<Scalars['String']['input']>;
  uuidatkomst?: InputMaybe<Scalars['String']['input']>;
  versjonid?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevFields';
  adresseid?: Maybe<Scalars['Float']['output']>;
  atkomstid?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
  offisielladresseMatrikkeladressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
  offisielladresseVegadressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevPopFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevPopFields';
  adresseid?: Maybe<Scalars['Float']['output']>;
  atkomstid?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
  offisielladresseMatrikkeladressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
  offisielladresseVegadressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevSampFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevSampFields';
  adresseid?: Maybe<Scalars['Float']['output']>;
  atkomstid?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
  offisielladresseMatrikkeladressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
  offisielladresseVegadressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "matrikkelenadresseleilighetsniva_atkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaAtkomstStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GeodataMatrikkelenadresseleilighetsnivaAtkomstStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<GeodataCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GeodataMatrikkelenadresseleilighetsnivaAtkomstStreamCursorValueInput = {
  adresseid?: InputMaybe<Scalars['Geodatabigint']['input']>;
  atkomstid?: InputMaybe<Scalars['Geodatabigint']['input']>;
  datauttaksdato?: InputMaybe<Scalars['Geodatatimestamptz']['input']>;
  navnerom?: InputMaybe<Scalars['String']['input']>;
  objid?: InputMaybe<Scalars['Int']['input']>;
  objtype?: InputMaybe<Scalars['String']['input']>;
  offisielladresseMatrikkeladressebruksenhetFk?: InputMaybe<Scalars['Geodatabigint']['input']>;
  offisielladresseVegadressebruksenhetFk?: InputMaybe<Scalars['Geodatabigint']['input']>;
  oppdateringsdato?: InputMaybe<Scalars['Geodatatimestamptz']['input']>;
  opphav?: InputMaybe<Scalars['String']['input']>;
  posisjon?: InputMaybe<Scalars['Geodatageometry']['input']>;
  typeatkomst?: InputMaybe<Scalars['String']['input']>;
  uuidadresse?: InputMaybe<Scalars['String']['input']>;
  uuidatkomst?: InputMaybe<Scalars['String']['input']>;
  versjonid?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type GeodataMatrikkelenadresseleilighetsnivaAtkomstSumFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaAtkomstSumFields';
  adresseid?: Maybe<Scalars['Geodatabigint']['output']>;
  atkomstid?: Maybe<Scalars['Geodatabigint']['output']>;
  objid?: Maybe<Scalars['Int']['output']>;
  offisielladresseMatrikkeladressebruksenhetFk?: Maybe<Scalars['Geodatabigint']['output']>;
  offisielladresseVegadressebruksenhetFk?: Maybe<Scalars['Geodatabigint']['output']>;
};

export type GeodataMatrikkelenadresseleilighetsnivaAtkomstUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaAtkomstIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaAtkomstSetInput>;
  /** filter the rows which have to be updated */
  where: GeodataMatrikkelenadresseleilighetsnivaAtkomstBoolExp;
};

/** aggregate varPop on columns */
export type GeodataMatrikkelenadresseleilighetsnivaAtkomstVarPopFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaAtkomstVarPopFields';
  adresseid?: Maybe<Scalars['Float']['output']>;
  atkomstid?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
  offisielladresseMatrikkeladressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
  offisielladresseVegadressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type GeodataMatrikkelenadresseleilighetsnivaAtkomstVarSampFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaAtkomstVarSampFields';
  adresseid?: Maybe<Scalars['Float']['output']>;
  atkomstid?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
  offisielladresseMatrikkeladressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
  offisielladresseVegadressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type GeodataMatrikkelenadresseleilighetsnivaAtkomstVarianceFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaAtkomstVarianceFields';
  adresseid?: Maybe<Scalars['Float']['output']>;
  atkomstid?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
  offisielladresseMatrikkeladressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
  offisielladresseVegadressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "matrikkelenadresseleilighetsniva.kommunenummer" */
export type GeodataMatrikkelenadresseleilighetsnivaKommunenummer = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaKommunenummer';
  description?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "matrikkelenadresseleilighetsniva.kommunenummer" */
export type GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregate = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregate';
  aggregate?: Maybe<GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregateFields>;
  nodes: Array<GeodataMatrikkelenadresseleilighetsnivaKommunenummer>;
};

/** aggregate fields of "matrikkelenadresseleilighetsniva.kommunenummer" */
export type GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregateFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<GeodataMatrikkelenadresseleilighetsnivaKommunenummerMaxFields>;
  min?: Maybe<GeodataMatrikkelenadresseleilighetsnivaKommunenummerMinFields>;
};


/** aggregate fields of "matrikkelenadresseleilighetsniva.kommunenummer" */
export type GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaKommunenummerSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "matrikkelenadresseleilighetsniva.kommunenummer". All fields are combined with a logical 'AND'. */
export type GeodataMatrikkelenadresseleilighetsnivaKommunenummerBoolExp = {
  _and?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaKommunenummerBoolExp>>;
  _not?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaKommunenummerBoolExp>;
  _or?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaKommunenummerBoolExp>>;
  description?: InputMaybe<TaskStringComparisonExp>;
  identifier?: InputMaybe<TaskStringComparisonExp>;
};

/** input type for inserting data into table "matrikkelenadresseleilighetsniva.kommunenummer" */
export type GeodataMatrikkelenadresseleilighetsnivaKommunenummerInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type GeodataMatrikkelenadresseleilighetsnivaKommunenummerMaxFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaKommunenummerMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type GeodataMatrikkelenadresseleilighetsnivaKommunenummerMinFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaKommunenummerMinFields';
  description?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "matrikkelenadresseleilighetsniva.kommunenummer" */
export type GeodataMatrikkelenadresseleilighetsnivaKommunenummerMutationResponse = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaKommunenummerMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<GeodataMatrikkelenadresseleilighetsnivaKommunenummer>;
};

/** Ordering options when selecting data from "matrikkelenadresseleilighetsniva.kommunenummer". */
export type GeodataMatrikkelenadresseleilighetsnivaKommunenummerOrderBy = {
  description?: InputMaybe<GeodataOrderBy>;
  identifier?: InputMaybe<GeodataOrderBy>;
};

/** select columns of table "matrikkelenadresseleilighetsniva.kommunenummer" */
export type GeodataMatrikkelenadresseleilighetsnivaKommunenummerSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'identifier'
  | '%future added value';

/** input type for updating data in table "matrikkelenadresseleilighetsniva.kommunenummer" */
export type GeodataMatrikkelenadresseleilighetsnivaKommunenummerSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "matrikkelenadresseleilighetsniva_kommunenummer" */
export type GeodataMatrikkelenadresseleilighetsnivaKommunenummerStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GeodataMatrikkelenadresseleilighetsnivaKommunenummerStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<GeodataCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GeodataMatrikkelenadresseleilighetsnivaKommunenummerStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
};

export type GeodataMatrikkelenadresseleilighetsnivaKommunenummerUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaKommunenummerSetInput>;
  /** filter the rows which have to be updated */
  where: GeodataMatrikkelenadresseleilighetsnivaKommunenummerBoolExp;
};

/** columns and relationships of "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet';
  adresseid?: Maybe<Scalars['Geodatabigint']['output']>;
  adressetilleggsnavn?: Maybe<Scalars['String']['output']>;
  adressetilleggsnavnkilde?: Maybe<Scalars['String']['output']>;
  bruksenhetid?: Maybe<Scalars['String']['output']>;
  bruksenhetsnummertekst?: Maybe<Scalars['String']['output']>;
  datauttaksdato?: Maybe<Scalars['Geodatatimestamptz']['output']>;
  grunnkretsnavn?: Maybe<Scalars['String']['output']>;
  grunnkretsnummer?: Maybe<Scalars['String']['output']>;
  kommunenavn?: Maybe<Scalars['String']['output']>;
  kommunenummer?: Maybe<Scalars['String']['output']>;
  matrikkelnummerbruksenhetBruksnummer?: Maybe<Scalars['Int']['output']>;
  matrikkelnummerbruksenhetFestenummer?: Maybe<Scalars['Int']['output']>;
  matrikkelnummerbruksenhetGardsnummer?: Maybe<Scalars['Int']['output']>;
  matrikkelnummerbruksenhetKommunenummer?: Maybe<Scalars['String']['output']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Maybe<Scalars['Int']['output']>;
  navnerom?: Maybe<Scalars['String']['output']>;
  objid?: Maybe<Scalars['Int']['output']>;
  objtype?: Maybe<Scalars['String']['output']>;
  offisielladressetekst?: Maybe<Scalars['String']['output']>;
  offisielladressetekstutenadressetilleggsnavn?: Maybe<Scalars['String']['output']>;
  oppdateringsdato?: Maybe<Scalars['Geodatatimestamptz']['output']>;
  organisasjonsnummer?: Maybe<Scalars['Int']['output']>;
  postnummer?: Maybe<Scalars['String']['output']>;
  poststed?: Maybe<Scalars['String']['output']>;
  representasjonspunkt?: Maybe<Scalars['Geodatageometry']['output']>;
  soknenavn?: Maybe<Scalars['String']['output']>;
  soknenummer?: Maybe<Scalars['String']['output']>;
  stedfestingverifisert?: Maybe<Scalars['Boolean']['output']>;
  tettstednavn?: Maybe<Scalars['String']['output']>;
  tettstednummer?: Maybe<Scalars['String']['output']>;
  undernummer?: Maybe<Scalars['Int']['output']>;
  uuidadresse?: Maybe<Scalars['String']['output']>;
  uuidbruksenhet?: Maybe<Scalars['String']['output']>;
  valgkretsnavn?: Maybe<Scalars['String']['output']>;
  valgkretsnummer?: Maybe<Scalars['String']['output']>;
  versjonid?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregate = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregate';
  aggregate?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregateFields>;
  nodes: Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet>;
};

/** aggregate fields of "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregateFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregateFields';
  avg?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMaxFields>;
  min?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMinFields>;
  stddev?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevFields>;
  stddevPop?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevPopFields>;
  stddevSamp?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevSampFields>;
  sum?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetSumFields>;
  varPop?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarPopFields>;
  varSamp?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarSampFields>;
  variance?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarianceFields>;
};


/** aggregate fields of "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_atkomstid" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid';
  atkomstid?: Maybe<Scalars['Geodatabigint']['output']>;
  matrikkeladressebruksenhetFk?: Maybe<Scalars['Geodatabigint']['output']>;
  objid?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_atkomstid" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregate = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregate';
  aggregate?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregateFields>;
  nodes: Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid>;
};

/** aggregate fields of "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_atkomstid" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregateFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregateFields';
  avg?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMaxFields>;
  min?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMinFields>;
  stddev?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevFields>;
  stddevPop?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevPopFields>;
  stddevSamp?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevSampFields>;
  sum?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidSumFields>;
  varPop?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarPopFields>;
  varSamp?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarSampFields>;
  variance?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarianceFields>;
};


/** aggregate fields of "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_atkomstid" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAvgFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAvgFields';
  atkomstid?: Maybe<Scalars['Float']['output']>;
  matrikkeladressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_atkomstid". All fields are combined with a logical 'AND'. */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidBoolExp = {
  _and?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidBoolExp>>;
  _not?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidBoolExp>;
  _or?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidBoolExp>>;
  atkomstid?: InputMaybe<GeodataBigintComparisonExp>;
  matrikkeladressebruksenhetFk?: InputMaybe<GeodataBigintComparisonExp>;
  objid?: InputMaybe<TaskIntComparisonExp>;
};

/** input type for incrementing numeric columns in table "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_atkomstid" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidIncInput = {
  atkomstid?: InputMaybe<Scalars['Geodatabigint']['input']>;
  matrikkeladressebruksenhetFk?: InputMaybe<Scalars['Geodatabigint']['input']>;
  objid?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_atkomstid" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidInsertInput = {
  atkomstid?: InputMaybe<Scalars['Geodatabigint']['input']>;
  matrikkeladressebruksenhetFk?: InputMaybe<Scalars['Geodatabigint']['input']>;
  objid?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMaxFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMaxFields';
  atkomstid?: Maybe<Scalars['Geodatabigint']['output']>;
  matrikkeladressebruksenhetFk?: Maybe<Scalars['Geodatabigint']['output']>;
  objid?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMinFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMinFields';
  atkomstid?: Maybe<Scalars['Geodatabigint']['output']>;
  matrikkeladressebruksenhetFk?: Maybe<Scalars['Geodatabigint']['output']>;
  objid?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_atkomstid" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMutationResponse = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid>;
};

/** Ordering options when selecting data from "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_atkomstid". */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidOrderBy = {
  atkomstid?: InputMaybe<GeodataOrderBy>;
  matrikkeladressebruksenhetFk?: InputMaybe<GeodataOrderBy>;
  objid?: InputMaybe<GeodataOrderBy>;
};

/** select columns of table "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_atkomstid" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidSelectColumn =
  /** column name */
  | 'atkomstid'
  /** column name */
  | 'matrikkeladressebruksenhetFk'
  /** column name */
  | 'objid'
  | '%future added value';

/** input type for updating data in table "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_atkomstid" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidSetInput = {
  atkomstid?: InputMaybe<Scalars['Geodatabigint']['input']>;
  matrikkeladressebruksenhetFk?: InputMaybe<Scalars['Geodatabigint']['input']>;
  objid?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevFields';
  atkomstid?: Maybe<Scalars['Float']['output']>;
  matrikkeladressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevPopFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevPopFields';
  atkomstid?: Maybe<Scalars['Float']['output']>;
  matrikkeladressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevSampFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevSampFields';
  atkomstid?: Maybe<Scalars['Float']['output']>;
  matrikkeladressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "matrikkelenadresseleilighetsniva_matrikkeladressebruksenhet_atkomstid" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<GeodataCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStreamCursorValueInput = {
  atkomstid?: InputMaybe<Scalars['Geodatabigint']['input']>;
  matrikkeladressebruksenhetFk?: InputMaybe<Scalars['Geodatabigint']['input']>;
  objid?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidSumFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidSumFields';
  atkomstid?: Maybe<Scalars['Geodatabigint']['output']>;
  matrikkeladressebruksenhetFk?: Maybe<Scalars['Geodatabigint']['output']>;
  objid?: Maybe<Scalars['Int']['output']>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidSetInput>;
  /** filter the rows which have to be updated */
  where: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidBoolExp;
};

/** aggregate varPop on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarPopFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarPopFields';
  atkomstid?: Maybe<Scalars['Float']['output']>;
  matrikkeladressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarSampFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarSampFields';
  atkomstid?: Maybe<Scalars['Float']['output']>;
  matrikkeladressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarianceFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarianceFields';
  atkomstid?: Maybe<Scalars['Float']['output']>;
  matrikkeladressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate avg on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAvgFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAvgFields';
  adresseid?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetBruksnummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetFestenummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetGardsnummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
  organisasjonsnummer?: Maybe<Scalars['Float']['output']>;
  undernummer?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet". All fields are combined with a logical 'AND'. */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetBoolExp = {
  _and?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetBoolExp>>;
  _not?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetBoolExp>;
  _or?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetBoolExp>>;
  adresseid?: InputMaybe<GeodataBigintComparisonExp>;
  adressetilleggsnavn?: InputMaybe<TaskStringComparisonExp>;
  adressetilleggsnavnkilde?: InputMaybe<TaskStringComparisonExp>;
  bruksenhetid?: InputMaybe<TaskStringComparisonExp>;
  bruksenhetsnummertekst?: InputMaybe<TaskStringComparisonExp>;
  datauttaksdato?: InputMaybe<TaskTimestamptzComparisonExp>;
  grunnkretsnavn?: InputMaybe<TaskStringComparisonExp>;
  grunnkretsnummer?: InputMaybe<TaskStringComparisonExp>;
  kommunenavn?: InputMaybe<TaskStringComparisonExp>;
  kommunenummer?: InputMaybe<TaskStringComparisonExp>;
  matrikkelnummerbruksenhetBruksnummer?: InputMaybe<TaskIntComparisonExp>;
  matrikkelnummerbruksenhetFestenummer?: InputMaybe<TaskIntComparisonExp>;
  matrikkelnummerbruksenhetGardsnummer?: InputMaybe<TaskIntComparisonExp>;
  matrikkelnummerbruksenhetKommunenummer?: InputMaybe<TaskStringComparisonExp>;
  matrikkelnummerbruksenhetSeksjonsnummer?: InputMaybe<TaskIntComparisonExp>;
  navnerom?: InputMaybe<TaskStringComparisonExp>;
  objid?: InputMaybe<TaskIntComparisonExp>;
  objtype?: InputMaybe<TaskStringComparisonExp>;
  offisielladressetekst?: InputMaybe<TaskStringComparisonExp>;
  offisielladressetekstutenadressetilleggsnavn?: InputMaybe<TaskStringComparisonExp>;
  oppdateringsdato?: InputMaybe<TaskTimestamptzComparisonExp>;
  organisasjonsnummer?: InputMaybe<TaskIntComparisonExp>;
  postnummer?: InputMaybe<TaskStringComparisonExp>;
  poststed?: InputMaybe<TaskStringComparisonExp>;
  representasjonspunkt?: InputMaybe<GeodataGeometryComparisonExp>;
  soknenavn?: InputMaybe<TaskStringComparisonExp>;
  soknenummer?: InputMaybe<TaskStringComparisonExp>;
  stedfestingverifisert?: InputMaybe<TelephonyBooleanComparisonExp>;
  tettstednavn?: InputMaybe<TaskStringComparisonExp>;
  tettstednummer?: InputMaybe<TaskStringComparisonExp>;
  undernummer?: InputMaybe<TaskIntComparisonExp>;
  uuidadresse?: InputMaybe<TaskStringComparisonExp>;
  uuidbruksenhet?: InputMaybe<TaskStringComparisonExp>;
  valgkretsnavn?: InputMaybe<TaskStringComparisonExp>;
  valgkretsnummer?: InputMaybe<TaskStringComparisonExp>;
  versjonid?: InputMaybe<TaskStringComparisonExp>;
};

/** input type for incrementing numeric columns in table "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetIncInput = {
  adresseid?: InputMaybe<Scalars['Geodatabigint']['input']>;
  matrikkelnummerbruksenhetBruksnummer?: InputMaybe<Scalars['Int']['input']>;
  matrikkelnummerbruksenhetFestenummer?: InputMaybe<Scalars['Int']['input']>;
  matrikkelnummerbruksenhetGardsnummer?: InputMaybe<Scalars['Int']['input']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: InputMaybe<Scalars['Int']['input']>;
  objid?: InputMaybe<Scalars['Int']['input']>;
  organisasjonsnummer?: InputMaybe<Scalars['Int']['input']>;
  undernummer?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetInsertInput = {
  adresseid?: InputMaybe<Scalars['Geodatabigint']['input']>;
  adressetilleggsnavn?: InputMaybe<Scalars['String']['input']>;
  adressetilleggsnavnkilde?: InputMaybe<Scalars['String']['input']>;
  bruksenhetid?: InputMaybe<Scalars['String']['input']>;
  bruksenhetsnummertekst?: InputMaybe<Scalars['String']['input']>;
  datauttaksdato?: InputMaybe<Scalars['Geodatatimestamptz']['input']>;
  grunnkretsnavn?: InputMaybe<Scalars['String']['input']>;
  grunnkretsnummer?: InputMaybe<Scalars['String']['input']>;
  kommunenavn?: InputMaybe<Scalars['String']['input']>;
  kommunenummer?: InputMaybe<Scalars['String']['input']>;
  matrikkelnummerbruksenhetBruksnummer?: InputMaybe<Scalars['Int']['input']>;
  matrikkelnummerbruksenhetFestenummer?: InputMaybe<Scalars['Int']['input']>;
  matrikkelnummerbruksenhetGardsnummer?: InputMaybe<Scalars['Int']['input']>;
  matrikkelnummerbruksenhetKommunenummer?: InputMaybe<Scalars['String']['input']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: InputMaybe<Scalars['Int']['input']>;
  navnerom?: InputMaybe<Scalars['String']['input']>;
  objid?: InputMaybe<Scalars['Int']['input']>;
  objtype?: InputMaybe<Scalars['String']['input']>;
  offisielladressetekst?: InputMaybe<Scalars['String']['input']>;
  offisielladressetekstutenadressetilleggsnavn?: InputMaybe<Scalars['String']['input']>;
  oppdateringsdato?: InputMaybe<Scalars['Geodatatimestamptz']['input']>;
  organisasjonsnummer?: InputMaybe<Scalars['Int']['input']>;
  postnummer?: InputMaybe<Scalars['String']['input']>;
  poststed?: InputMaybe<Scalars['String']['input']>;
  representasjonspunkt?: InputMaybe<Scalars['Geodatageometry']['input']>;
  soknenavn?: InputMaybe<Scalars['String']['input']>;
  soknenummer?: InputMaybe<Scalars['String']['input']>;
  stedfestingverifisert?: InputMaybe<Scalars['Boolean']['input']>;
  tettstednavn?: InputMaybe<Scalars['String']['input']>;
  tettstednummer?: InputMaybe<Scalars['String']['input']>;
  undernummer?: InputMaybe<Scalars['Int']['input']>;
  uuidadresse?: InputMaybe<Scalars['String']['input']>;
  uuidbruksenhet?: InputMaybe<Scalars['String']['input']>;
  valgkretsnavn?: InputMaybe<Scalars['String']['input']>;
  valgkretsnummer?: InputMaybe<Scalars['String']['input']>;
  versjonid?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMaxFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMaxFields';
  adresseid?: Maybe<Scalars['Geodatabigint']['output']>;
  adressetilleggsnavn?: Maybe<Scalars['String']['output']>;
  adressetilleggsnavnkilde?: Maybe<Scalars['String']['output']>;
  bruksenhetid?: Maybe<Scalars['String']['output']>;
  bruksenhetsnummertekst?: Maybe<Scalars['String']['output']>;
  datauttaksdato?: Maybe<Scalars['Geodatatimestamptz']['output']>;
  grunnkretsnavn?: Maybe<Scalars['String']['output']>;
  grunnkretsnummer?: Maybe<Scalars['String']['output']>;
  kommunenavn?: Maybe<Scalars['String']['output']>;
  kommunenummer?: Maybe<Scalars['String']['output']>;
  matrikkelnummerbruksenhetBruksnummer?: Maybe<Scalars['Int']['output']>;
  matrikkelnummerbruksenhetFestenummer?: Maybe<Scalars['Int']['output']>;
  matrikkelnummerbruksenhetGardsnummer?: Maybe<Scalars['Int']['output']>;
  matrikkelnummerbruksenhetKommunenummer?: Maybe<Scalars['String']['output']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Maybe<Scalars['Int']['output']>;
  navnerom?: Maybe<Scalars['String']['output']>;
  objid?: Maybe<Scalars['Int']['output']>;
  objtype?: Maybe<Scalars['String']['output']>;
  offisielladressetekst?: Maybe<Scalars['String']['output']>;
  offisielladressetekstutenadressetilleggsnavn?: Maybe<Scalars['String']['output']>;
  oppdateringsdato?: Maybe<Scalars['Geodatatimestamptz']['output']>;
  organisasjonsnummer?: Maybe<Scalars['Int']['output']>;
  postnummer?: Maybe<Scalars['String']['output']>;
  poststed?: Maybe<Scalars['String']['output']>;
  soknenavn?: Maybe<Scalars['String']['output']>;
  soknenummer?: Maybe<Scalars['String']['output']>;
  tettstednavn?: Maybe<Scalars['String']['output']>;
  tettstednummer?: Maybe<Scalars['String']['output']>;
  undernummer?: Maybe<Scalars['Int']['output']>;
  uuidadresse?: Maybe<Scalars['String']['output']>;
  uuidbruksenhet?: Maybe<Scalars['String']['output']>;
  valgkretsnavn?: Maybe<Scalars['String']['output']>;
  valgkretsnummer?: Maybe<Scalars['String']['output']>;
  versjonid?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMinFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMinFields';
  adresseid?: Maybe<Scalars['Geodatabigint']['output']>;
  adressetilleggsnavn?: Maybe<Scalars['String']['output']>;
  adressetilleggsnavnkilde?: Maybe<Scalars['String']['output']>;
  bruksenhetid?: Maybe<Scalars['String']['output']>;
  bruksenhetsnummertekst?: Maybe<Scalars['String']['output']>;
  datauttaksdato?: Maybe<Scalars['Geodatatimestamptz']['output']>;
  grunnkretsnavn?: Maybe<Scalars['String']['output']>;
  grunnkretsnummer?: Maybe<Scalars['String']['output']>;
  kommunenavn?: Maybe<Scalars['String']['output']>;
  kommunenummer?: Maybe<Scalars['String']['output']>;
  matrikkelnummerbruksenhetBruksnummer?: Maybe<Scalars['Int']['output']>;
  matrikkelnummerbruksenhetFestenummer?: Maybe<Scalars['Int']['output']>;
  matrikkelnummerbruksenhetGardsnummer?: Maybe<Scalars['Int']['output']>;
  matrikkelnummerbruksenhetKommunenummer?: Maybe<Scalars['String']['output']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Maybe<Scalars['Int']['output']>;
  navnerom?: Maybe<Scalars['String']['output']>;
  objid?: Maybe<Scalars['Int']['output']>;
  objtype?: Maybe<Scalars['String']['output']>;
  offisielladressetekst?: Maybe<Scalars['String']['output']>;
  offisielladressetekstutenadressetilleggsnavn?: Maybe<Scalars['String']['output']>;
  oppdateringsdato?: Maybe<Scalars['Geodatatimestamptz']['output']>;
  organisasjonsnummer?: Maybe<Scalars['Int']['output']>;
  postnummer?: Maybe<Scalars['String']['output']>;
  poststed?: Maybe<Scalars['String']['output']>;
  soknenavn?: Maybe<Scalars['String']['output']>;
  soknenummer?: Maybe<Scalars['String']['output']>;
  tettstednavn?: Maybe<Scalars['String']['output']>;
  tettstednummer?: Maybe<Scalars['String']['output']>;
  undernummer?: Maybe<Scalars['Int']['output']>;
  uuidadresse?: Maybe<Scalars['String']['output']>;
  uuidbruksenhet?: Maybe<Scalars['String']['output']>;
  valgkretsnavn?: Maybe<Scalars['String']['output']>;
  valgkretsnummer?: Maybe<Scalars['String']['output']>;
  versjonid?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMutationResponse = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet>;
};

/** Ordering options when selecting data from "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet". */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetOrderBy = {
  adresseid?: InputMaybe<GeodataOrderBy>;
  adressetilleggsnavn?: InputMaybe<GeodataOrderBy>;
  adressetilleggsnavnkilde?: InputMaybe<GeodataOrderBy>;
  bruksenhetid?: InputMaybe<GeodataOrderBy>;
  bruksenhetsnummertekst?: InputMaybe<GeodataOrderBy>;
  datauttaksdato?: InputMaybe<GeodataOrderBy>;
  grunnkretsnavn?: InputMaybe<GeodataOrderBy>;
  grunnkretsnummer?: InputMaybe<GeodataOrderBy>;
  kommunenavn?: InputMaybe<GeodataOrderBy>;
  kommunenummer?: InputMaybe<GeodataOrderBy>;
  matrikkelnummerbruksenhetBruksnummer?: InputMaybe<GeodataOrderBy>;
  matrikkelnummerbruksenhetFestenummer?: InputMaybe<GeodataOrderBy>;
  matrikkelnummerbruksenhetGardsnummer?: InputMaybe<GeodataOrderBy>;
  matrikkelnummerbruksenhetKommunenummer?: InputMaybe<GeodataOrderBy>;
  matrikkelnummerbruksenhetSeksjonsnummer?: InputMaybe<GeodataOrderBy>;
  navnerom?: InputMaybe<GeodataOrderBy>;
  objid?: InputMaybe<GeodataOrderBy>;
  objtype?: InputMaybe<GeodataOrderBy>;
  offisielladressetekst?: InputMaybe<GeodataOrderBy>;
  offisielladressetekstutenadressetilleggsnavn?: InputMaybe<GeodataOrderBy>;
  oppdateringsdato?: InputMaybe<GeodataOrderBy>;
  organisasjonsnummer?: InputMaybe<GeodataOrderBy>;
  postnummer?: InputMaybe<GeodataOrderBy>;
  poststed?: InputMaybe<GeodataOrderBy>;
  representasjonspunkt?: InputMaybe<GeodataOrderBy>;
  soknenavn?: InputMaybe<GeodataOrderBy>;
  soknenummer?: InputMaybe<GeodataOrderBy>;
  stedfestingverifisert?: InputMaybe<GeodataOrderBy>;
  tettstednavn?: InputMaybe<GeodataOrderBy>;
  tettstednummer?: InputMaybe<GeodataOrderBy>;
  undernummer?: InputMaybe<GeodataOrderBy>;
  uuidadresse?: InputMaybe<GeodataOrderBy>;
  uuidbruksenhet?: InputMaybe<GeodataOrderBy>;
  valgkretsnavn?: InputMaybe<GeodataOrderBy>;
  valgkretsnummer?: InputMaybe<GeodataOrderBy>;
  versjonid?: InputMaybe<GeodataOrderBy>;
};

/** select columns of table "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetSelectColumn =
  /** column name */
  | 'adresseid'
  /** column name */
  | 'adressetilleggsnavn'
  /** column name */
  | 'adressetilleggsnavnkilde'
  /** column name */
  | 'bruksenhetid'
  /** column name */
  | 'bruksenhetsnummertekst'
  /** column name */
  | 'datauttaksdato'
  /** column name */
  | 'grunnkretsnavn'
  /** column name */
  | 'grunnkretsnummer'
  /** column name */
  | 'kommunenavn'
  /** column name */
  | 'kommunenummer'
  /** column name */
  | 'matrikkelnummerbruksenhetBruksnummer'
  /** column name */
  | 'matrikkelnummerbruksenhetFestenummer'
  /** column name */
  | 'matrikkelnummerbruksenhetGardsnummer'
  /** column name */
  | 'matrikkelnummerbruksenhetKommunenummer'
  /** column name */
  | 'matrikkelnummerbruksenhetSeksjonsnummer'
  /** column name */
  | 'navnerom'
  /** column name */
  | 'objid'
  /** column name */
  | 'objtype'
  /** column name */
  | 'offisielladressetekst'
  /** column name */
  | 'offisielladressetekstutenadressetilleggsnavn'
  /** column name */
  | 'oppdateringsdato'
  /** column name */
  | 'organisasjonsnummer'
  /** column name */
  | 'postnummer'
  /** column name */
  | 'poststed'
  /** column name */
  | 'representasjonspunkt'
  /** column name */
  | 'soknenavn'
  /** column name */
  | 'soknenummer'
  /** column name */
  | 'stedfestingverifisert'
  /** column name */
  | 'tettstednavn'
  /** column name */
  | 'tettstednummer'
  /** column name */
  | 'undernummer'
  /** column name */
  | 'uuidadresse'
  /** column name */
  | 'uuidbruksenhet'
  /** column name */
  | 'valgkretsnavn'
  /** column name */
  | 'valgkretsnummer'
  /** column name */
  | 'versjonid'
  | '%future added value';

/** input type for updating data in table "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetSetInput = {
  adresseid?: InputMaybe<Scalars['Geodatabigint']['input']>;
  adressetilleggsnavn?: InputMaybe<Scalars['String']['input']>;
  adressetilleggsnavnkilde?: InputMaybe<Scalars['String']['input']>;
  bruksenhetid?: InputMaybe<Scalars['String']['input']>;
  bruksenhetsnummertekst?: InputMaybe<Scalars['String']['input']>;
  datauttaksdato?: InputMaybe<Scalars['Geodatatimestamptz']['input']>;
  grunnkretsnavn?: InputMaybe<Scalars['String']['input']>;
  grunnkretsnummer?: InputMaybe<Scalars['String']['input']>;
  kommunenavn?: InputMaybe<Scalars['String']['input']>;
  kommunenummer?: InputMaybe<Scalars['String']['input']>;
  matrikkelnummerbruksenhetBruksnummer?: InputMaybe<Scalars['Int']['input']>;
  matrikkelnummerbruksenhetFestenummer?: InputMaybe<Scalars['Int']['input']>;
  matrikkelnummerbruksenhetGardsnummer?: InputMaybe<Scalars['Int']['input']>;
  matrikkelnummerbruksenhetKommunenummer?: InputMaybe<Scalars['String']['input']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: InputMaybe<Scalars['Int']['input']>;
  navnerom?: InputMaybe<Scalars['String']['input']>;
  objid?: InputMaybe<Scalars['Int']['input']>;
  objtype?: InputMaybe<Scalars['String']['input']>;
  offisielladressetekst?: InputMaybe<Scalars['String']['input']>;
  offisielladressetekstutenadressetilleggsnavn?: InputMaybe<Scalars['String']['input']>;
  oppdateringsdato?: InputMaybe<Scalars['Geodatatimestamptz']['input']>;
  organisasjonsnummer?: InputMaybe<Scalars['Int']['input']>;
  postnummer?: InputMaybe<Scalars['String']['input']>;
  poststed?: InputMaybe<Scalars['String']['input']>;
  representasjonspunkt?: InputMaybe<Scalars['Geodatageometry']['input']>;
  soknenavn?: InputMaybe<Scalars['String']['input']>;
  soknenummer?: InputMaybe<Scalars['String']['input']>;
  stedfestingverifisert?: InputMaybe<Scalars['Boolean']['input']>;
  tettstednavn?: InputMaybe<Scalars['String']['input']>;
  tettstednummer?: InputMaybe<Scalars['String']['input']>;
  undernummer?: InputMaybe<Scalars['Int']['input']>;
  uuidadresse?: InputMaybe<Scalars['String']['input']>;
  uuidbruksenhet?: InputMaybe<Scalars['String']['input']>;
  valgkretsnavn?: InputMaybe<Scalars['String']['input']>;
  valgkretsnummer?: InputMaybe<Scalars['String']['input']>;
  versjonid?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevFields';
  adresseid?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetBruksnummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetFestenummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetGardsnummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
  organisasjonsnummer?: Maybe<Scalars['Float']['output']>;
  undernummer?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevPopFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevPopFields';
  adresseid?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetBruksnummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetFestenummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetGardsnummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
  organisasjonsnummer?: Maybe<Scalars['Float']['output']>;
  undernummer?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevSampFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevSampFields';
  adresseid?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetBruksnummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetFestenummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetGardsnummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
  organisasjonsnummer?: Maybe<Scalars['Float']['output']>;
  undernummer?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "matrikkelenadresseleilighetsniva_matrikkeladressebruksenhet" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<GeodataCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStreamCursorValueInput = {
  adresseid?: InputMaybe<Scalars['Geodatabigint']['input']>;
  adressetilleggsnavn?: InputMaybe<Scalars['String']['input']>;
  adressetilleggsnavnkilde?: InputMaybe<Scalars['String']['input']>;
  bruksenhetid?: InputMaybe<Scalars['String']['input']>;
  bruksenhetsnummertekst?: InputMaybe<Scalars['String']['input']>;
  datauttaksdato?: InputMaybe<Scalars['Geodatatimestamptz']['input']>;
  grunnkretsnavn?: InputMaybe<Scalars['String']['input']>;
  grunnkretsnummer?: InputMaybe<Scalars['String']['input']>;
  kommunenavn?: InputMaybe<Scalars['String']['input']>;
  kommunenummer?: InputMaybe<Scalars['String']['input']>;
  matrikkelnummerbruksenhetBruksnummer?: InputMaybe<Scalars['Int']['input']>;
  matrikkelnummerbruksenhetFestenummer?: InputMaybe<Scalars['Int']['input']>;
  matrikkelnummerbruksenhetGardsnummer?: InputMaybe<Scalars['Int']['input']>;
  matrikkelnummerbruksenhetKommunenummer?: InputMaybe<Scalars['String']['input']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: InputMaybe<Scalars['Int']['input']>;
  navnerom?: InputMaybe<Scalars['String']['input']>;
  objid?: InputMaybe<Scalars['Int']['input']>;
  objtype?: InputMaybe<Scalars['String']['input']>;
  offisielladressetekst?: InputMaybe<Scalars['String']['input']>;
  offisielladressetekstutenadressetilleggsnavn?: InputMaybe<Scalars['String']['input']>;
  oppdateringsdato?: InputMaybe<Scalars['Geodatatimestamptz']['input']>;
  organisasjonsnummer?: InputMaybe<Scalars['Int']['input']>;
  postnummer?: InputMaybe<Scalars['String']['input']>;
  poststed?: InputMaybe<Scalars['String']['input']>;
  representasjonspunkt?: InputMaybe<Scalars['Geodatageometry']['input']>;
  soknenavn?: InputMaybe<Scalars['String']['input']>;
  soknenummer?: InputMaybe<Scalars['String']['input']>;
  stedfestingverifisert?: InputMaybe<Scalars['Boolean']['input']>;
  tettstednavn?: InputMaybe<Scalars['String']['input']>;
  tettstednummer?: InputMaybe<Scalars['String']['input']>;
  undernummer?: InputMaybe<Scalars['Int']['input']>;
  uuidadresse?: InputMaybe<Scalars['String']['input']>;
  uuidbruksenhet?: InputMaybe<Scalars['String']['input']>;
  valgkretsnavn?: InputMaybe<Scalars['String']['input']>;
  valgkretsnummer?: InputMaybe<Scalars['String']['input']>;
  versjonid?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetSumFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetSumFields';
  adresseid?: Maybe<Scalars['Geodatabigint']['output']>;
  matrikkelnummerbruksenhetBruksnummer?: Maybe<Scalars['Int']['output']>;
  matrikkelnummerbruksenhetFestenummer?: Maybe<Scalars['Int']['output']>;
  matrikkelnummerbruksenhetGardsnummer?: Maybe<Scalars['Int']['output']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Maybe<Scalars['Int']['output']>;
  objid?: Maybe<Scalars['Int']['output']>;
  organisasjonsnummer?: Maybe<Scalars['Int']['output']>;
  undernummer?: Maybe<Scalars['Int']['output']>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetSetInput>;
  /** filter the rows which have to be updated */
  where: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetBoolExp;
};

/** columns and relationships of "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_uuidatkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst';
  matrikkeladressebruksenhetFk?: Maybe<Scalars['Geodatabigint']['output']>;
  objid?: Maybe<Scalars['Int']['output']>;
  uuidatkomst?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_uuidatkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregate = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregate';
  aggregate?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregateFields>;
  nodes: Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst>;
};

/** aggregate fields of "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_uuidatkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregateFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregateFields';
  avg?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMaxFields>;
  min?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMinFields>;
  stddev?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevFields>;
  stddevPop?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevPopFields>;
  stddevSamp?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevSampFields>;
  sum?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstSumFields>;
  varPop?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarPopFields>;
  varSamp?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarSampFields>;
  variance?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarianceFields>;
};


/** aggregate fields of "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_uuidatkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAvgFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAvgFields';
  matrikkeladressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_uuidatkomst". All fields are combined with a logical 'AND'. */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstBoolExp = {
  _and?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstBoolExp>>;
  _not?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstBoolExp>;
  _or?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstBoolExp>>;
  matrikkeladressebruksenhetFk?: InputMaybe<GeodataBigintComparisonExp>;
  objid?: InputMaybe<TaskIntComparisonExp>;
  uuidatkomst?: InputMaybe<TaskStringComparisonExp>;
};

/** input type for incrementing numeric columns in table "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_uuidatkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstIncInput = {
  matrikkeladressebruksenhetFk?: InputMaybe<Scalars['Geodatabigint']['input']>;
  objid?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_uuidatkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstInsertInput = {
  matrikkeladressebruksenhetFk?: InputMaybe<Scalars['Geodatabigint']['input']>;
  objid?: InputMaybe<Scalars['Int']['input']>;
  uuidatkomst?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMaxFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMaxFields';
  matrikkeladressebruksenhetFk?: Maybe<Scalars['Geodatabigint']['output']>;
  objid?: Maybe<Scalars['Int']['output']>;
  uuidatkomst?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMinFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMinFields';
  matrikkeladressebruksenhetFk?: Maybe<Scalars['Geodatabigint']['output']>;
  objid?: Maybe<Scalars['Int']['output']>;
  uuidatkomst?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_uuidatkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMutationResponse = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst>;
};

/** Ordering options when selecting data from "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_uuidatkomst". */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstOrderBy = {
  matrikkeladressebruksenhetFk?: InputMaybe<GeodataOrderBy>;
  objid?: InputMaybe<GeodataOrderBy>;
  uuidatkomst?: InputMaybe<GeodataOrderBy>;
};

/** select columns of table "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_uuidatkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstSelectColumn =
  /** column name */
  | 'matrikkeladressebruksenhetFk'
  /** column name */
  | 'objid'
  /** column name */
  | 'uuidatkomst'
  | '%future added value';

/** input type for updating data in table "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_uuidatkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstSetInput = {
  matrikkeladressebruksenhetFk?: InputMaybe<Scalars['Geodatabigint']['input']>;
  objid?: InputMaybe<Scalars['Int']['input']>;
  uuidatkomst?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevFields';
  matrikkeladressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevPopFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevPopFields';
  matrikkeladressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevSampFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevSampFields';
  matrikkeladressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "matrikkelenadresseleilighetsniva_matrikkeladressebruksenhet_uuidatkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<GeodataCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStreamCursorValueInput = {
  matrikkeladressebruksenhetFk?: InputMaybe<Scalars['Geodatabigint']['input']>;
  objid?: InputMaybe<Scalars['Int']['input']>;
  uuidatkomst?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstSumFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstSumFields';
  matrikkeladressebruksenhetFk?: Maybe<Scalars['Geodatabigint']['output']>;
  objid?: Maybe<Scalars['Int']['output']>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstSetInput>;
  /** filter the rows which have to be updated */
  where: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstBoolExp;
};

/** aggregate varPop on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarPopFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarPopFields';
  matrikkeladressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarSampFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarSampFields';
  matrikkeladressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarianceFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarianceFields';
  matrikkeladressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varPop on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarPopFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarPopFields';
  adresseid?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetBruksnummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetFestenummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetGardsnummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
  organisasjonsnummer?: Maybe<Scalars['Float']['output']>;
  undernummer?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarSampFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarSampFields';
  adresseid?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetBruksnummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetFestenummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetGardsnummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
  organisasjonsnummer?: Maybe<Scalars['Float']['output']>;
  undernummer?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarianceFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarianceFields';
  adresseid?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetBruksnummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetFestenummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetGardsnummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
  organisasjonsnummer?: Maybe<Scalars['Float']['output']>;
  undernummer?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "matrikkelenadresseleilighetsniva.typeatkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaTypeatkomst = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaTypeatkomst';
  description?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "matrikkelenadresseleilighetsniva.typeatkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregate = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregate';
  aggregate?: Maybe<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregateFields>;
  nodes: Array<GeodataMatrikkelenadresseleilighetsnivaTypeatkomst>;
};

/** aggregate fields of "matrikkelenadresseleilighetsniva.typeatkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregateFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMaxFields>;
  min?: Maybe<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMinFields>;
};


/** aggregate fields of "matrikkelenadresseleilighetsniva.typeatkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "matrikkelenadresseleilighetsniva.typeatkomst". All fields are combined with a logical 'AND'. */
export type GeodataMatrikkelenadresseleilighetsnivaTypeatkomstBoolExp = {
  _and?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstBoolExp>>;
  _not?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstBoolExp>;
  _or?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstBoolExp>>;
  description?: InputMaybe<TaskStringComparisonExp>;
  identifier?: InputMaybe<TaskStringComparisonExp>;
};

/** input type for inserting data into table "matrikkelenadresseleilighetsniva.typeatkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaTypeatkomstInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMaxFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMinFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMinFields';
  description?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "matrikkelenadresseleilighetsniva.typeatkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMutationResponse = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<GeodataMatrikkelenadresseleilighetsnivaTypeatkomst>;
};

/** Ordering options when selecting data from "matrikkelenadresseleilighetsniva.typeatkomst". */
export type GeodataMatrikkelenadresseleilighetsnivaTypeatkomstOrderBy = {
  description?: InputMaybe<GeodataOrderBy>;
  identifier?: InputMaybe<GeodataOrderBy>;
};

/** select columns of table "matrikkelenadresseleilighetsniva.typeatkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaTypeatkomstSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'identifier'
  | '%future added value';

/** input type for updating data in table "matrikkelenadresseleilighetsniva.typeatkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaTypeatkomstSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "matrikkelenadresseleilighetsniva_typeatkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaTypeatkomstStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<GeodataCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GeodataMatrikkelenadresseleilighetsnivaTypeatkomstStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
};

export type GeodataMatrikkelenadresseleilighetsnivaTypeatkomstUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstSetInput>;
  /** filter the rows which have to be updated */
  where: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstBoolExp;
};

/** columns and relationships of "matrikkelenadresseleilighetsniva.vegadressebruksenhet" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhet = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhet';
  adresseid?: Maybe<Scalars['Geodatabigint']['output']>;
  adressekode?: Maybe<Scalars['Int']['output']>;
  adressenavn?: Maybe<Scalars['String']['output']>;
  adressetilleggsnavn?: Maybe<Scalars['String']['output']>;
  adressetilleggsnavnkilde?: Maybe<Scalars['String']['output']>;
  bokstav?: Maybe<Scalars['String']['output']>;
  bruksenhetid?: Maybe<Scalars['String']['output']>;
  bruksenhetsnummertekst?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  datauttaksdato?: Maybe<Scalars['Geodatatimestamptz']['output']>;
  grunnkretsnavn?: Maybe<Scalars['String']['output']>;
  grunnkretsnummer?: Maybe<Scalars['String']['output']>;
  kommunenavn?: Maybe<Scalars['String']['output']>;
  kommunenummer?: Maybe<Scalars['String']['output']>;
  matrikkelnummerbruksenhetBruksnummer?: Maybe<Scalars['Int']['output']>;
  matrikkelnummerbruksenhetFestenummer?: Maybe<Scalars['Int']['output']>;
  matrikkelnummerbruksenhetGardsnummer?: Maybe<Scalars['Int']['output']>;
  matrikkelnummerbruksenhetKommunenummer?: Maybe<Scalars['String']['output']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Maybe<Scalars['Int']['output']>;
  navnerom?: Maybe<Scalars['String']['output']>;
  nummer?: Maybe<Scalars['Int']['output']>;
  objid?: Maybe<Scalars['Int']['output']>;
  objtype?: Maybe<Scalars['String']['output']>;
  offisielladressetekst?: Maybe<Scalars['String']['output']>;
  offisielladressetekstutenadressetilleggsnavn?: Maybe<Scalars['String']['output']>;
  oppdateringsdato?: Maybe<Scalars['Geodatatimestamptz']['output']>;
  organisasjonsnummer?: Maybe<Scalars['Int']['output']>;
  postnummer?: Maybe<Scalars['String']['output']>;
  poststed?: Maybe<Scalars['String']['output']>;
  representasjonspunkt?: Maybe<Scalars['Geodatageometry']['output']>;
  soknenavn?: Maybe<Scalars['String']['output']>;
  soknenummer?: Maybe<Scalars['String']['output']>;
  stedfestingverifisert?: Maybe<Scalars['Boolean']['output']>;
  tettstednavn?: Maybe<Scalars['String']['output']>;
  tettstednummer?: Maybe<Scalars['String']['output']>;
  uuidadresse?: Maybe<Scalars['String']['output']>;
  uuidbruksenhet?: Maybe<Scalars['String']['output']>;
  valgkretsnavn?: Maybe<Scalars['String']['output']>;
  valgkretsnummer?: Maybe<Scalars['String']['output']>;
  versjonid?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "matrikkelenadresseleilighetsniva.vegadressebruksenhet" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregate = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregate';
  aggregate?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregateFields>;
  nodes: Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhet>;
};

/** aggregate fields of "matrikkelenadresseleilighetsniva.vegadressebruksenhet" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregateFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregateFields';
  avg?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMaxFields>;
  min?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMinFields>;
  stddev?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevFields>;
  stddevPop?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevPopFields>;
  stddevSamp?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevSampFields>;
  sum?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetSumFields>;
  varPop?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarPopFields>;
  varSamp?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarSampFields>;
  variance?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarianceFields>;
};


/** aggregate fields of "matrikkelenadresseleilighetsniva.vegadressebruksenhet" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "matrikkelenadresseleilighetsniva.vegadressebruksenhet_atkomstid" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid';
  atkomstid?: Maybe<Scalars['Geodatabigint']['output']>;
  objid?: Maybe<Scalars['Int']['output']>;
  vegadressebruksenhetFk?: Maybe<Scalars['Geodatabigint']['output']>;
};

/** aggregated selection of "matrikkelenadresseleilighetsniva.vegadressebruksenhet_atkomstid" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregate = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregate';
  aggregate?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregateFields>;
  nodes: Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid>;
};

/** aggregate fields of "matrikkelenadresseleilighetsniva.vegadressebruksenhet_atkomstid" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregateFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregateFields';
  avg?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMaxFields>;
  min?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMinFields>;
  stddev?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevFields>;
  stddevPop?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevPopFields>;
  stddevSamp?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevSampFields>;
  sum?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidSumFields>;
  varPop?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarPopFields>;
  varSamp?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarSampFields>;
  variance?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarianceFields>;
};


/** aggregate fields of "matrikkelenadresseleilighetsniva.vegadressebruksenhet_atkomstid" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAvgFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAvgFields';
  atkomstid?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
  vegadressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "matrikkelenadresseleilighetsniva.vegadressebruksenhet_atkomstid". All fields are combined with a logical 'AND'. */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidBoolExp = {
  _and?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidBoolExp>>;
  _not?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidBoolExp>;
  _or?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidBoolExp>>;
  atkomstid?: InputMaybe<GeodataBigintComparisonExp>;
  objid?: InputMaybe<TaskIntComparisonExp>;
  vegadressebruksenhetFk?: InputMaybe<GeodataBigintComparisonExp>;
};

/** input type for incrementing numeric columns in table "matrikkelenadresseleilighetsniva.vegadressebruksenhet_atkomstid" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidIncInput = {
  atkomstid?: InputMaybe<Scalars['Geodatabigint']['input']>;
  objid?: InputMaybe<Scalars['Int']['input']>;
  vegadressebruksenhetFk?: InputMaybe<Scalars['Geodatabigint']['input']>;
};

/** input type for inserting data into table "matrikkelenadresseleilighetsniva.vegadressebruksenhet_atkomstid" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidInsertInput = {
  atkomstid?: InputMaybe<Scalars['Geodatabigint']['input']>;
  objid?: InputMaybe<Scalars['Int']['input']>;
  vegadressebruksenhetFk?: InputMaybe<Scalars['Geodatabigint']['input']>;
};

/** aggregate max on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMaxFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMaxFields';
  atkomstid?: Maybe<Scalars['Geodatabigint']['output']>;
  objid?: Maybe<Scalars['Int']['output']>;
  vegadressebruksenhetFk?: Maybe<Scalars['Geodatabigint']['output']>;
};

/** aggregate min on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMinFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMinFields';
  atkomstid?: Maybe<Scalars['Geodatabigint']['output']>;
  objid?: Maybe<Scalars['Int']['output']>;
  vegadressebruksenhetFk?: Maybe<Scalars['Geodatabigint']['output']>;
};

/** response of any mutation on the table "matrikkelenadresseleilighetsniva.vegadressebruksenhet_atkomstid" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMutationResponse = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid>;
};

/** Ordering options when selecting data from "matrikkelenadresseleilighetsniva.vegadressebruksenhet_atkomstid". */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidOrderBy = {
  atkomstid?: InputMaybe<GeodataOrderBy>;
  objid?: InputMaybe<GeodataOrderBy>;
  vegadressebruksenhetFk?: InputMaybe<GeodataOrderBy>;
};

/** select columns of table "matrikkelenadresseleilighetsniva.vegadressebruksenhet_atkomstid" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidSelectColumn =
  /** column name */
  | 'atkomstid'
  /** column name */
  | 'objid'
  /** column name */
  | 'vegadressebruksenhetFk'
  | '%future added value';

/** input type for updating data in table "matrikkelenadresseleilighetsniva.vegadressebruksenhet_atkomstid" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidSetInput = {
  atkomstid?: InputMaybe<Scalars['Geodatabigint']['input']>;
  objid?: InputMaybe<Scalars['Int']['input']>;
  vegadressebruksenhetFk?: InputMaybe<Scalars['Geodatabigint']['input']>;
};

/** aggregate stddev on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevFields';
  atkomstid?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
  vegadressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevPopFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevPopFields';
  atkomstid?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
  vegadressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevSampFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevSampFields';
  atkomstid?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
  vegadressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "matrikkelenadresseleilighetsniva_vegadressebruksenhet_atkomstid" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<GeodataCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStreamCursorValueInput = {
  atkomstid?: InputMaybe<Scalars['Geodatabigint']['input']>;
  objid?: InputMaybe<Scalars['Int']['input']>;
  vegadressebruksenhetFk?: InputMaybe<Scalars['Geodatabigint']['input']>;
};

/** aggregate sum on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidSumFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidSumFields';
  atkomstid?: Maybe<Scalars['Geodatabigint']['output']>;
  objid?: Maybe<Scalars['Int']['output']>;
  vegadressebruksenhetFk?: Maybe<Scalars['Geodatabigint']['output']>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidSetInput>;
  /** filter the rows which have to be updated */
  where: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidBoolExp;
};

/** aggregate varPop on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarPopFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarPopFields';
  atkomstid?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
  vegadressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarSampFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarSampFields';
  atkomstid?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
  vegadressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarianceFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarianceFields';
  atkomstid?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
  vegadressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
};

/** aggregate avg on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAvgFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAvgFields';
  adresseid?: Maybe<Scalars['Float']['output']>;
  adressekode?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetBruksnummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetFestenummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetGardsnummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Maybe<Scalars['Float']['output']>;
  nummer?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
  organisasjonsnummer?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "matrikkelenadresseleilighetsniva.vegadressebruksenhet". All fields are combined with a logical 'AND'. */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetBoolExp = {
  _and?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetBoolExp>>;
  _not?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetBoolExp>;
  _or?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetBoolExp>>;
  adresseid?: InputMaybe<GeodataBigintComparisonExp>;
  adressekode?: InputMaybe<TaskIntComparisonExp>;
  adressenavn?: InputMaybe<TaskStringComparisonExp>;
  adressetilleggsnavn?: InputMaybe<TaskStringComparisonExp>;
  adressetilleggsnavnkilde?: InputMaybe<TaskStringComparisonExp>;
  bokstav?: InputMaybe<TaskStringComparisonExp>;
  bruksenhetid?: InputMaybe<TaskStringComparisonExp>;
  bruksenhetsnummertekst?: InputMaybe<TaskStringComparisonExp>;
  country?: InputMaybe<TaskStringComparisonExp>;
  datauttaksdato?: InputMaybe<TaskTimestamptzComparisonExp>;
  grunnkretsnavn?: InputMaybe<TaskStringComparisonExp>;
  grunnkretsnummer?: InputMaybe<TaskStringComparisonExp>;
  kommunenavn?: InputMaybe<TaskStringComparisonExp>;
  kommunenummer?: InputMaybe<TaskStringComparisonExp>;
  matrikkelnummerbruksenhetBruksnummer?: InputMaybe<TaskIntComparisonExp>;
  matrikkelnummerbruksenhetFestenummer?: InputMaybe<TaskIntComparisonExp>;
  matrikkelnummerbruksenhetGardsnummer?: InputMaybe<TaskIntComparisonExp>;
  matrikkelnummerbruksenhetKommunenummer?: InputMaybe<TaskStringComparisonExp>;
  matrikkelnummerbruksenhetSeksjonsnummer?: InputMaybe<TaskIntComparisonExp>;
  navnerom?: InputMaybe<TaskStringComparisonExp>;
  nummer?: InputMaybe<TaskIntComparisonExp>;
  objid?: InputMaybe<TaskIntComparisonExp>;
  objtype?: InputMaybe<TaskStringComparisonExp>;
  offisielladressetekst?: InputMaybe<TaskStringComparisonExp>;
  offisielladressetekstutenadressetilleggsnavn?: InputMaybe<TaskStringComparisonExp>;
  oppdateringsdato?: InputMaybe<TaskTimestamptzComparisonExp>;
  organisasjonsnummer?: InputMaybe<TaskIntComparisonExp>;
  postnummer?: InputMaybe<TaskStringComparisonExp>;
  poststed?: InputMaybe<TaskStringComparisonExp>;
  representasjonspunkt?: InputMaybe<GeodataGeometryComparisonExp>;
  soknenavn?: InputMaybe<TaskStringComparisonExp>;
  soknenummer?: InputMaybe<TaskStringComparisonExp>;
  stedfestingverifisert?: InputMaybe<TelephonyBooleanComparisonExp>;
  tettstednavn?: InputMaybe<TaskStringComparisonExp>;
  tettstednummer?: InputMaybe<TaskStringComparisonExp>;
  uuidadresse?: InputMaybe<TaskStringComparisonExp>;
  uuidbruksenhet?: InputMaybe<TaskStringComparisonExp>;
  valgkretsnavn?: InputMaybe<TaskStringComparisonExp>;
  valgkretsnummer?: InputMaybe<TaskStringComparisonExp>;
  versjonid?: InputMaybe<TaskStringComparisonExp>;
};

/** input type for incrementing numeric columns in table "matrikkelenadresseleilighetsniva.vegadressebruksenhet" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetIncInput = {
  adresseid?: InputMaybe<Scalars['Geodatabigint']['input']>;
  adressekode?: InputMaybe<Scalars['Int']['input']>;
  matrikkelnummerbruksenhetBruksnummer?: InputMaybe<Scalars['Int']['input']>;
  matrikkelnummerbruksenhetFestenummer?: InputMaybe<Scalars['Int']['input']>;
  matrikkelnummerbruksenhetGardsnummer?: InputMaybe<Scalars['Int']['input']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: InputMaybe<Scalars['Int']['input']>;
  nummer?: InputMaybe<Scalars['Int']['input']>;
  objid?: InputMaybe<Scalars['Int']['input']>;
  organisasjonsnummer?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "matrikkelenadresseleilighetsniva.vegadressebruksenhet" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetInsertInput = {
  adresseid?: InputMaybe<Scalars['Geodatabigint']['input']>;
  adressekode?: InputMaybe<Scalars['Int']['input']>;
  adressenavn?: InputMaybe<Scalars['String']['input']>;
  adressetilleggsnavn?: InputMaybe<Scalars['String']['input']>;
  adressetilleggsnavnkilde?: InputMaybe<Scalars['String']['input']>;
  bokstav?: InputMaybe<Scalars['String']['input']>;
  bruksenhetid?: InputMaybe<Scalars['String']['input']>;
  bruksenhetsnummertekst?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  datauttaksdato?: InputMaybe<Scalars['Geodatatimestamptz']['input']>;
  grunnkretsnavn?: InputMaybe<Scalars['String']['input']>;
  grunnkretsnummer?: InputMaybe<Scalars['String']['input']>;
  kommunenavn?: InputMaybe<Scalars['String']['input']>;
  kommunenummer?: InputMaybe<Scalars['String']['input']>;
  matrikkelnummerbruksenhetBruksnummer?: InputMaybe<Scalars['Int']['input']>;
  matrikkelnummerbruksenhetFestenummer?: InputMaybe<Scalars['Int']['input']>;
  matrikkelnummerbruksenhetGardsnummer?: InputMaybe<Scalars['Int']['input']>;
  matrikkelnummerbruksenhetKommunenummer?: InputMaybe<Scalars['String']['input']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: InputMaybe<Scalars['Int']['input']>;
  navnerom?: InputMaybe<Scalars['String']['input']>;
  nummer?: InputMaybe<Scalars['Int']['input']>;
  objid?: InputMaybe<Scalars['Int']['input']>;
  objtype?: InputMaybe<Scalars['String']['input']>;
  offisielladressetekst?: InputMaybe<Scalars['String']['input']>;
  offisielladressetekstutenadressetilleggsnavn?: InputMaybe<Scalars['String']['input']>;
  oppdateringsdato?: InputMaybe<Scalars['Geodatatimestamptz']['input']>;
  organisasjonsnummer?: InputMaybe<Scalars['Int']['input']>;
  postnummer?: InputMaybe<Scalars['String']['input']>;
  poststed?: InputMaybe<Scalars['String']['input']>;
  representasjonspunkt?: InputMaybe<Scalars['Geodatageometry']['input']>;
  soknenavn?: InputMaybe<Scalars['String']['input']>;
  soknenummer?: InputMaybe<Scalars['String']['input']>;
  stedfestingverifisert?: InputMaybe<Scalars['Boolean']['input']>;
  tettstednavn?: InputMaybe<Scalars['String']['input']>;
  tettstednummer?: InputMaybe<Scalars['String']['input']>;
  uuidadresse?: InputMaybe<Scalars['String']['input']>;
  uuidbruksenhet?: InputMaybe<Scalars['String']['input']>;
  valgkretsnavn?: InputMaybe<Scalars['String']['input']>;
  valgkretsnummer?: InputMaybe<Scalars['String']['input']>;
  versjonid?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMaxFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMaxFields';
  adresseid?: Maybe<Scalars['Geodatabigint']['output']>;
  adressekode?: Maybe<Scalars['Int']['output']>;
  adressenavn?: Maybe<Scalars['String']['output']>;
  adressetilleggsnavn?: Maybe<Scalars['String']['output']>;
  adressetilleggsnavnkilde?: Maybe<Scalars['String']['output']>;
  bokstav?: Maybe<Scalars['String']['output']>;
  bruksenhetid?: Maybe<Scalars['String']['output']>;
  bruksenhetsnummertekst?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  datauttaksdato?: Maybe<Scalars['Geodatatimestamptz']['output']>;
  grunnkretsnavn?: Maybe<Scalars['String']['output']>;
  grunnkretsnummer?: Maybe<Scalars['String']['output']>;
  kommunenavn?: Maybe<Scalars['String']['output']>;
  kommunenummer?: Maybe<Scalars['String']['output']>;
  matrikkelnummerbruksenhetBruksnummer?: Maybe<Scalars['Int']['output']>;
  matrikkelnummerbruksenhetFestenummer?: Maybe<Scalars['Int']['output']>;
  matrikkelnummerbruksenhetGardsnummer?: Maybe<Scalars['Int']['output']>;
  matrikkelnummerbruksenhetKommunenummer?: Maybe<Scalars['String']['output']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Maybe<Scalars['Int']['output']>;
  navnerom?: Maybe<Scalars['String']['output']>;
  nummer?: Maybe<Scalars['Int']['output']>;
  objid?: Maybe<Scalars['Int']['output']>;
  objtype?: Maybe<Scalars['String']['output']>;
  offisielladressetekst?: Maybe<Scalars['String']['output']>;
  offisielladressetekstutenadressetilleggsnavn?: Maybe<Scalars['String']['output']>;
  oppdateringsdato?: Maybe<Scalars['Geodatatimestamptz']['output']>;
  organisasjonsnummer?: Maybe<Scalars['Int']['output']>;
  postnummer?: Maybe<Scalars['String']['output']>;
  poststed?: Maybe<Scalars['String']['output']>;
  soknenavn?: Maybe<Scalars['String']['output']>;
  soknenummer?: Maybe<Scalars['String']['output']>;
  tettstednavn?: Maybe<Scalars['String']['output']>;
  tettstednummer?: Maybe<Scalars['String']['output']>;
  uuidadresse?: Maybe<Scalars['String']['output']>;
  uuidbruksenhet?: Maybe<Scalars['String']['output']>;
  valgkretsnavn?: Maybe<Scalars['String']['output']>;
  valgkretsnummer?: Maybe<Scalars['String']['output']>;
  versjonid?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMinFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMinFields';
  adresseid?: Maybe<Scalars['Geodatabigint']['output']>;
  adressekode?: Maybe<Scalars['Int']['output']>;
  adressenavn?: Maybe<Scalars['String']['output']>;
  adressetilleggsnavn?: Maybe<Scalars['String']['output']>;
  adressetilleggsnavnkilde?: Maybe<Scalars['String']['output']>;
  bokstav?: Maybe<Scalars['String']['output']>;
  bruksenhetid?: Maybe<Scalars['String']['output']>;
  bruksenhetsnummertekst?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  datauttaksdato?: Maybe<Scalars['Geodatatimestamptz']['output']>;
  grunnkretsnavn?: Maybe<Scalars['String']['output']>;
  grunnkretsnummer?: Maybe<Scalars['String']['output']>;
  kommunenavn?: Maybe<Scalars['String']['output']>;
  kommunenummer?: Maybe<Scalars['String']['output']>;
  matrikkelnummerbruksenhetBruksnummer?: Maybe<Scalars['Int']['output']>;
  matrikkelnummerbruksenhetFestenummer?: Maybe<Scalars['Int']['output']>;
  matrikkelnummerbruksenhetGardsnummer?: Maybe<Scalars['Int']['output']>;
  matrikkelnummerbruksenhetKommunenummer?: Maybe<Scalars['String']['output']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Maybe<Scalars['Int']['output']>;
  navnerom?: Maybe<Scalars['String']['output']>;
  nummer?: Maybe<Scalars['Int']['output']>;
  objid?: Maybe<Scalars['Int']['output']>;
  objtype?: Maybe<Scalars['String']['output']>;
  offisielladressetekst?: Maybe<Scalars['String']['output']>;
  offisielladressetekstutenadressetilleggsnavn?: Maybe<Scalars['String']['output']>;
  oppdateringsdato?: Maybe<Scalars['Geodatatimestamptz']['output']>;
  organisasjonsnummer?: Maybe<Scalars['Int']['output']>;
  postnummer?: Maybe<Scalars['String']['output']>;
  poststed?: Maybe<Scalars['String']['output']>;
  soknenavn?: Maybe<Scalars['String']['output']>;
  soknenummer?: Maybe<Scalars['String']['output']>;
  tettstednavn?: Maybe<Scalars['String']['output']>;
  tettstednummer?: Maybe<Scalars['String']['output']>;
  uuidadresse?: Maybe<Scalars['String']['output']>;
  uuidbruksenhet?: Maybe<Scalars['String']['output']>;
  valgkretsnavn?: Maybe<Scalars['String']['output']>;
  valgkretsnummer?: Maybe<Scalars['String']['output']>;
  versjonid?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "matrikkelenadresseleilighetsniva.vegadressebruksenhet" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMutationResponse = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhet>;
};

/** Ordering options when selecting data from "matrikkelenadresseleilighetsniva.vegadressebruksenhet". */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetOrderBy = {
  adresseid?: InputMaybe<GeodataOrderBy>;
  adressekode?: InputMaybe<GeodataOrderBy>;
  adressenavn?: InputMaybe<GeodataOrderBy>;
  adressetilleggsnavn?: InputMaybe<GeodataOrderBy>;
  adressetilleggsnavnkilde?: InputMaybe<GeodataOrderBy>;
  bokstav?: InputMaybe<GeodataOrderBy>;
  bruksenhetid?: InputMaybe<GeodataOrderBy>;
  bruksenhetsnummertekst?: InputMaybe<GeodataOrderBy>;
  country?: InputMaybe<GeodataOrderBy>;
  datauttaksdato?: InputMaybe<GeodataOrderBy>;
  grunnkretsnavn?: InputMaybe<GeodataOrderBy>;
  grunnkretsnummer?: InputMaybe<GeodataOrderBy>;
  kommunenavn?: InputMaybe<GeodataOrderBy>;
  kommunenummer?: InputMaybe<GeodataOrderBy>;
  matrikkelnummerbruksenhetBruksnummer?: InputMaybe<GeodataOrderBy>;
  matrikkelnummerbruksenhetFestenummer?: InputMaybe<GeodataOrderBy>;
  matrikkelnummerbruksenhetGardsnummer?: InputMaybe<GeodataOrderBy>;
  matrikkelnummerbruksenhetKommunenummer?: InputMaybe<GeodataOrderBy>;
  matrikkelnummerbruksenhetSeksjonsnummer?: InputMaybe<GeodataOrderBy>;
  navnerom?: InputMaybe<GeodataOrderBy>;
  nummer?: InputMaybe<GeodataOrderBy>;
  objid?: InputMaybe<GeodataOrderBy>;
  objtype?: InputMaybe<GeodataOrderBy>;
  offisielladressetekst?: InputMaybe<GeodataOrderBy>;
  offisielladressetekstutenadressetilleggsnavn?: InputMaybe<GeodataOrderBy>;
  oppdateringsdato?: InputMaybe<GeodataOrderBy>;
  organisasjonsnummer?: InputMaybe<GeodataOrderBy>;
  postnummer?: InputMaybe<GeodataOrderBy>;
  poststed?: InputMaybe<GeodataOrderBy>;
  representasjonspunkt?: InputMaybe<GeodataOrderBy>;
  soknenavn?: InputMaybe<GeodataOrderBy>;
  soknenummer?: InputMaybe<GeodataOrderBy>;
  stedfestingverifisert?: InputMaybe<GeodataOrderBy>;
  tettstednavn?: InputMaybe<GeodataOrderBy>;
  tettstednummer?: InputMaybe<GeodataOrderBy>;
  uuidadresse?: InputMaybe<GeodataOrderBy>;
  uuidbruksenhet?: InputMaybe<GeodataOrderBy>;
  valgkretsnavn?: InputMaybe<GeodataOrderBy>;
  valgkretsnummer?: InputMaybe<GeodataOrderBy>;
  versjonid?: InputMaybe<GeodataOrderBy>;
};

/** select columns of table "matrikkelenadresseleilighetsniva.vegadressebruksenhet" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetSelectColumn =
  /** column name */
  | 'adresseid'
  /** column name */
  | 'adressekode'
  /** column name */
  | 'adressenavn'
  /** column name */
  | 'adressetilleggsnavn'
  /** column name */
  | 'adressetilleggsnavnkilde'
  /** column name */
  | 'bokstav'
  /** column name */
  | 'bruksenhetid'
  /** column name */
  | 'bruksenhetsnummertekst'
  /** column name */
  | 'country'
  /** column name */
  | 'datauttaksdato'
  /** column name */
  | 'grunnkretsnavn'
  /** column name */
  | 'grunnkretsnummer'
  /** column name */
  | 'kommunenavn'
  /** column name */
  | 'kommunenummer'
  /** column name */
  | 'matrikkelnummerbruksenhetBruksnummer'
  /** column name */
  | 'matrikkelnummerbruksenhetFestenummer'
  /** column name */
  | 'matrikkelnummerbruksenhetGardsnummer'
  /** column name */
  | 'matrikkelnummerbruksenhetKommunenummer'
  /** column name */
  | 'matrikkelnummerbruksenhetSeksjonsnummer'
  /** column name */
  | 'navnerom'
  /** column name */
  | 'nummer'
  /** column name */
  | 'objid'
  /** column name */
  | 'objtype'
  /** column name */
  | 'offisielladressetekst'
  /** column name */
  | 'offisielladressetekstutenadressetilleggsnavn'
  /** column name */
  | 'oppdateringsdato'
  /** column name */
  | 'organisasjonsnummer'
  /** column name */
  | 'postnummer'
  /** column name */
  | 'poststed'
  /** column name */
  | 'representasjonspunkt'
  /** column name */
  | 'soknenavn'
  /** column name */
  | 'soknenummer'
  /** column name */
  | 'stedfestingverifisert'
  /** column name */
  | 'tettstednavn'
  /** column name */
  | 'tettstednummer'
  /** column name */
  | 'uuidadresse'
  /** column name */
  | 'uuidbruksenhet'
  /** column name */
  | 'valgkretsnavn'
  /** column name */
  | 'valgkretsnummer'
  /** column name */
  | 'versjonid'
  | '%future added value';

/** input type for updating data in table "matrikkelenadresseleilighetsniva.vegadressebruksenhet" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetSetInput = {
  adresseid?: InputMaybe<Scalars['Geodatabigint']['input']>;
  adressekode?: InputMaybe<Scalars['Int']['input']>;
  adressenavn?: InputMaybe<Scalars['String']['input']>;
  adressetilleggsnavn?: InputMaybe<Scalars['String']['input']>;
  adressetilleggsnavnkilde?: InputMaybe<Scalars['String']['input']>;
  bokstav?: InputMaybe<Scalars['String']['input']>;
  bruksenhetid?: InputMaybe<Scalars['String']['input']>;
  bruksenhetsnummertekst?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  datauttaksdato?: InputMaybe<Scalars['Geodatatimestamptz']['input']>;
  grunnkretsnavn?: InputMaybe<Scalars['String']['input']>;
  grunnkretsnummer?: InputMaybe<Scalars['String']['input']>;
  kommunenavn?: InputMaybe<Scalars['String']['input']>;
  kommunenummer?: InputMaybe<Scalars['String']['input']>;
  matrikkelnummerbruksenhetBruksnummer?: InputMaybe<Scalars['Int']['input']>;
  matrikkelnummerbruksenhetFestenummer?: InputMaybe<Scalars['Int']['input']>;
  matrikkelnummerbruksenhetGardsnummer?: InputMaybe<Scalars['Int']['input']>;
  matrikkelnummerbruksenhetKommunenummer?: InputMaybe<Scalars['String']['input']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: InputMaybe<Scalars['Int']['input']>;
  navnerom?: InputMaybe<Scalars['String']['input']>;
  nummer?: InputMaybe<Scalars['Int']['input']>;
  objid?: InputMaybe<Scalars['Int']['input']>;
  objtype?: InputMaybe<Scalars['String']['input']>;
  offisielladressetekst?: InputMaybe<Scalars['String']['input']>;
  offisielladressetekstutenadressetilleggsnavn?: InputMaybe<Scalars['String']['input']>;
  oppdateringsdato?: InputMaybe<Scalars['Geodatatimestamptz']['input']>;
  organisasjonsnummer?: InputMaybe<Scalars['Int']['input']>;
  postnummer?: InputMaybe<Scalars['String']['input']>;
  poststed?: InputMaybe<Scalars['String']['input']>;
  representasjonspunkt?: InputMaybe<Scalars['Geodatageometry']['input']>;
  soknenavn?: InputMaybe<Scalars['String']['input']>;
  soknenummer?: InputMaybe<Scalars['String']['input']>;
  stedfestingverifisert?: InputMaybe<Scalars['Boolean']['input']>;
  tettstednavn?: InputMaybe<Scalars['String']['input']>;
  tettstednummer?: InputMaybe<Scalars['String']['input']>;
  uuidadresse?: InputMaybe<Scalars['String']['input']>;
  uuidbruksenhet?: InputMaybe<Scalars['String']['input']>;
  valgkretsnavn?: InputMaybe<Scalars['String']['input']>;
  valgkretsnummer?: InputMaybe<Scalars['String']['input']>;
  versjonid?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevFields';
  adresseid?: Maybe<Scalars['Float']['output']>;
  adressekode?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetBruksnummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetFestenummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetGardsnummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Maybe<Scalars['Float']['output']>;
  nummer?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
  organisasjonsnummer?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevPopFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevPopFields';
  adresseid?: Maybe<Scalars['Float']['output']>;
  adressekode?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetBruksnummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetFestenummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetGardsnummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Maybe<Scalars['Float']['output']>;
  nummer?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
  organisasjonsnummer?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevSampFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevSampFields';
  adresseid?: Maybe<Scalars['Float']['output']>;
  adressekode?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetBruksnummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetFestenummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetGardsnummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Maybe<Scalars['Float']['output']>;
  nummer?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
  organisasjonsnummer?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "matrikkelenadresseleilighetsniva_vegadressebruksenhet" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<GeodataCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStreamCursorValueInput = {
  adresseid?: InputMaybe<Scalars['Geodatabigint']['input']>;
  adressekode?: InputMaybe<Scalars['Int']['input']>;
  adressenavn?: InputMaybe<Scalars['String']['input']>;
  adressetilleggsnavn?: InputMaybe<Scalars['String']['input']>;
  adressetilleggsnavnkilde?: InputMaybe<Scalars['String']['input']>;
  bokstav?: InputMaybe<Scalars['String']['input']>;
  bruksenhetid?: InputMaybe<Scalars['String']['input']>;
  bruksenhetsnummertekst?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  datauttaksdato?: InputMaybe<Scalars['Geodatatimestamptz']['input']>;
  grunnkretsnavn?: InputMaybe<Scalars['String']['input']>;
  grunnkretsnummer?: InputMaybe<Scalars['String']['input']>;
  kommunenavn?: InputMaybe<Scalars['String']['input']>;
  kommunenummer?: InputMaybe<Scalars['String']['input']>;
  matrikkelnummerbruksenhetBruksnummer?: InputMaybe<Scalars['Int']['input']>;
  matrikkelnummerbruksenhetFestenummer?: InputMaybe<Scalars['Int']['input']>;
  matrikkelnummerbruksenhetGardsnummer?: InputMaybe<Scalars['Int']['input']>;
  matrikkelnummerbruksenhetKommunenummer?: InputMaybe<Scalars['String']['input']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: InputMaybe<Scalars['Int']['input']>;
  navnerom?: InputMaybe<Scalars['String']['input']>;
  nummer?: InputMaybe<Scalars['Int']['input']>;
  objid?: InputMaybe<Scalars['Int']['input']>;
  objtype?: InputMaybe<Scalars['String']['input']>;
  offisielladressetekst?: InputMaybe<Scalars['String']['input']>;
  offisielladressetekstutenadressetilleggsnavn?: InputMaybe<Scalars['String']['input']>;
  oppdateringsdato?: InputMaybe<Scalars['Geodatatimestamptz']['input']>;
  organisasjonsnummer?: InputMaybe<Scalars['Int']['input']>;
  postnummer?: InputMaybe<Scalars['String']['input']>;
  poststed?: InputMaybe<Scalars['String']['input']>;
  representasjonspunkt?: InputMaybe<Scalars['Geodatageometry']['input']>;
  soknenavn?: InputMaybe<Scalars['String']['input']>;
  soknenummer?: InputMaybe<Scalars['String']['input']>;
  stedfestingverifisert?: InputMaybe<Scalars['Boolean']['input']>;
  tettstednavn?: InputMaybe<Scalars['String']['input']>;
  tettstednummer?: InputMaybe<Scalars['String']['input']>;
  uuidadresse?: InputMaybe<Scalars['String']['input']>;
  uuidbruksenhet?: InputMaybe<Scalars['String']['input']>;
  valgkretsnavn?: InputMaybe<Scalars['String']['input']>;
  valgkretsnummer?: InputMaybe<Scalars['String']['input']>;
  versjonid?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetSumFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetSumFields';
  adresseid?: Maybe<Scalars['Geodatabigint']['output']>;
  adressekode?: Maybe<Scalars['Int']['output']>;
  matrikkelnummerbruksenhetBruksnummer?: Maybe<Scalars['Int']['output']>;
  matrikkelnummerbruksenhetFestenummer?: Maybe<Scalars['Int']['output']>;
  matrikkelnummerbruksenhetGardsnummer?: Maybe<Scalars['Int']['output']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Maybe<Scalars['Int']['output']>;
  nummer?: Maybe<Scalars['Int']['output']>;
  objid?: Maybe<Scalars['Int']['output']>;
  organisasjonsnummer?: Maybe<Scalars['Int']['output']>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetSetInput>;
  /** filter the rows which have to be updated */
  where: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetBoolExp;
};

/** columns and relationships of "matrikkelenadresseleilighetsniva.vegadressebruksenhet_uuidatkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst';
  objid?: Maybe<Scalars['Int']['output']>;
  uuidatkomst?: Maybe<Scalars['String']['output']>;
  vegadressebruksenhetFk?: Maybe<Scalars['Geodatabigint']['output']>;
};

/** aggregated selection of "matrikkelenadresseleilighetsniva.vegadressebruksenhet_uuidatkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregate = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregate';
  aggregate?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregateFields>;
  nodes: Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst>;
};

/** aggregate fields of "matrikkelenadresseleilighetsniva.vegadressebruksenhet_uuidatkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregateFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregateFields';
  avg?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMaxFields>;
  min?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMinFields>;
  stddev?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevFields>;
  stddevPop?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevPopFields>;
  stddevSamp?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevSampFields>;
  sum?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstSumFields>;
  varPop?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarPopFields>;
  varSamp?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarSampFields>;
  variance?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarianceFields>;
};


/** aggregate fields of "matrikkelenadresseleilighetsniva.vegadressebruksenhet_uuidatkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAvgFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAvgFields';
  objid?: Maybe<Scalars['Float']['output']>;
  vegadressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "matrikkelenadresseleilighetsniva.vegadressebruksenhet_uuidatkomst". All fields are combined with a logical 'AND'. */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstBoolExp = {
  _and?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstBoolExp>>;
  _not?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstBoolExp>;
  _or?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstBoolExp>>;
  objid?: InputMaybe<TaskIntComparisonExp>;
  uuidatkomst?: InputMaybe<TaskStringComparisonExp>;
  vegadressebruksenhetFk?: InputMaybe<GeodataBigintComparisonExp>;
};

/** input type for incrementing numeric columns in table "matrikkelenadresseleilighetsniva.vegadressebruksenhet_uuidatkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstIncInput = {
  objid?: InputMaybe<Scalars['Int']['input']>;
  vegadressebruksenhetFk?: InputMaybe<Scalars['Geodatabigint']['input']>;
};

/** input type for inserting data into table "matrikkelenadresseleilighetsniva.vegadressebruksenhet_uuidatkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstInsertInput = {
  objid?: InputMaybe<Scalars['Int']['input']>;
  uuidatkomst?: InputMaybe<Scalars['String']['input']>;
  vegadressebruksenhetFk?: InputMaybe<Scalars['Geodatabigint']['input']>;
};

/** aggregate max on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMaxFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMaxFields';
  objid?: Maybe<Scalars['Int']['output']>;
  uuidatkomst?: Maybe<Scalars['String']['output']>;
  vegadressebruksenhetFk?: Maybe<Scalars['Geodatabigint']['output']>;
};

/** aggregate min on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMinFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMinFields';
  objid?: Maybe<Scalars['Int']['output']>;
  uuidatkomst?: Maybe<Scalars['String']['output']>;
  vegadressebruksenhetFk?: Maybe<Scalars['Geodatabigint']['output']>;
};

/** response of any mutation on the table "matrikkelenadresseleilighetsniva.vegadressebruksenhet_uuidatkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMutationResponse = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst>;
};

/** Ordering options when selecting data from "matrikkelenadresseleilighetsniva.vegadressebruksenhet_uuidatkomst". */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstOrderBy = {
  objid?: InputMaybe<GeodataOrderBy>;
  uuidatkomst?: InputMaybe<GeodataOrderBy>;
  vegadressebruksenhetFk?: InputMaybe<GeodataOrderBy>;
};

/** select columns of table "matrikkelenadresseleilighetsniva.vegadressebruksenhet_uuidatkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstSelectColumn =
  /** column name */
  | 'objid'
  /** column name */
  | 'uuidatkomst'
  /** column name */
  | 'vegadressebruksenhetFk'
  | '%future added value';

/** input type for updating data in table "matrikkelenadresseleilighetsniva.vegadressebruksenhet_uuidatkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstSetInput = {
  objid?: InputMaybe<Scalars['Int']['input']>;
  uuidatkomst?: InputMaybe<Scalars['String']['input']>;
  vegadressebruksenhetFk?: InputMaybe<Scalars['Geodatabigint']['input']>;
};

/** aggregate stddev on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevFields';
  objid?: Maybe<Scalars['Float']['output']>;
  vegadressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevPopFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevPopFields';
  objid?: Maybe<Scalars['Float']['output']>;
  vegadressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevSampFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevSampFields';
  objid?: Maybe<Scalars['Float']['output']>;
  vegadressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "matrikkelenadresseleilighetsniva_vegadressebruksenhet_uuidatkomst" */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<GeodataCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStreamCursorValueInput = {
  objid?: InputMaybe<Scalars['Int']['input']>;
  uuidatkomst?: InputMaybe<Scalars['String']['input']>;
  vegadressebruksenhetFk?: InputMaybe<Scalars['Geodatabigint']['input']>;
};

/** aggregate sum on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstSumFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstSumFields';
  objid?: Maybe<Scalars['Int']['output']>;
  vegadressebruksenhetFk?: Maybe<Scalars['Geodatabigint']['output']>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstSetInput>;
  /** filter the rows which have to be updated */
  where: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstBoolExp;
};

/** aggregate varPop on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarPopFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarPopFields';
  objid?: Maybe<Scalars['Float']['output']>;
  vegadressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarSampFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarSampFields';
  objid?: Maybe<Scalars['Float']['output']>;
  vegadressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarianceFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarianceFields';
  objid?: Maybe<Scalars['Float']['output']>;
  vegadressebruksenhetFk?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varPop on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarPopFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarPopFields';
  adresseid?: Maybe<Scalars['Float']['output']>;
  adressekode?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetBruksnummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetFestenummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetGardsnummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Maybe<Scalars['Float']['output']>;
  nummer?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
  organisasjonsnummer?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarSampFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarSampFields';
  adresseid?: Maybe<Scalars['Float']['output']>;
  adressekode?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetBruksnummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetFestenummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetGardsnummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Maybe<Scalars['Float']['output']>;
  nummer?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
  organisasjonsnummer?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarianceFields = {
  __typename?: 'GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarianceFields';
  adresseid?: Maybe<Scalars['Float']['output']>;
  adressekode?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetBruksnummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetFestenummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetGardsnummer?: Maybe<Scalars['Float']['output']>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Maybe<Scalars['Float']['output']>;
  nummer?: Maybe<Scalars['Float']['output']>;
  objid?: Maybe<Scalars['Float']['output']>;
  organisasjonsnummer?: Maybe<Scalars['Float']['output']>;
};

/** column ordering options */
export type GeodataOrderBy =
  /** in ascending order, nulls last */
  | 'ASC'
  /** in ascending order, nulls first */
  | 'ASC_NULLS_FIRST'
  /** in ascending order, nulls last */
  | 'ASC_NULLS_LAST'
  /** in descending order, nulls first */
  | 'DESC'
  /** in descending order, nulls first */
  | 'DESC_NULLS_FIRST'
  /** in descending order, nulls last */
  | 'DESC_NULLS_LAST'
  | '%future added value';

/** columns and relationships of "spatial_ref_sys" */
export type GeodataSpatialRefSys = {
  __typename?: 'GeodataSpatialRefSys';
  authName?: Maybe<Scalars['String']['output']>;
  authSrid?: Maybe<Scalars['Int']['output']>;
  proj4text?: Maybe<Scalars['String']['output']>;
  srid: Scalars['Int']['output'];
  srtext?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "spatial_ref_sys" */
export type GeodataSpatialRefSysAggregate = {
  __typename?: 'GeodataSpatialRefSysAggregate';
  aggregate?: Maybe<GeodataSpatialRefSysAggregateFields>;
  nodes: Array<GeodataSpatialRefSys>;
};

/** aggregate fields of "spatial_ref_sys" */
export type GeodataSpatialRefSysAggregateFields = {
  __typename?: 'GeodataSpatialRefSysAggregateFields';
  avg?: Maybe<GeodataSpatialRefSysAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<GeodataSpatialRefSysMaxFields>;
  min?: Maybe<GeodataSpatialRefSysMinFields>;
  stddev?: Maybe<GeodataSpatialRefSysStddevFields>;
  stddevPop?: Maybe<GeodataSpatialRefSysStddevPopFields>;
  stddevSamp?: Maybe<GeodataSpatialRefSysStddevSampFields>;
  sum?: Maybe<GeodataSpatialRefSysSumFields>;
  varPop?: Maybe<GeodataSpatialRefSysVarPopFields>;
  varSamp?: Maybe<GeodataSpatialRefSysVarSampFields>;
  variance?: Maybe<GeodataSpatialRefSysVarianceFields>;
};


/** aggregate fields of "spatial_ref_sys" */
export type GeodataSpatialRefSysAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<GeodataSpatialRefSysSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type GeodataSpatialRefSysAvgFields = {
  __typename?: 'GeodataSpatialRefSysAvgFields';
  authSrid?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "spatial_ref_sys". All fields are combined with a logical 'AND'. */
export type GeodataSpatialRefSysBoolExp = {
  _and?: InputMaybe<Array<GeodataSpatialRefSysBoolExp>>;
  _not?: InputMaybe<GeodataSpatialRefSysBoolExp>;
  _or?: InputMaybe<Array<GeodataSpatialRefSysBoolExp>>;
  authName?: InputMaybe<TaskStringComparisonExp>;
  authSrid?: InputMaybe<TaskIntComparisonExp>;
  proj4text?: InputMaybe<TaskStringComparisonExp>;
  srid?: InputMaybe<TaskIntComparisonExp>;
  srtext?: InputMaybe<TaskStringComparisonExp>;
};

/** unique or primary key constraints on table "spatial_ref_sys" */
export type GeodataSpatialRefSysConstraint =
  /** unique or primary key constraint on columns "srid" */
  | 'spatial_ref_sys_pkey'
  | '%future added value';

/** input type for incrementing numeric columns in table "spatial_ref_sys" */
export type GeodataSpatialRefSysIncInput = {
  authSrid?: InputMaybe<Scalars['Int']['input']>;
  srid?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "spatial_ref_sys" */
export type GeodataSpatialRefSysInsertInput = {
  authName?: InputMaybe<Scalars['String']['input']>;
  authSrid?: InputMaybe<Scalars['Int']['input']>;
  proj4text?: InputMaybe<Scalars['String']['input']>;
  srid?: InputMaybe<Scalars['Int']['input']>;
  srtext?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type GeodataSpatialRefSysMaxFields = {
  __typename?: 'GeodataSpatialRefSysMaxFields';
  authName?: Maybe<Scalars['String']['output']>;
  authSrid?: Maybe<Scalars['Int']['output']>;
  proj4text?: Maybe<Scalars['String']['output']>;
  srid?: Maybe<Scalars['Int']['output']>;
  srtext?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type GeodataSpatialRefSysMinFields = {
  __typename?: 'GeodataSpatialRefSysMinFields';
  authName?: Maybe<Scalars['String']['output']>;
  authSrid?: Maybe<Scalars['Int']['output']>;
  proj4text?: Maybe<Scalars['String']['output']>;
  srid?: Maybe<Scalars['Int']['output']>;
  srtext?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "spatial_ref_sys" */
export type GeodataSpatialRefSysMutationResponse = {
  __typename?: 'GeodataSpatialRefSysMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<GeodataSpatialRefSys>;
};

/** on_conflict condition type for table "spatial_ref_sys" */
export type GeodataSpatialRefSysOnConflict = {
  constraint: GeodataSpatialRefSysConstraint;
  updateColumns?: Array<GeodataSpatialRefSysUpdateColumn>;
  where?: InputMaybe<GeodataSpatialRefSysBoolExp>;
};

/** Ordering options when selecting data from "spatial_ref_sys". */
export type GeodataSpatialRefSysOrderBy = {
  authName?: InputMaybe<GeodataOrderBy>;
  authSrid?: InputMaybe<GeodataOrderBy>;
  proj4text?: InputMaybe<GeodataOrderBy>;
  srid?: InputMaybe<GeodataOrderBy>;
  srtext?: InputMaybe<GeodataOrderBy>;
};

/** primary key columns input for table: spatial_ref_sys */
export type GeodataSpatialRefSysPkColumnsInput = {
  srid: Scalars['Int']['input'];
};

/** select columns of table "spatial_ref_sys" */
export type GeodataSpatialRefSysSelectColumn =
  /** column name */
  | 'authName'
  /** column name */
  | 'authSrid'
  /** column name */
  | 'proj4text'
  /** column name */
  | 'srid'
  /** column name */
  | 'srtext'
  | '%future added value';

/** input type for updating data in table "spatial_ref_sys" */
export type GeodataSpatialRefSysSetInput = {
  authName?: InputMaybe<Scalars['String']['input']>;
  authSrid?: InputMaybe<Scalars['Int']['input']>;
  proj4text?: InputMaybe<Scalars['String']['input']>;
  srid?: InputMaybe<Scalars['Int']['input']>;
  srtext?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type GeodataSpatialRefSysStddevFields = {
  __typename?: 'GeodataSpatialRefSysStddevFields';
  authSrid?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type GeodataSpatialRefSysStddevPopFields = {
  __typename?: 'GeodataSpatialRefSysStddevPopFields';
  authSrid?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type GeodataSpatialRefSysStddevSampFields = {
  __typename?: 'GeodataSpatialRefSysStddevSampFields';
  authSrid?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "spatial_ref_sys" */
export type GeodataSpatialRefSysStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GeodataSpatialRefSysStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<GeodataCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GeodataSpatialRefSysStreamCursorValueInput = {
  authName?: InputMaybe<Scalars['String']['input']>;
  authSrid?: InputMaybe<Scalars['Int']['input']>;
  proj4text?: InputMaybe<Scalars['String']['input']>;
  srid?: InputMaybe<Scalars['Int']['input']>;
  srtext?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type GeodataSpatialRefSysSumFields = {
  __typename?: 'GeodataSpatialRefSysSumFields';
  authSrid?: Maybe<Scalars['Int']['output']>;
  srid?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "spatial_ref_sys" */
export type GeodataSpatialRefSysUpdateColumn =
  /** column name */
  | 'authName'
  /** column name */
  | 'authSrid'
  /** column name */
  | 'proj4text'
  /** column name */
  | 'srid'
  /** column name */
  | 'srtext'
  | '%future added value';

export type GeodataSpatialRefSysUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<GeodataSpatialRefSysIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GeodataSpatialRefSysSetInput>;
  /** filter the rows which have to be updated */
  where: GeodataSpatialRefSysBoolExp;
};

/** aggregate varPop on columns */
export type GeodataSpatialRefSysVarPopFields = {
  __typename?: 'GeodataSpatialRefSysVarPopFields';
  authSrid?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type GeodataSpatialRefSysVarSampFields = {
  __typename?: 'GeodataSpatialRefSysVarSampFields';
  authSrid?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type GeodataSpatialRefSysVarianceFields = {
  __typename?: 'GeodataSpatialRefSysVarianceFields';
  authSrid?: Maybe<Scalars['Float']['output']>;
  srid?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "zip" */
export type GeodataZip = {
  __typename?: 'GeodataZip';
  /** An array relationship */
  addresses: Array<GeodataAddress>;
  /** An aggregate relationship */
  addressesAggregate: GeodataAddressAggregate;
  zip: Scalars['String']['output'];
};


/** columns and relationships of "zip" */
export type GeodataZipaddressesArgs = {
  distinctOn?: InputMaybe<Array<GeodataAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataAddressOrderBy>>;
  where?: InputMaybe<GeodataAddressBoolExp>;
};


/** columns and relationships of "zip" */
export type GeodataZipaddressesAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeodataAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataAddressOrderBy>>;
  where?: InputMaybe<GeodataAddressBoolExp>;
};

/** aggregated selection of "zip" */
export type GeodataZipAggregate = {
  __typename?: 'GeodataZipAggregate';
  aggregate?: Maybe<GeodataZipAggregateFields>;
  nodes: Array<GeodataZip>;
};

/** aggregate fields of "zip" */
export type GeodataZipAggregateFields = {
  __typename?: 'GeodataZipAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<GeodataZipMaxFields>;
  min?: Maybe<GeodataZipMinFields>;
};


/** aggregate fields of "zip" */
export type GeodataZipAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<GeodataZipSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "zip". All fields are combined with a logical 'AND'. */
export type GeodataZipBoolExp = {
  _and?: InputMaybe<Array<GeodataZipBoolExp>>;
  _not?: InputMaybe<GeodataZipBoolExp>;
  _or?: InputMaybe<Array<GeodataZipBoolExp>>;
  addresses?: InputMaybe<GeodataAddressBoolExp>;
  addressesAggregate?: InputMaybe<GeodataAddressAggregateBoolExp>;
  zip?: InputMaybe<TaskStringComparisonExp>;
};

/** unique or primary key constraints on table "zip" */
export type GeodataZipConstraint =
  /** unique or primary key constraint on columns "zip" */
  | 'zip_pkey'
  | '%future added value';

/** input type for inserting data into table "zip" */
export type GeodataZipInsertInput = {
  addresses?: InputMaybe<GeodataAddressArrRelInsertInput>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type GeodataZipMaxFields = {
  __typename?: 'GeodataZipMaxFields';
  zip?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type GeodataZipMinFields = {
  __typename?: 'GeodataZipMinFields';
  zip?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "zip" */
export type GeodataZipMutationResponse = {
  __typename?: 'GeodataZipMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<GeodataZip>;
};

/** on_conflict condition type for table "zip" */
export type GeodataZipOnConflict = {
  constraint: GeodataZipConstraint;
  updateColumns?: Array<GeodataZipUpdateColumn>;
  where?: InputMaybe<GeodataZipBoolExp>;
};

/** Ordering options when selecting data from "zip". */
export type GeodataZipOrderBy = {
  addressesAggregate?: InputMaybe<GeodataAddressAggregateOrderBy>;
  zip?: InputMaybe<GeodataOrderBy>;
};

/** primary key columns input for table: zip */
export type GeodataZipPkColumnsInput = {
  zip: Scalars['String']['input'];
};

/** select columns of table "zip" */
export type GeodataZipSelectColumn =
  /** column name */
  | 'zip'
  | '%future added value';

/** input type for updating data in table "zip" */
export type GeodataZipSetInput = {
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "zip" */
export type GeodataZipStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: GeodataZipStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<GeodataCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type GeodataZipStreamCursorValueInput = {
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "zip" */
export type GeodataZipUpdateColumn =
  /** column name */
  | 'zip'
  | '%future added value';

export type GeodataZipUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GeodataZipSetInput>;
  /** filter the rows which have to be updated */
  where: GeodataZipBoolExp;
};

export type GeodataaddressAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<GeodataAddressSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<GeodataAddressBoolExp>;
  predicate: TaskIntComparisonExp;
};

export type Geodatast_d_within_geography_input = {
  distance: Scalars['Float']['input'];
  from: Scalars['Geodatageography']['input'];
  use_spheroid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Geodatast_d_within_input = {
  distance: Scalars['Float']['input'];
  from: Scalars['Geodatageometry']['input'];
};

export type IncomingSMSOutput = {
  __typename?: 'IncomingSMSOutput';
  accessToken: Scalars['String']['output'];
  receiveSMS?: Maybe<smsConnector>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntComparisonExp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type JsonbCastExp = {
  String?: InputMaybe<StringComparisonExp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type JsonbComparisonExp = {
  _cast?: InputMaybe<JsonbCastExp>;
  /** is the column contained in the given json value */
  _containedIn?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _hasKey?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _hasKeysAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _hasKeysAny?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

export type LinkCustomParameters = {
  temp?: InputMaybe<Scalars['String']['input']>;
};

export type LinkGateCustomParameters = {
  temp?: InputMaybe<Scalars['String']['input']>;
};

export type LinkMobilitySMSContent = {
  encoding?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userData?: InputMaybe<Scalars['String']['input']>;
};

export type LinkMobilitySMSCustomParameters = {
  moReferenceId?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['String']['input']>;
  platformPartnerId?: InputMaybe<Scalars['String']['input']>;
  queued?: InputMaybe<Scalars['String']['input']>;
  serviceCentreTimeStamp?: InputMaybe<Scalars['String']['input']>;
  suggestedOperator?: InputMaybe<Scalars['String']['input']>;
};

export type LinkMobilitySMSOutput = {
  __typename?: 'LinkMobilitySMSOutput';
  status?: Maybe<Scalars['String']['output']>;
};

export type LinkMobilitySMSRoute = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  customParameters?: InputMaybe<LinkCustomParameters>;
  description?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  gateIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  keywordType?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['String']['input']>;
  platformPartnerId?: InputMaybe<Scalars['String']['input']>;
  platformServiceId?: InputMaybe<Scalars['String']['input']>;
  platformServiceType?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['String']['input']>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type LookupPhoneNumberOutput = {
  __typename?: 'LookupPhoneNumberOutput';
  category?: Maybe<EntryCategory>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  source?: Maybe<EntrySource>;
  street?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to compare columns of type "messageTypeEnum". All fields are combined with logical 'AND'. */
export type MessageTypeEnumComparisonExp = {
  _eq?: InputMaybe<messageTypeEnum>;
  _in?: InputMaybe<Array<messageTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<messageTypeEnum>;
  _nin?: InputMaybe<Array<messageTypeEnum>>;
};

/** columns and relationships of "messaging.activitySettings" */
export type MessagingActivitySettings = {
  __typename?: 'MessagingActivitySettings';
  /** An object relationship */
  activity: messagingActivity;
  activityId: Scalars['uuid']['output'];
  archived?: Maybe<Scalars['timestamptz']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  muteImportantMessages?: Maybe<Scalars['Boolean']['output']>;
  mutedTo?: Maybe<Scalars['timestamptz']['output']>;
  notificationSetting?: Maybe<MessagingActivitySettingsNotificationSettingTypeEnum>;
  pinned?: Maybe<Scalars['Boolean']['output']>;
  privateGroupName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "messaging.activitySettings" */
export type MessagingActivitySettingsAggregate = {
  __typename?: 'MessagingActivitySettingsAggregate';
  aggregate?: Maybe<MessagingActivitySettingsAggregateFields>;
  nodes: Array<MessagingActivitySettings>;
};

/** aggregate fields of "messaging.activitySettings" */
export type MessagingActivitySettingsAggregateFields = {
  __typename?: 'MessagingActivitySettingsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<MessagingActivitySettingsMaxFields>;
  min?: Maybe<MessagingActivitySettingsMinFields>;
};


/** aggregate fields of "messaging.activitySettings" */
export type MessagingActivitySettingsAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<MessagingActivitySettingsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "messaging.activitySettings". All fields are combined with a logical 'AND'. */
export type MessagingActivitySettingsBoolExp = {
  _and?: InputMaybe<Array<MessagingActivitySettingsBoolExp>>;
  _not?: InputMaybe<MessagingActivitySettingsBoolExp>;
  _or?: InputMaybe<Array<MessagingActivitySettingsBoolExp>>;
  activity?: InputMaybe<messagingActivityBoolExp>;
  activityId?: InputMaybe<UuidComparisonExp>;
  archived?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  muteImportantMessages?: InputMaybe<BooleanComparisonExp>;
  mutedTo?: InputMaybe<TimestamptzComparisonExp>;
  notificationSetting?: InputMaybe<MessagingActivitySettingsNotificationSettingTypeEnumComparisonExp>;
  pinned?: InputMaybe<BooleanComparisonExp>;
  privateGroupName?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "messaging.activitySettings" */
export type MessagingActivitySettingsConstraint =
  /** unique or primary key constraint on columns "activityId", "userId" */
  | 'activitySettings_activityId_userId_key'
  /** unique or primary key constraint on columns "id" */
  | 'activitySettings_pkey'
  | '%future added value';

/** input type for inserting data into table "messaging.activitySettings" */
export type MessagingActivitySettingsInsertInput = {
  activity?: InputMaybe<messagingActivityObjRelInsertInput>;
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  archived?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  muteImportantMessages?: InputMaybe<Scalars['Boolean']['input']>;
  mutedTo?: InputMaybe<Scalars['timestamptz']['input']>;
  notificationSetting?: InputMaybe<MessagingActivitySettingsNotificationSettingTypeEnum>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  privateGroupName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type MessagingActivitySettingsMaxFields = {
  __typename?: 'MessagingActivitySettingsMaxFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  archived?: Maybe<Scalars['timestamptz']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mutedTo?: Maybe<Scalars['timestamptz']['output']>;
  privateGroupName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type MessagingActivitySettingsMinFields = {
  __typename?: 'MessagingActivitySettingsMinFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  archived?: Maybe<Scalars['timestamptz']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mutedTo?: Maybe<Scalars['timestamptz']['output']>;
  privateGroupName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "messaging.activitySettings" */
export type MessagingActivitySettingsMutationResponse = {
  __typename?: 'MessagingActivitySettingsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MessagingActivitySettings>;
};

/** columns and relationships of "messaging.activitySettingsNotificationSettingType" */
export type MessagingActivitySettingsNotificationSettingType = {
  __typename?: 'MessagingActivitySettingsNotificationSettingType';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "messaging.activitySettingsNotificationSettingType" */
export type MessagingActivitySettingsNotificationSettingTypeAggregate = {
  __typename?: 'MessagingActivitySettingsNotificationSettingTypeAggregate';
  aggregate?: Maybe<MessagingActivitySettingsNotificationSettingTypeAggregateFields>;
  nodes: Array<MessagingActivitySettingsNotificationSettingType>;
};

/** aggregate fields of "messaging.activitySettingsNotificationSettingType" */
export type MessagingActivitySettingsNotificationSettingTypeAggregateFields = {
  __typename?: 'MessagingActivitySettingsNotificationSettingTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<MessagingActivitySettingsNotificationSettingTypeMaxFields>;
  min?: Maybe<MessagingActivitySettingsNotificationSettingTypeMinFields>;
};


/** aggregate fields of "messaging.activitySettingsNotificationSettingType" */
export type MessagingActivitySettingsNotificationSettingTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<MessagingActivitySettingsNotificationSettingTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "messaging.activitySettingsNotificationSettingType". All fields are combined with a logical 'AND'. */
export type MessagingActivitySettingsNotificationSettingTypeBoolExp = {
  _and?: InputMaybe<Array<MessagingActivitySettingsNotificationSettingTypeBoolExp>>;
  _not?: InputMaybe<MessagingActivitySettingsNotificationSettingTypeBoolExp>;
  _or?: InputMaybe<Array<MessagingActivitySettingsNotificationSettingTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "messaging.activitySettingsNotificationSettingType" */
export type MessagingActivitySettingsNotificationSettingTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'activitySettingsNotificationSettingType_pkey'
  | '%future added value';

export type MessagingActivitySettingsNotificationSettingTypeEnum =
  /** All messages */
  | 'ALL'
  /** Mentions only */
  | 'MENTIONS'
  /** Nothing */
  | 'NOTHING'
  | '%future added value';

/** Boolean expression to compare columns of type "MessagingActivitySettingsNotificationSettingTypeEnum". All fields are combined with logical 'AND'. */
export type MessagingActivitySettingsNotificationSettingTypeEnumComparisonExp = {
  _eq?: InputMaybe<MessagingActivitySettingsNotificationSettingTypeEnum>;
  _in?: InputMaybe<Array<MessagingActivitySettingsNotificationSettingTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<MessagingActivitySettingsNotificationSettingTypeEnum>;
  _nin?: InputMaybe<Array<MessagingActivitySettingsNotificationSettingTypeEnum>>;
};

/** input type for inserting data into table "messaging.activitySettingsNotificationSettingType" */
export type MessagingActivitySettingsNotificationSettingTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type MessagingActivitySettingsNotificationSettingTypeMaxFields = {
  __typename?: 'MessagingActivitySettingsNotificationSettingTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type MessagingActivitySettingsNotificationSettingTypeMinFields = {
  __typename?: 'MessagingActivitySettingsNotificationSettingTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "messaging.activitySettingsNotificationSettingType" */
export type MessagingActivitySettingsNotificationSettingTypeMutationResponse = {
  __typename?: 'MessagingActivitySettingsNotificationSettingTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MessagingActivitySettingsNotificationSettingType>;
};

/** on_conflict condition type for table "messaging.activitySettingsNotificationSettingType" */
export type MessagingActivitySettingsNotificationSettingTypeOnConflict = {
  constraint: MessagingActivitySettingsNotificationSettingTypeConstraint;
  updateColumns?: Array<MessagingActivitySettingsNotificationSettingTypeUpdateColumn>;
  where?: InputMaybe<MessagingActivitySettingsNotificationSettingTypeBoolExp>;
};

/** Ordering options when selecting data from "messaging.activitySettingsNotificationSettingType". */
export type MessagingActivitySettingsNotificationSettingTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: messaging.activitySettingsNotificationSettingType */
export type MessagingActivitySettingsNotificationSettingTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "messaging.activitySettingsNotificationSettingType" */
export type MessagingActivitySettingsNotificationSettingTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "messaging.activitySettingsNotificationSettingType" */
export type MessagingActivitySettingsNotificationSettingTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "messaging_activitySettingsNotificationSettingType" */
export type MessagingActivitySettingsNotificationSettingTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MessagingActivitySettingsNotificationSettingTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MessagingActivitySettingsNotificationSettingTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "messaging.activitySettingsNotificationSettingType" */
export type MessagingActivitySettingsNotificationSettingTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type MessagingActivitySettingsNotificationSettingTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MessagingActivitySettingsNotificationSettingTypeSetInput>;
  /** filter the rows which have to be updated */
  where: MessagingActivitySettingsNotificationSettingTypeBoolExp;
};

/** input type for inserting object relation for remote table "messaging.activitySettings" */
export type MessagingActivitySettingsObjRelInsertInput = {
  data: MessagingActivitySettingsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<MessagingActivitySettingsOnConflict>;
};

/** on_conflict condition type for table "messaging.activitySettings" */
export type MessagingActivitySettingsOnConflict = {
  constraint: MessagingActivitySettingsConstraint;
  updateColumns?: Array<MessagingActivitySettingsUpdateColumn>;
  where?: InputMaybe<MessagingActivitySettingsBoolExp>;
};

/** Ordering options when selecting data from "messaging.activitySettings". */
export type MessagingActivitySettingsOrderBy = {
  activity?: InputMaybe<messagingActivityOrderBy>;
  activityId?: InputMaybe<OrderBy>;
  archived?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  muteImportantMessages?: InputMaybe<OrderBy>;
  mutedTo?: InputMaybe<OrderBy>;
  notificationSetting?: InputMaybe<OrderBy>;
  pinned?: InputMaybe<OrderBy>;
  privateGroupName?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: messaging.activitySettings */
export type MessagingActivitySettingsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "messaging.activitySettings" */
export type MessagingActivitySettingsSelectColumn =
  /** column name */
  | 'activityId'
  /** column name */
  | 'archived'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'muteImportantMessages'
  /** column name */
  | 'mutedTo'
  /** column name */
  | 'notificationSetting'
  /** column name */
  | 'pinned'
  /** column name */
  | 'privateGroupName'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

/** input type for updating data in table "messaging.activitySettings" */
export type MessagingActivitySettingsSetInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  archived?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  muteImportantMessages?: InputMaybe<Scalars['Boolean']['input']>;
  mutedTo?: InputMaybe<Scalars['timestamptz']['input']>;
  notificationSetting?: InputMaybe<MessagingActivitySettingsNotificationSettingTypeEnum>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  privateGroupName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "messaging_activitySettings" */
export type MessagingActivitySettingsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MessagingActivitySettingsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MessagingActivitySettingsStreamCursorValueInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  archived?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  muteImportantMessages?: InputMaybe<Scalars['Boolean']['input']>;
  mutedTo?: InputMaybe<Scalars['timestamptz']['input']>;
  notificationSetting?: InputMaybe<MessagingActivitySettingsNotificationSettingTypeEnum>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  privateGroupName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "messaging.activitySettings" */
export type MessagingActivitySettingsUpdateColumn =
  /** column name */
  | 'activityId'
  /** column name */
  | 'archived'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'muteImportantMessages'
  /** column name */
  | 'mutedTo'
  /** column name */
  | 'notificationSetting'
  /** column name */
  | 'pinned'
  /** column name */
  | 'privateGroupName'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

export type MessagingActivitySettingsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MessagingActivitySettingsSetInput>;
  /** filter the rows which have to be updated */
  where: MessagingActivitySettingsBoolExp;
};

/** Boolean expression to compare columns of type "messagingActivityTypeEnum". All fields are combined with logical 'AND'. */
export type MessagingActivityTypeEnumComparisonExp = {
  _eq?: InputMaybe<messagingActivityTypeEnum>;
  _in?: InputMaybe<Array<messagingActivityTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<messagingActivityTypeEnum>;
  _nin?: InputMaybe<Array<messagingActivityTypeEnum>>;
};

/** columns and relationships of "messaging.invitation" */
export type MessagingInvitation = {
  __typename?: 'MessagingInvitation';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  activity: messagingActivity;
  activityId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  createdByUserId: Scalars['uuid']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "messaging.invitation" */
export type MessagingInvitationAggregate = {
  __typename?: 'MessagingInvitationAggregate';
  aggregate?: Maybe<MessagingInvitationAggregateFields>;
  nodes: Array<MessagingInvitation>;
};

export type MessagingInvitationAggregateBoolExp = {
  bool_and?: InputMaybe<messagingInvitationAggregateBoolExpBool_and>;
  bool_or?: InputMaybe<messagingInvitationAggregateBoolExpBool_or>;
  count?: InputMaybe<messagingInvitationAggregateBoolExpCount>;
};

/** aggregate fields of "messaging.invitation" */
export type MessagingInvitationAggregateFields = {
  __typename?: 'MessagingInvitationAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<MessagingInvitationMaxFields>;
  min?: Maybe<MessagingInvitationMinFields>;
};


/** aggregate fields of "messaging.invitation" */
export type MessagingInvitationAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<MessagingInvitationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "messaging.invitation" */
export type MessagingInvitationAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MessagingInvitationMaxOrderBy>;
  min?: InputMaybe<MessagingInvitationMinOrderBy>;
};

/** input type for inserting array relation for remote table "messaging.invitation" */
export type MessagingInvitationArrRelInsertInput = {
  data: Array<MessagingInvitationInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<MessagingInvitationOnConflict>;
};

/** Boolean expression to filter rows from the table "messaging.invitation". All fields are combined with a logical 'AND'. */
export type MessagingInvitationBoolExp = {
  _and?: InputMaybe<Array<MessagingInvitationBoolExp>>;
  _not?: InputMaybe<MessagingInvitationBoolExp>;
  _or?: InputMaybe<Array<MessagingInvitationBoolExp>>;
  accepted?: InputMaybe<BooleanComparisonExp>;
  activity?: InputMaybe<messagingActivityBoolExp>;
  activityId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserId?: InputMaybe<UuidComparisonExp>;
  firstName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lastName?: InputMaybe<StringComparisonExp>;
  phoneNumber?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "messaging.invitation" */
export type MessagingInvitationConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'invitation_pkey'
  /** unique or primary key constraint on columns "user_id", "activity_id" */
  | 'invitation_user_id_activity_id_key'
  | '%future added value';

/** input type for inserting data into table "messaging.invitation" */
export type MessagingInvitationInsertInput = {
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  activity?: InputMaybe<messagingActivityObjRelInsertInput>;
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type MessagingInvitationMaxFields = {
  __typename?: 'MessagingInvitationMaxFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "messaging.invitation" */
export type MessagingInvitationMaxOrderBy = {
  activityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type MessagingInvitationMinFields = {
  __typename?: 'MessagingInvitationMinFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "messaging.invitation" */
export type MessagingInvitationMinOrderBy = {
  activityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "messaging.invitation" */
export type MessagingInvitationMutationResponse = {
  __typename?: 'MessagingInvitationMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MessagingInvitation>;
};

/** on_conflict condition type for table "messaging.invitation" */
export type MessagingInvitationOnConflict = {
  constraint: MessagingInvitationConstraint;
  updateColumns?: Array<MessagingInvitationUpdateColumn>;
  where?: InputMaybe<MessagingInvitationBoolExp>;
};

/** Ordering options when selecting data from "messaging.invitation". */
export type MessagingInvitationOrderBy = {
  accepted?: InputMaybe<OrderBy>;
  activity?: InputMaybe<messagingActivityOrderBy>;
  activityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: messaging.invitation */
export type MessagingInvitationPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "messaging.invitation" */
export type MessagingInvitationSelectColumn =
  /** column name */
  | 'accepted'
  /** column name */
  | 'activityId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserId'
  /** column name */
  | 'firstName'
  /** column name */
  | 'id'
  /** column name */
  | 'lastName'
  /** column name */
  | 'phoneNumber'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

/** select "messagingInvitationAggregateBoolExpBool_andArgumentsColumns" columns of table "messaging.invitation" */
export type MessagingInvitationSelectColumnMessagingInvitationAggregateBoolExpBool_andArgumentsColumns =
  /** column name */
  | 'accepted'
  | '%future added value';

/** select "messagingInvitationAggregateBoolExpBool_orArgumentsColumns" columns of table "messaging.invitation" */
export type MessagingInvitationSelectColumnMessagingInvitationAggregateBoolExpBool_orArgumentsColumns =
  /** column name */
  | 'accepted'
  | '%future added value';

/** input type for updating data in table "messaging.invitation" */
export type MessagingInvitationSetInput = {
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "messaging_invitation" */
export type MessagingInvitationStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MessagingInvitationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MessagingInvitationStreamCursorValueInput = {
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "messaging.invitation" */
export type MessagingInvitationUpdateColumn =
  /** column name */
  | 'accepted'
  /** column name */
  | 'activityId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserId'
  /** column name */
  | 'firstName'
  /** column name */
  | 'id'
  /** column name */
  | 'lastName'
  /** column name */
  | 'phoneNumber'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

export type MessagingInvitationUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MessagingInvitationSetInput>;
  /** filter the rows which have to be updated */
  where: MessagingInvitationBoolExp;
};

/** columns and relationships of "messaging.mentions" */
export type MessagingMentions = {
  __typename?: 'MessagingMentions';
  id: Scalars['uuid']['output'];
  /** An object relationship */
  message: messagingMessage;
  messageId: Scalars['uuid']['output'];
  /** An object relationship */
  organizationUser: organizationUser;
  organizationUserId: Scalars['uuid']['output'];
};

/** aggregated selection of "messaging.mentions" */
export type MessagingMentionsAggregate = {
  __typename?: 'MessagingMentionsAggregate';
  aggregate?: Maybe<MessagingMentionsAggregateFields>;
  nodes: Array<MessagingMentions>;
};

export type MessagingMentionsAggregateBoolExp = {
  count?: InputMaybe<messagingMentionsAggregateBoolExpCount>;
};

/** aggregate fields of "messaging.mentions" */
export type MessagingMentionsAggregateFields = {
  __typename?: 'MessagingMentionsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<MessagingMentionsMaxFields>;
  min?: Maybe<MessagingMentionsMinFields>;
};


/** aggregate fields of "messaging.mentions" */
export type MessagingMentionsAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<MessagingMentionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "messaging.mentions" */
export type MessagingMentionsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MessagingMentionsMaxOrderBy>;
  min?: InputMaybe<MessagingMentionsMinOrderBy>;
};

/** input type for inserting array relation for remote table "messaging.mentions" */
export type MessagingMentionsArrRelInsertInput = {
  data: Array<MessagingMentionsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<MessagingMentionsOnConflict>;
};

/** Boolean expression to filter rows from the table "messaging.mentions". All fields are combined with a logical 'AND'. */
export type MessagingMentionsBoolExp = {
  _and?: InputMaybe<Array<MessagingMentionsBoolExp>>;
  _not?: InputMaybe<MessagingMentionsBoolExp>;
  _or?: InputMaybe<Array<MessagingMentionsBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  message?: InputMaybe<messagingMessageBoolExp>;
  messageId?: InputMaybe<UuidComparisonExp>;
  organizationUser?: InputMaybe<organizationUserBoolExp>;
  organizationUserId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "messaging.mentions" */
export type MessagingMentionsConstraint =
  /** unique or primary key constraint on columns "organization_user_id", "message_id" */
  | 'mentions_message_id_organization_user_id_key'
  /** unique or primary key constraint on columns "id" */
  | 'mentions_pkey'
  | '%future added value';

/** input type for inserting data into table "messaging.mentions" */
export type MessagingMentionsInsertInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<messagingMessageObjRelInsertInput>;
  messageId?: InputMaybe<Scalars['uuid']['input']>;
  organizationUser?: InputMaybe<organizationUserObjRelInsertInput>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type MessagingMentionsMaxFields = {
  __typename?: 'MessagingMentionsMaxFields';
  id?: Maybe<Scalars['uuid']['output']>;
  messageId?: Maybe<Scalars['uuid']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "messaging.mentions" */
export type MessagingMentionsMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  messageId?: InputMaybe<OrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type MessagingMentionsMinFields = {
  __typename?: 'MessagingMentionsMinFields';
  id?: Maybe<Scalars['uuid']['output']>;
  messageId?: Maybe<Scalars['uuid']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "messaging.mentions" */
export type MessagingMentionsMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  messageId?: InputMaybe<OrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "messaging.mentions" */
export type MessagingMentionsMutationResponse = {
  __typename?: 'MessagingMentionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MessagingMentions>;
};

/** on_conflict condition type for table "messaging.mentions" */
export type MessagingMentionsOnConflict = {
  constraint: MessagingMentionsConstraint;
  updateColumns?: Array<MessagingMentionsUpdateColumn>;
  where?: InputMaybe<MessagingMentionsBoolExp>;
};

/** Ordering options when selecting data from "messaging.mentions". */
export type MessagingMentionsOrderBy = {
  id?: InputMaybe<OrderBy>;
  message?: InputMaybe<messagingMessageOrderBy>;
  messageId?: InputMaybe<OrderBy>;
  organizationUser?: InputMaybe<organizationUserOrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: messaging.mentions */
export type MessagingMentionsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "messaging.mentions" */
export type MessagingMentionsSelectColumn =
  /** column name */
  | 'id'
  /** column name */
  | 'messageId'
  /** column name */
  | 'organizationUserId'
  | '%future added value';

/** input type for updating data in table "messaging.mentions" */
export type MessagingMentionsSetInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  messageId?: InputMaybe<Scalars['uuid']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "messaging_mentions" */
export type MessagingMentionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MessagingMentionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MessagingMentionsStreamCursorValueInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  messageId?: InputMaybe<Scalars['uuid']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "messaging.mentions" */
export type MessagingMentionsUpdateColumn =
  /** column name */
  | 'id'
  /** column name */
  | 'messageId'
  /** column name */
  | 'organizationUserId'
  | '%future added value';

export type MessagingMentionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MessagingMentionsSetInput>;
  /** filter the rows which have to be updated */
  where: MessagingMentionsBoolExp;
};

/** attachment */
export type MessagingMessageAttachment = {
  __typename?: 'MessagingMessageAttachment';
  attachedByUser: Scalars['uuid']['output'];
  attachment: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  file?: Maybe<publicFile>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  message: messagingMessage;
  messageId: Scalars['uuid']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<MessagingMessageAttachmentTypeEnum>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "messaging.message_attachment" */
export type MessagingMessageAttachmentAggregate = {
  __typename?: 'MessagingMessageAttachmentAggregate';
  aggregate?: Maybe<MessagingMessageAttachmentAggregateFields>;
  nodes: Array<MessagingMessageAttachment>;
};

export type MessagingMessageAttachmentAggregateBoolExp = {
  count?: InputMaybe<messagingMessageAttachmentAggregateBoolExpCount>;
};

/** aggregate fields of "messaging.message_attachment" */
export type MessagingMessageAttachmentAggregateFields = {
  __typename?: 'MessagingMessageAttachmentAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<MessagingMessageAttachmentMaxFields>;
  min?: Maybe<MessagingMessageAttachmentMinFields>;
};


/** aggregate fields of "messaging.message_attachment" */
export type MessagingMessageAttachmentAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<MessagingMessageAttachmentSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "messaging.message_attachment" */
export type MessagingMessageAttachmentAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<MessagingMessageAttachmentMaxOrderBy>;
  min?: InputMaybe<MessagingMessageAttachmentMinOrderBy>;
};

/** input type for inserting array relation for remote table "messaging.message_attachment" */
export type MessagingMessageAttachmentArrRelInsertInput = {
  data: Array<MessagingMessageAttachmentInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<MessagingMessageAttachmentOnConflict>;
};

/** Boolean expression to filter rows from the table "messaging.message_attachment". All fields are combined with a logical 'AND'. */
export type MessagingMessageAttachmentBoolExp = {
  _and?: InputMaybe<Array<MessagingMessageAttachmentBoolExp>>;
  _not?: InputMaybe<MessagingMessageAttachmentBoolExp>;
  _or?: InputMaybe<Array<MessagingMessageAttachmentBoolExp>>;
  attachedByUser?: InputMaybe<UuidComparisonExp>;
  attachment?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  file?: InputMaybe<publicFileBoolExp>;
  fileId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  message?: InputMaybe<messagingMessageBoolExp>;
  messageId?: InputMaybe<UuidComparisonExp>;
  mimeType?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<MessagingMessageAttachmentTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "messaging.message_attachment" */
export type MessagingMessageAttachmentConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'message_attachment_pkey'
  | '%future added value';

/** input type for inserting data into table "messaging.message_attachment" */
export type MessagingMessageAttachmentInsertInput = {
  attachedByUser?: InputMaybe<Scalars['uuid']['input']>;
  attachment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  file?: InputMaybe<publicFileObjRelInsertInput>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<messagingMessageObjRelInsertInput>;
  messageId?: InputMaybe<Scalars['uuid']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MessagingMessageAttachmentTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type MessagingMessageAttachmentMaxFields = {
  __typename?: 'MessagingMessageAttachmentMaxFields';
  attachedByUser?: Maybe<Scalars['uuid']['output']>;
  attachment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  messageId?: Maybe<Scalars['uuid']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "messaging.message_attachment" */
export type MessagingMessageAttachmentMaxOrderBy = {
  attachedByUser?: InputMaybe<OrderBy>;
  attachment?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  fileId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  messageId?: InputMaybe<OrderBy>;
  mimeType?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type MessagingMessageAttachmentMinFields = {
  __typename?: 'MessagingMessageAttachmentMinFields';
  attachedByUser?: Maybe<Scalars['uuid']['output']>;
  attachment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  messageId?: Maybe<Scalars['uuid']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "messaging.message_attachment" */
export type MessagingMessageAttachmentMinOrderBy = {
  attachedByUser?: InputMaybe<OrderBy>;
  attachment?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  fileId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  messageId?: InputMaybe<OrderBy>;
  mimeType?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "messaging.message_attachment" */
export type MessagingMessageAttachmentMutationResponse = {
  __typename?: 'MessagingMessageAttachmentMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MessagingMessageAttachment>;
};

/** on_conflict condition type for table "messaging.message_attachment" */
export type MessagingMessageAttachmentOnConflict = {
  constraint: MessagingMessageAttachmentConstraint;
  updateColumns?: Array<MessagingMessageAttachmentUpdateColumn>;
  where?: InputMaybe<MessagingMessageAttachmentBoolExp>;
};

/** Ordering options when selecting data from "messaging.message_attachment". */
export type MessagingMessageAttachmentOrderBy = {
  attachedByUser?: InputMaybe<OrderBy>;
  attachment?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  file?: InputMaybe<publicFileOrderBy>;
  fileId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message?: InputMaybe<messagingMessageOrderBy>;
  messageId?: InputMaybe<OrderBy>;
  mimeType?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: messaging.message_attachment */
export type MessagingMessageAttachmentPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "messaging.message_attachment" */
export type MessagingMessageAttachmentSelectColumn =
  /** column name */
  | 'attachedByUser'
  /** column name */
  | 'attachment'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'fileId'
  /** column name */
  | 'id'
  /** column name */
  | 'messageId'
  /** column name */
  | 'mimeType'
  /** column name */
  | 'name'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "messaging.message_attachment" */
export type MessagingMessageAttachmentSetInput = {
  attachedByUser?: InputMaybe<Scalars['uuid']['input']>;
  attachment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  messageId?: InputMaybe<Scalars['uuid']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MessagingMessageAttachmentTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "messaging_message_attachment" */
export type MessagingMessageAttachmentStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MessagingMessageAttachmentStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MessagingMessageAttachmentStreamCursorValueInput = {
  attachedByUser?: InputMaybe<Scalars['uuid']['input']>;
  attachment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  messageId?: InputMaybe<Scalars['uuid']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MessagingMessageAttachmentTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** attachment type */
export type MessagingMessageAttachmentType = {
  __typename?: 'MessagingMessageAttachmentType';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "messaging.message_attachment_type" */
export type MessagingMessageAttachmentTypeAggregate = {
  __typename?: 'MessagingMessageAttachmentTypeAggregate';
  aggregate?: Maybe<MessagingMessageAttachmentTypeAggregateFields>;
  nodes: Array<MessagingMessageAttachmentType>;
};

/** aggregate fields of "messaging.message_attachment_type" */
export type MessagingMessageAttachmentTypeAggregateFields = {
  __typename?: 'MessagingMessageAttachmentTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<MessagingMessageAttachmentTypeMaxFields>;
  min?: Maybe<MessagingMessageAttachmentTypeMinFields>;
};


/** aggregate fields of "messaging.message_attachment_type" */
export type MessagingMessageAttachmentTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<MessagingMessageAttachmentTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "messaging.message_attachment_type". All fields are combined with a logical 'AND'. */
export type MessagingMessageAttachmentTypeBoolExp = {
  _and?: InputMaybe<Array<MessagingMessageAttachmentTypeBoolExp>>;
  _not?: InputMaybe<MessagingMessageAttachmentTypeBoolExp>;
  _or?: InputMaybe<Array<MessagingMessageAttachmentTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "messaging.message_attachment_type" */
export type MessagingMessageAttachmentTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'message_attachment_type_pkey'
  | '%future added value';

export type MessagingMessageAttachmentTypeEnum =
  /** document */
  | 'DOCUMENT'
  /** image */
  | 'IMAGE'
  /** video */
  | 'VIDEO'
  | '%future added value';

/** Boolean expression to compare columns of type "MessagingMessageAttachmentTypeEnum". All fields are combined with logical 'AND'. */
export type MessagingMessageAttachmentTypeEnumComparisonExp = {
  _eq?: InputMaybe<MessagingMessageAttachmentTypeEnum>;
  _in?: InputMaybe<Array<MessagingMessageAttachmentTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<MessagingMessageAttachmentTypeEnum>;
  _nin?: InputMaybe<Array<MessagingMessageAttachmentTypeEnum>>;
};

/** input type for inserting data into table "messaging.message_attachment_type" */
export type MessagingMessageAttachmentTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type MessagingMessageAttachmentTypeMaxFields = {
  __typename?: 'MessagingMessageAttachmentTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type MessagingMessageAttachmentTypeMinFields = {
  __typename?: 'MessagingMessageAttachmentTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "messaging.message_attachment_type" */
export type MessagingMessageAttachmentTypeMutationResponse = {
  __typename?: 'MessagingMessageAttachmentTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MessagingMessageAttachmentType>;
};

/** on_conflict condition type for table "messaging.message_attachment_type" */
export type MessagingMessageAttachmentTypeOnConflict = {
  constraint: MessagingMessageAttachmentTypeConstraint;
  updateColumns?: Array<MessagingMessageAttachmentTypeUpdateColumn>;
  where?: InputMaybe<MessagingMessageAttachmentTypeBoolExp>;
};

/** Ordering options when selecting data from "messaging.message_attachment_type". */
export type MessagingMessageAttachmentTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: messaging.message_attachment_type */
export type MessagingMessageAttachmentTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "messaging.message_attachment_type" */
export type MessagingMessageAttachmentTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "messaging.message_attachment_type" */
export type MessagingMessageAttachmentTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "messaging_message_attachment_type" */
export type MessagingMessageAttachmentTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MessagingMessageAttachmentTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MessagingMessageAttachmentTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "messaging.message_attachment_type" */
export type MessagingMessageAttachmentTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type MessagingMessageAttachmentTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MessagingMessageAttachmentTypeSetInput>;
  /** filter the rows which have to be updated */
  where: MessagingMessageAttachmentTypeBoolExp;
};

/** update columns of table "messaging.message_attachment" */
export type MessagingMessageAttachmentUpdateColumn =
  /** column name */
  | 'attachedByUser'
  /** column name */
  | 'attachment'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'fileId'
  /** column name */
  | 'id'
  /** column name */
  | 'messageId'
  /** column name */
  | 'mimeType'
  /** column name */
  | 'name'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type MessagingMessageAttachmentUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MessagingMessageAttachmentSetInput>;
  /** filter the rows which have to be updated */
  where: MessagingMessageAttachmentBoolExp;
};

/** columns and relationships of "messaging.message_priority" */
export type MessagingMessagePriority = {
  __typename?: 'MessagingMessagePriority';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "messaging.message_priority" */
export type MessagingMessagePriorityAggregate = {
  __typename?: 'MessagingMessagePriorityAggregate';
  aggregate?: Maybe<MessagingMessagePriorityAggregateFields>;
  nodes: Array<MessagingMessagePriority>;
};

/** aggregate fields of "messaging.message_priority" */
export type MessagingMessagePriorityAggregateFields = {
  __typename?: 'MessagingMessagePriorityAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<MessagingMessagePriorityMaxFields>;
  min?: Maybe<MessagingMessagePriorityMinFields>;
};


/** aggregate fields of "messaging.message_priority" */
export type MessagingMessagePriorityAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<MessagingMessagePrioritySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "messaging.message_priority". All fields are combined with a logical 'AND'. */
export type MessagingMessagePriorityBoolExp = {
  _and?: InputMaybe<Array<MessagingMessagePriorityBoolExp>>;
  _not?: InputMaybe<MessagingMessagePriorityBoolExp>;
  _or?: InputMaybe<Array<MessagingMessagePriorityBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "messaging.message_priority" */
export type MessagingMessagePriorityConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'message_priority_pkey'
  | '%future added value';

export type MessagingMessagePriorityEnum =
  /** High priority */
  | 'HIGH'
  /** Normal priority */
  | 'NORMAL'
  | '%future added value';

/** Boolean expression to compare columns of type "MessagingMessagePriorityEnum". All fields are combined with logical 'AND'. */
export type MessagingMessagePriorityEnumComparisonExp = {
  _eq?: InputMaybe<MessagingMessagePriorityEnum>;
  _in?: InputMaybe<Array<MessagingMessagePriorityEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<MessagingMessagePriorityEnum>;
  _nin?: InputMaybe<Array<MessagingMessagePriorityEnum>>;
};

/** input type for inserting data into table "messaging.message_priority" */
export type MessagingMessagePriorityInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type MessagingMessagePriorityMaxFields = {
  __typename?: 'MessagingMessagePriorityMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type MessagingMessagePriorityMinFields = {
  __typename?: 'MessagingMessagePriorityMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "messaging.message_priority" */
export type MessagingMessagePriorityMutationResponse = {
  __typename?: 'MessagingMessagePriorityMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MessagingMessagePriority>;
};

/** on_conflict condition type for table "messaging.message_priority" */
export type MessagingMessagePriorityOnConflict = {
  constraint: MessagingMessagePriorityConstraint;
  updateColumns?: Array<MessagingMessagePriorityUpdateColumn>;
  where?: InputMaybe<MessagingMessagePriorityBoolExp>;
};

/** Ordering options when selecting data from "messaging.message_priority". */
export type MessagingMessagePriorityOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: messaging.message_priority */
export type MessagingMessagePriorityPkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "messaging.message_priority" */
export type MessagingMessagePrioritySelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "messaging.message_priority" */
export type MessagingMessagePrioritySetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "messaging_message_priority" */
export type MessagingMessagePriorityStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MessagingMessagePriorityStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MessagingMessagePriorityStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "messaging.message_priority" */
export type MessagingMessagePriorityUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type MessagingMessagePriorityUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MessagingMessagePrioritySetInput>;
  /** filter the rows which have to be updated */
  where: MessagingMessagePriorityBoolExp;
};

/** Boolean expression to compare columns of type "messagingMessageTypeEnum". All fields are combined with logical 'AND'. */
export type MessagingMessageTypeEnumComparisonExp = {
  _eq?: InputMaybe<messagingMessageTypeEnum>;
  _in?: InputMaybe<Array<messagingMessageTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<messagingMessageTypeEnum>;
  _nin?: InputMaybe<Array<messagingMessageTypeEnum>>;
};

export type NewActivity = {
  createdByUserId: Scalars['uuid']['input'];
  organizationId: Scalars['uuid']['input'];
};

export type NewActivityOutput = {
  __typename?: 'NewActivityOutput';
  result: Scalars['String']['output'];
};

export type NotificationInput = {
  dialog_type: Scalars['String']['input'];
  id: Scalars['String']['input'];
  timestamp: Scalars['timestamptz']['input'];
  user_id_from: Scalars['String']['input'];
  user_id_to: Scalars['String']['input'];
};

/** maps devices and push notifications sent */
export type NotificationNotificationDeviceSent = {
  __typename?: 'NotificationNotificationDeviceSent';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  device: notificationUserDevice;
  deviceId: Scalars['uuid']['output'];
  deviceScheduledIdentifier?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  notification: notificationSend;
  notificationId: Scalars['uuid']['output'];
  receivedAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<user>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "notification.notification_device_sent" */
export type NotificationNotificationDeviceSentAggregate = {
  __typename?: 'NotificationNotificationDeviceSentAggregate';
  aggregate?: Maybe<NotificationNotificationDeviceSentAggregateFields>;
  nodes: Array<NotificationNotificationDeviceSent>;
};

/** aggregate fields of "notification.notification_device_sent" */
export type NotificationNotificationDeviceSentAggregateFields = {
  __typename?: 'NotificationNotificationDeviceSentAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<NotificationNotificationDeviceSentMaxFields>;
  min?: Maybe<NotificationNotificationDeviceSentMinFields>;
};


/** aggregate fields of "notification.notification_device_sent" */
export type NotificationNotificationDeviceSentAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<NotificationNotificationDeviceSentSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "notification.notification_device_sent". All fields are combined with a logical 'AND'. */
export type NotificationNotificationDeviceSentBoolExp = {
  _and?: InputMaybe<Array<NotificationNotificationDeviceSentBoolExp>>;
  _not?: InputMaybe<NotificationNotificationDeviceSentBoolExp>;
  _or?: InputMaybe<Array<NotificationNotificationDeviceSentBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  device?: InputMaybe<notificationUserDeviceBoolExp>;
  deviceId?: InputMaybe<UuidComparisonExp>;
  deviceScheduledIdentifier?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  notification?: InputMaybe<notificationSendBoolExp>;
  notificationId?: InputMaybe<UuidComparisonExp>;
  receivedAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<userBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "notification.notification_device_sent" */
export type NotificationNotificationDeviceSentConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'notification_device_sent_pkey'
  | '%future added value';

/** input type for inserting data into table "notification.notification_device_sent" */
export type NotificationNotificationDeviceSentInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  device?: InputMaybe<notificationUserDeviceObjRelInsertInput>;
  deviceId?: InputMaybe<Scalars['uuid']['input']>;
  deviceScheduledIdentifier?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notification?: InputMaybe<notificationSendObjRelInsertInput>;
  notificationId?: InputMaybe<Scalars['uuid']['input']>;
  receivedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<userObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type NotificationNotificationDeviceSentMaxFields = {
  __typename?: 'NotificationNotificationDeviceSentMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deviceId?: Maybe<Scalars['uuid']['output']>;
  deviceScheduledIdentifier?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  notificationId?: Maybe<Scalars['uuid']['output']>;
  receivedAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type NotificationNotificationDeviceSentMinFields = {
  __typename?: 'NotificationNotificationDeviceSentMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deviceId?: Maybe<Scalars['uuid']['output']>;
  deviceScheduledIdentifier?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  notificationId?: Maybe<Scalars['uuid']['output']>;
  receivedAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "notification.notification_device_sent" */
export type NotificationNotificationDeviceSentMutationResponse = {
  __typename?: 'NotificationNotificationDeviceSentMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<NotificationNotificationDeviceSent>;
};

/** on_conflict condition type for table "notification.notification_device_sent" */
export type NotificationNotificationDeviceSentOnConflict = {
  constraint: NotificationNotificationDeviceSentConstraint;
  updateColumns?: Array<NotificationNotificationDeviceSentUpdateColumn>;
  where?: InputMaybe<NotificationNotificationDeviceSentBoolExp>;
};

/** Ordering options when selecting data from "notification.notification_device_sent". */
export type NotificationNotificationDeviceSentOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  device?: InputMaybe<notificationUserDeviceOrderBy>;
  deviceId?: InputMaybe<OrderBy>;
  deviceScheduledIdentifier?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  notification?: InputMaybe<notificationSendOrderBy>;
  notificationId?: InputMaybe<OrderBy>;
  receivedAt?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<userOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: notification.notification_device_sent */
export type NotificationNotificationDeviceSentPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "notification.notification_device_sent" */
export type NotificationNotificationDeviceSentSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'deviceId'
  /** column name */
  | 'deviceScheduledIdentifier'
  /** column name */
  | 'id'
  /** column name */
  | 'notificationId'
  /** column name */
  | 'receivedAt'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

/** input type for updating data in table "notification.notification_device_sent" */
export type NotificationNotificationDeviceSentSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deviceId?: InputMaybe<Scalars['uuid']['input']>;
  deviceScheduledIdentifier?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notificationId?: InputMaybe<Scalars['uuid']['input']>;
  receivedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "notification_notification_device_sent" */
export type NotificationNotificationDeviceSentStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: NotificationNotificationDeviceSentStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationNotificationDeviceSentStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deviceId?: InputMaybe<Scalars['uuid']['input']>;
  deviceScheduledIdentifier?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notificationId?: InputMaybe<Scalars['uuid']['input']>;
  receivedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "notification.notification_device_sent" */
export type NotificationNotificationDeviceSentUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'deviceId'
  /** column name */
  | 'deviceScheduledIdentifier'
  /** column name */
  | 'id'
  /** column name */
  | 'notificationId'
  /** column name */
  | 'receivedAt'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

export type NotificationNotificationDeviceSentUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NotificationNotificationDeviceSentSetInput>;
  /** filter the rows which have to be updated */
  where: NotificationNotificationDeviceSentBoolExp;
};

/** 24.06.25 - not in use */
export type NotificationNotificationSettingActivityPrimaryEnum = {
  __typename?: 'NotificationNotificationSettingActivityPrimaryEnum';
  comment: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "notification.notification_setting_activity_primary_enum" */
export type NotificationNotificationSettingActivityPrimaryEnumAggregate = {
  __typename?: 'NotificationNotificationSettingActivityPrimaryEnumAggregate';
  aggregate?: Maybe<NotificationNotificationSettingActivityPrimaryEnumAggregateFields>;
  nodes: Array<NotificationNotificationSettingActivityPrimaryEnum>;
};

/** aggregate fields of "notification.notification_setting_activity_primary_enum" */
export type NotificationNotificationSettingActivityPrimaryEnumAggregateFields = {
  __typename?: 'NotificationNotificationSettingActivityPrimaryEnumAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<NotificationNotificationSettingActivityPrimaryEnumMaxFields>;
  min?: Maybe<NotificationNotificationSettingActivityPrimaryEnumMinFields>;
};


/** aggregate fields of "notification.notification_setting_activity_primary_enum" */
export type NotificationNotificationSettingActivityPrimaryEnumAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<NotificationNotificationSettingActivityPrimaryEnumSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "notification.notification_setting_activity_primary_enum". All fields are combined with a logical 'AND'. */
export type NotificationNotificationSettingActivityPrimaryEnumBoolExp = {
  _and?: InputMaybe<Array<NotificationNotificationSettingActivityPrimaryEnumBoolExp>>;
  _not?: InputMaybe<NotificationNotificationSettingActivityPrimaryEnumBoolExp>;
  _or?: InputMaybe<Array<NotificationNotificationSettingActivityPrimaryEnumBoolExp>>;
  comment?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "notification.notification_setting_activity_primary_enum" */
export type NotificationNotificationSettingActivityPrimaryEnumConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'notification_setting_activity_primary_enum_pkey'
  | '%future added value';

export type NotificationNotificationSettingActivityPrimaryEnumEnum =
  /** All messages */
  | 'ALL'
  /** Only mentions */
  | 'MENTIONS'
  /** Nothing */
  | 'NOTHING'
  | '%future added value';

/** Boolean expression to compare columns of type "NotificationNotificationSettingActivityPrimaryEnumEnum". All fields are combined with logical 'AND'. */
export type NotificationNotificationSettingActivityPrimaryEnumEnumComparisonExp = {
  _eq?: InputMaybe<NotificationNotificationSettingActivityPrimaryEnumEnum>;
  _in?: InputMaybe<Array<NotificationNotificationSettingActivityPrimaryEnumEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<NotificationNotificationSettingActivityPrimaryEnumEnum>;
  _nin?: InputMaybe<Array<NotificationNotificationSettingActivityPrimaryEnumEnum>>;
};

/** input type for inserting data into table "notification.notification_setting_activity_primary_enum" */
export type NotificationNotificationSettingActivityPrimaryEnumInsertInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type NotificationNotificationSettingActivityPrimaryEnumMaxFields = {
  __typename?: 'NotificationNotificationSettingActivityPrimaryEnumMaxFields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type NotificationNotificationSettingActivityPrimaryEnumMinFields = {
  __typename?: 'NotificationNotificationSettingActivityPrimaryEnumMinFields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "notification.notification_setting_activity_primary_enum" */
export type NotificationNotificationSettingActivityPrimaryEnumMutationResponse = {
  __typename?: 'NotificationNotificationSettingActivityPrimaryEnumMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<NotificationNotificationSettingActivityPrimaryEnum>;
};

/** on_conflict condition type for table "notification.notification_setting_activity_primary_enum" */
export type NotificationNotificationSettingActivityPrimaryEnumOnConflict = {
  constraint: NotificationNotificationSettingActivityPrimaryEnumConstraint;
  updateColumns?: Array<NotificationNotificationSettingActivityPrimaryEnumUpdateColumn>;
  where?: InputMaybe<NotificationNotificationSettingActivityPrimaryEnumBoolExp>;
};

/** Ordering options when selecting data from "notification.notification_setting_activity_primary_enum". */
export type NotificationNotificationSettingActivityPrimaryEnumOrderBy = {
  comment?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: notification.notification_setting_activity_primary_enum */
export type NotificationNotificationSettingActivityPrimaryEnumPkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "notification.notification_setting_activity_primary_enum" */
export type NotificationNotificationSettingActivityPrimaryEnumSelectColumn =
  /** column name */
  | 'comment'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "notification.notification_setting_activity_primary_enum" */
export type NotificationNotificationSettingActivityPrimaryEnumSetInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "notification_notification_setting_activity_primary_enum" */
export type NotificationNotificationSettingActivityPrimaryEnumStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: NotificationNotificationSettingActivityPrimaryEnumStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationNotificationSettingActivityPrimaryEnumStreamCursorValueInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "notification.notification_setting_activity_primary_enum" */
export type NotificationNotificationSettingActivityPrimaryEnumUpdateColumn =
  /** column name */
  | 'comment'
  /** column name */
  | 'value'
  | '%future added value';

export type NotificationNotificationSettingActivityPrimaryEnumUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NotificationNotificationSettingActivityPrimaryEnumSetInput>;
  /** filter the rows which have to be updated */
  where: NotificationNotificationSettingActivityPrimaryEnumBoolExp;
};

export type NotificationOutput = {
  __typename?: 'NotificationOutput';
  result: Scalars['String']['output'];
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type NumericComparisonExp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** column ordering options */
export type OrderBy =
  /** in ascending order, nulls last */
  | 'ASC'
  /** in ascending order, nulls first */
  | 'ASC_NULLS_FIRST'
  /** in ascending order, nulls last */
  | 'ASC_NULLS_LAST'
  /** in descending order, nulls first */
  | 'DESC'
  /** in descending order, nulls first */
  | 'DESC_NULLS_FIRST'
  /** in descending order, nulls last */
  | 'DESC_NULLS_LAST'
  | '%future added value';

export type OrderUpdateInput = {
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['uuid']['input'];
  licences?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
};

export type OrderUpdateOutput = {
  __typename?: 'OrderUpdateOutput';
  id: Scalars['uuid']['output'];
};

/** columns and relationships of "orders.organizations" */
export type OrdersOrganizations = {
  __typename?: 'OrdersOrganizations';
  deliveryDate: Scalars['timestamptz']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  lastName: Scalars['String']['output'];
  mobileNumber: Scalars['String']['output'];
  nrOfUsers: Scalars['Int']['output'];
  organizationName: Scalars['String']['output'];
  organizationNumber: Scalars['String']['output'];
  providerType: Scalars['String']['output'];
};

/** aggregated selection of "orders.organizations" */
export type OrdersOrganizationsAggregate = {
  __typename?: 'OrdersOrganizationsAggregate';
  aggregate?: Maybe<OrdersOrganizationsAggregateFields>;
  nodes: Array<OrdersOrganizations>;
};

/** aggregate fields of "orders.organizations" */
export type OrdersOrganizationsAggregateFields = {
  __typename?: 'OrdersOrganizationsAggregateFields';
  avg?: Maybe<OrdersOrganizationsAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<OrdersOrganizationsMaxFields>;
  min?: Maybe<OrdersOrganizationsMinFields>;
  stddev?: Maybe<OrdersOrganizationsStddevFields>;
  stddevPop?: Maybe<OrdersOrganizationsStddevPopFields>;
  stddevSamp?: Maybe<OrdersOrganizationsStddevSampFields>;
  sum?: Maybe<OrdersOrganizationsSumFields>;
  varPop?: Maybe<OrdersOrganizationsVarPopFields>;
  varSamp?: Maybe<OrdersOrganizationsVarSampFields>;
  variance?: Maybe<OrdersOrganizationsVarianceFields>;
};


/** aggregate fields of "orders.organizations" */
export type OrdersOrganizationsAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<OrdersOrganizationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type OrdersOrganizationsAvgFields = {
  __typename?: 'OrdersOrganizationsAvgFields';
  nrOfUsers?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "orders.organizations". All fields are combined with a logical 'AND'. */
export type OrdersOrganizationsBoolExp = {
  _and?: InputMaybe<Array<OrdersOrganizationsBoolExp>>;
  _not?: InputMaybe<OrdersOrganizationsBoolExp>;
  _or?: InputMaybe<Array<OrdersOrganizationsBoolExp>>;
  deliveryDate?: InputMaybe<TimestamptzComparisonExp>;
  firstName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lastName?: InputMaybe<StringComparisonExp>;
  mobileNumber?: InputMaybe<StringComparisonExp>;
  nrOfUsers?: InputMaybe<IntComparisonExp>;
  organizationName?: InputMaybe<StringComparisonExp>;
  organizationNumber?: InputMaybe<StringComparisonExp>;
  providerType?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "orders.organizations" */
export type OrdersOrganizationsConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'organizations_pkey'
  | '%future added value';

/** input type for incrementing numeric columns in table "orders.organizations" */
export type OrdersOrganizationsIncInput = {
  nrOfUsers?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "orders.organizations" */
export type OrdersOrganizationsInsertInput = {
  deliveryDate?: InputMaybe<Scalars['timestamptz']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  nrOfUsers?: InputMaybe<Scalars['Int']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
  providerType?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type OrdersOrganizationsMaxFields = {
  __typename?: 'OrdersOrganizationsMaxFields';
  deliveryDate?: Maybe<Scalars['timestamptz']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mobileNumber?: Maybe<Scalars['String']['output']>;
  nrOfUsers?: Maybe<Scalars['Int']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationNumber?: Maybe<Scalars['String']['output']>;
  providerType?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type OrdersOrganizationsMinFields = {
  __typename?: 'OrdersOrganizationsMinFields';
  deliveryDate?: Maybe<Scalars['timestamptz']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mobileNumber?: Maybe<Scalars['String']['output']>;
  nrOfUsers?: Maybe<Scalars['Int']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationNumber?: Maybe<Scalars['String']['output']>;
  providerType?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "orders.organizations" */
export type OrdersOrganizationsMutationResponse = {
  __typename?: 'OrdersOrganizationsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OrdersOrganizations>;
};

/** on_conflict condition type for table "orders.organizations" */
export type OrdersOrganizationsOnConflict = {
  constraint: OrdersOrganizationsConstraint;
  updateColumns?: Array<OrdersOrganizationsUpdateColumn>;
  where?: InputMaybe<OrdersOrganizationsBoolExp>;
};

/** Ordering options when selecting data from "orders.organizations". */
export type OrdersOrganizationsOrderBy = {
  deliveryDate?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  mobileNumber?: InputMaybe<OrderBy>;
  nrOfUsers?: InputMaybe<OrderBy>;
  organizationName?: InputMaybe<OrderBy>;
  organizationNumber?: InputMaybe<OrderBy>;
  providerType?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: orders.organizations */
export type OrdersOrganizationsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "orders.organizations" */
export type OrdersOrganizationsSelectColumn =
  /** column name */
  | 'deliveryDate'
  /** column name */
  | 'firstName'
  /** column name */
  | 'id'
  /** column name */
  | 'lastName'
  /** column name */
  | 'mobileNumber'
  /** column name */
  | 'nrOfUsers'
  /** column name */
  | 'organizationName'
  /** column name */
  | 'organizationNumber'
  /** column name */
  | 'providerType'
  | '%future added value';

/** input type for updating data in table "orders.organizations" */
export type OrdersOrganizationsSetInput = {
  deliveryDate?: InputMaybe<Scalars['timestamptz']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  nrOfUsers?: InputMaybe<Scalars['Int']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
  providerType?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type OrdersOrganizationsStddevFields = {
  __typename?: 'OrdersOrganizationsStddevFields';
  nrOfUsers?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type OrdersOrganizationsStddevPopFields = {
  __typename?: 'OrdersOrganizationsStddevPopFields';
  nrOfUsers?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type OrdersOrganizationsStddevSampFields = {
  __typename?: 'OrdersOrganizationsStddevSampFields';
  nrOfUsers?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "orders_organizations" */
export type OrdersOrganizationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: OrdersOrganizationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OrdersOrganizationsStreamCursorValueInput = {
  deliveryDate?: InputMaybe<Scalars['timestamptz']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  nrOfUsers?: InputMaybe<Scalars['Int']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
  providerType?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type OrdersOrganizationsSumFields = {
  __typename?: 'OrdersOrganizationsSumFields';
  nrOfUsers?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "orders.organizations" */
export type OrdersOrganizationsUpdateColumn =
  /** column name */
  | 'deliveryDate'
  /** column name */
  | 'firstName'
  /** column name */
  | 'id'
  /** column name */
  | 'lastName'
  /** column name */
  | 'mobileNumber'
  /** column name */
  | 'nrOfUsers'
  /** column name */
  | 'organizationName'
  /** column name */
  | 'organizationNumber'
  /** column name */
  | 'providerType'
  | '%future added value';

export type OrdersOrganizationsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<OrdersOrganizationsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrdersOrganizationsSetInput>;
  /** filter the rows which have to be updated */
  where: OrdersOrganizationsBoolExp;
};

/** aggregate varPop on columns */
export type OrdersOrganizationsVarPopFields = {
  __typename?: 'OrdersOrganizationsVarPopFields';
  nrOfUsers?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type OrdersOrganizationsVarSampFields = {
  __typename?: 'OrdersOrganizationsVarSampFields';
  nrOfUsers?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type OrdersOrganizationsVarianceFields = {
  __typename?: 'OrdersOrganizationsVarianceFields';
  nrOfUsers?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "orders.request" */
export type OrdersRequest = {
  __typename?: 'OrdersRequest';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "orders.request" */
export type OrdersRequestAggregate = {
  __typename?: 'OrdersRequestAggregate';
  aggregate?: Maybe<OrdersRequestAggregateFields>;
  nodes: Array<OrdersRequest>;
};

/** aggregate fields of "orders.request" */
export type OrdersRequestAggregateFields = {
  __typename?: 'OrdersRequestAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<OrdersRequestMaxFields>;
  min?: Maybe<OrdersRequestMinFields>;
};


/** aggregate fields of "orders.request" */
export type OrdersRequestAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<OrdersRequestSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "orders.request". All fields are combined with a logical 'AND'. */
export type OrdersRequestBoolExp = {
  _and?: InputMaybe<Array<OrdersRequestBoolExp>>;
  _not?: InputMaybe<OrdersRequestBoolExp>;
  _or?: InputMaybe<Array<OrdersRequestBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "orders.request" */
export type OrdersRequestConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'request_pkey'
  | '%future added value';

export type OrdersRequestEnum =
  /** order telphony */
  | 'TELEPHONY'
  | '%future added value';

/** Boolean expression to compare columns of type "OrdersRequestEnum". All fields are combined with logical 'AND'. */
export type OrdersRequestEnumComparisonExp = {
  _eq?: InputMaybe<OrdersRequestEnum>;
  _in?: InputMaybe<Array<OrdersRequestEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<OrdersRequestEnum>;
  _nin?: InputMaybe<Array<OrdersRequestEnum>>;
};

/** input type for inserting data into table "orders.request" */
export type OrdersRequestInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type OrdersRequestMaxFields = {
  __typename?: 'OrdersRequestMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type OrdersRequestMinFields = {
  __typename?: 'OrdersRequestMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "orders.request" */
export type OrdersRequestMutationResponse = {
  __typename?: 'OrdersRequestMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OrdersRequest>;
};

/** on_conflict condition type for table "orders.request" */
export type OrdersRequestOnConflict = {
  constraint: OrdersRequestConstraint;
  updateColumns?: Array<OrdersRequestUpdateColumn>;
  where?: InputMaybe<OrdersRequestBoolExp>;
};

/** Ordering options when selecting data from "orders.request". */
export type OrdersRequestOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: orders.request */
export type OrdersRequestPkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "orders.request" */
export type OrdersRequestSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "orders.request" */
export type OrdersRequestSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "orders_request" */
export type OrdersRequestStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: OrdersRequestStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OrdersRequestStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "orders.request" */
export type OrdersRequestUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type OrdersRequestUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrdersRequestSetInput>;
  /** filter the rows which have to be updated */
  where: OrdersRequestBoolExp;
};

/** columns and relationships of "orders.status" */
export type OrdersStatus = {
  __typename?: 'OrdersStatus';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "orders.status" */
export type OrdersStatusAggregate = {
  __typename?: 'OrdersStatusAggregate';
  aggregate?: Maybe<OrdersStatusAggregateFields>;
  nodes: Array<OrdersStatus>;
};

/** aggregate fields of "orders.status" */
export type OrdersStatusAggregateFields = {
  __typename?: 'OrdersStatusAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<OrdersStatusMaxFields>;
  min?: Maybe<OrdersStatusMinFields>;
};


/** aggregate fields of "orders.status" */
export type OrdersStatusAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<OrdersStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "orders.status". All fields are combined with a logical 'AND'. */
export type OrdersStatusBoolExp = {
  _and?: InputMaybe<Array<OrdersStatusBoolExp>>;
  _not?: InputMaybe<OrdersStatusBoolExp>;
  _or?: InputMaybe<Array<OrdersStatusBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "orders.status" */
export type OrdersStatusConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'status_pkey'
  | '%future added value';

export type OrdersStatusEnum =
  /** Connection established */
  | 'CONNECTED'
  /** Everything is fine */
  | 'DONE'
  /** A worker has this one inFocus */
  | 'INPROGRESS'
  /** In queue to provider */
  | 'PENDING'
  /** Rejected by provider */
  | 'REJECTED'
  | '%future added value';

/** Boolean expression to compare columns of type "OrdersStatusEnum". All fields are combined with logical 'AND'. */
export type OrdersStatusEnumComparisonExp = {
  _eq?: InputMaybe<OrdersStatusEnum>;
  _in?: InputMaybe<Array<OrdersStatusEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<OrdersStatusEnum>;
  _nin?: InputMaybe<Array<OrdersStatusEnum>>;
};

/** input type for inserting data into table "orders.status" */
export type OrdersStatusInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type OrdersStatusMaxFields = {
  __typename?: 'OrdersStatusMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type OrdersStatusMinFields = {
  __typename?: 'OrdersStatusMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "orders.status" */
export type OrdersStatusMutationResponse = {
  __typename?: 'OrdersStatusMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OrdersStatus>;
};

/** on_conflict condition type for table "orders.status" */
export type OrdersStatusOnConflict = {
  constraint: OrdersStatusConstraint;
  updateColumns?: Array<OrdersStatusUpdateColumn>;
  where?: InputMaybe<OrdersStatusBoolExp>;
};

/** Ordering options when selecting data from "orders.status". */
export type OrdersStatusOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: orders.status */
export type OrdersStatusPkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "orders.status" */
export type OrdersStatusSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "orders.status" */
export type OrdersStatusSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "orders_status" */
export type OrdersStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: OrdersStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OrdersStatusStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "orders.status" */
export type OrdersStatusUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type OrdersStatusUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrdersStatusSetInput>;
  /** filter the rows which have to be updated */
  where: OrdersStatusBoolExp;
};

/** columns and relationships of "orders.type" */
export type OrdersType = {
  __typename?: 'OrdersType';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "orders.type" */
export type OrdersTypeAggregate = {
  __typename?: 'OrdersTypeAggregate';
  aggregate?: Maybe<OrdersTypeAggregateFields>;
  nodes: Array<OrdersType>;
};

/** aggregate fields of "orders.type" */
export type OrdersTypeAggregateFields = {
  __typename?: 'OrdersTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<OrdersTypeMaxFields>;
  min?: Maybe<OrdersTypeMinFields>;
};


/** aggregate fields of "orders.type" */
export type OrdersTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<OrdersTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "orders.type". All fields are combined with a logical 'AND'. */
export type OrdersTypeBoolExp = {
  _and?: InputMaybe<Array<OrdersTypeBoolExp>>;
  _not?: InputMaybe<OrdersTypeBoolExp>;
  _or?: InputMaybe<Array<OrdersTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "orders.type" */
export type OrdersTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'type_pkey'
  | '%future added value';

export type OrdersTypeEnum =
  /** Phonero order */
  | 'PHONERO'
  /** PHONERO_SMART_CONNECT */
  | 'PHONERO_SMART_CONNECT'
  /** Telenor order */
  | 'TELENOR'
  /** Telia order */
  | 'TELIA'
  /** Telia smartconnect order */
  | 'TELIA_SMART_CONNECT'
  | '%future added value';

/** Boolean expression to compare columns of type "OrdersTypeEnum". All fields are combined with logical 'AND'. */
export type OrdersTypeEnumComparisonExp = {
  _eq?: InputMaybe<OrdersTypeEnum>;
  _in?: InputMaybe<Array<OrdersTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<OrdersTypeEnum>;
  _nin?: InputMaybe<Array<OrdersTypeEnum>>;
};

/** input type for inserting data into table "orders.type" */
export type OrdersTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type OrdersTypeMaxFields = {
  __typename?: 'OrdersTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type OrdersTypeMinFields = {
  __typename?: 'OrdersTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "orders.type" */
export type OrdersTypeMutationResponse = {
  __typename?: 'OrdersTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OrdersType>;
};

/** on_conflict condition type for table "orders.type" */
export type OrdersTypeOnConflict = {
  constraint: OrdersTypeConstraint;
  updateColumns?: Array<OrdersTypeUpdateColumn>;
  where?: InputMaybe<OrdersTypeBoolExp>;
};

/** Ordering options when selecting data from "orders.type". */
export type OrdersTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: orders.type */
export type OrdersTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "orders.type" */
export type OrdersTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "orders.type" */
export type OrdersTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "orders_type" */
export type OrdersTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: OrdersTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OrdersTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "orders.type" */
export type OrdersTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type OrdersTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrdersTypeSetInput>;
  /** filter the rows which have to be updated */
  where: OrdersTypeBoolExp;
};

export type OrganizationOutput = {
  __typename?: 'OrganizationOutput';
  organization?: Maybe<Scalars['json']['output']>;
};

/** columns and relationships of "business.organization_user_attention_note" */
export type OrganizationUserAttentionNote = {
  __typename?: 'OrganizationUserAttentionNote';
  createdAt: Scalars['timestamptz']['output'];
  createdByUser: Scalars['uuid']['output'];
  createdOnUser: Scalars['uuid']['output'];
  /** An object relationship */
  creator?: Maybe<organizationUser>;
  id: Scalars['uuid']['output'];
  note: Scalars['String']['output'];
  /** An object relationship */
  subjectUser?: Maybe<organizationUser>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "business.organization_user_attention_note" */
export type OrganizationUserAttentionNoteAggregate = {
  __typename?: 'OrganizationUserAttentionNoteAggregate';
  aggregate?: Maybe<OrganizationUserAttentionNoteAggregateFields>;
  nodes: Array<OrganizationUserAttentionNote>;
};

/** aggregate fields of "business.organization_user_attention_note" */
export type OrganizationUserAttentionNoteAggregateFields = {
  __typename?: 'OrganizationUserAttentionNoteAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<OrganizationUserAttentionNoteMaxFields>;
  min?: Maybe<OrganizationUserAttentionNoteMinFields>;
};


/** aggregate fields of "business.organization_user_attention_note" */
export type OrganizationUserAttentionNoteAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<OrganizationUserAttentionNoteSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.organization_user_attention_note". All fields are combined with a logical 'AND'. */
export type OrganizationUserAttentionNoteBoolExp = {
  _and?: InputMaybe<Array<OrganizationUserAttentionNoteBoolExp>>;
  _not?: InputMaybe<OrganizationUserAttentionNoteBoolExp>;
  _or?: InputMaybe<Array<OrganizationUserAttentionNoteBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUser?: InputMaybe<UuidComparisonExp>;
  createdOnUser?: InputMaybe<UuidComparisonExp>;
  creator?: InputMaybe<organizationUserBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  note?: InputMaybe<StringComparisonExp>;
  subjectUser?: InputMaybe<organizationUserBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "business.organization_user_attention_note" */
export type OrganizationUserAttentionNoteConstraint =
  /** unique or primary key constraint on columns "created_by_user", "created_on_user" */
  | 'organization_user_attention_note_created_by_user_created_on_use'
  /** unique or primary key constraint on columns "id" */
  | 'organization_user_attention_note_pkey'
  | '%future added value';

/** input type for inserting data into table "business.organization_user_attention_note" */
export type OrganizationUserAttentionNoteInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUser?: InputMaybe<Scalars['uuid']['input']>;
  createdOnUser?: InputMaybe<Scalars['uuid']['input']>;
  creator?: InputMaybe<organizationUserObjRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  subjectUser?: InputMaybe<organizationUserObjRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type OrganizationUserAttentionNoteMaxFields = {
  __typename?: 'OrganizationUserAttentionNoteMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUser?: Maybe<Scalars['uuid']['output']>;
  createdOnUser?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type OrganizationUserAttentionNoteMinFields = {
  __typename?: 'OrganizationUserAttentionNoteMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUser?: Maybe<Scalars['uuid']['output']>;
  createdOnUser?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "business.organization_user_attention_note" */
export type OrganizationUserAttentionNoteMutationResponse = {
  __typename?: 'OrganizationUserAttentionNoteMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OrganizationUserAttentionNote>;
};

/** on_conflict condition type for table "business.organization_user_attention_note" */
export type OrganizationUserAttentionNoteOnConflict = {
  constraint: OrganizationUserAttentionNoteConstraint;
  updateColumns?: Array<OrganizationUserAttentionNoteUpdateColumn>;
  where?: InputMaybe<OrganizationUserAttentionNoteBoolExp>;
};

/** Ordering options when selecting data from "business.organization_user_attention_note". */
export type OrganizationUserAttentionNoteOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdByUser?: InputMaybe<OrderBy>;
  createdOnUser?: InputMaybe<OrderBy>;
  creator?: InputMaybe<organizationUserOrderBy>;
  id?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  subjectUser?: InputMaybe<organizationUserOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.organization_user_attention_note */
export type OrganizationUserAttentionNotePkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "business.organization_user_attention_note" */
export type OrganizationUserAttentionNoteSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUser'
  /** column name */
  | 'createdOnUser'
  /** column name */
  | 'id'
  /** column name */
  | 'note'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "business.organization_user_attention_note" */
export type OrganizationUserAttentionNoteSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUser?: InputMaybe<Scalars['uuid']['input']>;
  createdOnUser?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "OrganizationUserAttentionNote" */
export type OrganizationUserAttentionNoteStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: OrganizationUserAttentionNoteStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OrganizationUserAttentionNoteStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUser?: InputMaybe<Scalars['uuid']['input']>;
  createdOnUser?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "business.organization_user_attention_note" */
export type OrganizationUserAttentionNoteUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUser'
  /** column name */
  | 'createdOnUser'
  /** column name */
  | 'id'
  /** column name */
  | 'note'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type OrganizationUserAttentionNoteUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrganizationUserAttentionNoteSetInput>;
  /** filter the rows which have to be updated */
  where: OrganizationUserAttentionNoteBoolExp;
};

/** Boolean expression to compare columns of type "organizationUserAuthorizationEnum". All fields are combined with logical 'AND'. */
export type OrganizationUserAuthorizationEnumComparisonExp = {
  _eq?: InputMaybe<organizationUserAuthorizationEnum>;
  _in?: InputMaybe<Array<organizationUserAuthorizationEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<organizationUserAuthorizationEnum>;
  _nin?: InputMaybe<Array<organizationUserAuthorizationEnum>>;
};

/** Boolean expression to compare columns of type "organizationUserDetailTypeEnum". All fields are combined with logical 'AND'. */
export type OrganizationUserDetailTypeEnumComparisonExp = {
  _eq?: InputMaybe<organizationUserDetailTypeEnum>;
  _in?: InputMaybe<Array<organizationUserDetailTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<organizationUserDetailTypeEnum>;
  _nin?: InputMaybe<Array<organizationUserDetailTypeEnum>>;
};

/** Boolean expression to compare columns of type "organizationUserStatusEnum". All fields are combined with logical 'AND'. */
export type OrganizationUserStatusEnumComparisonExp = {
  _eq?: InputMaybe<organizationUserStatusEnum>;
  _in?: InputMaybe<Array<organizationUserStatusEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<organizationUserStatusEnum>;
  _nin?: InputMaybe<Array<organizationUserStatusEnum>>;
};

export type OrganizationsOutput = {
  __typename?: 'OrganizationsOutput';
  organizations?: Maybe<Scalars['json']['output']>;
};

/** Boolean expression to compare columns of type "phoneNumberVerificationStatusEnum". All fields are combined with logical 'AND'. */
export type PhoneNumberVerificationStatusEnumComparisonExp = {
  _eq?: InputMaybe<phoneNumberVerificationStatusEnum>;
  _in?: InputMaybe<Array<phoneNumberVerificationStatusEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<phoneNumberVerificationStatusEnum>;
  _nin?: InputMaybe<Array<phoneNumberVerificationStatusEnum>>;
};

export type PhoneRequestInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  callId?: InputMaybe<Scalars['String']['input']>;
  callingNumber?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  destinationNumber?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type PhoneRequestOutput = {
  __typename?: 'PhoneRequestOutput';
  id: Scalars['String']['output'];
};

/** columns and relationships of "prompt" */
export type Prompt = {
  __typename?: 'Prompt';
  createdAt: Scalars['timestamptz']['output'];
  endCallFunctionDescription?: Maybe<Scalars['String']['output']>;
  greet: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  systemTranscribe?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  userTranscribe?: Maybe<Scalars['String']['output']>;
  voice: VoiceTypesEnum;
};

/** aggregated selection of "prompt" */
export type PromptAggregate = {
  __typename?: 'PromptAggregate';
  aggregate?: Maybe<PromptAggregateFields>;
  nodes: Array<Prompt>;
};

/** aggregate fields of "prompt" */
export type PromptAggregateFields = {
  __typename?: 'PromptAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<PromptMaxFields>;
  min?: Maybe<PromptMinFields>;
};


/** aggregate fields of "prompt" */
export type PromptAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<PromptSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "prompt". All fields are combined with a logical 'AND'. */
export type PromptBoolExp = {
  _and?: InputMaybe<Array<PromptBoolExp>>;
  _not?: InputMaybe<PromptBoolExp>;
  _or?: InputMaybe<Array<PromptBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  endCallFunctionDescription?: InputMaybe<StringComparisonExp>;
  greet?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  summary?: InputMaybe<StringComparisonExp>;
  systemTranscribe?: InputMaybe<StringComparisonExp>;
  text?: InputMaybe<StringComparisonExp>;
  userTranscribe?: InputMaybe<StringComparisonExp>;
  voice?: InputMaybe<VoiceTypesEnumComparisonExp>;
};

/** unique or primary key constraints on table "prompt" */
export type PromptConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'prompt_pkey'
  | '%future added value';

/** input type for inserting data into table "prompt" */
export type PromptInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endCallFunctionDescription?: InputMaybe<Scalars['String']['input']>;
  greet?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  systemTranscribe?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  userTranscribe?: InputMaybe<Scalars['String']['input']>;
  voice?: InputMaybe<VoiceTypesEnum>;
};

/** aggregate max on columns */
export type PromptMaxFields = {
  __typename?: 'PromptMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  endCallFunctionDescription?: Maybe<Scalars['String']['output']>;
  greet?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  systemTranscribe?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  userTranscribe?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type PromptMinFields = {
  __typename?: 'PromptMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  endCallFunctionDescription?: Maybe<Scalars['String']['output']>;
  greet?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  systemTranscribe?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  userTranscribe?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "prompt" */
export type PromptMutationResponse = {
  __typename?: 'PromptMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Prompt>;
};

/** on_conflict condition type for table "prompt" */
export type PromptOnConflict = {
  constraint: PromptConstraint;
  updateColumns?: Array<PromptUpdateColumn>;
  where?: InputMaybe<PromptBoolExp>;
};

/** Ordering options when selecting data from "prompt". */
export type PromptOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  endCallFunctionDescription?: InputMaybe<OrderBy>;
  greet?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
  systemTranscribe?: InputMaybe<OrderBy>;
  text?: InputMaybe<OrderBy>;
  userTranscribe?: InputMaybe<OrderBy>;
  voice?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: prompt */
export type PromptPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "prompt" */
export type PromptSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'endCallFunctionDescription'
  /** column name */
  | 'greet'
  /** column name */
  | 'id'
  /** column name */
  | 'summary'
  /** column name */
  | 'systemTranscribe'
  /** column name */
  | 'text'
  /** column name */
  | 'userTranscribe'
  /** column name */
  | 'voice'
  | '%future added value';

/** input type for updating data in table "prompt" */
export type PromptSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endCallFunctionDescription?: InputMaybe<Scalars['String']['input']>;
  greet?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  systemTranscribe?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  userTranscribe?: InputMaybe<Scalars['String']['input']>;
  voice?: InputMaybe<VoiceTypesEnum>;
};

/** Streaming cursor of the table "prompt" */
export type PromptStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PromptStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PromptStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endCallFunctionDescription?: InputMaybe<Scalars['String']['input']>;
  greet?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  systemTranscribe?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  userTranscribe?: InputMaybe<Scalars['String']['input']>;
  voice?: InputMaybe<VoiceTypesEnum>;
};

/** update columns of table "prompt" */
export type PromptUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'endCallFunctionDescription'
  /** column name */
  | 'greet'
  /** column name */
  | 'id'
  /** column name */
  | 'summary'
  /** column name */
  | 'systemTranscribe'
  /** column name */
  | 'text'
  /** column name */
  | 'userTranscribe'
  /** column name */
  | 'voice'
  | '%future added value';

export type PromptUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PromptSetInput>;
  /** filter the rows which have to be updated */
  where: PromptBoolExp;
};

export type ProviderType =
  | 'PHONERO'
  | 'PHONERO_SMART_CONNECT'
  | 'TELIA'
  | 'TELIA_SMART_CONNECT'
  | '%future added value';

export type ProviderTypeEmail =
  | 'GMAIL'
  | 'MICROSOFT'
  | '%future added value';

/** columns and relationships of "business.queue_item_flexibility_type" */
export type QueueItemFlexibilityType = {
  __typename?: 'QueueItemFlexibilityType';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "business.queue_item_flexibility_type" */
export type QueueItemFlexibilityTypeAggregate = {
  __typename?: 'QueueItemFlexibilityTypeAggregate';
  aggregate?: Maybe<QueueItemFlexibilityTypeAggregateFields>;
  nodes: Array<QueueItemFlexibilityType>;
};

/** aggregate fields of "business.queue_item_flexibility_type" */
export type QueueItemFlexibilityTypeAggregateFields = {
  __typename?: 'QueueItemFlexibilityTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<QueueItemFlexibilityTypeMaxFields>;
  min?: Maybe<QueueItemFlexibilityTypeMinFields>;
};


/** aggregate fields of "business.queue_item_flexibility_type" */
export type QueueItemFlexibilityTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<QueueItemFlexibilityTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.queue_item_flexibility_type". All fields are combined with a logical 'AND'. */
export type QueueItemFlexibilityTypeBoolExp = {
  _and?: InputMaybe<Array<QueueItemFlexibilityTypeBoolExp>>;
  _not?: InputMaybe<QueueItemFlexibilityTypeBoolExp>;
  _or?: InputMaybe<Array<QueueItemFlexibilityTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.queue_item_flexibility_type" */
export type QueueItemFlexibilityTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'queue_item_flexibility_type_pkey'
  | '%future added value';

/** input type for inserting data into table "business.queue_item_flexibility_type" */
export type QueueItemFlexibilityTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type QueueItemFlexibilityTypeMaxFields = {
  __typename?: 'QueueItemFlexibilityTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type QueueItemFlexibilityTypeMinFields = {
  __typename?: 'QueueItemFlexibilityTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.queue_item_flexibility_type" */
export type QueueItemFlexibilityTypeMutationResponse = {
  __typename?: 'QueueItemFlexibilityTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<QueueItemFlexibilityType>;
};

/** input type for inserting object relation for remote table "business.queue_item_flexibility_type" */
export type QueueItemFlexibilityTypeObjRelInsertInput = {
  data: QueueItemFlexibilityTypeInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<QueueItemFlexibilityTypeOnConflict>;
};

/** on_conflict condition type for table "business.queue_item_flexibility_type" */
export type QueueItemFlexibilityTypeOnConflict = {
  constraint: QueueItemFlexibilityTypeConstraint;
  updateColumns?: Array<QueueItemFlexibilityTypeUpdateColumn>;
  where?: InputMaybe<QueueItemFlexibilityTypeBoolExp>;
};

/** Ordering options when selecting data from "business.queue_item_flexibility_type". */
export type QueueItemFlexibilityTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.queue_item_flexibility_type */
export type QueueItemFlexibilityTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "business.queue_item_flexibility_type" */
export type QueueItemFlexibilityTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "business.queue_item_flexibility_type" */
export type QueueItemFlexibilityTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "QueueItemFlexibilityType" */
export type QueueItemFlexibilityTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: QueueItemFlexibilityTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type QueueItemFlexibilityTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.queue_item_flexibility_type" */
export type QueueItemFlexibilityTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type QueueItemFlexibilityTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<QueueItemFlexibilityTypeSetInput>;
  /** filter the rows which have to be updated */
  where: QueueItemFlexibilityTypeBoolExp;
};

/** columns and relationships of "business.queue_item_participant_responsibiliy_type" */
export type QueueItemParticipantResponsibilityType = {
  __typename?: 'QueueItemParticipantResponsibilityType';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "business.queue_item_participant_responsibiliy_type" */
export type QueueItemParticipantResponsibilityTypeAggregate = {
  __typename?: 'QueueItemParticipantResponsibilityTypeAggregate';
  aggregate?: Maybe<QueueItemParticipantResponsibilityTypeAggregateFields>;
  nodes: Array<QueueItemParticipantResponsibilityType>;
};

/** aggregate fields of "business.queue_item_participant_responsibiliy_type" */
export type QueueItemParticipantResponsibilityTypeAggregateFields = {
  __typename?: 'QueueItemParticipantResponsibilityTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<QueueItemParticipantResponsibilityTypeMaxFields>;
  min?: Maybe<QueueItemParticipantResponsibilityTypeMinFields>;
};


/** aggregate fields of "business.queue_item_participant_responsibiliy_type" */
export type QueueItemParticipantResponsibilityTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<QueueItemParticipantResponsibilityTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.queue_item_participant_responsibiliy_type". All fields are combined with a logical 'AND'. */
export type QueueItemParticipantResponsibilityTypeBoolExp = {
  _and?: InputMaybe<Array<QueueItemParticipantResponsibilityTypeBoolExp>>;
  _not?: InputMaybe<QueueItemParticipantResponsibilityTypeBoolExp>;
  _or?: InputMaybe<Array<QueueItemParticipantResponsibilityTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.queue_item_participant_responsibiliy_type" */
export type QueueItemParticipantResponsibilityTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'queue_item_participant_responsibiliy_type_pkey'
  | '%future added value';

export type QueueItemParticipantResponsibilityTypeEnum =
  /** company */
  | 'COMPANY'
  /** customer */
  | 'CUSTOMER'
  /** Employee */
  | 'EMPLOYEE'
  /** owner */
  | 'OWNER'
  /** participant */
  | 'PARTICIPANT'
  /** responsible */
  | 'RESPONSIBLE'
  | '%future added value';

/** Boolean expression to compare columns of type "QueueItemParticipantResponsibilityTypeEnum". All fields are combined with logical 'AND'. */
export type QueueItemParticipantResponsibilityTypeEnumComparisonExp = {
  _eq?: InputMaybe<QueueItemParticipantResponsibilityTypeEnum>;
  _in?: InputMaybe<Array<QueueItemParticipantResponsibilityTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<QueueItemParticipantResponsibilityTypeEnum>;
  _nin?: InputMaybe<Array<QueueItemParticipantResponsibilityTypeEnum>>;
};

/** input type for inserting data into table "business.queue_item_participant_responsibiliy_type" */
export type QueueItemParticipantResponsibilityTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type QueueItemParticipantResponsibilityTypeMaxFields = {
  __typename?: 'QueueItemParticipantResponsibilityTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type QueueItemParticipantResponsibilityTypeMinFields = {
  __typename?: 'QueueItemParticipantResponsibilityTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.queue_item_participant_responsibiliy_type" */
export type QueueItemParticipantResponsibilityTypeMutationResponse = {
  __typename?: 'QueueItemParticipantResponsibilityTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<QueueItemParticipantResponsibilityType>;
};

/** input type for inserting object relation for remote table "business.queue_item_participant_responsibiliy_type" */
export type QueueItemParticipantResponsibilityTypeObjRelInsertInput = {
  data: QueueItemParticipantResponsibilityTypeInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<QueueItemParticipantResponsibilityTypeOnConflict>;
};

/** on_conflict condition type for table "business.queue_item_participant_responsibiliy_type" */
export type QueueItemParticipantResponsibilityTypeOnConflict = {
  constraint: QueueItemParticipantResponsibilityTypeConstraint;
  updateColumns?: Array<QueueItemParticipantResponsibilityTypeUpdateColumn>;
  where?: InputMaybe<QueueItemParticipantResponsibilityTypeBoolExp>;
};

/** Ordering options when selecting data from "business.queue_item_participant_responsibiliy_type". */
export type QueueItemParticipantResponsibilityTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.queue_item_participant_responsibiliy_type */
export type QueueItemParticipantResponsibilityTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "business.queue_item_participant_responsibiliy_type" */
export type QueueItemParticipantResponsibilityTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "business.queue_item_participant_responsibiliy_type" */
export type QueueItemParticipantResponsibilityTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "QueueItemParticipantResponsibilityType" */
export type QueueItemParticipantResponsibilityTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: QueueItemParticipantResponsibilityTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type QueueItemParticipantResponsibilityTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.queue_item_participant_responsibiliy_type" */
export type QueueItemParticipantResponsibilityTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type QueueItemParticipantResponsibilityTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<QueueItemParticipantResponsibilityTypeSetInput>;
  /** filter the rows which have to be updated */
  where: QueueItemParticipantResponsibilityTypeBoolExp;
};

/** columns and relationships of "code" */
export type RegistryCode = {
  __typename?: 'RegistryCode';
  beskrivelse?: Maybe<Scalars['String']['output']>;
  hjelpeenhetskode?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Registryuuid']['output'];
  kode?: Maybe<Scalars['String']['output']>;
  organizationInstitusjonellSektorkode?: Maybe<Scalars['Registryuuid']['output']>;
  organizationNaeringskode1?: Maybe<Scalars['Registryuuid']['output']>;
  organizationNaeringskode2?: Maybe<Scalars['Registryuuid']['output']>;
  organizationNaeringskode3?: Maybe<Scalars['Registryuuid']['output']>;
};

/** aggregated selection of "code" */
export type RegistryCodeAggregate = {
  __typename?: 'RegistryCodeAggregate';
  aggregate?: Maybe<RegistryCodeAggregateFields>;
  nodes: Array<RegistryCode>;
};

/** aggregate fields of "code" */
export type RegistryCodeAggregateFields = {
  __typename?: 'RegistryCodeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<RegistryCodeMaxFields>;
  min?: Maybe<RegistryCodeMinFields>;
};


/** aggregate fields of "code" */
export type RegistryCodeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<RegistryCodeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "code". All fields are combined with a logical 'AND'. */
export type RegistryCodeBoolExp = {
  _and?: InputMaybe<Array<RegistryCodeBoolExp>>;
  _not?: InputMaybe<RegistryCodeBoolExp>;
  _or?: InputMaybe<Array<RegistryCodeBoolExp>>;
  beskrivelse?: InputMaybe<TaskStringComparisonExp>;
  hjelpeenhetskode?: InputMaybe<TelephonyBooleanComparisonExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  kode?: InputMaybe<TaskStringComparisonExp>;
  organizationInstitusjonellSektorkode?: InputMaybe<TaskUuidComparisonExp>;
  organizationNaeringskode1?: InputMaybe<TaskUuidComparisonExp>;
  organizationNaeringskode2?: InputMaybe<TaskUuidComparisonExp>;
  organizationNaeringskode3?: InputMaybe<TaskUuidComparisonExp>;
};

/** unique or primary key constraints on table "code" */
export type RegistryCodeConstraint =
  /** unique or primary key constraint on columns "organization_institusjonellSektorkode" */
  | 'code_organization_institusjonellSektorkode_key'
  /** unique or primary key constraint on columns "organization_naeringskode1" */
  | 'code_organization_naeringskode1_key'
  /** unique or primary key constraint on columns "organization_naeringskode2" */
  | 'code_organization_naeringskode2_key'
  /** unique or primary key constraint on columns "organization_naeringskode3" */
  | 'code_organization_naeringskode3_key'
  /** unique or primary key constraint on columns "id" */
  | 'code_pkey'
  | '%future added value';

/** input type for inserting data into table "code" */
export type RegistryCodeInsertInput = {
  beskrivelse?: InputMaybe<Scalars['String']['input']>;
  hjelpeenhetskode?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Registryuuid']['input']>;
  kode?: InputMaybe<Scalars['String']['input']>;
  organizationInstitusjonellSektorkode?: InputMaybe<Scalars['Registryuuid']['input']>;
  organizationNaeringskode1?: InputMaybe<Scalars['Registryuuid']['input']>;
  organizationNaeringskode2?: InputMaybe<Scalars['Registryuuid']['input']>;
  organizationNaeringskode3?: InputMaybe<Scalars['Registryuuid']['input']>;
};

/** aggregate max on columns */
export type RegistryCodeMaxFields = {
  __typename?: 'RegistryCodeMaxFields';
  beskrivelse?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Registryuuid']['output']>;
  kode?: Maybe<Scalars['String']['output']>;
  organizationInstitusjonellSektorkode?: Maybe<Scalars['Registryuuid']['output']>;
  organizationNaeringskode1?: Maybe<Scalars['Registryuuid']['output']>;
  organizationNaeringskode2?: Maybe<Scalars['Registryuuid']['output']>;
  organizationNaeringskode3?: Maybe<Scalars['Registryuuid']['output']>;
};

/** aggregate min on columns */
export type RegistryCodeMinFields = {
  __typename?: 'RegistryCodeMinFields';
  beskrivelse?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Registryuuid']['output']>;
  kode?: Maybe<Scalars['String']['output']>;
  organizationInstitusjonellSektorkode?: Maybe<Scalars['Registryuuid']['output']>;
  organizationNaeringskode1?: Maybe<Scalars['Registryuuid']['output']>;
  organizationNaeringskode2?: Maybe<Scalars['Registryuuid']['output']>;
  organizationNaeringskode3?: Maybe<Scalars['Registryuuid']['output']>;
};

/** response of any mutation on the table "code" */
export type RegistryCodeMutationResponse = {
  __typename?: 'RegistryCodeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RegistryCode>;
};

/** input type for inserting object relation for remote table "code" */
export type RegistryCodeObjRelInsertInput = {
  data: RegistryCodeInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<RegistryCodeOnConflict>;
};

/** on_conflict condition type for table "code" */
export type RegistryCodeOnConflict = {
  constraint: RegistryCodeConstraint;
  updateColumns?: Array<RegistryCodeUpdateColumn>;
  where?: InputMaybe<RegistryCodeBoolExp>;
};

/** Ordering options when selecting data from "code". */
export type RegistryCodeOrderBy = {
  beskrivelse?: InputMaybe<RegistryOrderBy>;
  hjelpeenhetskode?: InputMaybe<RegistryOrderBy>;
  id?: InputMaybe<RegistryOrderBy>;
  kode?: InputMaybe<RegistryOrderBy>;
  organizationInstitusjonellSektorkode?: InputMaybe<RegistryOrderBy>;
  organizationNaeringskode1?: InputMaybe<RegistryOrderBy>;
  organizationNaeringskode2?: InputMaybe<RegistryOrderBy>;
  organizationNaeringskode3?: InputMaybe<RegistryOrderBy>;
};

/** primary key columns input for table: code */
export type RegistryCodePkColumnsInput = {
  id: Scalars['Registryuuid']['input'];
};

/** select columns of table "code" */
export type RegistryCodeSelectColumn =
  /** column name */
  | 'beskrivelse'
  /** column name */
  | 'hjelpeenhetskode'
  /** column name */
  | 'id'
  /** column name */
  | 'kode'
  /** column name */
  | 'organizationInstitusjonellSektorkode'
  /** column name */
  | 'organizationNaeringskode1'
  /** column name */
  | 'organizationNaeringskode2'
  /** column name */
  | 'organizationNaeringskode3'
  | '%future added value';

/** input type for updating data in table "code" */
export type RegistryCodeSetInput = {
  beskrivelse?: InputMaybe<Scalars['String']['input']>;
  hjelpeenhetskode?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Registryuuid']['input']>;
  kode?: InputMaybe<Scalars['String']['input']>;
  organizationInstitusjonellSektorkode?: InputMaybe<Scalars['Registryuuid']['input']>;
  organizationNaeringskode1?: InputMaybe<Scalars['Registryuuid']['input']>;
  organizationNaeringskode2?: InputMaybe<Scalars['Registryuuid']['input']>;
  organizationNaeringskode3?: InputMaybe<Scalars['Registryuuid']['input']>;
};

/** Streaming cursor of the table "code" */
export type RegistryCodeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RegistryCodeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<RegistryCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RegistryCodeStreamCursorValueInput = {
  beskrivelse?: InputMaybe<Scalars['String']['input']>;
  hjelpeenhetskode?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Registryuuid']['input']>;
  kode?: InputMaybe<Scalars['String']['input']>;
  organizationInstitusjonellSektorkode?: InputMaybe<Scalars['Registryuuid']['input']>;
  organizationNaeringskode1?: InputMaybe<Scalars['Registryuuid']['input']>;
  organizationNaeringskode2?: InputMaybe<Scalars['Registryuuid']['input']>;
  organizationNaeringskode3?: InputMaybe<Scalars['Registryuuid']['input']>;
};

/** update columns of table "code" */
export type RegistryCodeUpdateColumn =
  /** column name */
  | 'beskrivelse'
  /** column name */
  | 'hjelpeenhetskode'
  /** column name */
  | 'id'
  /** column name */
  | 'kode'
  /** column name */
  | 'organizationInstitusjonellSektorkode'
  /** column name */
  | 'organizationNaeringskode1'
  /** column name */
  | 'organizationNaeringskode2'
  /** column name */
  | 'organizationNaeringskode3'
  | '%future added value';

export type RegistryCodeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RegistryCodeSetInput>;
  /** filter the rows which have to be updated */
  where: RegistryCodeBoolExp;
};

/** ordering argument of a cursor */
export type RegistryCursorOrdering =
  /** ascending ordering of the cursor */
  | 'ASC'
  /** descending ordering of the cursor */
  | 'DESC'
  | '%future added value';

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type RegistryDateComparisonExp = {
  _eq?: InputMaybe<Scalars['Registrydate']['input']>;
  _gt?: InputMaybe<Scalars['Registrydate']['input']>;
  _gte?: InputMaybe<Scalars['Registrydate']['input']>;
  _in?: InputMaybe<Array<Scalars['Registrydate']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Registrydate']['input']>;
  _lte?: InputMaybe<Scalars['Registrydate']['input']>;
  _neq?: InputMaybe<Scalars['Registrydate']['input']>;
  _nin?: InputMaybe<Array<Scalars['Registrydate']['input']>>;
};

/** columns and relationships of "info" */
export type RegistryInfo = {
  __typename?: 'RegistryInfo';
  id: Scalars['Registryuuid']['output'];
  lastUpdated: Scalars['Registrydate']['output'];
};

/** aggregated selection of "info" */
export type RegistryInfoAggregate = {
  __typename?: 'RegistryInfoAggregate';
  aggregate?: Maybe<RegistryInfoAggregateFields>;
  nodes: Array<RegistryInfo>;
};

/** aggregate fields of "info" */
export type RegistryInfoAggregateFields = {
  __typename?: 'RegistryInfoAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<RegistryInfoMaxFields>;
  min?: Maybe<RegistryInfoMinFields>;
};


/** aggregate fields of "info" */
export type RegistryInfoAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<RegistryInfoSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "info". All fields are combined with a logical 'AND'. */
export type RegistryInfoBoolExp = {
  _and?: InputMaybe<Array<RegistryInfoBoolExp>>;
  _not?: InputMaybe<RegistryInfoBoolExp>;
  _or?: InputMaybe<Array<RegistryInfoBoolExp>>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  lastUpdated?: InputMaybe<RegistryDateComparisonExp>;
};

/** unique or primary key constraints on table "info" */
export type RegistryInfoConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'info_pkey'
  | '%future added value';

/** input type for inserting data into table "info" */
export type RegistryInfoInsertInput = {
  id?: InputMaybe<Scalars['Registryuuid']['input']>;
  lastUpdated?: InputMaybe<Scalars['Registrydate']['input']>;
};

/** aggregate max on columns */
export type RegistryInfoMaxFields = {
  __typename?: 'RegistryInfoMaxFields';
  id?: Maybe<Scalars['Registryuuid']['output']>;
  lastUpdated?: Maybe<Scalars['Registrydate']['output']>;
};

/** aggregate min on columns */
export type RegistryInfoMinFields = {
  __typename?: 'RegistryInfoMinFields';
  id?: Maybe<Scalars['Registryuuid']['output']>;
  lastUpdated?: Maybe<Scalars['Registrydate']['output']>;
};

/** response of any mutation on the table "info" */
export type RegistryInfoMutationResponse = {
  __typename?: 'RegistryInfoMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RegistryInfo>;
};

/** on_conflict condition type for table "info" */
export type RegistryInfoOnConflict = {
  constraint: RegistryInfoConstraint;
  updateColumns?: Array<RegistryInfoUpdateColumn>;
  where?: InputMaybe<RegistryInfoBoolExp>;
};

/** Ordering options when selecting data from "info". */
export type RegistryInfoOrderBy = {
  id?: InputMaybe<RegistryOrderBy>;
  lastUpdated?: InputMaybe<RegistryOrderBy>;
};

/** primary key columns input for table: info */
export type RegistryInfoPkColumnsInput = {
  id: Scalars['Registryuuid']['input'];
};

/** select columns of table "info" */
export type RegistryInfoSelectColumn =
  /** column name */
  | 'id'
  /** column name */
  | 'lastUpdated'
  | '%future added value';

/** input type for updating data in table "info" */
export type RegistryInfoSetInput = {
  id?: InputMaybe<Scalars['Registryuuid']['input']>;
  lastUpdated?: InputMaybe<Scalars['Registrydate']['input']>;
};

/** Streaming cursor of the table "info" */
export type RegistryInfoStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RegistryInfoStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<RegistryCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RegistryInfoStreamCursorValueInput = {
  id?: InputMaybe<Scalars['Registryuuid']['input']>;
  lastUpdated?: InputMaybe<Scalars['Registrydate']['input']>;
};

/** update columns of table "info" */
export type RegistryInfoUpdateColumn =
  /** column name */
  | 'id'
  /** column name */
  | 'lastUpdated'
  | '%future added value';

export type RegistryInfoUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RegistryInfoSetInput>;
  /** filter the rows which have to be updated */
  where: RegistryInfoBoolExp;
};

/** column ordering options */
export type RegistryOrderBy =
  /** in ascending order, nulls last */
  | 'ASC'
  /** in ascending order, nulls first */
  | 'ASC_NULLS_FIRST'
  /** in ascending order, nulls last */
  | 'ASC_NULLS_LAST'
  /** in descending order, nulls first */
  | 'DESC'
  /** in descending order, nulls first */
  | 'DESC_NULLS_FIRST'
  /** in descending order, nulls last */
  | 'DESC_NULLS_LAST'
  | '%future added value';

/** columns and relationships of "organisasjonsform" */
export type RegistryOrganisasjonsform = {
  __typename?: 'RegistryOrganisasjonsform';
  _links?: Maybe<Scalars['Registryjsonb']['output']>;
  beskrivelse: Scalars['String']['output'];
  id: Scalars['Registryuuid']['output'];
  kode: Scalars['String']['output'];
  links?: Maybe<Scalars['Registryjsonb']['output']>;
  organizationOrganisasjonsform?: Maybe<Scalars['Registryuuid']['output']>;
};


/** columns and relationships of "organisasjonsform" */
export type RegistryOrganisasjonsform_linksArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "organisasjonsform" */
export type RegistryOrganisasjonsformlinksArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "organisasjonsform" */
export type RegistryOrganisasjonsformAggregate = {
  __typename?: 'RegistryOrganisasjonsformAggregate';
  aggregate?: Maybe<RegistryOrganisasjonsformAggregateFields>;
  nodes: Array<RegistryOrganisasjonsform>;
};

/** aggregate fields of "organisasjonsform" */
export type RegistryOrganisasjonsformAggregateFields = {
  __typename?: 'RegistryOrganisasjonsformAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<RegistryOrganisasjonsformMaxFields>;
  min?: Maybe<RegistryOrganisasjonsformMinFields>;
};


/** aggregate fields of "organisasjonsform" */
export type RegistryOrganisasjonsformAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<RegistryOrganisasjonsformSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RegistryOrganisasjonsformAppendInput = {
  _links?: InputMaybe<Scalars['Registryjsonb']['input']>;
  links?: InputMaybe<Scalars['Registryjsonb']['input']>;
};

/** Boolean expression to filter rows from the table "organisasjonsform". All fields are combined with a logical 'AND'. */
export type RegistryOrganisasjonsformBoolExp = {
  _and?: InputMaybe<Array<RegistryOrganisasjonsformBoolExp>>;
  _links?: InputMaybe<TaskJsonbComparisonExp>;
  _not?: InputMaybe<RegistryOrganisasjonsformBoolExp>;
  _or?: InputMaybe<Array<RegistryOrganisasjonsformBoolExp>>;
  beskrivelse?: InputMaybe<TaskStringComparisonExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  kode?: InputMaybe<TaskStringComparisonExp>;
  links?: InputMaybe<TaskJsonbComparisonExp>;
  organizationOrganisasjonsform?: InputMaybe<TaskUuidComparisonExp>;
};

/** unique or primary key constraints on table "organisasjonsform" */
export type RegistryOrganisasjonsformConstraint =
  /** unique or primary key constraint on columns "organization_organisasjonsform" */
  | 'organisasjonsform_organization_organisasjonsform_key'
  /** unique or primary key constraint on columns "id" */
  | 'organisasjonsform_pkey'
  | '%future added value';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RegistryOrganisasjonsformDeleteAtPathInput = {
  _links?: InputMaybe<Array<Scalars['String']['input']>>;
  links?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RegistryOrganisasjonsformDeleteElemInput = {
  _links?: InputMaybe<Scalars['Int']['input']>;
  links?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RegistryOrganisasjonsformDeleteKeyInput = {
  _links?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "organisasjonsform" */
export type RegistryOrganisasjonsformInsertInput = {
  _links?: InputMaybe<Scalars['Registryjsonb']['input']>;
  beskrivelse?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Registryuuid']['input']>;
  kode?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Scalars['Registryjsonb']['input']>;
  organizationOrganisasjonsform?: InputMaybe<Scalars['Registryuuid']['input']>;
};

/** aggregate max on columns */
export type RegistryOrganisasjonsformMaxFields = {
  __typename?: 'RegistryOrganisasjonsformMaxFields';
  beskrivelse?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Registryuuid']['output']>;
  kode?: Maybe<Scalars['String']['output']>;
  organizationOrganisasjonsform?: Maybe<Scalars['Registryuuid']['output']>;
};

/** aggregate min on columns */
export type RegistryOrganisasjonsformMinFields = {
  __typename?: 'RegistryOrganisasjonsformMinFields';
  beskrivelse?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Registryuuid']['output']>;
  kode?: Maybe<Scalars['String']['output']>;
  organizationOrganisasjonsform?: Maybe<Scalars['Registryuuid']['output']>;
};

/** response of any mutation on the table "organisasjonsform" */
export type RegistryOrganisasjonsformMutationResponse = {
  __typename?: 'RegistryOrganisasjonsformMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RegistryOrganisasjonsform>;
};

/** input type for inserting object relation for remote table "organisasjonsform" */
export type RegistryOrganisasjonsformObjRelInsertInput = {
  data: RegistryOrganisasjonsformInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<RegistryOrganisasjonsformOnConflict>;
};

/** on_conflict condition type for table "organisasjonsform" */
export type RegistryOrganisasjonsformOnConflict = {
  constraint: RegistryOrganisasjonsformConstraint;
  updateColumns?: Array<RegistryOrganisasjonsformUpdateColumn>;
  where?: InputMaybe<RegistryOrganisasjonsformBoolExp>;
};

/** Ordering options when selecting data from "organisasjonsform". */
export type RegistryOrganisasjonsformOrderBy = {
  _links?: InputMaybe<RegistryOrderBy>;
  beskrivelse?: InputMaybe<RegistryOrderBy>;
  id?: InputMaybe<RegistryOrderBy>;
  kode?: InputMaybe<RegistryOrderBy>;
  links?: InputMaybe<RegistryOrderBy>;
  organizationOrganisasjonsform?: InputMaybe<RegistryOrderBy>;
};

/** primary key columns input for table: organisasjonsform */
export type RegistryOrganisasjonsformPkColumnsInput = {
  id: Scalars['Registryuuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RegistryOrganisasjonsformPrependInput = {
  _links?: InputMaybe<Scalars['Registryjsonb']['input']>;
  links?: InputMaybe<Scalars['Registryjsonb']['input']>;
};

/** select columns of table "organisasjonsform" */
export type RegistryOrganisasjonsformSelectColumn =
  /** column name */
  | '_links'
  /** column name */
  | 'beskrivelse'
  /** column name */
  | 'id'
  /** column name */
  | 'kode'
  /** column name */
  | 'links'
  /** column name */
  | 'organizationOrganisasjonsform'
  | '%future added value';

/** input type for updating data in table "organisasjonsform" */
export type RegistryOrganisasjonsformSetInput = {
  _links?: InputMaybe<Scalars['Registryjsonb']['input']>;
  beskrivelse?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Registryuuid']['input']>;
  kode?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Scalars['Registryjsonb']['input']>;
  organizationOrganisasjonsform?: InputMaybe<Scalars['Registryuuid']['input']>;
};

/** Streaming cursor of the table "organisasjonsform" */
export type RegistryOrganisasjonsformStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RegistryOrganisasjonsformStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<RegistryCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RegistryOrganisasjonsformStreamCursorValueInput = {
  _links?: InputMaybe<Scalars['Registryjsonb']['input']>;
  beskrivelse?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Registryuuid']['input']>;
  kode?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Scalars['Registryjsonb']['input']>;
  organizationOrganisasjonsform?: InputMaybe<Scalars['Registryuuid']['input']>;
};

/** update columns of table "organisasjonsform" */
export type RegistryOrganisasjonsformUpdateColumn =
  /** column name */
  | '_links'
  /** column name */
  | 'beskrivelse'
  /** column name */
  | 'id'
  /** column name */
  | 'kode'
  /** column name */
  | 'links'
  /** column name */
  | 'organizationOrganisasjonsform'
  | '%future added value';

export type RegistryOrganisasjonsformUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RegistryOrganisasjonsformAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<RegistryOrganisasjonsformDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<RegistryOrganisasjonsformDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<RegistryOrganisasjonsformDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RegistryOrganisasjonsformPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RegistryOrganisasjonsformSetInput>;
  /** filter the rows which have to be updated */
  where: RegistryOrganisasjonsformBoolExp;
};

/** columns and relationships of "organization" */
export type RegistryOrganization = {
  __typename?: 'RegistryOrganization';
  _links?: Maybe<Scalars['Registryjsonb']['output']>;
  antallAnsatte?: Maybe<Scalars['Registrynumeric']['output']>;
  createdAt: Scalars['Registrytimestamptz']['output'];
  epostadresse?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  forretningsadresse?: Maybe<RegistryPostadresse>;
  frivilligMvaRegistrertBeskrivelser?: Maybe<Scalars['Registryjsonb']['output']>;
  hjemmeside?: Maybe<Scalars['String']['output']>;
  id: Scalars['Registryuuid']['output'];
  /** An object relationship */
  institusjonellSektorkode?: Maybe<RegistryCode>;
  konkurs?: Maybe<Scalars['Boolean']['output']>;
  links?: Maybe<Scalars['Registryjsonb']['output']>;
  maalform?: Maybe<Scalars['String']['output']>;
  mobil?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  naeringskode1?: Maybe<RegistryCode>;
  /** An object relationship */
  naeringskode2?: Maybe<RegistryCode>;
  /** An object relationship */
  naeringskode3?: Maybe<RegistryCode>;
  navn: Scalars['String']['output'];
  /** An object relationship */
  organisasjonsform?: Maybe<RegistryOrganisasjonsform>;
  organisasjonsnummer: Scalars['String']['output'];
  overordnetEnhet?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  postadresse?: Maybe<RegistryPostadresse>;
  registreringsdatoEnhetsregisteret?: Maybe<Scalars['String']['output']>;
  registrertIForetaksregisteret?: Maybe<Scalars['Boolean']['output']>;
  registrertIFrivillighetsregisteret?: Maybe<Scalars['Boolean']['output']>;
  registrertIMvaregisteret?: Maybe<Scalars['Boolean']['output']>;
  registrertIStiftelsesregisteret?: Maybe<Scalars['Boolean']['output']>;
  sisteInnsendteAarsregnskap?: Maybe<Scalars['String']['output']>;
  slettedato?: Maybe<Scalars['String']['output']>;
  stiftelsesdato?: Maybe<Scalars['String']['output']>;
  telefon?: Maybe<Scalars['String']['output']>;
  underAvvikling?: Maybe<Scalars['Boolean']['output']>;
  underTvangsavviklingEllerTvangsopplosning?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['Registrytimestamptz']['output'];
};


/** columns and relationships of "organization" */
export type RegistryOrganization_linksArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "organization" */
export type RegistryOrganizationfrivilligMvaRegistrertBeskrivelserArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "organization" */
export type RegistryOrganizationlinksArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "organization" */
export type RegistryOrganizationAggregate = {
  __typename?: 'RegistryOrganizationAggregate';
  aggregate?: Maybe<RegistryOrganizationAggregateFields>;
  nodes: Array<RegistryOrganization>;
};

/** aggregate fields of "organization" */
export type RegistryOrganizationAggregateFields = {
  __typename?: 'RegistryOrganizationAggregateFields';
  avg?: Maybe<RegistryOrganizationAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<RegistryOrganizationMaxFields>;
  min?: Maybe<RegistryOrganizationMinFields>;
  stddev?: Maybe<RegistryOrganizationStddevFields>;
  stddevPop?: Maybe<RegistryOrganizationStddevPopFields>;
  stddevSamp?: Maybe<RegistryOrganizationStddevSampFields>;
  sum?: Maybe<RegistryOrganizationSumFields>;
  varPop?: Maybe<RegistryOrganizationVarPopFields>;
  varSamp?: Maybe<RegistryOrganizationVarSampFields>;
  variance?: Maybe<RegistryOrganizationVarianceFields>;
};


/** aggregate fields of "organization" */
export type RegistryOrganizationAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<RegistryOrganizationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RegistryOrganizationAppendInput = {
  _links?: InputMaybe<Scalars['Registryjsonb']['input']>;
  frivilligMvaRegistrertBeskrivelser?: InputMaybe<Scalars['Registryjsonb']['input']>;
  links?: InputMaybe<Scalars['Registryjsonb']['input']>;
};

/** aggregate avg on columns */
export type RegistryOrganizationAvgFields = {
  __typename?: 'RegistryOrganizationAvgFields';
  antallAnsatte?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "organization". All fields are combined with a logical 'AND'. */
export type RegistryOrganizationBoolExp = {
  _and?: InputMaybe<Array<RegistryOrganizationBoolExp>>;
  _links?: InputMaybe<TaskJsonbComparisonExp>;
  _not?: InputMaybe<RegistryOrganizationBoolExp>;
  _or?: InputMaybe<Array<RegistryOrganizationBoolExp>>;
  antallAnsatte?: InputMaybe<EmailingNumericComparisonExp>;
  createdAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  epostadresse?: InputMaybe<TaskStringComparisonExp>;
  forretningsadresse?: InputMaybe<RegistryPostadresseBoolExp>;
  frivilligMvaRegistrertBeskrivelser?: InputMaybe<TaskJsonbComparisonExp>;
  hjemmeside?: InputMaybe<TaskStringComparisonExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  institusjonellSektorkode?: InputMaybe<RegistryCodeBoolExp>;
  konkurs?: InputMaybe<TelephonyBooleanComparisonExp>;
  links?: InputMaybe<TaskJsonbComparisonExp>;
  maalform?: InputMaybe<TaskStringComparisonExp>;
  mobil?: InputMaybe<TaskStringComparisonExp>;
  naeringskode1?: InputMaybe<RegistryCodeBoolExp>;
  naeringskode2?: InputMaybe<RegistryCodeBoolExp>;
  naeringskode3?: InputMaybe<RegistryCodeBoolExp>;
  navn?: InputMaybe<TaskStringComparisonExp>;
  organisasjonsform?: InputMaybe<RegistryOrganisasjonsformBoolExp>;
  organisasjonsnummer?: InputMaybe<TaskStringComparisonExp>;
  overordnetEnhet?: InputMaybe<TaskStringComparisonExp>;
  postadresse?: InputMaybe<RegistryPostadresseBoolExp>;
  registreringsdatoEnhetsregisteret?: InputMaybe<TaskStringComparisonExp>;
  registrertIForetaksregisteret?: InputMaybe<TelephonyBooleanComparisonExp>;
  registrertIFrivillighetsregisteret?: InputMaybe<TelephonyBooleanComparisonExp>;
  registrertIMvaregisteret?: InputMaybe<TelephonyBooleanComparisonExp>;
  registrertIStiftelsesregisteret?: InputMaybe<TelephonyBooleanComparisonExp>;
  sisteInnsendteAarsregnskap?: InputMaybe<TaskStringComparisonExp>;
  slettedato?: InputMaybe<TaskStringComparisonExp>;
  stiftelsesdato?: InputMaybe<TaskStringComparisonExp>;
  telefon?: InputMaybe<TaskStringComparisonExp>;
  underAvvikling?: InputMaybe<TelephonyBooleanComparisonExp>;
  underTvangsavviklingEllerTvangsopplosning?: InputMaybe<TelephonyBooleanComparisonExp>;
  updatedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "organization" */
export type RegistryOrganizationConstraint =
  /** unique or primary key constraint on columns "organisasjonsnummer" */
  | 'organization_organisasjonsnummer_key'
  /** unique or primary key constraint on columns "id" */
  | 'organization_pkey'
  | '%future added value';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RegistryOrganizationDeleteAtPathInput = {
  _links?: InputMaybe<Array<Scalars['String']['input']>>;
  frivilligMvaRegistrertBeskrivelser?: InputMaybe<Array<Scalars['String']['input']>>;
  links?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RegistryOrganizationDeleteElemInput = {
  _links?: InputMaybe<Scalars['Int']['input']>;
  frivilligMvaRegistrertBeskrivelser?: InputMaybe<Scalars['Int']['input']>;
  links?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RegistryOrganizationDeleteKeyInput = {
  _links?: InputMaybe<Scalars['String']['input']>;
  frivilligMvaRegistrertBeskrivelser?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "organization" */
export type RegistryOrganizationIncInput = {
  antallAnsatte?: InputMaybe<Scalars['Registrynumeric']['input']>;
};

/** input type for inserting data into table "organization" */
export type RegistryOrganizationInsertInput = {
  _links?: InputMaybe<Scalars['Registryjsonb']['input']>;
  antallAnsatte?: InputMaybe<Scalars['Registrynumeric']['input']>;
  createdAt?: InputMaybe<Scalars['Registrytimestamptz']['input']>;
  epostadresse?: InputMaybe<Scalars['String']['input']>;
  forretningsadresse?: InputMaybe<RegistryPostadresseObjRelInsertInput>;
  frivilligMvaRegistrertBeskrivelser?: InputMaybe<Scalars['Registryjsonb']['input']>;
  hjemmeside?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Registryuuid']['input']>;
  institusjonellSektorkode?: InputMaybe<RegistryCodeObjRelInsertInput>;
  konkurs?: InputMaybe<Scalars['Boolean']['input']>;
  links?: InputMaybe<Scalars['Registryjsonb']['input']>;
  maalform?: InputMaybe<Scalars['String']['input']>;
  mobil?: InputMaybe<Scalars['String']['input']>;
  naeringskode1?: InputMaybe<RegistryCodeObjRelInsertInput>;
  naeringskode2?: InputMaybe<RegistryCodeObjRelInsertInput>;
  naeringskode3?: InputMaybe<RegistryCodeObjRelInsertInput>;
  navn?: InputMaybe<Scalars['String']['input']>;
  organisasjonsform?: InputMaybe<RegistryOrganisasjonsformObjRelInsertInput>;
  organisasjonsnummer?: InputMaybe<Scalars['String']['input']>;
  overordnetEnhet?: InputMaybe<Scalars['String']['input']>;
  postadresse?: InputMaybe<RegistryPostadresseObjRelInsertInput>;
  registreringsdatoEnhetsregisteret?: InputMaybe<Scalars['String']['input']>;
  registrertIForetaksregisteret?: InputMaybe<Scalars['Boolean']['input']>;
  registrertIFrivillighetsregisteret?: InputMaybe<Scalars['Boolean']['input']>;
  registrertIMvaregisteret?: InputMaybe<Scalars['Boolean']['input']>;
  registrertIStiftelsesregisteret?: InputMaybe<Scalars['Boolean']['input']>;
  sisteInnsendteAarsregnskap?: InputMaybe<Scalars['String']['input']>;
  slettedato?: InputMaybe<Scalars['String']['input']>;
  stiftelsesdato?: InputMaybe<Scalars['String']['input']>;
  telefon?: InputMaybe<Scalars['String']['input']>;
  underAvvikling?: InputMaybe<Scalars['Boolean']['input']>;
  underTvangsavviklingEllerTvangsopplosning?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Registrytimestamptz']['input']>;
};

/** aggregate max on columns */
export type RegistryOrganizationMaxFields = {
  __typename?: 'RegistryOrganizationMaxFields';
  antallAnsatte?: Maybe<Scalars['Registrynumeric']['output']>;
  createdAt?: Maybe<Scalars['Registrytimestamptz']['output']>;
  epostadresse?: Maybe<Scalars['String']['output']>;
  hjemmeside?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Registryuuid']['output']>;
  maalform?: Maybe<Scalars['String']['output']>;
  mobil?: Maybe<Scalars['String']['output']>;
  navn?: Maybe<Scalars['String']['output']>;
  organisasjonsnummer?: Maybe<Scalars['String']['output']>;
  overordnetEnhet?: Maybe<Scalars['String']['output']>;
  registreringsdatoEnhetsregisteret?: Maybe<Scalars['String']['output']>;
  sisteInnsendteAarsregnskap?: Maybe<Scalars['String']['output']>;
  slettedato?: Maybe<Scalars['String']['output']>;
  stiftelsesdato?: Maybe<Scalars['String']['output']>;
  telefon?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Registrytimestamptz']['output']>;
};

/** aggregate min on columns */
export type RegistryOrganizationMinFields = {
  __typename?: 'RegistryOrganizationMinFields';
  antallAnsatte?: Maybe<Scalars['Registrynumeric']['output']>;
  createdAt?: Maybe<Scalars['Registrytimestamptz']['output']>;
  epostadresse?: Maybe<Scalars['String']['output']>;
  hjemmeside?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Registryuuid']['output']>;
  maalform?: Maybe<Scalars['String']['output']>;
  mobil?: Maybe<Scalars['String']['output']>;
  navn?: Maybe<Scalars['String']['output']>;
  organisasjonsnummer?: Maybe<Scalars['String']['output']>;
  overordnetEnhet?: Maybe<Scalars['String']['output']>;
  registreringsdatoEnhetsregisteret?: Maybe<Scalars['String']['output']>;
  sisteInnsendteAarsregnskap?: Maybe<Scalars['String']['output']>;
  slettedato?: Maybe<Scalars['String']['output']>;
  stiftelsesdato?: Maybe<Scalars['String']['output']>;
  telefon?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Registrytimestamptz']['output']>;
};

/** response of any mutation on the table "organization" */
export type RegistryOrganizationMutationResponse = {
  __typename?: 'RegistryOrganizationMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RegistryOrganization>;
};

/** on_conflict condition type for table "organization" */
export type RegistryOrganizationOnConflict = {
  constraint: RegistryOrganizationConstraint;
  updateColumns?: Array<RegistryOrganizationUpdateColumn>;
  where?: InputMaybe<RegistryOrganizationBoolExp>;
};

/** Ordering options when selecting data from "organization". */
export type RegistryOrganizationOrderBy = {
  _links?: InputMaybe<RegistryOrderBy>;
  antallAnsatte?: InputMaybe<RegistryOrderBy>;
  createdAt?: InputMaybe<RegistryOrderBy>;
  epostadresse?: InputMaybe<RegistryOrderBy>;
  forretningsadresse?: InputMaybe<RegistryPostadresseOrderBy>;
  frivilligMvaRegistrertBeskrivelser?: InputMaybe<RegistryOrderBy>;
  hjemmeside?: InputMaybe<RegistryOrderBy>;
  id?: InputMaybe<RegistryOrderBy>;
  institusjonellSektorkode?: InputMaybe<RegistryCodeOrderBy>;
  konkurs?: InputMaybe<RegistryOrderBy>;
  links?: InputMaybe<RegistryOrderBy>;
  maalform?: InputMaybe<RegistryOrderBy>;
  mobil?: InputMaybe<RegistryOrderBy>;
  naeringskode1?: InputMaybe<RegistryCodeOrderBy>;
  naeringskode2?: InputMaybe<RegistryCodeOrderBy>;
  naeringskode3?: InputMaybe<RegistryCodeOrderBy>;
  navn?: InputMaybe<RegistryOrderBy>;
  organisasjonsform?: InputMaybe<RegistryOrganisasjonsformOrderBy>;
  organisasjonsnummer?: InputMaybe<RegistryOrderBy>;
  overordnetEnhet?: InputMaybe<RegistryOrderBy>;
  postadresse?: InputMaybe<RegistryPostadresseOrderBy>;
  registreringsdatoEnhetsregisteret?: InputMaybe<RegistryOrderBy>;
  registrertIForetaksregisteret?: InputMaybe<RegistryOrderBy>;
  registrertIFrivillighetsregisteret?: InputMaybe<RegistryOrderBy>;
  registrertIMvaregisteret?: InputMaybe<RegistryOrderBy>;
  registrertIStiftelsesregisteret?: InputMaybe<RegistryOrderBy>;
  sisteInnsendteAarsregnskap?: InputMaybe<RegistryOrderBy>;
  slettedato?: InputMaybe<RegistryOrderBy>;
  stiftelsesdato?: InputMaybe<RegistryOrderBy>;
  telefon?: InputMaybe<RegistryOrderBy>;
  underAvvikling?: InputMaybe<RegistryOrderBy>;
  underTvangsavviklingEllerTvangsopplosning?: InputMaybe<RegistryOrderBy>;
  updatedAt?: InputMaybe<RegistryOrderBy>;
};

/** primary key columns input for table: organization */
export type RegistryOrganizationPkColumnsInput = {
  id: Scalars['Registryuuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RegistryOrganizationPrependInput = {
  _links?: InputMaybe<Scalars['Registryjsonb']['input']>;
  frivilligMvaRegistrertBeskrivelser?: InputMaybe<Scalars['Registryjsonb']['input']>;
  links?: InputMaybe<Scalars['Registryjsonb']['input']>;
};

/** select columns of table "organization" */
export type RegistryOrganizationSelectColumn =
  /** column name */
  | '_links'
  /** column name */
  | 'antallAnsatte'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'epostadresse'
  /** column name */
  | 'frivilligMvaRegistrertBeskrivelser'
  /** column name */
  | 'hjemmeside'
  /** column name */
  | 'id'
  /** column name */
  | 'konkurs'
  /** column name */
  | 'links'
  /** column name */
  | 'maalform'
  /** column name */
  | 'mobil'
  /** column name */
  | 'navn'
  /** column name */
  | 'organisasjonsnummer'
  /** column name */
  | 'overordnetEnhet'
  /** column name */
  | 'registreringsdatoEnhetsregisteret'
  /** column name */
  | 'registrertIForetaksregisteret'
  /** column name */
  | 'registrertIFrivillighetsregisteret'
  /** column name */
  | 'registrertIMvaregisteret'
  /** column name */
  | 'registrertIStiftelsesregisteret'
  /** column name */
  | 'sisteInnsendteAarsregnskap'
  /** column name */
  | 'slettedato'
  /** column name */
  | 'stiftelsesdato'
  /** column name */
  | 'telefon'
  /** column name */
  | 'underAvvikling'
  /** column name */
  | 'underTvangsavviklingEllerTvangsopplosning'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "organization" */
export type RegistryOrganizationSetInput = {
  _links?: InputMaybe<Scalars['Registryjsonb']['input']>;
  antallAnsatte?: InputMaybe<Scalars['Registrynumeric']['input']>;
  createdAt?: InputMaybe<Scalars['Registrytimestamptz']['input']>;
  epostadresse?: InputMaybe<Scalars['String']['input']>;
  frivilligMvaRegistrertBeskrivelser?: InputMaybe<Scalars['Registryjsonb']['input']>;
  hjemmeside?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Registryuuid']['input']>;
  konkurs?: InputMaybe<Scalars['Boolean']['input']>;
  links?: InputMaybe<Scalars['Registryjsonb']['input']>;
  maalform?: InputMaybe<Scalars['String']['input']>;
  mobil?: InputMaybe<Scalars['String']['input']>;
  navn?: InputMaybe<Scalars['String']['input']>;
  organisasjonsnummer?: InputMaybe<Scalars['String']['input']>;
  overordnetEnhet?: InputMaybe<Scalars['String']['input']>;
  registreringsdatoEnhetsregisteret?: InputMaybe<Scalars['String']['input']>;
  registrertIForetaksregisteret?: InputMaybe<Scalars['Boolean']['input']>;
  registrertIFrivillighetsregisteret?: InputMaybe<Scalars['Boolean']['input']>;
  registrertIMvaregisteret?: InputMaybe<Scalars['Boolean']['input']>;
  registrertIStiftelsesregisteret?: InputMaybe<Scalars['Boolean']['input']>;
  sisteInnsendteAarsregnskap?: InputMaybe<Scalars['String']['input']>;
  slettedato?: InputMaybe<Scalars['String']['input']>;
  stiftelsesdato?: InputMaybe<Scalars['String']['input']>;
  telefon?: InputMaybe<Scalars['String']['input']>;
  underAvvikling?: InputMaybe<Scalars['Boolean']['input']>;
  underTvangsavviklingEllerTvangsopplosning?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Registrytimestamptz']['input']>;
};

/** aggregate stddev on columns */
export type RegistryOrganizationStddevFields = {
  __typename?: 'RegistryOrganizationStddevFields';
  antallAnsatte?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type RegistryOrganizationStddevPopFields = {
  __typename?: 'RegistryOrganizationStddevPopFields';
  antallAnsatte?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type RegistryOrganizationStddevSampFields = {
  __typename?: 'RegistryOrganizationStddevSampFields';
  antallAnsatte?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "organization" */
export type RegistryOrganizationStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RegistryOrganizationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<RegistryCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RegistryOrganizationStreamCursorValueInput = {
  _links?: InputMaybe<Scalars['Registryjsonb']['input']>;
  antallAnsatte?: InputMaybe<Scalars['Registrynumeric']['input']>;
  createdAt?: InputMaybe<Scalars['Registrytimestamptz']['input']>;
  epostadresse?: InputMaybe<Scalars['String']['input']>;
  frivilligMvaRegistrertBeskrivelser?: InputMaybe<Scalars['Registryjsonb']['input']>;
  hjemmeside?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Registryuuid']['input']>;
  konkurs?: InputMaybe<Scalars['Boolean']['input']>;
  links?: InputMaybe<Scalars['Registryjsonb']['input']>;
  maalform?: InputMaybe<Scalars['String']['input']>;
  mobil?: InputMaybe<Scalars['String']['input']>;
  navn?: InputMaybe<Scalars['String']['input']>;
  organisasjonsnummer?: InputMaybe<Scalars['String']['input']>;
  overordnetEnhet?: InputMaybe<Scalars['String']['input']>;
  registreringsdatoEnhetsregisteret?: InputMaybe<Scalars['String']['input']>;
  registrertIForetaksregisteret?: InputMaybe<Scalars['Boolean']['input']>;
  registrertIFrivillighetsregisteret?: InputMaybe<Scalars['Boolean']['input']>;
  registrertIMvaregisteret?: InputMaybe<Scalars['Boolean']['input']>;
  registrertIStiftelsesregisteret?: InputMaybe<Scalars['Boolean']['input']>;
  sisteInnsendteAarsregnskap?: InputMaybe<Scalars['String']['input']>;
  slettedato?: InputMaybe<Scalars['String']['input']>;
  stiftelsesdato?: InputMaybe<Scalars['String']['input']>;
  telefon?: InputMaybe<Scalars['String']['input']>;
  underAvvikling?: InputMaybe<Scalars['Boolean']['input']>;
  underTvangsavviklingEllerTvangsopplosning?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Registrytimestamptz']['input']>;
};

/** aggregate sum on columns */
export type RegistryOrganizationSumFields = {
  __typename?: 'RegistryOrganizationSumFields';
  antallAnsatte?: Maybe<Scalars['Registrynumeric']['output']>;
};

/** update columns of table "organization" */
export type RegistryOrganizationUpdateColumn =
  /** column name */
  | '_links'
  /** column name */
  | 'antallAnsatte'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'epostadresse'
  /** column name */
  | 'frivilligMvaRegistrertBeskrivelser'
  /** column name */
  | 'hjemmeside'
  /** column name */
  | 'id'
  /** column name */
  | 'konkurs'
  /** column name */
  | 'links'
  /** column name */
  | 'maalform'
  /** column name */
  | 'mobil'
  /** column name */
  | 'navn'
  /** column name */
  | 'organisasjonsnummer'
  /** column name */
  | 'overordnetEnhet'
  /** column name */
  | 'registreringsdatoEnhetsregisteret'
  /** column name */
  | 'registrertIForetaksregisteret'
  /** column name */
  | 'registrertIFrivillighetsregisteret'
  /** column name */
  | 'registrertIMvaregisteret'
  /** column name */
  | 'registrertIStiftelsesregisteret'
  /** column name */
  | 'sisteInnsendteAarsregnskap'
  /** column name */
  | 'slettedato'
  /** column name */
  | 'stiftelsesdato'
  /** column name */
  | 'telefon'
  /** column name */
  | 'underAvvikling'
  /** column name */
  | 'underTvangsavviklingEllerTvangsopplosning'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type RegistryOrganizationUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RegistryOrganizationAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<RegistryOrganizationDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<RegistryOrganizationDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<RegistryOrganizationDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RegistryOrganizationIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RegistryOrganizationPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RegistryOrganizationSetInput>;
  /** filter the rows which have to be updated */
  where: RegistryOrganizationBoolExp;
};

/** aggregate varPop on columns */
export type RegistryOrganizationVarPopFields = {
  __typename?: 'RegistryOrganizationVarPopFields';
  antallAnsatte?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type RegistryOrganizationVarSampFields = {
  __typename?: 'RegistryOrganizationVarSampFields';
  antallAnsatte?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type RegistryOrganizationVarianceFields = {
  __typename?: 'RegistryOrganizationVarianceFields';
  antallAnsatte?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "postadresse" */
export type RegistryPostadresse = {
  __typename?: 'RegistryPostadresse';
  adresse?: Maybe<Scalars['Registryjsonb']['output']>;
  id: Scalars['Registryuuid']['output'];
  kommune?: Maybe<Scalars['String']['output']>;
  kommunenummer?: Maybe<Scalars['String']['output']>;
  land?: Maybe<Scalars['String']['output']>;
  landkode?: Maybe<Scalars['String']['output']>;
  organizationForretningsadresse?: Maybe<Scalars['Registryuuid']['output']>;
  organizationPostadresse?: Maybe<Scalars['Registryuuid']['output']>;
  postnummer?: Maybe<Scalars['String']['output']>;
  poststed?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "postadresse" */
export type RegistryPostadresseadresseArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "postadresse" */
export type RegistryPostadresseAggregate = {
  __typename?: 'RegistryPostadresseAggregate';
  aggregate?: Maybe<RegistryPostadresseAggregateFields>;
  nodes: Array<RegistryPostadresse>;
};

/** aggregate fields of "postadresse" */
export type RegistryPostadresseAggregateFields = {
  __typename?: 'RegistryPostadresseAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<RegistryPostadresseMaxFields>;
  min?: Maybe<RegistryPostadresseMinFields>;
};


/** aggregate fields of "postadresse" */
export type RegistryPostadresseAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<RegistryPostadresseSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RegistryPostadresseAppendInput = {
  adresse?: InputMaybe<Scalars['Registryjsonb']['input']>;
};

/** Boolean expression to filter rows from the table "postadresse". All fields are combined with a logical 'AND'. */
export type RegistryPostadresseBoolExp = {
  _and?: InputMaybe<Array<RegistryPostadresseBoolExp>>;
  _not?: InputMaybe<RegistryPostadresseBoolExp>;
  _or?: InputMaybe<Array<RegistryPostadresseBoolExp>>;
  adresse?: InputMaybe<TaskJsonbComparisonExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  kommune?: InputMaybe<TaskStringComparisonExp>;
  kommunenummer?: InputMaybe<TaskStringComparisonExp>;
  land?: InputMaybe<TaskStringComparisonExp>;
  landkode?: InputMaybe<TaskStringComparisonExp>;
  organizationForretningsadresse?: InputMaybe<TaskUuidComparisonExp>;
  organizationPostadresse?: InputMaybe<TaskUuidComparisonExp>;
  postnummer?: InputMaybe<TaskStringComparisonExp>;
  poststed?: InputMaybe<TaskStringComparisonExp>;
};

/** unique or primary key constraints on table "postadresse" */
export type RegistryPostadresseConstraint =
  /** unique or primary key constraint on columns "organization_forretningsadresse" */
  | 'postadresse_forretningsadresse_key'
  /** unique or primary key constraint on columns "organization_postadresse" */
  | 'postadresse_organization_postadresse_key'
  /** unique or primary key constraint on columns "id" */
  | 'postadresse_pkey'
  | '%future added value';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RegistryPostadresseDeleteAtPathInput = {
  adresse?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RegistryPostadresseDeleteElemInput = {
  adresse?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RegistryPostadresseDeleteKeyInput = {
  adresse?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "postadresse" */
export type RegistryPostadresseInsertInput = {
  adresse?: InputMaybe<Scalars['Registryjsonb']['input']>;
  id?: InputMaybe<Scalars['Registryuuid']['input']>;
  kommune?: InputMaybe<Scalars['String']['input']>;
  kommunenummer?: InputMaybe<Scalars['String']['input']>;
  land?: InputMaybe<Scalars['String']['input']>;
  landkode?: InputMaybe<Scalars['String']['input']>;
  organizationForretningsadresse?: InputMaybe<Scalars['Registryuuid']['input']>;
  organizationPostadresse?: InputMaybe<Scalars['Registryuuid']['input']>;
  postnummer?: InputMaybe<Scalars['String']['input']>;
  poststed?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type RegistryPostadresseMaxFields = {
  __typename?: 'RegistryPostadresseMaxFields';
  id?: Maybe<Scalars['Registryuuid']['output']>;
  kommune?: Maybe<Scalars['String']['output']>;
  kommunenummer?: Maybe<Scalars['String']['output']>;
  land?: Maybe<Scalars['String']['output']>;
  landkode?: Maybe<Scalars['String']['output']>;
  organizationForretningsadresse?: Maybe<Scalars['Registryuuid']['output']>;
  organizationPostadresse?: Maybe<Scalars['Registryuuid']['output']>;
  postnummer?: Maybe<Scalars['String']['output']>;
  poststed?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type RegistryPostadresseMinFields = {
  __typename?: 'RegistryPostadresseMinFields';
  id?: Maybe<Scalars['Registryuuid']['output']>;
  kommune?: Maybe<Scalars['String']['output']>;
  kommunenummer?: Maybe<Scalars['String']['output']>;
  land?: Maybe<Scalars['String']['output']>;
  landkode?: Maybe<Scalars['String']['output']>;
  organizationForretningsadresse?: Maybe<Scalars['Registryuuid']['output']>;
  organizationPostadresse?: Maybe<Scalars['Registryuuid']['output']>;
  postnummer?: Maybe<Scalars['String']['output']>;
  poststed?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "postadresse" */
export type RegistryPostadresseMutationResponse = {
  __typename?: 'RegistryPostadresseMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RegistryPostadresse>;
};

/** input type for inserting object relation for remote table "postadresse" */
export type RegistryPostadresseObjRelInsertInput = {
  data: RegistryPostadresseInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<RegistryPostadresseOnConflict>;
};

/** on_conflict condition type for table "postadresse" */
export type RegistryPostadresseOnConflict = {
  constraint: RegistryPostadresseConstraint;
  updateColumns?: Array<RegistryPostadresseUpdateColumn>;
  where?: InputMaybe<RegistryPostadresseBoolExp>;
};

/** Ordering options when selecting data from "postadresse". */
export type RegistryPostadresseOrderBy = {
  adresse?: InputMaybe<RegistryOrderBy>;
  id?: InputMaybe<RegistryOrderBy>;
  kommune?: InputMaybe<RegistryOrderBy>;
  kommunenummer?: InputMaybe<RegistryOrderBy>;
  land?: InputMaybe<RegistryOrderBy>;
  landkode?: InputMaybe<RegistryOrderBy>;
  organizationForretningsadresse?: InputMaybe<RegistryOrderBy>;
  organizationPostadresse?: InputMaybe<RegistryOrderBy>;
  postnummer?: InputMaybe<RegistryOrderBy>;
  poststed?: InputMaybe<RegistryOrderBy>;
};

/** primary key columns input for table: postadresse */
export type RegistryPostadressePkColumnsInput = {
  id: Scalars['Registryuuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RegistryPostadressePrependInput = {
  adresse?: InputMaybe<Scalars['Registryjsonb']['input']>;
};

/** select columns of table "postadresse" */
export type RegistryPostadresseSelectColumn =
  /** column name */
  | 'adresse'
  /** column name */
  | 'id'
  /** column name */
  | 'kommune'
  /** column name */
  | 'kommunenummer'
  /** column name */
  | 'land'
  /** column name */
  | 'landkode'
  /** column name */
  | 'organizationForretningsadresse'
  /** column name */
  | 'organizationPostadresse'
  /** column name */
  | 'postnummer'
  /** column name */
  | 'poststed'
  | '%future added value';

/** input type for updating data in table "postadresse" */
export type RegistryPostadresseSetInput = {
  adresse?: InputMaybe<Scalars['Registryjsonb']['input']>;
  id?: InputMaybe<Scalars['Registryuuid']['input']>;
  kommune?: InputMaybe<Scalars['String']['input']>;
  kommunenummer?: InputMaybe<Scalars['String']['input']>;
  land?: InputMaybe<Scalars['String']['input']>;
  landkode?: InputMaybe<Scalars['String']['input']>;
  organizationForretningsadresse?: InputMaybe<Scalars['Registryuuid']['input']>;
  organizationPostadresse?: InputMaybe<Scalars['Registryuuid']['input']>;
  postnummer?: InputMaybe<Scalars['String']['input']>;
  poststed?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "postadresse" */
export type RegistryPostadresseStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RegistryPostadresseStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<RegistryCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RegistryPostadresseStreamCursorValueInput = {
  adresse?: InputMaybe<Scalars['Registryjsonb']['input']>;
  id?: InputMaybe<Scalars['Registryuuid']['input']>;
  kommune?: InputMaybe<Scalars['String']['input']>;
  kommunenummer?: InputMaybe<Scalars['String']['input']>;
  land?: InputMaybe<Scalars['String']['input']>;
  landkode?: InputMaybe<Scalars['String']['input']>;
  organizationForretningsadresse?: InputMaybe<Scalars['Registryuuid']['input']>;
  organizationPostadresse?: InputMaybe<Scalars['Registryuuid']['input']>;
  postnummer?: InputMaybe<Scalars['String']['input']>;
  poststed?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "postadresse" */
export type RegistryPostadresseUpdateColumn =
  /** column name */
  | 'adresse'
  /** column name */
  | 'id'
  /** column name */
  | 'kommune'
  /** column name */
  | 'kommunenummer'
  /** column name */
  | 'land'
  /** column name */
  | 'landkode'
  /** column name */
  | 'organizationForretningsadresse'
  /** column name */
  | 'organizationPostadresse'
  /** column name */
  | 'postnummer'
  /** column name */
  | 'poststed'
  | '%future added value';

export type RegistryPostadresseUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RegistryPostadresseAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<RegistryPostadresseDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<RegistryPostadresseDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<RegistryPostadresseDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RegistryPostadressePrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RegistryPostadresseSetInput>;
  /** filter the rows which have to be updated */
  where: RegistryPostadresseBoolExp;
};

/** columns and relationships of "business.relation_type" */
export type RelationType = {
  __typename?: 'RelationType';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "business.relation_type" */
export type RelationTypeAggregate = {
  __typename?: 'RelationTypeAggregate';
  aggregate?: Maybe<RelationTypeAggregateFields>;
  nodes: Array<RelationType>;
};

/** aggregate fields of "business.relation_type" */
export type RelationTypeAggregateFields = {
  __typename?: 'RelationTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<RelationTypeMaxFields>;
  min?: Maybe<RelationTypeMinFields>;
};


/** aggregate fields of "business.relation_type" */
export type RelationTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<RelationTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.relation_type". All fields are combined with a logical 'AND'. */
export type RelationTypeBoolExp = {
  _and?: InputMaybe<Array<RelationTypeBoolExp>>;
  _not?: InputMaybe<RelationTypeBoolExp>;
  _or?: InputMaybe<Array<RelationTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.relation_type" */
export type RelationTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'relation_type_pkey'
  | '%future added value';

export type RelationTypeEnum =
  /** if a relation is confirmed to be real */
  | 'CONFIRMED'
  /** if a relation is set as a suggestion */
  | 'SUGGESTION'
  | '%future added value';

/** Boolean expression to compare columns of type "RelationTypeEnum". All fields are combined with logical 'AND'. */
export type RelationTypeEnumComparisonExp = {
  _eq?: InputMaybe<RelationTypeEnum>;
  _in?: InputMaybe<Array<RelationTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<RelationTypeEnum>;
  _nin?: InputMaybe<Array<RelationTypeEnum>>;
};

/** input type for inserting data into table "business.relation_type" */
export type RelationTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type RelationTypeMaxFields = {
  __typename?: 'RelationTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type RelationTypeMinFields = {
  __typename?: 'RelationTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.relation_type" */
export type RelationTypeMutationResponse = {
  __typename?: 'RelationTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RelationType>;
};

/** input type for inserting object relation for remote table "business.relation_type" */
export type RelationTypeObjRelInsertInput = {
  data: RelationTypeInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<RelationTypeOnConflict>;
};

/** on_conflict condition type for table "business.relation_type" */
export type RelationTypeOnConflict = {
  constraint: RelationTypeConstraint;
  updateColumns?: Array<RelationTypeUpdateColumn>;
  where?: InputMaybe<RelationTypeBoolExp>;
};

/** Ordering options when selecting data from "business.relation_type". */
export type RelationTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.relation_type */
export type RelationTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "business.relation_type" */
export type RelationTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "business.relation_type" */
export type RelationTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "RelationType" */
export type RelationTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RelationTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RelationTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.relation_type" */
export type RelationTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type RelationTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RelationTypeSetInput>;
  /** filter the rows which have to be updated */
  where: RelationTypeBoolExp;
};

export type RemoveCustomerInput = {
  customerId: Scalars['uuid']['input'];
  deletionAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type RemoveCustomerOutput = {
  __typename?: 'RemoveCustomerOutput';
  json?: Maybe<Scalars['json']['output']>;
  result: Scalars['String']['output'];
};

export type RequestIntegrationsInput = {
  name: Scalars['String']['input'];
  schema: Scalars['String']['input'];
  terms: Scalars['String']['input'];
  termsversion: Scalars['String']['input'];
};

export type RequestIntegrationsOutput = {
  __typename?: 'RequestIntegrationsOutput';
  status: Scalars['String']['output'];
};

export type Route = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  customParameters?: InputMaybe<Scalars['jsonb']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['String']['input']>;
  gateIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  keywordType?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['String']['input']>;
  platformPartnerId?: InputMaybe<Scalars['String']['input']>;
  platformServiceId?: InputMaybe<Scalars['String']['input']>;
  platformServiceType?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['String']['input']>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type SearchPhoneInput = {
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type SearchPhoneOutput = {
  __typename?: 'SearchPhoneOutput';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  customerType?: Maybe<Scalars['String']['output']>;
  electronicQuery?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  manualQuery?: Maybe<Scalars['Boolean']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneBook?: Maybe<Scalars['Boolean']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['timestamptz']['output']>;
};

export type SendSMSOutput = {
  __typename?: 'SendSMSOutput';
  description?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  resultCode?: Maybe<Scalars['Int']['output']>;
};

export type SendSMSTokenOutput = {
  __typename?: 'SendSMSTokenOutput';
  code?: Maybe<Scalars['String']['output']>;
};

export type StatusOutput = {
  __typename?: 'StatusOutput';
  status?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringComparisonExp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "activity" */
export type TaskActivity = {
  __typename?: 'TaskActivity';
  activityActivityUuid?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  activityParticipants: Array<TaskActivityParticipant>;
  /** An aggregate relationship */
  activityParticipantsAggregate: TaskActivityParticipantAggregate;
  /** An object relationship */
  activityType: TaskActivityType;
  additionalData?: Maybe<Scalars['Taskjsonb']['output']>;
  createdAt: Scalars['Tasktimestamptz']['output'];
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  owner?: Maybe<TaskDomainUser>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  provider: Scalars['String']['output'];
  subTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: TaskActivityTypeEnum;
  updatedAt: Scalars['Tasktimestamptz']['output'];
};


/** columns and relationships of "activity" */
export type TaskActivityactivityParticipantsArgs = {
  distinctOn?: InputMaybe<Array<TaskActivityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskActivityParticipantOrderBy>>;
  where?: InputMaybe<TaskActivityParticipantBoolExp>;
};


/** columns and relationships of "activity" */
export type TaskActivityactivityParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TaskActivityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskActivityParticipantOrderBy>>;
  where?: InputMaybe<TaskActivityParticipantBoolExp>;
};


/** columns and relationships of "activity" */
export type TaskActivityadditionalDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "activity" */
export type TaskActivityAggregate = {
  __typename?: 'TaskActivityAggregate';
  aggregate?: Maybe<TaskActivityAggregateFields>;
  nodes: Array<TaskActivity>;
};

/** aggregate fields of "activity" */
export type TaskActivityAggregateFields = {
  __typename?: 'TaskActivityAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TaskActivityMaxFields>;
  min?: Maybe<TaskActivityMinFields>;
};


/** aggregate fields of "activity" */
export type TaskActivityAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TaskActivitySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type TaskActivityAppendInput = {
  additionalData?: InputMaybe<Scalars['Taskjsonb']['input']>;
};

/** Boolean expression to filter rows from the table "activity". All fields are combined with a logical 'AND'. */
export type TaskActivityBoolExp = {
  _and?: InputMaybe<Array<TaskActivityBoolExp>>;
  _not?: InputMaybe<TaskActivityBoolExp>;
  _or?: InputMaybe<Array<TaskActivityBoolExp>>;
  activityActivityUuid?: InputMaybe<TaskUuidComparisonExp>;
  activityParticipants?: InputMaybe<TaskActivityParticipantBoolExp>;
  activityParticipantsAggregate?: InputMaybe<TaskActivityParticipantAggregateBoolExp>;
  activityType?: InputMaybe<TaskActivityTypeBoolExp>;
  additionalData?: InputMaybe<TaskJsonbComparisonExp>;
  createdAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  createdByUserId?: InputMaybe<TaskUuidComparisonExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  owner?: InputMaybe<TaskDomainUserBoolExp>;
  ownerId?: InputMaybe<TaskUuidComparisonExp>;
  provider?: InputMaybe<TaskStringComparisonExp>;
  subTitle?: InputMaybe<TaskStringComparisonExp>;
  title?: InputMaybe<TaskStringComparisonExp>;
  type?: InputMaybe<TaskActivityTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "activity" */
export type TaskActivityConstraint =
  /** unique or primary key constraint on columns "activity_activity_uuid" */
  | 'activity_activity_activity_uuid_key'
  /** unique or primary key constraint on columns "id" */
  | 'activity_pkey'
  | '%future added value';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type TaskActivityDeleteAtPathInput = {
  additionalData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type TaskActivityDeleteElemInput = {
  additionalData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type TaskActivityDeleteKeyInput = {
  additionalData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "activity" */
export type TaskActivityInsertInput = {
  activityActivityUuid?: InputMaybe<Scalars['uuid']['input']>;
  activityParticipants?: InputMaybe<TaskActivityParticipantArrRelInsertInput>;
  activityType?: InputMaybe<TaskActivityTypeObjRelInsertInput>;
  additionalData?: InputMaybe<Scalars['Taskjsonb']['input']>;
  createdAt?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  owner?: InputMaybe<TaskDomainUserObjRelInsertInput>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TaskActivityTypeEnum>;
  updatedAt?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
};

/** aggregate max on columns */
export type TaskActivityMaxFields = {
  __typename?: 'TaskActivityMaxFields';
  activityActivityUuid?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['Tasktimestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  subTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Tasktimestamptz']['output']>;
};

/** aggregate min on columns */
export type TaskActivityMinFields = {
  __typename?: 'TaskActivityMinFields';
  activityActivityUuid?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['Tasktimestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  subTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Tasktimestamptz']['output']>;
};

/** response of any mutation on the table "activity" */
export type TaskActivityMutationResponse = {
  __typename?: 'TaskActivityMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TaskActivity>;
};

/** input type for inserting object relation for remote table "activity" */
export type TaskActivityObjRelInsertInput = {
  data: TaskActivityInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TaskActivityOnConflict>;
};

/** on_conflict condition type for table "activity" */
export type TaskActivityOnConflict = {
  constraint: TaskActivityConstraint;
  updateColumns?: Array<TaskActivityUpdateColumn>;
  where?: InputMaybe<TaskActivityBoolExp>;
};

/** Ordering options when selecting data from "activity". */
export type TaskActivityOrderBy = {
  activityActivityUuid?: InputMaybe<TaskOrderBy>;
  activityParticipantsAggregate?: InputMaybe<TaskActivityParticipantAggregateOrderBy>;
  activityType?: InputMaybe<TaskActivityTypeOrderBy>;
  additionalData?: InputMaybe<TaskOrderBy>;
  createdAt?: InputMaybe<TaskOrderBy>;
  createdByUserId?: InputMaybe<TaskOrderBy>;
  id?: InputMaybe<TaskOrderBy>;
  owner?: InputMaybe<TaskDomainUserOrderBy>;
  ownerId?: InputMaybe<TaskOrderBy>;
  provider?: InputMaybe<TaskOrderBy>;
  subTitle?: InputMaybe<TaskOrderBy>;
  title?: InputMaybe<TaskOrderBy>;
  type?: InputMaybe<TaskOrderBy>;
  updatedAt?: InputMaybe<TaskOrderBy>;
};

/** columns and relationships of "activity_participant" */
export type TaskActivityParticipant = {
  __typename?: 'TaskActivityParticipant';
  /** An object relationship */
  activity?: Maybe<TaskActivity>;
  activityActivityUuid?: Maybe<Scalars['uuid']['output']>;
  activityId: Scalars['uuid']['output'];
  createdAt: Scalars['Tasktimestamptz']['output'];
  /** An object relationship */
  domainUser?: Maybe<TaskDomainUser>;
  domainUserId?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  role?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Tasktimestamptz']['output'];
};

/** aggregated selection of "activity_participant" */
export type TaskActivityParticipantAggregate = {
  __typename?: 'TaskActivityParticipantAggregate';
  aggregate?: Maybe<TaskActivityParticipantAggregateFields>;
  nodes: Array<TaskActivityParticipant>;
};

export type TaskActivityParticipantAggregateBoolExp = {
  count?: InputMaybe<TaskactivityParticipantAggregateBoolExpCount>;
};

/** aggregate fields of "activity_participant" */
export type TaskActivityParticipantAggregateFields = {
  __typename?: 'TaskActivityParticipantAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TaskActivityParticipantMaxFields>;
  min?: Maybe<TaskActivityParticipantMinFields>;
};


/** aggregate fields of "activity_participant" */
export type TaskActivityParticipantAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TaskActivityParticipantSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "activity_participant" */
export type TaskActivityParticipantAggregateOrderBy = {
  count?: InputMaybe<TaskOrderBy>;
  max?: InputMaybe<TaskActivityParticipantMaxOrderBy>;
  min?: InputMaybe<TaskActivityParticipantMinOrderBy>;
};

/** input type for inserting array relation for remote table "activity_participant" */
export type TaskActivityParticipantArrRelInsertInput = {
  data: Array<TaskActivityParticipantInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<TaskActivityParticipantOnConflict>;
};

/** Boolean expression to filter rows from the table "activity_participant". All fields are combined with a logical 'AND'. */
export type TaskActivityParticipantBoolExp = {
  _and?: InputMaybe<Array<TaskActivityParticipantBoolExp>>;
  _not?: InputMaybe<TaskActivityParticipantBoolExp>;
  _or?: InputMaybe<Array<TaskActivityParticipantBoolExp>>;
  activity?: InputMaybe<TaskActivityBoolExp>;
  activityActivityUuid?: InputMaybe<TaskUuidComparisonExp>;
  activityId?: InputMaybe<TaskUuidComparisonExp>;
  createdAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  domainUser?: InputMaybe<TaskDomainUserBoolExp>;
  domainUserId?: InputMaybe<TaskUuidComparisonExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  role?: InputMaybe<TaskStringComparisonExp>;
  updatedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "activity_participant" */
export type TaskActivityParticipantConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'activity_participant_pkey'
  | '%future added value';

/** input type for inserting data into table "activity_participant" */
export type TaskActivityParticipantInsertInput = {
  activity?: InputMaybe<TaskActivityObjRelInsertInput>;
  activityActivityUuid?: InputMaybe<Scalars['uuid']['input']>;
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
  domainUser?: InputMaybe<TaskDomainUserObjRelInsertInput>;
  domainUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
};

/** aggregate max on columns */
export type TaskActivityParticipantMaxFields = {
  __typename?: 'TaskActivityParticipantMaxFields';
  activityActivityUuid?: Maybe<Scalars['uuid']['output']>;
  activityId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['Tasktimestamptz']['output']>;
  domainUserId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Tasktimestamptz']['output']>;
};

/** order by max() on columns of table "activity_participant" */
export type TaskActivityParticipantMaxOrderBy = {
  activityActivityUuid?: InputMaybe<TaskOrderBy>;
  activityId?: InputMaybe<TaskOrderBy>;
  createdAt?: InputMaybe<TaskOrderBy>;
  domainUserId?: InputMaybe<TaskOrderBy>;
  id?: InputMaybe<TaskOrderBy>;
  role?: InputMaybe<TaskOrderBy>;
  updatedAt?: InputMaybe<TaskOrderBy>;
};

/** aggregate min on columns */
export type TaskActivityParticipantMinFields = {
  __typename?: 'TaskActivityParticipantMinFields';
  activityActivityUuid?: Maybe<Scalars['uuid']['output']>;
  activityId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['Tasktimestamptz']['output']>;
  domainUserId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Tasktimestamptz']['output']>;
};

/** order by min() on columns of table "activity_participant" */
export type TaskActivityParticipantMinOrderBy = {
  activityActivityUuid?: InputMaybe<TaskOrderBy>;
  activityId?: InputMaybe<TaskOrderBy>;
  createdAt?: InputMaybe<TaskOrderBy>;
  domainUserId?: InputMaybe<TaskOrderBy>;
  id?: InputMaybe<TaskOrderBy>;
  role?: InputMaybe<TaskOrderBy>;
  updatedAt?: InputMaybe<TaskOrderBy>;
};

/** response of any mutation on the table "activity_participant" */
export type TaskActivityParticipantMutationResponse = {
  __typename?: 'TaskActivityParticipantMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TaskActivityParticipant>;
};

/** on_conflict condition type for table "activity_participant" */
export type TaskActivityParticipantOnConflict = {
  constraint: TaskActivityParticipantConstraint;
  updateColumns?: Array<TaskActivityParticipantUpdateColumn>;
  where?: InputMaybe<TaskActivityParticipantBoolExp>;
};

/** Ordering options when selecting data from "activity_participant". */
export type TaskActivityParticipantOrderBy = {
  activity?: InputMaybe<TaskActivityOrderBy>;
  activityActivityUuid?: InputMaybe<TaskOrderBy>;
  activityId?: InputMaybe<TaskOrderBy>;
  createdAt?: InputMaybe<TaskOrderBy>;
  domainUser?: InputMaybe<TaskDomainUserOrderBy>;
  domainUserId?: InputMaybe<TaskOrderBy>;
  id?: InputMaybe<TaskOrderBy>;
  role?: InputMaybe<TaskOrderBy>;
  updatedAt?: InputMaybe<TaskOrderBy>;
};

/** primary key columns input for table: activity_participant */
export type TaskActivityParticipantPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "activity_participant" */
export type TaskActivityParticipantSelectColumn =
  /** column name */
  | 'activityActivityUuid'
  /** column name */
  | 'activityId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'domainUserId'
  /** column name */
  | 'id'
  /** column name */
  | 'role'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "activity_participant" */
export type TaskActivityParticipantSetInput = {
  activityActivityUuid?: InputMaybe<Scalars['uuid']['input']>;
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
  domainUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
};

/** Streaming cursor of the table "activity_participant" */
export type TaskActivityParticipantStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TaskActivityParticipantStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TaskCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TaskActivityParticipantStreamCursorValueInput = {
  activityActivityUuid?: InputMaybe<Scalars['uuid']['input']>;
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
  domainUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
};

/** update columns of table "activity_participant" */
export type TaskActivityParticipantUpdateColumn =
  /** column name */
  | 'activityActivityUuid'
  /** column name */
  | 'activityId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'domainUserId'
  /** column name */
  | 'id'
  /** column name */
  | 'role'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type TaskActivityParticipantUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TaskActivityParticipantSetInput>;
  /** filter the rows which have to be updated */
  where: TaskActivityParticipantBoolExp;
};

/** primary key columns input for table: activity */
export type TaskActivityPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type TaskActivityPrependInput = {
  additionalData?: InputMaybe<Scalars['Taskjsonb']['input']>;
};

/** select columns of table "activity" */
export type TaskActivitySelectColumn =
  /** column name */
  | 'activityActivityUuid'
  /** column name */
  | 'additionalData'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserId'
  /** column name */
  | 'id'
  /** column name */
  | 'ownerId'
  /** column name */
  | 'provider'
  /** column name */
  | 'subTitle'
  /** column name */
  | 'title'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "activity" */
export type TaskActivitySetInput = {
  activityActivityUuid?: InputMaybe<Scalars['uuid']['input']>;
  additionalData?: InputMaybe<Scalars['Taskjsonb']['input']>;
  createdAt?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TaskActivityTypeEnum>;
  updatedAt?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
};

/** Streaming cursor of the table "activity" */
export type TaskActivityStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TaskActivityStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TaskCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TaskActivityStreamCursorValueInput = {
  activityActivityUuid?: InputMaybe<Scalars['uuid']['input']>;
  additionalData?: InputMaybe<Scalars['Taskjsonb']['input']>;
  createdAt?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TaskActivityTypeEnum>;
  updatedAt?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
};

/** columns and relationships of "activity_type" */
export type TaskActivityType = {
  __typename?: 'TaskActivityType';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "activity_type" */
export type TaskActivityTypeAggregate = {
  __typename?: 'TaskActivityTypeAggregate';
  aggregate?: Maybe<TaskActivityTypeAggregateFields>;
  nodes: Array<TaskActivityType>;
};

/** aggregate fields of "activity_type" */
export type TaskActivityTypeAggregateFields = {
  __typename?: 'TaskActivityTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TaskActivityTypeMaxFields>;
  min?: Maybe<TaskActivityTypeMinFields>;
};


/** aggregate fields of "activity_type" */
export type TaskActivityTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TaskActivityTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "activity_type". All fields are combined with a logical 'AND'. */
export type TaskActivityTypeBoolExp = {
  _and?: InputMaybe<Array<TaskActivityTypeBoolExp>>;
  _not?: InputMaybe<TaskActivityTypeBoolExp>;
  _or?: InputMaybe<Array<TaskActivityTypeBoolExp>>;
  description?: InputMaybe<TaskStringComparisonExp>;
  value?: InputMaybe<TaskStringComparisonExp>;
};

/** unique or primary key constraints on table "activity_type" */
export type TaskActivityTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'activity_type_pkey'
  | '%future added value';

export type TaskActivityTypeEnum =
  /** action */
  | 'ACTION'
  /** callback task */
  | 'CALLBACK'
  /** call to */
  | 'CALLTO'
  /** reminder task */
  | 'REMINDER'
  /** Task */
  | 'TASK'
  | '%future added value';

/** Boolean expression to compare columns of type "ActivityTypeEnum". All fields are combined with logical 'AND'. */
export type TaskActivityTypeEnumComparisonExp = {
  _eq?: InputMaybe<TaskActivityTypeEnum>;
  _in?: InputMaybe<Array<TaskActivityTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<TaskActivityTypeEnum>;
  _nin?: InputMaybe<Array<TaskActivityTypeEnum>>;
};

/** input type for inserting data into table "activity_type" */
export type TaskActivityTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type TaskActivityTypeMaxFields = {
  __typename?: 'TaskActivityTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type TaskActivityTypeMinFields = {
  __typename?: 'TaskActivityTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "activity_type" */
export type TaskActivityTypeMutationResponse = {
  __typename?: 'TaskActivityTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TaskActivityType>;
};

/** input type for inserting object relation for remote table "activity_type" */
export type TaskActivityTypeObjRelInsertInput = {
  data: TaskActivityTypeInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TaskActivityTypeOnConflict>;
};

/** on_conflict condition type for table "activity_type" */
export type TaskActivityTypeOnConflict = {
  constraint: TaskActivityTypeConstraint;
  updateColumns?: Array<TaskActivityTypeUpdateColumn>;
  where?: InputMaybe<TaskActivityTypeBoolExp>;
};

/** Ordering options when selecting data from "activity_type". */
export type TaskActivityTypeOrderBy = {
  description?: InputMaybe<TaskOrderBy>;
  value?: InputMaybe<TaskOrderBy>;
};

/** primary key columns input for table: activity_type */
export type TaskActivityTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "activity_type" */
export type TaskActivityTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "activity_type" */
export type TaskActivityTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "activity_type" */
export type TaskActivityTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TaskActivityTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TaskCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TaskActivityTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "activity_type" */
export type TaskActivityTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type TaskActivityTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TaskActivityTypeSetInput>;
  /** filter the rows which have to be updated */
  where: TaskActivityTypeBoolExp;
};

/** update columns of table "activity" */
export type TaskActivityUpdateColumn =
  /** column name */
  | 'activityActivityUuid'
  /** column name */
  | 'additionalData'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserId'
  /** column name */
  | 'id'
  /** column name */
  | 'ownerId'
  /** column name */
  | 'provider'
  /** column name */
  | 'subTitle'
  /** column name */
  | 'title'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type TaskActivityUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<TaskActivityAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<TaskActivityDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<TaskActivityDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<TaskActivityDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<TaskActivityPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TaskActivitySetInput>;
  /** filter the rows which have to be updated */
  where: TaskActivityBoolExp;
};

/** ordering argument of a cursor */
export type TaskCursorOrdering =
  /** ascending ordering of the cursor */
  | 'ASC'
  /** descending ordering of the cursor */
  | 'DESC'
  | '%future added value';

/** columns and relationships of "domain_organization" */
export type TaskDomainOrganization = {
  __typename?: 'TaskDomainOrganization';
  adminId?: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['Tasktimestamptz']['output'];
  /** An array relationship */
  domainUsers: Array<TaskDomainUser>;
  /** An aggregate relationship */
  domainUsersAggregate: TaskDomainUserAggregate;
  id: Scalars['uuid']['output'];
  organizationId?: Maybe<Scalars['uuid']['output']>;
  providerClientId: Scalars['String']['output'];
  updatedAt: Scalars['Tasktimestamptz']['output'];
};


/** columns and relationships of "domain_organization" */
export type TaskDomainOrganizationdomainUsersArgs = {
  distinctOn?: InputMaybe<Array<TaskDomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskDomainUserOrderBy>>;
  where?: InputMaybe<TaskDomainUserBoolExp>;
};


/** columns and relationships of "domain_organization" */
export type TaskDomainOrganizationdomainUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<TaskDomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskDomainUserOrderBy>>;
  where?: InputMaybe<TaskDomainUserBoolExp>;
};

/** aggregated selection of "domain_organization" */
export type TaskDomainOrganizationAggregate = {
  __typename?: 'TaskDomainOrganizationAggregate';
  aggregate?: Maybe<TaskDomainOrganizationAggregateFields>;
  nodes: Array<TaskDomainOrganization>;
};

/** aggregate fields of "domain_organization" */
export type TaskDomainOrganizationAggregateFields = {
  __typename?: 'TaskDomainOrganizationAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TaskDomainOrganizationMaxFields>;
  min?: Maybe<TaskDomainOrganizationMinFields>;
};


/** aggregate fields of "domain_organization" */
export type TaskDomainOrganizationAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TaskDomainOrganizationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "domain_organization". All fields are combined with a logical 'AND'. */
export type TaskDomainOrganizationBoolExp = {
  _and?: InputMaybe<Array<TaskDomainOrganizationBoolExp>>;
  _not?: InputMaybe<TaskDomainOrganizationBoolExp>;
  _or?: InputMaybe<Array<TaskDomainOrganizationBoolExp>>;
  adminId?: InputMaybe<TaskUuidComparisonExp>;
  createdAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  domainUsers?: InputMaybe<TaskDomainUserBoolExp>;
  domainUsersAggregate?: InputMaybe<TaskDomainUserAggregateBoolExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  organizationId?: InputMaybe<TaskUuidComparisonExp>;
  providerClientId?: InputMaybe<TaskStringComparisonExp>;
  updatedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "domain_organization" */
export type TaskDomainOrganizationConstraint =
  /** unique or primary key constraint on columns "organization_id" */
  | 'domain_organization_organization_id_key'
  /** unique or primary key constraint on columns "id" */
  | 'domain_organization_pkey'
  | '%future added value';

/** input type for inserting data into table "domain_organization" */
export type TaskDomainOrganizationInsertInput = {
  adminId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
  domainUsers?: InputMaybe<TaskDomainUserArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  providerClientId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
};

/** aggregate max on columns */
export type TaskDomainOrganizationMaxFields = {
  __typename?: 'TaskDomainOrganizationMaxFields';
  adminId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['Tasktimestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  providerClientId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Tasktimestamptz']['output']>;
};

/** aggregate min on columns */
export type TaskDomainOrganizationMinFields = {
  __typename?: 'TaskDomainOrganizationMinFields';
  adminId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['Tasktimestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  providerClientId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Tasktimestamptz']['output']>;
};

/** response of any mutation on the table "domain_organization" */
export type TaskDomainOrganizationMutationResponse = {
  __typename?: 'TaskDomainOrganizationMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TaskDomainOrganization>;
};

/** input type for inserting object relation for remote table "domain_organization" */
export type TaskDomainOrganizationObjRelInsertInput = {
  data: TaskDomainOrganizationInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TaskDomainOrganizationOnConflict>;
};

/** on_conflict condition type for table "domain_organization" */
export type TaskDomainOrganizationOnConflict = {
  constraint: TaskDomainOrganizationConstraint;
  updateColumns?: Array<TaskDomainOrganizationUpdateColumn>;
  where?: InputMaybe<TaskDomainOrganizationBoolExp>;
};

/** Ordering options when selecting data from "domain_organization". */
export type TaskDomainOrganizationOrderBy = {
  adminId?: InputMaybe<TaskOrderBy>;
  createdAt?: InputMaybe<TaskOrderBy>;
  domainUsersAggregate?: InputMaybe<TaskDomainUserAggregateOrderBy>;
  id?: InputMaybe<TaskOrderBy>;
  organizationId?: InputMaybe<TaskOrderBy>;
  providerClientId?: InputMaybe<TaskOrderBy>;
  updatedAt?: InputMaybe<TaskOrderBy>;
};

/** primary key columns input for table: domain_organization */
export type TaskDomainOrganizationPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "domain_organization" */
export type TaskDomainOrganizationSelectColumn =
  /** column name */
  | 'adminId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'providerClientId'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "domain_organization" */
export type TaskDomainOrganizationSetInput = {
  adminId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  providerClientId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
};

/** Streaming cursor of the table "domain_organization" */
export type TaskDomainOrganizationStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TaskDomainOrganizationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TaskCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TaskDomainOrganizationStreamCursorValueInput = {
  adminId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  providerClientId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
};

/** update columns of table "domain_organization" */
export type TaskDomainOrganizationUpdateColumn =
  /** column name */
  | 'adminId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'providerClientId'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type TaskDomainOrganizationUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TaskDomainOrganizationSetInput>;
  /** filter the rows which have to be updated */
  where: TaskDomainOrganizationBoolExp;
};

/** columns and relationships of "domain_user" */
export type TaskDomainUser = {
  __typename?: 'TaskDomainUser';
  /** An array relationship */
  activityParticipants: Array<TaskActivityParticipant>;
  /** An aggregate relationship */
  activityParticipantsAggregate: TaskActivityParticipantAggregate;
  category?: Maybe<TaskDomainUserCategoryEnum>;
  createdAt: Scalars['Tasktimestamptz']['output'];
  /** An object relationship */
  domainOrganization?: Maybe<TaskDomainOrganization>;
  domainOrganizationId: Scalars['uuid']['output'];
  /** An object relationship */
  domainUserCategory?: Maybe<TaskDomainUserCategory>;
  id: Scalars['uuid']['output'];
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['Tasktimestamptz']['output'];
};


/** columns and relationships of "domain_user" */
export type TaskDomainUseractivityParticipantsArgs = {
  distinctOn?: InputMaybe<Array<TaskActivityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskActivityParticipantOrderBy>>;
  where?: InputMaybe<TaskActivityParticipantBoolExp>;
};


/** columns and relationships of "domain_user" */
export type TaskDomainUseractivityParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TaskActivityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskActivityParticipantOrderBy>>;
  where?: InputMaybe<TaskActivityParticipantBoolExp>;
};

/** aggregated selection of "domain_user" */
export type TaskDomainUserAggregate = {
  __typename?: 'TaskDomainUserAggregate';
  aggregate?: Maybe<TaskDomainUserAggregateFields>;
  nodes: Array<TaskDomainUser>;
};

export type TaskDomainUserAggregateBoolExp = {
  count?: InputMaybe<TaskdomainUserAggregateBoolExpCount>;
};

/** aggregate fields of "domain_user" */
export type TaskDomainUserAggregateFields = {
  __typename?: 'TaskDomainUserAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TaskDomainUserMaxFields>;
  min?: Maybe<TaskDomainUserMinFields>;
};


/** aggregate fields of "domain_user" */
export type TaskDomainUserAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TaskDomainUserSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "domain_user" */
export type TaskDomainUserAggregateOrderBy = {
  count?: InputMaybe<TaskOrderBy>;
  max?: InputMaybe<TaskDomainUserMaxOrderBy>;
  min?: InputMaybe<TaskDomainUserMinOrderBy>;
};

/** input type for inserting array relation for remote table "domain_user" */
export type TaskDomainUserArrRelInsertInput = {
  data: Array<TaskDomainUserInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<TaskDomainUserOnConflict>;
};

/** Boolean expression to filter rows from the table "domain_user". All fields are combined with a logical 'AND'. */
export type TaskDomainUserBoolExp = {
  _and?: InputMaybe<Array<TaskDomainUserBoolExp>>;
  _not?: InputMaybe<TaskDomainUserBoolExp>;
  _or?: InputMaybe<Array<TaskDomainUserBoolExp>>;
  activityParticipants?: InputMaybe<TaskActivityParticipantBoolExp>;
  activityParticipantsAggregate?: InputMaybe<TaskActivityParticipantAggregateBoolExp>;
  category?: InputMaybe<TaskDomainUserCategoryEnumComparisonExp>;
  createdAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  domainOrganization?: InputMaybe<TaskDomainOrganizationBoolExp>;
  domainOrganizationId?: InputMaybe<TaskUuidComparisonExp>;
  domainUserCategory?: InputMaybe<TaskDomainUserCategoryBoolExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  organizationUserId?: InputMaybe<TaskUuidComparisonExp>;
  updatedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
};

/** columns and relationships of "domain_user_category" */
export type TaskDomainUserCategory = {
  __typename?: 'TaskDomainUserCategory';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "domain_user_category" */
export type TaskDomainUserCategoryAggregate = {
  __typename?: 'TaskDomainUserCategoryAggregate';
  aggregate?: Maybe<TaskDomainUserCategoryAggregateFields>;
  nodes: Array<TaskDomainUserCategory>;
};

/** aggregate fields of "domain_user_category" */
export type TaskDomainUserCategoryAggregateFields = {
  __typename?: 'TaskDomainUserCategoryAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TaskDomainUserCategoryMaxFields>;
  min?: Maybe<TaskDomainUserCategoryMinFields>;
};


/** aggregate fields of "domain_user_category" */
export type TaskDomainUserCategoryAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TaskDomainUserCategorySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "domain_user_category". All fields are combined with a logical 'AND'. */
export type TaskDomainUserCategoryBoolExp = {
  _and?: InputMaybe<Array<TaskDomainUserCategoryBoolExp>>;
  _not?: InputMaybe<TaskDomainUserCategoryBoolExp>;
  _or?: InputMaybe<Array<TaskDomainUserCategoryBoolExp>>;
  description?: InputMaybe<TaskStringComparisonExp>;
  value?: InputMaybe<TaskStringComparisonExp>;
};

/** unique or primary key constraints on table "domain_user_category" */
export type TaskDomainUserCategoryConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'domain_user_category_pkey'
  | '%future added value';

export type TaskDomainUserCategoryEnum =
  /** Customer */
  | 'CUSTOMER'
  /** Employee */
  | 'EMPLOYEE'
  | '%future added value';

/** Boolean expression to compare columns of type "DomainUserCategoryEnum". All fields are combined with logical 'AND'. */
export type TaskDomainUserCategoryEnumComparisonExp = {
  _eq?: InputMaybe<TaskDomainUserCategoryEnum>;
  _in?: InputMaybe<Array<TaskDomainUserCategoryEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<TaskDomainUserCategoryEnum>;
  _nin?: InputMaybe<Array<TaskDomainUserCategoryEnum>>;
};

/** input type for inserting data into table "domain_user_category" */
export type TaskDomainUserCategoryInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type TaskDomainUserCategoryMaxFields = {
  __typename?: 'TaskDomainUserCategoryMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type TaskDomainUserCategoryMinFields = {
  __typename?: 'TaskDomainUserCategoryMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "domain_user_category" */
export type TaskDomainUserCategoryMutationResponse = {
  __typename?: 'TaskDomainUserCategoryMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TaskDomainUserCategory>;
};

/** input type for inserting object relation for remote table "domain_user_category" */
export type TaskDomainUserCategoryObjRelInsertInput = {
  data: TaskDomainUserCategoryInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TaskDomainUserCategoryOnConflict>;
};

/** on_conflict condition type for table "domain_user_category" */
export type TaskDomainUserCategoryOnConflict = {
  constraint: TaskDomainUserCategoryConstraint;
  updateColumns?: Array<TaskDomainUserCategoryUpdateColumn>;
  where?: InputMaybe<TaskDomainUserCategoryBoolExp>;
};

/** Ordering options when selecting data from "domain_user_category". */
export type TaskDomainUserCategoryOrderBy = {
  description?: InputMaybe<TaskOrderBy>;
  value?: InputMaybe<TaskOrderBy>;
};

/** primary key columns input for table: domain_user_category */
export type TaskDomainUserCategoryPkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "domain_user_category" */
export type TaskDomainUserCategorySelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "domain_user_category" */
export type TaskDomainUserCategorySetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "domain_user_category" */
export type TaskDomainUserCategoryStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TaskDomainUserCategoryStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TaskCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TaskDomainUserCategoryStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "domain_user_category" */
export type TaskDomainUserCategoryUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type TaskDomainUserCategoryUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TaskDomainUserCategorySetInput>;
  /** filter the rows which have to be updated */
  where: TaskDomainUserCategoryBoolExp;
};

/** unique or primary key constraints on table "domain_user" */
export type TaskDomainUserConstraint =
  /** unique or primary key constraint on columns "organization_user_id" */
  | 'domain_user_organization_user_id_key'
  /** unique or primary key constraint on columns "id" */
  | 'domain_user_pkey'
  | '%future added value';

/** input type for inserting data into table "domain_user" */
export type TaskDomainUserInsertInput = {
  activityParticipants?: InputMaybe<TaskActivityParticipantArrRelInsertInput>;
  category?: InputMaybe<TaskDomainUserCategoryEnum>;
  createdAt?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
  domainOrganization?: InputMaybe<TaskDomainOrganizationObjRelInsertInput>;
  domainOrganizationId?: InputMaybe<Scalars['uuid']['input']>;
  domainUserCategory?: InputMaybe<TaskDomainUserCategoryObjRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
};

/** aggregate max on columns */
export type TaskDomainUserMaxFields = {
  __typename?: 'TaskDomainUserMaxFields';
  createdAt?: Maybe<Scalars['Tasktimestamptz']['output']>;
  domainOrganizationId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['Tasktimestamptz']['output']>;
};

/** order by max() on columns of table "domain_user" */
export type TaskDomainUserMaxOrderBy = {
  createdAt?: InputMaybe<TaskOrderBy>;
  domainOrganizationId?: InputMaybe<TaskOrderBy>;
  id?: InputMaybe<TaskOrderBy>;
  organizationUserId?: InputMaybe<TaskOrderBy>;
  updatedAt?: InputMaybe<TaskOrderBy>;
};

/** aggregate min on columns */
export type TaskDomainUserMinFields = {
  __typename?: 'TaskDomainUserMinFields';
  createdAt?: Maybe<Scalars['Tasktimestamptz']['output']>;
  domainOrganizationId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['Tasktimestamptz']['output']>;
};

/** order by min() on columns of table "domain_user" */
export type TaskDomainUserMinOrderBy = {
  createdAt?: InputMaybe<TaskOrderBy>;
  domainOrganizationId?: InputMaybe<TaskOrderBy>;
  id?: InputMaybe<TaskOrderBy>;
  organizationUserId?: InputMaybe<TaskOrderBy>;
  updatedAt?: InputMaybe<TaskOrderBy>;
};

/** response of any mutation on the table "domain_user" */
export type TaskDomainUserMutationResponse = {
  __typename?: 'TaskDomainUserMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TaskDomainUser>;
};

/** input type for inserting object relation for remote table "domain_user" */
export type TaskDomainUserObjRelInsertInput = {
  data: TaskDomainUserInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TaskDomainUserOnConflict>;
};

/** on_conflict condition type for table "domain_user" */
export type TaskDomainUserOnConflict = {
  constraint: TaskDomainUserConstraint;
  updateColumns?: Array<TaskDomainUserUpdateColumn>;
  where?: InputMaybe<TaskDomainUserBoolExp>;
};

/** Ordering options when selecting data from "domain_user". */
export type TaskDomainUserOrderBy = {
  activityParticipantsAggregate?: InputMaybe<TaskActivityParticipantAggregateOrderBy>;
  category?: InputMaybe<TaskOrderBy>;
  createdAt?: InputMaybe<TaskOrderBy>;
  domainOrganization?: InputMaybe<TaskDomainOrganizationOrderBy>;
  domainOrganizationId?: InputMaybe<TaskOrderBy>;
  domainUserCategory?: InputMaybe<TaskDomainUserCategoryOrderBy>;
  id?: InputMaybe<TaskOrderBy>;
  organizationUserId?: InputMaybe<TaskOrderBy>;
  updatedAt?: InputMaybe<TaskOrderBy>;
};

/** primary key columns input for table: domain_user */
export type TaskDomainUserPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "domain_user" */
export type TaskDomainUserSelectColumn =
  /** column name */
  | 'category'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'domainOrganizationId'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "domain_user" */
export type TaskDomainUserSetInput = {
  category?: InputMaybe<TaskDomainUserCategoryEnum>;
  createdAt?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
  domainOrganizationId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
};

/** Streaming cursor of the table "domain_user" */
export type TaskDomainUserStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TaskDomainUserStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TaskCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TaskDomainUserStreamCursorValueInput = {
  category?: InputMaybe<TaskDomainUserCategoryEnum>;
  createdAt?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
  domainOrganizationId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
};

/** update columns of table "domain_user" */
export type TaskDomainUserUpdateColumn =
  /** column name */
  | 'category'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'domainOrganizationId'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type TaskDomainUserUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TaskDomainUserSetInput>;
  /** filter the rows which have to be updated */
  where: TaskDomainUserBoolExp;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type TaskIntComparisonExp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type TaskJsonbCastExp = {
  String?: InputMaybe<TaskStringComparisonExp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type TaskJsonbComparisonExp = {
  _cast?: InputMaybe<TaskJsonbCastExp>;
  /** is the column contained in the given json value */
  _containedIn?: InputMaybe<Scalars['Taskjsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['Taskjsonb']['input']>;
  _eq?: InputMaybe<Scalars['Taskjsonb']['input']>;
  _gt?: InputMaybe<Scalars['Taskjsonb']['input']>;
  _gte?: InputMaybe<Scalars['Taskjsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _hasKey?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _hasKeysAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _hasKeysAny?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['Taskjsonb']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Taskjsonb']['input']>;
  _lte?: InputMaybe<Scalars['Taskjsonb']['input']>;
  _neq?: InputMaybe<Scalars['Taskjsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['Taskjsonb']['input']>>;
};

/** column ordering options */
export type TaskOrderBy =
  /** in ascending order, nulls last */
  | 'ASC'
  /** in ascending order, nulls first */
  | 'ASC_NULLS_FIRST'
  /** in ascending order, nulls last */
  | 'ASC_NULLS_LAST'
  /** in descending order, nulls first */
  | 'DESC'
  /** in descending order, nulls first */
  | 'DESC_NULLS_FIRST'
  /** in descending order, nulls last */
  | 'DESC_NULLS_LAST'
  | '%future added value';

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type TaskStringComparisonExp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type TaskTimestamptzComparisonExp = {
  _eq?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
  _gt?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
  _gte?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['Tasktimestamptz']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
  _lte?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
  _neq?: InputMaybe<Scalars['Tasktimestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['Tasktimestamptz']['input']>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type TaskUuidComparisonExp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type TaskactivityParticipantAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TaskActivityParticipantSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TaskActivityParticipantBoolExp>;
  predicate: TaskIntComparisonExp;
};

export type TaskdomainUserAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TaskDomainUserSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TaskDomainUserBoolExp>;
  predicate: TaskIntComparisonExp;
};

export type TasktaskActivityInput = {
  additionalData?: InputMaybe<Scalars['Taskjsonb']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  taskType?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type TasktaskActivityOutput = {
  __typename?: 'TasktaskActivityOutput';
  result: Scalars['Taskjson']['output'];
};

/** columns and relationships of "telephony.activity_participant_role" */
export type TelephonyActivityParticipantRole = {
  __typename?: 'TelephonyActivityParticipantRole';
  /** An array relationship */
  activityParticipants: Array<TelephonyactivityParticipant>;
  /** An aggregate relationship */
  activityParticipantsAggregate: TelephonyactivityParticipantAggregate;
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};


/** columns and relationships of "telephony.activity_participant_role" */
export type TelephonyActivityParticipantRoleactivityParticipantsArgs = {
  distinctOn?: InputMaybe<Array<TelephonyactivityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyactivityParticipantOrderBy>>;
  where?: InputMaybe<TelephonyactivityParticipantBoolExp>;
};


/** columns and relationships of "telephony.activity_participant_role" */
export type TelephonyActivityParticipantRoleactivityParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyactivityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyactivityParticipantOrderBy>>;
  where?: InputMaybe<TelephonyactivityParticipantBoolExp>;
};

/** aggregated selection of "telephony.activity_participant_role" */
export type TelephonyActivityParticipantRoleAggregate = {
  __typename?: 'TelephonyActivityParticipantRoleAggregate';
  aggregate?: Maybe<TelephonyActivityParticipantRoleAggregateFields>;
  nodes: Array<TelephonyActivityParticipantRole>;
};

/** aggregate fields of "telephony.activity_participant_role" */
export type TelephonyActivityParticipantRoleAggregateFields = {
  __typename?: 'TelephonyActivityParticipantRoleAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TelephonyActivityParticipantRoleMaxFields>;
  min?: Maybe<TelephonyActivityParticipantRoleMinFields>;
};


/** aggregate fields of "telephony.activity_participant_role" */
export type TelephonyActivityParticipantRoleAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TelephonyActivityParticipantRoleSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "telephony.activity_participant_role". All fields are combined with a logical 'AND'. */
export type TelephonyActivityParticipantRoleBoolExp = {
  _and?: InputMaybe<Array<TelephonyActivityParticipantRoleBoolExp>>;
  _not?: InputMaybe<TelephonyActivityParticipantRoleBoolExp>;
  _or?: InputMaybe<Array<TelephonyActivityParticipantRoleBoolExp>>;
  activityParticipants?: InputMaybe<TelephonyactivityParticipantBoolExp>;
  activityParticipantsAggregate?: InputMaybe<TelephonyactivityParticipantAggregateBoolExp>;
  description?: InputMaybe<TaskStringComparisonExp>;
  value?: InputMaybe<TaskStringComparisonExp>;
};

/** unique or primary key constraints on table "telephony.activity_participant_role" */
export type TelephonyActivityParticipantRoleConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'activity_participant_role_pkey'
  | '%future added value';

export type TelephonyActivityParticipantRoleEnum =
  /** Destination */
  | 'DESTINATION'
  /** General */
  | 'GENERAL'
  /** Originating */
  | 'ORIGINATING'
  | '%future added value';

/** Boolean expression to compare columns of type "ActivityParticipantRoleEnum". All fields are combined with logical 'AND'. */
export type TelephonyActivityParticipantRoleEnumComparisonExp = {
  _eq?: InputMaybe<TelephonyActivityParticipantRoleEnum>;
  _in?: InputMaybe<Array<TelephonyActivityParticipantRoleEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<TelephonyActivityParticipantRoleEnum>;
  _nin?: InputMaybe<Array<TelephonyActivityParticipantRoleEnum>>;
};

/** input type for inserting data into table "telephony.activity_participant_role" */
export type TelephonyActivityParticipantRoleInsertInput = {
  activityParticipants?: InputMaybe<TelephonyactivityParticipantArrRelInsertInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type TelephonyActivityParticipantRoleMaxFields = {
  __typename?: 'TelephonyActivityParticipantRoleMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type TelephonyActivityParticipantRoleMinFields = {
  __typename?: 'TelephonyActivityParticipantRoleMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "telephony.activity_participant_role" */
export type TelephonyActivityParticipantRoleMutationResponse = {
  __typename?: 'TelephonyActivityParticipantRoleMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TelephonyActivityParticipantRole>;
};

/** on_conflict condition type for table "telephony.activity_participant_role" */
export type TelephonyActivityParticipantRoleOnConflict = {
  constraint: TelephonyActivityParticipantRoleConstraint;
  updateColumns?: Array<TelephonyActivityParticipantRoleUpdateColumn>;
  where?: InputMaybe<TelephonyActivityParticipantRoleBoolExp>;
};

/** Ordering options when selecting data from "telephony.activity_participant_role". */
export type TelephonyActivityParticipantRoleOrderBy = {
  activityParticipantsAggregate?: InputMaybe<TelephonyactivityParticipantAggregateOrderBy>;
  description?: InputMaybe<TelephonyOrderBy>;
  value?: InputMaybe<TelephonyOrderBy>;
};

/** primary key columns input for table: telephony.activity_participant_role */
export type TelephonyActivityParticipantRolePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "telephony.activity_participant_role" */
export type TelephonyActivityParticipantRoleSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "telephony.activity_participant_role" */
export type TelephonyActivityParticipantRoleSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "ActivityParticipantRole" */
export type TelephonyActivityParticipantRoleStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TelephonyActivityParticipantRoleStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TelephonyCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TelephonyActivityParticipantRoleStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "telephony.activity_participant_role" */
export type TelephonyActivityParticipantRoleUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type TelephonyActivityParticipantRoleUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TelephonyActivityParticipantRoleSetInput>;
  /** filter the rows which have to be updated */
  where: TelephonyActivityParticipantRoleBoolExp;
};

/** columns and relationships of "telephony.activity_type" */
export type TelephonyActivityType = {
  __typename?: 'TelephonyActivityType';
  /** An array relationship */
  activities: Array<Telephonyactivity>;
  /** An aggregate relationship */
  activitiesAggregate: TelephonyactivityAggregate;
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};


/** columns and relationships of "telephony.activity_type" */
export type TelephonyActivityTypeactivitiesArgs = {
  distinctOn?: InputMaybe<Array<TelephonyactivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyactivityOrderBy>>;
  where?: InputMaybe<TelephonyactivityBoolExp>;
};


/** columns and relationships of "telephony.activity_type" */
export type TelephonyActivityTypeactivitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyactivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyactivityOrderBy>>;
  where?: InputMaybe<TelephonyactivityBoolExp>;
};

/** aggregated selection of "telephony.activity_type" */
export type TelephonyActivityTypeAggregate = {
  __typename?: 'TelephonyActivityTypeAggregate';
  aggregate?: Maybe<TelephonyActivityTypeAggregateFields>;
  nodes: Array<TelephonyActivityType>;
};

/** aggregate fields of "telephony.activity_type" */
export type TelephonyActivityTypeAggregateFields = {
  __typename?: 'TelephonyActivityTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TaskActivityTypeMaxFields>;
  min?: Maybe<TaskActivityTypeMinFields>;
};


/** aggregate fields of "telephony.activity_type" */
export type TelephonyActivityTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TelephonyActivityTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "telephony.activity_type". All fields are combined with a logical 'AND'. */
export type TelephonyActivityTypeBoolExp = {
  _and?: InputMaybe<Array<TelephonyActivityTypeBoolExp>>;
  _not?: InputMaybe<TelephonyActivityTypeBoolExp>;
  _or?: InputMaybe<Array<TelephonyActivityTypeBoolExp>>;
  activities?: InputMaybe<TelephonyactivityBoolExp>;
  activitiesAggregate?: InputMaybe<TelephonyactivityAggregateBoolExp>;
  description?: InputMaybe<TaskStringComparisonExp>;
  value?: InputMaybe<TaskStringComparisonExp>;
};

/** unique or primary key constraints on table "telephony.activity_type" */
export type TelephonyActivityTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'activity_type_pkey'
  | '%future added value';

export type TelephonyActivityTypeEnum =
  /** Phone call or conversation */
  | 'CALL'
  /** Phone conference */
  | 'CONFERENCE'
  /** Direct call */
  | 'DIRECT_CALL'
  /** Queue call */
  | 'QUEUE_CALL'
  /** Unknown call type */
  | 'UNKNOWN_CALL'
  | '%future added value';

/** input type for inserting data into table "telephony.activity_type" */
export type TelephonyActivityTypeInsertInput = {
  activities?: InputMaybe<TelephonyactivityArrRelInsertInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "telephony.activity_type" */
export type TelephonyActivityTypeMutationResponse = {
  __typename?: 'TelephonyActivityTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TelephonyActivityType>;
};

/** input type for inserting object relation for remote table "telephony.activity_type" */
export type TelephonyActivityTypeObjRelInsertInput = {
  data: TelephonyActivityTypeInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TelephonyActivityTypeOnConflict>;
};

/** on_conflict condition type for table "telephony.activity_type" */
export type TelephonyActivityTypeOnConflict = {
  constraint: TelephonyActivityTypeConstraint;
  updateColumns?: Array<TelephonyActivityTypeUpdateColumn>;
  where?: InputMaybe<TelephonyActivityTypeBoolExp>;
};

/** Ordering options when selecting data from "telephony.activity_type". */
export type TelephonyActivityTypeOrderBy = {
  activitiesAggregate?: InputMaybe<TelephonyactivityAggregateOrderBy>;
  description?: InputMaybe<TelephonyOrderBy>;
  value?: InputMaybe<TelephonyOrderBy>;
};

/** primary key columns input for table: telephony.activity_type */
export type TelephonyActivityTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "telephony.activity_type" */
export type TelephonyActivityTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "telephony.activity_type" */
export type TelephonyActivityTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "ActivityType" */
export type TelephonyActivityTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TaskActivityTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TelephonyCursorOrdering>;
};

/** update columns of table "telephony.activity_type" */
export type TelephonyActivityTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type TelephonyBooleanComparisonExp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** columns and relationships of "telephony.call_direction" */
export type TelephonyCallDirection = {
  __typename?: 'TelephonyCallDirection';
  description: Scalars['String']['output'];
  /** An array relationship */
  events: Array<Telephonyevent>;
  /** An aggregate relationship */
  eventsAggregate: TelephonyeventAggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "telephony.call_direction" */
export type TelephonyCallDirectioneventsArgs = {
  distinctOn?: InputMaybe<Array<TelephonyeventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyeventOrderBy>>;
  where?: InputMaybe<TelephonyeventBoolExp>;
};


/** columns and relationships of "telephony.call_direction" */
export type TelephonyCallDirectioneventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyeventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyeventOrderBy>>;
  where?: InputMaybe<TelephonyeventBoolExp>;
};

/** aggregated selection of "telephony.call_direction" */
export type TelephonyCallDirectionAggregate = {
  __typename?: 'TelephonyCallDirectionAggregate';
  aggregate?: Maybe<TelephonyCallDirectionAggregateFields>;
  nodes: Array<TelephonyCallDirection>;
};

/** aggregate fields of "telephony.call_direction" */
export type TelephonyCallDirectionAggregateFields = {
  __typename?: 'TelephonyCallDirectionAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TelephonyCallDirectionMaxFields>;
  min?: Maybe<TelephonyCallDirectionMinFields>;
};


/** aggregate fields of "telephony.call_direction" */
export type TelephonyCallDirectionAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TelephonyCallDirectionSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "telephony.call_direction". All fields are combined with a logical 'AND'. */
export type TelephonyCallDirectionBoolExp = {
  _and?: InputMaybe<Array<TelephonyCallDirectionBoolExp>>;
  _not?: InputMaybe<TelephonyCallDirectionBoolExp>;
  _or?: InputMaybe<Array<TelephonyCallDirectionBoolExp>>;
  description?: InputMaybe<TaskStringComparisonExp>;
  events?: InputMaybe<TelephonyeventBoolExp>;
  eventsAggregate?: InputMaybe<TelephonyeventAggregateBoolExp>;
  value?: InputMaybe<TaskStringComparisonExp>;
};

/** unique or primary key constraints on table "telephony.call_direction" */
export type TelephonyCallDirectionConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'direction_pkey'
  | '%future added value';

export type TelephonyCallDirectionEnum =
  | 'ORIGINATING'
  | 'TERMINATING'
  | '%future added value';

/** Boolean expression to compare columns of type "CallDirectionEnum". All fields are combined with logical 'AND'. */
export type TelephonyCallDirectionEnumComparisonExp = {
  _eq?: InputMaybe<TelephonyCallDirectionEnum>;
  _in?: InputMaybe<Array<TelephonyCallDirectionEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<TelephonyCallDirectionEnum>;
  _nin?: InputMaybe<Array<TelephonyCallDirectionEnum>>;
};

/** input type for inserting data into table "telephony.call_direction" */
export type TelephonyCallDirectionInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<TelephonyeventArrRelInsertInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type TelephonyCallDirectionMaxFields = {
  __typename?: 'TelephonyCallDirectionMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type TelephonyCallDirectionMinFields = {
  __typename?: 'TelephonyCallDirectionMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "telephony.call_direction" */
export type TelephonyCallDirectionMutationResponse = {
  __typename?: 'TelephonyCallDirectionMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TelephonyCallDirection>;
};

/** input type for inserting object relation for remote table "telephony.call_direction" */
export type TelephonyCallDirectionObjRelInsertInput = {
  data: TelephonyCallDirectionInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TelephonyCallDirectionOnConflict>;
};

/** on_conflict condition type for table "telephony.call_direction" */
export type TelephonyCallDirectionOnConflict = {
  constraint: TelephonyCallDirectionConstraint;
  updateColumns?: Array<TelephonyCallDirectionUpdateColumn>;
  where?: InputMaybe<TelephonyCallDirectionBoolExp>;
};

/** Ordering options when selecting data from "telephony.call_direction". */
export type TelephonyCallDirectionOrderBy = {
  description?: InputMaybe<TelephonyOrderBy>;
  eventsAggregate?: InputMaybe<TelephonyeventAggregateOrderBy>;
  value?: InputMaybe<TelephonyOrderBy>;
};

/** primary key columns input for table: telephony.call_direction */
export type TelephonyCallDirectionPkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "telephony.call_direction" */
export type TelephonyCallDirectionSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "telephony.call_direction" */
export type TelephonyCallDirectionSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "CallDirection" */
export type TelephonyCallDirectionStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TelephonyCallDirectionStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TelephonyCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TelephonyCallDirectionStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "telephony.call_direction" */
export type TelephonyCallDirectionUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type TelephonyCallDirectionUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TelephonyCallDirectionSetInput>;
  /** filter the rows which have to be updated */
  where: TelephonyCallDirectionBoolExp;
};

export type TelephonyCallResultInput = {
  callId: Scalars['String']['input'];
  providerClientId: Scalars['String']['input'];
};

export type TelephonyCallResultOutput = {
  __typename?: 'TelephonyCallResultOutput';
  result: TelephonyCallResultType;
};

export type TelephonyCallResultType =
  | 'ANSWERED'
  | 'TERMINATED'
  | 'UNCONCLUDED'
  | 'UNKNOWN'
  | '%future added value';

export type TelephonyClickToCallInput = {
  callerId?: InputMaybe<Scalars['String']['input']>;
  destinationNumber: Scalars['String']['input'];
  number: Scalars['String']['input'];
  providerClientId: Scalars['String']['input'];
};

export type TelephonyClickToCallOutput = {
  __typename?: 'TelephonyClickToCallOutput';
  error: Scalars['String']['output'];
};

export type TelephonyCredentialsOutput = {
  __typename?: 'TelephonyCredentialsOutput';
  error: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
};

export type TelephonyCredentialsValidation = {
  id: Scalars['uuid']['input'];
  organizationId: Scalars['uuid']['input'];
  password: Scalars['String']['input'];
  type: Scalars['String']['input'];
  userId: Scalars['uuid']['input'];
  username: Scalars['String']['input'];
};

/** ordering argument of a cursor */
export type TelephonyCursorOrdering =
  /** ascending ordering of the cursor */
  | 'ASC'
  /** descending ordering of the cursor */
  | 'DESC'
  | '%future added value';

/** columns and relationships of "telephony.domain_user_category" */
export type TelephonyDomainUserCategory = {
  __typename?: 'TelephonyDomainUserCategory';
  description: Scalars['String']['output'];
  /** An array relationship */
  domainUsers: Array<TelephonydomainUser>;
  /** An aggregate relationship */
  domainUsersAggregate: TelephonydomainUserAggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "telephony.domain_user_category" */
export type TelephonyDomainUserCategorydomainUsersArgs = {
  distinctOn?: InputMaybe<Array<TelephonydomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonydomainUserOrderBy>>;
  where?: InputMaybe<TelephonydomainUserBoolExp>;
};


/** columns and relationships of "telephony.domain_user_category" */
export type TelephonyDomainUserCategorydomainUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonydomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonydomainUserOrderBy>>;
  where?: InputMaybe<TelephonydomainUserBoolExp>;
};

/** aggregated selection of "telephony.domain_user_category" */
export type TelephonyDomainUserCategoryAggregate = {
  __typename?: 'TelephonyDomainUserCategoryAggregate';
  aggregate?: Maybe<TelephonyDomainUserCategoryAggregateFields>;
  nodes: Array<TelephonyDomainUserCategory>;
};

/** aggregate fields of "telephony.domain_user_category" */
export type TelephonyDomainUserCategoryAggregateFields = {
  __typename?: 'TelephonyDomainUserCategoryAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TaskDomainUserCategoryMaxFields>;
  min?: Maybe<TaskDomainUserCategoryMinFields>;
};


/** aggregate fields of "telephony.domain_user_category" */
export type TelephonyDomainUserCategoryAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TelephonyDomainUserCategorySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "telephony.domain_user_category". All fields are combined with a logical 'AND'. */
export type TelephonyDomainUserCategoryBoolExp = {
  _and?: InputMaybe<Array<TelephonyDomainUserCategoryBoolExp>>;
  _not?: InputMaybe<TelephonyDomainUserCategoryBoolExp>;
  _or?: InputMaybe<Array<TelephonyDomainUserCategoryBoolExp>>;
  description?: InputMaybe<TaskStringComparisonExp>;
  domainUsers?: InputMaybe<TelephonydomainUserBoolExp>;
  domainUsersAggregate?: InputMaybe<TelephonydomainUserAggregateBoolExp>;
  value?: InputMaybe<TaskStringComparisonExp>;
};

/** unique or primary key constraints on table "telephony.domain_user_category" */
export type TelephonyDomainUserCategoryConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'domain_user_category_pkey'
  | '%future added value';

export type TelephonyDomainUserCategoryEnum =
  /** Customer */
  | 'CUSTOMER'
  /** Customer candidate */
  | 'CUSTOMER_CANDIDATE'
  /** Employee */
  | 'EMPLOYEE'
  /** Employee candidate */
  | 'EMPLOYEE_CANDIDATE'
  | '%future added value';

/** input type for inserting data into table "telephony.domain_user_category" */
export type TelephonyDomainUserCategoryInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  domainUsers?: InputMaybe<TelephonydomainUserArrRelInsertInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "telephony.domain_user_category" */
export type TelephonyDomainUserCategoryMutationResponse = {
  __typename?: 'TelephonyDomainUserCategoryMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TelephonyDomainUserCategory>;
};

/** input type for inserting object relation for remote table "telephony.domain_user_category" */
export type TelephonyDomainUserCategoryObjRelInsertInput = {
  data: TelephonyDomainUserCategoryInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TelephonyDomainUserCategoryOnConflict>;
};

/** on_conflict condition type for table "telephony.domain_user_category" */
export type TelephonyDomainUserCategoryOnConflict = {
  constraint: TelephonyDomainUserCategoryConstraint;
  updateColumns?: Array<TelephonyDomainUserCategoryUpdateColumn>;
  where?: InputMaybe<TelephonyDomainUserCategoryBoolExp>;
};

/** Ordering options when selecting data from "telephony.domain_user_category". */
export type TelephonyDomainUserCategoryOrderBy = {
  description?: InputMaybe<TelephonyOrderBy>;
  domainUsersAggregate?: InputMaybe<TelephonydomainUserAggregateOrderBy>;
  value?: InputMaybe<TelephonyOrderBy>;
};

/** primary key columns input for table: telephony.domain_user_category */
export type TelephonyDomainUserCategoryPkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "telephony.domain_user_category" */
export type TelephonyDomainUserCategorySelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "telephony.domain_user_category" */
export type TelephonyDomainUserCategorySetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "DomainUserCategory" */
export type TelephonyDomainUserCategoryStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TaskDomainUserCategoryStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TelephonyCursorOrdering>;
};

/** update columns of table "telephony.domain_user_category" */
export type TelephonyDomainUserCategoryUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type TelephonyDomainUserOutput = {
  __typename?: 'TelephonyDomainUserOutput';
  category?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  domainOrganizationId?: Maybe<Scalars['uuid']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  function?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  numberType?: Maybe<Scalars['String']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  personId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type TelephonyEntryCategory =
  | 'COMPANY'
  | 'PERSON'
  | 'UNKNOWN'
  | '%future added value';

export type TelephonyEntrySource =
  | 'COMBINED'
  | 'DB'
  | 'EIGHTEENEIGHTYONE'
  | 'FIS'
  | 'NONE'
  | 'TIMEOUT'
  | '%future added value';

export type TelephonyLookupPhoneNumberOutput = {
  __typename?: 'TelephonyLookupPhoneNumberOutput';
  category?: Maybe<TelephonyEntryCategory>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  source?: Maybe<TelephonyEntrySource>;
  street?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "telephony.number_state" */
export type TelephonyNumberState = {
  __typename?: 'TelephonyNumberState';
  description: Scalars['String']['output'];
  /** An array relationship */
  events: Array<Telephonyevent>;
  /** An aggregate relationship */
  eventsAggregate: TelephonyeventAggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "telephony.number_state" */
export type TelephonyNumberStateeventsArgs = {
  distinctOn?: InputMaybe<Array<TelephonyeventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyeventOrderBy>>;
  where?: InputMaybe<TelephonyeventBoolExp>;
};


/** columns and relationships of "telephony.number_state" */
export type TelephonyNumberStateeventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyeventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyeventOrderBy>>;
  where?: InputMaybe<TelephonyeventBoolExp>;
};

/** aggregated selection of "telephony.number_state" */
export type TelephonyNumberStateAggregate = {
  __typename?: 'TelephonyNumberStateAggregate';
  aggregate?: Maybe<TelephonyNumberStateAggregateFields>;
  nodes: Array<TelephonyNumberState>;
};

/** aggregate fields of "telephony.number_state" */
export type TelephonyNumberStateAggregateFields = {
  __typename?: 'TelephonyNumberStateAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TelephonyNumberStateMaxFields>;
  min?: Maybe<TelephonyNumberStateMinFields>;
};


/** aggregate fields of "telephony.number_state" */
export type TelephonyNumberStateAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TelephonyNumberStateSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "telephony.number_state". All fields are combined with a logical 'AND'. */
export type TelephonyNumberStateBoolExp = {
  _and?: InputMaybe<Array<TelephonyNumberStateBoolExp>>;
  _not?: InputMaybe<TelephonyNumberStateBoolExp>;
  _or?: InputMaybe<Array<TelephonyNumberStateBoolExp>>;
  description?: InputMaybe<TaskStringComparisonExp>;
  events?: InputMaybe<TelephonyeventBoolExp>;
  eventsAggregate?: InputMaybe<TelephonyeventAggregateBoolExp>;
  value?: InputMaybe<TaskStringComparisonExp>;
};

/** unique or primary key constraints on table "telephony.number_state" */
export type TelephonyNumberStateConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'number_state_pkey'
  | '%future added value';

export type TelephonyNumberStateEnum =
  | 'ALERT'
  | 'BUSY'
  | 'IDLE'
  | '%future added value';

/** Boolean expression to compare columns of type "NumberStateEnum". All fields are combined with logical 'AND'. */
export type TelephonyNumberStateEnumComparisonExp = {
  _eq?: InputMaybe<TelephonyNumberStateEnum>;
  _in?: InputMaybe<Array<TelephonyNumberStateEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<TelephonyNumberStateEnum>;
  _nin?: InputMaybe<Array<TelephonyNumberStateEnum>>;
};

/** input type for inserting data into table "telephony.number_state" */
export type TelephonyNumberStateInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<TelephonyeventArrRelInsertInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type TelephonyNumberStateMaxFields = {
  __typename?: 'TelephonyNumberStateMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type TelephonyNumberStateMinFields = {
  __typename?: 'TelephonyNumberStateMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "telephony.number_state" */
export type TelephonyNumberStateMutationResponse = {
  __typename?: 'TelephonyNumberStateMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TelephonyNumberState>;
};

/** input type for inserting object relation for remote table "telephony.number_state" */
export type TelephonyNumberStateObjRelInsertInput = {
  data: TelephonyNumberStateInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TelephonyNumberStateOnConflict>;
};

/** on_conflict condition type for table "telephony.number_state" */
export type TelephonyNumberStateOnConflict = {
  constraint: TelephonyNumberStateConstraint;
  updateColumns?: Array<TelephonyNumberStateUpdateColumn>;
  where?: InputMaybe<TelephonyNumberStateBoolExp>;
};

/** Ordering options when selecting data from "telephony.number_state". */
export type TelephonyNumberStateOrderBy = {
  description?: InputMaybe<TelephonyOrderBy>;
  eventsAggregate?: InputMaybe<TelephonyeventAggregateOrderBy>;
  value?: InputMaybe<TelephonyOrderBy>;
};

/** primary key columns input for table: telephony.number_state */
export type TelephonyNumberStatePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "telephony.number_state" */
export type TelephonyNumberStateSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "telephony.number_state" */
export type TelephonyNumberStateSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "NumberState" */
export type TelephonyNumberStateStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TelephonyNumberStateStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TelephonyCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TelephonyNumberStateStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "telephony.number_state" */
export type TelephonyNumberStateUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type TelephonyNumberStateUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TelephonyNumberStateSetInput>;
  /** filter the rows which have to be updated */
  where: TelephonyNumberStateBoolExp;
};

/** column ordering options */
export type TelephonyOrderBy =
  /** in ascending order, nulls last */
  | 'ASC'
  /** in ascending order, nulls first */
  | 'ASC_NULLS_FIRST'
  /** in ascending order, nulls last */
  | 'ASC_NULLS_LAST'
  /** in descending order, nulls first */
  | 'DESC'
  /** in descending order, nulls first */
  | 'DESC_NULLS_FIRST'
  /** in descending order, nulls last */
  | 'DESC_NULLS_LAST'
  | '%future added value';

export type TelephonyPhoneRequestInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  callId?: InputMaybe<Scalars['String']['input']>;
  callingNumber?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  destinationNumber?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

export type TelephonyPhoneRequestOutput = {
  __typename?: 'TelephonyPhoneRequestOutput';
  id: Scalars['String']['output'];
};

export type TelephonyProviderIntegrationAccountInput = {
  endpoint: Scalars['String']['input'];
  password: Scalars['String']['input'];
  providerType: TelephonyTelephonyProviderType;
  username: Scalars['String']['input'];
};

export type TelephonyProviderIntegrationConfigurationInput = {
  activateSubscriptions: Scalars['Boolean']['input'];
};

export type TelephonyProviderIntegrationInput = {
  account: TelephonyProviderIntegrationAccountInput;
  configuration: TelephonyProviderIntegrationConfigurationInput;
  organizationId: Scalars['String']['input'];
};

/** Phonero, Telenor etc. */
export type TelephonyProviderType = {
  __typename?: 'TelephonyProviderType';
  description: Scalars['String']['output'];
  /** An array relationship */
  providerAccounts: Array<TelephonyproviderAccount>;
  /** An aggregate relationship */
  providerAccountsAggregate: TelephonyproviderAccountAggregate;
  value: Scalars['String']['output'];
};


/** Phonero, Telenor etc. */
export type TelephonyProviderTypeproviderAccountsArgs = {
  distinctOn?: InputMaybe<Array<TelephonyproviderAccountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyproviderAccountOrderBy>>;
  where?: InputMaybe<TelephonyproviderAccountBoolExp>;
};


/** Phonero, Telenor etc. */
export type TelephonyProviderTypeproviderAccountsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyproviderAccountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyproviderAccountOrderBy>>;
  where?: InputMaybe<TelephonyproviderAccountBoolExp>;
};

/** aggregated selection of "telephony.provider_type" */
export type TelephonyProviderTypeAggregate = {
  __typename?: 'TelephonyProviderTypeAggregate';
  aggregate?: Maybe<TelephonyProviderTypeAggregateFields>;
  nodes: Array<TelephonyProviderType>;
};

/** aggregate fields of "telephony.provider_type" */
export type TelephonyProviderTypeAggregateFields = {
  __typename?: 'TelephonyProviderTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TelephonyProviderTypeMaxFields>;
  min?: Maybe<TelephonyProviderTypeMinFields>;
};


/** aggregate fields of "telephony.provider_type" */
export type TelephonyProviderTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TelephonyProviderTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "telephony.provider_type". All fields are combined with a logical 'AND'. */
export type TelephonyProviderTypeBoolExp = {
  _and?: InputMaybe<Array<TelephonyProviderTypeBoolExp>>;
  _not?: InputMaybe<TelephonyProviderTypeBoolExp>;
  _or?: InputMaybe<Array<TelephonyProviderTypeBoolExp>>;
  description?: InputMaybe<TaskStringComparisonExp>;
  providerAccounts?: InputMaybe<TelephonyproviderAccountBoolExp>;
  providerAccountsAggregate?: InputMaybe<TelephonyproviderAccountAggregateBoolExp>;
  value?: InputMaybe<TaskStringComparisonExp>;
};

/** unique or primary key constraints on table "telephony.provider_type" */
export type TelephonyProviderTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'provider_type_pkey'
  | '%future added value';

export type TelephonyProviderTypeEnum =
  /** Cisco connector */
  | 'CISCO'
  /** Ciso west */
  | 'CISCOUSWEST'
  /** Phonero */
  | 'PHONERO'
  /** Phonero smart connect */
  | 'PHONERO_SMART_CONNECT'
  /** Telenor */
  | 'TELENOR'
  /** Telia */
  | 'TELIA'
  /** telia smart connect */
  | 'TELIA_SMART_CONNECT'
  /** Youtello self protect product */
  | 'YOUTELLO_SELF_PROTECT'
  /** Youtello self protect plus product */
  | 'YOUTELLO_SELF_PROTECT_PLUS'
  | '%future added value';

/** Boolean expression to compare columns of type "ProviderTypeEnum". All fields are combined with logical 'AND'. */
export type TelephonyProviderTypeEnumComparisonExp = {
  _eq?: InputMaybe<TelephonyProviderTypeEnum>;
  _in?: InputMaybe<Array<TelephonyProviderTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<TelephonyProviderTypeEnum>;
  _nin?: InputMaybe<Array<TelephonyProviderTypeEnum>>;
};

/** input type for inserting data into table "telephony.provider_type" */
export type TelephonyProviderTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  providerAccounts?: InputMaybe<TelephonyproviderAccountArrRelInsertInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type TelephonyProviderTypeMaxFields = {
  __typename?: 'TelephonyProviderTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type TelephonyProviderTypeMinFields = {
  __typename?: 'TelephonyProviderTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "telephony.provider_type" */
export type TelephonyProviderTypeMutationResponse = {
  __typename?: 'TelephonyProviderTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TelephonyProviderType>;
};

/** input type for inserting object relation for remote table "telephony.provider_type" */
export type TelephonyProviderTypeObjRelInsertInput = {
  data: TelephonyProviderTypeInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TelephonyProviderTypeOnConflict>;
};

/** on_conflict condition type for table "telephony.provider_type" */
export type TelephonyProviderTypeOnConflict = {
  constraint: TelephonyProviderTypeConstraint;
  updateColumns?: Array<TelephonyProviderTypeUpdateColumn>;
  where?: InputMaybe<TelephonyProviderTypeBoolExp>;
};

/** Ordering options when selecting data from "telephony.provider_type". */
export type TelephonyProviderTypeOrderBy = {
  description?: InputMaybe<TelephonyOrderBy>;
  providerAccountsAggregate?: InputMaybe<TelephonyproviderAccountAggregateOrderBy>;
  value?: InputMaybe<TelephonyOrderBy>;
};

/** primary key columns input for table: telephony.provider_type */
export type TelephonyProviderTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "telephony.provider_type" */
export type TelephonyProviderTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "telephony.provider_type" */
export type TelephonyProviderTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "ProviderType" */
export type TelephonyProviderTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TelephonyProviderTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TelephonyCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TelephonyProviderTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "telephony.provider_type" */
export type TelephonyProviderTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type TelephonyProviderTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TelephonyProviderTypeSetInput>;
  /** filter the rows which have to be updated */
  where: TelephonyProviderTypeBoolExp;
};

export type TelephonySendSMSOutput = {
  __typename?: 'TelephonySendSMSOutput';
  description?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  resultCode?: Maybe<Scalars['Int']['output']>;
};

export type TelephonySynchronizeDomainUsersInput = {
  account: TelephonyProviderIntegrationAccountInput;
  customerId?: InputMaybe<Scalars['String']['input']>;
};

export type TelephonySynchronizeDomainUsersOutput = {
  __typename?: 'TelephonySynchronizeDomainUsersOutput';
  accessToken: Scalars['String']['output'];
};

/** columns and relationships of "telephony.action_event_type" */
export type TelephonyTelephonyActionEventType = {
  __typename?: 'TelephonyTelephonyActionEventType';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "telephony.action_event_type" */
export type TelephonyTelephonyActionEventTypeAggregate = {
  __typename?: 'TelephonyTelephonyActionEventTypeAggregate';
  aggregate?: Maybe<TelephonyTelephonyActionEventTypeAggregateFields>;
  nodes: Array<TelephonyTelephonyActionEventType>;
};

/** aggregate fields of "telephony.action_event_type" */
export type TelephonyTelephonyActionEventTypeAggregateFields = {
  __typename?: 'TelephonyTelephonyActionEventTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TelephonyTelephonyActionEventTypeMaxFields>;
  min?: Maybe<TelephonyTelephonyActionEventTypeMinFields>;
};


/** aggregate fields of "telephony.action_event_type" */
export type TelephonyTelephonyActionEventTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TelephonyTelephonyActionEventTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "telephony.action_event_type". All fields are combined with a logical 'AND'. */
export type TelephonyTelephonyActionEventTypeBoolExp = {
  _and?: InputMaybe<Array<TelephonyTelephonyActionEventTypeBoolExp>>;
  _not?: InputMaybe<TelephonyTelephonyActionEventTypeBoolExp>;
  _or?: InputMaybe<Array<TelephonyTelephonyActionEventTypeBoolExp>>;
  description?: InputMaybe<TaskStringComparisonExp>;
  value?: InputMaybe<TaskStringComparisonExp>;
};

/** unique or primary key constraints on table "telephony.action_event_type" */
export type TelephonyTelephonyActionEventTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'action_event_type_pkey'
  | '%future added value';

export type TelephonyTelephonyActionEventTypeEnum =
  /** Automatically hanged up */
  | 'AUTOMATICALLY_HANGED_UP'
  /** MANUALLY_HANGED_UP */
  | 'MANUALLY_HANGED_UP'
  | '%future added value';

/** Boolean expression to compare columns of type "TelephonyActionEventTypeEnum". All fields are combined with logical 'AND'. */
export type TelephonyTelephonyActionEventTypeEnumComparisonExp = {
  _eq?: InputMaybe<TelephonyTelephonyActionEventTypeEnum>;
  _in?: InputMaybe<Array<TelephonyTelephonyActionEventTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<TelephonyTelephonyActionEventTypeEnum>;
  _nin?: InputMaybe<Array<TelephonyTelephonyActionEventTypeEnum>>;
};

/** input type for inserting data into table "telephony.action_event_type" */
export type TelephonyTelephonyActionEventTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type TelephonyTelephonyActionEventTypeMaxFields = {
  __typename?: 'TelephonyTelephonyActionEventTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type TelephonyTelephonyActionEventTypeMinFields = {
  __typename?: 'TelephonyTelephonyActionEventTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "telephony.action_event_type" */
export type TelephonyTelephonyActionEventTypeMutationResponse = {
  __typename?: 'TelephonyTelephonyActionEventTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TelephonyTelephonyActionEventType>;
};

/** on_conflict condition type for table "telephony.action_event_type" */
export type TelephonyTelephonyActionEventTypeOnConflict = {
  constraint: TelephonyTelephonyActionEventTypeConstraint;
  updateColumns?: Array<TelephonyTelephonyActionEventTypeUpdateColumn>;
  where?: InputMaybe<TelephonyTelephonyActionEventTypeBoolExp>;
};

/** Ordering options when selecting data from "telephony.action_event_type". */
export type TelephonyTelephonyActionEventTypeOrderBy = {
  description?: InputMaybe<TelephonyOrderBy>;
  value?: InputMaybe<TelephonyOrderBy>;
};

/** primary key columns input for table: telephony.action_event_type */
export type TelephonyTelephonyActionEventTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "telephony.action_event_type" */
export type TelephonyTelephonyActionEventTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "telephony.action_event_type" */
export type TelephonyTelephonyActionEventTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "telephony_action_event_type" */
export type TelephonyTelephonyActionEventTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TelephonyTelephonyActionEventTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TelephonyCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TelephonyTelephonyActionEventTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "telephony.action_event_type" */
export type TelephonyTelephonyActionEventTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type TelephonyTelephonyActionEventTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TelephonyTelephonyActionEventTypeSetInput>;
  /** filter the rows which have to be updated */
  where: TelephonyTelephonyActionEventTypeBoolExp;
};

/** columns and relationships of "telephony.action_type" */
export type TelephonyTelephonyActionType = {
  __typename?: 'TelephonyTelephonyActionType';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "telephony.action_type" */
export type TelephonyTelephonyActionTypeAggregate = {
  __typename?: 'TelephonyTelephonyActionTypeAggregate';
  aggregate?: Maybe<TelephonyTelephonyActionTypeAggregateFields>;
  nodes: Array<TelephonyTelephonyActionType>;
};

/** aggregate fields of "telephony.action_type" */
export type TelephonyTelephonyActionTypeAggregateFields = {
  __typename?: 'TelephonyTelephonyActionTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TelephonyTelephonyActionTypeMaxFields>;
  min?: Maybe<TelephonyTelephonyActionTypeMinFields>;
};


/** aggregate fields of "telephony.action_type" */
export type TelephonyTelephonyActionTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TelephonyTelephonyActionTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "telephony.action_type". All fields are combined with a logical 'AND'. */
export type TelephonyTelephonyActionTypeBoolExp = {
  _and?: InputMaybe<Array<TelephonyTelephonyActionTypeBoolExp>>;
  _not?: InputMaybe<TelephonyTelephonyActionTypeBoolExp>;
  _or?: InputMaybe<Array<TelephonyTelephonyActionTypeBoolExp>>;
  description?: InputMaybe<TaskStringComparisonExp>;
  value?: InputMaybe<TaskStringComparisonExp>;
};

/** unique or primary key constraints on table "telephony.action_type" */
export type TelephonyTelephonyActionTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'action_pkey'
  | '%future added value';

export type TelephonyTelephonyActionTypeEnum =
  /** Hang up */
  | 'HANGUP'
  | '%future added value';

/** Boolean expression to compare columns of type "TelephonyActionTypeEnum". All fields are combined with logical 'AND'. */
export type TelephonyTelephonyActionTypeEnumComparisonExp = {
  _eq?: InputMaybe<TelephonyTelephonyActionTypeEnum>;
  _in?: InputMaybe<Array<TelephonyTelephonyActionTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<TelephonyTelephonyActionTypeEnum>;
  _nin?: InputMaybe<Array<TelephonyTelephonyActionTypeEnum>>;
};

/** input type for inserting data into table "telephony.action_type" */
export type TelephonyTelephonyActionTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type TelephonyTelephonyActionTypeMaxFields = {
  __typename?: 'TelephonyTelephonyActionTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type TelephonyTelephonyActionTypeMinFields = {
  __typename?: 'TelephonyTelephonyActionTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "telephony.action_type" */
export type TelephonyTelephonyActionTypeMutationResponse = {
  __typename?: 'TelephonyTelephonyActionTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TelephonyTelephonyActionType>;
};

/** input type for inserting object relation for remote table "telephony.action_type" */
export type TelephonyTelephonyActionTypeObjRelInsertInput = {
  data: TelephonyTelephonyActionTypeInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TelephonyTelephonyActionTypeOnConflict>;
};

/** on_conflict condition type for table "telephony.action_type" */
export type TelephonyTelephonyActionTypeOnConflict = {
  constraint: TelephonyTelephonyActionTypeConstraint;
  updateColumns?: Array<TelephonyTelephonyActionTypeUpdateColumn>;
  where?: InputMaybe<TelephonyTelephonyActionTypeBoolExp>;
};

/** Ordering options when selecting data from "telephony.action_type". */
export type TelephonyTelephonyActionTypeOrderBy = {
  description?: InputMaybe<TelephonyOrderBy>;
  value?: InputMaybe<TelephonyOrderBy>;
};

/** primary key columns input for table: telephony.action_type */
export type TelephonyTelephonyActionTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "telephony.action_type" */
export type TelephonyTelephonyActionTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "telephony.action_type" */
export type TelephonyTelephonyActionTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "telephony_action_type" */
export type TelephonyTelephonyActionTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TelephonyTelephonyActionTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TelephonyCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TelephonyTelephonyActionTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "telephony.action_type" */
export type TelephonyTelephonyActionTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type TelephonyTelephonyActionTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TelephonyTelephonyActionTypeSetInput>;
  /** filter the rows which have to be updated */
  where: TelephonyTelephonyActionTypeBoolExp;
};

/** columns and relationships of "telephony.blocked_domain_user" */
export type TelephonyTelephonyBlockedDomainUser = {
  __typename?: 'TelephonyTelephonyBlockedDomainUser';
  blockedByDomainUserId: Scalars['uuid']['output'];
  /** An object relationship */
  blockedDomainUser?: Maybe<TelephonydomainUser>;
  blockedDomainUserId?: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['Telephonytimestamptz']['output'];
  /** An object relationship */
  domainUser?: Maybe<TelephonydomainUser>;
  id: Scalars['uuid']['output'];
  organizationId?: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['Telephonytimestamptz']['output'];
};

/** aggregated selection of "telephony.blocked_domain_user" */
export type TelephonyTelephonyBlockedDomainUserAggregate = {
  __typename?: 'TelephonyTelephonyBlockedDomainUserAggregate';
  aggregate?: Maybe<TelephonyTelephonyBlockedDomainUserAggregateFields>;
  nodes: Array<TelephonyTelephonyBlockedDomainUser>;
};

/** aggregate fields of "telephony.blocked_domain_user" */
export type TelephonyTelephonyBlockedDomainUserAggregateFields = {
  __typename?: 'TelephonyTelephonyBlockedDomainUserAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TelephonyTelephonyBlockedDomainUserMaxFields>;
  min?: Maybe<TelephonyTelephonyBlockedDomainUserMinFields>;
};


/** aggregate fields of "telephony.blocked_domain_user" */
export type TelephonyTelephonyBlockedDomainUserAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TelephonyTelephonyBlockedDomainUserSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "telephony.blocked_domain_user". All fields are combined with a logical 'AND'. */
export type TelephonyTelephonyBlockedDomainUserBoolExp = {
  _and?: InputMaybe<Array<TelephonyTelephonyBlockedDomainUserBoolExp>>;
  _not?: InputMaybe<TelephonyTelephonyBlockedDomainUserBoolExp>;
  _or?: InputMaybe<Array<TelephonyTelephonyBlockedDomainUserBoolExp>>;
  blockedByDomainUserId?: InputMaybe<TaskUuidComparisonExp>;
  blockedDomainUser?: InputMaybe<TelephonydomainUserBoolExp>;
  blockedDomainUserId?: InputMaybe<TaskUuidComparisonExp>;
  createdAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  domainUser?: InputMaybe<TelephonydomainUserBoolExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  organizationId?: InputMaybe<TaskUuidComparisonExp>;
  updatedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "telephony.blocked_domain_user" */
export type TelephonyTelephonyBlockedDomainUserConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'blocked_domain_user_pkey'
  | '%future added value';

/** input type for inserting data into table "telephony.blocked_domain_user" */
export type TelephonyTelephonyBlockedDomainUserInsertInput = {
  blockedByDomainUserId?: InputMaybe<Scalars['uuid']['input']>;
  blockedDomainUser?: InputMaybe<TelephonydomainUserObjRelInsertInput>;
  blockedDomainUserId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  domainUser?: InputMaybe<TelephonydomainUserObjRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** aggregate max on columns */
export type TelephonyTelephonyBlockedDomainUserMaxFields = {
  __typename?: 'TelephonyTelephonyBlockedDomainUserMaxFields';
  blockedByDomainUserId?: Maybe<Scalars['uuid']['output']>;
  blockedDomainUserId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
};

/** aggregate min on columns */
export type TelephonyTelephonyBlockedDomainUserMinFields = {
  __typename?: 'TelephonyTelephonyBlockedDomainUserMinFields';
  blockedByDomainUserId?: Maybe<Scalars['uuid']['output']>;
  blockedDomainUserId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
};

/** response of any mutation on the table "telephony.blocked_domain_user" */
export type TelephonyTelephonyBlockedDomainUserMutationResponse = {
  __typename?: 'TelephonyTelephonyBlockedDomainUserMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TelephonyTelephonyBlockedDomainUser>;
};

/** on_conflict condition type for table "telephony.blocked_domain_user" */
export type TelephonyTelephonyBlockedDomainUserOnConflict = {
  constraint: TelephonyTelephonyBlockedDomainUserConstraint;
  updateColumns?: Array<TelephonyTelephonyBlockedDomainUserUpdateColumn>;
  where?: InputMaybe<TelephonyTelephonyBlockedDomainUserBoolExp>;
};

/** Ordering options when selecting data from "telephony.blocked_domain_user". */
export type TelephonyTelephonyBlockedDomainUserOrderBy = {
  blockedByDomainUserId?: InputMaybe<TelephonyOrderBy>;
  blockedDomainUser?: InputMaybe<TelephonydomainUserOrderBy>;
  blockedDomainUserId?: InputMaybe<TelephonyOrderBy>;
  createdAt?: InputMaybe<TelephonyOrderBy>;
  domainUser?: InputMaybe<TelephonydomainUserOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  organizationId?: InputMaybe<TelephonyOrderBy>;
  updatedAt?: InputMaybe<TelephonyOrderBy>;
};

/** primary key columns input for table: telephony.blocked_domain_user */
export type TelephonyTelephonyBlockedDomainUserPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "telephony.blocked_domain_user" */
export type TelephonyTelephonyBlockedDomainUserSelectColumn =
  /** column name */
  | 'blockedByDomainUserId'
  /** column name */
  | 'blockedDomainUserId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "telephony.blocked_domain_user" */
export type TelephonyTelephonyBlockedDomainUserSetInput = {
  blockedByDomainUserId?: InputMaybe<Scalars['uuid']['input']>;
  blockedDomainUserId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** Streaming cursor of the table "telephony_blocked_domain_user" */
export type TelephonyTelephonyBlockedDomainUserStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TelephonyTelephonyBlockedDomainUserStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TelephonyCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TelephonyTelephonyBlockedDomainUserStreamCursorValueInput = {
  blockedByDomainUserId?: InputMaybe<Scalars['uuid']['input']>;
  blockedDomainUserId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** update columns of table "telephony.blocked_domain_user" */
export type TelephonyTelephonyBlockedDomainUserUpdateColumn =
  /** column name */
  | 'blockedByDomainUserId'
  /** column name */
  | 'blockedDomainUserId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type TelephonyTelephonyBlockedDomainUserUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TelephonyTelephonyBlockedDomainUserSetInput>;
  /** filter the rows which have to be updated */
  where: TelephonyTelephonyBlockedDomainUserBoolExp;
};

/** columns and relationships of "telephony.cisco_subscriber_product" */
export type TelephonyTelephonyCiscoSubscriberProduct = {
  __typename?: 'TelephonyTelephonyCiscoSubscriberProduct';
  createdAt: Scalars['Telephonytimestamptz']['output'];
  id: Scalars['uuid']['output'];
  phoneNumber: Scalars['String']['output'];
  product: TelephonyProviderTypeEnum;
  updatedAt: Scalars['Telephonytimestamptz']['output'];
};

/** aggregated selection of "telephony.cisco_subscriber_product" */
export type TelephonyTelephonyCiscoSubscriberProductAggregate = {
  __typename?: 'TelephonyTelephonyCiscoSubscriberProductAggregate';
  aggregate?: Maybe<TelephonyTelephonyCiscoSubscriberProductAggregateFields>;
  nodes: Array<TelephonyTelephonyCiscoSubscriberProduct>;
};

/** aggregate fields of "telephony.cisco_subscriber_product" */
export type TelephonyTelephonyCiscoSubscriberProductAggregateFields = {
  __typename?: 'TelephonyTelephonyCiscoSubscriberProductAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TelephonyTelephonyCiscoSubscriberProductMaxFields>;
  min?: Maybe<TelephonyTelephonyCiscoSubscriberProductMinFields>;
};


/** aggregate fields of "telephony.cisco_subscriber_product" */
export type TelephonyTelephonyCiscoSubscriberProductAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TelephonyTelephonyCiscoSubscriberProductSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "telephony.cisco_subscriber_product". All fields are combined with a logical 'AND'. */
export type TelephonyTelephonyCiscoSubscriberProductBoolExp = {
  _and?: InputMaybe<Array<TelephonyTelephonyCiscoSubscriberProductBoolExp>>;
  _not?: InputMaybe<TelephonyTelephonyCiscoSubscriberProductBoolExp>;
  _or?: InputMaybe<Array<TelephonyTelephonyCiscoSubscriberProductBoolExp>>;
  createdAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  phoneNumber?: InputMaybe<TaskStringComparisonExp>;
  product?: InputMaybe<TelephonyProviderTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "telephony.cisco_subscriber_product" */
export type TelephonyTelephonyCiscoSubscriberProductConstraint =
  /** unique or primary key constraint on columns "product", "phoneNumber" */
  | 'cisco_subscriber_product_phoneNumber_product_key'
  /** unique or primary key constraint on columns "id" */
  | 'cisco_subscriber_product_pkey'
  | '%future added value';

/** input type for inserting data into table "telephony.cisco_subscriber_product" */
export type TelephonyTelephonyCiscoSubscriberProductInsertInput = {
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<TelephonyProviderTypeEnum>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** aggregate max on columns */
export type TelephonyTelephonyCiscoSubscriberProductMaxFields = {
  __typename?: 'TelephonyTelephonyCiscoSubscriberProductMaxFields';
  createdAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
};

/** aggregate min on columns */
export type TelephonyTelephonyCiscoSubscriberProductMinFields = {
  __typename?: 'TelephonyTelephonyCiscoSubscriberProductMinFields';
  createdAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
};

/** response of any mutation on the table "telephony.cisco_subscriber_product" */
export type TelephonyTelephonyCiscoSubscriberProductMutationResponse = {
  __typename?: 'TelephonyTelephonyCiscoSubscriberProductMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TelephonyTelephonyCiscoSubscriberProduct>;
};

/** on_conflict condition type for table "telephony.cisco_subscriber_product" */
export type TelephonyTelephonyCiscoSubscriberProductOnConflict = {
  constraint: TelephonyTelephonyCiscoSubscriberProductConstraint;
  updateColumns?: Array<TelephonyTelephonyCiscoSubscriberProductUpdateColumn>;
  where?: InputMaybe<TelephonyTelephonyCiscoSubscriberProductBoolExp>;
};

/** Ordering options when selecting data from "telephony.cisco_subscriber_product". */
export type TelephonyTelephonyCiscoSubscriberProductOrderBy = {
  createdAt?: InputMaybe<TelephonyOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  phoneNumber?: InputMaybe<TelephonyOrderBy>;
  product?: InputMaybe<TelephonyOrderBy>;
  updatedAt?: InputMaybe<TelephonyOrderBy>;
};

/** primary key columns input for table: telephony.cisco_subscriber_product */
export type TelephonyTelephonyCiscoSubscriberProductPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "telephony.cisco_subscriber_product" */
export type TelephonyTelephonyCiscoSubscriberProductSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'phoneNumber'
  /** column name */
  | 'product'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "telephony.cisco_subscriber_product" */
export type TelephonyTelephonyCiscoSubscriberProductSetInput = {
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<TelephonyProviderTypeEnum>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** Streaming cursor of the table "telephony_cisco_subscriber_product" */
export type TelephonyTelephonyCiscoSubscriberProductStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TelephonyTelephonyCiscoSubscriberProductStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TelephonyCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TelephonyTelephonyCiscoSubscriberProductStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<TelephonyProviderTypeEnum>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** update columns of table "telephony.cisco_subscriber_product" */
export type TelephonyTelephonyCiscoSubscriberProductUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'phoneNumber'
  /** column name */
  | 'product'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type TelephonyTelephonyCiscoSubscriberProductUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TelephonyTelephonyCiscoSubscriberProductSetInput>;
  /** filter the rows which have to be updated */
  where: TelephonyTelephonyCiscoSubscriberProductBoolExp;
};

/** columns and relationships of "telephony.events" */
export type TelephonyTelephonyEvents = {
  __typename?: 'TelephonyTelephonyEvents';
  /** An object relationship */
  activity: Telephonyactivity;
  activityId: Scalars['uuid']['output'];
  callingNumber: Scalars['String']['output'];
  createdAt: Scalars['Telephonytimestamptz']['output'];
  destinationNumber: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  personNumber?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  timestamp: Scalars['Telephonytimestamptz']['output'];
};

/** aggregated selection of "telephony.events" */
export type TelephonyTelephonyEventsAggregate = {
  __typename?: 'TelephonyTelephonyEventsAggregate';
  aggregate?: Maybe<TelephonyTelephonyEventsAggregateFields>;
  nodes: Array<TelephonyTelephonyEvents>;
};

export type TelephonyTelephonyEventsAggregateBoolExp = {
  count?: InputMaybe<TelephonytelephonyEventsAggregateBoolExpCount>;
};

/** aggregate fields of "telephony.events" */
export type TelephonyTelephonyEventsAggregateFields = {
  __typename?: 'TelephonyTelephonyEventsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TelephonyTelephonyEventsMaxFields>;
  min?: Maybe<TelephonyTelephonyEventsMinFields>;
};


/** aggregate fields of "telephony.events" */
export type TelephonyTelephonyEventsAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TelephonyTelephonyEventsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "telephony.events" */
export type TelephonyTelephonyEventsAggregateOrderBy = {
  count?: InputMaybe<TelephonyOrderBy>;
  max?: InputMaybe<TelephonyTelephonyEventsMaxOrderBy>;
  min?: InputMaybe<TelephonyTelephonyEventsMinOrderBy>;
};

/** input type for inserting array relation for remote table "telephony.events" */
export type TelephonyTelephonyEventsArrRelInsertInput = {
  data: Array<TelephonyTelephonyEventsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<TelephonyTelephonyEventsOnConflict>;
};

/** Boolean expression to filter rows from the table "telephony.events". All fields are combined with a logical 'AND'. */
export type TelephonyTelephonyEventsBoolExp = {
  _and?: InputMaybe<Array<TelephonyTelephonyEventsBoolExp>>;
  _not?: InputMaybe<TelephonyTelephonyEventsBoolExp>;
  _or?: InputMaybe<Array<TelephonyTelephonyEventsBoolExp>>;
  activity?: InputMaybe<TelephonyactivityBoolExp>;
  activityId?: InputMaybe<TaskUuidComparisonExp>;
  callingNumber?: InputMaybe<TaskStringComparisonExp>;
  createdAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  destinationNumber?: InputMaybe<TaskStringComparisonExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  personNumber?: InputMaybe<TaskStringComparisonExp>;
  state?: InputMaybe<TaskStringComparisonExp>;
  timestamp?: InputMaybe<TaskTimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "telephony.events" */
export type TelephonyTelephonyEventsConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'events_pkey1'
  | '%future added value';

/** input type for inserting data into table "telephony.events" */
export type TelephonyTelephonyEventsInsertInput = {
  activity?: InputMaybe<TelephonyactivityObjRelInsertInput>;
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  callingNumber?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  destinationNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  personNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** aggregate max on columns */
export type TelephonyTelephonyEventsMaxFields = {
  __typename?: 'TelephonyTelephonyEventsMaxFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  callingNumber?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  destinationNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  personNumber?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Telephonytimestamptz']['output']>;
};

/** order by max() on columns of table "telephony.events" */
export type TelephonyTelephonyEventsMaxOrderBy = {
  activityId?: InputMaybe<TelephonyOrderBy>;
  callingNumber?: InputMaybe<TelephonyOrderBy>;
  createdAt?: InputMaybe<TelephonyOrderBy>;
  destinationNumber?: InputMaybe<TelephonyOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  personNumber?: InputMaybe<TelephonyOrderBy>;
  state?: InputMaybe<TelephonyOrderBy>;
  timestamp?: InputMaybe<TelephonyOrderBy>;
};

/** aggregate min on columns */
export type TelephonyTelephonyEventsMinFields = {
  __typename?: 'TelephonyTelephonyEventsMinFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  callingNumber?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  destinationNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  personNumber?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Telephonytimestamptz']['output']>;
};

/** order by min() on columns of table "telephony.events" */
export type TelephonyTelephonyEventsMinOrderBy = {
  activityId?: InputMaybe<TelephonyOrderBy>;
  callingNumber?: InputMaybe<TelephonyOrderBy>;
  createdAt?: InputMaybe<TelephonyOrderBy>;
  destinationNumber?: InputMaybe<TelephonyOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  personNumber?: InputMaybe<TelephonyOrderBy>;
  state?: InputMaybe<TelephonyOrderBy>;
  timestamp?: InputMaybe<TelephonyOrderBy>;
};

/** response of any mutation on the table "telephony.events" */
export type TelephonyTelephonyEventsMutationResponse = {
  __typename?: 'TelephonyTelephonyEventsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TelephonyTelephonyEvents>;
};

/** input type for inserting object relation for remote table "telephony.events" */
export type TelephonyTelephonyEventsObjRelInsertInput = {
  data: TelephonyTelephonyEventsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TelephonyTelephonyEventsOnConflict>;
};

/** on_conflict condition type for table "telephony.events" */
export type TelephonyTelephonyEventsOnConflict = {
  constraint: TelephonyTelephonyEventsConstraint;
  updateColumns?: Array<TelephonyTelephonyEventsUpdateColumn>;
  where?: InputMaybe<TelephonyTelephonyEventsBoolExp>;
};

/** Ordering options when selecting data from "telephony.events". */
export type TelephonyTelephonyEventsOrderBy = {
  activity?: InputMaybe<TelephonyactivityOrderBy>;
  activityId?: InputMaybe<TelephonyOrderBy>;
  callingNumber?: InputMaybe<TelephonyOrderBy>;
  createdAt?: InputMaybe<TelephonyOrderBy>;
  destinationNumber?: InputMaybe<TelephonyOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  personNumber?: InputMaybe<TelephonyOrderBy>;
  state?: InputMaybe<TelephonyOrderBy>;
  timestamp?: InputMaybe<TelephonyOrderBy>;
};

/** primary key columns input for table: telephony.events */
export type TelephonyTelephonyEventsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "telephony.events" */
export type TelephonyTelephonyEventsSelectColumn =
  /** column name */
  | 'activityId'
  /** column name */
  | 'callingNumber'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'destinationNumber'
  /** column name */
  | 'id'
  /** column name */
  | 'personNumber'
  /** column name */
  | 'state'
  /** column name */
  | 'timestamp'
  | '%future added value';

/** input type for updating data in table "telephony.events" */
export type TelephonyTelephonyEventsSetInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  callingNumber?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  destinationNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  personNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** Streaming cursor of the table "telephony_events" */
export type TelephonyTelephonyEventsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TelephonyTelephonyEventsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TelephonyCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TelephonyTelephonyEventsStreamCursorValueInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  callingNumber?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  destinationNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  personNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** update columns of table "telephony.events" */
export type TelephonyTelephonyEventsUpdateColumn =
  /** column name */
  | 'activityId'
  /** column name */
  | 'callingNumber'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'destinationNumber'
  /** column name */
  | 'id'
  /** column name */
  | 'personNumber'
  /** column name */
  | 'state'
  /** column name */
  | 'timestamp'
  | '%future added value';

export type TelephonyTelephonyEventsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TelephonyTelephonyEventsSetInput>;
  /** filter the rows which have to be updated */
  where: TelephonyTelephonyEventsBoolExp;
};

/** columns and relationships of "telephony.lookup_caller_api" */
export type TelephonyTelephonyLookupCallerApi = {
  __typename?: 'TelephonyTelephonyLookupCallerApi';
  createdAt: Scalars['Telephonytimestamptz']['output'];
  data: Scalars['Telephonyjsonb']['output'];
  id: Scalars['uuid']['output'];
  phoneNumber: Scalars['String']['output'];
  updatedAt: Scalars['Telephonytimestamptz']['output'];
};


/** columns and relationships of "telephony.lookup_caller_api" */
export type TelephonyTelephonyLookupCallerApidataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "telephony.lookup_caller_api" */
export type TelephonyTelephonyLookupCallerApiAggregate = {
  __typename?: 'TelephonyTelephonyLookupCallerApiAggregate';
  aggregate?: Maybe<TelephonyTelephonyLookupCallerApiAggregateFields>;
  nodes: Array<TelephonyTelephonyLookupCallerApi>;
};

/** aggregate fields of "telephony.lookup_caller_api" */
export type TelephonyTelephonyLookupCallerApiAggregateFields = {
  __typename?: 'TelephonyTelephonyLookupCallerApiAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TelephonyTelephonyLookupCallerApiMaxFields>;
  min?: Maybe<TelephonyTelephonyLookupCallerApiMinFields>;
};


/** aggregate fields of "telephony.lookup_caller_api" */
export type TelephonyTelephonyLookupCallerApiAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TelephonyTelephonyLookupCallerApiSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type TelephonyTelephonyLookupCallerApiAppendInput = {
  data?: InputMaybe<Scalars['Telephonyjsonb']['input']>;
};

/** Boolean expression to filter rows from the table "telephony.lookup_caller_api". All fields are combined with a logical 'AND'. */
export type TelephonyTelephonyLookupCallerApiBoolExp = {
  _and?: InputMaybe<Array<TelephonyTelephonyLookupCallerApiBoolExp>>;
  _not?: InputMaybe<TelephonyTelephonyLookupCallerApiBoolExp>;
  _or?: InputMaybe<Array<TelephonyTelephonyLookupCallerApiBoolExp>>;
  createdAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  data?: InputMaybe<TaskJsonbComparisonExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  phoneNumber?: InputMaybe<TaskStringComparisonExp>;
  updatedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "telephony.lookup_caller_api" */
export type TelephonyTelephonyLookupCallerApiConstraint =
  /** unique or primary key constraint on columns "phoneNumber" */
  | 'lookup_caller_api_phoneNumber_key'
  /** unique or primary key constraint on columns "id" */
  | 'lookup_caller_api_pkey'
  | '%future added value';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type TelephonyTelephonyLookupCallerApiDeleteAtPathInput = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type TelephonyTelephonyLookupCallerApiDeleteElemInput = {
  data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type TelephonyTelephonyLookupCallerApiDeleteKeyInput = {
  data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "telephony.lookup_caller_api" */
export type TelephonyTelephonyLookupCallerApiInsertInput = {
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  data?: InputMaybe<Scalars['Telephonyjsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** aggregate max on columns */
export type TelephonyTelephonyLookupCallerApiMaxFields = {
  __typename?: 'TelephonyTelephonyLookupCallerApiMaxFields';
  createdAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
};

/** aggregate min on columns */
export type TelephonyTelephonyLookupCallerApiMinFields = {
  __typename?: 'TelephonyTelephonyLookupCallerApiMinFields';
  createdAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
};

/** response of any mutation on the table "telephony.lookup_caller_api" */
export type TelephonyTelephonyLookupCallerApiMutationResponse = {
  __typename?: 'TelephonyTelephonyLookupCallerApiMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TelephonyTelephonyLookupCallerApi>;
};

/** on_conflict condition type for table "telephony.lookup_caller_api" */
export type TelephonyTelephonyLookupCallerApiOnConflict = {
  constraint: TelephonyTelephonyLookupCallerApiConstraint;
  updateColumns?: Array<TelephonyTelephonyLookupCallerApiUpdateColumn>;
  where?: InputMaybe<TelephonyTelephonyLookupCallerApiBoolExp>;
};

/** Ordering options when selecting data from "telephony.lookup_caller_api". */
export type TelephonyTelephonyLookupCallerApiOrderBy = {
  createdAt?: InputMaybe<TelephonyOrderBy>;
  data?: InputMaybe<TelephonyOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  phoneNumber?: InputMaybe<TelephonyOrderBy>;
  updatedAt?: InputMaybe<TelephonyOrderBy>;
};

/** primary key columns input for table: telephony.lookup_caller_api */
export type TelephonyTelephonyLookupCallerApiPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type TelephonyTelephonyLookupCallerApiPrependInput = {
  data?: InputMaybe<Scalars['Telephonyjsonb']['input']>;
};

/** select columns of table "telephony.lookup_caller_api" */
export type TelephonyTelephonyLookupCallerApiSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'data'
  /** column name */
  | 'id'
  /** column name */
  | 'phoneNumber'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "telephony.lookup_caller_api" */
export type TelephonyTelephonyLookupCallerApiSetInput = {
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  data?: InputMaybe<Scalars['Telephonyjsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** Streaming cursor of the table "telephony_lookup_caller_api" */
export type TelephonyTelephonyLookupCallerApiStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TelephonyTelephonyLookupCallerApiStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TelephonyCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TelephonyTelephonyLookupCallerApiStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  data?: InputMaybe<Scalars['Telephonyjsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** update columns of table "telephony.lookup_caller_api" */
export type TelephonyTelephonyLookupCallerApiUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'data'
  /** column name */
  | 'id'
  /** column name */
  | 'phoneNumber'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type TelephonyTelephonyLookupCallerApiUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<TelephonyTelephonyLookupCallerApiAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<TelephonyTelephonyLookupCallerApiDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<TelephonyTelephonyLookupCallerApiDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<TelephonyTelephonyLookupCallerApiDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<TelephonyTelephonyLookupCallerApiPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TelephonyTelephonyLookupCallerApiSetInput>;
  /** filter the rows which have to be updated */
  where: TelephonyTelephonyLookupCallerApiBoolExp;
};

/** columns and relationships of "telephony.lookup_refresh" */
export type TelephonyTelephonyLookupRefresh = {
  __typename?: 'TelephonyTelephonyLookupRefresh';
  refresh: Scalars['Int']['output'];
  type: TelephonyTelephonyLookupTypesEnum;
};

/** aggregated selection of "telephony.lookup_refresh" */
export type TelephonyTelephonyLookupRefreshAggregate = {
  __typename?: 'TelephonyTelephonyLookupRefreshAggregate';
  aggregate?: Maybe<TelephonyTelephonyLookupRefreshAggregateFields>;
  nodes: Array<TelephonyTelephonyLookupRefresh>;
};

/** aggregate fields of "telephony.lookup_refresh" */
export type TelephonyTelephonyLookupRefreshAggregateFields = {
  __typename?: 'TelephonyTelephonyLookupRefreshAggregateFields';
  avg?: Maybe<TelephonyTelephonyLookupRefreshAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<TelephonyTelephonyLookupRefreshMaxFields>;
  min?: Maybe<TelephonyTelephonyLookupRefreshMinFields>;
  stddev?: Maybe<TelephonyTelephonyLookupRefreshStddevFields>;
  stddevPop?: Maybe<TelephonyTelephonyLookupRefreshStddevPopFields>;
  stddevSamp?: Maybe<TelephonyTelephonyLookupRefreshStddevSampFields>;
  sum?: Maybe<TelephonyTelephonyLookupRefreshSumFields>;
  varPop?: Maybe<TelephonyTelephonyLookupRefreshVarPopFields>;
  varSamp?: Maybe<TelephonyTelephonyLookupRefreshVarSampFields>;
  variance?: Maybe<TelephonyTelephonyLookupRefreshVarianceFields>;
};


/** aggregate fields of "telephony.lookup_refresh" */
export type TelephonyTelephonyLookupRefreshAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TelephonyTelephonyLookupRefreshSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type TelephonyTelephonyLookupRefreshAvgFields = {
  __typename?: 'TelephonyTelephonyLookupRefreshAvgFields';
  refresh?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "telephony.lookup_refresh". All fields are combined with a logical 'AND'. */
export type TelephonyTelephonyLookupRefreshBoolExp = {
  _and?: InputMaybe<Array<TelephonyTelephonyLookupRefreshBoolExp>>;
  _not?: InputMaybe<TelephonyTelephonyLookupRefreshBoolExp>;
  _or?: InputMaybe<Array<TelephonyTelephonyLookupRefreshBoolExp>>;
  refresh?: InputMaybe<TaskIntComparisonExp>;
  type?: InputMaybe<TelephonyTelephonyLookupTypesEnumComparisonExp>;
};

/** unique or primary key constraints on table "telephony.lookup_refresh" */
export type TelephonyTelephonyLookupRefreshConstraint =
  /** unique or primary key constraint on columns "type" */
  | 'lookup_refresh_pkey'
  | '%future added value';

/** input type for incrementing numeric columns in table "telephony.lookup_refresh" */
export type TelephonyTelephonyLookupRefreshIncInput = {
  refresh?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "telephony.lookup_refresh" */
export type TelephonyTelephonyLookupRefreshInsertInput = {
  refresh?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<TelephonyTelephonyLookupTypesEnum>;
};

/** aggregate max on columns */
export type TelephonyTelephonyLookupRefreshMaxFields = {
  __typename?: 'TelephonyTelephonyLookupRefreshMaxFields';
  refresh?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type TelephonyTelephonyLookupRefreshMinFields = {
  __typename?: 'TelephonyTelephonyLookupRefreshMinFields';
  refresh?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "telephony.lookup_refresh" */
export type TelephonyTelephonyLookupRefreshMutationResponse = {
  __typename?: 'TelephonyTelephonyLookupRefreshMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TelephonyTelephonyLookupRefresh>;
};

/** on_conflict condition type for table "telephony.lookup_refresh" */
export type TelephonyTelephonyLookupRefreshOnConflict = {
  constraint: TelephonyTelephonyLookupRefreshConstraint;
  updateColumns?: Array<TelephonyTelephonyLookupRefreshUpdateColumn>;
  where?: InputMaybe<TelephonyTelephonyLookupRefreshBoolExp>;
};

/** Ordering options when selecting data from "telephony.lookup_refresh". */
export type TelephonyTelephonyLookupRefreshOrderBy = {
  refresh?: InputMaybe<TelephonyOrderBy>;
  type?: InputMaybe<TelephonyOrderBy>;
};

/** primary key columns input for table: telephony.lookup_refresh */
export type TelephonyTelephonyLookupRefreshPkColumnsInput = {
  type: TelephonyTelephonyLookupTypesEnum;
};

/** select columns of table "telephony.lookup_refresh" */
export type TelephonyTelephonyLookupRefreshSelectColumn =
  /** column name */
  | 'refresh'
  /** column name */
  | 'type'
  | '%future added value';

/** input type for updating data in table "telephony.lookup_refresh" */
export type TelephonyTelephonyLookupRefreshSetInput = {
  refresh?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<TelephonyTelephonyLookupTypesEnum>;
};

/** aggregate stddev on columns */
export type TelephonyTelephonyLookupRefreshStddevFields = {
  __typename?: 'TelephonyTelephonyLookupRefreshStddevFields';
  refresh?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type TelephonyTelephonyLookupRefreshStddevPopFields = {
  __typename?: 'TelephonyTelephonyLookupRefreshStddevPopFields';
  refresh?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type TelephonyTelephonyLookupRefreshStddevSampFields = {
  __typename?: 'TelephonyTelephonyLookupRefreshStddevSampFields';
  refresh?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "telephony_lookup_refresh" */
export type TelephonyTelephonyLookupRefreshStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TelephonyTelephonyLookupRefreshStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TelephonyCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TelephonyTelephonyLookupRefreshStreamCursorValueInput = {
  refresh?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<TelephonyTelephonyLookupTypesEnum>;
};

/** aggregate sum on columns */
export type TelephonyTelephonyLookupRefreshSumFields = {
  __typename?: 'TelephonyTelephonyLookupRefreshSumFields';
  refresh?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "telephony.lookup_refresh" */
export type TelephonyTelephonyLookupRefreshUpdateColumn =
  /** column name */
  | 'refresh'
  /** column name */
  | 'type'
  | '%future added value';

export type TelephonyTelephonyLookupRefreshUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TelephonyTelephonyLookupRefreshIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TelephonyTelephonyLookupRefreshSetInput>;
  /** filter the rows which have to be updated */
  where: TelephonyTelephonyLookupRefreshBoolExp;
};

/** aggregate varPop on columns */
export type TelephonyTelephonyLookupRefreshVarPopFields = {
  __typename?: 'TelephonyTelephonyLookupRefreshVarPopFields';
  refresh?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type TelephonyTelephonyLookupRefreshVarSampFields = {
  __typename?: 'TelephonyTelephonyLookupRefreshVarSampFields';
  refresh?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type TelephonyTelephonyLookupRefreshVarianceFields = {
  __typename?: 'TelephonyTelephonyLookupRefreshVarianceFields';
  refresh?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "telephony.lookup_types" */
export type TelephonyTelephonyLookupTypes = {
  __typename?: 'TelephonyTelephonyLookupTypes';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "telephony.lookup_types" */
export type TelephonyTelephonyLookupTypesAggregate = {
  __typename?: 'TelephonyTelephonyLookupTypesAggregate';
  aggregate?: Maybe<TelephonyTelephonyLookupTypesAggregateFields>;
  nodes: Array<TelephonyTelephonyLookupTypes>;
};

/** aggregate fields of "telephony.lookup_types" */
export type TelephonyTelephonyLookupTypesAggregateFields = {
  __typename?: 'TelephonyTelephonyLookupTypesAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TelephonyTelephonyLookupTypesMaxFields>;
  min?: Maybe<TelephonyTelephonyLookupTypesMinFields>;
};


/** aggregate fields of "telephony.lookup_types" */
export type TelephonyTelephonyLookupTypesAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TelephonyTelephonyLookupTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "telephony.lookup_types". All fields are combined with a logical 'AND'. */
export type TelephonyTelephonyLookupTypesBoolExp = {
  _and?: InputMaybe<Array<TelephonyTelephonyLookupTypesBoolExp>>;
  _not?: InputMaybe<TelephonyTelephonyLookupTypesBoolExp>;
  _or?: InputMaybe<Array<TelephonyTelephonyLookupTypesBoolExp>>;
  description?: InputMaybe<TaskStringComparisonExp>;
  value?: InputMaybe<TaskStringComparisonExp>;
};

/** unique or primary key constraints on table "telephony.lookup_types" */
export type TelephonyTelephonyLookupTypesConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'lookup_types_pkey'
  | '%future added value';

export type TelephonyTelephonyLookupTypesEnum =
  /** callerapi */
  | 'CALLERAPI'
  | '%future added value';

/** Boolean expression to compare columns of type "TelephonyLookupTypesEnum". All fields are combined with logical 'AND'. */
export type TelephonyTelephonyLookupTypesEnumComparisonExp = {
  _eq?: InputMaybe<TelephonyTelephonyLookupTypesEnum>;
  _in?: InputMaybe<Array<TelephonyTelephonyLookupTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<TelephonyTelephonyLookupTypesEnum>;
  _nin?: InputMaybe<Array<TelephonyTelephonyLookupTypesEnum>>;
};

/** input type for inserting data into table "telephony.lookup_types" */
export type TelephonyTelephonyLookupTypesInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type TelephonyTelephonyLookupTypesMaxFields = {
  __typename?: 'TelephonyTelephonyLookupTypesMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type TelephonyTelephonyLookupTypesMinFields = {
  __typename?: 'TelephonyTelephonyLookupTypesMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "telephony.lookup_types" */
export type TelephonyTelephonyLookupTypesMutationResponse = {
  __typename?: 'TelephonyTelephonyLookupTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TelephonyTelephonyLookupTypes>;
};

/** on_conflict condition type for table "telephony.lookup_types" */
export type TelephonyTelephonyLookupTypesOnConflict = {
  constraint: TelephonyTelephonyLookupTypesConstraint;
  updateColumns?: Array<TelephonyTelephonyLookupTypesUpdateColumn>;
  where?: InputMaybe<TelephonyTelephonyLookupTypesBoolExp>;
};

/** Ordering options when selecting data from "telephony.lookup_types". */
export type TelephonyTelephonyLookupTypesOrderBy = {
  description?: InputMaybe<TelephonyOrderBy>;
  value?: InputMaybe<TelephonyOrderBy>;
};

/** primary key columns input for table: telephony.lookup_types */
export type TelephonyTelephonyLookupTypesPkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "telephony.lookup_types" */
export type TelephonyTelephonyLookupTypesSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "telephony.lookup_types" */
export type TelephonyTelephonyLookupTypesSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "telephony_lookup_types" */
export type TelephonyTelephonyLookupTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TelephonyTelephonyLookupTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TelephonyCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TelephonyTelephonyLookupTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "telephony.lookup_types" */
export type TelephonyTelephonyLookupTypesUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type TelephonyTelephonyLookupTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TelephonyTelephonyLookupTypesSetInput>;
  /** filter the rows which have to be updated */
  where: TelephonyTelephonyLookupTypesBoolExp;
};

/** columns and relationships of "telephony.pods" */
export type TelephonyTelephonyPods = {
  __typename?: 'TelephonyTelephonyPods';
  createdAt: Scalars['Telephonytimestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Telephonytimestamptz']['output'];
};

/** aggregated selection of "telephony.pods" */
export type TelephonyTelephonyPodsAggregate = {
  __typename?: 'TelephonyTelephonyPodsAggregate';
  aggregate?: Maybe<TelephonyTelephonyPodsAggregateFields>;
  nodes: Array<TelephonyTelephonyPods>;
};

/** aggregate fields of "telephony.pods" */
export type TelephonyTelephonyPodsAggregateFields = {
  __typename?: 'TelephonyTelephonyPodsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TelephonyTelephonyPodsMaxFields>;
  min?: Maybe<TelephonyTelephonyPodsMinFields>;
};


/** aggregate fields of "telephony.pods" */
export type TelephonyTelephonyPodsAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TelephonyTelephonyPodsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "telephony.pods". All fields are combined with a logical 'AND'. */
export type TelephonyTelephonyPodsBoolExp = {
  _and?: InputMaybe<Array<TelephonyTelephonyPodsBoolExp>>;
  _not?: InputMaybe<TelephonyTelephonyPodsBoolExp>;
  _or?: InputMaybe<Array<TelephonyTelephonyPodsBoolExp>>;
  createdAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  name?: InputMaybe<TaskStringComparisonExp>;
  updatedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "telephony.pods" */
export type TelephonyTelephonyPodsConstraint =
  /** unique or primary key constraint on columns "name" */
  | 'pods_name_key'
  /** unique or primary key constraint on columns "id" */
  | 'pods_pkey'
  | '%future added value';

/** input type for inserting data into table "telephony.pods" */
export type TelephonyTelephonyPodsInsertInput = {
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** aggregate max on columns */
export type TelephonyTelephonyPodsMaxFields = {
  __typename?: 'TelephonyTelephonyPodsMaxFields';
  createdAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
};

/** aggregate min on columns */
export type TelephonyTelephonyPodsMinFields = {
  __typename?: 'TelephonyTelephonyPodsMinFields';
  createdAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
};

/** response of any mutation on the table "telephony.pods" */
export type TelephonyTelephonyPodsMutationResponse = {
  __typename?: 'TelephonyTelephonyPodsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TelephonyTelephonyPods>;
};

/** input type for inserting object relation for remote table "telephony.pods" */
export type TelephonyTelephonyPodsObjRelInsertInput = {
  data: TelephonyTelephonyPodsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TelephonyTelephonyPodsOnConflict>;
};

/** on_conflict condition type for table "telephony.pods" */
export type TelephonyTelephonyPodsOnConflict = {
  constraint: TelephonyTelephonyPodsConstraint;
  updateColumns?: Array<TelephonyTelephonyPodsUpdateColumn>;
  where?: InputMaybe<TelephonyTelephonyPodsBoolExp>;
};

/** Ordering options when selecting data from "telephony.pods". */
export type TelephonyTelephonyPodsOrderBy = {
  createdAt?: InputMaybe<TelephonyOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  name?: InputMaybe<TelephonyOrderBy>;
  updatedAt?: InputMaybe<TelephonyOrderBy>;
};

/** primary key columns input for table: telephony.pods */
export type TelephonyTelephonyPodsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "telephony.pods" */
export type TelephonyTelephonyPodsSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "telephony.pods" */
export type TelephonyTelephonyPodsSetInput = {
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** Streaming cursor of the table "telephony_pods" */
export type TelephonyTelephonyPodsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TelephonyTelephonyPodsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TelephonyCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TelephonyTelephonyPodsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** update columns of table "telephony.pods" */
export type TelephonyTelephonyPodsUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type TelephonyTelephonyPodsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TelephonyTelephonyPodsSetInput>;
  /** filter the rows which have to be updated */
  where: TelephonyTelephonyPodsBoolExp;
};

/** Access right for partners to administrate accounts on behalf of customers. */
export type TelephonyTelephonyProviderAccess = {
  __typename?: 'TelephonyTelephonyProviderAccess';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "telephony.provider_access" */
export type TelephonyTelephonyProviderAccessAggregate = {
  __typename?: 'TelephonyTelephonyProviderAccessAggregate';
  aggregate?: Maybe<TelephonyTelephonyProviderAccessAggregateFields>;
  nodes: Array<TelephonyTelephonyProviderAccess>;
};

/** aggregate fields of "telephony.provider_access" */
export type TelephonyTelephonyProviderAccessAggregateFields = {
  __typename?: 'TelephonyTelephonyProviderAccessAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TelephonyTelephonyProviderAccessMaxFields>;
  min?: Maybe<TelephonyTelephonyProviderAccessMinFields>;
};


/** aggregate fields of "telephony.provider_access" */
export type TelephonyTelephonyProviderAccessAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TelephonyTelephonyProviderAccessSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "telephony.provider_access". All fields are combined with a logical 'AND'. */
export type TelephonyTelephonyProviderAccessBoolExp = {
  _and?: InputMaybe<Array<TelephonyTelephonyProviderAccessBoolExp>>;
  _not?: InputMaybe<TelephonyTelephonyProviderAccessBoolExp>;
  _or?: InputMaybe<Array<TelephonyTelephonyProviderAccessBoolExp>>;
  description?: InputMaybe<TaskStringComparisonExp>;
  value?: InputMaybe<TaskStringComparisonExp>;
};

/** unique or primary key constraints on table "telephony.provider_access" */
export type TelephonyTelephonyProviderAccessConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'provider_access_pkey'
  | '%future added value';

export type TelephonyTelephonyProviderAccessEnum =
  /** Phonero */
  | 'PHONERO'
  /** Telenor */
  | 'TELENOR'
  /** Telia */
  | 'TELIA'
  | '%future added value';

/** Boolean expression to compare columns of type "TelephonyProviderAccessEnum". All fields are combined with logical 'AND'. */
export type TelephonyTelephonyProviderAccessEnumComparisonExp = {
  _eq?: InputMaybe<TelephonyTelephonyProviderAccessEnum>;
  _in?: InputMaybe<Array<TelephonyTelephonyProviderAccessEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<TelephonyTelephonyProviderAccessEnum>;
  _nin?: InputMaybe<Array<TelephonyTelephonyProviderAccessEnum>>;
};

/** input type for inserting data into table "telephony.provider_access" */
export type TelephonyTelephonyProviderAccessInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type TelephonyTelephonyProviderAccessMaxFields = {
  __typename?: 'TelephonyTelephonyProviderAccessMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type TelephonyTelephonyProviderAccessMinFields = {
  __typename?: 'TelephonyTelephonyProviderAccessMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "telephony.provider_access" */
export type TelephonyTelephonyProviderAccessMutationResponse = {
  __typename?: 'TelephonyTelephonyProviderAccessMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TelephonyTelephonyProviderAccess>;
};

/** on_conflict condition type for table "telephony.provider_access" */
export type TelephonyTelephonyProviderAccessOnConflict = {
  constraint: TelephonyTelephonyProviderAccessConstraint;
  updateColumns?: Array<TelephonyTelephonyProviderAccessUpdateColumn>;
  where?: InputMaybe<TelephonyTelephonyProviderAccessBoolExp>;
};

/** Ordering options when selecting data from "telephony.provider_access". */
export type TelephonyTelephonyProviderAccessOrderBy = {
  description?: InputMaybe<TelephonyOrderBy>;
  value?: InputMaybe<TelephonyOrderBy>;
};

/** primary key columns input for table: telephony.provider_access */
export type TelephonyTelephonyProviderAccessPkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "telephony.provider_access" */
export type TelephonyTelephonyProviderAccessSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "telephony.provider_access" */
export type TelephonyTelephonyProviderAccessSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "telephony_provider_access" */
export type TelephonyTelephonyProviderAccessStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TelephonyTelephonyProviderAccessStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TelephonyCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TelephonyTelephonyProviderAccessStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "telephony.provider_access" */
export type TelephonyTelephonyProviderAccessUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type TelephonyTelephonyProviderAccessUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TelephonyTelephonyProviderAccessSetInput>;
  /** filter the rows which have to be updated */
  where: TelephonyTelephonyProviderAccessBoolExp;
};

export type TelephonyTelephonyProviderType =
  | 'PHONERO'
  | 'TELENOR'
  | 'TELIA'
  | '%future added value';

/** columns and relationships of "telephony.active_numbers" */
export type TelephonyactiveNumbers = {
  __typename?: 'TelephonyactiveNumbers';
  phoneNumber: Scalars['String']['output'];
};

/** aggregated selection of "telephony.active_numbers" */
export type TelephonyactiveNumbersAggregate = {
  __typename?: 'TelephonyactiveNumbersAggregate';
  aggregate?: Maybe<TelephonyactiveNumbersAggregateFields>;
  nodes: Array<TelephonyactiveNumbers>;
};

/** aggregate fields of "telephony.active_numbers" */
export type TelephonyactiveNumbersAggregateFields = {
  __typename?: 'TelephonyactiveNumbersAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TelephonyactiveNumbersMaxFields>;
  min?: Maybe<TelephonyactiveNumbersMinFields>;
};


/** aggregate fields of "telephony.active_numbers" */
export type TelephonyactiveNumbersAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TelephonyactiveNumbersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "telephony.active_numbers". All fields are combined with a logical 'AND'. */
export type TelephonyactiveNumbersBoolExp = {
  _and?: InputMaybe<Array<TelephonyactiveNumbersBoolExp>>;
  _not?: InputMaybe<TelephonyactiveNumbersBoolExp>;
  _or?: InputMaybe<Array<TelephonyactiveNumbersBoolExp>>;
  phoneNumber?: InputMaybe<TaskStringComparisonExp>;
};

/** unique or primary key constraints on table "telephony.active_numbers" */
export type TelephonyactiveNumbersConstraint =
  /** unique or primary key constraint on columns "phone_number" */
  | 'active_numbers_pkey'
  | '%future added value';

/** input type for inserting data into table "telephony.active_numbers" */
export type TelephonyactiveNumbersInsertInput = {
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type TelephonyactiveNumbersMaxFields = {
  __typename?: 'TelephonyactiveNumbersMaxFields';
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type TelephonyactiveNumbersMinFields = {
  __typename?: 'TelephonyactiveNumbersMinFields';
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "telephony.active_numbers" */
export type TelephonyactiveNumbersMutationResponse = {
  __typename?: 'TelephonyactiveNumbersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TelephonyactiveNumbers>;
};

/** on_conflict condition type for table "telephony.active_numbers" */
export type TelephonyactiveNumbersOnConflict = {
  constraint: TelephonyactiveNumbersConstraint;
  updateColumns?: Array<TelephonyactiveNumbersUpdateColumn>;
  where?: InputMaybe<TelephonyactiveNumbersBoolExp>;
};

/** Ordering options when selecting data from "telephony.active_numbers". */
export type TelephonyactiveNumbersOrderBy = {
  phoneNumber?: InputMaybe<TelephonyOrderBy>;
};

/** primary key columns input for table: telephony.active_numbers */
export type TelephonyactiveNumbersPkColumnsInput = {
  phoneNumber: Scalars['String']['input'];
};

/** select columns of table "telephony.active_numbers" */
export type TelephonyactiveNumbersSelectColumn =
  /** column name */
  | 'phoneNumber'
  | '%future added value';

/** input type for updating data in table "telephony.active_numbers" */
export type TelephonyactiveNumbersSetInput = {
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "activeNumbers" */
export type TelephonyactiveNumbersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TelephonyactiveNumbersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TelephonyCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TelephonyactiveNumbersStreamCursorValueInput = {
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "telephony.active_numbers" */
export type TelephonyactiveNumbersUpdateColumn =
  /** column name */
  | 'phoneNumber'
  | '%future added value';

export type TelephonyactiveNumbersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TelephonyactiveNumbersSetInput>;
  /** filter the rows which have to be updated */
  where: TelephonyactiveNumbersBoolExp;
};

/** columns and relationships of "telephony.activity" */
export type Telephonyactivity = {
  __typename?: 'Telephonyactivity';
  actionEventType?: Maybe<TelephonyTelephonyActionEventTypeEnum>;
  /** An array relationship */
  activityParticipants: Array<TelephonyactivityParticipant>;
  /** An aggregate relationship */
  activityParticipantsAggregate: TelephonyactivityParticipantAggregate;
  /** An object relationship */
  activity_type?: Maybe<TelephonyActivityType>;
  callId?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  comments: Array<Telephonycomment>;
  /** An aggregate relationship */
  commentsAggregate: TelephonycommentAggregate;
  createdAt: Scalars['Telephonytimestamptz']['output'];
  destinationNumber?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  /** An array relationship */
  events: Array<TelephonyTelephonyEvents>;
  /** An aggregate relationship */
  eventsAggregate: TelephonyTelephonyEventsAggregate;
  id: Scalars['uuid']['output'];
  latestAlertReceivedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  latestBusyReceivedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  latestIdleReceivedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  mainNumberCallId?: Maybe<Scalars['String']['output']>;
  /** teknisk felt */
  number: Scalars['Int']['output'];
  originatingNumber?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  owner?: Maybe<TelephonydomainUser>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  provider?: Maybe<TelephonyProviderTypeEnum>;
  requestEndedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  requestStartedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  startedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  type?: Maybe<TelephonyActivityTypeEnum>;
  updatedAt: Scalars['Telephonytimestamptz']['output'];
};


/** columns and relationships of "telephony.activity" */
export type TelephonyactivityactivityParticipantsArgs = {
  distinctOn?: InputMaybe<Array<TelephonyactivityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyactivityParticipantOrderBy>>;
  where?: InputMaybe<TelephonyactivityParticipantBoolExp>;
};


/** columns and relationships of "telephony.activity" */
export type TelephonyactivityactivityParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyactivityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyactivityParticipantOrderBy>>;
  where?: InputMaybe<TelephonyactivityParticipantBoolExp>;
};


/** columns and relationships of "telephony.activity" */
export type TelephonyactivitycommentsArgs = {
  distinctOn?: InputMaybe<Array<TelephonycommentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonycommentOrderBy>>;
  where?: InputMaybe<TelephonycommentBoolExp>;
};


/** columns and relationships of "telephony.activity" */
export type TelephonyactivitycommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonycommentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonycommentOrderBy>>;
  where?: InputMaybe<TelephonycommentBoolExp>;
};


/** columns and relationships of "telephony.activity" */
export type TelephonyactivityeventsArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyEventsOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyEventsBoolExp>;
};


/** columns and relationships of "telephony.activity" */
export type TelephonyactivityeventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyEventsOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyEventsBoolExp>;
};

/** aggregated selection of "telephony.activity" */
export type TelephonyactivityAggregate = {
  __typename?: 'TelephonyactivityAggregate';
  aggregate?: Maybe<TelephonyactivityAggregateFields>;
  nodes: Array<Telephonyactivity>;
};

export type TelephonyactivityAggregateBoolExp = {
  count?: InputMaybe<TelephonyactivityAggregateBoolExpCount>;
};

export type TelephonyactivityAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TelephonyactivitySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TelephonyactivityBoolExp>;
  predicate: TaskIntComparisonExp;
};

/** aggregate fields of "telephony.activity" */
export type TelephonyactivityAggregateFields = {
  __typename?: 'TelephonyactivityAggregateFields';
  avg?: Maybe<TelephonyactivityAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<TelephonyactivityMaxFields>;
  min?: Maybe<TelephonyactivityMinFields>;
  stddev?: Maybe<TelephonyactivityStddevFields>;
  stddevPop?: Maybe<TelephonyactivityStddevPopFields>;
  stddevSamp?: Maybe<TelephonyactivityStddevSampFields>;
  sum?: Maybe<TelephonyactivitySumFields>;
  varPop?: Maybe<TelephonyactivityVarPopFields>;
  varSamp?: Maybe<TelephonyactivityVarSampFields>;
  variance?: Maybe<TelephonyactivityVarianceFields>;
};


/** aggregate fields of "telephony.activity" */
export type TelephonyactivityAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TelephonyactivitySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "telephony.activity" */
export type TelephonyactivityAggregateOrderBy = {
  avg?: InputMaybe<TelephonyactivityAvgOrderBy>;
  count?: InputMaybe<TelephonyOrderBy>;
  max?: InputMaybe<TelephonyactivityMaxOrderBy>;
  min?: InputMaybe<TelephonyactivityMinOrderBy>;
  stddev?: InputMaybe<TelephonyactivityStddevOrderBy>;
  stddevPop?: InputMaybe<TelephonyactivityStddevPopOrderBy>;
  stddevSamp?: InputMaybe<TelephonyactivityStddevSampOrderBy>;
  sum?: InputMaybe<TelephonyactivitySumOrderBy>;
  varPop?: InputMaybe<TelephonyactivityVarPopOrderBy>;
  varSamp?: InputMaybe<TelephonyactivityVarSampOrderBy>;
  variance?: InputMaybe<TelephonyactivityVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "telephony.activity" */
export type TelephonyactivityArrRelInsertInput = {
  data: Array<TelephonyactivityInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<TelephonyactivityOnConflict>;
};

/** aggregate avg on columns */
export type TelephonyactivityAvgFields = {
  __typename?: 'TelephonyactivityAvgFields';
  /** teknisk felt */
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "telephony.activity" */
export type TelephonyactivityAvgOrderBy = {
  /** teknisk felt */
  number?: InputMaybe<TelephonyOrderBy>;
};

/** Boolean expression to filter rows from the table "telephony.activity". All fields are combined with a logical 'AND'. */
export type TelephonyactivityBoolExp = {
  _and?: InputMaybe<Array<TelephonyactivityBoolExp>>;
  _not?: InputMaybe<TelephonyactivityBoolExp>;
  _or?: InputMaybe<Array<TelephonyactivityBoolExp>>;
  actionEventType?: InputMaybe<TelephonyTelephonyActionEventTypeEnumComparisonExp>;
  activityParticipants?: InputMaybe<TelephonyactivityParticipantBoolExp>;
  activityParticipantsAggregate?: InputMaybe<TelephonyactivityParticipantAggregateBoolExp>;
  activity_type?: InputMaybe<TelephonyActivityTypeBoolExp>;
  callId?: InputMaybe<TaskStringComparisonExp>;
  comments?: InputMaybe<TelephonycommentBoolExp>;
  commentsAggregate?: InputMaybe<TelephonycommentAggregateBoolExp>;
  createdAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  destinationNumber?: InputMaybe<TaskStringComparisonExp>;
  direction?: InputMaybe<TaskStringComparisonExp>;
  endedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  events?: InputMaybe<TelephonyTelephonyEventsBoolExp>;
  eventsAggregate?: InputMaybe<TelephonyTelephonyEventsAggregateBoolExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  latestAlertReceivedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  latestBusyReceivedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  latestIdleReceivedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  mainNumberCallId?: InputMaybe<TaskStringComparisonExp>;
  number?: InputMaybe<TaskIntComparisonExp>;
  originatingNumber?: InputMaybe<TaskStringComparisonExp>;
  owner?: InputMaybe<TelephonydomainUserBoolExp>;
  ownerId?: InputMaybe<TaskUuidComparisonExp>;
  provider?: InputMaybe<TelephonyProviderTypeEnumComparisonExp>;
  requestEndedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  requestStartedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  startedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  type?: InputMaybe<TaskActivityTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "telephony.activity" */
export type TelephonyactivityConstraint =
  /** unique or primary key constraint on columns "call_id" */
  | 'activity_call_id_key'
  /** unique or primary key constraint on columns "main_number_call_id" */
  | 'activity_main_number_call_id_key'
  /** unique or primary key constraint on columns "number" */
  | 'activity_number_key'
  /** unique or primary key constraint on columns "id" */
  | 'activity_pkey'
  | '%future added value';

/** input type for incrementing numeric columns in table "telephony.activity" */
export type TelephonyactivityIncInput = {
  /** teknisk felt */
  number?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "telephony.activity" */
export type TelephonyactivityInsertInput = {
  actionEventType?: InputMaybe<TelephonyTelephonyActionEventTypeEnum>;
  activityParticipants?: InputMaybe<TelephonyactivityParticipantArrRelInsertInput>;
  activity_type?: InputMaybe<TelephonyActivityTypeObjRelInsertInput>;
  callId?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<TelephonycommentArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  destinationNumber?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  events?: InputMaybe<TelephonyTelephonyEventsArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  latestAlertReceivedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  latestBusyReceivedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  latestIdleReceivedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  mainNumberCallId?: InputMaybe<Scalars['String']['input']>;
  /** teknisk felt */
  number?: InputMaybe<Scalars['Int']['input']>;
  originatingNumber?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<TelephonydomainUserObjRelInsertInput>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  provider?: InputMaybe<TelephonyProviderTypeEnum>;
  requestEndedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  requestStartedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  startedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  type?: InputMaybe<TelephonyActivityTypeEnum>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** aggregate max on columns */
export type TelephonyactivityMaxFields = {
  __typename?: 'TelephonyactivityMaxFields';
  callId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  destinationNumber?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  latestAlertReceivedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  latestBusyReceivedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  latestIdleReceivedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  mainNumberCallId?: Maybe<Scalars['String']['output']>;
  /** teknisk felt */
  number?: Maybe<Scalars['Int']['output']>;
  originatingNumber?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  requestEndedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  requestStartedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  startedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  updatedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
};

/** order by max() on columns of table "telephony.activity" */
export type TelephonyactivityMaxOrderBy = {
  callId?: InputMaybe<TelephonyOrderBy>;
  createdAt?: InputMaybe<TelephonyOrderBy>;
  destinationNumber?: InputMaybe<TelephonyOrderBy>;
  direction?: InputMaybe<TelephonyOrderBy>;
  endedAt?: InputMaybe<TelephonyOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  latestAlertReceivedAt?: InputMaybe<TelephonyOrderBy>;
  latestBusyReceivedAt?: InputMaybe<TelephonyOrderBy>;
  latestIdleReceivedAt?: InputMaybe<TelephonyOrderBy>;
  mainNumberCallId?: InputMaybe<TelephonyOrderBy>;
  /** teknisk felt */
  number?: InputMaybe<TelephonyOrderBy>;
  originatingNumber?: InputMaybe<TelephonyOrderBy>;
  ownerId?: InputMaybe<TelephonyOrderBy>;
  requestEndedAt?: InputMaybe<TelephonyOrderBy>;
  requestStartedAt?: InputMaybe<TelephonyOrderBy>;
  startedAt?: InputMaybe<TelephonyOrderBy>;
  updatedAt?: InputMaybe<TelephonyOrderBy>;
};

/** aggregate min on columns */
export type TelephonyactivityMinFields = {
  __typename?: 'TelephonyactivityMinFields';
  callId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  destinationNumber?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  latestAlertReceivedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  latestBusyReceivedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  latestIdleReceivedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  mainNumberCallId?: Maybe<Scalars['String']['output']>;
  /** teknisk felt */
  number?: Maybe<Scalars['Int']['output']>;
  originatingNumber?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  requestEndedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  requestStartedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  startedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  updatedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
};

/** order by min() on columns of table "telephony.activity" */
export type TelephonyactivityMinOrderBy = {
  callId?: InputMaybe<TelephonyOrderBy>;
  createdAt?: InputMaybe<TelephonyOrderBy>;
  destinationNumber?: InputMaybe<TelephonyOrderBy>;
  direction?: InputMaybe<TelephonyOrderBy>;
  endedAt?: InputMaybe<TelephonyOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  latestAlertReceivedAt?: InputMaybe<TelephonyOrderBy>;
  latestBusyReceivedAt?: InputMaybe<TelephonyOrderBy>;
  latestIdleReceivedAt?: InputMaybe<TelephonyOrderBy>;
  mainNumberCallId?: InputMaybe<TelephonyOrderBy>;
  /** teknisk felt */
  number?: InputMaybe<TelephonyOrderBy>;
  originatingNumber?: InputMaybe<TelephonyOrderBy>;
  ownerId?: InputMaybe<TelephonyOrderBy>;
  requestEndedAt?: InputMaybe<TelephonyOrderBy>;
  requestStartedAt?: InputMaybe<TelephonyOrderBy>;
  startedAt?: InputMaybe<TelephonyOrderBy>;
  updatedAt?: InputMaybe<TelephonyOrderBy>;
};

/** response of any mutation on the table "telephony.activity" */
export type TelephonyactivityMutationResponse = {
  __typename?: 'TelephonyactivityMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Telephonyactivity>;
};

/** input type for inserting object relation for remote table "telephony.activity" */
export type TelephonyactivityObjRelInsertInput = {
  data: TelephonyactivityInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TelephonyactivityOnConflict>;
};

/** on_conflict condition type for table "telephony.activity" */
export type TelephonyactivityOnConflict = {
  constraint: TelephonyactivityConstraint;
  updateColumns?: Array<TelephonyactivityUpdateColumn>;
  where?: InputMaybe<TelephonyactivityBoolExp>;
};

/** Ordering options when selecting data from "telephony.activity". */
export type TelephonyactivityOrderBy = {
  actionEventType?: InputMaybe<TelephonyOrderBy>;
  activityParticipantsAggregate?: InputMaybe<TelephonyactivityParticipantAggregateOrderBy>;
  activity_type?: InputMaybe<TelephonyActivityTypeOrderBy>;
  callId?: InputMaybe<TelephonyOrderBy>;
  commentsAggregate?: InputMaybe<TelephonycommentAggregateOrderBy>;
  createdAt?: InputMaybe<TelephonyOrderBy>;
  destinationNumber?: InputMaybe<TelephonyOrderBy>;
  direction?: InputMaybe<TelephonyOrderBy>;
  endedAt?: InputMaybe<TelephonyOrderBy>;
  eventsAggregate?: InputMaybe<TelephonyTelephonyEventsAggregateOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  latestAlertReceivedAt?: InputMaybe<TelephonyOrderBy>;
  latestBusyReceivedAt?: InputMaybe<TelephonyOrderBy>;
  latestIdleReceivedAt?: InputMaybe<TelephonyOrderBy>;
  mainNumberCallId?: InputMaybe<TelephonyOrderBy>;
  number?: InputMaybe<TelephonyOrderBy>;
  originatingNumber?: InputMaybe<TelephonyOrderBy>;
  owner?: InputMaybe<TelephonydomainUserOrderBy>;
  ownerId?: InputMaybe<TelephonyOrderBy>;
  provider?: InputMaybe<TelephonyOrderBy>;
  requestEndedAt?: InputMaybe<TelephonyOrderBy>;
  requestStartedAt?: InputMaybe<TelephonyOrderBy>;
  startedAt?: InputMaybe<TelephonyOrderBy>;
  type?: InputMaybe<TelephonyOrderBy>;
  updatedAt?: InputMaybe<TelephonyOrderBy>;
};

/** columns and relationships of "telephony.activity_participant" */
export type TelephonyactivityParticipant = {
  __typename?: 'TelephonyactivityParticipant';
  /** An object relationship */
  activity?: Maybe<Telephonyactivity>;
  activityId?: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['Telephonytimestamptz']['output'];
  /** An object relationship */
  domainUser?: Maybe<TelephonydomainUser>;
  domainUserId?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  role?: Maybe<TelephonyActivityParticipantRoleEnum>;
  updatedAt: Scalars['Telephonytimestamptz']['output'];
};

/** aggregated selection of "telephony.activity_participant" */
export type TelephonyactivityParticipantAggregate = {
  __typename?: 'TelephonyactivityParticipantAggregate';
  aggregate?: Maybe<TelephonyactivityParticipantAggregateFields>;
  nodes: Array<TelephonyactivityParticipant>;
};

export type TelephonyactivityParticipantAggregateBoolExp = {
  count?: InputMaybe<TelephonyactivityParticipantAggregateBoolExpCount>;
};

export type TelephonyactivityParticipantAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TelephonyactivityParticipantSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TelephonyactivityParticipantBoolExp>;
  predicate: TaskIntComparisonExp;
};

/** aggregate fields of "telephony.activity_participant" */
export type TelephonyactivityParticipantAggregateFields = {
  __typename?: 'TelephonyactivityParticipantAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TelephonyactivityParticipantMaxFields>;
  min?: Maybe<TelephonyactivityParticipantMinFields>;
};


/** aggregate fields of "telephony.activity_participant" */
export type TelephonyactivityParticipantAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TelephonyactivityParticipantSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "telephony.activity_participant" */
export type TelephonyactivityParticipantAggregateOrderBy = {
  count?: InputMaybe<TelephonyOrderBy>;
  max?: InputMaybe<TelephonyactivityParticipantMaxOrderBy>;
  min?: InputMaybe<TelephonyactivityParticipantMinOrderBy>;
};

/** input type for inserting array relation for remote table "telephony.activity_participant" */
export type TelephonyactivityParticipantArrRelInsertInput = {
  data: Array<TelephonyactivityParticipantInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<TelephonyactivityParticipantOnConflict>;
};

/** Boolean expression to filter rows from the table "telephony.activity_participant". All fields are combined with a logical 'AND'. */
export type TelephonyactivityParticipantBoolExp = {
  _and?: InputMaybe<Array<TelephonyactivityParticipantBoolExp>>;
  _not?: InputMaybe<TelephonyactivityParticipantBoolExp>;
  _or?: InputMaybe<Array<TelephonyactivityParticipantBoolExp>>;
  activity?: InputMaybe<TelephonyactivityBoolExp>;
  activityId?: InputMaybe<TaskUuidComparisonExp>;
  createdAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  domainUser?: InputMaybe<TelephonydomainUserBoolExp>;
  domainUserId?: InputMaybe<TaskUuidComparisonExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  role?: InputMaybe<TelephonyActivityParticipantRoleEnumComparisonExp>;
  updatedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "telephony.activity_participant" */
export type TelephonyactivityParticipantConstraint =
  /** unique or primary key constraint on columns "activity_id", "domain_user_id" */
  | 'activity_participant_activity_id_domain_user_id_key'
  /** unique or primary key constraint on columns "id" */
  | 'activity_participant_pkey'
  | '%future added value';

/** input type for inserting data into table "telephony.activity_participant" */
export type TelephonyactivityParticipantInsertInput = {
  activity?: InputMaybe<TelephonyactivityObjRelInsertInput>;
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  domainUser?: InputMaybe<TelephonydomainUserObjRelInsertInput>;
  domainUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<TelephonyActivityParticipantRoleEnum>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** aggregate max on columns */
export type TelephonyactivityParticipantMaxFields = {
  __typename?: 'TelephonyactivityParticipantMaxFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  domainUserId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
};

/** order by max() on columns of table "telephony.activity_participant" */
export type TelephonyactivityParticipantMaxOrderBy = {
  activityId?: InputMaybe<TelephonyOrderBy>;
  createdAt?: InputMaybe<TelephonyOrderBy>;
  domainUserId?: InputMaybe<TelephonyOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  updatedAt?: InputMaybe<TelephonyOrderBy>;
};

/** aggregate min on columns */
export type TelephonyactivityParticipantMinFields = {
  __typename?: 'TelephonyactivityParticipantMinFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  domainUserId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
};

/** order by min() on columns of table "telephony.activity_participant" */
export type TelephonyactivityParticipantMinOrderBy = {
  activityId?: InputMaybe<TelephonyOrderBy>;
  createdAt?: InputMaybe<TelephonyOrderBy>;
  domainUserId?: InputMaybe<TelephonyOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  updatedAt?: InputMaybe<TelephonyOrderBy>;
};

/** response of any mutation on the table "telephony.activity_participant" */
export type TelephonyactivityParticipantMutationResponse = {
  __typename?: 'TelephonyactivityParticipantMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TelephonyactivityParticipant>;
};

/** on_conflict condition type for table "telephony.activity_participant" */
export type TelephonyactivityParticipantOnConflict = {
  constraint: TelephonyactivityParticipantConstraint;
  updateColumns?: Array<TelephonyactivityParticipantUpdateColumn>;
  where?: InputMaybe<TelephonyactivityParticipantBoolExp>;
};

/** Ordering options when selecting data from "telephony.activity_participant". */
export type TelephonyactivityParticipantOrderBy = {
  activity?: InputMaybe<TelephonyactivityOrderBy>;
  activityId?: InputMaybe<TelephonyOrderBy>;
  createdAt?: InputMaybe<TelephonyOrderBy>;
  domainUser?: InputMaybe<TelephonydomainUserOrderBy>;
  domainUserId?: InputMaybe<TelephonyOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  role?: InputMaybe<TelephonyOrderBy>;
  updatedAt?: InputMaybe<TelephonyOrderBy>;
};

/** primary key columns input for table: telephony.activity_participant */
export type TelephonyactivityParticipantPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "telephony.activity_participant" */
export type TelephonyactivityParticipantSelectColumn =
  /** column name */
  | 'activityId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'domainUserId'
  /** column name */
  | 'id'
  /** column name */
  | 'role'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "telephony.activity_participant" */
export type TelephonyactivityParticipantSetInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  domainUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<TelephonyActivityParticipantRoleEnum>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** Streaming cursor of the table "activityParticipant" */
export type TelephonyactivityParticipantStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TelephonyactivityParticipantStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TelephonyCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TelephonyactivityParticipantStreamCursorValueInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  domainUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<TelephonyActivityParticipantRoleEnum>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** update columns of table "telephony.activity_participant" */
export type TelephonyactivityParticipantUpdateColumn =
  /** column name */
  | 'activityId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'domainUserId'
  /** column name */
  | 'id'
  /** column name */
  | 'role'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type TelephonyactivityParticipantUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TelephonyactivityParticipantSetInput>;
  /** filter the rows which have to be updated */
  where: TelephonyactivityParticipantBoolExp;
};

/** primary key columns input for table: telephony.activity */
export type TelephonyactivityPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "telephony.activity" */
export type TelephonyactivitySelectColumn =
  /** column name */
  | 'actionEventType'
  /** column name */
  | 'callId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'destinationNumber'
  /** column name */
  | 'direction'
  /** column name */
  | 'endedAt'
  /** column name */
  | 'id'
  /** column name */
  | 'latestAlertReceivedAt'
  /** column name */
  | 'latestBusyReceivedAt'
  /** column name */
  | 'latestIdleReceivedAt'
  /** column name */
  | 'mainNumberCallId'
  /** column name */
  | 'number'
  /** column name */
  | 'originatingNumber'
  /** column name */
  | 'ownerId'
  /** column name */
  | 'provider'
  /** column name */
  | 'requestEndedAt'
  /** column name */
  | 'requestStartedAt'
  /** column name */
  | 'startedAt'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "telephony.activity" */
export type TelephonyactivitySetInput = {
  actionEventType?: InputMaybe<TelephonyTelephonyActionEventTypeEnum>;
  callId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  destinationNumber?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  latestAlertReceivedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  latestBusyReceivedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  latestIdleReceivedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  mainNumberCallId?: InputMaybe<Scalars['String']['input']>;
  /** teknisk felt */
  number?: InputMaybe<Scalars['Int']['input']>;
  originatingNumber?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  provider?: InputMaybe<TelephonyProviderTypeEnum>;
  requestEndedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  requestStartedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  startedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  type?: InputMaybe<TelephonyActivityTypeEnum>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** aggregate stddev on columns */
export type TelephonyactivityStddevFields = {
  __typename?: 'TelephonyactivityStddevFields';
  /** teknisk felt */
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "telephony.activity" */
export type TelephonyactivityStddevOrderBy = {
  /** teknisk felt */
  number?: InputMaybe<TelephonyOrderBy>;
};

/** aggregate stddevPop on columns */
export type TelephonyactivityStddevPopFields = {
  __typename?: 'TelephonyactivityStddevPopFields';
  /** teknisk felt */
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "telephony.activity" */
export type TelephonyactivityStddevPopOrderBy = {
  /** teknisk felt */
  number?: InputMaybe<TelephonyOrderBy>;
};

/** aggregate stddevSamp on columns */
export type TelephonyactivityStddevSampFields = {
  __typename?: 'TelephonyactivityStddevSampFields';
  /** teknisk felt */
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "telephony.activity" */
export type TelephonyactivityStddevSampOrderBy = {
  /** teknisk felt */
  number?: InputMaybe<TelephonyOrderBy>;
};

/** Streaming cursor of the table "activity" */
export type TelephonyactivityStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TelephonyactivityStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TelephonyCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TelephonyactivityStreamCursorValueInput = {
  actionEventType?: InputMaybe<TelephonyTelephonyActionEventTypeEnum>;
  callId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  destinationNumber?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  latestAlertReceivedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  latestBusyReceivedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  latestIdleReceivedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  mainNumberCallId?: InputMaybe<Scalars['String']['input']>;
  /** teknisk felt */
  number?: InputMaybe<Scalars['Int']['input']>;
  originatingNumber?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  provider?: InputMaybe<TelephonyProviderTypeEnum>;
  requestEndedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  requestStartedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  startedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  type?: InputMaybe<TelephonyActivityTypeEnum>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** aggregate sum on columns */
export type TelephonyactivitySumFields = {
  __typename?: 'TelephonyactivitySumFields';
  /** teknisk felt */
  number?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "telephony.activity" */
export type TelephonyactivitySumOrderBy = {
  /** teknisk felt */
  number?: InputMaybe<TelephonyOrderBy>;
};

/** update columns of table "telephony.activity" */
export type TelephonyactivityUpdateColumn =
  /** column name */
  | 'actionEventType'
  /** column name */
  | 'callId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'destinationNumber'
  /** column name */
  | 'direction'
  /** column name */
  | 'endedAt'
  /** column name */
  | 'id'
  /** column name */
  | 'latestAlertReceivedAt'
  /** column name */
  | 'latestBusyReceivedAt'
  /** column name */
  | 'latestIdleReceivedAt'
  /** column name */
  | 'mainNumberCallId'
  /** column name */
  | 'number'
  /** column name */
  | 'originatingNumber'
  /** column name */
  | 'ownerId'
  /** column name */
  | 'provider'
  /** column name */
  | 'requestEndedAt'
  /** column name */
  | 'requestStartedAt'
  /** column name */
  | 'startedAt'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type TelephonyactivityUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TelephonyactivityIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TelephonyactivitySetInput>;
  /** filter the rows which have to be updated */
  where: TelephonyactivityBoolExp;
};

/** aggregate varPop on columns */
export type TelephonyactivityVarPopFields = {
  __typename?: 'TelephonyactivityVarPopFields';
  /** teknisk felt */
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "telephony.activity" */
export type TelephonyactivityVarPopOrderBy = {
  /** teknisk felt */
  number?: InputMaybe<TelephonyOrderBy>;
};

/** aggregate varSamp on columns */
export type TelephonyactivityVarSampFields = {
  __typename?: 'TelephonyactivityVarSampFields';
  /** teknisk felt */
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "telephony.activity" */
export type TelephonyactivityVarSampOrderBy = {
  /** teknisk felt */
  number?: InputMaybe<TelephonyOrderBy>;
};

/** aggregate variance on columns */
export type TelephonyactivityVarianceFields = {
  __typename?: 'TelephonyactivityVarianceFields';
  /** teknisk felt */
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "telephony.activity" */
export type TelephonyactivityVarianceOrderBy = {
  /** teknisk felt */
  number?: InputMaybe<TelephonyOrderBy>;
};

/** columns and relationships of "telephony.comment" */
export type Telephonycomment = {
  __typename?: 'Telephonycomment';
  /** An object relationship */
  activity?: Maybe<Telephonyactivity>;
  activityId?: Maybe<Scalars['uuid']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Telephonytimestamptz']['output'];
  id: Scalars['uuid']['output'];
  updatedAt: Scalars['Telephonytimestamptz']['output'];
};

/** aggregated selection of "telephony.comment" */
export type TelephonycommentAggregate = {
  __typename?: 'TelephonycommentAggregate';
  aggregate?: Maybe<TelephonycommentAggregateFields>;
  nodes: Array<Telephonycomment>;
};

export type TelephonycommentAggregateBoolExp = {
  count?: InputMaybe<TelephonycommentAggregateBoolExpCount>;
};

export type TelephonycommentAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TelephonycommentSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TelephonycommentBoolExp>;
  predicate: TaskIntComparisonExp;
};

/** aggregate fields of "telephony.comment" */
export type TelephonycommentAggregateFields = {
  __typename?: 'TelephonycommentAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TelephonycommentMaxFields>;
  min?: Maybe<TelephonycommentMinFields>;
};


/** aggregate fields of "telephony.comment" */
export type TelephonycommentAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TelephonycommentSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "telephony.comment" */
export type TelephonycommentAggregateOrderBy = {
  count?: InputMaybe<TelephonyOrderBy>;
  max?: InputMaybe<TelephonycommentMaxOrderBy>;
  min?: InputMaybe<TelephonycommentMinOrderBy>;
};

/** input type for inserting array relation for remote table "telephony.comment" */
export type TelephonycommentArrRelInsertInput = {
  data: Array<TelephonycommentInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<TelephonycommentOnConflict>;
};

/** Boolean expression to filter rows from the table "telephony.comment". All fields are combined with a logical 'AND'. */
export type TelephonycommentBoolExp = {
  _and?: InputMaybe<Array<TelephonycommentBoolExp>>;
  _not?: InputMaybe<TelephonycommentBoolExp>;
  _or?: InputMaybe<Array<TelephonycommentBoolExp>>;
  activity?: InputMaybe<TelephonyactivityBoolExp>;
  activityId?: InputMaybe<TaskUuidComparisonExp>;
  content?: InputMaybe<TaskStringComparisonExp>;
  createdAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  updatedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "telephony.comment" */
export type TelephonycommentConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'comment_pkey'
  | '%future added value';

/** input type for inserting data into table "telephony.comment" */
export type TelephonycommentInsertInput = {
  activity?: InputMaybe<TelephonyactivityObjRelInsertInput>;
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** aggregate max on columns */
export type TelephonycommentMaxFields = {
  __typename?: 'TelephonycommentMaxFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
};

/** order by max() on columns of table "telephony.comment" */
export type TelephonycommentMaxOrderBy = {
  activityId?: InputMaybe<TelephonyOrderBy>;
  content?: InputMaybe<TelephonyOrderBy>;
  createdAt?: InputMaybe<TelephonyOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  updatedAt?: InputMaybe<TelephonyOrderBy>;
};

/** aggregate min on columns */
export type TelephonycommentMinFields = {
  __typename?: 'TelephonycommentMinFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
};

/** order by min() on columns of table "telephony.comment" */
export type TelephonycommentMinOrderBy = {
  activityId?: InputMaybe<TelephonyOrderBy>;
  content?: InputMaybe<TelephonyOrderBy>;
  createdAt?: InputMaybe<TelephonyOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  updatedAt?: InputMaybe<TelephonyOrderBy>;
};

/** response of any mutation on the table "telephony.comment" */
export type TelephonycommentMutationResponse = {
  __typename?: 'TelephonycommentMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Telephonycomment>;
};

/** on_conflict condition type for table "telephony.comment" */
export type TelephonycommentOnConflict = {
  constraint: TelephonycommentConstraint;
  updateColumns?: Array<TelephonycommentUpdateColumn>;
  where?: InputMaybe<TelephonycommentBoolExp>;
};

/** Ordering options when selecting data from "telephony.comment". */
export type TelephonycommentOrderBy = {
  activity?: InputMaybe<TelephonyactivityOrderBy>;
  activityId?: InputMaybe<TelephonyOrderBy>;
  content?: InputMaybe<TelephonyOrderBy>;
  createdAt?: InputMaybe<TelephonyOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  updatedAt?: InputMaybe<TelephonyOrderBy>;
};

/** primary key columns input for table: telephony.comment */
export type TelephonycommentPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "telephony.comment" */
export type TelephonycommentSelectColumn =
  /** column name */
  | 'activityId'
  /** column name */
  | 'content'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "telephony.comment" */
export type TelephonycommentSetInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** Streaming cursor of the table "comment" */
export type TelephonycommentStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TelephonycommentStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TelephonyCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TelephonycommentStreamCursorValueInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** update columns of table "telephony.comment" */
export type TelephonycommentUpdateColumn =
  /** column name */
  | 'activityId'
  /** column name */
  | 'content'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type TelephonycommentUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TelephonycommentSetInput>;
  /** filter the rows which have to be updated */
  where: TelephonycommentBoolExp;
};

/** Corresponds to customers in Phonero */
export type TelephonydomainOrganization = {
  __typename?: 'TelephonydomainOrganization';
  /** Administrator of domain-org (organization.organization_user.id). */
  adminId?: Maybe<Scalars['uuid']['output']>;
  autoGenerated?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Telephonytimestamptz']['output'];
  /** An array relationship */
  domainUsers: Array<TelephonydomainUser>;
  /** An aggregate relationship */
  domainUsersAggregate: TelephonydomainUserAggregate;
  id: Scalars['uuid']['output'];
  organizationId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  pod?: Maybe<TelephonyTelephonyPods>;
  podName?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  providerAccount?: Maybe<TelephonyproviderAccount>;
  providerAccountId?: Maybe<Scalars['uuid']['output']>;
  /** E.g. Phonero customer id */
  providerClientId?: Maybe<Scalars['String']['output']>;
  providerClientName?: Maybe<Scalars['String']['output']>;
  providerClientSubscribed?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['Telephonytimestamptz']['output'];
};


/** Corresponds to customers in Phonero */
export type TelephonydomainOrganizationdomainUsersArgs = {
  distinctOn?: InputMaybe<Array<TelephonydomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonydomainUserOrderBy>>;
  where?: InputMaybe<TelephonydomainUserBoolExp>;
};


/** Corresponds to customers in Phonero */
export type TelephonydomainOrganizationdomainUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonydomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonydomainUserOrderBy>>;
  where?: InputMaybe<TelephonydomainUserBoolExp>;
};

/** aggregated selection of "telephony.domain_organization" */
export type TelephonydomainOrganizationAggregate = {
  __typename?: 'TelephonydomainOrganizationAggregate';
  aggregate?: Maybe<TelephonydomainOrganizationAggregateFields>;
  nodes: Array<TelephonydomainOrganization>;
};

export type TelephonydomainOrganizationAggregateBoolExp = {
  bool_and?: InputMaybe<TelephonydomainOrganizationAggregateBoolExpBool_and>;
  bool_or?: InputMaybe<TelephonydomainOrganizationAggregateBoolExpBool_or>;
  count?: InputMaybe<TelephonydomainOrganizationAggregateBoolExpCount>;
};

export type TelephonydomainOrganizationAggregateBoolExpBool_and = {
  arguments: TelephonydomainOrganizationSelectColumnDomainOrganizationAggregateBoolExpBool_andArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TelephonydomainOrganizationBoolExp>;
  predicate: TelephonyBooleanComparisonExp;
};

export type TelephonydomainOrganizationAggregateBoolExpBool_or = {
  arguments: TelephonydomainOrganizationSelectColumnDomainOrganizationAggregateBoolExpBool_orArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TelephonydomainOrganizationBoolExp>;
  predicate: TelephonyBooleanComparisonExp;
};

export type TelephonydomainOrganizationAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TelephonydomainOrganizationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TelephonydomainOrganizationBoolExp>;
  predicate: TaskIntComparisonExp;
};

/** aggregate fields of "telephony.domain_organization" */
export type TelephonydomainOrganizationAggregateFields = {
  __typename?: 'TelephonydomainOrganizationAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TelephonydomainOrganizationMaxFields>;
  min?: Maybe<TelephonydomainOrganizationMinFields>;
};


/** aggregate fields of "telephony.domain_organization" */
export type TelephonydomainOrganizationAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TelephonydomainOrganizationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "telephony.domain_organization" */
export type TelephonydomainOrganizationAggregateOrderBy = {
  count?: InputMaybe<TelephonyOrderBy>;
  max?: InputMaybe<TelephonydomainOrganizationMaxOrderBy>;
  min?: InputMaybe<TelephonydomainOrganizationMinOrderBy>;
};

/** input type for inserting array relation for remote table "telephony.domain_organization" */
export type TelephonydomainOrganizationArrRelInsertInput = {
  data: Array<TelephonydomainOrganizationInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<TelephonydomainOrganizationOnConflict>;
};

/** Boolean expression to filter rows from the table "telephony.domain_organization". All fields are combined with a logical 'AND'. */
export type TelephonydomainOrganizationBoolExp = {
  _and?: InputMaybe<Array<TelephonydomainOrganizationBoolExp>>;
  _not?: InputMaybe<TelephonydomainOrganizationBoolExp>;
  _or?: InputMaybe<Array<TelephonydomainOrganizationBoolExp>>;
  adminId?: InputMaybe<TaskUuidComparisonExp>;
  autoGenerated?: InputMaybe<TelephonyBooleanComparisonExp>;
  createdAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  domainUsers?: InputMaybe<TelephonydomainUserBoolExp>;
  domainUsersAggregate?: InputMaybe<TelephonydomainUserAggregateBoolExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  organizationId?: InputMaybe<TaskUuidComparisonExp>;
  pod?: InputMaybe<TelephonyTelephonyPodsBoolExp>;
  podName?: InputMaybe<TaskStringComparisonExp>;
  providerAccount?: InputMaybe<TelephonyproviderAccountBoolExp>;
  providerAccountId?: InputMaybe<TaskUuidComparisonExp>;
  providerClientId?: InputMaybe<TaskStringComparisonExp>;
  providerClientName?: InputMaybe<TaskStringComparisonExp>;
  providerClientSubscribed?: InputMaybe<TelephonyBooleanComparisonExp>;
  updatedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "telephony.domain_organization" */
export type TelephonydomainOrganizationConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'domain_organization_pkey'
  /** unique or primary key constraint on columns "provider_client_id" */
  | 'domain_organization_provider_client_id_key'
  | '%future added value';

/** input type for inserting data into table "telephony.domain_organization" */
export type TelephonydomainOrganizationInsertInput = {
  /** Administrator of domain-org (organization.organization_user.id). */
  adminId?: InputMaybe<Scalars['uuid']['input']>;
  autoGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  domainUsers?: InputMaybe<TelephonydomainUserArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  pod?: InputMaybe<TelephonyTelephonyPodsObjRelInsertInput>;
  podName?: InputMaybe<Scalars['String']['input']>;
  providerAccount?: InputMaybe<TelephonyproviderAccountObjRelInsertInput>;
  providerAccountId?: InputMaybe<Scalars['uuid']['input']>;
  /** E.g. Phonero customer id */
  providerClientId?: InputMaybe<Scalars['String']['input']>;
  providerClientName?: InputMaybe<Scalars['String']['input']>;
  providerClientSubscribed?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** aggregate max on columns */
export type TelephonydomainOrganizationMaxFields = {
  __typename?: 'TelephonydomainOrganizationMaxFields';
  /** Administrator of domain-org (organization.organization_user.id). */
  adminId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  podName?: Maybe<Scalars['String']['output']>;
  providerAccountId?: Maybe<Scalars['uuid']['output']>;
  /** E.g. Phonero customer id */
  providerClientId?: Maybe<Scalars['String']['output']>;
  providerClientName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
};

/** order by max() on columns of table "telephony.domain_organization" */
export type TelephonydomainOrganizationMaxOrderBy = {
  /** Administrator of domain-org (organization.organization_user.id). */
  adminId?: InputMaybe<TelephonyOrderBy>;
  createdAt?: InputMaybe<TelephonyOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  organizationId?: InputMaybe<TelephonyOrderBy>;
  podName?: InputMaybe<TelephonyOrderBy>;
  providerAccountId?: InputMaybe<TelephonyOrderBy>;
  /** E.g. Phonero customer id */
  providerClientId?: InputMaybe<TelephonyOrderBy>;
  providerClientName?: InputMaybe<TelephonyOrderBy>;
  updatedAt?: InputMaybe<TelephonyOrderBy>;
};

/** aggregate min on columns */
export type TelephonydomainOrganizationMinFields = {
  __typename?: 'TelephonydomainOrganizationMinFields';
  /** Administrator of domain-org (organization.organization_user.id). */
  adminId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  podName?: Maybe<Scalars['String']['output']>;
  providerAccountId?: Maybe<Scalars['uuid']['output']>;
  /** E.g. Phonero customer id */
  providerClientId?: Maybe<Scalars['String']['output']>;
  providerClientName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
};

/** order by min() on columns of table "telephony.domain_organization" */
export type TelephonydomainOrganizationMinOrderBy = {
  /** Administrator of domain-org (organization.organization_user.id). */
  adminId?: InputMaybe<TelephonyOrderBy>;
  createdAt?: InputMaybe<TelephonyOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  organizationId?: InputMaybe<TelephonyOrderBy>;
  podName?: InputMaybe<TelephonyOrderBy>;
  providerAccountId?: InputMaybe<TelephonyOrderBy>;
  /** E.g. Phonero customer id */
  providerClientId?: InputMaybe<TelephonyOrderBy>;
  providerClientName?: InputMaybe<TelephonyOrderBy>;
  updatedAt?: InputMaybe<TelephonyOrderBy>;
};

/** response of any mutation on the table "telephony.domain_organization" */
export type TelephonydomainOrganizationMutationResponse = {
  __typename?: 'TelephonydomainOrganizationMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TelephonydomainOrganization>;
};

/** input type for inserting object relation for remote table "telephony.domain_organization" */
export type TelephonydomainOrganizationObjRelInsertInput = {
  data: TelephonydomainOrganizationInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TelephonydomainOrganizationOnConflict>;
};

/** on_conflict condition type for table "telephony.domain_organization" */
export type TelephonydomainOrganizationOnConflict = {
  constraint: TelephonydomainOrganizationConstraint;
  updateColumns?: Array<TelephonydomainOrganizationUpdateColumn>;
  where?: InputMaybe<TelephonydomainOrganizationBoolExp>;
};

/** Ordering options when selecting data from "telephony.domain_organization". */
export type TelephonydomainOrganizationOrderBy = {
  adminId?: InputMaybe<TelephonyOrderBy>;
  autoGenerated?: InputMaybe<TelephonyOrderBy>;
  createdAt?: InputMaybe<TelephonyOrderBy>;
  domainUsersAggregate?: InputMaybe<TelephonydomainUserAggregateOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  organizationId?: InputMaybe<TelephonyOrderBy>;
  pod?: InputMaybe<TelephonyTelephonyPodsOrderBy>;
  podName?: InputMaybe<TelephonyOrderBy>;
  providerAccount?: InputMaybe<TelephonyproviderAccountOrderBy>;
  providerAccountId?: InputMaybe<TelephonyOrderBy>;
  providerClientId?: InputMaybe<TelephonyOrderBy>;
  providerClientName?: InputMaybe<TelephonyOrderBy>;
  providerClientSubscribed?: InputMaybe<TelephonyOrderBy>;
  updatedAt?: InputMaybe<TelephonyOrderBy>;
};

/** primary key columns input for table: telephony.domain_organization */
export type TelephonydomainOrganizationPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "telephony.domain_organization" */
export type TelephonydomainOrganizationSelectColumn =
  /** column name */
  | 'adminId'
  /** column name */
  | 'autoGenerated'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'podName'
  /** column name */
  | 'providerAccountId'
  /** column name */
  | 'providerClientId'
  /** column name */
  | 'providerClientName'
  /** column name */
  | 'providerClientSubscribed'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** select "domainOrganizationAggregateBoolExpBool_andArgumentsColumns" columns of table "telephony.domain_organization" */
export type TelephonydomainOrganizationSelectColumnDomainOrganizationAggregateBoolExpBool_andArgumentsColumns =
  /** column name */
  | 'autoGenerated'
  /** column name */
  | 'providerClientSubscribed'
  | '%future added value';

/** select "domainOrganizationAggregateBoolExpBool_orArgumentsColumns" columns of table "telephony.domain_organization" */
export type TelephonydomainOrganizationSelectColumnDomainOrganizationAggregateBoolExpBool_orArgumentsColumns =
  /** column name */
  | 'autoGenerated'
  /** column name */
  | 'providerClientSubscribed'
  | '%future added value';

/** input type for updating data in table "telephony.domain_organization" */
export type TelephonydomainOrganizationSetInput = {
  /** Administrator of domain-org (organization.organization_user.id). */
  adminId?: InputMaybe<Scalars['uuid']['input']>;
  autoGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  podName?: InputMaybe<Scalars['String']['input']>;
  providerAccountId?: InputMaybe<Scalars['uuid']['input']>;
  /** E.g. Phonero customer id */
  providerClientId?: InputMaybe<Scalars['String']['input']>;
  providerClientName?: InputMaybe<Scalars['String']['input']>;
  providerClientSubscribed?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** Streaming cursor of the table "domainOrganization" */
export type TelephonydomainOrganizationStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TelephonydomainOrganizationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TelephonyCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TelephonydomainOrganizationStreamCursorValueInput = {
  /** Administrator of domain-org (organization.organization_user.id). */
  adminId?: InputMaybe<Scalars['uuid']['input']>;
  autoGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  podName?: InputMaybe<Scalars['String']['input']>;
  providerAccountId?: InputMaybe<Scalars['uuid']['input']>;
  /** E.g. Phonero customer id */
  providerClientId?: InputMaybe<Scalars['String']['input']>;
  providerClientName?: InputMaybe<Scalars['String']['input']>;
  providerClientSubscribed?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** update columns of table "telephony.domain_organization" */
export type TelephonydomainOrganizationUpdateColumn =
  /** column name */
  | 'adminId'
  /** column name */
  | 'autoGenerated'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'podName'
  /** column name */
  | 'providerAccountId'
  /** column name */
  | 'providerClientId'
  /** column name */
  | 'providerClientName'
  /** column name */
  | 'providerClientSubscribed'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type TelephonydomainOrganizationUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TelephonydomainOrganizationSetInput>;
  /** filter the rows which have to be updated */
  where: TelephonydomainOrganizationBoolExp;
};

/** columns and relationships of "telephony.domain_user" */
export type TelephonydomainUser = {
  __typename?: 'TelephonydomainUser';
  /** An array relationship */
  activityParticipants: Array<TelephonyactivityParticipant>;
  /** An aggregate relationship */
  activityParticipantsAggregate: TelephonyactivityParticipantAggregate;
  category?: Maybe<TelephonyDomainUserCategoryEnum>;
  city?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Telephonytimestamptz']['output'];
  department?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  domainOrganization: TelephonydomainOrganization;
  domainOrganizationId: Scalars['uuid']['output'];
  /** An object relationship */
  domainUserCategory?: Maybe<TelephonyDomainUserCategory>;
  firstName?: Maybe<Scalars['String']['output']>;
  function?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  lookupRawData?: Maybe<Scalars['Telephonyjsonb']['output']>;
  numberType?: Maybe<Scalars['String']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  personId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneState?: Maybe<Scalars['String']['output']>;
  source?: Maybe<TelephonyProviderTypeEnum>;
  spamScore: Scalars['Int']['output'];
  street?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Telephonytimestamptz']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "telephony.domain_user" */
export type TelephonydomainUseractivityParticipantsArgs = {
  distinctOn?: InputMaybe<Array<TelephonyactivityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyactivityParticipantOrderBy>>;
  where?: InputMaybe<TelephonyactivityParticipantBoolExp>;
};


/** columns and relationships of "telephony.domain_user" */
export type TelephonydomainUseractivityParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyactivityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyactivityParticipantOrderBy>>;
  where?: InputMaybe<TelephonyactivityParticipantBoolExp>;
};


/** columns and relationships of "telephony.domain_user" */
export type TelephonydomainUserlookupRawDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "telephony.domain_user" */
export type TelephonydomainUserAggregate = {
  __typename?: 'TelephonydomainUserAggregate';
  aggregate?: Maybe<TelephonydomainUserAggregateFields>;
  nodes: Array<TelephonydomainUser>;
};

export type TelephonydomainUserAggregateBoolExp = {
  count?: InputMaybe<TelephonydomainUserAggregateBoolExpCount>;
};

export type TelephonydomainUserAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TelephonydomainUserSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TelephonydomainUserBoolExp>;
  predicate: TaskIntComparisonExp;
};

/** aggregate fields of "telephony.domain_user" */
export type TelephonydomainUserAggregateFields = {
  __typename?: 'TelephonydomainUserAggregateFields';
  avg?: Maybe<TelephonydomainUserAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<TelephonydomainUserMaxFields>;
  min?: Maybe<TelephonydomainUserMinFields>;
  stddev?: Maybe<TelephonydomainUserStddevFields>;
  stddevPop?: Maybe<TelephonydomainUserStddevPopFields>;
  stddevSamp?: Maybe<TelephonydomainUserStddevSampFields>;
  sum?: Maybe<TelephonydomainUserSumFields>;
  varPop?: Maybe<TelephonydomainUserVarPopFields>;
  varSamp?: Maybe<TelephonydomainUserVarSampFields>;
  variance?: Maybe<TelephonydomainUserVarianceFields>;
};


/** aggregate fields of "telephony.domain_user" */
export type TelephonydomainUserAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TelephonydomainUserSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "telephony.domain_user" */
export type TelephonydomainUserAggregateOrderBy = {
  avg?: InputMaybe<TelephonydomainUserAvgOrderBy>;
  count?: InputMaybe<TelephonyOrderBy>;
  max?: InputMaybe<TelephonydomainUserMaxOrderBy>;
  min?: InputMaybe<TelephonydomainUserMinOrderBy>;
  stddev?: InputMaybe<TelephonydomainUserStddevOrderBy>;
  stddevPop?: InputMaybe<TelephonydomainUserStddevPopOrderBy>;
  stddevSamp?: InputMaybe<TelephonydomainUserStddevSampOrderBy>;
  sum?: InputMaybe<TelephonydomainUserSumOrderBy>;
  varPop?: InputMaybe<TelephonydomainUserVarPopOrderBy>;
  varSamp?: InputMaybe<TelephonydomainUserVarSampOrderBy>;
  variance?: InputMaybe<TelephonydomainUserVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type TelephonydomainUserAppendInput = {
  lookupRawData?: InputMaybe<Scalars['Telephonyjsonb']['input']>;
};

/** input type for inserting array relation for remote table "telephony.domain_user" */
export type TelephonydomainUserArrRelInsertInput = {
  data: Array<TelephonydomainUserInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<TelephonydomainUserOnConflict>;
};

/** aggregate avg on columns */
export type TelephonydomainUserAvgFields = {
  __typename?: 'TelephonydomainUserAvgFields';
  spamScore?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "telephony.domain_user" */
export type TelephonydomainUserAvgOrderBy = {
  spamScore?: InputMaybe<TelephonyOrderBy>;
};

/** Boolean expression to filter rows from the table "telephony.domain_user". All fields are combined with a logical 'AND'. */
export type TelephonydomainUserBoolExp = {
  _and?: InputMaybe<Array<TelephonydomainUserBoolExp>>;
  _not?: InputMaybe<TelephonydomainUserBoolExp>;
  _or?: InputMaybe<Array<TelephonydomainUserBoolExp>>;
  activityParticipants?: InputMaybe<TelephonyactivityParticipantBoolExp>;
  activityParticipantsAggregate?: InputMaybe<TelephonyactivityParticipantAggregateBoolExp>;
  category?: InputMaybe<TaskDomainUserCategoryEnumComparisonExp>;
  city?: InputMaybe<TaskStringComparisonExp>;
  createdAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  department?: InputMaybe<TaskStringComparisonExp>;
  domainOrganization?: InputMaybe<TelephonydomainOrganizationBoolExp>;
  domainOrganizationId?: InputMaybe<TaskUuidComparisonExp>;
  domainUserCategory?: InputMaybe<TelephonyDomainUserCategoryBoolExp>;
  firstName?: InputMaybe<TaskStringComparisonExp>;
  function?: InputMaybe<TaskStringComparisonExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  lastName?: InputMaybe<TaskStringComparisonExp>;
  lookupRawData?: InputMaybe<TaskJsonbComparisonExp>;
  numberType?: InputMaybe<TaskStringComparisonExp>;
  organizationUserId?: InputMaybe<TaskUuidComparisonExp>;
  personId?: InputMaybe<TaskStringComparisonExp>;
  phoneNumber?: InputMaybe<TaskStringComparisonExp>;
  phoneState?: InputMaybe<TaskStringComparisonExp>;
  source?: InputMaybe<TelephonyProviderTypeEnumComparisonExp>;
  spamScore?: InputMaybe<TaskIntComparisonExp>;
  street?: InputMaybe<TaskStringComparisonExp>;
  updatedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  zip?: InputMaybe<TaskStringComparisonExp>;
};

/** unique or primary key constraints on table "telephony.domain_user" */
export type TelephonydomainUserConstraint =
  /** unique or primary key constraint on columns "phone_number", "domain_organization_id" */
  | 'domain_user_phone_number_domain_organization_id_key'
  /** unique or primary key constraint on columns "id" */
  | 'domain_user_pkey'
  | '%future added value';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type TelephonydomainUserDeleteAtPathInput = {
  lookupRawData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type TelephonydomainUserDeleteElemInput = {
  lookupRawData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type TelephonydomainUserDeleteKeyInput = {
  lookupRawData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "telephony.domain_user" */
export type TelephonydomainUserIncInput = {
  spamScore?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "telephony.domain_user" */
export type TelephonydomainUserInsertInput = {
  activityParticipants?: InputMaybe<TelephonyactivityParticipantArrRelInsertInput>;
  category?: InputMaybe<TelephonyDomainUserCategoryEnum>;
  city?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  domainOrganization?: InputMaybe<TelephonydomainOrganizationObjRelInsertInput>;
  domainOrganizationId?: InputMaybe<Scalars['uuid']['input']>;
  domainUserCategory?: InputMaybe<TelephonyDomainUserCategoryObjRelInsertInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  function?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lookupRawData?: InputMaybe<Scalars['Telephonyjsonb']['input']>;
  numberType?: InputMaybe<Scalars['String']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  personId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneState?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<TelephonyProviderTypeEnum>;
  spamScore?: InputMaybe<Scalars['Int']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type TelephonydomainUserMaxFields = {
  __typename?: 'TelephonydomainUserMaxFields';
  city?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  domainOrganizationId?: Maybe<Scalars['uuid']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  function?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  numberType?: Maybe<Scalars['String']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  personId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneState?: Maybe<Scalars['String']['output']>;
  spamScore?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "telephony.domain_user" */
export type TelephonydomainUserMaxOrderBy = {
  city?: InputMaybe<TelephonyOrderBy>;
  createdAt?: InputMaybe<TelephonyOrderBy>;
  department?: InputMaybe<TelephonyOrderBy>;
  domainOrganizationId?: InputMaybe<TelephonyOrderBy>;
  firstName?: InputMaybe<TelephonyOrderBy>;
  function?: InputMaybe<TelephonyOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  lastName?: InputMaybe<TelephonyOrderBy>;
  numberType?: InputMaybe<TelephonyOrderBy>;
  organizationUserId?: InputMaybe<TelephonyOrderBy>;
  personId?: InputMaybe<TelephonyOrderBy>;
  phoneNumber?: InputMaybe<TelephonyOrderBy>;
  phoneState?: InputMaybe<TelephonyOrderBy>;
  spamScore?: InputMaybe<TelephonyOrderBy>;
  street?: InputMaybe<TelephonyOrderBy>;
  updatedAt?: InputMaybe<TelephonyOrderBy>;
  zip?: InputMaybe<TelephonyOrderBy>;
};

/** aggregate min on columns */
export type TelephonydomainUserMinFields = {
  __typename?: 'TelephonydomainUserMinFields';
  city?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  domainOrganizationId?: Maybe<Scalars['uuid']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  function?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  numberType?: Maybe<Scalars['String']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  personId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneState?: Maybe<Scalars['String']['output']>;
  spamScore?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "telephony.domain_user" */
export type TelephonydomainUserMinOrderBy = {
  city?: InputMaybe<TelephonyOrderBy>;
  createdAt?: InputMaybe<TelephonyOrderBy>;
  department?: InputMaybe<TelephonyOrderBy>;
  domainOrganizationId?: InputMaybe<TelephonyOrderBy>;
  firstName?: InputMaybe<TelephonyOrderBy>;
  function?: InputMaybe<TelephonyOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  lastName?: InputMaybe<TelephonyOrderBy>;
  numberType?: InputMaybe<TelephonyOrderBy>;
  organizationUserId?: InputMaybe<TelephonyOrderBy>;
  personId?: InputMaybe<TelephonyOrderBy>;
  phoneNumber?: InputMaybe<TelephonyOrderBy>;
  phoneState?: InputMaybe<TelephonyOrderBy>;
  spamScore?: InputMaybe<TelephonyOrderBy>;
  street?: InputMaybe<TelephonyOrderBy>;
  updatedAt?: InputMaybe<TelephonyOrderBy>;
  zip?: InputMaybe<TelephonyOrderBy>;
};

/** response of any mutation on the table "telephony.domain_user" */
export type TelephonydomainUserMutationResponse = {
  __typename?: 'TelephonydomainUserMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TelephonydomainUser>;
};

/** input type for inserting object relation for remote table "telephony.domain_user" */
export type TelephonydomainUserObjRelInsertInput = {
  data: TelephonydomainUserInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TelephonydomainUserOnConflict>;
};

/** on_conflict condition type for table "telephony.domain_user" */
export type TelephonydomainUserOnConflict = {
  constraint: TelephonydomainUserConstraint;
  updateColumns?: Array<TelephonydomainUserUpdateColumn>;
  where?: InputMaybe<TelephonydomainUserBoolExp>;
};

/** Ordering options when selecting data from "telephony.domain_user". */
export type TelephonydomainUserOrderBy = {
  activityParticipantsAggregate?: InputMaybe<TelephonyactivityParticipantAggregateOrderBy>;
  category?: InputMaybe<TelephonyOrderBy>;
  city?: InputMaybe<TelephonyOrderBy>;
  createdAt?: InputMaybe<TelephonyOrderBy>;
  department?: InputMaybe<TelephonyOrderBy>;
  domainOrganization?: InputMaybe<TelephonydomainOrganizationOrderBy>;
  domainOrganizationId?: InputMaybe<TelephonyOrderBy>;
  domainUserCategory?: InputMaybe<TelephonyDomainUserCategoryOrderBy>;
  firstName?: InputMaybe<TelephonyOrderBy>;
  function?: InputMaybe<TelephonyOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  lastName?: InputMaybe<TelephonyOrderBy>;
  lookupRawData?: InputMaybe<TelephonyOrderBy>;
  numberType?: InputMaybe<TelephonyOrderBy>;
  organizationUserId?: InputMaybe<TelephonyOrderBy>;
  personId?: InputMaybe<TelephonyOrderBy>;
  phoneNumber?: InputMaybe<TelephonyOrderBy>;
  phoneState?: InputMaybe<TelephonyOrderBy>;
  source?: InputMaybe<TelephonyOrderBy>;
  spamScore?: InputMaybe<TelephonyOrderBy>;
  street?: InputMaybe<TelephonyOrderBy>;
  updatedAt?: InputMaybe<TelephonyOrderBy>;
  zip?: InputMaybe<TelephonyOrderBy>;
};

/** primary key columns input for table: telephony.domain_user */
export type TelephonydomainUserPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type TelephonydomainUserPrependInput = {
  lookupRawData?: InputMaybe<Scalars['Telephonyjsonb']['input']>;
};

/** select columns of table "telephony.domain_user" */
export type TelephonydomainUserSelectColumn =
  /** column name */
  | 'category'
  /** column name */
  | 'city'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'department'
  /** column name */
  | 'domainOrganizationId'
  /** column name */
  | 'firstName'
  /** column name */
  | 'function'
  /** column name */
  | 'id'
  /** column name */
  | 'lastName'
  /** column name */
  | 'lookupRawData'
  /** column name */
  | 'numberType'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'personId'
  /** column name */
  | 'phoneNumber'
  /** column name */
  | 'phoneState'
  /** column name */
  | 'source'
  /** column name */
  | 'spamScore'
  /** column name */
  | 'street'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'zip'
  | '%future added value';

/** input type for updating data in table "telephony.domain_user" */
export type TelephonydomainUserSetInput = {
  category?: InputMaybe<TelephonyDomainUserCategoryEnum>;
  city?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  domainOrganizationId?: InputMaybe<Scalars['uuid']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  function?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lookupRawData?: InputMaybe<Scalars['Telephonyjsonb']['input']>;
  numberType?: InputMaybe<Scalars['String']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  personId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneState?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<TelephonyProviderTypeEnum>;
  spamScore?: InputMaybe<Scalars['Int']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type TelephonydomainUserStddevFields = {
  __typename?: 'TelephonydomainUserStddevFields';
  spamScore?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "telephony.domain_user" */
export type TelephonydomainUserStddevOrderBy = {
  spamScore?: InputMaybe<TelephonyOrderBy>;
};

/** aggregate stddevPop on columns */
export type TelephonydomainUserStddevPopFields = {
  __typename?: 'TelephonydomainUserStddevPopFields';
  spamScore?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "telephony.domain_user" */
export type TelephonydomainUserStddevPopOrderBy = {
  spamScore?: InputMaybe<TelephonyOrderBy>;
};

/** aggregate stddevSamp on columns */
export type TelephonydomainUserStddevSampFields = {
  __typename?: 'TelephonydomainUserStddevSampFields';
  spamScore?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "telephony.domain_user" */
export type TelephonydomainUserStddevSampOrderBy = {
  spamScore?: InputMaybe<TelephonyOrderBy>;
};

/** Streaming cursor of the table "domainUser" */
export type TelephonydomainUserStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TelephonydomainUserStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TelephonyCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TelephonydomainUserStreamCursorValueInput = {
  category?: InputMaybe<TelephonyDomainUserCategoryEnum>;
  city?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  domainOrganizationId?: InputMaybe<Scalars['uuid']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  function?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lookupRawData?: InputMaybe<Scalars['Telephonyjsonb']['input']>;
  numberType?: InputMaybe<Scalars['String']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  personId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneState?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<TelephonyProviderTypeEnum>;
  spamScore?: InputMaybe<Scalars['Int']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type TelephonydomainUserSumFields = {
  __typename?: 'TelephonydomainUserSumFields';
  spamScore?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "telephony.domain_user" */
export type TelephonydomainUserSumOrderBy = {
  spamScore?: InputMaybe<TelephonyOrderBy>;
};

/** update columns of table "telephony.domain_user" */
export type TelephonydomainUserUpdateColumn =
  /** column name */
  | 'category'
  /** column name */
  | 'city'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'department'
  /** column name */
  | 'domainOrganizationId'
  /** column name */
  | 'firstName'
  /** column name */
  | 'function'
  /** column name */
  | 'id'
  /** column name */
  | 'lastName'
  /** column name */
  | 'lookupRawData'
  /** column name */
  | 'numberType'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'personId'
  /** column name */
  | 'phoneNumber'
  /** column name */
  | 'phoneState'
  /** column name */
  | 'source'
  /** column name */
  | 'spamScore'
  /** column name */
  | 'street'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'zip'
  | '%future added value';

export type TelephonydomainUserUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<TelephonydomainUserAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<TelephonydomainUserDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<TelephonydomainUserDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<TelephonydomainUserDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TelephonydomainUserIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<TelephonydomainUserPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TelephonydomainUserSetInput>;
  /** filter the rows which have to be updated */
  where: TelephonydomainUserBoolExp;
};

/** aggregate varPop on columns */
export type TelephonydomainUserVarPopFields = {
  __typename?: 'TelephonydomainUserVarPopFields';
  spamScore?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "telephony.domain_user" */
export type TelephonydomainUserVarPopOrderBy = {
  spamScore?: InputMaybe<TelephonyOrderBy>;
};

/** aggregate varSamp on columns */
export type TelephonydomainUserVarSampFields = {
  __typename?: 'TelephonydomainUserVarSampFields';
  spamScore?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "telephony.domain_user" */
export type TelephonydomainUserVarSampOrderBy = {
  spamScore?: InputMaybe<TelephonyOrderBy>;
};

/** aggregate variance on columns */
export type TelephonydomainUserVarianceFields = {
  __typename?: 'TelephonydomainUserVarianceFields';
  spamScore?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "telephony.domain_user" */
export type TelephonydomainUserVarianceOrderBy = {
  spamScore?: InputMaybe<TelephonyOrderBy>;
};

/** columns and relationships of "telephony.event_to_be_deleted_in_may_2024" */
export type Telephonyevent = {
  __typename?: 'Telephonyevent';
  /** An object relationship */
  callDirection?: Maybe<TelephonyCallDirection>;
  callId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  destinationNumber?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<TelephonyCallDirectionEnum>;
  /** Timestamp when finished handled */
  handledAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  numberState?: Maybe<TelephonyNumberState>;
  organizationId?: Maybe<Scalars['Int']['output']>;
  originatingNumber?: Maybe<Scalars['String']['output']>;
  personNumber?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<TelephonyProviderTypeEnum>;
  state?: Maybe<TelephonyNumberStateEnum>;
  timestamp?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  updatedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
};

/** columns and relationships of "telephony.event_action" */
export type TelephonyeventAction = {
  __typename?: 'TelephonyeventAction';
  /** An object relationship */
  actionType: TelephonyTelephonyActionType;
  createdAt: Scalars['Telephonytimestamptz']['output'];
  destinationNumber: Scalars['String']['output'];
  /** An object relationship */
  event: TelephonyTelephonyEvents;
  eventId: Scalars['uuid']['output'];
  handledAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  originalEvent?: Maybe<TelephonyTelephonyEvents>;
  originalEventId?: Maybe<Scalars['uuid']['output']>;
  originatingNumber: Scalars['String']['output'];
  state: TelephonyNumberStateEnum;
  type: TelephonyTelephonyActionTypeEnum;
  updatedAt: Scalars['Telephonytimestamptz']['output'];
};

/** aggregated selection of "telephony.event_action" */
export type TelephonyeventActionAggregate = {
  __typename?: 'TelephonyeventActionAggregate';
  aggregate?: Maybe<TelephonyeventActionAggregateFields>;
  nodes: Array<TelephonyeventAction>;
};

/** aggregate fields of "telephony.event_action" */
export type TelephonyeventActionAggregateFields = {
  __typename?: 'TelephonyeventActionAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TelephonyeventActionMaxFields>;
  min?: Maybe<TelephonyeventActionMinFields>;
};


/** aggregate fields of "telephony.event_action" */
export type TelephonyeventActionAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TelephonyeventActionSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "telephony.event_action". All fields are combined with a logical 'AND'. */
export type TelephonyeventActionBoolExp = {
  _and?: InputMaybe<Array<TelephonyeventActionBoolExp>>;
  _not?: InputMaybe<TelephonyeventActionBoolExp>;
  _or?: InputMaybe<Array<TelephonyeventActionBoolExp>>;
  actionType?: InputMaybe<TelephonyTelephonyActionTypeBoolExp>;
  createdAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  destinationNumber?: InputMaybe<TaskStringComparisonExp>;
  event?: InputMaybe<TelephonyTelephonyEventsBoolExp>;
  eventId?: InputMaybe<TaskUuidComparisonExp>;
  handledAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  originalEvent?: InputMaybe<TelephonyTelephonyEventsBoolExp>;
  originalEventId?: InputMaybe<TaskUuidComparisonExp>;
  originatingNumber?: InputMaybe<TaskStringComparisonExp>;
  state?: InputMaybe<TelephonyNumberStateEnumComparisonExp>;
  type?: InputMaybe<TelephonyTelephonyActionTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "telephony.event_action" */
export type TelephonyeventActionConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'event_action_pkey'
  /** unique or primary key constraint on columns "state", "destination_number", "type", "originating_number" */
  | 'event_action_state_originating_number_destination_number_type_k'
  | '%future added value';

/** input type for inserting data into table "telephony.event_action" */
export type TelephonyeventActionInsertInput = {
  actionType?: InputMaybe<TelephonyTelephonyActionTypeObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  destinationNumber?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<TelephonyTelephonyEventsObjRelInsertInput>;
  eventId?: InputMaybe<Scalars['uuid']['input']>;
  handledAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  originalEvent?: InputMaybe<TelephonyTelephonyEventsObjRelInsertInput>;
  originalEventId?: InputMaybe<Scalars['uuid']['input']>;
  originatingNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<TelephonyNumberStateEnum>;
  type?: InputMaybe<TelephonyTelephonyActionTypeEnum>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** aggregate max on columns */
export type TelephonyeventActionMaxFields = {
  __typename?: 'TelephonyeventActionMaxFields';
  createdAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  destinationNumber?: Maybe<Scalars['String']['output']>;
  eventId?: Maybe<Scalars['uuid']['output']>;
  handledAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  originalEventId?: Maybe<Scalars['uuid']['output']>;
  originatingNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
};

/** aggregate min on columns */
export type TelephonyeventActionMinFields = {
  __typename?: 'TelephonyeventActionMinFields';
  createdAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  destinationNumber?: Maybe<Scalars['String']['output']>;
  eventId?: Maybe<Scalars['uuid']['output']>;
  handledAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  originalEventId?: Maybe<Scalars['uuid']['output']>;
  originatingNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
};

/** response of any mutation on the table "telephony.event_action" */
export type TelephonyeventActionMutationResponse = {
  __typename?: 'TelephonyeventActionMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TelephonyeventAction>;
};

/** on_conflict condition type for table "telephony.event_action" */
export type TelephonyeventActionOnConflict = {
  constraint: TelephonyeventActionConstraint;
  updateColumns?: Array<TelephonyeventActionUpdateColumn>;
  where?: InputMaybe<TelephonyeventActionBoolExp>;
};

/** Ordering options when selecting data from "telephony.event_action". */
export type TelephonyeventActionOrderBy = {
  actionType?: InputMaybe<TelephonyTelephonyActionTypeOrderBy>;
  createdAt?: InputMaybe<TelephonyOrderBy>;
  destinationNumber?: InputMaybe<TelephonyOrderBy>;
  event?: InputMaybe<TelephonyTelephonyEventsOrderBy>;
  eventId?: InputMaybe<TelephonyOrderBy>;
  handledAt?: InputMaybe<TelephonyOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  originalEvent?: InputMaybe<TelephonyTelephonyEventsOrderBy>;
  originalEventId?: InputMaybe<TelephonyOrderBy>;
  originatingNumber?: InputMaybe<TelephonyOrderBy>;
  state?: InputMaybe<TelephonyOrderBy>;
  type?: InputMaybe<TelephonyOrderBy>;
  updatedAt?: InputMaybe<TelephonyOrderBy>;
};

/** primary key columns input for table: telephony.event_action */
export type TelephonyeventActionPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "telephony.event_action" */
export type TelephonyeventActionSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'destinationNumber'
  /** column name */
  | 'eventId'
  /** column name */
  | 'handledAt'
  /** column name */
  | 'id'
  /** column name */
  | 'originalEventId'
  /** column name */
  | 'originatingNumber'
  /** column name */
  | 'state'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "telephony.event_action" */
export type TelephonyeventActionSetInput = {
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  destinationNumber?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['uuid']['input']>;
  handledAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  originalEventId?: InputMaybe<Scalars['uuid']['input']>;
  originatingNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<TelephonyNumberStateEnum>;
  type?: InputMaybe<TelephonyTelephonyActionTypeEnum>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** Streaming cursor of the table "eventAction" */
export type TelephonyeventActionStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TelephonyeventActionStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TelephonyCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TelephonyeventActionStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  destinationNumber?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['uuid']['input']>;
  handledAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  originalEventId?: InputMaybe<Scalars['uuid']['input']>;
  originatingNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<TelephonyNumberStateEnum>;
  type?: InputMaybe<TelephonyTelephonyActionTypeEnum>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** update columns of table "telephony.event_action" */
export type TelephonyeventActionUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'destinationNumber'
  /** column name */
  | 'eventId'
  /** column name */
  | 'handledAt'
  /** column name */
  | 'id'
  /** column name */
  | 'originalEventId'
  /** column name */
  | 'originatingNumber'
  /** column name */
  | 'state'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type TelephonyeventActionUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TelephonyeventActionSetInput>;
  /** filter the rows which have to be updated */
  where: TelephonyeventActionBoolExp;
};

/** aggregated selection of "telephony.event_to_be_deleted_in_may_2024" */
export type TelephonyeventAggregate = {
  __typename?: 'TelephonyeventAggregate';
  aggregate?: Maybe<TelephonyeventAggregateFields>;
  nodes: Array<Telephonyevent>;
};

export type TelephonyeventAggregateBoolExp = {
  count?: InputMaybe<TelephonyeventAggregateBoolExpCount>;
};

export type TelephonyeventAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TelephonyeventSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TelephonyeventBoolExp>;
  predicate: TaskIntComparisonExp;
};

/** aggregate fields of "telephony.event_to_be_deleted_in_may_2024" */
export type TelephonyeventAggregateFields = {
  __typename?: 'TelephonyeventAggregateFields';
  avg?: Maybe<TelephonyeventAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<TelephonyeventMaxFields>;
  min?: Maybe<TelephonyeventMinFields>;
  stddev?: Maybe<TelephonyeventStddevFields>;
  stddevPop?: Maybe<TelephonyeventStddevPopFields>;
  stddevSamp?: Maybe<TelephonyeventStddevSampFields>;
  sum?: Maybe<TelephonyeventSumFields>;
  varPop?: Maybe<TelephonyeventVarPopFields>;
  varSamp?: Maybe<TelephonyeventVarSampFields>;
  variance?: Maybe<TelephonyeventVarianceFields>;
};


/** aggregate fields of "telephony.event_to_be_deleted_in_may_2024" */
export type TelephonyeventAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TelephonyeventSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "telephony.event_to_be_deleted_in_may_2024" */
export type TelephonyeventAggregateOrderBy = {
  avg?: InputMaybe<TelephonyeventAvgOrderBy>;
  count?: InputMaybe<TelephonyOrderBy>;
  max?: InputMaybe<TelephonyeventMaxOrderBy>;
  min?: InputMaybe<TelephonyeventMinOrderBy>;
  stddev?: InputMaybe<TelephonyeventStddevOrderBy>;
  stddevPop?: InputMaybe<TelephonyeventStddevPopOrderBy>;
  stddevSamp?: InputMaybe<TelephonyeventStddevSampOrderBy>;
  sum?: InputMaybe<TelephonyeventSumOrderBy>;
  varPop?: InputMaybe<TelephonyeventVarPopOrderBy>;
  varSamp?: InputMaybe<TelephonyeventVarSampOrderBy>;
  variance?: InputMaybe<TelephonyeventVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "telephony.event_to_be_deleted_in_may_2024" */
export type TelephonyeventArrRelInsertInput = {
  data: Array<TelephonyeventInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<TelephonyeventOnConflict>;
};

/** aggregate avg on columns */
export type TelephonyeventAvgFields = {
  __typename?: 'TelephonyeventAvgFields';
  organizationId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "telephony.event_to_be_deleted_in_may_2024" */
export type TelephonyeventAvgOrderBy = {
  organizationId?: InputMaybe<TelephonyOrderBy>;
};

/** Boolean expression to filter rows from the table "telephony.event_to_be_deleted_in_may_2024". All fields are combined with a logical 'AND'. */
export type TelephonyeventBoolExp = {
  _and?: InputMaybe<Array<TelephonyeventBoolExp>>;
  _not?: InputMaybe<TelephonyeventBoolExp>;
  _or?: InputMaybe<Array<TelephonyeventBoolExp>>;
  callDirection?: InputMaybe<TelephonyCallDirectionBoolExp>;
  callId?: InputMaybe<TaskStringComparisonExp>;
  createdAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  destinationNumber?: InputMaybe<TaskStringComparisonExp>;
  direction?: InputMaybe<TelephonyCallDirectionEnumComparisonExp>;
  handledAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  numberState?: InputMaybe<TelephonyNumberStateBoolExp>;
  organizationId?: InputMaybe<TaskIntComparisonExp>;
  originatingNumber?: InputMaybe<TaskStringComparisonExp>;
  personNumber?: InputMaybe<TaskStringComparisonExp>;
  provider?: InputMaybe<TelephonyProviderTypeEnumComparisonExp>;
  state?: InputMaybe<TelephonyNumberStateEnumComparisonExp>;
  timestamp?: InputMaybe<TaskTimestamptzComparisonExp>;
  updatedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "telephony.event_to_be_deleted_in_may_2024" */
export type TelephonyeventConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'events_id_key'
  /** unique or primary key constraint on columns "id" */
  | 'events_pkey'
  | '%future added value';

/** input type for incrementing numeric columns in table "telephony.event_to_be_deleted_in_may_2024" */
export type TelephonyeventIncInput = {
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "telephony.event_to_be_deleted_in_may_2024" */
export type TelephonyeventInsertInput = {
  callDirection?: InputMaybe<TelephonyCallDirectionObjRelInsertInput>;
  callId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  destinationNumber?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<TelephonyCallDirectionEnum>;
  /** Timestamp when finished handled */
  handledAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  numberState?: InputMaybe<TelephonyNumberStateObjRelInsertInput>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  originatingNumber?: InputMaybe<Scalars['String']['input']>;
  personNumber?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<TelephonyProviderTypeEnum>;
  state?: InputMaybe<TelephonyNumberStateEnum>;
  timestamp?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** aggregate max on columns */
export type TelephonyeventMaxFields = {
  __typename?: 'TelephonyeventMaxFields';
  callId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  destinationNumber?: Maybe<Scalars['String']['output']>;
  /** Timestamp when finished handled */
  handledAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationId?: Maybe<Scalars['Int']['output']>;
  originatingNumber?: Maybe<Scalars['String']['output']>;
  personNumber?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  updatedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
};

/** order by max() on columns of table "telephony.event_to_be_deleted_in_may_2024" */
export type TelephonyeventMaxOrderBy = {
  callId?: InputMaybe<TelephonyOrderBy>;
  createdAt?: InputMaybe<TelephonyOrderBy>;
  destinationNumber?: InputMaybe<TelephonyOrderBy>;
  /** Timestamp when finished handled */
  handledAt?: InputMaybe<TelephonyOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  organizationId?: InputMaybe<TelephonyOrderBy>;
  originatingNumber?: InputMaybe<TelephonyOrderBy>;
  personNumber?: InputMaybe<TelephonyOrderBy>;
  timestamp?: InputMaybe<TelephonyOrderBy>;
  updatedAt?: InputMaybe<TelephonyOrderBy>;
};

/** aggregate min on columns */
export type TelephonyeventMinFields = {
  __typename?: 'TelephonyeventMinFields';
  callId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  destinationNumber?: Maybe<Scalars['String']['output']>;
  /** Timestamp when finished handled */
  handledAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationId?: Maybe<Scalars['Int']['output']>;
  originatingNumber?: Maybe<Scalars['String']['output']>;
  personNumber?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  updatedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
};

/** order by min() on columns of table "telephony.event_to_be_deleted_in_may_2024" */
export type TelephonyeventMinOrderBy = {
  callId?: InputMaybe<TelephonyOrderBy>;
  createdAt?: InputMaybe<TelephonyOrderBy>;
  destinationNumber?: InputMaybe<TelephonyOrderBy>;
  /** Timestamp when finished handled */
  handledAt?: InputMaybe<TelephonyOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  organizationId?: InputMaybe<TelephonyOrderBy>;
  originatingNumber?: InputMaybe<TelephonyOrderBy>;
  personNumber?: InputMaybe<TelephonyOrderBy>;
  timestamp?: InputMaybe<TelephonyOrderBy>;
  updatedAt?: InputMaybe<TelephonyOrderBy>;
};

/** response of any mutation on the table "telephony.event_to_be_deleted_in_may_2024" */
export type TelephonyeventMutationResponse = {
  __typename?: 'TelephonyeventMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Telephonyevent>;
};

/** on_conflict condition type for table "telephony.event_to_be_deleted_in_may_2024" */
export type TelephonyeventOnConflict = {
  constraint: TelephonyeventConstraint;
  updateColumns?: Array<TelephonyeventUpdateColumn>;
  where?: InputMaybe<TelephonyeventBoolExp>;
};

/** Ordering options when selecting data from "telephony.event_to_be_deleted_in_may_2024". */
export type TelephonyeventOrderBy = {
  callDirection?: InputMaybe<TelephonyCallDirectionOrderBy>;
  callId?: InputMaybe<TelephonyOrderBy>;
  createdAt?: InputMaybe<TelephonyOrderBy>;
  destinationNumber?: InputMaybe<TelephonyOrderBy>;
  direction?: InputMaybe<TelephonyOrderBy>;
  handledAt?: InputMaybe<TelephonyOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  numberState?: InputMaybe<TelephonyNumberStateOrderBy>;
  organizationId?: InputMaybe<TelephonyOrderBy>;
  originatingNumber?: InputMaybe<TelephonyOrderBy>;
  personNumber?: InputMaybe<TelephonyOrderBy>;
  provider?: InputMaybe<TelephonyOrderBy>;
  state?: InputMaybe<TelephonyOrderBy>;
  timestamp?: InputMaybe<TelephonyOrderBy>;
  updatedAt?: InputMaybe<TelephonyOrderBy>;
};

/** primary key columns input for table: telephony.event_to_be_deleted_in_may_2024 */
export type TelephonyeventPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "telephony.event_to_be_deleted_in_may_2024" */
export type TelephonyeventSelectColumn =
  /** column name */
  | 'callId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'destinationNumber'
  /** column name */
  | 'direction'
  /** column name */
  | 'handledAt'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'originatingNumber'
  /** column name */
  | 'personNumber'
  /** column name */
  | 'provider'
  /** column name */
  | 'state'
  /** column name */
  | 'timestamp'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "telephony.event_to_be_deleted_in_may_2024" */
export type TelephonyeventSetInput = {
  callId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  destinationNumber?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<TelephonyCallDirectionEnum>;
  /** Timestamp when finished handled */
  handledAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  originatingNumber?: InputMaybe<Scalars['String']['input']>;
  personNumber?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<TelephonyProviderTypeEnum>;
  state?: InputMaybe<TelephonyNumberStateEnum>;
  timestamp?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** aggregate stddev on columns */
export type TelephonyeventStddevFields = {
  __typename?: 'TelephonyeventStddevFields';
  organizationId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "telephony.event_to_be_deleted_in_may_2024" */
export type TelephonyeventStddevOrderBy = {
  organizationId?: InputMaybe<TelephonyOrderBy>;
};

/** aggregate stddevPop on columns */
export type TelephonyeventStddevPopFields = {
  __typename?: 'TelephonyeventStddevPopFields';
  organizationId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "telephony.event_to_be_deleted_in_may_2024" */
export type TelephonyeventStddevPopOrderBy = {
  organizationId?: InputMaybe<TelephonyOrderBy>;
};

/** aggregate stddevSamp on columns */
export type TelephonyeventStddevSampFields = {
  __typename?: 'TelephonyeventStddevSampFields';
  organizationId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "telephony.event_to_be_deleted_in_may_2024" */
export type TelephonyeventStddevSampOrderBy = {
  organizationId?: InputMaybe<TelephonyOrderBy>;
};

/** Streaming cursor of the table "event" */
export type TelephonyeventStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TelephonyeventStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TelephonyCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TelephonyeventStreamCursorValueInput = {
  callId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  destinationNumber?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<TelephonyCallDirectionEnum>;
  /** Timestamp when finished handled */
  handledAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  originatingNumber?: InputMaybe<Scalars['String']['input']>;
  personNumber?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<TelephonyProviderTypeEnum>;
  state?: InputMaybe<TelephonyNumberStateEnum>;
  timestamp?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** aggregate sum on columns */
export type TelephonyeventSumFields = {
  __typename?: 'TelephonyeventSumFields';
  organizationId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "telephony.event_to_be_deleted_in_may_2024" */
export type TelephonyeventSumOrderBy = {
  organizationId?: InputMaybe<TelephonyOrderBy>;
};

/** update columns of table "telephony.event_to_be_deleted_in_may_2024" */
export type TelephonyeventUpdateColumn =
  /** column name */
  | 'callId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'destinationNumber'
  /** column name */
  | 'direction'
  /** column name */
  | 'handledAt'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'originatingNumber'
  /** column name */
  | 'personNumber'
  /** column name */
  | 'provider'
  /** column name */
  | 'state'
  /** column name */
  | 'timestamp'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type TelephonyeventUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TelephonyeventIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TelephonyeventSetInput>;
  /** filter the rows which have to be updated */
  where: TelephonyeventBoolExp;
};

/** aggregate varPop on columns */
export type TelephonyeventVarPopFields = {
  __typename?: 'TelephonyeventVarPopFields';
  organizationId?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "telephony.event_to_be_deleted_in_may_2024" */
export type TelephonyeventVarPopOrderBy = {
  organizationId?: InputMaybe<TelephonyOrderBy>;
};

/** aggregate varSamp on columns */
export type TelephonyeventVarSampFields = {
  __typename?: 'TelephonyeventVarSampFields';
  organizationId?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "telephony.event_to_be_deleted_in_may_2024" */
export type TelephonyeventVarSampOrderBy = {
  organizationId?: InputMaybe<TelephonyOrderBy>;
};

/** aggregate variance on columns */
export type TelephonyeventVarianceFields = {
  __typename?: 'TelephonyeventVarianceFields';
  organizationId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "telephony.event_to_be_deleted_in_may_2024" */
export type TelephonyeventVarianceOrderBy = {
  organizationId?: InputMaybe<TelephonyOrderBy>;
};

export type TelephonyhangUpCallOutput = {
  __typename?: 'TelephonyhangUpCallOutput';
  error?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "telephony.provider" */
export type Telephonyprovider = {
  __typename?: 'Telephonyprovider';
  createdAt: Scalars['Telephonytimestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  endpoint: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  provider_type?: Maybe<TelephonyProviderType>;
  type?: Maybe<TelephonyProviderTypeEnum>;
  updatedAt: Scalars['Telephonytimestamptz']['output'];
};

/** Telephony provider/gateway, tilsvarer phonero API-user */
export type TelephonyproviderAccount = {
  __typename?: 'TelephonyproviderAccount';
  /** An array relationship */
  domainOrganizations: Array<TelephonydomainOrganization>;
  /** An aggregate relationship */
  domainOrganizationsAggregate: TelephonydomainOrganizationAggregate;
  /** URL */
  endpoint?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  password?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  provider: Telephonyprovider;
  providerAccess?: Maybe<TelephonyTelephonyProviderAccessEnum>;
  providerId: Scalars['String']['output'];
  /** An object relationship */
  providerType?: Maybe<TelephonyProviderType>;
  sessionId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TelephonyProviderTypeEnum>;
  username?: Maybe<Scalars['String']['output']>;
};


/** Telephony provider/gateway, tilsvarer phonero API-user */
export type TelephonyproviderAccountdomainOrganizationsArgs = {
  distinctOn?: InputMaybe<Array<TelephonydomainOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonydomainOrganizationOrderBy>>;
  where?: InputMaybe<TelephonydomainOrganizationBoolExp>;
};


/** Telephony provider/gateway, tilsvarer phonero API-user */
export type TelephonyproviderAccountdomainOrganizationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonydomainOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonydomainOrganizationOrderBy>>;
  where?: InputMaybe<TelephonydomainOrganizationBoolExp>;
};

/** aggregated selection of "telephony.provider_account" */
export type TelephonyproviderAccountAggregate = {
  __typename?: 'TelephonyproviderAccountAggregate';
  aggregate?: Maybe<TelephonyproviderAccountAggregateFields>;
  nodes: Array<TelephonyproviderAccount>;
};

export type TelephonyproviderAccountAggregateBoolExp = {
  count?: InputMaybe<TelephonyproviderAccountAggregateBoolExpCount>;
};

export type TelephonyproviderAccountAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TelephonyproviderAccountSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TelephonyproviderAccountBoolExp>;
  predicate: TaskIntComparisonExp;
};

/** aggregate fields of "telephony.provider_account" */
export type TelephonyproviderAccountAggregateFields = {
  __typename?: 'TelephonyproviderAccountAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TelephonyproviderAccountMaxFields>;
  min?: Maybe<TelephonyproviderAccountMinFields>;
};


/** aggregate fields of "telephony.provider_account" */
export type TelephonyproviderAccountAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TelephonyproviderAccountSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "telephony.provider_account" */
export type TelephonyproviderAccountAggregateOrderBy = {
  count?: InputMaybe<TelephonyOrderBy>;
  max?: InputMaybe<TelephonyproviderAccountMaxOrderBy>;
  min?: InputMaybe<TelephonyproviderAccountMinOrderBy>;
};

/** input type for inserting array relation for remote table "telephony.provider_account" */
export type TelephonyproviderAccountArrRelInsertInput = {
  data: Array<TelephonyproviderAccountInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<TelephonyproviderAccountOnConflict>;
};

/** Boolean expression to filter rows from the table "telephony.provider_account". All fields are combined with a logical 'AND'. */
export type TelephonyproviderAccountBoolExp = {
  _and?: InputMaybe<Array<TelephonyproviderAccountBoolExp>>;
  _not?: InputMaybe<TelephonyproviderAccountBoolExp>;
  _or?: InputMaybe<Array<TelephonyproviderAccountBoolExp>>;
  domainOrganizations?: InputMaybe<TelephonydomainOrganizationBoolExp>;
  domainOrganizationsAggregate?: InputMaybe<TelephonydomainOrganizationAggregateBoolExp>;
  endpoint?: InputMaybe<TaskStringComparisonExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  password?: InputMaybe<TaskStringComparisonExp>;
  provider?: InputMaybe<TelephonyproviderBoolExp>;
  providerAccess?: InputMaybe<TelephonyTelephonyProviderAccessEnumComparisonExp>;
  providerId?: InputMaybe<TaskStringComparisonExp>;
  providerType?: InputMaybe<TelephonyProviderTypeBoolExp>;
  sessionId?: InputMaybe<TaskStringComparisonExp>;
  type?: InputMaybe<TelephonyProviderTypeEnumComparisonExp>;
  username?: InputMaybe<TaskStringComparisonExp>;
};

/** unique or primary key constraints on table "telephony.provider_account" */
export type TelephonyproviderAccountConstraint =
  /** unique or primary key constraint on columns "endpoint", "username" */
  | 'provider_account_endpoint_username_key'
  /** unique or primary key constraint on columns "id" */
  | 'provider_pkey'
  | '%future added value';

/** input type for inserting data into table "telephony.provider_account" */
export type TelephonyproviderAccountInsertInput = {
  domainOrganizations?: InputMaybe<TelephonydomainOrganizationArrRelInsertInput>;
  /** URL */
  endpoint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<TelephonyproviderObjRelInsertInput>;
  providerAccess?: InputMaybe<TelephonyTelephonyProviderAccessEnum>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerType?: InputMaybe<TelephonyProviderTypeObjRelInsertInput>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TelephonyProviderTypeEnum>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type TelephonyproviderAccountMaxFields = {
  __typename?: 'TelephonyproviderAccountMaxFields';
  /** URL */
  endpoint?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "telephony.provider_account" */
export type TelephonyproviderAccountMaxOrderBy = {
  /** URL */
  endpoint?: InputMaybe<TelephonyOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  password?: InputMaybe<TelephonyOrderBy>;
  providerId?: InputMaybe<TelephonyOrderBy>;
  sessionId?: InputMaybe<TelephonyOrderBy>;
  username?: InputMaybe<TelephonyOrderBy>;
};

/** aggregate min on columns */
export type TelephonyproviderAccountMinFields = {
  __typename?: 'TelephonyproviderAccountMinFields';
  /** URL */
  endpoint?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "telephony.provider_account" */
export type TelephonyproviderAccountMinOrderBy = {
  /** URL */
  endpoint?: InputMaybe<TelephonyOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  password?: InputMaybe<TelephonyOrderBy>;
  providerId?: InputMaybe<TelephonyOrderBy>;
  sessionId?: InputMaybe<TelephonyOrderBy>;
  username?: InputMaybe<TelephonyOrderBy>;
};

/** response of any mutation on the table "telephony.provider_account" */
export type TelephonyproviderAccountMutationResponse = {
  __typename?: 'TelephonyproviderAccountMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TelephonyproviderAccount>;
};

/** input type for inserting object relation for remote table "telephony.provider_account" */
export type TelephonyproviderAccountObjRelInsertInput = {
  data: TelephonyproviderAccountInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TelephonyproviderAccountOnConflict>;
};

/** on_conflict condition type for table "telephony.provider_account" */
export type TelephonyproviderAccountOnConflict = {
  constraint: TelephonyproviderAccountConstraint;
  updateColumns?: Array<TelephonyproviderAccountUpdateColumn>;
  where?: InputMaybe<TelephonyproviderAccountBoolExp>;
};

/** Ordering options when selecting data from "telephony.provider_account". */
export type TelephonyproviderAccountOrderBy = {
  domainOrganizationsAggregate?: InputMaybe<TelephonydomainOrganizationAggregateOrderBy>;
  endpoint?: InputMaybe<TelephonyOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  password?: InputMaybe<TelephonyOrderBy>;
  provider?: InputMaybe<TelephonyproviderOrderBy>;
  providerAccess?: InputMaybe<TelephonyOrderBy>;
  providerId?: InputMaybe<TelephonyOrderBy>;
  providerType?: InputMaybe<TelephonyProviderTypeOrderBy>;
  sessionId?: InputMaybe<TelephonyOrderBy>;
  type?: InputMaybe<TelephonyOrderBy>;
  username?: InputMaybe<TelephonyOrderBy>;
};

/** primary key columns input for table: telephony.provider_account */
export type TelephonyproviderAccountPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "telephony.provider_account" */
export type TelephonyproviderAccountSelectColumn =
  /** column name */
  | 'endpoint'
  /** column name */
  | 'id'
  /** column name */
  | 'password'
  /** column name */
  | 'providerAccess'
  /** column name */
  | 'providerId'
  /** column name */
  | 'sessionId'
  /** column name */
  | 'type'
  /** column name */
  | 'username'
  | '%future added value';

/** input type for updating data in table "telephony.provider_account" */
export type TelephonyproviderAccountSetInput = {
  /** URL */
  endpoint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  providerAccess?: InputMaybe<TelephonyTelephonyProviderAccessEnum>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TelephonyProviderTypeEnum>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "providerAccount" */
export type TelephonyproviderAccountStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TelephonyproviderAccountStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TelephonyCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TelephonyproviderAccountStreamCursorValueInput = {
  /** URL */
  endpoint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  providerAccess?: InputMaybe<TelephonyTelephonyProviderAccessEnum>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TelephonyProviderTypeEnum>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "telephony.provider_account" */
export type TelephonyproviderAccountUpdateColumn =
  /** column name */
  | 'endpoint'
  /** column name */
  | 'id'
  /** column name */
  | 'password'
  /** column name */
  | 'providerAccess'
  /** column name */
  | 'providerId'
  /** column name */
  | 'sessionId'
  /** column name */
  | 'type'
  /** column name */
  | 'username'
  | '%future added value';

export type TelephonyproviderAccountUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TelephonyproviderAccountSetInput>;
  /** filter the rows which have to be updated */
  where: TelephonyproviderAccountBoolExp;
};

/** aggregated selection of "telephony.provider" */
export type TelephonyproviderAggregate = {
  __typename?: 'TelephonyproviderAggregate';
  aggregate?: Maybe<TelephonyproviderAggregateFields>;
  nodes: Array<Telephonyprovider>;
};

/** aggregate fields of "telephony.provider" */
export type TelephonyproviderAggregateFields = {
  __typename?: 'TelephonyproviderAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TelephonyproviderMaxFields>;
  min?: Maybe<TelephonyproviderMinFields>;
};


/** aggregate fields of "telephony.provider" */
export type TelephonyproviderAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TelephonyproviderSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "telephony.provider". All fields are combined with a logical 'AND'. */
export type TelephonyproviderBoolExp = {
  _and?: InputMaybe<Array<TelephonyproviderBoolExp>>;
  _not?: InputMaybe<TelephonyproviderBoolExp>;
  _or?: InputMaybe<Array<TelephonyproviderBoolExp>>;
  createdAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  description?: InputMaybe<TaskStringComparisonExp>;
  emailAddress?: InputMaybe<TaskStringComparisonExp>;
  endpoint?: InputMaybe<TaskStringComparisonExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  name?: InputMaybe<TaskStringComparisonExp>;
  provider_type?: InputMaybe<TelephonyProviderTypeBoolExp>;
  type?: InputMaybe<TelephonyProviderTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "telephony.provider" */
export type TelephonyproviderConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'provider_pkey1'
  /** unique or primary key constraint on columns "type" */
  | 'provider_type_key'
  | '%future added value';

/** input type for inserting data into table "telephony.provider" */
export type TelephonyproviderInsertInput = {
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider_type?: InputMaybe<TelephonyProviderTypeObjRelInsertInput>;
  type?: InputMaybe<TelephonyProviderTypeEnum>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** aggregate max on columns */
export type TelephonyproviderMaxFields = {
  __typename?: 'TelephonyproviderMaxFields';
  createdAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  endpoint?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
};

/** aggregate min on columns */
export type TelephonyproviderMinFields = {
  __typename?: 'TelephonyproviderMinFields';
  createdAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  endpoint?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
};

/** response of any mutation on the table "telephony.provider" */
export type TelephonyproviderMutationResponse = {
  __typename?: 'TelephonyproviderMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Telephonyprovider>;
};

/** input type for inserting object relation for remote table "telephony.provider" */
export type TelephonyproviderObjRelInsertInput = {
  data: TelephonyproviderInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TelephonyproviderOnConflict>;
};

/** on_conflict condition type for table "telephony.provider" */
export type TelephonyproviderOnConflict = {
  constraint: TelephonyproviderConstraint;
  updateColumns?: Array<TelephonyproviderUpdateColumn>;
  where?: InputMaybe<TelephonyproviderBoolExp>;
};

/** Ordering options when selecting data from "telephony.provider". */
export type TelephonyproviderOrderBy = {
  createdAt?: InputMaybe<TelephonyOrderBy>;
  description?: InputMaybe<TelephonyOrderBy>;
  emailAddress?: InputMaybe<TelephonyOrderBy>;
  endpoint?: InputMaybe<TelephonyOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  name?: InputMaybe<TelephonyOrderBy>;
  provider_type?: InputMaybe<TelephonyProviderTypeOrderBy>;
  type?: InputMaybe<TelephonyOrderBy>;
  updatedAt?: InputMaybe<TelephonyOrderBy>;
};

/** primary key columns input for table: telephony.provider */
export type TelephonyproviderPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** Version control on terms accepted by Telephony provider users */
export type TelephonyproviderRequestTerm = {
  __typename?: 'TelephonyproviderRequestTerm';
  createdAt: Scalars['Telephonytimestamptz']['output'];
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  provider?: Maybe<Telephonyprovider>;
  providerId?: Maybe<Scalars['uuid']['output']>;
  terms: Scalars['String']['output'];
  termsversion: Scalars['Int']['output'];
  type: TelephonyProviderTypeEnum;
  updatedAt: Scalars['Telephonytimestamptz']['output'];
  version: Scalars['String']['output'];
};

/** aggregated selection of "telephony.provider_request_terms" */
export type TelephonyproviderRequestTermAggregate = {
  __typename?: 'TelephonyproviderRequestTermAggregate';
  aggregate?: Maybe<TelephonyproviderRequestTermAggregateFields>;
  nodes: Array<TelephonyproviderRequestTerm>;
};

/** aggregate fields of "telephony.provider_request_terms" */
export type TelephonyproviderRequestTermAggregateFields = {
  __typename?: 'TelephonyproviderRequestTermAggregateFields';
  avg?: Maybe<TelephonyproviderRequestTermAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<TelephonyproviderRequestTermMaxFields>;
  min?: Maybe<TelephonyproviderRequestTermMinFields>;
  stddev?: Maybe<TelephonyproviderRequestTermStddevFields>;
  stddevPop?: Maybe<TelephonyproviderRequestTermStddevPopFields>;
  stddevSamp?: Maybe<TelephonyproviderRequestTermStddevSampFields>;
  sum?: Maybe<TelephonyproviderRequestTermSumFields>;
  varPop?: Maybe<TelephonyproviderRequestTermVarPopFields>;
  varSamp?: Maybe<TelephonyproviderRequestTermVarSampFields>;
  variance?: Maybe<TelephonyproviderRequestTermVarianceFields>;
};


/** aggregate fields of "telephony.provider_request_terms" */
export type TelephonyproviderRequestTermAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<TelephonyproviderRequestTermSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type TelephonyproviderRequestTermAvgFields = {
  __typename?: 'TelephonyproviderRequestTermAvgFields';
  termsversion?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "telephony.provider_request_terms". All fields are combined with a logical 'AND'. */
export type TelephonyproviderRequestTermBoolExp = {
  _and?: InputMaybe<Array<TelephonyproviderRequestTermBoolExp>>;
  _not?: InputMaybe<TelephonyproviderRequestTermBoolExp>;
  _or?: InputMaybe<Array<TelephonyproviderRequestTermBoolExp>>;
  createdAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  createdByUserId?: InputMaybe<TaskUuidComparisonExp>;
  id?: InputMaybe<TaskUuidComparisonExp>;
  provider?: InputMaybe<TelephonyproviderBoolExp>;
  providerId?: InputMaybe<TaskUuidComparisonExp>;
  terms?: InputMaybe<TaskStringComparisonExp>;
  termsversion?: InputMaybe<TaskIntComparisonExp>;
  type?: InputMaybe<TelephonyProviderTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TaskTimestamptzComparisonExp>;
  version?: InputMaybe<TaskStringComparisonExp>;
};

/** unique or primary key constraints on table "telephony.provider_request_terms" */
export type TelephonyproviderRequestTermConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'provider_request_terms_pkey'
  /** unique or primary key constraint on columns "provider_id", "version" */
  | 'provider_request_terms_version_provider_id_key'
  | '%future added value';

/** input type for incrementing numeric columns in table "telephony.provider_request_terms" */
export type TelephonyproviderRequestTermIncInput = {
  termsversion?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "telephony.provider_request_terms" */
export type TelephonyproviderRequestTermInsertInput = {
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  provider?: InputMaybe<TelephonyproviderObjRelInsertInput>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  terms?: InputMaybe<Scalars['String']['input']>;
  termsversion?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<TelephonyProviderTypeEnum>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type TelephonyproviderRequestTermMaxFields = {
  __typename?: 'TelephonyproviderRequestTermMaxFields';
  createdAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  providerId?: Maybe<Scalars['uuid']['output']>;
  terms?: Maybe<Scalars['String']['output']>;
  termsversion?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type TelephonyproviderRequestTermMinFields = {
  __typename?: 'TelephonyproviderRequestTermMinFields';
  createdAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  providerId?: Maybe<Scalars['uuid']['output']>;
  terms?: Maybe<Scalars['String']['output']>;
  termsversion?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Telephonytimestamptz']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "telephony.provider_request_terms" */
export type TelephonyproviderRequestTermMutationResponse = {
  __typename?: 'TelephonyproviderRequestTermMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TelephonyproviderRequestTerm>;
};

/** on_conflict condition type for table "telephony.provider_request_terms" */
export type TelephonyproviderRequestTermOnConflict = {
  constraint: TelephonyproviderRequestTermConstraint;
  updateColumns?: Array<TelephonyproviderRequestTermUpdateColumn>;
  where?: InputMaybe<TelephonyproviderRequestTermBoolExp>;
};

/** Ordering options when selecting data from "telephony.provider_request_terms". */
export type TelephonyproviderRequestTermOrderBy = {
  createdAt?: InputMaybe<TelephonyOrderBy>;
  createdByUserId?: InputMaybe<TelephonyOrderBy>;
  id?: InputMaybe<TelephonyOrderBy>;
  provider?: InputMaybe<TelephonyproviderOrderBy>;
  providerId?: InputMaybe<TelephonyOrderBy>;
  terms?: InputMaybe<TelephonyOrderBy>;
  termsversion?: InputMaybe<TelephonyOrderBy>;
  type?: InputMaybe<TelephonyOrderBy>;
  updatedAt?: InputMaybe<TelephonyOrderBy>;
  version?: InputMaybe<TelephonyOrderBy>;
};

/** primary key columns input for table: telephony.provider_request_terms */
export type TelephonyproviderRequestTermPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "telephony.provider_request_terms" */
export type TelephonyproviderRequestTermSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserId'
  /** column name */
  | 'id'
  /** column name */
  | 'providerId'
  /** column name */
  | 'terms'
  /** column name */
  | 'termsversion'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'version'
  | '%future added value';

/** input type for updating data in table "telephony.provider_request_terms" */
export type TelephonyproviderRequestTermSetInput = {
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  terms?: InputMaybe<Scalars['String']['input']>;
  termsversion?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<TelephonyProviderTypeEnum>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type TelephonyproviderRequestTermStddevFields = {
  __typename?: 'TelephonyproviderRequestTermStddevFields';
  termsversion?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type TelephonyproviderRequestTermStddevPopFields = {
  __typename?: 'TelephonyproviderRequestTermStddevPopFields';
  termsversion?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type TelephonyproviderRequestTermStddevSampFields = {
  __typename?: 'TelephonyproviderRequestTermStddevSampFields';
  termsversion?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "providerRequestTerm" */
export type TelephonyproviderRequestTermStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TelephonyproviderRequestTermStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TelephonyCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TelephonyproviderRequestTermStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  providerId?: InputMaybe<Scalars['uuid']['input']>;
  terms?: InputMaybe<Scalars['String']['input']>;
  termsversion?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<TelephonyProviderTypeEnum>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type TelephonyproviderRequestTermSumFields = {
  __typename?: 'TelephonyproviderRequestTermSumFields';
  termsversion?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "telephony.provider_request_terms" */
export type TelephonyproviderRequestTermUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserId'
  /** column name */
  | 'id'
  /** column name */
  | 'providerId'
  /** column name */
  | 'terms'
  /** column name */
  | 'termsversion'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'version'
  | '%future added value';

export type TelephonyproviderRequestTermUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TelephonyproviderRequestTermIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TelephonyproviderRequestTermSetInput>;
  /** filter the rows which have to be updated */
  where: TelephonyproviderRequestTermBoolExp;
};

/** aggregate varPop on columns */
export type TelephonyproviderRequestTermVarPopFields = {
  __typename?: 'TelephonyproviderRequestTermVarPopFields';
  termsversion?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type TelephonyproviderRequestTermVarSampFields = {
  __typename?: 'TelephonyproviderRequestTermVarSampFields';
  termsversion?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type TelephonyproviderRequestTermVarianceFields = {
  __typename?: 'TelephonyproviderRequestTermVarianceFields';
  termsversion?: Maybe<Scalars['Float']['output']>;
};

/** select columns of table "telephony.provider" */
export type TelephonyproviderSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'description'
  /** column name */
  | 'emailAddress'
  /** column name */
  | 'endpoint'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "telephony.provider" */
export type TelephonyproviderSetInput = {
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TelephonyProviderTypeEnum>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** Streaming cursor of the table "provider" */
export type TelephonyproviderStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TelephonyproviderStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<TelephonyCursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TelephonyproviderStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TelephonyProviderTypeEnum>;
  updatedAt?: InputMaybe<Scalars['Telephonytimestamptz']['input']>;
};

/** update columns of table "telephony.provider" */
export type TelephonyproviderUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'description'
  /** column name */
  | 'emailAddress'
  /** column name */
  | 'endpoint'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type TelephonyproviderUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TelephonyproviderSetInput>;
  /** filter the rows which have to be updated */
  where: TelephonyproviderBoolExp;
};

export type TelephonytelephonyEventsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TelephonyTelephonyEventsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TelephonyTelephonyEventsBoolExp>;
  predicate: TaskIntComparisonExp;
};

export type TelephonytriggerTestCallOutput = {
  __typename?: 'TelephonytriggerTestCallOutput';
  callId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type TimestampComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type TimestamptzArrayComparisonExp = {
  /** is the array contained in the given array value */
  _containedIn?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _eq?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _gt?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _gte?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['timestamptz']['input']>>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _lte?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _neq?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['timestamptz']['input']>>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type TimestamptzComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** Boolean expression to compare columns of type "timetz". All fields are combined with logical 'AND'. */
export type TimetzComparisonExp = {
  _eq?: InputMaybe<Scalars['timetz']['input']>;
  _gt?: InputMaybe<Scalars['timetz']['input']>;
  _gte?: InputMaybe<Scalars['timetz']['input']>;
  _in?: InputMaybe<Array<Scalars['timetz']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timetz']['input']>;
  _lte?: InputMaybe<Scalars['timetz']['input']>;
  _neq?: InputMaybe<Scalars['timetz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timetz']['input']>>;
};

export type UserAndOrgInput = {
  companynet?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  licenses?: InputMaybe<Scalars['String']['input']>;
  orgName?: InputMaybe<Scalars['String']['input']>;
  orgNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  price?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<Scalars['String']['input']>;
  termsVersion?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "userDetailsTypeEnum". All fields are combined with logical 'AND'. */
export type UserDetailsTypeEnumComparisonExp = {
  _eq?: InputMaybe<userDetailsTypeEnum>;
  _in?: InputMaybe<Array<userDetailsTypeEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<userDetailsTypeEnum>;
  _nin?: InputMaybe<Array<userDetailsTypeEnum>>;
};

export type UserOrgOutput = {
  __typename?: 'UserOrgOutput';
  orgId: Scalars['uuid']['output'];
  telephonyProviderRequestId?: Maybe<Scalars['uuid']['output']>;
  userId: Scalars['uuid']['output'];
};

/** Boolean expression to compare columns of type "userRoleEnum". All fields are combined with logical 'AND'. */
export type UserRoleEnumComparisonExp = {
  _eq?: InputMaybe<userRoleEnum>;
  _in?: InputMaybe<Array<userRoleEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<userRoleEnum>;
  _nin?: InputMaybe<Array<userRoleEnum>>;
};

export type UserUpdateInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['uuid']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UserUpdateOutput = {
  __typename?: 'UserUpdateOutput';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidComparisonExp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type VerificationOutput = {
  __typename?: 'VerificationOutput';
  id: Scalars['uuid']['output'];
};

/** columns and relationships of "voice_types" */
export type VoiceTypes = {
  __typename?: 'VoiceTypes';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "voice_types" */
export type VoiceTypesAggregate = {
  __typename?: 'VoiceTypesAggregate';
  aggregate?: Maybe<VoiceTypesAggregateFields>;
  nodes: Array<VoiceTypes>;
};

/** aggregate fields of "voice_types" */
export type VoiceTypesAggregateFields = {
  __typename?: 'VoiceTypesAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<VoiceTypesMaxFields>;
  min?: Maybe<VoiceTypesMinFields>;
};


/** aggregate fields of "voice_types" */
export type VoiceTypesAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<VoiceTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "voice_types". All fields are combined with a logical 'AND'. */
export type VoiceTypesBoolExp = {
  _and?: InputMaybe<Array<VoiceTypesBoolExp>>;
  _not?: InputMaybe<VoiceTypesBoolExp>;
  _or?: InputMaybe<Array<VoiceTypesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "voice_types" */
export type VoiceTypesConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'voice_types_pkey'
  | '%future added value';

export type VoiceTypesEnum =
  /** alloy */
  | 'ALLOY'
  /** ash */
  | 'ASH'
  /** ballad */
  | 'BALLAD'
  /** coral */
  | 'CORAL'
  /** echo */
  | 'ECHO'
  /** sage */
  | 'SAGE'
  /** shimmer */
  | 'SHIMMER'
  /** verse */
  | 'VERSE'
  | '%future added value';

/** Boolean expression to compare columns of type "VoiceTypesEnum". All fields are combined with logical 'AND'. */
export type VoiceTypesEnumComparisonExp = {
  _eq?: InputMaybe<VoiceTypesEnum>;
  _in?: InputMaybe<Array<VoiceTypesEnum>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<VoiceTypesEnum>;
  _nin?: InputMaybe<Array<VoiceTypesEnum>>;
};

/** input type for inserting data into table "voice_types" */
export type VoiceTypesInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type VoiceTypesMaxFields = {
  __typename?: 'VoiceTypesMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type VoiceTypesMinFields = {
  __typename?: 'VoiceTypesMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "voice_types" */
export type VoiceTypesMutationResponse = {
  __typename?: 'VoiceTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<VoiceTypes>;
};

/** on_conflict condition type for table "voice_types" */
export type VoiceTypesOnConflict = {
  constraint: VoiceTypesConstraint;
  updateColumns?: Array<VoiceTypesUpdateColumn>;
  where?: InputMaybe<VoiceTypesBoolExp>;
};

/** Ordering options when selecting data from "voice_types". */
export type VoiceTypesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: voice_types */
export type VoiceTypesPkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "voice_types" */
export type VoiceTypesSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "voice_types" */
export type VoiceTypesSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "voice_types" */
export type VoiceTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: VoiceTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VoiceTypesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "voice_types" */
export type VoiceTypesUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type VoiceTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<VoiceTypesSetInput>;
  /** filter the rows which have to be updated */
  where: VoiceTypesBoolExp;
};

export type acceptInviteObject = {
  id: Scalars['String']['input'];
};

export type acceptInviteOutput = {
  __typename?: 'acceptInviteOutput';
  result: Scalars['jsonb']['output'];
};

export type acceptRequestObject = {
  id: Scalars['String']['input'];
};

export type acceptRequestsOutput = {
  __typename?: 'acceptRequestsOutput';
  result: Scalars['jsonb']['output'];
};

/** columns and relationships of "business.queue_item_participant" */
export type activityParticipant = {
  __typename?: 'activityParticipant';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  channel?: Maybe<BusinessQueueItemParticipantChannelTypeEnum>;
  contact?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organizationUser?: Maybe<organizationUser>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  owner?: Maybe<Scalars['Boolean']['output']>;
  queueItemId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  queue_item?: Maybe<queueItem>;
  /** An object relationship */
  queue_item_participant_responsibiliy_type?: Maybe<QueueItemParticipantResponsibilityType>;
  responsibility?: Maybe<QueueItemParticipantResponsibilityTypeEnum>;
  responsible?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "business.queue_item_participant" */
export type activityParticipantAggregate = {
  __typename?: 'activityParticipantAggregate';
  aggregate?: Maybe<activityParticipantAggregateFields>;
  nodes: Array<activityParticipant>;
};

export type activityParticipantAggregateBoolExp = {
  bool_and?: InputMaybe<activityParticipantAggregateBoolExpBool_and>;
  bool_or?: InputMaybe<activityParticipantAggregateBoolExpBool_or>;
  count?: InputMaybe<activityParticipantAggregateBoolExpCount>;
};

export type activityParticipantAggregateBoolExpBool_and = {
  arguments: activityParticipantSelectColumnActivityParticipantAggregateBoolExpBool_andArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<activityParticipantBoolExp>;
  predicate: BooleanComparisonExp;
};

export type activityParticipantAggregateBoolExpBool_or = {
  arguments: activityParticipantSelectColumnActivityParticipantAggregateBoolExpBool_orArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<activityParticipantBoolExp>;
  predicate: BooleanComparisonExp;
};

export type activityParticipantAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<activityParticipantSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<activityParticipantBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "business.queue_item_participant" */
export type activityParticipantAggregateFields = {
  __typename?: 'activityParticipantAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<activityParticipantMaxFields>;
  min?: Maybe<activityParticipantMinFields>;
};


/** aggregate fields of "business.queue_item_participant" */
export type activityParticipantAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<activityParticipantSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.queue_item_participant" */
export type activityParticipantAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<activityParticipantMaxOrderBy>;
  min?: InputMaybe<activityParticipantMinOrderBy>;
};

/** input type for inserting array relation for remote table "business.queue_item_participant" */
export type activityParticipantArrRelInsertInput = {
  data: Array<activityParticipantInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<activityParticipantOnConflict>;
};

/** Boolean expression to filter rows from the table "business.queue_item_participant". All fields are combined with a logical 'AND'. */
export type activityParticipantBoolExp = {
  _and?: InputMaybe<Array<activityParticipantBoolExp>>;
  _not?: InputMaybe<activityParticipantBoolExp>;
  _or?: InputMaybe<Array<activityParticipantBoolExp>>;
  accepted?: InputMaybe<BooleanComparisonExp>;
  channel?: InputMaybe<BusinessQueueItemParticipantChannelTypeEnumComparisonExp>;
  contact?: InputMaybe<BooleanComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organizationUser?: InputMaybe<organizationUserBoolExp>;
  organizationUserId?: InputMaybe<UuidComparisonExp>;
  owner?: InputMaybe<BooleanComparisonExp>;
  queueItemId?: InputMaybe<UuidComparisonExp>;
  queue_item?: InputMaybe<queueItemBoolExp>;
  queue_item_participant_responsibiliy_type?: InputMaybe<QueueItemParticipantResponsibilityTypeBoolExp>;
  responsibility?: InputMaybe<QueueItemParticipantResponsibilityTypeEnumComparisonExp>;
  responsible?: InputMaybe<BooleanComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "business.queue_item_participant" */
export type activityParticipantConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'activity_participant_pkey1'
  /** unique or primary key constraint on columns "organization_user_id", "queue_item_id" */
  | 'queue_item_participant_queue_item_id_organization_user_id_key'
  | '%future added value';

/** input type for inserting data into table "business.queue_item_participant" */
export type activityParticipantInsertInput = {
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  channel?: InputMaybe<BusinessQueueItemParticipantChannelTypeEnum>;
  contact?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationUser?: InputMaybe<organizationUserObjRelInsertInput>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  owner?: InputMaybe<Scalars['Boolean']['input']>;
  queueItemId?: InputMaybe<Scalars['uuid']['input']>;
  queue_item?: InputMaybe<queueItemObjRelInsertInput>;
  queue_item_participant_responsibiliy_type?: InputMaybe<QueueItemParticipantResponsibilityTypeObjRelInsertInput>;
  responsibility?: InputMaybe<QueueItemParticipantResponsibilityTypeEnum>;
  responsible?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type activityParticipantMaxFields = {
  __typename?: 'activityParticipantMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  queueItemId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "business.queue_item_participant" */
export type activityParticipantMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  queueItemId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type activityParticipantMinFields = {
  __typename?: 'activityParticipantMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  queueItemId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "business.queue_item_participant" */
export type activityParticipantMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  queueItemId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "business.queue_item_participant" */
export type activityParticipantMutationResponse = {
  __typename?: 'activityParticipantMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<activityParticipant>;
};

/** on_conflict condition type for table "business.queue_item_participant" */
export type activityParticipantOnConflict = {
  constraint: activityParticipantConstraint;
  updateColumns?: Array<activityParticipantUpdateColumn>;
  where?: InputMaybe<activityParticipantBoolExp>;
};

/** Ordering options when selecting data from "business.queue_item_participant". */
export type activityParticipantOrderBy = {
  accepted?: InputMaybe<OrderBy>;
  channel?: InputMaybe<OrderBy>;
  contact?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organizationUser?: InputMaybe<organizationUserOrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  owner?: InputMaybe<OrderBy>;
  queueItemId?: InputMaybe<OrderBy>;
  queue_item?: InputMaybe<queueItemOrderBy>;
  queue_item_participant_responsibiliy_type?: InputMaybe<QueueItemParticipantResponsibilityTypeOrderBy>;
  responsibility?: InputMaybe<OrderBy>;
  responsible?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.queue_item_participant */
export type activityParticipantPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "business.queue_item_participant" */
export type activityParticipantSelectColumn =
  /** column name */
  | 'accepted'
  /** column name */
  | 'channel'
  /** column name */
  | 'contact'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'owner'
  /** column name */
  | 'queueItemId'
  /** column name */
  | 'responsibility'
  /** column name */
  | 'responsible'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** select "activityParticipantAggregateBoolExpBool_andArgumentsColumns" columns of table "business.queue_item_participant" */
export type activityParticipantSelectColumnActivityParticipantAggregateBoolExpBool_andArgumentsColumns =
  /** column name */
  | 'accepted'
  /** column name */
  | 'contact'
  /** column name */
  | 'owner'
  /** column name */
  | 'responsible'
  | '%future added value';

/** select "activityParticipantAggregateBoolExpBool_orArgumentsColumns" columns of table "business.queue_item_participant" */
export type activityParticipantSelectColumnActivityParticipantAggregateBoolExpBool_orArgumentsColumns =
  /** column name */
  | 'accepted'
  /** column name */
  | 'contact'
  /** column name */
  | 'owner'
  /** column name */
  | 'responsible'
  | '%future added value';

/** input type for updating data in table "business.queue_item_participant" */
export type activityParticipantSetInput = {
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  channel?: InputMaybe<BusinessQueueItemParticipantChannelTypeEnum>;
  contact?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  owner?: InputMaybe<Scalars['Boolean']['input']>;
  queueItemId?: InputMaybe<Scalars['uuid']['input']>;
  responsibility?: InputMaybe<QueueItemParticipantResponsibilityTypeEnum>;
  responsible?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "activityParticipant" */
export type activityParticipantStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: activityParticipantStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type activityParticipantStreamCursorValueInput = {
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  channel?: InputMaybe<BusinessQueueItemParticipantChannelTypeEnum>;
  contact?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  owner?: InputMaybe<Scalars['Boolean']['input']>;
  queueItemId?: InputMaybe<Scalars['uuid']['input']>;
  responsibility?: InputMaybe<QueueItemParticipantResponsibilityTypeEnum>;
  responsible?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "business.queue_item_participant" */
export type activityParticipantUpdateColumn =
  /** column name */
  | 'accepted'
  /** column name */
  | 'channel'
  /** column name */
  | 'contact'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'owner'
  /** column name */
  | 'queueItemId'
  /** column name */
  | 'responsibility'
  /** column name */
  | 'responsible'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type activityParticipantUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<activityParticipantSetInput>;
  /** filter the rows which have to be updated */
  where: activityParticipantBoolExp;
};

export type activityTaskInput = {
  additionalData?: InputMaybe<Scalars['jsonb']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  taskType?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  toUserId?: InputMaybe<Scalars['uuid']['input']>;
};

export type activityTaskOutput = {
  __typename?: 'activityTaskOutput';
  result?: Maybe<Scalars['json']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "business.address" */
export type address = {
  __typename?: 'address';
  city: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  lat?: Maybe<Scalars['String']['output']>;
  long?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization?: Maybe<organization>;
  organizationBusinessAddress?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organizationUser?: Maybe<organizationUser>;
  organizationUserAddress?: Maybe<Scalars['uuid']['output']>;
  street: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

/** aggregated selection of "business.address" */
export type addressAggregate = {
  __typename?: 'addressAggregate';
  aggregate?: Maybe<addressAggregateFields>;
  nodes: Array<address>;
};

export type addressAggregateBoolExp = {
  count?: InputMaybe<addressAggregateBoolExpCount>;
};

export type addressAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<addressSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<addressBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "business.address" */
export type addressAggregateFields = {
  __typename?: 'addressAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<addressMaxFields>;
  min?: Maybe<addressMinFields>;
};


/** aggregate fields of "business.address" */
export type addressAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<addressSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.address" */
export type addressAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<addressMaxOrderBy>;
  min?: InputMaybe<addressMinOrderBy>;
};

/** input type for inserting array relation for remote table "business.address" */
export type addressArrRelInsertInput = {
  data: Array<addressInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<addressOnConflict>;
};

/** Boolean expression to filter rows from the table "business.address". All fields are combined with a logical 'AND'. */
export type addressBoolExp = {
  _and?: InputMaybe<Array<addressBoolExp>>;
  _not?: InputMaybe<addressBoolExp>;
  _or?: InputMaybe<Array<addressBoolExp>>;
  city?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lat?: InputMaybe<StringComparisonExp>;
  long?: InputMaybe<StringComparisonExp>;
  organization?: InputMaybe<organizationBoolExp>;
  organizationBusinessAddress?: InputMaybe<UuidComparisonExp>;
  organizationUser?: InputMaybe<organizationUserBoolExp>;
  organizationUserAddress?: InputMaybe<UuidComparisonExp>;
  street?: InputMaybe<StringComparisonExp>;
  zip?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.address" */
export type addressConstraint =
  /** unique or primary key constraint on columns "organization_business_address" */
  | 'address_organization_business_address_key'
  /** unique or primary key constraint on columns "id" */
  | 'address_pkey'
  /** unique or primary key constraint on columns "organization_business_address", "zip", "city", "street" */
  | 'address_zip_city_street_organization_business_address_key'
  /** unique or primary key constraint on columns "organization_user_address", "zip", "city", "street" */
  | 'address_zip_city_street_organization_user_address_key'
  | '%future added value';

/** input type for inserting data into table "business.address" */
export type addressInsertInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  long?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<organizationObjRelInsertInput>;
  organizationBusinessAddress?: InputMaybe<Scalars['uuid']['input']>;
  organizationUser?: InputMaybe<organizationUserObjRelInsertInput>;
  organizationUserAddress?: InputMaybe<Scalars['uuid']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type addressMaxFields = {
  __typename?: 'addressMaxFields';
  city?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lat?: Maybe<Scalars['String']['output']>;
  long?: Maybe<Scalars['String']['output']>;
  organizationBusinessAddress?: Maybe<Scalars['uuid']['output']>;
  organizationUserAddress?: Maybe<Scalars['uuid']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "business.address" */
export type addressMaxOrderBy = {
  city?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lat?: InputMaybe<OrderBy>;
  long?: InputMaybe<OrderBy>;
  organizationBusinessAddress?: InputMaybe<OrderBy>;
  organizationUserAddress?: InputMaybe<OrderBy>;
  street?: InputMaybe<OrderBy>;
  zip?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type addressMinFields = {
  __typename?: 'addressMinFields';
  city?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lat?: Maybe<Scalars['String']['output']>;
  long?: Maybe<Scalars['String']['output']>;
  organizationBusinessAddress?: Maybe<Scalars['uuid']['output']>;
  organizationUserAddress?: Maybe<Scalars['uuid']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "business.address" */
export type addressMinOrderBy = {
  city?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lat?: InputMaybe<OrderBy>;
  long?: InputMaybe<OrderBy>;
  organizationBusinessAddress?: InputMaybe<OrderBy>;
  organizationUserAddress?: InputMaybe<OrderBy>;
  street?: InputMaybe<OrderBy>;
  zip?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "business.address" */
export type addressMutationResponse = {
  __typename?: 'addressMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<address>;
};

/** input type for inserting object relation for remote table "business.address" */
export type addressObjRelInsertInput = {
  data: addressInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<addressOnConflict>;
};

/** on_conflict condition type for table "business.address" */
export type addressOnConflict = {
  constraint: addressConstraint;
  updateColumns?: Array<addressUpdateColumn>;
  where?: InputMaybe<addressBoolExp>;
};

/** Ordering options when selecting data from "business.address". */
export type addressOrderBy = {
  city?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lat?: InputMaybe<OrderBy>;
  long?: InputMaybe<OrderBy>;
  organization?: InputMaybe<organizationOrderBy>;
  organizationBusinessAddress?: InputMaybe<OrderBy>;
  organizationUser?: InputMaybe<organizationUserOrderBy>;
  organizationUserAddress?: InputMaybe<OrderBy>;
  street?: InputMaybe<OrderBy>;
  zip?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.address */
export type addressPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "business.address" */
export type addressSelectColumn =
  /** column name */
  | 'city'
  /** column name */
  | 'id'
  /** column name */
  | 'lat'
  /** column name */
  | 'long'
  /** column name */
  | 'organizationBusinessAddress'
  /** column name */
  | 'organizationUserAddress'
  /** column name */
  | 'street'
  /** column name */
  | 'zip'
  | '%future added value';

/** input type for updating data in table "business.address" */
export type addressSetInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  long?: InputMaybe<Scalars['String']['input']>;
  organizationBusinessAddress?: InputMaybe<Scalars['uuid']['input']>;
  organizationUserAddress?: InputMaybe<Scalars['uuid']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "address" */
export type addressStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: addressStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type addressStreamCursorValueInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  long?: InputMaybe<Scalars['String']['input']>;
  organizationBusinessAddress?: InputMaybe<Scalars['uuid']['input']>;
  organizationUserAddress?: InputMaybe<Scalars['uuid']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.address" */
export type addressUpdateColumn =
  /** column name */
  | 'city'
  /** column name */
  | 'id'
  /** column name */
  | 'lat'
  /** column name */
  | 'long'
  /** column name */
  | 'organizationBusinessAddress'
  /** column name */
  | 'organizationUserAddress'
  /** column name */
  | 'street'
  /** column name */
  | 'zip'
  | '%future added value';

export type addressUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<addressSetInput>;
  /** filter the rows which have to be updated */
  where: addressBoolExp;
};

/** columns and relationships of "business.blocked_domain_user" */
export type blockedDomainUser = {
  __typename?: 'blockedDomainUser';
  blockedBydomainUserId: Scalars['uuid']['output'];
  /** An object relationship */
  blockedDomainUser?: Maybe<domainUser>;
  blockedDomainUserId?: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  domainUser: domainUser;
  id: Scalars['uuid']['output'];
  lightlyBlocked?: Maybe<Scalars['Boolean']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "business.blocked_domain_user" */
export type blockedDomainUserAggregate = {
  __typename?: 'blockedDomainUserAggregate';
  aggregate?: Maybe<blockedDomainUserAggregateFields>;
  nodes: Array<blockedDomainUser>;
};

/** aggregate fields of "business.blocked_domain_user" */
export type blockedDomainUserAggregateFields = {
  __typename?: 'blockedDomainUserAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<blockedDomainUserMaxFields>;
  min?: Maybe<blockedDomainUserMinFields>;
};


/** aggregate fields of "business.blocked_domain_user" */
export type blockedDomainUserAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<blockedDomainUserSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.blocked_domain_user". All fields are combined with a logical 'AND'. */
export type blockedDomainUserBoolExp = {
  _and?: InputMaybe<Array<blockedDomainUserBoolExp>>;
  _not?: InputMaybe<blockedDomainUserBoolExp>;
  _or?: InputMaybe<Array<blockedDomainUserBoolExp>>;
  blockedBydomainUserId?: InputMaybe<UuidComparisonExp>;
  blockedDomainUser?: InputMaybe<domainUserBoolExp>;
  blockedDomainUserId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  domainUser?: InputMaybe<domainUserBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lightlyBlocked?: InputMaybe<BooleanComparisonExp>;
  organizationId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "business.blocked_domain_user" */
export type blockedDomainUserConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'blocked_domain_user_pkey'
  | '%future added value';

/** input type for inserting data into table "business.blocked_domain_user" */
export type blockedDomainUserInsertInput = {
  blockedBydomainUserId?: InputMaybe<Scalars['uuid']['input']>;
  blockedDomainUser?: InputMaybe<domainUserObjRelInsertInput>;
  blockedDomainUserId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  domainUser?: InputMaybe<domainUserObjRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lightlyBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type blockedDomainUserMaxFields = {
  __typename?: 'blockedDomainUserMaxFields';
  blockedBydomainUserId?: Maybe<Scalars['uuid']['output']>;
  blockedDomainUserId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type blockedDomainUserMinFields = {
  __typename?: 'blockedDomainUserMinFields';
  blockedBydomainUserId?: Maybe<Scalars['uuid']['output']>;
  blockedDomainUserId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "business.blocked_domain_user" */
export type blockedDomainUserMutationResponse = {
  __typename?: 'blockedDomainUserMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<blockedDomainUser>;
};

/** on_conflict condition type for table "business.blocked_domain_user" */
export type blockedDomainUserOnConflict = {
  constraint: blockedDomainUserConstraint;
  updateColumns?: Array<blockedDomainUserUpdateColumn>;
  where?: InputMaybe<blockedDomainUserBoolExp>;
};

/** Ordering options when selecting data from "business.blocked_domain_user". */
export type blockedDomainUserOrderBy = {
  blockedBydomainUserId?: InputMaybe<OrderBy>;
  blockedDomainUser?: InputMaybe<domainUserOrderBy>;
  blockedDomainUserId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  domainUser?: InputMaybe<domainUserOrderBy>;
  id?: InputMaybe<OrderBy>;
  lightlyBlocked?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.blocked_domain_user */
export type blockedDomainUserPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "business.blocked_domain_user" */
export type blockedDomainUserSelectColumn =
  /** column name */
  | 'blockedBydomainUserId'
  /** column name */
  | 'blockedDomainUserId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'lightlyBlocked'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "business.blocked_domain_user" */
export type blockedDomainUserSetInput = {
  blockedBydomainUserId?: InputMaybe<Scalars['uuid']['input']>;
  blockedDomainUserId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lightlyBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "blockedDomainUser" */
export type blockedDomainUserStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: blockedDomainUserStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type blockedDomainUserStreamCursorValueInput = {
  blockedBydomainUserId?: InputMaybe<Scalars['uuid']['input']>;
  blockedDomainUserId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lightlyBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "business.blocked_domain_user" */
export type blockedDomainUserUpdateColumn =
  /** column name */
  | 'blockedBydomainUserId'
  /** column name */
  | 'blockedDomainUserId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'lightlyBlocked'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type blockedDomainUserUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<blockedDomainUserSetInput>;
  /** filter the rows which have to be updated */
  where: blockedDomainUserBoolExp;
};

export type bregmutation_root = {
  __typename?: 'bregmutation_root';
  /** delete data from the table: "code" */
  deleteCode?: Maybe<RegistryCodeMutationResponse>;
  /** delete single row from the table: "code" */
  deleteCodeByPk?: Maybe<RegistryCode>;
  /** delete data from the table: "info" */
  deleteInfo?: Maybe<RegistryInfoMutationResponse>;
  /** delete single row from the table: "info" */
  deleteInfoByPk?: Maybe<RegistryInfo>;
  /** delete data from the table: "organisasjonsform" */
  deleteOrganisasjonsform?: Maybe<RegistryOrganisasjonsformMutationResponse>;
  /** delete single row from the table: "organisasjonsform" */
  deleteOrganisasjonsformByPk?: Maybe<RegistryOrganisasjonsform>;
  /** delete data from the table: "organization" */
  deleteOrganization?: Maybe<RegistryOrganizationMutationResponse>;
  /** delete single row from the table: "organization" */
  deleteOrganizationByPk?: Maybe<RegistryOrganization>;
  /** delete data from the table: "postadresse" */
  deletePostadresse?: Maybe<RegistryPostadresseMutationResponse>;
  /** delete single row from the table: "postadresse" */
  deletePostadresseByPk?: Maybe<RegistryPostadresse>;
  /** insert data into the table: "code" */
  insertCode?: Maybe<RegistryCodeMutationResponse>;
  /** insert a single row into the table: "code" */
  insertCodeOne?: Maybe<RegistryCode>;
  /** insert data into the table: "info" */
  insertInfo?: Maybe<RegistryInfoMutationResponse>;
  /** insert a single row into the table: "info" */
  insertInfoOne?: Maybe<RegistryInfo>;
  /** insert data into the table: "organisasjonsform" */
  insertOrganisasjonsform?: Maybe<RegistryOrganisasjonsformMutationResponse>;
  /** insert a single row into the table: "organisasjonsform" */
  insertOrganisasjonsformOne?: Maybe<RegistryOrganisasjonsform>;
  /** insert data into the table: "organization" */
  insertOrganization?: Maybe<RegistryOrganizationMutationResponse>;
  /** insert a single row into the table: "organization" */
  insertOrganizationOne?: Maybe<RegistryOrganization>;
  /** insert data into the table: "postadresse" */
  insertPostadresse?: Maybe<RegistryPostadresseMutationResponse>;
  /** insert a single row into the table: "postadresse" */
  insertPostadresseOne?: Maybe<RegistryPostadresse>;
  /** update data of the table: "code" */
  updateCode?: Maybe<RegistryCodeMutationResponse>;
  /** update single row of the table: "code" */
  updateCodeByPk?: Maybe<RegistryCode>;
  /** update multiples rows of table: "code" */
  updateCodeMany?: Maybe<Array<Maybe<RegistryCodeMutationResponse>>>;
  /** update data of the table: "info" */
  updateInfo?: Maybe<RegistryInfoMutationResponse>;
  /** update single row of the table: "info" */
  updateInfoByPk?: Maybe<RegistryInfo>;
  /** update multiples rows of table: "info" */
  updateInfoMany?: Maybe<Array<Maybe<RegistryInfoMutationResponse>>>;
  /** update data of the table: "organisasjonsform" */
  updateOrganisasjonsform?: Maybe<RegistryOrganisasjonsformMutationResponse>;
  /** update single row of the table: "organisasjonsform" */
  updateOrganisasjonsformByPk?: Maybe<RegistryOrganisasjonsform>;
  /** update multiples rows of table: "organisasjonsform" */
  updateOrganisasjonsformMany?: Maybe<Array<Maybe<RegistryOrganisasjonsformMutationResponse>>>;
  /** update data of the table: "organization" */
  updateOrganization?: Maybe<RegistryOrganizationMutationResponse>;
  /** update single row of the table: "organization" */
  updateOrganizationByPk?: Maybe<RegistryOrganization>;
  /** update multiples rows of table: "organization" */
  updateOrganizationMany?: Maybe<Array<Maybe<RegistryOrganizationMutationResponse>>>;
  /** update data of the table: "postadresse" */
  updatePostadresse?: Maybe<RegistryPostadresseMutationResponse>;
  /** update single row of the table: "postadresse" */
  updatePostadresseByPk?: Maybe<RegistryPostadresse>;
  /** update multiples rows of table: "postadresse" */
  updatePostadresseMany?: Maybe<Array<Maybe<RegistryPostadresseMutationResponse>>>;
};


export type bregmutation_rootdeleteCodeArgs = {
  where: RegistryCodeBoolExp;
};


export type bregmutation_rootdeleteCodeByPkArgs = {
  id: Scalars['Registryuuid']['input'];
};


export type bregmutation_rootdeleteInfoArgs = {
  where: RegistryInfoBoolExp;
};


export type bregmutation_rootdeleteInfoByPkArgs = {
  id: Scalars['Registryuuid']['input'];
};


export type bregmutation_rootdeleteOrganisasjonsformArgs = {
  where: RegistryOrganisasjonsformBoolExp;
};


export type bregmutation_rootdeleteOrganisasjonsformByPkArgs = {
  id: Scalars['Registryuuid']['input'];
};


export type bregmutation_rootdeleteOrganizationArgs = {
  where: RegistryOrganizationBoolExp;
};


export type bregmutation_rootdeleteOrganizationByPkArgs = {
  id: Scalars['Registryuuid']['input'];
};


export type bregmutation_rootdeletePostadresseArgs = {
  where: RegistryPostadresseBoolExp;
};


export type bregmutation_rootdeletePostadresseByPkArgs = {
  id: Scalars['Registryuuid']['input'];
};


export type bregmutation_rootinsertCodeArgs = {
  objects: Array<RegistryCodeInsertInput>;
  onConflict?: InputMaybe<RegistryCodeOnConflict>;
};


export type bregmutation_rootinsertCodeOneArgs = {
  object: RegistryCodeInsertInput;
  onConflict?: InputMaybe<RegistryCodeOnConflict>;
};


export type bregmutation_rootinsertInfoArgs = {
  objects: Array<RegistryInfoInsertInput>;
  onConflict?: InputMaybe<RegistryInfoOnConflict>;
};


export type bregmutation_rootinsertInfoOneArgs = {
  object: RegistryInfoInsertInput;
  onConflict?: InputMaybe<RegistryInfoOnConflict>;
};


export type bregmutation_rootinsertOrganisasjonsformArgs = {
  objects: Array<RegistryOrganisasjonsformInsertInput>;
  onConflict?: InputMaybe<RegistryOrganisasjonsformOnConflict>;
};


export type bregmutation_rootinsertOrganisasjonsformOneArgs = {
  object: RegistryOrganisasjonsformInsertInput;
  onConflict?: InputMaybe<RegistryOrganisasjonsformOnConflict>;
};


export type bregmutation_rootinsertOrganizationArgs = {
  objects: Array<RegistryOrganizationInsertInput>;
  onConflict?: InputMaybe<RegistryOrganizationOnConflict>;
};


export type bregmutation_rootinsertOrganizationOneArgs = {
  object: RegistryOrganizationInsertInput;
  onConflict?: InputMaybe<RegistryOrganizationOnConflict>;
};


export type bregmutation_rootinsertPostadresseArgs = {
  objects: Array<RegistryPostadresseInsertInput>;
  onConflict?: InputMaybe<RegistryPostadresseOnConflict>;
};


export type bregmutation_rootinsertPostadresseOneArgs = {
  object: RegistryPostadresseInsertInput;
  onConflict?: InputMaybe<RegistryPostadresseOnConflict>;
};


export type bregmutation_rootupdateCodeArgs = {
  _set?: InputMaybe<RegistryCodeSetInput>;
  where: RegistryCodeBoolExp;
};


export type bregmutation_rootupdateCodeByPkArgs = {
  _set?: InputMaybe<RegistryCodeSetInput>;
  pkColumns: RegistryCodePkColumnsInput;
};


export type bregmutation_rootupdateCodeManyArgs = {
  updates: Array<RegistryCodeUpdates>;
};


export type bregmutation_rootupdateInfoArgs = {
  _set?: InputMaybe<RegistryInfoSetInput>;
  where: RegistryInfoBoolExp;
};


export type bregmutation_rootupdateInfoByPkArgs = {
  _set?: InputMaybe<RegistryInfoSetInput>;
  pkColumns: RegistryInfoPkColumnsInput;
};


export type bregmutation_rootupdateInfoManyArgs = {
  updates: Array<RegistryInfoUpdates>;
};


export type bregmutation_rootupdateOrganisasjonsformArgs = {
  _append?: InputMaybe<RegistryOrganisasjonsformAppendInput>;
  _deleteAtPath?: InputMaybe<RegistryOrganisasjonsformDeleteAtPathInput>;
  _deleteElem?: InputMaybe<RegistryOrganisasjonsformDeleteElemInput>;
  _deleteKey?: InputMaybe<RegistryOrganisasjonsformDeleteKeyInput>;
  _prepend?: InputMaybe<RegistryOrganisasjonsformPrependInput>;
  _set?: InputMaybe<RegistryOrganisasjonsformSetInput>;
  where: RegistryOrganisasjonsformBoolExp;
};


export type bregmutation_rootupdateOrganisasjonsformByPkArgs = {
  _append?: InputMaybe<RegistryOrganisasjonsformAppendInput>;
  _deleteAtPath?: InputMaybe<RegistryOrganisasjonsformDeleteAtPathInput>;
  _deleteElem?: InputMaybe<RegistryOrganisasjonsformDeleteElemInput>;
  _deleteKey?: InputMaybe<RegistryOrganisasjonsformDeleteKeyInput>;
  _prepend?: InputMaybe<RegistryOrganisasjonsformPrependInput>;
  _set?: InputMaybe<RegistryOrganisasjonsformSetInput>;
  pkColumns: RegistryOrganisasjonsformPkColumnsInput;
};


export type bregmutation_rootupdateOrganisasjonsformManyArgs = {
  updates: Array<RegistryOrganisasjonsformUpdates>;
};


export type bregmutation_rootupdateOrganizationArgs = {
  _append?: InputMaybe<RegistryOrganizationAppendInput>;
  _deleteAtPath?: InputMaybe<RegistryOrganizationDeleteAtPathInput>;
  _deleteElem?: InputMaybe<RegistryOrganizationDeleteElemInput>;
  _deleteKey?: InputMaybe<RegistryOrganizationDeleteKeyInput>;
  _inc?: InputMaybe<RegistryOrganizationIncInput>;
  _prepend?: InputMaybe<RegistryOrganizationPrependInput>;
  _set?: InputMaybe<RegistryOrganizationSetInput>;
  where: RegistryOrganizationBoolExp;
};


export type bregmutation_rootupdateOrganizationByPkArgs = {
  _append?: InputMaybe<RegistryOrganizationAppendInput>;
  _deleteAtPath?: InputMaybe<RegistryOrganizationDeleteAtPathInput>;
  _deleteElem?: InputMaybe<RegistryOrganizationDeleteElemInput>;
  _deleteKey?: InputMaybe<RegistryOrganizationDeleteKeyInput>;
  _inc?: InputMaybe<RegistryOrganizationIncInput>;
  _prepend?: InputMaybe<RegistryOrganizationPrependInput>;
  _set?: InputMaybe<RegistryOrganizationSetInput>;
  pkColumns: RegistryOrganizationPkColumnsInput;
};


export type bregmutation_rootupdateOrganizationManyArgs = {
  updates: Array<RegistryOrganizationUpdates>;
};


export type bregmutation_rootupdatePostadresseArgs = {
  _append?: InputMaybe<RegistryPostadresseAppendInput>;
  _deleteAtPath?: InputMaybe<RegistryPostadresseDeleteAtPathInput>;
  _deleteElem?: InputMaybe<RegistryPostadresseDeleteElemInput>;
  _deleteKey?: InputMaybe<RegistryPostadresseDeleteKeyInput>;
  _prepend?: InputMaybe<RegistryPostadressePrependInput>;
  _set?: InputMaybe<RegistryPostadresseSetInput>;
  where: RegistryPostadresseBoolExp;
};


export type bregmutation_rootupdatePostadresseByPkArgs = {
  _append?: InputMaybe<RegistryPostadresseAppendInput>;
  _deleteAtPath?: InputMaybe<RegistryPostadresseDeleteAtPathInput>;
  _deleteElem?: InputMaybe<RegistryPostadresseDeleteElemInput>;
  _deleteKey?: InputMaybe<RegistryPostadresseDeleteKeyInput>;
  _prepend?: InputMaybe<RegistryPostadressePrependInput>;
  _set?: InputMaybe<RegistryPostadresseSetInput>;
  pkColumns: RegistryPostadressePkColumnsInput;
};


export type bregmutation_rootupdatePostadresseManyArgs = {
  updates: Array<RegistryPostadresseUpdates>;
};

export type bregquery_root = {
  __typename?: 'bregquery_root';
  /** fetch data from the table: "code" */
  code: Array<RegistryCode>;
  /** fetch aggregated fields from the table: "code" */
  codeAggregate: RegistryCodeAggregate;
  /** fetch data from the table: "code" using primary key columns */
  codeByPk?: Maybe<RegistryCode>;
  /** fetch data from the table: "info" */
  info: Array<RegistryInfo>;
  /** fetch aggregated fields from the table: "info" */
  infoAggregate: RegistryInfoAggregate;
  /** fetch data from the table: "info" using primary key columns */
  infoByPk?: Maybe<RegistryInfo>;
  /** fetch data from the table: "organisasjonsform" */
  organisasjonsform: Array<RegistryOrganisasjonsform>;
  /** fetch aggregated fields from the table: "organisasjonsform" */
  organisasjonsformAggregate: RegistryOrganisasjonsformAggregate;
  /** fetch data from the table: "organisasjonsform" using primary key columns */
  organisasjonsformByPk?: Maybe<RegistryOrganisasjonsform>;
  /** fetch data from the table: "organization" */
  organization: Array<RegistryOrganization>;
  /** fetch aggregated fields from the table: "organization" */
  organizationAggregate: RegistryOrganizationAggregate;
  /** fetch data from the table: "organization" using primary key columns */
  organizationByPk?: Maybe<RegistryOrganization>;
  /** fetch data from the table: "postadresse" */
  postadresse: Array<RegistryPostadresse>;
  /** fetch aggregated fields from the table: "postadresse" */
  postadresseAggregate: RegistryPostadresseAggregate;
  /** fetch data from the table: "postadresse" using primary key columns */
  postadresseByPk?: Maybe<RegistryPostadresse>;
};


export type bregquery_rootcodeArgs = {
  distinctOn?: InputMaybe<Array<RegistryCodeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegistryCodeOrderBy>>;
  where?: InputMaybe<RegistryCodeBoolExp>;
};


export type bregquery_rootcodeAggregateArgs = {
  distinctOn?: InputMaybe<Array<RegistryCodeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegistryCodeOrderBy>>;
  where?: InputMaybe<RegistryCodeBoolExp>;
};


export type bregquery_rootcodeByPkArgs = {
  id: Scalars['Registryuuid']['input'];
};


export type bregquery_rootinfoArgs = {
  distinctOn?: InputMaybe<Array<RegistryInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegistryInfoOrderBy>>;
  where?: InputMaybe<RegistryInfoBoolExp>;
};


export type bregquery_rootinfoAggregateArgs = {
  distinctOn?: InputMaybe<Array<RegistryInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegistryInfoOrderBy>>;
  where?: InputMaybe<RegistryInfoBoolExp>;
};


export type bregquery_rootinfoByPkArgs = {
  id: Scalars['Registryuuid']['input'];
};


export type bregquery_rootorganisasjonsformArgs = {
  distinctOn?: InputMaybe<Array<RegistryOrganisasjonsformSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegistryOrganisasjonsformOrderBy>>;
  where?: InputMaybe<RegistryOrganisasjonsformBoolExp>;
};


export type bregquery_rootorganisasjonsformAggregateArgs = {
  distinctOn?: InputMaybe<Array<RegistryOrganisasjonsformSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegistryOrganisasjonsformOrderBy>>;
  where?: InputMaybe<RegistryOrganisasjonsformBoolExp>;
};


export type bregquery_rootorganisasjonsformByPkArgs = {
  id: Scalars['Registryuuid']['input'];
};


export type bregquery_rootorganizationArgs = {
  distinctOn?: InputMaybe<Array<RegistryOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegistryOrganizationOrderBy>>;
  where?: InputMaybe<RegistryOrganizationBoolExp>;
};


export type bregquery_rootorganizationAggregateArgs = {
  distinctOn?: InputMaybe<Array<RegistryOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegistryOrganizationOrderBy>>;
  where?: InputMaybe<RegistryOrganizationBoolExp>;
};


export type bregquery_rootorganizationByPkArgs = {
  id: Scalars['Registryuuid']['input'];
};


export type bregquery_rootpostadresseArgs = {
  distinctOn?: InputMaybe<Array<RegistryPostadresseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegistryPostadresseOrderBy>>;
  where?: InputMaybe<RegistryPostadresseBoolExp>;
};


export type bregquery_rootpostadresseAggregateArgs = {
  distinctOn?: InputMaybe<Array<RegistryPostadresseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegistryPostadresseOrderBy>>;
  where?: InputMaybe<RegistryPostadresseBoolExp>;
};


export type bregquery_rootpostadresseByPkArgs = {
  id: Scalars['Registryuuid']['input'];
};

export type bregsubscription_root = {
  __typename?: 'bregsubscription_root';
  /** fetch data from the table: "code" */
  code: Array<RegistryCode>;
  /** fetch aggregated fields from the table: "code" */
  codeAggregate: RegistryCodeAggregate;
  /** fetch data from the table: "code" using primary key columns */
  codeByPk?: Maybe<RegistryCode>;
  /** fetch data from the table in a streaming manner: "code" */
  codeStream: Array<RegistryCode>;
  /** fetch data from the table: "info" */
  info: Array<RegistryInfo>;
  /** fetch aggregated fields from the table: "info" */
  infoAggregate: RegistryInfoAggregate;
  /** fetch data from the table: "info" using primary key columns */
  infoByPk?: Maybe<RegistryInfo>;
  /** fetch data from the table in a streaming manner: "info" */
  infoStream: Array<RegistryInfo>;
  /** fetch data from the table: "organisasjonsform" */
  organisasjonsform: Array<RegistryOrganisasjonsform>;
  /** fetch aggregated fields from the table: "organisasjonsform" */
  organisasjonsformAggregate: RegistryOrganisasjonsformAggregate;
  /** fetch data from the table: "organisasjonsform" using primary key columns */
  organisasjonsformByPk?: Maybe<RegistryOrganisasjonsform>;
  /** fetch data from the table in a streaming manner: "organisasjonsform" */
  organisasjonsformStream: Array<RegistryOrganisasjonsform>;
  /** fetch data from the table: "organization" */
  organization: Array<RegistryOrganization>;
  /** fetch aggregated fields from the table: "organization" */
  organizationAggregate: RegistryOrganizationAggregate;
  /** fetch data from the table: "organization" using primary key columns */
  organizationByPk?: Maybe<RegistryOrganization>;
  /** fetch data from the table in a streaming manner: "organization" */
  organizationStream: Array<RegistryOrganization>;
  /** fetch data from the table: "postadresse" */
  postadresse: Array<RegistryPostadresse>;
  /** fetch aggregated fields from the table: "postadresse" */
  postadresseAggregate: RegistryPostadresseAggregate;
  /** fetch data from the table: "postadresse" using primary key columns */
  postadresseByPk?: Maybe<RegistryPostadresse>;
  /** fetch data from the table in a streaming manner: "postadresse" */
  postadresseStream: Array<RegistryPostadresse>;
};


export type bregsubscription_rootcodeArgs = {
  distinctOn?: InputMaybe<Array<RegistryCodeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegistryCodeOrderBy>>;
  where?: InputMaybe<RegistryCodeBoolExp>;
};


export type bregsubscription_rootcodeAggregateArgs = {
  distinctOn?: InputMaybe<Array<RegistryCodeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegistryCodeOrderBy>>;
  where?: InputMaybe<RegistryCodeBoolExp>;
};


export type bregsubscription_rootcodeByPkArgs = {
  id: Scalars['Registryuuid']['input'];
};


export type bregsubscription_rootcodeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RegistryCodeStreamCursorInput>>;
  where?: InputMaybe<RegistryCodeBoolExp>;
};


export type bregsubscription_rootinfoArgs = {
  distinctOn?: InputMaybe<Array<RegistryInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegistryInfoOrderBy>>;
  where?: InputMaybe<RegistryInfoBoolExp>;
};


export type bregsubscription_rootinfoAggregateArgs = {
  distinctOn?: InputMaybe<Array<RegistryInfoSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegistryInfoOrderBy>>;
  where?: InputMaybe<RegistryInfoBoolExp>;
};


export type bregsubscription_rootinfoByPkArgs = {
  id: Scalars['Registryuuid']['input'];
};


export type bregsubscription_rootinfoStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RegistryInfoStreamCursorInput>>;
  where?: InputMaybe<RegistryInfoBoolExp>;
};


export type bregsubscription_rootorganisasjonsformArgs = {
  distinctOn?: InputMaybe<Array<RegistryOrganisasjonsformSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegistryOrganisasjonsformOrderBy>>;
  where?: InputMaybe<RegistryOrganisasjonsformBoolExp>;
};


export type bregsubscription_rootorganisasjonsformAggregateArgs = {
  distinctOn?: InputMaybe<Array<RegistryOrganisasjonsformSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegistryOrganisasjonsformOrderBy>>;
  where?: InputMaybe<RegistryOrganisasjonsformBoolExp>;
};


export type bregsubscription_rootorganisasjonsformByPkArgs = {
  id: Scalars['Registryuuid']['input'];
};


export type bregsubscription_rootorganisasjonsformStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RegistryOrganisasjonsformStreamCursorInput>>;
  where?: InputMaybe<RegistryOrganisasjonsformBoolExp>;
};


export type bregsubscription_rootorganizationArgs = {
  distinctOn?: InputMaybe<Array<RegistryOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegistryOrganizationOrderBy>>;
  where?: InputMaybe<RegistryOrganizationBoolExp>;
};


export type bregsubscription_rootorganizationAggregateArgs = {
  distinctOn?: InputMaybe<Array<RegistryOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegistryOrganizationOrderBy>>;
  where?: InputMaybe<RegistryOrganizationBoolExp>;
};


export type bregsubscription_rootorganizationByPkArgs = {
  id: Scalars['Registryuuid']['input'];
};


export type bregsubscription_rootorganizationStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RegistryOrganizationStreamCursorInput>>;
  where?: InputMaybe<RegistryOrganizationBoolExp>;
};


export type bregsubscription_rootpostadresseArgs = {
  distinctOn?: InputMaybe<Array<RegistryPostadresseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegistryPostadresseOrderBy>>;
  where?: InputMaybe<RegistryPostadresseBoolExp>;
};


export type bregsubscription_rootpostadresseAggregateArgs = {
  distinctOn?: InputMaybe<Array<RegistryPostadresseSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegistryPostadresseOrderBy>>;
  where?: InputMaybe<RegistryPostadresseBoolExp>;
};


export type bregsubscription_rootpostadresseByPkArgs = {
  id: Scalars['Registryuuid']['input'];
};


export type bregsubscription_rootpostadresseStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RegistryPostadresseStreamCursorInput>>;
  where?: InputMaybe<RegistryPostadresseBoolExp>;
};

export type businessMessageAttachmentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BusinessMessageAttachmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BusinessMessageAttachmentsBoolExp>;
  predicate: IntComparisonExp;
};

export type businessOrganizationUserEmailAggregateBoolExpBool_and = {
  arguments: BusinessOrganizationUserEmailSelectColumnBusinessOrganizationUserEmailAggregateBoolExpBool_andArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BusinessOrganizationUserEmailBoolExp>;
  predicate: BooleanComparisonExp;
};

export type businessOrganizationUserEmailAggregateBoolExpBool_or = {
  arguments: BusinessOrganizationUserEmailSelectColumnBusinessOrganizationUserEmailAggregateBoolExpBool_orArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BusinessOrganizationUserEmailBoolExp>;
  predicate: BooleanComparisonExp;
};

export type businessOrganizationUserEmailAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BusinessOrganizationUserEmailSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BusinessOrganizationUserEmailBoolExp>;
  predicate: IntComparisonExp;
};

export type businessOrganizationUserRequestAggregateBoolExpBool_and = {
  arguments: BusinessOrganizationUserRequestSelectColumnBusinessOrganizationUserRequestAggregateBoolExpBool_andArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BusinessOrganizationUserRequestBoolExp>;
  predicate: BooleanComparisonExp;
};

export type businessOrganizationUserRequestAggregateBoolExpBool_or = {
  arguments: BusinessOrganizationUserRequestSelectColumnBusinessOrganizationUserRequestAggregateBoolExpBool_orArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BusinessOrganizationUserRequestBoolExp>;
  predicate: BooleanComparisonExp;
};

export type businessOrganizationUserRequestAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BusinessOrganizationUserRequestSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BusinessOrganizationUserRequestBoolExp>;
  predicate: IntComparisonExp;
};

export type businessOrganizationUserUrlAddressAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BusinessOrganizationUserUrlAddressSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BusinessOrganizationUserUrlAddressBoolExp>;
  predicate: IntComparisonExp;
};

export type businessQueueItemAlarmsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BusinessQueueItemAlarmsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BusinessQueueItemAlarmsBoolExp>;
  predicate: IntComparisonExp;
};

/** columns and relationships of "business.queue_item_collaboration" */
export type businessQueueItemCollaboration = {
  __typename?: 'businessQueueItemCollaboration';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  customerUser?: Maybe<organizationUser>;
  customerUserId: Scalars['uuid']['output'];
  from: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  organization: organization;
  organizationId: Scalars['uuid']['output'];
  private: Scalars['Boolean']['output'];
  skipNotifications: Scalars['Boolean']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "business.queue_item_collaboration" */
export type businessQueueItemCollaborationAggregate = {
  __typename?: 'businessQueueItemCollaborationAggregate';
  aggregate?: Maybe<businessQueueItemCollaborationAggregateFields>;
  nodes: Array<businessQueueItemCollaboration>;
};

export type businessQueueItemCollaborationAggregateBoolExp = {
  bool_and?: InputMaybe<businessQueueItemCollaborationAggregateBoolExpBool_and>;
  bool_or?: InputMaybe<businessQueueItemCollaborationAggregateBoolExpBool_or>;
  count?: InputMaybe<businessQueueItemCollaborationAggregateBoolExpCount>;
};

export type businessQueueItemCollaborationAggregateBoolExpBool_and = {
  arguments: businessQueueItemCollaborationSelectColumnBusinessQueueItemCollaborationAggregateBoolExpBool_andArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<businessQueueItemCollaborationBoolExp>;
  predicate: BooleanComparisonExp;
};

export type businessQueueItemCollaborationAggregateBoolExpBool_or = {
  arguments: businessQueueItemCollaborationSelectColumnBusinessQueueItemCollaborationAggregateBoolExpBool_orArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<businessQueueItemCollaborationBoolExp>;
  predicate: BooleanComparisonExp;
};

export type businessQueueItemCollaborationAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<businessQueueItemCollaborationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<businessQueueItemCollaborationBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "business.queue_item_collaboration" */
export type businessQueueItemCollaborationAggregateFields = {
  __typename?: 'businessQueueItemCollaborationAggregateFields';
  avg?: Maybe<businessQueueItemCollaborationAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<businessQueueItemCollaborationMaxFields>;
  min?: Maybe<businessQueueItemCollaborationMinFields>;
  stddev?: Maybe<businessQueueItemCollaborationStddevFields>;
  stddevPop?: Maybe<businessQueueItemCollaborationStddevPopFields>;
  stddevSamp?: Maybe<businessQueueItemCollaborationStddevSampFields>;
  sum?: Maybe<businessQueueItemCollaborationSumFields>;
  varPop?: Maybe<businessQueueItemCollaborationVarPopFields>;
  varSamp?: Maybe<businessQueueItemCollaborationVarSampFields>;
  variance?: Maybe<businessQueueItemCollaborationVarianceFields>;
};


/** aggregate fields of "business.queue_item_collaboration" */
export type businessQueueItemCollaborationAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<businessQueueItemCollaborationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.queue_item_collaboration" */
export type businessQueueItemCollaborationAggregateOrderBy = {
  avg?: InputMaybe<businessQueueItemCollaborationAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<businessQueueItemCollaborationMaxOrderBy>;
  min?: InputMaybe<businessQueueItemCollaborationMinOrderBy>;
  stddev?: InputMaybe<businessQueueItemCollaborationStddevOrderBy>;
  stddevPop?: InputMaybe<businessQueueItemCollaborationStddevPopOrderBy>;
  stddevSamp?: InputMaybe<businessQueueItemCollaborationStddevSampOrderBy>;
  sum?: InputMaybe<businessQueueItemCollaborationSumOrderBy>;
  varPop?: InputMaybe<businessQueueItemCollaborationVarPopOrderBy>;
  varSamp?: InputMaybe<businessQueueItemCollaborationVarSampOrderBy>;
  variance?: InputMaybe<businessQueueItemCollaborationVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "business.queue_item_collaboration" */
export type businessQueueItemCollaborationArrRelInsertInput = {
  data: Array<businessQueueItemCollaborationInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<businessQueueItemCollaborationOnConflict>;
};

/** aggregate avg on columns */
export type businessQueueItemCollaborationAvgFields = {
  __typename?: 'businessQueueItemCollaborationAvgFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "business.queue_item_collaboration" */
export type businessQueueItemCollaborationAvgOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "business.queue_item_collaboration". All fields are combined with a logical 'AND'. */
export type businessQueueItemCollaborationBoolExp = {
  _and?: InputMaybe<Array<businessQueueItemCollaborationBoolExp>>;
  _not?: InputMaybe<businessQueueItemCollaborationBoolExp>;
  _or?: InputMaybe<Array<businessQueueItemCollaborationBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customerUser?: InputMaybe<organizationUserBoolExp>;
  customerUserId?: InputMaybe<UuidComparisonExp>;
  from?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  organization?: InputMaybe<organizationBoolExp>;
  organizationId?: InputMaybe<UuidComparisonExp>;
  private?: InputMaybe<BooleanComparisonExp>;
  skipNotifications?: InputMaybe<BooleanComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "business.queue_item_collaboration" */
export type businessQueueItemCollaborationConstraint =
  /** unique or primary key constraint on columns "customer_user_id", "user_id", "organization_id" */
  | 'queue_item_collaboration_organization_id_user_id_customer_user_'
  /** unique or primary key constraint on columns "id" */
  | 'queue_item_private_pkey'
  | '%future added value';

/** input type for incrementing numeric columns in table "business.queue_item_collaboration" */
export type businessQueueItemCollaborationIncInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "business.queue_item_collaboration" */
export type businessQueueItemCollaborationInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customerUser?: InputMaybe<organizationUserObjRelInsertInput>;
  customerUserId?: InputMaybe<Scalars['uuid']['input']>;
  from?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<organizationObjRelInsertInput>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  skipNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type businessQueueItemCollaborationMaxFields = {
  __typename?: 'businessQueueItemCollaborationMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  customerUserId?: Maybe<Scalars['uuid']['output']>;
  from?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "business.queue_item_collaboration" */
export type businessQueueItemCollaborationMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customerUserId?: InputMaybe<OrderBy>;
  from?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type businessQueueItemCollaborationMinFields = {
  __typename?: 'businessQueueItemCollaborationMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  customerUserId?: Maybe<Scalars['uuid']['output']>;
  from?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "business.queue_item_collaboration" */
export type businessQueueItemCollaborationMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customerUserId?: InputMaybe<OrderBy>;
  from?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "business.queue_item_collaboration" */
export type businessQueueItemCollaborationMutationResponse = {
  __typename?: 'businessQueueItemCollaborationMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<businessQueueItemCollaboration>;
};

/** on_conflict condition type for table "business.queue_item_collaboration" */
export type businessQueueItemCollaborationOnConflict = {
  constraint: businessQueueItemCollaborationConstraint;
  updateColumns?: Array<businessQueueItemCollaborationUpdateColumn>;
  where?: InputMaybe<businessQueueItemCollaborationBoolExp>;
};

/** Ordering options when selecting data from "business.queue_item_collaboration". */
export type businessQueueItemCollaborationOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customerUser?: InputMaybe<organizationUserOrderBy>;
  customerUserId?: InputMaybe<OrderBy>;
  from?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organization?: InputMaybe<organizationOrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  private?: InputMaybe<OrderBy>;
  skipNotifications?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.queue_item_collaboration */
export type businessQueueItemCollaborationPkColumnsInput = {
  id: Scalars['Int']['input'];
};

/** select columns of table "business.queue_item_collaboration" */
export type businessQueueItemCollaborationSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'customerUserId'
  /** column name */
  | 'from'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'private'
  /** column name */
  | 'skipNotifications'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

/** select "businessQueueItemCollaborationAggregateBoolExpBool_andArgumentsColumns" columns of table "business.queue_item_collaboration" */
export type businessQueueItemCollaborationSelectColumnBusinessQueueItemCollaborationAggregateBoolExpBool_andArgumentsColumns =
  /** column name */
  | 'private'
  /** column name */
  | 'skipNotifications'
  | '%future added value';

/** select "businessQueueItemCollaborationAggregateBoolExpBool_orArgumentsColumns" columns of table "business.queue_item_collaboration" */
export type businessQueueItemCollaborationSelectColumnBusinessQueueItemCollaborationAggregateBoolExpBool_orArgumentsColumns =
  /** column name */
  | 'private'
  /** column name */
  | 'skipNotifications'
  | '%future added value';

/** input type for updating data in table "business.queue_item_collaboration" */
export type businessQueueItemCollaborationSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customerUserId?: InputMaybe<Scalars['uuid']['input']>;
  from?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  skipNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type businessQueueItemCollaborationStddevFields = {
  __typename?: 'businessQueueItemCollaborationStddevFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "business.queue_item_collaboration" */
export type businessQueueItemCollaborationStddevOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type businessQueueItemCollaborationStddevPopFields = {
  __typename?: 'businessQueueItemCollaborationStddevPopFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "business.queue_item_collaboration" */
export type businessQueueItemCollaborationStddevPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type businessQueueItemCollaborationStddevSampFields = {
  __typename?: 'businessQueueItemCollaborationStddevSampFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "business.queue_item_collaboration" */
export type businessQueueItemCollaborationStddevSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "businessQueueItemCollaboration" */
export type businessQueueItemCollaborationStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: businessQueueItemCollaborationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type businessQueueItemCollaborationStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customerUserId?: InputMaybe<Scalars['uuid']['input']>;
  from?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  skipNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type businessQueueItemCollaborationSumFields = {
  __typename?: 'businessQueueItemCollaborationSumFields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "business.queue_item_collaboration" */
export type businessQueueItemCollaborationSumOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** update columns of table "business.queue_item_collaboration" */
export type businessQueueItemCollaborationUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'customerUserId'
  /** column name */
  | 'from'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'private'
  /** column name */
  | 'skipNotifications'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

export type businessQueueItemCollaborationUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<businessQueueItemCollaborationIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<businessQueueItemCollaborationSetInput>;
  /** filter the rows which have to be updated */
  where: businessQueueItemCollaborationBoolExp;
};

/** aggregate varPop on columns */
export type businessQueueItemCollaborationVarPopFields = {
  __typename?: 'businessQueueItemCollaborationVarPopFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "business.queue_item_collaboration" */
export type businessQueueItemCollaborationVarPopOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type businessQueueItemCollaborationVarSampFields = {
  __typename?: 'businessQueueItemCollaborationVarSampFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "business.queue_item_collaboration" */
export type businessQueueItemCollaborationVarSampOrderBy = {
  id?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type businessQueueItemCollaborationVarianceFields = {
  __typename?: 'businessQueueItemCollaborationVarianceFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "business.queue_item_collaboration" */
export type businessQueueItemCollaborationVarianceOrderBy = {
  id?: InputMaybe<OrderBy>;
};

export type businessQueueItemDomainUsersViewAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BusinessQueueItemDomainUsersViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BusinessQueueItemDomainUsersViewBoolExp>;
  predicate: IntComparisonExp;
};

export type businessQueueItemOrganizationUsersViewAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BusinessQueueItemOrganizationUsersViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BusinessQueueItemOrganizationUsersViewBoolExp>;
  predicate: IntComparisonExp;
};

export type businessQueueItemParticipantsViewAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BusinessQueueItemParticipantsViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BusinessQueueItemParticipantsViewBoolExp>;
  predicate: IntComparisonExp;
};

export type businessUserContactNumbersAggregateBoolExpBool_and = {
  arguments: BusinessUserContactNumbersSelectColumnBusinessUserContactNumbersAggregateBoolExpBool_andArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BusinessUserContactNumbersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type businessUserContactNumbersAggregateBoolExpBool_or = {
  arguments: BusinessUserContactNumbersSelectColumnBusinessUserContactNumbersAggregateBoolExpBool_orArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BusinessUserContactNumbersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type businessUserContactNumbersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BusinessUserContactNumbersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BusinessUserContactNumbersBoolExp>;
  predicate: IntComparisonExp;
};

/** columns and relationships of "business.user_contacts" */
export type businessUserContacts = {
  __typename?: 'businessUserContacts';
  birthday?: Maybe<Scalars['timestamptz']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  contactType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  dates?: Maybe<Array<Scalars['timestamptz']['output']>>;
  department?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  imageAvailable?: Maybe<Scalars['Boolean']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  maidenName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  namePrefix?: Maybe<Scalars['String']['output']>;
  nameSuffix?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  nonGregorianBirthday?: Maybe<Scalars['timestamptz']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  origId?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  phoneNumbers: Array<BusinessUserContactNumbers>;
  /** An aggregate relationship */
  phoneNumbersAggregate: BusinessUserContactNumbersAggregate;
  phoneticFirstName?: Maybe<Scalars['String']['output']>;
  phoneticLastName?: Maybe<Scalars['String']['output']>;
  phoneticMiddleName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  userId: Scalars['uuid']['output'];
};


/** columns and relationships of "business.user_contacts" */
export type businessUserContactsphoneNumbersArgs = {
  distinctOn?: InputMaybe<Array<BusinessUserContactNumbersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessUserContactNumbersOrderBy>>;
  where?: InputMaybe<BusinessUserContactNumbersBoolExp>;
};


/** columns and relationships of "business.user_contacts" */
export type businessUserContactsphoneNumbersAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessUserContactNumbersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessUserContactNumbersOrderBy>>;
  where?: InputMaybe<BusinessUserContactNumbersBoolExp>;
};

/** aggregated selection of "business.user_contacts" */
export type businessUserContactsAggregate = {
  __typename?: 'businessUserContactsAggregate';
  aggregate?: Maybe<businessUserContactsAggregateFields>;
  nodes: Array<businessUserContacts>;
};

/** aggregate fields of "business.user_contacts" */
export type businessUserContactsAggregateFields = {
  __typename?: 'businessUserContactsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<businessUserContactsMaxFields>;
  min?: Maybe<businessUserContactsMinFields>;
};


/** aggregate fields of "business.user_contacts" */
export type businessUserContactsAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<businessUserContactsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.user_contacts". All fields are combined with a logical 'AND'. */
export type businessUserContactsBoolExp = {
  _and?: InputMaybe<Array<businessUserContactsBoolExp>>;
  _not?: InputMaybe<businessUserContactsBoolExp>;
  _or?: InputMaybe<Array<businessUserContactsBoolExp>>;
  birthday?: InputMaybe<TimestamptzComparisonExp>;
  company?: InputMaybe<StringComparisonExp>;
  contactType?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dates?: InputMaybe<TimestamptzArrayComparisonExp>;
  department?: InputMaybe<StringComparisonExp>;
  firstName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  imageAvailable?: InputMaybe<BooleanComparisonExp>;
  jobTitle?: InputMaybe<StringComparisonExp>;
  lastName?: InputMaybe<StringComparisonExp>;
  maidenName?: InputMaybe<StringComparisonExp>;
  middleName?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  namePrefix?: InputMaybe<StringComparisonExp>;
  nameSuffix?: InputMaybe<StringComparisonExp>;
  nickname?: InputMaybe<StringComparisonExp>;
  nonGregorianBirthday?: InputMaybe<TimestamptzComparisonExp>;
  note?: InputMaybe<StringComparisonExp>;
  origId?: InputMaybe<StringComparisonExp>;
  phoneNumbers?: InputMaybe<BusinessUserContactNumbersBoolExp>;
  phoneNumbersAggregate?: InputMaybe<BusinessUserContactNumbersAggregateBoolExp>;
  phoneticFirstName?: InputMaybe<StringComparisonExp>;
  phoneticLastName?: InputMaybe<StringComparisonExp>;
  phoneticMiddleName?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "business.user_contacts" */
export type businessUserContactsConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'user_contacts_pkey'
  /** unique or primary key constraint on columns "userId", "origId" */
  | 'user_contacts_userId_origId_key'
  | '%future added value';

/** input type for inserting data into table "business.user_contacts" */
export type businessUserContactsInsertInput = {
  birthday?: InputMaybe<Scalars['timestamptz']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  contactType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dates?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  department?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imageAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  maidenName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  namePrefix?: InputMaybe<Scalars['String']['input']>;
  nameSuffix?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  nonGregorianBirthday?: InputMaybe<Scalars['timestamptz']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  origId?: InputMaybe<Scalars['String']['input']>;
  phoneNumbers?: InputMaybe<BusinessUserContactNumbersArrRelInsertInput>;
  phoneticFirstName?: InputMaybe<Scalars['String']['input']>;
  phoneticLastName?: InputMaybe<Scalars['String']['input']>;
  phoneticMiddleName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type businessUserContactsMaxFields = {
  __typename?: 'businessUserContactsMaxFields';
  birthday?: Maybe<Scalars['timestamptz']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  contactType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dates?: Maybe<Array<Scalars['timestamptz']['output']>>;
  department?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  maidenName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  namePrefix?: Maybe<Scalars['String']['output']>;
  nameSuffix?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  nonGregorianBirthday?: Maybe<Scalars['timestamptz']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  origId?: Maybe<Scalars['String']['output']>;
  phoneticFirstName?: Maybe<Scalars['String']['output']>;
  phoneticLastName?: Maybe<Scalars['String']['output']>;
  phoneticMiddleName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type businessUserContactsMinFields = {
  __typename?: 'businessUserContactsMinFields';
  birthday?: Maybe<Scalars['timestamptz']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  contactType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dates?: Maybe<Array<Scalars['timestamptz']['output']>>;
  department?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  maidenName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  namePrefix?: Maybe<Scalars['String']['output']>;
  nameSuffix?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  nonGregorianBirthday?: Maybe<Scalars['timestamptz']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  origId?: Maybe<Scalars['String']['output']>;
  phoneticFirstName?: Maybe<Scalars['String']['output']>;
  phoneticLastName?: Maybe<Scalars['String']['output']>;
  phoneticMiddleName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "business.user_contacts" */
export type businessUserContactsMutationResponse = {
  __typename?: 'businessUserContactsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<businessUserContacts>;
};

/** input type for inserting object relation for remote table "business.user_contacts" */
export type businessUserContactsObjRelInsertInput = {
  data: businessUserContactsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<businessUserContactsOnConflict>;
};

/** on_conflict condition type for table "business.user_contacts" */
export type businessUserContactsOnConflict = {
  constraint: businessUserContactsConstraint;
  updateColumns?: Array<businessUserContactsUpdateColumn>;
  where?: InputMaybe<businessUserContactsBoolExp>;
};

/** Ordering options when selecting data from "business.user_contacts". */
export type businessUserContactsOrderBy = {
  birthday?: InputMaybe<OrderBy>;
  company?: InputMaybe<OrderBy>;
  contactType?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dates?: InputMaybe<OrderBy>;
  department?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  imageAvailable?: InputMaybe<OrderBy>;
  jobTitle?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  maidenName?: InputMaybe<OrderBy>;
  middleName?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  namePrefix?: InputMaybe<OrderBy>;
  nameSuffix?: InputMaybe<OrderBy>;
  nickname?: InputMaybe<OrderBy>;
  nonGregorianBirthday?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  origId?: InputMaybe<OrderBy>;
  phoneNumbersAggregate?: InputMaybe<BusinessUserContactNumbersAggregateOrderBy>;
  phoneticFirstName?: InputMaybe<OrderBy>;
  phoneticLastName?: InputMaybe<OrderBy>;
  phoneticMiddleName?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.user_contacts */
export type businessUserContactsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "business.user_contacts" */
export type businessUserContactsSelectColumn =
  /** column name */
  | 'birthday'
  /** column name */
  | 'company'
  /** column name */
  | 'contactType'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'dates'
  /** column name */
  | 'department'
  /** column name */
  | 'firstName'
  /** column name */
  | 'id'
  /** column name */
  | 'imageAvailable'
  /** column name */
  | 'jobTitle'
  /** column name */
  | 'lastName'
  /** column name */
  | 'maidenName'
  /** column name */
  | 'middleName'
  /** column name */
  | 'name'
  /** column name */
  | 'namePrefix'
  /** column name */
  | 'nameSuffix'
  /** column name */
  | 'nickname'
  /** column name */
  | 'nonGregorianBirthday'
  /** column name */
  | 'note'
  /** column name */
  | 'origId'
  /** column name */
  | 'phoneticFirstName'
  /** column name */
  | 'phoneticLastName'
  /** column name */
  | 'phoneticMiddleName'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

/** input type for updating data in table "business.user_contacts" */
export type businessUserContactsSetInput = {
  birthday?: InputMaybe<Scalars['timestamptz']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  contactType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dates?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  department?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imageAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  maidenName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  namePrefix?: InputMaybe<Scalars['String']['input']>;
  nameSuffix?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  nonGregorianBirthday?: InputMaybe<Scalars['timestamptz']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  origId?: InputMaybe<Scalars['String']['input']>;
  phoneticFirstName?: InputMaybe<Scalars['String']['input']>;
  phoneticLastName?: InputMaybe<Scalars['String']['input']>;
  phoneticMiddleName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "businessUserContacts" */
export type businessUserContactsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: businessUserContactsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type businessUserContactsStreamCursorValueInput = {
  birthday?: InputMaybe<Scalars['timestamptz']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  contactType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dates?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  department?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imageAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  maidenName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  namePrefix?: InputMaybe<Scalars['String']['input']>;
  nameSuffix?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  nonGregorianBirthday?: InputMaybe<Scalars['timestamptz']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  origId?: InputMaybe<Scalars['String']['input']>;
  phoneticFirstName?: InputMaybe<Scalars['String']['input']>;
  phoneticLastName?: InputMaybe<Scalars['String']['input']>;
  phoneticMiddleName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "business.user_contacts" */
export type businessUserContactsUpdateColumn =
  /** column name */
  | 'birthday'
  /** column name */
  | 'company'
  /** column name */
  | 'contactType'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'dates'
  /** column name */
  | 'department'
  /** column name */
  | 'firstName'
  /** column name */
  | 'id'
  /** column name */
  | 'imageAvailable'
  /** column name */
  | 'jobTitle'
  /** column name */
  | 'lastName'
  /** column name */
  | 'maidenName'
  /** column name */
  | 'middleName'
  /** column name */
  | 'name'
  /** column name */
  | 'namePrefix'
  /** column name */
  | 'nameSuffix'
  /** column name */
  | 'nickname'
  /** column name */
  | 'nonGregorianBirthday'
  /** column name */
  | 'note'
  /** column name */
  | 'origId'
  /** column name */
  | 'phoneticFirstName'
  /** column name */
  | 'phoneticLastName'
  /** column name */
  | 'phoneticMiddleName'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

export type businessUserContactsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<businessUserContactsSetInput>;
  /** filter the rows which have to be updated */
  where: businessUserContactsBoolExp;
};

export type businessUserFeedAggregateBoolExpBool_and = {
  arguments: BusinessUserFeedSelectColumnBusinessUserFeedAggregateBoolExpBool_andArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BusinessUserFeedBoolExp>;
  predicate: BooleanComparisonExp;
};

export type businessUserFeedAggregateBoolExpBool_or = {
  arguments: BusinessUserFeedSelectColumnBusinessUserFeedAggregateBoolExpBool_orArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BusinessUserFeedBoolExp>;
  predicate: BooleanComparisonExp;
};

export type businessUserFeedAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BusinessUserFeedSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BusinessUserFeedBoolExp>;
  predicate: IntComparisonExp;
};

/** columns and relationships of "business.user_settings" */
export type businessUserSettings = {
  __typename?: 'businessUserSettings';
  callbackNotificationsOnPrivateContacts: Scalars['Boolean']['output'];
  createdAt: Scalars['timestamptz']['output'];
  followupNotificationsOnPrivateContacts: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  lostCallAutoTaskOnCustomers: Scalars['Boolean']['output'];
  lostCallAutoTaskOnPrivateContacts: Scalars['Boolean']['output'];
  lostCallAutoTaskOnUnknown: Scalars['Boolean']['output'];
  lostCallDeadlineOffset?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "business.user_settings" */
export type businessUserSettingsAggregate = {
  __typename?: 'businessUserSettingsAggregate';
  aggregate?: Maybe<businessUserSettingsAggregateFields>;
  nodes: Array<businessUserSettings>;
};

/** aggregate fields of "business.user_settings" */
export type businessUserSettingsAggregateFields = {
  __typename?: 'businessUserSettingsAggregateFields';
  avg?: Maybe<businessUserSettingsAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<businessUserSettingsMaxFields>;
  min?: Maybe<businessUserSettingsMinFields>;
  stddev?: Maybe<businessUserSettingsStddevFields>;
  stddevPop?: Maybe<businessUserSettingsStddevPopFields>;
  stddevSamp?: Maybe<businessUserSettingsStddevSampFields>;
  sum?: Maybe<businessUserSettingsSumFields>;
  varPop?: Maybe<businessUserSettingsVarPopFields>;
  varSamp?: Maybe<businessUserSettingsVarSampFields>;
  variance?: Maybe<businessUserSettingsVarianceFields>;
};


/** aggregate fields of "business.user_settings" */
export type businessUserSettingsAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<businessUserSettingsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type businessUserSettingsAvgFields = {
  __typename?: 'businessUserSettingsAvgFields';
  lostCallDeadlineOffset?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "business.user_settings". All fields are combined with a logical 'AND'. */
export type businessUserSettingsBoolExp = {
  _and?: InputMaybe<Array<businessUserSettingsBoolExp>>;
  _not?: InputMaybe<businessUserSettingsBoolExp>;
  _or?: InputMaybe<Array<businessUserSettingsBoolExp>>;
  callbackNotificationsOnPrivateContacts?: InputMaybe<BooleanComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  followupNotificationsOnPrivateContacts?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lostCallAutoTaskOnCustomers?: InputMaybe<BooleanComparisonExp>;
  lostCallAutoTaskOnPrivateContacts?: InputMaybe<BooleanComparisonExp>;
  lostCallAutoTaskOnUnknown?: InputMaybe<BooleanComparisonExp>;
  lostCallDeadlineOffset?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "business.user_settings" */
export type businessUserSettingsConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'user_settings_pkey'
  /** unique or primary key constraint on columns "userId" */
  | 'user_settings_userId_key'
  | '%future added value';

/** input type for incrementing numeric columns in table "business.user_settings" */
export type businessUserSettingsIncInput = {
  lostCallDeadlineOffset?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "business.user_settings" */
export type businessUserSettingsInsertInput = {
  callbackNotificationsOnPrivateContacts?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  followupNotificationsOnPrivateContacts?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lostCallAutoTaskOnCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  lostCallAutoTaskOnPrivateContacts?: InputMaybe<Scalars['Boolean']['input']>;
  lostCallAutoTaskOnUnknown?: InputMaybe<Scalars['Boolean']['input']>;
  lostCallDeadlineOffset?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type businessUserSettingsMaxFields = {
  __typename?: 'businessUserSettingsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lostCallDeadlineOffset?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type businessUserSettingsMinFields = {
  __typename?: 'businessUserSettingsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lostCallDeadlineOffset?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "business.user_settings" */
export type businessUserSettingsMutationResponse = {
  __typename?: 'businessUserSettingsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<businessUserSettings>;
};

/** on_conflict condition type for table "business.user_settings" */
export type businessUserSettingsOnConflict = {
  constraint: businessUserSettingsConstraint;
  updateColumns?: Array<businessUserSettingsUpdateColumn>;
  where?: InputMaybe<businessUserSettingsBoolExp>;
};

/** Ordering options when selecting data from "business.user_settings". */
export type businessUserSettingsOrderBy = {
  callbackNotificationsOnPrivateContacts?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  followupNotificationsOnPrivateContacts?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lostCallAutoTaskOnCustomers?: InputMaybe<OrderBy>;
  lostCallAutoTaskOnPrivateContacts?: InputMaybe<OrderBy>;
  lostCallAutoTaskOnUnknown?: InputMaybe<OrderBy>;
  lostCallDeadlineOffset?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.user_settings */
export type businessUserSettingsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "business.user_settings" */
export type businessUserSettingsSelectColumn =
  /** column name */
  | 'callbackNotificationsOnPrivateContacts'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'followupNotificationsOnPrivateContacts'
  /** column name */
  | 'id'
  /** column name */
  | 'lostCallAutoTaskOnCustomers'
  /** column name */
  | 'lostCallAutoTaskOnPrivateContacts'
  /** column name */
  | 'lostCallAutoTaskOnUnknown'
  /** column name */
  | 'lostCallDeadlineOffset'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

/** input type for updating data in table "business.user_settings" */
export type businessUserSettingsSetInput = {
  callbackNotificationsOnPrivateContacts?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  followupNotificationsOnPrivateContacts?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lostCallAutoTaskOnCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  lostCallAutoTaskOnPrivateContacts?: InputMaybe<Scalars['Boolean']['input']>;
  lostCallAutoTaskOnUnknown?: InputMaybe<Scalars['Boolean']['input']>;
  lostCallDeadlineOffset?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type businessUserSettingsStddevFields = {
  __typename?: 'businessUserSettingsStddevFields';
  lostCallDeadlineOffset?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type businessUserSettingsStddevPopFields = {
  __typename?: 'businessUserSettingsStddevPopFields';
  lostCallDeadlineOffset?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type businessUserSettingsStddevSampFields = {
  __typename?: 'businessUserSettingsStddevSampFields';
  lostCallDeadlineOffset?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "businessUserSettings" */
export type businessUserSettingsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: businessUserSettingsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type businessUserSettingsStreamCursorValueInput = {
  callbackNotificationsOnPrivateContacts?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  followupNotificationsOnPrivateContacts?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lostCallAutoTaskOnCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  lostCallAutoTaskOnPrivateContacts?: InputMaybe<Scalars['Boolean']['input']>;
  lostCallAutoTaskOnUnknown?: InputMaybe<Scalars['Boolean']['input']>;
  lostCallDeadlineOffset?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type businessUserSettingsSumFields = {
  __typename?: 'businessUserSettingsSumFields';
  lostCallDeadlineOffset?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "business.user_settings" */
export type businessUserSettingsUpdateColumn =
  /** column name */
  | 'callbackNotificationsOnPrivateContacts'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'followupNotificationsOnPrivateContacts'
  /** column name */
  | 'id'
  /** column name */
  | 'lostCallAutoTaskOnCustomers'
  /** column name */
  | 'lostCallAutoTaskOnPrivateContacts'
  /** column name */
  | 'lostCallAutoTaskOnUnknown'
  /** column name */
  | 'lostCallDeadlineOffset'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

export type businessUserSettingsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<businessUserSettingsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<businessUserSettingsSetInput>;
  /** filter the rows which have to be updated */
  where: businessUserSettingsBoolExp;
};

/** aggregate varPop on columns */
export type businessUserSettingsVarPopFields = {
  __typename?: 'businessUserSettingsVarPopFields';
  lostCallDeadlineOffset?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type businessUserSettingsVarSampFields = {
  __typename?: 'businessUserSettingsVarSampFields';
  lostCallDeadlineOffset?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type businessUserSettingsVarianceFields = {
  __typename?: 'businessUserSettingsVarianceFields';
  lostCallDeadlineOffset?: Maybe<Scalars['Float']['output']>;
};

export type businessUserStatesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BusinessUserStatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BusinessUserStatesBoolExp>;
  predicate: IntComparisonExp;
};

export type callBackLaterResult = {
  __typename?: 'callBackLaterResult';
  result: Scalars['String']['output'];
};

export type checkTelephonyIdOutput = {
  __typename?: 'checkTelephonyIdOutput';
  feedback?: Maybe<Scalars['String']['output']>;
};

export type createEmailProviderIntegrationAccount = {
  id: Scalars['uuid']['input'];
  linkedAddress: Scalars['String']['input'];
  refreshToken: Scalars['String']['input'];
  token: Scalars['String']['input'];
  type: ProviderTypeEmail;
  user: Scalars['String']['input'];
  userId: Scalars['uuid']['input'];
};

export type createEmailProviderIntegrationInput = {
  account: createEmailProviderIntegrationAccount;
};

export type createEmailProviderSubscriptionInput = {
  account: Scalars['String']['input'];
  id: Scalars['uuid']['input'];
  server: Scalars['String']['input'];
  tunnelPort: Scalars['String']['input'];
  type: Scalars['String']['input'];
  userId: Scalars['uuid']['input'];
};

export type createEmailProviderSubscriptionOutput = {
  __typename?: 'createEmailProviderSubscriptionOutput';
  expiration: Scalars['timestamptz']['output'];
  subscriptionId: Scalars['uuid']['output'];
};

export type createMessagingGroupOutput = {
  __typename?: 'createMessagingGroupOutput';
  id: Scalars['uuid']['output'];
};

export type createPhoneroOrgUserInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  domainUserId?: InputMaybe<Scalars['uuid']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  function?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  numberType?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  personId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

export type createPhoneroOrgUsersOutput = {
  __typename?: 'createPhoneroOrgUsersOutput';
  result: Scalars['String']['output'];
};

export type createRoomOutput = {
  __typename?: 'createRoomOutput';
  id: Scalars['uuid']['output'];
};

/** Statuses messages between Catalyst and Youtello */
export type crmStatusMessage = {
  __typename?: 'crmStatusMessage';
  code?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  creator?: Maybe<CrmCreatorTypeEnum>;
  /** An object relationship */
  crmContext?: Maybe<CrmContext>;
  crmContextId?: Maybe<Scalars['uuid']['output']>;
  crmData?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  event?: Maybe<CrmEvent>;
  eventId?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  message?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Scalars['jsonb']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  traceContext?: Maybe<CrmTraceContext>;
  traceContextId?: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  youtelloContext?: Maybe<CrmContext>;
  youtelloContextId?: Maybe<Scalars['uuid']['output']>;
  youtelloData?: Maybe<Scalars['jsonb']['output']>;
};


/** Statuses messages between Catalyst and Youtello */
export type crmStatusMessagecrmDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Statuses messages between Catalyst and Youtello */
export type crmStatusMessagepayloadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Statuses messages between Catalyst and Youtello */
export type crmStatusMessageyoutelloDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "crm.status_message" */
export type crmStatusMessageAggregate = {
  __typename?: 'crmStatusMessageAggregate';
  aggregate?: Maybe<crmStatusMessageAggregateFields>;
  nodes: Array<crmStatusMessage>;
};

/** aggregate fields of "crm.status_message" */
export type crmStatusMessageAggregateFields = {
  __typename?: 'crmStatusMessageAggregateFields';
  avg?: Maybe<crmStatusMessageAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<crmStatusMessageMaxFields>;
  min?: Maybe<crmStatusMessageMinFields>;
  stddev?: Maybe<crmStatusMessageStddevFields>;
  stddevPop?: Maybe<crmStatusMessageStddevPopFields>;
  stddevSamp?: Maybe<crmStatusMessageStddevSampFields>;
  sum?: Maybe<crmStatusMessageSumFields>;
  varPop?: Maybe<crmStatusMessageVarPopFields>;
  varSamp?: Maybe<crmStatusMessageVarSampFields>;
  variance?: Maybe<crmStatusMessageVarianceFields>;
};


/** aggregate fields of "crm.status_message" */
export type crmStatusMessageAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<crmStatusMessageSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type crmStatusMessageAppendInput = {
  crmData?: InputMaybe<Scalars['jsonb']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  youtelloData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type crmStatusMessageAvgFields = {
  __typename?: 'crmStatusMessageAvgFields';
  code?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "crm.status_message". All fields are combined with a logical 'AND'. */
export type crmStatusMessageBoolExp = {
  _and?: InputMaybe<Array<crmStatusMessageBoolExp>>;
  _not?: InputMaybe<crmStatusMessageBoolExp>;
  _or?: InputMaybe<Array<crmStatusMessageBoolExp>>;
  code?: InputMaybe<IntComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  creator?: InputMaybe<CrmCreatorTypeEnumComparisonExp>;
  crmContext?: InputMaybe<CrmContextBoolExp>;
  crmContextId?: InputMaybe<UuidComparisonExp>;
  crmData?: InputMaybe<JsonbComparisonExp>;
  event?: InputMaybe<CrmEventBoolExp>;
  eventId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  message?: InputMaybe<StringComparisonExp>;
  payload?: InputMaybe<JsonbComparisonExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  traceContext?: InputMaybe<CrmTraceContextBoolExp>;
  traceContextId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  youtelloContext?: InputMaybe<CrmContextBoolExp>;
  youtelloContextId?: InputMaybe<UuidComparisonExp>;
  youtelloData?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "crm.status_message" */
export type crmStatusMessageConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'status_message_pkey'
  | '%future added value';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type crmStatusMessageDeleteAtPathInput = {
  crmData?: InputMaybe<Array<Scalars['String']['input']>>;
  payload?: InputMaybe<Array<Scalars['String']['input']>>;
  youtelloData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type crmStatusMessageDeleteElemInput = {
  crmData?: InputMaybe<Scalars['Int']['input']>;
  payload?: InputMaybe<Scalars['Int']['input']>;
  youtelloData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type crmStatusMessageDeleteKeyInput = {
  crmData?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<Scalars['String']['input']>;
  youtelloData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "crm.status_message" */
export type crmStatusMessageIncInput = {
  code?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "crm.status_message" */
export type crmStatusMessageInsertInput = {
  code?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  creator?: InputMaybe<CrmCreatorTypeEnum>;
  crmContext?: InputMaybe<CrmContextObjRelInsertInput>;
  crmContextId?: InputMaybe<Scalars['uuid']['input']>;
  crmData?: InputMaybe<Scalars['jsonb']['input']>;
  event?: InputMaybe<CrmEventObjRelInsertInput>;
  eventId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  traceContext?: InputMaybe<CrmTraceContextObjRelInsertInput>;
  traceContextId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  youtelloContext?: InputMaybe<CrmContextObjRelInsertInput>;
  youtelloContextId?: InputMaybe<Scalars['uuid']['input']>;
  youtelloData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type crmStatusMessageMaxFields = {
  __typename?: 'crmStatusMessageMaxFields';
  code?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  crmContextId?: Maybe<Scalars['uuid']['output']>;
  eventId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  traceContextId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  youtelloContextId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type crmStatusMessageMinFields = {
  __typename?: 'crmStatusMessageMinFields';
  code?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  crmContextId?: Maybe<Scalars['uuid']['output']>;
  eventId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  traceContextId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  youtelloContextId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "crm.status_message" */
export type crmStatusMessageMutationResponse = {
  __typename?: 'crmStatusMessageMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<crmStatusMessage>;
};

/** on_conflict condition type for table "crm.status_message" */
export type crmStatusMessageOnConflict = {
  constraint: crmStatusMessageConstraint;
  updateColumns?: Array<crmStatusMessageUpdateColumn>;
  where?: InputMaybe<crmStatusMessageBoolExp>;
};

/** Ordering options when selecting data from "crm.status_message". */
export type crmStatusMessageOrderBy = {
  code?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  creator?: InputMaybe<OrderBy>;
  crmContext?: InputMaybe<CrmContextOrderBy>;
  crmContextId?: InputMaybe<OrderBy>;
  crmData?: InputMaybe<OrderBy>;
  event?: InputMaybe<CrmEventOrderBy>;
  eventId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message?: InputMaybe<OrderBy>;
  payload?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  traceContext?: InputMaybe<CrmTraceContextOrderBy>;
  traceContextId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  youtelloContext?: InputMaybe<CrmContextOrderBy>;
  youtelloContextId?: InputMaybe<OrderBy>;
  youtelloData?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: crm.status_message */
export type crmStatusMessagePkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type crmStatusMessagePrependInput = {
  crmData?: InputMaybe<Scalars['jsonb']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  youtelloData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "crm.status_message" */
export type crmStatusMessageSelectColumn =
  /** column name */
  | 'code'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'creator'
  /** column name */
  | 'crmContextId'
  /** column name */
  | 'crmData'
  /** column name */
  | 'eventId'
  /** column name */
  | 'id'
  /** column name */
  | 'message'
  /** column name */
  | 'payload'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'traceContextId'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'youtelloContextId'
  /** column name */
  | 'youtelloData'
  | '%future added value';

/** input type for updating data in table "crm.status_message" */
export type crmStatusMessageSetInput = {
  code?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  creator?: InputMaybe<CrmCreatorTypeEnum>;
  crmContextId?: InputMaybe<Scalars['uuid']['input']>;
  crmData?: InputMaybe<Scalars['jsonb']['input']>;
  eventId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  traceContextId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  youtelloContextId?: InputMaybe<Scalars['uuid']['input']>;
  youtelloData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate stddev on columns */
export type crmStatusMessageStddevFields = {
  __typename?: 'crmStatusMessageStddevFields';
  code?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type crmStatusMessageStddevPopFields = {
  __typename?: 'crmStatusMessageStddevPopFields';
  code?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type crmStatusMessageStddevSampFields = {
  __typename?: 'crmStatusMessageStddevSampFields';
  code?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "crmStatusMessage" */
export type crmStatusMessageStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: crmStatusMessageStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type crmStatusMessageStreamCursorValueInput = {
  code?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  creator?: InputMaybe<CrmCreatorTypeEnum>;
  crmContextId?: InputMaybe<Scalars['uuid']['input']>;
  crmData?: InputMaybe<Scalars['jsonb']['input']>;
  eventId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  traceContextId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  youtelloContextId?: InputMaybe<Scalars['uuid']['input']>;
  youtelloData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate sum on columns */
export type crmStatusMessageSumFields = {
  __typename?: 'crmStatusMessageSumFields';
  code?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "crm.status_message" */
export type crmStatusMessageUpdateColumn =
  /** column name */
  | 'code'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'creator'
  /** column name */
  | 'crmContextId'
  /** column name */
  | 'crmData'
  /** column name */
  | 'eventId'
  /** column name */
  | 'id'
  /** column name */
  | 'message'
  /** column name */
  | 'payload'
  /** column name */
  | 'tenantId'
  /** column name */
  | 'traceContextId'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'youtelloContextId'
  /** column name */
  | 'youtelloData'
  | '%future added value';

export type crmStatusMessageUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<crmStatusMessageAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<crmStatusMessageDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<crmStatusMessageDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<crmStatusMessageDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<crmStatusMessageIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<crmStatusMessagePrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<crmStatusMessageSetInput>;
  /** filter the rows which have to be updated */
  where: crmStatusMessageBoolExp;
};

/** aggregate varPop on columns */
export type crmStatusMessageVarPopFields = {
  __typename?: 'crmStatusMessageVarPopFields';
  code?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type crmStatusMessageVarSampFields = {
  __typename?: 'crmStatusMessageVarSampFields';
  code?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type crmStatusMessageVarianceFields = {
  __typename?: 'crmStatusMessageVarianceFields';
  code?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "crm.youtello_catalyst_id_mapping" */
export type crmYoutelloCatalystIdMapping = {
  __typename?: 'crmYoutelloCatalystIdMapping';
  catalystId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  crmType: Scalars['String']['output'];
  crmUrl?: Maybe<Scalars['String']['output']>;
  crmVisibility?: Maybe<Scalars['Int']['output']>;
  organizationId: Scalars['uuid']['output'];
  unifiedEntityType: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  youtelloId: Scalars['uuid']['output'];
};

/** aggregated selection of "crm.youtello_catalyst_id_mapping" */
export type crmYoutelloCatalystIdMappingAggregate = {
  __typename?: 'crmYoutelloCatalystIdMappingAggregate';
  aggregate?: Maybe<crmYoutelloCatalystIdMappingAggregateFields>;
  nodes: Array<crmYoutelloCatalystIdMapping>;
};

export type crmYoutelloCatalystIdMappingAggregateBoolExp = {
  count?: InputMaybe<crmYoutelloCatalystIdMappingAggregateBoolExpCount>;
};

export type crmYoutelloCatalystIdMappingAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<crmYoutelloCatalystIdMappingSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<crmYoutelloCatalystIdMappingBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "crm.youtello_catalyst_id_mapping" */
export type crmYoutelloCatalystIdMappingAggregateFields = {
  __typename?: 'crmYoutelloCatalystIdMappingAggregateFields';
  avg?: Maybe<crmYoutelloCatalystIdMappingAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<crmYoutelloCatalystIdMappingMaxFields>;
  min?: Maybe<crmYoutelloCatalystIdMappingMinFields>;
  stddev?: Maybe<crmYoutelloCatalystIdMappingStddevFields>;
  stddevPop?: Maybe<crmYoutelloCatalystIdMappingStddevPopFields>;
  stddevSamp?: Maybe<crmYoutelloCatalystIdMappingStddevSampFields>;
  sum?: Maybe<crmYoutelloCatalystIdMappingSumFields>;
  varPop?: Maybe<crmYoutelloCatalystIdMappingVarPopFields>;
  varSamp?: Maybe<crmYoutelloCatalystIdMappingVarSampFields>;
  variance?: Maybe<crmYoutelloCatalystIdMappingVarianceFields>;
};


/** aggregate fields of "crm.youtello_catalyst_id_mapping" */
export type crmYoutelloCatalystIdMappingAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<crmYoutelloCatalystIdMappingSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "crm.youtello_catalyst_id_mapping" */
export type crmYoutelloCatalystIdMappingAggregateOrderBy = {
  avg?: InputMaybe<crmYoutelloCatalystIdMappingAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<crmYoutelloCatalystIdMappingMaxOrderBy>;
  min?: InputMaybe<crmYoutelloCatalystIdMappingMinOrderBy>;
  stddev?: InputMaybe<crmYoutelloCatalystIdMappingStddevOrderBy>;
  stddevPop?: InputMaybe<crmYoutelloCatalystIdMappingStddevPopOrderBy>;
  stddevSamp?: InputMaybe<crmYoutelloCatalystIdMappingStddevSampOrderBy>;
  sum?: InputMaybe<crmYoutelloCatalystIdMappingSumOrderBy>;
  varPop?: InputMaybe<crmYoutelloCatalystIdMappingVarPopOrderBy>;
  varSamp?: InputMaybe<crmYoutelloCatalystIdMappingVarSampOrderBy>;
  variance?: InputMaybe<crmYoutelloCatalystIdMappingVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "crm.youtello_catalyst_id_mapping" */
export type crmYoutelloCatalystIdMappingArrRelInsertInput = {
  data: Array<crmYoutelloCatalystIdMappingInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<crmYoutelloCatalystIdMappingOnConflict>;
};

/** aggregate avg on columns */
export type crmYoutelloCatalystIdMappingAvgFields = {
  __typename?: 'crmYoutelloCatalystIdMappingAvgFields';
  crmVisibility?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "crm.youtello_catalyst_id_mapping" */
export type crmYoutelloCatalystIdMappingAvgOrderBy = {
  crmVisibility?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "crm.youtello_catalyst_id_mapping". All fields are combined with a logical 'AND'. */
export type crmYoutelloCatalystIdMappingBoolExp = {
  _and?: InputMaybe<Array<crmYoutelloCatalystIdMappingBoolExp>>;
  _not?: InputMaybe<crmYoutelloCatalystIdMappingBoolExp>;
  _or?: InputMaybe<Array<crmYoutelloCatalystIdMappingBoolExp>>;
  catalystId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  crmType?: InputMaybe<StringComparisonExp>;
  crmUrl?: InputMaybe<StringComparisonExp>;
  crmVisibility?: InputMaybe<IntComparisonExp>;
  organizationId?: InputMaybe<UuidComparisonExp>;
  unifiedEntityType?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  youtelloId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "crm.youtello_catalyst_id_mapping" */
export type crmYoutelloCatalystIdMappingConstraint =
  /** unique or primary key constraint on columns "catalyst_id" */
  | 'youtello_catalyst_id_mapping_catalyst_id_key'
  /** unique or primary key constraint on columns "youtello_id", "catalyst_id" */
  | 'youtello_catalyst_id_mapping_pkey'
  /** unique or primary key constraint on columns "youtello_id" */
  | 'youtello_catalyst_id_mapping_youtello_id_key'
  | '%future added value';

/** input type for incrementing numeric columns in table "crm.youtello_catalyst_id_mapping" */
export type crmYoutelloCatalystIdMappingIncInput = {
  crmVisibility?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "crm.youtello_catalyst_id_mapping" */
export type crmYoutelloCatalystIdMappingInsertInput = {
  catalystId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  crmType?: InputMaybe<Scalars['String']['input']>;
  crmUrl?: InputMaybe<Scalars['String']['input']>;
  crmVisibility?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  unifiedEntityType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  youtelloId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type crmYoutelloCatalystIdMappingMaxFields = {
  __typename?: 'crmYoutelloCatalystIdMappingMaxFields';
  catalystId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  crmType?: Maybe<Scalars['String']['output']>;
  crmUrl?: Maybe<Scalars['String']['output']>;
  crmVisibility?: Maybe<Scalars['Int']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  unifiedEntityType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  youtelloId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "crm.youtello_catalyst_id_mapping" */
export type crmYoutelloCatalystIdMappingMaxOrderBy = {
  catalystId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  crmType?: InputMaybe<OrderBy>;
  crmUrl?: InputMaybe<OrderBy>;
  crmVisibility?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  unifiedEntityType?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  youtelloId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type crmYoutelloCatalystIdMappingMinFields = {
  __typename?: 'crmYoutelloCatalystIdMappingMinFields';
  catalystId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  crmType?: Maybe<Scalars['String']['output']>;
  crmUrl?: Maybe<Scalars['String']['output']>;
  crmVisibility?: Maybe<Scalars['Int']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  unifiedEntityType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  youtelloId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "crm.youtello_catalyst_id_mapping" */
export type crmYoutelloCatalystIdMappingMinOrderBy = {
  catalystId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  crmType?: InputMaybe<OrderBy>;
  crmUrl?: InputMaybe<OrderBy>;
  crmVisibility?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  unifiedEntityType?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  youtelloId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "crm.youtello_catalyst_id_mapping" */
export type crmYoutelloCatalystIdMappingMutationResponse = {
  __typename?: 'crmYoutelloCatalystIdMappingMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<crmYoutelloCatalystIdMapping>;
};

/** on_conflict condition type for table "crm.youtello_catalyst_id_mapping" */
export type crmYoutelloCatalystIdMappingOnConflict = {
  constraint: crmYoutelloCatalystIdMappingConstraint;
  updateColumns?: Array<crmYoutelloCatalystIdMappingUpdateColumn>;
  where?: InputMaybe<crmYoutelloCatalystIdMappingBoolExp>;
};

/** Ordering options when selecting data from "crm.youtello_catalyst_id_mapping". */
export type crmYoutelloCatalystIdMappingOrderBy = {
  catalystId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  crmType?: InputMaybe<OrderBy>;
  crmUrl?: InputMaybe<OrderBy>;
  crmVisibility?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  unifiedEntityType?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  youtelloId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: crm.youtello_catalyst_id_mapping */
export type crmYoutelloCatalystIdMappingPkColumnsInput = {
  catalystId: Scalars['uuid']['input'];
  youtelloId: Scalars['uuid']['input'];
};

/** select columns of table "crm.youtello_catalyst_id_mapping" */
export type crmYoutelloCatalystIdMappingSelectColumn =
  /** column name */
  | 'catalystId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'crmType'
  /** column name */
  | 'crmUrl'
  /** column name */
  | 'crmVisibility'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'unifiedEntityType'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'youtelloId'
  | '%future added value';

/** input type for updating data in table "crm.youtello_catalyst_id_mapping" */
export type crmYoutelloCatalystIdMappingSetInput = {
  catalystId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  crmType?: InputMaybe<Scalars['String']['input']>;
  crmUrl?: InputMaybe<Scalars['String']['input']>;
  crmVisibility?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  unifiedEntityType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  youtelloId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type crmYoutelloCatalystIdMappingStddevFields = {
  __typename?: 'crmYoutelloCatalystIdMappingStddevFields';
  crmVisibility?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "crm.youtello_catalyst_id_mapping" */
export type crmYoutelloCatalystIdMappingStddevOrderBy = {
  crmVisibility?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type crmYoutelloCatalystIdMappingStddevPopFields = {
  __typename?: 'crmYoutelloCatalystIdMappingStddevPopFields';
  crmVisibility?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "crm.youtello_catalyst_id_mapping" */
export type crmYoutelloCatalystIdMappingStddevPopOrderBy = {
  crmVisibility?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type crmYoutelloCatalystIdMappingStddevSampFields = {
  __typename?: 'crmYoutelloCatalystIdMappingStddevSampFields';
  crmVisibility?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "crm.youtello_catalyst_id_mapping" */
export type crmYoutelloCatalystIdMappingStddevSampOrderBy = {
  crmVisibility?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "crmYoutelloCatalystIdMapping" */
export type crmYoutelloCatalystIdMappingStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: crmYoutelloCatalystIdMappingStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type crmYoutelloCatalystIdMappingStreamCursorValueInput = {
  catalystId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  crmType?: InputMaybe<Scalars['String']['input']>;
  crmUrl?: InputMaybe<Scalars['String']['input']>;
  crmVisibility?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  unifiedEntityType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  youtelloId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type crmYoutelloCatalystIdMappingSumFields = {
  __typename?: 'crmYoutelloCatalystIdMappingSumFields';
  crmVisibility?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "crm.youtello_catalyst_id_mapping" */
export type crmYoutelloCatalystIdMappingSumOrderBy = {
  crmVisibility?: InputMaybe<OrderBy>;
};

/** update columns of table "crm.youtello_catalyst_id_mapping" */
export type crmYoutelloCatalystIdMappingUpdateColumn =
  /** column name */
  | 'catalystId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'crmType'
  /** column name */
  | 'crmUrl'
  /** column name */
  | 'crmVisibility'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'unifiedEntityType'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'youtelloId'
  | '%future added value';

export type crmYoutelloCatalystIdMappingUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<crmYoutelloCatalystIdMappingIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<crmYoutelloCatalystIdMappingSetInput>;
  /** filter the rows which have to be updated */
  where: crmYoutelloCatalystIdMappingBoolExp;
};

/** aggregate varPop on columns */
export type crmYoutelloCatalystIdMappingVarPopFields = {
  __typename?: 'crmYoutelloCatalystIdMappingVarPopFields';
  crmVisibility?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "crm.youtello_catalyst_id_mapping" */
export type crmYoutelloCatalystIdMappingVarPopOrderBy = {
  crmVisibility?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type crmYoutelloCatalystIdMappingVarSampFields = {
  __typename?: 'crmYoutelloCatalystIdMappingVarSampFields';
  crmVisibility?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "crm.youtello_catalyst_id_mapping" */
export type crmYoutelloCatalystIdMappingVarSampOrderBy = {
  crmVisibility?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type crmYoutelloCatalystIdMappingVarianceFields = {
  __typename?: 'crmYoutelloCatalystIdMappingVarianceFields';
  crmVisibility?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "crm.youtello_catalyst_id_mapping" */
export type crmYoutelloCatalystIdMappingVarianceOrderBy = {
  crmVisibility?: InputMaybe<OrderBy>;
};

export type dashboardDataOutput = {
  __typename?: 'dashboardDataOutput';
  json?: Maybe<Scalars['json']['output']>;
};

export type deleteEmailProviderSubscriptionInput = {
  account: Scalars['String']['input'];
  id: Scalars['uuid']['input'];
  server: Scalars['String']['input'];
  subscriptionId: Scalars['uuid']['input'];
  type: Scalars['String']['input'];
  userId: Scalars['uuid']['input'];
};

export type deleteEmailProviderSubscriptionOutput = {
  __typename?: 'deleteEmailProviderSubscriptionOutput';
  subscriptionId: Scalars['uuid']['output'];
};

/** Aktiviteter */
export type domainActivity = {
  __typename?: 'domainActivity';
  /** An object relationship */
  activityStatus?: Maybe<ActivityStatus>;
  /** An object relationship */
  activityType?: Maybe<ActivityType>;
  additionalData?: Maybe<Scalars['jsonb']['output']>;
  channelActivityUuid?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  createdByUser?: Maybe<user>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  direction?: Maybe<ActivityDirectionEnum>;
  domain?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  domainParticipants: Array<domainParticipant>;
  /** An aggregate relationship */
  domainParticipantsAggregate: domainParticipantAggregate;
  emailChannel?: Maybe<Emailingactivity>;
  endedAt?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** Teknisk felt */
  number: Scalars['Int']['output'];
  /** An object relationship */
  owner?: Maybe<domainUser>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  provider?: Maybe<ActivityProviderEnum>;
  /** An object relationship */
  queueItem?: Maybe<queueItem>;
  requestEndedAt?: Maybe<Scalars['timestamptz']['output']>;
  requestStartedAt?: Maybe<Scalars['timestamptz']['output']>;
  schema?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<ActivityStatusEnum>;
  subTitle?: Maybe<Scalars['String']['output']>;
  table?: Maybe<Scalars['String']['output']>;
  taskChannel?: Maybe<TaskActivity>;
  telephonyChannel?: Maybe<Telephonyactivity>;
  title?: Maybe<Scalars['String']['output']>;
  triggerName?: Maybe<Scalars['String']['output']>;
  triggerTime?: Maybe<Scalars['timestamptz']['output']>;
  type?: Maybe<ActivityTypeEnum>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};


/** Aktiviteter */
export type domainActivityadditionalDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Aktiviteter */
export type domainActivitydomainParticipantsArgs = {
  distinctOn?: InputMaybe<Array<domainParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainParticipantOrderBy>>;
  where?: InputMaybe<domainParticipantBoolExp>;
};


/** Aktiviteter */
export type domainActivitydomainParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<domainParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainParticipantOrderBy>>;
  where?: InputMaybe<domainParticipantBoolExp>;
};

/** aggregated selection of "business.domain_activity" */
export type domainActivityAggregate = {
  __typename?: 'domainActivityAggregate';
  aggregate?: Maybe<domainActivityAggregateFields>;
  nodes: Array<domainActivity>;
};

export type domainActivityAggregateBoolExp = {
  count?: InputMaybe<domainActivityAggregateBoolExpCount>;
};

export type domainActivityAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<domainActivitySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<domainActivityBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "business.domain_activity" */
export type domainActivityAggregateFields = {
  __typename?: 'domainActivityAggregateFields';
  avg?: Maybe<domainActivityAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<domainActivityMaxFields>;
  min?: Maybe<domainActivityMinFields>;
  stddev?: Maybe<domainActivityStddevFields>;
  stddevPop?: Maybe<domainActivityStddevPopFields>;
  stddevSamp?: Maybe<domainActivityStddevSampFields>;
  sum?: Maybe<domainActivitySumFields>;
  varPop?: Maybe<domainActivityVarPopFields>;
  varSamp?: Maybe<domainActivityVarSampFields>;
  variance?: Maybe<domainActivityVarianceFields>;
};


/** aggregate fields of "business.domain_activity" */
export type domainActivityAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<domainActivitySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.domain_activity" */
export type domainActivityAggregateOrderBy = {
  avg?: InputMaybe<domainActivityAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<domainActivityMaxOrderBy>;
  min?: InputMaybe<domainActivityMinOrderBy>;
  stddev?: InputMaybe<domainActivityStddevOrderBy>;
  stddevPop?: InputMaybe<domainActivityStddevPopOrderBy>;
  stddevSamp?: InputMaybe<domainActivityStddevSampOrderBy>;
  sum?: InputMaybe<domainActivitySumOrderBy>;
  varPop?: InputMaybe<domainActivityVarPopOrderBy>;
  varSamp?: InputMaybe<domainActivityVarSampOrderBy>;
  variance?: InputMaybe<domainActivityVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type domainActivityAppendInput = {
  additionalData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "business.domain_activity" */
export type domainActivityArrRelInsertInput = {
  data: Array<domainActivityInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<domainActivityOnConflict>;
};

/** aggregate avg on columns */
export type domainActivityAvgFields = {
  __typename?: 'domainActivityAvgFields';
  /** Teknisk felt */
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "business.domain_activity" */
export type domainActivityAvgOrderBy = {
  /** Teknisk felt */
  number?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "business.domain_activity". All fields are combined with a logical 'AND'. */
export type domainActivityBoolExp = {
  _and?: InputMaybe<Array<domainActivityBoolExp>>;
  _not?: InputMaybe<domainActivityBoolExp>;
  _or?: InputMaybe<Array<domainActivityBoolExp>>;
  activityStatus?: InputMaybe<ActivityStatusBoolExp>;
  activityType?: InputMaybe<ActivityTypeBoolExp>;
  additionalData?: InputMaybe<JsonbComparisonExp>;
  channelActivityUuid?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUser?: InputMaybe<userBoolExp>;
  createdByUserId?: InputMaybe<UuidComparisonExp>;
  direction?: InputMaybe<ActivityDirectionEnumComparisonExp>;
  domain?: InputMaybe<StringComparisonExp>;
  domainParticipants?: InputMaybe<domainParticipantBoolExp>;
  domainParticipantsAggregate?: InputMaybe<domainParticipantAggregateBoolExp>;
  endedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  number?: InputMaybe<IntComparisonExp>;
  owner?: InputMaybe<domainUserBoolExp>;
  ownerId?: InputMaybe<UuidComparisonExp>;
  provider?: InputMaybe<ActivityProviderEnumComparisonExp>;
  queueItem?: InputMaybe<queueItemBoolExp>;
  requestEndedAt?: InputMaybe<TimestamptzComparisonExp>;
  requestStartedAt?: InputMaybe<TimestamptzComparisonExp>;
  schema?: InputMaybe<StringComparisonExp>;
  startedAt?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<ActivityStatusEnumComparisonExp>;
  subTitle?: InputMaybe<StringComparisonExp>;
  table?: InputMaybe<StringComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  triggerName?: InputMaybe<StringComparisonExp>;
  triggerTime?: InputMaybe<TimestamptzComparisonExp>;
  type?: InputMaybe<ActivityTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "business.domain_activity" */
export type domainActivityConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'activities_pkey'
  /** unique or primary key constraint on columns "channel_activity_uuid" */
  | 'activity_channel_activity_uuid_key'
  | '%future added value';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type domainActivityDeleteAtPathInput = {
  additionalData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type domainActivityDeleteElemInput = {
  additionalData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type domainActivityDeleteKeyInput = {
  additionalData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "business.domain_activity" */
export type domainActivityIncInput = {
  /** Teknisk felt */
  number?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "business.domain_activity" */
export type domainActivityInsertInput = {
  activityStatus?: InputMaybe<ActivityStatusObjRelInsertInput>;
  activityType?: InputMaybe<ActivityTypeObjRelInsertInput>;
  additionalData?: InputMaybe<Scalars['jsonb']['input']>;
  channelActivityUuid?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUser?: InputMaybe<userObjRelInsertInput>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  direction?: InputMaybe<ActivityDirectionEnum>;
  domain?: InputMaybe<Scalars['String']['input']>;
  domainParticipants?: InputMaybe<domainParticipantArrRelInsertInput>;
  endedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** Teknisk felt */
  number?: InputMaybe<Scalars['Int']['input']>;
  owner?: InputMaybe<domainUserObjRelInsertInput>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  provider?: InputMaybe<ActivityProviderEnum>;
  queueItem?: InputMaybe<queueItemObjRelInsertInput>;
  requestEndedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  requestStartedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  schema?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<ActivityStatusEnum>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  table?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  triggerName?: InputMaybe<Scalars['String']['input']>;
  triggerTime?: InputMaybe<Scalars['timestamptz']['input']>;
  type?: InputMaybe<ActivityTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type domainActivityMaxFields = {
  __typename?: 'domainActivityMaxFields';
  channelActivityUuid?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** Teknisk felt */
  number?: Maybe<Scalars['Int']['output']>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  requestEndedAt?: Maybe<Scalars['timestamptz']['output']>;
  requestStartedAt?: Maybe<Scalars['timestamptz']['output']>;
  schema?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['timestamptz']['output']>;
  subTitle?: Maybe<Scalars['String']['output']>;
  table?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  triggerName?: Maybe<Scalars['String']['output']>;
  triggerTime?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "business.domain_activity" */
export type domainActivityMaxOrderBy = {
  channelActivityUuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  domain?: InputMaybe<OrderBy>;
  endedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** Teknisk felt */
  number?: InputMaybe<OrderBy>;
  ownerId?: InputMaybe<OrderBy>;
  requestEndedAt?: InputMaybe<OrderBy>;
  requestStartedAt?: InputMaybe<OrderBy>;
  schema?: InputMaybe<OrderBy>;
  startedAt?: InputMaybe<OrderBy>;
  subTitle?: InputMaybe<OrderBy>;
  table?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  triggerName?: InputMaybe<OrderBy>;
  triggerTime?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type domainActivityMinFields = {
  __typename?: 'domainActivityMinFields';
  channelActivityUuid?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** Teknisk felt */
  number?: Maybe<Scalars['Int']['output']>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  requestEndedAt?: Maybe<Scalars['timestamptz']['output']>;
  requestStartedAt?: Maybe<Scalars['timestamptz']['output']>;
  schema?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['timestamptz']['output']>;
  subTitle?: Maybe<Scalars['String']['output']>;
  table?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  triggerName?: Maybe<Scalars['String']['output']>;
  triggerTime?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "business.domain_activity" */
export type domainActivityMinOrderBy = {
  channelActivityUuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  domain?: InputMaybe<OrderBy>;
  endedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  /** Teknisk felt */
  number?: InputMaybe<OrderBy>;
  ownerId?: InputMaybe<OrderBy>;
  requestEndedAt?: InputMaybe<OrderBy>;
  requestStartedAt?: InputMaybe<OrderBy>;
  schema?: InputMaybe<OrderBy>;
  startedAt?: InputMaybe<OrderBy>;
  subTitle?: InputMaybe<OrderBy>;
  table?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  triggerName?: InputMaybe<OrderBy>;
  triggerTime?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "business.domain_activity" */
export type domainActivityMutationResponse = {
  __typename?: 'domainActivityMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<domainActivity>;
};

/** input type for inserting object relation for remote table "business.domain_activity" */
export type domainActivityObjRelInsertInput = {
  data: domainActivityInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<domainActivityOnConflict>;
};

/** on_conflict condition type for table "business.domain_activity" */
export type domainActivityOnConflict = {
  constraint: domainActivityConstraint;
  updateColumns?: Array<domainActivityUpdateColumn>;
  where?: InputMaybe<domainActivityBoolExp>;
};

/** Ordering options when selecting data from "business.domain_activity". */
export type domainActivityOrderBy = {
  activityStatus?: InputMaybe<ActivityStatusOrderBy>;
  activityType?: InputMaybe<ActivityTypeOrderBy>;
  additionalData?: InputMaybe<OrderBy>;
  channelActivityUuid?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUser?: InputMaybe<userOrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  direction?: InputMaybe<OrderBy>;
  domain?: InputMaybe<OrderBy>;
  domainParticipantsAggregate?: InputMaybe<domainParticipantAggregateOrderBy>;
  endedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  number?: InputMaybe<OrderBy>;
  owner?: InputMaybe<domainUserOrderBy>;
  ownerId?: InputMaybe<OrderBy>;
  provider?: InputMaybe<OrderBy>;
  queueItem?: InputMaybe<queueItemOrderBy>;
  requestEndedAt?: InputMaybe<OrderBy>;
  requestStartedAt?: InputMaybe<OrderBy>;
  schema?: InputMaybe<OrderBy>;
  startedAt?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  subTitle?: InputMaybe<OrderBy>;
  table?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  triggerName?: InputMaybe<OrderBy>;
  triggerTime?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.domain_activity */
export type domainActivityPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type domainActivityPrependInput = {
  additionalData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "business.domain_activity" */
export type domainActivitySelectColumn =
  /** column name */
  | 'additionalData'
  /** column name */
  | 'channelActivityUuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserId'
  /** column name */
  | 'direction'
  /** column name */
  | 'domain'
  /** column name */
  | 'endedAt'
  /** column name */
  | 'id'
  /** column name */
  | 'number'
  /** column name */
  | 'ownerId'
  /** column name */
  | 'provider'
  /** column name */
  | 'requestEndedAt'
  /** column name */
  | 'requestStartedAt'
  /** column name */
  | 'schema'
  /** column name */
  | 'startedAt'
  /** column name */
  | 'status'
  /** column name */
  | 'subTitle'
  /** column name */
  | 'table'
  /** column name */
  | 'title'
  /** column name */
  | 'triggerName'
  /** column name */
  | 'triggerTime'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "business.domain_activity" */
export type domainActivitySetInput = {
  additionalData?: InputMaybe<Scalars['jsonb']['input']>;
  channelActivityUuid?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  direction?: InputMaybe<ActivityDirectionEnum>;
  domain?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** Teknisk felt */
  number?: InputMaybe<Scalars['Int']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  provider?: InputMaybe<ActivityProviderEnum>;
  requestEndedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  requestStartedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  schema?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<ActivityStatusEnum>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  table?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  triggerName?: InputMaybe<Scalars['String']['input']>;
  triggerTime?: InputMaybe<Scalars['timestamptz']['input']>;
  type?: InputMaybe<ActivityTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type domainActivityStddevFields = {
  __typename?: 'domainActivityStddevFields';
  /** Teknisk felt */
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "business.domain_activity" */
export type domainActivityStddevOrderBy = {
  /** Teknisk felt */
  number?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type domainActivityStddevPopFields = {
  __typename?: 'domainActivityStddevPopFields';
  /** Teknisk felt */
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "business.domain_activity" */
export type domainActivityStddevPopOrderBy = {
  /** Teknisk felt */
  number?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type domainActivityStddevSampFields = {
  __typename?: 'domainActivityStddevSampFields';
  /** Teknisk felt */
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "business.domain_activity" */
export type domainActivityStddevSampOrderBy = {
  /** Teknisk felt */
  number?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "domainActivity" */
export type domainActivityStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: domainActivityStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type domainActivityStreamCursorValueInput = {
  additionalData?: InputMaybe<Scalars['jsonb']['input']>;
  channelActivityUuid?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  direction?: InputMaybe<ActivityDirectionEnum>;
  domain?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** Teknisk felt */
  number?: InputMaybe<Scalars['Int']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  provider?: InputMaybe<ActivityProviderEnum>;
  requestEndedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  requestStartedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  schema?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<ActivityStatusEnum>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  table?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  triggerName?: InputMaybe<Scalars['String']['input']>;
  triggerTime?: InputMaybe<Scalars['timestamptz']['input']>;
  type?: InputMaybe<ActivityTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type domainActivitySumFields = {
  __typename?: 'domainActivitySumFields';
  /** Teknisk felt */
  number?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "business.domain_activity" */
export type domainActivitySumOrderBy = {
  /** Teknisk felt */
  number?: InputMaybe<OrderBy>;
};

/** update columns of table "business.domain_activity" */
export type domainActivityUpdateColumn =
  /** column name */
  | 'additionalData'
  /** column name */
  | 'channelActivityUuid'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserId'
  /** column name */
  | 'direction'
  /** column name */
  | 'domain'
  /** column name */
  | 'endedAt'
  /** column name */
  | 'id'
  /** column name */
  | 'number'
  /** column name */
  | 'ownerId'
  /** column name */
  | 'provider'
  /** column name */
  | 'requestEndedAt'
  /** column name */
  | 'requestStartedAt'
  /** column name */
  | 'schema'
  /** column name */
  | 'startedAt'
  /** column name */
  | 'status'
  /** column name */
  | 'subTitle'
  /** column name */
  | 'table'
  /** column name */
  | 'title'
  /** column name */
  | 'triggerName'
  /** column name */
  | 'triggerTime'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type domainActivityUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<domainActivityAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<domainActivityDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<domainActivityDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<domainActivityDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<domainActivityIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<domainActivityPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<domainActivitySetInput>;
  /** filter the rows which have to be updated */
  where: domainActivityBoolExp;
};

/** aggregate varPop on columns */
export type domainActivityVarPopFields = {
  __typename?: 'domainActivityVarPopFields';
  /** Teknisk felt */
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "business.domain_activity" */
export type domainActivityVarPopOrderBy = {
  /** Teknisk felt */
  number?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type domainActivityVarSampFields = {
  __typename?: 'domainActivityVarSampFields';
  /** Teknisk felt */
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "business.domain_activity" */
export type domainActivityVarSampOrderBy = {
  /** Teknisk felt */
  number?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type domainActivityVarianceFields = {
  __typename?: 'domainActivityVarianceFields';
  /** Teknisk felt */
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "business.domain_activity" */
export type domainActivityVarianceOrderBy = {
  /** Teknisk felt */
  number?: InputMaybe<OrderBy>;
};

/** columns and relationships of "business.domain_organization" */
export type domainOrganization = {
  __typename?: 'domainOrganization';
  /** Administrator of domain-org (organization.organization_user.id). */
  adminId?: Maybe<Scalars['uuid']['output']>;
  autoGenerated?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  domainOrganizationUuid?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  domainType?: Maybe<domainType>;
  domainTypeId?: Maybe<domainTypeEnum>;
  /** An array relationship */
  domainUsers: Array<domainUser>;
  /** An aggregate relationship */
  domainUsersAggregate: domainUserAggregate;
  /** An array relationship */
  emailDomainOrganization: Array<domainOrganization>;
  /** An aggregate relationship */
  emailDomainOrganizationAggregate: domainOrganizationAggregate;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organization?: Maybe<organization>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organizationUser?: Maybe<organizationUser>;
  /** E.g. Phonero customer id */
  providerClientId?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  telephonyDomainOrganization: Array<domainOrganization>;
  /** An aggregate relationship */
  telephonyDomainOrganizationAggregate: domainOrganizationAggregate;
  triggerName?: Maybe<Scalars['String']['output']>;
  triggerTime?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "business.domain_organization" */
export type domainOrganizationdomainUsersArgs = {
  distinctOn?: InputMaybe<Array<domainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainUserOrderBy>>;
  where?: InputMaybe<domainUserBoolExp>;
};


/** columns and relationships of "business.domain_organization" */
export type domainOrganizationdomainUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<domainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainUserOrderBy>>;
  where?: InputMaybe<domainUserBoolExp>;
};


/** columns and relationships of "business.domain_organization" */
export type domainOrganizationemailDomainOrganizationArgs = {
  distinctOn?: InputMaybe<Array<domainOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainOrganizationOrderBy>>;
  where?: InputMaybe<domainOrganizationBoolExp>;
};


/** columns and relationships of "business.domain_organization" */
export type domainOrganizationemailDomainOrganizationAggregateArgs = {
  distinctOn?: InputMaybe<Array<domainOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainOrganizationOrderBy>>;
  where?: InputMaybe<domainOrganizationBoolExp>;
};


/** columns and relationships of "business.domain_organization" */
export type domainOrganizationtelephonyDomainOrganizationArgs = {
  distinctOn?: InputMaybe<Array<domainOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainOrganizationOrderBy>>;
  where?: InputMaybe<domainOrganizationBoolExp>;
};


/** columns and relationships of "business.domain_organization" */
export type domainOrganizationtelephonyDomainOrganizationAggregateArgs = {
  distinctOn?: InputMaybe<Array<domainOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainOrganizationOrderBy>>;
  where?: InputMaybe<domainOrganizationBoolExp>;
};

/** aggregated selection of "business.domain_organization" */
export type domainOrganizationAggregate = {
  __typename?: 'domainOrganizationAggregate';
  aggregate?: Maybe<domainOrganizationAggregateFields>;
  nodes: Array<domainOrganization>;
};

export type domainOrganizationAggregateBoolExp = {
  bool_and?: InputMaybe<domainOrganizationAggregateBoolExpBool_and>;
  bool_or?: InputMaybe<domainOrganizationAggregateBoolExpBool_or>;
  count?: InputMaybe<domainOrganizationAggregateBoolExpCount>;
};

export type domainOrganizationAggregateBoolExpBool_and = {
  arguments: domainOrganizationSelectColumnDomainOrganizationAggregateBoolExpBool_andArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<domainOrganizationBoolExp>;
  predicate: BooleanComparisonExp;
};

export type domainOrganizationAggregateBoolExpBool_or = {
  arguments: domainOrganizationSelectColumnDomainOrganizationAggregateBoolExpBool_orArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<domainOrganizationBoolExp>;
  predicate: BooleanComparisonExp;
};

export type domainOrganizationAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<domainOrganizationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<domainOrganizationBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "business.domain_organization" */
export type domainOrganizationAggregateFields = {
  __typename?: 'domainOrganizationAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<domainOrganizationMaxFields>;
  min?: Maybe<domainOrganizationMinFields>;
};


/** aggregate fields of "business.domain_organization" */
export type domainOrganizationAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<domainOrganizationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.domain_organization" */
export type domainOrganizationAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<domainOrganizationMaxOrderBy>;
  min?: InputMaybe<domainOrganizationMinOrderBy>;
};

/** input type for inserting array relation for remote table "business.domain_organization" */
export type domainOrganizationArrRelInsertInput = {
  data: Array<domainOrganizationInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<domainOrganizationOnConflict>;
};

/** Boolean expression to filter rows from the table "business.domain_organization". All fields are combined with a logical 'AND'. */
export type domainOrganizationBoolExp = {
  _and?: InputMaybe<Array<domainOrganizationBoolExp>>;
  _not?: InputMaybe<domainOrganizationBoolExp>;
  _or?: InputMaybe<Array<domainOrganizationBoolExp>>;
  adminId?: InputMaybe<UuidComparisonExp>;
  autoGenerated?: InputMaybe<BooleanComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  domainOrganizationUuid?: InputMaybe<UuidComparisonExp>;
  domainType?: InputMaybe<domainTypeBoolExp>;
  domainTypeId?: InputMaybe<DomainTypeEnumComparisonExp>;
  domainUsers?: InputMaybe<domainUserBoolExp>;
  domainUsersAggregate?: InputMaybe<domainUserAggregateBoolExp>;
  emailDomainOrganization?: InputMaybe<domainOrganizationBoolExp>;
  emailDomainOrganizationAggregate?: InputMaybe<domainOrganizationAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organization?: InputMaybe<organizationBoolExp>;
  organizationId?: InputMaybe<UuidComparisonExp>;
  organizationUser?: InputMaybe<organizationUserBoolExp>;
  providerClientId?: InputMaybe<StringComparisonExp>;
  telephonyDomainOrganization?: InputMaybe<domainOrganizationBoolExp>;
  telephonyDomainOrganizationAggregate?: InputMaybe<domainOrganizationAggregateBoolExp>;
  triggerName?: InputMaybe<StringComparisonExp>;
  triggerTime?: InputMaybe<TimestamptzComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "business.domain_organization" */
export type domainOrganizationConstraint =
  /** unique or primary key constraint on columns "domain_organization_uuid" */
  | 'domain_organization_domain_organization_uuid_key'
  /** unique or primary key constraint on columns "id" */
  | 'domain_organization_pkey'
  | '%future added value';

/** input type for inserting data into table "business.domain_organization" */
export type domainOrganizationInsertInput = {
  /** Administrator of domain-org (organization.organization_user.id). */
  adminId?: InputMaybe<Scalars['uuid']['input']>;
  autoGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  domainOrganizationUuid?: InputMaybe<Scalars['uuid']['input']>;
  domainType?: InputMaybe<domainTypeObjRelInsertInput>;
  domainTypeId?: InputMaybe<domainTypeEnum>;
  domainUsers?: InputMaybe<domainUserArrRelInsertInput>;
  emailDomainOrganization?: InputMaybe<domainOrganizationArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization?: InputMaybe<organizationObjRelInsertInput>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  organizationUser?: InputMaybe<organizationUserObjRelInsertInput>;
  /** E.g. Phonero customer id */
  providerClientId?: InputMaybe<Scalars['String']['input']>;
  telephonyDomainOrganization?: InputMaybe<domainOrganizationArrRelInsertInput>;
  triggerName?: InputMaybe<Scalars['String']['input']>;
  triggerTime?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type domainOrganizationMaxFields = {
  __typename?: 'domainOrganizationMaxFields';
  /** Administrator of domain-org (organization.organization_user.id). */
  adminId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  domainOrganizationUuid?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  /** E.g. Phonero customer id */
  providerClientId?: Maybe<Scalars['String']['output']>;
  triggerName?: Maybe<Scalars['String']['output']>;
  triggerTime?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "business.domain_organization" */
export type domainOrganizationMaxOrderBy = {
  /** Administrator of domain-org (organization.organization_user.id). */
  adminId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  domainOrganizationUuid?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  /** E.g. Phonero customer id */
  providerClientId?: InputMaybe<OrderBy>;
  triggerName?: InputMaybe<OrderBy>;
  triggerTime?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type domainOrganizationMinFields = {
  __typename?: 'domainOrganizationMinFields';
  /** Administrator of domain-org (organization.organization_user.id). */
  adminId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  domainOrganizationUuid?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  /** E.g. Phonero customer id */
  providerClientId?: Maybe<Scalars['String']['output']>;
  triggerName?: Maybe<Scalars['String']['output']>;
  triggerTime?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "business.domain_organization" */
export type domainOrganizationMinOrderBy = {
  /** Administrator of domain-org (organization.organization_user.id). */
  adminId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  domainOrganizationUuid?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  /** E.g. Phonero customer id */
  providerClientId?: InputMaybe<OrderBy>;
  triggerName?: InputMaybe<OrderBy>;
  triggerTime?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "business.domain_organization" */
export type domainOrganizationMutationResponse = {
  __typename?: 'domainOrganizationMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<domainOrganization>;
};

/** input type for inserting object relation for remote table "business.domain_organization" */
export type domainOrganizationObjRelInsertInput = {
  data: domainOrganizationInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<domainOrganizationOnConflict>;
};

/** on_conflict condition type for table "business.domain_organization" */
export type domainOrganizationOnConflict = {
  constraint: domainOrganizationConstraint;
  updateColumns?: Array<domainOrganizationUpdateColumn>;
  where?: InputMaybe<domainOrganizationBoolExp>;
};

/** Ordering options when selecting data from "business.domain_organization". */
export type domainOrganizationOrderBy = {
  adminId?: InputMaybe<OrderBy>;
  autoGenerated?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  domainOrganizationUuid?: InputMaybe<OrderBy>;
  domainType?: InputMaybe<domainTypeOrderBy>;
  domainTypeId?: InputMaybe<OrderBy>;
  domainUsersAggregate?: InputMaybe<domainUserAggregateOrderBy>;
  emailDomainOrganizationAggregate?: InputMaybe<domainOrganizationAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  organization?: InputMaybe<organizationOrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  organizationUser?: InputMaybe<organizationUserOrderBy>;
  providerClientId?: InputMaybe<OrderBy>;
  telephonyDomainOrganizationAggregate?: InputMaybe<domainOrganizationAggregateOrderBy>;
  triggerName?: InputMaybe<OrderBy>;
  triggerTime?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.domain_organization */
export type domainOrganizationPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "business.domain_organization" */
export type domainOrganizationSelectColumn =
  /** column name */
  | 'adminId'
  /** column name */
  | 'autoGenerated'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'domainOrganizationUuid'
  /** column name */
  | 'domainTypeId'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'providerClientId'
  /** column name */
  | 'triggerName'
  /** column name */
  | 'triggerTime'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** select "domainOrganizationAggregateBoolExpBool_andArgumentsColumns" columns of table "business.domain_organization" */
export type domainOrganizationSelectColumnDomainOrganizationAggregateBoolExpBool_andArgumentsColumns =
  /** column name */
  | 'autoGenerated'
  | '%future added value';

/** select "domainOrganizationAggregateBoolExpBool_orArgumentsColumns" columns of table "business.domain_organization" */
export type domainOrganizationSelectColumnDomainOrganizationAggregateBoolExpBool_orArgumentsColumns =
  /** column name */
  | 'autoGenerated'
  | '%future added value';

/** input type for updating data in table "business.domain_organization" */
export type domainOrganizationSetInput = {
  /** Administrator of domain-org (organization.organization_user.id). */
  adminId?: InputMaybe<Scalars['uuid']['input']>;
  autoGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  domainOrganizationUuid?: InputMaybe<Scalars['uuid']['input']>;
  domainTypeId?: InputMaybe<domainTypeEnum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  /** E.g. Phonero customer id */
  providerClientId?: InputMaybe<Scalars['String']['input']>;
  triggerName?: InputMaybe<Scalars['String']['input']>;
  triggerTime?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "domainOrganization" */
export type domainOrganizationStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: domainOrganizationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type domainOrganizationStreamCursorValueInput = {
  /** Administrator of domain-org (organization.organization_user.id). */
  adminId?: InputMaybe<Scalars['uuid']['input']>;
  autoGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  domainOrganizationUuid?: InputMaybe<Scalars['uuid']['input']>;
  domainTypeId?: InputMaybe<domainTypeEnum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  /** E.g. Phonero customer id */
  providerClientId?: InputMaybe<Scalars['String']['input']>;
  triggerName?: InputMaybe<Scalars['String']['input']>;
  triggerTime?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "business.domain_organization" */
export type domainOrganizationUpdateColumn =
  /** column name */
  | 'adminId'
  /** column name */
  | 'autoGenerated'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'domainOrganizationUuid'
  /** column name */
  | 'domainTypeId'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'providerClientId'
  /** column name */
  | 'triggerName'
  /** column name */
  | 'triggerTime'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type domainOrganizationUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<domainOrganizationSetInput>;
  /** filter the rows which have to be updated */
  where: domainOrganizationBoolExp;
};

/** columns and relationships of "business.domain_participant" */
export type domainParticipant = {
  __typename?: 'domainParticipant';
  activityId?: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  domainActivity?: Maybe<domainActivity>;
  /** An object relationship */
  domainUser?: Maybe<domainUser>;
  domainUserId?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  triggerName?: Maybe<Scalars['String']['output']>;
  triggerTime?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "business.domain_participant" */
export type domainParticipantAggregate = {
  __typename?: 'domainParticipantAggregate';
  aggregate?: Maybe<domainParticipantAggregateFields>;
  nodes: Array<domainParticipant>;
};

export type domainParticipantAggregateBoolExp = {
  count?: InputMaybe<domainParticipantAggregateBoolExpCount>;
};

export type domainParticipantAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<domainParticipantSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<domainParticipantBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "business.domain_participant" */
export type domainParticipantAggregateFields = {
  __typename?: 'domainParticipantAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<domainParticipantMaxFields>;
  min?: Maybe<domainParticipantMinFields>;
};


/** aggregate fields of "business.domain_participant" */
export type domainParticipantAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<domainParticipantSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.domain_participant" */
export type domainParticipantAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<domainParticipantMaxOrderBy>;
  min?: InputMaybe<domainParticipantMinOrderBy>;
};

/** input type for inserting array relation for remote table "business.domain_participant" */
export type domainParticipantArrRelInsertInput = {
  data: Array<domainParticipantInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<domainParticipantOnConflict>;
};

/** Boolean expression to filter rows from the table "business.domain_participant". All fields are combined with a logical 'AND'. */
export type domainParticipantBoolExp = {
  _and?: InputMaybe<Array<domainParticipantBoolExp>>;
  _not?: InputMaybe<domainParticipantBoolExp>;
  _or?: InputMaybe<Array<domainParticipantBoolExp>>;
  activityId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  domainActivity?: InputMaybe<domainActivityBoolExp>;
  domainUser?: InputMaybe<domainUserBoolExp>;
  domainUserId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  triggerName?: InputMaybe<StringComparisonExp>;
  triggerTime?: InputMaybe<TimestamptzComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "business.domain_participant" */
export type domainParticipantConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'activity_participant_pkey'
  | '%future added value';

/** input type for inserting data into table "business.domain_participant" */
export type domainParticipantInsertInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  domainActivity?: InputMaybe<domainActivityObjRelInsertInput>;
  domainUser?: InputMaybe<domainUserObjRelInsertInput>;
  domainUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  triggerName?: InputMaybe<Scalars['String']['input']>;
  triggerTime?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type domainParticipantMaxFields = {
  __typename?: 'domainParticipantMaxFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  domainUserId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  triggerName?: Maybe<Scalars['String']['output']>;
  triggerTime?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "business.domain_participant" */
export type domainParticipantMaxOrderBy = {
  activityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  domainUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  triggerName?: InputMaybe<OrderBy>;
  triggerTime?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type domainParticipantMinFields = {
  __typename?: 'domainParticipantMinFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  domainUserId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  triggerName?: Maybe<Scalars['String']['output']>;
  triggerTime?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "business.domain_participant" */
export type domainParticipantMinOrderBy = {
  activityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  domainUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  triggerName?: InputMaybe<OrderBy>;
  triggerTime?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "business.domain_participant" */
export type domainParticipantMutationResponse = {
  __typename?: 'domainParticipantMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<domainParticipant>;
};

/** on_conflict condition type for table "business.domain_participant" */
export type domainParticipantOnConflict = {
  constraint: domainParticipantConstraint;
  updateColumns?: Array<domainParticipantUpdateColumn>;
  where?: InputMaybe<domainParticipantBoolExp>;
};

/** Ordering options when selecting data from "business.domain_participant". */
export type domainParticipantOrderBy = {
  activityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  domainActivity?: InputMaybe<domainActivityOrderBy>;
  domainUser?: InputMaybe<domainUserOrderBy>;
  domainUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  triggerName?: InputMaybe<OrderBy>;
  triggerTime?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.domain_participant */
export type domainParticipantPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "business.domain_participant" */
export type domainParticipantSelectColumn =
  /** column name */
  | 'activityId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'domainUserId'
  /** column name */
  | 'id'
  /** column name */
  | 'triggerName'
  /** column name */
  | 'triggerTime'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "business.domain_participant" */
export type domainParticipantSetInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  domainUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  triggerName?: InputMaybe<Scalars['String']['input']>;
  triggerTime?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "domainParticipant" */
export type domainParticipantStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: domainParticipantStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type domainParticipantStreamCursorValueInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  domainUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  triggerName?: InputMaybe<Scalars['String']['input']>;
  triggerTime?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "business.domain_participant" */
export type domainParticipantUpdateColumn =
  /** column name */
  | 'activityId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'domainUserId'
  /** column name */
  | 'id'
  /** column name */
  | 'triggerName'
  /** column name */
  | 'triggerTime'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type domainParticipantUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<domainParticipantSetInput>;
  /** filter the rows which have to be updated */
  where: domainParticipantBoolExp;
};

/** columns and relationships of "business.domain_type" */
export type domainType = {
  __typename?: 'domainType';
  description: Scalars['String']['output'];
  /** An array relationship */
  domainOrganizations: Array<domainOrganization>;
  /** An aggregate relationship */
  domainOrganizationsAggregate: domainOrganizationAggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "business.domain_type" */
export type domainTypedomainOrganizationsArgs = {
  distinctOn?: InputMaybe<Array<domainOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainOrganizationOrderBy>>;
  where?: InputMaybe<domainOrganizationBoolExp>;
};


/** columns and relationships of "business.domain_type" */
export type domainTypedomainOrganizationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<domainOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainOrganizationOrderBy>>;
  where?: InputMaybe<domainOrganizationBoolExp>;
};

/** aggregated selection of "business.domain_type" */
export type domainTypeAggregate = {
  __typename?: 'domainTypeAggregate';
  aggregate?: Maybe<domainTypeAggregateFields>;
  nodes: Array<domainType>;
};

/** aggregate fields of "business.domain_type" */
export type domainTypeAggregateFields = {
  __typename?: 'domainTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<domainTypeMaxFields>;
  min?: Maybe<domainTypeMinFields>;
};


/** aggregate fields of "business.domain_type" */
export type domainTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<domainTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.domain_type". All fields are combined with a logical 'AND'. */
export type domainTypeBoolExp = {
  _and?: InputMaybe<Array<domainTypeBoolExp>>;
  _not?: InputMaybe<domainTypeBoolExp>;
  _or?: InputMaybe<Array<domainTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  domainOrganizations?: InputMaybe<domainOrganizationBoolExp>;
  domainOrganizationsAggregate?: InputMaybe<domainOrganizationAggregateBoolExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.domain_type" */
export type domainTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'domain_type_pkey'
  | '%future added value';

export type domainTypeEnum =
  /** Email */
  | 'EMAIL'
  /** General */
  | 'GENERAL'
  /** Messaging */
  | 'MESSAGING'
  /** Telephony */
  | 'TELEPHONY'
  | '%future added value';

/** input type for inserting data into table "business.domain_type" */
export type domainTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  domainOrganizations?: InputMaybe<domainOrganizationArrRelInsertInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type domainTypeMaxFields = {
  __typename?: 'domainTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type domainTypeMinFields = {
  __typename?: 'domainTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.domain_type" */
export type domainTypeMutationResponse = {
  __typename?: 'domainTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<domainType>;
};

/** input type for inserting object relation for remote table "business.domain_type" */
export type domainTypeObjRelInsertInput = {
  data: domainTypeInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<domainTypeOnConflict>;
};

/** on_conflict condition type for table "business.domain_type" */
export type domainTypeOnConflict = {
  constraint: domainTypeConstraint;
  updateColumns?: Array<domainTypeUpdateColumn>;
  where?: InputMaybe<domainTypeBoolExp>;
};

/** Ordering options when selecting data from "business.domain_type". */
export type domainTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  domainOrganizationsAggregate?: InputMaybe<domainOrganizationAggregateOrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.domain_type */
export type domainTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "business.domain_type" */
export type domainTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "business.domain_type" */
export type domainTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "domainType" */
export type domainTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: domainTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type domainTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.domain_type" */
export type domainTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type domainTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<domainTypeSetInput>;
  /** filter the rows which have to be updated */
  where: domainTypeBoolExp;
};

/** columns and relationships of "business.domain_user" */
export type domainUser = {
  __typename?: 'domainUser';
  category?: Maybe<domainUserCategoryEnum>;
  city?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  department?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  domainOrganization?: Maybe<domainOrganization>;
  domainOrganizationId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  domainParticipants: Array<domainParticipant>;
  /** An aggregate relationship */
  domainParticipantsAggregate: domainParticipantAggregate;
  /** An object relationship */
  domainUserCategory?: Maybe<domainUserCategory>;
  domainUserUuid?: Maybe<Scalars['uuid']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  emailDomainUser?: Maybe<EmailingdomainUser>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  relOrganizationUser: Array<relOrganizationUserDomainUser>;
  /** An aggregate relationship */
  relOrganizationUserAggregate: relOrganizationUserDomainUserAggregate;
  source?: Maybe<Scalars['String']['output']>;
  spamScore: Scalars['Int']['output'];
  street?: Maybe<Scalars['String']['output']>;
  taskDomainUser?: Maybe<TaskDomainUser>;
  telephonyDomainUser?: Maybe<TelephonydomainUser>;
  triggerName?: Maybe<Scalars['String']['output']>;
  triggerTime?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "business.domain_user" */
export type domainUserdomainParticipantsArgs = {
  distinctOn?: InputMaybe<Array<domainParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainParticipantOrderBy>>;
  where?: InputMaybe<domainParticipantBoolExp>;
};


/** columns and relationships of "business.domain_user" */
export type domainUserdomainParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<domainParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainParticipantOrderBy>>;
  where?: InputMaybe<domainParticipantBoolExp>;
};


/** columns and relationships of "business.domain_user" */
export type domainUserrelOrganizationUserArgs = {
  distinctOn?: InputMaybe<Array<relOrganizationUserDomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<relOrganizationUserDomainUserOrderBy>>;
  where?: InputMaybe<relOrganizationUserDomainUserBoolExp>;
};


/** columns and relationships of "business.domain_user" */
export type domainUserrelOrganizationUserAggregateArgs = {
  distinctOn?: InputMaybe<Array<relOrganizationUserDomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<relOrganizationUserDomainUserOrderBy>>;
  where?: InputMaybe<relOrganizationUserDomainUserBoolExp>;
};

/** aggregated selection of "business.domain_user" */
export type domainUserAggregate = {
  __typename?: 'domainUserAggregate';
  aggregate?: Maybe<domainUserAggregateFields>;
  nodes: Array<domainUser>;
};

export type domainUserAggregateBoolExp = {
  count?: InputMaybe<domainUserAggregateBoolExpCount>;
};

export type domainUserAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<domainUserSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<domainUserBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "business.domain_user" */
export type domainUserAggregateFields = {
  __typename?: 'domainUserAggregateFields';
  avg?: Maybe<domainUserAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<domainUserMaxFields>;
  min?: Maybe<domainUserMinFields>;
  stddev?: Maybe<domainUserStddevFields>;
  stddevPop?: Maybe<domainUserStddevPopFields>;
  stddevSamp?: Maybe<domainUserStddevSampFields>;
  sum?: Maybe<domainUserSumFields>;
  varPop?: Maybe<domainUserVarPopFields>;
  varSamp?: Maybe<domainUserVarSampFields>;
  variance?: Maybe<domainUserVarianceFields>;
};


/** aggregate fields of "business.domain_user" */
export type domainUserAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<domainUserSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.domain_user" */
export type domainUserAggregateOrderBy = {
  avg?: InputMaybe<domainUserAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<domainUserMaxOrderBy>;
  min?: InputMaybe<domainUserMinOrderBy>;
  stddev?: InputMaybe<domainUserStddevOrderBy>;
  stddevPop?: InputMaybe<domainUserStddevPopOrderBy>;
  stddevSamp?: InputMaybe<domainUserStddevSampOrderBy>;
  sum?: InputMaybe<domainUserSumOrderBy>;
  varPop?: InputMaybe<domainUserVarPopOrderBy>;
  varSamp?: InputMaybe<domainUserVarSampOrderBy>;
  variance?: InputMaybe<domainUserVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "business.domain_user" */
export type domainUserArrRelInsertInput = {
  data: Array<domainUserInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<domainUserOnConflict>;
};

/** aggregate avg on columns */
export type domainUserAvgFields = {
  __typename?: 'domainUserAvgFields';
  spamScore?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "business.domain_user" */
export type domainUserAvgOrderBy = {
  spamScore?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "business.domain_user". All fields are combined with a logical 'AND'. */
export type domainUserBoolExp = {
  _and?: InputMaybe<Array<domainUserBoolExp>>;
  _not?: InputMaybe<domainUserBoolExp>;
  _or?: InputMaybe<Array<domainUserBoolExp>>;
  category?: InputMaybe<DomainUserCategoryEnumComparisonExp>;
  city?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  department?: InputMaybe<StringComparisonExp>;
  domainOrganization?: InputMaybe<domainOrganizationBoolExp>;
  domainOrganizationId?: InputMaybe<UuidComparisonExp>;
  domainParticipants?: InputMaybe<domainParticipantBoolExp>;
  domainParticipantsAggregate?: InputMaybe<domainParticipantAggregateBoolExp>;
  domainUserCategory?: InputMaybe<domainUserCategoryBoolExp>;
  domainUserUuid?: InputMaybe<UuidComparisonExp>;
  emailAddress?: InputMaybe<StringComparisonExp>;
  firstName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lastName?: InputMaybe<StringComparisonExp>;
  organizationUserId?: InputMaybe<UuidComparisonExp>;
  phoneNumber?: InputMaybe<StringComparisonExp>;
  position?: InputMaybe<StringComparisonExp>;
  relOrganizationUser?: InputMaybe<relOrganizationUserDomainUserBoolExp>;
  relOrganizationUserAggregate?: InputMaybe<relOrganizationUserDomainUserAggregateBoolExp>;
  source?: InputMaybe<StringComparisonExp>;
  spamScore?: InputMaybe<IntComparisonExp>;
  street?: InputMaybe<StringComparisonExp>;
  triggerName?: InputMaybe<StringComparisonExp>;
  triggerTime?: InputMaybe<TimestamptzComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  zip?: InputMaybe<StringComparisonExp>;
};

/** columns and relationships of "business.domain_user_category" */
export type domainUserCategory = {
  __typename?: 'domainUserCategory';
  description: Scalars['String']['output'];
  /** An array relationship */
  domainUsers: Array<domainUser>;
  /** An aggregate relationship */
  domainUsersAggregate: domainUserAggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "business.domain_user_category" */
export type domainUserCategorydomainUsersArgs = {
  distinctOn?: InputMaybe<Array<domainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainUserOrderBy>>;
  where?: InputMaybe<domainUserBoolExp>;
};


/** columns and relationships of "business.domain_user_category" */
export type domainUserCategorydomainUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<domainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainUserOrderBy>>;
  where?: InputMaybe<domainUserBoolExp>;
};

/** aggregated selection of "business.domain_user_category" */
export type domainUserCategoryAggregate = {
  __typename?: 'domainUserCategoryAggregate';
  aggregate?: Maybe<domainUserCategoryAggregateFields>;
  nodes: Array<domainUserCategory>;
};

/** aggregate fields of "business.domain_user_category" */
export type domainUserCategoryAggregateFields = {
  __typename?: 'domainUserCategoryAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<domainUserCategoryMaxFields>;
  min?: Maybe<domainUserCategoryMinFields>;
};


/** aggregate fields of "business.domain_user_category" */
export type domainUserCategoryAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<domainUserCategorySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.domain_user_category". All fields are combined with a logical 'AND'. */
export type domainUserCategoryBoolExp = {
  _and?: InputMaybe<Array<domainUserCategoryBoolExp>>;
  _not?: InputMaybe<domainUserCategoryBoolExp>;
  _or?: InputMaybe<Array<domainUserCategoryBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  domainUsers?: InputMaybe<domainUserBoolExp>;
  domainUsersAggregate?: InputMaybe<domainUserAggregateBoolExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.domain_user_category" */
export type domainUserCategoryConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'telephony_domain_user_category_pkey'
  | '%future added value';

export type domainUserCategoryEnum =
  /** Customer */
  | 'CUSTOMER'
  /** Customer Candidate */
  | 'CUSTOMER_CANDIDATE'
  /** Employee */
  | 'EMPLOYEE'
  /** Employee Candidate */
  | 'EMPLOYEE_CANDIDATE'
  | '%future added value';

/** input type for inserting data into table "business.domain_user_category" */
export type domainUserCategoryInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  domainUsers?: InputMaybe<domainUserArrRelInsertInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type domainUserCategoryMaxFields = {
  __typename?: 'domainUserCategoryMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type domainUserCategoryMinFields = {
  __typename?: 'domainUserCategoryMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.domain_user_category" */
export type domainUserCategoryMutationResponse = {
  __typename?: 'domainUserCategoryMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<domainUserCategory>;
};

/** input type for inserting object relation for remote table "business.domain_user_category" */
export type domainUserCategoryObjRelInsertInput = {
  data: domainUserCategoryInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<domainUserCategoryOnConflict>;
};

/** on_conflict condition type for table "business.domain_user_category" */
export type domainUserCategoryOnConflict = {
  constraint: domainUserCategoryConstraint;
  updateColumns?: Array<domainUserCategoryUpdateColumn>;
  where?: InputMaybe<domainUserCategoryBoolExp>;
};

/** Ordering options when selecting data from "business.domain_user_category". */
export type domainUserCategoryOrderBy = {
  description?: InputMaybe<OrderBy>;
  domainUsersAggregate?: InputMaybe<domainUserAggregateOrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.domain_user_category */
export type domainUserCategoryPkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "business.domain_user_category" */
export type domainUserCategorySelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "business.domain_user_category" */
export type domainUserCategorySetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "domainUserCategory" */
export type domainUserCategoryStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: domainUserCategoryStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type domainUserCategoryStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.domain_user_category" */
export type domainUserCategoryUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type domainUserCategoryUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<domainUserCategorySetInput>;
  /** filter the rows which have to be updated */
  where: domainUserCategoryBoolExp;
};

/** unique or primary key constraints on table "business.domain_user" */
export type domainUserConstraint =
  /** unique or primary key constraint on columns "domain_user_uuid" */
  | 'domain_user_domain_user_uuid_key'
  /** unique or primary key constraint on columns "id" */
  | 'telephony_domain_user_pkey'
  | '%future added value';

/** input type for incrementing numeric columns in table "business.domain_user" */
export type domainUserIncInput = {
  spamScore?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "business.domain_user" */
export type domainUserInsertInput = {
  category?: InputMaybe<domainUserCategoryEnum>;
  city?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  domainOrganization?: InputMaybe<domainOrganizationObjRelInsertInput>;
  domainOrganizationId?: InputMaybe<Scalars['uuid']['input']>;
  domainParticipants?: InputMaybe<domainParticipantArrRelInsertInput>;
  domainUserCategory?: InputMaybe<domainUserCategoryObjRelInsertInput>;
  domainUserUuid?: InputMaybe<Scalars['uuid']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  relOrganizationUser?: InputMaybe<relOrganizationUserDomainUserArrRelInsertInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  spamScore?: InputMaybe<Scalars['Int']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  triggerName?: InputMaybe<Scalars['String']['input']>;
  triggerTime?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type domainUserMaxFields = {
  __typename?: 'domainUserMaxFields';
  city?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  domainOrganizationId?: Maybe<Scalars['uuid']['output']>;
  domainUserUuid?: Maybe<Scalars['uuid']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  spamScore?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  triggerName?: Maybe<Scalars['String']['output']>;
  triggerTime?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "business.domain_user" */
export type domainUserMaxOrderBy = {
  city?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  department?: InputMaybe<OrderBy>;
  domainOrganizationId?: InputMaybe<OrderBy>;
  domainUserUuid?: InputMaybe<OrderBy>;
  emailAddress?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  spamScore?: InputMaybe<OrderBy>;
  street?: InputMaybe<OrderBy>;
  triggerName?: InputMaybe<OrderBy>;
  triggerTime?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  zip?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type domainUserMinFields = {
  __typename?: 'domainUserMinFields';
  city?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  domainOrganizationId?: Maybe<Scalars['uuid']['output']>;
  domainUserUuid?: Maybe<Scalars['uuid']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  spamScore?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  triggerName?: Maybe<Scalars['String']['output']>;
  triggerTime?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "business.domain_user" */
export type domainUserMinOrderBy = {
  city?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  department?: InputMaybe<OrderBy>;
  domainOrganizationId?: InputMaybe<OrderBy>;
  domainUserUuid?: InputMaybe<OrderBy>;
  emailAddress?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  spamScore?: InputMaybe<OrderBy>;
  street?: InputMaybe<OrderBy>;
  triggerName?: InputMaybe<OrderBy>;
  triggerTime?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  zip?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "business.domain_user" */
export type domainUserMutationResponse = {
  __typename?: 'domainUserMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<domainUser>;
};

/** input type for inserting object relation for remote table "business.domain_user" */
export type domainUserObjRelInsertInput = {
  data: domainUserInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<domainUserOnConflict>;
};

/** on_conflict condition type for table "business.domain_user" */
export type domainUserOnConflict = {
  constraint: domainUserConstraint;
  updateColumns?: Array<domainUserUpdateColumn>;
  where?: InputMaybe<domainUserBoolExp>;
};

/** Ordering options when selecting data from "business.domain_user". */
export type domainUserOrderBy = {
  category?: InputMaybe<OrderBy>;
  city?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  department?: InputMaybe<OrderBy>;
  domainOrganization?: InputMaybe<domainOrganizationOrderBy>;
  domainOrganizationId?: InputMaybe<OrderBy>;
  domainParticipantsAggregate?: InputMaybe<domainParticipantAggregateOrderBy>;
  domainUserCategory?: InputMaybe<domainUserCategoryOrderBy>;
  domainUserUuid?: InputMaybe<OrderBy>;
  emailAddress?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  relOrganizationUserAggregate?: InputMaybe<relOrganizationUserDomainUserAggregateOrderBy>;
  source?: InputMaybe<OrderBy>;
  spamScore?: InputMaybe<OrderBy>;
  street?: InputMaybe<OrderBy>;
  triggerName?: InputMaybe<OrderBy>;
  triggerTime?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  zip?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.domain_user */
export type domainUserPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "business.domain_user" */
export type domainUserSelectColumn =
  /** column name */
  | 'category'
  /** column name */
  | 'city'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'department'
  /** column name */
  | 'domainOrganizationId'
  /** column name */
  | 'domainUserUuid'
  /** column name */
  | 'emailAddress'
  /** column name */
  | 'firstName'
  /** column name */
  | 'id'
  /** column name */
  | 'lastName'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'phoneNumber'
  /** column name */
  | 'position'
  /** column name */
  | 'source'
  /** column name */
  | 'spamScore'
  /** column name */
  | 'street'
  /** column name */
  | 'triggerName'
  /** column name */
  | 'triggerTime'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'zip'
  | '%future added value';

/** input type for updating data in table "business.domain_user" */
export type domainUserSetInput = {
  category?: InputMaybe<domainUserCategoryEnum>;
  city?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  domainOrganizationId?: InputMaybe<Scalars['uuid']['input']>;
  domainUserUuid?: InputMaybe<Scalars['uuid']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  spamScore?: InputMaybe<Scalars['Int']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  triggerName?: InputMaybe<Scalars['String']['input']>;
  triggerTime?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type domainUserStddevFields = {
  __typename?: 'domainUserStddevFields';
  spamScore?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "business.domain_user" */
export type domainUserStddevOrderBy = {
  spamScore?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type domainUserStddevPopFields = {
  __typename?: 'domainUserStddevPopFields';
  spamScore?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "business.domain_user" */
export type domainUserStddevPopOrderBy = {
  spamScore?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type domainUserStddevSampFields = {
  __typename?: 'domainUserStddevSampFields';
  spamScore?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "business.domain_user" */
export type domainUserStddevSampOrderBy = {
  spamScore?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "domainUser" */
export type domainUserStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: domainUserStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type domainUserStreamCursorValueInput = {
  category?: InputMaybe<domainUserCategoryEnum>;
  city?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  domainOrganizationId?: InputMaybe<Scalars['uuid']['input']>;
  domainUserUuid?: InputMaybe<Scalars['uuid']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  spamScore?: InputMaybe<Scalars['Int']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  triggerName?: InputMaybe<Scalars['String']['input']>;
  triggerTime?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type domainUserSumFields = {
  __typename?: 'domainUserSumFields';
  spamScore?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "business.domain_user" */
export type domainUserSumOrderBy = {
  spamScore?: InputMaybe<OrderBy>;
};

/** update columns of table "business.domain_user" */
export type domainUserUpdateColumn =
  /** column name */
  | 'category'
  /** column name */
  | 'city'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'department'
  /** column name */
  | 'domainOrganizationId'
  /** column name */
  | 'domainUserUuid'
  /** column name */
  | 'emailAddress'
  /** column name */
  | 'firstName'
  /** column name */
  | 'id'
  /** column name */
  | 'lastName'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'phoneNumber'
  /** column name */
  | 'position'
  /** column name */
  | 'source'
  /** column name */
  | 'spamScore'
  /** column name */
  | 'street'
  /** column name */
  | 'triggerName'
  /** column name */
  | 'triggerTime'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'zip'
  | '%future added value';

export type domainUserUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<domainUserIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<domainUserSetInput>;
  /** filter the rows which have to be updated */
  where: domainUserBoolExp;
};

/** aggregate varPop on columns */
export type domainUserVarPopFields = {
  __typename?: 'domainUserVarPopFields';
  spamScore?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "business.domain_user" */
export type domainUserVarPopOrderBy = {
  spamScore?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type domainUserVarSampFields = {
  __typename?: 'domainUserVarSampFields';
  spamScore?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "business.domain_user" */
export type domainUserVarSampOrderBy = {
  spamScore?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type domainUserVarianceFields = {
  __typename?: 'domainUserVarianceFields';
  spamScore?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "business.domain_user" */
export type domainUserVarianceOrderBy = {
  spamScore?: InputMaybe<OrderBy>;
};

export type emailDomainUserOutput = {
  __typename?: 'emailDomainUserOutput';
  id?: Maybe<Scalars['uuid']['output']>;
};

export type emailingmutation_root = {
  __typename?: 'emailingmutation_root';
  /** insert data into the table: "email.activity" */
  createActivities?: Maybe<EmailingactivityMutationResponse>;
  /** insert a single row into the table: "email.activity" */
  createActivity?: Maybe<Emailingactivity>;
  /** insert a single row into the table: "email.activity_participant" */
  createActivityParticipant?: Maybe<EmailingactivityParticipant>;
  /** insert a single row into the table: "email.activity_participant_role" */
  createActivityParticipantRole?: Maybe<EmailingactivityParticipantRole>;
  /** insert data into the table: "email.activity_participant_role" */
  createActivityParticipantRoles?: Maybe<EmailingactivityParticipantRoleMutationResponse>;
  /** insert data into the table: "email.activity_participant" */
  createActivityParticipants?: Maybe<EmailingactivityParticipantMutationResponse>;
  /** insert a single row into the table: "email.domain_organization" */
  createDomainOrganization?: Maybe<EmailingdomainOrganization>;
  /** insert data into the table: "email.domain_organization" */
  createDomainOrganizations?: Maybe<EmailingdomainOrganizationMutationResponse>;
  /** insert a single row into the table: "email.domain_user" */
  createDomainUser?: Maybe<EmailingdomainUser>;
  /** insert data into the table: "email.domain_user_category" */
  createDomainUserCategories?: Maybe<EmailingdomainUserCategoryMutationResponse>;
  /** insert a single row into the table: "email.domain_user_category" */
  createDomainUserCategory?: Maybe<EmailingdomainUserCategory>;
  /** insert data into the table: "email.domain_user" */
  createDomainUsers?: Maybe<EmailingdomainUserMutationResponse>;
  /** insert a single row into the table: "email.event" */
  createEvent?: Maybe<Emailingevent>;
  /** insert data into the table: "email.event" */
  createEvents?: Maybe<EmailingeventMutationResponse>;
  /** insert a single row into the table: "email.provider_account" */
  createProviderAccount?: Maybe<EmailingproviderAccount>;
  /** insert data into the table: "email.provider_account" */
  createProviderAccounts?: Maybe<EmailingproviderAccountMutationResponse>;
  /** insert a single row into the table: "email.provider_type" */
  createProviderType?: Maybe<EmailingproviderType>;
  /** insert data into the table: "email.provider_type" */
  createProviderTypes?: Maybe<EmailingproviderTypeMutationResponse>;
  /** delete data from the table: "email.activity" */
  deleteActivities?: Maybe<EmailingactivityMutationResponse>;
  /** delete single row from the table: "email.activity" */
  deleteActivity?: Maybe<Emailingactivity>;
  /** delete single row from the table: "email.activity_participant" */
  deleteActivityParticipant?: Maybe<EmailingactivityParticipant>;
  /** delete single row from the table: "email.activity_participant_role" */
  deleteActivityParticipantRole?: Maybe<EmailingactivityParticipantRole>;
  /** delete data from the table: "email.activity_participant_role" */
  deleteActivityParticipantRoles?: Maybe<EmailingactivityParticipantRoleMutationResponse>;
  /** delete data from the table: "email.activity_participant" */
  deleteActivityParticipants?: Maybe<EmailingactivityParticipantMutationResponse>;
  /** delete single row from the table: "email.domain_organization" */
  deleteDomainOrganization?: Maybe<EmailingdomainOrganization>;
  /** delete data from the table: "email.domain_organization" */
  deleteDomainOrganizations?: Maybe<EmailingdomainOrganizationMutationResponse>;
  /** delete single row from the table: "email.domain_user" */
  deleteDomainUser?: Maybe<EmailingdomainUser>;
  /** delete data from the table: "email.domain_user_category" */
  deleteDomainUserCategories?: Maybe<EmailingdomainUserCategoryMutationResponse>;
  /** delete single row from the table: "email.domain_user_category" */
  deleteDomainUserCategory?: Maybe<EmailingdomainUserCategory>;
  /** delete data from the table: "email.domain_user" */
  deleteDomainUsers?: Maybe<EmailingdomainUserMutationResponse>;
  /** delete data from the table: "email.account_subscribers" */
  deleteEmailAccountSubscribers?: Maybe<EmailingEmailAccountSubscribersMutationResponse>;
  /** delete single row from the table: "email.account_subscribers" */
  deleteEmailAccountSubscribersByPk?: Maybe<EmailingEmailAccountSubscribers>;
  /** delete data from the table: "email.activity_type" */
  deleteEmailActivityType?: Maybe<EmailingEmailActivityTypeMutationResponse>;
  /** delete single row from the table: "email.activity_type" */
  deleteEmailActivityTypeByPk?: Maybe<EmailingEmailActivityType>;
  /** delete data from the table: "email.comment" */
  deleteEmailComment?: Maybe<EmailingEmailCommentMutationResponse>;
  /** delete single row from the table: "email.comment" */
  deleteEmailCommentByPk?: Maybe<EmailingEmailComment>;
  /** delete single row from the table: "email.event" */
  deleteEvent?: Maybe<Emailingevent>;
  /** delete data from the table: "email.event" */
  deleteEvents?: Maybe<EmailingeventMutationResponse>;
  /** delete single row from the table: "email.provider_account" */
  deleteProviderAccount?: Maybe<EmailingproviderAccount>;
  /** delete data from the table: "email.provider_account" */
  deleteProviderAccounts?: Maybe<EmailingproviderAccountMutationResponse>;
  /** delete single row from the table: "email.provider_type" */
  deleteProviderType?: Maybe<EmailingproviderType>;
  /** delete data from the table: "email.provider_type" */
  deleteProviderTypes?: Maybe<EmailingproviderTypeMutationResponse>;
  /** insert data into the table: "email.account_subscribers" */
  insertEmailAccountSubscribers?: Maybe<EmailingEmailAccountSubscribersMutationResponse>;
  /** insert a single row into the table: "email.account_subscribers" */
  insertEmailAccountSubscribersOne?: Maybe<EmailingEmailAccountSubscribers>;
  /** insert data into the table: "email.activity_type" */
  insertEmailActivityType?: Maybe<EmailingEmailActivityTypeMutationResponse>;
  /** insert a single row into the table: "email.activity_type" */
  insertEmailActivityTypeOne?: Maybe<EmailingEmailActivityType>;
  /** insert data into the table: "email.comment" */
  insertEmailComment?: Maybe<EmailingEmailCommentMutationResponse>;
  /** insert a single row into the table: "email.comment" */
  insertEmailCommentOne?: Maybe<EmailingEmailComment>;
  /** update data of the table: "email.activity" */
  updateActivities?: Maybe<EmailingactivityMutationResponse>;
  /** update single row of the table: "email.activity" */
  updateActivity?: Maybe<Emailingactivity>;
  /** update multiples rows of table: "email.activity" */
  updateActivityMany?: Maybe<Array<Maybe<EmailingactivityMutationResponse>>>;
  /** update single row of the table: "email.activity_participant" */
  updateActivityParticipant?: Maybe<EmailingactivityParticipant>;
  /** update multiples rows of table: "email.activity_participant" */
  updateActivityParticipantMany?: Maybe<Array<Maybe<EmailingactivityParticipantMutationResponse>>>;
  /** update single row of the table: "email.activity_participant_role" */
  updateActivityParticipantRole?: Maybe<EmailingactivityParticipantRole>;
  /** update multiples rows of table: "email.activity_participant_role" */
  updateActivityParticipantRoleMany?: Maybe<Array<Maybe<EmailingactivityParticipantRoleMutationResponse>>>;
  /** update data of the table: "email.activity_participant_role" */
  updateActivityParticipantRoles?: Maybe<EmailingactivityParticipantRoleMutationResponse>;
  /** update data of the table: "email.activity_participant" */
  updateActivityParticipants?: Maybe<EmailingactivityParticipantMutationResponse>;
  /** update single row of the table: "email.domain_organization" */
  updateDomainOrganization?: Maybe<EmailingdomainOrganization>;
  /** update multiples rows of table: "email.domain_organization" */
  updateDomainOrganizationMany?: Maybe<Array<Maybe<EmailingdomainOrganizationMutationResponse>>>;
  /** update data of the table: "email.domain_organization" */
  updateDomainOrganizations?: Maybe<EmailingdomainOrganizationMutationResponse>;
  /** update single row of the table: "email.domain_user" */
  updateDomainUser?: Maybe<EmailingdomainUser>;
  /** update data of the table: "email.domain_user_category" */
  updateDomainUserCategories?: Maybe<EmailingdomainUserCategoryMutationResponse>;
  /** update single row of the table: "email.domain_user_category" */
  updateDomainUserCategory?: Maybe<EmailingdomainUserCategory>;
  /** update multiples rows of table: "email.domain_user_category" */
  updateDomainUserCategoryMany?: Maybe<Array<Maybe<EmailingdomainUserCategoryMutationResponse>>>;
  /** update multiples rows of table: "email.domain_user" */
  updateDomainUserMany?: Maybe<Array<Maybe<EmailingdomainUserMutationResponse>>>;
  /** update data of the table: "email.domain_user" */
  updateDomainUsers?: Maybe<EmailingdomainUserMutationResponse>;
  /** update data of the table: "email.account_subscribers" */
  updateEmailAccountSubscribers?: Maybe<EmailingEmailAccountSubscribersMutationResponse>;
  /** update single row of the table: "email.account_subscribers" */
  updateEmailAccountSubscribersByPk?: Maybe<EmailingEmailAccountSubscribers>;
  /** update multiples rows of table: "email.account_subscribers" */
  updateEmailAccountSubscribersMany?: Maybe<Array<Maybe<EmailingEmailAccountSubscribersMutationResponse>>>;
  /** update data of the table: "email.activity_type" */
  updateEmailActivityType?: Maybe<EmailingEmailActivityTypeMutationResponse>;
  /** update single row of the table: "email.activity_type" */
  updateEmailActivityTypeByPk?: Maybe<EmailingEmailActivityType>;
  /** update multiples rows of table: "email.activity_type" */
  updateEmailActivityTypeMany?: Maybe<Array<Maybe<EmailingEmailActivityTypeMutationResponse>>>;
  /** update data of the table: "email.comment" */
  updateEmailComment?: Maybe<EmailingEmailCommentMutationResponse>;
  /** update single row of the table: "email.comment" */
  updateEmailCommentByPk?: Maybe<EmailingEmailComment>;
  /** update multiples rows of table: "email.comment" */
  updateEmailCommentMany?: Maybe<Array<Maybe<EmailingEmailCommentMutationResponse>>>;
  /** update single row of the table: "email.event" */
  updateEvent?: Maybe<Emailingevent>;
  /** update multiples rows of table: "email.event" */
  updateEventMany?: Maybe<Array<Maybe<EmailingeventMutationResponse>>>;
  /** update data of the table: "email.event" */
  updateEvents?: Maybe<EmailingeventMutationResponse>;
  /** update single row of the table: "email.provider_account" */
  updateProviderAccount?: Maybe<EmailingproviderAccount>;
  /** update multiples rows of table: "email.provider_account" */
  updateProviderAccountMany?: Maybe<Array<Maybe<EmailingproviderAccountMutationResponse>>>;
  /** update data of the table: "email.provider_account" */
  updateProviderAccounts?: Maybe<EmailingproviderAccountMutationResponse>;
  /** update single row of the table: "email.provider_type" */
  updateProviderType?: Maybe<EmailingproviderType>;
  /** update multiples rows of table: "email.provider_type" */
  updateProviderTypeMany?: Maybe<Array<Maybe<EmailingproviderTypeMutationResponse>>>;
  /** update data of the table: "email.provider_type" */
  updateProviderTypes?: Maybe<EmailingproviderTypeMutationResponse>;
};


export type emailingmutation_rootcreateActivitiesArgs = {
  objects: Array<EmailingactivityInsertInput>;
  onConflict?: InputMaybe<EmailingactivityOnConflict>;
};


export type emailingmutation_rootcreateActivityArgs = {
  object: EmailingactivityInsertInput;
  onConflict?: InputMaybe<EmailingactivityOnConflict>;
};


export type emailingmutation_rootcreateActivityParticipantArgs = {
  object: EmailingactivityParticipantInsertInput;
  onConflict?: InputMaybe<EmailingactivityParticipantOnConflict>;
};


export type emailingmutation_rootcreateActivityParticipantRoleArgs = {
  object: EmailingactivityParticipantRoleInsertInput;
  onConflict?: InputMaybe<EmailingactivityParticipantRoleOnConflict>;
};


export type emailingmutation_rootcreateActivityParticipantRolesArgs = {
  objects: Array<EmailingactivityParticipantRoleInsertInput>;
  onConflict?: InputMaybe<EmailingactivityParticipantRoleOnConflict>;
};


export type emailingmutation_rootcreateActivityParticipantsArgs = {
  objects: Array<EmailingactivityParticipantInsertInput>;
  onConflict?: InputMaybe<EmailingactivityParticipantOnConflict>;
};


export type emailingmutation_rootcreateDomainOrganizationArgs = {
  object: EmailingdomainOrganizationInsertInput;
  onConflict?: InputMaybe<EmailingdomainOrganizationOnConflict>;
};


export type emailingmutation_rootcreateDomainOrganizationsArgs = {
  objects: Array<EmailingdomainOrganizationInsertInput>;
  onConflict?: InputMaybe<EmailingdomainOrganizationOnConflict>;
};


export type emailingmutation_rootcreateDomainUserArgs = {
  object: EmailingdomainUserInsertInput;
  onConflict?: InputMaybe<EmailingdomainUserOnConflict>;
};


export type emailingmutation_rootcreateDomainUserCategoriesArgs = {
  objects: Array<EmailingdomainUserCategoryInsertInput>;
  onConflict?: InputMaybe<EmailingdomainUserCategoryOnConflict>;
};


export type emailingmutation_rootcreateDomainUserCategoryArgs = {
  object: EmailingdomainUserCategoryInsertInput;
  onConflict?: InputMaybe<EmailingdomainUserCategoryOnConflict>;
};


export type emailingmutation_rootcreateDomainUsersArgs = {
  objects: Array<EmailingdomainUserInsertInput>;
  onConflict?: InputMaybe<EmailingdomainUserOnConflict>;
};


export type emailingmutation_rootcreateEventArgs = {
  object: EmailingeventInsertInput;
  onConflict?: InputMaybe<EmailingeventOnConflict>;
};


export type emailingmutation_rootcreateEventsArgs = {
  objects: Array<EmailingeventInsertInput>;
  onConflict?: InputMaybe<EmailingeventOnConflict>;
};


export type emailingmutation_rootcreateProviderAccountArgs = {
  object: EmailingproviderAccountInsertInput;
  onConflict?: InputMaybe<EmailingproviderAccountOnConflict>;
};


export type emailingmutation_rootcreateProviderAccountsArgs = {
  objects: Array<EmailingproviderAccountInsertInput>;
  onConflict?: InputMaybe<EmailingproviderAccountOnConflict>;
};


export type emailingmutation_rootcreateProviderTypeArgs = {
  object: EmailingproviderTypeInsertInput;
  onConflict?: InputMaybe<EmailingproviderTypeOnConflict>;
};


export type emailingmutation_rootcreateProviderTypesArgs = {
  objects: Array<EmailingproviderTypeInsertInput>;
  onConflict?: InputMaybe<EmailingproviderTypeOnConflict>;
};


export type emailingmutation_rootdeleteActivitiesArgs = {
  where: EmailingactivityBoolExp;
};


export type emailingmutation_rootdeleteActivityArgs = {
  id: Scalars['uuid']['input'];
};


export type emailingmutation_rootdeleteActivityParticipantArgs = {
  id: Scalars['uuid']['input'];
};


export type emailingmutation_rootdeleteActivityParticipantRoleArgs = {
  value: Scalars['String']['input'];
};


export type emailingmutation_rootdeleteActivityParticipantRolesArgs = {
  where: EmailingactivityParticipantRoleBoolExp;
};


export type emailingmutation_rootdeleteActivityParticipantsArgs = {
  where: EmailingactivityParticipantBoolExp;
};


export type emailingmutation_rootdeleteDomainOrganizationArgs = {
  id: Scalars['uuid']['input'];
};


export type emailingmutation_rootdeleteDomainOrganizationsArgs = {
  where: EmailingdomainOrganizationBoolExp;
};


export type emailingmutation_rootdeleteDomainUserArgs = {
  id: Scalars['uuid']['input'];
};


export type emailingmutation_rootdeleteDomainUserCategoriesArgs = {
  where: EmailingdomainUserCategoryBoolExp;
};


export type emailingmutation_rootdeleteDomainUserCategoryArgs = {
  value: Scalars['String']['input'];
};


export type emailingmutation_rootdeleteDomainUsersArgs = {
  where: EmailingdomainUserBoolExp;
};


export type emailingmutation_rootdeleteEmailAccountSubscribersArgs = {
  where: EmailingEmailAccountSubscribersBoolExp;
};


export type emailingmutation_rootdeleteEmailAccountSubscribersByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type emailingmutation_rootdeleteEmailActivityTypeArgs = {
  where: EmailingEmailActivityTypeBoolExp;
};


export type emailingmutation_rootdeleteEmailActivityTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type emailingmutation_rootdeleteEmailCommentArgs = {
  where: EmailingEmailCommentBoolExp;
};


export type emailingmutation_rootdeleteEmailCommentByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type emailingmutation_rootdeleteEventArgs = {
  id: Scalars['uuid']['input'];
};


export type emailingmutation_rootdeleteEventsArgs = {
  where: EmailingeventBoolExp;
};


export type emailingmutation_rootdeleteProviderAccountArgs = {
  id: Scalars['uuid']['input'];
};


export type emailingmutation_rootdeleteProviderAccountsArgs = {
  where: EmailingproviderAccountBoolExp;
};


export type emailingmutation_rootdeleteProviderTypeArgs = {
  value: Scalars['String']['input'];
};


export type emailingmutation_rootdeleteProviderTypesArgs = {
  where: EmailingproviderTypeBoolExp;
};


export type emailingmutation_rootinsertEmailAccountSubscribersArgs = {
  objects: Array<EmailingEmailAccountSubscribersInsertInput>;
  onConflict?: InputMaybe<EmailingEmailAccountSubscribersOnConflict>;
};


export type emailingmutation_rootinsertEmailAccountSubscribersOneArgs = {
  object: EmailingEmailAccountSubscribersInsertInput;
  onConflict?: InputMaybe<EmailingEmailAccountSubscribersOnConflict>;
};


export type emailingmutation_rootinsertEmailActivityTypeArgs = {
  objects: Array<EmailingEmailActivityTypeInsertInput>;
  onConflict?: InputMaybe<EmailingEmailActivityTypeOnConflict>;
};


export type emailingmutation_rootinsertEmailActivityTypeOneArgs = {
  object: EmailingEmailActivityTypeInsertInput;
  onConflict?: InputMaybe<EmailingEmailActivityTypeOnConflict>;
};


export type emailingmutation_rootinsertEmailCommentArgs = {
  objects: Array<EmailingEmailCommentInsertInput>;
  onConflict?: InputMaybe<EmailingEmailCommentOnConflict>;
};


export type emailingmutation_rootinsertEmailCommentOneArgs = {
  object: EmailingEmailCommentInsertInput;
  onConflict?: InputMaybe<EmailingEmailCommentOnConflict>;
};


export type emailingmutation_rootupdateActivitiesArgs = {
  _inc?: InputMaybe<EmailingactivityIncInput>;
  _set?: InputMaybe<EmailingactivitySetInput>;
  where: EmailingactivityBoolExp;
};


export type emailingmutation_rootupdateActivityArgs = {
  _inc?: InputMaybe<EmailingactivityIncInput>;
  _set?: InputMaybe<EmailingactivitySetInput>;
  pkColumns: EmailingactivityPkColumnsInput;
};


export type emailingmutation_rootupdateActivityManyArgs = {
  updates: Array<TelephonyactivityUpdates>;
};


export type emailingmutation_rootupdateActivityParticipantArgs = {
  _set?: InputMaybe<EmailingactivityParticipantSetInput>;
  pkColumns: EmailingactivityParticipantPkColumnsInput;
};


export type emailingmutation_rootupdateActivityParticipantManyArgs = {
  updates: Array<TelephonyactivityParticipantUpdates>;
};


export type emailingmutation_rootupdateActivityParticipantRoleArgs = {
  _set?: InputMaybe<EmailingactivityParticipantRoleSetInput>;
  pkColumns: EmailingactivityParticipantRolePkColumnsInput;
};


export type emailingmutation_rootupdateActivityParticipantRoleManyArgs = {
  updates: Array<EmailingactivityParticipantRoleUpdates>;
};


export type emailingmutation_rootupdateActivityParticipantRolesArgs = {
  _set?: InputMaybe<EmailingactivityParticipantRoleSetInput>;
  where: EmailingactivityParticipantRoleBoolExp;
};


export type emailingmutation_rootupdateActivityParticipantsArgs = {
  _set?: InputMaybe<EmailingactivityParticipantSetInput>;
  where: EmailingactivityParticipantBoolExp;
};


export type emailingmutation_rootupdateDomainOrganizationArgs = {
  _set?: InputMaybe<EmailingdomainOrganizationSetInput>;
  pkColumns: EmailingdomainOrganizationPkColumnsInput;
};


export type emailingmutation_rootupdateDomainOrganizationManyArgs = {
  updates: Array<TelephonydomainOrganizationUpdates>;
};


export type emailingmutation_rootupdateDomainOrganizationsArgs = {
  _set?: InputMaybe<EmailingdomainOrganizationSetInput>;
  where: EmailingdomainOrganizationBoolExp;
};


export type emailingmutation_rootupdateDomainUserArgs = {
  _set?: InputMaybe<EmailingdomainUserSetInput>;
  pkColumns: EmailingdomainUserPkColumnsInput;
};


export type emailingmutation_rootupdateDomainUserCategoriesArgs = {
  _set?: InputMaybe<EmailingdomainUserCategorySetInput>;
  where: EmailingdomainUserCategoryBoolExp;
};


export type emailingmutation_rootupdateDomainUserCategoryArgs = {
  _set?: InputMaybe<EmailingdomainUserCategorySetInput>;
  pkColumns: EmailingdomainUserCategoryPkColumnsInput;
};


export type emailingmutation_rootupdateDomainUserCategoryManyArgs = {
  updates: Array<EmailingdomainUserCategoryUpdates>;
};


export type emailingmutation_rootupdateDomainUserManyArgs = {
  updates: Array<EmailingdomainUserUpdates>;
};


export type emailingmutation_rootupdateDomainUsersArgs = {
  _set?: InputMaybe<EmailingdomainUserSetInput>;
  where: EmailingdomainUserBoolExp;
};


export type emailingmutation_rootupdateEmailAccountSubscribersArgs = {
  _set?: InputMaybe<EmailingEmailAccountSubscribersSetInput>;
  where: EmailingEmailAccountSubscribersBoolExp;
};


export type emailingmutation_rootupdateEmailAccountSubscribersByPkArgs = {
  _set?: InputMaybe<EmailingEmailAccountSubscribersSetInput>;
  pkColumns: EmailingEmailAccountSubscribersPkColumnsInput;
};


export type emailingmutation_rootupdateEmailAccountSubscribersManyArgs = {
  updates: Array<EmailingEmailAccountSubscribersUpdates>;
};


export type emailingmutation_rootupdateEmailActivityTypeArgs = {
  _set?: InputMaybe<EmailingEmailActivityTypeSetInput>;
  where: EmailingEmailActivityTypeBoolExp;
};


export type emailingmutation_rootupdateEmailActivityTypeByPkArgs = {
  _set?: InputMaybe<EmailingEmailActivityTypeSetInput>;
  pkColumns: EmailingEmailActivityTypePkColumnsInput;
};


export type emailingmutation_rootupdateEmailActivityTypeManyArgs = {
  updates: Array<EmailingEmailActivityTypeUpdates>;
};


export type emailingmutation_rootupdateEmailCommentArgs = {
  _set?: InputMaybe<EmailingEmailCommentSetInput>;
  where: EmailingEmailCommentBoolExp;
};


export type emailingmutation_rootupdateEmailCommentByPkArgs = {
  _set?: InputMaybe<EmailingEmailCommentSetInput>;
  pkColumns: EmailingEmailCommentPkColumnsInput;
};


export type emailingmutation_rootupdateEmailCommentManyArgs = {
  updates: Array<EmailingEmailCommentUpdates>;
};


export type emailingmutation_rootupdateEventArgs = {
  _set?: InputMaybe<EmailingeventSetInput>;
  pkColumns: EmailingeventPkColumnsInput;
};


export type emailingmutation_rootupdateEventManyArgs = {
  updates: Array<EmailingeventUpdates>;
};


export type emailingmutation_rootupdateEventsArgs = {
  _set?: InputMaybe<EmailingeventSetInput>;
  where: EmailingeventBoolExp;
};


export type emailingmutation_rootupdateProviderAccountArgs = {
  _inc?: InputMaybe<EmailingproviderAccountIncInput>;
  _set?: InputMaybe<EmailingproviderAccountSetInput>;
  pkColumns: EmailingproviderAccountPkColumnsInput;
};


export type emailingmutation_rootupdateProviderAccountManyArgs = {
  updates: Array<EmailingproviderAccountUpdates>;
};


export type emailingmutation_rootupdateProviderAccountsArgs = {
  _inc?: InputMaybe<EmailingproviderAccountIncInput>;
  _set?: InputMaybe<EmailingproviderAccountSetInput>;
  where: EmailingproviderAccountBoolExp;
};


export type emailingmutation_rootupdateProviderTypeArgs = {
  _set?: InputMaybe<EmailingproviderTypeSetInput>;
  pkColumns: EmailingproviderTypePkColumnsInput;
};


export type emailingmutation_rootupdateProviderTypeManyArgs = {
  updates: Array<EmailingproviderTypeUpdates>;
};


export type emailingmutation_rootupdateProviderTypesArgs = {
  _set?: InputMaybe<EmailingproviderTypeSetInput>;
  where: EmailingproviderTypeBoolExp;
};

export type emailingquery_root = {
  __typename?: 'emailingquery_root';
  /** fetch data from the table: "email.activity" */
  activities: Array<Emailingactivity>;
  /** fetch data from the table: "email.activity" using primary key columns */
  activity?: Maybe<Emailingactivity>;
  /** fetch data from the table: "email.activity_participant" using primary key columns */
  activityParticipant?: Maybe<EmailingactivityParticipant>;
  /** fetch data from the table: "email.activity_participant_role" using primary key columns */
  activityParticipantRole?: Maybe<EmailingactivityParticipantRole>;
  /** fetch data from the table: "email.activity_participant_role" */
  activityParticipantRoles: Array<EmailingactivityParticipantRole>;
  /** An array relationship */
  activityParticipants: Array<EmailingactivityParticipant>;
  /** fetch aggregated fields from the table: "email.activity" */
  aggregateActivities: EmailingactivityAggregate;
  /** fetch aggregated fields from the table: "email.activity_participant_role" */
  aggregateActivityParticipantRoles: EmailingactivityParticipantRoleAggregate;
  /** fetch aggregated fields from the table: "email.activity_participant" */
  aggregateActivityParticipants: EmailingactivityParticipantAggregate;
  /** fetch aggregated fields from the table: "email.domain_organization" */
  aggregateDomainOrganizations: EmailingdomainOrganizationAggregate;
  /** fetch aggregated fields from the table: "email.domain_user_category" */
  aggregateDomainUserCategories: EmailingdomainUserCategoryAggregate;
  /** fetch aggregated fields from the table: "email.domain_user" */
  aggregateDomainUsers: EmailingdomainUserAggregate;
  /** fetch aggregated fields from the table: "email.event" */
  aggregateEvents: EmailingeventAggregate;
  /** fetch aggregated fields from the table: "email.provider_account" */
  aggregateProviderAccounts: EmailingproviderAccountAggregate;
  /** fetch aggregated fields from the table: "email.provider_type" */
  aggregateProviderTypes: EmailingproviderTypeAggregate;
  /** fetch data from the table: "email.domain_organization" using primary key columns */
  domainOrganization?: Maybe<EmailingdomainOrganization>;
  /** fetch data from the table: "email.domain_organization" */
  domainOrganizations: Array<EmailingdomainOrganization>;
  /** fetch data from the table: "email.domain_user" using primary key columns */
  domainUser?: Maybe<EmailingdomainUser>;
  /** fetch data from the table: "email.domain_user_category" */
  domainUserCategories: Array<EmailingdomainUserCategory>;
  /** fetch data from the table: "email.domain_user_category" using primary key columns */
  domainUserCategory?: Maybe<EmailingdomainUserCategory>;
  /** An array relationship */
  domainUsers: Array<EmailingdomainUser>;
  /** fetch data from the table: "email.account_subscribers" */
  emailAccountSubscribers: Array<EmailingEmailAccountSubscribers>;
  /** fetch aggregated fields from the table: "email.account_subscribers" */
  emailAccountSubscribersAggregate: EmailingEmailAccountSubscribersAggregate;
  /** fetch data from the table: "email.account_subscribers" using primary key columns */
  emailAccountSubscribersByPk?: Maybe<EmailingEmailAccountSubscribers>;
  /** fetch data from the table: "email.activity_type" */
  emailActivityType: Array<EmailingEmailActivityType>;
  /** fetch aggregated fields from the table: "email.activity_type" */
  emailActivityTypeAggregate: EmailingEmailActivityTypeAggregate;
  /** fetch data from the table: "email.activity_type" using primary key columns */
  emailActivityTypeByPk?: Maybe<EmailingEmailActivityType>;
  /** fetch data from the table: "email.comment" */
  emailComment: Array<EmailingEmailComment>;
  /** fetch aggregated fields from the table: "email.comment" */
  emailCommentAggregate: EmailingEmailCommentAggregate;
  /** fetch data from the table: "email.comment" using primary key columns */
  emailCommentByPk?: Maybe<EmailingEmailComment>;
  /** fetch data from the table: "email.event" using primary key columns */
  event?: Maybe<Emailingevent>;
  /** fetch data from the table: "email.event" */
  events: Array<Emailingevent>;
  /** fetch data from the table: "email.provider_account" using primary key columns */
  providerAccount?: Maybe<EmailingproviderAccount>;
  /** An array relationship */
  providerAccounts: Array<EmailingproviderAccount>;
  /** fetch data from the table: "email.provider_type" using primary key columns */
  providerType?: Maybe<EmailingproviderType>;
  /** fetch data from the table: "email.provider_type" */
  providerTypes: Array<EmailingproviderType>;
};


export type emailingquery_rootactivitiesArgs = {
  distinctOn?: InputMaybe<Array<EmailingactivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingactivityOrderBy>>;
  where?: InputMaybe<EmailingactivityBoolExp>;
};


export type emailingquery_rootactivityArgs = {
  id: Scalars['uuid']['input'];
};


export type emailingquery_rootactivityParticipantArgs = {
  id: Scalars['uuid']['input'];
};


export type emailingquery_rootactivityParticipantRoleArgs = {
  value: Scalars['String']['input'];
};


export type emailingquery_rootactivityParticipantRolesArgs = {
  distinctOn?: InputMaybe<Array<EmailingactivityParticipantRoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingactivityParticipantRoleOrderBy>>;
  where?: InputMaybe<EmailingactivityParticipantRoleBoolExp>;
};


export type emailingquery_rootactivityParticipantsArgs = {
  distinctOn?: InputMaybe<Array<EmailingactivityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingactivityParticipantOrderBy>>;
  where?: InputMaybe<EmailingactivityParticipantBoolExp>;
};


export type emailingquery_rootaggregateActivitiesArgs = {
  distinctOn?: InputMaybe<Array<EmailingactivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingactivityOrderBy>>;
  where?: InputMaybe<EmailingactivityBoolExp>;
};


export type emailingquery_rootaggregateActivityParticipantRolesArgs = {
  distinctOn?: InputMaybe<Array<EmailingactivityParticipantRoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingactivityParticipantRoleOrderBy>>;
  where?: InputMaybe<EmailingactivityParticipantRoleBoolExp>;
};


export type emailingquery_rootaggregateActivityParticipantsArgs = {
  distinctOn?: InputMaybe<Array<EmailingactivityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingactivityParticipantOrderBy>>;
  where?: InputMaybe<EmailingactivityParticipantBoolExp>;
};


export type emailingquery_rootaggregateDomainOrganizationsArgs = {
  distinctOn?: InputMaybe<Array<EmailingdomainOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingdomainOrganizationOrderBy>>;
  where?: InputMaybe<EmailingdomainOrganizationBoolExp>;
};


export type emailingquery_rootaggregateDomainUserCategoriesArgs = {
  distinctOn?: InputMaybe<Array<EmailingdomainUserCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingdomainUserCategoryOrderBy>>;
  where?: InputMaybe<EmailingdomainUserCategoryBoolExp>;
};


export type emailingquery_rootaggregateDomainUsersArgs = {
  distinctOn?: InputMaybe<Array<EmailingdomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingdomainUserOrderBy>>;
  where?: InputMaybe<EmailingdomainUserBoolExp>;
};


export type emailingquery_rootaggregateEventsArgs = {
  distinctOn?: InputMaybe<Array<EmailingeventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingeventOrderBy>>;
  where?: InputMaybe<EmailingeventBoolExp>;
};


export type emailingquery_rootaggregateProviderAccountsArgs = {
  distinctOn?: InputMaybe<Array<EmailingproviderAccountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingproviderAccountOrderBy>>;
  where?: InputMaybe<EmailingproviderAccountBoolExp>;
};


export type emailingquery_rootaggregateProviderTypesArgs = {
  distinctOn?: InputMaybe<Array<EmailingproviderTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingproviderTypeOrderBy>>;
  where?: InputMaybe<EmailingproviderTypeBoolExp>;
};


export type emailingquery_rootdomainOrganizationArgs = {
  id: Scalars['uuid']['input'];
};


export type emailingquery_rootdomainOrganizationsArgs = {
  distinctOn?: InputMaybe<Array<EmailingdomainOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingdomainOrganizationOrderBy>>;
  where?: InputMaybe<EmailingdomainOrganizationBoolExp>;
};


export type emailingquery_rootdomainUserArgs = {
  id: Scalars['uuid']['input'];
};


export type emailingquery_rootdomainUserCategoriesArgs = {
  distinctOn?: InputMaybe<Array<EmailingdomainUserCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingdomainUserCategoryOrderBy>>;
  where?: InputMaybe<EmailingdomainUserCategoryBoolExp>;
};


export type emailingquery_rootdomainUserCategoryArgs = {
  value: Scalars['String']['input'];
};


export type emailingquery_rootdomainUsersArgs = {
  distinctOn?: InputMaybe<Array<EmailingdomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingdomainUserOrderBy>>;
  where?: InputMaybe<EmailingdomainUserBoolExp>;
};


export type emailingquery_rootemailAccountSubscribersArgs = {
  distinctOn?: InputMaybe<Array<EmailingEmailAccountSubscribersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingEmailAccountSubscribersOrderBy>>;
  where?: InputMaybe<EmailingEmailAccountSubscribersBoolExp>;
};


export type emailingquery_rootemailAccountSubscribersAggregateArgs = {
  distinctOn?: InputMaybe<Array<EmailingEmailAccountSubscribersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingEmailAccountSubscribersOrderBy>>;
  where?: InputMaybe<EmailingEmailAccountSubscribersBoolExp>;
};


export type emailingquery_rootemailAccountSubscribersByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type emailingquery_rootemailActivityTypeArgs = {
  distinctOn?: InputMaybe<Array<EmailingEmailActivityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingEmailActivityTypeOrderBy>>;
  where?: InputMaybe<EmailingEmailActivityTypeBoolExp>;
};


export type emailingquery_rootemailActivityTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<EmailingEmailActivityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingEmailActivityTypeOrderBy>>;
  where?: InputMaybe<EmailingEmailActivityTypeBoolExp>;
};


export type emailingquery_rootemailActivityTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type emailingquery_rootemailCommentArgs = {
  distinctOn?: InputMaybe<Array<EmailingEmailCommentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingEmailCommentOrderBy>>;
  where?: InputMaybe<EmailingEmailCommentBoolExp>;
};


export type emailingquery_rootemailCommentAggregateArgs = {
  distinctOn?: InputMaybe<Array<EmailingEmailCommentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingEmailCommentOrderBy>>;
  where?: InputMaybe<EmailingEmailCommentBoolExp>;
};


export type emailingquery_rootemailCommentByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type emailingquery_rooteventArgs = {
  id: Scalars['uuid']['input'];
};


export type emailingquery_rooteventsArgs = {
  distinctOn?: InputMaybe<Array<EmailingeventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingeventOrderBy>>;
  where?: InputMaybe<EmailingeventBoolExp>;
};


export type emailingquery_rootproviderAccountArgs = {
  id: Scalars['uuid']['input'];
};


export type emailingquery_rootproviderAccountsArgs = {
  distinctOn?: InputMaybe<Array<EmailingproviderAccountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingproviderAccountOrderBy>>;
  where?: InputMaybe<EmailingproviderAccountBoolExp>;
};


export type emailingquery_rootproviderTypeArgs = {
  value: Scalars['String']['input'];
};


export type emailingquery_rootproviderTypesArgs = {
  distinctOn?: InputMaybe<Array<EmailingproviderTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingproviderTypeOrderBy>>;
  where?: InputMaybe<EmailingproviderTypeBoolExp>;
};

export type emailingsubscription_root = {
  __typename?: 'emailingsubscription_root';
  /** fetch data from the table: "email.activity" */
  activities: Array<Emailingactivity>;
  /** fetch data from the table: "email.activity" using primary key columns */
  activity?: Maybe<Emailingactivity>;
  /** fetch data from the table: "email.activity_participant" using primary key columns */
  activityParticipant?: Maybe<EmailingactivityParticipant>;
  /** fetch data from the table: "email.activity_participant_role" using primary key columns */
  activityParticipantRole?: Maybe<EmailingactivityParticipantRole>;
  /** fetch data from the table in a streaming manner: "email.activity_participant_role" */
  activityParticipantRoleStream: Array<EmailingactivityParticipantRole>;
  /** fetch data from the table: "email.activity_participant_role" */
  activityParticipantRoles: Array<EmailingactivityParticipantRole>;
  /** fetch data from the table in a streaming manner: "email.activity_participant" */
  activityParticipantStream: Array<EmailingactivityParticipant>;
  /** An array relationship */
  activityParticipants: Array<EmailingactivityParticipant>;
  /** fetch data from the table in a streaming manner: "email.activity" */
  activityStream: Array<Emailingactivity>;
  /** fetch aggregated fields from the table: "email.activity" */
  aggregateActivities: EmailingactivityAggregate;
  /** fetch aggregated fields from the table: "email.activity_participant_role" */
  aggregateActivityParticipantRoles: EmailingactivityParticipantRoleAggregate;
  /** fetch aggregated fields from the table: "email.activity_participant" */
  aggregateActivityParticipants: EmailingactivityParticipantAggregate;
  /** fetch aggregated fields from the table: "email.domain_organization" */
  aggregateDomainOrganizations: EmailingdomainOrganizationAggregate;
  /** fetch aggregated fields from the table: "email.domain_user_category" */
  aggregateDomainUserCategories: EmailingdomainUserCategoryAggregate;
  /** fetch aggregated fields from the table: "email.domain_user" */
  aggregateDomainUsers: EmailingdomainUserAggregate;
  /** fetch aggregated fields from the table: "email.event" */
  aggregateEvents: EmailingeventAggregate;
  /** fetch aggregated fields from the table: "email.provider_account" */
  aggregateProviderAccounts: EmailingproviderAccountAggregate;
  /** fetch aggregated fields from the table: "email.provider_type" */
  aggregateProviderTypes: EmailingproviderTypeAggregate;
  /** fetch data from the table: "email.domain_organization" using primary key columns */
  domainOrganization?: Maybe<EmailingdomainOrganization>;
  /** fetch data from the table in a streaming manner: "email.domain_organization" */
  domainOrganizationStream: Array<EmailingdomainOrganization>;
  /** fetch data from the table: "email.domain_organization" */
  domainOrganizations: Array<EmailingdomainOrganization>;
  /** fetch data from the table: "email.domain_user" using primary key columns */
  domainUser?: Maybe<EmailingdomainUser>;
  /** fetch data from the table: "email.domain_user_category" */
  domainUserCategories: Array<EmailingdomainUserCategory>;
  /** fetch data from the table: "email.domain_user_category" using primary key columns */
  domainUserCategory?: Maybe<EmailingdomainUserCategory>;
  /** fetch data from the table in a streaming manner: "email.domain_user_category" */
  domainUserCategoryStream: Array<EmailingdomainUserCategory>;
  /** fetch data from the table in a streaming manner: "email.domain_user" */
  domainUserStream: Array<EmailingdomainUser>;
  /** An array relationship */
  domainUsers: Array<EmailingdomainUser>;
  /** fetch data from the table: "email.account_subscribers" */
  emailAccountSubscribers: Array<EmailingEmailAccountSubscribers>;
  /** fetch aggregated fields from the table: "email.account_subscribers" */
  emailAccountSubscribersAggregate: EmailingEmailAccountSubscribersAggregate;
  /** fetch data from the table: "email.account_subscribers" using primary key columns */
  emailAccountSubscribersByPk?: Maybe<EmailingEmailAccountSubscribers>;
  /** fetch data from the table in a streaming manner: "email.account_subscribers" */
  emailAccountSubscribersStream: Array<EmailingEmailAccountSubscribers>;
  /** fetch data from the table: "email.activity_type" */
  emailActivityType: Array<EmailingEmailActivityType>;
  /** fetch aggregated fields from the table: "email.activity_type" */
  emailActivityTypeAggregate: EmailingEmailActivityTypeAggregate;
  /** fetch data from the table: "email.activity_type" using primary key columns */
  emailActivityTypeByPk?: Maybe<EmailingEmailActivityType>;
  /** fetch data from the table in a streaming manner: "email.activity_type" */
  emailActivityTypeStream: Array<EmailingEmailActivityType>;
  /** fetch data from the table: "email.comment" */
  emailComment: Array<EmailingEmailComment>;
  /** fetch aggregated fields from the table: "email.comment" */
  emailCommentAggregate: EmailingEmailCommentAggregate;
  /** fetch data from the table: "email.comment" using primary key columns */
  emailCommentByPk?: Maybe<EmailingEmailComment>;
  /** fetch data from the table in a streaming manner: "email.comment" */
  emailCommentStream: Array<EmailingEmailComment>;
  /** fetch data from the table: "email.event" using primary key columns */
  event?: Maybe<Emailingevent>;
  /** fetch data from the table in a streaming manner: "email.event" */
  eventStream: Array<Emailingevent>;
  /** fetch data from the table: "email.event" */
  events: Array<Emailingevent>;
  /** fetch data from the table: "email.provider_account" using primary key columns */
  providerAccount?: Maybe<EmailingproviderAccount>;
  /** fetch data from the table in a streaming manner: "email.provider_account" */
  providerAccountStream: Array<EmailingproviderAccount>;
  /** An array relationship */
  providerAccounts: Array<EmailingproviderAccount>;
  /** fetch data from the table: "email.provider_type" using primary key columns */
  providerType?: Maybe<EmailingproviderType>;
  /** fetch data from the table in a streaming manner: "email.provider_type" */
  providerTypeStream: Array<EmailingproviderType>;
  /** fetch data from the table: "email.provider_type" */
  providerTypes: Array<EmailingproviderType>;
};


export type emailingsubscription_rootactivitiesArgs = {
  distinctOn?: InputMaybe<Array<EmailingactivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingactivityOrderBy>>;
  where?: InputMaybe<EmailingactivityBoolExp>;
};


export type emailingsubscription_rootactivityArgs = {
  id: Scalars['uuid']['input'];
};


export type emailingsubscription_rootactivityParticipantArgs = {
  id: Scalars['uuid']['input'];
};


export type emailingsubscription_rootactivityParticipantRoleArgs = {
  value: Scalars['String']['input'];
};


export type emailingsubscription_rootactivityParticipantRoleStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EmailingactivityParticipantRoleStreamCursorInput>>;
  where?: InputMaybe<EmailingactivityParticipantRoleBoolExp>;
};


export type emailingsubscription_rootactivityParticipantRolesArgs = {
  distinctOn?: InputMaybe<Array<EmailingactivityParticipantRoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingactivityParticipantRoleOrderBy>>;
  where?: InputMaybe<EmailingactivityParticipantRoleBoolExp>;
};


export type emailingsubscription_rootactivityParticipantStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonyactivityParticipantStreamCursorInput>>;
  where?: InputMaybe<EmailingactivityParticipantBoolExp>;
};


export type emailingsubscription_rootactivityParticipantsArgs = {
  distinctOn?: InputMaybe<Array<EmailingactivityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingactivityParticipantOrderBy>>;
  where?: InputMaybe<EmailingactivityParticipantBoolExp>;
};


export type emailingsubscription_rootactivityStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonyactivityStreamCursorInput>>;
  where?: InputMaybe<EmailingactivityBoolExp>;
};


export type emailingsubscription_rootaggregateActivitiesArgs = {
  distinctOn?: InputMaybe<Array<EmailingactivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingactivityOrderBy>>;
  where?: InputMaybe<EmailingactivityBoolExp>;
};


export type emailingsubscription_rootaggregateActivityParticipantRolesArgs = {
  distinctOn?: InputMaybe<Array<EmailingactivityParticipantRoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingactivityParticipantRoleOrderBy>>;
  where?: InputMaybe<EmailingactivityParticipantRoleBoolExp>;
};


export type emailingsubscription_rootaggregateActivityParticipantsArgs = {
  distinctOn?: InputMaybe<Array<EmailingactivityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingactivityParticipantOrderBy>>;
  where?: InputMaybe<EmailingactivityParticipantBoolExp>;
};


export type emailingsubscription_rootaggregateDomainOrganizationsArgs = {
  distinctOn?: InputMaybe<Array<EmailingdomainOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingdomainOrganizationOrderBy>>;
  where?: InputMaybe<EmailingdomainOrganizationBoolExp>;
};


export type emailingsubscription_rootaggregateDomainUserCategoriesArgs = {
  distinctOn?: InputMaybe<Array<EmailingdomainUserCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingdomainUserCategoryOrderBy>>;
  where?: InputMaybe<EmailingdomainUserCategoryBoolExp>;
};


export type emailingsubscription_rootaggregateDomainUsersArgs = {
  distinctOn?: InputMaybe<Array<EmailingdomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingdomainUserOrderBy>>;
  where?: InputMaybe<EmailingdomainUserBoolExp>;
};


export type emailingsubscription_rootaggregateEventsArgs = {
  distinctOn?: InputMaybe<Array<EmailingeventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingeventOrderBy>>;
  where?: InputMaybe<EmailingeventBoolExp>;
};


export type emailingsubscription_rootaggregateProviderAccountsArgs = {
  distinctOn?: InputMaybe<Array<EmailingproviderAccountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingproviderAccountOrderBy>>;
  where?: InputMaybe<EmailingproviderAccountBoolExp>;
};


export type emailingsubscription_rootaggregateProviderTypesArgs = {
  distinctOn?: InputMaybe<Array<EmailingproviderTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingproviderTypeOrderBy>>;
  where?: InputMaybe<EmailingproviderTypeBoolExp>;
};


export type emailingsubscription_rootdomainOrganizationArgs = {
  id: Scalars['uuid']['input'];
};


export type emailingsubscription_rootdomainOrganizationStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonydomainOrganizationStreamCursorInput>>;
  where?: InputMaybe<EmailingdomainOrganizationBoolExp>;
};


export type emailingsubscription_rootdomainOrganizationsArgs = {
  distinctOn?: InputMaybe<Array<EmailingdomainOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingdomainOrganizationOrderBy>>;
  where?: InputMaybe<EmailingdomainOrganizationBoolExp>;
};


export type emailingsubscription_rootdomainUserArgs = {
  id: Scalars['uuid']['input'];
};


export type emailingsubscription_rootdomainUserCategoriesArgs = {
  distinctOn?: InputMaybe<Array<EmailingdomainUserCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingdomainUserCategoryOrderBy>>;
  where?: InputMaybe<EmailingdomainUserCategoryBoolExp>;
};


export type emailingsubscription_rootdomainUserCategoryArgs = {
  value: Scalars['String']['input'];
};


export type emailingsubscription_rootdomainUserCategoryStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EmailingdomainUserCategoryStreamCursorInput>>;
  where?: InputMaybe<EmailingdomainUserCategoryBoolExp>;
};


export type emailingsubscription_rootdomainUserStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonydomainUserStreamCursorInput>>;
  where?: InputMaybe<EmailingdomainUserBoolExp>;
};


export type emailingsubscription_rootdomainUsersArgs = {
  distinctOn?: InputMaybe<Array<EmailingdomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingdomainUserOrderBy>>;
  where?: InputMaybe<EmailingdomainUserBoolExp>;
};


export type emailingsubscription_rootemailAccountSubscribersArgs = {
  distinctOn?: InputMaybe<Array<EmailingEmailAccountSubscribersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingEmailAccountSubscribersOrderBy>>;
  where?: InputMaybe<EmailingEmailAccountSubscribersBoolExp>;
};


export type emailingsubscription_rootemailAccountSubscribersAggregateArgs = {
  distinctOn?: InputMaybe<Array<EmailingEmailAccountSubscribersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingEmailAccountSubscribersOrderBy>>;
  where?: InputMaybe<EmailingEmailAccountSubscribersBoolExp>;
};


export type emailingsubscription_rootemailAccountSubscribersByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type emailingsubscription_rootemailAccountSubscribersStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EmailingEmailAccountSubscribersStreamCursorInput>>;
  where?: InputMaybe<EmailingEmailAccountSubscribersBoolExp>;
};


export type emailingsubscription_rootemailActivityTypeArgs = {
  distinctOn?: InputMaybe<Array<EmailingEmailActivityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingEmailActivityTypeOrderBy>>;
  where?: InputMaybe<EmailingEmailActivityTypeBoolExp>;
};


export type emailingsubscription_rootemailActivityTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<EmailingEmailActivityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingEmailActivityTypeOrderBy>>;
  where?: InputMaybe<EmailingEmailActivityTypeBoolExp>;
};


export type emailingsubscription_rootemailActivityTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type emailingsubscription_rootemailActivityTypeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EmailingEmailActivityTypeStreamCursorInput>>;
  where?: InputMaybe<EmailingEmailActivityTypeBoolExp>;
};


export type emailingsubscription_rootemailCommentArgs = {
  distinctOn?: InputMaybe<Array<EmailingEmailCommentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingEmailCommentOrderBy>>;
  where?: InputMaybe<EmailingEmailCommentBoolExp>;
};


export type emailingsubscription_rootemailCommentAggregateArgs = {
  distinctOn?: InputMaybe<Array<EmailingEmailCommentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingEmailCommentOrderBy>>;
  where?: InputMaybe<EmailingEmailCommentBoolExp>;
};


export type emailingsubscription_rootemailCommentByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type emailingsubscription_rootemailCommentStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EmailingEmailCommentStreamCursorInput>>;
  where?: InputMaybe<EmailingEmailCommentBoolExp>;
};


export type emailingsubscription_rooteventArgs = {
  id: Scalars['uuid']['input'];
};


export type emailingsubscription_rooteventStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonyeventStreamCursorInput>>;
  where?: InputMaybe<EmailingeventBoolExp>;
};


export type emailingsubscription_rooteventsArgs = {
  distinctOn?: InputMaybe<Array<EmailingeventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingeventOrderBy>>;
  where?: InputMaybe<EmailingeventBoolExp>;
};


export type emailingsubscription_rootproviderAccountArgs = {
  id: Scalars['uuid']['input'];
};


export type emailingsubscription_rootproviderAccountStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonyproviderAccountStreamCursorInput>>;
  where?: InputMaybe<EmailingproviderAccountBoolExp>;
};


export type emailingsubscription_rootproviderAccountsArgs = {
  distinctOn?: InputMaybe<Array<EmailingproviderAccountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingproviderAccountOrderBy>>;
  where?: InputMaybe<EmailingproviderAccountBoolExp>;
};


export type emailingsubscription_rootproviderTypeArgs = {
  value: Scalars['String']['input'];
};


export type emailingsubscription_rootproviderTypeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EmailingproviderTypeStreamCursorInput>>;
  where?: InputMaybe<EmailingproviderTypeBoolExp>;
};


export type emailingsubscription_rootproviderTypesArgs = {
  distinctOn?: InputMaybe<Array<EmailingproviderTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailingproviderTypeOrderBy>>;
  where?: InputMaybe<EmailingproviderTypeBoolExp>;
};

export type fileOutput = {
  __typename?: 'fileOutput';
  id?: Maybe<Scalars['uuid']['output']>;
};

export type geodatamutation_root = {
  __typename?: 'geodatamutation_root';
  /** delete data from the table: "address" */
  deleteAddress?: Maybe<GeodataAddressMutationResponse>;
  /** delete single row from the table: "address" */
  deleteAddressByPk?: Maybe<GeodataAddress>;
  /** delete data from the table: "matrikkelenadresseleilighetsniva.adressetilleggsnavnkildekode" */
  deleteMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode?: Maybe<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMutationResponse>;
  /** delete data from the table: "matrikkelenadresseleilighetsniva.atkomst" */
  deleteMatrikkelenadresseleilighetsnivaAtkomst?: Maybe<GeodataMatrikkelenadresseleilighetsnivaAtkomstMutationResponse>;
  /** delete data from the table: "matrikkelenadresseleilighetsniva.kommunenummer" */
  deleteMatrikkelenadresseleilighetsnivaKommunenummer?: Maybe<GeodataMatrikkelenadresseleilighetsnivaKommunenummerMutationResponse>;
  /** delete data from the table: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet" */
  deleteMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMutationResponse>;
  /** delete data from the table: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_atkomstid" */
  deleteMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMutationResponse>;
  /** delete data from the table: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_uuidatkomst" */
  deleteMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMutationResponse>;
  /** delete data from the table: "matrikkelenadresseleilighetsniva.typeatkomst" */
  deleteMatrikkelenadresseleilighetsnivaTypeatkomst?: Maybe<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMutationResponse>;
  /** delete data from the table: "matrikkelenadresseleilighetsniva.vegadressebruksenhet" */
  deleteMatrikkelenadresseleilighetsnivaVegadressebruksenhet?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMutationResponse>;
  /** delete data from the table: "matrikkelenadresseleilighetsniva.vegadressebruksenhet_atkomstid" */
  deleteMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMutationResponse>;
  /** delete data from the table: "matrikkelenadresseleilighetsniva.vegadressebruksenhet_uuidatkomst" */
  deleteMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMutationResponse>;
  /** delete data from the table: "spatial_ref_sys" */
  deleteSpatialRefSys?: Maybe<GeodataSpatialRefSysMutationResponse>;
  /** delete single row from the table: "spatial_ref_sys" */
  deleteSpatialRefSysByPk?: Maybe<GeodataSpatialRefSys>;
  /** delete data from the table: "zip" */
  deleteZip?: Maybe<GeodataZipMutationResponse>;
  /** delete single row from the table: "zip" */
  deleteZipByPk?: Maybe<GeodataZip>;
  /** insert data into the table: "address" */
  insertAddress?: Maybe<GeodataAddressMutationResponse>;
  /** insert a single row into the table: "address" */
  insertAddressOne?: Maybe<GeodataAddress>;
  /** insert data into the table: "matrikkelenadresseleilighetsniva.adressetilleggsnavnkildekode" */
  insertMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode?: Maybe<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMutationResponse>;
  /** insert a single row into the table: "matrikkelenadresseleilighetsniva.adressetilleggsnavnkildekode" */
  insertMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeOne?: Maybe<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode>;
  /** insert data into the table: "matrikkelenadresseleilighetsniva.atkomst" */
  insertMatrikkelenadresseleilighetsnivaAtkomst?: Maybe<GeodataMatrikkelenadresseleilighetsnivaAtkomstMutationResponse>;
  /** insert a single row into the table: "matrikkelenadresseleilighetsniva.atkomst" */
  insertMatrikkelenadresseleilighetsnivaAtkomstOne?: Maybe<GeodataMatrikkelenadresseleilighetsnivaAtkomst>;
  /** insert data into the table: "matrikkelenadresseleilighetsniva.kommunenummer" */
  insertMatrikkelenadresseleilighetsnivaKommunenummer?: Maybe<GeodataMatrikkelenadresseleilighetsnivaKommunenummerMutationResponse>;
  /** insert a single row into the table: "matrikkelenadresseleilighetsniva.kommunenummer" */
  insertMatrikkelenadresseleilighetsnivaKommunenummerOne?: Maybe<GeodataMatrikkelenadresseleilighetsnivaKommunenummer>;
  /** insert data into the table: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet" */
  insertMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMutationResponse>;
  /** insert data into the table: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_atkomstid" */
  insertMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMutationResponse>;
  /** insert a single row into the table: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_atkomstid" */
  insertMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidOne?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid>;
  /** insert a single row into the table: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet" */
  insertMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetOne?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet>;
  /** insert data into the table: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_uuidatkomst" */
  insertMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMutationResponse>;
  /** insert a single row into the table: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_uuidatkomst" */
  insertMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstOne?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst>;
  /** insert data into the table: "matrikkelenadresseleilighetsniva.typeatkomst" */
  insertMatrikkelenadresseleilighetsnivaTypeatkomst?: Maybe<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMutationResponse>;
  /** insert a single row into the table: "matrikkelenadresseleilighetsniva.typeatkomst" */
  insertMatrikkelenadresseleilighetsnivaTypeatkomstOne?: Maybe<GeodataMatrikkelenadresseleilighetsnivaTypeatkomst>;
  /** insert data into the table: "matrikkelenadresseleilighetsniva.vegadressebruksenhet" */
  insertMatrikkelenadresseleilighetsnivaVegadressebruksenhet?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMutationResponse>;
  /** insert data into the table: "matrikkelenadresseleilighetsniva.vegadressebruksenhet_atkomstid" */
  insertMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMutationResponse>;
  /** insert a single row into the table: "matrikkelenadresseleilighetsniva.vegadressebruksenhet_atkomstid" */
  insertMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidOne?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid>;
  /** insert a single row into the table: "matrikkelenadresseleilighetsniva.vegadressebruksenhet" */
  insertMatrikkelenadresseleilighetsnivaVegadressebruksenhetOne?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhet>;
  /** insert data into the table: "matrikkelenadresseleilighetsniva.vegadressebruksenhet_uuidatkomst" */
  insertMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMutationResponse>;
  /** insert a single row into the table: "matrikkelenadresseleilighetsniva.vegadressebruksenhet_uuidatkomst" */
  insertMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstOne?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst>;
  /** insert data into the table: "spatial_ref_sys" */
  insertSpatialRefSys?: Maybe<GeodataSpatialRefSysMutationResponse>;
  /** insert a single row into the table: "spatial_ref_sys" */
  insertSpatialRefSysOne?: Maybe<GeodataSpatialRefSys>;
  /** insert data into the table: "zip" */
  insertZip?: Maybe<GeodataZipMutationResponse>;
  /** insert a single row into the table: "zip" */
  insertZipOne?: Maybe<GeodataZip>;
  /** update data of the table: "address" */
  updateAddress?: Maybe<GeodataAddressMutationResponse>;
  /** update single row of the table: "address" */
  updateAddressByPk?: Maybe<GeodataAddress>;
  /** update multiples rows of table: "address" */
  updateAddressMany?: Maybe<Array<Maybe<GeodataAddressMutationResponse>>>;
  /** update data of the table: "matrikkelenadresseleilighetsniva.adressetilleggsnavnkildekode" */
  updateMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode?: Maybe<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMutationResponse>;
  /** update multiples rows of table: "matrikkelenadresseleilighetsniva.adressetilleggsnavnkildekode" */
  updateMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMany?: Maybe<Array<Maybe<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMutationResponse>>>;
  /** update data of the table: "matrikkelenadresseleilighetsniva.atkomst" */
  updateMatrikkelenadresseleilighetsnivaAtkomst?: Maybe<GeodataMatrikkelenadresseleilighetsnivaAtkomstMutationResponse>;
  /** update multiples rows of table: "matrikkelenadresseleilighetsniva.atkomst" */
  updateMatrikkelenadresseleilighetsnivaAtkomstMany?: Maybe<Array<Maybe<GeodataMatrikkelenadresseleilighetsnivaAtkomstMutationResponse>>>;
  /** update data of the table: "matrikkelenadresseleilighetsniva.kommunenummer" */
  updateMatrikkelenadresseleilighetsnivaKommunenummer?: Maybe<GeodataMatrikkelenadresseleilighetsnivaKommunenummerMutationResponse>;
  /** update multiples rows of table: "matrikkelenadresseleilighetsniva.kommunenummer" */
  updateMatrikkelenadresseleilighetsnivaKommunenummerMany?: Maybe<Array<Maybe<GeodataMatrikkelenadresseleilighetsnivaKommunenummerMutationResponse>>>;
  /** update data of the table: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet" */
  updateMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMutationResponse>;
  /** update data of the table: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_atkomstid" */
  updateMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMutationResponse>;
  /** update multiples rows of table: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_atkomstid" */
  updateMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMany?: Maybe<Array<Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMutationResponse>>>;
  /** update multiples rows of table: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet" */
  updateMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMany?: Maybe<Array<Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMutationResponse>>>;
  /** update data of the table: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_uuidatkomst" */
  updateMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst?: Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMutationResponse>;
  /** update multiples rows of table: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_uuidatkomst" */
  updateMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMany?: Maybe<Array<Maybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMutationResponse>>>;
  /** update data of the table: "matrikkelenadresseleilighetsniva.typeatkomst" */
  updateMatrikkelenadresseleilighetsnivaTypeatkomst?: Maybe<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMutationResponse>;
  /** update multiples rows of table: "matrikkelenadresseleilighetsniva.typeatkomst" */
  updateMatrikkelenadresseleilighetsnivaTypeatkomstMany?: Maybe<Array<Maybe<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMutationResponse>>>;
  /** update data of the table: "matrikkelenadresseleilighetsniva.vegadressebruksenhet" */
  updateMatrikkelenadresseleilighetsnivaVegadressebruksenhet?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMutationResponse>;
  /** update data of the table: "matrikkelenadresseleilighetsniva.vegadressebruksenhet_atkomstid" */
  updateMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMutationResponse>;
  /** update multiples rows of table: "matrikkelenadresseleilighetsniva.vegadressebruksenhet_atkomstid" */
  updateMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMany?: Maybe<Array<Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMutationResponse>>>;
  /** update multiples rows of table: "matrikkelenadresseleilighetsniva.vegadressebruksenhet" */
  updateMatrikkelenadresseleilighetsnivaVegadressebruksenhetMany?: Maybe<Array<Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMutationResponse>>>;
  /** update data of the table: "matrikkelenadresseleilighetsniva.vegadressebruksenhet_uuidatkomst" */
  updateMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst?: Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMutationResponse>;
  /** update multiples rows of table: "matrikkelenadresseleilighetsniva.vegadressebruksenhet_uuidatkomst" */
  updateMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMany?: Maybe<Array<Maybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMutationResponse>>>;
  /** update data of the table: "spatial_ref_sys" */
  updateSpatialRefSys?: Maybe<GeodataSpatialRefSysMutationResponse>;
  /** update single row of the table: "spatial_ref_sys" */
  updateSpatialRefSysByPk?: Maybe<GeodataSpatialRefSys>;
  /** update multiples rows of table: "spatial_ref_sys" */
  updateSpatialRefSysMany?: Maybe<Array<Maybe<GeodataSpatialRefSysMutationResponse>>>;
  /** update data of the table: "zip" */
  updateZip?: Maybe<GeodataZipMutationResponse>;
  /** update single row of the table: "zip" */
  updateZipByPk?: Maybe<GeodataZip>;
  /** update multiples rows of table: "zip" */
  updateZipMany?: Maybe<Array<Maybe<GeodataZipMutationResponse>>>;
};


export type geodatamutation_rootdeleteAddressArgs = {
  where: GeodataAddressBoolExp;
};


export type geodatamutation_rootdeleteAddressByPkArgs = {
  id: Scalars['Geodatauuid']['input'];
};


export type geodatamutation_rootdeleteMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeArgs = {
  where: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeBoolExp;
};


export type geodatamutation_rootdeleteMatrikkelenadresseleilighetsnivaAtkomstArgs = {
  where: GeodataMatrikkelenadresseleilighetsnivaAtkomstBoolExp;
};


export type geodatamutation_rootdeleteMatrikkelenadresseleilighetsnivaKommunenummerArgs = {
  where: GeodataMatrikkelenadresseleilighetsnivaKommunenummerBoolExp;
};


export type geodatamutation_rootdeleteMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetArgs = {
  where: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetBoolExp;
};


export type geodatamutation_rootdeleteMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidArgs = {
  where: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidBoolExp;
};


export type geodatamutation_rootdeleteMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstArgs = {
  where: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstBoolExp;
};


export type geodatamutation_rootdeleteMatrikkelenadresseleilighetsnivaTypeatkomstArgs = {
  where: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstBoolExp;
};


export type geodatamutation_rootdeleteMatrikkelenadresseleilighetsnivaVegadressebruksenhetArgs = {
  where: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetBoolExp;
};


export type geodatamutation_rootdeleteMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidArgs = {
  where: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidBoolExp;
};


export type geodatamutation_rootdeleteMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstArgs = {
  where: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstBoolExp;
};


export type geodatamutation_rootdeleteSpatialRefSysArgs = {
  where: GeodataSpatialRefSysBoolExp;
};


export type geodatamutation_rootdeleteSpatialRefSysByPkArgs = {
  srid: Scalars['Int']['input'];
};


export type geodatamutation_rootdeleteZipArgs = {
  where: GeodataZipBoolExp;
};


export type geodatamutation_rootdeleteZipByPkArgs = {
  zip: Scalars['String']['input'];
};


export type geodatamutation_rootinsertAddressArgs = {
  objects: Array<GeodataAddressInsertInput>;
  onConflict?: InputMaybe<GeodataAddressOnConflict>;
};


export type geodatamutation_rootinsertAddressOneArgs = {
  object: GeodataAddressInsertInput;
  onConflict?: InputMaybe<GeodataAddressOnConflict>;
};


export type geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeArgs = {
  objects: Array<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeInsertInput>;
};


export type geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeOneArgs = {
  object: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeInsertInput;
};


export type geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaAtkomstArgs = {
  objects: Array<GeodataMatrikkelenadresseleilighetsnivaAtkomstInsertInput>;
};


export type geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaAtkomstOneArgs = {
  object: GeodataMatrikkelenadresseleilighetsnivaAtkomstInsertInput;
};


export type geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaKommunenummerArgs = {
  objects: Array<GeodataMatrikkelenadresseleilighetsnivaKommunenummerInsertInput>;
};


export type geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaKommunenummerOneArgs = {
  object: GeodataMatrikkelenadresseleilighetsnivaKommunenummerInsertInput;
};


export type geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetArgs = {
  objects: Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetInsertInput>;
};


export type geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidArgs = {
  objects: Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidInsertInput>;
};


export type geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidOneArgs = {
  object: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidInsertInput;
};


export type geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetOneArgs = {
  object: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetInsertInput;
};


export type geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstArgs = {
  objects: Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstInsertInput>;
};


export type geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstOneArgs = {
  object: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstInsertInput;
};


export type geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaTypeatkomstArgs = {
  objects: Array<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstInsertInput>;
};


export type geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaTypeatkomstOneArgs = {
  object: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstInsertInput;
};


export type geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaVegadressebruksenhetArgs = {
  objects: Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetInsertInput>;
};


export type geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidArgs = {
  objects: Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidInsertInput>;
};


export type geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidOneArgs = {
  object: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidInsertInput;
};


export type geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaVegadressebruksenhetOneArgs = {
  object: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetInsertInput;
};


export type geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstArgs = {
  objects: Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstInsertInput>;
};


export type geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstOneArgs = {
  object: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstInsertInput;
};


export type geodatamutation_rootinsertSpatialRefSysArgs = {
  objects: Array<GeodataSpatialRefSysInsertInput>;
  onConflict?: InputMaybe<GeodataSpatialRefSysOnConflict>;
};


export type geodatamutation_rootinsertSpatialRefSysOneArgs = {
  object: GeodataSpatialRefSysInsertInput;
  onConflict?: InputMaybe<GeodataSpatialRefSysOnConflict>;
};


export type geodatamutation_rootinsertZipArgs = {
  objects: Array<GeodataZipInsertInput>;
  onConflict?: InputMaybe<GeodataZipOnConflict>;
};


export type geodatamutation_rootinsertZipOneArgs = {
  object: GeodataZipInsertInput;
  onConflict?: InputMaybe<GeodataZipOnConflict>;
};


export type geodatamutation_rootupdateAddressArgs = {
  _set?: InputMaybe<GeodataAddressSetInput>;
  where: GeodataAddressBoolExp;
};


export type geodatamutation_rootupdateAddressByPkArgs = {
  _set?: InputMaybe<GeodataAddressSetInput>;
  pkColumns: GeodataAddressPkColumnsInput;
};


export type geodatamutation_rootupdateAddressManyArgs = {
  updates: Array<GeodataAddressUpdates>;
};


export type geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeArgs = {
  _set?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeSetInput>;
  where: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeBoolExp;
};


export type geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeManyArgs = {
  updates: Array<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeUpdates>;
};


export type geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaAtkomstArgs = {
  _inc?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaAtkomstIncInput>;
  _set?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaAtkomstSetInput>;
  where: GeodataMatrikkelenadresseleilighetsnivaAtkomstBoolExp;
};


export type geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaAtkomstManyArgs = {
  updates: Array<GeodataMatrikkelenadresseleilighetsnivaAtkomstUpdates>;
};


export type geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaKommunenummerArgs = {
  _set?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaKommunenummerSetInput>;
  where: GeodataMatrikkelenadresseleilighetsnivaKommunenummerBoolExp;
};


export type geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaKommunenummerManyArgs = {
  updates: Array<GeodataMatrikkelenadresseleilighetsnivaKommunenummerUpdates>;
};


export type geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetArgs = {
  _inc?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetIncInput>;
  _set?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetSetInput>;
  where: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetBoolExp;
};


export type geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidArgs = {
  _inc?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidIncInput>;
  _set?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidSetInput>;
  where: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidBoolExp;
};


export type geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidManyArgs = {
  updates: Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidUpdates>;
};


export type geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetManyArgs = {
  updates: Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUpdates>;
};


export type geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstArgs = {
  _inc?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstIncInput>;
  _set?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstSetInput>;
  where: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstBoolExp;
};


export type geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstManyArgs = {
  updates: Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstUpdates>;
};


export type geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaTypeatkomstArgs = {
  _set?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstSetInput>;
  where: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstBoolExp;
};


export type geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaTypeatkomstManyArgs = {
  updates: Array<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstUpdates>;
};


export type geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaVegadressebruksenhetArgs = {
  _inc?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetIncInput>;
  _set?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetSetInput>;
  where: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetBoolExp;
};


export type geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidArgs = {
  _inc?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidIncInput>;
  _set?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidSetInput>;
  where: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidBoolExp;
};


export type geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidManyArgs = {
  updates: Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidUpdates>;
};


export type geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaVegadressebruksenhetManyArgs = {
  updates: Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUpdates>;
};


export type geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstArgs = {
  _inc?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstIncInput>;
  _set?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstSetInput>;
  where: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstBoolExp;
};


export type geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstManyArgs = {
  updates: Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstUpdates>;
};


export type geodatamutation_rootupdateSpatialRefSysArgs = {
  _inc?: InputMaybe<GeodataSpatialRefSysIncInput>;
  _set?: InputMaybe<GeodataSpatialRefSysSetInput>;
  where: GeodataSpatialRefSysBoolExp;
};


export type geodatamutation_rootupdateSpatialRefSysByPkArgs = {
  _inc?: InputMaybe<GeodataSpatialRefSysIncInput>;
  _set?: InputMaybe<GeodataSpatialRefSysSetInput>;
  pkColumns: GeodataSpatialRefSysPkColumnsInput;
};


export type geodatamutation_rootupdateSpatialRefSysManyArgs = {
  updates: Array<GeodataSpatialRefSysUpdates>;
};


export type geodatamutation_rootupdateZipArgs = {
  _set?: InputMaybe<GeodataZipSetInput>;
  where: GeodataZipBoolExp;
};


export type geodatamutation_rootupdateZipByPkArgs = {
  _set?: InputMaybe<GeodataZipSetInput>;
  pkColumns: GeodataZipPkColumnsInput;
};


export type geodatamutation_rootupdateZipManyArgs = {
  updates: Array<GeodataZipUpdates>;
};

export type geodataquery_root = {
  __typename?: 'geodataquery_root';
  /** fetch data from the table: "address" */
  address: Array<GeodataAddress>;
  /** fetch aggregated fields from the table: "address" */
  addressAggregate: GeodataAddressAggregate;
  /** fetch data from the table: "address" using primary key columns */
  addressByPk?: Maybe<GeodataAddress>;
  /** fetch data from the table: "matrikkelenadresseleilighetsniva.adressetilleggsnavnkildekode" */
  matrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode: Array<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode>;
  /** fetch aggregated fields from the table: "matrikkelenadresseleilighetsniva.adressetilleggsnavnkildekode" */
  matrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregate: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregate;
  /** fetch data from the table: "matrikkelenadresseleilighetsniva.atkomst" */
  matrikkelenadresseleilighetsnivaAtkomst: Array<GeodataMatrikkelenadresseleilighetsnivaAtkomst>;
  /** fetch aggregated fields from the table: "matrikkelenadresseleilighetsniva.atkomst" */
  matrikkelenadresseleilighetsnivaAtkomstAggregate: GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregate;
  /** fetch data from the table: "matrikkelenadresseleilighetsniva.kommunenummer" */
  matrikkelenadresseleilighetsnivaKommunenummer: Array<GeodataMatrikkelenadresseleilighetsnivaKommunenummer>;
  /** fetch aggregated fields from the table: "matrikkelenadresseleilighetsniva.kommunenummer" */
  matrikkelenadresseleilighetsnivaKommunenummerAggregate: GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregate;
  /** fetch data from the table: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet" */
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet: Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet>;
  /** fetch aggregated fields from the table: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet" */
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregate: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregate;
  /** fetch data from the table: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_atkomstid" */
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid: Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid>;
  /** fetch aggregated fields from the table: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_atkomstid" */
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregate: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregate;
  /** fetch data from the table: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_uuidatkomst" */
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst: Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst>;
  /** fetch aggregated fields from the table: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_uuidatkomst" */
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregate: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregate;
  /** fetch data from the table: "matrikkelenadresseleilighetsniva.typeatkomst" */
  matrikkelenadresseleilighetsnivaTypeatkomst: Array<GeodataMatrikkelenadresseleilighetsnivaTypeatkomst>;
  /** fetch aggregated fields from the table: "matrikkelenadresseleilighetsniva.typeatkomst" */
  matrikkelenadresseleilighetsnivaTypeatkomstAggregate: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregate;
  /** fetch data from the table: "matrikkelenadresseleilighetsniva.vegadressebruksenhet" */
  matrikkelenadresseleilighetsnivaVegadressebruksenhet: Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhet>;
  /** fetch aggregated fields from the table: "matrikkelenadresseleilighetsniva.vegadressebruksenhet" */
  matrikkelenadresseleilighetsnivaVegadressebruksenhetAggregate: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregate;
  /** fetch data from the table: "matrikkelenadresseleilighetsniva.vegadressebruksenhet_atkomstid" */
  matrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid: Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid>;
  /** fetch aggregated fields from the table: "matrikkelenadresseleilighetsniva.vegadressebruksenhet_atkomstid" */
  matrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregate: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregate;
  /** fetch data from the table: "matrikkelenadresseleilighetsniva.vegadressebruksenhet_uuidatkomst" */
  matrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst: Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst>;
  /** fetch aggregated fields from the table: "matrikkelenadresseleilighetsniva.vegadressebruksenhet_uuidatkomst" */
  matrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregate: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregate;
  /** fetch data from the table: "spatial_ref_sys" */
  spatialRefSys: Array<GeodataSpatialRefSys>;
  /** fetch aggregated fields from the table: "spatial_ref_sys" */
  spatialRefSysAggregate: GeodataSpatialRefSysAggregate;
  /** fetch data from the table: "spatial_ref_sys" using primary key columns */
  spatialRefSysByPk?: Maybe<GeodataSpatialRefSys>;
  /** fetch data from the table: "zip" */
  zip: Array<GeodataZip>;
  /** fetch aggregated fields from the table: "zip" */
  zipAggregate: GeodataZipAggregate;
  /** fetch data from the table: "zip" using primary key columns */
  zipByPk?: Maybe<GeodataZip>;
};


export type geodataquery_rootaddressArgs = {
  distinctOn?: InputMaybe<Array<GeodataAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataAddressOrderBy>>;
  where?: InputMaybe<GeodataAddressBoolExp>;
};


export type geodataquery_rootaddressAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeodataAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataAddressOrderBy>>;
  where?: InputMaybe<GeodataAddressBoolExp>;
};


export type geodataquery_rootaddressByPkArgs = {
  id: Scalars['Geodatauuid']['input'];
};


export type geodataquery_rootmatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeBoolExp>;
};


export type geodataquery_rootmatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeBoolExp>;
};


export type geodataquery_rootmatrikkelenadresseleilighetsnivaAtkomstArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaAtkomstSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaAtkomstOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaAtkomstBoolExp>;
};


export type geodataquery_rootmatrikkelenadresseleilighetsnivaAtkomstAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaAtkomstSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaAtkomstOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaAtkomstBoolExp>;
};


export type geodataquery_rootmatrikkelenadresseleilighetsnivaKommunenummerArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaKommunenummerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaKommunenummerOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaKommunenummerBoolExp>;
};


export type geodataquery_rootmatrikkelenadresseleilighetsnivaKommunenummerAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaKommunenummerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaKommunenummerOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaKommunenummerBoolExp>;
};


export type geodataquery_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetBoolExp>;
};


export type geodataquery_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetBoolExp>;
};


export type geodataquery_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidBoolExp>;
};


export type geodataquery_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidBoolExp>;
};


export type geodataquery_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstBoolExp>;
};


export type geodataquery_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstBoolExp>;
};


export type geodataquery_rootmatrikkelenadresseleilighetsnivaTypeatkomstArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstBoolExp>;
};


export type geodataquery_rootmatrikkelenadresseleilighetsnivaTypeatkomstAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstBoolExp>;
};


export type geodataquery_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetBoolExp>;
};


export type geodataquery_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetBoolExp>;
};


export type geodataquery_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidBoolExp>;
};


export type geodataquery_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidBoolExp>;
};


export type geodataquery_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstBoolExp>;
};


export type geodataquery_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstBoolExp>;
};


export type geodataquery_rootspatialRefSysArgs = {
  distinctOn?: InputMaybe<Array<GeodataSpatialRefSysSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataSpatialRefSysOrderBy>>;
  where?: InputMaybe<GeodataSpatialRefSysBoolExp>;
};


export type geodataquery_rootspatialRefSysAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeodataSpatialRefSysSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataSpatialRefSysOrderBy>>;
  where?: InputMaybe<GeodataSpatialRefSysBoolExp>;
};


export type geodataquery_rootspatialRefSysByPkArgs = {
  srid: Scalars['Int']['input'];
};


export type geodataquery_rootzipArgs = {
  distinctOn?: InputMaybe<Array<GeodataZipSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataZipOrderBy>>;
  where?: InputMaybe<GeodataZipBoolExp>;
};


export type geodataquery_rootzipAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeodataZipSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataZipOrderBy>>;
  where?: InputMaybe<GeodataZipBoolExp>;
};


export type geodataquery_rootzipByPkArgs = {
  zip: Scalars['String']['input'];
};

export type geodatasubscription_root = {
  __typename?: 'geodatasubscription_root';
  /** fetch data from the table: "address" */
  address: Array<GeodataAddress>;
  /** fetch aggregated fields from the table: "address" */
  addressAggregate: GeodataAddressAggregate;
  /** fetch data from the table: "address" using primary key columns */
  addressByPk?: Maybe<GeodataAddress>;
  /** fetch data from the table in a streaming manner: "address" */
  addressStream: Array<GeodataAddress>;
  /** fetch data from the table: "matrikkelenadresseleilighetsniva.adressetilleggsnavnkildekode" */
  matrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode: Array<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode>;
  /** fetch aggregated fields from the table: "matrikkelenadresseleilighetsniva.adressetilleggsnavnkildekode" */
  matrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregate: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregate;
  /** fetch data from the table in a streaming manner: "matrikkelenadresseleilighetsniva.adressetilleggsnavnkildekode" */
  matrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeStream: Array<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode>;
  /** fetch data from the table: "matrikkelenadresseleilighetsniva.atkomst" */
  matrikkelenadresseleilighetsnivaAtkomst: Array<GeodataMatrikkelenadresseleilighetsnivaAtkomst>;
  /** fetch aggregated fields from the table: "matrikkelenadresseleilighetsniva.atkomst" */
  matrikkelenadresseleilighetsnivaAtkomstAggregate: GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregate;
  /** fetch data from the table in a streaming manner: "matrikkelenadresseleilighetsniva.atkomst" */
  matrikkelenadresseleilighetsnivaAtkomstStream: Array<GeodataMatrikkelenadresseleilighetsnivaAtkomst>;
  /** fetch data from the table: "matrikkelenadresseleilighetsniva.kommunenummer" */
  matrikkelenadresseleilighetsnivaKommunenummer: Array<GeodataMatrikkelenadresseleilighetsnivaKommunenummer>;
  /** fetch aggregated fields from the table: "matrikkelenadresseleilighetsniva.kommunenummer" */
  matrikkelenadresseleilighetsnivaKommunenummerAggregate: GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregate;
  /** fetch data from the table in a streaming manner: "matrikkelenadresseleilighetsniva.kommunenummer" */
  matrikkelenadresseleilighetsnivaKommunenummerStream: Array<GeodataMatrikkelenadresseleilighetsnivaKommunenummer>;
  /** fetch data from the table: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet" */
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet: Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet>;
  /** fetch aggregated fields from the table: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet" */
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregate: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregate;
  /** fetch data from the table: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_atkomstid" */
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid: Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid>;
  /** fetch aggregated fields from the table: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_atkomstid" */
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregate: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregate;
  /** fetch data from the table in a streaming manner: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_atkomstid" */
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStream: Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid>;
  /** fetch data from the table in a streaming manner: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet" */
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStream: Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet>;
  /** fetch data from the table: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_uuidatkomst" */
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst: Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst>;
  /** fetch aggregated fields from the table: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_uuidatkomst" */
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregate: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregate;
  /** fetch data from the table in a streaming manner: "matrikkelenadresseleilighetsniva.matrikkeladressebruksenhet_uuidatkomst" */
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStream: Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst>;
  /** fetch data from the table: "matrikkelenadresseleilighetsniva.typeatkomst" */
  matrikkelenadresseleilighetsnivaTypeatkomst: Array<GeodataMatrikkelenadresseleilighetsnivaTypeatkomst>;
  /** fetch aggregated fields from the table: "matrikkelenadresseleilighetsniva.typeatkomst" */
  matrikkelenadresseleilighetsnivaTypeatkomstAggregate: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregate;
  /** fetch data from the table in a streaming manner: "matrikkelenadresseleilighetsniva.typeatkomst" */
  matrikkelenadresseleilighetsnivaTypeatkomstStream: Array<GeodataMatrikkelenadresseleilighetsnivaTypeatkomst>;
  /** fetch data from the table: "matrikkelenadresseleilighetsniva.vegadressebruksenhet" */
  matrikkelenadresseleilighetsnivaVegadressebruksenhet: Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhet>;
  /** fetch aggregated fields from the table: "matrikkelenadresseleilighetsniva.vegadressebruksenhet" */
  matrikkelenadresseleilighetsnivaVegadressebruksenhetAggregate: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregate;
  /** fetch data from the table: "matrikkelenadresseleilighetsniva.vegadressebruksenhet_atkomstid" */
  matrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid: Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid>;
  /** fetch aggregated fields from the table: "matrikkelenadresseleilighetsniva.vegadressebruksenhet_atkomstid" */
  matrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregate: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregate;
  /** fetch data from the table in a streaming manner: "matrikkelenadresseleilighetsniva.vegadressebruksenhet_atkomstid" */
  matrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStream: Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid>;
  /** fetch data from the table in a streaming manner: "matrikkelenadresseleilighetsniva.vegadressebruksenhet" */
  matrikkelenadresseleilighetsnivaVegadressebruksenhetStream: Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhet>;
  /** fetch data from the table: "matrikkelenadresseleilighetsniva.vegadressebruksenhet_uuidatkomst" */
  matrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst: Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst>;
  /** fetch aggregated fields from the table: "matrikkelenadresseleilighetsniva.vegadressebruksenhet_uuidatkomst" */
  matrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregate: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregate;
  /** fetch data from the table in a streaming manner: "matrikkelenadresseleilighetsniva.vegadressebruksenhet_uuidatkomst" */
  matrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStream: Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst>;
  /** fetch data from the table: "spatial_ref_sys" */
  spatialRefSys: Array<GeodataSpatialRefSys>;
  /** fetch aggregated fields from the table: "spatial_ref_sys" */
  spatialRefSysAggregate: GeodataSpatialRefSysAggregate;
  /** fetch data from the table: "spatial_ref_sys" using primary key columns */
  spatialRefSysByPk?: Maybe<GeodataSpatialRefSys>;
  /** fetch data from the table in a streaming manner: "spatial_ref_sys" */
  spatialRefSysStream: Array<GeodataSpatialRefSys>;
  /** fetch data from the table: "zip" */
  zip: Array<GeodataZip>;
  /** fetch aggregated fields from the table: "zip" */
  zipAggregate: GeodataZipAggregate;
  /** fetch data from the table: "zip" using primary key columns */
  zipByPk?: Maybe<GeodataZip>;
  /** fetch data from the table in a streaming manner: "zip" */
  zipStream: Array<GeodataZip>;
};


export type geodatasubscription_rootaddressArgs = {
  distinctOn?: InputMaybe<Array<GeodataAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataAddressOrderBy>>;
  where?: InputMaybe<GeodataAddressBoolExp>;
};


export type geodatasubscription_rootaddressAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeodataAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataAddressOrderBy>>;
  where?: InputMaybe<GeodataAddressBoolExp>;
};


export type geodatasubscription_rootaddressByPkArgs = {
  id: Scalars['Geodatauuid']['input'];
};


export type geodatasubscription_rootaddressStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<GeodataAddressStreamCursorInput>>;
  where?: InputMaybe<GeodataAddressBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeStreamCursorInput>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaAtkomstArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaAtkomstSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaAtkomstOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaAtkomstBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaAtkomstAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaAtkomstSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaAtkomstOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaAtkomstBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaAtkomstStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<GeodataMatrikkelenadresseleilighetsnivaAtkomstStreamCursorInput>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaAtkomstBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaKommunenummerArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaKommunenummerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaKommunenummerOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaKommunenummerBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaKommunenummerAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaKommunenummerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaKommunenummerOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaKommunenummerBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaKommunenummerStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<GeodataMatrikkelenadresseleilighetsnivaKommunenummerStreamCursorInput>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaKommunenummerBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStreamCursorInput>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStreamCursorInput>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStreamCursorInput>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaTypeatkomstArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaTypeatkomstAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaTypeatkomstStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstStreamCursorInput>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStreamCursorInput>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStreamCursorInput>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstOrderBy>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstBoolExp>;
};


export type geodatasubscription_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStreamCursorInput>>;
  where?: InputMaybe<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstBoolExp>;
};


export type geodatasubscription_rootspatialRefSysArgs = {
  distinctOn?: InputMaybe<Array<GeodataSpatialRefSysSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataSpatialRefSysOrderBy>>;
  where?: InputMaybe<GeodataSpatialRefSysBoolExp>;
};


export type geodatasubscription_rootspatialRefSysAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeodataSpatialRefSysSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataSpatialRefSysOrderBy>>;
  where?: InputMaybe<GeodataSpatialRefSysBoolExp>;
};


export type geodatasubscription_rootspatialRefSysByPkArgs = {
  srid: Scalars['Int']['input'];
};


export type geodatasubscription_rootspatialRefSysStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<GeodataSpatialRefSysStreamCursorInput>>;
  where?: InputMaybe<GeodataSpatialRefSysBoolExp>;
};


export type geodatasubscription_rootzipArgs = {
  distinctOn?: InputMaybe<Array<GeodataZipSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataZipOrderBy>>;
  where?: InputMaybe<GeodataZipBoolExp>;
};


export type geodatasubscription_rootzipAggregateArgs = {
  distinctOn?: InputMaybe<Array<GeodataZipSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GeodataZipOrderBy>>;
  where?: InputMaybe<GeodataZipBoolExp>;
};


export type geodatasubscription_rootzipByPkArgs = {
  zip: Scalars['String']['input'];
};


export type geodatasubscription_rootzipStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<GeodataZipStreamCursorInput>>;
  where?: InputMaybe<GeodataZipBoolExp>;
};

export type getEmailAccountInput = {
  userId: Scalars['uuid']['input'];
};

export type getEmailAccountOutput = {
  __typename?: 'getEmailAccountOutput';
  id: Scalars['uuid']['output'];
  idToken: Scalars['String']['output'];
  linkedAddress: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  subscriptionExpiration?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
  type: ProviderTypeEmail;
  userId: Scalars['uuid']['output'];
};

/** fields of action: "incomingSms" */
export type incomingSms = {
  __typename?: 'incomingSms';
  /** the time at which this action was created */
  created_at: Scalars['timestamptz']['output'];
  /** errors related to the invocation */
  errors?: Maybe<Scalars['json']['output']>;
  /** the unique id of an action */
  id: Scalars['uuid']['output'];
  /** the output fields of this action */
  output?: Maybe<IncomingSMSOutput>;
};

export type inviteObject = {
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  extraData?: InputMaybe<Scalars['jsonb']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  toUserId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type inviteOutput = {
  __typename?: 'inviteOutput';
  result: Scalars['json']['output'];
};

/** columns and relationships of "business.languages" */
export type languages = {
  __typename?: 'languages';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "business.languages" */
export type languagesAggregate = {
  __typename?: 'languagesAggregate';
  aggregate?: Maybe<languagesAggregateFields>;
  nodes: Array<languages>;
};

/** aggregate fields of "business.languages" */
export type languagesAggregateFields = {
  __typename?: 'languagesAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<languagesMaxFields>;
  min?: Maybe<languagesMinFields>;
};


/** aggregate fields of "business.languages" */
export type languagesAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<languagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.languages". All fields are combined with a logical 'AND'. */
export type languagesBoolExp = {
  _and?: InputMaybe<Array<languagesBoolExp>>;
  _not?: InputMaybe<languagesBoolExp>;
  _or?: InputMaybe<Array<languagesBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.languages" */
export type languagesConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'languages_pkey'
  | '%future added value';

/** input type for inserting data into table "business.languages" */
export type languagesInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type languagesMaxFields = {
  __typename?: 'languagesMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type languagesMinFields = {
  __typename?: 'languagesMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.languages" */
export type languagesMutationResponse = {
  __typename?: 'languagesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<languages>;
};

/** input type for inserting object relation for remote table "business.languages" */
export type languagesObjRelInsertInput = {
  data: languagesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<languagesOnConflict>;
};

/** on_conflict condition type for table "business.languages" */
export type languagesOnConflict = {
  constraint: languagesConstraint;
  updateColumns?: Array<languagesUpdateColumn>;
  where?: InputMaybe<languagesBoolExp>;
};

/** Ordering options when selecting data from "business.languages". */
export type languagesOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.languages */
export type languagesPkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "business.languages" */
export type languagesSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "business.languages" */
export type languagesSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "languages" */
export type languagesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: languagesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type languagesStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.languages" */
export type languagesUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type languagesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<languagesSetInput>;
  /** filter the rows which have to be updated */
  where: languagesBoolExp;
};

export type leaveOrganizationObject = {
  organizationId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type leaveOrganizationOutput = {
  __typename?: 'leaveOrganizationOutput';
  result: Scalars['jsonb']['output'];
};

/** columns and relationships of "business.message" */
export type message = {
  __typename?: 'message';
  /** An object relationship */
  activity?: Maybe<domainActivity>;
  activityId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  attachments: Array<BusinessMessageAttachments>;
  /** An aggregate relationship */
  attachmentsAggregate: BusinessMessageAttachmentsAggregate;
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  messageType?: Maybe<messageType>;
  system?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<messageTypeEnum>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<user>;
  userId?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "business.message" */
export type messageattachmentsArgs = {
  distinctOn?: InputMaybe<Array<BusinessMessageAttachmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessMessageAttachmentsOrderBy>>;
  where?: InputMaybe<BusinessMessageAttachmentsBoolExp>;
};


/** columns and relationships of "business.message" */
export type messageattachmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessMessageAttachmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessMessageAttachmentsOrderBy>>;
  where?: InputMaybe<BusinessMessageAttachmentsBoolExp>;
};

/** aggregated selection of "business.message" */
export type messageAggregate = {
  __typename?: 'messageAggregate';
  aggregate?: Maybe<messageAggregateFields>;
  nodes: Array<message>;
};

export type messageAggregateBoolExp = {
  bool_and?: InputMaybe<messageAggregateBoolExpBool_and>;
  bool_or?: InputMaybe<messageAggregateBoolExpBool_or>;
  count?: InputMaybe<messageAggregateBoolExpCount>;
};

export type messageAggregateBoolExpBool_and = {
  arguments: messageSelectColumnMessageAggregateBoolExpBool_andArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<messageBoolExp>;
  predicate: BooleanComparisonExp;
};

export type messageAggregateBoolExpBool_or = {
  arguments: messageSelectColumnMessageAggregateBoolExpBool_orArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<messageBoolExp>;
  predicate: BooleanComparisonExp;
};

export type messageAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<messageSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<messageBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "business.message" */
export type messageAggregateFields = {
  __typename?: 'messageAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<messageMaxFields>;
  min?: Maybe<messageMinFields>;
};


/** aggregate fields of "business.message" */
export type messageAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<messageSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.message" */
export type messageAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<messageMaxOrderBy>;
  min?: InputMaybe<messageMinOrderBy>;
};

/** input type for inserting array relation for remote table "business.message" */
export type messageArrRelInsertInput = {
  data: Array<messageInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<messageOnConflict>;
};

/** Boolean expression to filter rows from the table "business.message". All fields are combined with a logical 'AND'. */
export type messageBoolExp = {
  _and?: InputMaybe<Array<messageBoolExp>>;
  _not?: InputMaybe<messageBoolExp>;
  _or?: InputMaybe<Array<messageBoolExp>>;
  activity?: InputMaybe<domainActivityBoolExp>;
  activityId?: InputMaybe<UuidComparisonExp>;
  attachments?: InputMaybe<BusinessMessageAttachmentsBoolExp>;
  attachmentsAggregate?: InputMaybe<BusinessMessageAttachmentsAggregateBoolExp>;
  content?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  messageType?: InputMaybe<messageTypeBoolExp>;
  system?: InputMaybe<BooleanComparisonExp>;
  type?: InputMaybe<MessageTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<userBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "business.message" */
export type messageConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'message_pkey'
  | '%future added value';

/** input type for inserting data into table "business.message" */
export type messageInsertInput = {
  activity?: InputMaybe<domainActivityObjRelInsertInput>;
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  attachments?: InputMaybe<BusinessMessageAttachmentsArrRelInsertInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  messageType?: InputMaybe<messageTypeObjRelInsertInput>;
  system?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<messageTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<userObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type messageMaxFields = {
  __typename?: 'messageMaxFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "business.message" */
export type messageMaxOrderBy = {
  activityId?: InputMaybe<OrderBy>;
  content?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type messageMinFields = {
  __typename?: 'messageMinFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "business.message" */
export type messageMinOrderBy = {
  activityId?: InputMaybe<OrderBy>;
  content?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "business.message" */
export type messageMutationResponse = {
  __typename?: 'messageMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<message>;
};

/** on_conflict condition type for table "business.message" */
export type messageOnConflict = {
  constraint: messageConstraint;
  updateColumns?: Array<messageUpdateColumn>;
  where?: InputMaybe<messageBoolExp>;
};

/** Ordering options when selecting data from "business.message". */
export type messageOrderBy = {
  activity?: InputMaybe<domainActivityOrderBy>;
  activityId?: InputMaybe<OrderBy>;
  attachmentsAggregate?: InputMaybe<BusinessMessageAttachmentsAggregateOrderBy>;
  content?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  messageType?: InputMaybe<messageTypeOrderBy>;
  system?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<userOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.message */
export type messagePkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "business.message" */
export type messageSelectColumn =
  /** column name */
  | 'activityId'
  /** column name */
  | 'content'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'system'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

/** select "messageAggregateBoolExpBool_andArgumentsColumns" columns of table "business.message" */
export type messageSelectColumnMessageAggregateBoolExpBool_andArgumentsColumns =
  /** column name */
  | 'system'
  | '%future added value';

/** select "messageAggregateBoolExpBool_orArgumentsColumns" columns of table "business.message" */
export type messageSelectColumnMessageAggregateBoolExpBool_orArgumentsColumns =
  /** column name */
  | 'system'
  | '%future added value';

/** input type for updating data in table "business.message" */
export type messageSetInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  system?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<messageTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "message" */
export type messageStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: messageStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type messageStreamCursorValueInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  system?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<messageTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "business.message_type" */
export type messageType = {
  __typename?: 'messageType';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "business.message_type" */
export type messageTypeAggregate = {
  __typename?: 'messageTypeAggregate';
  aggregate?: Maybe<messageTypeAggregateFields>;
  nodes: Array<messageType>;
};

/** aggregate fields of "business.message_type" */
export type messageTypeAggregateFields = {
  __typename?: 'messageTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<messageTypeMaxFields>;
  min?: Maybe<messageTypeMinFields>;
};


/** aggregate fields of "business.message_type" */
export type messageTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<messageTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.message_type". All fields are combined with a logical 'AND'. */
export type messageTypeBoolExp = {
  _and?: InputMaybe<Array<messageTypeBoolExp>>;
  _not?: InputMaybe<messageTypeBoolExp>;
  _or?: InputMaybe<Array<messageTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.message_type" */
export type messageTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'message_type_pkey'
  | '%future added value';

export type messageTypeEnum =
  /** Html */
  | 'HTML'
  /** Plain text */
  | 'PLAIN'
  | '%future added value';

/** input type for inserting data into table "business.message_type" */
export type messageTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type messageTypeMaxFields = {
  __typename?: 'messageTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type messageTypeMinFields = {
  __typename?: 'messageTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.message_type" */
export type messageTypeMutationResponse = {
  __typename?: 'messageTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<messageType>;
};

/** input type for inserting object relation for remote table "business.message_type" */
export type messageTypeObjRelInsertInput = {
  data: messageTypeInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<messageTypeOnConflict>;
};

/** on_conflict condition type for table "business.message_type" */
export type messageTypeOnConflict = {
  constraint: messageTypeConstraint;
  updateColumns?: Array<messageTypeUpdateColumn>;
  where?: InputMaybe<messageTypeBoolExp>;
};

/** Ordering options when selecting data from "business.message_type". */
export type messageTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.message_type */
export type messageTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "business.message_type" */
export type messageTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "business.message_type" */
export type messageTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "messageType" */
export type messageTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: messageTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type messageTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.message_type" */
export type messageTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type messageTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<messageTypeSetInput>;
  /** filter the rows which have to be updated */
  where: messageTypeBoolExp;
};

/** update columns of table "business.message" */
export type messageUpdateColumn =
  /** column name */
  | 'activityId'
  /** column name */
  | 'content'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'system'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

export type messageUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<messageSetInput>;
  /** filter the rows which have to be updated */
  where: messageBoolExp;
};

/** columns and relationships of "messaging.activity" */
export type messagingActivity = {
  __typename?: 'messagingActivity';
  activityId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  activityOrganizations: Array<messagingActivityOrganization>;
  /** An aggregate relationship */
  activityOrganizationsAggregate: messagingActivityOrganizationAggregate;
  activityType?: Maybe<messagingActivityTypeEnum>;
  /** An array relationship */
  activityUsers: Array<messagingActivityUser>;
  /** An aggregate relationship */
  activityUsersAggregate: messagingActivityUserAggregate;
  createdAt: Scalars['timestamptz']['output'];
  endedAt?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  invitations: Array<MessagingInvitation>;
  /** An aggregate relationship */
  invitationsAggregate: MessagingInvitationAggregate;
  /** An array relationship */
  messages: Array<messagingMessage>;
  /** An aggregate relationship */
  messagesAggregate: messagingMessageAggregate;
  owner?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  settings?: Maybe<MessagingActivitySettings>;
  startedAt?: Maybe<Scalars['timestamptz']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "messaging.activity" */
export type messagingActivityactivityOrganizationsArgs = {
  distinctOn?: InputMaybe<Array<messagingActivityOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingActivityOrganizationOrderBy>>;
  where?: InputMaybe<messagingActivityOrganizationBoolExp>;
};


/** columns and relationships of "messaging.activity" */
export type messagingActivityactivityOrganizationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<messagingActivityOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingActivityOrganizationOrderBy>>;
  where?: InputMaybe<messagingActivityOrganizationBoolExp>;
};


/** columns and relationships of "messaging.activity" */
export type messagingActivityactivityUsersArgs = {
  distinctOn?: InputMaybe<Array<messagingActivityUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingActivityUserOrderBy>>;
  where?: InputMaybe<messagingActivityUserBoolExp>;
};


/** columns and relationships of "messaging.activity" */
export type messagingActivityactivityUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<messagingActivityUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingActivityUserOrderBy>>;
  where?: InputMaybe<messagingActivityUserBoolExp>;
};


/** columns and relationships of "messaging.activity" */
export type messagingActivityinvitationsArgs = {
  distinctOn?: InputMaybe<Array<MessagingInvitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingInvitationOrderBy>>;
  where?: InputMaybe<MessagingInvitationBoolExp>;
};


/** columns and relationships of "messaging.activity" */
export type messagingActivityinvitationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MessagingInvitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingInvitationOrderBy>>;
  where?: InputMaybe<MessagingInvitationBoolExp>;
};


/** columns and relationships of "messaging.activity" */
export type messagingActivitymessagesArgs = {
  distinctOn?: InputMaybe<Array<messagingMessageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingMessageOrderBy>>;
  where?: InputMaybe<messagingMessageBoolExp>;
};


/** columns and relationships of "messaging.activity" */
export type messagingActivitymessagesAggregateArgs = {
  distinctOn?: InputMaybe<Array<messagingMessageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingMessageOrderBy>>;
  where?: InputMaybe<messagingMessageBoolExp>;
};

/** aggregated selection of "messaging.activity" */
export type messagingActivityAggregate = {
  __typename?: 'messagingActivityAggregate';
  aggregate?: Maybe<messagingActivityAggregateFields>;
  nodes: Array<messagingActivity>;
};

/** aggregate fields of "messaging.activity" */
export type messagingActivityAggregateFields = {
  __typename?: 'messagingActivityAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<messagingActivityMaxFields>;
  min?: Maybe<messagingActivityMinFields>;
};


/** aggregate fields of "messaging.activity" */
export type messagingActivityAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<messagingActivitySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "messaging.activity". All fields are combined with a logical 'AND'. */
export type messagingActivityBoolExp = {
  _and?: InputMaybe<Array<messagingActivityBoolExp>>;
  _not?: InputMaybe<messagingActivityBoolExp>;
  _or?: InputMaybe<Array<messagingActivityBoolExp>>;
  activityId?: InputMaybe<UuidComparisonExp>;
  activityOrganizations?: InputMaybe<messagingActivityOrganizationBoolExp>;
  activityOrganizationsAggregate?: InputMaybe<messagingActivityOrganizationAggregateBoolExp>;
  activityType?: InputMaybe<MessagingActivityTypeEnumComparisonExp>;
  activityUsers?: InputMaybe<messagingActivityUserBoolExp>;
  activityUsersAggregate?: InputMaybe<messagingActivityUserAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  endedAt?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  invitations?: InputMaybe<MessagingInvitationBoolExp>;
  invitationsAggregate?: InputMaybe<MessagingInvitationAggregateBoolExp>;
  messages?: InputMaybe<messagingMessageBoolExp>;
  messagesAggregate?: InputMaybe<messagingMessageAggregateBoolExp>;
  owner?: InputMaybe<UuidComparisonExp>;
  settings?: InputMaybe<MessagingActivitySettingsBoolExp>;
  startedAt?: InputMaybe<TimestamptzComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "messaging.activity" */
export type messagingActivityConstraint =
  /** unique or primary key constraint on columns "activity_activity_id" */
  | 'activity_activity_activity_id_key'
  /** unique or primary key constraint on columns "id" */
  | 'activity_pkey'
  | '%future added value';

/** input type for inserting data into table "messaging.activity" */
export type messagingActivityInsertInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  activityOrganizations?: InputMaybe<messagingActivityOrganizationArrRelInsertInput>;
  activityType?: InputMaybe<messagingActivityTypeEnum>;
  activityUsers?: InputMaybe<messagingActivityUserArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endedAt?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invitations?: InputMaybe<MessagingInvitationArrRelInsertInput>;
  messages?: InputMaybe<messagingMessageArrRelInsertInput>;
  owner?: InputMaybe<Scalars['uuid']['input']>;
  settings?: InputMaybe<MessagingActivitySettingsObjRelInsertInput>;
  startedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type messagingActivityMaxFields = {
  __typename?: 'messagingActivityMaxFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  endedAt?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  owner?: Maybe<Scalars['uuid']['output']>;
  startedAt?: Maybe<Scalars['timestamptz']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type messagingActivityMinFields = {
  __typename?: 'messagingActivityMinFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  endedAt?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  owner?: Maybe<Scalars['uuid']['output']>;
  startedAt?: Maybe<Scalars['timestamptz']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "messaging.activity" */
export type messagingActivityMutationResponse = {
  __typename?: 'messagingActivityMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<messagingActivity>;
};

/** input type for inserting object relation for remote table "messaging.activity" */
export type messagingActivityObjRelInsertInput = {
  data: messagingActivityInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<messagingActivityOnConflict>;
};

/** on_conflict condition type for table "messaging.activity" */
export type messagingActivityOnConflict = {
  constraint: messagingActivityConstraint;
  updateColumns?: Array<messagingActivityUpdateColumn>;
  where?: InputMaybe<messagingActivityBoolExp>;
};

/** Ordering options when selecting data from "messaging.activity". */
export type messagingActivityOrderBy = {
  activityId?: InputMaybe<OrderBy>;
  activityOrganizationsAggregate?: InputMaybe<messagingActivityOrganizationAggregateOrderBy>;
  activityType?: InputMaybe<OrderBy>;
  activityUsersAggregate?: InputMaybe<messagingActivityUserAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  endedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invitationsAggregate?: InputMaybe<MessagingInvitationAggregateOrderBy>;
  messagesAggregate?: InputMaybe<messagingMessageAggregateOrderBy>;
  owner?: InputMaybe<OrderBy>;
  settings?: InputMaybe<MessagingActivitySettingsOrderBy>;
  startedAt?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** columns and relationships of "messaging.activity_organization" */
export type messagingActivityOrganization = {
  __typename?: 'messagingActivityOrganization';
  /** An object relationship */
  activity: messagingActivity;
  activityId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organization?: Maybe<organization>;
  organizationId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "messaging.activity_organization" */
export type messagingActivityOrganizationAggregate = {
  __typename?: 'messagingActivityOrganizationAggregate';
  aggregate?: Maybe<messagingActivityOrganizationAggregateFields>;
  nodes: Array<messagingActivityOrganization>;
};

export type messagingActivityOrganizationAggregateBoolExp = {
  count?: InputMaybe<messagingActivityOrganizationAggregateBoolExpCount>;
};

export type messagingActivityOrganizationAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<messagingActivityOrganizationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<messagingActivityOrganizationBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "messaging.activity_organization" */
export type messagingActivityOrganizationAggregateFields = {
  __typename?: 'messagingActivityOrganizationAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<messagingActivityOrganizationMaxFields>;
  min?: Maybe<messagingActivityOrganizationMinFields>;
};


/** aggregate fields of "messaging.activity_organization" */
export type messagingActivityOrganizationAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<messagingActivityOrganizationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "messaging.activity_organization" */
export type messagingActivityOrganizationAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<messagingActivityOrganizationMaxOrderBy>;
  min?: InputMaybe<messagingActivityOrganizationMinOrderBy>;
};

/** input type for inserting array relation for remote table "messaging.activity_organization" */
export type messagingActivityOrganizationArrRelInsertInput = {
  data: Array<messagingActivityOrganizationInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<messagingActivityOrganizationOnConflict>;
};

/** Boolean expression to filter rows from the table "messaging.activity_organization". All fields are combined with a logical 'AND'. */
export type messagingActivityOrganizationBoolExp = {
  _and?: InputMaybe<Array<messagingActivityOrganizationBoolExp>>;
  _not?: InputMaybe<messagingActivityOrganizationBoolExp>;
  _or?: InputMaybe<Array<messagingActivityOrganizationBoolExp>>;
  activity?: InputMaybe<messagingActivityBoolExp>;
  activityId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organization?: InputMaybe<organizationBoolExp>;
  organizationId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "messaging.activity_organization" */
export type messagingActivityOrganizationConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'activity_organization_pkey'
  | '%future added value';

/** input type for inserting data into table "messaging.activity_organization" */
export type messagingActivityOrganizationInsertInput = {
  activity?: InputMaybe<messagingActivityObjRelInsertInput>;
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization?: InputMaybe<organizationObjRelInsertInput>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type messagingActivityOrganizationMaxFields = {
  __typename?: 'messagingActivityOrganizationMaxFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "messaging.activity_organization" */
export type messagingActivityOrganizationMaxOrderBy = {
  activityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type messagingActivityOrganizationMinFields = {
  __typename?: 'messagingActivityOrganizationMinFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "messaging.activity_organization" */
export type messagingActivityOrganizationMinOrderBy = {
  activityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "messaging.activity_organization" */
export type messagingActivityOrganizationMutationResponse = {
  __typename?: 'messagingActivityOrganizationMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<messagingActivityOrganization>;
};

/** on_conflict condition type for table "messaging.activity_organization" */
export type messagingActivityOrganizationOnConflict = {
  constraint: messagingActivityOrganizationConstraint;
  updateColumns?: Array<messagingActivityOrganizationUpdateColumn>;
  where?: InputMaybe<messagingActivityOrganizationBoolExp>;
};

/** Ordering options when selecting data from "messaging.activity_organization". */
export type messagingActivityOrganizationOrderBy = {
  activity?: InputMaybe<messagingActivityOrderBy>;
  activityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organization?: InputMaybe<organizationOrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: messaging.activity_organization */
export type messagingActivityOrganizationPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "messaging.activity_organization" */
export type messagingActivityOrganizationSelectColumn =
  /** column name */
  | 'activityId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "messaging.activity_organization" */
export type messagingActivityOrganizationSetInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "messagingActivityOrganization" */
export type messagingActivityOrganizationStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: messagingActivityOrganizationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type messagingActivityOrganizationStreamCursorValueInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "messaging.activity_organization" */
export type messagingActivityOrganizationUpdateColumn =
  /** column name */
  | 'activityId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type messagingActivityOrganizationUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<messagingActivityOrganizationSetInput>;
  /** filter the rows which have to be updated */
  where: messagingActivityOrganizationBoolExp;
};

/** primary key columns input for table: messaging.activity */
export type messagingActivityPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "messaging.activity" */
export type messagingActivitySelectColumn =
  /** column name */
  | 'activityId'
  /** column name */
  | 'activityType'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'endedAt'
  /** column name */
  | 'id'
  /** column name */
  | 'owner'
  /** column name */
  | 'startedAt'
  /** column name */
  | 'title'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "messaging.activity" */
export type messagingActivitySetInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  activityType?: InputMaybe<messagingActivityTypeEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endedAt?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  owner?: InputMaybe<Scalars['uuid']['input']>;
  startedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "messagingActivity" */
export type messagingActivityStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: messagingActivityStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type messagingActivityStreamCursorValueInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  activityType?: InputMaybe<messagingActivityTypeEnum>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endedAt?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  owner?: InputMaybe<Scalars['uuid']['input']>;
  startedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "messaging.activity_type" */
export type messagingActivityType = {
  __typename?: 'messagingActivityType';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "messaging.activity_type" */
export type messagingActivityTypeAggregate = {
  __typename?: 'messagingActivityTypeAggregate';
  aggregate?: Maybe<messagingActivityTypeAggregateFields>;
  nodes: Array<messagingActivityType>;
};

/** aggregate fields of "messaging.activity_type" */
export type messagingActivityTypeAggregateFields = {
  __typename?: 'messagingActivityTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<messagingActivityTypeMaxFields>;
  min?: Maybe<messagingActivityTypeMinFields>;
};


/** aggregate fields of "messaging.activity_type" */
export type messagingActivityTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<messagingActivityTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "messaging.activity_type". All fields are combined with a logical 'AND'. */
export type messagingActivityTypeBoolExp = {
  _and?: InputMaybe<Array<messagingActivityTypeBoolExp>>;
  _not?: InputMaybe<messagingActivityTypeBoolExp>;
  _or?: InputMaybe<Array<messagingActivityTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "messaging.activity_type" */
export type messagingActivityTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'activity_type_pkey'
  | '%future added value';

export type messagingActivityTypeEnum =
  /** Groups */
  | 'GROUP'
  /** Instant messaging */
  | 'INSTANT'
  /** Facebook messenger */
  | 'MESSENGER'
  /** A organization room that is auto created and including all organization users */
  | 'ORGANIZATIONROOM'
  | '%future added value';

/** input type for inserting data into table "messaging.activity_type" */
export type messagingActivityTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type messagingActivityTypeMaxFields = {
  __typename?: 'messagingActivityTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type messagingActivityTypeMinFields = {
  __typename?: 'messagingActivityTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "messaging.activity_type" */
export type messagingActivityTypeMutationResponse = {
  __typename?: 'messagingActivityTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<messagingActivityType>;
};

/** on_conflict condition type for table "messaging.activity_type" */
export type messagingActivityTypeOnConflict = {
  constraint: messagingActivityTypeConstraint;
  updateColumns?: Array<messagingActivityTypeUpdateColumn>;
  where?: InputMaybe<messagingActivityTypeBoolExp>;
};

/** Ordering options when selecting data from "messaging.activity_type". */
export type messagingActivityTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: messaging.activity_type */
export type messagingActivityTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "messaging.activity_type" */
export type messagingActivityTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "messaging.activity_type" */
export type messagingActivityTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "messagingActivityType" */
export type messagingActivityTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: messagingActivityTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type messagingActivityTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "messaging.activity_type" */
export type messagingActivityTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type messagingActivityTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<messagingActivityTypeSetInput>;
  /** filter the rows which have to be updated */
  where: messagingActivityTypeBoolExp;
};

/** update columns of table "messaging.activity" */
export type messagingActivityUpdateColumn =
  /** column name */
  | 'activityId'
  /** column name */
  | 'activityType'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'endedAt'
  /** column name */
  | 'id'
  /** column name */
  | 'owner'
  /** column name */
  | 'startedAt'
  /** column name */
  | 'title'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type messagingActivityUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<messagingActivitySetInput>;
  /** filter the rows which have to be updated */
  where: messagingActivityBoolExp;
};

/** columns and relationships of "messaging.activity_user" */
export type messagingActivityUser = {
  __typename?: 'messagingActivityUser';
  /** An object relationship */
  activity: messagingActivity;
  activityId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  unreadImportantMessages: Scalars['Int']['output'];
  unreadMessages: Scalars['Int']['output'];
  /** An object relationship */
  user: user;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "messaging.activity_user" */
export type messagingActivityUserAggregate = {
  __typename?: 'messagingActivityUserAggregate';
  aggregate?: Maybe<messagingActivityUserAggregateFields>;
  nodes: Array<messagingActivityUser>;
};

export type messagingActivityUserAggregateBoolExp = {
  count?: InputMaybe<messagingActivityUserAggregateBoolExpCount>;
};

export type messagingActivityUserAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<messagingActivityUserSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<messagingActivityUserBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "messaging.activity_user" */
export type messagingActivityUserAggregateFields = {
  __typename?: 'messagingActivityUserAggregateFields';
  avg?: Maybe<messagingActivityUserAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<messagingActivityUserMaxFields>;
  min?: Maybe<messagingActivityUserMinFields>;
  stddev?: Maybe<messagingActivityUserStddevFields>;
  stddevPop?: Maybe<messagingActivityUserStddevPopFields>;
  stddevSamp?: Maybe<messagingActivityUserStddevSampFields>;
  sum?: Maybe<messagingActivityUserSumFields>;
  varPop?: Maybe<messagingActivityUserVarPopFields>;
  varSamp?: Maybe<messagingActivityUserVarSampFields>;
  variance?: Maybe<messagingActivityUserVarianceFields>;
};


/** aggregate fields of "messaging.activity_user" */
export type messagingActivityUserAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<messagingActivityUserSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "messaging.activity_user" */
export type messagingActivityUserAggregateOrderBy = {
  avg?: InputMaybe<messagingActivityUserAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<messagingActivityUserMaxOrderBy>;
  min?: InputMaybe<messagingActivityUserMinOrderBy>;
  stddev?: InputMaybe<messagingActivityUserStddevOrderBy>;
  stddevPop?: InputMaybe<messagingActivityUserStddevPopOrderBy>;
  stddevSamp?: InputMaybe<messagingActivityUserStddevSampOrderBy>;
  sum?: InputMaybe<messagingActivityUserSumOrderBy>;
  varPop?: InputMaybe<messagingActivityUserVarPopOrderBy>;
  varSamp?: InputMaybe<messagingActivityUserVarSampOrderBy>;
  variance?: InputMaybe<messagingActivityUserVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "messaging.activity_user" */
export type messagingActivityUserArrRelInsertInput = {
  data: Array<messagingActivityUserInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<messagingActivityUserOnConflict>;
};

/** aggregate avg on columns */
export type messagingActivityUserAvgFields = {
  __typename?: 'messagingActivityUserAvgFields';
  unreadImportantMessages?: Maybe<Scalars['Float']['output']>;
  unreadMessages?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "messaging.activity_user" */
export type messagingActivityUserAvgOrderBy = {
  unreadImportantMessages?: InputMaybe<OrderBy>;
  unreadMessages?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "messaging.activity_user". All fields are combined with a logical 'AND'. */
export type messagingActivityUserBoolExp = {
  _and?: InputMaybe<Array<messagingActivityUserBoolExp>>;
  _not?: InputMaybe<messagingActivityUserBoolExp>;
  _or?: InputMaybe<Array<messagingActivityUserBoolExp>>;
  activity?: InputMaybe<messagingActivityBoolExp>;
  activityId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  unreadImportantMessages?: InputMaybe<IntComparisonExp>;
  unreadMessages?: InputMaybe<IntComparisonExp>;
  user?: InputMaybe<userBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "messaging.activity_user" */
export type messagingActivityUserConstraint =
  /** unique or primary key constraint on columns "user_id", "activity_id" */
  | 'activity_user_activity_id_user_id_key'
  /** unique or primary key constraint on columns "id" */
  | 'activity_user_pkey'
  | '%future added value';

/** input type for incrementing numeric columns in table "messaging.activity_user" */
export type messagingActivityUserIncInput = {
  unreadImportantMessages?: InputMaybe<Scalars['Int']['input']>;
  unreadMessages?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "messaging.activity_user" */
export type messagingActivityUserInsertInput = {
  activity?: InputMaybe<messagingActivityObjRelInsertInput>;
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  unreadImportantMessages?: InputMaybe<Scalars['Int']['input']>;
  unreadMessages?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<userObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type messagingActivityUserMaxFields = {
  __typename?: 'messagingActivityUserMaxFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  unreadImportantMessages?: Maybe<Scalars['Int']['output']>;
  unreadMessages?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "messaging.activity_user" */
export type messagingActivityUserMaxOrderBy = {
  activityId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  unreadImportantMessages?: InputMaybe<OrderBy>;
  unreadMessages?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type messagingActivityUserMinFields = {
  __typename?: 'messagingActivityUserMinFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  unreadImportantMessages?: Maybe<Scalars['Int']['output']>;
  unreadMessages?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "messaging.activity_user" */
export type messagingActivityUserMinOrderBy = {
  activityId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  unreadImportantMessages?: InputMaybe<OrderBy>;
  unreadMessages?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "messaging.activity_user" */
export type messagingActivityUserMutationResponse = {
  __typename?: 'messagingActivityUserMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<messagingActivityUser>;
};

/** on_conflict condition type for table "messaging.activity_user" */
export type messagingActivityUserOnConflict = {
  constraint: messagingActivityUserConstraint;
  updateColumns?: Array<messagingActivityUserUpdateColumn>;
  where?: InputMaybe<messagingActivityUserBoolExp>;
};

/** Ordering options when selecting data from "messaging.activity_user". */
export type messagingActivityUserOrderBy = {
  activity?: InputMaybe<messagingActivityOrderBy>;
  activityId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  unreadImportantMessages?: InputMaybe<OrderBy>;
  unreadMessages?: InputMaybe<OrderBy>;
  user?: InputMaybe<userOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: messaging.activity_user */
export type messagingActivityUserPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "messaging.activity_user" */
export type messagingActivityUserSelectColumn =
  /** column name */
  | 'activityId'
  /** column name */
  | 'id'
  /** column name */
  | 'unreadImportantMessages'
  /** column name */
  | 'unreadMessages'
  /** column name */
  | 'userId'
  | '%future added value';

/** input type for updating data in table "messaging.activity_user" */
export type messagingActivityUserSetInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  unreadImportantMessages?: InputMaybe<Scalars['Int']['input']>;
  unreadMessages?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type messagingActivityUserStddevFields = {
  __typename?: 'messagingActivityUserStddevFields';
  unreadImportantMessages?: Maybe<Scalars['Float']['output']>;
  unreadMessages?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "messaging.activity_user" */
export type messagingActivityUserStddevOrderBy = {
  unreadImportantMessages?: InputMaybe<OrderBy>;
  unreadMessages?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type messagingActivityUserStddevPopFields = {
  __typename?: 'messagingActivityUserStddevPopFields';
  unreadImportantMessages?: Maybe<Scalars['Float']['output']>;
  unreadMessages?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "messaging.activity_user" */
export type messagingActivityUserStddevPopOrderBy = {
  unreadImportantMessages?: InputMaybe<OrderBy>;
  unreadMessages?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type messagingActivityUserStddevSampFields = {
  __typename?: 'messagingActivityUserStddevSampFields';
  unreadImportantMessages?: Maybe<Scalars['Float']['output']>;
  unreadMessages?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "messaging.activity_user" */
export type messagingActivityUserStddevSampOrderBy = {
  unreadImportantMessages?: InputMaybe<OrderBy>;
  unreadMessages?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "messagingActivityUser" */
export type messagingActivityUserStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: messagingActivityUserStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type messagingActivityUserStreamCursorValueInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  unreadImportantMessages?: InputMaybe<Scalars['Int']['input']>;
  unreadMessages?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type messagingActivityUserSumFields = {
  __typename?: 'messagingActivityUserSumFields';
  unreadImportantMessages?: Maybe<Scalars['Int']['output']>;
  unreadMessages?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "messaging.activity_user" */
export type messagingActivityUserSumOrderBy = {
  unreadImportantMessages?: InputMaybe<OrderBy>;
  unreadMessages?: InputMaybe<OrderBy>;
};

/** update columns of table "messaging.activity_user" */
export type messagingActivityUserUpdateColumn =
  /** column name */
  | 'activityId'
  /** column name */
  | 'id'
  /** column name */
  | 'unreadImportantMessages'
  /** column name */
  | 'unreadMessages'
  /** column name */
  | 'userId'
  | '%future added value';

export type messagingActivityUserUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<messagingActivityUserIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<messagingActivityUserSetInput>;
  /** filter the rows which have to be updated */
  where: messagingActivityUserBoolExp;
};

/** aggregate varPop on columns */
export type messagingActivityUserVarPopFields = {
  __typename?: 'messagingActivityUserVarPopFields';
  unreadImportantMessages?: Maybe<Scalars['Float']['output']>;
  unreadMessages?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "messaging.activity_user" */
export type messagingActivityUserVarPopOrderBy = {
  unreadImportantMessages?: InputMaybe<OrderBy>;
  unreadMessages?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type messagingActivityUserVarSampFields = {
  __typename?: 'messagingActivityUserVarSampFields';
  unreadImportantMessages?: Maybe<Scalars['Float']['output']>;
  unreadMessages?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "messaging.activity_user" */
export type messagingActivityUserVarSampOrderBy = {
  unreadImportantMessages?: InputMaybe<OrderBy>;
  unreadMessages?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type messagingActivityUserVarianceFields = {
  __typename?: 'messagingActivityUserVarianceFields';
  unreadImportantMessages?: Maybe<Scalars['Float']['output']>;
  unreadMessages?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "messaging.activity_user" */
export type messagingActivityUserVarianceOrderBy = {
  unreadImportantMessages?: InputMaybe<OrderBy>;
  unreadMessages?: InputMaybe<OrderBy>;
};

export type messagingInvitationAggregateBoolExpBool_and = {
  arguments: MessagingInvitationSelectColumnMessagingInvitationAggregateBoolExpBool_andArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MessagingInvitationBoolExp>;
  predicate: BooleanComparisonExp;
};

export type messagingInvitationAggregateBoolExpBool_or = {
  arguments: MessagingInvitationSelectColumnMessagingInvitationAggregateBoolExpBool_orArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MessagingInvitationBoolExp>;
  predicate: BooleanComparisonExp;
};

export type messagingInvitationAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<MessagingInvitationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MessagingInvitationBoolExp>;
  predicate: IntComparisonExp;
};

export type messagingMentionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<MessagingMentionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MessagingMentionsBoolExp>;
  predicate: IntComparisonExp;
};

/** columns and relationships of "messaging.message" */
export type messagingMessage = {
  __typename?: 'messagingMessage';
  /** An object relationship */
  activity?: Maybe<messagingActivity>;
  activityId?: Maybe<Scalars['uuid']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  image?: Maybe<Scalars['String']['output']>;
  important?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  mentions: Array<MessagingMentions>;
  /** An aggregate relationship */
  mentionsAggregate: MessagingMentionsAggregate;
  /** An array relationship */
  messageAttachments: Array<MessagingMessageAttachment>;
  /** An aggregate relationship */
  messageAttachmentsAggregate: MessagingMessageAttachmentAggregate;
  /** An array relationship */
  messageEmojis: Array<messagingMessageEmoji>;
  /** An aggregate relationship */
  messageEmojisAggregate: messagingMessageEmojiAggregate;
  /** An aggregate relationship */
  messageReadsAggregate: messagingMessageReadAggregate;
  /** An array relationship */
  message_attachments: Array<MessagingMessageAttachment>;
  /** An array relationship */
  message_reads: Array<messagingMessageRead>;
  priority?: Maybe<MessagingMessagePriorityEnum>;
  system?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<messagingMessageTypeEnum>;
  updatedAt: Scalars['timestamptz']['output'];
  userId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  userTable?: Maybe<user>;
};


/** columns and relationships of "messaging.message" */
export type messagingMessagementionsArgs = {
  distinctOn?: InputMaybe<Array<MessagingMentionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingMentionsOrderBy>>;
  where?: InputMaybe<MessagingMentionsBoolExp>;
};


/** columns and relationships of "messaging.message" */
export type messagingMessagementionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MessagingMentionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingMentionsOrderBy>>;
  where?: InputMaybe<MessagingMentionsBoolExp>;
};


/** columns and relationships of "messaging.message" */
export type messagingMessagemessageAttachmentsArgs = {
  distinctOn?: InputMaybe<Array<MessagingMessageAttachmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingMessageAttachmentOrderBy>>;
  where?: InputMaybe<MessagingMessageAttachmentBoolExp>;
};


/** columns and relationships of "messaging.message" */
export type messagingMessagemessageAttachmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MessagingMessageAttachmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingMessageAttachmentOrderBy>>;
  where?: InputMaybe<MessagingMessageAttachmentBoolExp>;
};


/** columns and relationships of "messaging.message" */
export type messagingMessagemessageEmojisArgs = {
  distinctOn?: InputMaybe<Array<messagingMessageEmojiSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingMessageEmojiOrderBy>>;
  where?: InputMaybe<messagingMessageEmojiBoolExp>;
};


/** columns and relationships of "messaging.message" */
export type messagingMessagemessageEmojisAggregateArgs = {
  distinctOn?: InputMaybe<Array<messagingMessageEmojiSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingMessageEmojiOrderBy>>;
  where?: InputMaybe<messagingMessageEmojiBoolExp>;
};


/** columns and relationships of "messaging.message" */
export type messagingMessagemessageReadsAggregateArgs = {
  distinctOn?: InputMaybe<Array<messagingMessageReadSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingMessageReadOrderBy>>;
  where?: InputMaybe<messagingMessageReadBoolExp>;
};


/** columns and relationships of "messaging.message" */
export type messagingMessagemessage_attachmentsArgs = {
  distinctOn?: InputMaybe<Array<MessagingMessageAttachmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingMessageAttachmentOrderBy>>;
  where?: InputMaybe<MessagingMessageAttachmentBoolExp>;
};


/** columns and relationships of "messaging.message" */
export type messagingMessagemessage_readsArgs = {
  distinctOn?: InputMaybe<Array<messagingMessageReadSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingMessageReadOrderBy>>;
  where?: InputMaybe<messagingMessageReadBoolExp>;
};

/** aggregated selection of "messaging.message" */
export type messagingMessageAggregate = {
  __typename?: 'messagingMessageAggregate';
  aggregate?: Maybe<messagingMessageAggregateFields>;
  nodes: Array<messagingMessage>;
};

export type messagingMessageAggregateBoolExp = {
  bool_and?: InputMaybe<messagingMessageAggregateBoolExpBool_and>;
  bool_or?: InputMaybe<messagingMessageAggregateBoolExpBool_or>;
  count?: InputMaybe<messagingMessageAggregateBoolExpCount>;
};

export type messagingMessageAggregateBoolExpBool_and = {
  arguments: messagingMessageSelectColumnMessagingMessageAggregateBoolExpBool_andArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<messagingMessageBoolExp>;
  predicate: BooleanComparisonExp;
};

export type messagingMessageAggregateBoolExpBool_or = {
  arguments: messagingMessageSelectColumnMessagingMessageAggregateBoolExpBool_orArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<messagingMessageBoolExp>;
  predicate: BooleanComparisonExp;
};

export type messagingMessageAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<messagingMessageSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<messagingMessageBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "messaging.message" */
export type messagingMessageAggregateFields = {
  __typename?: 'messagingMessageAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<messagingMessageMaxFields>;
  min?: Maybe<messagingMessageMinFields>;
};


/** aggregate fields of "messaging.message" */
export type messagingMessageAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<messagingMessageSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "messaging.message" */
export type messagingMessageAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<messagingMessageMaxOrderBy>;
  min?: InputMaybe<messagingMessageMinOrderBy>;
};

/** input type for inserting array relation for remote table "messaging.message" */
export type messagingMessageArrRelInsertInput = {
  data: Array<messagingMessageInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<messagingMessageOnConflict>;
};

export type messagingMessageAttachmentAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<MessagingMessageAttachmentSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MessagingMessageAttachmentBoolExp>;
  predicate: IntComparisonExp;
};

/** Boolean expression to filter rows from the table "messaging.message". All fields are combined with a logical 'AND'. */
export type messagingMessageBoolExp = {
  _and?: InputMaybe<Array<messagingMessageBoolExp>>;
  _not?: InputMaybe<messagingMessageBoolExp>;
  _or?: InputMaybe<Array<messagingMessageBoolExp>>;
  activity?: InputMaybe<messagingActivityBoolExp>;
  activityId?: InputMaybe<UuidComparisonExp>;
  content?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  image?: InputMaybe<StringComparisonExp>;
  important?: InputMaybe<BooleanComparisonExp>;
  mentions?: InputMaybe<MessagingMentionsBoolExp>;
  mentionsAggregate?: InputMaybe<MessagingMentionsAggregateBoolExp>;
  messageAttachments?: InputMaybe<MessagingMessageAttachmentBoolExp>;
  messageAttachmentsAggregate?: InputMaybe<MessagingMessageAttachmentAggregateBoolExp>;
  messageEmojis?: InputMaybe<messagingMessageEmojiBoolExp>;
  messageEmojisAggregate?: InputMaybe<messagingMessageEmojiAggregateBoolExp>;
  message_attachments?: InputMaybe<MessagingMessageAttachmentBoolExp>;
  message_attachmentsAggregate?: InputMaybe<MessagingMessageAttachmentAggregateBoolExp>;
  message_reads?: InputMaybe<messagingMessageReadBoolExp>;
  message_readsAggregate?: InputMaybe<messagingMessageReadAggregateBoolExp>;
  priority?: InputMaybe<MessagingMessagePriorityEnumComparisonExp>;
  system?: InputMaybe<BooleanComparisonExp>;
  type?: InputMaybe<MessagingMessageTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userTable?: InputMaybe<userBoolExp>;
};

/** unique or primary key constraints on table "messaging.message" */
export type messagingMessageConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'messages_pkey'
  | '%future added value';

/** columns and relationships of "messaging.message_emoji" */
export type messagingMessageEmoji = {
  __typename?: 'messagingMessageEmoji';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  emoji: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  message: messagingMessage;
  messageId: Scalars['uuid']['output'];
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user?: Maybe<user>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "messaging.message_emoji" */
export type messagingMessageEmojiAggregate = {
  __typename?: 'messagingMessageEmojiAggregate';
  aggregate?: Maybe<messagingMessageEmojiAggregateFields>;
  nodes: Array<messagingMessageEmoji>;
};

export type messagingMessageEmojiAggregateBoolExp = {
  count?: InputMaybe<messagingMessageEmojiAggregateBoolExpCount>;
};

export type messagingMessageEmojiAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<messagingMessageEmojiSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<messagingMessageEmojiBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "messaging.message_emoji" */
export type messagingMessageEmojiAggregateFields = {
  __typename?: 'messagingMessageEmojiAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<messagingMessageEmojiMaxFields>;
  min?: Maybe<messagingMessageEmojiMinFields>;
};


/** aggregate fields of "messaging.message_emoji" */
export type messagingMessageEmojiAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<messagingMessageEmojiSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "messaging.message_emoji" */
export type messagingMessageEmojiAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<messagingMessageEmojiMaxOrderBy>;
  min?: InputMaybe<messagingMessageEmojiMinOrderBy>;
};

/** input type for inserting array relation for remote table "messaging.message_emoji" */
export type messagingMessageEmojiArrRelInsertInput = {
  data: Array<messagingMessageEmojiInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<messagingMessageEmojiOnConflict>;
};

/** Boolean expression to filter rows from the table "messaging.message_emoji". All fields are combined with a logical 'AND'. */
export type messagingMessageEmojiBoolExp = {
  _and?: InputMaybe<Array<messagingMessageEmojiBoolExp>>;
  _not?: InputMaybe<messagingMessageEmojiBoolExp>;
  _or?: InputMaybe<Array<messagingMessageEmojiBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  emoji?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  message?: InputMaybe<messagingMessageBoolExp>;
  messageId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<userBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "messaging.message_emoji" */
export type messagingMessageEmojiConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'message_emoji_pkey'
  | '%future added value';

/** input type for inserting data into table "messaging.message_emoji" */
export type messagingMessageEmojiInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<messagingMessageObjRelInsertInput>;
  messageId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<userObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type messagingMessageEmojiMaxFields = {
  __typename?: 'messagingMessageEmojiMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  emoji?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  messageId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "messaging.message_emoji" */
export type messagingMessageEmojiMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  emoji?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  messageId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type messagingMessageEmojiMinFields = {
  __typename?: 'messagingMessageEmojiMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  emoji?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  messageId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "messaging.message_emoji" */
export type messagingMessageEmojiMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  emoji?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  messageId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "messaging.message_emoji" */
export type messagingMessageEmojiMutationResponse = {
  __typename?: 'messagingMessageEmojiMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<messagingMessageEmoji>;
};

/** on_conflict condition type for table "messaging.message_emoji" */
export type messagingMessageEmojiOnConflict = {
  constraint: messagingMessageEmojiConstraint;
  updateColumns?: Array<messagingMessageEmojiUpdateColumn>;
  where?: InputMaybe<messagingMessageEmojiBoolExp>;
};

/** Ordering options when selecting data from "messaging.message_emoji". */
export type messagingMessageEmojiOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  emoji?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message?: InputMaybe<messagingMessageOrderBy>;
  messageId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<userOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: messaging.message_emoji */
export type messagingMessageEmojiPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "messaging.message_emoji" */
export type messagingMessageEmojiSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'emoji'
  /** column name */
  | 'id'
  /** column name */
  | 'messageId'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

/** input type for updating data in table "messaging.message_emoji" */
export type messagingMessageEmojiSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  messageId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "messagingMessageEmoji" */
export type messagingMessageEmojiStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: messagingMessageEmojiStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type messagingMessageEmojiStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  messageId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "messaging.message_emoji" */
export type messagingMessageEmojiUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'emoji'
  /** column name */
  | 'id'
  /** column name */
  | 'messageId'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

export type messagingMessageEmojiUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<messagingMessageEmojiSetInput>;
  /** filter the rows which have to be updated */
  where: messagingMessageEmojiBoolExp;
};

/** input type for inserting data into table "messaging.message" */
export type messagingMessageInsertInput = {
  activity?: InputMaybe<messagingActivityObjRelInsertInput>;
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  important?: InputMaybe<Scalars['Boolean']['input']>;
  mentions?: InputMaybe<MessagingMentionsArrRelInsertInput>;
  messageAttachments?: InputMaybe<MessagingMessageAttachmentArrRelInsertInput>;
  messageEmojis?: InputMaybe<messagingMessageEmojiArrRelInsertInput>;
  message_attachments?: InputMaybe<MessagingMessageAttachmentArrRelInsertInput>;
  message_reads?: InputMaybe<messagingMessageReadArrRelInsertInput>;
  priority?: InputMaybe<MessagingMessagePriorityEnum>;
  system?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<messagingMessageTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  userTable?: InputMaybe<userObjRelInsertInput>;
};

/** aggregate max on columns */
export type messagingMessageMaxFields = {
  __typename?: 'messagingMessageMaxFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "messaging.message" */
export type messagingMessageMaxOrderBy = {
  activityId?: InputMaybe<OrderBy>;
  content?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  image?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type messagingMessageMinFields = {
  __typename?: 'messagingMessageMinFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "messaging.message" */
export type messagingMessageMinOrderBy = {
  activityId?: InputMaybe<OrderBy>;
  content?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  image?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "messaging.message" */
export type messagingMessageMutationResponse = {
  __typename?: 'messagingMessageMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<messagingMessage>;
};

/** input type for inserting object relation for remote table "messaging.message" */
export type messagingMessageObjRelInsertInput = {
  data: messagingMessageInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<messagingMessageOnConflict>;
};

/** on_conflict condition type for table "messaging.message" */
export type messagingMessageOnConflict = {
  constraint: messagingMessageConstraint;
  updateColumns?: Array<messagingMessageUpdateColumn>;
  where?: InputMaybe<messagingMessageBoolExp>;
};

/** Ordering options when selecting data from "messaging.message". */
export type messagingMessageOrderBy = {
  activity?: InputMaybe<messagingActivityOrderBy>;
  activityId?: InputMaybe<OrderBy>;
  content?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  image?: InputMaybe<OrderBy>;
  important?: InputMaybe<OrderBy>;
  mentionsAggregate?: InputMaybe<MessagingMentionsAggregateOrderBy>;
  messageAttachmentsAggregate?: InputMaybe<MessagingMessageAttachmentAggregateOrderBy>;
  messageEmojisAggregate?: InputMaybe<messagingMessageEmojiAggregateOrderBy>;
  message_attachmentsAggregate?: InputMaybe<MessagingMessageAttachmentAggregateOrderBy>;
  message_readsAggregate?: InputMaybe<messagingMessageReadAggregateOrderBy>;
  priority?: InputMaybe<OrderBy>;
  system?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  userTable?: InputMaybe<userOrderBy>;
};

/** primary key columns input for table: messaging.message */
export type messagingMessagePkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "messaging.message_read" */
export type messagingMessageRead = {
  __typename?: 'messagingMessageRead';
  activityId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  message: messagingMessage;
  messageId: Scalars['uuid']['output'];
  read: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "messaging.message_read" */
export type messagingMessageReadAggregate = {
  __typename?: 'messagingMessageReadAggregate';
  aggregate?: Maybe<messagingMessageReadAggregateFields>;
  nodes: Array<messagingMessageRead>;
};

export type messagingMessageReadAggregateBoolExp = {
  bool_and?: InputMaybe<messagingMessageReadAggregateBoolExpBool_and>;
  bool_or?: InputMaybe<messagingMessageReadAggregateBoolExpBool_or>;
  count?: InputMaybe<messagingMessageReadAggregateBoolExpCount>;
};

export type messagingMessageReadAggregateBoolExpBool_and = {
  arguments: messagingMessageReadSelectColumnMessagingMessageReadAggregateBoolExpBool_andArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<messagingMessageReadBoolExp>;
  predicate: BooleanComparisonExp;
};

export type messagingMessageReadAggregateBoolExpBool_or = {
  arguments: messagingMessageReadSelectColumnMessagingMessageReadAggregateBoolExpBool_orArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<messagingMessageReadBoolExp>;
  predicate: BooleanComparisonExp;
};

export type messagingMessageReadAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<messagingMessageReadSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<messagingMessageReadBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "messaging.message_read" */
export type messagingMessageReadAggregateFields = {
  __typename?: 'messagingMessageReadAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<messagingMessageReadMaxFields>;
  min?: Maybe<messagingMessageReadMinFields>;
};


/** aggregate fields of "messaging.message_read" */
export type messagingMessageReadAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<messagingMessageReadSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "messaging.message_read" */
export type messagingMessageReadAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<messagingMessageReadMaxOrderBy>;
  min?: InputMaybe<messagingMessageReadMinOrderBy>;
};

/** input type for inserting array relation for remote table "messaging.message_read" */
export type messagingMessageReadArrRelInsertInput = {
  data: Array<messagingMessageReadInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<messagingMessageReadOnConflict>;
};

/** Boolean expression to filter rows from the table "messaging.message_read". All fields are combined with a logical 'AND'. */
export type messagingMessageReadBoolExp = {
  _and?: InputMaybe<Array<messagingMessageReadBoolExp>>;
  _not?: InputMaybe<messagingMessageReadBoolExp>;
  _or?: InputMaybe<Array<messagingMessageReadBoolExp>>;
  activityId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  message?: InputMaybe<messagingMessageBoolExp>;
  messageId?: InputMaybe<UuidComparisonExp>;
  read?: InputMaybe<BooleanComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "messaging.message_read" */
export type messagingMessageReadConstraint =
  /** unique or primary key constraint on columns "user_id", "message_id" */
  | 'message_read_message_id_user_id_key'
  /** unique or primary key constraint on columns "id" */
  | 'message_read_pkey'
  | '%future added value';

/** input type for inserting data into table "messaging.message_read" */
export type messagingMessageReadInsertInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<messagingMessageObjRelInsertInput>;
  messageId?: InputMaybe<Scalars['uuid']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type messagingMessageReadMaxFields = {
  __typename?: 'messagingMessageReadMaxFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  messageId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "messaging.message_read" */
export type messagingMessageReadMaxOrderBy = {
  activityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  messageId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type messagingMessageReadMinFields = {
  __typename?: 'messagingMessageReadMinFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  messageId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "messaging.message_read" */
export type messagingMessageReadMinOrderBy = {
  activityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  messageId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "messaging.message_read" */
export type messagingMessageReadMutationResponse = {
  __typename?: 'messagingMessageReadMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<messagingMessageRead>;
};

/** on_conflict condition type for table "messaging.message_read" */
export type messagingMessageReadOnConflict = {
  constraint: messagingMessageReadConstraint;
  updateColumns?: Array<messagingMessageReadUpdateColumn>;
  where?: InputMaybe<messagingMessageReadBoolExp>;
};

/** Ordering options when selecting data from "messaging.message_read". */
export type messagingMessageReadOrderBy = {
  activityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message?: InputMaybe<messagingMessageOrderBy>;
  messageId?: InputMaybe<OrderBy>;
  read?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: messaging.message_read */
export type messagingMessageReadPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "messaging.message_read" */
export type messagingMessageReadSelectColumn =
  /** column name */
  | 'activityId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'messageId'
  /** column name */
  | 'read'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

/** select "messagingMessageReadAggregateBoolExpBool_andArgumentsColumns" columns of table "messaging.message_read" */
export type messagingMessageReadSelectColumnMessagingMessageReadAggregateBoolExpBool_andArgumentsColumns =
  /** column name */
  | 'read'
  | '%future added value';

/** select "messagingMessageReadAggregateBoolExpBool_orArgumentsColumns" columns of table "messaging.message_read" */
export type messagingMessageReadSelectColumnMessagingMessageReadAggregateBoolExpBool_orArgumentsColumns =
  /** column name */
  | 'read'
  | '%future added value';

/** input type for updating data in table "messaging.message_read" */
export type messagingMessageReadSetInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  messageId?: InputMaybe<Scalars['uuid']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "messagingMessageRead" */
export type messagingMessageReadStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: messagingMessageReadStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type messagingMessageReadStreamCursorValueInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  messageId?: InputMaybe<Scalars['uuid']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "messaging.message_read" */
export type messagingMessageReadUpdateColumn =
  /** column name */
  | 'activityId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'messageId'
  /** column name */
  | 'read'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

export type messagingMessageReadUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<messagingMessageReadSetInput>;
  /** filter the rows which have to be updated */
  where: messagingMessageReadBoolExp;
};

/** select columns of table "messaging.message" */
export type messagingMessageSelectColumn =
  /** column name */
  | 'activityId'
  /** column name */
  | 'content'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'image'
  /** column name */
  | 'important'
  /** column name */
  | 'priority'
  /** column name */
  | 'system'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

/** select "messagingMessageAggregateBoolExpBool_andArgumentsColumns" columns of table "messaging.message" */
export type messagingMessageSelectColumnMessagingMessageAggregateBoolExpBool_andArgumentsColumns =
  /** column name */
  | 'important'
  /** column name */
  | 'system'
  | '%future added value';

/** select "messagingMessageAggregateBoolExpBool_orArgumentsColumns" columns of table "messaging.message" */
export type messagingMessageSelectColumnMessagingMessageAggregateBoolExpBool_orArgumentsColumns =
  /** column name */
  | 'important'
  /** column name */
  | 'system'
  | '%future added value';

/** input type for updating data in table "messaging.message" */
export type messagingMessageSetInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  important?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<MessagingMessagePriorityEnum>;
  system?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<messagingMessageTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "messagingMessage" */
export type messagingMessageStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: messagingMessageStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type messagingMessageStreamCursorValueInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  important?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<MessagingMessagePriorityEnum>;
  system?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<messagingMessageTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "messaging.message_type" */
export type messagingMessageType = {
  __typename?: 'messagingMessageType';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "messaging.message_type" */
export type messagingMessageTypeAggregate = {
  __typename?: 'messagingMessageTypeAggregate';
  aggregate?: Maybe<messagingMessageTypeAggregateFields>;
  nodes: Array<messagingMessageType>;
};

/** aggregate fields of "messaging.message_type" */
export type messagingMessageTypeAggregateFields = {
  __typename?: 'messagingMessageTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<messagingMessageTypeMaxFields>;
  min?: Maybe<messagingMessageTypeMinFields>;
};


/** aggregate fields of "messaging.message_type" */
export type messagingMessageTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<messagingMessageTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "messaging.message_type". All fields are combined with a logical 'AND'. */
export type messagingMessageTypeBoolExp = {
  _and?: InputMaybe<Array<messagingMessageTypeBoolExp>>;
  _not?: InputMaybe<messagingMessageTypeBoolExp>;
  _or?: InputMaybe<Array<messagingMessageTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "messaging.message_type" */
export type messagingMessageTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'message_type_pkey'
  | '%future added value';

export type messagingMessageTypeEnum =
  /** deleted message */
  | 'DELETED'
  /** Html */
  | 'HTML'
  /** Plain text */
  | 'PLAIN'
  | '%future added value';

/** input type for inserting data into table "messaging.message_type" */
export type messagingMessageTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type messagingMessageTypeMaxFields = {
  __typename?: 'messagingMessageTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type messagingMessageTypeMinFields = {
  __typename?: 'messagingMessageTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "messaging.message_type" */
export type messagingMessageTypeMutationResponse = {
  __typename?: 'messagingMessageTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<messagingMessageType>;
};

/** on_conflict condition type for table "messaging.message_type" */
export type messagingMessageTypeOnConflict = {
  constraint: messagingMessageTypeConstraint;
  updateColumns?: Array<messagingMessageTypeUpdateColumn>;
  where?: InputMaybe<messagingMessageTypeBoolExp>;
};

/** Ordering options when selecting data from "messaging.message_type". */
export type messagingMessageTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: messaging.message_type */
export type messagingMessageTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "messaging.message_type" */
export type messagingMessageTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "messaging.message_type" */
export type messagingMessageTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "messagingMessageType" */
export type messagingMessageTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: messagingMessageTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type messagingMessageTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "messaging.message_type" */
export type messagingMessageTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type messagingMessageTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<messagingMessageTypeSetInput>;
  /** filter the rows which have to be updated */
  where: messagingMessageTypeBoolExp;
};

/** update columns of table "messaging.message" */
export type messagingMessageUpdateColumn =
  /** column name */
  | 'activityId'
  /** column name */
  | 'content'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'image'
  /** column name */
  | 'important'
  /** column name */
  | 'priority'
  /** column name */
  | 'system'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

export type messagingMessageUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<messagingMessageSetInput>;
  /** filter the rows which have to be updated */
  where: messagingMessageBoolExp;
};

/** mutation root */
export type mutation_root = {
  __typename?: 'mutation_root';
  acceptInviteToOrganization?: Maybe<acceptInviteOutput>;
  acceptRequestToOrganization?: Maybe<acceptRequestsOutput>;
  addDomainUserToOrganization?: Maybe<AddDomainUserToOrganizationOutput>;
  /** addEmailProviderIntegration */
  addEmailProviderIntegration?: Maybe<Array<Maybe<emailDomainUserOutput>>>;
  /** addEmailProviderSubscription */
  addEmailProviderSubscription?: Maybe<Array<Maybe<createEmailProviderSubscriptionOutput>>>;
  /** blockUser */
  blockDomainUser?: Maybe<BlockUserOutput>;
  breg?: Maybe<bregmutation_root>;
  /** callBackLater */
  callBackLater?: Maybe<callBackLaterResult>;
  changeOrganizationName?: Maybe<ChangeOrganizationNameOutput>;
  checkOneTimeCode?: Maybe<CheckOnetimeCodeOutput>;
  /** checkPhoneNumber */
  checkPhoneNumber?: Maybe<CheckPhoneNumberOutput>;
  checkTelephonyId?: Maybe<checkTelephonyIdOutput>;
  /** insert a single row into the table: "business.queue_item_participant" */
  createActivityParticipant?: Maybe<activityParticipant>;
  /** insert data into the table: "business.queue_item_participant" */
  createActivityParticipants?: Maybe<activityParticipantMutationResponse>;
  /** insert a single row into the table: "business.activity_status" */
  createActivityStatus?: Maybe<ActivityStatus>;
  /** insert data into the table: "business.activity_status" */
  createActivityStatuses?: Maybe<ActivityStatusMutationResponse>;
  createActivityTask?: Maybe<activityTaskOutput>;
  /** insert a single row into the table: "business.activity_type" */
  createActivityType?: Maybe<ActivityType>;
  /** insert data into the table: "business.activity_type" */
  createActivityTypes?: Maybe<ActivityTypeMutationResponse>;
  /** insert a single row into the table: "business.address" */
  createAddress?: Maybe<address>;
  /** insert data into the table: "business.address" */
  createAddresses?: Maybe<addressMutationResponse>;
  /** insert a single row into the table: "business.blocked_domain_user" */
  createBlockedDomainUser?: Maybe<blockedDomainUser>;
  /** insert data into the table: "business.blocked_domain_user" */
  createBlockedDomainUsers?: Maybe<blockedDomainUserMutationResponse>;
  /** insert a single row into the table: "business.queue_item_collaboration" */
  createBusinessQueueItemCollaboration?: Maybe<businessQueueItemCollaboration>;
  /** insert data into the table: "business.queue_item_collaboration" */
  createBusinessQueueItemCollaborations?: Maybe<businessQueueItemCollaborationMutationResponse>;
  /** insert a single row into the table: "business.user_contacts" */
  createBusinessUserContact?: Maybe<businessUserContacts>;
  /** insert data into the table: "business.user_contacts" */
  createBusinessUserContacts?: Maybe<businessUserContactsMutationResponse>;
  /** insert a single row into the table: "business.user_settings" */
  createBusinessUserSetting?: Maybe<businessUserSettings>;
  /** insert data into the table: "business.user_settings" */
  createBusinessUserSettings?: Maybe<businessUserSettingsMutationResponse>;
  /** insert a single row into the table: "crm.status_message" */
  createCrmStatusMessage?: Maybe<crmStatusMessage>;
  /** insert data into the table: "crm.status_message" */
  createCrmStatusMessages?: Maybe<crmStatusMessageMutationResponse>;
  /** insert a single row into the table: "crm.youtello_catalyst_id_mapping" */
  createCrmYoutelloCatalystIdMapping?: Maybe<crmYoutelloCatalystIdMapping>;
  /** insert data into the table: "crm.youtello_catalyst_id_mapping" */
  createCrmYoutelloCatalystIdMappings?: Maybe<crmYoutelloCatalystIdMappingMutationResponse>;
  /** insert data into the table: "business.domain_activity" */
  createDomainActivities?: Maybe<domainActivityMutationResponse>;
  /** insert a single row into the table: "business.domain_activity" */
  createDomainActivity?: Maybe<domainActivity>;
  /** insert a single row into the table: "business.domain_organization" */
  createDomainOrganization?: Maybe<domainOrganization>;
  /** insert data into the table: "business.domain_organization" */
  createDomainOrganizations?: Maybe<domainOrganizationMutationResponse>;
  /** insert a single row into the table: "business.domain_participant" */
  createDomainParticipant?: Maybe<domainParticipant>;
  /** insert data into the table: "business.domain_participant" */
  createDomainParticipants?: Maybe<domainParticipantMutationResponse>;
  /** insert a single row into the table: "business.domain_type" */
  createDomainType?: Maybe<domainType>;
  /** insert data into the table: "business.domain_type" */
  createDomainTypes?: Maybe<domainTypeMutationResponse>;
  /** insert a single row into the table: "business.domain_user" */
  createDomainUser?: Maybe<domainUser>;
  /** insert data into the table: "business.domain_user_category" */
  createDomainUserCategories?: Maybe<domainUserCategoryMutationResponse>;
  /** insert a single row into the table: "business.domain_user_category" */
  createDomainUserCategory?: Maybe<domainUserCategory>;
  /** insert data into the table: "business.domain_user" */
  createDomainUsers?: Maybe<domainUserMutationResponse>;
  createInviteToOrganization?: Maybe<inviteOutput>;
  /** insert a single row into the table: "business.message" */
  createMessage?: Maybe<message>;
  /** insert a single row into the table: "business.message_type" */
  createMessageType?: Maybe<messageType>;
  /** insert data into the table: "business.message_type" */
  createMessageTypes?: Maybe<messageTypeMutationResponse>;
  /** insert data into the table: "business.message" */
  createMessages?: Maybe<messageMutationResponse>;
  /** insert data into the table: "messaging.activity" */
  createMessagingActivities?: Maybe<messagingActivityMutationResponse>;
  /** insert a single row into the table: "messaging.activity" */
  createMessagingActivity?: Maybe<messagingActivity>;
  /** insert a single row into the table: "messaging.activity_organization" */
  createMessagingActivityOrganization?: Maybe<messagingActivityOrganization>;
  /** insert data into the table: "messaging.activity_organization" */
  createMessagingActivityOrganizations?: Maybe<messagingActivityOrganizationMutationResponse>;
  /** insert a single row into the table: "messaging.activity_type" */
  createMessagingActivityType?: Maybe<messagingActivityType>;
  /** insert data into the table: "messaging.activity_type" */
  createMessagingActivityTypes?: Maybe<messagingActivityTypeMutationResponse>;
  /** insert a single row into the table: "messaging.activity_user" */
  createMessagingActivityUser?: Maybe<messagingActivityUser>;
  /** insert data into the table: "messaging.activity_user" */
  createMessagingActivityUsers?: Maybe<messagingActivityUserMutationResponse>;
  /** createMessagingGroup */
  createMessagingGroup?: Maybe<createMessagingGroupOutput>;
  /** insert a single row into the table: "messaging.message" */
  createMessagingMessage?: Maybe<messagingMessage>;
  /** insert a single row into the table: "messaging.message_emoji" */
  createMessagingMessageEmoji?: Maybe<messagingMessageEmoji>;
  /** insert data into the table: "messaging.message_emoji" */
  createMessagingMessageEmojis?: Maybe<messagingMessageEmojiMutationResponse>;
  /** insert a single row into the table: "messaging.message_read" */
  createMessagingMessageRead?: Maybe<messagingMessageRead>;
  /** insert data into the table: "messaging.message_read" */
  createMessagingMessageReads?: Maybe<messagingMessageReadMutationResponse>;
  /** insert a single row into the table: "messaging.message_type" */
  createMessagingMessageType?: Maybe<messagingMessageType>;
  /** insert data into the table: "messaging.message_type" */
  createMessagingMessageTypes?: Maybe<messagingMessageTypeMutationResponse>;
  /** insert data into the table: "messaging.message" */
  createMessagingMessages?: Maybe<messagingMessageMutationResponse>;
  /** insert a single row into the table: "notification.notifications" */
  createNotification?: Maybe<notification>;
  /** insert a single row into the table: "notification.notification_send" */
  createNotificationSend?: Maybe<notificationSend>;
  /** insert data into the table: "notification.notification_send" */
  createNotificationSends?: Maybe<notificationSendMutationResponse>;
  /** insert data into the table: "notification.notification_setting_activity" */
  createNotificationSettingActivities?: Maybe<notificationSettingActivityMutationResponse>;
  /** insert a single row into the table: "notification.notification_setting_activity" */
  createNotificationSettingActivity?: Maybe<notificationSettingActivity>;
  /** insert a single row into the table: "notification.notification_users" */
  createNotificationUser?: Maybe<notificationUser>;
  /** insert a single row into the table: "notification.notification_user_devices" */
  createNotificationUserDevice?: Maybe<notificationUserDevice>;
  /** insert data into the table: "notification.notification_user_devices" */
  createNotificationUserDevices?: Maybe<notificationUserDeviceMutationResponse>;
  /** insert data into the table: "notification.notification_users" */
  createNotificationUsers?: Maybe<notificationUserMutationResponse>;
  /** insert data into the table: "notification.notifications" */
  createNotifications?: Maybe<notificationMutationResponse>;
  /** insert a single row into the table: "orders.integrations" */
  createOrdersIntegration?: Maybe<ordersIntegrations>;
  /** insert data into the table: "orders.integrations" */
  createOrdersIntegrations?: Maybe<ordersIntegrationsMutationResponse>;
  /** insert a single row into the table: "business.organizations" */
  createOrganization?: Maybe<organization>;
  /** insert a single row into the table: "business.authorization_enum_group" */
  createOrganizationAuthorizationEnumGroup?: Maybe<organizationAuthorizationEnumGroup>;
  /** insert data into the table: "business.authorization_enum_group" */
  createOrganizationAuthorizationEnumGroups?: Maybe<organizationAuthorizationEnumGroupMutationResponse>;
  /** insert a single row into the table: "business.authorization_group" */
  createOrganizationAuthorizationGroup?: Maybe<organizationAuthorizationGroup>;
  /** insert data into the table: "business.authorization_group" */
  createOrganizationAuthorizationGroups?: Maybe<organizationAuthorizationGroupMutationResponse>;
  /** insert a single row into the table: "business.organization_relationship" */
  createOrganizationOrganizationRelationship?: Maybe<organizationOrganizationRelationship>;
  /** insert data into the table: "business.organization_relationship_category" */
  createOrganizationOrganizationRelationshipCategories?: Maybe<organizationOrganizationRelationshipCategoryMutationResponse>;
  /** insert a single row into the table: "business.organization_relationship_category" */
  createOrganizationOrganizationRelationshipCategory?: Maybe<organizationOrganizationRelationshipCategory>;
  /** insert data into the table: "business.organization_relationship" */
  createOrganizationOrganizationRelationships?: Maybe<organizationOrganizationRelationshipMutationResponse>;
  /** insert a single row into the table: "business.organization_user_authorization" */
  createOrganizationOrganizationUserAuthorization?: Maybe<organizationOrganizationUserAuthorization>;
  /** insert data into the table: "business.organization_user_authorization" */
  createOrganizationOrganizationUserAuthorizations?: Maybe<organizationOrganizationUserAuthorizationMutationResponse>;
  /** insert a single row into the table: "business.organization_user" */
  createOrganizationUser?: Maybe<organizationUser>;
  /** insert a single row into the table: "business.organization_user_attachments" */
  createOrganizationUserAttachment?: Maybe<organizationUserAttachments>;
  /** insert data into the table: "business.organization_user_attachments" */
  createOrganizationUserAttachments?: Maybe<organizationUserAttachmentsMutationResponse>;
  /** insert a single row into the table: "business.organization_user_attention_note" */
  createOrganizationUserAttentionNote?: Maybe<OrganizationUserAttentionNote>;
  /** insert data into the table: "business.organization_user_attention_note" */
  createOrganizationUserAttentionNotes?: Maybe<OrganizationUserAttentionNoteMutationResponse>;
  /** insert a single row into the table: "business.user_authorization" */
  createOrganizationUserAuthorization?: Maybe<organizationUserAuthorization>;
  /** insert data into the table: "business.user_authorization" */
  createOrganizationUserAuthorizations?: Maybe<organizationUserAuthorizationMutationResponse>;
  /** insert a single row into the table: "business.organization_user_details" */
  createOrganizationUserDetail?: Maybe<organizationUserDetail>;
  /** insert a single row into the table: "business.organization_user_details_type" */
  createOrganizationUserDetailType?: Maybe<organizationUserDetailType>;
  /** insert data into the table: "business.organization_user_details_type" */
  createOrganizationUserDetailTypes?: Maybe<organizationUserDetailTypeMutationResponse>;
  /** insert data into the table: "business.organization_user_details" */
  createOrganizationUserDetails?: Maybe<organizationUserDetailMutationResponse>;
  /** insert a single row into the table: "business.organization_user_invite" */
  createOrganizationUserInvite?: Maybe<organizationUserInvite>;
  /** insert data into the table: "business.organization_user_invite" */
  createOrganizationUserInvites?: Maybe<organizationUserInviteMutationResponse>;
  /** insert a single row into the table: "business.organization_user_request" */
  createOrganizationUserRequest?: Maybe<BusinessOrganizationUserRequest>;
  /** insert data into the table: "business.organization_user_request" */
  createOrganizationUserRequests?: Maybe<BusinessOrganizationUserRequestMutationResponse>;
  /** insert a single row into the table: "business.organization_user_status" */
  createOrganizationUserStatus?: Maybe<organizationUserStatus>;
  /** insert data into the table: "business.organization_user_status" */
  createOrganizationUserStatuses?: Maybe<organizationUserStatusMutationResponse>;
  /** insert data into the table: "business.organization_user" */
  createOrganizationUsers?: Maybe<organizationUserMutationResponse>;
  /** insert data into the table: "business.organizations" */
  createOrganizations?: Maybe<organizationMutationResponse>;
  /** insert a single row into the table: "business.phone_number_verification_status" */
  createPhoneNumberVerificationStatus?: Maybe<phoneNumberVerificationStatus>;
  /** insert data into the table: "business.phone_number_verification_status" */
  createPhoneNumberVerificationStatuses?: Maybe<phoneNumberVerificationStatusMutationResponse>;
  createPhoneroOrgUsers?: Maybe<createPhoneroOrgUsersOutput>;
  /** insert a single row into the table: "devices" */
  createPublicDevice?: Maybe<publicDevice>;
  /** insert data into the table: "devices" */
  createPublicDevices?: Maybe<publicDeviceMutationResponse>;
  /** insert a single row into the table: "external_requests" */
  createPublicExternalRequest?: Maybe<publicExternalRequest>;
  /** insert data into the table: "external_requests" */
  createPublicExternalRequests?: Maybe<publicExternalRequestMutationResponse>;
  /** insert a single row into the table: "files" */
  createPublicFile?: Maybe<publicFile>;
  /** insert data into the table: "files" */
  createPublicFiles?: Maybe<publicFileMutationResponse>;
  /** insert a single row into the table: "notifications" */
  createPublicNotification?: Maybe<publicNotification>;
  /** insert data into the table: "notifications" */
  createPublicNotifications?: Maybe<publicNotificationMutationResponse>;
  /** insert a single row into the table: "business.queue_item" */
  createQueueItem?: Maybe<queueItem>;
  /** insert data into the table: "business.queue_item" */
  createQueueItems?: Maybe<queueItemMutationResponse>;
  /** insert a single row into the table: "business.rel_organization_user_domain_user" */
  createRelOrganizationUserDomainUser?: Maybe<relOrganizationUserDomainUser>;
  /** insert data into the table: "business.rel_organization_user_domain_user" */
  createRelOrganizationUserDomainUsers?: Maybe<relOrganizationUserDomainUserMutationResponse>;
  createRequestToOrganization?: Maybe<orgAccessRequestOutput>;
  /** createRoom */
  createRoom?: Maybe<createRoomOutput>;
  /** createServerSms */
  createServerSms?: Maybe<CreateSMSOutput>;
  /** insert a single row into the table: "sms.connectors" */
  createSmsConnector?: Maybe<smsConnector>;
  /** insert data into the table: "sms.connectors" */
  createSmsConnectors?: Maybe<smsConnectorMutationResponse>;
  /** insert a single row into the table: "sms.gates" */
  createSmsGate?: Maybe<smsGate>;
  /** insert data into the table: "sms.gates" */
  createSmsGates?: Maybe<smsGateMutationResponse>;
  /** insert a single row into the table: "sms.link_mobility_sms_content" */
  createSmsLinkMobilitySmsContent?: Maybe<smsLinkMobilitySmsContent>;
  /** insert data into the table: "sms.link_mobility_sms_content" */
  createSmsLinkMobilitySmsContents?: Maybe<smsLinkMobilitySmsContentMutationResponse>;
  /** insert a single row into the table: "sms.link_mobility_sms_message" */
  createSmsLinkMobilitySmsMessage?: Maybe<smsLinkMobilitySmsMessage>;
  /** insert data into the table: "sms.link_mobility_sms_message" */
  createSmsLinkMobilitySmsMessages?: Maybe<smsLinkMobilitySmsMessageMutationResponse>;
  /** insert a single row into the table: "sms.link_mobility_sms_route" */
  createSmsLinkMobilitySmsRoute?: Maybe<smsLinkMobilitySmsRoute>;
  /** insert data into the table: "sms.link_mobility_sms_route" */
  createSmsLinkMobilitySmsRoutes?: Maybe<smsLinkMobilitySmsRouteMutationResponse>;
  /** insert a single row into the table: "sms.providers" */
  createSmsProvider?: Maybe<smsProvider>;
  /** insert data into the table: "sms.providers" */
  createSmsProviders?: Maybe<smsProviderMutationResponse>;
  /** insert a single row into the table: "sms.sms" */
  createSmsSm?: Maybe<smsSm>;
  /** insert data into the table: "sms.sms" */
  createSmsSms?: Maybe<smsSmMutationResponse>;
  /** insert data into the table: "sms.sms_external_incoming_link_mobility" */
  createSmsSmsExternalIncomingLinkMobilities?: Maybe<smsSmsExternalIncomingLinkMobilityMutationResponse>;
  /** insert a single row into the table: "sms.sms_external_incoming_link_mobility" */
  createSmsSmsExternalIncomingLinkMobility?: Maybe<smsSmsExternalIncomingLinkMobility>;
  /** createTelephonyNewProviderActivity */
  createTelephonyNewProviderActivity?: Maybe<NewActivityOutput>;
  /** createTelephonyProviderIntegration */
  createTelephonyProviderIntegration?: Maybe<Array<Maybe<telephonyDomainUserOutput>>>;
  /** insert a single row into the table: "business.users" */
  createUser?: Maybe<user>;
  /** createUserAndOrg */
  createUserAndOrg?: Maybe<UserOrgOutput>;
  /** insert a single row into the table: "business.user_details" */
  createUserDetail?: Maybe<userDetail>;
  /** insert data into the table: "business.user_details" */
  createUserDetails?: Maybe<userDetailMutationResponse>;
  /** insert a single row into the table: "business.user_details_type" */
  createUserDetailsType?: Maybe<userDetailsType>;
  /** insert data into the table: "business.user_details_type" */
  createUserDetailsTypes?: Maybe<userDetailsTypeMutationResponse>;
  /** insert a single row into the table: "business.user_devices" */
  createUserDevice?: Maybe<userDevice>;
  /** insert data into the table: "business.user_devices" */
  createUserDevices?: Maybe<userDeviceMutationResponse>;
  /** insert a single row into the table: "business.user_phone_numbers" */
  createUserPhoneNumber?: Maybe<userPhoneNumber>;
  /** insert data into the table: "business.user_phone_numbers" */
  createUserPhoneNumbers?: Maybe<userPhoneNumberMutationResponse>;
  /** insert a single row into the table: "business.user_role" */
  createUserRole?: Maybe<userRole>;
  /** insert data into the table: "business.user_role" */
  createUserRoles?: Maybe<userRoleMutationResponse>;
  /** insert data into the table: "business.users" */
  createUsers?: Maybe<userMutationResponse>;
  /** insert a single row into the table: "validation.validation" */
  createValidationValidation?: Maybe<validationValidation>;
  /** insert data into the table: "validation.validation" */
  createValidationValidations?: Maybe<validationValidationMutationResponse>;
  /** Invites a customer to a video session */
  createVideoInviteToOrganizationUser?: Maybe<videoInviteOrgUserOutput>;
  /** delete data from the table: "business.direction" */
  deleteActivityDirection?: Maybe<ActivityDirectionMutationResponse>;
  /** delete single row from the table: "business.direction" */
  deleteActivityDirectionByPk?: Maybe<ActivityDirection>;
  /** delete single row from the table: "business.queue_item_participant" */
  deleteActivityParticipant?: Maybe<activityParticipant>;
  /** delete data from the table: "business.queue_item_participant" */
  deleteActivityParticipants?: Maybe<activityParticipantMutationResponse>;
  /** delete data from the table: "business.provider" */
  deleteActivityProvider?: Maybe<ActivityProviderMutationResponse>;
  /** delete single row from the table: "business.provider" */
  deleteActivityProviderByPk?: Maybe<ActivityProvider>;
  /** delete single row from the table: "business.activity_status" */
  deleteActivityStatus?: Maybe<ActivityStatus>;
  /** delete data from the table: "business.activity_status" */
  deleteActivityStatuses?: Maybe<ActivityStatusMutationResponse>;
  /** delete single row from the table: "business.activity_type" */
  deleteActivityType?: Maybe<ActivityType>;
  /** delete data from the table: "business.activity_type" */
  deleteActivityTypes?: Maybe<ActivityTypeMutationResponse>;
  /** delete single row from the table: "business.address" */
  deleteAddress?: Maybe<address>;
  /** delete data from the table: "business.address" */
  deleteAddresses?: Maybe<addressMutationResponse>;
  /** delete single row from the table: "business.blocked_domain_user" */
  deleteBlockedDomainUser?: Maybe<blockedDomainUser>;
  /** delete data from the table: "business.blocked_domain_user" */
  deleteBlockedDomainUsers?: Maybe<blockedDomainUserMutationResponse>;
  /** delete data from the table: "business.domain_activity_type" */
  deleteBusinessDomainActivityType?: Maybe<BusinessDomainActivityTypeMutationResponse>;
  /** delete single row from the table: "business.domain_activity_type" */
  deleteBusinessDomainActivityTypeByPk?: Maybe<BusinessDomainActivityType>;
  /** delete data from the table: "business.feed_type" */
  deleteBusinessFeedType?: Maybe<BusinessFeedTypeMutationResponse>;
  /** delete single row from the table: "business.feed_type" */
  deleteBusinessFeedTypeByPk?: Maybe<BusinessFeedType>;
  /** delete data from the table: "business.message_attachments" */
  deleteBusinessMessageAttachments?: Maybe<BusinessMessageAttachmentsMutationResponse>;
  /** delete single row from the table: "business.message_attachments" */
  deleteBusinessMessageAttachmentsByPk?: Maybe<BusinessMessageAttachments>;
  /** delete data from the table: "business.organization_user_callback_answer" */
  deleteBusinessOrganizationUserCallbackAnswer?: Maybe<BusinessOrganizationUserCallbackAnswerMutationResponse>;
  /** delete single row from the table: "business.organization_user_callback_answer" */
  deleteBusinessOrganizationUserCallbackAnswerByPk?: Maybe<BusinessOrganizationUserCallbackAnswer>;
  /** delete data from the table: "business.organization_user_email" */
  deleteBusinessOrganizationUserEmail?: Maybe<BusinessOrganizationUserEmailMutationResponse>;
  /** delete single row from the table: "business.organization_user_email" */
  deleteBusinessOrganizationUserEmailByPk?: Maybe<BusinessOrganizationUserEmail>;
  /** delete data from the table: "business.organization_user_email_type" */
  deleteBusinessOrganizationUserEmailType?: Maybe<BusinessOrganizationUserEmailTypeMutationResponse>;
  /** delete single row from the table: "business.organization_user_email_type" */
  deleteBusinessOrganizationUserEmailTypeByPk?: Maybe<BusinessOrganizationUserEmailType>;
  /** delete data from the table: "business.organization_user_request_type" */
  deleteBusinessOrganizationUserRequestType?: Maybe<BusinessOrganizationUserRequestTypeMutationResponse>;
  /** delete single row from the table: "business.organization_user_request_type" */
  deleteBusinessOrganizationUserRequestTypeByPk?: Maybe<BusinessOrganizationUserRequestType>;
  /** delete data from the table: "business.organization_user_suggestion_type" */
  deleteBusinessOrganizationUserSuggestionType?: Maybe<BusinessOrganizationUserSuggestionTypeMutationResponse>;
  /** delete single row from the table: "business.organization_user_suggestion_type" */
  deleteBusinessOrganizationUserSuggestionTypeByPk?: Maybe<BusinessOrganizationUserSuggestionType>;
  /** delete data from the table: "business.organization_user_suggestions" */
  deleteBusinessOrganizationUserSuggestions?: Maybe<BusinessOrganizationUserSuggestionsMutationResponse>;
  /** delete single row from the table: "business.organization_user_suggestions" */
  deleteBusinessOrganizationUserSuggestionsByPk?: Maybe<BusinessOrganizationUserSuggestions>;
  /** delete data from the table: "business.organization_user_url_address" */
  deleteBusinessOrganizationUserUrlAddress?: Maybe<BusinessOrganizationUserUrlAddressMutationResponse>;
  /** delete single row from the table: "business.organization_user_url_address" */
  deleteBusinessOrganizationUserUrlAddressByPk?: Maybe<BusinessOrganizationUserUrlAddress>;
  /** delete data from the table: "business.organization_user_url_address_type" */
  deleteBusinessOrganizationUserUrlAddressType?: Maybe<BusinessOrganizationUserUrlAddressTypeMutationResponse>;
  /** delete single row from the table: "business.organization_user_url_address_type" */
  deleteBusinessOrganizationUserUrlAddressTypeByPk?: Maybe<BusinessOrganizationUserUrlAddressType>;
  /** delete data from the table: "business.queue_item_alarm_type" */
  deleteBusinessQueueItemAlarmType?: Maybe<BusinessQueueItemAlarmTypeMutationResponse>;
  /** delete single row from the table: "business.queue_item_alarm_type" */
  deleteBusinessQueueItemAlarmTypeByPk?: Maybe<BusinessQueueItemAlarmType>;
  /** delete data from the table: "business.queue_item_alarms" */
  deleteBusinessQueueItemAlarms?: Maybe<BusinessQueueItemAlarmsMutationResponse>;
  /** delete single row from the table: "business.queue_item_alarms" */
  deleteBusinessQueueItemAlarmsByPk?: Maybe<BusinessQueueItemAlarms>;
  /** delete single row from the table: "business.queue_item_collaboration" */
  deleteBusinessQueueItemCollaboration?: Maybe<businessQueueItemCollaboration>;
  /** delete data from the table: "business.queue_item_collaboration" */
  deleteBusinessQueueItemCollaborations?: Maybe<businessQueueItemCollaborationMutationResponse>;
  /** delete data from the table: "business.queue_item_participant_channel_type" */
  deleteBusinessQueueItemParticipantChannelType?: Maybe<BusinessQueueItemParticipantChannelTypeMutationResponse>;
  /** delete single row from the table: "business.queue_item_participant_channel_type" */
  deleteBusinessQueueItemParticipantChannelTypeByPk?: Maybe<BusinessQueueItemParticipantChannelType>;
  /** delete data from the table: "business.queue_item_sub_type" */
  deleteBusinessQueueItemSubType?: Maybe<BusinessQueueItemSubTypeMutationResponse>;
  /** delete single row from the table: "business.queue_item_sub_type" */
  deleteBusinessQueueItemSubTypeByPk?: Maybe<BusinessQueueItemSubType>;
  /** delete single row from the table: "business.user_contacts" */
  deleteBusinessUserContact?: Maybe<businessUserContacts>;
  /** delete data from the table: "business.user_contact_numbers" */
  deleteBusinessUserContactNumbers?: Maybe<BusinessUserContactNumbersMutationResponse>;
  /** delete single row from the table: "business.user_contact_numbers" */
  deleteBusinessUserContactNumbersByPk?: Maybe<BusinessUserContactNumbers>;
  /** delete data from the table: "business.user_contacts" */
  deleteBusinessUserContacts?: Maybe<businessUserContactsMutationResponse>;
  /** delete data from the table: "business.user_feed" */
  deleteBusinessUserFeed?: Maybe<BusinessUserFeedMutationResponse>;
  /** delete single row from the table: "business.user_feed" */
  deleteBusinessUserFeedByPk?: Maybe<BusinessUserFeed>;
  /** delete data from the table: "business.user_request_status" */
  deleteBusinessUserRequestStatus?: Maybe<BusinessUserRequestStatusMutationResponse>;
  /** delete single row from the table: "business.user_request_status" */
  deleteBusinessUserRequestStatusByPk?: Maybe<BusinessUserRequestStatus>;
  /** delete single row from the table: "business.user_settings" */
  deleteBusinessUserSetting?: Maybe<businessUserSettings>;
  /** delete data from the table: "business.user_settings" */
  deleteBusinessUserSettings?: Maybe<businessUserSettingsMutationResponse>;
  /** delete data from the table: "business.user_states" */
  deleteBusinessUserStates?: Maybe<BusinessUserStatesMutationResponse>;
  /** delete single row from the table: "business.user_states" */
  deleteBusinessUserStatesByPk?: Maybe<BusinessUserStates>;
  /** delete data from the table: "crm.context" */
  deleteCrmContext?: Maybe<CrmContextMutationResponse>;
  /** delete single row from the table: "crm.context" */
  deleteCrmContextByPk?: Maybe<CrmContext>;
  /** delete data from the table: "crm.context_type" */
  deleteCrmContextType?: Maybe<CrmContextTypeMutationResponse>;
  /** delete single row from the table: "crm.context_type" */
  deleteCrmContextTypeByPk?: Maybe<CrmContextType>;
  /** delete data from the table: "crm.creator_type" */
  deleteCrmCreatorType?: Maybe<CrmCreatorTypeMutationResponse>;
  /** delete single row from the table: "crm.creator_type" */
  deleteCrmCreatorTypeByPk?: Maybe<CrmCreatorType>;
  /** delete data from the table: "crm.crm_type" */
  deleteCrmCrmType?: Maybe<CrmCrmTypeMutationResponse>;
  /** delete single row from the table: "crm.crm_type" */
  deleteCrmCrmTypeByPk?: Maybe<CrmCrmType>;
  /** delete data from the table: "crm.direction_type" */
  deleteCrmDirectionType?: Maybe<CrmDirectionTypeMutationResponse>;
  /** delete single row from the table: "crm.direction_type" */
  deleteCrmDirectionTypeByPk?: Maybe<CrmDirectionType>;
  /** delete data from the table: "crm.entity" */
  deleteCrmEntity?: Maybe<CrmEntityMutationResponse>;
  /** delete single row from the table: "crm.entity" */
  deleteCrmEntityByPk?: Maybe<CrmEntity>;
  /** delete data from the table: "crm.event" */
  deleteCrmEvent?: Maybe<CrmEventMutationResponse>;
  /** delete single row from the table: "crm.event" */
  deleteCrmEventByPk?: Maybe<CrmEvent>;
  /** delete data from the table: "crm.event_type" */
  deleteCrmEventType?: Maybe<CrmEventTypeMutationResponse>;
  /** delete single row from the table: "crm.event_type" */
  deleteCrmEventTypeByPk?: Maybe<CrmEventType>;
  /** delete data from the table: "crm.status_code" */
  deleteCrmStatusCode?: Maybe<CrmStatusCodeMutationResponse>;
  /** delete single row from the table: "crm.status_code" */
  deleteCrmStatusCodeByPk?: Maybe<CrmStatusCode>;
  /** delete single row from the table: "crm.status_message" */
  deleteCrmStatusMessage?: Maybe<crmStatusMessage>;
  /** delete data from the table: "crm.status_message" */
  deleteCrmStatusMessages?: Maybe<crmStatusMessageMutationResponse>;
  /** delete data from the table: "crm.system_type" */
  deleteCrmSystemType?: Maybe<CrmSystemTypeMutationResponse>;
  /** delete single row from the table: "crm.system_type" */
  deleteCrmSystemTypeByPk?: Maybe<CrmSystemType>;
  /** delete data from the table: "crm.trace_context" */
  deleteCrmTraceContext?: Maybe<CrmTraceContextMutationResponse>;
  /** delete single row from the table: "crm.trace_context" */
  deleteCrmTraceContextByPk?: Maybe<CrmTraceContext>;
  /** delete data from the table: "crm.unified_entity_type" */
  deleteCrmUnifiedEntityType?: Maybe<CrmUnifiedEntityTypeMutationResponse>;
  /** delete single row from the table: "crm.unified_entity_type" */
  deleteCrmUnifiedEntityTypeByPk?: Maybe<CrmUnifiedEntityType>;
  /** delete data from the table: "crm.youtello_catalyst_id_mapping" */
  deleteCrmYoutelloCatalystIdMapping?: Maybe<crmYoutelloCatalystIdMappingMutationResponse>;
  /** delete single row from the table: "crm.youtello_catalyst_id_mapping" */
  deleteCrmYoutelloCatalystIdMappingByPk?: Maybe<crmYoutelloCatalystIdMapping>;
  /** delete data from the table: "business.domain_activity" */
  deleteDomainActivities?: Maybe<domainActivityMutationResponse>;
  /** delete single row from the table: "business.domain_activity" */
  deleteDomainActivity?: Maybe<domainActivity>;
  /** delete single row from the table: "business.domain_organization" */
  deleteDomainOrganization?: Maybe<domainOrganization>;
  /** delete data from the table: "business.domain_organization" */
  deleteDomainOrganizations?: Maybe<domainOrganizationMutationResponse>;
  /** delete single row from the table: "business.domain_participant" */
  deleteDomainParticipant?: Maybe<domainParticipant>;
  /** delete data from the table: "business.domain_participant" */
  deleteDomainParticipants?: Maybe<domainParticipantMutationResponse>;
  /** delete single row from the table: "business.domain_type" */
  deleteDomainType?: Maybe<domainType>;
  /** delete data from the table: "business.domain_type" */
  deleteDomainTypes?: Maybe<domainTypeMutationResponse>;
  /** delete single row from the table: "business.domain_user" */
  deleteDomainUser?: Maybe<domainUser>;
  /** delete data from the table: "business.domain_user_category" */
  deleteDomainUserCategories?: Maybe<domainUserCategoryMutationResponse>;
  /** delete single row from the table: "business.domain_user_category" */
  deleteDomainUserCategory?: Maybe<domainUserCategory>;
  /** delete data from the table: "business.domain_user" */
  deleteDomainUsers?: Maybe<domainUserMutationResponse>;
  deleteInviteUserToOrg?: Maybe<DeleteUserOutput>;
  /** delete data from the table: "business.languages" */
  deleteLanguages?: Maybe<languagesMutationResponse>;
  /** delete single row from the table: "business.languages" */
  deleteLanguagesByPk?: Maybe<languages>;
  /** delete single row from the table: "business.message" */
  deleteMessage?: Maybe<message>;
  /** delete single row from the table: "business.message_type" */
  deleteMessageType?: Maybe<messageType>;
  /** delete data from the table: "business.message_type" */
  deleteMessageTypes?: Maybe<messageTypeMutationResponse>;
  /** delete data from the table: "business.message" */
  deleteMessages?: Maybe<messageMutationResponse>;
  /** delete data from the table: "messaging.activity" */
  deleteMessagingActivities?: Maybe<messagingActivityMutationResponse>;
  /** delete single row from the table: "messaging.activity" */
  deleteMessagingActivity?: Maybe<messagingActivity>;
  /** delete single row from the table: "messaging.activity_organization" */
  deleteMessagingActivityOrganization?: Maybe<messagingActivityOrganization>;
  /** delete data from the table: "messaging.activity_organization" */
  deleteMessagingActivityOrganizations?: Maybe<messagingActivityOrganizationMutationResponse>;
  /** delete data from the table: "messaging.activitySettings" */
  deleteMessagingActivitySettings?: Maybe<MessagingActivitySettingsMutationResponse>;
  /** delete single row from the table: "messaging.activitySettings" */
  deleteMessagingActivitySettingsByPk?: Maybe<MessagingActivitySettings>;
  /** delete data from the table: "messaging.activitySettingsNotificationSettingType" */
  deleteMessagingActivitySettingsNotificationSettingType?: Maybe<MessagingActivitySettingsNotificationSettingTypeMutationResponse>;
  /** delete single row from the table: "messaging.activitySettingsNotificationSettingType" */
  deleteMessagingActivitySettingsNotificationSettingTypeByPk?: Maybe<MessagingActivitySettingsNotificationSettingType>;
  /** delete single row from the table: "messaging.activity_type" */
  deleteMessagingActivityType?: Maybe<messagingActivityType>;
  /** delete data from the table: "messaging.activity_type" */
  deleteMessagingActivityTypes?: Maybe<messagingActivityTypeMutationResponse>;
  /** delete single row from the table: "messaging.activity_user" */
  deleteMessagingActivityUser?: Maybe<messagingActivityUser>;
  /** delete data from the table: "messaging.activity_user" */
  deleteMessagingActivityUsers?: Maybe<messagingActivityUserMutationResponse>;
  /** delete data from the table: "messaging.invitation" */
  deleteMessagingInvitation?: Maybe<MessagingInvitationMutationResponse>;
  /** delete single row from the table: "messaging.invitation" */
  deleteMessagingInvitationByPk?: Maybe<MessagingInvitation>;
  /** delete data from the table: "messaging.mentions" */
  deleteMessagingMentions?: Maybe<MessagingMentionsMutationResponse>;
  /** delete single row from the table: "messaging.mentions" */
  deleteMessagingMentionsByPk?: Maybe<MessagingMentions>;
  /** delete single row from the table: "messaging.message" */
  deleteMessagingMessage?: Maybe<messagingMessage>;
  /** delete data from the table: "messaging.message_attachment" */
  deleteMessagingMessageAttachment?: Maybe<MessagingMessageAttachmentMutationResponse>;
  /** delete single row from the table: "messaging.message_attachment" */
  deleteMessagingMessageAttachmentByPk?: Maybe<MessagingMessageAttachment>;
  /** delete data from the table: "messaging.message_attachment_type" */
  deleteMessagingMessageAttachmentType?: Maybe<MessagingMessageAttachmentTypeMutationResponse>;
  /** delete single row from the table: "messaging.message_attachment_type" */
  deleteMessagingMessageAttachmentTypeByPk?: Maybe<MessagingMessageAttachmentType>;
  /** delete single row from the table: "messaging.message_emoji" */
  deleteMessagingMessageEmoji?: Maybe<messagingMessageEmoji>;
  /** delete data from the table: "messaging.message_emoji" */
  deleteMessagingMessageEmojis?: Maybe<messagingMessageEmojiMutationResponse>;
  /** delete data from the table: "messaging.message_priority" */
  deleteMessagingMessagePriority?: Maybe<MessagingMessagePriorityMutationResponse>;
  /** delete single row from the table: "messaging.message_priority" */
  deleteMessagingMessagePriorityByPk?: Maybe<MessagingMessagePriority>;
  /** delete single row from the table: "messaging.message_read" */
  deleteMessagingMessageRead?: Maybe<messagingMessageRead>;
  /** delete data from the table: "messaging.message_read" */
  deleteMessagingMessageReads?: Maybe<messagingMessageReadMutationResponse>;
  /** delete single row from the table: "messaging.message_type" */
  deleteMessagingMessageType?: Maybe<messagingMessageType>;
  /** delete data from the table: "messaging.message_type" */
  deleteMessagingMessageTypes?: Maybe<messagingMessageTypeMutationResponse>;
  /** delete data from the table: "messaging.message" */
  deleteMessagingMessages?: Maybe<messagingMessageMutationResponse>;
  /** delete single row from the table: "notification.notifications" */
  deleteNotification?: Maybe<notification>;
  /** delete data from the table: "notification.notification_device_sent" */
  deleteNotificationNotificationDeviceSent?: Maybe<NotificationNotificationDeviceSentMutationResponse>;
  /** delete single row from the table: "notification.notification_device_sent" */
  deleteNotificationNotificationDeviceSentByPk?: Maybe<NotificationNotificationDeviceSent>;
  /** delete data from the table: "notification.notification_setting_activity_primary_enum" */
  deleteNotificationNotificationSettingActivityPrimaryEnum?: Maybe<NotificationNotificationSettingActivityPrimaryEnumMutationResponse>;
  /** delete single row from the table: "notification.notification_setting_activity_primary_enum" */
  deleteNotificationNotificationSettingActivityPrimaryEnumByPk?: Maybe<NotificationNotificationSettingActivityPrimaryEnum>;
  /** delete single row from the table: "notification.notification_send" */
  deleteNotificationSend?: Maybe<notificationSend>;
  /** delete data from the table: "notification.notification_send" */
  deleteNotificationSends?: Maybe<notificationSendMutationResponse>;
  /** delete data from the table: "notification.notification_setting_activity" */
  deleteNotificationSettingActivities?: Maybe<notificationSettingActivityMutationResponse>;
  /** delete single row from the table: "notification.notification_setting_activity" */
  deleteNotificationSettingActivity?: Maybe<notificationSettingActivity>;
  /** delete single row from the table: "notification.notification_users" */
  deleteNotificationUser?: Maybe<notificationUser>;
  /** delete single row from the table: "notification.notification_user_devices" */
  deleteNotificationUserDevice?: Maybe<notificationUserDevice>;
  /** delete data from the table: "notification.notification_user_devices" */
  deleteNotificationUserDevices?: Maybe<notificationUserDeviceMutationResponse>;
  /** delete data from the table: "notification.notification_users" */
  deleteNotificationUsers?: Maybe<notificationUserMutationResponse>;
  /** delete data from the table: "notification.notifications" */
  deleteNotifications?: Maybe<notificationMutationResponse>;
  /** delete single row from the table: "orders.integrations" */
  deleteOrdersIntegration?: Maybe<ordersIntegrations>;
  /** delete data from the table: "orders.integrations" */
  deleteOrdersIntegrations?: Maybe<ordersIntegrationsMutationResponse>;
  /** delete data from the table: "orders.organizations" */
  deleteOrdersOrganizations?: Maybe<OrdersOrganizationsMutationResponse>;
  /** delete single row from the table: "orders.organizations" */
  deleteOrdersOrganizationsByPk?: Maybe<OrdersOrganizations>;
  /** delete data from the table: "orders.request" */
  deleteOrdersRequest?: Maybe<OrdersRequestMutationResponse>;
  /** delete single row from the table: "orders.request" */
  deleteOrdersRequestByPk?: Maybe<OrdersRequest>;
  /** delete data from the table: "orders.status" */
  deleteOrdersStatus?: Maybe<OrdersStatusMutationResponse>;
  /** delete single row from the table: "orders.status" */
  deleteOrdersStatusByPk?: Maybe<OrdersStatus>;
  /** delete data from the table: "orders.type" */
  deleteOrdersType?: Maybe<OrdersTypeMutationResponse>;
  /** delete single row from the table: "orders.type" */
  deleteOrdersTypeByPk?: Maybe<OrdersType>;
  /** delete single row from the table: "business.organizations" */
  deleteOrganization?: Maybe<organization>;
  /** delete single row from the table: "business.authorization_enum_group" */
  deleteOrganizationAuthorizationEnumGroup?: Maybe<organizationAuthorizationEnumGroup>;
  /** delete data from the table: "business.authorization_enum_group" */
  deleteOrganizationAuthorizationEnumGroups?: Maybe<organizationAuthorizationEnumGroupMutationResponse>;
  /** delete single row from the table: "business.authorization_group" */
  deleteOrganizationAuthorizationGroup?: Maybe<organizationAuthorizationGroup>;
  /** delete data from the table: "business.authorization_group" */
  deleteOrganizationAuthorizationGroups?: Maybe<organizationAuthorizationGroupMutationResponse>;
  /** delete single row from the table: "business.organization_relationship" */
  deleteOrganizationOrganizationRelationship?: Maybe<organizationOrganizationRelationship>;
  /** delete data from the table: "business.organization_relationship_category" */
  deleteOrganizationOrganizationRelationshipCategories?: Maybe<organizationOrganizationRelationshipCategoryMutationResponse>;
  /** delete single row from the table: "business.organization_relationship_category" */
  deleteOrganizationOrganizationRelationshipCategory?: Maybe<organizationOrganizationRelationshipCategory>;
  /** delete data from the table: "business.organization_relationship" */
  deleteOrganizationOrganizationRelationships?: Maybe<organizationOrganizationRelationshipMutationResponse>;
  /** delete single row from the table: "business.organization_user_authorization" */
  deleteOrganizationOrganizationUserAuthorization?: Maybe<organizationOrganizationUserAuthorization>;
  /** delete data from the table: "business.organization_user_authorization" */
  deleteOrganizationOrganizationUserAuthorizations?: Maybe<organizationOrganizationUserAuthorizationMutationResponse>;
  /** delete single row from the table: "business.organization_user" */
  deleteOrganizationUser?: Maybe<organizationUser>;
  /** delete single row from the table: "business.organization_user_attachments" */
  deleteOrganizationUserAttachment?: Maybe<organizationUserAttachments>;
  /** delete data from the table: "business.organization_user_attachments" */
  deleteOrganizationUserAttachments?: Maybe<organizationUserAttachmentsMutationResponse>;
  /** delete single row from the table: "business.organization_user_attention_note" */
  deleteOrganizationUserAttentionNote?: Maybe<OrganizationUserAttentionNote>;
  /** delete data from the table: "business.organization_user_attention_note" */
  deleteOrganizationUserAttentionNotes?: Maybe<OrganizationUserAttentionNoteMutationResponse>;
  /** delete single row from the table: "business.user_authorization" */
  deleteOrganizationUserAuthorization?: Maybe<organizationUserAuthorization>;
  /** delete data from the table: "business.user_authorization" */
  deleteOrganizationUserAuthorizations?: Maybe<organizationUserAuthorizationMutationResponse>;
  /** delete single row from the table: "business.organization_user_details" */
  deleteOrganizationUserDetail?: Maybe<organizationUserDetail>;
  /** delete single row from the table: "business.organization_user_details_type" */
  deleteOrganizationUserDetailType?: Maybe<organizationUserDetailType>;
  /** delete data from the table: "business.organization_user_details_type" */
  deleteOrganizationUserDetailTypes?: Maybe<organizationUserDetailTypeMutationResponse>;
  /** delete data from the table: "business.organization_user_details" */
  deleteOrganizationUserDetails?: Maybe<organizationUserDetailMutationResponse>;
  /** delete single row from the table: "business.organization_user_invite" */
  deleteOrganizationUserInvite?: Maybe<organizationUserInvite>;
  /** delete data from the table: "business.organization_user_invite" */
  deleteOrganizationUserInvites?: Maybe<organizationUserInviteMutationResponse>;
  /** delete single row from the table: "business.organization_user_request" */
  deleteOrganizationUserRequest?: Maybe<BusinessOrganizationUserRequest>;
  /** delete data from the table: "business.organization_user_request" */
  deleteOrganizationUserRequests?: Maybe<BusinessOrganizationUserRequestMutationResponse>;
  /** delete single row from the table: "business.organization_user_status" */
  deleteOrganizationUserStatus?: Maybe<organizationUserStatus>;
  /** delete data from the table: "business.organization_user_status" */
  deleteOrganizationUserStatuses?: Maybe<organizationUserStatusMutationResponse>;
  /** delete data from the table: "business.organization_user" */
  deleteOrganizationUsers?: Maybe<organizationUserMutationResponse>;
  /** delete data from the table: "business.organizations" */
  deleteOrganizations?: Maybe<organizationMutationResponse>;
  /** delete single row from the table: "business.phone_number_verification_status" */
  deletePhoneNumberVerificationStatus?: Maybe<phoneNumberVerificationStatus>;
  /** delete data from the table: "business.phone_number_verification_status" */
  deletePhoneNumberVerificationStatuses?: Maybe<phoneNumberVerificationStatusMutationResponse>;
  /** delete data from the table: "prompt" */
  deletePrompt?: Maybe<PromptMutationResponse>;
  /** delete single row from the table: "prompt" */
  deletePromptByPk?: Maybe<Prompt>;
  /** delete single row from the table: "devices" */
  deletePublicDevice?: Maybe<publicDevice>;
  /** delete data from the table: "devices" */
  deletePublicDevices?: Maybe<publicDeviceMutationResponse>;
  /** delete single row from the table: "external_requests" */
  deletePublicExternalRequest?: Maybe<publicExternalRequest>;
  /** delete data from the table: "external_requests" */
  deletePublicExternalRequests?: Maybe<publicExternalRequestMutationResponse>;
  /** delete single row from the table: "files" */
  deletePublicFile?: Maybe<publicFile>;
  /** delete data from the table: "files" */
  deletePublicFiles?: Maybe<publicFileMutationResponse>;
  /** delete single row from the table: "notifications" */
  deletePublicNotification?: Maybe<publicNotification>;
  /** delete data from the table: "notifications" */
  deletePublicNotifications?: Maybe<publicNotificationMutationResponse>;
  /** delete single row from the table: "business.queue_item" */
  deleteQueueItem?: Maybe<queueItem>;
  /** delete data from the table: "business.queue_item_flexibility_type" */
  deleteQueueItemFlexibilityType?: Maybe<QueueItemFlexibilityTypeMutationResponse>;
  /** delete single row from the table: "business.queue_item_flexibility_type" */
  deleteQueueItemFlexibilityTypeByPk?: Maybe<QueueItemFlexibilityType>;
  /** delete data from the table: "business.queue_item_participant_responsibiliy_type" */
  deleteQueueItemParticipantResponsibilityType?: Maybe<QueueItemParticipantResponsibilityTypeMutationResponse>;
  /** delete single row from the table: "business.queue_item_participant_responsibiliy_type" */
  deleteQueueItemParticipantResponsibilityTypeByPk?: Maybe<QueueItemParticipantResponsibilityType>;
  /** delete data from the table: "business.queue_item" */
  deleteQueueItems?: Maybe<queueItemMutationResponse>;
  /** delete single row from the table: "business.rel_organization_user_domain_user" */
  deleteRelOrganizationUserDomainUser?: Maybe<relOrganizationUserDomainUser>;
  /** delete data from the table: "business.rel_organization_user_domain_user" */
  deleteRelOrganizationUserDomainUsers?: Maybe<relOrganizationUserDomainUserMutationResponse>;
  /** delete data from the table: "business.relation_type" */
  deleteRelationType?: Maybe<RelationTypeMutationResponse>;
  /** delete single row from the table: "business.relation_type" */
  deleteRelationTypeByPk?: Maybe<RelationType>;
  deleteRequestToOrganization?: Maybe<DeleteRequestUserOutput>;
  /** delete single row from the table: "sms.connectors" */
  deleteSmsConnector?: Maybe<smsConnector>;
  /** delete data from the table: "sms.connectors" */
  deleteSmsConnectors?: Maybe<smsConnectorMutationResponse>;
  /** delete single row from the table: "sms.gates" */
  deleteSmsGate?: Maybe<smsGate>;
  /** delete data from the table: "sms.gates" */
  deleteSmsGates?: Maybe<smsGateMutationResponse>;
  /** delete single row from the table: "sms.link_mobility_sms_content" */
  deleteSmsLinkMobilitySmsContent?: Maybe<smsLinkMobilitySmsContent>;
  /** delete data from the table: "sms.link_mobility_sms_content" */
  deleteSmsLinkMobilitySmsContents?: Maybe<smsLinkMobilitySmsContentMutationResponse>;
  /** delete single row from the table: "sms.link_mobility_sms_message" */
  deleteSmsLinkMobilitySmsMessage?: Maybe<smsLinkMobilitySmsMessage>;
  /** delete data from the table: "sms.link_mobility_sms_message" */
  deleteSmsLinkMobilitySmsMessages?: Maybe<smsLinkMobilitySmsMessageMutationResponse>;
  /** delete single row from the table: "sms.link_mobility_sms_route" */
  deleteSmsLinkMobilitySmsRoute?: Maybe<smsLinkMobilitySmsRoute>;
  /** delete data from the table: "sms.link_mobility_sms_route" */
  deleteSmsLinkMobilitySmsRoutes?: Maybe<smsLinkMobilitySmsRouteMutationResponse>;
  /** delete single row from the table: "sms.providers" */
  deleteSmsProvider?: Maybe<smsProvider>;
  /** delete data from the table: "sms.providers" */
  deleteSmsProviders?: Maybe<smsProviderMutationResponse>;
  /** delete single row from the table: "sms.sms" */
  deleteSmsSm?: Maybe<smsSm>;
  /** delete data from the table: "sms.sms" */
  deleteSmsSms?: Maybe<smsSmMutationResponse>;
  /** delete data from the table: "sms.sms_external_incoming_link_mobility" */
  deleteSmsSmsExternalIncomingLinkMobilities?: Maybe<smsSmsExternalIncomingLinkMobilityMutationResponse>;
  /** delete single row from the table: "sms.sms_external_incoming_link_mobility" */
  deleteSmsSmsExternalIncomingLinkMobility?: Maybe<smsSmsExternalIncomingLinkMobility>;
  /** delete single row from the table: "business.users" */
  deleteUser?: Maybe<user>;
  /** delete single row from the table: "business.user_details" */
  deleteUserDetail?: Maybe<userDetail>;
  /** delete data from the table: "business.user_details" */
  deleteUserDetails?: Maybe<userDetailMutationResponse>;
  /** delete single row from the table: "business.user_details_type" */
  deleteUserDetailsType?: Maybe<userDetailsType>;
  /** delete data from the table: "business.user_details_type" */
  deleteUserDetailsTypes?: Maybe<userDetailsTypeMutationResponse>;
  /** delete single row from the table: "business.user_devices" */
  deleteUserDevice?: Maybe<userDevice>;
  /** delete data from the table: "business.user_devices" */
  deleteUserDevices?: Maybe<userDeviceMutationResponse>;
  /** delete single row from the table: "business.user_phone_numbers" */
  deleteUserPhoneNumber?: Maybe<userPhoneNumber>;
  /** delete data from the table: "business.user_phone_numbers" */
  deleteUserPhoneNumbers?: Maybe<userPhoneNumberMutationResponse>;
  /** delete single row from the table: "business.user_role" */
  deleteUserRole?: Maybe<userRole>;
  /** delete data from the table: "business.user_role" */
  deleteUserRoles?: Maybe<userRoleMutationResponse>;
  /** delete data from the table: "business.users" */
  deleteUsers?: Maybe<userMutationResponse>;
  /** delete single row from the table: "validation.validation" */
  deleteValidationValidation?: Maybe<validationValidation>;
  /** delete data from the table: "validation.validation" */
  deleteValidationValidations?: Maybe<validationValidationMutationResponse>;
  /** delete data from the table: "voice_types" */
  deleteVoiceTypes?: Maybe<VoiceTypesMutationResponse>;
  /** delete single row from the table: "voice_types" */
  deleteVoiceTypesByPk?: Maybe<VoiceTypes>;
  emailing?: Maybe<emailingmutation_root>;
  /** fileUpload */
  fileUpload?: Maybe<Array<Maybe<fileOutput>>>;
  geodata?: Maybe<geodatamutation_root>;
  incomingSms: Scalars['uuid']['output'];
  initiateVerification?: Maybe<VerificationOutput>;
  /** insert data into the table: "business.direction" */
  insertActivityDirection?: Maybe<ActivityDirectionMutationResponse>;
  /** insert a single row into the table: "business.direction" */
  insertActivityDirectionOne?: Maybe<ActivityDirection>;
  /** insert data into the table: "business.provider" */
  insertActivityProvider?: Maybe<ActivityProviderMutationResponse>;
  /** insert a single row into the table: "business.provider" */
  insertActivityProviderOne?: Maybe<ActivityProvider>;
  /** insert data into the table: "business.domain_activity_type" */
  insertBusinessDomainActivityType?: Maybe<BusinessDomainActivityTypeMutationResponse>;
  /** insert a single row into the table: "business.domain_activity_type" */
  insertBusinessDomainActivityTypeOne?: Maybe<BusinessDomainActivityType>;
  /** insert data into the table: "business.feed_type" */
  insertBusinessFeedType?: Maybe<BusinessFeedTypeMutationResponse>;
  /** insert a single row into the table: "business.feed_type" */
  insertBusinessFeedTypeOne?: Maybe<BusinessFeedType>;
  /** insert data into the table: "business.message_attachments" */
  insertBusinessMessageAttachments?: Maybe<BusinessMessageAttachmentsMutationResponse>;
  /** insert a single row into the table: "business.message_attachments" */
  insertBusinessMessageAttachmentsOne?: Maybe<BusinessMessageAttachments>;
  /** insert data into the table: "business.organization_user_callback_answer" */
  insertBusinessOrganizationUserCallbackAnswer?: Maybe<BusinessOrganizationUserCallbackAnswerMutationResponse>;
  /** insert a single row into the table: "business.organization_user_callback_answer" */
  insertBusinessOrganizationUserCallbackAnswerOne?: Maybe<BusinessOrganizationUserCallbackAnswer>;
  /** insert data into the table: "business.organization_user_email" */
  insertBusinessOrganizationUserEmail?: Maybe<BusinessOrganizationUserEmailMutationResponse>;
  /** insert a single row into the table: "business.organization_user_email" */
  insertBusinessOrganizationUserEmailOne?: Maybe<BusinessOrganizationUserEmail>;
  /** insert data into the table: "business.organization_user_email_type" */
  insertBusinessOrganizationUserEmailType?: Maybe<BusinessOrganizationUserEmailTypeMutationResponse>;
  /** insert a single row into the table: "business.organization_user_email_type" */
  insertBusinessOrganizationUserEmailTypeOne?: Maybe<BusinessOrganizationUserEmailType>;
  /** insert data into the table: "business.organization_user_request_type" */
  insertBusinessOrganizationUserRequestType?: Maybe<BusinessOrganizationUserRequestTypeMutationResponse>;
  /** insert a single row into the table: "business.organization_user_request_type" */
  insertBusinessOrganizationUserRequestTypeOne?: Maybe<BusinessOrganizationUserRequestType>;
  /** insert data into the table: "business.organization_user_suggestion_type" */
  insertBusinessOrganizationUserSuggestionType?: Maybe<BusinessOrganizationUserSuggestionTypeMutationResponse>;
  /** insert a single row into the table: "business.organization_user_suggestion_type" */
  insertBusinessOrganizationUserSuggestionTypeOne?: Maybe<BusinessOrganizationUserSuggestionType>;
  /** insert data into the table: "business.organization_user_suggestions" */
  insertBusinessOrganizationUserSuggestions?: Maybe<BusinessOrganizationUserSuggestionsMutationResponse>;
  /** insert a single row into the table: "business.organization_user_suggestions" */
  insertBusinessOrganizationUserSuggestionsOne?: Maybe<BusinessOrganizationUserSuggestions>;
  /** insert data into the table: "business.organization_user_url_address" */
  insertBusinessOrganizationUserUrlAddress?: Maybe<BusinessOrganizationUserUrlAddressMutationResponse>;
  /** insert a single row into the table: "business.organization_user_url_address" */
  insertBusinessOrganizationUserUrlAddressOne?: Maybe<BusinessOrganizationUserUrlAddress>;
  /** insert data into the table: "business.organization_user_url_address_type" */
  insertBusinessOrganizationUserUrlAddressType?: Maybe<BusinessOrganizationUserUrlAddressTypeMutationResponse>;
  /** insert a single row into the table: "business.organization_user_url_address_type" */
  insertBusinessOrganizationUserUrlAddressTypeOne?: Maybe<BusinessOrganizationUserUrlAddressType>;
  /** insert data into the table: "business.queue_item_alarm_type" */
  insertBusinessQueueItemAlarmType?: Maybe<BusinessQueueItemAlarmTypeMutationResponse>;
  /** insert a single row into the table: "business.queue_item_alarm_type" */
  insertBusinessQueueItemAlarmTypeOne?: Maybe<BusinessQueueItemAlarmType>;
  /** insert data into the table: "business.queue_item_alarms" */
  insertBusinessQueueItemAlarms?: Maybe<BusinessQueueItemAlarmsMutationResponse>;
  /** insert a single row into the table: "business.queue_item_alarms" */
  insertBusinessQueueItemAlarmsOne?: Maybe<BusinessQueueItemAlarms>;
  /** insert data into the table: "business.queue_item_participant_channel_type" */
  insertBusinessQueueItemParticipantChannelType?: Maybe<BusinessQueueItemParticipantChannelTypeMutationResponse>;
  /** insert a single row into the table: "business.queue_item_participant_channel_type" */
  insertBusinessQueueItemParticipantChannelTypeOne?: Maybe<BusinessQueueItemParticipantChannelType>;
  /** insert data into the table: "business.queue_item_sub_type" */
  insertBusinessQueueItemSubType?: Maybe<BusinessQueueItemSubTypeMutationResponse>;
  /** insert a single row into the table: "business.queue_item_sub_type" */
  insertBusinessQueueItemSubTypeOne?: Maybe<BusinessQueueItemSubType>;
  /** insert data into the table: "business.user_contact_numbers" */
  insertBusinessUserContactNumbers?: Maybe<BusinessUserContactNumbersMutationResponse>;
  /** insert a single row into the table: "business.user_contact_numbers" */
  insertBusinessUserContactNumbersOne?: Maybe<BusinessUserContactNumbers>;
  /** insert data into the table: "business.user_feed" */
  insertBusinessUserFeed?: Maybe<BusinessUserFeedMutationResponse>;
  /** insert a single row into the table: "business.user_feed" */
  insertBusinessUserFeedOne?: Maybe<BusinessUserFeed>;
  /** insert data into the table: "business.user_request_status" */
  insertBusinessUserRequestStatus?: Maybe<BusinessUserRequestStatusMutationResponse>;
  /** insert a single row into the table: "business.user_request_status" */
  insertBusinessUserRequestStatusOne?: Maybe<BusinessUserRequestStatus>;
  /** insert data into the table: "business.user_states" */
  insertBusinessUserStates?: Maybe<BusinessUserStatesMutationResponse>;
  /** insert a single row into the table: "business.user_states" */
  insertBusinessUserStatesOne?: Maybe<BusinessUserStates>;
  /** insert data into the table: "crm.context" */
  insertCrmContext?: Maybe<CrmContextMutationResponse>;
  /** insert a single row into the table: "crm.context" */
  insertCrmContextOne?: Maybe<CrmContext>;
  /** insert data into the table: "crm.context_type" */
  insertCrmContextType?: Maybe<CrmContextTypeMutationResponse>;
  /** insert a single row into the table: "crm.context_type" */
  insertCrmContextTypeOne?: Maybe<CrmContextType>;
  /** insert data into the table: "crm.creator_type" */
  insertCrmCreatorType?: Maybe<CrmCreatorTypeMutationResponse>;
  /** insert a single row into the table: "crm.creator_type" */
  insertCrmCreatorTypeOne?: Maybe<CrmCreatorType>;
  /** insert data into the table: "crm.crm_type" */
  insertCrmCrmType?: Maybe<CrmCrmTypeMutationResponse>;
  /** insert a single row into the table: "crm.crm_type" */
  insertCrmCrmTypeOne?: Maybe<CrmCrmType>;
  /** insert data into the table: "crm.direction_type" */
  insertCrmDirectionType?: Maybe<CrmDirectionTypeMutationResponse>;
  /** insert a single row into the table: "crm.direction_type" */
  insertCrmDirectionTypeOne?: Maybe<CrmDirectionType>;
  /** insert data into the table: "crm.entity" */
  insertCrmEntity?: Maybe<CrmEntityMutationResponse>;
  /** insert a single row into the table: "crm.entity" */
  insertCrmEntityOne?: Maybe<CrmEntity>;
  /** insert data into the table: "crm.event" */
  insertCrmEvent?: Maybe<CrmEventMutationResponse>;
  /** insert a single row into the table: "crm.event" */
  insertCrmEventOne?: Maybe<CrmEvent>;
  /** insert data into the table: "crm.event_type" */
  insertCrmEventType?: Maybe<CrmEventTypeMutationResponse>;
  /** insert a single row into the table: "crm.event_type" */
  insertCrmEventTypeOne?: Maybe<CrmEventType>;
  /** insert data into the table: "crm.status_code" */
  insertCrmStatusCode?: Maybe<CrmStatusCodeMutationResponse>;
  /** insert a single row into the table: "crm.status_code" */
  insertCrmStatusCodeOne?: Maybe<CrmStatusCode>;
  /** insert data into the table: "crm.system_type" */
  insertCrmSystemType?: Maybe<CrmSystemTypeMutationResponse>;
  /** insert a single row into the table: "crm.system_type" */
  insertCrmSystemTypeOne?: Maybe<CrmSystemType>;
  /** insert data into the table: "crm.trace_context" */
  insertCrmTraceContext?: Maybe<CrmTraceContextMutationResponse>;
  /** insert a single row into the table: "crm.trace_context" */
  insertCrmTraceContextOne?: Maybe<CrmTraceContext>;
  /** insert data into the table: "crm.unified_entity_type" */
  insertCrmUnifiedEntityType?: Maybe<CrmUnifiedEntityTypeMutationResponse>;
  /** insert a single row into the table: "crm.unified_entity_type" */
  insertCrmUnifiedEntityTypeOne?: Maybe<CrmUnifiedEntityType>;
  /** insert data into the table: "business.languages" */
  insertLanguages?: Maybe<languagesMutationResponse>;
  /** insert a single row into the table: "business.languages" */
  insertLanguagesOne?: Maybe<languages>;
  /** insert data into the table: "messaging.activitySettings" */
  insertMessagingActivitySettings?: Maybe<MessagingActivitySettingsMutationResponse>;
  /** insert data into the table: "messaging.activitySettingsNotificationSettingType" */
  insertMessagingActivitySettingsNotificationSettingType?: Maybe<MessagingActivitySettingsNotificationSettingTypeMutationResponse>;
  /** insert a single row into the table: "messaging.activitySettingsNotificationSettingType" */
  insertMessagingActivitySettingsNotificationSettingTypeOne?: Maybe<MessagingActivitySettingsNotificationSettingType>;
  /** insert a single row into the table: "messaging.activitySettings" */
  insertMessagingActivitySettingsOne?: Maybe<MessagingActivitySettings>;
  /** insert data into the table: "messaging.invitation" */
  insertMessagingInvitation?: Maybe<MessagingInvitationMutationResponse>;
  /** insert a single row into the table: "messaging.invitation" */
  insertMessagingInvitationOne?: Maybe<MessagingInvitation>;
  /** insert data into the table: "messaging.mentions" */
  insertMessagingMentions?: Maybe<MessagingMentionsMutationResponse>;
  /** insert a single row into the table: "messaging.mentions" */
  insertMessagingMentionsOne?: Maybe<MessagingMentions>;
  /** insert data into the table: "messaging.message_attachment" */
  insertMessagingMessageAttachment?: Maybe<MessagingMessageAttachmentMutationResponse>;
  /** insert a single row into the table: "messaging.message_attachment" */
  insertMessagingMessageAttachmentOne?: Maybe<MessagingMessageAttachment>;
  /** insert data into the table: "messaging.message_attachment_type" */
  insertMessagingMessageAttachmentType?: Maybe<MessagingMessageAttachmentTypeMutationResponse>;
  /** insert a single row into the table: "messaging.message_attachment_type" */
  insertMessagingMessageAttachmentTypeOne?: Maybe<MessagingMessageAttachmentType>;
  /** insert data into the table: "messaging.message_priority" */
  insertMessagingMessagePriority?: Maybe<MessagingMessagePriorityMutationResponse>;
  /** insert a single row into the table: "messaging.message_priority" */
  insertMessagingMessagePriorityOne?: Maybe<MessagingMessagePriority>;
  /** insert data into the table: "notification.notification_device_sent" */
  insertNotificationNotificationDeviceSent?: Maybe<NotificationNotificationDeviceSentMutationResponse>;
  /** insert a single row into the table: "notification.notification_device_sent" */
  insertNotificationNotificationDeviceSentOne?: Maybe<NotificationNotificationDeviceSent>;
  /** insert data into the table: "notification.notification_setting_activity_primary_enum" */
  insertNotificationNotificationSettingActivityPrimaryEnum?: Maybe<NotificationNotificationSettingActivityPrimaryEnumMutationResponse>;
  /** insert a single row into the table: "notification.notification_setting_activity_primary_enum" */
  insertNotificationNotificationSettingActivityPrimaryEnumOne?: Maybe<NotificationNotificationSettingActivityPrimaryEnum>;
  /** insert data into the table: "orders.organizations" */
  insertOrdersOrganizations?: Maybe<OrdersOrganizationsMutationResponse>;
  /** insert a single row into the table: "orders.organizations" */
  insertOrdersOrganizationsOne?: Maybe<OrdersOrganizations>;
  /** insert data into the table: "orders.request" */
  insertOrdersRequest?: Maybe<OrdersRequestMutationResponse>;
  /** insert a single row into the table: "orders.request" */
  insertOrdersRequestOne?: Maybe<OrdersRequest>;
  /** insert data into the table: "orders.status" */
  insertOrdersStatus?: Maybe<OrdersStatusMutationResponse>;
  /** insert a single row into the table: "orders.status" */
  insertOrdersStatusOne?: Maybe<OrdersStatus>;
  /** insert data into the table: "orders.type" */
  insertOrdersType?: Maybe<OrdersTypeMutationResponse>;
  /** insert a single row into the table: "orders.type" */
  insertOrdersTypeOne?: Maybe<OrdersType>;
  /** insert data into the table: "prompt" */
  insertPrompt?: Maybe<PromptMutationResponse>;
  /** insert a single row into the table: "prompt" */
  insertPromptOne?: Maybe<Prompt>;
  /** insert data into the table: "business.queue_item_flexibility_type" */
  insertQueueItemFlexibilityType?: Maybe<QueueItemFlexibilityTypeMutationResponse>;
  /** insert a single row into the table: "business.queue_item_flexibility_type" */
  insertQueueItemFlexibilityTypeOne?: Maybe<QueueItemFlexibilityType>;
  /** insert data into the table: "business.queue_item_participant_responsibiliy_type" */
  insertQueueItemParticipantResponsibilityType?: Maybe<QueueItemParticipantResponsibilityTypeMutationResponse>;
  /** insert a single row into the table: "business.queue_item_participant_responsibiliy_type" */
  insertQueueItemParticipantResponsibilityTypeOne?: Maybe<QueueItemParticipantResponsibilityType>;
  /** insert data into the table: "business.relation_type" */
  insertRelationType?: Maybe<RelationTypeMutationResponse>;
  /** insert a single row into the table: "business.relation_type" */
  insertRelationTypeOne?: Maybe<RelationType>;
  /** insert data into the table: "voice_types" */
  insertVoiceTypes?: Maybe<VoiceTypesMutationResponse>;
  /** insert a single row into the table: "voice_types" */
  insertVoiceTypesOne?: Maybe<VoiceTypes>;
  leaveOrganization?: Maybe<leaveOrganizationOutput>;
  linkMobilitySMS?: Maybe<LinkMobilitySMSOutput>;
  makePhoneRequest?: Maybe<PhoneRequestOutput>;
  orderUpdate?: Maybe<OrderUpdateOutput>;
  /** privatizeUser */
  privatizeUser?: Maybe<privatizeUserResult>;
  removeCustomer?: Maybe<RemoveCustomerOutput>;
  /** removeEmailProviderIntegration */
  removeEmailProviderIntegration?: Maybe<Array<Maybe<removeEmailDomainUserOutput>>>;
  /** removeEmailProviderSubscription */
  removeEmailProviderSubscription?: Maybe<Array<Maybe<deleteEmailProviderSubscriptionOutput>>>;
  removeOrganization?: Maybe<removeOrganizationOutput>;
  /** renewEmailProviderSubscription */
  renewEmailProviderSubscription?: Maybe<Array<Maybe<renewEmailProviderSubscriptionOutput>>>;
  /** request a provider integration */
  requestIntegrations?: Maybe<RequestIntegrationsOutput>;
  searchPhoneApi?: Maybe<SearchPhoneOutput>;
  /** sendEmail */
  sendEmail?: Maybe<StatusOutput>;
  sendNotfication?: Maybe<NotificationOutput>;
  sendSMS?: Maybe<SendSMSOutput>;
  sendSmsToken?: Maybe<SendSMSTokenOutput>;
  setUpOrganization?: Maybe<setUpOrganizationOutput>;
  /** synchronizeTelephonyDomainUsers */
  synchronizeTelephonyDomainUsers?: Maybe<StatusOutput>;
  task?: Maybe<taskmutation_root>;
  telephony?: Maybe<telephonymutation_root>;
  /** testNotificationSettings */
  testNotificationSettings?: Maybe<testNotificationSettingsResult>;
  /** update data of the table: "business.direction" */
  updateActivityDirection?: Maybe<ActivityDirectionMutationResponse>;
  /** update single row of the table: "business.direction" */
  updateActivityDirectionByPk?: Maybe<ActivityDirection>;
  /** update multiples rows of table: "business.direction" */
  updateActivityDirectionMany?: Maybe<Array<Maybe<ActivityDirectionMutationResponse>>>;
  /** update single row of the table: "business.queue_item_participant" */
  updateActivityParticipant?: Maybe<activityParticipant>;
  /** update data of the table: "business.queue_item_participant" */
  updateActivityParticipants?: Maybe<activityParticipantMutationResponse>;
  /** update data of the table: "business.provider" */
  updateActivityProvider?: Maybe<ActivityProviderMutationResponse>;
  /** update single row of the table: "business.provider" */
  updateActivityProviderByPk?: Maybe<ActivityProvider>;
  /** update multiples rows of table: "business.provider" */
  updateActivityProviderMany?: Maybe<Array<Maybe<ActivityProviderMutationResponse>>>;
  /** update single row of the table: "business.activity_status" */
  updateActivityStatus?: Maybe<ActivityStatus>;
  /** update data of the table: "business.activity_status" */
  updateActivityStatuses?: Maybe<ActivityStatusMutationResponse>;
  /** update single row of the table: "business.activity_type" */
  updateActivityType?: Maybe<ActivityType>;
  /** update data of the table: "business.activity_type" */
  updateActivityTypes?: Maybe<ActivityTypeMutationResponse>;
  /** update single row of the table: "business.address" */
  updateAddress?: Maybe<address>;
  /** update data of the table: "business.address" */
  updateAddresses?: Maybe<addressMutationResponse>;
  /** update single row of the table: "business.blocked_domain_user" */
  updateBlockedDomainUser?: Maybe<blockedDomainUser>;
  /** update data of the table: "business.blocked_domain_user" */
  updateBlockedDomainUsers?: Maybe<blockedDomainUserMutationResponse>;
  /** update data of the table: "business.domain_activity_type" */
  updateBusinessDomainActivityType?: Maybe<BusinessDomainActivityTypeMutationResponse>;
  /** update single row of the table: "business.domain_activity_type" */
  updateBusinessDomainActivityTypeByPk?: Maybe<BusinessDomainActivityType>;
  /** update multiples rows of table: "business.domain_activity_type" */
  updateBusinessDomainActivityTypeMany?: Maybe<Array<Maybe<BusinessDomainActivityTypeMutationResponse>>>;
  /** update data of the table: "business.feed_type" */
  updateBusinessFeedType?: Maybe<BusinessFeedTypeMutationResponse>;
  /** update single row of the table: "business.feed_type" */
  updateBusinessFeedTypeByPk?: Maybe<BusinessFeedType>;
  /** update multiples rows of table: "business.feed_type" */
  updateBusinessFeedTypeMany?: Maybe<Array<Maybe<BusinessFeedTypeMutationResponse>>>;
  /** update data of the table: "business.message_attachments" */
  updateBusinessMessageAttachments?: Maybe<BusinessMessageAttachmentsMutationResponse>;
  /** update single row of the table: "business.message_attachments" */
  updateBusinessMessageAttachmentsByPk?: Maybe<BusinessMessageAttachments>;
  /** update multiples rows of table: "business.message_attachments" */
  updateBusinessMessageAttachmentsMany?: Maybe<Array<Maybe<BusinessMessageAttachmentsMutationResponse>>>;
  /** update data of the table: "business.organization_user_callback_answer" */
  updateBusinessOrganizationUserCallbackAnswer?: Maybe<BusinessOrganizationUserCallbackAnswerMutationResponse>;
  /** update single row of the table: "business.organization_user_callback_answer" */
  updateBusinessOrganizationUserCallbackAnswerByPk?: Maybe<BusinessOrganizationUserCallbackAnswer>;
  /** update multiples rows of table: "business.organization_user_callback_answer" */
  updateBusinessOrganizationUserCallbackAnswerMany?: Maybe<Array<Maybe<BusinessOrganizationUserCallbackAnswerMutationResponse>>>;
  /** update data of the table: "business.organization_user_email" */
  updateBusinessOrganizationUserEmail?: Maybe<BusinessOrganizationUserEmailMutationResponse>;
  /** update single row of the table: "business.organization_user_email" */
  updateBusinessOrganizationUserEmailByPk?: Maybe<BusinessOrganizationUserEmail>;
  /** update multiples rows of table: "business.organization_user_email" */
  updateBusinessOrganizationUserEmailMany?: Maybe<Array<Maybe<BusinessOrganizationUserEmailMutationResponse>>>;
  /** update data of the table: "business.organization_user_email_type" */
  updateBusinessOrganizationUserEmailType?: Maybe<BusinessOrganizationUserEmailTypeMutationResponse>;
  /** update single row of the table: "business.organization_user_email_type" */
  updateBusinessOrganizationUserEmailTypeByPk?: Maybe<BusinessOrganizationUserEmailType>;
  /** update multiples rows of table: "business.organization_user_email_type" */
  updateBusinessOrganizationUserEmailTypeMany?: Maybe<Array<Maybe<BusinessOrganizationUserEmailTypeMutationResponse>>>;
  /** update multiples rows of table: "business.organization_user_request" */
  updateBusinessOrganizationUserRequestMany?: Maybe<Array<Maybe<BusinessOrganizationUserRequestMutationResponse>>>;
  /** update data of the table: "business.organization_user_request_type" */
  updateBusinessOrganizationUserRequestType?: Maybe<BusinessOrganizationUserRequestTypeMutationResponse>;
  /** update single row of the table: "business.organization_user_request_type" */
  updateBusinessOrganizationUserRequestTypeByPk?: Maybe<BusinessOrganizationUserRequestType>;
  /** update multiples rows of table: "business.organization_user_request_type" */
  updateBusinessOrganizationUserRequestTypeMany?: Maybe<Array<Maybe<BusinessOrganizationUserRequestTypeMutationResponse>>>;
  /** update data of the table: "business.organization_user_suggestion_type" */
  updateBusinessOrganizationUserSuggestionType?: Maybe<BusinessOrganizationUserSuggestionTypeMutationResponse>;
  /** update single row of the table: "business.organization_user_suggestion_type" */
  updateBusinessOrganizationUserSuggestionTypeByPk?: Maybe<BusinessOrganizationUserSuggestionType>;
  /** update multiples rows of table: "business.organization_user_suggestion_type" */
  updateBusinessOrganizationUserSuggestionTypeMany?: Maybe<Array<Maybe<BusinessOrganizationUserSuggestionTypeMutationResponse>>>;
  /** update data of the table: "business.organization_user_suggestions" */
  updateBusinessOrganizationUserSuggestions?: Maybe<BusinessOrganizationUserSuggestionsMutationResponse>;
  /** update single row of the table: "business.organization_user_suggestions" */
  updateBusinessOrganizationUserSuggestionsByPk?: Maybe<BusinessOrganizationUserSuggestions>;
  /** update multiples rows of table: "business.organization_user_suggestions" */
  updateBusinessOrganizationUserSuggestionsMany?: Maybe<Array<Maybe<BusinessOrganizationUserSuggestionsMutationResponse>>>;
  /** update data of the table: "business.organization_user_url_address" */
  updateBusinessOrganizationUserUrlAddress?: Maybe<BusinessOrganizationUserUrlAddressMutationResponse>;
  /** update single row of the table: "business.organization_user_url_address" */
  updateBusinessOrganizationUserUrlAddressByPk?: Maybe<BusinessOrganizationUserUrlAddress>;
  /** update multiples rows of table: "business.organization_user_url_address" */
  updateBusinessOrganizationUserUrlAddressMany?: Maybe<Array<Maybe<BusinessOrganizationUserUrlAddressMutationResponse>>>;
  /** update data of the table: "business.organization_user_url_address_type" */
  updateBusinessOrganizationUserUrlAddressType?: Maybe<BusinessOrganizationUserUrlAddressTypeMutationResponse>;
  /** update single row of the table: "business.organization_user_url_address_type" */
  updateBusinessOrganizationUserUrlAddressTypeByPk?: Maybe<BusinessOrganizationUserUrlAddressType>;
  /** update multiples rows of table: "business.organization_user_url_address_type" */
  updateBusinessOrganizationUserUrlAddressTypeMany?: Maybe<Array<Maybe<BusinessOrganizationUserUrlAddressTypeMutationResponse>>>;
  /** update data of the table: "business.queue_item_alarm_type" */
  updateBusinessQueueItemAlarmType?: Maybe<BusinessQueueItemAlarmTypeMutationResponse>;
  /** update single row of the table: "business.queue_item_alarm_type" */
  updateBusinessQueueItemAlarmTypeByPk?: Maybe<BusinessQueueItemAlarmType>;
  /** update multiples rows of table: "business.queue_item_alarm_type" */
  updateBusinessQueueItemAlarmTypeMany?: Maybe<Array<Maybe<BusinessQueueItemAlarmTypeMutationResponse>>>;
  /** update data of the table: "business.queue_item_alarms" */
  updateBusinessQueueItemAlarms?: Maybe<BusinessQueueItemAlarmsMutationResponse>;
  /** update single row of the table: "business.queue_item_alarms" */
  updateBusinessQueueItemAlarmsByPk?: Maybe<BusinessQueueItemAlarms>;
  /** update multiples rows of table: "business.queue_item_alarms" */
  updateBusinessQueueItemAlarmsMany?: Maybe<Array<Maybe<BusinessQueueItemAlarmsMutationResponse>>>;
  /** update single row of the table: "business.queue_item_collaboration" */
  updateBusinessQueueItemCollaboration?: Maybe<businessQueueItemCollaboration>;
  /** update data of the table: "business.queue_item_collaboration" */
  updateBusinessQueueItemCollaborations?: Maybe<businessQueueItemCollaborationMutationResponse>;
  /** update data of the table: "business.queue_item_participant_channel_type" */
  updateBusinessQueueItemParticipantChannelType?: Maybe<BusinessQueueItemParticipantChannelTypeMutationResponse>;
  /** update single row of the table: "business.queue_item_participant_channel_type" */
  updateBusinessQueueItemParticipantChannelTypeByPk?: Maybe<BusinessQueueItemParticipantChannelType>;
  /** update multiples rows of table: "business.queue_item_participant_channel_type" */
  updateBusinessQueueItemParticipantChannelTypeMany?: Maybe<Array<Maybe<BusinessQueueItemParticipantChannelTypeMutationResponse>>>;
  /** update data of the table: "business.queue_item_sub_type" */
  updateBusinessQueueItemSubType?: Maybe<BusinessQueueItemSubTypeMutationResponse>;
  /** update single row of the table: "business.queue_item_sub_type" */
  updateBusinessQueueItemSubTypeByPk?: Maybe<BusinessQueueItemSubType>;
  /** update multiples rows of table: "business.queue_item_sub_type" */
  updateBusinessQueueItemSubTypeMany?: Maybe<Array<Maybe<BusinessQueueItemSubTypeMutationResponse>>>;
  /** update single row of the table: "business.user_contacts" */
  updateBusinessUserContact?: Maybe<businessUserContacts>;
  /** update data of the table: "business.user_contact_numbers" */
  updateBusinessUserContactNumbers?: Maybe<BusinessUserContactNumbersMutationResponse>;
  /** update single row of the table: "business.user_contact_numbers" */
  updateBusinessUserContactNumbersByPk?: Maybe<BusinessUserContactNumbers>;
  /** update multiples rows of table: "business.user_contact_numbers" */
  updateBusinessUserContactNumbersMany?: Maybe<Array<Maybe<BusinessUserContactNumbersMutationResponse>>>;
  /** update data of the table: "business.user_contacts" */
  updateBusinessUserContacts?: Maybe<businessUserContactsMutationResponse>;
  /** update data of the table: "business.user_feed" */
  updateBusinessUserFeed?: Maybe<BusinessUserFeedMutationResponse>;
  /** update single row of the table: "business.user_feed" */
  updateBusinessUserFeedByPk?: Maybe<BusinessUserFeed>;
  /** update multiples rows of table: "business.user_feed" */
  updateBusinessUserFeedMany?: Maybe<Array<Maybe<BusinessUserFeedMutationResponse>>>;
  /** update data of the table: "business.user_request_status" */
  updateBusinessUserRequestStatus?: Maybe<BusinessUserRequestStatusMutationResponse>;
  /** update single row of the table: "business.user_request_status" */
  updateBusinessUserRequestStatusByPk?: Maybe<BusinessUserRequestStatus>;
  /** update multiples rows of table: "business.user_request_status" */
  updateBusinessUserRequestStatusMany?: Maybe<Array<Maybe<BusinessUserRequestStatusMutationResponse>>>;
  /** update single row of the table: "business.user_settings" */
  updateBusinessUserSetting?: Maybe<businessUserSettings>;
  /** update data of the table: "business.user_settings" */
  updateBusinessUserSettings?: Maybe<businessUserSettingsMutationResponse>;
  /** update data of the table: "business.user_states" */
  updateBusinessUserStates?: Maybe<BusinessUserStatesMutationResponse>;
  /** update single row of the table: "business.user_states" */
  updateBusinessUserStatesByPk?: Maybe<BusinessUserStates>;
  /** update multiples rows of table: "business.user_states" */
  updateBusinessUserStatesMany?: Maybe<Array<Maybe<BusinessUserStatesMutationResponse>>>;
  /** update data of the table: "crm.context" */
  updateCrmContext?: Maybe<CrmContextMutationResponse>;
  /** update single row of the table: "crm.context" */
  updateCrmContextByPk?: Maybe<CrmContext>;
  /** update multiples rows of table: "crm.context" */
  updateCrmContextMany?: Maybe<Array<Maybe<CrmContextMutationResponse>>>;
  /** update data of the table: "crm.context_type" */
  updateCrmContextType?: Maybe<CrmContextTypeMutationResponse>;
  /** update single row of the table: "crm.context_type" */
  updateCrmContextTypeByPk?: Maybe<CrmContextType>;
  /** update multiples rows of table: "crm.context_type" */
  updateCrmContextTypeMany?: Maybe<Array<Maybe<CrmContextTypeMutationResponse>>>;
  /** update data of the table: "crm.creator_type" */
  updateCrmCreatorType?: Maybe<CrmCreatorTypeMutationResponse>;
  /** update single row of the table: "crm.creator_type" */
  updateCrmCreatorTypeByPk?: Maybe<CrmCreatorType>;
  /** update multiples rows of table: "crm.creator_type" */
  updateCrmCreatorTypeMany?: Maybe<Array<Maybe<CrmCreatorTypeMutationResponse>>>;
  /** update data of the table: "crm.crm_type" */
  updateCrmCrmType?: Maybe<CrmCrmTypeMutationResponse>;
  /** update single row of the table: "crm.crm_type" */
  updateCrmCrmTypeByPk?: Maybe<CrmCrmType>;
  /** update multiples rows of table: "crm.crm_type" */
  updateCrmCrmTypeMany?: Maybe<Array<Maybe<CrmCrmTypeMutationResponse>>>;
  /** update data of the table: "crm.direction_type" */
  updateCrmDirectionType?: Maybe<CrmDirectionTypeMutationResponse>;
  /** update single row of the table: "crm.direction_type" */
  updateCrmDirectionTypeByPk?: Maybe<CrmDirectionType>;
  /** update multiples rows of table: "crm.direction_type" */
  updateCrmDirectionTypeMany?: Maybe<Array<Maybe<CrmDirectionTypeMutationResponse>>>;
  /** update data of the table: "crm.entity" */
  updateCrmEntity?: Maybe<CrmEntityMutationResponse>;
  /** update single row of the table: "crm.entity" */
  updateCrmEntityByPk?: Maybe<CrmEntity>;
  /** update multiples rows of table: "crm.entity" */
  updateCrmEntityMany?: Maybe<Array<Maybe<CrmEntityMutationResponse>>>;
  /** update data of the table: "crm.event" */
  updateCrmEvent?: Maybe<CrmEventMutationResponse>;
  /** update single row of the table: "crm.event" */
  updateCrmEventByPk?: Maybe<CrmEvent>;
  /** update multiples rows of table: "crm.event" */
  updateCrmEventMany?: Maybe<Array<Maybe<CrmEventMutationResponse>>>;
  /** update data of the table: "crm.event_type" */
  updateCrmEventType?: Maybe<CrmEventTypeMutationResponse>;
  /** update single row of the table: "crm.event_type" */
  updateCrmEventTypeByPk?: Maybe<CrmEventType>;
  /** update multiples rows of table: "crm.event_type" */
  updateCrmEventTypeMany?: Maybe<Array<Maybe<CrmEventTypeMutationResponse>>>;
  /** update data of the table: "crm.status_code" */
  updateCrmStatusCode?: Maybe<CrmStatusCodeMutationResponse>;
  /** update single row of the table: "crm.status_code" */
  updateCrmStatusCodeByPk?: Maybe<CrmStatusCode>;
  /** update multiples rows of table: "crm.status_code" */
  updateCrmStatusCodeMany?: Maybe<Array<Maybe<CrmStatusCodeMutationResponse>>>;
  /** update single row of the table: "crm.status_message" */
  updateCrmStatusMessage?: Maybe<crmStatusMessage>;
  /** update multiples rows of table: "crm.status_message" */
  updateCrmStatusMessageMany?: Maybe<Array<Maybe<crmStatusMessageMutationResponse>>>;
  /** update data of the table: "crm.status_message" */
  updateCrmStatusMessages?: Maybe<crmStatusMessageMutationResponse>;
  /** update data of the table: "crm.system_type" */
  updateCrmSystemType?: Maybe<CrmSystemTypeMutationResponse>;
  /** update single row of the table: "crm.system_type" */
  updateCrmSystemTypeByPk?: Maybe<CrmSystemType>;
  /** update multiples rows of table: "crm.system_type" */
  updateCrmSystemTypeMany?: Maybe<Array<Maybe<CrmSystemTypeMutationResponse>>>;
  /** update data of the table: "crm.trace_context" */
  updateCrmTraceContext?: Maybe<CrmTraceContextMutationResponse>;
  /** update single row of the table: "crm.trace_context" */
  updateCrmTraceContextByPk?: Maybe<CrmTraceContext>;
  /** update multiples rows of table: "crm.trace_context" */
  updateCrmTraceContextMany?: Maybe<Array<Maybe<CrmTraceContextMutationResponse>>>;
  /** update data of the table: "crm.unified_entity_type" */
  updateCrmUnifiedEntityType?: Maybe<CrmUnifiedEntityTypeMutationResponse>;
  /** update single row of the table: "crm.unified_entity_type" */
  updateCrmUnifiedEntityTypeByPk?: Maybe<CrmUnifiedEntityType>;
  /** update multiples rows of table: "crm.unified_entity_type" */
  updateCrmUnifiedEntityTypeMany?: Maybe<Array<Maybe<CrmUnifiedEntityTypeMutationResponse>>>;
  /** update data of the table: "crm.youtello_catalyst_id_mapping" */
  updateCrmYoutelloCatalystIdMapping?: Maybe<crmYoutelloCatalystIdMappingMutationResponse>;
  /** update single row of the table: "crm.youtello_catalyst_id_mapping" */
  updateCrmYoutelloCatalystIdMappingByPk?: Maybe<crmYoutelloCatalystIdMapping>;
  /** update multiples rows of table: "crm.youtello_catalyst_id_mapping" */
  updateCrmYoutelloCatalystIdMappingMany?: Maybe<Array<Maybe<crmYoutelloCatalystIdMappingMutationResponse>>>;
  /** updateDashboardData */
  updateDashboardData?: Maybe<updateDashboardDataOutput>;
  /** update data of the table: "business.domain_activity" */
  updateDomainActivities?: Maybe<domainActivityMutationResponse>;
  /** update single row of the table: "business.domain_activity" */
  updateDomainActivity?: Maybe<domainActivity>;
  /** update single row of the table: "business.domain_organization" */
  updateDomainOrganization?: Maybe<domainOrganization>;
  /** update data of the table: "business.domain_organization" */
  updateDomainOrganizations?: Maybe<domainOrganizationMutationResponse>;
  /** update single row of the table: "business.domain_participant" */
  updateDomainParticipant?: Maybe<domainParticipant>;
  /** update data of the table: "business.domain_participant" */
  updateDomainParticipants?: Maybe<domainParticipantMutationResponse>;
  /** update single row of the table: "business.domain_type" */
  updateDomainType?: Maybe<domainType>;
  /** update data of the table: "business.domain_type" */
  updateDomainTypes?: Maybe<domainTypeMutationResponse>;
  /** update single row of the table: "business.domain_user" */
  updateDomainUser?: Maybe<domainUser>;
  /** update data of the table: "business.domain_user_category" */
  updateDomainUserCategories?: Maybe<domainUserCategoryMutationResponse>;
  /** update single row of the table: "business.domain_user_category" */
  updateDomainUserCategory?: Maybe<domainUserCategory>;
  /** update data of the table: "business.domain_user" */
  updateDomainUsers?: Maybe<domainUserMutationResponse>;
  /** update data of the table: "business.languages" */
  updateLanguages?: Maybe<languagesMutationResponse>;
  /** update single row of the table: "business.languages" */
  updateLanguagesByPk?: Maybe<languages>;
  /** update multiples rows of table: "business.languages" */
  updateLanguagesMany?: Maybe<Array<Maybe<languagesMutationResponse>>>;
  /** update multiples rows of table: "business.queue_item_participant" */
  updateManyActivityParticipants?: Maybe<Array<Maybe<activityParticipantMutationResponse>>>;
  /** update multiples rows of table: "business.activity_status" */
  updateManyActivityStatuses?: Maybe<Array<Maybe<ActivityStatusMutationResponse>>>;
  /** update multiples rows of table: "business.activity_type" */
  updateManyActivityTypes?: Maybe<Array<Maybe<ActivityTypeMutationResponse>>>;
  /** update multiples rows of table: "business.address" */
  updateManyAddresses?: Maybe<Array<Maybe<addressMutationResponse>>>;
  /** update multiples rows of table: "business.blocked_domain_user" */
  updateManyBlockedDomainUsers?: Maybe<Array<Maybe<blockedDomainUserMutationResponse>>>;
  /** update multiples rows of table: "business.queue_item_collaboration" */
  updateManyBusinessQueueItemCollaborations?: Maybe<Array<Maybe<businessQueueItemCollaborationMutationResponse>>>;
  /** update multiples rows of table: "business.user_contacts" */
  updateManyBusinessUserContacts?: Maybe<Array<Maybe<businessUserContactsMutationResponse>>>;
  /** update multiples rows of table: "business.user_settings" */
  updateManyBusinessUserSettings?: Maybe<Array<Maybe<businessUserSettingsMutationResponse>>>;
  /** update multiples rows of table: "business.domain_activity" */
  updateManyDomainActivities?: Maybe<Array<Maybe<domainActivityMutationResponse>>>;
  /** update multiples rows of table: "business.domain_organization" */
  updateManyDomainOrganizations?: Maybe<Array<Maybe<domainOrganizationMutationResponse>>>;
  /** update multiples rows of table: "business.domain_participant" */
  updateManyDomainParticipants?: Maybe<Array<Maybe<domainParticipantMutationResponse>>>;
  /** update multiples rows of table: "business.domain_type" */
  updateManyDomainTypes?: Maybe<Array<Maybe<domainTypeMutationResponse>>>;
  /** update multiples rows of table: "business.domain_user_category" */
  updateManyDomainUserCategories?: Maybe<Array<Maybe<domainUserCategoryMutationResponse>>>;
  /** update multiples rows of table: "business.domain_user" */
  updateManyDomainUsers?: Maybe<Array<Maybe<domainUserMutationResponse>>>;
  /** update multiples rows of table: "business.message_type" */
  updateManyMessageTypes?: Maybe<Array<Maybe<messageTypeMutationResponse>>>;
  /** update multiples rows of table: "business.message" */
  updateManyMessages?: Maybe<Array<Maybe<messageMutationResponse>>>;
  /** update multiples rows of table: "messaging.activity_organization" */
  updateManyMessagingActivityOrganizations?: Maybe<Array<Maybe<messagingActivityOrganizationMutationResponse>>>;
  /** update multiples rows of table: "notification.notification_send" */
  updateManyNotificationSends?: Maybe<Array<Maybe<notificationSendMutationResponse>>>;
  /** update multiples rows of table: "notification.notification_setting_activity" */
  updateManyNotificationSettingActivities?: Maybe<Array<Maybe<notificationSettingActivityMutationResponse>>>;
  /** update multiples rows of table: "notification.notification_user_devices" */
  updateManyNotificationUserDevices?: Maybe<Array<Maybe<notificationUserDeviceMutationResponse>>>;
  /** update multiples rows of table: "notification.notification_users" */
  updateManyNotificationUsers?: Maybe<Array<Maybe<notificationUserMutationResponse>>>;
  /** update multiples rows of table: "notification.notifications" */
  updateManyNotifications?: Maybe<Array<Maybe<notificationMutationResponse>>>;
  /** update multiples rows of table: "orders.integrations" */
  updateManyOrdersIntegrations?: Maybe<Array<Maybe<ordersIntegrationsMutationResponse>>>;
  /** update multiples rows of table: "business.organization_user_attachments" */
  updateManyOrganizationUserAttachments?: Maybe<Array<Maybe<organizationUserAttachmentsMutationResponse>>>;
  /** update multiples rows of table: "business.organization_user_attention_note" */
  updateManyOrganizationUserAttentionNotes?: Maybe<Array<Maybe<OrganizationUserAttentionNoteMutationResponse>>>;
  /** update multiples rows of table: "business.organization_user_details_type" */
  updateManyOrganizationUserDetailTypes?: Maybe<Array<Maybe<organizationUserDetailTypeMutationResponse>>>;
  /** update multiples rows of table: "business.organization_user_details" */
  updateManyOrganizationUserDetails?: Maybe<Array<Maybe<organizationUserDetailMutationResponse>>>;
  /** update multiples rows of table: "business.organization_user_invite" */
  updateManyOrganizationUserInvites?: Maybe<Array<Maybe<organizationUserInviteMutationResponse>>>;
  /** update multiples rows of table: "business.organization_user_status" */
  updateManyOrganizationUserStatuses?: Maybe<Array<Maybe<organizationUserStatusMutationResponse>>>;
  /** update multiples rows of table: "business.organization_user" */
  updateManyOrganizationUsers?: Maybe<Array<Maybe<organizationUserMutationResponse>>>;
  /** update multiples rows of table: "business.organizations" */
  updateManyOrganizations?: Maybe<Array<Maybe<organizationMutationResponse>>>;
  /** update multiples rows of table: "business.phone_number_verification_status" */
  updateManyPhoneNumberVerificationStatuses?: Maybe<Array<Maybe<phoneNumberVerificationStatusMutationResponse>>>;
  /** update multiples rows of table: "business.queue_item" */
  updateManyQueueItems?: Maybe<Array<Maybe<queueItemMutationResponse>>>;
  /** update multiples rows of table: "business.rel_organization_user_domain_user" */
  updateManyRelOrganizationUserDomainUsers?: Maybe<Array<Maybe<relOrganizationUserDomainUserMutationResponse>>>;
  /** update multiples rows of table: "business.user_details" */
  updateManyUserDetails?: Maybe<Array<Maybe<userDetailMutationResponse>>>;
  /** update multiples rows of table: "business.user_details_type" */
  updateManyUserDetailsTypes?: Maybe<Array<Maybe<userDetailsTypeMutationResponse>>>;
  /** update multiples rows of table: "business.user_devices" */
  updateManyUserDevices?: Maybe<Array<Maybe<userDeviceMutationResponse>>>;
  /** update multiples rows of table: "business.user_phone_numbers" */
  updateManyUserPhoneNumbers?: Maybe<Array<Maybe<userPhoneNumberMutationResponse>>>;
  /** update multiples rows of table: "business.user_role" */
  updateManyUserRoles?: Maybe<Array<Maybe<userRoleMutationResponse>>>;
  /** update multiples rows of table: "business.users" */
  updateManyUsers?: Maybe<Array<Maybe<userMutationResponse>>>;
  /** update single row of the table: "business.message" */
  updateMessage?: Maybe<message>;
  /** update single row of the table: "business.message_type" */
  updateMessageType?: Maybe<messageType>;
  /** update data of the table: "business.message_type" */
  updateMessageTypes?: Maybe<messageTypeMutationResponse>;
  /** update data of the table: "business.message" */
  updateMessages?: Maybe<messageMutationResponse>;
  /** update data of the table: "messaging.activity" */
  updateMessagingActivities?: Maybe<messagingActivityMutationResponse>;
  /** update single row of the table: "messaging.activity" */
  updateMessagingActivity?: Maybe<messagingActivity>;
  /** update multiples rows of table: "messaging.activity" */
  updateMessagingActivityMany?: Maybe<Array<Maybe<messagingActivityMutationResponse>>>;
  /** update single row of the table: "messaging.activity_organization" */
  updateMessagingActivityOrganization?: Maybe<messagingActivityOrganization>;
  /** update data of the table: "messaging.activity_organization" */
  updateMessagingActivityOrganizations?: Maybe<messagingActivityOrganizationMutationResponse>;
  /** update data of the table: "messaging.activitySettings" */
  updateMessagingActivitySettings?: Maybe<MessagingActivitySettingsMutationResponse>;
  /** update single row of the table: "messaging.activitySettings" */
  updateMessagingActivitySettingsByPk?: Maybe<MessagingActivitySettings>;
  /** update multiples rows of table: "messaging.activitySettings" */
  updateMessagingActivitySettingsMany?: Maybe<Array<Maybe<MessagingActivitySettingsMutationResponse>>>;
  /** update data of the table: "messaging.activitySettingsNotificationSettingType" */
  updateMessagingActivitySettingsNotificationSettingType?: Maybe<MessagingActivitySettingsNotificationSettingTypeMutationResponse>;
  /** update single row of the table: "messaging.activitySettingsNotificationSettingType" */
  updateMessagingActivitySettingsNotificationSettingTypeByPk?: Maybe<MessagingActivitySettingsNotificationSettingType>;
  /** update multiples rows of table: "messaging.activitySettingsNotificationSettingType" */
  updateMessagingActivitySettingsNotificationSettingTypeMany?: Maybe<Array<Maybe<MessagingActivitySettingsNotificationSettingTypeMutationResponse>>>;
  /** update single row of the table: "messaging.activity_type" */
  updateMessagingActivityType?: Maybe<messagingActivityType>;
  /** update multiples rows of table: "messaging.activity_type" */
  updateMessagingActivityTypeMany?: Maybe<Array<Maybe<messagingActivityTypeMutationResponse>>>;
  /** update data of the table: "messaging.activity_type" */
  updateMessagingActivityTypes?: Maybe<messagingActivityTypeMutationResponse>;
  /** update single row of the table: "messaging.activity_user" */
  updateMessagingActivityUser?: Maybe<messagingActivityUser>;
  /** update multiples rows of table: "messaging.activity_user" */
  updateMessagingActivityUserMany?: Maybe<Array<Maybe<messagingActivityUserMutationResponse>>>;
  /** update data of the table: "messaging.activity_user" */
  updateMessagingActivityUsers?: Maybe<messagingActivityUserMutationResponse>;
  /** update data of the table: "messaging.invitation" */
  updateMessagingInvitation?: Maybe<MessagingInvitationMutationResponse>;
  /** update single row of the table: "messaging.invitation" */
  updateMessagingInvitationByPk?: Maybe<MessagingInvitation>;
  /** update multiples rows of table: "messaging.invitation" */
  updateMessagingInvitationMany?: Maybe<Array<Maybe<MessagingInvitationMutationResponse>>>;
  /** update data of the table: "messaging.mentions" */
  updateMessagingMentions?: Maybe<MessagingMentionsMutationResponse>;
  /** update single row of the table: "messaging.mentions" */
  updateMessagingMentionsByPk?: Maybe<MessagingMentions>;
  /** update multiples rows of table: "messaging.mentions" */
  updateMessagingMentionsMany?: Maybe<Array<Maybe<MessagingMentionsMutationResponse>>>;
  /** update single row of the table: "messaging.message" */
  updateMessagingMessage?: Maybe<messagingMessage>;
  /** update data of the table: "messaging.message_attachment" */
  updateMessagingMessageAttachment?: Maybe<MessagingMessageAttachmentMutationResponse>;
  /** update single row of the table: "messaging.message_attachment" */
  updateMessagingMessageAttachmentByPk?: Maybe<MessagingMessageAttachment>;
  /** update multiples rows of table: "messaging.message_attachment" */
  updateMessagingMessageAttachmentMany?: Maybe<Array<Maybe<MessagingMessageAttachmentMutationResponse>>>;
  /** update data of the table: "messaging.message_attachment_type" */
  updateMessagingMessageAttachmentType?: Maybe<MessagingMessageAttachmentTypeMutationResponse>;
  /** update single row of the table: "messaging.message_attachment_type" */
  updateMessagingMessageAttachmentTypeByPk?: Maybe<MessagingMessageAttachmentType>;
  /** update multiples rows of table: "messaging.message_attachment_type" */
  updateMessagingMessageAttachmentTypeMany?: Maybe<Array<Maybe<MessagingMessageAttachmentTypeMutationResponse>>>;
  /** update single row of the table: "messaging.message_emoji" */
  updateMessagingMessageEmoji?: Maybe<messagingMessageEmoji>;
  /** update multiples rows of table: "messaging.message_emoji" */
  updateMessagingMessageEmojiMany?: Maybe<Array<Maybe<messagingMessageEmojiMutationResponse>>>;
  /** update data of the table: "messaging.message_emoji" */
  updateMessagingMessageEmojis?: Maybe<messagingMessageEmojiMutationResponse>;
  /** update multiples rows of table: "messaging.message" */
  updateMessagingMessageMany?: Maybe<Array<Maybe<messagingMessageMutationResponse>>>;
  /** update data of the table: "messaging.message_priority" */
  updateMessagingMessagePriority?: Maybe<MessagingMessagePriorityMutationResponse>;
  /** update single row of the table: "messaging.message_priority" */
  updateMessagingMessagePriorityByPk?: Maybe<MessagingMessagePriority>;
  /** update multiples rows of table: "messaging.message_priority" */
  updateMessagingMessagePriorityMany?: Maybe<Array<Maybe<MessagingMessagePriorityMutationResponse>>>;
  /** update single row of the table: "messaging.message_read" */
  updateMessagingMessageRead?: Maybe<messagingMessageRead>;
  /** update multiples rows of table: "messaging.message_read" */
  updateMessagingMessageReadMany?: Maybe<Array<Maybe<messagingMessageReadMutationResponse>>>;
  /** update data of the table: "messaging.message_read" */
  updateMessagingMessageReads?: Maybe<messagingMessageReadMutationResponse>;
  /** update single row of the table: "messaging.message_type" */
  updateMessagingMessageType?: Maybe<messagingMessageType>;
  /** update multiples rows of table: "messaging.message_type" */
  updateMessagingMessageTypeMany?: Maybe<Array<Maybe<messagingMessageTypeMutationResponse>>>;
  /** update data of the table: "messaging.message_type" */
  updateMessagingMessageTypes?: Maybe<messagingMessageTypeMutationResponse>;
  /** update data of the table: "messaging.message" */
  updateMessagingMessages?: Maybe<messagingMessageMutationResponse>;
  /** update single row of the table: "notification.notifications" */
  updateNotification?: Maybe<notification>;
  /** update data of the table: "notification.notification_device_sent" */
  updateNotificationNotificationDeviceSent?: Maybe<NotificationNotificationDeviceSentMutationResponse>;
  /** update single row of the table: "notification.notification_device_sent" */
  updateNotificationNotificationDeviceSentByPk?: Maybe<NotificationNotificationDeviceSent>;
  /** update multiples rows of table: "notification.notification_device_sent" */
  updateNotificationNotificationDeviceSentMany?: Maybe<Array<Maybe<NotificationNotificationDeviceSentMutationResponse>>>;
  /** update data of the table: "notification.notification_setting_activity_primary_enum" */
  updateNotificationNotificationSettingActivityPrimaryEnum?: Maybe<NotificationNotificationSettingActivityPrimaryEnumMutationResponse>;
  /** update single row of the table: "notification.notification_setting_activity_primary_enum" */
  updateNotificationNotificationSettingActivityPrimaryEnumByPk?: Maybe<NotificationNotificationSettingActivityPrimaryEnum>;
  /** update multiples rows of table: "notification.notification_setting_activity_primary_enum" */
  updateNotificationNotificationSettingActivityPrimaryEnumMany?: Maybe<Array<Maybe<NotificationNotificationSettingActivityPrimaryEnumMutationResponse>>>;
  /** update single row of the table: "notification.notification_send" */
  updateNotificationSend?: Maybe<notificationSend>;
  /** update data of the table: "notification.notification_send" */
  updateNotificationSends?: Maybe<notificationSendMutationResponse>;
  /** update data of the table: "notification.notification_setting_activity" */
  updateNotificationSettingActivities?: Maybe<notificationSettingActivityMutationResponse>;
  /** update single row of the table: "notification.notification_setting_activity" */
  updateNotificationSettingActivity?: Maybe<notificationSettingActivity>;
  /** update single row of the table: "notification.notification_users" */
  updateNotificationUser?: Maybe<notificationUser>;
  /** update single row of the table: "notification.notification_user_devices" */
  updateNotificationUserDevice?: Maybe<notificationUserDevice>;
  /** update data of the table: "notification.notification_user_devices" */
  updateNotificationUserDevices?: Maybe<notificationUserDeviceMutationResponse>;
  /** update data of the table: "notification.notification_users" */
  updateNotificationUsers?: Maybe<notificationUserMutationResponse>;
  /** update data of the table: "notification.notifications" */
  updateNotifications?: Maybe<notificationMutationResponse>;
  /** update single row of the table: "orders.integrations" */
  updateOrdersIntegration?: Maybe<ordersIntegrations>;
  /** update data of the table: "orders.integrations" */
  updateOrdersIntegrations?: Maybe<ordersIntegrationsMutationResponse>;
  /** update data of the table: "orders.organizations" */
  updateOrdersOrganizations?: Maybe<OrdersOrganizationsMutationResponse>;
  /** update single row of the table: "orders.organizations" */
  updateOrdersOrganizationsByPk?: Maybe<OrdersOrganizations>;
  /** update multiples rows of table: "orders.organizations" */
  updateOrdersOrganizationsMany?: Maybe<Array<Maybe<OrdersOrganizationsMutationResponse>>>;
  /** update data of the table: "orders.request" */
  updateOrdersRequest?: Maybe<OrdersRequestMutationResponse>;
  /** update single row of the table: "orders.request" */
  updateOrdersRequestByPk?: Maybe<OrdersRequest>;
  /** update multiples rows of table: "orders.request" */
  updateOrdersRequestMany?: Maybe<Array<Maybe<OrdersRequestMutationResponse>>>;
  /** update data of the table: "orders.status" */
  updateOrdersStatus?: Maybe<OrdersStatusMutationResponse>;
  /** update single row of the table: "orders.status" */
  updateOrdersStatusByPk?: Maybe<OrdersStatus>;
  /** update multiples rows of table: "orders.status" */
  updateOrdersStatusMany?: Maybe<Array<Maybe<OrdersStatusMutationResponse>>>;
  /** update data of the table: "orders.type" */
  updateOrdersType?: Maybe<OrdersTypeMutationResponse>;
  /** update single row of the table: "orders.type" */
  updateOrdersTypeByPk?: Maybe<OrdersType>;
  /** update multiples rows of table: "orders.type" */
  updateOrdersTypeMany?: Maybe<Array<Maybe<OrdersTypeMutationResponse>>>;
  /** update single row of the table: "business.organizations" */
  updateOrganization?: Maybe<organization>;
  /** update single row of the table: "business.authorization_enum_group" */
  updateOrganizationAuthorizationEnumGroup?: Maybe<organizationAuthorizationEnumGroup>;
  /** update multiples rows of table: "business.authorization_enum_group" */
  updateOrganizationAuthorizationEnumGroupMany?: Maybe<Array<Maybe<organizationAuthorizationEnumGroupMutationResponse>>>;
  /** update data of the table: "business.authorization_enum_group" */
  updateOrganizationAuthorizationEnumGroups?: Maybe<organizationAuthorizationEnumGroupMutationResponse>;
  /** update single row of the table: "business.authorization_group" */
  updateOrganizationAuthorizationGroup?: Maybe<organizationAuthorizationGroup>;
  /** update multiples rows of table: "business.authorization_group" */
  updateOrganizationAuthorizationGroupMany?: Maybe<Array<Maybe<organizationAuthorizationGroupMutationResponse>>>;
  /** update data of the table: "business.authorization_group" */
  updateOrganizationAuthorizationGroups?: Maybe<organizationAuthorizationGroupMutationResponse>;
  /** update single row of the table: "business.organization_relationship" */
  updateOrganizationOrganizationRelationship?: Maybe<organizationOrganizationRelationship>;
  /** update data of the table: "business.organization_relationship_category" */
  updateOrganizationOrganizationRelationshipCategories?: Maybe<organizationOrganizationRelationshipCategoryMutationResponse>;
  /** update single row of the table: "business.organization_relationship_category" */
  updateOrganizationOrganizationRelationshipCategory?: Maybe<organizationOrganizationRelationshipCategory>;
  /** update multiples rows of table: "business.organization_relationship_category" */
  updateOrganizationOrganizationRelationshipCategoryMany?: Maybe<Array<Maybe<organizationOrganizationRelationshipCategoryMutationResponse>>>;
  /** update multiples rows of table: "business.organization_relationship" */
  updateOrganizationOrganizationRelationshipMany?: Maybe<Array<Maybe<organizationOrganizationRelationshipMutationResponse>>>;
  /** update data of the table: "business.organization_relationship" */
  updateOrganizationOrganizationRelationships?: Maybe<organizationOrganizationRelationshipMutationResponse>;
  /** update single row of the table: "business.organization_user_authorization" */
  updateOrganizationOrganizationUserAuthorization?: Maybe<organizationOrganizationUserAuthorization>;
  /** update multiples rows of table: "business.organization_user_authorization" */
  updateOrganizationOrganizationUserAuthorizationMany?: Maybe<Array<Maybe<organizationOrganizationUserAuthorizationMutationResponse>>>;
  /** update data of the table: "business.organization_user_authorization" */
  updateOrganizationOrganizationUserAuthorizations?: Maybe<organizationOrganizationUserAuthorizationMutationResponse>;
  /** update single row of the table: "business.organization_user" */
  updateOrganizationUser?: Maybe<organizationUser>;
  /** update single row of the table: "business.organization_user_attachments" */
  updateOrganizationUserAttachment?: Maybe<organizationUserAttachments>;
  /** update data of the table: "business.organization_user_attachments" */
  updateOrganizationUserAttachments?: Maybe<organizationUserAttachmentsMutationResponse>;
  /** update single row of the table: "business.organization_user_attention_note" */
  updateOrganizationUserAttentionNote?: Maybe<OrganizationUserAttentionNote>;
  /** update data of the table: "business.organization_user_attention_note" */
  updateOrganizationUserAttentionNotes?: Maybe<OrganizationUserAttentionNoteMutationResponse>;
  /** update single row of the table: "business.user_authorization" */
  updateOrganizationUserAuthorization?: Maybe<organizationUserAuthorization>;
  /** update multiples rows of table: "business.user_authorization" */
  updateOrganizationUserAuthorizationMany?: Maybe<Array<Maybe<organizationUserAuthorizationMutationResponse>>>;
  /** update data of the table: "business.user_authorization" */
  updateOrganizationUserAuthorizations?: Maybe<organizationUserAuthorizationMutationResponse>;
  /** update single row of the table: "business.organization_user_details" */
  updateOrganizationUserDetail?: Maybe<organizationUserDetail>;
  /** update single row of the table: "business.organization_user_details_type" */
  updateOrganizationUserDetailType?: Maybe<organizationUserDetailType>;
  /** update data of the table: "business.organization_user_details_type" */
  updateOrganizationUserDetailTypes?: Maybe<organizationUserDetailTypeMutationResponse>;
  /** update data of the table: "business.organization_user_details" */
  updateOrganizationUserDetails?: Maybe<organizationUserDetailMutationResponse>;
  /** update single row of the table: "business.organization_user_invite" */
  updateOrganizationUserInvite?: Maybe<organizationUserInvite>;
  /** update data of the table: "business.organization_user_invite" */
  updateOrganizationUserInvites?: Maybe<organizationUserInviteMutationResponse>;
  /** update single row of the table: "business.organization_user_request" */
  updateOrganizationUserRequest?: Maybe<BusinessOrganizationUserRequest>;
  /** update data of the table: "business.organization_user_request" */
  updateOrganizationUserRequests?: Maybe<BusinessOrganizationUserRequestMutationResponse>;
  /** update single row of the table: "business.organization_user_status" */
  updateOrganizationUserStatus?: Maybe<organizationUserStatus>;
  /** update data of the table: "business.organization_user_status" */
  updateOrganizationUserStatuses?: Maybe<organizationUserStatusMutationResponse>;
  /** update data of the table: "business.organization_user" */
  updateOrganizationUsers?: Maybe<organizationUserMutationResponse>;
  /** update data of the table: "business.organizations" */
  updateOrganizations?: Maybe<organizationMutationResponse>;
  /** update single row of the table: "business.phone_number_verification_status" */
  updatePhoneNumberVerificationStatus?: Maybe<phoneNumberVerificationStatus>;
  /** update data of the table: "business.phone_number_verification_status" */
  updatePhoneNumberVerificationStatuses?: Maybe<phoneNumberVerificationStatusMutationResponse>;
  /** update data of the table: "prompt" */
  updatePrompt?: Maybe<PromptMutationResponse>;
  /** update single row of the table: "prompt" */
  updatePromptByPk?: Maybe<Prompt>;
  /** update multiples rows of table: "prompt" */
  updatePromptMany?: Maybe<Array<Maybe<PromptMutationResponse>>>;
  /** update single row of the table: "devices" */
  updatePublicDevice?: Maybe<publicDevice>;
  /** update multiples rows of table: "devices" */
  updatePublicDeviceMany?: Maybe<Array<Maybe<publicDeviceMutationResponse>>>;
  /** update data of the table: "devices" */
  updatePublicDevices?: Maybe<publicDeviceMutationResponse>;
  /** update single row of the table: "external_requests" */
  updatePublicExternalRequest?: Maybe<publicExternalRequest>;
  /** update multiples rows of table: "external_requests" */
  updatePublicExternalRequestMany?: Maybe<Array<Maybe<publicExternalRequestMutationResponse>>>;
  /** update data of the table: "external_requests" */
  updatePublicExternalRequests?: Maybe<publicExternalRequestMutationResponse>;
  /** update single row of the table: "files" */
  updatePublicFile?: Maybe<publicFile>;
  /** update multiples rows of table: "files" */
  updatePublicFileMany?: Maybe<Array<Maybe<publicFileMutationResponse>>>;
  /** update data of the table: "files" */
  updatePublicFiles?: Maybe<publicFileMutationResponse>;
  /** update single row of the table: "notifications" */
  updatePublicNotification?: Maybe<publicNotification>;
  /** update multiples rows of table: "notifications" */
  updatePublicNotificationMany?: Maybe<Array<Maybe<publicNotificationMutationResponse>>>;
  /** update data of the table: "notifications" */
  updatePublicNotifications?: Maybe<publicNotificationMutationResponse>;
  /** update single row of the table: "business.queue_item" */
  updateQueueItem?: Maybe<queueItem>;
  /** update data of the table: "business.queue_item_flexibility_type" */
  updateQueueItemFlexibilityType?: Maybe<QueueItemFlexibilityTypeMutationResponse>;
  /** update single row of the table: "business.queue_item_flexibility_type" */
  updateQueueItemFlexibilityTypeByPk?: Maybe<QueueItemFlexibilityType>;
  /** update multiples rows of table: "business.queue_item_flexibility_type" */
  updateQueueItemFlexibilityTypeMany?: Maybe<Array<Maybe<QueueItemFlexibilityTypeMutationResponse>>>;
  /** update data of the table: "business.queue_item_participant_responsibiliy_type" */
  updateQueueItemParticipantResponsibilityType?: Maybe<QueueItemParticipantResponsibilityTypeMutationResponse>;
  /** update single row of the table: "business.queue_item_participant_responsibiliy_type" */
  updateQueueItemParticipantResponsibilityTypeByPk?: Maybe<QueueItemParticipantResponsibilityType>;
  /** update multiples rows of table: "business.queue_item_participant_responsibiliy_type" */
  updateQueueItemParticipantResponsibilityTypeMany?: Maybe<Array<Maybe<QueueItemParticipantResponsibilityTypeMutationResponse>>>;
  /** update data of the table: "business.queue_item" */
  updateQueueItems?: Maybe<queueItemMutationResponse>;
  /** update single row of the table: "business.rel_organization_user_domain_user" */
  updateRelOrganizationUserDomainUser?: Maybe<relOrganizationUserDomainUser>;
  /** update data of the table: "business.rel_organization_user_domain_user" */
  updateRelOrganizationUserDomainUsers?: Maybe<relOrganizationUserDomainUserMutationResponse>;
  /** update data of the table: "business.relation_type" */
  updateRelationType?: Maybe<RelationTypeMutationResponse>;
  /** update single row of the table: "business.relation_type" */
  updateRelationTypeByPk?: Maybe<RelationType>;
  /** update multiples rows of table: "business.relation_type" */
  updateRelationTypeMany?: Maybe<Array<Maybe<RelationTypeMutationResponse>>>;
  /** update single row of the table: "sms.connectors" */
  updateSmsConnector?: Maybe<smsConnector>;
  /** update multiples rows of table: "sms.connectors" */
  updateSmsConnectorMany?: Maybe<Array<Maybe<smsConnectorMutationResponse>>>;
  /** update data of the table: "sms.connectors" */
  updateSmsConnectors?: Maybe<smsConnectorMutationResponse>;
  /** update single row of the table: "sms.gates" */
  updateSmsGate?: Maybe<smsGate>;
  /** update multiples rows of table: "sms.gates" */
  updateSmsGateMany?: Maybe<Array<Maybe<smsGateMutationResponse>>>;
  /** update data of the table: "sms.gates" */
  updateSmsGates?: Maybe<smsGateMutationResponse>;
  /** update single row of the table: "sms.link_mobility_sms_content" */
  updateSmsLinkMobilitySmsContent?: Maybe<smsLinkMobilitySmsContent>;
  /** update multiples rows of table: "sms.link_mobility_sms_content" */
  updateSmsLinkMobilitySmsContentMany?: Maybe<Array<Maybe<smsLinkMobilitySmsContentMutationResponse>>>;
  /** update data of the table: "sms.link_mobility_sms_content" */
  updateSmsLinkMobilitySmsContents?: Maybe<smsLinkMobilitySmsContentMutationResponse>;
  /** update single row of the table: "sms.link_mobility_sms_message" */
  updateSmsLinkMobilitySmsMessage?: Maybe<smsLinkMobilitySmsMessage>;
  /** update multiples rows of table: "sms.link_mobility_sms_message" */
  updateSmsLinkMobilitySmsMessageMany?: Maybe<Array<Maybe<smsLinkMobilitySmsMessageMutationResponse>>>;
  /** update data of the table: "sms.link_mobility_sms_message" */
  updateSmsLinkMobilitySmsMessages?: Maybe<smsLinkMobilitySmsMessageMutationResponse>;
  /** update single row of the table: "sms.link_mobility_sms_route" */
  updateSmsLinkMobilitySmsRoute?: Maybe<smsLinkMobilitySmsRoute>;
  /** update multiples rows of table: "sms.link_mobility_sms_route" */
  updateSmsLinkMobilitySmsRouteMany?: Maybe<Array<Maybe<smsLinkMobilitySmsRouteMutationResponse>>>;
  /** update data of the table: "sms.link_mobility_sms_route" */
  updateSmsLinkMobilitySmsRoutes?: Maybe<smsLinkMobilitySmsRouteMutationResponse>;
  /** update single row of the table: "sms.providers" */
  updateSmsProvider?: Maybe<smsProvider>;
  /** update multiples rows of table: "sms.providers" */
  updateSmsProviderMany?: Maybe<Array<Maybe<smsProviderMutationResponse>>>;
  /** update data of the table: "sms.providers" */
  updateSmsProviders?: Maybe<smsProviderMutationResponse>;
  /** update single row of the table: "sms.sms" */
  updateSmsSm?: Maybe<smsSm>;
  /** update multiples rows of table: "sms.sms" */
  updateSmsSmMany?: Maybe<Array<Maybe<smsSmMutationResponse>>>;
  /** update data of the table: "sms.sms" */
  updateSmsSms?: Maybe<smsSmMutationResponse>;
  /** update data of the table: "sms.sms_external_incoming_link_mobility" */
  updateSmsSmsExternalIncomingLinkMobilities?: Maybe<smsSmsExternalIncomingLinkMobilityMutationResponse>;
  /** update single row of the table: "sms.sms_external_incoming_link_mobility" */
  updateSmsSmsExternalIncomingLinkMobility?: Maybe<smsSmsExternalIncomingLinkMobility>;
  /** update multiples rows of table: "sms.sms_external_incoming_link_mobility" */
  updateSmsSmsExternalIncomingLinkMobilityMany?: Maybe<Array<Maybe<smsSmsExternalIncomingLinkMobilityMutationResponse>>>;
  /** update single row of the table: "business.users" */
  updateUser?: Maybe<user>;
  /** update single row of the table: "business.user_details" */
  updateUserDetail?: Maybe<userDetail>;
  /** update data of the table: "business.user_details" */
  updateUserDetails?: Maybe<userDetailMutationResponse>;
  /** update single row of the table: "business.user_details_type" */
  updateUserDetailsType?: Maybe<userDetailsType>;
  /** update data of the table: "business.user_details_type" */
  updateUserDetailsTypes?: Maybe<userDetailsTypeMutationResponse>;
  /** update single row of the table: "business.user_devices" */
  updateUserDevice?: Maybe<userDevice>;
  /** update data of the table: "business.user_devices" */
  updateUserDevices?: Maybe<userDeviceMutationResponse>;
  /** update single row of the table: "business.user_phone_numbers" */
  updateUserPhoneNumber?: Maybe<userPhoneNumber>;
  /** update data of the table: "business.user_phone_numbers" */
  updateUserPhoneNumbers?: Maybe<userPhoneNumberMutationResponse>;
  /** update single row of the table: "business.user_role" */
  updateUserRole?: Maybe<userRole>;
  /** update data of the table: "business.user_role" */
  updateUserRoles?: Maybe<userRoleMutationResponse>;
  /** update data of the table: "business.users" */
  updateUsers?: Maybe<userMutationResponse>;
  /** update single row of the table: "validation.validation" */
  updateValidationValidation?: Maybe<validationValidation>;
  /** update multiples rows of table: "validation.validation" */
  updateValidationValidationMany?: Maybe<Array<Maybe<validationValidationMutationResponse>>>;
  /** update data of the table: "validation.validation" */
  updateValidationValidations?: Maybe<validationValidationMutationResponse>;
  /** update data of the table: "voice_types" */
  updateVoiceTypes?: Maybe<VoiceTypesMutationResponse>;
  /** update single row of the table: "voice_types" */
  updateVoiceTypesByPk?: Maybe<VoiceTypes>;
  /** update multiples rows of table: "voice_types" */
  updateVoiceTypesMany?: Maybe<Array<Maybe<VoiceTypesMutationResponse>>>;
  userDelete?: Maybe<userDeleteOutput>;
  userUpdate?: Maybe<UserUpdateOutput>;
  /** Used by Telia, Phonero employees to verify credentials agains organizations. */
  validateTelephonyCredentialsToOrg?: Maybe<TelephonyCredentialsOutput>;
  verifyOrganizationUserPhoneNumber?: Maybe<verifyOrganizationUserPhoneNumberOutput>;
};


/** mutation root */
export type mutation_rootacceptInviteToOrganizationArgs = {
  input: acceptInviteObject;
};


/** mutation root */
export type mutation_rootacceptRequestToOrganizationArgs = {
  input: acceptRequestObject;
};


/** mutation root */
export type mutation_rootaddDomainUserToOrganizationArgs = {
  domainUserId: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootaddEmailProviderIntegrationArgs = {
  integration: createEmailProviderIntegrationInput;
};


/** mutation root */
export type mutation_rootaddEmailProviderSubscriptionArgs = {
  integration: createEmailProviderSubscriptionInput;
};


/** mutation root */
export type mutation_rootblockDomainUserArgs = {
  blockedDomainUserId: Scalars['uuid']['input'];
  domainUserId: Scalars['uuid']['input'];
  lightlyBlocked?: InputMaybe<Scalars['Boolean']['input']>;
};


/** mutation root */
export type mutation_rootcallBackLaterArgs = {
  createAutomaticSMS?: InputMaybe<Scalars['Boolean']['input']>;
  createCallbackTask?: InputMaybe<Scalars['Boolean']['input']>;
  createReminder?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['uuid']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type mutation_rootchangeOrganizationNameArgs = {
  params: ChangeOrganizationNameInput;
};


/** mutation root */
export type mutation_rootcheckOneTimeCodeArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};


/** mutation root */
export type mutation_rootcheckPhoneNumberArgs = {
  country: Scalars['String']['input'];
  nr?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type mutation_rootcheckTelephonyIdArgs = {
  orgId: Scalars['uuid']['input'];
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerType?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type mutation_rootcreateActivityParticipantArgs = {
  object: activityParticipantInsertInput;
  onConflict?: InputMaybe<activityParticipantOnConflict>;
};


/** mutation root */
export type mutation_rootcreateActivityParticipantsArgs = {
  objects: Array<activityParticipantInsertInput>;
  onConflict?: InputMaybe<activityParticipantOnConflict>;
};


/** mutation root */
export type mutation_rootcreateActivityStatusArgs = {
  object: ActivityStatusInsertInput;
  onConflict?: InputMaybe<ActivityStatusOnConflict>;
};


/** mutation root */
export type mutation_rootcreateActivityStatusesArgs = {
  objects: Array<ActivityStatusInsertInput>;
  onConflict?: InputMaybe<ActivityStatusOnConflict>;
};


/** mutation root */
export type mutation_rootcreateActivityTaskArgs = {
  input: activityTaskInput;
};


/** mutation root */
export type mutation_rootcreateActivityTypeArgs = {
  object: ActivityTypeInsertInput;
  onConflict?: InputMaybe<ActivityTypeOnConflict>;
};


/** mutation root */
export type mutation_rootcreateActivityTypesArgs = {
  objects: Array<ActivityTypeInsertInput>;
  onConflict?: InputMaybe<ActivityTypeOnConflict>;
};


/** mutation root */
export type mutation_rootcreateAddressArgs = {
  object: addressInsertInput;
  onConflict?: InputMaybe<addressOnConflict>;
};


/** mutation root */
export type mutation_rootcreateAddressesArgs = {
  objects: Array<addressInsertInput>;
  onConflict?: InputMaybe<addressOnConflict>;
};


/** mutation root */
export type mutation_rootcreateBlockedDomainUserArgs = {
  object: blockedDomainUserInsertInput;
  onConflict?: InputMaybe<blockedDomainUserOnConflict>;
};


/** mutation root */
export type mutation_rootcreateBlockedDomainUsersArgs = {
  objects: Array<blockedDomainUserInsertInput>;
  onConflict?: InputMaybe<blockedDomainUserOnConflict>;
};


/** mutation root */
export type mutation_rootcreateBusinessQueueItemCollaborationArgs = {
  object: businessQueueItemCollaborationInsertInput;
  onConflict?: InputMaybe<businessQueueItemCollaborationOnConflict>;
};


/** mutation root */
export type mutation_rootcreateBusinessQueueItemCollaborationsArgs = {
  objects: Array<businessQueueItemCollaborationInsertInput>;
  onConflict?: InputMaybe<businessQueueItemCollaborationOnConflict>;
};


/** mutation root */
export type mutation_rootcreateBusinessUserContactArgs = {
  object: businessUserContactsInsertInput;
  onConflict?: InputMaybe<businessUserContactsOnConflict>;
};


/** mutation root */
export type mutation_rootcreateBusinessUserContactsArgs = {
  objects: Array<businessUserContactsInsertInput>;
  onConflict?: InputMaybe<businessUserContactsOnConflict>;
};


/** mutation root */
export type mutation_rootcreateBusinessUserSettingArgs = {
  object: businessUserSettingsInsertInput;
  onConflict?: InputMaybe<businessUserSettingsOnConflict>;
};


/** mutation root */
export type mutation_rootcreateBusinessUserSettingsArgs = {
  objects: Array<businessUserSettingsInsertInput>;
  onConflict?: InputMaybe<businessUserSettingsOnConflict>;
};


/** mutation root */
export type mutation_rootcreateCrmStatusMessageArgs = {
  object: crmStatusMessageInsertInput;
  onConflict?: InputMaybe<crmStatusMessageOnConflict>;
};


/** mutation root */
export type mutation_rootcreateCrmStatusMessagesArgs = {
  objects: Array<crmStatusMessageInsertInput>;
  onConflict?: InputMaybe<crmStatusMessageOnConflict>;
};


/** mutation root */
export type mutation_rootcreateCrmYoutelloCatalystIdMappingArgs = {
  object: crmYoutelloCatalystIdMappingInsertInput;
  onConflict?: InputMaybe<crmYoutelloCatalystIdMappingOnConflict>;
};


/** mutation root */
export type mutation_rootcreateCrmYoutelloCatalystIdMappingsArgs = {
  objects: Array<crmYoutelloCatalystIdMappingInsertInput>;
  onConflict?: InputMaybe<crmYoutelloCatalystIdMappingOnConflict>;
};


/** mutation root */
export type mutation_rootcreateDomainActivitiesArgs = {
  objects: Array<domainActivityInsertInput>;
  onConflict?: InputMaybe<domainActivityOnConflict>;
};


/** mutation root */
export type mutation_rootcreateDomainActivityArgs = {
  object: domainActivityInsertInput;
  onConflict?: InputMaybe<domainActivityOnConflict>;
};


/** mutation root */
export type mutation_rootcreateDomainOrganizationArgs = {
  object: domainOrganizationInsertInput;
  onConflict?: InputMaybe<domainOrganizationOnConflict>;
};


/** mutation root */
export type mutation_rootcreateDomainOrganizationsArgs = {
  objects: Array<domainOrganizationInsertInput>;
  onConflict?: InputMaybe<domainOrganizationOnConflict>;
};


/** mutation root */
export type mutation_rootcreateDomainParticipantArgs = {
  object: domainParticipantInsertInput;
  onConflict?: InputMaybe<domainParticipantOnConflict>;
};


/** mutation root */
export type mutation_rootcreateDomainParticipantsArgs = {
  objects: Array<domainParticipantInsertInput>;
  onConflict?: InputMaybe<domainParticipantOnConflict>;
};


/** mutation root */
export type mutation_rootcreateDomainTypeArgs = {
  object: domainTypeInsertInput;
  onConflict?: InputMaybe<domainTypeOnConflict>;
};


/** mutation root */
export type mutation_rootcreateDomainTypesArgs = {
  objects: Array<domainTypeInsertInput>;
  onConflict?: InputMaybe<domainTypeOnConflict>;
};


/** mutation root */
export type mutation_rootcreateDomainUserArgs = {
  object: domainUserInsertInput;
  onConflict?: InputMaybe<domainUserOnConflict>;
};


/** mutation root */
export type mutation_rootcreateDomainUserCategoriesArgs = {
  objects: Array<domainUserCategoryInsertInput>;
  onConflict?: InputMaybe<domainUserCategoryOnConflict>;
};


/** mutation root */
export type mutation_rootcreateDomainUserCategoryArgs = {
  object: domainUserCategoryInsertInput;
  onConflict?: InputMaybe<domainUserCategoryOnConflict>;
};


/** mutation root */
export type mutation_rootcreateDomainUsersArgs = {
  objects: Array<domainUserInsertInput>;
  onConflict?: InputMaybe<domainUserOnConflict>;
};


/** mutation root */
export type mutation_rootcreateInviteToOrganizationArgs = {
  input: inviteObject;
};


/** mutation root */
export type mutation_rootcreateMessageArgs = {
  object: messageInsertInput;
  onConflict?: InputMaybe<messageOnConflict>;
};


/** mutation root */
export type mutation_rootcreateMessageTypeArgs = {
  object: messageTypeInsertInput;
  onConflict?: InputMaybe<messageTypeOnConflict>;
};


/** mutation root */
export type mutation_rootcreateMessageTypesArgs = {
  objects: Array<messageTypeInsertInput>;
  onConflict?: InputMaybe<messageTypeOnConflict>;
};


/** mutation root */
export type mutation_rootcreateMessagesArgs = {
  objects: Array<messageInsertInput>;
  onConflict?: InputMaybe<messageOnConflict>;
};


/** mutation root */
export type mutation_rootcreateMessagingActivitiesArgs = {
  objects: Array<messagingActivityInsertInput>;
  onConflict?: InputMaybe<messagingActivityOnConflict>;
};


/** mutation root */
export type mutation_rootcreateMessagingActivityArgs = {
  object: messagingActivityInsertInput;
  onConflict?: InputMaybe<messagingActivityOnConflict>;
};


/** mutation root */
export type mutation_rootcreateMessagingActivityOrganizationArgs = {
  object: messagingActivityOrganizationInsertInput;
  onConflict?: InputMaybe<messagingActivityOrganizationOnConflict>;
};


/** mutation root */
export type mutation_rootcreateMessagingActivityOrganizationsArgs = {
  objects: Array<messagingActivityOrganizationInsertInput>;
  onConflict?: InputMaybe<messagingActivityOrganizationOnConflict>;
};


/** mutation root */
export type mutation_rootcreateMessagingActivityTypeArgs = {
  object: messagingActivityTypeInsertInput;
  onConflict?: InputMaybe<messagingActivityTypeOnConflict>;
};


/** mutation root */
export type mutation_rootcreateMessagingActivityTypesArgs = {
  objects: Array<messagingActivityTypeInsertInput>;
  onConflict?: InputMaybe<messagingActivityTypeOnConflict>;
};


/** mutation root */
export type mutation_rootcreateMessagingActivityUserArgs = {
  object: messagingActivityUserInsertInput;
  onConflict?: InputMaybe<messagingActivityUserOnConflict>;
};


/** mutation root */
export type mutation_rootcreateMessagingActivityUsersArgs = {
  objects: Array<messagingActivityUserInsertInput>;
  onConflict?: InputMaybe<messagingActivityUserOnConflict>;
};


/** mutation root */
export type mutation_rootcreateMessagingGroupArgs = {
  members: Array<InputMaybe<Scalars['uuid']['input']>>;
  roomName: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootcreateMessagingMessageArgs = {
  object: messagingMessageInsertInput;
  onConflict?: InputMaybe<messagingMessageOnConflict>;
};


/** mutation root */
export type mutation_rootcreateMessagingMessageEmojiArgs = {
  object: messagingMessageEmojiInsertInput;
  onConflict?: InputMaybe<messagingMessageEmojiOnConflict>;
};


/** mutation root */
export type mutation_rootcreateMessagingMessageEmojisArgs = {
  objects: Array<messagingMessageEmojiInsertInput>;
  onConflict?: InputMaybe<messagingMessageEmojiOnConflict>;
};


/** mutation root */
export type mutation_rootcreateMessagingMessageReadArgs = {
  object: messagingMessageReadInsertInput;
  onConflict?: InputMaybe<messagingMessageReadOnConflict>;
};


/** mutation root */
export type mutation_rootcreateMessagingMessageReadsArgs = {
  objects: Array<messagingMessageReadInsertInput>;
  onConflict?: InputMaybe<messagingMessageReadOnConflict>;
};


/** mutation root */
export type mutation_rootcreateMessagingMessageTypeArgs = {
  object: messagingMessageTypeInsertInput;
  onConflict?: InputMaybe<messagingMessageTypeOnConflict>;
};


/** mutation root */
export type mutation_rootcreateMessagingMessageTypesArgs = {
  objects: Array<messagingMessageTypeInsertInput>;
  onConflict?: InputMaybe<messagingMessageTypeOnConflict>;
};


/** mutation root */
export type mutation_rootcreateMessagingMessagesArgs = {
  objects: Array<messagingMessageInsertInput>;
  onConflict?: InputMaybe<messagingMessageOnConflict>;
};


/** mutation root */
export type mutation_rootcreateNotificationArgs = {
  object: notificationInsertInput;
  onConflict?: InputMaybe<notificationOnConflict>;
};


/** mutation root */
export type mutation_rootcreateNotificationSendArgs = {
  object: notificationSendInsertInput;
  onConflict?: InputMaybe<notificationSendOnConflict>;
};


/** mutation root */
export type mutation_rootcreateNotificationSendsArgs = {
  objects: Array<notificationSendInsertInput>;
  onConflict?: InputMaybe<notificationSendOnConflict>;
};


/** mutation root */
export type mutation_rootcreateNotificationSettingActivitiesArgs = {
  objects: Array<notificationSettingActivityInsertInput>;
  onConflict?: InputMaybe<notificationSettingActivityOnConflict>;
};


/** mutation root */
export type mutation_rootcreateNotificationSettingActivityArgs = {
  object: notificationSettingActivityInsertInput;
  onConflict?: InputMaybe<notificationSettingActivityOnConflict>;
};


/** mutation root */
export type mutation_rootcreateNotificationUserArgs = {
  object: notificationUserInsertInput;
  onConflict?: InputMaybe<notificationUserOnConflict>;
};


/** mutation root */
export type mutation_rootcreateNotificationUserDeviceArgs = {
  object: notificationUserDeviceInsertInput;
  onConflict?: InputMaybe<notificationUserDeviceOnConflict>;
};


/** mutation root */
export type mutation_rootcreateNotificationUserDevicesArgs = {
  objects: Array<notificationUserDeviceInsertInput>;
  onConflict?: InputMaybe<notificationUserDeviceOnConflict>;
};


/** mutation root */
export type mutation_rootcreateNotificationUsersArgs = {
  objects: Array<notificationUserInsertInput>;
  onConflict?: InputMaybe<notificationUserOnConflict>;
};


/** mutation root */
export type mutation_rootcreateNotificationsArgs = {
  objects: Array<notificationInsertInput>;
  onConflict?: InputMaybe<notificationOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrdersIntegrationArgs = {
  object: ordersIntegrationsInsertInput;
  onConflict?: InputMaybe<ordersIntegrationsOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrdersIntegrationsArgs = {
  objects: Array<ordersIntegrationsInsertInput>;
  onConflict?: InputMaybe<ordersIntegrationsOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationArgs = {
  object: organizationInsertInput;
  onConflict?: InputMaybe<organizationOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationAuthorizationEnumGroupArgs = {
  object: organizationAuthorizationEnumGroupInsertInput;
  onConflict?: InputMaybe<organizationAuthorizationEnumGroupOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationAuthorizationEnumGroupsArgs = {
  objects: Array<organizationAuthorizationEnumGroupInsertInput>;
  onConflict?: InputMaybe<organizationAuthorizationEnumGroupOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationAuthorizationGroupArgs = {
  object: organizationAuthorizationGroupInsertInput;
  onConflict?: InputMaybe<organizationAuthorizationGroupOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationAuthorizationGroupsArgs = {
  objects: Array<organizationAuthorizationGroupInsertInput>;
  onConflict?: InputMaybe<organizationAuthorizationGroupOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationOrganizationRelationshipArgs = {
  object: organizationOrganizationRelationshipInsertInput;
  onConflict?: InputMaybe<organizationOrganizationRelationshipOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationOrganizationRelationshipCategoriesArgs = {
  objects: Array<organizationOrganizationRelationshipCategoryInsertInput>;
  onConflict?: InputMaybe<organizationOrganizationRelationshipCategoryOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationOrganizationRelationshipCategoryArgs = {
  object: organizationOrganizationRelationshipCategoryInsertInput;
  onConflict?: InputMaybe<organizationOrganizationRelationshipCategoryOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationOrganizationRelationshipsArgs = {
  objects: Array<organizationOrganizationRelationshipInsertInput>;
  onConflict?: InputMaybe<organizationOrganizationRelationshipOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationOrganizationUserAuthorizationArgs = {
  object: organizationOrganizationUserAuthorizationInsertInput;
  onConflict?: InputMaybe<organizationOrganizationUserAuthorizationOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationOrganizationUserAuthorizationsArgs = {
  objects: Array<organizationOrganizationUserAuthorizationInsertInput>;
  onConflict?: InputMaybe<organizationOrganizationUserAuthorizationOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationUserArgs = {
  object: organizationUserInsertInput;
  onConflict?: InputMaybe<organizationUserOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationUserAttachmentArgs = {
  object: organizationUserAttachmentsInsertInput;
  onConflict?: InputMaybe<organizationUserAttachmentsOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationUserAttachmentsArgs = {
  objects: Array<organizationUserAttachmentsInsertInput>;
  onConflict?: InputMaybe<organizationUserAttachmentsOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationUserAttentionNoteArgs = {
  object: OrganizationUserAttentionNoteInsertInput;
  onConflict?: InputMaybe<OrganizationUserAttentionNoteOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationUserAttentionNotesArgs = {
  objects: Array<OrganizationUserAttentionNoteInsertInput>;
  onConflict?: InputMaybe<OrganizationUserAttentionNoteOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationUserAuthorizationArgs = {
  object: organizationUserAuthorizationInsertInput;
  onConflict?: InputMaybe<organizationUserAuthorizationOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationUserAuthorizationsArgs = {
  objects: Array<organizationUserAuthorizationInsertInput>;
  onConflict?: InputMaybe<organizationUserAuthorizationOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationUserDetailArgs = {
  object: organizationUserDetailInsertInput;
  onConflict?: InputMaybe<organizationUserDetailOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationUserDetailTypeArgs = {
  object: organizationUserDetailTypeInsertInput;
  onConflict?: InputMaybe<organizationUserDetailTypeOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationUserDetailTypesArgs = {
  objects: Array<organizationUserDetailTypeInsertInput>;
  onConflict?: InputMaybe<organizationUserDetailTypeOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationUserDetailsArgs = {
  objects: Array<organizationUserDetailInsertInput>;
  onConflict?: InputMaybe<organizationUserDetailOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationUserInviteArgs = {
  object: organizationUserInviteInsertInput;
  onConflict?: InputMaybe<organizationUserInviteOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationUserInvitesArgs = {
  objects: Array<organizationUserInviteInsertInput>;
  onConflict?: InputMaybe<organizationUserInviteOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationUserRequestArgs = {
  object: BusinessOrganizationUserRequestInsertInput;
  onConflict?: InputMaybe<BusinessOrganizationUserRequestOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationUserRequestsArgs = {
  objects: Array<BusinessOrganizationUserRequestInsertInput>;
  onConflict?: InputMaybe<BusinessOrganizationUserRequestOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationUserStatusArgs = {
  object: organizationUserStatusInsertInput;
  onConflict?: InputMaybe<organizationUserStatusOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationUserStatusesArgs = {
  objects: Array<organizationUserStatusInsertInput>;
  onConflict?: InputMaybe<organizationUserStatusOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationUsersArgs = {
  objects: Array<organizationUserInsertInput>;
  onConflict?: InputMaybe<organizationUserOnConflict>;
};


/** mutation root */
export type mutation_rootcreateOrganizationsArgs = {
  objects: Array<organizationInsertInput>;
  onConflict?: InputMaybe<organizationOnConflict>;
};


/** mutation root */
export type mutation_rootcreatePhoneNumberVerificationStatusArgs = {
  object: phoneNumberVerificationStatusInsertInput;
  onConflict?: InputMaybe<phoneNumberVerificationStatusOnConflict>;
};


/** mutation root */
export type mutation_rootcreatePhoneNumberVerificationStatusesArgs = {
  objects: Array<phoneNumberVerificationStatusInsertInput>;
  onConflict?: InputMaybe<phoneNumberVerificationStatusOnConflict>;
};


/** mutation root */
export type mutation_rootcreatePhoneroOrgUsersArgs = {
  phoneroUsers?: InputMaybe<Array<createPhoneroOrgUserInput>>;
};


/** mutation root */
export type mutation_rootcreatePublicDeviceArgs = {
  object: publicDeviceInsertInput;
  onConflict?: InputMaybe<publicDeviceOnConflict>;
};


/** mutation root */
export type mutation_rootcreatePublicDevicesArgs = {
  objects: Array<publicDeviceInsertInput>;
  onConflict?: InputMaybe<publicDeviceOnConflict>;
};


/** mutation root */
export type mutation_rootcreatePublicExternalRequestArgs = {
  object: publicExternalRequestInsertInput;
  onConflict?: InputMaybe<publicExternalRequestOnConflict>;
};


/** mutation root */
export type mutation_rootcreatePublicExternalRequestsArgs = {
  objects: Array<publicExternalRequestInsertInput>;
  onConflict?: InputMaybe<publicExternalRequestOnConflict>;
};


/** mutation root */
export type mutation_rootcreatePublicFileArgs = {
  object: publicFileInsertInput;
  onConflict?: InputMaybe<publicFileOnConflict>;
};


/** mutation root */
export type mutation_rootcreatePublicFilesArgs = {
  objects: Array<publicFileInsertInput>;
  onConflict?: InputMaybe<publicFileOnConflict>;
};


/** mutation root */
export type mutation_rootcreatePublicNotificationArgs = {
  object: publicNotificationInsertInput;
  onConflict?: InputMaybe<publicNotificationOnConflict>;
};


/** mutation root */
export type mutation_rootcreatePublicNotificationsArgs = {
  objects: Array<publicNotificationInsertInput>;
  onConflict?: InputMaybe<publicNotificationOnConflict>;
};


/** mutation root */
export type mutation_rootcreateQueueItemArgs = {
  object: queueItemInsertInput;
  onConflict?: InputMaybe<queueItemOnConflict>;
};


/** mutation root */
export type mutation_rootcreateQueueItemsArgs = {
  objects: Array<queueItemInsertInput>;
  onConflict?: InputMaybe<queueItemOnConflict>;
};


/** mutation root */
export type mutation_rootcreateRelOrganizationUserDomainUserArgs = {
  object: relOrganizationUserDomainUserInsertInput;
  onConflict?: InputMaybe<relOrganizationUserDomainUserOnConflict>;
};


/** mutation root */
export type mutation_rootcreateRelOrganizationUserDomainUsersArgs = {
  objects: Array<relOrganizationUserDomainUserInsertInput>;
  onConflict?: InputMaybe<relOrganizationUserDomainUserOnConflict>;
};


/** mutation root */
export type mutation_rootcreateRequestToOrganizationArgs = {
  organization: orgAccessRequestInput;
};


/** mutation root */
export type mutation_rootcreateRoomArgs = {
  id1: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootcreateServerSmsArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type mutation_rootcreateSmsConnectorArgs = {
  object: smsConnectorInsertInput;
  onConflict?: InputMaybe<smsConnectorOnConflict>;
};


/** mutation root */
export type mutation_rootcreateSmsConnectorsArgs = {
  objects: Array<smsConnectorInsertInput>;
  onConflict?: InputMaybe<smsConnectorOnConflict>;
};


/** mutation root */
export type mutation_rootcreateSmsGateArgs = {
  object: smsGateInsertInput;
  onConflict?: InputMaybe<smsGateOnConflict>;
};


/** mutation root */
export type mutation_rootcreateSmsGatesArgs = {
  objects: Array<smsGateInsertInput>;
  onConflict?: InputMaybe<smsGateOnConflict>;
};


/** mutation root */
export type mutation_rootcreateSmsLinkMobilitySmsContentArgs = {
  object: smsLinkMobilitySmsContentInsertInput;
  onConflict?: InputMaybe<smsLinkMobilitySmsContentOnConflict>;
};


/** mutation root */
export type mutation_rootcreateSmsLinkMobilitySmsContentsArgs = {
  objects: Array<smsLinkMobilitySmsContentInsertInput>;
  onConflict?: InputMaybe<smsLinkMobilitySmsContentOnConflict>;
};


/** mutation root */
export type mutation_rootcreateSmsLinkMobilitySmsMessageArgs = {
  object: smsLinkMobilitySmsMessageInsertInput;
  onConflict?: InputMaybe<smsLinkMobilitySmsMessageOnConflict>;
};


/** mutation root */
export type mutation_rootcreateSmsLinkMobilitySmsMessagesArgs = {
  objects: Array<smsLinkMobilitySmsMessageInsertInput>;
  onConflict?: InputMaybe<smsLinkMobilitySmsMessageOnConflict>;
};


/** mutation root */
export type mutation_rootcreateSmsLinkMobilitySmsRouteArgs = {
  object: smsLinkMobilitySmsRouteInsertInput;
  onConflict?: InputMaybe<smsLinkMobilitySmsRouteOnConflict>;
};


/** mutation root */
export type mutation_rootcreateSmsLinkMobilitySmsRoutesArgs = {
  objects: Array<smsLinkMobilitySmsRouteInsertInput>;
  onConflict?: InputMaybe<smsLinkMobilitySmsRouteOnConflict>;
};


/** mutation root */
export type mutation_rootcreateSmsProviderArgs = {
  object: smsProviderInsertInput;
  onConflict?: InputMaybe<smsProviderOnConflict>;
};


/** mutation root */
export type mutation_rootcreateSmsProvidersArgs = {
  objects: Array<smsProviderInsertInput>;
  onConflict?: InputMaybe<smsProviderOnConflict>;
};


/** mutation root */
export type mutation_rootcreateSmsSmArgs = {
  object: smsSmInsertInput;
  onConflict?: InputMaybe<smsSmOnConflict>;
};


/** mutation root */
export type mutation_rootcreateSmsSmsArgs = {
  objects: Array<smsSmInsertInput>;
  onConflict?: InputMaybe<smsSmOnConflict>;
};


/** mutation root */
export type mutation_rootcreateSmsSmsExternalIncomingLinkMobilitiesArgs = {
  objects: Array<smsSmsExternalIncomingLinkMobilityInsertInput>;
  onConflict?: InputMaybe<smsSmsExternalIncomingLinkMobilityOnConflict>;
};


/** mutation root */
export type mutation_rootcreateSmsSmsExternalIncomingLinkMobilityArgs = {
  object: smsSmsExternalIncomingLinkMobilityInsertInput;
  onConflict?: InputMaybe<smsSmsExternalIncomingLinkMobilityOnConflict>;
};


/** mutation root */
export type mutation_rootcreateTelephonyNewProviderActivityArgs = {
  input: NewActivity;
};


/** mutation root */
export type mutation_rootcreateTelephonyProviderIntegrationArgs = {
  integration: telephonyProviderIntegrationInput;
};


/** mutation root */
export type mutation_rootcreateUserArgs = {
  object: userInsertInput;
  onConflict?: InputMaybe<userOnConflict>;
};


/** mutation root */
export type mutation_rootcreateUserAndOrgArgs = {
  userOrg: UserAndOrgInput;
};


/** mutation root */
export type mutation_rootcreateUserDetailArgs = {
  object: userDetailInsertInput;
  onConflict?: InputMaybe<userDetailOnConflict>;
};


/** mutation root */
export type mutation_rootcreateUserDetailsArgs = {
  objects: Array<userDetailInsertInput>;
  onConflict?: InputMaybe<userDetailOnConflict>;
};


/** mutation root */
export type mutation_rootcreateUserDetailsTypeArgs = {
  object: userDetailsTypeInsertInput;
  onConflict?: InputMaybe<userDetailsTypeOnConflict>;
};


/** mutation root */
export type mutation_rootcreateUserDetailsTypesArgs = {
  objects: Array<userDetailsTypeInsertInput>;
  onConflict?: InputMaybe<userDetailsTypeOnConflict>;
};


/** mutation root */
export type mutation_rootcreateUserDeviceArgs = {
  object: userDeviceInsertInput;
  onConflict?: InputMaybe<userDeviceOnConflict>;
};


/** mutation root */
export type mutation_rootcreateUserDevicesArgs = {
  objects: Array<userDeviceInsertInput>;
  onConflict?: InputMaybe<userDeviceOnConflict>;
};


/** mutation root */
export type mutation_rootcreateUserPhoneNumberArgs = {
  object: userPhoneNumberInsertInput;
  onConflict?: InputMaybe<userPhoneNumberOnConflict>;
};


/** mutation root */
export type mutation_rootcreateUserPhoneNumbersArgs = {
  objects: Array<userPhoneNumberInsertInput>;
  onConflict?: InputMaybe<userPhoneNumberOnConflict>;
};


/** mutation root */
export type mutation_rootcreateUserRoleArgs = {
  object: userRoleInsertInput;
  onConflict?: InputMaybe<userRoleOnConflict>;
};


/** mutation root */
export type mutation_rootcreateUserRolesArgs = {
  objects: Array<userRoleInsertInput>;
  onConflict?: InputMaybe<userRoleOnConflict>;
};


/** mutation root */
export type mutation_rootcreateUsersArgs = {
  objects: Array<userInsertInput>;
  onConflict?: InputMaybe<userOnConflict>;
};


/** mutation root */
export type mutation_rootcreateValidationValidationArgs = {
  object: validationValidationInsertInput;
  onConflict?: InputMaybe<validationValidationOnConflict>;
};


/** mutation root */
export type mutation_rootcreateValidationValidationsArgs = {
  objects: Array<validationValidationInsertInput>;
  onConflict?: InputMaybe<validationValidationOnConflict>;
};


/** mutation root */
export type mutation_rootcreateVideoInviteToOrganizationUserArgs = {
  object: videoInviteOrgUserInput;
};


/** mutation root */
export type mutation_rootdeleteActivityDirectionArgs = {
  where: ActivityDirectionBoolExp;
};


/** mutation root */
export type mutation_rootdeleteActivityDirectionByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteActivityParticipantArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteActivityParticipantsArgs = {
  where: activityParticipantBoolExp;
};


/** mutation root */
export type mutation_rootdeleteActivityProviderArgs = {
  where: ActivityProviderBoolExp;
};


/** mutation root */
export type mutation_rootdeleteActivityProviderByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteActivityStatusArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteActivityStatusesArgs = {
  where: ActivityStatusBoolExp;
};


/** mutation root */
export type mutation_rootdeleteActivityTypeArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteActivityTypesArgs = {
  where: ActivityTypeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteAddressArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteAddressesArgs = {
  where: addressBoolExp;
};


/** mutation root */
export type mutation_rootdeleteBlockedDomainUserArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteBlockedDomainUsersArgs = {
  where: blockedDomainUserBoolExp;
};


/** mutation root */
export type mutation_rootdeleteBusinessDomainActivityTypeArgs = {
  where: BusinessDomainActivityTypeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteBusinessDomainActivityTypeByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteBusinessFeedTypeArgs = {
  where: BusinessFeedTypeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteBusinessFeedTypeByPkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteBusinessMessageAttachmentsArgs = {
  where: BusinessMessageAttachmentsBoolExp;
};


/** mutation root */
export type mutation_rootdeleteBusinessMessageAttachmentsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteBusinessOrganizationUserCallbackAnswerArgs = {
  where: BusinessOrganizationUserCallbackAnswerBoolExp;
};


/** mutation root */
export type mutation_rootdeleteBusinessOrganizationUserCallbackAnswerByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteBusinessOrganizationUserEmailArgs = {
  where: BusinessOrganizationUserEmailBoolExp;
};


/** mutation root */
export type mutation_rootdeleteBusinessOrganizationUserEmailByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteBusinessOrganizationUserEmailTypeArgs = {
  where: BusinessOrganizationUserEmailTypeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteBusinessOrganizationUserEmailTypeByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteBusinessOrganizationUserRequestTypeArgs = {
  where: BusinessOrganizationUserRequestTypeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteBusinessOrganizationUserRequestTypeByPkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteBusinessOrganizationUserSuggestionTypeArgs = {
  where: BusinessOrganizationUserSuggestionTypeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteBusinessOrganizationUserSuggestionTypeByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteBusinessOrganizationUserSuggestionsArgs = {
  where: BusinessOrganizationUserSuggestionsBoolExp;
};


/** mutation root */
export type mutation_rootdeleteBusinessOrganizationUserSuggestionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteBusinessOrganizationUserUrlAddressArgs = {
  where: BusinessOrganizationUserUrlAddressBoolExp;
};


/** mutation root */
export type mutation_rootdeleteBusinessOrganizationUserUrlAddressByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteBusinessOrganizationUserUrlAddressTypeArgs = {
  where: BusinessOrganizationUserUrlAddressTypeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteBusinessOrganizationUserUrlAddressTypeByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteBusinessQueueItemAlarmTypeArgs = {
  where: BusinessQueueItemAlarmTypeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteBusinessQueueItemAlarmTypeByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteBusinessQueueItemAlarmsArgs = {
  where: BusinessQueueItemAlarmsBoolExp;
};


/** mutation root */
export type mutation_rootdeleteBusinessQueueItemAlarmsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteBusinessQueueItemCollaborationArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type mutation_rootdeleteBusinessQueueItemCollaborationsArgs = {
  where: businessQueueItemCollaborationBoolExp;
};


/** mutation root */
export type mutation_rootdeleteBusinessQueueItemParticipantChannelTypeArgs = {
  where: BusinessQueueItemParticipantChannelTypeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteBusinessQueueItemParticipantChannelTypeByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteBusinessQueueItemSubTypeArgs = {
  where: BusinessQueueItemSubTypeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteBusinessQueueItemSubTypeByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteBusinessUserContactArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteBusinessUserContactNumbersArgs = {
  where: BusinessUserContactNumbersBoolExp;
};


/** mutation root */
export type mutation_rootdeleteBusinessUserContactNumbersByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteBusinessUserContactsArgs = {
  where: businessUserContactsBoolExp;
};


/** mutation root */
export type mutation_rootdeleteBusinessUserFeedArgs = {
  where: BusinessUserFeedBoolExp;
};


/** mutation root */
export type mutation_rootdeleteBusinessUserFeedByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteBusinessUserRequestStatusArgs = {
  where: BusinessUserRequestStatusBoolExp;
};


/** mutation root */
export type mutation_rootdeleteBusinessUserRequestStatusByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteBusinessUserSettingArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteBusinessUserSettingsArgs = {
  where: businessUserSettingsBoolExp;
};


/** mutation root */
export type mutation_rootdeleteBusinessUserStatesArgs = {
  where: BusinessUserStatesBoolExp;
};


/** mutation root */
export type mutation_rootdeleteBusinessUserStatesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteCrmContextArgs = {
  where: CrmContextBoolExp;
};


/** mutation root */
export type mutation_rootdeleteCrmContextByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteCrmContextTypeArgs = {
  where: CrmContextTypeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteCrmContextTypeByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteCrmCreatorTypeArgs = {
  where: CrmCreatorTypeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteCrmCreatorTypeByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteCrmCrmTypeArgs = {
  where: CrmCrmTypeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteCrmCrmTypeByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteCrmDirectionTypeArgs = {
  where: CrmDirectionTypeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteCrmDirectionTypeByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteCrmEntityArgs = {
  where: CrmEntityBoolExp;
};


/** mutation root */
export type mutation_rootdeleteCrmEntityByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteCrmEventArgs = {
  where: CrmEventBoolExp;
};


/** mutation root */
export type mutation_rootdeleteCrmEventByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteCrmEventTypeArgs = {
  where: CrmEventTypeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteCrmEventTypeByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteCrmStatusCodeArgs = {
  where: CrmStatusCodeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteCrmStatusCodeByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteCrmStatusMessageArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteCrmStatusMessagesArgs = {
  where: crmStatusMessageBoolExp;
};


/** mutation root */
export type mutation_rootdeleteCrmSystemTypeArgs = {
  where: CrmSystemTypeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteCrmSystemTypeByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteCrmTraceContextArgs = {
  where: CrmTraceContextBoolExp;
};


/** mutation root */
export type mutation_rootdeleteCrmTraceContextByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteCrmUnifiedEntityTypeArgs = {
  where: CrmUnifiedEntityTypeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteCrmUnifiedEntityTypeByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteCrmYoutelloCatalystIdMappingArgs = {
  where: crmYoutelloCatalystIdMappingBoolExp;
};


/** mutation root */
export type mutation_rootdeleteCrmYoutelloCatalystIdMappingByPkArgs = {
  catalystId: Scalars['uuid']['input'];
  youtelloId: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteDomainActivitiesArgs = {
  where: domainActivityBoolExp;
};


/** mutation root */
export type mutation_rootdeleteDomainActivityArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteDomainOrganizationArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteDomainOrganizationsArgs = {
  where: domainOrganizationBoolExp;
};


/** mutation root */
export type mutation_rootdeleteDomainParticipantArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteDomainParticipantsArgs = {
  where: domainParticipantBoolExp;
};


/** mutation root */
export type mutation_rootdeleteDomainTypeArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteDomainTypesArgs = {
  where: domainTypeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteDomainUserArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteDomainUserCategoriesArgs = {
  where: domainUserCategoryBoolExp;
};


/** mutation root */
export type mutation_rootdeleteDomainUserCategoryArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteDomainUsersArgs = {
  where: domainUserBoolExp;
};


/** mutation root */
export type mutation_rootdeleteInviteUserToOrgArgs = {
  input: DeleteUserInput;
};


/** mutation root */
export type mutation_rootdeleteLanguagesArgs = {
  where: languagesBoolExp;
};


/** mutation root */
export type mutation_rootdeleteLanguagesByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteMessageArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteMessageTypeArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteMessageTypesArgs = {
  where: messageTypeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteMessagesArgs = {
  where: messageBoolExp;
};


/** mutation root */
export type mutation_rootdeleteMessagingActivitiesArgs = {
  where: messagingActivityBoolExp;
};


/** mutation root */
export type mutation_rootdeleteMessagingActivityArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteMessagingActivityOrganizationArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteMessagingActivityOrganizationsArgs = {
  where: messagingActivityOrganizationBoolExp;
};


/** mutation root */
export type mutation_rootdeleteMessagingActivitySettingsArgs = {
  where: MessagingActivitySettingsBoolExp;
};


/** mutation root */
export type mutation_rootdeleteMessagingActivitySettingsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteMessagingActivitySettingsNotificationSettingTypeArgs = {
  where: MessagingActivitySettingsNotificationSettingTypeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteMessagingActivitySettingsNotificationSettingTypeByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteMessagingActivityTypeArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteMessagingActivityTypesArgs = {
  where: messagingActivityTypeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteMessagingActivityUserArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteMessagingActivityUsersArgs = {
  where: messagingActivityUserBoolExp;
};


/** mutation root */
export type mutation_rootdeleteMessagingInvitationArgs = {
  where: MessagingInvitationBoolExp;
};


/** mutation root */
export type mutation_rootdeleteMessagingInvitationByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteMessagingMentionsArgs = {
  where: MessagingMentionsBoolExp;
};


/** mutation root */
export type mutation_rootdeleteMessagingMentionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteMessagingMessageArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteMessagingMessageAttachmentArgs = {
  where: MessagingMessageAttachmentBoolExp;
};


/** mutation root */
export type mutation_rootdeleteMessagingMessageAttachmentByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteMessagingMessageAttachmentTypeArgs = {
  where: MessagingMessageAttachmentTypeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteMessagingMessageAttachmentTypeByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteMessagingMessageEmojiArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteMessagingMessageEmojisArgs = {
  where: messagingMessageEmojiBoolExp;
};


/** mutation root */
export type mutation_rootdeleteMessagingMessagePriorityArgs = {
  where: MessagingMessagePriorityBoolExp;
};


/** mutation root */
export type mutation_rootdeleteMessagingMessagePriorityByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteMessagingMessageReadArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteMessagingMessageReadsArgs = {
  where: messagingMessageReadBoolExp;
};


/** mutation root */
export type mutation_rootdeleteMessagingMessageTypeArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteMessagingMessageTypesArgs = {
  where: messagingMessageTypeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteMessagingMessagesArgs = {
  where: messagingMessageBoolExp;
};


/** mutation root */
export type mutation_rootdeleteNotificationArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteNotificationNotificationDeviceSentArgs = {
  where: NotificationNotificationDeviceSentBoolExp;
};


/** mutation root */
export type mutation_rootdeleteNotificationNotificationDeviceSentByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteNotificationNotificationSettingActivityPrimaryEnumArgs = {
  where: NotificationNotificationSettingActivityPrimaryEnumBoolExp;
};


/** mutation root */
export type mutation_rootdeleteNotificationNotificationSettingActivityPrimaryEnumByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteNotificationSendArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteNotificationSendsArgs = {
  where: notificationSendBoolExp;
};


/** mutation root */
export type mutation_rootdeleteNotificationSettingActivitiesArgs = {
  where: notificationSettingActivityBoolExp;
};


/** mutation root */
export type mutation_rootdeleteNotificationSettingActivityArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteNotificationUserArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteNotificationUserDeviceArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteNotificationUserDevicesArgs = {
  where: notificationUserDeviceBoolExp;
};


/** mutation root */
export type mutation_rootdeleteNotificationUsersArgs = {
  where: notificationUserBoolExp;
};


/** mutation root */
export type mutation_rootdeleteNotificationsArgs = {
  where: notificationBoolExp;
};


/** mutation root */
export type mutation_rootdeleteOrdersIntegrationArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteOrdersIntegrationsArgs = {
  where: ordersIntegrationsBoolExp;
};


/** mutation root */
export type mutation_rootdeleteOrdersOrganizationsArgs = {
  where: OrdersOrganizationsBoolExp;
};


/** mutation root */
export type mutation_rootdeleteOrdersOrganizationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteOrdersRequestArgs = {
  where: OrdersRequestBoolExp;
};


/** mutation root */
export type mutation_rootdeleteOrdersRequestByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteOrdersStatusArgs = {
  where: OrdersStatusBoolExp;
};


/** mutation root */
export type mutation_rootdeleteOrdersStatusByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteOrdersTypeArgs = {
  where: OrdersTypeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteOrdersTypeByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteOrganizationArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteOrganizationAuthorizationEnumGroupArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteOrganizationAuthorizationEnumGroupsArgs = {
  where: organizationAuthorizationEnumGroupBoolExp;
};


/** mutation root */
export type mutation_rootdeleteOrganizationAuthorizationGroupArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteOrganizationAuthorizationGroupsArgs = {
  where: organizationAuthorizationGroupBoolExp;
};


/** mutation root */
export type mutation_rootdeleteOrganizationOrganizationRelationshipArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteOrganizationOrganizationRelationshipCategoriesArgs = {
  where: organizationOrganizationRelationshipCategoryBoolExp;
};


/** mutation root */
export type mutation_rootdeleteOrganizationOrganizationRelationshipCategoryArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteOrganizationOrganizationRelationshipsArgs = {
  where: organizationOrganizationRelationshipBoolExp;
};


/** mutation root */
export type mutation_rootdeleteOrganizationOrganizationUserAuthorizationArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteOrganizationOrganizationUserAuthorizationsArgs = {
  where: organizationOrganizationUserAuthorizationBoolExp;
};


/** mutation root */
export type mutation_rootdeleteOrganizationUserArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteOrganizationUserAttachmentArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteOrganizationUserAttachmentsArgs = {
  where: organizationUserAttachmentsBoolExp;
};


/** mutation root */
export type mutation_rootdeleteOrganizationUserAttentionNoteArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteOrganizationUserAttentionNotesArgs = {
  where: OrganizationUserAttentionNoteBoolExp;
};


/** mutation root */
export type mutation_rootdeleteOrganizationUserAuthorizationArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteOrganizationUserAuthorizationsArgs = {
  where: organizationUserAuthorizationBoolExp;
};


/** mutation root */
export type mutation_rootdeleteOrganizationUserDetailArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteOrganizationUserDetailTypeArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteOrganizationUserDetailTypesArgs = {
  where: organizationUserDetailTypeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteOrganizationUserDetailsArgs = {
  where: organizationUserDetailBoolExp;
};


/** mutation root */
export type mutation_rootdeleteOrganizationUserInviteArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteOrganizationUserInvitesArgs = {
  where: organizationUserInviteBoolExp;
};


/** mutation root */
export type mutation_rootdeleteOrganizationUserRequestArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteOrganizationUserRequestsArgs = {
  where: BusinessOrganizationUserRequestBoolExp;
};


/** mutation root */
export type mutation_rootdeleteOrganizationUserStatusArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteOrganizationUserStatusesArgs = {
  where: organizationUserStatusBoolExp;
};


/** mutation root */
export type mutation_rootdeleteOrganizationUsersArgs = {
  where: organizationUserBoolExp;
};


/** mutation root */
export type mutation_rootdeleteOrganizationsArgs = {
  where: organizationBoolExp;
};


/** mutation root */
export type mutation_rootdeletePhoneNumberVerificationStatusArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeletePhoneNumberVerificationStatusesArgs = {
  where: phoneNumberVerificationStatusBoolExp;
};


/** mutation root */
export type mutation_rootdeletePromptArgs = {
  where: PromptBoolExp;
};


/** mutation root */
export type mutation_rootdeletePromptByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeletePublicDeviceArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeletePublicDevicesArgs = {
  where: publicDeviceBoolExp;
};


/** mutation root */
export type mutation_rootdeletePublicExternalRequestArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeletePublicExternalRequestsArgs = {
  where: publicExternalRequestBoolExp;
};


/** mutation root */
export type mutation_rootdeletePublicFileArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeletePublicFilesArgs = {
  where: publicFileBoolExp;
};


/** mutation root */
export type mutation_rootdeletePublicNotificationArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeletePublicNotificationsArgs = {
  where: publicNotificationBoolExp;
};


/** mutation root */
export type mutation_rootdeleteQueueItemArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteQueueItemFlexibilityTypeArgs = {
  where: QueueItemFlexibilityTypeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteQueueItemFlexibilityTypeByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteQueueItemParticipantResponsibilityTypeArgs = {
  where: QueueItemParticipantResponsibilityTypeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteQueueItemParticipantResponsibilityTypeByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteQueueItemsArgs = {
  where: queueItemBoolExp;
};


/** mutation root */
export type mutation_rootdeleteRelOrganizationUserDomainUserArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteRelOrganizationUserDomainUsersArgs = {
  where: relOrganizationUserDomainUserBoolExp;
};


/** mutation root */
export type mutation_rootdeleteRelationTypeArgs = {
  where: RelationTypeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteRelationTypeByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteRequestToOrganizationArgs = {
  input: DeleteRequestUserInput;
};


/** mutation root */
export type mutation_rootdeleteSmsConnectorArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type mutation_rootdeleteSmsConnectorsArgs = {
  where: smsConnectorBoolExp;
};


/** mutation root */
export type mutation_rootdeleteSmsGateArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type mutation_rootdeleteSmsGatesArgs = {
  where: smsGateBoolExp;
};


/** mutation root */
export type mutation_rootdeleteSmsLinkMobilitySmsContentArgs = {
  uuid: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteSmsLinkMobilitySmsContentsArgs = {
  where: smsLinkMobilitySmsContentBoolExp;
};


/** mutation root */
export type mutation_rootdeleteSmsLinkMobilitySmsMessageArgs = {
  uuid: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteSmsLinkMobilitySmsMessagesArgs = {
  where: smsLinkMobilitySmsMessageBoolExp;
};


/** mutation root */
export type mutation_rootdeleteSmsLinkMobilitySmsRouteArgs = {
  uuid: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteSmsLinkMobilitySmsRoutesArgs = {
  where: smsLinkMobilitySmsRouteBoolExp;
};


/** mutation root */
export type mutation_rootdeleteSmsProviderArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type mutation_rootdeleteSmsProvidersArgs = {
  where: smsProviderBoolExp;
};


/** mutation root */
export type mutation_rootdeleteSmsSmArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteSmsSmsArgs = {
  where: smsSmBoolExp;
};


/** mutation root */
export type mutation_rootdeleteSmsSmsExternalIncomingLinkMobilitiesArgs = {
  where: smsSmsExternalIncomingLinkMobilityBoolExp;
};


/** mutation root */
export type mutation_rootdeleteSmsSmsExternalIncomingLinkMobilityArgs = {
  uuid: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteUserArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteUserDetailArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteUserDetailsArgs = {
  where: userDetailBoolExp;
};


/** mutation root */
export type mutation_rootdeleteUserDetailsTypeArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteUserDetailsTypesArgs = {
  where: userDetailsTypeBoolExp;
};


/** mutation root */
export type mutation_rootdeleteUserDeviceArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteUserDevicesArgs = {
  where: userDeviceBoolExp;
};


/** mutation root */
export type mutation_rootdeleteUserPhoneNumberArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteUserPhoneNumbersArgs = {
  where: userPhoneNumberBoolExp;
};


/** mutation root */
export type mutation_rootdeleteUserRoleArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootdeleteUserRolesArgs = {
  where: userRoleBoolExp;
};


/** mutation root */
export type mutation_rootdeleteUsersArgs = {
  where: userBoolExp;
};


/** mutation root */
export type mutation_rootdeleteValidationValidationArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootdeleteValidationValidationsArgs = {
  where: validationValidationBoolExp;
};


/** mutation root */
export type mutation_rootdeleteVoiceTypesArgs = {
  where: VoiceTypesBoolExp;
};


/** mutation root */
export type mutation_rootdeleteVoiceTypesByPkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootfileUploadArgs = {
  ACL?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<InputMaybe<File>>>;
};


/** mutation root */
export type mutation_rootincomingSmsArgs = {
  content?: InputMaybe<Content>;
  customParameters?: InputMaybe<CustomParameters>;
  destination?: InputMaybe<Scalars['String']['input']>;
  gateCustomParameters?: InputMaybe<GateCustomParameters>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  operatorMessageId?: InputMaybe<Scalars['String']['input']>;
  operatorTimestamp?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Route>;
  source?: InputMaybe<Scalars['String']['input']>;
  subNumber?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type mutation_rootinitiateVerificationArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
  validateItem?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type mutation_rootinsertActivityDirectionArgs = {
  objects: Array<ActivityDirectionInsertInput>;
  onConflict?: InputMaybe<ActivityDirectionOnConflict>;
};


/** mutation root */
export type mutation_rootinsertActivityDirectionOneArgs = {
  object: ActivityDirectionInsertInput;
  onConflict?: InputMaybe<ActivityDirectionOnConflict>;
};


/** mutation root */
export type mutation_rootinsertActivityProviderArgs = {
  objects: Array<ActivityProviderInsertInput>;
  onConflict?: InputMaybe<ActivityProviderOnConflict>;
};


/** mutation root */
export type mutation_rootinsertActivityProviderOneArgs = {
  object: ActivityProviderInsertInput;
  onConflict?: InputMaybe<ActivityProviderOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessDomainActivityTypeArgs = {
  objects: Array<BusinessDomainActivityTypeInsertInput>;
  onConflict?: InputMaybe<BusinessDomainActivityTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessDomainActivityTypeOneArgs = {
  object: BusinessDomainActivityTypeInsertInput;
  onConflict?: InputMaybe<BusinessDomainActivityTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessFeedTypeArgs = {
  objects: Array<BusinessFeedTypeInsertInput>;
  onConflict?: InputMaybe<BusinessFeedTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessFeedTypeOneArgs = {
  object: BusinessFeedTypeInsertInput;
  onConflict?: InputMaybe<BusinessFeedTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessMessageAttachmentsArgs = {
  objects: Array<BusinessMessageAttachmentsInsertInput>;
  onConflict?: InputMaybe<BusinessMessageAttachmentsOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessMessageAttachmentsOneArgs = {
  object: BusinessMessageAttachmentsInsertInput;
  onConflict?: InputMaybe<BusinessMessageAttachmentsOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessOrganizationUserCallbackAnswerArgs = {
  objects: Array<BusinessOrganizationUserCallbackAnswerInsertInput>;
  onConflict?: InputMaybe<BusinessOrganizationUserCallbackAnswerOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessOrganizationUserCallbackAnswerOneArgs = {
  object: BusinessOrganizationUserCallbackAnswerInsertInput;
  onConflict?: InputMaybe<BusinessOrganizationUserCallbackAnswerOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessOrganizationUserEmailArgs = {
  objects: Array<BusinessOrganizationUserEmailInsertInput>;
  onConflict?: InputMaybe<BusinessOrganizationUserEmailOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessOrganizationUserEmailOneArgs = {
  object: BusinessOrganizationUserEmailInsertInput;
  onConflict?: InputMaybe<BusinessOrganizationUserEmailOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessOrganizationUserEmailTypeArgs = {
  objects: Array<BusinessOrganizationUserEmailTypeInsertInput>;
  onConflict?: InputMaybe<BusinessOrganizationUserEmailTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessOrganizationUserEmailTypeOneArgs = {
  object: BusinessOrganizationUserEmailTypeInsertInput;
  onConflict?: InputMaybe<BusinessOrganizationUserEmailTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessOrganizationUserRequestTypeArgs = {
  objects: Array<BusinessOrganizationUserRequestTypeInsertInput>;
  onConflict?: InputMaybe<BusinessOrganizationUserRequestTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessOrganizationUserRequestTypeOneArgs = {
  object: BusinessOrganizationUserRequestTypeInsertInput;
  onConflict?: InputMaybe<BusinessOrganizationUserRequestTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessOrganizationUserSuggestionTypeArgs = {
  objects: Array<BusinessOrganizationUserSuggestionTypeInsertInput>;
  onConflict?: InputMaybe<BusinessOrganizationUserSuggestionTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessOrganizationUserSuggestionTypeOneArgs = {
  object: BusinessOrganizationUserSuggestionTypeInsertInput;
  onConflict?: InputMaybe<BusinessOrganizationUserSuggestionTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessOrganizationUserSuggestionsArgs = {
  objects: Array<BusinessOrganizationUserSuggestionsInsertInput>;
  onConflict?: InputMaybe<BusinessOrganizationUserSuggestionsOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessOrganizationUserSuggestionsOneArgs = {
  object: BusinessOrganizationUserSuggestionsInsertInput;
  onConflict?: InputMaybe<BusinessOrganizationUserSuggestionsOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessOrganizationUserUrlAddressArgs = {
  objects: Array<BusinessOrganizationUserUrlAddressInsertInput>;
  onConflict?: InputMaybe<BusinessOrganizationUserUrlAddressOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessOrganizationUserUrlAddressOneArgs = {
  object: BusinessOrganizationUserUrlAddressInsertInput;
  onConflict?: InputMaybe<BusinessOrganizationUserUrlAddressOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessOrganizationUserUrlAddressTypeArgs = {
  objects: Array<BusinessOrganizationUserUrlAddressTypeInsertInput>;
  onConflict?: InputMaybe<BusinessOrganizationUserUrlAddressTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessOrganizationUserUrlAddressTypeOneArgs = {
  object: BusinessOrganizationUserUrlAddressTypeInsertInput;
  onConflict?: InputMaybe<BusinessOrganizationUserUrlAddressTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessQueueItemAlarmTypeArgs = {
  objects: Array<BusinessQueueItemAlarmTypeInsertInput>;
  onConflict?: InputMaybe<BusinessQueueItemAlarmTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessQueueItemAlarmTypeOneArgs = {
  object: BusinessQueueItemAlarmTypeInsertInput;
  onConflict?: InputMaybe<BusinessQueueItemAlarmTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessQueueItemAlarmsArgs = {
  objects: Array<BusinessQueueItemAlarmsInsertInput>;
  onConflict?: InputMaybe<BusinessQueueItemAlarmsOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessQueueItemAlarmsOneArgs = {
  object: BusinessQueueItemAlarmsInsertInput;
  onConflict?: InputMaybe<BusinessQueueItemAlarmsOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessQueueItemParticipantChannelTypeArgs = {
  objects: Array<BusinessQueueItemParticipantChannelTypeInsertInput>;
  onConflict?: InputMaybe<BusinessQueueItemParticipantChannelTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessQueueItemParticipantChannelTypeOneArgs = {
  object: BusinessQueueItemParticipantChannelTypeInsertInput;
  onConflict?: InputMaybe<BusinessQueueItemParticipantChannelTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessQueueItemSubTypeArgs = {
  objects: Array<BusinessQueueItemSubTypeInsertInput>;
  onConflict?: InputMaybe<BusinessQueueItemSubTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessQueueItemSubTypeOneArgs = {
  object: BusinessQueueItemSubTypeInsertInput;
  onConflict?: InputMaybe<BusinessQueueItemSubTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessUserContactNumbersArgs = {
  objects: Array<BusinessUserContactNumbersInsertInput>;
  onConflict?: InputMaybe<BusinessUserContactNumbersOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessUserContactNumbersOneArgs = {
  object: BusinessUserContactNumbersInsertInput;
  onConflict?: InputMaybe<BusinessUserContactNumbersOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessUserFeedArgs = {
  objects: Array<BusinessUserFeedInsertInput>;
  onConflict?: InputMaybe<BusinessUserFeedOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessUserFeedOneArgs = {
  object: BusinessUserFeedInsertInput;
  onConflict?: InputMaybe<BusinessUserFeedOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessUserRequestStatusArgs = {
  objects: Array<BusinessUserRequestStatusInsertInput>;
  onConflict?: InputMaybe<BusinessUserRequestStatusOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessUserRequestStatusOneArgs = {
  object: BusinessUserRequestStatusInsertInput;
  onConflict?: InputMaybe<BusinessUserRequestStatusOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessUserStatesArgs = {
  objects: Array<BusinessUserStatesInsertInput>;
  onConflict?: InputMaybe<BusinessUserStatesOnConflict>;
};


/** mutation root */
export type mutation_rootinsertBusinessUserStatesOneArgs = {
  object: BusinessUserStatesInsertInput;
  onConflict?: InputMaybe<BusinessUserStatesOnConflict>;
};


/** mutation root */
export type mutation_rootinsertCrmContextArgs = {
  objects: Array<CrmContextInsertInput>;
  onConflict?: InputMaybe<CrmContextOnConflict>;
};


/** mutation root */
export type mutation_rootinsertCrmContextOneArgs = {
  object: CrmContextInsertInput;
  onConflict?: InputMaybe<CrmContextOnConflict>;
};


/** mutation root */
export type mutation_rootinsertCrmContextTypeArgs = {
  objects: Array<CrmContextTypeInsertInput>;
  onConflict?: InputMaybe<CrmContextTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertCrmContextTypeOneArgs = {
  object: CrmContextTypeInsertInput;
  onConflict?: InputMaybe<CrmContextTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertCrmCreatorTypeArgs = {
  objects: Array<CrmCreatorTypeInsertInput>;
  onConflict?: InputMaybe<CrmCreatorTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertCrmCreatorTypeOneArgs = {
  object: CrmCreatorTypeInsertInput;
  onConflict?: InputMaybe<CrmCreatorTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertCrmCrmTypeArgs = {
  objects: Array<CrmCrmTypeInsertInput>;
  onConflict?: InputMaybe<CrmCrmTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertCrmCrmTypeOneArgs = {
  object: CrmCrmTypeInsertInput;
  onConflict?: InputMaybe<CrmCrmTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertCrmDirectionTypeArgs = {
  objects: Array<CrmDirectionTypeInsertInput>;
  onConflict?: InputMaybe<CrmDirectionTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertCrmDirectionTypeOneArgs = {
  object: CrmDirectionTypeInsertInput;
  onConflict?: InputMaybe<CrmDirectionTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertCrmEntityArgs = {
  objects: Array<CrmEntityInsertInput>;
  onConflict?: InputMaybe<CrmEntityOnConflict>;
};


/** mutation root */
export type mutation_rootinsertCrmEntityOneArgs = {
  object: CrmEntityInsertInput;
  onConflict?: InputMaybe<CrmEntityOnConflict>;
};


/** mutation root */
export type mutation_rootinsertCrmEventArgs = {
  objects: Array<CrmEventInsertInput>;
  onConflict?: InputMaybe<CrmEventOnConflict>;
};


/** mutation root */
export type mutation_rootinsertCrmEventOneArgs = {
  object: CrmEventInsertInput;
  onConflict?: InputMaybe<CrmEventOnConflict>;
};


/** mutation root */
export type mutation_rootinsertCrmEventTypeArgs = {
  objects: Array<CrmEventTypeInsertInput>;
  onConflict?: InputMaybe<CrmEventTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertCrmEventTypeOneArgs = {
  object: CrmEventTypeInsertInput;
  onConflict?: InputMaybe<CrmEventTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertCrmStatusCodeArgs = {
  objects: Array<CrmStatusCodeInsertInput>;
  onConflict?: InputMaybe<CrmStatusCodeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertCrmStatusCodeOneArgs = {
  object: CrmStatusCodeInsertInput;
  onConflict?: InputMaybe<CrmStatusCodeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertCrmSystemTypeArgs = {
  objects: Array<CrmSystemTypeInsertInput>;
  onConflict?: InputMaybe<CrmSystemTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertCrmSystemTypeOneArgs = {
  object: CrmSystemTypeInsertInput;
  onConflict?: InputMaybe<CrmSystemTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertCrmTraceContextArgs = {
  objects: Array<CrmTraceContextInsertInput>;
  onConflict?: InputMaybe<CrmTraceContextOnConflict>;
};


/** mutation root */
export type mutation_rootinsertCrmTraceContextOneArgs = {
  object: CrmTraceContextInsertInput;
  onConflict?: InputMaybe<CrmTraceContextOnConflict>;
};


/** mutation root */
export type mutation_rootinsertCrmUnifiedEntityTypeArgs = {
  objects: Array<CrmUnifiedEntityTypeInsertInput>;
  onConflict?: InputMaybe<CrmUnifiedEntityTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertCrmUnifiedEntityTypeOneArgs = {
  object: CrmUnifiedEntityTypeInsertInput;
  onConflict?: InputMaybe<CrmUnifiedEntityTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertLanguagesArgs = {
  objects: Array<languagesInsertInput>;
  onConflict?: InputMaybe<languagesOnConflict>;
};


/** mutation root */
export type mutation_rootinsertLanguagesOneArgs = {
  object: languagesInsertInput;
  onConflict?: InputMaybe<languagesOnConflict>;
};


/** mutation root */
export type mutation_rootinsertMessagingActivitySettingsArgs = {
  objects: Array<MessagingActivitySettingsInsertInput>;
  onConflict?: InputMaybe<MessagingActivitySettingsOnConflict>;
};


/** mutation root */
export type mutation_rootinsertMessagingActivitySettingsNotificationSettingTypeArgs = {
  objects: Array<MessagingActivitySettingsNotificationSettingTypeInsertInput>;
  onConflict?: InputMaybe<MessagingActivitySettingsNotificationSettingTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertMessagingActivitySettingsNotificationSettingTypeOneArgs = {
  object: MessagingActivitySettingsNotificationSettingTypeInsertInput;
  onConflict?: InputMaybe<MessagingActivitySettingsNotificationSettingTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertMessagingActivitySettingsOneArgs = {
  object: MessagingActivitySettingsInsertInput;
  onConflict?: InputMaybe<MessagingActivitySettingsOnConflict>;
};


/** mutation root */
export type mutation_rootinsertMessagingInvitationArgs = {
  objects: Array<MessagingInvitationInsertInput>;
  onConflict?: InputMaybe<MessagingInvitationOnConflict>;
};


/** mutation root */
export type mutation_rootinsertMessagingInvitationOneArgs = {
  object: MessagingInvitationInsertInput;
  onConflict?: InputMaybe<MessagingInvitationOnConflict>;
};


/** mutation root */
export type mutation_rootinsertMessagingMentionsArgs = {
  objects: Array<MessagingMentionsInsertInput>;
  onConflict?: InputMaybe<MessagingMentionsOnConflict>;
};


/** mutation root */
export type mutation_rootinsertMessagingMentionsOneArgs = {
  object: MessagingMentionsInsertInput;
  onConflict?: InputMaybe<MessagingMentionsOnConflict>;
};


/** mutation root */
export type mutation_rootinsertMessagingMessageAttachmentArgs = {
  objects: Array<MessagingMessageAttachmentInsertInput>;
  onConflict?: InputMaybe<MessagingMessageAttachmentOnConflict>;
};


/** mutation root */
export type mutation_rootinsertMessagingMessageAttachmentOneArgs = {
  object: MessagingMessageAttachmentInsertInput;
  onConflict?: InputMaybe<MessagingMessageAttachmentOnConflict>;
};


/** mutation root */
export type mutation_rootinsertMessagingMessageAttachmentTypeArgs = {
  objects: Array<MessagingMessageAttachmentTypeInsertInput>;
  onConflict?: InputMaybe<MessagingMessageAttachmentTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertMessagingMessageAttachmentTypeOneArgs = {
  object: MessagingMessageAttachmentTypeInsertInput;
  onConflict?: InputMaybe<MessagingMessageAttachmentTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertMessagingMessagePriorityArgs = {
  objects: Array<MessagingMessagePriorityInsertInput>;
  onConflict?: InputMaybe<MessagingMessagePriorityOnConflict>;
};


/** mutation root */
export type mutation_rootinsertMessagingMessagePriorityOneArgs = {
  object: MessagingMessagePriorityInsertInput;
  onConflict?: InputMaybe<MessagingMessagePriorityOnConflict>;
};


/** mutation root */
export type mutation_rootinsertNotificationNotificationDeviceSentArgs = {
  objects: Array<NotificationNotificationDeviceSentInsertInput>;
  onConflict?: InputMaybe<NotificationNotificationDeviceSentOnConflict>;
};


/** mutation root */
export type mutation_rootinsertNotificationNotificationDeviceSentOneArgs = {
  object: NotificationNotificationDeviceSentInsertInput;
  onConflict?: InputMaybe<NotificationNotificationDeviceSentOnConflict>;
};


/** mutation root */
export type mutation_rootinsertNotificationNotificationSettingActivityPrimaryEnumArgs = {
  objects: Array<NotificationNotificationSettingActivityPrimaryEnumInsertInput>;
  onConflict?: InputMaybe<NotificationNotificationSettingActivityPrimaryEnumOnConflict>;
};


/** mutation root */
export type mutation_rootinsertNotificationNotificationSettingActivityPrimaryEnumOneArgs = {
  object: NotificationNotificationSettingActivityPrimaryEnumInsertInput;
  onConflict?: InputMaybe<NotificationNotificationSettingActivityPrimaryEnumOnConflict>;
};


/** mutation root */
export type mutation_rootinsertOrdersOrganizationsArgs = {
  objects: Array<OrdersOrganizationsInsertInput>;
  onConflict?: InputMaybe<OrdersOrganizationsOnConflict>;
};


/** mutation root */
export type mutation_rootinsertOrdersOrganizationsOneArgs = {
  object: OrdersOrganizationsInsertInput;
  onConflict?: InputMaybe<OrdersOrganizationsOnConflict>;
};


/** mutation root */
export type mutation_rootinsertOrdersRequestArgs = {
  objects: Array<OrdersRequestInsertInput>;
  onConflict?: InputMaybe<OrdersRequestOnConflict>;
};


/** mutation root */
export type mutation_rootinsertOrdersRequestOneArgs = {
  object: OrdersRequestInsertInput;
  onConflict?: InputMaybe<OrdersRequestOnConflict>;
};


/** mutation root */
export type mutation_rootinsertOrdersStatusArgs = {
  objects: Array<OrdersStatusInsertInput>;
  onConflict?: InputMaybe<OrdersStatusOnConflict>;
};


/** mutation root */
export type mutation_rootinsertOrdersStatusOneArgs = {
  object: OrdersStatusInsertInput;
  onConflict?: InputMaybe<OrdersStatusOnConflict>;
};


/** mutation root */
export type mutation_rootinsertOrdersTypeArgs = {
  objects: Array<OrdersTypeInsertInput>;
  onConflict?: InputMaybe<OrdersTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertOrdersTypeOneArgs = {
  object: OrdersTypeInsertInput;
  onConflict?: InputMaybe<OrdersTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertPromptArgs = {
  objects: Array<PromptInsertInput>;
  onConflict?: InputMaybe<PromptOnConflict>;
};


/** mutation root */
export type mutation_rootinsertPromptOneArgs = {
  object: PromptInsertInput;
  onConflict?: InputMaybe<PromptOnConflict>;
};


/** mutation root */
export type mutation_rootinsertQueueItemFlexibilityTypeArgs = {
  objects: Array<QueueItemFlexibilityTypeInsertInput>;
  onConflict?: InputMaybe<QueueItemFlexibilityTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertQueueItemFlexibilityTypeOneArgs = {
  object: QueueItemFlexibilityTypeInsertInput;
  onConflict?: InputMaybe<QueueItemFlexibilityTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertQueueItemParticipantResponsibilityTypeArgs = {
  objects: Array<QueueItemParticipantResponsibilityTypeInsertInput>;
  onConflict?: InputMaybe<QueueItemParticipantResponsibilityTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertQueueItemParticipantResponsibilityTypeOneArgs = {
  object: QueueItemParticipantResponsibilityTypeInsertInput;
  onConflict?: InputMaybe<QueueItemParticipantResponsibilityTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertRelationTypeArgs = {
  objects: Array<RelationTypeInsertInput>;
  onConflict?: InputMaybe<RelationTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertRelationTypeOneArgs = {
  object: RelationTypeInsertInput;
  onConflict?: InputMaybe<RelationTypeOnConflict>;
};


/** mutation root */
export type mutation_rootinsertVoiceTypesArgs = {
  objects: Array<VoiceTypesInsertInput>;
  onConflict?: InputMaybe<VoiceTypesOnConflict>;
};


/** mutation root */
export type mutation_rootinsertVoiceTypesOneArgs = {
  object: VoiceTypesInsertInput;
  onConflict?: InputMaybe<VoiceTypesOnConflict>;
};


/** mutation root */
export type mutation_rootleaveOrganizationArgs = {
  input: leaveOrganizationObject;
};


/** mutation root */
export type mutation_rootlinkMobilitySMSArgs = {
  content?: InputMaybe<LinkMobilitySMSContent>;
  customParameters?: InputMaybe<LinkMobilitySMSCustomParameters>;
  destination?: InputMaybe<Scalars['String']['input']>;
  gateCustomParameters?: InputMaybe<LinkGateCustomParameters>;
  messageId: Scalars['String']['input'];
  operator?: InputMaybe<Scalars['String']['input']>;
  operatorMessageId?: InputMaybe<Scalars['String']['input']>;
  operatorTimestamp?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<LinkMobilitySMSRoute>;
  source?: InputMaybe<Scalars['String']['input']>;
  subNumber?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type mutation_rootmakePhoneRequestArgs = {
  request: PhoneRequestInput;
};


/** mutation root */
export type mutation_rootorderUpdateArgs = {
  order: OrderUpdateInput;
};


/** mutation root */
export type mutation_rootprivatizeUserArgs = {
  id: Scalars['uuid']['input'];
  lightlyBlock?: InputMaybe<Scalars['Boolean']['input']>;
  privatizeAndBlock?: InputMaybe<Scalars['Boolean']['input']>;
};


/** mutation root */
export type mutation_rootremoveCustomerArgs = {
  customer: RemoveCustomerInput;
};


/** mutation root */
export type mutation_rootremoveEmailProviderIntegrationArgs = {
  integration: removeEmailProviderIntegrationInput;
};


/** mutation root */
export type mutation_rootremoveEmailProviderSubscriptionArgs = {
  integration: deleteEmailProviderSubscriptionInput;
};


/** mutation root */
export type mutation_rootremoveOrganizationArgs = {
  org: removeOrganizationInput;
};


/** mutation root */
export type mutation_rootrenewEmailProviderSubscriptionArgs = {
  integration: renewEmailProviderSubscriptionInput;
};


/** mutation root */
export type mutation_rootrequestIntegrationsArgs = {
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  providers: Array<InputMaybe<RequestIntegrationsInput>>;
};


/** mutation root */
export type mutation_rootsearchPhoneApiArgs = {
  search: SearchPhoneInput;
};


/** mutation root */
export type mutation_rootsendEmailArgs = {
  bcc: Scalars['String']['input'];
  body: Scalars['String']['input'];
  cc: Scalars['String']['input'];
  from: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  to: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootsendNotficationArgs = {
  notfication: NotificationInput;
};


/** mutation root */
export type mutation_rootsendSMSArgs = {
  body: Scalars['String']['input'];
  from?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootsendSmsTokenArgs = {
  smsContent?: InputMaybe<Scalars['String']['input']>;
  toMobileNumber?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type mutation_rootsetUpOrganizationArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type mutation_roottestNotificationSettingsArgs = {
  id: Scalars['uuid']['input'];
  number: Scalars['String']['input'];
  receiverNumber: Scalars['String']['input'];
};


/** mutation root */
export type mutation_rootupdateActivityDirectionArgs = {
  _set?: InputMaybe<ActivityDirectionSetInput>;
  where: ActivityDirectionBoolExp;
};


/** mutation root */
export type mutation_rootupdateActivityDirectionByPkArgs = {
  _set?: InputMaybe<ActivityDirectionSetInput>;
  pkColumns: ActivityDirectionPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateActivityDirectionManyArgs = {
  updates: Array<ActivityDirectionUpdates>;
};


/** mutation root */
export type mutation_rootupdateActivityParticipantArgs = {
  _set?: InputMaybe<activityParticipantSetInput>;
  pkColumns: activityParticipantPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateActivityParticipantsArgs = {
  _set?: InputMaybe<activityParticipantSetInput>;
  where: activityParticipantBoolExp;
};


/** mutation root */
export type mutation_rootupdateActivityProviderArgs = {
  _set?: InputMaybe<ActivityProviderSetInput>;
  where: ActivityProviderBoolExp;
};


/** mutation root */
export type mutation_rootupdateActivityProviderByPkArgs = {
  _set?: InputMaybe<ActivityProviderSetInput>;
  pkColumns: ActivityProviderPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateActivityProviderManyArgs = {
  updates: Array<ActivityProviderUpdates>;
};


/** mutation root */
export type mutation_rootupdateActivityStatusArgs = {
  _set?: InputMaybe<ActivityStatusSetInput>;
  pkColumns: ActivityStatusPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateActivityStatusesArgs = {
  _set?: InputMaybe<ActivityStatusSetInput>;
  where: ActivityStatusBoolExp;
};


/** mutation root */
export type mutation_rootupdateActivityTypeArgs = {
  _set?: InputMaybe<ActivityTypeSetInput>;
  pkColumns: ActivityTypePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateActivityTypesArgs = {
  _set?: InputMaybe<ActivityTypeSetInput>;
  where: ActivityTypeBoolExp;
};


/** mutation root */
export type mutation_rootupdateAddressArgs = {
  _set?: InputMaybe<addressSetInput>;
  pkColumns: addressPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateAddressesArgs = {
  _set?: InputMaybe<addressSetInput>;
  where: addressBoolExp;
};


/** mutation root */
export type mutation_rootupdateBlockedDomainUserArgs = {
  _set?: InputMaybe<blockedDomainUserSetInput>;
  pkColumns: blockedDomainUserPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateBlockedDomainUsersArgs = {
  _set?: InputMaybe<blockedDomainUserSetInput>;
  where: blockedDomainUserBoolExp;
};


/** mutation root */
export type mutation_rootupdateBusinessDomainActivityTypeArgs = {
  _set?: InputMaybe<BusinessDomainActivityTypeSetInput>;
  where: BusinessDomainActivityTypeBoolExp;
};


/** mutation root */
export type mutation_rootupdateBusinessDomainActivityTypeByPkArgs = {
  _set?: InputMaybe<BusinessDomainActivityTypeSetInput>;
  pkColumns: BusinessDomainActivityTypePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateBusinessDomainActivityTypeManyArgs = {
  updates: Array<BusinessDomainActivityTypeUpdates>;
};


/** mutation root */
export type mutation_rootupdateBusinessFeedTypeArgs = {
  _set?: InputMaybe<BusinessFeedTypeSetInput>;
  where: BusinessFeedTypeBoolExp;
};


/** mutation root */
export type mutation_rootupdateBusinessFeedTypeByPkArgs = {
  _set?: InputMaybe<BusinessFeedTypeSetInput>;
  pkColumns: BusinessFeedTypePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateBusinessFeedTypeManyArgs = {
  updates: Array<BusinessFeedTypeUpdates>;
};


/** mutation root */
export type mutation_rootupdateBusinessMessageAttachmentsArgs = {
  _set?: InputMaybe<BusinessMessageAttachmentsSetInput>;
  where: BusinessMessageAttachmentsBoolExp;
};


/** mutation root */
export type mutation_rootupdateBusinessMessageAttachmentsByPkArgs = {
  _set?: InputMaybe<BusinessMessageAttachmentsSetInput>;
  pkColumns: BusinessMessageAttachmentsPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateBusinessMessageAttachmentsManyArgs = {
  updates: Array<BusinessMessageAttachmentsUpdates>;
};


/** mutation root */
export type mutation_rootupdateBusinessOrganizationUserCallbackAnswerArgs = {
  _set?: InputMaybe<BusinessOrganizationUserCallbackAnswerSetInput>;
  where: BusinessOrganizationUserCallbackAnswerBoolExp;
};


/** mutation root */
export type mutation_rootupdateBusinessOrganizationUserCallbackAnswerByPkArgs = {
  _set?: InputMaybe<BusinessOrganizationUserCallbackAnswerSetInput>;
  pkColumns: BusinessOrganizationUserCallbackAnswerPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateBusinessOrganizationUserCallbackAnswerManyArgs = {
  updates: Array<BusinessOrganizationUserCallbackAnswerUpdates>;
};


/** mutation root */
export type mutation_rootupdateBusinessOrganizationUserEmailArgs = {
  _set?: InputMaybe<BusinessOrganizationUserEmailSetInput>;
  where: BusinessOrganizationUserEmailBoolExp;
};


/** mutation root */
export type mutation_rootupdateBusinessOrganizationUserEmailByPkArgs = {
  _set?: InputMaybe<BusinessOrganizationUserEmailSetInput>;
  pkColumns: BusinessOrganizationUserEmailPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateBusinessOrganizationUserEmailManyArgs = {
  updates: Array<BusinessOrganizationUserEmailUpdates>;
};


/** mutation root */
export type mutation_rootupdateBusinessOrganizationUserEmailTypeArgs = {
  _set?: InputMaybe<BusinessOrganizationUserEmailTypeSetInput>;
  where: BusinessOrganizationUserEmailTypeBoolExp;
};


/** mutation root */
export type mutation_rootupdateBusinessOrganizationUserEmailTypeByPkArgs = {
  _set?: InputMaybe<BusinessOrganizationUserEmailTypeSetInput>;
  pkColumns: BusinessOrganizationUserEmailTypePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateBusinessOrganizationUserEmailTypeManyArgs = {
  updates: Array<BusinessOrganizationUserEmailTypeUpdates>;
};


/** mutation root */
export type mutation_rootupdateBusinessOrganizationUserRequestManyArgs = {
  updates: Array<BusinessOrganizationUserRequestUpdates>;
};


/** mutation root */
export type mutation_rootupdateBusinessOrganizationUserRequestTypeArgs = {
  _set?: InputMaybe<BusinessOrganizationUserRequestTypeSetInput>;
  where: BusinessOrganizationUserRequestTypeBoolExp;
};


/** mutation root */
export type mutation_rootupdateBusinessOrganizationUserRequestTypeByPkArgs = {
  _set?: InputMaybe<BusinessOrganizationUserRequestTypeSetInput>;
  pkColumns: BusinessOrganizationUserRequestTypePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateBusinessOrganizationUserRequestTypeManyArgs = {
  updates: Array<BusinessOrganizationUserRequestTypeUpdates>;
};


/** mutation root */
export type mutation_rootupdateBusinessOrganizationUserSuggestionTypeArgs = {
  _set?: InputMaybe<BusinessOrganizationUserSuggestionTypeSetInput>;
  where: BusinessOrganizationUserSuggestionTypeBoolExp;
};


/** mutation root */
export type mutation_rootupdateBusinessOrganizationUserSuggestionTypeByPkArgs = {
  _set?: InputMaybe<BusinessOrganizationUserSuggestionTypeSetInput>;
  pkColumns: BusinessOrganizationUserSuggestionTypePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateBusinessOrganizationUserSuggestionTypeManyArgs = {
  updates: Array<BusinessOrganizationUserSuggestionTypeUpdates>;
};


/** mutation root */
export type mutation_rootupdateBusinessOrganizationUserSuggestionsArgs = {
  _set?: InputMaybe<BusinessOrganizationUserSuggestionsSetInput>;
  where: BusinessOrganizationUserSuggestionsBoolExp;
};


/** mutation root */
export type mutation_rootupdateBusinessOrganizationUserSuggestionsByPkArgs = {
  _set?: InputMaybe<BusinessOrganizationUserSuggestionsSetInput>;
  pkColumns: BusinessOrganizationUserSuggestionsPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateBusinessOrganizationUserSuggestionsManyArgs = {
  updates: Array<BusinessOrganizationUserSuggestionsUpdates>;
};


/** mutation root */
export type mutation_rootupdateBusinessOrganizationUserUrlAddressArgs = {
  _set?: InputMaybe<BusinessOrganizationUserUrlAddressSetInput>;
  where: BusinessOrganizationUserUrlAddressBoolExp;
};


/** mutation root */
export type mutation_rootupdateBusinessOrganizationUserUrlAddressByPkArgs = {
  _set?: InputMaybe<BusinessOrganizationUserUrlAddressSetInput>;
  pkColumns: BusinessOrganizationUserUrlAddressPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateBusinessOrganizationUserUrlAddressManyArgs = {
  updates: Array<BusinessOrganizationUserUrlAddressUpdates>;
};


/** mutation root */
export type mutation_rootupdateBusinessOrganizationUserUrlAddressTypeArgs = {
  _set?: InputMaybe<BusinessOrganizationUserUrlAddressTypeSetInput>;
  where: BusinessOrganizationUserUrlAddressTypeBoolExp;
};


/** mutation root */
export type mutation_rootupdateBusinessOrganizationUserUrlAddressTypeByPkArgs = {
  _set?: InputMaybe<BusinessOrganizationUserUrlAddressTypeSetInput>;
  pkColumns: BusinessOrganizationUserUrlAddressTypePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateBusinessOrganizationUserUrlAddressTypeManyArgs = {
  updates: Array<BusinessOrganizationUserUrlAddressTypeUpdates>;
};


/** mutation root */
export type mutation_rootupdateBusinessQueueItemAlarmTypeArgs = {
  _set?: InputMaybe<BusinessQueueItemAlarmTypeSetInput>;
  where: BusinessQueueItemAlarmTypeBoolExp;
};


/** mutation root */
export type mutation_rootupdateBusinessQueueItemAlarmTypeByPkArgs = {
  _set?: InputMaybe<BusinessQueueItemAlarmTypeSetInput>;
  pkColumns: BusinessQueueItemAlarmTypePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateBusinessQueueItemAlarmTypeManyArgs = {
  updates: Array<BusinessQueueItemAlarmTypeUpdates>;
};


/** mutation root */
export type mutation_rootupdateBusinessQueueItemAlarmsArgs = {
  _inc?: InputMaybe<BusinessQueueItemAlarmsIncInput>;
  _set?: InputMaybe<BusinessQueueItemAlarmsSetInput>;
  where: BusinessQueueItemAlarmsBoolExp;
};


/** mutation root */
export type mutation_rootupdateBusinessQueueItemAlarmsByPkArgs = {
  _inc?: InputMaybe<BusinessQueueItemAlarmsIncInput>;
  _set?: InputMaybe<BusinessQueueItemAlarmsSetInput>;
  pkColumns: BusinessQueueItemAlarmsPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateBusinessQueueItemAlarmsManyArgs = {
  updates: Array<BusinessQueueItemAlarmsUpdates>;
};


/** mutation root */
export type mutation_rootupdateBusinessQueueItemCollaborationArgs = {
  _inc?: InputMaybe<businessQueueItemCollaborationIncInput>;
  _set?: InputMaybe<businessQueueItemCollaborationSetInput>;
  pkColumns: businessQueueItemCollaborationPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateBusinessQueueItemCollaborationsArgs = {
  _inc?: InputMaybe<businessQueueItemCollaborationIncInput>;
  _set?: InputMaybe<businessQueueItemCollaborationSetInput>;
  where: businessQueueItemCollaborationBoolExp;
};


/** mutation root */
export type mutation_rootupdateBusinessQueueItemParticipantChannelTypeArgs = {
  _set?: InputMaybe<BusinessQueueItemParticipantChannelTypeSetInput>;
  where: BusinessQueueItemParticipantChannelTypeBoolExp;
};


/** mutation root */
export type mutation_rootupdateBusinessQueueItemParticipantChannelTypeByPkArgs = {
  _set?: InputMaybe<BusinessQueueItemParticipantChannelTypeSetInput>;
  pkColumns: BusinessQueueItemParticipantChannelTypePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateBusinessQueueItemParticipantChannelTypeManyArgs = {
  updates: Array<BusinessQueueItemParticipantChannelTypeUpdates>;
};


/** mutation root */
export type mutation_rootupdateBusinessQueueItemSubTypeArgs = {
  _set?: InputMaybe<BusinessQueueItemSubTypeSetInput>;
  where: BusinessQueueItemSubTypeBoolExp;
};


/** mutation root */
export type mutation_rootupdateBusinessQueueItemSubTypeByPkArgs = {
  _set?: InputMaybe<BusinessQueueItemSubTypeSetInput>;
  pkColumns: BusinessQueueItemSubTypePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateBusinessQueueItemSubTypeManyArgs = {
  updates: Array<BusinessQueueItemSubTypeUpdates>;
};


/** mutation root */
export type mutation_rootupdateBusinessUserContactArgs = {
  _set?: InputMaybe<businessUserContactsSetInput>;
  pkColumns: businessUserContactsPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateBusinessUserContactNumbersArgs = {
  _set?: InputMaybe<BusinessUserContactNumbersSetInput>;
  where: BusinessUserContactNumbersBoolExp;
};


/** mutation root */
export type mutation_rootupdateBusinessUserContactNumbersByPkArgs = {
  _set?: InputMaybe<BusinessUserContactNumbersSetInput>;
  pkColumns: BusinessUserContactNumbersPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateBusinessUserContactNumbersManyArgs = {
  updates: Array<BusinessUserContactNumbersUpdates>;
};


/** mutation root */
export type mutation_rootupdateBusinessUserContactsArgs = {
  _set?: InputMaybe<businessUserContactsSetInput>;
  where: businessUserContactsBoolExp;
};


/** mutation root */
export type mutation_rootupdateBusinessUserFeedArgs = {
  _append?: InputMaybe<BusinessUserFeedAppendInput>;
  _deleteAtPath?: InputMaybe<BusinessUserFeedDeleteAtPathInput>;
  _deleteElem?: InputMaybe<BusinessUserFeedDeleteElemInput>;
  _deleteKey?: InputMaybe<BusinessUserFeedDeleteKeyInput>;
  _prepend?: InputMaybe<BusinessUserFeedPrependInput>;
  _set?: InputMaybe<BusinessUserFeedSetInput>;
  where: BusinessUserFeedBoolExp;
};


/** mutation root */
export type mutation_rootupdateBusinessUserFeedByPkArgs = {
  _append?: InputMaybe<BusinessUserFeedAppendInput>;
  _deleteAtPath?: InputMaybe<BusinessUserFeedDeleteAtPathInput>;
  _deleteElem?: InputMaybe<BusinessUserFeedDeleteElemInput>;
  _deleteKey?: InputMaybe<BusinessUserFeedDeleteKeyInput>;
  _prepend?: InputMaybe<BusinessUserFeedPrependInput>;
  _set?: InputMaybe<BusinessUserFeedSetInput>;
  pkColumns: BusinessUserFeedPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateBusinessUserFeedManyArgs = {
  updates: Array<BusinessUserFeedUpdates>;
};


/** mutation root */
export type mutation_rootupdateBusinessUserRequestStatusArgs = {
  _set?: InputMaybe<BusinessUserRequestStatusSetInput>;
  where: BusinessUserRequestStatusBoolExp;
};


/** mutation root */
export type mutation_rootupdateBusinessUserRequestStatusByPkArgs = {
  _set?: InputMaybe<BusinessUserRequestStatusSetInput>;
  pkColumns: BusinessUserRequestStatusPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateBusinessUserRequestStatusManyArgs = {
  updates: Array<BusinessUserRequestStatusUpdates>;
};


/** mutation root */
export type mutation_rootupdateBusinessUserSettingArgs = {
  _inc?: InputMaybe<businessUserSettingsIncInput>;
  _set?: InputMaybe<businessUserSettingsSetInput>;
  pkColumns: businessUserSettingsPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateBusinessUserSettingsArgs = {
  _inc?: InputMaybe<businessUserSettingsIncInput>;
  _set?: InputMaybe<businessUserSettingsSetInput>;
  where: businessUserSettingsBoolExp;
};


/** mutation root */
export type mutation_rootupdateBusinessUserStatesArgs = {
  _set?: InputMaybe<BusinessUserStatesSetInput>;
  where: BusinessUserStatesBoolExp;
};


/** mutation root */
export type mutation_rootupdateBusinessUserStatesByPkArgs = {
  _set?: InputMaybe<BusinessUserStatesSetInput>;
  pkColumns: BusinessUserStatesPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateBusinessUserStatesManyArgs = {
  updates: Array<BusinessUserStatesUpdates>;
};


/** mutation root */
export type mutation_rootupdateCrmContextArgs = {
  _set?: InputMaybe<CrmContextSetInput>;
  where: CrmContextBoolExp;
};


/** mutation root */
export type mutation_rootupdateCrmContextByPkArgs = {
  _set?: InputMaybe<CrmContextSetInput>;
  pkColumns: CrmContextPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateCrmContextManyArgs = {
  updates: Array<CrmContextUpdates>;
};


/** mutation root */
export type mutation_rootupdateCrmContextTypeArgs = {
  _set?: InputMaybe<CrmContextTypeSetInput>;
  where: CrmContextTypeBoolExp;
};


/** mutation root */
export type mutation_rootupdateCrmContextTypeByPkArgs = {
  _set?: InputMaybe<CrmContextTypeSetInput>;
  pkColumns: CrmContextTypePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateCrmContextTypeManyArgs = {
  updates: Array<CrmContextTypeUpdates>;
};


/** mutation root */
export type mutation_rootupdateCrmCreatorTypeArgs = {
  _set?: InputMaybe<CrmCreatorTypeSetInput>;
  where: CrmCreatorTypeBoolExp;
};


/** mutation root */
export type mutation_rootupdateCrmCreatorTypeByPkArgs = {
  _set?: InputMaybe<CrmCreatorTypeSetInput>;
  pkColumns: CrmCreatorTypePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateCrmCreatorTypeManyArgs = {
  updates: Array<CrmCreatorTypeUpdates>;
};


/** mutation root */
export type mutation_rootupdateCrmCrmTypeArgs = {
  _set?: InputMaybe<CrmCrmTypeSetInput>;
  where: CrmCrmTypeBoolExp;
};


/** mutation root */
export type mutation_rootupdateCrmCrmTypeByPkArgs = {
  _set?: InputMaybe<CrmCrmTypeSetInput>;
  pkColumns: CrmCrmTypePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateCrmCrmTypeManyArgs = {
  updates: Array<CrmCrmTypeUpdates>;
};


/** mutation root */
export type mutation_rootupdateCrmDirectionTypeArgs = {
  _set?: InputMaybe<CrmDirectionTypeSetInput>;
  where: CrmDirectionTypeBoolExp;
};


/** mutation root */
export type mutation_rootupdateCrmDirectionTypeByPkArgs = {
  _set?: InputMaybe<CrmDirectionTypeSetInput>;
  pkColumns: CrmDirectionTypePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateCrmDirectionTypeManyArgs = {
  updates: Array<CrmDirectionTypeUpdates>;
};


/** mutation root */
export type mutation_rootupdateCrmEntityArgs = {
  _set?: InputMaybe<CrmEntitySetInput>;
  where: CrmEntityBoolExp;
};


/** mutation root */
export type mutation_rootupdateCrmEntityByPkArgs = {
  _set?: InputMaybe<CrmEntitySetInput>;
  pkColumns: CrmEntityPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateCrmEntityManyArgs = {
  updates: Array<CrmEntityUpdates>;
};


/** mutation root */
export type mutation_rootupdateCrmEventArgs = {
  _set?: InputMaybe<CrmEventSetInput>;
  where: CrmEventBoolExp;
};


/** mutation root */
export type mutation_rootupdateCrmEventByPkArgs = {
  _set?: InputMaybe<CrmEventSetInput>;
  pkColumns: CrmEventPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateCrmEventManyArgs = {
  updates: Array<CrmEventUpdates>;
};


/** mutation root */
export type mutation_rootupdateCrmEventTypeArgs = {
  _set?: InputMaybe<CrmEventTypeSetInput>;
  where: CrmEventTypeBoolExp;
};


/** mutation root */
export type mutation_rootupdateCrmEventTypeByPkArgs = {
  _set?: InputMaybe<CrmEventTypeSetInput>;
  pkColumns: CrmEventTypePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateCrmEventTypeManyArgs = {
  updates: Array<CrmEventTypeUpdates>;
};


/** mutation root */
export type mutation_rootupdateCrmStatusCodeArgs = {
  _set?: InputMaybe<CrmStatusCodeSetInput>;
  where: CrmStatusCodeBoolExp;
};


/** mutation root */
export type mutation_rootupdateCrmStatusCodeByPkArgs = {
  _set?: InputMaybe<CrmStatusCodeSetInput>;
  pkColumns: CrmStatusCodePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateCrmStatusCodeManyArgs = {
  updates: Array<CrmStatusCodeUpdates>;
};


/** mutation root */
export type mutation_rootupdateCrmStatusMessageArgs = {
  _append?: InputMaybe<crmStatusMessageAppendInput>;
  _deleteAtPath?: InputMaybe<crmStatusMessageDeleteAtPathInput>;
  _deleteElem?: InputMaybe<crmStatusMessageDeleteElemInput>;
  _deleteKey?: InputMaybe<crmStatusMessageDeleteKeyInput>;
  _inc?: InputMaybe<crmStatusMessageIncInput>;
  _prepend?: InputMaybe<crmStatusMessagePrependInput>;
  _set?: InputMaybe<crmStatusMessageSetInput>;
  pkColumns: crmStatusMessagePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateCrmStatusMessageManyArgs = {
  updates: Array<crmStatusMessageUpdates>;
};


/** mutation root */
export type mutation_rootupdateCrmStatusMessagesArgs = {
  _append?: InputMaybe<crmStatusMessageAppendInput>;
  _deleteAtPath?: InputMaybe<crmStatusMessageDeleteAtPathInput>;
  _deleteElem?: InputMaybe<crmStatusMessageDeleteElemInput>;
  _deleteKey?: InputMaybe<crmStatusMessageDeleteKeyInput>;
  _inc?: InputMaybe<crmStatusMessageIncInput>;
  _prepend?: InputMaybe<crmStatusMessagePrependInput>;
  _set?: InputMaybe<crmStatusMessageSetInput>;
  where: crmStatusMessageBoolExp;
};


/** mutation root */
export type mutation_rootupdateCrmSystemTypeArgs = {
  _set?: InputMaybe<CrmSystemTypeSetInput>;
  where: CrmSystemTypeBoolExp;
};


/** mutation root */
export type mutation_rootupdateCrmSystemTypeByPkArgs = {
  _set?: InputMaybe<CrmSystemTypeSetInput>;
  pkColumns: CrmSystemTypePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateCrmSystemTypeManyArgs = {
  updates: Array<CrmSystemTypeUpdates>;
};


/** mutation root */
export type mutation_rootupdateCrmTraceContextArgs = {
  _set?: InputMaybe<CrmTraceContextSetInput>;
  where: CrmTraceContextBoolExp;
};


/** mutation root */
export type mutation_rootupdateCrmTraceContextByPkArgs = {
  _set?: InputMaybe<CrmTraceContextSetInput>;
  pkColumns: CrmTraceContextPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateCrmTraceContextManyArgs = {
  updates: Array<CrmTraceContextUpdates>;
};


/** mutation root */
export type mutation_rootupdateCrmUnifiedEntityTypeArgs = {
  _set?: InputMaybe<CrmUnifiedEntityTypeSetInput>;
  where: CrmUnifiedEntityTypeBoolExp;
};


/** mutation root */
export type mutation_rootupdateCrmUnifiedEntityTypeByPkArgs = {
  _set?: InputMaybe<CrmUnifiedEntityTypeSetInput>;
  pkColumns: CrmUnifiedEntityTypePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateCrmUnifiedEntityTypeManyArgs = {
  updates: Array<CrmUnifiedEntityTypeUpdates>;
};


/** mutation root */
export type mutation_rootupdateCrmYoutelloCatalystIdMappingArgs = {
  _inc?: InputMaybe<crmYoutelloCatalystIdMappingIncInput>;
  _set?: InputMaybe<crmYoutelloCatalystIdMappingSetInput>;
  where: crmYoutelloCatalystIdMappingBoolExp;
};


/** mutation root */
export type mutation_rootupdateCrmYoutelloCatalystIdMappingByPkArgs = {
  _inc?: InputMaybe<crmYoutelloCatalystIdMappingIncInput>;
  _set?: InputMaybe<crmYoutelloCatalystIdMappingSetInput>;
  pkColumns: crmYoutelloCatalystIdMappingPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateCrmYoutelloCatalystIdMappingManyArgs = {
  updates: Array<crmYoutelloCatalystIdMappingUpdates>;
};


/** mutation root */
export type mutation_rootupdateDashboardDataArgs = {
  changeForAll?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['uuid']['input'];
  useExpo?: InputMaybe<Scalars['Boolean']['input']>;
};


/** mutation root */
export type mutation_rootupdateDomainActivitiesArgs = {
  _append?: InputMaybe<domainActivityAppendInput>;
  _deleteAtPath?: InputMaybe<domainActivityDeleteAtPathInput>;
  _deleteElem?: InputMaybe<domainActivityDeleteElemInput>;
  _deleteKey?: InputMaybe<domainActivityDeleteKeyInput>;
  _inc?: InputMaybe<domainActivityIncInput>;
  _prepend?: InputMaybe<domainActivityPrependInput>;
  _set?: InputMaybe<domainActivitySetInput>;
  where: domainActivityBoolExp;
};


/** mutation root */
export type mutation_rootupdateDomainActivityArgs = {
  _append?: InputMaybe<domainActivityAppendInput>;
  _deleteAtPath?: InputMaybe<domainActivityDeleteAtPathInput>;
  _deleteElem?: InputMaybe<domainActivityDeleteElemInput>;
  _deleteKey?: InputMaybe<domainActivityDeleteKeyInput>;
  _inc?: InputMaybe<domainActivityIncInput>;
  _prepend?: InputMaybe<domainActivityPrependInput>;
  _set?: InputMaybe<domainActivitySetInput>;
  pkColumns: domainActivityPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateDomainOrganizationArgs = {
  _set?: InputMaybe<domainOrganizationSetInput>;
  pkColumns: domainOrganizationPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateDomainOrganizationsArgs = {
  _set?: InputMaybe<domainOrganizationSetInput>;
  where: domainOrganizationBoolExp;
};


/** mutation root */
export type mutation_rootupdateDomainParticipantArgs = {
  _set?: InputMaybe<domainParticipantSetInput>;
  pkColumns: domainParticipantPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateDomainParticipantsArgs = {
  _set?: InputMaybe<domainParticipantSetInput>;
  where: domainParticipantBoolExp;
};


/** mutation root */
export type mutation_rootupdateDomainTypeArgs = {
  _set?: InputMaybe<domainTypeSetInput>;
  pkColumns: domainTypePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateDomainTypesArgs = {
  _set?: InputMaybe<domainTypeSetInput>;
  where: domainTypeBoolExp;
};


/** mutation root */
export type mutation_rootupdateDomainUserArgs = {
  _inc?: InputMaybe<domainUserIncInput>;
  _set?: InputMaybe<domainUserSetInput>;
  pkColumns: domainUserPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateDomainUserCategoriesArgs = {
  _set?: InputMaybe<domainUserCategorySetInput>;
  where: domainUserCategoryBoolExp;
};


/** mutation root */
export type mutation_rootupdateDomainUserCategoryArgs = {
  _set?: InputMaybe<domainUserCategorySetInput>;
  pkColumns: domainUserCategoryPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateDomainUsersArgs = {
  _inc?: InputMaybe<domainUserIncInput>;
  _set?: InputMaybe<domainUserSetInput>;
  where: domainUserBoolExp;
};


/** mutation root */
export type mutation_rootupdateLanguagesArgs = {
  _set?: InputMaybe<languagesSetInput>;
  where: languagesBoolExp;
};


/** mutation root */
export type mutation_rootupdateLanguagesByPkArgs = {
  _set?: InputMaybe<languagesSetInput>;
  pkColumns: languagesPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateLanguagesManyArgs = {
  updates: Array<languagesUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyActivityParticipantsArgs = {
  updates: Array<activityParticipantUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyActivityStatusesArgs = {
  updates: Array<ActivityStatusUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyActivityTypesArgs = {
  updates: Array<ActivityTypeUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyAddressesArgs = {
  updates: Array<addressUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyBlockedDomainUsersArgs = {
  updates: Array<blockedDomainUserUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyBusinessQueueItemCollaborationsArgs = {
  updates: Array<businessQueueItemCollaborationUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyBusinessUserContactsArgs = {
  updates: Array<businessUserContactsUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyBusinessUserSettingsArgs = {
  updates: Array<businessUserSettingsUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyDomainActivitiesArgs = {
  updates: Array<domainActivityUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyDomainOrganizationsArgs = {
  updates: Array<domainOrganizationUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyDomainParticipantsArgs = {
  updates: Array<domainParticipantUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyDomainTypesArgs = {
  updates: Array<domainTypeUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyDomainUserCategoriesArgs = {
  updates: Array<domainUserCategoryUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyDomainUsersArgs = {
  updates: Array<domainUserUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyMessageTypesArgs = {
  updates: Array<messageTypeUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyMessagesArgs = {
  updates: Array<messageUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyMessagingActivityOrganizationsArgs = {
  updates: Array<messagingActivityOrganizationUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyNotificationSendsArgs = {
  updates: Array<notificationSendUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyNotificationSettingActivitiesArgs = {
  updates: Array<notificationSettingActivityUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyNotificationUserDevicesArgs = {
  updates: Array<notificationUserDeviceUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyNotificationUsersArgs = {
  updates: Array<notificationUserUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyNotificationsArgs = {
  updates: Array<notificationUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyOrdersIntegrationsArgs = {
  updates: Array<ordersIntegrationsUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyOrganizationUserAttachmentsArgs = {
  updates: Array<organizationUserAttachmentsUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyOrganizationUserAttentionNotesArgs = {
  updates: Array<OrganizationUserAttentionNoteUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyOrganizationUserDetailTypesArgs = {
  updates: Array<organizationUserDetailTypeUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyOrganizationUserDetailsArgs = {
  updates: Array<organizationUserDetailUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyOrganizationUserInvitesArgs = {
  updates: Array<organizationUserInviteUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyOrganizationUserStatusesArgs = {
  updates: Array<organizationUserStatusUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyOrganizationUsersArgs = {
  updates: Array<organizationUserUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyOrganizationsArgs = {
  updates: Array<organizationUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyPhoneNumberVerificationStatusesArgs = {
  updates: Array<phoneNumberVerificationStatusUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyQueueItemsArgs = {
  updates: Array<queueItemUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyRelOrganizationUserDomainUsersArgs = {
  updates: Array<relOrganizationUserDomainUserUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyUserDetailsArgs = {
  updates: Array<userDetailUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyUserDetailsTypesArgs = {
  updates: Array<userDetailsTypeUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyUserDevicesArgs = {
  updates: Array<userDeviceUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyUserPhoneNumbersArgs = {
  updates: Array<userPhoneNumberUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyUserRolesArgs = {
  updates: Array<userRoleUpdates>;
};


/** mutation root */
export type mutation_rootupdateManyUsersArgs = {
  updates: Array<userUpdates>;
};


/** mutation root */
export type mutation_rootupdateMessageArgs = {
  _set?: InputMaybe<messageSetInput>;
  pkColumns: messagePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateMessageTypeArgs = {
  _set?: InputMaybe<messageTypeSetInput>;
  pkColumns: messageTypePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateMessageTypesArgs = {
  _set?: InputMaybe<messageTypeSetInput>;
  where: messageTypeBoolExp;
};


/** mutation root */
export type mutation_rootupdateMessagesArgs = {
  _set?: InputMaybe<messageSetInput>;
  where: messageBoolExp;
};


/** mutation root */
export type mutation_rootupdateMessagingActivitiesArgs = {
  _set?: InputMaybe<messagingActivitySetInput>;
  where: messagingActivityBoolExp;
};


/** mutation root */
export type mutation_rootupdateMessagingActivityArgs = {
  _set?: InputMaybe<messagingActivitySetInput>;
  pkColumns: messagingActivityPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateMessagingActivityManyArgs = {
  updates: Array<messagingActivityUpdates>;
};


/** mutation root */
export type mutation_rootupdateMessagingActivityOrganizationArgs = {
  _set?: InputMaybe<messagingActivityOrganizationSetInput>;
  pkColumns: messagingActivityOrganizationPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateMessagingActivityOrganizationsArgs = {
  _set?: InputMaybe<messagingActivityOrganizationSetInput>;
  where: messagingActivityOrganizationBoolExp;
};


/** mutation root */
export type mutation_rootupdateMessagingActivitySettingsArgs = {
  _set?: InputMaybe<MessagingActivitySettingsSetInput>;
  where: MessagingActivitySettingsBoolExp;
};


/** mutation root */
export type mutation_rootupdateMessagingActivitySettingsByPkArgs = {
  _set?: InputMaybe<MessagingActivitySettingsSetInput>;
  pkColumns: MessagingActivitySettingsPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateMessagingActivitySettingsManyArgs = {
  updates: Array<MessagingActivitySettingsUpdates>;
};


/** mutation root */
export type mutation_rootupdateMessagingActivitySettingsNotificationSettingTypeArgs = {
  _set?: InputMaybe<MessagingActivitySettingsNotificationSettingTypeSetInput>;
  where: MessagingActivitySettingsNotificationSettingTypeBoolExp;
};


/** mutation root */
export type mutation_rootupdateMessagingActivitySettingsNotificationSettingTypeByPkArgs = {
  _set?: InputMaybe<MessagingActivitySettingsNotificationSettingTypeSetInput>;
  pkColumns: MessagingActivitySettingsNotificationSettingTypePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateMessagingActivitySettingsNotificationSettingTypeManyArgs = {
  updates: Array<MessagingActivitySettingsNotificationSettingTypeUpdates>;
};


/** mutation root */
export type mutation_rootupdateMessagingActivityTypeArgs = {
  _set?: InputMaybe<messagingActivityTypeSetInput>;
  pkColumns: messagingActivityTypePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateMessagingActivityTypeManyArgs = {
  updates: Array<messagingActivityTypeUpdates>;
};


/** mutation root */
export type mutation_rootupdateMessagingActivityTypesArgs = {
  _set?: InputMaybe<messagingActivityTypeSetInput>;
  where: messagingActivityTypeBoolExp;
};


/** mutation root */
export type mutation_rootupdateMessagingActivityUserArgs = {
  _inc?: InputMaybe<messagingActivityUserIncInput>;
  _set?: InputMaybe<messagingActivityUserSetInput>;
  pkColumns: messagingActivityUserPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateMessagingActivityUserManyArgs = {
  updates: Array<messagingActivityUserUpdates>;
};


/** mutation root */
export type mutation_rootupdateMessagingActivityUsersArgs = {
  _inc?: InputMaybe<messagingActivityUserIncInput>;
  _set?: InputMaybe<messagingActivityUserSetInput>;
  where: messagingActivityUserBoolExp;
};


/** mutation root */
export type mutation_rootupdateMessagingInvitationArgs = {
  _set?: InputMaybe<MessagingInvitationSetInput>;
  where: MessagingInvitationBoolExp;
};


/** mutation root */
export type mutation_rootupdateMessagingInvitationByPkArgs = {
  _set?: InputMaybe<MessagingInvitationSetInput>;
  pkColumns: MessagingInvitationPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateMessagingInvitationManyArgs = {
  updates: Array<MessagingInvitationUpdates>;
};


/** mutation root */
export type mutation_rootupdateMessagingMentionsArgs = {
  _set?: InputMaybe<MessagingMentionsSetInput>;
  where: MessagingMentionsBoolExp;
};


/** mutation root */
export type mutation_rootupdateMessagingMentionsByPkArgs = {
  _set?: InputMaybe<MessagingMentionsSetInput>;
  pkColumns: MessagingMentionsPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateMessagingMentionsManyArgs = {
  updates: Array<MessagingMentionsUpdates>;
};


/** mutation root */
export type mutation_rootupdateMessagingMessageArgs = {
  _set?: InputMaybe<messagingMessageSetInput>;
  pkColumns: messagingMessagePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateMessagingMessageAttachmentArgs = {
  _set?: InputMaybe<MessagingMessageAttachmentSetInput>;
  where: MessagingMessageAttachmentBoolExp;
};


/** mutation root */
export type mutation_rootupdateMessagingMessageAttachmentByPkArgs = {
  _set?: InputMaybe<MessagingMessageAttachmentSetInput>;
  pkColumns: MessagingMessageAttachmentPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateMessagingMessageAttachmentManyArgs = {
  updates: Array<MessagingMessageAttachmentUpdates>;
};


/** mutation root */
export type mutation_rootupdateMessagingMessageAttachmentTypeArgs = {
  _set?: InputMaybe<MessagingMessageAttachmentTypeSetInput>;
  where: MessagingMessageAttachmentTypeBoolExp;
};


/** mutation root */
export type mutation_rootupdateMessagingMessageAttachmentTypeByPkArgs = {
  _set?: InputMaybe<MessagingMessageAttachmentTypeSetInput>;
  pkColumns: MessagingMessageAttachmentTypePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateMessagingMessageAttachmentTypeManyArgs = {
  updates: Array<MessagingMessageAttachmentTypeUpdates>;
};


/** mutation root */
export type mutation_rootupdateMessagingMessageEmojiArgs = {
  _set?: InputMaybe<messagingMessageEmojiSetInput>;
  pkColumns: messagingMessageEmojiPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateMessagingMessageEmojiManyArgs = {
  updates: Array<messagingMessageEmojiUpdates>;
};


/** mutation root */
export type mutation_rootupdateMessagingMessageEmojisArgs = {
  _set?: InputMaybe<messagingMessageEmojiSetInput>;
  where: messagingMessageEmojiBoolExp;
};


/** mutation root */
export type mutation_rootupdateMessagingMessageManyArgs = {
  updates: Array<messagingMessageUpdates>;
};


/** mutation root */
export type mutation_rootupdateMessagingMessagePriorityArgs = {
  _set?: InputMaybe<MessagingMessagePrioritySetInput>;
  where: MessagingMessagePriorityBoolExp;
};


/** mutation root */
export type mutation_rootupdateMessagingMessagePriorityByPkArgs = {
  _set?: InputMaybe<MessagingMessagePrioritySetInput>;
  pkColumns: MessagingMessagePriorityPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateMessagingMessagePriorityManyArgs = {
  updates: Array<MessagingMessagePriorityUpdates>;
};


/** mutation root */
export type mutation_rootupdateMessagingMessageReadArgs = {
  _set?: InputMaybe<messagingMessageReadSetInput>;
  pkColumns: messagingMessageReadPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateMessagingMessageReadManyArgs = {
  updates: Array<messagingMessageReadUpdates>;
};


/** mutation root */
export type mutation_rootupdateMessagingMessageReadsArgs = {
  _set?: InputMaybe<messagingMessageReadSetInput>;
  where: messagingMessageReadBoolExp;
};


/** mutation root */
export type mutation_rootupdateMessagingMessageTypeArgs = {
  _set?: InputMaybe<messagingMessageTypeSetInput>;
  pkColumns: messagingMessageTypePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateMessagingMessageTypeManyArgs = {
  updates: Array<messagingMessageTypeUpdates>;
};


/** mutation root */
export type mutation_rootupdateMessagingMessageTypesArgs = {
  _set?: InputMaybe<messagingMessageTypeSetInput>;
  where: messagingMessageTypeBoolExp;
};


/** mutation root */
export type mutation_rootupdateMessagingMessagesArgs = {
  _set?: InputMaybe<messagingMessageSetInput>;
  where: messagingMessageBoolExp;
};


/** mutation root */
export type mutation_rootupdateNotificationArgs = {
  _set?: InputMaybe<notificationSetInput>;
  pkColumns: notificationPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateNotificationNotificationDeviceSentArgs = {
  _set?: InputMaybe<NotificationNotificationDeviceSentSetInput>;
  where: NotificationNotificationDeviceSentBoolExp;
};


/** mutation root */
export type mutation_rootupdateNotificationNotificationDeviceSentByPkArgs = {
  _set?: InputMaybe<NotificationNotificationDeviceSentSetInput>;
  pkColumns: NotificationNotificationDeviceSentPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateNotificationNotificationDeviceSentManyArgs = {
  updates: Array<NotificationNotificationDeviceSentUpdates>;
};


/** mutation root */
export type mutation_rootupdateNotificationNotificationSettingActivityPrimaryEnumArgs = {
  _set?: InputMaybe<NotificationNotificationSettingActivityPrimaryEnumSetInput>;
  where: NotificationNotificationSettingActivityPrimaryEnumBoolExp;
};


/** mutation root */
export type mutation_rootupdateNotificationNotificationSettingActivityPrimaryEnumByPkArgs = {
  _set?: InputMaybe<NotificationNotificationSettingActivityPrimaryEnumSetInput>;
  pkColumns: NotificationNotificationSettingActivityPrimaryEnumPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateNotificationNotificationSettingActivityPrimaryEnumManyArgs = {
  updates: Array<NotificationNotificationSettingActivityPrimaryEnumUpdates>;
};


/** mutation root */
export type mutation_rootupdateNotificationSendArgs = {
  _set?: InputMaybe<notificationSendSetInput>;
  pkColumns: notificationSendPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateNotificationSendsArgs = {
  _set?: InputMaybe<notificationSendSetInput>;
  where: notificationSendBoolExp;
};


/** mutation root */
export type mutation_rootupdateNotificationSettingActivitiesArgs = {
  _set?: InputMaybe<notificationSettingActivitySetInput>;
  where: notificationSettingActivityBoolExp;
};


/** mutation root */
export type mutation_rootupdateNotificationSettingActivityArgs = {
  _set?: InputMaybe<notificationSettingActivitySetInput>;
  pkColumns: notificationSettingActivityPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateNotificationUserArgs = {
  _set?: InputMaybe<notificationUserSetInput>;
  pkColumns: notificationUserPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateNotificationUserDeviceArgs = {
  _inc?: InputMaybe<notificationUserDeviceIncInput>;
  _set?: InputMaybe<notificationUserDeviceSetInput>;
  pkColumns: notificationUserDevicePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateNotificationUserDevicesArgs = {
  _inc?: InputMaybe<notificationUserDeviceIncInput>;
  _set?: InputMaybe<notificationUserDeviceSetInput>;
  where: notificationUserDeviceBoolExp;
};


/** mutation root */
export type mutation_rootupdateNotificationUsersArgs = {
  _set?: InputMaybe<notificationUserSetInput>;
  where: notificationUserBoolExp;
};


/** mutation root */
export type mutation_rootupdateNotificationsArgs = {
  _set?: InputMaybe<notificationSetInput>;
  where: notificationBoolExp;
};


/** mutation root */
export type mutation_rootupdateOrdersIntegrationArgs = {
  _inc?: InputMaybe<ordersIntegrationsIncInput>;
  _set?: InputMaybe<ordersIntegrationsSetInput>;
  pkColumns: ordersIntegrationsPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateOrdersIntegrationsArgs = {
  _inc?: InputMaybe<ordersIntegrationsIncInput>;
  _set?: InputMaybe<ordersIntegrationsSetInput>;
  where: ordersIntegrationsBoolExp;
};


/** mutation root */
export type mutation_rootupdateOrdersOrganizationsArgs = {
  _inc?: InputMaybe<OrdersOrganizationsIncInput>;
  _set?: InputMaybe<OrdersOrganizationsSetInput>;
  where: OrdersOrganizationsBoolExp;
};


/** mutation root */
export type mutation_rootupdateOrdersOrganizationsByPkArgs = {
  _inc?: InputMaybe<OrdersOrganizationsIncInput>;
  _set?: InputMaybe<OrdersOrganizationsSetInput>;
  pkColumns: OrdersOrganizationsPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateOrdersOrganizationsManyArgs = {
  updates: Array<OrdersOrganizationsUpdates>;
};


/** mutation root */
export type mutation_rootupdateOrdersRequestArgs = {
  _set?: InputMaybe<OrdersRequestSetInput>;
  where: OrdersRequestBoolExp;
};


/** mutation root */
export type mutation_rootupdateOrdersRequestByPkArgs = {
  _set?: InputMaybe<OrdersRequestSetInput>;
  pkColumns: OrdersRequestPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateOrdersRequestManyArgs = {
  updates: Array<OrdersRequestUpdates>;
};


/** mutation root */
export type mutation_rootupdateOrdersStatusArgs = {
  _set?: InputMaybe<OrdersStatusSetInput>;
  where: OrdersStatusBoolExp;
};


/** mutation root */
export type mutation_rootupdateOrdersStatusByPkArgs = {
  _set?: InputMaybe<OrdersStatusSetInput>;
  pkColumns: OrdersStatusPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateOrdersStatusManyArgs = {
  updates: Array<OrdersStatusUpdates>;
};


/** mutation root */
export type mutation_rootupdateOrdersTypeArgs = {
  _set?: InputMaybe<OrdersTypeSetInput>;
  where: OrdersTypeBoolExp;
};


/** mutation root */
export type mutation_rootupdateOrdersTypeByPkArgs = {
  _set?: InputMaybe<OrdersTypeSetInput>;
  pkColumns: OrdersTypePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateOrdersTypeManyArgs = {
  updates: Array<OrdersTypeUpdates>;
};


/** mutation root */
export type mutation_rootupdateOrganizationArgs = {
  _inc?: InputMaybe<organizationIncInput>;
  _set?: InputMaybe<organizationSetInput>;
  pkColumns: organizationPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateOrganizationAuthorizationEnumGroupArgs = {
  _set?: InputMaybe<organizationAuthorizationEnumGroupSetInput>;
  pkColumns: organizationAuthorizationEnumGroupPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateOrganizationAuthorizationEnumGroupManyArgs = {
  updates: Array<organizationAuthorizationEnumGroupUpdates>;
};


/** mutation root */
export type mutation_rootupdateOrganizationAuthorizationEnumGroupsArgs = {
  _set?: InputMaybe<organizationAuthorizationEnumGroupSetInput>;
  where: organizationAuthorizationEnumGroupBoolExp;
};


/** mutation root */
export type mutation_rootupdateOrganizationAuthorizationGroupArgs = {
  _set?: InputMaybe<organizationAuthorizationGroupSetInput>;
  pkColumns: organizationAuthorizationGroupPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateOrganizationAuthorizationGroupManyArgs = {
  updates: Array<organizationAuthorizationGroupUpdates>;
};


/** mutation root */
export type mutation_rootupdateOrganizationAuthorizationGroupsArgs = {
  _set?: InputMaybe<organizationAuthorizationGroupSetInput>;
  where: organizationAuthorizationGroupBoolExp;
};


/** mutation root */
export type mutation_rootupdateOrganizationOrganizationRelationshipArgs = {
  _set?: InputMaybe<organizationOrganizationRelationshipSetInput>;
  pkColumns: organizationOrganizationRelationshipPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateOrganizationOrganizationRelationshipCategoriesArgs = {
  _set?: InputMaybe<organizationOrganizationRelationshipCategorySetInput>;
  where: organizationOrganizationRelationshipCategoryBoolExp;
};


/** mutation root */
export type mutation_rootupdateOrganizationOrganizationRelationshipCategoryArgs = {
  _set?: InputMaybe<organizationOrganizationRelationshipCategorySetInput>;
  pkColumns: organizationOrganizationRelationshipCategoryPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateOrganizationOrganizationRelationshipCategoryManyArgs = {
  updates: Array<organizationOrganizationRelationshipCategoryUpdates>;
};


/** mutation root */
export type mutation_rootupdateOrganizationOrganizationRelationshipManyArgs = {
  updates: Array<organizationOrganizationRelationshipUpdates>;
};


/** mutation root */
export type mutation_rootupdateOrganizationOrganizationRelationshipsArgs = {
  _set?: InputMaybe<organizationOrganizationRelationshipSetInput>;
  where: organizationOrganizationRelationshipBoolExp;
};


/** mutation root */
export type mutation_rootupdateOrganizationOrganizationUserAuthorizationArgs = {
  _set?: InputMaybe<organizationOrganizationUserAuthorizationSetInput>;
  pkColumns: organizationOrganizationUserAuthorizationPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateOrganizationOrganizationUserAuthorizationManyArgs = {
  updates: Array<organizationOrganizationUserAuthorizationUpdates>;
};


/** mutation root */
export type mutation_rootupdateOrganizationOrganizationUserAuthorizationsArgs = {
  _set?: InputMaybe<organizationOrganizationUserAuthorizationSetInput>;
  where: organizationOrganizationUserAuthorizationBoolExp;
};


/** mutation root */
export type mutation_rootupdateOrganizationUserArgs = {
  _append?: InputMaybe<organizationUserAppendInput>;
  _deleteAtPath?: InputMaybe<organizationUserDeleteAtPathInput>;
  _deleteElem?: InputMaybe<organizationUserDeleteElemInput>;
  _deleteKey?: InputMaybe<organizationUserDeleteKeyInput>;
  _prepend?: InputMaybe<organizationUserPrependInput>;
  _set?: InputMaybe<organizationUserSetInput>;
  pkColumns: organizationUserPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateOrganizationUserAttachmentArgs = {
  _set?: InputMaybe<organizationUserAttachmentsSetInput>;
  pkColumns: organizationUserAttachmentsPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateOrganizationUserAttachmentsArgs = {
  _set?: InputMaybe<organizationUserAttachmentsSetInput>;
  where: organizationUserAttachmentsBoolExp;
};


/** mutation root */
export type mutation_rootupdateOrganizationUserAttentionNoteArgs = {
  _set?: InputMaybe<OrganizationUserAttentionNoteSetInput>;
  pkColumns: OrganizationUserAttentionNotePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateOrganizationUserAttentionNotesArgs = {
  _set?: InputMaybe<OrganizationUserAttentionNoteSetInput>;
  where: OrganizationUserAttentionNoteBoolExp;
};


/** mutation root */
export type mutation_rootupdateOrganizationUserAuthorizationArgs = {
  _set?: InputMaybe<organizationUserAuthorizationSetInput>;
  pkColumns: organizationUserAuthorizationPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateOrganizationUserAuthorizationManyArgs = {
  updates: Array<organizationUserAuthorizationUpdates>;
};


/** mutation root */
export type mutation_rootupdateOrganizationUserAuthorizationsArgs = {
  _set?: InputMaybe<organizationUserAuthorizationSetInput>;
  where: organizationUserAuthorizationBoolExp;
};


/** mutation root */
export type mutation_rootupdateOrganizationUserDetailArgs = {
  _set?: InputMaybe<organizationUserDetailSetInput>;
  pkColumns: organizationUserDetailPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateOrganizationUserDetailTypeArgs = {
  _set?: InputMaybe<organizationUserDetailTypeSetInput>;
  pkColumns: organizationUserDetailTypePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateOrganizationUserDetailTypesArgs = {
  _set?: InputMaybe<organizationUserDetailTypeSetInput>;
  where: organizationUserDetailTypeBoolExp;
};


/** mutation root */
export type mutation_rootupdateOrganizationUserDetailsArgs = {
  _set?: InputMaybe<organizationUserDetailSetInput>;
  where: organizationUserDetailBoolExp;
};


/** mutation root */
export type mutation_rootupdateOrganizationUserInviteArgs = {
  _append?: InputMaybe<organizationUserInviteAppendInput>;
  _deleteAtPath?: InputMaybe<organizationUserInviteDeleteAtPathInput>;
  _deleteElem?: InputMaybe<organizationUserInviteDeleteElemInput>;
  _deleteKey?: InputMaybe<organizationUserInviteDeleteKeyInput>;
  _prepend?: InputMaybe<organizationUserInvitePrependInput>;
  _set?: InputMaybe<organizationUserInviteSetInput>;
  pkColumns: organizationUserInvitePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateOrganizationUserInvitesArgs = {
  _append?: InputMaybe<organizationUserInviteAppendInput>;
  _deleteAtPath?: InputMaybe<organizationUserInviteDeleteAtPathInput>;
  _deleteElem?: InputMaybe<organizationUserInviteDeleteElemInput>;
  _deleteKey?: InputMaybe<organizationUserInviteDeleteKeyInput>;
  _prepend?: InputMaybe<organizationUserInvitePrependInput>;
  _set?: InputMaybe<organizationUserInviteSetInput>;
  where: organizationUserInviteBoolExp;
};


/** mutation root */
export type mutation_rootupdateOrganizationUserRequestArgs = {
  _append?: InputMaybe<BusinessOrganizationUserRequestAppendInput>;
  _deleteAtPath?: InputMaybe<BusinessOrganizationUserRequestDeleteAtPathInput>;
  _deleteElem?: InputMaybe<BusinessOrganizationUserRequestDeleteElemInput>;
  _deleteKey?: InputMaybe<BusinessOrganizationUserRequestDeleteKeyInput>;
  _prepend?: InputMaybe<BusinessOrganizationUserRequestPrependInput>;
  _set?: InputMaybe<BusinessOrganizationUserRequestSetInput>;
  pkColumns: BusinessOrganizationUserRequestPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateOrganizationUserRequestsArgs = {
  _append?: InputMaybe<BusinessOrganizationUserRequestAppendInput>;
  _deleteAtPath?: InputMaybe<BusinessOrganizationUserRequestDeleteAtPathInput>;
  _deleteElem?: InputMaybe<BusinessOrganizationUserRequestDeleteElemInput>;
  _deleteKey?: InputMaybe<BusinessOrganizationUserRequestDeleteKeyInput>;
  _prepend?: InputMaybe<BusinessOrganizationUserRequestPrependInput>;
  _set?: InputMaybe<BusinessOrganizationUserRequestSetInput>;
  where: BusinessOrganizationUserRequestBoolExp;
};


/** mutation root */
export type mutation_rootupdateOrganizationUserStatusArgs = {
  _set?: InputMaybe<organizationUserStatusSetInput>;
  pkColumns: organizationUserStatusPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateOrganizationUserStatusesArgs = {
  _set?: InputMaybe<organizationUserStatusSetInput>;
  where: organizationUserStatusBoolExp;
};


/** mutation root */
export type mutation_rootupdateOrganizationUsersArgs = {
  _append?: InputMaybe<organizationUserAppendInput>;
  _deleteAtPath?: InputMaybe<organizationUserDeleteAtPathInput>;
  _deleteElem?: InputMaybe<organizationUserDeleteElemInput>;
  _deleteKey?: InputMaybe<organizationUserDeleteKeyInput>;
  _prepend?: InputMaybe<organizationUserPrependInput>;
  _set?: InputMaybe<organizationUserSetInput>;
  where: organizationUserBoolExp;
};


/** mutation root */
export type mutation_rootupdateOrganizationsArgs = {
  _inc?: InputMaybe<organizationIncInput>;
  _set?: InputMaybe<organizationSetInput>;
  where: organizationBoolExp;
};


/** mutation root */
export type mutation_rootupdatePhoneNumberVerificationStatusArgs = {
  _set?: InputMaybe<phoneNumberVerificationStatusSetInput>;
  pkColumns: phoneNumberVerificationStatusPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdatePhoneNumberVerificationStatusesArgs = {
  _set?: InputMaybe<phoneNumberVerificationStatusSetInput>;
  where: phoneNumberVerificationStatusBoolExp;
};


/** mutation root */
export type mutation_rootupdatePromptArgs = {
  _set?: InputMaybe<PromptSetInput>;
  where: PromptBoolExp;
};


/** mutation root */
export type mutation_rootupdatePromptByPkArgs = {
  _set?: InputMaybe<PromptSetInput>;
  pkColumns: PromptPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdatePromptManyArgs = {
  updates: Array<PromptUpdates>;
};


/** mutation root */
export type mutation_rootupdatePublicDeviceArgs = {
  _set?: InputMaybe<publicDeviceSetInput>;
  pkColumns: publicDevicePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdatePublicDeviceManyArgs = {
  updates: Array<publicDeviceUpdates>;
};


/** mutation root */
export type mutation_rootupdatePublicDevicesArgs = {
  _set?: InputMaybe<publicDeviceSetInput>;
  where: publicDeviceBoolExp;
};


/** mutation root */
export type mutation_rootupdatePublicExternalRequestArgs = {
  _append?: InputMaybe<publicExternalRequestAppendInput>;
  _deleteAtPath?: InputMaybe<publicExternalRequestDeleteAtPathInput>;
  _deleteElem?: InputMaybe<publicExternalRequestDeleteElemInput>;
  _deleteKey?: InputMaybe<publicExternalRequestDeleteKeyInput>;
  _prepend?: InputMaybe<publicExternalRequestPrependInput>;
  _set?: InputMaybe<publicExternalRequestSetInput>;
  pkColumns: publicExternalRequestPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdatePublicExternalRequestManyArgs = {
  updates: Array<publicExternalRequestUpdates>;
};


/** mutation root */
export type mutation_rootupdatePublicExternalRequestsArgs = {
  _append?: InputMaybe<publicExternalRequestAppendInput>;
  _deleteAtPath?: InputMaybe<publicExternalRequestDeleteAtPathInput>;
  _deleteElem?: InputMaybe<publicExternalRequestDeleteElemInput>;
  _deleteKey?: InputMaybe<publicExternalRequestDeleteKeyInput>;
  _prepend?: InputMaybe<publicExternalRequestPrependInput>;
  _set?: InputMaybe<publicExternalRequestSetInput>;
  where: publicExternalRequestBoolExp;
};


/** mutation root */
export type mutation_rootupdatePublicFileArgs = {
  _set?: InputMaybe<publicFileSetInput>;
  pkColumns: publicFilePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdatePublicFileManyArgs = {
  updates: Array<publicFileUpdates>;
};


/** mutation root */
export type mutation_rootupdatePublicFilesArgs = {
  _set?: InputMaybe<publicFileSetInput>;
  where: publicFileBoolExp;
};


/** mutation root */
export type mutation_rootupdatePublicNotificationArgs = {
  _inc?: InputMaybe<publicNotificationIncInput>;
  _set?: InputMaybe<publicNotificationSetInput>;
  pkColumns: publicNotificationPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdatePublicNotificationManyArgs = {
  updates: Array<publicNotificationUpdates>;
};


/** mutation root */
export type mutation_rootupdatePublicNotificationsArgs = {
  _inc?: InputMaybe<publicNotificationIncInput>;
  _set?: InputMaybe<publicNotificationSetInput>;
  where: publicNotificationBoolExp;
};


/** mutation root */
export type mutation_rootupdateQueueItemArgs = {
  _append?: InputMaybe<queueItemAppendInput>;
  _deleteAtPath?: InputMaybe<queueItemDeleteAtPathInput>;
  _deleteElem?: InputMaybe<queueItemDeleteElemInput>;
  _deleteKey?: InputMaybe<queueItemDeleteKeyInput>;
  _prepend?: InputMaybe<queueItemPrependInput>;
  _set?: InputMaybe<queueItemSetInput>;
  pkColumns: queueItemPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateQueueItemFlexibilityTypeArgs = {
  _set?: InputMaybe<QueueItemFlexibilityTypeSetInput>;
  where: QueueItemFlexibilityTypeBoolExp;
};


/** mutation root */
export type mutation_rootupdateQueueItemFlexibilityTypeByPkArgs = {
  _set?: InputMaybe<QueueItemFlexibilityTypeSetInput>;
  pkColumns: QueueItemFlexibilityTypePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateQueueItemFlexibilityTypeManyArgs = {
  updates: Array<QueueItemFlexibilityTypeUpdates>;
};


/** mutation root */
export type mutation_rootupdateQueueItemParticipantResponsibilityTypeArgs = {
  _set?: InputMaybe<QueueItemParticipantResponsibilityTypeSetInput>;
  where: QueueItemParticipantResponsibilityTypeBoolExp;
};


/** mutation root */
export type mutation_rootupdateQueueItemParticipantResponsibilityTypeByPkArgs = {
  _set?: InputMaybe<QueueItemParticipantResponsibilityTypeSetInput>;
  pkColumns: QueueItemParticipantResponsibilityTypePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateQueueItemParticipantResponsibilityTypeManyArgs = {
  updates: Array<QueueItemParticipantResponsibilityTypeUpdates>;
};


/** mutation root */
export type mutation_rootupdateQueueItemsArgs = {
  _append?: InputMaybe<queueItemAppendInput>;
  _deleteAtPath?: InputMaybe<queueItemDeleteAtPathInput>;
  _deleteElem?: InputMaybe<queueItemDeleteElemInput>;
  _deleteKey?: InputMaybe<queueItemDeleteKeyInput>;
  _prepend?: InputMaybe<queueItemPrependInput>;
  _set?: InputMaybe<queueItemSetInput>;
  where: queueItemBoolExp;
};


/** mutation root */
export type mutation_rootupdateRelOrganizationUserDomainUserArgs = {
  _set?: InputMaybe<relOrganizationUserDomainUserSetInput>;
  pkColumns: relOrganizationUserDomainUserPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateRelOrganizationUserDomainUsersArgs = {
  _set?: InputMaybe<relOrganizationUserDomainUserSetInput>;
  where: relOrganizationUserDomainUserBoolExp;
};


/** mutation root */
export type mutation_rootupdateRelationTypeArgs = {
  _set?: InputMaybe<RelationTypeSetInput>;
  where: RelationTypeBoolExp;
};


/** mutation root */
export type mutation_rootupdateRelationTypeByPkArgs = {
  _set?: InputMaybe<RelationTypeSetInput>;
  pkColumns: RelationTypePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateRelationTypeManyArgs = {
  updates: Array<RelationTypeUpdates>;
};


/** mutation root */
export type mutation_rootupdateSmsConnectorArgs = {
  _inc?: InputMaybe<smsConnectorIncInput>;
  _set?: InputMaybe<smsConnectorSetInput>;
  pkColumns: smsConnectorPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateSmsConnectorManyArgs = {
  updates: Array<smsConnectorUpdates>;
};


/** mutation root */
export type mutation_rootupdateSmsConnectorsArgs = {
  _inc?: InputMaybe<smsConnectorIncInput>;
  _set?: InputMaybe<smsConnectorSetInput>;
  where: smsConnectorBoolExp;
};


/** mutation root */
export type mutation_rootupdateSmsGateArgs = {
  _inc?: InputMaybe<smsGateIncInput>;
  _set?: InputMaybe<smsGateSetInput>;
  pkColumns: smsGatePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateSmsGateManyArgs = {
  updates: Array<smsGateUpdates>;
};


/** mutation root */
export type mutation_rootupdateSmsGatesArgs = {
  _inc?: InputMaybe<smsGateIncInput>;
  _set?: InputMaybe<smsGateSetInput>;
  where: smsGateBoolExp;
};


/** mutation root */
export type mutation_rootupdateSmsLinkMobilitySmsContentArgs = {
  _set?: InputMaybe<smsLinkMobilitySmsContentSetInput>;
  pkColumns: smsLinkMobilitySmsContentPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateSmsLinkMobilitySmsContentManyArgs = {
  updates: Array<smsLinkMobilitySmsContentUpdates>;
};


/** mutation root */
export type mutation_rootupdateSmsLinkMobilitySmsContentsArgs = {
  _set?: InputMaybe<smsLinkMobilitySmsContentSetInput>;
  where: smsLinkMobilitySmsContentBoolExp;
};


/** mutation root */
export type mutation_rootupdateSmsLinkMobilitySmsMessageArgs = {
  _append?: InputMaybe<smsLinkMobilitySmsMessageAppendInput>;
  _deleteAtPath?: InputMaybe<smsLinkMobilitySmsMessageDeleteAtPathInput>;
  _deleteElem?: InputMaybe<smsLinkMobilitySmsMessageDeleteElemInput>;
  _deleteKey?: InputMaybe<smsLinkMobilitySmsMessageDeleteKeyInput>;
  _inc?: InputMaybe<smsLinkMobilitySmsMessageIncInput>;
  _prepend?: InputMaybe<smsLinkMobilitySmsMessagePrependInput>;
  _set?: InputMaybe<smsLinkMobilitySmsMessageSetInput>;
  pkColumns: smsLinkMobilitySmsMessagePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateSmsLinkMobilitySmsMessageManyArgs = {
  updates: Array<smsLinkMobilitySmsMessageUpdates>;
};


/** mutation root */
export type mutation_rootupdateSmsLinkMobilitySmsMessagesArgs = {
  _append?: InputMaybe<smsLinkMobilitySmsMessageAppendInput>;
  _deleteAtPath?: InputMaybe<smsLinkMobilitySmsMessageDeleteAtPathInput>;
  _deleteElem?: InputMaybe<smsLinkMobilitySmsMessageDeleteElemInput>;
  _deleteKey?: InputMaybe<smsLinkMobilitySmsMessageDeleteKeyInput>;
  _inc?: InputMaybe<smsLinkMobilitySmsMessageIncInput>;
  _prepend?: InputMaybe<smsLinkMobilitySmsMessagePrependInput>;
  _set?: InputMaybe<smsLinkMobilitySmsMessageSetInput>;
  where: smsLinkMobilitySmsMessageBoolExp;
};


/** mutation root */
export type mutation_rootupdateSmsLinkMobilitySmsRouteArgs = {
  _append?: InputMaybe<smsLinkMobilitySmsRouteAppendInput>;
  _deleteAtPath?: InputMaybe<smsLinkMobilitySmsRouteDeleteAtPathInput>;
  _deleteElem?: InputMaybe<smsLinkMobilitySmsRouteDeleteElemInput>;
  _deleteKey?: InputMaybe<smsLinkMobilitySmsRouteDeleteKeyInput>;
  _prepend?: InputMaybe<smsLinkMobilitySmsRoutePrependInput>;
  _set?: InputMaybe<smsLinkMobilitySmsRouteSetInput>;
  pkColumns: smsLinkMobilitySmsRoutePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateSmsLinkMobilitySmsRouteManyArgs = {
  updates: Array<smsLinkMobilitySmsRouteUpdates>;
};


/** mutation root */
export type mutation_rootupdateSmsLinkMobilitySmsRoutesArgs = {
  _append?: InputMaybe<smsLinkMobilitySmsRouteAppendInput>;
  _deleteAtPath?: InputMaybe<smsLinkMobilitySmsRouteDeleteAtPathInput>;
  _deleteElem?: InputMaybe<smsLinkMobilitySmsRouteDeleteElemInput>;
  _deleteKey?: InputMaybe<smsLinkMobilitySmsRouteDeleteKeyInput>;
  _prepend?: InputMaybe<smsLinkMobilitySmsRoutePrependInput>;
  _set?: InputMaybe<smsLinkMobilitySmsRouteSetInput>;
  where: smsLinkMobilitySmsRouteBoolExp;
};


/** mutation root */
export type mutation_rootupdateSmsProviderArgs = {
  _inc?: InputMaybe<smsProviderIncInput>;
  _set?: InputMaybe<smsProviderSetInput>;
  pkColumns: smsProviderPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateSmsProviderManyArgs = {
  updates: Array<smsProviderUpdates>;
};


/** mutation root */
export type mutation_rootupdateSmsProvidersArgs = {
  _inc?: InputMaybe<smsProviderIncInput>;
  _set?: InputMaybe<smsProviderSetInput>;
  where: smsProviderBoolExp;
};


/** mutation root */
export type mutation_rootupdateSmsSmArgs = {
  _inc?: InputMaybe<smsSmIncInput>;
  _set?: InputMaybe<smsSmSetInput>;
  pkColumns: smsSmPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateSmsSmManyArgs = {
  updates: Array<smsSmUpdates>;
};


/** mutation root */
export type mutation_rootupdateSmsSmsArgs = {
  _inc?: InputMaybe<smsSmIncInput>;
  _set?: InputMaybe<smsSmSetInput>;
  where: smsSmBoolExp;
};


/** mutation root */
export type mutation_rootupdateSmsSmsExternalIncomingLinkMobilitiesArgs = {
  _set?: InputMaybe<smsSmsExternalIncomingLinkMobilitySetInput>;
  where: smsSmsExternalIncomingLinkMobilityBoolExp;
};


/** mutation root */
export type mutation_rootupdateSmsSmsExternalIncomingLinkMobilityArgs = {
  _set?: InputMaybe<smsSmsExternalIncomingLinkMobilitySetInput>;
  pkColumns: smsSmsExternalIncomingLinkMobilityPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateSmsSmsExternalIncomingLinkMobilityManyArgs = {
  updates: Array<smsSmsExternalIncomingLinkMobilityUpdates>;
};


/** mutation root */
export type mutation_rootupdateUserArgs = {
  _set?: InputMaybe<userSetInput>;
  pkColumns: userPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateUserDetailArgs = {
  _set?: InputMaybe<userDetailSetInput>;
  pkColumns: userDetailPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateUserDetailsArgs = {
  _set?: InputMaybe<userDetailSetInput>;
  where: userDetailBoolExp;
};


/** mutation root */
export type mutation_rootupdateUserDetailsTypeArgs = {
  _set?: InputMaybe<userDetailsTypeSetInput>;
  pkColumns: userDetailsTypePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateUserDetailsTypesArgs = {
  _set?: InputMaybe<userDetailsTypeSetInput>;
  where: userDetailsTypeBoolExp;
};


/** mutation root */
export type mutation_rootupdateUserDeviceArgs = {
  _set?: InputMaybe<userDeviceSetInput>;
  pkColumns: userDevicePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateUserDevicesArgs = {
  _set?: InputMaybe<userDeviceSetInput>;
  where: userDeviceBoolExp;
};


/** mutation root */
export type mutation_rootupdateUserPhoneNumberArgs = {
  _set?: InputMaybe<userPhoneNumberSetInput>;
  pkColumns: userPhoneNumberPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateUserPhoneNumbersArgs = {
  _set?: InputMaybe<userPhoneNumberSetInput>;
  where: userPhoneNumberBoolExp;
};


/** mutation root */
export type mutation_rootupdateUserRoleArgs = {
  _set?: InputMaybe<userRoleSetInput>;
  pkColumns: userRolePkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateUserRolesArgs = {
  _set?: InputMaybe<userRoleSetInput>;
  where: userRoleBoolExp;
};


/** mutation root */
export type mutation_rootupdateUsersArgs = {
  _set?: InputMaybe<userSetInput>;
  where: userBoolExp;
};


/** mutation root */
export type mutation_rootupdateValidationValidationArgs = {
  _inc?: InputMaybe<validationValidationIncInput>;
  _set?: InputMaybe<validationValidationSetInput>;
  pkColumns: validationValidationPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateValidationValidationManyArgs = {
  updates: Array<validationValidationUpdates>;
};


/** mutation root */
export type mutation_rootupdateValidationValidationsArgs = {
  _inc?: InputMaybe<validationValidationIncInput>;
  _set?: InputMaybe<validationValidationSetInput>;
  where: validationValidationBoolExp;
};


/** mutation root */
export type mutation_rootupdateVoiceTypesArgs = {
  _set?: InputMaybe<VoiceTypesSetInput>;
  where: VoiceTypesBoolExp;
};


/** mutation root */
export type mutation_rootupdateVoiceTypesByPkArgs = {
  _set?: InputMaybe<VoiceTypesSetInput>;
  pkColumns: VoiceTypesPkColumnsInput;
};


/** mutation root */
export type mutation_rootupdateVoiceTypesManyArgs = {
  updates: Array<VoiceTypesUpdates>;
};


/** mutation root */
export type mutation_rootuserDeleteArgs = {
  userId: Scalars['uuid']['input'];
};


/** mutation root */
export type mutation_rootuserUpdateArgs = {
  user: UserUpdateInput;
};


/** mutation root */
export type mutation_rootvalidateTelephonyCredentialsToOrgArgs = {
  input: TelephonyCredentialsValidation;
};


/** mutation root */
export type mutation_rootverifyOrganizationUserPhoneNumberArgs = {
  verifyOrganizationUserPhoneNumber: verifyOrganizationUserPhoneNumberInput;
};

/** 24.06.25 - not in use */
export type notification = {
  __typename?: 'notification';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  sourceDomain: Scalars['String']['output'];
  sourceId: Scalars['uuid']['output'];
  sourceTable?: Maybe<Scalars['String']['output']>;
  sourceTriggerName: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  subId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "notification.notifications" */
export type notificationAggregate = {
  __typename?: 'notificationAggregate';
  aggregate?: Maybe<notificationAggregateFields>;
  nodes: Array<notification>;
};

/** aggregate fields of "notification.notifications" */
export type notificationAggregateFields = {
  __typename?: 'notificationAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<notificationMaxFields>;
  min?: Maybe<notificationMinFields>;
};


/** aggregate fields of "notification.notifications" */
export type notificationAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<notificationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "notification.notifications". All fields are combined with a logical 'AND'. */
export type notificationBoolExp = {
  _and?: InputMaybe<Array<notificationBoolExp>>;
  _not?: InputMaybe<notificationBoolExp>;
  _or?: InputMaybe<Array<notificationBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  sourceDomain?: InputMaybe<StringComparisonExp>;
  sourceId?: InputMaybe<UuidComparisonExp>;
  sourceTable?: InputMaybe<StringComparisonExp>;
  sourceTriggerName?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  subId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "notification.notifications" */
export type notificationConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'notifications_pkey'
  | '%future added value';

/** input type for inserting data into table "notification.notifications" */
export type notificationInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sourceDomain?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['uuid']['input']>;
  sourceTable?: InputMaybe<Scalars['String']['input']>;
  sourceTriggerName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type notificationMaxFields = {
  __typename?: 'notificationMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sourceDomain?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['uuid']['output']>;
  sourceTable?: Maybe<Scalars['String']['output']>;
  sourceTriggerName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type notificationMinFields = {
  __typename?: 'notificationMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sourceDomain?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['uuid']['output']>;
  sourceTable?: Maybe<Scalars['String']['output']>;
  sourceTriggerName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "notification.notifications" */
export type notificationMutationResponse = {
  __typename?: 'notificationMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<notification>;
};

/** on_conflict condition type for table "notification.notifications" */
export type notificationOnConflict = {
  constraint: notificationConstraint;
  updateColumns?: Array<notificationUpdateColumn>;
  where?: InputMaybe<notificationBoolExp>;
};

/** Ordering options when selecting data from "notification.notifications". */
export type notificationOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  sourceDomain?: InputMaybe<OrderBy>;
  sourceId?: InputMaybe<OrderBy>;
  sourceTable?: InputMaybe<OrderBy>;
  sourceTriggerName?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  subId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: notification.notifications */
export type notificationPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "notification.notifications" */
export type notificationSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'sourceDomain'
  /** column name */
  | 'sourceId'
  /** column name */
  | 'sourceTable'
  /** column name */
  | 'sourceTriggerName'
  /** column name */
  | 'status'
  /** column name */
  | 'subId'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** columns and relationships of "notification.notification_send" */
export type notificationSend = {
  __typename?: 'notificationSend';
  activityId?: Maybe<Scalars['uuid']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  doNavigateParams?: Maybe<Scalars['String']['output']>;
  doNavigateScreen?: Maybe<Scalars['String']['output']>;
  doNavigateStack?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  numberLookupTimeout: Scalars['Boolean']['output'];
  priority?: Maybe<Scalars['String']['output']>;
  push?: Maybe<Scalars['Boolean']['output']>;
  receivedAt?: Maybe<Scalars['timestamptz']['output']>;
  remember?: Maybe<Scalars['Boolean']['output']>;
  seen?: Maybe<Scalars['Boolean']['output']>;
  sentAt?: Maybe<Scalars['timestamptz']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  userIdCreated?: Maybe<Scalars['uuid']['output']>;
  userIdTo?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "notification.notification_send" */
export type notificationSendAggregate = {
  __typename?: 'notificationSendAggregate';
  aggregate?: Maybe<notificationSendAggregateFields>;
  nodes: Array<notificationSend>;
};

/** aggregate fields of "notification.notification_send" */
export type notificationSendAggregateFields = {
  __typename?: 'notificationSendAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<notificationSendMaxFields>;
  min?: Maybe<notificationSendMinFields>;
};


/** aggregate fields of "notification.notification_send" */
export type notificationSendAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<notificationSendSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "notification.notification_send". All fields are combined with a logical 'AND'. */
export type notificationSendBoolExp = {
  _and?: InputMaybe<Array<notificationSendBoolExp>>;
  _not?: InputMaybe<notificationSendBoolExp>;
  _or?: InputMaybe<Array<notificationSendBoolExp>>;
  activityId?: InputMaybe<UuidComparisonExp>;
  body?: InputMaybe<StringComparisonExp>;
  category?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  doNavigateParams?: InputMaybe<StringComparisonExp>;
  doNavigateScreen?: InputMaybe<StringComparisonExp>;
  doNavigateStack?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  numberLookupTimeout?: InputMaybe<BooleanComparisonExp>;
  priority?: InputMaybe<StringComparisonExp>;
  push?: InputMaybe<BooleanComparisonExp>;
  receivedAt?: InputMaybe<TimestamptzComparisonExp>;
  remember?: InputMaybe<BooleanComparisonExp>;
  seen?: InputMaybe<BooleanComparisonExp>;
  sentAt?: InputMaybe<TimestamptzComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userIdCreated?: InputMaybe<UuidComparisonExp>;
  userIdTo?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "notification.notification_send" */
export type notificationSendConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'notification_send_pkey'
  | '%future added value';

/** input type for inserting data into table "notification.notification_send" */
export type notificationSendInsertInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  doNavigateParams?: InputMaybe<Scalars['String']['input']>;
  doNavigateScreen?: InputMaybe<Scalars['String']['input']>;
  doNavigateStack?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  numberLookupTimeout?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  push?: InputMaybe<Scalars['Boolean']['input']>;
  receivedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  remember?: InputMaybe<Scalars['Boolean']['input']>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  sentAt?: InputMaybe<Scalars['timestamptz']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userIdCreated?: InputMaybe<Scalars['uuid']['input']>;
  userIdTo?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type notificationSendMaxFields = {
  __typename?: 'notificationSendMaxFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  doNavigateParams?: Maybe<Scalars['String']['output']>;
  doNavigateScreen?: Maybe<Scalars['String']['output']>;
  doNavigateStack?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  receivedAt?: Maybe<Scalars['timestamptz']['output']>;
  sentAt?: Maybe<Scalars['timestamptz']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userIdCreated?: Maybe<Scalars['uuid']['output']>;
  userIdTo?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type notificationSendMinFields = {
  __typename?: 'notificationSendMinFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  doNavigateParams?: Maybe<Scalars['String']['output']>;
  doNavigateScreen?: Maybe<Scalars['String']['output']>;
  doNavigateStack?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  receivedAt?: Maybe<Scalars['timestamptz']['output']>;
  sentAt?: Maybe<Scalars['timestamptz']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userIdCreated?: Maybe<Scalars['uuid']['output']>;
  userIdTo?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "notification.notification_send" */
export type notificationSendMutationResponse = {
  __typename?: 'notificationSendMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<notificationSend>;
};

/** input type for inserting object relation for remote table "notification.notification_send" */
export type notificationSendObjRelInsertInput = {
  data: notificationSendInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<notificationSendOnConflict>;
};

/** on_conflict condition type for table "notification.notification_send" */
export type notificationSendOnConflict = {
  constraint: notificationSendConstraint;
  updateColumns?: Array<notificationSendUpdateColumn>;
  where?: InputMaybe<notificationSendBoolExp>;
};

/** Ordering options when selecting data from "notification.notification_send". */
export type notificationSendOrderBy = {
  activityId?: InputMaybe<OrderBy>;
  body?: InputMaybe<OrderBy>;
  category?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  doNavigateParams?: InputMaybe<OrderBy>;
  doNavigateScreen?: InputMaybe<OrderBy>;
  doNavigateStack?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  numberLookupTimeout?: InputMaybe<OrderBy>;
  priority?: InputMaybe<OrderBy>;
  push?: InputMaybe<OrderBy>;
  receivedAt?: InputMaybe<OrderBy>;
  remember?: InputMaybe<OrderBy>;
  seen?: InputMaybe<OrderBy>;
  sentAt?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userIdCreated?: InputMaybe<OrderBy>;
  userIdTo?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: notification.notification_send */
export type notificationSendPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "notification.notification_send" */
export type notificationSendSelectColumn =
  /** column name */
  | 'activityId'
  /** column name */
  | 'body'
  /** column name */
  | 'category'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'doNavigateParams'
  /** column name */
  | 'doNavigateScreen'
  /** column name */
  | 'doNavigateStack'
  /** column name */
  | 'id'
  /** column name */
  | 'numberLookupTimeout'
  /** column name */
  | 'priority'
  /** column name */
  | 'push'
  /** column name */
  | 'receivedAt'
  /** column name */
  | 'remember'
  /** column name */
  | 'seen'
  /** column name */
  | 'sentAt'
  /** column name */
  | 'title'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userIdCreated'
  /** column name */
  | 'userIdTo'
  | '%future added value';

/** input type for updating data in table "notification.notification_send" */
export type notificationSendSetInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  doNavigateParams?: InputMaybe<Scalars['String']['input']>;
  doNavigateScreen?: InputMaybe<Scalars['String']['input']>;
  doNavigateStack?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  numberLookupTimeout?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  push?: InputMaybe<Scalars['Boolean']['input']>;
  receivedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  remember?: InputMaybe<Scalars['Boolean']['input']>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  sentAt?: InputMaybe<Scalars['timestamptz']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userIdCreated?: InputMaybe<Scalars['uuid']['input']>;
  userIdTo?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "notificationSend" */
export type notificationSendStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: notificationSendStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type notificationSendStreamCursorValueInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  doNavigateParams?: InputMaybe<Scalars['String']['input']>;
  doNavigateScreen?: InputMaybe<Scalars['String']['input']>;
  doNavigateStack?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  numberLookupTimeout?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  push?: InputMaybe<Scalars['Boolean']['input']>;
  receivedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  remember?: InputMaybe<Scalars['Boolean']['input']>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  sentAt?: InputMaybe<Scalars['timestamptz']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userIdCreated?: InputMaybe<Scalars['uuid']['input']>;
  userIdTo?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "notification.notification_send" */
export type notificationSendUpdateColumn =
  /** column name */
  | 'activityId'
  /** column name */
  | 'body'
  /** column name */
  | 'category'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'doNavigateParams'
  /** column name */
  | 'doNavigateScreen'
  /** column name */
  | 'doNavigateStack'
  /** column name */
  | 'id'
  /** column name */
  | 'numberLookupTimeout'
  /** column name */
  | 'priority'
  /** column name */
  | 'push'
  /** column name */
  | 'receivedAt'
  /** column name */
  | 'remember'
  /** column name */
  | 'seen'
  /** column name */
  | 'sentAt'
  /** column name */
  | 'title'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userIdCreated'
  /** column name */
  | 'userIdTo'
  | '%future added value';

export type notificationSendUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<notificationSendSetInput>;
  /** filter the rows which have to be updated */
  where: notificationSendBoolExp;
};

/** input type for updating data in table "notification.notifications" */
export type notificationSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sourceDomain?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['uuid']['input']>;
  sourceTable?: InputMaybe<Scalars['String']['input']>;
  sourceTriggerName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** 24.06.25 - not in use */
export type notificationSettingActivity = {
  __typename?: 'notificationSettingActivity';
  activityId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  mobilePushNotification: Scalars['Boolean']['output'];
  muteUntil?: Maybe<Scalars['timestamptz']['output']>;
  primarySetting: NotificationNotificationSettingActivityPrimaryEnumEnum;
  updatedAt: Scalars['timestamptz']['output'];
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "notification.notification_setting_activity" */
export type notificationSettingActivityAggregate = {
  __typename?: 'notificationSettingActivityAggregate';
  aggregate?: Maybe<notificationSettingActivityAggregateFields>;
  nodes: Array<notificationSettingActivity>;
};

/** aggregate fields of "notification.notification_setting_activity" */
export type notificationSettingActivityAggregateFields = {
  __typename?: 'notificationSettingActivityAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<notificationSettingActivityMaxFields>;
  min?: Maybe<notificationSettingActivityMinFields>;
};


/** aggregate fields of "notification.notification_setting_activity" */
export type notificationSettingActivityAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<notificationSettingActivitySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "notification.notification_setting_activity". All fields are combined with a logical 'AND'. */
export type notificationSettingActivityBoolExp = {
  _and?: InputMaybe<Array<notificationSettingActivityBoolExp>>;
  _not?: InputMaybe<notificationSettingActivityBoolExp>;
  _or?: InputMaybe<Array<notificationSettingActivityBoolExp>>;
  activityId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  mobilePushNotification?: InputMaybe<BooleanComparisonExp>;
  muteUntil?: InputMaybe<TimestamptzComparisonExp>;
  primarySetting?: InputMaybe<NotificationNotificationSettingActivityPrimaryEnumEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "notification.notification_setting_activity" */
export type notificationSettingActivityConstraint =
  /** unique or primary key constraint on columns "user_id", "activity_id" */
  | 'notification_setting_activity_activity_id_user_id_key'
  /** unique or primary key constraint on columns "id" */
  | 'notification_setting_activity_pkey'
  | '%future added value';

/** input type for inserting data into table "notification.notification_setting_activity" */
export type notificationSettingActivityInsertInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mobilePushNotification?: InputMaybe<Scalars['Boolean']['input']>;
  muteUntil?: InputMaybe<Scalars['timestamptz']['input']>;
  primarySetting?: InputMaybe<NotificationNotificationSettingActivityPrimaryEnumEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type notificationSettingActivityMaxFields = {
  __typename?: 'notificationSettingActivityMaxFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  muteUntil?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type notificationSettingActivityMinFields = {
  __typename?: 'notificationSettingActivityMinFields';
  activityId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  muteUntil?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "notification.notification_setting_activity" */
export type notificationSettingActivityMutationResponse = {
  __typename?: 'notificationSettingActivityMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<notificationSettingActivity>;
};

/** on_conflict condition type for table "notification.notification_setting_activity" */
export type notificationSettingActivityOnConflict = {
  constraint: notificationSettingActivityConstraint;
  updateColumns?: Array<notificationSettingActivityUpdateColumn>;
  where?: InputMaybe<notificationSettingActivityBoolExp>;
};

/** Ordering options when selecting data from "notification.notification_setting_activity". */
export type notificationSettingActivityOrderBy = {
  activityId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  mobilePushNotification?: InputMaybe<OrderBy>;
  muteUntil?: InputMaybe<OrderBy>;
  primarySetting?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: notification.notification_setting_activity */
export type notificationSettingActivityPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "notification.notification_setting_activity" */
export type notificationSettingActivitySelectColumn =
  /** column name */
  | 'activityId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'mobilePushNotification'
  /** column name */
  | 'muteUntil'
  /** column name */
  | 'primarySetting'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

/** input type for updating data in table "notification.notification_setting_activity" */
export type notificationSettingActivitySetInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mobilePushNotification?: InputMaybe<Scalars['Boolean']['input']>;
  muteUntil?: InputMaybe<Scalars['timestamptz']['input']>;
  primarySetting?: InputMaybe<NotificationNotificationSettingActivityPrimaryEnumEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "notificationSettingActivity" */
export type notificationSettingActivityStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: notificationSettingActivityStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type notificationSettingActivityStreamCursorValueInput = {
  activityId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mobilePushNotification?: InputMaybe<Scalars['Boolean']['input']>;
  muteUntil?: InputMaybe<Scalars['timestamptz']['input']>;
  primarySetting?: InputMaybe<NotificationNotificationSettingActivityPrimaryEnumEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "notification.notification_setting_activity" */
export type notificationSettingActivityUpdateColumn =
  /** column name */
  | 'activityId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'mobilePushNotification'
  /** column name */
  | 'muteUntil'
  /** column name */
  | 'primarySetting'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

export type notificationSettingActivityUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<notificationSettingActivitySetInput>;
  /** filter the rows which have to be updated */
  where: notificationSettingActivityBoolExp;
};

/** Streaming cursor of the table "notification" */
export type notificationStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: notificationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type notificationStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sourceDomain?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['uuid']['input']>;
  sourceTable?: InputMaybe<Scalars['String']['input']>;
  sourceTriggerName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "notification.notifications" */
export type notificationUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'sourceDomain'
  /** column name */
  | 'sourceId'
  /** column name */
  | 'sourceTable'
  /** column name */
  | 'sourceTriggerName'
  /** column name */
  | 'status'
  /** column name */
  | 'subId'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type notificationUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<notificationSetInput>;
  /** filter the rows which have to be updated */
  where: notificationBoolExp;
};

/** 24.06.25 - start of use */
export type notificationUser = {
  __typename?: 'notificationUser';
  id: Scalars['uuid']['output'];
  toggleNotification: Scalars['Boolean']['output'];
  toggleNotificationBusinessHoursIgnore: Scalars['Boolean']['output'];
  userId: Scalars['uuid']['output'];
  userPushSettings?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "notification.notification_users" */
export type notificationUserAggregate = {
  __typename?: 'notificationUserAggregate';
  aggregate?: Maybe<notificationUserAggregateFields>;
  nodes: Array<notificationUser>;
};

/** aggregate fields of "notification.notification_users" */
export type notificationUserAggregateFields = {
  __typename?: 'notificationUserAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<notificationUserMaxFields>;
  min?: Maybe<notificationUserMinFields>;
};


/** aggregate fields of "notification.notification_users" */
export type notificationUserAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<notificationUserSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "notification.notification_users". All fields are combined with a logical 'AND'. */
export type notificationUserBoolExp = {
  _and?: InputMaybe<Array<notificationUserBoolExp>>;
  _not?: InputMaybe<notificationUserBoolExp>;
  _or?: InputMaybe<Array<notificationUserBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  toggleNotification?: InputMaybe<BooleanComparisonExp>;
  toggleNotificationBusinessHoursIgnore?: InputMaybe<BooleanComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userPushSettings?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "notification.notification_users" */
export type notificationUserConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'notification_users_pkey'
  /** unique or primary key constraint on columns "user_id" */
  | 'notification_users_user_id_key'
  | '%future added value';

/** columns and relationships of "notification.notification_user_devices" */
export type notificationUserDevice = {
  __typename?: 'notificationUserDevice';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deviceAppVersion?: Maybe<Scalars['String']['output']>;
  deviceBrand?: Maybe<Scalars['String']['output']>;
  deviceIsDevice?: Maybe<Scalars['Boolean']['output']>;
  deviceLocale?: Maybe<Scalars['String']['output']>;
  deviceModel?: Maybe<Scalars['String']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  deviceOs?: Maybe<Scalars['String']['output']>;
  deviceOsVersion?: Maybe<Scalars['String']['output']>;
  deviceRestarts?: Maybe<Scalars['Int']['output']>;
  deviceSettings?: Maybe<Scalars['String']['output']>;
  deviceTimezone?: Maybe<Scalars['String']['output']>;
  deviceYear?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  nativePushToken?: Maybe<Scalars['String']['output']>;
  pushDelay?: Maybe<Scalars['Int']['output']>;
  pushToken?: Maybe<Scalars['String']['output']>;
  retries: Scalars['Int']['output'];
  retryDelay: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  useExpo?: Maybe<Scalars['Boolean']['output']>;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "notification.notification_user_devices" */
export type notificationUserDeviceAggregate = {
  __typename?: 'notificationUserDeviceAggregate';
  aggregate?: Maybe<notificationUserDeviceAggregateFields>;
  nodes: Array<notificationUserDevice>;
};

export type notificationUserDeviceAggregateBoolExp = {
  bool_and?: InputMaybe<notificationUserDeviceAggregateBoolExpBool_and>;
  bool_or?: InputMaybe<notificationUserDeviceAggregateBoolExpBool_or>;
  count?: InputMaybe<notificationUserDeviceAggregateBoolExpCount>;
};

export type notificationUserDeviceAggregateBoolExpBool_and = {
  arguments: notificationUserDeviceSelectColumnNotificationUserDeviceAggregateBoolExpBool_andArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<notificationUserDeviceBoolExp>;
  predicate: BooleanComparisonExp;
};

export type notificationUserDeviceAggregateBoolExpBool_or = {
  arguments: notificationUserDeviceSelectColumnNotificationUserDeviceAggregateBoolExpBool_orArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<notificationUserDeviceBoolExp>;
  predicate: BooleanComparisonExp;
};

export type notificationUserDeviceAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<notificationUserDeviceSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<notificationUserDeviceBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "notification.notification_user_devices" */
export type notificationUserDeviceAggregateFields = {
  __typename?: 'notificationUserDeviceAggregateFields';
  avg?: Maybe<notificationUserDeviceAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<notificationUserDeviceMaxFields>;
  min?: Maybe<notificationUserDeviceMinFields>;
  stddev?: Maybe<notificationUserDeviceStddevFields>;
  stddevPop?: Maybe<notificationUserDeviceStddevPopFields>;
  stddevSamp?: Maybe<notificationUserDeviceStddevSampFields>;
  sum?: Maybe<notificationUserDeviceSumFields>;
  varPop?: Maybe<notificationUserDeviceVarPopFields>;
  varSamp?: Maybe<notificationUserDeviceVarSampFields>;
  variance?: Maybe<notificationUserDeviceVarianceFields>;
};


/** aggregate fields of "notification.notification_user_devices" */
export type notificationUserDeviceAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<notificationUserDeviceSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "notification.notification_user_devices" */
export type notificationUserDeviceAggregateOrderBy = {
  avg?: InputMaybe<notificationUserDeviceAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<notificationUserDeviceMaxOrderBy>;
  min?: InputMaybe<notificationUserDeviceMinOrderBy>;
  stddev?: InputMaybe<notificationUserDeviceStddevOrderBy>;
  stddevPop?: InputMaybe<notificationUserDeviceStddevPopOrderBy>;
  stddevSamp?: InputMaybe<notificationUserDeviceStddevSampOrderBy>;
  sum?: InputMaybe<notificationUserDeviceSumOrderBy>;
  varPop?: InputMaybe<notificationUserDeviceVarPopOrderBy>;
  varSamp?: InputMaybe<notificationUserDeviceVarSampOrderBy>;
  variance?: InputMaybe<notificationUserDeviceVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "notification.notification_user_devices" */
export type notificationUserDeviceArrRelInsertInput = {
  data: Array<notificationUserDeviceInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<notificationUserDeviceOnConflict>;
};

/** aggregate avg on columns */
export type notificationUserDeviceAvgFields = {
  __typename?: 'notificationUserDeviceAvgFields';
  deviceRestarts?: Maybe<Scalars['Float']['output']>;
  pushDelay?: Maybe<Scalars['Float']['output']>;
  retries?: Maybe<Scalars['Float']['output']>;
  retryDelay?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "notification.notification_user_devices" */
export type notificationUserDeviceAvgOrderBy = {
  deviceRestarts?: InputMaybe<OrderBy>;
  pushDelay?: InputMaybe<OrderBy>;
  retries?: InputMaybe<OrderBy>;
  retryDelay?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "notification.notification_user_devices". All fields are combined with a logical 'AND'. */
export type notificationUserDeviceBoolExp = {
  _and?: InputMaybe<Array<notificationUserDeviceBoolExp>>;
  _not?: InputMaybe<notificationUserDeviceBoolExp>;
  _or?: InputMaybe<Array<notificationUserDeviceBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deviceAppVersion?: InputMaybe<StringComparisonExp>;
  deviceBrand?: InputMaybe<StringComparisonExp>;
  deviceIsDevice?: InputMaybe<BooleanComparisonExp>;
  deviceLocale?: InputMaybe<StringComparisonExp>;
  deviceModel?: InputMaybe<StringComparisonExp>;
  deviceName?: InputMaybe<StringComparisonExp>;
  deviceOs?: InputMaybe<StringComparisonExp>;
  deviceOsVersion?: InputMaybe<StringComparisonExp>;
  deviceRestarts?: InputMaybe<IntComparisonExp>;
  deviceSettings?: InputMaybe<StringComparisonExp>;
  deviceTimezone?: InputMaybe<StringComparisonExp>;
  deviceYear?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  nativePushToken?: InputMaybe<StringComparisonExp>;
  pushDelay?: InputMaybe<IntComparisonExp>;
  pushToken?: InputMaybe<StringComparisonExp>;
  retries?: InputMaybe<IntComparisonExp>;
  retryDelay?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  useExpo?: InputMaybe<BooleanComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "notification.notification_user_devices" */
export type notificationUserDeviceConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'notification_user_devices_id_key'
  /** unique or primary key constraint on columns "id" */
  | 'notification_user_devices_pkey'
  | '%future added value';

/** input type for incrementing numeric columns in table "notification.notification_user_devices" */
export type notificationUserDeviceIncInput = {
  deviceRestarts?: InputMaybe<Scalars['Int']['input']>;
  pushDelay?: InputMaybe<Scalars['Int']['input']>;
  retries?: InputMaybe<Scalars['Int']['input']>;
  retryDelay?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "notification.notification_user_devices" */
export type notificationUserDeviceInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deviceAppVersion?: InputMaybe<Scalars['String']['input']>;
  deviceBrand?: InputMaybe<Scalars['String']['input']>;
  deviceIsDevice?: InputMaybe<Scalars['Boolean']['input']>;
  deviceLocale?: InputMaybe<Scalars['String']['input']>;
  deviceModel?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  deviceOs?: InputMaybe<Scalars['String']['input']>;
  deviceOsVersion?: InputMaybe<Scalars['String']['input']>;
  deviceRestarts?: InputMaybe<Scalars['Int']['input']>;
  deviceSettings?: InputMaybe<Scalars['String']['input']>;
  deviceTimezone?: InputMaybe<Scalars['String']['input']>;
  deviceYear?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nativePushToken?: InputMaybe<Scalars['String']['input']>;
  pushDelay?: InputMaybe<Scalars['Int']['input']>;
  pushToken?: InputMaybe<Scalars['String']['input']>;
  retries?: InputMaybe<Scalars['Int']['input']>;
  retryDelay?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  useExpo?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type notificationUserDeviceMaxFields = {
  __typename?: 'notificationUserDeviceMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deviceAppVersion?: Maybe<Scalars['String']['output']>;
  deviceBrand?: Maybe<Scalars['String']['output']>;
  deviceLocale?: Maybe<Scalars['String']['output']>;
  deviceModel?: Maybe<Scalars['String']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  deviceOs?: Maybe<Scalars['String']['output']>;
  deviceOsVersion?: Maybe<Scalars['String']['output']>;
  deviceRestarts?: Maybe<Scalars['Int']['output']>;
  deviceSettings?: Maybe<Scalars['String']['output']>;
  deviceTimezone?: Maybe<Scalars['String']['output']>;
  deviceYear?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  nativePushToken?: Maybe<Scalars['String']['output']>;
  pushDelay?: Maybe<Scalars['Int']['output']>;
  pushToken?: Maybe<Scalars['String']['output']>;
  retries?: Maybe<Scalars['Int']['output']>;
  retryDelay?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "notification.notification_user_devices" */
export type notificationUserDeviceMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deviceAppVersion?: InputMaybe<OrderBy>;
  deviceBrand?: InputMaybe<OrderBy>;
  deviceLocale?: InputMaybe<OrderBy>;
  deviceModel?: InputMaybe<OrderBy>;
  deviceName?: InputMaybe<OrderBy>;
  deviceOs?: InputMaybe<OrderBy>;
  deviceOsVersion?: InputMaybe<OrderBy>;
  deviceRestarts?: InputMaybe<OrderBy>;
  deviceSettings?: InputMaybe<OrderBy>;
  deviceTimezone?: InputMaybe<OrderBy>;
  deviceYear?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  nativePushToken?: InputMaybe<OrderBy>;
  pushDelay?: InputMaybe<OrderBy>;
  pushToken?: InputMaybe<OrderBy>;
  retries?: InputMaybe<OrderBy>;
  retryDelay?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type notificationUserDeviceMinFields = {
  __typename?: 'notificationUserDeviceMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deviceAppVersion?: Maybe<Scalars['String']['output']>;
  deviceBrand?: Maybe<Scalars['String']['output']>;
  deviceLocale?: Maybe<Scalars['String']['output']>;
  deviceModel?: Maybe<Scalars['String']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  deviceOs?: Maybe<Scalars['String']['output']>;
  deviceOsVersion?: Maybe<Scalars['String']['output']>;
  deviceRestarts?: Maybe<Scalars['Int']['output']>;
  deviceSettings?: Maybe<Scalars['String']['output']>;
  deviceTimezone?: Maybe<Scalars['String']['output']>;
  deviceYear?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  nativePushToken?: Maybe<Scalars['String']['output']>;
  pushDelay?: Maybe<Scalars['Int']['output']>;
  pushToken?: Maybe<Scalars['String']['output']>;
  retries?: Maybe<Scalars['Int']['output']>;
  retryDelay?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "notification.notification_user_devices" */
export type notificationUserDeviceMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deviceAppVersion?: InputMaybe<OrderBy>;
  deviceBrand?: InputMaybe<OrderBy>;
  deviceLocale?: InputMaybe<OrderBy>;
  deviceModel?: InputMaybe<OrderBy>;
  deviceName?: InputMaybe<OrderBy>;
  deviceOs?: InputMaybe<OrderBy>;
  deviceOsVersion?: InputMaybe<OrderBy>;
  deviceRestarts?: InputMaybe<OrderBy>;
  deviceSettings?: InputMaybe<OrderBy>;
  deviceTimezone?: InputMaybe<OrderBy>;
  deviceYear?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  nativePushToken?: InputMaybe<OrderBy>;
  pushDelay?: InputMaybe<OrderBy>;
  pushToken?: InputMaybe<OrderBy>;
  retries?: InputMaybe<OrderBy>;
  retryDelay?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "notification.notification_user_devices" */
export type notificationUserDeviceMutationResponse = {
  __typename?: 'notificationUserDeviceMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<notificationUserDevice>;
};

/** input type for inserting object relation for remote table "notification.notification_user_devices" */
export type notificationUserDeviceObjRelInsertInput = {
  data: notificationUserDeviceInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<notificationUserDeviceOnConflict>;
};

/** on_conflict condition type for table "notification.notification_user_devices" */
export type notificationUserDeviceOnConflict = {
  constraint: notificationUserDeviceConstraint;
  updateColumns?: Array<notificationUserDeviceUpdateColumn>;
  where?: InputMaybe<notificationUserDeviceBoolExp>;
};

/** Ordering options when selecting data from "notification.notification_user_devices". */
export type notificationUserDeviceOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deviceAppVersion?: InputMaybe<OrderBy>;
  deviceBrand?: InputMaybe<OrderBy>;
  deviceIsDevice?: InputMaybe<OrderBy>;
  deviceLocale?: InputMaybe<OrderBy>;
  deviceModel?: InputMaybe<OrderBy>;
  deviceName?: InputMaybe<OrderBy>;
  deviceOs?: InputMaybe<OrderBy>;
  deviceOsVersion?: InputMaybe<OrderBy>;
  deviceRestarts?: InputMaybe<OrderBy>;
  deviceSettings?: InputMaybe<OrderBy>;
  deviceTimezone?: InputMaybe<OrderBy>;
  deviceYear?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  nativePushToken?: InputMaybe<OrderBy>;
  pushDelay?: InputMaybe<OrderBy>;
  pushToken?: InputMaybe<OrderBy>;
  retries?: InputMaybe<OrderBy>;
  retryDelay?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  useExpo?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: notification.notification_user_devices */
export type notificationUserDevicePkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "notification.notification_user_devices" */
export type notificationUserDeviceSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'deviceAppVersion'
  /** column name */
  | 'deviceBrand'
  /** column name */
  | 'deviceIsDevice'
  /** column name */
  | 'deviceLocale'
  /** column name */
  | 'deviceModel'
  /** column name */
  | 'deviceName'
  /** column name */
  | 'deviceOs'
  /** column name */
  | 'deviceOsVersion'
  /** column name */
  | 'deviceRestarts'
  /** column name */
  | 'deviceSettings'
  /** column name */
  | 'deviceTimezone'
  /** column name */
  | 'deviceYear'
  /** column name */
  | 'id'
  /** column name */
  | 'nativePushToken'
  /** column name */
  | 'pushDelay'
  /** column name */
  | 'pushToken'
  /** column name */
  | 'retries'
  /** column name */
  | 'retryDelay'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'useExpo'
  /** column name */
  | 'userId'
  | '%future added value';

/** select "notificationUserDeviceAggregateBoolExpBool_andArgumentsColumns" columns of table "notification.notification_user_devices" */
export type notificationUserDeviceSelectColumnNotificationUserDeviceAggregateBoolExpBool_andArgumentsColumns =
  /** column name */
  | 'deviceIsDevice'
  /** column name */
  | 'useExpo'
  | '%future added value';

/** select "notificationUserDeviceAggregateBoolExpBool_orArgumentsColumns" columns of table "notification.notification_user_devices" */
export type notificationUserDeviceSelectColumnNotificationUserDeviceAggregateBoolExpBool_orArgumentsColumns =
  /** column name */
  | 'deviceIsDevice'
  /** column name */
  | 'useExpo'
  | '%future added value';

/** input type for updating data in table "notification.notification_user_devices" */
export type notificationUserDeviceSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deviceAppVersion?: InputMaybe<Scalars['String']['input']>;
  deviceBrand?: InputMaybe<Scalars['String']['input']>;
  deviceIsDevice?: InputMaybe<Scalars['Boolean']['input']>;
  deviceLocale?: InputMaybe<Scalars['String']['input']>;
  deviceModel?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  deviceOs?: InputMaybe<Scalars['String']['input']>;
  deviceOsVersion?: InputMaybe<Scalars['String']['input']>;
  deviceRestarts?: InputMaybe<Scalars['Int']['input']>;
  deviceSettings?: InputMaybe<Scalars['String']['input']>;
  deviceTimezone?: InputMaybe<Scalars['String']['input']>;
  deviceYear?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nativePushToken?: InputMaybe<Scalars['String']['input']>;
  pushDelay?: InputMaybe<Scalars['Int']['input']>;
  pushToken?: InputMaybe<Scalars['String']['input']>;
  retries?: InputMaybe<Scalars['Int']['input']>;
  retryDelay?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  useExpo?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type notificationUserDeviceStddevFields = {
  __typename?: 'notificationUserDeviceStddevFields';
  deviceRestarts?: Maybe<Scalars['Float']['output']>;
  pushDelay?: Maybe<Scalars['Float']['output']>;
  retries?: Maybe<Scalars['Float']['output']>;
  retryDelay?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "notification.notification_user_devices" */
export type notificationUserDeviceStddevOrderBy = {
  deviceRestarts?: InputMaybe<OrderBy>;
  pushDelay?: InputMaybe<OrderBy>;
  retries?: InputMaybe<OrderBy>;
  retryDelay?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type notificationUserDeviceStddevPopFields = {
  __typename?: 'notificationUserDeviceStddevPopFields';
  deviceRestarts?: Maybe<Scalars['Float']['output']>;
  pushDelay?: Maybe<Scalars['Float']['output']>;
  retries?: Maybe<Scalars['Float']['output']>;
  retryDelay?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "notification.notification_user_devices" */
export type notificationUserDeviceStddevPopOrderBy = {
  deviceRestarts?: InputMaybe<OrderBy>;
  pushDelay?: InputMaybe<OrderBy>;
  retries?: InputMaybe<OrderBy>;
  retryDelay?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type notificationUserDeviceStddevSampFields = {
  __typename?: 'notificationUserDeviceStddevSampFields';
  deviceRestarts?: Maybe<Scalars['Float']['output']>;
  pushDelay?: Maybe<Scalars['Float']['output']>;
  retries?: Maybe<Scalars['Float']['output']>;
  retryDelay?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "notification.notification_user_devices" */
export type notificationUserDeviceStddevSampOrderBy = {
  deviceRestarts?: InputMaybe<OrderBy>;
  pushDelay?: InputMaybe<OrderBy>;
  retries?: InputMaybe<OrderBy>;
  retryDelay?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "notificationUserDevice" */
export type notificationUserDeviceStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: notificationUserDeviceStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type notificationUserDeviceStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deviceAppVersion?: InputMaybe<Scalars['String']['input']>;
  deviceBrand?: InputMaybe<Scalars['String']['input']>;
  deviceIsDevice?: InputMaybe<Scalars['Boolean']['input']>;
  deviceLocale?: InputMaybe<Scalars['String']['input']>;
  deviceModel?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  deviceOs?: InputMaybe<Scalars['String']['input']>;
  deviceOsVersion?: InputMaybe<Scalars['String']['input']>;
  deviceRestarts?: InputMaybe<Scalars['Int']['input']>;
  deviceSettings?: InputMaybe<Scalars['String']['input']>;
  deviceTimezone?: InputMaybe<Scalars['String']['input']>;
  deviceYear?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nativePushToken?: InputMaybe<Scalars['String']['input']>;
  pushDelay?: InputMaybe<Scalars['Int']['input']>;
  pushToken?: InputMaybe<Scalars['String']['input']>;
  retries?: InputMaybe<Scalars['Int']['input']>;
  retryDelay?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  useExpo?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type notificationUserDeviceSumFields = {
  __typename?: 'notificationUserDeviceSumFields';
  deviceRestarts?: Maybe<Scalars['Int']['output']>;
  pushDelay?: Maybe<Scalars['Int']['output']>;
  retries?: Maybe<Scalars['Int']['output']>;
  retryDelay?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "notification.notification_user_devices" */
export type notificationUserDeviceSumOrderBy = {
  deviceRestarts?: InputMaybe<OrderBy>;
  pushDelay?: InputMaybe<OrderBy>;
  retries?: InputMaybe<OrderBy>;
  retryDelay?: InputMaybe<OrderBy>;
};

/** update columns of table "notification.notification_user_devices" */
export type notificationUserDeviceUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'deviceAppVersion'
  /** column name */
  | 'deviceBrand'
  /** column name */
  | 'deviceIsDevice'
  /** column name */
  | 'deviceLocale'
  /** column name */
  | 'deviceModel'
  /** column name */
  | 'deviceName'
  /** column name */
  | 'deviceOs'
  /** column name */
  | 'deviceOsVersion'
  /** column name */
  | 'deviceRestarts'
  /** column name */
  | 'deviceSettings'
  /** column name */
  | 'deviceTimezone'
  /** column name */
  | 'deviceYear'
  /** column name */
  | 'id'
  /** column name */
  | 'nativePushToken'
  /** column name */
  | 'pushDelay'
  /** column name */
  | 'pushToken'
  /** column name */
  | 'retries'
  /** column name */
  | 'retryDelay'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'useExpo'
  /** column name */
  | 'userId'
  | '%future added value';

export type notificationUserDeviceUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<notificationUserDeviceIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<notificationUserDeviceSetInput>;
  /** filter the rows which have to be updated */
  where: notificationUserDeviceBoolExp;
};

/** aggregate varPop on columns */
export type notificationUserDeviceVarPopFields = {
  __typename?: 'notificationUserDeviceVarPopFields';
  deviceRestarts?: Maybe<Scalars['Float']['output']>;
  pushDelay?: Maybe<Scalars['Float']['output']>;
  retries?: Maybe<Scalars['Float']['output']>;
  retryDelay?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "notification.notification_user_devices" */
export type notificationUserDeviceVarPopOrderBy = {
  deviceRestarts?: InputMaybe<OrderBy>;
  pushDelay?: InputMaybe<OrderBy>;
  retries?: InputMaybe<OrderBy>;
  retryDelay?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type notificationUserDeviceVarSampFields = {
  __typename?: 'notificationUserDeviceVarSampFields';
  deviceRestarts?: Maybe<Scalars['Float']['output']>;
  pushDelay?: Maybe<Scalars['Float']['output']>;
  retries?: Maybe<Scalars['Float']['output']>;
  retryDelay?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "notification.notification_user_devices" */
export type notificationUserDeviceVarSampOrderBy = {
  deviceRestarts?: InputMaybe<OrderBy>;
  pushDelay?: InputMaybe<OrderBy>;
  retries?: InputMaybe<OrderBy>;
  retryDelay?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type notificationUserDeviceVarianceFields = {
  __typename?: 'notificationUserDeviceVarianceFields';
  deviceRestarts?: Maybe<Scalars['Float']['output']>;
  pushDelay?: Maybe<Scalars['Float']['output']>;
  retries?: Maybe<Scalars['Float']['output']>;
  retryDelay?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "notification.notification_user_devices" */
export type notificationUserDeviceVarianceOrderBy = {
  deviceRestarts?: InputMaybe<OrderBy>;
  pushDelay?: InputMaybe<OrderBy>;
  retries?: InputMaybe<OrderBy>;
  retryDelay?: InputMaybe<OrderBy>;
};

/** input type for inserting data into table "notification.notification_users" */
export type notificationUserInsertInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  toggleNotification?: InputMaybe<Scalars['Boolean']['input']>;
  toggleNotificationBusinessHoursIgnore?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  userPushSettings?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type notificationUserMaxFields = {
  __typename?: 'notificationUserMaxFields';
  id?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  userPushSettings?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type notificationUserMinFields = {
  __typename?: 'notificationUserMinFields';
  id?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  userPushSettings?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "notification.notification_users" */
export type notificationUserMutationResponse = {
  __typename?: 'notificationUserMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<notificationUser>;
};

/** on_conflict condition type for table "notification.notification_users" */
export type notificationUserOnConflict = {
  constraint: notificationUserConstraint;
  updateColumns?: Array<notificationUserUpdateColumn>;
  where?: InputMaybe<notificationUserBoolExp>;
};

/** Ordering options when selecting data from "notification.notification_users". */
export type notificationUserOrderBy = {
  id?: InputMaybe<OrderBy>;
  toggleNotification?: InputMaybe<OrderBy>;
  toggleNotificationBusinessHoursIgnore?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  userPushSettings?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: notification.notification_users */
export type notificationUserPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "notification.notification_users" */
export type notificationUserSelectColumn =
  /** column name */
  | 'id'
  /** column name */
  | 'toggleNotification'
  /** column name */
  | 'toggleNotificationBusinessHoursIgnore'
  /** column name */
  | 'userId'
  /** column name */
  | 'userPushSettings'
  | '%future added value';

/** input type for updating data in table "notification.notification_users" */
export type notificationUserSetInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  toggleNotification?: InputMaybe<Scalars['Boolean']['input']>;
  toggleNotificationBusinessHoursIgnore?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  userPushSettings?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "notificationUser" */
export type notificationUserStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: notificationUserStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type notificationUserStreamCursorValueInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  toggleNotification?: InputMaybe<Scalars['Boolean']['input']>;
  toggleNotificationBusinessHoursIgnore?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  userPushSettings?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "notification.notification_users" */
export type notificationUserUpdateColumn =
  /** column name */
  | 'id'
  /** column name */
  | 'toggleNotification'
  /** column name */
  | 'toggleNotificationBusinessHoursIgnore'
  /** column name */
  | 'userId'
  /** column name */
  | 'userPushSettings'
  | '%future added value';

export type notificationUserUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<notificationUserSetInput>;
  /** filter the rows which have to be updated */
  where: notificationUserBoolExp;
};

/** columns and relationships of "orders.integrations" */
export type ordersIntegrations = {
  __typename?: 'ordersIntegrations';
  active: Scalars['Boolean']['output'];
  authLevel: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  deliveryDate?: Maybe<Scalars['timestamptz']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  integrations_organization: organization;
  lastName?: Maybe<Scalars['String']['output']>;
  licenses?: Maybe<Scalars['Int']['output']>;
  lockedBy?: Maybe<Scalars['uuid']['output']>;
  organizationId: Scalars['uuid']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationNumber?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  providerAccountId?: Maybe<Scalars['String']['output']>;
  request?: Maybe<OrdersRequestEnum>;
  requestStatus?: Maybe<OrdersStatusEnum>;
  terms: Scalars['String']['output'];
  termsversion: Scalars['String']['output'];
  type: OrdersTypeEnum;
  updatedAt: Scalars['timestamptz']['output'];
  userId: Scalars['uuid']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "orders.integrations" */
export type ordersIntegrationsAggregate = {
  __typename?: 'ordersIntegrationsAggregate';
  aggregate?: Maybe<ordersIntegrationsAggregateFields>;
  nodes: Array<ordersIntegrations>;
};

export type ordersIntegrationsAggregateBoolExp = {
  bool_and?: InputMaybe<ordersIntegrationsAggregateBoolExpBool_and>;
  bool_or?: InputMaybe<ordersIntegrationsAggregateBoolExpBool_or>;
  count?: InputMaybe<ordersIntegrationsAggregateBoolExpCount>;
};

export type ordersIntegrationsAggregateBoolExpBool_and = {
  arguments: ordersIntegrationsSelectColumnOrdersIntegrationsAggregateBoolExpBool_andArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ordersIntegrationsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ordersIntegrationsAggregateBoolExpBool_or = {
  arguments: ordersIntegrationsSelectColumnOrdersIntegrationsAggregateBoolExpBool_orArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ordersIntegrationsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ordersIntegrationsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ordersIntegrationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ordersIntegrationsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "orders.integrations" */
export type ordersIntegrationsAggregateFields = {
  __typename?: 'ordersIntegrationsAggregateFields';
  avg?: Maybe<ordersIntegrationsAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ordersIntegrationsMaxFields>;
  min?: Maybe<ordersIntegrationsMinFields>;
  stddev?: Maybe<ordersIntegrationsStddevFields>;
  stddevPop?: Maybe<ordersIntegrationsStddevPopFields>;
  stddevSamp?: Maybe<ordersIntegrationsStddevSampFields>;
  sum?: Maybe<ordersIntegrationsSumFields>;
  varPop?: Maybe<ordersIntegrationsVarPopFields>;
  varSamp?: Maybe<ordersIntegrationsVarSampFields>;
  variance?: Maybe<ordersIntegrationsVarianceFields>;
};


/** aggregate fields of "orders.integrations" */
export type ordersIntegrationsAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<ordersIntegrationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "orders.integrations" */
export type ordersIntegrationsAggregateOrderBy = {
  avg?: InputMaybe<ordersIntegrationsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ordersIntegrationsMaxOrderBy>;
  min?: InputMaybe<ordersIntegrationsMinOrderBy>;
  stddev?: InputMaybe<ordersIntegrationsStddevOrderBy>;
  stddevPop?: InputMaybe<ordersIntegrationsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ordersIntegrationsStddevSampOrderBy>;
  sum?: InputMaybe<ordersIntegrationsSumOrderBy>;
  varPop?: InputMaybe<ordersIntegrationsVarPopOrderBy>;
  varSamp?: InputMaybe<ordersIntegrationsVarSampOrderBy>;
  variance?: InputMaybe<ordersIntegrationsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "orders.integrations" */
export type ordersIntegrationsArrRelInsertInput = {
  data: Array<ordersIntegrationsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ordersIntegrationsOnConflict>;
};

/** aggregate avg on columns */
export type ordersIntegrationsAvgFields = {
  __typename?: 'ordersIntegrationsAvgFields';
  licenses?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "orders.integrations" */
export type ordersIntegrationsAvgOrderBy = {
  licenses?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "orders.integrations". All fields are combined with a logical 'AND'. */
export type ordersIntegrationsBoolExp = {
  _and?: InputMaybe<Array<ordersIntegrationsBoolExp>>;
  _not?: InputMaybe<ordersIntegrationsBoolExp>;
  _or?: InputMaybe<Array<ordersIntegrationsBoolExp>>;
  active?: InputMaybe<BooleanComparisonExp>;
  authLevel?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deliveryDate?: InputMaybe<TimestamptzComparisonExp>;
  firstName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  integrations_organization?: InputMaybe<organizationBoolExp>;
  lastName?: InputMaybe<StringComparisonExp>;
  licenses?: InputMaybe<IntComparisonExp>;
  lockedBy?: InputMaybe<UuidComparisonExp>;
  organizationId?: InputMaybe<UuidComparisonExp>;
  organizationName?: InputMaybe<StringComparisonExp>;
  organizationNumber?: InputMaybe<StringComparisonExp>;
  password?: InputMaybe<StringComparisonExp>;
  phoneNumber?: InputMaybe<StringComparisonExp>;
  price?: InputMaybe<StringComparisonExp>;
  providerAccountId?: InputMaybe<StringComparisonExp>;
  request?: InputMaybe<OrdersRequestEnumComparisonExp>;
  requestStatus?: InputMaybe<OrdersStatusEnumComparisonExp>;
  terms?: InputMaybe<StringComparisonExp>;
  termsversion?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<OrdersTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  username?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "orders.integrations" */
export type ordersIntegrationsConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'integrations_pkey'
  | '%future added value';

/** input type for incrementing numeric columns in table "orders.integrations" */
export type ordersIntegrationsIncInput = {
  licenses?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "orders.integrations" */
export type ordersIntegrationsInsertInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  authLevel?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deliveryDate?: InputMaybe<Scalars['timestamptz']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  integrations_organization?: InputMaybe<organizationObjRelInsertInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  licenses?: InputMaybe<Scalars['Int']['input']>;
  lockedBy?: InputMaybe<Scalars['uuid']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  providerAccountId?: InputMaybe<Scalars['String']['input']>;
  request?: InputMaybe<OrdersRequestEnum>;
  requestStatus?: InputMaybe<OrdersStatusEnum>;
  terms?: InputMaybe<Scalars['String']['input']>;
  termsversion?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OrdersTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ordersIntegrationsMaxFields = {
  __typename?: 'ordersIntegrationsMaxFields';
  authLevel?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deliveryDate?: Maybe<Scalars['timestamptz']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  licenses?: Maybe<Scalars['Int']['output']>;
  lockedBy?: Maybe<Scalars['uuid']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationNumber?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  providerAccountId?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Scalars['String']['output']>;
  termsversion?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "orders.integrations" */
export type ordersIntegrationsMaxOrderBy = {
  authLevel?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deliveryDate?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  licenses?: InputMaybe<OrderBy>;
  lockedBy?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  organizationName?: InputMaybe<OrderBy>;
  organizationNumber?: InputMaybe<OrderBy>;
  password?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  price?: InputMaybe<OrderBy>;
  providerAccountId?: InputMaybe<OrderBy>;
  terms?: InputMaybe<OrderBy>;
  termsversion?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  username?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ordersIntegrationsMinFields = {
  __typename?: 'ordersIntegrationsMinFields';
  authLevel?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deliveryDate?: Maybe<Scalars['timestamptz']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  licenses?: Maybe<Scalars['Int']['output']>;
  lockedBy?: Maybe<Scalars['uuid']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationNumber?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  providerAccountId?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Scalars['String']['output']>;
  termsversion?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "orders.integrations" */
export type ordersIntegrationsMinOrderBy = {
  authLevel?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deliveryDate?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  licenses?: InputMaybe<OrderBy>;
  lockedBy?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  organizationName?: InputMaybe<OrderBy>;
  organizationNumber?: InputMaybe<OrderBy>;
  password?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  price?: InputMaybe<OrderBy>;
  providerAccountId?: InputMaybe<OrderBy>;
  terms?: InputMaybe<OrderBy>;
  termsversion?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  username?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "orders.integrations" */
export type ordersIntegrationsMutationResponse = {
  __typename?: 'ordersIntegrationsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ordersIntegrations>;
};

/** input type for inserting object relation for remote table "orders.integrations" */
export type ordersIntegrationsObjRelInsertInput = {
  data: ordersIntegrationsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ordersIntegrationsOnConflict>;
};

/** on_conflict condition type for table "orders.integrations" */
export type ordersIntegrationsOnConflict = {
  constraint: ordersIntegrationsConstraint;
  updateColumns?: Array<ordersIntegrationsUpdateColumn>;
  where?: InputMaybe<ordersIntegrationsBoolExp>;
};

/** Ordering options when selecting data from "orders.integrations". */
export type ordersIntegrationsOrderBy = {
  active?: InputMaybe<OrderBy>;
  authLevel?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deliveryDate?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integrations_organization?: InputMaybe<organizationOrderBy>;
  lastName?: InputMaybe<OrderBy>;
  licenses?: InputMaybe<OrderBy>;
  lockedBy?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  organizationName?: InputMaybe<OrderBy>;
  organizationNumber?: InputMaybe<OrderBy>;
  password?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  price?: InputMaybe<OrderBy>;
  providerAccountId?: InputMaybe<OrderBy>;
  request?: InputMaybe<OrderBy>;
  requestStatus?: InputMaybe<OrderBy>;
  terms?: InputMaybe<OrderBy>;
  termsversion?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  username?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: orders.integrations */
export type ordersIntegrationsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "orders.integrations" */
export type ordersIntegrationsSelectColumn =
  /** column name */
  | 'active'
  /** column name */
  | 'authLevel'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'deliveryDate'
  /** column name */
  | 'firstName'
  /** column name */
  | 'id'
  /** column name */
  | 'lastName'
  /** column name */
  | 'licenses'
  /** column name */
  | 'lockedBy'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'organizationName'
  /** column name */
  | 'organizationNumber'
  /** column name */
  | 'password'
  /** column name */
  | 'phoneNumber'
  /** column name */
  | 'price'
  /** column name */
  | 'providerAccountId'
  /** column name */
  | 'request'
  /** column name */
  | 'requestStatus'
  /** column name */
  | 'terms'
  /** column name */
  | 'termsversion'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  /** column name */
  | 'username'
  | '%future added value';

/** select "ordersIntegrationsAggregateBoolExpBool_andArgumentsColumns" columns of table "orders.integrations" */
export type ordersIntegrationsSelectColumnOrdersIntegrationsAggregateBoolExpBool_andArgumentsColumns =
  /** column name */
  | 'active'
  | '%future added value';

/** select "ordersIntegrationsAggregateBoolExpBool_orArgumentsColumns" columns of table "orders.integrations" */
export type ordersIntegrationsSelectColumnOrdersIntegrationsAggregateBoolExpBool_orArgumentsColumns =
  /** column name */
  | 'active'
  | '%future added value';

/** input type for updating data in table "orders.integrations" */
export type ordersIntegrationsSetInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  authLevel?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deliveryDate?: InputMaybe<Scalars['timestamptz']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  licenses?: InputMaybe<Scalars['Int']['input']>;
  lockedBy?: InputMaybe<Scalars['uuid']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  providerAccountId?: InputMaybe<Scalars['String']['input']>;
  request?: InputMaybe<OrdersRequestEnum>;
  requestStatus?: InputMaybe<OrdersStatusEnum>;
  terms?: InputMaybe<Scalars['String']['input']>;
  termsversion?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OrdersTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type ordersIntegrationsStddevFields = {
  __typename?: 'ordersIntegrationsStddevFields';
  licenses?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "orders.integrations" */
export type ordersIntegrationsStddevOrderBy = {
  licenses?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ordersIntegrationsStddevPopFields = {
  __typename?: 'ordersIntegrationsStddevPopFields';
  licenses?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "orders.integrations" */
export type ordersIntegrationsStddevPopOrderBy = {
  licenses?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ordersIntegrationsStddevSampFields = {
  __typename?: 'ordersIntegrationsStddevSampFields';
  licenses?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "orders.integrations" */
export type ordersIntegrationsStddevSampOrderBy = {
  licenses?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "ordersIntegrations" */
export type ordersIntegrationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ordersIntegrationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ordersIntegrationsStreamCursorValueInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  authLevel?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deliveryDate?: InputMaybe<Scalars['timestamptz']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  licenses?: InputMaybe<Scalars['Int']['input']>;
  lockedBy?: InputMaybe<Scalars['uuid']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  providerAccountId?: InputMaybe<Scalars['String']['input']>;
  request?: InputMaybe<OrdersRequestEnum>;
  requestStatus?: InputMaybe<OrdersStatusEnum>;
  terms?: InputMaybe<Scalars['String']['input']>;
  termsversion?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OrdersTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type ordersIntegrationsSumFields = {
  __typename?: 'ordersIntegrationsSumFields';
  licenses?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "orders.integrations" */
export type ordersIntegrationsSumOrderBy = {
  licenses?: InputMaybe<OrderBy>;
};

/** update columns of table "orders.integrations" */
export type ordersIntegrationsUpdateColumn =
  /** column name */
  | 'active'
  /** column name */
  | 'authLevel'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'deliveryDate'
  /** column name */
  | 'firstName'
  /** column name */
  | 'id'
  /** column name */
  | 'lastName'
  /** column name */
  | 'licenses'
  /** column name */
  | 'lockedBy'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'organizationName'
  /** column name */
  | 'organizationNumber'
  /** column name */
  | 'password'
  /** column name */
  | 'phoneNumber'
  /** column name */
  | 'price'
  /** column name */
  | 'providerAccountId'
  /** column name */
  | 'request'
  /** column name */
  | 'requestStatus'
  /** column name */
  | 'terms'
  /** column name */
  | 'termsversion'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  /** column name */
  | 'username'
  | '%future added value';

export type ordersIntegrationsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ordersIntegrationsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ordersIntegrationsSetInput>;
  /** filter the rows which have to be updated */
  where: ordersIntegrationsBoolExp;
};

/** aggregate varPop on columns */
export type ordersIntegrationsVarPopFields = {
  __typename?: 'ordersIntegrationsVarPopFields';
  licenses?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "orders.integrations" */
export type ordersIntegrationsVarPopOrderBy = {
  licenses?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ordersIntegrationsVarSampFields = {
  __typename?: 'ordersIntegrationsVarSampFields';
  licenses?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "orders.integrations" */
export type ordersIntegrationsVarSampOrderBy = {
  licenses?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ordersIntegrationsVarianceFields = {
  __typename?: 'ordersIntegrationsVarianceFields';
  licenses?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "orders.integrations" */
export type ordersIntegrationsVarianceOrderBy = {
  licenses?: InputMaybe<OrderBy>;
};

export type orgAccessRequestInput = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
};

export type orgAccessRequestOutput = {
  __typename?: 'orgAccessRequestOutput';
  result: Scalars['json']['output'];
};

/** Organisasjoner */
export type organization = {
  __typename?: 'organization';
  /** An aggregate relationship */
  activityOrganizationsAggregate: messagingActivityOrganizationAggregate;
  /** An array relationship */
  activity_organizations: Array<messagingActivityOrganization>;
  /** An object relationship */
  businessAddress?: Maybe<address>;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  createdBy?: Maybe<user>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nrOfEmployees?: Maybe<Scalars['Int']['output']>;
  organizationNumber?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  organizationUserInvites: Array<organizationUserInvite>;
  /** An aggregate relationship */
  organizationUserInvitesAggregate: organizationUserInviteAggregate;
  /** An array relationship */
  organizationUserRequests: Array<BusinessOrganizationUserRequest>;
  /** An aggregate relationship */
  organizationUserRequestsAggregate: BusinessOrganizationUserRequestAggregate;
  /** An array relationship */
  organizationUsers: Array<organizationUser>;
  /** An aggregate relationship */
  organizationUsersAggregate: organizationUserAggregate;
  /** An array relationship */
  organizationsDomainOrganizations: Array<domainOrganization>;
  /** An aggregate relationship */
  organizationsDomainOrganizationsAggregate: domainOrganizationAggregate;
  /** An array relationship */
  organizationsOrderIntegrations: Array<ordersIntegrations>;
  /** An aggregate relationship */
  organizationsOrderIntegrationsAggregate: ordersIntegrationsAggregate;
  /** An object relationship */
  owner?: Maybe<user>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  phoneroCustomerId?: Maybe<Scalars['String']['output']>;
  reinforceImportantMessagesWithSms?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  users: Array<organizationOrganizationUserUsersView>;
  /** An aggregate relationship */
  usersAggregate: organizationOrganizationUserUsersViewAggregate;
};


/** Organisasjoner */
export type organizationactivityOrganizationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<messagingActivityOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingActivityOrganizationOrderBy>>;
  where?: InputMaybe<messagingActivityOrganizationBoolExp>;
};


/** Organisasjoner */
export type organizationactivity_organizationsArgs = {
  distinctOn?: InputMaybe<Array<messagingActivityOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingActivityOrganizationOrderBy>>;
  where?: InputMaybe<messagingActivityOrganizationBoolExp>;
};


/** Organisasjoner */
export type organizationorganizationUserInvitesArgs = {
  distinctOn?: InputMaybe<Array<organizationUserInviteSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserInviteOrderBy>>;
  where?: InputMaybe<organizationUserInviteBoolExp>;
};


/** Organisasjoner */
export type organizationorganizationUserInvitesAggregateArgs = {
  distinctOn?: InputMaybe<Array<organizationUserInviteSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserInviteOrderBy>>;
  where?: InputMaybe<organizationUserInviteBoolExp>;
};


/** Organisasjoner */
export type organizationorganizationUserRequestsArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserRequestOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserRequestBoolExp>;
};


/** Organisasjoner */
export type organizationorganizationUserRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserRequestOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserRequestBoolExp>;
};


/** Organisasjoner */
export type organizationorganizationUsersArgs = {
  distinctOn?: InputMaybe<Array<organizationUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserOrderBy>>;
  where?: InputMaybe<organizationUserBoolExp>;
};


/** Organisasjoner */
export type organizationorganizationUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<organizationUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserOrderBy>>;
  where?: InputMaybe<organizationUserBoolExp>;
};


/** Organisasjoner */
export type organizationorganizationsDomainOrganizationsArgs = {
  distinctOn?: InputMaybe<Array<domainOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainOrganizationOrderBy>>;
  where?: InputMaybe<domainOrganizationBoolExp>;
};


/** Organisasjoner */
export type organizationorganizationsDomainOrganizationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<domainOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainOrganizationOrderBy>>;
  where?: InputMaybe<domainOrganizationBoolExp>;
};


/** Organisasjoner */
export type organizationorganizationsOrderIntegrationsArgs = {
  distinctOn?: InputMaybe<Array<ordersIntegrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ordersIntegrationsOrderBy>>;
  where?: InputMaybe<ordersIntegrationsBoolExp>;
};


/** Organisasjoner */
export type organizationorganizationsOrderIntegrationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ordersIntegrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ordersIntegrationsOrderBy>>;
  where?: InputMaybe<ordersIntegrationsBoolExp>;
};


/** Organisasjoner */
export type organizationusersArgs = {
  distinctOn?: InputMaybe<Array<organizationOrganizationUserUsersViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrganizationUserUsersViewOrderBy>>;
  where?: InputMaybe<organizationOrganizationUserUsersViewBoolExp>;
};


/** Organisasjoner */
export type organizationusersAggregateArgs = {
  distinctOn?: InputMaybe<Array<organizationOrganizationUserUsersViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrganizationUserUsersViewOrderBy>>;
  where?: InputMaybe<organizationOrganizationUserUsersViewBoolExp>;
};

/** aggregated selection of "business.organizations" */
export type organizationAggregate = {
  __typename?: 'organizationAggregate';
  aggregate?: Maybe<organizationAggregateFields>;
  nodes: Array<organization>;
};

export type organizationAggregateBoolExp = {
  bool_and?: InputMaybe<organizationAggregateBoolExpBool_and>;
  bool_or?: InputMaybe<organizationAggregateBoolExpBool_or>;
  count?: InputMaybe<organizationAggregateBoolExpCount>;
};

export type organizationAggregateBoolExpBool_and = {
  arguments: organizationSelectColumnOrganizationAggregateBoolExpBool_andArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<organizationBoolExp>;
  predicate: BooleanComparisonExp;
};

export type organizationAggregateBoolExpBool_or = {
  arguments: organizationSelectColumnOrganizationAggregateBoolExpBool_orArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<organizationBoolExp>;
  predicate: BooleanComparisonExp;
};

export type organizationAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<organizationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<organizationBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "business.organizations" */
export type organizationAggregateFields = {
  __typename?: 'organizationAggregateFields';
  avg?: Maybe<organizationAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<organizationMaxFields>;
  min?: Maybe<organizationMinFields>;
  stddev?: Maybe<organizationStddevFields>;
  stddevPop?: Maybe<organizationStddevPopFields>;
  stddevSamp?: Maybe<organizationStddevSampFields>;
  sum?: Maybe<organizationSumFields>;
  varPop?: Maybe<organizationVarPopFields>;
  varSamp?: Maybe<organizationVarSampFields>;
  variance?: Maybe<organizationVarianceFields>;
};


/** aggregate fields of "business.organizations" */
export type organizationAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<organizationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.organizations" */
export type organizationAggregateOrderBy = {
  avg?: InputMaybe<organizationAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<organizationMaxOrderBy>;
  min?: InputMaybe<organizationMinOrderBy>;
  stddev?: InputMaybe<organizationStddevOrderBy>;
  stddevPop?: InputMaybe<organizationStddevPopOrderBy>;
  stddevSamp?: InputMaybe<organizationStddevSampOrderBy>;
  sum?: InputMaybe<organizationSumOrderBy>;
  varPop?: InputMaybe<organizationVarPopOrderBy>;
  varSamp?: InputMaybe<organizationVarSampOrderBy>;
  variance?: InputMaybe<organizationVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "business.organizations" */
export type organizationArrRelInsertInput = {
  data: Array<organizationInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<organizationOnConflict>;
};

/** columns and relationships of "business.authorization_enum_group" */
export type organizationAuthorizationEnumGroup = {
  __typename?: 'organizationAuthorizationEnumGroup';
  authorization?: Maybe<organizationUserAuthorizationEnum>;
  groupId?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
};

/** aggregated selection of "business.authorization_enum_group" */
export type organizationAuthorizationEnumGroupAggregate = {
  __typename?: 'organizationAuthorizationEnumGroupAggregate';
  aggregate?: Maybe<organizationAuthorizationEnumGroupAggregateFields>;
  nodes: Array<organizationAuthorizationEnumGroup>;
};

export type organizationAuthorizationEnumGroupAggregateBoolExp = {
  count?: InputMaybe<organizationAuthorizationEnumGroupAggregateBoolExpCount>;
};

export type organizationAuthorizationEnumGroupAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<organizationAuthorizationEnumGroupSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<organizationAuthorizationEnumGroupBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "business.authorization_enum_group" */
export type organizationAuthorizationEnumGroupAggregateFields = {
  __typename?: 'organizationAuthorizationEnumGroupAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<organizationAuthorizationEnumGroupMaxFields>;
  min?: Maybe<organizationAuthorizationEnumGroupMinFields>;
};


/** aggregate fields of "business.authorization_enum_group" */
export type organizationAuthorizationEnumGroupAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<organizationAuthorizationEnumGroupSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.authorization_enum_group" */
export type organizationAuthorizationEnumGroupAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<organizationAuthorizationEnumGroupMaxOrderBy>;
  min?: InputMaybe<organizationAuthorizationEnumGroupMinOrderBy>;
};

/** input type for inserting array relation for remote table "business.authorization_enum_group" */
export type organizationAuthorizationEnumGroupArrRelInsertInput = {
  data: Array<organizationAuthorizationEnumGroupInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<organizationAuthorizationEnumGroupOnConflict>;
};

/** Boolean expression to filter rows from the table "business.authorization_enum_group". All fields are combined with a logical 'AND'. */
export type organizationAuthorizationEnumGroupBoolExp = {
  _and?: InputMaybe<Array<organizationAuthorizationEnumGroupBoolExp>>;
  _not?: InputMaybe<organizationAuthorizationEnumGroupBoolExp>;
  _or?: InputMaybe<Array<organizationAuthorizationEnumGroupBoolExp>>;
  authorization?: InputMaybe<OrganizationUserAuthorizationEnumComparisonExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "business.authorization_enum_group" */
export type organizationAuthorizationEnumGroupConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'authorization_enum_group_pkey'
  | '%future added value';

/** input type for inserting data into table "business.authorization_enum_group" */
export type organizationAuthorizationEnumGroupInsertInput = {
  authorization?: InputMaybe<organizationUserAuthorizationEnum>;
  groupId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type organizationAuthorizationEnumGroupMaxFields = {
  __typename?: 'organizationAuthorizationEnumGroupMaxFields';
  groupId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "business.authorization_enum_group" */
export type organizationAuthorizationEnumGroupMaxOrderBy = {
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type organizationAuthorizationEnumGroupMinFields = {
  __typename?: 'organizationAuthorizationEnumGroupMinFields';
  groupId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "business.authorization_enum_group" */
export type organizationAuthorizationEnumGroupMinOrderBy = {
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "business.authorization_enum_group" */
export type organizationAuthorizationEnumGroupMutationResponse = {
  __typename?: 'organizationAuthorizationEnumGroupMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<organizationAuthorizationEnumGroup>;
};

/** on_conflict condition type for table "business.authorization_enum_group" */
export type organizationAuthorizationEnumGroupOnConflict = {
  constraint: organizationAuthorizationEnumGroupConstraint;
  updateColumns?: Array<organizationAuthorizationEnumGroupUpdateColumn>;
  where?: InputMaybe<organizationAuthorizationEnumGroupBoolExp>;
};

/** Ordering options when selecting data from "business.authorization_enum_group". */
export type organizationAuthorizationEnumGroupOrderBy = {
  authorization?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.authorization_enum_group */
export type organizationAuthorizationEnumGroupPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "business.authorization_enum_group" */
export type organizationAuthorizationEnumGroupSelectColumn =
  /** column name */
  | 'authorization'
  /** column name */
  | 'groupId'
  /** column name */
  | 'id'
  | '%future added value';

/** input type for updating data in table "business.authorization_enum_group" */
export type organizationAuthorizationEnumGroupSetInput = {
  authorization?: InputMaybe<organizationUserAuthorizationEnum>;
  groupId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "organizationAuthorizationEnumGroup" */
export type organizationAuthorizationEnumGroupStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: organizationAuthorizationEnumGroupStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type organizationAuthorizationEnumGroupStreamCursorValueInput = {
  authorization?: InputMaybe<organizationUserAuthorizationEnum>;
  groupId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "business.authorization_enum_group" */
export type organizationAuthorizationEnumGroupUpdateColumn =
  /** column name */
  | 'authorization'
  /** column name */
  | 'groupId'
  /** column name */
  | 'id'
  | '%future added value';

export type organizationAuthorizationEnumGroupUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<organizationAuthorizationEnumGroupSetInput>;
  /** filter the rows which have to be updated */
  where: organizationAuthorizationEnumGroupBoolExp;
};

/** columns and relationships of "business.authorization_group" */
export type organizationAuthorizationGroup = {
  __typename?: 'organizationAuthorizationGroup';
  /** An aggregate relationship */
  authorizationEnumGroupsAggregate: organizationAuthorizationEnumGroupAggregate;
  /** An array relationship */
  authorization_enum_groups: Array<organizationAuthorizationEnumGroup>;
  id: Scalars['uuid']['output'];
  text: Scalars['String']['output'];
};


/** columns and relationships of "business.authorization_group" */
export type organizationAuthorizationGroupauthorizationEnumGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<organizationAuthorizationEnumGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationAuthorizationEnumGroupOrderBy>>;
  where?: InputMaybe<organizationAuthorizationEnumGroupBoolExp>;
};


/** columns and relationships of "business.authorization_group" */
export type organizationAuthorizationGroupauthorization_enum_groupsArgs = {
  distinctOn?: InputMaybe<Array<organizationAuthorizationEnumGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationAuthorizationEnumGroupOrderBy>>;
  where?: InputMaybe<organizationAuthorizationEnumGroupBoolExp>;
};

/** aggregated selection of "business.authorization_group" */
export type organizationAuthorizationGroupAggregate = {
  __typename?: 'organizationAuthorizationGroupAggregate';
  aggregate?: Maybe<organizationAuthorizationGroupAggregateFields>;
  nodes: Array<organizationAuthorizationGroup>;
};

/** aggregate fields of "business.authorization_group" */
export type organizationAuthorizationGroupAggregateFields = {
  __typename?: 'organizationAuthorizationGroupAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<organizationAuthorizationGroupMaxFields>;
  min?: Maybe<organizationAuthorizationGroupMinFields>;
};


/** aggregate fields of "business.authorization_group" */
export type organizationAuthorizationGroupAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<organizationAuthorizationGroupSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.authorization_group". All fields are combined with a logical 'AND'. */
export type organizationAuthorizationGroupBoolExp = {
  _and?: InputMaybe<Array<organizationAuthorizationGroupBoolExp>>;
  _not?: InputMaybe<organizationAuthorizationGroupBoolExp>;
  _or?: InputMaybe<Array<organizationAuthorizationGroupBoolExp>>;
  authorization_enum_groups?: InputMaybe<organizationAuthorizationEnumGroupBoolExp>;
  authorization_enum_groupsAggregate?: InputMaybe<organizationAuthorizationEnumGroupAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  text?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.authorization_group" */
export type organizationAuthorizationGroupConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'authorization_group_pkey'
  | '%future added value';

/** input type for inserting data into table "business.authorization_group" */
export type organizationAuthorizationGroupInsertInput = {
  authorization_enum_groups?: InputMaybe<organizationAuthorizationEnumGroupArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type organizationAuthorizationGroupMaxFields = {
  __typename?: 'organizationAuthorizationGroupMaxFields';
  id?: Maybe<Scalars['uuid']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type organizationAuthorizationGroupMinFields = {
  __typename?: 'organizationAuthorizationGroupMinFields';
  id?: Maybe<Scalars['uuid']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.authorization_group" */
export type organizationAuthorizationGroupMutationResponse = {
  __typename?: 'organizationAuthorizationGroupMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<organizationAuthorizationGroup>;
};

/** on_conflict condition type for table "business.authorization_group" */
export type organizationAuthorizationGroupOnConflict = {
  constraint: organizationAuthorizationGroupConstraint;
  updateColumns?: Array<organizationAuthorizationGroupUpdateColumn>;
  where?: InputMaybe<organizationAuthorizationGroupBoolExp>;
};

/** Ordering options when selecting data from "business.authorization_group". */
export type organizationAuthorizationGroupOrderBy = {
  authorization_enum_groupsAggregate?: InputMaybe<organizationAuthorizationEnumGroupAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  text?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.authorization_group */
export type organizationAuthorizationGroupPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "business.authorization_group" */
export type organizationAuthorizationGroupSelectColumn =
  /** column name */
  | 'id'
  /** column name */
  | 'text'
  | '%future added value';

/** input type for updating data in table "business.authorization_group" */
export type organizationAuthorizationGroupSetInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "organizationAuthorizationGroup" */
export type organizationAuthorizationGroupStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: organizationAuthorizationGroupStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type organizationAuthorizationGroupStreamCursorValueInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.authorization_group" */
export type organizationAuthorizationGroupUpdateColumn =
  /** column name */
  | 'id'
  /** column name */
  | 'text'
  | '%future added value';

export type organizationAuthorizationGroupUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<organizationAuthorizationGroupSetInput>;
  /** filter the rows which have to be updated */
  where: organizationAuthorizationGroupBoolExp;
};

/** aggregate avg on columns */
export type organizationAvgFields = {
  __typename?: 'organizationAvgFields';
  nrOfEmployees?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "business.organizations" */
export type organizationAvgOrderBy = {
  nrOfEmployees?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "business.organizations". All fields are combined with a logical 'AND'. */
export type organizationBoolExp = {
  _and?: InputMaybe<Array<organizationBoolExp>>;
  _not?: InputMaybe<organizationBoolExp>;
  _or?: InputMaybe<Array<organizationBoolExp>>;
  activity_organizations?: InputMaybe<messagingActivityOrganizationBoolExp>;
  activity_organizationsAggregate?: InputMaybe<messagingActivityOrganizationAggregateBoolExp>;
  businessAddress?: InputMaybe<addressBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdBy?: InputMaybe<userBoolExp>;
  createdByUserId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  image?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  nrOfEmployees?: InputMaybe<IntComparisonExp>;
  organizationNumber?: InputMaybe<StringComparisonExp>;
  organizationUserInvites?: InputMaybe<organizationUserInviteBoolExp>;
  organizationUserInvitesAggregate?: InputMaybe<organizationUserInviteAggregateBoolExp>;
  organizationUserRequests?: InputMaybe<BusinessOrganizationUserRequestBoolExp>;
  organizationUserRequestsAggregate?: InputMaybe<BusinessOrganizationUserRequestAggregateBoolExp>;
  organizationUsers?: InputMaybe<organizationUserBoolExp>;
  organizationUsersAggregate?: InputMaybe<organizationUserAggregateBoolExp>;
  organizationsDomainOrganizations?: InputMaybe<domainOrganizationBoolExp>;
  organizationsDomainOrganizationsAggregate?: InputMaybe<domainOrganizationAggregateBoolExp>;
  organizationsOrderIntegrations?: InputMaybe<ordersIntegrationsBoolExp>;
  organizationsOrderIntegrationsAggregate?: InputMaybe<ordersIntegrationsAggregateBoolExp>;
  owner?: InputMaybe<userBoolExp>;
  ownerId?: InputMaybe<UuidComparisonExp>;
  phoneroCustomerId?: InputMaybe<StringComparisonExp>;
  reinforceImportantMessagesWithSms?: InputMaybe<BooleanComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  users?: InputMaybe<organizationOrganizationUserUsersViewBoolExp>;
  usersAggregate?: InputMaybe<organizationOrganizationUserUsersViewAggregateBoolExp>;
};

/** unique or primary key constraints on table "business.organizations" */
export type organizationConstraint =
  /** unique or primary key constraint on columns "organization_number" */
  | 'organizations_organizationNumber_key'
  /** unique or primary key constraint on columns "id" */
  | 'organizations_pkey'
  | '%future added value';

/** input type for incrementing numeric columns in table "business.organizations" */
export type organizationIncInput = {
  nrOfEmployees?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "business.organizations" */
export type organizationInsertInput = {
  activity_organizations?: InputMaybe<messagingActivityOrganizationArrRelInsertInput>;
  businessAddress?: InputMaybe<addressObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<userObjRelInsertInput>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nrOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
  organizationUserInvites?: InputMaybe<organizationUserInviteArrRelInsertInput>;
  organizationUserRequests?: InputMaybe<BusinessOrganizationUserRequestArrRelInsertInput>;
  organizationUsers?: InputMaybe<organizationUserArrRelInsertInput>;
  organizationsDomainOrganizations?: InputMaybe<domainOrganizationArrRelInsertInput>;
  organizationsOrderIntegrations?: InputMaybe<ordersIntegrationsArrRelInsertInput>;
  owner?: InputMaybe<userObjRelInsertInput>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  phoneroCustomerId?: InputMaybe<Scalars['String']['input']>;
  reinforceImportantMessagesWithSms?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  users?: InputMaybe<organizationOrganizationUserUsersViewArrRelInsertInput>;
};

/** aggregate max on columns */
export type organizationMaxFields = {
  __typename?: 'organizationMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nrOfEmployees?: Maybe<Scalars['Int']['output']>;
  organizationNumber?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  phoneroCustomerId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "business.organizations" */
export type organizationMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  image?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  nrOfEmployees?: InputMaybe<OrderBy>;
  organizationNumber?: InputMaybe<OrderBy>;
  ownerId?: InputMaybe<OrderBy>;
  phoneroCustomerId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type organizationMinFields = {
  __typename?: 'organizationMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nrOfEmployees?: Maybe<Scalars['Int']['output']>;
  organizationNumber?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  phoneroCustomerId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "business.organizations" */
export type organizationMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  image?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  nrOfEmployees?: InputMaybe<OrderBy>;
  organizationNumber?: InputMaybe<OrderBy>;
  ownerId?: InputMaybe<OrderBy>;
  phoneroCustomerId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "business.organizations" */
export type organizationMutationResponse = {
  __typename?: 'organizationMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<organization>;
};

/** input type for inserting object relation for remote table "business.organizations" */
export type organizationObjRelInsertInput = {
  data: organizationInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<organizationOnConflict>;
};

/** on_conflict condition type for table "business.organizations" */
export type organizationOnConflict = {
  constraint: organizationConstraint;
  updateColumns?: Array<organizationUpdateColumn>;
  where?: InputMaybe<organizationBoolExp>;
};

/** Ordering options when selecting data from "business.organizations". */
export type organizationOrderBy = {
  activity_organizationsAggregate?: InputMaybe<messagingActivityOrganizationAggregateOrderBy>;
  businessAddress?: InputMaybe<addressOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<userOrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  image?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  nrOfEmployees?: InputMaybe<OrderBy>;
  organizationNumber?: InputMaybe<OrderBy>;
  organizationUserInvitesAggregate?: InputMaybe<organizationUserInviteAggregateOrderBy>;
  organizationUserRequestsAggregate?: InputMaybe<BusinessOrganizationUserRequestAggregateOrderBy>;
  organizationUsersAggregate?: InputMaybe<organizationUserAggregateOrderBy>;
  organizationsDomainOrganizationsAggregate?: InputMaybe<domainOrganizationAggregateOrderBy>;
  organizationsOrderIntegrationsAggregate?: InputMaybe<ordersIntegrationsAggregateOrderBy>;
  owner?: InputMaybe<userOrderBy>;
  ownerId?: InputMaybe<OrderBy>;
  phoneroCustomerId?: InputMaybe<OrderBy>;
  reinforceImportantMessagesWithSms?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  usersAggregate?: InputMaybe<organizationOrganizationUserUsersViewAggregateOrderBy>;
};

/** columns and relationships of "business.organization_relationship" */
export type organizationOrganizationRelationship = {
  __typename?: 'organizationOrganizationRelationship';
  category?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  fromOrgId?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  toOrgId?: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "business.organization_relationship" */
export type organizationOrganizationRelationshipAggregate = {
  __typename?: 'organizationOrganizationRelationshipAggregate';
  aggregate?: Maybe<organizationOrganizationRelationshipAggregateFields>;
  nodes: Array<organizationOrganizationRelationship>;
};

/** aggregate fields of "business.organization_relationship" */
export type organizationOrganizationRelationshipAggregateFields = {
  __typename?: 'organizationOrganizationRelationshipAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<organizationOrganizationRelationshipMaxFields>;
  min?: Maybe<organizationOrganizationRelationshipMinFields>;
};


/** aggregate fields of "business.organization_relationship" */
export type organizationOrganizationRelationshipAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<organizationOrganizationRelationshipSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.organization_relationship". All fields are combined with a logical 'AND'. */
export type organizationOrganizationRelationshipBoolExp = {
  _and?: InputMaybe<Array<organizationOrganizationRelationshipBoolExp>>;
  _not?: InputMaybe<organizationOrganizationRelationshipBoolExp>;
  _or?: InputMaybe<Array<organizationOrganizationRelationshipBoolExp>>;
  category?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  fromOrgId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  toOrgId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** columns and relationships of "business.organization_relationship_category" */
export type organizationOrganizationRelationshipCategory = {
  __typename?: 'organizationOrganizationRelationshipCategory';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "business.organization_relationship_category" */
export type organizationOrganizationRelationshipCategoryAggregate = {
  __typename?: 'organizationOrganizationRelationshipCategoryAggregate';
  aggregate?: Maybe<organizationOrganizationRelationshipCategoryAggregateFields>;
  nodes: Array<organizationOrganizationRelationshipCategory>;
};

/** aggregate fields of "business.organization_relationship_category" */
export type organizationOrganizationRelationshipCategoryAggregateFields = {
  __typename?: 'organizationOrganizationRelationshipCategoryAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<organizationOrganizationRelationshipCategoryMaxFields>;
  min?: Maybe<organizationOrganizationRelationshipCategoryMinFields>;
};


/** aggregate fields of "business.organization_relationship_category" */
export type organizationOrganizationRelationshipCategoryAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<organizationOrganizationRelationshipCategorySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.organization_relationship_category". All fields are combined with a logical 'AND'. */
export type organizationOrganizationRelationshipCategoryBoolExp = {
  _and?: InputMaybe<Array<organizationOrganizationRelationshipCategoryBoolExp>>;
  _not?: InputMaybe<organizationOrganizationRelationshipCategoryBoolExp>;
  _or?: InputMaybe<Array<organizationOrganizationRelationshipCategoryBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.organization_relationship_category" */
export type organizationOrganizationRelationshipCategoryConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'organization_relationship_category_pkey'
  | '%future added value';

/** input type for inserting data into table "business.organization_relationship_category" */
export type organizationOrganizationRelationshipCategoryInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type organizationOrganizationRelationshipCategoryMaxFields = {
  __typename?: 'organizationOrganizationRelationshipCategoryMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type organizationOrganizationRelationshipCategoryMinFields = {
  __typename?: 'organizationOrganizationRelationshipCategoryMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.organization_relationship_category" */
export type organizationOrganizationRelationshipCategoryMutationResponse = {
  __typename?: 'organizationOrganizationRelationshipCategoryMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<organizationOrganizationRelationshipCategory>;
};

/** on_conflict condition type for table "business.organization_relationship_category" */
export type organizationOrganizationRelationshipCategoryOnConflict = {
  constraint: organizationOrganizationRelationshipCategoryConstraint;
  updateColumns?: Array<organizationOrganizationRelationshipCategoryUpdateColumn>;
  where?: InputMaybe<organizationOrganizationRelationshipCategoryBoolExp>;
};

/** Ordering options when selecting data from "business.organization_relationship_category". */
export type organizationOrganizationRelationshipCategoryOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.organization_relationship_category */
export type organizationOrganizationRelationshipCategoryPkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "business.organization_relationship_category" */
export type organizationOrganizationRelationshipCategorySelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "business.organization_relationship_category" */
export type organizationOrganizationRelationshipCategorySetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "organizationOrganizationRelationshipCategory" */
export type organizationOrganizationRelationshipCategoryStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: organizationOrganizationRelationshipCategoryStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type organizationOrganizationRelationshipCategoryStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.organization_relationship_category" */
export type organizationOrganizationRelationshipCategoryUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type organizationOrganizationRelationshipCategoryUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<organizationOrganizationRelationshipCategorySetInput>;
  /** filter the rows which have to be updated */
  where: organizationOrganizationRelationshipCategoryBoolExp;
};

/** unique or primary key constraints on table "business.organization_relationship" */
export type organizationOrganizationRelationshipConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'organization_relationship_pkey'
  | '%future added value';

/** input type for inserting data into table "business.organization_relationship" */
export type organizationOrganizationRelationshipInsertInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fromOrgId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  toOrgId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type organizationOrganizationRelationshipMaxFields = {
  __typename?: 'organizationOrganizationRelationshipMaxFields';
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fromOrgId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  toOrgId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type organizationOrganizationRelationshipMinFields = {
  __typename?: 'organizationOrganizationRelationshipMinFields';
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fromOrgId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  toOrgId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "business.organization_relationship" */
export type organizationOrganizationRelationshipMutationResponse = {
  __typename?: 'organizationOrganizationRelationshipMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<organizationOrganizationRelationship>;
};

/** on_conflict condition type for table "business.organization_relationship" */
export type organizationOrganizationRelationshipOnConflict = {
  constraint: organizationOrganizationRelationshipConstraint;
  updateColumns?: Array<organizationOrganizationRelationshipUpdateColumn>;
  where?: InputMaybe<organizationOrganizationRelationshipBoolExp>;
};

/** Ordering options when selecting data from "business.organization_relationship". */
export type organizationOrganizationRelationshipOrderBy = {
  category?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  fromOrgId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  toOrgId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.organization_relationship */
export type organizationOrganizationRelationshipPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "business.organization_relationship" */
export type organizationOrganizationRelationshipSelectColumn =
  /** column name */
  | 'category'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'fromOrgId'
  /** column name */
  | 'id'
  /** column name */
  | 'toOrgId'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "business.organization_relationship" */
export type organizationOrganizationRelationshipSetInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fromOrgId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  toOrgId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "organizationOrganizationRelationship" */
export type organizationOrganizationRelationshipStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: organizationOrganizationRelationshipStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type organizationOrganizationRelationshipStreamCursorValueInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fromOrgId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  toOrgId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "business.organization_relationship" */
export type organizationOrganizationRelationshipUpdateColumn =
  /** column name */
  | 'category'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'fromOrgId'
  /** column name */
  | 'id'
  /** column name */
  | 'toOrgId'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type organizationOrganizationRelationshipUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<organizationOrganizationRelationshipSetInput>;
  /** filter the rows which have to be updated */
  where: organizationOrganizationRelationshipBoolExp;
};

/** columns and relationships of "business.organization_user_authorization" */
export type organizationOrganizationUserAuthorization = {
  __typename?: 'organizationOrganizationUserAuthorization';
  /** An object relationship */
  authorization: organizationUserAuthorization;
  id: Scalars['uuid']['output'];
  organizationUserId: Scalars['uuid']['output'];
  /** An object relationship */
  organization_user: organizationUser;
  userAuthorization: organizationUserAuthorizationEnum;
};

/** aggregated selection of "business.organization_user_authorization" */
export type organizationOrganizationUserAuthorizationAggregate = {
  __typename?: 'organizationOrganizationUserAuthorizationAggregate';
  aggregate?: Maybe<organizationOrganizationUserAuthorizationAggregateFields>;
  nodes: Array<organizationOrganizationUserAuthorization>;
};

export type organizationOrganizationUserAuthorizationAggregateBoolExp = {
  count?: InputMaybe<organizationOrganizationUserAuthorizationAggregateBoolExpCount>;
};

export type organizationOrganizationUserAuthorizationAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<organizationOrganizationUserAuthorizationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<organizationOrganizationUserAuthorizationBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "business.organization_user_authorization" */
export type organizationOrganizationUserAuthorizationAggregateFields = {
  __typename?: 'organizationOrganizationUserAuthorizationAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<organizationOrganizationUserAuthorizationMaxFields>;
  min?: Maybe<organizationOrganizationUserAuthorizationMinFields>;
};


/** aggregate fields of "business.organization_user_authorization" */
export type organizationOrganizationUserAuthorizationAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<organizationOrganizationUserAuthorizationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.organization_user_authorization" */
export type organizationOrganizationUserAuthorizationAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<organizationOrganizationUserAuthorizationMaxOrderBy>;
  min?: InputMaybe<organizationOrganizationUserAuthorizationMinOrderBy>;
};

/** input type for inserting array relation for remote table "business.organization_user_authorization" */
export type organizationOrganizationUserAuthorizationArrRelInsertInput = {
  data: Array<organizationOrganizationUserAuthorizationInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<organizationOrganizationUserAuthorizationOnConflict>;
};

/** Boolean expression to filter rows from the table "business.organization_user_authorization". All fields are combined with a logical 'AND'. */
export type organizationOrganizationUserAuthorizationBoolExp = {
  _and?: InputMaybe<Array<organizationOrganizationUserAuthorizationBoolExp>>;
  _not?: InputMaybe<organizationOrganizationUserAuthorizationBoolExp>;
  _or?: InputMaybe<Array<organizationOrganizationUserAuthorizationBoolExp>>;
  authorization?: InputMaybe<organizationUserAuthorizationBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organizationUserId?: InputMaybe<UuidComparisonExp>;
  organization_user?: InputMaybe<organizationUserBoolExp>;
  userAuthorization?: InputMaybe<OrganizationUserAuthorizationEnumComparisonExp>;
};

/** unique or primary key constraints on table "business.organization_user_authorization" */
export type organizationOrganizationUserAuthorizationConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'organization_user_authorization_pkey'
  | '%future added value';

/** input type for inserting data into table "business.organization_user_authorization" */
export type organizationOrganizationUserAuthorizationInsertInput = {
  authorization?: InputMaybe<organizationUserAuthorizationObjRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  organization_user?: InputMaybe<organizationUserObjRelInsertInput>;
  userAuthorization?: InputMaybe<organizationUserAuthorizationEnum>;
};

/** aggregate max on columns */
export type organizationOrganizationUserAuthorizationMaxFields = {
  __typename?: 'organizationOrganizationUserAuthorizationMaxFields';
  id?: Maybe<Scalars['uuid']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "business.organization_user_authorization" */
export type organizationOrganizationUserAuthorizationMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type organizationOrganizationUserAuthorizationMinFields = {
  __typename?: 'organizationOrganizationUserAuthorizationMinFields';
  id?: Maybe<Scalars['uuid']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "business.organization_user_authorization" */
export type organizationOrganizationUserAuthorizationMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "business.organization_user_authorization" */
export type organizationOrganizationUserAuthorizationMutationResponse = {
  __typename?: 'organizationOrganizationUserAuthorizationMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<organizationOrganizationUserAuthorization>;
};

/** on_conflict condition type for table "business.organization_user_authorization" */
export type organizationOrganizationUserAuthorizationOnConflict = {
  constraint: organizationOrganizationUserAuthorizationConstraint;
  updateColumns?: Array<organizationOrganizationUserAuthorizationUpdateColumn>;
  where?: InputMaybe<organizationOrganizationUserAuthorizationBoolExp>;
};

/** Ordering options when selecting data from "business.organization_user_authorization". */
export type organizationOrganizationUserAuthorizationOrderBy = {
  authorization?: InputMaybe<organizationUserAuthorizationOrderBy>;
  id?: InputMaybe<OrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  organization_user?: InputMaybe<organizationUserOrderBy>;
  userAuthorization?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.organization_user_authorization */
export type organizationOrganizationUserAuthorizationPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "business.organization_user_authorization" */
export type organizationOrganizationUserAuthorizationSelectColumn =
  /** column name */
  | 'id'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'userAuthorization'
  | '%future added value';

/** input type for updating data in table "business.organization_user_authorization" */
export type organizationOrganizationUserAuthorizationSetInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  userAuthorization?: InputMaybe<organizationUserAuthorizationEnum>;
};

/** Streaming cursor of the table "organizationOrganizationUserAuthorization" */
export type organizationOrganizationUserAuthorizationStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: organizationOrganizationUserAuthorizationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type organizationOrganizationUserAuthorizationStreamCursorValueInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  userAuthorization?: InputMaybe<organizationUserAuthorizationEnum>;
};

/** update columns of table "business.organization_user_authorization" */
export type organizationOrganizationUserAuthorizationUpdateColumn =
  /** column name */
  | 'id'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'userAuthorization'
  | '%future added value';

export type organizationOrganizationUserAuthorizationUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<organizationOrganizationUserAuthorizationSetInput>;
  /** filter the rows which have to be updated */
  where: organizationOrganizationUserAuthorizationBoolExp;
};

/** columns and relationships of "business.organization_user__organizations_view" */
export type organizationOrganizationUserOrganizationsView = {
  __typename?: 'organizationOrganizationUserOrganizationsView';
  /** An object relationship */
  company?: Maybe<organizationUser>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationnumber?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  reinforceimportantmessageswithsms?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  users: Array<user>;
  /** An aggregate relationship */
  usersAggregate: userAggregate;
};


/** columns and relationships of "business.organization_user__organizations_view" */
export type organizationOrganizationUserOrganizationsViewusersArgs = {
  distinctOn?: InputMaybe<Array<userSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<userOrderBy>>;
  where?: InputMaybe<userBoolExp>;
};


/** columns and relationships of "business.organization_user__organizations_view" */
export type organizationOrganizationUserOrganizationsViewusersAggregateArgs = {
  distinctOn?: InputMaybe<Array<userSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<userOrderBy>>;
  where?: InputMaybe<userBoolExp>;
};

/** aggregated selection of "business.organization_user__organizations_view" */
export type organizationOrganizationUserOrganizationsViewAggregate = {
  __typename?: 'organizationOrganizationUserOrganizationsViewAggregate';
  aggregate?: Maybe<organizationOrganizationUserOrganizationsViewAggregateFields>;
  nodes: Array<organizationOrganizationUserOrganizationsView>;
};

export type organizationOrganizationUserOrganizationsViewAggregateBoolExp = {
  bool_and?: InputMaybe<organizationOrganizationUserOrganizationsViewAggregateBoolExpBool_and>;
  bool_or?: InputMaybe<organizationOrganizationUserOrganizationsViewAggregateBoolExpBool_or>;
  count?: InputMaybe<organizationOrganizationUserOrganizationsViewAggregateBoolExpCount>;
};

export type organizationOrganizationUserOrganizationsViewAggregateBoolExpBool_and = {
  arguments: organizationOrganizationUserOrganizationsViewSelectColumnOrganizationOrganizationUserOrganizationsViewAggregateBoolExpBool_andArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<organizationOrganizationUserOrganizationsViewBoolExp>;
  predicate: BooleanComparisonExp;
};

export type organizationOrganizationUserOrganizationsViewAggregateBoolExpBool_or = {
  arguments: organizationOrganizationUserOrganizationsViewSelectColumnOrganizationOrganizationUserOrganizationsViewAggregateBoolExpBool_orArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<organizationOrganizationUserOrganizationsViewBoolExp>;
  predicate: BooleanComparisonExp;
};

export type organizationOrganizationUserOrganizationsViewAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<organizationOrganizationUserOrganizationsViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<organizationOrganizationUserOrganizationsViewBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "business.organization_user__organizations_view" */
export type organizationOrganizationUserOrganizationsViewAggregateFields = {
  __typename?: 'organizationOrganizationUserOrganizationsViewAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<organizationOrganizationUserOrganizationsViewMaxFields>;
  min?: Maybe<organizationOrganizationUserOrganizationsViewMinFields>;
};


/** aggregate fields of "business.organization_user__organizations_view" */
export type organizationOrganizationUserOrganizationsViewAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<organizationOrganizationUserOrganizationsViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.organization_user__organizations_view" */
export type organizationOrganizationUserOrganizationsViewAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<organizationOrganizationUserOrganizationsViewMaxOrderBy>;
  min?: InputMaybe<organizationOrganizationUserOrganizationsViewMinOrderBy>;
};

/** input type for inserting array relation for remote table "business.organization_user__organizations_view" */
export type organizationOrganizationUserOrganizationsViewArrRelInsertInput = {
  data: Array<organizationOrganizationUserOrganizationsViewInsertInput>;
};

/** Boolean expression to filter rows from the table "business.organization_user__organizations_view". All fields are combined with a logical 'AND'. */
export type organizationOrganizationUserOrganizationsViewBoolExp = {
  _and?: InputMaybe<Array<organizationOrganizationUserOrganizationsViewBoolExp>>;
  _not?: InputMaybe<organizationOrganizationUserOrganizationsViewBoolExp>;
  _or?: InputMaybe<Array<organizationOrganizationUserOrganizationsViewBoolExp>>;
  company?: InputMaybe<organizationUserBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organizationnumber?: InputMaybe<StringComparisonExp>;
  ownerId?: InputMaybe<UuidComparisonExp>;
  reinforceimportantmessageswithsms?: InputMaybe<BooleanComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  users?: InputMaybe<userBoolExp>;
  usersAggregate?: InputMaybe<userAggregateBoolExp>;
};

/** input type for inserting data into table "business.organization_user__organizations_view" */
export type organizationOrganizationUserOrganizationsViewInsertInput = {
  company?: InputMaybe<organizationUserObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationnumber?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  reinforceimportantmessageswithsms?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  users?: InputMaybe<userArrRelInsertInput>;
};

/** aggregate max on columns */
export type organizationOrganizationUserOrganizationsViewMaxFields = {
  __typename?: 'organizationOrganizationUserOrganizationsViewMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationnumber?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "business.organization_user__organizations_view" */
export type organizationOrganizationUserOrganizationsViewMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organizationnumber?: InputMaybe<OrderBy>;
  ownerId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type organizationOrganizationUserOrganizationsViewMinFields = {
  __typename?: 'organizationOrganizationUserOrganizationsViewMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationnumber?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "business.organization_user__organizations_view" */
export type organizationOrganizationUserOrganizationsViewMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organizationnumber?: InputMaybe<OrderBy>;
  ownerId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "business.organization_user__organizations_view". */
export type organizationOrganizationUserOrganizationsViewOrderBy = {
  company?: InputMaybe<organizationUserOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organizationnumber?: InputMaybe<OrderBy>;
  ownerId?: InputMaybe<OrderBy>;
  reinforceimportantmessageswithsms?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  usersAggregate?: InputMaybe<userAggregateOrderBy>;
};

/** select columns of table "business.organization_user__organizations_view" */
export type organizationOrganizationUserOrganizationsViewSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'organizationnumber'
  /** column name */
  | 'ownerId'
  /** column name */
  | 'reinforceimportantmessageswithsms'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

/** select "organizationOrganizationUserOrganizationsViewAggregateBoolExpBool_andArgumentsColumns" columns of table "business.organization_user__organizations_view" */
export type organizationOrganizationUserOrganizationsViewSelectColumnOrganizationOrganizationUserOrganizationsViewAggregateBoolExpBool_andArgumentsColumns =
  /** column name */
  | 'reinforceimportantmessageswithsms'
  | '%future added value';

/** select "organizationOrganizationUserOrganizationsViewAggregateBoolExpBool_orArgumentsColumns" columns of table "business.organization_user__organizations_view" */
export type organizationOrganizationUserOrganizationsViewSelectColumnOrganizationOrganizationUserOrganizationsViewAggregateBoolExpBool_orArgumentsColumns =
  /** column name */
  | 'reinforceimportantmessageswithsms'
  | '%future added value';

/** Streaming cursor of the table "organizationOrganizationUserOrganizationsView" */
export type organizationOrganizationUserOrganizationsViewStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: organizationOrganizationUserOrganizationsViewStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type organizationOrganizationUserOrganizationsViewStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationnumber?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  reinforceimportantmessageswithsms?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "business.organization_user__users_view" */
export type organizationOrganizationUserUsersView = {
  __typename?: 'organizationOrganizationUserUsersView';
  authId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  organizationsX: Array<organization>;
  /** An aggregate relationship */
  organizationsXAggregate: organizationAggregate;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "business.organization_user__users_view" */
export type organizationOrganizationUserUsersVieworganizationsXArgs = {
  distinctOn?: InputMaybe<Array<organizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrderBy>>;
  where?: InputMaybe<organizationBoolExp>;
};


/** columns and relationships of "business.organization_user__users_view" */
export type organizationOrganizationUserUsersVieworganizationsXAggregateArgs = {
  distinctOn?: InputMaybe<Array<organizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrderBy>>;
  where?: InputMaybe<organizationBoolExp>;
};

/** aggregated selection of "business.organization_user__users_view" */
export type organizationOrganizationUserUsersViewAggregate = {
  __typename?: 'organizationOrganizationUserUsersViewAggregate';
  aggregate?: Maybe<organizationOrganizationUserUsersViewAggregateFields>;
  nodes: Array<organizationOrganizationUserUsersView>;
};

export type organizationOrganizationUserUsersViewAggregateBoolExp = {
  count?: InputMaybe<organizationOrganizationUserUsersViewAggregateBoolExpCount>;
};

export type organizationOrganizationUserUsersViewAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<organizationOrganizationUserUsersViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<organizationOrganizationUserUsersViewBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "business.organization_user__users_view" */
export type organizationOrganizationUserUsersViewAggregateFields = {
  __typename?: 'organizationOrganizationUserUsersViewAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<organizationOrganizationUserUsersViewMaxFields>;
  min?: Maybe<organizationOrganizationUserUsersViewMinFields>;
};


/** aggregate fields of "business.organization_user__users_view" */
export type organizationOrganizationUserUsersViewAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<organizationOrganizationUserUsersViewSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.organization_user__users_view" */
export type organizationOrganizationUserUsersViewAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<organizationOrganizationUserUsersViewMaxOrderBy>;
  min?: InputMaybe<organizationOrganizationUserUsersViewMinOrderBy>;
};

/** input type for inserting array relation for remote table "business.organization_user__users_view" */
export type organizationOrganizationUserUsersViewArrRelInsertInput = {
  data: Array<organizationOrganizationUserUsersViewInsertInput>;
};

/** Boolean expression to filter rows from the table "business.organization_user__users_view". All fields are combined with a logical 'AND'. */
export type organizationOrganizationUserUsersViewBoolExp = {
  _and?: InputMaybe<Array<organizationOrganizationUserUsersViewBoolExp>>;
  _not?: InputMaybe<organizationOrganizationUserUsersViewBoolExp>;
  _or?: InputMaybe<Array<organizationOrganizationUserUsersViewBoolExp>>;
  authId?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organizationId?: InputMaybe<UuidComparisonExp>;
  organizationsX?: InputMaybe<organizationBoolExp>;
  organizationsXAggregate?: InputMaybe<organizationAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  username?: InputMaybe<StringComparisonExp>;
};

/** input type for inserting data into table "business.organization_user__users_view" */
export type organizationOrganizationUserUsersViewInsertInput = {
  authId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  organizationsX?: InputMaybe<organizationArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type organizationOrganizationUserUsersViewMaxFields = {
  __typename?: 'organizationOrganizationUserUsersViewMaxFields';
  authId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "business.organization_user__users_view" */
export type organizationOrganizationUserUsersViewMaxOrderBy = {
  authId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  username?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type organizationOrganizationUserUsersViewMinFields = {
  __typename?: 'organizationOrganizationUserUsersViewMinFields';
  authId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "business.organization_user__users_view" */
export type organizationOrganizationUserUsersViewMinOrderBy = {
  authId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  username?: InputMaybe<OrderBy>;
};

/** input type for inserting object relation for remote table "business.organization_user__users_view" */
export type organizationOrganizationUserUsersViewObjRelInsertInput = {
  data: organizationOrganizationUserUsersViewInsertInput;
};

/** Ordering options when selecting data from "business.organization_user__users_view". */
export type organizationOrganizationUserUsersViewOrderBy = {
  authId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  organizationsXAggregate?: InputMaybe<organizationAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  username?: InputMaybe<OrderBy>;
};

/** select columns of table "business.organization_user__users_view" */
export type organizationOrganizationUserUsersViewSelectColumn =
  /** column name */
  | 'authId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'username'
  | '%future added value';

/** Streaming cursor of the table "organizationOrganizationUserUsersView" */
export type organizationOrganizationUserUsersViewStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: organizationOrganizationUserUsersViewStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type organizationOrganizationUserUsersViewStreamCursorValueInput = {
  authId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** primary key columns input for table: business.organizations */
export type organizationPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "business.organizations" */
export type organizationSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserId'
  /** column name */
  | 'id'
  /** column name */
  | 'image'
  /** column name */
  | 'name'
  /** column name */
  | 'nrOfEmployees'
  /** column name */
  | 'organizationNumber'
  /** column name */
  | 'ownerId'
  /** column name */
  | 'phoneroCustomerId'
  /** column name */
  | 'reinforceImportantMessagesWithSms'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** select "organizationAggregateBoolExpBool_andArgumentsColumns" columns of table "business.organizations" */
export type organizationSelectColumnOrganizationAggregateBoolExpBool_andArgumentsColumns =
  /** column name */
  | 'reinforceImportantMessagesWithSms'
  | '%future added value';

/** select "organizationAggregateBoolExpBool_orArgumentsColumns" columns of table "business.organizations" */
export type organizationSelectColumnOrganizationAggregateBoolExpBool_orArgumentsColumns =
  /** column name */
  | 'reinforceImportantMessagesWithSms'
  | '%future added value';

/** input type for updating data in table "business.organizations" */
export type organizationSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nrOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  phoneroCustomerId?: InputMaybe<Scalars['String']['input']>;
  reinforceImportantMessagesWithSms?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type organizationStddevFields = {
  __typename?: 'organizationStddevFields';
  nrOfEmployees?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "business.organizations" */
export type organizationStddevOrderBy = {
  nrOfEmployees?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type organizationStddevPopFields = {
  __typename?: 'organizationStddevPopFields';
  nrOfEmployees?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "business.organizations" */
export type organizationStddevPopOrderBy = {
  nrOfEmployees?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type organizationStddevSampFields = {
  __typename?: 'organizationStddevSampFields';
  nrOfEmployees?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "business.organizations" */
export type organizationStddevSampOrderBy = {
  nrOfEmployees?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "organization" */
export type organizationStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: organizationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type organizationStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nrOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  phoneroCustomerId?: InputMaybe<Scalars['String']['input']>;
  reinforceImportantMessagesWithSms?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type organizationSumFields = {
  __typename?: 'organizationSumFields';
  nrOfEmployees?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "business.organizations" */
export type organizationSumOrderBy = {
  nrOfEmployees?: InputMaybe<OrderBy>;
};

/** update columns of table "business.organizations" */
export type organizationUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserId'
  /** column name */
  | 'id'
  /** column name */
  | 'image'
  /** column name */
  | 'name'
  /** column name */
  | 'nrOfEmployees'
  /** column name */
  | 'organizationNumber'
  /** column name */
  | 'ownerId'
  /** column name */
  | 'phoneroCustomerId'
  /** column name */
  | 'reinforceImportantMessagesWithSms'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type organizationUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<organizationIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<organizationSetInput>;
  /** filter the rows which have to be updated */
  where: organizationBoolExp;
};

/** Organisasjonsbrukere */
export type organizationUser = {
  __typename?: 'organizationUser';
  /** An array relationship */
  activityDomainUsers: Array<domainUser>;
  /** An aggregate relationship */
  activityDomainUsersAggregate: domainUserAggregate;
  /** An array relationship */
  addresses: Array<address>;
  /** An aggregate relationship */
  addressesAggregate: addressAggregate;
  /** An array relationship */
  attachments: Array<organizationUserAttachments>;
  /** An aggregate relationship */
  attachmentsAggregate: organizationUserAttachmentsAggregate;
  /** An array relationship */
  collaborations: Array<businessQueueItemCollaboration>;
  /** An aggregate relationship */
  collaborationsAggregate: businessQueueItemCollaborationAggregate;
  /** An object relationship */
  company?: Maybe<organizationUser>;
  companyId?: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  createdBy?: Maybe<user>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  crmRepresentations: Array<crmYoutelloCatalystIdMapping>;
  /** An aggregate relationship */
  crmRepresentationsAggregate: crmYoutelloCatalystIdMappingAggregate;
  deletionAt?: Maybe<Scalars['timestamptz']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  emails: Array<BusinessOrganizationUserEmail>;
  /** An aggregate relationship */
  emailsAggregate: BusinessOrganizationUserEmailAggregate;
  extraData?: Maybe<Scalars['jsonb']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  image?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization?: Maybe<organization>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  organizationNumber?: Maybe<Scalars['String']['output']>;
  /** An aggregate relationship */
  organizationUserAuthorizationsAggregate: organizationOrganizationUserAuthorizationAggregate;
  /** An aggregate relationship */
  organizationUserDetailsAggregate: organizationUserDetailAggregate;
  /** An array relationship */
  organization_user_authorizations: Array<organizationOrganizationUserAuthorization>;
  /** An array relationship */
  organization_user_details: Array<organizationUserDetail>;
  /** An object relationship */
  owner?: Maybe<user>;
  ownerUserId?: Maybe<Scalars['uuid']['output']>;
  permissions?: Maybe<Scalars['jsonb']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  role?: Maybe<userRoleEnum>;
  status?: Maybe<organizationUserStatusEnum>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  urlAddresses: Array<BusinessOrganizationUserUrlAddress>;
  /** An aggregate relationship */
  urlAddressesAggregate: BusinessOrganizationUserUrlAddressAggregate;
  /** An object relationship */
  user?: Maybe<user>;
  userId?: Maybe<Scalars['uuid']['output']>;
};


/** Organisasjonsbrukere */
export type organizationUseractivityDomainUsersArgs = {
  distinctOn?: InputMaybe<Array<domainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainUserOrderBy>>;
  where?: InputMaybe<domainUserBoolExp>;
};


/** Organisasjonsbrukere */
export type organizationUseractivityDomainUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<domainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainUserOrderBy>>;
  where?: InputMaybe<domainUserBoolExp>;
};


/** Organisasjonsbrukere */
export type organizationUseraddressesArgs = {
  distinctOn?: InputMaybe<Array<addressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<addressOrderBy>>;
  where?: InputMaybe<addressBoolExp>;
};


/** Organisasjonsbrukere */
export type organizationUseraddressesAggregateArgs = {
  distinctOn?: InputMaybe<Array<addressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<addressOrderBy>>;
  where?: InputMaybe<addressBoolExp>;
};


/** Organisasjonsbrukere */
export type organizationUserattachmentsArgs = {
  distinctOn?: InputMaybe<Array<organizationUserAttachmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserAttachmentsOrderBy>>;
  where?: InputMaybe<organizationUserAttachmentsBoolExp>;
};


/** Organisasjonsbrukere */
export type organizationUserattachmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<organizationUserAttachmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserAttachmentsOrderBy>>;
  where?: InputMaybe<organizationUserAttachmentsBoolExp>;
};


/** Organisasjonsbrukere */
export type organizationUsercollaborationsArgs = {
  distinctOn?: InputMaybe<Array<businessQueueItemCollaborationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<businessQueueItemCollaborationOrderBy>>;
  where?: InputMaybe<businessQueueItemCollaborationBoolExp>;
};


/** Organisasjonsbrukere */
export type organizationUsercollaborationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<businessQueueItemCollaborationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<businessQueueItemCollaborationOrderBy>>;
  where?: InputMaybe<businessQueueItemCollaborationBoolExp>;
};


/** Organisasjonsbrukere */
export type organizationUsercrmRepresentationsArgs = {
  distinctOn?: InputMaybe<Array<crmYoutelloCatalystIdMappingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<crmYoutelloCatalystIdMappingOrderBy>>;
  where?: InputMaybe<crmYoutelloCatalystIdMappingBoolExp>;
};


/** Organisasjonsbrukere */
export type organizationUsercrmRepresentationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<crmYoutelloCatalystIdMappingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<crmYoutelloCatalystIdMappingOrderBy>>;
  where?: InputMaybe<crmYoutelloCatalystIdMappingBoolExp>;
};


/** Organisasjonsbrukere */
export type organizationUseremailsArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserEmailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserEmailOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserEmailBoolExp>;
};


/** Organisasjonsbrukere */
export type organizationUseremailsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserEmailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserEmailOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserEmailBoolExp>;
};


/** Organisasjonsbrukere */
export type organizationUserextraDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Organisasjonsbrukere */
export type organizationUserorganizationUserAuthorizationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<organizationOrganizationUserAuthorizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrganizationUserAuthorizationOrderBy>>;
  where?: InputMaybe<organizationOrganizationUserAuthorizationBoolExp>;
};


/** Organisasjonsbrukere */
export type organizationUserorganizationUserDetailsAggregateArgs = {
  distinctOn?: InputMaybe<Array<organizationUserDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserDetailOrderBy>>;
  where?: InputMaybe<organizationUserDetailBoolExp>;
};


/** Organisasjonsbrukere */
export type organizationUserorganization_user_authorizationsArgs = {
  distinctOn?: InputMaybe<Array<organizationOrganizationUserAuthorizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrganizationUserAuthorizationOrderBy>>;
  where?: InputMaybe<organizationOrganizationUserAuthorizationBoolExp>;
};


/** Organisasjonsbrukere */
export type organizationUserorganization_user_detailsArgs = {
  distinctOn?: InputMaybe<Array<organizationUserDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserDetailOrderBy>>;
  where?: InputMaybe<organizationUserDetailBoolExp>;
};


/** Organisasjonsbrukere */
export type organizationUserpermissionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Organisasjonsbrukere */
export type organizationUserurlAddressesArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserUrlAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserUrlAddressOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserUrlAddressBoolExp>;
};


/** Organisasjonsbrukere */
export type organizationUserurlAddressesAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserUrlAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserUrlAddressOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserUrlAddressBoolExp>;
};

/** aggregated selection of "business.organization_user" */
export type organizationUserAggregate = {
  __typename?: 'organizationUserAggregate';
  aggregate?: Maybe<organizationUserAggregateFields>;
  nodes: Array<organizationUser>;
};

export type organizationUserAggregateBoolExp = {
  count?: InputMaybe<organizationUserAggregateBoolExpCount>;
};

export type organizationUserAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<organizationUserSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<organizationUserBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "business.organization_user" */
export type organizationUserAggregateFields = {
  __typename?: 'organizationUserAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<organizationUserMaxFields>;
  min?: Maybe<organizationUserMinFields>;
};


/** aggregate fields of "business.organization_user" */
export type organizationUserAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<organizationUserSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.organization_user" */
export type organizationUserAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<organizationUserMaxOrderBy>;
  min?: InputMaybe<organizationUserMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type organizationUserAppendInput = {
  extraData?: InputMaybe<Scalars['jsonb']['input']>;
  permissions?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "business.organization_user" */
export type organizationUserArrRelInsertInput = {
  data: Array<organizationUserInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<organizationUserOnConflict>;
};

/** columns and relationships of "business.organization_user_attachments" */
export type organizationUserAttachments = {
  __typename?: 'organizationUserAttachments';
  attachedByUser?: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  file: publicFile;
  fileId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organizationUser: organizationUser;
  organizationUserId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "business.organization_user_attachments" */
export type organizationUserAttachmentsAggregate = {
  __typename?: 'organizationUserAttachmentsAggregate';
  aggregate?: Maybe<organizationUserAttachmentsAggregateFields>;
  nodes: Array<organizationUserAttachments>;
};

export type organizationUserAttachmentsAggregateBoolExp = {
  count?: InputMaybe<organizationUserAttachmentsAggregateBoolExpCount>;
};

export type organizationUserAttachmentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<organizationUserAttachmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<organizationUserAttachmentsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "business.organization_user_attachments" */
export type organizationUserAttachmentsAggregateFields = {
  __typename?: 'organizationUserAttachmentsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<organizationUserAttachmentsMaxFields>;
  min?: Maybe<organizationUserAttachmentsMinFields>;
};


/** aggregate fields of "business.organization_user_attachments" */
export type organizationUserAttachmentsAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<organizationUserAttachmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.organization_user_attachments" */
export type organizationUserAttachmentsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<organizationUserAttachmentsMaxOrderBy>;
  min?: InputMaybe<organizationUserAttachmentsMinOrderBy>;
};

/** input type for inserting array relation for remote table "business.organization_user_attachments" */
export type organizationUserAttachmentsArrRelInsertInput = {
  data: Array<organizationUserAttachmentsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<organizationUserAttachmentsOnConflict>;
};

/** Boolean expression to filter rows from the table "business.organization_user_attachments". All fields are combined with a logical 'AND'. */
export type organizationUserAttachmentsBoolExp = {
  _and?: InputMaybe<Array<organizationUserAttachmentsBoolExp>>;
  _not?: InputMaybe<organizationUserAttachmentsBoolExp>;
  _or?: InputMaybe<Array<organizationUserAttachmentsBoolExp>>;
  attachedByUser?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  file?: InputMaybe<publicFileBoolExp>;
  fileId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organizationUser?: InputMaybe<organizationUserBoolExp>;
  organizationUserId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "business.organization_user_attachments" */
export type organizationUserAttachmentsConstraint =
  /** unique or primary key constraint on columns "organization_user_id", "file_id" */
  | 'organization_user_attachments_file_id_organization_user_id_key'
  /** unique or primary key constraint on columns "id" */
  | 'organization_user_attachments_pkey'
  | '%future added value';

/** input type for inserting data into table "business.organization_user_attachments" */
export type organizationUserAttachmentsInsertInput = {
  attachedByUser?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  file?: InputMaybe<publicFileObjRelInsertInput>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationUser?: InputMaybe<organizationUserObjRelInsertInput>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type organizationUserAttachmentsMaxFields = {
  __typename?: 'organizationUserAttachmentsMaxFields';
  attachedByUser?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "business.organization_user_attachments" */
export type organizationUserAttachmentsMaxOrderBy = {
  attachedByUser?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  fileId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type organizationUserAttachmentsMinFields = {
  __typename?: 'organizationUserAttachmentsMinFields';
  attachedByUser?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "business.organization_user_attachments" */
export type organizationUserAttachmentsMinOrderBy = {
  attachedByUser?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  fileId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "business.organization_user_attachments" */
export type organizationUserAttachmentsMutationResponse = {
  __typename?: 'organizationUserAttachmentsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<organizationUserAttachments>;
};

/** on_conflict condition type for table "business.organization_user_attachments" */
export type organizationUserAttachmentsOnConflict = {
  constraint: organizationUserAttachmentsConstraint;
  updateColumns?: Array<organizationUserAttachmentsUpdateColumn>;
  where?: InputMaybe<organizationUserAttachmentsBoolExp>;
};

/** Ordering options when selecting data from "business.organization_user_attachments". */
export type organizationUserAttachmentsOrderBy = {
  attachedByUser?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  file?: InputMaybe<publicFileOrderBy>;
  fileId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organizationUser?: InputMaybe<organizationUserOrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.organization_user_attachments */
export type organizationUserAttachmentsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "business.organization_user_attachments" */
export type organizationUserAttachmentsSelectColumn =
  /** column name */
  | 'attachedByUser'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'fileId'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "business.organization_user_attachments" */
export type organizationUserAttachmentsSetInput = {
  attachedByUser?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "organizationUserAttachments" */
export type organizationUserAttachmentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: organizationUserAttachmentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type organizationUserAttachmentsStreamCursorValueInput = {
  attachedByUser?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "business.organization_user_attachments" */
export type organizationUserAttachmentsUpdateColumn =
  /** column name */
  | 'attachedByUser'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'fileId'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type organizationUserAttachmentsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<organizationUserAttachmentsSetInput>;
  /** filter the rows which have to be updated */
  where: organizationUserAttachmentsBoolExp;
};

/** columns and relationships of "business.user_authorization" */
export type organizationUserAuthorization = {
  __typename?: 'organizationUserAuthorization';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "business.user_authorization" */
export type organizationUserAuthorizationAggregate = {
  __typename?: 'organizationUserAuthorizationAggregate';
  aggregate?: Maybe<organizationUserAuthorizationAggregateFields>;
  nodes: Array<organizationUserAuthorization>;
};

/** aggregate fields of "business.user_authorization" */
export type organizationUserAuthorizationAggregateFields = {
  __typename?: 'organizationUserAuthorizationAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<organizationUserAuthorizationMaxFields>;
  min?: Maybe<organizationUserAuthorizationMinFields>;
};


/** aggregate fields of "business.user_authorization" */
export type organizationUserAuthorizationAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<organizationUserAuthorizationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.user_authorization". All fields are combined with a logical 'AND'. */
export type organizationUserAuthorizationBoolExp = {
  _and?: InputMaybe<Array<organizationUserAuthorizationBoolExp>>;
  _not?: InputMaybe<organizationUserAuthorizationBoolExp>;
  _or?: InputMaybe<Array<organizationUserAuthorizationBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.user_authorization" */
export type organizationUserAuthorizationConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'permission_pkey'
  | '%future added value';

export type organizationUserAuthorizationEnum =
  /** Description */
  | 'AUTH1'
  /** Description */
  | 'AUTH2'
  /** Description */
  | 'AUTH3'
  /** Description */
  | 'AUTH4'
  /** Description */
  | 'AUTH5'
  /** Description */
  | 'AUTH6'
  /** Description */
  | 'AUTH7'
  /** Description */
  | 'AUTH8'
  /** Description */
  | 'AUTH9'
  /** Description */
  | 'AUTH10'
  | '%future added value';

/** input type for inserting data into table "business.user_authorization" */
export type organizationUserAuthorizationInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type organizationUserAuthorizationMaxFields = {
  __typename?: 'organizationUserAuthorizationMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type organizationUserAuthorizationMinFields = {
  __typename?: 'organizationUserAuthorizationMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.user_authorization" */
export type organizationUserAuthorizationMutationResponse = {
  __typename?: 'organizationUserAuthorizationMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<organizationUserAuthorization>;
};

/** input type for inserting object relation for remote table "business.user_authorization" */
export type organizationUserAuthorizationObjRelInsertInput = {
  data: organizationUserAuthorizationInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<organizationUserAuthorizationOnConflict>;
};

/** on_conflict condition type for table "business.user_authorization" */
export type organizationUserAuthorizationOnConflict = {
  constraint: organizationUserAuthorizationConstraint;
  updateColumns?: Array<organizationUserAuthorizationUpdateColumn>;
  where?: InputMaybe<organizationUserAuthorizationBoolExp>;
};

/** Ordering options when selecting data from "business.user_authorization". */
export type organizationUserAuthorizationOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.user_authorization */
export type organizationUserAuthorizationPkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "business.user_authorization" */
export type organizationUserAuthorizationSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "business.user_authorization" */
export type organizationUserAuthorizationSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "organizationUserAuthorization" */
export type organizationUserAuthorizationStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: organizationUserAuthorizationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type organizationUserAuthorizationStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.user_authorization" */
export type organizationUserAuthorizationUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type organizationUserAuthorizationUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<organizationUserAuthorizationSetInput>;
  /** filter the rows which have to be updated */
  where: organizationUserAuthorizationBoolExp;
};

/** Boolean expression to filter rows from the table "business.organization_user". All fields are combined with a logical 'AND'. */
export type organizationUserBoolExp = {
  _and?: InputMaybe<Array<organizationUserBoolExp>>;
  _not?: InputMaybe<organizationUserBoolExp>;
  _or?: InputMaybe<Array<organizationUserBoolExp>>;
  activityDomainUsers?: InputMaybe<domainUserBoolExp>;
  activityDomainUsersAggregate?: InputMaybe<domainUserAggregateBoolExp>;
  addresses?: InputMaybe<addressBoolExp>;
  addressesAggregate?: InputMaybe<addressAggregateBoolExp>;
  attachments?: InputMaybe<organizationUserAttachmentsBoolExp>;
  attachmentsAggregate?: InputMaybe<organizationUserAttachmentsAggregateBoolExp>;
  collaborations?: InputMaybe<businessQueueItemCollaborationBoolExp>;
  collaborationsAggregate?: InputMaybe<businessQueueItemCollaborationAggregateBoolExp>;
  company?: InputMaybe<organizationUserBoolExp>;
  companyId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdBy?: InputMaybe<userBoolExp>;
  createdByUserId?: InputMaybe<UuidComparisonExp>;
  crmRepresentations?: InputMaybe<crmYoutelloCatalystIdMappingBoolExp>;
  crmRepresentationsAggregate?: InputMaybe<crmYoutelloCatalystIdMappingAggregateBoolExp>;
  deletionAt?: InputMaybe<TimestamptzComparisonExp>;
  department?: InputMaybe<StringComparisonExp>;
  emailAddress?: InputMaybe<StringComparisonExp>;
  emails?: InputMaybe<BusinessOrganizationUserEmailBoolExp>;
  emailsAggregate?: InputMaybe<BusinessOrganizationUserEmailAggregateBoolExp>;
  extraData?: InputMaybe<JsonbComparisonExp>;
  firstName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  image?: InputMaybe<StringComparisonExp>;
  lastName?: InputMaybe<StringComparisonExp>;
  organization?: InputMaybe<organizationBoolExp>;
  organizationId?: InputMaybe<UuidComparisonExp>;
  organizationNumber?: InputMaybe<StringComparisonExp>;
  organization_user_authorizations?: InputMaybe<organizationOrganizationUserAuthorizationBoolExp>;
  organization_user_authorizationsAggregate?: InputMaybe<organizationOrganizationUserAuthorizationAggregateBoolExp>;
  organization_user_details?: InputMaybe<organizationUserDetailBoolExp>;
  organization_user_detailsAggregate?: InputMaybe<organizationUserDetailAggregateBoolExp>;
  owner?: InputMaybe<userBoolExp>;
  ownerUserId?: InputMaybe<UuidComparisonExp>;
  permissions?: InputMaybe<JsonbComparisonExp>;
  phoneNumber?: InputMaybe<StringComparisonExp>;
  position?: InputMaybe<StringComparisonExp>;
  role?: InputMaybe<UserRoleEnumComparisonExp>;
  status?: InputMaybe<OrganizationUserStatusEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  urlAddresses?: InputMaybe<BusinessOrganizationUserUrlAddressBoolExp>;
  urlAddressesAggregate?: InputMaybe<BusinessOrganizationUserUrlAddressAggregateBoolExp>;
  user?: InputMaybe<userBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "business.organization_user" */
export type organizationUserConstraint =
  /** unique or primary key constraint on columns "email_address", "organization_id" */
  | 'organization_user_organization_id_email_address_key'
  /** unique or primary key constraint on columns "email_address", "organization_id" */
  | 'organization_user_organization_id_email_address_key2'
  /** unique or primary key constraint on columns "phone_number", "organization_id" */
  | 'organization_user_organization_id_phone_number_key'
  /** unique or primary key constraint on columns "user_id", "role", "organization_id" */
  | 'organization_user_organization_id_user_id_role_key'
  /** unique or primary key constraint on columns "organization_number", "organization_id" */
  | 'organization_user_organization_number_organization_id_key'
  /** unique or primary key constraint on columns "id" */
  | 'organization_user_pkey'
  | '%future added value';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type organizationUserDeleteAtPathInput = {
  extraData?: InputMaybe<Array<Scalars['String']['input']>>;
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type organizationUserDeleteElemInput = {
  extraData?: InputMaybe<Scalars['Int']['input']>;
  permissions?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type organizationUserDeleteKeyInput = {
  extraData?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "business.organization_user_details" */
export type organizationUserDetail = {
  __typename?: 'organizationUserDetail';
  createdAt: Scalars['timestamptz']['output'];
  createdByUserId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organizationUserDetailsType: organizationUserDetailType;
  organizationUserId: Scalars['uuid']['output'];
  /** An object relationship */
  organization_user: organizationUser;
  type: organizationUserDetailTypeEnum;
  updatedAt: Scalars['timestamptz']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "business.organization_user_details" */
export type organizationUserDetailAggregate = {
  __typename?: 'organizationUserDetailAggregate';
  aggregate?: Maybe<organizationUserDetailAggregateFields>;
  nodes: Array<organizationUserDetail>;
};

export type organizationUserDetailAggregateBoolExp = {
  count?: InputMaybe<organizationUserDetailAggregateBoolExpCount>;
};

export type organizationUserDetailAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<organizationUserDetailSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<organizationUserDetailBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "business.organization_user_details" */
export type organizationUserDetailAggregateFields = {
  __typename?: 'organizationUserDetailAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<organizationUserDetailMaxFields>;
  min?: Maybe<organizationUserDetailMinFields>;
};


/** aggregate fields of "business.organization_user_details" */
export type organizationUserDetailAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<organizationUserDetailSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.organization_user_details" */
export type organizationUserDetailAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<organizationUserDetailMaxOrderBy>;
  min?: InputMaybe<organizationUserDetailMinOrderBy>;
};

/** input type for inserting array relation for remote table "business.organization_user_details" */
export type organizationUserDetailArrRelInsertInput = {
  data: Array<organizationUserDetailInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<organizationUserDetailOnConflict>;
};

/** Boolean expression to filter rows from the table "business.organization_user_details". All fields are combined with a logical 'AND'. */
export type organizationUserDetailBoolExp = {
  _and?: InputMaybe<Array<organizationUserDetailBoolExp>>;
  _not?: InputMaybe<organizationUserDetailBoolExp>;
  _or?: InputMaybe<Array<organizationUserDetailBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organizationUserDetailsType?: InputMaybe<organizationUserDetailTypeBoolExp>;
  organizationUserId?: InputMaybe<UuidComparisonExp>;
  organization_user?: InputMaybe<organizationUserBoolExp>;
  type?: InputMaybe<OrganizationUserDetailTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.organization_user_details" */
export type organizationUserDetailConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'organization_user_details_pkey'
  | '%future added value';

/** input type for inserting data into table "business.organization_user_details" */
export type organizationUserDetailInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationUserDetailsType?: InputMaybe<organizationUserDetailTypeObjRelInsertInput>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  organization_user?: InputMaybe<organizationUserObjRelInsertInput>;
  type?: InputMaybe<organizationUserDetailTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type organizationUserDetailMaxFields = {
  __typename?: 'organizationUserDetailMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "business.organization_user_details" */
export type organizationUserDetailMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type organizationUserDetailMinFields = {
  __typename?: 'organizationUserDetailMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "business.organization_user_details" */
export type organizationUserDetailMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "business.organization_user_details" */
export type organizationUserDetailMutationResponse = {
  __typename?: 'organizationUserDetailMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<organizationUserDetail>;
};

/** on_conflict condition type for table "business.organization_user_details" */
export type organizationUserDetailOnConflict = {
  constraint: organizationUserDetailConstraint;
  updateColumns?: Array<organizationUserDetailUpdateColumn>;
  where?: InputMaybe<organizationUserDetailBoolExp>;
};

/** Ordering options when selecting data from "business.organization_user_details". */
export type organizationUserDetailOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organizationUserDetailsType?: InputMaybe<organizationUserDetailTypeOrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  organization_user?: InputMaybe<organizationUserOrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.organization_user_details */
export type organizationUserDetailPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "business.organization_user_details" */
export type organizationUserDetailSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserId'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "business.organization_user_details" */
export type organizationUserDetailSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<organizationUserDetailTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "organizationUserDetail" */
export type organizationUserDetailStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: organizationUserDetailStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type organizationUserDetailStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<organizationUserDetailTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "business.organization_user_details_type" */
export type organizationUserDetailType = {
  __typename?: 'organizationUserDetailType';
  description: Scalars['String']['output'];
  /** An array relationship */
  organizationUserDetails: Array<organizationUserDetail>;
  /** An aggregate relationship */
  organizationUserDetailsAggregate: organizationUserDetailAggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "business.organization_user_details_type" */
export type organizationUserDetailTypeorganizationUserDetailsArgs = {
  distinctOn?: InputMaybe<Array<organizationUserDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserDetailOrderBy>>;
  where?: InputMaybe<organizationUserDetailBoolExp>;
};


/** columns and relationships of "business.organization_user_details_type" */
export type organizationUserDetailTypeorganizationUserDetailsAggregateArgs = {
  distinctOn?: InputMaybe<Array<organizationUserDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserDetailOrderBy>>;
  where?: InputMaybe<organizationUserDetailBoolExp>;
};

/** aggregated selection of "business.organization_user_details_type" */
export type organizationUserDetailTypeAggregate = {
  __typename?: 'organizationUserDetailTypeAggregate';
  aggregate?: Maybe<organizationUserDetailTypeAggregateFields>;
  nodes: Array<organizationUserDetailType>;
};

/** aggregate fields of "business.organization_user_details_type" */
export type organizationUserDetailTypeAggregateFields = {
  __typename?: 'organizationUserDetailTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<organizationUserDetailTypeMaxFields>;
  min?: Maybe<organizationUserDetailTypeMinFields>;
};


/** aggregate fields of "business.organization_user_details_type" */
export type organizationUserDetailTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<organizationUserDetailTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.organization_user_details_type". All fields are combined with a logical 'AND'. */
export type organizationUserDetailTypeBoolExp = {
  _and?: InputMaybe<Array<organizationUserDetailTypeBoolExp>>;
  _not?: InputMaybe<organizationUserDetailTypeBoolExp>;
  _or?: InputMaybe<Array<organizationUserDetailTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  organizationUserDetails?: InputMaybe<organizationUserDetailBoolExp>;
  organizationUserDetailsAggregate?: InputMaybe<organizationUserDetailAggregateBoolExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.organization_user_details_type" */
export type organizationUserDetailTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'organization_user_details_type_pkey'
  | '%future added value';

export type organizationUserDetailTypeEnum =
  | 'CITY'
  | 'DEPARTMENT'
  | 'EMAIL'
  | 'FIRSTNAME'
  | 'LASTNAME'
  | 'PHONENUMBER'
  | 'POSITION'
  | 'STREET'
  | 'ZIP'
  | '%future added value';

/** input type for inserting data into table "business.organization_user_details_type" */
export type organizationUserDetailTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  organizationUserDetails?: InputMaybe<organizationUserDetailArrRelInsertInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type organizationUserDetailTypeMaxFields = {
  __typename?: 'organizationUserDetailTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type organizationUserDetailTypeMinFields = {
  __typename?: 'organizationUserDetailTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.organization_user_details_type" */
export type organizationUserDetailTypeMutationResponse = {
  __typename?: 'organizationUserDetailTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<organizationUserDetailType>;
};

/** input type for inserting object relation for remote table "business.organization_user_details_type" */
export type organizationUserDetailTypeObjRelInsertInput = {
  data: organizationUserDetailTypeInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<organizationUserDetailTypeOnConflict>;
};

/** on_conflict condition type for table "business.organization_user_details_type" */
export type organizationUserDetailTypeOnConflict = {
  constraint: organizationUserDetailTypeConstraint;
  updateColumns?: Array<organizationUserDetailTypeUpdateColumn>;
  where?: InputMaybe<organizationUserDetailTypeBoolExp>;
};

/** Ordering options when selecting data from "business.organization_user_details_type". */
export type organizationUserDetailTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  organizationUserDetailsAggregate?: InputMaybe<organizationUserDetailAggregateOrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.organization_user_details_type */
export type organizationUserDetailTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "business.organization_user_details_type" */
export type organizationUserDetailTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "business.organization_user_details_type" */
export type organizationUserDetailTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "organizationUserDetailType" */
export type organizationUserDetailTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: organizationUserDetailTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type organizationUserDetailTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.organization_user_details_type" */
export type organizationUserDetailTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type organizationUserDetailTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<organizationUserDetailTypeSetInput>;
  /** filter the rows which have to be updated */
  where: organizationUserDetailTypeBoolExp;
};

/** update columns of table "business.organization_user_details" */
export type organizationUserDetailUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserId'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'value'
  | '%future added value';

export type organizationUserDetailUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<organizationUserDetailSetInput>;
  /** filter the rows which have to be updated */
  where: organizationUserDetailBoolExp;
};

/** input type for inserting data into table "business.organization_user" */
export type organizationUserInsertInput = {
  activityDomainUsers?: InputMaybe<domainUserArrRelInsertInput>;
  addresses?: InputMaybe<addressArrRelInsertInput>;
  attachments?: InputMaybe<organizationUserAttachmentsArrRelInsertInput>;
  collaborations?: InputMaybe<businessQueueItemCollaborationArrRelInsertInput>;
  company?: InputMaybe<organizationUserObjRelInsertInput>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<userObjRelInsertInput>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  crmRepresentations?: InputMaybe<crmYoutelloCatalystIdMappingArrRelInsertInput>;
  deletionAt?: InputMaybe<Scalars['timestamptz']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<BusinessOrganizationUserEmailArrRelInsertInput>;
  extraData?: InputMaybe<Scalars['jsonb']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<organizationObjRelInsertInput>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
  organization_user_authorizations?: InputMaybe<organizationOrganizationUserAuthorizationArrRelInsertInput>;
  organization_user_details?: InputMaybe<organizationUserDetailArrRelInsertInput>;
  owner?: InputMaybe<userObjRelInsertInput>;
  ownerUserId?: InputMaybe<Scalars['uuid']['input']>;
  permissions?: InputMaybe<Scalars['jsonb']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<userRoleEnum>;
  status?: InputMaybe<organizationUserStatusEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  urlAddresses?: InputMaybe<BusinessOrganizationUserUrlAddressArrRelInsertInput>;
  user?: InputMaybe<userObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** users that are invited to an organization in Youtello */
export type organizationUserInvite = {
  __typename?: 'organizationUserInvite';
  city?: Maybe<Scalars['String']['output']>;
  createdByUserId: Scalars['uuid']['output'];
  extraData?: Maybe<Scalars['jsonb']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization?: Maybe<organization>;
  organizationId: Scalars['uuid']['output'];
  organizationName: Scalars['String']['output'];
  organizationNumber?: Maybe<Scalars['String']['output']>;
  permissionRole?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberCountryCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};


/** users that are invited to an organization in Youtello */
export type organizationUserInviteextraDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "business.organization_user_invite" */
export type organizationUserInviteAggregate = {
  __typename?: 'organizationUserInviteAggregate';
  aggregate?: Maybe<organizationUserInviteAggregateFields>;
  nodes: Array<organizationUserInvite>;
};

export type organizationUserInviteAggregateBoolExp = {
  count?: InputMaybe<organizationUserInviteAggregateBoolExpCount>;
};

export type organizationUserInviteAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<organizationUserInviteSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<organizationUserInviteBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "business.organization_user_invite" */
export type organizationUserInviteAggregateFields = {
  __typename?: 'organizationUserInviteAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<organizationUserInviteMaxFields>;
  min?: Maybe<organizationUserInviteMinFields>;
};


/** aggregate fields of "business.organization_user_invite" */
export type organizationUserInviteAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<organizationUserInviteSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.organization_user_invite" */
export type organizationUserInviteAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<organizationUserInviteMaxOrderBy>;
  min?: InputMaybe<organizationUserInviteMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type organizationUserInviteAppendInput = {
  extraData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "business.organization_user_invite" */
export type organizationUserInviteArrRelInsertInput = {
  data: Array<organizationUserInviteInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<organizationUserInviteOnConflict>;
};

/** Boolean expression to filter rows from the table "business.organization_user_invite". All fields are combined with a logical 'AND'. */
export type organizationUserInviteBoolExp = {
  _and?: InputMaybe<Array<organizationUserInviteBoolExp>>;
  _not?: InputMaybe<organizationUserInviteBoolExp>;
  _or?: InputMaybe<Array<organizationUserInviteBoolExp>>;
  city?: InputMaybe<StringComparisonExp>;
  createdByUserId?: InputMaybe<UuidComparisonExp>;
  extraData?: InputMaybe<JsonbComparisonExp>;
  firstName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lastName?: InputMaybe<StringComparisonExp>;
  organization?: InputMaybe<organizationBoolExp>;
  organizationId?: InputMaybe<UuidComparisonExp>;
  organizationName?: InputMaybe<StringComparisonExp>;
  organizationNumber?: InputMaybe<StringComparisonExp>;
  permissionRole?: InputMaybe<StringComparisonExp>;
  phoneNumber?: InputMaybe<StringComparisonExp>;
  phoneNumberCountryCode?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  street?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  zip?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.organization_user_invite" */
export type organizationUserInviteConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'organization_user_invite_pkey'
  | '%future added value';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type organizationUserInviteDeleteAtPathInput = {
  extraData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type organizationUserInviteDeleteElemInput = {
  extraData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type organizationUserInviteDeleteKeyInput = {
  extraData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "business.organization_user_invite" */
export type organizationUserInviteInsertInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  extraData?: InputMaybe<Scalars['jsonb']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<organizationObjRelInsertInput>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
  permissionRole?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberCountryCode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type organizationUserInviteMaxFields = {
  __typename?: 'organizationUserInviteMaxFields';
  city?: Maybe<Scalars['String']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationNumber?: Maybe<Scalars['String']['output']>;
  permissionRole?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberCountryCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "business.organization_user_invite" */
export type organizationUserInviteMaxOrderBy = {
  city?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  organizationName?: InputMaybe<OrderBy>;
  organizationNumber?: InputMaybe<OrderBy>;
  permissionRole?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  phoneNumberCountryCode?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  street?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  zip?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type organizationUserInviteMinFields = {
  __typename?: 'organizationUserInviteMinFields';
  city?: Maybe<Scalars['String']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationNumber?: Maybe<Scalars['String']['output']>;
  permissionRole?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberCountryCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "business.organization_user_invite" */
export type organizationUserInviteMinOrderBy = {
  city?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  organizationName?: InputMaybe<OrderBy>;
  organizationNumber?: InputMaybe<OrderBy>;
  permissionRole?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  phoneNumberCountryCode?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  street?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  zip?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "business.organization_user_invite" */
export type organizationUserInviteMutationResponse = {
  __typename?: 'organizationUserInviteMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<organizationUserInvite>;
};

/** on_conflict condition type for table "business.organization_user_invite" */
export type organizationUserInviteOnConflict = {
  constraint: organizationUserInviteConstraint;
  updateColumns?: Array<organizationUserInviteUpdateColumn>;
  where?: InputMaybe<organizationUserInviteBoolExp>;
};

/** Ordering options when selecting data from "business.organization_user_invite". */
export type organizationUserInviteOrderBy = {
  city?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  extraData?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  organization?: InputMaybe<organizationOrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  organizationName?: InputMaybe<OrderBy>;
  organizationNumber?: InputMaybe<OrderBy>;
  permissionRole?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  phoneNumberCountryCode?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  street?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  zip?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.organization_user_invite */
export type organizationUserInvitePkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type organizationUserInvitePrependInput = {
  extraData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "business.organization_user_invite" */
export type organizationUserInviteSelectColumn =
  /** column name */
  | 'city'
  /** column name */
  | 'createdByUserId'
  /** column name */
  | 'extraData'
  /** column name */
  | 'firstName'
  /** column name */
  | 'id'
  /** column name */
  | 'lastName'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'organizationName'
  /** column name */
  | 'organizationNumber'
  /** column name */
  | 'permissionRole'
  /** column name */
  | 'phoneNumber'
  /** column name */
  | 'phoneNumberCountryCode'
  /** column name */
  | 'status'
  /** column name */
  | 'street'
  /** column name */
  | 'type'
  /** column name */
  | 'userId'
  /** column name */
  | 'zip'
  | '%future added value';

/** input type for updating data in table "business.organization_user_invite" */
export type organizationUserInviteSetInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  extraData?: InputMaybe<Scalars['jsonb']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
  permissionRole?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberCountryCode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "organizationUserInvite" */
export type organizationUserInviteStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: organizationUserInviteStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type organizationUserInviteStreamCursorValueInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  extraData?: InputMaybe<Scalars['jsonb']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
  permissionRole?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberCountryCode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.organization_user_invite" */
export type organizationUserInviteUpdateColumn =
  /** column name */
  | 'city'
  /** column name */
  | 'createdByUserId'
  /** column name */
  | 'extraData'
  /** column name */
  | 'firstName'
  /** column name */
  | 'id'
  /** column name */
  | 'lastName'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'organizationName'
  /** column name */
  | 'organizationNumber'
  /** column name */
  | 'permissionRole'
  /** column name */
  | 'phoneNumber'
  /** column name */
  | 'phoneNumberCountryCode'
  /** column name */
  | 'status'
  /** column name */
  | 'street'
  /** column name */
  | 'type'
  /** column name */
  | 'userId'
  /** column name */
  | 'zip'
  | '%future added value';

export type organizationUserInviteUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<organizationUserInviteAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<organizationUserInviteDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<organizationUserInviteDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<organizationUserInviteDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<organizationUserInvitePrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<organizationUserInviteSetInput>;
  /** filter the rows which have to be updated */
  where: organizationUserInviteBoolExp;
};

/** aggregate max on columns */
export type organizationUserMaxFields = {
  __typename?: 'organizationUserMaxFields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  deletionAt?: Maybe<Scalars['timestamptz']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  organizationNumber?: Maybe<Scalars['String']['output']>;
  ownerUserId?: Maybe<Scalars['uuid']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "business.organization_user" */
export type organizationUserMaxOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  deletionAt?: InputMaybe<OrderBy>;
  department?: InputMaybe<OrderBy>;
  emailAddress?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  image?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  organizationNumber?: InputMaybe<OrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type organizationUserMinFields = {
  __typename?: 'organizationUserMinFields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  deletionAt?: Maybe<Scalars['timestamptz']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  organizationNumber?: Maybe<Scalars['String']['output']>;
  ownerUserId?: Maybe<Scalars['uuid']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "business.organization_user" */
export type organizationUserMinOrderBy = {
  companyId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  deletionAt?: InputMaybe<OrderBy>;
  department?: InputMaybe<OrderBy>;
  emailAddress?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  image?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  organizationNumber?: InputMaybe<OrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "business.organization_user" */
export type organizationUserMutationResponse = {
  __typename?: 'organizationUserMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<organizationUser>;
};

/** input type for inserting object relation for remote table "business.organization_user" */
export type organizationUserObjRelInsertInput = {
  data: organizationUserInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<organizationUserOnConflict>;
};

/** on_conflict condition type for table "business.organization_user" */
export type organizationUserOnConflict = {
  constraint: organizationUserConstraint;
  updateColumns?: Array<organizationUserUpdateColumn>;
  where?: InputMaybe<organizationUserBoolExp>;
};

/** Ordering options when selecting data from "business.organization_user". */
export type organizationUserOrderBy = {
  activityDomainUsersAggregate?: InputMaybe<domainUserAggregateOrderBy>;
  addressesAggregate?: InputMaybe<addressAggregateOrderBy>;
  attachmentsAggregate?: InputMaybe<organizationUserAttachmentsAggregateOrderBy>;
  collaborationsAggregate?: InputMaybe<businessQueueItemCollaborationAggregateOrderBy>;
  company?: InputMaybe<organizationUserOrderBy>;
  companyId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<userOrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  crmRepresentationsAggregate?: InputMaybe<crmYoutelloCatalystIdMappingAggregateOrderBy>;
  deletionAt?: InputMaybe<OrderBy>;
  department?: InputMaybe<OrderBy>;
  emailAddress?: InputMaybe<OrderBy>;
  emailsAggregate?: InputMaybe<BusinessOrganizationUserEmailAggregateOrderBy>;
  extraData?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  image?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  organization?: InputMaybe<organizationOrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  organizationNumber?: InputMaybe<OrderBy>;
  organization_user_authorizationsAggregate?: InputMaybe<organizationOrganizationUserAuthorizationAggregateOrderBy>;
  organization_user_detailsAggregate?: InputMaybe<organizationUserDetailAggregateOrderBy>;
  owner?: InputMaybe<userOrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
  permissions?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  role?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  urlAddressesAggregate?: InputMaybe<BusinessOrganizationUserUrlAddressAggregateOrderBy>;
  user?: InputMaybe<userOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

export type organizationUserOutput = {
  __typename?: 'organizationUserOutput';
  id: Scalars['uuid']['output'];
  organizationUsers?: Maybe<Array<Maybe<organizationUsers>>>;
};

/** primary key columns input for table: business.organization_user */
export type organizationUserPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type organizationUserPrependInput = {
  extraData?: InputMaybe<Scalars['jsonb']['input']>;
  permissions?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "business.organization_user" */
export type organizationUserSelectColumn =
  /** column name */
  | 'companyId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserId'
  /** column name */
  | 'deletionAt'
  /** column name */
  | 'department'
  /** column name */
  | 'emailAddress'
  /** column name */
  | 'extraData'
  /** column name */
  | 'firstName'
  /** column name */
  | 'id'
  /** column name */
  | 'image'
  /** column name */
  | 'lastName'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'organizationNumber'
  /** column name */
  | 'ownerUserId'
  /** column name */
  | 'permissions'
  /** column name */
  | 'phoneNumber'
  /** column name */
  | 'position'
  /** column name */
  | 'role'
  /** column name */
  | 'status'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

/** input type for updating data in table "business.organization_user" */
export type organizationUserSetInput = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  deletionAt?: InputMaybe<Scalars['timestamptz']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  extraData?: InputMaybe<Scalars['jsonb']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
  ownerUserId?: InputMaybe<Scalars['uuid']['input']>;
  permissions?: InputMaybe<Scalars['jsonb']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<userRoleEnum>;
  status?: InputMaybe<organizationUserStatusEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "business.organization_user_status" */
export type organizationUserStatus = {
  __typename?: 'organizationUserStatus';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "business.organization_user_status" */
export type organizationUserStatusAggregate = {
  __typename?: 'organizationUserStatusAggregate';
  aggregate?: Maybe<organizationUserStatusAggregateFields>;
  nodes: Array<organizationUserStatus>;
};

/** aggregate fields of "business.organization_user_status" */
export type organizationUserStatusAggregateFields = {
  __typename?: 'organizationUserStatusAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<organizationUserStatusMaxFields>;
  min?: Maybe<organizationUserStatusMinFields>;
};


/** aggregate fields of "business.organization_user_status" */
export type organizationUserStatusAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<organizationUserStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.organization_user_status". All fields are combined with a logical 'AND'. */
export type organizationUserStatusBoolExp = {
  _and?: InputMaybe<Array<organizationUserStatusBoolExp>>;
  _not?: InputMaybe<organizationUserStatusBoolExp>;
  _or?: InputMaybe<Array<organizationUserStatusBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.organization_user_status" */
export type organizationUserStatusConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'organization_user_status_pkey'
  | '%future added value';

export type organizationUserStatusEnum =
  /** Active user */
  | 'ACTIVE'
  /** If user is deleted */
  | 'DELETED_USER'
  /** Deactivated user */
  | 'INACTIVE'
  /** when an invitation is already sent */
  | 'INVITATION_SENT'
  /** User has been invited */
  | 'INVITED'
  /** User leaved from organization */
  | 'LEAVED_ORGANIZATION'
  /** User has left the organization */
  | 'REMOVED'
  /** Scheduled for deletion at time given in column deletionAt */
  | 'SCHEDULED_FOR_DELETION'
  | '%future added value';

/** input type for inserting data into table "business.organization_user_status" */
export type organizationUserStatusInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type organizationUserStatusMaxFields = {
  __typename?: 'organizationUserStatusMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type organizationUserStatusMinFields = {
  __typename?: 'organizationUserStatusMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.organization_user_status" */
export type organizationUserStatusMutationResponse = {
  __typename?: 'organizationUserStatusMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<organizationUserStatus>;
};

/** on_conflict condition type for table "business.organization_user_status" */
export type organizationUserStatusOnConflict = {
  constraint: organizationUserStatusConstraint;
  updateColumns?: Array<organizationUserStatusUpdateColumn>;
  where?: InputMaybe<organizationUserStatusBoolExp>;
};

/** Ordering options when selecting data from "business.organization_user_status". */
export type organizationUserStatusOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.organization_user_status */
export type organizationUserStatusPkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "business.organization_user_status" */
export type organizationUserStatusSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "business.organization_user_status" */
export type organizationUserStatusSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "organizationUserStatus" */
export type organizationUserStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: organizationUserStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type organizationUserStatusStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.organization_user_status" */
export type organizationUserStatusUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type organizationUserStatusUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<organizationUserStatusSetInput>;
  /** filter the rows which have to be updated */
  where: organizationUserStatusBoolExp;
};

/** Streaming cursor of the table "organizationUser" */
export type organizationUserStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: organizationUserStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type organizationUserStreamCursorValueInput = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  deletionAt?: InputMaybe<Scalars['timestamptz']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  extraData?: InputMaybe<Scalars['jsonb']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
  ownerUserId?: InputMaybe<Scalars['uuid']['input']>;
  permissions?: InputMaybe<Scalars['jsonb']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<userRoleEnum>;
  status?: InputMaybe<organizationUserStatusEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "business.organization_user" */
export type organizationUserUpdateColumn =
  /** column name */
  | 'companyId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserId'
  /** column name */
  | 'deletionAt'
  /** column name */
  | 'department'
  /** column name */
  | 'emailAddress'
  /** column name */
  | 'extraData'
  /** column name */
  | 'firstName'
  /** column name */
  | 'id'
  /** column name */
  | 'image'
  /** column name */
  | 'lastName'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'organizationNumber'
  /** column name */
  | 'ownerUserId'
  /** column name */
  | 'permissions'
  /** column name */
  | 'phoneNumber'
  /** column name */
  | 'position'
  /** column name */
  | 'role'
  /** column name */
  | 'status'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  | '%future added value';

export type organizationUserUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<organizationUserAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<organizationUserDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<organizationUserDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<organizationUserDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<organizationUserPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<organizationUserSetInput>;
  /** filter the rows which have to be updated */
  where: organizationUserBoolExp;
};

export type organizationUsers = {
  __typename?: 'organizationUsers';
  firstName: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  lastName: Scalars['String']['output'];
  organizationId: Scalars['uuid']['output'];
};

/** aggregate varPop on columns */
export type organizationVarPopFields = {
  __typename?: 'organizationVarPopFields';
  nrOfEmployees?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "business.organizations" */
export type organizationVarPopOrderBy = {
  nrOfEmployees?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type organizationVarSampFields = {
  __typename?: 'organizationVarSampFields';
  nrOfEmployees?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "business.organizations" */
export type organizationVarSampOrderBy = {
  nrOfEmployees?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type organizationVarianceFields = {
  __typename?: 'organizationVarianceFields';
  nrOfEmployees?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "business.organizations" */
export type organizationVarianceOrderBy = {
  nrOfEmployees?: InputMaybe<OrderBy>;
};

/** columns and relationships of "business.phone_number_verification_status" */
export type phoneNumberVerificationStatus = {
  __typename?: 'phoneNumberVerificationStatus';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "business.phone_number_verification_status" */
export type phoneNumberVerificationStatusAggregate = {
  __typename?: 'phoneNumberVerificationStatusAggregate';
  aggregate?: Maybe<phoneNumberVerificationStatusAggregateFields>;
  nodes: Array<phoneNumberVerificationStatus>;
};

/** aggregate fields of "business.phone_number_verification_status" */
export type phoneNumberVerificationStatusAggregateFields = {
  __typename?: 'phoneNumberVerificationStatusAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<phoneNumberVerificationStatusMaxFields>;
  min?: Maybe<phoneNumberVerificationStatusMinFields>;
};


/** aggregate fields of "business.phone_number_verification_status" */
export type phoneNumberVerificationStatusAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<phoneNumberVerificationStatusSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.phone_number_verification_status". All fields are combined with a logical 'AND'. */
export type phoneNumberVerificationStatusBoolExp = {
  _and?: InputMaybe<Array<phoneNumberVerificationStatusBoolExp>>;
  _not?: InputMaybe<phoneNumberVerificationStatusBoolExp>;
  _or?: InputMaybe<Array<phoneNumberVerificationStatusBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.phone_number_verification_status" */
export type phoneNumberVerificationStatusConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'phone_number_verification_status_pkey'
  | '%future added value';

export type phoneNumberVerificationStatusEnum =
  /** No */
  | 'NO'
  /** Yes */
  | 'YES'
  | '%future added value';

/** input type for inserting data into table "business.phone_number_verification_status" */
export type phoneNumberVerificationStatusInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type phoneNumberVerificationStatusMaxFields = {
  __typename?: 'phoneNumberVerificationStatusMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type phoneNumberVerificationStatusMinFields = {
  __typename?: 'phoneNumberVerificationStatusMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.phone_number_verification_status" */
export type phoneNumberVerificationStatusMutationResponse = {
  __typename?: 'phoneNumberVerificationStatusMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<phoneNumberVerificationStatus>;
};

/** on_conflict condition type for table "business.phone_number_verification_status" */
export type phoneNumberVerificationStatusOnConflict = {
  constraint: phoneNumberVerificationStatusConstraint;
  updateColumns?: Array<phoneNumberVerificationStatusUpdateColumn>;
  where?: InputMaybe<phoneNumberVerificationStatusBoolExp>;
};

/** Ordering options when selecting data from "business.phone_number_verification_status". */
export type phoneNumberVerificationStatusOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.phone_number_verification_status */
export type phoneNumberVerificationStatusPkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "business.phone_number_verification_status" */
export type phoneNumberVerificationStatusSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "business.phone_number_verification_status" */
export type phoneNumberVerificationStatusSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "phoneNumberVerificationStatus" */
export type phoneNumberVerificationStatusStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: phoneNumberVerificationStatusStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type phoneNumberVerificationStatusStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.phone_number_verification_status" */
export type phoneNumberVerificationStatusUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type phoneNumberVerificationStatusUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<phoneNumberVerificationStatusSetInput>;
  /** filter the rows which have to be updated */
  where: phoneNumberVerificationStatusBoolExp;
};

export type phoneUserOutput = {
  __typename?: 'phoneUserOutput';
  phoneUser: Scalars['Boolean']['output'];
};

export type privatizeUserResult = {
  __typename?: 'privatizeUserResult';
  result: Scalars['String']['output'];
};

/** columns and relationships of "devices" */
export type publicDevice = {
  __typename?: 'publicDevice';
  deviceBrand?: Maybe<Scalars['String']['output']>;
  deviceIsDevice?: Maybe<Scalars['Boolean']['output']>;
  deviceModel?: Maybe<Scalars['String']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  deviceOs?: Maybe<Scalars['String']['output']>;
  deviceOsVersion?: Maybe<Scalars['String']['output']>;
  devicePushToken?: Maybe<Scalars['String']['output']>;
  deviceYear?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "devices" */
export type publicDeviceAggregate = {
  __typename?: 'publicDeviceAggregate';
  aggregate?: Maybe<publicDeviceAggregateFields>;
  nodes: Array<publicDevice>;
};

/** aggregate fields of "devices" */
export type publicDeviceAggregateFields = {
  __typename?: 'publicDeviceAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<publicDeviceMaxFields>;
  min?: Maybe<publicDeviceMinFields>;
};


/** aggregate fields of "devices" */
export type publicDeviceAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<publicDeviceSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "devices". All fields are combined with a logical 'AND'. */
export type publicDeviceBoolExp = {
  _and?: InputMaybe<Array<publicDeviceBoolExp>>;
  _not?: InputMaybe<publicDeviceBoolExp>;
  _or?: InputMaybe<Array<publicDeviceBoolExp>>;
  deviceBrand?: InputMaybe<StringComparisonExp>;
  deviceIsDevice?: InputMaybe<BooleanComparisonExp>;
  deviceModel?: InputMaybe<StringComparisonExp>;
  deviceName?: InputMaybe<StringComparisonExp>;
  deviceOs?: InputMaybe<StringComparisonExp>;
  deviceOsVersion?: InputMaybe<StringComparisonExp>;
  devicePushToken?: InputMaybe<StringComparisonExp>;
  deviceYear?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "devices" */
export type publicDeviceConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'devices_pkey'
  | '%future added value';

/** input type for inserting data into table "devices" */
export type publicDeviceInsertInput = {
  deviceBrand?: InputMaybe<Scalars['String']['input']>;
  deviceIsDevice?: InputMaybe<Scalars['Boolean']['input']>;
  deviceModel?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  deviceOs?: InputMaybe<Scalars['String']['input']>;
  deviceOsVersion?: InputMaybe<Scalars['String']['input']>;
  devicePushToken?: InputMaybe<Scalars['String']['input']>;
  deviceYear?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type publicDeviceMaxFields = {
  __typename?: 'publicDeviceMaxFields';
  deviceBrand?: Maybe<Scalars['String']['output']>;
  deviceModel?: Maybe<Scalars['String']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  deviceOs?: Maybe<Scalars['String']['output']>;
  deviceOsVersion?: Maybe<Scalars['String']['output']>;
  devicePushToken?: Maybe<Scalars['String']['output']>;
  deviceYear?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type publicDeviceMinFields = {
  __typename?: 'publicDeviceMinFields';
  deviceBrand?: Maybe<Scalars['String']['output']>;
  deviceModel?: Maybe<Scalars['String']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  deviceOs?: Maybe<Scalars['String']['output']>;
  deviceOsVersion?: Maybe<Scalars['String']['output']>;
  devicePushToken?: Maybe<Scalars['String']['output']>;
  deviceYear?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "devices" */
export type publicDeviceMutationResponse = {
  __typename?: 'publicDeviceMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<publicDevice>;
};

/** on_conflict condition type for table "devices" */
export type publicDeviceOnConflict = {
  constraint: publicDeviceConstraint;
  updateColumns?: Array<publicDeviceUpdateColumn>;
  where?: InputMaybe<publicDeviceBoolExp>;
};

/** Ordering options when selecting data from "devices". */
export type publicDeviceOrderBy = {
  deviceBrand?: InputMaybe<OrderBy>;
  deviceIsDevice?: InputMaybe<OrderBy>;
  deviceModel?: InputMaybe<OrderBy>;
  deviceName?: InputMaybe<OrderBy>;
  deviceOs?: InputMaybe<OrderBy>;
  deviceOsVersion?: InputMaybe<OrderBy>;
  devicePushToken?: InputMaybe<OrderBy>;
  deviceYear?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: devices */
export type publicDevicePkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "devices" */
export type publicDeviceSelectColumn =
  /** column name */
  | 'deviceBrand'
  /** column name */
  | 'deviceIsDevice'
  /** column name */
  | 'deviceModel'
  /** column name */
  | 'deviceName'
  /** column name */
  | 'deviceOs'
  /** column name */
  | 'deviceOsVersion'
  /** column name */
  | 'devicePushToken'
  /** column name */
  | 'deviceYear'
  /** column name */
  | 'id'
  /** column name */
  | 'userId'
  | '%future added value';

/** input type for updating data in table "devices" */
export type publicDeviceSetInput = {
  deviceBrand?: InputMaybe<Scalars['String']['input']>;
  deviceIsDevice?: InputMaybe<Scalars['Boolean']['input']>;
  deviceModel?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  deviceOs?: InputMaybe<Scalars['String']['input']>;
  deviceOsVersion?: InputMaybe<Scalars['String']['input']>;
  devicePushToken?: InputMaybe<Scalars['String']['input']>;
  deviceYear?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "publicDevice" */
export type publicDeviceStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: publicDeviceStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type publicDeviceStreamCursorValueInput = {
  deviceBrand?: InputMaybe<Scalars['String']['input']>;
  deviceIsDevice?: InputMaybe<Scalars['Boolean']['input']>;
  deviceModel?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  deviceOs?: InputMaybe<Scalars['String']['input']>;
  deviceOsVersion?: InputMaybe<Scalars['String']['input']>;
  devicePushToken?: InputMaybe<Scalars['String']['input']>;
  deviceYear?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "devices" */
export type publicDeviceUpdateColumn =
  /** column name */
  | 'deviceBrand'
  /** column name */
  | 'deviceIsDevice'
  /** column name */
  | 'deviceModel'
  /** column name */
  | 'deviceName'
  /** column name */
  | 'deviceOs'
  /** column name */
  | 'deviceOsVersion'
  /** column name */
  | 'devicePushToken'
  /** column name */
  | 'deviceYear'
  /** column name */
  | 'id'
  /** column name */
  | 'userId'
  | '%future added value';

export type publicDeviceUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<publicDeviceSetInput>;
  /** filter the rows which have to be updated */
  where: publicDeviceBoolExp;
};

/** columns and relationships of "external_requests" */
export type publicExternalRequest = {
  __typename?: 'publicExternalRequest';
  action?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['uuid']['output'];
  input?: Maybe<Scalars['jsonb']['output']>;
  sessionVariables?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "external_requests" */
export type publicExternalRequestactionArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "external_requests" */
export type publicExternalRequestinputArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "external_requests" */
export type publicExternalRequestsessionVariablesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "external_requests" */
export type publicExternalRequestAggregate = {
  __typename?: 'publicExternalRequestAggregate';
  aggregate?: Maybe<publicExternalRequestAggregateFields>;
  nodes: Array<publicExternalRequest>;
};

/** aggregate fields of "external_requests" */
export type publicExternalRequestAggregateFields = {
  __typename?: 'publicExternalRequestAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<publicExternalRequestMaxFields>;
  min?: Maybe<publicExternalRequestMinFields>;
};


/** aggregate fields of "external_requests" */
export type publicExternalRequestAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<publicExternalRequestSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type publicExternalRequestAppendInput = {
  action?: InputMaybe<Scalars['jsonb']['input']>;
  input?: InputMaybe<Scalars['jsonb']['input']>;
  sessionVariables?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "external_requests". All fields are combined with a logical 'AND'. */
export type publicExternalRequestBoolExp = {
  _and?: InputMaybe<Array<publicExternalRequestBoolExp>>;
  _not?: InputMaybe<publicExternalRequestBoolExp>;
  _or?: InputMaybe<Array<publicExternalRequestBoolExp>>;
  action?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  input?: InputMaybe<JsonbComparisonExp>;
  sessionVariables?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "external_requests" */
export type publicExternalRequestConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'external_requests_id_key'
  /** unique or primary key constraint on columns "id" */
  | 'external_requests_pkey'
  | '%future added value';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type publicExternalRequestDeleteAtPathInput = {
  action?: InputMaybe<Array<Scalars['String']['input']>>;
  input?: InputMaybe<Array<Scalars['String']['input']>>;
  sessionVariables?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type publicExternalRequestDeleteElemInput = {
  action?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<Scalars['Int']['input']>;
  sessionVariables?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type publicExternalRequestDeleteKeyInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<Scalars['String']['input']>;
  sessionVariables?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "external_requests" */
export type publicExternalRequestInsertInput = {
  action?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  input?: InputMaybe<Scalars['jsonb']['input']>;
  sessionVariables?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type publicExternalRequestMaxFields = {
  __typename?: 'publicExternalRequestMaxFields';
  id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type publicExternalRequestMinFields = {
  __typename?: 'publicExternalRequestMinFields';
  id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "external_requests" */
export type publicExternalRequestMutationResponse = {
  __typename?: 'publicExternalRequestMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<publicExternalRequest>;
};

/** on_conflict condition type for table "external_requests" */
export type publicExternalRequestOnConflict = {
  constraint: publicExternalRequestConstraint;
  updateColumns?: Array<publicExternalRequestUpdateColumn>;
  where?: InputMaybe<publicExternalRequestBoolExp>;
};

/** Ordering options when selecting data from "external_requests". */
export type publicExternalRequestOrderBy = {
  action?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input?: InputMaybe<OrderBy>;
  sessionVariables?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: external_requests */
export type publicExternalRequestPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type publicExternalRequestPrependInput = {
  action?: InputMaybe<Scalars['jsonb']['input']>;
  input?: InputMaybe<Scalars['jsonb']['input']>;
  sessionVariables?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "external_requests" */
export type publicExternalRequestSelectColumn =
  /** column name */
  | 'action'
  /** column name */
  | 'id'
  /** column name */
  | 'input'
  /** column name */
  | 'sessionVariables'
  | '%future added value';

/** input type for updating data in table "external_requests" */
export type publicExternalRequestSetInput = {
  action?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  input?: InputMaybe<Scalars['jsonb']['input']>;
  sessionVariables?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "publicExternalRequest" */
export type publicExternalRequestStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: publicExternalRequestStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type publicExternalRequestStreamCursorValueInput = {
  action?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  input?: InputMaybe<Scalars['jsonb']['input']>;
  sessionVariables?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "external_requests" */
export type publicExternalRequestUpdateColumn =
  /** column name */
  | 'action'
  /** column name */
  | 'id'
  /** column name */
  | 'input'
  /** column name */
  | 'sessionVariables'
  | '%future added value';

export type publicExternalRequestUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<publicExternalRequestAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<publicExternalRequestDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<publicExternalRequestDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<publicExternalRequestDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<publicExternalRequestPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<publicExternalRequestSetInput>;
  /** filter the rows which have to be updated */
  where: publicExternalRequestBoolExp;
};

/** columns and relationships of "files" */
export type publicFile = {
  __typename?: 'publicFile';
  createdAt: Scalars['timestamptz']['output'];
  createdBy?: Maybe<Scalars['uuid']['output']>;
  filePath: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  key?: Maybe<Scalars['String']['output']>;
  /** An aggregate relationship */
  messageAttachmentsAggregate: MessagingMessageAttachmentAggregate;
  /** An array relationship */
  message_attachments: Array<MessagingMessageAttachment>;
  name?: Maybe<Scalars['String']['output']>;
  /** An aggregate relationship */
  organizationUserAttachmentsAggregate: organizationUserAttachmentsAggregate;
  /** An array relationship */
  organization_user_attachments: Array<organizationUserAttachments>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "files" */
export type publicFilemessageAttachmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MessagingMessageAttachmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingMessageAttachmentOrderBy>>;
  where?: InputMaybe<MessagingMessageAttachmentBoolExp>;
};


/** columns and relationships of "files" */
export type publicFilemessage_attachmentsArgs = {
  distinctOn?: InputMaybe<Array<MessagingMessageAttachmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingMessageAttachmentOrderBy>>;
  where?: InputMaybe<MessagingMessageAttachmentBoolExp>;
};


/** columns and relationships of "files" */
export type publicFileorganizationUserAttachmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<organizationUserAttachmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserAttachmentsOrderBy>>;
  where?: InputMaybe<organizationUserAttachmentsBoolExp>;
};


/** columns and relationships of "files" */
export type publicFileorganization_user_attachmentsArgs = {
  distinctOn?: InputMaybe<Array<organizationUserAttachmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserAttachmentsOrderBy>>;
  where?: InputMaybe<organizationUserAttachmentsBoolExp>;
};

/** aggregated selection of "files" */
export type publicFileAggregate = {
  __typename?: 'publicFileAggregate';
  aggregate?: Maybe<publicFileAggregateFields>;
  nodes: Array<publicFile>;
};

/** aggregate fields of "files" */
export type publicFileAggregateFields = {
  __typename?: 'publicFileAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<publicFileMaxFields>;
  min?: Maybe<publicFileMinFields>;
};


/** aggregate fields of "files" */
export type publicFileAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<publicFileSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "files". All fields are combined with a logical 'AND'. */
export type publicFileBoolExp = {
  _and?: InputMaybe<Array<publicFileBoolExp>>;
  _not?: InputMaybe<publicFileBoolExp>;
  _or?: InputMaybe<Array<publicFileBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdBy?: InputMaybe<UuidComparisonExp>;
  filePath?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  key?: InputMaybe<StringComparisonExp>;
  message_attachments?: InputMaybe<MessagingMessageAttachmentBoolExp>;
  message_attachmentsAggregate?: InputMaybe<MessagingMessageAttachmentAggregateBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  organization_user_attachments?: InputMaybe<organizationUserAttachmentsBoolExp>;
  organization_user_attachmentsAggregate?: InputMaybe<organizationUserAttachmentsAggregateBoolExp>;
  type?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "files" */
export type publicFileConstraint =
  /** unique or primary key constraint on columns "file_path" */
  | 'files_file_path_key'
  /** unique or primary key constraint on columns "id" */
  | 'files_pkey'
  | '%future added value';

/** input type for inserting data into table "files" */
export type publicFileInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  message_attachments?: InputMaybe<MessagingMessageAttachmentArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_user_attachments?: InputMaybe<organizationUserAttachmentsArrRelInsertInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type publicFileMaxFields = {
  __typename?: 'publicFileMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['uuid']['output']>;
  filePath?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type publicFileMinFields = {
  __typename?: 'publicFileMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['uuid']['output']>;
  filePath?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "files" */
export type publicFileMutationResponse = {
  __typename?: 'publicFileMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<publicFile>;
};

/** input type for inserting object relation for remote table "files" */
export type publicFileObjRelInsertInput = {
  data: publicFileInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<publicFileOnConflict>;
};

/** on_conflict condition type for table "files" */
export type publicFileOnConflict = {
  constraint: publicFileConstraint;
  updateColumns?: Array<publicFileUpdateColumn>;
  where?: InputMaybe<publicFileBoolExp>;
};

/** Ordering options when selecting data from "files". */
export type publicFileOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  filePath?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  key?: InputMaybe<OrderBy>;
  message_attachmentsAggregate?: InputMaybe<MessagingMessageAttachmentAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  organization_user_attachmentsAggregate?: InputMaybe<organizationUserAttachmentsAggregateOrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: files */
export type publicFilePkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "files" */
export type publicFileSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdBy'
  /** column name */
  | 'filePath'
  /** column name */
  | 'id'
  /** column name */
  | 'key'
  /** column name */
  | 'name'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "files" */
export type publicFileSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "publicFile" */
export type publicFileStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: publicFileStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type publicFileStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "files" */
export type publicFileUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdBy'
  /** column name */
  | 'filePath'
  /** column name */
  | 'id'
  /** column name */
  | 'key'
  /** column name */
  | 'name'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type publicFileUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<publicFileSetInput>;
  /** filter the rows which have to be updated */
  where: publicFileBoolExp;
};

/** columns and relationships of "notifications" */
export type publicNotification = {
  __typename?: 'publicNotification';
  callId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  destinationNumber: Scalars['String']['output'];
  direction: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organization?: Maybe<organization>;
  originatingNumber: Scalars['String']['output'];
  phoneroCustomerId?: Maybe<Scalars['Int']['output']>;
  state: Scalars['String']['output'];
  timestamp: Scalars['timestamp']['output'];
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "notifications" */
export type publicNotificationAggregate = {
  __typename?: 'publicNotificationAggregate';
  aggregate?: Maybe<publicNotificationAggregateFields>;
  nodes: Array<publicNotification>;
};

/** aggregate fields of "notifications" */
export type publicNotificationAggregateFields = {
  __typename?: 'publicNotificationAggregateFields';
  avg?: Maybe<publicNotificationAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<publicNotificationMaxFields>;
  min?: Maybe<publicNotificationMinFields>;
  stddev?: Maybe<publicNotificationStddevFields>;
  stddevPop?: Maybe<publicNotificationStddevPopFields>;
  stddevSamp?: Maybe<publicNotificationStddevSampFields>;
  sum?: Maybe<publicNotificationSumFields>;
  varPop?: Maybe<publicNotificationVarPopFields>;
  varSamp?: Maybe<publicNotificationVarSampFields>;
  variance?: Maybe<publicNotificationVarianceFields>;
};


/** aggregate fields of "notifications" */
export type publicNotificationAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<publicNotificationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type publicNotificationAvgFields = {
  __typename?: 'publicNotificationAvgFields';
  phoneroCustomerId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "notifications". All fields are combined with a logical 'AND'. */
export type publicNotificationBoolExp = {
  _and?: InputMaybe<Array<publicNotificationBoolExp>>;
  _not?: InputMaybe<publicNotificationBoolExp>;
  _or?: InputMaybe<Array<publicNotificationBoolExp>>;
  callId?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  destinationNumber?: InputMaybe<StringComparisonExp>;
  direction?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organization?: InputMaybe<organizationBoolExp>;
  originatingNumber?: InputMaybe<StringComparisonExp>;
  phoneroCustomerId?: InputMaybe<IntComparisonExp>;
  state?: InputMaybe<StringComparisonExp>;
  timestamp?: InputMaybe<TimestampComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "notifications" */
export type publicNotificationConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'notifications_id_key'
  /** unique or primary key constraint on columns "id" */
  | 'notifications_pkey'
  | '%future added value';

/** input type for incrementing numeric columns in table "notifications" */
export type publicNotificationIncInput = {
  phoneroCustomerId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "notifications" */
export type publicNotificationInsertInput = {
  callId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  destinationNumber?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization?: InputMaybe<organizationObjRelInsertInput>;
  originatingNumber?: InputMaybe<Scalars['String']['input']>;
  phoneroCustomerId?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['timestamp']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type publicNotificationMaxFields = {
  __typename?: 'publicNotificationMaxFields';
  callId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  destinationNumber?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  originatingNumber?: Maybe<Scalars['String']['output']>;
  phoneroCustomerId?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['timestamp']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type publicNotificationMinFields = {
  __typename?: 'publicNotificationMinFields';
  callId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  destinationNumber?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  originatingNumber?: Maybe<Scalars['String']['output']>;
  phoneroCustomerId?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['timestamp']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "notifications" */
export type publicNotificationMutationResponse = {
  __typename?: 'publicNotificationMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<publicNotification>;
};

/** on_conflict condition type for table "notifications" */
export type publicNotificationOnConflict = {
  constraint: publicNotificationConstraint;
  updateColumns?: Array<publicNotificationUpdateColumn>;
  where?: InputMaybe<publicNotificationBoolExp>;
};

/** Ordering options when selecting data from "notifications". */
export type publicNotificationOrderBy = {
  callId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  destinationNumber?: InputMaybe<OrderBy>;
  direction?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organization?: InputMaybe<organizationOrderBy>;
  originatingNumber?: InputMaybe<OrderBy>;
  phoneroCustomerId?: InputMaybe<OrderBy>;
  state?: InputMaybe<OrderBy>;
  timestamp?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: notifications */
export type publicNotificationPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "notifications" */
export type publicNotificationSelectColumn =
  /** column name */
  | 'callId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'destinationNumber'
  /** column name */
  | 'direction'
  /** column name */
  | 'id'
  /** column name */
  | 'originatingNumber'
  /** column name */
  | 'phoneroCustomerId'
  /** column name */
  | 'state'
  /** column name */
  | 'timestamp'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "notifications" */
export type publicNotificationSetInput = {
  callId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  destinationNumber?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  originatingNumber?: InputMaybe<Scalars['String']['input']>;
  phoneroCustomerId?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['timestamp']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type publicNotificationStddevFields = {
  __typename?: 'publicNotificationStddevFields';
  phoneroCustomerId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type publicNotificationStddevPopFields = {
  __typename?: 'publicNotificationStddevPopFields';
  phoneroCustomerId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type publicNotificationStddevSampFields = {
  __typename?: 'publicNotificationStddevSampFields';
  phoneroCustomerId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "publicNotification" */
export type publicNotificationStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: publicNotificationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type publicNotificationStreamCursorValueInput = {
  callId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  destinationNumber?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  originatingNumber?: InputMaybe<Scalars['String']['input']>;
  phoneroCustomerId?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['timestamp']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type publicNotificationSumFields = {
  __typename?: 'publicNotificationSumFields';
  phoneroCustomerId?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "notifications" */
export type publicNotificationUpdateColumn =
  /** column name */
  | 'callId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'destinationNumber'
  /** column name */
  | 'direction'
  /** column name */
  | 'id'
  /** column name */
  | 'originatingNumber'
  /** column name */
  | 'phoneroCustomerId'
  /** column name */
  | 'state'
  /** column name */
  | 'timestamp'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type publicNotificationUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<publicNotificationIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<publicNotificationSetInput>;
  /** filter the rows which have to be updated */
  where: publicNotificationBoolExp;
};

/** aggregate varPop on columns */
export type publicNotificationVarPopFields = {
  __typename?: 'publicNotificationVarPopFields';
  phoneroCustomerId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type publicNotificationVarSampFields = {
  __typename?: 'publicNotificationVarSampFields';
  phoneroCustomerId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type publicNotificationVarianceFields = {
  __typename?: 'publicNotificationVarianceFields';
  phoneroCustomerId?: Maybe<Scalars['Float']['output']>;
};

export type query_root = {
  __typename?: 'query_root';
  /** fetch data from the table: "business.direction" */
  ActivityDirection: Array<ActivityDirection>;
  /** fetch aggregated fields from the table: "business.direction" */
  ActivityDirectionAggregate: ActivityDirectionAggregate;
  /** fetch data from the table: "business.direction" using primary key columns */
  ActivityDirectionByPk?: Maybe<ActivityDirection>;
  /** fetch data from the table: "business.provider" */
  ActivityProvider: Array<ActivityProvider>;
  /** fetch aggregated fields from the table: "business.provider" */
  ActivityProviderAggregate: ActivityProviderAggregate;
  /** fetch data from the table: "business.provider" using primary key columns */
  ActivityProviderByPk?: Maybe<ActivityProvider>;
  /** fetch data from the table: "business.queue_item_flexibility_type" */
  QueueItemFlexibilityType: Array<QueueItemFlexibilityType>;
  /** fetch aggregated fields from the table: "business.queue_item_flexibility_type" */
  QueueItemFlexibilityTypeAggregate: QueueItemFlexibilityTypeAggregate;
  /** fetch data from the table: "business.queue_item_flexibility_type" using primary key columns */
  QueueItemFlexibilityTypeByPk?: Maybe<QueueItemFlexibilityType>;
  /** fetch data from the table: "business.queue_item_participant_responsibiliy_type" */
  QueueItemParticipantResponsibilityType: Array<QueueItemParticipantResponsibilityType>;
  /** fetch aggregated fields from the table: "business.queue_item_participant_responsibiliy_type" */
  QueueItemParticipantResponsibilityTypeAggregate: QueueItemParticipantResponsibilityTypeAggregate;
  /** fetch data from the table: "business.queue_item_participant_responsibiliy_type" using primary key columns */
  QueueItemParticipantResponsibilityTypeByPk?: Maybe<QueueItemParticipantResponsibilityType>;
  /** fetch data from the table: "business.relation_type" */
  RelationType: Array<RelationType>;
  /** fetch aggregated fields from the table: "business.relation_type" */
  RelationTypeAggregate: RelationTypeAggregate;
  /** fetch data from the table: "business.relation_type" using primary key columns */
  RelationTypeByPk?: Maybe<RelationType>;
  /** fetch data from the table: "business.queue_item_participant" using primary key columns */
  activityParticipant?: Maybe<activityParticipant>;
  /** fetch data from the table: "business.queue_item_participant" */
  activityParticipants: Array<activityParticipant>;
  /** fetch aggregated fields from the table: "business.queue_item_participant" */
  activityParticipantsAggregate: activityParticipantAggregate;
  /** fetch data from the table: "business.activity_status" using primary key columns */
  activityStatus?: Maybe<ActivityStatus>;
  /** fetch data from the table: "business.activity_status" */
  activityStatuses: Array<ActivityStatus>;
  /** fetch aggregated fields from the table: "business.activity_status" */
  activityStatusesAggregate: ActivityStatusAggregate;
  /** fetch data from the table: "business.activity_type" using primary key columns */
  activityType?: Maybe<ActivityType>;
  /** fetch data from the table: "business.activity_type" */
  activityTypes: Array<ActivityType>;
  /** fetch aggregated fields from the table: "business.activity_type" */
  activityTypesAggregate: ActivityTypeAggregate;
  /** fetch data from the table: "business.address" using primary key columns */
  address?: Maybe<address>;
  /** An array relationship */
  addresses: Array<address>;
  /** An aggregate relationship */
  addressesAggregate: addressAggregate;
  /** fetch aggregated fields from the table: "business.user_contacts" */
  aggregateBusinessUserContacts: businessUserContactsAggregate;
  /** fetch aggregated fields from the table: "business.user_settings" */
  aggregateBusinessUserSettings: businessUserSettingsAggregate;
  /** fetch aggregated fields from the table: "messaging.activity" */
  aggregateMessagingActivities: messagingActivityAggregate;
  /** fetch aggregated fields from the table: "messaging.activity_type" */
  aggregateMessagingActivityTypes: messagingActivityTypeAggregate;
  /** fetch aggregated fields from the table: "messaging.activity_user" */
  aggregateMessagingActivityUsers: messagingActivityUserAggregate;
  /** fetch aggregated fields from the table: "messaging.message_emoji" */
  aggregateMessagingMessageEmojis: messagingMessageEmojiAggregate;
  /** fetch aggregated fields from the table: "messaging.message_read" */
  aggregateMessagingMessageReads: messagingMessageReadAggregate;
  /** fetch aggregated fields from the table: "messaging.message_type" */
  aggregateMessagingMessageTypes: messagingMessageTypeAggregate;
  /** fetch aggregated fields from the table: "messaging.message" */
  aggregateMessagingMessages: messagingMessageAggregate;
  /** fetch aggregated fields from the table: "business.authorization_enum_group" */
  aggregateOrganizationAuthorizationEnumGroups: organizationAuthorizationEnumGroupAggregate;
  /** fetch aggregated fields from the table: "business.authorization_group" */
  aggregateOrganizationAuthorizationGroups: organizationAuthorizationGroupAggregate;
  /** fetch aggregated fields from the table: "business.organization_relationship_category" */
  aggregateOrganizationOrganizationRelationshipCategories: organizationOrganizationRelationshipCategoryAggregate;
  /** fetch aggregated fields from the table: "business.organization_relationship" */
  aggregateOrganizationOrganizationRelationships: organizationOrganizationRelationshipAggregate;
  /** fetch aggregated fields from the table: "business.organization_user_authorization" */
  aggregateOrganizationOrganizationUserAuthorizations: organizationOrganizationUserAuthorizationAggregate;
  /** fetch aggregated fields from the table: "business.organization_user__organizations_view" */
  aggregateOrganizationOrganizationUserOrganizationsViews: organizationOrganizationUserOrganizationsViewAggregate;
  /** fetch aggregated fields from the table: "business.organization_user__users_view" */
  aggregateOrganizationOrganizationUserUsersViews: organizationOrganizationUserUsersViewAggregate;
  /** fetch aggregated fields from the table: "business.user_authorization" */
  aggregateOrganizationUserAuthorizations: organizationUserAuthorizationAggregate;
  /** fetch aggregated fields from the table: "devices" */
  aggregatePublicDevices: publicDeviceAggregate;
  /** fetch aggregated fields from the table: "external_requests" */
  aggregatePublicExternalRequests: publicExternalRequestAggregate;
  /** fetch aggregated fields from the table: "files" */
  aggregatePublicFiles: publicFileAggregate;
  /** fetch aggregated fields from the table: "notifications" */
  aggregatePublicNotifications: publicNotificationAggregate;
  /** fetch aggregated fields from the table: "sms.connectors" */
  aggregateSmsConnectors: smsConnectorAggregate;
  /** fetch aggregated fields from the table: "sms.gates" */
  aggregateSmsGates: smsGateAggregate;
  /** fetch aggregated fields from the table: "sms.link_mobility_sms_content" */
  aggregateSmsLinkMobilitySmsContents: smsLinkMobilitySmsContentAggregate;
  /** fetch aggregated fields from the table: "sms.link_mobility_sms_message" */
  aggregateSmsLinkMobilitySmsMessages: smsLinkMobilitySmsMessageAggregate;
  /** fetch aggregated fields from the table: "sms.link_mobility_sms_route" */
  aggregateSmsLinkMobilitySmsRoutes: smsLinkMobilitySmsRouteAggregate;
  /** fetch aggregated fields from the table: "sms.providers" */
  aggregateSmsProviders: smsProviderAggregate;
  /** fetch aggregated fields from the table: "sms.sms" */
  aggregateSmsSms: smsSmAggregate;
  /** fetch aggregated fields from the table: "sms.sms_external_incoming_link_mobility" */
  aggregateSmsSmsExternalIncomingLinkMobilities: smsSmsExternalIncomingLinkMobilityAggregate;
  /** fetch aggregated fields from the table: "validation.validation" */
  aggregateValidationValidations: validationValidationAggregate;
  /** fetch data from the table: "business.blocked_domain_user" using primary key columns */
  blockedDomainUser?: Maybe<blockedDomainUser>;
  /** fetch data from the table: "business.blocked_domain_user" */
  blockedDomainUsers: Array<blockedDomainUser>;
  /** fetch aggregated fields from the table: "business.blocked_domain_user" */
  blockedDomainUsersAggregate: blockedDomainUserAggregate;
  breg?: Maybe<bregquery_root>;
  /** fetch data from the table: "business.domain_activity_type" */
  businessDomainActivityType: Array<BusinessDomainActivityType>;
  /** fetch aggregated fields from the table: "business.domain_activity_type" */
  businessDomainActivityTypeAggregate: BusinessDomainActivityTypeAggregate;
  /** fetch data from the table: "business.domain_activity_type" using primary key columns */
  businessDomainActivityTypeByPk?: Maybe<BusinessDomainActivityType>;
  /** fetch data from the table: "business.feed_type" */
  businessFeedType: Array<BusinessFeedType>;
  /** fetch aggregated fields from the table: "business.feed_type" */
  businessFeedTypeAggregate: BusinessFeedTypeAggregate;
  /** fetch data from the table: "business.feed_type" using primary key columns */
  businessFeedTypeByPk?: Maybe<BusinessFeedType>;
  /** fetch data from the table: "business.message_attachments" */
  businessMessageAttachments: Array<BusinessMessageAttachments>;
  /** fetch aggregated fields from the table: "business.message_attachments" */
  businessMessageAttachmentsAggregate: BusinessMessageAttachmentsAggregate;
  /** fetch data from the table: "business.message_attachments" using primary key columns */
  businessMessageAttachmentsByPk?: Maybe<BusinessMessageAttachments>;
  /** fetch data from the table: "business.organization_user_callback_answer" */
  businessOrganizationUserCallbackAnswer: Array<BusinessOrganizationUserCallbackAnswer>;
  /** fetch aggregated fields from the table: "business.organization_user_callback_answer" */
  businessOrganizationUserCallbackAnswerAggregate: BusinessOrganizationUserCallbackAnswerAggregate;
  /** fetch data from the table: "business.organization_user_callback_answer" using primary key columns */
  businessOrganizationUserCallbackAnswerByPk?: Maybe<BusinessOrganizationUserCallbackAnswer>;
  /** fetch data from the table: "business.organization_user_email" */
  businessOrganizationUserEmail: Array<BusinessOrganizationUserEmail>;
  /** fetch aggregated fields from the table: "business.organization_user_email" */
  businessOrganizationUserEmailAggregate: BusinessOrganizationUserEmailAggregate;
  /** fetch data from the table: "business.organization_user_email" using primary key columns */
  businessOrganizationUserEmailByPk?: Maybe<BusinessOrganizationUserEmail>;
  /** fetch data from the table: "business.organization_user_email_type" */
  businessOrganizationUserEmailType: Array<BusinessOrganizationUserEmailType>;
  /** fetch aggregated fields from the table: "business.organization_user_email_type" */
  businessOrganizationUserEmailTypeAggregate: BusinessOrganizationUserEmailTypeAggregate;
  /** fetch data from the table: "business.organization_user_email_type" using primary key columns */
  businessOrganizationUserEmailTypeByPk?: Maybe<BusinessOrganizationUserEmailType>;
  /** fetch aggregated fields from the table: "business.organization_user_request" */
  businessOrganizationUserRequestAggregate: BusinessOrganizationUserRequestAggregate;
  /** fetch data from the table: "business.organization_user_request_type" */
  businessOrganizationUserRequestType: Array<BusinessOrganizationUserRequestType>;
  /** fetch aggregated fields from the table: "business.organization_user_request_type" */
  businessOrganizationUserRequestTypeAggregate: BusinessOrganizationUserRequestTypeAggregate;
  /** fetch data from the table: "business.organization_user_request_type" using primary key columns */
  businessOrganizationUserRequestTypeByPk?: Maybe<BusinessOrganizationUserRequestType>;
  /** fetch data from the table: "business.organization_user_suggestion_type" */
  businessOrganizationUserSuggestionType: Array<BusinessOrganizationUserSuggestionType>;
  /** fetch aggregated fields from the table: "business.organization_user_suggestion_type" */
  businessOrganizationUserSuggestionTypeAggregate: BusinessOrganizationUserSuggestionTypeAggregate;
  /** fetch data from the table: "business.organization_user_suggestion_type" using primary key columns */
  businessOrganizationUserSuggestionTypeByPk?: Maybe<BusinessOrganizationUserSuggestionType>;
  /** fetch data from the table: "business.organization_user_suggestions" */
  businessOrganizationUserSuggestions: Array<BusinessOrganizationUserSuggestions>;
  /** fetch aggregated fields from the table: "business.organization_user_suggestions" */
  businessOrganizationUserSuggestionsAggregate: BusinessOrganizationUserSuggestionsAggregate;
  /** fetch data from the table: "business.organization_user_suggestions" using primary key columns */
  businessOrganizationUserSuggestionsByPk?: Maybe<BusinessOrganizationUserSuggestions>;
  /** fetch data from the table: "business.organization_user_url_address" */
  businessOrganizationUserUrlAddress: Array<BusinessOrganizationUserUrlAddress>;
  /** fetch aggregated fields from the table: "business.organization_user_url_address" */
  businessOrganizationUserUrlAddressAggregate: BusinessOrganizationUserUrlAddressAggregate;
  /** fetch data from the table: "business.organization_user_url_address" using primary key columns */
  businessOrganizationUserUrlAddressByPk?: Maybe<BusinessOrganizationUserUrlAddress>;
  /** fetch data from the table: "business.organization_user_url_address_type" */
  businessOrganizationUserUrlAddressType: Array<BusinessOrganizationUserUrlAddressType>;
  /** fetch aggregated fields from the table: "business.organization_user_url_address_type" */
  businessOrganizationUserUrlAddressTypeAggregate: BusinessOrganizationUserUrlAddressTypeAggregate;
  /** fetch data from the table: "business.organization_user_url_address_type" using primary key columns */
  businessOrganizationUserUrlAddressTypeByPk?: Maybe<BusinessOrganizationUserUrlAddressType>;
  /** fetch data from the table: "business.queue_item_alarm_type" */
  businessQueueItemAlarmType: Array<BusinessQueueItemAlarmType>;
  /** fetch aggregated fields from the table: "business.queue_item_alarm_type" */
  businessQueueItemAlarmTypeAggregate: BusinessQueueItemAlarmTypeAggregate;
  /** fetch data from the table: "business.queue_item_alarm_type" using primary key columns */
  businessQueueItemAlarmTypeByPk?: Maybe<BusinessQueueItemAlarmType>;
  /** fetch data from the table: "business.queue_item_alarms" */
  businessQueueItemAlarms: Array<BusinessQueueItemAlarms>;
  /** fetch aggregated fields from the table: "business.queue_item_alarms" */
  businessQueueItemAlarmsAggregate: BusinessQueueItemAlarmsAggregate;
  /** fetch data from the table: "business.queue_item_alarms" using primary key columns */
  businessQueueItemAlarmsByPk?: Maybe<BusinessQueueItemAlarms>;
  /** fetch data from the table: "business.queue_item_collaboration" using primary key columns */
  businessQueueItemCollaboration?: Maybe<businessQueueItemCollaboration>;
  /** fetch aggregated fields from the table: "business.queue_item_collaboration" */
  businessQueueItemCollaborationAggregate: businessQueueItemCollaborationAggregate;
  /** fetch data from the table: "business.queue_item_collaboration" */
  businessQueueItemCollaborations: Array<businessQueueItemCollaboration>;
  /** fetch data from the table: "business.queue_item_domain_users_view" */
  businessQueueItemDomainUsersView: Array<BusinessQueueItemDomainUsersView>;
  /** fetch aggregated fields from the table: "business.queue_item_domain_users_view" */
  businessQueueItemDomainUsersViewAggregate: BusinessQueueItemDomainUsersViewAggregate;
  /** fetch data from the table: "business.queue_item_organization_users_view" */
  businessQueueItemOrganizationUsersView: Array<BusinessQueueItemOrganizationUsersView>;
  /** fetch aggregated fields from the table: "business.queue_item_organization_users_view" */
  businessQueueItemOrganizationUsersViewAggregate: BusinessQueueItemOrganizationUsersViewAggregate;
  /** fetch data from the table: "business.queue_item_participant_channel_type" */
  businessQueueItemParticipantChannelType: Array<BusinessQueueItemParticipantChannelType>;
  /** fetch aggregated fields from the table: "business.queue_item_participant_channel_type" */
  businessQueueItemParticipantChannelTypeAggregate: BusinessQueueItemParticipantChannelTypeAggregate;
  /** fetch data from the table: "business.queue_item_participant_channel_type" using primary key columns */
  businessQueueItemParticipantChannelTypeByPk?: Maybe<BusinessQueueItemParticipantChannelType>;
  /** fetch data from the table: "business.queue_item_participants_view" */
  businessQueueItemParticipantsView: Array<BusinessQueueItemParticipantsView>;
  /** fetch aggregated fields from the table: "business.queue_item_participants_view" */
  businessQueueItemParticipantsViewAggregate: BusinessQueueItemParticipantsViewAggregate;
  /** fetch data from the table: "business.queue_item_sub_type" */
  businessQueueItemSubType: Array<BusinessQueueItemSubType>;
  /** fetch aggregated fields from the table: "business.queue_item_sub_type" */
  businessQueueItemSubTypeAggregate: BusinessQueueItemSubTypeAggregate;
  /** fetch data from the table: "business.queue_item_sub_type" using primary key columns */
  businessQueueItemSubTypeByPk?: Maybe<BusinessQueueItemSubType>;
  /** fetch data from the table: "business.user_contacts" using primary key columns */
  businessUserContact?: Maybe<businessUserContacts>;
  /** fetch data from the table: "business.user_contact_numbers" */
  businessUserContactNumbers: Array<BusinessUserContactNumbers>;
  /** fetch aggregated fields from the table: "business.user_contact_numbers" */
  businessUserContactNumbersAggregate: BusinessUserContactNumbersAggregate;
  /** fetch data from the table: "business.user_contact_numbers" using primary key columns */
  businessUserContactNumbersByPk?: Maybe<BusinessUserContactNumbers>;
  /** fetch data from the table: "business.user_contacts" */
  businessUserContacts: Array<businessUserContacts>;
  /** fetch data from the table: "business.user_feed" */
  businessUserFeed: Array<BusinessUserFeed>;
  /** fetch aggregated fields from the table: "business.user_feed" */
  businessUserFeedAggregate: BusinessUserFeedAggregate;
  /** fetch data from the table: "business.user_feed" using primary key columns */
  businessUserFeedByPk?: Maybe<BusinessUserFeed>;
  /** fetch data from the table: "business.user_request_status" */
  businessUserRequestStatus: Array<BusinessUserRequestStatus>;
  /** fetch aggregated fields from the table: "business.user_request_status" */
  businessUserRequestStatusAggregate: BusinessUserRequestStatusAggregate;
  /** fetch data from the table: "business.user_request_status" using primary key columns */
  businessUserRequestStatusByPk?: Maybe<BusinessUserRequestStatus>;
  /** fetch data from the table: "business.user_settings" using primary key columns */
  businessUserSetting?: Maybe<businessUserSettings>;
  /** fetch data from the table: "business.user_settings" */
  businessUserSettings: Array<businessUserSettings>;
  /** fetch data from the table: "business.user_states" */
  businessUserStates: Array<BusinessUserStates>;
  /** fetch aggregated fields from the table: "business.user_states" */
  businessUserStatesAggregate: BusinessUserStatesAggregate;
  /** fetch data from the table: "business.user_states" using primary key columns */
  businessUserStatesByPk?: Maybe<BusinessUserStates>;
  /** fetch data from the table: "crm.context" */
  crmContext: Array<CrmContext>;
  /** fetch aggregated fields from the table: "crm.context" */
  crmContextAggregate: CrmContextAggregate;
  /** fetch data from the table: "crm.context" using primary key columns */
  crmContextByPk?: Maybe<CrmContext>;
  /** fetch data from the table: "crm.context_type" */
  crmContextType: Array<CrmContextType>;
  /** fetch aggregated fields from the table: "crm.context_type" */
  crmContextTypeAggregate: CrmContextTypeAggregate;
  /** fetch data from the table: "crm.context_type" using primary key columns */
  crmContextTypeByPk?: Maybe<CrmContextType>;
  /** fetch data from the table: "crm.creator_type" */
  crmCreatorType: Array<CrmCreatorType>;
  /** fetch aggregated fields from the table: "crm.creator_type" */
  crmCreatorTypeAggregate: CrmCreatorTypeAggregate;
  /** fetch data from the table: "crm.creator_type" using primary key columns */
  crmCreatorTypeByPk?: Maybe<CrmCreatorType>;
  /** fetch data from the table: "crm.crm_type" */
  crmCrmType: Array<CrmCrmType>;
  /** fetch aggregated fields from the table: "crm.crm_type" */
  crmCrmTypeAggregate: CrmCrmTypeAggregate;
  /** fetch data from the table: "crm.crm_type" using primary key columns */
  crmCrmTypeByPk?: Maybe<CrmCrmType>;
  /** fetch data from the table: "crm.direction_type" */
  crmDirectionType: Array<CrmDirectionType>;
  /** fetch aggregated fields from the table: "crm.direction_type" */
  crmDirectionTypeAggregate: CrmDirectionTypeAggregate;
  /** fetch data from the table: "crm.direction_type" using primary key columns */
  crmDirectionTypeByPk?: Maybe<CrmDirectionType>;
  /** fetch data from the table: "crm.entity" */
  crmEntity: Array<CrmEntity>;
  /** fetch aggregated fields from the table: "crm.entity" */
  crmEntityAggregate: CrmEntityAggregate;
  /** fetch data from the table: "crm.entity" using primary key columns */
  crmEntityByPk?: Maybe<CrmEntity>;
  /** fetch data from the table: "crm.event" */
  crmEvent: Array<CrmEvent>;
  /** fetch aggregated fields from the table: "crm.event" */
  crmEventAggregate: CrmEventAggregate;
  /** fetch data from the table: "crm.event" using primary key columns */
  crmEventByPk?: Maybe<CrmEvent>;
  /** fetch data from the table: "crm.event_type" */
  crmEventType: Array<CrmEventType>;
  /** fetch aggregated fields from the table: "crm.event_type" */
  crmEventTypeAggregate: CrmEventTypeAggregate;
  /** fetch data from the table: "crm.event_type" using primary key columns */
  crmEventTypeByPk?: Maybe<CrmEventType>;
  /** fetch data from the table: "crm.status_code" */
  crmStatusCode: Array<CrmStatusCode>;
  /** fetch aggregated fields from the table: "crm.status_code" */
  crmStatusCodeAggregate: CrmStatusCodeAggregate;
  /** fetch data from the table: "crm.status_code" using primary key columns */
  crmStatusCodeByPk?: Maybe<CrmStatusCode>;
  /** fetch aggregated fields from the table: "crm.status_message" */
  crmStatusMessageAggregate: crmStatusMessageAggregate;
  /** fetch data from the table: "crm.status_message" using primary key columns */
  crmStatusMessageByPk?: Maybe<crmStatusMessage>;
  /** fetch data from the table: "crm.status_message" */
  crmStatusMessages: Array<crmStatusMessage>;
  /** fetch data from the table: "crm.system_type" */
  crmSystemType: Array<CrmSystemType>;
  /** fetch aggregated fields from the table: "crm.system_type" */
  crmSystemTypeAggregate: CrmSystemTypeAggregate;
  /** fetch data from the table: "crm.system_type" using primary key columns */
  crmSystemTypeByPk?: Maybe<CrmSystemType>;
  /** fetch data from the table: "crm.trace_context" */
  crmTraceContext: Array<CrmTraceContext>;
  /** fetch aggregated fields from the table: "crm.trace_context" */
  crmTraceContextAggregate: CrmTraceContextAggregate;
  /** fetch data from the table: "crm.trace_context" using primary key columns */
  crmTraceContextByPk?: Maybe<CrmTraceContext>;
  /** fetch data from the table: "crm.unified_entity_type" */
  crmUnifiedEntityType: Array<CrmUnifiedEntityType>;
  /** fetch aggregated fields from the table: "crm.unified_entity_type" */
  crmUnifiedEntityTypeAggregate: CrmUnifiedEntityTypeAggregate;
  /** fetch data from the table: "crm.unified_entity_type" using primary key columns */
  crmUnifiedEntityTypeByPk?: Maybe<CrmUnifiedEntityType>;
  /** fetch data from the table: "crm.youtello_catalyst_id_mapping" using primary key columns */
  crmYoutelloCatalystIdMapping?: Maybe<crmYoutelloCatalystIdMapping>;
  /** fetch aggregated fields from the table: "crm.youtello_catalyst_id_mapping" */
  crmYoutelloCatalystIdMappingAggregate: crmYoutelloCatalystIdMappingAggregate;
  /** fetch data from the table: "crm.youtello_catalyst_id_mapping" */
  crmYoutelloCatalystIdMappings: Array<crmYoutelloCatalystIdMapping>;
  /** An array relationship */
  domainActivities: Array<domainActivity>;
  /** An aggregate relationship */
  domainActivitiesAggregate: domainActivityAggregate;
  /** fetch data from the table: "business.domain_activity" using primary key columns */
  domainActivity?: Maybe<domainActivity>;
  /** fetch data from the table: "business.domain_organization" using primary key columns */
  domainOrganization?: Maybe<domainOrganization>;
  /** An array relationship */
  domainOrganizations: Array<domainOrganization>;
  /** An aggregate relationship */
  domainOrganizationsAggregate: domainOrganizationAggregate;
  /** fetch data from the table: "business.domain_participant" using primary key columns */
  domainParticipant?: Maybe<domainParticipant>;
  /** An array relationship */
  domainParticipants: Array<domainParticipant>;
  /** An aggregate relationship */
  domainParticipantsAggregate: domainParticipantAggregate;
  /** fetch data from the table: "business.domain_type" using primary key columns */
  domainType?: Maybe<domainType>;
  /** fetch data from the table: "business.domain_type" */
  domainTypes: Array<domainType>;
  /** fetch aggregated fields from the table: "business.domain_type" */
  domainTypesAggregate: domainTypeAggregate;
  /** fetch data from the table: "business.domain_user" using primary key columns */
  domainUser?: Maybe<domainUser>;
  /** fetch data from the table: "business.domain_user_category" */
  domainUserCategories: Array<domainUserCategory>;
  /** fetch aggregated fields from the table: "business.domain_user_category" */
  domainUserCategoriesAggregate: domainUserCategoryAggregate;
  /** fetch data from the table: "business.domain_user_category" using primary key columns */
  domainUserCategory?: Maybe<domainUserCategory>;
  /** An array relationship */
  domainUsers: Array<domainUser>;
  /** An aggregate relationship */
  domainUsersAggregate: domainUserAggregate;
  emailing?: Maybe<emailingquery_root>;
  geodata?: Maybe<geodataquery_root>;
  getDashboardData?: Maybe<dashboardDataOutput>;
  /** getEmailAccount */
  getEmailAccount?: Maybe<Array<Maybe<getEmailAccountOutput>>>;
  getOrganization?: Maybe<OrganizationOutput>;
  getOrganizations?: Maybe<OrganizationsOutput>;
  /** getUser */
  getUser?: Maybe<organizationUserOutput>;
  incomingSms?: Maybe<incomingSms>;
  /** isPhoneUser */
  isPhoneUser?: Maybe<phoneUserOutput>;
  /** fetch data from the table: "business.languages" using primary key columns */
  language?: Maybe<languages>;
  /** fetch aggregated fields from the table: "business.languages" */
  languageAggregate: languagesAggregate;
  /** fetch data from the table: "business.languages" */
  languages: Array<languages>;
  lookupPhoneNumber?: Maybe<LookupPhoneNumberOutput>;
  /** fetch data from the table: "business.message" using primary key columns */
  message?: Maybe<message>;
  /** fetch data from the table: "business.message_type" using primary key columns */
  messageType?: Maybe<messageType>;
  /** fetch data from the table: "business.message_type" */
  messageTypes: Array<messageType>;
  /** fetch aggregated fields from the table: "business.message_type" */
  messageTypesAggregate: messageTypeAggregate;
  /** An array relationship */
  messages: Array<message>;
  /** An aggregate relationship */
  messagesAggregate: messageAggregate;
  /** fetch data from the table: "messaging.activity" */
  messagingActivities: Array<messagingActivity>;
  /** fetch data from the table: "messaging.activity" using primary key columns */
  messagingActivity?: Maybe<messagingActivity>;
  /** fetch data from the table: "messaging.activity_organization" using primary key columns */
  messagingActivityOrganization?: Maybe<messagingActivityOrganization>;
  /** fetch aggregated fields from the table: "messaging.activity_organization" */
  messagingActivityOrganizationAggregate: messagingActivityOrganizationAggregate;
  /** fetch data from the table: "messaging.activity_organization" */
  messagingActivityOrganizations: Array<messagingActivityOrganization>;
  /** fetch data from the table: "messaging.activitySettings" */
  messagingActivitySettings: Array<MessagingActivitySettings>;
  /** fetch aggregated fields from the table: "messaging.activitySettings" */
  messagingActivitySettingsAggregate: MessagingActivitySettingsAggregate;
  /** fetch data from the table: "messaging.activitySettings" using primary key columns */
  messagingActivitySettingsByPk?: Maybe<MessagingActivitySettings>;
  /** fetch data from the table: "messaging.activitySettingsNotificationSettingType" */
  messagingActivitySettingsNotificationSettingType: Array<MessagingActivitySettingsNotificationSettingType>;
  /** fetch aggregated fields from the table: "messaging.activitySettingsNotificationSettingType" */
  messagingActivitySettingsNotificationSettingTypeAggregate: MessagingActivitySettingsNotificationSettingTypeAggregate;
  /** fetch data from the table: "messaging.activitySettingsNotificationSettingType" using primary key columns */
  messagingActivitySettingsNotificationSettingTypeByPk?: Maybe<MessagingActivitySettingsNotificationSettingType>;
  /** fetch data from the table: "messaging.activity_type" using primary key columns */
  messagingActivityType?: Maybe<messagingActivityType>;
  /** fetch data from the table: "messaging.activity_type" */
  messagingActivityTypes: Array<messagingActivityType>;
  /** fetch data from the table: "messaging.activity_user" using primary key columns */
  messagingActivityUser?: Maybe<messagingActivityUser>;
  /** fetch data from the table: "messaging.activity_user" */
  messagingActivityUsers: Array<messagingActivityUser>;
  /** fetch data from the table: "messaging.invitation" */
  messagingInvitation: Array<MessagingInvitation>;
  /** fetch aggregated fields from the table: "messaging.invitation" */
  messagingInvitationAggregate: MessagingInvitationAggregate;
  /** fetch data from the table: "messaging.invitation" using primary key columns */
  messagingInvitationByPk?: Maybe<MessagingInvitation>;
  /** fetch data from the table: "messaging.mentions" */
  messagingMentions: Array<MessagingMentions>;
  /** fetch aggregated fields from the table: "messaging.mentions" */
  messagingMentionsAggregate: MessagingMentionsAggregate;
  /** fetch data from the table: "messaging.mentions" using primary key columns */
  messagingMentionsByPk?: Maybe<MessagingMentions>;
  /** fetch data from the table: "messaging.message" using primary key columns */
  messagingMessage?: Maybe<messagingMessage>;
  /** fetch data from the table: "messaging.message_attachment" */
  messagingMessageAttachment: Array<MessagingMessageAttachment>;
  /** fetch aggregated fields from the table: "messaging.message_attachment" */
  messagingMessageAttachmentAggregate: MessagingMessageAttachmentAggregate;
  /** fetch data from the table: "messaging.message_attachment" using primary key columns */
  messagingMessageAttachmentByPk?: Maybe<MessagingMessageAttachment>;
  /** fetch data from the table: "messaging.message_attachment_type" */
  messagingMessageAttachmentType: Array<MessagingMessageAttachmentType>;
  /** fetch aggregated fields from the table: "messaging.message_attachment_type" */
  messagingMessageAttachmentTypeAggregate: MessagingMessageAttachmentTypeAggregate;
  /** fetch data from the table: "messaging.message_attachment_type" using primary key columns */
  messagingMessageAttachmentTypeByPk?: Maybe<MessagingMessageAttachmentType>;
  /** fetch data from the table: "messaging.message_emoji" using primary key columns */
  messagingMessageEmoji?: Maybe<messagingMessageEmoji>;
  /** fetch data from the table: "messaging.message_emoji" */
  messagingMessageEmojis: Array<messagingMessageEmoji>;
  /** fetch data from the table: "messaging.message_priority" */
  messagingMessagePriority: Array<MessagingMessagePriority>;
  /** fetch aggregated fields from the table: "messaging.message_priority" */
  messagingMessagePriorityAggregate: MessagingMessagePriorityAggregate;
  /** fetch data from the table: "messaging.message_priority" using primary key columns */
  messagingMessagePriorityByPk?: Maybe<MessagingMessagePriority>;
  /** fetch data from the table: "messaging.message_read" using primary key columns */
  messagingMessageRead?: Maybe<messagingMessageRead>;
  /** fetch data from the table: "messaging.message_read" */
  messagingMessageReads: Array<messagingMessageRead>;
  /** fetch data from the table: "messaging.message_type" using primary key columns */
  messagingMessageType?: Maybe<messagingMessageType>;
  /** fetch data from the table: "messaging.message_type" */
  messagingMessageTypes: Array<messagingMessageType>;
  /** fetch data from the table: "messaging.message" */
  messagingMessages: Array<messagingMessage>;
  /** fetch data from the table: "notification.notifications" using primary key columns */
  notification?: Maybe<notification>;
  /** fetch data from the table: "notification.notification_device_sent" */
  notificationNotificationDeviceSent: Array<NotificationNotificationDeviceSent>;
  /** fetch aggregated fields from the table: "notification.notification_device_sent" */
  notificationNotificationDeviceSentAggregate: NotificationNotificationDeviceSentAggregate;
  /** fetch data from the table: "notification.notification_device_sent" using primary key columns */
  notificationNotificationDeviceSentByPk?: Maybe<NotificationNotificationDeviceSent>;
  /** fetch data from the table: "notification.notification_setting_activity_primary_enum" */
  notificationNotificationSettingActivityPrimaryEnum: Array<NotificationNotificationSettingActivityPrimaryEnum>;
  /** fetch aggregated fields from the table: "notification.notification_setting_activity_primary_enum" */
  notificationNotificationSettingActivityPrimaryEnumAggregate: NotificationNotificationSettingActivityPrimaryEnumAggregate;
  /** fetch data from the table: "notification.notification_setting_activity_primary_enum" using primary key columns */
  notificationNotificationSettingActivityPrimaryEnumByPk?: Maybe<NotificationNotificationSettingActivityPrimaryEnum>;
  /** fetch data from the table: "notification.notification_send" using primary key columns */
  notificationSend?: Maybe<notificationSend>;
  /** fetch data from the table: "notification.notification_send" */
  notificationSends: Array<notificationSend>;
  /** fetch aggregated fields from the table: "notification.notification_send" */
  notificationSendsAggregate: notificationSendAggregate;
  /** fetch data from the table: "notification.notification_setting_activity" */
  notificationSettingActivities: Array<notificationSettingActivity>;
  /** fetch aggregated fields from the table: "notification.notification_setting_activity" */
  notificationSettingActivitiesAggregate: notificationSettingActivityAggregate;
  /** fetch data from the table: "notification.notification_setting_activity" using primary key columns */
  notificationSettingActivity?: Maybe<notificationSettingActivity>;
  /** fetch data from the table: "notification.notification_users" using primary key columns */
  notificationUser?: Maybe<notificationUser>;
  /** fetch data from the table: "notification.notification_user_devices" using primary key columns */
  notificationUserDevice?: Maybe<notificationUserDevice>;
  /** An array relationship */
  notificationUserDevices: Array<notificationUserDevice>;
  /** An aggregate relationship */
  notificationUserDevicesAggregate: notificationUserDeviceAggregate;
  /** fetch data from the table: "notification.notification_users" */
  notificationUsers: Array<notificationUser>;
  /** fetch aggregated fields from the table: "notification.notification_users" */
  notificationUsersAggregate: notificationUserAggregate;
  /** fetch data from the table: "notification.notifications" */
  notifications: Array<notification>;
  /** fetch aggregated fields from the table: "notification.notifications" */
  notificationsAggregate: notificationAggregate;
  /** fetch data from the table: "orders.integrations" using primary key columns */
  ordersIntegration?: Maybe<ordersIntegrations>;
  /** fetch data from the table: "orders.integrations" */
  ordersIntegrations: Array<ordersIntegrations>;
  /** fetch aggregated fields from the table: "orders.integrations" */
  ordersIntegrationsAggregate: ordersIntegrationsAggregate;
  /** fetch data from the table: "orders.organizations" */
  ordersOrganizations: Array<OrdersOrganizations>;
  /** fetch aggregated fields from the table: "orders.organizations" */
  ordersOrganizationsAggregate: OrdersOrganizationsAggregate;
  /** fetch data from the table: "orders.organizations" using primary key columns */
  ordersOrganizationsByPk?: Maybe<OrdersOrganizations>;
  /** fetch data from the table: "orders.request" */
  ordersRequest: Array<OrdersRequest>;
  /** fetch aggregated fields from the table: "orders.request" */
  ordersRequestAggregate: OrdersRequestAggregate;
  /** fetch data from the table: "orders.request" using primary key columns */
  ordersRequestByPk?: Maybe<OrdersRequest>;
  /** fetch data from the table: "orders.status" */
  ordersStatus: Array<OrdersStatus>;
  /** fetch aggregated fields from the table: "orders.status" */
  ordersStatusAggregate: OrdersStatusAggregate;
  /** fetch data from the table: "orders.status" using primary key columns */
  ordersStatusByPk?: Maybe<OrdersStatus>;
  /** fetch data from the table: "orders.type" */
  ordersType: Array<OrdersType>;
  /** fetch aggregated fields from the table: "orders.type" */
  ordersTypeAggregate: OrdersTypeAggregate;
  /** fetch data from the table: "orders.type" using primary key columns */
  ordersTypeByPk?: Maybe<OrdersType>;
  /** fetch data from the table: "business.organizations" using primary key columns */
  organization?: Maybe<organization>;
  /** fetch data from the table: "business.authorization_enum_group" using primary key columns */
  organizationAuthorizationEnumGroup?: Maybe<organizationAuthorizationEnumGroup>;
  /** fetch data from the table: "business.authorization_enum_group" */
  organizationAuthorizationEnumGroups: Array<organizationAuthorizationEnumGroup>;
  /** fetch data from the table: "business.authorization_group" using primary key columns */
  organizationAuthorizationGroup?: Maybe<organizationAuthorizationGroup>;
  /** fetch data from the table: "business.authorization_group" */
  organizationAuthorizationGroups: Array<organizationAuthorizationGroup>;
  /** fetch data from the table: "business.organization_relationship" using primary key columns */
  organizationOrganizationRelationship?: Maybe<organizationOrganizationRelationship>;
  /** fetch data from the table: "business.organization_relationship_category" */
  organizationOrganizationRelationshipCategories: Array<organizationOrganizationRelationshipCategory>;
  /** fetch data from the table: "business.organization_relationship_category" using primary key columns */
  organizationOrganizationRelationshipCategory?: Maybe<organizationOrganizationRelationshipCategory>;
  /** fetch data from the table: "business.organization_relationship" */
  organizationOrganizationRelationships: Array<organizationOrganizationRelationship>;
  /** fetch data from the table: "business.organization_user_authorization" using primary key columns */
  organizationOrganizationUserAuthorization?: Maybe<organizationOrganizationUserAuthorization>;
  /** fetch data from the table: "business.organization_user_authorization" */
  organizationOrganizationUserAuthorizations: Array<organizationOrganizationUserAuthorization>;
  /** fetch data from the table: "business.organization_user__organizations_view" */
  organizationOrganizationUserOrganizationsViews: Array<organizationOrganizationUserOrganizationsView>;
  /** fetch data from the table: "business.organization_user__users_view" */
  organizationOrganizationUserUsersViews: Array<organizationOrganizationUserUsersView>;
  /** fetch data from the table: "business.organization_user" using primary key columns */
  organizationUser?: Maybe<organizationUser>;
  /** fetch data from the table: "business.organization_user_attachments" using primary key columns */
  organizationUserAttachment?: Maybe<organizationUserAttachments>;
  /** fetch data from the table: "business.organization_user_attachments" */
  organizationUserAttachments: Array<organizationUserAttachments>;
  /** An aggregate relationship */
  organizationUserAttachmentsAggregate: organizationUserAttachmentsAggregate;
  /** fetch data from the table: "business.organization_user_attention_note" using primary key columns */
  organizationUserAttentionNote?: Maybe<OrganizationUserAttentionNote>;
  /** fetch aggregated fields from the table: "business.organization_user_attention_note" */
  organizationUserAttentionNoteAggregate: OrganizationUserAttentionNoteAggregate;
  /** fetch data from the table: "business.organization_user_attention_note" */
  organizationUserAttentionNotes: Array<OrganizationUserAttentionNote>;
  /** fetch data from the table: "business.user_authorization" using primary key columns */
  organizationUserAuthorization?: Maybe<organizationUserAuthorization>;
  /** fetch data from the table: "business.user_authorization" */
  organizationUserAuthorizations: Array<organizationUserAuthorization>;
  /** fetch data from the table: "business.organization_user_details" using primary key columns */
  organizationUserDetail?: Maybe<organizationUserDetail>;
  /** fetch data from the table: "business.organization_user_details_type" using primary key columns */
  organizationUserDetailType?: Maybe<organizationUserDetailType>;
  /** fetch data from the table: "business.organization_user_details_type" */
  organizationUserDetailTypes: Array<organizationUserDetailType>;
  /** fetch aggregated fields from the table: "business.organization_user_details_type" */
  organizationUserDetailTypesAggregate: organizationUserDetailTypeAggregate;
  /** An array relationship */
  organizationUserDetails: Array<organizationUserDetail>;
  /** An aggregate relationship */
  organizationUserDetailsAggregate: organizationUserDetailAggregate;
  /** fetch data from the table: "business.organization_user_invite" using primary key columns */
  organizationUserInvite?: Maybe<organizationUserInvite>;
  /** An array relationship */
  organizationUserInvites: Array<organizationUserInvite>;
  /** An aggregate relationship */
  organizationUserInvitesAggregate: organizationUserInviteAggregate;
  /** fetch data from the table: "business.organization_user_request" using primary key columns */
  organizationUserRequest?: Maybe<BusinessOrganizationUserRequest>;
  /** An array relationship */
  organizationUserRequests: Array<BusinessOrganizationUserRequest>;
  /** fetch data from the table: "business.organization_user_status" using primary key columns */
  organizationUserStatus?: Maybe<organizationUserStatus>;
  /** fetch data from the table: "business.organization_user_status" */
  organizationUserStatuses: Array<organizationUserStatus>;
  /** fetch aggregated fields from the table: "business.organization_user_status" */
  organizationUserStatusesAggregate: organizationUserStatusAggregate;
  /** An array relationship */
  organizationUsers: Array<organizationUser>;
  /** An aggregate relationship */
  organizationUsersAggregate: organizationUserAggregate;
  /** fetch data from the table: "business.organizations" */
  organizations: Array<organization>;
  /** fetch aggregated fields from the table: "business.organizations" */
  organizationsAggregate: organizationAggregate;
  /** fetch data from the table: "business.phone_number_verification_status" using primary key columns */
  phoneNumberVerificationStatus?: Maybe<phoneNumberVerificationStatus>;
  /** fetch data from the table: "business.phone_number_verification_status" */
  phoneNumberVerificationStatuses: Array<phoneNumberVerificationStatus>;
  /** fetch aggregated fields from the table: "business.phone_number_verification_status" */
  phoneNumberVerificationStatusesAggregate: phoneNumberVerificationStatusAggregate;
  /** fetch data from the table: "prompt" */
  prompt: Array<Prompt>;
  /** fetch aggregated fields from the table: "prompt" */
  promptAggregate: PromptAggregate;
  /** fetch data from the table: "prompt" using primary key columns */
  promptByPk?: Maybe<Prompt>;
  /** fetch data from the table: "devices" using primary key columns */
  publicDevice?: Maybe<publicDevice>;
  /** fetch data from the table: "devices" */
  publicDevices: Array<publicDevice>;
  /** fetch data from the table: "external_requests" using primary key columns */
  publicExternalRequest?: Maybe<publicExternalRequest>;
  /** fetch data from the table: "external_requests" */
  publicExternalRequests: Array<publicExternalRequest>;
  /** fetch data from the table: "files" using primary key columns */
  publicFile?: Maybe<publicFile>;
  /** fetch data from the table: "files" */
  publicFiles: Array<publicFile>;
  /** fetch data from the table: "notifications" using primary key columns */
  publicNotification?: Maybe<publicNotification>;
  /** fetch data from the table: "notifications" */
  publicNotifications: Array<publicNotification>;
  /** fetch data from the table: "business.queue_item" using primary key columns */
  queueItem?: Maybe<queueItem>;
  /** fetch data from the table: "business.queue_item" */
  queueItems: Array<queueItem>;
  /** fetch aggregated fields from the table: "business.queue_item" */
  queueItemsAggregate: queueItemAggregate;
  /** fetch data from the table: "business.rel_organization_user_domain_user" using primary key columns */
  relOrganizationUserDomainUser?: Maybe<relOrganizationUserDomainUser>;
  /** fetch data from the table: "business.rel_organization_user_domain_user" */
  relOrganizationUserDomainUsers: Array<relOrganizationUserDomainUser>;
  /** fetch aggregated fields from the table: "business.rel_organization_user_domain_user" */
  relOrganizationUserDomainUsersAggregate: relOrganizationUserDomainUserAggregate;
  /** fetch data from the table: "sms.connectors" using primary key columns */
  smsConnector?: Maybe<smsConnector>;
  /** fetch data from the table: "sms.connectors" */
  smsConnectors: Array<smsConnector>;
  /** fetch data from the table: "sms.gates" using primary key columns */
  smsGate?: Maybe<smsGate>;
  /** fetch data from the table: "sms.gates" */
  smsGates: Array<smsGate>;
  /** fetch data from the table: "sms.link_mobility_sms_content" using primary key columns */
  smsLinkMobilitySmsContent?: Maybe<smsLinkMobilitySmsContent>;
  /** fetch data from the table: "sms.link_mobility_sms_content" */
  smsLinkMobilitySmsContents: Array<smsLinkMobilitySmsContent>;
  /** fetch data from the table: "sms.link_mobility_sms_message" using primary key columns */
  smsLinkMobilitySmsMessage?: Maybe<smsLinkMobilitySmsMessage>;
  /** fetch data from the table: "sms.link_mobility_sms_message" */
  smsLinkMobilitySmsMessages: Array<smsLinkMobilitySmsMessage>;
  /** fetch data from the table: "sms.link_mobility_sms_route" using primary key columns */
  smsLinkMobilitySmsRoute?: Maybe<smsLinkMobilitySmsRoute>;
  /** fetch data from the table: "sms.link_mobility_sms_route" */
  smsLinkMobilitySmsRoutes: Array<smsLinkMobilitySmsRoute>;
  /** fetch data from the table: "sms.providers" using primary key columns */
  smsProvider?: Maybe<smsProvider>;
  /** fetch data from the table: "sms.providers" */
  smsProviders: Array<smsProvider>;
  /** fetch data from the table: "sms.sms" using primary key columns */
  smsSm?: Maybe<smsSm>;
  /** fetch data from the table: "sms.sms" */
  smsSms: Array<smsSm>;
  /** fetch data from the table: "sms.sms_external_incoming_link_mobility" */
  smsSmsExternalIncomingLinkMobilities: Array<smsSmsExternalIncomingLinkMobility>;
  /** fetch data from the table: "sms.sms_external_incoming_link_mobility" using primary key columns */
  smsSmsExternalIncomingLinkMobility?: Maybe<smsSmsExternalIncomingLinkMobility>;
  task?: Maybe<taskquery_root>;
  telephony?: Maybe<telephonyquery_root>;
  /** fetch data from the table: "business.users" using primary key columns */
  user?: Maybe<user>;
  /** fetch data from the table: "business.user_details" using primary key columns */
  userDetail?: Maybe<userDetail>;
  /** fetch data from the table: "business.user_details" */
  userDetails: Array<userDetail>;
  /** fetch aggregated fields from the table: "business.user_details" */
  userDetailsAggregate: userDetailAggregate;
  /** fetch data from the table: "business.user_details_type" using primary key columns */
  userDetailsType?: Maybe<userDetailsType>;
  /** fetch data from the table: "business.user_details_type" */
  userDetailsTypes: Array<userDetailsType>;
  /** fetch aggregated fields from the table: "business.user_details_type" */
  userDetailsTypesAggregate: userDetailsTypeAggregate;
  /** fetch data from the table: "business.user_devices" using primary key columns */
  userDevice?: Maybe<userDevice>;
  /** fetch data from the table: "business.user_devices" */
  userDevices: Array<userDevice>;
  /** fetch aggregated fields from the table: "business.user_devices" */
  userDevicesAggregate: userDeviceAggregate;
  /** fetch data from the table: "business.user_phone_numbers" using primary key columns */
  userPhoneNumber?: Maybe<userPhoneNumber>;
  /** fetch data from the table: "business.user_phone_numbers" */
  userPhoneNumbers: Array<userPhoneNumber>;
  /** fetch aggregated fields from the table: "business.user_phone_numbers" */
  userPhoneNumbersAggregate: userPhoneNumberAggregate;
  /** fetch data from the table: "business.user_role" using primary key columns */
  userRole?: Maybe<userRole>;
  /** fetch data from the table: "business.user_role" */
  userRoles: Array<userRole>;
  /** fetch aggregated fields from the table: "business.user_role" */
  userRolesAggregate: userRoleAggregate;
  /** An array relationship */
  users: Array<user>;
  /** An aggregate relationship */
  usersAggregate: userAggregate;
  /** fetch data from the table: "validation.validation" using primary key columns */
  validationValidation?: Maybe<validationValidation>;
  /** fetch data from the table: "validation.validation" */
  validationValidations: Array<validationValidation>;
  /** fetch data from the table: "voice_types" */
  voiceTypes: Array<VoiceTypes>;
  /** fetch aggregated fields from the table: "voice_types" */
  voiceTypesAggregate: VoiceTypesAggregate;
  /** fetch data from the table: "voice_types" using primary key columns */
  voiceTypesByPk?: Maybe<VoiceTypes>;
};


export type query_rootActivityDirectionArgs = {
  distinctOn?: InputMaybe<Array<ActivityDirectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityDirectionOrderBy>>;
  where?: InputMaybe<ActivityDirectionBoolExp>;
};


export type query_rootActivityDirectionAggregateArgs = {
  distinctOn?: InputMaybe<Array<ActivityDirectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityDirectionOrderBy>>;
  where?: InputMaybe<ActivityDirectionBoolExp>;
};


export type query_rootActivityDirectionByPkArgs = {
  value: Scalars['String']['input'];
};


export type query_rootActivityProviderArgs = {
  distinctOn?: InputMaybe<Array<ActivityProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityProviderOrderBy>>;
  where?: InputMaybe<ActivityProviderBoolExp>;
};


export type query_rootActivityProviderAggregateArgs = {
  distinctOn?: InputMaybe<Array<ActivityProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityProviderOrderBy>>;
  where?: InputMaybe<ActivityProviderBoolExp>;
};


export type query_rootActivityProviderByPkArgs = {
  value: Scalars['String']['input'];
};


export type query_rootQueueItemFlexibilityTypeArgs = {
  distinctOn?: InputMaybe<Array<QueueItemFlexibilityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QueueItemFlexibilityTypeOrderBy>>;
  where?: InputMaybe<QueueItemFlexibilityTypeBoolExp>;
};


export type query_rootQueueItemFlexibilityTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<QueueItemFlexibilityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QueueItemFlexibilityTypeOrderBy>>;
  where?: InputMaybe<QueueItemFlexibilityTypeBoolExp>;
};


export type query_rootQueueItemFlexibilityTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type query_rootQueueItemParticipantResponsibilityTypeArgs = {
  distinctOn?: InputMaybe<Array<QueueItemParticipantResponsibilityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QueueItemParticipantResponsibilityTypeOrderBy>>;
  where?: InputMaybe<QueueItemParticipantResponsibilityTypeBoolExp>;
};


export type query_rootQueueItemParticipantResponsibilityTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<QueueItemParticipantResponsibilityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QueueItemParticipantResponsibilityTypeOrderBy>>;
  where?: InputMaybe<QueueItemParticipantResponsibilityTypeBoolExp>;
};


export type query_rootQueueItemParticipantResponsibilityTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type query_rootRelationTypeArgs = {
  distinctOn?: InputMaybe<Array<RelationTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RelationTypeOrderBy>>;
  where?: InputMaybe<RelationTypeBoolExp>;
};


export type query_rootRelationTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<RelationTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RelationTypeOrderBy>>;
  where?: InputMaybe<RelationTypeBoolExp>;
};


export type query_rootRelationTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type query_rootactivityParticipantArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootactivityParticipantsArgs = {
  distinctOn?: InputMaybe<Array<activityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<activityParticipantOrderBy>>;
  where?: InputMaybe<activityParticipantBoolExp>;
};


export type query_rootactivityParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<activityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<activityParticipantOrderBy>>;
  where?: InputMaybe<activityParticipantBoolExp>;
};


export type query_rootactivityStatusArgs = {
  value: Scalars['String']['input'];
};


export type query_rootactivityStatusesArgs = {
  distinctOn?: InputMaybe<Array<ActivityStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityStatusOrderBy>>;
  where?: InputMaybe<ActivityStatusBoolExp>;
};


export type query_rootactivityStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ActivityStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityStatusOrderBy>>;
  where?: InputMaybe<ActivityStatusBoolExp>;
};


export type query_rootactivityTypeArgs = {
  value: Scalars['String']['input'];
};


export type query_rootactivityTypesArgs = {
  distinctOn?: InputMaybe<Array<ActivityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityTypeOrderBy>>;
  where?: InputMaybe<ActivityTypeBoolExp>;
};


export type query_rootactivityTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ActivityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityTypeOrderBy>>;
  where?: InputMaybe<ActivityTypeBoolExp>;
};


export type query_rootaddressArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootaddressesArgs = {
  distinctOn?: InputMaybe<Array<addressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<addressOrderBy>>;
  where?: InputMaybe<addressBoolExp>;
};


export type query_rootaddressesAggregateArgs = {
  distinctOn?: InputMaybe<Array<addressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<addressOrderBy>>;
  where?: InputMaybe<addressBoolExp>;
};


export type query_rootaggregateBusinessUserContactsArgs = {
  distinctOn?: InputMaybe<Array<businessUserContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<businessUserContactsOrderBy>>;
  where?: InputMaybe<businessUserContactsBoolExp>;
};


export type query_rootaggregateBusinessUserSettingsArgs = {
  distinctOn?: InputMaybe<Array<businessUserSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<businessUserSettingsOrderBy>>;
  where?: InputMaybe<businessUserSettingsBoolExp>;
};


export type query_rootaggregateMessagingActivitiesArgs = {
  distinctOn?: InputMaybe<Array<messagingActivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingActivityOrderBy>>;
  where?: InputMaybe<messagingActivityBoolExp>;
};


export type query_rootaggregateMessagingActivityTypesArgs = {
  distinctOn?: InputMaybe<Array<messagingActivityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingActivityTypeOrderBy>>;
  where?: InputMaybe<messagingActivityTypeBoolExp>;
};


export type query_rootaggregateMessagingActivityUsersArgs = {
  distinctOn?: InputMaybe<Array<messagingActivityUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingActivityUserOrderBy>>;
  where?: InputMaybe<messagingActivityUserBoolExp>;
};


export type query_rootaggregateMessagingMessageEmojisArgs = {
  distinctOn?: InputMaybe<Array<messagingMessageEmojiSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingMessageEmojiOrderBy>>;
  where?: InputMaybe<messagingMessageEmojiBoolExp>;
};


export type query_rootaggregateMessagingMessageReadsArgs = {
  distinctOn?: InputMaybe<Array<messagingMessageReadSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingMessageReadOrderBy>>;
  where?: InputMaybe<messagingMessageReadBoolExp>;
};


export type query_rootaggregateMessagingMessageTypesArgs = {
  distinctOn?: InputMaybe<Array<messagingMessageTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingMessageTypeOrderBy>>;
  where?: InputMaybe<messagingMessageTypeBoolExp>;
};


export type query_rootaggregateMessagingMessagesArgs = {
  distinctOn?: InputMaybe<Array<messagingMessageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingMessageOrderBy>>;
  where?: InputMaybe<messagingMessageBoolExp>;
};


export type query_rootaggregateOrganizationAuthorizationEnumGroupsArgs = {
  distinctOn?: InputMaybe<Array<organizationAuthorizationEnumGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationAuthorizationEnumGroupOrderBy>>;
  where?: InputMaybe<organizationAuthorizationEnumGroupBoolExp>;
};


export type query_rootaggregateOrganizationAuthorizationGroupsArgs = {
  distinctOn?: InputMaybe<Array<organizationAuthorizationGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationAuthorizationGroupOrderBy>>;
  where?: InputMaybe<organizationAuthorizationGroupBoolExp>;
};


export type query_rootaggregateOrganizationOrganizationRelationshipCategoriesArgs = {
  distinctOn?: InputMaybe<Array<organizationOrganizationRelationshipCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrganizationRelationshipCategoryOrderBy>>;
  where?: InputMaybe<organizationOrganizationRelationshipCategoryBoolExp>;
};


export type query_rootaggregateOrganizationOrganizationRelationshipsArgs = {
  distinctOn?: InputMaybe<Array<organizationOrganizationRelationshipSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrganizationRelationshipOrderBy>>;
  where?: InputMaybe<organizationOrganizationRelationshipBoolExp>;
};


export type query_rootaggregateOrganizationOrganizationUserAuthorizationsArgs = {
  distinctOn?: InputMaybe<Array<organizationOrganizationUserAuthorizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrganizationUserAuthorizationOrderBy>>;
  where?: InputMaybe<organizationOrganizationUserAuthorizationBoolExp>;
};


export type query_rootaggregateOrganizationOrganizationUserOrganizationsViewsArgs = {
  distinctOn?: InputMaybe<Array<organizationOrganizationUserOrganizationsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrganizationUserOrganizationsViewOrderBy>>;
  where?: InputMaybe<organizationOrganizationUserOrganizationsViewBoolExp>;
};


export type query_rootaggregateOrganizationOrganizationUserUsersViewsArgs = {
  distinctOn?: InputMaybe<Array<organizationOrganizationUserUsersViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrganizationUserUsersViewOrderBy>>;
  where?: InputMaybe<organizationOrganizationUserUsersViewBoolExp>;
};


export type query_rootaggregateOrganizationUserAuthorizationsArgs = {
  distinctOn?: InputMaybe<Array<organizationUserAuthorizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserAuthorizationOrderBy>>;
  where?: InputMaybe<organizationUserAuthorizationBoolExp>;
};


export type query_rootaggregatePublicDevicesArgs = {
  distinctOn?: InputMaybe<Array<publicDeviceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<publicDeviceOrderBy>>;
  where?: InputMaybe<publicDeviceBoolExp>;
};


export type query_rootaggregatePublicExternalRequestsArgs = {
  distinctOn?: InputMaybe<Array<publicExternalRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<publicExternalRequestOrderBy>>;
  where?: InputMaybe<publicExternalRequestBoolExp>;
};


export type query_rootaggregatePublicFilesArgs = {
  distinctOn?: InputMaybe<Array<publicFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<publicFileOrderBy>>;
  where?: InputMaybe<publicFileBoolExp>;
};


export type query_rootaggregatePublicNotificationsArgs = {
  distinctOn?: InputMaybe<Array<publicNotificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<publicNotificationOrderBy>>;
  where?: InputMaybe<publicNotificationBoolExp>;
};


export type query_rootaggregateSmsConnectorsArgs = {
  distinctOn?: InputMaybe<Array<smsConnectorSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsConnectorOrderBy>>;
  where?: InputMaybe<smsConnectorBoolExp>;
};


export type query_rootaggregateSmsGatesArgs = {
  distinctOn?: InputMaybe<Array<smsGateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsGateOrderBy>>;
  where?: InputMaybe<smsGateBoolExp>;
};


export type query_rootaggregateSmsLinkMobilitySmsContentsArgs = {
  distinctOn?: InputMaybe<Array<smsLinkMobilitySmsContentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsLinkMobilitySmsContentOrderBy>>;
  where?: InputMaybe<smsLinkMobilitySmsContentBoolExp>;
};


export type query_rootaggregateSmsLinkMobilitySmsMessagesArgs = {
  distinctOn?: InputMaybe<Array<smsLinkMobilitySmsMessageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsLinkMobilitySmsMessageOrderBy>>;
  where?: InputMaybe<smsLinkMobilitySmsMessageBoolExp>;
};


export type query_rootaggregateSmsLinkMobilitySmsRoutesArgs = {
  distinctOn?: InputMaybe<Array<smsLinkMobilitySmsRouteSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsLinkMobilitySmsRouteOrderBy>>;
  where?: InputMaybe<smsLinkMobilitySmsRouteBoolExp>;
};


export type query_rootaggregateSmsProvidersArgs = {
  distinctOn?: InputMaybe<Array<smsProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsProviderOrderBy>>;
  where?: InputMaybe<smsProviderBoolExp>;
};


export type query_rootaggregateSmsSmsArgs = {
  distinctOn?: InputMaybe<Array<smsSmSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsSmOrderBy>>;
  where?: InputMaybe<smsSmBoolExp>;
};


export type query_rootaggregateSmsSmsExternalIncomingLinkMobilitiesArgs = {
  distinctOn?: InputMaybe<Array<smsSmsExternalIncomingLinkMobilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsSmsExternalIncomingLinkMobilityOrderBy>>;
  where?: InputMaybe<smsSmsExternalIncomingLinkMobilityBoolExp>;
};


export type query_rootaggregateValidationValidationsArgs = {
  distinctOn?: InputMaybe<Array<validationValidationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<validationValidationOrderBy>>;
  where?: InputMaybe<validationValidationBoolExp>;
};


export type query_rootblockedDomainUserArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootblockedDomainUsersArgs = {
  distinctOn?: InputMaybe<Array<blockedDomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<blockedDomainUserOrderBy>>;
  where?: InputMaybe<blockedDomainUserBoolExp>;
};


export type query_rootblockedDomainUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<blockedDomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<blockedDomainUserOrderBy>>;
  where?: InputMaybe<blockedDomainUserBoolExp>;
};


export type query_rootbusinessDomainActivityTypeArgs = {
  distinctOn?: InputMaybe<Array<BusinessDomainActivityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessDomainActivityTypeOrderBy>>;
  where?: InputMaybe<BusinessDomainActivityTypeBoolExp>;
};


export type query_rootbusinessDomainActivityTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessDomainActivityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessDomainActivityTypeOrderBy>>;
  where?: InputMaybe<BusinessDomainActivityTypeBoolExp>;
};


export type query_rootbusinessDomainActivityTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type query_rootbusinessFeedTypeArgs = {
  distinctOn?: InputMaybe<Array<BusinessFeedTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessFeedTypeOrderBy>>;
  where?: InputMaybe<BusinessFeedTypeBoolExp>;
};


export type query_rootbusinessFeedTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessFeedTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessFeedTypeOrderBy>>;
  where?: InputMaybe<BusinessFeedTypeBoolExp>;
};


export type query_rootbusinessFeedTypeByPkArgs = {
  type: Scalars['String']['input'];
};


export type query_rootbusinessMessageAttachmentsArgs = {
  distinctOn?: InputMaybe<Array<BusinessMessageAttachmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessMessageAttachmentsOrderBy>>;
  where?: InputMaybe<BusinessMessageAttachmentsBoolExp>;
};


export type query_rootbusinessMessageAttachmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessMessageAttachmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessMessageAttachmentsOrderBy>>;
  where?: InputMaybe<BusinessMessageAttachmentsBoolExp>;
};


export type query_rootbusinessMessageAttachmentsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootbusinessOrganizationUserCallbackAnswerArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserCallbackAnswerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserCallbackAnswerOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserCallbackAnswerBoolExp>;
};


export type query_rootbusinessOrganizationUserCallbackAnswerAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserCallbackAnswerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserCallbackAnswerOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserCallbackAnswerBoolExp>;
};


export type query_rootbusinessOrganizationUserCallbackAnswerByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootbusinessOrganizationUserEmailArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserEmailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserEmailOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserEmailBoolExp>;
};


export type query_rootbusinessOrganizationUserEmailAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserEmailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserEmailOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserEmailBoolExp>;
};


export type query_rootbusinessOrganizationUserEmailByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootbusinessOrganizationUserEmailTypeArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserEmailTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserEmailTypeOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserEmailTypeBoolExp>;
};


export type query_rootbusinessOrganizationUserEmailTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserEmailTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserEmailTypeOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserEmailTypeBoolExp>;
};


export type query_rootbusinessOrganizationUserEmailTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type query_rootbusinessOrganizationUserRequestAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserRequestOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserRequestBoolExp>;
};


export type query_rootbusinessOrganizationUserRequestTypeArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserRequestTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserRequestTypeOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserRequestTypeBoolExp>;
};


export type query_rootbusinessOrganizationUserRequestTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserRequestTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserRequestTypeOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserRequestTypeBoolExp>;
};


export type query_rootbusinessOrganizationUserRequestTypeByPkArgs = {
  name: Scalars['String']['input'];
};


export type query_rootbusinessOrganizationUserSuggestionTypeArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserSuggestionTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserSuggestionTypeOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserSuggestionTypeBoolExp>;
};


export type query_rootbusinessOrganizationUserSuggestionTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserSuggestionTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserSuggestionTypeOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserSuggestionTypeBoolExp>;
};


export type query_rootbusinessOrganizationUserSuggestionTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type query_rootbusinessOrganizationUserSuggestionsArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserSuggestionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserSuggestionsOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserSuggestionsBoolExp>;
};


export type query_rootbusinessOrganizationUserSuggestionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserSuggestionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserSuggestionsOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserSuggestionsBoolExp>;
};


export type query_rootbusinessOrganizationUserSuggestionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootbusinessOrganizationUserUrlAddressArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserUrlAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserUrlAddressOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserUrlAddressBoolExp>;
};


export type query_rootbusinessOrganizationUserUrlAddressAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserUrlAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserUrlAddressOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserUrlAddressBoolExp>;
};


export type query_rootbusinessOrganizationUserUrlAddressByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootbusinessOrganizationUserUrlAddressTypeArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserUrlAddressTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserUrlAddressTypeOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserUrlAddressTypeBoolExp>;
};


export type query_rootbusinessOrganizationUserUrlAddressTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserUrlAddressTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserUrlAddressTypeOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserUrlAddressTypeBoolExp>;
};


export type query_rootbusinessOrganizationUserUrlAddressTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type query_rootbusinessQueueItemAlarmTypeArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemAlarmTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemAlarmTypeOrderBy>>;
  where?: InputMaybe<BusinessQueueItemAlarmTypeBoolExp>;
};


export type query_rootbusinessQueueItemAlarmTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemAlarmTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemAlarmTypeOrderBy>>;
  where?: InputMaybe<BusinessQueueItemAlarmTypeBoolExp>;
};


export type query_rootbusinessQueueItemAlarmTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type query_rootbusinessQueueItemAlarmsArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemAlarmsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemAlarmsOrderBy>>;
  where?: InputMaybe<BusinessQueueItemAlarmsBoolExp>;
};


export type query_rootbusinessQueueItemAlarmsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemAlarmsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemAlarmsOrderBy>>;
  where?: InputMaybe<BusinessQueueItemAlarmsBoolExp>;
};


export type query_rootbusinessQueueItemAlarmsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootbusinessQueueItemCollaborationArgs = {
  id: Scalars['Int']['input'];
};


export type query_rootbusinessQueueItemCollaborationAggregateArgs = {
  distinctOn?: InputMaybe<Array<businessQueueItemCollaborationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<businessQueueItemCollaborationOrderBy>>;
  where?: InputMaybe<businessQueueItemCollaborationBoolExp>;
};


export type query_rootbusinessQueueItemCollaborationsArgs = {
  distinctOn?: InputMaybe<Array<businessQueueItemCollaborationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<businessQueueItemCollaborationOrderBy>>;
  where?: InputMaybe<businessQueueItemCollaborationBoolExp>;
};


export type query_rootbusinessQueueItemDomainUsersViewArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemDomainUsersViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemDomainUsersViewOrderBy>>;
  where?: InputMaybe<BusinessQueueItemDomainUsersViewBoolExp>;
};


export type query_rootbusinessQueueItemDomainUsersViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemDomainUsersViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemDomainUsersViewOrderBy>>;
  where?: InputMaybe<BusinessQueueItemDomainUsersViewBoolExp>;
};


export type query_rootbusinessQueueItemOrganizationUsersViewArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemOrganizationUsersViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemOrganizationUsersViewOrderBy>>;
  where?: InputMaybe<BusinessQueueItemOrganizationUsersViewBoolExp>;
};


export type query_rootbusinessQueueItemOrganizationUsersViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemOrganizationUsersViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemOrganizationUsersViewOrderBy>>;
  where?: InputMaybe<BusinessQueueItemOrganizationUsersViewBoolExp>;
};


export type query_rootbusinessQueueItemParticipantChannelTypeArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemParticipantChannelTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemParticipantChannelTypeOrderBy>>;
  where?: InputMaybe<BusinessQueueItemParticipantChannelTypeBoolExp>;
};


export type query_rootbusinessQueueItemParticipantChannelTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemParticipantChannelTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemParticipantChannelTypeOrderBy>>;
  where?: InputMaybe<BusinessQueueItemParticipantChannelTypeBoolExp>;
};


export type query_rootbusinessQueueItemParticipantChannelTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type query_rootbusinessQueueItemParticipantsViewArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemParticipantsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemParticipantsViewOrderBy>>;
  where?: InputMaybe<BusinessQueueItemParticipantsViewBoolExp>;
};


export type query_rootbusinessQueueItemParticipantsViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemParticipantsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemParticipantsViewOrderBy>>;
  where?: InputMaybe<BusinessQueueItemParticipantsViewBoolExp>;
};


export type query_rootbusinessQueueItemSubTypeArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemSubTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemSubTypeOrderBy>>;
  where?: InputMaybe<BusinessQueueItemSubTypeBoolExp>;
};


export type query_rootbusinessQueueItemSubTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemSubTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemSubTypeOrderBy>>;
  where?: InputMaybe<BusinessQueueItemSubTypeBoolExp>;
};


export type query_rootbusinessQueueItemSubTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type query_rootbusinessUserContactArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootbusinessUserContactNumbersArgs = {
  distinctOn?: InputMaybe<Array<BusinessUserContactNumbersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessUserContactNumbersOrderBy>>;
  where?: InputMaybe<BusinessUserContactNumbersBoolExp>;
};


export type query_rootbusinessUserContactNumbersAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessUserContactNumbersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessUserContactNumbersOrderBy>>;
  where?: InputMaybe<BusinessUserContactNumbersBoolExp>;
};


export type query_rootbusinessUserContactNumbersByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootbusinessUserContactsArgs = {
  distinctOn?: InputMaybe<Array<businessUserContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<businessUserContactsOrderBy>>;
  where?: InputMaybe<businessUserContactsBoolExp>;
};


export type query_rootbusinessUserFeedArgs = {
  distinctOn?: InputMaybe<Array<BusinessUserFeedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessUserFeedOrderBy>>;
  where?: InputMaybe<BusinessUserFeedBoolExp>;
};


export type query_rootbusinessUserFeedAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessUserFeedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessUserFeedOrderBy>>;
  where?: InputMaybe<BusinessUserFeedBoolExp>;
};


export type query_rootbusinessUserFeedByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootbusinessUserRequestStatusArgs = {
  distinctOn?: InputMaybe<Array<BusinessUserRequestStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessUserRequestStatusOrderBy>>;
  where?: InputMaybe<BusinessUserRequestStatusBoolExp>;
};


export type query_rootbusinessUserRequestStatusAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessUserRequestStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessUserRequestStatusOrderBy>>;
  where?: InputMaybe<BusinessUserRequestStatusBoolExp>;
};


export type query_rootbusinessUserRequestStatusByPkArgs = {
  value: Scalars['String']['input'];
};


export type query_rootbusinessUserSettingArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootbusinessUserSettingsArgs = {
  distinctOn?: InputMaybe<Array<businessUserSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<businessUserSettingsOrderBy>>;
  where?: InputMaybe<businessUserSettingsBoolExp>;
};


export type query_rootbusinessUserStatesArgs = {
  distinctOn?: InputMaybe<Array<BusinessUserStatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessUserStatesOrderBy>>;
  where?: InputMaybe<BusinessUserStatesBoolExp>;
};


export type query_rootbusinessUserStatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessUserStatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessUserStatesOrderBy>>;
  where?: InputMaybe<BusinessUserStatesBoolExp>;
};


export type query_rootbusinessUserStatesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootcrmContextArgs = {
  distinctOn?: InputMaybe<Array<CrmContextSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmContextOrderBy>>;
  where?: InputMaybe<CrmContextBoolExp>;
};


export type query_rootcrmContextAggregateArgs = {
  distinctOn?: InputMaybe<Array<CrmContextSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmContextOrderBy>>;
  where?: InputMaybe<CrmContextBoolExp>;
};


export type query_rootcrmContextByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootcrmContextTypeArgs = {
  distinctOn?: InputMaybe<Array<CrmContextTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmContextTypeOrderBy>>;
  where?: InputMaybe<CrmContextTypeBoolExp>;
};


export type query_rootcrmContextTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<CrmContextTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmContextTypeOrderBy>>;
  where?: InputMaybe<CrmContextTypeBoolExp>;
};


export type query_rootcrmContextTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type query_rootcrmCreatorTypeArgs = {
  distinctOn?: InputMaybe<Array<CrmCreatorTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmCreatorTypeOrderBy>>;
  where?: InputMaybe<CrmCreatorTypeBoolExp>;
};


export type query_rootcrmCreatorTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<CrmCreatorTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmCreatorTypeOrderBy>>;
  where?: InputMaybe<CrmCreatorTypeBoolExp>;
};


export type query_rootcrmCreatorTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type query_rootcrmCrmTypeArgs = {
  distinctOn?: InputMaybe<Array<CrmCrmTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmCrmTypeOrderBy>>;
  where?: InputMaybe<CrmCrmTypeBoolExp>;
};


export type query_rootcrmCrmTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<CrmCrmTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmCrmTypeOrderBy>>;
  where?: InputMaybe<CrmCrmTypeBoolExp>;
};


export type query_rootcrmCrmTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type query_rootcrmDirectionTypeArgs = {
  distinctOn?: InputMaybe<Array<CrmDirectionTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmDirectionTypeOrderBy>>;
  where?: InputMaybe<CrmDirectionTypeBoolExp>;
};


export type query_rootcrmDirectionTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<CrmDirectionTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmDirectionTypeOrderBy>>;
  where?: InputMaybe<CrmDirectionTypeBoolExp>;
};


export type query_rootcrmDirectionTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type query_rootcrmEntityArgs = {
  distinctOn?: InputMaybe<Array<CrmEntitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmEntityOrderBy>>;
  where?: InputMaybe<CrmEntityBoolExp>;
};


export type query_rootcrmEntityAggregateArgs = {
  distinctOn?: InputMaybe<Array<CrmEntitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmEntityOrderBy>>;
  where?: InputMaybe<CrmEntityBoolExp>;
};


export type query_rootcrmEntityByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootcrmEventArgs = {
  distinctOn?: InputMaybe<Array<CrmEventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmEventOrderBy>>;
  where?: InputMaybe<CrmEventBoolExp>;
};


export type query_rootcrmEventAggregateArgs = {
  distinctOn?: InputMaybe<Array<CrmEventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmEventOrderBy>>;
  where?: InputMaybe<CrmEventBoolExp>;
};


export type query_rootcrmEventByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootcrmEventTypeArgs = {
  distinctOn?: InputMaybe<Array<CrmEventTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmEventTypeOrderBy>>;
  where?: InputMaybe<CrmEventTypeBoolExp>;
};


export type query_rootcrmEventTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<CrmEventTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmEventTypeOrderBy>>;
  where?: InputMaybe<CrmEventTypeBoolExp>;
};


export type query_rootcrmEventTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type query_rootcrmStatusCodeArgs = {
  distinctOn?: InputMaybe<Array<CrmStatusCodeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmStatusCodeOrderBy>>;
  where?: InputMaybe<CrmStatusCodeBoolExp>;
};


export type query_rootcrmStatusCodeAggregateArgs = {
  distinctOn?: InputMaybe<Array<CrmStatusCodeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmStatusCodeOrderBy>>;
  where?: InputMaybe<CrmStatusCodeBoolExp>;
};


export type query_rootcrmStatusCodeByPkArgs = {
  value: Scalars['String']['input'];
};


export type query_rootcrmStatusMessageAggregateArgs = {
  distinctOn?: InputMaybe<Array<crmStatusMessageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<crmStatusMessageOrderBy>>;
  where?: InputMaybe<crmStatusMessageBoolExp>;
};


export type query_rootcrmStatusMessageByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootcrmStatusMessagesArgs = {
  distinctOn?: InputMaybe<Array<crmStatusMessageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<crmStatusMessageOrderBy>>;
  where?: InputMaybe<crmStatusMessageBoolExp>;
};


export type query_rootcrmSystemTypeArgs = {
  distinctOn?: InputMaybe<Array<CrmSystemTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmSystemTypeOrderBy>>;
  where?: InputMaybe<CrmSystemTypeBoolExp>;
};


export type query_rootcrmSystemTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<CrmSystemTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmSystemTypeOrderBy>>;
  where?: InputMaybe<CrmSystemTypeBoolExp>;
};


export type query_rootcrmSystemTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type query_rootcrmTraceContextArgs = {
  distinctOn?: InputMaybe<Array<CrmTraceContextSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmTraceContextOrderBy>>;
  where?: InputMaybe<CrmTraceContextBoolExp>;
};


export type query_rootcrmTraceContextAggregateArgs = {
  distinctOn?: InputMaybe<Array<CrmTraceContextSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmTraceContextOrderBy>>;
  where?: InputMaybe<CrmTraceContextBoolExp>;
};


export type query_rootcrmTraceContextByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootcrmUnifiedEntityTypeArgs = {
  distinctOn?: InputMaybe<Array<CrmUnifiedEntityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmUnifiedEntityTypeOrderBy>>;
  where?: InputMaybe<CrmUnifiedEntityTypeBoolExp>;
};


export type query_rootcrmUnifiedEntityTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<CrmUnifiedEntityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmUnifiedEntityTypeOrderBy>>;
  where?: InputMaybe<CrmUnifiedEntityTypeBoolExp>;
};


export type query_rootcrmUnifiedEntityTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type query_rootcrmYoutelloCatalystIdMappingArgs = {
  catalystId: Scalars['uuid']['input'];
  youtelloId: Scalars['uuid']['input'];
};


export type query_rootcrmYoutelloCatalystIdMappingAggregateArgs = {
  distinctOn?: InputMaybe<Array<crmYoutelloCatalystIdMappingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<crmYoutelloCatalystIdMappingOrderBy>>;
  where?: InputMaybe<crmYoutelloCatalystIdMappingBoolExp>;
};


export type query_rootcrmYoutelloCatalystIdMappingsArgs = {
  distinctOn?: InputMaybe<Array<crmYoutelloCatalystIdMappingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<crmYoutelloCatalystIdMappingOrderBy>>;
  where?: InputMaybe<crmYoutelloCatalystIdMappingBoolExp>;
};


export type query_rootdomainActivitiesArgs = {
  distinctOn?: InputMaybe<Array<domainActivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainActivityOrderBy>>;
  where?: InputMaybe<domainActivityBoolExp>;
};


export type query_rootdomainActivitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<domainActivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainActivityOrderBy>>;
  where?: InputMaybe<domainActivityBoolExp>;
};


export type query_rootdomainActivityArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootdomainOrganizationArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootdomainOrganizationsArgs = {
  distinctOn?: InputMaybe<Array<domainOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainOrganizationOrderBy>>;
  where?: InputMaybe<domainOrganizationBoolExp>;
};


export type query_rootdomainOrganizationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<domainOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainOrganizationOrderBy>>;
  where?: InputMaybe<domainOrganizationBoolExp>;
};


export type query_rootdomainParticipantArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootdomainParticipantsArgs = {
  distinctOn?: InputMaybe<Array<domainParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainParticipantOrderBy>>;
  where?: InputMaybe<domainParticipantBoolExp>;
};


export type query_rootdomainParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<domainParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainParticipantOrderBy>>;
  where?: InputMaybe<domainParticipantBoolExp>;
};


export type query_rootdomainTypeArgs = {
  value: Scalars['String']['input'];
};


export type query_rootdomainTypesArgs = {
  distinctOn?: InputMaybe<Array<domainTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainTypeOrderBy>>;
  where?: InputMaybe<domainTypeBoolExp>;
};


export type query_rootdomainTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<domainTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainTypeOrderBy>>;
  where?: InputMaybe<domainTypeBoolExp>;
};


export type query_rootdomainUserArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootdomainUserCategoriesArgs = {
  distinctOn?: InputMaybe<Array<domainUserCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainUserCategoryOrderBy>>;
  where?: InputMaybe<domainUserCategoryBoolExp>;
};


export type query_rootdomainUserCategoriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<domainUserCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainUserCategoryOrderBy>>;
  where?: InputMaybe<domainUserCategoryBoolExp>;
};


export type query_rootdomainUserCategoryArgs = {
  value: Scalars['String']['input'];
};


export type query_rootdomainUsersArgs = {
  distinctOn?: InputMaybe<Array<domainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainUserOrderBy>>;
  where?: InputMaybe<domainUserBoolExp>;
};


export type query_rootdomainUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<domainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainUserOrderBy>>;
  where?: InputMaybe<domainUserBoolExp>;
};


export type query_rootgetDashboardDataArgs = {
  timestamptz: Scalars['timestamptz']['input'];
};


export type query_rootgetEmailAccountArgs = {
  account: getEmailAccountInput;
};


export type query_rootgetOrganizationArgs = {
  orgId?: InputMaybe<Scalars['uuid']['input']>;
};


export type query_rootgetOrganizationsArgs = {
  orgId?: InputMaybe<Scalars['uuid']['input']>;
  userId: Scalars['uuid']['input'];
};


export type query_rootgetUserArgs = {
  user: userInput;
};


export type query_rootincomingSmsArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootisPhoneUserArgs = {
  user: Scalars['String']['input'];
};


export type query_rootlanguageArgs = {
  value: Scalars['String']['input'];
};


export type query_rootlanguageAggregateArgs = {
  distinctOn?: InputMaybe<Array<languagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<languagesOrderBy>>;
  where?: InputMaybe<languagesBoolExp>;
};


export type query_rootlanguagesArgs = {
  distinctOn?: InputMaybe<Array<languagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<languagesOrderBy>>;
  where?: InputMaybe<languagesBoolExp>;
};


export type query_rootlookupPhoneNumberArgs = {
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  providerClientId?: InputMaybe<Scalars['String']['input']>;
};


export type query_rootmessageArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootmessageTypeArgs = {
  value: Scalars['String']['input'];
};


export type query_rootmessageTypesArgs = {
  distinctOn?: InputMaybe<Array<messageTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messageTypeOrderBy>>;
  where?: InputMaybe<messageTypeBoolExp>;
};


export type query_rootmessageTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<messageTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messageTypeOrderBy>>;
  where?: InputMaybe<messageTypeBoolExp>;
};


export type query_rootmessagesArgs = {
  distinctOn?: InputMaybe<Array<messageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messageOrderBy>>;
  where?: InputMaybe<messageBoolExp>;
};


export type query_rootmessagesAggregateArgs = {
  distinctOn?: InputMaybe<Array<messageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messageOrderBy>>;
  where?: InputMaybe<messageBoolExp>;
};


export type query_rootmessagingActivitiesArgs = {
  distinctOn?: InputMaybe<Array<messagingActivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingActivityOrderBy>>;
  where?: InputMaybe<messagingActivityBoolExp>;
};


export type query_rootmessagingActivityArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootmessagingActivityOrganizationArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootmessagingActivityOrganizationAggregateArgs = {
  distinctOn?: InputMaybe<Array<messagingActivityOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingActivityOrganizationOrderBy>>;
  where?: InputMaybe<messagingActivityOrganizationBoolExp>;
};


export type query_rootmessagingActivityOrganizationsArgs = {
  distinctOn?: InputMaybe<Array<messagingActivityOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingActivityOrganizationOrderBy>>;
  where?: InputMaybe<messagingActivityOrganizationBoolExp>;
};


export type query_rootmessagingActivitySettingsArgs = {
  distinctOn?: InputMaybe<Array<MessagingActivitySettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingActivitySettingsOrderBy>>;
  where?: InputMaybe<MessagingActivitySettingsBoolExp>;
};


export type query_rootmessagingActivitySettingsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MessagingActivitySettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingActivitySettingsOrderBy>>;
  where?: InputMaybe<MessagingActivitySettingsBoolExp>;
};


export type query_rootmessagingActivitySettingsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootmessagingActivitySettingsNotificationSettingTypeArgs = {
  distinctOn?: InputMaybe<Array<MessagingActivitySettingsNotificationSettingTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingActivitySettingsNotificationSettingTypeOrderBy>>;
  where?: InputMaybe<MessagingActivitySettingsNotificationSettingTypeBoolExp>;
};


export type query_rootmessagingActivitySettingsNotificationSettingTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<MessagingActivitySettingsNotificationSettingTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingActivitySettingsNotificationSettingTypeOrderBy>>;
  where?: InputMaybe<MessagingActivitySettingsNotificationSettingTypeBoolExp>;
};


export type query_rootmessagingActivitySettingsNotificationSettingTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type query_rootmessagingActivityTypeArgs = {
  value: Scalars['String']['input'];
};


export type query_rootmessagingActivityTypesArgs = {
  distinctOn?: InputMaybe<Array<messagingActivityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingActivityTypeOrderBy>>;
  where?: InputMaybe<messagingActivityTypeBoolExp>;
};


export type query_rootmessagingActivityUserArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootmessagingActivityUsersArgs = {
  distinctOn?: InputMaybe<Array<messagingActivityUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingActivityUserOrderBy>>;
  where?: InputMaybe<messagingActivityUserBoolExp>;
};


export type query_rootmessagingInvitationArgs = {
  distinctOn?: InputMaybe<Array<MessagingInvitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingInvitationOrderBy>>;
  where?: InputMaybe<MessagingInvitationBoolExp>;
};


export type query_rootmessagingInvitationAggregateArgs = {
  distinctOn?: InputMaybe<Array<MessagingInvitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingInvitationOrderBy>>;
  where?: InputMaybe<MessagingInvitationBoolExp>;
};


export type query_rootmessagingInvitationByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootmessagingMentionsArgs = {
  distinctOn?: InputMaybe<Array<MessagingMentionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingMentionsOrderBy>>;
  where?: InputMaybe<MessagingMentionsBoolExp>;
};


export type query_rootmessagingMentionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MessagingMentionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingMentionsOrderBy>>;
  where?: InputMaybe<MessagingMentionsBoolExp>;
};


export type query_rootmessagingMentionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootmessagingMessageArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootmessagingMessageAttachmentArgs = {
  distinctOn?: InputMaybe<Array<MessagingMessageAttachmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingMessageAttachmentOrderBy>>;
  where?: InputMaybe<MessagingMessageAttachmentBoolExp>;
};


export type query_rootmessagingMessageAttachmentAggregateArgs = {
  distinctOn?: InputMaybe<Array<MessagingMessageAttachmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingMessageAttachmentOrderBy>>;
  where?: InputMaybe<MessagingMessageAttachmentBoolExp>;
};


export type query_rootmessagingMessageAttachmentByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootmessagingMessageAttachmentTypeArgs = {
  distinctOn?: InputMaybe<Array<MessagingMessageAttachmentTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingMessageAttachmentTypeOrderBy>>;
  where?: InputMaybe<MessagingMessageAttachmentTypeBoolExp>;
};


export type query_rootmessagingMessageAttachmentTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<MessagingMessageAttachmentTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingMessageAttachmentTypeOrderBy>>;
  where?: InputMaybe<MessagingMessageAttachmentTypeBoolExp>;
};


export type query_rootmessagingMessageAttachmentTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type query_rootmessagingMessageEmojiArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootmessagingMessageEmojisArgs = {
  distinctOn?: InputMaybe<Array<messagingMessageEmojiSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingMessageEmojiOrderBy>>;
  where?: InputMaybe<messagingMessageEmojiBoolExp>;
};


export type query_rootmessagingMessagePriorityArgs = {
  distinctOn?: InputMaybe<Array<MessagingMessagePrioritySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingMessagePriorityOrderBy>>;
  where?: InputMaybe<MessagingMessagePriorityBoolExp>;
};


export type query_rootmessagingMessagePriorityAggregateArgs = {
  distinctOn?: InputMaybe<Array<MessagingMessagePrioritySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingMessagePriorityOrderBy>>;
  where?: InputMaybe<MessagingMessagePriorityBoolExp>;
};


export type query_rootmessagingMessagePriorityByPkArgs = {
  value: Scalars['String']['input'];
};


export type query_rootmessagingMessageReadArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootmessagingMessageReadsArgs = {
  distinctOn?: InputMaybe<Array<messagingMessageReadSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingMessageReadOrderBy>>;
  where?: InputMaybe<messagingMessageReadBoolExp>;
};


export type query_rootmessagingMessageTypeArgs = {
  value: Scalars['String']['input'];
};


export type query_rootmessagingMessageTypesArgs = {
  distinctOn?: InputMaybe<Array<messagingMessageTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingMessageTypeOrderBy>>;
  where?: InputMaybe<messagingMessageTypeBoolExp>;
};


export type query_rootmessagingMessagesArgs = {
  distinctOn?: InputMaybe<Array<messagingMessageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingMessageOrderBy>>;
  where?: InputMaybe<messagingMessageBoolExp>;
};


export type query_rootnotificationArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootnotificationNotificationDeviceSentArgs = {
  distinctOn?: InputMaybe<Array<NotificationNotificationDeviceSentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationNotificationDeviceSentOrderBy>>;
  where?: InputMaybe<NotificationNotificationDeviceSentBoolExp>;
};


export type query_rootnotificationNotificationDeviceSentAggregateArgs = {
  distinctOn?: InputMaybe<Array<NotificationNotificationDeviceSentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationNotificationDeviceSentOrderBy>>;
  where?: InputMaybe<NotificationNotificationDeviceSentBoolExp>;
};


export type query_rootnotificationNotificationDeviceSentByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootnotificationNotificationSettingActivityPrimaryEnumArgs = {
  distinctOn?: InputMaybe<Array<NotificationNotificationSettingActivityPrimaryEnumSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationNotificationSettingActivityPrimaryEnumOrderBy>>;
  where?: InputMaybe<NotificationNotificationSettingActivityPrimaryEnumBoolExp>;
};


export type query_rootnotificationNotificationSettingActivityPrimaryEnumAggregateArgs = {
  distinctOn?: InputMaybe<Array<NotificationNotificationSettingActivityPrimaryEnumSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationNotificationSettingActivityPrimaryEnumOrderBy>>;
  where?: InputMaybe<NotificationNotificationSettingActivityPrimaryEnumBoolExp>;
};


export type query_rootnotificationNotificationSettingActivityPrimaryEnumByPkArgs = {
  value: Scalars['String']['input'];
};


export type query_rootnotificationSendArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootnotificationSendsArgs = {
  distinctOn?: InputMaybe<Array<notificationSendSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<notificationSendOrderBy>>;
  where?: InputMaybe<notificationSendBoolExp>;
};


export type query_rootnotificationSendsAggregateArgs = {
  distinctOn?: InputMaybe<Array<notificationSendSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<notificationSendOrderBy>>;
  where?: InputMaybe<notificationSendBoolExp>;
};


export type query_rootnotificationSettingActivitiesArgs = {
  distinctOn?: InputMaybe<Array<notificationSettingActivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<notificationSettingActivityOrderBy>>;
  where?: InputMaybe<notificationSettingActivityBoolExp>;
};


export type query_rootnotificationSettingActivitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<notificationSettingActivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<notificationSettingActivityOrderBy>>;
  where?: InputMaybe<notificationSettingActivityBoolExp>;
};


export type query_rootnotificationSettingActivityArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootnotificationUserArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootnotificationUserDeviceArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootnotificationUserDevicesArgs = {
  distinctOn?: InputMaybe<Array<notificationUserDeviceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<notificationUserDeviceOrderBy>>;
  where?: InputMaybe<notificationUserDeviceBoolExp>;
};


export type query_rootnotificationUserDevicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<notificationUserDeviceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<notificationUserDeviceOrderBy>>;
  where?: InputMaybe<notificationUserDeviceBoolExp>;
};


export type query_rootnotificationUsersArgs = {
  distinctOn?: InputMaybe<Array<notificationUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<notificationUserOrderBy>>;
  where?: InputMaybe<notificationUserBoolExp>;
};


export type query_rootnotificationUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<notificationUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<notificationUserOrderBy>>;
  where?: InputMaybe<notificationUserBoolExp>;
};


export type query_rootnotificationsArgs = {
  distinctOn?: InputMaybe<Array<notificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<notificationOrderBy>>;
  where?: InputMaybe<notificationBoolExp>;
};


export type query_rootnotificationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<notificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<notificationOrderBy>>;
  where?: InputMaybe<notificationBoolExp>;
};


export type query_rootordersIntegrationArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootordersIntegrationsArgs = {
  distinctOn?: InputMaybe<Array<ordersIntegrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ordersIntegrationsOrderBy>>;
  where?: InputMaybe<ordersIntegrationsBoolExp>;
};


export type query_rootordersIntegrationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ordersIntegrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ordersIntegrationsOrderBy>>;
  where?: InputMaybe<ordersIntegrationsBoolExp>;
};


export type query_rootordersOrganizationsArgs = {
  distinctOn?: InputMaybe<Array<OrdersOrganizationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersOrganizationsOrderBy>>;
  where?: InputMaybe<OrdersOrganizationsBoolExp>;
};


export type query_rootordersOrganizationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<OrdersOrganizationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersOrganizationsOrderBy>>;
  where?: InputMaybe<OrdersOrganizationsBoolExp>;
};


export type query_rootordersOrganizationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootordersRequestArgs = {
  distinctOn?: InputMaybe<Array<OrdersRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersRequestOrderBy>>;
  where?: InputMaybe<OrdersRequestBoolExp>;
};


export type query_rootordersRequestAggregateArgs = {
  distinctOn?: InputMaybe<Array<OrdersRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersRequestOrderBy>>;
  where?: InputMaybe<OrdersRequestBoolExp>;
};


export type query_rootordersRequestByPkArgs = {
  value: Scalars['String']['input'];
};


export type query_rootordersStatusArgs = {
  distinctOn?: InputMaybe<Array<OrdersStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersStatusOrderBy>>;
  where?: InputMaybe<OrdersStatusBoolExp>;
};


export type query_rootordersStatusAggregateArgs = {
  distinctOn?: InputMaybe<Array<OrdersStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersStatusOrderBy>>;
  where?: InputMaybe<OrdersStatusBoolExp>;
};


export type query_rootordersStatusByPkArgs = {
  value: Scalars['String']['input'];
};


export type query_rootordersTypeArgs = {
  distinctOn?: InputMaybe<Array<OrdersTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersTypeOrderBy>>;
  where?: InputMaybe<OrdersTypeBoolExp>;
};


export type query_rootordersTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<OrdersTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersTypeOrderBy>>;
  where?: InputMaybe<OrdersTypeBoolExp>;
};


export type query_rootordersTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type query_rootorganizationArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootorganizationAuthorizationEnumGroupArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootorganizationAuthorizationEnumGroupsArgs = {
  distinctOn?: InputMaybe<Array<organizationAuthorizationEnumGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationAuthorizationEnumGroupOrderBy>>;
  where?: InputMaybe<organizationAuthorizationEnumGroupBoolExp>;
};


export type query_rootorganizationAuthorizationGroupArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootorganizationAuthorizationGroupsArgs = {
  distinctOn?: InputMaybe<Array<organizationAuthorizationGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationAuthorizationGroupOrderBy>>;
  where?: InputMaybe<organizationAuthorizationGroupBoolExp>;
};


export type query_rootorganizationOrganizationRelationshipArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootorganizationOrganizationRelationshipCategoriesArgs = {
  distinctOn?: InputMaybe<Array<organizationOrganizationRelationshipCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrganizationRelationshipCategoryOrderBy>>;
  where?: InputMaybe<organizationOrganizationRelationshipCategoryBoolExp>;
};


export type query_rootorganizationOrganizationRelationshipCategoryArgs = {
  value: Scalars['String']['input'];
};


export type query_rootorganizationOrganizationRelationshipsArgs = {
  distinctOn?: InputMaybe<Array<organizationOrganizationRelationshipSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrganizationRelationshipOrderBy>>;
  where?: InputMaybe<organizationOrganizationRelationshipBoolExp>;
};


export type query_rootorganizationOrganizationUserAuthorizationArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootorganizationOrganizationUserAuthorizationsArgs = {
  distinctOn?: InputMaybe<Array<organizationOrganizationUserAuthorizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrganizationUserAuthorizationOrderBy>>;
  where?: InputMaybe<organizationOrganizationUserAuthorizationBoolExp>;
};


export type query_rootorganizationOrganizationUserOrganizationsViewsArgs = {
  distinctOn?: InputMaybe<Array<organizationOrganizationUserOrganizationsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrganizationUserOrganizationsViewOrderBy>>;
  where?: InputMaybe<organizationOrganizationUserOrganizationsViewBoolExp>;
};


export type query_rootorganizationOrganizationUserUsersViewsArgs = {
  distinctOn?: InputMaybe<Array<organizationOrganizationUserUsersViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrganizationUserUsersViewOrderBy>>;
  where?: InputMaybe<organizationOrganizationUserUsersViewBoolExp>;
};


export type query_rootorganizationUserArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootorganizationUserAttachmentArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootorganizationUserAttachmentsArgs = {
  distinctOn?: InputMaybe<Array<organizationUserAttachmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserAttachmentsOrderBy>>;
  where?: InputMaybe<organizationUserAttachmentsBoolExp>;
};


export type query_rootorganizationUserAttachmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<organizationUserAttachmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserAttachmentsOrderBy>>;
  where?: InputMaybe<organizationUserAttachmentsBoolExp>;
};


export type query_rootorganizationUserAttentionNoteArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootorganizationUserAttentionNoteAggregateArgs = {
  distinctOn?: InputMaybe<Array<OrganizationUserAttentionNoteSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationUserAttentionNoteOrderBy>>;
  where?: InputMaybe<OrganizationUserAttentionNoteBoolExp>;
};


export type query_rootorganizationUserAttentionNotesArgs = {
  distinctOn?: InputMaybe<Array<OrganizationUserAttentionNoteSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationUserAttentionNoteOrderBy>>;
  where?: InputMaybe<OrganizationUserAttentionNoteBoolExp>;
};


export type query_rootorganizationUserAuthorizationArgs = {
  value: Scalars['String']['input'];
};


export type query_rootorganizationUserAuthorizationsArgs = {
  distinctOn?: InputMaybe<Array<organizationUserAuthorizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserAuthorizationOrderBy>>;
  where?: InputMaybe<organizationUserAuthorizationBoolExp>;
};


export type query_rootorganizationUserDetailArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootorganizationUserDetailTypeArgs = {
  value: Scalars['String']['input'];
};


export type query_rootorganizationUserDetailTypesArgs = {
  distinctOn?: InputMaybe<Array<organizationUserDetailTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserDetailTypeOrderBy>>;
  where?: InputMaybe<organizationUserDetailTypeBoolExp>;
};


export type query_rootorganizationUserDetailTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<organizationUserDetailTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserDetailTypeOrderBy>>;
  where?: InputMaybe<organizationUserDetailTypeBoolExp>;
};


export type query_rootorganizationUserDetailsArgs = {
  distinctOn?: InputMaybe<Array<organizationUserDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserDetailOrderBy>>;
  where?: InputMaybe<organizationUserDetailBoolExp>;
};


export type query_rootorganizationUserDetailsAggregateArgs = {
  distinctOn?: InputMaybe<Array<organizationUserDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserDetailOrderBy>>;
  where?: InputMaybe<organizationUserDetailBoolExp>;
};


export type query_rootorganizationUserInviteArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootorganizationUserInvitesArgs = {
  distinctOn?: InputMaybe<Array<organizationUserInviteSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserInviteOrderBy>>;
  where?: InputMaybe<organizationUserInviteBoolExp>;
};


export type query_rootorganizationUserInvitesAggregateArgs = {
  distinctOn?: InputMaybe<Array<organizationUserInviteSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserInviteOrderBy>>;
  where?: InputMaybe<organizationUserInviteBoolExp>;
};


export type query_rootorganizationUserRequestArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootorganizationUserRequestsArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserRequestOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserRequestBoolExp>;
};


export type query_rootorganizationUserStatusArgs = {
  value: Scalars['String']['input'];
};


export type query_rootorganizationUserStatusesArgs = {
  distinctOn?: InputMaybe<Array<organizationUserStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserStatusOrderBy>>;
  where?: InputMaybe<organizationUserStatusBoolExp>;
};


export type query_rootorganizationUserStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<organizationUserStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserStatusOrderBy>>;
  where?: InputMaybe<organizationUserStatusBoolExp>;
};


export type query_rootorganizationUsersArgs = {
  distinctOn?: InputMaybe<Array<organizationUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserOrderBy>>;
  where?: InputMaybe<organizationUserBoolExp>;
};


export type query_rootorganizationUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<organizationUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserOrderBy>>;
  where?: InputMaybe<organizationUserBoolExp>;
};


export type query_rootorganizationsArgs = {
  distinctOn?: InputMaybe<Array<organizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrderBy>>;
  where?: InputMaybe<organizationBoolExp>;
};


export type query_rootorganizationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<organizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrderBy>>;
  where?: InputMaybe<organizationBoolExp>;
};


export type query_rootphoneNumberVerificationStatusArgs = {
  value: Scalars['String']['input'];
};


export type query_rootphoneNumberVerificationStatusesArgs = {
  distinctOn?: InputMaybe<Array<phoneNumberVerificationStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<phoneNumberVerificationStatusOrderBy>>;
  where?: InputMaybe<phoneNumberVerificationStatusBoolExp>;
};


export type query_rootphoneNumberVerificationStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<phoneNumberVerificationStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<phoneNumberVerificationStatusOrderBy>>;
  where?: InputMaybe<phoneNumberVerificationStatusBoolExp>;
};


export type query_rootpromptArgs = {
  distinctOn?: InputMaybe<Array<PromptSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PromptOrderBy>>;
  where?: InputMaybe<PromptBoolExp>;
};


export type query_rootpromptAggregateArgs = {
  distinctOn?: InputMaybe<Array<PromptSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PromptOrderBy>>;
  where?: InputMaybe<PromptBoolExp>;
};


export type query_rootpromptByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootpublicDeviceArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootpublicDevicesArgs = {
  distinctOn?: InputMaybe<Array<publicDeviceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<publicDeviceOrderBy>>;
  where?: InputMaybe<publicDeviceBoolExp>;
};


export type query_rootpublicExternalRequestArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootpublicExternalRequestsArgs = {
  distinctOn?: InputMaybe<Array<publicExternalRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<publicExternalRequestOrderBy>>;
  where?: InputMaybe<publicExternalRequestBoolExp>;
};


export type query_rootpublicFileArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootpublicFilesArgs = {
  distinctOn?: InputMaybe<Array<publicFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<publicFileOrderBy>>;
  where?: InputMaybe<publicFileBoolExp>;
};


export type query_rootpublicNotificationArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootpublicNotificationsArgs = {
  distinctOn?: InputMaybe<Array<publicNotificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<publicNotificationOrderBy>>;
  where?: InputMaybe<publicNotificationBoolExp>;
};


export type query_rootqueueItemArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootqueueItemsArgs = {
  distinctOn?: InputMaybe<Array<queueItemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<queueItemOrderBy>>;
  where?: InputMaybe<queueItemBoolExp>;
};


export type query_rootqueueItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<queueItemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<queueItemOrderBy>>;
  where?: InputMaybe<queueItemBoolExp>;
};


export type query_rootrelOrganizationUserDomainUserArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootrelOrganizationUserDomainUsersArgs = {
  distinctOn?: InputMaybe<Array<relOrganizationUserDomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<relOrganizationUserDomainUserOrderBy>>;
  where?: InputMaybe<relOrganizationUserDomainUserBoolExp>;
};


export type query_rootrelOrganizationUserDomainUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<relOrganizationUserDomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<relOrganizationUserDomainUserOrderBy>>;
  where?: InputMaybe<relOrganizationUserDomainUserBoolExp>;
};


export type query_rootsmsConnectorArgs = {
  id: Scalars['Int']['input'];
};


export type query_rootsmsConnectorsArgs = {
  distinctOn?: InputMaybe<Array<smsConnectorSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsConnectorOrderBy>>;
  where?: InputMaybe<smsConnectorBoolExp>;
};


export type query_rootsmsGateArgs = {
  id: Scalars['Int']['input'];
};


export type query_rootsmsGatesArgs = {
  distinctOn?: InputMaybe<Array<smsGateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsGateOrderBy>>;
  where?: InputMaybe<smsGateBoolExp>;
};


export type query_rootsmsLinkMobilitySmsContentArgs = {
  uuid: Scalars['uuid']['input'];
};


export type query_rootsmsLinkMobilitySmsContentsArgs = {
  distinctOn?: InputMaybe<Array<smsLinkMobilitySmsContentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsLinkMobilitySmsContentOrderBy>>;
  where?: InputMaybe<smsLinkMobilitySmsContentBoolExp>;
};


export type query_rootsmsLinkMobilitySmsMessageArgs = {
  uuid: Scalars['uuid']['input'];
};


export type query_rootsmsLinkMobilitySmsMessagesArgs = {
  distinctOn?: InputMaybe<Array<smsLinkMobilitySmsMessageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsLinkMobilitySmsMessageOrderBy>>;
  where?: InputMaybe<smsLinkMobilitySmsMessageBoolExp>;
};


export type query_rootsmsLinkMobilitySmsRouteArgs = {
  uuid: Scalars['uuid']['input'];
};


export type query_rootsmsLinkMobilitySmsRoutesArgs = {
  distinctOn?: InputMaybe<Array<smsLinkMobilitySmsRouteSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsLinkMobilitySmsRouteOrderBy>>;
  where?: InputMaybe<smsLinkMobilitySmsRouteBoolExp>;
};


export type query_rootsmsProviderArgs = {
  id: Scalars['Int']['input'];
};


export type query_rootsmsProvidersArgs = {
  distinctOn?: InputMaybe<Array<smsProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsProviderOrderBy>>;
  where?: InputMaybe<smsProviderBoolExp>;
};


export type query_rootsmsSmArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootsmsSmsArgs = {
  distinctOn?: InputMaybe<Array<smsSmSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsSmOrderBy>>;
  where?: InputMaybe<smsSmBoolExp>;
};


export type query_rootsmsSmsExternalIncomingLinkMobilitiesArgs = {
  distinctOn?: InputMaybe<Array<smsSmsExternalIncomingLinkMobilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsSmsExternalIncomingLinkMobilityOrderBy>>;
  where?: InputMaybe<smsSmsExternalIncomingLinkMobilityBoolExp>;
};


export type query_rootsmsSmsExternalIncomingLinkMobilityArgs = {
  uuid: Scalars['uuid']['input'];
};


export type query_rootuserArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootuserDetailArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootuserDetailsArgs = {
  distinctOn?: InputMaybe<Array<userDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<userDetailOrderBy>>;
  where?: InputMaybe<userDetailBoolExp>;
};


export type query_rootuserDetailsAggregateArgs = {
  distinctOn?: InputMaybe<Array<userDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<userDetailOrderBy>>;
  where?: InputMaybe<userDetailBoolExp>;
};


export type query_rootuserDetailsTypeArgs = {
  value: Scalars['String']['input'];
};


export type query_rootuserDetailsTypesArgs = {
  distinctOn?: InputMaybe<Array<userDetailsTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<userDetailsTypeOrderBy>>;
  where?: InputMaybe<userDetailsTypeBoolExp>;
};


export type query_rootuserDetailsTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<userDetailsTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<userDetailsTypeOrderBy>>;
  where?: InputMaybe<userDetailsTypeBoolExp>;
};


export type query_rootuserDeviceArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootuserDevicesArgs = {
  distinctOn?: InputMaybe<Array<userDeviceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<userDeviceOrderBy>>;
  where?: InputMaybe<userDeviceBoolExp>;
};


export type query_rootuserDevicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<userDeviceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<userDeviceOrderBy>>;
  where?: InputMaybe<userDeviceBoolExp>;
};


export type query_rootuserPhoneNumberArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootuserPhoneNumbersArgs = {
  distinctOn?: InputMaybe<Array<userPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<userPhoneNumberOrderBy>>;
  where?: InputMaybe<userPhoneNumberBoolExp>;
};


export type query_rootuserPhoneNumbersAggregateArgs = {
  distinctOn?: InputMaybe<Array<userPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<userPhoneNumberOrderBy>>;
  where?: InputMaybe<userPhoneNumberBoolExp>;
};


export type query_rootuserRoleArgs = {
  value: Scalars['String']['input'];
};


export type query_rootuserRolesArgs = {
  distinctOn?: InputMaybe<Array<userRoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<userRoleOrderBy>>;
  where?: InputMaybe<userRoleBoolExp>;
};


export type query_rootuserRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<userRoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<userRoleOrderBy>>;
  where?: InputMaybe<userRoleBoolExp>;
};


export type query_rootusersArgs = {
  distinctOn?: InputMaybe<Array<userSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<userOrderBy>>;
  where?: InputMaybe<userBoolExp>;
};


export type query_rootusersAggregateArgs = {
  distinctOn?: InputMaybe<Array<userSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<userOrderBy>>;
  where?: InputMaybe<userBoolExp>;
};


export type query_rootvalidationValidationArgs = {
  id: Scalars['uuid']['input'];
};


export type query_rootvalidationValidationsArgs = {
  distinctOn?: InputMaybe<Array<validationValidationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<validationValidationOrderBy>>;
  where?: InputMaybe<validationValidationBoolExp>;
};


export type query_rootvoiceTypesArgs = {
  distinctOn?: InputMaybe<Array<VoiceTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoiceTypesOrderBy>>;
  where?: InputMaybe<VoiceTypesBoolExp>;
};


export type query_rootvoiceTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VoiceTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoiceTypesOrderBy>>;
  where?: InputMaybe<VoiceTypesBoolExp>;
};


export type query_rootvoiceTypesByPkArgs = {
  value: Scalars['String']['input'];
};

/** columns and relationships of "business.queue_item" */
export type queueItem = {
  __typename?: 'queueItem';
  /** An object relationship */
  activityStatus?: Maybe<ActivityStatus>;
  /** An object relationship */
  activity_type?: Maybe<ActivityType>;
  additionalData?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  alarms: Array<BusinessQueueItemAlarms>;
  /** An aggregate relationship */
  alarmsAggregate: BusinessQueueItemAlarmsAggregate;
  createdAt: Scalars['timestamptz']['output'];
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  deletionAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  domainActivity?: Maybe<domainActivity>;
  domainActivityId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  domainUsers: Array<BusinessQueueItemDomainUsersView>;
  /** An aggregate relationship */
  domainUsersAggregate: BusinessQueueItemDomainUsersViewAggregate;
  dueDate?: Maybe<Scalars['timestamptz']['output']>;
  flexibilityType?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  flexibility_type?: Maybe<QueueItemFlexibilityType>;
  id: Scalars['uuid']['output'];
  location?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  messages: Array<message>;
  /** An aggregate relationship */
  messagesAggregate: messageAggregate;
  /** An object relationship */
  organization?: Maybe<organization>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  organizationUsers: Array<BusinessQueueItemOrganizationUsersView>;
  /** An aggregate relationship */
  organizationUsersAggregate: BusinessQueueItemOrganizationUsersViewAggregate;
  ownerOrganizationUserId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  owner_organization_user?: Maybe<organizationUser>;
  /** An array relationship */
  participants: Array<BusinessQueueItemParticipantsView>;
  /** An aggregate relationship */
  participantsAggregate: BusinessQueueItemParticipantsViewAggregate;
  private: Scalars['Boolean']['output'];
  /** An array relationship */
  queueParticipants: Array<activityParticipant>;
  /** An aggregate relationship */
  queueParticipantsAggregate: activityParticipantAggregate;
  /** An array relationship */
  relatedQueueItem: Array<queueItem>;
  /** An aggregate relationship */
  relatedQueueItemAggregate: queueItemAggregate;
  relatedQueueItemId?: Maybe<Scalars['uuid']['output']>;
  searchText?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<ActivityStatusEnum>;
  subTitle?: Maybe<Scalars['String']['output']>;
  subType?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  sub_type?: Maybe<BusinessQueueItemSubType>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ActivityTypeEnum>;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "business.queue_item" */
export type queueItemadditionalDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "business.queue_item" */
export type queueItemalarmsArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemAlarmsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemAlarmsOrderBy>>;
  where?: InputMaybe<BusinessQueueItemAlarmsBoolExp>;
};


/** columns and relationships of "business.queue_item" */
export type queueItemalarmsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemAlarmsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemAlarmsOrderBy>>;
  where?: InputMaybe<BusinessQueueItemAlarmsBoolExp>;
};


/** columns and relationships of "business.queue_item" */
export type queueItemdomainUsersArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemDomainUsersViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemDomainUsersViewOrderBy>>;
  where?: InputMaybe<BusinessQueueItemDomainUsersViewBoolExp>;
};


/** columns and relationships of "business.queue_item" */
export type queueItemdomainUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemDomainUsersViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemDomainUsersViewOrderBy>>;
  where?: InputMaybe<BusinessQueueItemDomainUsersViewBoolExp>;
};


/** columns and relationships of "business.queue_item" */
export type queueItemmessagesArgs = {
  distinctOn?: InputMaybe<Array<messageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messageOrderBy>>;
  where?: InputMaybe<messageBoolExp>;
};


/** columns and relationships of "business.queue_item" */
export type queueItemmessagesAggregateArgs = {
  distinctOn?: InputMaybe<Array<messageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messageOrderBy>>;
  where?: InputMaybe<messageBoolExp>;
};


/** columns and relationships of "business.queue_item" */
export type queueItemorganizationUsersArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemOrganizationUsersViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemOrganizationUsersViewOrderBy>>;
  where?: InputMaybe<BusinessQueueItemOrganizationUsersViewBoolExp>;
};


/** columns and relationships of "business.queue_item" */
export type queueItemorganizationUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemOrganizationUsersViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemOrganizationUsersViewOrderBy>>;
  where?: InputMaybe<BusinessQueueItemOrganizationUsersViewBoolExp>;
};


/** columns and relationships of "business.queue_item" */
export type queueItemparticipantsArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemParticipantsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemParticipantsViewOrderBy>>;
  where?: InputMaybe<BusinessQueueItemParticipantsViewBoolExp>;
};


/** columns and relationships of "business.queue_item" */
export type queueItemparticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemParticipantsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemParticipantsViewOrderBy>>;
  where?: InputMaybe<BusinessQueueItemParticipantsViewBoolExp>;
};


/** columns and relationships of "business.queue_item" */
export type queueItemqueueParticipantsArgs = {
  distinctOn?: InputMaybe<Array<activityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<activityParticipantOrderBy>>;
  where?: InputMaybe<activityParticipantBoolExp>;
};


/** columns and relationships of "business.queue_item" */
export type queueItemqueueParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<activityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<activityParticipantOrderBy>>;
  where?: InputMaybe<activityParticipantBoolExp>;
};


/** columns and relationships of "business.queue_item" */
export type queueItemrelatedQueueItemArgs = {
  distinctOn?: InputMaybe<Array<queueItemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<queueItemOrderBy>>;
  where?: InputMaybe<queueItemBoolExp>;
};


/** columns and relationships of "business.queue_item" */
export type queueItemrelatedQueueItemAggregateArgs = {
  distinctOn?: InputMaybe<Array<queueItemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<queueItemOrderBy>>;
  where?: InputMaybe<queueItemBoolExp>;
};

/** aggregated selection of "business.queue_item" */
export type queueItemAggregate = {
  __typename?: 'queueItemAggregate';
  aggregate?: Maybe<queueItemAggregateFields>;
  nodes: Array<queueItem>;
};

export type queueItemAggregateBoolExp = {
  bool_and?: InputMaybe<queueItemAggregateBoolExpBool_and>;
  bool_or?: InputMaybe<queueItemAggregateBoolExpBool_or>;
  count?: InputMaybe<queueItemAggregateBoolExpCount>;
};

export type queueItemAggregateBoolExpBool_and = {
  arguments: queueItemSelectColumnQueueItemAggregateBoolExpBool_andArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<queueItemBoolExp>;
  predicate: BooleanComparisonExp;
};

export type queueItemAggregateBoolExpBool_or = {
  arguments: queueItemSelectColumnQueueItemAggregateBoolExpBool_orArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<queueItemBoolExp>;
  predicate: BooleanComparisonExp;
};

export type queueItemAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<queueItemSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<queueItemBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "business.queue_item" */
export type queueItemAggregateFields = {
  __typename?: 'queueItemAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<queueItemMaxFields>;
  min?: Maybe<queueItemMinFields>;
};


/** aggregate fields of "business.queue_item" */
export type queueItemAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<queueItemSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.queue_item" */
export type queueItemAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<queueItemMaxOrderBy>;
  min?: InputMaybe<queueItemMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type queueItemAppendInput = {
  additionalData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "business.queue_item" */
export type queueItemArrRelInsertInput = {
  data: Array<queueItemInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<queueItemOnConflict>;
};

/** Boolean expression to filter rows from the table "business.queue_item". All fields are combined with a logical 'AND'. */
export type queueItemBoolExp = {
  _and?: InputMaybe<Array<queueItemBoolExp>>;
  _not?: InputMaybe<queueItemBoolExp>;
  _or?: InputMaybe<Array<queueItemBoolExp>>;
  activityStatus?: InputMaybe<ActivityStatusBoolExp>;
  activity_type?: InputMaybe<ActivityTypeBoolExp>;
  additionalData?: InputMaybe<JsonbComparisonExp>;
  alarms?: InputMaybe<BusinessQueueItemAlarmsBoolExp>;
  alarmsAggregate?: InputMaybe<BusinessQueueItemAlarmsAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdByUserId?: InputMaybe<UuidComparisonExp>;
  deletionAt?: InputMaybe<TimestamptzComparisonExp>;
  domainActivity?: InputMaybe<domainActivityBoolExp>;
  domainActivityId?: InputMaybe<UuidComparisonExp>;
  domainUsers?: InputMaybe<BusinessQueueItemDomainUsersViewBoolExp>;
  domainUsersAggregate?: InputMaybe<BusinessQueueItemDomainUsersViewAggregateBoolExp>;
  dueDate?: InputMaybe<TimestamptzComparisonExp>;
  flexibilityType?: InputMaybe<StringComparisonExp>;
  flexibility_type?: InputMaybe<QueueItemFlexibilityTypeBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  location?: InputMaybe<StringComparisonExp>;
  messages?: InputMaybe<messageBoolExp>;
  messagesAggregate?: InputMaybe<messageAggregateBoolExp>;
  organization?: InputMaybe<organizationBoolExp>;
  organizationId?: InputMaybe<UuidComparisonExp>;
  organizationUsers?: InputMaybe<BusinessQueueItemOrganizationUsersViewBoolExp>;
  organizationUsersAggregate?: InputMaybe<BusinessQueueItemOrganizationUsersViewAggregateBoolExp>;
  ownerOrganizationUserId?: InputMaybe<UuidComparisonExp>;
  owner_organization_user?: InputMaybe<organizationUserBoolExp>;
  participants?: InputMaybe<BusinessQueueItemParticipantsViewBoolExp>;
  participantsAggregate?: InputMaybe<BusinessQueueItemParticipantsViewAggregateBoolExp>;
  private?: InputMaybe<BooleanComparisonExp>;
  queueParticipants?: InputMaybe<activityParticipantBoolExp>;
  queueParticipantsAggregate?: InputMaybe<activityParticipantAggregateBoolExp>;
  relatedQueueItem?: InputMaybe<queueItemBoolExp>;
  relatedQueueItemAggregate?: InputMaybe<queueItemAggregateBoolExp>;
  relatedQueueItemId?: InputMaybe<UuidComparisonExp>;
  searchText?: InputMaybe<StringComparisonExp>;
  startDate?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<ActivityStatusEnumComparisonExp>;
  subTitle?: InputMaybe<StringComparisonExp>;
  subType?: InputMaybe<StringComparisonExp>;
  sub_type?: InputMaybe<BusinessQueueItemSubTypeBoolExp>;
  title?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<ActivityTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "business.queue_item" */
export type queueItemConstraint =
  /** unique or primary key constraint on columns "domain_activity_id" */
  | 'queue_item_domain_activity_id_key'
  /** unique or primary key constraint on columns "id" */
  | 'queue_item_pkey'
  | '%future added value';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type queueItemDeleteAtPathInput = {
  additionalData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type queueItemDeleteElemInput = {
  additionalData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type queueItemDeleteKeyInput = {
  additionalData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "business.queue_item" */
export type queueItemInsertInput = {
  activityStatus?: InputMaybe<ActivityStatusObjRelInsertInput>;
  activity_type?: InputMaybe<ActivityTypeObjRelInsertInput>;
  additionalData?: InputMaybe<Scalars['jsonb']['input']>;
  alarms?: InputMaybe<BusinessQueueItemAlarmsArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  deletionAt?: InputMaybe<Scalars['timestamptz']['input']>;
  domainActivity?: InputMaybe<domainActivityObjRelInsertInput>;
  domainActivityId?: InputMaybe<Scalars['uuid']['input']>;
  domainUsers?: InputMaybe<BusinessQueueItemDomainUsersViewArrRelInsertInput>;
  dueDate?: InputMaybe<Scalars['timestamptz']['input']>;
  flexibilityType?: InputMaybe<Scalars['String']['input']>;
  flexibility_type?: InputMaybe<QueueItemFlexibilityTypeObjRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<messageArrRelInsertInput>;
  organization?: InputMaybe<organizationObjRelInsertInput>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  organizationUsers?: InputMaybe<BusinessQueueItemOrganizationUsersViewArrRelInsertInput>;
  ownerOrganizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  owner_organization_user?: InputMaybe<organizationUserObjRelInsertInput>;
  participants?: InputMaybe<BusinessQueueItemParticipantsViewArrRelInsertInput>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  queueParticipants?: InputMaybe<activityParticipantArrRelInsertInput>;
  relatedQueueItem?: InputMaybe<queueItemArrRelInsertInput>;
  relatedQueueItemId?: InputMaybe<Scalars['uuid']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<ActivityStatusEnum>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  subType?: InputMaybe<Scalars['String']['input']>;
  sub_type?: InputMaybe<BusinessQueueItemSubTypeObjRelInsertInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ActivityTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type queueItemMaxFields = {
  __typename?: 'queueItemMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  deletionAt?: Maybe<Scalars['timestamptz']['output']>;
  domainActivityId?: Maybe<Scalars['uuid']['output']>;
  dueDate?: Maybe<Scalars['timestamptz']['output']>;
  flexibilityType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  ownerOrganizationUserId?: Maybe<Scalars['uuid']['output']>;
  relatedQueueItemId?: Maybe<Scalars['uuid']['output']>;
  searchText?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['timestamptz']['output']>;
  subTitle?: Maybe<Scalars['String']['output']>;
  subType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "business.queue_item" */
export type queueItemMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  deletionAt?: InputMaybe<OrderBy>;
  domainActivityId?: InputMaybe<OrderBy>;
  dueDate?: InputMaybe<OrderBy>;
  flexibilityType?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  location?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  ownerOrganizationUserId?: InputMaybe<OrderBy>;
  relatedQueueItemId?: InputMaybe<OrderBy>;
  searchText?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
  subTitle?: InputMaybe<OrderBy>;
  subType?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type queueItemMinFields = {
  __typename?: 'queueItemMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdByUserId?: Maybe<Scalars['uuid']['output']>;
  deletionAt?: Maybe<Scalars['timestamptz']['output']>;
  domainActivityId?: Maybe<Scalars['uuid']['output']>;
  dueDate?: Maybe<Scalars['timestamptz']['output']>;
  flexibilityType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  ownerOrganizationUserId?: Maybe<Scalars['uuid']['output']>;
  relatedQueueItemId?: Maybe<Scalars['uuid']['output']>;
  searchText?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['timestamptz']['output']>;
  subTitle?: Maybe<Scalars['String']['output']>;
  subType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "business.queue_item" */
export type queueItemMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  deletionAt?: InputMaybe<OrderBy>;
  domainActivityId?: InputMaybe<OrderBy>;
  dueDate?: InputMaybe<OrderBy>;
  flexibilityType?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  location?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  ownerOrganizationUserId?: InputMaybe<OrderBy>;
  relatedQueueItemId?: InputMaybe<OrderBy>;
  searchText?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
  subTitle?: InputMaybe<OrderBy>;
  subType?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "business.queue_item" */
export type queueItemMutationResponse = {
  __typename?: 'queueItemMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<queueItem>;
};

/** input type for inserting object relation for remote table "business.queue_item" */
export type queueItemObjRelInsertInput = {
  data: queueItemInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<queueItemOnConflict>;
};

/** on_conflict condition type for table "business.queue_item" */
export type queueItemOnConflict = {
  constraint: queueItemConstraint;
  updateColumns?: Array<queueItemUpdateColumn>;
  where?: InputMaybe<queueItemBoolExp>;
};

/** Ordering options when selecting data from "business.queue_item". */
export type queueItemOrderBy = {
  activityStatus?: InputMaybe<ActivityStatusOrderBy>;
  activity_type?: InputMaybe<ActivityTypeOrderBy>;
  additionalData?: InputMaybe<OrderBy>;
  alarmsAggregate?: InputMaybe<BusinessQueueItemAlarmsAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdByUserId?: InputMaybe<OrderBy>;
  deletionAt?: InputMaybe<OrderBy>;
  domainActivity?: InputMaybe<domainActivityOrderBy>;
  domainActivityId?: InputMaybe<OrderBy>;
  domainUsersAggregate?: InputMaybe<BusinessQueueItemDomainUsersViewAggregateOrderBy>;
  dueDate?: InputMaybe<OrderBy>;
  flexibilityType?: InputMaybe<OrderBy>;
  flexibility_type?: InputMaybe<QueueItemFlexibilityTypeOrderBy>;
  id?: InputMaybe<OrderBy>;
  location?: InputMaybe<OrderBy>;
  messagesAggregate?: InputMaybe<messageAggregateOrderBy>;
  organization?: InputMaybe<organizationOrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  organizationUsersAggregate?: InputMaybe<BusinessQueueItemOrganizationUsersViewAggregateOrderBy>;
  ownerOrganizationUserId?: InputMaybe<OrderBy>;
  owner_organization_user?: InputMaybe<organizationUserOrderBy>;
  participantsAggregate?: InputMaybe<BusinessQueueItemParticipantsViewAggregateOrderBy>;
  private?: InputMaybe<OrderBy>;
  queueParticipantsAggregate?: InputMaybe<activityParticipantAggregateOrderBy>;
  relatedQueueItemAggregate?: InputMaybe<queueItemAggregateOrderBy>;
  relatedQueueItemId?: InputMaybe<OrderBy>;
  searchText?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  subTitle?: InputMaybe<OrderBy>;
  subType?: InputMaybe<OrderBy>;
  sub_type?: InputMaybe<BusinessQueueItemSubTypeOrderBy>;
  title?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.queue_item */
export type queueItemPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type queueItemPrependInput = {
  additionalData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "business.queue_item" */
export type queueItemSelectColumn =
  /** column name */
  | 'additionalData'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserId'
  /** column name */
  | 'deletionAt'
  /** column name */
  | 'domainActivityId'
  /** column name */
  | 'dueDate'
  /** column name */
  | 'flexibilityType'
  /** column name */
  | 'id'
  /** column name */
  | 'location'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'ownerOrganizationUserId'
  /** column name */
  | 'private'
  /** column name */
  | 'relatedQueueItemId'
  /** column name */
  | 'searchText'
  /** column name */
  | 'startDate'
  /** column name */
  | 'status'
  /** column name */
  | 'subTitle'
  /** column name */
  | 'subType'
  /** column name */
  | 'title'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** select "queueItemAggregateBoolExpBool_andArgumentsColumns" columns of table "business.queue_item" */
export type queueItemSelectColumnQueueItemAggregateBoolExpBool_andArgumentsColumns =
  /** column name */
  | 'private'
  | '%future added value';

/** select "queueItemAggregateBoolExpBool_orArgumentsColumns" columns of table "business.queue_item" */
export type queueItemSelectColumnQueueItemAggregateBoolExpBool_orArgumentsColumns =
  /** column name */
  | 'private'
  | '%future added value';

/** input type for updating data in table "business.queue_item" */
export type queueItemSetInput = {
  additionalData?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  deletionAt?: InputMaybe<Scalars['timestamptz']['input']>;
  domainActivityId?: InputMaybe<Scalars['uuid']['input']>;
  dueDate?: InputMaybe<Scalars['timestamptz']['input']>;
  flexibilityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  ownerOrganizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  relatedQueueItemId?: InputMaybe<Scalars['uuid']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<ActivityStatusEnum>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  subType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ActivityTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "queueItem" */
export type queueItemStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: queueItemStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type queueItemStreamCursorValueInput = {
  additionalData?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdByUserId?: InputMaybe<Scalars['uuid']['input']>;
  deletionAt?: InputMaybe<Scalars['timestamptz']['input']>;
  domainActivityId?: InputMaybe<Scalars['uuid']['input']>;
  dueDate?: InputMaybe<Scalars['timestamptz']['input']>;
  flexibilityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  ownerOrganizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  relatedQueueItemId?: InputMaybe<Scalars['uuid']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<ActivityStatusEnum>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  subType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ActivityTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "business.queue_item" */
export type queueItemUpdateColumn =
  /** column name */
  | 'additionalData'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdByUserId'
  /** column name */
  | 'deletionAt'
  /** column name */
  | 'domainActivityId'
  /** column name */
  | 'dueDate'
  /** column name */
  | 'flexibilityType'
  /** column name */
  | 'id'
  /** column name */
  | 'location'
  /** column name */
  | 'organizationId'
  /** column name */
  | 'ownerOrganizationUserId'
  /** column name */
  | 'private'
  /** column name */
  | 'relatedQueueItemId'
  /** column name */
  | 'searchText'
  /** column name */
  | 'startDate'
  /** column name */
  | 'status'
  /** column name */
  | 'subTitle'
  /** column name */
  | 'subType'
  /** column name */
  | 'title'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type queueItemUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<queueItemAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<queueItemDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<queueItemDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<queueItemDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<queueItemPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<queueItemSetInput>;
  /** filter the rows which have to be updated */
  where: queueItemBoolExp;
};

/** columns and relationships of "business.rel_organization_user_domain_user" */
export type relOrganizationUserDomainUser = {
  __typename?: 'relOrganizationUserDomainUser';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  domainUser: domainUser;
  domainUserId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organizationUser: organizationUser;
  organizationUserId: Scalars['uuid']['output'];
  relationType?: Maybe<RelationTypeEnum>;
  /** An object relationship */
  type?: Maybe<RelationType>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "business.rel_organization_user_domain_user" */
export type relOrganizationUserDomainUserAggregate = {
  __typename?: 'relOrganizationUserDomainUserAggregate';
  aggregate?: Maybe<relOrganizationUserDomainUserAggregateFields>;
  nodes: Array<relOrganizationUserDomainUser>;
};

export type relOrganizationUserDomainUserAggregateBoolExp = {
  count?: InputMaybe<relOrganizationUserDomainUserAggregateBoolExpCount>;
};

export type relOrganizationUserDomainUserAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<relOrganizationUserDomainUserSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<relOrganizationUserDomainUserBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "business.rel_organization_user_domain_user" */
export type relOrganizationUserDomainUserAggregateFields = {
  __typename?: 'relOrganizationUserDomainUserAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<relOrganizationUserDomainUserMaxFields>;
  min?: Maybe<relOrganizationUserDomainUserMinFields>;
};


/** aggregate fields of "business.rel_organization_user_domain_user" */
export type relOrganizationUserDomainUserAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<relOrganizationUserDomainUserSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.rel_organization_user_domain_user" */
export type relOrganizationUserDomainUserAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<relOrganizationUserDomainUserMaxOrderBy>;
  min?: InputMaybe<relOrganizationUserDomainUserMinOrderBy>;
};

/** input type for inserting array relation for remote table "business.rel_organization_user_domain_user" */
export type relOrganizationUserDomainUserArrRelInsertInput = {
  data: Array<relOrganizationUserDomainUserInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<relOrganizationUserDomainUserOnConflict>;
};

/** Boolean expression to filter rows from the table "business.rel_organization_user_domain_user". All fields are combined with a logical 'AND'. */
export type relOrganizationUserDomainUserBoolExp = {
  _and?: InputMaybe<Array<relOrganizationUserDomainUserBoolExp>>;
  _not?: InputMaybe<relOrganizationUserDomainUserBoolExp>;
  _or?: InputMaybe<Array<relOrganizationUserDomainUserBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  domainUser?: InputMaybe<domainUserBoolExp>;
  domainUserId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organizationUser?: InputMaybe<organizationUserBoolExp>;
  organizationUserId?: InputMaybe<UuidComparisonExp>;
  relationType?: InputMaybe<RelationTypeEnumComparisonExp>;
  type?: InputMaybe<RelationTypeBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "business.rel_organization_user_domain_user" */
export type relOrganizationUserDomainUserConstraint =
  /** unique or primary key constraint on columns "organization_user_id", "domain_user_id" */
  | 'organization_user_domain_user_organization_user_id_domain_u_key'
  /** unique or primary key constraint on columns "id" */
  | 'organization_user_domain_user_pkey'
  | '%future added value';

/** input type for inserting data into table "business.rel_organization_user_domain_user" */
export type relOrganizationUserDomainUserInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  domainUser?: InputMaybe<domainUserObjRelInsertInput>;
  domainUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationUser?: InputMaybe<organizationUserObjRelInsertInput>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  relationType?: InputMaybe<RelationTypeEnum>;
  type?: InputMaybe<RelationTypeObjRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type relOrganizationUserDomainUserMaxFields = {
  __typename?: 'relOrganizationUserDomainUserMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  domainUserId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "business.rel_organization_user_domain_user" */
export type relOrganizationUserDomainUserMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  domainUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type relOrganizationUserDomainUserMinFields = {
  __typename?: 'relOrganizationUserDomainUserMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  domainUserId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "business.rel_organization_user_domain_user" */
export type relOrganizationUserDomainUserMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  domainUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "business.rel_organization_user_domain_user" */
export type relOrganizationUserDomainUserMutationResponse = {
  __typename?: 'relOrganizationUserDomainUserMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<relOrganizationUserDomainUser>;
};

/** on_conflict condition type for table "business.rel_organization_user_domain_user" */
export type relOrganizationUserDomainUserOnConflict = {
  constraint: relOrganizationUserDomainUserConstraint;
  updateColumns?: Array<relOrganizationUserDomainUserUpdateColumn>;
  where?: InputMaybe<relOrganizationUserDomainUserBoolExp>;
};

/** Ordering options when selecting data from "business.rel_organization_user_domain_user". */
export type relOrganizationUserDomainUserOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  domainUser?: InputMaybe<domainUserOrderBy>;
  domainUserId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organizationUser?: InputMaybe<organizationUserOrderBy>;
  organizationUserId?: InputMaybe<OrderBy>;
  relationType?: InputMaybe<OrderBy>;
  type?: InputMaybe<RelationTypeOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.rel_organization_user_domain_user */
export type relOrganizationUserDomainUserPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "business.rel_organization_user_domain_user" */
export type relOrganizationUserDomainUserSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'domainUserId'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'relationType'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "business.rel_organization_user_domain_user" */
export type relOrganizationUserDomainUserSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  domainUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  relationType?: InputMaybe<RelationTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "relOrganizationUserDomainUser" */
export type relOrganizationUserDomainUserStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: relOrganizationUserDomainUserStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type relOrganizationUserDomainUserStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  domainUserId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  relationType?: InputMaybe<RelationTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "business.rel_organization_user_domain_user" */
export type relOrganizationUserDomainUserUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'domainUserId'
  /** column name */
  | 'id'
  /** column name */
  | 'organizationUserId'
  /** column name */
  | 'relationType'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type relOrganizationUserDomainUserUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<relOrganizationUserDomainUserSetInput>;
  /** filter the rows which have to be updated */
  where: relOrganizationUserDomainUserBoolExp;
};

export type removeEmailDomainUserOutput = {
  __typename?: 'removeEmailDomainUserOutput';
  id?: Maybe<Scalars['uuid']['output']>;
};

export type removeEmailProviderIntegrationAccount = {
  id: Scalars['uuid']['input'];
};

export type removeEmailProviderIntegrationInput = {
  account: removeEmailProviderIntegrationAccount;
};

export type removeOrganizationInput = {
  deleteUsers?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
};

export type removeOrganizationOutput = {
  __typename?: 'removeOrganizationOutput';
  json?: Maybe<Scalars['json']['output']>;
  result: Scalars['String']['output'];
};

export type renewEmailProviderSubscriptionInput = {
  account: Scalars['String']['input'];
  server: Scalars['String']['input'];
  subscriptionId: Scalars['uuid']['input'];
  type: Scalars['String']['input'];
  userId: Scalars['uuid']['input'];
};

export type renewEmailProviderSubscriptionOutput = {
  __typename?: 'renewEmailProviderSubscriptionOutput';
  expiration: Scalars['timestamptz']['output'];
  subscriptionId: Scalars['uuid']['output'];
};

export type setUpOrganizationOutput = {
  __typename?: 'setUpOrganizationOutput';
  businessAddress?: Maybe<BusinessAddress>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationNumber?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "sms.connectors" */
export type smsConnector = {
  __typename?: 'smsConnector';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "sms.connectors" */
export type smsConnectorAggregate = {
  __typename?: 'smsConnectorAggregate';
  aggregate?: Maybe<smsConnectorAggregateFields>;
  nodes: Array<smsConnector>;
};

/** aggregate fields of "sms.connectors" */
export type smsConnectorAggregateFields = {
  __typename?: 'smsConnectorAggregateFields';
  avg?: Maybe<smsConnectorAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<smsConnectorMaxFields>;
  min?: Maybe<smsConnectorMinFields>;
  stddev?: Maybe<smsConnectorStddevFields>;
  stddevPop?: Maybe<smsConnectorStddevPopFields>;
  stddevSamp?: Maybe<smsConnectorStddevSampFields>;
  sum?: Maybe<smsConnectorSumFields>;
  varPop?: Maybe<smsConnectorVarPopFields>;
  varSamp?: Maybe<smsConnectorVarSampFields>;
  variance?: Maybe<smsConnectorVarianceFields>;
};


/** aggregate fields of "sms.connectors" */
export type smsConnectorAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<smsConnectorSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type smsConnectorAvgFields = {
  __typename?: 'smsConnectorAvgFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "sms.connectors". All fields are combined with a logical 'AND'. */
export type smsConnectorBoolExp = {
  _and?: InputMaybe<Array<smsConnectorBoolExp>>;
  _not?: InputMaybe<smsConnectorBoolExp>;
  _or?: InputMaybe<Array<smsConnectorBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "sms.connectors" */
export type smsConnectorConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'connectors_pkey'
  | '%future added value';

/** input type for incrementing numeric columns in table "sms.connectors" */
export type smsConnectorIncInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "sms.connectors" */
export type smsConnectorInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type smsConnectorMaxFields = {
  __typename?: 'smsConnectorMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type smsConnectorMinFields = {
  __typename?: 'smsConnectorMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "sms.connectors" */
export type smsConnectorMutationResponse = {
  __typename?: 'smsConnectorMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<smsConnector>;
};

/** on_conflict condition type for table "sms.connectors" */
export type smsConnectorOnConflict = {
  constraint: smsConnectorConstraint;
  updateColumns?: Array<smsConnectorUpdateColumn>;
  where?: InputMaybe<smsConnectorBoolExp>;
};

/** Ordering options when selecting data from "sms.connectors". */
export type smsConnectorOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: sms.connectors */
export type smsConnectorPkColumnsInput = {
  id: Scalars['Int']['input'];
};

/** select columns of table "sms.connectors" */
export type smsConnectorSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "sms.connectors" */
export type smsConnectorSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type smsConnectorStddevFields = {
  __typename?: 'smsConnectorStddevFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type smsConnectorStddevPopFields = {
  __typename?: 'smsConnectorStddevPopFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type smsConnectorStddevSampFields = {
  __typename?: 'smsConnectorStddevSampFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "smsConnector" */
export type smsConnectorStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: smsConnectorStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type smsConnectorStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type smsConnectorSumFields = {
  __typename?: 'smsConnectorSumFields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "sms.connectors" */
export type smsConnectorUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type smsConnectorUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<smsConnectorIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<smsConnectorSetInput>;
  /** filter the rows which have to be updated */
  where: smsConnectorBoolExp;
};

/** aggregate varPop on columns */
export type smsConnectorVarPopFields = {
  __typename?: 'smsConnectorVarPopFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type smsConnectorVarSampFields = {
  __typename?: 'smsConnectorVarSampFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type smsConnectorVarianceFields = {
  __typename?: 'smsConnectorVarianceFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "sms.gates" */
export type smsGate = {
  __typename?: 'smsGate';
  id: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "sms.gates" */
export type smsGateAggregate = {
  __typename?: 'smsGateAggregate';
  aggregate?: Maybe<smsGateAggregateFields>;
  nodes: Array<smsGate>;
};

/** aggregate fields of "sms.gates" */
export type smsGateAggregateFields = {
  __typename?: 'smsGateAggregateFields';
  avg?: Maybe<smsGateAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<smsGateMaxFields>;
  min?: Maybe<smsGateMinFields>;
  stddev?: Maybe<smsGateStddevFields>;
  stddevPop?: Maybe<smsGateStddevPopFields>;
  stddevSamp?: Maybe<smsGateStddevSampFields>;
  sum?: Maybe<smsGateSumFields>;
  varPop?: Maybe<smsGateVarPopFields>;
  varSamp?: Maybe<smsGateVarSampFields>;
  variance?: Maybe<smsGateVarianceFields>;
};


/** aggregate fields of "sms.gates" */
export type smsGateAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<smsGateSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type smsGateAvgFields = {
  __typename?: 'smsGateAvgFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "sms.gates". All fields are combined with a logical 'AND'. */
export type smsGateBoolExp = {
  _and?: InputMaybe<Array<smsGateBoolExp>>;
  _not?: InputMaybe<smsGateBoolExp>;
  _or?: InputMaybe<Array<smsGateBoolExp>>;
  id?: InputMaybe<IntComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "sms.gates" */
export type smsGateConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'gates_pkey'
  | '%future added value';

/** input type for incrementing numeric columns in table "sms.gates" */
export type smsGateIncInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "sms.gates" */
export type smsGateInsertInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type smsGateMaxFields = {
  __typename?: 'smsGateMaxFields';
  id?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type smsGateMinFields = {
  __typename?: 'smsGateMinFields';
  id?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "sms.gates" */
export type smsGateMutationResponse = {
  __typename?: 'smsGateMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<smsGate>;
};

/** on_conflict condition type for table "sms.gates" */
export type smsGateOnConflict = {
  constraint: smsGateConstraint;
  updateColumns?: Array<smsGateUpdateColumn>;
  where?: InputMaybe<smsGateBoolExp>;
};

/** Ordering options when selecting data from "sms.gates". */
export type smsGateOrderBy = {
  id?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: sms.gates */
export type smsGatePkColumnsInput = {
  id: Scalars['Int']['input'];
};

/** select columns of table "sms.gates" */
export type smsGateSelectColumn =
  /** column name */
  | 'id'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "sms.gates" */
export type smsGateSetInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type smsGateStddevFields = {
  __typename?: 'smsGateStddevFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type smsGateStddevPopFields = {
  __typename?: 'smsGateStddevPopFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type smsGateStddevSampFields = {
  __typename?: 'smsGateStddevSampFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "smsGate" */
export type smsGateStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: smsGateStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type smsGateStreamCursorValueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type smsGateSumFields = {
  __typename?: 'smsGateSumFields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "sms.gates" */
export type smsGateUpdateColumn =
  /** column name */
  | 'id'
  /** column name */
  | 'value'
  | '%future added value';

export type smsGateUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<smsGateIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<smsGateSetInput>;
  /** filter the rows which have to be updated */
  where: smsGateBoolExp;
};

/** aggregate varPop on columns */
export type smsGateVarPopFields = {
  __typename?: 'smsGateVarPopFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type smsGateVarSampFields = {
  __typename?: 'smsGateVarSampFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type smsGateVarianceFields = {
  __typename?: 'smsGateVarianceFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "sms.link_mobility_sms_content" */
export type smsLinkMobilitySmsContent = {
  __typename?: 'smsLinkMobilitySmsContent';
  encoding?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userData?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['uuid']['output'];
};

/** aggregated selection of "sms.link_mobility_sms_content" */
export type smsLinkMobilitySmsContentAggregate = {
  __typename?: 'smsLinkMobilitySmsContentAggregate';
  aggregate?: Maybe<smsLinkMobilitySmsContentAggregateFields>;
  nodes: Array<smsLinkMobilitySmsContent>;
};

/** aggregate fields of "sms.link_mobility_sms_content" */
export type smsLinkMobilitySmsContentAggregateFields = {
  __typename?: 'smsLinkMobilitySmsContentAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<smsLinkMobilitySmsContentMaxFields>;
  min?: Maybe<smsLinkMobilitySmsContentMinFields>;
};


/** aggregate fields of "sms.link_mobility_sms_content" */
export type smsLinkMobilitySmsContentAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<smsLinkMobilitySmsContentSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "sms.link_mobility_sms_content". All fields are combined with a logical 'AND'. */
export type smsLinkMobilitySmsContentBoolExp = {
  _and?: InputMaybe<Array<smsLinkMobilitySmsContentBoolExp>>;
  _not?: InputMaybe<smsLinkMobilitySmsContentBoolExp>;
  _or?: InputMaybe<Array<smsLinkMobilitySmsContentBoolExp>>;
  encoding?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  userData?: InputMaybe<StringComparisonExp>;
  uuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "sms.link_mobility_sms_content" */
export type smsLinkMobilitySmsContentConstraint =
  /** unique or primary key constraint on columns "uuid" */
  | 'link_mobility_sms_content_pkey'
  | '%future added value';

/** input type for inserting data into table "sms.link_mobility_sms_content" */
export type smsLinkMobilitySmsContentInsertInput = {
  encoding?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userData?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type smsLinkMobilitySmsContentMaxFields = {
  __typename?: 'smsLinkMobilitySmsContentMaxFields';
  encoding?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userData?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type smsLinkMobilitySmsContentMinFields = {
  __typename?: 'smsLinkMobilitySmsContentMinFields';
  encoding?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userData?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "sms.link_mobility_sms_content" */
export type smsLinkMobilitySmsContentMutationResponse = {
  __typename?: 'smsLinkMobilitySmsContentMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<smsLinkMobilitySmsContent>;
};

/** input type for inserting object relation for remote table "sms.link_mobility_sms_content" */
export type smsLinkMobilitySmsContentObjRelInsertInput = {
  data: smsLinkMobilitySmsContentInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<smsLinkMobilitySmsContentOnConflict>;
};

/** on_conflict condition type for table "sms.link_mobility_sms_content" */
export type smsLinkMobilitySmsContentOnConflict = {
  constraint: smsLinkMobilitySmsContentConstraint;
  updateColumns?: Array<smsLinkMobilitySmsContentUpdateColumn>;
  where?: InputMaybe<smsLinkMobilitySmsContentBoolExp>;
};

/** Ordering options when selecting data from "sms.link_mobility_sms_content". */
export type smsLinkMobilitySmsContentOrderBy = {
  encoding?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  userData?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: sms.link_mobility_sms_content */
export type smsLinkMobilitySmsContentPkColumnsInput = {
  uuid: Scalars['uuid']['input'];
};

/** select columns of table "sms.link_mobility_sms_content" */
export type smsLinkMobilitySmsContentSelectColumn =
  /** column name */
  | 'encoding'
  /** column name */
  | 'type'
  /** column name */
  | 'userData'
  /** column name */
  | 'uuid'
  | '%future added value';

/** input type for updating data in table "sms.link_mobility_sms_content" */
export type smsLinkMobilitySmsContentSetInput = {
  encoding?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userData?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "smsLinkMobilitySmsContent" */
export type smsLinkMobilitySmsContentStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: smsLinkMobilitySmsContentStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type smsLinkMobilitySmsContentStreamCursorValueInput = {
  encoding?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userData?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "sms.link_mobility_sms_content" */
export type smsLinkMobilitySmsContentUpdateColumn =
  /** column name */
  | 'encoding'
  /** column name */
  | 'type'
  /** column name */
  | 'userData'
  /** column name */
  | 'uuid'
  | '%future added value';

export type smsLinkMobilitySmsContentUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<smsLinkMobilitySmsContentSetInput>;
  /** filter the rows which have to be updated */
  where: smsLinkMobilitySmsContentBoolExp;
};

/** columns and relationships of "sms.link_mobility_sms_message" */
export type smsLinkMobilitySmsMessage = {
  __typename?: 'smsLinkMobilitySmsMessage';
  /** An object relationship */
  content?: Maybe<smsLinkMobilitySmsContent>;
  contentId?: Maybe<Scalars['uuid']['output']>;
  customParameters?: Maybe<Scalars['jsonb']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  gateCustomParameters?: Maybe<Scalars['jsonb']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  operator?: Maybe<Scalars['String']['output']>;
  operatorMessageId?: Maybe<Scalars['String']['output']>;
  operatorTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  route?: Maybe<smsLinkMobilitySmsRoute>;
  routeId?: Maybe<Scalars['uuid']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  subNumber?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "sms.link_mobility_sms_message" */
export type smsLinkMobilitySmsMessagecustomParametersArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "sms.link_mobility_sms_message" */
export type smsLinkMobilitySmsMessagegateCustomParametersArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "sms.link_mobility_sms_message" */
export type smsLinkMobilitySmsMessageAggregate = {
  __typename?: 'smsLinkMobilitySmsMessageAggregate';
  aggregate?: Maybe<smsLinkMobilitySmsMessageAggregateFields>;
  nodes: Array<smsLinkMobilitySmsMessage>;
};

/** aggregate fields of "sms.link_mobility_sms_message" */
export type smsLinkMobilitySmsMessageAggregateFields = {
  __typename?: 'smsLinkMobilitySmsMessageAggregateFields';
  avg?: Maybe<smsLinkMobilitySmsMessageAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<smsLinkMobilitySmsMessageMaxFields>;
  min?: Maybe<smsLinkMobilitySmsMessageMinFields>;
  stddev?: Maybe<smsLinkMobilitySmsMessageStddevFields>;
  stddevPop?: Maybe<smsLinkMobilitySmsMessageStddevPopFields>;
  stddevSamp?: Maybe<smsLinkMobilitySmsMessageStddevSampFields>;
  sum?: Maybe<smsLinkMobilitySmsMessageSumFields>;
  varPop?: Maybe<smsLinkMobilitySmsMessageVarPopFields>;
  varSamp?: Maybe<smsLinkMobilitySmsMessageVarSampFields>;
  variance?: Maybe<smsLinkMobilitySmsMessageVarianceFields>;
};


/** aggregate fields of "sms.link_mobility_sms_message" */
export type smsLinkMobilitySmsMessageAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<smsLinkMobilitySmsMessageSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type smsLinkMobilitySmsMessageAppendInput = {
  customParameters?: InputMaybe<Scalars['jsonb']['input']>;
  gateCustomParameters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type smsLinkMobilitySmsMessageAvgFields = {
  __typename?: 'smsLinkMobilitySmsMessageAvgFields';
  subNumber?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "sms.link_mobility_sms_message". All fields are combined with a logical 'AND'. */
export type smsLinkMobilitySmsMessageBoolExp = {
  _and?: InputMaybe<Array<smsLinkMobilitySmsMessageBoolExp>>;
  _not?: InputMaybe<smsLinkMobilitySmsMessageBoolExp>;
  _or?: InputMaybe<Array<smsLinkMobilitySmsMessageBoolExp>>;
  content?: InputMaybe<smsLinkMobilitySmsContentBoolExp>;
  contentId?: InputMaybe<UuidComparisonExp>;
  customParameters?: InputMaybe<JsonbComparisonExp>;
  destination?: InputMaybe<StringComparisonExp>;
  gateCustomParameters?: InputMaybe<JsonbComparisonExp>;
  messageId?: InputMaybe<StringComparisonExp>;
  operator?: InputMaybe<StringComparisonExp>;
  operatorMessageId?: InputMaybe<StringComparisonExp>;
  operatorTimestamp?: InputMaybe<TimestamptzComparisonExp>;
  route?: InputMaybe<smsLinkMobilitySmsRouteBoolExp>;
  routeId?: InputMaybe<UuidComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  subNumber?: InputMaybe<IntComparisonExp>;
  timestamp?: InputMaybe<TimestamptzComparisonExp>;
  uuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "sms.link_mobility_sms_message" */
export type smsLinkMobilitySmsMessageConstraint =
  /** unique or primary key constraint on columns "uuid" */
  | 'link_mobility_sms_message_pkey'
  | '%future added value';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type smsLinkMobilitySmsMessageDeleteAtPathInput = {
  customParameters?: InputMaybe<Array<Scalars['String']['input']>>;
  gateCustomParameters?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type smsLinkMobilitySmsMessageDeleteElemInput = {
  customParameters?: InputMaybe<Scalars['Int']['input']>;
  gateCustomParameters?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type smsLinkMobilitySmsMessageDeleteKeyInput = {
  customParameters?: InputMaybe<Scalars['String']['input']>;
  gateCustomParameters?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "sms.link_mobility_sms_message" */
export type smsLinkMobilitySmsMessageIncInput = {
  subNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "sms.link_mobility_sms_message" */
export type smsLinkMobilitySmsMessageInsertInput = {
  content?: InputMaybe<smsLinkMobilitySmsContentObjRelInsertInput>;
  contentId?: InputMaybe<Scalars['uuid']['input']>;
  customParameters?: InputMaybe<Scalars['jsonb']['input']>;
  destination?: InputMaybe<Scalars['String']['input']>;
  gateCustomParameters?: InputMaybe<Scalars['jsonb']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  operatorMessageId?: InputMaybe<Scalars['String']['input']>;
  operatorTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  route?: InputMaybe<smsLinkMobilitySmsRouteObjRelInsertInput>;
  routeId?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  subNumber?: InputMaybe<Scalars['Int']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type smsLinkMobilitySmsMessageMaxFields = {
  __typename?: 'smsLinkMobilitySmsMessageMaxFields';
  contentId?: Maybe<Scalars['uuid']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  operator?: Maybe<Scalars['String']['output']>;
  operatorMessageId?: Maybe<Scalars['String']['output']>;
  operatorTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  routeId?: Maybe<Scalars['uuid']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  subNumber?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type smsLinkMobilitySmsMessageMinFields = {
  __typename?: 'smsLinkMobilitySmsMessageMinFields';
  contentId?: Maybe<Scalars['uuid']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  operator?: Maybe<Scalars['String']['output']>;
  operatorMessageId?: Maybe<Scalars['String']['output']>;
  operatorTimestamp?: Maybe<Scalars['timestamptz']['output']>;
  routeId?: Maybe<Scalars['uuid']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  subNumber?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "sms.link_mobility_sms_message" */
export type smsLinkMobilitySmsMessageMutationResponse = {
  __typename?: 'smsLinkMobilitySmsMessageMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<smsLinkMobilitySmsMessage>;
};

/** input type for inserting object relation for remote table "sms.link_mobility_sms_message" */
export type smsLinkMobilitySmsMessageObjRelInsertInput = {
  data: smsLinkMobilitySmsMessageInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<smsLinkMobilitySmsMessageOnConflict>;
};

/** on_conflict condition type for table "sms.link_mobility_sms_message" */
export type smsLinkMobilitySmsMessageOnConflict = {
  constraint: smsLinkMobilitySmsMessageConstraint;
  updateColumns?: Array<smsLinkMobilitySmsMessageUpdateColumn>;
  where?: InputMaybe<smsLinkMobilitySmsMessageBoolExp>;
};

/** Ordering options when selecting data from "sms.link_mobility_sms_message". */
export type smsLinkMobilitySmsMessageOrderBy = {
  content?: InputMaybe<smsLinkMobilitySmsContentOrderBy>;
  contentId?: InputMaybe<OrderBy>;
  customParameters?: InputMaybe<OrderBy>;
  destination?: InputMaybe<OrderBy>;
  gateCustomParameters?: InputMaybe<OrderBy>;
  messageId?: InputMaybe<OrderBy>;
  operator?: InputMaybe<OrderBy>;
  operatorMessageId?: InputMaybe<OrderBy>;
  operatorTimestamp?: InputMaybe<OrderBy>;
  route?: InputMaybe<smsLinkMobilitySmsRouteOrderBy>;
  routeId?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  subNumber?: InputMaybe<OrderBy>;
  timestamp?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: sms.link_mobility_sms_message */
export type smsLinkMobilitySmsMessagePkColumnsInput = {
  uuid: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type smsLinkMobilitySmsMessagePrependInput = {
  customParameters?: InputMaybe<Scalars['jsonb']['input']>;
  gateCustomParameters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "sms.link_mobility_sms_message" */
export type smsLinkMobilitySmsMessageSelectColumn =
  /** column name */
  | 'contentId'
  /** column name */
  | 'customParameters'
  /** column name */
  | 'destination'
  /** column name */
  | 'gateCustomParameters'
  /** column name */
  | 'messageId'
  /** column name */
  | 'operator'
  /** column name */
  | 'operatorMessageId'
  /** column name */
  | 'operatorTimestamp'
  /** column name */
  | 'routeId'
  /** column name */
  | 'source'
  /** column name */
  | 'subNumber'
  /** column name */
  | 'timestamp'
  /** column name */
  | 'uuid'
  | '%future added value';

/** input type for updating data in table "sms.link_mobility_sms_message" */
export type smsLinkMobilitySmsMessageSetInput = {
  contentId?: InputMaybe<Scalars['uuid']['input']>;
  customParameters?: InputMaybe<Scalars['jsonb']['input']>;
  destination?: InputMaybe<Scalars['String']['input']>;
  gateCustomParameters?: InputMaybe<Scalars['jsonb']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  operatorMessageId?: InputMaybe<Scalars['String']['input']>;
  operatorTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  routeId?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  subNumber?: InputMaybe<Scalars['Int']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type smsLinkMobilitySmsMessageStddevFields = {
  __typename?: 'smsLinkMobilitySmsMessageStddevFields';
  subNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type smsLinkMobilitySmsMessageStddevPopFields = {
  __typename?: 'smsLinkMobilitySmsMessageStddevPopFields';
  subNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type smsLinkMobilitySmsMessageStddevSampFields = {
  __typename?: 'smsLinkMobilitySmsMessageStddevSampFields';
  subNumber?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "smsLinkMobilitySmsMessage" */
export type smsLinkMobilitySmsMessageStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: smsLinkMobilitySmsMessageStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type smsLinkMobilitySmsMessageStreamCursorValueInput = {
  contentId?: InputMaybe<Scalars['uuid']['input']>;
  customParameters?: InputMaybe<Scalars['jsonb']['input']>;
  destination?: InputMaybe<Scalars['String']['input']>;
  gateCustomParameters?: InputMaybe<Scalars['jsonb']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  operatorMessageId?: InputMaybe<Scalars['String']['input']>;
  operatorTimestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  routeId?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  subNumber?: InputMaybe<Scalars['Int']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type smsLinkMobilitySmsMessageSumFields = {
  __typename?: 'smsLinkMobilitySmsMessageSumFields';
  subNumber?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "sms.link_mobility_sms_message" */
export type smsLinkMobilitySmsMessageUpdateColumn =
  /** column name */
  | 'contentId'
  /** column name */
  | 'customParameters'
  /** column name */
  | 'destination'
  /** column name */
  | 'gateCustomParameters'
  /** column name */
  | 'messageId'
  /** column name */
  | 'operator'
  /** column name */
  | 'operatorMessageId'
  /** column name */
  | 'operatorTimestamp'
  /** column name */
  | 'routeId'
  /** column name */
  | 'source'
  /** column name */
  | 'subNumber'
  /** column name */
  | 'timestamp'
  /** column name */
  | 'uuid'
  | '%future added value';

export type smsLinkMobilitySmsMessageUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<smsLinkMobilitySmsMessageAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<smsLinkMobilitySmsMessageDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<smsLinkMobilitySmsMessageDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<smsLinkMobilitySmsMessageDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<smsLinkMobilitySmsMessageIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<smsLinkMobilitySmsMessagePrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<smsLinkMobilitySmsMessageSetInput>;
  /** filter the rows which have to be updated */
  where: smsLinkMobilitySmsMessageBoolExp;
};

/** aggregate varPop on columns */
export type smsLinkMobilitySmsMessageVarPopFields = {
  __typename?: 'smsLinkMobilitySmsMessageVarPopFields';
  subNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type smsLinkMobilitySmsMessageVarSampFields = {
  __typename?: 'smsLinkMobilitySmsMessageVarSampFields';
  subNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type smsLinkMobilitySmsMessageVarianceFields = {
  __typename?: 'smsLinkMobilitySmsMessageVarianceFields';
  subNumber?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "sms.link_mobility_sms_route" */
export type smsLinkMobilitySmsRoute = {
  __typename?: 'smsLinkMobilitySmsRoute';
  active?: Maybe<Scalars['Boolean']['output']>;
  customParameters?: Maybe<Scalars['jsonb']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['timestamptz']['output']>;
  gateIds?: Maybe<Scalars['jsonb']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  keyword?: Maybe<Scalars['String']['output']>;
  keywordType?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  platformId?: Maybe<Scalars['String']['output']>;
  platformPartnerId?: Maybe<Scalars['String']['output']>;
  platformServiceId?: Maybe<Scalars['String']['output']>;
  platformServiceType?: Maybe<Scalars['String']['output']>;
  refId?: Maybe<Scalars['String']['output']>;
  shared?: Maybe<Scalars['Boolean']['output']>;
  start?: Maybe<Scalars['timestamptz']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['uuid']['output'];
};


/** columns and relationships of "sms.link_mobility_sms_route" */
export type smsLinkMobilitySmsRoutecustomParametersArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "sms.link_mobility_sms_route" */
export type smsLinkMobilitySmsRoutegateIdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "sms.link_mobility_sms_route" */
export type smsLinkMobilitySmsRouteAggregate = {
  __typename?: 'smsLinkMobilitySmsRouteAggregate';
  aggregate?: Maybe<smsLinkMobilitySmsRouteAggregateFields>;
  nodes: Array<smsLinkMobilitySmsRoute>;
};

/** aggregate fields of "sms.link_mobility_sms_route" */
export type smsLinkMobilitySmsRouteAggregateFields = {
  __typename?: 'smsLinkMobilitySmsRouteAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<smsLinkMobilitySmsRouteMaxFields>;
  min?: Maybe<smsLinkMobilitySmsRouteMinFields>;
};


/** aggregate fields of "sms.link_mobility_sms_route" */
export type smsLinkMobilitySmsRouteAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<smsLinkMobilitySmsRouteSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type smsLinkMobilitySmsRouteAppendInput = {
  customParameters?: InputMaybe<Scalars['jsonb']['input']>;
  gateIds?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "sms.link_mobility_sms_route". All fields are combined with a logical 'AND'. */
export type smsLinkMobilitySmsRouteBoolExp = {
  _and?: InputMaybe<Array<smsLinkMobilitySmsRouteBoolExp>>;
  _not?: InputMaybe<smsLinkMobilitySmsRouteBoolExp>;
  _or?: InputMaybe<Array<smsLinkMobilitySmsRouteBoolExp>>;
  active?: InputMaybe<BooleanComparisonExp>;
  customParameters?: InputMaybe<JsonbComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  end?: InputMaybe<TimestamptzComparisonExp>;
  gateIds?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  keyword?: InputMaybe<StringComparisonExp>;
  keywordType?: InputMaybe<StringComparisonExp>;
  number?: InputMaybe<StringComparisonExp>;
  platformId?: InputMaybe<StringComparisonExp>;
  platformPartnerId?: InputMaybe<StringComparisonExp>;
  platformServiceId?: InputMaybe<StringComparisonExp>;
  platformServiceType?: InputMaybe<StringComparisonExp>;
  refId?: InputMaybe<StringComparisonExp>;
  shared?: InputMaybe<BooleanComparisonExp>;
  start?: InputMaybe<TimestamptzComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  uuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "sms.link_mobility_sms_route" */
export type smsLinkMobilitySmsRouteConstraint =
  /** unique or primary key constraint on columns "uuid" */
  | 'link_mobility_sms_route_pkey'
  | '%future added value';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type smsLinkMobilitySmsRouteDeleteAtPathInput = {
  customParameters?: InputMaybe<Array<Scalars['String']['input']>>;
  gateIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type smsLinkMobilitySmsRouteDeleteElemInput = {
  customParameters?: InputMaybe<Scalars['Int']['input']>;
  gateIds?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type smsLinkMobilitySmsRouteDeleteKeyInput = {
  customParameters?: InputMaybe<Scalars['String']['input']>;
  gateIds?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "sms.link_mobility_sms_route" */
export type smsLinkMobilitySmsRouteInsertInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  customParameters?: InputMaybe<Scalars['jsonb']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['timestamptz']['input']>;
  gateIds?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  keywordType?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['String']['input']>;
  platformPartnerId?: InputMaybe<Scalars['String']['input']>;
  platformServiceId?: InputMaybe<Scalars['String']['input']>;
  platformServiceType?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['String']['input']>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['timestamptz']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type smsLinkMobilitySmsRouteMaxFields = {
  __typename?: 'smsLinkMobilitySmsRouteMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  keyword?: Maybe<Scalars['String']['output']>;
  keywordType?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  platformId?: Maybe<Scalars['String']['output']>;
  platformPartnerId?: Maybe<Scalars['String']['output']>;
  platformServiceId?: Maybe<Scalars['String']['output']>;
  platformServiceType?: Maybe<Scalars['String']['output']>;
  refId?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['timestamptz']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type smsLinkMobilitySmsRouteMinFields = {
  __typename?: 'smsLinkMobilitySmsRouteMinFields';
  description?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  keyword?: Maybe<Scalars['String']['output']>;
  keywordType?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  platformId?: Maybe<Scalars['String']['output']>;
  platformPartnerId?: Maybe<Scalars['String']['output']>;
  platformServiceId?: Maybe<Scalars['String']['output']>;
  platformServiceType?: Maybe<Scalars['String']['output']>;
  refId?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['timestamptz']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "sms.link_mobility_sms_route" */
export type smsLinkMobilitySmsRouteMutationResponse = {
  __typename?: 'smsLinkMobilitySmsRouteMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<smsLinkMobilitySmsRoute>;
};

/** input type for inserting object relation for remote table "sms.link_mobility_sms_route" */
export type smsLinkMobilitySmsRouteObjRelInsertInput = {
  data: smsLinkMobilitySmsRouteInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<smsLinkMobilitySmsRouteOnConflict>;
};

/** on_conflict condition type for table "sms.link_mobility_sms_route" */
export type smsLinkMobilitySmsRouteOnConflict = {
  constraint: smsLinkMobilitySmsRouteConstraint;
  updateColumns?: Array<smsLinkMobilitySmsRouteUpdateColumn>;
  where?: InputMaybe<smsLinkMobilitySmsRouteBoolExp>;
};

/** Ordering options when selecting data from "sms.link_mobility_sms_route". */
export type smsLinkMobilitySmsRouteOrderBy = {
  active?: InputMaybe<OrderBy>;
  customParameters?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  end?: InputMaybe<OrderBy>;
  gateIds?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  keyword?: InputMaybe<OrderBy>;
  keywordType?: InputMaybe<OrderBy>;
  number?: InputMaybe<OrderBy>;
  platformId?: InputMaybe<OrderBy>;
  platformPartnerId?: InputMaybe<OrderBy>;
  platformServiceId?: InputMaybe<OrderBy>;
  platformServiceType?: InputMaybe<OrderBy>;
  refId?: InputMaybe<OrderBy>;
  shared?: InputMaybe<OrderBy>;
  start?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: sms.link_mobility_sms_route */
export type smsLinkMobilitySmsRoutePkColumnsInput = {
  uuid: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type smsLinkMobilitySmsRoutePrependInput = {
  customParameters?: InputMaybe<Scalars['jsonb']['input']>;
  gateIds?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "sms.link_mobility_sms_route" */
export type smsLinkMobilitySmsRouteSelectColumn =
  /** column name */
  | 'active'
  /** column name */
  | 'customParameters'
  /** column name */
  | 'description'
  /** column name */
  | 'end'
  /** column name */
  | 'gateIds'
  /** column name */
  | 'id'
  /** column name */
  | 'keyword'
  /** column name */
  | 'keywordType'
  /** column name */
  | 'number'
  /** column name */
  | 'platformId'
  /** column name */
  | 'platformPartnerId'
  /** column name */
  | 'platformServiceId'
  /** column name */
  | 'platformServiceType'
  /** column name */
  | 'refId'
  /** column name */
  | 'shared'
  /** column name */
  | 'start'
  /** column name */
  | 'type'
  /** column name */
  | 'uuid'
  | '%future added value';

/** input type for updating data in table "sms.link_mobility_sms_route" */
export type smsLinkMobilitySmsRouteSetInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  customParameters?: InputMaybe<Scalars['jsonb']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['timestamptz']['input']>;
  gateIds?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  keywordType?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['String']['input']>;
  platformPartnerId?: InputMaybe<Scalars['String']['input']>;
  platformServiceId?: InputMaybe<Scalars['String']['input']>;
  platformServiceType?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['String']['input']>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['timestamptz']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "smsLinkMobilitySmsRoute" */
export type smsLinkMobilitySmsRouteStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: smsLinkMobilitySmsRouteStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type smsLinkMobilitySmsRouteStreamCursorValueInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  customParameters?: InputMaybe<Scalars['jsonb']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['timestamptz']['input']>;
  gateIds?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  keywordType?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['String']['input']>;
  platformPartnerId?: InputMaybe<Scalars['String']['input']>;
  platformServiceId?: InputMaybe<Scalars['String']['input']>;
  platformServiceType?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['String']['input']>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['timestamptz']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "sms.link_mobility_sms_route" */
export type smsLinkMobilitySmsRouteUpdateColumn =
  /** column name */
  | 'active'
  /** column name */
  | 'customParameters'
  /** column name */
  | 'description'
  /** column name */
  | 'end'
  /** column name */
  | 'gateIds'
  /** column name */
  | 'id'
  /** column name */
  | 'keyword'
  /** column name */
  | 'keywordType'
  /** column name */
  | 'number'
  /** column name */
  | 'platformId'
  /** column name */
  | 'platformPartnerId'
  /** column name */
  | 'platformServiceId'
  /** column name */
  | 'platformServiceType'
  /** column name */
  | 'refId'
  /** column name */
  | 'shared'
  /** column name */
  | 'start'
  /** column name */
  | 'type'
  /** column name */
  | 'uuid'
  | '%future added value';

export type smsLinkMobilitySmsRouteUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<smsLinkMobilitySmsRouteAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<smsLinkMobilitySmsRouteDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<smsLinkMobilitySmsRouteDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<smsLinkMobilitySmsRouteDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<smsLinkMobilitySmsRoutePrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<smsLinkMobilitySmsRouteSetInput>;
  /** filter the rows which have to be updated */
  where: smsLinkMobilitySmsRouteBoolExp;
};

/** columns and relationships of "sms.providers" */
export type smsProvider = {
  __typename?: 'smsProvider';
  createdAt: Scalars['timestamptz']['output'];
  endpoint: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "sms.providers" */
export type smsProviderAggregate = {
  __typename?: 'smsProviderAggregate';
  aggregate?: Maybe<smsProviderAggregateFields>;
  nodes: Array<smsProvider>;
};

/** aggregate fields of "sms.providers" */
export type smsProviderAggregateFields = {
  __typename?: 'smsProviderAggregateFields';
  avg?: Maybe<smsProviderAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<smsProviderMaxFields>;
  min?: Maybe<smsProviderMinFields>;
  stddev?: Maybe<smsProviderStddevFields>;
  stddevPop?: Maybe<smsProviderStddevPopFields>;
  stddevSamp?: Maybe<smsProviderStddevSampFields>;
  sum?: Maybe<smsProviderSumFields>;
  varPop?: Maybe<smsProviderVarPopFields>;
  varSamp?: Maybe<smsProviderVarSampFields>;
  variance?: Maybe<smsProviderVarianceFields>;
};


/** aggregate fields of "sms.providers" */
export type smsProviderAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<smsProviderSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type smsProviderAvgFields = {
  __typename?: 'smsProviderAvgFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "sms.providers". All fields are combined with a logical 'AND'. */
export type smsProviderBoolExp = {
  _and?: InputMaybe<Array<smsProviderBoolExp>>;
  _not?: InputMaybe<smsProviderBoolExp>;
  _or?: InputMaybe<Array<smsProviderBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  endpoint?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "sms.providers" */
export type smsProviderConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'providers_pkey'
  | '%future added value';

/** input type for incrementing numeric columns in table "sms.providers" */
export type smsProviderIncInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "sms.providers" */
export type smsProviderInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type smsProviderMaxFields = {
  __typename?: 'smsProviderMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  endpoint?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type smsProviderMinFields = {
  __typename?: 'smsProviderMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  endpoint?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "sms.providers" */
export type smsProviderMutationResponse = {
  __typename?: 'smsProviderMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<smsProvider>;
};

/** on_conflict condition type for table "sms.providers" */
export type smsProviderOnConflict = {
  constraint: smsProviderConstraint;
  updateColumns?: Array<smsProviderUpdateColumn>;
  where?: InputMaybe<smsProviderBoolExp>;
};

/** Ordering options when selecting data from "sms.providers". */
export type smsProviderOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  endpoint?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: sms.providers */
export type smsProviderPkColumnsInput = {
  id: Scalars['Int']['input'];
};

/** select columns of table "sms.providers" */
export type smsProviderSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'endpoint'
  /** column name */
  | 'id'
  /** column name */
  | 'updatedAt'
  | '%future added value';

/** input type for updating data in table "sms.providers" */
export type smsProviderSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type smsProviderStddevFields = {
  __typename?: 'smsProviderStddevFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type smsProviderStddevPopFields = {
  __typename?: 'smsProviderStddevPopFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type smsProviderStddevSampFields = {
  __typename?: 'smsProviderStddevSampFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "smsProvider" */
export type smsProviderStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: smsProviderStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type smsProviderStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type smsProviderSumFields = {
  __typename?: 'smsProviderSumFields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "sms.providers" */
export type smsProviderUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'endpoint'
  /** column name */
  | 'id'
  /** column name */
  | 'updatedAt'
  | '%future added value';

export type smsProviderUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<smsProviderIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<smsProviderSetInput>;
  /** filter the rows which have to be updated */
  where: smsProviderBoolExp;
};

/** aggregate varPop on columns */
export type smsProviderVarPopFields = {
  __typename?: 'smsProviderVarPopFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type smsProviderVarSampFields = {
  __typename?: 'smsProviderVarSampFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type smsProviderVarianceFields = {
  __typename?: 'smsProviderVarianceFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "sms.sms" */
export type smsSm = {
  __typename?: 'smsSm';
  content: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  deliveryReportGates?: Maybe<Scalars['Int']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  platformId?: Maybe<Scalars['String']['output']>;
  platformPartnerId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  useDeliveryReport?: Maybe<Scalars['Boolean']['output']>;
  userData?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "sms.sms" */
export type smsSmAggregate = {
  __typename?: 'smsSmAggregate';
  aggregate?: Maybe<smsSmAggregateFields>;
  nodes: Array<smsSm>;
};

/** aggregate fields of "sms.sms" */
export type smsSmAggregateFields = {
  __typename?: 'smsSmAggregateFields';
  avg?: Maybe<smsSmAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<smsSmMaxFields>;
  min?: Maybe<smsSmMinFields>;
  stddev?: Maybe<smsSmStddevFields>;
  stddevPop?: Maybe<smsSmStddevPopFields>;
  stddevSamp?: Maybe<smsSmStddevSampFields>;
  sum?: Maybe<smsSmSumFields>;
  varPop?: Maybe<smsSmVarPopFields>;
  varSamp?: Maybe<smsSmVarSampFields>;
  variance?: Maybe<smsSmVarianceFields>;
};


/** aggregate fields of "sms.sms" */
export type smsSmAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<smsSmSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type smsSmAvgFields = {
  __typename?: 'smsSmAvgFields';
  deliveryReportGates?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "sms.sms". All fields are combined with a logical 'AND'. */
export type smsSmBoolExp = {
  _and?: InputMaybe<Array<smsSmBoolExp>>;
  _not?: InputMaybe<smsSmBoolExp>;
  _or?: InputMaybe<Array<smsSmBoolExp>>;
  content?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deliveryReportGates?: InputMaybe<IntComparisonExp>;
  destination?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  platformId?: InputMaybe<StringComparisonExp>;
  platformPartnerId?: InputMaybe<StringComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  useDeliveryReport?: InputMaybe<BooleanComparisonExp>;
  userData?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "sms.sms" */
export type smsSmConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'sms_pkey'
  | '%future added value';

/** input type for incrementing numeric columns in table "sms.sms" */
export type smsSmIncInput = {
  deliveryReportGates?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "sms.sms" */
export type smsSmInsertInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deliveryReportGates?: InputMaybe<Scalars['Int']['input']>;
  destination?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  platformId?: InputMaybe<Scalars['String']['input']>;
  platformPartnerId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  useDeliveryReport?: InputMaybe<Scalars['Boolean']['input']>;
  userData?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type smsSmMaxFields = {
  __typename?: 'smsSmMaxFields';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deliveryReportGates?: Maybe<Scalars['Int']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  platformId?: Maybe<Scalars['String']['output']>;
  platformPartnerId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userData?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type smsSmMinFields = {
  __typename?: 'smsSmMinFields';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deliveryReportGates?: Maybe<Scalars['Int']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  platformId?: Maybe<Scalars['String']['output']>;
  platformPartnerId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userData?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "sms.sms" */
export type smsSmMutationResponse = {
  __typename?: 'smsSmMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<smsSm>;
};

/** on_conflict condition type for table "sms.sms" */
export type smsSmOnConflict = {
  constraint: smsSmConstraint;
  updateColumns?: Array<smsSmUpdateColumn>;
  where?: InputMaybe<smsSmBoolExp>;
};

/** Ordering options when selecting data from "sms.sms". */
export type smsSmOrderBy = {
  content?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deliveryReportGates?: InputMaybe<OrderBy>;
  destination?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  platformId?: InputMaybe<OrderBy>;
  platformPartnerId?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  useDeliveryReport?: InputMaybe<OrderBy>;
  userData?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: sms.sms */
export type smsSmPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "sms.sms" */
export type smsSmSelectColumn =
  /** column name */
  | 'content'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'deliveryReportGates'
  /** column name */
  | 'destination'
  /** column name */
  | 'id'
  /** column name */
  | 'platformId'
  /** column name */
  | 'platformPartnerId'
  /** column name */
  | 'source'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'useDeliveryReport'
  /** column name */
  | 'userData'
  | '%future added value';

/** input type for updating data in table "sms.sms" */
export type smsSmSetInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deliveryReportGates?: InputMaybe<Scalars['Int']['input']>;
  destination?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  platformId?: InputMaybe<Scalars['String']['input']>;
  platformPartnerId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  useDeliveryReport?: InputMaybe<Scalars['Boolean']['input']>;
  userData?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type smsSmStddevFields = {
  __typename?: 'smsSmStddevFields';
  deliveryReportGates?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type smsSmStddevPopFields = {
  __typename?: 'smsSmStddevPopFields';
  deliveryReportGates?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type smsSmStddevSampFields = {
  __typename?: 'smsSmStddevSampFields';
  deliveryReportGates?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "smsSm" */
export type smsSmStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: smsSmStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type smsSmStreamCursorValueInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deliveryReportGates?: InputMaybe<Scalars['Int']['input']>;
  destination?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  platformId?: InputMaybe<Scalars['String']['input']>;
  platformPartnerId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  useDeliveryReport?: InputMaybe<Scalars['Boolean']['input']>;
  userData?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type smsSmSumFields = {
  __typename?: 'smsSmSumFields';
  deliveryReportGates?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "sms.sms" */
export type smsSmUpdateColumn =
  /** column name */
  | 'content'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'deliveryReportGates'
  /** column name */
  | 'destination'
  /** column name */
  | 'id'
  /** column name */
  | 'platformId'
  /** column name */
  | 'platformPartnerId'
  /** column name */
  | 'source'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'useDeliveryReport'
  /** column name */
  | 'userData'
  | '%future added value';

export type smsSmUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<smsSmIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<smsSmSetInput>;
  /** filter the rows which have to be updated */
  where: smsSmBoolExp;
};

/** aggregate varPop on columns */
export type smsSmVarPopFields = {
  __typename?: 'smsSmVarPopFields';
  deliveryReportGates?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type smsSmVarSampFields = {
  __typename?: 'smsSmVarSampFields';
  deliveryReportGates?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type smsSmVarianceFields = {
  __typename?: 'smsSmVarianceFields';
  deliveryReportGates?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "sms.sms_external_incoming_link_mobility" */
export type smsSmsExternalIncomingLinkMobility = {
  __typename?: 'smsSmsExternalIncomingLinkMobility';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  message: smsLinkMobilitySmsMessage;
  messageId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  uuid: Scalars['uuid']['output'];
};

/** aggregated selection of "sms.sms_external_incoming_link_mobility" */
export type smsSmsExternalIncomingLinkMobilityAggregate = {
  __typename?: 'smsSmsExternalIncomingLinkMobilityAggregate';
  aggregate?: Maybe<smsSmsExternalIncomingLinkMobilityAggregateFields>;
  nodes: Array<smsSmsExternalIncomingLinkMobility>;
};

/** aggregate fields of "sms.sms_external_incoming_link_mobility" */
export type smsSmsExternalIncomingLinkMobilityAggregateFields = {
  __typename?: 'smsSmsExternalIncomingLinkMobilityAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<smsSmsExternalIncomingLinkMobilityMaxFields>;
  min?: Maybe<smsSmsExternalIncomingLinkMobilityMinFields>;
};


/** aggregate fields of "sms.sms_external_incoming_link_mobility" */
export type smsSmsExternalIncomingLinkMobilityAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<smsSmsExternalIncomingLinkMobilitySelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "sms.sms_external_incoming_link_mobility". All fields are combined with a logical 'AND'. */
export type smsSmsExternalIncomingLinkMobilityBoolExp = {
  _and?: InputMaybe<Array<smsSmsExternalIncomingLinkMobilityBoolExp>>;
  _not?: InputMaybe<smsSmsExternalIncomingLinkMobilityBoolExp>;
  _or?: InputMaybe<Array<smsSmsExternalIncomingLinkMobilityBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  message?: InputMaybe<smsLinkMobilitySmsMessageBoolExp>;
  messageId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  uuid?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "sms.sms_external_incoming_link_mobility" */
export type smsSmsExternalIncomingLinkMobilityConstraint =
  /** unique or primary key constraint on columns "uuid" */
  | 'external_sms_link_mobility_pkey'
  | '%future added value';

/** input type for inserting data into table "sms.sms_external_incoming_link_mobility" */
export type smsSmsExternalIncomingLinkMobilityInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  message?: InputMaybe<smsLinkMobilitySmsMessageObjRelInsertInput>;
  messageId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type smsSmsExternalIncomingLinkMobilityMaxFields = {
  __typename?: 'smsSmsExternalIncomingLinkMobilityMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  messageId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type smsSmsExternalIncomingLinkMobilityMinFields = {
  __typename?: 'smsSmsExternalIncomingLinkMobilityMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  messageId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  uuid?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "sms.sms_external_incoming_link_mobility" */
export type smsSmsExternalIncomingLinkMobilityMutationResponse = {
  __typename?: 'smsSmsExternalIncomingLinkMobilityMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<smsSmsExternalIncomingLinkMobility>;
};

/** on_conflict condition type for table "sms.sms_external_incoming_link_mobility" */
export type smsSmsExternalIncomingLinkMobilityOnConflict = {
  constraint: smsSmsExternalIncomingLinkMobilityConstraint;
  updateColumns?: Array<smsSmsExternalIncomingLinkMobilityUpdateColumn>;
  where?: InputMaybe<smsSmsExternalIncomingLinkMobilityBoolExp>;
};

/** Ordering options when selecting data from "sms.sms_external_incoming_link_mobility". */
export type smsSmsExternalIncomingLinkMobilityOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  message?: InputMaybe<smsLinkMobilitySmsMessageOrderBy>;
  messageId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  uuid?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: sms.sms_external_incoming_link_mobility */
export type smsSmsExternalIncomingLinkMobilityPkColumnsInput = {
  uuid: Scalars['uuid']['input'];
};

/** select columns of table "sms.sms_external_incoming_link_mobility" */
export type smsSmsExternalIncomingLinkMobilitySelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'messageId'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'uuid'
  | '%future added value';

/** input type for updating data in table "sms.sms_external_incoming_link_mobility" */
export type smsSmsExternalIncomingLinkMobilitySetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  messageId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "smsSmsExternalIncomingLinkMobility" */
export type smsSmsExternalIncomingLinkMobilityStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: smsSmsExternalIncomingLinkMobilityStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type smsSmsExternalIncomingLinkMobilityStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  messageId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uuid?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "sms.sms_external_incoming_link_mobility" */
export type smsSmsExternalIncomingLinkMobilityUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'messageId'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'uuid'
  | '%future added value';

export type smsSmsExternalIncomingLinkMobilityUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<smsSmsExternalIncomingLinkMobilitySetInput>;
  /** filter the rows which have to be updated */
  where: smsSmsExternalIncomingLinkMobilityBoolExp;
};

export type subscription_root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "business.direction" */
  ActivityDirection: Array<ActivityDirection>;
  /** fetch aggregated fields from the table: "business.direction" */
  ActivityDirectionAggregate: ActivityDirectionAggregate;
  /** fetch data from the table: "business.direction" using primary key columns */
  ActivityDirectionByPk?: Maybe<ActivityDirection>;
  /** fetch data from the table in a streaming manner: "business.direction" */
  ActivityDirectionStream: Array<ActivityDirection>;
  /** fetch data from the table: "business.provider" */
  ActivityProvider: Array<ActivityProvider>;
  /** fetch aggregated fields from the table: "business.provider" */
  ActivityProviderAggregate: ActivityProviderAggregate;
  /** fetch data from the table: "business.provider" using primary key columns */
  ActivityProviderByPk?: Maybe<ActivityProvider>;
  /** fetch data from the table in a streaming manner: "business.provider" */
  ActivityProviderStream: Array<ActivityProvider>;
  /** fetch data from the table: "business.queue_item_flexibility_type" */
  QueueItemFlexibilityType: Array<QueueItemFlexibilityType>;
  /** fetch aggregated fields from the table: "business.queue_item_flexibility_type" */
  QueueItemFlexibilityTypeAggregate: QueueItemFlexibilityTypeAggregate;
  /** fetch data from the table: "business.queue_item_flexibility_type" using primary key columns */
  QueueItemFlexibilityTypeByPk?: Maybe<QueueItemFlexibilityType>;
  /** fetch data from the table in a streaming manner: "business.queue_item_flexibility_type" */
  QueueItemFlexibilityTypeStream: Array<QueueItemFlexibilityType>;
  /** fetch data from the table: "business.queue_item_participant_responsibiliy_type" */
  QueueItemParticipantResponsibilityType: Array<QueueItemParticipantResponsibilityType>;
  /** fetch aggregated fields from the table: "business.queue_item_participant_responsibiliy_type" */
  QueueItemParticipantResponsibilityTypeAggregate: QueueItemParticipantResponsibilityTypeAggregate;
  /** fetch data from the table: "business.queue_item_participant_responsibiliy_type" using primary key columns */
  QueueItemParticipantResponsibilityTypeByPk?: Maybe<QueueItemParticipantResponsibilityType>;
  /** fetch data from the table in a streaming manner: "business.queue_item_participant_responsibiliy_type" */
  QueueItemParticipantResponsibilityTypeStream: Array<QueueItemParticipantResponsibilityType>;
  /** fetch data from the table: "business.relation_type" */
  RelationType: Array<RelationType>;
  /** fetch aggregated fields from the table: "business.relation_type" */
  RelationTypeAggregate: RelationTypeAggregate;
  /** fetch data from the table: "business.relation_type" using primary key columns */
  RelationTypeByPk?: Maybe<RelationType>;
  /** fetch data from the table in a streaming manner: "business.relation_type" */
  RelationTypeStream: Array<RelationType>;
  /** fetch data from the table: "business.queue_item_participant" using primary key columns */
  activityParticipant?: Maybe<activityParticipant>;
  /** fetch data from the table: "business.queue_item_participant" */
  activityParticipants: Array<activityParticipant>;
  /** fetch aggregated fields from the table: "business.queue_item_participant" */
  activityParticipantsAggregate: activityParticipantAggregate;
  /** fetch data from the table in a streaming manner: "business.queue_item_participant" */
  activityParticipantsStream: Array<activityParticipant>;
  /** fetch data from the table: "business.activity_status" using primary key columns */
  activityStatus?: Maybe<ActivityStatus>;
  /** fetch data from the table: "business.activity_status" */
  activityStatuses: Array<ActivityStatus>;
  /** fetch aggregated fields from the table: "business.activity_status" */
  activityStatusesAggregate: ActivityStatusAggregate;
  /** fetch data from the table in a streaming manner: "business.activity_status" */
  activityStatusesStream: Array<ActivityStatus>;
  /** fetch data from the table: "business.activity_type" using primary key columns */
  activityType?: Maybe<ActivityType>;
  /** fetch data from the table: "business.activity_type" */
  activityTypes: Array<ActivityType>;
  /** fetch aggregated fields from the table: "business.activity_type" */
  activityTypesAggregate: ActivityTypeAggregate;
  /** fetch data from the table in a streaming manner: "business.activity_type" */
  activityTypesStream: Array<ActivityType>;
  /** fetch data from the table: "business.address" using primary key columns */
  address?: Maybe<address>;
  /** An array relationship */
  addresses: Array<address>;
  /** An aggregate relationship */
  addressesAggregate: addressAggregate;
  /** fetch data from the table in a streaming manner: "business.address" */
  addressesStream: Array<address>;
  /** fetch aggregated fields from the table: "business.user_contacts" */
  aggregateBusinessUserContacts: businessUserContactsAggregate;
  /** fetch aggregated fields from the table: "business.user_settings" */
  aggregateBusinessUserSettings: businessUserSettingsAggregate;
  /** fetch aggregated fields from the table: "messaging.activity" */
  aggregateMessagingActivities: messagingActivityAggregate;
  /** fetch aggregated fields from the table: "messaging.activity_type" */
  aggregateMessagingActivityTypes: messagingActivityTypeAggregate;
  /** fetch aggregated fields from the table: "messaging.activity_user" */
  aggregateMessagingActivityUsers: messagingActivityUserAggregate;
  /** fetch aggregated fields from the table: "messaging.message_emoji" */
  aggregateMessagingMessageEmojis: messagingMessageEmojiAggregate;
  /** fetch aggregated fields from the table: "messaging.message_read" */
  aggregateMessagingMessageReads: messagingMessageReadAggregate;
  /** fetch aggregated fields from the table: "messaging.message_type" */
  aggregateMessagingMessageTypes: messagingMessageTypeAggregate;
  /** fetch aggregated fields from the table: "messaging.message" */
  aggregateMessagingMessages: messagingMessageAggregate;
  /** fetch aggregated fields from the table: "business.authorization_enum_group" */
  aggregateOrganizationAuthorizationEnumGroups: organizationAuthorizationEnumGroupAggregate;
  /** fetch aggregated fields from the table: "business.authorization_group" */
  aggregateOrganizationAuthorizationGroups: organizationAuthorizationGroupAggregate;
  /** fetch aggregated fields from the table: "business.organization_relationship_category" */
  aggregateOrganizationOrganizationRelationshipCategories: organizationOrganizationRelationshipCategoryAggregate;
  /** fetch aggregated fields from the table: "business.organization_relationship" */
  aggregateOrganizationOrganizationRelationships: organizationOrganizationRelationshipAggregate;
  /** fetch aggregated fields from the table: "business.organization_user_authorization" */
  aggregateOrganizationOrganizationUserAuthorizations: organizationOrganizationUserAuthorizationAggregate;
  /** fetch aggregated fields from the table: "business.organization_user__organizations_view" */
  aggregateOrganizationOrganizationUserOrganizationsViews: organizationOrganizationUserOrganizationsViewAggregate;
  /** fetch aggregated fields from the table: "business.organization_user__users_view" */
  aggregateOrganizationOrganizationUserUsersViews: organizationOrganizationUserUsersViewAggregate;
  /** fetch aggregated fields from the table: "business.user_authorization" */
  aggregateOrganizationUserAuthorizations: organizationUserAuthorizationAggregate;
  /** fetch aggregated fields from the table: "devices" */
  aggregatePublicDevices: publicDeviceAggregate;
  /** fetch aggregated fields from the table: "external_requests" */
  aggregatePublicExternalRequests: publicExternalRequestAggregate;
  /** fetch aggregated fields from the table: "files" */
  aggregatePublicFiles: publicFileAggregate;
  /** fetch aggregated fields from the table: "notifications" */
  aggregatePublicNotifications: publicNotificationAggregate;
  /** fetch aggregated fields from the table: "sms.connectors" */
  aggregateSmsConnectors: smsConnectorAggregate;
  /** fetch aggregated fields from the table: "sms.gates" */
  aggregateSmsGates: smsGateAggregate;
  /** fetch aggregated fields from the table: "sms.link_mobility_sms_content" */
  aggregateSmsLinkMobilitySmsContents: smsLinkMobilitySmsContentAggregate;
  /** fetch aggregated fields from the table: "sms.link_mobility_sms_message" */
  aggregateSmsLinkMobilitySmsMessages: smsLinkMobilitySmsMessageAggregate;
  /** fetch aggregated fields from the table: "sms.link_mobility_sms_route" */
  aggregateSmsLinkMobilitySmsRoutes: smsLinkMobilitySmsRouteAggregate;
  /** fetch aggregated fields from the table: "sms.providers" */
  aggregateSmsProviders: smsProviderAggregate;
  /** fetch aggregated fields from the table: "sms.sms" */
  aggregateSmsSms: smsSmAggregate;
  /** fetch aggregated fields from the table: "sms.sms_external_incoming_link_mobility" */
  aggregateSmsSmsExternalIncomingLinkMobilities: smsSmsExternalIncomingLinkMobilityAggregate;
  /** fetch aggregated fields from the table: "validation.validation" */
  aggregateValidationValidations: validationValidationAggregate;
  /** fetch data from the table: "business.blocked_domain_user" using primary key columns */
  blockedDomainUser?: Maybe<blockedDomainUser>;
  /** fetch data from the table: "business.blocked_domain_user" */
  blockedDomainUsers: Array<blockedDomainUser>;
  /** fetch aggregated fields from the table: "business.blocked_domain_user" */
  blockedDomainUsersAggregate: blockedDomainUserAggregate;
  /** fetch data from the table in a streaming manner: "business.blocked_domain_user" */
  blockedDomainUsersStream: Array<blockedDomainUser>;
  breg?: Maybe<bregsubscription_root>;
  /** fetch data from the table: "business.domain_activity_type" */
  businessDomainActivityType: Array<BusinessDomainActivityType>;
  /** fetch aggregated fields from the table: "business.domain_activity_type" */
  businessDomainActivityTypeAggregate: BusinessDomainActivityTypeAggregate;
  /** fetch data from the table: "business.domain_activity_type" using primary key columns */
  businessDomainActivityTypeByPk?: Maybe<BusinessDomainActivityType>;
  /** fetch data from the table in a streaming manner: "business.domain_activity_type" */
  businessDomainActivityTypeStream: Array<BusinessDomainActivityType>;
  /** fetch data from the table: "business.feed_type" */
  businessFeedType: Array<BusinessFeedType>;
  /** fetch aggregated fields from the table: "business.feed_type" */
  businessFeedTypeAggregate: BusinessFeedTypeAggregate;
  /** fetch data from the table: "business.feed_type" using primary key columns */
  businessFeedTypeByPk?: Maybe<BusinessFeedType>;
  /** fetch data from the table in a streaming manner: "business.feed_type" */
  businessFeedTypeStream: Array<BusinessFeedType>;
  /** fetch data from the table: "business.message_attachments" */
  businessMessageAttachments: Array<BusinessMessageAttachments>;
  /** fetch aggregated fields from the table: "business.message_attachments" */
  businessMessageAttachmentsAggregate: BusinessMessageAttachmentsAggregate;
  /** fetch data from the table: "business.message_attachments" using primary key columns */
  businessMessageAttachmentsByPk?: Maybe<BusinessMessageAttachments>;
  /** fetch data from the table in a streaming manner: "business.message_attachments" */
  businessMessageAttachmentsStream: Array<BusinessMessageAttachments>;
  /** fetch data from the table: "business.organization_user_callback_answer" */
  businessOrganizationUserCallbackAnswer: Array<BusinessOrganizationUserCallbackAnswer>;
  /** fetch aggregated fields from the table: "business.organization_user_callback_answer" */
  businessOrganizationUserCallbackAnswerAggregate: BusinessOrganizationUserCallbackAnswerAggregate;
  /** fetch data from the table: "business.organization_user_callback_answer" using primary key columns */
  businessOrganizationUserCallbackAnswerByPk?: Maybe<BusinessOrganizationUserCallbackAnswer>;
  /** fetch data from the table in a streaming manner: "business.organization_user_callback_answer" */
  businessOrganizationUserCallbackAnswerStream: Array<BusinessOrganizationUserCallbackAnswer>;
  /** fetch data from the table: "business.organization_user_email" */
  businessOrganizationUserEmail: Array<BusinessOrganizationUserEmail>;
  /** fetch aggregated fields from the table: "business.organization_user_email" */
  businessOrganizationUserEmailAggregate: BusinessOrganizationUserEmailAggregate;
  /** fetch data from the table: "business.organization_user_email" using primary key columns */
  businessOrganizationUserEmailByPk?: Maybe<BusinessOrganizationUserEmail>;
  /** fetch data from the table in a streaming manner: "business.organization_user_email" */
  businessOrganizationUserEmailStream: Array<BusinessOrganizationUserEmail>;
  /** fetch data from the table: "business.organization_user_email_type" */
  businessOrganizationUserEmailType: Array<BusinessOrganizationUserEmailType>;
  /** fetch aggregated fields from the table: "business.organization_user_email_type" */
  businessOrganizationUserEmailTypeAggregate: BusinessOrganizationUserEmailTypeAggregate;
  /** fetch data from the table: "business.organization_user_email_type" using primary key columns */
  businessOrganizationUserEmailTypeByPk?: Maybe<BusinessOrganizationUserEmailType>;
  /** fetch data from the table in a streaming manner: "business.organization_user_email_type" */
  businessOrganizationUserEmailTypeStream: Array<BusinessOrganizationUserEmailType>;
  /** fetch aggregated fields from the table: "business.organization_user_request" */
  businessOrganizationUserRequestAggregate: BusinessOrganizationUserRequestAggregate;
  /** fetch data from the table in a streaming manner: "business.organization_user_request" */
  businessOrganizationUserRequestStream: Array<BusinessOrganizationUserRequest>;
  /** fetch data from the table: "business.organization_user_request_type" */
  businessOrganizationUserRequestType: Array<BusinessOrganizationUserRequestType>;
  /** fetch aggregated fields from the table: "business.organization_user_request_type" */
  businessOrganizationUserRequestTypeAggregate: BusinessOrganizationUserRequestTypeAggregate;
  /** fetch data from the table: "business.organization_user_request_type" using primary key columns */
  businessOrganizationUserRequestTypeByPk?: Maybe<BusinessOrganizationUserRequestType>;
  /** fetch data from the table in a streaming manner: "business.organization_user_request_type" */
  businessOrganizationUserRequestTypeStream: Array<BusinessOrganizationUserRequestType>;
  /** fetch data from the table: "business.organization_user_suggestion_type" */
  businessOrganizationUserSuggestionType: Array<BusinessOrganizationUserSuggestionType>;
  /** fetch aggregated fields from the table: "business.organization_user_suggestion_type" */
  businessOrganizationUserSuggestionTypeAggregate: BusinessOrganizationUserSuggestionTypeAggregate;
  /** fetch data from the table: "business.organization_user_suggestion_type" using primary key columns */
  businessOrganizationUserSuggestionTypeByPk?: Maybe<BusinessOrganizationUserSuggestionType>;
  /** fetch data from the table in a streaming manner: "business.organization_user_suggestion_type" */
  businessOrganizationUserSuggestionTypeStream: Array<BusinessOrganizationUserSuggestionType>;
  /** fetch data from the table: "business.organization_user_suggestions" */
  businessOrganizationUserSuggestions: Array<BusinessOrganizationUserSuggestions>;
  /** fetch aggregated fields from the table: "business.organization_user_suggestions" */
  businessOrganizationUserSuggestionsAggregate: BusinessOrganizationUserSuggestionsAggregate;
  /** fetch data from the table: "business.organization_user_suggestions" using primary key columns */
  businessOrganizationUserSuggestionsByPk?: Maybe<BusinessOrganizationUserSuggestions>;
  /** fetch data from the table in a streaming manner: "business.organization_user_suggestions" */
  businessOrganizationUserSuggestionsStream: Array<BusinessOrganizationUserSuggestions>;
  /** fetch data from the table: "business.organization_user_url_address" */
  businessOrganizationUserUrlAddress: Array<BusinessOrganizationUserUrlAddress>;
  /** fetch aggregated fields from the table: "business.organization_user_url_address" */
  businessOrganizationUserUrlAddressAggregate: BusinessOrganizationUserUrlAddressAggregate;
  /** fetch data from the table: "business.organization_user_url_address" using primary key columns */
  businessOrganizationUserUrlAddressByPk?: Maybe<BusinessOrganizationUserUrlAddress>;
  /** fetch data from the table in a streaming manner: "business.organization_user_url_address" */
  businessOrganizationUserUrlAddressStream: Array<BusinessOrganizationUserUrlAddress>;
  /** fetch data from the table: "business.organization_user_url_address_type" */
  businessOrganizationUserUrlAddressType: Array<BusinessOrganizationUserUrlAddressType>;
  /** fetch aggregated fields from the table: "business.organization_user_url_address_type" */
  businessOrganizationUserUrlAddressTypeAggregate: BusinessOrganizationUserUrlAddressTypeAggregate;
  /** fetch data from the table: "business.organization_user_url_address_type" using primary key columns */
  businessOrganizationUserUrlAddressTypeByPk?: Maybe<BusinessOrganizationUserUrlAddressType>;
  /** fetch data from the table in a streaming manner: "business.organization_user_url_address_type" */
  businessOrganizationUserUrlAddressTypeStream: Array<BusinessOrganizationUserUrlAddressType>;
  /** fetch data from the table: "business.queue_item_alarm_type" */
  businessQueueItemAlarmType: Array<BusinessQueueItemAlarmType>;
  /** fetch aggregated fields from the table: "business.queue_item_alarm_type" */
  businessQueueItemAlarmTypeAggregate: BusinessQueueItemAlarmTypeAggregate;
  /** fetch data from the table: "business.queue_item_alarm_type" using primary key columns */
  businessQueueItemAlarmTypeByPk?: Maybe<BusinessQueueItemAlarmType>;
  /** fetch data from the table in a streaming manner: "business.queue_item_alarm_type" */
  businessQueueItemAlarmTypeStream: Array<BusinessQueueItemAlarmType>;
  /** fetch data from the table: "business.queue_item_alarms" */
  businessQueueItemAlarms: Array<BusinessQueueItemAlarms>;
  /** fetch aggregated fields from the table: "business.queue_item_alarms" */
  businessQueueItemAlarmsAggregate: BusinessQueueItemAlarmsAggregate;
  /** fetch data from the table: "business.queue_item_alarms" using primary key columns */
  businessQueueItemAlarmsByPk?: Maybe<BusinessQueueItemAlarms>;
  /** fetch data from the table in a streaming manner: "business.queue_item_alarms" */
  businessQueueItemAlarmsStream: Array<BusinessQueueItemAlarms>;
  /** fetch data from the table: "business.queue_item_collaboration" using primary key columns */
  businessQueueItemCollaboration?: Maybe<businessQueueItemCollaboration>;
  /** fetch aggregated fields from the table: "business.queue_item_collaboration" */
  businessQueueItemCollaborationAggregate: businessQueueItemCollaborationAggregate;
  /** fetch data from the table in a streaming manner: "business.queue_item_collaboration" */
  businessQueueItemCollaborationStream: Array<businessQueueItemCollaboration>;
  /** fetch data from the table: "business.queue_item_collaboration" */
  businessQueueItemCollaborations: Array<businessQueueItemCollaboration>;
  /** fetch data from the table: "business.queue_item_domain_users_view" */
  businessQueueItemDomainUsersView: Array<BusinessQueueItemDomainUsersView>;
  /** fetch aggregated fields from the table: "business.queue_item_domain_users_view" */
  businessQueueItemDomainUsersViewAggregate: BusinessQueueItemDomainUsersViewAggregate;
  /** fetch data from the table in a streaming manner: "business.queue_item_domain_users_view" */
  businessQueueItemDomainUsersViewStream: Array<BusinessQueueItemDomainUsersView>;
  /** fetch data from the table: "business.queue_item_organization_users_view" */
  businessQueueItemOrganizationUsersView: Array<BusinessQueueItemOrganizationUsersView>;
  /** fetch aggregated fields from the table: "business.queue_item_organization_users_view" */
  businessQueueItemOrganizationUsersViewAggregate: BusinessQueueItemOrganizationUsersViewAggregate;
  /** fetch data from the table in a streaming manner: "business.queue_item_organization_users_view" */
  businessQueueItemOrganizationUsersViewStream: Array<BusinessQueueItemOrganizationUsersView>;
  /** fetch data from the table: "business.queue_item_participant_channel_type" */
  businessQueueItemParticipantChannelType: Array<BusinessQueueItemParticipantChannelType>;
  /** fetch aggregated fields from the table: "business.queue_item_participant_channel_type" */
  businessQueueItemParticipantChannelTypeAggregate: BusinessQueueItemParticipantChannelTypeAggregate;
  /** fetch data from the table: "business.queue_item_participant_channel_type" using primary key columns */
  businessQueueItemParticipantChannelTypeByPk?: Maybe<BusinessQueueItemParticipantChannelType>;
  /** fetch data from the table in a streaming manner: "business.queue_item_participant_channel_type" */
  businessQueueItemParticipantChannelTypeStream: Array<BusinessQueueItemParticipantChannelType>;
  /** fetch data from the table: "business.queue_item_participants_view" */
  businessQueueItemParticipantsView: Array<BusinessQueueItemParticipantsView>;
  /** fetch aggregated fields from the table: "business.queue_item_participants_view" */
  businessQueueItemParticipantsViewAggregate: BusinessQueueItemParticipantsViewAggregate;
  /** fetch data from the table in a streaming manner: "business.queue_item_participants_view" */
  businessQueueItemParticipantsViewStream: Array<BusinessQueueItemParticipantsView>;
  /** fetch data from the table: "business.queue_item_sub_type" */
  businessQueueItemSubType: Array<BusinessQueueItemSubType>;
  /** fetch aggregated fields from the table: "business.queue_item_sub_type" */
  businessQueueItemSubTypeAggregate: BusinessQueueItemSubTypeAggregate;
  /** fetch data from the table: "business.queue_item_sub_type" using primary key columns */
  businessQueueItemSubTypeByPk?: Maybe<BusinessQueueItemSubType>;
  /** fetch data from the table in a streaming manner: "business.queue_item_sub_type" */
  businessQueueItemSubTypeStream: Array<BusinessQueueItemSubType>;
  /** fetch data from the table: "business.user_contacts" using primary key columns */
  businessUserContact?: Maybe<businessUserContacts>;
  /** fetch data from the table: "business.user_contact_numbers" */
  businessUserContactNumbers: Array<BusinessUserContactNumbers>;
  /** fetch aggregated fields from the table: "business.user_contact_numbers" */
  businessUserContactNumbersAggregate: BusinessUserContactNumbersAggregate;
  /** fetch data from the table: "business.user_contact_numbers" using primary key columns */
  businessUserContactNumbersByPk?: Maybe<BusinessUserContactNumbers>;
  /** fetch data from the table in a streaming manner: "business.user_contact_numbers" */
  businessUserContactNumbersStream: Array<BusinessUserContactNumbers>;
  /** fetch data from the table: "business.user_contacts" */
  businessUserContacts: Array<businessUserContacts>;
  /** fetch data from the table: "business.user_feed" */
  businessUserFeed: Array<BusinessUserFeed>;
  /** fetch aggregated fields from the table: "business.user_feed" */
  businessUserFeedAggregate: BusinessUserFeedAggregate;
  /** fetch data from the table: "business.user_feed" using primary key columns */
  businessUserFeedByPk?: Maybe<BusinessUserFeed>;
  /** fetch data from the table in a streaming manner: "business.user_feed" */
  businessUserFeedStream: Array<BusinessUserFeed>;
  /** fetch data from the table: "business.user_request_status" */
  businessUserRequestStatus: Array<BusinessUserRequestStatus>;
  /** fetch aggregated fields from the table: "business.user_request_status" */
  businessUserRequestStatusAggregate: BusinessUserRequestStatusAggregate;
  /** fetch data from the table: "business.user_request_status" using primary key columns */
  businessUserRequestStatusByPk?: Maybe<BusinessUserRequestStatus>;
  /** fetch data from the table in a streaming manner: "business.user_request_status" */
  businessUserRequestStatusStream: Array<BusinessUserRequestStatus>;
  /** fetch data from the table: "business.user_settings" using primary key columns */
  businessUserSetting?: Maybe<businessUserSettings>;
  /** fetch data from the table: "business.user_settings" */
  businessUserSettings: Array<businessUserSettings>;
  /** fetch data from the table: "business.user_states" */
  businessUserStates: Array<BusinessUserStates>;
  /** fetch aggregated fields from the table: "business.user_states" */
  businessUserStatesAggregate: BusinessUserStatesAggregate;
  /** fetch data from the table: "business.user_states" using primary key columns */
  businessUserStatesByPk?: Maybe<BusinessUserStates>;
  /** fetch data from the table in a streaming manner: "business.user_states" */
  businessUserStatesStream: Array<BusinessUserStates>;
  /** fetch data from the table: "crm.context" */
  crmContext: Array<CrmContext>;
  /** fetch aggregated fields from the table: "crm.context" */
  crmContextAggregate: CrmContextAggregate;
  /** fetch data from the table: "crm.context" using primary key columns */
  crmContextByPk?: Maybe<CrmContext>;
  /** fetch data from the table in a streaming manner: "crm.context" */
  crmContextStream: Array<CrmContext>;
  /** fetch data from the table: "crm.context_type" */
  crmContextType: Array<CrmContextType>;
  /** fetch aggregated fields from the table: "crm.context_type" */
  crmContextTypeAggregate: CrmContextTypeAggregate;
  /** fetch data from the table: "crm.context_type" using primary key columns */
  crmContextTypeByPk?: Maybe<CrmContextType>;
  /** fetch data from the table in a streaming manner: "crm.context_type" */
  crmContextTypeStream: Array<CrmContextType>;
  /** fetch data from the table: "crm.creator_type" */
  crmCreatorType: Array<CrmCreatorType>;
  /** fetch aggregated fields from the table: "crm.creator_type" */
  crmCreatorTypeAggregate: CrmCreatorTypeAggregate;
  /** fetch data from the table: "crm.creator_type" using primary key columns */
  crmCreatorTypeByPk?: Maybe<CrmCreatorType>;
  /** fetch data from the table in a streaming manner: "crm.creator_type" */
  crmCreatorTypeStream: Array<CrmCreatorType>;
  /** fetch data from the table: "crm.crm_type" */
  crmCrmType: Array<CrmCrmType>;
  /** fetch aggregated fields from the table: "crm.crm_type" */
  crmCrmTypeAggregate: CrmCrmTypeAggregate;
  /** fetch data from the table: "crm.crm_type" using primary key columns */
  crmCrmTypeByPk?: Maybe<CrmCrmType>;
  /** fetch data from the table in a streaming manner: "crm.crm_type" */
  crmCrmTypeStream: Array<CrmCrmType>;
  /** fetch data from the table: "crm.direction_type" */
  crmDirectionType: Array<CrmDirectionType>;
  /** fetch aggregated fields from the table: "crm.direction_type" */
  crmDirectionTypeAggregate: CrmDirectionTypeAggregate;
  /** fetch data from the table: "crm.direction_type" using primary key columns */
  crmDirectionTypeByPk?: Maybe<CrmDirectionType>;
  /** fetch data from the table in a streaming manner: "crm.direction_type" */
  crmDirectionTypeStream: Array<CrmDirectionType>;
  /** fetch data from the table: "crm.entity" */
  crmEntity: Array<CrmEntity>;
  /** fetch aggregated fields from the table: "crm.entity" */
  crmEntityAggregate: CrmEntityAggregate;
  /** fetch data from the table: "crm.entity" using primary key columns */
  crmEntityByPk?: Maybe<CrmEntity>;
  /** fetch data from the table in a streaming manner: "crm.entity" */
  crmEntityStream: Array<CrmEntity>;
  /** fetch data from the table: "crm.event" */
  crmEvent: Array<CrmEvent>;
  /** fetch aggregated fields from the table: "crm.event" */
  crmEventAggregate: CrmEventAggregate;
  /** fetch data from the table: "crm.event" using primary key columns */
  crmEventByPk?: Maybe<CrmEvent>;
  /** fetch data from the table in a streaming manner: "crm.event" */
  crmEventStream: Array<CrmEvent>;
  /** fetch data from the table: "crm.event_type" */
  crmEventType: Array<CrmEventType>;
  /** fetch aggregated fields from the table: "crm.event_type" */
  crmEventTypeAggregate: CrmEventTypeAggregate;
  /** fetch data from the table: "crm.event_type" using primary key columns */
  crmEventTypeByPk?: Maybe<CrmEventType>;
  /** fetch data from the table in a streaming manner: "crm.event_type" */
  crmEventTypeStream: Array<CrmEventType>;
  /** fetch data from the table: "crm.status_code" */
  crmStatusCode: Array<CrmStatusCode>;
  /** fetch aggregated fields from the table: "crm.status_code" */
  crmStatusCodeAggregate: CrmStatusCodeAggregate;
  /** fetch data from the table: "crm.status_code" using primary key columns */
  crmStatusCodeByPk?: Maybe<CrmStatusCode>;
  /** fetch data from the table in a streaming manner: "crm.status_code" */
  crmStatusCodeStream: Array<CrmStatusCode>;
  /** fetch aggregated fields from the table: "crm.status_message" */
  crmStatusMessageAggregate: crmStatusMessageAggregate;
  /** fetch data from the table: "crm.status_message" using primary key columns */
  crmStatusMessageByPk?: Maybe<crmStatusMessage>;
  /** fetch data from the table in a streaming manner: "crm.status_message" */
  crmStatusMessageStream: Array<crmStatusMessage>;
  /** fetch data from the table: "crm.status_message" */
  crmStatusMessages: Array<crmStatusMessage>;
  /** fetch data from the table: "crm.system_type" */
  crmSystemType: Array<CrmSystemType>;
  /** fetch aggregated fields from the table: "crm.system_type" */
  crmSystemTypeAggregate: CrmSystemTypeAggregate;
  /** fetch data from the table: "crm.system_type" using primary key columns */
  crmSystemTypeByPk?: Maybe<CrmSystemType>;
  /** fetch data from the table in a streaming manner: "crm.system_type" */
  crmSystemTypeStream: Array<CrmSystemType>;
  /** fetch data from the table: "crm.trace_context" */
  crmTraceContext: Array<CrmTraceContext>;
  /** fetch aggregated fields from the table: "crm.trace_context" */
  crmTraceContextAggregate: CrmTraceContextAggregate;
  /** fetch data from the table: "crm.trace_context" using primary key columns */
  crmTraceContextByPk?: Maybe<CrmTraceContext>;
  /** fetch data from the table in a streaming manner: "crm.trace_context" */
  crmTraceContextStream: Array<CrmTraceContext>;
  /** fetch data from the table: "crm.unified_entity_type" */
  crmUnifiedEntityType: Array<CrmUnifiedEntityType>;
  /** fetch aggregated fields from the table: "crm.unified_entity_type" */
  crmUnifiedEntityTypeAggregate: CrmUnifiedEntityTypeAggregate;
  /** fetch data from the table: "crm.unified_entity_type" using primary key columns */
  crmUnifiedEntityTypeByPk?: Maybe<CrmUnifiedEntityType>;
  /** fetch data from the table in a streaming manner: "crm.unified_entity_type" */
  crmUnifiedEntityTypeStream: Array<CrmUnifiedEntityType>;
  /** fetch data from the table: "crm.youtello_catalyst_id_mapping" using primary key columns */
  crmYoutelloCatalystIdMapping?: Maybe<crmYoutelloCatalystIdMapping>;
  /** fetch aggregated fields from the table: "crm.youtello_catalyst_id_mapping" */
  crmYoutelloCatalystIdMappingAggregate: crmYoutelloCatalystIdMappingAggregate;
  /** fetch data from the table in a streaming manner: "crm.youtello_catalyst_id_mapping" */
  crmYoutelloCatalystIdMappingStream: Array<crmYoutelloCatalystIdMapping>;
  /** fetch data from the table: "crm.youtello_catalyst_id_mapping" */
  crmYoutelloCatalystIdMappings: Array<crmYoutelloCatalystIdMapping>;
  /** An array relationship */
  domainActivities: Array<domainActivity>;
  /** An aggregate relationship */
  domainActivitiesAggregate: domainActivityAggregate;
  /** fetch data from the table in a streaming manner: "business.domain_activity" */
  domainActivitiesStream: Array<domainActivity>;
  /** fetch data from the table: "business.domain_activity" using primary key columns */
  domainActivity?: Maybe<domainActivity>;
  /** fetch data from the table: "business.domain_organization" using primary key columns */
  domainOrganization?: Maybe<domainOrganization>;
  /** An array relationship */
  domainOrganizations: Array<domainOrganization>;
  /** An aggregate relationship */
  domainOrganizationsAggregate: domainOrganizationAggregate;
  /** fetch data from the table in a streaming manner: "business.domain_organization" */
  domainOrganizationsStream: Array<domainOrganization>;
  /** fetch data from the table: "business.domain_participant" using primary key columns */
  domainParticipant?: Maybe<domainParticipant>;
  /** An array relationship */
  domainParticipants: Array<domainParticipant>;
  /** An aggregate relationship */
  domainParticipantsAggregate: domainParticipantAggregate;
  /** fetch data from the table in a streaming manner: "business.domain_participant" */
  domainParticipantsStream: Array<domainParticipant>;
  /** fetch data from the table: "business.domain_type" using primary key columns */
  domainType?: Maybe<domainType>;
  /** fetch data from the table: "business.domain_type" */
  domainTypes: Array<domainType>;
  /** fetch aggregated fields from the table: "business.domain_type" */
  domainTypesAggregate: domainTypeAggregate;
  /** fetch data from the table in a streaming manner: "business.domain_type" */
  domainTypesStream: Array<domainType>;
  /** fetch data from the table: "business.domain_user" using primary key columns */
  domainUser?: Maybe<domainUser>;
  /** fetch data from the table: "business.domain_user_category" */
  domainUserCategories: Array<domainUserCategory>;
  /** fetch aggregated fields from the table: "business.domain_user_category" */
  domainUserCategoriesAggregate: domainUserCategoryAggregate;
  /** fetch data from the table in a streaming manner: "business.domain_user_category" */
  domainUserCategoriesStream: Array<domainUserCategory>;
  /** fetch data from the table: "business.domain_user_category" using primary key columns */
  domainUserCategory?: Maybe<domainUserCategory>;
  /** An array relationship */
  domainUsers: Array<domainUser>;
  /** An aggregate relationship */
  domainUsersAggregate: domainUserAggregate;
  /** fetch data from the table in a streaming manner: "business.domain_user" */
  domainUsersStream: Array<domainUser>;
  emailing?: Maybe<emailingsubscription_root>;
  geodata?: Maybe<geodatasubscription_root>;
  incomingSms?: Maybe<incomingSms>;
  /** fetch data from the table: "business.languages" using primary key columns */
  language?: Maybe<languages>;
  /** fetch aggregated fields from the table: "business.languages" */
  languageAggregate: languagesAggregate;
  /** fetch data from the table in a streaming manner: "business.languages" */
  languageStream: Array<languages>;
  /** fetch data from the table: "business.languages" */
  languages: Array<languages>;
  /** fetch data from the table: "business.message" using primary key columns */
  message?: Maybe<message>;
  /** fetch data from the table: "business.message_type" using primary key columns */
  messageType?: Maybe<messageType>;
  /** fetch data from the table: "business.message_type" */
  messageTypes: Array<messageType>;
  /** fetch aggregated fields from the table: "business.message_type" */
  messageTypesAggregate: messageTypeAggregate;
  /** fetch data from the table in a streaming manner: "business.message_type" */
  messageTypesStream: Array<messageType>;
  /** An array relationship */
  messages: Array<message>;
  /** An aggregate relationship */
  messagesAggregate: messageAggregate;
  /** fetch data from the table in a streaming manner: "business.message" */
  messagesStream: Array<message>;
  /** fetch data from the table: "messaging.activity" */
  messagingActivities: Array<messagingActivity>;
  /** fetch data from the table: "messaging.activity" using primary key columns */
  messagingActivity?: Maybe<messagingActivity>;
  /** fetch data from the table: "messaging.activity_organization" using primary key columns */
  messagingActivityOrganization?: Maybe<messagingActivityOrganization>;
  /** fetch aggregated fields from the table: "messaging.activity_organization" */
  messagingActivityOrganizationAggregate: messagingActivityOrganizationAggregate;
  /** fetch data from the table in a streaming manner: "messaging.activity_organization" */
  messagingActivityOrganizationStream: Array<messagingActivityOrganization>;
  /** fetch data from the table: "messaging.activity_organization" */
  messagingActivityOrganizations: Array<messagingActivityOrganization>;
  /** fetch data from the table: "messaging.activitySettings" */
  messagingActivitySettings: Array<MessagingActivitySettings>;
  /** fetch aggregated fields from the table: "messaging.activitySettings" */
  messagingActivitySettingsAggregate: MessagingActivitySettingsAggregate;
  /** fetch data from the table: "messaging.activitySettings" using primary key columns */
  messagingActivitySettingsByPk?: Maybe<MessagingActivitySettings>;
  /** fetch data from the table: "messaging.activitySettingsNotificationSettingType" */
  messagingActivitySettingsNotificationSettingType: Array<MessagingActivitySettingsNotificationSettingType>;
  /** fetch aggregated fields from the table: "messaging.activitySettingsNotificationSettingType" */
  messagingActivitySettingsNotificationSettingTypeAggregate: MessagingActivitySettingsNotificationSettingTypeAggregate;
  /** fetch data from the table: "messaging.activitySettingsNotificationSettingType" using primary key columns */
  messagingActivitySettingsNotificationSettingTypeByPk?: Maybe<MessagingActivitySettingsNotificationSettingType>;
  /** fetch data from the table in a streaming manner: "messaging.activitySettingsNotificationSettingType" */
  messagingActivitySettingsNotificationSettingTypeStream: Array<MessagingActivitySettingsNotificationSettingType>;
  /** fetch data from the table in a streaming manner: "messaging.activitySettings" */
  messagingActivitySettingsStream: Array<MessagingActivitySettings>;
  /** fetch data from the table in a streaming manner: "messaging.activity" */
  messagingActivityStream: Array<messagingActivity>;
  /** fetch data from the table: "messaging.activity_type" using primary key columns */
  messagingActivityType?: Maybe<messagingActivityType>;
  /** fetch data from the table in a streaming manner: "messaging.activity_type" */
  messagingActivityTypeStream: Array<messagingActivityType>;
  /** fetch data from the table: "messaging.activity_type" */
  messagingActivityTypes: Array<messagingActivityType>;
  /** fetch data from the table: "messaging.activity_user" using primary key columns */
  messagingActivityUser?: Maybe<messagingActivityUser>;
  /** fetch data from the table in a streaming manner: "messaging.activity_user" */
  messagingActivityUserStream: Array<messagingActivityUser>;
  /** fetch data from the table: "messaging.activity_user" */
  messagingActivityUsers: Array<messagingActivityUser>;
  /** fetch data from the table: "messaging.invitation" */
  messagingInvitation: Array<MessagingInvitation>;
  /** fetch aggregated fields from the table: "messaging.invitation" */
  messagingInvitationAggregate: MessagingInvitationAggregate;
  /** fetch data from the table: "messaging.invitation" using primary key columns */
  messagingInvitationByPk?: Maybe<MessagingInvitation>;
  /** fetch data from the table in a streaming manner: "messaging.invitation" */
  messagingInvitationStream: Array<MessagingInvitation>;
  /** fetch data from the table: "messaging.mentions" */
  messagingMentions: Array<MessagingMentions>;
  /** fetch aggregated fields from the table: "messaging.mentions" */
  messagingMentionsAggregate: MessagingMentionsAggregate;
  /** fetch data from the table: "messaging.mentions" using primary key columns */
  messagingMentionsByPk?: Maybe<MessagingMentions>;
  /** fetch data from the table in a streaming manner: "messaging.mentions" */
  messagingMentionsStream: Array<MessagingMentions>;
  /** fetch data from the table: "messaging.message" using primary key columns */
  messagingMessage?: Maybe<messagingMessage>;
  /** fetch data from the table: "messaging.message_attachment" */
  messagingMessageAttachment: Array<MessagingMessageAttachment>;
  /** fetch aggregated fields from the table: "messaging.message_attachment" */
  messagingMessageAttachmentAggregate: MessagingMessageAttachmentAggregate;
  /** fetch data from the table: "messaging.message_attachment" using primary key columns */
  messagingMessageAttachmentByPk?: Maybe<MessagingMessageAttachment>;
  /** fetch data from the table in a streaming manner: "messaging.message_attachment" */
  messagingMessageAttachmentStream: Array<MessagingMessageAttachment>;
  /** fetch data from the table: "messaging.message_attachment_type" */
  messagingMessageAttachmentType: Array<MessagingMessageAttachmentType>;
  /** fetch aggregated fields from the table: "messaging.message_attachment_type" */
  messagingMessageAttachmentTypeAggregate: MessagingMessageAttachmentTypeAggregate;
  /** fetch data from the table: "messaging.message_attachment_type" using primary key columns */
  messagingMessageAttachmentTypeByPk?: Maybe<MessagingMessageAttachmentType>;
  /** fetch data from the table in a streaming manner: "messaging.message_attachment_type" */
  messagingMessageAttachmentTypeStream: Array<MessagingMessageAttachmentType>;
  /** fetch data from the table: "messaging.message_emoji" using primary key columns */
  messagingMessageEmoji?: Maybe<messagingMessageEmoji>;
  /** fetch data from the table in a streaming manner: "messaging.message_emoji" */
  messagingMessageEmojiStream: Array<messagingMessageEmoji>;
  /** fetch data from the table: "messaging.message_emoji" */
  messagingMessageEmojis: Array<messagingMessageEmoji>;
  /** fetch data from the table: "messaging.message_priority" */
  messagingMessagePriority: Array<MessagingMessagePriority>;
  /** fetch aggregated fields from the table: "messaging.message_priority" */
  messagingMessagePriorityAggregate: MessagingMessagePriorityAggregate;
  /** fetch data from the table: "messaging.message_priority" using primary key columns */
  messagingMessagePriorityByPk?: Maybe<MessagingMessagePriority>;
  /** fetch data from the table in a streaming manner: "messaging.message_priority" */
  messagingMessagePriorityStream: Array<MessagingMessagePriority>;
  /** fetch data from the table: "messaging.message_read" using primary key columns */
  messagingMessageRead?: Maybe<messagingMessageRead>;
  /** fetch data from the table in a streaming manner: "messaging.message_read" */
  messagingMessageReadStream: Array<messagingMessageRead>;
  /** fetch data from the table: "messaging.message_read" */
  messagingMessageReads: Array<messagingMessageRead>;
  /** fetch data from the table in a streaming manner: "messaging.message" */
  messagingMessageStream: Array<messagingMessage>;
  /** fetch data from the table: "messaging.message_type" using primary key columns */
  messagingMessageType?: Maybe<messagingMessageType>;
  /** fetch data from the table in a streaming manner: "messaging.message_type" */
  messagingMessageTypeStream: Array<messagingMessageType>;
  /** fetch data from the table: "messaging.message_type" */
  messagingMessageTypes: Array<messagingMessageType>;
  /** fetch data from the table: "messaging.message" */
  messagingMessages: Array<messagingMessage>;
  /** fetch data from the table: "notification.notifications" using primary key columns */
  notification?: Maybe<notification>;
  /** fetch data from the table: "notification.notification_device_sent" */
  notificationNotificationDeviceSent: Array<NotificationNotificationDeviceSent>;
  /** fetch aggregated fields from the table: "notification.notification_device_sent" */
  notificationNotificationDeviceSentAggregate: NotificationNotificationDeviceSentAggregate;
  /** fetch data from the table: "notification.notification_device_sent" using primary key columns */
  notificationNotificationDeviceSentByPk?: Maybe<NotificationNotificationDeviceSent>;
  /** fetch data from the table in a streaming manner: "notification.notification_device_sent" */
  notificationNotificationDeviceSentStream: Array<NotificationNotificationDeviceSent>;
  /** fetch data from the table: "notification.notification_setting_activity_primary_enum" */
  notificationNotificationSettingActivityPrimaryEnum: Array<NotificationNotificationSettingActivityPrimaryEnum>;
  /** fetch aggregated fields from the table: "notification.notification_setting_activity_primary_enum" */
  notificationNotificationSettingActivityPrimaryEnumAggregate: NotificationNotificationSettingActivityPrimaryEnumAggregate;
  /** fetch data from the table: "notification.notification_setting_activity_primary_enum" using primary key columns */
  notificationNotificationSettingActivityPrimaryEnumByPk?: Maybe<NotificationNotificationSettingActivityPrimaryEnum>;
  /** fetch data from the table in a streaming manner: "notification.notification_setting_activity_primary_enum" */
  notificationNotificationSettingActivityPrimaryEnumStream: Array<NotificationNotificationSettingActivityPrimaryEnum>;
  /** fetch data from the table: "notification.notification_send" using primary key columns */
  notificationSend?: Maybe<notificationSend>;
  /** fetch data from the table: "notification.notification_send" */
  notificationSends: Array<notificationSend>;
  /** fetch aggregated fields from the table: "notification.notification_send" */
  notificationSendsAggregate: notificationSendAggregate;
  /** fetch data from the table in a streaming manner: "notification.notification_send" */
  notificationSendsStream: Array<notificationSend>;
  /** fetch data from the table: "notification.notification_setting_activity" */
  notificationSettingActivities: Array<notificationSettingActivity>;
  /** fetch aggregated fields from the table: "notification.notification_setting_activity" */
  notificationSettingActivitiesAggregate: notificationSettingActivityAggregate;
  /** fetch data from the table in a streaming manner: "notification.notification_setting_activity" */
  notificationSettingActivitiesStream: Array<notificationSettingActivity>;
  /** fetch data from the table: "notification.notification_setting_activity" using primary key columns */
  notificationSettingActivity?: Maybe<notificationSettingActivity>;
  /** fetch data from the table: "notification.notification_users" using primary key columns */
  notificationUser?: Maybe<notificationUser>;
  /** fetch data from the table: "notification.notification_user_devices" using primary key columns */
  notificationUserDevice?: Maybe<notificationUserDevice>;
  /** An array relationship */
  notificationUserDevices: Array<notificationUserDevice>;
  /** An aggregate relationship */
  notificationUserDevicesAggregate: notificationUserDeviceAggregate;
  /** fetch data from the table in a streaming manner: "notification.notification_user_devices" */
  notificationUserDevicesStream: Array<notificationUserDevice>;
  /** fetch data from the table: "notification.notification_users" */
  notificationUsers: Array<notificationUser>;
  /** fetch aggregated fields from the table: "notification.notification_users" */
  notificationUsersAggregate: notificationUserAggregate;
  /** fetch data from the table in a streaming manner: "notification.notification_users" */
  notificationUsersStream: Array<notificationUser>;
  /** fetch data from the table: "notification.notifications" */
  notifications: Array<notification>;
  /** fetch aggregated fields from the table: "notification.notifications" */
  notificationsAggregate: notificationAggregate;
  /** fetch data from the table in a streaming manner: "notification.notifications" */
  notificationsStream: Array<notification>;
  /** fetch data from the table: "orders.integrations" using primary key columns */
  ordersIntegration?: Maybe<ordersIntegrations>;
  /** fetch data from the table: "orders.integrations" */
  ordersIntegrations: Array<ordersIntegrations>;
  /** fetch aggregated fields from the table: "orders.integrations" */
  ordersIntegrationsAggregate: ordersIntegrationsAggregate;
  /** fetch data from the table in a streaming manner: "orders.integrations" */
  ordersIntegrationsStream: Array<ordersIntegrations>;
  /** fetch data from the table: "orders.organizations" */
  ordersOrganizations: Array<OrdersOrganizations>;
  /** fetch aggregated fields from the table: "orders.organizations" */
  ordersOrganizationsAggregate: OrdersOrganizationsAggregate;
  /** fetch data from the table: "orders.organizations" using primary key columns */
  ordersOrganizationsByPk?: Maybe<OrdersOrganizations>;
  /** fetch data from the table in a streaming manner: "orders.organizations" */
  ordersOrganizationsStream: Array<OrdersOrganizations>;
  /** fetch data from the table: "orders.request" */
  ordersRequest: Array<OrdersRequest>;
  /** fetch aggregated fields from the table: "orders.request" */
  ordersRequestAggregate: OrdersRequestAggregate;
  /** fetch data from the table: "orders.request" using primary key columns */
  ordersRequestByPk?: Maybe<OrdersRequest>;
  /** fetch data from the table in a streaming manner: "orders.request" */
  ordersRequestStream: Array<OrdersRequest>;
  /** fetch data from the table: "orders.status" */
  ordersStatus: Array<OrdersStatus>;
  /** fetch aggregated fields from the table: "orders.status" */
  ordersStatusAggregate: OrdersStatusAggregate;
  /** fetch data from the table: "orders.status" using primary key columns */
  ordersStatusByPk?: Maybe<OrdersStatus>;
  /** fetch data from the table in a streaming manner: "orders.status" */
  ordersStatusStream: Array<OrdersStatus>;
  /** fetch data from the table: "orders.type" */
  ordersType: Array<OrdersType>;
  /** fetch aggregated fields from the table: "orders.type" */
  ordersTypeAggregate: OrdersTypeAggregate;
  /** fetch data from the table: "orders.type" using primary key columns */
  ordersTypeByPk?: Maybe<OrdersType>;
  /** fetch data from the table in a streaming manner: "orders.type" */
  ordersTypeStream: Array<OrdersType>;
  /** fetch data from the table: "business.organizations" using primary key columns */
  organization?: Maybe<organization>;
  /** fetch data from the table: "business.authorization_enum_group" using primary key columns */
  organizationAuthorizationEnumGroup?: Maybe<organizationAuthorizationEnumGroup>;
  /** fetch data from the table in a streaming manner: "business.authorization_enum_group" */
  organizationAuthorizationEnumGroupStream: Array<organizationAuthorizationEnumGroup>;
  /** fetch data from the table: "business.authorization_enum_group" */
  organizationAuthorizationEnumGroups: Array<organizationAuthorizationEnumGroup>;
  /** fetch data from the table: "business.authorization_group" using primary key columns */
  organizationAuthorizationGroup?: Maybe<organizationAuthorizationGroup>;
  /** fetch data from the table in a streaming manner: "business.authorization_group" */
  organizationAuthorizationGroupStream: Array<organizationAuthorizationGroup>;
  /** fetch data from the table: "business.authorization_group" */
  organizationAuthorizationGroups: Array<organizationAuthorizationGroup>;
  /** fetch data from the table: "business.organization_relationship" using primary key columns */
  organizationOrganizationRelationship?: Maybe<organizationOrganizationRelationship>;
  /** fetch data from the table: "business.organization_relationship_category" */
  organizationOrganizationRelationshipCategories: Array<organizationOrganizationRelationshipCategory>;
  /** fetch data from the table: "business.organization_relationship_category" using primary key columns */
  organizationOrganizationRelationshipCategory?: Maybe<organizationOrganizationRelationshipCategory>;
  /** fetch data from the table in a streaming manner: "business.organization_relationship_category" */
  organizationOrganizationRelationshipCategoryStream: Array<organizationOrganizationRelationshipCategory>;
  /** fetch data from the table in a streaming manner: "business.organization_relationship" */
  organizationOrganizationRelationshipStream: Array<organizationOrganizationRelationship>;
  /** fetch data from the table: "business.organization_relationship" */
  organizationOrganizationRelationships: Array<organizationOrganizationRelationship>;
  /** fetch data from the table: "business.organization_user_authorization" using primary key columns */
  organizationOrganizationUserAuthorization?: Maybe<organizationOrganizationUserAuthorization>;
  /** fetch data from the table in a streaming manner: "business.organization_user_authorization" */
  organizationOrganizationUserAuthorizationStream: Array<organizationOrganizationUserAuthorization>;
  /** fetch data from the table: "business.organization_user_authorization" */
  organizationOrganizationUserAuthorizations: Array<organizationOrganizationUserAuthorization>;
  /** fetch data from the table in a streaming manner: "business.organization_user__organizations_view" */
  organizationOrganizationUserOrganizationsViewStream: Array<organizationOrganizationUserOrganizationsView>;
  /** fetch data from the table: "business.organization_user__organizations_view" */
  organizationOrganizationUserOrganizationsViews: Array<organizationOrganizationUserOrganizationsView>;
  /** fetch data from the table in a streaming manner: "business.organization_user__users_view" */
  organizationOrganizationUserUsersViewStream: Array<organizationOrganizationUserUsersView>;
  /** fetch data from the table: "business.organization_user__users_view" */
  organizationOrganizationUserUsersViews: Array<organizationOrganizationUserUsersView>;
  /** fetch data from the table: "business.organization_user" using primary key columns */
  organizationUser?: Maybe<organizationUser>;
  /** fetch data from the table: "business.organization_user_attachments" using primary key columns */
  organizationUserAttachment?: Maybe<organizationUserAttachments>;
  /** fetch data from the table: "business.organization_user_attachments" */
  organizationUserAttachments: Array<organizationUserAttachments>;
  /** An aggregate relationship */
  organizationUserAttachmentsAggregate: organizationUserAttachmentsAggregate;
  /** fetch data from the table in a streaming manner: "business.organization_user_attachments" */
  organizationUserAttachmentsStream: Array<organizationUserAttachments>;
  /** fetch data from the table: "business.organization_user_attention_note" using primary key columns */
  organizationUserAttentionNote?: Maybe<OrganizationUserAttentionNote>;
  /** fetch aggregated fields from the table: "business.organization_user_attention_note" */
  organizationUserAttentionNoteAggregate: OrganizationUserAttentionNoteAggregate;
  /** fetch data from the table in a streaming manner: "business.organization_user_attention_note" */
  organizationUserAttentionNoteStream: Array<OrganizationUserAttentionNote>;
  /** fetch data from the table: "business.organization_user_attention_note" */
  organizationUserAttentionNotes: Array<OrganizationUserAttentionNote>;
  /** fetch data from the table: "business.user_authorization" using primary key columns */
  organizationUserAuthorization?: Maybe<organizationUserAuthorization>;
  /** fetch data from the table in a streaming manner: "business.user_authorization" */
  organizationUserAuthorizationStream: Array<organizationUserAuthorization>;
  /** fetch data from the table: "business.user_authorization" */
  organizationUserAuthorizations: Array<organizationUserAuthorization>;
  /** fetch data from the table: "business.organization_user_details" using primary key columns */
  organizationUserDetail?: Maybe<organizationUserDetail>;
  /** fetch data from the table: "business.organization_user_details_type" using primary key columns */
  organizationUserDetailType?: Maybe<organizationUserDetailType>;
  /** fetch data from the table: "business.organization_user_details_type" */
  organizationUserDetailTypes: Array<organizationUserDetailType>;
  /** fetch aggregated fields from the table: "business.organization_user_details_type" */
  organizationUserDetailTypesAggregate: organizationUserDetailTypeAggregate;
  /** fetch data from the table in a streaming manner: "business.organization_user_details_type" */
  organizationUserDetailTypesStream: Array<organizationUserDetailType>;
  /** An array relationship */
  organizationUserDetails: Array<organizationUserDetail>;
  /** An aggregate relationship */
  organizationUserDetailsAggregate: organizationUserDetailAggregate;
  /** fetch data from the table in a streaming manner: "business.organization_user_details" */
  organizationUserDetailsStream: Array<organizationUserDetail>;
  /** fetch data from the table: "business.organization_user_invite" using primary key columns */
  organizationUserInvite?: Maybe<organizationUserInvite>;
  /** fetch data from the table in a streaming manner: "business.organization_user_invite" */
  organizationUserInviteStream: Array<organizationUserInvite>;
  /** An array relationship */
  organizationUserInvites: Array<organizationUserInvite>;
  /** An aggregate relationship */
  organizationUserInvitesAggregate: organizationUserInviteAggregate;
  /** fetch data from the table: "business.organization_user_request" using primary key columns */
  organizationUserRequest?: Maybe<BusinessOrganizationUserRequest>;
  /** An array relationship */
  organizationUserRequests: Array<BusinessOrganizationUserRequest>;
  /** fetch data from the table: "business.organization_user_status" using primary key columns */
  organizationUserStatus?: Maybe<organizationUserStatus>;
  /** fetch data from the table: "business.organization_user_status" */
  organizationUserStatuses: Array<organizationUserStatus>;
  /** fetch aggregated fields from the table: "business.organization_user_status" */
  organizationUserStatusesAggregate: organizationUserStatusAggregate;
  /** fetch data from the table in a streaming manner: "business.organization_user_status" */
  organizationUserStatusesStream: Array<organizationUserStatus>;
  /** An array relationship */
  organizationUsers: Array<organizationUser>;
  /** An aggregate relationship */
  organizationUsersAggregate: organizationUserAggregate;
  /** fetch data from the table in a streaming manner: "business.organization_user" */
  organizationUsersStream: Array<organizationUser>;
  /** fetch data from the table: "business.organizations" */
  organizations: Array<organization>;
  /** fetch aggregated fields from the table: "business.organizations" */
  organizationsAggregate: organizationAggregate;
  /** fetch data from the table in a streaming manner: "business.organizations" */
  organizationsStream: Array<organization>;
  /** fetch data from the table: "business.phone_number_verification_status" using primary key columns */
  phoneNumberVerificationStatus?: Maybe<phoneNumberVerificationStatus>;
  /** fetch data from the table in a streaming manner: "business.phone_number_verification_status" */
  phoneNumberVerificationStatusStream: Array<phoneNumberVerificationStatus>;
  /** fetch data from the table: "business.phone_number_verification_status" */
  phoneNumberVerificationStatuses: Array<phoneNumberVerificationStatus>;
  /** fetch aggregated fields from the table: "business.phone_number_verification_status" */
  phoneNumberVerificationStatusesAggregate: phoneNumberVerificationStatusAggregate;
  /** fetch data from the table: "prompt" */
  prompt: Array<Prompt>;
  /** fetch aggregated fields from the table: "prompt" */
  promptAggregate: PromptAggregate;
  /** fetch data from the table: "prompt" using primary key columns */
  promptByPk?: Maybe<Prompt>;
  /** fetch data from the table in a streaming manner: "prompt" */
  promptStream: Array<Prompt>;
  /** fetch data from the table: "devices" using primary key columns */
  publicDevice?: Maybe<publicDevice>;
  /** fetch data from the table in a streaming manner: "devices" */
  publicDeviceStream: Array<publicDevice>;
  /** fetch data from the table: "devices" */
  publicDevices: Array<publicDevice>;
  /** fetch data from the table: "external_requests" using primary key columns */
  publicExternalRequest?: Maybe<publicExternalRequest>;
  /** fetch data from the table in a streaming manner: "external_requests" */
  publicExternalRequestStream: Array<publicExternalRequest>;
  /** fetch data from the table: "external_requests" */
  publicExternalRequests: Array<publicExternalRequest>;
  /** fetch data from the table: "files" using primary key columns */
  publicFile?: Maybe<publicFile>;
  /** fetch data from the table in a streaming manner: "files" */
  publicFileStream: Array<publicFile>;
  /** fetch data from the table: "files" */
  publicFiles: Array<publicFile>;
  /** fetch data from the table: "notifications" using primary key columns */
  publicNotification?: Maybe<publicNotification>;
  /** fetch data from the table in a streaming manner: "notifications" */
  publicNotificationStream: Array<publicNotification>;
  /** fetch data from the table: "notifications" */
  publicNotifications: Array<publicNotification>;
  /** fetch data from the table: "business.queue_item" using primary key columns */
  queueItem?: Maybe<queueItem>;
  /** fetch data from the table: "business.queue_item" */
  queueItems: Array<queueItem>;
  /** fetch aggregated fields from the table: "business.queue_item" */
  queueItemsAggregate: queueItemAggregate;
  /** fetch data from the table in a streaming manner: "business.queue_item" */
  queueItemsStream: Array<queueItem>;
  /** fetch data from the table: "business.rel_organization_user_domain_user" using primary key columns */
  relOrganizationUserDomainUser?: Maybe<relOrganizationUserDomainUser>;
  /** fetch data from the table: "business.rel_organization_user_domain_user" */
  relOrganizationUserDomainUsers: Array<relOrganizationUserDomainUser>;
  /** fetch aggregated fields from the table: "business.rel_organization_user_domain_user" */
  relOrganizationUserDomainUsersAggregate: relOrganizationUserDomainUserAggregate;
  /** fetch data from the table in a streaming manner: "business.rel_organization_user_domain_user" */
  relOrganizationUserDomainUsersStream: Array<relOrganizationUserDomainUser>;
  /** fetch data from the table: "sms.connectors" using primary key columns */
  smsConnector?: Maybe<smsConnector>;
  /** fetch data from the table in a streaming manner: "sms.connectors" */
  smsConnectorStream: Array<smsConnector>;
  /** fetch data from the table: "sms.connectors" */
  smsConnectors: Array<smsConnector>;
  /** fetch data from the table: "sms.gates" using primary key columns */
  smsGate?: Maybe<smsGate>;
  /** fetch data from the table in a streaming manner: "sms.gates" */
  smsGateStream: Array<smsGate>;
  /** fetch data from the table: "sms.gates" */
  smsGates: Array<smsGate>;
  /** fetch data from the table: "sms.link_mobility_sms_content" using primary key columns */
  smsLinkMobilitySmsContent?: Maybe<smsLinkMobilitySmsContent>;
  /** fetch data from the table in a streaming manner: "sms.link_mobility_sms_content" */
  smsLinkMobilitySmsContentStream: Array<smsLinkMobilitySmsContent>;
  /** fetch data from the table: "sms.link_mobility_sms_content" */
  smsLinkMobilitySmsContents: Array<smsLinkMobilitySmsContent>;
  /** fetch data from the table: "sms.link_mobility_sms_message" using primary key columns */
  smsLinkMobilitySmsMessage?: Maybe<smsLinkMobilitySmsMessage>;
  /** fetch data from the table in a streaming manner: "sms.link_mobility_sms_message" */
  smsLinkMobilitySmsMessageStream: Array<smsLinkMobilitySmsMessage>;
  /** fetch data from the table: "sms.link_mobility_sms_message" */
  smsLinkMobilitySmsMessages: Array<smsLinkMobilitySmsMessage>;
  /** fetch data from the table: "sms.link_mobility_sms_route" using primary key columns */
  smsLinkMobilitySmsRoute?: Maybe<smsLinkMobilitySmsRoute>;
  /** fetch data from the table in a streaming manner: "sms.link_mobility_sms_route" */
  smsLinkMobilitySmsRouteStream: Array<smsLinkMobilitySmsRoute>;
  /** fetch data from the table: "sms.link_mobility_sms_route" */
  smsLinkMobilitySmsRoutes: Array<smsLinkMobilitySmsRoute>;
  /** fetch data from the table: "sms.providers" using primary key columns */
  smsProvider?: Maybe<smsProvider>;
  /** fetch data from the table in a streaming manner: "sms.providers" */
  smsProviderStream: Array<smsProvider>;
  /** fetch data from the table: "sms.providers" */
  smsProviders: Array<smsProvider>;
  /** fetch data from the table: "sms.sms" using primary key columns */
  smsSm?: Maybe<smsSm>;
  /** fetch data from the table in a streaming manner: "sms.sms" */
  smsSmStream: Array<smsSm>;
  /** fetch data from the table: "sms.sms" */
  smsSms: Array<smsSm>;
  /** fetch data from the table: "sms.sms_external_incoming_link_mobility" */
  smsSmsExternalIncomingLinkMobilities: Array<smsSmsExternalIncomingLinkMobility>;
  /** fetch data from the table: "sms.sms_external_incoming_link_mobility" using primary key columns */
  smsSmsExternalIncomingLinkMobility?: Maybe<smsSmsExternalIncomingLinkMobility>;
  /** fetch data from the table in a streaming manner: "sms.sms_external_incoming_link_mobility" */
  smsSmsExternalIncomingLinkMobilityStream: Array<smsSmsExternalIncomingLinkMobility>;
  /** fetch data from the table in a streaming manner: "business.user_contacts" */
  streamBusinessUserContacts: Array<businessUserContacts>;
  /** fetch data from the table in a streaming manner: "business.user_settings" */
  streamBusinessUserSettings: Array<businessUserSettings>;
  task?: Maybe<tasksubscription_root>;
  telephony?: Maybe<telephonysubscription_root>;
  /** fetch data from the table: "business.users" using primary key columns */
  user?: Maybe<user>;
  /** fetch data from the table: "business.user_details" using primary key columns */
  userDetail?: Maybe<userDetail>;
  /** fetch data from the table in a streaming manner: "business.user_details" */
  userDetailStream: Array<userDetail>;
  /** fetch data from the table: "business.user_details" */
  userDetails: Array<userDetail>;
  /** fetch aggregated fields from the table: "business.user_details" */
  userDetailsAggregate: userDetailAggregate;
  /** fetch data from the table: "business.user_details_type" using primary key columns */
  userDetailsType?: Maybe<userDetailsType>;
  /** fetch data from the table: "business.user_details_type" */
  userDetailsTypes: Array<userDetailsType>;
  /** fetch aggregated fields from the table: "business.user_details_type" */
  userDetailsTypesAggregate: userDetailsTypeAggregate;
  /** fetch data from the table in a streaming manner: "business.user_details_type" */
  userDetailsTypesStream: Array<userDetailsType>;
  /** fetch data from the table: "business.user_devices" using primary key columns */
  userDevice?: Maybe<userDevice>;
  /** fetch data from the table: "business.user_devices" */
  userDevices: Array<userDevice>;
  /** fetch aggregated fields from the table: "business.user_devices" */
  userDevicesAggregate: userDeviceAggregate;
  /** fetch data from the table in a streaming manner: "business.user_devices" */
  userDevicesStream: Array<userDevice>;
  /** fetch data from the table: "business.user_phone_numbers" using primary key columns */
  userPhoneNumber?: Maybe<userPhoneNumber>;
  /** fetch data from the table: "business.user_phone_numbers" */
  userPhoneNumbers: Array<userPhoneNumber>;
  /** fetch aggregated fields from the table: "business.user_phone_numbers" */
  userPhoneNumbersAggregate: userPhoneNumberAggregate;
  /** fetch data from the table in a streaming manner: "business.user_phone_numbers" */
  userPhoneNumbersStream: Array<userPhoneNumber>;
  /** fetch data from the table: "business.user_role" using primary key columns */
  userRole?: Maybe<userRole>;
  /** fetch data from the table: "business.user_role" */
  userRoles: Array<userRole>;
  /** fetch aggregated fields from the table: "business.user_role" */
  userRolesAggregate: userRoleAggregate;
  /** fetch data from the table in a streaming manner: "business.user_role" */
  userRolesStream: Array<userRole>;
  /** An array relationship */
  users: Array<user>;
  /** An aggregate relationship */
  usersAggregate: userAggregate;
  /** fetch data from the table in a streaming manner: "business.users" */
  usersStream: Array<user>;
  /** fetch data from the table: "validation.validation" using primary key columns */
  validationValidation?: Maybe<validationValidation>;
  /** fetch data from the table in a streaming manner: "validation.validation" */
  validationValidationStream: Array<validationValidation>;
  /** fetch data from the table: "validation.validation" */
  validationValidations: Array<validationValidation>;
  /** fetch data from the table: "voice_types" */
  voiceTypes: Array<VoiceTypes>;
  /** fetch aggregated fields from the table: "voice_types" */
  voiceTypesAggregate: VoiceTypesAggregate;
  /** fetch data from the table: "voice_types" using primary key columns */
  voiceTypesByPk?: Maybe<VoiceTypes>;
  /** fetch data from the table in a streaming manner: "voice_types" */
  voiceTypesStream: Array<VoiceTypes>;
};


export type subscription_rootActivityDirectionArgs = {
  distinctOn?: InputMaybe<Array<ActivityDirectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityDirectionOrderBy>>;
  where?: InputMaybe<ActivityDirectionBoolExp>;
};


export type subscription_rootActivityDirectionAggregateArgs = {
  distinctOn?: InputMaybe<Array<ActivityDirectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityDirectionOrderBy>>;
  where?: InputMaybe<ActivityDirectionBoolExp>;
};


export type subscription_rootActivityDirectionByPkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootActivityDirectionStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ActivityDirectionStreamCursorInput>>;
  where?: InputMaybe<ActivityDirectionBoolExp>;
};


export type subscription_rootActivityProviderArgs = {
  distinctOn?: InputMaybe<Array<ActivityProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityProviderOrderBy>>;
  where?: InputMaybe<ActivityProviderBoolExp>;
};


export type subscription_rootActivityProviderAggregateArgs = {
  distinctOn?: InputMaybe<Array<ActivityProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityProviderOrderBy>>;
  where?: InputMaybe<ActivityProviderBoolExp>;
};


export type subscription_rootActivityProviderByPkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootActivityProviderStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ActivityProviderStreamCursorInput>>;
  where?: InputMaybe<ActivityProviderBoolExp>;
};


export type subscription_rootQueueItemFlexibilityTypeArgs = {
  distinctOn?: InputMaybe<Array<QueueItemFlexibilityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QueueItemFlexibilityTypeOrderBy>>;
  where?: InputMaybe<QueueItemFlexibilityTypeBoolExp>;
};


export type subscription_rootQueueItemFlexibilityTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<QueueItemFlexibilityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QueueItemFlexibilityTypeOrderBy>>;
  where?: InputMaybe<QueueItemFlexibilityTypeBoolExp>;
};


export type subscription_rootQueueItemFlexibilityTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootQueueItemFlexibilityTypeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<QueueItemFlexibilityTypeStreamCursorInput>>;
  where?: InputMaybe<QueueItemFlexibilityTypeBoolExp>;
};


export type subscription_rootQueueItemParticipantResponsibilityTypeArgs = {
  distinctOn?: InputMaybe<Array<QueueItemParticipantResponsibilityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QueueItemParticipantResponsibilityTypeOrderBy>>;
  where?: InputMaybe<QueueItemParticipantResponsibilityTypeBoolExp>;
};


export type subscription_rootQueueItemParticipantResponsibilityTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<QueueItemParticipantResponsibilityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QueueItemParticipantResponsibilityTypeOrderBy>>;
  where?: InputMaybe<QueueItemParticipantResponsibilityTypeBoolExp>;
};


export type subscription_rootQueueItemParticipantResponsibilityTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootQueueItemParticipantResponsibilityTypeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<QueueItemParticipantResponsibilityTypeStreamCursorInput>>;
  where?: InputMaybe<QueueItemParticipantResponsibilityTypeBoolExp>;
};


export type subscription_rootRelationTypeArgs = {
  distinctOn?: InputMaybe<Array<RelationTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RelationTypeOrderBy>>;
  where?: InputMaybe<RelationTypeBoolExp>;
};


export type subscription_rootRelationTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<RelationTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RelationTypeOrderBy>>;
  where?: InputMaybe<RelationTypeBoolExp>;
};


export type subscription_rootRelationTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootRelationTypeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RelationTypeStreamCursorInput>>;
  where?: InputMaybe<RelationTypeBoolExp>;
};


export type subscription_rootactivityParticipantArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootactivityParticipantsArgs = {
  distinctOn?: InputMaybe<Array<activityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<activityParticipantOrderBy>>;
  where?: InputMaybe<activityParticipantBoolExp>;
};


export type subscription_rootactivityParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<activityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<activityParticipantOrderBy>>;
  where?: InputMaybe<activityParticipantBoolExp>;
};


export type subscription_rootactivityParticipantsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<activityParticipantStreamCursorInput>>;
  where?: InputMaybe<activityParticipantBoolExp>;
};


export type subscription_rootactivityStatusArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootactivityStatusesArgs = {
  distinctOn?: InputMaybe<Array<ActivityStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityStatusOrderBy>>;
  where?: InputMaybe<ActivityStatusBoolExp>;
};


export type subscription_rootactivityStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ActivityStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityStatusOrderBy>>;
  where?: InputMaybe<ActivityStatusBoolExp>;
};


export type subscription_rootactivityStatusesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ActivityStatusStreamCursorInput>>;
  where?: InputMaybe<ActivityStatusBoolExp>;
};


export type subscription_rootactivityTypeArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootactivityTypesArgs = {
  distinctOn?: InputMaybe<Array<ActivityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityTypeOrderBy>>;
  where?: InputMaybe<ActivityTypeBoolExp>;
};


export type subscription_rootactivityTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ActivityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivityTypeOrderBy>>;
  where?: InputMaybe<ActivityTypeBoolExp>;
};


export type subscription_rootactivityTypesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ActivityTypeStreamCursorInput>>;
  where?: InputMaybe<ActivityTypeBoolExp>;
};


export type subscription_rootaddressArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootaddressesArgs = {
  distinctOn?: InputMaybe<Array<addressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<addressOrderBy>>;
  where?: InputMaybe<addressBoolExp>;
};


export type subscription_rootaddressesAggregateArgs = {
  distinctOn?: InputMaybe<Array<addressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<addressOrderBy>>;
  where?: InputMaybe<addressBoolExp>;
};


export type subscription_rootaddressesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<addressStreamCursorInput>>;
  where?: InputMaybe<addressBoolExp>;
};


export type subscription_rootaggregateBusinessUserContactsArgs = {
  distinctOn?: InputMaybe<Array<businessUserContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<businessUserContactsOrderBy>>;
  where?: InputMaybe<businessUserContactsBoolExp>;
};


export type subscription_rootaggregateBusinessUserSettingsArgs = {
  distinctOn?: InputMaybe<Array<businessUserSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<businessUserSettingsOrderBy>>;
  where?: InputMaybe<businessUserSettingsBoolExp>;
};


export type subscription_rootaggregateMessagingActivitiesArgs = {
  distinctOn?: InputMaybe<Array<messagingActivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingActivityOrderBy>>;
  where?: InputMaybe<messagingActivityBoolExp>;
};


export type subscription_rootaggregateMessagingActivityTypesArgs = {
  distinctOn?: InputMaybe<Array<messagingActivityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingActivityTypeOrderBy>>;
  where?: InputMaybe<messagingActivityTypeBoolExp>;
};


export type subscription_rootaggregateMessagingActivityUsersArgs = {
  distinctOn?: InputMaybe<Array<messagingActivityUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingActivityUserOrderBy>>;
  where?: InputMaybe<messagingActivityUserBoolExp>;
};


export type subscription_rootaggregateMessagingMessageEmojisArgs = {
  distinctOn?: InputMaybe<Array<messagingMessageEmojiSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingMessageEmojiOrderBy>>;
  where?: InputMaybe<messagingMessageEmojiBoolExp>;
};


export type subscription_rootaggregateMessagingMessageReadsArgs = {
  distinctOn?: InputMaybe<Array<messagingMessageReadSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingMessageReadOrderBy>>;
  where?: InputMaybe<messagingMessageReadBoolExp>;
};


export type subscription_rootaggregateMessagingMessageTypesArgs = {
  distinctOn?: InputMaybe<Array<messagingMessageTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingMessageTypeOrderBy>>;
  where?: InputMaybe<messagingMessageTypeBoolExp>;
};


export type subscription_rootaggregateMessagingMessagesArgs = {
  distinctOn?: InputMaybe<Array<messagingMessageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingMessageOrderBy>>;
  where?: InputMaybe<messagingMessageBoolExp>;
};


export type subscription_rootaggregateOrganizationAuthorizationEnumGroupsArgs = {
  distinctOn?: InputMaybe<Array<organizationAuthorizationEnumGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationAuthorizationEnumGroupOrderBy>>;
  where?: InputMaybe<organizationAuthorizationEnumGroupBoolExp>;
};


export type subscription_rootaggregateOrganizationAuthorizationGroupsArgs = {
  distinctOn?: InputMaybe<Array<organizationAuthorizationGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationAuthorizationGroupOrderBy>>;
  where?: InputMaybe<organizationAuthorizationGroupBoolExp>;
};


export type subscription_rootaggregateOrganizationOrganizationRelationshipCategoriesArgs = {
  distinctOn?: InputMaybe<Array<organizationOrganizationRelationshipCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrganizationRelationshipCategoryOrderBy>>;
  where?: InputMaybe<organizationOrganizationRelationshipCategoryBoolExp>;
};


export type subscription_rootaggregateOrganizationOrganizationRelationshipsArgs = {
  distinctOn?: InputMaybe<Array<organizationOrganizationRelationshipSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrganizationRelationshipOrderBy>>;
  where?: InputMaybe<organizationOrganizationRelationshipBoolExp>;
};


export type subscription_rootaggregateOrganizationOrganizationUserAuthorizationsArgs = {
  distinctOn?: InputMaybe<Array<organizationOrganizationUserAuthorizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrganizationUserAuthorizationOrderBy>>;
  where?: InputMaybe<organizationOrganizationUserAuthorizationBoolExp>;
};


export type subscription_rootaggregateOrganizationOrganizationUserOrganizationsViewsArgs = {
  distinctOn?: InputMaybe<Array<organizationOrganizationUserOrganizationsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrganizationUserOrganizationsViewOrderBy>>;
  where?: InputMaybe<organizationOrganizationUserOrganizationsViewBoolExp>;
};


export type subscription_rootaggregateOrganizationOrganizationUserUsersViewsArgs = {
  distinctOn?: InputMaybe<Array<organizationOrganizationUserUsersViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrganizationUserUsersViewOrderBy>>;
  where?: InputMaybe<organizationOrganizationUserUsersViewBoolExp>;
};


export type subscription_rootaggregateOrganizationUserAuthorizationsArgs = {
  distinctOn?: InputMaybe<Array<organizationUserAuthorizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserAuthorizationOrderBy>>;
  where?: InputMaybe<organizationUserAuthorizationBoolExp>;
};


export type subscription_rootaggregatePublicDevicesArgs = {
  distinctOn?: InputMaybe<Array<publicDeviceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<publicDeviceOrderBy>>;
  where?: InputMaybe<publicDeviceBoolExp>;
};


export type subscription_rootaggregatePublicExternalRequestsArgs = {
  distinctOn?: InputMaybe<Array<publicExternalRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<publicExternalRequestOrderBy>>;
  where?: InputMaybe<publicExternalRequestBoolExp>;
};


export type subscription_rootaggregatePublicFilesArgs = {
  distinctOn?: InputMaybe<Array<publicFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<publicFileOrderBy>>;
  where?: InputMaybe<publicFileBoolExp>;
};


export type subscription_rootaggregatePublicNotificationsArgs = {
  distinctOn?: InputMaybe<Array<publicNotificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<publicNotificationOrderBy>>;
  where?: InputMaybe<publicNotificationBoolExp>;
};


export type subscription_rootaggregateSmsConnectorsArgs = {
  distinctOn?: InputMaybe<Array<smsConnectorSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsConnectorOrderBy>>;
  where?: InputMaybe<smsConnectorBoolExp>;
};


export type subscription_rootaggregateSmsGatesArgs = {
  distinctOn?: InputMaybe<Array<smsGateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsGateOrderBy>>;
  where?: InputMaybe<smsGateBoolExp>;
};


export type subscription_rootaggregateSmsLinkMobilitySmsContentsArgs = {
  distinctOn?: InputMaybe<Array<smsLinkMobilitySmsContentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsLinkMobilitySmsContentOrderBy>>;
  where?: InputMaybe<smsLinkMobilitySmsContentBoolExp>;
};


export type subscription_rootaggregateSmsLinkMobilitySmsMessagesArgs = {
  distinctOn?: InputMaybe<Array<smsLinkMobilitySmsMessageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsLinkMobilitySmsMessageOrderBy>>;
  where?: InputMaybe<smsLinkMobilitySmsMessageBoolExp>;
};


export type subscription_rootaggregateSmsLinkMobilitySmsRoutesArgs = {
  distinctOn?: InputMaybe<Array<smsLinkMobilitySmsRouteSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsLinkMobilitySmsRouteOrderBy>>;
  where?: InputMaybe<smsLinkMobilitySmsRouteBoolExp>;
};


export type subscription_rootaggregateSmsProvidersArgs = {
  distinctOn?: InputMaybe<Array<smsProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsProviderOrderBy>>;
  where?: InputMaybe<smsProviderBoolExp>;
};


export type subscription_rootaggregateSmsSmsArgs = {
  distinctOn?: InputMaybe<Array<smsSmSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsSmOrderBy>>;
  where?: InputMaybe<smsSmBoolExp>;
};


export type subscription_rootaggregateSmsSmsExternalIncomingLinkMobilitiesArgs = {
  distinctOn?: InputMaybe<Array<smsSmsExternalIncomingLinkMobilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsSmsExternalIncomingLinkMobilityOrderBy>>;
  where?: InputMaybe<smsSmsExternalIncomingLinkMobilityBoolExp>;
};


export type subscription_rootaggregateValidationValidationsArgs = {
  distinctOn?: InputMaybe<Array<validationValidationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<validationValidationOrderBy>>;
  where?: InputMaybe<validationValidationBoolExp>;
};


export type subscription_rootblockedDomainUserArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootblockedDomainUsersArgs = {
  distinctOn?: InputMaybe<Array<blockedDomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<blockedDomainUserOrderBy>>;
  where?: InputMaybe<blockedDomainUserBoolExp>;
};


export type subscription_rootblockedDomainUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<blockedDomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<blockedDomainUserOrderBy>>;
  where?: InputMaybe<blockedDomainUserBoolExp>;
};


export type subscription_rootblockedDomainUsersStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<blockedDomainUserStreamCursorInput>>;
  where?: InputMaybe<blockedDomainUserBoolExp>;
};


export type subscription_rootbusinessDomainActivityTypeArgs = {
  distinctOn?: InputMaybe<Array<BusinessDomainActivityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessDomainActivityTypeOrderBy>>;
  where?: InputMaybe<BusinessDomainActivityTypeBoolExp>;
};


export type subscription_rootbusinessDomainActivityTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessDomainActivityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessDomainActivityTypeOrderBy>>;
  where?: InputMaybe<BusinessDomainActivityTypeBoolExp>;
};


export type subscription_rootbusinessDomainActivityTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootbusinessDomainActivityTypeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BusinessDomainActivityTypeStreamCursorInput>>;
  where?: InputMaybe<BusinessDomainActivityTypeBoolExp>;
};


export type subscription_rootbusinessFeedTypeArgs = {
  distinctOn?: InputMaybe<Array<BusinessFeedTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessFeedTypeOrderBy>>;
  where?: InputMaybe<BusinessFeedTypeBoolExp>;
};


export type subscription_rootbusinessFeedTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessFeedTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessFeedTypeOrderBy>>;
  where?: InputMaybe<BusinessFeedTypeBoolExp>;
};


export type subscription_rootbusinessFeedTypeByPkArgs = {
  type: Scalars['String']['input'];
};


export type subscription_rootbusinessFeedTypeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BusinessFeedTypeStreamCursorInput>>;
  where?: InputMaybe<BusinessFeedTypeBoolExp>;
};


export type subscription_rootbusinessMessageAttachmentsArgs = {
  distinctOn?: InputMaybe<Array<BusinessMessageAttachmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessMessageAttachmentsOrderBy>>;
  where?: InputMaybe<BusinessMessageAttachmentsBoolExp>;
};


export type subscription_rootbusinessMessageAttachmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessMessageAttachmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessMessageAttachmentsOrderBy>>;
  where?: InputMaybe<BusinessMessageAttachmentsBoolExp>;
};


export type subscription_rootbusinessMessageAttachmentsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootbusinessMessageAttachmentsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BusinessMessageAttachmentsStreamCursorInput>>;
  where?: InputMaybe<BusinessMessageAttachmentsBoolExp>;
};


export type subscription_rootbusinessOrganizationUserCallbackAnswerArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserCallbackAnswerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserCallbackAnswerOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserCallbackAnswerBoolExp>;
};


export type subscription_rootbusinessOrganizationUserCallbackAnswerAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserCallbackAnswerSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserCallbackAnswerOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserCallbackAnswerBoolExp>;
};


export type subscription_rootbusinessOrganizationUserCallbackAnswerByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootbusinessOrganizationUserCallbackAnswerStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BusinessOrganizationUserCallbackAnswerStreamCursorInput>>;
  where?: InputMaybe<BusinessOrganizationUserCallbackAnswerBoolExp>;
};


export type subscription_rootbusinessOrganizationUserEmailArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserEmailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserEmailOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserEmailBoolExp>;
};


export type subscription_rootbusinessOrganizationUserEmailAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserEmailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserEmailOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserEmailBoolExp>;
};


export type subscription_rootbusinessOrganizationUserEmailByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootbusinessOrganizationUserEmailStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BusinessOrganizationUserEmailStreamCursorInput>>;
  where?: InputMaybe<BusinessOrganizationUserEmailBoolExp>;
};


export type subscription_rootbusinessOrganizationUserEmailTypeArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserEmailTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserEmailTypeOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserEmailTypeBoolExp>;
};


export type subscription_rootbusinessOrganizationUserEmailTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserEmailTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserEmailTypeOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserEmailTypeBoolExp>;
};


export type subscription_rootbusinessOrganizationUserEmailTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootbusinessOrganizationUserEmailTypeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BusinessOrganizationUserEmailTypeStreamCursorInput>>;
  where?: InputMaybe<BusinessOrganizationUserEmailTypeBoolExp>;
};


export type subscription_rootbusinessOrganizationUserRequestAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserRequestOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserRequestBoolExp>;
};


export type subscription_rootbusinessOrganizationUserRequestStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BusinessOrganizationUserRequestStreamCursorInput>>;
  where?: InputMaybe<BusinessOrganizationUserRequestBoolExp>;
};


export type subscription_rootbusinessOrganizationUserRequestTypeArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserRequestTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserRequestTypeOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserRequestTypeBoolExp>;
};


export type subscription_rootbusinessOrganizationUserRequestTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserRequestTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserRequestTypeOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserRequestTypeBoolExp>;
};


export type subscription_rootbusinessOrganizationUserRequestTypeByPkArgs = {
  name: Scalars['String']['input'];
};


export type subscription_rootbusinessOrganizationUserRequestTypeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BusinessOrganizationUserRequestTypeStreamCursorInput>>;
  where?: InputMaybe<BusinessOrganizationUserRequestTypeBoolExp>;
};


export type subscription_rootbusinessOrganizationUserSuggestionTypeArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserSuggestionTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserSuggestionTypeOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserSuggestionTypeBoolExp>;
};


export type subscription_rootbusinessOrganizationUserSuggestionTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserSuggestionTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserSuggestionTypeOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserSuggestionTypeBoolExp>;
};


export type subscription_rootbusinessOrganizationUserSuggestionTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootbusinessOrganizationUserSuggestionTypeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BusinessOrganizationUserSuggestionTypeStreamCursorInput>>;
  where?: InputMaybe<BusinessOrganizationUserSuggestionTypeBoolExp>;
};


export type subscription_rootbusinessOrganizationUserSuggestionsArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserSuggestionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserSuggestionsOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserSuggestionsBoolExp>;
};


export type subscription_rootbusinessOrganizationUserSuggestionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserSuggestionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserSuggestionsOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserSuggestionsBoolExp>;
};


export type subscription_rootbusinessOrganizationUserSuggestionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootbusinessOrganizationUserSuggestionsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BusinessOrganizationUserSuggestionsStreamCursorInput>>;
  where?: InputMaybe<BusinessOrganizationUserSuggestionsBoolExp>;
};


export type subscription_rootbusinessOrganizationUserUrlAddressArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserUrlAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserUrlAddressOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserUrlAddressBoolExp>;
};


export type subscription_rootbusinessOrganizationUserUrlAddressAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserUrlAddressSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserUrlAddressOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserUrlAddressBoolExp>;
};


export type subscription_rootbusinessOrganizationUserUrlAddressByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootbusinessOrganizationUserUrlAddressStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BusinessOrganizationUserUrlAddressStreamCursorInput>>;
  where?: InputMaybe<BusinessOrganizationUserUrlAddressBoolExp>;
};


export type subscription_rootbusinessOrganizationUserUrlAddressTypeArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserUrlAddressTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserUrlAddressTypeOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserUrlAddressTypeBoolExp>;
};


export type subscription_rootbusinessOrganizationUserUrlAddressTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserUrlAddressTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserUrlAddressTypeOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserUrlAddressTypeBoolExp>;
};


export type subscription_rootbusinessOrganizationUserUrlAddressTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootbusinessOrganizationUserUrlAddressTypeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BusinessOrganizationUserUrlAddressTypeStreamCursorInput>>;
  where?: InputMaybe<BusinessOrganizationUserUrlAddressTypeBoolExp>;
};


export type subscription_rootbusinessQueueItemAlarmTypeArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemAlarmTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemAlarmTypeOrderBy>>;
  where?: InputMaybe<BusinessQueueItemAlarmTypeBoolExp>;
};


export type subscription_rootbusinessQueueItemAlarmTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemAlarmTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemAlarmTypeOrderBy>>;
  where?: InputMaybe<BusinessQueueItemAlarmTypeBoolExp>;
};


export type subscription_rootbusinessQueueItemAlarmTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootbusinessQueueItemAlarmTypeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BusinessQueueItemAlarmTypeStreamCursorInput>>;
  where?: InputMaybe<BusinessQueueItemAlarmTypeBoolExp>;
};


export type subscription_rootbusinessQueueItemAlarmsArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemAlarmsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemAlarmsOrderBy>>;
  where?: InputMaybe<BusinessQueueItemAlarmsBoolExp>;
};


export type subscription_rootbusinessQueueItemAlarmsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemAlarmsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemAlarmsOrderBy>>;
  where?: InputMaybe<BusinessQueueItemAlarmsBoolExp>;
};


export type subscription_rootbusinessQueueItemAlarmsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootbusinessQueueItemAlarmsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BusinessQueueItemAlarmsStreamCursorInput>>;
  where?: InputMaybe<BusinessQueueItemAlarmsBoolExp>;
};


export type subscription_rootbusinessQueueItemCollaborationArgs = {
  id: Scalars['Int']['input'];
};


export type subscription_rootbusinessQueueItemCollaborationAggregateArgs = {
  distinctOn?: InputMaybe<Array<businessQueueItemCollaborationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<businessQueueItemCollaborationOrderBy>>;
  where?: InputMaybe<businessQueueItemCollaborationBoolExp>;
};


export type subscription_rootbusinessQueueItemCollaborationStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<businessQueueItemCollaborationStreamCursorInput>>;
  where?: InputMaybe<businessQueueItemCollaborationBoolExp>;
};


export type subscription_rootbusinessQueueItemCollaborationsArgs = {
  distinctOn?: InputMaybe<Array<businessQueueItemCollaborationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<businessQueueItemCollaborationOrderBy>>;
  where?: InputMaybe<businessQueueItemCollaborationBoolExp>;
};


export type subscription_rootbusinessQueueItemDomainUsersViewArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemDomainUsersViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemDomainUsersViewOrderBy>>;
  where?: InputMaybe<BusinessQueueItemDomainUsersViewBoolExp>;
};


export type subscription_rootbusinessQueueItemDomainUsersViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemDomainUsersViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemDomainUsersViewOrderBy>>;
  where?: InputMaybe<BusinessQueueItemDomainUsersViewBoolExp>;
};


export type subscription_rootbusinessQueueItemDomainUsersViewStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BusinessQueueItemDomainUsersViewStreamCursorInput>>;
  where?: InputMaybe<BusinessQueueItemDomainUsersViewBoolExp>;
};


export type subscription_rootbusinessQueueItemOrganizationUsersViewArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemOrganizationUsersViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemOrganizationUsersViewOrderBy>>;
  where?: InputMaybe<BusinessQueueItemOrganizationUsersViewBoolExp>;
};


export type subscription_rootbusinessQueueItemOrganizationUsersViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemOrganizationUsersViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemOrganizationUsersViewOrderBy>>;
  where?: InputMaybe<BusinessQueueItemOrganizationUsersViewBoolExp>;
};


export type subscription_rootbusinessQueueItemOrganizationUsersViewStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BusinessQueueItemOrganizationUsersViewStreamCursorInput>>;
  where?: InputMaybe<BusinessQueueItemOrganizationUsersViewBoolExp>;
};


export type subscription_rootbusinessQueueItemParticipantChannelTypeArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemParticipantChannelTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemParticipantChannelTypeOrderBy>>;
  where?: InputMaybe<BusinessQueueItemParticipantChannelTypeBoolExp>;
};


export type subscription_rootbusinessQueueItemParticipantChannelTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemParticipantChannelTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemParticipantChannelTypeOrderBy>>;
  where?: InputMaybe<BusinessQueueItemParticipantChannelTypeBoolExp>;
};


export type subscription_rootbusinessQueueItemParticipantChannelTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootbusinessQueueItemParticipantChannelTypeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BusinessQueueItemParticipantChannelTypeStreamCursorInput>>;
  where?: InputMaybe<BusinessQueueItemParticipantChannelTypeBoolExp>;
};


export type subscription_rootbusinessQueueItemParticipantsViewArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemParticipantsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemParticipantsViewOrderBy>>;
  where?: InputMaybe<BusinessQueueItemParticipantsViewBoolExp>;
};


export type subscription_rootbusinessQueueItemParticipantsViewAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemParticipantsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemParticipantsViewOrderBy>>;
  where?: InputMaybe<BusinessQueueItemParticipantsViewBoolExp>;
};


export type subscription_rootbusinessQueueItemParticipantsViewStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BusinessQueueItemParticipantsViewStreamCursorInput>>;
  where?: InputMaybe<BusinessQueueItemParticipantsViewBoolExp>;
};


export type subscription_rootbusinessQueueItemSubTypeArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemSubTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemSubTypeOrderBy>>;
  where?: InputMaybe<BusinessQueueItemSubTypeBoolExp>;
};


export type subscription_rootbusinessQueueItemSubTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessQueueItemSubTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessQueueItemSubTypeOrderBy>>;
  where?: InputMaybe<BusinessQueueItemSubTypeBoolExp>;
};


export type subscription_rootbusinessQueueItemSubTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootbusinessQueueItemSubTypeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BusinessQueueItemSubTypeStreamCursorInput>>;
  where?: InputMaybe<BusinessQueueItemSubTypeBoolExp>;
};


export type subscription_rootbusinessUserContactArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootbusinessUserContactNumbersArgs = {
  distinctOn?: InputMaybe<Array<BusinessUserContactNumbersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessUserContactNumbersOrderBy>>;
  where?: InputMaybe<BusinessUserContactNumbersBoolExp>;
};


export type subscription_rootbusinessUserContactNumbersAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessUserContactNumbersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessUserContactNumbersOrderBy>>;
  where?: InputMaybe<BusinessUserContactNumbersBoolExp>;
};


export type subscription_rootbusinessUserContactNumbersByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootbusinessUserContactNumbersStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BusinessUserContactNumbersStreamCursorInput>>;
  where?: InputMaybe<BusinessUserContactNumbersBoolExp>;
};


export type subscription_rootbusinessUserContactsArgs = {
  distinctOn?: InputMaybe<Array<businessUserContactsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<businessUserContactsOrderBy>>;
  where?: InputMaybe<businessUserContactsBoolExp>;
};


export type subscription_rootbusinessUserFeedArgs = {
  distinctOn?: InputMaybe<Array<BusinessUserFeedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessUserFeedOrderBy>>;
  where?: InputMaybe<BusinessUserFeedBoolExp>;
};


export type subscription_rootbusinessUserFeedAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessUserFeedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessUserFeedOrderBy>>;
  where?: InputMaybe<BusinessUserFeedBoolExp>;
};


export type subscription_rootbusinessUserFeedByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootbusinessUserFeedStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BusinessUserFeedStreamCursorInput>>;
  where?: InputMaybe<BusinessUserFeedBoolExp>;
};


export type subscription_rootbusinessUserRequestStatusArgs = {
  distinctOn?: InputMaybe<Array<BusinessUserRequestStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessUserRequestStatusOrderBy>>;
  where?: InputMaybe<BusinessUserRequestStatusBoolExp>;
};


export type subscription_rootbusinessUserRequestStatusAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessUserRequestStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessUserRequestStatusOrderBy>>;
  where?: InputMaybe<BusinessUserRequestStatusBoolExp>;
};


export type subscription_rootbusinessUserRequestStatusByPkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootbusinessUserRequestStatusStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BusinessUserRequestStatusStreamCursorInput>>;
  where?: InputMaybe<BusinessUserRequestStatusBoolExp>;
};


export type subscription_rootbusinessUserSettingArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootbusinessUserSettingsArgs = {
  distinctOn?: InputMaybe<Array<businessUserSettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<businessUserSettingsOrderBy>>;
  where?: InputMaybe<businessUserSettingsBoolExp>;
};


export type subscription_rootbusinessUserStatesArgs = {
  distinctOn?: InputMaybe<Array<BusinessUserStatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessUserStatesOrderBy>>;
  where?: InputMaybe<BusinessUserStatesBoolExp>;
};


export type subscription_rootbusinessUserStatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessUserStatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessUserStatesOrderBy>>;
  where?: InputMaybe<BusinessUserStatesBoolExp>;
};


export type subscription_rootbusinessUserStatesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootbusinessUserStatesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BusinessUserStatesStreamCursorInput>>;
  where?: InputMaybe<BusinessUserStatesBoolExp>;
};


export type subscription_rootcrmContextArgs = {
  distinctOn?: InputMaybe<Array<CrmContextSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmContextOrderBy>>;
  where?: InputMaybe<CrmContextBoolExp>;
};


export type subscription_rootcrmContextAggregateArgs = {
  distinctOn?: InputMaybe<Array<CrmContextSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmContextOrderBy>>;
  where?: InputMaybe<CrmContextBoolExp>;
};


export type subscription_rootcrmContextByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootcrmContextStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CrmContextStreamCursorInput>>;
  where?: InputMaybe<CrmContextBoolExp>;
};


export type subscription_rootcrmContextTypeArgs = {
  distinctOn?: InputMaybe<Array<CrmContextTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmContextTypeOrderBy>>;
  where?: InputMaybe<CrmContextTypeBoolExp>;
};


export type subscription_rootcrmContextTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<CrmContextTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmContextTypeOrderBy>>;
  where?: InputMaybe<CrmContextTypeBoolExp>;
};


export type subscription_rootcrmContextTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootcrmContextTypeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CrmContextTypeStreamCursorInput>>;
  where?: InputMaybe<CrmContextTypeBoolExp>;
};


export type subscription_rootcrmCreatorTypeArgs = {
  distinctOn?: InputMaybe<Array<CrmCreatorTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmCreatorTypeOrderBy>>;
  where?: InputMaybe<CrmCreatorTypeBoolExp>;
};


export type subscription_rootcrmCreatorTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<CrmCreatorTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmCreatorTypeOrderBy>>;
  where?: InputMaybe<CrmCreatorTypeBoolExp>;
};


export type subscription_rootcrmCreatorTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootcrmCreatorTypeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CrmCreatorTypeStreamCursorInput>>;
  where?: InputMaybe<CrmCreatorTypeBoolExp>;
};


export type subscription_rootcrmCrmTypeArgs = {
  distinctOn?: InputMaybe<Array<CrmCrmTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmCrmTypeOrderBy>>;
  where?: InputMaybe<CrmCrmTypeBoolExp>;
};


export type subscription_rootcrmCrmTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<CrmCrmTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmCrmTypeOrderBy>>;
  where?: InputMaybe<CrmCrmTypeBoolExp>;
};


export type subscription_rootcrmCrmTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootcrmCrmTypeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CrmCrmTypeStreamCursorInput>>;
  where?: InputMaybe<CrmCrmTypeBoolExp>;
};


export type subscription_rootcrmDirectionTypeArgs = {
  distinctOn?: InputMaybe<Array<CrmDirectionTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmDirectionTypeOrderBy>>;
  where?: InputMaybe<CrmDirectionTypeBoolExp>;
};


export type subscription_rootcrmDirectionTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<CrmDirectionTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmDirectionTypeOrderBy>>;
  where?: InputMaybe<CrmDirectionTypeBoolExp>;
};


export type subscription_rootcrmDirectionTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootcrmDirectionTypeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CrmDirectionTypeStreamCursorInput>>;
  where?: InputMaybe<CrmDirectionTypeBoolExp>;
};


export type subscription_rootcrmEntityArgs = {
  distinctOn?: InputMaybe<Array<CrmEntitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmEntityOrderBy>>;
  where?: InputMaybe<CrmEntityBoolExp>;
};


export type subscription_rootcrmEntityAggregateArgs = {
  distinctOn?: InputMaybe<Array<CrmEntitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmEntityOrderBy>>;
  where?: InputMaybe<CrmEntityBoolExp>;
};


export type subscription_rootcrmEntityByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootcrmEntityStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CrmEntityStreamCursorInput>>;
  where?: InputMaybe<CrmEntityBoolExp>;
};


export type subscription_rootcrmEventArgs = {
  distinctOn?: InputMaybe<Array<CrmEventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmEventOrderBy>>;
  where?: InputMaybe<CrmEventBoolExp>;
};


export type subscription_rootcrmEventAggregateArgs = {
  distinctOn?: InputMaybe<Array<CrmEventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmEventOrderBy>>;
  where?: InputMaybe<CrmEventBoolExp>;
};


export type subscription_rootcrmEventByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootcrmEventStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CrmEventStreamCursorInput>>;
  where?: InputMaybe<CrmEventBoolExp>;
};


export type subscription_rootcrmEventTypeArgs = {
  distinctOn?: InputMaybe<Array<CrmEventTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmEventTypeOrderBy>>;
  where?: InputMaybe<CrmEventTypeBoolExp>;
};


export type subscription_rootcrmEventTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<CrmEventTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmEventTypeOrderBy>>;
  where?: InputMaybe<CrmEventTypeBoolExp>;
};


export type subscription_rootcrmEventTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootcrmEventTypeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CrmEventTypeStreamCursorInput>>;
  where?: InputMaybe<CrmEventTypeBoolExp>;
};


export type subscription_rootcrmStatusCodeArgs = {
  distinctOn?: InputMaybe<Array<CrmStatusCodeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmStatusCodeOrderBy>>;
  where?: InputMaybe<CrmStatusCodeBoolExp>;
};


export type subscription_rootcrmStatusCodeAggregateArgs = {
  distinctOn?: InputMaybe<Array<CrmStatusCodeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmStatusCodeOrderBy>>;
  where?: InputMaybe<CrmStatusCodeBoolExp>;
};


export type subscription_rootcrmStatusCodeByPkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootcrmStatusCodeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CrmStatusCodeStreamCursorInput>>;
  where?: InputMaybe<CrmStatusCodeBoolExp>;
};


export type subscription_rootcrmStatusMessageAggregateArgs = {
  distinctOn?: InputMaybe<Array<crmStatusMessageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<crmStatusMessageOrderBy>>;
  where?: InputMaybe<crmStatusMessageBoolExp>;
};


export type subscription_rootcrmStatusMessageByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootcrmStatusMessageStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<crmStatusMessageStreamCursorInput>>;
  where?: InputMaybe<crmStatusMessageBoolExp>;
};


export type subscription_rootcrmStatusMessagesArgs = {
  distinctOn?: InputMaybe<Array<crmStatusMessageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<crmStatusMessageOrderBy>>;
  where?: InputMaybe<crmStatusMessageBoolExp>;
};


export type subscription_rootcrmSystemTypeArgs = {
  distinctOn?: InputMaybe<Array<CrmSystemTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmSystemTypeOrderBy>>;
  where?: InputMaybe<CrmSystemTypeBoolExp>;
};


export type subscription_rootcrmSystemTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<CrmSystemTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmSystemTypeOrderBy>>;
  where?: InputMaybe<CrmSystemTypeBoolExp>;
};


export type subscription_rootcrmSystemTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootcrmSystemTypeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CrmSystemTypeStreamCursorInput>>;
  where?: InputMaybe<CrmSystemTypeBoolExp>;
};


export type subscription_rootcrmTraceContextArgs = {
  distinctOn?: InputMaybe<Array<CrmTraceContextSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmTraceContextOrderBy>>;
  where?: InputMaybe<CrmTraceContextBoolExp>;
};


export type subscription_rootcrmTraceContextAggregateArgs = {
  distinctOn?: InputMaybe<Array<CrmTraceContextSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmTraceContextOrderBy>>;
  where?: InputMaybe<CrmTraceContextBoolExp>;
};


export type subscription_rootcrmTraceContextByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootcrmTraceContextStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CrmTraceContextStreamCursorInput>>;
  where?: InputMaybe<CrmTraceContextBoolExp>;
};


export type subscription_rootcrmUnifiedEntityTypeArgs = {
  distinctOn?: InputMaybe<Array<CrmUnifiedEntityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmUnifiedEntityTypeOrderBy>>;
  where?: InputMaybe<CrmUnifiedEntityTypeBoolExp>;
};


export type subscription_rootcrmUnifiedEntityTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<CrmUnifiedEntityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CrmUnifiedEntityTypeOrderBy>>;
  where?: InputMaybe<CrmUnifiedEntityTypeBoolExp>;
};


export type subscription_rootcrmUnifiedEntityTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootcrmUnifiedEntityTypeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CrmUnifiedEntityTypeStreamCursorInput>>;
  where?: InputMaybe<CrmUnifiedEntityTypeBoolExp>;
};


export type subscription_rootcrmYoutelloCatalystIdMappingArgs = {
  catalystId: Scalars['uuid']['input'];
  youtelloId: Scalars['uuid']['input'];
};


export type subscription_rootcrmYoutelloCatalystIdMappingAggregateArgs = {
  distinctOn?: InputMaybe<Array<crmYoutelloCatalystIdMappingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<crmYoutelloCatalystIdMappingOrderBy>>;
  where?: InputMaybe<crmYoutelloCatalystIdMappingBoolExp>;
};


export type subscription_rootcrmYoutelloCatalystIdMappingStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<crmYoutelloCatalystIdMappingStreamCursorInput>>;
  where?: InputMaybe<crmYoutelloCatalystIdMappingBoolExp>;
};


export type subscription_rootcrmYoutelloCatalystIdMappingsArgs = {
  distinctOn?: InputMaybe<Array<crmYoutelloCatalystIdMappingSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<crmYoutelloCatalystIdMappingOrderBy>>;
  where?: InputMaybe<crmYoutelloCatalystIdMappingBoolExp>;
};


export type subscription_rootdomainActivitiesArgs = {
  distinctOn?: InputMaybe<Array<domainActivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainActivityOrderBy>>;
  where?: InputMaybe<domainActivityBoolExp>;
};


export type subscription_rootdomainActivitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<domainActivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainActivityOrderBy>>;
  where?: InputMaybe<domainActivityBoolExp>;
};


export type subscription_rootdomainActivitiesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<domainActivityStreamCursorInput>>;
  where?: InputMaybe<domainActivityBoolExp>;
};


export type subscription_rootdomainActivityArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootdomainOrganizationArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootdomainOrganizationsArgs = {
  distinctOn?: InputMaybe<Array<domainOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainOrganizationOrderBy>>;
  where?: InputMaybe<domainOrganizationBoolExp>;
};


export type subscription_rootdomainOrganizationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<domainOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainOrganizationOrderBy>>;
  where?: InputMaybe<domainOrganizationBoolExp>;
};


export type subscription_rootdomainOrganizationsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<domainOrganizationStreamCursorInput>>;
  where?: InputMaybe<domainOrganizationBoolExp>;
};


export type subscription_rootdomainParticipantArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootdomainParticipantsArgs = {
  distinctOn?: InputMaybe<Array<domainParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainParticipantOrderBy>>;
  where?: InputMaybe<domainParticipantBoolExp>;
};


export type subscription_rootdomainParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<domainParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainParticipantOrderBy>>;
  where?: InputMaybe<domainParticipantBoolExp>;
};


export type subscription_rootdomainParticipantsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<domainParticipantStreamCursorInput>>;
  where?: InputMaybe<domainParticipantBoolExp>;
};


export type subscription_rootdomainTypeArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootdomainTypesArgs = {
  distinctOn?: InputMaybe<Array<domainTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainTypeOrderBy>>;
  where?: InputMaybe<domainTypeBoolExp>;
};


export type subscription_rootdomainTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<domainTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainTypeOrderBy>>;
  where?: InputMaybe<domainTypeBoolExp>;
};


export type subscription_rootdomainTypesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<domainTypeStreamCursorInput>>;
  where?: InputMaybe<domainTypeBoolExp>;
};


export type subscription_rootdomainUserArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootdomainUserCategoriesArgs = {
  distinctOn?: InputMaybe<Array<domainUserCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainUserCategoryOrderBy>>;
  where?: InputMaybe<domainUserCategoryBoolExp>;
};


export type subscription_rootdomainUserCategoriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<domainUserCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainUserCategoryOrderBy>>;
  where?: InputMaybe<domainUserCategoryBoolExp>;
};


export type subscription_rootdomainUserCategoriesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<domainUserCategoryStreamCursorInput>>;
  where?: InputMaybe<domainUserCategoryBoolExp>;
};


export type subscription_rootdomainUserCategoryArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootdomainUsersArgs = {
  distinctOn?: InputMaybe<Array<domainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainUserOrderBy>>;
  where?: InputMaybe<domainUserBoolExp>;
};


export type subscription_rootdomainUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<domainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainUserOrderBy>>;
  where?: InputMaybe<domainUserBoolExp>;
};


export type subscription_rootdomainUsersStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<domainUserStreamCursorInput>>;
  where?: InputMaybe<domainUserBoolExp>;
};


export type subscription_rootincomingSmsArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootlanguageArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootlanguageAggregateArgs = {
  distinctOn?: InputMaybe<Array<languagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<languagesOrderBy>>;
  where?: InputMaybe<languagesBoolExp>;
};


export type subscription_rootlanguageStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<languagesStreamCursorInput>>;
  where?: InputMaybe<languagesBoolExp>;
};


export type subscription_rootlanguagesArgs = {
  distinctOn?: InputMaybe<Array<languagesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<languagesOrderBy>>;
  where?: InputMaybe<languagesBoolExp>;
};


export type subscription_rootmessageArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootmessageTypeArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootmessageTypesArgs = {
  distinctOn?: InputMaybe<Array<messageTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messageTypeOrderBy>>;
  where?: InputMaybe<messageTypeBoolExp>;
};


export type subscription_rootmessageTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<messageTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messageTypeOrderBy>>;
  where?: InputMaybe<messageTypeBoolExp>;
};


export type subscription_rootmessageTypesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<messageTypeStreamCursorInput>>;
  where?: InputMaybe<messageTypeBoolExp>;
};


export type subscription_rootmessagesArgs = {
  distinctOn?: InputMaybe<Array<messageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messageOrderBy>>;
  where?: InputMaybe<messageBoolExp>;
};


export type subscription_rootmessagesAggregateArgs = {
  distinctOn?: InputMaybe<Array<messageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messageOrderBy>>;
  where?: InputMaybe<messageBoolExp>;
};


export type subscription_rootmessagesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<messageStreamCursorInput>>;
  where?: InputMaybe<messageBoolExp>;
};


export type subscription_rootmessagingActivitiesArgs = {
  distinctOn?: InputMaybe<Array<messagingActivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingActivityOrderBy>>;
  where?: InputMaybe<messagingActivityBoolExp>;
};


export type subscription_rootmessagingActivityArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootmessagingActivityOrganizationArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootmessagingActivityOrganizationAggregateArgs = {
  distinctOn?: InputMaybe<Array<messagingActivityOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingActivityOrganizationOrderBy>>;
  where?: InputMaybe<messagingActivityOrganizationBoolExp>;
};


export type subscription_rootmessagingActivityOrganizationStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<messagingActivityOrganizationStreamCursorInput>>;
  where?: InputMaybe<messagingActivityOrganizationBoolExp>;
};


export type subscription_rootmessagingActivityOrganizationsArgs = {
  distinctOn?: InputMaybe<Array<messagingActivityOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingActivityOrganizationOrderBy>>;
  where?: InputMaybe<messagingActivityOrganizationBoolExp>;
};


export type subscription_rootmessagingActivitySettingsArgs = {
  distinctOn?: InputMaybe<Array<MessagingActivitySettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingActivitySettingsOrderBy>>;
  where?: InputMaybe<MessagingActivitySettingsBoolExp>;
};


export type subscription_rootmessagingActivitySettingsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MessagingActivitySettingsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingActivitySettingsOrderBy>>;
  where?: InputMaybe<MessagingActivitySettingsBoolExp>;
};


export type subscription_rootmessagingActivitySettingsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootmessagingActivitySettingsNotificationSettingTypeArgs = {
  distinctOn?: InputMaybe<Array<MessagingActivitySettingsNotificationSettingTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingActivitySettingsNotificationSettingTypeOrderBy>>;
  where?: InputMaybe<MessagingActivitySettingsNotificationSettingTypeBoolExp>;
};


export type subscription_rootmessagingActivitySettingsNotificationSettingTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<MessagingActivitySettingsNotificationSettingTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingActivitySettingsNotificationSettingTypeOrderBy>>;
  where?: InputMaybe<MessagingActivitySettingsNotificationSettingTypeBoolExp>;
};


export type subscription_rootmessagingActivitySettingsNotificationSettingTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootmessagingActivitySettingsNotificationSettingTypeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MessagingActivitySettingsNotificationSettingTypeStreamCursorInput>>;
  where?: InputMaybe<MessagingActivitySettingsNotificationSettingTypeBoolExp>;
};


export type subscription_rootmessagingActivitySettingsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MessagingActivitySettingsStreamCursorInput>>;
  where?: InputMaybe<MessagingActivitySettingsBoolExp>;
};


export type subscription_rootmessagingActivityStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<messagingActivityStreamCursorInput>>;
  where?: InputMaybe<messagingActivityBoolExp>;
};


export type subscription_rootmessagingActivityTypeArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootmessagingActivityTypeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<messagingActivityTypeStreamCursorInput>>;
  where?: InputMaybe<messagingActivityTypeBoolExp>;
};


export type subscription_rootmessagingActivityTypesArgs = {
  distinctOn?: InputMaybe<Array<messagingActivityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingActivityTypeOrderBy>>;
  where?: InputMaybe<messagingActivityTypeBoolExp>;
};


export type subscription_rootmessagingActivityUserArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootmessagingActivityUserStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<messagingActivityUserStreamCursorInput>>;
  where?: InputMaybe<messagingActivityUserBoolExp>;
};


export type subscription_rootmessagingActivityUsersArgs = {
  distinctOn?: InputMaybe<Array<messagingActivityUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingActivityUserOrderBy>>;
  where?: InputMaybe<messagingActivityUserBoolExp>;
};


export type subscription_rootmessagingInvitationArgs = {
  distinctOn?: InputMaybe<Array<MessagingInvitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingInvitationOrderBy>>;
  where?: InputMaybe<MessagingInvitationBoolExp>;
};


export type subscription_rootmessagingInvitationAggregateArgs = {
  distinctOn?: InputMaybe<Array<MessagingInvitationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingInvitationOrderBy>>;
  where?: InputMaybe<MessagingInvitationBoolExp>;
};


export type subscription_rootmessagingInvitationByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootmessagingInvitationStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MessagingInvitationStreamCursorInput>>;
  where?: InputMaybe<MessagingInvitationBoolExp>;
};


export type subscription_rootmessagingMentionsArgs = {
  distinctOn?: InputMaybe<Array<MessagingMentionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingMentionsOrderBy>>;
  where?: InputMaybe<MessagingMentionsBoolExp>;
};


export type subscription_rootmessagingMentionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MessagingMentionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingMentionsOrderBy>>;
  where?: InputMaybe<MessagingMentionsBoolExp>;
};


export type subscription_rootmessagingMentionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootmessagingMentionsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MessagingMentionsStreamCursorInput>>;
  where?: InputMaybe<MessagingMentionsBoolExp>;
};


export type subscription_rootmessagingMessageArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootmessagingMessageAttachmentArgs = {
  distinctOn?: InputMaybe<Array<MessagingMessageAttachmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingMessageAttachmentOrderBy>>;
  where?: InputMaybe<MessagingMessageAttachmentBoolExp>;
};


export type subscription_rootmessagingMessageAttachmentAggregateArgs = {
  distinctOn?: InputMaybe<Array<MessagingMessageAttachmentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingMessageAttachmentOrderBy>>;
  where?: InputMaybe<MessagingMessageAttachmentBoolExp>;
};


export type subscription_rootmessagingMessageAttachmentByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootmessagingMessageAttachmentStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MessagingMessageAttachmentStreamCursorInput>>;
  where?: InputMaybe<MessagingMessageAttachmentBoolExp>;
};


export type subscription_rootmessagingMessageAttachmentTypeArgs = {
  distinctOn?: InputMaybe<Array<MessagingMessageAttachmentTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingMessageAttachmentTypeOrderBy>>;
  where?: InputMaybe<MessagingMessageAttachmentTypeBoolExp>;
};


export type subscription_rootmessagingMessageAttachmentTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<MessagingMessageAttachmentTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingMessageAttachmentTypeOrderBy>>;
  where?: InputMaybe<MessagingMessageAttachmentTypeBoolExp>;
};


export type subscription_rootmessagingMessageAttachmentTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootmessagingMessageAttachmentTypeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MessagingMessageAttachmentTypeStreamCursorInput>>;
  where?: InputMaybe<MessagingMessageAttachmentTypeBoolExp>;
};


export type subscription_rootmessagingMessageEmojiArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootmessagingMessageEmojiStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<messagingMessageEmojiStreamCursorInput>>;
  where?: InputMaybe<messagingMessageEmojiBoolExp>;
};


export type subscription_rootmessagingMessageEmojisArgs = {
  distinctOn?: InputMaybe<Array<messagingMessageEmojiSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingMessageEmojiOrderBy>>;
  where?: InputMaybe<messagingMessageEmojiBoolExp>;
};


export type subscription_rootmessagingMessagePriorityArgs = {
  distinctOn?: InputMaybe<Array<MessagingMessagePrioritySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingMessagePriorityOrderBy>>;
  where?: InputMaybe<MessagingMessagePriorityBoolExp>;
};


export type subscription_rootmessagingMessagePriorityAggregateArgs = {
  distinctOn?: InputMaybe<Array<MessagingMessagePrioritySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MessagingMessagePriorityOrderBy>>;
  where?: InputMaybe<MessagingMessagePriorityBoolExp>;
};


export type subscription_rootmessagingMessagePriorityByPkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootmessagingMessagePriorityStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MessagingMessagePriorityStreamCursorInput>>;
  where?: InputMaybe<MessagingMessagePriorityBoolExp>;
};


export type subscription_rootmessagingMessageReadArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootmessagingMessageReadStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<messagingMessageReadStreamCursorInput>>;
  where?: InputMaybe<messagingMessageReadBoolExp>;
};


export type subscription_rootmessagingMessageReadsArgs = {
  distinctOn?: InputMaybe<Array<messagingMessageReadSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingMessageReadOrderBy>>;
  where?: InputMaybe<messagingMessageReadBoolExp>;
};


export type subscription_rootmessagingMessageStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<messagingMessageStreamCursorInput>>;
  where?: InputMaybe<messagingMessageBoolExp>;
};


export type subscription_rootmessagingMessageTypeArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootmessagingMessageTypeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<messagingMessageTypeStreamCursorInput>>;
  where?: InputMaybe<messagingMessageTypeBoolExp>;
};


export type subscription_rootmessagingMessageTypesArgs = {
  distinctOn?: InputMaybe<Array<messagingMessageTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingMessageTypeOrderBy>>;
  where?: InputMaybe<messagingMessageTypeBoolExp>;
};


export type subscription_rootmessagingMessagesArgs = {
  distinctOn?: InputMaybe<Array<messagingMessageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingMessageOrderBy>>;
  where?: InputMaybe<messagingMessageBoolExp>;
};


export type subscription_rootnotificationArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootnotificationNotificationDeviceSentArgs = {
  distinctOn?: InputMaybe<Array<NotificationNotificationDeviceSentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationNotificationDeviceSentOrderBy>>;
  where?: InputMaybe<NotificationNotificationDeviceSentBoolExp>;
};


export type subscription_rootnotificationNotificationDeviceSentAggregateArgs = {
  distinctOn?: InputMaybe<Array<NotificationNotificationDeviceSentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationNotificationDeviceSentOrderBy>>;
  where?: InputMaybe<NotificationNotificationDeviceSentBoolExp>;
};


export type subscription_rootnotificationNotificationDeviceSentByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootnotificationNotificationDeviceSentStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<NotificationNotificationDeviceSentStreamCursorInput>>;
  where?: InputMaybe<NotificationNotificationDeviceSentBoolExp>;
};


export type subscription_rootnotificationNotificationSettingActivityPrimaryEnumArgs = {
  distinctOn?: InputMaybe<Array<NotificationNotificationSettingActivityPrimaryEnumSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationNotificationSettingActivityPrimaryEnumOrderBy>>;
  where?: InputMaybe<NotificationNotificationSettingActivityPrimaryEnumBoolExp>;
};


export type subscription_rootnotificationNotificationSettingActivityPrimaryEnumAggregateArgs = {
  distinctOn?: InputMaybe<Array<NotificationNotificationSettingActivityPrimaryEnumSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationNotificationSettingActivityPrimaryEnumOrderBy>>;
  where?: InputMaybe<NotificationNotificationSettingActivityPrimaryEnumBoolExp>;
};


export type subscription_rootnotificationNotificationSettingActivityPrimaryEnumByPkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootnotificationNotificationSettingActivityPrimaryEnumStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<NotificationNotificationSettingActivityPrimaryEnumStreamCursorInput>>;
  where?: InputMaybe<NotificationNotificationSettingActivityPrimaryEnumBoolExp>;
};


export type subscription_rootnotificationSendArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootnotificationSendsArgs = {
  distinctOn?: InputMaybe<Array<notificationSendSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<notificationSendOrderBy>>;
  where?: InputMaybe<notificationSendBoolExp>;
};


export type subscription_rootnotificationSendsAggregateArgs = {
  distinctOn?: InputMaybe<Array<notificationSendSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<notificationSendOrderBy>>;
  where?: InputMaybe<notificationSendBoolExp>;
};


export type subscription_rootnotificationSendsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<notificationSendStreamCursorInput>>;
  where?: InputMaybe<notificationSendBoolExp>;
};


export type subscription_rootnotificationSettingActivitiesArgs = {
  distinctOn?: InputMaybe<Array<notificationSettingActivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<notificationSettingActivityOrderBy>>;
  where?: InputMaybe<notificationSettingActivityBoolExp>;
};


export type subscription_rootnotificationSettingActivitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<notificationSettingActivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<notificationSettingActivityOrderBy>>;
  where?: InputMaybe<notificationSettingActivityBoolExp>;
};


export type subscription_rootnotificationSettingActivitiesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<notificationSettingActivityStreamCursorInput>>;
  where?: InputMaybe<notificationSettingActivityBoolExp>;
};


export type subscription_rootnotificationSettingActivityArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootnotificationUserArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootnotificationUserDeviceArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootnotificationUserDevicesArgs = {
  distinctOn?: InputMaybe<Array<notificationUserDeviceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<notificationUserDeviceOrderBy>>;
  where?: InputMaybe<notificationUserDeviceBoolExp>;
};


export type subscription_rootnotificationUserDevicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<notificationUserDeviceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<notificationUserDeviceOrderBy>>;
  where?: InputMaybe<notificationUserDeviceBoolExp>;
};


export type subscription_rootnotificationUserDevicesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<notificationUserDeviceStreamCursorInput>>;
  where?: InputMaybe<notificationUserDeviceBoolExp>;
};


export type subscription_rootnotificationUsersArgs = {
  distinctOn?: InputMaybe<Array<notificationUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<notificationUserOrderBy>>;
  where?: InputMaybe<notificationUserBoolExp>;
};


export type subscription_rootnotificationUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<notificationUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<notificationUserOrderBy>>;
  where?: InputMaybe<notificationUserBoolExp>;
};


export type subscription_rootnotificationUsersStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<notificationUserStreamCursorInput>>;
  where?: InputMaybe<notificationUserBoolExp>;
};


export type subscription_rootnotificationsArgs = {
  distinctOn?: InputMaybe<Array<notificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<notificationOrderBy>>;
  where?: InputMaybe<notificationBoolExp>;
};


export type subscription_rootnotificationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<notificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<notificationOrderBy>>;
  where?: InputMaybe<notificationBoolExp>;
};


export type subscription_rootnotificationsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<notificationStreamCursorInput>>;
  where?: InputMaybe<notificationBoolExp>;
};


export type subscription_rootordersIntegrationArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootordersIntegrationsArgs = {
  distinctOn?: InputMaybe<Array<ordersIntegrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ordersIntegrationsOrderBy>>;
  where?: InputMaybe<ordersIntegrationsBoolExp>;
};


export type subscription_rootordersIntegrationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ordersIntegrationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ordersIntegrationsOrderBy>>;
  where?: InputMaybe<ordersIntegrationsBoolExp>;
};


export type subscription_rootordersIntegrationsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ordersIntegrationsStreamCursorInput>>;
  where?: InputMaybe<ordersIntegrationsBoolExp>;
};


export type subscription_rootordersOrganizationsArgs = {
  distinctOn?: InputMaybe<Array<OrdersOrganizationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersOrganizationsOrderBy>>;
  where?: InputMaybe<OrdersOrganizationsBoolExp>;
};


export type subscription_rootordersOrganizationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<OrdersOrganizationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersOrganizationsOrderBy>>;
  where?: InputMaybe<OrdersOrganizationsBoolExp>;
};


export type subscription_rootordersOrganizationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootordersOrganizationsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<OrdersOrganizationsStreamCursorInput>>;
  where?: InputMaybe<OrdersOrganizationsBoolExp>;
};


export type subscription_rootordersRequestArgs = {
  distinctOn?: InputMaybe<Array<OrdersRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersRequestOrderBy>>;
  where?: InputMaybe<OrdersRequestBoolExp>;
};


export type subscription_rootordersRequestAggregateArgs = {
  distinctOn?: InputMaybe<Array<OrdersRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersRequestOrderBy>>;
  where?: InputMaybe<OrdersRequestBoolExp>;
};


export type subscription_rootordersRequestByPkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootordersRequestStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<OrdersRequestStreamCursorInput>>;
  where?: InputMaybe<OrdersRequestBoolExp>;
};


export type subscription_rootordersStatusArgs = {
  distinctOn?: InputMaybe<Array<OrdersStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersStatusOrderBy>>;
  where?: InputMaybe<OrdersStatusBoolExp>;
};


export type subscription_rootordersStatusAggregateArgs = {
  distinctOn?: InputMaybe<Array<OrdersStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersStatusOrderBy>>;
  where?: InputMaybe<OrdersStatusBoolExp>;
};


export type subscription_rootordersStatusByPkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootordersStatusStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<OrdersStatusStreamCursorInput>>;
  where?: InputMaybe<OrdersStatusBoolExp>;
};


export type subscription_rootordersTypeArgs = {
  distinctOn?: InputMaybe<Array<OrdersTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersTypeOrderBy>>;
  where?: InputMaybe<OrdersTypeBoolExp>;
};


export type subscription_rootordersTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<OrdersTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrdersTypeOrderBy>>;
  where?: InputMaybe<OrdersTypeBoolExp>;
};


export type subscription_rootordersTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootordersTypeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<OrdersTypeStreamCursorInput>>;
  where?: InputMaybe<OrdersTypeBoolExp>;
};


export type subscription_rootorganizationArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootorganizationAuthorizationEnumGroupArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootorganizationAuthorizationEnumGroupStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<organizationAuthorizationEnumGroupStreamCursorInput>>;
  where?: InputMaybe<organizationAuthorizationEnumGroupBoolExp>;
};


export type subscription_rootorganizationAuthorizationEnumGroupsArgs = {
  distinctOn?: InputMaybe<Array<organizationAuthorizationEnumGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationAuthorizationEnumGroupOrderBy>>;
  where?: InputMaybe<organizationAuthorizationEnumGroupBoolExp>;
};


export type subscription_rootorganizationAuthorizationGroupArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootorganizationAuthorizationGroupStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<organizationAuthorizationGroupStreamCursorInput>>;
  where?: InputMaybe<organizationAuthorizationGroupBoolExp>;
};


export type subscription_rootorganizationAuthorizationGroupsArgs = {
  distinctOn?: InputMaybe<Array<organizationAuthorizationGroupSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationAuthorizationGroupOrderBy>>;
  where?: InputMaybe<organizationAuthorizationGroupBoolExp>;
};


export type subscription_rootorganizationOrganizationRelationshipArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootorganizationOrganizationRelationshipCategoriesArgs = {
  distinctOn?: InputMaybe<Array<organizationOrganizationRelationshipCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrganizationRelationshipCategoryOrderBy>>;
  where?: InputMaybe<organizationOrganizationRelationshipCategoryBoolExp>;
};


export type subscription_rootorganizationOrganizationRelationshipCategoryArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootorganizationOrganizationRelationshipCategoryStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<organizationOrganizationRelationshipCategoryStreamCursorInput>>;
  where?: InputMaybe<organizationOrganizationRelationshipCategoryBoolExp>;
};


export type subscription_rootorganizationOrganizationRelationshipStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<organizationOrganizationRelationshipStreamCursorInput>>;
  where?: InputMaybe<organizationOrganizationRelationshipBoolExp>;
};


export type subscription_rootorganizationOrganizationRelationshipsArgs = {
  distinctOn?: InputMaybe<Array<organizationOrganizationRelationshipSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrganizationRelationshipOrderBy>>;
  where?: InputMaybe<organizationOrganizationRelationshipBoolExp>;
};


export type subscription_rootorganizationOrganizationUserAuthorizationArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootorganizationOrganizationUserAuthorizationStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<organizationOrganizationUserAuthorizationStreamCursorInput>>;
  where?: InputMaybe<organizationOrganizationUserAuthorizationBoolExp>;
};


export type subscription_rootorganizationOrganizationUserAuthorizationsArgs = {
  distinctOn?: InputMaybe<Array<organizationOrganizationUserAuthorizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrganizationUserAuthorizationOrderBy>>;
  where?: InputMaybe<organizationOrganizationUserAuthorizationBoolExp>;
};


export type subscription_rootorganizationOrganizationUserOrganizationsViewStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<organizationOrganizationUserOrganizationsViewStreamCursorInput>>;
  where?: InputMaybe<organizationOrganizationUserOrganizationsViewBoolExp>;
};


export type subscription_rootorganizationOrganizationUserOrganizationsViewsArgs = {
  distinctOn?: InputMaybe<Array<organizationOrganizationUserOrganizationsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrganizationUserOrganizationsViewOrderBy>>;
  where?: InputMaybe<organizationOrganizationUserOrganizationsViewBoolExp>;
};


export type subscription_rootorganizationOrganizationUserUsersViewStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<organizationOrganizationUserUsersViewStreamCursorInput>>;
  where?: InputMaybe<organizationOrganizationUserUsersViewBoolExp>;
};


export type subscription_rootorganizationOrganizationUserUsersViewsArgs = {
  distinctOn?: InputMaybe<Array<organizationOrganizationUserUsersViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrganizationUserUsersViewOrderBy>>;
  where?: InputMaybe<organizationOrganizationUserUsersViewBoolExp>;
};


export type subscription_rootorganizationUserArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootorganizationUserAttachmentArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootorganizationUserAttachmentsArgs = {
  distinctOn?: InputMaybe<Array<organizationUserAttachmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserAttachmentsOrderBy>>;
  where?: InputMaybe<organizationUserAttachmentsBoolExp>;
};


export type subscription_rootorganizationUserAttachmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<organizationUserAttachmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserAttachmentsOrderBy>>;
  where?: InputMaybe<organizationUserAttachmentsBoolExp>;
};


export type subscription_rootorganizationUserAttachmentsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<organizationUserAttachmentsStreamCursorInput>>;
  where?: InputMaybe<organizationUserAttachmentsBoolExp>;
};


export type subscription_rootorganizationUserAttentionNoteArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootorganizationUserAttentionNoteAggregateArgs = {
  distinctOn?: InputMaybe<Array<OrganizationUserAttentionNoteSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationUserAttentionNoteOrderBy>>;
  where?: InputMaybe<OrganizationUserAttentionNoteBoolExp>;
};


export type subscription_rootorganizationUserAttentionNoteStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<OrganizationUserAttentionNoteStreamCursorInput>>;
  where?: InputMaybe<OrganizationUserAttentionNoteBoolExp>;
};


export type subscription_rootorganizationUserAttentionNotesArgs = {
  distinctOn?: InputMaybe<Array<OrganizationUserAttentionNoteSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationUserAttentionNoteOrderBy>>;
  where?: InputMaybe<OrganizationUserAttentionNoteBoolExp>;
};


export type subscription_rootorganizationUserAuthorizationArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootorganizationUserAuthorizationStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<organizationUserAuthorizationStreamCursorInput>>;
  where?: InputMaybe<organizationUserAuthorizationBoolExp>;
};


export type subscription_rootorganizationUserAuthorizationsArgs = {
  distinctOn?: InputMaybe<Array<organizationUserAuthorizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserAuthorizationOrderBy>>;
  where?: InputMaybe<organizationUserAuthorizationBoolExp>;
};


export type subscription_rootorganizationUserDetailArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootorganizationUserDetailTypeArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootorganizationUserDetailTypesArgs = {
  distinctOn?: InputMaybe<Array<organizationUserDetailTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserDetailTypeOrderBy>>;
  where?: InputMaybe<organizationUserDetailTypeBoolExp>;
};


export type subscription_rootorganizationUserDetailTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<organizationUserDetailTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserDetailTypeOrderBy>>;
  where?: InputMaybe<organizationUserDetailTypeBoolExp>;
};


export type subscription_rootorganizationUserDetailTypesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<organizationUserDetailTypeStreamCursorInput>>;
  where?: InputMaybe<organizationUserDetailTypeBoolExp>;
};


export type subscription_rootorganizationUserDetailsArgs = {
  distinctOn?: InputMaybe<Array<organizationUserDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserDetailOrderBy>>;
  where?: InputMaybe<organizationUserDetailBoolExp>;
};


export type subscription_rootorganizationUserDetailsAggregateArgs = {
  distinctOn?: InputMaybe<Array<organizationUserDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserDetailOrderBy>>;
  where?: InputMaybe<organizationUserDetailBoolExp>;
};


export type subscription_rootorganizationUserDetailsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<organizationUserDetailStreamCursorInput>>;
  where?: InputMaybe<organizationUserDetailBoolExp>;
};


export type subscription_rootorganizationUserInviteArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootorganizationUserInviteStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<organizationUserInviteStreamCursorInput>>;
  where?: InputMaybe<organizationUserInviteBoolExp>;
};


export type subscription_rootorganizationUserInvitesArgs = {
  distinctOn?: InputMaybe<Array<organizationUserInviteSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserInviteOrderBy>>;
  where?: InputMaybe<organizationUserInviteBoolExp>;
};


export type subscription_rootorganizationUserInvitesAggregateArgs = {
  distinctOn?: InputMaybe<Array<organizationUserInviteSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserInviteOrderBy>>;
  where?: InputMaybe<organizationUserInviteBoolExp>;
};


export type subscription_rootorganizationUserRequestArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootorganizationUserRequestsArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserRequestOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserRequestBoolExp>;
};


export type subscription_rootorganizationUserStatusArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootorganizationUserStatusesArgs = {
  distinctOn?: InputMaybe<Array<organizationUserStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserStatusOrderBy>>;
  where?: InputMaybe<organizationUserStatusBoolExp>;
};


export type subscription_rootorganizationUserStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<organizationUserStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserStatusOrderBy>>;
  where?: InputMaybe<organizationUserStatusBoolExp>;
};


export type subscription_rootorganizationUserStatusesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<organizationUserStatusStreamCursorInput>>;
  where?: InputMaybe<organizationUserStatusBoolExp>;
};


export type subscription_rootorganizationUsersArgs = {
  distinctOn?: InputMaybe<Array<organizationUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserOrderBy>>;
  where?: InputMaybe<organizationUserBoolExp>;
};


export type subscription_rootorganizationUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<organizationUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserOrderBy>>;
  where?: InputMaybe<organizationUserBoolExp>;
};


export type subscription_rootorganizationUsersStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<organizationUserStreamCursorInput>>;
  where?: InputMaybe<organizationUserBoolExp>;
};


export type subscription_rootorganizationsArgs = {
  distinctOn?: InputMaybe<Array<organizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrderBy>>;
  where?: InputMaybe<organizationBoolExp>;
};


export type subscription_rootorganizationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<organizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrderBy>>;
  where?: InputMaybe<organizationBoolExp>;
};


export type subscription_rootorganizationsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<organizationStreamCursorInput>>;
  where?: InputMaybe<organizationBoolExp>;
};


export type subscription_rootphoneNumberVerificationStatusArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootphoneNumberVerificationStatusStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<phoneNumberVerificationStatusStreamCursorInput>>;
  where?: InputMaybe<phoneNumberVerificationStatusBoolExp>;
};


export type subscription_rootphoneNumberVerificationStatusesArgs = {
  distinctOn?: InputMaybe<Array<phoneNumberVerificationStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<phoneNumberVerificationStatusOrderBy>>;
  where?: InputMaybe<phoneNumberVerificationStatusBoolExp>;
};


export type subscription_rootphoneNumberVerificationStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<phoneNumberVerificationStatusSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<phoneNumberVerificationStatusOrderBy>>;
  where?: InputMaybe<phoneNumberVerificationStatusBoolExp>;
};


export type subscription_rootpromptArgs = {
  distinctOn?: InputMaybe<Array<PromptSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PromptOrderBy>>;
  where?: InputMaybe<PromptBoolExp>;
};


export type subscription_rootpromptAggregateArgs = {
  distinctOn?: InputMaybe<Array<PromptSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PromptOrderBy>>;
  where?: InputMaybe<PromptBoolExp>;
};


export type subscription_rootpromptByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootpromptStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PromptStreamCursorInput>>;
  where?: InputMaybe<PromptBoolExp>;
};


export type subscription_rootpublicDeviceArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootpublicDeviceStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<publicDeviceStreamCursorInput>>;
  where?: InputMaybe<publicDeviceBoolExp>;
};


export type subscription_rootpublicDevicesArgs = {
  distinctOn?: InputMaybe<Array<publicDeviceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<publicDeviceOrderBy>>;
  where?: InputMaybe<publicDeviceBoolExp>;
};


export type subscription_rootpublicExternalRequestArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootpublicExternalRequestStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<publicExternalRequestStreamCursorInput>>;
  where?: InputMaybe<publicExternalRequestBoolExp>;
};


export type subscription_rootpublicExternalRequestsArgs = {
  distinctOn?: InputMaybe<Array<publicExternalRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<publicExternalRequestOrderBy>>;
  where?: InputMaybe<publicExternalRequestBoolExp>;
};


export type subscription_rootpublicFileArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootpublicFileStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<publicFileStreamCursorInput>>;
  where?: InputMaybe<publicFileBoolExp>;
};


export type subscription_rootpublicFilesArgs = {
  distinctOn?: InputMaybe<Array<publicFileSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<publicFileOrderBy>>;
  where?: InputMaybe<publicFileBoolExp>;
};


export type subscription_rootpublicNotificationArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootpublicNotificationStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<publicNotificationStreamCursorInput>>;
  where?: InputMaybe<publicNotificationBoolExp>;
};


export type subscription_rootpublicNotificationsArgs = {
  distinctOn?: InputMaybe<Array<publicNotificationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<publicNotificationOrderBy>>;
  where?: InputMaybe<publicNotificationBoolExp>;
};


export type subscription_rootqueueItemArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootqueueItemsArgs = {
  distinctOn?: InputMaybe<Array<queueItemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<queueItemOrderBy>>;
  where?: InputMaybe<queueItemBoolExp>;
};


export type subscription_rootqueueItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<queueItemSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<queueItemOrderBy>>;
  where?: InputMaybe<queueItemBoolExp>;
};


export type subscription_rootqueueItemsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<queueItemStreamCursorInput>>;
  where?: InputMaybe<queueItemBoolExp>;
};


export type subscription_rootrelOrganizationUserDomainUserArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootrelOrganizationUserDomainUsersArgs = {
  distinctOn?: InputMaybe<Array<relOrganizationUserDomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<relOrganizationUserDomainUserOrderBy>>;
  where?: InputMaybe<relOrganizationUserDomainUserBoolExp>;
};


export type subscription_rootrelOrganizationUserDomainUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<relOrganizationUserDomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<relOrganizationUserDomainUserOrderBy>>;
  where?: InputMaybe<relOrganizationUserDomainUserBoolExp>;
};


export type subscription_rootrelOrganizationUserDomainUsersStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<relOrganizationUserDomainUserStreamCursorInput>>;
  where?: InputMaybe<relOrganizationUserDomainUserBoolExp>;
};


export type subscription_rootsmsConnectorArgs = {
  id: Scalars['Int']['input'];
};


export type subscription_rootsmsConnectorStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<smsConnectorStreamCursorInput>>;
  where?: InputMaybe<smsConnectorBoolExp>;
};


export type subscription_rootsmsConnectorsArgs = {
  distinctOn?: InputMaybe<Array<smsConnectorSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsConnectorOrderBy>>;
  where?: InputMaybe<smsConnectorBoolExp>;
};


export type subscription_rootsmsGateArgs = {
  id: Scalars['Int']['input'];
};


export type subscription_rootsmsGateStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<smsGateStreamCursorInput>>;
  where?: InputMaybe<smsGateBoolExp>;
};


export type subscription_rootsmsGatesArgs = {
  distinctOn?: InputMaybe<Array<smsGateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsGateOrderBy>>;
  where?: InputMaybe<smsGateBoolExp>;
};


export type subscription_rootsmsLinkMobilitySmsContentArgs = {
  uuid: Scalars['uuid']['input'];
};


export type subscription_rootsmsLinkMobilitySmsContentStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<smsLinkMobilitySmsContentStreamCursorInput>>;
  where?: InputMaybe<smsLinkMobilitySmsContentBoolExp>;
};


export type subscription_rootsmsLinkMobilitySmsContentsArgs = {
  distinctOn?: InputMaybe<Array<smsLinkMobilitySmsContentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsLinkMobilitySmsContentOrderBy>>;
  where?: InputMaybe<smsLinkMobilitySmsContentBoolExp>;
};


export type subscription_rootsmsLinkMobilitySmsMessageArgs = {
  uuid: Scalars['uuid']['input'];
};


export type subscription_rootsmsLinkMobilitySmsMessageStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<smsLinkMobilitySmsMessageStreamCursorInput>>;
  where?: InputMaybe<smsLinkMobilitySmsMessageBoolExp>;
};


export type subscription_rootsmsLinkMobilitySmsMessagesArgs = {
  distinctOn?: InputMaybe<Array<smsLinkMobilitySmsMessageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsLinkMobilitySmsMessageOrderBy>>;
  where?: InputMaybe<smsLinkMobilitySmsMessageBoolExp>;
};


export type subscription_rootsmsLinkMobilitySmsRouteArgs = {
  uuid: Scalars['uuid']['input'];
};


export type subscription_rootsmsLinkMobilitySmsRouteStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<smsLinkMobilitySmsRouteStreamCursorInput>>;
  where?: InputMaybe<smsLinkMobilitySmsRouteBoolExp>;
};


export type subscription_rootsmsLinkMobilitySmsRoutesArgs = {
  distinctOn?: InputMaybe<Array<smsLinkMobilitySmsRouteSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsLinkMobilitySmsRouteOrderBy>>;
  where?: InputMaybe<smsLinkMobilitySmsRouteBoolExp>;
};


export type subscription_rootsmsProviderArgs = {
  id: Scalars['Int']['input'];
};


export type subscription_rootsmsProviderStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<smsProviderStreamCursorInput>>;
  where?: InputMaybe<smsProviderBoolExp>;
};


export type subscription_rootsmsProvidersArgs = {
  distinctOn?: InputMaybe<Array<smsProviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsProviderOrderBy>>;
  where?: InputMaybe<smsProviderBoolExp>;
};


export type subscription_rootsmsSmArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootsmsSmStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<smsSmStreamCursorInput>>;
  where?: InputMaybe<smsSmBoolExp>;
};


export type subscription_rootsmsSmsArgs = {
  distinctOn?: InputMaybe<Array<smsSmSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsSmOrderBy>>;
  where?: InputMaybe<smsSmBoolExp>;
};


export type subscription_rootsmsSmsExternalIncomingLinkMobilitiesArgs = {
  distinctOn?: InputMaybe<Array<smsSmsExternalIncomingLinkMobilitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<smsSmsExternalIncomingLinkMobilityOrderBy>>;
  where?: InputMaybe<smsSmsExternalIncomingLinkMobilityBoolExp>;
};


export type subscription_rootsmsSmsExternalIncomingLinkMobilityArgs = {
  uuid: Scalars['uuid']['input'];
};


export type subscription_rootsmsSmsExternalIncomingLinkMobilityStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<smsSmsExternalIncomingLinkMobilityStreamCursorInput>>;
  where?: InputMaybe<smsSmsExternalIncomingLinkMobilityBoolExp>;
};


export type subscription_rootstreamBusinessUserContactsArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<businessUserContactsStreamCursorInput>>;
  where?: InputMaybe<businessUserContactsBoolExp>;
};


export type subscription_rootstreamBusinessUserSettingsArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<businessUserSettingsStreamCursorInput>>;
  where?: InputMaybe<businessUserSettingsBoolExp>;
};


export type subscription_rootuserArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootuserDetailArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootuserDetailStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<userDetailStreamCursorInput>>;
  where?: InputMaybe<userDetailBoolExp>;
};


export type subscription_rootuserDetailsArgs = {
  distinctOn?: InputMaybe<Array<userDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<userDetailOrderBy>>;
  where?: InputMaybe<userDetailBoolExp>;
};


export type subscription_rootuserDetailsAggregateArgs = {
  distinctOn?: InputMaybe<Array<userDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<userDetailOrderBy>>;
  where?: InputMaybe<userDetailBoolExp>;
};


export type subscription_rootuserDetailsTypeArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootuserDetailsTypesArgs = {
  distinctOn?: InputMaybe<Array<userDetailsTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<userDetailsTypeOrderBy>>;
  where?: InputMaybe<userDetailsTypeBoolExp>;
};


export type subscription_rootuserDetailsTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<userDetailsTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<userDetailsTypeOrderBy>>;
  where?: InputMaybe<userDetailsTypeBoolExp>;
};


export type subscription_rootuserDetailsTypesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<userDetailsTypeStreamCursorInput>>;
  where?: InputMaybe<userDetailsTypeBoolExp>;
};


export type subscription_rootuserDeviceArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootuserDevicesArgs = {
  distinctOn?: InputMaybe<Array<userDeviceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<userDeviceOrderBy>>;
  where?: InputMaybe<userDeviceBoolExp>;
};


export type subscription_rootuserDevicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<userDeviceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<userDeviceOrderBy>>;
  where?: InputMaybe<userDeviceBoolExp>;
};


export type subscription_rootuserDevicesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<userDeviceStreamCursorInput>>;
  where?: InputMaybe<userDeviceBoolExp>;
};


export type subscription_rootuserPhoneNumberArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootuserPhoneNumbersArgs = {
  distinctOn?: InputMaybe<Array<userPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<userPhoneNumberOrderBy>>;
  where?: InputMaybe<userPhoneNumberBoolExp>;
};


export type subscription_rootuserPhoneNumbersAggregateArgs = {
  distinctOn?: InputMaybe<Array<userPhoneNumberSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<userPhoneNumberOrderBy>>;
  where?: InputMaybe<userPhoneNumberBoolExp>;
};


export type subscription_rootuserPhoneNumbersStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<userPhoneNumberStreamCursorInput>>;
  where?: InputMaybe<userPhoneNumberBoolExp>;
};


export type subscription_rootuserRoleArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootuserRolesArgs = {
  distinctOn?: InputMaybe<Array<userRoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<userRoleOrderBy>>;
  where?: InputMaybe<userRoleBoolExp>;
};


export type subscription_rootuserRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<userRoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<userRoleOrderBy>>;
  where?: InputMaybe<userRoleBoolExp>;
};


export type subscription_rootuserRolesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<userRoleStreamCursorInput>>;
  where?: InputMaybe<userRoleBoolExp>;
};


export type subscription_rootusersArgs = {
  distinctOn?: InputMaybe<Array<userSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<userOrderBy>>;
  where?: InputMaybe<userBoolExp>;
};


export type subscription_rootusersAggregateArgs = {
  distinctOn?: InputMaybe<Array<userSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<userOrderBy>>;
  where?: InputMaybe<userBoolExp>;
};


export type subscription_rootusersStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<userStreamCursorInput>>;
  where?: InputMaybe<userBoolExp>;
};


export type subscription_rootvalidationValidationArgs = {
  id: Scalars['uuid']['input'];
};


export type subscription_rootvalidationValidationStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<validationValidationStreamCursorInput>>;
  where?: InputMaybe<validationValidationBoolExp>;
};


export type subscription_rootvalidationValidationsArgs = {
  distinctOn?: InputMaybe<Array<validationValidationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<validationValidationOrderBy>>;
  where?: InputMaybe<validationValidationBoolExp>;
};


export type subscription_rootvoiceTypesArgs = {
  distinctOn?: InputMaybe<Array<VoiceTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoiceTypesOrderBy>>;
  where?: InputMaybe<VoiceTypesBoolExp>;
};


export type subscription_rootvoiceTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<VoiceTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VoiceTypesOrderBy>>;
  where?: InputMaybe<VoiceTypesBoolExp>;
};


export type subscription_rootvoiceTypesByPkArgs = {
  value: Scalars['String']['input'];
};


export type subscription_rootvoiceTypesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<VoiceTypesStreamCursorInput>>;
  where?: InputMaybe<VoiceTypesBoolExp>;
};

export type taskmutation_root = {
  __typename?: 'taskmutation_root';
  createActivity?: Maybe<TasktaskActivityOutput>;
  /** delete data from the table: "activity" */
  deleteActivities?: Maybe<TaskActivityMutationResponse>;
  /** delete single row from the table: "activity" */
  deleteActivity?: Maybe<TaskActivity>;
  /** delete data from the table: "activity_participant" */
  deleteActivityParticipant?: Maybe<TaskActivityParticipantMutationResponse>;
  /** delete single row from the table: "activity_participant" */
  deleteActivityParticipantByPk?: Maybe<TaskActivityParticipant>;
  /** delete data from the table: "activity_type" */
  deleteActivityType?: Maybe<TaskActivityTypeMutationResponse>;
  /** delete single row from the table: "activity_type" */
  deleteActivityTypeByPk?: Maybe<TaskActivityType>;
  /** delete single row from the table: "domain_organization" */
  deleteDomainOrganizationByPk?: Maybe<TaskDomainOrganization>;
  /** delete data from the table: "domain_organization" */
  deleteDomainOrganizations?: Maybe<TaskDomainOrganizationMutationResponse>;
  /** delete data from the table: "domain_user" */
  deleteDomainUser?: Maybe<TaskDomainUserMutationResponse>;
  /** delete single row from the table: "domain_user" */
  deleteDomainUserByPk?: Maybe<TaskDomainUser>;
  /** delete data from the table: "domain_user_category" */
  deleteDomainUserCategory?: Maybe<TaskDomainUserCategoryMutationResponse>;
  /** delete single row from the table: "domain_user_category" */
  deleteDomainUserCategoryByPk?: Maybe<TaskDomainUserCategory>;
  /** insert data into the table: "activity" */
  insertActivity?: Maybe<TaskActivityMutationResponse>;
  /** insert a single row into the table: "activity" */
  insertActivityOne?: Maybe<TaskActivity>;
  /** insert data into the table: "activity_participant" */
  insertActivityParticipant?: Maybe<TaskActivityParticipantMutationResponse>;
  /** insert a single row into the table: "activity_participant" */
  insertActivityParticipantOne?: Maybe<TaskActivityParticipant>;
  /** insert data into the table: "activity_type" */
  insertActivityType?: Maybe<TaskActivityTypeMutationResponse>;
  /** insert a single row into the table: "activity_type" */
  insertActivityTypeOne?: Maybe<TaskActivityType>;
  /** insert data into the table: "domain_organization" */
  insertDomainOrganization?: Maybe<TaskDomainOrganizationMutationResponse>;
  /** insert a single row into the table: "domain_organization" */
  insertDomainOrganizationOne?: Maybe<TaskDomainOrganization>;
  /** insert data into the table: "domain_user" */
  insertDomainUser?: Maybe<TaskDomainUserMutationResponse>;
  /** insert data into the table: "domain_user_category" */
  insertDomainUserCategory?: Maybe<TaskDomainUserCategoryMutationResponse>;
  /** insert a single row into the table: "domain_user_category" */
  insertDomainUserCategoryOne?: Maybe<TaskDomainUserCategory>;
  /** insert a single row into the table: "domain_user" */
  insertDomainUserOne?: Maybe<TaskDomainUser>;
  /** update data of the table: "activity" */
  updateActivity?: Maybe<TaskActivityMutationResponse>;
  /** update single row of the table: "activity" */
  updateActivityByPk?: Maybe<TaskActivity>;
  /** update multiples rows of table: "activity" */
  updateActivityMany?: Maybe<Array<Maybe<TaskActivityMutationResponse>>>;
  /** update data of the table: "activity_participant" */
  updateActivityParticipant?: Maybe<TaskActivityParticipantMutationResponse>;
  /** update single row of the table: "activity_participant" */
  updateActivityParticipantByPk?: Maybe<TaskActivityParticipant>;
  /** update multiples rows of table: "activity_participant" */
  updateActivityParticipantMany?: Maybe<Array<Maybe<TaskActivityParticipantMutationResponse>>>;
  /** update data of the table: "activity_type" */
  updateActivityType?: Maybe<TaskActivityTypeMutationResponse>;
  /** update single row of the table: "activity_type" */
  updateActivityTypeByPk?: Maybe<TaskActivityType>;
  /** update multiples rows of table: "activity_type" */
  updateActivityTypeMany?: Maybe<Array<Maybe<TaskActivityTypeMutationResponse>>>;
  /** update data of the table: "domain_organization" */
  updateDomainOrganization?: Maybe<TaskDomainOrganizationMutationResponse>;
  /** update single row of the table: "domain_organization" */
  updateDomainOrganizationByPk?: Maybe<TaskDomainOrganization>;
  /** update multiples rows of table: "domain_organization" */
  updateDomainOrganizationMany?: Maybe<Array<Maybe<TaskDomainOrganizationMutationResponse>>>;
  /** update data of the table: "domain_user" */
  updateDomainUser?: Maybe<TaskDomainUserMutationResponse>;
  /** update single row of the table: "domain_user" */
  updateDomainUserByPk?: Maybe<TaskDomainUser>;
  /** update data of the table: "domain_user_category" */
  updateDomainUserCategory?: Maybe<TaskDomainUserCategoryMutationResponse>;
  /** update single row of the table: "domain_user_category" */
  updateDomainUserCategoryByPk?: Maybe<TaskDomainUserCategory>;
  /** update multiples rows of table: "domain_user_category" */
  updateDomainUserCategoryMany?: Maybe<Array<Maybe<TaskDomainUserCategoryMutationResponse>>>;
  /** update multiples rows of table: "domain_user" */
  updateDomainUserMany?: Maybe<Array<Maybe<TaskDomainUserMutationResponse>>>;
};


export type taskmutation_rootcreateActivityArgs = {
  input: TasktaskActivityInput;
};


export type taskmutation_rootdeleteActivitiesArgs = {
  where: TaskActivityBoolExp;
};


export type taskmutation_rootdeleteActivityArgs = {
  id: Scalars['uuid']['input'];
};


export type taskmutation_rootdeleteActivityParticipantArgs = {
  where: TaskActivityParticipantBoolExp;
};


export type taskmutation_rootdeleteActivityParticipantByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type taskmutation_rootdeleteActivityTypeArgs = {
  where: TaskActivityTypeBoolExp;
};


export type taskmutation_rootdeleteActivityTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type taskmutation_rootdeleteDomainOrganizationByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type taskmutation_rootdeleteDomainOrganizationsArgs = {
  where: TaskDomainOrganizationBoolExp;
};


export type taskmutation_rootdeleteDomainUserArgs = {
  where: TaskDomainUserBoolExp;
};


export type taskmutation_rootdeleteDomainUserByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type taskmutation_rootdeleteDomainUserCategoryArgs = {
  where: TaskDomainUserCategoryBoolExp;
};


export type taskmutation_rootdeleteDomainUserCategoryByPkArgs = {
  value: Scalars['String']['input'];
};


export type taskmutation_rootinsertActivityArgs = {
  objects: Array<TaskActivityInsertInput>;
  onConflict?: InputMaybe<TaskActivityOnConflict>;
};


export type taskmutation_rootinsertActivityOneArgs = {
  object: TaskActivityInsertInput;
  onConflict?: InputMaybe<TaskActivityOnConflict>;
};


export type taskmutation_rootinsertActivityParticipantArgs = {
  objects: Array<TaskActivityParticipantInsertInput>;
  onConflict?: InputMaybe<TaskActivityParticipantOnConflict>;
};


export type taskmutation_rootinsertActivityParticipantOneArgs = {
  object: TaskActivityParticipantInsertInput;
  onConflict?: InputMaybe<TaskActivityParticipantOnConflict>;
};


export type taskmutation_rootinsertActivityTypeArgs = {
  objects: Array<TaskActivityTypeInsertInput>;
  onConflict?: InputMaybe<TaskActivityTypeOnConflict>;
};


export type taskmutation_rootinsertActivityTypeOneArgs = {
  object: TaskActivityTypeInsertInput;
  onConflict?: InputMaybe<TaskActivityTypeOnConflict>;
};


export type taskmutation_rootinsertDomainOrganizationArgs = {
  objects: Array<TaskDomainOrganizationInsertInput>;
  onConflict?: InputMaybe<TaskDomainOrganizationOnConflict>;
};


export type taskmutation_rootinsertDomainOrganizationOneArgs = {
  object: TaskDomainOrganizationInsertInput;
  onConflict?: InputMaybe<TaskDomainOrganizationOnConflict>;
};


export type taskmutation_rootinsertDomainUserArgs = {
  objects: Array<TaskDomainUserInsertInput>;
  onConflict?: InputMaybe<TaskDomainUserOnConflict>;
};


export type taskmutation_rootinsertDomainUserCategoryArgs = {
  objects: Array<TaskDomainUserCategoryInsertInput>;
  onConflict?: InputMaybe<TaskDomainUserCategoryOnConflict>;
};


export type taskmutation_rootinsertDomainUserCategoryOneArgs = {
  object: TaskDomainUserCategoryInsertInput;
  onConflict?: InputMaybe<TaskDomainUserCategoryOnConflict>;
};


export type taskmutation_rootinsertDomainUserOneArgs = {
  object: TaskDomainUserInsertInput;
  onConflict?: InputMaybe<TaskDomainUserOnConflict>;
};


export type taskmutation_rootupdateActivityArgs = {
  _append?: InputMaybe<TaskActivityAppendInput>;
  _deleteAtPath?: InputMaybe<TaskActivityDeleteAtPathInput>;
  _deleteElem?: InputMaybe<TaskActivityDeleteElemInput>;
  _deleteKey?: InputMaybe<TaskActivityDeleteKeyInput>;
  _prepend?: InputMaybe<TaskActivityPrependInput>;
  _set?: InputMaybe<TaskActivitySetInput>;
  where: TaskActivityBoolExp;
};


export type taskmutation_rootupdateActivityByPkArgs = {
  _append?: InputMaybe<TaskActivityAppendInput>;
  _deleteAtPath?: InputMaybe<TaskActivityDeleteAtPathInput>;
  _deleteElem?: InputMaybe<TaskActivityDeleteElemInput>;
  _deleteKey?: InputMaybe<TaskActivityDeleteKeyInput>;
  _prepend?: InputMaybe<TaskActivityPrependInput>;
  _set?: InputMaybe<TaskActivitySetInput>;
  pkColumns: TaskActivityPkColumnsInput;
};


export type taskmutation_rootupdateActivityManyArgs = {
  updates: Array<TaskActivityUpdates>;
};


export type taskmutation_rootupdateActivityParticipantArgs = {
  _set?: InputMaybe<TaskActivityParticipantSetInput>;
  where: TaskActivityParticipantBoolExp;
};


export type taskmutation_rootupdateActivityParticipantByPkArgs = {
  _set?: InputMaybe<TaskActivityParticipantSetInput>;
  pkColumns: TaskActivityParticipantPkColumnsInput;
};


export type taskmutation_rootupdateActivityParticipantManyArgs = {
  updates: Array<TaskActivityParticipantUpdates>;
};


export type taskmutation_rootupdateActivityTypeArgs = {
  _set?: InputMaybe<TaskActivityTypeSetInput>;
  where: TaskActivityTypeBoolExp;
};


export type taskmutation_rootupdateActivityTypeByPkArgs = {
  _set?: InputMaybe<TaskActivityTypeSetInput>;
  pkColumns: TaskActivityTypePkColumnsInput;
};


export type taskmutation_rootupdateActivityTypeManyArgs = {
  updates: Array<TaskActivityTypeUpdates>;
};


export type taskmutation_rootupdateDomainOrganizationArgs = {
  _set?: InputMaybe<TaskDomainOrganizationSetInput>;
  where: TaskDomainOrganizationBoolExp;
};


export type taskmutation_rootupdateDomainOrganizationByPkArgs = {
  _set?: InputMaybe<TaskDomainOrganizationSetInput>;
  pkColumns: TaskDomainOrganizationPkColumnsInput;
};


export type taskmutation_rootupdateDomainOrganizationManyArgs = {
  updates: Array<TaskDomainOrganizationUpdates>;
};


export type taskmutation_rootupdateDomainUserArgs = {
  _set?: InputMaybe<TaskDomainUserSetInput>;
  where: TaskDomainUserBoolExp;
};


export type taskmutation_rootupdateDomainUserByPkArgs = {
  _set?: InputMaybe<TaskDomainUserSetInput>;
  pkColumns: TaskDomainUserPkColumnsInput;
};


export type taskmutation_rootupdateDomainUserCategoryArgs = {
  _set?: InputMaybe<TaskDomainUserCategorySetInput>;
  where: TaskDomainUserCategoryBoolExp;
};


export type taskmutation_rootupdateDomainUserCategoryByPkArgs = {
  _set?: InputMaybe<TaskDomainUserCategorySetInput>;
  pkColumns: TaskDomainUserCategoryPkColumnsInput;
};


export type taskmutation_rootupdateDomainUserCategoryManyArgs = {
  updates: Array<TaskDomainUserCategoryUpdates>;
};


export type taskmutation_rootupdateDomainUserManyArgs = {
  updates: Array<TaskDomainUserUpdates>;
};

export type taskquery_root = {
  __typename?: 'taskquery_root';
  /** fetch data from the table: "activity" */
  activity: Array<TaskActivity>;
  /** fetch aggregated fields from the table: "activity" */
  activityAggregate: TaskActivityAggregate;
  /** fetch data from the table: "activity" using primary key columns */
  activityByPk?: Maybe<TaskActivity>;
  /** fetch data from the table: "activity_participant" */
  activityParticipant: Array<TaskActivityParticipant>;
  /** fetch aggregated fields from the table: "activity_participant" */
  activityParticipantAggregate: TaskActivityParticipantAggregate;
  /** fetch data from the table: "activity_participant" using primary key columns */
  activityParticipantByPk?: Maybe<TaskActivityParticipant>;
  /** fetch data from the table: "activity_type" */
  activityType: Array<TaskActivityType>;
  /** fetch aggregated fields from the table: "activity_type" */
  activityTypeAggregate: TaskActivityTypeAggregate;
  /** fetch data from the table: "activity_type" using primary key columns */
  activityTypeByPk?: Maybe<TaskActivityType>;
  /** fetch data from the table: "domain_organization" */
  domainOrganization: Array<TaskDomainOrganization>;
  /** fetch aggregated fields from the table: "domain_organization" */
  domainOrganizationAggregate: TaskDomainOrganizationAggregate;
  /** fetch data from the table: "domain_organization" using primary key columns */
  domainOrganizationByPk?: Maybe<TaskDomainOrganization>;
  /** fetch data from the table: "domain_user" */
  domainUser: Array<TaskDomainUser>;
  /** fetch aggregated fields from the table: "domain_user" */
  domainUserAggregate: TaskDomainUserAggregate;
  /** fetch data from the table: "domain_user" using primary key columns */
  domainUserByPk?: Maybe<TaskDomainUser>;
  /** fetch data from the table: "domain_user_category" */
  domainUserCategory: Array<TaskDomainUserCategory>;
  /** fetch aggregated fields from the table: "domain_user_category" */
  domainUserCategoryAggregate: TaskDomainUserCategoryAggregate;
  /** fetch data from the table: "domain_user_category" using primary key columns */
  domainUserCategoryByPk?: Maybe<TaskDomainUserCategory>;
};


export type taskquery_rootactivityArgs = {
  distinctOn?: InputMaybe<Array<TaskActivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskActivityOrderBy>>;
  where?: InputMaybe<TaskActivityBoolExp>;
};


export type taskquery_rootactivityAggregateArgs = {
  distinctOn?: InputMaybe<Array<TaskActivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskActivityOrderBy>>;
  where?: InputMaybe<TaskActivityBoolExp>;
};


export type taskquery_rootactivityByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type taskquery_rootactivityParticipantArgs = {
  distinctOn?: InputMaybe<Array<TaskActivityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskActivityParticipantOrderBy>>;
  where?: InputMaybe<TaskActivityParticipantBoolExp>;
};


export type taskquery_rootactivityParticipantAggregateArgs = {
  distinctOn?: InputMaybe<Array<TaskActivityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskActivityParticipantOrderBy>>;
  where?: InputMaybe<TaskActivityParticipantBoolExp>;
};


export type taskquery_rootactivityParticipantByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type taskquery_rootactivityTypeArgs = {
  distinctOn?: InputMaybe<Array<TaskActivityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskActivityTypeOrderBy>>;
  where?: InputMaybe<TaskActivityTypeBoolExp>;
};


export type taskquery_rootactivityTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<TaskActivityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskActivityTypeOrderBy>>;
  where?: InputMaybe<TaskActivityTypeBoolExp>;
};


export type taskquery_rootactivityTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type taskquery_rootdomainOrganizationArgs = {
  distinctOn?: InputMaybe<Array<TaskDomainOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskDomainOrganizationOrderBy>>;
  where?: InputMaybe<TaskDomainOrganizationBoolExp>;
};


export type taskquery_rootdomainOrganizationAggregateArgs = {
  distinctOn?: InputMaybe<Array<TaskDomainOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskDomainOrganizationOrderBy>>;
  where?: InputMaybe<TaskDomainOrganizationBoolExp>;
};


export type taskquery_rootdomainOrganizationByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type taskquery_rootdomainUserArgs = {
  distinctOn?: InputMaybe<Array<TaskDomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskDomainUserOrderBy>>;
  where?: InputMaybe<TaskDomainUserBoolExp>;
};


export type taskquery_rootdomainUserAggregateArgs = {
  distinctOn?: InputMaybe<Array<TaskDomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskDomainUserOrderBy>>;
  where?: InputMaybe<TaskDomainUserBoolExp>;
};


export type taskquery_rootdomainUserByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type taskquery_rootdomainUserCategoryArgs = {
  distinctOn?: InputMaybe<Array<TaskDomainUserCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskDomainUserCategoryOrderBy>>;
  where?: InputMaybe<TaskDomainUserCategoryBoolExp>;
};


export type taskquery_rootdomainUserCategoryAggregateArgs = {
  distinctOn?: InputMaybe<Array<TaskDomainUserCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskDomainUserCategoryOrderBy>>;
  where?: InputMaybe<TaskDomainUserCategoryBoolExp>;
};


export type taskquery_rootdomainUserCategoryByPkArgs = {
  value: Scalars['String']['input'];
};

export type tasksubscription_root = {
  __typename?: 'tasksubscription_root';
  /** fetch data from the table: "activity" */
  activity: Array<TaskActivity>;
  /** fetch aggregated fields from the table: "activity" */
  activityAggregate: TaskActivityAggregate;
  /** fetch data from the table: "activity" using primary key columns */
  activityByPk?: Maybe<TaskActivity>;
  /** fetch data from the table: "activity_participant" */
  activityParticipant: Array<TaskActivityParticipant>;
  /** fetch aggregated fields from the table: "activity_participant" */
  activityParticipantAggregate: TaskActivityParticipantAggregate;
  /** fetch data from the table: "activity_participant" using primary key columns */
  activityParticipantByPk?: Maybe<TaskActivityParticipant>;
  /** fetch data from the table in a streaming manner: "activity_participant" */
  activityParticipantStream: Array<TaskActivityParticipant>;
  /** fetch data from the table in a streaming manner: "activity" */
  activityStream: Array<TaskActivity>;
  /** fetch data from the table: "activity_type" */
  activityType: Array<TaskActivityType>;
  /** fetch aggregated fields from the table: "activity_type" */
  activityTypeAggregate: TaskActivityTypeAggregate;
  /** fetch data from the table: "activity_type" using primary key columns */
  activityTypeByPk?: Maybe<TaskActivityType>;
  /** fetch data from the table in a streaming manner: "activity_type" */
  activityTypeStream: Array<TaskActivityType>;
  /** fetch data from the table: "domain_organization" */
  domainOrganization: Array<TaskDomainOrganization>;
  /** fetch aggregated fields from the table: "domain_organization" */
  domainOrganizationAggregate: TaskDomainOrganizationAggregate;
  /** fetch data from the table: "domain_organization" using primary key columns */
  domainOrganizationByPk?: Maybe<TaskDomainOrganization>;
  /** fetch data from the table in a streaming manner: "domain_organization" */
  domainOrganizationStream: Array<TaskDomainOrganization>;
  /** fetch data from the table: "domain_user" */
  domainUser: Array<TaskDomainUser>;
  /** fetch aggregated fields from the table: "domain_user" */
  domainUserAggregate: TaskDomainUserAggregate;
  /** fetch data from the table: "domain_user" using primary key columns */
  domainUserByPk?: Maybe<TaskDomainUser>;
  /** fetch data from the table: "domain_user_category" */
  domainUserCategory: Array<TaskDomainUserCategory>;
  /** fetch aggregated fields from the table: "domain_user_category" */
  domainUserCategoryAggregate: TaskDomainUserCategoryAggregate;
  /** fetch data from the table: "domain_user_category" using primary key columns */
  domainUserCategoryByPk?: Maybe<TaskDomainUserCategory>;
  /** fetch data from the table in a streaming manner: "domain_user_category" */
  domainUserCategoryStream: Array<TaskDomainUserCategory>;
  /** fetch data from the table in a streaming manner: "domain_user" */
  domainUserStream: Array<TaskDomainUser>;
};


export type tasksubscription_rootactivityArgs = {
  distinctOn?: InputMaybe<Array<TaskActivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskActivityOrderBy>>;
  where?: InputMaybe<TaskActivityBoolExp>;
};


export type tasksubscription_rootactivityAggregateArgs = {
  distinctOn?: InputMaybe<Array<TaskActivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskActivityOrderBy>>;
  where?: InputMaybe<TaskActivityBoolExp>;
};


export type tasksubscription_rootactivityByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type tasksubscription_rootactivityParticipantArgs = {
  distinctOn?: InputMaybe<Array<TaskActivityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskActivityParticipantOrderBy>>;
  where?: InputMaybe<TaskActivityParticipantBoolExp>;
};


export type tasksubscription_rootactivityParticipantAggregateArgs = {
  distinctOn?: InputMaybe<Array<TaskActivityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskActivityParticipantOrderBy>>;
  where?: InputMaybe<TaskActivityParticipantBoolExp>;
};


export type tasksubscription_rootactivityParticipantByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type tasksubscription_rootactivityParticipantStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TaskActivityParticipantStreamCursorInput>>;
  where?: InputMaybe<TaskActivityParticipantBoolExp>;
};


export type tasksubscription_rootactivityStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TaskActivityStreamCursorInput>>;
  where?: InputMaybe<TaskActivityBoolExp>;
};


export type tasksubscription_rootactivityTypeArgs = {
  distinctOn?: InputMaybe<Array<TaskActivityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskActivityTypeOrderBy>>;
  where?: InputMaybe<TaskActivityTypeBoolExp>;
};


export type tasksubscription_rootactivityTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<TaskActivityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskActivityTypeOrderBy>>;
  where?: InputMaybe<TaskActivityTypeBoolExp>;
};


export type tasksubscription_rootactivityTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type tasksubscription_rootactivityTypeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TaskActivityTypeStreamCursorInput>>;
  where?: InputMaybe<TaskActivityTypeBoolExp>;
};


export type tasksubscription_rootdomainOrganizationArgs = {
  distinctOn?: InputMaybe<Array<TaskDomainOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskDomainOrganizationOrderBy>>;
  where?: InputMaybe<TaskDomainOrganizationBoolExp>;
};


export type tasksubscription_rootdomainOrganizationAggregateArgs = {
  distinctOn?: InputMaybe<Array<TaskDomainOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskDomainOrganizationOrderBy>>;
  where?: InputMaybe<TaskDomainOrganizationBoolExp>;
};


export type tasksubscription_rootdomainOrganizationByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type tasksubscription_rootdomainOrganizationStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TaskDomainOrganizationStreamCursorInput>>;
  where?: InputMaybe<TaskDomainOrganizationBoolExp>;
};


export type tasksubscription_rootdomainUserArgs = {
  distinctOn?: InputMaybe<Array<TaskDomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskDomainUserOrderBy>>;
  where?: InputMaybe<TaskDomainUserBoolExp>;
};


export type tasksubscription_rootdomainUserAggregateArgs = {
  distinctOn?: InputMaybe<Array<TaskDomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskDomainUserOrderBy>>;
  where?: InputMaybe<TaskDomainUserBoolExp>;
};


export type tasksubscription_rootdomainUserByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type tasksubscription_rootdomainUserCategoryArgs = {
  distinctOn?: InputMaybe<Array<TaskDomainUserCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskDomainUserCategoryOrderBy>>;
  where?: InputMaybe<TaskDomainUserCategoryBoolExp>;
};


export type tasksubscription_rootdomainUserCategoryAggregateArgs = {
  distinctOn?: InputMaybe<Array<TaskDomainUserCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TaskDomainUserCategoryOrderBy>>;
  where?: InputMaybe<TaskDomainUserCategoryBoolExp>;
};


export type tasksubscription_rootdomainUserCategoryByPkArgs = {
  value: Scalars['String']['input'];
};


export type tasksubscription_rootdomainUserCategoryStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TaskDomainUserCategoryStreamCursorInput>>;
  where?: InputMaybe<TaskDomainUserCategoryBoolExp>;
};


export type tasksubscription_rootdomainUserStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TaskDomainUserStreamCursorInput>>;
  where?: InputMaybe<TaskDomainUserBoolExp>;
};

export type telephonyDomainUserOutput = {
  __typename?: 'telephonyDomainUserOutput';
  category?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  domainOrganizationId?: Maybe<Scalars['uuid']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  function?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  numberType?: Maybe<Scalars['String']['output']>;
  organizationUserId?: Maybe<Scalars['uuid']['output']>;
  personId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type telephonyProviderIntegrationAccount = {
  endpoint: Scalars['String']['input'];
  password: Scalars['String']['input'];
  providerType: ProviderType;
  username: Scalars['String']['input'];
};

export type telephonyProviderIntegrationConfiguration = {
  activateSubscriptions: Scalars['Boolean']['input'];
};

export type telephonyProviderIntegrationInput = {
  account: telephonyProviderIntegrationAccount;
  configuration: telephonyProviderIntegrationConfiguration;
  organizationId: Scalars['String']['input'];
};

export type telephonymutation_root = {
  __typename?: 'telephonymutation_root';
  clickToCall?: Maybe<TelephonyClickToCallOutput>;
  /** insert a single row into the table: "telephony.active_numbers" */
  createActiveNumber?: Maybe<TelephonyactiveNumbers>;
  /** insert data into the table: "telephony.active_numbers" */
  createActiveNumbers?: Maybe<TelephonyactiveNumbersMutationResponse>;
  /** insert data into the table: "telephony.activity" */
  createActivities?: Maybe<TelephonyactivityMutationResponse>;
  /** insert a single row into the table: "telephony.activity" */
  createActivity?: Maybe<Telephonyactivity>;
  /** insert a single row into the table: "telephony.activity_participant" */
  createActivityParticipant?: Maybe<TelephonyactivityParticipant>;
  /** insert a single row into the table: "telephony.activity_participant_role" */
  createActivityParticipantRole?: Maybe<TelephonyActivityParticipantRole>;
  /** insert data into the table: "telephony.activity_participant_role" */
  createActivityParticipantRoles?: Maybe<TelephonyActivityParticipantRoleMutationResponse>;
  /** insert data into the table: "telephony.activity_participant" */
  createActivityParticipants?: Maybe<TelephonyactivityParticipantMutationResponse>;
  /** insert a single row into the table: "telephony.activity_type" */
  createActivityType?: Maybe<TelephonyActivityType>;
  /** insert data into the table: "telephony.activity_type" */
  createActivityTypes?: Maybe<TelephonyActivityTypeMutationResponse>;
  /** insert a single row into the table: "telephony.call_direction" */
  createCallDirection?: Maybe<TelephonyCallDirection>;
  /** insert data into the table: "telephony.call_direction" */
  createCallDirections?: Maybe<TelephonyCallDirectionMutationResponse>;
  /** insert a single row into the table: "telephony.comment" */
  createComment?: Maybe<Telephonycomment>;
  /** insert data into the table: "telephony.comment" */
  createComments?: Maybe<TelephonycommentMutationResponse>;
  /** insert a single row into the table: "telephony.domain_organization" */
  createDomainOrganization?: Maybe<TelephonydomainOrganization>;
  /** insert data into the table: "telephony.domain_organization" */
  createDomainOrganizations?: Maybe<TelephonydomainOrganizationMutationResponse>;
  /** insert a single row into the table: "telephony.domain_user" */
  createDomainUser?: Maybe<TelephonydomainUser>;
  /** insert data into the table: "telephony.domain_user_category" */
  createDomainUserCategories?: Maybe<TelephonyDomainUserCategoryMutationResponse>;
  /** insert a single row into the table: "telephony.domain_user_category" */
  createDomainUserCategory?: Maybe<TelephonyDomainUserCategory>;
  /** insert data into the table: "telephony.domain_user" */
  createDomainUsers?: Maybe<TelephonydomainUserMutationResponse>;
  /** insert a single row into the table: "telephony.event_to_be_deleted_in_may_2024" */
  createEvent?: Maybe<Telephonyevent>;
  /** insert a single row into the table: "telephony.event_action" */
  createEventAction?: Maybe<TelephonyeventAction>;
  /** insert data into the table: "telephony.event_action" */
  createEventActions?: Maybe<TelephonyeventActionMutationResponse>;
  /** insert data into the table: "telephony.event_to_be_deleted_in_may_2024" */
  createEvents?: Maybe<TelephonyeventMutationResponse>;
  /** insert a single row into the table: "telephony.number_state" */
  createNumberState?: Maybe<TelephonyNumberState>;
  /** insert data into the table: "telephony.number_state" */
  createNumberStates?: Maybe<TelephonyNumberStateMutationResponse>;
  /** insert a single row into the table: "telephony.provider" */
  createProvider?: Maybe<Telephonyprovider>;
  /** insert a single row into the table: "telephony.provider_account" */
  createProviderAccount?: Maybe<TelephonyproviderAccount>;
  /** insert data into the table: "telephony.provider_account" */
  createProviderAccounts?: Maybe<TelephonyproviderAccountMutationResponse>;
  createProviderIntegration?: Maybe<Array<Maybe<TelephonyDomainUserOutput>>>;
  /** insert a single row into the table: "telephony.provider_request_terms" */
  createProviderRequestTerm?: Maybe<TelephonyproviderRequestTerm>;
  /** insert data into the table: "telephony.provider_request_terms" */
  createProviderRequestTerms?: Maybe<TelephonyproviderRequestTermMutationResponse>;
  /** insert a single row into the table: "telephony.provider_type" */
  createProviderType?: Maybe<TelephonyProviderType>;
  /** insert data into the table: "telephony.provider_type" */
  createProviderTypes?: Maybe<TelephonyProviderTypeMutationResponse>;
  /** insert data into the table: "telephony.provider" */
  createProviders?: Maybe<TelephonyproviderMutationResponse>;
  /** delete single row from the table: "telephony.active_numbers" */
  deleteActiveNumber?: Maybe<TelephonyactiveNumbers>;
  /** delete data from the table: "telephony.active_numbers" */
  deleteActiveNumbers?: Maybe<TelephonyactiveNumbersMutationResponse>;
  /** delete data from the table: "telephony.activity" */
  deleteActivities?: Maybe<TelephonyactivityMutationResponse>;
  /** delete single row from the table: "telephony.activity" */
  deleteActivity?: Maybe<Telephonyactivity>;
  /** delete single row from the table: "telephony.activity_participant" */
  deleteActivityParticipant?: Maybe<TelephonyactivityParticipant>;
  /** delete single row from the table: "telephony.activity_participant_role" */
  deleteActivityParticipantRole?: Maybe<TelephonyActivityParticipantRole>;
  /** delete data from the table: "telephony.activity_participant_role" */
  deleteActivityParticipantRoles?: Maybe<TelephonyActivityParticipantRoleMutationResponse>;
  /** delete data from the table: "telephony.activity_participant" */
  deleteActivityParticipants?: Maybe<TelephonyactivityParticipantMutationResponse>;
  /** delete single row from the table: "telephony.activity_type" */
  deleteActivityType?: Maybe<TelephonyActivityType>;
  /** delete data from the table: "telephony.activity_type" */
  deleteActivityTypes?: Maybe<TelephonyActivityTypeMutationResponse>;
  /** delete single row from the table: "telephony.call_direction" */
  deleteCallDirection?: Maybe<TelephonyCallDirection>;
  /** delete data from the table: "telephony.call_direction" */
  deleteCallDirections?: Maybe<TelephonyCallDirectionMutationResponse>;
  /** delete single row from the table: "telephony.comment" */
  deleteComment?: Maybe<Telephonycomment>;
  /** delete data from the table: "telephony.comment" */
  deleteComments?: Maybe<TelephonycommentMutationResponse>;
  /** delete single row from the table: "telephony.domain_organization" */
  deleteDomainOrganization?: Maybe<TelephonydomainOrganization>;
  /** delete data from the table: "telephony.domain_organization" */
  deleteDomainOrganizations?: Maybe<TelephonydomainOrganizationMutationResponse>;
  /** delete single row from the table: "telephony.domain_user" */
  deleteDomainUser?: Maybe<TelephonydomainUser>;
  /** delete data from the table: "telephony.domain_user_category" */
  deleteDomainUserCategories?: Maybe<TelephonyDomainUserCategoryMutationResponse>;
  /** delete single row from the table: "telephony.domain_user_category" */
  deleteDomainUserCategory?: Maybe<TelephonyDomainUserCategory>;
  /** delete data from the table: "telephony.domain_user" */
  deleteDomainUsers?: Maybe<TelephonydomainUserMutationResponse>;
  /** delete single row from the table: "telephony.event_to_be_deleted_in_may_2024" */
  deleteEvent?: Maybe<Telephonyevent>;
  /** delete single row from the table: "telephony.event_action" */
  deleteEventAction?: Maybe<TelephonyeventAction>;
  /** delete data from the table: "telephony.event_action" */
  deleteEventActions?: Maybe<TelephonyeventActionMutationResponse>;
  /** delete data from the table: "telephony.event_to_be_deleted_in_may_2024" */
  deleteEvents?: Maybe<TelephonyeventMutationResponse>;
  /** delete single row from the table: "telephony.number_state" */
  deleteNumberState?: Maybe<TelephonyNumberState>;
  /** delete data from the table: "telephony.number_state" */
  deleteNumberStates?: Maybe<TelephonyNumberStateMutationResponse>;
  /** delete single row from the table: "telephony.provider" */
  deleteProvider?: Maybe<Telephonyprovider>;
  /** delete single row from the table: "telephony.provider_account" */
  deleteProviderAccount?: Maybe<TelephonyproviderAccount>;
  /** delete data from the table: "telephony.provider_account" */
  deleteProviderAccounts?: Maybe<TelephonyproviderAccountMutationResponse>;
  /** delete single row from the table: "telephony.provider_request_terms" */
  deleteProviderRequestTerm?: Maybe<TelephonyproviderRequestTerm>;
  /** delete data from the table: "telephony.provider_request_terms" */
  deleteProviderRequestTerms?: Maybe<TelephonyproviderRequestTermMutationResponse>;
  /** delete single row from the table: "telephony.provider_type" */
  deleteProviderType?: Maybe<TelephonyProviderType>;
  /** delete data from the table: "telephony.provider_type" */
  deleteProviderTypes?: Maybe<TelephonyProviderTypeMutationResponse>;
  /** delete data from the table: "telephony.provider" */
  deleteProviders?: Maybe<TelephonyproviderMutationResponse>;
  /** delete data from the table: "telephony.action_event_type" */
  deleteTelephonyActionEventType?: Maybe<TelephonyTelephonyActionEventTypeMutationResponse>;
  /** delete single row from the table: "telephony.action_event_type" */
  deleteTelephonyActionEventTypeByPk?: Maybe<TelephonyTelephonyActionEventType>;
  /** delete data from the table: "telephony.action_type" */
  deleteTelephonyActionType?: Maybe<TelephonyTelephonyActionTypeMutationResponse>;
  /** delete single row from the table: "telephony.action_type" */
  deleteTelephonyActionTypeByPk?: Maybe<TelephonyTelephonyActionType>;
  /** delete data from the table: "telephony.blocked_domain_user" */
  deleteTelephonyBlockedDomainUser?: Maybe<TelephonyTelephonyBlockedDomainUserMutationResponse>;
  /** delete single row from the table: "telephony.blocked_domain_user" */
  deleteTelephonyBlockedDomainUserByPk?: Maybe<TelephonyTelephonyBlockedDomainUser>;
  /** delete data from the table: "telephony.cisco_subscriber_product" */
  deleteTelephonyCiscoSubscriberProduct?: Maybe<TelephonyTelephonyCiscoSubscriberProductMutationResponse>;
  /** delete single row from the table: "telephony.cisco_subscriber_product" */
  deleteTelephonyCiscoSubscriberProductByPk?: Maybe<TelephonyTelephonyCiscoSubscriberProduct>;
  /** delete data from the table: "telephony.events" */
  deleteTelephonyEvents?: Maybe<TelephonyTelephonyEventsMutationResponse>;
  /** delete single row from the table: "telephony.events" */
  deleteTelephonyEventsByPk?: Maybe<TelephonyTelephonyEvents>;
  /** delete data from the table: "telephony.lookup_caller_api" */
  deleteTelephonyLookupCallerApi?: Maybe<TelephonyTelephonyLookupCallerApiMutationResponse>;
  /** delete single row from the table: "telephony.lookup_caller_api" */
  deleteTelephonyLookupCallerApiByPk?: Maybe<TelephonyTelephonyLookupCallerApi>;
  /** delete data from the table: "telephony.lookup_refresh" */
  deleteTelephonyLookupRefresh?: Maybe<TelephonyTelephonyLookupRefreshMutationResponse>;
  /** delete single row from the table: "telephony.lookup_refresh" */
  deleteTelephonyLookupRefreshByPk?: Maybe<TelephonyTelephonyLookupRefresh>;
  /** delete data from the table: "telephony.lookup_types" */
  deleteTelephonyLookupTypes?: Maybe<TelephonyTelephonyLookupTypesMutationResponse>;
  /** delete single row from the table: "telephony.lookup_types" */
  deleteTelephonyLookupTypesByPk?: Maybe<TelephonyTelephonyLookupTypes>;
  /** delete data from the table: "telephony.pods" */
  deleteTelephonyPods?: Maybe<TelephonyTelephonyPodsMutationResponse>;
  /** delete single row from the table: "telephony.pods" */
  deleteTelephonyPodsByPk?: Maybe<TelephonyTelephonyPods>;
  /** delete data from the table: "telephony.provider_access" */
  deleteTelephonyProviderAccess?: Maybe<TelephonyTelephonyProviderAccessMutationResponse>;
  /** delete single row from the table: "telephony.provider_access" */
  deleteTelephonyProviderAccessByPk?: Maybe<TelephonyTelephonyProviderAccess>;
  hangUpCall?: Maybe<TelephonyhangUpCallOutput>;
  /** insert data into the table: "telephony.action_event_type" */
  insertTelephonyActionEventType?: Maybe<TelephonyTelephonyActionEventTypeMutationResponse>;
  /** insert a single row into the table: "telephony.action_event_type" */
  insertTelephonyActionEventTypeOne?: Maybe<TelephonyTelephonyActionEventType>;
  /** insert data into the table: "telephony.action_type" */
  insertTelephonyActionType?: Maybe<TelephonyTelephonyActionTypeMutationResponse>;
  /** insert a single row into the table: "telephony.action_type" */
  insertTelephonyActionTypeOne?: Maybe<TelephonyTelephonyActionType>;
  /** insert data into the table: "telephony.blocked_domain_user" */
  insertTelephonyBlockedDomainUser?: Maybe<TelephonyTelephonyBlockedDomainUserMutationResponse>;
  /** insert a single row into the table: "telephony.blocked_domain_user" */
  insertTelephonyBlockedDomainUserOne?: Maybe<TelephonyTelephonyBlockedDomainUser>;
  /** insert data into the table: "telephony.cisco_subscriber_product" */
  insertTelephonyCiscoSubscriberProduct?: Maybe<TelephonyTelephonyCiscoSubscriberProductMutationResponse>;
  /** insert a single row into the table: "telephony.cisco_subscriber_product" */
  insertTelephonyCiscoSubscriberProductOne?: Maybe<TelephonyTelephonyCiscoSubscriberProduct>;
  /** insert data into the table: "telephony.events" */
  insertTelephonyEvents?: Maybe<TelephonyTelephonyEventsMutationResponse>;
  /** insert a single row into the table: "telephony.events" */
  insertTelephonyEventsOne?: Maybe<TelephonyTelephonyEvents>;
  /** insert data into the table: "telephony.lookup_caller_api" */
  insertTelephonyLookupCallerApi?: Maybe<TelephonyTelephonyLookupCallerApiMutationResponse>;
  /** insert a single row into the table: "telephony.lookup_caller_api" */
  insertTelephonyLookupCallerApiOne?: Maybe<TelephonyTelephonyLookupCallerApi>;
  /** insert data into the table: "telephony.lookup_refresh" */
  insertTelephonyLookupRefresh?: Maybe<TelephonyTelephonyLookupRefreshMutationResponse>;
  /** insert a single row into the table: "telephony.lookup_refresh" */
  insertTelephonyLookupRefreshOne?: Maybe<TelephonyTelephonyLookupRefresh>;
  /** insert data into the table: "telephony.lookup_types" */
  insertTelephonyLookupTypes?: Maybe<TelephonyTelephonyLookupTypesMutationResponse>;
  /** insert a single row into the table: "telephony.lookup_types" */
  insertTelephonyLookupTypesOne?: Maybe<TelephonyTelephonyLookupTypes>;
  /** insert data into the table: "telephony.pods" */
  insertTelephonyPods?: Maybe<TelephonyTelephonyPodsMutationResponse>;
  /** insert a single row into the table: "telephony.pods" */
  insertTelephonyPodsOne?: Maybe<TelephonyTelephonyPods>;
  /** insert data into the table: "telephony.provider_access" */
  insertTelephonyProviderAccess?: Maybe<TelephonyTelephonyProviderAccessMutationResponse>;
  /** insert a single row into the table: "telephony.provider_access" */
  insertTelephonyProviderAccessOne?: Maybe<TelephonyTelephonyProviderAccess>;
  makePhoneRequest?: Maybe<TelephonyPhoneRequestOutput>;
  sendSMS?: Maybe<TelephonySendSMSOutput>;
  synchronizeDomainUsers?: Maybe<TelephonySynchronizeDomainUsersOutput>;
  triggerTestCall?: Maybe<TelephonytriggerTestCallOutput>;
  /** update single row of the table: "telephony.active_numbers" */
  updateActiveNumber?: Maybe<TelephonyactiveNumbers>;
  /** update data of the table: "telephony.active_numbers" */
  updateActiveNumbers?: Maybe<TelephonyactiveNumbersMutationResponse>;
  /** update data of the table: "telephony.activity" */
  updateActivities?: Maybe<TelephonyactivityMutationResponse>;
  /** update single row of the table: "telephony.activity" */
  updateActivity?: Maybe<Telephonyactivity>;
  /** update single row of the table: "telephony.activity_participant" */
  updateActivityParticipant?: Maybe<TelephonyactivityParticipant>;
  /** update single row of the table: "telephony.activity_participant_role" */
  updateActivityParticipantRole?: Maybe<TelephonyActivityParticipantRole>;
  /** update data of the table: "telephony.activity_participant_role" */
  updateActivityParticipantRoles?: Maybe<TelephonyActivityParticipantRoleMutationResponse>;
  /** update data of the table: "telephony.activity_participant" */
  updateActivityParticipants?: Maybe<TelephonyactivityParticipantMutationResponse>;
  /** update single row of the table: "telephony.activity_type" */
  updateActivityType?: Maybe<TelephonyActivityType>;
  /** update data of the table: "telephony.activity_type" */
  updateActivityTypes?: Maybe<TelephonyActivityTypeMutationResponse>;
  /** update single row of the table: "telephony.call_direction" */
  updateCallDirection?: Maybe<TelephonyCallDirection>;
  /** update data of the table: "telephony.call_direction" */
  updateCallDirections?: Maybe<TelephonyCallDirectionMutationResponse>;
  /** update single row of the table: "telephony.comment" */
  updateComment?: Maybe<Telephonycomment>;
  /** update data of the table: "telephony.comment" */
  updateComments?: Maybe<TelephonycommentMutationResponse>;
  /** update single row of the table: "telephony.domain_organization" */
  updateDomainOrganization?: Maybe<TelephonydomainOrganization>;
  /** update data of the table: "telephony.domain_organization" */
  updateDomainOrganizations?: Maybe<TelephonydomainOrganizationMutationResponse>;
  /** update single row of the table: "telephony.domain_user" */
  updateDomainUser?: Maybe<TelephonydomainUser>;
  /** update data of the table: "telephony.domain_user_category" */
  updateDomainUserCategories?: Maybe<TelephonyDomainUserCategoryMutationResponse>;
  /** update single row of the table: "telephony.domain_user_category" */
  updateDomainUserCategory?: Maybe<TelephonyDomainUserCategory>;
  /** update data of the table: "telephony.domain_user" */
  updateDomainUsers?: Maybe<TelephonydomainUserMutationResponse>;
  /** update single row of the table: "telephony.event_to_be_deleted_in_may_2024" */
  updateEvent?: Maybe<Telephonyevent>;
  /** update single row of the table: "telephony.event_action" */
  updateEventAction?: Maybe<TelephonyeventAction>;
  /** update multiples rows of table: "telephony.event_action" */
  updateEventActionMany?: Maybe<Array<Maybe<TelephonyeventActionMutationResponse>>>;
  /** update data of the table: "telephony.event_action" */
  updateEventActions?: Maybe<TelephonyeventActionMutationResponse>;
  /** update data of the table: "telephony.event_to_be_deleted_in_may_2024" */
  updateEvents?: Maybe<TelephonyeventMutationResponse>;
  /** update multiples rows of table: "telephony.active_numbers" */
  updateManyActiveNumbers?: Maybe<Array<Maybe<TelephonyactiveNumbersMutationResponse>>>;
  /** update multiples rows of table: "telephony.activity" */
  updateManyActivities?: Maybe<Array<Maybe<TelephonyactivityMutationResponse>>>;
  /** update multiples rows of table: "telephony.activity_participant_role" */
  updateManyActivityParticipantRoles?: Maybe<Array<Maybe<TelephonyActivityParticipantRoleMutationResponse>>>;
  /** update multiples rows of table: "telephony.activity_participant" */
  updateManyActivityParticipants?: Maybe<Array<Maybe<TelephonyactivityParticipantMutationResponse>>>;
  /** update multiples rows of table: "telephony.activity_type" */
  updateManyActivityTypes?: Maybe<Array<Maybe<TelephonyActivityTypeMutationResponse>>>;
  /** update multiples rows of table: "telephony.call_direction" */
  updateManyCallDirections?: Maybe<Array<Maybe<TelephonyCallDirectionMutationResponse>>>;
  /** update multiples rows of table: "telephony.comment" */
  updateManyComments?: Maybe<Array<Maybe<TelephonycommentMutationResponse>>>;
  /** update multiples rows of table: "telephony.domain_organization" */
  updateManyDomainOrganizations?: Maybe<Array<Maybe<TelephonydomainOrganizationMutationResponse>>>;
  /** update multiples rows of table: "telephony.domain_user_category" */
  updateManyDomainUserCategories?: Maybe<Array<Maybe<TelephonyDomainUserCategoryMutationResponse>>>;
  /** update multiples rows of table: "telephony.domain_user" */
  updateManyDomainUsers?: Maybe<Array<Maybe<TelephonydomainUserMutationResponse>>>;
  /** update multiples rows of table: "telephony.event_to_be_deleted_in_may_2024" */
  updateManyEvents?: Maybe<Array<Maybe<TelephonyeventMutationResponse>>>;
  /** update multiples rows of table: "telephony.number_state" */
  updateManyNumberStates?: Maybe<Array<Maybe<TelephonyNumberStateMutationResponse>>>;
  /** update multiples rows of table: "telephony.provider_account" */
  updateManyProviderAccount?: Maybe<Array<Maybe<TelephonyproviderAccountMutationResponse>>>;
  /** update multiples rows of table: "telephony.provider_request_terms" */
  updateManyProviderRequestTerms?: Maybe<Array<Maybe<TelephonyproviderRequestTermMutationResponse>>>;
  /** update multiples rows of table: "telephony.provider_type" */
  updateManyProviderTypes?: Maybe<Array<Maybe<TelephonyProviderTypeMutationResponse>>>;
  /** update single row of the table: "telephony.number_state" */
  updateNumberState?: Maybe<TelephonyNumberState>;
  /** update data of the table: "telephony.number_state" */
  updateNumberStates?: Maybe<TelephonyNumberStateMutationResponse>;
  /** update single row of the table: "telephony.provider" */
  updateProvider?: Maybe<Telephonyprovider>;
  /** update single row of the table: "telephony.provider_account" */
  updateProviderAccount?: Maybe<TelephonyproviderAccount>;
  /** update data of the table: "telephony.provider_account" */
  updateProviderAccounts?: Maybe<TelephonyproviderAccountMutationResponse>;
  /** update multiples rows of table: "telephony.provider" */
  updateProviderMany?: Maybe<Array<Maybe<TelephonyproviderMutationResponse>>>;
  /** update single row of the table: "telephony.provider_request_terms" */
  updateProviderRequestTerm?: Maybe<TelephonyproviderRequestTerm>;
  /** update data of the table: "telephony.provider_request_terms" */
  updateProviderRequestTerms?: Maybe<TelephonyproviderRequestTermMutationResponse>;
  /** update single row of the table: "telephony.provider_type" */
  updateProviderType?: Maybe<TelephonyProviderType>;
  /** update data of the table: "telephony.provider_type" */
  updateProviderTypes?: Maybe<TelephonyProviderTypeMutationResponse>;
  /** update data of the table: "telephony.provider" */
  updateProviders?: Maybe<TelephonyproviderMutationResponse>;
  /** update data of the table: "telephony.action_event_type" */
  updateTelephonyActionEventType?: Maybe<TelephonyTelephonyActionEventTypeMutationResponse>;
  /** update single row of the table: "telephony.action_event_type" */
  updateTelephonyActionEventTypeByPk?: Maybe<TelephonyTelephonyActionEventType>;
  /** update multiples rows of table: "telephony.action_event_type" */
  updateTelephonyActionEventTypeMany?: Maybe<Array<Maybe<TelephonyTelephonyActionEventTypeMutationResponse>>>;
  /** update data of the table: "telephony.action_type" */
  updateTelephonyActionType?: Maybe<TelephonyTelephonyActionTypeMutationResponse>;
  /** update single row of the table: "telephony.action_type" */
  updateTelephonyActionTypeByPk?: Maybe<TelephonyTelephonyActionType>;
  /** update multiples rows of table: "telephony.action_type" */
  updateTelephonyActionTypeMany?: Maybe<Array<Maybe<TelephonyTelephonyActionTypeMutationResponse>>>;
  /** update data of the table: "telephony.blocked_domain_user" */
  updateTelephonyBlockedDomainUser?: Maybe<TelephonyTelephonyBlockedDomainUserMutationResponse>;
  /** update single row of the table: "telephony.blocked_domain_user" */
  updateTelephonyBlockedDomainUserByPk?: Maybe<TelephonyTelephonyBlockedDomainUser>;
  /** update multiples rows of table: "telephony.blocked_domain_user" */
  updateTelephonyBlockedDomainUserMany?: Maybe<Array<Maybe<TelephonyTelephonyBlockedDomainUserMutationResponse>>>;
  /** update data of the table: "telephony.cisco_subscriber_product" */
  updateTelephonyCiscoSubscriberProduct?: Maybe<TelephonyTelephonyCiscoSubscriberProductMutationResponse>;
  /** update single row of the table: "telephony.cisco_subscriber_product" */
  updateTelephonyCiscoSubscriberProductByPk?: Maybe<TelephonyTelephonyCiscoSubscriberProduct>;
  /** update multiples rows of table: "telephony.cisco_subscriber_product" */
  updateTelephonyCiscoSubscriberProductMany?: Maybe<Array<Maybe<TelephonyTelephonyCiscoSubscriberProductMutationResponse>>>;
  /** update data of the table: "telephony.events" */
  updateTelephonyEvents?: Maybe<TelephonyTelephonyEventsMutationResponse>;
  /** update single row of the table: "telephony.events" */
  updateTelephonyEventsByPk?: Maybe<TelephonyTelephonyEvents>;
  /** update multiples rows of table: "telephony.events" */
  updateTelephonyEventsMany?: Maybe<Array<Maybe<TelephonyTelephonyEventsMutationResponse>>>;
  /** update data of the table: "telephony.lookup_caller_api" */
  updateTelephonyLookupCallerApi?: Maybe<TelephonyTelephonyLookupCallerApiMutationResponse>;
  /** update single row of the table: "telephony.lookup_caller_api" */
  updateTelephonyLookupCallerApiByPk?: Maybe<TelephonyTelephonyLookupCallerApi>;
  /** update multiples rows of table: "telephony.lookup_caller_api" */
  updateTelephonyLookupCallerApiMany?: Maybe<Array<Maybe<TelephonyTelephonyLookupCallerApiMutationResponse>>>;
  /** update data of the table: "telephony.lookup_refresh" */
  updateTelephonyLookupRefresh?: Maybe<TelephonyTelephonyLookupRefreshMutationResponse>;
  /** update single row of the table: "telephony.lookup_refresh" */
  updateTelephonyLookupRefreshByPk?: Maybe<TelephonyTelephonyLookupRefresh>;
  /** update multiples rows of table: "telephony.lookup_refresh" */
  updateTelephonyLookupRefreshMany?: Maybe<Array<Maybe<TelephonyTelephonyLookupRefreshMutationResponse>>>;
  /** update data of the table: "telephony.lookup_types" */
  updateTelephonyLookupTypes?: Maybe<TelephonyTelephonyLookupTypesMutationResponse>;
  /** update single row of the table: "telephony.lookup_types" */
  updateTelephonyLookupTypesByPk?: Maybe<TelephonyTelephonyLookupTypes>;
  /** update multiples rows of table: "telephony.lookup_types" */
  updateTelephonyLookupTypesMany?: Maybe<Array<Maybe<TelephonyTelephonyLookupTypesMutationResponse>>>;
  /** update data of the table: "telephony.pods" */
  updateTelephonyPods?: Maybe<TelephonyTelephonyPodsMutationResponse>;
  /** update single row of the table: "telephony.pods" */
  updateTelephonyPodsByPk?: Maybe<TelephonyTelephonyPods>;
  /** update multiples rows of table: "telephony.pods" */
  updateTelephonyPodsMany?: Maybe<Array<Maybe<TelephonyTelephonyPodsMutationResponse>>>;
  /** update data of the table: "telephony.provider_access" */
  updateTelephonyProviderAccess?: Maybe<TelephonyTelephonyProviderAccessMutationResponse>;
  /** update single row of the table: "telephony.provider_access" */
  updateTelephonyProviderAccessByPk?: Maybe<TelephonyTelephonyProviderAccess>;
  /** update multiples rows of table: "telephony.provider_access" */
  updateTelephonyProviderAccessMany?: Maybe<Array<Maybe<TelephonyTelephonyProviderAccessMutationResponse>>>;
};


export type telephonymutation_rootclickToCallArgs = {
  clickToCall: TelephonyClickToCallInput;
};


export type telephonymutation_rootcreateActiveNumberArgs = {
  object: TelephonyactiveNumbersInsertInput;
  onConflict?: InputMaybe<TelephonyactiveNumbersOnConflict>;
};


export type telephonymutation_rootcreateActiveNumbersArgs = {
  objects: Array<TelephonyactiveNumbersInsertInput>;
  onConflict?: InputMaybe<TelephonyactiveNumbersOnConflict>;
};


export type telephonymutation_rootcreateActivitiesArgs = {
  objects: Array<TelephonyactivityInsertInput>;
  onConflict?: InputMaybe<TelephonyactivityOnConflict>;
};


export type telephonymutation_rootcreateActivityArgs = {
  object: TelephonyactivityInsertInput;
  onConflict?: InputMaybe<TelephonyactivityOnConflict>;
};


export type telephonymutation_rootcreateActivityParticipantArgs = {
  object: TelephonyactivityParticipantInsertInput;
  onConflict?: InputMaybe<TelephonyactivityParticipantOnConflict>;
};


export type telephonymutation_rootcreateActivityParticipantRoleArgs = {
  object: TelephonyActivityParticipantRoleInsertInput;
  onConflict?: InputMaybe<TelephonyActivityParticipantRoleOnConflict>;
};


export type telephonymutation_rootcreateActivityParticipantRolesArgs = {
  objects: Array<TelephonyActivityParticipantRoleInsertInput>;
  onConflict?: InputMaybe<TelephonyActivityParticipantRoleOnConflict>;
};


export type telephonymutation_rootcreateActivityParticipantsArgs = {
  objects: Array<TelephonyactivityParticipantInsertInput>;
  onConflict?: InputMaybe<TelephonyactivityParticipantOnConflict>;
};


export type telephonymutation_rootcreateActivityTypeArgs = {
  object: TelephonyActivityTypeInsertInput;
  onConflict?: InputMaybe<TelephonyActivityTypeOnConflict>;
};


export type telephonymutation_rootcreateActivityTypesArgs = {
  objects: Array<TelephonyActivityTypeInsertInput>;
  onConflict?: InputMaybe<TelephonyActivityTypeOnConflict>;
};


export type telephonymutation_rootcreateCallDirectionArgs = {
  object: TelephonyCallDirectionInsertInput;
  onConflict?: InputMaybe<TelephonyCallDirectionOnConflict>;
};


export type telephonymutation_rootcreateCallDirectionsArgs = {
  objects: Array<TelephonyCallDirectionInsertInput>;
  onConflict?: InputMaybe<TelephonyCallDirectionOnConflict>;
};


export type telephonymutation_rootcreateCommentArgs = {
  object: TelephonycommentInsertInput;
  onConflict?: InputMaybe<TelephonycommentOnConflict>;
};


export type telephonymutation_rootcreateCommentsArgs = {
  objects: Array<TelephonycommentInsertInput>;
  onConflict?: InputMaybe<TelephonycommentOnConflict>;
};


export type telephonymutation_rootcreateDomainOrganizationArgs = {
  object: TelephonydomainOrganizationInsertInput;
  onConflict?: InputMaybe<TelephonydomainOrganizationOnConflict>;
};


export type telephonymutation_rootcreateDomainOrganizationsArgs = {
  objects: Array<TelephonydomainOrganizationInsertInput>;
  onConflict?: InputMaybe<TelephonydomainOrganizationOnConflict>;
};


export type telephonymutation_rootcreateDomainUserArgs = {
  object: TelephonydomainUserInsertInput;
  onConflict?: InputMaybe<TelephonydomainUserOnConflict>;
};


export type telephonymutation_rootcreateDomainUserCategoriesArgs = {
  objects: Array<TelephonyDomainUserCategoryInsertInput>;
  onConflict?: InputMaybe<TelephonyDomainUserCategoryOnConflict>;
};


export type telephonymutation_rootcreateDomainUserCategoryArgs = {
  object: TelephonyDomainUserCategoryInsertInput;
  onConflict?: InputMaybe<TelephonyDomainUserCategoryOnConflict>;
};


export type telephonymutation_rootcreateDomainUsersArgs = {
  objects: Array<TelephonydomainUserInsertInput>;
  onConflict?: InputMaybe<TelephonydomainUserOnConflict>;
};


export type telephonymutation_rootcreateEventArgs = {
  object: TelephonyeventInsertInput;
  onConflict?: InputMaybe<TelephonyeventOnConflict>;
};


export type telephonymutation_rootcreateEventActionArgs = {
  object: TelephonyeventActionInsertInput;
  onConflict?: InputMaybe<TelephonyeventActionOnConflict>;
};


export type telephonymutation_rootcreateEventActionsArgs = {
  objects: Array<TelephonyeventActionInsertInput>;
  onConflict?: InputMaybe<TelephonyeventActionOnConflict>;
};


export type telephonymutation_rootcreateEventsArgs = {
  objects: Array<TelephonyeventInsertInput>;
  onConflict?: InputMaybe<TelephonyeventOnConflict>;
};


export type telephonymutation_rootcreateNumberStateArgs = {
  object: TelephonyNumberStateInsertInput;
  onConflict?: InputMaybe<TelephonyNumberStateOnConflict>;
};


export type telephonymutation_rootcreateNumberStatesArgs = {
  objects: Array<TelephonyNumberStateInsertInput>;
  onConflict?: InputMaybe<TelephonyNumberStateOnConflict>;
};


export type telephonymutation_rootcreateProviderArgs = {
  object: TelephonyproviderInsertInput;
  onConflict?: InputMaybe<TelephonyproviderOnConflict>;
};


export type telephonymutation_rootcreateProviderAccountArgs = {
  object: TelephonyproviderAccountInsertInput;
  onConflict?: InputMaybe<TelephonyproviderAccountOnConflict>;
};


export type telephonymutation_rootcreateProviderAccountsArgs = {
  objects: Array<TelephonyproviderAccountInsertInput>;
  onConflict?: InputMaybe<TelephonyproviderAccountOnConflict>;
};


export type telephonymutation_rootcreateProviderIntegrationArgs = {
  integration: TelephonyProviderIntegrationInput;
};


export type telephonymutation_rootcreateProviderRequestTermArgs = {
  object: TelephonyproviderRequestTermInsertInput;
  onConflict?: InputMaybe<TelephonyproviderRequestTermOnConflict>;
};


export type telephonymutation_rootcreateProviderRequestTermsArgs = {
  objects: Array<TelephonyproviderRequestTermInsertInput>;
  onConflict?: InputMaybe<TelephonyproviderRequestTermOnConflict>;
};


export type telephonymutation_rootcreateProviderTypeArgs = {
  object: TelephonyProviderTypeInsertInput;
  onConflict?: InputMaybe<TelephonyProviderTypeOnConflict>;
};


export type telephonymutation_rootcreateProviderTypesArgs = {
  objects: Array<TelephonyProviderTypeInsertInput>;
  onConflict?: InputMaybe<TelephonyProviderTypeOnConflict>;
};


export type telephonymutation_rootcreateProvidersArgs = {
  objects: Array<TelephonyproviderInsertInput>;
  onConflict?: InputMaybe<TelephonyproviderOnConflict>;
};


export type telephonymutation_rootdeleteActiveNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type telephonymutation_rootdeleteActiveNumbersArgs = {
  where: TelephonyactiveNumbersBoolExp;
};


export type telephonymutation_rootdeleteActivitiesArgs = {
  where: TelephonyactivityBoolExp;
};


export type telephonymutation_rootdeleteActivityArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonymutation_rootdeleteActivityParticipantArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonymutation_rootdeleteActivityParticipantRoleArgs = {
  value: Scalars['String']['input'];
};


export type telephonymutation_rootdeleteActivityParticipantRolesArgs = {
  where: TelephonyActivityParticipantRoleBoolExp;
};


export type telephonymutation_rootdeleteActivityParticipantsArgs = {
  where: TelephonyactivityParticipantBoolExp;
};


export type telephonymutation_rootdeleteActivityTypeArgs = {
  value: Scalars['String']['input'];
};


export type telephonymutation_rootdeleteActivityTypesArgs = {
  where: TelephonyActivityTypeBoolExp;
};


export type telephonymutation_rootdeleteCallDirectionArgs = {
  value: Scalars['String']['input'];
};


export type telephonymutation_rootdeleteCallDirectionsArgs = {
  where: TelephonyCallDirectionBoolExp;
};


export type telephonymutation_rootdeleteCommentArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonymutation_rootdeleteCommentsArgs = {
  where: TelephonycommentBoolExp;
};


export type telephonymutation_rootdeleteDomainOrganizationArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonymutation_rootdeleteDomainOrganizationsArgs = {
  where: TelephonydomainOrganizationBoolExp;
};


export type telephonymutation_rootdeleteDomainUserArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonymutation_rootdeleteDomainUserCategoriesArgs = {
  where: TelephonyDomainUserCategoryBoolExp;
};


export type telephonymutation_rootdeleteDomainUserCategoryArgs = {
  value: Scalars['String']['input'];
};


export type telephonymutation_rootdeleteDomainUsersArgs = {
  where: TelephonydomainUserBoolExp;
};


export type telephonymutation_rootdeleteEventArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonymutation_rootdeleteEventActionArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonymutation_rootdeleteEventActionsArgs = {
  where: TelephonyeventActionBoolExp;
};


export type telephonymutation_rootdeleteEventsArgs = {
  where: TelephonyeventBoolExp;
};


export type telephonymutation_rootdeleteNumberStateArgs = {
  value: Scalars['String']['input'];
};


export type telephonymutation_rootdeleteNumberStatesArgs = {
  where: TelephonyNumberStateBoolExp;
};


export type telephonymutation_rootdeleteProviderArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonymutation_rootdeleteProviderAccountArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonymutation_rootdeleteProviderAccountsArgs = {
  where: TelephonyproviderAccountBoolExp;
};


export type telephonymutation_rootdeleteProviderRequestTermArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonymutation_rootdeleteProviderRequestTermsArgs = {
  where: TelephonyproviderRequestTermBoolExp;
};


export type telephonymutation_rootdeleteProviderTypeArgs = {
  value: Scalars['String']['input'];
};


export type telephonymutation_rootdeleteProviderTypesArgs = {
  where: TelephonyProviderTypeBoolExp;
};


export type telephonymutation_rootdeleteProvidersArgs = {
  where: TelephonyproviderBoolExp;
};


export type telephonymutation_rootdeleteTelephonyActionEventTypeArgs = {
  where: TelephonyTelephonyActionEventTypeBoolExp;
};


export type telephonymutation_rootdeleteTelephonyActionEventTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type telephonymutation_rootdeleteTelephonyActionTypeArgs = {
  where: TelephonyTelephonyActionTypeBoolExp;
};


export type telephonymutation_rootdeleteTelephonyActionTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type telephonymutation_rootdeleteTelephonyBlockedDomainUserArgs = {
  where: TelephonyTelephonyBlockedDomainUserBoolExp;
};


export type telephonymutation_rootdeleteTelephonyBlockedDomainUserByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonymutation_rootdeleteTelephonyCiscoSubscriberProductArgs = {
  where: TelephonyTelephonyCiscoSubscriberProductBoolExp;
};


export type telephonymutation_rootdeleteTelephonyCiscoSubscriberProductByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonymutation_rootdeleteTelephonyEventsArgs = {
  where: TelephonyTelephonyEventsBoolExp;
};


export type telephonymutation_rootdeleteTelephonyEventsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonymutation_rootdeleteTelephonyLookupCallerApiArgs = {
  where: TelephonyTelephonyLookupCallerApiBoolExp;
};


export type telephonymutation_rootdeleteTelephonyLookupCallerApiByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonymutation_rootdeleteTelephonyLookupRefreshArgs = {
  where: TelephonyTelephonyLookupRefreshBoolExp;
};


export type telephonymutation_rootdeleteTelephonyLookupRefreshByPkArgs = {
  type: TelephonyTelephonyLookupTypesEnum;
};


export type telephonymutation_rootdeleteTelephonyLookupTypesArgs = {
  where: TelephonyTelephonyLookupTypesBoolExp;
};


export type telephonymutation_rootdeleteTelephonyLookupTypesByPkArgs = {
  value: Scalars['String']['input'];
};


export type telephonymutation_rootdeleteTelephonyPodsArgs = {
  where: TelephonyTelephonyPodsBoolExp;
};


export type telephonymutation_rootdeleteTelephonyPodsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonymutation_rootdeleteTelephonyProviderAccessArgs = {
  where: TelephonyTelephonyProviderAccessBoolExp;
};


export type telephonymutation_rootdeleteTelephonyProviderAccessByPkArgs = {
  value: Scalars['String']['input'];
};


export type telephonymutation_roothangUpCallArgs = {
  callId: Scalars['String']['input'];
  providerClientId: Scalars['String']['input'];
};


export type telephonymutation_rootinsertTelephonyActionEventTypeArgs = {
  objects: Array<TelephonyTelephonyActionEventTypeInsertInput>;
  onConflict?: InputMaybe<TelephonyTelephonyActionEventTypeOnConflict>;
};


export type telephonymutation_rootinsertTelephonyActionEventTypeOneArgs = {
  object: TelephonyTelephonyActionEventTypeInsertInput;
  onConflict?: InputMaybe<TelephonyTelephonyActionEventTypeOnConflict>;
};


export type telephonymutation_rootinsertTelephonyActionTypeArgs = {
  objects: Array<TelephonyTelephonyActionTypeInsertInput>;
  onConflict?: InputMaybe<TelephonyTelephonyActionTypeOnConflict>;
};


export type telephonymutation_rootinsertTelephonyActionTypeOneArgs = {
  object: TelephonyTelephonyActionTypeInsertInput;
  onConflict?: InputMaybe<TelephonyTelephonyActionTypeOnConflict>;
};


export type telephonymutation_rootinsertTelephonyBlockedDomainUserArgs = {
  objects: Array<TelephonyTelephonyBlockedDomainUserInsertInput>;
  onConflict?: InputMaybe<TelephonyTelephonyBlockedDomainUserOnConflict>;
};


export type telephonymutation_rootinsertTelephonyBlockedDomainUserOneArgs = {
  object: TelephonyTelephonyBlockedDomainUserInsertInput;
  onConflict?: InputMaybe<TelephonyTelephonyBlockedDomainUserOnConflict>;
};


export type telephonymutation_rootinsertTelephonyCiscoSubscriberProductArgs = {
  objects: Array<TelephonyTelephonyCiscoSubscriberProductInsertInput>;
  onConflict?: InputMaybe<TelephonyTelephonyCiscoSubscriberProductOnConflict>;
};


export type telephonymutation_rootinsertTelephonyCiscoSubscriberProductOneArgs = {
  object: TelephonyTelephonyCiscoSubscriberProductInsertInput;
  onConflict?: InputMaybe<TelephonyTelephonyCiscoSubscriberProductOnConflict>;
};


export type telephonymutation_rootinsertTelephonyEventsArgs = {
  objects: Array<TelephonyTelephonyEventsInsertInput>;
  onConflict?: InputMaybe<TelephonyTelephonyEventsOnConflict>;
};


export type telephonymutation_rootinsertTelephonyEventsOneArgs = {
  object: TelephonyTelephonyEventsInsertInput;
  onConflict?: InputMaybe<TelephonyTelephonyEventsOnConflict>;
};


export type telephonymutation_rootinsertTelephonyLookupCallerApiArgs = {
  objects: Array<TelephonyTelephonyLookupCallerApiInsertInput>;
  onConflict?: InputMaybe<TelephonyTelephonyLookupCallerApiOnConflict>;
};


export type telephonymutation_rootinsertTelephonyLookupCallerApiOneArgs = {
  object: TelephonyTelephonyLookupCallerApiInsertInput;
  onConflict?: InputMaybe<TelephonyTelephonyLookupCallerApiOnConflict>;
};


export type telephonymutation_rootinsertTelephonyLookupRefreshArgs = {
  objects: Array<TelephonyTelephonyLookupRefreshInsertInput>;
  onConflict?: InputMaybe<TelephonyTelephonyLookupRefreshOnConflict>;
};


export type telephonymutation_rootinsertTelephonyLookupRefreshOneArgs = {
  object: TelephonyTelephonyLookupRefreshInsertInput;
  onConflict?: InputMaybe<TelephonyTelephonyLookupRefreshOnConflict>;
};


export type telephonymutation_rootinsertTelephonyLookupTypesArgs = {
  objects: Array<TelephonyTelephonyLookupTypesInsertInput>;
  onConflict?: InputMaybe<TelephonyTelephonyLookupTypesOnConflict>;
};


export type telephonymutation_rootinsertTelephonyLookupTypesOneArgs = {
  object: TelephonyTelephonyLookupTypesInsertInput;
  onConflict?: InputMaybe<TelephonyTelephonyLookupTypesOnConflict>;
};


export type telephonymutation_rootinsertTelephonyPodsArgs = {
  objects: Array<TelephonyTelephonyPodsInsertInput>;
  onConflict?: InputMaybe<TelephonyTelephonyPodsOnConflict>;
};


export type telephonymutation_rootinsertTelephonyPodsOneArgs = {
  object: TelephonyTelephonyPodsInsertInput;
  onConflict?: InputMaybe<TelephonyTelephonyPodsOnConflict>;
};


export type telephonymutation_rootinsertTelephonyProviderAccessArgs = {
  objects: Array<TelephonyTelephonyProviderAccessInsertInput>;
  onConflict?: InputMaybe<TelephonyTelephonyProviderAccessOnConflict>;
};


export type telephonymutation_rootinsertTelephonyProviderAccessOneArgs = {
  object: TelephonyTelephonyProviderAccessInsertInput;
  onConflict?: InputMaybe<TelephonyTelephonyProviderAccessOnConflict>;
};


export type telephonymutation_rootmakePhoneRequestArgs = {
  request: TelephonyPhoneRequestInput;
};


export type telephonymutation_rootsendSMSArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['String']['input']>;
  platformPartnerId?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  useDeliveryReport?: InputMaybe<Scalars['Boolean']['input']>;
};


export type telephonymutation_rootsynchronizeDomainUsersArgs = {
  params: TelephonySynchronizeDomainUsersInput;
};


export type telephonymutation_roottriggerTestCallArgs = {
  callId?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  receiverId: Scalars['String']['input'];
  receiverNr: Scalars['String']['input'];
  senderId: Scalars['String']['input'];
  senderNr: Scalars['String']['input'];
};


export type telephonymutation_rootupdateActiveNumberArgs = {
  _set?: InputMaybe<TelephonyactiveNumbersSetInput>;
  pkColumns: TelephonyactiveNumbersPkColumnsInput;
};


export type telephonymutation_rootupdateActiveNumbersArgs = {
  _set?: InputMaybe<TelephonyactiveNumbersSetInput>;
  where: TelephonyactiveNumbersBoolExp;
};


export type telephonymutation_rootupdateActivitiesArgs = {
  _inc?: InputMaybe<TelephonyactivityIncInput>;
  _set?: InputMaybe<TelephonyactivitySetInput>;
  where: TelephonyactivityBoolExp;
};


export type telephonymutation_rootupdateActivityArgs = {
  _inc?: InputMaybe<TelephonyactivityIncInput>;
  _set?: InputMaybe<TelephonyactivitySetInput>;
  pkColumns: TelephonyactivityPkColumnsInput;
};


export type telephonymutation_rootupdateActivityParticipantArgs = {
  _set?: InputMaybe<TelephonyactivityParticipantSetInput>;
  pkColumns: TelephonyactivityParticipantPkColumnsInput;
};


export type telephonymutation_rootupdateActivityParticipantRoleArgs = {
  _set?: InputMaybe<TelephonyActivityParticipantRoleSetInput>;
  pkColumns: TelephonyActivityParticipantRolePkColumnsInput;
};


export type telephonymutation_rootupdateActivityParticipantRolesArgs = {
  _set?: InputMaybe<TelephonyActivityParticipantRoleSetInput>;
  where: TelephonyActivityParticipantRoleBoolExp;
};


export type telephonymutation_rootupdateActivityParticipantsArgs = {
  _set?: InputMaybe<TelephonyactivityParticipantSetInput>;
  where: TelephonyactivityParticipantBoolExp;
};


export type telephonymutation_rootupdateActivityTypeArgs = {
  _set?: InputMaybe<TelephonyActivityTypeSetInput>;
  pkColumns: TelephonyActivityTypePkColumnsInput;
};


export type telephonymutation_rootupdateActivityTypesArgs = {
  _set?: InputMaybe<TelephonyActivityTypeSetInput>;
  where: TelephonyActivityTypeBoolExp;
};


export type telephonymutation_rootupdateCallDirectionArgs = {
  _set?: InputMaybe<TelephonyCallDirectionSetInput>;
  pkColumns: TelephonyCallDirectionPkColumnsInput;
};


export type telephonymutation_rootupdateCallDirectionsArgs = {
  _set?: InputMaybe<TelephonyCallDirectionSetInput>;
  where: TelephonyCallDirectionBoolExp;
};


export type telephonymutation_rootupdateCommentArgs = {
  _set?: InputMaybe<TelephonycommentSetInput>;
  pkColumns: TelephonycommentPkColumnsInput;
};


export type telephonymutation_rootupdateCommentsArgs = {
  _set?: InputMaybe<TelephonycommentSetInput>;
  where: TelephonycommentBoolExp;
};


export type telephonymutation_rootupdateDomainOrganizationArgs = {
  _set?: InputMaybe<TelephonydomainOrganizationSetInput>;
  pkColumns: TelephonydomainOrganizationPkColumnsInput;
};


export type telephonymutation_rootupdateDomainOrganizationsArgs = {
  _set?: InputMaybe<TelephonydomainOrganizationSetInput>;
  where: TelephonydomainOrganizationBoolExp;
};


export type telephonymutation_rootupdateDomainUserArgs = {
  _append?: InputMaybe<TelephonydomainUserAppendInput>;
  _deleteAtPath?: InputMaybe<TelephonydomainUserDeleteAtPathInput>;
  _deleteElem?: InputMaybe<TelephonydomainUserDeleteElemInput>;
  _deleteKey?: InputMaybe<TelephonydomainUserDeleteKeyInput>;
  _inc?: InputMaybe<TelephonydomainUserIncInput>;
  _prepend?: InputMaybe<TelephonydomainUserPrependInput>;
  _set?: InputMaybe<TelephonydomainUserSetInput>;
  pkColumns: TelephonydomainUserPkColumnsInput;
};


export type telephonymutation_rootupdateDomainUserCategoriesArgs = {
  _set?: InputMaybe<TelephonyDomainUserCategorySetInput>;
  where: TelephonyDomainUserCategoryBoolExp;
};


export type telephonymutation_rootupdateDomainUserCategoryArgs = {
  _set?: InputMaybe<TelephonyDomainUserCategorySetInput>;
  pkColumns: TelephonyDomainUserCategoryPkColumnsInput;
};


export type telephonymutation_rootupdateDomainUsersArgs = {
  _append?: InputMaybe<TelephonydomainUserAppendInput>;
  _deleteAtPath?: InputMaybe<TelephonydomainUserDeleteAtPathInput>;
  _deleteElem?: InputMaybe<TelephonydomainUserDeleteElemInput>;
  _deleteKey?: InputMaybe<TelephonydomainUserDeleteKeyInput>;
  _inc?: InputMaybe<TelephonydomainUserIncInput>;
  _prepend?: InputMaybe<TelephonydomainUserPrependInput>;
  _set?: InputMaybe<TelephonydomainUserSetInput>;
  where: TelephonydomainUserBoolExp;
};


export type telephonymutation_rootupdateEventArgs = {
  _inc?: InputMaybe<TelephonyeventIncInput>;
  _set?: InputMaybe<TelephonyeventSetInput>;
  pkColumns: TelephonyeventPkColumnsInput;
};


export type telephonymutation_rootupdateEventActionArgs = {
  _set?: InputMaybe<TelephonyeventActionSetInput>;
  pkColumns: TelephonyeventActionPkColumnsInput;
};


export type telephonymutation_rootupdateEventActionManyArgs = {
  updates: Array<TelephonyeventActionUpdates>;
};


export type telephonymutation_rootupdateEventActionsArgs = {
  _set?: InputMaybe<TelephonyeventActionSetInput>;
  where: TelephonyeventActionBoolExp;
};


export type telephonymutation_rootupdateEventsArgs = {
  _inc?: InputMaybe<TelephonyeventIncInput>;
  _set?: InputMaybe<TelephonyeventSetInput>;
  where: TelephonyeventBoolExp;
};


export type telephonymutation_rootupdateManyActiveNumbersArgs = {
  updates: Array<TelephonyactiveNumbersUpdates>;
};


export type telephonymutation_rootupdateManyActivitiesArgs = {
  updates: Array<TelephonyactivityUpdates>;
};


export type telephonymutation_rootupdateManyActivityParticipantRolesArgs = {
  updates: Array<TelephonyActivityParticipantRoleUpdates>;
};


export type telephonymutation_rootupdateManyActivityParticipantsArgs = {
  updates: Array<TelephonyactivityParticipantUpdates>;
};


export type telephonymutation_rootupdateManyActivityTypesArgs = {
  updates: Array<TaskActivityTypeUpdates>;
};


export type telephonymutation_rootupdateManyCallDirectionsArgs = {
  updates: Array<TelephonyCallDirectionUpdates>;
};


export type telephonymutation_rootupdateManyCommentsArgs = {
  updates: Array<TelephonycommentUpdates>;
};


export type telephonymutation_rootupdateManyDomainOrganizationsArgs = {
  updates: Array<TelephonydomainOrganizationUpdates>;
};


export type telephonymutation_rootupdateManyDomainUserCategoriesArgs = {
  updates: Array<TaskDomainUserCategoryUpdates>;
};


export type telephonymutation_rootupdateManyDomainUsersArgs = {
  updates: Array<TelephonydomainUserUpdates>;
};


export type telephonymutation_rootupdateManyEventsArgs = {
  updates: Array<TelephonyeventUpdates>;
};


export type telephonymutation_rootupdateManyNumberStatesArgs = {
  updates: Array<TelephonyNumberStateUpdates>;
};


export type telephonymutation_rootupdateManyProviderAccountArgs = {
  updates: Array<TelephonyproviderAccountUpdates>;
};


export type telephonymutation_rootupdateManyProviderRequestTermsArgs = {
  updates: Array<TelephonyproviderRequestTermUpdates>;
};


export type telephonymutation_rootupdateManyProviderTypesArgs = {
  updates: Array<TelephonyProviderTypeUpdates>;
};


export type telephonymutation_rootupdateNumberStateArgs = {
  _set?: InputMaybe<TelephonyNumberStateSetInput>;
  pkColumns: TelephonyNumberStatePkColumnsInput;
};


export type telephonymutation_rootupdateNumberStatesArgs = {
  _set?: InputMaybe<TelephonyNumberStateSetInput>;
  where: TelephonyNumberStateBoolExp;
};


export type telephonymutation_rootupdateProviderArgs = {
  _set?: InputMaybe<TelephonyproviderSetInput>;
  pkColumns: TelephonyproviderPkColumnsInput;
};


export type telephonymutation_rootupdateProviderAccountArgs = {
  _set?: InputMaybe<TelephonyproviderAccountSetInput>;
  pkColumns: TelephonyproviderAccountPkColumnsInput;
};


export type telephonymutation_rootupdateProviderAccountsArgs = {
  _set?: InputMaybe<TelephonyproviderAccountSetInput>;
  where: TelephonyproviderAccountBoolExp;
};


export type telephonymutation_rootupdateProviderManyArgs = {
  updates: Array<TelephonyproviderUpdates>;
};


export type telephonymutation_rootupdateProviderRequestTermArgs = {
  _inc?: InputMaybe<TelephonyproviderRequestTermIncInput>;
  _set?: InputMaybe<TelephonyproviderRequestTermSetInput>;
  pkColumns: TelephonyproviderRequestTermPkColumnsInput;
};


export type telephonymutation_rootupdateProviderRequestTermsArgs = {
  _inc?: InputMaybe<TelephonyproviderRequestTermIncInput>;
  _set?: InputMaybe<TelephonyproviderRequestTermSetInput>;
  where: TelephonyproviderRequestTermBoolExp;
};


export type telephonymutation_rootupdateProviderTypeArgs = {
  _set?: InputMaybe<TelephonyProviderTypeSetInput>;
  pkColumns: TelephonyProviderTypePkColumnsInput;
};


export type telephonymutation_rootupdateProviderTypesArgs = {
  _set?: InputMaybe<TelephonyProviderTypeSetInput>;
  where: TelephonyProviderTypeBoolExp;
};


export type telephonymutation_rootupdateProvidersArgs = {
  _set?: InputMaybe<TelephonyproviderSetInput>;
  where: TelephonyproviderBoolExp;
};


export type telephonymutation_rootupdateTelephonyActionEventTypeArgs = {
  _set?: InputMaybe<TelephonyTelephonyActionEventTypeSetInput>;
  where: TelephonyTelephonyActionEventTypeBoolExp;
};


export type telephonymutation_rootupdateTelephonyActionEventTypeByPkArgs = {
  _set?: InputMaybe<TelephonyTelephonyActionEventTypeSetInput>;
  pkColumns: TelephonyTelephonyActionEventTypePkColumnsInput;
};


export type telephonymutation_rootupdateTelephonyActionEventTypeManyArgs = {
  updates: Array<TelephonyTelephonyActionEventTypeUpdates>;
};


export type telephonymutation_rootupdateTelephonyActionTypeArgs = {
  _set?: InputMaybe<TelephonyTelephonyActionTypeSetInput>;
  where: TelephonyTelephonyActionTypeBoolExp;
};


export type telephonymutation_rootupdateTelephonyActionTypeByPkArgs = {
  _set?: InputMaybe<TelephonyTelephonyActionTypeSetInput>;
  pkColumns: TelephonyTelephonyActionTypePkColumnsInput;
};


export type telephonymutation_rootupdateTelephonyActionTypeManyArgs = {
  updates: Array<TelephonyTelephonyActionTypeUpdates>;
};


export type telephonymutation_rootupdateTelephonyBlockedDomainUserArgs = {
  _set?: InputMaybe<TelephonyTelephonyBlockedDomainUserSetInput>;
  where: TelephonyTelephonyBlockedDomainUserBoolExp;
};


export type telephonymutation_rootupdateTelephonyBlockedDomainUserByPkArgs = {
  _set?: InputMaybe<TelephonyTelephonyBlockedDomainUserSetInput>;
  pkColumns: TelephonyTelephonyBlockedDomainUserPkColumnsInput;
};


export type telephonymutation_rootupdateTelephonyBlockedDomainUserManyArgs = {
  updates: Array<TelephonyTelephonyBlockedDomainUserUpdates>;
};


export type telephonymutation_rootupdateTelephonyCiscoSubscriberProductArgs = {
  _set?: InputMaybe<TelephonyTelephonyCiscoSubscriberProductSetInput>;
  where: TelephonyTelephonyCiscoSubscriberProductBoolExp;
};


export type telephonymutation_rootupdateTelephonyCiscoSubscriberProductByPkArgs = {
  _set?: InputMaybe<TelephonyTelephonyCiscoSubscriberProductSetInput>;
  pkColumns: TelephonyTelephonyCiscoSubscriberProductPkColumnsInput;
};


export type telephonymutation_rootupdateTelephonyCiscoSubscriberProductManyArgs = {
  updates: Array<TelephonyTelephonyCiscoSubscriberProductUpdates>;
};


export type telephonymutation_rootupdateTelephonyEventsArgs = {
  _set?: InputMaybe<TelephonyTelephonyEventsSetInput>;
  where: TelephonyTelephonyEventsBoolExp;
};


export type telephonymutation_rootupdateTelephonyEventsByPkArgs = {
  _set?: InputMaybe<TelephonyTelephonyEventsSetInput>;
  pkColumns: TelephonyTelephonyEventsPkColumnsInput;
};


export type telephonymutation_rootupdateTelephonyEventsManyArgs = {
  updates: Array<TelephonyTelephonyEventsUpdates>;
};


export type telephonymutation_rootupdateTelephonyLookupCallerApiArgs = {
  _append?: InputMaybe<TelephonyTelephonyLookupCallerApiAppendInput>;
  _deleteAtPath?: InputMaybe<TelephonyTelephonyLookupCallerApiDeleteAtPathInput>;
  _deleteElem?: InputMaybe<TelephonyTelephonyLookupCallerApiDeleteElemInput>;
  _deleteKey?: InputMaybe<TelephonyTelephonyLookupCallerApiDeleteKeyInput>;
  _prepend?: InputMaybe<TelephonyTelephonyLookupCallerApiPrependInput>;
  _set?: InputMaybe<TelephonyTelephonyLookupCallerApiSetInput>;
  where: TelephonyTelephonyLookupCallerApiBoolExp;
};


export type telephonymutation_rootupdateTelephonyLookupCallerApiByPkArgs = {
  _append?: InputMaybe<TelephonyTelephonyLookupCallerApiAppendInput>;
  _deleteAtPath?: InputMaybe<TelephonyTelephonyLookupCallerApiDeleteAtPathInput>;
  _deleteElem?: InputMaybe<TelephonyTelephonyLookupCallerApiDeleteElemInput>;
  _deleteKey?: InputMaybe<TelephonyTelephonyLookupCallerApiDeleteKeyInput>;
  _prepend?: InputMaybe<TelephonyTelephonyLookupCallerApiPrependInput>;
  _set?: InputMaybe<TelephonyTelephonyLookupCallerApiSetInput>;
  pkColumns: TelephonyTelephonyLookupCallerApiPkColumnsInput;
};


export type telephonymutation_rootupdateTelephonyLookupCallerApiManyArgs = {
  updates: Array<TelephonyTelephonyLookupCallerApiUpdates>;
};


export type telephonymutation_rootupdateTelephonyLookupRefreshArgs = {
  _inc?: InputMaybe<TelephonyTelephonyLookupRefreshIncInput>;
  _set?: InputMaybe<TelephonyTelephonyLookupRefreshSetInput>;
  where: TelephonyTelephonyLookupRefreshBoolExp;
};


export type telephonymutation_rootupdateTelephonyLookupRefreshByPkArgs = {
  _inc?: InputMaybe<TelephonyTelephonyLookupRefreshIncInput>;
  _set?: InputMaybe<TelephonyTelephonyLookupRefreshSetInput>;
  pkColumns: TelephonyTelephonyLookupRefreshPkColumnsInput;
};


export type telephonymutation_rootupdateTelephonyLookupRefreshManyArgs = {
  updates: Array<TelephonyTelephonyLookupRefreshUpdates>;
};


export type telephonymutation_rootupdateTelephonyLookupTypesArgs = {
  _set?: InputMaybe<TelephonyTelephonyLookupTypesSetInput>;
  where: TelephonyTelephonyLookupTypesBoolExp;
};


export type telephonymutation_rootupdateTelephonyLookupTypesByPkArgs = {
  _set?: InputMaybe<TelephonyTelephonyLookupTypesSetInput>;
  pkColumns: TelephonyTelephonyLookupTypesPkColumnsInput;
};


export type telephonymutation_rootupdateTelephonyLookupTypesManyArgs = {
  updates: Array<TelephonyTelephonyLookupTypesUpdates>;
};


export type telephonymutation_rootupdateTelephonyPodsArgs = {
  _set?: InputMaybe<TelephonyTelephonyPodsSetInput>;
  where: TelephonyTelephonyPodsBoolExp;
};


export type telephonymutation_rootupdateTelephonyPodsByPkArgs = {
  _set?: InputMaybe<TelephonyTelephonyPodsSetInput>;
  pkColumns: TelephonyTelephonyPodsPkColumnsInput;
};


export type telephonymutation_rootupdateTelephonyPodsManyArgs = {
  updates: Array<TelephonyTelephonyPodsUpdates>;
};


export type telephonymutation_rootupdateTelephonyProviderAccessArgs = {
  _set?: InputMaybe<TelephonyTelephonyProviderAccessSetInput>;
  where: TelephonyTelephonyProviderAccessBoolExp;
};


export type telephonymutation_rootupdateTelephonyProviderAccessByPkArgs = {
  _set?: InputMaybe<TelephonyTelephonyProviderAccessSetInput>;
  pkColumns: TelephonyTelephonyProviderAccessPkColumnsInput;
};


export type telephonymutation_rootupdateTelephonyProviderAccessManyArgs = {
  updates: Array<TelephonyTelephonyProviderAccessUpdates>;
};

export type telephonyquery_root = {
  __typename?: 'telephonyquery_root';
  /** fetch data from the table: "telephony.active_numbers" using primary key columns */
  activeNumber?: Maybe<TelephonyactiveNumbers>;
  /** fetch data from the table: "telephony.active_numbers" */
  activeNumbers: Array<TelephonyactiveNumbers>;
  /** fetch aggregated fields from the table: "telephony.active_numbers" */
  activeNumbersAggregate: TelephonyactiveNumbersAggregate;
  /** An array relationship */
  activities: Array<Telephonyactivity>;
  /** An aggregate relationship */
  activitiesAggregate: TelephonyactivityAggregate;
  /** fetch data from the table: "telephony.activity" using primary key columns */
  activity?: Maybe<Telephonyactivity>;
  /** fetch data from the table: "telephony.activity_participant" using primary key columns */
  activityParticipant?: Maybe<TelephonyactivityParticipant>;
  /** fetch data from the table: "telephony.activity_participant_role" using primary key columns */
  activityParticipantRole?: Maybe<TelephonyActivityParticipantRole>;
  /** fetch data from the table: "telephony.activity_participant_role" */
  activityParticipantRoles: Array<TelephonyActivityParticipantRole>;
  /** fetch aggregated fields from the table: "telephony.activity_participant_role" */
  activityParticipantRolesAggregate: TelephonyActivityParticipantRoleAggregate;
  /** An array relationship */
  activityParticipants: Array<TelephonyactivityParticipant>;
  /** An aggregate relationship */
  activityParticipantsAggregate: TelephonyactivityParticipantAggregate;
  /** fetch data from the table: "telephony.activity_type" using primary key columns */
  activityType?: Maybe<TelephonyActivityType>;
  /** fetch data from the table: "telephony.activity_type" */
  activityTypes: Array<TelephonyActivityType>;
  /** fetch aggregated fields from the table: "telephony.activity_type" */
  activityTypesAggregate: TelephonyActivityTypeAggregate;
  /** fetch data from the table: "telephony.call_direction" using primary key columns */
  callDirection?: Maybe<TelephonyCallDirection>;
  /** fetch data from the table: "telephony.call_direction" */
  callDirections: Array<TelephonyCallDirection>;
  /** fetch aggregated fields from the table: "telephony.call_direction" */
  callDirectionsAggregate: TelephonyCallDirectionAggregate;
  callResult?: Maybe<TelephonyCallResultOutput>;
  /** fetch data from the table: "telephony.comment" using primary key columns */
  comment?: Maybe<Telephonycomment>;
  /** An array relationship */
  comments: Array<Telephonycomment>;
  /** An aggregate relationship */
  commentsAggregate: TelephonycommentAggregate;
  /** fetch data from the table: "telephony.domain_organization" using primary key columns */
  domainOrganization?: Maybe<TelephonydomainOrganization>;
  /** An array relationship */
  domainOrganizations: Array<TelephonydomainOrganization>;
  /** An aggregate relationship */
  domainOrganizationsAggregate: TelephonydomainOrganizationAggregate;
  /** fetch data from the table: "telephony.domain_user" using primary key columns */
  domainUser?: Maybe<TelephonydomainUser>;
  /** fetch data from the table: "telephony.domain_user_category" */
  domainUserCategories: Array<TelephonyDomainUserCategory>;
  /** fetch aggregated fields from the table: "telephony.domain_user_category" */
  domainUserCategoriesAggregate: TelephonyDomainUserCategoryAggregate;
  /** fetch data from the table: "telephony.domain_user_category" using primary key columns */
  domainUserCategory?: Maybe<TelephonyDomainUserCategory>;
  /** An array relationship */
  domainUsers: Array<TelephonydomainUser>;
  /** An aggregate relationship */
  domainUsersAggregate: TelephonydomainUserAggregate;
  /** fetch data from the table: "telephony.event_to_be_deleted_in_may_2024" using primary key columns */
  event?: Maybe<Telephonyevent>;
  /** fetch aggregated fields from the table: "telephony.event_action" */
  eventActionAggregate: TelephonyeventActionAggregate;
  /** fetch data from the table: "telephony.event_action" using primary key columns */
  eventActionByPk?: Maybe<TelephonyeventAction>;
  /** fetch data from the table: "telephony.event_action" */
  eventActions: Array<TelephonyeventAction>;
  /** An array relationship */
  events: Array<Telephonyevent>;
  /** An aggregate relationship */
  eventsAggregate: TelephonyeventAggregate;
  lookupPhoneNumber?: Maybe<TelephonyLookupPhoneNumberOutput>;
  /** fetch data from the table: "telephony.number_state" using primary key columns */
  numberState?: Maybe<TelephonyNumberState>;
  /** fetch data from the table: "telephony.number_state" */
  numberStates: Array<TelephonyNumberState>;
  /** fetch aggregated fields from the table: "telephony.number_state" */
  numberStatesAggregate: TelephonyNumberStateAggregate;
  /** fetch data from the table: "telephony.provider" using primary key columns */
  provider?: Maybe<Telephonyprovider>;
  /** fetch data from the table: "telephony.provider_account" using primary key columns */
  providerAccount?: Maybe<TelephonyproviderAccount>;
  /** An array relationship */
  providerAccounts: Array<TelephonyproviderAccount>;
  /** An aggregate relationship */
  providerAccountsAggregate: TelephonyproviderAccountAggregate;
  /** fetch aggregated fields from the table: "telephony.provider" */
  providerAggregate: TelephonyproviderAggregate;
  /** fetch data from the table: "telephony.provider_request_terms" using primary key columns */
  providerRequestTerm?: Maybe<TelephonyproviderRequestTerm>;
  /** fetch data from the table: "telephony.provider_request_terms" */
  providerRequestTerms: Array<TelephonyproviderRequestTerm>;
  /** fetch aggregated fields from the table: "telephony.provider_request_terms" */
  providerRequestTermsAggregate: TelephonyproviderRequestTermAggregate;
  /** fetch data from the table: "telephony.provider_type" using primary key columns */
  providerType?: Maybe<TelephonyProviderType>;
  /** fetch data from the table: "telephony.provider_type" */
  providerTypes: Array<TelephonyProviderType>;
  /** fetch aggregated fields from the table: "telephony.provider_type" */
  providerTypesAggregate: TelephonyProviderTypeAggregate;
  /** fetch data from the table: "telephony.provider" */
  providers: Array<Telephonyprovider>;
  /** fetch data from the table: "telephony.action_event_type" */
  telephonyActionEventType: Array<TelephonyTelephonyActionEventType>;
  /** fetch aggregated fields from the table: "telephony.action_event_type" */
  telephonyActionEventTypeAggregate: TelephonyTelephonyActionEventTypeAggregate;
  /** fetch data from the table: "telephony.action_event_type" using primary key columns */
  telephonyActionEventTypeByPk?: Maybe<TelephonyTelephonyActionEventType>;
  /** fetch data from the table: "telephony.action_type" */
  telephonyActionType: Array<TelephonyTelephonyActionType>;
  /** fetch aggregated fields from the table: "telephony.action_type" */
  telephonyActionTypeAggregate: TelephonyTelephonyActionTypeAggregate;
  /** fetch data from the table: "telephony.action_type" using primary key columns */
  telephonyActionTypeByPk?: Maybe<TelephonyTelephonyActionType>;
  /** fetch data from the table: "telephony.blocked_domain_user" */
  telephonyBlockedDomainUser: Array<TelephonyTelephonyBlockedDomainUser>;
  /** fetch aggregated fields from the table: "telephony.blocked_domain_user" */
  telephonyBlockedDomainUserAggregate: TelephonyTelephonyBlockedDomainUserAggregate;
  /** fetch data from the table: "telephony.blocked_domain_user" using primary key columns */
  telephonyBlockedDomainUserByPk?: Maybe<TelephonyTelephonyBlockedDomainUser>;
  /** fetch data from the table: "telephony.cisco_subscriber_product" */
  telephonyCiscoSubscriberProduct: Array<TelephonyTelephonyCiscoSubscriberProduct>;
  /** fetch aggregated fields from the table: "telephony.cisco_subscriber_product" */
  telephonyCiscoSubscriberProductAggregate: TelephonyTelephonyCiscoSubscriberProductAggregate;
  /** fetch data from the table: "telephony.cisco_subscriber_product" using primary key columns */
  telephonyCiscoSubscriberProductByPk?: Maybe<TelephonyTelephonyCiscoSubscriberProduct>;
  /** fetch data from the table: "telephony.events" */
  telephonyEvents: Array<TelephonyTelephonyEvents>;
  /** fetch aggregated fields from the table: "telephony.events" */
  telephonyEventsAggregate: TelephonyTelephonyEventsAggregate;
  /** fetch data from the table: "telephony.events" using primary key columns */
  telephonyEventsByPk?: Maybe<TelephonyTelephonyEvents>;
  /** fetch data from the table: "telephony.lookup_caller_api" */
  telephonyLookupCallerApi: Array<TelephonyTelephonyLookupCallerApi>;
  /** fetch aggregated fields from the table: "telephony.lookup_caller_api" */
  telephonyLookupCallerApiAggregate: TelephonyTelephonyLookupCallerApiAggregate;
  /** fetch data from the table: "telephony.lookup_caller_api" using primary key columns */
  telephonyLookupCallerApiByPk?: Maybe<TelephonyTelephonyLookupCallerApi>;
  /** fetch data from the table: "telephony.lookup_refresh" */
  telephonyLookupRefresh: Array<TelephonyTelephonyLookupRefresh>;
  /** fetch aggregated fields from the table: "telephony.lookup_refresh" */
  telephonyLookupRefreshAggregate: TelephonyTelephonyLookupRefreshAggregate;
  /** fetch data from the table: "telephony.lookup_refresh" using primary key columns */
  telephonyLookupRefreshByPk?: Maybe<TelephonyTelephonyLookupRefresh>;
  /** fetch data from the table: "telephony.lookup_types" */
  telephonyLookupTypes: Array<TelephonyTelephonyLookupTypes>;
  /** fetch aggregated fields from the table: "telephony.lookup_types" */
  telephonyLookupTypesAggregate: TelephonyTelephonyLookupTypesAggregate;
  /** fetch data from the table: "telephony.lookup_types" using primary key columns */
  telephonyLookupTypesByPk?: Maybe<TelephonyTelephonyLookupTypes>;
  /** fetch data from the table: "telephony.pods" */
  telephonyPods: Array<TelephonyTelephonyPods>;
  /** fetch aggregated fields from the table: "telephony.pods" */
  telephonyPodsAggregate: TelephonyTelephonyPodsAggregate;
  /** fetch data from the table: "telephony.pods" using primary key columns */
  telephonyPodsByPk?: Maybe<TelephonyTelephonyPods>;
  /** fetch data from the table: "telephony.provider_access" */
  telephonyProviderAccess: Array<TelephonyTelephonyProviderAccess>;
  /** fetch aggregated fields from the table: "telephony.provider_access" */
  telephonyProviderAccessAggregate: TelephonyTelephonyProviderAccessAggregate;
  /** fetch data from the table: "telephony.provider_access" using primary key columns */
  telephonyProviderAccessByPk?: Maybe<TelephonyTelephonyProviderAccess>;
};


export type telephonyquery_rootactiveNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type telephonyquery_rootactiveNumbersArgs = {
  distinctOn?: InputMaybe<Array<TelephonyactiveNumbersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyactiveNumbersOrderBy>>;
  where?: InputMaybe<TelephonyactiveNumbersBoolExp>;
};


export type telephonyquery_rootactiveNumbersAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyactiveNumbersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyactiveNumbersOrderBy>>;
  where?: InputMaybe<TelephonyactiveNumbersBoolExp>;
};


export type telephonyquery_rootactivitiesArgs = {
  distinctOn?: InputMaybe<Array<TelephonyactivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyactivityOrderBy>>;
  where?: InputMaybe<TelephonyactivityBoolExp>;
};


export type telephonyquery_rootactivitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyactivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyactivityOrderBy>>;
  where?: InputMaybe<TelephonyactivityBoolExp>;
};


export type telephonyquery_rootactivityArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonyquery_rootactivityParticipantArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonyquery_rootactivityParticipantRoleArgs = {
  value: Scalars['String']['input'];
};


export type telephonyquery_rootactivityParticipantRolesArgs = {
  distinctOn?: InputMaybe<Array<TelephonyActivityParticipantRoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyActivityParticipantRoleOrderBy>>;
  where?: InputMaybe<TelephonyActivityParticipantRoleBoolExp>;
};


export type telephonyquery_rootactivityParticipantRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyActivityParticipantRoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyActivityParticipantRoleOrderBy>>;
  where?: InputMaybe<TelephonyActivityParticipantRoleBoolExp>;
};


export type telephonyquery_rootactivityParticipantsArgs = {
  distinctOn?: InputMaybe<Array<TelephonyactivityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyactivityParticipantOrderBy>>;
  where?: InputMaybe<TelephonyactivityParticipantBoolExp>;
};


export type telephonyquery_rootactivityParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyactivityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyactivityParticipantOrderBy>>;
  where?: InputMaybe<TelephonyactivityParticipantBoolExp>;
};


export type telephonyquery_rootactivityTypeArgs = {
  value: Scalars['String']['input'];
};


export type telephonyquery_rootactivityTypesArgs = {
  distinctOn?: InputMaybe<Array<TelephonyActivityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyActivityTypeOrderBy>>;
  where?: InputMaybe<TelephonyActivityTypeBoolExp>;
};


export type telephonyquery_rootactivityTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyActivityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyActivityTypeOrderBy>>;
  where?: InputMaybe<TelephonyActivityTypeBoolExp>;
};


export type telephonyquery_rootcallDirectionArgs = {
  value: Scalars['String']['input'];
};


export type telephonyquery_rootcallDirectionsArgs = {
  distinctOn?: InputMaybe<Array<TelephonyCallDirectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyCallDirectionOrderBy>>;
  where?: InputMaybe<TelephonyCallDirectionBoolExp>;
};


export type telephonyquery_rootcallDirectionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyCallDirectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyCallDirectionOrderBy>>;
  where?: InputMaybe<TelephonyCallDirectionBoolExp>;
};


export type telephonyquery_rootcallResultArgs = {
  call: TelephonyCallResultInput;
};


export type telephonyquery_rootcommentArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonyquery_rootcommentsArgs = {
  distinctOn?: InputMaybe<Array<TelephonycommentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonycommentOrderBy>>;
  where?: InputMaybe<TelephonycommentBoolExp>;
};


export type telephonyquery_rootcommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonycommentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonycommentOrderBy>>;
  where?: InputMaybe<TelephonycommentBoolExp>;
};


export type telephonyquery_rootdomainOrganizationArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonyquery_rootdomainOrganizationsArgs = {
  distinctOn?: InputMaybe<Array<TelephonydomainOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonydomainOrganizationOrderBy>>;
  where?: InputMaybe<TelephonydomainOrganizationBoolExp>;
};


export type telephonyquery_rootdomainOrganizationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonydomainOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonydomainOrganizationOrderBy>>;
  where?: InputMaybe<TelephonydomainOrganizationBoolExp>;
};


export type telephonyquery_rootdomainUserArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonyquery_rootdomainUserCategoriesArgs = {
  distinctOn?: InputMaybe<Array<TelephonyDomainUserCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyDomainUserCategoryOrderBy>>;
  where?: InputMaybe<TelephonyDomainUserCategoryBoolExp>;
};


export type telephonyquery_rootdomainUserCategoriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyDomainUserCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyDomainUserCategoryOrderBy>>;
  where?: InputMaybe<TelephonyDomainUserCategoryBoolExp>;
};


export type telephonyquery_rootdomainUserCategoryArgs = {
  value: Scalars['String']['input'];
};


export type telephonyquery_rootdomainUsersArgs = {
  distinctOn?: InputMaybe<Array<TelephonydomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonydomainUserOrderBy>>;
  where?: InputMaybe<TelephonydomainUserBoolExp>;
};


export type telephonyquery_rootdomainUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonydomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonydomainUserOrderBy>>;
  where?: InputMaybe<TelephonydomainUserBoolExp>;
};


export type telephonyquery_rooteventArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonyquery_rooteventActionAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyeventActionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyeventActionOrderBy>>;
  where?: InputMaybe<TelephonyeventActionBoolExp>;
};


export type telephonyquery_rooteventActionByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonyquery_rooteventActionsArgs = {
  distinctOn?: InputMaybe<Array<TelephonyeventActionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyeventActionOrderBy>>;
  where?: InputMaybe<TelephonyeventActionBoolExp>;
};


export type telephonyquery_rooteventsArgs = {
  distinctOn?: InputMaybe<Array<TelephonyeventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyeventOrderBy>>;
  where?: InputMaybe<TelephonyeventBoolExp>;
};


export type telephonyquery_rooteventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyeventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyeventOrderBy>>;
  where?: InputMaybe<TelephonyeventBoolExp>;
};


export type telephonyquery_rootlookupPhoneNumberArgs = {
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  providerClientId?: InputMaybe<Scalars['String']['input']>;
};


export type telephonyquery_rootnumberStateArgs = {
  value: Scalars['String']['input'];
};


export type telephonyquery_rootnumberStatesArgs = {
  distinctOn?: InputMaybe<Array<TelephonyNumberStateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyNumberStateOrderBy>>;
  where?: InputMaybe<TelephonyNumberStateBoolExp>;
};


export type telephonyquery_rootnumberStatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyNumberStateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyNumberStateOrderBy>>;
  where?: InputMaybe<TelephonyNumberStateBoolExp>;
};


export type telephonyquery_rootproviderArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonyquery_rootproviderAccountArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonyquery_rootproviderAccountsArgs = {
  distinctOn?: InputMaybe<Array<TelephonyproviderAccountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyproviderAccountOrderBy>>;
  where?: InputMaybe<TelephonyproviderAccountBoolExp>;
};


export type telephonyquery_rootproviderAccountsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyproviderAccountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyproviderAccountOrderBy>>;
  where?: InputMaybe<TelephonyproviderAccountBoolExp>;
};


export type telephonyquery_rootproviderAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyproviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyproviderOrderBy>>;
  where?: InputMaybe<TelephonyproviderBoolExp>;
};


export type telephonyquery_rootproviderRequestTermArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonyquery_rootproviderRequestTermsArgs = {
  distinctOn?: InputMaybe<Array<TelephonyproviderRequestTermSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyproviderRequestTermOrderBy>>;
  where?: InputMaybe<TelephonyproviderRequestTermBoolExp>;
};


export type telephonyquery_rootproviderRequestTermsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyproviderRequestTermSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyproviderRequestTermOrderBy>>;
  where?: InputMaybe<TelephonyproviderRequestTermBoolExp>;
};


export type telephonyquery_rootproviderTypeArgs = {
  value: Scalars['String']['input'];
};


export type telephonyquery_rootproviderTypesArgs = {
  distinctOn?: InputMaybe<Array<TelephonyProviderTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyProviderTypeOrderBy>>;
  where?: InputMaybe<TelephonyProviderTypeBoolExp>;
};


export type telephonyquery_rootproviderTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyProviderTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyProviderTypeOrderBy>>;
  where?: InputMaybe<TelephonyProviderTypeBoolExp>;
};


export type telephonyquery_rootprovidersArgs = {
  distinctOn?: InputMaybe<Array<TelephonyproviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyproviderOrderBy>>;
  where?: InputMaybe<TelephonyproviderBoolExp>;
};


export type telephonyquery_roottelephonyActionEventTypeArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyActionEventTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyActionEventTypeOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyActionEventTypeBoolExp>;
};


export type telephonyquery_roottelephonyActionEventTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyActionEventTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyActionEventTypeOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyActionEventTypeBoolExp>;
};


export type telephonyquery_roottelephonyActionEventTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type telephonyquery_roottelephonyActionTypeArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyActionTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyActionTypeOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyActionTypeBoolExp>;
};


export type telephonyquery_roottelephonyActionTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyActionTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyActionTypeOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyActionTypeBoolExp>;
};


export type telephonyquery_roottelephonyActionTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type telephonyquery_roottelephonyBlockedDomainUserArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyBlockedDomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyBlockedDomainUserOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyBlockedDomainUserBoolExp>;
};


export type telephonyquery_roottelephonyBlockedDomainUserAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyBlockedDomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyBlockedDomainUserOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyBlockedDomainUserBoolExp>;
};


export type telephonyquery_roottelephonyBlockedDomainUserByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonyquery_roottelephonyCiscoSubscriberProductArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyCiscoSubscriberProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyCiscoSubscriberProductOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyCiscoSubscriberProductBoolExp>;
};


export type telephonyquery_roottelephonyCiscoSubscriberProductAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyCiscoSubscriberProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyCiscoSubscriberProductOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyCiscoSubscriberProductBoolExp>;
};


export type telephonyquery_roottelephonyCiscoSubscriberProductByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonyquery_roottelephonyEventsArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyEventsOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyEventsBoolExp>;
};


export type telephonyquery_roottelephonyEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyEventsOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyEventsBoolExp>;
};


export type telephonyquery_roottelephonyEventsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonyquery_roottelephonyLookupCallerApiArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyLookupCallerApiSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyLookupCallerApiOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyLookupCallerApiBoolExp>;
};


export type telephonyquery_roottelephonyLookupCallerApiAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyLookupCallerApiSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyLookupCallerApiOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyLookupCallerApiBoolExp>;
};


export type telephonyquery_roottelephonyLookupCallerApiByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonyquery_roottelephonyLookupRefreshArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyLookupRefreshSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyLookupRefreshOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyLookupRefreshBoolExp>;
};


export type telephonyquery_roottelephonyLookupRefreshAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyLookupRefreshSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyLookupRefreshOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyLookupRefreshBoolExp>;
};


export type telephonyquery_roottelephonyLookupRefreshByPkArgs = {
  type: TelephonyTelephonyLookupTypesEnum;
};


export type telephonyquery_roottelephonyLookupTypesArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyLookupTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyLookupTypesOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyLookupTypesBoolExp>;
};


export type telephonyquery_roottelephonyLookupTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyLookupTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyLookupTypesOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyLookupTypesBoolExp>;
};


export type telephonyquery_roottelephonyLookupTypesByPkArgs = {
  value: Scalars['String']['input'];
};


export type telephonyquery_roottelephonyPodsArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyPodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyPodsOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyPodsBoolExp>;
};


export type telephonyquery_roottelephonyPodsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyPodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyPodsOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyPodsBoolExp>;
};


export type telephonyquery_roottelephonyPodsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonyquery_roottelephonyProviderAccessArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyProviderAccessSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyProviderAccessOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyProviderAccessBoolExp>;
};


export type telephonyquery_roottelephonyProviderAccessAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyProviderAccessSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyProviderAccessOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyProviderAccessBoolExp>;
};


export type telephonyquery_roottelephonyProviderAccessByPkArgs = {
  value: Scalars['String']['input'];
};

export type telephonysubscription_root = {
  __typename?: 'telephonysubscription_root';
  /** fetch data from the table: "telephony.active_numbers" using primary key columns */
  activeNumber?: Maybe<TelephonyactiveNumbers>;
  /** fetch data from the table: "telephony.active_numbers" */
  activeNumbers: Array<TelephonyactiveNumbers>;
  /** fetch aggregated fields from the table: "telephony.active_numbers" */
  activeNumbersAggregate: TelephonyactiveNumbersAggregate;
  /** fetch data from the table in a streaming manner: "telephony.active_numbers" */
  activeNumbersStream: Array<TelephonyactiveNumbers>;
  /** An array relationship */
  activities: Array<Telephonyactivity>;
  /** An aggregate relationship */
  activitiesAggregate: TelephonyactivityAggregate;
  /** fetch data from the table in a streaming manner: "telephony.activity" */
  activitiesStream: Array<Telephonyactivity>;
  /** fetch data from the table: "telephony.activity" using primary key columns */
  activity?: Maybe<Telephonyactivity>;
  /** fetch data from the table: "telephony.activity_participant" using primary key columns */
  activityParticipant?: Maybe<TelephonyactivityParticipant>;
  /** fetch data from the table: "telephony.activity_participant_role" using primary key columns */
  activityParticipantRole?: Maybe<TelephonyActivityParticipantRole>;
  /** fetch data from the table: "telephony.activity_participant_role" */
  activityParticipantRoles: Array<TelephonyActivityParticipantRole>;
  /** fetch aggregated fields from the table: "telephony.activity_participant_role" */
  activityParticipantRolesAggregate: TelephonyActivityParticipantRoleAggregate;
  /** fetch data from the table in a streaming manner: "telephony.activity_participant_role" */
  activityParticipantRolesStream: Array<TelephonyActivityParticipantRole>;
  /** An array relationship */
  activityParticipants: Array<TelephonyactivityParticipant>;
  /** An aggregate relationship */
  activityParticipantsAggregate: TelephonyactivityParticipantAggregate;
  /** fetch data from the table in a streaming manner: "telephony.activity_participant" */
  activityParticipantsStream: Array<TelephonyactivityParticipant>;
  /** fetch data from the table: "telephony.activity_type" using primary key columns */
  activityType?: Maybe<TelephonyActivityType>;
  /** fetch data from the table: "telephony.activity_type" */
  activityTypes: Array<TelephonyActivityType>;
  /** fetch aggregated fields from the table: "telephony.activity_type" */
  activityTypesAggregate: TelephonyActivityTypeAggregate;
  /** fetch data from the table in a streaming manner: "telephony.activity_type" */
  activityTypesStream: Array<TelephonyActivityType>;
  /** fetch data from the table: "telephony.call_direction" using primary key columns */
  callDirection?: Maybe<TelephonyCallDirection>;
  /** fetch data from the table: "telephony.call_direction" */
  callDirections: Array<TelephonyCallDirection>;
  /** fetch aggregated fields from the table: "telephony.call_direction" */
  callDirectionsAggregate: TelephonyCallDirectionAggregate;
  /** fetch data from the table in a streaming manner: "telephony.call_direction" */
  callDirectionsStream: Array<TelephonyCallDirection>;
  /** fetch data from the table: "telephony.comment" using primary key columns */
  comment?: Maybe<Telephonycomment>;
  /** An array relationship */
  comments: Array<Telephonycomment>;
  /** An aggregate relationship */
  commentsAggregate: TelephonycommentAggregate;
  /** fetch data from the table in a streaming manner: "telephony.comment" */
  commentsStream: Array<Telephonycomment>;
  /** fetch data from the table: "telephony.domain_organization" using primary key columns */
  domainOrganization?: Maybe<TelephonydomainOrganization>;
  /** An array relationship */
  domainOrganizations: Array<TelephonydomainOrganization>;
  /** An aggregate relationship */
  domainOrganizationsAggregate: TelephonydomainOrganizationAggregate;
  /** fetch data from the table in a streaming manner: "telephony.domain_organization" */
  domainOrganizationsStream: Array<TelephonydomainOrganization>;
  /** fetch data from the table: "telephony.domain_user" using primary key columns */
  domainUser?: Maybe<TelephonydomainUser>;
  /** fetch data from the table: "telephony.domain_user_category" */
  domainUserCategories: Array<TelephonyDomainUserCategory>;
  /** fetch aggregated fields from the table: "telephony.domain_user_category" */
  domainUserCategoriesAggregate: TelephonyDomainUserCategoryAggregate;
  /** fetch data from the table in a streaming manner: "telephony.domain_user_category" */
  domainUserCategoriesStream: Array<TelephonyDomainUserCategory>;
  /** fetch data from the table: "telephony.domain_user_category" using primary key columns */
  domainUserCategory?: Maybe<TelephonyDomainUserCategory>;
  /** An array relationship */
  domainUsers: Array<TelephonydomainUser>;
  /** An aggregate relationship */
  domainUsersAggregate: TelephonydomainUserAggregate;
  /** fetch data from the table in a streaming manner: "telephony.domain_user" */
  domainUsersStream: Array<TelephonydomainUser>;
  /** fetch data from the table: "telephony.event_to_be_deleted_in_may_2024" using primary key columns */
  event?: Maybe<Telephonyevent>;
  /** fetch aggregated fields from the table: "telephony.event_action" */
  eventActionAggregate: TelephonyeventActionAggregate;
  /** fetch data from the table: "telephony.event_action" using primary key columns */
  eventActionByPk?: Maybe<TelephonyeventAction>;
  /** fetch data from the table in a streaming manner: "telephony.event_action" */
  eventActionStream: Array<TelephonyeventAction>;
  /** fetch data from the table: "telephony.event_action" */
  eventActions: Array<TelephonyeventAction>;
  /** An array relationship */
  events: Array<Telephonyevent>;
  /** An aggregate relationship */
  eventsAggregate: TelephonyeventAggregate;
  /** fetch data from the table in a streaming manner: "telephony.event_to_be_deleted_in_may_2024" */
  eventsStream: Array<Telephonyevent>;
  /** fetch data from the table: "telephony.number_state" using primary key columns */
  numberState?: Maybe<TelephonyNumberState>;
  /** fetch data from the table: "telephony.number_state" */
  numberStates: Array<TelephonyNumberState>;
  /** fetch aggregated fields from the table: "telephony.number_state" */
  numberStatesAggregate: TelephonyNumberStateAggregate;
  /** fetch data from the table in a streaming manner: "telephony.number_state" */
  numberStatesStream: Array<TelephonyNumberState>;
  /** fetch data from the table: "telephony.provider" using primary key columns */
  provider?: Maybe<Telephonyprovider>;
  /** fetch data from the table: "telephony.provider_account" using primary key columns */
  providerAccount?: Maybe<TelephonyproviderAccount>;
  /** An array relationship */
  providerAccounts: Array<TelephonyproviderAccount>;
  /** An aggregate relationship */
  providerAccountsAggregate: TelephonyproviderAccountAggregate;
  /** fetch data from the table in a streaming manner: "telephony.provider_account" */
  providerAccountsStream: Array<TelephonyproviderAccount>;
  /** fetch aggregated fields from the table: "telephony.provider" */
  providerAggregate: TelephonyproviderAggregate;
  /** fetch data from the table: "telephony.provider_request_terms" using primary key columns */
  providerRequestTerm?: Maybe<TelephonyproviderRequestTerm>;
  /** fetch data from the table: "telephony.provider_request_terms" */
  providerRequestTerms: Array<TelephonyproviderRequestTerm>;
  /** fetch aggregated fields from the table: "telephony.provider_request_terms" */
  providerRequestTermsAggregate: TelephonyproviderRequestTermAggregate;
  /** fetch data from the table in a streaming manner: "telephony.provider_request_terms" */
  providerRequestTermsStream: Array<TelephonyproviderRequestTerm>;
  /** fetch data from the table in a streaming manner: "telephony.provider" */
  providerStream: Array<Telephonyprovider>;
  /** fetch data from the table: "telephony.provider_type" using primary key columns */
  providerType?: Maybe<TelephonyProviderType>;
  /** fetch data from the table: "telephony.provider_type" */
  providerTypes: Array<TelephonyProviderType>;
  /** fetch aggregated fields from the table: "telephony.provider_type" */
  providerTypesAggregate: TelephonyProviderTypeAggregate;
  /** fetch data from the table in a streaming manner: "telephony.provider_type" */
  providerTypesStream: Array<TelephonyProviderType>;
  /** fetch data from the table: "telephony.provider" */
  providers: Array<Telephonyprovider>;
  /** fetch data from the table: "telephony.action_event_type" */
  telephonyActionEventType: Array<TelephonyTelephonyActionEventType>;
  /** fetch aggregated fields from the table: "telephony.action_event_type" */
  telephonyActionEventTypeAggregate: TelephonyTelephonyActionEventTypeAggregate;
  /** fetch data from the table: "telephony.action_event_type" using primary key columns */
  telephonyActionEventTypeByPk?: Maybe<TelephonyTelephonyActionEventType>;
  /** fetch data from the table in a streaming manner: "telephony.action_event_type" */
  telephonyActionEventTypeStream: Array<TelephonyTelephonyActionEventType>;
  /** fetch data from the table: "telephony.action_type" */
  telephonyActionType: Array<TelephonyTelephonyActionType>;
  /** fetch aggregated fields from the table: "telephony.action_type" */
  telephonyActionTypeAggregate: TelephonyTelephonyActionTypeAggregate;
  /** fetch data from the table: "telephony.action_type" using primary key columns */
  telephonyActionTypeByPk?: Maybe<TelephonyTelephonyActionType>;
  /** fetch data from the table in a streaming manner: "telephony.action_type" */
  telephonyActionTypeStream: Array<TelephonyTelephonyActionType>;
  /** fetch data from the table: "telephony.blocked_domain_user" */
  telephonyBlockedDomainUser: Array<TelephonyTelephonyBlockedDomainUser>;
  /** fetch aggregated fields from the table: "telephony.blocked_domain_user" */
  telephonyBlockedDomainUserAggregate: TelephonyTelephonyBlockedDomainUserAggregate;
  /** fetch data from the table: "telephony.blocked_domain_user" using primary key columns */
  telephonyBlockedDomainUserByPk?: Maybe<TelephonyTelephonyBlockedDomainUser>;
  /** fetch data from the table in a streaming manner: "telephony.blocked_domain_user" */
  telephonyBlockedDomainUserStream: Array<TelephonyTelephonyBlockedDomainUser>;
  /** fetch data from the table: "telephony.cisco_subscriber_product" */
  telephonyCiscoSubscriberProduct: Array<TelephonyTelephonyCiscoSubscriberProduct>;
  /** fetch aggregated fields from the table: "telephony.cisco_subscriber_product" */
  telephonyCiscoSubscriberProductAggregate: TelephonyTelephonyCiscoSubscriberProductAggregate;
  /** fetch data from the table: "telephony.cisco_subscriber_product" using primary key columns */
  telephonyCiscoSubscriberProductByPk?: Maybe<TelephonyTelephonyCiscoSubscriberProduct>;
  /** fetch data from the table in a streaming manner: "telephony.cisco_subscriber_product" */
  telephonyCiscoSubscriberProductStream: Array<TelephonyTelephonyCiscoSubscriberProduct>;
  /** fetch data from the table: "telephony.events" */
  telephonyEvents: Array<TelephonyTelephonyEvents>;
  /** fetch aggregated fields from the table: "telephony.events" */
  telephonyEventsAggregate: TelephonyTelephonyEventsAggregate;
  /** fetch data from the table: "telephony.events" using primary key columns */
  telephonyEventsByPk?: Maybe<TelephonyTelephonyEvents>;
  /** fetch data from the table in a streaming manner: "telephony.events" */
  telephonyEventsStream: Array<TelephonyTelephonyEvents>;
  /** fetch data from the table: "telephony.lookup_caller_api" */
  telephonyLookupCallerApi: Array<TelephonyTelephonyLookupCallerApi>;
  /** fetch aggregated fields from the table: "telephony.lookup_caller_api" */
  telephonyLookupCallerApiAggregate: TelephonyTelephonyLookupCallerApiAggregate;
  /** fetch data from the table: "telephony.lookup_caller_api" using primary key columns */
  telephonyLookupCallerApiByPk?: Maybe<TelephonyTelephonyLookupCallerApi>;
  /** fetch data from the table in a streaming manner: "telephony.lookup_caller_api" */
  telephonyLookupCallerApiStream: Array<TelephonyTelephonyLookupCallerApi>;
  /** fetch data from the table: "telephony.lookup_refresh" */
  telephonyLookupRefresh: Array<TelephonyTelephonyLookupRefresh>;
  /** fetch aggregated fields from the table: "telephony.lookup_refresh" */
  telephonyLookupRefreshAggregate: TelephonyTelephonyLookupRefreshAggregate;
  /** fetch data from the table: "telephony.lookup_refresh" using primary key columns */
  telephonyLookupRefreshByPk?: Maybe<TelephonyTelephonyLookupRefresh>;
  /** fetch data from the table in a streaming manner: "telephony.lookup_refresh" */
  telephonyLookupRefreshStream: Array<TelephonyTelephonyLookupRefresh>;
  /** fetch data from the table: "telephony.lookup_types" */
  telephonyLookupTypes: Array<TelephonyTelephonyLookupTypes>;
  /** fetch aggregated fields from the table: "telephony.lookup_types" */
  telephonyLookupTypesAggregate: TelephonyTelephonyLookupTypesAggregate;
  /** fetch data from the table: "telephony.lookup_types" using primary key columns */
  telephonyLookupTypesByPk?: Maybe<TelephonyTelephonyLookupTypes>;
  /** fetch data from the table in a streaming manner: "telephony.lookup_types" */
  telephonyLookupTypesStream: Array<TelephonyTelephonyLookupTypes>;
  /** fetch data from the table: "telephony.pods" */
  telephonyPods: Array<TelephonyTelephonyPods>;
  /** fetch aggregated fields from the table: "telephony.pods" */
  telephonyPodsAggregate: TelephonyTelephonyPodsAggregate;
  /** fetch data from the table: "telephony.pods" using primary key columns */
  telephonyPodsByPk?: Maybe<TelephonyTelephonyPods>;
  /** fetch data from the table in a streaming manner: "telephony.pods" */
  telephonyPodsStream: Array<TelephonyTelephonyPods>;
  /** fetch data from the table: "telephony.provider_access" */
  telephonyProviderAccess: Array<TelephonyTelephonyProviderAccess>;
  /** fetch aggregated fields from the table: "telephony.provider_access" */
  telephonyProviderAccessAggregate: TelephonyTelephonyProviderAccessAggregate;
  /** fetch data from the table: "telephony.provider_access" using primary key columns */
  telephonyProviderAccessByPk?: Maybe<TelephonyTelephonyProviderAccess>;
  /** fetch data from the table in a streaming manner: "telephony.provider_access" */
  telephonyProviderAccessStream: Array<TelephonyTelephonyProviderAccess>;
};


export type telephonysubscription_rootactiveNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type telephonysubscription_rootactiveNumbersArgs = {
  distinctOn?: InputMaybe<Array<TelephonyactiveNumbersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyactiveNumbersOrderBy>>;
  where?: InputMaybe<TelephonyactiveNumbersBoolExp>;
};


export type telephonysubscription_rootactiveNumbersAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyactiveNumbersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyactiveNumbersOrderBy>>;
  where?: InputMaybe<TelephonyactiveNumbersBoolExp>;
};


export type telephonysubscription_rootactiveNumbersStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonyactiveNumbersStreamCursorInput>>;
  where?: InputMaybe<TelephonyactiveNumbersBoolExp>;
};


export type telephonysubscription_rootactivitiesArgs = {
  distinctOn?: InputMaybe<Array<TelephonyactivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyactivityOrderBy>>;
  where?: InputMaybe<TelephonyactivityBoolExp>;
};


export type telephonysubscription_rootactivitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyactivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyactivityOrderBy>>;
  where?: InputMaybe<TelephonyactivityBoolExp>;
};


export type telephonysubscription_rootactivitiesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonyactivityStreamCursorInput>>;
  where?: InputMaybe<TelephonyactivityBoolExp>;
};


export type telephonysubscription_rootactivityArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonysubscription_rootactivityParticipantArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonysubscription_rootactivityParticipantRoleArgs = {
  value: Scalars['String']['input'];
};


export type telephonysubscription_rootactivityParticipantRolesArgs = {
  distinctOn?: InputMaybe<Array<TelephonyActivityParticipantRoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyActivityParticipantRoleOrderBy>>;
  where?: InputMaybe<TelephonyActivityParticipantRoleBoolExp>;
};


export type telephonysubscription_rootactivityParticipantRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyActivityParticipantRoleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyActivityParticipantRoleOrderBy>>;
  where?: InputMaybe<TelephonyActivityParticipantRoleBoolExp>;
};


export type telephonysubscription_rootactivityParticipantRolesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonyActivityParticipantRoleStreamCursorInput>>;
  where?: InputMaybe<TelephonyActivityParticipantRoleBoolExp>;
};


export type telephonysubscription_rootactivityParticipantsArgs = {
  distinctOn?: InputMaybe<Array<TelephonyactivityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyactivityParticipantOrderBy>>;
  where?: InputMaybe<TelephonyactivityParticipantBoolExp>;
};


export type telephonysubscription_rootactivityParticipantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyactivityParticipantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyactivityParticipantOrderBy>>;
  where?: InputMaybe<TelephonyactivityParticipantBoolExp>;
};


export type telephonysubscription_rootactivityParticipantsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonyactivityParticipantStreamCursorInput>>;
  where?: InputMaybe<TelephonyactivityParticipantBoolExp>;
};


export type telephonysubscription_rootactivityTypeArgs = {
  value: Scalars['String']['input'];
};


export type telephonysubscription_rootactivityTypesArgs = {
  distinctOn?: InputMaybe<Array<TelephonyActivityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyActivityTypeOrderBy>>;
  where?: InputMaybe<TelephonyActivityTypeBoolExp>;
};


export type telephonysubscription_rootactivityTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyActivityTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyActivityTypeOrderBy>>;
  where?: InputMaybe<TelephonyActivityTypeBoolExp>;
};


export type telephonysubscription_rootactivityTypesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonyActivityTypeStreamCursorInput>>;
  where?: InputMaybe<TelephonyActivityTypeBoolExp>;
};


export type telephonysubscription_rootcallDirectionArgs = {
  value: Scalars['String']['input'];
};


export type telephonysubscription_rootcallDirectionsArgs = {
  distinctOn?: InputMaybe<Array<TelephonyCallDirectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyCallDirectionOrderBy>>;
  where?: InputMaybe<TelephonyCallDirectionBoolExp>;
};


export type telephonysubscription_rootcallDirectionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyCallDirectionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyCallDirectionOrderBy>>;
  where?: InputMaybe<TelephonyCallDirectionBoolExp>;
};


export type telephonysubscription_rootcallDirectionsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonyCallDirectionStreamCursorInput>>;
  where?: InputMaybe<TelephonyCallDirectionBoolExp>;
};


export type telephonysubscription_rootcommentArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonysubscription_rootcommentsArgs = {
  distinctOn?: InputMaybe<Array<TelephonycommentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonycommentOrderBy>>;
  where?: InputMaybe<TelephonycommentBoolExp>;
};


export type telephonysubscription_rootcommentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonycommentSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonycommentOrderBy>>;
  where?: InputMaybe<TelephonycommentBoolExp>;
};


export type telephonysubscription_rootcommentsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonycommentStreamCursorInput>>;
  where?: InputMaybe<TelephonycommentBoolExp>;
};


export type telephonysubscription_rootdomainOrganizationArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonysubscription_rootdomainOrganizationsArgs = {
  distinctOn?: InputMaybe<Array<TelephonydomainOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonydomainOrganizationOrderBy>>;
  where?: InputMaybe<TelephonydomainOrganizationBoolExp>;
};


export type telephonysubscription_rootdomainOrganizationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonydomainOrganizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonydomainOrganizationOrderBy>>;
  where?: InputMaybe<TelephonydomainOrganizationBoolExp>;
};


export type telephonysubscription_rootdomainOrganizationsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonydomainOrganizationStreamCursorInput>>;
  where?: InputMaybe<TelephonydomainOrganizationBoolExp>;
};


export type telephonysubscription_rootdomainUserArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonysubscription_rootdomainUserCategoriesArgs = {
  distinctOn?: InputMaybe<Array<TelephonyDomainUserCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyDomainUserCategoryOrderBy>>;
  where?: InputMaybe<TelephonyDomainUserCategoryBoolExp>;
};


export type telephonysubscription_rootdomainUserCategoriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyDomainUserCategorySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyDomainUserCategoryOrderBy>>;
  where?: InputMaybe<TelephonyDomainUserCategoryBoolExp>;
};


export type telephonysubscription_rootdomainUserCategoriesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonyDomainUserCategoryStreamCursorInput>>;
  where?: InputMaybe<TelephonyDomainUserCategoryBoolExp>;
};


export type telephonysubscription_rootdomainUserCategoryArgs = {
  value: Scalars['String']['input'];
};


export type telephonysubscription_rootdomainUsersArgs = {
  distinctOn?: InputMaybe<Array<TelephonydomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonydomainUserOrderBy>>;
  where?: InputMaybe<TelephonydomainUserBoolExp>;
};


export type telephonysubscription_rootdomainUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonydomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonydomainUserOrderBy>>;
  where?: InputMaybe<TelephonydomainUserBoolExp>;
};


export type telephonysubscription_rootdomainUsersStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonydomainUserStreamCursorInput>>;
  where?: InputMaybe<TelephonydomainUserBoolExp>;
};


export type telephonysubscription_rooteventArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonysubscription_rooteventActionAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyeventActionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyeventActionOrderBy>>;
  where?: InputMaybe<TelephonyeventActionBoolExp>;
};


export type telephonysubscription_rooteventActionByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonysubscription_rooteventActionStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonyeventActionStreamCursorInput>>;
  where?: InputMaybe<TelephonyeventActionBoolExp>;
};


export type telephonysubscription_rooteventActionsArgs = {
  distinctOn?: InputMaybe<Array<TelephonyeventActionSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyeventActionOrderBy>>;
  where?: InputMaybe<TelephonyeventActionBoolExp>;
};


export type telephonysubscription_rooteventsArgs = {
  distinctOn?: InputMaybe<Array<TelephonyeventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyeventOrderBy>>;
  where?: InputMaybe<TelephonyeventBoolExp>;
};


export type telephonysubscription_rooteventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyeventSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyeventOrderBy>>;
  where?: InputMaybe<TelephonyeventBoolExp>;
};


export type telephonysubscription_rooteventsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonyeventStreamCursorInput>>;
  where?: InputMaybe<TelephonyeventBoolExp>;
};


export type telephonysubscription_rootnumberStateArgs = {
  value: Scalars['String']['input'];
};


export type telephonysubscription_rootnumberStatesArgs = {
  distinctOn?: InputMaybe<Array<TelephonyNumberStateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyNumberStateOrderBy>>;
  where?: InputMaybe<TelephonyNumberStateBoolExp>;
};


export type telephonysubscription_rootnumberStatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyNumberStateSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyNumberStateOrderBy>>;
  where?: InputMaybe<TelephonyNumberStateBoolExp>;
};


export type telephonysubscription_rootnumberStatesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonyNumberStateStreamCursorInput>>;
  where?: InputMaybe<TelephonyNumberStateBoolExp>;
};


export type telephonysubscription_rootproviderArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonysubscription_rootproviderAccountArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonysubscription_rootproviderAccountsArgs = {
  distinctOn?: InputMaybe<Array<TelephonyproviderAccountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyproviderAccountOrderBy>>;
  where?: InputMaybe<TelephonyproviderAccountBoolExp>;
};


export type telephonysubscription_rootproviderAccountsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyproviderAccountSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyproviderAccountOrderBy>>;
  where?: InputMaybe<TelephonyproviderAccountBoolExp>;
};


export type telephonysubscription_rootproviderAccountsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonyproviderAccountStreamCursorInput>>;
  where?: InputMaybe<TelephonyproviderAccountBoolExp>;
};


export type telephonysubscription_rootproviderAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyproviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyproviderOrderBy>>;
  where?: InputMaybe<TelephonyproviderBoolExp>;
};


export type telephonysubscription_rootproviderRequestTermArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonysubscription_rootproviderRequestTermsArgs = {
  distinctOn?: InputMaybe<Array<TelephonyproviderRequestTermSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyproviderRequestTermOrderBy>>;
  where?: InputMaybe<TelephonyproviderRequestTermBoolExp>;
};


export type telephonysubscription_rootproviderRequestTermsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyproviderRequestTermSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyproviderRequestTermOrderBy>>;
  where?: InputMaybe<TelephonyproviderRequestTermBoolExp>;
};


export type telephonysubscription_rootproviderRequestTermsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonyproviderRequestTermStreamCursorInput>>;
  where?: InputMaybe<TelephonyproviderRequestTermBoolExp>;
};


export type telephonysubscription_rootproviderStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonyproviderStreamCursorInput>>;
  where?: InputMaybe<TelephonyproviderBoolExp>;
};


export type telephonysubscription_rootproviderTypeArgs = {
  value: Scalars['String']['input'];
};


export type telephonysubscription_rootproviderTypesArgs = {
  distinctOn?: InputMaybe<Array<TelephonyProviderTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyProviderTypeOrderBy>>;
  where?: InputMaybe<TelephonyProviderTypeBoolExp>;
};


export type telephonysubscription_rootproviderTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyProviderTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyProviderTypeOrderBy>>;
  where?: InputMaybe<TelephonyProviderTypeBoolExp>;
};


export type telephonysubscription_rootproviderTypesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonyProviderTypeStreamCursorInput>>;
  where?: InputMaybe<TelephonyProviderTypeBoolExp>;
};


export type telephonysubscription_rootprovidersArgs = {
  distinctOn?: InputMaybe<Array<TelephonyproviderSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyproviderOrderBy>>;
  where?: InputMaybe<TelephonyproviderBoolExp>;
};


export type telephonysubscription_roottelephonyActionEventTypeArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyActionEventTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyActionEventTypeOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyActionEventTypeBoolExp>;
};


export type telephonysubscription_roottelephonyActionEventTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyActionEventTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyActionEventTypeOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyActionEventTypeBoolExp>;
};


export type telephonysubscription_roottelephonyActionEventTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type telephonysubscription_roottelephonyActionEventTypeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonyTelephonyActionEventTypeStreamCursorInput>>;
  where?: InputMaybe<TelephonyTelephonyActionEventTypeBoolExp>;
};


export type telephonysubscription_roottelephonyActionTypeArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyActionTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyActionTypeOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyActionTypeBoolExp>;
};


export type telephonysubscription_roottelephonyActionTypeAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyActionTypeSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyActionTypeOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyActionTypeBoolExp>;
};


export type telephonysubscription_roottelephonyActionTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type telephonysubscription_roottelephonyActionTypeStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonyTelephonyActionTypeStreamCursorInput>>;
  where?: InputMaybe<TelephonyTelephonyActionTypeBoolExp>;
};


export type telephonysubscription_roottelephonyBlockedDomainUserArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyBlockedDomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyBlockedDomainUserOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyBlockedDomainUserBoolExp>;
};


export type telephonysubscription_roottelephonyBlockedDomainUserAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyBlockedDomainUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyBlockedDomainUserOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyBlockedDomainUserBoolExp>;
};


export type telephonysubscription_roottelephonyBlockedDomainUserByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonysubscription_roottelephonyBlockedDomainUserStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonyTelephonyBlockedDomainUserStreamCursorInput>>;
  where?: InputMaybe<TelephonyTelephonyBlockedDomainUserBoolExp>;
};


export type telephonysubscription_roottelephonyCiscoSubscriberProductArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyCiscoSubscriberProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyCiscoSubscriberProductOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyCiscoSubscriberProductBoolExp>;
};


export type telephonysubscription_roottelephonyCiscoSubscriberProductAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyCiscoSubscriberProductSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyCiscoSubscriberProductOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyCiscoSubscriberProductBoolExp>;
};


export type telephonysubscription_roottelephonyCiscoSubscriberProductByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonysubscription_roottelephonyCiscoSubscriberProductStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonyTelephonyCiscoSubscriberProductStreamCursorInput>>;
  where?: InputMaybe<TelephonyTelephonyCiscoSubscriberProductBoolExp>;
};


export type telephonysubscription_roottelephonyEventsArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyEventsOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyEventsBoolExp>;
};


export type telephonysubscription_roottelephonyEventsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyEventsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyEventsOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyEventsBoolExp>;
};


export type telephonysubscription_roottelephonyEventsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonysubscription_roottelephonyEventsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonyTelephonyEventsStreamCursorInput>>;
  where?: InputMaybe<TelephonyTelephonyEventsBoolExp>;
};


export type telephonysubscription_roottelephonyLookupCallerApiArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyLookupCallerApiSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyLookupCallerApiOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyLookupCallerApiBoolExp>;
};


export type telephonysubscription_roottelephonyLookupCallerApiAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyLookupCallerApiSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyLookupCallerApiOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyLookupCallerApiBoolExp>;
};


export type telephonysubscription_roottelephonyLookupCallerApiByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonysubscription_roottelephonyLookupCallerApiStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonyTelephonyLookupCallerApiStreamCursorInput>>;
  where?: InputMaybe<TelephonyTelephonyLookupCallerApiBoolExp>;
};


export type telephonysubscription_roottelephonyLookupRefreshArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyLookupRefreshSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyLookupRefreshOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyLookupRefreshBoolExp>;
};


export type telephonysubscription_roottelephonyLookupRefreshAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyLookupRefreshSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyLookupRefreshOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyLookupRefreshBoolExp>;
};


export type telephonysubscription_roottelephonyLookupRefreshByPkArgs = {
  type: TelephonyTelephonyLookupTypesEnum;
};


export type telephonysubscription_roottelephonyLookupRefreshStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonyTelephonyLookupRefreshStreamCursorInput>>;
  where?: InputMaybe<TelephonyTelephonyLookupRefreshBoolExp>;
};


export type telephonysubscription_roottelephonyLookupTypesArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyLookupTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyLookupTypesOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyLookupTypesBoolExp>;
};


export type telephonysubscription_roottelephonyLookupTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyLookupTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyLookupTypesOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyLookupTypesBoolExp>;
};


export type telephonysubscription_roottelephonyLookupTypesByPkArgs = {
  value: Scalars['String']['input'];
};


export type telephonysubscription_roottelephonyLookupTypesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonyTelephonyLookupTypesStreamCursorInput>>;
  where?: InputMaybe<TelephonyTelephonyLookupTypesBoolExp>;
};


export type telephonysubscription_roottelephonyPodsArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyPodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyPodsOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyPodsBoolExp>;
};


export type telephonysubscription_roottelephonyPodsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyPodsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyPodsOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyPodsBoolExp>;
};


export type telephonysubscription_roottelephonyPodsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type telephonysubscription_roottelephonyPodsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonyTelephonyPodsStreamCursorInput>>;
  where?: InputMaybe<TelephonyTelephonyPodsBoolExp>;
};


export type telephonysubscription_roottelephonyProviderAccessArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyProviderAccessSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyProviderAccessOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyProviderAccessBoolExp>;
};


export type telephonysubscription_roottelephonyProviderAccessAggregateArgs = {
  distinctOn?: InputMaybe<Array<TelephonyTelephonyProviderAccessSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TelephonyTelephonyProviderAccessOrderBy>>;
  where?: InputMaybe<TelephonyTelephonyProviderAccessBoolExp>;
};


export type telephonysubscription_roottelephonyProviderAccessByPkArgs = {
  value: Scalars['String']['input'];
};


export type telephonysubscription_roottelephonyProviderAccessStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TelephonyTelephonyProviderAccessStreamCursorInput>>;
  where?: InputMaybe<TelephonyTelephonyProviderAccessBoolExp>;
};

export type testNotificationSettingsResult = {
  __typename?: 'testNotificationSettingsResult';
  result: Scalars['String']['output'];
};

export type updateDashboardDataOutput = {
  __typename?: 'updateDashboardDataOutput';
  json?: Maybe<Scalars['json']['output']>;
};

/** Brukere */
export type user = {
  __typename?: 'user';
  authId?: Maybe<Scalars['String']['output']>;
  chosenLanguage?: Maybe<Scalars['String']['output']>;
  completedFirstTimeUser: Scalars['Boolean']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  customerCards: Array<organizationUser>;
  /** An aggregate relationship */
  customerCardsAggregate: organizationUserAggregate;
  /** An array relationship */
  domainActivities: Array<domainActivity>;
  /** An aggregate relationship */
  domainActivitiesAggregate: domainActivityAggregate;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  image?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  lastSeen?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  messages: Array<messagingMessage>;
  /** An aggregate relationship */
  messagesAggregate: messagingMessageAggregate;
  /** An array relationship */
  notes: Array<message>;
  /** An aggregate relationship */
  notesAggregate: messageAggregate;
  /** An array relationship */
  notificationUserDevices: Array<notificationUserDevice>;
  /** An aggregate relationship */
  notificationUserDevicesAggregate: notificationUserDeviceAggregate;
  /** An object relationship */
  orderIntegrations?: Maybe<ordersIntegrations>;
  /** An array relationship */
  organizationRequests: Array<BusinessOrganizationUserRequest>;
  /** An aggregate relationship */
  organizationRequestsAggregate: BusinessOrganizationUserRequestAggregate;
  /** An array relationship */
  organizationUserInvitations: Array<organizationUserInvite>;
  /** An aggregate relationship */
  organizationUserInvitationsAggregate: organizationUserInviteAggregate;
  /** An array relationship */
  organizationUsers: Array<organizationUser>;
  /** An aggregate relationship */
  organizationUsersAggregate: organizationUserAggregate;
  /** An array relationship */
  organizations: Array<organizationOrganizationUserOrganizationsView>;
  /** An aggregate relationship */
  organizationsAggregate: organizationOrganizationUserOrganizationsViewAggregate;
  /** An array relationship */
  organizationsByOwnerId: Array<organization>;
  /** An aggregate relationship */
  organizationsByOwnerIdAggregate: organizationAggregate;
  /** An object relationship */
  organizations_object?: Maybe<organizationOrganizationUserUsersView>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberIsVerified?: Maybe<Scalars['Boolean']['output']>;
  phoneState?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  states: Array<BusinessUserStates>;
  /** An aggregate relationship */
  statesAggregate: BusinessUserStatesAggregate;
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  userFeed: Array<BusinessUserFeed>;
  /** An aggregate relationship */
  userFeedAggregate: BusinessUserFeedAggregate;
  username?: Maybe<Scalars['String']['output']>;
};


/** Brukere */
export type usercustomerCardsArgs = {
  distinctOn?: InputMaybe<Array<organizationUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserOrderBy>>;
  where?: InputMaybe<organizationUserBoolExp>;
};


/** Brukere */
export type usercustomerCardsAggregateArgs = {
  distinctOn?: InputMaybe<Array<organizationUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserOrderBy>>;
  where?: InputMaybe<organizationUserBoolExp>;
};


/** Brukere */
export type userdomainActivitiesArgs = {
  distinctOn?: InputMaybe<Array<domainActivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainActivityOrderBy>>;
  where?: InputMaybe<domainActivityBoolExp>;
};


/** Brukere */
export type userdomainActivitiesAggregateArgs = {
  distinctOn?: InputMaybe<Array<domainActivitySelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<domainActivityOrderBy>>;
  where?: InputMaybe<domainActivityBoolExp>;
};


/** Brukere */
export type usermessagesArgs = {
  distinctOn?: InputMaybe<Array<messagingMessageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingMessageOrderBy>>;
  where?: InputMaybe<messagingMessageBoolExp>;
};


/** Brukere */
export type usermessagesAggregateArgs = {
  distinctOn?: InputMaybe<Array<messagingMessageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messagingMessageOrderBy>>;
  where?: InputMaybe<messagingMessageBoolExp>;
};


/** Brukere */
export type usernotesArgs = {
  distinctOn?: InputMaybe<Array<messageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messageOrderBy>>;
  where?: InputMaybe<messageBoolExp>;
};


/** Brukere */
export type usernotesAggregateArgs = {
  distinctOn?: InputMaybe<Array<messageSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<messageOrderBy>>;
  where?: InputMaybe<messageBoolExp>;
};


/** Brukere */
export type usernotificationUserDevicesArgs = {
  distinctOn?: InputMaybe<Array<notificationUserDeviceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<notificationUserDeviceOrderBy>>;
  where?: InputMaybe<notificationUserDeviceBoolExp>;
};


/** Brukere */
export type usernotificationUserDevicesAggregateArgs = {
  distinctOn?: InputMaybe<Array<notificationUserDeviceSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<notificationUserDeviceOrderBy>>;
  where?: InputMaybe<notificationUserDeviceBoolExp>;
};


/** Brukere */
export type userorganizationRequestsArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserRequestOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserRequestBoolExp>;
};


/** Brukere */
export type userorganizationRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessOrganizationUserRequestSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessOrganizationUserRequestOrderBy>>;
  where?: InputMaybe<BusinessOrganizationUserRequestBoolExp>;
};


/** Brukere */
export type userorganizationUserInvitationsArgs = {
  distinctOn?: InputMaybe<Array<organizationUserInviteSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserInviteOrderBy>>;
  where?: InputMaybe<organizationUserInviteBoolExp>;
};


/** Brukere */
export type userorganizationUserInvitationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<organizationUserInviteSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserInviteOrderBy>>;
  where?: InputMaybe<organizationUserInviteBoolExp>;
};


/** Brukere */
export type userorganizationUsersArgs = {
  distinctOn?: InputMaybe<Array<organizationUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserOrderBy>>;
  where?: InputMaybe<organizationUserBoolExp>;
};


/** Brukere */
export type userorganizationUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<organizationUserSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationUserOrderBy>>;
  where?: InputMaybe<organizationUserBoolExp>;
};


/** Brukere */
export type userorganizationsArgs = {
  distinctOn?: InputMaybe<Array<organizationOrganizationUserOrganizationsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrganizationUserOrganizationsViewOrderBy>>;
  where?: InputMaybe<organizationOrganizationUserOrganizationsViewBoolExp>;
};


/** Brukere */
export type userorganizationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<organizationOrganizationUserOrganizationsViewSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrganizationUserOrganizationsViewOrderBy>>;
  where?: InputMaybe<organizationOrganizationUserOrganizationsViewBoolExp>;
};


/** Brukere */
export type userorganizationsByOwnerIdArgs = {
  distinctOn?: InputMaybe<Array<organizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrderBy>>;
  where?: InputMaybe<organizationBoolExp>;
};


/** Brukere */
export type userorganizationsByOwnerIdAggregateArgs = {
  distinctOn?: InputMaybe<Array<organizationSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<organizationOrderBy>>;
  where?: InputMaybe<organizationBoolExp>;
};


/** Brukere */
export type userstatesArgs = {
  distinctOn?: InputMaybe<Array<BusinessUserStatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessUserStatesOrderBy>>;
  where?: InputMaybe<BusinessUserStatesBoolExp>;
};


/** Brukere */
export type userstatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessUserStatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessUserStatesOrderBy>>;
  where?: InputMaybe<BusinessUserStatesBoolExp>;
};


/** Brukere */
export type useruserFeedArgs = {
  distinctOn?: InputMaybe<Array<BusinessUserFeedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessUserFeedOrderBy>>;
  where?: InputMaybe<BusinessUserFeedBoolExp>;
};


/** Brukere */
export type useruserFeedAggregateArgs = {
  distinctOn?: InputMaybe<Array<BusinessUserFeedSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessUserFeedOrderBy>>;
  where?: InputMaybe<BusinessUserFeedBoolExp>;
};

/** aggregated selection of "business.users" */
export type userAggregate = {
  __typename?: 'userAggregate';
  aggregate?: Maybe<userAggregateFields>;
  nodes: Array<user>;
};

export type userAggregateBoolExp = {
  bool_and?: InputMaybe<userAggregateBoolExpBool_and>;
  bool_or?: InputMaybe<userAggregateBoolExpBool_or>;
  count?: InputMaybe<userAggregateBoolExpCount>;
};

export type userAggregateBoolExpBool_and = {
  arguments: userSelectColumnUserAggregateBoolExpBool_andArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<userBoolExp>;
  predicate: BooleanComparisonExp;
};

export type userAggregateBoolExpBool_or = {
  arguments: userSelectColumnUserAggregateBoolExpBool_orArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<userBoolExp>;
  predicate: BooleanComparisonExp;
};

export type userAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<userSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<userBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "business.users" */
export type userAggregateFields = {
  __typename?: 'userAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<userMaxFields>;
  min?: Maybe<userMinFields>;
};


/** aggregate fields of "business.users" */
export type userAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<userSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.users" */
export type userAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<userMaxOrderBy>;
  min?: InputMaybe<userMinOrderBy>;
};

/** input type for inserting array relation for remote table "business.users" */
export type userArrRelInsertInput = {
  data: Array<userInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<userOnConflict>;
};

/** Boolean expression to filter rows from the table "business.users". All fields are combined with a logical 'AND'. */
export type userBoolExp = {
  _and?: InputMaybe<Array<userBoolExp>>;
  _not?: InputMaybe<userBoolExp>;
  _or?: InputMaybe<Array<userBoolExp>>;
  authId?: InputMaybe<StringComparisonExp>;
  chosenLanguage?: InputMaybe<StringComparisonExp>;
  completedFirstTimeUser?: InputMaybe<BooleanComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customerCards?: InputMaybe<organizationUserBoolExp>;
  customerCardsAggregate?: InputMaybe<organizationUserAggregateBoolExp>;
  domainActivities?: InputMaybe<domainActivityBoolExp>;
  domainActivitiesAggregate?: InputMaybe<domainActivityAggregateBoolExp>;
  emailAddress?: InputMaybe<StringComparisonExp>;
  firstName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  image?: InputMaybe<StringComparisonExp>;
  lastName?: InputMaybe<StringComparisonExp>;
  lastSeen?: InputMaybe<TimestampComparisonExp>;
  messages?: InputMaybe<messagingMessageBoolExp>;
  messagesAggregate?: InputMaybe<messagingMessageAggregateBoolExp>;
  notes?: InputMaybe<messageBoolExp>;
  notesAggregate?: InputMaybe<messageAggregateBoolExp>;
  notificationUserDevices?: InputMaybe<notificationUserDeviceBoolExp>;
  notificationUserDevicesAggregate?: InputMaybe<notificationUserDeviceAggregateBoolExp>;
  orderIntegrations?: InputMaybe<ordersIntegrationsBoolExp>;
  organizationRequests?: InputMaybe<BusinessOrganizationUserRequestBoolExp>;
  organizationRequestsAggregate?: InputMaybe<BusinessOrganizationUserRequestAggregateBoolExp>;
  organizationUserInvitations?: InputMaybe<organizationUserInviteBoolExp>;
  organizationUserInvitationsAggregate?: InputMaybe<organizationUserInviteAggregateBoolExp>;
  organizationUsers?: InputMaybe<organizationUserBoolExp>;
  organizationUsersAggregate?: InputMaybe<organizationUserAggregateBoolExp>;
  organizations?: InputMaybe<organizationOrganizationUserOrganizationsViewBoolExp>;
  organizationsAggregate?: InputMaybe<organizationOrganizationUserOrganizationsViewAggregateBoolExp>;
  organizationsByOwnerId?: InputMaybe<organizationBoolExp>;
  organizationsByOwnerIdAggregate?: InputMaybe<organizationAggregateBoolExp>;
  organizations_object?: InputMaybe<organizationOrganizationUserUsersViewBoolExp>;
  phoneNumber?: InputMaybe<StringComparisonExp>;
  phoneNumberIsVerified?: InputMaybe<BooleanComparisonExp>;
  phoneState?: InputMaybe<StringComparisonExp>;
  states?: InputMaybe<BusinessUserStatesBoolExp>;
  statesAggregate?: InputMaybe<BusinessUserStatesAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userFeed?: InputMaybe<BusinessUserFeedBoolExp>;
  userFeedAggregate?: InputMaybe<BusinessUserFeedAggregateBoolExp>;
  username?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.users" */
export type userConstraint =
  /** unique or primary key constraint on columns "phone_number" */
  | 'users_phone_number_key'
  /** unique or primary key constraint on columns "id" */
  | 'users_pkey'
  /** unique or primary key constraint on columns "username" */
  | 'users_username_key'
  | '%future added value';

export type userDeleteOutput = {
  __typename?: 'userDeleteOutput';
  result: Scalars['String']['output'];
};

/** columns and relationships of "business.user_details" */
export type userDetail = {
  __typename?: 'userDetail';
  createdAt: Scalars['timestamp']['output'];
  id: Scalars['uuid']['output'];
  modifiedBy?: Maybe<Scalars['uuid']['output']>;
  type: userDetailsTypeEnum;
  updatedAt: Scalars['timestamp']['output'];
  userId: Scalars['uuid']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "business.user_details" */
export type userDetailAggregate = {
  __typename?: 'userDetailAggregate';
  aggregate?: Maybe<userDetailAggregateFields>;
  nodes: Array<userDetail>;
};

export type userDetailAggregateBoolExp = {
  count?: InputMaybe<userDetailAggregateBoolExpCount>;
};

export type userDetailAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<userDetailSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<userDetailBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "business.user_details" */
export type userDetailAggregateFields = {
  __typename?: 'userDetailAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<userDetailMaxFields>;
  min?: Maybe<userDetailMinFields>;
};


/** aggregate fields of "business.user_details" */
export type userDetailAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<userDetailSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "business.user_details" */
export type userDetailAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<userDetailMaxOrderBy>;
  min?: InputMaybe<userDetailMinOrderBy>;
};

/** input type for inserting array relation for remote table "business.user_details" */
export type userDetailArrRelInsertInput = {
  data: Array<userDetailInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<userDetailOnConflict>;
};

/** Boolean expression to filter rows from the table "business.user_details". All fields are combined with a logical 'AND'. */
export type userDetailBoolExp = {
  _and?: InputMaybe<Array<userDetailBoolExp>>;
  _not?: InputMaybe<userDetailBoolExp>;
  _or?: InputMaybe<Array<userDetailBoolExp>>;
  createdAt?: InputMaybe<TimestampComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  modifiedBy?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<UserDetailsTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestampComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.user_details" */
export type userDetailConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'user_details_pkey'
  /** unique or primary key constraint on columns "user_id", "type" */
  | 'user_details_user_id_type_key'
  | '%future added value';

/** input type for inserting data into table "business.user_details" */
export type userDetailInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  modifiedBy?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<userDetailsTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type userDetailMaxFields = {
  __typename?: 'userDetailMaxFields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  modifiedBy?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "business.user_details" */
export type userDetailMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  modifiedBy?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type userDetailMinFields = {
  __typename?: 'userDetailMinFields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  modifiedBy?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "business.user_details" */
export type userDetailMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  modifiedBy?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "business.user_details" */
export type userDetailMutationResponse = {
  __typename?: 'userDetailMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<userDetail>;
};

/** on_conflict condition type for table "business.user_details" */
export type userDetailOnConflict = {
  constraint: userDetailConstraint;
  updateColumns?: Array<userDetailUpdateColumn>;
  where?: InputMaybe<userDetailBoolExp>;
};

/** Ordering options when selecting data from "business.user_details". */
export type userDetailOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  modifiedBy?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.user_details */
export type userDetailPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "business.user_details" */
export type userDetailSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'modifiedBy'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "business.user_details" */
export type userDetailSetInput = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  modifiedBy?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<userDetailsTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "userDetail" */
export type userDetailStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: userDetailStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type userDetailStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  modifiedBy?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<userDetailsTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.user_details" */
export type userDetailUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'modifiedBy'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  /** column name */
  | 'value'
  | '%future added value';

export type userDetailUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<userDetailSetInput>;
  /** filter the rows which have to be updated */
  where: userDetailBoolExp;
};

/** columns and relationships of "business.user_details_type" */
export type userDetailsType = {
  __typename?: 'userDetailsType';
  description: Scalars['String']['output'];
  /** fetch aggregated fields from the table: "business.user_details" */
  userDetailsAggregate: userDetailAggregate;
  /** An array relationship */
  user_details: Array<userDetail>;
  value: Scalars['String']['output'];
};


/** columns and relationships of "business.user_details_type" */
export type userDetailsTypeuserDetailsAggregateArgs = {
  distinctOn?: InputMaybe<Array<userDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<userDetailOrderBy>>;
  where?: InputMaybe<userDetailBoolExp>;
};


/** columns and relationships of "business.user_details_type" */
export type userDetailsTypeuser_detailsArgs = {
  distinctOn?: InputMaybe<Array<userDetailSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<userDetailOrderBy>>;
  where?: InputMaybe<userDetailBoolExp>;
};

/** aggregated selection of "business.user_details_type" */
export type userDetailsTypeAggregate = {
  __typename?: 'userDetailsTypeAggregate';
  aggregate?: Maybe<userDetailsTypeAggregateFields>;
  nodes: Array<userDetailsType>;
};

/** aggregate fields of "business.user_details_type" */
export type userDetailsTypeAggregateFields = {
  __typename?: 'userDetailsTypeAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<userDetailsTypeMaxFields>;
  min?: Maybe<userDetailsTypeMinFields>;
};


/** aggregate fields of "business.user_details_type" */
export type userDetailsTypeAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<userDetailsTypeSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.user_details_type". All fields are combined with a logical 'AND'. */
export type userDetailsTypeBoolExp = {
  _and?: InputMaybe<Array<userDetailsTypeBoolExp>>;
  _not?: InputMaybe<userDetailsTypeBoolExp>;
  _or?: InputMaybe<Array<userDetailsTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  user_details?: InputMaybe<userDetailBoolExp>;
  user_detailsAggregate?: InputMaybe<userDetailAggregateBoolExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.user_details_type" */
export type userDetailsTypeConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'user_details_type_pkey'
  | '%future added value';

export type userDetailsTypeEnum =
  /** city */
  | 'CITY'
  /** email */
  | 'EMAIL'
  /** firstname */
  | 'FIRSTNAME'
  /** lastname */
  | 'LASTNAME'
  /** phonenumber */
  | 'PHONENUMBER'
  /** street */
  | 'STREET'
  /** zip */
  | 'ZIP'
  | '%future added value';

/** input type for inserting data into table "business.user_details_type" */
export type userDetailsTypeInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  user_details?: InputMaybe<userDetailArrRelInsertInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type userDetailsTypeMaxFields = {
  __typename?: 'userDetailsTypeMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type userDetailsTypeMinFields = {
  __typename?: 'userDetailsTypeMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.user_details_type" */
export type userDetailsTypeMutationResponse = {
  __typename?: 'userDetailsTypeMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<userDetailsType>;
};

/** on_conflict condition type for table "business.user_details_type" */
export type userDetailsTypeOnConflict = {
  constraint: userDetailsTypeConstraint;
  updateColumns?: Array<userDetailsTypeUpdateColumn>;
  where?: InputMaybe<userDetailsTypeBoolExp>;
};

/** Ordering options when selecting data from "business.user_details_type". */
export type userDetailsTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  user_detailsAggregate?: InputMaybe<userDetailAggregateOrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.user_details_type */
export type userDetailsTypePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "business.user_details_type" */
export type userDetailsTypeSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "business.user_details_type" */
export type userDetailsTypeSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "userDetailsType" */
export type userDetailsTypeStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: userDetailsTypeStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type userDetailsTypeStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.user_details_type" */
export type userDetailsTypeUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type userDetailsTypeUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<userDetailsTypeSetInput>;
  /** filter the rows which have to be updated */
  where: userDetailsTypeBoolExp;
};

/** columns and relationships of "business.user_devices" */
export type userDevice = {
  __typename?: 'userDevice';
  deviceBrand?: Maybe<Scalars['String']['output']>;
  deviceIsDevice?: Maybe<Scalars['Boolean']['output']>;
  deviceModel?: Maybe<Scalars['String']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  deviceOs?: Maybe<Scalars['String']['output']>;
  deviceOsVersion?: Maybe<Scalars['String']['output']>;
  devicePushToken?: Maybe<Scalars['String']['output']>;
  deviceYear?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "business.user_devices" */
export type userDeviceAggregate = {
  __typename?: 'userDeviceAggregate';
  aggregate?: Maybe<userDeviceAggregateFields>;
  nodes: Array<userDevice>;
};

/** aggregate fields of "business.user_devices" */
export type userDeviceAggregateFields = {
  __typename?: 'userDeviceAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<userDeviceMaxFields>;
  min?: Maybe<userDeviceMinFields>;
};


/** aggregate fields of "business.user_devices" */
export type userDeviceAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<userDeviceSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.user_devices". All fields are combined with a logical 'AND'. */
export type userDeviceBoolExp = {
  _and?: InputMaybe<Array<userDeviceBoolExp>>;
  _not?: InputMaybe<userDeviceBoolExp>;
  _or?: InputMaybe<Array<userDeviceBoolExp>>;
  deviceBrand?: InputMaybe<StringComparisonExp>;
  deviceIsDevice?: InputMaybe<BooleanComparisonExp>;
  deviceModel?: InputMaybe<StringComparisonExp>;
  deviceName?: InputMaybe<StringComparisonExp>;
  deviceOs?: InputMaybe<StringComparisonExp>;
  deviceOsVersion?: InputMaybe<StringComparisonExp>;
  devicePushToken?: InputMaybe<StringComparisonExp>;
  deviceYear?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "business.user_devices" */
export type userDeviceConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'user_devices_pkey'
  | '%future added value';

/** input type for inserting data into table "business.user_devices" */
export type userDeviceInsertInput = {
  deviceBrand?: InputMaybe<Scalars['String']['input']>;
  deviceIsDevice?: InputMaybe<Scalars['Boolean']['input']>;
  deviceModel?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  deviceOs?: InputMaybe<Scalars['String']['input']>;
  deviceOsVersion?: InputMaybe<Scalars['String']['input']>;
  devicePushToken?: InputMaybe<Scalars['String']['input']>;
  deviceYear?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type userDeviceMaxFields = {
  __typename?: 'userDeviceMaxFields';
  deviceBrand?: Maybe<Scalars['String']['output']>;
  deviceModel?: Maybe<Scalars['String']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  deviceOs?: Maybe<Scalars['String']['output']>;
  deviceOsVersion?: Maybe<Scalars['String']['output']>;
  devicePushToken?: Maybe<Scalars['String']['output']>;
  deviceYear?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type userDeviceMinFields = {
  __typename?: 'userDeviceMinFields';
  deviceBrand?: Maybe<Scalars['String']['output']>;
  deviceModel?: Maybe<Scalars['String']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  deviceOs?: Maybe<Scalars['String']['output']>;
  deviceOsVersion?: Maybe<Scalars['String']['output']>;
  devicePushToken?: Maybe<Scalars['String']['output']>;
  deviceYear?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "business.user_devices" */
export type userDeviceMutationResponse = {
  __typename?: 'userDeviceMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<userDevice>;
};

/** on_conflict condition type for table "business.user_devices" */
export type userDeviceOnConflict = {
  constraint: userDeviceConstraint;
  updateColumns?: Array<userDeviceUpdateColumn>;
  where?: InputMaybe<userDeviceBoolExp>;
};

/** Ordering options when selecting data from "business.user_devices". */
export type userDeviceOrderBy = {
  deviceBrand?: InputMaybe<OrderBy>;
  deviceIsDevice?: InputMaybe<OrderBy>;
  deviceModel?: InputMaybe<OrderBy>;
  deviceName?: InputMaybe<OrderBy>;
  deviceOs?: InputMaybe<OrderBy>;
  deviceOsVersion?: InputMaybe<OrderBy>;
  devicePushToken?: InputMaybe<OrderBy>;
  deviceYear?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.user_devices */
export type userDevicePkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "business.user_devices" */
export type userDeviceSelectColumn =
  /** column name */
  | 'deviceBrand'
  /** column name */
  | 'deviceIsDevice'
  /** column name */
  | 'deviceModel'
  /** column name */
  | 'deviceName'
  /** column name */
  | 'deviceOs'
  /** column name */
  | 'deviceOsVersion'
  /** column name */
  | 'devicePushToken'
  /** column name */
  | 'deviceYear'
  /** column name */
  | 'id'
  /** column name */
  | 'userId'
  | '%future added value';

/** input type for updating data in table "business.user_devices" */
export type userDeviceSetInput = {
  deviceBrand?: InputMaybe<Scalars['String']['input']>;
  deviceIsDevice?: InputMaybe<Scalars['Boolean']['input']>;
  deviceModel?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  deviceOs?: InputMaybe<Scalars['String']['input']>;
  deviceOsVersion?: InputMaybe<Scalars['String']['input']>;
  devicePushToken?: InputMaybe<Scalars['String']['input']>;
  deviceYear?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "userDevice" */
export type userDeviceStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: userDeviceStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type userDeviceStreamCursorValueInput = {
  deviceBrand?: InputMaybe<Scalars['String']['input']>;
  deviceIsDevice?: InputMaybe<Scalars['Boolean']['input']>;
  deviceModel?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  deviceOs?: InputMaybe<Scalars['String']['input']>;
  deviceOsVersion?: InputMaybe<Scalars['String']['input']>;
  devicePushToken?: InputMaybe<Scalars['String']['input']>;
  deviceYear?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "business.user_devices" */
export type userDeviceUpdateColumn =
  /** column name */
  | 'deviceBrand'
  /** column name */
  | 'deviceIsDevice'
  /** column name */
  | 'deviceModel'
  /** column name */
  | 'deviceName'
  /** column name */
  | 'deviceOs'
  /** column name */
  | 'deviceOsVersion'
  /** column name */
  | 'devicePushToken'
  /** column name */
  | 'deviceYear'
  /** column name */
  | 'id'
  /** column name */
  | 'userId'
  | '%future added value';

export type userDeviceUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<userDeviceSetInput>;
  /** filter the rows which have to be updated */
  where: userDeviceBoolExp;
};

export type userInput = {
  id: Scalars['uuid']['input'];
};

/** input type for inserting data into table "business.users" */
export type userInsertInput = {
  authId?: InputMaybe<Scalars['String']['input']>;
  chosenLanguage?: InputMaybe<Scalars['String']['input']>;
  completedFirstTimeUser?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customerCards?: InputMaybe<organizationUserArrRelInsertInput>;
  domainActivities?: InputMaybe<domainActivityArrRelInsertInput>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastSeen?: InputMaybe<Scalars['timestamp']['input']>;
  messages?: InputMaybe<messagingMessageArrRelInsertInput>;
  notes?: InputMaybe<messageArrRelInsertInput>;
  notificationUserDevices?: InputMaybe<notificationUserDeviceArrRelInsertInput>;
  orderIntegrations?: InputMaybe<ordersIntegrationsObjRelInsertInput>;
  organizationRequests?: InputMaybe<BusinessOrganizationUserRequestArrRelInsertInput>;
  organizationUserInvitations?: InputMaybe<organizationUserInviteArrRelInsertInput>;
  organizationUsers?: InputMaybe<organizationUserArrRelInsertInput>;
  organizations?: InputMaybe<organizationOrganizationUserOrganizationsViewArrRelInsertInput>;
  organizationsByOwnerId?: InputMaybe<organizationArrRelInsertInput>;
  organizations_object?: InputMaybe<organizationOrganizationUserUsersViewObjRelInsertInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIsVerified?: InputMaybe<Scalars['Boolean']['input']>;
  phoneState?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<BusinessUserStatesArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userFeed?: InputMaybe<BusinessUserFeedArrRelInsertInput>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type userMaxFields = {
  __typename?: 'userMaxFields';
  authId?: Maybe<Scalars['String']['output']>;
  chosenLanguage?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastSeen?: Maybe<Scalars['timestamp']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneState?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "business.users" */
export type userMaxOrderBy = {
  authId?: InputMaybe<OrderBy>;
  chosenLanguage?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  emailAddress?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  image?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  lastSeen?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  phoneState?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  username?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type userMinFields = {
  __typename?: 'userMinFields';
  authId?: Maybe<Scalars['String']['output']>;
  chosenLanguage?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastSeen?: Maybe<Scalars['timestamp']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneState?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "business.users" */
export type userMinOrderBy = {
  authId?: InputMaybe<OrderBy>;
  chosenLanguage?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  emailAddress?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  image?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  lastSeen?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  phoneState?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  username?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "business.users" */
export type userMutationResponse = {
  __typename?: 'userMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<user>;
};

/** input type for inserting object relation for remote table "business.users" */
export type userObjRelInsertInput = {
  data: userInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<userOnConflict>;
};

/** on_conflict condition type for table "business.users" */
export type userOnConflict = {
  constraint: userConstraint;
  updateColumns?: Array<userUpdateColumn>;
  where?: InputMaybe<userBoolExp>;
};

/** Ordering options when selecting data from "business.users". */
export type userOrderBy = {
  authId?: InputMaybe<OrderBy>;
  chosenLanguage?: InputMaybe<OrderBy>;
  completedFirstTimeUser?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customerCardsAggregate?: InputMaybe<organizationUserAggregateOrderBy>;
  domainActivitiesAggregate?: InputMaybe<domainActivityAggregateOrderBy>;
  emailAddress?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  image?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  lastSeen?: InputMaybe<OrderBy>;
  messagesAggregate?: InputMaybe<messagingMessageAggregateOrderBy>;
  notesAggregate?: InputMaybe<messageAggregateOrderBy>;
  notificationUserDevicesAggregate?: InputMaybe<notificationUserDeviceAggregateOrderBy>;
  orderIntegrations?: InputMaybe<ordersIntegrationsOrderBy>;
  organizationRequestsAggregate?: InputMaybe<BusinessOrganizationUserRequestAggregateOrderBy>;
  organizationUserInvitationsAggregate?: InputMaybe<organizationUserInviteAggregateOrderBy>;
  organizationUsersAggregate?: InputMaybe<organizationUserAggregateOrderBy>;
  organizationsAggregate?: InputMaybe<organizationOrganizationUserOrganizationsViewAggregateOrderBy>;
  organizationsByOwnerIdAggregate?: InputMaybe<organizationAggregateOrderBy>;
  organizations_object?: InputMaybe<organizationOrganizationUserUsersViewOrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  phoneNumberIsVerified?: InputMaybe<OrderBy>;
  phoneState?: InputMaybe<OrderBy>;
  statesAggregate?: InputMaybe<BusinessUserStatesAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userFeedAggregate?: InputMaybe<BusinessUserFeedAggregateOrderBy>;
  username?: InputMaybe<OrderBy>;
};

/** columns and relationships of "business.user_phone_numbers" */
export type userPhoneNumber = {
  __typename?: 'userPhoneNumber';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  mobileNumber: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  userId: Scalars['uuid']['output'];
  verificationStatus?: Maybe<phoneNumberVerificationStatusEnum>;
};

/** aggregated selection of "business.user_phone_numbers" */
export type userPhoneNumberAggregate = {
  __typename?: 'userPhoneNumberAggregate';
  aggregate?: Maybe<userPhoneNumberAggregateFields>;
  nodes: Array<userPhoneNumber>;
};

/** aggregate fields of "business.user_phone_numbers" */
export type userPhoneNumberAggregateFields = {
  __typename?: 'userPhoneNumberAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<userPhoneNumberMaxFields>;
  min?: Maybe<userPhoneNumberMinFields>;
};


/** aggregate fields of "business.user_phone_numbers" */
export type userPhoneNumberAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<userPhoneNumberSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.user_phone_numbers". All fields are combined with a logical 'AND'. */
export type userPhoneNumberBoolExp = {
  _and?: InputMaybe<Array<userPhoneNumberBoolExp>>;
  _not?: InputMaybe<userPhoneNumberBoolExp>;
  _or?: InputMaybe<Array<userPhoneNumberBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  mobileNumber?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  verificationStatus?: InputMaybe<PhoneNumberVerificationStatusEnumComparisonExp>;
};

/** unique or primary key constraints on table "business.user_phone_numbers" */
export type userPhoneNumberConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'user_phone_numbers_pkey'
  | '%future added value';

/** input type for inserting data into table "business.user_phone_numbers" */
export type userPhoneNumberInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  verificationStatus?: InputMaybe<phoneNumberVerificationStatusEnum>;
};

/** aggregate max on columns */
export type userPhoneNumberMaxFields = {
  __typename?: 'userPhoneNumberMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mobileNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type userPhoneNumberMinFields = {
  __typename?: 'userPhoneNumberMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mobileNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "business.user_phone_numbers" */
export type userPhoneNumberMutationResponse = {
  __typename?: 'userPhoneNumberMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<userPhoneNumber>;
};

/** on_conflict condition type for table "business.user_phone_numbers" */
export type userPhoneNumberOnConflict = {
  constraint: userPhoneNumberConstraint;
  updateColumns?: Array<userPhoneNumberUpdateColumn>;
  where?: InputMaybe<userPhoneNumberBoolExp>;
};

/** Ordering options when selecting data from "business.user_phone_numbers". */
export type userPhoneNumberOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  mobileNumber?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  verificationStatus?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.user_phone_numbers */
export type userPhoneNumberPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "business.user_phone_numbers" */
export type userPhoneNumberSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'mobileNumber'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  /** column name */
  | 'verificationStatus'
  | '%future added value';

/** input type for updating data in table "business.user_phone_numbers" */
export type userPhoneNumberSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  verificationStatus?: InputMaybe<phoneNumberVerificationStatusEnum>;
};

/** Streaming cursor of the table "userPhoneNumber" */
export type userPhoneNumberStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: userPhoneNumberStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type userPhoneNumberStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  verificationStatus?: InputMaybe<phoneNumberVerificationStatusEnum>;
};

/** update columns of table "business.user_phone_numbers" */
export type userPhoneNumberUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'mobileNumber'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'userId'
  /** column name */
  | 'verificationStatus'
  | '%future added value';

export type userPhoneNumberUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<userPhoneNumberSetInput>;
  /** filter the rows which have to be updated */
  where: userPhoneNumberBoolExp;
};

/** primary key columns input for table: business.users */
export type userPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "business.user_role" */
export type userRole = {
  __typename?: 'userRole';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "business.user_role" */
export type userRoleAggregate = {
  __typename?: 'userRoleAggregate';
  aggregate?: Maybe<userRoleAggregateFields>;
  nodes: Array<userRole>;
};

/** aggregate fields of "business.user_role" */
export type userRoleAggregateFields = {
  __typename?: 'userRoleAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<userRoleMaxFields>;
  min?: Maybe<userRoleMinFields>;
};


/** aggregate fields of "business.user_role" */
export type userRoleAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<userRoleSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "business.user_role". All fields are combined with a logical 'AND'. */
export type userRoleBoolExp = {
  _and?: InputMaybe<Array<userRoleBoolExp>>;
  _not?: InputMaybe<userRoleBoolExp>;
  _or?: InputMaybe<Array<userRoleBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "business.user_role" */
export type userRoleConstraint =
  /** unique or primary key constraint on columns "value" */
  | 'user_role_pkey'
  | '%future added value';

export type userRoleEnum =
  /** COMPANY */
  | 'COMPANY'
  /** Customer */
  | 'CUSTOMER'
  /** Employee */
  | 'EMPLOYEE'
  | '%future added value';

/** input type for inserting data into table "business.user_role" */
export type userRoleInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type userRoleMaxFields = {
  __typename?: 'userRoleMaxFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type userRoleMinFields = {
  __typename?: 'userRoleMinFields';
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "business.user_role" */
export type userRoleMutationResponse = {
  __typename?: 'userRoleMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<userRole>;
};

/** on_conflict condition type for table "business.user_role" */
export type userRoleOnConflict = {
  constraint: userRoleConstraint;
  updateColumns?: Array<userRoleUpdateColumn>;
  where?: InputMaybe<userRoleBoolExp>;
};

/** Ordering options when selecting data from "business.user_role". */
export type userRoleOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: business.user_role */
export type userRolePkColumnsInput = {
  value: Scalars['String']['input'];
};

/** select columns of table "business.user_role" */
export type userRoleSelectColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

/** input type for updating data in table "business.user_role" */
export type userRoleSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "userRole" */
export type userRoleStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: userRoleStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type userRoleStreamCursorValueInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.user_role" */
export type userRoleUpdateColumn =
  /** column name */
  | 'description'
  /** column name */
  | 'value'
  | '%future added value';

export type userRoleUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<userRoleSetInput>;
  /** filter the rows which have to be updated */
  where: userRoleBoolExp;
};

/** select columns of table "business.users" */
export type userSelectColumn =
  /** column name */
  | 'authId'
  /** column name */
  | 'chosenLanguage'
  /** column name */
  | 'completedFirstTimeUser'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'emailAddress'
  /** column name */
  | 'firstName'
  /** column name */
  | 'id'
  /** column name */
  | 'image'
  /** column name */
  | 'lastName'
  /** column name */
  | 'lastSeen'
  /** column name */
  | 'phoneNumber'
  /** column name */
  | 'phoneNumberIsVerified'
  /** column name */
  | 'phoneState'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'username'
  | '%future added value';

/** select "userAggregateBoolExpBool_andArgumentsColumns" columns of table "business.users" */
export type userSelectColumnUserAggregateBoolExpBool_andArgumentsColumns =
  /** column name */
  | 'completedFirstTimeUser'
  /** column name */
  | 'phoneNumberIsVerified'
  | '%future added value';

/** select "userAggregateBoolExpBool_orArgumentsColumns" columns of table "business.users" */
export type userSelectColumnUserAggregateBoolExpBool_orArgumentsColumns =
  /** column name */
  | 'completedFirstTimeUser'
  /** column name */
  | 'phoneNumberIsVerified'
  | '%future added value';

/** input type for updating data in table "business.users" */
export type userSetInput = {
  authId?: InputMaybe<Scalars['String']['input']>;
  chosenLanguage?: InputMaybe<Scalars['String']['input']>;
  completedFirstTimeUser?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastSeen?: InputMaybe<Scalars['timestamp']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIsVerified?: InputMaybe<Scalars['Boolean']['input']>;
  phoneState?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "user" */
export type userStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: userStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type userStreamCursorValueInput = {
  authId?: InputMaybe<Scalars['String']['input']>;
  chosenLanguage?: InputMaybe<Scalars['String']['input']>;
  completedFirstTimeUser?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastSeen?: InputMaybe<Scalars['timestamp']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberIsVerified?: InputMaybe<Scalars['Boolean']['input']>;
  phoneState?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "business.users" */
export type userUpdateColumn =
  /** column name */
  | 'authId'
  /** column name */
  | 'chosenLanguage'
  /** column name */
  | 'completedFirstTimeUser'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'emailAddress'
  /** column name */
  | 'firstName'
  /** column name */
  | 'id'
  /** column name */
  | 'image'
  /** column name */
  | 'lastName'
  /** column name */
  | 'lastSeen'
  /** column name */
  | 'phoneNumber'
  /** column name */
  | 'phoneNumberIsVerified'
  /** column name */
  | 'phoneState'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'username'
  | '%future added value';

export type userUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<userSetInput>;
  /** filter the rows which have to be updated */
  where: userBoolExp;
};

/** columns and relationships of "validation.validation" */
export type validationValidation = {
  __typename?: 'validationValidation';
  createdAt: Scalars['timestamptz']['output'];
  expireTime?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  used: Scalars['Boolean']['output'];
  userId: Scalars['uuid']['output'];
  validateItem?: Maybe<Scalars['String']['output']>;
  verificationCode: Scalars['String']['output'];
};

/** aggregated selection of "validation.validation" */
export type validationValidationAggregate = {
  __typename?: 'validationValidationAggregate';
  aggregate?: Maybe<validationValidationAggregateFields>;
  nodes: Array<validationValidation>;
};

/** aggregate fields of "validation.validation" */
export type validationValidationAggregateFields = {
  __typename?: 'validationValidationAggregateFields';
  avg?: Maybe<validationValidationAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<validationValidationMaxFields>;
  min?: Maybe<validationValidationMinFields>;
  stddev?: Maybe<validationValidationStddevFields>;
  stddevPop?: Maybe<validationValidationStddevPopFields>;
  stddevSamp?: Maybe<validationValidationStddevSampFields>;
  sum?: Maybe<validationValidationSumFields>;
  varPop?: Maybe<validationValidationVarPopFields>;
  varSamp?: Maybe<validationValidationVarSampFields>;
  variance?: Maybe<validationValidationVarianceFields>;
};


/** aggregate fields of "validation.validation" */
export type validationValidationAggregateFieldscountArgs = {
  columns?: InputMaybe<Array<validationValidationSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type validationValidationAvgFields = {
  __typename?: 'validationValidationAvgFields';
  expireTime?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "validation.validation". All fields are combined with a logical 'AND'. */
export type validationValidationBoolExp = {
  _and?: InputMaybe<Array<validationValidationBoolExp>>;
  _not?: InputMaybe<validationValidationBoolExp>;
  _or?: InputMaybe<Array<validationValidationBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  expireTime?: InputMaybe<NumericComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  used?: InputMaybe<BooleanComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  validateItem?: InputMaybe<StringComparisonExp>;
  verificationCode?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "validation.validation" */
export type validationValidationConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'validation_pkey'
  | '%future added value';

/** input type for incrementing numeric columns in table "validation.validation" */
export type validationValidationIncInput = {
  expireTime?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "validation.validation" */
export type validationValidationInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  expireTime?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  used?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  validateItem?: InputMaybe<Scalars['String']['input']>;
  verificationCode?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type validationValidationMaxFields = {
  __typename?: 'validationValidationMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  expireTime?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  validateItem?: Maybe<Scalars['String']['output']>;
  verificationCode?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type validationValidationMinFields = {
  __typename?: 'validationValidationMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  expireTime?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  validateItem?: Maybe<Scalars['String']['output']>;
  verificationCode?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "validation.validation" */
export type validationValidationMutationResponse = {
  __typename?: 'validationValidationMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<validationValidation>;
};

/** on_conflict condition type for table "validation.validation" */
export type validationValidationOnConflict = {
  constraint: validationValidationConstraint;
  updateColumns?: Array<validationValidationUpdateColumn>;
  where?: InputMaybe<validationValidationBoolExp>;
};

/** Ordering options when selecting data from "validation.validation". */
export type validationValidationOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  expireTime?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  used?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  validateItem?: InputMaybe<OrderBy>;
  verificationCode?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: validation.validation */
export type validationValidationPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "validation.validation" */
export type validationValidationSelectColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'expireTime'
  /** column name */
  | 'id'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'used'
  /** column name */
  | 'userId'
  /** column name */
  | 'validateItem'
  /** column name */
  | 'verificationCode'
  | '%future added value';

/** input type for updating data in table "validation.validation" */
export type validationValidationSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  expireTime?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  used?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  validateItem?: InputMaybe<Scalars['String']['input']>;
  verificationCode?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type validationValidationStddevFields = {
  __typename?: 'validationValidationStddevFields';
  expireTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type validationValidationStddevPopFields = {
  __typename?: 'validationValidationStddevPopFields';
  expireTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type validationValidationStddevSampFields = {
  __typename?: 'validationValidationStddevSampFields';
  expireTime?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "validationValidation" */
export type validationValidationStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: validationValidationStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type validationValidationStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  expireTime?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  used?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  validateItem?: InputMaybe<Scalars['String']['input']>;
  verificationCode?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type validationValidationSumFields = {
  __typename?: 'validationValidationSumFields';
  expireTime?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "validation.validation" */
export type validationValidationUpdateColumn =
  /** column name */
  | 'createdAt'
  /** column name */
  | 'expireTime'
  /** column name */
  | 'id'
  /** column name */
  | 'type'
  /** column name */
  | 'updatedAt'
  /** column name */
  | 'used'
  /** column name */
  | 'userId'
  /** column name */
  | 'validateItem'
  /** column name */
  | 'verificationCode'
  | '%future added value';

export type validationValidationUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<validationValidationIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<validationValidationSetInput>;
  /** filter the rows which have to be updated */
  where: validationValidationBoolExp;
};

/** aggregate varPop on columns */
export type validationValidationVarPopFields = {
  __typename?: 'validationValidationVarPopFields';
  expireTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type validationValidationVarSampFields = {
  __typename?: 'validationValidationVarSampFields';
  expireTime?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type validationValidationVarianceFields = {
  __typename?: 'validationValidationVarianceFields';
  expireTime?: Maybe<Scalars['Float']['output']>;
};

export type verifyOrganizationUserPhoneNumberInput = {
  verificationCode: Scalars['String']['input'];
};

export type verifyOrganizationUserPhoneNumberOutput = {
  __typename?: 'verifyOrganizationUserPhoneNumberOutput';
  verificationStatus: Scalars['String']['output'];
};

export type videoInviteOrgUserInput = {
  body: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  from: Scalars['String']['input'];
  organizationUserId: Scalars['uuid']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type videoInviteOrgUserOutput = {
  __typename?: 'videoInviteOrgUserOutput';
  result: Scalars['json']['output'];
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;



/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  ActivityDirection: ResolverTypeWrapper<ActivityDirection>;
  ActivityDirectionAggregate: ResolverTypeWrapper<ActivityDirectionAggregate>;
  ActivityDirectionAggregateFields: ResolverTypeWrapper<ActivityDirectionAggregateFields>;
  ActivityDirectionBoolExp: ActivityDirectionBoolExp;
  ActivityDirectionConstraint: ActivityDirectionConstraint;
  ActivityDirectionEnum: ActivityDirectionEnum;
  ActivityDirectionEnumComparisonExp: ActivityDirectionEnumComparisonExp;
  ActivityDirectionInsertInput: ActivityDirectionInsertInput;
  ActivityDirectionMaxFields: ResolverTypeWrapper<ActivityDirectionMaxFields>;
  ActivityDirectionMinFields: ResolverTypeWrapper<ActivityDirectionMinFields>;
  ActivityDirectionMutationResponse: ResolverTypeWrapper<ActivityDirectionMutationResponse>;
  ActivityDirectionOnConflict: ActivityDirectionOnConflict;
  ActivityDirectionOrderBy: ActivityDirectionOrderBy;
  ActivityDirectionPkColumnsInput: ActivityDirectionPkColumnsInput;
  ActivityDirectionSelectColumn: ActivityDirectionSelectColumn;
  ActivityDirectionSetInput: ActivityDirectionSetInput;
  ActivityDirectionStreamCursorInput: ActivityDirectionStreamCursorInput;
  ActivityDirectionStreamCursorValueInput: ActivityDirectionStreamCursorValueInput;
  ActivityDirectionUpdateColumn: ActivityDirectionUpdateColumn;
  ActivityDirectionUpdates: ActivityDirectionUpdates;
  ActivityProvider: ResolverTypeWrapper<ActivityProvider>;
  ActivityProviderAggregate: ResolverTypeWrapper<ActivityProviderAggregate>;
  ActivityProviderAggregateFields: ResolverTypeWrapper<ActivityProviderAggregateFields>;
  ActivityProviderBoolExp: ActivityProviderBoolExp;
  ActivityProviderConstraint: ActivityProviderConstraint;
  ActivityProviderEnum: ActivityProviderEnum;
  ActivityProviderEnumComparisonExp: ActivityProviderEnumComparisonExp;
  ActivityProviderInsertInput: ActivityProviderInsertInput;
  ActivityProviderMaxFields: ResolverTypeWrapper<ActivityProviderMaxFields>;
  ActivityProviderMinFields: ResolverTypeWrapper<ActivityProviderMinFields>;
  ActivityProviderMutationResponse: ResolverTypeWrapper<ActivityProviderMutationResponse>;
  ActivityProviderOnConflict: ActivityProviderOnConflict;
  ActivityProviderOrderBy: ActivityProviderOrderBy;
  ActivityProviderPkColumnsInput: ActivityProviderPkColumnsInput;
  ActivityProviderSelectColumn: ActivityProviderSelectColumn;
  ActivityProviderSetInput: ActivityProviderSetInput;
  ActivityProviderStreamCursorInput: ActivityProviderStreamCursorInput;
  ActivityProviderStreamCursorValueInput: ActivityProviderStreamCursorValueInput;
  ActivityProviderUpdateColumn: ActivityProviderUpdateColumn;
  ActivityProviderUpdates: ActivityProviderUpdates;
  ActivityStatus: ResolverTypeWrapper<ActivityStatus>;
  ActivityStatusAggregate: ResolverTypeWrapper<ActivityStatusAggregate>;
  ActivityStatusAggregateFields: ResolverTypeWrapper<ActivityStatusAggregateFields>;
  ActivityStatusBoolExp: ActivityStatusBoolExp;
  ActivityStatusConstraint: ActivityStatusConstraint;
  ActivityStatusEnum: ActivityStatusEnum;
  ActivityStatusEnumComparisonExp: ActivityStatusEnumComparisonExp;
  ActivityStatusInsertInput: ActivityStatusInsertInput;
  ActivityStatusMaxFields: ResolverTypeWrapper<ActivityStatusMaxFields>;
  ActivityStatusMinFields: ResolverTypeWrapper<ActivityStatusMinFields>;
  ActivityStatusMutationResponse: ResolverTypeWrapper<ActivityStatusMutationResponse>;
  ActivityStatusObjRelInsertInput: ActivityStatusObjRelInsertInput;
  ActivityStatusOnConflict: ActivityStatusOnConflict;
  ActivityStatusOrderBy: ActivityStatusOrderBy;
  ActivityStatusPkColumnsInput: ActivityStatusPkColumnsInput;
  ActivityStatusSelectColumn: ActivityStatusSelectColumn;
  ActivityStatusSetInput: ActivityStatusSetInput;
  ActivityStatusStreamCursorInput: ActivityStatusStreamCursorInput;
  ActivityStatusStreamCursorValueInput: ActivityStatusStreamCursorValueInput;
  ActivityStatusUpdateColumn: ActivityStatusUpdateColumn;
  ActivityStatusUpdates: ActivityStatusUpdates;
  ActivityType: ResolverTypeWrapper<ActivityType>;
  ActivityTypeAggregate: ResolverTypeWrapper<ActivityTypeAggregate>;
  ActivityTypeAggregateFields: ResolverTypeWrapper<ActivityTypeAggregateFields>;
  ActivityTypeBoolExp: ActivityTypeBoolExp;
  ActivityTypeConstraint: ActivityTypeConstraint;
  ActivityTypeEnum: ActivityTypeEnum;
  ActivityTypeEnumComparisonExp: ActivityTypeEnumComparisonExp;
  ActivityTypeInsertInput: ActivityTypeInsertInput;
  ActivityTypeMaxFields: ResolverTypeWrapper<ActivityTypeMaxFields>;
  ActivityTypeMinFields: ResolverTypeWrapper<ActivityTypeMinFields>;
  ActivityTypeMutationResponse: ResolverTypeWrapper<ActivityTypeMutationResponse>;
  ActivityTypeObjRelInsertInput: ActivityTypeObjRelInsertInput;
  ActivityTypeOnConflict: ActivityTypeOnConflict;
  ActivityTypeOrderBy: ActivityTypeOrderBy;
  ActivityTypePkColumnsInput: ActivityTypePkColumnsInput;
  ActivityTypeSelectColumn: ActivityTypeSelectColumn;
  ActivityTypeSetInput: ActivityTypeSetInput;
  ActivityTypeStreamCursorInput: ActivityTypeStreamCursorInput;
  ActivityTypeStreamCursorValueInput: ActivityTypeStreamCursorValueInput;
  ActivityTypeUpdateColumn: ActivityTypeUpdateColumn;
  ActivityTypeUpdates: ActivityTypeUpdates;
  AddDomainUserToOrganizationOutput: ResolverTypeWrapper<AddDomainUserToOrganizationOutput>;
  BlockUserOutput: ResolverTypeWrapper<BlockUserOutput>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  BooleanComparisonExp: BooleanComparisonExp;
  BusinessAddress: ResolverTypeWrapper<BusinessAddress>;
  BusinessDomainActivityType: ResolverTypeWrapper<BusinessDomainActivityType>;
  BusinessDomainActivityTypeAggregate: ResolverTypeWrapper<BusinessDomainActivityTypeAggregate>;
  BusinessDomainActivityTypeAggregateFields: ResolverTypeWrapper<BusinessDomainActivityTypeAggregateFields>;
  BusinessDomainActivityTypeBoolExp: BusinessDomainActivityTypeBoolExp;
  BusinessDomainActivityTypeConstraint: BusinessDomainActivityTypeConstraint;
  BusinessDomainActivityTypeInsertInput: BusinessDomainActivityTypeInsertInput;
  BusinessDomainActivityTypeMaxFields: ResolverTypeWrapper<BusinessDomainActivityTypeMaxFields>;
  BusinessDomainActivityTypeMinFields: ResolverTypeWrapper<BusinessDomainActivityTypeMinFields>;
  BusinessDomainActivityTypeMutationResponse: ResolverTypeWrapper<BusinessDomainActivityTypeMutationResponse>;
  BusinessDomainActivityTypeOnConflict: BusinessDomainActivityTypeOnConflict;
  BusinessDomainActivityTypeOrderBy: BusinessDomainActivityTypeOrderBy;
  BusinessDomainActivityTypePkColumnsInput: BusinessDomainActivityTypePkColumnsInput;
  BusinessDomainActivityTypeSelectColumn: BusinessDomainActivityTypeSelectColumn;
  BusinessDomainActivityTypeSetInput: BusinessDomainActivityTypeSetInput;
  BusinessDomainActivityTypeStreamCursorInput: BusinessDomainActivityTypeStreamCursorInput;
  BusinessDomainActivityTypeStreamCursorValueInput: BusinessDomainActivityTypeStreamCursorValueInput;
  BusinessDomainActivityTypeUpdateColumn: BusinessDomainActivityTypeUpdateColumn;
  BusinessDomainActivityTypeUpdates: BusinessDomainActivityTypeUpdates;
  BusinessFeedType: ResolverTypeWrapper<BusinessFeedType>;
  BusinessFeedTypeAggregate: ResolverTypeWrapper<BusinessFeedTypeAggregate>;
  BusinessFeedTypeAggregateFields: ResolverTypeWrapper<BusinessFeedTypeAggregateFields>;
  BusinessFeedTypeBoolExp: BusinessFeedTypeBoolExp;
  BusinessFeedTypeConstraint: BusinessFeedTypeConstraint;
  BusinessFeedTypeEnum: BusinessFeedTypeEnum;
  BusinessFeedTypeEnumComparisonExp: BusinessFeedTypeEnumComparisonExp;
  BusinessFeedTypeInsertInput: BusinessFeedTypeInsertInput;
  BusinessFeedTypeMaxFields: ResolverTypeWrapper<BusinessFeedTypeMaxFields>;
  BusinessFeedTypeMinFields: ResolverTypeWrapper<BusinessFeedTypeMinFields>;
  BusinessFeedTypeMutationResponse: ResolverTypeWrapper<BusinessFeedTypeMutationResponse>;
  BusinessFeedTypeOnConflict: BusinessFeedTypeOnConflict;
  BusinessFeedTypeOrderBy: BusinessFeedTypeOrderBy;
  BusinessFeedTypePkColumnsInput: BusinessFeedTypePkColumnsInput;
  BusinessFeedTypeSelectColumn: BusinessFeedTypeSelectColumn;
  BusinessFeedTypeSetInput: BusinessFeedTypeSetInput;
  BusinessFeedTypeStreamCursorInput: BusinessFeedTypeStreamCursorInput;
  BusinessFeedTypeStreamCursorValueInput: BusinessFeedTypeStreamCursorValueInput;
  BusinessFeedTypeUpdateColumn: BusinessFeedTypeUpdateColumn;
  BusinessFeedTypeUpdates: BusinessFeedTypeUpdates;
  BusinessMessageAttachments: ResolverTypeWrapper<BusinessMessageAttachments>;
  BusinessMessageAttachmentsAggregate: ResolverTypeWrapper<BusinessMessageAttachmentsAggregate>;
  BusinessMessageAttachmentsAggregateBoolExp: BusinessMessageAttachmentsAggregateBoolExp;
  BusinessMessageAttachmentsAggregateFields: ResolverTypeWrapper<BusinessMessageAttachmentsAggregateFields>;
  BusinessMessageAttachmentsAggregateOrderBy: BusinessMessageAttachmentsAggregateOrderBy;
  BusinessMessageAttachmentsArrRelInsertInput: BusinessMessageAttachmentsArrRelInsertInput;
  BusinessMessageAttachmentsBoolExp: BusinessMessageAttachmentsBoolExp;
  BusinessMessageAttachmentsConstraint: BusinessMessageAttachmentsConstraint;
  BusinessMessageAttachmentsInsertInput: BusinessMessageAttachmentsInsertInput;
  BusinessMessageAttachmentsMaxFields: ResolverTypeWrapper<BusinessMessageAttachmentsMaxFields>;
  BusinessMessageAttachmentsMaxOrderBy: BusinessMessageAttachmentsMaxOrderBy;
  BusinessMessageAttachmentsMinFields: ResolverTypeWrapper<BusinessMessageAttachmentsMinFields>;
  BusinessMessageAttachmentsMinOrderBy: BusinessMessageAttachmentsMinOrderBy;
  BusinessMessageAttachmentsMutationResponse: ResolverTypeWrapper<BusinessMessageAttachmentsMutationResponse>;
  BusinessMessageAttachmentsOnConflict: BusinessMessageAttachmentsOnConflict;
  BusinessMessageAttachmentsOrderBy: BusinessMessageAttachmentsOrderBy;
  BusinessMessageAttachmentsPkColumnsInput: BusinessMessageAttachmentsPkColumnsInput;
  BusinessMessageAttachmentsSelectColumn: BusinessMessageAttachmentsSelectColumn;
  BusinessMessageAttachmentsSetInput: BusinessMessageAttachmentsSetInput;
  BusinessMessageAttachmentsStreamCursorInput: BusinessMessageAttachmentsStreamCursorInput;
  BusinessMessageAttachmentsStreamCursorValueInput: BusinessMessageAttachmentsStreamCursorValueInput;
  BusinessMessageAttachmentsUpdateColumn: BusinessMessageAttachmentsUpdateColumn;
  BusinessMessageAttachmentsUpdates: BusinessMessageAttachmentsUpdates;
  BusinessOrganizationUserCallbackAnswer: ResolverTypeWrapper<BusinessOrganizationUserCallbackAnswer>;
  BusinessOrganizationUserCallbackAnswerAggregate: ResolverTypeWrapper<BusinessOrganizationUserCallbackAnswerAggregate>;
  BusinessOrganizationUserCallbackAnswerAggregateFields: ResolverTypeWrapper<BusinessOrganizationUserCallbackAnswerAggregateFields>;
  BusinessOrganizationUserCallbackAnswerBoolExp: BusinessOrganizationUserCallbackAnswerBoolExp;
  BusinessOrganizationUserCallbackAnswerConstraint: BusinessOrganizationUserCallbackAnswerConstraint;
  BusinessOrganizationUserCallbackAnswerInsertInput: BusinessOrganizationUserCallbackAnswerInsertInput;
  BusinessOrganizationUserCallbackAnswerMaxFields: ResolverTypeWrapper<BusinessOrganizationUserCallbackAnswerMaxFields>;
  BusinessOrganizationUserCallbackAnswerMinFields: ResolverTypeWrapper<BusinessOrganizationUserCallbackAnswerMinFields>;
  BusinessOrganizationUserCallbackAnswerMutationResponse: ResolverTypeWrapper<BusinessOrganizationUserCallbackAnswerMutationResponse>;
  BusinessOrganizationUserCallbackAnswerOnConflict: BusinessOrganizationUserCallbackAnswerOnConflict;
  BusinessOrganizationUserCallbackAnswerOrderBy: BusinessOrganizationUserCallbackAnswerOrderBy;
  BusinessOrganizationUserCallbackAnswerPkColumnsInput: BusinessOrganizationUserCallbackAnswerPkColumnsInput;
  BusinessOrganizationUserCallbackAnswerSelectColumn: BusinessOrganizationUserCallbackAnswerSelectColumn;
  BusinessOrganizationUserCallbackAnswerSetInput: BusinessOrganizationUserCallbackAnswerSetInput;
  BusinessOrganizationUserCallbackAnswerStreamCursorInput: BusinessOrganizationUserCallbackAnswerStreamCursorInput;
  BusinessOrganizationUserCallbackAnswerStreamCursorValueInput: BusinessOrganizationUserCallbackAnswerStreamCursorValueInput;
  BusinessOrganizationUserCallbackAnswerUpdateColumn: BusinessOrganizationUserCallbackAnswerUpdateColumn;
  BusinessOrganizationUserCallbackAnswerUpdates: BusinessOrganizationUserCallbackAnswerUpdates;
  BusinessOrganizationUserEmail: ResolverTypeWrapper<BusinessOrganizationUserEmail>;
  BusinessOrganizationUserEmailAggregate: ResolverTypeWrapper<BusinessOrganizationUserEmailAggregate>;
  BusinessOrganizationUserEmailAggregateBoolExp: BusinessOrganizationUserEmailAggregateBoolExp;
  BusinessOrganizationUserEmailAggregateFields: ResolverTypeWrapper<BusinessOrganizationUserEmailAggregateFields>;
  BusinessOrganizationUserEmailAggregateOrderBy: BusinessOrganizationUserEmailAggregateOrderBy;
  BusinessOrganizationUserEmailArrRelInsertInput: BusinessOrganizationUserEmailArrRelInsertInput;
  BusinessOrganizationUserEmailBoolExp: BusinessOrganizationUserEmailBoolExp;
  BusinessOrganizationUserEmailConstraint: BusinessOrganizationUserEmailConstraint;
  BusinessOrganizationUserEmailInsertInput: BusinessOrganizationUserEmailInsertInput;
  BusinessOrganizationUserEmailMaxFields: ResolverTypeWrapper<BusinessOrganizationUserEmailMaxFields>;
  BusinessOrganizationUserEmailMaxOrderBy: BusinessOrganizationUserEmailMaxOrderBy;
  BusinessOrganizationUserEmailMinFields: ResolverTypeWrapper<BusinessOrganizationUserEmailMinFields>;
  BusinessOrganizationUserEmailMinOrderBy: BusinessOrganizationUserEmailMinOrderBy;
  BusinessOrganizationUserEmailMutationResponse: ResolverTypeWrapper<BusinessOrganizationUserEmailMutationResponse>;
  BusinessOrganizationUserEmailOnConflict: BusinessOrganizationUserEmailOnConflict;
  BusinessOrganizationUserEmailOrderBy: BusinessOrganizationUserEmailOrderBy;
  BusinessOrganizationUserEmailPkColumnsInput: BusinessOrganizationUserEmailPkColumnsInput;
  BusinessOrganizationUserEmailSelectColumn: BusinessOrganizationUserEmailSelectColumn;
  BusinessOrganizationUserEmailSelectColumnBusinessOrganizationUserEmailAggregateBoolExpBool_andArgumentsColumns: BusinessOrganizationUserEmailSelectColumnBusinessOrganizationUserEmailAggregateBoolExpBool_andArgumentsColumns;
  BusinessOrganizationUserEmailSelectColumnBusinessOrganizationUserEmailAggregateBoolExpBool_orArgumentsColumns: BusinessOrganizationUserEmailSelectColumnBusinessOrganizationUserEmailAggregateBoolExpBool_orArgumentsColumns;
  BusinessOrganizationUserEmailSetInput: BusinessOrganizationUserEmailSetInput;
  BusinessOrganizationUserEmailStreamCursorInput: BusinessOrganizationUserEmailStreamCursorInput;
  BusinessOrganizationUserEmailStreamCursorValueInput: BusinessOrganizationUserEmailStreamCursorValueInput;
  BusinessOrganizationUserEmailType: ResolverTypeWrapper<BusinessOrganizationUserEmailType>;
  BusinessOrganizationUserEmailTypeAggregate: ResolverTypeWrapper<BusinessOrganizationUserEmailTypeAggregate>;
  BusinessOrganizationUserEmailTypeAggregateFields: ResolverTypeWrapper<BusinessOrganizationUserEmailTypeAggregateFields>;
  BusinessOrganizationUserEmailTypeBoolExp: BusinessOrganizationUserEmailTypeBoolExp;
  BusinessOrganizationUserEmailTypeConstraint: BusinessOrganizationUserEmailTypeConstraint;
  BusinessOrganizationUserEmailTypeEnum: BusinessOrganizationUserEmailTypeEnum;
  BusinessOrganizationUserEmailTypeEnumComparisonExp: BusinessOrganizationUserEmailTypeEnumComparisonExp;
  BusinessOrganizationUserEmailTypeInsertInput: BusinessOrganizationUserEmailTypeInsertInput;
  BusinessOrganizationUserEmailTypeMaxFields: ResolverTypeWrapper<BusinessOrganizationUserEmailTypeMaxFields>;
  BusinessOrganizationUserEmailTypeMinFields: ResolverTypeWrapper<BusinessOrganizationUserEmailTypeMinFields>;
  BusinessOrganizationUserEmailTypeMutationResponse: ResolverTypeWrapper<BusinessOrganizationUserEmailTypeMutationResponse>;
  BusinessOrganizationUserEmailTypeOnConflict: BusinessOrganizationUserEmailTypeOnConflict;
  BusinessOrganizationUserEmailTypeOrderBy: BusinessOrganizationUserEmailTypeOrderBy;
  BusinessOrganizationUserEmailTypePkColumnsInput: BusinessOrganizationUserEmailTypePkColumnsInput;
  BusinessOrganizationUserEmailTypeSelectColumn: BusinessOrganizationUserEmailTypeSelectColumn;
  BusinessOrganizationUserEmailTypeSetInput: BusinessOrganizationUserEmailTypeSetInput;
  BusinessOrganizationUserEmailTypeStreamCursorInput: BusinessOrganizationUserEmailTypeStreamCursorInput;
  BusinessOrganizationUserEmailTypeStreamCursorValueInput: BusinessOrganizationUserEmailTypeStreamCursorValueInput;
  BusinessOrganizationUserEmailTypeUpdateColumn: BusinessOrganizationUserEmailTypeUpdateColumn;
  BusinessOrganizationUserEmailTypeUpdates: BusinessOrganizationUserEmailTypeUpdates;
  BusinessOrganizationUserEmailUpdateColumn: BusinessOrganizationUserEmailUpdateColumn;
  BusinessOrganizationUserEmailUpdates: BusinessOrganizationUserEmailUpdates;
  BusinessOrganizationUserRequest: ResolverTypeWrapper<BusinessOrganizationUserRequest>;
  BusinessOrganizationUserRequestAggregate: ResolverTypeWrapper<BusinessOrganizationUserRequestAggregate>;
  BusinessOrganizationUserRequestAggregateBoolExp: BusinessOrganizationUserRequestAggregateBoolExp;
  BusinessOrganizationUserRequestAggregateFields: ResolverTypeWrapper<BusinessOrganizationUserRequestAggregateFields>;
  BusinessOrganizationUserRequestAggregateOrderBy: BusinessOrganizationUserRequestAggregateOrderBy;
  BusinessOrganizationUserRequestAppendInput: BusinessOrganizationUserRequestAppendInput;
  BusinessOrganizationUserRequestArrRelInsertInput: BusinessOrganizationUserRequestArrRelInsertInput;
  BusinessOrganizationUserRequestBoolExp: BusinessOrganizationUserRequestBoolExp;
  BusinessOrganizationUserRequestConstraint: BusinessOrganizationUserRequestConstraint;
  BusinessOrganizationUserRequestDeleteAtPathInput: BusinessOrganizationUserRequestDeleteAtPathInput;
  BusinessOrganizationUserRequestDeleteElemInput: BusinessOrganizationUserRequestDeleteElemInput;
  BusinessOrganizationUserRequestDeleteKeyInput: BusinessOrganizationUserRequestDeleteKeyInput;
  BusinessOrganizationUserRequestInsertInput: BusinessOrganizationUserRequestInsertInput;
  BusinessOrganizationUserRequestMaxFields: ResolverTypeWrapper<BusinessOrganizationUserRequestMaxFields>;
  BusinessOrganizationUserRequestMaxOrderBy: BusinessOrganizationUserRequestMaxOrderBy;
  BusinessOrganizationUserRequestMinFields: ResolverTypeWrapper<BusinessOrganizationUserRequestMinFields>;
  BusinessOrganizationUserRequestMinOrderBy: BusinessOrganizationUserRequestMinOrderBy;
  BusinessOrganizationUserRequestMutationResponse: ResolverTypeWrapper<BusinessOrganizationUserRequestMutationResponse>;
  BusinessOrganizationUserRequestOnConflict: BusinessOrganizationUserRequestOnConflict;
  BusinessOrganizationUserRequestOrderBy: BusinessOrganizationUserRequestOrderBy;
  BusinessOrganizationUserRequestPkColumnsInput: BusinessOrganizationUserRequestPkColumnsInput;
  BusinessOrganizationUserRequestPrependInput: BusinessOrganizationUserRequestPrependInput;
  BusinessOrganizationUserRequestSelectColumn: BusinessOrganizationUserRequestSelectColumn;
  BusinessOrganizationUserRequestSelectColumnBusinessOrganizationUserRequestAggregateBoolExpBool_andArgumentsColumns: BusinessOrganizationUserRequestSelectColumnBusinessOrganizationUserRequestAggregateBoolExpBool_andArgumentsColumns;
  BusinessOrganizationUserRequestSelectColumnBusinessOrganizationUserRequestAggregateBoolExpBool_orArgumentsColumns: BusinessOrganizationUserRequestSelectColumnBusinessOrganizationUserRequestAggregateBoolExpBool_orArgumentsColumns;
  BusinessOrganizationUserRequestSetInput: BusinessOrganizationUserRequestSetInput;
  BusinessOrganizationUserRequestStreamCursorInput: BusinessOrganizationUserRequestStreamCursorInput;
  BusinessOrganizationUserRequestStreamCursorValueInput: BusinessOrganizationUserRequestStreamCursorValueInput;
  BusinessOrganizationUserRequestType: ResolverTypeWrapper<BusinessOrganizationUserRequestType>;
  BusinessOrganizationUserRequestTypeAggregate: ResolverTypeWrapper<BusinessOrganizationUserRequestTypeAggregate>;
  BusinessOrganizationUserRequestTypeAggregateFields: ResolverTypeWrapper<BusinessOrganizationUserRequestTypeAggregateFields>;
  BusinessOrganizationUserRequestTypeBoolExp: BusinessOrganizationUserRequestTypeBoolExp;
  BusinessOrganizationUserRequestTypeConstraint: BusinessOrganizationUserRequestTypeConstraint;
  BusinessOrganizationUserRequestTypeEnum: BusinessOrganizationUserRequestTypeEnum;
  BusinessOrganizationUserRequestTypeEnumComparisonExp: BusinessOrganizationUserRequestTypeEnumComparisonExp;
  BusinessOrganizationUserRequestTypeInsertInput: BusinessOrganizationUserRequestTypeInsertInput;
  BusinessOrganizationUserRequestTypeMaxFields: ResolverTypeWrapper<BusinessOrganizationUserRequestTypeMaxFields>;
  BusinessOrganizationUserRequestTypeMinFields: ResolverTypeWrapper<BusinessOrganizationUserRequestTypeMinFields>;
  BusinessOrganizationUserRequestTypeMutationResponse: ResolverTypeWrapper<BusinessOrganizationUserRequestTypeMutationResponse>;
  BusinessOrganizationUserRequestTypeOnConflict: BusinessOrganizationUserRequestTypeOnConflict;
  BusinessOrganizationUserRequestTypeOrderBy: BusinessOrganizationUserRequestTypeOrderBy;
  BusinessOrganizationUserRequestTypePkColumnsInput: BusinessOrganizationUserRequestTypePkColumnsInput;
  BusinessOrganizationUserRequestTypeSelectColumn: BusinessOrganizationUserRequestTypeSelectColumn;
  BusinessOrganizationUserRequestTypeSetInput: BusinessOrganizationUserRequestTypeSetInput;
  BusinessOrganizationUserRequestTypeStreamCursorInput: BusinessOrganizationUserRequestTypeStreamCursorInput;
  BusinessOrganizationUserRequestTypeStreamCursorValueInput: BusinessOrganizationUserRequestTypeStreamCursorValueInput;
  BusinessOrganizationUserRequestTypeUpdateColumn: BusinessOrganizationUserRequestTypeUpdateColumn;
  BusinessOrganizationUserRequestTypeUpdates: BusinessOrganizationUserRequestTypeUpdates;
  BusinessOrganizationUserRequestUpdateColumn: BusinessOrganizationUserRequestUpdateColumn;
  BusinessOrganizationUserRequestUpdates: BusinessOrganizationUserRequestUpdates;
  BusinessOrganizationUserSuggestionType: ResolverTypeWrapper<BusinessOrganizationUserSuggestionType>;
  BusinessOrganizationUserSuggestionTypeAggregate: ResolverTypeWrapper<BusinessOrganizationUserSuggestionTypeAggregate>;
  BusinessOrganizationUserSuggestionTypeAggregateFields: ResolverTypeWrapper<BusinessOrganizationUserSuggestionTypeAggregateFields>;
  BusinessOrganizationUserSuggestionTypeBoolExp: BusinessOrganizationUserSuggestionTypeBoolExp;
  BusinessOrganizationUserSuggestionTypeConstraint: BusinessOrganizationUserSuggestionTypeConstraint;
  BusinessOrganizationUserSuggestionTypeInsertInput: BusinessOrganizationUserSuggestionTypeInsertInput;
  BusinessOrganizationUserSuggestionTypeMaxFields: ResolverTypeWrapper<BusinessOrganizationUserSuggestionTypeMaxFields>;
  BusinessOrganizationUserSuggestionTypeMinFields: ResolverTypeWrapper<BusinessOrganizationUserSuggestionTypeMinFields>;
  BusinessOrganizationUserSuggestionTypeMutationResponse: ResolverTypeWrapper<BusinessOrganizationUserSuggestionTypeMutationResponse>;
  BusinessOrganizationUserSuggestionTypeOnConflict: BusinessOrganizationUserSuggestionTypeOnConflict;
  BusinessOrganizationUserSuggestionTypeOrderBy: BusinessOrganizationUserSuggestionTypeOrderBy;
  BusinessOrganizationUserSuggestionTypePkColumnsInput: BusinessOrganizationUserSuggestionTypePkColumnsInput;
  BusinessOrganizationUserSuggestionTypeSelectColumn: BusinessOrganizationUserSuggestionTypeSelectColumn;
  BusinessOrganizationUserSuggestionTypeSetInput: BusinessOrganizationUserSuggestionTypeSetInput;
  BusinessOrganizationUserSuggestionTypeStreamCursorInput: BusinessOrganizationUserSuggestionTypeStreamCursorInput;
  BusinessOrganizationUserSuggestionTypeStreamCursorValueInput: BusinessOrganizationUserSuggestionTypeStreamCursorValueInput;
  BusinessOrganizationUserSuggestionTypeUpdateColumn: BusinessOrganizationUserSuggestionTypeUpdateColumn;
  BusinessOrganizationUserSuggestionTypeUpdates: BusinessOrganizationUserSuggestionTypeUpdates;
  BusinessOrganizationUserSuggestions: ResolverTypeWrapper<BusinessOrganizationUserSuggestions>;
  BusinessOrganizationUserSuggestionsAggregate: ResolverTypeWrapper<BusinessOrganizationUserSuggestionsAggregate>;
  BusinessOrganizationUserSuggestionsAggregateFields: ResolverTypeWrapper<BusinessOrganizationUserSuggestionsAggregateFields>;
  BusinessOrganizationUserSuggestionsBoolExp: BusinessOrganizationUserSuggestionsBoolExp;
  BusinessOrganizationUserSuggestionsConstraint: BusinessOrganizationUserSuggestionsConstraint;
  BusinessOrganizationUserSuggestionsInsertInput: BusinessOrganizationUserSuggestionsInsertInput;
  BusinessOrganizationUserSuggestionsMaxFields: ResolverTypeWrapper<BusinessOrganizationUserSuggestionsMaxFields>;
  BusinessOrganizationUserSuggestionsMinFields: ResolverTypeWrapper<BusinessOrganizationUserSuggestionsMinFields>;
  BusinessOrganizationUserSuggestionsMutationResponse: ResolverTypeWrapper<BusinessOrganizationUserSuggestionsMutationResponse>;
  BusinessOrganizationUserSuggestionsOnConflict: BusinessOrganizationUserSuggestionsOnConflict;
  BusinessOrganizationUserSuggestionsOrderBy: BusinessOrganizationUserSuggestionsOrderBy;
  BusinessOrganizationUserSuggestionsPkColumnsInput: BusinessOrganizationUserSuggestionsPkColumnsInput;
  BusinessOrganizationUserSuggestionsSelectColumn: BusinessOrganizationUserSuggestionsSelectColumn;
  BusinessOrganizationUserSuggestionsSetInput: BusinessOrganizationUserSuggestionsSetInput;
  BusinessOrganizationUserSuggestionsStreamCursorInput: BusinessOrganizationUserSuggestionsStreamCursorInput;
  BusinessOrganizationUserSuggestionsStreamCursorValueInput: BusinessOrganizationUserSuggestionsStreamCursorValueInput;
  BusinessOrganizationUserSuggestionsUpdateColumn: BusinessOrganizationUserSuggestionsUpdateColumn;
  BusinessOrganizationUserSuggestionsUpdates: BusinessOrganizationUserSuggestionsUpdates;
  BusinessOrganizationUserUrlAddress: ResolverTypeWrapper<BusinessOrganizationUserUrlAddress>;
  BusinessOrganizationUserUrlAddressAggregate: ResolverTypeWrapper<BusinessOrganizationUserUrlAddressAggregate>;
  BusinessOrganizationUserUrlAddressAggregateBoolExp: BusinessOrganizationUserUrlAddressAggregateBoolExp;
  BusinessOrganizationUserUrlAddressAggregateFields: ResolverTypeWrapper<BusinessOrganizationUserUrlAddressAggregateFields>;
  BusinessOrganizationUserUrlAddressAggregateOrderBy: BusinessOrganizationUserUrlAddressAggregateOrderBy;
  BusinessOrganizationUserUrlAddressArrRelInsertInput: BusinessOrganizationUserUrlAddressArrRelInsertInput;
  BusinessOrganizationUserUrlAddressBoolExp: BusinessOrganizationUserUrlAddressBoolExp;
  BusinessOrganizationUserUrlAddressConstraint: BusinessOrganizationUserUrlAddressConstraint;
  BusinessOrganizationUserUrlAddressInsertInput: BusinessOrganizationUserUrlAddressInsertInput;
  BusinessOrganizationUserUrlAddressMaxFields: ResolverTypeWrapper<BusinessOrganizationUserUrlAddressMaxFields>;
  BusinessOrganizationUserUrlAddressMaxOrderBy: BusinessOrganizationUserUrlAddressMaxOrderBy;
  BusinessOrganizationUserUrlAddressMinFields: ResolverTypeWrapper<BusinessOrganizationUserUrlAddressMinFields>;
  BusinessOrganizationUserUrlAddressMinOrderBy: BusinessOrganizationUserUrlAddressMinOrderBy;
  BusinessOrganizationUserUrlAddressMutationResponse: ResolverTypeWrapper<BusinessOrganizationUserUrlAddressMutationResponse>;
  BusinessOrganizationUserUrlAddressOnConflict: BusinessOrganizationUserUrlAddressOnConflict;
  BusinessOrganizationUserUrlAddressOrderBy: BusinessOrganizationUserUrlAddressOrderBy;
  BusinessOrganizationUserUrlAddressPkColumnsInput: BusinessOrganizationUserUrlAddressPkColumnsInput;
  BusinessOrganizationUserUrlAddressSelectColumn: BusinessOrganizationUserUrlAddressSelectColumn;
  BusinessOrganizationUserUrlAddressSetInput: BusinessOrganizationUserUrlAddressSetInput;
  BusinessOrganizationUserUrlAddressStreamCursorInput: BusinessOrganizationUserUrlAddressStreamCursorInput;
  BusinessOrganizationUserUrlAddressStreamCursorValueInput: BusinessOrganizationUserUrlAddressStreamCursorValueInput;
  BusinessOrganizationUserUrlAddressType: ResolverTypeWrapper<BusinessOrganizationUserUrlAddressType>;
  BusinessOrganizationUserUrlAddressTypeAggregate: ResolverTypeWrapper<BusinessOrganizationUserUrlAddressTypeAggregate>;
  BusinessOrganizationUserUrlAddressTypeAggregateFields: ResolverTypeWrapper<BusinessOrganizationUserUrlAddressTypeAggregateFields>;
  BusinessOrganizationUserUrlAddressTypeBoolExp: BusinessOrganizationUserUrlAddressTypeBoolExp;
  BusinessOrganizationUserUrlAddressTypeConstraint: BusinessOrganizationUserUrlAddressTypeConstraint;
  BusinessOrganizationUserUrlAddressTypeEnum: BusinessOrganizationUserUrlAddressTypeEnum;
  BusinessOrganizationUserUrlAddressTypeEnumComparisonExp: BusinessOrganizationUserUrlAddressTypeEnumComparisonExp;
  BusinessOrganizationUserUrlAddressTypeInsertInput: BusinessOrganizationUserUrlAddressTypeInsertInput;
  BusinessOrganizationUserUrlAddressTypeMaxFields: ResolverTypeWrapper<BusinessOrganizationUserUrlAddressTypeMaxFields>;
  BusinessOrganizationUserUrlAddressTypeMinFields: ResolverTypeWrapper<BusinessOrganizationUserUrlAddressTypeMinFields>;
  BusinessOrganizationUserUrlAddressTypeMutationResponse: ResolverTypeWrapper<BusinessOrganizationUserUrlAddressTypeMutationResponse>;
  BusinessOrganizationUserUrlAddressTypeObjRelInsertInput: BusinessOrganizationUserUrlAddressTypeObjRelInsertInput;
  BusinessOrganizationUserUrlAddressTypeOnConflict: BusinessOrganizationUserUrlAddressTypeOnConflict;
  BusinessOrganizationUserUrlAddressTypeOrderBy: BusinessOrganizationUserUrlAddressTypeOrderBy;
  BusinessOrganizationUserUrlAddressTypePkColumnsInput: BusinessOrganizationUserUrlAddressTypePkColumnsInput;
  BusinessOrganizationUserUrlAddressTypeSelectColumn: BusinessOrganizationUserUrlAddressTypeSelectColumn;
  BusinessOrganizationUserUrlAddressTypeSetInput: BusinessOrganizationUserUrlAddressTypeSetInput;
  BusinessOrganizationUserUrlAddressTypeStreamCursorInput: BusinessOrganizationUserUrlAddressTypeStreamCursorInput;
  BusinessOrganizationUserUrlAddressTypeStreamCursorValueInput: BusinessOrganizationUserUrlAddressTypeStreamCursorValueInput;
  BusinessOrganizationUserUrlAddressTypeUpdateColumn: BusinessOrganizationUserUrlAddressTypeUpdateColumn;
  BusinessOrganizationUserUrlAddressTypeUpdates: BusinessOrganizationUserUrlAddressTypeUpdates;
  BusinessOrganizationUserUrlAddressUpdateColumn: BusinessOrganizationUserUrlAddressUpdateColumn;
  BusinessOrganizationUserUrlAddressUpdates: BusinessOrganizationUserUrlAddressUpdates;
  BusinessQueueItemAlarmType: ResolverTypeWrapper<BusinessQueueItemAlarmType>;
  BusinessQueueItemAlarmTypeAggregate: ResolverTypeWrapper<BusinessQueueItemAlarmTypeAggregate>;
  BusinessQueueItemAlarmTypeAggregateFields: ResolverTypeWrapper<BusinessQueueItemAlarmTypeAggregateFields>;
  BusinessQueueItemAlarmTypeBoolExp: BusinessQueueItemAlarmTypeBoolExp;
  BusinessQueueItemAlarmTypeConstraint: BusinessQueueItemAlarmTypeConstraint;
  BusinessQueueItemAlarmTypeEnum: BusinessQueueItemAlarmTypeEnum;
  BusinessQueueItemAlarmTypeEnumComparisonExp: BusinessQueueItemAlarmTypeEnumComparisonExp;
  BusinessQueueItemAlarmTypeInsertInput: BusinessQueueItemAlarmTypeInsertInput;
  BusinessQueueItemAlarmTypeMaxFields: ResolverTypeWrapper<BusinessQueueItemAlarmTypeMaxFields>;
  BusinessQueueItemAlarmTypeMinFields: ResolverTypeWrapper<BusinessQueueItemAlarmTypeMinFields>;
  BusinessQueueItemAlarmTypeMutationResponse: ResolverTypeWrapper<BusinessQueueItemAlarmTypeMutationResponse>;
  BusinessQueueItemAlarmTypeOnConflict: BusinessQueueItemAlarmTypeOnConflict;
  BusinessQueueItemAlarmTypeOrderBy: BusinessQueueItemAlarmTypeOrderBy;
  BusinessQueueItemAlarmTypePkColumnsInput: BusinessQueueItemAlarmTypePkColumnsInput;
  BusinessQueueItemAlarmTypeSelectColumn: BusinessQueueItemAlarmTypeSelectColumn;
  BusinessQueueItemAlarmTypeSetInput: BusinessQueueItemAlarmTypeSetInput;
  BusinessQueueItemAlarmTypeStreamCursorInput: BusinessQueueItemAlarmTypeStreamCursorInput;
  BusinessQueueItemAlarmTypeStreamCursorValueInput: BusinessQueueItemAlarmTypeStreamCursorValueInput;
  BusinessQueueItemAlarmTypeUpdateColumn: BusinessQueueItemAlarmTypeUpdateColumn;
  BusinessQueueItemAlarmTypeUpdates: BusinessQueueItemAlarmTypeUpdates;
  BusinessQueueItemAlarms: ResolverTypeWrapper<BusinessQueueItemAlarms>;
  BusinessQueueItemAlarmsAggregate: ResolverTypeWrapper<BusinessQueueItemAlarmsAggregate>;
  BusinessQueueItemAlarmsAggregateBoolExp: BusinessQueueItemAlarmsAggregateBoolExp;
  BusinessQueueItemAlarmsAggregateFields: ResolverTypeWrapper<BusinessQueueItemAlarmsAggregateFields>;
  BusinessQueueItemAlarmsAggregateOrderBy: BusinessQueueItemAlarmsAggregateOrderBy;
  BusinessQueueItemAlarmsArrRelInsertInput: BusinessQueueItemAlarmsArrRelInsertInput;
  BusinessQueueItemAlarmsAvgFields: ResolverTypeWrapper<BusinessQueueItemAlarmsAvgFields>;
  BusinessQueueItemAlarmsAvgOrderBy: BusinessQueueItemAlarmsAvgOrderBy;
  BusinessQueueItemAlarmsBoolExp: BusinessQueueItemAlarmsBoolExp;
  BusinessQueueItemAlarmsConstraint: BusinessQueueItemAlarmsConstraint;
  BusinessQueueItemAlarmsIncInput: BusinessQueueItemAlarmsIncInput;
  BusinessQueueItemAlarmsInsertInput: BusinessQueueItemAlarmsInsertInput;
  BusinessQueueItemAlarmsMaxFields: ResolverTypeWrapper<BusinessQueueItemAlarmsMaxFields>;
  BusinessQueueItemAlarmsMaxOrderBy: BusinessQueueItemAlarmsMaxOrderBy;
  BusinessQueueItemAlarmsMinFields: ResolverTypeWrapper<BusinessQueueItemAlarmsMinFields>;
  BusinessQueueItemAlarmsMinOrderBy: BusinessQueueItemAlarmsMinOrderBy;
  BusinessQueueItemAlarmsMutationResponse: ResolverTypeWrapper<BusinessQueueItemAlarmsMutationResponse>;
  BusinessQueueItemAlarmsOnConflict: BusinessQueueItemAlarmsOnConflict;
  BusinessQueueItemAlarmsOrderBy: BusinessQueueItemAlarmsOrderBy;
  BusinessQueueItemAlarmsPkColumnsInput: BusinessQueueItemAlarmsPkColumnsInput;
  BusinessQueueItemAlarmsSelectColumn: BusinessQueueItemAlarmsSelectColumn;
  BusinessQueueItemAlarmsSetInput: BusinessQueueItemAlarmsSetInput;
  BusinessQueueItemAlarmsStddevFields: ResolverTypeWrapper<BusinessQueueItemAlarmsStddevFields>;
  BusinessQueueItemAlarmsStddevOrderBy: BusinessQueueItemAlarmsStddevOrderBy;
  BusinessQueueItemAlarmsStddevPopFields: ResolverTypeWrapper<BusinessQueueItemAlarmsStddevPopFields>;
  BusinessQueueItemAlarmsStddevPopOrderBy: BusinessQueueItemAlarmsStddevPopOrderBy;
  BusinessQueueItemAlarmsStddevSampFields: ResolverTypeWrapper<BusinessQueueItemAlarmsStddevSampFields>;
  BusinessQueueItemAlarmsStddevSampOrderBy: BusinessQueueItemAlarmsStddevSampOrderBy;
  BusinessQueueItemAlarmsStreamCursorInput: BusinessQueueItemAlarmsStreamCursorInput;
  BusinessQueueItemAlarmsStreamCursorValueInput: BusinessQueueItemAlarmsStreamCursorValueInput;
  BusinessQueueItemAlarmsSumFields: ResolverTypeWrapper<BusinessQueueItemAlarmsSumFields>;
  BusinessQueueItemAlarmsSumOrderBy: BusinessQueueItemAlarmsSumOrderBy;
  BusinessQueueItemAlarmsUpdateColumn: BusinessQueueItemAlarmsUpdateColumn;
  BusinessQueueItemAlarmsUpdates: BusinessQueueItemAlarmsUpdates;
  BusinessQueueItemAlarmsVarPopFields: ResolverTypeWrapper<BusinessQueueItemAlarmsVarPopFields>;
  BusinessQueueItemAlarmsVarPopOrderBy: BusinessQueueItemAlarmsVarPopOrderBy;
  BusinessQueueItemAlarmsVarSampFields: ResolverTypeWrapper<BusinessQueueItemAlarmsVarSampFields>;
  BusinessQueueItemAlarmsVarSampOrderBy: BusinessQueueItemAlarmsVarSampOrderBy;
  BusinessQueueItemAlarmsVarianceFields: ResolverTypeWrapper<BusinessQueueItemAlarmsVarianceFields>;
  BusinessQueueItemAlarmsVarianceOrderBy: BusinessQueueItemAlarmsVarianceOrderBy;
  BusinessQueueItemDomainUsersView: ResolverTypeWrapper<BusinessQueueItemDomainUsersView>;
  BusinessQueueItemDomainUsersViewAggregate: ResolverTypeWrapper<BusinessQueueItemDomainUsersViewAggregate>;
  BusinessQueueItemDomainUsersViewAggregateBoolExp: BusinessQueueItemDomainUsersViewAggregateBoolExp;
  BusinessQueueItemDomainUsersViewAggregateFields: ResolverTypeWrapper<BusinessQueueItemDomainUsersViewAggregateFields>;
  BusinessQueueItemDomainUsersViewAggregateOrderBy: BusinessQueueItemDomainUsersViewAggregateOrderBy;
  BusinessQueueItemDomainUsersViewArrRelInsertInput: BusinessQueueItemDomainUsersViewArrRelInsertInput;
  BusinessQueueItemDomainUsersViewAvgFields: ResolverTypeWrapper<BusinessQueueItemDomainUsersViewAvgFields>;
  BusinessQueueItemDomainUsersViewAvgOrderBy: BusinessQueueItemDomainUsersViewAvgOrderBy;
  BusinessQueueItemDomainUsersViewBoolExp: BusinessQueueItemDomainUsersViewBoolExp;
  BusinessQueueItemDomainUsersViewInsertInput: BusinessQueueItemDomainUsersViewInsertInput;
  BusinessQueueItemDomainUsersViewMaxFields: ResolverTypeWrapper<BusinessQueueItemDomainUsersViewMaxFields>;
  BusinessQueueItemDomainUsersViewMaxOrderBy: BusinessQueueItemDomainUsersViewMaxOrderBy;
  BusinessQueueItemDomainUsersViewMinFields: ResolverTypeWrapper<BusinessQueueItemDomainUsersViewMinFields>;
  BusinessQueueItemDomainUsersViewMinOrderBy: BusinessQueueItemDomainUsersViewMinOrderBy;
  BusinessQueueItemDomainUsersViewOrderBy: BusinessQueueItemDomainUsersViewOrderBy;
  BusinessQueueItemDomainUsersViewSelectColumn: BusinessQueueItemDomainUsersViewSelectColumn;
  BusinessQueueItemDomainUsersViewStddevFields: ResolverTypeWrapper<BusinessQueueItemDomainUsersViewStddevFields>;
  BusinessQueueItemDomainUsersViewStddevOrderBy: BusinessQueueItemDomainUsersViewStddevOrderBy;
  BusinessQueueItemDomainUsersViewStddevPopFields: ResolverTypeWrapper<BusinessQueueItemDomainUsersViewStddevPopFields>;
  BusinessQueueItemDomainUsersViewStddevPopOrderBy: BusinessQueueItemDomainUsersViewStddevPopOrderBy;
  BusinessQueueItemDomainUsersViewStddevSampFields: ResolverTypeWrapper<BusinessQueueItemDomainUsersViewStddevSampFields>;
  BusinessQueueItemDomainUsersViewStddevSampOrderBy: BusinessQueueItemDomainUsersViewStddevSampOrderBy;
  BusinessQueueItemDomainUsersViewStreamCursorInput: BusinessQueueItemDomainUsersViewStreamCursorInput;
  BusinessQueueItemDomainUsersViewStreamCursorValueInput: BusinessQueueItemDomainUsersViewStreamCursorValueInput;
  BusinessQueueItemDomainUsersViewSumFields: ResolverTypeWrapper<BusinessQueueItemDomainUsersViewSumFields>;
  BusinessQueueItemDomainUsersViewSumOrderBy: BusinessQueueItemDomainUsersViewSumOrderBy;
  BusinessQueueItemDomainUsersViewVarPopFields: ResolverTypeWrapper<BusinessQueueItemDomainUsersViewVarPopFields>;
  BusinessQueueItemDomainUsersViewVarPopOrderBy: BusinessQueueItemDomainUsersViewVarPopOrderBy;
  BusinessQueueItemDomainUsersViewVarSampFields: ResolverTypeWrapper<BusinessQueueItemDomainUsersViewVarSampFields>;
  BusinessQueueItemDomainUsersViewVarSampOrderBy: BusinessQueueItemDomainUsersViewVarSampOrderBy;
  BusinessQueueItemDomainUsersViewVarianceFields: ResolverTypeWrapper<BusinessQueueItemDomainUsersViewVarianceFields>;
  BusinessQueueItemDomainUsersViewVarianceOrderBy: BusinessQueueItemDomainUsersViewVarianceOrderBy;
  BusinessQueueItemOrganizationUsersView: ResolverTypeWrapper<BusinessQueueItemOrganizationUsersView>;
  BusinessQueueItemOrganizationUsersViewAggregate: ResolverTypeWrapper<BusinessQueueItemOrganizationUsersViewAggregate>;
  BusinessQueueItemOrganizationUsersViewAggregateBoolExp: BusinessQueueItemOrganizationUsersViewAggregateBoolExp;
  BusinessQueueItemOrganizationUsersViewAggregateFields: ResolverTypeWrapper<BusinessQueueItemOrganizationUsersViewAggregateFields>;
  BusinessQueueItemOrganizationUsersViewAggregateOrderBy: BusinessQueueItemOrganizationUsersViewAggregateOrderBy;
  BusinessQueueItemOrganizationUsersViewArrRelInsertInput: BusinessQueueItemOrganizationUsersViewArrRelInsertInput;
  BusinessQueueItemOrganizationUsersViewBoolExp: BusinessQueueItemOrganizationUsersViewBoolExp;
  BusinessQueueItemOrganizationUsersViewInsertInput: BusinessQueueItemOrganizationUsersViewInsertInput;
  BusinessQueueItemOrganizationUsersViewMaxFields: ResolverTypeWrapper<BusinessQueueItemOrganizationUsersViewMaxFields>;
  BusinessQueueItemOrganizationUsersViewMaxOrderBy: BusinessQueueItemOrganizationUsersViewMaxOrderBy;
  BusinessQueueItemOrganizationUsersViewMinFields: ResolverTypeWrapper<BusinessQueueItemOrganizationUsersViewMinFields>;
  BusinessQueueItemOrganizationUsersViewMinOrderBy: BusinessQueueItemOrganizationUsersViewMinOrderBy;
  BusinessQueueItemOrganizationUsersViewOrderBy: BusinessQueueItemOrganizationUsersViewOrderBy;
  BusinessQueueItemOrganizationUsersViewSelectColumn: BusinessQueueItemOrganizationUsersViewSelectColumn;
  BusinessQueueItemOrganizationUsersViewStreamCursorInput: BusinessQueueItemOrganizationUsersViewStreamCursorInput;
  BusinessQueueItemOrganizationUsersViewStreamCursorValueInput: BusinessQueueItemOrganizationUsersViewStreamCursorValueInput;
  BusinessQueueItemParticipantChannelType: ResolverTypeWrapper<BusinessQueueItemParticipantChannelType>;
  BusinessQueueItemParticipantChannelTypeAggregate: ResolverTypeWrapper<BusinessQueueItemParticipantChannelTypeAggregate>;
  BusinessQueueItemParticipantChannelTypeAggregateFields: ResolverTypeWrapper<BusinessQueueItemParticipantChannelTypeAggregateFields>;
  BusinessQueueItemParticipantChannelTypeBoolExp: BusinessQueueItemParticipantChannelTypeBoolExp;
  BusinessQueueItemParticipantChannelTypeConstraint: BusinessQueueItemParticipantChannelTypeConstraint;
  BusinessQueueItemParticipantChannelTypeEnum: BusinessQueueItemParticipantChannelTypeEnum;
  BusinessQueueItemParticipantChannelTypeEnumComparisonExp: BusinessQueueItemParticipantChannelTypeEnumComparisonExp;
  BusinessQueueItemParticipantChannelTypeInsertInput: BusinessQueueItemParticipantChannelTypeInsertInput;
  BusinessQueueItemParticipantChannelTypeMaxFields: ResolverTypeWrapper<BusinessQueueItemParticipantChannelTypeMaxFields>;
  BusinessQueueItemParticipantChannelTypeMinFields: ResolverTypeWrapper<BusinessQueueItemParticipantChannelTypeMinFields>;
  BusinessQueueItemParticipantChannelTypeMutationResponse: ResolverTypeWrapper<BusinessQueueItemParticipantChannelTypeMutationResponse>;
  BusinessQueueItemParticipantChannelTypeOnConflict: BusinessQueueItemParticipantChannelTypeOnConflict;
  BusinessQueueItemParticipantChannelTypeOrderBy: BusinessQueueItemParticipantChannelTypeOrderBy;
  BusinessQueueItemParticipantChannelTypePkColumnsInput: BusinessQueueItemParticipantChannelTypePkColumnsInput;
  BusinessQueueItemParticipantChannelTypeSelectColumn: BusinessQueueItemParticipantChannelTypeSelectColumn;
  BusinessQueueItemParticipantChannelTypeSetInput: BusinessQueueItemParticipantChannelTypeSetInput;
  BusinessQueueItemParticipantChannelTypeStreamCursorInput: BusinessQueueItemParticipantChannelTypeStreamCursorInput;
  BusinessQueueItemParticipantChannelTypeStreamCursorValueInput: BusinessQueueItemParticipantChannelTypeStreamCursorValueInput;
  BusinessQueueItemParticipantChannelTypeUpdateColumn: BusinessQueueItemParticipantChannelTypeUpdateColumn;
  BusinessQueueItemParticipantChannelTypeUpdates: BusinessQueueItemParticipantChannelTypeUpdates;
  BusinessQueueItemParticipantsView: ResolverTypeWrapper<BusinessQueueItemParticipantsView>;
  BusinessQueueItemParticipantsViewAggregate: ResolverTypeWrapper<BusinessQueueItemParticipantsViewAggregate>;
  BusinessQueueItemParticipantsViewAggregateBoolExp: BusinessQueueItemParticipantsViewAggregateBoolExp;
  BusinessQueueItemParticipantsViewAggregateFields: ResolverTypeWrapper<BusinessQueueItemParticipantsViewAggregateFields>;
  BusinessQueueItemParticipantsViewAggregateOrderBy: BusinessQueueItemParticipantsViewAggregateOrderBy;
  BusinessQueueItemParticipantsViewArrRelInsertInput: BusinessQueueItemParticipantsViewArrRelInsertInput;
  BusinessQueueItemParticipantsViewBoolExp: BusinessQueueItemParticipantsViewBoolExp;
  BusinessQueueItemParticipantsViewInsertInput: BusinessQueueItemParticipantsViewInsertInput;
  BusinessQueueItemParticipantsViewMaxFields: ResolverTypeWrapper<BusinessQueueItemParticipantsViewMaxFields>;
  BusinessQueueItemParticipantsViewMaxOrderBy: BusinessQueueItemParticipantsViewMaxOrderBy;
  BusinessQueueItemParticipantsViewMinFields: ResolverTypeWrapper<BusinessQueueItemParticipantsViewMinFields>;
  BusinessQueueItemParticipantsViewMinOrderBy: BusinessQueueItemParticipantsViewMinOrderBy;
  BusinessQueueItemParticipantsViewOrderBy: BusinessQueueItemParticipantsViewOrderBy;
  BusinessQueueItemParticipantsViewSelectColumn: BusinessQueueItemParticipantsViewSelectColumn;
  BusinessQueueItemParticipantsViewStreamCursorInput: BusinessQueueItemParticipantsViewStreamCursorInput;
  BusinessQueueItemParticipantsViewStreamCursorValueInput: BusinessQueueItemParticipantsViewStreamCursorValueInput;
  BusinessQueueItemSubType: ResolverTypeWrapper<BusinessQueueItemSubType>;
  BusinessQueueItemSubTypeAggregate: ResolverTypeWrapper<BusinessQueueItemSubTypeAggregate>;
  BusinessQueueItemSubTypeAggregateFields: ResolverTypeWrapper<BusinessQueueItemSubTypeAggregateFields>;
  BusinessQueueItemSubTypeBoolExp: BusinessQueueItemSubTypeBoolExp;
  BusinessQueueItemSubTypeConstraint: BusinessQueueItemSubTypeConstraint;
  BusinessQueueItemSubTypeInsertInput: BusinessQueueItemSubTypeInsertInput;
  BusinessQueueItemSubTypeMaxFields: ResolverTypeWrapper<BusinessQueueItemSubTypeMaxFields>;
  BusinessQueueItemSubTypeMinFields: ResolverTypeWrapper<BusinessQueueItemSubTypeMinFields>;
  BusinessQueueItemSubTypeMutationResponse: ResolverTypeWrapper<BusinessQueueItemSubTypeMutationResponse>;
  BusinessQueueItemSubTypeObjRelInsertInput: BusinessQueueItemSubTypeObjRelInsertInput;
  BusinessQueueItemSubTypeOnConflict: BusinessQueueItemSubTypeOnConflict;
  BusinessQueueItemSubTypeOrderBy: BusinessQueueItemSubTypeOrderBy;
  BusinessQueueItemSubTypePkColumnsInput: BusinessQueueItemSubTypePkColumnsInput;
  BusinessQueueItemSubTypeSelectColumn: BusinessQueueItemSubTypeSelectColumn;
  BusinessQueueItemSubTypeSetInput: BusinessQueueItemSubTypeSetInput;
  BusinessQueueItemSubTypeStreamCursorInput: BusinessQueueItemSubTypeStreamCursorInput;
  BusinessQueueItemSubTypeStreamCursorValueInput: BusinessQueueItemSubTypeStreamCursorValueInput;
  BusinessQueueItemSubTypeUpdateColumn: BusinessQueueItemSubTypeUpdateColumn;
  BusinessQueueItemSubTypeUpdates: BusinessQueueItemSubTypeUpdates;
  BusinessUserContactNumbers: ResolverTypeWrapper<BusinessUserContactNumbers>;
  BusinessUserContactNumbersAggregate: ResolverTypeWrapper<BusinessUserContactNumbersAggregate>;
  BusinessUserContactNumbersAggregateBoolExp: BusinessUserContactNumbersAggregateBoolExp;
  BusinessUserContactNumbersAggregateFields: ResolverTypeWrapper<BusinessUserContactNumbersAggregateFields>;
  BusinessUserContactNumbersAggregateOrderBy: BusinessUserContactNumbersAggregateOrderBy;
  BusinessUserContactNumbersArrRelInsertInput: BusinessUserContactNumbersArrRelInsertInput;
  BusinessUserContactNumbersBoolExp: BusinessUserContactNumbersBoolExp;
  BusinessUserContactNumbersConstraint: BusinessUserContactNumbersConstraint;
  BusinessUserContactNumbersInsertInput: BusinessUserContactNumbersInsertInput;
  BusinessUserContactNumbersMaxFields: ResolverTypeWrapper<BusinessUserContactNumbersMaxFields>;
  BusinessUserContactNumbersMaxOrderBy: BusinessUserContactNumbersMaxOrderBy;
  BusinessUserContactNumbersMinFields: ResolverTypeWrapper<BusinessUserContactNumbersMinFields>;
  BusinessUserContactNumbersMinOrderBy: BusinessUserContactNumbersMinOrderBy;
  BusinessUserContactNumbersMutationResponse: ResolverTypeWrapper<BusinessUserContactNumbersMutationResponse>;
  BusinessUserContactNumbersOnConflict: BusinessUserContactNumbersOnConflict;
  BusinessUserContactNumbersOrderBy: BusinessUserContactNumbersOrderBy;
  BusinessUserContactNumbersPkColumnsInput: BusinessUserContactNumbersPkColumnsInput;
  BusinessUserContactNumbersSelectColumn: BusinessUserContactNumbersSelectColumn;
  BusinessUserContactNumbersSelectColumnBusinessUserContactNumbersAggregateBoolExpBool_andArgumentsColumns: BusinessUserContactNumbersSelectColumnBusinessUserContactNumbersAggregateBoolExpBool_andArgumentsColumns;
  BusinessUserContactNumbersSelectColumnBusinessUserContactNumbersAggregateBoolExpBool_orArgumentsColumns: BusinessUserContactNumbersSelectColumnBusinessUserContactNumbersAggregateBoolExpBool_orArgumentsColumns;
  BusinessUserContactNumbersSetInput: BusinessUserContactNumbersSetInput;
  BusinessUserContactNumbersStreamCursorInput: BusinessUserContactNumbersStreamCursorInput;
  BusinessUserContactNumbersStreamCursorValueInput: BusinessUserContactNumbersStreamCursorValueInput;
  BusinessUserContactNumbersUpdateColumn: BusinessUserContactNumbersUpdateColumn;
  BusinessUserContactNumbersUpdates: BusinessUserContactNumbersUpdates;
  BusinessUserFeed: ResolverTypeWrapper<BusinessUserFeed>;
  BusinessUserFeedAggregate: ResolverTypeWrapper<BusinessUserFeedAggregate>;
  BusinessUserFeedAggregateBoolExp: BusinessUserFeedAggregateBoolExp;
  BusinessUserFeedAggregateFields: ResolverTypeWrapper<BusinessUserFeedAggregateFields>;
  BusinessUserFeedAggregateOrderBy: BusinessUserFeedAggregateOrderBy;
  BusinessUserFeedAppendInput: BusinessUserFeedAppendInput;
  BusinessUserFeedArrRelInsertInput: BusinessUserFeedArrRelInsertInput;
  BusinessUserFeedBoolExp: BusinessUserFeedBoolExp;
  BusinessUserFeedConstraint: BusinessUserFeedConstraint;
  BusinessUserFeedDeleteAtPathInput: BusinessUserFeedDeleteAtPathInput;
  BusinessUserFeedDeleteElemInput: BusinessUserFeedDeleteElemInput;
  BusinessUserFeedDeleteKeyInput: BusinessUserFeedDeleteKeyInput;
  BusinessUserFeedInsertInput: BusinessUserFeedInsertInput;
  BusinessUserFeedMaxFields: ResolverTypeWrapper<BusinessUserFeedMaxFields>;
  BusinessUserFeedMaxOrderBy: BusinessUserFeedMaxOrderBy;
  BusinessUserFeedMinFields: ResolverTypeWrapper<BusinessUserFeedMinFields>;
  BusinessUserFeedMinOrderBy: BusinessUserFeedMinOrderBy;
  BusinessUserFeedMutationResponse: ResolverTypeWrapper<BusinessUserFeedMutationResponse>;
  BusinessUserFeedOnConflict: BusinessUserFeedOnConflict;
  BusinessUserFeedOrderBy: BusinessUserFeedOrderBy;
  BusinessUserFeedPkColumnsInput: BusinessUserFeedPkColumnsInput;
  BusinessUserFeedPrependInput: BusinessUserFeedPrependInput;
  BusinessUserFeedSelectColumn: BusinessUserFeedSelectColumn;
  BusinessUserFeedSelectColumnBusinessUserFeedAggregateBoolExpBool_andArgumentsColumns: BusinessUserFeedSelectColumnBusinessUserFeedAggregateBoolExpBool_andArgumentsColumns;
  BusinessUserFeedSelectColumnBusinessUserFeedAggregateBoolExpBool_orArgumentsColumns: BusinessUserFeedSelectColumnBusinessUserFeedAggregateBoolExpBool_orArgumentsColumns;
  BusinessUserFeedSetInput: BusinessUserFeedSetInput;
  BusinessUserFeedStreamCursorInput: BusinessUserFeedStreamCursorInput;
  BusinessUserFeedStreamCursorValueInput: BusinessUserFeedStreamCursorValueInput;
  BusinessUserFeedUpdateColumn: BusinessUserFeedUpdateColumn;
  BusinessUserFeedUpdates: BusinessUserFeedUpdates;
  BusinessUserRequestStatus: ResolverTypeWrapper<BusinessUserRequestStatus>;
  BusinessUserRequestStatusAggregate: ResolverTypeWrapper<BusinessUserRequestStatusAggregate>;
  BusinessUserRequestStatusAggregateFields: ResolverTypeWrapper<BusinessUserRequestStatusAggregateFields>;
  BusinessUserRequestStatusBoolExp: BusinessUserRequestStatusBoolExp;
  BusinessUserRequestStatusConstraint: BusinessUserRequestStatusConstraint;
  BusinessUserRequestStatusEnum: BusinessUserRequestStatusEnum;
  BusinessUserRequestStatusEnumComparisonExp: BusinessUserRequestStatusEnumComparisonExp;
  BusinessUserRequestStatusInsertInput: BusinessUserRequestStatusInsertInput;
  BusinessUserRequestStatusMaxFields: ResolverTypeWrapper<BusinessUserRequestStatusMaxFields>;
  BusinessUserRequestStatusMinFields: ResolverTypeWrapper<BusinessUserRequestStatusMinFields>;
  BusinessUserRequestStatusMutationResponse: ResolverTypeWrapper<BusinessUserRequestStatusMutationResponse>;
  BusinessUserRequestStatusOnConflict: BusinessUserRequestStatusOnConflict;
  BusinessUserRequestStatusOrderBy: BusinessUserRequestStatusOrderBy;
  BusinessUserRequestStatusPkColumnsInput: BusinessUserRequestStatusPkColumnsInput;
  BusinessUserRequestStatusSelectColumn: BusinessUserRequestStatusSelectColumn;
  BusinessUserRequestStatusSetInput: BusinessUserRequestStatusSetInput;
  BusinessUserRequestStatusStreamCursorInput: BusinessUserRequestStatusStreamCursorInput;
  BusinessUserRequestStatusStreamCursorValueInput: BusinessUserRequestStatusStreamCursorValueInput;
  BusinessUserRequestStatusUpdateColumn: BusinessUserRequestStatusUpdateColumn;
  BusinessUserRequestStatusUpdates: BusinessUserRequestStatusUpdates;
  BusinessUserStates: ResolverTypeWrapper<BusinessUserStates>;
  BusinessUserStatesAggregate: ResolverTypeWrapper<BusinessUserStatesAggregate>;
  BusinessUserStatesAggregateBoolExp: BusinessUserStatesAggregateBoolExp;
  BusinessUserStatesAggregateFields: ResolverTypeWrapper<BusinessUserStatesAggregateFields>;
  BusinessUserStatesAggregateOrderBy: BusinessUserStatesAggregateOrderBy;
  BusinessUserStatesArrRelInsertInput: BusinessUserStatesArrRelInsertInput;
  BusinessUserStatesBoolExp: BusinessUserStatesBoolExp;
  BusinessUserStatesConstraint: BusinessUserStatesConstraint;
  BusinessUserStatesInsertInput: BusinessUserStatesInsertInput;
  BusinessUserStatesMaxFields: ResolverTypeWrapper<BusinessUserStatesMaxFields>;
  BusinessUserStatesMaxOrderBy: BusinessUserStatesMaxOrderBy;
  BusinessUserStatesMinFields: ResolverTypeWrapper<BusinessUserStatesMinFields>;
  BusinessUserStatesMinOrderBy: BusinessUserStatesMinOrderBy;
  BusinessUserStatesMutationResponse: ResolverTypeWrapper<BusinessUserStatesMutationResponse>;
  BusinessUserStatesOnConflict: BusinessUserStatesOnConflict;
  BusinessUserStatesOrderBy: BusinessUserStatesOrderBy;
  BusinessUserStatesPkColumnsInput: BusinessUserStatesPkColumnsInput;
  BusinessUserStatesSelectColumn: BusinessUserStatesSelectColumn;
  BusinessUserStatesSetInput: BusinessUserStatesSetInput;
  BusinessUserStatesStreamCursorInput: BusinessUserStatesStreamCursorInput;
  BusinessUserStatesStreamCursorValueInput: BusinessUserStatesStreamCursorValueInput;
  BusinessUserStatesUpdateColumn: BusinessUserStatesUpdateColumn;
  BusinessUserStatesUpdates: BusinessUserStatesUpdates;
  ChangeOrganizationNameInput: ChangeOrganizationNameInput;
  ChangeOrganizationNameOutput: ResolverTypeWrapper<ChangeOrganizationNameOutput>;
  CheckOnetimeCodeOutput: ResolverTypeWrapper<CheckOnetimeCodeOutput>;
  CheckPhoneNumberOutput: ResolverTypeWrapper<CheckPhoneNumberOutput>;
  Content: Content;
  CreateSMSOutput: ResolverTypeWrapper<CreateSMSOutput>;
  CrmContext: ResolverTypeWrapper<CrmContext>;
  CrmContextAggregate: ResolverTypeWrapper<CrmContextAggregate>;
  CrmContextAggregateFields: ResolverTypeWrapper<CrmContextAggregateFields>;
  CrmContextBoolExp: CrmContextBoolExp;
  CrmContextConstraint: CrmContextConstraint;
  CrmContextInsertInput: CrmContextInsertInput;
  CrmContextMaxFields: ResolverTypeWrapper<CrmContextMaxFields>;
  CrmContextMinFields: ResolverTypeWrapper<CrmContextMinFields>;
  CrmContextMutationResponse: ResolverTypeWrapper<CrmContextMutationResponse>;
  CrmContextObjRelInsertInput: CrmContextObjRelInsertInput;
  CrmContextOnConflict: CrmContextOnConflict;
  CrmContextOrderBy: CrmContextOrderBy;
  CrmContextPkColumnsInput: CrmContextPkColumnsInput;
  CrmContextSelectColumn: CrmContextSelectColumn;
  CrmContextSetInput: CrmContextSetInput;
  CrmContextStreamCursorInput: CrmContextStreamCursorInput;
  CrmContextStreamCursorValueInput: CrmContextStreamCursorValueInput;
  CrmContextType: ResolverTypeWrapper<CrmContextType>;
  CrmContextTypeAggregate: ResolverTypeWrapper<CrmContextTypeAggregate>;
  CrmContextTypeAggregateFields: ResolverTypeWrapper<CrmContextTypeAggregateFields>;
  CrmContextTypeBoolExp: CrmContextTypeBoolExp;
  CrmContextTypeConstraint: CrmContextTypeConstraint;
  CrmContextTypeEnum: CrmContextTypeEnum;
  CrmContextTypeEnumComparisonExp: CrmContextTypeEnumComparisonExp;
  CrmContextTypeInsertInput: CrmContextTypeInsertInput;
  CrmContextTypeMaxFields: ResolverTypeWrapper<CrmContextTypeMaxFields>;
  CrmContextTypeMinFields: ResolverTypeWrapper<CrmContextTypeMinFields>;
  CrmContextTypeMutationResponse: ResolverTypeWrapper<CrmContextTypeMutationResponse>;
  CrmContextTypeOnConflict: CrmContextTypeOnConflict;
  CrmContextTypeOrderBy: CrmContextTypeOrderBy;
  CrmContextTypePkColumnsInput: CrmContextTypePkColumnsInput;
  CrmContextTypeSelectColumn: CrmContextTypeSelectColumn;
  CrmContextTypeSetInput: CrmContextTypeSetInput;
  CrmContextTypeStreamCursorInput: CrmContextTypeStreamCursorInput;
  CrmContextTypeStreamCursorValueInput: CrmContextTypeStreamCursorValueInput;
  CrmContextTypeUpdateColumn: CrmContextTypeUpdateColumn;
  CrmContextTypeUpdates: CrmContextTypeUpdates;
  CrmContextUpdateColumn: CrmContextUpdateColumn;
  CrmContextUpdates: CrmContextUpdates;
  CrmCreatorType: ResolverTypeWrapper<CrmCreatorType>;
  CrmCreatorTypeAggregate: ResolverTypeWrapper<CrmCreatorTypeAggregate>;
  CrmCreatorTypeAggregateFields: ResolverTypeWrapper<CrmCreatorTypeAggregateFields>;
  CrmCreatorTypeBoolExp: CrmCreatorTypeBoolExp;
  CrmCreatorTypeConstraint: CrmCreatorTypeConstraint;
  CrmCreatorTypeEnum: CrmCreatorTypeEnum;
  CrmCreatorTypeEnumComparisonExp: CrmCreatorTypeEnumComparisonExp;
  CrmCreatorTypeInsertInput: CrmCreatorTypeInsertInput;
  CrmCreatorTypeMaxFields: ResolverTypeWrapper<CrmCreatorTypeMaxFields>;
  CrmCreatorTypeMinFields: ResolverTypeWrapper<CrmCreatorTypeMinFields>;
  CrmCreatorTypeMutationResponse: ResolverTypeWrapper<CrmCreatorTypeMutationResponse>;
  CrmCreatorTypeOnConflict: CrmCreatorTypeOnConflict;
  CrmCreatorTypeOrderBy: CrmCreatorTypeOrderBy;
  CrmCreatorTypePkColumnsInput: CrmCreatorTypePkColumnsInput;
  CrmCreatorTypeSelectColumn: CrmCreatorTypeSelectColumn;
  CrmCreatorTypeSetInput: CrmCreatorTypeSetInput;
  CrmCreatorTypeStreamCursorInput: CrmCreatorTypeStreamCursorInput;
  CrmCreatorTypeStreamCursorValueInput: CrmCreatorTypeStreamCursorValueInput;
  CrmCreatorTypeUpdateColumn: CrmCreatorTypeUpdateColumn;
  CrmCreatorTypeUpdates: CrmCreatorTypeUpdates;
  CrmCrmType: ResolverTypeWrapper<CrmCrmType>;
  CrmCrmTypeAggregate: ResolverTypeWrapper<CrmCrmTypeAggregate>;
  CrmCrmTypeAggregateFields: ResolverTypeWrapper<CrmCrmTypeAggregateFields>;
  CrmCrmTypeBoolExp: CrmCrmTypeBoolExp;
  CrmCrmTypeConstraint: CrmCrmTypeConstraint;
  CrmCrmTypeEnum: CrmCrmTypeEnum;
  CrmCrmTypeEnumComparisonExp: CrmCrmTypeEnumComparisonExp;
  CrmCrmTypeInsertInput: CrmCrmTypeInsertInput;
  CrmCrmTypeMaxFields: ResolverTypeWrapper<CrmCrmTypeMaxFields>;
  CrmCrmTypeMinFields: ResolverTypeWrapper<CrmCrmTypeMinFields>;
  CrmCrmTypeMutationResponse: ResolverTypeWrapper<CrmCrmTypeMutationResponse>;
  CrmCrmTypeOnConflict: CrmCrmTypeOnConflict;
  CrmCrmTypeOrderBy: CrmCrmTypeOrderBy;
  CrmCrmTypePkColumnsInput: CrmCrmTypePkColumnsInput;
  CrmCrmTypeSelectColumn: CrmCrmTypeSelectColumn;
  CrmCrmTypeSetInput: CrmCrmTypeSetInput;
  CrmCrmTypeStreamCursorInput: CrmCrmTypeStreamCursorInput;
  CrmCrmTypeStreamCursorValueInput: CrmCrmTypeStreamCursorValueInput;
  CrmCrmTypeUpdateColumn: CrmCrmTypeUpdateColumn;
  CrmCrmTypeUpdates: CrmCrmTypeUpdates;
  CrmDirectionType: ResolverTypeWrapper<CrmDirectionType>;
  CrmDirectionTypeAggregate: ResolverTypeWrapper<CrmDirectionTypeAggregate>;
  CrmDirectionTypeAggregateFields: ResolverTypeWrapper<CrmDirectionTypeAggregateFields>;
  CrmDirectionTypeBoolExp: CrmDirectionTypeBoolExp;
  CrmDirectionTypeConstraint: CrmDirectionTypeConstraint;
  CrmDirectionTypeInsertInput: CrmDirectionTypeInsertInput;
  CrmDirectionTypeMaxFields: ResolverTypeWrapper<CrmDirectionTypeMaxFields>;
  CrmDirectionTypeMinFields: ResolverTypeWrapper<CrmDirectionTypeMinFields>;
  CrmDirectionTypeMutationResponse: ResolverTypeWrapper<CrmDirectionTypeMutationResponse>;
  CrmDirectionTypeOnConflict: CrmDirectionTypeOnConflict;
  CrmDirectionTypeOrderBy: CrmDirectionTypeOrderBy;
  CrmDirectionTypePkColumnsInput: CrmDirectionTypePkColumnsInput;
  CrmDirectionTypeSelectColumn: CrmDirectionTypeSelectColumn;
  CrmDirectionTypeSetInput: CrmDirectionTypeSetInput;
  CrmDirectionTypeStreamCursorInput: CrmDirectionTypeStreamCursorInput;
  CrmDirectionTypeStreamCursorValueInput: CrmDirectionTypeStreamCursorValueInput;
  CrmDirectionTypeUpdateColumn: CrmDirectionTypeUpdateColumn;
  CrmDirectionTypeUpdates: CrmDirectionTypeUpdates;
  CrmEntity: ResolverTypeWrapper<CrmEntity>;
  CrmEntityAggregate: ResolverTypeWrapper<CrmEntityAggregate>;
  CrmEntityAggregateFields: ResolverTypeWrapper<CrmEntityAggregateFields>;
  CrmEntityBoolExp: CrmEntityBoolExp;
  CrmEntityConstraint: CrmEntityConstraint;
  CrmEntityInsertInput: CrmEntityInsertInput;
  CrmEntityMaxFields: ResolverTypeWrapper<CrmEntityMaxFields>;
  CrmEntityMinFields: ResolverTypeWrapper<CrmEntityMinFields>;
  CrmEntityMutationResponse: ResolverTypeWrapper<CrmEntityMutationResponse>;
  CrmEntityOnConflict: CrmEntityOnConflict;
  CrmEntityOrderBy: CrmEntityOrderBy;
  CrmEntityPkColumnsInput: CrmEntityPkColumnsInput;
  CrmEntitySelectColumn: CrmEntitySelectColumn;
  CrmEntitySetInput: CrmEntitySetInput;
  CrmEntityStreamCursorInput: CrmEntityStreamCursorInput;
  CrmEntityStreamCursorValueInput: CrmEntityStreamCursorValueInput;
  CrmEntityUpdateColumn: CrmEntityUpdateColumn;
  CrmEntityUpdates: CrmEntityUpdates;
  CrmEvent: ResolverTypeWrapper<CrmEvent>;
  CrmEventAggregate: ResolverTypeWrapper<CrmEventAggregate>;
  CrmEventAggregateFields: ResolverTypeWrapper<CrmEventAggregateFields>;
  CrmEventBoolExp: CrmEventBoolExp;
  CrmEventConstraint: CrmEventConstraint;
  CrmEventInsertInput: CrmEventInsertInput;
  CrmEventMaxFields: ResolverTypeWrapper<CrmEventMaxFields>;
  CrmEventMinFields: ResolverTypeWrapper<CrmEventMinFields>;
  CrmEventMutationResponse: ResolverTypeWrapper<CrmEventMutationResponse>;
  CrmEventObjRelInsertInput: CrmEventObjRelInsertInput;
  CrmEventOnConflict: CrmEventOnConflict;
  CrmEventOrderBy: CrmEventOrderBy;
  CrmEventPkColumnsInput: CrmEventPkColumnsInput;
  CrmEventSelectColumn: CrmEventSelectColumn;
  CrmEventSetInput: CrmEventSetInput;
  CrmEventStreamCursorInput: CrmEventStreamCursorInput;
  CrmEventStreamCursorValueInput: CrmEventStreamCursorValueInput;
  CrmEventType: ResolverTypeWrapper<CrmEventType>;
  CrmEventTypeAggregate: ResolverTypeWrapper<CrmEventTypeAggregate>;
  CrmEventTypeAggregateFields: ResolverTypeWrapper<CrmEventTypeAggregateFields>;
  CrmEventTypeBoolExp: CrmEventTypeBoolExp;
  CrmEventTypeConstraint: CrmEventTypeConstraint;
  CrmEventTypeEnum: CrmEventTypeEnum;
  CrmEventTypeEnumComparisonExp: CrmEventTypeEnumComparisonExp;
  CrmEventTypeInsertInput: CrmEventTypeInsertInput;
  CrmEventTypeMaxFields: ResolverTypeWrapper<CrmEventTypeMaxFields>;
  CrmEventTypeMinFields: ResolverTypeWrapper<CrmEventTypeMinFields>;
  CrmEventTypeMutationResponse: ResolverTypeWrapper<CrmEventTypeMutationResponse>;
  CrmEventTypeOnConflict: CrmEventTypeOnConflict;
  CrmEventTypeOrderBy: CrmEventTypeOrderBy;
  CrmEventTypePkColumnsInput: CrmEventTypePkColumnsInput;
  CrmEventTypeSelectColumn: CrmEventTypeSelectColumn;
  CrmEventTypeSetInput: CrmEventTypeSetInput;
  CrmEventTypeStreamCursorInput: CrmEventTypeStreamCursorInput;
  CrmEventTypeStreamCursorValueInput: CrmEventTypeStreamCursorValueInput;
  CrmEventTypeUpdateColumn: CrmEventTypeUpdateColumn;
  CrmEventTypeUpdates: CrmEventTypeUpdates;
  CrmEventUpdateColumn: CrmEventUpdateColumn;
  CrmEventUpdates: CrmEventUpdates;
  CrmStatusCode: ResolverTypeWrapper<CrmStatusCode>;
  CrmStatusCodeAggregate: ResolverTypeWrapper<CrmStatusCodeAggregate>;
  CrmStatusCodeAggregateFields: ResolverTypeWrapper<CrmStatusCodeAggregateFields>;
  CrmStatusCodeBoolExp: CrmStatusCodeBoolExp;
  CrmStatusCodeConstraint: CrmStatusCodeConstraint;
  CrmStatusCodeInsertInput: CrmStatusCodeInsertInput;
  CrmStatusCodeMaxFields: ResolverTypeWrapper<CrmStatusCodeMaxFields>;
  CrmStatusCodeMinFields: ResolverTypeWrapper<CrmStatusCodeMinFields>;
  CrmStatusCodeMutationResponse: ResolverTypeWrapper<CrmStatusCodeMutationResponse>;
  CrmStatusCodeOnConflict: CrmStatusCodeOnConflict;
  CrmStatusCodeOrderBy: CrmStatusCodeOrderBy;
  CrmStatusCodePkColumnsInput: CrmStatusCodePkColumnsInput;
  CrmStatusCodeSelectColumn: CrmStatusCodeSelectColumn;
  CrmStatusCodeSetInput: CrmStatusCodeSetInput;
  CrmStatusCodeStreamCursorInput: CrmStatusCodeStreamCursorInput;
  CrmStatusCodeStreamCursorValueInput: CrmStatusCodeStreamCursorValueInput;
  CrmStatusCodeUpdateColumn: CrmStatusCodeUpdateColumn;
  CrmStatusCodeUpdates: CrmStatusCodeUpdates;
  CrmSystemType: ResolverTypeWrapper<CrmSystemType>;
  CrmSystemTypeAggregate: ResolverTypeWrapper<CrmSystemTypeAggregate>;
  CrmSystemTypeAggregateFields: ResolverTypeWrapper<CrmSystemTypeAggregateFields>;
  CrmSystemTypeBoolExp: CrmSystemTypeBoolExp;
  CrmSystemTypeConstraint: CrmSystemTypeConstraint;
  CrmSystemTypeEnum: CrmSystemTypeEnum;
  CrmSystemTypeEnumComparisonExp: CrmSystemTypeEnumComparisonExp;
  CrmSystemTypeInsertInput: CrmSystemTypeInsertInput;
  CrmSystemTypeMaxFields: ResolverTypeWrapper<CrmSystemTypeMaxFields>;
  CrmSystemTypeMinFields: ResolverTypeWrapper<CrmSystemTypeMinFields>;
  CrmSystemTypeMutationResponse: ResolverTypeWrapper<CrmSystemTypeMutationResponse>;
  CrmSystemTypeOnConflict: CrmSystemTypeOnConflict;
  CrmSystemTypeOrderBy: CrmSystemTypeOrderBy;
  CrmSystemTypePkColumnsInput: CrmSystemTypePkColumnsInput;
  CrmSystemTypeSelectColumn: CrmSystemTypeSelectColumn;
  CrmSystemTypeSetInput: CrmSystemTypeSetInput;
  CrmSystemTypeStreamCursorInput: CrmSystemTypeStreamCursorInput;
  CrmSystemTypeStreamCursorValueInput: CrmSystemTypeStreamCursorValueInput;
  CrmSystemTypeUpdateColumn: CrmSystemTypeUpdateColumn;
  CrmSystemTypeUpdates: CrmSystemTypeUpdates;
  CrmTraceContext: ResolverTypeWrapper<CrmTraceContext>;
  CrmTraceContextAggregate: ResolverTypeWrapper<CrmTraceContextAggregate>;
  CrmTraceContextAggregateFields: ResolverTypeWrapper<CrmTraceContextAggregateFields>;
  CrmTraceContextBoolExp: CrmTraceContextBoolExp;
  CrmTraceContextConstraint: CrmTraceContextConstraint;
  CrmTraceContextInsertInput: CrmTraceContextInsertInput;
  CrmTraceContextMaxFields: ResolverTypeWrapper<CrmTraceContextMaxFields>;
  CrmTraceContextMinFields: ResolverTypeWrapper<CrmTraceContextMinFields>;
  CrmTraceContextMutationResponse: ResolverTypeWrapper<CrmTraceContextMutationResponse>;
  CrmTraceContextObjRelInsertInput: CrmTraceContextObjRelInsertInput;
  CrmTraceContextOnConflict: CrmTraceContextOnConflict;
  CrmTraceContextOrderBy: CrmTraceContextOrderBy;
  CrmTraceContextPkColumnsInput: CrmTraceContextPkColumnsInput;
  CrmTraceContextSelectColumn: CrmTraceContextSelectColumn;
  CrmTraceContextSetInput: CrmTraceContextSetInput;
  CrmTraceContextStreamCursorInput: CrmTraceContextStreamCursorInput;
  CrmTraceContextStreamCursorValueInput: CrmTraceContextStreamCursorValueInput;
  CrmTraceContextUpdateColumn: CrmTraceContextUpdateColumn;
  CrmTraceContextUpdates: CrmTraceContextUpdates;
  CrmUnifiedEntityType: ResolverTypeWrapper<CrmUnifiedEntityType>;
  CrmUnifiedEntityTypeAggregate: ResolverTypeWrapper<CrmUnifiedEntityTypeAggregate>;
  CrmUnifiedEntityTypeAggregateFields: ResolverTypeWrapper<CrmUnifiedEntityTypeAggregateFields>;
  CrmUnifiedEntityTypeBoolExp: CrmUnifiedEntityTypeBoolExp;
  CrmUnifiedEntityTypeConstraint: CrmUnifiedEntityTypeConstraint;
  CrmUnifiedEntityTypeEnum: CrmUnifiedEntityTypeEnum;
  CrmUnifiedEntityTypeEnumComparisonExp: CrmUnifiedEntityTypeEnumComparisonExp;
  CrmUnifiedEntityTypeInsertInput: CrmUnifiedEntityTypeInsertInput;
  CrmUnifiedEntityTypeMaxFields: ResolverTypeWrapper<CrmUnifiedEntityTypeMaxFields>;
  CrmUnifiedEntityTypeMinFields: ResolverTypeWrapper<CrmUnifiedEntityTypeMinFields>;
  CrmUnifiedEntityTypeMutationResponse: ResolverTypeWrapper<CrmUnifiedEntityTypeMutationResponse>;
  CrmUnifiedEntityTypeOnConflict: CrmUnifiedEntityTypeOnConflict;
  CrmUnifiedEntityTypeOrderBy: CrmUnifiedEntityTypeOrderBy;
  CrmUnifiedEntityTypePkColumnsInput: CrmUnifiedEntityTypePkColumnsInput;
  CrmUnifiedEntityTypeSelectColumn: CrmUnifiedEntityTypeSelectColumn;
  CrmUnifiedEntityTypeSetInput: CrmUnifiedEntityTypeSetInput;
  CrmUnifiedEntityTypeStreamCursorInput: CrmUnifiedEntityTypeStreamCursorInput;
  CrmUnifiedEntityTypeStreamCursorValueInput: CrmUnifiedEntityTypeStreamCursorValueInput;
  CrmUnifiedEntityTypeUpdateColumn: CrmUnifiedEntityTypeUpdateColumn;
  CrmUnifiedEntityTypeUpdates: CrmUnifiedEntityTypeUpdates;
  CursorOrdering: CursorOrdering;
  CustomParameters: CustomParameters;
  DeleteRequestUserInput: DeleteRequestUserInput;
  DeleteRequestUserOutput: ResolverTypeWrapper<DeleteRequestUserOutput>;
  DeleteUserInput: DeleteUserInput;
  DeleteUserOutput: ResolverTypeWrapper<DeleteUserOutput>;
  DomainTypeEnumComparisonExp: DomainTypeEnumComparisonExp;
  DomainUserCategoryEnumComparisonExp: DomainUserCategoryEnumComparisonExp;
  EmailingActivityParticipantRoleEnumComparisonExp: EmailingActivityParticipantRoleEnumComparisonExp;
  EmailingCursorOrdering: EmailingCursorOrdering;
  EmailingDomainUserCategoryEnumComparisonExp: EmailingDomainUserCategoryEnumComparisonExp;
  EmailingEmailAccountSubscribers: ResolverTypeWrapper<EmailingEmailAccountSubscribers>;
  EmailingEmailAccountSubscribersAggregate: ResolverTypeWrapper<EmailingEmailAccountSubscribersAggregate>;
  EmailingEmailAccountSubscribersAggregateBoolExp: EmailingEmailAccountSubscribersAggregateBoolExp;
  EmailingEmailAccountSubscribersAggregateFields: ResolverTypeWrapper<EmailingEmailAccountSubscribersAggregateFields>;
  EmailingEmailAccountSubscribersAggregateOrderBy: EmailingEmailAccountSubscribersAggregateOrderBy;
  EmailingEmailAccountSubscribersArrRelInsertInput: EmailingEmailAccountSubscribersArrRelInsertInput;
  EmailingEmailAccountSubscribersBoolExp: EmailingEmailAccountSubscribersBoolExp;
  EmailingEmailAccountSubscribersConstraint: EmailingEmailAccountSubscribersConstraint;
  EmailingEmailAccountSubscribersInsertInput: EmailingEmailAccountSubscribersInsertInput;
  EmailingEmailAccountSubscribersMaxFields: ResolverTypeWrapper<EmailingEmailAccountSubscribersMaxFields>;
  EmailingEmailAccountSubscribersMaxOrderBy: EmailingEmailAccountSubscribersMaxOrderBy;
  EmailingEmailAccountSubscribersMinFields: ResolverTypeWrapper<EmailingEmailAccountSubscribersMinFields>;
  EmailingEmailAccountSubscribersMinOrderBy: EmailingEmailAccountSubscribersMinOrderBy;
  EmailingEmailAccountSubscribersMutationResponse: ResolverTypeWrapper<EmailingEmailAccountSubscribersMutationResponse>;
  EmailingEmailAccountSubscribersOnConflict: EmailingEmailAccountSubscribersOnConflict;
  EmailingEmailAccountSubscribersOrderBy: EmailingEmailAccountSubscribersOrderBy;
  EmailingEmailAccountSubscribersPkColumnsInput: EmailingEmailAccountSubscribersPkColumnsInput;
  EmailingEmailAccountSubscribersSelectColumn: EmailingEmailAccountSubscribersSelectColumn;
  EmailingEmailAccountSubscribersSetInput: EmailingEmailAccountSubscribersSetInput;
  EmailingEmailAccountSubscribersStreamCursorInput: EmailingEmailAccountSubscribersStreamCursorInput;
  EmailingEmailAccountSubscribersStreamCursorValueInput: EmailingEmailAccountSubscribersStreamCursorValueInput;
  EmailingEmailAccountSubscribersUpdateColumn: EmailingEmailAccountSubscribersUpdateColumn;
  EmailingEmailAccountSubscribersUpdates: EmailingEmailAccountSubscribersUpdates;
  EmailingEmailActivityType: ResolverTypeWrapper<EmailingEmailActivityType>;
  EmailingEmailActivityTypeAggregate: ResolverTypeWrapper<EmailingEmailActivityTypeAggregate>;
  EmailingEmailActivityTypeAggregateFields: ResolverTypeWrapper<EmailingEmailActivityTypeAggregateFields>;
  EmailingEmailActivityTypeBoolExp: EmailingEmailActivityTypeBoolExp;
  EmailingEmailActivityTypeConstraint: EmailingEmailActivityTypeConstraint;
  EmailingEmailActivityTypeEnum: EmailingEmailActivityTypeEnum;
  EmailingEmailActivityTypeEnumComparisonExp: EmailingEmailActivityTypeEnumComparisonExp;
  EmailingEmailActivityTypeInsertInput: EmailingEmailActivityTypeInsertInput;
  EmailingEmailActivityTypeMaxFields: ResolverTypeWrapper<EmailingEmailActivityTypeMaxFields>;
  EmailingEmailActivityTypeMinFields: ResolverTypeWrapper<EmailingEmailActivityTypeMinFields>;
  EmailingEmailActivityTypeMutationResponse: ResolverTypeWrapper<EmailingEmailActivityTypeMutationResponse>;
  EmailingEmailActivityTypeOnConflict: EmailingEmailActivityTypeOnConflict;
  EmailingEmailActivityTypeOrderBy: EmailingEmailActivityTypeOrderBy;
  EmailingEmailActivityTypePkColumnsInput: EmailingEmailActivityTypePkColumnsInput;
  EmailingEmailActivityTypeSelectColumn: EmailingEmailActivityTypeSelectColumn;
  EmailingEmailActivityTypeSetInput: EmailingEmailActivityTypeSetInput;
  EmailingEmailActivityTypeStreamCursorInput: EmailingEmailActivityTypeStreamCursorInput;
  EmailingEmailActivityTypeStreamCursorValueInput: EmailingEmailActivityTypeStreamCursorValueInput;
  EmailingEmailActivityTypeUpdateColumn: EmailingEmailActivityTypeUpdateColumn;
  EmailingEmailActivityTypeUpdates: EmailingEmailActivityTypeUpdates;
  EmailingEmailComment: ResolverTypeWrapper<EmailingEmailComment>;
  EmailingEmailCommentAggregate: ResolverTypeWrapper<EmailingEmailCommentAggregate>;
  EmailingEmailCommentAggregateBoolExp: EmailingEmailCommentAggregateBoolExp;
  EmailingEmailCommentAggregateFields: ResolverTypeWrapper<EmailingEmailCommentAggregateFields>;
  EmailingEmailCommentAggregateOrderBy: EmailingEmailCommentAggregateOrderBy;
  EmailingEmailCommentArrRelInsertInput: EmailingEmailCommentArrRelInsertInput;
  EmailingEmailCommentBoolExp: EmailingEmailCommentBoolExp;
  EmailingEmailCommentConstraint: EmailingEmailCommentConstraint;
  EmailingEmailCommentInsertInput: EmailingEmailCommentInsertInput;
  EmailingEmailCommentMaxFields: ResolverTypeWrapper<EmailingEmailCommentMaxFields>;
  EmailingEmailCommentMaxOrderBy: EmailingEmailCommentMaxOrderBy;
  EmailingEmailCommentMinFields: ResolverTypeWrapper<EmailingEmailCommentMinFields>;
  EmailingEmailCommentMinOrderBy: EmailingEmailCommentMinOrderBy;
  EmailingEmailCommentMutationResponse: ResolverTypeWrapper<EmailingEmailCommentMutationResponse>;
  EmailingEmailCommentOnConflict: EmailingEmailCommentOnConflict;
  EmailingEmailCommentOrderBy: EmailingEmailCommentOrderBy;
  EmailingEmailCommentPkColumnsInput: EmailingEmailCommentPkColumnsInput;
  EmailingEmailCommentSelectColumn: EmailingEmailCommentSelectColumn;
  EmailingEmailCommentSetInput: EmailingEmailCommentSetInput;
  EmailingEmailCommentStreamCursorInput: EmailingEmailCommentStreamCursorInput;
  EmailingEmailCommentStreamCursorValueInput: EmailingEmailCommentStreamCursorValueInput;
  EmailingEmailCommentUpdateColumn: EmailingEmailCommentUpdateColumn;
  EmailingEmailCommentUpdates: EmailingEmailCommentUpdates;
  EmailingNumericComparisonExp: EmailingNumericComparisonExp;
  EmailingOrderBy: EmailingOrderBy;
  EmailingProviderTypeEnumComparisonExp: EmailingProviderTypeEnumComparisonExp;
  Emailingactivity: ResolverTypeWrapper<Emailingactivity>;
  EmailingactivityAggregate: ResolverTypeWrapper<EmailingactivityAggregate>;
  EmailingactivityAggregateFields: ResolverTypeWrapper<EmailingactivityAggregateFields>;
  EmailingactivityAvgFields: ResolverTypeWrapper<EmailingactivityAvgFields>;
  EmailingactivityBoolExp: EmailingactivityBoolExp;
  EmailingactivityConstraint: EmailingactivityConstraint;
  EmailingactivityIncInput: EmailingactivityIncInput;
  EmailingactivityInsertInput: EmailingactivityInsertInput;
  EmailingactivityMaxFields: ResolverTypeWrapper<EmailingactivityMaxFields>;
  EmailingactivityMinFields: ResolverTypeWrapper<EmailingactivityMinFields>;
  EmailingactivityMutationResponse: ResolverTypeWrapper<EmailingactivityMutationResponse>;
  EmailingactivityObjRelInsertInput: EmailingactivityObjRelInsertInput;
  EmailingactivityOnConflict: EmailingactivityOnConflict;
  EmailingactivityOrderBy: EmailingactivityOrderBy;
  EmailingactivityParticipant: ResolverTypeWrapper<EmailingactivityParticipant>;
  EmailingactivityParticipantAggregate: ResolverTypeWrapper<EmailingactivityParticipantAggregate>;
  EmailingactivityParticipantAggregateFields: ResolverTypeWrapper<EmailingactivityParticipantAggregateFields>;
  EmailingactivityParticipantAggregateOrderBy: EmailingactivityParticipantAggregateOrderBy;
  EmailingactivityParticipantArrRelInsertInput: EmailingactivityParticipantArrRelInsertInput;
  EmailingactivityParticipantBoolExp: EmailingactivityParticipantBoolExp;
  EmailingactivityParticipantConstraint: EmailingactivityParticipantConstraint;
  EmailingactivityParticipantInsertInput: EmailingactivityParticipantInsertInput;
  EmailingactivityParticipantMaxFields: ResolverTypeWrapper<EmailingactivityParticipantMaxFields>;
  EmailingactivityParticipantMaxOrderBy: EmailingactivityParticipantMaxOrderBy;
  EmailingactivityParticipantMinFields: ResolverTypeWrapper<EmailingactivityParticipantMinFields>;
  EmailingactivityParticipantMinOrderBy: EmailingactivityParticipantMinOrderBy;
  EmailingactivityParticipantMutationResponse: ResolverTypeWrapper<EmailingactivityParticipantMutationResponse>;
  EmailingactivityParticipantOnConflict: EmailingactivityParticipantOnConflict;
  EmailingactivityParticipantOrderBy: EmailingactivityParticipantOrderBy;
  EmailingactivityParticipantPkColumnsInput: EmailingactivityParticipantPkColumnsInput;
  EmailingactivityParticipantRole: ResolverTypeWrapper<EmailingactivityParticipantRole>;
  EmailingactivityParticipantRoleAggregate: ResolverTypeWrapper<EmailingactivityParticipantRoleAggregate>;
  EmailingactivityParticipantRoleAggregateFields: ResolverTypeWrapper<EmailingactivityParticipantRoleAggregateFields>;
  EmailingactivityParticipantRoleBoolExp: EmailingactivityParticipantRoleBoolExp;
  EmailingactivityParticipantRoleConstraint: EmailingactivityParticipantRoleConstraint;
  EmailingactivityParticipantRoleEnum: EmailingactivityParticipantRoleEnum;
  EmailingactivityParticipantRoleInsertInput: EmailingactivityParticipantRoleInsertInput;
  EmailingactivityParticipantRoleMaxFields: ResolverTypeWrapper<EmailingactivityParticipantRoleMaxFields>;
  EmailingactivityParticipantRoleMinFields: ResolverTypeWrapper<EmailingactivityParticipantRoleMinFields>;
  EmailingactivityParticipantRoleMutationResponse: ResolverTypeWrapper<EmailingactivityParticipantRoleMutationResponse>;
  EmailingactivityParticipantRoleOnConflict: EmailingactivityParticipantRoleOnConflict;
  EmailingactivityParticipantRoleOrderBy: EmailingactivityParticipantRoleOrderBy;
  EmailingactivityParticipantRolePkColumnsInput: EmailingactivityParticipantRolePkColumnsInput;
  EmailingactivityParticipantRoleSelectColumn: EmailingactivityParticipantRoleSelectColumn;
  EmailingactivityParticipantRoleSetInput: EmailingactivityParticipantRoleSetInput;
  EmailingactivityParticipantRoleStreamCursorInput: EmailingactivityParticipantRoleStreamCursorInput;
  EmailingactivityParticipantRoleStreamCursorValueInput: EmailingactivityParticipantRoleStreamCursorValueInput;
  EmailingactivityParticipantRoleUpdateColumn: EmailingactivityParticipantRoleUpdateColumn;
  EmailingactivityParticipantRoleUpdates: EmailingactivityParticipantRoleUpdates;
  EmailingactivityParticipantSelectColumn: EmailingactivityParticipantSelectColumn;
  EmailingactivityParticipantSetInput: EmailingactivityParticipantSetInput;
  EmailingactivityParticipantUpdateColumn: EmailingactivityParticipantUpdateColumn;
  EmailingactivityPkColumnsInput: EmailingactivityPkColumnsInput;
  EmailingactivitySelectColumn: EmailingactivitySelectColumn;
  EmailingactivitySetInput: EmailingactivitySetInput;
  EmailingactivityStddevFields: ResolverTypeWrapper<EmailingactivityStddevFields>;
  EmailingactivityStddevPopFields: ResolverTypeWrapper<EmailingactivityStddevPopFields>;
  EmailingactivityStddevSampFields: ResolverTypeWrapper<EmailingactivityStddevSampFields>;
  EmailingactivitySumFields: ResolverTypeWrapper<EmailingactivitySumFields>;
  EmailingactivityUpdateColumn: EmailingactivityUpdateColumn;
  EmailingactivityVarPopFields: ResolverTypeWrapper<EmailingactivityVarPopFields>;
  EmailingactivityVarSampFields: ResolverTypeWrapper<EmailingactivityVarSampFields>;
  EmailingactivityVarianceFields: ResolverTypeWrapper<EmailingactivityVarianceFields>;
  EmailingdomainOrganization: ResolverTypeWrapper<EmailingdomainOrganization>;
  EmailingdomainOrganizationAggregate: ResolverTypeWrapper<EmailingdomainOrganizationAggregate>;
  EmailingdomainOrganizationAggregateBoolExp: EmailingdomainOrganizationAggregateBoolExp;
  EmailingdomainOrganizationAggregateFields: ResolverTypeWrapper<EmailingdomainOrganizationAggregateFields>;
  EmailingdomainOrganizationAggregateOrderBy: EmailingdomainOrganizationAggregateOrderBy;
  EmailingdomainOrganizationArrRelInsertInput: EmailingdomainOrganizationArrRelInsertInput;
  EmailingdomainOrganizationBoolExp: EmailingdomainOrganizationBoolExp;
  EmailingdomainOrganizationConstraint: EmailingdomainOrganizationConstraint;
  EmailingdomainOrganizationInsertInput: EmailingdomainOrganizationInsertInput;
  EmailingdomainOrganizationMaxFields: ResolverTypeWrapper<EmailingdomainOrganizationMaxFields>;
  EmailingdomainOrganizationMaxOrderBy: EmailingdomainOrganizationMaxOrderBy;
  EmailingdomainOrganizationMinFields: ResolverTypeWrapper<EmailingdomainOrganizationMinFields>;
  EmailingdomainOrganizationMinOrderBy: EmailingdomainOrganizationMinOrderBy;
  EmailingdomainOrganizationMutationResponse: ResolverTypeWrapper<EmailingdomainOrganizationMutationResponse>;
  EmailingdomainOrganizationObjRelInsertInput: EmailingdomainOrganizationObjRelInsertInput;
  EmailingdomainOrganizationOnConflict: EmailingdomainOrganizationOnConflict;
  EmailingdomainOrganizationOrderBy: EmailingdomainOrganizationOrderBy;
  EmailingdomainOrganizationPkColumnsInput: EmailingdomainOrganizationPkColumnsInput;
  EmailingdomainOrganizationSelectColumn: EmailingdomainOrganizationSelectColumn;
  EmailingdomainOrganizationSetInput: EmailingdomainOrganizationSetInput;
  EmailingdomainOrganizationUpdateColumn: EmailingdomainOrganizationUpdateColumn;
  EmailingdomainUser: ResolverTypeWrapper<EmailingdomainUser>;
  EmailingdomainUserAggregate: ResolverTypeWrapper<EmailingdomainUserAggregate>;
  EmailingdomainUserAggregateFields: ResolverTypeWrapper<EmailingdomainUserAggregateFields>;
  EmailingdomainUserAggregateOrderBy: EmailingdomainUserAggregateOrderBy;
  EmailingdomainUserArrRelInsertInput: EmailingdomainUserArrRelInsertInput;
  EmailingdomainUserBoolExp: EmailingdomainUserBoolExp;
  EmailingdomainUserCategory: ResolverTypeWrapper<EmailingdomainUserCategory>;
  EmailingdomainUserCategoryAggregate: ResolverTypeWrapper<EmailingdomainUserCategoryAggregate>;
  EmailingdomainUserCategoryAggregateFields: ResolverTypeWrapper<EmailingdomainUserCategoryAggregateFields>;
  EmailingdomainUserCategoryBoolExp: EmailingdomainUserCategoryBoolExp;
  EmailingdomainUserCategoryConstraint: EmailingdomainUserCategoryConstraint;
  EmailingdomainUserCategoryEnum: EmailingdomainUserCategoryEnum;
  EmailingdomainUserCategoryInsertInput: EmailingdomainUserCategoryInsertInput;
  EmailingdomainUserCategoryMaxFields: ResolverTypeWrapper<EmailingdomainUserCategoryMaxFields>;
  EmailingdomainUserCategoryMinFields: ResolverTypeWrapper<EmailingdomainUserCategoryMinFields>;
  EmailingdomainUserCategoryMutationResponse: ResolverTypeWrapper<EmailingdomainUserCategoryMutationResponse>;
  EmailingdomainUserCategoryObjRelInsertInput: EmailingdomainUserCategoryObjRelInsertInput;
  EmailingdomainUserCategoryOnConflict: EmailingdomainUserCategoryOnConflict;
  EmailingdomainUserCategoryOrderBy: EmailingdomainUserCategoryOrderBy;
  EmailingdomainUserCategoryPkColumnsInput: EmailingdomainUserCategoryPkColumnsInput;
  EmailingdomainUserCategorySelectColumn: EmailingdomainUserCategorySelectColumn;
  EmailingdomainUserCategorySetInput: EmailingdomainUserCategorySetInput;
  EmailingdomainUserCategoryStreamCursorInput: EmailingdomainUserCategoryStreamCursorInput;
  EmailingdomainUserCategoryStreamCursorValueInput: EmailingdomainUserCategoryStreamCursorValueInput;
  EmailingdomainUserCategoryUpdateColumn: EmailingdomainUserCategoryUpdateColumn;
  EmailingdomainUserCategoryUpdates: EmailingdomainUserCategoryUpdates;
  EmailingdomainUserConstraint: EmailingdomainUserConstraint;
  EmailingdomainUserInsertInput: EmailingdomainUserInsertInput;
  EmailingdomainUserMaxFields: ResolverTypeWrapper<EmailingdomainUserMaxFields>;
  EmailingdomainUserMaxOrderBy: EmailingdomainUserMaxOrderBy;
  EmailingdomainUserMinFields: ResolverTypeWrapper<EmailingdomainUserMinFields>;
  EmailingdomainUserMinOrderBy: EmailingdomainUserMinOrderBy;
  EmailingdomainUserMutationResponse: ResolverTypeWrapper<EmailingdomainUserMutationResponse>;
  EmailingdomainUserObjRelInsertInput: EmailingdomainUserObjRelInsertInput;
  EmailingdomainUserOnConflict: EmailingdomainUserOnConflict;
  EmailingdomainUserOrderBy: EmailingdomainUserOrderBy;
  EmailingdomainUserPkColumnsInput: EmailingdomainUserPkColumnsInput;
  EmailingdomainUserSelectColumn: EmailingdomainUserSelectColumn;
  EmailingdomainUserSetInput: EmailingdomainUserSetInput;
  EmailingdomainUserUpdateColumn: EmailingdomainUserUpdateColumn;
  EmailingdomainUserUpdates: EmailingdomainUserUpdates;
  EmailingemailAccountSubscribersAggregateBoolExpCount: EmailingemailAccountSubscribersAggregateBoolExpCount;
  EmailingemailCommentAggregateBoolExpCount: EmailingemailCommentAggregateBoolExpCount;
  Emailingevent: ResolverTypeWrapper<Emailingevent>;
  EmailingeventAggregate: ResolverTypeWrapper<EmailingeventAggregate>;
  EmailingeventAggregateFields: ResolverTypeWrapper<EmailingeventAggregateFields>;
  EmailingeventBoolExp: EmailingeventBoolExp;
  EmailingeventConstraint: EmailingeventConstraint;
  EmailingeventInsertInput: EmailingeventInsertInput;
  EmailingeventMaxFields: ResolverTypeWrapper<EmailingeventMaxFields>;
  EmailingeventMinFields: ResolverTypeWrapper<EmailingeventMinFields>;
  EmailingeventMutationResponse: ResolverTypeWrapper<EmailingeventMutationResponse>;
  EmailingeventOnConflict: EmailingeventOnConflict;
  EmailingeventOrderBy: EmailingeventOrderBy;
  EmailingeventPkColumnsInput: EmailingeventPkColumnsInput;
  EmailingeventSelectColumn: EmailingeventSelectColumn;
  EmailingeventSetInput: EmailingeventSetInput;
  EmailingeventUpdateColumn: EmailingeventUpdateColumn;
  EmailingeventUpdates: EmailingeventUpdates;
  Emailingnumeric: ResolverTypeWrapper<Scalars['Emailingnumeric']['output']>;
  EmailingproviderAccount: ResolverTypeWrapper<EmailingproviderAccount>;
  EmailingproviderAccountAggregate: ResolverTypeWrapper<EmailingproviderAccountAggregate>;
  EmailingproviderAccountAggregateFields: ResolverTypeWrapper<EmailingproviderAccountAggregateFields>;
  EmailingproviderAccountAggregateOrderBy: EmailingproviderAccountAggregateOrderBy;
  EmailingproviderAccountArrRelInsertInput: EmailingproviderAccountArrRelInsertInput;
  EmailingproviderAccountAvgFields: ResolverTypeWrapper<EmailingproviderAccountAvgFields>;
  EmailingproviderAccountAvgOrderBy: EmailingproviderAccountAvgOrderBy;
  EmailingproviderAccountBoolExp: EmailingproviderAccountBoolExp;
  EmailingproviderAccountConstraint: EmailingproviderAccountConstraint;
  EmailingproviderAccountIncInput: EmailingproviderAccountIncInput;
  EmailingproviderAccountInsertInput: EmailingproviderAccountInsertInput;
  EmailingproviderAccountMaxFields: ResolverTypeWrapper<EmailingproviderAccountMaxFields>;
  EmailingproviderAccountMaxOrderBy: EmailingproviderAccountMaxOrderBy;
  EmailingproviderAccountMinFields: ResolverTypeWrapper<EmailingproviderAccountMinFields>;
  EmailingproviderAccountMinOrderBy: EmailingproviderAccountMinOrderBy;
  EmailingproviderAccountMutationResponse: ResolverTypeWrapper<EmailingproviderAccountMutationResponse>;
  EmailingproviderAccountOnConflict: EmailingproviderAccountOnConflict;
  EmailingproviderAccountOrderBy: EmailingproviderAccountOrderBy;
  EmailingproviderAccountPkColumnsInput: EmailingproviderAccountPkColumnsInput;
  EmailingproviderAccountSelectColumn: EmailingproviderAccountSelectColumn;
  EmailingproviderAccountSetInput: EmailingproviderAccountSetInput;
  EmailingproviderAccountStddevFields: ResolverTypeWrapper<EmailingproviderAccountStddevFields>;
  EmailingproviderAccountStddevOrderBy: EmailingproviderAccountStddevOrderBy;
  EmailingproviderAccountStddevPopFields: ResolverTypeWrapper<EmailingproviderAccountStddevPopFields>;
  EmailingproviderAccountStddevPopOrderBy: EmailingproviderAccountStddevPopOrderBy;
  EmailingproviderAccountStddevSampFields: ResolverTypeWrapper<EmailingproviderAccountStddevSampFields>;
  EmailingproviderAccountStddevSampOrderBy: EmailingproviderAccountStddevSampOrderBy;
  EmailingproviderAccountSumFields: ResolverTypeWrapper<EmailingproviderAccountSumFields>;
  EmailingproviderAccountSumOrderBy: EmailingproviderAccountSumOrderBy;
  EmailingproviderAccountUpdateColumn: EmailingproviderAccountUpdateColumn;
  EmailingproviderAccountUpdates: EmailingproviderAccountUpdates;
  EmailingproviderAccountVarPopFields: ResolverTypeWrapper<EmailingproviderAccountVarPopFields>;
  EmailingproviderAccountVarPopOrderBy: EmailingproviderAccountVarPopOrderBy;
  EmailingproviderAccountVarSampFields: ResolverTypeWrapper<EmailingproviderAccountVarSampFields>;
  EmailingproviderAccountVarSampOrderBy: EmailingproviderAccountVarSampOrderBy;
  EmailingproviderAccountVarianceFields: ResolverTypeWrapper<EmailingproviderAccountVarianceFields>;
  EmailingproviderAccountVarianceOrderBy: EmailingproviderAccountVarianceOrderBy;
  EmailingproviderType: ResolverTypeWrapper<EmailingproviderType>;
  EmailingproviderTypeAggregate: ResolverTypeWrapper<EmailingproviderTypeAggregate>;
  EmailingproviderTypeAggregateFields: ResolverTypeWrapper<EmailingproviderTypeAggregateFields>;
  EmailingproviderTypeBoolExp: EmailingproviderTypeBoolExp;
  EmailingproviderTypeConstraint: EmailingproviderTypeConstraint;
  EmailingproviderTypeEnum: EmailingproviderTypeEnum;
  EmailingproviderTypeInsertInput: EmailingproviderTypeInsertInput;
  EmailingproviderTypeMaxFields: ResolverTypeWrapper<EmailingproviderTypeMaxFields>;
  EmailingproviderTypeMinFields: ResolverTypeWrapper<EmailingproviderTypeMinFields>;
  EmailingproviderTypeMutationResponse: ResolverTypeWrapper<EmailingproviderTypeMutationResponse>;
  EmailingproviderTypeObjRelInsertInput: EmailingproviderTypeObjRelInsertInput;
  EmailingproviderTypeOnConflict: EmailingproviderTypeOnConflict;
  EmailingproviderTypeOrderBy: EmailingproviderTypeOrderBy;
  EmailingproviderTypePkColumnsInput: EmailingproviderTypePkColumnsInput;
  EmailingproviderTypeSelectColumn: EmailingproviderTypeSelectColumn;
  EmailingproviderTypeSetInput: EmailingproviderTypeSetInput;
  EmailingproviderTypeStreamCursorInput: EmailingproviderTypeStreamCursorInput;
  EmailingproviderTypeStreamCursorValueInput: EmailingproviderTypeStreamCursorValueInput;
  EmailingproviderTypeUpdateColumn: EmailingproviderTypeUpdateColumn;
  EmailingproviderTypeUpdates: EmailingproviderTypeUpdates;
  Emailingtimestamptz: ResolverTypeWrapper<Scalars['Emailingtimestamptz']['output']>;
  EntryCategory: EntryCategory;
  EntrySource: EntrySource;
  File: File;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  GateCustomParameters: GateCustomParameters;
  GeodataAddress: ResolverTypeWrapper<GeodataAddress>;
  GeodataAddressAggregate: ResolverTypeWrapper<GeodataAddressAggregate>;
  GeodataAddressAggregateBoolExp: GeodataAddressAggregateBoolExp;
  GeodataAddressAggregateFields: ResolverTypeWrapper<GeodataAddressAggregateFields>;
  GeodataAddressAggregateOrderBy: GeodataAddressAggregateOrderBy;
  GeodataAddressArrRelInsertInput: GeodataAddressArrRelInsertInput;
  GeodataAddressBoolExp: GeodataAddressBoolExp;
  GeodataAddressConstraint: GeodataAddressConstraint;
  GeodataAddressInsertInput: GeodataAddressInsertInput;
  GeodataAddressMaxFields: ResolverTypeWrapper<GeodataAddressMaxFields>;
  GeodataAddressMaxOrderBy: GeodataAddressMaxOrderBy;
  GeodataAddressMinFields: ResolverTypeWrapper<GeodataAddressMinFields>;
  GeodataAddressMinOrderBy: GeodataAddressMinOrderBy;
  GeodataAddressMutationResponse: ResolverTypeWrapper<GeodataAddressMutationResponse>;
  GeodataAddressOnConflict: GeodataAddressOnConflict;
  GeodataAddressOrderBy: GeodataAddressOrderBy;
  GeodataAddressPkColumnsInput: GeodataAddressPkColumnsInput;
  GeodataAddressSelectColumn: GeodataAddressSelectColumn;
  GeodataAddressSetInput: GeodataAddressSetInput;
  GeodataAddressStreamCursorInput: GeodataAddressStreamCursorInput;
  GeodataAddressStreamCursorValueInput: GeodataAddressStreamCursorValueInput;
  GeodataAddressUpdateColumn: GeodataAddressUpdateColumn;
  GeodataAddressUpdates: GeodataAddressUpdates;
  GeodataBigintComparisonExp: GeodataBigintComparisonExp;
  GeodataCursorOrdering: GeodataCursorOrdering;
  GeodataGeographyCastExp: GeodataGeographyCastExp;
  GeodataGeographyComparisonExp: GeodataGeographyComparisonExp;
  GeodataGeometryCastExp: GeodataGeometryCastExp;
  GeodataGeometryComparisonExp: GeodataGeometryComparisonExp;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode>;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregate: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregate>;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregateFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregateFields>;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeBoolExp: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeBoolExp;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeInsertInput: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeInsertInput;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMaxFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMaxFields>;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMinFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMinFields>;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMutationResponse: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMutationResponse>;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeOrderBy: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeOrderBy;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeSelectColumn: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeSelectColumn;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeSetInput: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeSetInput;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeStreamCursorInput: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeStreamCursorInput;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeStreamCursorValueInput: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeStreamCursorValueInput;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeUpdates: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeUpdates;
  GeodataMatrikkelenadresseleilighetsnivaAtkomst: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaAtkomst>;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregate: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregate>;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregateFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregateFields>;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstAvgFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaAtkomstAvgFields>;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstBoolExp: GeodataMatrikkelenadresseleilighetsnivaAtkomstBoolExp;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstIncInput: GeodataMatrikkelenadresseleilighetsnivaAtkomstIncInput;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstInsertInput: GeodataMatrikkelenadresseleilighetsnivaAtkomstInsertInput;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstMaxFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaAtkomstMaxFields>;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstMinFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaAtkomstMinFields>;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstMutationResponse: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaAtkomstMutationResponse>;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstOrderBy: GeodataMatrikkelenadresseleilighetsnivaAtkomstOrderBy;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstSelectColumn: GeodataMatrikkelenadresseleilighetsnivaAtkomstSelectColumn;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstSetInput: GeodataMatrikkelenadresseleilighetsnivaAtkomstSetInput;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevFields>;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevPopFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevPopFields>;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevSampFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevSampFields>;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstStreamCursorInput: GeodataMatrikkelenadresseleilighetsnivaAtkomstStreamCursorInput;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstStreamCursorValueInput: GeodataMatrikkelenadresseleilighetsnivaAtkomstStreamCursorValueInput;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstSumFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaAtkomstSumFields>;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstUpdates: GeodataMatrikkelenadresseleilighetsnivaAtkomstUpdates;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstVarPopFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaAtkomstVarPopFields>;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstVarSampFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaAtkomstVarSampFields>;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstVarianceFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaAtkomstVarianceFields>;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummer: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaKommunenummer>;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregate: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregate>;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregateFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregateFields>;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerBoolExp: GeodataMatrikkelenadresseleilighetsnivaKommunenummerBoolExp;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerInsertInput: GeodataMatrikkelenadresseleilighetsnivaKommunenummerInsertInput;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerMaxFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaKommunenummerMaxFields>;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerMinFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaKommunenummerMinFields>;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerMutationResponse: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaKommunenummerMutationResponse>;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerOrderBy: GeodataMatrikkelenadresseleilighetsnivaKommunenummerOrderBy;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerSelectColumn: GeodataMatrikkelenadresseleilighetsnivaKommunenummerSelectColumn;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerSetInput: GeodataMatrikkelenadresseleilighetsnivaKommunenummerSetInput;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerStreamCursorInput: GeodataMatrikkelenadresseleilighetsnivaKommunenummerStreamCursorInput;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerStreamCursorValueInput: GeodataMatrikkelenadresseleilighetsnivaKommunenummerStreamCursorValueInput;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerUpdates: GeodataMatrikkelenadresseleilighetsnivaKommunenummerUpdates;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregate: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregate>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregateFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregateFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregate: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregate>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregateFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregateFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAvgFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAvgFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidBoolExp: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidBoolExp;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidIncInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidIncInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidInsertInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidInsertInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMaxFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMaxFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMinFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMinFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMutationResponse: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMutationResponse>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidOrderBy: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidOrderBy;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidSelectColumn: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidSelectColumn;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidSetInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidSetInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevPopFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevPopFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevSampFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevSampFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStreamCursorInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStreamCursorInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStreamCursorValueInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStreamCursorValueInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidSumFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidSumFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidUpdates: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidUpdates;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarPopFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarPopFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarSampFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarSampFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarianceFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarianceFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAvgFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAvgFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetBoolExp: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetBoolExp;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetIncInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetIncInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetInsertInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetInsertInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMaxFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMaxFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMinFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMinFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMutationResponse: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMutationResponse>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetOrderBy: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetOrderBy;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetSelectColumn: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetSelectColumn;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetSetInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetSetInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevPopFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevPopFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevSampFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevSampFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStreamCursorInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStreamCursorInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStreamCursorValueInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStreamCursorValueInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetSumFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetSumFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUpdates: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUpdates;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregate: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregate>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregateFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregateFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAvgFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAvgFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstBoolExp: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstBoolExp;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstIncInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstIncInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstInsertInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstInsertInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMaxFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMaxFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMinFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMinFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMutationResponse: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMutationResponse>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstOrderBy: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstOrderBy;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstSelectColumn: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstSelectColumn;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstSetInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstSetInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevPopFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevPopFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevSampFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevSampFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStreamCursorInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStreamCursorInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStreamCursorValueInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStreamCursorValueInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstSumFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstSumFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstUpdates: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstUpdates;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarPopFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarPopFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarSampFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarSampFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarianceFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarianceFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarPopFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarPopFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarSampFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarSampFields>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarianceFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarianceFields>;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomst: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaTypeatkomst>;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregate: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregate>;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregateFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregateFields>;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstBoolExp: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstBoolExp;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstInsertInput: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstInsertInput;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMaxFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMaxFields>;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMinFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMinFields>;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMutationResponse: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMutationResponse>;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstOrderBy: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstOrderBy;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstSelectColumn: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstSelectColumn;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstSetInput: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstSetInput;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstStreamCursorInput: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstStreamCursorInput;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstStreamCursorValueInput: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstStreamCursorValueInput;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstUpdates: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstUpdates;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhet: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhet>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregate: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregate>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregateFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregateFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregate: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregate>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregateFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregateFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAvgFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAvgFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidBoolExp: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidBoolExp;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidIncInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidIncInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidInsertInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidInsertInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMaxFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMaxFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMinFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMinFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMutationResponse: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMutationResponse>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidOrderBy: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidOrderBy;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidSelectColumn: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidSelectColumn;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidSetInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidSetInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevPopFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevPopFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevSampFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevSampFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStreamCursorInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStreamCursorInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStreamCursorValueInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStreamCursorValueInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidSumFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidSumFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidUpdates: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidUpdates;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarPopFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarPopFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarSampFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarSampFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarianceFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarianceFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAvgFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAvgFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetBoolExp: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetBoolExp;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetIncInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetIncInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetInsertInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetInsertInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMaxFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMaxFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMinFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMinFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMutationResponse: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMutationResponse>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetOrderBy: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetOrderBy;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetSelectColumn: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetSelectColumn;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetSetInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetSetInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevPopFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevPopFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevSampFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevSampFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStreamCursorInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStreamCursorInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStreamCursorValueInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStreamCursorValueInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetSumFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetSumFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUpdates: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUpdates;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregate: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregate>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregateFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregateFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAvgFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAvgFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstBoolExp: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstBoolExp;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstIncInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstIncInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstInsertInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstInsertInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMaxFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMaxFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMinFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMinFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMutationResponse: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMutationResponse>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstOrderBy: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstOrderBy;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstSelectColumn: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstSelectColumn;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstSetInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstSetInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevPopFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevPopFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevSampFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevSampFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStreamCursorInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStreamCursorInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStreamCursorValueInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStreamCursorValueInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstSumFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstSumFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstUpdates: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstUpdates;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarPopFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarPopFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarSampFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarSampFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarianceFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarianceFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarPopFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarPopFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarSampFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarSampFields>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarianceFields: ResolverTypeWrapper<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarianceFields>;
  GeodataOrderBy: GeodataOrderBy;
  GeodataSpatialRefSys: ResolverTypeWrapper<GeodataSpatialRefSys>;
  GeodataSpatialRefSysAggregate: ResolverTypeWrapper<GeodataSpatialRefSysAggregate>;
  GeodataSpatialRefSysAggregateFields: ResolverTypeWrapper<GeodataSpatialRefSysAggregateFields>;
  GeodataSpatialRefSysAvgFields: ResolverTypeWrapper<GeodataSpatialRefSysAvgFields>;
  GeodataSpatialRefSysBoolExp: GeodataSpatialRefSysBoolExp;
  GeodataSpatialRefSysConstraint: GeodataSpatialRefSysConstraint;
  GeodataSpatialRefSysIncInput: GeodataSpatialRefSysIncInput;
  GeodataSpatialRefSysInsertInput: GeodataSpatialRefSysInsertInput;
  GeodataSpatialRefSysMaxFields: ResolverTypeWrapper<GeodataSpatialRefSysMaxFields>;
  GeodataSpatialRefSysMinFields: ResolverTypeWrapper<GeodataSpatialRefSysMinFields>;
  GeodataSpatialRefSysMutationResponse: ResolverTypeWrapper<GeodataSpatialRefSysMutationResponse>;
  GeodataSpatialRefSysOnConflict: GeodataSpatialRefSysOnConflict;
  GeodataSpatialRefSysOrderBy: GeodataSpatialRefSysOrderBy;
  GeodataSpatialRefSysPkColumnsInput: GeodataSpatialRefSysPkColumnsInput;
  GeodataSpatialRefSysSelectColumn: GeodataSpatialRefSysSelectColumn;
  GeodataSpatialRefSysSetInput: GeodataSpatialRefSysSetInput;
  GeodataSpatialRefSysStddevFields: ResolverTypeWrapper<GeodataSpatialRefSysStddevFields>;
  GeodataSpatialRefSysStddevPopFields: ResolverTypeWrapper<GeodataSpatialRefSysStddevPopFields>;
  GeodataSpatialRefSysStddevSampFields: ResolverTypeWrapper<GeodataSpatialRefSysStddevSampFields>;
  GeodataSpatialRefSysStreamCursorInput: GeodataSpatialRefSysStreamCursorInput;
  GeodataSpatialRefSysStreamCursorValueInput: GeodataSpatialRefSysStreamCursorValueInput;
  GeodataSpatialRefSysSumFields: ResolverTypeWrapper<GeodataSpatialRefSysSumFields>;
  GeodataSpatialRefSysUpdateColumn: GeodataSpatialRefSysUpdateColumn;
  GeodataSpatialRefSysUpdates: GeodataSpatialRefSysUpdates;
  GeodataSpatialRefSysVarPopFields: ResolverTypeWrapper<GeodataSpatialRefSysVarPopFields>;
  GeodataSpatialRefSysVarSampFields: ResolverTypeWrapper<GeodataSpatialRefSysVarSampFields>;
  GeodataSpatialRefSysVarianceFields: ResolverTypeWrapper<GeodataSpatialRefSysVarianceFields>;
  GeodataZip: ResolverTypeWrapper<GeodataZip>;
  GeodataZipAggregate: ResolverTypeWrapper<GeodataZipAggregate>;
  GeodataZipAggregateFields: ResolverTypeWrapper<GeodataZipAggregateFields>;
  GeodataZipBoolExp: GeodataZipBoolExp;
  GeodataZipConstraint: GeodataZipConstraint;
  GeodataZipInsertInput: GeodataZipInsertInput;
  GeodataZipMaxFields: ResolverTypeWrapper<GeodataZipMaxFields>;
  GeodataZipMinFields: ResolverTypeWrapper<GeodataZipMinFields>;
  GeodataZipMutationResponse: ResolverTypeWrapper<GeodataZipMutationResponse>;
  GeodataZipOnConflict: GeodataZipOnConflict;
  GeodataZipOrderBy: GeodataZipOrderBy;
  GeodataZipPkColumnsInput: GeodataZipPkColumnsInput;
  GeodataZipSelectColumn: GeodataZipSelectColumn;
  GeodataZipSetInput: GeodataZipSetInput;
  GeodataZipStreamCursorInput: GeodataZipStreamCursorInput;
  GeodataZipStreamCursorValueInput: GeodataZipStreamCursorValueInput;
  GeodataZipUpdateColumn: GeodataZipUpdateColumn;
  GeodataZipUpdates: GeodataZipUpdates;
  GeodataaddressAggregateBoolExpCount: GeodataaddressAggregateBoolExpCount;
  Geodatabigint: ResolverTypeWrapper<Scalars['Geodatabigint']['output']>;
  Geodatageography: ResolverTypeWrapper<Scalars['Geodatageography']['output']>;
  Geodatageometry: ResolverTypeWrapper<Scalars['Geodatageometry']['output']>;
  Geodatast_d_within_geography_input: Geodatast_d_within_geography_input;
  Geodatast_d_within_input: Geodatast_d_within_input;
  Geodatatimestamptz: ResolverTypeWrapper<Scalars['Geodatatimestamptz']['output']>;
  Geodatauuid: ResolverTypeWrapper<Scalars['Geodatauuid']['output']>;
  IncomingSMSOutput: ResolverTypeWrapper<IncomingSMSOutput>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  IntComparisonExp: IntComparisonExp;
  JsonbCastExp: JsonbCastExp;
  JsonbComparisonExp: JsonbComparisonExp;
  LinkCustomParameters: LinkCustomParameters;
  LinkGateCustomParameters: LinkGateCustomParameters;
  LinkMobilitySMSContent: LinkMobilitySMSContent;
  LinkMobilitySMSCustomParameters: LinkMobilitySMSCustomParameters;
  LinkMobilitySMSOutput: ResolverTypeWrapper<LinkMobilitySMSOutput>;
  LinkMobilitySMSRoute: LinkMobilitySMSRoute;
  LookupPhoneNumberOutput: ResolverTypeWrapper<LookupPhoneNumberOutput>;
  MessageTypeEnumComparisonExp: MessageTypeEnumComparisonExp;
  MessagingActivitySettings: ResolverTypeWrapper<MessagingActivitySettings>;
  MessagingActivitySettingsAggregate: ResolverTypeWrapper<MessagingActivitySettingsAggregate>;
  MessagingActivitySettingsAggregateFields: ResolverTypeWrapper<MessagingActivitySettingsAggregateFields>;
  MessagingActivitySettingsBoolExp: MessagingActivitySettingsBoolExp;
  MessagingActivitySettingsConstraint: MessagingActivitySettingsConstraint;
  MessagingActivitySettingsInsertInput: MessagingActivitySettingsInsertInput;
  MessagingActivitySettingsMaxFields: ResolverTypeWrapper<MessagingActivitySettingsMaxFields>;
  MessagingActivitySettingsMinFields: ResolverTypeWrapper<MessagingActivitySettingsMinFields>;
  MessagingActivitySettingsMutationResponse: ResolverTypeWrapper<MessagingActivitySettingsMutationResponse>;
  MessagingActivitySettingsNotificationSettingType: ResolverTypeWrapper<MessagingActivitySettingsNotificationSettingType>;
  MessagingActivitySettingsNotificationSettingTypeAggregate: ResolverTypeWrapper<MessagingActivitySettingsNotificationSettingTypeAggregate>;
  MessagingActivitySettingsNotificationSettingTypeAggregateFields: ResolverTypeWrapper<MessagingActivitySettingsNotificationSettingTypeAggregateFields>;
  MessagingActivitySettingsNotificationSettingTypeBoolExp: MessagingActivitySettingsNotificationSettingTypeBoolExp;
  MessagingActivitySettingsNotificationSettingTypeConstraint: MessagingActivitySettingsNotificationSettingTypeConstraint;
  MessagingActivitySettingsNotificationSettingTypeEnum: MessagingActivitySettingsNotificationSettingTypeEnum;
  MessagingActivitySettingsNotificationSettingTypeEnumComparisonExp: MessagingActivitySettingsNotificationSettingTypeEnumComparisonExp;
  MessagingActivitySettingsNotificationSettingTypeInsertInput: MessagingActivitySettingsNotificationSettingTypeInsertInput;
  MessagingActivitySettingsNotificationSettingTypeMaxFields: ResolverTypeWrapper<MessagingActivitySettingsNotificationSettingTypeMaxFields>;
  MessagingActivitySettingsNotificationSettingTypeMinFields: ResolverTypeWrapper<MessagingActivitySettingsNotificationSettingTypeMinFields>;
  MessagingActivitySettingsNotificationSettingTypeMutationResponse: ResolverTypeWrapper<MessagingActivitySettingsNotificationSettingTypeMutationResponse>;
  MessagingActivitySettingsNotificationSettingTypeOnConflict: MessagingActivitySettingsNotificationSettingTypeOnConflict;
  MessagingActivitySettingsNotificationSettingTypeOrderBy: MessagingActivitySettingsNotificationSettingTypeOrderBy;
  MessagingActivitySettingsNotificationSettingTypePkColumnsInput: MessagingActivitySettingsNotificationSettingTypePkColumnsInput;
  MessagingActivitySettingsNotificationSettingTypeSelectColumn: MessagingActivitySettingsNotificationSettingTypeSelectColumn;
  MessagingActivitySettingsNotificationSettingTypeSetInput: MessagingActivitySettingsNotificationSettingTypeSetInput;
  MessagingActivitySettingsNotificationSettingTypeStreamCursorInput: MessagingActivitySettingsNotificationSettingTypeStreamCursorInput;
  MessagingActivitySettingsNotificationSettingTypeStreamCursorValueInput: MessagingActivitySettingsNotificationSettingTypeStreamCursorValueInput;
  MessagingActivitySettingsNotificationSettingTypeUpdateColumn: MessagingActivitySettingsNotificationSettingTypeUpdateColumn;
  MessagingActivitySettingsNotificationSettingTypeUpdates: MessagingActivitySettingsNotificationSettingTypeUpdates;
  MessagingActivitySettingsObjRelInsertInput: MessagingActivitySettingsObjRelInsertInput;
  MessagingActivitySettingsOnConflict: MessagingActivitySettingsOnConflict;
  MessagingActivitySettingsOrderBy: MessagingActivitySettingsOrderBy;
  MessagingActivitySettingsPkColumnsInput: MessagingActivitySettingsPkColumnsInput;
  MessagingActivitySettingsSelectColumn: MessagingActivitySettingsSelectColumn;
  MessagingActivitySettingsSetInput: MessagingActivitySettingsSetInput;
  MessagingActivitySettingsStreamCursorInput: MessagingActivitySettingsStreamCursorInput;
  MessagingActivitySettingsStreamCursorValueInput: MessagingActivitySettingsStreamCursorValueInput;
  MessagingActivitySettingsUpdateColumn: MessagingActivitySettingsUpdateColumn;
  MessagingActivitySettingsUpdates: MessagingActivitySettingsUpdates;
  MessagingActivityTypeEnumComparisonExp: MessagingActivityTypeEnumComparisonExp;
  MessagingInvitation: ResolverTypeWrapper<MessagingInvitation>;
  MessagingInvitationAggregate: ResolverTypeWrapper<MessagingInvitationAggregate>;
  MessagingInvitationAggregateBoolExp: MessagingInvitationAggregateBoolExp;
  MessagingInvitationAggregateFields: ResolverTypeWrapper<MessagingInvitationAggregateFields>;
  MessagingInvitationAggregateOrderBy: MessagingInvitationAggregateOrderBy;
  MessagingInvitationArrRelInsertInput: MessagingInvitationArrRelInsertInput;
  MessagingInvitationBoolExp: MessagingInvitationBoolExp;
  MessagingInvitationConstraint: MessagingInvitationConstraint;
  MessagingInvitationInsertInput: MessagingInvitationInsertInput;
  MessagingInvitationMaxFields: ResolverTypeWrapper<MessagingInvitationMaxFields>;
  MessagingInvitationMaxOrderBy: MessagingInvitationMaxOrderBy;
  MessagingInvitationMinFields: ResolverTypeWrapper<MessagingInvitationMinFields>;
  MessagingInvitationMinOrderBy: MessagingInvitationMinOrderBy;
  MessagingInvitationMutationResponse: ResolverTypeWrapper<MessagingInvitationMutationResponse>;
  MessagingInvitationOnConflict: MessagingInvitationOnConflict;
  MessagingInvitationOrderBy: MessagingInvitationOrderBy;
  MessagingInvitationPkColumnsInput: MessagingInvitationPkColumnsInput;
  MessagingInvitationSelectColumn: MessagingInvitationSelectColumn;
  MessagingInvitationSelectColumnMessagingInvitationAggregateBoolExpBool_andArgumentsColumns: MessagingInvitationSelectColumnMessagingInvitationAggregateBoolExpBool_andArgumentsColumns;
  MessagingInvitationSelectColumnMessagingInvitationAggregateBoolExpBool_orArgumentsColumns: MessagingInvitationSelectColumnMessagingInvitationAggregateBoolExpBool_orArgumentsColumns;
  MessagingInvitationSetInput: MessagingInvitationSetInput;
  MessagingInvitationStreamCursorInput: MessagingInvitationStreamCursorInput;
  MessagingInvitationStreamCursorValueInput: MessagingInvitationStreamCursorValueInput;
  MessagingInvitationUpdateColumn: MessagingInvitationUpdateColumn;
  MessagingInvitationUpdates: MessagingInvitationUpdates;
  MessagingMentions: ResolverTypeWrapper<MessagingMentions>;
  MessagingMentionsAggregate: ResolverTypeWrapper<MessagingMentionsAggregate>;
  MessagingMentionsAggregateBoolExp: MessagingMentionsAggregateBoolExp;
  MessagingMentionsAggregateFields: ResolverTypeWrapper<MessagingMentionsAggregateFields>;
  MessagingMentionsAggregateOrderBy: MessagingMentionsAggregateOrderBy;
  MessagingMentionsArrRelInsertInput: MessagingMentionsArrRelInsertInput;
  MessagingMentionsBoolExp: MessagingMentionsBoolExp;
  MessagingMentionsConstraint: MessagingMentionsConstraint;
  MessagingMentionsInsertInput: MessagingMentionsInsertInput;
  MessagingMentionsMaxFields: ResolverTypeWrapper<MessagingMentionsMaxFields>;
  MessagingMentionsMaxOrderBy: MessagingMentionsMaxOrderBy;
  MessagingMentionsMinFields: ResolverTypeWrapper<MessagingMentionsMinFields>;
  MessagingMentionsMinOrderBy: MessagingMentionsMinOrderBy;
  MessagingMentionsMutationResponse: ResolverTypeWrapper<MessagingMentionsMutationResponse>;
  MessagingMentionsOnConflict: MessagingMentionsOnConflict;
  MessagingMentionsOrderBy: MessagingMentionsOrderBy;
  MessagingMentionsPkColumnsInput: MessagingMentionsPkColumnsInput;
  MessagingMentionsSelectColumn: MessagingMentionsSelectColumn;
  MessagingMentionsSetInput: MessagingMentionsSetInput;
  MessagingMentionsStreamCursorInput: MessagingMentionsStreamCursorInput;
  MessagingMentionsStreamCursorValueInput: MessagingMentionsStreamCursorValueInput;
  MessagingMentionsUpdateColumn: MessagingMentionsUpdateColumn;
  MessagingMentionsUpdates: MessagingMentionsUpdates;
  MessagingMessageAttachment: ResolverTypeWrapper<MessagingMessageAttachment>;
  MessagingMessageAttachmentAggregate: ResolverTypeWrapper<MessagingMessageAttachmentAggregate>;
  MessagingMessageAttachmentAggregateBoolExp: MessagingMessageAttachmentAggregateBoolExp;
  MessagingMessageAttachmentAggregateFields: ResolverTypeWrapper<MessagingMessageAttachmentAggregateFields>;
  MessagingMessageAttachmentAggregateOrderBy: MessagingMessageAttachmentAggregateOrderBy;
  MessagingMessageAttachmentArrRelInsertInput: MessagingMessageAttachmentArrRelInsertInput;
  MessagingMessageAttachmentBoolExp: MessagingMessageAttachmentBoolExp;
  MessagingMessageAttachmentConstraint: MessagingMessageAttachmentConstraint;
  MessagingMessageAttachmentInsertInput: MessagingMessageAttachmentInsertInput;
  MessagingMessageAttachmentMaxFields: ResolverTypeWrapper<MessagingMessageAttachmentMaxFields>;
  MessagingMessageAttachmentMaxOrderBy: MessagingMessageAttachmentMaxOrderBy;
  MessagingMessageAttachmentMinFields: ResolverTypeWrapper<MessagingMessageAttachmentMinFields>;
  MessagingMessageAttachmentMinOrderBy: MessagingMessageAttachmentMinOrderBy;
  MessagingMessageAttachmentMutationResponse: ResolverTypeWrapper<MessagingMessageAttachmentMutationResponse>;
  MessagingMessageAttachmentOnConflict: MessagingMessageAttachmentOnConflict;
  MessagingMessageAttachmentOrderBy: MessagingMessageAttachmentOrderBy;
  MessagingMessageAttachmentPkColumnsInput: MessagingMessageAttachmentPkColumnsInput;
  MessagingMessageAttachmentSelectColumn: MessagingMessageAttachmentSelectColumn;
  MessagingMessageAttachmentSetInput: MessagingMessageAttachmentSetInput;
  MessagingMessageAttachmentStreamCursorInput: MessagingMessageAttachmentStreamCursorInput;
  MessagingMessageAttachmentStreamCursorValueInput: MessagingMessageAttachmentStreamCursorValueInput;
  MessagingMessageAttachmentType: ResolverTypeWrapper<MessagingMessageAttachmentType>;
  MessagingMessageAttachmentTypeAggregate: ResolverTypeWrapper<MessagingMessageAttachmentTypeAggregate>;
  MessagingMessageAttachmentTypeAggregateFields: ResolverTypeWrapper<MessagingMessageAttachmentTypeAggregateFields>;
  MessagingMessageAttachmentTypeBoolExp: MessagingMessageAttachmentTypeBoolExp;
  MessagingMessageAttachmentTypeConstraint: MessagingMessageAttachmentTypeConstraint;
  MessagingMessageAttachmentTypeEnum: MessagingMessageAttachmentTypeEnum;
  MessagingMessageAttachmentTypeEnumComparisonExp: MessagingMessageAttachmentTypeEnumComparisonExp;
  MessagingMessageAttachmentTypeInsertInput: MessagingMessageAttachmentTypeInsertInput;
  MessagingMessageAttachmentTypeMaxFields: ResolverTypeWrapper<MessagingMessageAttachmentTypeMaxFields>;
  MessagingMessageAttachmentTypeMinFields: ResolverTypeWrapper<MessagingMessageAttachmentTypeMinFields>;
  MessagingMessageAttachmentTypeMutationResponse: ResolverTypeWrapper<MessagingMessageAttachmentTypeMutationResponse>;
  MessagingMessageAttachmentTypeOnConflict: MessagingMessageAttachmentTypeOnConflict;
  MessagingMessageAttachmentTypeOrderBy: MessagingMessageAttachmentTypeOrderBy;
  MessagingMessageAttachmentTypePkColumnsInput: MessagingMessageAttachmentTypePkColumnsInput;
  MessagingMessageAttachmentTypeSelectColumn: MessagingMessageAttachmentTypeSelectColumn;
  MessagingMessageAttachmentTypeSetInput: MessagingMessageAttachmentTypeSetInput;
  MessagingMessageAttachmentTypeStreamCursorInput: MessagingMessageAttachmentTypeStreamCursorInput;
  MessagingMessageAttachmentTypeStreamCursorValueInput: MessagingMessageAttachmentTypeStreamCursorValueInput;
  MessagingMessageAttachmentTypeUpdateColumn: MessagingMessageAttachmentTypeUpdateColumn;
  MessagingMessageAttachmentTypeUpdates: MessagingMessageAttachmentTypeUpdates;
  MessagingMessageAttachmentUpdateColumn: MessagingMessageAttachmentUpdateColumn;
  MessagingMessageAttachmentUpdates: MessagingMessageAttachmentUpdates;
  MessagingMessagePriority: ResolverTypeWrapper<MessagingMessagePriority>;
  MessagingMessagePriorityAggregate: ResolverTypeWrapper<MessagingMessagePriorityAggregate>;
  MessagingMessagePriorityAggregateFields: ResolverTypeWrapper<MessagingMessagePriorityAggregateFields>;
  MessagingMessagePriorityBoolExp: MessagingMessagePriorityBoolExp;
  MessagingMessagePriorityConstraint: MessagingMessagePriorityConstraint;
  MessagingMessagePriorityEnum: MessagingMessagePriorityEnum;
  MessagingMessagePriorityEnumComparisonExp: MessagingMessagePriorityEnumComparisonExp;
  MessagingMessagePriorityInsertInput: MessagingMessagePriorityInsertInput;
  MessagingMessagePriorityMaxFields: ResolverTypeWrapper<MessagingMessagePriorityMaxFields>;
  MessagingMessagePriorityMinFields: ResolverTypeWrapper<MessagingMessagePriorityMinFields>;
  MessagingMessagePriorityMutationResponse: ResolverTypeWrapper<MessagingMessagePriorityMutationResponse>;
  MessagingMessagePriorityOnConflict: MessagingMessagePriorityOnConflict;
  MessagingMessagePriorityOrderBy: MessagingMessagePriorityOrderBy;
  MessagingMessagePriorityPkColumnsInput: MessagingMessagePriorityPkColumnsInput;
  MessagingMessagePrioritySelectColumn: MessagingMessagePrioritySelectColumn;
  MessagingMessagePrioritySetInput: MessagingMessagePrioritySetInput;
  MessagingMessagePriorityStreamCursorInput: MessagingMessagePriorityStreamCursorInput;
  MessagingMessagePriorityStreamCursorValueInput: MessagingMessagePriorityStreamCursorValueInput;
  MessagingMessagePriorityUpdateColumn: MessagingMessagePriorityUpdateColumn;
  MessagingMessagePriorityUpdates: MessagingMessagePriorityUpdates;
  MessagingMessageTypeEnumComparisonExp: MessagingMessageTypeEnumComparisonExp;
  NewActivity: NewActivity;
  NewActivityOutput: ResolverTypeWrapper<NewActivityOutput>;
  NotificationInput: NotificationInput;
  NotificationNotificationDeviceSent: ResolverTypeWrapper<NotificationNotificationDeviceSent>;
  NotificationNotificationDeviceSentAggregate: ResolverTypeWrapper<NotificationNotificationDeviceSentAggregate>;
  NotificationNotificationDeviceSentAggregateFields: ResolverTypeWrapper<NotificationNotificationDeviceSentAggregateFields>;
  NotificationNotificationDeviceSentBoolExp: NotificationNotificationDeviceSentBoolExp;
  NotificationNotificationDeviceSentConstraint: NotificationNotificationDeviceSentConstraint;
  NotificationNotificationDeviceSentInsertInput: NotificationNotificationDeviceSentInsertInput;
  NotificationNotificationDeviceSentMaxFields: ResolverTypeWrapper<NotificationNotificationDeviceSentMaxFields>;
  NotificationNotificationDeviceSentMinFields: ResolverTypeWrapper<NotificationNotificationDeviceSentMinFields>;
  NotificationNotificationDeviceSentMutationResponse: ResolverTypeWrapper<NotificationNotificationDeviceSentMutationResponse>;
  NotificationNotificationDeviceSentOnConflict: NotificationNotificationDeviceSentOnConflict;
  NotificationNotificationDeviceSentOrderBy: NotificationNotificationDeviceSentOrderBy;
  NotificationNotificationDeviceSentPkColumnsInput: NotificationNotificationDeviceSentPkColumnsInput;
  NotificationNotificationDeviceSentSelectColumn: NotificationNotificationDeviceSentSelectColumn;
  NotificationNotificationDeviceSentSetInput: NotificationNotificationDeviceSentSetInput;
  NotificationNotificationDeviceSentStreamCursorInput: NotificationNotificationDeviceSentStreamCursorInput;
  NotificationNotificationDeviceSentStreamCursorValueInput: NotificationNotificationDeviceSentStreamCursorValueInput;
  NotificationNotificationDeviceSentUpdateColumn: NotificationNotificationDeviceSentUpdateColumn;
  NotificationNotificationDeviceSentUpdates: NotificationNotificationDeviceSentUpdates;
  NotificationNotificationSettingActivityPrimaryEnum: ResolverTypeWrapper<NotificationNotificationSettingActivityPrimaryEnum>;
  NotificationNotificationSettingActivityPrimaryEnumAggregate: ResolverTypeWrapper<NotificationNotificationSettingActivityPrimaryEnumAggregate>;
  NotificationNotificationSettingActivityPrimaryEnumAggregateFields: ResolverTypeWrapper<NotificationNotificationSettingActivityPrimaryEnumAggregateFields>;
  NotificationNotificationSettingActivityPrimaryEnumBoolExp: NotificationNotificationSettingActivityPrimaryEnumBoolExp;
  NotificationNotificationSettingActivityPrimaryEnumConstraint: NotificationNotificationSettingActivityPrimaryEnumConstraint;
  NotificationNotificationSettingActivityPrimaryEnumEnum: NotificationNotificationSettingActivityPrimaryEnumEnum;
  NotificationNotificationSettingActivityPrimaryEnumEnumComparisonExp: NotificationNotificationSettingActivityPrimaryEnumEnumComparisonExp;
  NotificationNotificationSettingActivityPrimaryEnumInsertInput: NotificationNotificationSettingActivityPrimaryEnumInsertInput;
  NotificationNotificationSettingActivityPrimaryEnumMaxFields: ResolverTypeWrapper<NotificationNotificationSettingActivityPrimaryEnumMaxFields>;
  NotificationNotificationSettingActivityPrimaryEnumMinFields: ResolverTypeWrapper<NotificationNotificationSettingActivityPrimaryEnumMinFields>;
  NotificationNotificationSettingActivityPrimaryEnumMutationResponse: ResolverTypeWrapper<NotificationNotificationSettingActivityPrimaryEnumMutationResponse>;
  NotificationNotificationSettingActivityPrimaryEnumOnConflict: NotificationNotificationSettingActivityPrimaryEnumOnConflict;
  NotificationNotificationSettingActivityPrimaryEnumOrderBy: NotificationNotificationSettingActivityPrimaryEnumOrderBy;
  NotificationNotificationSettingActivityPrimaryEnumPkColumnsInput: NotificationNotificationSettingActivityPrimaryEnumPkColumnsInput;
  NotificationNotificationSettingActivityPrimaryEnumSelectColumn: NotificationNotificationSettingActivityPrimaryEnumSelectColumn;
  NotificationNotificationSettingActivityPrimaryEnumSetInput: NotificationNotificationSettingActivityPrimaryEnumSetInput;
  NotificationNotificationSettingActivityPrimaryEnumStreamCursorInput: NotificationNotificationSettingActivityPrimaryEnumStreamCursorInput;
  NotificationNotificationSettingActivityPrimaryEnumStreamCursorValueInput: NotificationNotificationSettingActivityPrimaryEnumStreamCursorValueInput;
  NotificationNotificationSettingActivityPrimaryEnumUpdateColumn: NotificationNotificationSettingActivityPrimaryEnumUpdateColumn;
  NotificationNotificationSettingActivityPrimaryEnumUpdates: NotificationNotificationSettingActivityPrimaryEnumUpdates;
  NotificationOutput: ResolverTypeWrapper<NotificationOutput>;
  NumericComparisonExp: NumericComparisonExp;
  OrderBy: OrderBy;
  OrderUpdateInput: OrderUpdateInput;
  OrderUpdateOutput: ResolverTypeWrapper<OrderUpdateOutput>;
  OrdersOrganizations: ResolverTypeWrapper<OrdersOrganizations>;
  OrdersOrganizationsAggregate: ResolverTypeWrapper<OrdersOrganizationsAggregate>;
  OrdersOrganizationsAggregateFields: ResolverTypeWrapper<OrdersOrganizationsAggregateFields>;
  OrdersOrganizationsAvgFields: ResolverTypeWrapper<OrdersOrganizationsAvgFields>;
  OrdersOrganizationsBoolExp: OrdersOrganizationsBoolExp;
  OrdersOrganizationsConstraint: OrdersOrganizationsConstraint;
  OrdersOrganizationsIncInput: OrdersOrganizationsIncInput;
  OrdersOrganizationsInsertInput: OrdersOrganizationsInsertInput;
  OrdersOrganizationsMaxFields: ResolverTypeWrapper<OrdersOrganizationsMaxFields>;
  OrdersOrganizationsMinFields: ResolverTypeWrapper<OrdersOrganizationsMinFields>;
  OrdersOrganizationsMutationResponse: ResolverTypeWrapper<OrdersOrganizationsMutationResponse>;
  OrdersOrganizationsOnConflict: OrdersOrganizationsOnConflict;
  OrdersOrganizationsOrderBy: OrdersOrganizationsOrderBy;
  OrdersOrganizationsPkColumnsInput: OrdersOrganizationsPkColumnsInput;
  OrdersOrganizationsSelectColumn: OrdersOrganizationsSelectColumn;
  OrdersOrganizationsSetInput: OrdersOrganizationsSetInput;
  OrdersOrganizationsStddevFields: ResolverTypeWrapper<OrdersOrganizationsStddevFields>;
  OrdersOrganizationsStddevPopFields: ResolverTypeWrapper<OrdersOrganizationsStddevPopFields>;
  OrdersOrganizationsStddevSampFields: ResolverTypeWrapper<OrdersOrganizationsStddevSampFields>;
  OrdersOrganizationsStreamCursorInput: OrdersOrganizationsStreamCursorInput;
  OrdersOrganizationsStreamCursorValueInput: OrdersOrganizationsStreamCursorValueInput;
  OrdersOrganizationsSumFields: ResolverTypeWrapper<OrdersOrganizationsSumFields>;
  OrdersOrganizationsUpdateColumn: OrdersOrganizationsUpdateColumn;
  OrdersOrganizationsUpdates: OrdersOrganizationsUpdates;
  OrdersOrganizationsVarPopFields: ResolverTypeWrapper<OrdersOrganizationsVarPopFields>;
  OrdersOrganizationsVarSampFields: ResolverTypeWrapper<OrdersOrganizationsVarSampFields>;
  OrdersOrganizationsVarianceFields: ResolverTypeWrapper<OrdersOrganizationsVarianceFields>;
  OrdersRequest: ResolverTypeWrapper<OrdersRequest>;
  OrdersRequestAggregate: ResolverTypeWrapper<OrdersRequestAggregate>;
  OrdersRequestAggregateFields: ResolverTypeWrapper<OrdersRequestAggregateFields>;
  OrdersRequestBoolExp: OrdersRequestBoolExp;
  OrdersRequestConstraint: OrdersRequestConstraint;
  OrdersRequestEnum: OrdersRequestEnum;
  OrdersRequestEnumComparisonExp: OrdersRequestEnumComparisonExp;
  OrdersRequestInsertInput: OrdersRequestInsertInput;
  OrdersRequestMaxFields: ResolverTypeWrapper<OrdersRequestMaxFields>;
  OrdersRequestMinFields: ResolverTypeWrapper<OrdersRequestMinFields>;
  OrdersRequestMutationResponse: ResolverTypeWrapper<OrdersRequestMutationResponse>;
  OrdersRequestOnConflict: OrdersRequestOnConflict;
  OrdersRequestOrderBy: OrdersRequestOrderBy;
  OrdersRequestPkColumnsInput: OrdersRequestPkColumnsInput;
  OrdersRequestSelectColumn: OrdersRequestSelectColumn;
  OrdersRequestSetInput: OrdersRequestSetInput;
  OrdersRequestStreamCursorInput: OrdersRequestStreamCursorInput;
  OrdersRequestStreamCursorValueInput: OrdersRequestStreamCursorValueInput;
  OrdersRequestUpdateColumn: OrdersRequestUpdateColumn;
  OrdersRequestUpdates: OrdersRequestUpdates;
  OrdersStatus: ResolverTypeWrapper<OrdersStatus>;
  OrdersStatusAggregate: ResolverTypeWrapper<OrdersStatusAggregate>;
  OrdersStatusAggregateFields: ResolverTypeWrapper<OrdersStatusAggregateFields>;
  OrdersStatusBoolExp: OrdersStatusBoolExp;
  OrdersStatusConstraint: OrdersStatusConstraint;
  OrdersStatusEnum: OrdersStatusEnum;
  OrdersStatusEnumComparisonExp: OrdersStatusEnumComparisonExp;
  OrdersStatusInsertInput: OrdersStatusInsertInput;
  OrdersStatusMaxFields: ResolverTypeWrapper<OrdersStatusMaxFields>;
  OrdersStatusMinFields: ResolverTypeWrapper<OrdersStatusMinFields>;
  OrdersStatusMutationResponse: ResolverTypeWrapper<OrdersStatusMutationResponse>;
  OrdersStatusOnConflict: OrdersStatusOnConflict;
  OrdersStatusOrderBy: OrdersStatusOrderBy;
  OrdersStatusPkColumnsInput: OrdersStatusPkColumnsInput;
  OrdersStatusSelectColumn: OrdersStatusSelectColumn;
  OrdersStatusSetInput: OrdersStatusSetInput;
  OrdersStatusStreamCursorInput: OrdersStatusStreamCursorInput;
  OrdersStatusStreamCursorValueInput: OrdersStatusStreamCursorValueInput;
  OrdersStatusUpdateColumn: OrdersStatusUpdateColumn;
  OrdersStatusUpdates: OrdersStatusUpdates;
  OrdersType: ResolverTypeWrapper<OrdersType>;
  OrdersTypeAggregate: ResolverTypeWrapper<OrdersTypeAggregate>;
  OrdersTypeAggregateFields: ResolverTypeWrapper<OrdersTypeAggregateFields>;
  OrdersTypeBoolExp: OrdersTypeBoolExp;
  OrdersTypeConstraint: OrdersTypeConstraint;
  OrdersTypeEnum: OrdersTypeEnum;
  OrdersTypeEnumComparisonExp: OrdersTypeEnumComparisonExp;
  OrdersTypeInsertInput: OrdersTypeInsertInput;
  OrdersTypeMaxFields: ResolverTypeWrapper<OrdersTypeMaxFields>;
  OrdersTypeMinFields: ResolverTypeWrapper<OrdersTypeMinFields>;
  OrdersTypeMutationResponse: ResolverTypeWrapper<OrdersTypeMutationResponse>;
  OrdersTypeOnConflict: OrdersTypeOnConflict;
  OrdersTypeOrderBy: OrdersTypeOrderBy;
  OrdersTypePkColumnsInput: OrdersTypePkColumnsInput;
  OrdersTypeSelectColumn: OrdersTypeSelectColumn;
  OrdersTypeSetInput: OrdersTypeSetInput;
  OrdersTypeStreamCursorInput: OrdersTypeStreamCursorInput;
  OrdersTypeStreamCursorValueInput: OrdersTypeStreamCursorValueInput;
  OrdersTypeUpdateColumn: OrdersTypeUpdateColumn;
  OrdersTypeUpdates: OrdersTypeUpdates;
  OrganizationOutput: ResolverTypeWrapper<OrganizationOutput>;
  OrganizationUserAttentionNote: ResolverTypeWrapper<OrganizationUserAttentionNote>;
  OrganizationUserAttentionNoteAggregate: ResolverTypeWrapper<OrganizationUserAttentionNoteAggregate>;
  OrganizationUserAttentionNoteAggregateFields: ResolverTypeWrapper<OrganizationUserAttentionNoteAggregateFields>;
  OrganizationUserAttentionNoteBoolExp: OrganizationUserAttentionNoteBoolExp;
  OrganizationUserAttentionNoteConstraint: OrganizationUserAttentionNoteConstraint;
  OrganizationUserAttentionNoteInsertInput: OrganizationUserAttentionNoteInsertInput;
  OrganizationUserAttentionNoteMaxFields: ResolverTypeWrapper<OrganizationUserAttentionNoteMaxFields>;
  OrganizationUserAttentionNoteMinFields: ResolverTypeWrapper<OrganizationUserAttentionNoteMinFields>;
  OrganizationUserAttentionNoteMutationResponse: ResolverTypeWrapper<OrganizationUserAttentionNoteMutationResponse>;
  OrganizationUserAttentionNoteOnConflict: OrganizationUserAttentionNoteOnConflict;
  OrganizationUserAttentionNoteOrderBy: OrganizationUserAttentionNoteOrderBy;
  OrganizationUserAttentionNotePkColumnsInput: OrganizationUserAttentionNotePkColumnsInput;
  OrganizationUserAttentionNoteSelectColumn: OrganizationUserAttentionNoteSelectColumn;
  OrganizationUserAttentionNoteSetInput: OrganizationUserAttentionNoteSetInput;
  OrganizationUserAttentionNoteStreamCursorInput: OrganizationUserAttentionNoteStreamCursorInput;
  OrganizationUserAttentionNoteStreamCursorValueInput: OrganizationUserAttentionNoteStreamCursorValueInput;
  OrganizationUserAttentionNoteUpdateColumn: OrganizationUserAttentionNoteUpdateColumn;
  OrganizationUserAttentionNoteUpdates: OrganizationUserAttentionNoteUpdates;
  OrganizationUserAuthorizationEnumComparisonExp: OrganizationUserAuthorizationEnumComparisonExp;
  OrganizationUserDetailTypeEnumComparisonExp: OrganizationUserDetailTypeEnumComparisonExp;
  OrganizationUserStatusEnumComparisonExp: OrganizationUserStatusEnumComparisonExp;
  OrganizationsOutput: ResolverTypeWrapper<OrganizationsOutput>;
  PhoneNumberVerificationStatusEnumComparisonExp: PhoneNumberVerificationStatusEnumComparisonExp;
  PhoneRequestInput: PhoneRequestInput;
  PhoneRequestOutput: ResolverTypeWrapper<PhoneRequestOutput>;
  Prompt: ResolverTypeWrapper<Prompt>;
  PromptAggregate: ResolverTypeWrapper<PromptAggregate>;
  PromptAggregateFields: ResolverTypeWrapper<PromptAggregateFields>;
  PromptBoolExp: PromptBoolExp;
  PromptConstraint: PromptConstraint;
  PromptInsertInput: PromptInsertInput;
  PromptMaxFields: ResolverTypeWrapper<PromptMaxFields>;
  PromptMinFields: ResolverTypeWrapper<PromptMinFields>;
  PromptMutationResponse: ResolverTypeWrapper<PromptMutationResponse>;
  PromptOnConflict: PromptOnConflict;
  PromptOrderBy: PromptOrderBy;
  PromptPkColumnsInput: PromptPkColumnsInput;
  PromptSelectColumn: PromptSelectColumn;
  PromptSetInput: PromptSetInput;
  PromptStreamCursorInput: PromptStreamCursorInput;
  PromptStreamCursorValueInput: PromptStreamCursorValueInput;
  PromptUpdateColumn: PromptUpdateColumn;
  PromptUpdates: PromptUpdates;
  ProviderType: ProviderType;
  ProviderTypeEmail: ProviderTypeEmail;
  QueueItemFlexibilityType: ResolverTypeWrapper<QueueItemFlexibilityType>;
  QueueItemFlexibilityTypeAggregate: ResolverTypeWrapper<QueueItemFlexibilityTypeAggregate>;
  QueueItemFlexibilityTypeAggregateFields: ResolverTypeWrapper<QueueItemFlexibilityTypeAggregateFields>;
  QueueItemFlexibilityTypeBoolExp: QueueItemFlexibilityTypeBoolExp;
  QueueItemFlexibilityTypeConstraint: QueueItemFlexibilityTypeConstraint;
  QueueItemFlexibilityTypeInsertInput: QueueItemFlexibilityTypeInsertInput;
  QueueItemFlexibilityTypeMaxFields: ResolverTypeWrapper<QueueItemFlexibilityTypeMaxFields>;
  QueueItemFlexibilityTypeMinFields: ResolverTypeWrapper<QueueItemFlexibilityTypeMinFields>;
  QueueItemFlexibilityTypeMutationResponse: ResolverTypeWrapper<QueueItemFlexibilityTypeMutationResponse>;
  QueueItemFlexibilityTypeObjRelInsertInput: QueueItemFlexibilityTypeObjRelInsertInput;
  QueueItemFlexibilityTypeOnConflict: QueueItemFlexibilityTypeOnConflict;
  QueueItemFlexibilityTypeOrderBy: QueueItemFlexibilityTypeOrderBy;
  QueueItemFlexibilityTypePkColumnsInput: QueueItemFlexibilityTypePkColumnsInput;
  QueueItemFlexibilityTypeSelectColumn: QueueItemFlexibilityTypeSelectColumn;
  QueueItemFlexibilityTypeSetInput: QueueItemFlexibilityTypeSetInput;
  QueueItemFlexibilityTypeStreamCursorInput: QueueItemFlexibilityTypeStreamCursorInput;
  QueueItemFlexibilityTypeStreamCursorValueInput: QueueItemFlexibilityTypeStreamCursorValueInput;
  QueueItemFlexibilityTypeUpdateColumn: QueueItemFlexibilityTypeUpdateColumn;
  QueueItemFlexibilityTypeUpdates: QueueItemFlexibilityTypeUpdates;
  QueueItemParticipantResponsibilityType: ResolverTypeWrapper<QueueItemParticipantResponsibilityType>;
  QueueItemParticipantResponsibilityTypeAggregate: ResolverTypeWrapper<QueueItemParticipantResponsibilityTypeAggregate>;
  QueueItemParticipantResponsibilityTypeAggregateFields: ResolverTypeWrapper<QueueItemParticipantResponsibilityTypeAggregateFields>;
  QueueItemParticipantResponsibilityTypeBoolExp: QueueItemParticipantResponsibilityTypeBoolExp;
  QueueItemParticipantResponsibilityTypeConstraint: QueueItemParticipantResponsibilityTypeConstraint;
  QueueItemParticipantResponsibilityTypeEnum: QueueItemParticipantResponsibilityTypeEnum;
  QueueItemParticipantResponsibilityTypeEnumComparisonExp: QueueItemParticipantResponsibilityTypeEnumComparisonExp;
  QueueItemParticipantResponsibilityTypeInsertInput: QueueItemParticipantResponsibilityTypeInsertInput;
  QueueItemParticipantResponsibilityTypeMaxFields: ResolverTypeWrapper<QueueItemParticipantResponsibilityTypeMaxFields>;
  QueueItemParticipantResponsibilityTypeMinFields: ResolverTypeWrapper<QueueItemParticipantResponsibilityTypeMinFields>;
  QueueItemParticipantResponsibilityTypeMutationResponse: ResolverTypeWrapper<QueueItemParticipantResponsibilityTypeMutationResponse>;
  QueueItemParticipantResponsibilityTypeObjRelInsertInput: QueueItemParticipantResponsibilityTypeObjRelInsertInput;
  QueueItemParticipantResponsibilityTypeOnConflict: QueueItemParticipantResponsibilityTypeOnConflict;
  QueueItemParticipantResponsibilityTypeOrderBy: QueueItemParticipantResponsibilityTypeOrderBy;
  QueueItemParticipantResponsibilityTypePkColumnsInput: QueueItemParticipantResponsibilityTypePkColumnsInput;
  QueueItemParticipantResponsibilityTypeSelectColumn: QueueItemParticipantResponsibilityTypeSelectColumn;
  QueueItemParticipantResponsibilityTypeSetInput: QueueItemParticipantResponsibilityTypeSetInput;
  QueueItemParticipantResponsibilityTypeStreamCursorInput: QueueItemParticipantResponsibilityTypeStreamCursorInput;
  QueueItemParticipantResponsibilityTypeStreamCursorValueInput: QueueItemParticipantResponsibilityTypeStreamCursorValueInput;
  QueueItemParticipantResponsibilityTypeUpdateColumn: QueueItemParticipantResponsibilityTypeUpdateColumn;
  QueueItemParticipantResponsibilityTypeUpdates: QueueItemParticipantResponsibilityTypeUpdates;
  RegistryCode: ResolverTypeWrapper<RegistryCode>;
  RegistryCodeAggregate: ResolverTypeWrapper<RegistryCodeAggregate>;
  RegistryCodeAggregateFields: ResolverTypeWrapper<RegistryCodeAggregateFields>;
  RegistryCodeBoolExp: RegistryCodeBoolExp;
  RegistryCodeConstraint: RegistryCodeConstraint;
  RegistryCodeInsertInput: RegistryCodeInsertInput;
  RegistryCodeMaxFields: ResolverTypeWrapper<RegistryCodeMaxFields>;
  RegistryCodeMinFields: ResolverTypeWrapper<RegistryCodeMinFields>;
  RegistryCodeMutationResponse: ResolverTypeWrapper<RegistryCodeMutationResponse>;
  RegistryCodeObjRelInsertInput: RegistryCodeObjRelInsertInput;
  RegistryCodeOnConflict: RegistryCodeOnConflict;
  RegistryCodeOrderBy: RegistryCodeOrderBy;
  RegistryCodePkColumnsInput: RegistryCodePkColumnsInput;
  RegistryCodeSelectColumn: RegistryCodeSelectColumn;
  RegistryCodeSetInput: RegistryCodeSetInput;
  RegistryCodeStreamCursorInput: RegistryCodeStreamCursorInput;
  RegistryCodeStreamCursorValueInput: RegistryCodeStreamCursorValueInput;
  RegistryCodeUpdateColumn: RegistryCodeUpdateColumn;
  RegistryCodeUpdates: RegistryCodeUpdates;
  RegistryCursorOrdering: RegistryCursorOrdering;
  RegistryDateComparisonExp: RegistryDateComparisonExp;
  RegistryInfo: ResolverTypeWrapper<RegistryInfo>;
  RegistryInfoAggregate: ResolverTypeWrapper<RegistryInfoAggregate>;
  RegistryInfoAggregateFields: ResolverTypeWrapper<RegistryInfoAggregateFields>;
  RegistryInfoBoolExp: RegistryInfoBoolExp;
  RegistryInfoConstraint: RegistryInfoConstraint;
  RegistryInfoInsertInput: RegistryInfoInsertInput;
  RegistryInfoMaxFields: ResolverTypeWrapper<RegistryInfoMaxFields>;
  RegistryInfoMinFields: ResolverTypeWrapper<RegistryInfoMinFields>;
  RegistryInfoMutationResponse: ResolverTypeWrapper<RegistryInfoMutationResponse>;
  RegistryInfoOnConflict: RegistryInfoOnConflict;
  RegistryInfoOrderBy: RegistryInfoOrderBy;
  RegistryInfoPkColumnsInput: RegistryInfoPkColumnsInput;
  RegistryInfoSelectColumn: RegistryInfoSelectColumn;
  RegistryInfoSetInput: RegistryInfoSetInput;
  RegistryInfoStreamCursorInput: RegistryInfoStreamCursorInput;
  RegistryInfoStreamCursorValueInput: RegistryInfoStreamCursorValueInput;
  RegistryInfoUpdateColumn: RegistryInfoUpdateColumn;
  RegistryInfoUpdates: RegistryInfoUpdates;
  RegistryOrderBy: RegistryOrderBy;
  RegistryOrganisasjonsform: ResolverTypeWrapper<RegistryOrganisasjonsform>;
  RegistryOrganisasjonsformAggregate: ResolverTypeWrapper<RegistryOrganisasjonsformAggregate>;
  RegistryOrganisasjonsformAggregateFields: ResolverTypeWrapper<RegistryOrganisasjonsformAggregateFields>;
  RegistryOrganisasjonsformAppendInput: RegistryOrganisasjonsformAppendInput;
  RegistryOrganisasjonsformBoolExp: RegistryOrganisasjonsformBoolExp;
  RegistryOrganisasjonsformConstraint: RegistryOrganisasjonsformConstraint;
  RegistryOrganisasjonsformDeleteAtPathInput: RegistryOrganisasjonsformDeleteAtPathInput;
  RegistryOrganisasjonsformDeleteElemInput: RegistryOrganisasjonsformDeleteElemInput;
  RegistryOrganisasjonsformDeleteKeyInput: RegistryOrganisasjonsformDeleteKeyInput;
  RegistryOrganisasjonsformInsertInput: RegistryOrganisasjonsformInsertInput;
  RegistryOrganisasjonsformMaxFields: ResolverTypeWrapper<RegistryOrganisasjonsformMaxFields>;
  RegistryOrganisasjonsformMinFields: ResolverTypeWrapper<RegistryOrganisasjonsformMinFields>;
  RegistryOrganisasjonsformMutationResponse: ResolverTypeWrapper<RegistryOrganisasjonsformMutationResponse>;
  RegistryOrganisasjonsformObjRelInsertInput: RegistryOrganisasjonsformObjRelInsertInput;
  RegistryOrganisasjonsformOnConflict: RegistryOrganisasjonsformOnConflict;
  RegistryOrganisasjonsformOrderBy: RegistryOrganisasjonsformOrderBy;
  RegistryOrganisasjonsformPkColumnsInput: RegistryOrganisasjonsformPkColumnsInput;
  RegistryOrganisasjonsformPrependInput: RegistryOrganisasjonsformPrependInput;
  RegistryOrganisasjonsformSelectColumn: RegistryOrganisasjonsformSelectColumn;
  RegistryOrganisasjonsformSetInput: RegistryOrganisasjonsformSetInput;
  RegistryOrganisasjonsformStreamCursorInput: RegistryOrganisasjonsformStreamCursorInput;
  RegistryOrganisasjonsformStreamCursorValueInput: RegistryOrganisasjonsformStreamCursorValueInput;
  RegistryOrganisasjonsformUpdateColumn: RegistryOrganisasjonsformUpdateColumn;
  RegistryOrganisasjonsformUpdates: RegistryOrganisasjonsformUpdates;
  RegistryOrganization: ResolverTypeWrapper<RegistryOrganization>;
  RegistryOrganizationAggregate: ResolverTypeWrapper<RegistryOrganizationAggregate>;
  RegistryOrganizationAggregateFields: ResolverTypeWrapper<RegistryOrganizationAggregateFields>;
  RegistryOrganizationAppendInput: RegistryOrganizationAppendInput;
  RegistryOrganizationAvgFields: ResolverTypeWrapper<RegistryOrganizationAvgFields>;
  RegistryOrganizationBoolExp: RegistryOrganizationBoolExp;
  RegistryOrganizationConstraint: RegistryOrganizationConstraint;
  RegistryOrganizationDeleteAtPathInput: RegistryOrganizationDeleteAtPathInput;
  RegistryOrganizationDeleteElemInput: RegistryOrganizationDeleteElemInput;
  RegistryOrganizationDeleteKeyInput: RegistryOrganizationDeleteKeyInput;
  RegistryOrganizationIncInput: RegistryOrganizationIncInput;
  RegistryOrganizationInsertInput: RegistryOrganizationInsertInput;
  RegistryOrganizationMaxFields: ResolverTypeWrapper<RegistryOrganizationMaxFields>;
  RegistryOrganizationMinFields: ResolverTypeWrapper<RegistryOrganizationMinFields>;
  RegistryOrganizationMutationResponse: ResolverTypeWrapper<RegistryOrganizationMutationResponse>;
  RegistryOrganizationOnConflict: RegistryOrganizationOnConflict;
  RegistryOrganizationOrderBy: RegistryOrganizationOrderBy;
  RegistryOrganizationPkColumnsInput: RegistryOrganizationPkColumnsInput;
  RegistryOrganizationPrependInput: RegistryOrganizationPrependInput;
  RegistryOrganizationSelectColumn: RegistryOrganizationSelectColumn;
  RegistryOrganizationSetInput: RegistryOrganizationSetInput;
  RegistryOrganizationStddevFields: ResolverTypeWrapper<RegistryOrganizationStddevFields>;
  RegistryOrganizationStddevPopFields: ResolverTypeWrapper<RegistryOrganizationStddevPopFields>;
  RegistryOrganizationStddevSampFields: ResolverTypeWrapper<RegistryOrganizationStddevSampFields>;
  RegistryOrganizationStreamCursorInput: RegistryOrganizationStreamCursorInput;
  RegistryOrganizationStreamCursorValueInput: RegistryOrganizationStreamCursorValueInput;
  RegistryOrganizationSumFields: ResolverTypeWrapper<RegistryOrganizationSumFields>;
  RegistryOrganizationUpdateColumn: RegistryOrganizationUpdateColumn;
  RegistryOrganizationUpdates: RegistryOrganizationUpdates;
  RegistryOrganizationVarPopFields: ResolverTypeWrapper<RegistryOrganizationVarPopFields>;
  RegistryOrganizationVarSampFields: ResolverTypeWrapper<RegistryOrganizationVarSampFields>;
  RegistryOrganizationVarianceFields: ResolverTypeWrapper<RegistryOrganizationVarianceFields>;
  RegistryPostadresse: ResolverTypeWrapper<RegistryPostadresse>;
  RegistryPostadresseAggregate: ResolverTypeWrapper<RegistryPostadresseAggregate>;
  RegistryPostadresseAggregateFields: ResolverTypeWrapper<RegistryPostadresseAggregateFields>;
  RegistryPostadresseAppendInput: RegistryPostadresseAppendInput;
  RegistryPostadresseBoolExp: RegistryPostadresseBoolExp;
  RegistryPostadresseConstraint: RegistryPostadresseConstraint;
  RegistryPostadresseDeleteAtPathInput: RegistryPostadresseDeleteAtPathInput;
  RegistryPostadresseDeleteElemInput: RegistryPostadresseDeleteElemInput;
  RegistryPostadresseDeleteKeyInput: RegistryPostadresseDeleteKeyInput;
  RegistryPostadresseInsertInput: RegistryPostadresseInsertInput;
  RegistryPostadresseMaxFields: ResolverTypeWrapper<RegistryPostadresseMaxFields>;
  RegistryPostadresseMinFields: ResolverTypeWrapper<RegistryPostadresseMinFields>;
  RegistryPostadresseMutationResponse: ResolverTypeWrapper<RegistryPostadresseMutationResponse>;
  RegistryPostadresseObjRelInsertInput: RegistryPostadresseObjRelInsertInput;
  RegistryPostadresseOnConflict: RegistryPostadresseOnConflict;
  RegistryPostadresseOrderBy: RegistryPostadresseOrderBy;
  RegistryPostadressePkColumnsInput: RegistryPostadressePkColumnsInput;
  RegistryPostadressePrependInput: RegistryPostadressePrependInput;
  RegistryPostadresseSelectColumn: RegistryPostadresseSelectColumn;
  RegistryPostadresseSetInput: RegistryPostadresseSetInput;
  RegistryPostadresseStreamCursorInput: RegistryPostadresseStreamCursorInput;
  RegistryPostadresseStreamCursorValueInput: RegistryPostadresseStreamCursorValueInput;
  RegistryPostadresseUpdateColumn: RegistryPostadresseUpdateColumn;
  RegistryPostadresseUpdates: RegistryPostadresseUpdates;
  Registrydate: ResolverTypeWrapper<Scalars['Registrydate']['output']>;
  Registryjsonb: ResolverTypeWrapper<Scalars['Registryjsonb']['output']>;
  Registrynumeric: ResolverTypeWrapper<Scalars['Registrynumeric']['output']>;
  Registrytimestamptz: ResolverTypeWrapper<Scalars['Registrytimestamptz']['output']>;
  Registryuuid: ResolverTypeWrapper<Scalars['Registryuuid']['output']>;
  RelationType: ResolverTypeWrapper<RelationType>;
  RelationTypeAggregate: ResolverTypeWrapper<RelationTypeAggregate>;
  RelationTypeAggregateFields: ResolverTypeWrapper<RelationTypeAggregateFields>;
  RelationTypeBoolExp: RelationTypeBoolExp;
  RelationTypeConstraint: RelationTypeConstraint;
  RelationTypeEnum: RelationTypeEnum;
  RelationTypeEnumComparisonExp: RelationTypeEnumComparisonExp;
  RelationTypeInsertInput: RelationTypeInsertInput;
  RelationTypeMaxFields: ResolverTypeWrapper<RelationTypeMaxFields>;
  RelationTypeMinFields: ResolverTypeWrapper<RelationTypeMinFields>;
  RelationTypeMutationResponse: ResolverTypeWrapper<RelationTypeMutationResponse>;
  RelationTypeObjRelInsertInput: RelationTypeObjRelInsertInput;
  RelationTypeOnConflict: RelationTypeOnConflict;
  RelationTypeOrderBy: RelationTypeOrderBy;
  RelationTypePkColumnsInput: RelationTypePkColumnsInput;
  RelationTypeSelectColumn: RelationTypeSelectColumn;
  RelationTypeSetInput: RelationTypeSetInput;
  RelationTypeStreamCursorInput: RelationTypeStreamCursorInput;
  RelationTypeStreamCursorValueInput: RelationTypeStreamCursorValueInput;
  RelationTypeUpdateColumn: RelationTypeUpdateColumn;
  RelationTypeUpdates: RelationTypeUpdates;
  RemoveCustomerInput: RemoveCustomerInput;
  RemoveCustomerOutput: ResolverTypeWrapper<RemoveCustomerOutput>;
  RequestIntegrationsInput: RequestIntegrationsInput;
  RequestIntegrationsOutput: ResolverTypeWrapper<RequestIntegrationsOutput>;
  Route: Route;
  SearchPhoneInput: SearchPhoneInput;
  SearchPhoneOutput: ResolverTypeWrapper<SearchPhoneOutput>;
  SendSMSOutput: ResolverTypeWrapper<SendSMSOutput>;
  SendSMSTokenOutput: ResolverTypeWrapper<SendSMSTokenOutput>;
  StatusOutput: ResolverTypeWrapper<StatusOutput>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  StringComparisonExp: StringComparisonExp;
  TaskActivity: ResolverTypeWrapper<TaskActivity>;
  TaskActivityAggregate: ResolverTypeWrapper<TaskActivityAggregate>;
  TaskActivityAggregateFields: ResolverTypeWrapper<TaskActivityAggregateFields>;
  TaskActivityAppendInput: TaskActivityAppendInput;
  TaskActivityBoolExp: TaskActivityBoolExp;
  TaskActivityConstraint: TaskActivityConstraint;
  TaskActivityDeleteAtPathInput: TaskActivityDeleteAtPathInput;
  TaskActivityDeleteElemInput: TaskActivityDeleteElemInput;
  TaskActivityDeleteKeyInput: TaskActivityDeleteKeyInput;
  TaskActivityInsertInput: TaskActivityInsertInput;
  TaskActivityMaxFields: ResolverTypeWrapper<TaskActivityMaxFields>;
  TaskActivityMinFields: ResolverTypeWrapper<TaskActivityMinFields>;
  TaskActivityMutationResponse: ResolverTypeWrapper<TaskActivityMutationResponse>;
  TaskActivityObjRelInsertInput: TaskActivityObjRelInsertInput;
  TaskActivityOnConflict: TaskActivityOnConflict;
  TaskActivityOrderBy: TaskActivityOrderBy;
  TaskActivityParticipant: ResolverTypeWrapper<TaskActivityParticipant>;
  TaskActivityParticipantAggregate: ResolverTypeWrapper<TaskActivityParticipantAggregate>;
  TaskActivityParticipantAggregateBoolExp: TaskActivityParticipantAggregateBoolExp;
  TaskActivityParticipantAggregateFields: ResolverTypeWrapper<TaskActivityParticipantAggregateFields>;
  TaskActivityParticipantAggregateOrderBy: TaskActivityParticipantAggregateOrderBy;
  TaskActivityParticipantArrRelInsertInput: TaskActivityParticipantArrRelInsertInput;
  TaskActivityParticipantBoolExp: TaskActivityParticipantBoolExp;
  TaskActivityParticipantConstraint: TaskActivityParticipantConstraint;
  TaskActivityParticipantInsertInput: TaskActivityParticipantInsertInput;
  TaskActivityParticipantMaxFields: ResolverTypeWrapper<TaskActivityParticipantMaxFields>;
  TaskActivityParticipantMaxOrderBy: TaskActivityParticipantMaxOrderBy;
  TaskActivityParticipantMinFields: ResolverTypeWrapper<TaskActivityParticipantMinFields>;
  TaskActivityParticipantMinOrderBy: TaskActivityParticipantMinOrderBy;
  TaskActivityParticipantMutationResponse: ResolverTypeWrapper<TaskActivityParticipantMutationResponse>;
  TaskActivityParticipantOnConflict: TaskActivityParticipantOnConflict;
  TaskActivityParticipantOrderBy: TaskActivityParticipantOrderBy;
  TaskActivityParticipantPkColumnsInput: TaskActivityParticipantPkColumnsInput;
  TaskActivityParticipantSelectColumn: TaskActivityParticipantSelectColumn;
  TaskActivityParticipantSetInput: TaskActivityParticipantSetInput;
  TaskActivityParticipantStreamCursorInput: TaskActivityParticipantStreamCursorInput;
  TaskActivityParticipantStreamCursorValueInput: TaskActivityParticipantStreamCursorValueInput;
  TaskActivityParticipantUpdateColumn: TaskActivityParticipantUpdateColumn;
  TaskActivityParticipantUpdates: TaskActivityParticipantUpdates;
  TaskActivityPkColumnsInput: TaskActivityPkColumnsInput;
  TaskActivityPrependInput: TaskActivityPrependInput;
  TaskActivitySelectColumn: TaskActivitySelectColumn;
  TaskActivitySetInput: TaskActivitySetInput;
  TaskActivityStreamCursorInput: TaskActivityStreamCursorInput;
  TaskActivityStreamCursorValueInput: TaskActivityStreamCursorValueInput;
  TaskActivityType: ResolverTypeWrapper<TaskActivityType>;
  TaskActivityTypeAggregate: ResolverTypeWrapper<TaskActivityTypeAggregate>;
  TaskActivityTypeAggregateFields: ResolverTypeWrapper<TaskActivityTypeAggregateFields>;
  TaskActivityTypeBoolExp: TaskActivityTypeBoolExp;
  TaskActivityTypeConstraint: TaskActivityTypeConstraint;
  TaskActivityTypeEnum: TaskActivityTypeEnum;
  TaskActivityTypeEnumComparisonExp: TaskActivityTypeEnumComparisonExp;
  TaskActivityTypeInsertInput: TaskActivityTypeInsertInput;
  TaskActivityTypeMaxFields: ResolverTypeWrapper<TaskActivityTypeMaxFields>;
  TaskActivityTypeMinFields: ResolverTypeWrapper<TaskActivityTypeMinFields>;
  TaskActivityTypeMutationResponse: ResolverTypeWrapper<TaskActivityTypeMutationResponse>;
  TaskActivityTypeObjRelInsertInput: TaskActivityTypeObjRelInsertInput;
  TaskActivityTypeOnConflict: TaskActivityTypeOnConflict;
  TaskActivityTypeOrderBy: TaskActivityTypeOrderBy;
  TaskActivityTypePkColumnsInput: TaskActivityTypePkColumnsInput;
  TaskActivityTypeSelectColumn: TaskActivityTypeSelectColumn;
  TaskActivityTypeSetInput: TaskActivityTypeSetInput;
  TaskActivityTypeStreamCursorInput: TaskActivityTypeStreamCursorInput;
  TaskActivityTypeStreamCursorValueInput: TaskActivityTypeStreamCursorValueInput;
  TaskActivityTypeUpdateColumn: TaskActivityTypeUpdateColumn;
  TaskActivityTypeUpdates: TaskActivityTypeUpdates;
  TaskActivityUpdateColumn: TaskActivityUpdateColumn;
  TaskActivityUpdates: TaskActivityUpdates;
  TaskCursorOrdering: TaskCursorOrdering;
  TaskDomainOrganization: ResolverTypeWrapper<TaskDomainOrganization>;
  TaskDomainOrganizationAggregate: ResolverTypeWrapper<TaskDomainOrganizationAggregate>;
  TaskDomainOrganizationAggregateFields: ResolverTypeWrapper<TaskDomainOrganizationAggregateFields>;
  TaskDomainOrganizationBoolExp: TaskDomainOrganizationBoolExp;
  TaskDomainOrganizationConstraint: TaskDomainOrganizationConstraint;
  TaskDomainOrganizationInsertInput: TaskDomainOrganizationInsertInput;
  TaskDomainOrganizationMaxFields: ResolverTypeWrapper<TaskDomainOrganizationMaxFields>;
  TaskDomainOrganizationMinFields: ResolverTypeWrapper<TaskDomainOrganizationMinFields>;
  TaskDomainOrganizationMutationResponse: ResolverTypeWrapper<TaskDomainOrganizationMutationResponse>;
  TaskDomainOrganizationObjRelInsertInput: TaskDomainOrganizationObjRelInsertInput;
  TaskDomainOrganizationOnConflict: TaskDomainOrganizationOnConflict;
  TaskDomainOrganizationOrderBy: TaskDomainOrganizationOrderBy;
  TaskDomainOrganizationPkColumnsInput: TaskDomainOrganizationPkColumnsInput;
  TaskDomainOrganizationSelectColumn: TaskDomainOrganizationSelectColumn;
  TaskDomainOrganizationSetInput: TaskDomainOrganizationSetInput;
  TaskDomainOrganizationStreamCursorInput: TaskDomainOrganizationStreamCursorInput;
  TaskDomainOrganizationStreamCursorValueInput: TaskDomainOrganizationStreamCursorValueInput;
  TaskDomainOrganizationUpdateColumn: TaskDomainOrganizationUpdateColumn;
  TaskDomainOrganizationUpdates: TaskDomainOrganizationUpdates;
  TaskDomainUser: ResolverTypeWrapper<TaskDomainUser>;
  TaskDomainUserAggregate: ResolverTypeWrapper<TaskDomainUserAggregate>;
  TaskDomainUserAggregateBoolExp: TaskDomainUserAggregateBoolExp;
  TaskDomainUserAggregateFields: ResolverTypeWrapper<TaskDomainUserAggregateFields>;
  TaskDomainUserAggregateOrderBy: TaskDomainUserAggregateOrderBy;
  TaskDomainUserArrRelInsertInput: TaskDomainUserArrRelInsertInput;
  TaskDomainUserBoolExp: TaskDomainUserBoolExp;
  TaskDomainUserCategory: ResolverTypeWrapper<TaskDomainUserCategory>;
  TaskDomainUserCategoryAggregate: ResolverTypeWrapper<TaskDomainUserCategoryAggregate>;
  TaskDomainUserCategoryAggregateFields: ResolverTypeWrapper<TaskDomainUserCategoryAggregateFields>;
  TaskDomainUserCategoryBoolExp: TaskDomainUserCategoryBoolExp;
  TaskDomainUserCategoryConstraint: TaskDomainUserCategoryConstraint;
  TaskDomainUserCategoryEnum: TaskDomainUserCategoryEnum;
  TaskDomainUserCategoryEnumComparisonExp: TaskDomainUserCategoryEnumComparisonExp;
  TaskDomainUserCategoryInsertInput: TaskDomainUserCategoryInsertInput;
  TaskDomainUserCategoryMaxFields: ResolverTypeWrapper<TaskDomainUserCategoryMaxFields>;
  TaskDomainUserCategoryMinFields: ResolverTypeWrapper<TaskDomainUserCategoryMinFields>;
  TaskDomainUserCategoryMutationResponse: ResolverTypeWrapper<TaskDomainUserCategoryMutationResponse>;
  TaskDomainUserCategoryObjRelInsertInput: TaskDomainUserCategoryObjRelInsertInput;
  TaskDomainUserCategoryOnConflict: TaskDomainUserCategoryOnConflict;
  TaskDomainUserCategoryOrderBy: TaskDomainUserCategoryOrderBy;
  TaskDomainUserCategoryPkColumnsInput: TaskDomainUserCategoryPkColumnsInput;
  TaskDomainUserCategorySelectColumn: TaskDomainUserCategorySelectColumn;
  TaskDomainUserCategorySetInput: TaskDomainUserCategorySetInput;
  TaskDomainUserCategoryStreamCursorInput: TaskDomainUserCategoryStreamCursorInput;
  TaskDomainUserCategoryStreamCursorValueInput: TaskDomainUserCategoryStreamCursorValueInput;
  TaskDomainUserCategoryUpdateColumn: TaskDomainUserCategoryUpdateColumn;
  TaskDomainUserCategoryUpdates: TaskDomainUserCategoryUpdates;
  TaskDomainUserConstraint: TaskDomainUserConstraint;
  TaskDomainUserInsertInput: TaskDomainUserInsertInput;
  TaskDomainUserMaxFields: ResolverTypeWrapper<TaskDomainUserMaxFields>;
  TaskDomainUserMaxOrderBy: TaskDomainUserMaxOrderBy;
  TaskDomainUserMinFields: ResolverTypeWrapper<TaskDomainUserMinFields>;
  TaskDomainUserMinOrderBy: TaskDomainUserMinOrderBy;
  TaskDomainUserMutationResponse: ResolverTypeWrapper<TaskDomainUserMutationResponse>;
  TaskDomainUserObjRelInsertInput: TaskDomainUserObjRelInsertInput;
  TaskDomainUserOnConflict: TaskDomainUserOnConflict;
  TaskDomainUserOrderBy: TaskDomainUserOrderBy;
  TaskDomainUserPkColumnsInput: TaskDomainUserPkColumnsInput;
  TaskDomainUserSelectColumn: TaskDomainUserSelectColumn;
  TaskDomainUserSetInput: TaskDomainUserSetInput;
  TaskDomainUserStreamCursorInput: TaskDomainUserStreamCursorInput;
  TaskDomainUserStreamCursorValueInput: TaskDomainUserStreamCursorValueInput;
  TaskDomainUserUpdateColumn: TaskDomainUserUpdateColumn;
  TaskDomainUserUpdates: TaskDomainUserUpdates;
  TaskIntComparisonExp: TaskIntComparisonExp;
  TaskJsonbCastExp: TaskJsonbCastExp;
  TaskJsonbComparisonExp: TaskJsonbComparisonExp;
  TaskOrderBy: TaskOrderBy;
  TaskStringComparisonExp: TaskStringComparisonExp;
  TaskTimestamptzComparisonExp: TaskTimestamptzComparisonExp;
  TaskUuidComparisonExp: TaskUuidComparisonExp;
  TaskactivityParticipantAggregateBoolExpCount: TaskactivityParticipantAggregateBoolExpCount;
  TaskdomainUserAggregateBoolExpCount: TaskdomainUserAggregateBoolExpCount;
  Taskjson: ResolverTypeWrapper<Scalars['Taskjson']['output']>;
  Taskjsonb: ResolverTypeWrapper<Scalars['Taskjsonb']['output']>;
  TasktaskActivityInput: TasktaskActivityInput;
  TasktaskActivityOutput: ResolverTypeWrapper<TasktaskActivityOutput>;
  Tasktimestamptz: ResolverTypeWrapper<Scalars['Tasktimestamptz']['output']>;
  TelephonyActivityParticipantRole: ResolverTypeWrapper<TelephonyActivityParticipantRole>;
  TelephonyActivityParticipantRoleAggregate: ResolverTypeWrapper<TelephonyActivityParticipantRoleAggregate>;
  TelephonyActivityParticipantRoleAggregateFields: ResolverTypeWrapper<TelephonyActivityParticipantRoleAggregateFields>;
  TelephonyActivityParticipantRoleBoolExp: TelephonyActivityParticipantRoleBoolExp;
  TelephonyActivityParticipantRoleConstraint: TelephonyActivityParticipantRoleConstraint;
  TelephonyActivityParticipantRoleEnum: TelephonyActivityParticipantRoleEnum;
  TelephonyActivityParticipantRoleEnumComparisonExp: TelephonyActivityParticipantRoleEnumComparisonExp;
  TelephonyActivityParticipantRoleInsertInput: TelephonyActivityParticipantRoleInsertInput;
  TelephonyActivityParticipantRoleMaxFields: ResolverTypeWrapper<TelephonyActivityParticipantRoleMaxFields>;
  TelephonyActivityParticipantRoleMinFields: ResolverTypeWrapper<TelephonyActivityParticipantRoleMinFields>;
  TelephonyActivityParticipantRoleMutationResponse: ResolverTypeWrapper<TelephonyActivityParticipantRoleMutationResponse>;
  TelephonyActivityParticipantRoleOnConflict: TelephonyActivityParticipantRoleOnConflict;
  TelephonyActivityParticipantRoleOrderBy: TelephonyActivityParticipantRoleOrderBy;
  TelephonyActivityParticipantRolePkColumnsInput: TelephonyActivityParticipantRolePkColumnsInput;
  TelephonyActivityParticipantRoleSelectColumn: TelephonyActivityParticipantRoleSelectColumn;
  TelephonyActivityParticipantRoleSetInput: TelephonyActivityParticipantRoleSetInput;
  TelephonyActivityParticipantRoleStreamCursorInput: TelephonyActivityParticipantRoleStreamCursorInput;
  TelephonyActivityParticipantRoleStreamCursorValueInput: TelephonyActivityParticipantRoleStreamCursorValueInput;
  TelephonyActivityParticipantRoleUpdateColumn: TelephonyActivityParticipantRoleUpdateColumn;
  TelephonyActivityParticipantRoleUpdates: TelephonyActivityParticipantRoleUpdates;
  TelephonyActivityType: ResolverTypeWrapper<TelephonyActivityType>;
  TelephonyActivityTypeAggregate: ResolverTypeWrapper<TelephonyActivityTypeAggregate>;
  TelephonyActivityTypeAggregateFields: ResolverTypeWrapper<TelephonyActivityTypeAggregateFields>;
  TelephonyActivityTypeBoolExp: TelephonyActivityTypeBoolExp;
  TelephonyActivityTypeConstraint: TelephonyActivityTypeConstraint;
  TelephonyActivityTypeEnum: TelephonyActivityTypeEnum;
  TelephonyActivityTypeInsertInput: TelephonyActivityTypeInsertInput;
  TelephonyActivityTypeMutationResponse: ResolverTypeWrapper<TelephonyActivityTypeMutationResponse>;
  TelephonyActivityTypeObjRelInsertInput: TelephonyActivityTypeObjRelInsertInput;
  TelephonyActivityTypeOnConflict: TelephonyActivityTypeOnConflict;
  TelephonyActivityTypeOrderBy: TelephonyActivityTypeOrderBy;
  TelephonyActivityTypePkColumnsInput: TelephonyActivityTypePkColumnsInput;
  TelephonyActivityTypeSelectColumn: TelephonyActivityTypeSelectColumn;
  TelephonyActivityTypeSetInput: TelephonyActivityTypeSetInput;
  TelephonyActivityTypeStreamCursorInput: TelephonyActivityTypeStreamCursorInput;
  TelephonyActivityTypeUpdateColumn: TelephonyActivityTypeUpdateColumn;
  TelephonyBooleanComparisonExp: TelephonyBooleanComparisonExp;
  TelephonyCallDirection: ResolverTypeWrapper<TelephonyCallDirection>;
  TelephonyCallDirectionAggregate: ResolverTypeWrapper<TelephonyCallDirectionAggregate>;
  TelephonyCallDirectionAggregateFields: ResolverTypeWrapper<TelephonyCallDirectionAggregateFields>;
  TelephonyCallDirectionBoolExp: TelephonyCallDirectionBoolExp;
  TelephonyCallDirectionConstraint: TelephonyCallDirectionConstraint;
  TelephonyCallDirectionEnum: TelephonyCallDirectionEnum;
  TelephonyCallDirectionEnumComparisonExp: TelephonyCallDirectionEnumComparisonExp;
  TelephonyCallDirectionInsertInput: TelephonyCallDirectionInsertInput;
  TelephonyCallDirectionMaxFields: ResolverTypeWrapper<TelephonyCallDirectionMaxFields>;
  TelephonyCallDirectionMinFields: ResolverTypeWrapper<TelephonyCallDirectionMinFields>;
  TelephonyCallDirectionMutationResponse: ResolverTypeWrapper<TelephonyCallDirectionMutationResponse>;
  TelephonyCallDirectionObjRelInsertInput: TelephonyCallDirectionObjRelInsertInput;
  TelephonyCallDirectionOnConflict: TelephonyCallDirectionOnConflict;
  TelephonyCallDirectionOrderBy: TelephonyCallDirectionOrderBy;
  TelephonyCallDirectionPkColumnsInput: TelephonyCallDirectionPkColumnsInput;
  TelephonyCallDirectionSelectColumn: TelephonyCallDirectionSelectColumn;
  TelephonyCallDirectionSetInput: TelephonyCallDirectionSetInput;
  TelephonyCallDirectionStreamCursorInput: TelephonyCallDirectionStreamCursorInput;
  TelephonyCallDirectionStreamCursorValueInput: TelephonyCallDirectionStreamCursorValueInput;
  TelephonyCallDirectionUpdateColumn: TelephonyCallDirectionUpdateColumn;
  TelephonyCallDirectionUpdates: TelephonyCallDirectionUpdates;
  TelephonyCallResultInput: TelephonyCallResultInput;
  TelephonyCallResultOutput: ResolverTypeWrapper<TelephonyCallResultOutput>;
  TelephonyCallResultType: TelephonyCallResultType;
  TelephonyClickToCallInput: TelephonyClickToCallInput;
  TelephonyClickToCallOutput: ResolverTypeWrapper<TelephonyClickToCallOutput>;
  TelephonyCredentialsOutput: ResolverTypeWrapper<TelephonyCredentialsOutput>;
  TelephonyCredentialsValidation: TelephonyCredentialsValidation;
  TelephonyCursorOrdering: TelephonyCursorOrdering;
  TelephonyDomainUserCategory: ResolverTypeWrapper<TelephonyDomainUserCategory>;
  TelephonyDomainUserCategoryAggregate: ResolverTypeWrapper<TelephonyDomainUserCategoryAggregate>;
  TelephonyDomainUserCategoryAggregateFields: ResolverTypeWrapper<TelephonyDomainUserCategoryAggregateFields>;
  TelephonyDomainUserCategoryBoolExp: TelephonyDomainUserCategoryBoolExp;
  TelephonyDomainUserCategoryConstraint: TelephonyDomainUserCategoryConstraint;
  TelephonyDomainUserCategoryEnum: TelephonyDomainUserCategoryEnum;
  TelephonyDomainUserCategoryInsertInput: TelephonyDomainUserCategoryInsertInput;
  TelephonyDomainUserCategoryMutationResponse: ResolverTypeWrapper<TelephonyDomainUserCategoryMutationResponse>;
  TelephonyDomainUserCategoryObjRelInsertInput: TelephonyDomainUserCategoryObjRelInsertInput;
  TelephonyDomainUserCategoryOnConflict: TelephonyDomainUserCategoryOnConflict;
  TelephonyDomainUserCategoryOrderBy: TelephonyDomainUserCategoryOrderBy;
  TelephonyDomainUserCategoryPkColumnsInput: TelephonyDomainUserCategoryPkColumnsInput;
  TelephonyDomainUserCategorySelectColumn: TelephonyDomainUserCategorySelectColumn;
  TelephonyDomainUserCategorySetInput: TelephonyDomainUserCategorySetInput;
  TelephonyDomainUserCategoryStreamCursorInput: TelephonyDomainUserCategoryStreamCursorInput;
  TelephonyDomainUserCategoryUpdateColumn: TelephonyDomainUserCategoryUpdateColumn;
  TelephonyDomainUserOutput: ResolverTypeWrapper<TelephonyDomainUserOutput>;
  TelephonyEntryCategory: TelephonyEntryCategory;
  TelephonyEntrySource: TelephonyEntrySource;
  TelephonyLookupPhoneNumberOutput: ResolverTypeWrapper<TelephonyLookupPhoneNumberOutput>;
  TelephonyNumberState: ResolverTypeWrapper<TelephonyNumberState>;
  TelephonyNumberStateAggregate: ResolverTypeWrapper<TelephonyNumberStateAggregate>;
  TelephonyNumberStateAggregateFields: ResolverTypeWrapper<TelephonyNumberStateAggregateFields>;
  TelephonyNumberStateBoolExp: TelephonyNumberStateBoolExp;
  TelephonyNumberStateConstraint: TelephonyNumberStateConstraint;
  TelephonyNumberStateEnum: TelephonyNumberStateEnum;
  TelephonyNumberStateEnumComparisonExp: TelephonyNumberStateEnumComparisonExp;
  TelephonyNumberStateInsertInput: TelephonyNumberStateInsertInput;
  TelephonyNumberStateMaxFields: ResolverTypeWrapper<TelephonyNumberStateMaxFields>;
  TelephonyNumberStateMinFields: ResolverTypeWrapper<TelephonyNumberStateMinFields>;
  TelephonyNumberStateMutationResponse: ResolverTypeWrapper<TelephonyNumberStateMutationResponse>;
  TelephonyNumberStateObjRelInsertInput: TelephonyNumberStateObjRelInsertInput;
  TelephonyNumberStateOnConflict: TelephonyNumberStateOnConflict;
  TelephonyNumberStateOrderBy: TelephonyNumberStateOrderBy;
  TelephonyNumberStatePkColumnsInput: TelephonyNumberStatePkColumnsInput;
  TelephonyNumberStateSelectColumn: TelephonyNumberStateSelectColumn;
  TelephonyNumberStateSetInput: TelephonyNumberStateSetInput;
  TelephonyNumberStateStreamCursorInput: TelephonyNumberStateStreamCursorInput;
  TelephonyNumberStateStreamCursorValueInput: TelephonyNumberStateStreamCursorValueInput;
  TelephonyNumberStateUpdateColumn: TelephonyNumberStateUpdateColumn;
  TelephonyNumberStateUpdates: TelephonyNumberStateUpdates;
  TelephonyOrderBy: TelephonyOrderBy;
  TelephonyPhoneRequestInput: TelephonyPhoneRequestInput;
  TelephonyPhoneRequestOutput: ResolverTypeWrapper<TelephonyPhoneRequestOutput>;
  TelephonyProviderIntegrationAccountInput: TelephonyProviderIntegrationAccountInput;
  TelephonyProviderIntegrationConfigurationInput: TelephonyProviderIntegrationConfigurationInput;
  TelephonyProviderIntegrationInput: TelephonyProviderIntegrationInput;
  TelephonyProviderType: ResolverTypeWrapper<TelephonyProviderType>;
  TelephonyProviderTypeAggregate: ResolverTypeWrapper<TelephonyProviderTypeAggregate>;
  TelephonyProviderTypeAggregateFields: ResolverTypeWrapper<TelephonyProviderTypeAggregateFields>;
  TelephonyProviderTypeBoolExp: TelephonyProviderTypeBoolExp;
  TelephonyProviderTypeConstraint: TelephonyProviderTypeConstraint;
  TelephonyProviderTypeEnum: TelephonyProviderTypeEnum;
  TelephonyProviderTypeEnumComparisonExp: TelephonyProviderTypeEnumComparisonExp;
  TelephonyProviderTypeInsertInput: TelephonyProviderTypeInsertInput;
  TelephonyProviderTypeMaxFields: ResolverTypeWrapper<TelephonyProviderTypeMaxFields>;
  TelephonyProviderTypeMinFields: ResolverTypeWrapper<TelephonyProviderTypeMinFields>;
  TelephonyProviderTypeMutationResponse: ResolverTypeWrapper<TelephonyProviderTypeMutationResponse>;
  TelephonyProviderTypeObjRelInsertInput: TelephonyProviderTypeObjRelInsertInput;
  TelephonyProviderTypeOnConflict: TelephonyProviderTypeOnConflict;
  TelephonyProviderTypeOrderBy: TelephonyProviderTypeOrderBy;
  TelephonyProviderTypePkColumnsInput: TelephonyProviderTypePkColumnsInput;
  TelephonyProviderTypeSelectColumn: TelephonyProviderTypeSelectColumn;
  TelephonyProviderTypeSetInput: TelephonyProviderTypeSetInput;
  TelephonyProviderTypeStreamCursorInput: TelephonyProviderTypeStreamCursorInput;
  TelephonyProviderTypeStreamCursorValueInput: TelephonyProviderTypeStreamCursorValueInput;
  TelephonyProviderTypeUpdateColumn: TelephonyProviderTypeUpdateColumn;
  TelephonyProviderTypeUpdates: TelephonyProviderTypeUpdates;
  TelephonySendSMSOutput: ResolverTypeWrapper<TelephonySendSMSOutput>;
  TelephonySynchronizeDomainUsersInput: TelephonySynchronizeDomainUsersInput;
  TelephonySynchronizeDomainUsersOutput: ResolverTypeWrapper<TelephonySynchronizeDomainUsersOutput>;
  TelephonyTelephonyActionEventType: ResolverTypeWrapper<TelephonyTelephonyActionEventType>;
  TelephonyTelephonyActionEventTypeAggregate: ResolverTypeWrapper<TelephonyTelephonyActionEventTypeAggregate>;
  TelephonyTelephonyActionEventTypeAggregateFields: ResolverTypeWrapper<TelephonyTelephonyActionEventTypeAggregateFields>;
  TelephonyTelephonyActionEventTypeBoolExp: TelephonyTelephonyActionEventTypeBoolExp;
  TelephonyTelephonyActionEventTypeConstraint: TelephonyTelephonyActionEventTypeConstraint;
  TelephonyTelephonyActionEventTypeEnum: TelephonyTelephonyActionEventTypeEnum;
  TelephonyTelephonyActionEventTypeEnumComparisonExp: TelephonyTelephonyActionEventTypeEnumComparisonExp;
  TelephonyTelephonyActionEventTypeInsertInput: TelephonyTelephonyActionEventTypeInsertInput;
  TelephonyTelephonyActionEventTypeMaxFields: ResolverTypeWrapper<TelephonyTelephonyActionEventTypeMaxFields>;
  TelephonyTelephonyActionEventTypeMinFields: ResolverTypeWrapper<TelephonyTelephonyActionEventTypeMinFields>;
  TelephonyTelephonyActionEventTypeMutationResponse: ResolverTypeWrapper<TelephonyTelephonyActionEventTypeMutationResponse>;
  TelephonyTelephonyActionEventTypeOnConflict: TelephonyTelephonyActionEventTypeOnConflict;
  TelephonyTelephonyActionEventTypeOrderBy: TelephonyTelephonyActionEventTypeOrderBy;
  TelephonyTelephonyActionEventTypePkColumnsInput: TelephonyTelephonyActionEventTypePkColumnsInput;
  TelephonyTelephonyActionEventTypeSelectColumn: TelephonyTelephonyActionEventTypeSelectColumn;
  TelephonyTelephonyActionEventTypeSetInput: TelephonyTelephonyActionEventTypeSetInput;
  TelephonyTelephonyActionEventTypeStreamCursorInput: TelephonyTelephonyActionEventTypeStreamCursorInput;
  TelephonyTelephonyActionEventTypeStreamCursorValueInput: TelephonyTelephonyActionEventTypeStreamCursorValueInput;
  TelephonyTelephonyActionEventTypeUpdateColumn: TelephonyTelephonyActionEventTypeUpdateColumn;
  TelephonyTelephonyActionEventTypeUpdates: TelephonyTelephonyActionEventTypeUpdates;
  TelephonyTelephonyActionType: ResolverTypeWrapper<TelephonyTelephonyActionType>;
  TelephonyTelephonyActionTypeAggregate: ResolverTypeWrapper<TelephonyTelephonyActionTypeAggregate>;
  TelephonyTelephonyActionTypeAggregateFields: ResolverTypeWrapper<TelephonyTelephonyActionTypeAggregateFields>;
  TelephonyTelephonyActionTypeBoolExp: TelephonyTelephonyActionTypeBoolExp;
  TelephonyTelephonyActionTypeConstraint: TelephonyTelephonyActionTypeConstraint;
  TelephonyTelephonyActionTypeEnum: TelephonyTelephonyActionTypeEnum;
  TelephonyTelephonyActionTypeEnumComparisonExp: TelephonyTelephonyActionTypeEnumComparisonExp;
  TelephonyTelephonyActionTypeInsertInput: TelephonyTelephonyActionTypeInsertInput;
  TelephonyTelephonyActionTypeMaxFields: ResolverTypeWrapper<TelephonyTelephonyActionTypeMaxFields>;
  TelephonyTelephonyActionTypeMinFields: ResolverTypeWrapper<TelephonyTelephonyActionTypeMinFields>;
  TelephonyTelephonyActionTypeMutationResponse: ResolverTypeWrapper<TelephonyTelephonyActionTypeMutationResponse>;
  TelephonyTelephonyActionTypeObjRelInsertInput: TelephonyTelephonyActionTypeObjRelInsertInput;
  TelephonyTelephonyActionTypeOnConflict: TelephonyTelephonyActionTypeOnConflict;
  TelephonyTelephonyActionTypeOrderBy: TelephonyTelephonyActionTypeOrderBy;
  TelephonyTelephonyActionTypePkColumnsInput: TelephonyTelephonyActionTypePkColumnsInput;
  TelephonyTelephonyActionTypeSelectColumn: TelephonyTelephonyActionTypeSelectColumn;
  TelephonyTelephonyActionTypeSetInput: TelephonyTelephonyActionTypeSetInput;
  TelephonyTelephonyActionTypeStreamCursorInput: TelephonyTelephonyActionTypeStreamCursorInput;
  TelephonyTelephonyActionTypeStreamCursorValueInput: TelephonyTelephonyActionTypeStreamCursorValueInput;
  TelephonyTelephonyActionTypeUpdateColumn: TelephonyTelephonyActionTypeUpdateColumn;
  TelephonyTelephonyActionTypeUpdates: TelephonyTelephonyActionTypeUpdates;
  TelephonyTelephonyBlockedDomainUser: ResolverTypeWrapper<TelephonyTelephonyBlockedDomainUser>;
  TelephonyTelephonyBlockedDomainUserAggregate: ResolverTypeWrapper<TelephonyTelephonyBlockedDomainUserAggregate>;
  TelephonyTelephonyBlockedDomainUserAggregateFields: ResolverTypeWrapper<TelephonyTelephonyBlockedDomainUserAggregateFields>;
  TelephonyTelephonyBlockedDomainUserBoolExp: TelephonyTelephonyBlockedDomainUserBoolExp;
  TelephonyTelephonyBlockedDomainUserConstraint: TelephonyTelephonyBlockedDomainUserConstraint;
  TelephonyTelephonyBlockedDomainUserInsertInput: TelephonyTelephonyBlockedDomainUserInsertInput;
  TelephonyTelephonyBlockedDomainUserMaxFields: ResolverTypeWrapper<TelephonyTelephonyBlockedDomainUserMaxFields>;
  TelephonyTelephonyBlockedDomainUserMinFields: ResolverTypeWrapper<TelephonyTelephonyBlockedDomainUserMinFields>;
  TelephonyTelephonyBlockedDomainUserMutationResponse: ResolverTypeWrapper<TelephonyTelephonyBlockedDomainUserMutationResponse>;
  TelephonyTelephonyBlockedDomainUserOnConflict: TelephonyTelephonyBlockedDomainUserOnConflict;
  TelephonyTelephonyBlockedDomainUserOrderBy: TelephonyTelephonyBlockedDomainUserOrderBy;
  TelephonyTelephonyBlockedDomainUserPkColumnsInput: TelephonyTelephonyBlockedDomainUserPkColumnsInput;
  TelephonyTelephonyBlockedDomainUserSelectColumn: TelephonyTelephonyBlockedDomainUserSelectColumn;
  TelephonyTelephonyBlockedDomainUserSetInput: TelephonyTelephonyBlockedDomainUserSetInput;
  TelephonyTelephonyBlockedDomainUserStreamCursorInput: TelephonyTelephonyBlockedDomainUserStreamCursorInput;
  TelephonyTelephonyBlockedDomainUserStreamCursorValueInput: TelephonyTelephonyBlockedDomainUserStreamCursorValueInput;
  TelephonyTelephonyBlockedDomainUserUpdateColumn: TelephonyTelephonyBlockedDomainUserUpdateColumn;
  TelephonyTelephonyBlockedDomainUserUpdates: TelephonyTelephonyBlockedDomainUserUpdates;
  TelephonyTelephonyCiscoSubscriberProduct: ResolverTypeWrapper<TelephonyTelephonyCiscoSubscriberProduct>;
  TelephonyTelephonyCiscoSubscriberProductAggregate: ResolverTypeWrapper<TelephonyTelephonyCiscoSubscriberProductAggregate>;
  TelephonyTelephonyCiscoSubscriberProductAggregateFields: ResolverTypeWrapper<TelephonyTelephonyCiscoSubscriberProductAggregateFields>;
  TelephonyTelephonyCiscoSubscriberProductBoolExp: TelephonyTelephonyCiscoSubscriberProductBoolExp;
  TelephonyTelephonyCiscoSubscriberProductConstraint: TelephonyTelephonyCiscoSubscriberProductConstraint;
  TelephonyTelephonyCiscoSubscriberProductInsertInput: TelephonyTelephonyCiscoSubscriberProductInsertInput;
  TelephonyTelephonyCiscoSubscriberProductMaxFields: ResolverTypeWrapper<TelephonyTelephonyCiscoSubscriberProductMaxFields>;
  TelephonyTelephonyCiscoSubscriberProductMinFields: ResolverTypeWrapper<TelephonyTelephonyCiscoSubscriberProductMinFields>;
  TelephonyTelephonyCiscoSubscriberProductMutationResponse: ResolverTypeWrapper<TelephonyTelephonyCiscoSubscriberProductMutationResponse>;
  TelephonyTelephonyCiscoSubscriberProductOnConflict: TelephonyTelephonyCiscoSubscriberProductOnConflict;
  TelephonyTelephonyCiscoSubscriberProductOrderBy: TelephonyTelephonyCiscoSubscriberProductOrderBy;
  TelephonyTelephonyCiscoSubscriberProductPkColumnsInput: TelephonyTelephonyCiscoSubscriberProductPkColumnsInput;
  TelephonyTelephonyCiscoSubscriberProductSelectColumn: TelephonyTelephonyCiscoSubscriberProductSelectColumn;
  TelephonyTelephonyCiscoSubscriberProductSetInput: TelephonyTelephonyCiscoSubscriberProductSetInput;
  TelephonyTelephonyCiscoSubscriberProductStreamCursorInput: TelephonyTelephonyCiscoSubscriberProductStreamCursorInput;
  TelephonyTelephonyCiscoSubscriberProductStreamCursorValueInput: TelephonyTelephonyCiscoSubscriberProductStreamCursorValueInput;
  TelephonyTelephonyCiscoSubscriberProductUpdateColumn: TelephonyTelephonyCiscoSubscriberProductUpdateColumn;
  TelephonyTelephonyCiscoSubscriberProductUpdates: TelephonyTelephonyCiscoSubscriberProductUpdates;
  TelephonyTelephonyEvents: ResolverTypeWrapper<TelephonyTelephonyEvents>;
  TelephonyTelephonyEventsAggregate: ResolverTypeWrapper<TelephonyTelephonyEventsAggregate>;
  TelephonyTelephonyEventsAggregateBoolExp: TelephonyTelephonyEventsAggregateBoolExp;
  TelephonyTelephonyEventsAggregateFields: ResolverTypeWrapper<TelephonyTelephonyEventsAggregateFields>;
  TelephonyTelephonyEventsAggregateOrderBy: TelephonyTelephonyEventsAggregateOrderBy;
  TelephonyTelephonyEventsArrRelInsertInput: TelephonyTelephonyEventsArrRelInsertInput;
  TelephonyTelephonyEventsBoolExp: TelephonyTelephonyEventsBoolExp;
  TelephonyTelephonyEventsConstraint: TelephonyTelephonyEventsConstraint;
  TelephonyTelephonyEventsInsertInput: TelephonyTelephonyEventsInsertInput;
  TelephonyTelephonyEventsMaxFields: ResolverTypeWrapper<TelephonyTelephonyEventsMaxFields>;
  TelephonyTelephonyEventsMaxOrderBy: TelephonyTelephonyEventsMaxOrderBy;
  TelephonyTelephonyEventsMinFields: ResolverTypeWrapper<TelephonyTelephonyEventsMinFields>;
  TelephonyTelephonyEventsMinOrderBy: TelephonyTelephonyEventsMinOrderBy;
  TelephonyTelephonyEventsMutationResponse: ResolverTypeWrapper<TelephonyTelephonyEventsMutationResponse>;
  TelephonyTelephonyEventsObjRelInsertInput: TelephonyTelephonyEventsObjRelInsertInput;
  TelephonyTelephonyEventsOnConflict: TelephonyTelephonyEventsOnConflict;
  TelephonyTelephonyEventsOrderBy: TelephonyTelephonyEventsOrderBy;
  TelephonyTelephonyEventsPkColumnsInput: TelephonyTelephonyEventsPkColumnsInput;
  TelephonyTelephonyEventsSelectColumn: TelephonyTelephonyEventsSelectColumn;
  TelephonyTelephonyEventsSetInput: TelephonyTelephonyEventsSetInput;
  TelephonyTelephonyEventsStreamCursorInput: TelephonyTelephonyEventsStreamCursorInput;
  TelephonyTelephonyEventsStreamCursorValueInput: TelephonyTelephonyEventsStreamCursorValueInput;
  TelephonyTelephonyEventsUpdateColumn: TelephonyTelephonyEventsUpdateColumn;
  TelephonyTelephonyEventsUpdates: TelephonyTelephonyEventsUpdates;
  TelephonyTelephonyLookupCallerApi: ResolverTypeWrapper<TelephonyTelephonyLookupCallerApi>;
  TelephonyTelephonyLookupCallerApiAggregate: ResolverTypeWrapper<TelephonyTelephonyLookupCallerApiAggregate>;
  TelephonyTelephonyLookupCallerApiAggregateFields: ResolverTypeWrapper<TelephonyTelephonyLookupCallerApiAggregateFields>;
  TelephonyTelephonyLookupCallerApiAppendInput: TelephonyTelephonyLookupCallerApiAppendInput;
  TelephonyTelephonyLookupCallerApiBoolExp: TelephonyTelephonyLookupCallerApiBoolExp;
  TelephonyTelephonyLookupCallerApiConstraint: TelephonyTelephonyLookupCallerApiConstraint;
  TelephonyTelephonyLookupCallerApiDeleteAtPathInput: TelephonyTelephonyLookupCallerApiDeleteAtPathInput;
  TelephonyTelephonyLookupCallerApiDeleteElemInput: TelephonyTelephonyLookupCallerApiDeleteElemInput;
  TelephonyTelephonyLookupCallerApiDeleteKeyInput: TelephonyTelephonyLookupCallerApiDeleteKeyInput;
  TelephonyTelephonyLookupCallerApiInsertInput: TelephonyTelephonyLookupCallerApiInsertInput;
  TelephonyTelephonyLookupCallerApiMaxFields: ResolverTypeWrapper<TelephonyTelephonyLookupCallerApiMaxFields>;
  TelephonyTelephonyLookupCallerApiMinFields: ResolverTypeWrapper<TelephonyTelephonyLookupCallerApiMinFields>;
  TelephonyTelephonyLookupCallerApiMutationResponse: ResolverTypeWrapper<TelephonyTelephonyLookupCallerApiMutationResponse>;
  TelephonyTelephonyLookupCallerApiOnConflict: TelephonyTelephonyLookupCallerApiOnConflict;
  TelephonyTelephonyLookupCallerApiOrderBy: TelephonyTelephonyLookupCallerApiOrderBy;
  TelephonyTelephonyLookupCallerApiPkColumnsInput: TelephonyTelephonyLookupCallerApiPkColumnsInput;
  TelephonyTelephonyLookupCallerApiPrependInput: TelephonyTelephonyLookupCallerApiPrependInput;
  TelephonyTelephonyLookupCallerApiSelectColumn: TelephonyTelephonyLookupCallerApiSelectColumn;
  TelephonyTelephonyLookupCallerApiSetInput: TelephonyTelephonyLookupCallerApiSetInput;
  TelephonyTelephonyLookupCallerApiStreamCursorInput: TelephonyTelephonyLookupCallerApiStreamCursorInput;
  TelephonyTelephonyLookupCallerApiStreamCursorValueInput: TelephonyTelephonyLookupCallerApiStreamCursorValueInput;
  TelephonyTelephonyLookupCallerApiUpdateColumn: TelephonyTelephonyLookupCallerApiUpdateColumn;
  TelephonyTelephonyLookupCallerApiUpdates: TelephonyTelephonyLookupCallerApiUpdates;
  TelephonyTelephonyLookupRefresh: ResolverTypeWrapper<TelephonyTelephonyLookupRefresh>;
  TelephonyTelephonyLookupRefreshAggregate: ResolverTypeWrapper<TelephonyTelephonyLookupRefreshAggregate>;
  TelephonyTelephonyLookupRefreshAggregateFields: ResolverTypeWrapper<TelephonyTelephonyLookupRefreshAggregateFields>;
  TelephonyTelephonyLookupRefreshAvgFields: ResolverTypeWrapper<TelephonyTelephonyLookupRefreshAvgFields>;
  TelephonyTelephonyLookupRefreshBoolExp: TelephonyTelephonyLookupRefreshBoolExp;
  TelephonyTelephonyLookupRefreshConstraint: TelephonyTelephonyLookupRefreshConstraint;
  TelephonyTelephonyLookupRefreshIncInput: TelephonyTelephonyLookupRefreshIncInput;
  TelephonyTelephonyLookupRefreshInsertInput: TelephonyTelephonyLookupRefreshInsertInput;
  TelephonyTelephonyLookupRefreshMaxFields: ResolverTypeWrapper<TelephonyTelephonyLookupRefreshMaxFields>;
  TelephonyTelephonyLookupRefreshMinFields: ResolverTypeWrapper<TelephonyTelephonyLookupRefreshMinFields>;
  TelephonyTelephonyLookupRefreshMutationResponse: ResolverTypeWrapper<TelephonyTelephonyLookupRefreshMutationResponse>;
  TelephonyTelephonyLookupRefreshOnConflict: TelephonyTelephonyLookupRefreshOnConflict;
  TelephonyTelephonyLookupRefreshOrderBy: TelephonyTelephonyLookupRefreshOrderBy;
  TelephonyTelephonyLookupRefreshPkColumnsInput: TelephonyTelephonyLookupRefreshPkColumnsInput;
  TelephonyTelephonyLookupRefreshSelectColumn: TelephonyTelephonyLookupRefreshSelectColumn;
  TelephonyTelephonyLookupRefreshSetInput: TelephonyTelephonyLookupRefreshSetInput;
  TelephonyTelephonyLookupRefreshStddevFields: ResolverTypeWrapper<TelephonyTelephonyLookupRefreshStddevFields>;
  TelephonyTelephonyLookupRefreshStddevPopFields: ResolverTypeWrapper<TelephonyTelephonyLookupRefreshStddevPopFields>;
  TelephonyTelephonyLookupRefreshStddevSampFields: ResolverTypeWrapper<TelephonyTelephonyLookupRefreshStddevSampFields>;
  TelephonyTelephonyLookupRefreshStreamCursorInput: TelephonyTelephonyLookupRefreshStreamCursorInput;
  TelephonyTelephonyLookupRefreshStreamCursorValueInput: TelephonyTelephonyLookupRefreshStreamCursorValueInput;
  TelephonyTelephonyLookupRefreshSumFields: ResolverTypeWrapper<TelephonyTelephonyLookupRefreshSumFields>;
  TelephonyTelephonyLookupRefreshUpdateColumn: TelephonyTelephonyLookupRefreshUpdateColumn;
  TelephonyTelephonyLookupRefreshUpdates: TelephonyTelephonyLookupRefreshUpdates;
  TelephonyTelephonyLookupRefreshVarPopFields: ResolverTypeWrapper<TelephonyTelephonyLookupRefreshVarPopFields>;
  TelephonyTelephonyLookupRefreshVarSampFields: ResolverTypeWrapper<TelephonyTelephonyLookupRefreshVarSampFields>;
  TelephonyTelephonyLookupRefreshVarianceFields: ResolverTypeWrapper<TelephonyTelephonyLookupRefreshVarianceFields>;
  TelephonyTelephonyLookupTypes: ResolverTypeWrapper<TelephonyTelephonyLookupTypes>;
  TelephonyTelephonyLookupTypesAggregate: ResolverTypeWrapper<TelephonyTelephonyLookupTypesAggregate>;
  TelephonyTelephonyLookupTypesAggregateFields: ResolverTypeWrapper<TelephonyTelephonyLookupTypesAggregateFields>;
  TelephonyTelephonyLookupTypesBoolExp: TelephonyTelephonyLookupTypesBoolExp;
  TelephonyTelephonyLookupTypesConstraint: TelephonyTelephonyLookupTypesConstraint;
  TelephonyTelephonyLookupTypesEnum: TelephonyTelephonyLookupTypesEnum;
  TelephonyTelephonyLookupTypesEnumComparisonExp: TelephonyTelephonyLookupTypesEnumComparisonExp;
  TelephonyTelephonyLookupTypesInsertInput: TelephonyTelephonyLookupTypesInsertInput;
  TelephonyTelephonyLookupTypesMaxFields: ResolverTypeWrapper<TelephonyTelephonyLookupTypesMaxFields>;
  TelephonyTelephonyLookupTypesMinFields: ResolverTypeWrapper<TelephonyTelephonyLookupTypesMinFields>;
  TelephonyTelephonyLookupTypesMutationResponse: ResolverTypeWrapper<TelephonyTelephonyLookupTypesMutationResponse>;
  TelephonyTelephonyLookupTypesOnConflict: TelephonyTelephonyLookupTypesOnConflict;
  TelephonyTelephonyLookupTypesOrderBy: TelephonyTelephonyLookupTypesOrderBy;
  TelephonyTelephonyLookupTypesPkColumnsInput: TelephonyTelephonyLookupTypesPkColumnsInput;
  TelephonyTelephonyLookupTypesSelectColumn: TelephonyTelephonyLookupTypesSelectColumn;
  TelephonyTelephonyLookupTypesSetInput: TelephonyTelephonyLookupTypesSetInput;
  TelephonyTelephonyLookupTypesStreamCursorInput: TelephonyTelephonyLookupTypesStreamCursorInput;
  TelephonyTelephonyLookupTypesStreamCursorValueInput: TelephonyTelephonyLookupTypesStreamCursorValueInput;
  TelephonyTelephonyLookupTypesUpdateColumn: TelephonyTelephonyLookupTypesUpdateColumn;
  TelephonyTelephonyLookupTypesUpdates: TelephonyTelephonyLookupTypesUpdates;
  TelephonyTelephonyPods: ResolverTypeWrapper<TelephonyTelephonyPods>;
  TelephonyTelephonyPodsAggregate: ResolverTypeWrapper<TelephonyTelephonyPodsAggregate>;
  TelephonyTelephonyPodsAggregateFields: ResolverTypeWrapper<TelephonyTelephonyPodsAggregateFields>;
  TelephonyTelephonyPodsBoolExp: TelephonyTelephonyPodsBoolExp;
  TelephonyTelephonyPodsConstraint: TelephonyTelephonyPodsConstraint;
  TelephonyTelephonyPodsInsertInput: TelephonyTelephonyPodsInsertInput;
  TelephonyTelephonyPodsMaxFields: ResolverTypeWrapper<TelephonyTelephonyPodsMaxFields>;
  TelephonyTelephonyPodsMinFields: ResolverTypeWrapper<TelephonyTelephonyPodsMinFields>;
  TelephonyTelephonyPodsMutationResponse: ResolverTypeWrapper<TelephonyTelephonyPodsMutationResponse>;
  TelephonyTelephonyPodsObjRelInsertInput: TelephonyTelephonyPodsObjRelInsertInput;
  TelephonyTelephonyPodsOnConflict: TelephonyTelephonyPodsOnConflict;
  TelephonyTelephonyPodsOrderBy: TelephonyTelephonyPodsOrderBy;
  TelephonyTelephonyPodsPkColumnsInput: TelephonyTelephonyPodsPkColumnsInput;
  TelephonyTelephonyPodsSelectColumn: TelephonyTelephonyPodsSelectColumn;
  TelephonyTelephonyPodsSetInput: TelephonyTelephonyPodsSetInput;
  TelephonyTelephonyPodsStreamCursorInput: TelephonyTelephonyPodsStreamCursorInput;
  TelephonyTelephonyPodsStreamCursorValueInput: TelephonyTelephonyPodsStreamCursorValueInput;
  TelephonyTelephonyPodsUpdateColumn: TelephonyTelephonyPodsUpdateColumn;
  TelephonyTelephonyPodsUpdates: TelephonyTelephonyPodsUpdates;
  TelephonyTelephonyProviderAccess: ResolverTypeWrapper<TelephonyTelephonyProviderAccess>;
  TelephonyTelephonyProviderAccessAggregate: ResolverTypeWrapper<TelephonyTelephonyProviderAccessAggregate>;
  TelephonyTelephonyProviderAccessAggregateFields: ResolverTypeWrapper<TelephonyTelephonyProviderAccessAggregateFields>;
  TelephonyTelephonyProviderAccessBoolExp: TelephonyTelephonyProviderAccessBoolExp;
  TelephonyTelephonyProviderAccessConstraint: TelephonyTelephonyProviderAccessConstraint;
  TelephonyTelephonyProviderAccessEnum: TelephonyTelephonyProviderAccessEnum;
  TelephonyTelephonyProviderAccessEnumComparisonExp: TelephonyTelephonyProviderAccessEnumComparisonExp;
  TelephonyTelephonyProviderAccessInsertInput: TelephonyTelephonyProviderAccessInsertInput;
  TelephonyTelephonyProviderAccessMaxFields: ResolverTypeWrapper<TelephonyTelephonyProviderAccessMaxFields>;
  TelephonyTelephonyProviderAccessMinFields: ResolverTypeWrapper<TelephonyTelephonyProviderAccessMinFields>;
  TelephonyTelephonyProviderAccessMutationResponse: ResolverTypeWrapper<TelephonyTelephonyProviderAccessMutationResponse>;
  TelephonyTelephonyProviderAccessOnConflict: TelephonyTelephonyProviderAccessOnConflict;
  TelephonyTelephonyProviderAccessOrderBy: TelephonyTelephonyProviderAccessOrderBy;
  TelephonyTelephonyProviderAccessPkColumnsInput: TelephonyTelephonyProviderAccessPkColumnsInput;
  TelephonyTelephonyProviderAccessSelectColumn: TelephonyTelephonyProviderAccessSelectColumn;
  TelephonyTelephonyProviderAccessSetInput: TelephonyTelephonyProviderAccessSetInput;
  TelephonyTelephonyProviderAccessStreamCursorInput: TelephonyTelephonyProviderAccessStreamCursorInput;
  TelephonyTelephonyProviderAccessStreamCursorValueInput: TelephonyTelephonyProviderAccessStreamCursorValueInput;
  TelephonyTelephonyProviderAccessUpdateColumn: TelephonyTelephonyProviderAccessUpdateColumn;
  TelephonyTelephonyProviderAccessUpdates: TelephonyTelephonyProviderAccessUpdates;
  TelephonyTelephonyProviderType: TelephonyTelephonyProviderType;
  TelephonyactiveNumbers: ResolverTypeWrapper<TelephonyactiveNumbers>;
  TelephonyactiveNumbersAggregate: ResolverTypeWrapper<TelephonyactiveNumbersAggregate>;
  TelephonyactiveNumbersAggregateFields: ResolverTypeWrapper<TelephonyactiveNumbersAggregateFields>;
  TelephonyactiveNumbersBoolExp: TelephonyactiveNumbersBoolExp;
  TelephonyactiveNumbersConstraint: TelephonyactiveNumbersConstraint;
  TelephonyactiveNumbersInsertInput: TelephonyactiveNumbersInsertInput;
  TelephonyactiveNumbersMaxFields: ResolverTypeWrapper<TelephonyactiveNumbersMaxFields>;
  TelephonyactiveNumbersMinFields: ResolverTypeWrapper<TelephonyactiveNumbersMinFields>;
  TelephonyactiveNumbersMutationResponse: ResolverTypeWrapper<TelephonyactiveNumbersMutationResponse>;
  TelephonyactiveNumbersOnConflict: TelephonyactiveNumbersOnConflict;
  TelephonyactiveNumbersOrderBy: TelephonyactiveNumbersOrderBy;
  TelephonyactiveNumbersPkColumnsInput: TelephonyactiveNumbersPkColumnsInput;
  TelephonyactiveNumbersSelectColumn: TelephonyactiveNumbersSelectColumn;
  TelephonyactiveNumbersSetInput: TelephonyactiveNumbersSetInput;
  TelephonyactiveNumbersStreamCursorInput: TelephonyactiveNumbersStreamCursorInput;
  TelephonyactiveNumbersStreamCursorValueInput: TelephonyactiveNumbersStreamCursorValueInput;
  TelephonyactiveNumbersUpdateColumn: TelephonyactiveNumbersUpdateColumn;
  TelephonyactiveNumbersUpdates: TelephonyactiveNumbersUpdates;
  Telephonyactivity: ResolverTypeWrapper<Telephonyactivity>;
  TelephonyactivityAggregate: ResolverTypeWrapper<TelephonyactivityAggregate>;
  TelephonyactivityAggregateBoolExp: TelephonyactivityAggregateBoolExp;
  TelephonyactivityAggregateBoolExpCount: TelephonyactivityAggregateBoolExpCount;
  TelephonyactivityAggregateFields: ResolverTypeWrapper<TelephonyactivityAggregateFields>;
  TelephonyactivityAggregateOrderBy: TelephonyactivityAggregateOrderBy;
  TelephonyactivityArrRelInsertInput: TelephonyactivityArrRelInsertInput;
  TelephonyactivityAvgFields: ResolverTypeWrapper<TelephonyactivityAvgFields>;
  TelephonyactivityAvgOrderBy: TelephonyactivityAvgOrderBy;
  TelephonyactivityBoolExp: TelephonyactivityBoolExp;
  TelephonyactivityConstraint: TelephonyactivityConstraint;
  TelephonyactivityIncInput: TelephonyactivityIncInput;
  TelephonyactivityInsertInput: TelephonyactivityInsertInput;
  TelephonyactivityMaxFields: ResolverTypeWrapper<TelephonyactivityMaxFields>;
  TelephonyactivityMaxOrderBy: TelephonyactivityMaxOrderBy;
  TelephonyactivityMinFields: ResolverTypeWrapper<TelephonyactivityMinFields>;
  TelephonyactivityMinOrderBy: TelephonyactivityMinOrderBy;
  TelephonyactivityMutationResponse: ResolverTypeWrapper<TelephonyactivityMutationResponse>;
  TelephonyactivityObjRelInsertInput: TelephonyactivityObjRelInsertInput;
  TelephonyactivityOnConflict: TelephonyactivityOnConflict;
  TelephonyactivityOrderBy: TelephonyactivityOrderBy;
  TelephonyactivityParticipant: ResolverTypeWrapper<TelephonyactivityParticipant>;
  TelephonyactivityParticipantAggregate: ResolverTypeWrapper<TelephonyactivityParticipantAggregate>;
  TelephonyactivityParticipantAggregateBoolExp: TelephonyactivityParticipantAggregateBoolExp;
  TelephonyactivityParticipantAggregateBoolExpCount: TelephonyactivityParticipantAggregateBoolExpCount;
  TelephonyactivityParticipantAggregateFields: ResolverTypeWrapper<TelephonyactivityParticipantAggregateFields>;
  TelephonyactivityParticipantAggregateOrderBy: TelephonyactivityParticipantAggregateOrderBy;
  TelephonyactivityParticipantArrRelInsertInput: TelephonyactivityParticipantArrRelInsertInput;
  TelephonyactivityParticipantBoolExp: TelephonyactivityParticipantBoolExp;
  TelephonyactivityParticipantConstraint: TelephonyactivityParticipantConstraint;
  TelephonyactivityParticipantInsertInput: TelephonyactivityParticipantInsertInput;
  TelephonyactivityParticipantMaxFields: ResolverTypeWrapper<TelephonyactivityParticipantMaxFields>;
  TelephonyactivityParticipantMaxOrderBy: TelephonyactivityParticipantMaxOrderBy;
  TelephonyactivityParticipantMinFields: ResolverTypeWrapper<TelephonyactivityParticipantMinFields>;
  TelephonyactivityParticipantMinOrderBy: TelephonyactivityParticipantMinOrderBy;
  TelephonyactivityParticipantMutationResponse: ResolverTypeWrapper<TelephonyactivityParticipantMutationResponse>;
  TelephonyactivityParticipantOnConflict: TelephonyactivityParticipantOnConflict;
  TelephonyactivityParticipantOrderBy: TelephonyactivityParticipantOrderBy;
  TelephonyactivityParticipantPkColumnsInput: TelephonyactivityParticipantPkColumnsInput;
  TelephonyactivityParticipantSelectColumn: TelephonyactivityParticipantSelectColumn;
  TelephonyactivityParticipantSetInput: TelephonyactivityParticipantSetInput;
  TelephonyactivityParticipantStreamCursorInput: TelephonyactivityParticipantStreamCursorInput;
  TelephonyactivityParticipantStreamCursorValueInput: TelephonyactivityParticipantStreamCursorValueInput;
  TelephonyactivityParticipantUpdateColumn: TelephonyactivityParticipantUpdateColumn;
  TelephonyactivityParticipantUpdates: TelephonyactivityParticipantUpdates;
  TelephonyactivityPkColumnsInput: TelephonyactivityPkColumnsInput;
  TelephonyactivitySelectColumn: TelephonyactivitySelectColumn;
  TelephonyactivitySetInput: TelephonyactivitySetInput;
  TelephonyactivityStddevFields: ResolverTypeWrapper<TelephonyactivityStddevFields>;
  TelephonyactivityStddevOrderBy: TelephonyactivityStddevOrderBy;
  TelephonyactivityStddevPopFields: ResolverTypeWrapper<TelephonyactivityStddevPopFields>;
  TelephonyactivityStddevPopOrderBy: TelephonyactivityStddevPopOrderBy;
  TelephonyactivityStddevSampFields: ResolverTypeWrapper<TelephonyactivityStddevSampFields>;
  TelephonyactivityStddevSampOrderBy: TelephonyactivityStddevSampOrderBy;
  TelephonyactivityStreamCursorInput: TelephonyactivityStreamCursorInput;
  TelephonyactivityStreamCursorValueInput: TelephonyactivityStreamCursorValueInput;
  TelephonyactivitySumFields: ResolverTypeWrapper<TelephonyactivitySumFields>;
  TelephonyactivitySumOrderBy: TelephonyactivitySumOrderBy;
  TelephonyactivityUpdateColumn: TelephonyactivityUpdateColumn;
  TelephonyactivityUpdates: TelephonyactivityUpdates;
  TelephonyactivityVarPopFields: ResolverTypeWrapper<TelephonyactivityVarPopFields>;
  TelephonyactivityVarPopOrderBy: TelephonyactivityVarPopOrderBy;
  TelephonyactivityVarSampFields: ResolverTypeWrapper<TelephonyactivityVarSampFields>;
  TelephonyactivityVarSampOrderBy: TelephonyactivityVarSampOrderBy;
  TelephonyactivityVarianceFields: ResolverTypeWrapper<TelephonyactivityVarianceFields>;
  TelephonyactivityVarianceOrderBy: TelephonyactivityVarianceOrderBy;
  Telephonycomment: ResolverTypeWrapper<Telephonycomment>;
  TelephonycommentAggregate: ResolverTypeWrapper<TelephonycommentAggregate>;
  TelephonycommentAggregateBoolExp: TelephonycommentAggregateBoolExp;
  TelephonycommentAggregateBoolExpCount: TelephonycommentAggregateBoolExpCount;
  TelephonycommentAggregateFields: ResolverTypeWrapper<TelephonycommentAggregateFields>;
  TelephonycommentAggregateOrderBy: TelephonycommentAggregateOrderBy;
  TelephonycommentArrRelInsertInput: TelephonycommentArrRelInsertInput;
  TelephonycommentBoolExp: TelephonycommentBoolExp;
  TelephonycommentConstraint: TelephonycommentConstraint;
  TelephonycommentInsertInput: TelephonycommentInsertInput;
  TelephonycommentMaxFields: ResolverTypeWrapper<TelephonycommentMaxFields>;
  TelephonycommentMaxOrderBy: TelephonycommentMaxOrderBy;
  TelephonycommentMinFields: ResolverTypeWrapper<TelephonycommentMinFields>;
  TelephonycommentMinOrderBy: TelephonycommentMinOrderBy;
  TelephonycommentMutationResponse: ResolverTypeWrapper<TelephonycommentMutationResponse>;
  TelephonycommentOnConflict: TelephonycommentOnConflict;
  TelephonycommentOrderBy: TelephonycommentOrderBy;
  TelephonycommentPkColumnsInput: TelephonycommentPkColumnsInput;
  TelephonycommentSelectColumn: TelephonycommentSelectColumn;
  TelephonycommentSetInput: TelephonycommentSetInput;
  TelephonycommentStreamCursorInput: TelephonycommentStreamCursorInput;
  TelephonycommentStreamCursorValueInput: TelephonycommentStreamCursorValueInput;
  TelephonycommentUpdateColumn: TelephonycommentUpdateColumn;
  TelephonycommentUpdates: TelephonycommentUpdates;
  TelephonydomainOrganization: ResolverTypeWrapper<TelephonydomainOrganization>;
  TelephonydomainOrganizationAggregate: ResolverTypeWrapper<TelephonydomainOrganizationAggregate>;
  TelephonydomainOrganizationAggregateBoolExp: TelephonydomainOrganizationAggregateBoolExp;
  TelephonydomainOrganizationAggregateBoolExpBool_and: TelephonydomainOrganizationAggregateBoolExpBool_and;
  TelephonydomainOrganizationAggregateBoolExpBool_or: TelephonydomainOrganizationAggregateBoolExpBool_or;
  TelephonydomainOrganizationAggregateBoolExpCount: TelephonydomainOrganizationAggregateBoolExpCount;
  TelephonydomainOrganizationAggregateFields: ResolverTypeWrapper<TelephonydomainOrganizationAggregateFields>;
  TelephonydomainOrganizationAggregateOrderBy: TelephonydomainOrganizationAggregateOrderBy;
  TelephonydomainOrganizationArrRelInsertInput: TelephonydomainOrganizationArrRelInsertInput;
  TelephonydomainOrganizationBoolExp: TelephonydomainOrganizationBoolExp;
  TelephonydomainOrganizationConstraint: TelephonydomainOrganizationConstraint;
  TelephonydomainOrganizationInsertInput: TelephonydomainOrganizationInsertInput;
  TelephonydomainOrganizationMaxFields: ResolverTypeWrapper<TelephonydomainOrganizationMaxFields>;
  TelephonydomainOrganizationMaxOrderBy: TelephonydomainOrganizationMaxOrderBy;
  TelephonydomainOrganizationMinFields: ResolverTypeWrapper<TelephonydomainOrganizationMinFields>;
  TelephonydomainOrganizationMinOrderBy: TelephonydomainOrganizationMinOrderBy;
  TelephonydomainOrganizationMutationResponse: ResolverTypeWrapper<TelephonydomainOrganizationMutationResponse>;
  TelephonydomainOrganizationObjRelInsertInput: TelephonydomainOrganizationObjRelInsertInput;
  TelephonydomainOrganizationOnConflict: TelephonydomainOrganizationOnConflict;
  TelephonydomainOrganizationOrderBy: TelephonydomainOrganizationOrderBy;
  TelephonydomainOrganizationPkColumnsInput: TelephonydomainOrganizationPkColumnsInput;
  TelephonydomainOrganizationSelectColumn: TelephonydomainOrganizationSelectColumn;
  TelephonydomainOrganizationSelectColumnDomainOrganizationAggregateBoolExpBool_andArgumentsColumns: TelephonydomainOrganizationSelectColumnDomainOrganizationAggregateBoolExpBool_andArgumentsColumns;
  TelephonydomainOrganizationSelectColumnDomainOrganizationAggregateBoolExpBool_orArgumentsColumns: TelephonydomainOrganizationSelectColumnDomainOrganizationAggregateBoolExpBool_orArgumentsColumns;
  TelephonydomainOrganizationSetInput: TelephonydomainOrganizationSetInput;
  TelephonydomainOrganizationStreamCursorInput: TelephonydomainOrganizationStreamCursorInput;
  TelephonydomainOrganizationStreamCursorValueInput: TelephonydomainOrganizationStreamCursorValueInput;
  TelephonydomainOrganizationUpdateColumn: TelephonydomainOrganizationUpdateColumn;
  TelephonydomainOrganizationUpdates: TelephonydomainOrganizationUpdates;
  TelephonydomainUser: ResolverTypeWrapper<TelephonydomainUser>;
  TelephonydomainUserAggregate: ResolverTypeWrapper<TelephonydomainUserAggregate>;
  TelephonydomainUserAggregateBoolExp: TelephonydomainUserAggregateBoolExp;
  TelephonydomainUserAggregateBoolExpCount: TelephonydomainUserAggregateBoolExpCount;
  TelephonydomainUserAggregateFields: ResolverTypeWrapper<TelephonydomainUserAggregateFields>;
  TelephonydomainUserAggregateOrderBy: TelephonydomainUserAggregateOrderBy;
  TelephonydomainUserAppendInput: TelephonydomainUserAppendInput;
  TelephonydomainUserArrRelInsertInput: TelephonydomainUserArrRelInsertInput;
  TelephonydomainUserAvgFields: ResolverTypeWrapper<TelephonydomainUserAvgFields>;
  TelephonydomainUserAvgOrderBy: TelephonydomainUserAvgOrderBy;
  TelephonydomainUserBoolExp: TelephonydomainUserBoolExp;
  TelephonydomainUserConstraint: TelephonydomainUserConstraint;
  TelephonydomainUserDeleteAtPathInput: TelephonydomainUserDeleteAtPathInput;
  TelephonydomainUserDeleteElemInput: TelephonydomainUserDeleteElemInput;
  TelephonydomainUserDeleteKeyInput: TelephonydomainUserDeleteKeyInput;
  TelephonydomainUserIncInput: TelephonydomainUserIncInput;
  TelephonydomainUserInsertInput: TelephonydomainUserInsertInput;
  TelephonydomainUserMaxFields: ResolverTypeWrapper<TelephonydomainUserMaxFields>;
  TelephonydomainUserMaxOrderBy: TelephonydomainUserMaxOrderBy;
  TelephonydomainUserMinFields: ResolverTypeWrapper<TelephonydomainUserMinFields>;
  TelephonydomainUserMinOrderBy: TelephonydomainUserMinOrderBy;
  TelephonydomainUserMutationResponse: ResolverTypeWrapper<TelephonydomainUserMutationResponse>;
  TelephonydomainUserObjRelInsertInput: TelephonydomainUserObjRelInsertInput;
  TelephonydomainUserOnConflict: TelephonydomainUserOnConflict;
  TelephonydomainUserOrderBy: TelephonydomainUserOrderBy;
  TelephonydomainUserPkColumnsInput: TelephonydomainUserPkColumnsInput;
  TelephonydomainUserPrependInput: TelephonydomainUserPrependInput;
  TelephonydomainUserSelectColumn: TelephonydomainUserSelectColumn;
  TelephonydomainUserSetInput: TelephonydomainUserSetInput;
  TelephonydomainUserStddevFields: ResolverTypeWrapper<TelephonydomainUserStddevFields>;
  TelephonydomainUserStddevOrderBy: TelephonydomainUserStddevOrderBy;
  TelephonydomainUserStddevPopFields: ResolverTypeWrapper<TelephonydomainUserStddevPopFields>;
  TelephonydomainUserStddevPopOrderBy: TelephonydomainUserStddevPopOrderBy;
  TelephonydomainUserStddevSampFields: ResolverTypeWrapper<TelephonydomainUserStddevSampFields>;
  TelephonydomainUserStddevSampOrderBy: TelephonydomainUserStddevSampOrderBy;
  TelephonydomainUserStreamCursorInput: TelephonydomainUserStreamCursorInput;
  TelephonydomainUserStreamCursorValueInput: TelephonydomainUserStreamCursorValueInput;
  TelephonydomainUserSumFields: ResolverTypeWrapper<TelephonydomainUserSumFields>;
  TelephonydomainUserSumOrderBy: TelephonydomainUserSumOrderBy;
  TelephonydomainUserUpdateColumn: TelephonydomainUserUpdateColumn;
  TelephonydomainUserUpdates: TelephonydomainUserUpdates;
  TelephonydomainUserVarPopFields: ResolverTypeWrapper<TelephonydomainUserVarPopFields>;
  TelephonydomainUserVarPopOrderBy: TelephonydomainUserVarPopOrderBy;
  TelephonydomainUserVarSampFields: ResolverTypeWrapper<TelephonydomainUserVarSampFields>;
  TelephonydomainUserVarSampOrderBy: TelephonydomainUserVarSampOrderBy;
  TelephonydomainUserVarianceFields: ResolverTypeWrapper<TelephonydomainUserVarianceFields>;
  TelephonydomainUserVarianceOrderBy: TelephonydomainUserVarianceOrderBy;
  Telephonyevent: ResolverTypeWrapper<Telephonyevent>;
  TelephonyeventAction: ResolverTypeWrapper<TelephonyeventAction>;
  TelephonyeventActionAggregate: ResolverTypeWrapper<TelephonyeventActionAggregate>;
  TelephonyeventActionAggregateFields: ResolverTypeWrapper<TelephonyeventActionAggregateFields>;
  TelephonyeventActionBoolExp: TelephonyeventActionBoolExp;
  TelephonyeventActionConstraint: TelephonyeventActionConstraint;
  TelephonyeventActionInsertInput: TelephonyeventActionInsertInput;
  TelephonyeventActionMaxFields: ResolverTypeWrapper<TelephonyeventActionMaxFields>;
  TelephonyeventActionMinFields: ResolverTypeWrapper<TelephonyeventActionMinFields>;
  TelephonyeventActionMutationResponse: ResolverTypeWrapper<TelephonyeventActionMutationResponse>;
  TelephonyeventActionOnConflict: TelephonyeventActionOnConflict;
  TelephonyeventActionOrderBy: TelephonyeventActionOrderBy;
  TelephonyeventActionPkColumnsInput: TelephonyeventActionPkColumnsInput;
  TelephonyeventActionSelectColumn: TelephonyeventActionSelectColumn;
  TelephonyeventActionSetInput: TelephonyeventActionSetInput;
  TelephonyeventActionStreamCursorInput: TelephonyeventActionStreamCursorInput;
  TelephonyeventActionStreamCursorValueInput: TelephonyeventActionStreamCursorValueInput;
  TelephonyeventActionUpdateColumn: TelephonyeventActionUpdateColumn;
  TelephonyeventActionUpdates: TelephonyeventActionUpdates;
  TelephonyeventAggregate: ResolverTypeWrapper<TelephonyeventAggregate>;
  TelephonyeventAggregateBoolExp: TelephonyeventAggregateBoolExp;
  TelephonyeventAggregateBoolExpCount: TelephonyeventAggregateBoolExpCount;
  TelephonyeventAggregateFields: ResolverTypeWrapper<TelephonyeventAggregateFields>;
  TelephonyeventAggregateOrderBy: TelephonyeventAggregateOrderBy;
  TelephonyeventArrRelInsertInput: TelephonyeventArrRelInsertInput;
  TelephonyeventAvgFields: ResolverTypeWrapper<TelephonyeventAvgFields>;
  TelephonyeventAvgOrderBy: TelephonyeventAvgOrderBy;
  TelephonyeventBoolExp: TelephonyeventBoolExp;
  TelephonyeventConstraint: TelephonyeventConstraint;
  TelephonyeventIncInput: TelephonyeventIncInput;
  TelephonyeventInsertInput: TelephonyeventInsertInput;
  TelephonyeventMaxFields: ResolverTypeWrapper<TelephonyeventMaxFields>;
  TelephonyeventMaxOrderBy: TelephonyeventMaxOrderBy;
  TelephonyeventMinFields: ResolverTypeWrapper<TelephonyeventMinFields>;
  TelephonyeventMinOrderBy: TelephonyeventMinOrderBy;
  TelephonyeventMutationResponse: ResolverTypeWrapper<TelephonyeventMutationResponse>;
  TelephonyeventOnConflict: TelephonyeventOnConflict;
  TelephonyeventOrderBy: TelephonyeventOrderBy;
  TelephonyeventPkColumnsInput: TelephonyeventPkColumnsInput;
  TelephonyeventSelectColumn: TelephonyeventSelectColumn;
  TelephonyeventSetInput: TelephonyeventSetInput;
  TelephonyeventStddevFields: ResolverTypeWrapper<TelephonyeventStddevFields>;
  TelephonyeventStddevOrderBy: TelephonyeventStddevOrderBy;
  TelephonyeventStddevPopFields: ResolverTypeWrapper<TelephonyeventStddevPopFields>;
  TelephonyeventStddevPopOrderBy: TelephonyeventStddevPopOrderBy;
  TelephonyeventStddevSampFields: ResolverTypeWrapper<TelephonyeventStddevSampFields>;
  TelephonyeventStddevSampOrderBy: TelephonyeventStddevSampOrderBy;
  TelephonyeventStreamCursorInput: TelephonyeventStreamCursorInput;
  TelephonyeventStreamCursorValueInput: TelephonyeventStreamCursorValueInput;
  TelephonyeventSumFields: ResolverTypeWrapper<TelephonyeventSumFields>;
  TelephonyeventSumOrderBy: TelephonyeventSumOrderBy;
  TelephonyeventUpdateColumn: TelephonyeventUpdateColumn;
  TelephonyeventUpdates: TelephonyeventUpdates;
  TelephonyeventVarPopFields: ResolverTypeWrapper<TelephonyeventVarPopFields>;
  TelephonyeventVarPopOrderBy: TelephonyeventVarPopOrderBy;
  TelephonyeventVarSampFields: ResolverTypeWrapper<TelephonyeventVarSampFields>;
  TelephonyeventVarSampOrderBy: TelephonyeventVarSampOrderBy;
  TelephonyeventVarianceFields: ResolverTypeWrapper<TelephonyeventVarianceFields>;
  TelephonyeventVarianceOrderBy: TelephonyeventVarianceOrderBy;
  TelephonyhangUpCallOutput: ResolverTypeWrapper<TelephonyhangUpCallOutput>;
  Telephonyjsonb: ResolverTypeWrapper<Scalars['Telephonyjsonb']['output']>;
  Telephonyprovider: ResolverTypeWrapper<Telephonyprovider>;
  TelephonyproviderAccount: ResolverTypeWrapper<TelephonyproviderAccount>;
  TelephonyproviderAccountAggregate: ResolverTypeWrapper<TelephonyproviderAccountAggregate>;
  TelephonyproviderAccountAggregateBoolExp: TelephonyproviderAccountAggregateBoolExp;
  TelephonyproviderAccountAggregateBoolExpCount: TelephonyproviderAccountAggregateBoolExpCount;
  TelephonyproviderAccountAggregateFields: ResolverTypeWrapper<TelephonyproviderAccountAggregateFields>;
  TelephonyproviderAccountAggregateOrderBy: TelephonyproviderAccountAggregateOrderBy;
  TelephonyproviderAccountArrRelInsertInput: TelephonyproviderAccountArrRelInsertInput;
  TelephonyproviderAccountBoolExp: TelephonyproviderAccountBoolExp;
  TelephonyproviderAccountConstraint: TelephonyproviderAccountConstraint;
  TelephonyproviderAccountInsertInput: TelephonyproviderAccountInsertInput;
  TelephonyproviderAccountMaxFields: ResolverTypeWrapper<TelephonyproviderAccountMaxFields>;
  TelephonyproviderAccountMaxOrderBy: TelephonyproviderAccountMaxOrderBy;
  TelephonyproviderAccountMinFields: ResolverTypeWrapper<TelephonyproviderAccountMinFields>;
  TelephonyproviderAccountMinOrderBy: TelephonyproviderAccountMinOrderBy;
  TelephonyproviderAccountMutationResponse: ResolverTypeWrapper<TelephonyproviderAccountMutationResponse>;
  TelephonyproviderAccountObjRelInsertInput: TelephonyproviderAccountObjRelInsertInput;
  TelephonyproviderAccountOnConflict: TelephonyproviderAccountOnConflict;
  TelephonyproviderAccountOrderBy: TelephonyproviderAccountOrderBy;
  TelephonyproviderAccountPkColumnsInput: TelephonyproviderAccountPkColumnsInput;
  TelephonyproviderAccountSelectColumn: TelephonyproviderAccountSelectColumn;
  TelephonyproviderAccountSetInput: TelephonyproviderAccountSetInput;
  TelephonyproviderAccountStreamCursorInput: TelephonyproviderAccountStreamCursorInput;
  TelephonyproviderAccountStreamCursorValueInput: TelephonyproviderAccountStreamCursorValueInput;
  TelephonyproviderAccountUpdateColumn: TelephonyproviderAccountUpdateColumn;
  TelephonyproviderAccountUpdates: TelephonyproviderAccountUpdates;
  TelephonyproviderAggregate: ResolverTypeWrapper<TelephonyproviderAggregate>;
  TelephonyproviderAggregateFields: ResolverTypeWrapper<TelephonyproviderAggregateFields>;
  TelephonyproviderBoolExp: TelephonyproviderBoolExp;
  TelephonyproviderConstraint: TelephonyproviderConstraint;
  TelephonyproviderInsertInput: TelephonyproviderInsertInput;
  TelephonyproviderMaxFields: ResolverTypeWrapper<TelephonyproviderMaxFields>;
  TelephonyproviderMinFields: ResolverTypeWrapper<TelephonyproviderMinFields>;
  TelephonyproviderMutationResponse: ResolverTypeWrapper<TelephonyproviderMutationResponse>;
  TelephonyproviderObjRelInsertInput: TelephonyproviderObjRelInsertInput;
  TelephonyproviderOnConflict: TelephonyproviderOnConflict;
  TelephonyproviderOrderBy: TelephonyproviderOrderBy;
  TelephonyproviderPkColumnsInput: TelephonyproviderPkColumnsInput;
  TelephonyproviderRequestTerm: ResolverTypeWrapper<TelephonyproviderRequestTerm>;
  TelephonyproviderRequestTermAggregate: ResolverTypeWrapper<TelephonyproviderRequestTermAggregate>;
  TelephonyproviderRequestTermAggregateFields: ResolverTypeWrapper<TelephonyproviderRequestTermAggregateFields>;
  TelephonyproviderRequestTermAvgFields: ResolverTypeWrapper<TelephonyproviderRequestTermAvgFields>;
  TelephonyproviderRequestTermBoolExp: TelephonyproviderRequestTermBoolExp;
  TelephonyproviderRequestTermConstraint: TelephonyproviderRequestTermConstraint;
  TelephonyproviderRequestTermIncInput: TelephonyproviderRequestTermIncInput;
  TelephonyproviderRequestTermInsertInput: TelephonyproviderRequestTermInsertInput;
  TelephonyproviderRequestTermMaxFields: ResolverTypeWrapper<TelephonyproviderRequestTermMaxFields>;
  TelephonyproviderRequestTermMinFields: ResolverTypeWrapper<TelephonyproviderRequestTermMinFields>;
  TelephonyproviderRequestTermMutationResponse: ResolverTypeWrapper<TelephonyproviderRequestTermMutationResponse>;
  TelephonyproviderRequestTermOnConflict: TelephonyproviderRequestTermOnConflict;
  TelephonyproviderRequestTermOrderBy: TelephonyproviderRequestTermOrderBy;
  TelephonyproviderRequestTermPkColumnsInput: TelephonyproviderRequestTermPkColumnsInput;
  TelephonyproviderRequestTermSelectColumn: TelephonyproviderRequestTermSelectColumn;
  TelephonyproviderRequestTermSetInput: TelephonyproviderRequestTermSetInput;
  TelephonyproviderRequestTermStddevFields: ResolverTypeWrapper<TelephonyproviderRequestTermStddevFields>;
  TelephonyproviderRequestTermStddevPopFields: ResolverTypeWrapper<TelephonyproviderRequestTermStddevPopFields>;
  TelephonyproviderRequestTermStddevSampFields: ResolverTypeWrapper<TelephonyproviderRequestTermStddevSampFields>;
  TelephonyproviderRequestTermStreamCursorInput: TelephonyproviderRequestTermStreamCursorInput;
  TelephonyproviderRequestTermStreamCursorValueInput: TelephonyproviderRequestTermStreamCursorValueInput;
  TelephonyproviderRequestTermSumFields: ResolverTypeWrapper<TelephonyproviderRequestTermSumFields>;
  TelephonyproviderRequestTermUpdateColumn: TelephonyproviderRequestTermUpdateColumn;
  TelephonyproviderRequestTermUpdates: TelephonyproviderRequestTermUpdates;
  TelephonyproviderRequestTermVarPopFields: ResolverTypeWrapper<TelephonyproviderRequestTermVarPopFields>;
  TelephonyproviderRequestTermVarSampFields: ResolverTypeWrapper<TelephonyproviderRequestTermVarSampFields>;
  TelephonyproviderRequestTermVarianceFields: ResolverTypeWrapper<TelephonyproviderRequestTermVarianceFields>;
  TelephonyproviderSelectColumn: TelephonyproviderSelectColumn;
  TelephonyproviderSetInput: TelephonyproviderSetInput;
  TelephonyproviderStreamCursorInput: TelephonyproviderStreamCursorInput;
  TelephonyproviderStreamCursorValueInput: TelephonyproviderStreamCursorValueInput;
  TelephonyproviderUpdateColumn: TelephonyproviderUpdateColumn;
  TelephonyproviderUpdates: TelephonyproviderUpdates;
  TelephonytelephonyEventsAggregateBoolExpCount: TelephonytelephonyEventsAggregateBoolExpCount;
  Telephonytimestamptz: ResolverTypeWrapper<Scalars['Telephonytimestamptz']['output']>;
  TelephonytriggerTestCallOutput: ResolverTypeWrapper<TelephonytriggerTestCallOutput>;
  TimestampComparisonExp: TimestampComparisonExp;
  TimestamptzArrayComparisonExp: TimestamptzArrayComparisonExp;
  TimestamptzComparisonExp: TimestamptzComparisonExp;
  TimetzComparisonExp: TimetzComparisonExp;
  UserAndOrgInput: UserAndOrgInput;
  UserDetailsTypeEnumComparisonExp: UserDetailsTypeEnumComparisonExp;
  UserOrgOutput: ResolverTypeWrapper<UserOrgOutput>;
  UserRoleEnumComparisonExp: UserRoleEnumComparisonExp;
  UserUpdateInput: UserUpdateInput;
  UserUpdateOutput: ResolverTypeWrapper<UserUpdateOutput>;
  UuidComparisonExp: UuidComparisonExp;
  VerificationOutput: ResolverTypeWrapper<VerificationOutput>;
  VoiceTypes: ResolverTypeWrapper<VoiceTypes>;
  VoiceTypesAggregate: ResolverTypeWrapper<VoiceTypesAggregate>;
  VoiceTypesAggregateFields: ResolverTypeWrapper<VoiceTypesAggregateFields>;
  VoiceTypesBoolExp: VoiceTypesBoolExp;
  VoiceTypesConstraint: VoiceTypesConstraint;
  VoiceTypesEnum: VoiceTypesEnum;
  VoiceTypesEnumComparisonExp: VoiceTypesEnumComparisonExp;
  VoiceTypesInsertInput: VoiceTypesInsertInput;
  VoiceTypesMaxFields: ResolverTypeWrapper<VoiceTypesMaxFields>;
  VoiceTypesMinFields: ResolverTypeWrapper<VoiceTypesMinFields>;
  VoiceTypesMutationResponse: ResolverTypeWrapper<VoiceTypesMutationResponse>;
  VoiceTypesOnConflict: VoiceTypesOnConflict;
  VoiceTypesOrderBy: VoiceTypesOrderBy;
  VoiceTypesPkColumnsInput: VoiceTypesPkColumnsInput;
  VoiceTypesSelectColumn: VoiceTypesSelectColumn;
  VoiceTypesSetInput: VoiceTypesSetInput;
  VoiceTypesStreamCursorInput: VoiceTypesStreamCursorInput;
  VoiceTypesStreamCursorValueInput: VoiceTypesStreamCursorValueInput;
  VoiceTypesUpdateColumn: VoiceTypesUpdateColumn;
  VoiceTypesUpdates: VoiceTypesUpdates;
  acceptInviteObject: acceptInviteObject;
  acceptInviteOutput: ResolverTypeWrapper<acceptInviteOutput>;
  acceptRequestObject: acceptRequestObject;
  acceptRequestsOutput: ResolverTypeWrapper<acceptRequestsOutput>;
  activityParticipant: ResolverTypeWrapper<activityParticipant>;
  activityParticipantAggregate: ResolverTypeWrapper<activityParticipantAggregate>;
  activityParticipantAggregateBoolExp: activityParticipantAggregateBoolExp;
  activityParticipantAggregateBoolExpBool_and: activityParticipantAggregateBoolExpBool_and;
  activityParticipantAggregateBoolExpBool_or: activityParticipantAggregateBoolExpBool_or;
  activityParticipantAggregateBoolExpCount: activityParticipantAggregateBoolExpCount;
  activityParticipantAggregateFields: ResolverTypeWrapper<activityParticipantAggregateFields>;
  activityParticipantAggregateOrderBy: activityParticipantAggregateOrderBy;
  activityParticipantArrRelInsertInput: activityParticipantArrRelInsertInput;
  activityParticipantBoolExp: activityParticipantBoolExp;
  activityParticipantConstraint: activityParticipantConstraint;
  activityParticipantInsertInput: activityParticipantInsertInput;
  activityParticipantMaxFields: ResolverTypeWrapper<activityParticipantMaxFields>;
  activityParticipantMaxOrderBy: activityParticipantMaxOrderBy;
  activityParticipantMinFields: ResolverTypeWrapper<activityParticipantMinFields>;
  activityParticipantMinOrderBy: activityParticipantMinOrderBy;
  activityParticipantMutationResponse: ResolverTypeWrapper<activityParticipantMutationResponse>;
  activityParticipantOnConflict: activityParticipantOnConflict;
  activityParticipantOrderBy: activityParticipantOrderBy;
  activityParticipantPkColumnsInput: activityParticipantPkColumnsInput;
  activityParticipantSelectColumn: activityParticipantSelectColumn;
  activityParticipantSelectColumnActivityParticipantAggregateBoolExpBool_andArgumentsColumns: activityParticipantSelectColumnActivityParticipantAggregateBoolExpBool_andArgumentsColumns;
  activityParticipantSelectColumnActivityParticipantAggregateBoolExpBool_orArgumentsColumns: activityParticipantSelectColumnActivityParticipantAggregateBoolExpBool_orArgumentsColumns;
  activityParticipantSetInput: activityParticipantSetInput;
  activityParticipantStreamCursorInput: activityParticipantStreamCursorInput;
  activityParticipantStreamCursorValueInput: activityParticipantStreamCursorValueInput;
  activityParticipantUpdateColumn: activityParticipantUpdateColumn;
  activityParticipantUpdates: activityParticipantUpdates;
  activityTaskInput: activityTaskInput;
  activityTaskOutput: ResolverTypeWrapper<activityTaskOutput>;
  address: ResolverTypeWrapper<address>;
  addressAggregate: ResolverTypeWrapper<addressAggregate>;
  addressAggregateBoolExp: addressAggregateBoolExp;
  addressAggregateBoolExpCount: addressAggregateBoolExpCount;
  addressAggregateFields: ResolverTypeWrapper<addressAggregateFields>;
  addressAggregateOrderBy: addressAggregateOrderBy;
  addressArrRelInsertInput: addressArrRelInsertInput;
  addressBoolExp: addressBoolExp;
  addressConstraint: addressConstraint;
  addressInsertInput: addressInsertInput;
  addressMaxFields: ResolverTypeWrapper<addressMaxFields>;
  addressMaxOrderBy: addressMaxOrderBy;
  addressMinFields: ResolverTypeWrapper<addressMinFields>;
  addressMinOrderBy: addressMinOrderBy;
  addressMutationResponse: ResolverTypeWrapper<addressMutationResponse>;
  addressObjRelInsertInput: addressObjRelInsertInput;
  addressOnConflict: addressOnConflict;
  addressOrderBy: addressOrderBy;
  addressPkColumnsInput: addressPkColumnsInput;
  addressSelectColumn: addressSelectColumn;
  addressSetInput: addressSetInput;
  addressStreamCursorInput: addressStreamCursorInput;
  addressStreamCursorValueInput: addressStreamCursorValueInput;
  addressUpdateColumn: addressUpdateColumn;
  addressUpdates: addressUpdates;
  blockedDomainUser: ResolverTypeWrapper<blockedDomainUser>;
  blockedDomainUserAggregate: ResolverTypeWrapper<blockedDomainUserAggregate>;
  blockedDomainUserAggregateFields: ResolverTypeWrapper<blockedDomainUserAggregateFields>;
  blockedDomainUserBoolExp: blockedDomainUserBoolExp;
  blockedDomainUserConstraint: blockedDomainUserConstraint;
  blockedDomainUserInsertInput: blockedDomainUserInsertInput;
  blockedDomainUserMaxFields: ResolverTypeWrapper<blockedDomainUserMaxFields>;
  blockedDomainUserMinFields: ResolverTypeWrapper<blockedDomainUserMinFields>;
  blockedDomainUserMutationResponse: ResolverTypeWrapper<blockedDomainUserMutationResponse>;
  blockedDomainUserOnConflict: blockedDomainUserOnConflict;
  blockedDomainUserOrderBy: blockedDomainUserOrderBy;
  blockedDomainUserPkColumnsInput: blockedDomainUserPkColumnsInput;
  blockedDomainUserSelectColumn: blockedDomainUserSelectColumn;
  blockedDomainUserSetInput: blockedDomainUserSetInput;
  blockedDomainUserStreamCursorInput: blockedDomainUserStreamCursorInput;
  blockedDomainUserStreamCursorValueInput: blockedDomainUserStreamCursorValueInput;
  blockedDomainUserUpdateColumn: blockedDomainUserUpdateColumn;
  blockedDomainUserUpdates: blockedDomainUserUpdates;
  bregmutation_root: ResolverTypeWrapper<bregmutation_root>;
  bregquery_root: ResolverTypeWrapper<bregquery_root>;
  bregsubscription_root: ResolverTypeWrapper<bregsubscription_root>;
  businessMessageAttachmentsAggregateBoolExpCount: businessMessageAttachmentsAggregateBoolExpCount;
  businessOrganizationUserEmailAggregateBoolExpBool_and: businessOrganizationUserEmailAggregateBoolExpBool_and;
  businessOrganizationUserEmailAggregateBoolExpBool_or: businessOrganizationUserEmailAggregateBoolExpBool_or;
  businessOrganizationUserEmailAggregateBoolExpCount: businessOrganizationUserEmailAggregateBoolExpCount;
  businessOrganizationUserRequestAggregateBoolExpBool_and: businessOrganizationUserRequestAggregateBoolExpBool_and;
  businessOrganizationUserRequestAggregateBoolExpBool_or: businessOrganizationUserRequestAggregateBoolExpBool_or;
  businessOrganizationUserRequestAggregateBoolExpCount: businessOrganizationUserRequestAggregateBoolExpCount;
  businessOrganizationUserUrlAddressAggregateBoolExpCount: businessOrganizationUserUrlAddressAggregateBoolExpCount;
  businessQueueItemAlarmsAggregateBoolExpCount: businessQueueItemAlarmsAggregateBoolExpCount;
  businessQueueItemCollaboration: ResolverTypeWrapper<businessQueueItemCollaboration>;
  businessQueueItemCollaborationAggregate: ResolverTypeWrapper<businessQueueItemCollaborationAggregate>;
  businessQueueItemCollaborationAggregateBoolExp: businessQueueItemCollaborationAggregateBoolExp;
  businessQueueItemCollaborationAggregateBoolExpBool_and: businessQueueItemCollaborationAggregateBoolExpBool_and;
  businessQueueItemCollaborationAggregateBoolExpBool_or: businessQueueItemCollaborationAggregateBoolExpBool_or;
  businessQueueItemCollaborationAggregateBoolExpCount: businessQueueItemCollaborationAggregateBoolExpCount;
  businessQueueItemCollaborationAggregateFields: ResolverTypeWrapper<businessQueueItemCollaborationAggregateFields>;
  businessQueueItemCollaborationAggregateOrderBy: businessQueueItemCollaborationAggregateOrderBy;
  businessQueueItemCollaborationArrRelInsertInput: businessQueueItemCollaborationArrRelInsertInput;
  businessQueueItemCollaborationAvgFields: ResolverTypeWrapper<businessQueueItemCollaborationAvgFields>;
  businessQueueItemCollaborationAvgOrderBy: businessQueueItemCollaborationAvgOrderBy;
  businessQueueItemCollaborationBoolExp: businessQueueItemCollaborationBoolExp;
  businessQueueItemCollaborationConstraint: businessQueueItemCollaborationConstraint;
  businessQueueItemCollaborationIncInput: businessQueueItemCollaborationIncInput;
  businessQueueItemCollaborationInsertInput: businessQueueItemCollaborationInsertInput;
  businessQueueItemCollaborationMaxFields: ResolverTypeWrapper<businessQueueItemCollaborationMaxFields>;
  businessQueueItemCollaborationMaxOrderBy: businessQueueItemCollaborationMaxOrderBy;
  businessQueueItemCollaborationMinFields: ResolverTypeWrapper<businessQueueItemCollaborationMinFields>;
  businessQueueItemCollaborationMinOrderBy: businessQueueItemCollaborationMinOrderBy;
  businessQueueItemCollaborationMutationResponse: ResolverTypeWrapper<businessQueueItemCollaborationMutationResponse>;
  businessQueueItemCollaborationOnConflict: businessQueueItemCollaborationOnConflict;
  businessQueueItemCollaborationOrderBy: businessQueueItemCollaborationOrderBy;
  businessQueueItemCollaborationPkColumnsInput: businessQueueItemCollaborationPkColumnsInput;
  businessQueueItemCollaborationSelectColumn: businessQueueItemCollaborationSelectColumn;
  businessQueueItemCollaborationSelectColumnBusinessQueueItemCollaborationAggregateBoolExpBool_andArgumentsColumns: businessQueueItemCollaborationSelectColumnBusinessQueueItemCollaborationAggregateBoolExpBool_andArgumentsColumns;
  businessQueueItemCollaborationSelectColumnBusinessQueueItemCollaborationAggregateBoolExpBool_orArgumentsColumns: businessQueueItemCollaborationSelectColumnBusinessQueueItemCollaborationAggregateBoolExpBool_orArgumentsColumns;
  businessQueueItemCollaborationSetInput: businessQueueItemCollaborationSetInput;
  businessQueueItemCollaborationStddevFields: ResolverTypeWrapper<businessQueueItemCollaborationStddevFields>;
  businessQueueItemCollaborationStddevOrderBy: businessQueueItemCollaborationStddevOrderBy;
  businessQueueItemCollaborationStddevPopFields: ResolverTypeWrapper<businessQueueItemCollaborationStddevPopFields>;
  businessQueueItemCollaborationStddevPopOrderBy: businessQueueItemCollaborationStddevPopOrderBy;
  businessQueueItemCollaborationStddevSampFields: ResolverTypeWrapper<businessQueueItemCollaborationStddevSampFields>;
  businessQueueItemCollaborationStddevSampOrderBy: businessQueueItemCollaborationStddevSampOrderBy;
  businessQueueItemCollaborationStreamCursorInput: businessQueueItemCollaborationStreamCursorInput;
  businessQueueItemCollaborationStreamCursorValueInput: businessQueueItemCollaborationStreamCursorValueInput;
  businessQueueItemCollaborationSumFields: ResolverTypeWrapper<businessQueueItemCollaborationSumFields>;
  businessQueueItemCollaborationSumOrderBy: businessQueueItemCollaborationSumOrderBy;
  businessQueueItemCollaborationUpdateColumn: businessQueueItemCollaborationUpdateColumn;
  businessQueueItemCollaborationUpdates: businessQueueItemCollaborationUpdates;
  businessQueueItemCollaborationVarPopFields: ResolverTypeWrapper<businessQueueItemCollaborationVarPopFields>;
  businessQueueItemCollaborationVarPopOrderBy: businessQueueItemCollaborationVarPopOrderBy;
  businessQueueItemCollaborationVarSampFields: ResolverTypeWrapper<businessQueueItemCollaborationVarSampFields>;
  businessQueueItemCollaborationVarSampOrderBy: businessQueueItemCollaborationVarSampOrderBy;
  businessQueueItemCollaborationVarianceFields: ResolverTypeWrapper<businessQueueItemCollaborationVarianceFields>;
  businessQueueItemCollaborationVarianceOrderBy: businessQueueItemCollaborationVarianceOrderBy;
  businessQueueItemDomainUsersViewAggregateBoolExpCount: businessQueueItemDomainUsersViewAggregateBoolExpCount;
  businessQueueItemOrganizationUsersViewAggregateBoolExpCount: businessQueueItemOrganizationUsersViewAggregateBoolExpCount;
  businessQueueItemParticipantsViewAggregateBoolExpCount: businessQueueItemParticipantsViewAggregateBoolExpCount;
  businessUserContactNumbersAggregateBoolExpBool_and: businessUserContactNumbersAggregateBoolExpBool_and;
  businessUserContactNumbersAggregateBoolExpBool_or: businessUserContactNumbersAggregateBoolExpBool_or;
  businessUserContactNumbersAggregateBoolExpCount: businessUserContactNumbersAggregateBoolExpCount;
  businessUserContacts: ResolverTypeWrapper<businessUserContacts>;
  businessUserContactsAggregate: ResolverTypeWrapper<businessUserContactsAggregate>;
  businessUserContactsAggregateFields: ResolverTypeWrapper<businessUserContactsAggregateFields>;
  businessUserContactsBoolExp: businessUserContactsBoolExp;
  businessUserContactsConstraint: businessUserContactsConstraint;
  businessUserContactsInsertInput: businessUserContactsInsertInput;
  businessUserContactsMaxFields: ResolverTypeWrapper<businessUserContactsMaxFields>;
  businessUserContactsMinFields: ResolverTypeWrapper<businessUserContactsMinFields>;
  businessUserContactsMutationResponse: ResolverTypeWrapper<businessUserContactsMutationResponse>;
  businessUserContactsObjRelInsertInput: businessUserContactsObjRelInsertInput;
  businessUserContactsOnConflict: businessUserContactsOnConflict;
  businessUserContactsOrderBy: businessUserContactsOrderBy;
  businessUserContactsPkColumnsInput: businessUserContactsPkColumnsInput;
  businessUserContactsSelectColumn: businessUserContactsSelectColumn;
  businessUserContactsSetInput: businessUserContactsSetInput;
  businessUserContactsStreamCursorInput: businessUserContactsStreamCursorInput;
  businessUserContactsStreamCursorValueInput: businessUserContactsStreamCursorValueInput;
  businessUserContactsUpdateColumn: businessUserContactsUpdateColumn;
  businessUserContactsUpdates: businessUserContactsUpdates;
  businessUserFeedAggregateBoolExpBool_and: businessUserFeedAggregateBoolExpBool_and;
  businessUserFeedAggregateBoolExpBool_or: businessUserFeedAggregateBoolExpBool_or;
  businessUserFeedAggregateBoolExpCount: businessUserFeedAggregateBoolExpCount;
  businessUserSettings: ResolverTypeWrapper<businessUserSettings>;
  businessUserSettingsAggregate: ResolverTypeWrapper<businessUserSettingsAggregate>;
  businessUserSettingsAggregateFields: ResolverTypeWrapper<businessUserSettingsAggregateFields>;
  businessUserSettingsAvgFields: ResolverTypeWrapper<businessUserSettingsAvgFields>;
  businessUserSettingsBoolExp: businessUserSettingsBoolExp;
  businessUserSettingsConstraint: businessUserSettingsConstraint;
  businessUserSettingsIncInput: businessUserSettingsIncInput;
  businessUserSettingsInsertInput: businessUserSettingsInsertInput;
  businessUserSettingsMaxFields: ResolverTypeWrapper<businessUserSettingsMaxFields>;
  businessUserSettingsMinFields: ResolverTypeWrapper<businessUserSettingsMinFields>;
  businessUserSettingsMutationResponse: ResolverTypeWrapper<businessUserSettingsMutationResponse>;
  businessUserSettingsOnConflict: businessUserSettingsOnConflict;
  businessUserSettingsOrderBy: businessUserSettingsOrderBy;
  businessUserSettingsPkColumnsInput: businessUserSettingsPkColumnsInput;
  businessUserSettingsSelectColumn: businessUserSettingsSelectColumn;
  businessUserSettingsSetInput: businessUserSettingsSetInput;
  businessUserSettingsStddevFields: ResolverTypeWrapper<businessUserSettingsStddevFields>;
  businessUserSettingsStddevPopFields: ResolverTypeWrapper<businessUserSettingsStddevPopFields>;
  businessUserSettingsStddevSampFields: ResolverTypeWrapper<businessUserSettingsStddevSampFields>;
  businessUserSettingsStreamCursorInput: businessUserSettingsStreamCursorInput;
  businessUserSettingsStreamCursorValueInput: businessUserSettingsStreamCursorValueInput;
  businessUserSettingsSumFields: ResolverTypeWrapper<businessUserSettingsSumFields>;
  businessUserSettingsUpdateColumn: businessUserSettingsUpdateColumn;
  businessUserSettingsUpdates: businessUserSettingsUpdates;
  businessUserSettingsVarPopFields: ResolverTypeWrapper<businessUserSettingsVarPopFields>;
  businessUserSettingsVarSampFields: ResolverTypeWrapper<businessUserSettingsVarSampFields>;
  businessUserSettingsVarianceFields: ResolverTypeWrapper<businessUserSettingsVarianceFields>;
  businessUserStatesAggregateBoolExpCount: businessUserStatesAggregateBoolExpCount;
  callBackLaterResult: ResolverTypeWrapper<callBackLaterResult>;
  checkTelephonyIdOutput: ResolverTypeWrapper<checkTelephonyIdOutput>;
  createEmailProviderIntegrationAccount: createEmailProviderIntegrationAccount;
  createEmailProviderIntegrationInput: createEmailProviderIntegrationInput;
  createEmailProviderSubscriptionInput: createEmailProviderSubscriptionInput;
  createEmailProviderSubscriptionOutput: ResolverTypeWrapper<createEmailProviderSubscriptionOutput>;
  createMessagingGroupOutput: ResolverTypeWrapper<createMessagingGroupOutput>;
  createPhoneroOrgUserInput: createPhoneroOrgUserInput;
  createPhoneroOrgUsersOutput: ResolverTypeWrapper<createPhoneroOrgUsersOutput>;
  createRoomOutput: ResolverTypeWrapper<createRoomOutput>;
  crmStatusMessage: ResolverTypeWrapper<crmStatusMessage>;
  crmStatusMessageAggregate: ResolverTypeWrapper<crmStatusMessageAggregate>;
  crmStatusMessageAggregateFields: ResolverTypeWrapper<crmStatusMessageAggregateFields>;
  crmStatusMessageAppendInput: crmStatusMessageAppendInput;
  crmStatusMessageAvgFields: ResolverTypeWrapper<crmStatusMessageAvgFields>;
  crmStatusMessageBoolExp: crmStatusMessageBoolExp;
  crmStatusMessageConstraint: crmStatusMessageConstraint;
  crmStatusMessageDeleteAtPathInput: crmStatusMessageDeleteAtPathInput;
  crmStatusMessageDeleteElemInput: crmStatusMessageDeleteElemInput;
  crmStatusMessageDeleteKeyInput: crmStatusMessageDeleteKeyInput;
  crmStatusMessageIncInput: crmStatusMessageIncInput;
  crmStatusMessageInsertInput: crmStatusMessageInsertInput;
  crmStatusMessageMaxFields: ResolverTypeWrapper<crmStatusMessageMaxFields>;
  crmStatusMessageMinFields: ResolverTypeWrapper<crmStatusMessageMinFields>;
  crmStatusMessageMutationResponse: ResolverTypeWrapper<crmStatusMessageMutationResponse>;
  crmStatusMessageOnConflict: crmStatusMessageOnConflict;
  crmStatusMessageOrderBy: crmStatusMessageOrderBy;
  crmStatusMessagePkColumnsInput: crmStatusMessagePkColumnsInput;
  crmStatusMessagePrependInput: crmStatusMessagePrependInput;
  crmStatusMessageSelectColumn: crmStatusMessageSelectColumn;
  crmStatusMessageSetInput: crmStatusMessageSetInput;
  crmStatusMessageStddevFields: ResolverTypeWrapper<crmStatusMessageStddevFields>;
  crmStatusMessageStddevPopFields: ResolverTypeWrapper<crmStatusMessageStddevPopFields>;
  crmStatusMessageStddevSampFields: ResolverTypeWrapper<crmStatusMessageStddevSampFields>;
  crmStatusMessageStreamCursorInput: crmStatusMessageStreamCursorInput;
  crmStatusMessageStreamCursorValueInput: crmStatusMessageStreamCursorValueInput;
  crmStatusMessageSumFields: ResolverTypeWrapper<crmStatusMessageSumFields>;
  crmStatusMessageUpdateColumn: crmStatusMessageUpdateColumn;
  crmStatusMessageUpdates: crmStatusMessageUpdates;
  crmStatusMessageVarPopFields: ResolverTypeWrapper<crmStatusMessageVarPopFields>;
  crmStatusMessageVarSampFields: ResolverTypeWrapper<crmStatusMessageVarSampFields>;
  crmStatusMessageVarianceFields: ResolverTypeWrapper<crmStatusMessageVarianceFields>;
  crmYoutelloCatalystIdMapping: ResolverTypeWrapper<crmYoutelloCatalystIdMapping>;
  crmYoutelloCatalystIdMappingAggregate: ResolverTypeWrapper<crmYoutelloCatalystIdMappingAggregate>;
  crmYoutelloCatalystIdMappingAggregateBoolExp: crmYoutelloCatalystIdMappingAggregateBoolExp;
  crmYoutelloCatalystIdMappingAggregateBoolExpCount: crmYoutelloCatalystIdMappingAggregateBoolExpCount;
  crmYoutelloCatalystIdMappingAggregateFields: ResolverTypeWrapper<crmYoutelloCatalystIdMappingAggregateFields>;
  crmYoutelloCatalystIdMappingAggregateOrderBy: crmYoutelloCatalystIdMappingAggregateOrderBy;
  crmYoutelloCatalystIdMappingArrRelInsertInput: crmYoutelloCatalystIdMappingArrRelInsertInput;
  crmYoutelloCatalystIdMappingAvgFields: ResolverTypeWrapper<crmYoutelloCatalystIdMappingAvgFields>;
  crmYoutelloCatalystIdMappingAvgOrderBy: crmYoutelloCatalystIdMappingAvgOrderBy;
  crmYoutelloCatalystIdMappingBoolExp: crmYoutelloCatalystIdMappingBoolExp;
  crmYoutelloCatalystIdMappingConstraint: crmYoutelloCatalystIdMappingConstraint;
  crmYoutelloCatalystIdMappingIncInput: crmYoutelloCatalystIdMappingIncInput;
  crmYoutelloCatalystIdMappingInsertInput: crmYoutelloCatalystIdMappingInsertInput;
  crmYoutelloCatalystIdMappingMaxFields: ResolverTypeWrapper<crmYoutelloCatalystIdMappingMaxFields>;
  crmYoutelloCatalystIdMappingMaxOrderBy: crmYoutelloCatalystIdMappingMaxOrderBy;
  crmYoutelloCatalystIdMappingMinFields: ResolverTypeWrapper<crmYoutelloCatalystIdMappingMinFields>;
  crmYoutelloCatalystIdMappingMinOrderBy: crmYoutelloCatalystIdMappingMinOrderBy;
  crmYoutelloCatalystIdMappingMutationResponse: ResolverTypeWrapper<crmYoutelloCatalystIdMappingMutationResponse>;
  crmYoutelloCatalystIdMappingOnConflict: crmYoutelloCatalystIdMappingOnConflict;
  crmYoutelloCatalystIdMappingOrderBy: crmYoutelloCatalystIdMappingOrderBy;
  crmYoutelloCatalystIdMappingPkColumnsInput: crmYoutelloCatalystIdMappingPkColumnsInput;
  crmYoutelloCatalystIdMappingSelectColumn: crmYoutelloCatalystIdMappingSelectColumn;
  crmYoutelloCatalystIdMappingSetInput: crmYoutelloCatalystIdMappingSetInput;
  crmYoutelloCatalystIdMappingStddevFields: ResolverTypeWrapper<crmYoutelloCatalystIdMappingStddevFields>;
  crmYoutelloCatalystIdMappingStddevOrderBy: crmYoutelloCatalystIdMappingStddevOrderBy;
  crmYoutelloCatalystIdMappingStddevPopFields: ResolverTypeWrapper<crmYoutelloCatalystIdMappingStddevPopFields>;
  crmYoutelloCatalystIdMappingStddevPopOrderBy: crmYoutelloCatalystIdMappingStddevPopOrderBy;
  crmYoutelloCatalystIdMappingStddevSampFields: ResolverTypeWrapper<crmYoutelloCatalystIdMappingStddevSampFields>;
  crmYoutelloCatalystIdMappingStddevSampOrderBy: crmYoutelloCatalystIdMappingStddevSampOrderBy;
  crmYoutelloCatalystIdMappingStreamCursorInput: crmYoutelloCatalystIdMappingStreamCursorInput;
  crmYoutelloCatalystIdMappingStreamCursorValueInput: crmYoutelloCatalystIdMappingStreamCursorValueInput;
  crmYoutelloCatalystIdMappingSumFields: ResolverTypeWrapper<crmYoutelloCatalystIdMappingSumFields>;
  crmYoutelloCatalystIdMappingSumOrderBy: crmYoutelloCatalystIdMappingSumOrderBy;
  crmYoutelloCatalystIdMappingUpdateColumn: crmYoutelloCatalystIdMappingUpdateColumn;
  crmYoutelloCatalystIdMappingUpdates: crmYoutelloCatalystIdMappingUpdates;
  crmYoutelloCatalystIdMappingVarPopFields: ResolverTypeWrapper<crmYoutelloCatalystIdMappingVarPopFields>;
  crmYoutelloCatalystIdMappingVarPopOrderBy: crmYoutelloCatalystIdMappingVarPopOrderBy;
  crmYoutelloCatalystIdMappingVarSampFields: ResolverTypeWrapper<crmYoutelloCatalystIdMappingVarSampFields>;
  crmYoutelloCatalystIdMappingVarSampOrderBy: crmYoutelloCatalystIdMappingVarSampOrderBy;
  crmYoutelloCatalystIdMappingVarianceFields: ResolverTypeWrapper<crmYoutelloCatalystIdMappingVarianceFields>;
  crmYoutelloCatalystIdMappingVarianceOrderBy: crmYoutelloCatalystIdMappingVarianceOrderBy;
  dashboardDataOutput: ResolverTypeWrapper<dashboardDataOutput>;
  deleteEmailProviderSubscriptionInput: deleteEmailProviderSubscriptionInput;
  deleteEmailProviderSubscriptionOutput: ResolverTypeWrapper<deleteEmailProviderSubscriptionOutput>;
  domainActivity: ResolverTypeWrapper<domainActivity>;
  domainActivityAggregate: ResolverTypeWrapper<domainActivityAggregate>;
  domainActivityAggregateBoolExp: domainActivityAggregateBoolExp;
  domainActivityAggregateBoolExpCount: domainActivityAggregateBoolExpCount;
  domainActivityAggregateFields: ResolverTypeWrapper<domainActivityAggregateFields>;
  domainActivityAggregateOrderBy: domainActivityAggregateOrderBy;
  domainActivityAppendInput: domainActivityAppendInput;
  domainActivityArrRelInsertInput: domainActivityArrRelInsertInput;
  domainActivityAvgFields: ResolverTypeWrapper<domainActivityAvgFields>;
  domainActivityAvgOrderBy: domainActivityAvgOrderBy;
  domainActivityBoolExp: domainActivityBoolExp;
  domainActivityConstraint: domainActivityConstraint;
  domainActivityDeleteAtPathInput: domainActivityDeleteAtPathInput;
  domainActivityDeleteElemInput: domainActivityDeleteElemInput;
  domainActivityDeleteKeyInput: domainActivityDeleteKeyInput;
  domainActivityIncInput: domainActivityIncInput;
  domainActivityInsertInput: domainActivityInsertInput;
  domainActivityMaxFields: ResolverTypeWrapper<domainActivityMaxFields>;
  domainActivityMaxOrderBy: domainActivityMaxOrderBy;
  domainActivityMinFields: ResolverTypeWrapper<domainActivityMinFields>;
  domainActivityMinOrderBy: domainActivityMinOrderBy;
  domainActivityMutationResponse: ResolverTypeWrapper<domainActivityMutationResponse>;
  domainActivityObjRelInsertInput: domainActivityObjRelInsertInput;
  domainActivityOnConflict: domainActivityOnConflict;
  domainActivityOrderBy: domainActivityOrderBy;
  domainActivityPkColumnsInput: domainActivityPkColumnsInput;
  domainActivityPrependInput: domainActivityPrependInput;
  domainActivitySelectColumn: domainActivitySelectColumn;
  domainActivitySetInput: domainActivitySetInput;
  domainActivityStddevFields: ResolverTypeWrapper<domainActivityStddevFields>;
  domainActivityStddevOrderBy: domainActivityStddevOrderBy;
  domainActivityStddevPopFields: ResolverTypeWrapper<domainActivityStddevPopFields>;
  domainActivityStddevPopOrderBy: domainActivityStddevPopOrderBy;
  domainActivityStddevSampFields: ResolverTypeWrapper<domainActivityStddevSampFields>;
  domainActivityStddevSampOrderBy: domainActivityStddevSampOrderBy;
  domainActivityStreamCursorInput: domainActivityStreamCursorInput;
  domainActivityStreamCursorValueInput: domainActivityStreamCursorValueInput;
  domainActivitySumFields: ResolverTypeWrapper<domainActivitySumFields>;
  domainActivitySumOrderBy: domainActivitySumOrderBy;
  domainActivityUpdateColumn: domainActivityUpdateColumn;
  domainActivityUpdates: domainActivityUpdates;
  domainActivityVarPopFields: ResolverTypeWrapper<domainActivityVarPopFields>;
  domainActivityVarPopOrderBy: domainActivityVarPopOrderBy;
  domainActivityVarSampFields: ResolverTypeWrapper<domainActivityVarSampFields>;
  domainActivityVarSampOrderBy: domainActivityVarSampOrderBy;
  domainActivityVarianceFields: ResolverTypeWrapper<domainActivityVarianceFields>;
  domainActivityVarianceOrderBy: domainActivityVarianceOrderBy;
  domainOrganization: ResolverTypeWrapper<domainOrganization>;
  domainOrganizationAggregate: ResolverTypeWrapper<domainOrganizationAggregate>;
  domainOrganizationAggregateBoolExp: domainOrganizationAggregateBoolExp;
  domainOrganizationAggregateBoolExpBool_and: domainOrganizationAggregateBoolExpBool_and;
  domainOrganizationAggregateBoolExpBool_or: domainOrganizationAggregateBoolExpBool_or;
  domainOrganizationAggregateBoolExpCount: domainOrganizationAggregateBoolExpCount;
  domainOrganizationAggregateFields: ResolverTypeWrapper<domainOrganizationAggregateFields>;
  domainOrganizationAggregateOrderBy: domainOrganizationAggregateOrderBy;
  domainOrganizationArrRelInsertInput: domainOrganizationArrRelInsertInput;
  domainOrganizationBoolExp: domainOrganizationBoolExp;
  domainOrganizationConstraint: domainOrganizationConstraint;
  domainOrganizationInsertInput: domainOrganizationInsertInput;
  domainOrganizationMaxFields: ResolverTypeWrapper<domainOrganizationMaxFields>;
  domainOrganizationMaxOrderBy: domainOrganizationMaxOrderBy;
  domainOrganizationMinFields: ResolverTypeWrapper<domainOrganizationMinFields>;
  domainOrganizationMinOrderBy: domainOrganizationMinOrderBy;
  domainOrganizationMutationResponse: ResolverTypeWrapper<domainOrganizationMutationResponse>;
  domainOrganizationObjRelInsertInput: domainOrganizationObjRelInsertInput;
  domainOrganizationOnConflict: domainOrganizationOnConflict;
  domainOrganizationOrderBy: domainOrganizationOrderBy;
  domainOrganizationPkColumnsInput: domainOrganizationPkColumnsInput;
  domainOrganizationSelectColumn: domainOrganizationSelectColumn;
  domainOrganizationSelectColumnDomainOrganizationAggregateBoolExpBool_andArgumentsColumns: domainOrganizationSelectColumnDomainOrganizationAggregateBoolExpBool_andArgumentsColumns;
  domainOrganizationSelectColumnDomainOrganizationAggregateBoolExpBool_orArgumentsColumns: domainOrganizationSelectColumnDomainOrganizationAggregateBoolExpBool_orArgumentsColumns;
  domainOrganizationSetInput: domainOrganizationSetInput;
  domainOrganizationStreamCursorInput: domainOrganizationStreamCursorInput;
  domainOrganizationStreamCursorValueInput: domainOrganizationStreamCursorValueInput;
  domainOrganizationUpdateColumn: domainOrganizationUpdateColumn;
  domainOrganizationUpdates: domainOrganizationUpdates;
  domainParticipant: ResolverTypeWrapper<domainParticipant>;
  domainParticipantAggregate: ResolverTypeWrapper<domainParticipantAggregate>;
  domainParticipantAggregateBoolExp: domainParticipantAggregateBoolExp;
  domainParticipantAggregateBoolExpCount: domainParticipantAggregateBoolExpCount;
  domainParticipantAggregateFields: ResolverTypeWrapper<domainParticipantAggregateFields>;
  domainParticipantAggregateOrderBy: domainParticipantAggregateOrderBy;
  domainParticipantArrRelInsertInput: domainParticipantArrRelInsertInput;
  domainParticipantBoolExp: domainParticipantBoolExp;
  domainParticipantConstraint: domainParticipantConstraint;
  domainParticipantInsertInput: domainParticipantInsertInput;
  domainParticipantMaxFields: ResolverTypeWrapper<domainParticipantMaxFields>;
  domainParticipantMaxOrderBy: domainParticipantMaxOrderBy;
  domainParticipantMinFields: ResolverTypeWrapper<domainParticipantMinFields>;
  domainParticipantMinOrderBy: domainParticipantMinOrderBy;
  domainParticipantMutationResponse: ResolverTypeWrapper<domainParticipantMutationResponse>;
  domainParticipantOnConflict: domainParticipantOnConflict;
  domainParticipantOrderBy: domainParticipantOrderBy;
  domainParticipantPkColumnsInput: domainParticipantPkColumnsInput;
  domainParticipantSelectColumn: domainParticipantSelectColumn;
  domainParticipantSetInput: domainParticipantSetInput;
  domainParticipantStreamCursorInput: domainParticipantStreamCursorInput;
  domainParticipantStreamCursorValueInput: domainParticipantStreamCursorValueInput;
  domainParticipantUpdateColumn: domainParticipantUpdateColumn;
  domainParticipantUpdates: domainParticipantUpdates;
  domainType: ResolverTypeWrapper<domainType>;
  domainTypeAggregate: ResolverTypeWrapper<domainTypeAggregate>;
  domainTypeAggregateFields: ResolverTypeWrapper<domainTypeAggregateFields>;
  domainTypeBoolExp: domainTypeBoolExp;
  domainTypeConstraint: domainTypeConstraint;
  domainTypeEnum: domainTypeEnum;
  domainTypeInsertInput: domainTypeInsertInput;
  domainTypeMaxFields: ResolverTypeWrapper<domainTypeMaxFields>;
  domainTypeMinFields: ResolverTypeWrapper<domainTypeMinFields>;
  domainTypeMutationResponse: ResolverTypeWrapper<domainTypeMutationResponse>;
  domainTypeObjRelInsertInput: domainTypeObjRelInsertInput;
  domainTypeOnConflict: domainTypeOnConflict;
  domainTypeOrderBy: domainTypeOrderBy;
  domainTypePkColumnsInput: domainTypePkColumnsInput;
  domainTypeSelectColumn: domainTypeSelectColumn;
  domainTypeSetInput: domainTypeSetInput;
  domainTypeStreamCursorInput: domainTypeStreamCursorInput;
  domainTypeStreamCursorValueInput: domainTypeStreamCursorValueInput;
  domainTypeUpdateColumn: domainTypeUpdateColumn;
  domainTypeUpdates: domainTypeUpdates;
  domainUser: ResolverTypeWrapper<domainUser>;
  domainUserAggregate: ResolverTypeWrapper<domainUserAggregate>;
  domainUserAggregateBoolExp: domainUserAggregateBoolExp;
  domainUserAggregateBoolExpCount: domainUserAggregateBoolExpCount;
  domainUserAggregateFields: ResolverTypeWrapper<domainUserAggregateFields>;
  domainUserAggregateOrderBy: domainUserAggregateOrderBy;
  domainUserArrRelInsertInput: domainUserArrRelInsertInput;
  domainUserAvgFields: ResolverTypeWrapper<domainUserAvgFields>;
  domainUserAvgOrderBy: domainUserAvgOrderBy;
  domainUserBoolExp: domainUserBoolExp;
  domainUserCategory: ResolverTypeWrapper<domainUserCategory>;
  domainUserCategoryAggregate: ResolverTypeWrapper<domainUserCategoryAggregate>;
  domainUserCategoryAggregateFields: ResolverTypeWrapper<domainUserCategoryAggregateFields>;
  domainUserCategoryBoolExp: domainUserCategoryBoolExp;
  domainUserCategoryConstraint: domainUserCategoryConstraint;
  domainUserCategoryEnum: domainUserCategoryEnum;
  domainUserCategoryInsertInput: domainUserCategoryInsertInput;
  domainUserCategoryMaxFields: ResolverTypeWrapper<domainUserCategoryMaxFields>;
  domainUserCategoryMinFields: ResolverTypeWrapper<domainUserCategoryMinFields>;
  domainUserCategoryMutationResponse: ResolverTypeWrapper<domainUserCategoryMutationResponse>;
  domainUserCategoryObjRelInsertInput: domainUserCategoryObjRelInsertInput;
  domainUserCategoryOnConflict: domainUserCategoryOnConflict;
  domainUserCategoryOrderBy: domainUserCategoryOrderBy;
  domainUserCategoryPkColumnsInput: domainUserCategoryPkColumnsInput;
  domainUserCategorySelectColumn: domainUserCategorySelectColumn;
  domainUserCategorySetInput: domainUserCategorySetInput;
  domainUserCategoryStreamCursorInput: domainUserCategoryStreamCursorInput;
  domainUserCategoryStreamCursorValueInput: domainUserCategoryStreamCursorValueInput;
  domainUserCategoryUpdateColumn: domainUserCategoryUpdateColumn;
  domainUserCategoryUpdates: domainUserCategoryUpdates;
  domainUserConstraint: domainUserConstraint;
  domainUserIncInput: domainUserIncInput;
  domainUserInsertInput: domainUserInsertInput;
  domainUserMaxFields: ResolverTypeWrapper<domainUserMaxFields>;
  domainUserMaxOrderBy: domainUserMaxOrderBy;
  domainUserMinFields: ResolverTypeWrapper<domainUserMinFields>;
  domainUserMinOrderBy: domainUserMinOrderBy;
  domainUserMutationResponse: ResolverTypeWrapper<domainUserMutationResponse>;
  domainUserObjRelInsertInput: domainUserObjRelInsertInput;
  domainUserOnConflict: domainUserOnConflict;
  domainUserOrderBy: domainUserOrderBy;
  domainUserPkColumnsInput: domainUserPkColumnsInput;
  domainUserSelectColumn: domainUserSelectColumn;
  domainUserSetInput: domainUserSetInput;
  domainUserStddevFields: ResolverTypeWrapper<domainUserStddevFields>;
  domainUserStddevOrderBy: domainUserStddevOrderBy;
  domainUserStddevPopFields: ResolverTypeWrapper<domainUserStddevPopFields>;
  domainUserStddevPopOrderBy: domainUserStddevPopOrderBy;
  domainUserStddevSampFields: ResolverTypeWrapper<domainUserStddevSampFields>;
  domainUserStddevSampOrderBy: domainUserStddevSampOrderBy;
  domainUserStreamCursorInput: domainUserStreamCursorInput;
  domainUserStreamCursorValueInput: domainUserStreamCursorValueInput;
  domainUserSumFields: ResolverTypeWrapper<domainUserSumFields>;
  domainUserSumOrderBy: domainUserSumOrderBy;
  domainUserUpdateColumn: domainUserUpdateColumn;
  domainUserUpdates: domainUserUpdates;
  domainUserVarPopFields: ResolverTypeWrapper<domainUserVarPopFields>;
  domainUserVarPopOrderBy: domainUserVarPopOrderBy;
  domainUserVarSampFields: ResolverTypeWrapper<domainUserVarSampFields>;
  domainUserVarSampOrderBy: domainUserVarSampOrderBy;
  domainUserVarianceFields: ResolverTypeWrapper<domainUserVarianceFields>;
  domainUserVarianceOrderBy: domainUserVarianceOrderBy;
  emailDomainUserOutput: ResolverTypeWrapper<emailDomainUserOutput>;
  emailingmutation_root: ResolverTypeWrapper<emailingmutation_root>;
  emailingquery_root: ResolverTypeWrapper<emailingquery_root>;
  emailingsubscription_root: ResolverTypeWrapper<emailingsubscription_root>;
  fileOutput: ResolverTypeWrapper<fileOutput>;
  geodatamutation_root: ResolverTypeWrapper<geodatamutation_root>;
  geodataquery_root: ResolverTypeWrapper<geodataquery_root>;
  geodatasubscription_root: ResolverTypeWrapper<geodatasubscription_root>;
  getEmailAccountInput: getEmailAccountInput;
  getEmailAccountOutput: ResolverTypeWrapper<getEmailAccountOutput>;
  incomingSms: ResolverTypeWrapper<incomingSms>;
  inviteObject: inviteObject;
  inviteOutput: ResolverTypeWrapper<inviteOutput>;
  json: ResolverTypeWrapper<Scalars['json']['output']>;
  jsonb: ResolverTypeWrapper<Scalars['jsonb']['output']>;
  languages: ResolverTypeWrapper<languages>;
  languagesAggregate: ResolverTypeWrapper<languagesAggregate>;
  languagesAggregateFields: ResolverTypeWrapper<languagesAggregateFields>;
  languagesBoolExp: languagesBoolExp;
  languagesConstraint: languagesConstraint;
  languagesInsertInput: languagesInsertInput;
  languagesMaxFields: ResolverTypeWrapper<languagesMaxFields>;
  languagesMinFields: ResolverTypeWrapper<languagesMinFields>;
  languagesMutationResponse: ResolverTypeWrapper<languagesMutationResponse>;
  languagesObjRelInsertInput: languagesObjRelInsertInput;
  languagesOnConflict: languagesOnConflict;
  languagesOrderBy: languagesOrderBy;
  languagesPkColumnsInput: languagesPkColumnsInput;
  languagesSelectColumn: languagesSelectColumn;
  languagesSetInput: languagesSetInput;
  languagesStreamCursorInput: languagesStreamCursorInput;
  languagesStreamCursorValueInput: languagesStreamCursorValueInput;
  languagesUpdateColumn: languagesUpdateColumn;
  languagesUpdates: languagesUpdates;
  leaveOrganizationObject: leaveOrganizationObject;
  leaveOrganizationOutput: ResolverTypeWrapper<leaveOrganizationOutput>;
  message: ResolverTypeWrapper<message>;
  messageAggregate: ResolverTypeWrapper<messageAggregate>;
  messageAggregateBoolExp: messageAggregateBoolExp;
  messageAggregateBoolExpBool_and: messageAggregateBoolExpBool_and;
  messageAggregateBoolExpBool_or: messageAggregateBoolExpBool_or;
  messageAggregateBoolExpCount: messageAggregateBoolExpCount;
  messageAggregateFields: ResolverTypeWrapper<messageAggregateFields>;
  messageAggregateOrderBy: messageAggregateOrderBy;
  messageArrRelInsertInput: messageArrRelInsertInput;
  messageBoolExp: messageBoolExp;
  messageConstraint: messageConstraint;
  messageInsertInput: messageInsertInput;
  messageMaxFields: ResolverTypeWrapper<messageMaxFields>;
  messageMaxOrderBy: messageMaxOrderBy;
  messageMinFields: ResolverTypeWrapper<messageMinFields>;
  messageMinOrderBy: messageMinOrderBy;
  messageMutationResponse: ResolverTypeWrapper<messageMutationResponse>;
  messageOnConflict: messageOnConflict;
  messageOrderBy: messageOrderBy;
  messagePkColumnsInput: messagePkColumnsInput;
  messageSelectColumn: messageSelectColumn;
  messageSelectColumnMessageAggregateBoolExpBool_andArgumentsColumns: messageSelectColumnMessageAggregateBoolExpBool_andArgumentsColumns;
  messageSelectColumnMessageAggregateBoolExpBool_orArgumentsColumns: messageSelectColumnMessageAggregateBoolExpBool_orArgumentsColumns;
  messageSetInput: messageSetInput;
  messageStreamCursorInput: messageStreamCursorInput;
  messageStreamCursorValueInput: messageStreamCursorValueInput;
  messageType: ResolverTypeWrapper<messageType>;
  messageTypeAggregate: ResolverTypeWrapper<messageTypeAggregate>;
  messageTypeAggregateFields: ResolverTypeWrapper<messageTypeAggregateFields>;
  messageTypeBoolExp: messageTypeBoolExp;
  messageTypeConstraint: messageTypeConstraint;
  messageTypeEnum: messageTypeEnum;
  messageTypeInsertInput: messageTypeInsertInput;
  messageTypeMaxFields: ResolverTypeWrapper<messageTypeMaxFields>;
  messageTypeMinFields: ResolverTypeWrapper<messageTypeMinFields>;
  messageTypeMutationResponse: ResolverTypeWrapper<messageTypeMutationResponse>;
  messageTypeObjRelInsertInput: messageTypeObjRelInsertInput;
  messageTypeOnConflict: messageTypeOnConflict;
  messageTypeOrderBy: messageTypeOrderBy;
  messageTypePkColumnsInput: messageTypePkColumnsInput;
  messageTypeSelectColumn: messageTypeSelectColumn;
  messageTypeSetInput: messageTypeSetInput;
  messageTypeStreamCursorInput: messageTypeStreamCursorInput;
  messageTypeStreamCursorValueInput: messageTypeStreamCursorValueInput;
  messageTypeUpdateColumn: messageTypeUpdateColumn;
  messageTypeUpdates: messageTypeUpdates;
  messageUpdateColumn: messageUpdateColumn;
  messageUpdates: messageUpdates;
  messagingActivity: ResolverTypeWrapper<messagingActivity>;
  messagingActivityAggregate: ResolverTypeWrapper<messagingActivityAggregate>;
  messagingActivityAggregateFields: ResolverTypeWrapper<messagingActivityAggregateFields>;
  messagingActivityBoolExp: messagingActivityBoolExp;
  messagingActivityConstraint: messagingActivityConstraint;
  messagingActivityInsertInput: messagingActivityInsertInput;
  messagingActivityMaxFields: ResolverTypeWrapper<messagingActivityMaxFields>;
  messagingActivityMinFields: ResolverTypeWrapper<messagingActivityMinFields>;
  messagingActivityMutationResponse: ResolverTypeWrapper<messagingActivityMutationResponse>;
  messagingActivityObjRelInsertInput: messagingActivityObjRelInsertInput;
  messagingActivityOnConflict: messagingActivityOnConflict;
  messagingActivityOrderBy: messagingActivityOrderBy;
  messagingActivityOrganization: ResolverTypeWrapper<messagingActivityOrganization>;
  messagingActivityOrganizationAggregate: ResolverTypeWrapper<messagingActivityOrganizationAggregate>;
  messagingActivityOrganizationAggregateBoolExp: messagingActivityOrganizationAggregateBoolExp;
  messagingActivityOrganizationAggregateBoolExpCount: messagingActivityOrganizationAggregateBoolExpCount;
  messagingActivityOrganizationAggregateFields: ResolverTypeWrapper<messagingActivityOrganizationAggregateFields>;
  messagingActivityOrganizationAggregateOrderBy: messagingActivityOrganizationAggregateOrderBy;
  messagingActivityOrganizationArrRelInsertInput: messagingActivityOrganizationArrRelInsertInput;
  messagingActivityOrganizationBoolExp: messagingActivityOrganizationBoolExp;
  messagingActivityOrganizationConstraint: messagingActivityOrganizationConstraint;
  messagingActivityOrganizationInsertInput: messagingActivityOrganizationInsertInput;
  messagingActivityOrganizationMaxFields: ResolverTypeWrapper<messagingActivityOrganizationMaxFields>;
  messagingActivityOrganizationMaxOrderBy: messagingActivityOrganizationMaxOrderBy;
  messagingActivityOrganizationMinFields: ResolverTypeWrapper<messagingActivityOrganizationMinFields>;
  messagingActivityOrganizationMinOrderBy: messagingActivityOrganizationMinOrderBy;
  messagingActivityOrganizationMutationResponse: ResolverTypeWrapper<messagingActivityOrganizationMutationResponse>;
  messagingActivityOrganizationOnConflict: messagingActivityOrganizationOnConflict;
  messagingActivityOrganizationOrderBy: messagingActivityOrganizationOrderBy;
  messagingActivityOrganizationPkColumnsInput: messagingActivityOrganizationPkColumnsInput;
  messagingActivityOrganizationSelectColumn: messagingActivityOrganizationSelectColumn;
  messagingActivityOrganizationSetInput: messagingActivityOrganizationSetInput;
  messagingActivityOrganizationStreamCursorInput: messagingActivityOrganizationStreamCursorInput;
  messagingActivityOrganizationStreamCursorValueInput: messagingActivityOrganizationStreamCursorValueInput;
  messagingActivityOrganizationUpdateColumn: messagingActivityOrganizationUpdateColumn;
  messagingActivityOrganizationUpdates: messagingActivityOrganizationUpdates;
  messagingActivityPkColumnsInput: messagingActivityPkColumnsInput;
  messagingActivitySelectColumn: messagingActivitySelectColumn;
  messagingActivitySetInput: messagingActivitySetInput;
  messagingActivityStreamCursorInput: messagingActivityStreamCursorInput;
  messagingActivityStreamCursorValueInput: messagingActivityStreamCursorValueInput;
  messagingActivityType: ResolverTypeWrapper<messagingActivityType>;
  messagingActivityTypeAggregate: ResolverTypeWrapper<messagingActivityTypeAggregate>;
  messagingActivityTypeAggregateFields: ResolverTypeWrapper<messagingActivityTypeAggregateFields>;
  messagingActivityTypeBoolExp: messagingActivityTypeBoolExp;
  messagingActivityTypeConstraint: messagingActivityTypeConstraint;
  messagingActivityTypeEnum: messagingActivityTypeEnum;
  messagingActivityTypeInsertInput: messagingActivityTypeInsertInput;
  messagingActivityTypeMaxFields: ResolverTypeWrapper<messagingActivityTypeMaxFields>;
  messagingActivityTypeMinFields: ResolverTypeWrapper<messagingActivityTypeMinFields>;
  messagingActivityTypeMutationResponse: ResolverTypeWrapper<messagingActivityTypeMutationResponse>;
  messagingActivityTypeOnConflict: messagingActivityTypeOnConflict;
  messagingActivityTypeOrderBy: messagingActivityTypeOrderBy;
  messagingActivityTypePkColumnsInput: messagingActivityTypePkColumnsInput;
  messagingActivityTypeSelectColumn: messagingActivityTypeSelectColumn;
  messagingActivityTypeSetInput: messagingActivityTypeSetInput;
  messagingActivityTypeStreamCursorInput: messagingActivityTypeStreamCursorInput;
  messagingActivityTypeStreamCursorValueInput: messagingActivityTypeStreamCursorValueInput;
  messagingActivityTypeUpdateColumn: messagingActivityTypeUpdateColumn;
  messagingActivityTypeUpdates: messagingActivityTypeUpdates;
  messagingActivityUpdateColumn: messagingActivityUpdateColumn;
  messagingActivityUpdates: messagingActivityUpdates;
  messagingActivityUser: ResolverTypeWrapper<messagingActivityUser>;
  messagingActivityUserAggregate: ResolverTypeWrapper<messagingActivityUserAggregate>;
  messagingActivityUserAggregateBoolExp: messagingActivityUserAggregateBoolExp;
  messagingActivityUserAggregateBoolExpCount: messagingActivityUserAggregateBoolExpCount;
  messagingActivityUserAggregateFields: ResolverTypeWrapper<messagingActivityUserAggregateFields>;
  messagingActivityUserAggregateOrderBy: messagingActivityUserAggregateOrderBy;
  messagingActivityUserArrRelInsertInput: messagingActivityUserArrRelInsertInput;
  messagingActivityUserAvgFields: ResolverTypeWrapper<messagingActivityUserAvgFields>;
  messagingActivityUserAvgOrderBy: messagingActivityUserAvgOrderBy;
  messagingActivityUserBoolExp: messagingActivityUserBoolExp;
  messagingActivityUserConstraint: messagingActivityUserConstraint;
  messagingActivityUserIncInput: messagingActivityUserIncInput;
  messagingActivityUserInsertInput: messagingActivityUserInsertInput;
  messagingActivityUserMaxFields: ResolverTypeWrapper<messagingActivityUserMaxFields>;
  messagingActivityUserMaxOrderBy: messagingActivityUserMaxOrderBy;
  messagingActivityUserMinFields: ResolverTypeWrapper<messagingActivityUserMinFields>;
  messagingActivityUserMinOrderBy: messagingActivityUserMinOrderBy;
  messagingActivityUserMutationResponse: ResolverTypeWrapper<messagingActivityUserMutationResponse>;
  messagingActivityUserOnConflict: messagingActivityUserOnConflict;
  messagingActivityUserOrderBy: messagingActivityUserOrderBy;
  messagingActivityUserPkColumnsInput: messagingActivityUserPkColumnsInput;
  messagingActivityUserSelectColumn: messagingActivityUserSelectColumn;
  messagingActivityUserSetInput: messagingActivityUserSetInput;
  messagingActivityUserStddevFields: ResolverTypeWrapper<messagingActivityUserStddevFields>;
  messagingActivityUserStddevOrderBy: messagingActivityUserStddevOrderBy;
  messagingActivityUserStddevPopFields: ResolverTypeWrapper<messagingActivityUserStddevPopFields>;
  messagingActivityUserStddevPopOrderBy: messagingActivityUserStddevPopOrderBy;
  messagingActivityUserStddevSampFields: ResolverTypeWrapper<messagingActivityUserStddevSampFields>;
  messagingActivityUserStddevSampOrderBy: messagingActivityUserStddevSampOrderBy;
  messagingActivityUserStreamCursorInput: messagingActivityUserStreamCursorInput;
  messagingActivityUserStreamCursorValueInput: messagingActivityUserStreamCursorValueInput;
  messagingActivityUserSumFields: ResolverTypeWrapper<messagingActivityUserSumFields>;
  messagingActivityUserSumOrderBy: messagingActivityUserSumOrderBy;
  messagingActivityUserUpdateColumn: messagingActivityUserUpdateColumn;
  messagingActivityUserUpdates: messagingActivityUserUpdates;
  messagingActivityUserVarPopFields: ResolverTypeWrapper<messagingActivityUserVarPopFields>;
  messagingActivityUserVarPopOrderBy: messagingActivityUserVarPopOrderBy;
  messagingActivityUserVarSampFields: ResolverTypeWrapper<messagingActivityUserVarSampFields>;
  messagingActivityUserVarSampOrderBy: messagingActivityUserVarSampOrderBy;
  messagingActivityUserVarianceFields: ResolverTypeWrapper<messagingActivityUserVarianceFields>;
  messagingActivityUserVarianceOrderBy: messagingActivityUserVarianceOrderBy;
  messagingInvitationAggregateBoolExpBool_and: messagingInvitationAggregateBoolExpBool_and;
  messagingInvitationAggregateBoolExpBool_or: messagingInvitationAggregateBoolExpBool_or;
  messagingInvitationAggregateBoolExpCount: messagingInvitationAggregateBoolExpCount;
  messagingMentionsAggregateBoolExpCount: messagingMentionsAggregateBoolExpCount;
  messagingMessage: ResolverTypeWrapper<messagingMessage>;
  messagingMessageAggregate: ResolverTypeWrapper<messagingMessageAggregate>;
  messagingMessageAggregateBoolExp: messagingMessageAggregateBoolExp;
  messagingMessageAggregateBoolExpBool_and: messagingMessageAggregateBoolExpBool_and;
  messagingMessageAggregateBoolExpBool_or: messagingMessageAggregateBoolExpBool_or;
  messagingMessageAggregateBoolExpCount: messagingMessageAggregateBoolExpCount;
  messagingMessageAggregateFields: ResolverTypeWrapper<messagingMessageAggregateFields>;
  messagingMessageAggregateOrderBy: messagingMessageAggregateOrderBy;
  messagingMessageArrRelInsertInput: messagingMessageArrRelInsertInput;
  messagingMessageAttachmentAggregateBoolExpCount: messagingMessageAttachmentAggregateBoolExpCount;
  messagingMessageBoolExp: messagingMessageBoolExp;
  messagingMessageConstraint: messagingMessageConstraint;
  messagingMessageEmoji: ResolverTypeWrapper<messagingMessageEmoji>;
  messagingMessageEmojiAggregate: ResolverTypeWrapper<messagingMessageEmojiAggregate>;
  messagingMessageEmojiAggregateBoolExp: messagingMessageEmojiAggregateBoolExp;
  messagingMessageEmojiAggregateBoolExpCount: messagingMessageEmojiAggregateBoolExpCount;
  messagingMessageEmojiAggregateFields: ResolverTypeWrapper<messagingMessageEmojiAggregateFields>;
  messagingMessageEmojiAggregateOrderBy: messagingMessageEmojiAggregateOrderBy;
  messagingMessageEmojiArrRelInsertInput: messagingMessageEmojiArrRelInsertInput;
  messagingMessageEmojiBoolExp: messagingMessageEmojiBoolExp;
  messagingMessageEmojiConstraint: messagingMessageEmojiConstraint;
  messagingMessageEmojiInsertInput: messagingMessageEmojiInsertInput;
  messagingMessageEmojiMaxFields: ResolverTypeWrapper<messagingMessageEmojiMaxFields>;
  messagingMessageEmojiMaxOrderBy: messagingMessageEmojiMaxOrderBy;
  messagingMessageEmojiMinFields: ResolverTypeWrapper<messagingMessageEmojiMinFields>;
  messagingMessageEmojiMinOrderBy: messagingMessageEmojiMinOrderBy;
  messagingMessageEmojiMutationResponse: ResolverTypeWrapper<messagingMessageEmojiMutationResponse>;
  messagingMessageEmojiOnConflict: messagingMessageEmojiOnConflict;
  messagingMessageEmojiOrderBy: messagingMessageEmojiOrderBy;
  messagingMessageEmojiPkColumnsInput: messagingMessageEmojiPkColumnsInput;
  messagingMessageEmojiSelectColumn: messagingMessageEmojiSelectColumn;
  messagingMessageEmojiSetInput: messagingMessageEmojiSetInput;
  messagingMessageEmojiStreamCursorInput: messagingMessageEmojiStreamCursorInput;
  messagingMessageEmojiStreamCursorValueInput: messagingMessageEmojiStreamCursorValueInput;
  messagingMessageEmojiUpdateColumn: messagingMessageEmojiUpdateColumn;
  messagingMessageEmojiUpdates: messagingMessageEmojiUpdates;
  messagingMessageInsertInput: messagingMessageInsertInput;
  messagingMessageMaxFields: ResolverTypeWrapper<messagingMessageMaxFields>;
  messagingMessageMaxOrderBy: messagingMessageMaxOrderBy;
  messagingMessageMinFields: ResolverTypeWrapper<messagingMessageMinFields>;
  messagingMessageMinOrderBy: messagingMessageMinOrderBy;
  messagingMessageMutationResponse: ResolverTypeWrapper<messagingMessageMutationResponse>;
  messagingMessageObjRelInsertInput: messagingMessageObjRelInsertInput;
  messagingMessageOnConflict: messagingMessageOnConflict;
  messagingMessageOrderBy: messagingMessageOrderBy;
  messagingMessagePkColumnsInput: messagingMessagePkColumnsInput;
  messagingMessageRead: ResolverTypeWrapper<messagingMessageRead>;
  messagingMessageReadAggregate: ResolverTypeWrapper<messagingMessageReadAggregate>;
  messagingMessageReadAggregateBoolExp: messagingMessageReadAggregateBoolExp;
  messagingMessageReadAggregateBoolExpBool_and: messagingMessageReadAggregateBoolExpBool_and;
  messagingMessageReadAggregateBoolExpBool_or: messagingMessageReadAggregateBoolExpBool_or;
  messagingMessageReadAggregateBoolExpCount: messagingMessageReadAggregateBoolExpCount;
  messagingMessageReadAggregateFields: ResolverTypeWrapper<messagingMessageReadAggregateFields>;
  messagingMessageReadAggregateOrderBy: messagingMessageReadAggregateOrderBy;
  messagingMessageReadArrRelInsertInput: messagingMessageReadArrRelInsertInput;
  messagingMessageReadBoolExp: messagingMessageReadBoolExp;
  messagingMessageReadConstraint: messagingMessageReadConstraint;
  messagingMessageReadInsertInput: messagingMessageReadInsertInput;
  messagingMessageReadMaxFields: ResolverTypeWrapper<messagingMessageReadMaxFields>;
  messagingMessageReadMaxOrderBy: messagingMessageReadMaxOrderBy;
  messagingMessageReadMinFields: ResolverTypeWrapper<messagingMessageReadMinFields>;
  messagingMessageReadMinOrderBy: messagingMessageReadMinOrderBy;
  messagingMessageReadMutationResponse: ResolverTypeWrapper<messagingMessageReadMutationResponse>;
  messagingMessageReadOnConflict: messagingMessageReadOnConflict;
  messagingMessageReadOrderBy: messagingMessageReadOrderBy;
  messagingMessageReadPkColumnsInput: messagingMessageReadPkColumnsInput;
  messagingMessageReadSelectColumn: messagingMessageReadSelectColumn;
  messagingMessageReadSelectColumnMessagingMessageReadAggregateBoolExpBool_andArgumentsColumns: messagingMessageReadSelectColumnMessagingMessageReadAggregateBoolExpBool_andArgumentsColumns;
  messagingMessageReadSelectColumnMessagingMessageReadAggregateBoolExpBool_orArgumentsColumns: messagingMessageReadSelectColumnMessagingMessageReadAggregateBoolExpBool_orArgumentsColumns;
  messagingMessageReadSetInput: messagingMessageReadSetInput;
  messagingMessageReadStreamCursorInput: messagingMessageReadStreamCursorInput;
  messagingMessageReadStreamCursorValueInput: messagingMessageReadStreamCursorValueInput;
  messagingMessageReadUpdateColumn: messagingMessageReadUpdateColumn;
  messagingMessageReadUpdates: messagingMessageReadUpdates;
  messagingMessageSelectColumn: messagingMessageSelectColumn;
  messagingMessageSelectColumnMessagingMessageAggregateBoolExpBool_andArgumentsColumns: messagingMessageSelectColumnMessagingMessageAggregateBoolExpBool_andArgumentsColumns;
  messagingMessageSelectColumnMessagingMessageAggregateBoolExpBool_orArgumentsColumns: messagingMessageSelectColumnMessagingMessageAggregateBoolExpBool_orArgumentsColumns;
  messagingMessageSetInput: messagingMessageSetInput;
  messagingMessageStreamCursorInput: messagingMessageStreamCursorInput;
  messagingMessageStreamCursorValueInput: messagingMessageStreamCursorValueInput;
  messagingMessageType: ResolverTypeWrapper<messagingMessageType>;
  messagingMessageTypeAggregate: ResolverTypeWrapper<messagingMessageTypeAggregate>;
  messagingMessageTypeAggregateFields: ResolverTypeWrapper<messagingMessageTypeAggregateFields>;
  messagingMessageTypeBoolExp: messagingMessageTypeBoolExp;
  messagingMessageTypeConstraint: messagingMessageTypeConstraint;
  messagingMessageTypeEnum: messagingMessageTypeEnum;
  messagingMessageTypeInsertInput: messagingMessageTypeInsertInput;
  messagingMessageTypeMaxFields: ResolverTypeWrapper<messagingMessageTypeMaxFields>;
  messagingMessageTypeMinFields: ResolverTypeWrapper<messagingMessageTypeMinFields>;
  messagingMessageTypeMutationResponse: ResolverTypeWrapper<messagingMessageTypeMutationResponse>;
  messagingMessageTypeOnConflict: messagingMessageTypeOnConflict;
  messagingMessageTypeOrderBy: messagingMessageTypeOrderBy;
  messagingMessageTypePkColumnsInput: messagingMessageTypePkColumnsInput;
  messagingMessageTypeSelectColumn: messagingMessageTypeSelectColumn;
  messagingMessageTypeSetInput: messagingMessageTypeSetInput;
  messagingMessageTypeStreamCursorInput: messagingMessageTypeStreamCursorInput;
  messagingMessageTypeStreamCursorValueInput: messagingMessageTypeStreamCursorValueInput;
  messagingMessageTypeUpdateColumn: messagingMessageTypeUpdateColumn;
  messagingMessageTypeUpdates: messagingMessageTypeUpdates;
  messagingMessageUpdateColumn: messagingMessageUpdateColumn;
  messagingMessageUpdates: messagingMessageUpdates;
  mutation_root: ResolverTypeWrapper<{}>;
  notification: ResolverTypeWrapper<notification>;
  notificationAggregate: ResolverTypeWrapper<notificationAggregate>;
  notificationAggregateFields: ResolverTypeWrapper<notificationAggregateFields>;
  notificationBoolExp: notificationBoolExp;
  notificationConstraint: notificationConstraint;
  notificationInsertInput: notificationInsertInput;
  notificationMaxFields: ResolverTypeWrapper<notificationMaxFields>;
  notificationMinFields: ResolverTypeWrapper<notificationMinFields>;
  notificationMutationResponse: ResolverTypeWrapper<notificationMutationResponse>;
  notificationOnConflict: notificationOnConflict;
  notificationOrderBy: notificationOrderBy;
  notificationPkColumnsInput: notificationPkColumnsInput;
  notificationSelectColumn: notificationSelectColumn;
  notificationSend: ResolverTypeWrapper<notificationSend>;
  notificationSendAggregate: ResolverTypeWrapper<notificationSendAggregate>;
  notificationSendAggregateFields: ResolverTypeWrapper<notificationSendAggregateFields>;
  notificationSendBoolExp: notificationSendBoolExp;
  notificationSendConstraint: notificationSendConstraint;
  notificationSendInsertInput: notificationSendInsertInput;
  notificationSendMaxFields: ResolverTypeWrapper<notificationSendMaxFields>;
  notificationSendMinFields: ResolverTypeWrapper<notificationSendMinFields>;
  notificationSendMutationResponse: ResolverTypeWrapper<notificationSendMutationResponse>;
  notificationSendObjRelInsertInput: notificationSendObjRelInsertInput;
  notificationSendOnConflict: notificationSendOnConflict;
  notificationSendOrderBy: notificationSendOrderBy;
  notificationSendPkColumnsInput: notificationSendPkColumnsInput;
  notificationSendSelectColumn: notificationSendSelectColumn;
  notificationSendSetInput: notificationSendSetInput;
  notificationSendStreamCursorInput: notificationSendStreamCursorInput;
  notificationSendStreamCursorValueInput: notificationSendStreamCursorValueInput;
  notificationSendUpdateColumn: notificationSendUpdateColumn;
  notificationSendUpdates: notificationSendUpdates;
  notificationSetInput: notificationSetInput;
  notificationSettingActivity: ResolverTypeWrapper<notificationSettingActivity>;
  notificationSettingActivityAggregate: ResolverTypeWrapper<notificationSettingActivityAggregate>;
  notificationSettingActivityAggregateFields: ResolverTypeWrapper<notificationSettingActivityAggregateFields>;
  notificationSettingActivityBoolExp: notificationSettingActivityBoolExp;
  notificationSettingActivityConstraint: notificationSettingActivityConstraint;
  notificationSettingActivityInsertInput: notificationSettingActivityInsertInput;
  notificationSettingActivityMaxFields: ResolverTypeWrapper<notificationSettingActivityMaxFields>;
  notificationSettingActivityMinFields: ResolverTypeWrapper<notificationSettingActivityMinFields>;
  notificationSettingActivityMutationResponse: ResolverTypeWrapper<notificationSettingActivityMutationResponse>;
  notificationSettingActivityOnConflict: notificationSettingActivityOnConflict;
  notificationSettingActivityOrderBy: notificationSettingActivityOrderBy;
  notificationSettingActivityPkColumnsInput: notificationSettingActivityPkColumnsInput;
  notificationSettingActivitySelectColumn: notificationSettingActivitySelectColumn;
  notificationSettingActivitySetInput: notificationSettingActivitySetInput;
  notificationSettingActivityStreamCursorInput: notificationSettingActivityStreamCursorInput;
  notificationSettingActivityStreamCursorValueInput: notificationSettingActivityStreamCursorValueInput;
  notificationSettingActivityUpdateColumn: notificationSettingActivityUpdateColumn;
  notificationSettingActivityUpdates: notificationSettingActivityUpdates;
  notificationStreamCursorInput: notificationStreamCursorInput;
  notificationStreamCursorValueInput: notificationStreamCursorValueInput;
  notificationUpdateColumn: notificationUpdateColumn;
  notificationUpdates: notificationUpdates;
  notificationUser: ResolverTypeWrapper<notificationUser>;
  notificationUserAggregate: ResolverTypeWrapper<notificationUserAggregate>;
  notificationUserAggregateFields: ResolverTypeWrapper<notificationUserAggregateFields>;
  notificationUserBoolExp: notificationUserBoolExp;
  notificationUserConstraint: notificationUserConstraint;
  notificationUserDevice: ResolverTypeWrapper<notificationUserDevice>;
  notificationUserDeviceAggregate: ResolverTypeWrapper<notificationUserDeviceAggregate>;
  notificationUserDeviceAggregateBoolExp: notificationUserDeviceAggregateBoolExp;
  notificationUserDeviceAggregateBoolExpBool_and: notificationUserDeviceAggregateBoolExpBool_and;
  notificationUserDeviceAggregateBoolExpBool_or: notificationUserDeviceAggregateBoolExpBool_or;
  notificationUserDeviceAggregateBoolExpCount: notificationUserDeviceAggregateBoolExpCount;
  notificationUserDeviceAggregateFields: ResolverTypeWrapper<notificationUserDeviceAggregateFields>;
  notificationUserDeviceAggregateOrderBy: notificationUserDeviceAggregateOrderBy;
  notificationUserDeviceArrRelInsertInput: notificationUserDeviceArrRelInsertInput;
  notificationUserDeviceAvgFields: ResolverTypeWrapper<notificationUserDeviceAvgFields>;
  notificationUserDeviceAvgOrderBy: notificationUserDeviceAvgOrderBy;
  notificationUserDeviceBoolExp: notificationUserDeviceBoolExp;
  notificationUserDeviceConstraint: notificationUserDeviceConstraint;
  notificationUserDeviceIncInput: notificationUserDeviceIncInput;
  notificationUserDeviceInsertInput: notificationUserDeviceInsertInput;
  notificationUserDeviceMaxFields: ResolverTypeWrapper<notificationUserDeviceMaxFields>;
  notificationUserDeviceMaxOrderBy: notificationUserDeviceMaxOrderBy;
  notificationUserDeviceMinFields: ResolverTypeWrapper<notificationUserDeviceMinFields>;
  notificationUserDeviceMinOrderBy: notificationUserDeviceMinOrderBy;
  notificationUserDeviceMutationResponse: ResolverTypeWrapper<notificationUserDeviceMutationResponse>;
  notificationUserDeviceObjRelInsertInput: notificationUserDeviceObjRelInsertInput;
  notificationUserDeviceOnConflict: notificationUserDeviceOnConflict;
  notificationUserDeviceOrderBy: notificationUserDeviceOrderBy;
  notificationUserDevicePkColumnsInput: notificationUserDevicePkColumnsInput;
  notificationUserDeviceSelectColumn: notificationUserDeviceSelectColumn;
  notificationUserDeviceSelectColumnNotificationUserDeviceAggregateBoolExpBool_andArgumentsColumns: notificationUserDeviceSelectColumnNotificationUserDeviceAggregateBoolExpBool_andArgumentsColumns;
  notificationUserDeviceSelectColumnNotificationUserDeviceAggregateBoolExpBool_orArgumentsColumns: notificationUserDeviceSelectColumnNotificationUserDeviceAggregateBoolExpBool_orArgumentsColumns;
  notificationUserDeviceSetInput: notificationUserDeviceSetInput;
  notificationUserDeviceStddevFields: ResolverTypeWrapper<notificationUserDeviceStddevFields>;
  notificationUserDeviceStddevOrderBy: notificationUserDeviceStddevOrderBy;
  notificationUserDeviceStddevPopFields: ResolverTypeWrapper<notificationUserDeviceStddevPopFields>;
  notificationUserDeviceStddevPopOrderBy: notificationUserDeviceStddevPopOrderBy;
  notificationUserDeviceStddevSampFields: ResolverTypeWrapper<notificationUserDeviceStddevSampFields>;
  notificationUserDeviceStddevSampOrderBy: notificationUserDeviceStddevSampOrderBy;
  notificationUserDeviceStreamCursorInput: notificationUserDeviceStreamCursorInput;
  notificationUserDeviceStreamCursorValueInput: notificationUserDeviceStreamCursorValueInput;
  notificationUserDeviceSumFields: ResolverTypeWrapper<notificationUserDeviceSumFields>;
  notificationUserDeviceSumOrderBy: notificationUserDeviceSumOrderBy;
  notificationUserDeviceUpdateColumn: notificationUserDeviceUpdateColumn;
  notificationUserDeviceUpdates: notificationUserDeviceUpdates;
  notificationUserDeviceVarPopFields: ResolverTypeWrapper<notificationUserDeviceVarPopFields>;
  notificationUserDeviceVarPopOrderBy: notificationUserDeviceVarPopOrderBy;
  notificationUserDeviceVarSampFields: ResolverTypeWrapper<notificationUserDeviceVarSampFields>;
  notificationUserDeviceVarSampOrderBy: notificationUserDeviceVarSampOrderBy;
  notificationUserDeviceVarianceFields: ResolverTypeWrapper<notificationUserDeviceVarianceFields>;
  notificationUserDeviceVarianceOrderBy: notificationUserDeviceVarianceOrderBy;
  notificationUserInsertInput: notificationUserInsertInput;
  notificationUserMaxFields: ResolverTypeWrapper<notificationUserMaxFields>;
  notificationUserMinFields: ResolverTypeWrapper<notificationUserMinFields>;
  notificationUserMutationResponse: ResolverTypeWrapper<notificationUserMutationResponse>;
  notificationUserOnConflict: notificationUserOnConflict;
  notificationUserOrderBy: notificationUserOrderBy;
  notificationUserPkColumnsInput: notificationUserPkColumnsInput;
  notificationUserSelectColumn: notificationUserSelectColumn;
  notificationUserSetInput: notificationUserSetInput;
  notificationUserStreamCursorInput: notificationUserStreamCursorInput;
  notificationUserStreamCursorValueInput: notificationUserStreamCursorValueInput;
  notificationUserUpdateColumn: notificationUserUpdateColumn;
  notificationUserUpdates: notificationUserUpdates;
  numeric: ResolverTypeWrapper<Scalars['numeric']['output']>;
  ordersIntegrations: ResolverTypeWrapper<ordersIntegrations>;
  ordersIntegrationsAggregate: ResolverTypeWrapper<ordersIntegrationsAggregate>;
  ordersIntegrationsAggregateBoolExp: ordersIntegrationsAggregateBoolExp;
  ordersIntegrationsAggregateBoolExpBool_and: ordersIntegrationsAggregateBoolExpBool_and;
  ordersIntegrationsAggregateBoolExpBool_or: ordersIntegrationsAggregateBoolExpBool_or;
  ordersIntegrationsAggregateBoolExpCount: ordersIntegrationsAggregateBoolExpCount;
  ordersIntegrationsAggregateFields: ResolverTypeWrapper<ordersIntegrationsAggregateFields>;
  ordersIntegrationsAggregateOrderBy: ordersIntegrationsAggregateOrderBy;
  ordersIntegrationsArrRelInsertInput: ordersIntegrationsArrRelInsertInput;
  ordersIntegrationsAvgFields: ResolverTypeWrapper<ordersIntegrationsAvgFields>;
  ordersIntegrationsAvgOrderBy: ordersIntegrationsAvgOrderBy;
  ordersIntegrationsBoolExp: ordersIntegrationsBoolExp;
  ordersIntegrationsConstraint: ordersIntegrationsConstraint;
  ordersIntegrationsIncInput: ordersIntegrationsIncInput;
  ordersIntegrationsInsertInput: ordersIntegrationsInsertInput;
  ordersIntegrationsMaxFields: ResolverTypeWrapper<ordersIntegrationsMaxFields>;
  ordersIntegrationsMaxOrderBy: ordersIntegrationsMaxOrderBy;
  ordersIntegrationsMinFields: ResolverTypeWrapper<ordersIntegrationsMinFields>;
  ordersIntegrationsMinOrderBy: ordersIntegrationsMinOrderBy;
  ordersIntegrationsMutationResponse: ResolverTypeWrapper<ordersIntegrationsMutationResponse>;
  ordersIntegrationsObjRelInsertInput: ordersIntegrationsObjRelInsertInput;
  ordersIntegrationsOnConflict: ordersIntegrationsOnConflict;
  ordersIntegrationsOrderBy: ordersIntegrationsOrderBy;
  ordersIntegrationsPkColumnsInput: ordersIntegrationsPkColumnsInput;
  ordersIntegrationsSelectColumn: ordersIntegrationsSelectColumn;
  ordersIntegrationsSelectColumnOrdersIntegrationsAggregateBoolExpBool_andArgumentsColumns: ordersIntegrationsSelectColumnOrdersIntegrationsAggregateBoolExpBool_andArgumentsColumns;
  ordersIntegrationsSelectColumnOrdersIntegrationsAggregateBoolExpBool_orArgumentsColumns: ordersIntegrationsSelectColumnOrdersIntegrationsAggregateBoolExpBool_orArgumentsColumns;
  ordersIntegrationsSetInput: ordersIntegrationsSetInput;
  ordersIntegrationsStddevFields: ResolverTypeWrapper<ordersIntegrationsStddevFields>;
  ordersIntegrationsStddevOrderBy: ordersIntegrationsStddevOrderBy;
  ordersIntegrationsStddevPopFields: ResolverTypeWrapper<ordersIntegrationsStddevPopFields>;
  ordersIntegrationsStddevPopOrderBy: ordersIntegrationsStddevPopOrderBy;
  ordersIntegrationsStddevSampFields: ResolverTypeWrapper<ordersIntegrationsStddevSampFields>;
  ordersIntegrationsStddevSampOrderBy: ordersIntegrationsStddevSampOrderBy;
  ordersIntegrationsStreamCursorInput: ordersIntegrationsStreamCursorInput;
  ordersIntegrationsStreamCursorValueInput: ordersIntegrationsStreamCursorValueInput;
  ordersIntegrationsSumFields: ResolverTypeWrapper<ordersIntegrationsSumFields>;
  ordersIntegrationsSumOrderBy: ordersIntegrationsSumOrderBy;
  ordersIntegrationsUpdateColumn: ordersIntegrationsUpdateColumn;
  ordersIntegrationsUpdates: ordersIntegrationsUpdates;
  ordersIntegrationsVarPopFields: ResolverTypeWrapper<ordersIntegrationsVarPopFields>;
  ordersIntegrationsVarPopOrderBy: ordersIntegrationsVarPopOrderBy;
  ordersIntegrationsVarSampFields: ResolverTypeWrapper<ordersIntegrationsVarSampFields>;
  ordersIntegrationsVarSampOrderBy: ordersIntegrationsVarSampOrderBy;
  ordersIntegrationsVarianceFields: ResolverTypeWrapper<ordersIntegrationsVarianceFields>;
  ordersIntegrationsVarianceOrderBy: ordersIntegrationsVarianceOrderBy;
  orgAccessRequestInput: orgAccessRequestInput;
  orgAccessRequestOutput: ResolverTypeWrapper<orgAccessRequestOutput>;
  organization: ResolverTypeWrapper<organization>;
  organizationAggregate: ResolverTypeWrapper<organizationAggregate>;
  organizationAggregateBoolExp: organizationAggregateBoolExp;
  organizationAggregateBoolExpBool_and: organizationAggregateBoolExpBool_and;
  organizationAggregateBoolExpBool_or: organizationAggregateBoolExpBool_or;
  organizationAggregateBoolExpCount: organizationAggregateBoolExpCount;
  organizationAggregateFields: ResolverTypeWrapper<organizationAggregateFields>;
  organizationAggregateOrderBy: organizationAggregateOrderBy;
  organizationArrRelInsertInput: organizationArrRelInsertInput;
  organizationAuthorizationEnumGroup: ResolverTypeWrapper<organizationAuthorizationEnumGroup>;
  organizationAuthorizationEnumGroupAggregate: ResolverTypeWrapper<organizationAuthorizationEnumGroupAggregate>;
  organizationAuthorizationEnumGroupAggregateBoolExp: organizationAuthorizationEnumGroupAggregateBoolExp;
  organizationAuthorizationEnumGroupAggregateBoolExpCount: organizationAuthorizationEnumGroupAggregateBoolExpCount;
  organizationAuthorizationEnumGroupAggregateFields: ResolverTypeWrapper<organizationAuthorizationEnumGroupAggregateFields>;
  organizationAuthorizationEnumGroupAggregateOrderBy: organizationAuthorizationEnumGroupAggregateOrderBy;
  organizationAuthorizationEnumGroupArrRelInsertInput: organizationAuthorizationEnumGroupArrRelInsertInput;
  organizationAuthorizationEnumGroupBoolExp: organizationAuthorizationEnumGroupBoolExp;
  organizationAuthorizationEnumGroupConstraint: organizationAuthorizationEnumGroupConstraint;
  organizationAuthorizationEnumGroupInsertInput: organizationAuthorizationEnumGroupInsertInput;
  organizationAuthorizationEnumGroupMaxFields: ResolverTypeWrapper<organizationAuthorizationEnumGroupMaxFields>;
  organizationAuthorizationEnumGroupMaxOrderBy: organizationAuthorizationEnumGroupMaxOrderBy;
  organizationAuthorizationEnumGroupMinFields: ResolverTypeWrapper<organizationAuthorizationEnumGroupMinFields>;
  organizationAuthorizationEnumGroupMinOrderBy: organizationAuthorizationEnumGroupMinOrderBy;
  organizationAuthorizationEnumGroupMutationResponse: ResolverTypeWrapper<organizationAuthorizationEnumGroupMutationResponse>;
  organizationAuthorizationEnumGroupOnConflict: organizationAuthorizationEnumGroupOnConflict;
  organizationAuthorizationEnumGroupOrderBy: organizationAuthorizationEnumGroupOrderBy;
  organizationAuthorizationEnumGroupPkColumnsInput: organizationAuthorizationEnumGroupPkColumnsInput;
  organizationAuthorizationEnumGroupSelectColumn: organizationAuthorizationEnumGroupSelectColumn;
  organizationAuthorizationEnumGroupSetInput: organizationAuthorizationEnumGroupSetInput;
  organizationAuthorizationEnumGroupStreamCursorInput: organizationAuthorizationEnumGroupStreamCursorInput;
  organizationAuthorizationEnumGroupStreamCursorValueInput: organizationAuthorizationEnumGroupStreamCursorValueInput;
  organizationAuthorizationEnumGroupUpdateColumn: organizationAuthorizationEnumGroupUpdateColumn;
  organizationAuthorizationEnumGroupUpdates: organizationAuthorizationEnumGroupUpdates;
  organizationAuthorizationGroup: ResolverTypeWrapper<organizationAuthorizationGroup>;
  organizationAuthorizationGroupAggregate: ResolverTypeWrapper<organizationAuthorizationGroupAggregate>;
  organizationAuthorizationGroupAggregateFields: ResolverTypeWrapper<organizationAuthorizationGroupAggregateFields>;
  organizationAuthorizationGroupBoolExp: organizationAuthorizationGroupBoolExp;
  organizationAuthorizationGroupConstraint: organizationAuthorizationGroupConstraint;
  organizationAuthorizationGroupInsertInput: organizationAuthorizationGroupInsertInput;
  organizationAuthorizationGroupMaxFields: ResolverTypeWrapper<organizationAuthorizationGroupMaxFields>;
  organizationAuthorizationGroupMinFields: ResolverTypeWrapper<organizationAuthorizationGroupMinFields>;
  organizationAuthorizationGroupMutationResponse: ResolverTypeWrapper<organizationAuthorizationGroupMutationResponse>;
  organizationAuthorizationGroupOnConflict: organizationAuthorizationGroupOnConflict;
  organizationAuthorizationGroupOrderBy: organizationAuthorizationGroupOrderBy;
  organizationAuthorizationGroupPkColumnsInput: organizationAuthorizationGroupPkColumnsInput;
  organizationAuthorizationGroupSelectColumn: organizationAuthorizationGroupSelectColumn;
  organizationAuthorizationGroupSetInput: organizationAuthorizationGroupSetInput;
  organizationAuthorizationGroupStreamCursorInput: organizationAuthorizationGroupStreamCursorInput;
  organizationAuthorizationGroupStreamCursorValueInput: organizationAuthorizationGroupStreamCursorValueInput;
  organizationAuthorizationGroupUpdateColumn: organizationAuthorizationGroupUpdateColumn;
  organizationAuthorizationGroupUpdates: organizationAuthorizationGroupUpdates;
  organizationAvgFields: ResolverTypeWrapper<organizationAvgFields>;
  organizationAvgOrderBy: organizationAvgOrderBy;
  organizationBoolExp: organizationBoolExp;
  organizationConstraint: organizationConstraint;
  organizationIncInput: organizationIncInput;
  organizationInsertInput: organizationInsertInput;
  organizationMaxFields: ResolverTypeWrapper<organizationMaxFields>;
  organizationMaxOrderBy: organizationMaxOrderBy;
  organizationMinFields: ResolverTypeWrapper<organizationMinFields>;
  organizationMinOrderBy: organizationMinOrderBy;
  organizationMutationResponse: ResolverTypeWrapper<organizationMutationResponse>;
  organizationObjRelInsertInput: organizationObjRelInsertInput;
  organizationOnConflict: organizationOnConflict;
  organizationOrderBy: organizationOrderBy;
  organizationOrganizationRelationship: ResolverTypeWrapper<organizationOrganizationRelationship>;
  organizationOrganizationRelationshipAggregate: ResolverTypeWrapper<organizationOrganizationRelationshipAggregate>;
  organizationOrganizationRelationshipAggregateFields: ResolverTypeWrapper<organizationOrganizationRelationshipAggregateFields>;
  organizationOrganizationRelationshipBoolExp: organizationOrganizationRelationshipBoolExp;
  organizationOrganizationRelationshipCategory: ResolverTypeWrapper<organizationOrganizationRelationshipCategory>;
  organizationOrganizationRelationshipCategoryAggregate: ResolverTypeWrapper<organizationOrganizationRelationshipCategoryAggregate>;
  organizationOrganizationRelationshipCategoryAggregateFields: ResolverTypeWrapper<organizationOrganizationRelationshipCategoryAggregateFields>;
  organizationOrganizationRelationshipCategoryBoolExp: organizationOrganizationRelationshipCategoryBoolExp;
  organizationOrganizationRelationshipCategoryConstraint: organizationOrganizationRelationshipCategoryConstraint;
  organizationOrganizationRelationshipCategoryInsertInput: organizationOrganizationRelationshipCategoryInsertInput;
  organizationOrganizationRelationshipCategoryMaxFields: ResolverTypeWrapper<organizationOrganizationRelationshipCategoryMaxFields>;
  organizationOrganizationRelationshipCategoryMinFields: ResolverTypeWrapper<organizationOrganizationRelationshipCategoryMinFields>;
  organizationOrganizationRelationshipCategoryMutationResponse: ResolverTypeWrapper<organizationOrganizationRelationshipCategoryMutationResponse>;
  organizationOrganizationRelationshipCategoryOnConflict: organizationOrganizationRelationshipCategoryOnConflict;
  organizationOrganizationRelationshipCategoryOrderBy: organizationOrganizationRelationshipCategoryOrderBy;
  organizationOrganizationRelationshipCategoryPkColumnsInput: organizationOrganizationRelationshipCategoryPkColumnsInput;
  organizationOrganizationRelationshipCategorySelectColumn: organizationOrganizationRelationshipCategorySelectColumn;
  organizationOrganizationRelationshipCategorySetInput: organizationOrganizationRelationshipCategorySetInput;
  organizationOrganizationRelationshipCategoryStreamCursorInput: organizationOrganizationRelationshipCategoryStreamCursorInput;
  organizationOrganizationRelationshipCategoryStreamCursorValueInput: organizationOrganizationRelationshipCategoryStreamCursorValueInput;
  organizationOrganizationRelationshipCategoryUpdateColumn: organizationOrganizationRelationshipCategoryUpdateColumn;
  organizationOrganizationRelationshipCategoryUpdates: organizationOrganizationRelationshipCategoryUpdates;
  organizationOrganizationRelationshipConstraint: organizationOrganizationRelationshipConstraint;
  organizationOrganizationRelationshipInsertInput: organizationOrganizationRelationshipInsertInput;
  organizationOrganizationRelationshipMaxFields: ResolverTypeWrapper<organizationOrganizationRelationshipMaxFields>;
  organizationOrganizationRelationshipMinFields: ResolverTypeWrapper<organizationOrganizationRelationshipMinFields>;
  organizationOrganizationRelationshipMutationResponse: ResolverTypeWrapper<organizationOrganizationRelationshipMutationResponse>;
  organizationOrganizationRelationshipOnConflict: organizationOrganizationRelationshipOnConflict;
  organizationOrganizationRelationshipOrderBy: organizationOrganizationRelationshipOrderBy;
  organizationOrganizationRelationshipPkColumnsInput: organizationOrganizationRelationshipPkColumnsInput;
  organizationOrganizationRelationshipSelectColumn: organizationOrganizationRelationshipSelectColumn;
  organizationOrganizationRelationshipSetInput: organizationOrganizationRelationshipSetInput;
  organizationOrganizationRelationshipStreamCursorInput: organizationOrganizationRelationshipStreamCursorInput;
  organizationOrganizationRelationshipStreamCursorValueInput: organizationOrganizationRelationshipStreamCursorValueInput;
  organizationOrganizationRelationshipUpdateColumn: organizationOrganizationRelationshipUpdateColumn;
  organizationOrganizationRelationshipUpdates: organizationOrganizationRelationshipUpdates;
  organizationOrganizationUserAuthorization: ResolverTypeWrapper<organizationOrganizationUserAuthorization>;
  organizationOrganizationUserAuthorizationAggregate: ResolverTypeWrapper<organizationOrganizationUserAuthorizationAggregate>;
  organizationOrganizationUserAuthorizationAggregateBoolExp: organizationOrganizationUserAuthorizationAggregateBoolExp;
  organizationOrganizationUserAuthorizationAggregateBoolExpCount: organizationOrganizationUserAuthorizationAggregateBoolExpCount;
  organizationOrganizationUserAuthorizationAggregateFields: ResolverTypeWrapper<organizationOrganizationUserAuthorizationAggregateFields>;
  organizationOrganizationUserAuthorizationAggregateOrderBy: organizationOrganizationUserAuthorizationAggregateOrderBy;
  organizationOrganizationUserAuthorizationArrRelInsertInput: organizationOrganizationUserAuthorizationArrRelInsertInput;
  organizationOrganizationUserAuthorizationBoolExp: organizationOrganizationUserAuthorizationBoolExp;
  organizationOrganizationUserAuthorizationConstraint: organizationOrganizationUserAuthorizationConstraint;
  organizationOrganizationUserAuthorizationInsertInput: organizationOrganizationUserAuthorizationInsertInput;
  organizationOrganizationUserAuthorizationMaxFields: ResolverTypeWrapper<organizationOrganizationUserAuthorizationMaxFields>;
  organizationOrganizationUserAuthorizationMaxOrderBy: organizationOrganizationUserAuthorizationMaxOrderBy;
  organizationOrganizationUserAuthorizationMinFields: ResolverTypeWrapper<organizationOrganizationUserAuthorizationMinFields>;
  organizationOrganizationUserAuthorizationMinOrderBy: organizationOrganizationUserAuthorizationMinOrderBy;
  organizationOrganizationUserAuthorizationMutationResponse: ResolverTypeWrapper<organizationOrganizationUserAuthorizationMutationResponse>;
  organizationOrganizationUserAuthorizationOnConflict: organizationOrganizationUserAuthorizationOnConflict;
  organizationOrganizationUserAuthorizationOrderBy: organizationOrganizationUserAuthorizationOrderBy;
  organizationOrganizationUserAuthorizationPkColumnsInput: organizationOrganizationUserAuthorizationPkColumnsInput;
  organizationOrganizationUserAuthorizationSelectColumn: organizationOrganizationUserAuthorizationSelectColumn;
  organizationOrganizationUserAuthorizationSetInput: organizationOrganizationUserAuthorizationSetInput;
  organizationOrganizationUserAuthorizationStreamCursorInput: organizationOrganizationUserAuthorizationStreamCursorInput;
  organizationOrganizationUserAuthorizationStreamCursorValueInput: organizationOrganizationUserAuthorizationStreamCursorValueInput;
  organizationOrganizationUserAuthorizationUpdateColumn: organizationOrganizationUserAuthorizationUpdateColumn;
  organizationOrganizationUserAuthorizationUpdates: organizationOrganizationUserAuthorizationUpdates;
  organizationOrganizationUserOrganizationsView: ResolverTypeWrapper<organizationOrganizationUserOrganizationsView>;
  organizationOrganizationUserOrganizationsViewAggregate: ResolverTypeWrapper<organizationOrganizationUserOrganizationsViewAggregate>;
  organizationOrganizationUserOrganizationsViewAggregateBoolExp: organizationOrganizationUserOrganizationsViewAggregateBoolExp;
  organizationOrganizationUserOrganizationsViewAggregateBoolExpBool_and: organizationOrganizationUserOrganizationsViewAggregateBoolExpBool_and;
  organizationOrganizationUserOrganizationsViewAggregateBoolExpBool_or: organizationOrganizationUserOrganizationsViewAggregateBoolExpBool_or;
  organizationOrganizationUserOrganizationsViewAggregateBoolExpCount: organizationOrganizationUserOrganizationsViewAggregateBoolExpCount;
  organizationOrganizationUserOrganizationsViewAggregateFields: ResolverTypeWrapper<organizationOrganizationUserOrganizationsViewAggregateFields>;
  organizationOrganizationUserOrganizationsViewAggregateOrderBy: organizationOrganizationUserOrganizationsViewAggregateOrderBy;
  organizationOrganizationUserOrganizationsViewArrRelInsertInput: organizationOrganizationUserOrganizationsViewArrRelInsertInput;
  organizationOrganizationUserOrganizationsViewBoolExp: organizationOrganizationUserOrganizationsViewBoolExp;
  organizationOrganizationUserOrganizationsViewInsertInput: organizationOrganizationUserOrganizationsViewInsertInput;
  organizationOrganizationUserOrganizationsViewMaxFields: ResolverTypeWrapper<organizationOrganizationUserOrganizationsViewMaxFields>;
  organizationOrganizationUserOrganizationsViewMaxOrderBy: organizationOrganizationUserOrganizationsViewMaxOrderBy;
  organizationOrganizationUserOrganizationsViewMinFields: ResolverTypeWrapper<organizationOrganizationUserOrganizationsViewMinFields>;
  organizationOrganizationUserOrganizationsViewMinOrderBy: organizationOrganizationUserOrganizationsViewMinOrderBy;
  organizationOrganizationUserOrganizationsViewOrderBy: organizationOrganizationUserOrganizationsViewOrderBy;
  organizationOrganizationUserOrganizationsViewSelectColumn: organizationOrganizationUserOrganizationsViewSelectColumn;
  organizationOrganizationUserOrganizationsViewSelectColumnOrganizationOrganizationUserOrganizationsViewAggregateBoolExpBool_andArgumentsColumns: organizationOrganizationUserOrganizationsViewSelectColumnOrganizationOrganizationUserOrganizationsViewAggregateBoolExpBool_andArgumentsColumns;
  organizationOrganizationUserOrganizationsViewSelectColumnOrganizationOrganizationUserOrganizationsViewAggregateBoolExpBool_orArgumentsColumns: organizationOrganizationUserOrganizationsViewSelectColumnOrganizationOrganizationUserOrganizationsViewAggregateBoolExpBool_orArgumentsColumns;
  organizationOrganizationUserOrganizationsViewStreamCursorInput: organizationOrganizationUserOrganizationsViewStreamCursorInput;
  organizationOrganizationUserOrganizationsViewStreamCursorValueInput: organizationOrganizationUserOrganizationsViewStreamCursorValueInput;
  organizationOrganizationUserUsersView: ResolverTypeWrapper<organizationOrganizationUserUsersView>;
  organizationOrganizationUserUsersViewAggregate: ResolverTypeWrapper<organizationOrganizationUserUsersViewAggregate>;
  organizationOrganizationUserUsersViewAggregateBoolExp: organizationOrganizationUserUsersViewAggregateBoolExp;
  organizationOrganizationUserUsersViewAggregateBoolExpCount: organizationOrganizationUserUsersViewAggregateBoolExpCount;
  organizationOrganizationUserUsersViewAggregateFields: ResolverTypeWrapper<organizationOrganizationUserUsersViewAggregateFields>;
  organizationOrganizationUserUsersViewAggregateOrderBy: organizationOrganizationUserUsersViewAggregateOrderBy;
  organizationOrganizationUserUsersViewArrRelInsertInput: organizationOrganizationUserUsersViewArrRelInsertInput;
  organizationOrganizationUserUsersViewBoolExp: organizationOrganizationUserUsersViewBoolExp;
  organizationOrganizationUserUsersViewInsertInput: organizationOrganizationUserUsersViewInsertInput;
  organizationOrganizationUserUsersViewMaxFields: ResolverTypeWrapper<organizationOrganizationUserUsersViewMaxFields>;
  organizationOrganizationUserUsersViewMaxOrderBy: organizationOrganizationUserUsersViewMaxOrderBy;
  organizationOrganizationUserUsersViewMinFields: ResolverTypeWrapper<organizationOrganizationUserUsersViewMinFields>;
  organizationOrganizationUserUsersViewMinOrderBy: organizationOrganizationUserUsersViewMinOrderBy;
  organizationOrganizationUserUsersViewObjRelInsertInput: organizationOrganizationUserUsersViewObjRelInsertInput;
  organizationOrganizationUserUsersViewOrderBy: organizationOrganizationUserUsersViewOrderBy;
  organizationOrganizationUserUsersViewSelectColumn: organizationOrganizationUserUsersViewSelectColumn;
  organizationOrganizationUserUsersViewStreamCursorInput: organizationOrganizationUserUsersViewStreamCursorInput;
  organizationOrganizationUserUsersViewStreamCursorValueInput: organizationOrganizationUserUsersViewStreamCursorValueInput;
  organizationPkColumnsInput: organizationPkColumnsInput;
  organizationSelectColumn: organizationSelectColumn;
  organizationSelectColumnOrganizationAggregateBoolExpBool_andArgumentsColumns: organizationSelectColumnOrganizationAggregateBoolExpBool_andArgumentsColumns;
  organizationSelectColumnOrganizationAggregateBoolExpBool_orArgumentsColumns: organizationSelectColumnOrganizationAggregateBoolExpBool_orArgumentsColumns;
  organizationSetInput: organizationSetInput;
  organizationStddevFields: ResolverTypeWrapper<organizationStddevFields>;
  organizationStddevOrderBy: organizationStddevOrderBy;
  organizationStddevPopFields: ResolverTypeWrapper<organizationStddevPopFields>;
  organizationStddevPopOrderBy: organizationStddevPopOrderBy;
  organizationStddevSampFields: ResolverTypeWrapper<organizationStddevSampFields>;
  organizationStddevSampOrderBy: organizationStddevSampOrderBy;
  organizationStreamCursorInput: organizationStreamCursorInput;
  organizationStreamCursorValueInput: organizationStreamCursorValueInput;
  organizationSumFields: ResolverTypeWrapper<organizationSumFields>;
  organizationSumOrderBy: organizationSumOrderBy;
  organizationUpdateColumn: organizationUpdateColumn;
  organizationUpdates: organizationUpdates;
  organizationUser: ResolverTypeWrapper<organizationUser>;
  organizationUserAggregate: ResolverTypeWrapper<organizationUserAggregate>;
  organizationUserAggregateBoolExp: organizationUserAggregateBoolExp;
  organizationUserAggregateBoolExpCount: organizationUserAggregateBoolExpCount;
  organizationUserAggregateFields: ResolverTypeWrapper<organizationUserAggregateFields>;
  organizationUserAggregateOrderBy: organizationUserAggregateOrderBy;
  organizationUserAppendInput: organizationUserAppendInput;
  organizationUserArrRelInsertInput: organizationUserArrRelInsertInput;
  organizationUserAttachments: ResolverTypeWrapper<organizationUserAttachments>;
  organizationUserAttachmentsAggregate: ResolverTypeWrapper<organizationUserAttachmentsAggregate>;
  organizationUserAttachmentsAggregateBoolExp: organizationUserAttachmentsAggregateBoolExp;
  organizationUserAttachmentsAggregateBoolExpCount: organizationUserAttachmentsAggregateBoolExpCount;
  organizationUserAttachmentsAggregateFields: ResolverTypeWrapper<organizationUserAttachmentsAggregateFields>;
  organizationUserAttachmentsAggregateOrderBy: organizationUserAttachmentsAggregateOrderBy;
  organizationUserAttachmentsArrRelInsertInput: organizationUserAttachmentsArrRelInsertInput;
  organizationUserAttachmentsBoolExp: organizationUserAttachmentsBoolExp;
  organizationUserAttachmentsConstraint: organizationUserAttachmentsConstraint;
  organizationUserAttachmentsInsertInput: organizationUserAttachmentsInsertInput;
  organizationUserAttachmentsMaxFields: ResolverTypeWrapper<organizationUserAttachmentsMaxFields>;
  organizationUserAttachmentsMaxOrderBy: organizationUserAttachmentsMaxOrderBy;
  organizationUserAttachmentsMinFields: ResolverTypeWrapper<organizationUserAttachmentsMinFields>;
  organizationUserAttachmentsMinOrderBy: organizationUserAttachmentsMinOrderBy;
  organizationUserAttachmentsMutationResponse: ResolverTypeWrapper<organizationUserAttachmentsMutationResponse>;
  organizationUserAttachmentsOnConflict: organizationUserAttachmentsOnConflict;
  organizationUserAttachmentsOrderBy: organizationUserAttachmentsOrderBy;
  organizationUserAttachmentsPkColumnsInput: organizationUserAttachmentsPkColumnsInput;
  organizationUserAttachmentsSelectColumn: organizationUserAttachmentsSelectColumn;
  organizationUserAttachmentsSetInput: organizationUserAttachmentsSetInput;
  organizationUserAttachmentsStreamCursorInput: organizationUserAttachmentsStreamCursorInput;
  organizationUserAttachmentsStreamCursorValueInput: organizationUserAttachmentsStreamCursorValueInput;
  organizationUserAttachmentsUpdateColumn: organizationUserAttachmentsUpdateColumn;
  organizationUserAttachmentsUpdates: organizationUserAttachmentsUpdates;
  organizationUserAuthorization: ResolverTypeWrapper<organizationUserAuthorization>;
  organizationUserAuthorizationAggregate: ResolverTypeWrapper<organizationUserAuthorizationAggregate>;
  organizationUserAuthorizationAggregateFields: ResolverTypeWrapper<organizationUserAuthorizationAggregateFields>;
  organizationUserAuthorizationBoolExp: organizationUserAuthorizationBoolExp;
  organizationUserAuthorizationConstraint: organizationUserAuthorizationConstraint;
  organizationUserAuthorizationEnum: organizationUserAuthorizationEnum;
  organizationUserAuthorizationInsertInput: organizationUserAuthorizationInsertInput;
  organizationUserAuthorizationMaxFields: ResolverTypeWrapper<organizationUserAuthorizationMaxFields>;
  organizationUserAuthorizationMinFields: ResolverTypeWrapper<organizationUserAuthorizationMinFields>;
  organizationUserAuthorizationMutationResponse: ResolverTypeWrapper<organizationUserAuthorizationMutationResponse>;
  organizationUserAuthorizationObjRelInsertInput: organizationUserAuthorizationObjRelInsertInput;
  organizationUserAuthorizationOnConflict: organizationUserAuthorizationOnConflict;
  organizationUserAuthorizationOrderBy: organizationUserAuthorizationOrderBy;
  organizationUserAuthorizationPkColumnsInput: organizationUserAuthorizationPkColumnsInput;
  organizationUserAuthorizationSelectColumn: organizationUserAuthorizationSelectColumn;
  organizationUserAuthorizationSetInput: organizationUserAuthorizationSetInput;
  organizationUserAuthorizationStreamCursorInput: organizationUserAuthorizationStreamCursorInput;
  organizationUserAuthorizationStreamCursorValueInput: organizationUserAuthorizationStreamCursorValueInput;
  organizationUserAuthorizationUpdateColumn: organizationUserAuthorizationUpdateColumn;
  organizationUserAuthorizationUpdates: organizationUserAuthorizationUpdates;
  organizationUserBoolExp: organizationUserBoolExp;
  organizationUserConstraint: organizationUserConstraint;
  organizationUserDeleteAtPathInput: organizationUserDeleteAtPathInput;
  organizationUserDeleteElemInput: organizationUserDeleteElemInput;
  organizationUserDeleteKeyInput: organizationUserDeleteKeyInput;
  organizationUserDetail: ResolverTypeWrapper<organizationUserDetail>;
  organizationUserDetailAggregate: ResolverTypeWrapper<organizationUserDetailAggregate>;
  organizationUserDetailAggregateBoolExp: organizationUserDetailAggregateBoolExp;
  organizationUserDetailAggregateBoolExpCount: organizationUserDetailAggregateBoolExpCount;
  organizationUserDetailAggregateFields: ResolverTypeWrapper<organizationUserDetailAggregateFields>;
  organizationUserDetailAggregateOrderBy: organizationUserDetailAggregateOrderBy;
  organizationUserDetailArrRelInsertInput: organizationUserDetailArrRelInsertInput;
  organizationUserDetailBoolExp: organizationUserDetailBoolExp;
  organizationUserDetailConstraint: organizationUserDetailConstraint;
  organizationUserDetailInsertInput: organizationUserDetailInsertInput;
  organizationUserDetailMaxFields: ResolverTypeWrapper<organizationUserDetailMaxFields>;
  organizationUserDetailMaxOrderBy: organizationUserDetailMaxOrderBy;
  organizationUserDetailMinFields: ResolverTypeWrapper<organizationUserDetailMinFields>;
  organizationUserDetailMinOrderBy: organizationUserDetailMinOrderBy;
  organizationUserDetailMutationResponse: ResolverTypeWrapper<organizationUserDetailMutationResponse>;
  organizationUserDetailOnConflict: organizationUserDetailOnConflict;
  organizationUserDetailOrderBy: organizationUserDetailOrderBy;
  organizationUserDetailPkColumnsInput: organizationUserDetailPkColumnsInput;
  organizationUserDetailSelectColumn: organizationUserDetailSelectColumn;
  organizationUserDetailSetInput: organizationUserDetailSetInput;
  organizationUserDetailStreamCursorInput: organizationUserDetailStreamCursorInput;
  organizationUserDetailStreamCursorValueInput: organizationUserDetailStreamCursorValueInput;
  organizationUserDetailType: ResolverTypeWrapper<organizationUserDetailType>;
  organizationUserDetailTypeAggregate: ResolverTypeWrapper<organizationUserDetailTypeAggregate>;
  organizationUserDetailTypeAggregateFields: ResolverTypeWrapper<organizationUserDetailTypeAggregateFields>;
  organizationUserDetailTypeBoolExp: organizationUserDetailTypeBoolExp;
  organizationUserDetailTypeConstraint: organizationUserDetailTypeConstraint;
  organizationUserDetailTypeEnum: organizationUserDetailTypeEnum;
  organizationUserDetailTypeInsertInput: organizationUserDetailTypeInsertInput;
  organizationUserDetailTypeMaxFields: ResolverTypeWrapper<organizationUserDetailTypeMaxFields>;
  organizationUserDetailTypeMinFields: ResolverTypeWrapper<organizationUserDetailTypeMinFields>;
  organizationUserDetailTypeMutationResponse: ResolverTypeWrapper<organizationUserDetailTypeMutationResponse>;
  organizationUserDetailTypeObjRelInsertInput: organizationUserDetailTypeObjRelInsertInput;
  organizationUserDetailTypeOnConflict: organizationUserDetailTypeOnConflict;
  organizationUserDetailTypeOrderBy: organizationUserDetailTypeOrderBy;
  organizationUserDetailTypePkColumnsInput: organizationUserDetailTypePkColumnsInput;
  organizationUserDetailTypeSelectColumn: organizationUserDetailTypeSelectColumn;
  organizationUserDetailTypeSetInput: organizationUserDetailTypeSetInput;
  organizationUserDetailTypeStreamCursorInput: organizationUserDetailTypeStreamCursorInput;
  organizationUserDetailTypeStreamCursorValueInput: organizationUserDetailTypeStreamCursorValueInput;
  organizationUserDetailTypeUpdateColumn: organizationUserDetailTypeUpdateColumn;
  organizationUserDetailTypeUpdates: organizationUserDetailTypeUpdates;
  organizationUserDetailUpdateColumn: organizationUserDetailUpdateColumn;
  organizationUserDetailUpdates: organizationUserDetailUpdates;
  organizationUserInsertInput: organizationUserInsertInput;
  organizationUserInvite: ResolverTypeWrapper<organizationUserInvite>;
  organizationUserInviteAggregate: ResolverTypeWrapper<organizationUserInviteAggregate>;
  organizationUserInviteAggregateBoolExp: organizationUserInviteAggregateBoolExp;
  organizationUserInviteAggregateBoolExpCount: organizationUserInviteAggregateBoolExpCount;
  organizationUserInviteAggregateFields: ResolverTypeWrapper<organizationUserInviteAggregateFields>;
  organizationUserInviteAggregateOrderBy: organizationUserInviteAggregateOrderBy;
  organizationUserInviteAppendInput: organizationUserInviteAppendInput;
  organizationUserInviteArrRelInsertInput: organizationUserInviteArrRelInsertInput;
  organizationUserInviteBoolExp: organizationUserInviteBoolExp;
  organizationUserInviteConstraint: organizationUserInviteConstraint;
  organizationUserInviteDeleteAtPathInput: organizationUserInviteDeleteAtPathInput;
  organizationUserInviteDeleteElemInput: organizationUserInviteDeleteElemInput;
  organizationUserInviteDeleteKeyInput: organizationUserInviteDeleteKeyInput;
  organizationUserInviteInsertInput: organizationUserInviteInsertInput;
  organizationUserInviteMaxFields: ResolverTypeWrapper<organizationUserInviteMaxFields>;
  organizationUserInviteMaxOrderBy: organizationUserInviteMaxOrderBy;
  organizationUserInviteMinFields: ResolverTypeWrapper<organizationUserInviteMinFields>;
  organizationUserInviteMinOrderBy: organizationUserInviteMinOrderBy;
  organizationUserInviteMutationResponse: ResolverTypeWrapper<organizationUserInviteMutationResponse>;
  organizationUserInviteOnConflict: organizationUserInviteOnConflict;
  organizationUserInviteOrderBy: organizationUserInviteOrderBy;
  organizationUserInvitePkColumnsInput: organizationUserInvitePkColumnsInput;
  organizationUserInvitePrependInput: organizationUserInvitePrependInput;
  organizationUserInviteSelectColumn: organizationUserInviteSelectColumn;
  organizationUserInviteSetInput: organizationUserInviteSetInput;
  organizationUserInviteStreamCursorInput: organizationUserInviteStreamCursorInput;
  organizationUserInviteStreamCursorValueInput: organizationUserInviteStreamCursorValueInput;
  organizationUserInviteUpdateColumn: organizationUserInviteUpdateColumn;
  organizationUserInviteUpdates: organizationUserInviteUpdates;
  organizationUserMaxFields: ResolverTypeWrapper<organizationUserMaxFields>;
  organizationUserMaxOrderBy: organizationUserMaxOrderBy;
  organizationUserMinFields: ResolverTypeWrapper<organizationUserMinFields>;
  organizationUserMinOrderBy: organizationUserMinOrderBy;
  organizationUserMutationResponse: ResolverTypeWrapper<organizationUserMutationResponse>;
  organizationUserObjRelInsertInput: organizationUserObjRelInsertInput;
  organizationUserOnConflict: organizationUserOnConflict;
  organizationUserOrderBy: organizationUserOrderBy;
  organizationUserOutput: ResolverTypeWrapper<organizationUserOutput>;
  organizationUserPkColumnsInput: organizationUserPkColumnsInput;
  organizationUserPrependInput: organizationUserPrependInput;
  organizationUserSelectColumn: organizationUserSelectColumn;
  organizationUserSetInput: organizationUserSetInput;
  organizationUserStatus: ResolverTypeWrapper<organizationUserStatus>;
  organizationUserStatusAggregate: ResolverTypeWrapper<organizationUserStatusAggregate>;
  organizationUserStatusAggregateFields: ResolverTypeWrapper<organizationUserStatusAggregateFields>;
  organizationUserStatusBoolExp: organizationUserStatusBoolExp;
  organizationUserStatusConstraint: organizationUserStatusConstraint;
  organizationUserStatusEnum: organizationUserStatusEnum;
  organizationUserStatusInsertInput: organizationUserStatusInsertInput;
  organizationUserStatusMaxFields: ResolverTypeWrapper<organizationUserStatusMaxFields>;
  organizationUserStatusMinFields: ResolverTypeWrapper<organizationUserStatusMinFields>;
  organizationUserStatusMutationResponse: ResolverTypeWrapper<organizationUserStatusMutationResponse>;
  organizationUserStatusOnConflict: organizationUserStatusOnConflict;
  organizationUserStatusOrderBy: organizationUserStatusOrderBy;
  organizationUserStatusPkColumnsInput: organizationUserStatusPkColumnsInput;
  organizationUserStatusSelectColumn: organizationUserStatusSelectColumn;
  organizationUserStatusSetInput: organizationUserStatusSetInput;
  organizationUserStatusStreamCursorInput: organizationUserStatusStreamCursorInput;
  organizationUserStatusStreamCursorValueInput: organizationUserStatusStreamCursorValueInput;
  organizationUserStatusUpdateColumn: organizationUserStatusUpdateColumn;
  organizationUserStatusUpdates: organizationUserStatusUpdates;
  organizationUserStreamCursorInput: organizationUserStreamCursorInput;
  organizationUserStreamCursorValueInput: organizationUserStreamCursorValueInput;
  organizationUserUpdateColumn: organizationUserUpdateColumn;
  organizationUserUpdates: organizationUserUpdates;
  organizationUsers: ResolverTypeWrapper<organizationUsers>;
  organizationVarPopFields: ResolverTypeWrapper<organizationVarPopFields>;
  organizationVarPopOrderBy: organizationVarPopOrderBy;
  organizationVarSampFields: ResolverTypeWrapper<organizationVarSampFields>;
  organizationVarSampOrderBy: organizationVarSampOrderBy;
  organizationVarianceFields: ResolverTypeWrapper<organizationVarianceFields>;
  organizationVarianceOrderBy: organizationVarianceOrderBy;
  phoneNumberVerificationStatus: ResolverTypeWrapper<phoneNumberVerificationStatus>;
  phoneNumberVerificationStatusAggregate: ResolverTypeWrapper<phoneNumberVerificationStatusAggregate>;
  phoneNumberVerificationStatusAggregateFields: ResolverTypeWrapper<phoneNumberVerificationStatusAggregateFields>;
  phoneNumberVerificationStatusBoolExp: phoneNumberVerificationStatusBoolExp;
  phoneNumberVerificationStatusConstraint: phoneNumberVerificationStatusConstraint;
  phoneNumberVerificationStatusEnum: phoneNumberVerificationStatusEnum;
  phoneNumberVerificationStatusInsertInput: phoneNumberVerificationStatusInsertInput;
  phoneNumberVerificationStatusMaxFields: ResolverTypeWrapper<phoneNumberVerificationStatusMaxFields>;
  phoneNumberVerificationStatusMinFields: ResolverTypeWrapper<phoneNumberVerificationStatusMinFields>;
  phoneNumberVerificationStatusMutationResponse: ResolverTypeWrapper<phoneNumberVerificationStatusMutationResponse>;
  phoneNumberVerificationStatusOnConflict: phoneNumberVerificationStatusOnConflict;
  phoneNumberVerificationStatusOrderBy: phoneNumberVerificationStatusOrderBy;
  phoneNumberVerificationStatusPkColumnsInput: phoneNumberVerificationStatusPkColumnsInput;
  phoneNumberVerificationStatusSelectColumn: phoneNumberVerificationStatusSelectColumn;
  phoneNumberVerificationStatusSetInput: phoneNumberVerificationStatusSetInput;
  phoneNumberVerificationStatusStreamCursorInput: phoneNumberVerificationStatusStreamCursorInput;
  phoneNumberVerificationStatusStreamCursorValueInput: phoneNumberVerificationStatusStreamCursorValueInput;
  phoneNumberVerificationStatusUpdateColumn: phoneNumberVerificationStatusUpdateColumn;
  phoneNumberVerificationStatusUpdates: phoneNumberVerificationStatusUpdates;
  phoneUserOutput: ResolverTypeWrapper<phoneUserOutput>;
  privatizeUserResult: ResolverTypeWrapper<privatizeUserResult>;
  publicDevice: ResolverTypeWrapper<publicDevice>;
  publicDeviceAggregate: ResolverTypeWrapper<publicDeviceAggregate>;
  publicDeviceAggregateFields: ResolverTypeWrapper<publicDeviceAggregateFields>;
  publicDeviceBoolExp: publicDeviceBoolExp;
  publicDeviceConstraint: publicDeviceConstraint;
  publicDeviceInsertInput: publicDeviceInsertInput;
  publicDeviceMaxFields: ResolverTypeWrapper<publicDeviceMaxFields>;
  publicDeviceMinFields: ResolverTypeWrapper<publicDeviceMinFields>;
  publicDeviceMutationResponse: ResolverTypeWrapper<publicDeviceMutationResponse>;
  publicDeviceOnConflict: publicDeviceOnConflict;
  publicDeviceOrderBy: publicDeviceOrderBy;
  publicDevicePkColumnsInput: publicDevicePkColumnsInput;
  publicDeviceSelectColumn: publicDeviceSelectColumn;
  publicDeviceSetInput: publicDeviceSetInput;
  publicDeviceStreamCursorInput: publicDeviceStreamCursorInput;
  publicDeviceStreamCursorValueInput: publicDeviceStreamCursorValueInput;
  publicDeviceUpdateColumn: publicDeviceUpdateColumn;
  publicDeviceUpdates: publicDeviceUpdates;
  publicExternalRequest: ResolverTypeWrapper<publicExternalRequest>;
  publicExternalRequestAggregate: ResolverTypeWrapper<publicExternalRequestAggregate>;
  publicExternalRequestAggregateFields: ResolverTypeWrapper<publicExternalRequestAggregateFields>;
  publicExternalRequestAppendInput: publicExternalRequestAppendInput;
  publicExternalRequestBoolExp: publicExternalRequestBoolExp;
  publicExternalRequestConstraint: publicExternalRequestConstraint;
  publicExternalRequestDeleteAtPathInput: publicExternalRequestDeleteAtPathInput;
  publicExternalRequestDeleteElemInput: publicExternalRequestDeleteElemInput;
  publicExternalRequestDeleteKeyInput: publicExternalRequestDeleteKeyInput;
  publicExternalRequestInsertInput: publicExternalRequestInsertInput;
  publicExternalRequestMaxFields: ResolverTypeWrapper<publicExternalRequestMaxFields>;
  publicExternalRequestMinFields: ResolverTypeWrapper<publicExternalRequestMinFields>;
  publicExternalRequestMutationResponse: ResolverTypeWrapper<publicExternalRequestMutationResponse>;
  publicExternalRequestOnConflict: publicExternalRequestOnConflict;
  publicExternalRequestOrderBy: publicExternalRequestOrderBy;
  publicExternalRequestPkColumnsInput: publicExternalRequestPkColumnsInput;
  publicExternalRequestPrependInput: publicExternalRequestPrependInput;
  publicExternalRequestSelectColumn: publicExternalRequestSelectColumn;
  publicExternalRequestSetInput: publicExternalRequestSetInput;
  publicExternalRequestStreamCursorInput: publicExternalRequestStreamCursorInput;
  publicExternalRequestStreamCursorValueInput: publicExternalRequestStreamCursorValueInput;
  publicExternalRequestUpdateColumn: publicExternalRequestUpdateColumn;
  publicExternalRequestUpdates: publicExternalRequestUpdates;
  publicFile: ResolverTypeWrapper<publicFile>;
  publicFileAggregate: ResolverTypeWrapper<publicFileAggregate>;
  publicFileAggregateFields: ResolverTypeWrapper<publicFileAggregateFields>;
  publicFileBoolExp: publicFileBoolExp;
  publicFileConstraint: publicFileConstraint;
  publicFileInsertInput: publicFileInsertInput;
  publicFileMaxFields: ResolverTypeWrapper<publicFileMaxFields>;
  publicFileMinFields: ResolverTypeWrapper<publicFileMinFields>;
  publicFileMutationResponse: ResolverTypeWrapper<publicFileMutationResponse>;
  publicFileObjRelInsertInput: publicFileObjRelInsertInput;
  publicFileOnConflict: publicFileOnConflict;
  publicFileOrderBy: publicFileOrderBy;
  publicFilePkColumnsInput: publicFilePkColumnsInput;
  publicFileSelectColumn: publicFileSelectColumn;
  publicFileSetInput: publicFileSetInput;
  publicFileStreamCursorInput: publicFileStreamCursorInput;
  publicFileStreamCursorValueInput: publicFileStreamCursorValueInput;
  publicFileUpdateColumn: publicFileUpdateColumn;
  publicFileUpdates: publicFileUpdates;
  publicNotification: ResolverTypeWrapper<publicNotification>;
  publicNotificationAggregate: ResolverTypeWrapper<publicNotificationAggregate>;
  publicNotificationAggregateFields: ResolverTypeWrapper<publicNotificationAggregateFields>;
  publicNotificationAvgFields: ResolverTypeWrapper<publicNotificationAvgFields>;
  publicNotificationBoolExp: publicNotificationBoolExp;
  publicNotificationConstraint: publicNotificationConstraint;
  publicNotificationIncInput: publicNotificationIncInput;
  publicNotificationInsertInput: publicNotificationInsertInput;
  publicNotificationMaxFields: ResolverTypeWrapper<publicNotificationMaxFields>;
  publicNotificationMinFields: ResolverTypeWrapper<publicNotificationMinFields>;
  publicNotificationMutationResponse: ResolverTypeWrapper<publicNotificationMutationResponse>;
  publicNotificationOnConflict: publicNotificationOnConflict;
  publicNotificationOrderBy: publicNotificationOrderBy;
  publicNotificationPkColumnsInput: publicNotificationPkColumnsInput;
  publicNotificationSelectColumn: publicNotificationSelectColumn;
  publicNotificationSetInput: publicNotificationSetInput;
  publicNotificationStddevFields: ResolverTypeWrapper<publicNotificationStddevFields>;
  publicNotificationStddevPopFields: ResolverTypeWrapper<publicNotificationStddevPopFields>;
  publicNotificationStddevSampFields: ResolverTypeWrapper<publicNotificationStddevSampFields>;
  publicNotificationStreamCursorInput: publicNotificationStreamCursorInput;
  publicNotificationStreamCursorValueInput: publicNotificationStreamCursorValueInput;
  publicNotificationSumFields: ResolverTypeWrapper<publicNotificationSumFields>;
  publicNotificationUpdateColumn: publicNotificationUpdateColumn;
  publicNotificationUpdates: publicNotificationUpdates;
  publicNotificationVarPopFields: ResolverTypeWrapper<publicNotificationVarPopFields>;
  publicNotificationVarSampFields: ResolverTypeWrapper<publicNotificationVarSampFields>;
  publicNotificationVarianceFields: ResolverTypeWrapper<publicNotificationVarianceFields>;
  query_root: ResolverTypeWrapper<{}>;
  queueItem: ResolverTypeWrapper<queueItem>;
  queueItemAggregate: ResolverTypeWrapper<queueItemAggregate>;
  queueItemAggregateBoolExp: queueItemAggregateBoolExp;
  queueItemAggregateBoolExpBool_and: queueItemAggregateBoolExpBool_and;
  queueItemAggregateBoolExpBool_or: queueItemAggregateBoolExpBool_or;
  queueItemAggregateBoolExpCount: queueItemAggregateBoolExpCount;
  queueItemAggregateFields: ResolverTypeWrapper<queueItemAggregateFields>;
  queueItemAggregateOrderBy: queueItemAggregateOrderBy;
  queueItemAppendInput: queueItemAppendInput;
  queueItemArrRelInsertInput: queueItemArrRelInsertInput;
  queueItemBoolExp: queueItemBoolExp;
  queueItemConstraint: queueItemConstraint;
  queueItemDeleteAtPathInput: queueItemDeleteAtPathInput;
  queueItemDeleteElemInput: queueItemDeleteElemInput;
  queueItemDeleteKeyInput: queueItemDeleteKeyInput;
  queueItemInsertInput: queueItemInsertInput;
  queueItemMaxFields: ResolverTypeWrapper<queueItemMaxFields>;
  queueItemMaxOrderBy: queueItemMaxOrderBy;
  queueItemMinFields: ResolverTypeWrapper<queueItemMinFields>;
  queueItemMinOrderBy: queueItemMinOrderBy;
  queueItemMutationResponse: ResolverTypeWrapper<queueItemMutationResponse>;
  queueItemObjRelInsertInput: queueItemObjRelInsertInput;
  queueItemOnConflict: queueItemOnConflict;
  queueItemOrderBy: queueItemOrderBy;
  queueItemPkColumnsInput: queueItemPkColumnsInput;
  queueItemPrependInput: queueItemPrependInput;
  queueItemSelectColumn: queueItemSelectColumn;
  queueItemSelectColumnQueueItemAggregateBoolExpBool_andArgumentsColumns: queueItemSelectColumnQueueItemAggregateBoolExpBool_andArgumentsColumns;
  queueItemSelectColumnQueueItemAggregateBoolExpBool_orArgumentsColumns: queueItemSelectColumnQueueItemAggregateBoolExpBool_orArgumentsColumns;
  queueItemSetInput: queueItemSetInput;
  queueItemStreamCursorInput: queueItemStreamCursorInput;
  queueItemStreamCursorValueInput: queueItemStreamCursorValueInput;
  queueItemUpdateColumn: queueItemUpdateColumn;
  queueItemUpdates: queueItemUpdates;
  relOrganizationUserDomainUser: ResolverTypeWrapper<relOrganizationUserDomainUser>;
  relOrganizationUserDomainUserAggregate: ResolverTypeWrapper<relOrganizationUserDomainUserAggregate>;
  relOrganizationUserDomainUserAggregateBoolExp: relOrganizationUserDomainUserAggregateBoolExp;
  relOrganizationUserDomainUserAggregateBoolExpCount: relOrganizationUserDomainUserAggregateBoolExpCount;
  relOrganizationUserDomainUserAggregateFields: ResolverTypeWrapper<relOrganizationUserDomainUserAggregateFields>;
  relOrganizationUserDomainUserAggregateOrderBy: relOrganizationUserDomainUserAggregateOrderBy;
  relOrganizationUserDomainUserArrRelInsertInput: relOrganizationUserDomainUserArrRelInsertInput;
  relOrganizationUserDomainUserBoolExp: relOrganizationUserDomainUserBoolExp;
  relOrganizationUserDomainUserConstraint: relOrganizationUserDomainUserConstraint;
  relOrganizationUserDomainUserInsertInput: relOrganizationUserDomainUserInsertInput;
  relOrganizationUserDomainUserMaxFields: ResolverTypeWrapper<relOrganizationUserDomainUserMaxFields>;
  relOrganizationUserDomainUserMaxOrderBy: relOrganizationUserDomainUserMaxOrderBy;
  relOrganizationUserDomainUserMinFields: ResolverTypeWrapper<relOrganizationUserDomainUserMinFields>;
  relOrganizationUserDomainUserMinOrderBy: relOrganizationUserDomainUserMinOrderBy;
  relOrganizationUserDomainUserMutationResponse: ResolverTypeWrapper<relOrganizationUserDomainUserMutationResponse>;
  relOrganizationUserDomainUserOnConflict: relOrganizationUserDomainUserOnConflict;
  relOrganizationUserDomainUserOrderBy: relOrganizationUserDomainUserOrderBy;
  relOrganizationUserDomainUserPkColumnsInput: relOrganizationUserDomainUserPkColumnsInput;
  relOrganizationUserDomainUserSelectColumn: relOrganizationUserDomainUserSelectColumn;
  relOrganizationUserDomainUserSetInput: relOrganizationUserDomainUserSetInput;
  relOrganizationUserDomainUserStreamCursorInput: relOrganizationUserDomainUserStreamCursorInput;
  relOrganizationUserDomainUserStreamCursorValueInput: relOrganizationUserDomainUserStreamCursorValueInput;
  relOrganizationUserDomainUserUpdateColumn: relOrganizationUserDomainUserUpdateColumn;
  relOrganizationUserDomainUserUpdates: relOrganizationUserDomainUserUpdates;
  removeEmailDomainUserOutput: ResolverTypeWrapper<removeEmailDomainUserOutput>;
  removeEmailProviderIntegrationAccount: removeEmailProviderIntegrationAccount;
  removeEmailProviderIntegrationInput: removeEmailProviderIntegrationInput;
  removeOrganizationInput: removeOrganizationInput;
  removeOrganizationOutput: ResolverTypeWrapper<removeOrganizationOutput>;
  renewEmailProviderSubscriptionInput: renewEmailProviderSubscriptionInput;
  renewEmailProviderSubscriptionOutput: ResolverTypeWrapper<renewEmailProviderSubscriptionOutput>;
  setUpOrganizationOutput: ResolverTypeWrapper<setUpOrganizationOutput>;
  smsConnector: ResolverTypeWrapper<smsConnector>;
  smsConnectorAggregate: ResolverTypeWrapper<smsConnectorAggregate>;
  smsConnectorAggregateFields: ResolverTypeWrapper<smsConnectorAggregateFields>;
  smsConnectorAvgFields: ResolverTypeWrapper<smsConnectorAvgFields>;
  smsConnectorBoolExp: smsConnectorBoolExp;
  smsConnectorConstraint: smsConnectorConstraint;
  smsConnectorIncInput: smsConnectorIncInput;
  smsConnectorInsertInput: smsConnectorInsertInput;
  smsConnectorMaxFields: ResolverTypeWrapper<smsConnectorMaxFields>;
  smsConnectorMinFields: ResolverTypeWrapper<smsConnectorMinFields>;
  smsConnectorMutationResponse: ResolverTypeWrapper<smsConnectorMutationResponse>;
  smsConnectorOnConflict: smsConnectorOnConflict;
  smsConnectorOrderBy: smsConnectorOrderBy;
  smsConnectorPkColumnsInput: smsConnectorPkColumnsInput;
  smsConnectorSelectColumn: smsConnectorSelectColumn;
  smsConnectorSetInput: smsConnectorSetInput;
  smsConnectorStddevFields: ResolverTypeWrapper<smsConnectorStddevFields>;
  smsConnectorStddevPopFields: ResolverTypeWrapper<smsConnectorStddevPopFields>;
  smsConnectorStddevSampFields: ResolverTypeWrapper<smsConnectorStddevSampFields>;
  smsConnectorStreamCursorInput: smsConnectorStreamCursorInput;
  smsConnectorStreamCursorValueInput: smsConnectorStreamCursorValueInput;
  smsConnectorSumFields: ResolverTypeWrapper<smsConnectorSumFields>;
  smsConnectorUpdateColumn: smsConnectorUpdateColumn;
  smsConnectorUpdates: smsConnectorUpdates;
  smsConnectorVarPopFields: ResolverTypeWrapper<smsConnectorVarPopFields>;
  smsConnectorVarSampFields: ResolverTypeWrapper<smsConnectorVarSampFields>;
  smsConnectorVarianceFields: ResolverTypeWrapper<smsConnectorVarianceFields>;
  smsGate: ResolverTypeWrapper<smsGate>;
  smsGateAggregate: ResolverTypeWrapper<smsGateAggregate>;
  smsGateAggregateFields: ResolverTypeWrapper<smsGateAggregateFields>;
  smsGateAvgFields: ResolverTypeWrapper<smsGateAvgFields>;
  smsGateBoolExp: smsGateBoolExp;
  smsGateConstraint: smsGateConstraint;
  smsGateIncInput: smsGateIncInput;
  smsGateInsertInput: smsGateInsertInput;
  smsGateMaxFields: ResolverTypeWrapper<smsGateMaxFields>;
  smsGateMinFields: ResolverTypeWrapper<smsGateMinFields>;
  smsGateMutationResponse: ResolverTypeWrapper<smsGateMutationResponse>;
  smsGateOnConflict: smsGateOnConflict;
  smsGateOrderBy: smsGateOrderBy;
  smsGatePkColumnsInput: smsGatePkColumnsInput;
  smsGateSelectColumn: smsGateSelectColumn;
  smsGateSetInput: smsGateSetInput;
  smsGateStddevFields: ResolverTypeWrapper<smsGateStddevFields>;
  smsGateStddevPopFields: ResolverTypeWrapper<smsGateStddevPopFields>;
  smsGateStddevSampFields: ResolverTypeWrapper<smsGateStddevSampFields>;
  smsGateStreamCursorInput: smsGateStreamCursorInput;
  smsGateStreamCursorValueInput: smsGateStreamCursorValueInput;
  smsGateSumFields: ResolverTypeWrapper<smsGateSumFields>;
  smsGateUpdateColumn: smsGateUpdateColumn;
  smsGateUpdates: smsGateUpdates;
  smsGateVarPopFields: ResolverTypeWrapper<smsGateVarPopFields>;
  smsGateVarSampFields: ResolverTypeWrapper<smsGateVarSampFields>;
  smsGateVarianceFields: ResolverTypeWrapper<smsGateVarianceFields>;
  smsLinkMobilitySmsContent: ResolverTypeWrapper<smsLinkMobilitySmsContent>;
  smsLinkMobilitySmsContentAggregate: ResolverTypeWrapper<smsLinkMobilitySmsContentAggregate>;
  smsLinkMobilitySmsContentAggregateFields: ResolverTypeWrapper<smsLinkMobilitySmsContentAggregateFields>;
  smsLinkMobilitySmsContentBoolExp: smsLinkMobilitySmsContentBoolExp;
  smsLinkMobilitySmsContentConstraint: smsLinkMobilitySmsContentConstraint;
  smsLinkMobilitySmsContentInsertInput: smsLinkMobilitySmsContentInsertInput;
  smsLinkMobilitySmsContentMaxFields: ResolverTypeWrapper<smsLinkMobilitySmsContentMaxFields>;
  smsLinkMobilitySmsContentMinFields: ResolverTypeWrapper<smsLinkMobilitySmsContentMinFields>;
  smsLinkMobilitySmsContentMutationResponse: ResolverTypeWrapper<smsLinkMobilitySmsContentMutationResponse>;
  smsLinkMobilitySmsContentObjRelInsertInput: smsLinkMobilitySmsContentObjRelInsertInput;
  smsLinkMobilitySmsContentOnConflict: smsLinkMobilitySmsContentOnConflict;
  smsLinkMobilitySmsContentOrderBy: smsLinkMobilitySmsContentOrderBy;
  smsLinkMobilitySmsContentPkColumnsInput: smsLinkMobilitySmsContentPkColumnsInput;
  smsLinkMobilitySmsContentSelectColumn: smsLinkMobilitySmsContentSelectColumn;
  smsLinkMobilitySmsContentSetInput: smsLinkMobilitySmsContentSetInput;
  smsLinkMobilitySmsContentStreamCursorInput: smsLinkMobilitySmsContentStreamCursorInput;
  smsLinkMobilitySmsContentStreamCursorValueInput: smsLinkMobilitySmsContentStreamCursorValueInput;
  smsLinkMobilitySmsContentUpdateColumn: smsLinkMobilitySmsContentUpdateColumn;
  smsLinkMobilitySmsContentUpdates: smsLinkMobilitySmsContentUpdates;
  smsLinkMobilitySmsMessage: ResolverTypeWrapper<smsLinkMobilitySmsMessage>;
  smsLinkMobilitySmsMessageAggregate: ResolverTypeWrapper<smsLinkMobilitySmsMessageAggregate>;
  smsLinkMobilitySmsMessageAggregateFields: ResolverTypeWrapper<smsLinkMobilitySmsMessageAggregateFields>;
  smsLinkMobilitySmsMessageAppendInput: smsLinkMobilitySmsMessageAppendInput;
  smsLinkMobilitySmsMessageAvgFields: ResolverTypeWrapper<smsLinkMobilitySmsMessageAvgFields>;
  smsLinkMobilitySmsMessageBoolExp: smsLinkMobilitySmsMessageBoolExp;
  smsLinkMobilitySmsMessageConstraint: smsLinkMobilitySmsMessageConstraint;
  smsLinkMobilitySmsMessageDeleteAtPathInput: smsLinkMobilitySmsMessageDeleteAtPathInput;
  smsLinkMobilitySmsMessageDeleteElemInput: smsLinkMobilitySmsMessageDeleteElemInput;
  smsLinkMobilitySmsMessageDeleteKeyInput: smsLinkMobilitySmsMessageDeleteKeyInput;
  smsLinkMobilitySmsMessageIncInput: smsLinkMobilitySmsMessageIncInput;
  smsLinkMobilitySmsMessageInsertInput: smsLinkMobilitySmsMessageInsertInput;
  smsLinkMobilitySmsMessageMaxFields: ResolverTypeWrapper<smsLinkMobilitySmsMessageMaxFields>;
  smsLinkMobilitySmsMessageMinFields: ResolverTypeWrapper<smsLinkMobilitySmsMessageMinFields>;
  smsLinkMobilitySmsMessageMutationResponse: ResolverTypeWrapper<smsLinkMobilitySmsMessageMutationResponse>;
  smsLinkMobilitySmsMessageObjRelInsertInput: smsLinkMobilitySmsMessageObjRelInsertInput;
  smsLinkMobilitySmsMessageOnConflict: smsLinkMobilitySmsMessageOnConflict;
  smsLinkMobilitySmsMessageOrderBy: smsLinkMobilitySmsMessageOrderBy;
  smsLinkMobilitySmsMessagePkColumnsInput: smsLinkMobilitySmsMessagePkColumnsInput;
  smsLinkMobilitySmsMessagePrependInput: smsLinkMobilitySmsMessagePrependInput;
  smsLinkMobilitySmsMessageSelectColumn: smsLinkMobilitySmsMessageSelectColumn;
  smsLinkMobilitySmsMessageSetInput: smsLinkMobilitySmsMessageSetInput;
  smsLinkMobilitySmsMessageStddevFields: ResolverTypeWrapper<smsLinkMobilitySmsMessageStddevFields>;
  smsLinkMobilitySmsMessageStddevPopFields: ResolverTypeWrapper<smsLinkMobilitySmsMessageStddevPopFields>;
  smsLinkMobilitySmsMessageStddevSampFields: ResolverTypeWrapper<smsLinkMobilitySmsMessageStddevSampFields>;
  smsLinkMobilitySmsMessageStreamCursorInput: smsLinkMobilitySmsMessageStreamCursorInput;
  smsLinkMobilitySmsMessageStreamCursorValueInput: smsLinkMobilitySmsMessageStreamCursorValueInput;
  smsLinkMobilitySmsMessageSumFields: ResolverTypeWrapper<smsLinkMobilitySmsMessageSumFields>;
  smsLinkMobilitySmsMessageUpdateColumn: smsLinkMobilitySmsMessageUpdateColumn;
  smsLinkMobilitySmsMessageUpdates: smsLinkMobilitySmsMessageUpdates;
  smsLinkMobilitySmsMessageVarPopFields: ResolverTypeWrapper<smsLinkMobilitySmsMessageVarPopFields>;
  smsLinkMobilitySmsMessageVarSampFields: ResolverTypeWrapper<smsLinkMobilitySmsMessageVarSampFields>;
  smsLinkMobilitySmsMessageVarianceFields: ResolverTypeWrapper<smsLinkMobilitySmsMessageVarianceFields>;
  smsLinkMobilitySmsRoute: ResolverTypeWrapper<smsLinkMobilitySmsRoute>;
  smsLinkMobilitySmsRouteAggregate: ResolverTypeWrapper<smsLinkMobilitySmsRouteAggregate>;
  smsLinkMobilitySmsRouteAggregateFields: ResolverTypeWrapper<smsLinkMobilitySmsRouteAggregateFields>;
  smsLinkMobilitySmsRouteAppendInput: smsLinkMobilitySmsRouteAppendInput;
  smsLinkMobilitySmsRouteBoolExp: smsLinkMobilitySmsRouteBoolExp;
  smsLinkMobilitySmsRouteConstraint: smsLinkMobilitySmsRouteConstraint;
  smsLinkMobilitySmsRouteDeleteAtPathInput: smsLinkMobilitySmsRouteDeleteAtPathInput;
  smsLinkMobilitySmsRouteDeleteElemInput: smsLinkMobilitySmsRouteDeleteElemInput;
  smsLinkMobilitySmsRouteDeleteKeyInput: smsLinkMobilitySmsRouteDeleteKeyInput;
  smsLinkMobilitySmsRouteInsertInput: smsLinkMobilitySmsRouteInsertInput;
  smsLinkMobilitySmsRouteMaxFields: ResolverTypeWrapper<smsLinkMobilitySmsRouteMaxFields>;
  smsLinkMobilitySmsRouteMinFields: ResolverTypeWrapper<smsLinkMobilitySmsRouteMinFields>;
  smsLinkMobilitySmsRouteMutationResponse: ResolverTypeWrapper<smsLinkMobilitySmsRouteMutationResponse>;
  smsLinkMobilitySmsRouteObjRelInsertInput: smsLinkMobilitySmsRouteObjRelInsertInput;
  smsLinkMobilitySmsRouteOnConflict: smsLinkMobilitySmsRouteOnConflict;
  smsLinkMobilitySmsRouteOrderBy: smsLinkMobilitySmsRouteOrderBy;
  smsLinkMobilitySmsRoutePkColumnsInput: smsLinkMobilitySmsRoutePkColumnsInput;
  smsLinkMobilitySmsRoutePrependInput: smsLinkMobilitySmsRoutePrependInput;
  smsLinkMobilitySmsRouteSelectColumn: smsLinkMobilitySmsRouteSelectColumn;
  smsLinkMobilitySmsRouteSetInput: smsLinkMobilitySmsRouteSetInput;
  smsLinkMobilitySmsRouteStreamCursorInput: smsLinkMobilitySmsRouteStreamCursorInput;
  smsLinkMobilitySmsRouteStreamCursorValueInput: smsLinkMobilitySmsRouteStreamCursorValueInput;
  smsLinkMobilitySmsRouteUpdateColumn: smsLinkMobilitySmsRouteUpdateColumn;
  smsLinkMobilitySmsRouteUpdates: smsLinkMobilitySmsRouteUpdates;
  smsProvider: ResolverTypeWrapper<smsProvider>;
  smsProviderAggregate: ResolverTypeWrapper<smsProviderAggregate>;
  smsProviderAggregateFields: ResolverTypeWrapper<smsProviderAggregateFields>;
  smsProviderAvgFields: ResolverTypeWrapper<smsProviderAvgFields>;
  smsProviderBoolExp: smsProviderBoolExp;
  smsProviderConstraint: smsProviderConstraint;
  smsProviderIncInput: smsProviderIncInput;
  smsProviderInsertInput: smsProviderInsertInput;
  smsProviderMaxFields: ResolverTypeWrapper<smsProviderMaxFields>;
  smsProviderMinFields: ResolverTypeWrapper<smsProviderMinFields>;
  smsProviderMutationResponse: ResolverTypeWrapper<smsProviderMutationResponse>;
  smsProviderOnConflict: smsProviderOnConflict;
  smsProviderOrderBy: smsProviderOrderBy;
  smsProviderPkColumnsInput: smsProviderPkColumnsInput;
  smsProviderSelectColumn: smsProviderSelectColumn;
  smsProviderSetInput: smsProviderSetInput;
  smsProviderStddevFields: ResolverTypeWrapper<smsProviderStddevFields>;
  smsProviderStddevPopFields: ResolverTypeWrapper<smsProviderStddevPopFields>;
  smsProviderStddevSampFields: ResolverTypeWrapper<smsProviderStddevSampFields>;
  smsProviderStreamCursorInput: smsProviderStreamCursorInput;
  smsProviderStreamCursorValueInput: smsProviderStreamCursorValueInput;
  smsProviderSumFields: ResolverTypeWrapper<smsProviderSumFields>;
  smsProviderUpdateColumn: smsProviderUpdateColumn;
  smsProviderUpdates: smsProviderUpdates;
  smsProviderVarPopFields: ResolverTypeWrapper<smsProviderVarPopFields>;
  smsProviderVarSampFields: ResolverTypeWrapper<smsProviderVarSampFields>;
  smsProviderVarianceFields: ResolverTypeWrapper<smsProviderVarianceFields>;
  smsSm: ResolverTypeWrapper<smsSm>;
  smsSmAggregate: ResolverTypeWrapper<smsSmAggregate>;
  smsSmAggregateFields: ResolverTypeWrapper<smsSmAggregateFields>;
  smsSmAvgFields: ResolverTypeWrapper<smsSmAvgFields>;
  smsSmBoolExp: smsSmBoolExp;
  smsSmConstraint: smsSmConstraint;
  smsSmIncInput: smsSmIncInput;
  smsSmInsertInput: smsSmInsertInput;
  smsSmMaxFields: ResolverTypeWrapper<smsSmMaxFields>;
  smsSmMinFields: ResolverTypeWrapper<smsSmMinFields>;
  smsSmMutationResponse: ResolverTypeWrapper<smsSmMutationResponse>;
  smsSmOnConflict: smsSmOnConflict;
  smsSmOrderBy: smsSmOrderBy;
  smsSmPkColumnsInput: smsSmPkColumnsInput;
  smsSmSelectColumn: smsSmSelectColumn;
  smsSmSetInput: smsSmSetInput;
  smsSmStddevFields: ResolverTypeWrapper<smsSmStddevFields>;
  smsSmStddevPopFields: ResolverTypeWrapper<smsSmStddevPopFields>;
  smsSmStddevSampFields: ResolverTypeWrapper<smsSmStddevSampFields>;
  smsSmStreamCursorInput: smsSmStreamCursorInput;
  smsSmStreamCursorValueInput: smsSmStreamCursorValueInput;
  smsSmSumFields: ResolverTypeWrapper<smsSmSumFields>;
  smsSmUpdateColumn: smsSmUpdateColumn;
  smsSmUpdates: smsSmUpdates;
  smsSmVarPopFields: ResolverTypeWrapper<smsSmVarPopFields>;
  smsSmVarSampFields: ResolverTypeWrapper<smsSmVarSampFields>;
  smsSmVarianceFields: ResolverTypeWrapper<smsSmVarianceFields>;
  smsSmsExternalIncomingLinkMobility: ResolverTypeWrapper<smsSmsExternalIncomingLinkMobility>;
  smsSmsExternalIncomingLinkMobilityAggregate: ResolverTypeWrapper<smsSmsExternalIncomingLinkMobilityAggregate>;
  smsSmsExternalIncomingLinkMobilityAggregateFields: ResolverTypeWrapper<smsSmsExternalIncomingLinkMobilityAggregateFields>;
  smsSmsExternalIncomingLinkMobilityBoolExp: smsSmsExternalIncomingLinkMobilityBoolExp;
  smsSmsExternalIncomingLinkMobilityConstraint: smsSmsExternalIncomingLinkMobilityConstraint;
  smsSmsExternalIncomingLinkMobilityInsertInput: smsSmsExternalIncomingLinkMobilityInsertInput;
  smsSmsExternalIncomingLinkMobilityMaxFields: ResolverTypeWrapper<smsSmsExternalIncomingLinkMobilityMaxFields>;
  smsSmsExternalIncomingLinkMobilityMinFields: ResolverTypeWrapper<smsSmsExternalIncomingLinkMobilityMinFields>;
  smsSmsExternalIncomingLinkMobilityMutationResponse: ResolverTypeWrapper<smsSmsExternalIncomingLinkMobilityMutationResponse>;
  smsSmsExternalIncomingLinkMobilityOnConflict: smsSmsExternalIncomingLinkMobilityOnConflict;
  smsSmsExternalIncomingLinkMobilityOrderBy: smsSmsExternalIncomingLinkMobilityOrderBy;
  smsSmsExternalIncomingLinkMobilityPkColumnsInput: smsSmsExternalIncomingLinkMobilityPkColumnsInput;
  smsSmsExternalIncomingLinkMobilitySelectColumn: smsSmsExternalIncomingLinkMobilitySelectColumn;
  smsSmsExternalIncomingLinkMobilitySetInput: smsSmsExternalIncomingLinkMobilitySetInput;
  smsSmsExternalIncomingLinkMobilityStreamCursorInput: smsSmsExternalIncomingLinkMobilityStreamCursorInput;
  smsSmsExternalIncomingLinkMobilityStreamCursorValueInput: smsSmsExternalIncomingLinkMobilityStreamCursorValueInput;
  smsSmsExternalIncomingLinkMobilityUpdateColumn: smsSmsExternalIncomingLinkMobilityUpdateColumn;
  smsSmsExternalIncomingLinkMobilityUpdates: smsSmsExternalIncomingLinkMobilityUpdates;
  subscription_root: ResolverTypeWrapper<{}>;
  taskmutation_root: ResolverTypeWrapper<taskmutation_root>;
  taskquery_root: ResolverTypeWrapper<taskquery_root>;
  tasksubscription_root: ResolverTypeWrapper<tasksubscription_root>;
  telephonyDomainUserOutput: ResolverTypeWrapper<telephonyDomainUserOutput>;
  telephonyProviderIntegrationAccount: telephonyProviderIntegrationAccount;
  telephonyProviderIntegrationConfiguration: telephonyProviderIntegrationConfiguration;
  telephonyProviderIntegrationInput: telephonyProviderIntegrationInput;
  telephonymutation_root: ResolverTypeWrapper<telephonymutation_root>;
  telephonyquery_root: ResolverTypeWrapper<telephonyquery_root>;
  telephonysubscription_root: ResolverTypeWrapper<telephonysubscription_root>;
  testNotificationSettingsResult: ResolverTypeWrapper<testNotificationSettingsResult>;
  timestamp: ResolverTypeWrapper<Scalars['timestamp']['output']>;
  timestamptz: ResolverTypeWrapper<Scalars['timestamptz']['output']>;
  timetz: ResolverTypeWrapper<Scalars['timetz']['output']>;
  updateDashboardDataOutput: ResolverTypeWrapper<updateDashboardDataOutput>;
  user: ResolverTypeWrapper<user>;
  userAggregate: ResolverTypeWrapper<userAggregate>;
  userAggregateBoolExp: userAggregateBoolExp;
  userAggregateBoolExpBool_and: userAggregateBoolExpBool_and;
  userAggregateBoolExpBool_or: userAggregateBoolExpBool_or;
  userAggregateBoolExpCount: userAggregateBoolExpCount;
  userAggregateFields: ResolverTypeWrapper<userAggregateFields>;
  userAggregateOrderBy: userAggregateOrderBy;
  userArrRelInsertInput: userArrRelInsertInput;
  userBoolExp: userBoolExp;
  userConstraint: userConstraint;
  userDeleteOutput: ResolverTypeWrapper<userDeleteOutput>;
  userDetail: ResolverTypeWrapper<userDetail>;
  userDetailAggregate: ResolverTypeWrapper<userDetailAggregate>;
  userDetailAggregateBoolExp: userDetailAggregateBoolExp;
  userDetailAggregateBoolExpCount: userDetailAggregateBoolExpCount;
  userDetailAggregateFields: ResolverTypeWrapper<userDetailAggregateFields>;
  userDetailAggregateOrderBy: userDetailAggregateOrderBy;
  userDetailArrRelInsertInput: userDetailArrRelInsertInput;
  userDetailBoolExp: userDetailBoolExp;
  userDetailConstraint: userDetailConstraint;
  userDetailInsertInput: userDetailInsertInput;
  userDetailMaxFields: ResolverTypeWrapper<userDetailMaxFields>;
  userDetailMaxOrderBy: userDetailMaxOrderBy;
  userDetailMinFields: ResolverTypeWrapper<userDetailMinFields>;
  userDetailMinOrderBy: userDetailMinOrderBy;
  userDetailMutationResponse: ResolverTypeWrapper<userDetailMutationResponse>;
  userDetailOnConflict: userDetailOnConflict;
  userDetailOrderBy: userDetailOrderBy;
  userDetailPkColumnsInput: userDetailPkColumnsInput;
  userDetailSelectColumn: userDetailSelectColumn;
  userDetailSetInput: userDetailSetInput;
  userDetailStreamCursorInput: userDetailStreamCursorInput;
  userDetailStreamCursorValueInput: userDetailStreamCursorValueInput;
  userDetailUpdateColumn: userDetailUpdateColumn;
  userDetailUpdates: userDetailUpdates;
  userDetailsType: ResolverTypeWrapper<userDetailsType>;
  userDetailsTypeAggregate: ResolverTypeWrapper<userDetailsTypeAggregate>;
  userDetailsTypeAggregateFields: ResolverTypeWrapper<userDetailsTypeAggregateFields>;
  userDetailsTypeBoolExp: userDetailsTypeBoolExp;
  userDetailsTypeConstraint: userDetailsTypeConstraint;
  userDetailsTypeEnum: userDetailsTypeEnum;
  userDetailsTypeInsertInput: userDetailsTypeInsertInput;
  userDetailsTypeMaxFields: ResolverTypeWrapper<userDetailsTypeMaxFields>;
  userDetailsTypeMinFields: ResolverTypeWrapper<userDetailsTypeMinFields>;
  userDetailsTypeMutationResponse: ResolverTypeWrapper<userDetailsTypeMutationResponse>;
  userDetailsTypeOnConflict: userDetailsTypeOnConflict;
  userDetailsTypeOrderBy: userDetailsTypeOrderBy;
  userDetailsTypePkColumnsInput: userDetailsTypePkColumnsInput;
  userDetailsTypeSelectColumn: userDetailsTypeSelectColumn;
  userDetailsTypeSetInput: userDetailsTypeSetInput;
  userDetailsTypeStreamCursorInput: userDetailsTypeStreamCursorInput;
  userDetailsTypeStreamCursorValueInput: userDetailsTypeStreamCursorValueInput;
  userDetailsTypeUpdateColumn: userDetailsTypeUpdateColumn;
  userDetailsTypeUpdates: userDetailsTypeUpdates;
  userDevice: ResolverTypeWrapper<userDevice>;
  userDeviceAggregate: ResolverTypeWrapper<userDeviceAggregate>;
  userDeviceAggregateFields: ResolverTypeWrapper<userDeviceAggregateFields>;
  userDeviceBoolExp: userDeviceBoolExp;
  userDeviceConstraint: userDeviceConstraint;
  userDeviceInsertInput: userDeviceInsertInput;
  userDeviceMaxFields: ResolverTypeWrapper<userDeviceMaxFields>;
  userDeviceMinFields: ResolverTypeWrapper<userDeviceMinFields>;
  userDeviceMutationResponse: ResolverTypeWrapper<userDeviceMutationResponse>;
  userDeviceOnConflict: userDeviceOnConflict;
  userDeviceOrderBy: userDeviceOrderBy;
  userDevicePkColumnsInput: userDevicePkColumnsInput;
  userDeviceSelectColumn: userDeviceSelectColumn;
  userDeviceSetInput: userDeviceSetInput;
  userDeviceStreamCursorInput: userDeviceStreamCursorInput;
  userDeviceStreamCursorValueInput: userDeviceStreamCursorValueInput;
  userDeviceUpdateColumn: userDeviceUpdateColumn;
  userDeviceUpdates: userDeviceUpdates;
  userInput: userInput;
  userInsertInput: userInsertInput;
  userMaxFields: ResolverTypeWrapper<userMaxFields>;
  userMaxOrderBy: userMaxOrderBy;
  userMinFields: ResolverTypeWrapper<userMinFields>;
  userMinOrderBy: userMinOrderBy;
  userMutationResponse: ResolverTypeWrapper<userMutationResponse>;
  userObjRelInsertInput: userObjRelInsertInput;
  userOnConflict: userOnConflict;
  userOrderBy: userOrderBy;
  userPhoneNumber: ResolverTypeWrapper<userPhoneNumber>;
  userPhoneNumberAggregate: ResolverTypeWrapper<userPhoneNumberAggregate>;
  userPhoneNumberAggregateFields: ResolverTypeWrapper<userPhoneNumberAggregateFields>;
  userPhoneNumberBoolExp: userPhoneNumberBoolExp;
  userPhoneNumberConstraint: userPhoneNumberConstraint;
  userPhoneNumberInsertInput: userPhoneNumberInsertInput;
  userPhoneNumberMaxFields: ResolverTypeWrapper<userPhoneNumberMaxFields>;
  userPhoneNumberMinFields: ResolverTypeWrapper<userPhoneNumberMinFields>;
  userPhoneNumberMutationResponse: ResolverTypeWrapper<userPhoneNumberMutationResponse>;
  userPhoneNumberOnConflict: userPhoneNumberOnConflict;
  userPhoneNumberOrderBy: userPhoneNumberOrderBy;
  userPhoneNumberPkColumnsInput: userPhoneNumberPkColumnsInput;
  userPhoneNumberSelectColumn: userPhoneNumberSelectColumn;
  userPhoneNumberSetInput: userPhoneNumberSetInput;
  userPhoneNumberStreamCursorInput: userPhoneNumberStreamCursorInput;
  userPhoneNumberStreamCursorValueInput: userPhoneNumberStreamCursorValueInput;
  userPhoneNumberUpdateColumn: userPhoneNumberUpdateColumn;
  userPhoneNumberUpdates: userPhoneNumberUpdates;
  userPkColumnsInput: userPkColumnsInput;
  userRole: ResolverTypeWrapper<userRole>;
  userRoleAggregate: ResolverTypeWrapper<userRoleAggregate>;
  userRoleAggregateFields: ResolverTypeWrapper<userRoleAggregateFields>;
  userRoleBoolExp: userRoleBoolExp;
  userRoleConstraint: userRoleConstraint;
  userRoleEnum: userRoleEnum;
  userRoleInsertInput: userRoleInsertInput;
  userRoleMaxFields: ResolverTypeWrapper<userRoleMaxFields>;
  userRoleMinFields: ResolverTypeWrapper<userRoleMinFields>;
  userRoleMutationResponse: ResolverTypeWrapper<userRoleMutationResponse>;
  userRoleOnConflict: userRoleOnConflict;
  userRoleOrderBy: userRoleOrderBy;
  userRolePkColumnsInput: userRolePkColumnsInput;
  userRoleSelectColumn: userRoleSelectColumn;
  userRoleSetInput: userRoleSetInput;
  userRoleStreamCursorInput: userRoleStreamCursorInput;
  userRoleStreamCursorValueInput: userRoleStreamCursorValueInput;
  userRoleUpdateColumn: userRoleUpdateColumn;
  userRoleUpdates: userRoleUpdates;
  userSelectColumn: userSelectColumn;
  userSelectColumnUserAggregateBoolExpBool_andArgumentsColumns: userSelectColumnUserAggregateBoolExpBool_andArgumentsColumns;
  userSelectColumnUserAggregateBoolExpBool_orArgumentsColumns: userSelectColumnUserAggregateBoolExpBool_orArgumentsColumns;
  userSetInput: userSetInput;
  userStreamCursorInput: userStreamCursorInput;
  userStreamCursorValueInput: userStreamCursorValueInput;
  userUpdateColumn: userUpdateColumn;
  userUpdates: userUpdates;
  uuid: ResolverTypeWrapper<Scalars['uuid']['output']>;
  validationValidation: ResolverTypeWrapper<validationValidation>;
  validationValidationAggregate: ResolverTypeWrapper<validationValidationAggregate>;
  validationValidationAggregateFields: ResolverTypeWrapper<validationValidationAggregateFields>;
  validationValidationAvgFields: ResolverTypeWrapper<validationValidationAvgFields>;
  validationValidationBoolExp: validationValidationBoolExp;
  validationValidationConstraint: validationValidationConstraint;
  validationValidationIncInput: validationValidationIncInput;
  validationValidationInsertInput: validationValidationInsertInput;
  validationValidationMaxFields: ResolverTypeWrapper<validationValidationMaxFields>;
  validationValidationMinFields: ResolverTypeWrapper<validationValidationMinFields>;
  validationValidationMutationResponse: ResolverTypeWrapper<validationValidationMutationResponse>;
  validationValidationOnConflict: validationValidationOnConflict;
  validationValidationOrderBy: validationValidationOrderBy;
  validationValidationPkColumnsInput: validationValidationPkColumnsInput;
  validationValidationSelectColumn: validationValidationSelectColumn;
  validationValidationSetInput: validationValidationSetInput;
  validationValidationStddevFields: ResolverTypeWrapper<validationValidationStddevFields>;
  validationValidationStddevPopFields: ResolverTypeWrapper<validationValidationStddevPopFields>;
  validationValidationStddevSampFields: ResolverTypeWrapper<validationValidationStddevSampFields>;
  validationValidationStreamCursorInput: validationValidationStreamCursorInput;
  validationValidationStreamCursorValueInput: validationValidationStreamCursorValueInput;
  validationValidationSumFields: ResolverTypeWrapper<validationValidationSumFields>;
  validationValidationUpdateColumn: validationValidationUpdateColumn;
  validationValidationUpdates: validationValidationUpdates;
  validationValidationVarPopFields: ResolverTypeWrapper<validationValidationVarPopFields>;
  validationValidationVarSampFields: ResolverTypeWrapper<validationValidationVarSampFields>;
  validationValidationVarianceFields: ResolverTypeWrapper<validationValidationVarianceFields>;
  verifyOrganizationUserPhoneNumberInput: verifyOrganizationUserPhoneNumberInput;
  verifyOrganizationUserPhoneNumberOutput: ResolverTypeWrapper<verifyOrganizationUserPhoneNumberOutput>;
  videoInviteOrgUserInput: videoInviteOrgUserInput;
  videoInviteOrgUserOutput: ResolverTypeWrapper<videoInviteOrgUserOutput>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  ActivityDirection: ActivityDirection;
  ActivityDirectionAggregate: ActivityDirectionAggregate;
  ActivityDirectionAggregateFields: ActivityDirectionAggregateFields;
  ActivityDirectionBoolExp: ActivityDirectionBoolExp;
  ActivityDirectionEnumComparisonExp: ActivityDirectionEnumComparisonExp;
  ActivityDirectionInsertInput: ActivityDirectionInsertInput;
  ActivityDirectionMaxFields: ActivityDirectionMaxFields;
  ActivityDirectionMinFields: ActivityDirectionMinFields;
  ActivityDirectionMutationResponse: ActivityDirectionMutationResponse;
  ActivityDirectionOnConflict: ActivityDirectionOnConflict;
  ActivityDirectionOrderBy: ActivityDirectionOrderBy;
  ActivityDirectionPkColumnsInput: ActivityDirectionPkColumnsInput;
  ActivityDirectionSetInput: ActivityDirectionSetInput;
  ActivityDirectionStreamCursorInput: ActivityDirectionStreamCursorInput;
  ActivityDirectionStreamCursorValueInput: ActivityDirectionStreamCursorValueInput;
  ActivityDirectionUpdates: ActivityDirectionUpdates;
  ActivityProvider: ActivityProvider;
  ActivityProviderAggregate: ActivityProviderAggregate;
  ActivityProviderAggregateFields: ActivityProviderAggregateFields;
  ActivityProviderBoolExp: ActivityProviderBoolExp;
  ActivityProviderEnumComparisonExp: ActivityProviderEnumComparisonExp;
  ActivityProviderInsertInput: ActivityProviderInsertInput;
  ActivityProviderMaxFields: ActivityProviderMaxFields;
  ActivityProviderMinFields: ActivityProviderMinFields;
  ActivityProviderMutationResponse: ActivityProviderMutationResponse;
  ActivityProviderOnConflict: ActivityProviderOnConflict;
  ActivityProviderOrderBy: ActivityProviderOrderBy;
  ActivityProviderPkColumnsInput: ActivityProviderPkColumnsInput;
  ActivityProviderSetInput: ActivityProviderSetInput;
  ActivityProviderStreamCursorInput: ActivityProviderStreamCursorInput;
  ActivityProviderStreamCursorValueInput: ActivityProviderStreamCursorValueInput;
  ActivityProviderUpdates: ActivityProviderUpdates;
  ActivityStatus: ActivityStatus;
  ActivityStatusAggregate: ActivityStatusAggregate;
  ActivityStatusAggregateFields: ActivityStatusAggregateFields;
  ActivityStatusBoolExp: ActivityStatusBoolExp;
  ActivityStatusEnumComparisonExp: ActivityStatusEnumComparisonExp;
  ActivityStatusInsertInput: ActivityStatusInsertInput;
  ActivityStatusMaxFields: ActivityStatusMaxFields;
  ActivityStatusMinFields: ActivityStatusMinFields;
  ActivityStatusMutationResponse: ActivityStatusMutationResponse;
  ActivityStatusObjRelInsertInput: ActivityStatusObjRelInsertInput;
  ActivityStatusOnConflict: ActivityStatusOnConflict;
  ActivityStatusOrderBy: ActivityStatusOrderBy;
  ActivityStatusPkColumnsInput: ActivityStatusPkColumnsInput;
  ActivityStatusSetInput: ActivityStatusSetInput;
  ActivityStatusStreamCursorInput: ActivityStatusStreamCursorInput;
  ActivityStatusStreamCursorValueInput: ActivityStatusStreamCursorValueInput;
  ActivityStatusUpdates: ActivityStatusUpdates;
  ActivityType: ActivityType;
  ActivityTypeAggregate: ActivityTypeAggregate;
  ActivityTypeAggregateFields: ActivityTypeAggregateFields;
  ActivityTypeBoolExp: ActivityTypeBoolExp;
  ActivityTypeEnumComparisonExp: ActivityTypeEnumComparisonExp;
  ActivityTypeInsertInput: ActivityTypeInsertInput;
  ActivityTypeMaxFields: ActivityTypeMaxFields;
  ActivityTypeMinFields: ActivityTypeMinFields;
  ActivityTypeMutationResponse: ActivityTypeMutationResponse;
  ActivityTypeObjRelInsertInput: ActivityTypeObjRelInsertInput;
  ActivityTypeOnConflict: ActivityTypeOnConflict;
  ActivityTypeOrderBy: ActivityTypeOrderBy;
  ActivityTypePkColumnsInput: ActivityTypePkColumnsInput;
  ActivityTypeSetInput: ActivityTypeSetInput;
  ActivityTypeStreamCursorInput: ActivityTypeStreamCursorInput;
  ActivityTypeStreamCursorValueInput: ActivityTypeStreamCursorValueInput;
  ActivityTypeUpdates: ActivityTypeUpdates;
  AddDomainUserToOrganizationOutput: AddDomainUserToOrganizationOutput;
  BlockUserOutput: BlockUserOutput;
  Boolean: Scalars['Boolean']['output'];
  BooleanComparisonExp: BooleanComparisonExp;
  BusinessAddress: BusinessAddress;
  BusinessDomainActivityType: BusinessDomainActivityType;
  BusinessDomainActivityTypeAggregate: BusinessDomainActivityTypeAggregate;
  BusinessDomainActivityTypeAggregateFields: BusinessDomainActivityTypeAggregateFields;
  BusinessDomainActivityTypeBoolExp: BusinessDomainActivityTypeBoolExp;
  BusinessDomainActivityTypeInsertInput: BusinessDomainActivityTypeInsertInput;
  BusinessDomainActivityTypeMaxFields: BusinessDomainActivityTypeMaxFields;
  BusinessDomainActivityTypeMinFields: BusinessDomainActivityTypeMinFields;
  BusinessDomainActivityTypeMutationResponse: BusinessDomainActivityTypeMutationResponse;
  BusinessDomainActivityTypeOnConflict: BusinessDomainActivityTypeOnConflict;
  BusinessDomainActivityTypeOrderBy: BusinessDomainActivityTypeOrderBy;
  BusinessDomainActivityTypePkColumnsInput: BusinessDomainActivityTypePkColumnsInput;
  BusinessDomainActivityTypeSetInput: BusinessDomainActivityTypeSetInput;
  BusinessDomainActivityTypeStreamCursorInput: BusinessDomainActivityTypeStreamCursorInput;
  BusinessDomainActivityTypeStreamCursorValueInput: BusinessDomainActivityTypeStreamCursorValueInput;
  BusinessDomainActivityTypeUpdates: BusinessDomainActivityTypeUpdates;
  BusinessFeedType: BusinessFeedType;
  BusinessFeedTypeAggregate: BusinessFeedTypeAggregate;
  BusinessFeedTypeAggregateFields: BusinessFeedTypeAggregateFields;
  BusinessFeedTypeBoolExp: BusinessFeedTypeBoolExp;
  BusinessFeedTypeEnumComparisonExp: BusinessFeedTypeEnumComparisonExp;
  BusinessFeedTypeInsertInput: BusinessFeedTypeInsertInput;
  BusinessFeedTypeMaxFields: BusinessFeedTypeMaxFields;
  BusinessFeedTypeMinFields: BusinessFeedTypeMinFields;
  BusinessFeedTypeMutationResponse: BusinessFeedTypeMutationResponse;
  BusinessFeedTypeOnConflict: BusinessFeedTypeOnConflict;
  BusinessFeedTypeOrderBy: BusinessFeedTypeOrderBy;
  BusinessFeedTypePkColumnsInput: BusinessFeedTypePkColumnsInput;
  BusinessFeedTypeSetInput: BusinessFeedTypeSetInput;
  BusinessFeedTypeStreamCursorInput: BusinessFeedTypeStreamCursorInput;
  BusinessFeedTypeStreamCursorValueInput: BusinessFeedTypeStreamCursorValueInput;
  BusinessFeedTypeUpdates: BusinessFeedTypeUpdates;
  BusinessMessageAttachments: BusinessMessageAttachments;
  BusinessMessageAttachmentsAggregate: BusinessMessageAttachmentsAggregate;
  BusinessMessageAttachmentsAggregateBoolExp: BusinessMessageAttachmentsAggregateBoolExp;
  BusinessMessageAttachmentsAggregateFields: BusinessMessageAttachmentsAggregateFields;
  BusinessMessageAttachmentsAggregateOrderBy: BusinessMessageAttachmentsAggregateOrderBy;
  BusinessMessageAttachmentsArrRelInsertInput: BusinessMessageAttachmentsArrRelInsertInput;
  BusinessMessageAttachmentsBoolExp: BusinessMessageAttachmentsBoolExp;
  BusinessMessageAttachmentsInsertInput: BusinessMessageAttachmentsInsertInput;
  BusinessMessageAttachmentsMaxFields: BusinessMessageAttachmentsMaxFields;
  BusinessMessageAttachmentsMaxOrderBy: BusinessMessageAttachmentsMaxOrderBy;
  BusinessMessageAttachmentsMinFields: BusinessMessageAttachmentsMinFields;
  BusinessMessageAttachmentsMinOrderBy: BusinessMessageAttachmentsMinOrderBy;
  BusinessMessageAttachmentsMutationResponse: BusinessMessageAttachmentsMutationResponse;
  BusinessMessageAttachmentsOnConflict: BusinessMessageAttachmentsOnConflict;
  BusinessMessageAttachmentsOrderBy: BusinessMessageAttachmentsOrderBy;
  BusinessMessageAttachmentsPkColumnsInput: BusinessMessageAttachmentsPkColumnsInput;
  BusinessMessageAttachmentsSetInput: BusinessMessageAttachmentsSetInput;
  BusinessMessageAttachmentsStreamCursorInput: BusinessMessageAttachmentsStreamCursorInput;
  BusinessMessageAttachmentsStreamCursorValueInput: BusinessMessageAttachmentsStreamCursorValueInput;
  BusinessMessageAttachmentsUpdates: BusinessMessageAttachmentsUpdates;
  BusinessOrganizationUserCallbackAnswer: BusinessOrganizationUserCallbackAnswer;
  BusinessOrganizationUserCallbackAnswerAggregate: BusinessOrganizationUserCallbackAnswerAggregate;
  BusinessOrganizationUserCallbackAnswerAggregateFields: BusinessOrganizationUserCallbackAnswerAggregateFields;
  BusinessOrganizationUserCallbackAnswerBoolExp: BusinessOrganizationUserCallbackAnswerBoolExp;
  BusinessOrganizationUserCallbackAnswerInsertInput: BusinessOrganizationUserCallbackAnswerInsertInput;
  BusinessOrganizationUserCallbackAnswerMaxFields: BusinessOrganizationUserCallbackAnswerMaxFields;
  BusinessOrganizationUserCallbackAnswerMinFields: BusinessOrganizationUserCallbackAnswerMinFields;
  BusinessOrganizationUserCallbackAnswerMutationResponse: BusinessOrganizationUserCallbackAnswerMutationResponse;
  BusinessOrganizationUserCallbackAnswerOnConflict: BusinessOrganizationUserCallbackAnswerOnConflict;
  BusinessOrganizationUserCallbackAnswerOrderBy: BusinessOrganizationUserCallbackAnswerOrderBy;
  BusinessOrganizationUserCallbackAnswerPkColumnsInput: BusinessOrganizationUserCallbackAnswerPkColumnsInput;
  BusinessOrganizationUserCallbackAnswerSetInput: BusinessOrganizationUserCallbackAnswerSetInput;
  BusinessOrganizationUserCallbackAnswerStreamCursorInput: BusinessOrganizationUserCallbackAnswerStreamCursorInput;
  BusinessOrganizationUserCallbackAnswerStreamCursorValueInput: BusinessOrganizationUserCallbackAnswerStreamCursorValueInput;
  BusinessOrganizationUserCallbackAnswerUpdates: BusinessOrganizationUserCallbackAnswerUpdates;
  BusinessOrganizationUserEmail: BusinessOrganizationUserEmail;
  BusinessOrganizationUserEmailAggregate: BusinessOrganizationUserEmailAggregate;
  BusinessOrganizationUserEmailAggregateBoolExp: BusinessOrganizationUserEmailAggregateBoolExp;
  BusinessOrganizationUserEmailAggregateFields: BusinessOrganizationUserEmailAggregateFields;
  BusinessOrganizationUserEmailAggregateOrderBy: BusinessOrganizationUserEmailAggregateOrderBy;
  BusinessOrganizationUserEmailArrRelInsertInput: BusinessOrganizationUserEmailArrRelInsertInput;
  BusinessOrganizationUserEmailBoolExp: BusinessOrganizationUserEmailBoolExp;
  BusinessOrganizationUserEmailInsertInput: BusinessOrganizationUserEmailInsertInput;
  BusinessOrganizationUserEmailMaxFields: BusinessOrganizationUserEmailMaxFields;
  BusinessOrganizationUserEmailMaxOrderBy: BusinessOrganizationUserEmailMaxOrderBy;
  BusinessOrganizationUserEmailMinFields: BusinessOrganizationUserEmailMinFields;
  BusinessOrganizationUserEmailMinOrderBy: BusinessOrganizationUserEmailMinOrderBy;
  BusinessOrganizationUserEmailMutationResponse: BusinessOrganizationUserEmailMutationResponse;
  BusinessOrganizationUserEmailOnConflict: BusinessOrganizationUserEmailOnConflict;
  BusinessOrganizationUserEmailOrderBy: BusinessOrganizationUserEmailOrderBy;
  BusinessOrganizationUserEmailPkColumnsInput: BusinessOrganizationUserEmailPkColumnsInput;
  BusinessOrganizationUserEmailSetInput: BusinessOrganizationUserEmailSetInput;
  BusinessOrganizationUserEmailStreamCursorInput: BusinessOrganizationUserEmailStreamCursorInput;
  BusinessOrganizationUserEmailStreamCursorValueInput: BusinessOrganizationUserEmailStreamCursorValueInput;
  BusinessOrganizationUserEmailType: BusinessOrganizationUserEmailType;
  BusinessOrganizationUserEmailTypeAggregate: BusinessOrganizationUserEmailTypeAggregate;
  BusinessOrganizationUserEmailTypeAggregateFields: BusinessOrganizationUserEmailTypeAggregateFields;
  BusinessOrganizationUserEmailTypeBoolExp: BusinessOrganizationUserEmailTypeBoolExp;
  BusinessOrganizationUserEmailTypeEnumComparisonExp: BusinessOrganizationUserEmailTypeEnumComparisonExp;
  BusinessOrganizationUserEmailTypeInsertInput: BusinessOrganizationUserEmailTypeInsertInput;
  BusinessOrganizationUserEmailTypeMaxFields: BusinessOrganizationUserEmailTypeMaxFields;
  BusinessOrganizationUserEmailTypeMinFields: BusinessOrganizationUserEmailTypeMinFields;
  BusinessOrganizationUserEmailTypeMutationResponse: BusinessOrganizationUserEmailTypeMutationResponse;
  BusinessOrganizationUserEmailTypeOnConflict: BusinessOrganizationUserEmailTypeOnConflict;
  BusinessOrganizationUserEmailTypeOrderBy: BusinessOrganizationUserEmailTypeOrderBy;
  BusinessOrganizationUserEmailTypePkColumnsInput: BusinessOrganizationUserEmailTypePkColumnsInput;
  BusinessOrganizationUserEmailTypeSetInput: BusinessOrganizationUserEmailTypeSetInput;
  BusinessOrganizationUserEmailTypeStreamCursorInput: BusinessOrganizationUserEmailTypeStreamCursorInput;
  BusinessOrganizationUserEmailTypeStreamCursorValueInput: BusinessOrganizationUserEmailTypeStreamCursorValueInput;
  BusinessOrganizationUserEmailTypeUpdates: BusinessOrganizationUserEmailTypeUpdates;
  BusinessOrganizationUserEmailUpdates: BusinessOrganizationUserEmailUpdates;
  BusinessOrganizationUserRequest: BusinessOrganizationUserRequest;
  BusinessOrganizationUserRequestAggregate: BusinessOrganizationUserRequestAggregate;
  BusinessOrganizationUserRequestAggregateBoolExp: BusinessOrganizationUserRequestAggregateBoolExp;
  BusinessOrganizationUserRequestAggregateFields: BusinessOrganizationUserRequestAggregateFields;
  BusinessOrganizationUserRequestAggregateOrderBy: BusinessOrganizationUserRequestAggregateOrderBy;
  BusinessOrganizationUserRequestAppendInput: BusinessOrganizationUserRequestAppendInput;
  BusinessOrganizationUserRequestArrRelInsertInput: BusinessOrganizationUserRequestArrRelInsertInput;
  BusinessOrganizationUserRequestBoolExp: BusinessOrganizationUserRequestBoolExp;
  BusinessOrganizationUserRequestDeleteAtPathInput: BusinessOrganizationUserRequestDeleteAtPathInput;
  BusinessOrganizationUserRequestDeleteElemInput: BusinessOrganizationUserRequestDeleteElemInput;
  BusinessOrganizationUserRequestDeleteKeyInput: BusinessOrganizationUserRequestDeleteKeyInput;
  BusinessOrganizationUserRequestInsertInput: BusinessOrganizationUserRequestInsertInput;
  BusinessOrganizationUserRequestMaxFields: BusinessOrganizationUserRequestMaxFields;
  BusinessOrganizationUserRequestMaxOrderBy: BusinessOrganizationUserRequestMaxOrderBy;
  BusinessOrganizationUserRequestMinFields: BusinessOrganizationUserRequestMinFields;
  BusinessOrganizationUserRequestMinOrderBy: BusinessOrganizationUserRequestMinOrderBy;
  BusinessOrganizationUserRequestMutationResponse: BusinessOrganizationUserRequestMutationResponse;
  BusinessOrganizationUserRequestOnConflict: BusinessOrganizationUserRequestOnConflict;
  BusinessOrganizationUserRequestOrderBy: BusinessOrganizationUserRequestOrderBy;
  BusinessOrganizationUserRequestPkColumnsInput: BusinessOrganizationUserRequestPkColumnsInput;
  BusinessOrganizationUserRequestPrependInput: BusinessOrganizationUserRequestPrependInput;
  BusinessOrganizationUserRequestSetInput: BusinessOrganizationUserRequestSetInput;
  BusinessOrganizationUserRequestStreamCursorInput: BusinessOrganizationUserRequestStreamCursorInput;
  BusinessOrganizationUserRequestStreamCursorValueInput: BusinessOrganizationUserRequestStreamCursorValueInput;
  BusinessOrganizationUserRequestType: BusinessOrganizationUserRequestType;
  BusinessOrganizationUserRequestTypeAggregate: BusinessOrganizationUserRequestTypeAggregate;
  BusinessOrganizationUserRequestTypeAggregateFields: BusinessOrganizationUserRequestTypeAggregateFields;
  BusinessOrganizationUserRequestTypeBoolExp: BusinessOrganizationUserRequestTypeBoolExp;
  BusinessOrganizationUserRequestTypeEnumComparisonExp: BusinessOrganizationUserRequestTypeEnumComparisonExp;
  BusinessOrganizationUserRequestTypeInsertInput: BusinessOrganizationUserRequestTypeInsertInput;
  BusinessOrganizationUserRequestTypeMaxFields: BusinessOrganizationUserRequestTypeMaxFields;
  BusinessOrganizationUserRequestTypeMinFields: BusinessOrganizationUserRequestTypeMinFields;
  BusinessOrganizationUserRequestTypeMutationResponse: BusinessOrganizationUserRequestTypeMutationResponse;
  BusinessOrganizationUserRequestTypeOnConflict: BusinessOrganizationUserRequestTypeOnConflict;
  BusinessOrganizationUserRequestTypeOrderBy: BusinessOrganizationUserRequestTypeOrderBy;
  BusinessOrganizationUserRequestTypePkColumnsInput: BusinessOrganizationUserRequestTypePkColumnsInput;
  BusinessOrganizationUserRequestTypeSetInput: BusinessOrganizationUserRequestTypeSetInput;
  BusinessOrganizationUserRequestTypeStreamCursorInput: BusinessOrganizationUserRequestTypeStreamCursorInput;
  BusinessOrganizationUserRequestTypeStreamCursorValueInput: BusinessOrganizationUserRequestTypeStreamCursorValueInput;
  BusinessOrganizationUserRequestTypeUpdates: BusinessOrganizationUserRequestTypeUpdates;
  BusinessOrganizationUserRequestUpdates: BusinessOrganizationUserRequestUpdates;
  BusinessOrganizationUserSuggestionType: BusinessOrganizationUserSuggestionType;
  BusinessOrganizationUserSuggestionTypeAggregate: BusinessOrganizationUserSuggestionTypeAggregate;
  BusinessOrganizationUserSuggestionTypeAggregateFields: BusinessOrganizationUserSuggestionTypeAggregateFields;
  BusinessOrganizationUserSuggestionTypeBoolExp: BusinessOrganizationUserSuggestionTypeBoolExp;
  BusinessOrganizationUserSuggestionTypeInsertInput: BusinessOrganizationUserSuggestionTypeInsertInput;
  BusinessOrganizationUserSuggestionTypeMaxFields: BusinessOrganizationUserSuggestionTypeMaxFields;
  BusinessOrganizationUserSuggestionTypeMinFields: BusinessOrganizationUserSuggestionTypeMinFields;
  BusinessOrganizationUserSuggestionTypeMutationResponse: BusinessOrganizationUserSuggestionTypeMutationResponse;
  BusinessOrganizationUserSuggestionTypeOnConflict: BusinessOrganizationUserSuggestionTypeOnConflict;
  BusinessOrganizationUserSuggestionTypeOrderBy: BusinessOrganizationUserSuggestionTypeOrderBy;
  BusinessOrganizationUserSuggestionTypePkColumnsInput: BusinessOrganizationUserSuggestionTypePkColumnsInput;
  BusinessOrganizationUserSuggestionTypeSetInput: BusinessOrganizationUserSuggestionTypeSetInput;
  BusinessOrganizationUserSuggestionTypeStreamCursorInput: BusinessOrganizationUserSuggestionTypeStreamCursorInput;
  BusinessOrganizationUserSuggestionTypeStreamCursorValueInput: BusinessOrganizationUserSuggestionTypeStreamCursorValueInput;
  BusinessOrganizationUserSuggestionTypeUpdates: BusinessOrganizationUserSuggestionTypeUpdates;
  BusinessOrganizationUserSuggestions: BusinessOrganizationUserSuggestions;
  BusinessOrganizationUserSuggestionsAggregate: BusinessOrganizationUserSuggestionsAggregate;
  BusinessOrganizationUserSuggestionsAggregateFields: BusinessOrganizationUserSuggestionsAggregateFields;
  BusinessOrganizationUserSuggestionsBoolExp: BusinessOrganizationUserSuggestionsBoolExp;
  BusinessOrganizationUserSuggestionsInsertInput: BusinessOrganizationUserSuggestionsInsertInput;
  BusinessOrganizationUserSuggestionsMaxFields: BusinessOrganizationUserSuggestionsMaxFields;
  BusinessOrganizationUserSuggestionsMinFields: BusinessOrganizationUserSuggestionsMinFields;
  BusinessOrganizationUserSuggestionsMutationResponse: BusinessOrganizationUserSuggestionsMutationResponse;
  BusinessOrganizationUserSuggestionsOnConflict: BusinessOrganizationUserSuggestionsOnConflict;
  BusinessOrganizationUserSuggestionsOrderBy: BusinessOrganizationUserSuggestionsOrderBy;
  BusinessOrganizationUserSuggestionsPkColumnsInput: BusinessOrganizationUserSuggestionsPkColumnsInput;
  BusinessOrganizationUserSuggestionsSetInput: BusinessOrganizationUserSuggestionsSetInput;
  BusinessOrganizationUserSuggestionsStreamCursorInput: BusinessOrganizationUserSuggestionsStreamCursorInput;
  BusinessOrganizationUserSuggestionsStreamCursorValueInput: BusinessOrganizationUserSuggestionsStreamCursorValueInput;
  BusinessOrganizationUserSuggestionsUpdates: BusinessOrganizationUserSuggestionsUpdates;
  BusinessOrganizationUserUrlAddress: BusinessOrganizationUserUrlAddress;
  BusinessOrganizationUserUrlAddressAggregate: BusinessOrganizationUserUrlAddressAggregate;
  BusinessOrganizationUserUrlAddressAggregateBoolExp: BusinessOrganizationUserUrlAddressAggregateBoolExp;
  BusinessOrganizationUserUrlAddressAggregateFields: BusinessOrganizationUserUrlAddressAggregateFields;
  BusinessOrganizationUserUrlAddressAggregateOrderBy: BusinessOrganizationUserUrlAddressAggregateOrderBy;
  BusinessOrganizationUserUrlAddressArrRelInsertInput: BusinessOrganizationUserUrlAddressArrRelInsertInput;
  BusinessOrganizationUserUrlAddressBoolExp: BusinessOrganizationUserUrlAddressBoolExp;
  BusinessOrganizationUserUrlAddressInsertInput: BusinessOrganizationUserUrlAddressInsertInput;
  BusinessOrganizationUserUrlAddressMaxFields: BusinessOrganizationUserUrlAddressMaxFields;
  BusinessOrganizationUserUrlAddressMaxOrderBy: BusinessOrganizationUserUrlAddressMaxOrderBy;
  BusinessOrganizationUserUrlAddressMinFields: BusinessOrganizationUserUrlAddressMinFields;
  BusinessOrganizationUserUrlAddressMinOrderBy: BusinessOrganizationUserUrlAddressMinOrderBy;
  BusinessOrganizationUserUrlAddressMutationResponse: BusinessOrganizationUserUrlAddressMutationResponse;
  BusinessOrganizationUserUrlAddressOnConflict: BusinessOrganizationUserUrlAddressOnConflict;
  BusinessOrganizationUserUrlAddressOrderBy: BusinessOrganizationUserUrlAddressOrderBy;
  BusinessOrganizationUserUrlAddressPkColumnsInput: BusinessOrganizationUserUrlAddressPkColumnsInput;
  BusinessOrganizationUserUrlAddressSetInput: BusinessOrganizationUserUrlAddressSetInput;
  BusinessOrganizationUserUrlAddressStreamCursorInput: BusinessOrganizationUserUrlAddressStreamCursorInput;
  BusinessOrganizationUserUrlAddressStreamCursorValueInput: BusinessOrganizationUserUrlAddressStreamCursorValueInput;
  BusinessOrganizationUserUrlAddressType: BusinessOrganizationUserUrlAddressType;
  BusinessOrganizationUserUrlAddressTypeAggregate: BusinessOrganizationUserUrlAddressTypeAggregate;
  BusinessOrganizationUserUrlAddressTypeAggregateFields: BusinessOrganizationUserUrlAddressTypeAggregateFields;
  BusinessOrganizationUserUrlAddressTypeBoolExp: BusinessOrganizationUserUrlAddressTypeBoolExp;
  BusinessOrganizationUserUrlAddressTypeEnumComparisonExp: BusinessOrganizationUserUrlAddressTypeEnumComparisonExp;
  BusinessOrganizationUserUrlAddressTypeInsertInput: BusinessOrganizationUserUrlAddressTypeInsertInput;
  BusinessOrganizationUserUrlAddressTypeMaxFields: BusinessOrganizationUserUrlAddressTypeMaxFields;
  BusinessOrganizationUserUrlAddressTypeMinFields: BusinessOrganizationUserUrlAddressTypeMinFields;
  BusinessOrganizationUserUrlAddressTypeMutationResponse: BusinessOrganizationUserUrlAddressTypeMutationResponse;
  BusinessOrganizationUserUrlAddressTypeObjRelInsertInput: BusinessOrganizationUserUrlAddressTypeObjRelInsertInput;
  BusinessOrganizationUserUrlAddressTypeOnConflict: BusinessOrganizationUserUrlAddressTypeOnConflict;
  BusinessOrganizationUserUrlAddressTypeOrderBy: BusinessOrganizationUserUrlAddressTypeOrderBy;
  BusinessOrganizationUserUrlAddressTypePkColumnsInput: BusinessOrganizationUserUrlAddressTypePkColumnsInput;
  BusinessOrganizationUserUrlAddressTypeSetInput: BusinessOrganizationUserUrlAddressTypeSetInput;
  BusinessOrganizationUserUrlAddressTypeStreamCursorInput: BusinessOrganizationUserUrlAddressTypeStreamCursorInput;
  BusinessOrganizationUserUrlAddressTypeStreamCursorValueInput: BusinessOrganizationUserUrlAddressTypeStreamCursorValueInput;
  BusinessOrganizationUserUrlAddressTypeUpdates: BusinessOrganizationUserUrlAddressTypeUpdates;
  BusinessOrganizationUserUrlAddressUpdates: BusinessOrganizationUserUrlAddressUpdates;
  BusinessQueueItemAlarmType: BusinessQueueItemAlarmType;
  BusinessQueueItemAlarmTypeAggregate: BusinessQueueItemAlarmTypeAggregate;
  BusinessQueueItemAlarmTypeAggregateFields: BusinessQueueItemAlarmTypeAggregateFields;
  BusinessQueueItemAlarmTypeBoolExp: BusinessQueueItemAlarmTypeBoolExp;
  BusinessQueueItemAlarmTypeEnumComparisonExp: BusinessQueueItemAlarmTypeEnumComparisonExp;
  BusinessQueueItemAlarmTypeInsertInput: BusinessQueueItemAlarmTypeInsertInput;
  BusinessQueueItemAlarmTypeMaxFields: BusinessQueueItemAlarmTypeMaxFields;
  BusinessQueueItemAlarmTypeMinFields: BusinessQueueItemAlarmTypeMinFields;
  BusinessQueueItemAlarmTypeMutationResponse: BusinessQueueItemAlarmTypeMutationResponse;
  BusinessQueueItemAlarmTypeOnConflict: BusinessQueueItemAlarmTypeOnConflict;
  BusinessQueueItemAlarmTypeOrderBy: BusinessQueueItemAlarmTypeOrderBy;
  BusinessQueueItemAlarmTypePkColumnsInput: BusinessQueueItemAlarmTypePkColumnsInput;
  BusinessQueueItemAlarmTypeSetInput: BusinessQueueItemAlarmTypeSetInput;
  BusinessQueueItemAlarmTypeStreamCursorInput: BusinessQueueItemAlarmTypeStreamCursorInput;
  BusinessQueueItemAlarmTypeStreamCursorValueInput: BusinessQueueItemAlarmTypeStreamCursorValueInput;
  BusinessQueueItemAlarmTypeUpdates: BusinessQueueItemAlarmTypeUpdates;
  BusinessQueueItemAlarms: BusinessQueueItemAlarms;
  BusinessQueueItemAlarmsAggregate: BusinessQueueItemAlarmsAggregate;
  BusinessQueueItemAlarmsAggregateBoolExp: BusinessQueueItemAlarmsAggregateBoolExp;
  BusinessQueueItemAlarmsAggregateFields: BusinessQueueItemAlarmsAggregateFields;
  BusinessQueueItemAlarmsAggregateOrderBy: BusinessQueueItemAlarmsAggregateOrderBy;
  BusinessQueueItemAlarmsArrRelInsertInput: BusinessQueueItemAlarmsArrRelInsertInput;
  BusinessQueueItemAlarmsAvgFields: BusinessQueueItemAlarmsAvgFields;
  BusinessQueueItemAlarmsAvgOrderBy: BusinessQueueItemAlarmsAvgOrderBy;
  BusinessQueueItemAlarmsBoolExp: BusinessQueueItemAlarmsBoolExp;
  BusinessQueueItemAlarmsIncInput: BusinessQueueItemAlarmsIncInput;
  BusinessQueueItemAlarmsInsertInput: BusinessQueueItemAlarmsInsertInput;
  BusinessQueueItemAlarmsMaxFields: BusinessQueueItemAlarmsMaxFields;
  BusinessQueueItemAlarmsMaxOrderBy: BusinessQueueItemAlarmsMaxOrderBy;
  BusinessQueueItemAlarmsMinFields: BusinessQueueItemAlarmsMinFields;
  BusinessQueueItemAlarmsMinOrderBy: BusinessQueueItemAlarmsMinOrderBy;
  BusinessQueueItemAlarmsMutationResponse: BusinessQueueItemAlarmsMutationResponse;
  BusinessQueueItemAlarmsOnConflict: BusinessQueueItemAlarmsOnConflict;
  BusinessQueueItemAlarmsOrderBy: BusinessQueueItemAlarmsOrderBy;
  BusinessQueueItemAlarmsPkColumnsInput: BusinessQueueItemAlarmsPkColumnsInput;
  BusinessQueueItemAlarmsSetInput: BusinessQueueItemAlarmsSetInput;
  BusinessQueueItemAlarmsStddevFields: BusinessQueueItemAlarmsStddevFields;
  BusinessQueueItemAlarmsStddevOrderBy: BusinessQueueItemAlarmsStddevOrderBy;
  BusinessQueueItemAlarmsStddevPopFields: BusinessQueueItemAlarmsStddevPopFields;
  BusinessQueueItemAlarmsStddevPopOrderBy: BusinessQueueItemAlarmsStddevPopOrderBy;
  BusinessQueueItemAlarmsStddevSampFields: BusinessQueueItemAlarmsStddevSampFields;
  BusinessQueueItemAlarmsStddevSampOrderBy: BusinessQueueItemAlarmsStddevSampOrderBy;
  BusinessQueueItemAlarmsStreamCursorInput: BusinessQueueItemAlarmsStreamCursorInput;
  BusinessQueueItemAlarmsStreamCursorValueInput: BusinessQueueItemAlarmsStreamCursorValueInput;
  BusinessQueueItemAlarmsSumFields: BusinessQueueItemAlarmsSumFields;
  BusinessQueueItemAlarmsSumOrderBy: BusinessQueueItemAlarmsSumOrderBy;
  BusinessQueueItemAlarmsUpdates: BusinessQueueItemAlarmsUpdates;
  BusinessQueueItemAlarmsVarPopFields: BusinessQueueItemAlarmsVarPopFields;
  BusinessQueueItemAlarmsVarPopOrderBy: BusinessQueueItemAlarmsVarPopOrderBy;
  BusinessQueueItemAlarmsVarSampFields: BusinessQueueItemAlarmsVarSampFields;
  BusinessQueueItemAlarmsVarSampOrderBy: BusinessQueueItemAlarmsVarSampOrderBy;
  BusinessQueueItemAlarmsVarianceFields: BusinessQueueItemAlarmsVarianceFields;
  BusinessQueueItemAlarmsVarianceOrderBy: BusinessQueueItemAlarmsVarianceOrderBy;
  BusinessQueueItemDomainUsersView: BusinessQueueItemDomainUsersView;
  BusinessQueueItemDomainUsersViewAggregate: BusinessQueueItemDomainUsersViewAggregate;
  BusinessQueueItemDomainUsersViewAggregateBoolExp: BusinessQueueItemDomainUsersViewAggregateBoolExp;
  BusinessQueueItemDomainUsersViewAggregateFields: BusinessQueueItemDomainUsersViewAggregateFields;
  BusinessQueueItemDomainUsersViewAggregateOrderBy: BusinessQueueItemDomainUsersViewAggregateOrderBy;
  BusinessQueueItemDomainUsersViewArrRelInsertInput: BusinessQueueItemDomainUsersViewArrRelInsertInput;
  BusinessQueueItemDomainUsersViewAvgFields: BusinessQueueItemDomainUsersViewAvgFields;
  BusinessQueueItemDomainUsersViewAvgOrderBy: BusinessQueueItemDomainUsersViewAvgOrderBy;
  BusinessQueueItemDomainUsersViewBoolExp: BusinessQueueItemDomainUsersViewBoolExp;
  BusinessQueueItemDomainUsersViewInsertInput: BusinessQueueItemDomainUsersViewInsertInput;
  BusinessQueueItemDomainUsersViewMaxFields: BusinessQueueItemDomainUsersViewMaxFields;
  BusinessQueueItemDomainUsersViewMaxOrderBy: BusinessQueueItemDomainUsersViewMaxOrderBy;
  BusinessQueueItemDomainUsersViewMinFields: BusinessQueueItemDomainUsersViewMinFields;
  BusinessQueueItemDomainUsersViewMinOrderBy: BusinessQueueItemDomainUsersViewMinOrderBy;
  BusinessQueueItemDomainUsersViewOrderBy: BusinessQueueItemDomainUsersViewOrderBy;
  BusinessQueueItemDomainUsersViewStddevFields: BusinessQueueItemDomainUsersViewStddevFields;
  BusinessQueueItemDomainUsersViewStddevOrderBy: BusinessQueueItemDomainUsersViewStddevOrderBy;
  BusinessQueueItemDomainUsersViewStddevPopFields: BusinessQueueItemDomainUsersViewStddevPopFields;
  BusinessQueueItemDomainUsersViewStddevPopOrderBy: BusinessQueueItemDomainUsersViewStddevPopOrderBy;
  BusinessQueueItemDomainUsersViewStddevSampFields: BusinessQueueItemDomainUsersViewStddevSampFields;
  BusinessQueueItemDomainUsersViewStddevSampOrderBy: BusinessQueueItemDomainUsersViewStddevSampOrderBy;
  BusinessQueueItemDomainUsersViewStreamCursorInput: BusinessQueueItemDomainUsersViewStreamCursorInput;
  BusinessQueueItemDomainUsersViewStreamCursorValueInput: BusinessQueueItemDomainUsersViewStreamCursorValueInput;
  BusinessQueueItemDomainUsersViewSumFields: BusinessQueueItemDomainUsersViewSumFields;
  BusinessQueueItemDomainUsersViewSumOrderBy: BusinessQueueItemDomainUsersViewSumOrderBy;
  BusinessQueueItemDomainUsersViewVarPopFields: BusinessQueueItemDomainUsersViewVarPopFields;
  BusinessQueueItemDomainUsersViewVarPopOrderBy: BusinessQueueItemDomainUsersViewVarPopOrderBy;
  BusinessQueueItemDomainUsersViewVarSampFields: BusinessQueueItemDomainUsersViewVarSampFields;
  BusinessQueueItemDomainUsersViewVarSampOrderBy: BusinessQueueItemDomainUsersViewVarSampOrderBy;
  BusinessQueueItemDomainUsersViewVarianceFields: BusinessQueueItemDomainUsersViewVarianceFields;
  BusinessQueueItemDomainUsersViewVarianceOrderBy: BusinessQueueItemDomainUsersViewVarianceOrderBy;
  BusinessQueueItemOrganizationUsersView: BusinessQueueItemOrganizationUsersView;
  BusinessQueueItemOrganizationUsersViewAggregate: BusinessQueueItemOrganizationUsersViewAggregate;
  BusinessQueueItemOrganizationUsersViewAggregateBoolExp: BusinessQueueItemOrganizationUsersViewAggregateBoolExp;
  BusinessQueueItemOrganizationUsersViewAggregateFields: BusinessQueueItemOrganizationUsersViewAggregateFields;
  BusinessQueueItemOrganizationUsersViewAggregateOrderBy: BusinessQueueItemOrganizationUsersViewAggregateOrderBy;
  BusinessQueueItemOrganizationUsersViewArrRelInsertInput: BusinessQueueItemOrganizationUsersViewArrRelInsertInput;
  BusinessQueueItemOrganizationUsersViewBoolExp: BusinessQueueItemOrganizationUsersViewBoolExp;
  BusinessQueueItemOrganizationUsersViewInsertInput: BusinessQueueItemOrganizationUsersViewInsertInput;
  BusinessQueueItemOrganizationUsersViewMaxFields: BusinessQueueItemOrganizationUsersViewMaxFields;
  BusinessQueueItemOrganizationUsersViewMaxOrderBy: BusinessQueueItemOrganizationUsersViewMaxOrderBy;
  BusinessQueueItemOrganizationUsersViewMinFields: BusinessQueueItemOrganizationUsersViewMinFields;
  BusinessQueueItemOrganizationUsersViewMinOrderBy: BusinessQueueItemOrganizationUsersViewMinOrderBy;
  BusinessQueueItemOrganizationUsersViewOrderBy: BusinessQueueItemOrganizationUsersViewOrderBy;
  BusinessQueueItemOrganizationUsersViewStreamCursorInput: BusinessQueueItemOrganizationUsersViewStreamCursorInput;
  BusinessQueueItemOrganizationUsersViewStreamCursorValueInput: BusinessQueueItemOrganizationUsersViewStreamCursorValueInput;
  BusinessQueueItemParticipantChannelType: BusinessQueueItemParticipantChannelType;
  BusinessQueueItemParticipantChannelTypeAggregate: BusinessQueueItemParticipantChannelTypeAggregate;
  BusinessQueueItemParticipantChannelTypeAggregateFields: BusinessQueueItemParticipantChannelTypeAggregateFields;
  BusinessQueueItemParticipantChannelTypeBoolExp: BusinessQueueItemParticipantChannelTypeBoolExp;
  BusinessQueueItemParticipantChannelTypeEnumComparisonExp: BusinessQueueItemParticipantChannelTypeEnumComparisonExp;
  BusinessQueueItemParticipantChannelTypeInsertInput: BusinessQueueItemParticipantChannelTypeInsertInput;
  BusinessQueueItemParticipantChannelTypeMaxFields: BusinessQueueItemParticipantChannelTypeMaxFields;
  BusinessQueueItemParticipantChannelTypeMinFields: BusinessQueueItemParticipantChannelTypeMinFields;
  BusinessQueueItemParticipantChannelTypeMutationResponse: BusinessQueueItemParticipantChannelTypeMutationResponse;
  BusinessQueueItemParticipantChannelTypeOnConflict: BusinessQueueItemParticipantChannelTypeOnConflict;
  BusinessQueueItemParticipantChannelTypeOrderBy: BusinessQueueItemParticipantChannelTypeOrderBy;
  BusinessQueueItemParticipantChannelTypePkColumnsInput: BusinessQueueItemParticipantChannelTypePkColumnsInput;
  BusinessQueueItemParticipantChannelTypeSetInput: BusinessQueueItemParticipantChannelTypeSetInput;
  BusinessQueueItemParticipantChannelTypeStreamCursorInput: BusinessQueueItemParticipantChannelTypeStreamCursorInput;
  BusinessQueueItemParticipantChannelTypeStreamCursorValueInput: BusinessQueueItemParticipantChannelTypeStreamCursorValueInput;
  BusinessQueueItemParticipantChannelTypeUpdates: BusinessQueueItemParticipantChannelTypeUpdates;
  BusinessQueueItemParticipantsView: BusinessQueueItemParticipantsView;
  BusinessQueueItemParticipantsViewAggregate: BusinessQueueItemParticipantsViewAggregate;
  BusinessQueueItemParticipantsViewAggregateBoolExp: BusinessQueueItemParticipantsViewAggregateBoolExp;
  BusinessQueueItemParticipantsViewAggregateFields: BusinessQueueItemParticipantsViewAggregateFields;
  BusinessQueueItemParticipantsViewAggregateOrderBy: BusinessQueueItemParticipantsViewAggregateOrderBy;
  BusinessQueueItemParticipantsViewArrRelInsertInput: BusinessQueueItemParticipantsViewArrRelInsertInput;
  BusinessQueueItemParticipantsViewBoolExp: BusinessQueueItemParticipantsViewBoolExp;
  BusinessQueueItemParticipantsViewInsertInput: BusinessQueueItemParticipantsViewInsertInput;
  BusinessQueueItemParticipantsViewMaxFields: BusinessQueueItemParticipantsViewMaxFields;
  BusinessQueueItemParticipantsViewMaxOrderBy: BusinessQueueItemParticipantsViewMaxOrderBy;
  BusinessQueueItemParticipantsViewMinFields: BusinessQueueItemParticipantsViewMinFields;
  BusinessQueueItemParticipantsViewMinOrderBy: BusinessQueueItemParticipantsViewMinOrderBy;
  BusinessQueueItemParticipantsViewOrderBy: BusinessQueueItemParticipantsViewOrderBy;
  BusinessQueueItemParticipantsViewStreamCursorInput: BusinessQueueItemParticipantsViewStreamCursorInput;
  BusinessQueueItemParticipantsViewStreamCursorValueInput: BusinessQueueItemParticipantsViewStreamCursorValueInput;
  BusinessQueueItemSubType: BusinessQueueItemSubType;
  BusinessQueueItemSubTypeAggregate: BusinessQueueItemSubTypeAggregate;
  BusinessQueueItemSubTypeAggregateFields: BusinessQueueItemSubTypeAggregateFields;
  BusinessQueueItemSubTypeBoolExp: BusinessQueueItemSubTypeBoolExp;
  BusinessQueueItemSubTypeInsertInput: BusinessQueueItemSubTypeInsertInput;
  BusinessQueueItemSubTypeMaxFields: BusinessQueueItemSubTypeMaxFields;
  BusinessQueueItemSubTypeMinFields: BusinessQueueItemSubTypeMinFields;
  BusinessQueueItemSubTypeMutationResponse: BusinessQueueItemSubTypeMutationResponse;
  BusinessQueueItemSubTypeObjRelInsertInput: BusinessQueueItemSubTypeObjRelInsertInput;
  BusinessQueueItemSubTypeOnConflict: BusinessQueueItemSubTypeOnConflict;
  BusinessQueueItemSubTypeOrderBy: BusinessQueueItemSubTypeOrderBy;
  BusinessQueueItemSubTypePkColumnsInput: BusinessQueueItemSubTypePkColumnsInput;
  BusinessQueueItemSubTypeSetInput: BusinessQueueItemSubTypeSetInput;
  BusinessQueueItemSubTypeStreamCursorInput: BusinessQueueItemSubTypeStreamCursorInput;
  BusinessQueueItemSubTypeStreamCursorValueInput: BusinessQueueItemSubTypeStreamCursorValueInput;
  BusinessQueueItemSubTypeUpdates: BusinessQueueItemSubTypeUpdates;
  BusinessUserContactNumbers: BusinessUserContactNumbers;
  BusinessUserContactNumbersAggregate: BusinessUserContactNumbersAggregate;
  BusinessUserContactNumbersAggregateBoolExp: BusinessUserContactNumbersAggregateBoolExp;
  BusinessUserContactNumbersAggregateFields: BusinessUserContactNumbersAggregateFields;
  BusinessUserContactNumbersAggregateOrderBy: BusinessUserContactNumbersAggregateOrderBy;
  BusinessUserContactNumbersArrRelInsertInput: BusinessUserContactNumbersArrRelInsertInput;
  BusinessUserContactNumbersBoolExp: BusinessUserContactNumbersBoolExp;
  BusinessUserContactNumbersInsertInput: BusinessUserContactNumbersInsertInput;
  BusinessUserContactNumbersMaxFields: BusinessUserContactNumbersMaxFields;
  BusinessUserContactNumbersMaxOrderBy: BusinessUserContactNumbersMaxOrderBy;
  BusinessUserContactNumbersMinFields: BusinessUserContactNumbersMinFields;
  BusinessUserContactNumbersMinOrderBy: BusinessUserContactNumbersMinOrderBy;
  BusinessUserContactNumbersMutationResponse: BusinessUserContactNumbersMutationResponse;
  BusinessUserContactNumbersOnConflict: BusinessUserContactNumbersOnConflict;
  BusinessUserContactNumbersOrderBy: BusinessUserContactNumbersOrderBy;
  BusinessUserContactNumbersPkColumnsInput: BusinessUserContactNumbersPkColumnsInput;
  BusinessUserContactNumbersSetInput: BusinessUserContactNumbersSetInput;
  BusinessUserContactNumbersStreamCursorInput: BusinessUserContactNumbersStreamCursorInput;
  BusinessUserContactNumbersStreamCursorValueInput: BusinessUserContactNumbersStreamCursorValueInput;
  BusinessUserContactNumbersUpdates: BusinessUserContactNumbersUpdates;
  BusinessUserFeed: BusinessUserFeed;
  BusinessUserFeedAggregate: BusinessUserFeedAggregate;
  BusinessUserFeedAggregateBoolExp: BusinessUserFeedAggregateBoolExp;
  BusinessUserFeedAggregateFields: BusinessUserFeedAggregateFields;
  BusinessUserFeedAggregateOrderBy: BusinessUserFeedAggregateOrderBy;
  BusinessUserFeedAppendInput: BusinessUserFeedAppendInput;
  BusinessUserFeedArrRelInsertInput: BusinessUserFeedArrRelInsertInput;
  BusinessUserFeedBoolExp: BusinessUserFeedBoolExp;
  BusinessUserFeedDeleteAtPathInput: BusinessUserFeedDeleteAtPathInput;
  BusinessUserFeedDeleteElemInput: BusinessUserFeedDeleteElemInput;
  BusinessUserFeedDeleteKeyInput: BusinessUserFeedDeleteKeyInput;
  BusinessUserFeedInsertInput: BusinessUserFeedInsertInput;
  BusinessUserFeedMaxFields: BusinessUserFeedMaxFields;
  BusinessUserFeedMaxOrderBy: BusinessUserFeedMaxOrderBy;
  BusinessUserFeedMinFields: BusinessUserFeedMinFields;
  BusinessUserFeedMinOrderBy: BusinessUserFeedMinOrderBy;
  BusinessUserFeedMutationResponse: BusinessUserFeedMutationResponse;
  BusinessUserFeedOnConflict: BusinessUserFeedOnConflict;
  BusinessUserFeedOrderBy: BusinessUserFeedOrderBy;
  BusinessUserFeedPkColumnsInput: BusinessUserFeedPkColumnsInput;
  BusinessUserFeedPrependInput: BusinessUserFeedPrependInput;
  BusinessUserFeedSetInput: BusinessUserFeedSetInput;
  BusinessUserFeedStreamCursorInput: BusinessUserFeedStreamCursorInput;
  BusinessUserFeedStreamCursorValueInput: BusinessUserFeedStreamCursorValueInput;
  BusinessUserFeedUpdates: BusinessUserFeedUpdates;
  BusinessUserRequestStatus: BusinessUserRequestStatus;
  BusinessUserRequestStatusAggregate: BusinessUserRequestStatusAggregate;
  BusinessUserRequestStatusAggregateFields: BusinessUserRequestStatusAggregateFields;
  BusinessUserRequestStatusBoolExp: BusinessUserRequestStatusBoolExp;
  BusinessUserRequestStatusEnumComparisonExp: BusinessUserRequestStatusEnumComparisonExp;
  BusinessUserRequestStatusInsertInput: BusinessUserRequestStatusInsertInput;
  BusinessUserRequestStatusMaxFields: BusinessUserRequestStatusMaxFields;
  BusinessUserRequestStatusMinFields: BusinessUserRequestStatusMinFields;
  BusinessUserRequestStatusMutationResponse: BusinessUserRequestStatusMutationResponse;
  BusinessUserRequestStatusOnConflict: BusinessUserRequestStatusOnConflict;
  BusinessUserRequestStatusOrderBy: BusinessUserRequestStatusOrderBy;
  BusinessUserRequestStatusPkColumnsInput: BusinessUserRequestStatusPkColumnsInput;
  BusinessUserRequestStatusSetInput: BusinessUserRequestStatusSetInput;
  BusinessUserRequestStatusStreamCursorInput: BusinessUserRequestStatusStreamCursorInput;
  BusinessUserRequestStatusStreamCursorValueInput: BusinessUserRequestStatusStreamCursorValueInput;
  BusinessUserRequestStatusUpdates: BusinessUserRequestStatusUpdates;
  BusinessUserStates: BusinessUserStates;
  BusinessUserStatesAggregate: BusinessUserStatesAggregate;
  BusinessUserStatesAggregateBoolExp: BusinessUserStatesAggregateBoolExp;
  BusinessUserStatesAggregateFields: BusinessUserStatesAggregateFields;
  BusinessUserStatesAggregateOrderBy: BusinessUserStatesAggregateOrderBy;
  BusinessUserStatesArrRelInsertInput: BusinessUserStatesArrRelInsertInput;
  BusinessUserStatesBoolExp: BusinessUserStatesBoolExp;
  BusinessUserStatesInsertInput: BusinessUserStatesInsertInput;
  BusinessUserStatesMaxFields: BusinessUserStatesMaxFields;
  BusinessUserStatesMaxOrderBy: BusinessUserStatesMaxOrderBy;
  BusinessUserStatesMinFields: BusinessUserStatesMinFields;
  BusinessUserStatesMinOrderBy: BusinessUserStatesMinOrderBy;
  BusinessUserStatesMutationResponse: BusinessUserStatesMutationResponse;
  BusinessUserStatesOnConflict: BusinessUserStatesOnConflict;
  BusinessUserStatesOrderBy: BusinessUserStatesOrderBy;
  BusinessUserStatesPkColumnsInput: BusinessUserStatesPkColumnsInput;
  BusinessUserStatesSetInput: BusinessUserStatesSetInput;
  BusinessUserStatesStreamCursorInput: BusinessUserStatesStreamCursorInput;
  BusinessUserStatesStreamCursorValueInput: BusinessUserStatesStreamCursorValueInput;
  BusinessUserStatesUpdates: BusinessUserStatesUpdates;
  ChangeOrganizationNameInput: ChangeOrganizationNameInput;
  ChangeOrganizationNameOutput: ChangeOrganizationNameOutput;
  CheckOnetimeCodeOutput: CheckOnetimeCodeOutput;
  CheckPhoneNumberOutput: CheckPhoneNumberOutput;
  Content: Content;
  CreateSMSOutput: CreateSMSOutput;
  CrmContext: CrmContext;
  CrmContextAggregate: CrmContextAggregate;
  CrmContextAggregateFields: CrmContextAggregateFields;
  CrmContextBoolExp: CrmContextBoolExp;
  CrmContextInsertInput: CrmContextInsertInput;
  CrmContextMaxFields: CrmContextMaxFields;
  CrmContextMinFields: CrmContextMinFields;
  CrmContextMutationResponse: CrmContextMutationResponse;
  CrmContextObjRelInsertInput: CrmContextObjRelInsertInput;
  CrmContextOnConflict: CrmContextOnConflict;
  CrmContextOrderBy: CrmContextOrderBy;
  CrmContextPkColumnsInput: CrmContextPkColumnsInput;
  CrmContextSetInput: CrmContextSetInput;
  CrmContextStreamCursorInput: CrmContextStreamCursorInput;
  CrmContextStreamCursorValueInput: CrmContextStreamCursorValueInput;
  CrmContextType: CrmContextType;
  CrmContextTypeAggregate: CrmContextTypeAggregate;
  CrmContextTypeAggregateFields: CrmContextTypeAggregateFields;
  CrmContextTypeBoolExp: CrmContextTypeBoolExp;
  CrmContextTypeEnumComparisonExp: CrmContextTypeEnumComparisonExp;
  CrmContextTypeInsertInput: CrmContextTypeInsertInput;
  CrmContextTypeMaxFields: CrmContextTypeMaxFields;
  CrmContextTypeMinFields: CrmContextTypeMinFields;
  CrmContextTypeMutationResponse: CrmContextTypeMutationResponse;
  CrmContextTypeOnConflict: CrmContextTypeOnConflict;
  CrmContextTypeOrderBy: CrmContextTypeOrderBy;
  CrmContextTypePkColumnsInput: CrmContextTypePkColumnsInput;
  CrmContextTypeSetInput: CrmContextTypeSetInput;
  CrmContextTypeStreamCursorInput: CrmContextTypeStreamCursorInput;
  CrmContextTypeStreamCursorValueInput: CrmContextTypeStreamCursorValueInput;
  CrmContextTypeUpdates: CrmContextTypeUpdates;
  CrmContextUpdates: CrmContextUpdates;
  CrmCreatorType: CrmCreatorType;
  CrmCreatorTypeAggregate: CrmCreatorTypeAggregate;
  CrmCreatorTypeAggregateFields: CrmCreatorTypeAggregateFields;
  CrmCreatorTypeBoolExp: CrmCreatorTypeBoolExp;
  CrmCreatorTypeEnumComparisonExp: CrmCreatorTypeEnumComparisonExp;
  CrmCreatorTypeInsertInput: CrmCreatorTypeInsertInput;
  CrmCreatorTypeMaxFields: CrmCreatorTypeMaxFields;
  CrmCreatorTypeMinFields: CrmCreatorTypeMinFields;
  CrmCreatorTypeMutationResponse: CrmCreatorTypeMutationResponse;
  CrmCreatorTypeOnConflict: CrmCreatorTypeOnConflict;
  CrmCreatorTypeOrderBy: CrmCreatorTypeOrderBy;
  CrmCreatorTypePkColumnsInput: CrmCreatorTypePkColumnsInput;
  CrmCreatorTypeSetInput: CrmCreatorTypeSetInput;
  CrmCreatorTypeStreamCursorInput: CrmCreatorTypeStreamCursorInput;
  CrmCreatorTypeStreamCursorValueInput: CrmCreatorTypeStreamCursorValueInput;
  CrmCreatorTypeUpdates: CrmCreatorTypeUpdates;
  CrmCrmType: CrmCrmType;
  CrmCrmTypeAggregate: CrmCrmTypeAggregate;
  CrmCrmTypeAggregateFields: CrmCrmTypeAggregateFields;
  CrmCrmTypeBoolExp: CrmCrmTypeBoolExp;
  CrmCrmTypeEnumComparisonExp: CrmCrmTypeEnumComparisonExp;
  CrmCrmTypeInsertInput: CrmCrmTypeInsertInput;
  CrmCrmTypeMaxFields: CrmCrmTypeMaxFields;
  CrmCrmTypeMinFields: CrmCrmTypeMinFields;
  CrmCrmTypeMutationResponse: CrmCrmTypeMutationResponse;
  CrmCrmTypeOnConflict: CrmCrmTypeOnConflict;
  CrmCrmTypeOrderBy: CrmCrmTypeOrderBy;
  CrmCrmTypePkColumnsInput: CrmCrmTypePkColumnsInput;
  CrmCrmTypeSetInput: CrmCrmTypeSetInput;
  CrmCrmTypeStreamCursorInput: CrmCrmTypeStreamCursorInput;
  CrmCrmTypeStreamCursorValueInput: CrmCrmTypeStreamCursorValueInput;
  CrmCrmTypeUpdates: CrmCrmTypeUpdates;
  CrmDirectionType: CrmDirectionType;
  CrmDirectionTypeAggregate: CrmDirectionTypeAggregate;
  CrmDirectionTypeAggregateFields: CrmDirectionTypeAggregateFields;
  CrmDirectionTypeBoolExp: CrmDirectionTypeBoolExp;
  CrmDirectionTypeInsertInput: CrmDirectionTypeInsertInput;
  CrmDirectionTypeMaxFields: CrmDirectionTypeMaxFields;
  CrmDirectionTypeMinFields: CrmDirectionTypeMinFields;
  CrmDirectionTypeMutationResponse: CrmDirectionTypeMutationResponse;
  CrmDirectionTypeOnConflict: CrmDirectionTypeOnConflict;
  CrmDirectionTypeOrderBy: CrmDirectionTypeOrderBy;
  CrmDirectionTypePkColumnsInput: CrmDirectionTypePkColumnsInput;
  CrmDirectionTypeSetInput: CrmDirectionTypeSetInput;
  CrmDirectionTypeStreamCursorInput: CrmDirectionTypeStreamCursorInput;
  CrmDirectionTypeStreamCursorValueInput: CrmDirectionTypeStreamCursorValueInput;
  CrmDirectionTypeUpdates: CrmDirectionTypeUpdates;
  CrmEntity: CrmEntity;
  CrmEntityAggregate: CrmEntityAggregate;
  CrmEntityAggregateFields: CrmEntityAggregateFields;
  CrmEntityBoolExp: CrmEntityBoolExp;
  CrmEntityInsertInput: CrmEntityInsertInput;
  CrmEntityMaxFields: CrmEntityMaxFields;
  CrmEntityMinFields: CrmEntityMinFields;
  CrmEntityMutationResponse: CrmEntityMutationResponse;
  CrmEntityOnConflict: CrmEntityOnConflict;
  CrmEntityOrderBy: CrmEntityOrderBy;
  CrmEntityPkColumnsInput: CrmEntityPkColumnsInput;
  CrmEntitySetInput: CrmEntitySetInput;
  CrmEntityStreamCursorInput: CrmEntityStreamCursorInput;
  CrmEntityStreamCursorValueInput: CrmEntityStreamCursorValueInput;
  CrmEntityUpdates: CrmEntityUpdates;
  CrmEvent: CrmEvent;
  CrmEventAggregate: CrmEventAggregate;
  CrmEventAggregateFields: CrmEventAggregateFields;
  CrmEventBoolExp: CrmEventBoolExp;
  CrmEventInsertInput: CrmEventInsertInput;
  CrmEventMaxFields: CrmEventMaxFields;
  CrmEventMinFields: CrmEventMinFields;
  CrmEventMutationResponse: CrmEventMutationResponse;
  CrmEventObjRelInsertInput: CrmEventObjRelInsertInput;
  CrmEventOnConflict: CrmEventOnConflict;
  CrmEventOrderBy: CrmEventOrderBy;
  CrmEventPkColumnsInput: CrmEventPkColumnsInput;
  CrmEventSetInput: CrmEventSetInput;
  CrmEventStreamCursorInput: CrmEventStreamCursorInput;
  CrmEventStreamCursorValueInput: CrmEventStreamCursorValueInput;
  CrmEventType: CrmEventType;
  CrmEventTypeAggregate: CrmEventTypeAggregate;
  CrmEventTypeAggregateFields: CrmEventTypeAggregateFields;
  CrmEventTypeBoolExp: CrmEventTypeBoolExp;
  CrmEventTypeEnumComparisonExp: CrmEventTypeEnumComparisonExp;
  CrmEventTypeInsertInput: CrmEventTypeInsertInput;
  CrmEventTypeMaxFields: CrmEventTypeMaxFields;
  CrmEventTypeMinFields: CrmEventTypeMinFields;
  CrmEventTypeMutationResponse: CrmEventTypeMutationResponse;
  CrmEventTypeOnConflict: CrmEventTypeOnConflict;
  CrmEventTypeOrderBy: CrmEventTypeOrderBy;
  CrmEventTypePkColumnsInput: CrmEventTypePkColumnsInput;
  CrmEventTypeSetInput: CrmEventTypeSetInput;
  CrmEventTypeStreamCursorInput: CrmEventTypeStreamCursorInput;
  CrmEventTypeStreamCursorValueInput: CrmEventTypeStreamCursorValueInput;
  CrmEventTypeUpdates: CrmEventTypeUpdates;
  CrmEventUpdates: CrmEventUpdates;
  CrmStatusCode: CrmStatusCode;
  CrmStatusCodeAggregate: CrmStatusCodeAggregate;
  CrmStatusCodeAggregateFields: CrmStatusCodeAggregateFields;
  CrmStatusCodeBoolExp: CrmStatusCodeBoolExp;
  CrmStatusCodeInsertInput: CrmStatusCodeInsertInput;
  CrmStatusCodeMaxFields: CrmStatusCodeMaxFields;
  CrmStatusCodeMinFields: CrmStatusCodeMinFields;
  CrmStatusCodeMutationResponse: CrmStatusCodeMutationResponse;
  CrmStatusCodeOnConflict: CrmStatusCodeOnConflict;
  CrmStatusCodeOrderBy: CrmStatusCodeOrderBy;
  CrmStatusCodePkColumnsInput: CrmStatusCodePkColumnsInput;
  CrmStatusCodeSetInput: CrmStatusCodeSetInput;
  CrmStatusCodeStreamCursorInput: CrmStatusCodeStreamCursorInput;
  CrmStatusCodeStreamCursorValueInput: CrmStatusCodeStreamCursorValueInput;
  CrmStatusCodeUpdates: CrmStatusCodeUpdates;
  CrmSystemType: CrmSystemType;
  CrmSystemTypeAggregate: CrmSystemTypeAggregate;
  CrmSystemTypeAggregateFields: CrmSystemTypeAggregateFields;
  CrmSystemTypeBoolExp: CrmSystemTypeBoolExp;
  CrmSystemTypeEnumComparisonExp: CrmSystemTypeEnumComparisonExp;
  CrmSystemTypeInsertInput: CrmSystemTypeInsertInput;
  CrmSystemTypeMaxFields: CrmSystemTypeMaxFields;
  CrmSystemTypeMinFields: CrmSystemTypeMinFields;
  CrmSystemTypeMutationResponse: CrmSystemTypeMutationResponse;
  CrmSystemTypeOnConflict: CrmSystemTypeOnConflict;
  CrmSystemTypeOrderBy: CrmSystemTypeOrderBy;
  CrmSystemTypePkColumnsInput: CrmSystemTypePkColumnsInput;
  CrmSystemTypeSetInput: CrmSystemTypeSetInput;
  CrmSystemTypeStreamCursorInput: CrmSystemTypeStreamCursorInput;
  CrmSystemTypeStreamCursorValueInput: CrmSystemTypeStreamCursorValueInput;
  CrmSystemTypeUpdates: CrmSystemTypeUpdates;
  CrmTraceContext: CrmTraceContext;
  CrmTraceContextAggregate: CrmTraceContextAggregate;
  CrmTraceContextAggregateFields: CrmTraceContextAggregateFields;
  CrmTraceContextBoolExp: CrmTraceContextBoolExp;
  CrmTraceContextInsertInput: CrmTraceContextInsertInput;
  CrmTraceContextMaxFields: CrmTraceContextMaxFields;
  CrmTraceContextMinFields: CrmTraceContextMinFields;
  CrmTraceContextMutationResponse: CrmTraceContextMutationResponse;
  CrmTraceContextObjRelInsertInput: CrmTraceContextObjRelInsertInput;
  CrmTraceContextOnConflict: CrmTraceContextOnConflict;
  CrmTraceContextOrderBy: CrmTraceContextOrderBy;
  CrmTraceContextPkColumnsInput: CrmTraceContextPkColumnsInput;
  CrmTraceContextSetInput: CrmTraceContextSetInput;
  CrmTraceContextStreamCursorInput: CrmTraceContextStreamCursorInput;
  CrmTraceContextStreamCursorValueInput: CrmTraceContextStreamCursorValueInput;
  CrmTraceContextUpdates: CrmTraceContextUpdates;
  CrmUnifiedEntityType: CrmUnifiedEntityType;
  CrmUnifiedEntityTypeAggregate: CrmUnifiedEntityTypeAggregate;
  CrmUnifiedEntityTypeAggregateFields: CrmUnifiedEntityTypeAggregateFields;
  CrmUnifiedEntityTypeBoolExp: CrmUnifiedEntityTypeBoolExp;
  CrmUnifiedEntityTypeEnumComparisonExp: CrmUnifiedEntityTypeEnumComparisonExp;
  CrmUnifiedEntityTypeInsertInput: CrmUnifiedEntityTypeInsertInput;
  CrmUnifiedEntityTypeMaxFields: CrmUnifiedEntityTypeMaxFields;
  CrmUnifiedEntityTypeMinFields: CrmUnifiedEntityTypeMinFields;
  CrmUnifiedEntityTypeMutationResponse: CrmUnifiedEntityTypeMutationResponse;
  CrmUnifiedEntityTypeOnConflict: CrmUnifiedEntityTypeOnConflict;
  CrmUnifiedEntityTypeOrderBy: CrmUnifiedEntityTypeOrderBy;
  CrmUnifiedEntityTypePkColumnsInput: CrmUnifiedEntityTypePkColumnsInput;
  CrmUnifiedEntityTypeSetInput: CrmUnifiedEntityTypeSetInput;
  CrmUnifiedEntityTypeStreamCursorInput: CrmUnifiedEntityTypeStreamCursorInput;
  CrmUnifiedEntityTypeStreamCursorValueInput: CrmUnifiedEntityTypeStreamCursorValueInput;
  CrmUnifiedEntityTypeUpdates: CrmUnifiedEntityTypeUpdates;
  CustomParameters: CustomParameters;
  DeleteRequestUserInput: DeleteRequestUserInput;
  DeleteRequestUserOutput: DeleteRequestUserOutput;
  DeleteUserInput: DeleteUserInput;
  DeleteUserOutput: DeleteUserOutput;
  DomainTypeEnumComparisonExp: DomainTypeEnumComparisonExp;
  DomainUserCategoryEnumComparisonExp: DomainUserCategoryEnumComparisonExp;
  EmailingActivityParticipantRoleEnumComparisonExp: EmailingActivityParticipantRoleEnumComparisonExp;
  EmailingDomainUserCategoryEnumComparisonExp: EmailingDomainUserCategoryEnumComparisonExp;
  EmailingEmailAccountSubscribers: EmailingEmailAccountSubscribers;
  EmailingEmailAccountSubscribersAggregate: EmailingEmailAccountSubscribersAggregate;
  EmailingEmailAccountSubscribersAggregateBoolExp: EmailingEmailAccountSubscribersAggregateBoolExp;
  EmailingEmailAccountSubscribersAggregateFields: EmailingEmailAccountSubscribersAggregateFields;
  EmailingEmailAccountSubscribersAggregateOrderBy: EmailingEmailAccountSubscribersAggregateOrderBy;
  EmailingEmailAccountSubscribersArrRelInsertInput: EmailingEmailAccountSubscribersArrRelInsertInput;
  EmailingEmailAccountSubscribersBoolExp: EmailingEmailAccountSubscribersBoolExp;
  EmailingEmailAccountSubscribersInsertInput: EmailingEmailAccountSubscribersInsertInput;
  EmailingEmailAccountSubscribersMaxFields: EmailingEmailAccountSubscribersMaxFields;
  EmailingEmailAccountSubscribersMaxOrderBy: EmailingEmailAccountSubscribersMaxOrderBy;
  EmailingEmailAccountSubscribersMinFields: EmailingEmailAccountSubscribersMinFields;
  EmailingEmailAccountSubscribersMinOrderBy: EmailingEmailAccountSubscribersMinOrderBy;
  EmailingEmailAccountSubscribersMutationResponse: EmailingEmailAccountSubscribersMutationResponse;
  EmailingEmailAccountSubscribersOnConflict: EmailingEmailAccountSubscribersOnConflict;
  EmailingEmailAccountSubscribersOrderBy: EmailingEmailAccountSubscribersOrderBy;
  EmailingEmailAccountSubscribersPkColumnsInput: EmailingEmailAccountSubscribersPkColumnsInput;
  EmailingEmailAccountSubscribersSetInput: EmailingEmailAccountSubscribersSetInput;
  EmailingEmailAccountSubscribersStreamCursorInput: EmailingEmailAccountSubscribersStreamCursorInput;
  EmailingEmailAccountSubscribersStreamCursorValueInput: EmailingEmailAccountSubscribersStreamCursorValueInput;
  EmailingEmailAccountSubscribersUpdates: EmailingEmailAccountSubscribersUpdates;
  EmailingEmailActivityType: EmailingEmailActivityType;
  EmailingEmailActivityTypeAggregate: EmailingEmailActivityTypeAggregate;
  EmailingEmailActivityTypeAggregateFields: EmailingEmailActivityTypeAggregateFields;
  EmailingEmailActivityTypeBoolExp: EmailingEmailActivityTypeBoolExp;
  EmailingEmailActivityTypeEnumComparisonExp: EmailingEmailActivityTypeEnumComparisonExp;
  EmailingEmailActivityTypeInsertInput: EmailingEmailActivityTypeInsertInput;
  EmailingEmailActivityTypeMaxFields: EmailingEmailActivityTypeMaxFields;
  EmailingEmailActivityTypeMinFields: EmailingEmailActivityTypeMinFields;
  EmailingEmailActivityTypeMutationResponse: EmailingEmailActivityTypeMutationResponse;
  EmailingEmailActivityTypeOnConflict: EmailingEmailActivityTypeOnConflict;
  EmailingEmailActivityTypeOrderBy: EmailingEmailActivityTypeOrderBy;
  EmailingEmailActivityTypePkColumnsInput: EmailingEmailActivityTypePkColumnsInput;
  EmailingEmailActivityTypeSetInput: EmailingEmailActivityTypeSetInput;
  EmailingEmailActivityTypeStreamCursorInput: EmailingEmailActivityTypeStreamCursorInput;
  EmailingEmailActivityTypeStreamCursorValueInput: EmailingEmailActivityTypeStreamCursorValueInput;
  EmailingEmailActivityTypeUpdates: EmailingEmailActivityTypeUpdates;
  EmailingEmailComment: EmailingEmailComment;
  EmailingEmailCommentAggregate: EmailingEmailCommentAggregate;
  EmailingEmailCommentAggregateBoolExp: EmailingEmailCommentAggregateBoolExp;
  EmailingEmailCommentAggregateFields: EmailingEmailCommentAggregateFields;
  EmailingEmailCommentAggregateOrderBy: EmailingEmailCommentAggregateOrderBy;
  EmailingEmailCommentArrRelInsertInput: EmailingEmailCommentArrRelInsertInput;
  EmailingEmailCommentBoolExp: EmailingEmailCommentBoolExp;
  EmailingEmailCommentInsertInput: EmailingEmailCommentInsertInput;
  EmailingEmailCommentMaxFields: EmailingEmailCommentMaxFields;
  EmailingEmailCommentMaxOrderBy: EmailingEmailCommentMaxOrderBy;
  EmailingEmailCommentMinFields: EmailingEmailCommentMinFields;
  EmailingEmailCommentMinOrderBy: EmailingEmailCommentMinOrderBy;
  EmailingEmailCommentMutationResponse: EmailingEmailCommentMutationResponse;
  EmailingEmailCommentOnConflict: EmailingEmailCommentOnConflict;
  EmailingEmailCommentOrderBy: EmailingEmailCommentOrderBy;
  EmailingEmailCommentPkColumnsInput: EmailingEmailCommentPkColumnsInput;
  EmailingEmailCommentSetInput: EmailingEmailCommentSetInput;
  EmailingEmailCommentStreamCursorInput: EmailingEmailCommentStreamCursorInput;
  EmailingEmailCommentStreamCursorValueInput: EmailingEmailCommentStreamCursorValueInput;
  EmailingEmailCommentUpdates: EmailingEmailCommentUpdates;
  EmailingNumericComparisonExp: EmailingNumericComparisonExp;
  EmailingProviderTypeEnumComparisonExp: EmailingProviderTypeEnumComparisonExp;
  Emailingactivity: Emailingactivity;
  EmailingactivityAggregate: EmailingactivityAggregate;
  EmailingactivityAggregateFields: EmailingactivityAggregateFields;
  EmailingactivityAvgFields: EmailingactivityAvgFields;
  EmailingactivityBoolExp: EmailingactivityBoolExp;
  EmailingactivityIncInput: EmailingactivityIncInput;
  EmailingactivityInsertInput: EmailingactivityInsertInput;
  EmailingactivityMaxFields: EmailingactivityMaxFields;
  EmailingactivityMinFields: EmailingactivityMinFields;
  EmailingactivityMutationResponse: EmailingactivityMutationResponse;
  EmailingactivityObjRelInsertInput: EmailingactivityObjRelInsertInput;
  EmailingactivityOnConflict: EmailingactivityOnConflict;
  EmailingactivityOrderBy: EmailingactivityOrderBy;
  EmailingactivityParticipant: EmailingactivityParticipant;
  EmailingactivityParticipantAggregate: EmailingactivityParticipantAggregate;
  EmailingactivityParticipantAggregateFields: EmailingactivityParticipantAggregateFields;
  EmailingactivityParticipantAggregateOrderBy: EmailingactivityParticipantAggregateOrderBy;
  EmailingactivityParticipantArrRelInsertInput: EmailingactivityParticipantArrRelInsertInput;
  EmailingactivityParticipantBoolExp: EmailingactivityParticipantBoolExp;
  EmailingactivityParticipantInsertInput: EmailingactivityParticipantInsertInput;
  EmailingactivityParticipantMaxFields: EmailingactivityParticipantMaxFields;
  EmailingactivityParticipantMaxOrderBy: EmailingactivityParticipantMaxOrderBy;
  EmailingactivityParticipantMinFields: EmailingactivityParticipantMinFields;
  EmailingactivityParticipantMinOrderBy: EmailingactivityParticipantMinOrderBy;
  EmailingactivityParticipantMutationResponse: EmailingactivityParticipantMutationResponse;
  EmailingactivityParticipantOnConflict: EmailingactivityParticipantOnConflict;
  EmailingactivityParticipantOrderBy: EmailingactivityParticipantOrderBy;
  EmailingactivityParticipantPkColumnsInput: EmailingactivityParticipantPkColumnsInput;
  EmailingactivityParticipantRole: EmailingactivityParticipantRole;
  EmailingactivityParticipantRoleAggregate: EmailingactivityParticipantRoleAggregate;
  EmailingactivityParticipantRoleAggregateFields: EmailingactivityParticipantRoleAggregateFields;
  EmailingactivityParticipantRoleBoolExp: EmailingactivityParticipantRoleBoolExp;
  EmailingactivityParticipantRoleInsertInput: EmailingactivityParticipantRoleInsertInput;
  EmailingactivityParticipantRoleMaxFields: EmailingactivityParticipantRoleMaxFields;
  EmailingactivityParticipantRoleMinFields: EmailingactivityParticipantRoleMinFields;
  EmailingactivityParticipantRoleMutationResponse: EmailingactivityParticipantRoleMutationResponse;
  EmailingactivityParticipantRoleOnConflict: EmailingactivityParticipantRoleOnConflict;
  EmailingactivityParticipantRoleOrderBy: EmailingactivityParticipantRoleOrderBy;
  EmailingactivityParticipantRolePkColumnsInput: EmailingactivityParticipantRolePkColumnsInput;
  EmailingactivityParticipantRoleSetInput: EmailingactivityParticipantRoleSetInput;
  EmailingactivityParticipantRoleStreamCursorInput: EmailingactivityParticipantRoleStreamCursorInput;
  EmailingactivityParticipantRoleStreamCursorValueInput: EmailingactivityParticipantRoleStreamCursorValueInput;
  EmailingactivityParticipantRoleUpdates: EmailingactivityParticipantRoleUpdates;
  EmailingactivityParticipantSetInput: EmailingactivityParticipantSetInput;
  EmailingactivityPkColumnsInput: EmailingactivityPkColumnsInput;
  EmailingactivitySetInput: EmailingactivitySetInput;
  EmailingactivityStddevFields: EmailingactivityStddevFields;
  EmailingactivityStddevPopFields: EmailingactivityStddevPopFields;
  EmailingactivityStddevSampFields: EmailingactivityStddevSampFields;
  EmailingactivitySumFields: EmailingactivitySumFields;
  EmailingactivityVarPopFields: EmailingactivityVarPopFields;
  EmailingactivityVarSampFields: EmailingactivityVarSampFields;
  EmailingactivityVarianceFields: EmailingactivityVarianceFields;
  EmailingdomainOrganization: EmailingdomainOrganization;
  EmailingdomainOrganizationAggregate: EmailingdomainOrganizationAggregate;
  EmailingdomainOrganizationAggregateBoolExp: EmailingdomainOrganizationAggregateBoolExp;
  EmailingdomainOrganizationAggregateFields: EmailingdomainOrganizationAggregateFields;
  EmailingdomainOrganizationAggregateOrderBy: EmailingdomainOrganizationAggregateOrderBy;
  EmailingdomainOrganizationArrRelInsertInput: EmailingdomainOrganizationArrRelInsertInput;
  EmailingdomainOrganizationBoolExp: EmailingdomainOrganizationBoolExp;
  EmailingdomainOrganizationInsertInput: EmailingdomainOrganizationInsertInput;
  EmailingdomainOrganizationMaxFields: EmailingdomainOrganizationMaxFields;
  EmailingdomainOrganizationMaxOrderBy: EmailingdomainOrganizationMaxOrderBy;
  EmailingdomainOrganizationMinFields: EmailingdomainOrganizationMinFields;
  EmailingdomainOrganizationMinOrderBy: EmailingdomainOrganizationMinOrderBy;
  EmailingdomainOrganizationMutationResponse: EmailingdomainOrganizationMutationResponse;
  EmailingdomainOrganizationObjRelInsertInput: EmailingdomainOrganizationObjRelInsertInput;
  EmailingdomainOrganizationOnConflict: EmailingdomainOrganizationOnConflict;
  EmailingdomainOrganizationOrderBy: EmailingdomainOrganizationOrderBy;
  EmailingdomainOrganizationPkColumnsInput: EmailingdomainOrganizationPkColumnsInput;
  EmailingdomainOrganizationSetInput: EmailingdomainOrganizationSetInput;
  EmailingdomainUser: EmailingdomainUser;
  EmailingdomainUserAggregate: EmailingdomainUserAggregate;
  EmailingdomainUserAggregateFields: EmailingdomainUserAggregateFields;
  EmailingdomainUserAggregateOrderBy: EmailingdomainUserAggregateOrderBy;
  EmailingdomainUserArrRelInsertInput: EmailingdomainUserArrRelInsertInput;
  EmailingdomainUserBoolExp: EmailingdomainUserBoolExp;
  EmailingdomainUserCategory: EmailingdomainUserCategory;
  EmailingdomainUserCategoryAggregate: EmailingdomainUserCategoryAggregate;
  EmailingdomainUserCategoryAggregateFields: EmailingdomainUserCategoryAggregateFields;
  EmailingdomainUserCategoryBoolExp: EmailingdomainUserCategoryBoolExp;
  EmailingdomainUserCategoryInsertInput: EmailingdomainUserCategoryInsertInput;
  EmailingdomainUserCategoryMaxFields: EmailingdomainUserCategoryMaxFields;
  EmailingdomainUserCategoryMinFields: EmailingdomainUserCategoryMinFields;
  EmailingdomainUserCategoryMutationResponse: EmailingdomainUserCategoryMutationResponse;
  EmailingdomainUserCategoryObjRelInsertInput: EmailingdomainUserCategoryObjRelInsertInput;
  EmailingdomainUserCategoryOnConflict: EmailingdomainUserCategoryOnConflict;
  EmailingdomainUserCategoryOrderBy: EmailingdomainUserCategoryOrderBy;
  EmailingdomainUserCategoryPkColumnsInput: EmailingdomainUserCategoryPkColumnsInput;
  EmailingdomainUserCategorySetInput: EmailingdomainUserCategorySetInput;
  EmailingdomainUserCategoryStreamCursorInput: EmailingdomainUserCategoryStreamCursorInput;
  EmailingdomainUserCategoryStreamCursorValueInput: EmailingdomainUserCategoryStreamCursorValueInput;
  EmailingdomainUserCategoryUpdates: EmailingdomainUserCategoryUpdates;
  EmailingdomainUserInsertInput: EmailingdomainUserInsertInput;
  EmailingdomainUserMaxFields: EmailingdomainUserMaxFields;
  EmailingdomainUserMaxOrderBy: EmailingdomainUserMaxOrderBy;
  EmailingdomainUserMinFields: EmailingdomainUserMinFields;
  EmailingdomainUserMinOrderBy: EmailingdomainUserMinOrderBy;
  EmailingdomainUserMutationResponse: EmailingdomainUserMutationResponse;
  EmailingdomainUserObjRelInsertInput: EmailingdomainUserObjRelInsertInput;
  EmailingdomainUserOnConflict: EmailingdomainUserOnConflict;
  EmailingdomainUserOrderBy: EmailingdomainUserOrderBy;
  EmailingdomainUserPkColumnsInput: EmailingdomainUserPkColumnsInput;
  EmailingdomainUserSetInput: EmailingdomainUserSetInput;
  EmailingdomainUserUpdates: EmailingdomainUserUpdates;
  EmailingemailAccountSubscribersAggregateBoolExpCount: EmailingemailAccountSubscribersAggregateBoolExpCount;
  EmailingemailCommentAggregateBoolExpCount: EmailingemailCommentAggregateBoolExpCount;
  Emailingevent: Emailingevent;
  EmailingeventAggregate: EmailingeventAggregate;
  EmailingeventAggregateFields: EmailingeventAggregateFields;
  EmailingeventBoolExp: EmailingeventBoolExp;
  EmailingeventInsertInput: EmailingeventInsertInput;
  EmailingeventMaxFields: EmailingeventMaxFields;
  EmailingeventMinFields: EmailingeventMinFields;
  EmailingeventMutationResponse: EmailingeventMutationResponse;
  EmailingeventOnConflict: EmailingeventOnConflict;
  EmailingeventOrderBy: EmailingeventOrderBy;
  EmailingeventPkColumnsInput: EmailingeventPkColumnsInput;
  EmailingeventSetInput: EmailingeventSetInput;
  EmailingeventUpdates: EmailingeventUpdates;
  Emailingnumeric: Scalars['Emailingnumeric']['output'];
  EmailingproviderAccount: EmailingproviderAccount;
  EmailingproviderAccountAggregate: EmailingproviderAccountAggregate;
  EmailingproviderAccountAggregateFields: EmailingproviderAccountAggregateFields;
  EmailingproviderAccountAggregateOrderBy: EmailingproviderAccountAggregateOrderBy;
  EmailingproviderAccountArrRelInsertInput: EmailingproviderAccountArrRelInsertInput;
  EmailingproviderAccountAvgFields: EmailingproviderAccountAvgFields;
  EmailingproviderAccountAvgOrderBy: EmailingproviderAccountAvgOrderBy;
  EmailingproviderAccountBoolExp: EmailingproviderAccountBoolExp;
  EmailingproviderAccountIncInput: EmailingproviderAccountIncInput;
  EmailingproviderAccountInsertInput: EmailingproviderAccountInsertInput;
  EmailingproviderAccountMaxFields: EmailingproviderAccountMaxFields;
  EmailingproviderAccountMaxOrderBy: EmailingproviderAccountMaxOrderBy;
  EmailingproviderAccountMinFields: EmailingproviderAccountMinFields;
  EmailingproviderAccountMinOrderBy: EmailingproviderAccountMinOrderBy;
  EmailingproviderAccountMutationResponse: EmailingproviderAccountMutationResponse;
  EmailingproviderAccountOnConflict: EmailingproviderAccountOnConflict;
  EmailingproviderAccountOrderBy: EmailingproviderAccountOrderBy;
  EmailingproviderAccountPkColumnsInput: EmailingproviderAccountPkColumnsInput;
  EmailingproviderAccountSetInput: EmailingproviderAccountSetInput;
  EmailingproviderAccountStddevFields: EmailingproviderAccountStddevFields;
  EmailingproviderAccountStddevOrderBy: EmailingproviderAccountStddevOrderBy;
  EmailingproviderAccountStddevPopFields: EmailingproviderAccountStddevPopFields;
  EmailingproviderAccountStddevPopOrderBy: EmailingproviderAccountStddevPopOrderBy;
  EmailingproviderAccountStddevSampFields: EmailingproviderAccountStddevSampFields;
  EmailingproviderAccountStddevSampOrderBy: EmailingproviderAccountStddevSampOrderBy;
  EmailingproviderAccountSumFields: EmailingproviderAccountSumFields;
  EmailingproviderAccountSumOrderBy: EmailingproviderAccountSumOrderBy;
  EmailingproviderAccountUpdates: EmailingproviderAccountUpdates;
  EmailingproviderAccountVarPopFields: EmailingproviderAccountVarPopFields;
  EmailingproviderAccountVarPopOrderBy: EmailingproviderAccountVarPopOrderBy;
  EmailingproviderAccountVarSampFields: EmailingproviderAccountVarSampFields;
  EmailingproviderAccountVarSampOrderBy: EmailingproviderAccountVarSampOrderBy;
  EmailingproviderAccountVarianceFields: EmailingproviderAccountVarianceFields;
  EmailingproviderAccountVarianceOrderBy: EmailingproviderAccountVarianceOrderBy;
  EmailingproviderType: EmailingproviderType;
  EmailingproviderTypeAggregate: EmailingproviderTypeAggregate;
  EmailingproviderTypeAggregateFields: EmailingproviderTypeAggregateFields;
  EmailingproviderTypeBoolExp: EmailingproviderTypeBoolExp;
  EmailingproviderTypeInsertInput: EmailingproviderTypeInsertInput;
  EmailingproviderTypeMaxFields: EmailingproviderTypeMaxFields;
  EmailingproviderTypeMinFields: EmailingproviderTypeMinFields;
  EmailingproviderTypeMutationResponse: EmailingproviderTypeMutationResponse;
  EmailingproviderTypeObjRelInsertInput: EmailingproviderTypeObjRelInsertInput;
  EmailingproviderTypeOnConflict: EmailingproviderTypeOnConflict;
  EmailingproviderTypeOrderBy: EmailingproviderTypeOrderBy;
  EmailingproviderTypePkColumnsInput: EmailingproviderTypePkColumnsInput;
  EmailingproviderTypeSetInput: EmailingproviderTypeSetInput;
  EmailingproviderTypeStreamCursorInput: EmailingproviderTypeStreamCursorInput;
  EmailingproviderTypeStreamCursorValueInput: EmailingproviderTypeStreamCursorValueInput;
  EmailingproviderTypeUpdates: EmailingproviderTypeUpdates;
  Emailingtimestamptz: Scalars['Emailingtimestamptz']['output'];
  File: File;
  Float: Scalars['Float']['output'];
  GateCustomParameters: GateCustomParameters;
  GeodataAddress: GeodataAddress;
  GeodataAddressAggregate: GeodataAddressAggregate;
  GeodataAddressAggregateBoolExp: GeodataAddressAggregateBoolExp;
  GeodataAddressAggregateFields: GeodataAddressAggregateFields;
  GeodataAddressAggregateOrderBy: GeodataAddressAggregateOrderBy;
  GeodataAddressArrRelInsertInput: GeodataAddressArrRelInsertInput;
  GeodataAddressBoolExp: GeodataAddressBoolExp;
  GeodataAddressInsertInput: GeodataAddressInsertInput;
  GeodataAddressMaxFields: GeodataAddressMaxFields;
  GeodataAddressMaxOrderBy: GeodataAddressMaxOrderBy;
  GeodataAddressMinFields: GeodataAddressMinFields;
  GeodataAddressMinOrderBy: GeodataAddressMinOrderBy;
  GeodataAddressMutationResponse: GeodataAddressMutationResponse;
  GeodataAddressOnConflict: GeodataAddressOnConflict;
  GeodataAddressOrderBy: GeodataAddressOrderBy;
  GeodataAddressPkColumnsInput: GeodataAddressPkColumnsInput;
  GeodataAddressSetInput: GeodataAddressSetInput;
  GeodataAddressStreamCursorInput: GeodataAddressStreamCursorInput;
  GeodataAddressStreamCursorValueInput: GeodataAddressStreamCursorValueInput;
  GeodataAddressUpdates: GeodataAddressUpdates;
  GeodataBigintComparisonExp: GeodataBigintComparisonExp;
  GeodataGeographyCastExp: GeodataGeographyCastExp;
  GeodataGeographyComparisonExp: GeodataGeographyComparisonExp;
  GeodataGeometryCastExp: GeodataGeometryCastExp;
  GeodataGeometryComparisonExp: GeodataGeometryComparisonExp;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregate: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregate;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregateFields: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregateFields;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeBoolExp: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeBoolExp;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeInsertInput: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeInsertInput;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMaxFields: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMaxFields;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMinFields: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMinFields;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMutationResponse: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMutationResponse;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeOrderBy: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeOrderBy;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeSetInput: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeSetInput;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeStreamCursorInput: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeStreamCursorInput;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeStreamCursorValueInput: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeStreamCursorValueInput;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeUpdates: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeUpdates;
  GeodataMatrikkelenadresseleilighetsnivaAtkomst: GeodataMatrikkelenadresseleilighetsnivaAtkomst;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregate: GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregate;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregateFields: GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregateFields;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstAvgFields: GeodataMatrikkelenadresseleilighetsnivaAtkomstAvgFields;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstBoolExp: GeodataMatrikkelenadresseleilighetsnivaAtkomstBoolExp;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstIncInput: GeodataMatrikkelenadresseleilighetsnivaAtkomstIncInput;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstInsertInput: GeodataMatrikkelenadresseleilighetsnivaAtkomstInsertInput;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstMaxFields: GeodataMatrikkelenadresseleilighetsnivaAtkomstMaxFields;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstMinFields: GeodataMatrikkelenadresseleilighetsnivaAtkomstMinFields;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstMutationResponse: GeodataMatrikkelenadresseleilighetsnivaAtkomstMutationResponse;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstOrderBy: GeodataMatrikkelenadresseleilighetsnivaAtkomstOrderBy;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstSetInput: GeodataMatrikkelenadresseleilighetsnivaAtkomstSetInput;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevFields: GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevFields;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevPopFields: GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevPopFields;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevSampFields: GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevSampFields;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstStreamCursorInput: GeodataMatrikkelenadresseleilighetsnivaAtkomstStreamCursorInput;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstStreamCursorValueInput: GeodataMatrikkelenadresseleilighetsnivaAtkomstStreamCursorValueInput;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstSumFields: GeodataMatrikkelenadresseleilighetsnivaAtkomstSumFields;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstUpdates: GeodataMatrikkelenadresseleilighetsnivaAtkomstUpdates;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstVarPopFields: GeodataMatrikkelenadresseleilighetsnivaAtkomstVarPopFields;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstVarSampFields: GeodataMatrikkelenadresseleilighetsnivaAtkomstVarSampFields;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstVarianceFields: GeodataMatrikkelenadresseleilighetsnivaAtkomstVarianceFields;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummer: GeodataMatrikkelenadresseleilighetsnivaKommunenummer;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregate: GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregate;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregateFields: GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregateFields;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerBoolExp: GeodataMatrikkelenadresseleilighetsnivaKommunenummerBoolExp;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerInsertInput: GeodataMatrikkelenadresseleilighetsnivaKommunenummerInsertInput;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerMaxFields: GeodataMatrikkelenadresseleilighetsnivaKommunenummerMaxFields;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerMinFields: GeodataMatrikkelenadresseleilighetsnivaKommunenummerMinFields;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerMutationResponse: GeodataMatrikkelenadresseleilighetsnivaKommunenummerMutationResponse;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerOrderBy: GeodataMatrikkelenadresseleilighetsnivaKommunenummerOrderBy;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerSetInput: GeodataMatrikkelenadresseleilighetsnivaKommunenummerSetInput;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerStreamCursorInput: GeodataMatrikkelenadresseleilighetsnivaKommunenummerStreamCursorInput;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerStreamCursorValueInput: GeodataMatrikkelenadresseleilighetsnivaKommunenummerStreamCursorValueInput;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerUpdates: GeodataMatrikkelenadresseleilighetsnivaKommunenummerUpdates;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregate: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregate;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregateFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregateFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregate: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregate;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregateFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregateFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAvgFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAvgFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidBoolExp: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidBoolExp;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidIncInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidIncInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidInsertInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidInsertInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMaxFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMaxFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMinFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMinFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMutationResponse: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMutationResponse;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidOrderBy: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidOrderBy;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidSetInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidSetInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevPopFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevPopFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevSampFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevSampFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStreamCursorInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStreamCursorInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStreamCursorValueInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStreamCursorValueInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidSumFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidSumFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidUpdates: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidUpdates;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarPopFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarPopFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarSampFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarSampFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarianceFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarianceFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAvgFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAvgFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetBoolExp: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetBoolExp;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetIncInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetIncInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetInsertInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetInsertInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMaxFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMaxFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMinFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMinFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMutationResponse: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMutationResponse;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetOrderBy: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetOrderBy;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetSetInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetSetInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevPopFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevPopFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevSampFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevSampFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStreamCursorInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStreamCursorInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStreamCursorValueInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStreamCursorValueInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetSumFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetSumFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUpdates: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUpdates;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregate: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregate;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregateFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregateFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAvgFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAvgFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstBoolExp: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstBoolExp;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstIncInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstIncInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstInsertInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstInsertInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMaxFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMaxFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMinFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMinFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMutationResponse: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMutationResponse;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstOrderBy: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstOrderBy;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstSetInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstSetInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevPopFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevPopFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevSampFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevSampFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStreamCursorInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStreamCursorInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStreamCursorValueInput: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStreamCursorValueInput;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstSumFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstSumFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstUpdates: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstUpdates;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarPopFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarPopFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarSampFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarSampFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarianceFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarianceFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarPopFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarPopFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarSampFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarSampFields;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarianceFields: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarianceFields;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomst: GeodataMatrikkelenadresseleilighetsnivaTypeatkomst;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregate: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregate;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregateFields: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregateFields;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstBoolExp: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstBoolExp;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstInsertInput: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstInsertInput;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMaxFields: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMaxFields;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMinFields: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMinFields;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMutationResponse: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMutationResponse;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstOrderBy: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstOrderBy;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstSetInput: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstSetInput;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstStreamCursorInput: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstStreamCursorInput;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstStreamCursorValueInput: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstStreamCursorValueInput;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstUpdates: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstUpdates;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhet: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhet;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregate: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregate;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregateFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregateFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregate: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregate;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregateFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregateFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAvgFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAvgFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidBoolExp: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidBoolExp;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidIncInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidIncInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidInsertInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidInsertInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMaxFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMaxFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMinFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMinFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMutationResponse: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMutationResponse;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidOrderBy: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidOrderBy;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidSetInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidSetInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevPopFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevPopFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevSampFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevSampFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStreamCursorInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStreamCursorInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStreamCursorValueInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStreamCursorValueInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidSumFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidSumFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidUpdates: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidUpdates;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarPopFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarPopFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarSampFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarSampFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarianceFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarianceFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAvgFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAvgFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetBoolExp: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetBoolExp;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetIncInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetIncInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetInsertInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetInsertInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMaxFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMaxFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMinFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMinFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMutationResponse: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMutationResponse;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetOrderBy: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetOrderBy;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetSetInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetSetInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevPopFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevPopFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevSampFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevSampFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStreamCursorInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStreamCursorInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStreamCursorValueInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStreamCursorValueInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetSumFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetSumFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUpdates: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUpdates;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregate: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregate;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregateFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregateFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAvgFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAvgFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstBoolExp: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstBoolExp;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstIncInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstIncInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstInsertInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstInsertInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMaxFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMaxFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMinFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMinFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMutationResponse: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMutationResponse;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstOrderBy: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstOrderBy;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstSetInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstSetInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevPopFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevPopFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevSampFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevSampFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStreamCursorInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStreamCursorInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStreamCursorValueInput: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStreamCursorValueInput;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstSumFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstSumFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstUpdates: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstUpdates;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarPopFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarPopFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarSampFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarSampFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarianceFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarianceFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarPopFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarPopFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarSampFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarSampFields;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarianceFields: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarianceFields;
  GeodataSpatialRefSys: GeodataSpatialRefSys;
  GeodataSpatialRefSysAggregate: GeodataSpatialRefSysAggregate;
  GeodataSpatialRefSysAggregateFields: GeodataSpatialRefSysAggregateFields;
  GeodataSpatialRefSysAvgFields: GeodataSpatialRefSysAvgFields;
  GeodataSpatialRefSysBoolExp: GeodataSpatialRefSysBoolExp;
  GeodataSpatialRefSysIncInput: GeodataSpatialRefSysIncInput;
  GeodataSpatialRefSysInsertInput: GeodataSpatialRefSysInsertInput;
  GeodataSpatialRefSysMaxFields: GeodataSpatialRefSysMaxFields;
  GeodataSpatialRefSysMinFields: GeodataSpatialRefSysMinFields;
  GeodataSpatialRefSysMutationResponse: GeodataSpatialRefSysMutationResponse;
  GeodataSpatialRefSysOnConflict: GeodataSpatialRefSysOnConflict;
  GeodataSpatialRefSysOrderBy: GeodataSpatialRefSysOrderBy;
  GeodataSpatialRefSysPkColumnsInput: GeodataSpatialRefSysPkColumnsInput;
  GeodataSpatialRefSysSetInput: GeodataSpatialRefSysSetInput;
  GeodataSpatialRefSysStddevFields: GeodataSpatialRefSysStddevFields;
  GeodataSpatialRefSysStddevPopFields: GeodataSpatialRefSysStddevPopFields;
  GeodataSpatialRefSysStddevSampFields: GeodataSpatialRefSysStddevSampFields;
  GeodataSpatialRefSysStreamCursorInput: GeodataSpatialRefSysStreamCursorInput;
  GeodataSpatialRefSysStreamCursorValueInput: GeodataSpatialRefSysStreamCursorValueInput;
  GeodataSpatialRefSysSumFields: GeodataSpatialRefSysSumFields;
  GeodataSpatialRefSysUpdates: GeodataSpatialRefSysUpdates;
  GeodataSpatialRefSysVarPopFields: GeodataSpatialRefSysVarPopFields;
  GeodataSpatialRefSysVarSampFields: GeodataSpatialRefSysVarSampFields;
  GeodataSpatialRefSysVarianceFields: GeodataSpatialRefSysVarianceFields;
  GeodataZip: GeodataZip;
  GeodataZipAggregate: GeodataZipAggregate;
  GeodataZipAggregateFields: GeodataZipAggregateFields;
  GeodataZipBoolExp: GeodataZipBoolExp;
  GeodataZipInsertInput: GeodataZipInsertInput;
  GeodataZipMaxFields: GeodataZipMaxFields;
  GeodataZipMinFields: GeodataZipMinFields;
  GeodataZipMutationResponse: GeodataZipMutationResponse;
  GeodataZipOnConflict: GeodataZipOnConflict;
  GeodataZipOrderBy: GeodataZipOrderBy;
  GeodataZipPkColumnsInput: GeodataZipPkColumnsInput;
  GeodataZipSetInput: GeodataZipSetInput;
  GeodataZipStreamCursorInput: GeodataZipStreamCursorInput;
  GeodataZipStreamCursorValueInput: GeodataZipStreamCursorValueInput;
  GeodataZipUpdates: GeodataZipUpdates;
  GeodataaddressAggregateBoolExpCount: GeodataaddressAggregateBoolExpCount;
  Geodatabigint: Scalars['Geodatabigint']['output'];
  Geodatageography: Scalars['Geodatageography']['output'];
  Geodatageometry: Scalars['Geodatageometry']['output'];
  Geodatast_d_within_geography_input: Geodatast_d_within_geography_input;
  Geodatast_d_within_input: Geodatast_d_within_input;
  Geodatatimestamptz: Scalars['Geodatatimestamptz']['output'];
  Geodatauuid: Scalars['Geodatauuid']['output'];
  IncomingSMSOutput: IncomingSMSOutput;
  Int: Scalars['Int']['output'];
  IntComparisonExp: IntComparisonExp;
  JsonbCastExp: JsonbCastExp;
  JsonbComparisonExp: JsonbComparisonExp;
  LinkCustomParameters: LinkCustomParameters;
  LinkGateCustomParameters: LinkGateCustomParameters;
  LinkMobilitySMSContent: LinkMobilitySMSContent;
  LinkMobilitySMSCustomParameters: LinkMobilitySMSCustomParameters;
  LinkMobilitySMSOutput: LinkMobilitySMSOutput;
  LinkMobilitySMSRoute: LinkMobilitySMSRoute;
  LookupPhoneNumberOutput: LookupPhoneNumberOutput;
  MessageTypeEnumComparisonExp: MessageTypeEnumComparisonExp;
  MessagingActivitySettings: MessagingActivitySettings;
  MessagingActivitySettingsAggregate: MessagingActivitySettingsAggregate;
  MessagingActivitySettingsAggregateFields: MessagingActivitySettingsAggregateFields;
  MessagingActivitySettingsBoolExp: MessagingActivitySettingsBoolExp;
  MessagingActivitySettingsInsertInput: MessagingActivitySettingsInsertInput;
  MessagingActivitySettingsMaxFields: MessagingActivitySettingsMaxFields;
  MessagingActivitySettingsMinFields: MessagingActivitySettingsMinFields;
  MessagingActivitySettingsMutationResponse: MessagingActivitySettingsMutationResponse;
  MessagingActivitySettingsNotificationSettingType: MessagingActivitySettingsNotificationSettingType;
  MessagingActivitySettingsNotificationSettingTypeAggregate: MessagingActivitySettingsNotificationSettingTypeAggregate;
  MessagingActivitySettingsNotificationSettingTypeAggregateFields: MessagingActivitySettingsNotificationSettingTypeAggregateFields;
  MessagingActivitySettingsNotificationSettingTypeBoolExp: MessagingActivitySettingsNotificationSettingTypeBoolExp;
  MessagingActivitySettingsNotificationSettingTypeEnumComparisonExp: MessagingActivitySettingsNotificationSettingTypeEnumComparisonExp;
  MessagingActivitySettingsNotificationSettingTypeInsertInput: MessagingActivitySettingsNotificationSettingTypeInsertInput;
  MessagingActivitySettingsNotificationSettingTypeMaxFields: MessagingActivitySettingsNotificationSettingTypeMaxFields;
  MessagingActivitySettingsNotificationSettingTypeMinFields: MessagingActivitySettingsNotificationSettingTypeMinFields;
  MessagingActivitySettingsNotificationSettingTypeMutationResponse: MessagingActivitySettingsNotificationSettingTypeMutationResponse;
  MessagingActivitySettingsNotificationSettingTypeOnConflict: MessagingActivitySettingsNotificationSettingTypeOnConflict;
  MessagingActivitySettingsNotificationSettingTypeOrderBy: MessagingActivitySettingsNotificationSettingTypeOrderBy;
  MessagingActivitySettingsNotificationSettingTypePkColumnsInput: MessagingActivitySettingsNotificationSettingTypePkColumnsInput;
  MessagingActivitySettingsNotificationSettingTypeSetInput: MessagingActivitySettingsNotificationSettingTypeSetInput;
  MessagingActivitySettingsNotificationSettingTypeStreamCursorInput: MessagingActivitySettingsNotificationSettingTypeStreamCursorInput;
  MessagingActivitySettingsNotificationSettingTypeStreamCursorValueInput: MessagingActivitySettingsNotificationSettingTypeStreamCursorValueInput;
  MessagingActivitySettingsNotificationSettingTypeUpdates: MessagingActivitySettingsNotificationSettingTypeUpdates;
  MessagingActivitySettingsObjRelInsertInput: MessagingActivitySettingsObjRelInsertInput;
  MessagingActivitySettingsOnConflict: MessagingActivitySettingsOnConflict;
  MessagingActivitySettingsOrderBy: MessagingActivitySettingsOrderBy;
  MessagingActivitySettingsPkColumnsInput: MessagingActivitySettingsPkColumnsInput;
  MessagingActivitySettingsSetInput: MessagingActivitySettingsSetInput;
  MessagingActivitySettingsStreamCursorInput: MessagingActivitySettingsStreamCursorInput;
  MessagingActivitySettingsStreamCursorValueInput: MessagingActivitySettingsStreamCursorValueInput;
  MessagingActivitySettingsUpdates: MessagingActivitySettingsUpdates;
  MessagingActivityTypeEnumComparisonExp: MessagingActivityTypeEnumComparisonExp;
  MessagingInvitation: MessagingInvitation;
  MessagingInvitationAggregate: MessagingInvitationAggregate;
  MessagingInvitationAggregateBoolExp: MessagingInvitationAggregateBoolExp;
  MessagingInvitationAggregateFields: MessagingInvitationAggregateFields;
  MessagingInvitationAggregateOrderBy: MessagingInvitationAggregateOrderBy;
  MessagingInvitationArrRelInsertInput: MessagingInvitationArrRelInsertInput;
  MessagingInvitationBoolExp: MessagingInvitationBoolExp;
  MessagingInvitationInsertInput: MessagingInvitationInsertInput;
  MessagingInvitationMaxFields: MessagingInvitationMaxFields;
  MessagingInvitationMaxOrderBy: MessagingInvitationMaxOrderBy;
  MessagingInvitationMinFields: MessagingInvitationMinFields;
  MessagingInvitationMinOrderBy: MessagingInvitationMinOrderBy;
  MessagingInvitationMutationResponse: MessagingInvitationMutationResponse;
  MessagingInvitationOnConflict: MessagingInvitationOnConflict;
  MessagingInvitationOrderBy: MessagingInvitationOrderBy;
  MessagingInvitationPkColumnsInput: MessagingInvitationPkColumnsInput;
  MessagingInvitationSetInput: MessagingInvitationSetInput;
  MessagingInvitationStreamCursorInput: MessagingInvitationStreamCursorInput;
  MessagingInvitationStreamCursorValueInput: MessagingInvitationStreamCursorValueInput;
  MessagingInvitationUpdates: MessagingInvitationUpdates;
  MessagingMentions: MessagingMentions;
  MessagingMentionsAggregate: MessagingMentionsAggregate;
  MessagingMentionsAggregateBoolExp: MessagingMentionsAggregateBoolExp;
  MessagingMentionsAggregateFields: MessagingMentionsAggregateFields;
  MessagingMentionsAggregateOrderBy: MessagingMentionsAggregateOrderBy;
  MessagingMentionsArrRelInsertInput: MessagingMentionsArrRelInsertInput;
  MessagingMentionsBoolExp: MessagingMentionsBoolExp;
  MessagingMentionsInsertInput: MessagingMentionsInsertInput;
  MessagingMentionsMaxFields: MessagingMentionsMaxFields;
  MessagingMentionsMaxOrderBy: MessagingMentionsMaxOrderBy;
  MessagingMentionsMinFields: MessagingMentionsMinFields;
  MessagingMentionsMinOrderBy: MessagingMentionsMinOrderBy;
  MessagingMentionsMutationResponse: MessagingMentionsMutationResponse;
  MessagingMentionsOnConflict: MessagingMentionsOnConflict;
  MessagingMentionsOrderBy: MessagingMentionsOrderBy;
  MessagingMentionsPkColumnsInput: MessagingMentionsPkColumnsInput;
  MessagingMentionsSetInput: MessagingMentionsSetInput;
  MessagingMentionsStreamCursorInput: MessagingMentionsStreamCursorInput;
  MessagingMentionsStreamCursorValueInput: MessagingMentionsStreamCursorValueInput;
  MessagingMentionsUpdates: MessagingMentionsUpdates;
  MessagingMessageAttachment: MessagingMessageAttachment;
  MessagingMessageAttachmentAggregate: MessagingMessageAttachmentAggregate;
  MessagingMessageAttachmentAggregateBoolExp: MessagingMessageAttachmentAggregateBoolExp;
  MessagingMessageAttachmentAggregateFields: MessagingMessageAttachmentAggregateFields;
  MessagingMessageAttachmentAggregateOrderBy: MessagingMessageAttachmentAggregateOrderBy;
  MessagingMessageAttachmentArrRelInsertInput: MessagingMessageAttachmentArrRelInsertInput;
  MessagingMessageAttachmentBoolExp: MessagingMessageAttachmentBoolExp;
  MessagingMessageAttachmentInsertInput: MessagingMessageAttachmentInsertInput;
  MessagingMessageAttachmentMaxFields: MessagingMessageAttachmentMaxFields;
  MessagingMessageAttachmentMaxOrderBy: MessagingMessageAttachmentMaxOrderBy;
  MessagingMessageAttachmentMinFields: MessagingMessageAttachmentMinFields;
  MessagingMessageAttachmentMinOrderBy: MessagingMessageAttachmentMinOrderBy;
  MessagingMessageAttachmentMutationResponse: MessagingMessageAttachmentMutationResponse;
  MessagingMessageAttachmentOnConflict: MessagingMessageAttachmentOnConflict;
  MessagingMessageAttachmentOrderBy: MessagingMessageAttachmentOrderBy;
  MessagingMessageAttachmentPkColumnsInput: MessagingMessageAttachmentPkColumnsInput;
  MessagingMessageAttachmentSetInput: MessagingMessageAttachmentSetInput;
  MessagingMessageAttachmentStreamCursorInput: MessagingMessageAttachmentStreamCursorInput;
  MessagingMessageAttachmentStreamCursorValueInput: MessagingMessageAttachmentStreamCursorValueInput;
  MessagingMessageAttachmentType: MessagingMessageAttachmentType;
  MessagingMessageAttachmentTypeAggregate: MessagingMessageAttachmentTypeAggregate;
  MessagingMessageAttachmentTypeAggregateFields: MessagingMessageAttachmentTypeAggregateFields;
  MessagingMessageAttachmentTypeBoolExp: MessagingMessageAttachmentTypeBoolExp;
  MessagingMessageAttachmentTypeEnumComparisonExp: MessagingMessageAttachmentTypeEnumComparisonExp;
  MessagingMessageAttachmentTypeInsertInput: MessagingMessageAttachmentTypeInsertInput;
  MessagingMessageAttachmentTypeMaxFields: MessagingMessageAttachmentTypeMaxFields;
  MessagingMessageAttachmentTypeMinFields: MessagingMessageAttachmentTypeMinFields;
  MessagingMessageAttachmentTypeMutationResponse: MessagingMessageAttachmentTypeMutationResponse;
  MessagingMessageAttachmentTypeOnConflict: MessagingMessageAttachmentTypeOnConflict;
  MessagingMessageAttachmentTypeOrderBy: MessagingMessageAttachmentTypeOrderBy;
  MessagingMessageAttachmentTypePkColumnsInput: MessagingMessageAttachmentTypePkColumnsInput;
  MessagingMessageAttachmentTypeSetInput: MessagingMessageAttachmentTypeSetInput;
  MessagingMessageAttachmentTypeStreamCursorInput: MessagingMessageAttachmentTypeStreamCursorInput;
  MessagingMessageAttachmentTypeStreamCursorValueInput: MessagingMessageAttachmentTypeStreamCursorValueInput;
  MessagingMessageAttachmentTypeUpdates: MessagingMessageAttachmentTypeUpdates;
  MessagingMessageAttachmentUpdates: MessagingMessageAttachmentUpdates;
  MessagingMessagePriority: MessagingMessagePriority;
  MessagingMessagePriorityAggregate: MessagingMessagePriorityAggregate;
  MessagingMessagePriorityAggregateFields: MessagingMessagePriorityAggregateFields;
  MessagingMessagePriorityBoolExp: MessagingMessagePriorityBoolExp;
  MessagingMessagePriorityEnumComparisonExp: MessagingMessagePriorityEnumComparisonExp;
  MessagingMessagePriorityInsertInput: MessagingMessagePriorityInsertInput;
  MessagingMessagePriorityMaxFields: MessagingMessagePriorityMaxFields;
  MessagingMessagePriorityMinFields: MessagingMessagePriorityMinFields;
  MessagingMessagePriorityMutationResponse: MessagingMessagePriorityMutationResponse;
  MessagingMessagePriorityOnConflict: MessagingMessagePriorityOnConflict;
  MessagingMessagePriorityOrderBy: MessagingMessagePriorityOrderBy;
  MessagingMessagePriorityPkColumnsInput: MessagingMessagePriorityPkColumnsInput;
  MessagingMessagePrioritySetInput: MessagingMessagePrioritySetInput;
  MessagingMessagePriorityStreamCursorInput: MessagingMessagePriorityStreamCursorInput;
  MessagingMessagePriorityStreamCursorValueInput: MessagingMessagePriorityStreamCursorValueInput;
  MessagingMessagePriorityUpdates: MessagingMessagePriorityUpdates;
  MessagingMessageTypeEnumComparisonExp: MessagingMessageTypeEnumComparisonExp;
  NewActivity: NewActivity;
  NewActivityOutput: NewActivityOutput;
  NotificationInput: NotificationInput;
  NotificationNotificationDeviceSent: NotificationNotificationDeviceSent;
  NotificationNotificationDeviceSentAggregate: NotificationNotificationDeviceSentAggregate;
  NotificationNotificationDeviceSentAggregateFields: NotificationNotificationDeviceSentAggregateFields;
  NotificationNotificationDeviceSentBoolExp: NotificationNotificationDeviceSentBoolExp;
  NotificationNotificationDeviceSentInsertInput: NotificationNotificationDeviceSentInsertInput;
  NotificationNotificationDeviceSentMaxFields: NotificationNotificationDeviceSentMaxFields;
  NotificationNotificationDeviceSentMinFields: NotificationNotificationDeviceSentMinFields;
  NotificationNotificationDeviceSentMutationResponse: NotificationNotificationDeviceSentMutationResponse;
  NotificationNotificationDeviceSentOnConflict: NotificationNotificationDeviceSentOnConflict;
  NotificationNotificationDeviceSentOrderBy: NotificationNotificationDeviceSentOrderBy;
  NotificationNotificationDeviceSentPkColumnsInput: NotificationNotificationDeviceSentPkColumnsInput;
  NotificationNotificationDeviceSentSetInput: NotificationNotificationDeviceSentSetInput;
  NotificationNotificationDeviceSentStreamCursorInput: NotificationNotificationDeviceSentStreamCursorInput;
  NotificationNotificationDeviceSentStreamCursorValueInput: NotificationNotificationDeviceSentStreamCursorValueInput;
  NotificationNotificationDeviceSentUpdates: NotificationNotificationDeviceSentUpdates;
  NotificationNotificationSettingActivityPrimaryEnum: NotificationNotificationSettingActivityPrimaryEnum;
  NotificationNotificationSettingActivityPrimaryEnumAggregate: NotificationNotificationSettingActivityPrimaryEnumAggregate;
  NotificationNotificationSettingActivityPrimaryEnumAggregateFields: NotificationNotificationSettingActivityPrimaryEnumAggregateFields;
  NotificationNotificationSettingActivityPrimaryEnumBoolExp: NotificationNotificationSettingActivityPrimaryEnumBoolExp;
  NotificationNotificationSettingActivityPrimaryEnumEnumComparisonExp: NotificationNotificationSettingActivityPrimaryEnumEnumComparisonExp;
  NotificationNotificationSettingActivityPrimaryEnumInsertInput: NotificationNotificationSettingActivityPrimaryEnumInsertInput;
  NotificationNotificationSettingActivityPrimaryEnumMaxFields: NotificationNotificationSettingActivityPrimaryEnumMaxFields;
  NotificationNotificationSettingActivityPrimaryEnumMinFields: NotificationNotificationSettingActivityPrimaryEnumMinFields;
  NotificationNotificationSettingActivityPrimaryEnumMutationResponse: NotificationNotificationSettingActivityPrimaryEnumMutationResponse;
  NotificationNotificationSettingActivityPrimaryEnumOnConflict: NotificationNotificationSettingActivityPrimaryEnumOnConflict;
  NotificationNotificationSettingActivityPrimaryEnumOrderBy: NotificationNotificationSettingActivityPrimaryEnumOrderBy;
  NotificationNotificationSettingActivityPrimaryEnumPkColumnsInput: NotificationNotificationSettingActivityPrimaryEnumPkColumnsInput;
  NotificationNotificationSettingActivityPrimaryEnumSetInput: NotificationNotificationSettingActivityPrimaryEnumSetInput;
  NotificationNotificationSettingActivityPrimaryEnumStreamCursorInput: NotificationNotificationSettingActivityPrimaryEnumStreamCursorInput;
  NotificationNotificationSettingActivityPrimaryEnumStreamCursorValueInput: NotificationNotificationSettingActivityPrimaryEnumStreamCursorValueInput;
  NotificationNotificationSettingActivityPrimaryEnumUpdates: NotificationNotificationSettingActivityPrimaryEnumUpdates;
  NotificationOutput: NotificationOutput;
  NumericComparisonExp: NumericComparisonExp;
  OrderUpdateInput: OrderUpdateInput;
  OrderUpdateOutput: OrderUpdateOutput;
  OrdersOrganizations: OrdersOrganizations;
  OrdersOrganizationsAggregate: OrdersOrganizationsAggregate;
  OrdersOrganizationsAggregateFields: OrdersOrganizationsAggregateFields;
  OrdersOrganizationsAvgFields: OrdersOrganizationsAvgFields;
  OrdersOrganizationsBoolExp: OrdersOrganizationsBoolExp;
  OrdersOrganizationsIncInput: OrdersOrganizationsIncInput;
  OrdersOrganizationsInsertInput: OrdersOrganizationsInsertInput;
  OrdersOrganizationsMaxFields: OrdersOrganizationsMaxFields;
  OrdersOrganizationsMinFields: OrdersOrganizationsMinFields;
  OrdersOrganizationsMutationResponse: OrdersOrganizationsMutationResponse;
  OrdersOrganizationsOnConflict: OrdersOrganizationsOnConflict;
  OrdersOrganizationsOrderBy: OrdersOrganizationsOrderBy;
  OrdersOrganizationsPkColumnsInput: OrdersOrganizationsPkColumnsInput;
  OrdersOrganizationsSetInput: OrdersOrganizationsSetInput;
  OrdersOrganizationsStddevFields: OrdersOrganizationsStddevFields;
  OrdersOrganizationsStddevPopFields: OrdersOrganizationsStddevPopFields;
  OrdersOrganizationsStddevSampFields: OrdersOrganizationsStddevSampFields;
  OrdersOrganizationsStreamCursorInput: OrdersOrganizationsStreamCursorInput;
  OrdersOrganizationsStreamCursorValueInput: OrdersOrganizationsStreamCursorValueInput;
  OrdersOrganizationsSumFields: OrdersOrganizationsSumFields;
  OrdersOrganizationsUpdates: OrdersOrganizationsUpdates;
  OrdersOrganizationsVarPopFields: OrdersOrganizationsVarPopFields;
  OrdersOrganizationsVarSampFields: OrdersOrganizationsVarSampFields;
  OrdersOrganizationsVarianceFields: OrdersOrganizationsVarianceFields;
  OrdersRequest: OrdersRequest;
  OrdersRequestAggregate: OrdersRequestAggregate;
  OrdersRequestAggregateFields: OrdersRequestAggregateFields;
  OrdersRequestBoolExp: OrdersRequestBoolExp;
  OrdersRequestEnumComparisonExp: OrdersRequestEnumComparisonExp;
  OrdersRequestInsertInput: OrdersRequestInsertInput;
  OrdersRequestMaxFields: OrdersRequestMaxFields;
  OrdersRequestMinFields: OrdersRequestMinFields;
  OrdersRequestMutationResponse: OrdersRequestMutationResponse;
  OrdersRequestOnConflict: OrdersRequestOnConflict;
  OrdersRequestOrderBy: OrdersRequestOrderBy;
  OrdersRequestPkColumnsInput: OrdersRequestPkColumnsInput;
  OrdersRequestSetInput: OrdersRequestSetInput;
  OrdersRequestStreamCursorInput: OrdersRequestStreamCursorInput;
  OrdersRequestStreamCursorValueInput: OrdersRequestStreamCursorValueInput;
  OrdersRequestUpdates: OrdersRequestUpdates;
  OrdersStatus: OrdersStatus;
  OrdersStatusAggregate: OrdersStatusAggregate;
  OrdersStatusAggregateFields: OrdersStatusAggregateFields;
  OrdersStatusBoolExp: OrdersStatusBoolExp;
  OrdersStatusEnumComparisonExp: OrdersStatusEnumComparisonExp;
  OrdersStatusInsertInput: OrdersStatusInsertInput;
  OrdersStatusMaxFields: OrdersStatusMaxFields;
  OrdersStatusMinFields: OrdersStatusMinFields;
  OrdersStatusMutationResponse: OrdersStatusMutationResponse;
  OrdersStatusOnConflict: OrdersStatusOnConflict;
  OrdersStatusOrderBy: OrdersStatusOrderBy;
  OrdersStatusPkColumnsInput: OrdersStatusPkColumnsInput;
  OrdersStatusSetInput: OrdersStatusSetInput;
  OrdersStatusStreamCursorInput: OrdersStatusStreamCursorInput;
  OrdersStatusStreamCursorValueInput: OrdersStatusStreamCursorValueInput;
  OrdersStatusUpdates: OrdersStatusUpdates;
  OrdersType: OrdersType;
  OrdersTypeAggregate: OrdersTypeAggregate;
  OrdersTypeAggregateFields: OrdersTypeAggregateFields;
  OrdersTypeBoolExp: OrdersTypeBoolExp;
  OrdersTypeEnumComparisonExp: OrdersTypeEnumComparisonExp;
  OrdersTypeInsertInput: OrdersTypeInsertInput;
  OrdersTypeMaxFields: OrdersTypeMaxFields;
  OrdersTypeMinFields: OrdersTypeMinFields;
  OrdersTypeMutationResponse: OrdersTypeMutationResponse;
  OrdersTypeOnConflict: OrdersTypeOnConflict;
  OrdersTypeOrderBy: OrdersTypeOrderBy;
  OrdersTypePkColumnsInput: OrdersTypePkColumnsInput;
  OrdersTypeSetInput: OrdersTypeSetInput;
  OrdersTypeStreamCursorInput: OrdersTypeStreamCursorInput;
  OrdersTypeStreamCursorValueInput: OrdersTypeStreamCursorValueInput;
  OrdersTypeUpdates: OrdersTypeUpdates;
  OrganizationOutput: OrganizationOutput;
  OrganizationUserAttentionNote: OrganizationUserAttentionNote;
  OrganizationUserAttentionNoteAggregate: OrganizationUserAttentionNoteAggregate;
  OrganizationUserAttentionNoteAggregateFields: OrganizationUserAttentionNoteAggregateFields;
  OrganizationUserAttentionNoteBoolExp: OrganizationUserAttentionNoteBoolExp;
  OrganizationUserAttentionNoteInsertInput: OrganizationUserAttentionNoteInsertInput;
  OrganizationUserAttentionNoteMaxFields: OrganizationUserAttentionNoteMaxFields;
  OrganizationUserAttentionNoteMinFields: OrganizationUserAttentionNoteMinFields;
  OrganizationUserAttentionNoteMutationResponse: OrganizationUserAttentionNoteMutationResponse;
  OrganizationUserAttentionNoteOnConflict: OrganizationUserAttentionNoteOnConflict;
  OrganizationUserAttentionNoteOrderBy: OrganizationUserAttentionNoteOrderBy;
  OrganizationUserAttentionNotePkColumnsInput: OrganizationUserAttentionNotePkColumnsInput;
  OrganizationUserAttentionNoteSetInput: OrganizationUserAttentionNoteSetInput;
  OrganizationUserAttentionNoteStreamCursorInput: OrganizationUserAttentionNoteStreamCursorInput;
  OrganizationUserAttentionNoteStreamCursorValueInput: OrganizationUserAttentionNoteStreamCursorValueInput;
  OrganizationUserAttentionNoteUpdates: OrganizationUserAttentionNoteUpdates;
  OrganizationUserAuthorizationEnumComparisonExp: OrganizationUserAuthorizationEnumComparisonExp;
  OrganizationUserDetailTypeEnumComparisonExp: OrganizationUserDetailTypeEnumComparisonExp;
  OrganizationUserStatusEnumComparisonExp: OrganizationUserStatusEnumComparisonExp;
  OrganizationsOutput: OrganizationsOutput;
  PhoneNumberVerificationStatusEnumComparisonExp: PhoneNumberVerificationStatusEnumComparisonExp;
  PhoneRequestInput: PhoneRequestInput;
  PhoneRequestOutput: PhoneRequestOutput;
  Prompt: Prompt;
  PromptAggregate: PromptAggregate;
  PromptAggregateFields: PromptAggregateFields;
  PromptBoolExp: PromptBoolExp;
  PromptInsertInput: PromptInsertInput;
  PromptMaxFields: PromptMaxFields;
  PromptMinFields: PromptMinFields;
  PromptMutationResponse: PromptMutationResponse;
  PromptOnConflict: PromptOnConflict;
  PromptOrderBy: PromptOrderBy;
  PromptPkColumnsInput: PromptPkColumnsInput;
  PromptSetInput: PromptSetInput;
  PromptStreamCursorInput: PromptStreamCursorInput;
  PromptStreamCursorValueInput: PromptStreamCursorValueInput;
  PromptUpdates: PromptUpdates;
  QueueItemFlexibilityType: QueueItemFlexibilityType;
  QueueItemFlexibilityTypeAggregate: QueueItemFlexibilityTypeAggregate;
  QueueItemFlexibilityTypeAggregateFields: QueueItemFlexibilityTypeAggregateFields;
  QueueItemFlexibilityTypeBoolExp: QueueItemFlexibilityTypeBoolExp;
  QueueItemFlexibilityTypeInsertInput: QueueItemFlexibilityTypeInsertInput;
  QueueItemFlexibilityTypeMaxFields: QueueItemFlexibilityTypeMaxFields;
  QueueItemFlexibilityTypeMinFields: QueueItemFlexibilityTypeMinFields;
  QueueItemFlexibilityTypeMutationResponse: QueueItemFlexibilityTypeMutationResponse;
  QueueItemFlexibilityTypeObjRelInsertInput: QueueItemFlexibilityTypeObjRelInsertInput;
  QueueItemFlexibilityTypeOnConflict: QueueItemFlexibilityTypeOnConflict;
  QueueItemFlexibilityTypeOrderBy: QueueItemFlexibilityTypeOrderBy;
  QueueItemFlexibilityTypePkColumnsInput: QueueItemFlexibilityTypePkColumnsInput;
  QueueItemFlexibilityTypeSetInput: QueueItemFlexibilityTypeSetInput;
  QueueItemFlexibilityTypeStreamCursorInput: QueueItemFlexibilityTypeStreamCursorInput;
  QueueItemFlexibilityTypeStreamCursorValueInput: QueueItemFlexibilityTypeStreamCursorValueInput;
  QueueItemFlexibilityTypeUpdates: QueueItemFlexibilityTypeUpdates;
  QueueItemParticipantResponsibilityType: QueueItemParticipantResponsibilityType;
  QueueItemParticipantResponsibilityTypeAggregate: QueueItemParticipantResponsibilityTypeAggregate;
  QueueItemParticipantResponsibilityTypeAggregateFields: QueueItemParticipantResponsibilityTypeAggregateFields;
  QueueItemParticipantResponsibilityTypeBoolExp: QueueItemParticipantResponsibilityTypeBoolExp;
  QueueItemParticipantResponsibilityTypeEnumComparisonExp: QueueItemParticipantResponsibilityTypeEnumComparisonExp;
  QueueItemParticipantResponsibilityTypeInsertInput: QueueItemParticipantResponsibilityTypeInsertInput;
  QueueItemParticipantResponsibilityTypeMaxFields: QueueItemParticipantResponsibilityTypeMaxFields;
  QueueItemParticipantResponsibilityTypeMinFields: QueueItemParticipantResponsibilityTypeMinFields;
  QueueItemParticipantResponsibilityTypeMutationResponse: QueueItemParticipantResponsibilityTypeMutationResponse;
  QueueItemParticipantResponsibilityTypeObjRelInsertInput: QueueItemParticipantResponsibilityTypeObjRelInsertInput;
  QueueItemParticipantResponsibilityTypeOnConflict: QueueItemParticipantResponsibilityTypeOnConflict;
  QueueItemParticipantResponsibilityTypeOrderBy: QueueItemParticipantResponsibilityTypeOrderBy;
  QueueItemParticipantResponsibilityTypePkColumnsInput: QueueItemParticipantResponsibilityTypePkColumnsInput;
  QueueItemParticipantResponsibilityTypeSetInput: QueueItemParticipantResponsibilityTypeSetInput;
  QueueItemParticipantResponsibilityTypeStreamCursorInput: QueueItemParticipantResponsibilityTypeStreamCursorInput;
  QueueItemParticipantResponsibilityTypeStreamCursorValueInput: QueueItemParticipantResponsibilityTypeStreamCursorValueInput;
  QueueItemParticipantResponsibilityTypeUpdates: QueueItemParticipantResponsibilityTypeUpdates;
  RegistryCode: RegistryCode;
  RegistryCodeAggregate: RegistryCodeAggregate;
  RegistryCodeAggregateFields: RegistryCodeAggregateFields;
  RegistryCodeBoolExp: RegistryCodeBoolExp;
  RegistryCodeInsertInput: RegistryCodeInsertInput;
  RegistryCodeMaxFields: RegistryCodeMaxFields;
  RegistryCodeMinFields: RegistryCodeMinFields;
  RegistryCodeMutationResponse: RegistryCodeMutationResponse;
  RegistryCodeObjRelInsertInput: RegistryCodeObjRelInsertInput;
  RegistryCodeOnConflict: RegistryCodeOnConflict;
  RegistryCodeOrderBy: RegistryCodeOrderBy;
  RegistryCodePkColumnsInput: RegistryCodePkColumnsInput;
  RegistryCodeSetInput: RegistryCodeSetInput;
  RegistryCodeStreamCursorInput: RegistryCodeStreamCursorInput;
  RegistryCodeStreamCursorValueInput: RegistryCodeStreamCursorValueInput;
  RegistryCodeUpdates: RegistryCodeUpdates;
  RegistryDateComparisonExp: RegistryDateComparisonExp;
  RegistryInfo: RegistryInfo;
  RegistryInfoAggregate: RegistryInfoAggregate;
  RegistryInfoAggregateFields: RegistryInfoAggregateFields;
  RegistryInfoBoolExp: RegistryInfoBoolExp;
  RegistryInfoInsertInput: RegistryInfoInsertInput;
  RegistryInfoMaxFields: RegistryInfoMaxFields;
  RegistryInfoMinFields: RegistryInfoMinFields;
  RegistryInfoMutationResponse: RegistryInfoMutationResponse;
  RegistryInfoOnConflict: RegistryInfoOnConflict;
  RegistryInfoOrderBy: RegistryInfoOrderBy;
  RegistryInfoPkColumnsInput: RegistryInfoPkColumnsInput;
  RegistryInfoSetInput: RegistryInfoSetInput;
  RegistryInfoStreamCursorInput: RegistryInfoStreamCursorInput;
  RegistryInfoStreamCursorValueInput: RegistryInfoStreamCursorValueInput;
  RegistryInfoUpdates: RegistryInfoUpdates;
  RegistryOrganisasjonsform: RegistryOrganisasjonsform;
  RegistryOrganisasjonsformAggregate: RegistryOrganisasjonsformAggregate;
  RegistryOrganisasjonsformAggregateFields: RegistryOrganisasjonsformAggregateFields;
  RegistryOrganisasjonsformAppendInput: RegistryOrganisasjonsformAppendInput;
  RegistryOrganisasjonsformBoolExp: RegistryOrganisasjonsformBoolExp;
  RegistryOrganisasjonsformDeleteAtPathInput: RegistryOrganisasjonsformDeleteAtPathInput;
  RegistryOrganisasjonsformDeleteElemInput: RegistryOrganisasjonsformDeleteElemInput;
  RegistryOrganisasjonsformDeleteKeyInput: RegistryOrganisasjonsformDeleteKeyInput;
  RegistryOrganisasjonsformInsertInput: RegistryOrganisasjonsformInsertInput;
  RegistryOrganisasjonsformMaxFields: RegistryOrganisasjonsformMaxFields;
  RegistryOrganisasjonsformMinFields: RegistryOrganisasjonsformMinFields;
  RegistryOrganisasjonsformMutationResponse: RegistryOrganisasjonsformMutationResponse;
  RegistryOrganisasjonsformObjRelInsertInput: RegistryOrganisasjonsformObjRelInsertInput;
  RegistryOrganisasjonsformOnConflict: RegistryOrganisasjonsformOnConflict;
  RegistryOrganisasjonsformOrderBy: RegistryOrganisasjonsformOrderBy;
  RegistryOrganisasjonsformPkColumnsInput: RegistryOrganisasjonsformPkColumnsInput;
  RegistryOrganisasjonsformPrependInput: RegistryOrganisasjonsformPrependInput;
  RegistryOrganisasjonsformSetInput: RegistryOrganisasjonsformSetInput;
  RegistryOrganisasjonsformStreamCursorInput: RegistryOrganisasjonsformStreamCursorInput;
  RegistryOrganisasjonsformStreamCursorValueInput: RegistryOrganisasjonsformStreamCursorValueInput;
  RegistryOrganisasjonsformUpdates: RegistryOrganisasjonsformUpdates;
  RegistryOrganization: RegistryOrganization;
  RegistryOrganizationAggregate: RegistryOrganizationAggregate;
  RegistryOrganizationAggregateFields: RegistryOrganizationAggregateFields;
  RegistryOrganizationAppendInput: RegistryOrganizationAppendInput;
  RegistryOrganizationAvgFields: RegistryOrganizationAvgFields;
  RegistryOrganizationBoolExp: RegistryOrganizationBoolExp;
  RegistryOrganizationDeleteAtPathInput: RegistryOrganizationDeleteAtPathInput;
  RegistryOrganizationDeleteElemInput: RegistryOrganizationDeleteElemInput;
  RegistryOrganizationDeleteKeyInput: RegistryOrganizationDeleteKeyInput;
  RegistryOrganizationIncInput: RegistryOrganizationIncInput;
  RegistryOrganizationInsertInput: RegistryOrganizationInsertInput;
  RegistryOrganizationMaxFields: RegistryOrganizationMaxFields;
  RegistryOrganizationMinFields: RegistryOrganizationMinFields;
  RegistryOrganizationMutationResponse: RegistryOrganizationMutationResponse;
  RegistryOrganizationOnConflict: RegistryOrganizationOnConflict;
  RegistryOrganizationOrderBy: RegistryOrganizationOrderBy;
  RegistryOrganizationPkColumnsInput: RegistryOrganizationPkColumnsInput;
  RegistryOrganizationPrependInput: RegistryOrganizationPrependInput;
  RegistryOrganizationSetInput: RegistryOrganizationSetInput;
  RegistryOrganizationStddevFields: RegistryOrganizationStddevFields;
  RegistryOrganizationStddevPopFields: RegistryOrganizationStddevPopFields;
  RegistryOrganizationStddevSampFields: RegistryOrganizationStddevSampFields;
  RegistryOrganizationStreamCursorInput: RegistryOrganizationStreamCursorInput;
  RegistryOrganizationStreamCursorValueInput: RegistryOrganizationStreamCursorValueInput;
  RegistryOrganizationSumFields: RegistryOrganizationSumFields;
  RegistryOrganizationUpdates: RegistryOrganizationUpdates;
  RegistryOrganizationVarPopFields: RegistryOrganizationVarPopFields;
  RegistryOrganizationVarSampFields: RegistryOrganizationVarSampFields;
  RegistryOrganizationVarianceFields: RegistryOrganizationVarianceFields;
  RegistryPostadresse: RegistryPostadresse;
  RegistryPostadresseAggregate: RegistryPostadresseAggregate;
  RegistryPostadresseAggregateFields: RegistryPostadresseAggregateFields;
  RegistryPostadresseAppendInput: RegistryPostadresseAppendInput;
  RegistryPostadresseBoolExp: RegistryPostadresseBoolExp;
  RegistryPostadresseDeleteAtPathInput: RegistryPostadresseDeleteAtPathInput;
  RegistryPostadresseDeleteElemInput: RegistryPostadresseDeleteElemInput;
  RegistryPostadresseDeleteKeyInput: RegistryPostadresseDeleteKeyInput;
  RegistryPostadresseInsertInput: RegistryPostadresseInsertInput;
  RegistryPostadresseMaxFields: RegistryPostadresseMaxFields;
  RegistryPostadresseMinFields: RegistryPostadresseMinFields;
  RegistryPostadresseMutationResponse: RegistryPostadresseMutationResponse;
  RegistryPostadresseObjRelInsertInput: RegistryPostadresseObjRelInsertInput;
  RegistryPostadresseOnConflict: RegistryPostadresseOnConflict;
  RegistryPostadresseOrderBy: RegistryPostadresseOrderBy;
  RegistryPostadressePkColumnsInput: RegistryPostadressePkColumnsInput;
  RegistryPostadressePrependInput: RegistryPostadressePrependInput;
  RegistryPostadresseSetInput: RegistryPostadresseSetInput;
  RegistryPostadresseStreamCursorInput: RegistryPostadresseStreamCursorInput;
  RegistryPostadresseStreamCursorValueInput: RegistryPostadresseStreamCursorValueInput;
  RegistryPostadresseUpdates: RegistryPostadresseUpdates;
  Registrydate: Scalars['Registrydate']['output'];
  Registryjsonb: Scalars['Registryjsonb']['output'];
  Registrynumeric: Scalars['Registrynumeric']['output'];
  Registrytimestamptz: Scalars['Registrytimestamptz']['output'];
  Registryuuid: Scalars['Registryuuid']['output'];
  RelationType: RelationType;
  RelationTypeAggregate: RelationTypeAggregate;
  RelationTypeAggregateFields: RelationTypeAggregateFields;
  RelationTypeBoolExp: RelationTypeBoolExp;
  RelationTypeEnumComparisonExp: RelationTypeEnumComparisonExp;
  RelationTypeInsertInput: RelationTypeInsertInput;
  RelationTypeMaxFields: RelationTypeMaxFields;
  RelationTypeMinFields: RelationTypeMinFields;
  RelationTypeMutationResponse: RelationTypeMutationResponse;
  RelationTypeObjRelInsertInput: RelationTypeObjRelInsertInput;
  RelationTypeOnConflict: RelationTypeOnConflict;
  RelationTypeOrderBy: RelationTypeOrderBy;
  RelationTypePkColumnsInput: RelationTypePkColumnsInput;
  RelationTypeSetInput: RelationTypeSetInput;
  RelationTypeStreamCursorInput: RelationTypeStreamCursorInput;
  RelationTypeStreamCursorValueInput: RelationTypeStreamCursorValueInput;
  RelationTypeUpdates: RelationTypeUpdates;
  RemoveCustomerInput: RemoveCustomerInput;
  RemoveCustomerOutput: RemoveCustomerOutput;
  RequestIntegrationsInput: RequestIntegrationsInput;
  RequestIntegrationsOutput: RequestIntegrationsOutput;
  Route: Route;
  SearchPhoneInput: SearchPhoneInput;
  SearchPhoneOutput: SearchPhoneOutput;
  SendSMSOutput: SendSMSOutput;
  SendSMSTokenOutput: SendSMSTokenOutput;
  StatusOutput: StatusOutput;
  String: Scalars['String']['output'];
  StringComparisonExp: StringComparisonExp;
  TaskActivity: TaskActivity;
  TaskActivityAggregate: TaskActivityAggregate;
  TaskActivityAggregateFields: TaskActivityAggregateFields;
  TaskActivityAppendInput: TaskActivityAppendInput;
  TaskActivityBoolExp: TaskActivityBoolExp;
  TaskActivityDeleteAtPathInput: TaskActivityDeleteAtPathInput;
  TaskActivityDeleteElemInput: TaskActivityDeleteElemInput;
  TaskActivityDeleteKeyInput: TaskActivityDeleteKeyInput;
  TaskActivityInsertInput: TaskActivityInsertInput;
  TaskActivityMaxFields: TaskActivityMaxFields;
  TaskActivityMinFields: TaskActivityMinFields;
  TaskActivityMutationResponse: TaskActivityMutationResponse;
  TaskActivityObjRelInsertInput: TaskActivityObjRelInsertInput;
  TaskActivityOnConflict: TaskActivityOnConflict;
  TaskActivityOrderBy: TaskActivityOrderBy;
  TaskActivityParticipant: TaskActivityParticipant;
  TaskActivityParticipantAggregate: TaskActivityParticipantAggregate;
  TaskActivityParticipantAggregateBoolExp: TaskActivityParticipantAggregateBoolExp;
  TaskActivityParticipantAggregateFields: TaskActivityParticipantAggregateFields;
  TaskActivityParticipantAggregateOrderBy: TaskActivityParticipantAggregateOrderBy;
  TaskActivityParticipantArrRelInsertInput: TaskActivityParticipantArrRelInsertInput;
  TaskActivityParticipantBoolExp: TaskActivityParticipantBoolExp;
  TaskActivityParticipantInsertInput: TaskActivityParticipantInsertInput;
  TaskActivityParticipantMaxFields: TaskActivityParticipantMaxFields;
  TaskActivityParticipantMaxOrderBy: TaskActivityParticipantMaxOrderBy;
  TaskActivityParticipantMinFields: TaskActivityParticipantMinFields;
  TaskActivityParticipantMinOrderBy: TaskActivityParticipantMinOrderBy;
  TaskActivityParticipantMutationResponse: TaskActivityParticipantMutationResponse;
  TaskActivityParticipantOnConflict: TaskActivityParticipantOnConflict;
  TaskActivityParticipantOrderBy: TaskActivityParticipantOrderBy;
  TaskActivityParticipantPkColumnsInput: TaskActivityParticipantPkColumnsInput;
  TaskActivityParticipantSetInput: TaskActivityParticipantSetInput;
  TaskActivityParticipantStreamCursorInput: TaskActivityParticipantStreamCursorInput;
  TaskActivityParticipantStreamCursorValueInput: TaskActivityParticipantStreamCursorValueInput;
  TaskActivityParticipantUpdates: TaskActivityParticipantUpdates;
  TaskActivityPkColumnsInput: TaskActivityPkColumnsInput;
  TaskActivityPrependInput: TaskActivityPrependInput;
  TaskActivitySetInput: TaskActivitySetInput;
  TaskActivityStreamCursorInput: TaskActivityStreamCursorInput;
  TaskActivityStreamCursorValueInput: TaskActivityStreamCursorValueInput;
  TaskActivityType: TaskActivityType;
  TaskActivityTypeAggregate: TaskActivityTypeAggregate;
  TaskActivityTypeAggregateFields: TaskActivityTypeAggregateFields;
  TaskActivityTypeBoolExp: TaskActivityTypeBoolExp;
  TaskActivityTypeEnumComparisonExp: TaskActivityTypeEnumComparisonExp;
  TaskActivityTypeInsertInput: TaskActivityTypeInsertInput;
  TaskActivityTypeMaxFields: TaskActivityTypeMaxFields;
  TaskActivityTypeMinFields: TaskActivityTypeMinFields;
  TaskActivityTypeMutationResponse: TaskActivityTypeMutationResponse;
  TaskActivityTypeObjRelInsertInput: TaskActivityTypeObjRelInsertInput;
  TaskActivityTypeOnConflict: TaskActivityTypeOnConflict;
  TaskActivityTypeOrderBy: TaskActivityTypeOrderBy;
  TaskActivityTypePkColumnsInput: TaskActivityTypePkColumnsInput;
  TaskActivityTypeSetInput: TaskActivityTypeSetInput;
  TaskActivityTypeStreamCursorInput: TaskActivityTypeStreamCursorInput;
  TaskActivityTypeStreamCursorValueInput: TaskActivityTypeStreamCursorValueInput;
  TaskActivityTypeUpdates: TaskActivityTypeUpdates;
  TaskActivityUpdates: TaskActivityUpdates;
  TaskDomainOrganization: TaskDomainOrganization;
  TaskDomainOrganizationAggregate: TaskDomainOrganizationAggregate;
  TaskDomainOrganizationAggregateFields: TaskDomainOrganizationAggregateFields;
  TaskDomainOrganizationBoolExp: TaskDomainOrganizationBoolExp;
  TaskDomainOrganizationInsertInput: TaskDomainOrganizationInsertInput;
  TaskDomainOrganizationMaxFields: TaskDomainOrganizationMaxFields;
  TaskDomainOrganizationMinFields: TaskDomainOrganizationMinFields;
  TaskDomainOrganizationMutationResponse: TaskDomainOrganizationMutationResponse;
  TaskDomainOrganizationObjRelInsertInput: TaskDomainOrganizationObjRelInsertInput;
  TaskDomainOrganizationOnConflict: TaskDomainOrganizationOnConflict;
  TaskDomainOrganizationOrderBy: TaskDomainOrganizationOrderBy;
  TaskDomainOrganizationPkColumnsInput: TaskDomainOrganizationPkColumnsInput;
  TaskDomainOrganizationSetInput: TaskDomainOrganizationSetInput;
  TaskDomainOrganizationStreamCursorInput: TaskDomainOrganizationStreamCursorInput;
  TaskDomainOrganizationStreamCursorValueInput: TaskDomainOrganizationStreamCursorValueInput;
  TaskDomainOrganizationUpdates: TaskDomainOrganizationUpdates;
  TaskDomainUser: TaskDomainUser;
  TaskDomainUserAggregate: TaskDomainUserAggregate;
  TaskDomainUserAggregateBoolExp: TaskDomainUserAggregateBoolExp;
  TaskDomainUserAggregateFields: TaskDomainUserAggregateFields;
  TaskDomainUserAggregateOrderBy: TaskDomainUserAggregateOrderBy;
  TaskDomainUserArrRelInsertInput: TaskDomainUserArrRelInsertInput;
  TaskDomainUserBoolExp: TaskDomainUserBoolExp;
  TaskDomainUserCategory: TaskDomainUserCategory;
  TaskDomainUserCategoryAggregate: TaskDomainUserCategoryAggregate;
  TaskDomainUserCategoryAggregateFields: TaskDomainUserCategoryAggregateFields;
  TaskDomainUserCategoryBoolExp: TaskDomainUserCategoryBoolExp;
  TaskDomainUserCategoryEnumComparisonExp: TaskDomainUserCategoryEnumComparisonExp;
  TaskDomainUserCategoryInsertInput: TaskDomainUserCategoryInsertInput;
  TaskDomainUserCategoryMaxFields: TaskDomainUserCategoryMaxFields;
  TaskDomainUserCategoryMinFields: TaskDomainUserCategoryMinFields;
  TaskDomainUserCategoryMutationResponse: TaskDomainUserCategoryMutationResponse;
  TaskDomainUserCategoryObjRelInsertInput: TaskDomainUserCategoryObjRelInsertInput;
  TaskDomainUserCategoryOnConflict: TaskDomainUserCategoryOnConflict;
  TaskDomainUserCategoryOrderBy: TaskDomainUserCategoryOrderBy;
  TaskDomainUserCategoryPkColumnsInput: TaskDomainUserCategoryPkColumnsInput;
  TaskDomainUserCategorySetInput: TaskDomainUserCategorySetInput;
  TaskDomainUserCategoryStreamCursorInput: TaskDomainUserCategoryStreamCursorInput;
  TaskDomainUserCategoryStreamCursorValueInput: TaskDomainUserCategoryStreamCursorValueInput;
  TaskDomainUserCategoryUpdates: TaskDomainUserCategoryUpdates;
  TaskDomainUserInsertInput: TaskDomainUserInsertInput;
  TaskDomainUserMaxFields: TaskDomainUserMaxFields;
  TaskDomainUserMaxOrderBy: TaskDomainUserMaxOrderBy;
  TaskDomainUserMinFields: TaskDomainUserMinFields;
  TaskDomainUserMinOrderBy: TaskDomainUserMinOrderBy;
  TaskDomainUserMutationResponse: TaskDomainUserMutationResponse;
  TaskDomainUserObjRelInsertInput: TaskDomainUserObjRelInsertInput;
  TaskDomainUserOnConflict: TaskDomainUserOnConflict;
  TaskDomainUserOrderBy: TaskDomainUserOrderBy;
  TaskDomainUserPkColumnsInput: TaskDomainUserPkColumnsInput;
  TaskDomainUserSetInput: TaskDomainUserSetInput;
  TaskDomainUserStreamCursorInput: TaskDomainUserStreamCursorInput;
  TaskDomainUserStreamCursorValueInput: TaskDomainUserStreamCursorValueInput;
  TaskDomainUserUpdates: TaskDomainUserUpdates;
  TaskIntComparisonExp: TaskIntComparisonExp;
  TaskJsonbCastExp: TaskJsonbCastExp;
  TaskJsonbComparisonExp: TaskJsonbComparisonExp;
  TaskStringComparisonExp: TaskStringComparisonExp;
  TaskTimestamptzComparisonExp: TaskTimestamptzComparisonExp;
  TaskUuidComparisonExp: TaskUuidComparisonExp;
  TaskactivityParticipantAggregateBoolExpCount: TaskactivityParticipantAggregateBoolExpCount;
  TaskdomainUserAggregateBoolExpCount: TaskdomainUserAggregateBoolExpCount;
  Taskjson: Scalars['Taskjson']['output'];
  Taskjsonb: Scalars['Taskjsonb']['output'];
  TasktaskActivityInput: TasktaskActivityInput;
  TasktaskActivityOutput: TasktaskActivityOutput;
  Tasktimestamptz: Scalars['Tasktimestamptz']['output'];
  TelephonyActivityParticipantRole: TelephonyActivityParticipantRole;
  TelephonyActivityParticipantRoleAggregate: TelephonyActivityParticipantRoleAggregate;
  TelephonyActivityParticipantRoleAggregateFields: TelephonyActivityParticipantRoleAggregateFields;
  TelephonyActivityParticipantRoleBoolExp: TelephonyActivityParticipantRoleBoolExp;
  TelephonyActivityParticipantRoleEnumComparisonExp: TelephonyActivityParticipantRoleEnumComparisonExp;
  TelephonyActivityParticipantRoleInsertInput: TelephonyActivityParticipantRoleInsertInput;
  TelephonyActivityParticipantRoleMaxFields: TelephonyActivityParticipantRoleMaxFields;
  TelephonyActivityParticipantRoleMinFields: TelephonyActivityParticipantRoleMinFields;
  TelephonyActivityParticipantRoleMutationResponse: TelephonyActivityParticipantRoleMutationResponse;
  TelephonyActivityParticipantRoleOnConflict: TelephonyActivityParticipantRoleOnConflict;
  TelephonyActivityParticipantRoleOrderBy: TelephonyActivityParticipantRoleOrderBy;
  TelephonyActivityParticipantRolePkColumnsInput: TelephonyActivityParticipantRolePkColumnsInput;
  TelephonyActivityParticipantRoleSetInput: TelephonyActivityParticipantRoleSetInput;
  TelephonyActivityParticipantRoleStreamCursorInput: TelephonyActivityParticipantRoleStreamCursorInput;
  TelephonyActivityParticipantRoleStreamCursorValueInput: TelephonyActivityParticipantRoleStreamCursorValueInput;
  TelephonyActivityParticipantRoleUpdates: TelephonyActivityParticipantRoleUpdates;
  TelephonyActivityType: TelephonyActivityType;
  TelephonyActivityTypeAggregate: TelephonyActivityTypeAggregate;
  TelephonyActivityTypeAggregateFields: TelephonyActivityTypeAggregateFields;
  TelephonyActivityTypeBoolExp: TelephonyActivityTypeBoolExp;
  TelephonyActivityTypeInsertInput: TelephonyActivityTypeInsertInput;
  TelephonyActivityTypeMutationResponse: TelephonyActivityTypeMutationResponse;
  TelephonyActivityTypeObjRelInsertInput: TelephonyActivityTypeObjRelInsertInput;
  TelephonyActivityTypeOnConflict: TelephonyActivityTypeOnConflict;
  TelephonyActivityTypeOrderBy: TelephonyActivityTypeOrderBy;
  TelephonyActivityTypePkColumnsInput: TelephonyActivityTypePkColumnsInput;
  TelephonyActivityTypeSetInput: TelephonyActivityTypeSetInput;
  TelephonyActivityTypeStreamCursorInput: TelephonyActivityTypeStreamCursorInput;
  TelephonyBooleanComparisonExp: TelephonyBooleanComparisonExp;
  TelephonyCallDirection: TelephonyCallDirection;
  TelephonyCallDirectionAggregate: TelephonyCallDirectionAggregate;
  TelephonyCallDirectionAggregateFields: TelephonyCallDirectionAggregateFields;
  TelephonyCallDirectionBoolExp: TelephonyCallDirectionBoolExp;
  TelephonyCallDirectionEnumComparisonExp: TelephonyCallDirectionEnumComparisonExp;
  TelephonyCallDirectionInsertInput: TelephonyCallDirectionInsertInput;
  TelephonyCallDirectionMaxFields: TelephonyCallDirectionMaxFields;
  TelephonyCallDirectionMinFields: TelephonyCallDirectionMinFields;
  TelephonyCallDirectionMutationResponse: TelephonyCallDirectionMutationResponse;
  TelephonyCallDirectionObjRelInsertInput: TelephonyCallDirectionObjRelInsertInput;
  TelephonyCallDirectionOnConflict: TelephonyCallDirectionOnConflict;
  TelephonyCallDirectionOrderBy: TelephonyCallDirectionOrderBy;
  TelephonyCallDirectionPkColumnsInput: TelephonyCallDirectionPkColumnsInput;
  TelephonyCallDirectionSetInput: TelephonyCallDirectionSetInput;
  TelephonyCallDirectionStreamCursorInput: TelephonyCallDirectionStreamCursorInput;
  TelephonyCallDirectionStreamCursorValueInput: TelephonyCallDirectionStreamCursorValueInput;
  TelephonyCallDirectionUpdates: TelephonyCallDirectionUpdates;
  TelephonyCallResultInput: TelephonyCallResultInput;
  TelephonyCallResultOutput: TelephonyCallResultOutput;
  TelephonyClickToCallInput: TelephonyClickToCallInput;
  TelephonyClickToCallOutput: TelephonyClickToCallOutput;
  TelephonyCredentialsOutput: TelephonyCredentialsOutput;
  TelephonyCredentialsValidation: TelephonyCredentialsValidation;
  TelephonyDomainUserCategory: TelephonyDomainUserCategory;
  TelephonyDomainUserCategoryAggregate: TelephonyDomainUserCategoryAggregate;
  TelephonyDomainUserCategoryAggregateFields: TelephonyDomainUserCategoryAggregateFields;
  TelephonyDomainUserCategoryBoolExp: TelephonyDomainUserCategoryBoolExp;
  TelephonyDomainUserCategoryInsertInput: TelephonyDomainUserCategoryInsertInput;
  TelephonyDomainUserCategoryMutationResponse: TelephonyDomainUserCategoryMutationResponse;
  TelephonyDomainUserCategoryObjRelInsertInput: TelephonyDomainUserCategoryObjRelInsertInput;
  TelephonyDomainUserCategoryOnConflict: TelephonyDomainUserCategoryOnConflict;
  TelephonyDomainUserCategoryOrderBy: TelephonyDomainUserCategoryOrderBy;
  TelephonyDomainUserCategoryPkColumnsInput: TelephonyDomainUserCategoryPkColumnsInput;
  TelephonyDomainUserCategorySetInput: TelephonyDomainUserCategorySetInput;
  TelephonyDomainUserCategoryStreamCursorInput: TelephonyDomainUserCategoryStreamCursorInput;
  TelephonyDomainUserOutput: TelephonyDomainUserOutput;
  TelephonyLookupPhoneNumberOutput: TelephonyLookupPhoneNumberOutput;
  TelephonyNumberState: TelephonyNumberState;
  TelephonyNumberStateAggregate: TelephonyNumberStateAggregate;
  TelephonyNumberStateAggregateFields: TelephonyNumberStateAggregateFields;
  TelephonyNumberStateBoolExp: TelephonyNumberStateBoolExp;
  TelephonyNumberStateEnumComparisonExp: TelephonyNumberStateEnumComparisonExp;
  TelephonyNumberStateInsertInput: TelephonyNumberStateInsertInput;
  TelephonyNumberStateMaxFields: TelephonyNumberStateMaxFields;
  TelephonyNumberStateMinFields: TelephonyNumberStateMinFields;
  TelephonyNumberStateMutationResponse: TelephonyNumberStateMutationResponse;
  TelephonyNumberStateObjRelInsertInput: TelephonyNumberStateObjRelInsertInput;
  TelephonyNumberStateOnConflict: TelephonyNumberStateOnConflict;
  TelephonyNumberStateOrderBy: TelephonyNumberStateOrderBy;
  TelephonyNumberStatePkColumnsInput: TelephonyNumberStatePkColumnsInput;
  TelephonyNumberStateSetInput: TelephonyNumberStateSetInput;
  TelephonyNumberStateStreamCursorInput: TelephonyNumberStateStreamCursorInput;
  TelephonyNumberStateStreamCursorValueInput: TelephonyNumberStateStreamCursorValueInput;
  TelephonyNumberStateUpdates: TelephonyNumberStateUpdates;
  TelephonyPhoneRequestInput: TelephonyPhoneRequestInput;
  TelephonyPhoneRequestOutput: TelephonyPhoneRequestOutput;
  TelephonyProviderIntegrationAccountInput: TelephonyProviderIntegrationAccountInput;
  TelephonyProviderIntegrationConfigurationInput: TelephonyProviderIntegrationConfigurationInput;
  TelephonyProviderIntegrationInput: TelephonyProviderIntegrationInput;
  TelephonyProviderType: TelephonyProviderType;
  TelephonyProviderTypeAggregate: TelephonyProviderTypeAggregate;
  TelephonyProviderTypeAggregateFields: TelephonyProviderTypeAggregateFields;
  TelephonyProviderTypeBoolExp: TelephonyProviderTypeBoolExp;
  TelephonyProviderTypeEnumComparisonExp: TelephonyProviderTypeEnumComparisonExp;
  TelephonyProviderTypeInsertInput: TelephonyProviderTypeInsertInput;
  TelephonyProviderTypeMaxFields: TelephonyProviderTypeMaxFields;
  TelephonyProviderTypeMinFields: TelephonyProviderTypeMinFields;
  TelephonyProviderTypeMutationResponse: TelephonyProviderTypeMutationResponse;
  TelephonyProviderTypeObjRelInsertInput: TelephonyProviderTypeObjRelInsertInput;
  TelephonyProviderTypeOnConflict: TelephonyProviderTypeOnConflict;
  TelephonyProviderTypeOrderBy: TelephonyProviderTypeOrderBy;
  TelephonyProviderTypePkColumnsInput: TelephonyProviderTypePkColumnsInput;
  TelephonyProviderTypeSetInput: TelephonyProviderTypeSetInput;
  TelephonyProviderTypeStreamCursorInput: TelephonyProviderTypeStreamCursorInput;
  TelephonyProviderTypeStreamCursorValueInput: TelephonyProviderTypeStreamCursorValueInput;
  TelephonyProviderTypeUpdates: TelephonyProviderTypeUpdates;
  TelephonySendSMSOutput: TelephonySendSMSOutput;
  TelephonySynchronizeDomainUsersInput: TelephonySynchronizeDomainUsersInput;
  TelephonySynchronizeDomainUsersOutput: TelephonySynchronizeDomainUsersOutput;
  TelephonyTelephonyActionEventType: TelephonyTelephonyActionEventType;
  TelephonyTelephonyActionEventTypeAggregate: TelephonyTelephonyActionEventTypeAggregate;
  TelephonyTelephonyActionEventTypeAggregateFields: TelephonyTelephonyActionEventTypeAggregateFields;
  TelephonyTelephonyActionEventTypeBoolExp: TelephonyTelephonyActionEventTypeBoolExp;
  TelephonyTelephonyActionEventTypeEnumComparisonExp: TelephonyTelephonyActionEventTypeEnumComparisonExp;
  TelephonyTelephonyActionEventTypeInsertInput: TelephonyTelephonyActionEventTypeInsertInput;
  TelephonyTelephonyActionEventTypeMaxFields: TelephonyTelephonyActionEventTypeMaxFields;
  TelephonyTelephonyActionEventTypeMinFields: TelephonyTelephonyActionEventTypeMinFields;
  TelephonyTelephonyActionEventTypeMutationResponse: TelephonyTelephonyActionEventTypeMutationResponse;
  TelephonyTelephonyActionEventTypeOnConflict: TelephonyTelephonyActionEventTypeOnConflict;
  TelephonyTelephonyActionEventTypeOrderBy: TelephonyTelephonyActionEventTypeOrderBy;
  TelephonyTelephonyActionEventTypePkColumnsInput: TelephonyTelephonyActionEventTypePkColumnsInput;
  TelephonyTelephonyActionEventTypeSetInput: TelephonyTelephonyActionEventTypeSetInput;
  TelephonyTelephonyActionEventTypeStreamCursorInput: TelephonyTelephonyActionEventTypeStreamCursorInput;
  TelephonyTelephonyActionEventTypeStreamCursorValueInput: TelephonyTelephonyActionEventTypeStreamCursorValueInput;
  TelephonyTelephonyActionEventTypeUpdates: TelephonyTelephonyActionEventTypeUpdates;
  TelephonyTelephonyActionType: TelephonyTelephonyActionType;
  TelephonyTelephonyActionTypeAggregate: TelephonyTelephonyActionTypeAggregate;
  TelephonyTelephonyActionTypeAggregateFields: TelephonyTelephonyActionTypeAggregateFields;
  TelephonyTelephonyActionTypeBoolExp: TelephonyTelephonyActionTypeBoolExp;
  TelephonyTelephonyActionTypeEnumComparisonExp: TelephonyTelephonyActionTypeEnumComparisonExp;
  TelephonyTelephonyActionTypeInsertInput: TelephonyTelephonyActionTypeInsertInput;
  TelephonyTelephonyActionTypeMaxFields: TelephonyTelephonyActionTypeMaxFields;
  TelephonyTelephonyActionTypeMinFields: TelephonyTelephonyActionTypeMinFields;
  TelephonyTelephonyActionTypeMutationResponse: TelephonyTelephonyActionTypeMutationResponse;
  TelephonyTelephonyActionTypeObjRelInsertInput: TelephonyTelephonyActionTypeObjRelInsertInput;
  TelephonyTelephonyActionTypeOnConflict: TelephonyTelephonyActionTypeOnConflict;
  TelephonyTelephonyActionTypeOrderBy: TelephonyTelephonyActionTypeOrderBy;
  TelephonyTelephonyActionTypePkColumnsInput: TelephonyTelephonyActionTypePkColumnsInput;
  TelephonyTelephonyActionTypeSetInput: TelephonyTelephonyActionTypeSetInput;
  TelephonyTelephonyActionTypeStreamCursorInput: TelephonyTelephonyActionTypeStreamCursorInput;
  TelephonyTelephonyActionTypeStreamCursorValueInput: TelephonyTelephonyActionTypeStreamCursorValueInput;
  TelephonyTelephonyActionTypeUpdates: TelephonyTelephonyActionTypeUpdates;
  TelephonyTelephonyBlockedDomainUser: TelephonyTelephonyBlockedDomainUser;
  TelephonyTelephonyBlockedDomainUserAggregate: TelephonyTelephonyBlockedDomainUserAggregate;
  TelephonyTelephonyBlockedDomainUserAggregateFields: TelephonyTelephonyBlockedDomainUserAggregateFields;
  TelephonyTelephonyBlockedDomainUserBoolExp: TelephonyTelephonyBlockedDomainUserBoolExp;
  TelephonyTelephonyBlockedDomainUserInsertInput: TelephonyTelephonyBlockedDomainUserInsertInput;
  TelephonyTelephonyBlockedDomainUserMaxFields: TelephonyTelephonyBlockedDomainUserMaxFields;
  TelephonyTelephonyBlockedDomainUserMinFields: TelephonyTelephonyBlockedDomainUserMinFields;
  TelephonyTelephonyBlockedDomainUserMutationResponse: TelephonyTelephonyBlockedDomainUserMutationResponse;
  TelephonyTelephonyBlockedDomainUserOnConflict: TelephonyTelephonyBlockedDomainUserOnConflict;
  TelephonyTelephonyBlockedDomainUserOrderBy: TelephonyTelephonyBlockedDomainUserOrderBy;
  TelephonyTelephonyBlockedDomainUserPkColumnsInput: TelephonyTelephonyBlockedDomainUserPkColumnsInput;
  TelephonyTelephonyBlockedDomainUserSetInput: TelephonyTelephonyBlockedDomainUserSetInput;
  TelephonyTelephonyBlockedDomainUserStreamCursorInput: TelephonyTelephonyBlockedDomainUserStreamCursorInput;
  TelephonyTelephonyBlockedDomainUserStreamCursorValueInput: TelephonyTelephonyBlockedDomainUserStreamCursorValueInput;
  TelephonyTelephonyBlockedDomainUserUpdates: TelephonyTelephonyBlockedDomainUserUpdates;
  TelephonyTelephonyCiscoSubscriberProduct: TelephonyTelephonyCiscoSubscriberProduct;
  TelephonyTelephonyCiscoSubscriberProductAggregate: TelephonyTelephonyCiscoSubscriberProductAggregate;
  TelephonyTelephonyCiscoSubscriberProductAggregateFields: TelephonyTelephonyCiscoSubscriberProductAggregateFields;
  TelephonyTelephonyCiscoSubscriberProductBoolExp: TelephonyTelephonyCiscoSubscriberProductBoolExp;
  TelephonyTelephonyCiscoSubscriberProductInsertInput: TelephonyTelephonyCiscoSubscriberProductInsertInput;
  TelephonyTelephonyCiscoSubscriberProductMaxFields: TelephonyTelephonyCiscoSubscriberProductMaxFields;
  TelephonyTelephonyCiscoSubscriberProductMinFields: TelephonyTelephonyCiscoSubscriberProductMinFields;
  TelephonyTelephonyCiscoSubscriberProductMutationResponse: TelephonyTelephonyCiscoSubscriberProductMutationResponse;
  TelephonyTelephonyCiscoSubscriberProductOnConflict: TelephonyTelephonyCiscoSubscriberProductOnConflict;
  TelephonyTelephonyCiscoSubscriberProductOrderBy: TelephonyTelephonyCiscoSubscriberProductOrderBy;
  TelephonyTelephonyCiscoSubscriberProductPkColumnsInput: TelephonyTelephonyCiscoSubscriberProductPkColumnsInput;
  TelephonyTelephonyCiscoSubscriberProductSetInput: TelephonyTelephonyCiscoSubscriberProductSetInput;
  TelephonyTelephonyCiscoSubscriberProductStreamCursorInput: TelephonyTelephonyCiscoSubscriberProductStreamCursorInput;
  TelephonyTelephonyCiscoSubscriberProductStreamCursorValueInput: TelephonyTelephonyCiscoSubscriberProductStreamCursorValueInput;
  TelephonyTelephonyCiscoSubscriberProductUpdates: TelephonyTelephonyCiscoSubscriberProductUpdates;
  TelephonyTelephonyEvents: TelephonyTelephonyEvents;
  TelephonyTelephonyEventsAggregate: TelephonyTelephonyEventsAggregate;
  TelephonyTelephonyEventsAggregateBoolExp: TelephonyTelephonyEventsAggregateBoolExp;
  TelephonyTelephonyEventsAggregateFields: TelephonyTelephonyEventsAggregateFields;
  TelephonyTelephonyEventsAggregateOrderBy: TelephonyTelephonyEventsAggregateOrderBy;
  TelephonyTelephonyEventsArrRelInsertInput: TelephonyTelephonyEventsArrRelInsertInput;
  TelephonyTelephonyEventsBoolExp: TelephonyTelephonyEventsBoolExp;
  TelephonyTelephonyEventsInsertInput: TelephonyTelephonyEventsInsertInput;
  TelephonyTelephonyEventsMaxFields: TelephonyTelephonyEventsMaxFields;
  TelephonyTelephonyEventsMaxOrderBy: TelephonyTelephonyEventsMaxOrderBy;
  TelephonyTelephonyEventsMinFields: TelephonyTelephonyEventsMinFields;
  TelephonyTelephonyEventsMinOrderBy: TelephonyTelephonyEventsMinOrderBy;
  TelephonyTelephonyEventsMutationResponse: TelephonyTelephonyEventsMutationResponse;
  TelephonyTelephonyEventsObjRelInsertInput: TelephonyTelephonyEventsObjRelInsertInput;
  TelephonyTelephonyEventsOnConflict: TelephonyTelephonyEventsOnConflict;
  TelephonyTelephonyEventsOrderBy: TelephonyTelephonyEventsOrderBy;
  TelephonyTelephonyEventsPkColumnsInput: TelephonyTelephonyEventsPkColumnsInput;
  TelephonyTelephonyEventsSetInput: TelephonyTelephonyEventsSetInput;
  TelephonyTelephonyEventsStreamCursorInput: TelephonyTelephonyEventsStreamCursorInput;
  TelephonyTelephonyEventsStreamCursorValueInput: TelephonyTelephonyEventsStreamCursorValueInput;
  TelephonyTelephonyEventsUpdates: TelephonyTelephonyEventsUpdates;
  TelephonyTelephonyLookupCallerApi: TelephonyTelephonyLookupCallerApi;
  TelephonyTelephonyLookupCallerApiAggregate: TelephonyTelephonyLookupCallerApiAggregate;
  TelephonyTelephonyLookupCallerApiAggregateFields: TelephonyTelephonyLookupCallerApiAggregateFields;
  TelephonyTelephonyLookupCallerApiAppendInput: TelephonyTelephonyLookupCallerApiAppendInput;
  TelephonyTelephonyLookupCallerApiBoolExp: TelephonyTelephonyLookupCallerApiBoolExp;
  TelephonyTelephonyLookupCallerApiDeleteAtPathInput: TelephonyTelephonyLookupCallerApiDeleteAtPathInput;
  TelephonyTelephonyLookupCallerApiDeleteElemInput: TelephonyTelephonyLookupCallerApiDeleteElemInput;
  TelephonyTelephonyLookupCallerApiDeleteKeyInput: TelephonyTelephonyLookupCallerApiDeleteKeyInput;
  TelephonyTelephonyLookupCallerApiInsertInput: TelephonyTelephonyLookupCallerApiInsertInput;
  TelephonyTelephonyLookupCallerApiMaxFields: TelephonyTelephonyLookupCallerApiMaxFields;
  TelephonyTelephonyLookupCallerApiMinFields: TelephonyTelephonyLookupCallerApiMinFields;
  TelephonyTelephonyLookupCallerApiMutationResponse: TelephonyTelephonyLookupCallerApiMutationResponse;
  TelephonyTelephonyLookupCallerApiOnConflict: TelephonyTelephonyLookupCallerApiOnConflict;
  TelephonyTelephonyLookupCallerApiOrderBy: TelephonyTelephonyLookupCallerApiOrderBy;
  TelephonyTelephonyLookupCallerApiPkColumnsInput: TelephonyTelephonyLookupCallerApiPkColumnsInput;
  TelephonyTelephonyLookupCallerApiPrependInput: TelephonyTelephonyLookupCallerApiPrependInput;
  TelephonyTelephonyLookupCallerApiSetInput: TelephonyTelephonyLookupCallerApiSetInput;
  TelephonyTelephonyLookupCallerApiStreamCursorInput: TelephonyTelephonyLookupCallerApiStreamCursorInput;
  TelephonyTelephonyLookupCallerApiStreamCursorValueInput: TelephonyTelephonyLookupCallerApiStreamCursorValueInput;
  TelephonyTelephonyLookupCallerApiUpdates: TelephonyTelephonyLookupCallerApiUpdates;
  TelephonyTelephonyLookupRefresh: TelephonyTelephonyLookupRefresh;
  TelephonyTelephonyLookupRefreshAggregate: TelephonyTelephonyLookupRefreshAggregate;
  TelephonyTelephonyLookupRefreshAggregateFields: TelephonyTelephonyLookupRefreshAggregateFields;
  TelephonyTelephonyLookupRefreshAvgFields: TelephonyTelephonyLookupRefreshAvgFields;
  TelephonyTelephonyLookupRefreshBoolExp: TelephonyTelephonyLookupRefreshBoolExp;
  TelephonyTelephonyLookupRefreshIncInput: TelephonyTelephonyLookupRefreshIncInput;
  TelephonyTelephonyLookupRefreshInsertInput: TelephonyTelephonyLookupRefreshInsertInput;
  TelephonyTelephonyLookupRefreshMaxFields: TelephonyTelephonyLookupRefreshMaxFields;
  TelephonyTelephonyLookupRefreshMinFields: TelephonyTelephonyLookupRefreshMinFields;
  TelephonyTelephonyLookupRefreshMutationResponse: TelephonyTelephonyLookupRefreshMutationResponse;
  TelephonyTelephonyLookupRefreshOnConflict: TelephonyTelephonyLookupRefreshOnConflict;
  TelephonyTelephonyLookupRefreshOrderBy: TelephonyTelephonyLookupRefreshOrderBy;
  TelephonyTelephonyLookupRefreshPkColumnsInput: TelephonyTelephonyLookupRefreshPkColumnsInput;
  TelephonyTelephonyLookupRefreshSetInput: TelephonyTelephonyLookupRefreshSetInput;
  TelephonyTelephonyLookupRefreshStddevFields: TelephonyTelephonyLookupRefreshStddevFields;
  TelephonyTelephonyLookupRefreshStddevPopFields: TelephonyTelephonyLookupRefreshStddevPopFields;
  TelephonyTelephonyLookupRefreshStddevSampFields: TelephonyTelephonyLookupRefreshStddevSampFields;
  TelephonyTelephonyLookupRefreshStreamCursorInput: TelephonyTelephonyLookupRefreshStreamCursorInput;
  TelephonyTelephonyLookupRefreshStreamCursorValueInput: TelephonyTelephonyLookupRefreshStreamCursorValueInput;
  TelephonyTelephonyLookupRefreshSumFields: TelephonyTelephonyLookupRefreshSumFields;
  TelephonyTelephonyLookupRefreshUpdates: TelephonyTelephonyLookupRefreshUpdates;
  TelephonyTelephonyLookupRefreshVarPopFields: TelephonyTelephonyLookupRefreshVarPopFields;
  TelephonyTelephonyLookupRefreshVarSampFields: TelephonyTelephonyLookupRefreshVarSampFields;
  TelephonyTelephonyLookupRefreshVarianceFields: TelephonyTelephonyLookupRefreshVarianceFields;
  TelephonyTelephonyLookupTypes: TelephonyTelephonyLookupTypes;
  TelephonyTelephonyLookupTypesAggregate: TelephonyTelephonyLookupTypesAggregate;
  TelephonyTelephonyLookupTypesAggregateFields: TelephonyTelephonyLookupTypesAggregateFields;
  TelephonyTelephonyLookupTypesBoolExp: TelephonyTelephonyLookupTypesBoolExp;
  TelephonyTelephonyLookupTypesEnumComparisonExp: TelephonyTelephonyLookupTypesEnumComparisonExp;
  TelephonyTelephonyLookupTypesInsertInput: TelephonyTelephonyLookupTypesInsertInput;
  TelephonyTelephonyLookupTypesMaxFields: TelephonyTelephonyLookupTypesMaxFields;
  TelephonyTelephonyLookupTypesMinFields: TelephonyTelephonyLookupTypesMinFields;
  TelephonyTelephonyLookupTypesMutationResponse: TelephonyTelephonyLookupTypesMutationResponse;
  TelephonyTelephonyLookupTypesOnConflict: TelephonyTelephonyLookupTypesOnConflict;
  TelephonyTelephonyLookupTypesOrderBy: TelephonyTelephonyLookupTypesOrderBy;
  TelephonyTelephonyLookupTypesPkColumnsInput: TelephonyTelephonyLookupTypesPkColumnsInput;
  TelephonyTelephonyLookupTypesSetInput: TelephonyTelephonyLookupTypesSetInput;
  TelephonyTelephonyLookupTypesStreamCursorInput: TelephonyTelephonyLookupTypesStreamCursorInput;
  TelephonyTelephonyLookupTypesStreamCursorValueInput: TelephonyTelephonyLookupTypesStreamCursorValueInput;
  TelephonyTelephonyLookupTypesUpdates: TelephonyTelephonyLookupTypesUpdates;
  TelephonyTelephonyPods: TelephonyTelephonyPods;
  TelephonyTelephonyPodsAggregate: TelephonyTelephonyPodsAggregate;
  TelephonyTelephonyPodsAggregateFields: TelephonyTelephonyPodsAggregateFields;
  TelephonyTelephonyPodsBoolExp: TelephonyTelephonyPodsBoolExp;
  TelephonyTelephonyPodsInsertInput: TelephonyTelephonyPodsInsertInput;
  TelephonyTelephonyPodsMaxFields: TelephonyTelephonyPodsMaxFields;
  TelephonyTelephonyPodsMinFields: TelephonyTelephonyPodsMinFields;
  TelephonyTelephonyPodsMutationResponse: TelephonyTelephonyPodsMutationResponse;
  TelephonyTelephonyPodsObjRelInsertInput: TelephonyTelephonyPodsObjRelInsertInput;
  TelephonyTelephonyPodsOnConflict: TelephonyTelephonyPodsOnConflict;
  TelephonyTelephonyPodsOrderBy: TelephonyTelephonyPodsOrderBy;
  TelephonyTelephonyPodsPkColumnsInput: TelephonyTelephonyPodsPkColumnsInput;
  TelephonyTelephonyPodsSetInput: TelephonyTelephonyPodsSetInput;
  TelephonyTelephonyPodsStreamCursorInput: TelephonyTelephonyPodsStreamCursorInput;
  TelephonyTelephonyPodsStreamCursorValueInput: TelephonyTelephonyPodsStreamCursorValueInput;
  TelephonyTelephonyPodsUpdates: TelephonyTelephonyPodsUpdates;
  TelephonyTelephonyProviderAccess: TelephonyTelephonyProviderAccess;
  TelephonyTelephonyProviderAccessAggregate: TelephonyTelephonyProviderAccessAggregate;
  TelephonyTelephonyProviderAccessAggregateFields: TelephonyTelephonyProviderAccessAggregateFields;
  TelephonyTelephonyProviderAccessBoolExp: TelephonyTelephonyProviderAccessBoolExp;
  TelephonyTelephonyProviderAccessEnumComparisonExp: TelephonyTelephonyProviderAccessEnumComparisonExp;
  TelephonyTelephonyProviderAccessInsertInput: TelephonyTelephonyProviderAccessInsertInput;
  TelephonyTelephonyProviderAccessMaxFields: TelephonyTelephonyProviderAccessMaxFields;
  TelephonyTelephonyProviderAccessMinFields: TelephonyTelephonyProviderAccessMinFields;
  TelephonyTelephonyProviderAccessMutationResponse: TelephonyTelephonyProviderAccessMutationResponse;
  TelephonyTelephonyProviderAccessOnConflict: TelephonyTelephonyProviderAccessOnConflict;
  TelephonyTelephonyProviderAccessOrderBy: TelephonyTelephonyProviderAccessOrderBy;
  TelephonyTelephonyProviderAccessPkColumnsInput: TelephonyTelephonyProviderAccessPkColumnsInput;
  TelephonyTelephonyProviderAccessSetInput: TelephonyTelephonyProviderAccessSetInput;
  TelephonyTelephonyProviderAccessStreamCursorInput: TelephonyTelephonyProviderAccessStreamCursorInput;
  TelephonyTelephonyProviderAccessStreamCursorValueInput: TelephonyTelephonyProviderAccessStreamCursorValueInput;
  TelephonyTelephonyProviderAccessUpdates: TelephonyTelephonyProviderAccessUpdates;
  TelephonyactiveNumbers: TelephonyactiveNumbers;
  TelephonyactiveNumbersAggregate: TelephonyactiveNumbersAggregate;
  TelephonyactiveNumbersAggregateFields: TelephonyactiveNumbersAggregateFields;
  TelephonyactiveNumbersBoolExp: TelephonyactiveNumbersBoolExp;
  TelephonyactiveNumbersInsertInput: TelephonyactiveNumbersInsertInput;
  TelephonyactiveNumbersMaxFields: TelephonyactiveNumbersMaxFields;
  TelephonyactiveNumbersMinFields: TelephonyactiveNumbersMinFields;
  TelephonyactiveNumbersMutationResponse: TelephonyactiveNumbersMutationResponse;
  TelephonyactiveNumbersOnConflict: TelephonyactiveNumbersOnConflict;
  TelephonyactiveNumbersOrderBy: TelephonyactiveNumbersOrderBy;
  TelephonyactiveNumbersPkColumnsInput: TelephonyactiveNumbersPkColumnsInput;
  TelephonyactiveNumbersSetInput: TelephonyactiveNumbersSetInput;
  TelephonyactiveNumbersStreamCursorInput: TelephonyactiveNumbersStreamCursorInput;
  TelephonyactiveNumbersStreamCursorValueInput: TelephonyactiveNumbersStreamCursorValueInput;
  TelephonyactiveNumbersUpdates: TelephonyactiveNumbersUpdates;
  Telephonyactivity: Telephonyactivity;
  TelephonyactivityAggregate: TelephonyactivityAggregate;
  TelephonyactivityAggregateBoolExp: TelephonyactivityAggregateBoolExp;
  TelephonyactivityAggregateBoolExpCount: TelephonyactivityAggregateBoolExpCount;
  TelephonyactivityAggregateFields: TelephonyactivityAggregateFields;
  TelephonyactivityAggregateOrderBy: TelephonyactivityAggregateOrderBy;
  TelephonyactivityArrRelInsertInput: TelephonyactivityArrRelInsertInput;
  TelephonyactivityAvgFields: TelephonyactivityAvgFields;
  TelephonyactivityAvgOrderBy: TelephonyactivityAvgOrderBy;
  TelephonyactivityBoolExp: TelephonyactivityBoolExp;
  TelephonyactivityIncInput: TelephonyactivityIncInput;
  TelephonyactivityInsertInput: TelephonyactivityInsertInput;
  TelephonyactivityMaxFields: TelephonyactivityMaxFields;
  TelephonyactivityMaxOrderBy: TelephonyactivityMaxOrderBy;
  TelephonyactivityMinFields: TelephonyactivityMinFields;
  TelephonyactivityMinOrderBy: TelephonyactivityMinOrderBy;
  TelephonyactivityMutationResponse: TelephonyactivityMutationResponse;
  TelephonyactivityObjRelInsertInput: TelephonyactivityObjRelInsertInput;
  TelephonyactivityOnConflict: TelephonyactivityOnConflict;
  TelephonyactivityOrderBy: TelephonyactivityOrderBy;
  TelephonyactivityParticipant: TelephonyactivityParticipant;
  TelephonyactivityParticipantAggregate: TelephonyactivityParticipantAggregate;
  TelephonyactivityParticipantAggregateBoolExp: TelephonyactivityParticipantAggregateBoolExp;
  TelephonyactivityParticipantAggregateBoolExpCount: TelephonyactivityParticipantAggregateBoolExpCount;
  TelephonyactivityParticipantAggregateFields: TelephonyactivityParticipantAggregateFields;
  TelephonyactivityParticipantAggregateOrderBy: TelephonyactivityParticipantAggregateOrderBy;
  TelephonyactivityParticipantArrRelInsertInput: TelephonyactivityParticipantArrRelInsertInput;
  TelephonyactivityParticipantBoolExp: TelephonyactivityParticipantBoolExp;
  TelephonyactivityParticipantInsertInput: TelephonyactivityParticipantInsertInput;
  TelephonyactivityParticipantMaxFields: TelephonyactivityParticipantMaxFields;
  TelephonyactivityParticipantMaxOrderBy: TelephonyactivityParticipantMaxOrderBy;
  TelephonyactivityParticipantMinFields: TelephonyactivityParticipantMinFields;
  TelephonyactivityParticipantMinOrderBy: TelephonyactivityParticipantMinOrderBy;
  TelephonyactivityParticipantMutationResponse: TelephonyactivityParticipantMutationResponse;
  TelephonyactivityParticipantOnConflict: TelephonyactivityParticipantOnConflict;
  TelephonyactivityParticipantOrderBy: TelephonyactivityParticipantOrderBy;
  TelephonyactivityParticipantPkColumnsInput: TelephonyactivityParticipantPkColumnsInput;
  TelephonyactivityParticipantSetInput: TelephonyactivityParticipantSetInput;
  TelephonyactivityParticipantStreamCursorInput: TelephonyactivityParticipantStreamCursorInput;
  TelephonyactivityParticipantStreamCursorValueInput: TelephonyactivityParticipantStreamCursorValueInput;
  TelephonyactivityParticipantUpdates: TelephonyactivityParticipantUpdates;
  TelephonyactivityPkColumnsInput: TelephonyactivityPkColumnsInput;
  TelephonyactivitySetInput: TelephonyactivitySetInput;
  TelephonyactivityStddevFields: TelephonyactivityStddevFields;
  TelephonyactivityStddevOrderBy: TelephonyactivityStddevOrderBy;
  TelephonyactivityStddevPopFields: TelephonyactivityStddevPopFields;
  TelephonyactivityStddevPopOrderBy: TelephonyactivityStddevPopOrderBy;
  TelephonyactivityStddevSampFields: TelephonyactivityStddevSampFields;
  TelephonyactivityStddevSampOrderBy: TelephonyactivityStddevSampOrderBy;
  TelephonyactivityStreamCursorInput: TelephonyactivityStreamCursorInput;
  TelephonyactivityStreamCursorValueInput: TelephonyactivityStreamCursorValueInput;
  TelephonyactivitySumFields: TelephonyactivitySumFields;
  TelephonyactivitySumOrderBy: TelephonyactivitySumOrderBy;
  TelephonyactivityUpdates: TelephonyactivityUpdates;
  TelephonyactivityVarPopFields: TelephonyactivityVarPopFields;
  TelephonyactivityVarPopOrderBy: TelephonyactivityVarPopOrderBy;
  TelephonyactivityVarSampFields: TelephonyactivityVarSampFields;
  TelephonyactivityVarSampOrderBy: TelephonyactivityVarSampOrderBy;
  TelephonyactivityVarianceFields: TelephonyactivityVarianceFields;
  TelephonyactivityVarianceOrderBy: TelephonyactivityVarianceOrderBy;
  Telephonycomment: Telephonycomment;
  TelephonycommentAggregate: TelephonycommentAggregate;
  TelephonycommentAggregateBoolExp: TelephonycommentAggregateBoolExp;
  TelephonycommentAggregateBoolExpCount: TelephonycommentAggregateBoolExpCount;
  TelephonycommentAggregateFields: TelephonycommentAggregateFields;
  TelephonycommentAggregateOrderBy: TelephonycommentAggregateOrderBy;
  TelephonycommentArrRelInsertInput: TelephonycommentArrRelInsertInput;
  TelephonycommentBoolExp: TelephonycommentBoolExp;
  TelephonycommentInsertInput: TelephonycommentInsertInput;
  TelephonycommentMaxFields: TelephonycommentMaxFields;
  TelephonycommentMaxOrderBy: TelephonycommentMaxOrderBy;
  TelephonycommentMinFields: TelephonycommentMinFields;
  TelephonycommentMinOrderBy: TelephonycommentMinOrderBy;
  TelephonycommentMutationResponse: TelephonycommentMutationResponse;
  TelephonycommentOnConflict: TelephonycommentOnConflict;
  TelephonycommentOrderBy: TelephonycommentOrderBy;
  TelephonycommentPkColumnsInput: TelephonycommentPkColumnsInput;
  TelephonycommentSetInput: TelephonycommentSetInput;
  TelephonycommentStreamCursorInput: TelephonycommentStreamCursorInput;
  TelephonycommentStreamCursorValueInput: TelephonycommentStreamCursorValueInput;
  TelephonycommentUpdates: TelephonycommentUpdates;
  TelephonydomainOrganization: TelephonydomainOrganization;
  TelephonydomainOrganizationAggregate: TelephonydomainOrganizationAggregate;
  TelephonydomainOrganizationAggregateBoolExp: TelephonydomainOrganizationAggregateBoolExp;
  TelephonydomainOrganizationAggregateBoolExpBool_and: TelephonydomainOrganizationAggregateBoolExpBool_and;
  TelephonydomainOrganizationAggregateBoolExpBool_or: TelephonydomainOrganizationAggregateBoolExpBool_or;
  TelephonydomainOrganizationAggregateBoolExpCount: TelephonydomainOrganizationAggregateBoolExpCount;
  TelephonydomainOrganizationAggregateFields: TelephonydomainOrganizationAggregateFields;
  TelephonydomainOrganizationAggregateOrderBy: TelephonydomainOrganizationAggregateOrderBy;
  TelephonydomainOrganizationArrRelInsertInput: TelephonydomainOrganizationArrRelInsertInput;
  TelephonydomainOrganizationBoolExp: TelephonydomainOrganizationBoolExp;
  TelephonydomainOrganizationInsertInput: TelephonydomainOrganizationInsertInput;
  TelephonydomainOrganizationMaxFields: TelephonydomainOrganizationMaxFields;
  TelephonydomainOrganizationMaxOrderBy: TelephonydomainOrganizationMaxOrderBy;
  TelephonydomainOrganizationMinFields: TelephonydomainOrganizationMinFields;
  TelephonydomainOrganizationMinOrderBy: TelephonydomainOrganizationMinOrderBy;
  TelephonydomainOrganizationMutationResponse: TelephonydomainOrganizationMutationResponse;
  TelephonydomainOrganizationObjRelInsertInput: TelephonydomainOrganizationObjRelInsertInput;
  TelephonydomainOrganizationOnConflict: TelephonydomainOrganizationOnConflict;
  TelephonydomainOrganizationOrderBy: TelephonydomainOrganizationOrderBy;
  TelephonydomainOrganizationPkColumnsInput: TelephonydomainOrganizationPkColumnsInput;
  TelephonydomainOrganizationSetInput: TelephonydomainOrganizationSetInput;
  TelephonydomainOrganizationStreamCursorInput: TelephonydomainOrganizationStreamCursorInput;
  TelephonydomainOrganizationStreamCursorValueInput: TelephonydomainOrganizationStreamCursorValueInput;
  TelephonydomainOrganizationUpdates: TelephonydomainOrganizationUpdates;
  TelephonydomainUser: TelephonydomainUser;
  TelephonydomainUserAggregate: TelephonydomainUserAggregate;
  TelephonydomainUserAggregateBoolExp: TelephonydomainUserAggregateBoolExp;
  TelephonydomainUserAggregateBoolExpCount: TelephonydomainUserAggregateBoolExpCount;
  TelephonydomainUserAggregateFields: TelephonydomainUserAggregateFields;
  TelephonydomainUserAggregateOrderBy: TelephonydomainUserAggregateOrderBy;
  TelephonydomainUserAppendInput: TelephonydomainUserAppendInput;
  TelephonydomainUserArrRelInsertInput: TelephonydomainUserArrRelInsertInput;
  TelephonydomainUserAvgFields: TelephonydomainUserAvgFields;
  TelephonydomainUserAvgOrderBy: TelephonydomainUserAvgOrderBy;
  TelephonydomainUserBoolExp: TelephonydomainUserBoolExp;
  TelephonydomainUserDeleteAtPathInput: TelephonydomainUserDeleteAtPathInput;
  TelephonydomainUserDeleteElemInput: TelephonydomainUserDeleteElemInput;
  TelephonydomainUserDeleteKeyInput: TelephonydomainUserDeleteKeyInput;
  TelephonydomainUserIncInput: TelephonydomainUserIncInput;
  TelephonydomainUserInsertInput: TelephonydomainUserInsertInput;
  TelephonydomainUserMaxFields: TelephonydomainUserMaxFields;
  TelephonydomainUserMaxOrderBy: TelephonydomainUserMaxOrderBy;
  TelephonydomainUserMinFields: TelephonydomainUserMinFields;
  TelephonydomainUserMinOrderBy: TelephonydomainUserMinOrderBy;
  TelephonydomainUserMutationResponse: TelephonydomainUserMutationResponse;
  TelephonydomainUserObjRelInsertInput: TelephonydomainUserObjRelInsertInput;
  TelephonydomainUserOnConflict: TelephonydomainUserOnConflict;
  TelephonydomainUserOrderBy: TelephonydomainUserOrderBy;
  TelephonydomainUserPkColumnsInput: TelephonydomainUserPkColumnsInput;
  TelephonydomainUserPrependInput: TelephonydomainUserPrependInput;
  TelephonydomainUserSetInput: TelephonydomainUserSetInput;
  TelephonydomainUserStddevFields: TelephonydomainUserStddevFields;
  TelephonydomainUserStddevOrderBy: TelephonydomainUserStddevOrderBy;
  TelephonydomainUserStddevPopFields: TelephonydomainUserStddevPopFields;
  TelephonydomainUserStddevPopOrderBy: TelephonydomainUserStddevPopOrderBy;
  TelephonydomainUserStddevSampFields: TelephonydomainUserStddevSampFields;
  TelephonydomainUserStddevSampOrderBy: TelephonydomainUserStddevSampOrderBy;
  TelephonydomainUserStreamCursorInput: TelephonydomainUserStreamCursorInput;
  TelephonydomainUserStreamCursorValueInput: TelephonydomainUserStreamCursorValueInput;
  TelephonydomainUserSumFields: TelephonydomainUserSumFields;
  TelephonydomainUserSumOrderBy: TelephonydomainUserSumOrderBy;
  TelephonydomainUserUpdates: TelephonydomainUserUpdates;
  TelephonydomainUserVarPopFields: TelephonydomainUserVarPopFields;
  TelephonydomainUserVarPopOrderBy: TelephonydomainUserVarPopOrderBy;
  TelephonydomainUserVarSampFields: TelephonydomainUserVarSampFields;
  TelephonydomainUserVarSampOrderBy: TelephonydomainUserVarSampOrderBy;
  TelephonydomainUserVarianceFields: TelephonydomainUserVarianceFields;
  TelephonydomainUserVarianceOrderBy: TelephonydomainUserVarianceOrderBy;
  Telephonyevent: Telephonyevent;
  TelephonyeventAction: TelephonyeventAction;
  TelephonyeventActionAggregate: TelephonyeventActionAggregate;
  TelephonyeventActionAggregateFields: TelephonyeventActionAggregateFields;
  TelephonyeventActionBoolExp: TelephonyeventActionBoolExp;
  TelephonyeventActionInsertInput: TelephonyeventActionInsertInput;
  TelephonyeventActionMaxFields: TelephonyeventActionMaxFields;
  TelephonyeventActionMinFields: TelephonyeventActionMinFields;
  TelephonyeventActionMutationResponse: TelephonyeventActionMutationResponse;
  TelephonyeventActionOnConflict: TelephonyeventActionOnConflict;
  TelephonyeventActionOrderBy: TelephonyeventActionOrderBy;
  TelephonyeventActionPkColumnsInput: TelephonyeventActionPkColumnsInput;
  TelephonyeventActionSetInput: TelephonyeventActionSetInput;
  TelephonyeventActionStreamCursorInput: TelephonyeventActionStreamCursorInput;
  TelephonyeventActionStreamCursorValueInput: TelephonyeventActionStreamCursorValueInput;
  TelephonyeventActionUpdates: TelephonyeventActionUpdates;
  TelephonyeventAggregate: TelephonyeventAggregate;
  TelephonyeventAggregateBoolExp: TelephonyeventAggregateBoolExp;
  TelephonyeventAggregateBoolExpCount: TelephonyeventAggregateBoolExpCount;
  TelephonyeventAggregateFields: TelephonyeventAggregateFields;
  TelephonyeventAggregateOrderBy: TelephonyeventAggregateOrderBy;
  TelephonyeventArrRelInsertInput: TelephonyeventArrRelInsertInput;
  TelephonyeventAvgFields: TelephonyeventAvgFields;
  TelephonyeventAvgOrderBy: TelephonyeventAvgOrderBy;
  TelephonyeventBoolExp: TelephonyeventBoolExp;
  TelephonyeventIncInput: TelephonyeventIncInput;
  TelephonyeventInsertInput: TelephonyeventInsertInput;
  TelephonyeventMaxFields: TelephonyeventMaxFields;
  TelephonyeventMaxOrderBy: TelephonyeventMaxOrderBy;
  TelephonyeventMinFields: TelephonyeventMinFields;
  TelephonyeventMinOrderBy: TelephonyeventMinOrderBy;
  TelephonyeventMutationResponse: TelephonyeventMutationResponse;
  TelephonyeventOnConflict: TelephonyeventOnConflict;
  TelephonyeventOrderBy: TelephonyeventOrderBy;
  TelephonyeventPkColumnsInput: TelephonyeventPkColumnsInput;
  TelephonyeventSetInput: TelephonyeventSetInput;
  TelephonyeventStddevFields: TelephonyeventStddevFields;
  TelephonyeventStddevOrderBy: TelephonyeventStddevOrderBy;
  TelephonyeventStddevPopFields: TelephonyeventStddevPopFields;
  TelephonyeventStddevPopOrderBy: TelephonyeventStddevPopOrderBy;
  TelephonyeventStddevSampFields: TelephonyeventStddevSampFields;
  TelephonyeventStddevSampOrderBy: TelephonyeventStddevSampOrderBy;
  TelephonyeventStreamCursorInput: TelephonyeventStreamCursorInput;
  TelephonyeventStreamCursorValueInput: TelephonyeventStreamCursorValueInput;
  TelephonyeventSumFields: TelephonyeventSumFields;
  TelephonyeventSumOrderBy: TelephonyeventSumOrderBy;
  TelephonyeventUpdates: TelephonyeventUpdates;
  TelephonyeventVarPopFields: TelephonyeventVarPopFields;
  TelephonyeventVarPopOrderBy: TelephonyeventVarPopOrderBy;
  TelephonyeventVarSampFields: TelephonyeventVarSampFields;
  TelephonyeventVarSampOrderBy: TelephonyeventVarSampOrderBy;
  TelephonyeventVarianceFields: TelephonyeventVarianceFields;
  TelephonyeventVarianceOrderBy: TelephonyeventVarianceOrderBy;
  TelephonyhangUpCallOutput: TelephonyhangUpCallOutput;
  Telephonyjsonb: Scalars['Telephonyjsonb']['output'];
  Telephonyprovider: Telephonyprovider;
  TelephonyproviderAccount: TelephonyproviderAccount;
  TelephonyproviderAccountAggregate: TelephonyproviderAccountAggregate;
  TelephonyproviderAccountAggregateBoolExp: TelephonyproviderAccountAggregateBoolExp;
  TelephonyproviderAccountAggregateBoolExpCount: TelephonyproviderAccountAggregateBoolExpCount;
  TelephonyproviderAccountAggregateFields: TelephonyproviderAccountAggregateFields;
  TelephonyproviderAccountAggregateOrderBy: TelephonyproviderAccountAggregateOrderBy;
  TelephonyproviderAccountArrRelInsertInput: TelephonyproviderAccountArrRelInsertInput;
  TelephonyproviderAccountBoolExp: TelephonyproviderAccountBoolExp;
  TelephonyproviderAccountInsertInput: TelephonyproviderAccountInsertInput;
  TelephonyproviderAccountMaxFields: TelephonyproviderAccountMaxFields;
  TelephonyproviderAccountMaxOrderBy: TelephonyproviderAccountMaxOrderBy;
  TelephonyproviderAccountMinFields: TelephonyproviderAccountMinFields;
  TelephonyproviderAccountMinOrderBy: TelephonyproviderAccountMinOrderBy;
  TelephonyproviderAccountMutationResponse: TelephonyproviderAccountMutationResponse;
  TelephonyproviderAccountObjRelInsertInput: TelephonyproviderAccountObjRelInsertInput;
  TelephonyproviderAccountOnConflict: TelephonyproviderAccountOnConflict;
  TelephonyproviderAccountOrderBy: TelephonyproviderAccountOrderBy;
  TelephonyproviderAccountPkColumnsInput: TelephonyproviderAccountPkColumnsInput;
  TelephonyproviderAccountSetInput: TelephonyproviderAccountSetInput;
  TelephonyproviderAccountStreamCursorInput: TelephonyproviderAccountStreamCursorInput;
  TelephonyproviderAccountStreamCursorValueInput: TelephonyproviderAccountStreamCursorValueInput;
  TelephonyproviderAccountUpdates: TelephonyproviderAccountUpdates;
  TelephonyproviderAggregate: TelephonyproviderAggregate;
  TelephonyproviderAggregateFields: TelephonyproviderAggregateFields;
  TelephonyproviderBoolExp: TelephonyproviderBoolExp;
  TelephonyproviderInsertInput: TelephonyproviderInsertInput;
  TelephonyproviderMaxFields: TelephonyproviderMaxFields;
  TelephonyproviderMinFields: TelephonyproviderMinFields;
  TelephonyproviderMutationResponse: TelephonyproviderMutationResponse;
  TelephonyproviderObjRelInsertInput: TelephonyproviderObjRelInsertInput;
  TelephonyproviderOnConflict: TelephonyproviderOnConflict;
  TelephonyproviderOrderBy: TelephonyproviderOrderBy;
  TelephonyproviderPkColumnsInput: TelephonyproviderPkColumnsInput;
  TelephonyproviderRequestTerm: TelephonyproviderRequestTerm;
  TelephonyproviderRequestTermAggregate: TelephonyproviderRequestTermAggregate;
  TelephonyproviderRequestTermAggregateFields: TelephonyproviderRequestTermAggregateFields;
  TelephonyproviderRequestTermAvgFields: TelephonyproviderRequestTermAvgFields;
  TelephonyproviderRequestTermBoolExp: TelephonyproviderRequestTermBoolExp;
  TelephonyproviderRequestTermIncInput: TelephonyproviderRequestTermIncInput;
  TelephonyproviderRequestTermInsertInput: TelephonyproviderRequestTermInsertInput;
  TelephonyproviderRequestTermMaxFields: TelephonyproviderRequestTermMaxFields;
  TelephonyproviderRequestTermMinFields: TelephonyproviderRequestTermMinFields;
  TelephonyproviderRequestTermMutationResponse: TelephonyproviderRequestTermMutationResponse;
  TelephonyproviderRequestTermOnConflict: TelephonyproviderRequestTermOnConflict;
  TelephonyproviderRequestTermOrderBy: TelephonyproviderRequestTermOrderBy;
  TelephonyproviderRequestTermPkColumnsInput: TelephonyproviderRequestTermPkColumnsInput;
  TelephonyproviderRequestTermSetInput: TelephonyproviderRequestTermSetInput;
  TelephonyproviderRequestTermStddevFields: TelephonyproviderRequestTermStddevFields;
  TelephonyproviderRequestTermStddevPopFields: TelephonyproviderRequestTermStddevPopFields;
  TelephonyproviderRequestTermStddevSampFields: TelephonyproviderRequestTermStddevSampFields;
  TelephonyproviderRequestTermStreamCursorInput: TelephonyproviderRequestTermStreamCursorInput;
  TelephonyproviderRequestTermStreamCursorValueInput: TelephonyproviderRequestTermStreamCursorValueInput;
  TelephonyproviderRequestTermSumFields: TelephonyproviderRequestTermSumFields;
  TelephonyproviderRequestTermUpdates: TelephonyproviderRequestTermUpdates;
  TelephonyproviderRequestTermVarPopFields: TelephonyproviderRequestTermVarPopFields;
  TelephonyproviderRequestTermVarSampFields: TelephonyproviderRequestTermVarSampFields;
  TelephonyproviderRequestTermVarianceFields: TelephonyproviderRequestTermVarianceFields;
  TelephonyproviderSetInput: TelephonyproviderSetInput;
  TelephonyproviderStreamCursorInput: TelephonyproviderStreamCursorInput;
  TelephonyproviderStreamCursorValueInput: TelephonyproviderStreamCursorValueInput;
  TelephonyproviderUpdates: TelephonyproviderUpdates;
  TelephonytelephonyEventsAggregateBoolExpCount: TelephonytelephonyEventsAggregateBoolExpCount;
  Telephonytimestamptz: Scalars['Telephonytimestamptz']['output'];
  TelephonytriggerTestCallOutput: TelephonytriggerTestCallOutput;
  TimestampComparisonExp: TimestampComparisonExp;
  TimestamptzArrayComparisonExp: TimestamptzArrayComparisonExp;
  TimestamptzComparisonExp: TimestamptzComparisonExp;
  TimetzComparisonExp: TimetzComparisonExp;
  UserAndOrgInput: UserAndOrgInput;
  UserDetailsTypeEnumComparisonExp: UserDetailsTypeEnumComparisonExp;
  UserOrgOutput: UserOrgOutput;
  UserRoleEnumComparisonExp: UserRoleEnumComparisonExp;
  UserUpdateInput: UserUpdateInput;
  UserUpdateOutput: UserUpdateOutput;
  UuidComparisonExp: UuidComparisonExp;
  VerificationOutput: VerificationOutput;
  VoiceTypes: VoiceTypes;
  VoiceTypesAggregate: VoiceTypesAggregate;
  VoiceTypesAggregateFields: VoiceTypesAggregateFields;
  VoiceTypesBoolExp: VoiceTypesBoolExp;
  VoiceTypesEnumComparisonExp: VoiceTypesEnumComparisonExp;
  VoiceTypesInsertInput: VoiceTypesInsertInput;
  VoiceTypesMaxFields: VoiceTypesMaxFields;
  VoiceTypesMinFields: VoiceTypesMinFields;
  VoiceTypesMutationResponse: VoiceTypesMutationResponse;
  VoiceTypesOnConflict: VoiceTypesOnConflict;
  VoiceTypesOrderBy: VoiceTypesOrderBy;
  VoiceTypesPkColumnsInput: VoiceTypesPkColumnsInput;
  VoiceTypesSetInput: VoiceTypesSetInput;
  VoiceTypesStreamCursorInput: VoiceTypesStreamCursorInput;
  VoiceTypesStreamCursorValueInput: VoiceTypesStreamCursorValueInput;
  VoiceTypesUpdates: VoiceTypesUpdates;
  acceptInviteObject: acceptInviteObject;
  acceptInviteOutput: acceptInviteOutput;
  acceptRequestObject: acceptRequestObject;
  acceptRequestsOutput: acceptRequestsOutput;
  activityParticipant: activityParticipant;
  activityParticipantAggregate: activityParticipantAggregate;
  activityParticipantAggregateBoolExp: activityParticipantAggregateBoolExp;
  activityParticipantAggregateBoolExpBool_and: activityParticipantAggregateBoolExpBool_and;
  activityParticipantAggregateBoolExpBool_or: activityParticipantAggregateBoolExpBool_or;
  activityParticipantAggregateBoolExpCount: activityParticipantAggregateBoolExpCount;
  activityParticipantAggregateFields: activityParticipantAggregateFields;
  activityParticipantAggregateOrderBy: activityParticipantAggregateOrderBy;
  activityParticipantArrRelInsertInput: activityParticipantArrRelInsertInput;
  activityParticipantBoolExp: activityParticipantBoolExp;
  activityParticipantInsertInput: activityParticipantInsertInput;
  activityParticipantMaxFields: activityParticipantMaxFields;
  activityParticipantMaxOrderBy: activityParticipantMaxOrderBy;
  activityParticipantMinFields: activityParticipantMinFields;
  activityParticipantMinOrderBy: activityParticipantMinOrderBy;
  activityParticipantMutationResponse: activityParticipantMutationResponse;
  activityParticipantOnConflict: activityParticipantOnConflict;
  activityParticipantOrderBy: activityParticipantOrderBy;
  activityParticipantPkColumnsInput: activityParticipantPkColumnsInput;
  activityParticipantSetInput: activityParticipantSetInput;
  activityParticipantStreamCursorInput: activityParticipantStreamCursorInput;
  activityParticipantStreamCursorValueInput: activityParticipantStreamCursorValueInput;
  activityParticipantUpdates: activityParticipantUpdates;
  activityTaskInput: activityTaskInput;
  activityTaskOutput: activityTaskOutput;
  address: address;
  addressAggregate: addressAggregate;
  addressAggregateBoolExp: addressAggregateBoolExp;
  addressAggregateBoolExpCount: addressAggregateBoolExpCount;
  addressAggregateFields: addressAggregateFields;
  addressAggregateOrderBy: addressAggregateOrderBy;
  addressArrRelInsertInput: addressArrRelInsertInput;
  addressBoolExp: addressBoolExp;
  addressInsertInput: addressInsertInput;
  addressMaxFields: addressMaxFields;
  addressMaxOrderBy: addressMaxOrderBy;
  addressMinFields: addressMinFields;
  addressMinOrderBy: addressMinOrderBy;
  addressMutationResponse: addressMutationResponse;
  addressObjRelInsertInput: addressObjRelInsertInput;
  addressOnConflict: addressOnConflict;
  addressOrderBy: addressOrderBy;
  addressPkColumnsInput: addressPkColumnsInput;
  addressSetInput: addressSetInput;
  addressStreamCursorInput: addressStreamCursorInput;
  addressStreamCursorValueInput: addressStreamCursorValueInput;
  addressUpdates: addressUpdates;
  blockedDomainUser: blockedDomainUser;
  blockedDomainUserAggregate: blockedDomainUserAggregate;
  blockedDomainUserAggregateFields: blockedDomainUserAggregateFields;
  blockedDomainUserBoolExp: blockedDomainUserBoolExp;
  blockedDomainUserInsertInput: blockedDomainUserInsertInput;
  blockedDomainUserMaxFields: blockedDomainUserMaxFields;
  blockedDomainUserMinFields: blockedDomainUserMinFields;
  blockedDomainUserMutationResponse: blockedDomainUserMutationResponse;
  blockedDomainUserOnConflict: blockedDomainUserOnConflict;
  blockedDomainUserOrderBy: blockedDomainUserOrderBy;
  blockedDomainUserPkColumnsInput: blockedDomainUserPkColumnsInput;
  blockedDomainUserSetInput: blockedDomainUserSetInput;
  blockedDomainUserStreamCursorInput: blockedDomainUserStreamCursorInput;
  blockedDomainUserStreamCursorValueInput: blockedDomainUserStreamCursorValueInput;
  blockedDomainUserUpdates: blockedDomainUserUpdates;
  bregmutation_root: bregmutation_root;
  bregquery_root: bregquery_root;
  bregsubscription_root: bregsubscription_root;
  businessMessageAttachmentsAggregateBoolExpCount: businessMessageAttachmentsAggregateBoolExpCount;
  businessOrganizationUserEmailAggregateBoolExpBool_and: businessOrganizationUserEmailAggregateBoolExpBool_and;
  businessOrganizationUserEmailAggregateBoolExpBool_or: businessOrganizationUserEmailAggregateBoolExpBool_or;
  businessOrganizationUserEmailAggregateBoolExpCount: businessOrganizationUserEmailAggregateBoolExpCount;
  businessOrganizationUserRequestAggregateBoolExpBool_and: businessOrganizationUserRequestAggregateBoolExpBool_and;
  businessOrganizationUserRequestAggregateBoolExpBool_or: businessOrganizationUserRequestAggregateBoolExpBool_or;
  businessOrganizationUserRequestAggregateBoolExpCount: businessOrganizationUserRequestAggregateBoolExpCount;
  businessOrganizationUserUrlAddressAggregateBoolExpCount: businessOrganizationUserUrlAddressAggregateBoolExpCount;
  businessQueueItemAlarmsAggregateBoolExpCount: businessQueueItemAlarmsAggregateBoolExpCount;
  businessQueueItemCollaboration: businessQueueItemCollaboration;
  businessQueueItemCollaborationAggregate: businessQueueItemCollaborationAggregate;
  businessQueueItemCollaborationAggregateBoolExp: businessQueueItemCollaborationAggregateBoolExp;
  businessQueueItemCollaborationAggregateBoolExpBool_and: businessQueueItemCollaborationAggregateBoolExpBool_and;
  businessQueueItemCollaborationAggregateBoolExpBool_or: businessQueueItemCollaborationAggregateBoolExpBool_or;
  businessQueueItemCollaborationAggregateBoolExpCount: businessQueueItemCollaborationAggregateBoolExpCount;
  businessQueueItemCollaborationAggregateFields: businessQueueItemCollaborationAggregateFields;
  businessQueueItemCollaborationAggregateOrderBy: businessQueueItemCollaborationAggregateOrderBy;
  businessQueueItemCollaborationArrRelInsertInput: businessQueueItemCollaborationArrRelInsertInput;
  businessQueueItemCollaborationAvgFields: businessQueueItemCollaborationAvgFields;
  businessQueueItemCollaborationAvgOrderBy: businessQueueItemCollaborationAvgOrderBy;
  businessQueueItemCollaborationBoolExp: businessQueueItemCollaborationBoolExp;
  businessQueueItemCollaborationIncInput: businessQueueItemCollaborationIncInput;
  businessQueueItemCollaborationInsertInput: businessQueueItemCollaborationInsertInput;
  businessQueueItemCollaborationMaxFields: businessQueueItemCollaborationMaxFields;
  businessQueueItemCollaborationMaxOrderBy: businessQueueItemCollaborationMaxOrderBy;
  businessQueueItemCollaborationMinFields: businessQueueItemCollaborationMinFields;
  businessQueueItemCollaborationMinOrderBy: businessQueueItemCollaborationMinOrderBy;
  businessQueueItemCollaborationMutationResponse: businessQueueItemCollaborationMutationResponse;
  businessQueueItemCollaborationOnConflict: businessQueueItemCollaborationOnConflict;
  businessQueueItemCollaborationOrderBy: businessQueueItemCollaborationOrderBy;
  businessQueueItemCollaborationPkColumnsInput: businessQueueItemCollaborationPkColumnsInput;
  businessQueueItemCollaborationSetInput: businessQueueItemCollaborationSetInput;
  businessQueueItemCollaborationStddevFields: businessQueueItemCollaborationStddevFields;
  businessQueueItemCollaborationStddevOrderBy: businessQueueItemCollaborationStddevOrderBy;
  businessQueueItemCollaborationStddevPopFields: businessQueueItemCollaborationStddevPopFields;
  businessQueueItemCollaborationStddevPopOrderBy: businessQueueItemCollaborationStddevPopOrderBy;
  businessQueueItemCollaborationStddevSampFields: businessQueueItemCollaborationStddevSampFields;
  businessQueueItemCollaborationStddevSampOrderBy: businessQueueItemCollaborationStddevSampOrderBy;
  businessQueueItemCollaborationStreamCursorInput: businessQueueItemCollaborationStreamCursorInput;
  businessQueueItemCollaborationStreamCursorValueInput: businessQueueItemCollaborationStreamCursorValueInput;
  businessQueueItemCollaborationSumFields: businessQueueItemCollaborationSumFields;
  businessQueueItemCollaborationSumOrderBy: businessQueueItemCollaborationSumOrderBy;
  businessQueueItemCollaborationUpdates: businessQueueItemCollaborationUpdates;
  businessQueueItemCollaborationVarPopFields: businessQueueItemCollaborationVarPopFields;
  businessQueueItemCollaborationVarPopOrderBy: businessQueueItemCollaborationVarPopOrderBy;
  businessQueueItemCollaborationVarSampFields: businessQueueItemCollaborationVarSampFields;
  businessQueueItemCollaborationVarSampOrderBy: businessQueueItemCollaborationVarSampOrderBy;
  businessQueueItemCollaborationVarianceFields: businessQueueItemCollaborationVarianceFields;
  businessQueueItemCollaborationVarianceOrderBy: businessQueueItemCollaborationVarianceOrderBy;
  businessQueueItemDomainUsersViewAggregateBoolExpCount: businessQueueItemDomainUsersViewAggregateBoolExpCount;
  businessQueueItemOrganizationUsersViewAggregateBoolExpCount: businessQueueItemOrganizationUsersViewAggregateBoolExpCount;
  businessQueueItemParticipantsViewAggregateBoolExpCount: businessQueueItemParticipantsViewAggregateBoolExpCount;
  businessUserContactNumbersAggregateBoolExpBool_and: businessUserContactNumbersAggregateBoolExpBool_and;
  businessUserContactNumbersAggregateBoolExpBool_or: businessUserContactNumbersAggregateBoolExpBool_or;
  businessUserContactNumbersAggregateBoolExpCount: businessUserContactNumbersAggregateBoolExpCount;
  businessUserContacts: businessUserContacts;
  businessUserContactsAggregate: businessUserContactsAggregate;
  businessUserContactsAggregateFields: businessUserContactsAggregateFields;
  businessUserContactsBoolExp: businessUserContactsBoolExp;
  businessUserContactsInsertInput: businessUserContactsInsertInput;
  businessUserContactsMaxFields: businessUserContactsMaxFields;
  businessUserContactsMinFields: businessUserContactsMinFields;
  businessUserContactsMutationResponse: businessUserContactsMutationResponse;
  businessUserContactsObjRelInsertInput: businessUserContactsObjRelInsertInput;
  businessUserContactsOnConflict: businessUserContactsOnConflict;
  businessUserContactsOrderBy: businessUserContactsOrderBy;
  businessUserContactsPkColumnsInput: businessUserContactsPkColumnsInput;
  businessUserContactsSetInput: businessUserContactsSetInput;
  businessUserContactsStreamCursorInput: businessUserContactsStreamCursorInput;
  businessUserContactsStreamCursorValueInput: businessUserContactsStreamCursorValueInput;
  businessUserContactsUpdates: businessUserContactsUpdates;
  businessUserFeedAggregateBoolExpBool_and: businessUserFeedAggregateBoolExpBool_and;
  businessUserFeedAggregateBoolExpBool_or: businessUserFeedAggregateBoolExpBool_or;
  businessUserFeedAggregateBoolExpCount: businessUserFeedAggregateBoolExpCount;
  businessUserSettings: businessUserSettings;
  businessUserSettingsAggregate: businessUserSettingsAggregate;
  businessUserSettingsAggregateFields: businessUserSettingsAggregateFields;
  businessUserSettingsAvgFields: businessUserSettingsAvgFields;
  businessUserSettingsBoolExp: businessUserSettingsBoolExp;
  businessUserSettingsIncInput: businessUserSettingsIncInput;
  businessUserSettingsInsertInput: businessUserSettingsInsertInput;
  businessUserSettingsMaxFields: businessUserSettingsMaxFields;
  businessUserSettingsMinFields: businessUserSettingsMinFields;
  businessUserSettingsMutationResponse: businessUserSettingsMutationResponse;
  businessUserSettingsOnConflict: businessUserSettingsOnConflict;
  businessUserSettingsOrderBy: businessUserSettingsOrderBy;
  businessUserSettingsPkColumnsInput: businessUserSettingsPkColumnsInput;
  businessUserSettingsSetInput: businessUserSettingsSetInput;
  businessUserSettingsStddevFields: businessUserSettingsStddevFields;
  businessUserSettingsStddevPopFields: businessUserSettingsStddevPopFields;
  businessUserSettingsStddevSampFields: businessUserSettingsStddevSampFields;
  businessUserSettingsStreamCursorInput: businessUserSettingsStreamCursorInput;
  businessUserSettingsStreamCursorValueInput: businessUserSettingsStreamCursorValueInput;
  businessUserSettingsSumFields: businessUserSettingsSumFields;
  businessUserSettingsUpdates: businessUserSettingsUpdates;
  businessUserSettingsVarPopFields: businessUserSettingsVarPopFields;
  businessUserSettingsVarSampFields: businessUserSettingsVarSampFields;
  businessUserSettingsVarianceFields: businessUserSettingsVarianceFields;
  businessUserStatesAggregateBoolExpCount: businessUserStatesAggregateBoolExpCount;
  callBackLaterResult: callBackLaterResult;
  checkTelephonyIdOutput: checkTelephonyIdOutput;
  createEmailProviderIntegrationAccount: createEmailProviderIntegrationAccount;
  createEmailProviderIntegrationInput: createEmailProviderIntegrationInput;
  createEmailProviderSubscriptionInput: createEmailProviderSubscriptionInput;
  createEmailProviderSubscriptionOutput: createEmailProviderSubscriptionOutput;
  createMessagingGroupOutput: createMessagingGroupOutput;
  createPhoneroOrgUserInput: createPhoneroOrgUserInput;
  createPhoneroOrgUsersOutput: createPhoneroOrgUsersOutput;
  createRoomOutput: createRoomOutput;
  crmStatusMessage: crmStatusMessage;
  crmStatusMessageAggregate: crmStatusMessageAggregate;
  crmStatusMessageAggregateFields: crmStatusMessageAggregateFields;
  crmStatusMessageAppendInput: crmStatusMessageAppendInput;
  crmStatusMessageAvgFields: crmStatusMessageAvgFields;
  crmStatusMessageBoolExp: crmStatusMessageBoolExp;
  crmStatusMessageDeleteAtPathInput: crmStatusMessageDeleteAtPathInput;
  crmStatusMessageDeleteElemInput: crmStatusMessageDeleteElemInput;
  crmStatusMessageDeleteKeyInput: crmStatusMessageDeleteKeyInput;
  crmStatusMessageIncInput: crmStatusMessageIncInput;
  crmStatusMessageInsertInput: crmStatusMessageInsertInput;
  crmStatusMessageMaxFields: crmStatusMessageMaxFields;
  crmStatusMessageMinFields: crmStatusMessageMinFields;
  crmStatusMessageMutationResponse: crmStatusMessageMutationResponse;
  crmStatusMessageOnConflict: crmStatusMessageOnConflict;
  crmStatusMessageOrderBy: crmStatusMessageOrderBy;
  crmStatusMessagePkColumnsInput: crmStatusMessagePkColumnsInput;
  crmStatusMessagePrependInput: crmStatusMessagePrependInput;
  crmStatusMessageSetInput: crmStatusMessageSetInput;
  crmStatusMessageStddevFields: crmStatusMessageStddevFields;
  crmStatusMessageStddevPopFields: crmStatusMessageStddevPopFields;
  crmStatusMessageStddevSampFields: crmStatusMessageStddevSampFields;
  crmStatusMessageStreamCursorInput: crmStatusMessageStreamCursorInput;
  crmStatusMessageStreamCursorValueInput: crmStatusMessageStreamCursorValueInput;
  crmStatusMessageSumFields: crmStatusMessageSumFields;
  crmStatusMessageUpdates: crmStatusMessageUpdates;
  crmStatusMessageVarPopFields: crmStatusMessageVarPopFields;
  crmStatusMessageVarSampFields: crmStatusMessageVarSampFields;
  crmStatusMessageVarianceFields: crmStatusMessageVarianceFields;
  crmYoutelloCatalystIdMapping: crmYoutelloCatalystIdMapping;
  crmYoutelloCatalystIdMappingAggregate: crmYoutelloCatalystIdMappingAggregate;
  crmYoutelloCatalystIdMappingAggregateBoolExp: crmYoutelloCatalystIdMappingAggregateBoolExp;
  crmYoutelloCatalystIdMappingAggregateBoolExpCount: crmYoutelloCatalystIdMappingAggregateBoolExpCount;
  crmYoutelloCatalystIdMappingAggregateFields: crmYoutelloCatalystIdMappingAggregateFields;
  crmYoutelloCatalystIdMappingAggregateOrderBy: crmYoutelloCatalystIdMappingAggregateOrderBy;
  crmYoutelloCatalystIdMappingArrRelInsertInput: crmYoutelloCatalystIdMappingArrRelInsertInput;
  crmYoutelloCatalystIdMappingAvgFields: crmYoutelloCatalystIdMappingAvgFields;
  crmYoutelloCatalystIdMappingAvgOrderBy: crmYoutelloCatalystIdMappingAvgOrderBy;
  crmYoutelloCatalystIdMappingBoolExp: crmYoutelloCatalystIdMappingBoolExp;
  crmYoutelloCatalystIdMappingIncInput: crmYoutelloCatalystIdMappingIncInput;
  crmYoutelloCatalystIdMappingInsertInput: crmYoutelloCatalystIdMappingInsertInput;
  crmYoutelloCatalystIdMappingMaxFields: crmYoutelloCatalystIdMappingMaxFields;
  crmYoutelloCatalystIdMappingMaxOrderBy: crmYoutelloCatalystIdMappingMaxOrderBy;
  crmYoutelloCatalystIdMappingMinFields: crmYoutelloCatalystIdMappingMinFields;
  crmYoutelloCatalystIdMappingMinOrderBy: crmYoutelloCatalystIdMappingMinOrderBy;
  crmYoutelloCatalystIdMappingMutationResponse: crmYoutelloCatalystIdMappingMutationResponse;
  crmYoutelloCatalystIdMappingOnConflict: crmYoutelloCatalystIdMappingOnConflict;
  crmYoutelloCatalystIdMappingOrderBy: crmYoutelloCatalystIdMappingOrderBy;
  crmYoutelloCatalystIdMappingPkColumnsInput: crmYoutelloCatalystIdMappingPkColumnsInput;
  crmYoutelloCatalystIdMappingSetInput: crmYoutelloCatalystIdMappingSetInput;
  crmYoutelloCatalystIdMappingStddevFields: crmYoutelloCatalystIdMappingStddevFields;
  crmYoutelloCatalystIdMappingStddevOrderBy: crmYoutelloCatalystIdMappingStddevOrderBy;
  crmYoutelloCatalystIdMappingStddevPopFields: crmYoutelloCatalystIdMappingStddevPopFields;
  crmYoutelloCatalystIdMappingStddevPopOrderBy: crmYoutelloCatalystIdMappingStddevPopOrderBy;
  crmYoutelloCatalystIdMappingStddevSampFields: crmYoutelloCatalystIdMappingStddevSampFields;
  crmYoutelloCatalystIdMappingStddevSampOrderBy: crmYoutelloCatalystIdMappingStddevSampOrderBy;
  crmYoutelloCatalystIdMappingStreamCursorInput: crmYoutelloCatalystIdMappingStreamCursorInput;
  crmYoutelloCatalystIdMappingStreamCursorValueInput: crmYoutelloCatalystIdMappingStreamCursorValueInput;
  crmYoutelloCatalystIdMappingSumFields: crmYoutelloCatalystIdMappingSumFields;
  crmYoutelloCatalystIdMappingSumOrderBy: crmYoutelloCatalystIdMappingSumOrderBy;
  crmYoutelloCatalystIdMappingUpdates: crmYoutelloCatalystIdMappingUpdates;
  crmYoutelloCatalystIdMappingVarPopFields: crmYoutelloCatalystIdMappingVarPopFields;
  crmYoutelloCatalystIdMappingVarPopOrderBy: crmYoutelloCatalystIdMappingVarPopOrderBy;
  crmYoutelloCatalystIdMappingVarSampFields: crmYoutelloCatalystIdMappingVarSampFields;
  crmYoutelloCatalystIdMappingVarSampOrderBy: crmYoutelloCatalystIdMappingVarSampOrderBy;
  crmYoutelloCatalystIdMappingVarianceFields: crmYoutelloCatalystIdMappingVarianceFields;
  crmYoutelloCatalystIdMappingVarianceOrderBy: crmYoutelloCatalystIdMappingVarianceOrderBy;
  dashboardDataOutput: dashboardDataOutput;
  deleteEmailProviderSubscriptionInput: deleteEmailProviderSubscriptionInput;
  deleteEmailProviderSubscriptionOutput: deleteEmailProviderSubscriptionOutput;
  domainActivity: domainActivity;
  domainActivityAggregate: domainActivityAggregate;
  domainActivityAggregateBoolExp: domainActivityAggregateBoolExp;
  domainActivityAggregateBoolExpCount: domainActivityAggregateBoolExpCount;
  domainActivityAggregateFields: domainActivityAggregateFields;
  domainActivityAggregateOrderBy: domainActivityAggregateOrderBy;
  domainActivityAppendInput: domainActivityAppendInput;
  domainActivityArrRelInsertInput: domainActivityArrRelInsertInput;
  domainActivityAvgFields: domainActivityAvgFields;
  domainActivityAvgOrderBy: domainActivityAvgOrderBy;
  domainActivityBoolExp: domainActivityBoolExp;
  domainActivityDeleteAtPathInput: domainActivityDeleteAtPathInput;
  domainActivityDeleteElemInput: domainActivityDeleteElemInput;
  domainActivityDeleteKeyInput: domainActivityDeleteKeyInput;
  domainActivityIncInput: domainActivityIncInput;
  domainActivityInsertInput: domainActivityInsertInput;
  domainActivityMaxFields: domainActivityMaxFields;
  domainActivityMaxOrderBy: domainActivityMaxOrderBy;
  domainActivityMinFields: domainActivityMinFields;
  domainActivityMinOrderBy: domainActivityMinOrderBy;
  domainActivityMutationResponse: domainActivityMutationResponse;
  domainActivityObjRelInsertInput: domainActivityObjRelInsertInput;
  domainActivityOnConflict: domainActivityOnConflict;
  domainActivityOrderBy: domainActivityOrderBy;
  domainActivityPkColumnsInput: domainActivityPkColumnsInput;
  domainActivityPrependInput: domainActivityPrependInput;
  domainActivitySetInput: domainActivitySetInput;
  domainActivityStddevFields: domainActivityStddevFields;
  domainActivityStddevOrderBy: domainActivityStddevOrderBy;
  domainActivityStddevPopFields: domainActivityStddevPopFields;
  domainActivityStddevPopOrderBy: domainActivityStddevPopOrderBy;
  domainActivityStddevSampFields: domainActivityStddevSampFields;
  domainActivityStddevSampOrderBy: domainActivityStddevSampOrderBy;
  domainActivityStreamCursorInput: domainActivityStreamCursorInput;
  domainActivityStreamCursorValueInput: domainActivityStreamCursorValueInput;
  domainActivitySumFields: domainActivitySumFields;
  domainActivitySumOrderBy: domainActivitySumOrderBy;
  domainActivityUpdates: domainActivityUpdates;
  domainActivityVarPopFields: domainActivityVarPopFields;
  domainActivityVarPopOrderBy: domainActivityVarPopOrderBy;
  domainActivityVarSampFields: domainActivityVarSampFields;
  domainActivityVarSampOrderBy: domainActivityVarSampOrderBy;
  domainActivityVarianceFields: domainActivityVarianceFields;
  domainActivityVarianceOrderBy: domainActivityVarianceOrderBy;
  domainOrganization: domainOrganization;
  domainOrganizationAggregate: domainOrganizationAggregate;
  domainOrganizationAggregateBoolExp: domainOrganizationAggregateBoolExp;
  domainOrganizationAggregateBoolExpBool_and: domainOrganizationAggregateBoolExpBool_and;
  domainOrganizationAggregateBoolExpBool_or: domainOrganizationAggregateBoolExpBool_or;
  domainOrganizationAggregateBoolExpCount: domainOrganizationAggregateBoolExpCount;
  domainOrganizationAggregateFields: domainOrganizationAggregateFields;
  domainOrganizationAggregateOrderBy: domainOrganizationAggregateOrderBy;
  domainOrganizationArrRelInsertInput: domainOrganizationArrRelInsertInput;
  domainOrganizationBoolExp: domainOrganizationBoolExp;
  domainOrganizationInsertInput: domainOrganizationInsertInput;
  domainOrganizationMaxFields: domainOrganizationMaxFields;
  domainOrganizationMaxOrderBy: domainOrganizationMaxOrderBy;
  domainOrganizationMinFields: domainOrganizationMinFields;
  domainOrganizationMinOrderBy: domainOrganizationMinOrderBy;
  domainOrganizationMutationResponse: domainOrganizationMutationResponse;
  domainOrganizationObjRelInsertInput: domainOrganizationObjRelInsertInput;
  domainOrganizationOnConflict: domainOrganizationOnConflict;
  domainOrganizationOrderBy: domainOrganizationOrderBy;
  domainOrganizationPkColumnsInput: domainOrganizationPkColumnsInput;
  domainOrganizationSetInput: domainOrganizationSetInput;
  domainOrganizationStreamCursorInput: domainOrganizationStreamCursorInput;
  domainOrganizationStreamCursorValueInput: domainOrganizationStreamCursorValueInput;
  domainOrganizationUpdates: domainOrganizationUpdates;
  domainParticipant: domainParticipant;
  domainParticipantAggregate: domainParticipantAggregate;
  domainParticipantAggregateBoolExp: domainParticipantAggregateBoolExp;
  domainParticipantAggregateBoolExpCount: domainParticipantAggregateBoolExpCount;
  domainParticipantAggregateFields: domainParticipantAggregateFields;
  domainParticipantAggregateOrderBy: domainParticipantAggregateOrderBy;
  domainParticipantArrRelInsertInput: domainParticipantArrRelInsertInput;
  domainParticipantBoolExp: domainParticipantBoolExp;
  domainParticipantInsertInput: domainParticipantInsertInput;
  domainParticipantMaxFields: domainParticipantMaxFields;
  domainParticipantMaxOrderBy: domainParticipantMaxOrderBy;
  domainParticipantMinFields: domainParticipantMinFields;
  domainParticipantMinOrderBy: domainParticipantMinOrderBy;
  domainParticipantMutationResponse: domainParticipantMutationResponse;
  domainParticipantOnConflict: domainParticipantOnConflict;
  domainParticipantOrderBy: domainParticipantOrderBy;
  domainParticipantPkColumnsInput: domainParticipantPkColumnsInput;
  domainParticipantSetInput: domainParticipantSetInput;
  domainParticipantStreamCursorInput: domainParticipantStreamCursorInput;
  domainParticipantStreamCursorValueInput: domainParticipantStreamCursorValueInput;
  domainParticipantUpdates: domainParticipantUpdates;
  domainType: domainType;
  domainTypeAggregate: domainTypeAggregate;
  domainTypeAggregateFields: domainTypeAggregateFields;
  domainTypeBoolExp: domainTypeBoolExp;
  domainTypeInsertInput: domainTypeInsertInput;
  domainTypeMaxFields: domainTypeMaxFields;
  domainTypeMinFields: domainTypeMinFields;
  domainTypeMutationResponse: domainTypeMutationResponse;
  domainTypeObjRelInsertInput: domainTypeObjRelInsertInput;
  domainTypeOnConflict: domainTypeOnConflict;
  domainTypeOrderBy: domainTypeOrderBy;
  domainTypePkColumnsInput: domainTypePkColumnsInput;
  domainTypeSetInput: domainTypeSetInput;
  domainTypeStreamCursorInput: domainTypeStreamCursorInput;
  domainTypeStreamCursorValueInput: domainTypeStreamCursorValueInput;
  domainTypeUpdates: domainTypeUpdates;
  domainUser: domainUser;
  domainUserAggregate: domainUserAggregate;
  domainUserAggregateBoolExp: domainUserAggregateBoolExp;
  domainUserAggregateBoolExpCount: domainUserAggregateBoolExpCount;
  domainUserAggregateFields: domainUserAggregateFields;
  domainUserAggregateOrderBy: domainUserAggregateOrderBy;
  domainUserArrRelInsertInput: domainUserArrRelInsertInput;
  domainUserAvgFields: domainUserAvgFields;
  domainUserAvgOrderBy: domainUserAvgOrderBy;
  domainUserBoolExp: domainUserBoolExp;
  domainUserCategory: domainUserCategory;
  domainUserCategoryAggregate: domainUserCategoryAggregate;
  domainUserCategoryAggregateFields: domainUserCategoryAggregateFields;
  domainUserCategoryBoolExp: domainUserCategoryBoolExp;
  domainUserCategoryInsertInput: domainUserCategoryInsertInput;
  domainUserCategoryMaxFields: domainUserCategoryMaxFields;
  domainUserCategoryMinFields: domainUserCategoryMinFields;
  domainUserCategoryMutationResponse: domainUserCategoryMutationResponse;
  domainUserCategoryObjRelInsertInput: domainUserCategoryObjRelInsertInput;
  domainUserCategoryOnConflict: domainUserCategoryOnConflict;
  domainUserCategoryOrderBy: domainUserCategoryOrderBy;
  domainUserCategoryPkColumnsInput: domainUserCategoryPkColumnsInput;
  domainUserCategorySetInput: domainUserCategorySetInput;
  domainUserCategoryStreamCursorInput: domainUserCategoryStreamCursorInput;
  domainUserCategoryStreamCursorValueInput: domainUserCategoryStreamCursorValueInput;
  domainUserCategoryUpdates: domainUserCategoryUpdates;
  domainUserIncInput: domainUserIncInput;
  domainUserInsertInput: domainUserInsertInput;
  domainUserMaxFields: domainUserMaxFields;
  domainUserMaxOrderBy: domainUserMaxOrderBy;
  domainUserMinFields: domainUserMinFields;
  domainUserMinOrderBy: domainUserMinOrderBy;
  domainUserMutationResponse: domainUserMutationResponse;
  domainUserObjRelInsertInput: domainUserObjRelInsertInput;
  domainUserOnConflict: domainUserOnConflict;
  domainUserOrderBy: domainUserOrderBy;
  domainUserPkColumnsInput: domainUserPkColumnsInput;
  domainUserSetInput: domainUserSetInput;
  domainUserStddevFields: domainUserStddevFields;
  domainUserStddevOrderBy: domainUserStddevOrderBy;
  domainUserStddevPopFields: domainUserStddevPopFields;
  domainUserStddevPopOrderBy: domainUserStddevPopOrderBy;
  domainUserStddevSampFields: domainUserStddevSampFields;
  domainUserStddevSampOrderBy: domainUserStddevSampOrderBy;
  domainUserStreamCursorInput: domainUserStreamCursorInput;
  domainUserStreamCursorValueInput: domainUserStreamCursorValueInput;
  domainUserSumFields: domainUserSumFields;
  domainUserSumOrderBy: domainUserSumOrderBy;
  domainUserUpdates: domainUserUpdates;
  domainUserVarPopFields: domainUserVarPopFields;
  domainUserVarPopOrderBy: domainUserVarPopOrderBy;
  domainUserVarSampFields: domainUserVarSampFields;
  domainUserVarSampOrderBy: domainUserVarSampOrderBy;
  domainUserVarianceFields: domainUserVarianceFields;
  domainUserVarianceOrderBy: domainUserVarianceOrderBy;
  emailDomainUserOutput: emailDomainUserOutput;
  emailingmutation_root: emailingmutation_root;
  emailingquery_root: emailingquery_root;
  emailingsubscription_root: emailingsubscription_root;
  fileOutput: fileOutput;
  geodatamutation_root: geodatamutation_root;
  geodataquery_root: geodataquery_root;
  geodatasubscription_root: geodatasubscription_root;
  getEmailAccountInput: getEmailAccountInput;
  getEmailAccountOutput: getEmailAccountOutput;
  incomingSms: incomingSms;
  inviteObject: inviteObject;
  inviteOutput: inviteOutput;
  json: Scalars['json']['output'];
  jsonb: Scalars['jsonb']['output'];
  languages: languages;
  languagesAggregate: languagesAggregate;
  languagesAggregateFields: languagesAggregateFields;
  languagesBoolExp: languagesBoolExp;
  languagesInsertInput: languagesInsertInput;
  languagesMaxFields: languagesMaxFields;
  languagesMinFields: languagesMinFields;
  languagesMutationResponse: languagesMutationResponse;
  languagesObjRelInsertInput: languagesObjRelInsertInput;
  languagesOnConflict: languagesOnConflict;
  languagesOrderBy: languagesOrderBy;
  languagesPkColumnsInput: languagesPkColumnsInput;
  languagesSetInput: languagesSetInput;
  languagesStreamCursorInput: languagesStreamCursorInput;
  languagesStreamCursorValueInput: languagesStreamCursorValueInput;
  languagesUpdates: languagesUpdates;
  leaveOrganizationObject: leaveOrganizationObject;
  leaveOrganizationOutput: leaveOrganizationOutput;
  message: message;
  messageAggregate: messageAggregate;
  messageAggregateBoolExp: messageAggregateBoolExp;
  messageAggregateBoolExpBool_and: messageAggregateBoolExpBool_and;
  messageAggregateBoolExpBool_or: messageAggregateBoolExpBool_or;
  messageAggregateBoolExpCount: messageAggregateBoolExpCount;
  messageAggregateFields: messageAggregateFields;
  messageAggregateOrderBy: messageAggregateOrderBy;
  messageArrRelInsertInput: messageArrRelInsertInput;
  messageBoolExp: messageBoolExp;
  messageInsertInput: messageInsertInput;
  messageMaxFields: messageMaxFields;
  messageMaxOrderBy: messageMaxOrderBy;
  messageMinFields: messageMinFields;
  messageMinOrderBy: messageMinOrderBy;
  messageMutationResponse: messageMutationResponse;
  messageOnConflict: messageOnConflict;
  messageOrderBy: messageOrderBy;
  messagePkColumnsInput: messagePkColumnsInput;
  messageSetInput: messageSetInput;
  messageStreamCursorInput: messageStreamCursorInput;
  messageStreamCursorValueInput: messageStreamCursorValueInput;
  messageType: messageType;
  messageTypeAggregate: messageTypeAggregate;
  messageTypeAggregateFields: messageTypeAggregateFields;
  messageTypeBoolExp: messageTypeBoolExp;
  messageTypeInsertInput: messageTypeInsertInput;
  messageTypeMaxFields: messageTypeMaxFields;
  messageTypeMinFields: messageTypeMinFields;
  messageTypeMutationResponse: messageTypeMutationResponse;
  messageTypeObjRelInsertInput: messageTypeObjRelInsertInput;
  messageTypeOnConflict: messageTypeOnConflict;
  messageTypeOrderBy: messageTypeOrderBy;
  messageTypePkColumnsInput: messageTypePkColumnsInput;
  messageTypeSetInput: messageTypeSetInput;
  messageTypeStreamCursorInput: messageTypeStreamCursorInput;
  messageTypeStreamCursorValueInput: messageTypeStreamCursorValueInput;
  messageTypeUpdates: messageTypeUpdates;
  messageUpdates: messageUpdates;
  messagingActivity: messagingActivity;
  messagingActivityAggregate: messagingActivityAggregate;
  messagingActivityAggregateFields: messagingActivityAggregateFields;
  messagingActivityBoolExp: messagingActivityBoolExp;
  messagingActivityInsertInput: messagingActivityInsertInput;
  messagingActivityMaxFields: messagingActivityMaxFields;
  messagingActivityMinFields: messagingActivityMinFields;
  messagingActivityMutationResponse: messagingActivityMutationResponse;
  messagingActivityObjRelInsertInput: messagingActivityObjRelInsertInput;
  messagingActivityOnConflict: messagingActivityOnConflict;
  messagingActivityOrderBy: messagingActivityOrderBy;
  messagingActivityOrganization: messagingActivityOrganization;
  messagingActivityOrganizationAggregate: messagingActivityOrganizationAggregate;
  messagingActivityOrganizationAggregateBoolExp: messagingActivityOrganizationAggregateBoolExp;
  messagingActivityOrganizationAggregateBoolExpCount: messagingActivityOrganizationAggregateBoolExpCount;
  messagingActivityOrganizationAggregateFields: messagingActivityOrganizationAggregateFields;
  messagingActivityOrganizationAggregateOrderBy: messagingActivityOrganizationAggregateOrderBy;
  messagingActivityOrganizationArrRelInsertInput: messagingActivityOrganizationArrRelInsertInput;
  messagingActivityOrganizationBoolExp: messagingActivityOrganizationBoolExp;
  messagingActivityOrganizationInsertInput: messagingActivityOrganizationInsertInput;
  messagingActivityOrganizationMaxFields: messagingActivityOrganizationMaxFields;
  messagingActivityOrganizationMaxOrderBy: messagingActivityOrganizationMaxOrderBy;
  messagingActivityOrganizationMinFields: messagingActivityOrganizationMinFields;
  messagingActivityOrganizationMinOrderBy: messagingActivityOrganizationMinOrderBy;
  messagingActivityOrganizationMutationResponse: messagingActivityOrganizationMutationResponse;
  messagingActivityOrganizationOnConflict: messagingActivityOrganizationOnConflict;
  messagingActivityOrganizationOrderBy: messagingActivityOrganizationOrderBy;
  messagingActivityOrganizationPkColumnsInput: messagingActivityOrganizationPkColumnsInput;
  messagingActivityOrganizationSetInput: messagingActivityOrganizationSetInput;
  messagingActivityOrganizationStreamCursorInput: messagingActivityOrganizationStreamCursorInput;
  messagingActivityOrganizationStreamCursorValueInput: messagingActivityOrganizationStreamCursorValueInput;
  messagingActivityOrganizationUpdates: messagingActivityOrganizationUpdates;
  messagingActivityPkColumnsInput: messagingActivityPkColumnsInput;
  messagingActivitySetInput: messagingActivitySetInput;
  messagingActivityStreamCursorInput: messagingActivityStreamCursorInput;
  messagingActivityStreamCursorValueInput: messagingActivityStreamCursorValueInput;
  messagingActivityType: messagingActivityType;
  messagingActivityTypeAggregate: messagingActivityTypeAggregate;
  messagingActivityTypeAggregateFields: messagingActivityTypeAggregateFields;
  messagingActivityTypeBoolExp: messagingActivityTypeBoolExp;
  messagingActivityTypeInsertInput: messagingActivityTypeInsertInput;
  messagingActivityTypeMaxFields: messagingActivityTypeMaxFields;
  messagingActivityTypeMinFields: messagingActivityTypeMinFields;
  messagingActivityTypeMutationResponse: messagingActivityTypeMutationResponse;
  messagingActivityTypeOnConflict: messagingActivityTypeOnConflict;
  messagingActivityTypeOrderBy: messagingActivityTypeOrderBy;
  messagingActivityTypePkColumnsInput: messagingActivityTypePkColumnsInput;
  messagingActivityTypeSetInput: messagingActivityTypeSetInput;
  messagingActivityTypeStreamCursorInput: messagingActivityTypeStreamCursorInput;
  messagingActivityTypeStreamCursorValueInput: messagingActivityTypeStreamCursorValueInput;
  messagingActivityTypeUpdates: messagingActivityTypeUpdates;
  messagingActivityUpdates: messagingActivityUpdates;
  messagingActivityUser: messagingActivityUser;
  messagingActivityUserAggregate: messagingActivityUserAggregate;
  messagingActivityUserAggregateBoolExp: messagingActivityUserAggregateBoolExp;
  messagingActivityUserAggregateBoolExpCount: messagingActivityUserAggregateBoolExpCount;
  messagingActivityUserAggregateFields: messagingActivityUserAggregateFields;
  messagingActivityUserAggregateOrderBy: messagingActivityUserAggregateOrderBy;
  messagingActivityUserArrRelInsertInput: messagingActivityUserArrRelInsertInput;
  messagingActivityUserAvgFields: messagingActivityUserAvgFields;
  messagingActivityUserAvgOrderBy: messagingActivityUserAvgOrderBy;
  messagingActivityUserBoolExp: messagingActivityUserBoolExp;
  messagingActivityUserIncInput: messagingActivityUserIncInput;
  messagingActivityUserInsertInput: messagingActivityUserInsertInput;
  messagingActivityUserMaxFields: messagingActivityUserMaxFields;
  messagingActivityUserMaxOrderBy: messagingActivityUserMaxOrderBy;
  messagingActivityUserMinFields: messagingActivityUserMinFields;
  messagingActivityUserMinOrderBy: messagingActivityUserMinOrderBy;
  messagingActivityUserMutationResponse: messagingActivityUserMutationResponse;
  messagingActivityUserOnConflict: messagingActivityUserOnConflict;
  messagingActivityUserOrderBy: messagingActivityUserOrderBy;
  messagingActivityUserPkColumnsInput: messagingActivityUserPkColumnsInput;
  messagingActivityUserSetInput: messagingActivityUserSetInput;
  messagingActivityUserStddevFields: messagingActivityUserStddevFields;
  messagingActivityUserStddevOrderBy: messagingActivityUserStddevOrderBy;
  messagingActivityUserStddevPopFields: messagingActivityUserStddevPopFields;
  messagingActivityUserStddevPopOrderBy: messagingActivityUserStddevPopOrderBy;
  messagingActivityUserStddevSampFields: messagingActivityUserStddevSampFields;
  messagingActivityUserStddevSampOrderBy: messagingActivityUserStddevSampOrderBy;
  messagingActivityUserStreamCursorInput: messagingActivityUserStreamCursorInput;
  messagingActivityUserStreamCursorValueInput: messagingActivityUserStreamCursorValueInput;
  messagingActivityUserSumFields: messagingActivityUserSumFields;
  messagingActivityUserSumOrderBy: messagingActivityUserSumOrderBy;
  messagingActivityUserUpdates: messagingActivityUserUpdates;
  messagingActivityUserVarPopFields: messagingActivityUserVarPopFields;
  messagingActivityUserVarPopOrderBy: messagingActivityUserVarPopOrderBy;
  messagingActivityUserVarSampFields: messagingActivityUserVarSampFields;
  messagingActivityUserVarSampOrderBy: messagingActivityUserVarSampOrderBy;
  messagingActivityUserVarianceFields: messagingActivityUserVarianceFields;
  messagingActivityUserVarianceOrderBy: messagingActivityUserVarianceOrderBy;
  messagingInvitationAggregateBoolExpBool_and: messagingInvitationAggregateBoolExpBool_and;
  messagingInvitationAggregateBoolExpBool_or: messagingInvitationAggregateBoolExpBool_or;
  messagingInvitationAggregateBoolExpCount: messagingInvitationAggregateBoolExpCount;
  messagingMentionsAggregateBoolExpCount: messagingMentionsAggregateBoolExpCount;
  messagingMessage: messagingMessage;
  messagingMessageAggregate: messagingMessageAggregate;
  messagingMessageAggregateBoolExp: messagingMessageAggregateBoolExp;
  messagingMessageAggregateBoolExpBool_and: messagingMessageAggregateBoolExpBool_and;
  messagingMessageAggregateBoolExpBool_or: messagingMessageAggregateBoolExpBool_or;
  messagingMessageAggregateBoolExpCount: messagingMessageAggregateBoolExpCount;
  messagingMessageAggregateFields: messagingMessageAggregateFields;
  messagingMessageAggregateOrderBy: messagingMessageAggregateOrderBy;
  messagingMessageArrRelInsertInput: messagingMessageArrRelInsertInput;
  messagingMessageAttachmentAggregateBoolExpCount: messagingMessageAttachmentAggregateBoolExpCount;
  messagingMessageBoolExp: messagingMessageBoolExp;
  messagingMessageEmoji: messagingMessageEmoji;
  messagingMessageEmojiAggregate: messagingMessageEmojiAggregate;
  messagingMessageEmojiAggregateBoolExp: messagingMessageEmojiAggregateBoolExp;
  messagingMessageEmojiAggregateBoolExpCount: messagingMessageEmojiAggregateBoolExpCount;
  messagingMessageEmojiAggregateFields: messagingMessageEmojiAggregateFields;
  messagingMessageEmojiAggregateOrderBy: messagingMessageEmojiAggregateOrderBy;
  messagingMessageEmojiArrRelInsertInput: messagingMessageEmojiArrRelInsertInput;
  messagingMessageEmojiBoolExp: messagingMessageEmojiBoolExp;
  messagingMessageEmojiInsertInput: messagingMessageEmojiInsertInput;
  messagingMessageEmojiMaxFields: messagingMessageEmojiMaxFields;
  messagingMessageEmojiMaxOrderBy: messagingMessageEmojiMaxOrderBy;
  messagingMessageEmojiMinFields: messagingMessageEmojiMinFields;
  messagingMessageEmojiMinOrderBy: messagingMessageEmojiMinOrderBy;
  messagingMessageEmojiMutationResponse: messagingMessageEmojiMutationResponse;
  messagingMessageEmojiOnConflict: messagingMessageEmojiOnConflict;
  messagingMessageEmojiOrderBy: messagingMessageEmojiOrderBy;
  messagingMessageEmojiPkColumnsInput: messagingMessageEmojiPkColumnsInput;
  messagingMessageEmojiSetInput: messagingMessageEmojiSetInput;
  messagingMessageEmojiStreamCursorInput: messagingMessageEmojiStreamCursorInput;
  messagingMessageEmojiStreamCursorValueInput: messagingMessageEmojiStreamCursorValueInput;
  messagingMessageEmojiUpdates: messagingMessageEmojiUpdates;
  messagingMessageInsertInput: messagingMessageInsertInput;
  messagingMessageMaxFields: messagingMessageMaxFields;
  messagingMessageMaxOrderBy: messagingMessageMaxOrderBy;
  messagingMessageMinFields: messagingMessageMinFields;
  messagingMessageMinOrderBy: messagingMessageMinOrderBy;
  messagingMessageMutationResponse: messagingMessageMutationResponse;
  messagingMessageObjRelInsertInput: messagingMessageObjRelInsertInput;
  messagingMessageOnConflict: messagingMessageOnConflict;
  messagingMessageOrderBy: messagingMessageOrderBy;
  messagingMessagePkColumnsInput: messagingMessagePkColumnsInput;
  messagingMessageRead: messagingMessageRead;
  messagingMessageReadAggregate: messagingMessageReadAggregate;
  messagingMessageReadAggregateBoolExp: messagingMessageReadAggregateBoolExp;
  messagingMessageReadAggregateBoolExpBool_and: messagingMessageReadAggregateBoolExpBool_and;
  messagingMessageReadAggregateBoolExpBool_or: messagingMessageReadAggregateBoolExpBool_or;
  messagingMessageReadAggregateBoolExpCount: messagingMessageReadAggregateBoolExpCount;
  messagingMessageReadAggregateFields: messagingMessageReadAggregateFields;
  messagingMessageReadAggregateOrderBy: messagingMessageReadAggregateOrderBy;
  messagingMessageReadArrRelInsertInput: messagingMessageReadArrRelInsertInput;
  messagingMessageReadBoolExp: messagingMessageReadBoolExp;
  messagingMessageReadInsertInput: messagingMessageReadInsertInput;
  messagingMessageReadMaxFields: messagingMessageReadMaxFields;
  messagingMessageReadMaxOrderBy: messagingMessageReadMaxOrderBy;
  messagingMessageReadMinFields: messagingMessageReadMinFields;
  messagingMessageReadMinOrderBy: messagingMessageReadMinOrderBy;
  messagingMessageReadMutationResponse: messagingMessageReadMutationResponse;
  messagingMessageReadOnConflict: messagingMessageReadOnConflict;
  messagingMessageReadOrderBy: messagingMessageReadOrderBy;
  messagingMessageReadPkColumnsInput: messagingMessageReadPkColumnsInput;
  messagingMessageReadSetInput: messagingMessageReadSetInput;
  messagingMessageReadStreamCursorInput: messagingMessageReadStreamCursorInput;
  messagingMessageReadStreamCursorValueInput: messagingMessageReadStreamCursorValueInput;
  messagingMessageReadUpdates: messagingMessageReadUpdates;
  messagingMessageSetInput: messagingMessageSetInput;
  messagingMessageStreamCursorInput: messagingMessageStreamCursorInput;
  messagingMessageStreamCursorValueInput: messagingMessageStreamCursorValueInput;
  messagingMessageType: messagingMessageType;
  messagingMessageTypeAggregate: messagingMessageTypeAggregate;
  messagingMessageTypeAggregateFields: messagingMessageTypeAggregateFields;
  messagingMessageTypeBoolExp: messagingMessageTypeBoolExp;
  messagingMessageTypeInsertInput: messagingMessageTypeInsertInput;
  messagingMessageTypeMaxFields: messagingMessageTypeMaxFields;
  messagingMessageTypeMinFields: messagingMessageTypeMinFields;
  messagingMessageTypeMutationResponse: messagingMessageTypeMutationResponse;
  messagingMessageTypeOnConflict: messagingMessageTypeOnConflict;
  messagingMessageTypeOrderBy: messagingMessageTypeOrderBy;
  messagingMessageTypePkColumnsInput: messagingMessageTypePkColumnsInput;
  messagingMessageTypeSetInput: messagingMessageTypeSetInput;
  messagingMessageTypeStreamCursorInput: messagingMessageTypeStreamCursorInput;
  messagingMessageTypeStreamCursorValueInput: messagingMessageTypeStreamCursorValueInput;
  messagingMessageTypeUpdates: messagingMessageTypeUpdates;
  messagingMessageUpdates: messagingMessageUpdates;
  mutation_root: {};
  notification: notification;
  notificationAggregate: notificationAggregate;
  notificationAggregateFields: notificationAggregateFields;
  notificationBoolExp: notificationBoolExp;
  notificationInsertInput: notificationInsertInput;
  notificationMaxFields: notificationMaxFields;
  notificationMinFields: notificationMinFields;
  notificationMutationResponse: notificationMutationResponse;
  notificationOnConflict: notificationOnConflict;
  notificationOrderBy: notificationOrderBy;
  notificationPkColumnsInput: notificationPkColumnsInput;
  notificationSend: notificationSend;
  notificationSendAggregate: notificationSendAggregate;
  notificationSendAggregateFields: notificationSendAggregateFields;
  notificationSendBoolExp: notificationSendBoolExp;
  notificationSendInsertInput: notificationSendInsertInput;
  notificationSendMaxFields: notificationSendMaxFields;
  notificationSendMinFields: notificationSendMinFields;
  notificationSendMutationResponse: notificationSendMutationResponse;
  notificationSendObjRelInsertInput: notificationSendObjRelInsertInput;
  notificationSendOnConflict: notificationSendOnConflict;
  notificationSendOrderBy: notificationSendOrderBy;
  notificationSendPkColumnsInput: notificationSendPkColumnsInput;
  notificationSendSetInput: notificationSendSetInput;
  notificationSendStreamCursorInput: notificationSendStreamCursorInput;
  notificationSendStreamCursorValueInput: notificationSendStreamCursorValueInput;
  notificationSendUpdates: notificationSendUpdates;
  notificationSetInput: notificationSetInput;
  notificationSettingActivity: notificationSettingActivity;
  notificationSettingActivityAggregate: notificationSettingActivityAggregate;
  notificationSettingActivityAggregateFields: notificationSettingActivityAggregateFields;
  notificationSettingActivityBoolExp: notificationSettingActivityBoolExp;
  notificationSettingActivityInsertInput: notificationSettingActivityInsertInput;
  notificationSettingActivityMaxFields: notificationSettingActivityMaxFields;
  notificationSettingActivityMinFields: notificationSettingActivityMinFields;
  notificationSettingActivityMutationResponse: notificationSettingActivityMutationResponse;
  notificationSettingActivityOnConflict: notificationSettingActivityOnConflict;
  notificationSettingActivityOrderBy: notificationSettingActivityOrderBy;
  notificationSettingActivityPkColumnsInput: notificationSettingActivityPkColumnsInput;
  notificationSettingActivitySetInput: notificationSettingActivitySetInput;
  notificationSettingActivityStreamCursorInput: notificationSettingActivityStreamCursorInput;
  notificationSettingActivityStreamCursorValueInput: notificationSettingActivityStreamCursorValueInput;
  notificationSettingActivityUpdates: notificationSettingActivityUpdates;
  notificationStreamCursorInput: notificationStreamCursorInput;
  notificationStreamCursorValueInput: notificationStreamCursorValueInput;
  notificationUpdates: notificationUpdates;
  notificationUser: notificationUser;
  notificationUserAggregate: notificationUserAggregate;
  notificationUserAggregateFields: notificationUserAggregateFields;
  notificationUserBoolExp: notificationUserBoolExp;
  notificationUserDevice: notificationUserDevice;
  notificationUserDeviceAggregate: notificationUserDeviceAggregate;
  notificationUserDeviceAggregateBoolExp: notificationUserDeviceAggregateBoolExp;
  notificationUserDeviceAggregateBoolExpBool_and: notificationUserDeviceAggregateBoolExpBool_and;
  notificationUserDeviceAggregateBoolExpBool_or: notificationUserDeviceAggregateBoolExpBool_or;
  notificationUserDeviceAggregateBoolExpCount: notificationUserDeviceAggregateBoolExpCount;
  notificationUserDeviceAggregateFields: notificationUserDeviceAggregateFields;
  notificationUserDeviceAggregateOrderBy: notificationUserDeviceAggregateOrderBy;
  notificationUserDeviceArrRelInsertInput: notificationUserDeviceArrRelInsertInput;
  notificationUserDeviceAvgFields: notificationUserDeviceAvgFields;
  notificationUserDeviceAvgOrderBy: notificationUserDeviceAvgOrderBy;
  notificationUserDeviceBoolExp: notificationUserDeviceBoolExp;
  notificationUserDeviceIncInput: notificationUserDeviceIncInput;
  notificationUserDeviceInsertInput: notificationUserDeviceInsertInput;
  notificationUserDeviceMaxFields: notificationUserDeviceMaxFields;
  notificationUserDeviceMaxOrderBy: notificationUserDeviceMaxOrderBy;
  notificationUserDeviceMinFields: notificationUserDeviceMinFields;
  notificationUserDeviceMinOrderBy: notificationUserDeviceMinOrderBy;
  notificationUserDeviceMutationResponse: notificationUserDeviceMutationResponse;
  notificationUserDeviceObjRelInsertInput: notificationUserDeviceObjRelInsertInput;
  notificationUserDeviceOnConflict: notificationUserDeviceOnConflict;
  notificationUserDeviceOrderBy: notificationUserDeviceOrderBy;
  notificationUserDevicePkColumnsInput: notificationUserDevicePkColumnsInput;
  notificationUserDeviceSetInput: notificationUserDeviceSetInput;
  notificationUserDeviceStddevFields: notificationUserDeviceStddevFields;
  notificationUserDeviceStddevOrderBy: notificationUserDeviceStddevOrderBy;
  notificationUserDeviceStddevPopFields: notificationUserDeviceStddevPopFields;
  notificationUserDeviceStddevPopOrderBy: notificationUserDeviceStddevPopOrderBy;
  notificationUserDeviceStddevSampFields: notificationUserDeviceStddevSampFields;
  notificationUserDeviceStddevSampOrderBy: notificationUserDeviceStddevSampOrderBy;
  notificationUserDeviceStreamCursorInput: notificationUserDeviceStreamCursorInput;
  notificationUserDeviceStreamCursorValueInput: notificationUserDeviceStreamCursorValueInput;
  notificationUserDeviceSumFields: notificationUserDeviceSumFields;
  notificationUserDeviceSumOrderBy: notificationUserDeviceSumOrderBy;
  notificationUserDeviceUpdates: notificationUserDeviceUpdates;
  notificationUserDeviceVarPopFields: notificationUserDeviceVarPopFields;
  notificationUserDeviceVarPopOrderBy: notificationUserDeviceVarPopOrderBy;
  notificationUserDeviceVarSampFields: notificationUserDeviceVarSampFields;
  notificationUserDeviceVarSampOrderBy: notificationUserDeviceVarSampOrderBy;
  notificationUserDeviceVarianceFields: notificationUserDeviceVarianceFields;
  notificationUserDeviceVarianceOrderBy: notificationUserDeviceVarianceOrderBy;
  notificationUserInsertInput: notificationUserInsertInput;
  notificationUserMaxFields: notificationUserMaxFields;
  notificationUserMinFields: notificationUserMinFields;
  notificationUserMutationResponse: notificationUserMutationResponse;
  notificationUserOnConflict: notificationUserOnConflict;
  notificationUserOrderBy: notificationUserOrderBy;
  notificationUserPkColumnsInput: notificationUserPkColumnsInput;
  notificationUserSetInput: notificationUserSetInput;
  notificationUserStreamCursorInput: notificationUserStreamCursorInput;
  notificationUserStreamCursorValueInput: notificationUserStreamCursorValueInput;
  notificationUserUpdates: notificationUserUpdates;
  numeric: Scalars['numeric']['output'];
  ordersIntegrations: ordersIntegrations;
  ordersIntegrationsAggregate: ordersIntegrationsAggregate;
  ordersIntegrationsAggregateBoolExp: ordersIntegrationsAggregateBoolExp;
  ordersIntegrationsAggregateBoolExpBool_and: ordersIntegrationsAggregateBoolExpBool_and;
  ordersIntegrationsAggregateBoolExpBool_or: ordersIntegrationsAggregateBoolExpBool_or;
  ordersIntegrationsAggregateBoolExpCount: ordersIntegrationsAggregateBoolExpCount;
  ordersIntegrationsAggregateFields: ordersIntegrationsAggregateFields;
  ordersIntegrationsAggregateOrderBy: ordersIntegrationsAggregateOrderBy;
  ordersIntegrationsArrRelInsertInput: ordersIntegrationsArrRelInsertInput;
  ordersIntegrationsAvgFields: ordersIntegrationsAvgFields;
  ordersIntegrationsAvgOrderBy: ordersIntegrationsAvgOrderBy;
  ordersIntegrationsBoolExp: ordersIntegrationsBoolExp;
  ordersIntegrationsIncInput: ordersIntegrationsIncInput;
  ordersIntegrationsInsertInput: ordersIntegrationsInsertInput;
  ordersIntegrationsMaxFields: ordersIntegrationsMaxFields;
  ordersIntegrationsMaxOrderBy: ordersIntegrationsMaxOrderBy;
  ordersIntegrationsMinFields: ordersIntegrationsMinFields;
  ordersIntegrationsMinOrderBy: ordersIntegrationsMinOrderBy;
  ordersIntegrationsMutationResponse: ordersIntegrationsMutationResponse;
  ordersIntegrationsObjRelInsertInput: ordersIntegrationsObjRelInsertInput;
  ordersIntegrationsOnConflict: ordersIntegrationsOnConflict;
  ordersIntegrationsOrderBy: ordersIntegrationsOrderBy;
  ordersIntegrationsPkColumnsInput: ordersIntegrationsPkColumnsInput;
  ordersIntegrationsSetInput: ordersIntegrationsSetInput;
  ordersIntegrationsStddevFields: ordersIntegrationsStddevFields;
  ordersIntegrationsStddevOrderBy: ordersIntegrationsStddevOrderBy;
  ordersIntegrationsStddevPopFields: ordersIntegrationsStddevPopFields;
  ordersIntegrationsStddevPopOrderBy: ordersIntegrationsStddevPopOrderBy;
  ordersIntegrationsStddevSampFields: ordersIntegrationsStddevSampFields;
  ordersIntegrationsStddevSampOrderBy: ordersIntegrationsStddevSampOrderBy;
  ordersIntegrationsStreamCursorInput: ordersIntegrationsStreamCursorInput;
  ordersIntegrationsStreamCursorValueInput: ordersIntegrationsStreamCursorValueInput;
  ordersIntegrationsSumFields: ordersIntegrationsSumFields;
  ordersIntegrationsSumOrderBy: ordersIntegrationsSumOrderBy;
  ordersIntegrationsUpdates: ordersIntegrationsUpdates;
  ordersIntegrationsVarPopFields: ordersIntegrationsVarPopFields;
  ordersIntegrationsVarPopOrderBy: ordersIntegrationsVarPopOrderBy;
  ordersIntegrationsVarSampFields: ordersIntegrationsVarSampFields;
  ordersIntegrationsVarSampOrderBy: ordersIntegrationsVarSampOrderBy;
  ordersIntegrationsVarianceFields: ordersIntegrationsVarianceFields;
  ordersIntegrationsVarianceOrderBy: ordersIntegrationsVarianceOrderBy;
  orgAccessRequestInput: orgAccessRequestInput;
  orgAccessRequestOutput: orgAccessRequestOutput;
  organization: organization;
  organizationAggregate: organizationAggregate;
  organizationAggregateBoolExp: organizationAggregateBoolExp;
  organizationAggregateBoolExpBool_and: organizationAggregateBoolExpBool_and;
  organizationAggregateBoolExpBool_or: organizationAggregateBoolExpBool_or;
  organizationAggregateBoolExpCount: organizationAggregateBoolExpCount;
  organizationAggregateFields: organizationAggregateFields;
  organizationAggregateOrderBy: organizationAggregateOrderBy;
  organizationArrRelInsertInput: organizationArrRelInsertInput;
  organizationAuthorizationEnumGroup: organizationAuthorizationEnumGroup;
  organizationAuthorizationEnumGroupAggregate: organizationAuthorizationEnumGroupAggregate;
  organizationAuthorizationEnumGroupAggregateBoolExp: organizationAuthorizationEnumGroupAggregateBoolExp;
  organizationAuthorizationEnumGroupAggregateBoolExpCount: organizationAuthorizationEnumGroupAggregateBoolExpCount;
  organizationAuthorizationEnumGroupAggregateFields: organizationAuthorizationEnumGroupAggregateFields;
  organizationAuthorizationEnumGroupAggregateOrderBy: organizationAuthorizationEnumGroupAggregateOrderBy;
  organizationAuthorizationEnumGroupArrRelInsertInput: organizationAuthorizationEnumGroupArrRelInsertInput;
  organizationAuthorizationEnumGroupBoolExp: organizationAuthorizationEnumGroupBoolExp;
  organizationAuthorizationEnumGroupInsertInput: organizationAuthorizationEnumGroupInsertInput;
  organizationAuthorizationEnumGroupMaxFields: organizationAuthorizationEnumGroupMaxFields;
  organizationAuthorizationEnumGroupMaxOrderBy: organizationAuthorizationEnumGroupMaxOrderBy;
  organizationAuthorizationEnumGroupMinFields: organizationAuthorizationEnumGroupMinFields;
  organizationAuthorizationEnumGroupMinOrderBy: organizationAuthorizationEnumGroupMinOrderBy;
  organizationAuthorizationEnumGroupMutationResponse: organizationAuthorizationEnumGroupMutationResponse;
  organizationAuthorizationEnumGroupOnConflict: organizationAuthorizationEnumGroupOnConflict;
  organizationAuthorizationEnumGroupOrderBy: organizationAuthorizationEnumGroupOrderBy;
  organizationAuthorizationEnumGroupPkColumnsInput: organizationAuthorizationEnumGroupPkColumnsInput;
  organizationAuthorizationEnumGroupSetInput: organizationAuthorizationEnumGroupSetInput;
  organizationAuthorizationEnumGroupStreamCursorInput: organizationAuthorizationEnumGroupStreamCursorInput;
  organizationAuthorizationEnumGroupStreamCursorValueInput: organizationAuthorizationEnumGroupStreamCursorValueInput;
  organizationAuthorizationEnumGroupUpdates: organizationAuthorizationEnumGroupUpdates;
  organizationAuthorizationGroup: organizationAuthorizationGroup;
  organizationAuthorizationGroupAggregate: organizationAuthorizationGroupAggregate;
  organizationAuthorizationGroupAggregateFields: organizationAuthorizationGroupAggregateFields;
  organizationAuthorizationGroupBoolExp: organizationAuthorizationGroupBoolExp;
  organizationAuthorizationGroupInsertInput: organizationAuthorizationGroupInsertInput;
  organizationAuthorizationGroupMaxFields: organizationAuthorizationGroupMaxFields;
  organizationAuthorizationGroupMinFields: organizationAuthorizationGroupMinFields;
  organizationAuthorizationGroupMutationResponse: organizationAuthorizationGroupMutationResponse;
  organizationAuthorizationGroupOnConflict: organizationAuthorizationGroupOnConflict;
  organizationAuthorizationGroupOrderBy: organizationAuthorizationGroupOrderBy;
  organizationAuthorizationGroupPkColumnsInput: organizationAuthorizationGroupPkColumnsInput;
  organizationAuthorizationGroupSetInput: organizationAuthorizationGroupSetInput;
  organizationAuthorizationGroupStreamCursorInput: organizationAuthorizationGroupStreamCursorInput;
  organizationAuthorizationGroupStreamCursorValueInput: organizationAuthorizationGroupStreamCursorValueInput;
  organizationAuthorizationGroupUpdates: organizationAuthorizationGroupUpdates;
  organizationAvgFields: organizationAvgFields;
  organizationAvgOrderBy: organizationAvgOrderBy;
  organizationBoolExp: organizationBoolExp;
  organizationIncInput: organizationIncInput;
  organizationInsertInput: organizationInsertInput;
  organizationMaxFields: organizationMaxFields;
  organizationMaxOrderBy: organizationMaxOrderBy;
  organizationMinFields: organizationMinFields;
  organizationMinOrderBy: organizationMinOrderBy;
  organizationMutationResponse: organizationMutationResponse;
  organizationObjRelInsertInput: organizationObjRelInsertInput;
  organizationOnConflict: organizationOnConflict;
  organizationOrderBy: organizationOrderBy;
  organizationOrganizationRelationship: organizationOrganizationRelationship;
  organizationOrganizationRelationshipAggregate: organizationOrganizationRelationshipAggregate;
  organizationOrganizationRelationshipAggregateFields: organizationOrganizationRelationshipAggregateFields;
  organizationOrganizationRelationshipBoolExp: organizationOrganizationRelationshipBoolExp;
  organizationOrganizationRelationshipCategory: organizationOrganizationRelationshipCategory;
  organizationOrganizationRelationshipCategoryAggregate: organizationOrganizationRelationshipCategoryAggregate;
  organizationOrganizationRelationshipCategoryAggregateFields: organizationOrganizationRelationshipCategoryAggregateFields;
  organizationOrganizationRelationshipCategoryBoolExp: organizationOrganizationRelationshipCategoryBoolExp;
  organizationOrganizationRelationshipCategoryInsertInput: organizationOrganizationRelationshipCategoryInsertInput;
  organizationOrganizationRelationshipCategoryMaxFields: organizationOrganizationRelationshipCategoryMaxFields;
  organizationOrganizationRelationshipCategoryMinFields: organizationOrganizationRelationshipCategoryMinFields;
  organizationOrganizationRelationshipCategoryMutationResponse: organizationOrganizationRelationshipCategoryMutationResponse;
  organizationOrganizationRelationshipCategoryOnConflict: organizationOrganizationRelationshipCategoryOnConflict;
  organizationOrganizationRelationshipCategoryOrderBy: organizationOrganizationRelationshipCategoryOrderBy;
  organizationOrganizationRelationshipCategoryPkColumnsInput: organizationOrganizationRelationshipCategoryPkColumnsInput;
  organizationOrganizationRelationshipCategorySetInput: organizationOrganizationRelationshipCategorySetInput;
  organizationOrganizationRelationshipCategoryStreamCursorInput: organizationOrganizationRelationshipCategoryStreamCursorInput;
  organizationOrganizationRelationshipCategoryStreamCursorValueInput: organizationOrganizationRelationshipCategoryStreamCursorValueInput;
  organizationOrganizationRelationshipCategoryUpdates: organizationOrganizationRelationshipCategoryUpdates;
  organizationOrganizationRelationshipInsertInput: organizationOrganizationRelationshipInsertInput;
  organizationOrganizationRelationshipMaxFields: organizationOrganizationRelationshipMaxFields;
  organizationOrganizationRelationshipMinFields: organizationOrganizationRelationshipMinFields;
  organizationOrganizationRelationshipMutationResponse: organizationOrganizationRelationshipMutationResponse;
  organizationOrganizationRelationshipOnConflict: organizationOrganizationRelationshipOnConflict;
  organizationOrganizationRelationshipOrderBy: organizationOrganizationRelationshipOrderBy;
  organizationOrganizationRelationshipPkColumnsInput: organizationOrganizationRelationshipPkColumnsInput;
  organizationOrganizationRelationshipSetInput: organizationOrganizationRelationshipSetInput;
  organizationOrganizationRelationshipStreamCursorInput: organizationOrganizationRelationshipStreamCursorInput;
  organizationOrganizationRelationshipStreamCursorValueInput: organizationOrganizationRelationshipStreamCursorValueInput;
  organizationOrganizationRelationshipUpdates: organizationOrganizationRelationshipUpdates;
  organizationOrganizationUserAuthorization: organizationOrganizationUserAuthorization;
  organizationOrganizationUserAuthorizationAggregate: organizationOrganizationUserAuthorizationAggregate;
  organizationOrganizationUserAuthorizationAggregateBoolExp: organizationOrganizationUserAuthorizationAggregateBoolExp;
  organizationOrganizationUserAuthorizationAggregateBoolExpCount: organizationOrganizationUserAuthorizationAggregateBoolExpCount;
  organizationOrganizationUserAuthorizationAggregateFields: organizationOrganizationUserAuthorizationAggregateFields;
  organizationOrganizationUserAuthorizationAggregateOrderBy: organizationOrganizationUserAuthorizationAggregateOrderBy;
  organizationOrganizationUserAuthorizationArrRelInsertInput: organizationOrganizationUserAuthorizationArrRelInsertInput;
  organizationOrganizationUserAuthorizationBoolExp: organizationOrganizationUserAuthorizationBoolExp;
  organizationOrganizationUserAuthorizationInsertInput: organizationOrganizationUserAuthorizationInsertInput;
  organizationOrganizationUserAuthorizationMaxFields: organizationOrganizationUserAuthorizationMaxFields;
  organizationOrganizationUserAuthorizationMaxOrderBy: organizationOrganizationUserAuthorizationMaxOrderBy;
  organizationOrganizationUserAuthorizationMinFields: organizationOrganizationUserAuthorizationMinFields;
  organizationOrganizationUserAuthorizationMinOrderBy: organizationOrganizationUserAuthorizationMinOrderBy;
  organizationOrganizationUserAuthorizationMutationResponse: organizationOrganizationUserAuthorizationMutationResponse;
  organizationOrganizationUserAuthorizationOnConflict: organizationOrganizationUserAuthorizationOnConflict;
  organizationOrganizationUserAuthorizationOrderBy: organizationOrganizationUserAuthorizationOrderBy;
  organizationOrganizationUserAuthorizationPkColumnsInput: organizationOrganizationUserAuthorizationPkColumnsInput;
  organizationOrganizationUserAuthorizationSetInput: organizationOrganizationUserAuthorizationSetInput;
  organizationOrganizationUserAuthorizationStreamCursorInput: organizationOrganizationUserAuthorizationStreamCursorInput;
  organizationOrganizationUserAuthorizationStreamCursorValueInput: organizationOrganizationUserAuthorizationStreamCursorValueInput;
  organizationOrganizationUserAuthorizationUpdates: organizationOrganizationUserAuthorizationUpdates;
  organizationOrganizationUserOrganizationsView: organizationOrganizationUserOrganizationsView;
  organizationOrganizationUserOrganizationsViewAggregate: organizationOrganizationUserOrganizationsViewAggregate;
  organizationOrganizationUserOrganizationsViewAggregateBoolExp: organizationOrganizationUserOrganizationsViewAggregateBoolExp;
  organizationOrganizationUserOrganizationsViewAggregateBoolExpBool_and: organizationOrganizationUserOrganizationsViewAggregateBoolExpBool_and;
  organizationOrganizationUserOrganizationsViewAggregateBoolExpBool_or: organizationOrganizationUserOrganizationsViewAggregateBoolExpBool_or;
  organizationOrganizationUserOrganizationsViewAggregateBoolExpCount: organizationOrganizationUserOrganizationsViewAggregateBoolExpCount;
  organizationOrganizationUserOrganizationsViewAggregateFields: organizationOrganizationUserOrganizationsViewAggregateFields;
  organizationOrganizationUserOrganizationsViewAggregateOrderBy: organizationOrganizationUserOrganizationsViewAggregateOrderBy;
  organizationOrganizationUserOrganizationsViewArrRelInsertInput: organizationOrganizationUserOrganizationsViewArrRelInsertInput;
  organizationOrganizationUserOrganizationsViewBoolExp: organizationOrganizationUserOrganizationsViewBoolExp;
  organizationOrganizationUserOrganizationsViewInsertInput: organizationOrganizationUserOrganizationsViewInsertInput;
  organizationOrganizationUserOrganizationsViewMaxFields: organizationOrganizationUserOrganizationsViewMaxFields;
  organizationOrganizationUserOrganizationsViewMaxOrderBy: organizationOrganizationUserOrganizationsViewMaxOrderBy;
  organizationOrganizationUserOrganizationsViewMinFields: organizationOrganizationUserOrganizationsViewMinFields;
  organizationOrganizationUserOrganizationsViewMinOrderBy: organizationOrganizationUserOrganizationsViewMinOrderBy;
  organizationOrganizationUserOrganizationsViewOrderBy: organizationOrganizationUserOrganizationsViewOrderBy;
  organizationOrganizationUserOrganizationsViewStreamCursorInput: organizationOrganizationUserOrganizationsViewStreamCursorInput;
  organizationOrganizationUserOrganizationsViewStreamCursorValueInput: organizationOrganizationUserOrganizationsViewStreamCursorValueInput;
  organizationOrganizationUserUsersView: organizationOrganizationUserUsersView;
  organizationOrganizationUserUsersViewAggregate: organizationOrganizationUserUsersViewAggregate;
  organizationOrganizationUserUsersViewAggregateBoolExp: organizationOrganizationUserUsersViewAggregateBoolExp;
  organizationOrganizationUserUsersViewAggregateBoolExpCount: organizationOrganizationUserUsersViewAggregateBoolExpCount;
  organizationOrganizationUserUsersViewAggregateFields: organizationOrganizationUserUsersViewAggregateFields;
  organizationOrganizationUserUsersViewAggregateOrderBy: organizationOrganizationUserUsersViewAggregateOrderBy;
  organizationOrganizationUserUsersViewArrRelInsertInput: organizationOrganizationUserUsersViewArrRelInsertInput;
  organizationOrganizationUserUsersViewBoolExp: organizationOrganizationUserUsersViewBoolExp;
  organizationOrganizationUserUsersViewInsertInput: organizationOrganizationUserUsersViewInsertInput;
  organizationOrganizationUserUsersViewMaxFields: organizationOrganizationUserUsersViewMaxFields;
  organizationOrganizationUserUsersViewMaxOrderBy: organizationOrganizationUserUsersViewMaxOrderBy;
  organizationOrganizationUserUsersViewMinFields: organizationOrganizationUserUsersViewMinFields;
  organizationOrganizationUserUsersViewMinOrderBy: organizationOrganizationUserUsersViewMinOrderBy;
  organizationOrganizationUserUsersViewObjRelInsertInput: organizationOrganizationUserUsersViewObjRelInsertInput;
  organizationOrganizationUserUsersViewOrderBy: organizationOrganizationUserUsersViewOrderBy;
  organizationOrganizationUserUsersViewStreamCursorInput: organizationOrganizationUserUsersViewStreamCursorInput;
  organizationOrganizationUserUsersViewStreamCursorValueInput: organizationOrganizationUserUsersViewStreamCursorValueInput;
  organizationPkColumnsInput: organizationPkColumnsInput;
  organizationSetInput: organizationSetInput;
  organizationStddevFields: organizationStddevFields;
  organizationStddevOrderBy: organizationStddevOrderBy;
  organizationStddevPopFields: organizationStddevPopFields;
  organizationStddevPopOrderBy: organizationStddevPopOrderBy;
  organizationStddevSampFields: organizationStddevSampFields;
  organizationStddevSampOrderBy: organizationStddevSampOrderBy;
  organizationStreamCursorInput: organizationStreamCursorInput;
  organizationStreamCursorValueInput: organizationStreamCursorValueInput;
  organizationSumFields: organizationSumFields;
  organizationSumOrderBy: organizationSumOrderBy;
  organizationUpdates: organizationUpdates;
  organizationUser: organizationUser;
  organizationUserAggregate: organizationUserAggregate;
  organizationUserAggregateBoolExp: organizationUserAggregateBoolExp;
  organizationUserAggregateBoolExpCount: organizationUserAggregateBoolExpCount;
  organizationUserAggregateFields: organizationUserAggregateFields;
  organizationUserAggregateOrderBy: organizationUserAggregateOrderBy;
  organizationUserAppendInput: organizationUserAppendInput;
  organizationUserArrRelInsertInput: organizationUserArrRelInsertInput;
  organizationUserAttachments: organizationUserAttachments;
  organizationUserAttachmentsAggregate: organizationUserAttachmentsAggregate;
  organizationUserAttachmentsAggregateBoolExp: organizationUserAttachmentsAggregateBoolExp;
  organizationUserAttachmentsAggregateBoolExpCount: organizationUserAttachmentsAggregateBoolExpCount;
  organizationUserAttachmentsAggregateFields: organizationUserAttachmentsAggregateFields;
  organizationUserAttachmentsAggregateOrderBy: organizationUserAttachmentsAggregateOrderBy;
  organizationUserAttachmentsArrRelInsertInput: organizationUserAttachmentsArrRelInsertInput;
  organizationUserAttachmentsBoolExp: organizationUserAttachmentsBoolExp;
  organizationUserAttachmentsInsertInput: organizationUserAttachmentsInsertInput;
  organizationUserAttachmentsMaxFields: organizationUserAttachmentsMaxFields;
  organizationUserAttachmentsMaxOrderBy: organizationUserAttachmentsMaxOrderBy;
  organizationUserAttachmentsMinFields: organizationUserAttachmentsMinFields;
  organizationUserAttachmentsMinOrderBy: organizationUserAttachmentsMinOrderBy;
  organizationUserAttachmentsMutationResponse: organizationUserAttachmentsMutationResponse;
  organizationUserAttachmentsOnConflict: organizationUserAttachmentsOnConflict;
  organizationUserAttachmentsOrderBy: organizationUserAttachmentsOrderBy;
  organizationUserAttachmentsPkColumnsInput: organizationUserAttachmentsPkColumnsInput;
  organizationUserAttachmentsSetInput: organizationUserAttachmentsSetInput;
  organizationUserAttachmentsStreamCursorInput: organizationUserAttachmentsStreamCursorInput;
  organizationUserAttachmentsStreamCursorValueInput: organizationUserAttachmentsStreamCursorValueInput;
  organizationUserAttachmentsUpdates: organizationUserAttachmentsUpdates;
  organizationUserAuthorization: organizationUserAuthorization;
  organizationUserAuthorizationAggregate: organizationUserAuthorizationAggregate;
  organizationUserAuthorizationAggregateFields: organizationUserAuthorizationAggregateFields;
  organizationUserAuthorizationBoolExp: organizationUserAuthorizationBoolExp;
  organizationUserAuthorizationInsertInput: organizationUserAuthorizationInsertInput;
  organizationUserAuthorizationMaxFields: organizationUserAuthorizationMaxFields;
  organizationUserAuthorizationMinFields: organizationUserAuthorizationMinFields;
  organizationUserAuthorizationMutationResponse: organizationUserAuthorizationMutationResponse;
  organizationUserAuthorizationObjRelInsertInput: organizationUserAuthorizationObjRelInsertInput;
  organizationUserAuthorizationOnConflict: organizationUserAuthorizationOnConflict;
  organizationUserAuthorizationOrderBy: organizationUserAuthorizationOrderBy;
  organizationUserAuthorizationPkColumnsInput: organizationUserAuthorizationPkColumnsInput;
  organizationUserAuthorizationSetInput: organizationUserAuthorizationSetInput;
  organizationUserAuthorizationStreamCursorInput: organizationUserAuthorizationStreamCursorInput;
  organizationUserAuthorizationStreamCursorValueInput: organizationUserAuthorizationStreamCursorValueInput;
  organizationUserAuthorizationUpdates: organizationUserAuthorizationUpdates;
  organizationUserBoolExp: organizationUserBoolExp;
  organizationUserDeleteAtPathInput: organizationUserDeleteAtPathInput;
  organizationUserDeleteElemInput: organizationUserDeleteElemInput;
  organizationUserDeleteKeyInput: organizationUserDeleteKeyInput;
  organizationUserDetail: organizationUserDetail;
  organizationUserDetailAggregate: organizationUserDetailAggregate;
  organizationUserDetailAggregateBoolExp: organizationUserDetailAggregateBoolExp;
  organizationUserDetailAggregateBoolExpCount: organizationUserDetailAggregateBoolExpCount;
  organizationUserDetailAggregateFields: organizationUserDetailAggregateFields;
  organizationUserDetailAggregateOrderBy: organizationUserDetailAggregateOrderBy;
  organizationUserDetailArrRelInsertInput: organizationUserDetailArrRelInsertInput;
  organizationUserDetailBoolExp: organizationUserDetailBoolExp;
  organizationUserDetailInsertInput: organizationUserDetailInsertInput;
  organizationUserDetailMaxFields: organizationUserDetailMaxFields;
  organizationUserDetailMaxOrderBy: organizationUserDetailMaxOrderBy;
  organizationUserDetailMinFields: organizationUserDetailMinFields;
  organizationUserDetailMinOrderBy: organizationUserDetailMinOrderBy;
  organizationUserDetailMutationResponse: organizationUserDetailMutationResponse;
  organizationUserDetailOnConflict: organizationUserDetailOnConflict;
  organizationUserDetailOrderBy: organizationUserDetailOrderBy;
  organizationUserDetailPkColumnsInput: organizationUserDetailPkColumnsInput;
  organizationUserDetailSetInput: organizationUserDetailSetInput;
  organizationUserDetailStreamCursorInput: organizationUserDetailStreamCursorInput;
  organizationUserDetailStreamCursorValueInput: organizationUserDetailStreamCursorValueInput;
  organizationUserDetailType: organizationUserDetailType;
  organizationUserDetailTypeAggregate: organizationUserDetailTypeAggregate;
  organizationUserDetailTypeAggregateFields: organizationUserDetailTypeAggregateFields;
  organizationUserDetailTypeBoolExp: organizationUserDetailTypeBoolExp;
  organizationUserDetailTypeInsertInput: organizationUserDetailTypeInsertInput;
  organizationUserDetailTypeMaxFields: organizationUserDetailTypeMaxFields;
  organizationUserDetailTypeMinFields: organizationUserDetailTypeMinFields;
  organizationUserDetailTypeMutationResponse: organizationUserDetailTypeMutationResponse;
  organizationUserDetailTypeObjRelInsertInput: organizationUserDetailTypeObjRelInsertInput;
  organizationUserDetailTypeOnConflict: organizationUserDetailTypeOnConflict;
  organizationUserDetailTypeOrderBy: organizationUserDetailTypeOrderBy;
  organizationUserDetailTypePkColumnsInput: organizationUserDetailTypePkColumnsInput;
  organizationUserDetailTypeSetInput: organizationUserDetailTypeSetInput;
  organizationUserDetailTypeStreamCursorInput: organizationUserDetailTypeStreamCursorInput;
  organizationUserDetailTypeStreamCursorValueInput: organizationUserDetailTypeStreamCursorValueInput;
  organizationUserDetailTypeUpdates: organizationUserDetailTypeUpdates;
  organizationUserDetailUpdates: organizationUserDetailUpdates;
  organizationUserInsertInput: organizationUserInsertInput;
  organizationUserInvite: organizationUserInvite;
  organizationUserInviteAggregate: organizationUserInviteAggregate;
  organizationUserInviteAggregateBoolExp: organizationUserInviteAggregateBoolExp;
  organizationUserInviteAggregateBoolExpCount: organizationUserInviteAggregateBoolExpCount;
  organizationUserInviteAggregateFields: organizationUserInviteAggregateFields;
  organizationUserInviteAggregateOrderBy: organizationUserInviteAggregateOrderBy;
  organizationUserInviteAppendInput: organizationUserInviteAppendInput;
  organizationUserInviteArrRelInsertInput: organizationUserInviteArrRelInsertInput;
  organizationUserInviteBoolExp: organizationUserInviteBoolExp;
  organizationUserInviteDeleteAtPathInput: organizationUserInviteDeleteAtPathInput;
  organizationUserInviteDeleteElemInput: organizationUserInviteDeleteElemInput;
  organizationUserInviteDeleteKeyInput: organizationUserInviteDeleteKeyInput;
  organizationUserInviteInsertInput: organizationUserInviteInsertInput;
  organizationUserInviteMaxFields: organizationUserInviteMaxFields;
  organizationUserInviteMaxOrderBy: organizationUserInviteMaxOrderBy;
  organizationUserInviteMinFields: organizationUserInviteMinFields;
  organizationUserInviteMinOrderBy: organizationUserInviteMinOrderBy;
  organizationUserInviteMutationResponse: organizationUserInviteMutationResponse;
  organizationUserInviteOnConflict: organizationUserInviteOnConflict;
  organizationUserInviteOrderBy: organizationUserInviteOrderBy;
  organizationUserInvitePkColumnsInput: organizationUserInvitePkColumnsInput;
  organizationUserInvitePrependInput: organizationUserInvitePrependInput;
  organizationUserInviteSetInput: organizationUserInviteSetInput;
  organizationUserInviteStreamCursorInput: organizationUserInviteStreamCursorInput;
  organizationUserInviteStreamCursorValueInput: organizationUserInviteStreamCursorValueInput;
  organizationUserInviteUpdates: organizationUserInviteUpdates;
  organizationUserMaxFields: organizationUserMaxFields;
  organizationUserMaxOrderBy: organizationUserMaxOrderBy;
  organizationUserMinFields: organizationUserMinFields;
  organizationUserMinOrderBy: organizationUserMinOrderBy;
  organizationUserMutationResponse: organizationUserMutationResponse;
  organizationUserObjRelInsertInput: organizationUserObjRelInsertInput;
  organizationUserOnConflict: organizationUserOnConflict;
  organizationUserOrderBy: organizationUserOrderBy;
  organizationUserOutput: organizationUserOutput;
  organizationUserPkColumnsInput: organizationUserPkColumnsInput;
  organizationUserPrependInput: organizationUserPrependInput;
  organizationUserSetInput: organizationUserSetInput;
  organizationUserStatus: organizationUserStatus;
  organizationUserStatusAggregate: organizationUserStatusAggregate;
  organizationUserStatusAggregateFields: organizationUserStatusAggregateFields;
  organizationUserStatusBoolExp: organizationUserStatusBoolExp;
  organizationUserStatusInsertInput: organizationUserStatusInsertInput;
  organizationUserStatusMaxFields: organizationUserStatusMaxFields;
  organizationUserStatusMinFields: organizationUserStatusMinFields;
  organizationUserStatusMutationResponse: organizationUserStatusMutationResponse;
  organizationUserStatusOnConflict: organizationUserStatusOnConflict;
  organizationUserStatusOrderBy: organizationUserStatusOrderBy;
  organizationUserStatusPkColumnsInput: organizationUserStatusPkColumnsInput;
  organizationUserStatusSetInput: organizationUserStatusSetInput;
  organizationUserStatusStreamCursorInput: organizationUserStatusStreamCursorInput;
  organizationUserStatusStreamCursorValueInput: organizationUserStatusStreamCursorValueInput;
  organizationUserStatusUpdates: organizationUserStatusUpdates;
  organizationUserStreamCursorInput: organizationUserStreamCursorInput;
  organizationUserStreamCursorValueInput: organizationUserStreamCursorValueInput;
  organizationUserUpdates: organizationUserUpdates;
  organizationUsers: organizationUsers;
  organizationVarPopFields: organizationVarPopFields;
  organizationVarPopOrderBy: organizationVarPopOrderBy;
  organizationVarSampFields: organizationVarSampFields;
  organizationVarSampOrderBy: organizationVarSampOrderBy;
  organizationVarianceFields: organizationVarianceFields;
  organizationVarianceOrderBy: organizationVarianceOrderBy;
  phoneNumberVerificationStatus: phoneNumberVerificationStatus;
  phoneNumberVerificationStatusAggregate: phoneNumberVerificationStatusAggregate;
  phoneNumberVerificationStatusAggregateFields: phoneNumberVerificationStatusAggregateFields;
  phoneNumberVerificationStatusBoolExp: phoneNumberVerificationStatusBoolExp;
  phoneNumberVerificationStatusInsertInput: phoneNumberVerificationStatusInsertInput;
  phoneNumberVerificationStatusMaxFields: phoneNumberVerificationStatusMaxFields;
  phoneNumberVerificationStatusMinFields: phoneNumberVerificationStatusMinFields;
  phoneNumberVerificationStatusMutationResponse: phoneNumberVerificationStatusMutationResponse;
  phoneNumberVerificationStatusOnConflict: phoneNumberVerificationStatusOnConflict;
  phoneNumberVerificationStatusOrderBy: phoneNumberVerificationStatusOrderBy;
  phoneNumberVerificationStatusPkColumnsInput: phoneNumberVerificationStatusPkColumnsInput;
  phoneNumberVerificationStatusSetInput: phoneNumberVerificationStatusSetInput;
  phoneNumberVerificationStatusStreamCursorInput: phoneNumberVerificationStatusStreamCursorInput;
  phoneNumberVerificationStatusStreamCursorValueInput: phoneNumberVerificationStatusStreamCursorValueInput;
  phoneNumberVerificationStatusUpdates: phoneNumberVerificationStatusUpdates;
  phoneUserOutput: phoneUserOutput;
  privatizeUserResult: privatizeUserResult;
  publicDevice: publicDevice;
  publicDeviceAggregate: publicDeviceAggregate;
  publicDeviceAggregateFields: publicDeviceAggregateFields;
  publicDeviceBoolExp: publicDeviceBoolExp;
  publicDeviceInsertInput: publicDeviceInsertInput;
  publicDeviceMaxFields: publicDeviceMaxFields;
  publicDeviceMinFields: publicDeviceMinFields;
  publicDeviceMutationResponse: publicDeviceMutationResponse;
  publicDeviceOnConflict: publicDeviceOnConflict;
  publicDeviceOrderBy: publicDeviceOrderBy;
  publicDevicePkColumnsInput: publicDevicePkColumnsInput;
  publicDeviceSetInput: publicDeviceSetInput;
  publicDeviceStreamCursorInput: publicDeviceStreamCursorInput;
  publicDeviceStreamCursorValueInput: publicDeviceStreamCursorValueInput;
  publicDeviceUpdates: publicDeviceUpdates;
  publicExternalRequest: publicExternalRequest;
  publicExternalRequestAggregate: publicExternalRequestAggregate;
  publicExternalRequestAggregateFields: publicExternalRequestAggregateFields;
  publicExternalRequestAppendInput: publicExternalRequestAppendInput;
  publicExternalRequestBoolExp: publicExternalRequestBoolExp;
  publicExternalRequestDeleteAtPathInput: publicExternalRequestDeleteAtPathInput;
  publicExternalRequestDeleteElemInput: publicExternalRequestDeleteElemInput;
  publicExternalRequestDeleteKeyInput: publicExternalRequestDeleteKeyInput;
  publicExternalRequestInsertInput: publicExternalRequestInsertInput;
  publicExternalRequestMaxFields: publicExternalRequestMaxFields;
  publicExternalRequestMinFields: publicExternalRequestMinFields;
  publicExternalRequestMutationResponse: publicExternalRequestMutationResponse;
  publicExternalRequestOnConflict: publicExternalRequestOnConflict;
  publicExternalRequestOrderBy: publicExternalRequestOrderBy;
  publicExternalRequestPkColumnsInput: publicExternalRequestPkColumnsInput;
  publicExternalRequestPrependInput: publicExternalRequestPrependInput;
  publicExternalRequestSetInput: publicExternalRequestSetInput;
  publicExternalRequestStreamCursorInput: publicExternalRequestStreamCursorInput;
  publicExternalRequestStreamCursorValueInput: publicExternalRequestStreamCursorValueInput;
  publicExternalRequestUpdates: publicExternalRequestUpdates;
  publicFile: publicFile;
  publicFileAggregate: publicFileAggregate;
  publicFileAggregateFields: publicFileAggregateFields;
  publicFileBoolExp: publicFileBoolExp;
  publicFileInsertInput: publicFileInsertInput;
  publicFileMaxFields: publicFileMaxFields;
  publicFileMinFields: publicFileMinFields;
  publicFileMutationResponse: publicFileMutationResponse;
  publicFileObjRelInsertInput: publicFileObjRelInsertInput;
  publicFileOnConflict: publicFileOnConflict;
  publicFileOrderBy: publicFileOrderBy;
  publicFilePkColumnsInput: publicFilePkColumnsInput;
  publicFileSetInput: publicFileSetInput;
  publicFileStreamCursorInput: publicFileStreamCursorInput;
  publicFileStreamCursorValueInput: publicFileStreamCursorValueInput;
  publicFileUpdates: publicFileUpdates;
  publicNotification: publicNotification;
  publicNotificationAggregate: publicNotificationAggregate;
  publicNotificationAggregateFields: publicNotificationAggregateFields;
  publicNotificationAvgFields: publicNotificationAvgFields;
  publicNotificationBoolExp: publicNotificationBoolExp;
  publicNotificationIncInput: publicNotificationIncInput;
  publicNotificationInsertInput: publicNotificationInsertInput;
  publicNotificationMaxFields: publicNotificationMaxFields;
  publicNotificationMinFields: publicNotificationMinFields;
  publicNotificationMutationResponse: publicNotificationMutationResponse;
  publicNotificationOnConflict: publicNotificationOnConflict;
  publicNotificationOrderBy: publicNotificationOrderBy;
  publicNotificationPkColumnsInput: publicNotificationPkColumnsInput;
  publicNotificationSetInput: publicNotificationSetInput;
  publicNotificationStddevFields: publicNotificationStddevFields;
  publicNotificationStddevPopFields: publicNotificationStddevPopFields;
  publicNotificationStddevSampFields: publicNotificationStddevSampFields;
  publicNotificationStreamCursorInput: publicNotificationStreamCursorInput;
  publicNotificationStreamCursorValueInput: publicNotificationStreamCursorValueInput;
  publicNotificationSumFields: publicNotificationSumFields;
  publicNotificationUpdates: publicNotificationUpdates;
  publicNotificationVarPopFields: publicNotificationVarPopFields;
  publicNotificationVarSampFields: publicNotificationVarSampFields;
  publicNotificationVarianceFields: publicNotificationVarianceFields;
  query_root: {};
  queueItem: queueItem;
  queueItemAggregate: queueItemAggregate;
  queueItemAggregateBoolExp: queueItemAggregateBoolExp;
  queueItemAggregateBoolExpBool_and: queueItemAggregateBoolExpBool_and;
  queueItemAggregateBoolExpBool_or: queueItemAggregateBoolExpBool_or;
  queueItemAggregateBoolExpCount: queueItemAggregateBoolExpCount;
  queueItemAggregateFields: queueItemAggregateFields;
  queueItemAggregateOrderBy: queueItemAggregateOrderBy;
  queueItemAppendInput: queueItemAppendInput;
  queueItemArrRelInsertInput: queueItemArrRelInsertInput;
  queueItemBoolExp: queueItemBoolExp;
  queueItemDeleteAtPathInput: queueItemDeleteAtPathInput;
  queueItemDeleteElemInput: queueItemDeleteElemInput;
  queueItemDeleteKeyInput: queueItemDeleteKeyInput;
  queueItemInsertInput: queueItemInsertInput;
  queueItemMaxFields: queueItemMaxFields;
  queueItemMaxOrderBy: queueItemMaxOrderBy;
  queueItemMinFields: queueItemMinFields;
  queueItemMinOrderBy: queueItemMinOrderBy;
  queueItemMutationResponse: queueItemMutationResponse;
  queueItemObjRelInsertInput: queueItemObjRelInsertInput;
  queueItemOnConflict: queueItemOnConflict;
  queueItemOrderBy: queueItemOrderBy;
  queueItemPkColumnsInput: queueItemPkColumnsInput;
  queueItemPrependInput: queueItemPrependInput;
  queueItemSetInput: queueItemSetInput;
  queueItemStreamCursorInput: queueItemStreamCursorInput;
  queueItemStreamCursorValueInput: queueItemStreamCursorValueInput;
  queueItemUpdates: queueItemUpdates;
  relOrganizationUserDomainUser: relOrganizationUserDomainUser;
  relOrganizationUserDomainUserAggregate: relOrganizationUserDomainUserAggregate;
  relOrganizationUserDomainUserAggregateBoolExp: relOrganizationUserDomainUserAggregateBoolExp;
  relOrganizationUserDomainUserAggregateBoolExpCount: relOrganizationUserDomainUserAggregateBoolExpCount;
  relOrganizationUserDomainUserAggregateFields: relOrganizationUserDomainUserAggregateFields;
  relOrganizationUserDomainUserAggregateOrderBy: relOrganizationUserDomainUserAggregateOrderBy;
  relOrganizationUserDomainUserArrRelInsertInput: relOrganizationUserDomainUserArrRelInsertInput;
  relOrganizationUserDomainUserBoolExp: relOrganizationUserDomainUserBoolExp;
  relOrganizationUserDomainUserInsertInput: relOrganizationUserDomainUserInsertInput;
  relOrganizationUserDomainUserMaxFields: relOrganizationUserDomainUserMaxFields;
  relOrganizationUserDomainUserMaxOrderBy: relOrganizationUserDomainUserMaxOrderBy;
  relOrganizationUserDomainUserMinFields: relOrganizationUserDomainUserMinFields;
  relOrganizationUserDomainUserMinOrderBy: relOrganizationUserDomainUserMinOrderBy;
  relOrganizationUserDomainUserMutationResponse: relOrganizationUserDomainUserMutationResponse;
  relOrganizationUserDomainUserOnConflict: relOrganizationUserDomainUserOnConflict;
  relOrganizationUserDomainUserOrderBy: relOrganizationUserDomainUserOrderBy;
  relOrganizationUserDomainUserPkColumnsInput: relOrganizationUserDomainUserPkColumnsInput;
  relOrganizationUserDomainUserSetInput: relOrganizationUserDomainUserSetInput;
  relOrganizationUserDomainUserStreamCursorInput: relOrganizationUserDomainUserStreamCursorInput;
  relOrganizationUserDomainUserStreamCursorValueInput: relOrganizationUserDomainUserStreamCursorValueInput;
  relOrganizationUserDomainUserUpdates: relOrganizationUserDomainUserUpdates;
  removeEmailDomainUserOutput: removeEmailDomainUserOutput;
  removeEmailProviderIntegrationAccount: removeEmailProviderIntegrationAccount;
  removeEmailProviderIntegrationInput: removeEmailProviderIntegrationInput;
  removeOrganizationInput: removeOrganizationInput;
  removeOrganizationOutput: removeOrganizationOutput;
  renewEmailProviderSubscriptionInput: renewEmailProviderSubscriptionInput;
  renewEmailProviderSubscriptionOutput: renewEmailProviderSubscriptionOutput;
  setUpOrganizationOutput: setUpOrganizationOutput;
  smsConnector: smsConnector;
  smsConnectorAggregate: smsConnectorAggregate;
  smsConnectorAggregateFields: smsConnectorAggregateFields;
  smsConnectorAvgFields: smsConnectorAvgFields;
  smsConnectorBoolExp: smsConnectorBoolExp;
  smsConnectorIncInput: smsConnectorIncInput;
  smsConnectorInsertInput: smsConnectorInsertInput;
  smsConnectorMaxFields: smsConnectorMaxFields;
  smsConnectorMinFields: smsConnectorMinFields;
  smsConnectorMutationResponse: smsConnectorMutationResponse;
  smsConnectorOnConflict: smsConnectorOnConflict;
  smsConnectorOrderBy: smsConnectorOrderBy;
  smsConnectorPkColumnsInput: smsConnectorPkColumnsInput;
  smsConnectorSetInput: smsConnectorSetInput;
  smsConnectorStddevFields: smsConnectorStddevFields;
  smsConnectorStddevPopFields: smsConnectorStddevPopFields;
  smsConnectorStddevSampFields: smsConnectorStddevSampFields;
  smsConnectorStreamCursorInput: smsConnectorStreamCursorInput;
  smsConnectorStreamCursorValueInput: smsConnectorStreamCursorValueInput;
  smsConnectorSumFields: smsConnectorSumFields;
  smsConnectorUpdates: smsConnectorUpdates;
  smsConnectorVarPopFields: smsConnectorVarPopFields;
  smsConnectorVarSampFields: smsConnectorVarSampFields;
  smsConnectorVarianceFields: smsConnectorVarianceFields;
  smsGate: smsGate;
  smsGateAggregate: smsGateAggregate;
  smsGateAggregateFields: smsGateAggregateFields;
  smsGateAvgFields: smsGateAvgFields;
  smsGateBoolExp: smsGateBoolExp;
  smsGateIncInput: smsGateIncInput;
  smsGateInsertInput: smsGateInsertInput;
  smsGateMaxFields: smsGateMaxFields;
  smsGateMinFields: smsGateMinFields;
  smsGateMutationResponse: smsGateMutationResponse;
  smsGateOnConflict: smsGateOnConflict;
  smsGateOrderBy: smsGateOrderBy;
  smsGatePkColumnsInput: smsGatePkColumnsInput;
  smsGateSetInput: smsGateSetInput;
  smsGateStddevFields: smsGateStddevFields;
  smsGateStddevPopFields: smsGateStddevPopFields;
  smsGateStddevSampFields: smsGateStddevSampFields;
  smsGateStreamCursorInput: smsGateStreamCursorInput;
  smsGateStreamCursorValueInput: smsGateStreamCursorValueInput;
  smsGateSumFields: smsGateSumFields;
  smsGateUpdates: smsGateUpdates;
  smsGateVarPopFields: smsGateVarPopFields;
  smsGateVarSampFields: smsGateVarSampFields;
  smsGateVarianceFields: smsGateVarianceFields;
  smsLinkMobilitySmsContent: smsLinkMobilitySmsContent;
  smsLinkMobilitySmsContentAggregate: smsLinkMobilitySmsContentAggregate;
  smsLinkMobilitySmsContentAggregateFields: smsLinkMobilitySmsContentAggregateFields;
  smsLinkMobilitySmsContentBoolExp: smsLinkMobilitySmsContentBoolExp;
  smsLinkMobilitySmsContentInsertInput: smsLinkMobilitySmsContentInsertInput;
  smsLinkMobilitySmsContentMaxFields: smsLinkMobilitySmsContentMaxFields;
  smsLinkMobilitySmsContentMinFields: smsLinkMobilitySmsContentMinFields;
  smsLinkMobilitySmsContentMutationResponse: smsLinkMobilitySmsContentMutationResponse;
  smsLinkMobilitySmsContentObjRelInsertInput: smsLinkMobilitySmsContentObjRelInsertInput;
  smsLinkMobilitySmsContentOnConflict: smsLinkMobilitySmsContentOnConflict;
  smsLinkMobilitySmsContentOrderBy: smsLinkMobilitySmsContentOrderBy;
  smsLinkMobilitySmsContentPkColumnsInput: smsLinkMobilitySmsContentPkColumnsInput;
  smsLinkMobilitySmsContentSetInput: smsLinkMobilitySmsContentSetInput;
  smsLinkMobilitySmsContentStreamCursorInput: smsLinkMobilitySmsContentStreamCursorInput;
  smsLinkMobilitySmsContentStreamCursorValueInput: smsLinkMobilitySmsContentStreamCursorValueInput;
  smsLinkMobilitySmsContentUpdates: smsLinkMobilitySmsContentUpdates;
  smsLinkMobilitySmsMessage: smsLinkMobilitySmsMessage;
  smsLinkMobilitySmsMessageAggregate: smsLinkMobilitySmsMessageAggregate;
  smsLinkMobilitySmsMessageAggregateFields: smsLinkMobilitySmsMessageAggregateFields;
  smsLinkMobilitySmsMessageAppendInput: smsLinkMobilitySmsMessageAppendInput;
  smsLinkMobilitySmsMessageAvgFields: smsLinkMobilitySmsMessageAvgFields;
  smsLinkMobilitySmsMessageBoolExp: smsLinkMobilitySmsMessageBoolExp;
  smsLinkMobilitySmsMessageDeleteAtPathInput: smsLinkMobilitySmsMessageDeleteAtPathInput;
  smsLinkMobilitySmsMessageDeleteElemInput: smsLinkMobilitySmsMessageDeleteElemInput;
  smsLinkMobilitySmsMessageDeleteKeyInput: smsLinkMobilitySmsMessageDeleteKeyInput;
  smsLinkMobilitySmsMessageIncInput: smsLinkMobilitySmsMessageIncInput;
  smsLinkMobilitySmsMessageInsertInput: smsLinkMobilitySmsMessageInsertInput;
  smsLinkMobilitySmsMessageMaxFields: smsLinkMobilitySmsMessageMaxFields;
  smsLinkMobilitySmsMessageMinFields: smsLinkMobilitySmsMessageMinFields;
  smsLinkMobilitySmsMessageMutationResponse: smsLinkMobilitySmsMessageMutationResponse;
  smsLinkMobilitySmsMessageObjRelInsertInput: smsLinkMobilitySmsMessageObjRelInsertInput;
  smsLinkMobilitySmsMessageOnConflict: smsLinkMobilitySmsMessageOnConflict;
  smsLinkMobilitySmsMessageOrderBy: smsLinkMobilitySmsMessageOrderBy;
  smsLinkMobilitySmsMessagePkColumnsInput: smsLinkMobilitySmsMessagePkColumnsInput;
  smsLinkMobilitySmsMessagePrependInput: smsLinkMobilitySmsMessagePrependInput;
  smsLinkMobilitySmsMessageSetInput: smsLinkMobilitySmsMessageSetInput;
  smsLinkMobilitySmsMessageStddevFields: smsLinkMobilitySmsMessageStddevFields;
  smsLinkMobilitySmsMessageStddevPopFields: smsLinkMobilitySmsMessageStddevPopFields;
  smsLinkMobilitySmsMessageStddevSampFields: smsLinkMobilitySmsMessageStddevSampFields;
  smsLinkMobilitySmsMessageStreamCursorInput: smsLinkMobilitySmsMessageStreamCursorInput;
  smsLinkMobilitySmsMessageStreamCursorValueInput: smsLinkMobilitySmsMessageStreamCursorValueInput;
  smsLinkMobilitySmsMessageSumFields: smsLinkMobilitySmsMessageSumFields;
  smsLinkMobilitySmsMessageUpdates: smsLinkMobilitySmsMessageUpdates;
  smsLinkMobilitySmsMessageVarPopFields: smsLinkMobilitySmsMessageVarPopFields;
  smsLinkMobilitySmsMessageVarSampFields: smsLinkMobilitySmsMessageVarSampFields;
  smsLinkMobilitySmsMessageVarianceFields: smsLinkMobilitySmsMessageVarianceFields;
  smsLinkMobilitySmsRoute: smsLinkMobilitySmsRoute;
  smsLinkMobilitySmsRouteAggregate: smsLinkMobilitySmsRouteAggregate;
  smsLinkMobilitySmsRouteAggregateFields: smsLinkMobilitySmsRouteAggregateFields;
  smsLinkMobilitySmsRouteAppendInput: smsLinkMobilitySmsRouteAppendInput;
  smsLinkMobilitySmsRouteBoolExp: smsLinkMobilitySmsRouteBoolExp;
  smsLinkMobilitySmsRouteDeleteAtPathInput: smsLinkMobilitySmsRouteDeleteAtPathInput;
  smsLinkMobilitySmsRouteDeleteElemInput: smsLinkMobilitySmsRouteDeleteElemInput;
  smsLinkMobilitySmsRouteDeleteKeyInput: smsLinkMobilitySmsRouteDeleteKeyInput;
  smsLinkMobilitySmsRouteInsertInput: smsLinkMobilitySmsRouteInsertInput;
  smsLinkMobilitySmsRouteMaxFields: smsLinkMobilitySmsRouteMaxFields;
  smsLinkMobilitySmsRouteMinFields: smsLinkMobilitySmsRouteMinFields;
  smsLinkMobilitySmsRouteMutationResponse: smsLinkMobilitySmsRouteMutationResponse;
  smsLinkMobilitySmsRouteObjRelInsertInput: smsLinkMobilitySmsRouteObjRelInsertInput;
  smsLinkMobilitySmsRouteOnConflict: smsLinkMobilitySmsRouteOnConflict;
  smsLinkMobilitySmsRouteOrderBy: smsLinkMobilitySmsRouteOrderBy;
  smsLinkMobilitySmsRoutePkColumnsInput: smsLinkMobilitySmsRoutePkColumnsInput;
  smsLinkMobilitySmsRoutePrependInput: smsLinkMobilitySmsRoutePrependInput;
  smsLinkMobilitySmsRouteSetInput: smsLinkMobilitySmsRouteSetInput;
  smsLinkMobilitySmsRouteStreamCursorInput: smsLinkMobilitySmsRouteStreamCursorInput;
  smsLinkMobilitySmsRouteStreamCursorValueInput: smsLinkMobilitySmsRouteStreamCursorValueInput;
  smsLinkMobilitySmsRouteUpdates: smsLinkMobilitySmsRouteUpdates;
  smsProvider: smsProvider;
  smsProviderAggregate: smsProviderAggregate;
  smsProviderAggregateFields: smsProviderAggregateFields;
  smsProviderAvgFields: smsProviderAvgFields;
  smsProviderBoolExp: smsProviderBoolExp;
  smsProviderIncInput: smsProviderIncInput;
  smsProviderInsertInput: smsProviderInsertInput;
  smsProviderMaxFields: smsProviderMaxFields;
  smsProviderMinFields: smsProviderMinFields;
  smsProviderMutationResponse: smsProviderMutationResponse;
  smsProviderOnConflict: smsProviderOnConflict;
  smsProviderOrderBy: smsProviderOrderBy;
  smsProviderPkColumnsInput: smsProviderPkColumnsInput;
  smsProviderSetInput: smsProviderSetInput;
  smsProviderStddevFields: smsProviderStddevFields;
  smsProviderStddevPopFields: smsProviderStddevPopFields;
  smsProviderStddevSampFields: smsProviderStddevSampFields;
  smsProviderStreamCursorInput: smsProviderStreamCursorInput;
  smsProviderStreamCursorValueInput: smsProviderStreamCursorValueInput;
  smsProviderSumFields: smsProviderSumFields;
  smsProviderUpdates: smsProviderUpdates;
  smsProviderVarPopFields: smsProviderVarPopFields;
  smsProviderVarSampFields: smsProviderVarSampFields;
  smsProviderVarianceFields: smsProviderVarianceFields;
  smsSm: smsSm;
  smsSmAggregate: smsSmAggregate;
  smsSmAggregateFields: smsSmAggregateFields;
  smsSmAvgFields: smsSmAvgFields;
  smsSmBoolExp: smsSmBoolExp;
  smsSmIncInput: smsSmIncInput;
  smsSmInsertInput: smsSmInsertInput;
  smsSmMaxFields: smsSmMaxFields;
  smsSmMinFields: smsSmMinFields;
  smsSmMutationResponse: smsSmMutationResponse;
  smsSmOnConflict: smsSmOnConflict;
  smsSmOrderBy: smsSmOrderBy;
  smsSmPkColumnsInput: smsSmPkColumnsInput;
  smsSmSetInput: smsSmSetInput;
  smsSmStddevFields: smsSmStddevFields;
  smsSmStddevPopFields: smsSmStddevPopFields;
  smsSmStddevSampFields: smsSmStddevSampFields;
  smsSmStreamCursorInput: smsSmStreamCursorInput;
  smsSmStreamCursorValueInput: smsSmStreamCursorValueInput;
  smsSmSumFields: smsSmSumFields;
  smsSmUpdates: smsSmUpdates;
  smsSmVarPopFields: smsSmVarPopFields;
  smsSmVarSampFields: smsSmVarSampFields;
  smsSmVarianceFields: smsSmVarianceFields;
  smsSmsExternalIncomingLinkMobility: smsSmsExternalIncomingLinkMobility;
  smsSmsExternalIncomingLinkMobilityAggregate: smsSmsExternalIncomingLinkMobilityAggregate;
  smsSmsExternalIncomingLinkMobilityAggregateFields: smsSmsExternalIncomingLinkMobilityAggregateFields;
  smsSmsExternalIncomingLinkMobilityBoolExp: smsSmsExternalIncomingLinkMobilityBoolExp;
  smsSmsExternalIncomingLinkMobilityInsertInput: smsSmsExternalIncomingLinkMobilityInsertInput;
  smsSmsExternalIncomingLinkMobilityMaxFields: smsSmsExternalIncomingLinkMobilityMaxFields;
  smsSmsExternalIncomingLinkMobilityMinFields: smsSmsExternalIncomingLinkMobilityMinFields;
  smsSmsExternalIncomingLinkMobilityMutationResponse: smsSmsExternalIncomingLinkMobilityMutationResponse;
  smsSmsExternalIncomingLinkMobilityOnConflict: smsSmsExternalIncomingLinkMobilityOnConflict;
  smsSmsExternalIncomingLinkMobilityOrderBy: smsSmsExternalIncomingLinkMobilityOrderBy;
  smsSmsExternalIncomingLinkMobilityPkColumnsInput: smsSmsExternalIncomingLinkMobilityPkColumnsInput;
  smsSmsExternalIncomingLinkMobilitySetInput: smsSmsExternalIncomingLinkMobilitySetInput;
  smsSmsExternalIncomingLinkMobilityStreamCursorInput: smsSmsExternalIncomingLinkMobilityStreamCursorInput;
  smsSmsExternalIncomingLinkMobilityStreamCursorValueInput: smsSmsExternalIncomingLinkMobilityStreamCursorValueInput;
  smsSmsExternalIncomingLinkMobilityUpdates: smsSmsExternalIncomingLinkMobilityUpdates;
  subscription_root: {};
  taskmutation_root: taskmutation_root;
  taskquery_root: taskquery_root;
  tasksubscription_root: tasksubscription_root;
  telephonyDomainUserOutput: telephonyDomainUserOutput;
  telephonyProviderIntegrationAccount: telephonyProviderIntegrationAccount;
  telephonyProviderIntegrationConfiguration: telephonyProviderIntegrationConfiguration;
  telephonyProviderIntegrationInput: telephonyProviderIntegrationInput;
  telephonymutation_root: telephonymutation_root;
  telephonyquery_root: telephonyquery_root;
  telephonysubscription_root: telephonysubscription_root;
  testNotificationSettingsResult: testNotificationSettingsResult;
  timestamp: Scalars['timestamp']['output'];
  timestamptz: Scalars['timestamptz']['output'];
  timetz: Scalars['timetz']['output'];
  updateDashboardDataOutput: updateDashboardDataOutput;
  user: user;
  userAggregate: userAggregate;
  userAggregateBoolExp: userAggregateBoolExp;
  userAggregateBoolExpBool_and: userAggregateBoolExpBool_and;
  userAggregateBoolExpBool_or: userAggregateBoolExpBool_or;
  userAggregateBoolExpCount: userAggregateBoolExpCount;
  userAggregateFields: userAggregateFields;
  userAggregateOrderBy: userAggregateOrderBy;
  userArrRelInsertInput: userArrRelInsertInput;
  userBoolExp: userBoolExp;
  userDeleteOutput: userDeleteOutput;
  userDetail: userDetail;
  userDetailAggregate: userDetailAggregate;
  userDetailAggregateBoolExp: userDetailAggregateBoolExp;
  userDetailAggregateBoolExpCount: userDetailAggregateBoolExpCount;
  userDetailAggregateFields: userDetailAggregateFields;
  userDetailAggregateOrderBy: userDetailAggregateOrderBy;
  userDetailArrRelInsertInput: userDetailArrRelInsertInput;
  userDetailBoolExp: userDetailBoolExp;
  userDetailInsertInput: userDetailInsertInput;
  userDetailMaxFields: userDetailMaxFields;
  userDetailMaxOrderBy: userDetailMaxOrderBy;
  userDetailMinFields: userDetailMinFields;
  userDetailMinOrderBy: userDetailMinOrderBy;
  userDetailMutationResponse: userDetailMutationResponse;
  userDetailOnConflict: userDetailOnConflict;
  userDetailOrderBy: userDetailOrderBy;
  userDetailPkColumnsInput: userDetailPkColumnsInput;
  userDetailSetInput: userDetailSetInput;
  userDetailStreamCursorInput: userDetailStreamCursorInput;
  userDetailStreamCursorValueInput: userDetailStreamCursorValueInput;
  userDetailUpdates: userDetailUpdates;
  userDetailsType: userDetailsType;
  userDetailsTypeAggregate: userDetailsTypeAggregate;
  userDetailsTypeAggregateFields: userDetailsTypeAggregateFields;
  userDetailsTypeBoolExp: userDetailsTypeBoolExp;
  userDetailsTypeInsertInput: userDetailsTypeInsertInput;
  userDetailsTypeMaxFields: userDetailsTypeMaxFields;
  userDetailsTypeMinFields: userDetailsTypeMinFields;
  userDetailsTypeMutationResponse: userDetailsTypeMutationResponse;
  userDetailsTypeOnConflict: userDetailsTypeOnConflict;
  userDetailsTypeOrderBy: userDetailsTypeOrderBy;
  userDetailsTypePkColumnsInput: userDetailsTypePkColumnsInput;
  userDetailsTypeSetInput: userDetailsTypeSetInput;
  userDetailsTypeStreamCursorInput: userDetailsTypeStreamCursorInput;
  userDetailsTypeStreamCursorValueInput: userDetailsTypeStreamCursorValueInput;
  userDetailsTypeUpdates: userDetailsTypeUpdates;
  userDevice: userDevice;
  userDeviceAggregate: userDeviceAggregate;
  userDeviceAggregateFields: userDeviceAggregateFields;
  userDeviceBoolExp: userDeviceBoolExp;
  userDeviceInsertInput: userDeviceInsertInput;
  userDeviceMaxFields: userDeviceMaxFields;
  userDeviceMinFields: userDeviceMinFields;
  userDeviceMutationResponse: userDeviceMutationResponse;
  userDeviceOnConflict: userDeviceOnConflict;
  userDeviceOrderBy: userDeviceOrderBy;
  userDevicePkColumnsInput: userDevicePkColumnsInput;
  userDeviceSetInput: userDeviceSetInput;
  userDeviceStreamCursorInput: userDeviceStreamCursorInput;
  userDeviceStreamCursorValueInput: userDeviceStreamCursorValueInput;
  userDeviceUpdates: userDeviceUpdates;
  userInput: userInput;
  userInsertInput: userInsertInput;
  userMaxFields: userMaxFields;
  userMaxOrderBy: userMaxOrderBy;
  userMinFields: userMinFields;
  userMinOrderBy: userMinOrderBy;
  userMutationResponse: userMutationResponse;
  userObjRelInsertInput: userObjRelInsertInput;
  userOnConflict: userOnConflict;
  userOrderBy: userOrderBy;
  userPhoneNumber: userPhoneNumber;
  userPhoneNumberAggregate: userPhoneNumberAggregate;
  userPhoneNumberAggregateFields: userPhoneNumberAggregateFields;
  userPhoneNumberBoolExp: userPhoneNumberBoolExp;
  userPhoneNumberInsertInput: userPhoneNumberInsertInput;
  userPhoneNumberMaxFields: userPhoneNumberMaxFields;
  userPhoneNumberMinFields: userPhoneNumberMinFields;
  userPhoneNumberMutationResponse: userPhoneNumberMutationResponse;
  userPhoneNumberOnConflict: userPhoneNumberOnConflict;
  userPhoneNumberOrderBy: userPhoneNumberOrderBy;
  userPhoneNumberPkColumnsInput: userPhoneNumberPkColumnsInput;
  userPhoneNumberSetInput: userPhoneNumberSetInput;
  userPhoneNumberStreamCursorInput: userPhoneNumberStreamCursorInput;
  userPhoneNumberStreamCursorValueInput: userPhoneNumberStreamCursorValueInput;
  userPhoneNumberUpdates: userPhoneNumberUpdates;
  userPkColumnsInput: userPkColumnsInput;
  userRole: userRole;
  userRoleAggregate: userRoleAggregate;
  userRoleAggregateFields: userRoleAggregateFields;
  userRoleBoolExp: userRoleBoolExp;
  userRoleInsertInput: userRoleInsertInput;
  userRoleMaxFields: userRoleMaxFields;
  userRoleMinFields: userRoleMinFields;
  userRoleMutationResponse: userRoleMutationResponse;
  userRoleOnConflict: userRoleOnConflict;
  userRoleOrderBy: userRoleOrderBy;
  userRolePkColumnsInput: userRolePkColumnsInput;
  userRoleSetInput: userRoleSetInput;
  userRoleStreamCursorInput: userRoleStreamCursorInput;
  userRoleStreamCursorValueInput: userRoleStreamCursorValueInput;
  userRoleUpdates: userRoleUpdates;
  userSetInput: userSetInput;
  userStreamCursorInput: userStreamCursorInput;
  userStreamCursorValueInput: userStreamCursorValueInput;
  userUpdates: userUpdates;
  uuid: Scalars['uuid']['output'];
  validationValidation: validationValidation;
  validationValidationAggregate: validationValidationAggregate;
  validationValidationAggregateFields: validationValidationAggregateFields;
  validationValidationAvgFields: validationValidationAvgFields;
  validationValidationBoolExp: validationValidationBoolExp;
  validationValidationIncInput: validationValidationIncInput;
  validationValidationInsertInput: validationValidationInsertInput;
  validationValidationMaxFields: validationValidationMaxFields;
  validationValidationMinFields: validationValidationMinFields;
  validationValidationMutationResponse: validationValidationMutationResponse;
  validationValidationOnConflict: validationValidationOnConflict;
  validationValidationOrderBy: validationValidationOrderBy;
  validationValidationPkColumnsInput: validationValidationPkColumnsInput;
  validationValidationSetInput: validationValidationSetInput;
  validationValidationStddevFields: validationValidationStddevFields;
  validationValidationStddevPopFields: validationValidationStddevPopFields;
  validationValidationStddevSampFields: validationValidationStddevSampFields;
  validationValidationStreamCursorInput: validationValidationStreamCursorInput;
  validationValidationStreamCursorValueInput: validationValidationStreamCursorValueInput;
  validationValidationSumFields: validationValidationSumFields;
  validationValidationUpdates: validationValidationUpdates;
  validationValidationVarPopFields: validationValidationVarPopFields;
  validationValidationVarSampFields: validationValidationVarSampFields;
  validationValidationVarianceFields: validationValidationVarianceFields;
  verifyOrganizationUserPhoneNumberInput: verifyOrganizationUserPhoneNumberInput;
  verifyOrganizationUserPhoneNumberOutput: verifyOrganizationUserPhoneNumberOutput;
  videoInviteOrgUserInput: videoInviteOrgUserInput;
  videoInviteOrgUserOutput: videoInviteOrgUserOutput;
};

export type cachedDirectiveArgs = {
  refresh?: Scalars['Boolean']['input'];
  ttl?: Scalars['Int']['input'];
};

export type cachedDirectiveResolver<Result, Parent, ContextType = any, Args = cachedDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type ActivityDirectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityDirection'] = ResolversParentTypes['ActivityDirection']> = {
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityDirectionAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityDirectionAggregate'] = ResolversParentTypes['ActivityDirectionAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['ActivityDirectionAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['ActivityDirection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityDirectionAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityDirectionAggregateFields'] = ResolversParentTypes['ActivityDirectionAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<ActivityDirectionAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['ActivityDirectionMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['ActivityDirectionMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityDirectionMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityDirectionMaxFields'] = ResolversParentTypes['ActivityDirectionMaxFields']> = {
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityDirectionMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityDirectionMinFields'] = ResolversParentTypes['ActivityDirectionMinFields']> = {
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityDirectionMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityDirectionMutationResponse'] = ResolversParentTypes['ActivityDirectionMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['ActivityDirection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityProviderResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityProvider'] = ResolversParentTypes['ActivityProvider']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityProviderAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityProviderAggregate'] = ResolversParentTypes['ActivityProviderAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['ActivityProviderAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['ActivityProvider']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityProviderAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityProviderAggregateFields'] = ResolversParentTypes['ActivityProviderAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<ActivityProviderAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['ActivityProviderMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['ActivityProviderMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityProviderMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityProviderMaxFields'] = ResolversParentTypes['ActivityProviderMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityProviderMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityProviderMinFields'] = ResolversParentTypes['ActivityProviderMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityProviderMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityProviderMutationResponse'] = ResolversParentTypes['ActivityProviderMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['ActivityProvider']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityStatus'] = ResolversParentTypes['ActivityStatus']> = {
  activities?: Resolver<Array<ResolversTypes['domainActivity']>, ParentType, ContextType, Partial<ActivityStatusactivitiesArgs>>;
  activitiesAggregate?: Resolver<ResolversTypes['domainActivityAggregate'], ParentType, ContextType, Partial<ActivityStatusactivitiesAggregateArgs>>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityStatusAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityStatusAggregate'] = ResolversParentTypes['ActivityStatusAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['ActivityStatusAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['ActivityStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityStatusAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityStatusAggregateFields'] = ResolversParentTypes['ActivityStatusAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<ActivityStatusAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['ActivityStatusMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['ActivityStatusMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityStatusMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityStatusMaxFields'] = ResolversParentTypes['ActivityStatusMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityStatusMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityStatusMinFields'] = ResolversParentTypes['ActivityStatusMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityStatusMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityStatusMutationResponse'] = ResolversParentTypes['ActivityStatusMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['ActivityStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityType'] = ResolversParentTypes['ActivityType']> = {
  activities?: Resolver<Array<ResolversTypes['domainActivity']>, ParentType, ContextType, Partial<ActivityTypeactivitiesArgs>>;
  activitiesAggregate?: Resolver<ResolversTypes['domainActivityAggregate'], ParentType, ContextType, Partial<ActivityTypeactivitiesAggregateArgs>>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityTypeAggregate'] = ResolversParentTypes['ActivityTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['ActivityTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['ActivityType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityTypeAggregateFields'] = ResolversParentTypes['ActivityTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<ActivityTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['ActivityTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['ActivityTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityTypeMaxFields'] = ResolversParentTypes['ActivityTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityTypeMinFields'] = ResolversParentTypes['ActivityTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityTypeMutationResponse'] = ResolversParentTypes['ActivityTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['ActivityType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddDomainUserToOrganizationOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddDomainUserToOrganizationOutput'] = ResolversParentTypes['AddDomainUserToOrganizationOutput']> = {
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BlockUserOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['BlockUserOutput'] = ResolversParentTypes['BlockUserOutput']> = {
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessAddress'] = ResolversParentTypes['BusinessAddress']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessDomainActivityTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessDomainActivityType'] = ResolversParentTypes['BusinessDomainActivityType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessDomainActivityTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessDomainActivityTypeAggregate'] = ResolversParentTypes['BusinessDomainActivityTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['BusinessDomainActivityTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['BusinessDomainActivityType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessDomainActivityTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessDomainActivityTypeAggregateFields'] = ResolversParentTypes['BusinessDomainActivityTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<BusinessDomainActivityTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['BusinessDomainActivityTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['BusinessDomainActivityTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessDomainActivityTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessDomainActivityTypeMaxFields'] = ResolversParentTypes['BusinessDomainActivityTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessDomainActivityTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessDomainActivityTypeMinFields'] = ResolversParentTypes['BusinessDomainActivityTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessDomainActivityTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessDomainActivityTypeMutationResponse'] = ResolversParentTypes['BusinessDomainActivityTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['BusinessDomainActivityType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessFeedTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessFeedType'] = ResolversParentTypes['BusinessFeedType']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessFeedTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessFeedTypeAggregate'] = ResolversParentTypes['BusinessFeedTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['BusinessFeedTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['BusinessFeedType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessFeedTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessFeedTypeAggregateFields'] = ResolversParentTypes['BusinessFeedTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<BusinessFeedTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['BusinessFeedTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['BusinessFeedTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessFeedTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessFeedTypeMaxFields'] = ResolversParentTypes['BusinessFeedTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessFeedTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessFeedTypeMinFields'] = ResolversParentTypes['BusinessFeedTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessFeedTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessFeedTypeMutationResponse'] = ResolversParentTypes['BusinessFeedTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['BusinessFeedType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessMessageAttachmentsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessMessageAttachments'] = ResolversParentTypes['BusinessMessageAttachments']> = {
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  fileId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  messageId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessMessageAttachmentsAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessMessageAttachmentsAggregate'] = ResolversParentTypes['BusinessMessageAttachmentsAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['BusinessMessageAttachmentsAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['BusinessMessageAttachments']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessMessageAttachmentsAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessMessageAttachmentsAggregateFields'] = ResolversParentTypes['BusinessMessageAttachmentsAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<BusinessMessageAttachmentsAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['BusinessMessageAttachmentsMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['BusinessMessageAttachmentsMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessMessageAttachmentsMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessMessageAttachmentsMaxFields'] = ResolversParentTypes['BusinessMessageAttachmentsMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  fileId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  messageId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessMessageAttachmentsMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessMessageAttachmentsMinFields'] = ResolversParentTypes['BusinessMessageAttachmentsMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  fileId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  messageId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessMessageAttachmentsMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessMessageAttachmentsMutationResponse'] = ResolversParentTypes['BusinessMessageAttachmentsMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['BusinessMessageAttachments']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserCallbackAnswerResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserCallbackAnswer'] = ResolversParentTypes['BusinessOrganizationUserCallbackAnswer']> = {
  activeAnswer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  answerLanguage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  language?: Resolver<Maybe<ResolversTypes['languages']>, ParentType, ContextType>;
  organizationUser?: Resolver<Maybe<ResolversTypes['organizationUser']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserCallbackAnswerAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserCallbackAnswerAggregate'] = ResolversParentTypes['BusinessOrganizationUserCallbackAnswerAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserCallbackAnswerAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['BusinessOrganizationUserCallbackAnswer']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserCallbackAnswerAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserCallbackAnswerAggregateFields'] = ResolversParentTypes['BusinessOrganizationUserCallbackAnswerAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<BusinessOrganizationUserCallbackAnswerAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserCallbackAnswerMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserCallbackAnswerMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserCallbackAnswerMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserCallbackAnswerMaxFields'] = ResolversParentTypes['BusinessOrganizationUserCallbackAnswerMaxFields']> = {
  answerLanguage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserCallbackAnswerMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserCallbackAnswerMinFields'] = ResolversParentTypes['BusinessOrganizationUserCallbackAnswerMinFields']> = {
  answerLanguage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserCallbackAnswerMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserCallbackAnswerMutationResponse'] = ResolversParentTypes['BusinessOrganizationUserCallbackAnswerMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['BusinessOrganizationUserCallbackAnswer']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserEmailResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserEmail'] = ResolversParentTypes['BusinessOrganizationUserEmail']> = {
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  isPrimary?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationUser?: Resolver<ResolversTypes['organizationUser'], ParentType, ContextType>;
  organizationUserId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['BusinessOrganizationUserEmailTypeEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserEmailAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserEmailAggregate'] = ResolversParentTypes['BusinessOrganizationUserEmailAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserEmailAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['BusinessOrganizationUserEmail']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserEmailAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserEmailAggregateFields'] = ResolversParentTypes['BusinessOrganizationUserEmailAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<BusinessOrganizationUserEmailAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserEmailMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserEmailMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserEmailMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserEmailMaxFields'] = ResolversParentTypes['BusinessOrganizationUserEmailMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserEmailMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserEmailMinFields'] = ResolversParentTypes['BusinessOrganizationUserEmailMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserEmailMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserEmailMutationResponse'] = ResolversParentTypes['BusinessOrganizationUserEmailMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['BusinessOrganizationUserEmail']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserEmailTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserEmailType'] = ResolversParentTypes['BusinessOrganizationUserEmailType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserEmailTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserEmailTypeAggregate'] = ResolversParentTypes['BusinessOrganizationUserEmailTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserEmailTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['BusinessOrganizationUserEmailType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserEmailTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserEmailTypeAggregateFields'] = ResolversParentTypes['BusinessOrganizationUserEmailTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<BusinessOrganizationUserEmailTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserEmailTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserEmailTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserEmailTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserEmailTypeMaxFields'] = ResolversParentTypes['BusinessOrganizationUserEmailTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserEmailTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserEmailTypeMinFields'] = ResolversParentTypes['BusinessOrganizationUserEmailTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserEmailTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserEmailTypeMutationResponse'] = ResolversParentTypes['BusinessOrganizationUserEmailTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['BusinessOrganizationUserEmailType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserRequest'] = ResolversParentTypes['BusinessOrganizationUserRequest']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  extraData?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<BusinessOrganizationUserRequestextraDataArgs>>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  isCompleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationNumberJoin?: Resolver<Maybe<ResolversTypes['organization']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizations?: Resolver<Maybe<ResolversTypes['organization']>, ParentType, ContextType>;
  permissionRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumberCountryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BusinessUserRequestStatusEnum']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserRequestTypeEnum']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserRequestAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserRequestAggregate'] = ResolversParentTypes['BusinessOrganizationUserRequestAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserRequestAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['BusinessOrganizationUserRequest']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserRequestAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserRequestAggregateFields'] = ResolversParentTypes['BusinessOrganizationUserRequestAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<BusinessOrganizationUserRequestAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserRequestMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserRequestMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserRequestMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserRequestMaxFields'] = ResolversParentTypes['BusinessOrganizationUserRequestMaxFields']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  permissionRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumberCountryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserRequestMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserRequestMinFields'] = ResolversParentTypes['BusinessOrganizationUserRequestMinFields']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  permissionRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumberCountryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserRequestMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserRequestMutationResponse'] = ResolversParentTypes['BusinessOrganizationUserRequestMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['BusinessOrganizationUserRequest']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserRequestTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserRequestType'] = ResolversParentTypes['BusinessOrganizationUserRequestType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserRequestTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserRequestTypeAggregate'] = ResolversParentTypes['BusinessOrganizationUserRequestTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserRequestTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['BusinessOrganizationUserRequestType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserRequestTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserRequestTypeAggregateFields'] = ResolversParentTypes['BusinessOrganizationUserRequestTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<BusinessOrganizationUserRequestTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserRequestTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserRequestTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserRequestTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserRequestTypeMaxFields'] = ResolversParentTypes['BusinessOrganizationUserRequestTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserRequestTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserRequestTypeMinFields'] = ResolversParentTypes['BusinessOrganizationUserRequestTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserRequestTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserRequestTypeMutationResponse'] = ResolversParentTypes['BusinessOrganizationUserRequestTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['BusinessOrganizationUserRequestType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserSuggestionTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserSuggestionType'] = ResolversParentTypes['BusinessOrganizationUserSuggestionType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserSuggestionTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserSuggestionTypeAggregate'] = ResolversParentTypes['BusinessOrganizationUserSuggestionTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserSuggestionTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['BusinessOrganizationUserSuggestionType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserSuggestionTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserSuggestionTypeAggregateFields'] = ResolversParentTypes['BusinessOrganizationUserSuggestionTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<BusinessOrganizationUserSuggestionTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserSuggestionTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserSuggestionTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserSuggestionTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserSuggestionTypeMaxFields'] = ResolversParentTypes['BusinessOrganizationUserSuggestionTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserSuggestionTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserSuggestionTypeMinFields'] = ResolversParentTypes['BusinessOrganizationUserSuggestionTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserSuggestionTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserSuggestionTypeMutationResponse'] = ResolversParentTypes['BusinessOrganizationUserSuggestionTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['BusinessOrganizationUserSuggestionType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserSuggestionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserSuggestions'] = ResolversParentTypes['BusinessOrganizationUserSuggestions']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['organization'], ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumberCountryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceOfSuggestion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  suggestionType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  triggerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserSuggestionsAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserSuggestionsAggregate'] = ResolversParentTypes['BusinessOrganizationUserSuggestionsAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserSuggestionsAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['BusinessOrganizationUserSuggestions']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserSuggestionsAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserSuggestionsAggregateFields'] = ResolversParentTypes['BusinessOrganizationUserSuggestionsAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<BusinessOrganizationUserSuggestionsAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserSuggestionsMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserSuggestionsMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserSuggestionsMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserSuggestionsMaxFields'] = ResolversParentTypes['BusinessOrganizationUserSuggestionsMaxFields']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumberCountryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceOfSuggestion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  suggestionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  triggerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserSuggestionsMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserSuggestionsMinFields'] = ResolversParentTypes['BusinessOrganizationUserSuggestionsMinFields']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumberCountryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceOfSuggestion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  suggestionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  triggerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserSuggestionsMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserSuggestionsMutationResponse'] = ResolversParentTypes['BusinessOrganizationUserSuggestionsMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['BusinessOrganizationUserSuggestions']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserUrlAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserUrlAddress'] = ResolversParentTypes['BusinessOrganizationUserUrlAddress']> = {
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationUser?: Resolver<ResolversTypes['organizationUser'], ParentType, ContextType>;
  organizationUserId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['BusinessOrganizationUserUrlAddressTypeEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  urlType?: Resolver<ResolversTypes['BusinessOrganizationUserUrlAddressType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserUrlAddressAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserUrlAddressAggregate'] = ResolversParentTypes['BusinessOrganizationUserUrlAddressAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserUrlAddressAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['BusinessOrganizationUserUrlAddress']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserUrlAddressAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserUrlAddressAggregateFields'] = ResolversParentTypes['BusinessOrganizationUserUrlAddressAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<BusinessOrganizationUserUrlAddressAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserUrlAddressMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserUrlAddressMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserUrlAddressMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserUrlAddressMaxFields'] = ResolversParentTypes['BusinessOrganizationUserUrlAddressMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserUrlAddressMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserUrlAddressMinFields'] = ResolversParentTypes['BusinessOrganizationUserUrlAddressMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserUrlAddressMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserUrlAddressMutationResponse'] = ResolversParentTypes['BusinessOrganizationUserUrlAddressMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['BusinessOrganizationUserUrlAddress']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserUrlAddressTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserUrlAddressType'] = ResolversParentTypes['BusinessOrganizationUserUrlAddressType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserUrlAddressTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserUrlAddressTypeAggregate'] = ResolversParentTypes['BusinessOrganizationUserUrlAddressTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserUrlAddressTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['BusinessOrganizationUserUrlAddressType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserUrlAddressTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserUrlAddressTypeAggregateFields'] = ResolversParentTypes['BusinessOrganizationUserUrlAddressTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<BusinessOrganizationUserUrlAddressTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserUrlAddressTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserUrlAddressTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserUrlAddressTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserUrlAddressTypeMaxFields'] = ResolversParentTypes['BusinessOrganizationUserUrlAddressTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserUrlAddressTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserUrlAddressTypeMinFields'] = ResolversParentTypes['BusinessOrganizationUserUrlAddressTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessOrganizationUserUrlAddressTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOrganizationUserUrlAddressTypeMutationResponse'] = ResolversParentTypes['BusinessOrganizationUserUrlAddressTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['BusinessOrganizationUserUrlAddressType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemAlarmTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemAlarmType'] = ResolversParentTypes['BusinessQueueItemAlarmType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemAlarmTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemAlarmTypeAggregate'] = ResolversParentTypes['BusinessQueueItemAlarmTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['BusinessQueueItemAlarmTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['BusinessQueueItemAlarmType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemAlarmTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemAlarmTypeAggregateFields'] = ResolversParentTypes['BusinessQueueItemAlarmTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<BusinessQueueItemAlarmTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['BusinessQueueItemAlarmTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['BusinessQueueItemAlarmTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemAlarmTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemAlarmTypeMaxFields'] = ResolversParentTypes['BusinessQueueItemAlarmTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemAlarmTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemAlarmTypeMinFields'] = ResolversParentTypes['BusinessQueueItemAlarmTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemAlarmTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemAlarmTypeMutationResponse'] = ResolversParentTypes['BusinessQueueItemAlarmTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['BusinessQueueItemAlarmType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemAlarmsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemAlarms'] = ResolversParentTypes['BusinessQueueItemAlarms']> = {
  absoluteDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  alarmSelectionType?: Resolver<ResolversTypes['BusinessQueueItemAlarmTypeEnum'], ParentType, ContextType>;
  calendarId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  organizationUserId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  queueItem?: Resolver<Maybe<ResolversTypes['queueItem']>, ParentType, ContextType>;
  queueItemId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  relativeOffset?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemAlarmsAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemAlarmsAggregate'] = ResolversParentTypes['BusinessQueueItemAlarmsAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['BusinessQueueItemAlarmsAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['BusinessQueueItemAlarms']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemAlarmsAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemAlarmsAggregateFields'] = ResolversParentTypes['BusinessQueueItemAlarmsAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['BusinessQueueItemAlarmsAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<BusinessQueueItemAlarmsAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['BusinessQueueItemAlarmsMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['BusinessQueueItemAlarmsMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['BusinessQueueItemAlarmsStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['BusinessQueueItemAlarmsStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['BusinessQueueItemAlarmsStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['BusinessQueueItemAlarmsSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['BusinessQueueItemAlarmsVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['BusinessQueueItemAlarmsVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['BusinessQueueItemAlarmsVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemAlarmsAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemAlarmsAvgFields'] = ResolversParentTypes['BusinessQueueItemAlarmsAvgFields']> = {
  relativeOffset?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemAlarmsMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemAlarmsMaxFields'] = ResolversParentTypes['BusinessQueueItemAlarmsMaxFields']> = {
  absoluteDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  calendarId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  queueItemId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  relativeOffset?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemAlarmsMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemAlarmsMinFields'] = ResolversParentTypes['BusinessQueueItemAlarmsMinFields']> = {
  absoluteDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  calendarId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  queueItemId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  relativeOffset?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemAlarmsMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemAlarmsMutationResponse'] = ResolversParentTypes['BusinessQueueItemAlarmsMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['BusinessQueueItemAlarms']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemAlarmsStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemAlarmsStddevFields'] = ResolversParentTypes['BusinessQueueItemAlarmsStddevFields']> = {
  relativeOffset?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemAlarmsStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemAlarmsStddevPopFields'] = ResolversParentTypes['BusinessQueueItemAlarmsStddevPopFields']> = {
  relativeOffset?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemAlarmsStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemAlarmsStddevSampFields'] = ResolversParentTypes['BusinessQueueItemAlarmsStddevSampFields']> = {
  relativeOffset?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemAlarmsSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemAlarmsSumFields'] = ResolversParentTypes['BusinessQueueItemAlarmsSumFields']> = {
  relativeOffset?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemAlarmsVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemAlarmsVarPopFields'] = ResolversParentTypes['BusinessQueueItemAlarmsVarPopFields']> = {
  relativeOffset?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemAlarmsVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemAlarmsVarSampFields'] = ResolversParentTypes['BusinessQueueItemAlarmsVarSampFields']> = {
  relativeOffset?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemAlarmsVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemAlarmsVarianceFields'] = ResolversParentTypes['BusinessQueueItemAlarmsVarianceFields']> = {
  relativeOffset?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemDomainUsersViewResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemDomainUsersView'] = ResolversParentTypes['BusinessQueueItemDomainUsersView']> = {
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  domainOrganizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  domainUserUuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationUser?: Resolver<Maybe<ResolversTypes['organizationUser']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  queItemId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  queueItem?: Resolver<Maybe<ResolversTypes['queueItem']>, ParentType, ContextType>;
  relOrganizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  spamScore?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  triggerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  triggerTime?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemDomainUsersViewAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemDomainUsersViewAggregate'] = ResolversParentTypes['BusinessQueueItemDomainUsersViewAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['BusinessQueueItemDomainUsersViewAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['BusinessQueueItemDomainUsersView']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemDomainUsersViewAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemDomainUsersViewAggregateFields'] = ResolversParentTypes['BusinessQueueItemDomainUsersViewAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['BusinessQueueItemDomainUsersViewAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<BusinessQueueItemDomainUsersViewAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['BusinessQueueItemDomainUsersViewMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['BusinessQueueItemDomainUsersViewMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['BusinessQueueItemDomainUsersViewStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['BusinessQueueItemDomainUsersViewStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['BusinessQueueItemDomainUsersViewStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['BusinessQueueItemDomainUsersViewSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['BusinessQueueItemDomainUsersViewVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['BusinessQueueItemDomainUsersViewVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['BusinessQueueItemDomainUsersViewVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemDomainUsersViewAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemDomainUsersViewAvgFields'] = ResolversParentTypes['BusinessQueueItemDomainUsersViewAvgFields']> = {
  spamScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemDomainUsersViewMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemDomainUsersViewMaxFields'] = ResolversParentTypes['BusinessQueueItemDomainUsersViewMaxFields']> = {
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  domainOrganizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  domainUserUuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  queItemId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  relOrganizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  spamScore?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  triggerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  triggerTime?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemDomainUsersViewMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemDomainUsersViewMinFields'] = ResolversParentTypes['BusinessQueueItemDomainUsersViewMinFields']> = {
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  domainOrganizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  domainUserUuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  queItemId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  relOrganizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  spamScore?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  triggerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  triggerTime?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemDomainUsersViewStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemDomainUsersViewStddevFields'] = ResolversParentTypes['BusinessQueueItemDomainUsersViewStddevFields']> = {
  spamScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemDomainUsersViewStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemDomainUsersViewStddevPopFields'] = ResolversParentTypes['BusinessQueueItemDomainUsersViewStddevPopFields']> = {
  spamScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemDomainUsersViewStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemDomainUsersViewStddevSampFields'] = ResolversParentTypes['BusinessQueueItemDomainUsersViewStddevSampFields']> = {
  spamScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemDomainUsersViewSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemDomainUsersViewSumFields'] = ResolversParentTypes['BusinessQueueItemDomainUsersViewSumFields']> = {
  spamScore?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemDomainUsersViewVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemDomainUsersViewVarPopFields'] = ResolversParentTypes['BusinessQueueItemDomainUsersViewVarPopFields']> = {
  spamScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemDomainUsersViewVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemDomainUsersViewVarSampFields'] = ResolversParentTypes['BusinessQueueItemDomainUsersViewVarSampFields']> = {
  spamScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemDomainUsersViewVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemDomainUsersViewVarianceFields'] = ResolversParentTypes['BusinessQueueItemDomainUsersViewVarianceFields']> = {
  spamScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemOrganizationUsersViewResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemOrganizationUsersView'] = ResolversParentTypes['BusinessQueueItemOrganizationUsersView']> = {
  company?: Resolver<Maybe<ResolversTypes['organizationUser']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organization?: Resolver<Maybe<ResolversTypes['organization']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  queItemId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemOrganizationUsersViewAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemOrganizationUsersViewAggregate'] = ResolversParentTypes['BusinessQueueItemOrganizationUsersViewAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['BusinessQueueItemOrganizationUsersViewAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['BusinessQueueItemOrganizationUsersView']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemOrganizationUsersViewAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemOrganizationUsersViewAggregateFields'] = ResolversParentTypes['BusinessQueueItemOrganizationUsersViewAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<BusinessQueueItemOrganizationUsersViewAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['BusinessQueueItemOrganizationUsersViewMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['BusinessQueueItemOrganizationUsersViewMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemOrganizationUsersViewMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemOrganizationUsersViewMaxFields'] = ResolversParentTypes['BusinessQueueItemOrganizationUsersViewMaxFields']> = {
  companyId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  queItemId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemOrganizationUsersViewMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemOrganizationUsersViewMinFields'] = ResolversParentTypes['BusinessQueueItemOrganizationUsersViewMinFields']> = {
  companyId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  queItemId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemParticipantChannelTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemParticipantChannelType'] = ResolversParentTypes['BusinessQueueItemParticipantChannelType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemParticipantChannelTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemParticipantChannelTypeAggregate'] = ResolversParentTypes['BusinessQueueItemParticipantChannelTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['BusinessQueueItemParticipantChannelTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['BusinessQueueItemParticipantChannelType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemParticipantChannelTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemParticipantChannelTypeAggregateFields'] = ResolversParentTypes['BusinessQueueItemParticipantChannelTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<BusinessQueueItemParticipantChannelTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['BusinessQueueItemParticipantChannelTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['BusinessQueueItemParticipantChannelTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemParticipantChannelTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemParticipantChannelTypeMaxFields'] = ResolversParentTypes['BusinessQueueItemParticipantChannelTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemParticipantChannelTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemParticipantChannelTypeMinFields'] = ResolversParentTypes['BusinessQueueItemParticipantChannelTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemParticipantChannelTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemParticipantChannelTypeMutationResponse'] = ResolversParentTypes['BusinessQueueItemParticipantChannelTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['BusinessQueueItemParticipantChannelType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemParticipantsViewResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemParticipantsView'] = ResolversParentTypes['BusinessQueueItemParticipantsView']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  queItemId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  queueItem?: Resolver<Maybe<ResolversTypes['queueItem']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemParticipantsViewAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemParticipantsViewAggregate'] = ResolversParentTypes['BusinessQueueItemParticipantsViewAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['BusinessQueueItemParticipantsViewAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['BusinessQueueItemParticipantsView']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemParticipantsViewAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemParticipantsViewAggregateFields'] = ResolversParentTypes['BusinessQueueItemParticipantsViewAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<BusinessQueueItemParticipantsViewAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['BusinessQueueItemParticipantsViewMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['BusinessQueueItemParticipantsViewMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemParticipantsViewMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemParticipantsViewMaxFields'] = ResolversParentTypes['BusinessQueueItemParticipantsViewMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  queItemId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemParticipantsViewMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemParticipantsViewMinFields'] = ResolversParentTypes['BusinessQueueItemParticipantsViewMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  queItemId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemSubTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemSubType'] = ResolversParentTypes['BusinessQueueItemSubType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemSubTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemSubTypeAggregate'] = ResolversParentTypes['BusinessQueueItemSubTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['BusinessQueueItemSubTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['BusinessQueueItemSubType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemSubTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemSubTypeAggregateFields'] = ResolversParentTypes['BusinessQueueItemSubTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<BusinessQueueItemSubTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['BusinessQueueItemSubTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['BusinessQueueItemSubTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemSubTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemSubTypeMaxFields'] = ResolversParentTypes['BusinessQueueItemSubTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemSubTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemSubTypeMinFields'] = ResolversParentTypes['BusinessQueueItemSubTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessQueueItemSubTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessQueueItemSubTypeMutationResponse'] = ResolversParentTypes['BusinessQueueItemSubTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['BusinessQueueItemSubType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessUserContactNumbersResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessUserContactNumbers'] = ResolversParentTypes['BusinessUserContactNumbers']> = {
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  digits?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  isPrimary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  origId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  userContact?: Resolver<ResolversTypes['businessUserContacts'], ParentType, ContextType>;
  userContactId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessUserContactNumbersAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessUserContactNumbersAggregate'] = ResolversParentTypes['BusinessUserContactNumbersAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['BusinessUserContactNumbersAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['BusinessUserContactNumbers']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessUserContactNumbersAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessUserContactNumbersAggregateFields'] = ResolversParentTypes['BusinessUserContactNumbersAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<BusinessUserContactNumbersAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['BusinessUserContactNumbersMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['BusinessUserContactNumbersMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessUserContactNumbersMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessUserContactNumbersMaxFields'] = ResolversParentTypes['BusinessUserContactNumbersMaxFields']> = {
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  digits?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  origId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userContactId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessUserContactNumbersMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessUserContactNumbersMinFields'] = ResolversParentTypes['BusinessUserContactNumbersMinFields']> = {
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  digits?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  origId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userContactId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessUserContactNumbersMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessUserContactNumbersMutationResponse'] = ResolversParentTypes['BusinessUserContactNumbersMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['BusinessUserContactNumbers']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessUserFeedResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessUserFeed'] = ResolversParentTypes['BusinessUserFeed']> = {
  completed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timetz']>, ParentType, ContextType>;
  extraData?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<BusinessUserFeedextraDataArgs>>;
  feedSeen?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  feedType?: Resolver<ResolversTypes['BusinessFeedTypeEnum'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  important?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  subtitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessUserFeedAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessUserFeedAggregate'] = ResolversParentTypes['BusinessUserFeedAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['BusinessUserFeedAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['BusinessUserFeed']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessUserFeedAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessUserFeedAggregateFields'] = ResolversParentTypes['BusinessUserFeedAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<BusinessUserFeedAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['BusinessUserFeedMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['BusinessUserFeedMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessUserFeedMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessUserFeedMaxFields'] = ResolversParentTypes['BusinessUserFeedMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timetz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  subtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessUserFeedMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessUserFeedMinFields'] = ResolversParentTypes['BusinessUserFeedMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timetz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  subtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessUserFeedMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessUserFeedMutationResponse'] = ResolversParentTypes['BusinessUserFeedMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['BusinessUserFeed']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessUserRequestStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessUserRequestStatus'] = ResolversParentTypes['BusinessUserRequestStatus']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessUserRequestStatusAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessUserRequestStatusAggregate'] = ResolversParentTypes['BusinessUserRequestStatusAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['BusinessUserRequestStatusAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['BusinessUserRequestStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessUserRequestStatusAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessUserRequestStatusAggregateFields'] = ResolversParentTypes['BusinessUserRequestStatusAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<BusinessUserRequestStatusAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['BusinessUserRequestStatusMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['BusinessUserRequestStatusMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessUserRequestStatusMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessUserRequestStatusMaxFields'] = ResolversParentTypes['BusinessUserRequestStatusMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessUserRequestStatusMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessUserRequestStatusMinFields'] = ResolversParentTypes['BusinessUserRequestStatusMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessUserRequestStatusMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessUserRequestStatusMutationResponse'] = ResolversParentTypes['BusinessUserRequestStatusMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['BusinessUserRequestStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessUserStatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessUserStates'] = ResolversParentTypes['BusinessUserStates']> = {
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  domainUser?: Resolver<ResolversTypes['domainUser'], ParentType, ContextType>;
  domainUserId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  queueItem?: Resolver<Maybe<ResolversTypes['queueItem']>, ParentType, ContextType>;
  queueItemId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessUserStatesAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessUserStatesAggregate'] = ResolversParentTypes['BusinessUserStatesAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['BusinessUserStatesAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['BusinessUserStates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessUserStatesAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessUserStatesAggregateFields'] = ResolversParentTypes['BusinessUserStatesAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<BusinessUserStatesAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['BusinessUserStatesMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['BusinessUserStatesMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessUserStatesMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessUserStatesMaxFields'] = ResolversParentTypes['BusinessUserStatesMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  domainUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  queueItemId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessUserStatesMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessUserStatesMinFields'] = ResolversParentTypes['BusinessUserStatesMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  domainUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  queueItemId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BusinessUserStatesMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessUserStatesMutationResponse'] = ResolversParentTypes['BusinessUserStatesMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['BusinessUserStates']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChangeOrganizationNameOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChangeOrganizationNameOutput'] = ResolversParentTypes['ChangeOrganizationNameOutput']> = {
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckOnetimeCodeOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckOnetimeCodeOutput'] = ResolversParentTypes['CheckOnetimeCodeOutput']> = {
  feedback?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckPhoneNumberOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckPhoneNumberOutput'] = ResolversParentTypes['CheckPhoneNumberOutput']> = {
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  formattedNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateSMSOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateSMSOutput'] = ResolversParentTypes['CreateSMSOutput']> = {
  resultCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmContextResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmContext'] = ResolversParentTypes['CrmContext']> = {
  catalystId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  crmType?: Resolver<Maybe<ResolversTypes['CrmCrmTypeEnum']>, ParentType, ContextType>;
  crmUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  entityType?: Resolver<Maybe<ResolversTypes['CrmUnifiedEntityTypeEnum']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['CrmContextTypeEnum']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  youtelloId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmContextAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmContextAggregate'] = ResolversParentTypes['CrmContextAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['CrmContextAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['CrmContext']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmContextAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmContextAggregateFields'] = ResolversParentTypes['CrmContextAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<CrmContextAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['CrmContextMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['CrmContextMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmContextMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmContextMaxFields'] = ResolversParentTypes['CrmContextMaxFields']> = {
  catalystId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  crmUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  youtelloId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmContextMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmContextMinFields'] = ResolversParentTypes['CrmContextMinFields']> = {
  catalystId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  crmUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  youtelloId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmContextMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmContextMutationResponse'] = ResolversParentTypes['CrmContextMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['CrmContext']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmContextTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmContextType'] = ResolversParentTypes['CrmContextType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmContextTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmContextTypeAggregate'] = ResolversParentTypes['CrmContextTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['CrmContextTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['CrmContextType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmContextTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmContextTypeAggregateFields'] = ResolversParentTypes['CrmContextTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<CrmContextTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['CrmContextTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['CrmContextTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmContextTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmContextTypeMaxFields'] = ResolversParentTypes['CrmContextTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmContextTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmContextTypeMinFields'] = ResolversParentTypes['CrmContextTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmContextTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmContextTypeMutationResponse'] = ResolversParentTypes['CrmContextTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['CrmContextType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmCreatorTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmCreatorType'] = ResolversParentTypes['CrmCreatorType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmCreatorTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmCreatorTypeAggregate'] = ResolversParentTypes['CrmCreatorTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['CrmCreatorTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['CrmCreatorType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmCreatorTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmCreatorTypeAggregateFields'] = ResolversParentTypes['CrmCreatorTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<CrmCreatorTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['CrmCreatorTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['CrmCreatorTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmCreatorTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmCreatorTypeMaxFields'] = ResolversParentTypes['CrmCreatorTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmCreatorTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmCreatorTypeMinFields'] = ResolversParentTypes['CrmCreatorTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmCreatorTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmCreatorTypeMutationResponse'] = ResolversParentTypes['CrmCreatorTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['CrmCreatorType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmCrmTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmCrmType'] = ResolversParentTypes['CrmCrmType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmCrmTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmCrmTypeAggregate'] = ResolversParentTypes['CrmCrmTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['CrmCrmTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['CrmCrmType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmCrmTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmCrmTypeAggregateFields'] = ResolversParentTypes['CrmCrmTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<CrmCrmTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['CrmCrmTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['CrmCrmTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmCrmTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmCrmTypeMaxFields'] = ResolversParentTypes['CrmCrmTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmCrmTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmCrmTypeMinFields'] = ResolversParentTypes['CrmCrmTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmCrmTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmCrmTypeMutationResponse'] = ResolversParentTypes['CrmCrmTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['CrmCrmType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmDirectionTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmDirectionType'] = ResolversParentTypes['CrmDirectionType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmDirectionTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmDirectionTypeAggregate'] = ResolversParentTypes['CrmDirectionTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['CrmDirectionTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['CrmDirectionType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmDirectionTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmDirectionTypeAggregateFields'] = ResolversParentTypes['CrmDirectionTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<CrmDirectionTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['CrmDirectionTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['CrmDirectionTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmDirectionTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmDirectionTypeMaxFields'] = ResolversParentTypes['CrmDirectionTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmDirectionTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmDirectionTypeMinFields'] = ResolversParentTypes['CrmDirectionTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmDirectionTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmDirectionTypeMutationResponse'] = ResolversParentTypes['CrmDirectionTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['CrmDirectionType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmEntity'] = ResolversParentTypes['CrmEntity']> = {
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['CrmUnifiedEntityTypeEnum']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmEntityAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmEntityAggregate'] = ResolversParentTypes['CrmEntityAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['CrmEntityAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['CrmEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmEntityAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmEntityAggregateFields'] = ResolversParentTypes['CrmEntityAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<CrmEntityAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['CrmEntityMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['CrmEntityMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmEntityMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmEntityMaxFields'] = ResolversParentTypes['CrmEntityMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmEntityMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmEntityMinFields'] = ResolversParentTypes['CrmEntityMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmEntityMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmEntityMutationResponse'] = ResolversParentTypes['CrmEntityMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['CrmEntity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmEvent'] = ResolversParentTypes['CrmEvent']> = {
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  originatingSystem?: Resolver<Maybe<ResolversTypes['CrmSystemTypeEnum']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['CrmEventTypeEnum']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmEventAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmEventAggregate'] = ResolversParentTypes['CrmEventAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['CrmEventAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['CrmEvent']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmEventAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmEventAggregateFields'] = ResolversParentTypes['CrmEventAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<CrmEventAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['CrmEventMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['CrmEventMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmEventMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmEventMaxFields'] = ResolversParentTypes['CrmEventMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmEventMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmEventMinFields'] = ResolversParentTypes['CrmEventMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmEventMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmEventMutationResponse'] = ResolversParentTypes['CrmEventMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['CrmEvent']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmEventTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmEventType'] = ResolversParentTypes['CrmEventType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmEventTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmEventTypeAggregate'] = ResolversParentTypes['CrmEventTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['CrmEventTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['CrmEventType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmEventTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmEventTypeAggregateFields'] = ResolversParentTypes['CrmEventTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<CrmEventTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['CrmEventTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['CrmEventTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmEventTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmEventTypeMaxFields'] = ResolversParentTypes['CrmEventTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmEventTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmEventTypeMinFields'] = ResolversParentTypes['CrmEventTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmEventTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmEventTypeMutationResponse'] = ResolversParentTypes['CrmEventTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['CrmEventType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmStatusCodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmStatusCode'] = ResolversParentTypes['CrmStatusCode']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmStatusCodeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmStatusCodeAggregate'] = ResolversParentTypes['CrmStatusCodeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['CrmStatusCodeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['CrmStatusCode']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmStatusCodeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmStatusCodeAggregateFields'] = ResolversParentTypes['CrmStatusCodeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<CrmStatusCodeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['CrmStatusCodeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['CrmStatusCodeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmStatusCodeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmStatusCodeMaxFields'] = ResolversParentTypes['CrmStatusCodeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmStatusCodeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmStatusCodeMinFields'] = ResolversParentTypes['CrmStatusCodeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmStatusCodeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmStatusCodeMutationResponse'] = ResolversParentTypes['CrmStatusCodeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['CrmStatusCode']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmSystemTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmSystemType'] = ResolversParentTypes['CrmSystemType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmSystemTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmSystemTypeAggregate'] = ResolversParentTypes['CrmSystemTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['CrmSystemTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['CrmSystemType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmSystemTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmSystemTypeAggregateFields'] = ResolversParentTypes['CrmSystemTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<CrmSystemTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['CrmSystemTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['CrmSystemTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmSystemTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmSystemTypeMaxFields'] = ResolversParentTypes['CrmSystemTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmSystemTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmSystemTypeMinFields'] = ResolversParentTypes['CrmSystemTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmSystemTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmSystemTypeMutationResponse'] = ResolversParentTypes['CrmSystemTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['CrmSystemType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmTraceContextResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmTraceContext'] = ResolversParentTypes['CrmTraceContext']> = {
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  spanId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  traceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmTraceContextAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmTraceContextAggregate'] = ResolversParentTypes['CrmTraceContextAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['CrmTraceContextAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['CrmTraceContext']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmTraceContextAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmTraceContextAggregateFields'] = ResolversParentTypes['CrmTraceContextAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<CrmTraceContextAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['CrmTraceContextMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['CrmTraceContextMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmTraceContextMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmTraceContextMaxFields'] = ResolversParentTypes['CrmTraceContextMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  spanId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  traceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmTraceContextMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmTraceContextMinFields'] = ResolversParentTypes['CrmTraceContextMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  spanId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  traceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmTraceContextMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmTraceContextMutationResponse'] = ResolversParentTypes['CrmTraceContextMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['CrmTraceContext']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmUnifiedEntityTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmUnifiedEntityType'] = ResolversParentTypes['CrmUnifiedEntityType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmUnifiedEntityTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmUnifiedEntityTypeAggregate'] = ResolversParentTypes['CrmUnifiedEntityTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['CrmUnifiedEntityTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['CrmUnifiedEntityType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmUnifiedEntityTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmUnifiedEntityTypeAggregateFields'] = ResolversParentTypes['CrmUnifiedEntityTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<CrmUnifiedEntityTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['CrmUnifiedEntityTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['CrmUnifiedEntityTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmUnifiedEntityTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmUnifiedEntityTypeMaxFields'] = ResolversParentTypes['CrmUnifiedEntityTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmUnifiedEntityTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmUnifiedEntityTypeMinFields'] = ResolversParentTypes['CrmUnifiedEntityTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrmUnifiedEntityTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['CrmUnifiedEntityTypeMutationResponse'] = ResolversParentTypes['CrmUnifiedEntityTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['CrmUnifiedEntityType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteRequestUserOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteRequestUserOutput'] = ResolversParentTypes['DeleteRequestUserOutput']> = {
  result?: Resolver<ResolversTypes['jsonb'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteUserOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteUserOutput'] = ResolversParentTypes['DeleteUserOutput']> = {
  result?: Resolver<ResolversTypes['jsonb'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingEmailAccountSubscribersResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingEmailAccountSubscribers'] = ResolversParentTypes['EmailingEmailAccountSubscribers']> = {
  createdAt?: Resolver<ResolversTypes['Emailingtimestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  providerAccount?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Emailingtimestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingEmailAccountSubscribersAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingEmailAccountSubscribersAggregate'] = ResolversParentTypes['EmailingEmailAccountSubscribersAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['EmailingEmailAccountSubscribersAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['EmailingEmailAccountSubscribers']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingEmailAccountSubscribersAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingEmailAccountSubscribersAggregateFields'] = ResolversParentTypes['EmailingEmailAccountSubscribersAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<EmailingEmailAccountSubscribersAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['EmailingEmailAccountSubscribersMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['EmailingEmailAccountSubscribersMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingEmailAccountSubscribersMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingEmailAccountSubscribersMaxFields'] = ResolversParentTypes['EmailingEmailAccountSubscribersMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  providerAccount?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingEmailAccountSubscribersMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingEmailAccountSubscribersMinFields'] = ResolversParentTypes['EmailingEmailAccountSubscribersMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  providerAccount?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingEmailAccountSubscribersMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingEmailAccountSubscribersMutationResponse'] = ResolversParentTypes['EmailingEmailAccountSubscribersMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['EmailingEmailAccountSubscribers']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingEmailActivityTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingEmailActivityType'] = ResolversParentTypes['EmailingEmailActivityType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingEmailActivityTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingEmailActivityTypeAggregate'] = ResolversParentTypes['EmailingEmailActivityTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['EmailingEmailActivityTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['EmailingEmailActivityType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingEmailActivityTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingEmailActivityTypeAggregateFields'] = ResolversParentTypes['EmailingEmailActivityTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<EmailingEmailActivityTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['EmailingEmailActivityTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['EmailingEmailActivityTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingEmailActivityTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingEmailActivityTypeMaxFields'] = ResolversParentTypes['EmailingEmailActivityTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingEmailActivityTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingEmailActivityTypeMinFields'] = ResolversParentTypes['EmailingEmailActivityTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingEmailActivityTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingEmailActivityTypeMutationResponse'] = ResolversParentTypes['EmailingEmailActivityTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['EmailingEmailActivityType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingEmailCommentResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingEmailComment'] = ResolversParentTypes['EmailingEmailComment']> = {
  activity?: Resolver<ResolversTypes['Emailingactivity'], ParentType, ContextType>;
  activityId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Emailingtimestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Emailingtimestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingEmailCommentAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingEmailCommentAggregate'] = ResolversParentTypes['EmailingEmailCommentAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['EmailingEmailCommentAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['EmailingEmailComment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingEmailCommentAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingEmailCommentAggregateFields'] = ResolversParentTypes['EmailingEmailCommentAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<EmailingEmailCommentAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['EmailingEmailCommentMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['EmailingEmailCommentMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingEmailCommentMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingEmailCommentMaxFields'] = ResolversParentTypes['EmailingEmailCommentMaxFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingEmailCommentMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingEmailCommentMinFields'] = ResolversParentTypes['EmailingEmailCommentMinFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingEmailCommentMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingEmailCommentMutationResponse'] = ResolversParentTypes['EmailingEmailCommentMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['EmailingEmailComment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingactivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['Emailingactivity'] = ResolversParentTypes['Emailingactivity']> = {
  activityActivityUuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  activityParticipants?: Resolver<Array<ResolversTypes['EmailingactivityParticipant']>, ParentType, ContextType, Partial<EmailingactivityactivityParticipantsArgs>>;
  activityParticipantsAggregate?: Resolver<ResolversTypes['EmailingactivityParticipantAggregate'], ParentType, ContextType, Partial<EmailingactivityactivityParticipantsAggregateArgs>>;
  comments?: Resolver<Array<ResolversTypes['EmailingEmailComment']>, ParentType, ContextType, Partial<EmailingactivitycommentsArgs>>;
  commentsAggregate?: Resolver<ResolversTypes['EmailingEmailCommentAggregate'], ParentType, ContextType, Partial<EmailingactivitycommentsAggregateArgs>>;
  conversationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conversationSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Emailingtimestamptz'], ParentType, ContextType>;
  direction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailProviderType?: Resolver<Maybe<ResolversTypes['EmailingproviderTypeEnum']>, ParentType, ContextType>;
  endedAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  fromAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  providerType?: Resolver<Maybe<ResolversTypes['EmailingproviderType']>, ParentType, ContextType>;
  startedAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  subject?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toAddresses?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['EmailingEmailActivityTypeEnum']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Emailingtimestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingactivityAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingactivityAggregate'] = ResolversParentTypes['EmailingactivityAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['EmailingactivityAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Emailingactivity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingactivityAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingactivityAggregateFields'] = ResolversParentTypes['EmailingactivityAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['EmailingactivityAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<EmailingactivityAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['EmailingactivityMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['EmailingactivityMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['EmailingactivityStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['EmailingactivityStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['EmailingactivityStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['EmailingactivitySumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['EmailingactivityVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['EmailingactivityVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['EmailingactivityVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingactivityAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingactivityAvgFields'] = ResolversParentTypes['EmailingactivityAvgFields']> = {
  conversationSize?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingactivityMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingactivityMaxFields'] = ResolversParentTypes['EmailingactivityMaxFields']> = {
  activityActivityUuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  conversationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conversationSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  direction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endedAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  fromAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  startedAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  subject?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toAddresses?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingactivityMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingactivityMinFields'] = ResolversParentTypes['EmailingactivityMinFields']> = {
  activityActivityUuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  conversationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conversationSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  direction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endedAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  fromAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  startedAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  subject?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toAddresses?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingactivityMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingactivityMutationResponse'] = ResolversParentTypes['EmailingactivityMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['Emailingactivity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingactivityParticipantResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingactivityParticipant'] = ResolversParentTypes['EmailingactivityParticipant']> = {
  activity?: Resolver<Maybe<ResolversTypes['Emailingactivity']>, ParentType, ContextType>;
  activityActivityUuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Emailingtimestamptz'], ParentType, ContextType>;
  domainUser?: Resolver<Maybe<ResolversTypes['EmailingdomainUser']>, ParentType, ContextType>;
  domainUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['EmailingactivityParticipantRoleEnum']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Emailingtimestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingactivityParticipantAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingactivityParticipantAggregate'] = ResolversParentTypes['EmailingactivityParticipantAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['EmailingactivityParticipantAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['EmailingactivityParticipant']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingactivityParticipantAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingactivityParticipantAggregateFields'] = ResolversParentTypes['EmailingactivityParticipantAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<EmailingactivityParticipantAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['EmailingactivityParticipantMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['EmailingactivityParticipantMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingactivityParticipantMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingactivityParticipantMaxFields'] = ResolversParentTypes['EmailingactivityParticipantMaxFields']> = {
  activityActivityUuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  domainUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingactivityParticipantMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingactivityParticipantMinFields'] = ResolversParentTypes['EmailingactivityParticipantMinFields']> = {
  activityActivityUuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  domainUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingactivityParticipantMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingactivityParticipantMutationResponse'] = ResolversParentTypes['EmailingactivityParticipantMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['EmailingactivityParticipant']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingactivityParticipantRoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingactivityParticipantRole'] = ResolversParentTypes['EmailingactivityParticipantRole']> = {
  activityParticipants?: Resolver<Array<ResolversTypes['EmailingactivityParticipant']>, ParentType, ContextType, Partial<EmailingactivityParticipantRoleactivityParticipantsArgs>>;
  activityParticipantsAggregate?: Resolver<ResolversTypes['EmailingactivityParticipantAggregate'], ParentType, ContextType, Partial<EmailingactivityParticipantRoleactivityParticipantsAggregateArgs>>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingactivityParticipantRoleAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingactivityParticipantRoleAggregate'] = ResolversParentTypes['EmailingactivityParticipantRoleAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['EmailingactivityParticipantRoleAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['EmailingactivityParticipantRole']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingactivityParticipantRoleAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingactivityParticipantRoleAggregateFields'] = ResolversParentTypes['EmailingactivityParticipantRoleAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<EmailingactivityParticipantRoleAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['EmailingactivityParticipantRoleMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['EmailingactivityParticipantRoleMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingactivityParticipantRoleMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingactivityParticipantRoleMaxFields'] = ResolversParentTypes['EmailingactivityParticipantRoleMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingactivityParticipantRoleMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingactivityParticipantRoleMinFields'] = ResolversParentTypes['EmailingactivityParticipantRoleMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingactivityParticipantRoleMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingactivityParticipantRoleMutationResponse'] = ResolversParentTypes['EmailingactivityParticipantRoleMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['EmailingactivityParticipantRole']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingactivityStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingactivityStddevFields'] = ResolversParentTypes['EmailingactivityStddevFields']> = {
  conversationSize?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingactivityStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingactivityStddevPopFields'] = ResolversParentTypes['EmailingactivityStddevPopFields']> = {
  conversationSize?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingactivityStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingactivityStddevSampFields'] = ResolversParentTypes['EmailingactivityStddevSampFields']> = {
  conversationSize?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingactivitySumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingactivitySumFields'] = ResolversParentTypes['EmailingactivitySumFields']> = {
  conversationSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingactivityVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingactivityVarPopFields'] = ResolversParentTypes['EmailingactivityVarPopFields']> = {
  conversationSize?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingactivityVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingactivityVarSampFields'] = ResolversParentTypes['EmailingactivityVarSampFields']> = {
  conversationSize?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingactivityVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingactivityVarianceFields'] = ResolversParentTypes['EmailingactivityVarianceFields']> = {
  conversationSize?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingdomainOrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingdomainOrganization'] = ResolversParentTypes['EmailingdomainOrganization']> = {
  createdAt?: Resolver<ResolversTypes['Emailingtimestamptz'], ParentType, ContextType>;
  domainUsers?: Resolver<Array<ResolversTypes['EmailingdomainUser']>, ParentType, ContextType, Partial<EmailingdomainOrganizationdomainUsersArgs>>;
  domainUsersAggregate?: Resolver<ResolversTypes['EmailingdomainUserAggregate'], ParentType, ContextType, Partial<EmailingdomainOrganizationdomainUsersAggregateArgs>>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Emailingtimestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingdomainOrganizationAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingdomainOrganizationAggregate'] = ResolversParentTypes['EmailingdomainOrganizationAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['EmailingdomainOrganizationAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['EmailingdomainOrganization']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingdomainOrganizationAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingdomainOrganizationAggregateFields'] = ResolversParentTypes['EmailingdomainOrganizationAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<EmailingdomainOrganizationAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['EmailingdomainOrganizationMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['EmailingdomainOrganizationMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingdomainOrganizationMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingdomainOrganizationMaxFields'] = ResolversParentTypes['EmailingdomainOrganizationMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingdomainOrganizationMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingdomainOrganizationMinFields'] = ResolversParentTypes['EmailingdomainOrganizationMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingdomainOrganizationMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingdomainOrganizationMutationResponse'] = ResolversParentTypes['EmailingdomainOrganizationMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['EmailingdomainOrganization']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingdomainUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingdomainUser'] = ResolversParentTypes['EmailingdomainUser']> = {
  activityParticipants?: Resolver<Array<ResolversTypes['EmailingactivityParticipant']>, ParentType, ContextType, Partial<EmailingdomainUseractivityParticipantsArgs>>;
  activityParticipantsAggregate?: Resolver<ResolversTypes['EmailingactivityParticipantAggregate'], ParentType, ContextType, Partial<EmailingdomainUseractivityParticipantsAggregateArgs>>;
  category?: Resolver<Maybe<ResolversTypes['EmailingdomainUserCategoryEnum']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Emailingtimestamptz'], ParentType, ContextType>;
  domainOrganization?: Resolver<ResolversTypes['EmailingdomainOrganization'], ParentType, ContextType>;
  domainOrganizationId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  domainUserCategory?: Resolver<Maybe<ResolversTypes['EmailingdomainUserCategory']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Emailingtimestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingdomainUserAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingdomainUserAggregate'] = ResolversParentTypes['EmailingdomainUserAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['EmailingdomainUserAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['EmailingdomainUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingdomainUserAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingdomainUserAggregateFields'] = ResolversParentTypes['EmailingdomainUserAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<EmailingdomainUserAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['EmailingdomainUserMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['EmailingdomainUserMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingdomainUserCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingdomainUserCategory'] = ResolversParentTypes['EmailingdomainUserCategory']> = {
  domainUsers?: Resolver<Array<ResolversTypes['EmailingdomainUser']>, ParentType, ContextType, Partial<EmailingdomainUserCategorydomainUsersArgs>>;
  domainUsersAggregate?: Resolver<ResolversTypes['EmailingdomainUserAggregate'], ParentType, ContextType, Partial<EmailingdomainUserCategorydomainUsersAggregateArgs>>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingdomainUserCategoryAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingdomainUserCategoryAggregate'] = ResolversParentTypes['EmailingdomainUserCategoryAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['EmailingdomainUserCategoryAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['EmailingdomainUserCategory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingdomainUserCategoryAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingdomainUserCategoryAggregateFields'] = ResolversParentTypes['EmailingdomainUserCategoryAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<EmailingdomainUserCategoryAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['EmailingdomainUserCategoryMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['EmailingdomainUserCategoryMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingdomainUserCategoryMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingdomainUserCategoryMaxFields'] = ResolversParentTypes['EmailingdomainUserCategoryMaxFields']> = {
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingdomainUserCategoryMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingdomainUserCategoryMinFields'] = ResolversParentTypes['EmailingdomainUserCategoryMinFields']> = {
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingdomainUserCategoryMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingdomainUserCategoryMutationResponse'] = ResolversParentTypes['EmailingdomainUserCategoryMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['EmailingdomainUserCategory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingdomainUserMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingdomainUserMaxFields'] = ResolversParentTypes['EmailingdomainUserMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  domainOrganizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingdomainUserMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingdomainUserMinFields'] = ResolversParentTypes['EmailingdomainUserMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  domainOrganizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingdomainUserMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingdomainUserMutationResponse'] = ResolversParentTypes['EmailingdomainUserMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['EmailingdomainUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingeventResolvers<ContextType = any, ParentType extends ResolversParentTypes['Emailingevent'] = ResolversParentTypes['Emailingevent']> = {
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conversationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Emailingtimestamptz'], ParentType, ContextType>;
  emailId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailProviderType?: Resolver<Maybe<ResolversTypes['EmailingproviderTypeEnum']>, ParentType, ContextType>;
  hasAttachments?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  isDraft?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isRead?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastModifiedAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  providerType?: Resolver<Maybe<ResolversTypes['EmailingproviderType']>, ParentType, ContextType>;
  receivedAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  recipientEmailAddresses?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  senderEmailAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sentAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  subject?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Emailingtimestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingeventAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingeventAggregate'] = ResolversParentTypes['EmailingeventAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['EmailingeventAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Emailingevent']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingeventAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingeventAggregateFields'] = ResolversParentTypes['EmailingeventAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<EmailingeventAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['EmailingeventMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['EmailingeventMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingeventMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingeventMaxFields'] = ResolversParentTypes['EmailingeventMaxFields']> = {
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conversationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  emailId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastModifiedAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  receivedAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  recipientEmailAddresses?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  senderEmailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sentAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  subject?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingeventMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingeventMinFields'] = ResolversParentTypes['EmailingeventMinFields']> = {
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conversationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  emailId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastModifiedAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  receivedAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  recipientEmailAddresses?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  senderEmailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sentAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  subject?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingeventMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingeventMutationResponse'] = ResolversParentTypes['EmailingeventMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['Emailingevent']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface EmailingnumericScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Emailingnumeric'], any> {
  name: 'Emailingnumeric';
}

export type EmailingproviderAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingproviderAccount'] = ResolversParentTypes['EmailingproviderAccount']> = {
  accountSubscribers?: Resolver<Array<ResolversTypes['EmailingEmailAccountSubscribers']>, ParentType, ContextType, Partial<EmailingproviderAccountaccountSubscribersArgs>>;
  accountSubscribersAggregate?: Resolver<ResolversTypes['EmailingEmailAccountSubscribersAggregate'], ParentType, ContextType, Partial<EmailingproviderAccountaccountSubscribersAggregateArgs>>;
  createdAt?: Resolver<ResolversTypes['Emailingtimestamptz'], ParentType, ContextType>;
  domainOrganization?: Resolver<Array<ResolversTypes['EmailingdomainOrganization']>, ParentType, ContextType, Partial<EmailingproviderAccountdomainOrganizationArgs>>;
  domainOrganizationAggregate?: Resolver<ResolversTypes['EmailingdomainOrganizationAggregate'], ParentType, ContextType, Partial<EmailingproviderAccountdomainOrganizationAggregateArgs>>;
  domainUser?: Resolver<Maybe<ResolversTypes['EmailingdomainUser']>, ParentType, ContextType>;
  domainUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  historyId?: Resolver<Maybe<ResolversTypes['Emailingnumeric']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  idToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  linkedAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  providerType?: Resolver<Maybe<ResolversTypes['EmailingproviderType']>, ParentType, ContextType>;
  refreshToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionExpiration?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  subscriptionFolders?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['EmailingproviderTypeEnum']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Emailingtimestamptz'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingproviderAccountAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingproviderAccountAggregate'] = ResolversParentTypes['EmailingproviderAccountAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['EmailingproviderAccountAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['EmailingproviderAccount']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingproviderAccountAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingproviderAccountAggregateFields'] = ResolversParentTypes['EmailingproviderAccountAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['EmailingproviderAccountAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<EmailingproviderAccountAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['EmailingproviderAccountMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['EmailingproviderAccountMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['EmailingproviderAccountStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['EmailingproviderAccountStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['EmailingproviderAccountStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['EmailingproviderAccountSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['EmailingproviderAccountVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['EmailingproviderAccountVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['EmailingproviderAccountVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingproviderAccountAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingproviderAccountAvgFields'] = ResolversParentTypes['EmailingproviderAccountAvgFields']> = {
  historyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingproviderAccountMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingproviderAccountMaxFields'] = ResolversParentTypes['EmailingproviderAccountMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  domainUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  historyId?: Resolver<Maybe<ResolversTypes['Emailingnumeric']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  idToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  refreshToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionExpiration?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  subscriptionFolders?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingproviderAccountMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingproviderAccountMinFields'] = ResolversParentTypes['EmailingproviderAccountMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  domainUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  historyId?: Resolver<Maybe<ResolversTypes['Emailingnumeric']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  idToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  refreshToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionExpiration?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  subscriptionFolders?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Emailingtimestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingproviderAccountMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingproviderAccountMutationResponse'] = ResolversParentTypes['EmailingproviderAccountMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['EmailingproviderAccount']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingproviderAccountStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingproviderAccountStddevFields'] = ResolversParentTypes['EmailingproviderAccountStddevFields']> = {
  historyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingproviderAccountStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingproviderAccountStddevPopFields'] = ResolversParentTypes['EmailingproviderAccountStddevPopFields']> = {
  historyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingproviderAccountStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingproviderAccountStddevSampFields'] = ResolversParentTypes['EmailingproviderAccountStddevSampFields']> = {
  historyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingproviderAccountSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingproviderAccountSumFields'] = ResolversParentTypes['EmailingproviderAccountSumFields']> = {
  historyId?: Resolver<Maybe<ResolversTypes['Emailingnumeric']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingproviderAccountVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingproviderAccountVarPopFields'] = ResolversParentTypes['EmailingproviderAccountVarPopFields']> = {
  historyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingproviderAccountVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingproviderAccountVarSampFields'] = ResolversParentTypes['EmailingproviderAccountVarSampFields']> = {
  historyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingproviderAccountVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingproviderAccountVarianceFields'] = ResolversParentTypes['EmailingproviderAccountVarianceFields']> = {
  historyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingproviderTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingproviderType'] = ResolversParentTypes['EmailingproviderType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerAccounts?: Resolver<Array<ResolversTypes['EmailingproviderAccount']>, ParentType, ContextType, Partial<EmailingproviderTypeproviderAccountsArgs>>;
  providerAccountsAggregate?: Resolver<ResolversTypes['EmailingproviderAccountAggregate'], ParentType, ContextType, Partial<EmailingproviderTypeproviderAccountsAggregateArgs>>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingproviderTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingproviderTypeAggregate'] = ResolversParentTypes['EmailingproviderTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['EmailingproviderTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['EmailingproviderType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingproviderTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingproviderTypeAggregateFields'] = ResolversParentTypes['EmailingproviderTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<EmailingproviderTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['EmailingproviderTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['EmailingproviderTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingproviderTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingproviderTypeMaxFields'] = ResolversParentTypes['EmailingproviderTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingproviderTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingproviderTypeMinFields'] = ResolversParentTypes['EmailingproviderTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailingproviderTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailingproviderTypeMutationResponse'] = ResolversParentTypes['EmailingproviderTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['EmailingproviderType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface EmailingtimestamptzScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Emailingtimestamptz'], any> {
  name: 'Emailingtimestamptz';
}

export type GeodataAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataAddress'] = ResolversParentTypes['GeodataAddress']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Geodatatimestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Geodatauuid'], ParentType, ContextType>;
  lat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  long?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Geodatatimestamptz'], ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataAddressAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataAddressAggregate'] = ResolversParentTypes['GeodataAddressAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['GeodataAddressAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['GeodataAddress']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataAddressAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataAddressAggregateFields'] = ResolversParentTypes['GeodataAddressAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<GeodataAddressAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['GeodataAddressMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['GeodataAddressMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataAddressMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataAddressMaxFields'] = ResolversParentTypes['GeodataAddressMaxFields']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Geodatatimestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Geodatauuid']>, ParentType, ContextType>;
  lat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  long?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Geodatatimestamptz']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataAddressMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataAddressMinFields'] = ResolversParentTypes['GeodataAddressMinFields']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Geodatatimestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Geodatauuid']>, ParentType, ContextType>;
  lat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  long?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Geodatatimestamptz']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataAddressMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataAddressMutationResponse'] = ResolversParentTypes['GeodataAddressMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['GeodataAddress']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregate'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregateFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMaxFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMinFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMutationResponse'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaAtkomstResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomst'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomst']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  atkomstid?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  datauttaksdato?: Resolver<Maybe<ResolversTypes['Geodatatimestamptz']>, ParentType, ContextType>;
  navnerom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  objtype?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  offisielladresseMatrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  offisielladresseVegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  oppdateringsdato?: Resolver<Maybe<ResolversTypes['Geodatatimestamptz']>, ParentType, ContextType>;
  opphav?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  posisjon?: Resolver<Maybe<ResolversTypes['Geodatageometry']>, ParentType, ContextType>;
  typeatkomst?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuidadresse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuidatkomst?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  versjonid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregate'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomst']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregateFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaAtkomstAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstAvgFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstAvgFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  atkomstid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  offisielladresseMatrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  offisielladresseVegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaAtkomstMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstMaxFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstMaxFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  atkomstid?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  datauttaksdato?: Resolver<Maybe<ResolversTypes['Geodatatimestamptz']>, ParentType, ContextType>;
  navnerom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  objtype?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  offisielladresseMatrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  offisielladresseVegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  oppdateringsdato?: Resolver<Maybe<ResolversTypes['Geodatatimestamptz']>, ParentType, ContextType>;
  opphav?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeatkomst?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuidadresse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuidatkomst?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  versjonid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaAtkomstMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstMinFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstMinFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  atkomstid?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  datauttaksdato?: Resolver<Maybe<ResolversTypes['Geodatatimestamptz']>, ParentType, ContextType>;
  navnerom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  objtype?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  offisielladresseMatrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  offisielladresseVegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  oppdateringsdato?: Resolver<Maybe<ResolversTypes['Geodatatimestamptz']>, ParentType, ContextType>;
  opphav?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeatkomst?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuidadresse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuidatkomst?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  versjonid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaAtkomstMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstMutationResponse'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomst']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  atkomstid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  offisielladresseMatrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  offisielladresseVegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevPopFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevPopFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  atkomstid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  offisielladresseMatrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  offisielladresseVegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevSampFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevSampFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  atkomstid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  offisielladresseMatrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  offisielladresseVegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaAtkomstSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstSumFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstSumFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  atkomstid?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  offisielladresseMatrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  offisielladresseVegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaAtkomstVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstVarPopFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstVarPopFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  atkomstid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  offisielladresseMatrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  offisielladresseVegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaAtkomstVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstVarSampFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstVarSampFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  atkomstid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  offisielladresseMatrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  offisielladresseVegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaAtkomstVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstVarianceFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstVarianceFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  atkomstid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  offisielladresseMatrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  offisielladresseVegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaKommunenummerResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaKommunenummer'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaKommunenummer']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregate'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaKommunenummer']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregateFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaKommunenummerMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaKommunenummerMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaKommunenummerMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaKommunenummerMaxFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaKommunenummerMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaKommunenummerMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaKommunenummerMinFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaKommunenummerMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaKommunenummerMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaKommunenummerMutationResponse'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaKommunenummerMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaKommunenummer']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  adressetilleggsnavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  adressetilleggsnavnkilde?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bruksenhetid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bruksenhetsnummertekst?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  datauttaksdato?: Resolver<Maybe<ResolversTypes['Geodatatimestamptz']>, ParentType, ContextType>;
  grunnkretsnavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grunnkretsnummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kommunenavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kommunenummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetBruksnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetFestenummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetGardsnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetKommunenummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  navnerom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  objtype?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  offisielladressetekst?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  offisielladressetekstutenadressetilleggsnavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oppdateringsdato?: Resolver<Maybe<ResolversTypes['Geodatatimestamptz']>, ParentType, ContextType>;
  organisasjonsnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  postnummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  poststed?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  representasjonspunkt?: Resolver<Maybe<ResolversTypes['Geodatageometry']>, ParentType, ContextType>;
  soknenavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  soknenummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stedfestingverifisert?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  tettstednavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tettstednummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  undernummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uuidadresse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuidbruksenhet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valgkretsnavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valgkretsnummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  versjonid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregate'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregateFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid']> = {
  atkomstid?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  matrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregate'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregateFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAvgFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAvgFields']> = {
  atkomstid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMaxFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMaxFields']> = {
  atkomstid?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  matrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMinFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMinFields']> = {
  atkomstid?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  matrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMutationResponse'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevFields']> = {
  atkomstid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevPopFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevPopFields']> = {
  atkomstid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevSampFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevSampFields']> = {
  atkomstid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidSumFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidSumFields']> = {
  atkomstid?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  matrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarPopFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarPopFields']> = {
  atkomstid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarSampFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarSampFields']> = {
  atkomstid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarianceFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarianceFields']> = {
  atkomstid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAvgFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAvgFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetBruksnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetFestenummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetGardsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  organisasjonsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  undernummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMaxFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMaxFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  adressetilleggsnavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  adressetilleggsnavnkilde?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bruksenhetid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bruksenhetsnummertekst?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  datauttaksdato?: Resolver<Maybe<ResolversTypes['Geodatatimestamptz']>, ParentType, ContextType>;
  grunnkretsnavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grunnkretsnummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kommunenavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kommunenummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetBruksnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetFestenummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetGardsnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetKommunenummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  navnerom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  objtype?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  offisielladressetekst?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  offisielladressetekstutenadressetilleggsnavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oppdateringsdato?: Resolver<Maybe<ResolversTypes['Geodatatimestamptz']>, ParentType, ContextType>;
  organisasjonsnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  postnummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  poststed?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  soknenavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  soknenummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tettstednavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tettstednummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  undernummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uuidadresse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuidbruksenhet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valgkretsnavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valgkretsnummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  versjonid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMinFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMinFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  adressetilleggsnavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  adressetilleggsnavnkilde?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bruksenhetid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bruksenhetsnummertekst?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  datauttaksdato?: Resolver<Maybe<ResolversTypes['Geodatatimestamptz']>, ParentType, ContextType>;
  grunnkretsnavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grunnkretsnummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kommunenavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kommunenummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetBruksnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetFestenummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetGardsnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetKommunenummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  navnerom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  objtype?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  offisielladressetekst?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  offisielladressetekstutenadressetilleggsnavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oppdateringsdato?: Resolver<Maybe<ResolversTypes['Geodatatimestamptz']>, ParentType, ContextType>;
  organisasjonsnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  postnummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  poststed?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  soknenavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  soknenummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tettstednavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tettstednummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  undernummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uuidadresse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuidbruksenhet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valgkretsnavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valgkretsnummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  versjonid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMutationResponse'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetBruksnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetFestenummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetGardsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  organisasjonsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  undernummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevPopFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevPopFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetBruksnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetFestenummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetGardsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  organisasjonsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  undernummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevSampFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevSampFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetBruksnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetFestenummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetGardsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  organisasjonsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  undernummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetSumFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetSumFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetBruksnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetFestenummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetGardsnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  organisasjonsnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  undernummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst']> = {
  matrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uuidatkomst?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregate'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregateFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAvgFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAvgFields']> = {
  matrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMaxFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMaxFields']> = {
  matrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uuidatkomst?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMinFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMinFields']> = {
  matrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uuidatkomst?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMutationResponse'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevFields']> = {
  matrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevPopFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevPopFields']> = {
  matrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevSampFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevSampFields']> = {
  matrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstSumFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstSumFields']> = {
  matrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarPopFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarPopFields']> = {
  matrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarSampFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarSampFields']> = {
  matrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarianceFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarianceFields']> = {
  matrikkeladressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarPopFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarPopFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetBruksnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetFestenummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetGardsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  organisasjonsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  undernummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarSampFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarSampFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetBruksnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetFestenummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetGardsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  organisasjonsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  undernummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarianceFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarianceFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetBruksnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetFestenummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetGardsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  organisasjonsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  undernummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaTypeatkomstResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaTypeatkomst'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaTypeatkomst']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregate'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaTypeatkomst']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregateFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMaxFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMinFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMutationResponse'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaTypeatkomst']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhet'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhet']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  adressekode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  adressenavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  adressetilleggsnavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  adressetilleggsnavnkilde?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bokstav?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bruksenhetid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bruksenhetsnummertekst?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  datauttaksdato?: Resolver<Maybe<ResolversTypes['Geodatatimestamptz']>, ParentType, ContextType>;
  grunnkretsnavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grunnkretsnummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kommunenavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kommunenummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetBruksnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetFestenummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetGardsnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetKommunenummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  navnerom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  objtype?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  offisielladressetekst?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  offisielladressetekstutenadressetilleggsnavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oppdateringsdato?: Resolver<Maybe<ResolversTypes['Geodatatimestamptz']>, ParentType, ContextType>;
  organisasjonsnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  postnummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  poststed?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  representasjonspunkt?: Resolver<Maybe<ResolversTypes['Geodatageometry']>, ParentType, ContextType>;
  soknenavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  soknenummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stedfestingverifisert?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  tettstednavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tettstednummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuidadresse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuidbruksenhet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valgkretsnavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valgkretsnummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  versjonid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregate'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhet']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregateFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid']> = {
  atkomstid?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  vegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregate'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregateFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAvgFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAvgFields']> = {
  atkomstid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  vegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMaxFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMaxFields']> = {
  atkomstid?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  vegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMinFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMinFields']> = {
  atkomstid?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  vegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMutationResponse'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevFields']> = {
  atkomstid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  vegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevPopFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevPopFields']> = {
  atkomstid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  vegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevSampFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevSampFields']> = {
  atkomstid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  vegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidSumFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidSumFields']> = {
  atkomstid?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  vegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarPopFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarPopFields']> = {
  atkomstid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  vegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarSampFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarSampFields']> = {
  atkomstid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  vegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarianceFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarianceFields']> = {
  atkomstid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  vegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAvgFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAvgFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  adressekode?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetBruksnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetFestenummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetGardsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  organisasjonsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMaxFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMaxFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  adressekode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  adressenavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  adressetilleggsnavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  adressetilleggsnavnkilde?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bokstav?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bruksenhetid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bruksenhetsnummertekst?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  datauttaksdato?: Resolver<Maybe<ResolversTypes['Geodatatimestamptz']>, ParentType, ContextType>;
  grunnkretsnavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grunnkretsnummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kommunenavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kommunenummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetBruksnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetFestenummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetGardsnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetKommunenummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  navnerom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  objtype?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  offisielladressetekst?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  offisielladressetekstutenadressetilleggsnavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oppdateringsdato?: Resolver<Maybe<ResolversTypes['Geodatatimestamptz']>, ParentType, ContextType>;
  organisasjonsnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  postnummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  poststed?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  soknenavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  soknenummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tettstednavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tettstednummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuidadresse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuidbruksenhet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valgkretsnavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valgkretsnummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  versjonid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMinFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMinFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  adressekode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  adressenavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  adressetilleggsnavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  adressetilleggsnavnkilde?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bokstav?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bruksenhetid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bruksenhetsnummertekst?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  datauttaksdato?: Resolver<Maybe<ResolversTypes['Geodatatimestamptz']>, ParentType, ContextType>;
  grunnkretsnavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grunnkretsnummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kommunenavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kommunenummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetBruksnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetFestenummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetGardsnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetKommunenummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  navnerom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  objtype?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  offisielladressetekst?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  offisielladressetekstutenadressetilleggsnavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oppdateringsdato?: Resolver<Maybe<ResolversTypes['Geodatatimestamptz']>, ParentType, ContextType>;
  organisasjonsnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  postnummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  poststed?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  soknenavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  soknenummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tettstednavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tettstednummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuidadresse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuidbruksenhet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valgkretsnavn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valgkretsnummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  versjonid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMutationResponse'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhet']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  adressekode?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetBruksnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetFestenummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetGardsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  organisasjonsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevPopFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevPopFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  adressekode?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetBruksnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetFestenummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetGardsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  organisasjonsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevSampFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevSampFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  adressekode?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetBruksnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetFestenummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetGardsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  organisasjonsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetSumFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetSumFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  adressekode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetBruksnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetFestenummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetGardsnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  nummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  organisasjonsnummer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst']> = {
  objid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uuidatkomst?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregate'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregateFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAvgFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAvgFields']> = {
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  vegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMaxFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMaxFields']> = {
  objid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uuidatkomst?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMinFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMinFields']> = {
  objid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uuidatkomst?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMutationResponse'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevFields']> = {
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  vegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevPopFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevPopFields']> = {
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  vegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevSampFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevSampFields']> = {
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  vegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstSumFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstSumFields']> = {
  objid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  vegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Geodatabigint']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarPopFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarPopFields']> = {
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  vegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarSampFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarSampFields']> = {
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  vegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarianceFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarianceFields']> = {
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  vegadressebruksenhetFk?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarPopFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarPopFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  adressekode?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetBruksnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetFestenummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetGardsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  organisasjonsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarSampFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarSampFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  adressekode?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetBruksnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetFestenummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetGardsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  organisasjonsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarianceFields'] = ResolversParentTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarianceFields']> = {
  adresseid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  adressekode?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetBruksnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetFestenummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetGardsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  matrikkelnummerbruksenhetSeksjonsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  organisasjonsnummer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataSpatialRefSysResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataSpatialRefSys'] = ResolversParentTypes['GeodataSpatialRefSys']> = {
  authName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  authSrid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  proj4text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  srid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  srtext?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataSpatialRefSysAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataSpatialRefSysAggregate'] = ResolversParentTypes['GeodataSpatialRefSysAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['GeodataSpatialRefSysAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['GeodataSpatialRefSys']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataSpatialRefSysAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataSpatialRefSysAggregateFields'] = ResolversParentTypes['GeodataSpatialRefSysAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['GeodataSpatialRefSysAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<GeodataSpatialRefSysAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['GeodataSpatialRefSysMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['GeodataSpatialRefSysMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['GeodataSpatialRefSysStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['GeodataSpatialRefSysStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['GeodataSpatialRefSysStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['GeodataSpatialRefSysSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['GeodataSpatialRefSysVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['GeodataSpatialRefSysVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['GeodataSpatialRefSysVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataSpatialRefSysAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataSpatialRefSysAvgFields'] = ResolversParentTypes['GeodataSpatialRefSysAvgFields']> = {
  authSrid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  srid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataSpatialRefSysMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataSpatialRefSysMaxFields'] = ResolversParentTypes['GeodataSpatialRefSysMaxFields']> = {
  authName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  authSrid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  proj4text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  srid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  srtext?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataSpatialRefSysMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataSpatialRefSysMinFields'] = ResolversParentTypes['GeodataSpatialRefSysMinFields']> = {
  authName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  authSrid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  proj4text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  srid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  srtext?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataSpatialRefSysMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataSpatialRefSysMutationResponse'] = ResolversParentTypes['GeodataSpatialRefSysMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['GeodataSpatialRefSys']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataSpatialRefSysStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataSpatialRefSysStddevFields'] = ResolversParentTypes['GeodataSpatialRefSysStddevFields']> = {
  authSrid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  srid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataSpatialRefSysStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataSpatialRefSysStddevPopFields'] = ResolversParentTypes['GeodataSpatialRefSysStddevPopFields']> = {
  authSrid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  srid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataSpatialRefSysStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataSpatialRefSysStddevSampFields'] = ResolversParentTypes['GeodataSpatialRefSysStddevSampFields']> = {
  authSrid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  srid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataSpatialRefSysSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataSpatialRefSysSumFields'] = ResolversParentTypes['GeodataSpatialRefSysSumFields']> = {
  authSrid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  srid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataSpatialRefSysVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataSpatialRefSysVarPopFields'] = ResolversParentTypes['GeodataSpatialRefSysVarPopFields']> = {
  authSrid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  srid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataSpatialRefSysVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataSpatialRefSysVarSampFields'] = ResolversParentTypes['GeodataSpatialRefSysVarSampFields']> = {
  authSrid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  srid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataSpatialRefSysVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataSpatialRefSysVarianceFields'] = ResolversParentTypes['GeodataSpatialRefSysVarianceFields']> = {
  authSrid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  srid?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataZipResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataZip'] = ResolversParentTypes['GeodataZip']> = {
  addresses?: Resolver<Array<ResolversTypes['GeodataAddress']>, ParentType, ContextType, Partial<GeodataZipaddressesArgs>>;
  addressesAggregate?: Resolver<ResolversTypes['GeodataAddressAggregate'], ParentType, ContextType, Partial<GeodataZipaddressesAggregateArgs>>;
  zip?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataZipAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataZipAggregate'] = ResolversParentTypes['GeodataZipAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['GeodataZipAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['GeodataZip']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataZipAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataZipAggregateFields'] = ResolversParentTypes['GeodataZipAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<GeodataZipAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['GeodataZipMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['GeodataZipMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataZipMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataZipMaxFields'] = ResolversParentTypes['GeodataZipMaxFields']> = {
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataZipMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataZipMinFields'] = ResolversParentTypes['GeodataZipMinFields']> = {
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeodataZipMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeodataZipMutationResponse'] = ResolversParentTypes['GeodataZipMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['GeodataZip']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface GeodatabigintScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Geodatabigint'], any> {
  name: 'Geodatabigint';
}

export interface GeodatageographyScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Geodatageography'], any> {
  name: 'Geodatageography';
}

export interface GeodatageometryScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Geodatageometry'], any> {
  name: 'Geodatageometry';
}

export interface GeodatatimestamptzScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Geodatatimestamptz'], any> {
  name: 'Geodatatimestamptz';
}

export interface GeodatauuidScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Geodatauuid'], any> {
  name: 'Geodatauuid';
}

export type IncomingSMSOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['IncomingSMSOutput'] = ResolversParentTypes['IncomingSMSOutput']> = {
  accessToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  receiveSMS?: Resolver<Maybe<ResolversTypes['smsConnector']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LinkMobilitySMSOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['LinkMobilitySMSOutput'] = ResolversParentTypes['LinkMobilitySMSOutput']> = {
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LookupPhoneNumberOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['LookupPhoneNumberOutput'] = ResolversParentTypes['LookupPhoneNumberOutput']> = {
  category?: Resolver<Maybe<ResolversTypes['EntryCategory']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['EntrySource']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingActivitySettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingActivitySettings'] = ResolversParentTypes['MessagingActivitySettings']> = {
  activity?: Resolver<ResolversTypes['messagingActivity'], ParentType, ContextType>;
  activityId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  archived?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  muteImportantMessages?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  mutedTo?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  notificationSetting?: Resolver<Maybe<ResolversTypes['MessagingActivitySettingsNotificationSettingTypeEnum']>, ParentType, ContextType>;
  pinned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  privateGroupName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingActivitySettingsAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingActivitySettingsAggregate'] = ResolversParentTypes['MessagingActivitySettingsAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['MessagingActivitySettingsAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['MessagingActivitySettings']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingActivitySettingsAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingActivitySettingsAggregateFields'] = ResolversParentTypes['MessagingActivitySettingsAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<MessagingActivitySettingsAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['MessagingActivitySettingsMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['MessagingActivitySettingsMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingActivitySettingsMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingActivitySettingsMaxFields'] = ResolversParentTypes['MessagingActivitySettingsMaxFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  archived?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  mutedTo?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  privateGroupName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingActivitySettingsMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingActivitySettingsMinFields'] = ResolversParentTypes['MessagingActivitySettingsMinFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  archived?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  mutedTo?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  privateGroupName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingActivitySettingsMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingActivitySettingsMutationResponse'] = ResolversParentTypes['MessagingActivitySettingsMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['MessagingActivitySettings']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingActivitySettingsNotificationSettingTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingActivitySettingsNotificationSettingType'] = ResolversParentTypes['MessagingActivitySettingsNotificationSettingType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingActivitySettingsNotificationSettingTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingActivitySettingsNotificationSettingTypeAggregate'] = ResolversParentTypes['MessagingActivitySettingsNotificationSettingTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['MessagingActivitySettingsNotificationSettingTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['MessagingActivitySettingsNotificationSettingType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingActivitySettingsNotificationSettingTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingActivitySettingsNotificationSettingTypeAggregateFields'] = ResolversParentTypes['MessagingActivitySettingsNotificationSettingTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<MessagingActivitySettingsNotificationSettingTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['MessagingActivitySettingsNotificationSettingTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['MessagingActivitySettingsNotificationSettingTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingActivitySettingsNotificationSettingTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingActivitySettingsNotificationSettingTypeMaxFields'] = ResolversParentTypes['MessagingActivitySettingsNotificationSettingTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingActivitySettingsNotificationSettingTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingActivitySettingsNotificationSettingTypeMinFields'] = ResolversParentTypes['MessagingActivitySettingsNotificationSettingTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingActivitySettingsNotificationSettingTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingActivitySettingsNotificationSettingTypeMutationResponse'] = ResolversParentTypes['MessagingActivitySettingsNotificationSettingTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['MessagingActivitySettingsNotificationSettingType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingInvitationResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingInvitation'] = ResolversParentTypes['MessagingInvitation']> = {
  accepted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  activity?: Resolver<ResolversTypes['messagingActivity'], ParentType, ContextType>;
  activityId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  createdByUserId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingInvitationAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingInvitationAggregate'] = ResolversParentTypes['MessagingInvitationAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['MessagingInvitationAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['MessagingInvitation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingInvitationAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingInvitationAggregateFields'] = ResolversParentTypes['MessagingInvitationAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<MessagingInvitationAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['MessagingInvitationMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['MessagingInvitationMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingInvitationMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingInvitationMaxFields'] = ResolversParentTypes['MessagingInvitationMaxFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingInvitationMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingInvitationMinFields'] = ResolversParentTypes['MessagingInvitationMinFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingInvitationMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingInvitationMutationResponse'] = ResolversParentTypes['MessagingInvitationMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['MessagingInvitation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingMentionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingMentions'] = ResolversParentTypes['MessagingMentions']> = {
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['messagingMessage'], ParentType, ContextType>;
  messageId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  organizationUser?: Resolver<ResolversTypes['organizationUser'], ParentType, ContextType>;
  organizationUserId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingMentionsAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingMentionsAggregate'] = ResolversParentTypes['MessagingMentionsAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['MessagingMentionsAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['MessagingMentions']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingMentionsAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingMentionsAggregateFields'] = ResolversParentTypes['MessagingMentionsAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<MessagingMentionsAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['MessagingMentionsMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['MessagingMentionsMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingMentionsMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingMentionsMaxFields'] = ResolversParentTypes['MessagingMentionsMaxFields']> = {
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  messageId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingMentionsMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingMentionsMinFields'] = ResolversParentTypes['MessagingMentionsMinFields']> = {
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  messageId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingMentionsMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingMentionsMutationResponse'] = ResolversParentTypes['MessagingMentionsMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['MessagingMentions']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingMessageAttachmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingMessageAttachment'] = ResolversParentTypes['MessagingMessageAttachment']> = {
  attachedByUser?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  attachment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  file?: Resolver<Maybe<ResolversTypes['publicFile']>, ParentType, ContextType>;
  fileId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['messagingMessage'], ParentType, ContextType>;
  messageId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  mimeType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['MessagingMessageAttachmentTypeEnum']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingMessageAttachmentAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingMessageAttachmentAggregate'] = ResolversParentTypes['MessagingMessageAttachmentAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['MessagingMessageAttachmentAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['MessagingMessageAttachment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingMessageAttachmentAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingMessageAttachmentAggregateFields'] = ResolversParentTypes['MessagingMessageAttachmentAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<MessagingMessageAttachmentAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['MessagingMessageAttachmentMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['MessagingMessageAttachmentMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingMessageAttachmentMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingMessageAttachmentMaxFields'] = ResolversParentTypes['MessagingMessageAttachmentMaxFields']> = {
  attachedByUser?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  attachment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  fileId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  messageId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  mimeType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingMessageAttachmentMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingMessageAttachmentMinFields'] = ResolversParentTypes['MessagingMessageAttachmentMinFields']> = {
  attachedByUser?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  attachment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  fileId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  messageId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  mimeType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingMessageAttachmentMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingMessageAttachmentMutationResponse'] = ResolversParentTypes['MessagingMessageAttachmentMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['MessagingMessageAttachment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingMessageAttachmentTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingMessageAttachmentType'] = ResolversParentTypes['MessagingMessageAttachmentType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingMessageAttachmentTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingMessageAttachmentTypeAggregate'] = ResolversParentTypes['MessagingMessageAttachmentTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['MessagingMessageAttachmentTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['MessagingMessageAttachmentType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingMessageAttachmentTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingMessageAttachmentTypeAggregateFields'] = ResolversParentTypes['MessagingMessageAttachmentTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<MessagingMessageAttachmentTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['MessagingMessageAttachmentTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['MessagingMessageAttachmentTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingMessageAttachmentTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingMessageAttachmentTypeMaxFields'] = ResolversParentTypes['MessagingMessageAttachmentTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingMessageAttachmentTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingMessageAttachmentTypeMinFields'] = ResolversParentTypes['MessagingMessageAttachmentTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingMessageAttachmentTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingMessageAttachmentTypeMutationResponse'] = ResolversParentTypes['MessagingMessageAttachmentTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['MessagingMessageAttachmentType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingMessagePriorityResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingMessagePriority'] = ResolversParentTypes['MessagingMessagePriority']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingMessagePriorityAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingMessagePriorityAggregate'] = ResolversParentTypes['MessagingMessagePriorityAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['MessagingMessagePriorityAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['MessagingMessagePriority']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingMessagePriorityAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingMessagePriorityAggregateFields'] = ResolversParentTypes['MessagingMessagePriorityAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<MessagingMessagePriorityAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['MessagingMessagePriorityMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['MessagingMessagePriorityMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingMessagePriorityMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingMessagePriorityMaxFields'] = ResolversParentTypes['MessagingMessagePriorityMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingMessagePriorityMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingMessagePriorityMinFields'] = ResolversParentTypes['MessagingMessagePriorityMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessagingMessagePriorityMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessagingMessagePriorityMutationResponse'] = ResolversParentTypes['MessagingMessagePriorityMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['MessagingMessagePriority']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NewActivityOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['NewActivityOutput'] = ResolversParentTypes['NewActivityOutput']> = {
  result?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationNotificationDeviceSentResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationNotificationDeviceSent'] = ResolversParentTypes['NotificationNotificationDeviceSent']> = {
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  device?: Resolver<ResolversTypes['notificationUserDevice'], ParentType, ContextType>;
  deviceId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  deviceScheduledIdentifier?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  notification?: Resolver<ResolversTypes['notificationSend'], ParentType, ContextType>;
  notificationId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  receivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationNotificationDeviceSentAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationNotificationDeviceSentAggregate'] = ResolversParentTypes['NotificationNotificationDeviceSentAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['NotificationNotificationDeviceSentAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['NotificationNotificationDeviceSent']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationNotificationDeviceSentAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationNotificationDeviceSentAggregateFields'] = ResolversParentTypes['NotificationNotificationDeviceSentAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<NotificationNotificationDeviceSentAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['NotificationNotificationDeviceSentMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['NotificationNotificationDeviceSentMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationNotificationDeviceSentMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationNotificationDeviceSentMaxFields'] = ResolversParentTypes['NotificationNotificationDeviceSentMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  deviceId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  deviceScheduledIdentifier?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  notificationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  receivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationNotificationDeviceSentMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationNotificationDeviceSentMinFields'] = ResolversParentTypes['NotificationNotificationDeviceSentMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  deviceId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  deviceScheduledIdentifier?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  notificationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  receivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationNotificationDeviceSentMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationNotificationDeviceSentMutationResponse'] = ResolversParentTypes['NotificationNotificationDeviceSentMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['NotificationNotificationDeviceSent']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationNotificationSettingActivityPrimaryEnumResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationNotificationSettingActivityPrimaryEnum'] = ResolversParentTypes['NotificationNotificationSettingActivityPrimaryEnum']> = {
  comment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationNotificationSettingActivityPrimaryEnumAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationNotificationSettingActivityPrimaryEnumAggregate'] = ResolversParentTypes['NotificationNotificationSettingActivityPrimaryEnumAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['NotificationNotificationSettingActivityPrimaryEnumAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['NotificationNotificationSettingActivityPrimaryEnum']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationNotificationSettingActivityPrimaryEnumAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationNotificationSettingActivityPrimaryEnumAggregateFields'] = ResolversParentTypes['NotificationNotificationSettingActivityPrimaryEnumAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<NotificationNotificationSettingActivityPrimaryEnumAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['NotificationNotificationSettingActivityPrimaryEnumMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['NotificationNotificationSettingActivityPrimaryEnumMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationNotificationSettingActivityPrimaryEnumMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationNotificationSettingActivityPrimaryEnumMaxFields'] = ResolversParentTypes['NotificationNotificationSettingActivityPrimaryEnumMaxFields']> = {
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationNotificationSettingActivityPrimaryEnumMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationNotificationSettingActivityPrimaryEnumMinFields'] = ResolversParentTypes['NotificationNotificationSettingActivityPrimaryEnumMinFields']> = {
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationNotificationSettingActivityPrimaryEnumMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationNotificationSettingActivityPrimaryEnumMutationResponse'] = ResolversParentTypes['NotificationNotificationSettingActivityPrimaryEnumMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['NotificationNotificationSettingActivityPrimaryEnum']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationOutput'] = ResolversParentTypes['NotificationOutput']> = {
  result?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderUpdateOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderUpdateOutput'] = ResolversParentTypes['OrderUpdateOutput']> = {
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersOrganizationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersOrganizations'] = ResolversParentTypes['OrdersOrganizations']> = {
  deliveryDate?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mobileNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nrOfUsers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  organizationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersOrganizationsAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersOrganizationsAggregate'] = ResolversParentTypes['OrdersOrganizationsAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['OrdersOrganizationsAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['OrdersOrganizations']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersOrganizationsAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersOrganizationsAggregateFields'] = ResolversParentTypes['OrdersOrganizationsAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['OrdersOrganizationsAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<OrdersOrganizationsAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['OrdersOrganizationsMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['OrdersOrganizationsMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['OrdersOrganizationsStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['OrdersOrganizationsStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['OrdersOrganizationsStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['OrdersOrganizationsSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['OrdersOrganizationsVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['OrdersOrganizationsVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['OrdersOrganizationsVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersOrganizationsAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersOrganizationsAvgFields'] = ResolversParentTypes['OrdersOrganizationsAvgFields']> = {
  nrOfUsers?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersOrganizationsMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersOrganizationsMaxFields'] = ResolversParentTypes['OrdersOrganizationsMaxFields']> = {
  deliveryDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobileNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nrOfUsers?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  organizationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  providerType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersOrganizationsMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersOrganizationsMinFields'] = ResolversParentTypes['OrdersOrganizationsMinFields']> = {
  deliveryDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobileNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nrOfUsers?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  organizationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  providerType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersOrganizationsMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersOrganizationsMutationResponse'] = ResolversParentTypes['OrdersOrganizationsMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['OrdersOrganizations']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersOrganizationsStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersOrganizationsStddevFields'] = ResolversParentTypes['OrdersOrganizationsStddevFields']> = {
  nrOfUsers?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersOrganizationsStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersOrganizationsStddevPopFields'] = ResolversParentTypes['OrdersOrganizationsStddevPopFields']> = {
  nrOfUsers?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersOrganizationsStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersOrganizationsStddevSampFields'] = ResolversParentTypes['OrdersOrganizationsStddevSampFields']> = {
  nrOfUsers?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersOrganizationsSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersOrganizationsSumFields'] = ResolversParentTypes['OrdersOrganizationsSumFields']> = {
  nrOfUsers?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersOrganizationsVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersOrganizationsVarPopFields'] = ResolversParentTypes['OrdersOrganizationsVarPopFields']> = {
  nrOfUsers?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersOrganizationsVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersOrganizationsVarSampFields'] = ResolversParentTypes['OrdersOrganizationsVarSampFields']> = {
  nrOfUsers?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersOrganizationsVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersOrganizationsVarianceFields'] = ResolversParentTypes['OrdersOrganizationsVarianceFields']> = {
  nrOfUsers?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersRequest'] = ResolversParentTypes['OrdersRequest']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersRequestAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersRequestAggregate'] = ResolversParentTypes['OrdersRequestAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['OrdersRequestAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['OrdersRequest']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersRequestAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersRequestAggregateFields'] = ResolversParentTypes['OrdersRequestAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<OrdersRequestAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['OrdersRequestMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['OrdersRequestMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersRequestMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersRequestMaxFields'] = ResolversParentTypes['OrdersRequestMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersRequestMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersRequestMinFields'] = ResolversParentTypes['OrdersRequestMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersRequestMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersRequestMutationResponse'] = ResolversParentTypes['OrdersRequestMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['OrdersRequest']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersStatus'] = ResolversParentTypes['OrdersStatus']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersStatusAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersStatusAggregate'] = ResolversParentTypes['OrdersStatusAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['OrdersStatusAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['OrdersStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersStatusAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersStatusAggregateFields'] = ResolversParentTypes['OrdersStatusAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<OrdersStatusAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['OrdersStatusMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['OrdersStatusMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersStatusMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersStatusMaxFields'] = ResolversParentTypes['OrdersStatusMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersStatusMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersStatusMinFields'] = ResolversParentTypes['OrdersStatusMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersStatusMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersStatusMutationResponse'] = ResolversParentTypes['OrdersStatusMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['OrdersStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersType'] = ResolversParentTypes['OrdersType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersTypeAggregate'] = ResolversParentTypes['OrdersTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['OrdersTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['OrdersType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersTypeAggregateFields'] = ResolversParentTypes['OrdersTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<OrdersTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['OrdersTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['OrdersTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersTypeMaxFields'] = ResolversParentTypes['OrdersTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersTypeMinFields'] = ResolversParentTypes['OrdersTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrdersTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrdersTypeMutationResponse'] = ResolversParentTypes['OrdersTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['OrdersType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationOutput'] = ResolversParentTypes['OrganizationOutput']> = {
  organization?: Resolver<Maybe<ResolversTypes['json']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationUserAttentionNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationUserAttentionNote'] = ResolversParentTypes['OrganizationUserAttentionNote']> = {
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  createdByUser?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  createdOnUser?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['organizationUser']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  note?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subjectUser?: Resolver<Maybe<ResolversTypes['organizationUser']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationUserAttentionNoteAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationUserAttentionNoteAggregate'] = ResolversParentTypes['OrganizationUserAttentionNoteAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['OrganizationUserAttentionNoteAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['OrganizationUserAttentionNote']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationUserAttentionNoteAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationUserAttentionNoteAggregateFields'] = ResolversParentTypes['OrganizationUserAttentionNoteAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<OrganizationUserAttentionNoteAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['OrganizationUserAttentionNoteMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['OrganizationUserAttentionNoteMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationUserAttentionNoteMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationUserAttentionNoteMaxFields'] = ResolversParentTypes['OrganizationUserAttentionNoteMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdByUser?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdOnUser?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationUserAttentionNoteMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationUserAttentionNoteMinFields'] = ResolversParentTypes['OrganizationUserAttentionNoteMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdByUser?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdOnUser?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationUserAttentionNoteMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationUserAttentionNoteMutationResponse'] = ResolversParentTypes['OrganizationUserAttentionNoteMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['OrganizationUserAttentionNote']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationsOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationsOutput'] = ResolversParentTypes['OrganizationsOutput']> = {
  organizations?: Resolver<Maybe<ResolversTypes['json']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PhoneRequestOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['PhoneRequestOutput'] = ResolversParentTypes['PhoneRequestOutput']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromptResolvers<ContextType = any, ParentType extends ResolversParentTypes['Prompt'] = ResolversParentTypes['Prompt']> = {
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  endCallFunctionDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  greet?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  systemTranscribe?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userTranscribe?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  voice?: Resolver<ResolversTypes['VoiceTypesEnum'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromptAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromptAggregate'] = ResolversParentTypes['PromptAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['PromptAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Prompt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromptAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromptAggregateFields'] = ResolversParentTypes['PromptAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<PromptAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['PromptMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['PromptMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromptMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromptMaxFields'] = ResolversParentTypes['PromptMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  endCallFunctionDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  greet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  systemTranscribe?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userTranscribe?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromptMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromptMinFields'] = ResolversParentTypes['PromptMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  endCallFunctionDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  greet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  systemTranscribe?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userTranscribe?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromptMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromptMutationResponse'] = ResolversParentTypes['PromptMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['Prompt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueueItemFlexibilityTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueueItemFlexibilityType'] = ResolversParentTypes['QueueItemFlexibilityType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueueItemFlexibilityTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueueItemFlexibilityTypeAggregate'] = ResolversParentTypes['QueueItemFlexibilityTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['QueueItemFlexibilityTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['QueueItemFlexibilityType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueueItemFlexibilityTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueueItemFlexibilityTypeAggregateFields'] = ResolversParentTypes['QueueItemFlexibilityTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<QueueItemFlexibilityTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['QueueItemFlexibilityTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['QueueItemFlexibilityTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueueItemFlexibilityTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueueItemFlexibilityTypeMaxFields'] = ResolversParentTypes['QueueItemFlexibilityTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueueItemFlexibilityTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueueItemFlexibilityTypeMinFields'] = ResolversParentTypes['QueueItemFlexibilityTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueueItemFlexibilityTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueueItemFlexibilityTypeMutationResponse'] = ResolversParentTypes['QueueItemFlexibilityTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['QueueItemFlexibilityType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueueItemParticipantResponsibilityTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueueItemParticipantResponsibilityType'] = ResolversParentTypes['QueueItemParticipantResponsibilityType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueueItemParticipantResponsibilityTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueueItemParticipantResponsibilityTypeAggregate'] = ResolversParentTypes['QueueItemParticipantResponsibilityTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['QueueItemParticipantResponsibilityTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['QueueItemParticipantResponsibilityType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueueItemParticipantResponsibilityTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueueItemParticipantResponsibilityTypeAggregateFields'] = ResolversParentTypes['QueueItemParticipantResponsibilityTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<QueueItemParticipantResponsibilityTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['QueueItemParticipantResponsibilityTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['QueueItemParticipantResponsibilityTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueueItemParticipantResponsibilityTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueueItemParticipantResponsibilityTypeMaxFields'] = ResolversParentTypes['QueueItemParticipantResponsibilityTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueueItemParticipantResponsibilityTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueueItemParticipantResponsibilityTypeMinFields'] = ResolversParentTypes['QueueItemParticipantResponsibilityTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueueItemParticipantResponsibilityTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['QueueItemParticipantResponsibilityTypeMutationResponse'] = ResolversParentTypes['QueueItemParticipantResponsibilityTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['QueueItemParticipantResponsibilityType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryCodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryCode'] = ResolversParentTypes['RegistryCode']> = {
  beskrivelse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hjelpeenhetskode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Registryuuid'], ParentType, ContextType>;
  kode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationInstitusjonellSektorkode?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  organizationNaeringskode1?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  organizationNaeringskode2?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  organizationNaeringskode3?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryCodeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryCodeAggregate'] = ResolversParentTypes['RegistryCodeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['RegistryCodeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['RegistryCode']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryCodeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryCodeAggregateFields'] = ResolversParentTypes['RegistryCodeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<RegistryCodeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['RegistryCodeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['RegistryCodeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryCodeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryCodeMaxFields'] = ResolversParentTypes['RegistryCodeMaxFields']> = {
  beskrivelse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  kode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationInstitusjonellSektorkode?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  organizationNaeringskode1?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  organizationNaeringskode2?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  organizationNaeringskode3?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryCodeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryCodeMinFields'] = ResolversParentTypes['RegistryCodeMinFields']> = {
  beskrivelse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  kode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationInstitusjonellSektorkode?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  organizationNaeringskode1?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  organizationNaeringskode2?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  organizationNaeringskode3?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryCodeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryCodeMutationResponse'] = ResolversParentTypes['RegistryCodeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['RegistryCode']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryInfo'] = ResolversParentTypes['RegistryInfo']> = {
  id?: Resolver<ResolversTypes['Registryuuid'], ParentType, ContextType>;
  lastUpdated?: Resolver<ResolversTypes['Registrydate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryInfoAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryInfoAggregate'] = ResolversParentTypes['RegistryInfoAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['RegistryInfoAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['RegistryInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryInfoAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryInfoAggregateFields'] = ResolversParentTypes['RegistryInfoAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<RegistryInfoAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['RegistryInfoMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['RegistryInfoMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryInfoMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryInfoMaxFields'] = ResolversParentTypes['RegistryInfoMaxFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['Registrydate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryInfoMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryInfoMinFields'] = ResolversParentTypes['RegistryInfoMinFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['Registrydate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryInfoMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryInfoMutationResponse'] = ResolversParentTypes['RegistryInfoMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['RegistryInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryOrganisasjonsformResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryOrganisasjonsform'] = ResolversParentTypes['RegistryOrganisasjonsform']> = {
  _links?: Resolver<Maybe<ResolversTypes['Registryjsonb']>, ParentType, ContextType, Partial<RegistryOrganisasjonsform_linksArgs>>;
  beskrivelse?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Registryuuid'], ParentType, ContextType>;
  kode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  links?: Resolver<Maybe<ResolversTypes['Registryjsonb']>, ParentType, ContextType, Partial<RegistryOrganisasjonsformlinksArgs>>;
  organizationOrganisasjonsform?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryOrganisasjonsformAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryOrganisasjonsformAggregate'] = ResolversParentTypes['RegistryOrganisasjonsformAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['RegistryOrganisasjonsformAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['RegistryOrganisasjonsform']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryOrganisasjonsformAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryOrganisasjonsformAggregateFields'] = ResolversParentTypes['RegistryOrganisasjonsformAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<RegistryOrganisasjonsformAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['RegistryOrganisasjonsformMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['RegistryOrganisasjonsformMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryOrganisasjonsformMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryOrganisasjonsformMaxFields'] = ResolversParentTypes['RegistryOrganisasjonsformMaxFields']> = {
  beskrivelse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  kode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationOrganisasjonsform?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryOrganisasjonsformMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryOrganisasjonsformMinFields'] = ResolversParentTypes['RegistryOrganisasjonsformMinFields']> = {
  beskrivelse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  kode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationOrganisasjonsform?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryOrganisasjonsformMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryOrganisasjonsformMutationResponse'] = ResolversParentTypes['RegistryOrganisasjonsformMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['RegistryOrganisasjonsform']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryOrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryOrganization'] = ResolversParentTypes['RegistryOrganization']> = {
  _links?: Resolver<Maybe<ResolversTypes['Registryjsonb']>, ParentType, ContextType, Partial<RegistryOrganization_linksArgs>>;
  antallAnsatte?: Resolver<Maybe<ResolversTypes['Registrynumeric']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Registrytimestamptz'], ParentType, ContextType>;
  epostadresse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  forretningsadresse?: Resolver<Maybe<ResolversTypes['RegistryPostadresse']>, ParentType, ContextType>;
  frivilligMvaRegistrertBeskrivelser?: Resolver<Maybe<ResolversTypes['Registryjsonb']>, ParentType, ContextType, Partial<RegistryOrganizationfrivilligMvaRegistrertBeskrivelserArgs>>;
  hjemmeside?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Registryuuid'], ParentType, ContextType>;
  institusjonellSektorkode?: Resolver<Maybe<ResolversTypes['RegistryCode']>, ParentType, ContextType>;
  konkurs?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  links?: Resolver<Maybe<ResolversTypes['Registryjsonb']>, ParentType, ContextType, Partial<RegistryOrganizationlinksArgs>>;
  maalform?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobil?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  naeringskode1?: Resolver<Maybe<ResolversTypes['RegistryCode']>, ParentType, ContextType>;
  naeringskode2?: Resolver<Maybe<ResolversTypes['RegistryCode']>, ParentType, ContextType>;
  naeringskode3?: Resolver<Maybe<ResolversTypes['RegistryCode']>, ParentType, ContextType>;
  navn?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organisasjonsform?: Resolver<Maybe<ResolversTypes['RegistryOrganisasjonsform']>, ParentType, ContextType>;
  organisasjonsnummer?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  overordnetEnhet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postadresse?: Resolver<Maybe<ResolversTypes['RegistryPostadresse']>, ParentType, ContextType>;
  registreringsdatoEnhetsregisteret?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registrertIForetaksregisteret?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  registrertIFrivillighetsregisteret?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  registrertIMvaregisteret?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  registrertIStiftelsesregisteret?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sisteInnsendteAarsregnskap?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slettedato?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stiftelsesdato?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  telefon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  underAvvikling?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  underTvangsavviklingEllerTvangsopplosning?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Registrytimestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryOrganizationAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryOrganizationAggregate'] = ResolversParentTypes['RegistryOrganizationAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['RegistryOrganizationAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['RegistryOrganization']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryOrganizationAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryOrganizationAggregateFields'] = ResolversParentTypes['RegistryOrganizationAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['RegistryOrganizationAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<RegistryOrganizationAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['RegistryOrganizationMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['RegistryOrganizationMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['RegistryOrganizationStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['RegistryOrganizationStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['RegistryOrganizationStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['RegistryOrganizationSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['RegistryOrganizationVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['RegistryOrganizationVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['RegistryOrganizationVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryOrganizationAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryOrganizationAvgFields'] = ResolversParentTypes['RegistryOrganizationAvgFields']> = {
  antallAnsatte?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryOrganizationMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryOrganizationMaxFields'] = ResolversParentTypes['RegistryOrganizationMaxFields']> = {
  antallAnsatte?: Resolver<Maybe<ResolversTypes['Registrynumeric']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Registrytimestamptz']>, ParentType, ContextType>;
  epostadresse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hjemmeside?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  maalform?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobil?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  navn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organisasjonsnummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  overordnetEnhet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registreringsdatoEnhetsregisteret?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sisteInnsendteAarsregnskap?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slettedato?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stiftelsesdato?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  telefon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Registrytimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryOrganizationMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryOrganizationMinFields'] = ResolversParentTypes['RegistryOrganizationMinFields']> = {
  antallAnsatte?: Resolver<Maybe<ResolversTypes['Registrynumeric']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Registrytimestamptz']>, ParentType, ContextType>;
  epostadresse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hjemmeside?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  maalform?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobil?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  navn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organisasjonsnummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  overordnetEnhet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registreringsdatoEnhetsregisteret?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sisteInnsendteAarsregnskap?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slettedato?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stiftelsesdato?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  telefon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Registrytimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryOrganizationMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryOrganizationMutationResponse'] = ResolversParentTypes['RegistryOrganizationMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['RegistryOrganization']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryOrganizationStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryOrganizationStddevFields'] = ResolversParentTypes['RegistryOrganizationStddevFields']> = {
  antallAnsatte?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryOrganizationStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryOrganizationStddevPopFields'] = ResolversParentTypes['RegistryOrganizationStddevPopFields']> = {
  antallAnsatte?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryOrganizationStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryOrganizationStddevSampFields'] = ResolversParentTypes['RegistryOrganizationStddevSampFields']> = {
  antallAnsatte?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryOrganizationSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryOrganizationSumFields'] = ResolversParentTypes['RegistryOrganizationSumFields']> = {
  antallAnsatte?: Resolver<Maybe<ResolversTypes['Registrynumeric']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryOrganizationVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryOrganizationVarPopFields'] = ResolversParentTypes['RegistryOrganizationVarPopFields']> = {
  antallAnsatte?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryOrganizationVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryOrganizationVarSampFields'] = ResolversParentTypes['RegistryOrganizationVarSampFields']> = {
  antallAnsatte?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryOrganizationVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryOrganizationVarianceFields'] = ResolversParentTypes['RegistryOrganizationVarianceFields']> = {
  antallAnsatte?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryPostadresseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryPostadresse'] = ResolversParentTypes['RegistryPostadresse']> = {
  adresse?: Resolver<Maybe<ResolversTypes['Registryjsonb']>, ParentType, ContextType, Partial<RegistryPostadresseadresseArgs>>;
  id?: Resolver<ResolversTypes['Registryuuid'], ParentType, ContextType>;
  kommune?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kommunenummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  land?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  landkode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationForretningsadresse?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  organizationPostadresse?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  postnummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  poststed?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryPostadresseAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryPostadresseAggregate'] = ResolversParentTypes['RegistryPostadresseAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['RegistryPostadresseAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['RegistryPostadresse']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryPostadresseAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryPostadresseAggregateFields'] = ResolversParentTypes['RegistryPostadresseAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<RegistryPostadresseAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['RegistryPostadresseMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['RegistryPostadresseMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryPostadresseMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryPostadresseMaxFields'] = ResolversParentTypes['RegistryPostadresseMaxFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  kommune?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kommunenummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  land?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  landkode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationForretningsadresse?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  organizationPostadresse?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  postnummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  poststed?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryPostadresseMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryPostadresseMinFields'] = ResolversParentTypes['RegistryPostadresseMinFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  kommune?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kommunenummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  land?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  landkode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationForretningsadresse?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  organizationPostadresse?: Resolver<Maybe<ResolversTypes['Registryuuid']>, ParentType, ContextType>;
  postnummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  poststed?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegistryPostadresseMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegistryPostadresseMutationResponse'] = ResolversParentTypes['RegistryPostadresseMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['RegistryPostadresse']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface RegistrydateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Registrydate'], any> {
  name: 'Registrydate';
}

export interface RegistryjsonbScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Registryjsonb'], any> {
  name: 'Registryjsonb';
}

export interface RegistrynumericScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Registrynumeric'], any> {
  name: 'Registrynumeric';
}

export interface RegistrytimestamptzScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Registrytimestamptz'], any> {
  name: 'Registrytimestamptz';
}

export interface RegistryuuidScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Registryuuid'], any> {
  name: 'Registryuuid';
}

export type RelationTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RelationType'] = ResolversParentTypes['RelationType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RelationTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['RelationTypeAggregate'] = ResolversParentTypes['RelationTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['RelationTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['RelationType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RelationTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RelationTypeAggregateFields'] = ResolversParentTypes['RelationTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<RelationTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['RelationTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['RelationTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RelationTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RelationTypeMaxFields'] = ResolversParentTypes['RelationTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RelationTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RelationTypeMinFields'] = ResolversParentTypes['RelationTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RelationTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RelationTypeMutationResponse'] = ResolversParentTypes['RelationTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['RelationType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RemoveCustomerOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveCustomerOutput'] = ResolversParentTypes['RemoveCustomerOutput']> = {
  json?: Resolver<Maybe<ResolversTypes['json']>, ParentType, ContextType>;
  result?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RequestIntegrationsOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestIntegrationsOutput'] = ResolversParentTypes['RequestIntegrationsOutput']> = {
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchPhoneOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchPhoneOutput'] = ResolversParentTypes['SearchPhoneOutput']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  customerType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  electronicQuery?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  manualQuery?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  middleName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneBook?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  postalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SendSMSOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendSMSOutput'] = ResolversParentTypes['SendSMSOutput']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messageId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resultCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SendSMSTokenOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendSMSTokenOutput'] = ResolversParentTypes['SendSMSTokenOutput']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StatusOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['StatusOutput'] = ResolversParentTypes['StatusOutput']> = {
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskActivity'] = ResolversParentTypes['TaskActivity']> = {
  activityActivityUuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  activityParticipants?: Resolver<Array<ResolversTypes['TaskActivityParticipant']>, ParentType, ContextType, Partial<TaskActivityactivityParticipantsArgs>>;
  activityParticipantsAggregate?: Resolver<ResolversTypes['TaskActivityParticipantAggregate'], ParentType, ContextType, Partial<TaskActivityactivityParticipantsAggregateArgs>>;
  activityType?: Resolver<ResolversTypes['TaskActivityType'], ParentType, ContextType>;
  additionalData?: Resolver<Maybe<ResolversTypes['Taskjsonb']>, ParentType, ContextType, Partial<TaskActivityadditionalDataArgs>>;
  createdAt?: Resolver<ResolversTypes['Tasktimestamptz'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['TaskDomainUser']>, ParentType, ContextType>;
  ownerId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  provider?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['TaskActivityTypeEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Tasktimestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskActivityAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskActivityAggregate'] = ResolversParentTypes['TaskActivityAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TaskActivityAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TaskActivity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskActivityAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskActivityAggregateFields'] = ResolversParentTypes['TaskActivityAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TaskActivityAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TaskActivityMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TaskActivityMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskActivityMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskActivityMaxFields'] = ResolversParentTypes['TaskActivityMaxFields']> = {
  activityActivityUuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Tasktimestamptz']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  ownerId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  provider?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Tasktimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskActivityMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskActivityMinFields'] = ResolversParentTypes['TaskActivityMinFields']> = {
  activityActivityUuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Tasktimestamptz']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  ownerId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  provider?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Tasktimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskActivityMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskActivityMutationResponse'] = ResolversParentTypes['TaskActivityMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['TaskActivity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskActivityParticipantResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskActivityParticipant'] = ResolversParentTypes['TaskActivityParticipant']> = {
  activity?: Resolver<Maybe<ResolversTypes['TaskActivity']>, ParentType, ContextType>;
  activityActivityUuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  activityId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Tasktimestamptz'], ParentType, ContextType>;
  domainUser?: Resolver<Maybe<ResolversTypes['TaskDomainUser']>, ParentType, ContextType>;
  domainUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Tasktimestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskActivityParticipantAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskActivityParticipantAggregate'] = ResolversParentTypes['TaskActivityParticipantAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TaskActivityParticipantAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TaskActivityParticipant']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskActivityParticipantAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskActivityParticipantAggregateFields'] = ResolversParentTypes['TaskActivityParticipantAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TaskActivityParticipantAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TaskActivityParticipantMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TaskActivityParticipantMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskActivityParticipantMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskActivityParticipantMaxFields'] = ResolversParentTypes['TaskActivityParticipantMaxFields']> = {
  activityActivityUuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Tasktimestamptz']>, ParentType, ContextType>;
  domainUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Tasktimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskActivityParticipantMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskActivityParticipantMinFields'] = ResolversParentTypes['TaskActivityParticipantMinFields']> = {
  activityActivityUuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Tasktimestamptz']>, ParentType, ContextType>;
  domainUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Tasktimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskActivityParticipantMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskActivityParticipantMutationResponse'] = ResolversParentTypes['TaskActivityParticipantMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['TaskActivityParticipant']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskActivityTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskActivityType'] = ResolversParentTypes['TaskActivityType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskActivityTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskActivityTypeAggregate'] = ResolversParentTypes['TaskActivityTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TaskActivityTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TaskActivityType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskActivityTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskActivityTypeAggregateFields'] = ResolversParentTypes['TaskActivityTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TaskActivityTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TaskActivityTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TaskActivityTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskActivityTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskActivityTypeMaxFields'] = ResolversParentTypes['TaskActivityTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskActivityTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskActivityTypeMinFields'] = ResolversParentTypes['TaskActivityTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskActivityTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskActivityTypeMutationResponse'] = ResolversParentTypes['TaskActivityTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['TaskActivityType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskDomainOrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskDomainOrganization'] = ResolversParentTypes['TaskDomainOrganization']> = {
  adminId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Tasktimestamptz'], ParentType, ContextType>;
  domainUsers?: Resolver<Array<ResolversTypes['TaskDomainUser']>, ParentType, ContextType, Partial<TaskDomainOrganizationdomainUsersArgs>>;
  domainUsersAggregate?: Resolver<ResolversTypes['TaskDomainUserAggregate'], ParentType, ContextType, Partial<TaskDomainOrganizationdomainUsersAggregateArgs>>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  providerClientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Tasktimestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskDomainOrganizationAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskDomainOrganizationAggregate'] = ResolversParentTypes['TaskDomainOrganizationAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TaskDomainOrganizationAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TaskDomainOrganization']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskDomainOrganizationAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskDomainOrganizationAggregateFields'] = ResolversParentTypes['TaskDomainOrganizationAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TaskDomainOrganizationAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TaskDomainOrganizationMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TaskDomainOrganizationMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskDomainOrganizationMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskDomainOrganizationMaxFields'] = ResolversParentTypes['TaskDomainOrganizationMaxFields']> = {
  adminId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Tasktimestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  providerClientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Tasktimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskDomainOrganizationMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskDomainOrganizationMinFields'] = ResolversParentTypes['TaskDomainOrganizationMinFields']> = {
  adminId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Tasktimestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  providerClientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Tasktimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskDomainOrganizationMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskDomainOrganizationMutationResponse'] = ResolversParentTypes['TaskDomainOrganizationMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['TaskDomainOrganization']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskDomainUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskDomainUser'] = ResolversParentTypes['TaskDomainUser']> = {
  activityParticipants?: Resolver<Array<ResolversTypes['TaskActivityParticipant']>, ParentType, ContextType, Partial<TaskDomainUseractivityParticipantsArgs>>;
  activityParticipantsAggregate?: Resolver<ResolversTypes['TaskActivityParticipantAggregate'], ParentType, ContextType, Partial<TaskDomainUseractivityParticipantsAggregateArgs>>;
  category?: Resolver<Maybe<ResolversTypes['TaskDomainUserCategoryEnum']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Tasktimestamptz'], ParentType, ContextType>;
  domainOrganization?: Resolver<Maybe<ResolversTypes['TaskDomainOrganization']>, ParentType, ContextType>;
  domainOrganizationId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  domainUserCategory?: Resolver<Maybe<ResolversTypes['TaskDomainUserCategory']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Tasktimestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskDomainUserAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskDomainUserAggregate'] = ResolversParentTypes['TaskDomainUserAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TaskDomainUserAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TaskDomainUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskDomainUserAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskDomainUserAggregateFields'] = ResolversParentTypes['TaskDomainUserAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TaskDomainUserAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TaskDomainUserMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TaskDomainUserMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskDomainUserCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskDomainUserCategory'] = ResolversParentTypes['TaskDomainUserCategory']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskDomainUserCategoryAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskDomainUserCategoryAggregate'] = ResolversParentTypes['TaskDomainUserCategoryAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TaskDomainUserCategoryAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TaskDomainUserCategory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskDomainUserCategoryAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskDomainUserCategoryAggregateFields'] = ResolversParentTypes['TaskDomainUserCategoryAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TaskDomainUserCategoryAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TaskDomainUserCategoryMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TaskDomainUserCategoryMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskDomainUserCategoryMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskDomainUserCategoryMaxFields'] = ResolversParentTypes['TaskDomainUserCategoryMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskDomainUserCategoryMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskDomainUserCategoryMinFields'] = ResolversParentTypes['TaskDomainUserCategoryMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskDomainUserCategoryMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskDomainUserCategoryMutationResponse'] = ResolversParentTypes['TaskDomainUserCategoryMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['TaskDomainUserCategory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskDomainUserMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskDomainUserMaxFields'] = ResolversParentTypes['TaskDomainUserMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['Tasktimestamptz']>, ParentType, ContextType>;
  domainOrganizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Tasktimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskDomainUserMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskDomainUserMinFields'] = ResolversParentTypes['TaskDomainUserMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['Tasktimestamptz']>, ParentType, ContextType>;
  domainOrganizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Tasktimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskDomainUserMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskDomainUserMutationResponse'] = ResolversParentTypes['TaskDomainUserMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['TaskDomainUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface TaskjsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Taskjson'], any> {
  name: 'Taskjson';
}

export interface TaskjsonbScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Taskjsonb'], any> {
  name: 'Taskjsonb';
}

export type TasktaskActivityOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['TasktaskActivityOutput'] = ResolversParentTypes['TasktaskActivityOutput']> = {
  result?: Resolver<ResolversTypes['Taskjson'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface TasktimestamptzScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Tasktimestamptz'], any> {
  name: 'Tasktimestamptz';
}

export type TelephonyActivityParticipantRoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyActivityParticipantRole'] = ResolversParentTypes['TelephonyActivityParticipantRole']> = {
  activityParticipants?: Resolver<Array<ResolversTypes['TelephonyactivityParticipant']>, ParentType, ContextType, Partial<TelephonyActivityParticipantRoleactivityParticipantsArgs>>;
  activityParticipantsAggregate?: Resolver<ResolversTypes['TelephonyactivityParticipantAggregate'], ParentType, ContextType, Partial<TelephonyActivityParticipantRoleactivityParticipantsAggregateArgs>>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyActivityParticipantRoleAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyActivityParticipantRoleAggregate'] = ResolversParentTypes['TelephonyActivityParticipantRoleAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TelephonyActivityParticipantRoleAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TelephonyActivityParticipantRole']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyActivityParticipantRoleAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyActivityParticipantRoleAggregateFields'] = ResolversParentTypes['TelephonyActivityParticipantRoleAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TelephonyActivityParticipantRoleAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TelephonyActivityParticipantRoleMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TelephonyActivityParticipantRoleMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyActivityParticipantRoleMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyActivityParticipantRoleMaxFields'] = ResolversParentTypes['TelephonyActivityParticipantRoleMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyActivityParticipantRoleMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyActivityParticipantRoleMinFields'] = ResolversParentTypes['TelephonyActivityParticipantRoleMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyActivityParticipantRoleMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyActivityParticipantRoleMutationResponse'] = ResolversParentTypes['TelephonyActivityParticipantRoleMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['TelephonyActivityParticipantRole']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyActivityTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyActivityType'] = ResolversParentTypes['TelephonyActivityType']> = {
  activities?: Resolver<Array<ResolversTypes['Telephonyactivity']>, ParentType, ContextType, Partial<TelephonyActivityTypeactivitiesArgs>>;
  activitiesAggregate?: Resolver<ResolversTypes['TelephonyactivityAggregate'], ParentType, ContextType, Partial<TelephonyActivityTypeactivitiesAggregateArgs>>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyActivityTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyActivityTypeAggregate'] = ResolversParentTypes['TelephonyActivityTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TelephonyActivityTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TelephonyActivityType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyActivityTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyActivityTypeAggregateFields'] = ResolversParentTypes['TelephonyActivityTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TelephonyActivityTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TaskActivityTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TaskActivityTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyActivityTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyActivityTypeMutationResponse'] = ResolversParentTypes['TelephonyActivityTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['TelephonyActivityType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyCallDirectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyCallDirection'] = ResolversParentTypes['TelephonyCallDirection']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<Array<ResolversTypes['Telephonyevent']>, ParentType, ContextType, Partial<TelephonyCallDirectioneventsArgs>>;
  eventsAggregate?: Resolver<ResolversTypes['TelephonyeventAggregate'], ParentType, ContextType, Partial<TelephonyCallDirectioneventsAggregateArgs>>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyCallDirectionAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyCallDirectionAggregate'] = ResolversParentTypes['TelephonyCallDirectionAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TelephonyCallDirectionAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TelephonyCallDirection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyCallDirectionAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyCallDirectionAggregateFields'] = ResolversParentTypes['TelephonyCallDirectionAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TelephonyCallDirectionAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TelephonyCallDirectionMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TelephonyCallDirectionMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyCallDirectionMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyCallDirectionMaxFields'] = ResolversParentTypes['TelephonyCallDirectionMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyCallDirectionMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyCallDirectionMinFields'] = ResolversParentTypes['TelephonyCallDirectionMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyCallDirectionMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyCallDirectionMutationResponse'] = ResolversParentTypes['TelephonyCallDirectionMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['TelephonyCallDirection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyCallResultOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyCallResultOutput'] = ResolversParentTypes['TelephonyCallResultOutput']> = {
  result?: Resolver<ResolversTypes['TelephonyCallResultType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyClickToCallOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyClickToCallOutput'] = ResolversParentTypes['TelephonyClickToCallOutput']> = {
  error?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyCredentialsOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyCredentialsOutput'] = ResolversParentTypes['TelephonyCredentialsOutput']> = {
  error?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyDomainUserCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyDomainUserCategory'] = ResolversParentTypes['TelephonyDomainUserCategory']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  domainUsers?: Resolver<Array<ResolversTypes['TelephonydomainUser']>, ParentType, ContextType, Partial<TelephonyDomainUserCategorydomainUsersArgs>>;
  domainUsersAggregate?: Resolver<ResolversTypes['TelephonydomainUserAggregate'], ParentType, ContextType, Partial<TelephonyDomainUserCategorydomainUsersAggregateArgs>>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyDomainUserCategoryAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyDomainUserCategoryAggregate'] = ResolversParentTypes['TelephonyDomainUserCategoryAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TelephonyDomainUserCategoryAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TelephonyDomainUserCategory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyDomainUserCategoryAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyDomainUserCategoryAggregateFields'] = ResolversParentTypes['TelephonyDomainUserCategoryAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TelephonyDomainUserCategoryAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TaskDomainUserCategoryMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TaskDomainUserCategoryMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyDomainUserCategoryMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyDomainUserCategoryMutationResponse'] = ResolversParentTypes['TelephonyDomainUserCategoryMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['TelephonyDomainUserCategory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyDomainUserOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyDomainUserOutput'] = ResolversParentTypes['TelephonyDomainUserOutput']> = {
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  domainOrganizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  function?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numberType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  personId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyLookupPhoneNumberOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyLookupPhoneNumberOutput'] = ResolversParentTypes['TelephonyLookupPhoneNumberOutput']> = {
  category?: Resolver<Maybe<ResolversTypes['TelephonyEntryCategory']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['TelephonyEntrySource']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyNumberStateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyNumberState'] = ResolversParentTypes['TelephonyNumberState']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<Array<ResolversTypes['Telephonyevent']>, ParentType, ContextType, Partial<TelephonyNumberStateeventsArgs>>;
  eventsAggregate?: Resolver<ResolversTypes['TelephonyeventAggregate'], ParentType, ContextType, Partial<TelephonyNumberStateeventsAggregateArgs>>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyNumberStateAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyNumberStateAggregate'] = ResolversParentTypes['TelephonyNumberStateAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TelephonyNumberStateAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TelephonyNumberState']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyNumberStateAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyNumberStateAggregateFields'] = ResolversParentTypes['TelephonyNumberStateAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TelephonyNumberStateAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TelephonyNumberStateMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TelephonyNumberStateMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyNumberStateMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyNumberStateMaxFields'] = ResolversParentTypes['TelephonyNumberStateMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyNumberStateMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyNumberStateMinFields'] = ResolversParentTypes['TelephonyNumberStateMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyNumberStateMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyNumberStateMutationResponse'] = ResolversParentTypes['TelephonyNumberStateMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['TelephonyNumberState']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyPhoneRequestOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyPhoneRequestOutput'] = ResolversParentTypes['TelephonyPhoneRequestOutput']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyProviderTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyProviderType'] = ResolversParentTypes['TelephonyProviderType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerAccounts?: Resolver<Array<ResolversTypes['TelephonyproviderAccount']>, ParentType, ContextType, Partial<TelephonyProviderTypeproviderAccountsArgs>>;
  providerAccountsAggregate?: Resolver<ResolversTypes['TelephonyproviderAccountAggregate'], ParentType, ContextType, Partial<TelephonyProviderTypeproviderAccountsAggregateArgs>>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyProviderTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyProviderTypeAggregate'] = ResolversParentTypes['TelephonyProviderTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TelephonyProviderTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TelephonyProviderType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyProviderTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyProviderTypeAggregateFields'] = ResolversParentTypes['TelephonyProviderTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TelephonyProviderTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TelephonyProviderTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TelephonyProviderTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyProviderTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyProviderTypeMaxFields'] = ResolversParentTypes['TelephonyProviderTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyProviderTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyProviderTypeMinFields'] = ResolversParentTypes['TelephonyProviderTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyProviderTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyProviderTypeMutationResponse'] = ResolversParentTypes['TelephonyProviderTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['TelephonyProviderType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonySendSMSOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonySendSMSOutput'] = ResolversParentTypes['TelephonySendSMSOutput']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messageId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resultCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonySynchronizeDomainUsersOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonySynchronizeDomainUsersOutput'] = ResolversParentTypes['TelephonySynchronizeDomainUsersOutput']> = {
  accessToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyActionEventTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyActionEventType'] = ResolversParentTypes['TelephonyTelephonyActionEventType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyActionEventTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyActionEventTypeAggregate'] = ResolversParentTypes['TelephonyTelephonyActionEventTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyActionEventTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TelephonyTelephonyActionEventType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyActionEventTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyActionEventTypeAggregateFields'] = ResolversParentTypes['TelephonyTelephonyActionEventTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TelephonyTelephonyActionEventTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyActionEventTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyActionEventTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyActionEventTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyActionEventTypeMaxFields'] = ResolversParentTypes['TelephonyTelephonyActionEventTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyActionEventTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyActionEventTypeMinFields'] = ResolversParentTypes['TelephonyTelephonyActionEventTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyActionEventTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyActionEventTypeMutationResponse'] = ResolversParentTypes['TelephonyTelephonyActionEventTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['TelephonyTelephonyActionEventType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyActionTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyActionType'] = ResolversParentTypes['TelephonyTelephonyActionType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyActionTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyActionTypeAggregate'] = ResolversParentTypes['TelephonyTelephonyActionTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyActionTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TelephonyTelephonyActionType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyActionTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyActionTypeAggregateFields'] = ResolversParentTypes['TelephonyTelephonyActionTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TelephonyTelephonyActionTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyActionTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyActionTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyActionTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyActionTypeMaxFields'] = ResolversParentTypes['TelephonyTelephonyActionTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyActionTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyActionTypeMinFields'] = ResolversParentTypes['TelephonyTelephonyActionTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyActionTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyActionTypeMutationResponse'] = ResolversParentTypes['TelephonyTelephonyActionTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['TelephonyTelephonyActionType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyBlockedDomainUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyBlockedDomainUser'] = ResolversParentTypes['TelephonyTelephonyBlockedDomainUser']> = {
  blockedByDomainUserId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  blockedDomainUser?: Resolver<Maybe<ResolversTypes['TelephonydomainUser']>, ParentType, ContextType>;
  blockedDomainUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Telephonytimestamptz'], ParentType, ContextType>;
  domainUser?: Resolver<Maybe<ResolversTypes['TelephonydomainUser']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Telephonytimestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyBlockedDomainUserAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyBlockedDomainUserAggregate'] = ResolversParentTypes['TelephonyTelephonyBlockedDomainUserAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyBlockedDomainUserAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TelephonyTelephonyBlockedDomainUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyBlockedDomainUserAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyBlockedDomainUserAggregateFields'] = ResolversParentTypes['TelephonyTelephonyBlockedDomainUserAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TelephonyTelephonyBlockedDomainUserAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyBlockedDomainUserMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyBlockedDomainUserMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyBlockedDomainUserMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyBlockedDomainUserMaxFields'] = ResolversParentTypes['TelephonyTelephonyBlockedDomainUserMaxFields']> = {
  blockedByDomainUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  blockedDomainUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyBlockedDomainUserMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyBlockedDomainUserMinFields'] = ResolversParentTypes['TelephonyTelephonyBlockedDomainUserMinFields']> = {
  blockedByDomainUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  blockedDomainUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyBlockedDomainUserMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyBlockedDomainUserMutationResponse'] = ResolversParentTypes['TelephonyTelephonyBlockedDomainUserMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['TelephonyTelephonyBlockedDomainUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyCiscoSubscriberProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyCiscoSubscriberProduct'] = ResolversParentTypes['TelephonyTelephonyCiscoSubscriberProduct']> = {
  createdAt?: Resolver<ResolversTypes['Telephonytimestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  product?: Resolver<ResolversTypes['TelephonyProviderTypeEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Telephonytimestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyCiscoSubscriberProductAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyCiscoSubscriberProductAggregate'] = ResolversParentTypes['TelephonyTelephonyCiscoSubscriberProductAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyCiscoSubscriberProductAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TelephonyTelephonyCiscoSubscriberProduct']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyCiscoSubscriberProductAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyCiscoSubscriberProductAggregateFields'] = ResolversParentTypes['TelephonyTelephonyCiscoSubscriberProductAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TelephonyTelephonyCiscoSubscriberProductAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyCiscoSubscriberProductMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyCiscoSubscriberProductMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyCiscoSubscriberProductMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyCiscoSubscriberProductMaxFields'] = ResolversParentTypes['TelephonyTelephonyCiscoSubscriberProductMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyCiscoSubscriberProductMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyCiscoSubscriberProductMinFields'] = ResolversParentTypes['TelephonyTelephonyCiscoSubscriberProductMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyCiscoSubscriberProductMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyCiscoSubscriberProductMutationResponse'] = ResolversParentTypes['TelephonyTelephonyCiscoSubscriberProductMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['TelephonyTelephonyCiscoSubscriberProduct']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyEventsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyEvents'] = ResolversParentTypes['TelephonyTelephonyEvents']> = {
  activity?: Resolver<ResolversTypes['Telephonyactivity'], ParentType, ContextType>;
  activityId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  callingNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Telephonytimestamptz'], ParentType, ContextType>;
  destinationNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  personNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Telephonytimestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyEventsAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyEventsAggregate'] = ResolversParentTypes['TelephonyTelephonyEventsAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyEventsAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TelephonyTelephonyEvents']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyEventsAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyEventsAggregateFields'] = ResolversParentTypes['TelephonyTelephonyEventsAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TelephonyTelephonyEventsAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyEventsMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyEventsMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyEventsMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyEventsMaxFields'] = ResolversParentTypes['TelephonyTelephonyEventsMaxFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  callingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  destinationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  personNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timestamp?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyEventsMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyEventsMinFields'] = ResolversParentTypes['TelephonyTelephonyEventsMinFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  callingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  destinationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  personNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timestamp?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyEventsMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyEventsMutationResponse'] = ResolversParentTypes['TelephonyTelephonyEventsMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['TelephonyTelephonyEvents']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyLookupCallerApiResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyLookupCallerApi'] = ResolversParentTypes['TelephonyTelephonyLookupCallerApi']> = {
  createdAt?: Resolver<ResolversTypes['Telephonytimestamptz'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['Telephonyjsonb'], ParentType, ContextType, Partial<TelephonyTelephonyLookupCallerApidataArgs>>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Telephonytimestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyLookupCallerApiAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyLookupCallerApiAggregate'] = ResolversParentTypes['TelephonyTelephonyLookupCallerApiAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupCallerApiAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TelephonyTelephonyLookupCallerApi']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyLookupCallerApiAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyLookupCallerApiAggregateFields'] = ResolversParentTypes['TelephonyTelephonyLookupCallerApiAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TelephonyTelephonyLookupCallerApiAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupCallerApiMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupCallerApiMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyLookupCallerApiMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyLookupCallerApiMaxFields'] = ResolversParentTypes['TelephonyTelephonyLookupCallerApiMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyLookupCallerApiMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyLookupCallerApiMinFields'] = ResolversParentTypes['TelephonyTelephonyLookupCallerApiMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyLookupCallerApiMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyLookupCallerApiMutationResponse'] = ResolversParentTypes['TelephonyTelephonyLookupCallerApiMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['TelephonyTelephonyLookupCallerApi']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyLookupRefreshResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyLookupRefresh'] = ResolversParentTypes['TelephonyTelephonyLookupRefresh']> = {
  refresh?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['TelephonyTelephonyLookupTypesEnum'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyLookupRefreshAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyLookupRefreshAggregate'] = ResolversParentTypes['TelephonyTelephonyLookupRefreshAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupRefreshAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TelephonyTelephonyLookupRefresh']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyLookupRefreshAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyLookupRefreshAggregateFields'] = ResolversParentTypes['TelephonyTelephonyLookupRefreshAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupRefreshAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TelephonyTelephonyLookupRefreshAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupRefreshMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupRefreshMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupRefreshStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupRefreshStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupRefreshStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupRefreshSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupRefreshVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupRefreshVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupRefreshVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyLookupRefreshAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyLookupRefreshAvgFields'] = ResolversParentTypes['TelephonyTelephonyLookupRefreshAvgFields']> = {
  refresh?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyLookupRefreshMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyLookupRefreshMaxFields'] = ResolversParentTypes['TelephonyTelephonyLookupRefreshMaxFields']> = {
  refresh?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyLookupRefreshMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyLookupRefreshMinFields'] = ResolversParentTypes['TelephonyTelephonyLookupRefreshMinFields']> = {
  refresh?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyLookupRefreshMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyLookupRefreshMutationResponse'] = ResolversParentTypes['TelephonyTelephonyLookupRefreshMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['TelephonyTelephonyLookupRefresh']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyLookupRefreshStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyLookupRefreshStddevFields'] = ResolversParentTypes['TelephonyTelephonyLookupRefreshStddevFields']> = {
  refresh?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyLookupRefreshStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyLookupRefreshStddevPopFields'] = ResolversParentTypes['TelephonyTelephonyLookupRefreshStddevPopFields']> = {
  refresh?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyLookupRefreshStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyLookupRefreshStddevSampFields'] = ResolversParentTypes['TelephonyTelephonyLookupRefreshStddevSampFields']> = {
  refresh?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyLookupRefreshSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyLookupRefreshSumFields'] = ResolversParentTypes['TelephonyTelephonyLookupRefreshSumFields']> = {
  refresh?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyLookupRefreshVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyLookupRefreshVarPopFields'] = ResolversParentTypes['TelephonyTelephonyLookupRefreshVarPopFields']> = {
  refresh?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyLookupRefreshVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyLookupRefreshVarSampFields'] = ResolversParentTypes['TelephonyTelephonyLookupRefreshVarSampFields']> = {
  refresh?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyLookupRefreshVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyLookupRefreshVarianceFields'] = ResolversParentTypes['TelephonyTelephonyLookupRefreshVarianceFields']> = {
  refresh?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyLookupTypesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyLookupTypes'] = ResolversParentTypes['TelephonyTelephonyLookupTypes']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyLookupTypesAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyLookupTypesAggregate'] = ResolversParentTypes['TelephonyTelephonyLookupTypesAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupTypesAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TelephonyTelephonyLookupTypes']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyLookupTypesAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyLookupTypesAggregateFields'] = ResolversParentTypes['TelephonyTelephonyLookupTypesAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TelephonyTelephonyLookupTypesAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupTypesMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupTypesMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyLookupTypesMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyLookupTypesMaxFields'] = ResolversParentTypes['TelephonyTelephonyLookupTypesMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyLookupTypesMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyLookupTypesMinFields'] = ResolversParentTypes['TelephonyTelephonyLookupTypesMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyLookupTypesMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyLookupTypesMutationResponse'] = ResolversParentTypes['TelephonyTelephonyLookupTypesMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['TelephonyTelephonyLookupTypes']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyPodsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyPods'] = ResolversParentTypes['TelephonyTelephonyPods']> = {
  createdAt?: Resolver<ResolversTypes['Telephonytimestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Telephonytimestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyPodsAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyPodsAggregate'] = ResolversParentTypes['TelephonyTelephonyPodsAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyPodsAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TelephonyTelephonyPods']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyPodsAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyPodsAggregateFields'] = ResolversParentTypes['TelephonyTelephonyPodsAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TelephonyTelephonyPodsAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyPodsMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyPodsMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyPodsMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyPodsMaxFields'] = ResolversParentTypes['TelephonyTelephonyPodsMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyPodsMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyPodsMinFields'] = ResolversParentTypes['TelephonyTelephonyPodsMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyPodsMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyPodsMutationResponse'] = ResolversParentTypes['TelephonyTelephonyPodsMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['TelephonyTelephonyPods']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyProviderAccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyProviderAccess'] = ResolversParentTypes['TelephonyTelephonyProviderAccess']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyProviderAccessAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyProviderAccessAggregate'] = ResolversParentTypes['TelephonyTelephonyProviderAccessAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyProviderAccessAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TelephonyTelephonyProviderAccess']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyProviderAccessAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyProviderAccessAggregateFields'] = ResolversParentTypes['TelephonyTelephonyProviderAccessAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TelephonyTelephonyProviderAccessAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyProviderAccessMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyProviderAccessMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyProviderAccessMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyProviderAccessMaxFields'] = ResolversParentTypes['TelephonyTelephonyProviderAccessMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyProviderAccessMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyProviderAccessMinFields'] = ResolversParentTypes['TelephonyTelephonyProviderAccessMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyTelephonyProviderAccessMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyTelephonyProviderAccessMutationResponse'] = ResolversParentTypes['TelephonyTelephonyProviderAccessMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['TelephonyTelephonyProviderAccess']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyactiveNumbersResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyactiveNumbers'] = ResolversParentTypes['TelephonyactiveNumbers']> = {
  phoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyactiveNumbersAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyactiveNumbersAggregate'] = ResolversParentTypes['TelephonyactiveNumbersAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TelephonyactiveNumbersAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TelephonyactiveNumbers']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyactiveNumbersAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyactiveNumbersAggregateFields'] = ResolversParentTypes['TelephonyactiveNumbersAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TelephonyactiveNumbersAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TelephonyactiveNumbersMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TelephonyactiveNumbersMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyactiveNumbersMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyactiveNumbersMaxFields'] = ResolversParentTypes['TelephonyactiveNumbersMaxFields']> = {
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyactiveNumbersMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyactiveNumbersMinFields'] = ResolversParentTypes['TelephonyactiveNumbersMinFields']> = {
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyactiveNumbersMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyactiveNumbersMutationResponse'] = ResolversParentTypes['TelephonyactiveNumbersMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['TelephonyactiveNumbers']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyactivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['Telephonyactivity'] = ResolversParentTypes['Telephonyactivity']> = {
  actionEventType?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyActionEventTypeEnum']>, ParentType, ContextType>;
  activityParticipants?: Resolver<Array<ResolversTypes['TelephonyactivityParticipant']>, ParentType, ContextType, Partial<TelephonyactivityactivityParticipantsArgs>>;
  activityParticipantsAggregate?: Resolver<ResolversTypes['TelephonyactivityParticipantAggregate'], ParentType, ContextType, Partial<TelephonyactivityactivityParticipantsAggregateArgs>>;
  activity_type?: Resolver<Maybe<ResolversTypes['TelephonyActivityType']>, ParentType, ContextType>;
  callId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comments?: Resolver<Array<ResolversTypes['Telephonycomment']>, ParentType, ContextType, Partial<TelephonyactivitycommentsArgs>>;
  commentsAggregate?: Resolver<ResolversTypes['TelephonycommentAggregate'], ParentType, ContextType, Partial<TelephonyactivitycommentsAggregateArgs>>;
  createdAt?: Resolver<ResolversTypes['Telephonytimestamptz'], ParentType, ContextType>;
  destinationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  direction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  events?: Resolver<Array<ResolversTypes['TelephonyTelephonyEvents']>, ParentType, ContextType, Partial<TelephonyactivityeventsArgs>>;
  eventsAggregate?: Resolver<ResolversTypes['TelephonyTelephonyEventsAggregate'], ParentType, ContextType, Partial<TelephonyactivityeventsAggregateArgs>>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  latestAlertReceivedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  latestBusyReceivedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  latestIdleReceivedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  mainNumberCallId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  originatingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['TelephonydomainUser']>, ParentType, ContextType>;
  ownerId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  provider?: Resolver<Maybe<ResolversTypes['TelephonyProviderTypeEnum']>, ParentType, ContextType>;
  requestEndedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  requestStartedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  startedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['TelephonyActivityTypeEnum']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Telephonytimestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyactivityAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyactivityAggregate'] = ResolversParentTypes['TelephonyactivityAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TelephonyactivityAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Telephonyactivity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyactivityAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyactivityAggregateFields'] = ResolversParentTypes['TelephonyactivityAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['TelephonyactivityAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TelephonyactivityAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TelephonyactivityMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TelephonyactivityMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['TelephonyactivityStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['TelephonyactivityStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['TelephonyactivityStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['TelephonyactivitySumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['TelephonyactivityVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['TelephonyactivityVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['TelephonyactivityVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyactivityAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyactivityAvgFields'] = ResolversParentTypes['TelephonyactivityAvgFields']> = {
  number?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyactivityMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyactivityMaxFields'] = ResolversParentTypes['TelephonyactivityMaxFields']> = {
  callId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  destinationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  direction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  latestAlertReceivedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  latestBusyReceivedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  latestIdleReceivedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  mainNumberCallId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  originatingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ownerId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  requestEndedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  requestStartedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  startedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyactivityMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyactivityMinFields'] = ResolversParentTypes['TelephonyactivityMinFields']> = {
  callId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  destinationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  direction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  latestAlertReceivedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  latestBusyReceivedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  latestIdleReceivedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  mainNumberCallId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  originatingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ownerId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  requestEndedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  requestStartedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  startedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyactivityMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyactivityMutationResponse'] = ResolversParentTypes['TelephonyactivityMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['Telephonyactivity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyactivityParticipantResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyactivityParticipant'] = ResolversParentTypes['TelephonyactivityParticipant']> = {
  activity?: Resolver<Maybe<ResolversTypes['Telephonyactivity']>, ParentType, ContextType>;
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Telephonytimestamptz'], ParentType, ContextType>;
  domainUser?: Resolver<Maybe<ResolversTypes['TelephonydomainUser']>, ParentType, ContextType>;
  domainUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['TelephonyActivityParticipantRoleEnum']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Telephonytimestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyactivityParticipantAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyactivityParticipantAggregate'] = ResolversParentTypes['TelephonyactivityParticipantAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TelephonyactivityParticipantAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TelephonyactivityParticipant']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyactivityParticipantAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyactivityParticipantAggregateFields'] = ResolversParentTypes['TelephonyactivityParticipantAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TelephonyactivityParticipantAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TelephonyactivityParticipantMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TelephonyactivityParticipantMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyactivityParticipantMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyactivityParticipantMaxFields'] = ResolversParentTypes['TelephonyactivityParticipantMaxFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  domainUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyactivityParticipantMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyactivityParticipantMinFields'] = ResolversParentTypes['TelephonyactivityParticipantMinFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  domainUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyactivityParticipantMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyactivityParticipantMutationResponse'] = ResolversParentTypes['TelephonyactivityParticipantMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['TelephonyactivityParticipant']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyactivityStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyactivityStddevFields'] = ResolversParentTypes['TelephonyactivityStddevFields']> = {
  number?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyactivityStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyactivityStddevPopFields'] = ResolversParentTypes['TelephonyactivityStddevPopFields']> = {
  number?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyactivityStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyactivityStddevSampFields'] = ResolversParentTypes['TelephonyactivityStddevSampFields']> = {
  number?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyactivitySumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyactivitySumFields'] = ResolversParentTypes['TelephonyactivitySumFields']> = {
  number?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyactivityVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyactivityVarPopFields'] = ResolversParentTypes['TelephonyactivityVarPopFields']> = {
  number?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyactivityVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyactivityVarSampFields'] = ResolversParentTypes['TelephonyactivityVarSampFields']> = {
  number?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyactivityVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyactivityVarianceFields'] = ResolversParentTypes['TelephonyactivityVarianceFields']> = {
  number?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonycommentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Telephonycomment'] = ResolversParentTypes['Telephonycomment']> = {
  activity?: Resolver<Maybe<ResolversTypes['Telephonyactivity']>, ParentType, ContextType>;
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Telephonytimestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Telephonytimestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonycommentAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonycommentAggregate'] = ResolversParentTypes['TelephonycommentAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TelephonycommentAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Telephonycomment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonycommentAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonycommentAggregateFields'] = ResolversParentTypes['TelephonycommentAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TelephonycommentAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TelephonycommentMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TelephonycommentMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonycommentMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonycommentMaxFields'] = ResolversParentTypes['TelephonycommentMaxFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonycommentMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonycommentMinFields'] = ResolversParentTypes['TelephonycommentMinFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonycommentMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonycommentMutationResponse'] = ResolversParentTypes['TelephonycommentMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['Telephonycomment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonydomainOrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonydomainOrganization'] = ResolversParentTypes['TelephonydomainOrganization']> = {
  adminId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  autoGenerated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Telephonytimestamptz'], ParentType, ContextType>;
  domainUsers?: Resolver<Array<ResolversTypes['TelephonydomainUser']>, ParentType, ContextType, Partial<TelephonydomainOrganizationdomainUsersArgs>>;
  domainUsersAggregate?: Resolver<ResolversTypes['TelephonydomainUserAggregate'], ParentType, ContextType, Partial<TelephonydomainOrganizationdomainUsersAggregateArgs>>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  pod?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyPods']>, ParentType, ContextType>;
  podName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  providerAccount?: Resolver<Maybe<ResolversTypes['TelephonyproviderAccount']>, ParentType, ContextType>;
  providerAccountId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  providerClientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  providerClientName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  providerClientSubscribed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Telephonytimestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonydomainOrganizationAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonydomainOrganizationAggregate'] = ResolversParentTypes['TelephonydomainOrganizationAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TelephonydomainOrganizationAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TelephonydomainOrganization']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonydomainOrganizationAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonydomainOrganizationAggregateFields'] = ResolversParentTypes['TelephonydomainOrganizationAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TelephonydomainOrganizationAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TelephonydomainOrganizationMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TelephonydomainOrganizationMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonydomainOrganizationMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonydomainOrganizationMaxFields'] = ResolversParentTypes['TelephonydomainOrganizationMaxFields']> = {
  adminId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  podName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  providerAccountId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  providerClientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  providerClientName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonydomainOrganizationMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonydomainOrganizationMinFields'] = ResolversParentTypes['TelephonydomainOrganizationMinFields']> = {
  adminId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  podName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  providerAccountId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  providerClientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  providerClientName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonydomainOrganizationMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonydomainOrganizationMutationResponse'] = ResolversParentTypes['TelephonydomainOrganizationMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['TelephonydomainOrganization']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonydomainUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonydomainUser'] = ResolversParentTypes['TelephonydomainUser']> = {
  activityParticipants?: Resolver<Array<ResolversTypes['TelephonyactivityParticipant']>, ParentType, ContextType, Partial<TelephonydomainUseractivityParticipantsArgs>>;
  activityParticipantsAggregate?: Resolver<ResolversTypes['TelephonyactivityParticipantAggregate'], ParentType, ContextType, Partial<TelephonydomainUseractivityParticipantsAggregateArgs>>;
  category?: Resolver<Maybe<ResolversTypes['TelephonyDomainUserCategoryEnum']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Telephonytimestamptz'], ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  domainOrganization?: Resolver<ResolversTypes['TelephonydomainOrganization'], ParentType, ContextType>;
  domainOrganizationId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  domainUserCategory?: Resolver<Maybe<ResolversTypes['TelephonyDomainUserCategory']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  function?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lookupRawData?: Resolver<Maybe<ResolversTypes['Telephonyjsonb']>, ParentType, ContextType, Partial<TelephonydomainUserlookupRawDataArgs>>;
  numberType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  personId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['TelephonyProviderTypeEnum']>, ParentType, ContextType>;
  spamScore?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Telephonytimestamptz'], ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonydomainUserAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonydomainUserAggregate'] = ResolversParentTypes['TelephonydomainUserAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TelephonydomainUserAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TelephonydomainUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonydomainUserAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonydomainUserAggregateFields'] = ResolversParentTypes['TelephonydomainUserAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['TelephonydomainUserAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TelephonydomainUserAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TelephonydomainUserMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TelephonydomainUserMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['TelephonydomainUserStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['TelephonydomainUserStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['TelephonydomainUserStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['TelephonydomainUserSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['TelephonydomainUserVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['TelephonydomainUserVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['TelephonydomainUserVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonydomainUserAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonydomainUserAvgFields'] = ResolversParentTypes['TelephonydomainUserAvgFields']> = {
  spamScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonydomainUserMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonydomainUserMaxFields'] = ResolversParentTypes['TelephonydomainUserMaxFields']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  domainOrganizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  function?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numberType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  personId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  spamScore?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonydomainUserMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonydomainUserMinFields'] = ResolversParentTypes['TelephonydomainUserMinFields']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  domainOrganizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  function?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numberType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  personId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  spamScore?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonydomainUserMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonydomainUserMutationResponse'] = ResolversParentTypes['TelephonydomainUserMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['TelephonydomainUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonydomainUserStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonydomainUserStddevFields'] = ResolversParentTypes['TelephonydomainUserStddevFields']> = {
  spamScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonydomainUserStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonydomainUserStddevPopFields'] = ResolversParentTypes['TelephonydomainUserStddevPopFields']> = {
  spamScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonydomainUserStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonydomainUserStddevSampFields'] = ResolversParentTypes['TelephonydomainUserStddevSampFields']> = {
  spamScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonydomainUserSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonydomainUserSumFields'] = ResolversParentTypes['TelephonydomainUserSumFields']> = {
  spamScore?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonydomainUserVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonydomainUserVarPopFields'] = ResolversParentTypes['TelephonydomainUserVarPopFields']> = {
  spamScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonydomainUserVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonydomainUserVarSampFields'] = ResolversParentTypes['TelephonydomainUserVarSampFields']> = {
  spamScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonydomainUserVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonydomainUserVarianceFields'] = ResolversParentTypes['TelephonydomainUserVarianceFields']> = {
  spamScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyeventResolvers<ContextType = any, ParentType extends ResolversParentTypes['Telephonyevent'] = ResolversParentTypes['Telephonyevent']> = {
  callDirection?: Resolver<Maybe<ResolversTypes['TelephonyCallDirection']>, ParentType, ContextType>;
  callId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  destinationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  direction?: Resolver<Maybe<ResolversTypes['TelephonyCallDirectionEnum']>, ParentType, ContextType>;
  handledAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  numberState?: Resolver<Maybe<ResolversTypes['TelephonyNumberState']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  originatingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  provider?: Resolver<Maybe<ResolversTypes['TelephonyProviderTypeEnum']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['TelephonyNumberStateEnum']>, ParentType, ContextType>;
  timestamp?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyeventActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyeventAction'] = ResolversParentTypes['TelephonyeventAction']> = {
  actionType?: Resolver<ResolversTypes['TelephonyTelephonyActionType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Telephonytimestamptz'], ParentType, ContextType>;
  destinationNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  event?: Resolver<ResolversTypes['TelephonyTelephonyEvents'], ParentType, ContextType>;
  eventId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  handledAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  originalEvent?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyEvents']>, ParentType, ContextType>;
  originalEventId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  originatingNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['TelephonyNumberStateEnum'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['TelephonyTelephonyActionTypeEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Telephonytimestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyeventActionAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyeventActionAggregate'] = ResolversParentTypes['TelephonyeventActionAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TelephonyeventActionAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TelephonyeventAction']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyeventActionAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyeventActionAggregateFields'] = ResolversParentTypes['TelephonyeventActionAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TelephonyeventActionAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TelephonyeventActionMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TelephonyeventActionMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyeventActionMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyeventActionMaxFields'] = ResolversParentTypes['TelephonyeventActionMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  destinationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  handledAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  originalEventId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  originatingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyeventActionMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyeventActionMinFields'] = ResolversParentTypes['TelephonyeventActionMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  destinationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  handledAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  originalEventId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  originatingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyeventActionMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyeventActionMutationResponse'] = ResolversParentTypes['TelephonyeventActionMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['TelephonyeventAction']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyeventAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyeventAggregate'] = ResolversParentTypes['TelephonyeventAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TelephonyeventAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Telephonyevent']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyeventAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyeventAggregateFields'] = ResolversParentTypes['TelephonyeventAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['TelephonyeventAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TelephonyeventAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TelephonyeventMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TelephonyeventMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['TelephonyeventStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['TelephonyeventStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['TelephonyeventStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['TelephonyeventSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['TelephonyeventVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['TelephonyeventVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['TelephonyeventVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyeventAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyeventAvgFields'] = ResolversParentTypes['TelephonyeventAvgFields']> = {
  organizationId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyeventMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyeventMaxFields'] = ResolversParentTypes['TelephonyeventMaxFields']> = {
  callId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  destinationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  handledAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  originatingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timestamp?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyeventMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyeventMinFields'] = ResolversParentTypes['TelephonyeventMinFields']> = {
  callId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  destinationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  handledAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  originatingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timestamp?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyeventMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyeventMutationResponse'] = ResolversParentTypes['TelephonyeventMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['Telephonyevent']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyeventStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyeventStddevFields'] = ResolversParentTypes['TelephonyeventStddevFields']> = {
  organizationId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyeventStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyeventStddevPopFields'] = ResolversParentTypes['TelephonyeventStddevPopFields']> = {
  organizationId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyeventStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyeventStddevSampFields'] = ResolversParentTypes['TelephonyeventStddevSampFields']> = {
  organizationId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyeventSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyeventSumFields'] = ResolversParentTypes['TelephonyeventSumFields']> = {
  organizationId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyeventVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyeventVarPopFields'] = ResolversParentTypes['TelephonyeventVarPopFields']> = {
  organizationId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyeventVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyeventVarSampFields'] = ResolversParentTypes['TelephonyeventVarSampFields']> = {
  organizationId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyeventVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyeventVarianceFields'] = ResolversParentTypes['TelephonyeventVarianceFields']> = {
  organizationId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyhangUpCallOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyhangUpCallOutput'] = ResolversParentTypes['TelephonyhangUpCallOutput']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface TelephonyjsonbScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Telephonyjsonb'], any> {
  name: 'Telephonyjsonb';
}

export type TelephonyproviderResolvers<ContextType = any, ParentType extends ResolversParentTypes['Telephonyprovider'] = ResolversParentTypes['Telephonyprovider']> = {
  createdAt?: Resolver<ResolversTypes['Telephonytimestamptz'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endpoint?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  provider_type?: Resolver<Maybe<ResolversTypes['TelephonyProviderType']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['TelephonyProviderTypeEnum']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Telephonytimestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyproviderAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyproviderAccount'] = ResolversParentTypes['TelephonyproviderAccount']> = {
  domainOrganizations?: Resolver<Array<ResolversTypes['TelephonydomainOrganization']>, ParentType, ContextType, Partial<TelephonyproviderAccountdomainOrganizationsArgs>>;
  domainOrganizationsAggregate?: Resolver<ResolversTypes['TelephonydomainOrganizationAggregate'], ParentType, ContextType, Partial<TelephonyproviderAccountdomainOrganizationsAggregateArgs>>;
  endpoint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  password?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  provider?: Resolver<ResolversTypes['Telephonyprovider'], ParentType, ContextType>;
  providerAccess?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyProviderAccessEnum']>, ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerType?: Resolver<Maybe<ResolversTypes['TelephonyProviderType']>, ParentType, ContextType>;
  sessionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['TelephonyProviderTypeEnum']>, ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyproviderAccountAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyproviderAccountAggregate'] = ResolversParentTypes['TelephonyproviderAccountAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TelephonyproviderAccountAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TelephonyproviderAccount']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyproviderAccountAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyproviderAccountAggregateFields'] = ResolversParentTypes['TelephonyproviderAccountAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TelephonyproviderAccountAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TelephonyproviderAccountMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TelephonyproviderAccountMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyproviderAccountMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyproviderAccountMaxFields'] = ResolversParentTypes['TelephonyproviderAccountMaxFields']> = {
  endpoint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  password?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  providerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sessionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyproviderAccountMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyproviderAccountMinFields'] = ResolversParentTypes['TelephonyproviderAccountMinFields']> = {
  endpoint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  password?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  providerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sessionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyproviderAccountMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyproviderAccountMutationResponse'] = ResolversParentTypes['TelephonyproviderAccountMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['TelephonyproviderAccount']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyproviderAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyproviderAggregate'] = ResolversParentTypes['TelephonyproviderAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TelephonyproviderAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Telephonyprovider']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyproviderAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyproviderAggregateFields'] = ResolversParentTypes['TelephonyproviderAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TelephonyproviderAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TelephonyproviderMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TelephonyproviderMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyproviderMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyproviderMaxFields'] = ResolversParentTypes['TelephonyproviderMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endpoint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyproviderMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyproviderMinFields'] = ResolversParentTypes['TelephonyproviderMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endpoint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyproviderMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyproviderMutationResponse'] = ResolversParentTypes['TelephonyproviderMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['Telephonyprovider']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyproviderRequestTermResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyproviderRequestTerm'] = ResolversParentTypes['TelephonyproviderRequestTerm']> = {
  createdAt?: Resolver<ResolversTypes['Telephonytimestamptz'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  provider?: Resolver<Maybe<ResolversTypes['Telephonyprovider']>, ParentType, ContextType>;
  providerId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  terms?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  termsversion?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['TelephonyProviderTypeEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Telephonytimestamptz'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyproviderRequestTermAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyproviderRequestTermAggregate'] = ResolversParentTypes['TelephonyproviderRequestTermAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['TelephonyproviderRequestTermAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TelephonyproviderRequestTerm']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyproviderRequestTermAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyproviderRequestTermAggregateFields'] = ResolversParentTypes['TelephonyproviderRequestTermAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['TelephonyproviderRequestTermAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<TelephonyproviderRequestTermAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['TelephonyproviderRequestTermMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['TelephonyproviderRequestTermMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['TelephonyproviderRequestTermStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['TelephonyproviderRequestTermStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['TelephonyproviderRequestTermStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['TelephonyproviderRequestTermSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['TelephonyproviderRequestTermVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['TelephonyproviderRequestTermVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['TelephonyproviderRequestTermVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyproviderRequestTermAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyproviderRequestTermAvgFields'] = ResolversParentTypes['TelephonyproviderRequestTermAvgFields']> = {
  termsversion?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyproviderRequestTermMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyproviderRequestTermMaxFields'] = ResolversParentTypes['TelephonyproviderRequestTermMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  providerId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  terms?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  termsversion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyproviderRequestTermMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyproviderRequestTermMinFields'] = ResolversParentTypes['TelephonyproviderRequestTermMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  providerId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  terms?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  termsversion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['Telephonytimestamptz']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyproviderRequestTermMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyproviderRequestTermMutationResponse'] = ResolversParentTypes['TelephonyproviderRequestTermMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['TelephonyproviderRequestTerm']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyproviderRequestTermStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyproviderRequestTermStddevFields'] = ResolversParentTypes['TelephonyproviderRequestTermStddevFields']> = {
  termsversion?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyproviderRequestTermStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyproviderRequestTermStddevPopFields'] = ResolversParentTypes['TelephonyproviderRequestTermStddevPopFields']> = {
  termsversion?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyproviderRequestTermStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyproviderRequestTermStddevSampFields'] = ResolversParentTypes['TelephonyproviderRequestTermStddevSampFields']> = {
  termsversion?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyproviderRequestTermSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyproviderRequestTermSumFields'] = ResolversParentTypes['TelephonyproviderRequestTermSumFields']> = {
  termsversion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyproviderRequestTermVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyproviderRequestTermVarPopFields'] = ResolversParentTypes['TelephonyproviderRequestTermVarPopFields']> = {
  termsversion?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyproviderRequestTermVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyproviderRequestTermVarSampFields'] = ResolversParentTypes['TelephonyproviderRequestTermVarSampFields']> = {
  termsversion?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TelephonyproviderRequestTermVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonyproviderRequestTermVarianceFields'] = ResolversParentTypes['TelephonyproviderRequestTermVarianceFields']> = {
  termsversion?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface TelephonytimestamptzScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Telephonytimestamptz'], any> {
  name: 'Telephonytimestamptz';
}

export type TelephonytriggerTestCallOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['TelephonytriggerTestCallOutput'] = ResolversParentTypes['TelephonytriggerTestCallOutput']> = {
  callId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserOrgOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserOrgOutput'] = ResolversParentTypes['UserOrgOutput']> = {
  orgId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  telephonyProviderRequestId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserUpdateOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserUpdateOutput'] = ResolversParentTypes['UserUpdateOutput']> = {
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VerificationOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerificationOutput'] = ResolversParentTypes['VerificationOutput']> = {
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VoiceTypesResolvers<ContextType = any, ParentType extends ResolversParentTypes['VoiceTypes'] = ResolversParentTypes['VoiceTypes']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VoiceTypesAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['VoiceTypesAggregate'] = ResolversParentTypes['VoiceTypesAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['VoiceTypesAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['VoiceTypes']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VoiceTypesAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['VoiceTypesAggregateFields'] = ResolversParentTypes['VoiceTypesAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<VoiceTypesAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['VoiceTypesMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['VoiceTypesMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VoiceTypesMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['VoiceTypesMaxFields'] = ResolversParentTypes['VoiceTypesMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VoiceTypesMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['VoiceTypesMinFields'] = ResolversParentTypes['VoiceTypesMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VoiceTypesMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['VoiceTypesMutationResponse'] = ResolversParentTypes['VoiceTypesMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['VoiceTypes']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type acceptInviteOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['acceptInviteOutput'] = ResolversParentTypes['acceptInviteOutput']> = {
  result?: Resolver<ResolversTypes['jsonb'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type acceptRequestsOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['acceptRequestsOutput'] = ResolversParentTypes['acceptRequestsOutput']> = {
  result?: Resolver<ResolversTypes['jsonb'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type activityParticipantResolvers<ContextType = any, ParentType extends ResolversParentTypes['activityParticipant'] = ResolversParentTypes['activityParticipant']> = {
  accepted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  channel?: Resolver<Maybe<ResolversTypes['BusinessQueueItemParticipantChannelTypeEnum']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  organizationUser?: Resolver<Maybe<ResolversTypes['organizationUser']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  queueItemId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  queue_item?: Resolver<Maybe<ResolversTypes['queueItem']>, ParentType, ContextType>;
  queue_item_participant_responsibiliy_type?: Resolver<Maybe<ResolversTypes['QueueItemParticipantResponsibilityType']>, ParentType, ContextType>;
  responsibility?: Resolver<Maybe<ResolversTypes['QueueItemParticipantResponsibilityTypeEnum']>, ParentType, ContextType>;
  responsible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type activityParticipantAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['activityParticipantAggregate'] = ResolversParentTypes['activityParticipantAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['activityParticipantAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['activityParticipant']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type activityParticipantAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['activityParticipantAggregateFields'] = ResolversParentTypes['activityParticipantAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<activityParticipantAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['activityParticipantMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['activityParticipantMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type activityParticipantMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['activityParticipantMaxFields'] = ResolversParentTypes['activityParticipantMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  queueItemId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type activityParticipantMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['activityParticipantMinFields'] = ResolversParentTypes['activityParticipantMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  queueItemId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type activityParticipantMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['activityParticipantMutationResponse'] = ResolversParentTypes['activityParticipantMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['activityParticipant']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type activityTaskOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['activityTaskOutput'] = ResolversParentTypes['activityTaskOutput']> = {
  result?: Resolver<Maybe<ResolversTypes['json']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type addressResolvers<ContextType = any, ParentType extends ResolversParentTypes['address'] = ResolversParentTypes['address']> = {
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  lat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  long?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organization?: Resolver<Maybe<ResolversTypes['organization']>, ParentType, ContextType>;
  organizationBusinessAddress?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationUser?: Resolver<Maybe<ResolversTypes['organizationUser']>, ParentType, ContextType>;
  organizationUserAddress?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  street?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  zip?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type addressAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['addressAggregate'] = ResolversParentTypes['addressAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['addressAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['address']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type addressAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['addressAggregateFields'] = ResolversParentTypes['addressAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<addressAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['addressMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['addressMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type addressMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['addressMaxFields'] = ResolversParentTypes['addressMaxFields']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  long?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationBusinessAddress?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationUserAddress?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type addressMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['addressMinFields'] = ResolversParentTypes['addressMinFields']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  long?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationBusinessAddress?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationUserAddress?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type addressMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['addressMutationResponse'] = ResolversParentTypes['addressMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['address']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type blockedDomainUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['blockedDomainUser'] = ResolversParentTypes['blockedDomainUser']> = {
  blockedBydomainUserId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  blockedDomainUser?: Resolver<Maybe<ResolversTypes['domainUser']>, ParentType, ContextType>;
  blockedDomainUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  domainUser?: Resolver<ResolversTypes['domainUser'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  lightlyBlocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type blockedDomainUserAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['blockedDomainUserAggregate'] = ResolversParentTypes['blockedDomainUserAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['blockedDomainUserAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['blockedDomainUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type blockedDomainUserAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['blockedDomainUserAggregateFields'] = ResolversParentTypes['blockedDomainUserAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<blockedDomainUserAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['blockedDomainUserMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['blockedDomainUserMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type blockedDomainUserMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['blockedDomainUserMaxFields'] = ResolversParentTypes['blockedDomainUserMaxFields']> = {
  blockedBydomainUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  blockedDomainUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type blockedDomainUserMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['blockedDomainUserMinFields'] = ResolversParentTypes['blockedDomainUserMinFields']> = {
  blockedBydomainUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  blockedDomainUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type blockedDomainUserMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['blockedDomainUserMutationResponse'] = ResolversParentTypes['blockedDomainUserMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['blockedDomainUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type bregmutation_rootResolvers<ContextType = any, ParentType extends ResolversParentTypes['bregmutation_root'] = ResolversParentTypes['bregmutation_root']> = {
  deleteCode?: Resolver<Maybe<ResolversTypes['RegistryCodeMutationResponse']>, ParentType, ContextType, RequireFields<bregmutation_rootdeleteCodeArgs, 'where'>>;
  deleteCodeByPk?: Resolver<Maybe<ResolversTypes['RegistryCode']>, ParentType, ContextType, RequireFields<bregmutation_rootdeleteCodeByPkArgs, 'id'>>;
  deleteInfo?: Resolver<Maybe<ResolversTypes['RegistryInfoMutationResponse']>, ParentType, ContextType, RequireFields<bregmutation_rootdeleteInfoArgs, 'where'>>;
  deleteInfoByPk?: Resolver<Maybe<ResolversTypes['RegistryInfo']>, ParentType, ContextType, RequireFields<bregmutation_rootdeleteInfoByPkArgs, 'id'>>;
  deleteOrganisasjonsform?: Resolver<Maybe<ResolversTypes['RegistryOrganisasjonsformMutationResponse']>, ParentType, ContextType, RequireFields<bregmutation_rootdeleteOrganisasjonsformArgs, 'where'>>;
  deleteOrganisasjonsformByPk?: Resolver<Maybe<ResolversTypes['RegistryOrganisasjonsform']>, ParentType, ContextType, RequireFields<bregmutation_rootdeleteOrganisasjonsformByPkArgs, 'id'>>;
  deleteOrganization?: Resolver<Maybe<ResolversTypes['RegistryOrganizationMutationResponse']>, ParentType, ContextType, RequireFields<bregmutation_rootdeleteOrganizationArgs, 'where'>>;
  deleteOrganizationByPk?: Resolver<Maybe<ResolversTypes['RegistryOrganization']>, ParentType, ContextType, RequireFields<bregmutation_rootdeleteOrganizationByPkArgs, 'id'>>;
  deletePostadresse?: Resolver<Maybe<ResolversTypes['RegistryPostadresseMutationResponse']>, ParentType, ContextType, RequireFields<bregmutation_rootdeletePostadresseArgs, 'where'>>;
  deletePostadresseByPk?: Resolver<Maybe<ResolversTypes['RegistryPostadresse']>, ParentType, ContextType, RequireFields<bregmutation_rootdeletePostadresseByPkArgs, 'id'>>;
  insertCode?: Resolver<Maybe<ResolversTypes['RegistryCodeMutationResponse']>, ParentType, ContextType, RequireFields<bregmutation_rootinsertCodeArgs, 'objects'>>;
  insertCodeOne?: Resolver<Maybe<ResolversTypes['RegistryCode']>, ParentType, ContextType, RequireFields<bregmutation_rootinsertCodeOneArgs, 'object'>>;
  insertInfo?: Resolver<Maybe<ResolversTypes['RegistryInfoMutationResponse']>, ParentType, ContextType, RequireFields<bregmutation_rootinsertInfoArgs, 'objects'>>;
  insertInfoOne?: Resolver<Maybe<ResolversTypes['RegistryInfo']>, ParentType, ContextType, RequireFields<bregmutation_rootinsertInfoOneArgs, 'object'>>;
  insertOrganisasjonsform?: Resolver<Maybe<ResolversTypes['RegistryOrganisasjonsformMutationResponse']>, ParentType, ContextType, RequireFields<bregmutation_rootinsertOrganisasjonsformArgs, 'objects'>>;
  insertOrganisasjonsformOne?: Resolver<Maybe<ResolversTypes['RegistryOrganisasjonsform']>, ParentType, ContextType, RequireFields<bregmutation_rootinsertOrganisasjonsformOneArgs, 'object'>>;
  insertOrganization?: Resolver<Maybe<ResolversTypes['RegistryOrganizationMutationResponse']>, ParentType, ContextType, RequireFields<bregmutation_rootinsertOrganizationArgs, 'objects'>>;
  insertOrganizationOne?: Resolver<Maybe<ResolversTypes['RegistryOrganization']>, ParentType, ContextType, RequireFields<bregmutation_rootinsertOrganizationOneArgs, 'object'>>;
  insertPostadresse?: Resolver<Maybe<ResolversTypes['RegistryPostadresseMutationResponse']>, ParentType, ContextType, RequireFields<bregmutation_rootinsertPostadresseArgs, 'objects'>>;
  insertPostadresseOne?: Resolver<Maybe<ResolversTypes['RegistryPostadresse']>, ParentType, ContextType, RequireFields<bregmutation_rootinsertPostadresseOneArgs, 'object'>>;
  updateCode?: Resolver<Maybe<ResolversTypes['RegistryCodeMutationResponse']>, ParentType, ContextType, RequireFields<bregmutation_rootupdateCodeArgs, 'where'>>;
  updateCodeByPk?: Resolver<Maybe<ResolversTypes['RegistryCode']>, ParentType, ContextType, RequireFields<bregmutation_rootupdateCodeByPkArgs, 'pkColumns'>>;
  updateCodeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['RegistryCodeMutationResponse']>>>, ParentType, ContextType, RequireFields<bregmutation_rootupdateCodeManyArgs, 'updates'>>;
  updateInfo?: Resolver<Maybe<ResolversTypes['RegistryInfoMutationResponse']>, ParentType, ContextType, RequireFields<bregmutation_rootupdateInfoArgs, 'where'>>;
  updateInfoByPk?: Resolver<Maybe<ResolversTypes['RegistryInfo']>, ParentType, ContextType, RequireFields<bregmutation_rootupdateInfoByPkArgs, 'pkColumns'>>;
  updateInfoMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['RegistryInfoMutationResponse']>>>, ParentType, ContextType, RequireFields<bregmutation_rootupdateInfoManyArgs, 'updates'>>;
  updateOrganisasjonsform?: Resolver<Maybe<ResolversTypes['RegistryOrganisasjonsformMutationResponse']>, ParentType, ContextType, RequireFields<bregmutation_rootupdateOrganisasjonsformArgs, 'where'>>;
  updateOrganisasjonsformByPk?: Resolver<Maybe<ResolversTypes['RegistryOrganisasjonsform']>, ParentType, ContextType, RequireFields<bregmutation_rootupdateOrganisasjonsformByPkArgs, 'pkColumns'>>;
  updateOrganisasjonsformMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['RegistryOrganisasjonsformMutationResponse']>>>, ParentType, ContextType, RequireFields<bregmutation_rootupdateOrganisasjonsformManyArgs, 'updates'>>;
  updateOrganization?: Resolver<Maybe<ResolversTypes['RegistryOrganizationMutationResponse']>, ParentType, ContextType, RequireFields<bregmutation_rootupdateOrganizationArgs, 'where'>>;
  updateOrganizationByPk?: Resolver<Maybe<ResolversTypes['RegistryOrganization']>, ParentType, ContextType, RequireFields<bregmutation_rootupdateOrganizationByPkArgs, 'pkColumns'>>;
  updateOrganizationMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['RegistryOrganizationMutationResponse']>>>, ParentType, ContextType, RequireFields<bregmutation_rootupdateOrganizationManyArgs, 'updates'>>;
  updatePostadresse?: Resolver<Maybe<ResolversTypes['RegistryPostadresseMutationResponse']>, ParentType, ContextType, RequireFields<bregmutation_rootupdatePostadresseArgs, 'where'>>;
  updatePostadresseByPk?: Resolver<Maybe<ResolversTypes['RegistryPostadresse']>, ParentType, ContextType, RequireFields<bregmutation_rootupdatePostadresseByPkArgs, 'pkColumns'>>;
  updatePostadresseMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['RegistryPostadresseMutationResponse']>>>, ParentType, ContextType, RequireFields<bregmutation_rootupdatePostadresseManyArgs, 'updates'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type bregquery_rootResolvers<ContextType = any, ParentType extends ResolversParentTypes['bregquery_root'] = ResolversParentTypes['bregquery_root']> = {
  code?: Resolver<Array<ResolversTypes['RegistryCode']>, ParentType, ContextType, Partial<bregquery_rootcodeArgs>>;
  codeAggregate?: Resolver<ResolversTypes['RegistryCodeAggregate'], ParentType, ContextType, Partial<bregquery_rootcodeAggregateArgs>>;
  codeByPk?: Resolver<Maybe<ResolversTypes['RegistryCode']>, ParentType, ContextType, RequireFields<bregquery_rootcodeByPkArgs, 'id'>>;
  info?: Resolver<Array<ResolversTypes['RegistryInfo']>, ParentType, ContextType, Partial<bregquery_rootinfoArgs>>;
  infoAggregate?: Resolver<ResolversTypes['RegistryInfoAggregate'], ParentType, ContextType, Partial<bregquery_rootinfoAggregateArgs>>;
  infoByPk?: Resolver<Maybe<ResolversTypes['RegistryInfo']>, ParentType, ContextType, RequireFields<bregquery_rootinfoByPkArgs, 'id'>>;
  organisasjonsform?: Resolver<Array<ResolversTypes['RegistryOrganisasjonsform']>, ParentType, ContextType, Partial<bregquery_rootorganisasjonsformArgs>>;
  organisasjonsformAggregate?: Resolver<ResolversTypes['RegistryOrganisasjonsformAggregate'], ParentType, ContextType, Partial<bregquery_rootorganisasjonsformAggregateArgs>>;
  organisasjonsformByPk?: Resolver<Maybe<ResolversTypes['RegistryOrganisasjonsform']>, ParentType, ContextType, RequireFields<bregquery_rootorganisasjonsformByPkArgs, 'id'>>;
  organization?: Resolver<Array<ResolversTypes['RegistryOrganization']>, ParentType, ContextType, Partial<bregquery_rootorganizationArgs>>;
  organizationAggregate?: Resolver<ResolversTypes['RegistryOrganizationAggregate'], ParentType, ContextType, Partial<bregquery_rootorganizationAggregateArgs>>;
  organizationByPk?: Resolver<Maybe<ResolversTypes['RegistryOrganization']>, ParentType, ContextType, RequireFields<bregquery_rootorganizationByPkArgs, 'id'>>;
  postadresse?: Resolver<Array<ResolversTypes['RegistryPostadresse']>, ParentType, ContextType, Partial<bregquery_rootpostadresseArgs>>;
  postadresseAggregate?: Resolver<ResolversTypes['RegistryPostadresseAggregate'], ParentType, ContextType, Partial<bregquery_rootpostadresseAggregateArgs>>;
  postadresseByPk?: Resolver<Maybe<ResolversTypes['RegistryPostadresse']>, ParentType, ContextType, RequireFields<bregquery_rootpostadresseByPkArgs, 'id'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type bregsubscription_rootResolvers<ContextType = any, ParentType extends ResolversParentTypes['bregsubscription_root'] = ResolversParentTypes['bregsubscription_root']> = {
  code?: Resolver<Array<ResolversTypes['RegistryCode']>, ParentType, ContextType, Partial<bregsubscription_rootcodeArgs>>;
  codeAggregate?: Resolver<ResolversTypes['RegistryCodeAggregate'], ParentType, ContextType, Partial<bregsubscription_rootcodeAggregateArgs>>;
  codeByPk?: Resolver<Maybe<ResolversTypes['RegistryCode']>, ParentType, ContextType, RequireFields<bregsubscription_rootcodeByPkArgs, 'id'>>;
  codeStream?: Resolver<Array<ResolversTypes['RegistryCode']>, ParentType, ContextType, RequireFields<bregsubscription_rootcodeStreamArgs, 'batchSize' | 'cursor'>>;
  info?: Resolver<Array<ResolversTypes['RegistryInfo']>, ParentType, ContextType, Partial<bregsubscription_rootinfoArgs>>;
  infoAggregate?: Resolver<ResolversTypes['RegistryInfoAggregate'], ParentType, ContextType, Partial<bregsubscription_rootinfoAggregateArgs>>;
  infoByPk?: Resolver<Maybe<ResolversTypes['RegistryInfo']>, ParentType, ContextType, RequireFields<bregsubscription_rootinfoByPkArgs, 'id'>>;
  infoStream?: Resolver<Array<ResolversTypes['RegistryInfo']>, ParentType, ContextType, RequireFields<bregsubscription_rootinfoStreamArgs, 'batchSize' | 'cursor'>>;
  organisasjonsform?: Resolver<Array<ResolversTypes['RegistryOrganisasjonsform']>, ParentType, ContextType, Partial<bregsubscription_rootorganisasjonsformArgs>>;
  organisasjonsformAggregate?: Resolver<ResolversTypes['RegistryOrganisasjonsformAggregate'], ParentType, ContextType, Partial<bregsubscription_rootorganisasjonsformAggregateArgs>>;
  organisasjonsformByPk?: Resolver<Maybe<ResolversTypes['RegistryOrganisasjonsform']>, ParentType, ContextType, RequireFields<bregsubscription_rootorganisasjonsformByPkArgs, 'id'>>;
  organisasjonsformStream?: Resolver<Array<ResolversTypes['RegistryOrganisasjonsform']>, ParentType, ContextType, RequireFields<bregsubscription_rootorganisasjonsformStreamArgs, 'batchSize' | 'cursor'>>;
  organization?: Resolver<Array<ResolversTypes['RegistryOrganization']>, ParentType, ContextType, Partial<bregsubscription_rootorganizationArgs>>;
  organizationAggregate?: Resolver<ResolversTypes['RegistryOrganizationAggregate'], ParentType, ContextType, Partial<bregsubscription_rootorganizationAggregateArgs>>;
  organizationByPk?: Resolver<Maybe<ResolversTypes['RegistryOrganization']>, ParentType, ContextType, RequireFields<bregsubscription_rootorganizationByPkArgs, 'id'>>;
  organizationStream?: Resolver<Array<ResolversTypes['RegistryOrganization']>, ParentType, ContextType, RequireFields<bregsubscription_rootorganizationStreamArgs, 'batchSize' | 'cursor'>>;
  postadresse?: Resolver<Array<ResolversTypes['RegistryPostadresse']>, ParentType, ContextType, Partial<bregsubscription_rootpostadresseArgs>>;
  postadresseAggregate?: Resolver<ResolversTypes['RegistryPostadresseAggregate'], ParentType, ContextType, Partial<bregsubscription_rootpostadresseAggregateArgs>>;
  postadresseByPk?: Resolver<Maybe<ResolversTypes['RegistryPostadresse']>, ParentType, ContextType, RequireFields<bregsubscription_rootpostadresseByPkArgs, 'id'>>;
  postadresseStream?: Resolver<Array<ResolversTypes['RegistryPostadresse']>, ParentType, ContextType, RequireFields<bregsubscription_rootpostadresseStreamArgs, 'batchSize' | 'cursor'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessQueueItemCollaborationResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessQueueItemCollaboration'] = ResolversParentTypes['businessQueueItemCollaboration']> = {
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  customerUser?: Resolver<Maybe<ResolversTypes['organizationUser']>, ParentType, ContextType>;
  customerUserId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  from?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['organization'], ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  private?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  skipNotifications?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessQueueItemCollaborationAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessQueueItemCollaborationAggregate'] = ResolversParentTypes['businessQueueItemCollaborationAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['businessQueueItemCollaborationAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['businessQueueItemCollaboration']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessQueueItemCollaborationAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessQueueItemCollaborationAggregateFields'] = ResolversParentTypes['businessQueueItemCollaborationAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['businessQueueItemCollaborationAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<businessQueueItemCollaborationAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['businessQueueItemCollaborationMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['businessQueueItemCollaborationMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['businessQueueItemCollaborationStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['businessQueueItemCollaborationStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['businessQueueItemCollaborationStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['businessQueueItemCollaborationSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['businessQueueItemCollaborationVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['businessQueueItemCollaborationVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['businessQueueItemCollaborationVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessQueueItemCollaborationAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessQueueItemCollaborationAvgFields'] = ResolversParentTypes['businessQueueItemCollaborationAvgFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessQueueItemCollaborationMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessQueueItemCollaborationMaxFields'] = ResolversParentTypes['businessQueueItemCollaborationMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  customerUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  from?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessQueueItemCollaborationMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessQueueItemCollaborationMinFields'] = ResolversParentTypes['businessQueueItemCollaborationMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  customerUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  from?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessQueueItemCollaborationMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessQueueItemCollaborationMutationResponse'] = ResolversParentTypes['businessQueueItemCollaborationMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['businessQueueItemCollaboration']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessQueueItemCollaborationStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessQueueItemCollaborationStddevFields'] = ResolversParentTypes['businessQueueItemCollaborationStddevFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessQueueItemCollaborationStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessQueueItemCollaborationStddevPopFields'] = ResolversParentTypes['businessQueueItemCollaborationStddevPopFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessQueueItemCollaborationStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessQueueItemCollaborationStddevSampFields'] = ResolversParentTypes['businessQueueItemCollaborationStddevSampFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessQueueItemCollaborationSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessQueueItemCollaborationSumFields'] = ResolversParentTypes['businessQueueItemCollaborationSumFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessQueueItemCollaborationVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessQueueItemCollaborationVarPopFields'] = ResolversParentTypes['businessQueueItemCollaborationVarPopFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessQueueItemCollaborationVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessQueueItemCollaborationVarSampFields'] = ResolversParentTypes['businessQueueItemCollaborationVarSampFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessQueueItemCollaborationVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessQueueItemCollaborationVarianceFields'] = ResolversParentTypes['businessQueueItemCollaborationVarianceFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessUserContactsResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessUserContacts'] = ResolversParentTypes['businessUserContacts']> = {
  birthday?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contactType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  dates?: Resolver<Maybe<Array<ResolversTypes['timestamptz']>>, ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  imageAvailable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  jobTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maidenName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  middleName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  namePrefix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nameSuffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nickname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nonGregorianBirthday?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  origId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumbers?: Resolver<Array<ResolversTypes['BusinessUserContactNumbers']>, ParentType, ContextType, Partial<businessUserContactsphoneNumbersArgs>>;
  phoneNumbersAggregate?: Resolver<ResolversTypes['BusinessUserContactNumbersAggregate'], ParentType, ContextType, Partial<businessUserContactsphoneNumbersAggregateArgs>>;
  phoneticFirstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneticLastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneticMiddleName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessUserContactsAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessUserContactsAggregate'] = ResolversParentTypes['businessUserContactsAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['businessUserContactsAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['businessUserContacts']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessUserContactsAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessUserContactsAggregateFields'] = ResolversParentTypes['businessUserContactsAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<businessUserContactsAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['businessUserContactsMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['businessUserContactsMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessUserContactsMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessUserContactsMaxFields'] = ResolversParentTypes['businessUserContactsMaxFields']> = {
  birthday?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contactType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  dates?: Resolver<Maybe<Array<ResolversTypes['timestamptz']>>, ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  jobTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maidenName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  middleName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  namePrefix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nameSuffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nickname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nonGregorianBirthday?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  origId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneticFirstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneticLastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneticMiddleName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessUserContactsMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessUserContactsMinFields'] = ResolversParentTypes['businessUserContactsMinFields']> = {
  birthday?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contactType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  dates?: Resolver<Maybe<Array<ResolversTypes['timestamptz']>>, ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  jobTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maidenName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  middleName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  namePrefix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nameSuffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nickname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nonGregorianBirthday?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  origId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneticFirstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneticLastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneticMiddleName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessUserContactsMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessUserContactsMutationResponse'] = ResolversParentTypes['businessUserContactsMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['businessUserContacts']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessUserSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessUserSettings'] = ResolversParentTypes['businessUserSettings']> = {
  callbackNotificationsOnPrivateContacts?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  followupNotificationsOnPrivateContacts?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  lostCallAutoTaskOnCustomers?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lostCallAutoTaskOnPrivateContacts?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lostCallAutoTaskOnUnknown?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lostCallDeadlineOffset?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessUserSettingsAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessUserSettingsAggregate'] = ResolversParentTypes['businessUserSettingsAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['businessUserSettingsAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['businessUserSettings']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessUserSettingsAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessUserSettingsAggregateFields'] = ResolversParentTypes['businessUserSettingsAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['businessUserSettingsAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<businessUserSettingsAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['businessUserSettingsMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['businessUserSettingsMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['businessUserSettingsStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['businessUserSettingsStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['businessUserSettingsStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['businessUserSettingsSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['businessUserSettingsVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['businessUserSettingsVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['businessUserSettingsVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessUserSettingsAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessUserSettingsAvgFields'] = ResolversParentTypes['businessUserSettingsAvgFields']> = {
  lostCallDeadlineOffset?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessUserSettingsMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessUserSettingsMaxFields'] = ResolversParentTypes['businessUserSettingsMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lostCallDeadlineOffset?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessUserSettingsMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessUserSettingsMinFields'] = ResolversParentTypes['businessUserSettingsMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lostCallDeadlineOffset?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessUserSettingsMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessUserSettingsMutationResponse'] = ResolversParentTypes['businessUserSettingsMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['businessUserSettings']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessUserSettingsStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessUserSettingsStddevFields'] = ResolversParentTypes['businessUserSettingsStddevFields']> = {
  lostCallDeadlineOffset?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessUserSettingsStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessUserSettingsStddevPopFields'] = ResolversParentTypes['businessUserSettingsStddevPopFields']> = {
  lostCallDeadlineOffset?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessUserSettingsStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessUserSettingsStddevSampFields'] = ResolversParentTypes['businessUserSettingsStddevSampFields']> = {
  lostCallDeadlineOffset?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessUserSettingsSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessUserSettingsSumFields'] = ResolversParentTypes['businessUserSettingsSumFields']> = {
  lostCallDeadlineOffset?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessUserSettingsVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessUserSettingsVarPopFields'] = ResolversParentTypes['businessUserSettingsVarPopFields']> = {
  lostCallDeadlineOffset?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessUserSettingsVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessUserSettingsVarSampFields'] = ResolversParentTypes['businessUserSettingsVarSampFields']> = {
  lostCallDeadlineOffset?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type businessUserSettingsVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['businessUserSettingsVarianceFields'] = ResolversParentTypes['businessUserSettingsVarianceFields']> = {
  lostCallDeadlineOffset?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type callBackLaterResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['callBackLaterResult'] = ResolversParentTypes['callBackLaterResult']> = {
  result?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type checkTelephonyIdOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['checkTelephonyIdOutput'] = ResolversParentTypes['checkTelephonyIdOutput']> = {
  feedback?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type createEmailProviderSubscriptionOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['createEmailProviderSubscriptionOutput'] = ResolversParentTypes['createEmailProviderSubscriptionOutput']> = {
  expiration?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  subscriptionId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type createMessagingGroupOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['createMessagingGroupOutput'] = ResolversParentTypes['createMessagingGroupOutput']> = {
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type createPhoneroOrgUsersOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['createPhoneroOrgUsersOutput'] = ResolversParentTypes['createPhoneroOrgUsersOutput']> = {
  result?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type createRoomOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['createRoomOutput'] = ResolversParentTypes['createRoomOutput']> = {
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type crmStatusMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['crmStatusMessage'] = ResolversParentTypes['crmStatusMessage']> = {
  code?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['CrmCreatorTypeEnum']>, ParentType, ContextType>;
  crmContext?: Resolver<Maybe<ResolversTypes['CrmContext']>, ParentType, ContextType>;
  crmContextId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  crmData?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<crmStatusMessagecrmDataArgs>>;
  event?: Resolver<Maybe<ResolversTypes['CrmEvent']>, ParentType, ContextType>;
  eventId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payload?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<crmStatusMessagepayloadArgs>>;
  tenantId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  traceContext?: Resolver<Maybe<ResolversTypes['CrmTraceContext']>, ParentType, ContextType>;
  traceContextId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  youtelloContext?: Resolver<Maybe<ResolversTypes['CrmContext']>, ParentType, ContextType>;
  youtelloContextId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  youtelloData?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<crmStatusMessageyoutelloDataArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type crmStatusMessageAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['crmStatusMessageAggregate'] = ResolversParentTypes['crmStatusMessageAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['crmStatusMessageAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['crmStatusMessage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type crmStatusMessageAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['crmStatusMessageAggregateFields'] = ResolversParentTypes['crmStatusMessageAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['crmStatusMessageAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<crmStatusMessageAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['crmStatusMessageMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['crmStatusMessageMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['crmStatusMessageStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['crmStatusMessageStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['crmStatusMessageStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['crmStatusMessageSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['crmStatusMessageVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['crmStatusMessageVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['crmStatusMessageVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type crmStatusMessageAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['crmStatusMessageAvgFields'] = ResolversParentTypes['crmStatusMessageAvgFields']> = {
  code?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type crmStatusMessageMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['crmStatusMessageMaxFields'] = ResolversParentTypes['crmStatusMessageMaxFields']> = {
  code?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  crmContextId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  eventId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tenantId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  traceContextId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  youtelloContextId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type crmStatusMessageMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['crmStatusMessageMinFields'] = ResolversParentTypes['crmStatusMessageMinFields']> = {
  code?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  crmContextId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  eventId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tenantId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  traceContextId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  youtelloContextId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type crmStatusMessageMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['crmStatusMessageMutationResponse'] = ResolversParentTypes['crmStatusMessageMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['crmStatusMessage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type crmStatusMessageStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['crmStatusMessageStddevFields'] = ResolversParentTypes['crmStatusMessageStddevFields']> = {
  code?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type crmStatusMessageStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['crmStatusMessageStddevPopFields'] = ResolversParentTypes['crmStatusMessageStddevPopFields']> = {
  code?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type crmStatusMessageStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['crmStatusMessageStddevSampFields'] = ResolversParentTypes['crmStatusMessageStddevSampFields']> = {
  code?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type crmStatusMessageSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['crmStatusMessageSumFields'] = ResolversParentTypes['crmStatusMessageSumFields']> = {
  code?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type crmStatusMessageVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['crmStatusMessageVarPopFields'] = ResolversParentTypes['crmStatusMessageVarPopFields']> = {
  code?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type crmStatusMessageVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['crmStatusMessageVarSampFields'] = ResolversParentTypes['crmStatusMessageVarSampFields']> = {
  code?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type crmStatusMessageVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['crmStatusMessageVarianceFields'] = ResolversParentTypes['crmStatusMessageVarianceFields']> = {
  code?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type crmYoutelloCatalystIdMappingResolvers<ContextType = any, ParentType extends ResolversParentTypes['crmYoutelloCatalystIdMapping'] = ResolversParentTypes['crmYoutelloCatalystIdMapping']> = {
  catalystId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  crmType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  crmUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crmVisibility?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  unifiedEntityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  youtelloId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type crmYoutelloCatalystIdMappingAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['crmYoutelloCatalystIdMappingAggregate'] = ResolversParentTypes['crmYoutelloCatalystIdMappingAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['crmYoutelloCatalystIdMappingAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['crmYoutelloCatalystIdMapping']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type crmYoutelloCatalystIdMappingAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['crmYoutelloCatalystIdMappingAggregateFields'] = ResolversParentTypes['crmYoutelloCatalystIdMappingAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['crmYoutelloCatalystIdMappingAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<crmYoutelloCatalystIdMappingAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['crmYoutelloCatalystIdMappingMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['crmYoutelloCatalystIdMappingMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['crmYoutelloCatalystIdMappingStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['crmYoutelloCatalystIdMappingStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['crmYoutelloCatalystIdMappingStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['crmYoutelloCatalystIdMappingSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['crmYoutelloCatalystIdMappingVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['crmYoutelloCatalystIdMappingVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['crmYoutelloCatalystIdMappingVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type crmYoutelloCatalystIdMappingAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['crmYoutelloCatalystIdMappingAvgFields'] = ResolversParentTypes['crmYoutelloCatalystIdMappingAvgFields']> = {
  crmVisibility?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type crmYoutelloCatalystIdMappingMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['crmYoutelloCatalystIdMappingMaxFields'] = ResolversParentTypes['crmYoutelloCatalystIdMappingMaxFields']> = {
  catalystId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  crmType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crmUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crmVisibility?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  unifiedEntityType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  youtelloId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type crmYoutelloCatalystIdMappingMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['crmYoutelloCatalystIdMappingMinFields'] = ResolversParentTypes['crmYoutelloCatalystIdMappingMinFields']> = {
  catalystId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  crmType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crmUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crmVisibility?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  unifiedEntityType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  youtelloId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type crmYoutelloCatalystIdMappingMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['crmYoutelloCatalystIdMappingMutationResponse'] = ResolversParentTypes['crmYoutelloCatalystIdMappingMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['crmYoutelloCatalystIdMapping']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type crmYoutelloCatalystIdMappingStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['crmYoutelloCatalystIdMappingStddevFields'] = ResolversParentTypes['crmYoutelloCatalystIdMappingStddevFields']> = {
  crmVisibility?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type crmYoutelloCatalystIdMappingStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['crmYoutelloCatalystIdMappingStddevPopFields'] = ResolversParentTypes['crmYoutelloCatalystIdMappingStddevPopFields']> = {
  crmVisibility?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type crmYoutelloCatalystIdMappingStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['crmYoutelloCatalystIdMappingStddevSampFields'] = ResolversParentTypes['crmYoutelloCatalystIdMappingStddevSampFields']> = {
  crmVisibility?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type crmYoutelloCatalystIdMappingSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['crmYoutelloCatalystIdMappingSumFields'] = ResolversParentTypes['crmYoutelloCatalystIdMappingSumFields']> = {
  crmVisibility?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type crmYoutelloCatalystIdMappingVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['crmYoutelloCatalystIdMappingVarPopFields'] = ResolversParentTypes['crmYoutelloCatalystIdMappingVarPopFields']> = {
  crmVisibility?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type crmYoutelloCatalystIdMappingVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['crmYoutelloCatalystIdMappingVarSampFields'] = ResolversParentTypes['crmYoutelloCatalystIdMappingVarSampFields']> = {
  crmVisibility?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type crmYoutelloCatalystIdMappingVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['crmYoutelloCatalystIdMappingVarianceFields'] = ResolversParentTypes['crmYoutelloCatalystIdMappingVarianceFields']> = {
  crmVisibility?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type dashboardDataOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['dashboardDataOutput'] = ResolversParentTypes['dashboardDataOutput']> = {
  json?: Resolver<Maybe<ResolversTypes['json']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type deleteEmailProviderSubscriptionOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['deleteEmailProviderSubscriptionOutput'] = ResolversParentTypes['deleteEmailProviderSubscriptionOutput']> = {
  subscriptionId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainActivity'] = ResolversParentTypes['domainActivity']> = {
  activityStatus?: Resolver<Maybe<ResolversTypes['ActivityStatus']>, ParentType, ContextType>;
  activityType?: Resolver<Maybe<ResolversTypes['ActivityType']>, ParentType, ContextType>;
  additionalData?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<domainActivityadditionalDataArgs>>;
  channelActivityUuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdByUser?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  direction?: Resolver<Maybe<ResolversTypes['ActivityDirectionEnum']>, ParentType, ContextType>;
  domain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  domainParticipants?: Resolver<Array<ResolversTypes['domainParticipant']>, ParentType, ContextType, Partial<domainActivitydomainParticipantsArgs>>;
  domainParticipantsAggregate?: Resolver<ResolversTypes['domainParticipantAggregate'], ParentType, ContextType, Partial<domainActivitydomainParticipantsAggregateArgs>>;
  emailChannel?: Resolver<Maybe<ResolversTypes['Emailingactivity']>, ParentType, ContextType>;
  endedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  number?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['domainUser']>, ParentType, ContextType>;
  ownerId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  provider?: Resolver<Maybe<ResolversTypes['ActivityProviderEnum']>, ParentType, ContextType>;
  queueItem?: Resolver<Maybe<ResolversTypes['queueItem']>, ParentType, ContextType>;
  requestEndedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  requestStartedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  schema?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ActivityStatusEnum']>, ParentType, ContextType>;
  subTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  table?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taskChannel?: Resolver<Maybe<ResolversTypes['TaskActivity']>, ParentType, ContextType>;
  telephonyChannel?: Resolver<Maybe<ResolversTypes['Telephonyactivity']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  triggerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  triggerTime?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['ActivityTypeEnum']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainActivityAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainActivityAggregate'] = ResolversParentTypes['domainActivityAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['domainActivityAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['domainActivity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainActivityAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainActivityAggregateFields'] = ResolversParentTypes['domainActivityAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['domainActivityAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<domainActivityAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['domainActivityMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['domainActivityMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['domainActivityStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['domainActivityStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['domainActivityStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['domainActivitySumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['domainActivityVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['domainActivityVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['domainActivityVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainActivityAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainActivityAvgFields'] = ResolversParentTypes['domainActivityAvgFields']> = {
  number?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainActivityMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainActivityMaxFields'] = ResolversParentTypes['domainActivityMaxFields']> = {
  channelActivityUuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  domain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ownerId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  requestEndedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  requestStartedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  schema?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  subTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  table?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  triggerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  triggerTime?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainActivityMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainActivityMinFields'] = ResolversParentTypes['domainActivityMinFields']> = {
  channelActivityUuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  domain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ownerId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  requestEndedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  requestStartedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  schema?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  subTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  table?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  triggerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  triggerTime?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainActivityMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainActivityMutationResponse'] = ResolversParentTypes['domainActivityMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['domainActivity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainActivityStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainActivityStddevFields'] = ResolversParentTypes['domainActivityStddevFields']> = {
  number?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainActivityStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainActivityStddevPopFields'] = ResolversParentTypes['domainActivityStddevPopFields']> = {
  number?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainActivityStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainActivityStddevSampFields'] = ResolversParentTypes['domainActivityStddevSampFields']> = {
  number?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainActivitySumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainActivitySumFields'] = ResolversParentTypes['domainActivitySumFields']> = {
  number?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainActivityVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainActivityVarPopFields'] = ResolversParentTypes['domainActivityVarPopFields']> = {
  number?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainActivityVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainActivityVarSampFields'] = ResolversParentTypes['domainActivityVarSampFields']> = {
  number?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainActivityVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainActivityVarianceFields'] = ResolversParentTypes['domainActivityVarianceFields']> = {
  number?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainOrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainOrganization'] = ResolversParentTypes['domainOrganization']> = {
  adminId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  autoGenerated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  domainOrganizationUuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  domainType?: Resolver<Maybe<ResolversTypes['domainType']>, ParentType, ContextType>;
  domainTypeId?: Resolver<Maybe<ResolversTypes['domainTypeEnum']>, ParentType, ContextType>;
  domainUsers?: Resolver<Array<ResolversTypes['domainUser']>, ParentType, ContextType, Partial<domainOrganizationdomainUsersArgs>>;
  domainUsersAggregate?: Resolver<ResolversTypes['domainUserAggregate'], ParentType, ContextType, Partial<domainOrganizationdomainUsersAggregateArgs>>;
  emailDomainOrganization?: Resolver<Array<ResolversTypes['domainOrganization']>, ParentType, ContextType, Partial<domainOrganizationemailDomainOrganizationArgs>>;
  emailDomainOrganizationAggregate?: Resolver<ResolversTypes['domainOrganizationAggregate'], ParentType, ContextType, Partial<domainOrganizationemailDomainOrganizationAggregateArgs>>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  organization?: Resolver<Maybe<ResolversTypes['organization']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationUser?: Resolver<Maybe<ResolversTypes['organizationUser']>, ParentType, ContextType>;
  providerClientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  telephonyDomainOrganization?: Resolver<Array<ResolversTypes['domainOrganization']>, ParentType, ContextType, Partial<domainOrganizationtelephonyDomainOrganizationArgs>>;
  telephonyDomainOrganizationAggregate?: Resolver<ResolversTypes['domainOrganizationAggregate'], ParentType, ContextType, Partial<domainOrganizationtelephonyDomainOrganizationAggregateArgs>>;
  triggerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  triggerTime?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainOrganizationAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainOrganizationAggregate'] = ResolversParentTypes['domainOrganizationAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['domainOrganizationAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['domainOrganization']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainOrganizationAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainOrganizationAggregateFields'] = ResolversParentTypes['domainOrganizationAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<domainOrganizationAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['domainOrganizationMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['domainOrganizationMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainOrganizationMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainOrganizationMaxFields'] = ResolversParentTypes['domainOrganizationMaxFields']> = {
  adminId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  domainOrganizationUuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  providerClientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  triggerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  triggerTime?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainOrganizationMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainOrganizationMinFields'] = ResolversParentTypes['domainOrganizationMinFields']> = {
  adminId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  domainOrganizationUuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  providerClientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  triggerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  triggerTime?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainOrganizationMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainOrganizationMutationResponse'] = ResolversParentTypes['domainOrganizationMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['domainOrganization']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainParticipantResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainParticipant'] = ResolversParentTypes['domainParticipant']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  domainActivity?: Resolver<Maybe<ResolversTypes['domainActivity']>, ParentType, ContextType>;
  domainUser?: Resolver<Maybe<ResolversTypes['domainUser']>, ParentType, ContextType>;
  domainUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  triggerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  triggerTime?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainParticipantAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainParticipantAggregate'] = ResolversParentTypes['domainParticipantAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['domainParticipantAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['domainParticipant']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainParticipantAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainParticipantAggregateFields'] = ResolversParentTypes['domainParticipantAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<domainParticipantAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['domainParticipantMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['domainParticipantMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainParticipantMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainParticipantMaxFields'] = ResolversParentTypes['domainParticipantMaxFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  domainUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  triggerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  triggerTime?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainParticipantMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainParticipantMinFields'] = ResolversParentTypes['domainParticipantMinFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  domainUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  triggerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  triggerTime?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainParticipantMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainParticipantMutationResponse'] = ResolversParentTypes['domainParticipantMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['domainParticipant']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainType'] = ResolversParentTypes['domainType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  domainOrganizations?: Resolver<Array<ResolversTypes['domainOrganization']>, ParentType, ContextType, Partial<domainTypedomainOrganizationsArgs>>;
  domainOrganizationsAggregate?: Resolver<ResolversTypes['domainOrganizationAggregate'], ParentType, ContextType, Partial<domainTypedomainOrganizationsAggregateArgs>>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainTypeAggregate'] = ResolversParentTypes['domainTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['domainTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['domainType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainTypeAggregateFields'] = ResolversParentTypes['domainTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<domainTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['domainTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['domainTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainTypeMaxFields'] = ResolversParentTypes['domainTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainTypeMinFields'] = ResolversParentTypes['domainTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainTypeMutationResponse'] = ResolversParentTypes['domainTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['domainType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainUser'] = ResolversParentTypes['domainUser']> = {
  category?: Resolver<Maybe<ResolversTypes['domainUserCategoryEnum']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  domainOrganization?: Resolver<Maybe<ResolversTypes['domainOrganization']>, ParentType, ContextType>;
  domainOrganizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  domainParticipants?: Resolver<Array<ResolversTypes['domainParticipant']>, ParentType, ContextType, Partial<domainUserdomainParticipantsArgs>>;
  domainParticipantsAggregate?: Resolver<ResolversTypes['domainParticipantAggregate'], ParentType, ContextType, Partial<domainUserdomainParticipantsAggregateArgs>>;
  domainUserCategory?: Resolver<Maybe<ResolversTypes['domainUserCategory']>, ParentType, ContextType>;
  domainUserUuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailDomainUser?: Resolver<Maybe<ResolversTypes['EmailingdomainUser']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  relOrganizationUser?: Resolver<Array<ResolversTypes['relOrganizationUserDomainUser']>, ParentType, ContextType, Partial<domainUserrelOrganizationUserArgs>>;
  relOrganizationUserAggregate?: Resolver<ResolversTypes['relOrganizationUserDomainUserAggregate'], ParentType, ContextType, Partial<domainUserrelOrganizationUserAggregateArgs>>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  spamScore?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taskDomainUser?: Resolver<Maybe<ResolversTypes['TaskDomainUser']>, ParentType, ContextType>;
  telephonyDomainUser?: Resolver<Maybe<ResolversTypes['TelephonydomainUser']>, ParentType, ContextType>;
  triggerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  triggerTime?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainUserAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainUserAggregate'] = ResolversParentTypes['domainUserAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['domainUserAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['domainUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainUserAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainUserAggregateFields'] = ResolversParentTypes['domainUserAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['domainUserAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<domainUserAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['domainUserMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['domainUserMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['domainUserStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['domainUserStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['domainUserStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['domainUserSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['domainUserVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['domainUserVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['domainUserVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainUserAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainUserAvgFields'] = ResolversParentTypes['domainUserAvgFields']> = {
  spamScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainUserCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainUserCategory'] = ResolversParentTypes['domainUserCategory']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  domainUsers?: Resolver<Array<ResolversTypes['domainUser']>, ParentType, ContextType, Partial<domainUserCategorydomainUsersArgs>>;
  domainUsersAggregate?: Resolver<ResolversTypes['domainUserAggregate'], ParentType, ContextType, Partial<domainUserCategorydomainUsersAggregateArgs>>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainUserCategoryAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainUserCategoryAggregate'] = ResolversParentTypes['domainUserCategoryAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['domainUserCategoryAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['domainUserCategory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainUserCategoryAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainUserCategoryAggregateFields'] = ResolversParentTypes['domainUserCategoryAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<domainUserCategoryAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['domainUserCategoryMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['domainUserCategoryMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainUserCategoryMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainUserCategoryMaxFields'] = ResolversParentTypes['domainUserCategoryMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainUserCategoryMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainUserCategoryMinFields'] = ResolversParentTypes['domainUserCategoryMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainUserCategoryMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainUserCategoryMutationResponse'] = ResolversParentTypes['domainUserCategoryMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['domainUserCategory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainUserMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainUserMaxFields'] = ResolversParentTypes['domainUserMaxFields']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  domainOrganizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  domainUserUuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  spamScore?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  triggerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  triggerTime?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainUserMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainUserMinFields'] = ResolversParentTypes['domainUserMinFields']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  domainOrganizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  domainUserUuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  spamScore?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  triggerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  triggerTime?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainUserMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainUserMutationResponse'] = ResolversParentTypes['domainUserMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['domainUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainUserStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainUserStddevFields'] = ResolversParentTypes['domainUserStddevFields']> = {
  spamScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainUserStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainUserStddevPopFields'] = ResolversParentTypes['domainUserStddevPopFields']> = {
  spamScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainUserStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainUserStddevSampFields'] = ResolversParentTypes['domainUserStddevSampFields']> = {
  spamScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainUserSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainUserSumFields'] = ResolversParentTypes['domainUserSumFields']> = {
  spamScore?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainUserVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainUserVarPopFields'] = ResolversParentTypes['domainUserVarPopFields']> = {
  spamScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainUserVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainUserVarSampFields'] = ResolversParentTypes['domainUserVarSampFields']> = {
  spamScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type domainUserVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['domainUserVarianceFields'] = ResolversParentTypes['domainUserVarianceFields']> = {
  spamScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type emailDomainUserOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['emailDomainUserOutput'] = ResolversParentTypes['emailDomainUserOutput']> = {
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type emailingmutation_rootResolvers<ContextType = any, ParentType extends ResolversParentTypes['emailingmutation_root'] = ResolversParentTypes['emailingmutation_root']> = {
  createActivities?: Resolver<Maybe<ResolversTypes['EmailingactivityMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootcreateActivitiesArgs, 'objects'>>;
  createActivity?: Resolver<Maybe<ResolversTypes['Emailingactivity']>, ParentType, ContextType, RequireFields<emailingmutation_rootcreateActivityArgs, 'object'>>;
  createActivityParticipant?: Resolver<Maybe<ResolversTypes['EmailingactivityParticipant']>, ParentType, ContextType, RequireFields<emailingmutation_rootcreateActivityParticipantArgs, 'object'>>;
  createActivityParticipantRole?: Resolver<Maybe<ResolversTypes['EmailingactivityParticipantRole']>, ParentType, ContextType, RequireFields<emailingmutation_rootcreateActivityParticipantRoleArgs, 'object'>>;
  createActivityParticipantRoles?: Resolver<Maybe<ResolversTypes['EmailingactivityParticipantRoleMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootcreateActivityParticipantRolesArgs, 'objects'>>;
  createActivityParticipants?: Resolver<Maybe<ResolversTypes['EmailingactivityParticipantMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootcreateActivityParticipantsArgs, 'objects'>>;
  createDomainOrganization?: Resolver<Maybe<ResolversTypes['EmailingdomainOrganization']>, ParentType, ContextType, RequireFields<emailingmutation_rootcreateDomainOrganizationArgs, 'object'>>;
  createDomainOrganizations?: Resolver<Maybe<ResolversTypes['EmailingdomainOrganizationMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootcreateDomainOrganizationsArgs, 'objects'>>;
  createDomainUser?: Resolver<Maybe<ResolversTypes['EmailingdomainUser']>, ParentType, ContextType, RequireFields<emailingmutation_rootcreateDomainUserArgs, 'object'>>;
  createDomainUserCategories?: Resolver<Maybe<ResolversTypes['EmailingdomainUserCategoryMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootcreateDomainUserCategoriesArgs, 'objects'>>;
  createDomainUserCategory?: Resolver<Maybe<ResolversTypes['EmailingdomainUserCategory']>, ParentType, ContextType, RequireFields<emailingmutation_rootcreateDomainUserCategoryArgs, 'object'>>;
  createDomainUsers?: Resolver<Maybe<ResolversTypes['EmailingdomainUserMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootcreateDomainUsersArgs, 'objects'>>;
  createEvent?: Resolver<Maybe<ResolversTypes['Emailingevent']>, ParentType, ContextType, RequireFields<emailingmutation_rootcreateEventArgs, 'object'>>;
  createEvents?: Resolver<Maybe<ResolversTypes['EmailingeventMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootcreateEventsArgs, 'objects'>>;
  createProviderAccount?: Resolver<Maybe<ResolversTypes['EmailingproviderAccount']>, ParentType, ContextType, RequireFields<emailingmutation_rootcreateProviderAccountArgs, 'object'>>;
  createProviderAccounts?: Resolver<Maybe<ResolversTypes['EmailingproviderAccountMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootcreateProviderAccountsArgs, 'objects'>>;
  createProviderType?: Resolver<Maybe<ResolversTypes['EmailingproviderType']>, ParentType, ContextType, RequireFields<emailingmutation_rootcreateProviderTypeArgs, 'object'>>;
  createProviderTypes?: Resolver<Maybe<ResolversTypes['EmailingproviderTypeMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootcreateProviderTypesArgs, 'objects'>>;
  deleteActivities?: Resolver<Maybe<ResolversTypes['EmailingactivityMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootdeleteActivitiesArgs, 'where'>>;
  deleteActivity?: Resolver<Maybe<ResolversTypes['Emailingactivity']>, ParentType, ContextType, RequireFields<emailingmutation_rootdeleteActivityArgs, 'id'>>;
  deleteActivityParticipant?: Resolver<Maybe<ResolversTypes['EmailingactivityParticipant']>, ParentType, ContextType, RequireFields<emailingmutation_rootdeleteActivityParticipantArgs, 'id'>>;
  deleteActivityParticipantRole?: Resolver<Maybe<ResolversTypes['EmailingactivityParticipantRole']>, ParentType, ContextType, RequireFields<emailingmutation_rootdeleteActivityParticipantRoleArgs, 'value'>>;
  deleteActivityParticipantRoles?: Resolver<Maybe<ResolversTypes['EmailingactivityParticipantRoleMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootdeleteActivityParticipantRolesArgs, 'where'>>;
  deleteActivityParticipants?: Resolver<Maybe<ResolversTypes['EmailingactivityParticipantMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootdeleteActivityParticipantsArgs, 'where'>>;
  deleteDomainOrganization?: Resolver<Maybe<ResolversTypes['EmailingdomainOrganization']>, ParentType, ContextType, RequireFields<emailingmutation_rootdeleteDomainOrganizationArgs, 'id'>>;
  deleteDomainOrganizations?: Resolver<Maybe<ResolversTypes['EmailingdomainOrganizationMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootdeleteDomainOrganizationsArgs, 'where'>>;
  deleteDomainUser?: Resolver<Maybe<ResolversTypes['EmailingdomainUser']>, ParentType, ContextType, RequireFields<emailingmutation_rootdeleteDomainUserArgs, 'id'>>;
  deleteDomainUserCategories?: Resolver<Maybe<ResolversTypes['EmailingdomainUserCategoryMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootdeleteDomainUserCategoriesArgs, 'where'>>;
  deleteDomainUserCategory?: Resolver<Maybe<ResolversTypes['EmailingdomainUserCategory']>, ParentType, ContextType, RequireFields<emailingmutation_rootdeleteDomainUserCategoryArgs, 'value'>>;
  deleteDomainUsers?: Resolver<Maybe<ResolversTypes['EmailingdomainUserMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootdeleteDomainUsersArgs, 'where'>>;
  deleteEmailAccountSubscribers?: Resolver<Maybe<ResolversTypes['EmailingEmailAccountSubscribersMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootdeleteEmailAccountSubscribersArgs, 'where'>>;
  deleteEmailAccountSubscribersByPk?: Resolver<Maybe<ResolversTypes['EmailingEmailAccountSubscribers']>, ParentType, ContextType, RequireFields<emailingmutation_rootdeleteEmailAccountSubscribersByPkArgs, 'id'>>;
  deleteEmailActivityType?: Resolver<Maybe<ResolversTypes['EmailingEmailActivityTypeMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootdeleteEmailActivityTypeArgs, 'where'>>;
  deleteEmailActivityTypeByPk?: Resolver<Maybe<ResolversTypes['EmailingEmailActivityType']>, ParentType, ContextType, RequireFields<emailingmutation_rootdeleteEmailActivityTypeByPkArgs, 'value'>>;
  deleteEmailComment?: Resolver<Maybe<ResolversTypes['EmailingEmailCommentMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootdeleteEmailCommentArgs, 'where'>>;
  deleteEmailCommentByPk?: Resolver<Maybe<ResolversTypes['EmailingEmailComment']>, ParentType, ContextType, RequireFields<emailingmutation_rootdeleteEmailCommentByPkArgs, 'id'>>;
  deleteEvent?: Resolver<Maybe<ResolversTypes['Emailingevent']>, ParentType, ContextType, RequireFields<emailingmutation_rootdeleteEventArgs, 'id'>>;
  deleteEvents?: Resolver<Maybe<ResolversTypes['EmailingeventMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootdeleteEventsArgs, 'where'>>;
  deleteProviderAccount?: Resolver<Maybe<ResolversTypes['EmailingproviderAccount']>, ParentType, ContextType, RequireFields<emailingmutation_rootdeleteProviderAccountArgs, 'id'>>;
  deleteProviderAccounts?: Resolver<Maybe<ResolversTypes['EmailingproviderAccountMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootdeleteProviderAccountsArgs, 'where'>>;
  deleteProviderType?: Resolver<Maybe<ResolversTypes['EmailingproviderType']>, ParentType, ContextType, RequireFields<emailingmutation_rootdeleteProviderTypeArgs, 'value'>>;
  deleteProviderTypes?: Resolver<Maybe<ResolversTypes['EmailingproviderTypeMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootdeleteProviderTypesArgs, 'where'>>;
  insertEmailAccountSubscribers?: Resolver<Maybe<ResolversTypes['EmailingEmailAccountSubscribersMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootinsertEmailAccountSubscribersArgs, 'objects'>>;
  insertEmailAccountSubscribersOne?: Resolver<Maybe<ResolversTypes['EmailingEmailAccountSubscribers']>, ParentType, ContextType, RequireFields<emailingmutation_rootinsertEmailAccountSubscribersOneArgs, 'object'>>;
  insertEmailActivityType?: Resolver<Maybe<ResolversTypes['EmailingEmailActivityTypeMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootinsertEmailActivityTypeArgs, 'objects'>>;
  insertEmailActivityTypeOne?: Resolver<Maybe<ResolversTypes['EmailingEmailActivityType']>, ParentType, ContextType, RequireFields<emailingmutation_rootinsertEmailActivityTypeOneArgs, 'object'>>;
  insertEmailComment?: Resolver<Maybe<ResolversTypes['EmailingEmailCommentMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootinsertEmailCommentArgs, 'objects'>>;
  insertEmailCommentOne?: Resolver<Maybe<ResolversTypes['EmailingEmailComment']>, ParentType, ContextType, RequireFields<emailingmutation_rootinsertEmailCommentOneArgs, 'object'>>;
  updateActivities?: Resolver<Maybe<ResolversTypes['EmailingactivityMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateActivitiesArgs, 'where'>>;
  updateActivity?: Resolver<Maybe<ResolversTypes['Emailingactivity']>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateActivityArgs, 'pkColumns'>>;
  updateActivityMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['EmailingactivityMutationResponse']>>>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateActivityManyArgs, 'updates'>>;
  updateActivityParticipant?: Resolver<Maybe<ResolversTypes['EmailingactivityParticipant']>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateActivityParticipantArgs, 'pkColumns'>>;
  updateActivityParticipantMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['EmailingactivityParticipantMutationResponse']>>>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateActivityParticipantManyArgs, 'updates'>>;
  updateActivityParticipantRole?: Resolver<Maybe<ResolversTypes['EmailingactivityParticipantRole']>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateActivityParticipantRoleArgs, 'pkColumns'>>;
  updateActivityParticipantRoleMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['EmailingactivityParticipantRoleMutationResponse']>>>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateActivityParticipantRoleManyArgs, 'updates'>>;
  updateActivityParticipantRoles?: Resolver<Maybe<ResolversTypes['EmailingactivityParticipantRoleMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateActivityParticipantRolesArgs, 'where'>>;
  updateActivityParticipants?: Resolver<Maybe<ResolversTypes['EmailingactivityParticipantMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateActivityParticipantsArgs, 'where'>>;
  updateDomainOrganization?: Resolver<Maybe<ResolversTypes['EmailingdomainOrganization']>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateDomainOrganizationArgs, 'pkColumns'>>;
  updateDomainOrganizationMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['EmailingdomainOrganizationMutationResponse']>>>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateDomainOrganizationManyArgs, 'updates'>>;
  updateDomainOrganizations?: Resolver<Maybe<ResolversTypes['EmailingdomainOrganizationMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateDomainOrganizationsArgs, 'where'>>;
  updateDomainUser?: Resolver<Maybe<ResolversTypes['EmailingdomainUser']>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateDomainUserArgs, 'pkColumns'>>;
  updateDomainUserCategories?: Resolver<Maybe<ResolversTypes['EmailingdomainUserCategoryMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateDomainUserCategoriesArgs, 'where'>>;
  updateDomainUserCategory?: Resolver<Maybe<ResolversTypes['EmailingdomainUserCategory']>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateDomainUserCategoryArgs, 'pkColumns'>>;
  updateDomainUserCategoryMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['EmailingdomainUserCategoryMutationResponse']>>>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateDomainUserCategoryManyArgs, 'updates'>>;
  updateDomainUserMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['EmailingdomainUserMutationResponse']>>>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateDomainUserManyArgs, 'updates'>>;
  updateDomainUsers?: Resolver<Maybe<ResolversTypes['EmailingdomainUserMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateDomainUsersArgs, 'where'>>;
  updateEmailAccountSubscribers?: Resolver<Maybe<ResolversTypes['EmailingEmailAccountSubscribersMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateEmailAccountSubscribersArgs, 'where'>>;
  updateEmailAccountSubscribersByPk?: Resolver<Maybe<ResolversTypes['EmailingEmailAccountSubscribers']>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateEmailAccountSubscribersByPkArgs, 'pkColumns'>>;
  updateEmailAccountSubscribersMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['EmailingEmailAccountSubscribersMutationResponse']>>>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateEmailAccountSubscribersManyArgs, 'updates'>>;
  updateEmailActivityType?: Resolver<Maybe<ResolversTypes['EmailingEmailActivityTypeMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateEmailActivityTypeArgs, 'where'>>;
  updateEmailActivityTypeByPk?: Resolver<Maybe<ResolversTypes['EmailingEmailActivityType']>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateEmailActivityTypeByPkArgs, 'pkColumns'>>;
  updateEmailActivityTypeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['EmailingEmailActivityTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateEmailActivityTypeManyArgs, 'updates'>>;
  updateEmailComment?: Resolver<Maybe<ResolversTypes['EmailingEmailCommentMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateEmailCommentArgs, 'where'>>;
  updateEmailCommentByPk?: Resolver<Maybe<ResolversTypes['EmailingEmailComment']>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateEmailCommentByPkArgs, 'pkColumns'>>;
  updateEmailCommentMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['EmailingEmailCommentMutationResponse']>>>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateEmailCommentManyArgs, 'updates'>>;
  updateEvent?: Resolver<Maybe<ResolversTypes['Emailingevent']>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateEventArgs, 'pkColumns'>>;
  updateEventMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['EmailingeventMutationResponse']>>>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateEventManyArgs, 'updates'>>;
  updateEvents?: Resolver<Maybe<ResolversTypes['EmailingeventMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateEventsArgs, 'where'>>;
  updateProviderAccount?: Resolver<Maybe<ResolversTypes['EmailingproviderAccount']>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateProviderAccountArgs, 'pkColumns'>>;
  updateProviderAccountMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['EmailingproviderAccountMutationResponse']>>>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateProviderAccountManyArgs, 'updates'>>;
  updateProviderAccounts?: Resolver<Maybe<ResolversTypes['EmailingproviderAccountMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateProviderAccountsArgs, 'where'>>;
  updateProviderType?: Resolver<Maybe<ResolversTypes['EmailingproviderType']>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateProviderTypeArgs, 'pkColumns'>>;
  updateProviderTypeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['EmailingproviderTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateProviderTypeManyArgs, 'updates'>>;
  updateProviderTypes?: Resolver<Maybe<ResolversTypes['EmailingproviderTypeMutationResponse']>, ParentType, ContextType, RequireFields<emailingmutation_rootupdateProviderTypesArgs, 'where'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type emailingquery_rootResolvers<ContextType = any, ParentType extends ResolversParentTypes['emailingquery_root'] = ResolversParentTypes['emailingquery_root']> = {
  activities?: Resolver<Array<ResolversTypes['Emailingactivity']>, ParentType, ContextType, Partial<emailingquery_rootactivitiesArgs>>;
  activity?: Resolver<Maybe<ResolversTypes['Emailingactivity']>, ParentType, ContextType, RequireFields<emailingquery_rootactivityArgs, 'id'>>;
  activityParticipant?: Resolver<Maybe<ResolversTypes['EmailingactivityParticipant']>, ParentType, ContextType, RequireFields<emailingquery_rootactivityParticipantArgs, 'id'>>;
  activityParticipantRole?: Resolver<Maybe<ResolversTypes['EmailingactivityParticipantRole']>, ParentType, ContextType, RequireFields<emailingquery_rootactivityParticipantRoleArgs, 'value'>>;
  activityParticipantRoles?: Resolver<Array<ResolversTypes['EmailingactivityParticipantRole']>, ParentType, ContextType, Partial<emailingquery_rootactivityParticipantRolesArgs>>;
  activityParticipants?: Resolver<Array<ResolversTypes['EmailingactivityParticipant']>, ParentType, ContextType, Partial<emailingquery_rootactivityParticipantsArgs>>;
  aggregateActivities?: Resolver<ResolversTypes['EmailingactivityAggregate'], ParentType, ContextType, Partial<emailingquery_rootaggregateActivitiesArgs>>;
  aggregateActivityParticipantRoles?: Resolver<ResolversTypes['EmailingactivityParticipantRoleAggregate'], ParentType, ContextType, Partial<emailingquery_rootaggregateActivityParticipantRolesArgs>>;
  aggregateActivityParticipants?: Resolver<ResolversTypes['EmailingactivityParticipantAggregate'], ParentType, ContextType, Partial<emailingquery_rootaggregateActivityParticipantsArgs>>;
  aggregateDomainOrganizations?: Resolver<ResolversTypes['EmailingdomainOrganizationAggregate'], ParentType, ContextType, Partial<emailingquery_rootaggregateDomainOrganizationsArgs>>;
  aggregateDomainUserCategories?: Resolver<ResolversTypes['EmailingdomainUserCategoryAggregate'], ParentType, ContextType, Partial<emailingquery_rootaggregateDomainUserCategoriesArgs>>;
  aggregateDomainUsers?: Resolver<ResolversTypes['EmailingdomainUserAggregate'], ParentType, ContextType, Partial<emailingquery_rootaggregateDomainUsersArgs>>;
  aggregateEvents?: Resolver<ResolversTypes['EmailingeventAggregate'], ParentType, ContextType, Partial<emailingquery_rootaggregateEventsArgs>>;
  aggregateProviderAccounts?: Resolver<ResolversTypes['EmailingproviderAccountAggregate'], ParentType, ContextType, Partial<emailingquery_rootaggregateProviderAccountsArgs>>;
  aggregateProviderTypes?: Resolver<ResolversTypes['EmailingproviderTypeAggregate'], ParentType, ContextType, Partial<emailingquery_rootaggregateProviderTypesArgs>>;
  domainOrganization?: Resolver<Maybe<ResolversTypes['EmailingdomainOrganization']>, ParentType, ContextType, RequireFields<emailingquery_rootdomainOrganizationArgs, 'id'>>;
  domainOrganizations?: Resolver<Array<ResolversTypes['EmailingdomainOrganization']>, ParentType, ContextType, Partial<emailingquery_rootdomainOrganizationsArgs>>;
  domainUser?: Resolver<Maybe<ResolversTypes['EmailingdomainUser']>, ParentType, ContextType, RequireFields<emailingquery_rootdomainUserArgs, 'id'>>;
  domainUserCategories?: Resolver<Array<ResolversTypes['EmailingdomainUserCategory']>, ParentType, ContextType, Partial<emailingquery_rootdomainUserCategoriesArgs>>;
  domainUserCategory?: Resolver<Maybe<ResolversTypes['EmailingdomainUserCategory']>, ParentType, ContextType, RequireFields<emailingquery_rootdomainUserCategoryArgs, 'value'>>;
  domainUsers?: Resolver<Array<ResolversTypes['EmailingdomainUser']>, ParentType, ContextType, Partial<emailingquery_rootdomainUsersArgs>>;
  emailAccountSubscribers?: Resolver<Array<ResolversTypes['EmailingEmailAccountSubscribers']>, ParentType, ContextType, Partial<emailingquery_rootemailAccountSubscribersArgs>>;
  emailAccountSubscribersAggregate?: Resolver<ResolversTypes['EmailingEmailAccountSubscribersAggregate'], ParentType, ContextType, Partial<emailingquery_rootemailAccountSubscribersAggregateArgs>>;
  emailAccountSubscribersByPk?: Resolver<Maybe<ResolversTypes['EmailingEmailAccountSubscribers']>, ParentType, ContextType, RequireFields<emailingquery_rootemailAccountSubscribersByPkArgs, 'id'>>;
  emailActivityType?: Resolver<Array<ResolversTypes['EmailingEmailActivityType']>, ParentType, ContextType, Partial<emailingquery_rootemailActivityTypeArgs>>;
  emailActivityTypeAggregate?: Resolver<ResolversTypes['EmailingEmailActivityTypeAggregate'], ParentType, ContextType, Partial<emailingquery_rootemailActivityTypeAggregateArgs>>;
  emailActivityTypeByPk?: Resolver<Maybe<ResolversTypes['EmailingEmailActivityType']>, ParentType, ContextType, RequireFields<emailingquery_rootemailActivityTypeByPkArgs, 'value'>>;
  emailComment?: Resolver<Array<ResolversTypes['EmailingEmailComment']>, ParentType, ContextType, Partial<emailingquery_rootemailCommentArgs>>;
  emailCommentAggregate?: Resolver<ResolversTypes['EmailingEmailCommentAggregate'], ParentType, ContextType, Partial<emailingquery_rootemailCommentAggregateArgs>>;
  emailCommentByPk?: Resolver<Maybe<ResolversTypes['EmailingEmailComment']>, ParentType, ContextType, RequireFields<emailingquery_rootemailCommentByPkArgs, 'id'>>;
  event?: Resolver<Maybe<ResolversTypes['Emailingevent']>, ParentType, ContextType, RequireFields<emailingquery_rooteventArgs, 'id'>>;
  events?: Resolver<Array<ResolversTypes['Emailingevent']>, ParentType, ContextType, Partial<emailingquery_rooteventsArgs>>;
  providerAccount?: Resolver<Maybe<ResolversTypes['EmailingproviderAccount']>, ParentType, ContextType, RequireFields<emailingquery_rootproviderAccountArgs, 'id'>>;
  providerAccounts?: Resolver<Array<ResolversTypes['EmailingproviderAccount']>, ParentType, ContextType, Partial<emailingquery_rootproviderAccountsArgs>>;
  providerType?: Resolver<Maybe<ResolversTypes['EmailingproviderType']>, ParentType, ContextType, RequireFields<emailingquery_rootproviderTypeArgs, 'value'>>;
  providerTypes?: Resolver<Array<ResolversTypes['EmailingproviderType']>, ParentType, ContextType, Partial<emailingquery_rootproviderTypesArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type emailingsubscription_rootResolvers<ContextType = any, ParentType extends ResolversParentTypes['emailingsubscription_root'] = ResolversParentTypes['emailingsubscription_root']> = {
  activities?: Resolver<Array<ResolversTypes['Emailingactivity']>, ParentType, ContextType, Partial<emailingsubscription_rootactivitiesArgs>>;
  activity?: Resolver<Maybe<ResolversTypes['Emailingactivity']>, ParentType, ContextType, RequireFields<emailingsubscription_rootactivityArgs, 'id'>>;
  activityParticipant?: Resolver<Maybe<ResolversTypes['EmailingactivityParticipant']>, ParentType, ContextType, RequireFields<emailingsubscription_rootactivityParticipantArgs, 'id'>>;
  activityParticipantRole?: Resolver<Maybe<ResolversTypes['EmailingactivityParticipantRole']>, ParentType, ContextType, RequireFields<emailingsubscription_rootactivityParticipantRoleArgs, 'value'>>;
  activityParticipantRoleStream?: Resolver<Array<ResolversTypes['EmailingactivityParticipantRole']>, ParentType, ContextType, RequireFields<emailingsubscription_rootactivityParticipantRoleStreamArgs, 'batchSize' | 'cursor'>>;
  activityParticipantRoles?: Resolver<Array<ResolversTypes['EmailingactivityParticipantRole']>, ParentType, ContextType, Partial<emailingsubscription_rootactivityParticipantRolesArgs>>;
  activityParticipantStream?: Resolver<Array<ResolversTypes['EmailingactivityParticipant']>, ParentType, ContextType, RequireFields<emailingsubscription_rootactivityParticipantStreamArgs, 'batchSize' | 'cursor'>>;
  activityParticipants?: Resolver<Array<ResolversTypes['EmailingactivityParticipant']>, ParentType, ContextType, Partial<emailingsubscription_rootactivityParticipantsArgs>>;
  activityStream?: Resolver<Array<ResolversTypes['Emailingactivity']>, ParentType, ContextType, RequireFields<emailingsubscription_rootactivityStreamArgs, 'batchSize' | 'cursor'>>;
  aggregateActivities?: Resolver<ResolversTypes['EmailingactivityAggregate'], ParentType, ContextType, Partial<emailingsubscription_rootaggregateActivitiesArgs>>;
  aggregateActivityParticipantRoles?: Resolver<ResolversTypes['EmailingactivityParticipantRoleAggregate'], ParentType, ContextType, Partial<emailingsubscription_rootaggregateActivityParticipantRolesArgs>>;
  aggregateActivityParticipants?: Resolver<ResolversTypes['EmailingactivityParticipantAggregate'], ParentType, ContextType, Partial<emailingsubscription_rootaggregateActivityParticipantsArgs>>;
  aggregateDomainOrganizations?: Resolver<ResolversTypes['EmailingdomainOrganizationAggregate'], ParentType, ContextType, Partial<emailingsubscription_rootaggregateDomainOrganizationsArgs>>;
  aggregateDomainUserCategories?: Resolver<ResolversTypes['EmailingdomainUserCategoryAggregate'], ParentType, ContextType, Partial<emailingsubscription_rootaggregateDomainUserCategoriesArgs>>;
  aggregateDomainUsers?: Resolver<ResolversTypes['EmailingdomainUserAggregate'], ParentType, ContextType, Partial<emailingsubscription_rootaggregateDomainUsersArgs>>;
  aggregateEvents?: Resolver<ResolversTypes['EmailingeventAggregate'], ParentType, ContextType, Partial<emailingsubscription_rootaggregateEventsArgs>>;
  aggregateProviderAccounts?: Resolver<ResolversTypes['EmailingproviderAccountAggregate'], ParentType, ContextType, Partial<emailingsubscription_rootaggregateProviderAccountsArgs>>;
  aggregateProviderTypes?: Resolver<ResolversTypes['EmailingproviderTypeAggregate'], ParentType, ContextType, Partial<emailingsubscription_rootaggregateProviderTypesArgs>>;
  domainOrganization?: Resolver<Maybe<ResolversTypes['EmailingdomainOrganization']>, ParentType, ContextType, RequireFields<emailingsubscription_rootdomainOrganizationArgs, 'id'>>;
  domainOrganizationStream?: Resolver<Array<ResolversTypes['EmailingdomainOrganization']>, ParentType, ContextType, RequireFields<emailingsubscription_rootdomainOrganizationStreamArgs, 'batchSize' | 'cursor'>>;
  domainOrganizations?: Resolver<Array<ResolversTypes['EmailingdomainOrganization']>, ParentType, ContextType, Partial<emailingsubscription_rootdomainOrganizationsArgs>>;
  domainUser?: Resolver<Maybe<ResolversTypes['EmailingdomainUser']>, ParentType, ContextType, RequireFields<emailingsubscription_rootdomainUserArgs, 'id'>>;
  domainUserCategories?: Resolver<Array<ResolversTypes['EmailingdomainUserCategory']>, ParentType, ContextType, Partial<emailingsubscription_rootdomainUserCategoriesArgs>>;
  domainUserCategory?: Resolver<Maybe<ResolversTypes['EmailingdomainUserCategory']>, ParentType, ContextType, RequireFields<emailingsubscription_rootdomainUserCategoryArgs, 'value'>>;
  domainUserCategoryStream?: Resolver<Array<ResolversTypes['EmailingdomainUserCategory']>, ParentType, ContextType, RequireFields<emailingsubscription_rootdomainUserCategoryStreamArgs, 'batchSize' | 'cursor'>>;
  domainUserStream?: Resolver<Array<ResolversTypes['EmailingdomainUser']>, ParentType, ContextType, RequireFields<emailingsubscription_rootdomainUserStreamArgs, 'batchSize' | 'cursor'>>;
  domainUsers?: Resolver<Array<ResolversTypes['EmailingdomainUser']>, ParentType, ContextType, Partial<emailingsubscription_rootdomainUsersArgs>>;
  emailAccountSubscribers?: Resolver<Array<ResolversTypes['EmailingEmailAccountSubscribers']>, ParentType, ContextType, Partial<emailingsubscription_rootemailAccountSubscribersArgs>>;
  emailAccountSubscribersAggregate?: Resolver<ResolversTypes['EmailingEmailAccountSubscribersAggregate'], ParentType, ContextType, Partial<emailingsubscription_rootemailAccountSubscribersAggregateArgs>>;
  emailAccountSubscribersByPk?: Resolver<Maybe<ResolversTypes['EmailingEmailAccountSubscribers']>, ParentType, ContextType, RequireFields<emailingsubscription_rootemailAccountSubscribersByPkArgs, 'id'>>;
  emailAccountSubscribersStream?: Resolver<Array<ResolversTypes['EmailingEmailAccountSubscribers']>, ParentType, ContextType, RequireFields<emailingsubscription_rootemailAccountSubscribersStreamArgs, 'batchSize' | 'cursor'>>;
  emailActivityType?: Resolver<Array<ResolversTypes['EmailingEmailActivityType']>, ParentType, ContextType, Partial<emailingsubscription_rootemailActivityTypeArgs>>;
  emailActivityTypeAggregate?: Resolver<ResolversTypes['EmailingEmailActivityTypeAggregate'], ParentType, ContextType, Partial<emailingsubscription_rootemailActivityTypeAggregateArgs>>;
  emailActivityTypeByPk?: Resolver<Maybe<ResolversTypes['EmailingEmailActivityType']>, ParentType, ContextType, RequireFields<emailingsubscription_rootemailActivityTypeByPkArgs, 'value'>>;
  emailActivityTypeStream?: Resolver<Array<ResolversTypes['EmailingEmailActivityType']>, ParentType, ContextType, RequireFields<emailingsubscription_rootemailActivityTypeStreamArgs, 'batchSize' | 'cursor'>>;
  emailComment?: Resolver<Array<ResolversTypes['EmailingEmailComment']>, ParentType, ContextType, Partial<emailingsubscription_rootemailCommentArgs>>;
  emailCommentAggregate?: Resolver<ResolversTypes['EmailingEmailCommentAggregate'], ParentType, ContextType, Partial<emailingsubscription_rootemailCommentAggregateArgs>>;
  emailCommentByPk?: Resolver<Maybe<ResolversTypes['EmailingEmailComment']>, ParentType, ContextType, RequireFields<emailingsubscription_rootemailCommentByPkArgs, 'id'>>;
  emailCommentStream?: Resolver<Array<ResolversTypes['EmailingEmailComment']>, ParentType, ContextType, RequireFields<emailingsubscription_rootemailCommentStreamArgs, 'batchSize' | 'cursor'>>;
  event?: Resolver<Maybe<ResolversTypes['Emailingevent']>, ParentType, ContextType, RequireFields<emailingsubscription_rooteventArgs, 'id'>>;
  eventStream?: Resolver<Array<ResolversTypes['Emailingevent']>, ParentType, ContextType, RequireFields<emailingsubscription_rooteventStreamArgs, 'batchSize' | 'cursor'>>;
  events?: Resolver<Array<ResolversTypes['Emailingevent']>, ParentType, ContextType, Partial<emailingsubscription_rooteventsArgs>>;
  providerAccount?: Resolver<Maybe<ResolversTypes['EmailingproviderAccount']>, ParentType, ContextType, RequireFields<emailingsubscription_rootproviderAccountArgs, 'id'>>;
  providerAccountStream?: Resolver<Array<ResolversTypes['EmailingproviderAccount']>, ParentType, ContextType, RequireFields<emailingsubscription_rootproviderAccountStreamArgs, 'batchSize' | 'cursor'>>;
  providerAccounts?: Resolver<Array<ResolversTypes['EmailingproviderAccount']>, ParentType, ContextType, Partial<emailingsubscription_rootproviderAccountsArgs>>;
  providerType?: Resolver<Maybe<ResolversTypes['EmailingproviderType']>, ParentType, ContextType, RequireFields<emailingsubscription_rootproviderTypeArgs, 'value'>>;
  providerTypeStream?: Resolver<Array<ResolversTypes['EmailingproviderType']>, ParentType, ContextType, RequireFields<emailingsubscription_rootproviderTypeStreamArgs, 'batchSize' | 'cursor'>>;
  providerTypes?: Resolver<Array<ResolversTypes['EmailingproviderType']>, ParentType, ContextType, Partial<emailingsubscription_rootproviderTypesArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type fileOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['fileOutput'] = ResolversParentTypes['fileOutput']> = {
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type geodatamutation_rootResolvers<ContextType = any, ParentType extends ResolversParentTypes['geodatamutation_root'] = ResolversParentTypes['geodatamutation_root']> = {
  deleteAddress?: Resolver<Maybe<ResolversTypes['GeodataAddressMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootdeleteAddressArgs, 'where'>>;
  deleteAddressByPk?: Resolver<Maybe<ResolversTypes['GeodataAddress']>, ParentType, ContextType, RequireFields<geodatamutation_rootdeleteAddressByPkArgs, 'id'>>;
  deleteMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootdeleteMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeArgs, 'where'>>;
  deleteMatrikkelenadresseleilighetsnivaAtkomst?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootdeleteMatrikkelenadresseleilighetsnivaAtkomstArgs, 'where'>>;
  deleteMatrikkelenadresseleilighetsnivaKommunenummer?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaKommunenummerMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootdeleteMatrikkelenadresseleilighetsnivaKommunenummerArgs, 'where'>>;
  deleteMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootdeleteMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetArgs, 'where'>>;
  deleteMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootdeleteMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidArgs, 'where'>>;
  deleteMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootdeleteMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstArgs, 'where'>>;
  deleteMatrikkelenadresseleilighetsnivaTypeatkomst?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootdeleteMatrikkelenadresseleilighetsnivaTypeatkomstArgs, 'where'>>;
  deleteMatrikkelenadresseleilighetsnivaVegadressebruksenhet?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootdeleteMatrikkelenadresseleilighetsnivaVegadressebruksenhetArgs, 'where'>>;
  deleteMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootdeleteMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidArgs, 'where'>>;
  deleteMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootdeleteMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstArgs, 'where'>>;
  deleteSpatialRefSys?: Resolver<Maybe<ResolversTypes['GeodataSpatialRefSysMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootdeleteSpatialRefSysArgs, 'where'>>;
  deleteSpatialRefSysByPk?: Resolver<Maybe<ResolversTypes['GeodataSpatialRefSys']>, ParentType, ContextType, RequireFields<geodatamutation_rootdeleteSpatialRefSysByPkArgs, 'srid'>>;
  deleteZip?: Resolver<Maybe<ResolversTypes['GeodataZipMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootdeleteZipArgs, 'where'>>;
  deleteZipByPk?: Resolver<Maybe<ResolversTypes['GeodataZip']>, ParentType, ContextType, RequireFields<geodatamutation_rootdeleteZipByPkArgs, 'zip'>>;
  insertAddress?: Resolver<Maybe<ResolversTypes['GeodataAddressMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootinsertAddressArgs, 'objects'>>;
  insertAddressOne?: Resolver<Maybe<ResolversTypes['GeodataAddress']>, ParentType, ContextType, RequireFields<geodatamutation_rootinsertAddressOneArgs, 'object'>>;
  insertMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeArgs, 'objects'>>;
  insertMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeOne?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode']>, ParentType, ContextType, RequireFields<geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeOneArgs, 'object'>>;
  insertMatrikkelenadresseleilighetsnivaAtkomst?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaAtkomstArgs, 'objects'>>;
  insertMatrikkelenadresseleilighetsnivaAtkomstOne?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomst']>, ParentType, ContextType, RequireFields<geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaAtkomstOneArgs, 'object'>>;
  insertMatrikkelenadresseleilighetsnivaKommunenummer?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaKommunenummerMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaKommunenummerArgs, 'objects'>>;
  insertMatrikkelenadresseleilighetsnivaKommunenummerOne?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaKommunenummer']>, ParentType, ContextType, RequireFields<geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaKommunenummerOneArgs, 'object'>>;
  insertMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetArgs, 'objects'>>;
  insertMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidArgs, 'objects'>>;
  insertMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidOne?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid']>, ParentType, ContextType, RequireFields<geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidOneArgs, 'object'>>;
  insertMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetOne?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet']>, ParentType, ContextType, RequireFields<geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetOneArgs, 'object'>>;
  insertMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstArgs, 'objects'>>;
  insertMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstOne?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst']>, ParentType, ContextType, RequireFields<geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstOneArgs, 'object'>>;
  insertMatrikkelenadresseleilighetsnivaTypeatkomst?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaTypeatkomstArgs, 'objects'>>;
  insertMatrikkelenadresseleilighetsnivaTypeatkomstOne?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaTypeatkomst']>, ParentType, ContextType, RequireFields<geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaTypeatkomstOneArgs, 'object'>>;
  insertMatrikkelenadresseleilighetsnivaVegadressebruksenhet?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaVegadressebruksenhetArgs, 'objects'>>;
  insertMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidArgs, 'objects'>>;
  insertMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidOne?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid']>, ParentType, ContextType, RequireFields<geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidOneArgs, 'object'>>;
  insertMatrikkelenadresseleilighetsnivaVegadressebruksenhetOne?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhet']>, ParentType, ContextType, RequireFields<geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaVegadressebruksenhetOneArgs, 'object'>>;
  insertMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstArgs, 'objects'>>;
  insertMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstOne?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst']>, ParentType, ContextType, RequireFields<geodatamutation_rootinsertMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstOneArgs, 'object'>>;
  insertSpatialRefSys?: Resolver<Maybe<ResolversTypes['GeodataSpatialRefSysMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootinsertSpatialRefSysArgs, 'objects'>>;
  insertSpatialRefSysOne?: Resolver<Maybe<ResolversTypes['GeodataSpatialRefSys']>, ParentType, ContextType, RequireFields<geodatamutation_rootinsertSpatialRefSysOneArgs, 'object'>>;
  insertZip?: Resolver<Maybe<ResolversTypes['GeodataZipMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootinsertZipArgs, 'objects'>>;
  insertZipOne?: Resolver<Maybe<ResolversTypes['GeodataZip']>, ParentType, ContextType, RequireFields<geodatamutation_rootinsertZipOneArgs, 'object'>>;
  updateAddress?: Resolver<Maybe<ResolversTypes['GeodataAddressMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootupdateAddressArgs, 'where'>>;
  updateAddressByPk?: Resolver<Maybe<ResolversTypes['GeodataAddress']>, ParentType, ContextType, RequireFields<geodatamutation_rootupdateAddressByPkArgs, 'pkColumns'>>;
  updateAddressMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['GeodataAddressMutationResponse']>>>, ParentType, ContextType, RequireFields<geodatamutation_rootupdateAddressManyArgs, 'updates'>>;
  updateMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeArgs, 'where'>>;
  updateMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMutationResponse']>>>, ParentType, ContextType, RequireFields<geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeManyArgs, 'updates'>>;
  updateMatrikkelenadresseleilighetsnivaAtkomst?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaAtkomstArgs, 'where'>>;
  updateMatrikkelenadresseleilighetsnivaAtkomstMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstMutationResponse']>>>, ParentType, ContextType, RequireFields<geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaAtkomstManyArgs, 'updates'>>;
  updateMatrikkelenadresseleilighetsnivaKommunenummer?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaKommunenummerMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaKommunenummerArgs, 'where'>>;
  updateMatrikkelenadresseleilighetsnivaKommunenummerMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaKommunenummerMutationResponse']>>>, ParentType, ContextType, RequireFields<geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaKommunenummerManyArgs, 'updates'>>;
  updateMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetArgs, 'where'>>;
  updateMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidArgs, 'where'>>;
  updateMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMutationResponse']>>>, ParentType, ContextType, RequireFields<geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidManyArgs, 'updates'>>;
  updateMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMutationResponse']>>>, ParentType, ContextType, RequireFields<geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetManyArgs, 'updates'>>;
  updateMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstArgs, 'where'>>;
  updateMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMutationResponse']>>>, ParentType, ContextType, RequireFields<geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstManyArgs, 'updates'>>;
  updateMatrikkelenadresseleilighetsnivaTypeatkomst?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaTypeatkomstArgs, 'where'>>;
  updateMatrikkelenadresseleilighetsnivaTypeatkomstMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMutationResponse']>>>, ParentType, ContextType, RequireFields<geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaTypeatkomstManyArgs, 'updates'>>;
  updateMatrikkelenadresseleilighetsnivaVegadressebruksenhet?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaVegadressebruksenhetArgs, 'where'>>;
  updateMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidArgs, 'where'>>;
  updateMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMutationResponse']>>>, ParentType, ContextType, RequireFields<geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidManyArgs, 'updates'>>;
  updateMatrikkelenadresseleilighetsnivaVegadressebruksenhetMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMutationResponse']>>>, ParentType, ContextType, RequireFields<geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaVegadressebruksenhetManyArgs, 'updates'>>;
  updateMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst?: Resolver<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstArgs, 'where'>>;
  updateMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMutationResponse']>>>, ParentType, ContextType, RequireFields<geodatamutation_rootupdateMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstManyArgs, 'updates'>>;
  updateSpatialRefSys?: Resolver<Maybe<ResolversTypes['GeodataSpatialRefSysMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootupdateSpatialRefSysArgs, 'where'>>;
  updateSpatialRefSysByPk?: Resolver<Maybe<ResolversTypes['GeodataSpatialRefSys']>, ParentType, ContextType, RequireFields<geodatamutation_rootupdateSpatialRefSysByPkArgs, 'pkColumns'>>;
  updateSpatialRefSysMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['GeodataSpatialRefSysMutationResponse']>>>, ParentType, ContextType, RequireFields<geodatamutation_rootupdateSpatialRefSysManyArgs, 'updates'>>;
  updateZip?: Resolver<Maybe<ResolversTypes['GeodataZipMutationResponse']>, ParentType, ContextType, RequireFields<geodatamutation_rootupdateZipArgs, 'where'>>;
  updateZipByPk?: Resolver<Maybe<ResolversTypes['GeodataZip']>, ParentType, ContextType, RequireFields<geodatamutation_rootupdateZipByPkArgs, 'pkColumns'>>;
  updateZipMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['GeodataZipMutationResponse']>>>, ParentType, ContextType, RequireFields<geodatamutation_rootupdateZipManyArgs, 'updates'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type geodataquery_rootResolvers<ContextType = any, ParentType extends ResolversParentTypes['geodataquery_root'] = ResolversParentTypes['geodataquery_root']> = {
  address?: Resolver<Array<ResolversTypes['GeodataAddress']>, ParentType, ContextType, Partial<geodataquery_rootaddressArgs>>;
  addressAggregate?: Resolver<ResolversTypes['GeodataAddressAggregate'], ParentType, ContextType, Partial<geodataquery_rootaddressAggregateArgs>>;
  addressByPk?: Resolver<Maybe<ResolversTypes['GeodataAddress']>, ParentType, ContextType, RequireFields<geodataquery_rootaddressByPkArgs, 'id'>>;
  matrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode']>, ParentType, ContextType, Partial<geodataquery_rootmatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeArgs>>;
  matrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregate?: Resolver<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregate'], ParentType, ContextType, Partial<geodataquery_rootmatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregateArgs>>;
  matrikkelenadresseleilighetsnivaAtkomst?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomst']>, ParentType, ContextType, Partial<geodataquery_rootmatrikkelenadresseleilighetsnivaAtkomstArgs>>;
  matrikkelenadresseleilighetsnivaAtkomstAggregate?: Resolver<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregate'], ParentType, ContextType, Partial<geodataquery_rootmatrikkelenadresseleilighetsnivaAtkomstAggregateArgs>>;
  matrikkelenadresseleilighetsnivaKommunenummer?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaKommunenummer']>, ParentType, ContextType, Partial<geodataquery_rootmatrikkelenadresseleilighetsnivaKommunenummerArgs>>;
  matrikkelenadresseleilighetsnivaKommunenummerAggregate?: Resolver<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregate'], ParentType, ContextType, Partial<geodataquery_rootmatrikkelenadresseleilighetsnivaKommunenummerAggregateArgs>>;
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet']>, ParentType, ContextType, Partial<geodataquery_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetArgs>>;
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregate?: Resolver<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregate'], ParentType, ContextType, Partial<geodataquery_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregateArgs>>;
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid']>, ParentType, ContextType, Partial<geodataquery_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidArgs>>;
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregate?: Resolver<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregate'], ParentType, ContextType, Partial<geodataquery_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregateArgs>>;
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst']>, ParentType, ContextType, Partial<geodataquery_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstArgs>>;
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregate?: Resolver<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregate'], ParentType, ContextType, Partial<geodataquery_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregateArgs>>;
  matrikkelenadresseleilighetsnivaTypeatkomst?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaTypeatkomst']>, ParentType, ContextType, Partial<geodataquery_rootmatrikkelenadresseleilighetsnivaTypeatkomstArgs>>;
  matrikkelenadresseleilighetsnivaTypeatkomstAggregate?: Resolver<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregate'], ParentType, ContextType, Partial<geodataquery_rootmatrikkelenadresseleilighetsnivaTypeatkomstAggregateArgs>>;
  matrikkelenadresseleilighetsnivaVegadressebruksenhet?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhet']>, ParentType, ContextType, Partial<geodataquery_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetArgs>>;
  matrikkelenadresseleilighetsnivaVegadressebruksenhetAggregate?: Resolver<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregate'], ParentType, ContextType, Partial<geodataquery_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregateArgs>>;
  matrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid']>, ParentType, ContextType, Partial<geodataquery_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidArgs>>;
  matrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregate?: Resolver<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregate'], ParentType, ContextType, Partial<geodataquery_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregateArgs>>;
  matrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst']>, ParentType, ContextType, Partial<geodataquery_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstArgs>>;
  matrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregate?: Resolver<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregate'], ParentType, ContextType, Partial<geodataquery_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregateArgs>>;
  spatialRefSys?: Resolver<Array<ResolversTypes['GeodataSpatialRefSys']>, ParentType, ContextType, Partial<geodataquery_rootspatialRefSysArgs>>;
  spatialRefSysAggregate?: Resolver<ResolversTypes['GeodataSpatialRefSysAggregate'], ParentType, ContextType, Partial<geodataquery_rootspatialRefSysAggregateArgs>>;
  spatialRefSysByPk?: Resolver<Maybe<ResolversTypes['GeodataSpatialRefSys']>, ParentType, ContextType, RequireFields<geodataquery_rootspatialRefSysByPkArgs, 'srid'>>;
  zip?: Resolver<Array<ResolversTypes['GeodataZip']>, ParentType, ContextType, Partial<geodataquery_rootzipArgs>>;
  zipAggregate?: Resolver<ResolversTypes['GeodataZipAggregate'], ParentType, ContextType, Partial<geodataquery_rootzipAggregateArgs>>;
  zipByPk?: Resolver<Maybe<ResolversTypes['GeodataZip']>, ParentType, ContextType, RequireFields<geodataquery_rootzipByPkArgs, 'zip'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type geodatasubscription_rootResolvers<ContextType = any, ParentType extends ResolversParentTypes['geodatasubscription_root'] = ResolversParentTypes['geodatasubscription_root']> = {
  address?: Resolver<Array<ResolversTypes['GeodataAddress']>, ParentType, ContextType, Partial<geodatasubscription_rootaddressArgs>>;
  addressAggregate?: Resolver<ResolversTypes['GeodataAddressAggregate'], ParentType, ContextType, Partial<geodatasubscription_rootaddressAggregateArgs>>;
  addressByPk?: Resolver<Maybe<ResolversTypes['GeodataAddress']>, ParentType, ContextType, RequireFields<geodatasubscription_rootaddressByPkArgs, 'id'>>;
  addressStream?: Resolver<Array<ResolversTypes['GeodataAddress']>, ParentType, ContextType, RequireFields<geodatasubscription_rootaddressStreamArgs, 'batchSize' | 'cursor'>>;
  matrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode']>, ParentType, ContextType, Partial<geodatasubscription_rootmatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeArgs>>;
  matrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregate?: Resolver<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregate'], ParentType, ContextType, Partial<geodatasubscription_rootmatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregateArgs>>;
  matrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeStream?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode']>, ParentType, ContextType, RequireFields<geodatasubscription_rootmatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeStreamArgs, 'batchSize' | 'cursor'>>;
  matrikkelenadresseleilighetsnivaAtkomst?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomst']>, ParentType, ContextType, Partial<geodatasubscription_rootmatrikkelenadresseleilighetsnivaAtkomstArgs>>;
  matrikkelenadresseleilighetsnivaAtkomstAggregate?: Resolver<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregate'], ParentType, ContextType, Partial<geodatasubscription_rootmatrikkelenadresseleilighetsnivaAtkomstAggregateArgs>>;
  matrikkelenadresseleilighetsnivaAtkomstStream?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaAtkomst']>, ParentType, ContextType, RequireFields<geodatasubscription_rootmatrikkelenadresseleilighetsnivaAtkomstStreamArgs, 'batchSize' | 'cursor'>>;
  matrikkelenadresseleilighetsnivaKommunenummer?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaKommunenummer']>, ParentType, ContextType, Partial<geodatasubscription_rootmatrikkelenadresseleilighetsnivaKommunenummerArgs>>;
  matrikkelenadresseleilighetsnivaKommunenummerAggregate?: Resolver<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregate'], ParentType, ContextType, Partial<geodatasubscription_rootmatrikkelenadresseleilighetsnivaKommunenummerAggregateArgs>>;
  matrikkelenadresseleilighetsnivaKommunenummerStream?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaKommunenummer']>, ParentType, ContextType, RequireFields<geodatasubscription_rootmatrikkelenadresseleilighetsnivaKommunenummerStreamArgs, 'batchSize' | 'cursor'>>;
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet']>, ParentType, ContextType, Partial<geodatasubscription_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetArgs>>;
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregate?: Resolver<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregate'], ParentType, ContextType, Partial<geodatasubscription_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregateArgs>>;
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid']>, ParentType, ContextType, Partial<geodatasubscription_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidArgs>>;
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregate?: Resolver<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregate'], ParentType, ContextType, Partial<geodatasubscription_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregateArgs>>;
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStream?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid']>, ParentType, ContextType, RequireFields<geodatasubscription_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStreamArgs, 'batchSize' | 'cursor'>>;
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStream?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet']>, ParentType, ContextType, RequireFields<geodatasubscription_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStreamArgs, 'batchSize' | 'cursor'>>;
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst']>, ParentType, ContextType, Partial<geodatasubscription_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstArgs>>;
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregate?: Resolver<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregate'], ParentType, ContextType, Partial<geodatasubscription_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregateArgs>>;
  matrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStream?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst']>, ParentType, ContextType, RequireFields<geodatasubscription_rootmatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStreamArgs, 'batchSize' | 'cursor'>>;
  matrikkelenadresseleilighetsnivaTypeatkomst?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaTypeatkomst']>, ParentType, ContextType, Partial<geodatasubscription_rootmatrikkelenadresseleilighetsnivaTypeatkomstArgs>>;
  matrikkelenadresseleilighetsnivaTypeatkomstAggregate?: Resolver<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregate'], ParentType, ContextType, Partial<geodatasubscription_rootmatrikkelenadresseleilighetsnivaTypeatkomstAggregateArgs>>;
  matrikkelenadresseleilighetsnivaTypeatkomstStream?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaTypeatkomst']>, ParentType, ContextType, RequireFields<geodatasubscription_rootmatrikkelenadresseleilighetsnivaTypeatkomstStreamArgs, 'batchSize' | 'cursor'>>;
  matrikkelenadresseleilighetsnivaVegadressebruksenhet?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhet']>, ParentType, ContextType, Partial<geodatasubscription_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetArgs>>;
  matrikkelenadresseleilighetsnivaVegadressebruksenhetAggregate?: Resolver<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregate'], ParentType, ContextType, Partial<geodatasubscription_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregateArgs>>;
  matrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid']>, ParentType, ContextType, Partial<geodatasubscription_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidArgs>>;
  matrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregate?: Resolver<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregate'], ParentType, ContextType, Partial<geodatasubscription_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregateArgs>>;
  matrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStream?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid']>, ParentType, ContextType, RequireFields<geodatasubscription_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStreamArgs, 'batchSize' | 'cursor'>>;
  matrikkelenadresseleilighetsnivaVegadressebruksenhetStream?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhet']>, ParentType, ContextType, RequireFields<geodatasubscription_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetStreamArgs, 'batchSize' | 'cursor'>>;
  matrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst']>, ParentType, ContextType, Partial<geodatasubscription_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstArgs>>;
  matrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregate?: Resolver<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregate'], ParentType, ContextType, Partial<geodatasubscription_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregateArgs>>;
  matrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStream?: Resolver<Array<ResolversTypes['GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst']>, ParentType, ContextType, RequireFields<geodatasubscription_rootmatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStreamArgs, 'batchSize' | 'cursor'>>;
  spatialRefSys?: Resolver<Array<ResolversTypes['GeodataSpatialRefSys']>, ParentType, ContextType, Partial<geodatasubscription_rootspatialRefSysArgs>>;
  spatialRefSysAggregate?: Resolver<ResolversTypes['GeodataSpatialRefSysAggregate'], ParentType, ContextType, Partial<geodatasubscription_rootspatialRefSysAggregateArgs>>;
  spatialRefSysByPk?: Resolver<Maybe<ResolversTypes['GeodataSpatialRefSys']>, ParentType, ContextType, RequireFields<geodatasubscription_rootspatialRefSysByPkArgs, 'srid'>>;
  spatialRefSysStream?: Resolver<Array<ResolversTypes['GeodataSpatialRefSys']>, ParentType, ContextType, RequireFields<geodatasubscription_rootspatialRefSysStreamArgs, 'batchSize' | 'cursor'>>;
  zip?: Resolver<Array<ResolversTypes['GeodataZip']>, ParentType, ContextType, Partial<geodatasubscription_rootzipArgs>>;
  zipAggregate?: Resolver<ResolversTypes['GeodataZipAggregate'], ParentType, ContextType, Partial<geodatasubscription_rootzipAggregateArgs>>;
  zipByPk?: Resolver<Maybe<ResolversTypes['GeodataZip']>, ParentType, ContextType, RequireFields<geodatasubscription_rootzipByPkArgs, 'zip'>>;
  zipStream?: Resolver<Array<ResolversTypes['GeodataZip']>, ParentType, ContextType, RequireFields<geodatasubscription_rootzipStreamArgs, 'batchSize' | 'cursor'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type getEmailAccountOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['getEmailAccountOutput'] = ResolversParentTypes['getEmailAccountOutput']> = {
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  idToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  linkedAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  refreshToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subscriptionExpiration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ProviderTypeEmail'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type incomingSmsResolvers<ContextType = any, ParentType extends ResolversParentTypes['incomingSms'] = ResolversParentTypes['incomingSms']> = {
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  errors?: Resolver<Maybe<ResolversTypes['json']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  output?: Resolver<Maybe<ResolversTypes['IncomingSMSOutput']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type inviteOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['inviteOutput'] = ResolversParentTypes['inviteOutput']> = {
  result?: Resolver<ResolversTypes['json'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface jsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['json'], any> {
  name: 'json';
}

export interface jsonbScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['jsonb'], any> {
  name: 'jsonb';
}

export type languagesResolvers<ContextType = any, ParentType extends ResolversParentTypes['languages'] = ResolversParentTypes['languages']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type languagesAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['languagesAggregate'] = ResolversParentTypes['languagesAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['languagesAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['languages']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type languagesAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['languagesAggregateFields'] = ResolversParentTypes['languagesAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<languagesAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['languagesMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['languagesMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type languagesMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['languagesMaxFields'] = ResolversParentTypes['languagesMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type languagesMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['languagesMinFields'] = ResolversParentTypes['languagesMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type languagesMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['languagesMutationResponse'] = ResolversParentTypes['languagesMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['languages']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type leaveOrganizationOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['leaveOrganizationOutput'] = ResolversParentTypes['leaveOrganizationOutput']> = {
  result?: Resolver<ResolversTypes['jsonb'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messageResolvers<ContextType = any, ParentType extends ResolversParentTypes['message'] = ResolversParentTypes['message']> = {
  activity?: Resolver<Maybe<ResolversTypes['domainActivity']>, ParentType, ContextType>;
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  attachments?: Resolver<Array<ResolversTypes['BusinessMessageAttachments']>, ParentType, ContextType, Partial<messageattachmentsArgs>>;
  attachmentsAggregate?: Resolver<ResolversTypes['BusinessMessageAttachmentsAggregate'], ParentType, ContextType, Partial<messageattachmentsAggregateArgs>>;
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  messageType?: Resolver<Maybe<ResolversTypes['messageType']>, ParentType, ContextType>;
  system?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['messageTypeEnum']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messageAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['messageAggregate'] = ResolversParentTypes['messageAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['messageAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['message']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messageAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messageAggregateFields'] = ResolversParentTypes['messageAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<messageAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['messageMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['messageMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messageMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messageMaxFields'] = ResolversParentTypes['messageMaxFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messageMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messageMinFields'] = ResolversParentTypes['messageMinFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messageMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['messageMutationResponse'] = ResolversParentTypes['messageMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['message']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messageTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['messageType'] = ResolversParentTypes['messageType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messageTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['messageTypeAggregate'] = ResolversParentTypes['messageTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['messageTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['messageType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messageTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messageTypeAggregateFields'] = ResolversParentTypes['messageTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<messageTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['messageTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['messageTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messageTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messageTypeMaxFields'] = ResolversParentTypes['messageTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messageTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messageTypeMinFields'] = ResolversParentTypes['messageTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messageTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['messageTypeMutationResponse'] = ResolversParentTypes['messageTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['messageType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivity'] = ResolversParentTypes['messagingActivity']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  activityOrganizations?: Resolver<Array<ResolversTypes['messagingActivityOrganization']>, ParentType, ContextType, Partial<messagingActivityactivityOrganizationsArgs>>;
  activityOrganizationsAggregate?: Resolver<ResolversTypes['messagingActivityOrganizationAggregate'], ParentType, ContextType, Partial<messagingActivityactivityOrganizationsAggregateArgs>>;
  activityType?: Resolver<Maybe<ResolversTypes['messagingActivityTypeEnum']>, ParentType, ContextType>;
  activityUsers?: Resolver<Array<ResolversTypes['messagingActivityUser']>, ParentType, ContextType, Partial<messagingActivityactivityUsersArgs>>;
  activityUsersAggregate?: Resolver<ResolversTypes['messagingActivityUserAggregate'], ParentType, ContextType, Partial<messagingActivityactivityUsersAggregateArgs>>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  endedAt?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  invitations?: Resolver<Array<ResolversTypes['MessagingInvitation']>, ParentType, ContextType, Partial<messagingActivityinvitationsArgs>>;
  invitationsAggregate?: Resolver<ResolversTypes['MessagingInvitationAggregate'], ParentType, ContextType, Partial<messagingActivityinvitationsAggregateArgs>>;
  messages?: Resolver<Array<ResolversTypes['messagingMessage']>, ParentType, ContextType, Partial<messagingActivitymessagesArgs>>;
  messagesAggregate?: Resolver<ResolversTypes['messagingMessageAggregate'], ParentType, ContextType, Partial<messagingActivitymessagesAggregateArgs>>;
  owner?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  settings?: Resolver<Maybe<ResolversTypes['MessagingActivitySettings']>, ParentType, ContextType>;
  startedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityAggregate'] = ResolversParentTypes['messagingActivityAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['messagingActivityAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['messagingActivity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityAggregateFields'] = ResolversParentTypes['messagingActivityAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<messagingActivityAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['messagingActivityMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['messagingActivityMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityMaxFields'] = ResolversParentTypes['messagingActivityMaxFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  endedAt?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  startedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityMinFields'] = ResolversParentTypes['messagingActivityMinFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  endedAt?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  startedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityMutationResponse'] = ResolversParentTypes['messagingActivityMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['messagingActivity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityOrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityOrganization'] = ResolversParentTypes['messagingActivityOrganization']> = {
  activity?: Resolver<ResolversTypes['messagingActivity'], ParentType, ContextType>;
  activityId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  organization?: Resolver<Maybe<ResolversTypes['organization']>, ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityOrganizationAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityOrganizationAggregate'] = ResolversParentTypes['messagingActivityOrganizationAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['messagingActivityOrganizationAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['messagingActivityOrganization']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityOrganizationAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityOrganizationAggregateFields'] = ResolversParentTypes['messagingActivityOrganizationAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<messagingActivityOrganizationAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['messagingActivityOrganizationMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['messagingActivityOrganizationMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityOrganizationMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityOrganizationMaxFields'] = ResolversParentTypes['messagingActivityOrganizationMaxFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityOrganizationMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityOrganizationMinFields'] = ResolversParentTypes['messagingActivityOrganizationMinFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityOrganizationMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityOrganizationMutationResponse'] = ResolversParentTypes['messagingActivityOrganizationMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['messagingActivityOrganization']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityType'] = ResolversParentTypes['messagingActivityType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityTypeAggregate'] = ResolversParentTypes['messagingActivityTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['messagingActivityTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['messagingActivityType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityTypeAggregateFields'] = ResolversParentTypes['messagingActivityTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<messagingActivityTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['messagingActivityTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['messagingActivityTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityTypeMaxFields'] = ResolversParentTypes['messagingActivityTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityTypeMinFields'] = ResolversParentTypes['messagingActivityTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityTypeMutationResponse'] = ResolversParentTypes['messagingActivityTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['messagingActivityType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityUser'] = ResolversParentTypes['messagingActivityUser']> = {
  activity?: Resolver<ResolversTypes['messagingActivity'], ParentType, ContextType>;
  activityId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  unreadImportantMessages?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  unreadMessages?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['user'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityUserAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityUserAggregate'] = ResolversParentTypes['messagingActivityUserAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['messagingActivityUserAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['messagingActivityUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityUserAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityUserAggregateFields'] = ResolversParentTypes['messagingActivityUserAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['messagingActivityUserAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<messagingActivityUserAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['messagingActivityUserMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['messagingActivityUserMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['messagingActivityUserStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['messagingActivityUserStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['messagingActivityUserStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['messagingActivityUserSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['messagingActivityUserVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['messagingActivityUserVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['messagingActivityUserVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityUserAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityUserAvgFields'] = ResolversParentTypes['messagingActivityUserAvgFields']> = {
  unreadImportantMessages?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  unreadMessages?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityUserMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityUserMaxFields'] = ResolversParentTypes['messagingActivityUserMaxFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  unreadImportantMessages?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  unreadMessages?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityUserMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityUserMinFields'] = ResolversParentTypes['messagingActivityUserMinFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  unreadImportantMessages?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  unreadMessages?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityUserMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityUserMutationResponse'] = ResolversParentTypes['messagingActivityUserMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['messagingActivityUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityUserStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityUserStddevFields'] = ResolversParentTypes['messagingActivityUserStddevFields']> = {
  unreadImportantMessages?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  unreadMessages?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityUserStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityUserStddevPopFields'] = ResolversParentTypes['messagingActivityUserStddevPopFields']> = {
  unreadImportantMessages?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  unreadMessages?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityUserStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityUserStddevSampFields'] = ResolversParentTypes['messagingActivityUserStddevSampFields']> = {
  unreadImportantMessages?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  unreadMessages?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityUserSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityUserSumFields'] = ResolversParentTypes['messagingActivityUserSumFields']> = {
  unreadImportantMessages?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  unreadMessages?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityUserVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityUserVarPopFields'] = ResolversParentTypes['messagingActivityUserVarPopFields']> = {
  unreadImportantMessages?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  unreadMessages?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityUserVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityUserVarSampFields'] = ResolversParentTypes['messagingActivityUserVarSampFields']> = {
  unreadImportantMessages?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  unreadMessages?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingActivityUserVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingActivityUserVarianceFields'] = ResolversParentTypes['messagingActivityUserVarianceFields']> = {
  unreadImportantMessages?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  unreadMessages?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingMessage'] = ResolversParentTypes['messagingMessage']> = {
  activity?: Resolver<Maybe<ResolversTypes['messagingActivity']>, ParentType, ContextType>;
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  important?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  mentions?: Resolver<Array<ResolversTypes['MessagingMentions']>, ParentType, ContextType, Partial<messagingMessagementionsArgs>>;
  mentionsAggregate?: Resolver<ResolversTypes['MessagingMentionsAggregate'], ParentType, ContextType, Partial<messagingMessagementionsAggregateArgs>>;
  messageAttachments?: Resolver<Array<ResolversTypes['MessagingMessageAttachment']>, ParentType, ContextType, Partial<messagingMessagemessageAttachmentsArgs>>;
  messageAttachmentsAggregate?: Resolver<ResolversTypes['MessagingMessageAttachmentAggregate'], ParentType, ContextType, Partial<messagingMessagemessageAttachmentsAggregateArgs>>;
  messageEmojis?: Resolver<Array<ResolversTypes['messagingMessageEmoji']>, ParentType, ContextType, Partial<messagingMessagemessageEmojisArgs>>;
  messageEmojisAggregate?: Resolver<ResolversTypes['messagingMessageEmojiAggregate'], ParentType, ContextType, Partial<messagingMessagemessageEmojisAggregateArgs>>;
  messageReadsAggregate?: Resolver<ResolversTypes['messagingMessageReadAggregate'], ParentType, ContextType, Partial<messagingMessagemessageReadsAggregateArgs>>;
  message_attachments?: Resolver<Array<ResolversTypes['MessagingMessageAttachment']>, ParentType, ContextType, Partial<messagingMessagemessage_attachmentsArgs>>;
  message_reads?: Resolver<Array<ResolversTypes['messagingMessageRead']>, ParentType, ContextType, Partial<messagingMessagemessage_readsArgs>>;
  priority?: Resolver<Maybe<ResolversTypes['MessagingMessagePriorityEnum']>, ParentType, ContextType>;
  system?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['messagingMessageTypeEnum']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  userTable?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingMessageAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingMessageAggregate'] = ResolversParentTypes['messagingMessageAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['messagingMessageAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['messagingMessage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingMessageAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingMessageAggregateFields'] = ResolversParentTypes['messagingMessageAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<messagingMessageAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['messagingMessageMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['messagingMessageMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingMessageEmojiResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingMessageEmoji'] = ResolversParentTypes['messagingMessageEmoji']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  emoji?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['messagingMessage'], ParentType, ContextType>;
  messageId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingMessageEmojiAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingMessageEmojiAggregate'] = ResolversParentTypes['messagingMessageEmojiAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['messagingMessageEmojiAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['messagingMessageEmoji']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingMessageEmojiAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingMessageEmojiAggregateFields'] = ResolversParentTypes['messagingMessageEmojiAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<messagingMessageEmojiAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['messagingMessageEmojiMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['messagingMessageEmojiMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingMessageEmojiMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingMessageEmojiMaxFields'] = ResolversParentTypes['messagingMessageEmojiMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  emoji?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  messageId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingMessageEmojiMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingMessageEmojiMinFields'] = ResolversParentTypes['messagingMessageEmojiMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  emoji?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  messageId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingMessageEmojiMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingMessageEmojiMutationResponse'] = ResolversParentTypes['messagingMessageEmojiMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['messagingMessageEmoji']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingMessageMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingMessageMaxFields'] = ResolversParentTypes['messagingMessageMaxFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingMessageMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingMessageMinFields'] = ResolversParentTypes['messagingMessageMinFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingMessageMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingMessageMutationResponse'] = ResolversParentTypes['messagingMessageMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['messagingMessage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingMessageReadResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingMessageRead'] = ResolversParentTypes['messagingMessageRead']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['messagingMessage'], ParentType, ContextType>;
  messageId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  read?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingMessageReadAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingMessageReadAggregate'] = ResolversParentTypes['messagingMessageReadAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['messagingMessageReadAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['messagingMessageRead']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingMessageReadAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingMessageReadAggregateFields'] = ResolversParentTypes['messagingMessageReadAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<messagingMessageReadAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['messagingMessageReadMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['messagingMessageReadMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingMessageReadMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingMessageReadMaxFields'] = ResolversParentTypes['messagingMessageReadMaxFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  messageId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingMessageReadMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingMessageReadMinFields'] = ResolversParentTypes['messagingMessageReadMinFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  messageId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingMessageReadMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingMessageReadMutationResponse'] = ResolversParentTypes['messagingMessageReadMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['messagingMessageRead']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingMessageTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingMessageType'] = ResolversParentTypes['messagingMessageType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingMessageTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingMessageTypeAggregate'] = ResolversParentTypes['messagingMessageTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['messagingMessageTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['messagingMessageType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingMessageTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingMessageTypeAggregateFields'] = ResolversParentTypes['messagingMessageTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<messagingMessageTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['messagingMessageTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['messagingMessageTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingMessageTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingMessageTypeMaxFields'] = ResolversParentTypes['messagingMessageTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingMessageTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingMessageTypeMinFields'] = ResolversParentTypes['messagingMessageTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type messagingMessageTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['messagingMessageTypeMutationResponse'] = ResolversParentTypes['messagingMessageTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['messagingMessageType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type mutation_rootResolvers<ContextType = any, ParentType extends ResolversParentTypes['mutation_root'] = ResolversParentTypes['mutation_root']> = {
  acceptInviteToOrganization?: Resolver<Maybe<ResolversTypes['acceptInviteOutput']>, ParentType, ContextType, RequireFields<mutation_rootacceptInviteToOrganizationArgs, 'input'>>;
  acceptRequestToOrganization?: Resolver<Maybe<ResolversTypes['acceptRequestsOutput']>, ParentType, ContextType, RequireFields<mutation_rootacceptRequestToOrganizationArgs, 'input'>>;
  addDomainUserToOrganization?: Resolver<Maybe<ResolversTypes['AddDomainUserToOrganizationOutput']>, ParentType, ContextType, RequireFields<mutation_rootaddDomainUserToOrganizationArgs, 'domainUserId'>>;
  addEmailProviderIntegration?: Resolver<Maybe<Array<Maybe<ResolversTypes['emailDomainUserOutput']>>>, ParentType, ContextType, RequireFields<mutation_rootaddEmailProviderIntegrationArgs, 'integration'>>;
  addEmailProviderSubscription?: Resolver<Maybe<Array<Maybe<ResolversTypes['createEmailProviderSubscriptionOutput']>>>, ParentType, ContextType, RequireFields<mutation_rootaddEmailProviderSubscriptionArgs, 'integration'>>;
  blockDomainUser?: Resolver<Maybe<ResolversTypes['BlockUserOutput']>, ParentType, ContextType, RequireFields<mutation_rootblockDomainUserArgs, 'blockedDomainUserId' | 'domainUserId'>>;
  breg?: Resolver<Maybe<ResolversTypes['bregmutation_root']>, ParentType, ContextType>;
  callBackLater?: Resolver<Maybe<ResolversTypes['callBackLaterResult']>, ParentType, ContextType, RequireFields<mutation_rootcallBackLaterArgs, 'id'>>;
  changeOrganizationName?: Resolver<Maybe<ResolversTypes['ChangeOrganizationNameOutput']>, ParentType, ContextType, RequireFields<mutation_rootchangeOrganizationNameArgs, 'params'>>;
  checkOneTimeCode?: Resolver<Maybe<ResolversTypes['CheckOnetimeCodeOutput']>, ParentType, ContextType, Partial<mutation_rootcheckOneTimeCodeArgs>>;
  checkPhoneNumber?: Resolver<Maybe<ResolversTypes['CheckPhoneNumberOutput']>, ParentType, ContextType, RequireFields<mutation_rootcheckPhoneNumberArgs, 'country'>>;
  checkTelephonyId?: Resolver<Maybe<ResolversTypes['checkTelephonyIdOutput']>, ParentType, ContextType, RequireFields<mutation_rootcheckTelephonyIdArgs, 'orgId'>>;
  createActivityParticipant?: Resolver<Maybe<ResolversTypes['activityParticipant']>, ParentType, ContextType, RequireFields<mutation_rootcreateActivityParticipantArgs, 'object'>>;
  createActivityParticipants?: Resolver<Maybe<ResolversTypes['activityParticipantMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateActivityParticipantsArgs, 'objects'>>;
  createActivityStatus?: Resolver<Maybe<ResolversTypes['ActivityStatus']>, ParentType, ContextType, RequireFields<mutation_rootcreateActivityStatusArgs, 'object'>>;
  createActivityStatuses?: Resolver<Maybe<ResolversTypes['ActivityStatusMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateActivityStatusesArgs, 'objects'>>;
  createActivityTask?: Resolver<Maybe<ResolversTypes['activityTaskOutput']>, ParentType, ContextType, RequireFields<mutation_rootcreateActivityTaskArgs, 'input'>>;
  createActivityType?: Resolver<Maybe<ResolversTypes['ActivityType']>, ParentType, ContextType, RequireFields<mutation_rootcreateActivityTypeArgs, 'object'>>;
  createActivityTypes?: Resolver<Maybe<ResolversTypes['ActivityTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateActivityTypesArgs, 'objects'>>;
  createAddress?: Resolver<Maybe<ResolversTypes['address']>, ParentType, ContextType, RequireFields<mutation_rootcreateAddressArgs, 'object'>>;
  createAddresses?: Resolver<Maybe<ResolversTypes['addressMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateAddressesArgs, 'objects'>>;
  createBlockedDomainUser?: Resolver<Maybe<ResolversTypes['blockedDomainUser']>, ParentType, ContextType, RequireFields<mutation_rootcreateBlockedDomainUserArgs, 'object'>>;
  createBlockedDomainUsers?: Resolver<Maybe<ResolversTypes['blockedDomainUserMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateBlockedDomainUsersArgs, 'objects'>>;
  createBusinessQueueItemCollaboration?: Resolver<Maybe<ResolversTypes['businessQueueItemCollaboration']>, ParentType, ContextType, RequireFields<mutation_rootcreateBusinessQueueItemCollaborationArgs, 'object'>>;
  createBusinessQueueItemCollaborations?: Resolver<Maybe<ResolversTypes['businessQueueItemCollaborationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateBusinessQueueItemCollaborationsArgs, 'objects'>>;
  createBusinessUserContact?: Resolver<Maybe<ResolversTypes['businessUserContacts']>, ParentType, ContextType, RequireFields<mutation_rootcreateBusinessUserContactArgs, 'object'>>;
  createBusinessUserContacts?: Resolver<Maybe<ResolversTypes['businessUserContactsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateBusinessUserContactsArgs, 'objects'>>;
  createBusinessUserSetting?: Resolver<Maybe<ResolversTypes['businessUserSettings']>, ParentType, ContextType, RequireFields<mutation_rootcreateBusinessUserSettingArgs, 'object'>>;
  createBusinessUserSettings?: Resolver<Maybe<ResolversTypes['businessUserSettingsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateBusinessUserSettingsArgs, 'objects'>>;
  createCrmStatusMessage?: Resolver<Maybe<ResolversTypes['crmStatusMessage']>, ParentType, ContextType, RequireFields<mutation_rootcreateCrmStatusMessageArgs, 'object'>>;
  createCrmStatusMessages?: Resolver<Maybe<ResolversTypes['crmStatusMessageMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateCrmStatusMessagesArgs, 'objects'>>;
  createCrmYoutelloCatalystIdMapping?: Resolver<Maybe<ResolversTypes['crmYoutelloCatalystIdMapping']>, ParentType, ContextType, RequireFields<mutation_rootcreateCrmYoutelloCatalystIdMappingArgs, 'object'>>;
  createCrmYoutelloCatalystIdMappings?: Resolver<Maybe<ResolversTypes['crmYoutelloCatalystIdMappingMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateCrmYoutelloCatalystIdMappingsArgs, 'objects'>>;
  createDomainActivities?: Resolver<Maybe<ResolversTypes['domainActivityMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateDomainActivitiesArgs, 'objects'>>;
  createDomainActivity?: Resolver<Maybe<ResolversTypes['domainActivity']>, ParentType, ContextType, RequireFields<mutation_rootcreateDomainActivityArgs, 'object'>>;
  createDomainOrganization?: Resolver<Maybe<ResolversTypes['domainOrganization']>, ParentType, ContextType, RequireFields<mutation_rootcreateDomainOrganizationArgs, 'object'>>;
  createDomainOrganizations?: Resolver<Maybe<ResolversTypes['domainOrganizationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateDomainOrganizationsArgs, 'objects'>>;
  createDomainParticipant?: Resolver<Maybe<ResolversTypes['domainParticipant']>, ParentType, ContextType, RequireFields<mutation_rootcreateDomainParticipantArgs, 'object'>>;
  createDomainParticipants?: Resolver<Maybe<ResolversTypes['domainParticipantMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateDomainParticipantsArgs, 'objects'>>;
  createDomainType?: Resolver<Maybe<ResolversTypes['domainType']>, ParentType, ContextType, RequireFields<mutation_rootcreateDomainTypeArgs, 'object'>>;
  createDomainTypes?: Resolver<Maybe<ResolversTypes['domainTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateDomainTypesArgs, 'objects'>>;
  createDomainUser?: Resolver<Maybe<ResolversTypes['domainUser']>, ParentType, ContextType, RequireFields<mutation_rootcreateDomainUserArgs, 'object'>>;
  createDomainUserCategories?: Resolver<Maybe<ResolversTypes['domainUserCategoryMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateDomainUserCategoriesArgs, 'objects'>>;
  createDomainUserCategory?: Resolver<Maybe<ResolversTypes['domainUserCategory']>, ParentType, ContextType, RequireFields<mutation_rootcreateDomainUserCategoryArgs, 'object'>>;
  createDomainUsers?: Resolver<Maybe<ResolversTypes['domainUserMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateDomainUsersArgs, 'objects'>>;
  createInviteToOrganization?: Resolver<Maybe<ResolversTypes['inviteOutput']>, ParentType, ContextType, RequireFields<mutation_rootcreateInviteToOrganizationArgs, 'input'>>;
  createMessage?: Resolver<Maybe<ResolversTypes['message']>, ParentType, ContextType, RequireFields<mutation_rootcreateMessageArgs, 'object'>>;
  createMessageType?: Resolver<Maybe<ResolversTypes['messageType']>, ParentType, ContextType, RequireFields<mutation_rootcreateMessageTypeArgs, 'object'>>;
  createMessageTypes?: Resolver<Maybe<ResolversTypes['messageTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateMessageTypesArgs, 'objects'>>;
  createMessages?: Resolver<Maybe<ResolversTypes['messageMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateMessagesArgs, 'objects'>>;
  createMessagingActivities?: Resolver<Maybe<ResolversTypes['messagingActivityMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateMessagingActivitiesArgs, 'objects'>>;
  createMessagingActivity?: Resolver<Maybe<ResolversTypes['messagingActivity']>, ParentType, ContextType, RequireFields<mutation_rootcreateMessagingActivityArgs, 'object'>>;
  createMessagingActivityOrganization?: Resolver<Maybe<ResolversTypes['messagingActivityOrganization']>, ParentType, ContextType, RequireFields<mutation_rootcreateMessagingActivityOrganizationArgs, 'object'>>;
  createMessagingActivityOrganizations?: Resolver<Maybe<ResolversTypes['messagingActivityOrganizationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateMessagingActivityOrganizationsArgs, 'objects'>>;
  createMessagingActivityType?: Resolver<Maybe<ResolversTypes['messagingActivityType']>, ParentType, ContextType, RequireFields<mutation_rootcreateMessagingActivityTypeArgs, 'object'>>;
  createMessagingActivityTypes?: Resolver<Maybe<ResolversTypes['messagingActivityTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateMessagingActivityTypesArgs, 'objects'>>;
  createMessagingActivityUser?: Resolver<Maybe<ResolversTypes['messagingActivityUser']>, ParentType, ContextType, RequireFields<mutation_rootcreateMessagingActivityUserArgs, 'object'>>;
  createMessagingActivityUsers?: Resolver<Maybe<ResolversTypes['messagingActivityUserMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateMessagingActivityUsersArgs, 'objects'>>;
  createMessagingGroup?: Resolver<Maybe<ResolversTypes['createMessagingGroupOutput']>, ParentType, ContextType, RequireFields<mutation_rootcreateMessagingGroupArgs, 'members' | 'roomName'>>;
  createMessagingMessage?: Resolver<Maybe<ResolversTypes['messagingMessage']>, ParentType, ContextType, RequireFields<mutation_rootcreateMessagingMessageArgs, 'object'>>;
  createMessagingMessageEmoji?: Resolver<Maybe<ResolversTypes['messagingMessageEmoji']>, ParentType, ContextType, RequireFields<mutation_rootcreateMessagingMessageEmojiArgs, 'object'>>;
  createMessagingMessageEmojis?: Resolver<Maybe<ResolversTypes['messagingMessageEmojiMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateMessagingMessageEmojisArgs, 'objects'>>;
  createMessagingMessageRead?: Resolver<Maybe<ResolversTypes['messagingMessageRead']>, ParentType, ContextType, RequireFields<mutation_rootcreateMessagingMessageReadArgs, 'object'>>;
  createMessagingMessageReads?: Resolver<Maybe<ResolversTypes['messagingMessageReadMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateMessagingMessageReadsArgs, 'objects'>>;
  createMessagingMessageType?: Resolver<Maybe<ResolversTypes['messagingMessageType']>, ParentType, ContextType, RequireFields<mutation_rootcreateMessagingMessageTypeArgs, 'object'>>;
  createMessagingMessageTypes?: Resolver<Maybe<ResolversTypes['messagingMessageTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateMessagingMessageTypesArgs, 'objects'>>;
  createMessagingMessages?: Resolver<Maybe<ResolversTypes['messagingMessageMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateMessagingMessagesArgs, 'objects'>>;
  createNotification?: Resolver<Maybe<ResolversTypes['notification']>, ParentType, ContextType, RequireFields<mutation_rootcreateNotificationArgs, 'object'>>;
  createNotificationSend?: Resolver<Maybe<ResolversTypes['notificationSend']>, ParentType, ContextType, RequireFields<mutation_rootcreateNotificationSendArgs, 'object'>>;
  createNotificationSends?: Resolver<Maybe<ResolversTypes['notificationSendMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateNotificationSendsArgs, 'objects'>>;
  createNotificationSettingActivities?: Resolver<Maybe<ResolversTypes['notificationSettingActivityMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateNotificationSettingActivitiesArgs, 'objects'>>;
  createNotificationSettingActivity?: Resolver<Maybe<ResolversTypes['notificationSettingActivity']>, ParentType, ContextType, RequireFields<mutation_rootcreateNotificationSettingActivityArgs, 'object'>>;
  createNotificationUser?: Resolver<Maybe<ResolversTypes['notificationUser']>, ParentType, ContextType, RequireFields<mutation_rootcreateNotificationUserArgs, 'object'>>;
  createNotificationUserDevice?: Resolver<Maybe<ResolversTypes['notificationUserDevice']>, ParentType, ContextType, RequireFields<mutation_rootcreateNotificationUserDeviceArgs, 'object'>>;
  createNotificationUserDevices?: Resolver<Maybe<ResolversTypes['notificationUserDeviceMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateNotificationUserDevicesArgs, 'objects'>>;
  createNotificationUsers?: Resolver<Maybe<ResolversTypes['notificationUserMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateNotificationUsersArgs, 'objects'>>;
  createNotifications?: Resolver<Maybe<ResolversTypes['notificationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateNotificationsArgs, 'objects'>>;
  createOrdersIntegration?: Resolver<Maybe<ResolversTypes['ordersIntegrations']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrdersIntegrationArgs, 'object'>>;
  createOrdersIntegrations?: Resolver<Maybe<ResolversTypes['ordersIntegrationsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrdersIntegrationsArgs, 'objects'>>;
  createOrganization?: Resolver<Maybe<ResolversTypes['organization']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationArgs, 'object'>>;
  createOrganizationAuthorizationEnumGroup?: Resolver<Maybe<ResolversTypes['organizationAuthorizationEnumGroup']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationAuthorizationEnumGroupArgs, 'object'>>;
  createOrganizationAuthorizationEnumGroups?: Resolver<Maybe<ResolversTypes['organizationAuthorizationEnumGroupMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationAuthorizationEnumGroupsArgs, 'objects'>>;
  createOrganizationAuthorizationGroup?: Resolver<Maybe<ResolversTypes['organizationAuthorizationGroup']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationAuthorizationGroupArgs, 'object'>>;
  createOrganizationAuthorizationGroups?: Resolver<Maybe<ResolversTypes['organizationAuthorizationGroupMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationAuthorizationGroupsArgs, 'objects'>>;
  createOrganizationOrganizationRelationship?: Resolver<Maybe<ResolversTypes['organizationOrganizationRelationship']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationOrganizationRelationshipArgs, 'object'>>;
  createOrganizationOrganizationRelationshipCategories?: Resolver<Maybe<ResolversTypes['organizationOrganizationRelationshipCategoryMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationOrganizationRelationshipCategoriesArgs, 'objects'>>;
  createOrganizationOrganizationRelationshipCategory?: Resolver<Maybe<ResolversTypes['organizationOrganizationRelationshipCategory']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationOrganizationRelationshipCategoryArgs, 'object'>>;
  createOrganizationOrganizationRelationships?: Resolver<Maybe<ResolversTypes['organizationOrganizationRelationshipMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationOrganizationRelationshipsArgs, 'objects'>>;
  createOrganizationOrganizationUserAuthorization?: Resolver<Maybe<ResolversTypes['organizationOrganizationUserAuthorization']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationOrganizationUserAuthorizationArgs, 'object'>>;
  createOrganizationOrganizationUserAuthorizations?: Resolver<Maybe<ResolversTypes['organizationOrganizationUserAuthorizationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationOrganizationUserAuthorizationsArgs, 'objects'>>;
  createOrganizationUser?: Resolver<Maybe<ResolversTypes['organizationUser']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationUserArgs, 'object'>>;
  createOrganizationUserAttachment?: Resolver<Maybe<ResolversTypes['organizationUserAttachments']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationUserAttachmentArgs, 'object'>>;
  createOrganizationUserAttachments?: Resolver<Maybe<ResolversTypes['organizationUserAttachmentsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationUserAttachmentsArgs, 'objects'>>;
  createOrganizationUserAttentionNote?: Resolver<Maybe<ResolversTypes['OrganizationUserAttentionNote']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationUserAttentionNoteArgs, 'object'>>;
  createOrganizationUserAttentionNotes?: Resolver<Maybe<ResolversTypes['OrganizationUserAttentionNoteMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationUserAttentionNotesArgs, 'objects'>>;
  createOrganizationUserAuthorization?: Resolver<Maybe<ResolversTypes['organizationUserAuthorization']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationUserAuthorizationArgs, 'object'>>;
  createOrganizationUserAuthorizations?: Resolver<Maybe<ResolversTypes['organizationUserAuthorizationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationUserAuthorizationsArgs, 'objects'>>;
  createOrganizationUserDetail?: Resolver<Maybe<ResolversTypes['organizationUserDetail']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationUserDetailArgs, 'object'>>;
  createOrganizationUserDetailType?: Resolver<Maybe<ResolversTypes['organizationUserDetailType']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationUserDetailTypeArgs, 'object'>>;
  createOrganizationUserDetailTypes?: Resolver<Maybe<ResolversTypes['organizationUserDetailTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationUserDetailTypesArgs, 'objects'>>;
  createOrganizationUserDetails?: Resolver<Maybe<ResolversTypes['organizationUserDetailMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationUserDetailsArgs, 'objects'>>;
  createOrganizationUserInvite?: Resolver<Maybe<ResolversTypes['organizationUserInvite']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationUserInviteArgs, 'object'>>;
  createOrganizationUserInvites?: Resolver<Maybe<ResolversTypes['organizationUserInviteMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationUserInvitesArgs, 'objects'>>;
  createOrganizationUserRequest?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserRequest']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationUserRequestArgs, 'object'>>;
  createOrganizationUserRequests?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserRequestMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationUserRequestsArgs, 'objects'>>;
  createOrganizationUserStatus?: Resolver<Maybe<ResolversTypes['organizationUserStatus']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationUserStatusArgs, 'object'>>;
  createOrganizationUserStatuses?: Resolver<Maybe<ResolversTypes['organizationUserStatusMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationUserStatusesArgs, 'objects'>>;
  createOrganizationUsers?: Resolver<Maybe<ResolversTypes['organizationUserMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationUsersArgs, 'objects'>>;
  createOrganizations?: Resolver<Maybe<ResolversTypes['organizationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateOrganizationsArgs, 'objects'>>;
  createPhoneNumberVerificationStatus?: Resolver<Maybe<ResolversTypes['phoneNumberVerificationStatus']>, ParentType, ContextType, RequireFields<mutation_rootcreatePhoneNumberVerificationStatusArgs, 'object'>>;
  createPhoneNumberVerificationStatuses?: Resolver<Maybe<ResolversTypes['phoneNumberVerificationStatusMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreatePhoneNumberVerificationStatusesArgs, 'objects'>>;
  createPhoneroOrgUsers?: Resolver<Maybe<ResolversTypes['createPhoneroOrgUsersOutput']>, ParentType, ContextType, Partial<mutation_rootcreatePhoneroOrgUsersArgs>>;
  createPublicDevice?: Resolver<Maybe<ResolversTypes['publicDevice']>, ParentType, ContextType, RequireFields<mutation_rootcreatePublicDeviceArgs, 'object'>>;
  createPublicDevices?: Resolver<Maybe<ResolversTypes['publicDeviceMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreatePublicDevicesArgs, 'objects'>>;
  createPublicExternalRequest?: Resolver<Maybe<ResolversTypes['publicExternalRequest']>, ParentType, ContextType, RequireFields<mutation_rootcreatePublicExternalRequestArgs, 'object'>>;
  createPublicExternalRequests?: Resolver<Maybe<ResolversTypes['publicExternalRequestMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreatePublicExternalRequestsArgs, 'objects'>>;
  createPublicFile?: Resolver<Maybe<ResolversTypes['publicFile']>, ParentType, ContextType, RequireFields<mutation_rootcreatePublicFileArgs, 'object'>>;
  createPublicFiles?: Resolver<Maybe<ResolversTypes['publicFileMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreatePublicFilesArgs, 'objects'>>;
  createPublicNotification?: Resolver<Maybe<ResolversTypes['publicNotification']>, ParentType, ContextType, RequireFields<mutation_rootcreatePublicNotificationArgs, 'object'>>;
  createPublicNotifications?: Resolver<Maybe<ResolversTypes['publicNotificationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreatePublicNotificationsArgs, 'objects'>>;
  createQueueItem?: Resolver<Maybe<ResolversTypes['queueItem']>, ParentType, ContextType, RequireFields<mutation_rootcreateQueueItemArgs, 'object'>>;
  createQueueItems?: Resolver<Maybe<ResolversTypes['queueItemMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateQueueItemsArgs, 'objects'>>;
  createRelOrganizationUserDomainUser?: Resolver<Maybe<ResolversTypes['relOrganizationUserDomainUser']>, ParentType, ContextType, RequireFields<mutation_rootcreateRelOrganizationUserDomainUserArgs, 'object'>>;
  createRelOrganizationUserDomainUsers?: Resolver<Maybe<ResolversTypes['relOrganizationUserDomainUserMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateRelOrganizationUserDomainUsersArgs, 'objects'>>;
  createRequestToOrganization?: Resolver<Maybe<ResolversTypes['orgAccessRequestOutput']>, ParentType, ContextType, RequireFields<mutation_rootcreateRequestToOrganizationArgs, 'organization'>>;
  createRoom?: Resolver<Maybe<ResolversTypes['createRoomOutput']>, ParentType, ContextType, RequireFields<mutation_rootcreateRoomArgs, 'id1'>>;
  createServerSms?: Resolver<Maybe<ResolversTypes['CreateSMSOutput']>, ParentType, ContextType, Partial<mutation_rootcreateServerSmsArgs>>;
  createSmsConnector?: Resolver<Maybe<ResolversTypes['smsConnector']>, ParentType, ContextType, RequireFields<mutation_rootcreateSmsConnectorArgs, 'object'>>;
  createSmsConnectors?: Resolver<Maybe<ResolversTypes['smsConnectorMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateSmsConnectorsArgs, 'objects'>>;
  createSmsGate?: Resolver<Maybe<ResolversTypes['smsGate']>, ParentType, ContextType, RequireFields<mutation_rootcreateSmsGateArgs, 'object'>>;
  createSmsGates?: Resolver<Maybe<ResolversTypes['smsGateMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateSmsGatesArgs, 'objects'>>;
  createSmsLinkMobilitySmsContent?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsContent']>, ParentType, ContextType, RequireFields<mutation_rootcreateSmsLinkMobilitySmsContentArgs, 'object'>>;
  createSmsLinkMobilitySmsContents?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsContentMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateSmsLinkMobilitySmsContentsArgs, 'objects'>>;
  createSmsLinkMobilitySmsMessage?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsMessage']>, ParentType, ContextType, RequireFields<mutation_rootcreateSmsLinkMobilitySmsMessageArgs, 'object'>>;
  createSmsLinkMobilitySmsMessages?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsMessageMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateSmsLinkMobilitySmsMessagesArgs, 'objects'>>;
  createSmsLinkMobilitySmsRoute?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsRoute']>, ParentType, ContextType, RequireFields<mutation_rootcreateSmsLinkMobilitySmsRouteArgs, 'object'>>;
  createSmsLinkMobilitySmsRoutes?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsRouteMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateSmsLinkMobilitySmsRoutesArgs, 'objects'>>;
  createSmsProvider?: Resolver<Maybe<ResolversTypes['smsProvider']>, ParentType, ContextType, RequireFields<mutation_rootcreateSmsProviderArgs, 'object'>>;
  createSmsProviders?: Resolver<Maybe<ResolversTypes['smsProviderMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateSmsProvidersArgs, 'objects'>>;
  createSmsSm?: Resolver<Maybe<ResolversTypes['smsSm']>, ParentType, ContextType, RequireFields<mutation_rootcreateSmsSmArgs, 'object'>>;
  createSmsSms?: Resolver<Maybe<ResolversTypes['smsSmMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateSmsSmsArgs, 'objects'>>;
  createSmsSmsExternalIncomingLinkMobilities?: Resolver<Maybe<ResolversTypes['smsSmsExternalIncomingLinkMobilityMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateSmsSmsExternalIncomingLinkMobilitiesArgs, 'objects'>>;
  createSmsSmsExternalIncomingLinkMobility?: Resolver<Maybe<ResolversTypes['smsSmsExternalIncomingLinkMobility']>, ParentType, ContextType, RequireFields<mutation_rootcreateSmsSmsExternalIncomingLinkMobilityArgs, 'object'>>;
  createTelephonyNewProviderActivity?: Resolver<Maybe<ResolversTypes['NewActivityOutput']>, ParentType, ContextType, RequireFields<mutation_rootcreateTelephonyNewProviderActivityArgs, 'input'>>;
  createTelephonyProviderIntegration?: Resolver<Maybe<Array<Maybe<ResolversTypes['telephonyDomainUserOutput']>>>, ParentType, ContextType, RequireFields<mutation_rootcreateTelephonyProviderIntegrationArgs, 'integration'>>;
  createUser?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType, RequireFields<mutation_rootcreateUserArgs, 'object'>>;
  createUserAndOrg?: Resolver<Maybe<ResolversTypes['UserOrgOutput']>, ParentType, ContextType, RequireFields<mutation_rootcreateUserAndOrgArgs, 'userOrg'>>;
  createUserDetail?: Resolver<Maybe<ResolversTypes['userDetail']>, ParentType, ContextType, RequireFields<mutation_rootcreateUserDetailArgs, 'object'>>;
  createUserDetails?: Resolver<Maybe<ResolversTypes['userDetailMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateUserDetailsArgs, 'objects'>>;
  createUserDetailsType?: Resolver<Maybe<ResolversTypes['userDetailsType']>, ParentType, ContextType, RequireFields<mutation_rootcreateUserDetailsTypeArgs, 'object'>>;
  createUserDetailsTypes?: Resolver<Maybe<ResolversTypes['userDetailsTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateUserDetailsTypesArgs, 'objects'>>;
  createUserDevice?: Resolver<Maybe<ResolversTypes['userDevice']>, ParentType, ContextType, RequireFields<mutation_rootcreateUserDeviceArgs, 'object'>>;
  createUserDevices?: Resolver<Maybe<ResolversTypes['userDeviceMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateUserDevicesArgs, 'objects'>>;
  createUserPhoneNumber?: Resolver<Maybe<ResolversTypes['userPhoneNumber']>, ParentType, ContextType, RequireFields<mutation_rootcreateUserPhoneNumberArgs, 'object'>>;
  createUserPhoneNumbers?: Resolver<Maybe<ResolversTypes['userPhoneNumberMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateUserPhoneNumbersArgs, 'objects'>>;
  createUserRole?: Resolver<Maybe<ResolversTypes['userRole']>, ParentType, ContextType, RequireFields<mutation_rootcreateUserRoleArgs, 'object'>>;
  createUserRoles?: Resolver<Maybe<ResolversTypes['userRoleMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateUserRolesArgs, 'objects'>>;
  createUsers?: Resolver<Maybe<ResolversTypes['userMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateUsersArgs, 'objects'>>;
  createValidationValidation?: Resolver<Maybe<ResolversTypes['validationValidation']>, ParentType, ContextType, RequireFields<mutation_rootcreateValidationValidationArgs, 'object'>>;
  createValidationValidations?: Resolver<Maybe<ResolversTypes['validationValidationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootcreateValidationValidationsArgs, 'objects'>>;
  createVideoInviteToOrganizationUser?: Resolver<Maybe<ResolversTypes['videoInviteOrgUserOutput']>, ParentType, ContextType, RequireFields<mutation_rootcreateVideoInviteToOrganizationUserArgs, 'object'>>;
  deleteActivityDirection?: Resolver<Maybe<ResolversTypes['ActivityDirectionMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteActivityDirectionArgs, 'where'>>;
  deleteActivityDirectionByPk?: Resolver<Maybe<ResolversTypes['ActivityDirection']>, ParentType, ContextType, RequireFields<mutation_rootdeleteActivityDirectionByPkArgs, 'value'>>;
  deleteActivityParticipant?: Resolver<Maybe<ResolversTypes['activityParticipant']>, ParentType, ContextType, RequireFields<mutation_rootdeleteActivityParticipantArgs, 'id'>>;
  deleteActivityParticipants?: Resolver<Maybe<ResolversTypes['activityParticipantMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteActivityParticipantsArgs, 'where'>>;
  deleteActivityProvider?: Resolver<Maybe<ResolversTypes['ActivityProviderMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteActivityProviderArgs, 'where'>>;
  deleteActivityProviderByPk?: Resolver<Maybe<ResolversTypes['ActivityProvider']>, ParentType, ContextType, RequireFields<mutation_rootdeleteActivityProviderByPkArgs, 'value'>>;
  deleteActivityStatus?: Resolver<Maybe<ResolversTypes['ActivityStatus']>, ParentType, ContextType, RequireFields<mutation_rootdeleteActivityStatusArgs, 'value'>>;
  deleteActivityStatuses?: Resolver<Maybe<ResolversTypes['ActivityStatusMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteActivityStatusesArgs, 'where'>>;
  deleteActivityType?: Resolver<Maybe<ResolversTypes['ActivityType']>, ParentType, ContextType, RequireFields<mutation_rootdeleteActivityTypeArgs, 'value'>>;
  deleteActivityTypes?: Resolver<Maybe<ResolversTypes['ActivityTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteActivityTypesArgs, 'where'>>;
  deleteAddress?: Resolver<Maybe<ResolversTypes['address']>, ParentType, ContextType, RequireFields<mutation_rootdeleteAddressArgs, 'id'>>;
  deleteAddresses?: Resolver<Maybe<ResolversTypes['addressMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteAddressesArgs, 'where'>>;
  deleteBlockedDomainUser?: Resolver<Maybe<ResolversTypes['blockedDomainUser']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBlockedDomainUserArgs, 'id'>>;
  deleteBlockedDomainUsers?: Resolver<Maybe<ResolversTypes['blockedDomainUserMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBlockedDomainUsersArgs, 'where'>>;
  deleteBusinessDomainActivityType?: Resolver<Maybe<ResolversTypes['BusinessDomainActivityTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessDomainActivityTypeArgs, 'where'>>;
  deleteBusinessDomainActivityTypeByPk?: Resolver<Maybe<ResolversTypes['BusinessDomainActivityType']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessDomainActivityTypeByPkArgs, 'value'>>;
  deleteBusinessFeedType?: Resolver<Maybe<ResolversTypes['BusinessFeedTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessFeedTypeArgs, 'where'>>;
  deleteBusinessFeedTypeByPk?: Resolver<Maybe<ResolversTypes['BusinessFeedType']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessFeedTypeByPkArgs, 'type'>>;
  deleteBusinessMessageAttachments?: Resolver<Maybe<ResolversTypes['BusinessMessageAttachmentsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessMessageAttachmentsArgs, 'where'>>;
  deleteBusinessMessageAttachmentsByPk?: Resolver<Maybe<ResolversTypes['BusinessMessageAttachments']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessMessageAttachmentsByPkArgs, 'id'>>;
  deleteBusinessOrganizationUserCallbackAnswer?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserCallbackAnswerMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessOrganizationUserCallbackAnswerArgs, 'where'>>;
  deleteBusinessOrganizationUserCallbackAnswerByPk?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserCallbackAnswer']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessOrganizationUserCallbackAnswerByPkArgs, 'id'>>;
  deleteBusinessOrganizationUserEmail?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserEmailMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessOrganizationUserEmailArgs, 'where'>>;
  deleteBusinessOrganizationUserEmailByPk?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserEmail']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessOrganizationUserEmailByPkArgs, 'id'>>;
  deleteBusinessOrganizationUserEmailType?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserEmailTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessOrganizationUserEmailTypeArgs, 'where'>>;
  deleteBusinessOrganizationUserEmailTypeByPk?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserEmailType']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessOrganizationUserEmailTypeByPkArgs, 'value'>>;
  deleteBusinessOrganizationUserRequestType?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserRequestTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessOrganizationUserRequestTypeArgs, 'where'>>;
  deleteBusinessOrganizationUserRequestTypeByPk?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserRequestType']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessOrganizationUserRequestTypeByPkArgs, 'name'>>;
  deleteBusinessOrganizationUserSuggestionType?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserSuggestionTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessOrganizationUserSuggestionTypeArgs, 'where'>>;
  deleteBusinessOrganizationUserSuggestionTypeByPk?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserSuggestionType']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessOrganizationUserSuggestionTypeByPkArgs, 'value'>>;
  deleteBusinessOrganizationUserSuggestions?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserSuggestionsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessOrganizationUserSuggestionsArgs, 'where'>>;
  deleteBusinessOrganizationUserSuggestionsByPk?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserSuggestions']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessOrganizationUserSuggestionsByPkArgs, 'id'>>;
  deleteBusinessOrganizationUserUrlAddress?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserUrlAddressMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessOrganizationUserUrlAddressArgs, 'where'>>;
  deleteBusinessOrganizationUserUrlAddressByPk?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserUrlAddress']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessOrganizationUserUrlAddressByPkArgs, 'id'>>;
  deleteBusinessOrganizationUserUrlAddressType?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserUrlAddressTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessOrganizationUserUrlAddressTypeArgs, 'where'>>;
  deleteBusinessOrganizationUserUrlAddressTypeByPk?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserUrlAddressType']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessOrganizationUserUrlAddressTypeByPkArgs, 'value'>>;
  deleteBusinessQueueItemAlarmType?: Resolver<Maybe<ResolversTypes['BusinessQueueItemAlarmTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessQueueItemAlarmTypeArgs, 'where'>>;
  deleteBusinessQueueItemAlarmTypeByPk?: Resolver<Maybe<ResolversTypes['BusinessQueueItemAlarmType']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessQueueItemAlarmTypeByPkArgs, 'value'>>;
  deleteBusinessQueueItemAlarms?: Resolver<Maybe<ResolversTypes['BusinessQueueItemAlarmsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessQueueItemAlarmsArgs, 'where'>>;
  deleteBusinessQueueItemAlarmsByPk?: Resolver<Maybe<ResolversTypes['BusinessQueueItemAlarms']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessQueueItemAlarmsByPkArgs, 'id'>>;
  deleteBusinessQueueItemCollaboration?: Resolver<Maybe<ResolversTypes['businessQueueItemCollaboration']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessQueueItemCollaborationArgs, 'id'>>;
  deleteBusinessQueueItemCollaborations?: Resolver<Maybe<ResolversTypes['businessQueueItemCollaborationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessQueueItemCollaborationsArgs, 'where'>>;
  deleteBusinessQueueItemParticipantChannelType?: Resolver<Maybe<ResolversTypes['BusinessQueueItemParticipantChannelTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessQueueItemParticipantChannelTypeArgs, 'where'>>;
  deleteBusinessQueueItemParticipantChannelTypeByPk?: Resolver<Maybe<ResolversTypes['BusinessQueueItemParticipantChannelType']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessQueueItemParticipantChannelTypeByPkArgs, 'value'>>;
  deleteBusinessQueueItemSubType?: Resolver<Maybe<ResolversTypes['BusinessQueueItemSubTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessQueueItemSubTypeArgs, 'where'>>;
  deleteBusinessQueueItemSubTypeByPk?: Resolver<Maybe<ResolversTypes['BusinessQueueItemSubType']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessQueueItemSubTypeByPkArgs, 'value'>>;
  deleteBusinessUserContact?: Resolver<Maybe<ResolversTypes['businessUserContacts']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessUserContactArgs, 'id'>>;
  deleteBusinessUserContactNumbers?: Resolver<Maybe<ResolversTypes['BusinessUserContactNumbersMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessUserContactNumbersArgs, 'where'>>;
  deleteBusinessUserContactNumbersByPk?: Resolver<Maybe<ResolversTypes['BusinessUserContactNumbers']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessUserContactNumbersByPkArgs, 'id'>>;
  deleteBusinessUserContacts?: Resolver<Maybe<ResolversTypes['businessUserContactsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessUserContactsArgs, 'where'>>;
  deleteBusinessUserFeed?: Resolver<Maybe<ResolversTypes['BusinessUserFeedMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessUserFeedArgs, 'where'>>;
  deleteBusinessUserFeedByPk?: Resolver<Maybe<ResolversTypes['BusinessUserFeed']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessUserFeedByPkArgs, 'id'>>;
  deleteBusinessUserRequestStatus?: Resolver<Maybe<ResolversTypes['BusinessUserRequestStatusMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessUserRequestStatusArgs, 'where'>>;
  deleteBusinessUserRequestStatusByPk?: Resolver<Maybe<ResolversTypes['BusinessUserRequestStatus']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessUserRequestStatusByPkArgs, 'value'>>;
  deleteBusinessUserSetting?: Resolver<Maybe<ResolversTypes['businessUserSettings']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessUserSettingArgs, 'id'>>;
  deleteBusinessUserSettings?: Resolver<Maybe<ResolversTypes['businessUserSettingsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessUserSettingsArgs, 'where'>>;
  deleteBusinessUserStates?: Resolver<Maybe<ResolversTypes['BusinessUserStatesMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessUserStatesArgs, 'where'>>;
  deleteBusinessUserStatesByPk?: Resolver<Maybe<ResolversTypes['BusinessUserStates']>, ParentType, ContextType, RequireFields<mutation_rootdeleteBusinessUserStatesByPkArgs, 'id'>>;
  deleteCrmContext?: Resolver<Maybe<ResolversTypes['CrmContextMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteCrmContextArgs, 'where'>>;
  deleteCrmContextByPk?: Resolver<Maybe<ResolversTypes['CrmContext']>, ParentType, ContextType, RequireFields<mutation_rootdeleteCrmContextByPkArgs, 'id'>>;
  deleteCrmContextType?: Resolver<Maybe<ResolversTypes['CrmContextTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteCrmContextTypeArgs, 'where'>>;
  deleteCrmContextTypeByPk?: Resolver<Maybe<ResolversTypes['CrmContextType']>, ParentType, ContextType, RequireFields<mutation_rootdeleteCrmContextTypeByPkArgs, 'value'>>;
  deleteCrmCreatorType?: Resolver<Maybe<ResolversTypes['CrmCreatorTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteCrmCreatorTypeArgs, 'where'>>;
  deleteCrmCreatorTypeByPk?: Resolver<Maybe<ResolversTypes['CrmCreatorType']>, ParentType, ContextType, RequireFields<mutation_rootdeleteCrmCreatorTypeByPkArgs, 'value'>>;
  deleteCrmCrmType?: Resolver<Maybe<ResolversTypes['CrmCrmTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteCrmCrmTypeArgs, 'where'>>;
  deleteCrmCrmTypeByPk?: Resolver<Maybe<ResolversTypes['CrmCrmType']>, ParentType, ContextType, RequireFields<mutation_rootdeleteCrmCrmTypeByPkArgs, 'value'>>;
  deleteCrmDirectionType?: Resolver<Maybe<ResolversTypes['CrmDirectionTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteCrmDirectionTypeArgs, 'where'>>;
  deleteCrmDirectionTypeByPk?: Resolver<Maybe<ResolversTypes['CrmDirectionType']>, ParentType, ContextType, RequireFields<mutation_rootdeleteCrmDirectionTypeByPkArgs, 'value'>>;
  deleteCrmEntity?: Resolver<Maybe<ResolversTypes['CrmEntityMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteCrmEntityArgs, 'where'>>;
  deleteCrmEntityByPk?: Resolver<Maybe<ResolversTypes['CrmEntity']>, ParentType, ContextType, RequireFields<mutation_rootdeleteCrmEntityByPkArgs, 'id'>>;
  deleteCrmEvent?: Resolver<Maybe<ResolversTypes['CrmEventMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteCrmEventArgs, 'where'>>;
  deleteCrmEventByPk?: Resolver<Maybe<ResolversTypes['CrmEvent']>, ParentType, ContextType, RequireFields<mutation_rootdeleteCrmEventByPkArgs, 'id'>>;
  deleteCrmEventType?: Resolver<Maybe<ResolversTypes['CrmEventTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteCrmEventTypeArgs, 'where'>>;
  deleteCrmEventTypeByPk?: Resolver<Maybe<ResolversTypes['CrmEventType']>, ParentType, ContextType, RequireFields<mutation_rootdeleteCrmEventTypeByPkArgs, 'value'>>;
  deleteCrmStatusCode?: Resolver<Maybe<ResolversTypes['CrmStatusCodeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteCrmStatusCodeArgs, 'where'>>;
  deleteCrmStatusCodeByPk?: Resolver<Maybe<ResolversTypes['CrmStatusCode']>, ParentType, ContextType, RequireFields<mutation_rootdeleteCrmStatusCodeByPkArgs, 'value'>>;
  deleteCrmStatusMessage?: Resolver<Maybe<ResolversTypes['crmStatusMessage']>, ParentType, ContextType, RequireFields<mutation_rootdeleteCrmStatusMessageArgs, 'id'>>;
  deleteCrmStatusMessages?: Resolver<Maybe<ResolversTypes['crmStatusMessageMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteCrmStatusMessagesArgs, 'where'>>;
  deleteCrmSystemType?: Resolver<Maybe<ResolversTypes['CrmSystemTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteCrmSystemTypeArgs, 'where'>>;
  deleteCrmSystemTypeByPk?: Resolver<Maybe<ResolversTypes['CrmSystemType']>, ParentType, ContextType, RequireFields<mutation_rootdeleteCrmSystemTypeByPkArgs, 'value'>>;
  deleteCrmTraceContext?: Resolver<Maybe<ResolversTypes['CrmTraceContextMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteCrmTraceContextArgs, 'where'>>;
  deleteCrmTraceContextByPk?: Resolver<Maybe<ResolversTypes['CrmTraceContext']>, ParentType, ContextType, RequireFields<mutation_rootdeleteCrmTraceContextByPkArgs, 'id'>>;
  deleteCrmUnifiedEntityType?: Resolver<Maybe<ResolversTypes['CrmUnifiedEntityTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteCrmUnifiedEntityTypeArgs, 'where'>>;
  deleteCrmUnifiedEntityTypeByPk?: Resolver<Maybe<ResolversTypes['CrmUnifiedEntityType']>, ParentType, ContextType, RequireFields<mutation_rootdeleteCrmUnifiedEntityTypeByPkArgs, 'value'>>;
  deleteCrmYoutelloCatalystIdMapping?: Resolver<Maybe<ResolversTypes['crmYoutelloCatalystIdMappingMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteCrmYoutelloCatalystIdMappingArgs, 'where'>>;
  deleteCrmYoutelloCatalystIdMappingByPk?: Resolver<Maybe<ResolversTypes['crmYoutelloCatalystIdMapping']>, ParentType, ContextType, RequireFields<mutation_rootdeleteCrmYoutelloCatalystIdMappingByPkArgs, 'catalystId' | 'youtelloId'>>;
  deleteDomainActivities?: Resolver<Maybe<ResolversTypes['domainActivityMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteDomainActivitiesArgs, 'where'>>;
  deleteDomainActivity?: Resolver<Maybe<ResolversTypes['domainActivity']>, ParentType, ContextType, RequireFields<mutation_rootdeleteDomainActivityArgs, 'id'>>;
  deleteDomainOrganization?: Resolver<Maybe<ResolversTypes['domainOrganization']>, ParentType, ContextType, RequireFields<mutation_rootdeleteDomainOrganizationArgs, 'id'>>;
  deleteDomainOrganizations?: Resolver<Maybe<ResolversTypes['domainOrganizationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteDomainOrganizationsArgs, 'where'>>;
  deleteDomainParticipant?: Resolver<Maybe<ResolversTypes['domainParticipant']>, ParentType, ContextType, RequireFields<mutation_rootdeleteDomainParticipantArgs, 'id'>>;
  deleteDomainParticipants?: Resolver<Maybe<ResolversTypes['domainParticipantMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteDomainParticipantsArgs, 'where'>>;
  deleteDomainType?: Resolver<Maybe<ResolversTypes['domainType']>, ParentType, ContextType, RequireFields<mutation_rootdeleteDomainTypeArgs, 'value'>>;
  deleteDomainTypes?: Resolver<Maybe<ResolversTypes['domainTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteDomainTypesArgs, 'where'>>;
  deleteDomainUser?: Resolver<Maybe<ResolversTypes['domainUser']>, ParentType, ContextType, RequireFields<mutation_rootdeleteDomainUserArgs, 'id'>>;
  deleteDomainUserCategories?: Resolver<Maybe<ResolversTypes['domainUserCategoryMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteDomainUserCategoriesArgs, 'where'>>;
  deleteDomainUserCategory?: Resolver<Maybe<ResolversTypes['domainUserCategory']>, ParentType, ContextType, RequireFields<mutation_rootdeleteDomainUserCategoryArgs, 'value'>>;
  deleteDomainUsers?: Resolver<Maybe<ResolversTypes['domainUserMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteDomainUsersArgs, 'where'>>;
  deleteInviteUserToOrg?: Resolver<Maybe<ResolversTypes['DeleteUserOutput']>, ParentType, ContextType, RequireFields<mutation_rootdeleteInviteUserToOrgArgs, 'input'>>;
  deleteLanguages?: Resolver<Maybe<ResolversTypes['languagesMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteLanguagesArgs, 'where'>>;
  deleteLanguagesByPk?: Resolver<Maybe<ResolversTypes['languages']>, ParentType, ContextType, RequireFields<mutation_rootdeleteLanguagesByPkArgs, 'value'>>;
  deleteMessage?: Resolver<Maybe<ResolversTypes['message']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessageArgs, 'id'>>;
  deleteMessageType?: Resolver<Maybe<ResolversTypes['messageType']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessageTypeArgs, 'value'>>;
  deleteMessageTypes?: Resolver<Maybe<ResolversTypes['messageTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessageTypesArgs, 'where'>>;
  deleteMessages?: Resolver<Maybe<ResolversTypes['messageMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagesArgs, 'where'>>;
  deleteMessagingActivities?: Resolver<Maybe<ResolversTypes['messagingActivityMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingActivitiesArgs, 'where'>>;
  deleteMessagingActivity?: Resolver<Maybe<ResolversTypes['messagingActivity']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingActivityArgs, 'id'>>;
  deleteMessagingActivityOrganization?: Resolver<Maybe<ResolversTypes['messagingActivityOrganization']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingActivityOrganizationArgs, 'id'>>;
  deleteMessagingActivityOrganizations?: Resolver<Maybe<ResolversTypes['messagingActivityOrganizationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingActivityOrganizationsArgs, 'where'>>;
  deleteMessagingActivitySettings?: Resolver<Maybe<ResolversTypes['MessagingActivitySettingsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingActivitySettingsArgs, 'where'>>;
  deleteMessagingActivitySettingsByPk?: Resolver<Maybe<ResolversTypes['MessagingActivitySettings']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingActivitySettingsByPkArgs, 'id'>>;
  deleteMessagingActivitySettingsNotificationSettingType?: Resolver<Maybe<ResolversTypes['MessagingActivitySettingsNotificationSettingTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingActivitySettingsNotificationSettingTypeArgs, 'where'>>;
  deleteMessagingActivitySettingsNotificationSettingTypeByPk?: Resolver<Maybe<ResolversTypes['MessagingActivitySettingsNotificationSettingType']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingActivitySettingsNotificationSettingTypeByPkArgs, 'value'>>;
  deleteMessagingActivityType?: Resolver<Maybe<ResolversTypes['messagingActivityType']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingActivityTypeArgs, 'value'>>;
  deleteMessagingActivityTypes?: Resolver<Maybe<ResolversTypes['messagingActivityTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingActivityTypesArgs, 'where'>>;
  deleteMessagingActivityUser?: Resolver<Maybe<ResolversTypes['messagingActivityUser']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingActivityUserArgs, 'id'>>;
  deleteMessagingActivityUsers?: Resolver<Maybe<ResolversTypes['messagingActivityUserMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingActivityUsersArgs, 'where'>>;
  deleteMessagingInvitation?: Resolver<Maybe<ResolversTypes['MessagingInvitationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingInvitationArgs, 'where'>>;
  deleteMessagingInvitationByPk?: Resolver<Maybe<ResolversTypes['MessagingInvitation']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingInvitationByPkArgs, 'id'>>;
  deleteMessagingMentions?: Resolver<Maybe<ResolversTypes['MessagingMentionsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingMentionsArgs, 'where'>>;
  deleteMessagingMentionsByPk?: Resolver<Maybe<ResolversTypes['MessagingMentions']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingMentionsByPkArgs, 'id'>>;
  deleteMessagingMessage?: Resolver<Maybe<ResolversTypes['messagingMessage']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingMessageArgs, 'id'>>;
  deleteMessagingMessageAttachment?: Resolver<Maybe<ResolversTypes['MessagingMessageAttachmentMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingMessageAttachmentArgs, 'where'>>;
  deleteMessagingMessageAttachmentByPk?: Resolver<Maybe<ResolversTypes['MessagingMessageAttachment']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingMessageAttachmentByPkArgs, 'id'>>;
  deleteMessagingMessageAttachmentType?: Resolver<Maybe<ResolversTypes['MessagingMessageAttachmentTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingMessageAttachmentTypeArgs, 'where'>>;
  deleteMessagingMessageAttachmentTypeByPk?: Resolver<Maybe<ResolversTypes['MessagingMessageAttachmentType']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingMessageAttachmentTypeByPkArgs, 'value'>>;
  deleteMessagingMessageEmoji?: Resolver<Maybe<ResolversTypes['messagingMessageEmoji']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingMessageEmojiArgs, 'id'>>;
  deleteMessagingMessageEmojis?: Resolver<Maybe<ResolversTypes['messagingMessageEmojiMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingMessageEmojisArgs, 'where'>>;
  deleteMessagingMessagePriority?: Resolver<Maybe<ResolversTypes['MessagingMessagePriorityMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingMessagePriorityArgs, 'where'>>;
  deleteMessagingMessagePriorityByPk?: Resolver<Maybe<ResolversTypes['MessagingMessagePriority']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingMessagePriorityByPkArgs, 'value'>>;
  deleteMessagingMessageRead?: Resolver<Maybe<ResolversTypes['messagingMessageRead']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingMessageReadArgs, 'id'>>;
  deleteMessagingMessageReads?: Resolver<Maybe<ResolversTypes['messagingMessageReadMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingMessageReadsArgs, 'where'>>;
  deleteMessagingMessageType?: Resolver<Maybe<ResolversTypes['messagingMessageType']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingMessageTypeArgs, 'value'>>;
  deleteMessagingMessageTypes?: Resolver<Maybe<ResolversTypes['messagingMessageTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingMessageTypesArgs, 'where'>>;
  deleteMessagingMessages?: Resolver<Maybe<ResolversTypes['messagingMessageMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteMessagingMessagesArgs, 'where'>>;
  deleteNotification?: Resolver<Maybe<ResolversTypes['notification']>, ParentType, ContextType, RequireFields<mutation_rootdeleteNotificationArgs, 'id'>>;
  deleteNotificationNotificationDeviceSent?: Resolver<Maybe<ResolversTypes['NotificationNotificationDeviceSentMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteNotificationNotificationDeviceSentArgs, 'where'>>;
  deleteNotificationNotificationDeviceSentByPk?: Resolver<Maybe<ResolversTypes['NotificationNotificationDeviceSent']>, ParentType, ContextType, RequireFields<mutation_rootdeleteNotificationNotificationDeviceSentByPkArgs, 'id'>>;
  deleteNotificationNotificationSettingActivityPrimaryEnum?: Resolver<Maybe<ResolversTypes['NotificationNotificationSettingActivityPrimaryEnumMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteNotificationNotificationSettingActivityPrimaryEnumArgs, 'where'>>;
  deleteNotificationNotificationSettingActivityPrimaryEnumByPk?: Resolver<Maybe<ResolversTypes['NotificationNotificationSettingActivityPrimaryEnum']>, ParentType, ContextType, RequireFields<mutation_rootdeleteNotificationNotificationSettingActivityPrimaryEnumByPkArgs, 'value'>>;
  deleteNotificationSend?: Resolver<Maybe<ResolversTypes['notificationSend']>, ParentType, ContextType, RequireFields<mutation_rootdeleteNotificationSendArgs, 'id'>>;
  deleteNotificationSends?: Resolver<Maybe<ResolversTypes['notificationSendMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteNotificationSendsArgs, 'where'>>;
  deleteNotificationSettingActivities?: Resolver<Maybe<ResolversTypes['notificationSettingActivityMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteNotificationSettingActivitiesArgs, 'where'>>;
  deleteNotificationSettingActivity?: Resolver<Maybe<ResolversTypes['notificationSettingActivity']>, ParentType, ContextType, RequireFields<mutation_rootdeleteNotificationSettingActivityArgs, 'id'>>;
  deleteNotificationUser?: Resolver<Maybe<ResolversTypes['notificationUser']>, ParentType, ContextType, RequireFields<mutation_rootdeleteNotificationUserArgs, 'id'>>;
  deleteNotificationUserDevice?: Resolver<Maybe<ResolversTypes['notificationUserDevice']>, ParentType, ContextType, RequireFields<mutation_rootdeleteNotificationUserDeviceArgs, 'id'>>;
  deleteNotificationUserDevices?: Resolver<Maybe<ResolversTypes['notificationUserDeviceMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteNotificationUserDevicesArgs, 'where'>>;
  deleteNotificationUsers?: Resolver<Maybe<ResolversTypes['notificationUserMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteNotificationUsersArgs, 'where'>>;
  deleteNotifications?: Resolver<Maybe<ResolversTypes['notificationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteNotificationsArgs, 'where'>>;
  deleteOrdersIntegration?: Resolver<Maybe<ResolversTypes['ordersIntegrations']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrdersIntegrationArgs, 'id'>>;
  deleteOrdersIntegrations?: Resolver<Maybe<ResolversTypes['ordersIntegrationsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrdersIntegrationsArgs, 'where'>>;
  deleteOrdersOrganizations?: Resolver<Maybe<ResolversTypes['OrdersOrganizationsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrdersOrganizationsArgs, 'where'>>;
  deleteOrdersOrganizationsByPk?: Resolver<Maybe<ResolversTypes['OrdersOrganizations']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrdersOrganizationsByPkArgs, 'id'>>;
  deleteOrdersRequest?: Resolver<Maybe<ResolversTypes['OrdersRequestMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrdersRequestArgs, 'where'>>;
  deleteOrdersRequestByPk?: Resolver<Maybe<ResolversTypes['OrdersRequest']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrdersRequestByPkArgs, 'value'>>;
  deleteOrdersStatus?: Resolver<Maybe<ResolversTypes['OrdersStatusMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrdersStatusArgs, 'where'>>;
  deleteOrdersStatusByPk?: Resolver<Maybe<ResolversTypes['OrdersStatus']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrdersStatusByPkArgs, 'value'>>;
  deleteOrdersType?: Resolver<Maybe<ResolversTypes['OrdersTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrdersTypeArgs, 'where'>>;
  deleteOrdersTypeByPk?: Resolver<Maybe<ResolversTypes['OrdersType']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrdersTypeByPkArgs, 'value'>>;
  deleteOrganization?: Resolver<Maybe<ResolversTypes['organization']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationArgs, 'id'>>;
  deleteOrganizationAuthorizationEnumGroup?: Resolver<Maybe<ResolversTypes['organizationAuthorizationEnumGroup']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationAuthorizationEnumGroupArgs, 'id'>>;
  deleteOrganizationAuthorizationEnumGroups?: Resolver<Maybe<ResolversTypes['organizationAuthorizationEnumGroupMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationAuthorizationEnumGroupsArgs, 'where'>>;
  deleteOrganizationAuthorizationGroup?: Resolver<Maybe<ResolversTypes['organizationAuthorizationGroup']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationAuthorizationGroupArgs, 'id'>>;
  deleteOrganizationAuthorizationGroups?: Resolver<Maybe<ResolversTypes['organizationAuthorizationGroupMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationAuthorizationGroupsArgs, 'where'>>;
  deleteOrganizationOrganizationRelationship?: Resolver<Maybe<ResolversTypes['organizationOrganizationRelationship']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationOrganizationRelationshipArgs, 'id'>>;
  deleteOrganizationOrganizationRelationshipCategories?: Resolver<Maybe<ResolversTypes['organizationOrganizationRelationshipCategoryMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationOrganizationRelationshipCategoriesArgs, 'where'>>;
  deleteOrganizationOrganizationRelationshipCategory?: Resolver<Maybe<ResolversTypes['organizationOrganizationRelationshipCategory']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationOrganizationRelationshipCategoryArgs, 'value'>>;
  deleteOrganizationOrganizationRelationships?: Resolver<Maybe<ResolversTypes['organizationOrganizationRelationshipMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationOrganizationRelationshipsArgs, 'where'>>;
  deleteOrganizationOrganizationUserAuthorization?: Resolver<Maybe<ResolversTypes['organizationOrganizationUserAuthorization']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationOrganizationUserAuthorizationArgs, 'id'>>;
  deleteOrganizationOrganizationUserAuthorizations?: Resolver<Maybe<ResolversTypes['organizationOrganizationUserAuthorizationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationOrganizationUserAuthorizationsArgs, 'where'>>;
  deleteOrganizationUser?: Resolver<Maybe<ResolversTypes['organizationUser']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationUserArgs, 'id'>>;
  deleteOrganizationUserAttachment?: Resolver<Maybe<ResolversTypes['organizationUserAttachments']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationUserAttachmentArgs, 'id'>>;
  deleteOrganizationUserAttachments?: Resolver<Maybe<ResolversTypes['organizationUserAttachmentsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationUserAttachmentsArgs, 'where'>>;
  deleteOrganizationUserAttentionNote?: Resolver<Maybe<ResolversTypes['OrganizationUserAttentionNote']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationUserAttentionNoteArgs, 'id'>>;
  deleteOrganizationUserAttentionNotes?: Resolver<Maybe<ResolversTypes['OrganizationUserAttentionNoteMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationUserAttentionNotesArgs, 'where'>>;
  deleteOrganizationUserAuthorization?: Resolver<Maybe<ResolversTypes['organizationUserAuthorization']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationUserAuthorizationArgs, 'value'>>;
  deleteOrganizationUserAuthorizations?: Resolver<Maybe<ResolversTypes['organizationUserAuthorizationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationUserAuthorizationsArgs, 'where'>>;
  deleteOrganizationUserDetail?: Resolver<Maybe<ResolversTypes['organizationUserDetail']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationUserDetailArgs, 'id'>>;
  deleteOrganizationUserDetailType?: Resolver<Maybe<ResolversTypes['organizationUserDetailType']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationUserDetailTypeArgs, 'value'>>;
  deleteOrganizationUserDetailTypes?: Resolver<Maybe<ResolversTypes['organizationUserDetailTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationUserDetailTypesArgs, 'where'>>;
  deleteOrganizationUserDetails?: Resolver<Maybe<ResolversTypes['organizationUserDetailMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationUserDetailsArgs, 'where'>>;
  deleteOrganizationUserInvite?: Resolver<Maybe<ResolversTypes['organizationUserInvite']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationUserInviteArgs, 'id'>>;
  deleteOrganizationUserInvites?: Resolver<Maybe<ResolversTypes['organizationUserInviteMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationUserInvitesArgs, 'where'>>;
  deleteOrganizationUserRequest?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserRequest']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationUserRequestArgs, 'id'>>;
  deleteOrganizationUserRequests?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserRequestMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationUserRequestsArgs, 'where'>>;
  deleteOrganizationUserStatus?: Resolver<Maybe<ResolversTypes['organizationUserStatus']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationUserStatusArgs, 'value'>>;
  deleteOrganizationUserStatuses?: Resolver<Maybe<ResolversTypes['organizationUserStatusMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationUserStatusesArgs, 'where'>>;
  deleteOrganizationUsers?: Resolver<Maybe<ResolversTypes['organizationUserMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationUsersArgs, 'where'>>;
  deleteOrganizations?: Resolver<Maybe<ResolversTypes['organizationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteOrganizationsArgs, 'where'>>;
  deletePhoneNumberVerificationStatus?: Resolver<Maybe<ResolversTypes['phoneNumberVerificationStatus']>, ParentType, ContextType, RequireFields<mutation_rootdeletePhoneNumberVerificationStatusArgs, 'value'>>;
  deletePhoneNumberVerificationStatuses?: Resolver<Maybe<ResolversTypes['phoneNumberVerificationStatusMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeletePhoneNumberVerificationStatusesArgs, 'where'>>;
  deletePrompt?: Resolver<Maybe<ResolversTypes['PromptMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeletePromptArgs, 'where'>>;
  deletePromptByPk?: Resolver<Maybe<ResolversTypes['Prompt']>, ParentType, ContextType, RequireFields<mutation_rootdeletePromptByPkArgs, 'id'>>;
  deletePublicDevice?: Resolver<Maybe<ResolversTypes['publicDevice']>, ParentType, ContextType, RequireFields<mutation_rootdeletePublicDeviceArgs, 'id'>>;
  deletePublicDevices?: Resolver<Maybe<ResolversTypes['publicDeviceMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeletePublicDevicesArgs, 'where'>>;
  deletePublicExternalRequest?: Resolver<Maybe<ResolversTypes['publicExternalRequest']>, ParentType, ContextType, RequireFields<mutation_rootdeletePublicExternalRequestArgs, 'id'>>;
  deletePublicExternalRequests?: Resolver<Maybe<ResolversTypes['publicExternalRequestMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeletePublicExternalRequestsArgs, 'where'>>;
  deletePublicFile?: Resolver<Maybe<ResolversTypes['publicFile']>, ParentType, ContextType, RequireFields<mutation_rootdeletePublicFileArgs, 'id'>>;
  deletePublicFiles?: Resolver<Maybe<ResolversTypes['publicFileMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeletePublicFilesArgs, 'where'>>;
  deletePublicNotification?: Resolver<Maybe<ResolversTypes['publicNotification']>, ParentType, ContextType, RequireFields<mutation_rootdeletePublicNotificationArgs, 'id'>>;
  deletePublicNotifications?: Resolver<Maybe<ResolversTypes['publicNotificationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeletePublicNotificationsArgs, 'where'>>;
  deleteQueueItem?: Resolver<Maybe<ResolversTypes['queueItem']>, ParentType, ContextType, RequireFields<mutation_rootdeleteQueueItemArgs, 'id'>>;
  deleteQueueItemFlexibilityType?: Resolver<Maybe<ResolversTypes['QueueItemFlexibilityTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteQueueItemFlexibilityTypeArgs, 'where'>>;
  deleteQueueItemFlexibilityTypeByPk?: Resolver<Maybe<ResolversTypes['QueueItemFlexibilityType']>, ParentType, ContextType, RequireFields<mutation_rootdeleteQueueItemFlexibilityTypeByPkArgs, 'value'>>;
  deleteQueueItemParticipantResponsibilityType?: Resolver<Maybe<ResolversTypes['QueueItemParticipantResponsibilityTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteQueueItemParticipantResponsibilityTypeArgs, 'where'>>;
  deleteQueueItemParticipantResponsibilityTypeByPk?: Resolver<Maybe<ResolversTypes['QueueItemParticipantResponsibilityType']>, ParentType, ContextType, RequireFields<mutation_rootdeleteQueueItemParticipantResponsibilityTypeByPkArgs, 'value'>>;
  deleteQueueItems?: Resolver<Maybe<ResolversTypes['queueItemMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteQueueItemsArgs, 'where'>>;
  deleteRelOrganizationUserDomainUser?: Resolver<Maybe<ResolversTypes['relOrganizationUserDomainUser']>, ParentType, ContextType, RequireFields<mutation_rootdeleteRelOrganizationUserDomainUserArgs, 'id'>>;
  deleteRelOrganizationUserDomainUsers?: Resolver<Maybe<ResolversTypes['relOrganizationUserDomainUserMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteRelOrganizationUserDomainUsersArgs, 'where'>>;
  deleteRelationType?: Resolver<Maybe<ResolversTypes['RelationTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteRelationTypeArgs, 'where'>>;
  deleteRelationTypeByPk?: Resolver<Maybe<ResolversTypes['RelationType']>, ParentType, ContextType, RequireFields<mutation_rootdeleteRelationTypeByPkArgs, 'value'>>;
  deleteRequestToOrganization?: Resolver<Maybe<ResolversTypes['DeleteRequestUserOutput']>, ParentType, ContextType, RequireFields<mutation_rootdeleteRequestToOrganizationArgs, 'input'>>;
  deleteSmsConnector?: Resolver<Maybe<ResolversTypes['smsConnector']>, ParentType, ContextType, RequireFields<mutation_rootdeleteSmsConnectorArgs, 'id'>>;
  deleteSmsConnectors?: Resolver<Maybe<ResolversTypes['smsConnectorMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteSmsConnectorsArgs, 'where'>>;
  deleteSmsGate?: Resolver<Maybe<ResolversTypes['smsGate']>, ParentType, ContextType, RequireFields<mutation_rootdeleteSmsGateArgs, 'id'>>;
  deleteSmsGates?: Resolver<Maybe<ResolversTypes['smsGateMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteSmsGatesArgs, 'where'>>;
  deleteSmsLinkMobilitySmsContent?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsContent']>, ParentType, ContextType, RequireFields<mutation_rootdeleteSmsLinkMobilitySmsContentArgs, 'uuid'>>;
  deleteSmsLinkMobilitySmsContents?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsContentMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteSmsLinkMobilitySmsContentsArgs, 'where'>>;
  deleteSmsLinkMobilitySmsMessage?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsMessage']>, ParentType, ContextType, RequireFields<mutation_rootdeleteSmsLinkMobilitySmsMessageArgs, 'uuid'>>;
  deleteSmsLinkMobilitySmsMessages?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsMessageMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteSmsLinkMobilitySmsMessagesArgs, 'where'>>;
  deleteSmsLinkMobilitySmsRoute?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsRoute']>, ParentType, ContextType, RequireFields<mutation_rootdeleteSmsLinkMobilitySmsRouteArgs, 'uuid'>>;
  deleteSmsLinkMobilitySmsRoutes?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsRouteMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteSmsLinkMobilitySmsRoutesArgs, 'where'>>;
  deleteSmsProvider?: Resolver<Maybe<ResolversTypes['smsProvider']>, ParentType, ContextType, RequireFields<mutation_rootdeleteSmsProviderArgs, 'id'>>;
  deleteSmsProviders?: Resolver<Maybe<ResolversTypes['smsProviderMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteSmsProvidersArgs, 'where'>>;
  deleteSmsSm?: Resolver<Maybe<ResolversTypes['smsSm']>, ParentType, ContextType, RequireFields<mutation_rootdeleteSmsSmArgs, 'id'>>;
  deleteSmsSms?: Resolver<Maybe<ResolversTypes['smsSmMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteSmsSmsArgs, 'where'>>;
  deleteSmsSmsExternalIncomingLinkMobilities?: Resolver<Maybe<ResolversTypes['smsSmsExternalIncomingLinkMobilityMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteSmsSmsExternalIncomingLinkMobilitiesArgs, 'where'>>;
  deleteSmsSmsExternalIncomingLinkMobility?: Resolver<Maybe<ResolversTypes['smsSmsExternalIncomingLinkMobility']>, ParentType, ContextType, RequireFields<mutation_rootdeleteSmsSmsExternalIncomingLinkMobilityArgs, 'uuid'>>;
  deleteUser?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType, RequireFields<mutation_rootdeleteUserArgs, 'id'>>;
  deleteUserDetail?: Resolver<Maybe<ResolversTypes['userDetail']>, ParentType, ContextType, RequireFields<mutation_rootdeleteUserDetailArgs, 'id'>>;
  deleteUserDetails?: Resolver<Maybe<ResolversTypes['userDetailMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteUserDetailsArgs, 'where'>>;
  deleteUserDetailsType?: Resolver<Maybe<ResolversTypes['userDetailsType']>, ParentType, ContextType, RequireFields<mutation_rootdeleteUserDetailsTypeArgs, 'value'>>;
  deleteUserDetailsTypes?: Resolver<Maybe<ResolversTypes['userDetailsTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteUserDetailsTypesArgs, 'where'>>;
  deleteUserDevice?: Resolver<Maybe<ResolversTypes['userDevice']>, ParentType, ContextType, RequireFields<mutation_rootdeleteUserDeviceArgs, 'id'>>;
  deleteUserDevices?: Resolver<Maybe<ResolversTypes['userDeviceMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteUserDevicesArgs, 'where'>>;
  deleteUserPhoneNumber?: Resolver<Maybe<ResolversTypes['userPhoneNumber']>, ParentType, ContextType, RequireFields<mutation_rootdeleteUserPhoneNumberArgs, 'id'>>;
  deleteUserPhoneNumbers?: Resolver<Maybe<ResolversTypes['userPhoneNumberMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteUserPhoneNumbersArgs, 'where'>>;
  deleteUserRole?: Resolver<Maybe<ResolversTypes['userRole']>, ParentType, ContextType, RequireFields<mutation_rootdeleteUserRoleArgs, 'value'>>;
  deleteUserRoles?: Resolver<Maybe<ResolversTypes['userRoleMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteUserRolesArgs, 'where'>>;
  deleteUsers?: Resolver<Maybe<ResolversTypes['userMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteUsersArgs, 'where'>>;
  deleteValidationValidation?: Resolver<Maybe<ResolversTypes['validationValidation']>, ParentType, ContextType, RequireFields<mutation_rootdeleteValidationValidationArgs, 'id'>>;
  deleteValidationValidations?: Resolver<Maybe<ResolversTypes['validationValidationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteValidationValidationsArgs, 'where'>>;
  deleteVoiceTypes?: Resolver<Maybe<ResolversTypes['VoiceTypesMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootdeleteVoiceTypesArgs, 'where'>>;
  deleteVoiceTypesByPk?: Resolver<Maybe<ResolversTypes['VoiceTypes']>, ParentType, ContextType, RequireFields<mutation_rootdeleteVoiceTypesByPkArgs, 'value'>>;
  emailing?: Resolver<Maybe<ResolversTypes['emailingmutation_root']>, ParentType, ContextType>;
  fileUpload?: Resolver<Maybe<Array<Maybe<ResolversTypes['fileOutput']>>>, ParentType, ContextType, Partial<mutation_rootfileUploadArgs>>;
  geodata?: Resolver<Maybe<ResolversTypes['geodatamutation_root']>, ParentType, ContextType>;
  incomingSms?: Resolver<ResolversTypes['uuid'], ParentType, ContextType, Partial<mutation_rootincomingSmsArgs>>;
  initiateVerification?: Resolver<Maybe<ResolversTypes['VerificationOutput']>, ParentType, ContextType, Partial<mutation_rootinitiateVerificationArgs>>;
  insertActivityDirection?: Resolver<Maybe<ResolversTypes['ActivityDirectionMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertActivityDirectionArgs, 'objects'>>;
  insertActivityDirectionOne?: Resolver<Maybe<ResolversTypes['ActivityDirection']>, ParentType, ContextType, RequireFields<mutation_rootinsertActivityDirectionOneArgs, 'object'>>;
  insertActivityProvider?: Resolver<Maybe<ResolversTypes['ActivityProviderMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertActivityProviderArgs, 'objects'>>;
  insertActivityProviderOne?: Resolver<Maybe<ResolversTypes['ActivityProvider']>, ParentType, ContextType, RequireFields<mutation_rootinsertActivityProviderOneArgs, 'object'>>;
  insertBusinessDomainActivityType?: Resolver<Maybe<ResolversTypes['BusinessDomainActivityTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessDomainActivityTypeArgs, 'objects'>>;
  insertBusinessDomainActivityTypeOne?: Resolver<Maybe<ResolversTypes['BusinessDomainActivityType']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessDomainActivityTypeOneArgs, 'object'>>;
  insertBusinessFeedType?: Resolver<Maybe<ResolversTypes['BusinessFeedTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessFeedTypeArgs, 'objects'>>;
  insertBusinessFeedTypeOne?: Resolver<Maybe<ResolversTypes['BusinessFeedType']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessFeedTypeOneArgs, 'object'>>;
  insertBusinessMessageAttachments?: Resolver<Maybe<ResolversTypes['BusinessMessageAttachmentsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessMessageAttachmentsArgs, 'objects'>>;
  insertBusinessMessageAttachmentsOne?: Resolver<Maybe<ResolversTypes['BusinessMessageAttachments']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessMessageAttachmentsOneArgs, 'object'>>;
  insertBusinessOrganizationUserCallbackAnswer?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserCallbackAnswerMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessOrganizationUserCallbackAnswerArgs, 'objects'>>;
  insertBusinessOrganizationUserCallbackAnswerOne?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserCallbackAnswer']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessOrganizationUserCallbackAnswerOneArgs, 'object'>>;
  insertBusinessOrganizationUserEmail?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserEmailMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessOrganizationUserEmailArgs, 'objects'>>;
  insertBusinessOrganizationUserEmailOne?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserEmail']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessOrganizationUserEmailOneArgs, 'object'>>;
  insertBusinessOrganizationUserEmailType?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserEmailTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessOrganizationUserEmailTypeArgs, 'objects'>>;
  insertBusinessOrganizationUserEmailTypeOne?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserEmailType']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessOrganizationUserEmailTypeOneArgs, 'object'>>;
  insertBusinessOrganizationUserRequestType?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserRequestTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessOrganizationUserRequestTypeArgs, 'objects'>>;
  insertBusinessOrganizationUserRequestTypeOne?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserRequestType']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessOrganizationUserRequestTypeOneArgs, 'object'>>;
  insertBusinessOrganizationUserSuggestionType?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserSuggestionTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessOrganizationUserSuggestionTypeArgs, 'objects'>>;
  insertBusinessOrganizationUserSuggestionTypeOne?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserSuggestionType']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessOrganizationUserSuggestionTypeOneArgs, 'object'>>;
  insertBusinessOrganizationUserSuggestions?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserSuggestionsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessOrganizationUserSuggestionsArgs, 'objects'>>;
  insertBusinessOrganizationUserSuggestionsOne?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserSuggestions']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessOrganizationUserSuggestionsOneArgs, 'object'>>;
  insertBusinessOrganizationUserUrlAddress?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserUrlAddressMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessOrganizationUserUrlAddressArgs, 'objects'>>;
  insertBusinessOrganizationUserUrlAddressOne?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserUrlAddress']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessOrganizationUserUrlAddressOneArgs, 'object'>>;
  insertBusinessOrganizationUserUrlAddressType?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserUrlAddressTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessOrganizationUserUrlAddressTypeArgs, 'objects'>>;
  insertBusinessOrganizationUserUrlAddressTypeOne?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserUrlAddressType']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessOrganizationUserUrlAddressTypeOneArgs, 'object'>>;
  insertBusinessQueueItemAlarmType?: Resolver<Maybe<ResolversTypes['BusinessQueueItemAlarmTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessQueueItemAlarmTypeArgs, 'objects'>>;
  insertBusinessQueueItemAlarmTypeOne?: Resolver<Maybe<ResolversTypes['BusinessQueueItemAlarmType']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessQueueItemAlarmTypeOneArgs, 'object'>>;
  insertBusinessQueueItemAlarms?: Resolver<Maybe<ResolversTypes['BusinessQueueItemAlarmsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessQueueItemAlarmsArgs, 'objects'>>;
  insertBusinessQueueItemAlarmsOne?: Resolver<Maybe<ResolversTypes['BusinessQueueItemAlarms']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessQueueItemAlarmsOneArgs, 'object'>>;
  insertBusinessQueueItemParticipantChannelType?: Resolver<Maybe<ResolversTypes['BusinessQueueItemParticipantChannelTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessQueueItemParticipantChannelTypeArgs, 'objects'>>;
  insertBusinessQueueItemParticipantChannelTypeOne?: Resolver<Maybe<ResolversTypes['BusinessQueueItemParticipantChannelType']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessQueueItemParticipantChannelTypeOneArgs, 'object'>>;
  insertBusinessQueueItemSubType?: Resolver<Maybe<ResolversTypes['BusinessQueueItemSubTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessQueueItemSubTypeArgs, 'objects'>>;
  insertBusinessQueueItemSubTypeOne?: Resolver<Maybe<ResolversTypes['BusinessQueueItemSubType']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessQueueItemSubTypeOneArgs, 'object'>>;
  insertBusinessUserContactNumbers?: Resolver<Maybe<ResolversTypes['BusinessUserContactNumbersMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessUserContactNumbersArgs, 'objects'>>;
  insertBusinessUserContactNumbersOne?: Resolver<Maybe<ResolversTypes['BusinessUserContactNumbers']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessUserContactNumbersOneArgs, 'object'>>;
  insertBusinessUserFeed?: Resolver<Maybe<ResolversTypes['BusinessUserFeedMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessUserFeedArgs, 'objects'>>;
  insertBusinessUserFeedOne?: Resolver<Maybe<ResolversTypes['BusinessUserFeed']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessUserFeedOneArgs, 'object'>>;
  insertBusinessUserRequestStatus?: Resolver<Maybe<ResolversTypes['BusinessUserRequestStatusMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessUserRequestStatusArgs, 'objects'>>;
  insertBusinessUserRequestStatusOne?: Resolver<Maybe<ResolversTypes['BusinessUserRequestStatus']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessUserRequestStatusOneArgs, 'object'>>;
  insertBusinessUserStates?: Resolver<Maybe<ResolversTypes['BusinessUserStatesMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessUserStatesArgs, 'objects'>>;
  insertBusinessUserStatesOne?: Resolver<Maybe<ResolversTypes['BusinessUserStates']>, ParentType, ContextType, RequireFields<mutation_rootinsertBusinessUserStatesOneArgs, 'object'>>;
  insertCrmContext?: Resolver<Maybe<ResolversTypes['CrmContextMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertCrmContextArgs, 'objects'>>;
  insertCrmContextOne?: Resolver<Maybe<ResolversTypes['CrmContext']>, ParentType, ContextType, RequireFields<mutation_rootinsertCrmContextOneArgs, 'object'>>;
  insertCrmContextType?: Resolver<Maybe<ResolversTypes['CrmContextTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertCrmContextTypeArgs, 'objects'>>;
  insertCrmContextTypeOne?: Resolver<Maybe<ResolversTypes['CrmContextType']>, ParentType, ContextType, RequireFields<mutation_rootinsertCrmContextTypeOneArgs, 'object'>>;
  insertCrmCreatorType?: Resolver<Maybe<ResolversTypes['CrmCreatorTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertCrmCreatorTypeArgs, 'objects'>>;
  insertCrmCreatorTypeOne?: Resolver<Maybe<ResolversTypes['CrmCreatorType']>, ParentType, ContextType, RequireFields<mutation_rootinsertCrmCreatorTypeOneArgs, 'object'>>;
  insertCrmCrmType?: Resolver<Maybe<ResolversTypes['CrmCrmTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertCrmCrmTypeArgs, 'objects'>>;
  insertCrmCrmTypeOne?: Resolver<Maybe<ResolversTypes['CrmCrmType']>, ParentType, ContextType, RequireFields<mutation_rootinsertCrmCrmTypeOneArgs, 'object'>>;
  insertCrmDirectionType?: Resolver<Maybe<ResolversTypes['CrmDirectionTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertCrmDirectionTypeArgs, 'objects'>>;
  insertCrmDirectionTypeOne?: Resolver<Maybe<ResolversTypes['CrmDirectionType']>, ParentType, ContextType, RequireFields<mutation_rootinsertCrmDirectionTypeOneArgs, 'object'>>;
  insertCrmEntity?: Resolver<Maybe<ResolversTypes['CrmEntityMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertCrmEntityArgs, 'objects'>>;
  insertCrmEntityOne?: Resolver<Maybe<ResolversTypes['CrmEntity']>, ParentType, ContextType, RequireFields<mutation_rootinsertCrmEntityOneArgs, 'object'>>;
  insertCrmEvent?: Resolver<Maybe<ResolversTypes['CrmEventMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertCrmEventArgs, 'objects'>>;
  insertCrmEventOne?: Resolver<Maybe<ResolversTypes['CrmEvent']>, ParentType, ContextType, RequireFields<mutation_rootinsertCrmEventOneArgs, 'object'>>;
  insertCrmEventType?: Resolver<Maybe<ResolversTypes['CrmEventTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertCrmEventTypeArgs, 'objects'>>;
  insertCrmEventTypeOne?: Resolver<Maybe<ResolversTypes['CrmEventType']>, ParentType, ContextType, RequireFields<mutation_rootinsertCrmEventTypeOneArgs, 'object'>>;
  insertCrmStatusCode?: Resolver<Maybe<ResolversTypes['CrmStatusCodeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertCrmStatusCodeArgs, 'objects'>>;
  insertCrmStatusCodeOne?: Resolver<Maybe<ResolversTypes['CrmStatusCode']>, ParentType, ContextType, RequireFields<mutation_rootinsertCrmStatusCodeOneArgs, 'object'>>;
  insertCrmSystemType?: Resolver<Maybe<ResolversTypes['CrmSystemTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertCrmSystemTypeArgs, 'objects'>>;
  insertCrmSystemTypeOne?: Resolver<Maybe<ResolversTypes['CrmSystemType']>, ParentType, ContextType, RequireFields<mutation_rootinsertCrmSystemTypeOneArgs, 'object'>>;
  insertCrmTraceContext?: Resolver<Maybe<ResolversTypes['CrmTraceContextMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertCrmTraceContextArgs, 'objects'>>;
  insertCrmTraceContextOne?: Resolver<Maybe<ResolversTypes['CrmTraceContext']>, ParentType, ContextType, RequireFields<mutation_rootinsertCrmTraceContextOneArgs, 'object'>>;
  insertCrmUnifiedEntityType?: Resolver<Maybe<ResolversTypes['CrmUnifiedEntityTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertCrmUnifiedEntityTypeArgs, 'objects'>>;
  insertCrmUnifiedEntityTypeOne?: Resolver<Maybe<ResolversTypes['CrmUnifiedEntityType']>, ParentType, ContextType, RequireFields<mutation_rootinsertCrmUnifiedEntityTypeOneArgs, 'object'>>;
  insertLanguages?: Resolver<Maybe<ResolversTypes['languagesMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertLanguagesArgs, 'objects'>>;
  insertLanguagesOne?: Resolver<Maybe<ResolversTypes['languages']>, ParentType, ContextType, RequireFields<mutation_rootinsertLanguagesOneArgs, 'object'>>;
  insertMessagingActivitySettings?: Resolver<Maybe<ResolversTypes['MessagingActivitySettingsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertMessagingActivitySettingsArgs, 'objects'>>;
  insertMessagingActivitySettingsNotificationSettingType?: Resolver<Maybe<ResolversTypes['MessagingActivitySettingsNotificationSettingTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertMessagingActivitySettingsNotificationSettingTypeArgs, 'objects'>>;
  insertMessagingActivitySettingsNotificationSettingTypeOne?: Resolver<Maybe<ResolversTypes['MessagingActivitySettingsNotificationSettingType']>, ParentType, ContextType, RequireFields<mutation_rootinsertMessagingActivitySettingsNotificationSettingTypeOneArgs, 'object'>>;
  insertMessagingActivitySettingsOne?: Resolver<Maybe<ResolversTypes['MessagingActivitySettings']>, ParentType, ContextType, RequireFields<mutation_rootinsertMessagingActivitySettingsOneArgs, 'object'>>;
  insertMessagingInvitation?: Resolver<Maybe<ResolversTypes['MessagingInvitationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertMessagingInvitationArgs, 'objects'>>;
  insertMessagingInvitationOne?: Resolver<Maybe<ResolversTypes['MessagingInvitation']>, ParentType, ContextType, RequireFields<mutation_rootinsertMessagingInvitationOneArgs, 'object'>>;
  insertMessagingMentions?: Resolver<Maybe<ResolversTypes['MessagingMentionsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertMessagingMentionsArgs, 'objects'>>;
  insertMessagingMentionsOne?: Resolver<Maybe<ResolversTypes['MessagingMentions']>, ParentType, ContextType, RequireFields<mutation_rootinsertMessagingMentionsOneArgs, 'object'>>;
  insertMessagingMessageAttachment?: Resolver<Maybe<ResolversTypes['MessagingMessageAttachmentMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertMessagingMessageAttachmentArgs, 'objects'>>;
  insertMessagingMessageAttachmentOne?: Resolver<Maybe<ResolversTypes['MessagingMessageAttachment']>, ParentType, ContextType, RequireFields<mutation_rootinsertMessagingMessageAttachmentOneArgs, 'object'>>;
  insertMessagingMessageAttachmentType?: Resolver<Maybe<ResolversTypes['MessagingMessageAttachmentTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertMessagingMessageAttachmentTypeArgs, 'objects'>>;
  insertMessagingMessageAttachmentTypeOne?: Resolver<Maybe<ResolversTypes['MessagingMessageAttachmentType']>, ParentType, ContextType, RequireFields<mutation_rootinsertMessagingMessageAttachmentTypeOneArgs, 'object'>>;
  insertMessagingMessagePriority?: Resolver<Maybe<ResolversTypes['MessagingMessagePriorityMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertMessagingMessagePriorityArgs, 'objects'>>;
  insertMessagingMessagePriorityOne?: Resolver<Maybe<ResolversTypes['MessagingMessagePriority']>, ParentType, ContextType, RequireFields<mutation_rootinsertMessagingMessagePriorityOneArgs, 'object'>>;
  insertNotificationNotificationDeviceSent?: Resolver<Maybe<ResolversTypes['NotificationNotificationDeviceSentMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertNotificationNotificationDeviceSentArgs, 'objects'>>;
  insertNotificationNotificationDeviceSentOne?: Resolver<Maybe<ResolversTypes['NotificationNotificationDeviceSent']>, ParentType, ContextType, RequireFields<mutation_rootinsertNotificationNotificationDeviceSentOneArgs, 'object'>>;
  insertNotificationNotificationSettingActivityPrimaryEnum?: Resolver<Maybe<ResolversTypes['NotificationNotificationSettingActivityPrimaryEnumMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertNotificationNotificationSettingActivityPrimaryEnumArgs, 'objects'>>;
  insertNotificationNotificationSettingActivityPrimaryEnumOne?: Resolver<Maybe<ResolversTypes['NotificationNotificationSettingActivityPrimaryEnum']>, ParentType, ContextType, RequireFields<mutation_rootinsertNotificationNotificationSettingActivityPrimaryEnumOneArgs, 'object'>>;
  insertOrdersOrganizations?: Resolver<Maybe<ResolversTypes['OrdersOrganizationsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertOrdersOrganizationsArgs, 'objects'>>;
  insertOrdersOrganizationsOne?: Resolver<Maybe<ResolversTypes['OrdersOrganizations']>, ParentType, ContextType, RequireFields<mutation_rootinsertOrdersOrganizationsOneArgs, 'object'>>;
  insertOrdersRequest?: Resolver<Maybe<ResolversTypes['OrdersRequestMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertOrdersRequestArgs, 'objects'>>;
  insertOrdersRequestOne?: Resolver<Maybe<ResolversTypes['OrdersRequest']>, ParentType, ContextType, RequireFields<mutation_rootinsertOrdersRequestOneArgs, 'object'>>;
  insertOrdersStatus?: Resolver<Maybe<ResolversTypes['OrdersStatusMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertOrdersStatusArgs, 'objects'>>;
  insertOrdersStatusOne?: Resolver<Maybe<ResolversTypes['OrdersStatus']>, ParentType, ContextType, RequireFields<mutation_rootinsertOrdersStatusOneArgs, 'object'>>;
  insertOrdersType?: Resolver<Maybe<ResolversTypes['OrdersTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertOrdersTypeArgs, 'objects'>>;
  insertOrdersTypeOne?: Resolver<Maybe<ResolversTypes['OrdersType']>, ParentType, ContextType, RequireFields<mutation_rootinsertOrdersTypeOneArgs, 'object'>>;
  insertPrompt?: Resolver<Maybe<ResolversTypes['PromptMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertPromptArgs, 'objects'>>;
  insertPromptOne?: Resolver<Maybe<ResolversTypes['Prompt']>, ParentType, ContextType, RequireFields<mutation_rootinsertPromptOneArgs, 'object'>>;
  insertQueueItemFlexibilityType?: Resolver<Maybe<ResolversTypes['QueueItemFlexibilityTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertQueueItemFlexibilityTypeArgs, 'objects'>>;
  insertQueueItemFlexibilityTypeOne?: Resolver<Maybe<ResolversTypes['QueueItemFlexibilityType']>, ParentType, ContextType, RequireFields<mutation_rootinsertQueueItemFlexibilityTypeOneArgs, 'object'>>;
  insertQueueItemParticipantResponsibilityType?: Resolver<Maybe<ResolversTypes['QueueItemParticipantResponsibilityTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertQueueItemParticipantResponsibilityTypeArgs, 'objects'>>;
  insertQueueItemParticipantResponsibilityTypeOne?: Resolver<Maybe<ResolversTypes['QueueItemParticipantResponsibilityType']>, ParentType, ContextType, RequireFields<mutation_rootinsertQueueItemParticipantResponsibilityTypeOneArgs, 'object'>>;
  insertRelationType?: Resolver<Maybe<ResolversTypes['RelationTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertRelationTypeArgs, 'objects'>>;
  insertRelationTypeOne?: Resolver<Maybe<ResolversTypes['RelationType']>, ParentType, ContextType, RequireFields<mutation_rootinsertRelationTypeOneArgs, 'object'>>;
  insertVoiceTypes?: Resolver<Maybe<ResolversTypes['VoiceTypesMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootinsertVoiceTypesArgs, 'objects'>>;
  insertVoiceTypesOne?: Resolver<Maybe<ResolversTypes['VoiceTypes']>, ParentType, ContextType, RequireFields<mutation_rootinsertVoiceTypesOneArgs, 'object'>>;
  leaveOrganization?: Resolver<Maybe<ResolversTypes['leaveOrganizationOutput']>, ParentType, ContextType, RequireFields<mutation_rootleaveOrganizationArgs, 'input'>>;
  linkMobilitySMS?: Resolver<Maybe<ResolversTypes['LinkMobilitySMSOutput']>, ParentType, ContextType, RequireFields<mutation_rootlinkMobilitySMSArgs, 'messageId'>>;
  makePhoneRequest?: Resolver<Maybe<ResolversTypes['PhoneRequestOutput']>, ParentType, ContextType, RequireFields<mutation_rootmakePhoneRequestArgs, 'request'>>;
  orderUpdate?: Resolver<Maybe<ResolversTypes['OrderUpdateOutput']>, ParentType, ContextType, RequireFields<mutation_rootorderUpdateArgs, 'order'>>;
  privatizeUser?: Resolver<Maybe<ResolversTypes['privatizeUserResult']>, ParentType, ContextType, RequireFields<mutation_rootprivatizeUserArgs, 'id'>>;
  removeCustomer?: Resolver<Maybe<ResolversTypes['RemoveCustomerOutput']>, ParentType, ContextType, RequireFields<mutation_rootremoveCustomerArgs, 'customer'>>;
  removeEmailProviderIntegration?: Resolver<Maybe<Array<Maybe<ResolversTypes['removeEmailDomainUserOutput']>>>, ParentType, ContextType, RequireFields<mutation_rootremoveEmailProviderIntegrationArgs, 'integration'>>;
  removeEmailProviderSubscription?: Resolver<Maybe<Array<Maybe<ResolversTypes['deleteEmailProviderSubscriptionOutput']>>>, ParentType, ContextType, RequireFields<mutation_rootremoveEmailProviderSubscriptionArgs, 'integration'>>;
  removeOrganization?: Resolver<Maybe<ResolversTypes['removeOrganizationOutput']>, ParentType, ContextType, RequireFields<mutation_rootremoveOrganizationArgs, 'org'>>;
  renewEmailProviderSubscription?: Resolver<Maybe<Array<Maybe<ResolversTypes['renewEmailProviderSubscriptionOutput']>>>, ParentType, ContextType, RequireFields<mutation_rootrenewEmailProviderSubscriptionArgs, 'integration'>>;
  requestIntegrations?: Resolver<Maybe<ResolversTypes['RequestIntegrationsOutput']>, ParentType, ContextType, RequireFields<mutation_rootrequestIntegrationsArgs, 'providers'>>;
  searchPhoneApi?: Resolver<Maybe<ResolversTypes['SearchPhoneOutput']>, ParentType, ContextType, RequireFields<mutation_rootsearchPhoneApiArgs, 'search'>>;
  sendEmail?: Resolver<Maybe<ResolversTypes['StatusOutput']>, ParentType, ContextType, RequireFields<mutation_rootsendEmailArgs, 'bcc' | 'body' | 'cc' | 'from' | 'subject' | 'to'>>;
  sendNotfication?: Resolver<Maybe<ResolversTypes['NotificationOutput']>, ParentType, ContextType, RequireFields<mutation_rootsendNotficationArgs, 'notfication'>>;
  sendSMS?: Resolver<Maybe<ResolversTypes['SendSMSOutput']>, ParentType, ContextType, RequireFields<mutation_rootsendSMSArgs, 'body' | 'to'>>;
  sendSmsToken?: Resolver<Maybe<ResolversTypes['SendSMSTokenOutput']>, ParentType, ContextType, Partial<mutation_rootsendSmsTokenArgs>>;
  setUpOrganization?: Resolver<Maybe<ResolversTypes['setUpOrganizationOutput']>, ParentType, ContextType, Partial<mutation_rootsetUpOrganizationArgs>>;
  synchronizeTelephonyDomainUsers?: Resolver<Maybe<ResolversTypes['StatusOutput']>, ParentType, ContextType>;
  task?: Resolver<Maybe<ResolversTypes['taskmutation_root']>, ParentType, ContextType>;
  telephony?: Resolver<Maybe<ResolversTypes['telephonymutation_root']>, ParentType, ContextType>;
  testNotificationSettings?: Resolver<Maybe<ResolversTypes['testNotificationSettingsResult']>, ParentType, ContextType, RequireFields<mutation_roottestNotificationSettingsArgs, 'id' | 'number' | 'receiverNumber'>>;
  updateActivityDirection?: Resolver<Maybe<ResolversTypes['ActivityDirectionMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateActivityDirectionArgs, 'where'>>;
  updateActivityDirectionByPk?: Resolver<Maybe<ResolversTypes['ActivityDirection']>, ParentType, ContextType, RequireFields<mutation_rootupdateActivityDirectionByPkArgs, 'pkColumns'>>;
  updateActivityDirectionMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['ActivityDirectionMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateActivityDirectionManyArgs, 'updates'>>;
  updateActivityParticipant?: Resolver<Maybe<ResolversTypes['activityParticipant']>, ParentType, ContextType, RequireFields<mutation_rootupdateActivityParticipantArgs, 'pkColumns'>>;
  updateActivityParticipants?: Resolver<Maybe<ResolversTypes['activityParticipantMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateActivityParticipantsArgs, 'where'>>;
  updateActivityProvider?: Resolver<Maybe<ResolversTypes['ActivityProviderMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateActivityProviderArgs, 'where'>>;
  updateActivityProviderByPk?: Resolver<Maybe<ResolversTypes['ActivityProvider']>, ParentType, ContextType, RequireFields<mutation_rootupdateActivityProviderByPkArgs, 'pkColumns'>>;
  updateActivityProviderMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['ActivityProviderMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateActivityProviderManyArgs, 'updates'>>;
  updateActivityStatus?: Resolver<Maybe<ResolversTypes['ActivityStatus']>, ParentType, ContextType, RequireFields<mutation_rootupdateActivityStatusArgs, 'pkColumns'>>;
  updateActivityStatuses?: Resolver<Maybe<ResolversTypes['ActivityStatusMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateActivityStatusesArgs, 'where'>>;
  updateActivityType?: Resolver<Maybe<ResolversTypes['ActivityType']>, ParentType, ContextType, RequireFields<mutation_rootupdateActivityTypeArgs, 'pkColumns'>>;
  updateActivityTypes?: Resolver<Maybe<ResolversTypes['ActivityTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateActivityTypesArgs, 'where'>>;
  updateAddress?: Resolver<Maybe<ResolversTypes['address']>, ParentType, ContextType, RequireFields<mutation_rootupdateAddressArgs, 'pkColumns'>>;
  updateAddresses?: Resolver<Maybe<ResolversTypes['addressMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateAddressesArgs, 'where'>>;
  updateBlockedDomainUser?: Resolver<Maybe<ResolversTypes['blockedDomainUser']>, ParentType, ContextType, RequireFields<mutation_rootupdateBlockedDomainUserArgs, 'pkColumns'>>;
  updateBlockedDomainUsers?: Resolver<Maybe<ResolversTypes['blockedDomainUserMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateBlockedDomainUsersArgs, 'where'>>;
  updateBusinessDomainActivityType?: Resolver<Maybe<ResolversTypes['BusinessDomainActivityTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessDomainActivityTypeArgs, 'where'>>;
  updateBusinessDomainActivityTypeByPk?: Resolver<Maybe<ResolversTypes['BusinessDomainActivityType']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessDomainActivityTypeByPkArgs, 'pkColumns'>>;
  updateBusinessDomainActivityTypeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['BusinessDomainActivityTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessDomainActivityTypeManyArgs, 'updates'>>;
  updateBusinessFeedType?: Resolver<Maybe<ResolversTypes['BusinessFeedTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessFeedTypeArgs, 'where'>>;
  updateBusinessFeedTypeByPk?: Resolver<Maybe<ResolversTypes['BusinessFeedType']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessFeedTypeByPkArgs, 'pkColumns'>>;
  updateBusinessFeedTypeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['BusinessFeedTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessFeedTypeManyArgs, 'updates'>>;
  updateBusinessMessageAttachments?: Resolver<Maybe<ResolversTypes['BusinessMessageAttachmentsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessMessageAttachmentsArgs, 'where'>>;
  updateBusinessMessageAttachmentsByPk?: Resolver<Maybe<ResolversTypes['BusinessMessageAttachments']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessMessageAttachmentsByPkArgs, 'pkColumns'>>;
  updateBusinessMessageAttachmentsMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['BusinessMessageAttachmentsMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessMessageAttachmentsManyArgs, 'updates'>>;
  updateBusinessOrganizationUserCallbackAnswer?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserCallbackAnswerMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessOrganizationUserCallbackAnswerArgs, 'where'>>;
  updateBusinessOrganizationUserCallbackAnswerByPk?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserCallbackAnswer']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessOrganizationUserCallbackAnswerByPkArgs, 'pkColumns'>>;
  updateBusinessOrganizationUserCallbackAnswerMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['BusinessOrganizationUserCallbackAnswerMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessOrganizationUserCallbackAnswerManyArgs, 'updates'>>;
  updateBusinessOrganizationUserEmail?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserEmailMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessOrganizationUserEmailArgs, 'where'>>;
  updateBusinessOrganizationUserEmailByPk?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserEmail']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessOrganizationUserEmailByPkArgs, 'pkColumns'>>;
  updateBusinessOrganizationUserEmailMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['BusinessOrganizationUserEmailMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessOrganizationUserEmailManyArgs, 'updates'>>;
  updateBusinessOrganizationUserEmailType?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserEmailTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessOrganizationUserEmailTypeArgs, 'where'>>;
  updateBusinessOrganizationUserEmailTypeByPk?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserEmailType']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessOrganizationUserEmailTypeByPkArgs, 'pkColumns'>>;
  updateBusinessOrganizationUserEmailTypeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['BusinessOrganizationUserEmailTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessOrganizationUserEmailTypeManyArgs, 'updates'>>;
  updateBusinessOrganizationUserRequestMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['BusinessOrganizationUserRequestMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessOrganizationUserRequestManyArgs, 'updates'>>;
  updateBusinessOrganizationUserRequestType?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserRequestTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessOrganizationUserRequestTypeArgs, 'where'>>;
  updateBusinessOrganizationUserRequestTypeByPk?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserRequestType']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessOrganizationUserRequestTypeByPkArgs, 'pkColumns'>>;
  updateBusinessOrganizationUserRequestTypeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['BusinessOrganizationUserRequestTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessOrganizationUserRequestTypeManyArgs, 'updates'>>;
  updateBusinessOrganizationUserSuggestionType?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserSuggestionTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessOrganizationUserSuggestionTypeArgs, 'where'>>;
  updateBusinessOrganizationUserSuggestionTypeByPk?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserSuggestionType']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessOrganizationUserSuggestionTypeByPkArgs, 'pkColumns'>>;
  updateBusinessOrganizationUserSuggestionTypeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['BusinessOrganizationUserSuggestionTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessOrganizationUserSuggestionTypeManyArgs, 'updates'>>;
  updateBusinessOrganizationUserSuggestions?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserSuggestionsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessOrganizationUserSuggestionsArgs, 'where'>>;
  updateBusinessOrganizationUserSuggestionsByPk?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserSuggestions']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessOrganizationUserSuggestionsByPkArgs, 'pkColumns'>>;
  updateBusinessOrganizationUserSuggestionsMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['BusinessOrganizationUserSuggestionsMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessOrganizationUserSuggestionsManyArgs, 'updates'>>;
  updateBusinessOrganizationUserUrlAddress?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserUrlAddressMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessOrganizationUserUrlAddressArgs, 'where'>>;
  updateBusinessOrganizationUserUrlAddressByPk?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserUrlAddress']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessOrganizationUserUrlAddressByPkArgs, 'pkColumns'>>;
  updateBusinessOrganizationUserUrlAddressMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['BusinessOrganizationUserUrlAddressMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessOrganizationUserUrlAddressManyArgs, 'updates'>>;
  updateBusinessOrganizationUserUrlAddressType?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserUrlAddressTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessOrganizationUserUrlAddressTypeArgs, 'where'>>;
  updateBusinessOrganizationUserUrlAddressTypeByPk?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserUrlAddressType']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessOrganizationUserUrlAddressTypeByPkArgs, 'pkColumns'>>;
  updateBusinessOrganizationUserUrlAddressTypeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['BusinessOrganizationUserUrlAddressTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessOrganizationUserUrlAddressTypeManyArgs, 'updates'>>;
  updateBusinessQueueItemAlarmType?: Resolver<Maybe<ResolversTypes['BusinessQueueItemAlarmTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessQueueItemAlarmTypeArgs, 'where'>>;
  updateBusinessQueueItemAlarmTypeByPk?: Resolver<Maybe<ResolversTypes['BusinessQueueItemAlarmType']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessQueueItemAlarmTypeByPkArgs, 'pkColumns'>>;
  updateBusinessQueueItemAlarmTypeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['BusinessQueueItemAlarmTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessQueueItemAlarmTypeManyArgs, 'updates'>>;
  updateBusinessQueueItemAlarms?: Resolver<Maybe<ResolversTypes['BusinessQueueItemAlarmsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessQueueItemAlarmsArgs, 'where'>>;
  updateBusinessQueueItemAlarmsByPk?: Resolver<Maybe<ResolversTypes['BusinessQueueItemAlarms']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessQueueItemAlarmsByPkArgs, 'pkColumns'>>;
  updateBusinessQueueItemAlarmsMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['BusinessQueueItemAlarmsMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessQueueItemAlarmsManyArgs, 'updates'>>;
  updateBusinessQueueItemCollaboration?: Resolver<Maybe<ResolversTypes['businessQueueItemCollaboration']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessQueueItemCollaborationArgs, 'pkColumns'>>;
  updateBusinessQueueItemCollaborations?: Resolver<Maybe<ResolversTypes['businessQueueItemCollaborationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessQueueItemCollaborationsArgs, 'where'>>;
  updateBusinessQueueItemParticipantChannelType?: Resolver<Maybe<ResolversTypes['BusinessQueueItemParticipantChannelTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessQueueItemParticipantChannelTypeArgs, 'where'>>;
  updateBusinessQueueItemParticipantChannelTypeByPk?: Resolver<Maybe<ResolversTypes['BusinessQueueItemParticipantChannelType']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessQueueItemParticipantChannelTypeByPkArgs, 'pkColumns'>>;
  updateBusinessQueueItemParticipantChannelTypeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['BusinessQueueItemParticipantChannelTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessQueueItemParticipantChannelTypeManyArgs, 'updates'>>;
  updateBusinessQueueItemSubType?: Resolver<Maybe<ResolversTypes['BusinessQueueItemSubTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessQueueItemSubTypeArgs, 'where'>>;
  updateBusinessQueueItemSubTypeByPk?: Resolver<Maybe<ResolversTypes['BusinessQueueItemSubType']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessQueueItemSubTypeByPkArgs, 'pkColumns'>>;
  updateBusinessQueueItemSubTypeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['BusinessQueueItemSubTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessQueueItemSubTypeManyArgs, 'updates'>>;
  updateBusinessUserContact?: Resolver<Maybe<ResolversTypes['businessUserContacts']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessUserContactArgs, 'pkColumns'>>;
  updateBusinessUserContactNumbers?: Resolver<Maybe<ResolversTypes['BusinessUserContactNumbersMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessUserContactNumbersArgs, 'where'>>;
  updateBusinessUserContactNumbersByPk?: Resolver<Maybe<ResolversTypes['BusinessUserContactNumbers']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessUserContactNumbersByPkArgs, 'pkColumns'>>;
  updateBusinessUserContactNumbersMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['BusinessUserContactNumbersMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessUserContactNumbersManyArgs, 'updates'>>;
  updateBusinessUserContacts?: Resolver<Maybe<ResolversTypes['businessUserContactsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessUserContactsArgs, 'where'>>;
  updateBusinessUserFeed?: Resolver<Maybe<ResolversTypes['BusinessUserFeedMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessUserFeedArgs, 'where'>>;
  updateBusinessUserFeedByPk?: Resolver<Maybe<ResolversTypes['BusinessUserFeed']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessUserFeedByPkArgs, 'pkColumns'>>;
  updateBusinessUserFeedMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['BusinessUserFeedMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessUserFeedManyArgs, 'updates'>>;
  updateBusinessUserRequestStatus?: Resolver<Maybe<ResolversTypes['BusinessUserRequestStatusMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessUserRequestStatusArgs, 'where'>>;
  updateBusinessUserRequestStatusByPk?: Resolver<Maybe<ResolversTypes['BusinessUserRequestStatus']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessUserRequestStatusByPkArgs, 'pkColumns'>>;
  updateBusinessUserRequestStatusMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['BusinessUserRequestStatusMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessUserRequestStatusManyArgs, 'updates'>>;
  updateBusinessUserSetting?: Resolver<Maybe<ResolversTypes['businessUserSettings']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessUserSettingArgs, 'pkColumns'>>;
  updateBusinessUserSettings?: Resolver<Maybe<ResolversTypes['businessUserSettingsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessUserSettingsArgs, 'where'>>;
  updateBusinessUserStates?: Resolver<Maybe<ResolversTypes['BusinessUserStatesMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessUserStatesArgs, 'where'>>;
  updateBusinessUserStatesByPk?: Resolver<Maybe<ResolversTypes['BusinessUserStates']>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessUserStatesByPkArgs, 'pkColumns'>>;
  updateBusinessUserStatesMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['BusinessUserStatesMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateBusinessUserStatesManyArgs, 'updates'>>;
  updateCrmContext?: Resolver<Maybe<ResolversTypes['CrmContextMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmContextArgs, 'where'>>;
  updateCrmContextByPk?: Resolver<Maybe<ResolversTypes['CrmContext']>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmContextByPkArgs, 'pkColumns'>>;
  updateCrmContextMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['CrmContextMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmContextManyArgs, 'updates'>>;
  updateCrmContextType?: Resolver<Maybe<ResolversTypes['CrmContextTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmContextTypeArgs, 'where'>>;
  updateCrmContextTypeByPk?: Resolver<Maybe<ResolversTypes['CrmContextType']>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmContextTypeByPkArgs, 'pkColumns'>>;
  updateCrmContextTypeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['CrmContextTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmContextTypeManyArgs, 'updates'>>;
  updateCrmCreatorType?: Resolver<Maybe<ResolversTypes['CrmCreatorTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmCreatorTypeArgs, 'where'>>;
  updateCrmCreatorTypeByPk?: Resolver<Maybe<ResolversTypes['CrmCreatorType']>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmCreatorTypeByPkArgs, 'pkColumns'>>;
  updateCrmCreatorTypeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['CrmCreatorTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmCreatorTypeManyArgs, 'updates'>>;
  updateCrmCrmType?: Resolver<Maybe<ResolversTypes['CrmCrmTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmCrmTypeArgs, 'where'>>;
  updateCrmCrmTypeByPk?: Resolver<Maybe<ResolversTypes['CrmCrmType']>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmCrmTypeByPkArgs, 'pkColumns'>>;
  updateCrmCrmTypeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['CrmCrmTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmCrmTypeManyArgs, 'updates'>>;
  updateCrmDirectionType?: Resolver<Maybe<ResolversTypes['CrmDirectionTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmDirectionTypeArgs, 'where'>>;
  updateCrmDirectionTypeByPk?: Resolver<Maybe<ResolversTypes['CrmDirectionType']>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmDirectionTypeByPkArgs, 'pkColumns'>>;
  updateCrmDirectionTypeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['CrmDirectionTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmDirectionTypeManyArgs, 'updates'>>;
  updateCrmEntity?: Resolver<Maybe<ResolversTypes['CrmEntityMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmEntityArgs, 'where'>>;
  updateCrmEntityByPk?: Resolver<Maybe<ResolversTypes['CrmEntity']>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmEntityByPkArgs, 'pkColumns'>>;
  updateCrmEntityMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['CrmEntityMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmEntityManyArgs, 'updates'>>;
  updateCrmEvent?: Resolver<Maybe<ResolversTypes['CrmEventMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmEventArgs, 'where'>>;
  updateCrmEventByPk?: Resolver<Maybe<ResolversTypes['CrmEvent']>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmEventByPkArgs, 'pkColumns'>>;
  updateCrmEventMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['CrmEventMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmEventManyArgs, 'updates'>>;
  updateCrmEventType?: Resolver<Maybe<ResolversTypes['CrmEventTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmEventTypeArgs, 'where'>>;
  updateCrmEventTypeByPk?: Resolver<Maybe<ResolversTypes['CrmEventType']>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmEventTypeByPkArgs, 'pkColumns'>>;
  updateCrmEventTypeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['CrmEventTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmEventTypeManyArgs, 'updates'>>;
  updateCrmStatusCode?: Resolver<Maybe<ResolversTypes['CrmStatusCodeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmStatusCodeArgs, 'where'>>;
  updateCrmStatusCodeByPk?: Resolver<Maybe<ResolversTypes['CrmStatusCode']>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmStatusCodeByPkArgs, 'pkColumns'>>;
  updateCrmStatusCodeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['CrmStatusCodeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmStatusCodeManyArgs, 'updates'>>;
  updateCrmStatusMessage?: Resolver<Maybe<ResolversTypes['crmStatusMessage']>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmStatusMessageArgs, 'pkColumns'>>;
  updateCrmStatusMessageMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['crmStatusMessageMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmStatusMessageManyArgs, 'updates'>>;
  updateCrmStatusMessages?: Resolver<Maybe<ResolversTypes['crmStatusMessageMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmStatusMessagesArgs, 'where'>>;
  updateCrmSystemType?: Resolver<Maybe<ResolversTypes['CrmSystemTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmSystemTypeArgs, 'where'>>;
  updateCrmSystemTypeByPk?: Resolver<Maybe<ResolversTypes['CrmSystemType']>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmSystemTypeByPkArgs, 'pkColumns'>>;
  updateCrmSystemTypeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['CrmSystemTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmSystemTypeManyArgs, 'updates'>>;
  updateCrmTraceContext?: Resolver<Maybe<ResolversTypes['CrmTraceContextMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmTraceContextArgs, 'where'>>;
  updateCrmTraceContextByPk?: Resolver<Maybe<ResolversTypes['CrmTraceContext']>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmTraceContextByPkArgs, 'pkColumns'>>;
  updateCrmTraceContextMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['CrmTraceContextMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmTraceContextManyArgs, 'updates'>>;
  updateCrmUnifiedEntityType?: Resolver<Maybe<ResolversTypes['CrmUnifiedEntityTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmUnifiedEntityTypeArgs, 'where'>>;
  updateCrmUnifiedEntityTypeByPk?: Resolver<Maybe<ResolversTypes['CrmUnifiedEntityType']>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmUnifiedEntityTypeByPkArgs, 'pkColumns'>>;
  updateCrmUnifiedEntityTypeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['CrmUnifiedEntityTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmUnifiedEntityTypeManyArgs, 'updates'>>;
  updateCrmYoutelloCatalystIdMapping?: Resolver<Maybe<ResolversTypes['crmYoutelloCatalystIdMappingMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmYoutelloCatalystIdMappingArgs, 'where'>>;
  updateCrmYoutelloCatalystIdMappingByPk?: Resolver<Maybe<ResolversTypes['crmYoutelloCatalystIdMapping']>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmYoutelloCatalystIdMappingByPkArgs, 'pkColumns'>>;
  updateCrmYoutelloCatalystIdMappingMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['crmYoutelloCatalystIdMappingMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateCrmYoutelloCatalystIdMappingManyArgs, 'updates'>>;
  updateDashboardData?: Resolver<Maybe<ResolversTypes['updateDashboardDataOutput']>, ParentType, ContextType, RequireFields<mutation_rootupdateDashboardDataArgs, 'id'>>;
  updateDomainActivities?: Resolver<Maybe<ResolversTypes['domainActivityMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateDomainActivitiesArgs, 'where'>>;
  updateDomainActivity?: Resolver<Maybe<ResolversTypes['domainActivity']>, ParentType, ContextType, RequireFields<mutation_rootupdateDomainActivityArgs, 'pkColumns'>>;
  updateDomainOrganization?: Resolver<Maybe<ResolversTypes['domainOrganization']>, ParentType, ContextType, RequireFields<mutation_rootupdateDomainOrganizationArgs, 'pkColumns'>>;
  updateDomainOrganizations?: Resolver<Maybe<ResolversTypes['domainOrganizationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateDomainOrganizationsArgs, 'where'>>;
  updateDomainParticipant?: Resolver<Maybe<ResolversTypes['domainParticipant']>, ParentType, ContextType, RequireFields<mutation_rootupdateDomainParticipantArgs, 'pkColumns'>>;
  updateDomainParticipants?: Resolver<Maybe<ResolversTypes['domainParticipantMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateDomainParticipantsArgs, 'where'>>;
  updateDomainType?: Resolver<Maybe<ResolversTypes['domainType']>, ParentType, ContextType, RequireFields<mutation_rootupdateDomainTypeArgs, 'pkColumns'>>;
  updateDomainTypes?: Resolver<Maybe<ResolversTypes['domainTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateDomainTypesArgs, 'where'>>;
  updateDomainUser?: Resolver<Maybe<ResolversTypes['domainUser']>, ParentType, ContextType, RequireFields<mutation_rootupdateDomainUserArgs, 'pkColumns'>>;
  updateDomainUserCategories?: Resolver<Maybe<ResolversTypes['domainUserCategoryMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateDomainUserCategoriesArgs, 'where'>>;
  updateDomainUserCategory?: Resolver<Maybe<ResolversTypes['domainUserCategory']>, ParentType, ContextType, RequireFields<mutation_rootupdateDomainUserCategoryArgs, 'pkColumns'>>;
  updateDomainUsers?: Resolver<Maybe<ResolversTypes['domainUserMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateDomainUsersArgs, 'where'>>;
  updateLanguages?: Resolver<Maybe<ResolversTypes['languagesMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateLanguagesArgs, 'where'>>;
  updateLanguagesByPk?: Resolver<Maybe<ResolversTypes['languages']>, ParentType, ContextType, RequireFields<mutation_rootupdateLanguagesByPkArgs, 'pkColumns'>>;
  updateLanguagesMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['languagesMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateLanguagesManyArgs, 'updates'>>;
  updateManyActivityParticipants?: Resolver<Maybe<Array<Maybe<ResolversTypes['activityParticipantMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyActivityParticipantsArgs, 'updates'>>;
  updateManyActivityStatuses?: Resolver<Maybe<Array<Maybe<ResolversTypes['ActivityStatusMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyActivityStatusesArgs, 'updates'>>;
  updateManyActivityTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['ActivityTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyActivityTypesArgs, 'updates'>>;
  updateManyAddresses?: Resolver<Maybe<Array<Maybe<ResolversTypes['addressMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyAddressesArgs, 'updates'>>;
  updateManyBlockedDomainUsers?: Resolver<Maybe<Array<Maybe<ResolversTypes['blockedDomainUserMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyBlockedDomainUsersArgs, 'updates'>>;
  updateManyBusinessQueueItemCollaborations?: Resolver<Maybe<Array<Maybe<ResolversTypes['businessQueueItemCollaborationMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyBusinessQueueItemCollaborationsArgs, 'updates'>>;
  updateManyBusinessUserContacts?: Resolver<Maybe<Array<Maybe<ResolversTypes['businessUserContactsMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyBusinessUserContactsArgs, 'updates'>>;
  updateManyBusinessUserSettings?: Resolver<Maybe<Array<Maybe<ResolversTypes['businessUserSettingsMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyBusinessUserSettingsArgs, 'updates'>>;
  updateManyDomainActivities?: Resolver<Maybe<Array<Maybe<ResolversTypes['domainActivityMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyDomainActivitiesArgs, 'updates'>>;
  updateManyDomainOrganizations?: Resolver<Maybe<Array<Maybe<ResolversTypes['domainOrganizationMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyDomainOrganizationsArgs, 'updates'>>;
  updateManyDomainParticipants?: Resolver<Maybe<Array<Maybe<ResolversTypes['domainParticipantMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyDomainParticipantsArgs, 'updates'>>;
  updateManyDomainTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['domainTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyDomainTypesArgs, 'updates'>>;
  updateManyDomainUserCategories?: Resolver<Maybe<Array<Maybe<ResolversTypes['domainUserCategoryMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyDomainUserCategoriesArgs, 'updates'>>;
  updateManyDomainUsers?: Resolver<Maybe<Array<Maybe<ResolversTypes['domainUserMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyDomainUsersArgs, 'updates'>>;
  updateManyMessageTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['messageTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyMessageTypesArgs, 'updates'>>;
  updateManyMessages?: Resolver<Maybe<Array<Maybe<ResolversTypes['messageMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyMessagesArgs, 'updates'>>;
  updateManyMessagingActivityOrganizations?: Resolver<Maybe<Array<Maybe<ResolversTypes['messagingActivityOrganizationMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyMessagingActivityOrganizationsArgs, 'updates'>>;
  updateManyNotificationSends?: Resolver<Maybe<Array<Maybe<ResolversTypes['notificationSendMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyNotificationSendsArgs, 'updates'>>;
  updateManyNotificationSettingActivities?: Resolver<Maybe<Array<Maybe<ResolversTypes['notificationSettingActivityMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyNotificationSettingActivitiesArgs, 'updates'>>;
  updateManyNotificationUserDevices?: Resolver<Maybe<Array<Maybe<ResolversTypes['notificationUserDeviceMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyNotificationUserDevicesArgs, 'updates'>>;
  updateManyNotificationUsers?: Resolver<Maybe<Array<Maybe<ResolversTypes['notificationUserMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyNotificationUsersArgs, 'updates'>>;
  updateManyNotifications?: Resolver<Maybe<Array<Maybe<ResolversTypes['notificationMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyNotificationsArgs, 'updates'>>;
  updateManyOrdersIntegrations?: Resolver<Maybe<Array<Maybe<ResolversTypes['ordersIntegrationsMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyOrdersIntegrationsArgs, 'updates'>>;
  updateManyOrganizationUserAttachments?: Resolver<Maybe<Array<Maybe<ResolversTypes['organizationUserAttachmentsMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyOrganizationUserAttachmentsArgs, 'updates'>>;
  updateManyOrganizationUserAttentionNotes?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrganizationUserAttentionNoteMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyOrganizationUserAttentionNotesArgs, 'updates'>>;
  updateManyOrganizationUserDetailTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['organizationUserDetailTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyOrganizationUserDetailTypesArgs, 'updates'>>;
  updateManyOrganizationUserDetails?: Resolver<Maybe<Array<Maybe<ResolversTypes['organizationUserDetailMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyOrganizationUserDetailsArgs, 'updates'>>;
  updateManyOrganizationUserInvites?: Resolver<Maybe<Array<Maybe<ResolversTypes['organizationUserInviteMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyOrganizationUserInvitesArgs, 'updates'>>;
  updateManyOrganizationUserStatuses?: Resolver<Maybe<Array<Maybe<ResolversTypes['organizationUserStatusMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyOrganizationUserStatusesArgs, 'updates'>>;
  updateManyOrganizationUsers?: Resolver<Maybe<Array<Maybe<ResolversTypes['organizationUserMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyOrganizationUsersArgs, 'updates'>>;
  updateManyOrganizations?: Resolver<Maybe<Array<Maybe<ResolversTypes['organizationMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyOrganizationsArgs, 'updates'>>;
  updateManyPhoneNumberVerificationStatuses?: Resolver<Maybe<Array<Maybe<ResolversTypes['phoneNumberVerificationStatusMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyPhoneNumberVerificationStatusesArgs, 'updates'>>;
  updateManyQueueItems?: Resolver<Maybe<Array<Maybe<ResolversTypes['queueItemMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyQueueItemsArgs, 'updates'>>;
  updateManyRelOrganizationUserDomainUsers?: Resolver<Maybe<Array<Maybe<ResolversTypes['relOrganizationUserDomainUserMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyRelOrganizationUserDomainUsersArgs, 'updates'>>;
  updateManyUserDetails?: Resolver<Maybe<Array<Maybe<ResolversTypes['userDetailMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyUserDetailsArgs, 'updates'>>;
  updateManyUserDetailsTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['userDetailsTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyUserDetailsTypesArgs, 'updates'>>;
  updateManyUserDevices?: Resolver<Maybe<Array<Maybe<ResolversTypes['userDeviceMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyUserDevicesArgs, 'updates'>>;
  updateManyUserPhoneNumbers?: Resolver<Maybe<Array<Maybe<ResolversTypes['userPhoneNumberMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyUserPhoneNumbersArgs, 'updates'>>;
  updateManyUserRoles?: Resolver<Maybe<Array<Maybe<ResolversTypes['userRoleMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyUserRolesArgs, 'updates'>>;
  updateManyUsers?: Resolver<Maybe<Array<Maybe<ResolversTypes['userMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateManyUsersArgs, 'updates'>>;
  updateMessage?: Resolver<Maybe<ResolversTypes['message']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessageArgs, 'pkColumns'>>;
  updateMessageType?: Resolver<Maybe<ResolversTypes['messageType']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessageTypeArgs, 'pkColumns'>>;
  updateMessageTypes?: Resolver<Maybe<ResolversTypes['messageTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessageTypesArgs, 'where'>>;
  updateMessages?: Resolver<Maybe<ResolversTypes['messageMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagesArgs, 'where'>>;
  updateMessagingActivities?: Resolver<Maybe<ResolversTypes['messagingActivityMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingActivitiesArgs, 'where'>>;
  updateMessagingActivity?: Resolver<Maybe<ResolversTypes['messagingActivity']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingActivityArgs, 'pkColumns'>>;
  updateMessagingActivityMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['messagingActivityMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingActivityManyArgs, 'updates'>>;
  updateMessagingActivityOrganization?: Resolver<Maybe<ResolversTypes['messagingActivityOrganization']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingActivityOrganizationArgs, 'pkColumns'>>;
  updateMessagingActivityOrganizations?: Resolver<Maybe<ResolversTypes['messagingActivityOrganizationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingActivityOrganizationsArgs, 'where'>>;
  updateMessagingActivitySettings?: Resolver<Maybe<ResolversTypes['MessagingActivitySettingsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingActivitySettingsArgs, 'where'>>;
  updateMessagingActivitySettingsByPk?: Resolver<Maybe<ResolversTypes['MessagingActivitySettings']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingActivitySettingsByPkArgs, 'pkColumns'>>;
  updateMessagingActivitySettingsMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['MessagingActivitySettingsMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingActivitySettingsManyArgs, 'updates'>>;
  updateMessagingActivitySettingsNotificationSettingType?: Resolver<Maybe<ResolversTypes['MessagingActivitySettingsNotificationSettingTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingActivitySettingsNotificationSettingTypeArgs, 'where'>>;
  updateMessagingActivitySettingsNotificationSettingTypeByPk?: Resolver<Maybe<ResolversTypes['MessagingActivitySettingsNotificationSettingType']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingActivitySettingsNotificationSettingTypeByPkArgs, 'pkColumns'>>;
  updateMessagingActivitySettingsNotificationSettingTypeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['MessagingActivitySettingsNotificationSettingTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingActivitySettingsNotificationSettingTypeManyArgs, 'updates'>>;
  updateMessagingActivityType?: Resolver<Maybe<ResolversTypes['messagingActivityType']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingActivityTypeArgs, 'pkColumns'>>;
  updateMessagingActivityTypeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['messagingActivityTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingActivityTypeManyArgs, 'updates'>>;
  updateMessagingActivityTypes?: Resolver<Maybe<ResolversTypes['messagingActivityTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingActivityTypesArgs, 'where'>>;
  updateMessagingActivityUser?: Resolver<Maybe<ResolversTypes['messagingActivityUser']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingActivityUserArgs, 'pkColumns'>>;
  updateMessagingActivityUserMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['messagingActivityUserMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingActivityUserManyArgs, 'updates'>>;
  updateMessagingActivityUsers?: Resolver<Maybe<ResolversTypes['messagingActivityUserMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingActivityUsersArgs, 'where'>>;
  updateMessagingInvitation?: Resolver<Maybe<ResolversTypes['MessagingInvitationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingInvitationArgs, 'where'>>;
  updateMessagingInvitationByPk?: Resolver<Maybe<ResolversTypes['MessagingInvitation']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingInvitationByPkArgs, 'pkColumns'>>;
  updateMessagingInvitationMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['MessagingInvitationMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingInvitationManyArgs, 'updates'>>;
  updateMessagingMentions?: Resolver<Maybe<ResolversTypes['MessagingMentionsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingMentionsArgs, 'where'>>;
  updateMessagingMentionsByPk?: Resolver<Maybe<ResolversTypes['MessagingMentions']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingMentionsByPkArgs, 'pkColumns'>>;
  updateMessagingMentionsMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['MessagingMentionsMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingMentionsManyArgs, 'updates'>>;
  updateMessagingMessage?: Resolver<Maybe<ResolversTypes['messagingMessage']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingMessageArgs, 'pkColumns'>>;
  updateMessagingMessageAttachment?: Resolver<Maybe<ResolversTypes['MessagingMessageAttachmentMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingMessageAttachmentArgs, 'where'>>;
  updateMessagingMessageAttachmentByPk?: Resolver<Maybe<ResolversTypes['MessagingMessageAttachment']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingMessageAttachmentByPkArgs, 'pkColumns'>>;
  updateMessagingMessageAttachmentMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['MessagingMessageAttachmentMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingMessageAttachmentManyArgs, 'updates'>>;
  updateMessagingMessageAttachmentType?: Resolver<Maybe<ResolversTypes['MessagingMessageAttachmentTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingMessageAttachmentTypeArgs, 'where'>>;
  updateMessagingMessageAttachmentTypeByPk?: Resolver<Maybe<ResolversTypes['MessagingMessageAttachmentType']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingMessageAttachmentTypeByPkArgs, 'pkColumns'>>;
  updateMessagingMessageAttachmentTypeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['MessagingMessageAttachmentTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingMessageAttachmentTypeManyArgs, 'updates'>>;
  updateMessagingMessageEmoji?: Resolver<Maybe<ResolversTypes['messagingMessageEmoji']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingMessageEmojiArgs, 'pkColumns'>>;
  updateMessagingMessageEmojiMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['messagingMessageEmojiMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingMessageEmojiManyArgs, 'updates'>>;
  updateMessagingMessageEmojis?: Resolver<Maybe<ResolversTypes['messagingMessageEmojiMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingMessageEmojisArgs, 'where'>>;
  updateMessagingMessageMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['messagingMessageMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingMessageManyArgs, 'updates'>>;
  updateMessagingMessagePriority?: Resolver<Maybe<ResolversTypes['MessagingMessagePriorityMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingMessagePriorityArgs, 'where'>>;
  updateMessagingMessagePriorityByPk?: Resolver<Maybe<ResolversTypes['MessagingMessagePriority']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingMessagePriorityByPkArgs, 'pkColumns'>>;
  updateMessagingMessagePriorityMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['MessagingMessagePriorityMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingMessagePriorityManyArgs, 'updates'>>;
  updateMessagingMessageRead?: Resolver<Maybe<ResolversTypes['messagingMessageRead']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingMessageReadArgs, 'pkColumns'>>;
  updateMessagingMessageReadMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['messagingMessageReadMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingMessageReadManyArgs, 'updates'>>;
  updateMessagingMessageReads?: Resolver<Maybe<ResolversTypes['messagingMessageReadMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingMessageReadsArgs, 'where'>>;
  updateMessagingMessageType?: Resolver<Maybe<ResolversTypes['messagingMessageType']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingMessageTypeArgs, 'pkColumns'>>;
  updateMessagingMessageTypeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['messagingMessageTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingMessageTypeManyArgs, 'updates'>>;
  updateMessagingMessageTypes?: Resolver<Maybe<ResolversTypes['messagingMessageTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingMessageTypesArgs, 'where'>>;
  updateMessagingMessages?: Resolver<Maybe<ResolversTypes['messagingMessageMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateMessagingMessagesArgs, 'where'>>;
  updateNotification?: Resolver<Maybe<ResolversTypes['notification']>, ParentType, ContextType, RequireFields<mutation_rootupdateNotificationArgs, 'pkColumns'>>;
  updateNotificationNotificationDeviceSent?: Resolver<Maybe<ResolversTypes['NotificationNotificationDeviceSentMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateNotificationNotificationDeviceSentArgs, 'where'>>;
  updateNotificationNotificationDeviceSentByPk?: Resolver<Maybe<ResolversTypes['NotificationNotificationDeviceSent']>, ParentType, ContextType, RequireFields<mutation_rootupdateNotificationNotificationDeviceSentByPkArgs, 'pkColumns'>>;
  updateNotificationNotificationDeviceSentMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['NotificationNotificationDeviceSentMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateNotificationNotificationDeviceSentManyArgs, 'updates'>>;
  updateNotificationNotificationSettingActivityPrimaryEnum?: Resolver<Maybe<ResolversTypes['NotificationNotificationSettingActivityPrimaryEnumMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateNotificationNotificationSettingActivityPrimaryEnumArgs, 'where'>>;
  updateNotificationNotificationSettingActivityPrimaryEnumByPk?: Resolver<Maybe<ResolversTypes['NotificationNotificationSettingActivityPrimaryEnum']>, ParentType, ContextType, RequireFields<mutation_rootupdateNotificationNotificationSettingActivityPrimaryEnumByPkArgs, 'pkColumns'>>;
  updateNotificationNotificationSettingActivityPrimaryEnumMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['NotificationNotificationSettingActivityPrimaryEnumMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateNotificationNotificationSettingActivityPrimaryEnumManyArgs, 'updates'>>;
  updateNotificationSend?: Resolver<Maybe<ResolversTypes['notificationSend']>, ParentType, ContextType, RequireFields<mutation_rootupdateNotificationSendArgs, 'pkColumns'>>;
  updateNotificationSends?: Resolver<Maybe<ResolversTypes['notificationSendMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateNotificationSendsArgs, 'where'>>;
  updateNotificationSettingActivities?: Resolver<Maybe<ResolversTypes['notificationSettingActivityMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateNotificationSettingActivitiesArgs, 'where'>>;
  updateNotificationSettingActivity?: Resolver<Maybe<ResolversTypes['notificationSettingActivity']>, ParentType, ContextType, RequireFields<mutation_rootupdateNotificationSettingActivityArgs, 'pkColumns'>>;
  updateNotificationUser?: Resolver<Maybe<ResolversTypes['notificationUser']>, ParentType, ContextType, RequireFields<mutation_rootupdateNotificationUserArgs, 'pkColumns'>>;
  updateNotificationUserDevice?: Resolver<Maybe<ResolversTypes['notificationUserDevice']>, ParentType, ContextType, RequireFields<mutation_rootupdateNotificationUserDeviceArgs, 'pkColumns'>>;
  updateNotificationUserDevices?: Resolver<Maybe<ResolversTypes['notificationUserDeviceMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateNotificationUserDevicesArgs, 'where'>>;
  updateNotificationUsers?: Resolver<Maybe<ResolversTypes['notificationUserMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateNotificationUsersArgs, 'where'>>;
  updateNotifications?: Resolver<Maybe<ResolversTypes['notificationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateNotificationsArgs, 'where'>>;
  updateOrdersIntegration?: Resolver<Maybe<ResolversTypes['ordersIntegrations']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrdersIntegrationArgs, 'pkColumns'>>;
  updateOrdersIntegrations?: Resolver<Maybe<ResolversTypes['ordersIntegrationsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrdersIntegrationsArgs, 'where'>>;
  updateOrdersOrganizations?: Resolver<Maybe<ResolversTypes['OrdersOrganizationsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrdersOrganizationsArgs, 'where'>>;
  updateOrdersOrganizationsByPk?: Resolver<Maybe<ResolversTypes['OrdersOrganizations']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrdersOrganizationsByPkArgs, 'pkColumns'>>;
  updateOrdersOrganizationsMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrdersOrganizationsMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateOrdersOrganizationsManyArgs, 'updates'>>;
  updateOrdersRequest?: Resolver<Maybe<ResolversTypes['OrdersRequestMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrdersRequestArgs, 'where'>>;
  updateOrdersRequestByPk?: Resolver<Maybe<ResolversTypes['OrdersRequest']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrdersRequestByPkArgs, 'pkColumns'>>;
  updateOrdersRequestMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrdersRequestMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateOrdersRequestManyArgs, 'updates'>>;
  updateOrdersStatus?: Resolver<Maybe<ResolversTypes['OrdersStatusMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrdersStatusArgs, 'where'>>;
  updateOrdersStatusByPk?: Resolver<Maybe<ResolversTypes['OrdersStatus']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrdersStatusByPkArgs, 'pkColumns'>>;
  updateOrdersStatusMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrdersStatusMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateOrdersStatusManyArgs, 'updates'>>;
  updateOrdersType?: Resolver<Maybe<ResolversTypes['OrdersTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrdersTypeArgs, 'where'>>;
  updateOrdersTypeByPk?: Resolver<Maybe<ResolversTypes['OrdersType']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrdersTypeByPkArgs, 'pkColumns'>>;
  updateOrdersTypeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrdersTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateOrdersTypeManyArgs, 'updates'>>;
  updateOrganization?: Resolver<Maybe<ResolversTypes['organization']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationArgs, 'pkColumns'>>;
  updateOrganizationAuthorizationEnumGroup?: Resolver<Maybe<ResolversTypes['organizationAuthorizationEnumGroup']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationAuthorizationEnumGroupArgs, 'pkColumns'>>;
  updateOrganizationAuthorizationEnumGroupMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['organizationAuthorizationEnumGroupMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationAuthorizationEnumGroupManyArgs, 'updates'>>;
  updateOrganizationAuthorizationEnumGroups?: Resolver<Maybe<ResolversTypes['organizationAuthorizationEnumGroupMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationAuthorizationEnumGroupsArgs, 'where'>>;
  updateOrganizationAuthorizationGroup?: Resolver<Maybe<ResolversTypes['organizationAuthorizationGroup']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationAuthorizationGroupArgs, 'pkColumns'>>;
  updateOrganizationAuthorizationGroupMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['organizationAuthorizationGroupMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationAuthorizationGroupManyArgs, 'updates'>>;
  updateOrganizationAuthorizationGroups?: Resolver<Maybe<ResolversTypes['organizationAuthorizationGroupMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationAuthorizationGroupsArgs, 'where'>>;
  updateOrganizationOrganizationRelationship?: Resolver<Maybe<ResolversTypes['organizationOrganizationRelationship']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationOrganizationRelationshipArgs, 'pkColumns'>>;
  updateOrganizationOrganizationRelationshipCategories?: Resolver<Maybe<ResolversTypes['organizationOrganizationRelationshipCategoryMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationOrganizationRelationshipCategoriesArgs, 'where'>>;
  updateOrganizationOrganizationRelationshipCategory?: Resolver<Maybe<ResolversTypes['organizationOrganizationRelationshipCategory']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationOrganizationRelationshipCategoryArgs, 'pkColumns'>>;
  updateOrganizationOrganizationRelationshipCategoryMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['organizationOrganizationRelationshipCategoryMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationOrganizationRelationshipCategoryManyArgs, 'updates'>>;
  updateOrganizationOrganizationRelationshipMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['organizationOrganizationRelationshipMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationOrganizationRelationshipManyArgs, 'updates'>>;
  updateOrganizationOrganizationRelationships?: Resolver<Maybe<ResolversTypes['organizationOrganizationRelationshipMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationOrganizationRelationshipsArgs, 'where'>>;
  updateOrganizationOrganizationUserAuthorization?: Resolver<Maybe<ResolversTypes['organizationOrganizationUserAuthorization']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationOrganizationUserAuthorizationArgs, 'pkColumns'>>;
  updateOrganizationOrganizationUserAuthorizationMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['organizationOrganizationUserAuthorizationMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationOrganizationUserAuthorizationManyArgs, 'updates'>>;
  updateOrganizationOrganizationUserAuthorizations?: Resolver<Maybe<ResolversTypes['organizationOrganizationUserAuthorizationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationOrganizationUserAuthorizationsArgs, 'where'>>;
  updateOrganizationUser?: Resolver<Maybe<ResolversTypes['organizationUser']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationUserArgs, 'pkColumns'>>;
  updateOrganizationUserAttachment?: Resolver<Maybe<ResolversTypes['organizationUserAttachments']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationUserAttachmentArgs, 'pkColumns'>>;
  updateOrganizationUserAttachments?: Resolver<Maybe<ResolversTypes['organizationUserAttachmentsMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationUserAttachmentsArgs, 'where'>>;
  updateOrganizationUserAttentionNote?: Resolver<Maybe<ResolversTypes['OrganizationUserAttentionNote']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationUserAttentionNoteArgs, 'pkColumns'>>;
  updateOrganizationUserAttentionNotes?: Resolver<Maybe<ResolversTypes['OrganizationUserAttentionNoteMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationUserAttentionNotesArgs, 'where'>>;
  updateOrganizationUserAuthorization?: Resolver<Maybe<ResolversTypes['organizationUserAuthorization']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationUserAuthorizationArgs, 'pkColumns'>>;
  updateOrganizationUserAuthorizationMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['organizationUserAuthorizationMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationUserAuthorizationManyArgs, 'updates'>>;
  updateOrganizationUserAuthorizations?: Resolver<Maybe<ResolversTypes['organizationUserAuthorizationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationUserAuthorizationsArgs, 'where'>>;
  updateOrganizationUserDetail?: Resolver<Maybe<ResolversTypes['organizationUserDetail']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationUserDetailArgs, 'pkColumns'>>;
  updateOrganizationUserDetailType?: Resolver<Maybe<ResolversTypes['organizationUserDetailType']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationUserDetailTypeArgs, 'pkColumns'>>;
  updateOrganizationUserDetailTypes?: Resolver<Maybe<ResolversTypes['organizationUserDetailTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationUserDetailTypesArgs, 'where'>>;
  updateOrganizationUserDetails?: Resolver<Maybe<ResolversTypes['organizationUserDetailMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationUserDetailsArgs, 'where'>>;
  updateOrganizationUserInvite?: Resolver<Maybe<ResolversTypes['organizationUserInvite']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationUserInviteArgs, 'pkColumns'>>;
  updateOrganizationUserInvites?: Resolver<Maybe<ResolversTypes['organizationUserInviteMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationUserInvitesArgs, 'where'>>;
  updateOrganizationUserRequest?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserRequest']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationUserRequestArgs, 'pkColumns'>>;
  updateOrganizationUserRequests?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserRequestMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationUserRequestsArgs, 'where'>>;
  updateOrganizationUserStatus?: Resolver<Maybe<ResolversTypes['organizationUserStatus']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationUserStatusArgs, 'pkColumns'>>;
  updateOrganizationUserStatuses?: Resolver<Maybe<ResolversTypes['organizationUserStatusMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationUserStatusesArgs, 'where'>>;
  updateOrganizationUsers?: Resolver<Maybe<ResolversTypes['organizationUserMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationUsersArgs, 'where'>>;
  updateOrganizations?: Resolver<Maybe<ResolversTypes['organizationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateOrganizationsArgs, 'where'>>;
  updatePhoneNumberVerificationStatus?: Resolver<Maybe<ResolversTypes['phoneNumberVerificationStatus']>, ParentType, ContextType, RequireFields<mutation_rootupdatePhoneNumberVerificationStatusArgs, 'pkColumns'>>;
  updatePhoneNumberVerificationStatuses?: Resolver<Maybe<ResolversTypes['phoneNumberVerificationStatusMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdatePhoneNumberVerificationStatusesArgs, 'where'>>;
  updatePrompt?: Resolver<Maybe<ResolversTypes['PromptMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdatePromptArgs, 'where'>>;
  updatePromptByPk?: Resolver<Maybe<ResolversTypes['Prompt']>, ParentType, ContextType, RequireFields<mutation_rootupdatePromptByPkArgs, 'pkColumns'>>;
  updatePromptMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['PromptMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdatePromptManyArgs, 'updates'>>;
  updatePublicDevice?: Resolver<Maybe<ResolversTypes['publicDevice']>, ParentType, ContextType, RequireFields<mutation_rootupdatePublicDeviceArgs, 'pkColumns'>>;
  updatePublicDeviceMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['publicDeviceMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdatePublicDeviceManyArgs, 'updates'>>;
  updatePublicDevices?: Resolver<Maybe<ResolversTypes['publicDeviceMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdatePublicDevicesArgs, 'where'>>;
  updatePublicExternalRequest?: Resolver<Maybe<ResolversTypes['publicExternalRequest']>, ParentType, ContextType, RequireFields<mutation_rootupdatePublicExternalRequestArgs, 'pkColumns'>>;
  updatePublicExternalRequestMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['publicExternalRequestMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdatePublicExternalRequestManyArgs, 'updates'>>;
  updatePublicExternalRequests?: Resolver<Maybe<ResolversTypes['publicExternalRequestMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdatePublicExternalRequestsArgs, 'where'>>;
  updatePublicFile?: Resolver<Maybe<ResolversTypes['publicFile']>, ParentType, ContextType, RequireFields<mutation_rootupdatePublicFileArgs, 'pkColumns'>>;
  updatePublicFileMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['publicFileMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdatePublicFileManyArgs, 'updates'>>;
  updatePublicFiles?: Resolver<Maybe<ResolversTypes['publicFileMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdatePublicFilesArgs, 'where'>>;
  updatePublicNotification?: Resolver<Maybe<ResolversTypes['publicNotification']>, ParentType, ContextType, RequireFields<mutation_rootupdatePublicNotificationArgs, 'pkColumns'>>;
  updatePublicNotificationMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['publicNotificationMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdatePublicNotificationManyArgs, 'updates'>>;
  updatePublicNotifications?: Resolver<Maybe<ResolversTypes['publicNotificationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdatePublicNotificationsArgs, 'where'>>;
  updateQueueItem?: Resolver<Maybe<ResolversTypes['queueItem']>, ParentType, ContextType, RequireFields<mutation_rootupdateQueueItemArgs, 'pkColumns'>>;
  updateQueueItemFlexibilityType?: Resolver<Maybe<ResolversTypes['QueueItemFlexibilityTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateQueueItemFlexibilityTypeArgs, 'where'>>;
  updateQueueItemFlexibilityTypeByPk?: Resolver<Maybe<ResolversTypes['QueueItemFlexibilityType']>, ParentType, ContextType, RequireFields<mutation_rootupdateQueueItemFlexibilityTypeByPkArgs, 'pkColumns'>>;
  updateQueueItemFlexibilityTypeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['QueueItemFlexibilityTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateQueueItemFlexibilityTypeManyArgs, 'updates'>>;
  updateQueueItemParticipantResponsibilityType?: Resolver<Maybe<ResolversTypes['QueueItemParticipantResponsibilityTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateQueueItemParticipantResponsibilityTypeArgs, 'where'>>;
  updateQueueItemParticipantResponsibilityTypeByPk?: Resolver<Maybe<ResolversTypes['QueueItemParticipantResponsibilityType']>, ParentType, ContextType, RequireFields<mutation_rootupdateQueueItemParticipantResponsibilityTypeByPkArgs, 'pkColumns'>>;
  updateQueueItemParticipantResponsibilityTypeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['QueueItemParticipantResponsibilityTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateQueueItemParticipantResponsibilityTypeManyArgs, 'updates'>>;
  updateQueueItems?: Resolver<Maybe<ResolversTypes['queueItemMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateQueueItemsArgs, 'where'>>;
  updateRelOrganizationUserDomainUser?: Resolver<Maybe<ResolversTypes['relOrganizationUserDomainUser']>, ParentType, ContextType, RequireFields<mutation_rootupdateRelOrganizationUserDomainUserArgs, 'pkColumns'>>;
  updateRelOrganizationUserDomainUsers?: Resolver<Maybe<ResolversTypes['relOrganizationUserDomainUserMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateRelOrganizationUserDomainUsersArgs, 'where'>>;
  updateRelationType?: Resolver<Maybe<ResolversTypes['RelationTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateRelationTypeArgs, 'where'>>;
  updateRelationTypeByPk?: Resolver<Maybe<ResolversTypes['RelationType']>, ParentType, ContextType, RequireFields<mutation_rootupdateRelationTypeByPkArgs, 'pkColumns'>>;
  updateRelationTypeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['RelationTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateRelationTypeManyArgs, 'updates'>>;
  updateSmsConnector?: Resolver<Maybe<ResolversTypes['smsConnector']>, ParentType, ContextType, RequireFields<mutation_rootupdateSmsConnectorArgs, 'pkColumns'>>;
  updateSmsConnectorMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['smsConnectorMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateSmsConnectorManyArgs, 'updates'>>;
  updateSmsConnectors?: Resolver<Maybe<ResolversTypes['smsConnectorMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateSmsConnectorsArgs, 'where'>>;
  updateSmsGate?: Resolver<Maybe<ResolversTypes['smsGate']>, ParentType, ContextType, RequireFields<mutation_rootupdateSmsGateArgs, 'pkColumns'>>;
  updateSmsGateMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['smsGateMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateSmsGateManyArgs, 'updates'>>;
  updateSmsGates?: Resolver<Maybe<ResolversTypes['smsGateMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateSmsGatesArgs, 'where'>>;
  updateSmsLinkMobilitySmsContent?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsContent']>, ParentType, ContextType, RequireFields<mutation_rootupdateSmsLinkMobilitySmsContentArgs, 'pkColumns'>>;
  updateSmsLinkMobilitySmsContentMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['smsLinkMobilitySmsContentMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateSmsLinkMobilitySmsContentManyArgs, 'updates'>>;
  updateSmsLinkMobilitySmsContents?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsContentMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateSmsLinkMobilitySmsContentsArgs, 'where'>>;
  updateSmsLinkMobilitySmsMessage?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsMessage']>, ParentType, ContextType, RequireFields<mutation_rootupdateSmsLinkMobilitySmsMessageArgs, 'pkColumns'>>;
  updateSmsLinkMobilitySmsMessageMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['smsLinkMobilitySmsMessageMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateSmsLinkMobilitySmsMessageManyArgs, 'updates'>>;
  updateSmsLinkMobilitySmsMessages?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsMessageMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateSmsLinkMobilitySmsMessagesArgs, 'where'>>;
  updateSmsLinkMobilitySmsRoute?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsRoute']>, ParentType, ContextType, RequireFields<mutation_rootupdateSmsLinkMobilitySmsRouteArgs, 'pkColumns'>>;
  updateSmsLinkMobilitySmsRouteMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['smsLinkMobilitySmsRouteMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateSmsLinkMobilitySmsRouteManyArgs, 'updates'>>;
  updateSmsLinkMobilitySmsRoutes?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsRouteMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateSmsLinkMobilitySmsRoutesArgs, 'where'>>;
  updateSmsProvider?: Resolver<Maybe<ResolversTypes['smsProvider']>, ParentType, ContextType, RequireFields<mutation_rootupdateSmsProviderArgs, 'pkColumns'>>;
  updateSmsProviderMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['smsProviderMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateSmsProviderManyArgs, 'updates'>>;
  updateSmsProviders?: Resolver<Maybe<ResolversTypes['smsProviderMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateSmsProvidersArgs, 'where'>>;
  updateSmsSm?: Resolver<Maybe<ResolversTypes['smsSm']>, ParentType, ContextType, RequireFields<mutation_rootupdateSmsSmArgs, 'pkColumns'>>;
  updateSmsSmMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['smsSmMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateSmsSmManyArgs, 'updates'>>;
  updateSmsSms?: Resolver<Maybe<ResolversTypes['smsSmMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateSmsSmsArgs, 'where'>>;
  updateSmsSmsExternalIncomingLinkMobilities?: Resolver<Maybe<ResolversTypes['smsSmsExternalIncomingLinkMobilityMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateSmsSmsExternalIncomingLinkMobilitiesArgs, 'where'>>;
  updateSmsSmsExternalIncomingLinkMobility?: Resolver<Maybe<ResolversTypes['smsSmsExternalIncomingLinkMobility']>, ParentType, ContextType, RequireFields<mutation_rootupdateSmsSmsExternalIncomingLinkMobilityArgs, 'pkColumns'>>;
  updateSmsSmsExternalIncomingLinkMobilityMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['smsSmsExternalIncomingLinkMobilityMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateSmsSmsExternalIncomingLinkMobilityManyArgs, 'updates'>>;
  updateUser?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType, RequireFields<mutation_rootupdateUserArgs, 'pkColumns'>>;
  updateUserDetail?: Resolver<Maybe<ResolversTypes['userDetail']>, ParentType, ContextType, RequireFields<mutation_rootupdateUserDetailArgs, 'pkColumns'>>;
  updateUserDetails?: Resolver<Maybe<ResolversTypes['userDetailMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateUserDetailsArgs, 'where'>>;
  updateUserDetailsType?: Resolver<Maybe<ResolversTypes['userDetailsType']>, ParentType, ContextType, RequireFields<mutation_rootupdateUserDetailsTypeArgs, 'pkColumns'>>;
  updateUserDetailsTypes?: Resolver<Maybe<ResolversTypes['userDetailsTypeMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateUserDetailsTypesArgs, 'where'>>;
  updateUserDevice?: Resolver<Maybe<ResolversTypes['userDevice']>, ParentType, ContextType, RequireFields<mutation_rootupdateUserDeviceArgs, 'pkColumns'>>;
  updateUserDevices?: Resolver<Maybe<ResolversTypes['userDeviceMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateUserDevicesArgs, 'where'>>;
  updateUserPhoneNumber?: Resolver<Maybe<ResolversTypes['userPhoneNumber']>, ParentType, ContextType, RequireFields<mutation_rootupdateUserPhoneNumberArgs, 'pkColumns'>>;
  updateUserPhoneNumbers?: Resolver<Maybe<ResolversTypes['userPhoneNumberMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateUserPhoneNumbersArgs, 'where'>>;
  updateUserRole?: Resolver<Maybe<ResolversTypes['userRole']>, ParentType, ContextType, RequireFields<mutation_rootupdateUserRoleArgs, 'pkColumns'>>;
  updateUserRoles?: Resolver<Maybe<ResolversTypes['userRoleMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateUserRolesArgs, 'where'>>;
  updateUsers?: Resolver<Maybe<ResolversTypes['userMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateUsersArgs, 'where'>>;
  updateValidationValidation?: Resolver<Maybe<ResolversTypes['validationValidation']>, ParentType, ContextType, RequireFields<mutation_rootupdateValidationValidationArgs, 'pkColumns'>>;
  updateValidationValidationMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['validationValidationMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateValidationValidationManyArgs, 'updates'>>;
  updateValidationValidations?: Resolver<Maybe<ResolversTypes['validationValidationMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateValidationValidationsArgs, 'where'>>;
  updateVoiceTypes?: Resolver<Maybe<ResolversTypes['VoiceTypesMutationResponse']>, ParentType, ContextType, RequireFields<mutation_rootupdateVoiceTypesArgs, 'where'>>;
  updateVoiceTypesByPk?: Resolver<Maybe<ResolversTypes['VoiceTypes']>, ParentType, ContextType, RequireFields<mutation_rootupdateVoiceTypesByPkArgs, 'pkColumns'>>;
  updateVoiceTypesMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['VoiceTypesMutationResponse']>>>, ParentType, ContextType, RequireFields<mutation_rootupdateVoiceTypesManyArgs, 'updates'>>;
  userDelete?: Resolver<Maybe<ResolversTypes['userDeleteOutput']>, ParentType, ContextType, RequireFields<mutation_rootuserDeleteArgs, 'userId'>>;
  userUpdate?: Resolver<Maybe<ResolversTypes['UserUpdateOutput']>, ParentType, ContextType, RequireFields<mutation_rootuserUpdateArgs, 'user'>>;
  validateTelephonyCredentialsToOrg?: Resolver<Maybe<ResolversTypes['TelephonyCredentialsOutput']>, ParentType, ContextType, RequireFields<mutation_rootvalidateTelephonyCredentialsToOrgArgs, 'input'>>;
  verifyOrganizationUserPhoneNumber?: Resolver<Maybe<ResolversTypes['verifyOrganizationUserPhoneNumberOutput']>, ParentType, ContextType, RequireFields<mutation_rootverifyOrganizationUserPhoneNumberArgs, 'verifyOrganizationUserPhoneNumber'>>;
};

export type notificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['notification'] = ResolversParentTypes['notification']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  sourceDomain?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sourceId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  sourceTable?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceTriggerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationAggregate'] = ResolversParentTypes['notificationAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['notificationAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['notification']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationAggregateFields'] = ResolversParentTypes['notificationAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<notificationAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['notificationMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['notificationMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationMaxFields'] = ResolversParentTypes['notificationMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  sourceDomain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  sourceTable?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceTriggerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationMinFields'] = ResolversParentTypes['notificationMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  sourceDomain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  sourceTable?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceTriggerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationMutationResponse'] = ResolversParentTypes['notificationMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['notification']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationSendResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationSend'] = ResolversParentTypes['notificationSend']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  doNavigateParams?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  doNavigateScreen?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  doNavigateStack?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  numberLookupTimeout?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  push?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  receivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  remember?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  seen?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sentAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  userIdCreated?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  userIdTo?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationSendAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationSendAggregate'] = ResolversParentTypes['notificationSendAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['notificationSendAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['notificationSend']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationSendAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationSendAggregateFields'] = ResolversParentTypes['notificationSendAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<notificationSendAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['notificationSendMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['notificationSendMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationSendMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationSendMaxFields'] = ResolversParentTypes['notificationSendMaxFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  doNavigateParams?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  doNavigateScreen?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  doNavigateStack?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  receivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  sentAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userIdCreated?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  userIdTo?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationSendMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationSendMinFields'] = ResolversParentTypes['notificationSendMinFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  doNavigateParams?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  doNavigateScreen?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  doNavigateStack?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  receivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  sentAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userIdCreated?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  userIdTo?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationSendMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationSendMutationResponse'] = ResolversParentTypes['notificationSendMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['notificationSend']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationSettingActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationSettingActivity'] = ResolversParentTypes['notificationSettingActivity']> = {
  activityId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  mobilePushNotification?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  muteUntil?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  primarySetting?: Resolver<ResolversTypes['NotificationNotificationSettingActivityPrimaryEnumEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationSettingActivityAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationSettingActivityAggregate'] = ResolversParentTypes['notificationSettingActivityAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['notificationSettingActivityAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['notificationSettingActivity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationSettingActivityAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationSettingActivityAggregateFields'] = ResolversParentTypes['notificationSettingActivityAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<notificationSettingActivityAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['notificationSettingActivityMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['notificationSettingActivityMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationSettingActivityMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationSettingActivityMaxFields'] = ResolversParentTypes['notificationSettingActivityMaxFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  muteUntil?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationSettingActivityMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationSettingActivityMinFields'] = ResolversParentTypes['notificationSettingActivityMinFields']> = {
  activityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  muteUntil?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationSettingActivityMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationSettingActivityMutationResponse'] = ResolversParentTypes['notificationSettingActivityMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['notificationSettingActivity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationUser'] = ResolversParentTypes['notificationUser']> = {
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  toggleNotification?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  toggleNotificationBusinessHoursIgnore?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  userPushSettings?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationUserAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationUserAggregate'] = ResolversParentTypes['notificationUserAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['notificationUserAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['notificationUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationUserAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationUserAggregateFields'] = ResolversParentTypes['notificationUserAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<notificationUserAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['notificationUserMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['notificationUserMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationUserDeviceResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationUserDevice'] = ResolversParentTypes['notificationUserDevice']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  deviceAppVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceBrand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceIsDevice?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  deviceLocale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceOs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceOsVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceRestarts?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  deviceSettings?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceTimezone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceYear?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  nativePushToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pushDelay?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pushToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  retries?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  retryDelay?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  useExpo?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationUserDeviceAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationUserDeviceAggregate'] = ResolversParentTypes['notificationUserDeviceAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['notificationUserDeviceAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['notificationUserDevice']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationUserDeviceAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationUserDeviceAggregateFields'] = ResolversParentTypes['notificationUserDeviceAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['notificationUserDeviceAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<notificationUserDeviceAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['notificationUserDeviceMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['notificationUserDeviceMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['notificationUserDeviceStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['notificationUserDeviceStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['notificationUserDeviceStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['notificationUserDeviceSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['notificationUserDeviceVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['notificationUserDeviceVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['notificationUserDeviceVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationUserDeviceAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationUserDeviceAvgFields'] = ResolversParentTypes['notificationUserDeviceAvgFields']> = {
  deviceRestarts?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pushDelay?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  retries?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  retryDelay?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationUserDeviceMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationUserDeviceMaxFields'] = ResolversParentTypes['notificationUserDeviceMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  deviceAppVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceBrand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceLocale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceOs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceOsVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceRestarts?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  deviceSettings?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceTimezone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceYear?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  nativePushToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pushDelay?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pushToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  retries?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  retryDelay?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationUserDeviceMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationUserDeviceMinFields'] = ResolversParentTypes['notificationUserDeviceMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  deviceAppVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceBrand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceLocale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceOs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceOsVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceRestarts?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  deviceSettings?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceTimezone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceYear?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  nativePushToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pushDelay?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pushToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  retries?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  retryDelay?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationUserDeviceMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationUserDeviceMutationResponse'] = ResolversParentTypes['notificationUserDeviceMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['notificationUserDevice']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationUserDeviceStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationUserDeviceStddevFields'] = ResolversParentTypes['notificationUserDeviceStddevFields']> = {
  deviceRestarts?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pushDelay?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  retries?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  retryDelay?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationUserDeviceStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationUserDeviceStddevPopFields'] = ResolversParentTypes['notificationUserDeviceStddevPopFields']> = {
  deviceRestarts?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pushDelay?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  retries?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  retryDelay?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationUserDeviceStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationUserDeviceStddevSampFields'] = ResolversParentTypes['notificationUserDeviceStddevSampFields']> = {
  deviceRestarts?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pushDelay?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  retries?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  retryDelay?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationUserDeviceSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationUserDeviceSumFields'] = ResolversParentTypes['notificationUserDeviceSumFields']> = {
  deviceRestarts?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pushDelay?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  retries?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  retryDelay?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationUserDeviceVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationUserDeviceVarPopFields'] = ResolversParentTypes['notificationUserDeviceVarPopFields']> = {
  deviceRestarts?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pushDelay?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  retries?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  retryDelay?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationUserDeviceVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationUserDeviceVarSampFields'] = ResolversParentTypes['notificationUserDeviceVarSampFields']> = {
  deviceRestarts?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pushDelay?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  retries?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  retryDelay?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationUserDeviceVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationUserDeviceVarianceFields'] = ResolversParentTypes['notificationUserDeviceVarianceFields']> = {
  deviceRestarts?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pushDelay?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  retries?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  retryDelay?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationUserMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationUserMaxFields'] = ResolversParentTypes['notificationUserMaxFields']> = {
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  userPushSettings?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationUserMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationUserMinFields'] = ResolversParentTypes['notificationUserMinFields']> = {
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  userPushSettings?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type notificationUserMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['notificationUserMutationResponse'] = ResolversParentTypes['notificationUserMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['notificationUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface numericScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['numeric'], any> {
  name: 'numeric';
}

export type ordersIntegrationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ordersIntegrations'] = ResolversParentTypes['ordersIntegrations']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  authLevel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  deliveryDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  integrations_organization?: Resolver<ResolversTypes['organization'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  licenses?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lockedBy?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  organizationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  password?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  providerAccountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  request?: Resolver<Maybe<ResolversTypes['OrdersRequestEnum']>, ParentType, ContextType>;
  requestStatus?: Resolver<Maybe<ResolversTypes['OrdersStatusEnum']>, ParentType, ContextType>;
  terms?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  termsversion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['OrdersTypeEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ordersIntegrationsAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['ordersIntegrationsAggregate'] = ResolversParentTypes['ordersIntegrationsAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['ordersIntegrationsAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['ordersIntegrations']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ordersIntegrationsAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ordersIntegrationsAggregateFields'] = ResolversParentTypes['ordersIntegrationsAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['ordersIntegrationsAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<ordersIntegrationsAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['ordersIntegrationsMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['ordersIntegrationsMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['ordersIntegrationsStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['ordersIntegrationsStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['ordersIntegrationsStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['ordersIntegrationsSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['ordersIntegrationsVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['ordersIntegrationsVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['ordersIntegrationsVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ordersIntegrationsAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ordersIntegrationsAvgFields'] = ResolversParentTypes['ordersIntegrationsAvgFields']> = {
  licenses?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ordersIntegrationsMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ordersIntegrationsMaxFields'] = ResolversParentTypes['ordersIntegrationsMaxFields']> = {
  authLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  deliveryDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  licenses?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lockedBy?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  password?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  providerAccountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  terms?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  termsversion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ordersIntegrationsMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ordersIntegrationsMinFields'] = ResolversParentTypes['ordersIntegrationsMinFields']> = {
  authLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  deliveryDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  licenses?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lockedBy?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  password?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  providerAccountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  terms?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  termsversion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ordersIntegrationsMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ordersIntegrationsMutationResponse'] = ResolversParentTypes['ordersIntegrationsMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['ordersIntegrations']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ordersIntegrationsStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ordersIntegrationsStddevFields'] = ResolversParentTypes['ordersIntegrationsStddevFields']> = {
  licenses?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ordersIntegrationsStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ordersIntegrationsStddevPopFields'] = ResolversParentTypes['ordersIntegrationsStddevPopFields']> = {
  licenses?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ordersIntegrationsStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ordersIntegrationsStddevSampFields'] = ResolversParentTypes['ordersIntegrationsStddevSampFields']> = {
  licenses?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ordersIntegrationsSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ordersIntegrationsSumFields'] = ResolversParentTypes['ordersIntegrationsSumFields']> = {
  licenses?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ordersIntegrationsVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ordersIntegrationsVarPopFields'] = ResolversParentTypes['ordersIntegrationsVarPopFields']> = {
  licenses?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ordersIntegrationsVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ordersIntegrationsVarSampFields'] = ResolversParentTypes['ordersIntegrationsVarSampFields']> = {
  licenses?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ordersIntegrationsVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ordersIntegrationsVarianceFields'] = ResolversParentTypes['ordersIntegrationsVarianceFields']> = {
  licenses?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type orgAccessRequestOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['orgAccessRequestOutput'] = ResolversParentTypes['orgAccessRequestOutput']> = {
  result?: Resolver<ResolversTypes['json'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['organization'] = ResolversParentTypes['organization']> = {
  activityOrganizationsAggregate?: Resolver<ResolversTypes['messagingActivityOrganizationAggregate'], ParentType, ContextType, Partial<organizationactivityOrganizationsAggregateArgs>>;
  activity_organizations?: Resolver<Array<ResolversTypes['messagingActivityOrganization']>, ParentType, ContextType, Partial<organizationactivity_organizationsArgs>>;
  businessAddress?: Resolver<Maybe<ResolversTypes['address']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nrOfEmployees?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  organizationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationUserInvites?: Resolver<Array<ResolversTypes['organizationUserInvite']>, ParentType, ContextType, Partial<organizationorganizationUserInvitesArgs>>;
  organizationUserInvitesAggregate?: Resolver<ResolversTypes['organizationUserInviteAggregate'], ParentType, ContextType, Partial<organizationorganizationUserInvitesAggregateArgs>>;
  organizationUserRequests?: Resolver<Array<ResolversTypes['BusinessOrganizationUserRequest']>, ParentType, ContextType, Partial<organizationorganizationUserRequestsArgs>>;
  organizationUserRequestsAggregate?: Resolver<ResolversTypes['BusinessOrganizationUserRequestAggregate'], ParentType, ContextType, Partial<organizationorganizationUserRequestsAggregateArgs>>;
  organizationUsers?: Resolver<Array<ResolversTypes['organizationUser']>, ParentType, ContextType, Partial<organizationorganizationUsersArgs>>;
  organizationUsersAggregate?: Resolver<ResolversTypes['organizationUserAggregate'], ParentType, ContextType, Partial<organizationorganizationUsersAggregateArgs>>;
  organizationsDomainOrganizations?: Resolver<Array<ResolversTypes['domainOrganization']>, ParentType, ContextType, Partial<organizationorganizationsDomainOrganizationsArgs>>;
  organizationsDomainOrganizationsAggregate?: Resolver<ResolversTypes['domainOrganizationAggregate'], ParentType, ContextType, Partial<organizationorganizationsDomainOrganizationsAggregateArgs>>;
  organizationsOrderIntegrations?: Resolver<Array<ResolversTypes['ordersIntegrations']>, ParentType, ContextType, Partial<organizationorganizationsOrderIntegrationsArgs>>;
  organizationsOrderIntegrationsAggregate?: Resolver<ResolversTypes['ordersIntegrationsAggregate'], ParentType, ContextType, Partial<organizationorganizationsOrderIntegrationsAggregateArgs>>;
  owner?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  ownerId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  phoneroCustomerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reinforceImportantMessagesWithSms?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['organizationOrganizationUserUsersView']>, ParentType, ContextType, Partial<organizationusersArgs>>;
  usersAggregate?: Resolver<ResolversTypes['organizationOrganizationUserUsersViewAggregate'], ParentType, ContextType, Partial<organizationusersAggregateArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationAggregate'] = ResolversParentTypes['organizationAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['organizationAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['organization']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationAggregateFields'] = ResolversParentTypes['organizationAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['organizationAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<organizationAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['organizationMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['organizationMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['organizationStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['organizationStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['organizationStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['organizationSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['organizationVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['organizationVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['organizationVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationAuthorizationEnumGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationAuthorizationEnumGroup'] = ResolversParentTypes['organizationAuthorizationEnumGroup']> = {
  authorization?: Resolver<Maybe<ResolversTypes['organizationUserAuthorizationEnum']>, ParentType, ContextType>;
  groupId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationAuthorizationEnumGroupAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationAuthorizationEnumGroupAggregate'] = ResolversParentTypes['organizationAuthorizationEnumGroupAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['organizationAuthorizationEnumGroupAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['organizationAuthorizationEnumGroup']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationAuthorizationEnumGroupAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationAuthorizationEnumGroupAggregateFields'] = ResolversParentTypes['organizationAuthorizationEnumGroupAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<organizationAuthorizationEnumGroupAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['organizationAuthorizationEnumGroupMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['organizationAuthorizationEnumGroupMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationAuthorizationEnumGroupMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationAuthorizationEnumGroupMaxFields'] = ResolversParentTypes['organizationAuthorizationEnumGroupMaxFields']> = {
  groupId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationAuthorizationEnumGroupMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationAuthorizationEnumGroupMinFields'] = ResolversParentTypes['organizationAuthorizationEnumGroupMinFields']> = {
  groupId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationAuthorizationEnumGroupMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationAuthorizationEnumGroupMutationResponse'] = ResolversParentTypes['organizationAuthorizationEnumGroupMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['organizationAuthorizationEnumGroup']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationAuthorizationGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationAuthorizationGroup'] = ResolversParentTypes['organizationAuthorizationGroup']> = {
  authorizationEnumGroupsAggregate?: Resolver<ResolversTypes['organizationAuthorizationEnumGroupAggregate'], ParentType, ContextType, Partial<organizationAuthorizationGroupauthorizationEnumGroupsAggregateArgs>>;
  authorization_enum_groups?: Resolver<Array<ResolversTypes['organizationAuthorizationEnumGroup']>, ParentType, ContextType, Partial<organizationAuthorizationGroupauthorization_enum_groupsArgs>>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationAuthorizationGroupAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationAuthorizationGroupAggregate'] = ResolversParentTypes['organizationAuthorizationGroupAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['organizationAuthorizationGroupAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['organizationAuthorizationGroup']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationAuthorizationGroupAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationAuthorizationGroupAggregateFields'] = ResolversParentTypes['organizationAuthorizationGroupAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<organizationAuthorizationGroupAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['organizationAuthorizationGroupMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['organizationAuthorizationGroupMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationAuthorizationGroupMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationAuthorizationGroupMaxFields'] = ResolversParentTypes['organizationAuthorizationGroupMaxFields']> = {
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationAuthorizationGroupMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationAuthorizationGroupMinFields'] = ResolversParentTypes['organizationAuthorizationGroupMinFields']> = {
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationAuthorizationGroupMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationAuthorizationGroupMutationResponse'] = ResolversParentTypes['organizationAuthorizationGroupMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['organizationAuthorizationGroup']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationAvgFields'] = ResolversParentTypes['organizationAvgFields']> = {
  nrOfEmployees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationMaxFields'] = ResolversParentTypes['organizationMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nrOfEmployees?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  organizationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ownerId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  phoneroCustomerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationMinFields'] = ResolversParentTypes['organizationMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nrOfEmployees?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  organizationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ownerId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  phoneroCustomerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationMutationResponse'] = ResolversParentTypes['organizationMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['organization']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationOrganizationRelationshipResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationOrganizationRelationship'] = ResolversParentTypes['organizationOrganizationRelationship']> = {
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  fromOrgId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  toOrgId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationOrganizationRelationshipAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationOrganizationRelationshipAggregate'] = ResolversParentTypes['organizationOrganizationRelationshipAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['organizationOrganizationRelationshipAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['organizationOrganizationRelationship']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationOrganizationRelationshipAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationOrganizationRelationshipAggregateFields'] = ResolversParentTypes['organizationOrganizationRelationshipAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<organizationOrganizationRelationshipAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['organizationOrganizationRelationshipMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['organizationOrganizationRelationshipMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationOrganizationRelationshipCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationOrganizationRelationshipCategory'] = ResolversParentTypes['organizationOrganizationRelationshipCategory']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationOrganizationRelationshipCategoryAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationOrganizationRelationshipCategoryAggregate'] = ResolversParentTypes['organizationOrganizationRelationshipCategoryAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['organizationOrganizationRelationshipCategoryAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['organizationOrganizationRelationshipCategory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationOrganizationRelationshipCategoryAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationOrganizationRelationshipCategoryAggregateFields'] = ResolversParentTypes['organizationOrganizationRelationshipCategoryAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<organizationOrganizationRelationshipCategoryAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['organizationOrganizationRelationshipCategoryMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['organizationOrganizationRelationshipCategoryMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationOrganizationRelationshipCategoryMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationOrganizationRelationshipCategoryMaxFields'] = ResolversParentTypes['organizationOrganizationRelationshipCategoryMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationOrganizationRelationshipCategoryMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationOrganizationRelationshipCategoryMinFields'] = ResolversParentTypes['organizationOrganizationRelationshipCategoryMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationOrganizationRelationshipCategoryMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationOrganizationRelationshipCategoryMutationResponse'] = ResolversParentTypes['organizationOrganizationRelationshipCategoryMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['organizationOrganizationRelationshipCategory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationOrganizationRelationshipMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationOrganizationRelationshipMaxFields'] = ResolversParentTypes['organizationOrganizationRelationshipMaxFields']> = {
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  fromOrgId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  toOrgId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationOrganizationRelationshipMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationOrganizationRelationshipMinFields'] = ResolversParentTypes['organizationOrganizationRelationshipMinFields']> = {
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  fromOrgId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  toOrgId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationOrganizationRelationshipMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationOrganizationRelationshipMutationResponse'] = ResolversParentTypes['organizationOrganizationRelationshipMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['organizationOrganizationRelationship']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationOrganizationUserAuthorizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationOrganizationUserAuthorization'] = ResolversParentTypes['organizationOrganizationUserAuthorization']> = {
  authorization?: Resolver<ResolversTypes['organizationUserAuthorization'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  organizationUserId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  organization_user?: Resolver<ResolversTypes['organizationUser'], ParentType, ContextType>;
  userAuthorization?: Resolver<ResolversTypes['organizationUserAuthorizationEnum'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationOrganizationUserAuthorizationAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationOrganizationUserAuthorizationAggregate'] = ResolversParentTypes['organizationOrganizationUserAuthorizationAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['organizationOrganizationUserAuthorizationAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['organizationOrganizationUserAuthorization']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationOrganizationUserAuthorizationAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationOrganizationUserAuthorizationAggregateFields'] = ResolversParentTypes['organizationOrganizationUserAuthorizationAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<organizationOrganizationUserAuthorizationAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['organizationOrganizationUserAuthorizationMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['organizationOrganizationUserAuthorizationMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationOrganizationUserAuthorizationMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationOrganizationUserAuthorizationMaxFields'] = ResolversParentTypes['organizationOrganizationUserAuthorizationMaxFields']> = {
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationOrganizationUserAuthorizationMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationOrganizationUserAuthorizationMinFields'] = ResolversParentTypes['organizationOrganizationUserAuthorizationMinFields']> = {
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationOrganizationUserAuthorizationMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationOrganizationUserAuthorizationMutationResponse'] = ResolversParentTypes['organizationOrganizationUserAuthorizationMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['organizationOrganizationUserAuthorization']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationOrganizationUserOrganizationsViewResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationOrganizationUserOrganizationsView'] = ResolversParentTypes['organizationOrganizationUserOrganizationsView']> = {
  company?: Resolver<Maybe<ResolversTypes['organizationUser']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationnumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ownerId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  reinforceimportantmessageswithsms?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['user']>, ParentType, ContextType, Partial<organizationOrganizationUserOrganizationsViewusersArgs>>;
  usersAggregate?: Resolver<ResolversTypes['userAggregate'], ParentType, ContextType, Partial<organizationOrganizationUserOrganizationsViewusersAggregateArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationOrganizationUserOrganizationsViewAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationOrganizationUserOrganizationsViewAggregate'] = ResolversParentTypes['organizationOrganizationUserOrganizationsViewAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['organizationOrganizationUserOrganizationsViewAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['organizationOrganizationUserOrganizationsView']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationOrganizationUserOrganizationsViewAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationOrganizationUserOrganizationsViewAggregateFields'] = ResolversParentTypes['organizationOrganizationUserOrganizationsViewAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<organizationOrganizationUserOrganizationsViewAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['organizationOrganizationUserOrganizationsViewMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['organizationOrganizationUserOrganizationsViewMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationOrganizationUserOrganizationsViewMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationOrganizationUserOrganizationsViewMaxFields'] = ResolversParentTypes['organizationOrganizationUserOrganizationsViewMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationnumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ownerId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationOrganizationUserOrganizationsViewMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationOrganizationUserOrganizationsViewMinFields'] = ResolversParentTypes['organizationOrganizationUserOrganizationsViewMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationnumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ownerId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationOrganizationUserUsersViewResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationOrganizationUserUsersView'] = ResolversParentTypes['organizationOrganizationUserUsersView']> = {
  authId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationsX?: Resolver<Array<ResolversTypes['organization']>, ParentType, ContextType, Partial<organizationOrganizationUserUsersVieworganizationsXArgs>>;
  organizationsXAggregate?: Resolver<ResolversTypes['organizationAggregate'], ParentType, ContextType, Partial<organizationOrganizationUserUsersVieworganizationsXAggregateArgs>>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationOrganizationUserUsersViewAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationOrganizationUserUsersViewAggregate'] = ResolversParentTypes['organizationOrganizationUserUsersViewAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['organizationOrganizationUserUsersViewAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['organizationOrganizationUserUsersView']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationOrganizationUserUsersViewAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationOrganizationUserUsersViewAggregateFields'] = ResolversParentTypes['organizationOrganizationUserUsersViewAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<organizationOrganizationUserUsersViewAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['organizationOrganizationUserUsersViewMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['organizationOrganizationUserUsersViewMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationOrganizationUserUsersViewMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationOrganizationUserUsersViewMaxFields'] = ResolversParentTypes['organizationOrganizationUserUsersViewMaxFields']> = {
  authId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationOrganizationUserUsersViewMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationOrganizationUserUsersViewMinFields'] = ResolversParentTypes['organizationOrganizationUserUsersViewMinFields']> = {
  authId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationStddevFields'] = ResolversParentTypes['organizationStddevFields']> = {
  nrOfEmployees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationStddevPopFields'] = ResolversParentTypes['organizationStddevPopFields']> = {
  nrOfEmployees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationStddevSampFields'] = ResolversParentTypes['organizationStddevSampFields']> = {
  nrOfEmployees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationSumFields'] = ResolversParentTypes['organizationSumFields']> = {
  nrOfEmployees?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUser'] = ResolversParentTypes['organizationUser']> = {
  activityDomainUsers?: Resolver<Array<ResolversTypes['domainUser']>, ParentType, ContextType, Partial<organizationUseractivityDomainUsersArgs>>;
  activityDomainUsersAggregate?: Resolver<ResolversTypes['domainUserAggregate'], ParentType, ContextType, Partial<organizationUseractivityDomainUsersAggregateArgs>>;
  addresses?: Resolver<Array<ResolversTypes['address']>, ParentType, ContextType, Partial<organizationUseraddressesArgs>>;
  addressesAggregate?: Resolver<ResolversTypes['addressAggregate'], ParentType, ContextType, Partial<organizationUseraddressesAggregateArgs>>;
  attachments?: Resolver<Array<ResolversTypes['organizationUserAttachments']>, ParentType, ContextType, Partial<organizationUserattachmentsArgs>>;
  attachmentsAggregate?: Resolver<ResolversTypes['organizationUserAttachmentsAggregate'], ParentType, ContextType, Partial<organizationUserattachmentsAggregateArgs>>;
  collaborations?: Resolver<Array<ResolversTypes['businessQueueItemCollaboration']>, ParentType, ContextType, Partial<organizationUsercollaborationsArgs>>;
  collaborationsAggregate?: Resolver<ResolversTypes['businessQueueItemCollaborationAggregate'], ParentType, ContextType, Partial<organizationUsercollaborationsAggregateArgs>>;
  company?: Resolver<Maybe<ResolversTypes['organizationUser']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  crmRepresentations?: Resolver<Array<ResolversTypes['crmYoutelloCatalystIdMapping']>, ParentType, ContextType, Partial<organizationUsercrmRepresentationsArgs>>;
  crmRepresentationsAggregate?: Resolver<ResolversTypes['crmYoutelloCatalystIdMappingAggregate'], ParentType, ContextType, Partial<organizationUsercrmRepresentationsAggregateArgs>>;
  deletionAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emails?: Resolver<Array<ResolversTypes['BusinessOrganizationUserEmail']>, ParentType, ContextType, Partial<organizationUseremailsArgs>>;
  emailsAggregate?: Resolver<ResolversTypes['BusinessOrganizationUserEmailAggregate'], ParentType, ContextType, Partial<organizationUseremailsAggregateArgs>>;
  extraData?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<organizationUserextraDataArgs>>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organization?: Resolver<Maybe<ResolversTypes['organization']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationUserAuthorizationsAggregate?: Resolver<ResolversTypes['organizationOrganizationUserAuthorizationAggregate'], ParentType, ContextType, Partial<organizationUserorganizationUserAuthorizationsAggregateArgs>>;
  organizationUserDetailsAggregate?: Resolver<ResolversTypes['organizationUserDetailAggregate'], ParentType, ContextType, Partial<organizationUserorganizationUserDetailsAggregateArgs>>;
  organization_user_authorizations?: Resolver<Array<ResolversTypes['organizationOrganizationUserAuthorization']>, ParentType, ContextType, Partial<organizationUserorganization_user_authorizationsArgs>>;
  organization_user_details?: Resolver<Array<ResolversTypes['organizationUserDetail']>, ParentType, ContextType, Partial<organizationUserorganization_user_detailsArgs>>;
  owner?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  ownerUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  permissions?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<organizationUserpermissionsArgs>>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['userRoleEnum']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['organizationUserStatusEnum']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  urlAddresses?: Resolver<Array<ResolversTypes['BusinessOrganizationUserUrlAddress']>, ParentType, ContextType, Partial<organizationUserurlAddressesArgs>>;
  urlAddressesAggregate?: Resolver<ResolversTypes['BusinessOrganizationUserUrlAddressAggregate'], ParentType, ContextType, Partial<organizationUserurlAddressesAggregateArgs>>;
  user?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserAggregate'] = ResolversParentTypes['organizationUserAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['organizationUserAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['organizationUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserAggregateFields'] = ResolversParentTypes['organizationUserAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<organizationUserAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['organizationUserMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['organizationUserMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserAttachmentsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserAttachments'] = ResolversParentTypes['organizationUserAttachments']> = {
  attachedByUser?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  file?: Resolver<ResolversTypes['publicFile'], ParentType, ContextType>;
  fileId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  organizationUser?: Resolver<ResolversTypes['organizationUser'], ParentType, ContextType>;
  organizationUserId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserAttachmentsAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserAttachmentsAggregate'] = ResolversParentTypes['organizationUserAttachmentsAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['organizationUserAttachmentsAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['organizationUserAttachments']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserAttachmentsAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserAttachmentsAggregateFields'] = ResolversParentTypes['organizationUserAttachmentsAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<organizationUserAttachmentsAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['organizationUserAttachmentsMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['organizationUserAttachmentsMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserAttachmentsMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserAttachmentsMaxFields'] = ResolversParentTypes['organizationUserAttachmentsMaxFields']> = {
  attachedByUser?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  fileId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserAttachmentsMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserAttachmentsMinFields'] = ResolversParentTypes['organizationUserAttachmentsMinFields']> = {
  attachedByUser?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  fileId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserAttachmentsMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserAttachmentsMutationResponse'] = ResolversParentTypes['organizationUserAttachmentsMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['organizationUserAttachments']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserAuthorizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserAuthorization'] = ResolversParentTypes['organizationUserAuthorization']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserAuthorizationAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserAuthorizationAggregate'] = ResolversParentTypes['organizationUserAuthorizationAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['organizationUserAuthorizationAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['organizationUserAuthorization']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserAuthorizationAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserAuthorizationAggregateFields'] = ResolversParentTypes['organizationUserAuthorizationAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<organizationUserAuthorizationAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['organizationUserAuthorizationMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['organizationUserAuthorizationMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserAuthorizationMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserAuthorizationMaxFields'] = ResolversParentTypes['organizationUserAuthorizationMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserAuthorizationMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserAuthorizationMinFields'] = ResolversParentTypes['organizationUserAuthorizationMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserAuthorizationMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserAuthorizationMutationResponse'] = ResolversParentTypes['organizationUserAuthorizationMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['organizationUserAuthorization']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserDetail'] = ResolversParentTypes['organizationUserDetail']> = {
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  createdByUserId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  organizationUserDetailsType?: Resolver<ResolversTypes['organizationUserDetailType'], ParentType, ContextType>;
  organizationUserId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  organization_user?: Resolver<ResolversTypes['organizationUser'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['organizationUserDetailTypeEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserDetailAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserDetailAggregate'] = ResolversParentTypes['organizationUserDetailAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['organizationUserDetailAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['organizationUserDetail']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserDetailAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserDetailAggregateFields'] = ResolversParentTypes['organizationUserDetailAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<organizationUserDetailAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['organizationUserDetailMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['organizationUserDetailMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserDetailMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserDetailMaxFields'] = ResolversParentTypes['organizationUserDetailMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserDetailMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserDetailMinFields'] = ResolversParentTypes['organizationUserDetailMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserDetailMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserDetailMutationResponse'] = ResolversParentTypes['organizationUserDetailMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['organizationUserDetail']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserDetailTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserDetailType'] = ResolversParentTypes['organizationUserDetailType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationUserDetails?: Resolver<Array<ResolversTypes['organizationUserDetail']>, ParentType, ContextType, Partial<organizationUserDetailTypeorganizationUserDetailsArgs>>;
  organizationUserDetailsAggregate?: Resolver<ResolversTypes['organizationUserDetailAggregate'], ParentType, ContextType, Partial<organizationUserDetailTypeorganizationUserDetailsAggregateArgs>>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserDetailTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserDetailTypeAggregate'] = ResolversParentTypes['organizationUserDetailTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['organizationUserDetailTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['organizationUserDetailType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserDetailTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserDetailTypeAggregateFields'] = ResolversParentTypes['organizationUserDetailTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<organizationUserDetailTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['organizationUserDetailTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['organizationUserDetailTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserDetailTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserDetailTypeMaxFields'] = ResolversParentTypes['organizationUserDetailTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserDetailTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserDetailTypeMinFields'] = ResolversParentTypes['organizationUserDetailTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserDetailTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserDetailTypeMutationResponse'] = ResolversParentTypes['organizationUserDetailTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['organizationUserDetailType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserInviteResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserInvite'] = ResolversParentTypes['organizationUserInvite']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdByUserId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  extraData?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<organizationUserInviteextraDataArgs>>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organization?: Resolver<Maybe<ResolversTypes['organization']>, ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  organizationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  permissionRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumberCountryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserInviteAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserInviteAggregate'] = ResolversParentTypes['organizationUserInviteAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['organizationUserInviteAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['organizationUserInvite']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserInviteAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserInviteAggregateFields'] = ResolversParentTypes['organizationUserInviteAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<organizationUserInviteAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['organizationUserInviteMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['organizationUserInviteMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserInviteMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserInviteMaxFields'] = ResolversParentTypes['organizationUserInviteMaxFields']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  permissionRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumberCountryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserInviteMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserInviteMinFields'] = ResolversParentTypes['organizationUserInviteMinFields']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  permissionRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumberCountryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserInviteMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserInviteMutationResponse'] = ResolversParentTypes['organizationUserInviteMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['organizationUserInvite']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserMaxFields'] = ResolversParentTypes['organizationUserMaxFields']> = {
  companyId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  deletionAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ownerUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserMinFields'] = ResolversParentTypes['organizationUserMinFields']> = {
  companyId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  deletionAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ownerUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserMutationResponse'] = ResolversParentTypes['organizationUserMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['organizationUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserOutput'] = ResolversParentTypes['organizationUserOutput']> = {
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  organizationUsers?: Resolver<Maybe<Array<Maybe<ResolversTypes['organizationUsers']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserStatus'] = ResolversParentTypes['organizationUserStatus']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserStatusAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserStatusAggregate'] = ResolversParentTypes['organizationUserStatusAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['organizationUserStatusAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['organizationUserStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserStatusAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserStatusAggregateFields'] = ResolversParentTypes['organizationUserStatusAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<organizationUserStatusAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['organizationUserStatusMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['organizationUserStatusMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserStatusMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserStatusMaxFields'] = ResolversParentTypes['organizationUserStatusMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserStatusMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserStatusMinFields'] = ResolversParentTypes['organizationUserStatusMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUserStatusMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUserStatusMutationResponse'] = ResolversParentTypes['organizationUserStatusMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['organizationUserStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationUsersResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationUsers'] = ResolversParentTypes['organizationUsers']> = {
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationVarPopFields'] = ResolversParentTypes['organizationVarPopFields']> = {
  nrOfEmployees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationVarSampFields'] = ResolversParentTypes['organizationVarSampFields']> = {
  nrOfEmployees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type organizationVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['organizationVarianceFields'] = ResolversParentTypes['organizationVarianceFields']> = {
  nrOfEmployees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type phoneNumberVerificationStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['phoneNumberVerificationStatus'] = ResolversParentTypes['phoneNumberVerificationStatus']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type phoneNumberVerificationStatusAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['phoneNumberVerificationStatusAggregate'] = ResolversParentTypes['phoneNumberVerificationStatusAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['phoneNumberVerificationStatusAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['phoneNumberVerificationStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type phoneNumberVerificationStatusAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['phoneNumberVerificationStatusAggregateFields'] = ResolversParentTypes['phoneNumberVerificationStatusAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<phoneNumberVerificationStatusAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['phoneNumberVerificationStatusMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['phoneNumberVerificationStatusMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type phoneNumberVerificationStatusMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['phoneNumberVerificationStatusMaxFields'] = ResolversParentTypes['phoneNumberVerificationStatusMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type phoneNumberVerificationStatusMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['phoneNumberVerificationStatusMinFields'] = ResolversParentTypes['phoneNumberVerificationStatusMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type phoneNumberVerificationStatusMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['phoneNumberVerificationStatusMutationResponse'] = ResolversParentTypes['phoneNumberVerificationStatusMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['phoneNumberVerificationStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type phoneUserOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['phoneUserOutput'] = ResolversParentTypes['phoneUserOutput']> = {
  phoneUser?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type privatizeUserResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['privatizeUserResult'] = ResolversParentTypes['privatizeUserResult']> = {
  result?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicDeviceResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicDevice'] = ResolversParentTypes['publicDevice']> = {
  deviceBrand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceIsDevice?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  deviceModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceOs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceOsVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  devicePushToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceYear?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicDeviceAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicDeviceAggregate'] = ResolversParentTypes['publicDeviceAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['publicDeviceAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['publicDevice']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicDeviceAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicDeviceAggregateFields'] = ResolversParentTypes['publicDeviceAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<publicDeviceAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['publicDeviceMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['publicDeviceMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicDeviceMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicDeviceMaxFields'] = ResolversParentTypes['publicDeviceMaxFields']> = {
  deviceBrand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceOs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceOsVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  devicePushToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceYear?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicDeviceMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicDeviceMinFields'] = ResolversParentTypes['publicDeviceMinFields']> = {
  deviceBrand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceOs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceOsVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  devicePushToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceYear?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicDeviceMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicDeviceMutationResponse'] = ResolversParentTypes['publicDeviceMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['publicDevice']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicExternalRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicExternalRequest'] = ResolversParentTypes['publicExternalRequest']> = {
  action?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<publicExternalRequestactionArgs>>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  input?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<publicExternalRequestinputArgs>>;
  sessionVariables?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<publicExternalRequestsessionVariablesArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicExternalRequestAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicExternalRequestAggregate'] = ResolversParentTypes['publicExternalRequestAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['publicExternalRequestAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['publicExternalRequest']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicExternalRequestAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicExternalRequestAggregateFields'] = ResolversParentTypes['publicExternalRequestAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<publicExternalRequestAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['publicExternalRequestMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['publicExternalRequestMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicExternalRequestMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicExternalRequestMaxFields'] = ResolversParentTypes['publicExternalRequestMaxFields']> = {
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicExternalRequestMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicExternalRequestMinFields'] = ResolversParentTypes['publicExternalRequestMinFields']> = {
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicExternalRequestMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicExternalRequestMutationResponse'] = ResolversParentTypes['publicExternalRequestMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['publicExternalRequest']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicFileResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicFile'] = ResolversParentTypes['publicFile']> = {
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  filePath?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messageAttachmentsAggregate?: Resolver<ResolversTypes['MessagingMessageAttachmentAggregate'], ParentType, ContextType, Partial<publicFilemessageAttachmentsAggregateArgs>>;
  message_attachments?: Resolver<Array<ResolversTypes['MessagingMessageAttachment']>, ParentType, ContextType, Partial<publicFilemessage_attachmentsArgs>>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationUserAttachmentsAggregate?: Resolver<ResolversTypes['organizationUserAttachmentsAggregate'], ParentType, ContextType, Partial<publicFileorganizationUserAttachmentsAggregateArgs>>;
  organization_user_attachments?: Resolver<Array<ResolversTypes['organizationUserAttachments']>, ParentType, ContextType, Partial<publicFileorganization_user_attachmentsArgs>>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicFileAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicFileAggregate'] = ResolversParentTypes['publicFileAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['publicFileAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['publicFile']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicFileAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicFileAggregateFields'] = ResolversParentTypes['publicFileAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<publicFileAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['publicFileMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['publicFileMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicFileMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicFileMaxFields'] = ResolversParentTypes['publicFileMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  filePath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicFileMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicFileMinFields'] = ResolversParentTypes['publicFileMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  filePath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicFileMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicFileMutationResponse'] = ResolversParentTypes['publicFileMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['publicFile']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicNotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicNotification'] = ResolversParentTypes['publicNotification']> = {
  callId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  destinationNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  direction?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  organization?: Resolver<Maybe<ResolversTypes['organization']>, ParentType, ContextType>;
  originatingNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phoneroCustomerId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['timestamp'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicNotificationAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicNotificationAggregate'] = ResolversParentTypes['publicNotificationAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['publicNotificationAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['publicNotification']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicNotificationAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicNotificationAggregateFields'] = ResolversParentTypes['publicNotificationAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['publicNotificationAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<publicNotificationAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['publicNotificationMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['publicNotificationMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['publicNotificationStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['publicNotificationStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['publicNotificationStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['publicNotificationSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['publicNotificationVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['publicNotificationVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['publicNotificationVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicNotificationAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicNotificationAvgFields'] = ResolversParentTypes['publicNotificationAvgFields']> = {
  phoneroCustomerId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicNotificationMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicNotificationMaxFields'] = ResolversParentTypes['publicNotificationMaxFields']> = {
  callId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  destinationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  direction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  originatingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneroCustomerId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timestamp?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicNotificationMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicNotificationMinFields'] = ResolversParentTypes['publicNotificationMinFields']> = {
  callId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  destinationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  direction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  originatingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneroCustomerId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timestamp?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicNotificationMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicNotificationMutationResponse'] = ResolversParentTypes['publicNotificationMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['publicNotification']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicNotificationStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicNotificationStddevFields'] = ResolversParentTypes['publicNotificationStddevFields']> = {
  phoneroCustomerId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicNotificationStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicNotificationStddevPopFields'] = ResolversParentTypes['publicNotificationStddevPopFields']> = {
  phoneroCustomerId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicNotificationStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicNotificationStddevSampFields'] = ResolversParentTypes['publicNotificationStddevSampFields']> = {
  phoneroCustomerId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicNotificationSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicNotificationSumFields'] = ResolversParentTypes['publicNotificationSumFields']> = {
  phoneroCustomerId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicNotificationVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicNotificationVarPopFields'] = ResolversParentTypes['publicNotificationVarPopFields']> = {
  phoneroCustomerId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicNotificationVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicNotificationVarSampFields'] = ResolversParentTypes['publicNotificationVarSampFields']> = {
  phoneroCustomerId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type publicNotificationVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['publicNotificationVarianceFields'] = ResolversParentTypes['publicNotificationVarianceFields']> = {
  phoneroCustomerId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type query_rootResolvers<ContextType = any, ParentType extends ResolversParentTypes['query_root'] = ResolversParentTypes['query_root']> = {
  ActivityDirection?: Resolver<Array<ResolversTypes['ActivityDirection']>, ParentType, ContextType, Partial<query_rootActivityDirectionArgs>>;
  ActivityDirectionAggregate?: Resolver<ResolversTypes['ActivityDirectionAggregate'], ParentType, ContextType, Partial<query_rootActivityDirectionAggregateArgs>>;
  ActivityDirectionByPk?: Resolver<Maybe<ResolversTypes['ActivityDirection']>, ParentType, ContextType, RequireFields<query_rootActivityDirectionByPkArgs, 'value'>>;
  ActivityProvider?: Resolver<Array<ResolversTypes['ActivityProvider']>, ParentType, ContextType, Partial<query_rootActivityProviderArgs>>;
  ActivityProviderAggregate?: Resolver<ResolversTypes['ActivityProviderAggregate'], ParentType, ContextType, Partial<query_rootActivityProviderAggregateArgs>>;
  ActivityProviderByPk?: Resolver<Maybe<ResolversTypes['ActivityProvider']>, ParentType, ContextType, RequireFields<query_rootActivityProviderByPkArgs, 'value'>>;
  QueueItemFlexibilityType?: Resolver<Array<ResolversTypes['QueueItemFlexibilityType']>, ParentType, ContextType, Partial<query_rootQueueItemFlexibilityTypeArgs>>;
  QueueItemFlexibilityTypeAggregate?: Resolver<ResolversTypes['QueueItemFlexibilityTypeAggregate'], ParentType, ContextType, Partial<query_rootQueueItemFlexibilityTypeAggregateArgs>>;
  QueueItemFlexibilityTypeByPk?: Resolver<Maybe<ResolversTypes['QueueItemFlexibilityType']>, ParentType, ContextType, RequireFields<query_rootQueueItemFlexibilityTypeByPkArgs, 'value'>>;
  QueueItemParticipantResponsibilityType?: Resolver<Array<ResolversTypes['QueueItemParticipantResponsibilityType']>, ParentType, ContextType, Partial<query_rootQueueItemParticipantResponsibilityTypeArgs>>;
  QueueItemParticipantResponsibilityTypeAggregate?: Resolver<ResolversTypes['QueueItemParticipantResponsibilityTypeAggregate'], ParentType, ContextType, Partial<query_rootQueueItemParticipantResponsibilityTypeAggregateArgs>>;
  QueueItemParticipantResponsibilityTypeByPk?: Resolver<Maybe<ResolversTypes['QueueItemParticipantResponsibilityType']>, ParentType, ContextType, RequireFields<query_rootQueueItemParticipantResponsibilityTypeByPkArgs, 'value'>>;
  RelationType?: Resolver<Array<ResolversTypes['RelationType']>, ParentType, ContextType, Partial<query_rootRelationTypeArgs>>;
  RelationTypeAggregate?: Resolver<ResolversTypes['RelationTypeAggregate'], ParentType, ContextType, Partial<query_rootRelationTypeAggregateArgs>>;
  RelationTypeByPk?: Resolver<Maybe<ResolversTypes['RelationType']>, ParentType, ContextType, RequireFields<query_rootRelationTypeByPkArgs, 'value'>>;
  activityParticipant?: Resolver<Maybe<ResolversTypes['activityParticipant']>, ParentType, ContextType, RequireFields<query_rootactivityParticipantArgs, 'id'>>;
  activityParticipants?: Resolver<Array<ResolversTypes['activityParticipant']>, ParentType, ContextType, Partial<query_rootactivityParticipantsArgs>>;
  activityParticipantsAggregate?: Resolver<ResolversTypes['activityParticipantAggregate'], ParentType, ContextType, Partial<query_rootactivityParticipantsAggregateArgs>>;
  activityStatus?: Resolver<Maybe<ResolversTypes['ActivityStatus']>, ParentType, ContextType, RequireFields<query_rootactivityStatusArgs, 'value'>>;
  activityStatuses?: Resolver<Array<ResolversTypes['ActivityStatus']>, ParentType, ContextType, Partial<query_rootactivityStatusesArgs>>;
  activityStatusesAggregate?: Resolver<ResolversTypes['ActivityStatusAggregate'], ParentType, ContextType, Partial<query_rootactivityStatusesAggregateArgs>>;
  activityType?: Resolver<Maybe<ResolversTypes['ActivityType']>, ParentType, ContextType, RequireFields<query_rootactivityTypeArgs, 'value'>>;
  activityTypes?: Resolver<Array<ResolversTypes['ActivityType']>, ParentType, ContextType, Partial<query_rootactivityTypesArgs>>;
  activityTypesAggregate?: Resolver<ResolversTypes['ActivityTypeAggregate'], ParentType, ContextType, Partial<query_rootactivityTypesAggregateArgs>>;
  address?: Resolver<Maybe<ResolversTypes['address']>, ParentType, ContextType, RequireFields<query_rootaddressArgs, 'id'>>;
  addresses?: Resolver<Array<ResolversTypes['address']>, ParentType, ContextType, Partial<query_rootaddressesArgs>>;
  addressesAggregate?: Resolver<ResolversTypes['addressAggregate'], ParentType, ContextType, Partial<query_rootaddressesAggregateArgs>>;
  aggregateBusinessUserContacts?: Resolver<ResolversTypes['businessUserContactsAggregate'], ParentType, ContextType, Partial<query_rootaggregateBusinessUserContactsArgs>>;
  aggregateBusinessUserSettings?: Resolver<ResolversTypes['businessUserSettingsAggregate'], ParentType, ContextType, Partial<query_rootaggregateBusinessUserSettingsArgs>>;
  aggregateMessagingActivities?: Resolver<ResolversTypes['messagingActivityAggregate'], ParentType, ContextType, Partial<query_rootaggregateMessagingActivitiesArgs>>;
  aggregateMessagingActivityTypes?: Resolver<ResolversTypes['messagingActivityTypeAggregate'], ParentType, ContextType, Partial<query_rootaggregateMessagingActivityTypesArgs>>;
  aggregateMessagingActivityUsers?: Resolver<ResolversTypes['messagingActivityUserAggregate'], ParentType, ContextType, Partial<query_rootaggregateMessagingActivityUsersArgs>>;
  aggregateMessagingMessageEmojis?: Resolver<ResolversTypes['messagingMessageEmojiAggregate'], ParentType, ContextType, Partial<query_rootaggregateMessagingMessageEmojisArgs>>;
  aggregateMessagingMessageReads?: Resolver<ResolversTypes['messagingMessageReadAggregate'], ParentType, ContextType, Partial<query_rootaggregateMessagingMessageReadsArgs>>;
  aggregateMessagingMessageTypes?: Resolver<ResolversTypes['messagingMessageTypeAggregate'], ParentType, ContextType, Partial<query_rootaggregateMessagingMessageTypesArgs>>;
  aggregateMessagingMessages?: Resolver<ResolversTypes['messagingMessageAggregate'], ParentType, ContextType, Partial<query_rootaggregateMessagingMessagesArgs>>;
  aggregateOrganizationAuthorizationEnumGroups?: Resolver<ResolversTypes['organizationAuthorizationEnumGroupAggregate'], ParentType, ContextType, Partial<query_rootaggregateOrganizationAuthorizationEnumGroupsArgs>>;
  aggregateOrganizationAuthorizationGroups?: Resolver<ResolversTypes['organizationAuthorizationGroupAggregate'], ParentType, ContextType, Partial<query_rootaggregateOrganizationAuthorizationGroupsArgs>>;
  aggregateOrganizationOrganizationRelationshipCategories?: Resolver<ResolversTypes['organizationOrganizationRelationshipCategoryAggregate'], ParentType, ContextType, Partial<query_rootaggregateOrganizationOrganizationRelationshipCategoriesArgs>>;
  aggregateOrganizationOrganizationRelationships?: Resolver<ResolversTypes['organizationOrganizationRelationshipAggregate'], ParentType, ContextType, Partial<query_rootaggregateOrganizationOrganizationRelationshipsArgs>>;
  aggregateOrganizationOrganizationUserAuthorizations?: Resolver<ResolversTypes['organizationOrganizationUserAuthorizationAggregate'], ParentType, ContextType, Partial<query_rootaggregateOrganizationOrganizationUserAuthorizationsArgs>>;
  aggregateOrganizationOrganizationUserOrganizationsViews?: Resolver<ResolversTypes['organizationOrganizationUserOrganizationsViewAggregate'], ParentType, ContextType, Partial<query_rootaggregateOrganizationOrganizationUserOrganizationsViewsArgs>>;
  aggregateOrganizationOrganizationUserUsersViews?: Resolver<ResolversTypes['organizationOrganizationUserUsersViewAggregate'], ParentType, ContextType, Partial<query_rootaggregateOrganizationOrganizationUserUsersViewsArgs>>;
  aggregateOrganizationUserAuthorizations?: Resolver<ResolversTypes['organizationUserAuthorizationAggregate'], ParentType, ContextType, Partial<query_rootaggregateOrganizationUserAuthorizationsArgs>>;
  aggregatePublicDevices?: Resolver<ResolversTypes['publicDeviceAggregate'], ParentType, ContextType, Partial<query_rootaggregatePublicDevicesArgs>>;
  aggregatePublicExternalRequests?: Resolver<ResolversTypes['publicExternalRequestAggregate'], ParentType, ContextType, Partial<query_rootaggregatePublicExternalRequestsArgs>>;
  aggregatePublicFiles?: Resolver<ResolversTypes['publicFileAggregate'], ParentType, ContextType, Partial<query_rootaggregatePublicFilesArgs>>;
  aggregatePublicNotifications?: Resolver<ResolversTypes['publicNotificationAggregate'], ParentType, ContextType, Partial<query_rootaggregatePublicNotificationsArgs>>;
  aggregateSmsConnectors?: Resolver<ResolversTypes['smsConnectorAggregate'], ParentType, ContextType, Partial<query_rootaggregateSmsConnectorsArgs>>;
  aggregateSmsGates?: Resolver<ResolversTypes['smsGateAggregate'], ParentType, ContextType, Partial<query_rootaggregateSmsGatesArgs>>;
  aggregateSmsLinkMobilitySmsContents?: Resolver<ResolversTypes['smsLinkMobilitySmsContentAggregate'], ParentType, ContextType, Partial<query_rootaggregateSmsLinkMobilitySmsContentsArgs>>;
  aggregateSmsLinkMobilitySmsMessages?: Resolver<ResolversTypes['smsLinkMobilitySmsMessageAggregate'], ParentType, ContextType, Partial<query_rootaggregateSmsLinkMobilitySmsMessagesArgs>>;
  aggregateSmsLinkMobilitySmsRoutes?: Resolver<ResolversTypes['smsLinkMobilitySmsRouteAggregate'], ParentType, ContextType, Partial<query_rootaggregateSmsLinkMobilitySmsRoutesArgs>>;
  aggregateSmsProviders?: Resolver<ResolversTypes['smsProviderAggregate'], ParentType, ContextType, Partial<query_rootaggregateSmsProvidersArgs>>;
  aggregateSmsSms?: Resolver<ResolversTypes['smsSmAggregate'], ParentType, ContextType, Partial<query_rootaggregateSmsSmsArgs>>;
  aggregateSmsSmsExternalIncomingLinkMobilities?: Resolver<ResolversTypes['smsSmsExternalIncomingLinkMobilityAggregate'], ParentType, ContextType, Partial<query_rootaggregateSmsSmsExternalIncomingLinkMobilitiesArgs>>;
  aggregateValidationValidations?: Resolver<ResolversTypes['validationValidationAggregate'], ParentType, ContextType, Partial<query_rootaggregateValidationValidationsArgs>>;
  blockedDomainUser?: Resolver<Maybe<ResolversTypes['blockedDomainUser']>, ParentType, ContextType, RequireFields<query_rootblockedDomainUserArgs, 'id'>>;
  blockedDomainUsers?: Resolver<Array<ResolversTypes['blockedDomainUser']>, ParentType, ContextType, Partial<query_rootblockedDomainUsersArgs>>;
  blockedDomainUsersAggregate?: Resolver<ResolversTypes['blockedDomainUserAggregate'], ParentType, ContextType, Partial<query_rootblockedDomainUsersAggregateArgs>>;
  breg?: Resolver<Maybe<ResolversTypes['bregquery_root']>, ParentType, ContextType>;
  businessDomainActivityType?: Resolver<Array<ResolversTypes['BusinessDomainActivityType']>, ParentType, ContextType, Partial<query_rootbusinessDomainActivityTypeArgs>>;
  businessDomainActivityTypeAggregate?: Resolver<ResolversTypes['BusinessDomainActivityTypeAggregate'], ParentType, ContextType, Partial<query_rootbusinessDomainActivityTypeAggregateArgs>>;
  businessDomainActivityTypeByPk?: Resolver<Maybe<ResolversTypes['BusinessDomainActivityType']>, ParentType, ContextType, RequireFields<query_rootbusinessDomainActivityTypeByPkArgs, 'value'>>;
  businessFeedType?: Resolver<Array<ResolversTypes['BusinessFeedType']>, ParentType, ContextType, Partial<query_rootbusinessFeedTypeArgs>>;
  businessFeedTypeAggregate?: Resolver<ResolversTypes['BusinessFeedTypeAggregate'], ParentType, ContextType, Partial<query_rootbusinessFeedTypeAggregateArgs>>;
  businessFeedTypeByPk?: Resolver<Maybe<ResolversTypes['BusinessFeedType']>, ParentType, ContextType, RequireFields<query_rootbusinessFeedTypeByPkArgs, 'type'>>;
  businessMessageAttachments?: Resolver<Array<ResolversTypes['BusinessMessageAttachments']>, ParentType, ContextType, Partial<query_rootbusinessMessageAttachmentsArgs>>;
  businessMessageAttachmentsAggregate?: Resolver<ResolversTypes['BusinessMessageAttachmentsAggregate'], ParentType, ContextType, Partial<query_rootbusinessMessageAttachmentsAggregateArgs>>;
  businessMessageAttachmentsByPk?: Resolver<Maybe<ResolversTypes['BusinessMessageAttachments']>, ParentType, ContextType, RequireFields<query_rootbusinessMessageAttachmentsByPkArgs, 'id'>>;
  businessOrganizationUserCallbackAnswer?: Resolver<Array<ResolversTypes['BusinessOrganizationUserCallbackAnswer']>, ParentType, ContextType, Partial<query_rootbusinessOrganizationUserCallbackAnswerArgs>>;
  businessOrganizationUserCallbackAnswerAggregate?: Resolver<ResolversTypes['BusinessOrganizationUserCallbackAnswerAggregate'], ParentType, ContextType, Partial<query_rootbusinessOrganizationUserCallbackAnswerAggregateArgs>>;
  businessOrganizationUserCallbackAnswerByPk?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserCallbackAnswer']>, ParentType, ContextType, RequireFields<query_rootbusinessOrganizationUserCallbackAnswerByPkArgs, 'id'>>;
  businessOrganizationUserEmail?: Resolver<Array<ResolversTypes['BusinessOrganizationUserEmail']>, ParentType, ContextType, Partial<query_rootbusinessOrganizationUserEmailArgs>>;
  businessOrganizationUserEmailAggregate?: Resolver<ResolversTypes['BusinessOrganizationUserEmailAggregate'], ParentType, ContextType, Partial<query_rootbusinessOrganizationUserEmailAggregateArgs>>;
  businessOrganizationUserEmailByPk?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserEmail']>, ParentType, ContextType, RequireFields<query_rootbusinessOrganizationUserEmailByPkArgs, 'id'>>;
  businessOrganizationUserEmailType?: Resolver<Array<ResolversTypes['BusinessOrganizationUserEmailType']>, ParentType, ContextType, Partial<query_rootbusinessOrganizationUserEmailTypeArgs>>;
  businessOrganizationUserEmailTypeAggregate?: Resolver<ResolversTypes['BusinessOrganizationUserEmailTypeAggregate'], ParentType, ContextType, Partial<query_rootbusinessOrganizationUserEmailTypeAggregateArgs>>;
  businessOrganizationUserEmailTypeByPk?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserEmailType']>, ParentType, ContextType, RequireFields<query_rootbusinessOrganizationUserEmailTypeByPkArgs, 'value'>>;
  businessOrganizationUserRequestAggregate?: Resolver<ResolversTypes['BusinessOrganizationUserRequestAggregate'], ParentType, ContextType, Partial<query_rootbusinessOrganizationUserRequestAggregateArgs>>;
  businessOrganizationUserRequestType?: Resolver<Array<ResolversTypes['BusinessOrganizationUserRequestType']>, ParentType, ContextType, Partial<query_rootbusinessOrganizationUserRequestTypeArgs>>;
  businessOrganizationUserRequestTypeAggregate?: Resolver<ResolversTypes['BusinessOrganizationUserRequestTypeAggregate'], ParentType, ContextType, Partial<query_rootbusinessOrganizationUserRequestTypeAggregateArgs>>;
  businessOrganizationUserRequestTypeByPk?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserRequestType']>, ParentType, ContextType, RequireFields<query_rootbusinessOrganizationUserRequestTypeByPkArgs, 'name'>>;
  businessOrganizationUserSuggestionType?: Resolver<Array<ResolversTypes['BusinessOrganizationUserSuggestionType']>, ParentType, ContextType, Partial<query_rootbusinessOrganizationUserSuggestionTypeArgs>>;
  businessOrganizationUserSuggestionTypeAggregate?: Resolver<ResolversTypes['BusinessOrganizationUserSuggestionTypeAggregate'], ParentType, ContextType, Partial<query_rootbusinessOrganizationUserSuggestionTypeAggregateArgs>>;
  businessOrganizationUserSuggestionTypeByPk?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserSuggestionType']>, ParentType, ContextType, RequireFields<query_rootbusinessOrganizationUserSuggestionTypeByPkArgs, 'value'>>;
  businessOrganizationUserSuggestions?: Resolver<Array<ResolversTypes['BusinessOrganizationUserSuggestions']>, ParentType, ContextType, Partial<query_rootbusinessOrganizationUserSuggestionsArgs>>;
  businessOrganizationUserSuggestionsAggregate?: Resolver<ResolversTypes['BusinessOrganizationUserSuggestionsAggregate'], ParentType, ContextType, Partial<query_rootbusinessOrganizationUserSuggestionsAggregateArgs>>;
  businessOrganizationUserSuggestionsByPk?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserSuggestions']>, ParentType, ContextType, RequireFields<query_rootbusinessOrganizationUserSuggestionsByPkArgs, 'id'>>;
  businessOrganizationUserUrlAddress?: Resolver<Array<ResolversTypes['BusinessOrganizationUserUrlAddress']>, ParentType, ContextType, Partial<query_rootbusinessOrganizationUserUrlAddressArgs>>;
  businessOrganizationUserUrlAddressAggregate?: Resolver<ResolversTypes['BusinessOrganizationUserUrlAddressAggregate'], ParentType, ContextType, Partial<query_rootbusinessOrganizationUserUrlAddressAggregateArgs>>;
  businessOrganizationUserUrlAddressByPk?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserUrlAddress']>, ParentType, ContextType, RequireFields<query_rootbusinessOrganizationUserUrlAddressByPkArgs, 'id'>>;
  businessOrganizationUserUrlAddressType?: Resolver<Array<ResolversTypes['BusinessOrganizationUserUrlAddressType']>, ParentType, ContextType, Partial<query_rootbusinessOrganizationUserUrlAddressTypeArgs>>;
  businessOrganizationUserUrlAddressTypeAggregate?: Resolver<ResolversTypes['BusinessOrganizationUserUrlAddressTypeAggregate'], ParentType, ContextType, Partial<query_rootbusinessOrganizationUserUrlAddressTypeAggregateArgs>>;
  businessOrganizationUserUrlAddressTypeByPk?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserUrlAddressType']>, ParentType, ContextType, RequireFields<query_rootbusinessOrganizationUserUrlAddressTypeByPkArgs, 'value'>>;
  businessQueueItemAlarmType?: Resolver<Array<ResolversTypes['BusinessQueueItemAlarmType']>, ParentType, ContextType, Partial<query_rootbusinessQueueItemAlarmTypeArgs>>;
  businessQueueItemAlarmTypeAggregate?: Resolver<ResolversTypes['BusinessQueueItemAlarmTypeAggregate'], ParentType, ContextType, Partial<query_rootbusinessQueueItemAlarmTypeAggregateArgs>>;
  businessQueueItemAlarmTypeByPk?: Resolver<Maybe<ResolversTypes['BusinessQueueItemAlarmType']>, ParentType, ContextType, RequireFields<query_rootbusinessQueueItemAlarmTypeByPkArgs, 'value'>>;
  businessQueueItemAlarms?: Resolver<Array<ResolversTypes['BusinessQueueItemAlarms']>, ParentType, ContextType, Partial<query_rootbusinessQueueItemAlarmsArgs>>;
  businessQueueItemAlarmsAggregate?: Resolver<ResolversTypes['BusinessQueueItemAlarmsAggregate'], ParentType, ContextType, Partial<query_rootbusinessQueueItemAlarmsAggregateArgs>>;
  businessQueueItemAlarmsByPk?: Resolver<Maybe<ResolversTypes['BusinessQueueItemAlarms']>, ParentType, ContextType, RequireFields<query_rootbusinessQueueItemAlarmsByPkArgs, 'id'>>;
  businessQueueItemCollaboration?: Resolver<Maybe<ResolversTypes['businessQueueItemCollaboration']>, ParentType, ContextType, RequireFields<query_rootbusinessQueueItemCollaborationArgs, 'id'>>;
  businessQueueItemCollaborationAggregate?: Resolver<ResolversTypes['businessQueueItemCollaborationAggregate'], ParentType, ContextType, Partial<query_rootbusinessQueueItemCollaborationAggregateArgs>>;
  businessQueueItemCollaborations?: Resolver<Array<ResolversTypes['businessQueueItemCollaboration']>, ParentType, ContextType, Partial<query_rootbusinessQueueItemCollaborationsArgs>>;
  businessQueueItemDomainUsersView?: Resolver<Array<ResolversTypes['BusinessQueueItemDomainUsersView']>, ParentType, ContextType, Partial<query_rootbusinessQueueItemDomainUsersViewArgs>>;
  businessQueueItemDomainUsersViewAggregate?: Resolver<ResolversTypes['BusinessQueueItemDomainUsersViewAggregate'], ParentType, ContextType, Partial<query_rootbusinessQueueItemDomainUsersViewAggregateArgs>>;
  businessQueueItemOrganizationUsersView?: Resolver<Array<ResolversTypes['BusinessQueueItemOrganizationUsersView']>, ParentType, ContextType, Partial<query_rootbusinessQueueItemOrganizationUsersViewArgs>>;
  businessQueueItemOrganizationUsersViewAggregate?: Resolver<ResolversTypes['BusinessQueueItemOrganizationUsersViewAggregate'], ParentType, ContextType, Partial<query_rootbusinessQueueItemOrganizationUsersViewAggregateArgs>>;
  businessQueueItemParticipantChannelType?: Resolver<Array<ResolversTypes['BusinessQueueItemParticipantChannelType']>, ParentType, ContextType, Partial<query_rootbusinessQueueItemParticipantChannelTypeArgs>>;
  businessQueueItemParticipantChannelTypeAggregate?: Resolver<ResolversTypes['BusinessQueueItemParticipantChannelTypeAggregate'], ParentType, ContextType, Partial<query_rootbusinessQueueItemParticipantChannelTypeAggregateArgs>>;
  businessQueueItemParticipantChannelTypeByPk?: Resolver<Maybe<ResolversTypes['BusinessQueueItemParticipantChannelType']>, ParentType, ContextType, RequireFields<query_rootbusinessQueueItemParticipantChannelTypeByPkArgs, 'value'>>;
  businessQueueItemParticipantsView?: Resolver<Array<ResolversTypes['BusinessQueueItemParticipantsView']>, ParentType, ContextType, Partial<query_rootbusinessQueueItemParticipantsViewArgs>>;
  businessQueueItemParticipantsViewAggregate?: Resolver<ResolversTypes['BusinessQueueItemParticipantsViewAggregate'], ParentType, ContextType, Partial<query_rootbusinessQueueItemParticipantsViewAggregateArgs>>;
  businessQueueItemSubType?: Resolver<Array<ResolversTypes['BusinessQueueItemSubType']>, ParentType, ContextType, Partial<query_rootbusinessQueueItemSubTypeArgs>>;
  businessQueueItemSubTypeAggregate?: Resolver<ResolversTypes['BusinessQueueItemSubTypeAggregate'], ParentType, ContextType, Partial<query_rootbusinessQueueItemSubTypeAggregateArgs>>;
  businessQueueItemSubTypeByPk?: Resolver<Maybe<ResolversTypes['BusinessQueueItemSubType']>, ParentType, ContextType, RequireFields<query_rootbusinessQueueItemSubTypeByPkArgs, 'value'>>;
  businessUserContact?: Resolver<Maybe<ResolversTypes['businessUserContacts']>, ParentType, ContextType, RequireFields<query_rootbusinessUserContactArgs, 'id'>>;
  businessUserContactNumbers?: Resolver<Array<ResolversTypes['BusinessUserContactNumbers']>, ParentType, ContextType, Partial<query_rootbusinessUserContactNumbersArgs>>;
  businessUserContactNumbersAggregate?: Resolver<ResolversTypes['BusinessUserContactNumbersAggregate'], ParentType, ContextType, Partial<query_rootbusinessUserContactNumbersAggregateArgs>>;
  businessUserContactNumbersByPk?: Resolver<Maybe<ResolversTypes['BusinessUserContactNumbers']>, ParentType, ContextType, RequireFields<query_rootbusinessUserContactNumbersByPkArgs, 'id'>>;
  businessUserContacts?: Resolver<Array<ResolversTypes['businessUserContacts']>, ParentType, ContextType, Partial<query_rootbusinessUserContactsArgs>>;
  businessUserFeed?: Resolver<Array<ResolversTypes['BusinessUserFeed']>, ParentType, ContextType, Partial<query_rootbusinessUserFeedArgs>>;
  businessUserFeedAggregate?: Resolver<ResolversTypes['BusinessUserFeedAggregate'], ParentType, ContextType, Partial<query_rootbusinessUserFeedAggregateArgs>>;
  businessUserFeedByPk?: Resolver<Maybe<ResolversTypes['BusinessUserFeed']>, ParentType, ContextType, RequireFields<query_rootbusinessUserFeedByPkArgs, 'id'>>;
  businessUserRequestStatus?: Resolver<Array<ResolversTypes['BusinessUserRequestStatus']>, ParentType, ContextType, Partial<query_rootbusinessUserRequestStatusArgs>>;
  businessUserRequestStatusAggregate?: Resolver<ResolversTypes['BusinessUserRequestStatusAggregate'], ParentType, ContextType, Partial<query_rootbusinessUserRequestStatusAggregateArgs>>;
  businessUserRequestStatusByPk?: Resolver<Maybe<ResolversTypes['BusinessUserRequestStatus']>, ParentType, ContextType, RequireFields<query_rootbusinessUserRequestStatusByPkArgs, 'value'>>;
  businessUserSetting?: Resolver<Maybe<ResolversTypes['businessUserSettings']>, ParentType, ContextType, RequireFields<query_rootbusinessUserSettingArgs, 'id'>>;
  businessUserSettings?: Resolver<Array<ResolversTypes['businessUserSettings']>, ParentType, ContextType, Partial<query_rootbusinessUserSettingsArgs>>;
  businessUserStates?: Resolver<Array<ResolversTypes['BusinessUserStates']>, ParentType, ContextType, Partial<query_rootbusinessUserStatesArgs>>;
  businessUserStatesAggregate?: Resolver<ResolversTypes['BusinessUserStatesAggregate'], ParentType, ContextType, Partial<query_rootbusinessUserStatesAggregateArgs>>;
  businessUserStatesByPk?: Resolver<Maybe<ResolversTypes['BusinessUserStates']>, ParentType, ContextType, RequireFields<query_rootbusinessUserStatesByPkArgs, 'id'>>;
  crmContext?: Resolver<Array<ResolversTypes['CrmContext']>, ParentType, ContextType, Partial<query_rootcrmContextArgs>>;
  crmContextAggregate?: Resolver<ResolversTypes['CrmContextAggregate'], ParentType, ContextType, Partial<query_rootcrmContextAggregateArgs>>;
  crmContextByPk?: Resolver<Maybe<ResolversTypes['CrmContext']>, ParentType, ContextType, RequireFields<query_rootcrmContextByPkArgs, 'id'>>;
  crmContextType?: Resolver<Array<ResolversTypes['CrmContextType']>, ParentType, ContextType, Partial<query_rootcrmContextTypeArgs>>;
  crmContextTypeAggregate?: Resolver<ResolversTypes['CrmContextTypeAggregate'], ParentType, ContextType, Partial<query_rootcrmContextTypeAggregateArgs>>;
  crmContextTypeByPk?: Resolver<Maybe<ResolversTypes['CrmContextType']>, ParentType, ContextType, RequireFields<query_rootcrmContextTypeByPkArgs, 'value'>>;
  crmCreatorType?: Resolver<Array<ResolversTypes['CrmCreatorType']>, ParentType, ContextType, Partial<query_rootcrmCreatorTypeArgs>>;
  crmCreatorTypeAggregate?: Resolver<ResolversTypes['CrmCreatorTypeAggregate'], ParentType, ContextType, Partial<query_rootcrmCreatorTypeAggregateArgs>>;
  crmCreatorTypeByPk?: Resolver<Maybe<ResolversTypes['CrmCreatorType']>, ParentType, ContextType, RequireFields<query_rootcrmCreatorTypeByPkArgs, 'value'>>;
  crmCrmType?: Resolver<Array<ResolversTypes['CrmCrmType']>, ParentType, ContextType, Partial<query_rootcrmCrmTypeArgs>>;
  crmCrmTypeAggregate?: Resolver<ResolversTypes['CrmCrmTypeAggregate'], ParentType, ContextType, Partial<query_rootcrmCrmTypeAggregateArgs>>;
  crmCrmTypeByPk?: Resolver<Maybe<ResolversTypes['CrmCrmType']>, ParentType, ContextType, RequireFields<query_rootcrmCrmTypeByPkArgs, 'value'>>;
  crmDirectionType?: Resolver<Array<ResolversTypes['CrmDirectionType']>, ParentType, ContextType, Partial<query_rootcrmDirectionTypeArgs>>;
  crmDirectionTypeAggregate?: Resolver<ResolversTypes['CrmDirectionTypeAggregate'], ParentType, ContextType, Partial<query_rootcrmDirectionTypeAggregateArgs>>;
  crmDirectionTypeByPk?: Resolver<Maybe<ResolversTypes['CrmDirectionType']>, ParentType, ContextType, RequireFields<query_rootcrmDirectionTypeByPkArgs, 'value'>>;
  crmEntity?: Resolver<Array<ResolversTypes['CrmEntity']>, ParentType, ContextType, Partial<query_rootcrmEntityArgs>>;
  crmEntityAggregate?: Resolver<ResolversTypes['CrmEntityAggregate'], ParentType, ContextType, Partial<query_rootcrmEntityAggregateArgs>>;
  crmEntityByPk?: Resolver<Maybe<ResolversTypes['CrmEntity']>, ParentType, ContextType, RequireFields<query_rootcrmEntityByPkArgs, 'id'>>;
  crmEvent?: Resolver<Array<ResolversTypes['CrmEvent']>, ParentType, ContextType, Partial<query_rootcrmEventArgs>>;
  crmEventAggregate?: Resolver<ResolversTypes['CrmEventAggregate'], ParentType, ContextType, Partial<query_rootcrmEventAggregateArgs>>;
  crmEventByPk?: Resolver<Maybe<ResolversTypes['CrmEvent']>, ParentType, ContextType, RequireFields<query_rootcrmEventByPkArgs, 'id'>>;
  crmEventType?: Resolver<Array<ResolversTypes['CrmEventType']>, ParentType, ContextType, Partial<query_rootcrmEventTypeArgs>>;
  crmEventTypeAggregate?: Resolver<ResolversTypes['CrmEventTypeAggregate'], ParentType, ContextType, Partial<query_rootcrmEventTypeAggregateArgs>>;
  crmEventTypeByPk?: Resolver<Maybe<ResolversTypes['CrmEventType']>, ParentType, ContextType, RequireFields<query_rootcrmEventTypeByPkArgs, 'value'>>;
  crmStatusCode?: Resolver<Array<ResolversTypes['CrmStatusCode']>, ParentType, ContextType, Partial<query_rootcrmStatusCodeArgs>>;
  crmStatusCodeAggregate?: Resolver<ResolversTypes['CrmStatusCodeAggregate'], ParentType, ContextType, Partial<query_rootcrmStatusCodeAggregateArgs>>;
  crmStatusCodeByPk?: Resolver<Maybe<ResolversTypes['CrmStatusCode']>, ParentType, ContextType, RequireFields<query_rootcrmStatusCodeByPkArgs, 'value'>>;
  crmStatusMessageAggregate?: Resolver<ResolversTypes['crmStatusMessageAggregate'], ParentType, ContextType, Partial<query_rootcrmStatusMessageAggregateArgs>>;
  crmStatusMessageByPk?: Resolver<Maybe<ResolversTypes['crmStatusMessage']>, ParentType, ContextType, RequireFields<query_rootcrmStatusMessageByPkArgs, 'id'>>;
  crmStatusMessages?: Resolver<Array<ResolversTypes['crmStatusMessage']>, ParentType, ContextType, Partial<query_rootcrmStatusMessagesArgs>>;
  crmSystemType?: Resolver<Array<ResolversTypes['CrmSystemType']>, ParentType, ContextType, Partial<query_rootcrmSystemTypeArgs>>;
  crmSystemTypeAggregate?: Resolver<ResolversTypes['CrmSystemTypeAggregate'], ParentType, ContextType, Partial<query_rootcrmSystemTypeAggregateArgs>>;
  crmSystemTypeByPk?: Resolver<Maybe<ResolversTypes['CrmSystemType']>, ParentType, ContextType, RequireFields<query_rootcrmSystemTypeByPkArgs, 'value'>>;
  crmTraceContext?: Resolver<Array<ResolversTypes['CrmTraceContext']>, ParentType, ContextType, Partial<query_rootcrmTraceContextArgs>>;
  crmTraceContextAggregate?: Resolver<ResolversTypes['CrmTraceContextAggregate'], ParentType, ContextType, Partial<query_rootcrmTraceContextAggregateArgs>>;
  crmTraceContextByPk?: Resolver<Maybe<ResolversTypes['CrmTraceContext']>, ParentType, ContextType, RequireFields<query_rootcrmTraceContextByPkArgs, 'id'>>;
  crmUnifiedEntityType?: Resolver<Array<ResolversTypes['CrmUnifiedEntityType']>, ParentType, ContextType, Partial<query_rootcrmUnifiedEntityTypeArgs>>;
  crmUnifiedEntityTypeAggregate?: Resolver<ResolversTypes['CrmUnifiedEntityTypeAggregate'], ParentType, ContextType, Partial<query_rootcrmUnifiedEntityTypeAggregateArgs>>;
  crmUnifiedEntityTypeByPk?: Resolver<Maybe<ResolversTypes['CrmUnifiedEntityType']>, ParentType, ContextType, RequireFields<query_rootcrmUnifiedEntityTypeByPkArgs, 'value'>>;
  crmYoutelloCatalystIdMapping?: Resolver<Maybe<ResolversTypes['crmYoutelloCatalystIdMapping']>, ParentType, ContextType, RequireFields<query_rootcrmYoutelloCatalystIdMappingArgs, 'catalystId' | 'youtelloId'>>;
  crmYoutelloCatalystIdMappingAggregate?: Resolver<ResolversTypes['crmYoutelloCatalystIdMappingAggregate'], ParentType, ContextType, Partial<query_rootcrmYoutelloCatalystIdMappingAggregateArgs>>;
  crmYoutelloCatalystIdMappings?: Resolver<Array<ResolversTypes['crmYoutelloCatalystIdMapping']>, ParentType, ContextType, Partial<query_rootcrmYoutelloCatalystIdMappingsArgs>>;
  domainActivities?: Resolver<Array<ResolversTypes['domainActivity']>, ParentType, ContextType, Partial<query_rootdomainActivitiesArgs>>;
  domainActivitiesAggregate?: Resolver<ResolversTypes['domainActivityAggregate'], ParentType, ContextType, Partial<query_rootdomainActivitiesAggregateArgs>>;
  domainActivity?: Resolver<Maybe<ResolversTypes['domainActivity']>, ParentType, ContextType, RequireFields<query_rootdomainActivityArgs, 'id'>>;
  domainOrganization?: Resolver<Maybe<ResolversTypes['domainOrganization']>, ParentType, ContextType, RequireFields<query_rootdomainOrganizationArgs, 'id'>>;
  domainOrganizations?: Resolver<Array<ResolversTypes['domainOrganization']>, ParentType, ContextType, Partial<query_rootdomainOrganizationsArgs>>;
  domainOrganizationsAggregate?: Resolver<ResolversTypes['domainOrganizationAggregate'], ParentType, ContextType, Partial<query_rootdomainOrganizationsAggregateArgs>>;
  domainParticipant?: Resolver<Maybe<ResolversTypes['domainParticipant']>, ParentType, ContextType, RequireFields<query_rootdomainParticipantArgs, 'id'>>;
  domainParticipants?: Resolver<Array<ResolversTypes['domainParticipant']>, ParentType, ContextType, Partial<query_rootdomainParticipantsArgs>>;
  domainParticipantsAggregate?: Resolver<ResolversTypes['domainParticipantAggregate'], ParentType, ContextType, Partial<query_rootdomainParticipantsAggregateArgs>>;
  domainType?: Resolver<Maybe<ResolversTypes['domainType']>, ParentType, ContextType, RequireFields<query_rootdomainTypeArgs, 'value'>>;
  domainTypes?: Resolver<Array<ResolversTypes['domainType']>, ParentType, ContextType, Partial<query_rootdomainTypesArgs>>;
  domainTypesAggregate?: Resolver<ResolversTypes['domainTypeAggregate'], ParentType, ContextType, Partial<query_rootdomainTypesAggregateArgs>>;
  domainUser?: Resolver<Maybe<ResolversTypes['domainUser']>, ParentType, ContextType, RequireFields<query_rootdomainUserArgs, 'id'>>;
  domainUserCategories?: Resolver<Array<ResolversTypes['domainUserCategory']>, ParentType, ContextType, Partial<query_rootdomainUserCategoriesArgs>>;
  domainUserCategoriesAggregate?: Resolver<ResolversTypes['domainUserCategoryAggregate'], ParentType, ContextType, Partial<query_rootdomainUserCategoriesAggregateArgs>>;
  domainUserCategory?: Resolver<Maybe<ResolversTypes['domainUserCategory']>, ParentType, ContextType, RequireFields<query_rootdomainUserCategoryArgs, 'value'>>;
  domainUsers?: Resolver<Array<ResolversTypes['domainUser']>, ParentType, ContextType, Partial<query_rootdomainUsersArgs>>;
  domainUsersAggregate?: Resolver<ResolversTypes['domainUserAggregate'], ParentType, ContextType, Partial<query_rootdomainUsersAggregateArgs>>;
  emailing?: Resolver<Maybe<ResolversTypes['emailingquery_root']>, ParentType, ContextType>;
  geodata?: Resolver<Maybe<ResolversTypes['geodataquery_root']>, ParentType, ContextType>;
  getDashboardData?: Resolver<Maybe<ResolversTypes['dashboardDataOutput']>, ParentType, ContextType, RequireFields<query_rootgetDashboardDataArgs, 'timestamptz'>>;
  getEmailAccount?: Resolver<Maybe<Array<Maybe<ResolversTypes['getEmailAccountOutput']>>>, ParentType, ContextType, RequireFields<query_rootgetEmailAccountArgs, 'account'>>;
  getOrganization?: Resolver<Maybe<ResolversTypes['OrganizationOutput']>, ParentType, ContextType, Partial<query_rootgetOrganizationArgs>>;
  getOrganizations?: Resolver<Maybe<ResolversTypes['OrganizationsOutput']>, ParentType, ContextType, RequireFields<query_rootgetOrganizationsArgs, 'userId'>>;
  getUser?: Resolver<Maybe<ResolversTypes['organizationUserOutput']>, ParentType, ContextType, RequireFields<query_rootgetUserArgs, 'user'>>;
  incomingSms?: Resolver<Maybe<ResolversTypes['incomingSms']>, ParentType, ContextType, RequireFields<query_rootincomingSmsArgs, 'id'>>;
  isPhoneUser?: Resolver<Maybe<ResolversTypes['phoneUserOutput']>, ParentType, ContextType, RequireFields<query_rootisPhoneUserArgs, 'user'>>;
  language?: Resolver<Maybe<ResolversTypes['languages']>, ParentType, ContextType, RequireFields<query_rootlanguageArgs, 'value'>>;
  languageAggregate?: Resolver<ResolversTypes['languagesAggregate'], ParentType, ContextType, Partial<query_rootlanguageAggregateArgs>>;
  languages?: Resolver<Array<ResolversTypes['languages']>, ParentType, ContextType, Partial<query_rootlanguagesArgs>>;
  lookupPhoneNumber?: Resolver<Maybe<ResolversTypes['LookupPhoneNumberOutput']>, ParentType, ContextType, Partial<query_rootlookupPhoneNumberArgs>>;
  message?: Resolver<Maybe<ResolversTypes['message']>, ParentType, ContextType, RequireFields<query_rootmessageArgs, 'id'>>;
  messageType?: Resolver<Maybe<ResolversTypes['messageType']>, ParentType, ContextType, RequireFields<query_rootmessageTypeArgs, 'value'>>;
  messageTypes?: Resolver<Array<ResolversTypes['messageType']>, ParentType, ContextType, Partial<query_rootmessageTypesArgs>>;
  messageTypesAggregate?: Resolver<ResolversTypes['messageTypeAggregate'], ParentType, ContextType, Partial<query_rootmessageTypesAggregateArgs>>;
  messages?: Resolver<Array<ResolversTypes['message']>, ParentType, ContextType, Partial<query_rootmessagesArgs>>;
  messagesAggregate?: Resolver<ResolversTypes['messageAggregate'], ParentType, ContextType, Partial<query_rootmessagesAggregateArgs>>;
  messagingActivities?: Resolver<Array<ResolversTypes['messagingActivity']>, ParentType, ContextType, Partial<query_rootmessagingActivitiesArgs>>;
  messagingActivity?: Resolver<Maybe<ResolversTypes['messagingActivity']>, ParentType, ContextType, RequireFields<query_rootmessagingActivityArgs, 'id'>>;
  messagingActivityOrganization?: Resolver<Maybe<ResolversTypes['messagingActivityOrganization']>, ParentType, ContextType, RequireFields<query_rootmessagingActivityOrganizationArgs, 'id'>>;
  messagingActivityOrganizationAggregate?: Resolver<ResolversTypes['messagingActivityOrganizationAggregate'], ParentType, ContextType, Partial<query_rootmessagingActivityOrganizationAggregateArgs>>;
  messagingActivityOrganizations?: Resolver<Array<ResolversTypes['messagingActivityOrganization']>, ParentType, ContextType, Partial<query_rootmessagingActivityOrganizationsArgs>>;
  messagingActivitySettings?: Resolver<Array<ResolversTypes['MessagingActivitySettings']>, ParentType, ContextType, Partial<query_rootmessagingActivitySettingsArgs>>;
  messagingActivitySettingsAggregate?: Resolver<ResolversTypes['MessagingActivitySettingsAggregate'], ParentType, ContextType, Partial<query_rootmessagingActivitySettingsAggregateArgs>>;
  messagingActivitySettingsByPk?: Resolver<Maybe<ResolversTypes['MessagingActivitySettings']>, ParentType, ContextType, RequireFields<query_rootmessagingActivitySettingsByPkArgs, 'id'>>;
  messagingActivitySettingsNotificationSettingType?: Resolver<Array<ResolversTypes['MessagingActivitySettingsNotificationSettingType']>, ParentType, ContextType, Partial<query_rootmessagingActivitySettingsNotificationSettingTypeArgs>>;
  messagingActivitySettingsNotificationSettingTypeAggregate?: Resolver<ResolversTypes['MessagingActivitySettingsNotificationSettingTypeAggregate'], ParentType, ContextType, Partial<query_rootmessagingActivitySettingsNotificationSettingTypeAggregateArgs>>;
  messagingActivitySettingsNotificationSettingTypeByPk?: Resolver<Maybe<ResolversTypes['MessagingActivitySettingsNotificationSettingType']>, ParentType, ContextType, RequireFields<query_rootmessagingActivitySettingsNotificationSettingTypeByPkArgs, 'value'>>;
  messagingActivityType?: Resolver<Maybe<ResolversTypes['messagingActivityType']>, ParentType, ContextType, RequireFields<query_rootmessagingActivityTypeArgs, 'value'>>;
  messagingActivityTypes?: Resolver<Array<ResolversTypes['messagingActivityType']>, ParentType, ContextType, Partial<query_rootmessagingActivityTypesArgs>>;
  messagingActivityUser?: Resolver<Maybe<ResolversTypes['messagingActivityUser']>, ParentType, ContextType, RequireFields<query_rootmessagingActivityUserArgs, 'id'>>;
  messagingActivityUsers?: Resolver<Array<ResolversTypes['messagingActivityUser']>, ParentType, ContextType, Partial<query_rootmessagingActivityUsersArgs>>;
  messagingInvitation?: Resolver<Array<ResolversTypes['MessagingInvitation']>, ParentType, ContextType, Partial<query_rootmessagingInvitationArgs>>;
  messagingInvitationAggregate?: Resolver<ResolversTypes['MessagingInvitationAggregate'], ParentType, ContextType, Partial<query_rootmessagingInvitationAggregateArgs>>;
  messagingInvitationByPk?: Resolver<Maybe<ResolversTypes['MessagingInvitation']>, ParentType, ContextType, RequireFields<query_rootmessagingInvitationByPkArgs, 'id'>>;
  messagingMentions?: Resolver<Array<ResolversTypes['MessagingMentions']>, ParentType, ContextType, Partial<query_rootmessagingMentionsArgs>>;
  messagingMentionsAggregate?: Resolver<ResolversTypes['MessagingMentionsAggregate'], ParentType, ContextType, Partial<query_rootmessagingMentionsAggregateArgs>>;
  messagingMentionsByPk?: Resolver<Maybe<ResolversTypes['MessagingMentions']>, ParentType, ContextType, RequireFields<query_rootmessagingMentionsByPkArgs, 'id'>>;
  messagingMessage?: Resolver<Maybe<ResolversTypes['messagingMessage']>, ParentType, ContextType, RequireFields<query_rootmessagingMessageArgs, 'id'>>;
  messagingMessageAttachment?: Resolver<Array<ResolversTypes['MessagingMessageAttachment']>, ParentType, ContextType, Partial<query_rootmessagingMessageAttachmentArgs>>;
  messagingMessageAttachmentAggregate?: Resolver<ResolversTypes['MessagingMessageAttachmentAggregate'], ParentType, ContextType, Partial<query_rootmessagingMessageAttachmentAggregateArgs>>;
  messagingMessageAttachmentByPk?: Resolver<Maybe<ResolversTypes['MessagingMessageAttachment']>, ParentType, ContextType, RequireFields<query_rootmessagingMessageAttachmentByPkArgs, 'id'>>;
  messagingMessageAttachmentType?: Resolver<Array<ResolversTypes['MessagingMessageAttachmentType']>, ParentType, ContextType, Partial<query_rootmessagingMessageAttachmentTypeArgs>>;
  messagingMessageAttachmentTypeAggregate?: Resolver<ResolversTypes['MessagingMessageAttachmentTypeAggregate'], ParentType, ContextType, Partial<query_rootmessagingMessageAttachmentTypeAggregateArgs>>;
  messagingMessageAttachmentTypeByPk?: Resolver<Maybe<ResolversTypes['MessagingMessageAttachmentType']>, ParentType, ContextType, RequireFields<query_rootmessagingMessageAttachmentTypeByPkArgs, 'value'>>;
  messagingMessageEmoji?: Resolver<Maybe<ResolversTypes['messagingMessageEmoji']>, ParentType, ContextType, RequireFields<query_rootmessagingMessageEmojiArgs, 'id'>>;
  messagingMessageEmojis?: Resolver<Array<ResolversTypes['messagingMessageEmoji']>, ParentType, ContextType, Partial<query_rootmessagingMessageEmojisArgs>>;
  messagingMessagePriority?: Resolver<Array<ResolversTypes['MessagingMessagePriority']>, ParentType, ContextType, Partial<query_rootmessagingMessagePriorityArgs>>;
  messagingMessagePriorityAggregate?: Resolver<ResolversTypes['MessagingMessagePriorityAggregate'], ParentType, ContextType, Partial<query_rootmessagingMessagePriorityAggregateArgs>>;
  messagingMessagePriorityByPk?: Resolver<Maybe<ResolversTypes['MessagingMessagePriority']>, ParentType, ContextType, RequireFields<query_rootmessagingMessagePriorityByPkArgs, 'value'>>;
  messagingMessageRead?: Resolver<Maybe<ResolversTypes['messagingMessageRead']>, ParentType, ContextType, RequireFields<query_rootmessagingMessageReadArgs, 'id'>>;
  messagingMessageReads?: Resolver<Array<ResolversTypes['messagingMessageRead']>, ParentType, ContextType, Partial<query_rootmessagingMessageReadsArgs>>;
  messagingMessageType?: Resolver<Maybe<ResolversTypes['messagingMessageType']>, ParentType, ContextType, RequireFields<query_rootmessagingMessageTypeArgs, 'value'>>;
  messagingMessageTypes?: Resolver<Array<ResolversTypes['messagingMessageType']>, ParentType, ContextType, Partial<query_rootmessagingMessageTypesArgs>>;
  messagingMessages?: Resolver<Array<ResolversTypes['messagingMessage']>, ParentType, ContextType, Partial<query_rootmessagingMessagesArgs>>;
  notification?: Resolver<Maybe<ResolversTypes['notification']>, ParentType, ContextType, RequireFields<query_rootnotificationArgs, 'id'>>;
  notificationNotificationDeviceSent?: Resolver<Array<ResolversTypes['NotificationNotificationDeviceSent']>, ParentType, ContextType, Partial<query_rootnotificationNotificationDeviceSentArgs>>;
  notificationNotificationDeviceSentAggregate?: Resolver<ResolversTypes['NotificationNotificationDeviceSentAggregate'], ParentType, ContextType, Partial<query_rootnotificationNotificationDeviceSentAggregateArgs>>;
  notificationNotificationDeviceSentByPk?: Resolver<Maybe<ResolversTypes['NotificationNotificationDeviceSent']>, ParentType, ContextType, RequireFields<query_rootnotificationNotificationDeviceSentByPkArgs, 'id'>>;
  notificationNotificationSettingActivityPrimaryEnum?: Resolver<Array<ResolversTypes['NotificationNotificationSettingActivityPrimaryEnum']>, ParentType, ContextType, Partial<query_rootnotificationNotificationSettingActivityPrimaryEnumArgs>>;
  notificationNotificationSettingActivityPrimaryEnumAggregate?: Resolver<ResolversTypes['NotificationNotificationSettingActivityPrimaryEnumAggregate'], ParentType, ContextType, Partial<query_rootnotificationNotificationSettingActivityPrimaryEnumAggregateArgs>>;
  notificationNotificationSettingActivityPrimaryEnumByPk?: Resolver<Maybe<ResolversTypes['NotificationNotificationSettingActivityPrimaryEnum']>, ParentType, ContextType, RequireFields<query_rootnotificationNotificationSettingActivityPrimaryEnumByPkArgs, 'value'>>;
  notificationSend?: Resolver<Maybe<ResolversTypes['notificationSend']>, ParentType, ContextType, RequireFields<query_rootnotificationSendArgs, 'id'>>;
  notificationSends?: Resolver<Array<ResolversTypes['notificationSend']>, ParentType, ContextType, Partial<query_rootnotificationSendsArgs>>;
  notificationSendsAggregate?: Resolver<ResolversTypes['notificationSendAggregate'], ParentType, ContextType, Partial<query_rootnotificationSendsAggregateArgs>>;
  notificationSettingActivities?: Resolver<Array<ResolversTypes['notificationSettingActivity']>, ParentType, ContextType, Partial<query_rootnotificationSettingActivitiesArgs>>;
  notificationSettingActivitiesAggregate?: Resolver<ResolversTypes['notificationSettingActivityAggregate'], ParentType, ContextType, Partial<query_rootnotificationSettingActivitiesAggregateArgs>>;
  notificationSettingActivity?: Resolver<Maybe<ResolversTypes['notificationSettingActivity']>, ParentType, ContextType, RequireFields<query_rootnotificationSettingActivityArgs, 'id'>>;
  notificationUser?: Resolver<Maybe<ResolversTypes['notificationUser']>, ParentType, ContextType, RequireFields<query_rootnotificationUserArgs, 'id'>>;
  notificationUserDevice?: Resolver<Maybe<ResolversTypes['notificationUserDevice']>, ParentType, ContextType, RequireFields<query_rootnotificationUserDeviceArgs, 'id'>>;
  notificationUserDevices?: Resolver<Array<ResolversTypes['notificationUserDevice']>, ParentType, ContextType, Partial<query_rootnotificationUserDevicesArgs>>;
  notificationUserDevicesAggregate?: Resolver<ResolversTypes['notificationUserDeviceAggregate'], ParentType, ContextType, Partial<query_rootnotificationUserDevicesAggregateArgs>>;
  notificationUsers?: Resolver<Array<ResolversTypes['notificationUser']>, ParentType, ContextType, Partial<query_rootnotificationUsersArgs>>;
  notificationUsersAggregate?: Resolver<ResolversTypes['notificationUserAggregate'], ParentType, ContextType, Partial<query_rootnotificationUsersAggregateArgs>>;
  notifications?: Resolver<Array<ResolversTypes['notification']>, ParentType, ContextType, Partial<query_rootnotificationsArgs>>;
  notificationsAggregate?: Resolver<ResolversTypes['notificationAggregate'], ParentType, ContextType, Partial<query_rootnotificationsAggregateArgs>>;
  ordersIntegration?: Resolver<Maybe<ResolversTypes['ordersIntegrations']>, ParentType, ContextType, RequireFields<query_rootordersIntegrationArgs, 'id'>>;
  ordersIntegrations?: Resolver<Array<ResolversTypes['ordersIntegrations']>, ParentType, ContextType, Partial<query_rootordersIntegrationsArgs>>;
  ordersIntegrationsAggregate?: Resolver<ResolversTypes['ordersIntegrationsAggregate'], ParentType, ContextType, Partial<query_rootordersIntegrationsAggregateArgs>>;
  ordersOrganizations?: Resolver<Array<ResolversTypes['OrdersOrganizations']>, ParentType, ContextType, Partial<query_rootordersOrganizationsArgs>>;
  ordersOrganizationsAggregate?: Resolver<ResolversTypes['OrdersOrganizationsAggregate'], ParentType, ContextType, Partial<query_rootordersOrganizationsAggregateArgs>>;
  ordersOrganizationsByPk?: Resolver<Maybe<ResolversTypes['OrdersOrganizations']>, ParentType, ContextType, RequireFields<query_rootordersOrganizationsByPkArgs, 'id'>>;
  ordersRequest?: Resolver<Array<ResolversTypes['OrdersRequest']>, ParentType, ContextType, Partial<query_rootordersRequestArgs>>;
  ordersRequestAggregate?: Resolver<ResolversTypes['OrdersRequestAggregate'], ParentType, ContextType, Partial<query_rootordersRequestAggregateArgs>>;
  ordersRequestByPk?: Resolver<Maybe<ResolversTypes['OrdersRequest']>, ParentType, ContextType, RequireFields<query_rootordersRequestByPkArgs, 'value'>>;
  ordersStatus?: Resolver<Array<ResolversTypes['OrdersStatus']>, ParentType, ContextType, Partial<query_rootordersStatusArgs>>;
  ordersStatusAggregate?: Resolver<ResolversTypes['OrdersStatusAggregate'], ParentType, ContextType, Partial<query_rootordersStatusAggregateArgs>>;
  ordersStatusByPk?: Resolver<Maybe<ResolversTypes['OrdersStatus']>, ParentType, ContextType, RequireFields<query_rootordersStatusByPkArgs, 'value'>>;
  ordersType?: Resolver<Array<ResolversTypes['OrdersType']>, ParentType, ContextType, Partial<query_rootordersTypeArgs>>;
  ordersTypeAggregate?: Resolver<ResolversTypes['OrdersTypeAggregate'], ParentType, ContextType, Partial<query_rootordersTypeAggregateArgs>>;
  ordersTypeByPk?: Resolver<Maybe<ResolversTypes['OrdersType']>, ParentType, ContextType, RequireFields<query_rootordersTypeByPkArgs, 'value'>>;
  organization?: Resolver<Maybe<ResolversTypes['organization']>, ParentType, ContextType, RequireFields<query_rootorganizationArgs, 'id'>>;
  organizationAuthorizationEnumGroup?: Resolver<Maybe<ResolversTypes['organizationAuthorizationEnumGroup']>, ParentType, ContextType, RequireFields<query_rootorganizationAuthorizationEnumGroupArgs, 'id'>>;
  organizationAuthorizationEnumGroups?: Resolver<Array<ResolversTypes['organizationAuthorizationEnumGroup']>, ParentType, ContextType, Partial<query_rootorganizationAuthorizationEnumGroupsArgs>>;
  organizationAuthorizationGroup?: Resolver<Maybe<ResolversTypes['organizationAuthorizationGroup']>, ParentType, ContextType, RequireFields<query_rootorganizationAuthorizationGroupArgs, 'id'>>;
  organizationAuthorizationGroups?: Resolver<Array<ResolversTypes['organizationAuthorizationGroup']>, ParentType, ContextType, Partial<query_rootorganizationAuthorizationGroupsArgs>>;
  organizationOrganizationRelationship?: Resolver<Maybe<ResolversTypes['organizationOrganizationRelationship']>, ParentType, ContextType, RequireFields<query_rootorganizationOrganizationRelationshipArgs, 'id'>>;
  organizationOrganizationRelationshipCategories?: Resolver<Array<ResolversTypes['organizationOrganizationRelationshipCategory']>, ParentType, ContextType, Partial<query_rootorganizationOrganizationRelationshipCategoriesArgs>>;
  organizationOrganizationRelationshipCategory?: Resolver<Maybe<ResolversTypes['organizationOrganizationRelationshipCategory']>, ParentType, ContextType, RequireFields<query_rootorganizationOrganizationRelationshipCategoryArgs, 'value'>>;
  organizationOrganizationRelationships?: Resolver<Array<ResolversTypes['organizationOrganizationRelationship']>, ParentType, ContextType, Partial<query_rootorganizationOrganizationRelationshipsArgs>>;
  organizationOrganizationUserAuthorization?: Resolver<Maybe<ResolversTypes['organizationOrganizationUserAuthorization']>, ParentType, ContextType, RequireFields<query_rootorganizationOrganizationUserAuthorizationArgs, 'id'>>;
  organizationOrganizationUserAuthorizations?: Resolver<Array<ResolversTypes['organizationOrganizationUserAuthorization']>, ParentType, ContextType, Partial<query_rootorganizationOrganizationUserAuthorizationsArgs>>;
  organizationOrganizationUserOrganizationsViews?: Resolver<Array<ResolversTypes['organizationOrganizationUserOrganizationsView']>, ParentType, ContextType, Partial<query_rootorganizationOrganizationUserOrganizationsViewsArgs>>;
  organizationOrganizationUserUsersViews?: Resolver<Array<ResolversTypes['organizationOrganizationUserUsersView']>, ParentType, ContextType, Partial<query_rootorganizationOrganizationUserUsersViewsArgs>>;
  organizationUser?: Resolver<Maybe<ResolversTypes['organizationUser']>, ParentType, ContextType, RequireFields<query_rootorganizationUserArgs, 'id'>>;
  organizationUserAttachment?: Resolver<Maybe<ResolversTypes['organizationUserAttachments']>, ParentType, ContextType, RequireFields<query_rootorganizationUserAttachmentArgs, 'id'>>;
  organizationUserAttachments?: Resolver<Array<ResolversTypes['organizationUserAttachments']>, ParentType, ContextType, Partial<query_rootorganizationUserAttachmentsArgs>>;
  organizationUserAttachmentsAggregate?: Resolver<ResolversTypes['organizationUserAttachmentsAggregate'], ParentType, ContextType, Partial<query_rootorganizationUserAttachmentsAggregateArgs>>;
  organizationUserAttentionNote?: Resolver<Maybe<ResolversTypes['OrganizationUserAttentionNote']>, ParentType, ContextType, RequireFields<query_rootorganizationUserAttentionNoteArgs, 'id'>>;
  organizationUserAttentionNoteAggregate?: Resolver<ResolversTypes['OrganizationUserAttentionNoteAggregate'], ParentType, ContextType, Partial<query_rootorganizationUserAttentionNoteAggregateArgs>>;
  organizationUserAttentionNotes?: Resolver<Array<ResolversTypes['OrganizationUserAttentionNote']>, ParentType, ContextType, Partial<query_rootorganizationUserAttentionNotesArgs>>;
  organizationUserAuthorization?: Resolver<Maybe<ResolversTypes['organizationUserAuthorization']>, ParentType, ContextType, RequireFields<query_rootorganizationUserAuthorizationArgs, 'value'>>;
  organizationUserAuthorizations?: Resolver<Array<ResolversTypes['organizationUserAuthorization']>, ParentType, ContextType, Partial<query_rootorganizationUserAuthorizationsArgs>>;
  organizationUserDetail?: Resolver<Maybe<ResolversTypes['organizationUserDetail']>, ParentType, ContextType, RequireFields<query_rootorganizationUserDetailArgs, 'id'>>;
  organizationUserDetailType?: Resolver<Maybe<ResolversTypes['organizationUserDetailType']>, ParentType, ContextType, RequireFields<query_rootorganizationUserDetailTypeArgs, 'value'>>;
  organizationUserDetailTypes?: Resolver<Array<ResolversTypes['organizationUserDetailType']>, ParentType, ContextType, Partial<query_rootorganizationUserDetailTypesArgs>>;
  organizationUserDetailTypesAggregate?: Resolver<ResolversTypes['organizationUserDetailTypeAggregate'], ParentType, ContextType, Partial<query_rootorganizationUserDetailTypesAggregateArgs>>;
  organizationUserDetails?: Resolver<Array<ResolversTypes['organizationUserDetail']>, ParentType, ContextType, Partial<query_rootorganizationUserDetailsArgs>>;
  organizationUserDetailsAggregate?: Resolver<ResolversTypes['organizationUserDetailAggregate'], ParentType, ContextType, Partial<query_rootorganizationUserDetailsAggregateArgs>>;
  organizationUserInvite?: Resolver<Maybe<ResolversTypes['organizationUserInvite']>, ParentType, ContextType, RequireFields<query_rootorganizationUserInviteArgs, 'id'>>;
  organizationUserInvites?: Resolver<Array<ResolversTypes['organizationUserInvite']>, ParentType, ContextType, Partial<query_rootorganizationUserInvitesArgs>>;
  organizationUserInvitesAggregate?: Resolver<ResolversTypes['organizationUserInviteAggregate'], ParentType, ContextType, Partial<query_rootorganizationUserInvitesAggregateArgs>>;
  organizationUserRequest?: Resolver<Maybe<ResolversTypes['BusinessOrganizationUserRequest']>, ParentType, ContextType, RequireFields<query_rootorganizationUserRequestArgs, 'id'>>;
  organizationUserRequests?: Resolver<Array<ResolversTypes['BusinessOrganizationUserRequest']>, ParentType, ContextType, Partial<query_rootorganizationUserRequestsArgs>>;
  organizationUserStatus?: Resolver<Maybe<ResolversTypes['organizationUserStatus']>, ParentType, ContextType, RequireFields<query_rootorganizationUserStatusArgs, 'value'>>;
  organizationUserStatuses?: Resolver<Array<ResolversTypes['organizationUserStatus']>, ParentType, ContextType, Partial<query_rootorganizationUserStatusesArgs>>;
  organizationUserStatusesAggregate?: Resolver<ResolversTypes['organizationUserStatusAggregate'], ParentType, ContextType, Partial<query_rootorganizationUserStatusesAggregateArgs>>;
  organizationUsers?: Resolver<Array<ResolversTypes['organizationUser']>, ParentType, ContextType, Partial<query_rootorganizationUsersArgs>>;
  organizationUsersAggregate?: Resolver<ResolversTypes['organizationUserAggregate'], ParentType, ContextType, Partial<query_rootorganizationUsersAggregateArgs>>;
  organizations?: Resolver<Array<ResolversTypes['organization']>, ParentType, ContextType, Partial<query_rootorganizationsArgs>>;
  organizationsAggregate?: Resolver<ResolversTypes['organizationAggregate'], ParentType, ContextType, Partial<query_rootorganizationsAggregateArgs>>;
  phoneNumberVerificationStatus?: Resolver<Maybe<ResolversTypes['phoneNumberVerificationStatus']>, ParentType, ContextType, RequireFields<query_rootphoneNumberVerificationStatusArgs, 'value'>>;
  phoneNumberVerificationStatuses?: Resolver<Array<ResolversTypes['phoneNumberVerificationStatus']>, ParentType, ContextType, Partial<query_rootphoneNumberVerificationStatusesArgs>>;
  phoneNumberVerificationStatusesAggregate?: Resolver<ResolversTypes['phoneNumberVerificationStatusAggregate'], ParentType, ContextType, Partial<query_rootphoneNumberVerificationStatusesAggregateArgs>>;
  prompt?: Resolver<Array<ResolversTypes['Prompt']>, ParentType, ContextType, Partial<query_rootpromptArgs>>;
  promptAggregate?: Resolver<ResolversTypes['PromptAggregate'], ParentType, ContextType, Partial<query_rootpromptAggregateArgs>>;
  promptByPk?: Resolver<Maybe<ResolversTypes['Prompt']>, ParentType, ContextType, RequireFields<query_rootpromptByPkArgs, 'id'>>;
  publicDevice?: Resolver<Maybe<ResolversTypes['publicDevice']>, ParentType, ContextType, RequireFields<query_rootpublicDeviceArgs, 'id'>>;
  publicDevices?: Resolver<Array<ResolversTypes['publicDevice']>, ParentType, ContextType, Partial<query_rootpublicDevicesArgs>>;
  publicExternalRequest?: Resolver<Maybe<ResolversTypes['publicExternalRequest']>, ParentType, ContextType, RequireFields<query_rootpublicExternalRequestArgs, 'id'>>;
  publicExternalRequests?: Resolver<Array<ResolversTypes['publicExternalRequest']>, ParentType, ContextType, Partial<query_rootpublicExternalRequestsArgs>>;
  publicFile?: Resolver<Maybe<ResolversTypes['publicFile']>, ParentType, ContextType, RequireFields<query_rootpublicFileArgs, 'id'>>;
  publicFiles?: Resolver<Array<ResolversTypes['publicFile']>, ParentType, ContextType, Partial<query_rootpublicFilesArgs>>;
  publicNotification?: Resolver<Maybe<ResolversTypes['publicNotification']>, ParentType, ContextType, RequireFields<query_rootpublicNotificationArgs, 'id'>>;
  publicNotifications?: Resolver<Array<ResolversTypes['publicNotification']>, ParentType, ContextType, Partial<query_rootpublicNotificationsArgs>>;
  queueItem?: Resolver<Maybe<ResolversTypes['queueItem']>, ParentType, ContextType, RequireFields<query_rootqueueItemArgs, 'id'>>;
  queueItems?: Resolver<Array<ResolversTypes['queueItem']>, ParentType, ContextType, Partial<query_rootqueueItemsArgs>>;
  queueItemsAggregate?: Resolver<ResolversTypes['queueItemAggregate'], ParentType, ContextType, Partial<query_rootqueueItemsAggregateArgs>>;
  relOrganizationUserDomainUser?: Resolver<Maybe<ResolversTypes['relOrganizationUserDomainUser']>, ParentType, ContextType, RequireFields<query_rootrelOrganizationUserDomainUserArgs, 'id'>>;
  relOrganizationUserDomainUsers?: Resolver<Array<ResolversTypes['relOrganizationUserDomainUser']>, ParentType, ContextType, Partial<query_rootrelOrganizationUserDomainUsersArgs>>;
  relOrganizationUserDomainUsersAggregate?: Resolver<ResolversTypes['relOrganizationUserDomainUserAggregate'], ParentType, ContextType, Partial<query_rootrelOrganizationUserDomainUsersAggregateArgs>>;
  smsConnector?: Resolver<Maybe<ResolversTypes['smsConnector']>, ParentType, ContextType, RequireFields<query_rootsmsConnectorArgs, 'id'>>;
  smsConnectors?: Resolver<Array<ResolversTypes['smsConnector']>, ParentType, ContextType, Partial<query_rootsmsConnectorsArgs>>;
  smsGate?: Resolver<Maybe<ResolversTypes['smsGate']>, ParentType, ContextType, RequireFields<query_rootsmsGateArgs, 'id'>>;
  smsGates?: Resolver<Array<ResolversTypes['smsGate']>, ParentType, ContextType, Partial<query_rootsmsGatesArgs>>;
  smsLinkMobilitySmsContent?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsContent']>, ParentType, ContextType, RequireFields<query_rootsmsLinkMobilitySmsContentArgs, 'uuid'>>;
  smsLinkMobilitySmsContents?: Resolver<Array<ResolversTypes['smsLinkMobilitySmsContent']>, ParentType, ContextType, Partial<query_rootsmsLinkMobilitySmsContentsArgs>>;
  smsLinkMobilitySmsMessage?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsMessage']>, ParentType, ContextType, RequireFields<query_rootsmsLinkMobilitySmsMessageArgs, 'uuid'>>;
  smsLinkMobilitySmsMessages?: Resolver<Array<ResolversTypes['smsLinkMobilitySmsMessage']>, ParentType, ContextType, Partial<query_rootsmsLinkMobilitySmsMessagesArgs>>;
  smsLinkMobilitySmsRoute?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsRoute']>, ParentType, ContextType, RequireFields<query_rootsmsLinkMobilitySmsRouteArgs, 'uuid'>>;
  smsLinkMobilitySmsRoutes?: Resolver<Array<ResolversTypes['smsLinkMobilitySmsRoute']>, ParentType, ContextType, Partial<query_rootsmsLinkMobilitySmsRoutesArgs>>;
  smsProvider?: Resolver<Maybe<ResolversTypes['smsProvider']>, ParentType, ContextType, RequireFields<query_rootsmsProviderArgs, 'id'>>;
  smsProviders?: Resolver<Array<ResolversTypes['smsProvider']>, ParentType, ContextType, Partial<query_rootsmsProvidersArgs>>;
  smsSm?: Resolver<Maybe<ResolversTypes['smsSm']>, ParentType, ContextType, RequireFields<query_rootsmsSmArgs, 'id'>>;
  smsSms?: Resolver<Array<ResolversTypes['smsSm']>, ParentType, ContextType, Partial<query_rootsmsSmsArgs>>;
  smsSmsExternalIncomingLinkMobilities?: Resolver<Array<ResolversTypes['smsSmsExternalIncomingLinkMobility']>, ParentType, ContextType, Partial<query_rootsmsSmsExternalIncomingLinkMobilitiesArgs>>;
  smsSmsExternalIncomingLinkMobility?: Resolver<Maybe<ResolversTypes['smsSmsExternalIncomingLinkMobility']>, ParentType, ContextType, RequireFields<query_rootsmsSmsExternalIncomingLinkMobilityArgs, 'uuid'>>;
  task?: Resolver<Maybe<ResolversTypes['taskquery_root']>, ParentType, ContextType>;
  telephony?: Resolver<Maybe<ResolversTypes['telephonyquery_root']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['user']>, ParentType, ContextType, RequireFields<query_rootuserArgs, 'id'>>;
  userDetail?: Resolver<Maybe<ResolversTypes['userDetail']>, ParentType, ContextType, RequireFields<query_rootuserDetailArgs, 'id'>>;
  userDetails?: Resolver<Array<ResolversTypes['userDetail']>, ParentType, ContextType, Partial<query_rootuserDetailsArgs>>;
  userDetailsAggregate?: Resolver<ResolversTypes['userDetailAggregate'], ParentType, ContextType, Partial<query_rootuserDetailsAggregateArgs>>;
  userDetailsType?: Resolver<Maybe<ResolversTypes['userDetailsType']>, ParentType, ContextType, RequireFields<query_rootuserDetailsTypeArgs, 'value'>>;
  userDetailsTypes?: Resolver<Array<ResolversTypes['userDetailsType']>, ParentType, ContextType, Partial<query_rootuserDetailsTypesArgs>>;
  userDetailsTypesAggregate?: Resolver<ResolversTypes['userDetailsTypeAggregate'], ParentType, ContextType, Partial<query_rootuserDetailsTypesAggregateArgs>>;
  userDevice?: Resolver<Maybe<ResolversTypes['userDevice']>, ParentType, ContextType, RequireFields<query_rootuserDeviceArgs, 'id'>>;
  userDevices?: Resolver<Array<ResolversTypes['userDevice']>, ParentType, ContextType, Partial<query_rootuserDevicesArgs>>;
  userDevicesAggregate?: Resolver<ResolversTypes['userDeviceAggregate'], ParentType, ContextType, Partial<query_rootuserDevicesAggregateArgs>>;
  userPhoneNumber?: Resolver<Maybe<ResolversTypes['userPhoneNumber']>, ParentType, ContextType, RequireFields<query_rootuserPhoneNumberArgs, 'id'>>;
  userPhoneNumbers?: Resolver<Array<ResolversTypes['userPhoneNumber']>, ParentType, ContextType, Partial<query_rootuserPhoneNumbersArgs>>;
  userPhoneNumbersAggregate?: Resolver<ResolversTypes['userPhoneNumberAggregate'], ParentType, ContextType, Partial<query_rootuserPhoneNumbersAggregateArgs>>;
  userRole?: Resolver<Maybe<ResolversTypes['userRole']>, ParentType, ContextType, RequireFields<query_rootuserRoleArgs, 'value'>>;
  userRoles?: Resolver<Array<ResolversTypes['userRole']>, ParentType, ContextType, Partial<query_rootuserRolesArgs>>;
  userRolesAggregate?: Resolver<ResolversTypes['userRoleAggregate'], ParentType, ContextType, Partial<query_rootuserRolesAggregateArgs>>;
  users?: Resolver<Array<ResolversTypes['user']>, ParentType, ContextType, Partial<query_rootusersArgs>>;
  usersAggregate?: Resolver<ResolversTypes['userAggregate'], ParentType, ContextType, Partial<query_rootusersAggregateArgs>>;
  validationValidation?: Resolver<Maybe<ResolversTypes['validationValidation']>, ParentType, ContextType, RequireFields<query_rootvalidationValidationArgs, 'id'>>;
  validationValidations?: Resolver<Array<ResolversTypes['validationValidation']>, ParentType, ContextType, Partial<query_rootvalidationValidationsArgs>>;
  voiceTypes?: Resolver<Array<ResolversTypes['VoiceTypes']>, ParentType, ContextType, Partial<query_rootvoiceTypesArgs>>;
  voiceTypesAggregate?: Resolver<ResolversTypes['VoiceTypesAggregate'], ParentType, ContextType, Partial<query_rootvoiceTypesAggregateArgs>>;
  voiceTypesByPk?: Resolver<Maybe<ResolversTypes['VoiceTypes']>, ParentType, ContextType, RequireFields<query_rootvoiceTypesByPkArgs, 'value'>>;
};

export type queueItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['queueItem'] = ResolversParentTypes['queueItem']> = {
  activityStatus?: Resolver<Maybe<ResolversTypes['ActivityStatus']>, ParentType, ContextType>;
  activity_type?: Resolver<Maybe<ResolversTypes['ActivityType']>, ParentType, ContextType>;
  additionalData?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<queueItemadditionalDataArgs>>;
  alarms?: Resolver<Array<ResolversTypes['BusinessQueueItemAlarms']>, ParentType, ContextType, Partial<queueItemalarmsArgs>>;
  alarmsAggregate?: Resolver<ResolversTypes['BusinessQueueItemAlarmsAggregate'], ParentType, ContextType, Partial<queueItemalarmsAggregateArgs>>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  deletionAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  domainActivity?: Resolver<Maybe<ResolversTypes['domainActivity']>, ParentType, ContextType>;
  domainActivityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  domainUsers?: Resolver<Array<ResolversTypes['BusinessQueueItemDomainUsersView']>, ParentType, ContextType, Partial<queueItemdomainUsersArgs>>;
  domainUsersAggregate?: Resolver<ResolversTypes['BusinessQueueItemDomainUsersViewAggregate'], ParentType, ContextType, Partial<queueItemdomainUsersAggregateArgs>>;
  dueDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  flexibilityType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexibility_type?: Resolver<Maybe<ResolversTypes['QueueItemFlexibilityType']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['message']>, ParentType, ContextType, Partial<queueItemmessagesArgs>>;
  messagesAggregate?: Resolver<ResolversTypes['messageAggregate'], ParentType, ContextType, Partial<queueItemmessagesAggregateArgs>>;
  organization?: Resolver<Maybe<ResolversTypes['organization']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationUsers?: Resolver<Array<ResolversTypes['BusinessQueueItemOrganizationUsersView']>, ParentType, ContextType, Partial<queueItemorganizationUsersArgs>>;
  organizationUsersAggregate?: Resolver<ResolversTypes['BusinessQueueItemOrganizationUsersViewAggregate'], ParentType, ContextType, Partial<queueItemorganizationUsersAggregateArgs>>;
  ownerOrganizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  owner_organization_user?: Resolver<Maybe<ResolversTypes['organizationUser']>, ParentType, ContextType>;
  participants?: Resolver<Array<ResolversTypes['BusinessQueueItemParticipantsView']>, ParentType, ContextType, Partial<queueItemparticipantsArgs>>;
  participantsAggregate?: Resolver<ResolversTypes['BusinessQueueItemParticipantsViewAggregate'], ParentType, ContextType, Partial<queueItemparticipantsAggregateArgs>>;
  private?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  queueParticipants?: Resolver<Array<ResolversTypes['activityParticipant']>, ParentType, ContextType, Partial<queueItemqueueParticipantsArgs>>;
  queueParticipantsAggregate?: Resolver<ResolversTypes['activityParticipantAggregate'], ParentType, ContextType, Partial<queueItemqueueParticipantsAggregateArgs>>;
  relatedQueueItem?: Resolver<Array<ResolversTypes['queueItem']>, ParentType, ContextType, Partial<queueItemrelatedQueueItemArgs>>;
  relatedQueueItemAggregate?: Resolver<ResolversTypes['queueItemAggregate'], ParentType, ContextType, Partial<queueItemrelatedQueueItemAggregateArgs>>;
  relatedQueueItemId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  searchText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ActivityStatusEnum']>, ParentType, ContextType>;
  subTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sub_type?: Resolver<Maybe<ResolversTypes['BusinessQueueItemSubType']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['ActivityTypeEnum']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type queueItemAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['queueItemAggregate'] = ResolversParentTypes['queueItemAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['queueItemAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['queueItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type queueItemAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['queueItemAggregateFields'] = ResolversParentTypes['queueItemAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<queueItemAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['queueItemMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['queueItemMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type queueItemMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['queueItemMaxFields'] = ResolversParentTypes['queueItemMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  deletionAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  domainActivityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  dueDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  flexibilityType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  ownerOrganizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  relatedQueueItemId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  searchText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  subTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type queueItemMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['queueItemMinFields'] = ResolversParentTypes['queueItemMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdByUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  deletionAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  domainActivityId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  dueDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  flexibilityType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  ownerOrganizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  relatedQueueItemId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  searchText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  subTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type queueItemMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['queueItemMutationResponse'] = ResolversParentTypes['queueItemMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['queueItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type relOrganizationUserDomainUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['relOrganizationUserDomainUser'] = ResolversParentTypes['relOrganizationUserDomainUser']> = {
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  domainUser?: Resolver<ResolversTypes['domainUser'], ParentType, ContextType>;
  domainUserId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  organizationUser?: Resolver<ResolversTypes['organizationUser'], ParentType, ContextType>;
  organizationUserId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  relationType?: Resolver<Maybe<ResolversTypes['RelationTypeEnum']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['RelationType']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type relOrganizationUserDomainUserAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['relOrganizationUserDomainUserAggregate'] = ResolversParentTypes['relOrganizationUserDomainUserAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['relOrganizationUserDomainUserAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['relOrganizationUserDomainUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type relOrganizationUserDomainUserAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['relOrganizationUserDomainUserAggregateFields'] = ResolversParentTypes['relOrganizationUserDomainUserAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<relOrganizationUserDomainUserAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['relOrganizationUserDomainUserMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['relOrganizationUserDomainUserMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type relOrganizationUserDomainUserMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['relOrganizationUserDomainUserMaxFields'] = ResolversParentTypes['relOrganizationUserDomainUserMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  domainUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type relOrganizationUserDomainUserMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['relOrganizationUserDomainUserMinFields'] = ResolversParentTypes['relOrganizationUserDomainUserMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  domainUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type relOrganizationUserDomainUserMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['relOrganizationUserDomainUserMutationResponse'] = ResolversParentTypes['relOrganizationUserDomainUserMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['relOrganizationUserDomainUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type removeEmailDomainUserOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['removeEmailDomainUserOutput'] = ResolversParentTypes['removeEmailDomainUserOutput']> = {
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type removeOrganizationOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['removeOrganizationOutput'] = ResolversParentTypes['removeOrganizationOutput']> = {
  json?: Resolver<Maybe<ResolversTypes['json']>, ParentType, ContextType>;
  result?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type renewEmailProviderSubscriptionOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['renewEmailProviderSubscriptionOutput'] = ResolversParentTypes['renewEmailProviderSubscriptionOutput']> = {
  expiration?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  subscriptionId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type setUpOrganizationOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['setUpOrganizationOutput'] = ResolversParentTypes['setUpOrganizationOutput']> = {
  businessAddress?: Resolver<Maybe<ResolversTypes['BusinessAddress']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsConnectorResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsConnector'] = ResolversParentTypes['smsConnector']> = {
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsConnectorAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsConnectorAggregate'] = ResolversParentTypes['smsConnectorAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['smsConnectorAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['smsConnector']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsConnectorAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsConnectorAggregateFields'] = ResolversParentTypes['smsConnectorAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['smsConnectorAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<smsConnectorAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['smsConnectorMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['smsConnectorMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['smsConnectorStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['smsConnectorStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['smsConnectorStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['smsConnectorSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['smsConnectorVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['smsConnectorVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['smsConnectorVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsConnectorAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsConnectorAvgFields'] = ResolversParentTypes['smsConnectorAvgFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsConnectorMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsConnectorMaxFields'] = ResolversParentTypes['smsConnectorMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsConnectorMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsConnectorMinFields'] = ResolversParentTypes['smsConnectorMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsConnectorMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsConnectorMutationResponse'] = ResolversParentTypes['smsConnectorMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['smsConnector']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsConnectorStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsConnectorStddevFields'] = ResolversParentTypes['smsConnectorStddevFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsConnectorStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsConnectorStddevPopFields'] = ResolversParentTypes['smsConnectorStddevPopFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsConnectorStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsConnectorStddevSampFields'] = ResolversParentTypes['smsConnectorStddevSampFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsConnectorSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsConnectorSumFields'] = ResolversParentTypes['smsConnectorSumFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsConnectorVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsConnectorVarPopFields'] = ResolversParentTypes['smsConnectorVarPopFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsConnectorVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsConnectorVarSampFields'] = ResolversParentTypes['smsConnectorVarSampFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsConnectorVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsConnectorVarianceFields'] = ResolversParentTypes['smsConnectorVarianceFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsGateResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsGate'] = ResolversParentTypes['smsGate']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsGateAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsGateAggregate'] = ResolversParentTypes['smsGateAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['smsGateAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['smsGate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsGateAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsGateAggregateFields'] = ResolversParentTypes['smsGateAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['smsGateAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<smsGateAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['smsGateMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['smsGateMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['smsGateStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['smsGateStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['smsGateStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['smsGateSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['smsGateVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['smsGateVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['smsGateVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsGateAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsGateAvgFields'] = ResolversParentTypes['smsGateAvgFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsGateMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsGateMaxFields'] = ResolversParentTypes['smsGateMaxFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsGateMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsGateMinFields'] = ResolversParentTypes['smsGateMinFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsGateMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsGateMutationResponse'] = ResolversParentTypes['smsGateMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['smsGate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsGateStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsGateStddevFields'] = ResolversParentTypes['smsGateStddevFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsGateStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsGateStddevPopFields'] = ResolversParentTypes['smsGateStddevPopFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsGateStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsGateStddevSampFields'] = ResolversParentTypes['smsGateStddevSampFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsGateSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsGateSumFields'] = ResolversParentTypes['smsGateSumFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsGateVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsGateVarPopFields'] = ResolversParentTypes['smsGateVarPopFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsGateVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsGateVarSampFields'] = ResolversParentTypes['smsGateVarSampFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsGateVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsGateVarianceFields'] = ResolversParentTypes['smsGateVarianceFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsLinkMobilitySmsContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsLinkMobilitySmsContent'] = ResolversParentTypes['smsLinkMobilitySmsContent']> = {
  encoding?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userData?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsLinkMobilitySmsContentAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsLinkMobilitySmsContentAggregate'] = ResolversParentTypes['smsLinkMobilitySmsContentAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsContentAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['smsLinkMobilitySmsContent']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsLinkMobilitySmsContentAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsLinkMobilitySmsContentAggregateFields'] = ResolversParentTypes['smsLinkMobilitySmsContentAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<smsLinkMobilitySmsContentAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsContentMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsContentMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsLinkMobilitySmsContentMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsLinkMobilitySmsContentMaxFields'] = ResolversParentTypes['smsLinkMobilitySmsContentMaxFields']> = {
  encoding?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userData?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsLinkMobilitySmsContentMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsLinkMobilitySmsContentMinFields'] = ResolversParentTypes['smsLinkMobilitySmsContentMinFields']> = {
  encoding?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userData?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsLinkMobilitySmsContentMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsLinkMobilitySmsContentMutationResponse'] = ResolversParentTypes['smsLinkMobilitySmsContentMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['smsLinkMobilitySmsContent']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsLinkMobilitySmsMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsLinkMobilitySmsMessage'] = ResolversParentTypes['smsLinkMobilitySmsMessage']> = {
  content?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsContent']>, ParentType, ContextType>;
  contentId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  customParameters?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<smsLinkMobilitySmsMessagecustomParametersArgs>>;
  destination?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gateCustomParameters?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<smsLinkMobilitySmsMessagegateCustomParametersArgs>>;
  messageId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  operator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  operatorMessageId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  operatorTimestamp?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  route?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsRoute']>, ParentType, ContextType>;
  routeId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  timestamp?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsLinkMobilitySmsMessageAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsLinkMobilitySmsMessageAggregate'] = ResolversParentTypes['smsLinkMobilitySmsMessageAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsMessageAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['smsLinkMobilitySmsMessage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsLinkMobilitySmsMessageAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsLinkMobilitySmsMessageAggregateFields'] = ResolversParentTypes['smsLinkMobilitySmsMessageAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsMessageAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<smsLinkMobilitySmsMessageAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsMessageMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsMessageMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsMessageStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsMessageStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsMessageStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsMessageSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsMessageVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsMessageVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsMessageVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsLinkMobilitySmsMessageAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsLinkMobilitySmsMessageAvgFields'] = ResolversParentTypes['smsLinkMobilitySmsMessageAvgFields']> = {
  subNumber?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsLinkMobilitySmsMessageMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsLinkMobilitySmsMessageMaxFields'] = ResolversParentTypes['smsLinkMobilitySmsMessageMaxFields']> = {
  contentId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  destination?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messageId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  operator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  operatorMessageId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  operatorTimestamp?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  routeId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  timestamp?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsLinkMobilitySmsMessageMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsLinkMobilitySmsMessageMinFields'] = ResolversParentTypes['smsLinkMobilitySmsMessageMinFields']> = {
  contentId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  destination?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messageId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  operator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  operatorMessageId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  operatorTimestamp?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  routeId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  timestamp?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsLinkMobilitySmsMessageMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsLinkMobilitySmsMessageMutationResponse'] = ResolversParentTypes['smsLinkMobilitySmsMessageMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['smsLinkMobilitySmsMessage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsLinkMobilitySmsMessageStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsLinkMobilitySmsMessageStddevFields'] = ResolversParentTypes['smsLinkMobilitySmsMessageStddevFields']> = {
  subNumber?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsLinkMobilitySmsMessageStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsLinkMobilitySmsMessageStddevPopFields'] = ResolversParentTypes['smsLinkMobilitySmsMessageStddevPopFields']> = {
  subNumber?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsLinkMobilitySmsMessageStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsLinkMobilitySmsMessageStddevSampFields'] = ResolversParentTypes['smsLinkMobilitySmsMessageStddevSampFields']> = {
  subNumber?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsLinkMobilitySmsMessageSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsLinkMobilitySmsMessageSumFields'] = ResolversParentTypes['smsLinkMobilitySmsMessageSumFields']> = {
  subNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsLinkMobilitySmsMessageVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsLinkMobilitySmsMessageVarPopFields'] = ResolversParentTypes['smsLinkMobilitySmsMessageVarPopFields']> = {
  subNumber?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsLinkMobilitySmsMessageVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsLinkMobilitySmsMessageVarSampFields'] = ResolversParentTypes['smsLinkMobilitySmsMessageVarSampFields']> = {
  subNumber?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsLinkMobilitySmsMessageVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsLinkMobilitySmsMessageVarianceFields'] = ResolversParentTypes['smsLinkMobilitySmsMessageVarianceFields']> = {
  subNumber?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsLinkMobilitySmsRouteResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsLinkMobilitySmsRoute'] = ResolversParentTypes['smsLinkMobilitySmsRoute']> = {
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  customParameters?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<smsLinkMobilitySmsRoutecustomParametersArgs>>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  end?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  gateIds?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<smsLinkMobilitySmsRoutegateIdsArgs>>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyword?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keywordType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  platformPartnerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  platformServiceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  platformServiceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shared?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsLinkMobilitySmsRouteAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsLinkMobilitySmsRouteAggregate'] = ResolversParentTypes['smsLinkMobilitySmsRouteAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsRouteAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['smsLinkMobilitySmsRoute']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsLinkMobilitySmsRouteAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsLinkMobilitySmsRouteAggregateFields'] = ResolversParentTypes['smsLinkMobilitySmsRouteAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<smsLinkMobilitySmsRouteAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsRouteMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['smsLinkMobilitySmsRouteMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsLinkMobilitySmsRouteMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsLinkMobilitySmsRouteMaxFields'] = ResolversParentTypes['smsLinkMobilitySmsRouteMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  end?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyword?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keywordType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  platformPartnerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  platformServiceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  platformServiceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsLinkMobilitySmsRouteMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsLinkMobilitySmsRouteMinFields'] = ResolversParentTypes['smsLinkMobilitySmsRouteMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  end?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyword?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keywordType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  platformPartnerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  platformServiceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  platformServiceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsLinkMobilitySmsRouteMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsLinkMobilitySmsRouteMutationResponse'] = ResolversParentTypes['smsLinkMobilitySmsRouteMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['smsLinkMobilitySmsRoute']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsProviderResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsProvider'] = ResolversParentTypes['smsProvider']> = {
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  endpoint?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsProviderAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsProviderAggregate'] = ResolversParentTypes['smsProviderAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['smsProviderAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['smsProvider']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsProviderAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsProviderAggregateFields'] = ResolversParentTypes['smsProviderAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['smsProviderAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<smsProviderAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['smsProviderMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['smsProviderMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['smsProviderStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['smsProviderStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['smsProviderStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['smsProviderSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['smsProviderVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['smsProviderVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['smsProviderVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsProviderAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsProviderAvgFields'] = ResolversParentTypes['smsProviderAvgFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsProviderMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsProviderMaxFields'] = ResolversParentTypes['smsProviderMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  endpoint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsProviderMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsProviderMinFields'] = ResolversParentTypes['smsProviderMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  endpoint?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsProviderMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsProviderMutationResponse'] = ResolversParentTypes['smsProviderMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['smsProvider']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsProviderStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsProviderStddevFields'] = ResolversParentTypes['smsProviderStddevFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsProviderStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsProviderStddevPopFields'] = ResolversParentTypes['smsProviderStddevPopFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsProviderStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsProviderStddevSampFields'] = ResolversParentTypes['smsProviderStddevSampFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsProviderSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsProviderSumFields'] = ResolversParentTypes['smsProviderSumFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsProviderVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsProviderVarPopFields'] = ResolversParentTypes['smsProviderVarPopFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsProviderVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsProviderVarSampFields'] = ResolversParentTypes['smsProviderVarSampFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsProviderVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsProviderVarianceFields'] = ResolversParentTypes['smsProviderVarianceFields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsSmResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsSm'] = ResolversParentTypes['smsSm']> = {
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  deliveryReportGates?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  destination?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  platformPartnerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  useDeliveryReport?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  userData?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsSmAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsSmAggregate'] = ResolversParentTypes['smsSmAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['smsSmAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['smsSm']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsSmAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsSmAggregateFields'] = ResolversParentTypes['smsSmAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['smsSmAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<smsSmAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['smsSmMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['smsSmMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['smsSmStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['smsSmStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['smsSmStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['smsSmSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['smsSmVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['smsSmVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['smsSmVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsSmAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsSmAvgFields'] = ResolversParentTypes['smsSmAvgFields']> = {
  deliveryReportGates?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsSmMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsSmMaxFields'] = ResolversParentTypes['smsSmMaxFields']> = {
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  deliveryReportGates?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  destination?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  platformPartnerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userData?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsSmMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsSmMinFields'] = ResolversParentTypes['smsSmMinFields']> = {
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  deliveryReportGates?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  destination?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  platformId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  platformPartnerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userData?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsSmMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsSmMutationResponse'] = ResolversParentTypes['smsSmMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['smsSm']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsSmStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsSmStddevFields'] = ResolversParentTypes['smsSmStddevFields']> = {
  deliveryReportGates?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsSmStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsSmStddevPopFields'] = ResolversParentTypes['smsSmStddevPopFields']> = {
  deliveryReportGates?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsSmStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsSmStddevSampFields'] = ResolversParentTypes['smsSmStddevSampFields']> = {
  deliveryReportGates?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsSmSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsSmSumFields'] = ResolversParentTypes['smsSmSumFields']> = {
  deliveryReportGates?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsSmVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsSmVarPopFields'] = ResolversParentTypes['smsSmVarPopFields']> = {
  deliveryReportGates?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsSmVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsSmVarSampFields'] = ResolversParentTypes['smsSmVarSampFields']> = {
  deliveryReportGates?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsSmVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsSmVarianceFields'] = ResolversParentTypes['smsSmVarianceFields']> = {
  deliveryReportGates?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsSmsExternalIncomingLinkMobilityResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsSmsExternalIncomingLinkMobility'] = ResolversParentTypes['smsSmsExternalIncomingLinkMobility']> = {
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['smsLinkMobilitySmsMessage'], ParentType, ContextType>;
  messageId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsSmsExternalIncomingLinkMobilityAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsSmsExternalIncomingLinkMobilityAggregate'] = ResolversParentTypes['smsSmsExternalIncomingLinkMobilityAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['smsSmsExternalIncomingLinkMobilityAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['smsSmsExternalIncomingLinkMobility']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsSmsExternalIncomingLinkMobilityAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsSmsExternalIncomingLinkMobilityAggregateFields'] = ResolversParentTypes['smsSmsExternalIncomingLinkMobilityAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<smsSmsExternalIncomingLinkMobilityAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['smsSmsExternalIncomingLinkMobilityMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['smsSmsExternalIncomingLinkMobilityMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsSmsExternalIncomingLinkMobilityMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsSmsExternalIncomingLinkMobilityMaxFields'] = ResolversParentTypes['smsSmsExternalIncomingLinkMobilityMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  messageId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsSmsExternalIncomingLinkMobilityMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsSmsExternalIncomingLinkMobilityMinFields'] = ResolversParentTypes['smsSmsExternalIncomingLinkMobilityMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  messageId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type smsSmsExternalIncomingLinkMobilityMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['smsSmsExternalIncomingLinkMobilityMutationResponse'] = ResolversParentTypes['smsSmsExternalIncomingLinkMobilityMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['smsSmsExternalIncomingLinkMobility']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type subscription_rootResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_root'] = ResolversParentTypes['subscription_root']> = {
  ActivityDirection?: SubscriptionResolver<Array<ResolversTypes['ActivityDirection']>, "ActivityDirection", ParentType, ContextType, Partial<subscription_rootActivityDirectionArgs>>;
  ActivityDirectionAggregate?: SubscriptionResolver<ResolversTypes['ActivityDirectionAggregate'], "ActivityDirectionAggregate", ParentType, ContextType, Partial<subscription_rootActivityDirectionAggregateArgs>>;
  ActivityDirectionByPk?: SubscriptionResolver<Maybe<ResolversTypes['ActivityDirection']>, "ActivityDirectionByPk", ParentType, ContextType, RequireFields<subscription_rootActivityDirectionByPkArgs, 'value'>>;
  ActivityDirectionStream?: SubscriptionResolver<Array<ResolversTypes['ActivityDirection']>, "ActivityDirectionStream", ParentType, ContextType, RequireFields<subscription_rootActivityDirectionStreamArgs, 'batchSize' | 'cursor'>>;
  ActivityProvider?: SubscriptionResolver<Array<ResolversTypes['ActivityProvider']>, "ActivityProvider", ParentType, ContextType, Partial<subscription_rootActivityProviderArgs>>;
  ActivityProviderAggregate?: SubscriptionResolver<ResolversTypes['ActivityProviderAggregate'], "ActivityProviderAggregate", ParentType, ContextType, Partial<subscription_rootActivityProviderAggregateArgs>>;
  ActivityProviderByPk?: SubscriptionResolver<Maybe<ResolversTypes['ActivityProvider']>, "ActivityProviderByPk", ParentType, ContextType, RequireFields<subscription_rootActivityProviderByPkArgs, 'value'>>;
  ActivityProviderStream?: SubscriptionResolver<Array<ResolversTypes['ActivityProvider']>, "ActivityProviderStream", ParentType, ContextType, RequireFields<subscription_rootActivityProviderStreamArgs, 'batchSize' | 'cursor'>>;
  QueueItemFlexibilityType?: SubscriptionResolver<Array<ResolversTypes['QueueItemFlexibilityType']>, "QueueItemFlexibilityType", ParentType, ContextType, Partial<subscription_rootQueueItemFlexibilityTypeArgs>>;
  QueueItemFlexibilityTypeAggregate?: SubscriptionResolver<ResolversTypes['QueueItemFlexibilityTypeAggregate'], "QueueItemFlexibilityTypeAggregate", ParentType, ContextType, Partial<subscription_rootQueueItemFlexibilityTypeAggregateArgs>>;
  QueueItemFlexibilityTypeByPk?: SubscriptionResolver<Maybe<ResolversTypes['QueueItemFlexibilityType']>, "QueueItemFlexibilityTypeByPk", ParentType, ContextType, RequireFields<subscription_rootQueueItemFlexibilityTypeByPkArgs, 'value'>>;
  QueueItemFlexibilityTypeStream?: SubscriptionResolver<Array<ResolversTypes['QueueItemFlexibilityType']>, "QueueItemFlexibilityTypeStream", ParentType, ContextType, RequireFields<subscription_rootQueueItemFlexibilityTypeStreamArgs, 'batchSize' | 'cursor'>>;
  QueueItemParticipantResponsibilityType?: SubscriptionResolver<Array<ResolversTypes['QueueItemParticipantResponsibilityType']>, "QueueItemParticipantResponsibilityType", ParentType, ContextType, Partial<subscription_rootQueueItemParticipantResponsibilityTypeArgs>>;
  QueueItemParticipantResponsibilityTypeAggregate?: SubscriptionResolver<ResolversTypes['QueueItemParticipantResponsibilityTypeAggregate'], "QueueItemParticipantResponsibilityTypeAggregate", ParentType, ContextType, Partial<subscription_rootQueueItemParticipantResponsibilityTypeAggregateArgs>>;
  QueueItemParticipantResponsibilityTypeByPk?: SubscriptionResolver<Maybe<ResolversTypes['QueueItemParticipantResponsibilityType']>, "QueueItemParticipantResponsibilityTypeByPk", ParentType, ContextType, RequireFields<subscription_rootQueueItemParticipantResponsibilityTypeByPkArgs, 'value'>>;
  QueueItemParticipantResponsibilityTypeStream?: SubscriptionResolver<Array<ResolversTypes['QueueItemParticipantResponsibilityType']>, "QueueItemParticipantResponsibilityTypeStream", ParentType, ContextType, RequireFields<subscription_rootQueueItemParticipantResponsibilityTypeStreamArgs, 'batchSize' | 'cursor'>>;
  RelationType?: SubscriptionResolver<Array<ResolversTypes['RelationType']>, "RelationType", ParentType, ContextType, Partial<subscription_rootRelationTypeArgs>>;
  RelationTypeAggregate?: SubscriptionResolver<ResolversTypes['RelationTypeAggregate'], "RelationTypeAggregate", ParentType, ContextType, Partial<subscription_rootRelationTypeAggregateArgs>>;
  RelationTypeByPk?: SubscriptionResolver<Maybe<ResolversTypes['RelationType']>, "RelationTypeByPk", ParentType, ContextType, RequireFields<subscription_rootRelationTypeByPkArgs, 'value'>>;
  RelationTypeStream?: SubscriptionResolver<Array<ResolversTypes['RelationType']>, "RelationTypeStream", ParentType, ContextType, RequireFields<subscription_rootRelationTypeStreamArgs, 'batchSize' | 'cursor'>>;
  activityParticipant?: SubscriptionResolver<Maybe<ResolversTypes['activityParticipant']>, "activityParticipant", ParentType, ContextType, RequireFields<subscription_rootactivityParticipantArgs, 'id'>>;
  activityParticipants?: SubscriptionResolver<Array<ResolversTypes['activityParticipant']>, "activityParticipants", ParentType, ContextType, Partial<subscription_rootactivityParticipantsArgs>>;
  activityParticipantsAggregate?: SubscriptionResolver<ResolversTypes['activityParticipantAggregate'], "activityParticipantsAggregate", ParentType, ContextType, Partial<subscription_rootactivityParticipantsAggregateArgs>>;
  activityParticipantsStream?: SubscriptionResolver<Array<ResolversTypes['activityParticipant']>, "activityParticipantsStream", ParentType, ContextType, RequireFields<subscription_rootactivityParticipantsStreamArgs, 'batchSize' | 'cursor'>>;
  activityStatus?: SubscriptionResolver<Maybe<ResolversTypes['ActivityStatus']>, "activityStatus", ParentType, ContextType, RequireFields<subscription_rootactivityStatusArgs, 'value'>>;
  activityStatuses?: SubscriptionResolver<Array<ResolversTypes['ActivityStatus']>, "activityStatuses", ParentType, ContextType, Partial<subscription_rootactivityStatusesArgs>>;
  activityStatusesAggregate?: SubscriptionResolver<ResolversTypes['ActivityStatusAggregate'], "activityStatusesAggregate", ParentType, ContextType, Partial<subscription_rootactivityStatusesAggregateArgs>>;
  activityStatusesStream?: SubscriptionResolver<Array<ResolversTypes['ActivityStatus']>, "activityStatusesStream", ParentType, ContextType, RequireFields<subscription_rootactivityStatusesStreamArgs, 'batchSize' | 'cursor'>>;
  activityType?: SubscriptionResolver<Maybe<ResolversTypes['ActivityType']>, "activityType", ParentType, ContextType, RequireFields<subscription_rootactivityTypeArgs, 'value'>>;
  activityTypes?: SubscriptionResolver<Array<ResolversTypes['ActivityType']>, "activityTypes", ParentType, ContextType, Partial<subscription_rootactivityTypesArgs>>;
  activityTypesAggregate?: SubscriptionResolver<ResolversTypes['ActivityTypeAggregate'], "activityTypesAggregate", ParentType, ContextType, Partial<subscription_rootactivityTypesAggregateArgs>>;
  activityTypesStream?: SubscriptionResolver<Array<ResolversTypes['ActivityType']>, "activityTypesStream", ParentType, ContextType, RequireFields<subscription_rootactivityTypesStreamArgs, 'batchSize' | 'cursor'>>;
  address?: SubscriptionResolver<Maybe<ResolversTypes['address']>, "address", ParentType, ContextType, RequireFields<subscription_rootaddressArgs, 'id'>>;
  addresses?: SubscriptionResolver<Array<ResolversTypes['address']>, "addresses", ParentType, ContextType, Partial<subscription_rootaddressesArgs>>;
  addressesAggregate?: SubscriptionResolver<ResolversTypes['addressAggregate'], "addressesAggregate", ParentType, ContextType, Partial<subscription_rootaddressesAggregateArgs>>;
  addressesStream?: SubscriptionResolver<Array<ResolversTypes['address']>, "addressesStream", ParentType, ContextType, RequireFields<subscription_rootaddressesStreamArgs, 'batchSize' | 'cursor'>>;
  aggregateBusinessUserContacts?: SubscriptionResolver<ResolversTypes['businessUserContactsAggregate'], "aggregateBusinessUserContacts", ParentType, ContextType, Partial<subscription_rootaggregateBusinessUserContactsArgs>>;
  aggregateBusinessUserSettings?: SubscriptionResolver<ResolversTypes['businessUserSettingsAggregate'], "aggregateBusinessUserSettings", ParentType, ContextType, Partial<subscription_rootaggregateBusinessUserSettingsArgs>>;
  aggregateMessagingActivities?: SubscriptionResolver<ResolversTypes['messagingActivityAggregate'], "aggregateMessagingActivities", ParentType, ContextType, Partial<subscription_rootaggregateMessagingActivitiesArgs>>;
  aggregateMessagingActivityTypes?: SubscriptionResolver<ResolversTypes['messagingActivityTypeAggregate'], "aggregateMessagingActivityTypes", ParentType, ContextType, Partial<subscription_rootaggregateMessagingActivityTypesArgs>>;
  aggregateMessagingActivityUsers?: SubscriptionResolver<ResolversTypes['messagingActivityUserAggregate'], "aggregateMessagingActivityUsers", ParentType, ContextType, Partial<subscription_rootaggregateMessagingActivityUsersArgs>>;
  aggregateMessagingMessageEmojis?: SubscriptionResolver<ResolversTypes['messagingMessageEmojiAggregate'], "aggregateMessagingMessageEmojis", ParentType, ContextType, Partial<subscription_rootaggregateMessagingMessageEmojisArgs>>;
  aggregateMessagingMessageReads?: SubscriptionResolver<ResolversTypes['messagingMessageReadAggregate'], "aggregateMessagingMessageReads", ParentType, ContextType, Partial<subscription_rootaggregateMessagingMessageReadsArgs>>;
  aggregateMessagingMessageTypes?: SubscriptionResolver<ResolversTypes['messagingMessageTypeAggregate'], "aggregateMessagingMessageTypes", ParentType, ContextType, Partial<subscription_rootaggregateMessagingMessageTypesArgs>>;
  aggregateMessagingMessages?: SubscriptionResolver<ResolversTypes['messagingMessageAggregate'], "aggregateMessagingMessages", ParentType, ContextType, Partial<subscription_rootaggregateMessagingMessagesArgs>>;
  aggregateOrganizationAuthorizationEnumGroups?: SubscriptionResolver<ResolversTypes['organizationAuthorizationEnumGroupAggregate'], "aggregateOrganizationAuthorizationEnumGroups", ParentType, ContextType, Partial<subscription_rootaggregateOrganizationAuthorizationEnumGroupsArgs>>;
  aggregateOrganizationAuthorizationGroups?: SubscriptionResolver<ResolversTypes['organizationAuthorizationGroupAggregate'], "aggregateOrganizationAuthorizationGroups", ParentType, ContextType, Partial<subscription_rootaggregateOrganizationAuthorizationGroupsArgs>>;
  aggregateOrganizationOrganizationRelationshipCategories?: SubscriptionResolver<ResolversTypes['organizationOrganizationRelationshipCategoryAggregate'], "aggregateOrganizationOrganizationRelationshipCategories", ParentType, ContextType, Partial<subscription_rootaggregateOrganizationOrganizationRelationshipCategoriesArgs>>;
  aggregateOrganizationOrganizationRelationships?: SubscriptionResolver<ResolversTypes['organizationOrganizationRelationshipAggregate'], "aggregateOrganizationOrganizationRelationships", ParentType, ContextType, Partial<subscription_rootaggregateOrganizationOrganizationRelationshipsArgs>>;
  aggregateOrganizationOrganizationUserAuthorizations?: SubscriptionResolver<ResolversTypes['organizationOrganizationUserAuthorizationAggregate'], "aggregateOrganizationOrganizationUserAuthorizations", ParentType, ContextType, Partial<subscription_rootaggregateOrganizationOrganizationUserAuthorizationsArgs>>;
  aggregateOrganizationOrganizationUserOrganizationsViews?: SubscriptionResolver<ResolversTypes['organizationOrganizationUserOrganizationsViewAggregate'], "aggregateOrganizationOrganizationUserOrganizationsViews", ParentType, ContextType, Partial<subscription_rootaggregateOrganizationOrganizationUserOrganizationsViewsArgs>>;
  aggregateOrganizationOrganizationUserUsersViews?: SubscriptionResolver<ResolversTypes['organizationOrganizationUserUsersViewAggregate'], "aggregateOrganizationOrganizationUserUsersViews", ParentType, ContextType, Partial<subscription_rootaggregateOrganizationOrganizationUserUsersViewsArgs>>;
  aggregateOrganizationUserAuthorizations?: SubscriptionResolver<ResolversTypes['organizationUserAuthorizationAggregate'], "aggregateOrganizationUserAuthorizations", ParentType, ContextType, Partial<subscription_rootaggregateOrganizationUserAuthorizationsArgs>>;
  aggregatePublicDevices?: SubscriptionResolver<ResolversTypes['publicDeviceAggregate'], "aggregatePublicDevices", ParentType, ContextType, Partial<subscription_rootaggregatePublicDevicesArgs>>;
  aggregatePublicExternalRequests?: SubscriptionResolver<ResolversTypes['publicExternalRequestAggregate'], "aggregatePublicExternalRequests", ParentType, ContextType, Partial<subscription_rootaggregatePublicExternalRequestsArgs>>;
  aggregatePublicFiles?: SubscriptionResolver<ResolversTypes['publicFileAggregate'], "aggregatePublicFiles", ParentType, ContextType, Partial<subscription_rootaggregatePublicFilesArgs>>;
  aggregatePublicNotifications?: SubscriptionResolver<ResolversTypes['publicNotificationAggregate'], "aggregatePublicNotifications", ParentType, ContextType, Partial<subscription_rootaggregatePublicNotificationsArgs>>;
  aggregateSmsConnectors?: SubscriptionResolver<ResolversTypes['smsConnectorAggregate'], "aggregateSmsConnectors", ParentType, ContextType, Partial<subscription_rootaggregateSmsConnectorsArgs>>;
  aggregateSmsGates?: SubscriptionResolver<ResolversTypes['smsGateAggregate'], "aggregateSmsGates", ParentType, ContextType, Partial<subscription_rootaggregateSmsGatesArgs>>;
  aggregateSmsLinkMobilitySmsContents?: SubscriptionResolver<ResolversTypes['smsLinkMobilitySmsContentAggregate'], "aggregateSmsLinkMobilitySmsContents", ParentType, ContextType, Partial<subscription_rootaggregateSmsLinkMobilitySmsContentsArgs>>;
  aggregateSmsLinkMobilitySmsMessages?: SubscriptionResolver<ResolversTypes['smsLinkMobilitySmsMessageAggregate'], "aggregateSmsLinkMobilitySmsMessages", ParentType, ContextType, Partial<subscription_rootaggregateSmsLinkMobilitySmsMessagesArgs>>;
  aggregateSmsLinkMobilitySmsRoutes?: SubscriptionResolver<ResolversTypes['smsLinkMobilitySmsRouteAggregate'], "aggregateSmsLinkMobilitySmsRoutes", ParentType, ContextType, Partial<subscription_rootaggregateSmsLinkMobilitySmsRoutesArgs>>;
  aggregateSmsProviders?: SubscriptionResolver<ResolversTypes['smsProviderAggregate'], "aggregateSmsProviders", ParentType, ContextType, Partial<subscription_rootaggregateSmsProvidersArgs>>;
  aggregateSmsSms?: SubscriptionResolver<ResolversTypes['smsSmAggregate'], "aggregateSmsSms", ParentType, ContextType, Partial<subscription_rootaggregateSmsSmsArgs>>;
  aggregateSmsSmsExternalIncomingLinkMobilities?: SubscriptionResolver<ResolversTypes['smsSmsExternalIncomingLinkMobilityAggregate'], "aggregateSmsSmsExternalIncomingLinkMobilities", ParentType, ContextType, Partial<subscription_rootaggregateSmsSmsExternalIncomingLinkMobilitiesArgs>>;
  aggregateValidationValidations?: SubscriptionResolver<ResolversTypes['validationValidationAggregate'], "aggregateValidationValidations", ParentType, ContextType, Partial<subscription_rootaggregateValidationValidationsArgs>>;
  blockedDomainUser?: SubscriptionResolver<Maybe<ResolversTypes['blockedDomainUser']>, "blockedDomainUser", ParentType, ContextType, RequireFields<subscription_rootblockedDomainUserArgs, 'id'>>;
  blockedDomainUsers?: SubscriptionResolver<Array<ResolversTypes['blockedDomainUser']>, "blockedDomainUsers", ParentType, ContextType, Partial<subscription_rootblockedDomainUsersArgs>>;
  blockedDomainUsersAggregate?: SubscriptionResolver<ResolversTypes['blockedDomainUserAggregate'], "blockedDomainUsersAggregate", ParentType, ContextType, Partial<subscription_rootblockedDomainUsersAggregateArgs>>;
  blockedDomainUsersStream?: SubscriptionResolver<Array<ResolversTypes['blockedDomainUser']>, "blockedDomainUsersStream", ParentType, ContextType, RequireFields<subscription_rootblockedDomainUsersStreamArgs, 'batchSize' | 'cursor'>>;
  breg?: SubscriptionResolver<Maybe<ResolversTypes['bregsubscription_root']>, "breg", ParentType, ContextType>;
  businessDomainActivityType?: SubscriptionResolver<Array<ResolversTypes['BusinessDomainActivityType']>, "businessDomainActivityType", ParentType, ContextType, Partial<subscription_rootbusinessDomainActivityTypeArgs>>;
  businessDomainActivityTypeAggregate?: SubscriptionResolver<ResolversTypes['BusinessDomainActivityTypeAggregate'], "businessDomainActivityTypeAggregate", ParentType, ContextType, Partial<subscription_rootbusinessDomainActivityTypeAggregateArgs>>;
  businessDomainActivityTypeByPk?: SubscriptionResolver<Maybe<ResolversTypes['BusinessDomainActivityType']>, "businessDomainActivityTypeByPk", ParentType, ContextType, RequireFields<subscription_rootbusinessDomainActivityTypeByPkArgs, 'value'>>;
  businessDomainActivityTypeStream?: SubscriptionResolver<Array<ResolversTypes['BusinessDomainActivityType']>, "businessDomainActivityTypeStream", ParentType, ContextType, RequireFields<subscription_rootbusinessDomainActivityTypeStreamArgs, 'batchSize' | 'cursor'>>;
  businessFeedType?: SubscriptionResolver<Array<ResolversTypes['BusinessFeedType']>, "businessFeedType", ParentType, ContextType, Partial<subscription_rootbusinessFeedTypeArgs>>;
  businessFeedTypeAggregate?: SubscriptionResolver<ResolversTypes['BusinessFeedTypeAggregate'], "businessFeedTypeAggregate", ParentType, ContextType, Partial<subscription_rootbusinessFeedTypeAggregateArgs>>;
  businessFeedTypeByPk?: SubscriptionResolver<Maybe<ResolversTypes['BusinessFeedType']>, "businessFeedTypeByPk", ParentType, ContextType, RequireFields<subscription_rootbusinessFeedTypeByPkArgs, 'type'>>;
  businessFeedTypeStream?: SubscriptionResolver<Array<ResolversTypes['BusinessFeedType']>, "businessFeedTypeStream", ParentType, ContextType, RequireFields<subscription_rootbusinessFeedTypeStreamArgs, 'batchSize' | 'cursor'>>;
  businessMessageAttachments?: SubscriptionResolver<Array<ResolversTypes['BusinessMessageAttachments']>, "businessMessageAttachments", ParentType, ContextType, Partial<subscription_rootbusinessMessageAttachmentsArgs>>;
  businessMessageAttachmentsAggregate?: SubscriptionResolver<ResolversTypes['BusinessMessageAttachmentsAggregate'], "businessMessageAttachmentsAggregate", ParentType, ContextType, Partial<subscription_rootbusinessMessageAttachmentsAggregateArgs>>;
  businessMessageAttachmentsByPk?: SubscriptionResolver<Maybe<ResolversTypes['BusinessMessageAttachments']>, "businessMessageAttachmentsByPk", ParentType, ContextType, RequireFields<subscription_rootbusinessMessageAttachmentsByPkArgs, 'id'>>;
  businessMessageAttachmentsStream?: SubscriptionResolver<Array<ResolversTypes['BusinessMessageAttachments']>, "businessMessageAttachmentsStream", ParentType, ContextType, RequireFields<subscription_rootbusinessMessageAttachmentsStreamArgs, 'batchSize' | 'cursor'>>;
  businessOrganizationUserCallbackAnswer?: SubscriptionResolver<Array<ResolversTypes['BusinessOrganizationUserCallbackAnswer']>, "businessOrganizationUserCallbackAnswer", ParentType, ContextType, Partial<subscription_rootbusinessOrganizationUserCallbackAnswerArgs>>;
  businessOrganizationUserCallbackAnswerAggregate?: SubscriptionResolver<ResolversTypes['BusinessOrganizationUserCallbackAnswerAggregate'], "businessOrganizationUserCallbackAnswerAggregate", ParentType, ContextType, Partial<subscription_rootbusinessOrganizationUserCallbackAnswerAggregateArgs>>;
  businessOrganizationUserCallbackAnswerByPk?: SubscriptionResolver<Maybe<ResolversTypes['BusinessOrganizationUserCallbackAnswer']>, "businessOrganizationUserCallbackAnswerByPk", ParentType, ContextType, RequireFields<subscription_rootbusinessOrganizationUserCallbackAnswerByPkArgs, 'id'>>;
  businessOrganizationUserCallbackAnswerStream?: SubscriptionResolver<Array<ResolversTypes['BusinessOrganizationUserCallbackAnswer']>, "businessOrganizationUserCallbackAnswerStream", ParentType, ContextType, RequireFields<subscription_rootbusinessOrganizationUserCallbackAnswerStreamArgs, 'batchSize' | 'cursor'>>;
  businessOrganizationUserEmail?: SubscriptionResolver<Array<ResolversTypes['BusinessOrganizationUserEmail']>, "businessOrganizationUserEmail", ParentType, ContextType, Partial<subscription_rootbusinessOrganizationUserEmailArgs>>;
  businessOrganizationUserEmailAggregate?: SubscriptionResolver<ResolversTypes['BusinessOrganizationUserEmailAggregate'], "businessOrganizationUserEmailAggregate", ParentType, ContextType, Partial<subscription_rootbusinessOrganizationUserEmailAggregateArgs>>;
  businessOrganizationUserEmailByPk?: SubscriptionResolver<Maybe<ResolversTypes['BusinessOrganizationUserEmail']>, "businessOrganizationUserEmailByPk", ParentType, ContextType, RequireFields<subscription_rootbusinessOrganizationUserEmailByPkArgs, 'id'>>;
  businessOrganizationUserEmailStream?: SubscriptionResolver<Array<ResolversTypes['BusinessOrganizationUserEmail']>, "businessOrganizationUserEmailStream", ParentType, ContextType, RequireFields<subscription_rootbusinessOrganizationUserEmailStreamArgs, 'batchSize' | 'cursor'>>;
  businessOrganizationUserEmailType?: SubscriptionResolver<Array<ResolversTypes['BusinessOrganizationUserEmailType']>, "businessOrganizationUserEmailType", ParentType, ContextType, Partial<subscription_rootbusinessOrganizationUserEmailTypeArgs>>;
  businessOrganizationUserEmailTypeAggregate?: SubscriptionResolver<ResolversTypes['BusinessOrganizationUserEmailTypeAggregate'], "businessOrganizationUserEmailTypeAggregate", ParentType, ContextType, Partial<subscription_rootbusinessOrganizationUserEmailTypeAggregateArgs>>;
  businessOrganizationUserEmailTypeByPk?: SubscriptionResolver<Maybe<ResolversTypes['BusinessOrganizationUserEmailType']>, "businessOrganizationUserEmailTypeByPk", ParentType, ContextType, RequireFields<subscription_rootbusinessOrganizationUserEmailTypeByPkArgs, 'value'>>;
  businessOrganizationUserEmailTypeStream?: SubscriptionResolver<Array<ResolversTypes['BusinessOrganizationUserEmailType']>, "businessOrganizationUserEmailTypeStream", ParentType, ContextType, RequireFields<subscription_rootbusinessOrganizationUserEmailTypeStreamArgs, 'batchSize' | 'cursor'>>;
  businessOrganizationUserRequestAggregate?: SubscriptionResolver<ResolversTypes['BusinessOrganizationUserRequestAggregate'], "businessOrganizationUserRequestAggregate", ParentType, ContextType, Partial<subscription_rootbusinessOrganizationUserRequestAggregateArgs>>;
  businessOrganizationUserRequestStream?: SubscriptionResolver<Array<ResolversTypes['BusinessOrganizationUserRequest']>, "businessOrganizationUserRequestStream", ParentType, ContextType, RequireFields<subscription_rootbusinessOrganizationUserRequestStreamArgs, 'batchSize' | 'cursor'>>;
  businessOrganizationUserRequestType?: SubscriptionResolver<Array<ResolversTypes['BusinessOrganizationUserRequestType']>, "businessOrganizationUserRequestType", ParentType, ContextType, Partial<subscription_rootbusinessOrganizationUserRequestTypeArgs>>;
  businessOrganizationUserRequestTypeAggregate?: SubscriptionResolver<ResolversTypes['BusinessOrganizationUserRequestTypeAggregate'], "businessOrganizationUserRequestTypeAggregate", ParentType, ContextType, Partial<subscription_rootbusinessOrganizationUserRequestTypeAggregateArgs>>;
  businessOrganizationUserRequestTypeByPk?: SubscriptionResolver<Maybe<ResolversTypes['BusinessOrganizationUserRequestType']>, "businessOrganizationUserRequestTypeByPk", ParentType, ContextType, RequireFields<subscription_rootbusinessOrganizationUserRequestTypeByPkArgs, 'name'>>;
  businessOrganizationUserRequestTypeStream?: SubscriptionResolver<Array<ResolversTypes['BusinessOrganizationUserRequestType']>, "businessOrganizationUserRequestTypeStream", ParentType, ContextType, RequireFields<subscription_rootbusinessOrganizationUserRequestTypeStreamArgs, 'batchSize' | 'cursor'>>;
  businessOrganizationUserSuggestionType?: SubscriptionResolver<Array<ResolversTypes['BusinessOrganizationUserSuggestionType']>, "businessOrganizationUserSuggestionType", ParentType, ContextType, Partial<subscription_rootbusinessOrganizationUserSuggestionTypeArgs>>;
  businessOrganizationUserSuggestionTypeAggregate?: SubscriptionResolver<ResolversTypes['BusinessOrganizationUserSuggestionTypeAggregate'], "businessOrganizationUserSuggestionTypeAggregate", ParentType, ContextType, Partial<subscription_rootbusinessOrganizationUserSuggestionTypeAggregateArgs>>;
  businessOrganizationUserSuggestionTypeByPk?: SubscriptionResolver<Maybe<ResolversTypes['BusinessOrganizationUserSuggestionType']>, "businessOrganizationUserSuggestionTypeByPk", ParentType, ContextType, RequireFields<subscription_rootbusinessOrganizationUserSuggestionTypeByPkArgs, 'value'>>;
  businessOrganizationUserSuggestionTypeStream?: SubscriptionResolver<Array<ResolversTypes['BusinessOrganizationUserSuggestionType']>, "businessOrganizationUserSuggestionTypeStream", ParentType, ContextType, RequireFields<subscription_rootbusinessOrganizationUserSuggestionTypeStreamArgs, 'batchSize' | 'cursor'>>;
  businessOrganizationUserSuggestions?: SubscriptionResolver<Array<ResolversTypes['BusinessOrganizationUserSuggestions']>, "businessOrganizationUserSuggestions", ParentType, ContextType, Partial<subscription_rootbusinessOrganizationUserSuggestionsArgs>>;
  businessOrganizationUserSuggestionsAggregate?: SubscriptionResolver<ResolversTypes['BusinessOrganizationUserSuggestionsAggregate'], "businessOrganizationUserSuggestionsAggregate", ParentType, ContextType, Partial<subscription_rootbusinessOrganizationUserSuggestionsAggregateArgs>>;
  businessOrganizationUserSuggestionsByPk?: SubscriptionResolver<Maybe<ResolversTypes['BusinessOrganizationUserSuggestions']>, "businessOrganizationUserSuggestionsByPk", ParentType, ContextType, RequireFields<subscription_rootbusinessOrganizationUserSuggestionsByPkArgs, 'id'>>;
  businessOrganizationUserSuggestionsStream?: SubscriptionResolver<Array<ResolversTypes['BusinessOrganizationUserSuggestions']>, "businessOrganizationUserSuggestionsStream", ParentType, ContextType, RequireFields<subscription_rootbusinessOrganizationUserSuggestionsStreamArgs, 'batchSize' | 'cursor'>>;
  businessOrganizationUserUrlAddress?: SubscriptionResolver<Array<ResolversTypes['BusinessOrganizationUserUrlAddress']>, "businessOrganizationUserUrlAddress", ParentType, ContextType, Partial<subscription_rootbusinessOrganizationUserUrlAddressArgs>>;
  businessOrganizationUserUrlAddressAggregate?: SubscriptionResolver<ResolversTypes['BusinessOrganizationUserUrlAddressAggregate'], "businessOrganizationUserUrlAddressAggregate", ParentType, ContextType, Partial<subscription_rootbusinessOrganizationUserUrlAddressAggregateArgs>>;
  businessOrganizationUserUrlAddressByPk?: SubscriptionResolver<Maybe<ResolversTypes['BusinessOrganizationUserUrlAddress']>, "businessOrganizationUserUrlAddressByPk", ParentType, ContextType, RequireFields<subscription_rootbusinessOrganizationUserUrlAddressByPkArgs, 'id'>>;
  businessOrganizationUserUrlAddressStream?: SubscriptionResolver<Array<ResolversTypes['BusinessOrganizationUserUrlAddress']>, "businessOrganizationUserUrlAddressStream", ParentType, ContextType, RequireFields<subscription_rootbusinessOrganizationUserUrlAddressStreamArgs, 'batchSize' | 'cursor'>>;
  businessOrganizationUserUrlAddressType?: SubscriptionResolver<Array<ResolversTypes['BusinessOrganizationUserUrlAddressType']>, "businessOrganizationUserUrlAddressType", ParentType, ContextType, Partial<subscription_rootbusinessOrganizationUserUrlAddressTypeArgs>>;
  businessOrganizationUserUrlAddressTypeAggregate?: SubscriptionResolver<ResolversTypes['BusinessOrganizationUserUrlAddressTypeAggregate'], "businessOrganizationUserUrlAddressTypeAggregate", ParentType, ContextType, Partial<subscription_rootbusinessOrganizationUserUrlAddressTypeAggregateArgs>>;
  businessOrganizationUserUrlAddressTypeByPk?: SubscriptionResolver<Maybe<ResolversTypes['BusinessOrganizationUserUrlAddressType']>, "businessOrganizationUserUrlAddressTypeByPk", ParentType, ContextType, RequireFields<subscription_rootbusinessOrganizationUserUrlAddressTypeByPkArgs, 'value'>>;
  businessOrganizationUserUrlAddressTypeStream?: SubscriptionResolver<Array<ResolversTypes['BusinessOrganizationUserUrlAddressType']>, "businessOrganizationUserUrlAddressTypeStream", ParentType, ContextType, RequireFields<subscription_rootbusinessOrganizationUserUrlAddressTypeStreamArgs, 'batchSize' | 'cursor'>>;
  businessQueueItemAlarmType?: SubscriptionResolver<Array<ResolversTypes['BusinessQueueItemAlarmType']>, "businessQueueItemAlarmType", ParentType, ContextType, Partial<subscription_rootbusinessQueueItemAlarmTypeArgs>>;
  businessQueueItemAlarmTypeAggregate?: SubscriptionResolver<ResolversTypes['BusinessQueueItemAlarmTypeAggregate'], "businessQueueItemAlarmTypeAggregate", ParentType, ContextType, Partial<subscription_rootbusinessQueueItemAlarmTypeAggregateArgs>>;
  businessQueueItemAlarmTypeByPk?: SubscriptionResolver<Maybe<ResolversTypes['BusinessQueueItemAlarmType']>, "businessQueueItemAlarmTypeByPk", ParentType, ContextType, RequireFields<subscription_rootbusinessQueueItemAlarmTypeByPkArgs, 'value'>>;
  businessQueueItemAlarmTypeStream?: SubscriptionResolver<Array<ResolversTypes['BusinessQueueItemAlarmType']>, "businessQueueItemAlarmTypeStream", ParentType, ContextType, RequireFields<subscription_rootbusinessQueueItemAlarmTypeStreamArgs, 'batchSize' | 'cursor'>>;
  businessQueueItemAlarms?: SubscriptionResolver<Array<ResolversTypes['BusinessQueueItemAlarms']>, "businessQueueItemAlarms", ParentType, ContextType, Partial<subscription_rootbusinessQueueItemAlarmsArgs>>;
  businessQueueItemAlarmsAggregate?: SubscriptionResolver<ResolversTypes['BusinessQueueItemAlarmsAggregate'], "businessQueueItemAlarmsAggregate", ParentType, ContextType, Partial<subscription_rootbusinessQueueItemAlarmsAggregateArgs>>;
  businessQueueItemAlarmsByPk?: SubscriptionResolver<Maybe<ResolversTypes['BusinessQueueItemAlarms']>, "businessQueueItemAlarmsByPk", ParentType, ContextType, RequireFields<subscription_rootbusinessQueueItemAlarmsByPkArgs, 'id'>>;
  businessQueueItemAlarmsStream?: SubscriptionResolver<Array<ResolversTypes['BusinessQueueItemAlarms']>, "businessQueueItemAlarmsStream", ParentType, ContextType, RequireFields<subscription_rootbusinessQueueItemAlarmsStreamArgs, 'batchSize' | 'cursor'>>;
  businessQueueItemCollaboration?: SubscriptionResolver<Maybe<ResolversTypes['businessQueueItemCollaboration']>, "businessQueueItemCollaboration", ParentType, ContextType, RequireFields<subscription_rootbusinessQueueItemCollaborationArgs, 'id'>>;
  businessQueueItemCollaborationAggregate?: SubscriptionResolver<ResolversTypes['businessQueueItemCollaborationAggregate'], "businessQueueItemCollaborationAggregate", ParentType, ContextType, Partial<subscription_rootbusinessQueueItemCollaborationAggregateArgs>>;
  businessQueueItemCollaborationStream?: SubscriptionResolver<Array<ResolversTypes['businessQueueItemCollaboration']>, "businessQueueItemCollaborationStream", ParentType, ContextType, RequireFields<subscription_rootbusinessQueueItemCollaborationStreamArgs, 'batchSize' | 'cursor'>>;
  businessQueueItemCollaborations?: SubscriptionResolver<Array<ResolversTypes['businessQueueItemCollaboration']>, "businessQueueItemCollaborations", ParentType, ContextType, Partial<subscription_rootbusinessQueueItemCollaborationsArgs>>;
  businessQueueItemDomainUsersView?: SubscriptionResolver<Array<ResolversTypes['BusinessQueueItemDomainUsersView']>, "businessQueueItemDomainUsersView", ParentType, ContextType, Partial<subscription_rootbusinessQueueItemDomainUsersViewArgs>>;
  businessQueueItemDomainUsersViewAggregate?: SubscriptionResolver<ResolversTypes['BusinessQueueItemDomainUsersViewAggregate'], "businessQueueItemDomainUsersViewAggregate", ParentType, ContextType, Partial<subscription_rootbusinessQueueItemDomainUsersViewAggregateArgs>>;
  businessQueueItemDomainUsersViewStream?: SubscriptionResolver<Array<ResolversTypes['BusinessQueueItemDomainUsersView']>, "businessQueueItemDomainUsersViewStream", ParentType, ContextType, RequireFields<subscription_rootbusinessQueueItemDomainUsersViewStreamArgs, 'batchSize' | 'cursor'>>;
  businessQueueItemOrganizationUsersView?: SubscriptionResolver<Array<ResolversTypes['BusinessQueueItemOrganizationUsersView']>, "businessQueueItemOrganizationUsersView", ParentType, ContextType, Partial<subscription_rootbusinessQueueItemOrganizationUsersViewArgs>>;
  businessQueueItemOrganizationUsersViewAggregate?: SubscriptionResolver<ResolversTypes['BusinessQueueItemOrganizationUsersViewAggregate'], "businessQueueItemOrganizationUsersViewAggregate", ParentType, ContextType, Partial<subscription_rootbusinessQueueItemOrganizationUsersViewAggregateArgs>>;
  businessQueueItemOrganizationUsersViewStream?: SubscriptionResolver<Array<ResolversTypes['BusinessQueueItemOrganizationUsersView']>, "businessQueueItemOrganizationUsersViewStream", ParentType, ContextType, RequireFields<subscription_rootbusinessQueueItemOrganizationUsersViewStreamArgs, 'batchSize' | 'cursor'>>;
  businessQueueItemParticipantChannelType?: SubscriptionResolver<Array<ResolversTypes['BusinessQueueItemParticipantChannelType']>, "businessQueueItemParticipantChannelType", ParentType, ContextType, Partial<subscription_rootbusinessQueueItemParticipantChannelTypeArgs>>;
  businessQueueItemParticipantChannelTypeAggregate?: SubscriptionResolver<ResolversTypes['BusinessQueueItemParticipantChannelTypeAggregate'], "businessQueueItemParticipantChannelTypeAggregate", ParentType, ContextType, Partial<subscription_rootbusinessQueueItemParticipantChannelTypeAggregateArgs>>;
  businessQueueItemParticipantChannelTypeByPk?: SubscriptionResolver<Maybe<ResolversTypes['BusinessQueueItemParticipantChannelType']>, "businessQueueItemParticipantChannelTypeByPk", ParentType, ContextType, RequireFields<subscription_rootbusinessQueueItemParticipantChannelTypeByPkArgs, 'value'>>;
  businessQueueItemParticipantChannelTypeStream?: SubscriptionResolver<Array<ResolversTypes['BusinessQueueItemParticipantChannelType']>, "businessQueueItemParticipantChannelTypeStream", ParentType, ContextType, RequireFields<subscription_rootbusinessQueueItemParticipantChannelTypeStreamArgs, 'batchSize' | 'cursor'>>;
  businessQueueItemParticipantsView?: SubscriptionResolver<Array<ResolversTypes['BusinessQueueItemParticipantsView']>, "businessQueueItemParticipantsView", ParentType, ContextType, Partial<subscription_rootbusinessQueueItemParticipantsViewArgs>>;
  businessQueueItemParticipantsViewAggregate?: SubscriptionResolver<ResolversTypes['BusinessQueueItemParticipantsViewAggregate'], "businessQueueItemParticipantsViewAggregate", ParentType, ContextType, Partial<subscription_rootbusinessQueueItemParticipantsViewAggregateArgs>>;
  businessQueueItemParticipantsViewStream?: SubscriptionResolver<Array<ResolversTypes['BusinessQueueItemParticipantsView']>, "businessQueueItemParticipantsViewStream", ParentType, ContextType, RequireFields<subscription_rootbusinessQueueItemParticipantsViewStreamArgs, 'batchSize' | 'cursor'>>;
  businessQueueItemSubType?: SubscriptionResolver<Array<ResolversTypes['BusinessQueueItemSubType']>, "businessQueueItemSubType", ParentType, ContextType, Partial<subscription_rootbusinessQueueItemSubTypeArgs>>;
  businessQueueItemSubTypeAggregate?: SubscriptionResolver<ResolversTypes['BusinessQueueItemSubTypeAggregate'], "businessQueueItemSubTypeAggregate", ParentType, ContextType, Partial<subscription_rootbusinessQueueItemSubTypeAggregateArgs>>;
  businessQueueItemSubTypeByPk?: SubscriptionResolver<Maybe<ResolversTypes['BusinessQueueItemSubType']>, "businessQueueItemSubTypeByPk", ParentType, ContextType, RequireFields<subscription_rootbusinessQueueItemSubTypeByPkArgs, 'value'>>;
  businessQueueItemSubTypeStream?: SubscriptionResolver<Array<ResolversTypes['BusinessQueueItemSubType']>, "businessQueueItemSubTypeStream", ParentType, ContextType, RequireFields<subscription_rootbusinessQueueItemSubTypeStreamArgs, 'batchSize' | 'cursor'>>;
  businessUserContact?: SubscriptionResolver<Maybe<ResolversTypes['businessUserContacts']>, "businessUserContact", ParentType, ContextType, RequireFields<subscription_rootbusinessUserContactArgs, 'id'>>;
  businessUserContactNumbers?: SubscriptionResolver<Array<ResolversTypes['BusinessUserContactNumbers']>, "businessUserContactNumbers", ParentType, ContextType, Partial<subscription_rootbusinessUserContactNumbersArgs>>;
  businessUserContactNumbersAggregate?: SubscriptionResolver<ResolversTypes['BusinessUserContactNumbersAggregate'], "businessUserContactNumbersAggregate", ParentType, ContextType, Partial<subscription_rootbusinessUserContactNumbersAggregateArgs>>;
  businessUserContactNumbersByPk?: SubscriptionResolver<Maybe<ResolversTypes['BusinessUserContactNumbers']>, "businessUserContactNumbersByPk", ParentType, ContextType, RequireFields<subscription_rootbusinessUserContactNumbersByPkArgs, 'id'>>;
  businessUserContactNumbersStream?: SubscriptionResolver<Array<ResolversTypes['BusinessUserContactNumbers']>, "businessUserContactNumbersStream", ParentType, ContextType, RequireFields<subscription_rootbusinessUserContactNumbersStreamArgs, 'batchSize' | 'cursor'>>;
  businessUserContacts?: SubscriptionResolver<Array<ResolversTypes['businessUserContacts']>, "businessUserContacts", ParentType, ContextType, Partial<subscription_rootbusinessUserContactsArgs>>;
  businessUserFeed?: SubscriptionResolver<Array<ResolversTypes['BusinessUserFeed']>, "businessUserFeed", ParentType, ContextType, Partial<subscription_rootbusinessUserFeedArgs>>;
  businessUserFeedAggregate?: SubscriptionResolver<ResolversTypes['BusinessUserFeedAggregate'], "businessUserFeedAggregate", ParentType, ContextType, Partial<subscription_rootbusinessUserFeedAggregateArgs>>;
  businessUserFeedByPk?: SubscriptionResolver<Maybe<ResolversTypes['BusinessUserFeed']>, "businessUserFeedByPk", ParentType, ContextType, RequireFields<subscription_rootbusinessUserFeedByPkArgs, 'id'>>;
  businessUserFeedStream?: SubscriptionResolver<Array<ResolversTypes['BusinessUserFeed']>, "businessUserFeedStream", ParentType, ContextType, RequireFields<subscription_rootbusinessUserFeedStreamArgs, 'batchSize' | 'cursor'>>;
  businessUserRequestStatus?: SubscriptionResolver<Array<ResolversTypes['BusinessUserRequestStatus']>, "businessUserRequestStatus", ParentType, ContextType, Partial<subscription_rootbusinessUserRequestStatusArgs>>;
  businessUserRequestStatusAggregate?: SubscriptionResolver<ResolversTypes['BusinessUserRequestStatusAggregate'], "businessUserRequestStatusAggregate", ParentType, ContextType, Partial<subscription_rootbusinessUserRequestStatusAggregateArgs>>;
  businessUserRequestStatusByPk?: SubscriptionResolver<Maybe<ResolversTypes['BusinessUserRequestStatus']>, "businessUserRequestStatusByPk", ParentType, ContextType, RequireFields<subscription_rootbusinessUserRequestStatusByPkArgs, 'value'>>;
  businessUserRequestStatusStream?: SubscriptionResolver<Array<ResolversTypes['BusinessUserRequestStatus']>, "businessUserRequestStatusStream", ParentType, ContextType, RequireFields<subscription_rootbusinessUserRequestStatusStreamArgs, 'batchSize' | 'cursor'>>;
  businessUserSetting?: SubscriptionResolver<Maybe<ResolversTypes['businessUserSettings']>, "businessUserSetting", ParentType, ContextType, RequireFields<subscription_rootbusinessUserSettingArgs, 'id'>>;
  businessUserSettings?: SubscriptionResolver<Array<ResolversTypes['businessUserSettings']>, "businessUserSettings", ParentType, ContextType, Partial<subscription_rootbusinessUserSettingsArgs>>;
  businessUserStates?: SubscriptionResolver<Array<ResolversTypes['BusinessUserStates']>, "businessUserStates", ParentType, ContextType, Partial<subscription_rootbusinessUserStatesArgs>>;
  businessUserStatesAggregate?: SubscriptionResolver<ResolversTypes['BusinessUserStatesAggregate'], "businessUserStatesAggregate", ParentType, ContextType, Partial<subscription_rootbusinessUserStatesAggregateArgs>>;
  businessUserStatesByPk?: SubscriptionResolver<Maybe<ResolversTypes['BusinessUserStates']>, "businessUserStatesByPk", ParentType, ContextType, RequireFields<subscription_rootbusinessUserStatesByPkArgs, 'id'>>;
  businessUserStatesStream?: SubscriptionResolver<Array<ResolversTypes['BusinessUserStates']>, "businessUserStatesStream", ParentType, ContextType, RequireFields<subscription_rootbusinessUserStatesStreamArgs, 'batchSize' | 'cursor'>>;
  crmContext?: SubscriptionResolver<Array<ResolversTypes['CrmContext']>, "crmContext", ParentType, ContextType, Partial<subscription_rootcrmContextArgs>>;
  crmContextAggregate?: SubscriptionResolver<ResolversTypes['CrmContextAggregate'], "crmContextAggregate", ParentType, ContextType, Partial<subscription_rootcrmContextAggregateArgs>>;
  crmContextByPk?: SubscriptionResolver<Maybe<ResolversTypes['CrmContext']>, "crmContextByPk", ParentType, ContextType, RequireFields<subscription_rootcrmContextByPkArgs, 'id'>>;
  crmContextStream?: SubscriptionResolver<Array<ResolversTypes['CrmContext']>, "crmContextStream", ParentType, ContextType, RequireFields<subscription_rootcrmContextStreamArgs, 'batchSize' | 'cursor'>>;
  crmContextType?: SubscriptionResolver<Array<ResolversTypes['CrmContextType']>, "crmContextType", ParentType, ContextType, Partial<subscription_rootcrmContextTypeArgs>>;
  crmContextTypeAggregate?: SubscriptionResolver<ResolversTypes['CrmContextTypeAggregate'], "crmContextTypeAggregate", ParentType, ContextType, Partial<subscription_rootcrmContextTypeAggregateArgs>>;
  crmContextTypeByPk?: SubscriptionResolver<Maybe<ResolversTypes['CrmContextType']>, "crmContextTypeByPk", ParentType, ContextType, RequireFields<subscription_rootcrmContextTypeByPkArgs, 'value'>>;
  crmContextTypeStream?: SubscriptionResolver<Array<ResolversTypes['CrmContextType']>, "crmContextTypeStream", ParentType, ContextType, RequireFields<subscription_rootcrmContextTypeStreamArgs, 'batchSize' | 'cursor'>>;
  crmCreatorType?: SubscriptionResolver<Array<ResolversTypes['CrmCreatorType']>, "crmCreatorType", ParentType, ContextType, Partial<subscription_rootcrmCreatorTypeArgs>>;
  crmCreatorTypeAggregate?: SubscriptionResolver<ResolversTypes['CrmCreatorTypeAggregate'], "crmCreatorTypeAggregate", ParentType, ContextType, Partial<subscription_rootcrmCreatorTypeAggregateArgs>>;
  crmCreatorTypeByPk?: SubscriptionResolver<Maybe<ResolversTypes['CrmCreatorType']>, "crmCreatorTypeByPk", ParentType, ContextType, RequireFields<subscription_rootcrmCreatorTypeByPkArgs, 'value'>>;
  crmCreatorTypeStream?: SubscriptionResolver<Array<ResolversTypes['CrmCreatorType']>, "crmCreatorTypeStream", ParentType, ContextType, RequireFields<subscription_rootcrmCreatorTypeStreamArgs, 'batchSize' | 'cursor'>>;
  crmCrmType?: SubscriptionResolver<Array<ResolversTypes['CrmCrmType']>, "crmCrmType", ParentType, ContextType, Partial<subscription_rootcrmCrmTypeArgs>>;
  crmCrmTypeAggregate?: SubscriptionResolver<ResolversTypes['CrmCrmTypeAggregate'], "crmCrmTypeAggregate", ParentType, ContextType, Partial<subscription_rootcrmCrmTypeAggregateArgs>>;
  crmCrmTypeByPk?: SubscriptionResolver<Maybe<ResolversTypes['CrmCrmType']>, "crmCrmTypeByPk", ParentType, ContextType, RequireFields<subscription_rootcrmCrmTypeByPkArgs, 'value'>>;
  crmCrmTypeStream?: SubscriptionResolver<Array<ResolversTypes['CrmCrmType']>, "crmCrmTypeStream", ParentType, ContextType, RequireFields<subscription_rootcrmCrmTypeStreamArgs, 'batchSize' | 'cursor'>>;
  crmDirectionType?: SubscriptionResolver<Array<ResolversTypes['CrmDirectionType']>, "crmDirectionType", ParentType, ContextType, Partial<subscription_rootcrmDirectionTypeArgs>>;
  crmDirectionTypeAggregate?: SubscriptionResolver<ResolversTypes['CrmDirectionTypeAggregate'], "crmDirectionTypeAggregate", ParentType, ContextType, Partial<subscription_rootcrmDirectionTypeAggregateArgs>>;
  crmDirectionTypeByPk?: SubscriptionResolver<Maybe<ResolversTypes['CrmDirectionType']>, "crmDirectionTypeByPk", ParentType, ContextType, RequireFields<subscription_rootcrmDirectionTypeByPkArgs, 'value'>>;
  crmDirectionTypeStream?: SubscriptionResolver<Array<ResolversTypes['CrmDirectionType']>, "crmDirectionTypeStream", ParentType, ContextType, RequireFields<subscription_rootcrmDirectionTypeStreamArgs, 'batchSize' | 'cursor'>>;
  crmEntity?: SubscriptionResolver<Array<ResolversTypes['CrmEntity']>, "crmEntity", ParentType, ContextType, Partial<subscription_rootcrmEntityArgs>>;
  crmEntityAggregate?: SubscriptionResolver<ResolversTypes['CrmEntityAggregate'], "crmEntityAggregate", ParentType, ContextType, Partial<subscription_rootcrmEntityAggregateArgs>>;
  crmEntityByPk?: SubscriptionResolver<Maybe<ResolversTypes['CrmEntity']>, "crmEntityByPk", ParentType, ContextType, RequireFields<subscription_rootcrmEntityByPkArgs, 'id'>>;
  crmEntityStream?: SubscriptionResolver<Array<ResolversTypes['CrmEntity']>, "crmEntityStream", ParentType, ContextType, RequireFields<subscription_rootcrmEntityStreamArgs, 'batchSize' | 'cursor'>>;
  crmEvent?: SubscriptionResolver<Array<ResolversTypes['CrmEvent']>, "crmEvent", ParentType, ContextType, Partial<subscription_rootcrmEventArgs>>;
  crmEventAggregate?: SubscriptionResolver<ResolversTypes['CrmEventAggregate'], "crmEventAggregate", ParentType, ContextType, Partial<subscription_rootcrmEventAggregateArgs>>;
  crmEventByPk?: SubscriptionResolver<Maybe<ResolversTypes['CrmEvent']>, "crmEventByPk", ParentType, ContextType, RequireFields<subscription_rootcrmEventByPkArgs, 'id'>>;
  crmEventStream?: SubscriptionResolver<Array<ResolversTypes['CrmEvent']>, "crmEventStream", ParentType, ContextType, RequireFields<subscription_rootcrmEventStreamArgs, 'batchSize' | 'cursor'>>;
  crmEventType?: SubscriptionResolver<Array<ResolversTypes['CrmEventType']>, "crmEventType", ParentType, ContextType, Partial<subscription_rootcrmEventTypeArgs>>;
  crmEventTypeAggregate?: SubscriptionResolver<ResolversTypes['CrmEventTypeAggregate'], "crmEventTypeAggregate", ParentType, ContextType, Partial<subscription_rootcrmEventTypeAggregateArgs>>;
  crmEventTypeByPk?: SubscriptionResolver<Maybe<ResolversTypes['CrmEventType']>, "crmEventTypeByPk", ParentType, ContextType, RequireFields<subscription_rootcrmEventTypeByPkArgs, 'value'>>;
  crmEventTypeStream?: SubscriptionResolver<Array<ResolversTypes['CrmEventType']>, "crmEventTypeStream", ParentType, ContextType, RequireFields<subscription_rootcrmEventTypeStreamArgs, 'batchSize' | 'cursor'>>;
  crmStatusCode?: SubscriptionResolver<Array<ResolversTypes['CrmStatusCode']>, "crmStatusCode", ParentType, ContextType, Partial<subscription_rootcrmStatusCodeArgs>>;
  crmStatusCodeAggregate?: SubscriptionResolver<ResolversTypes['CrmStatusCodeAggregate'], "crmStatusCodeAggregate", ParentType, ContextType, Partial<subscription_rootcrmStatusCodeAggregateArgs>>;
  crmStatusCodeByPk?: SubscriptionResolver<Maybe<ResolversTypes['CrmStatusCode']>, "crmStatusCodeByPk", ParentType, ContextType, RequireFields<subscription_rootcrmStatusCodeByPkArgs, 'value'>>;
  crmStatusCodeStream?: SubscriptionResolver<Array<ResolversTypes['CrmStatusCode']>, "crmStatusCodeStream", ParentType, ContextType, RequireFields<subscription_rootcrmStatusCodeStreamArgs, 'batchSize' | 'cursor'>>;
  crmStatusMessageAggregate?: SubscriptionResolver<ResolversTypes['crmStatusMessageAggregate'], "crmStatusMessageAggregate", ParentType, ContextType, Partial<subscription_rootcrmStatusMessageAggregateArgs>>;
  crmStatusMessageByPk?: SubscriptionResolver<Maybe<ResolversTypes['crmStatusMessage']>, "crmStatusMessageByPk", ParentType, ContextType, RequireFields<subscription_rootcrmStatusMessageByPkArgs, 'id'>>;
  crmStatusMessageStream?: SubscriptionResolver<Array<ResolversTypes['crmStatusMessage']>, "crmStatusMessageStream", ParentType, ContextType, RequireFields<subscription_rootcrmStatusMessageStreamArgs, 'batchSize' | 'cursor'>>;
  crmStatusMessages?: SubscriptionResolver<Array<ResolversTypes['crmStatusMessage']>, "crmStatusMessages", ParentType, ContextType, Partial<subscription_rootcrmStatusMessagesArgs>>;
  crmSystemType?: SubscriptionResolver<Array<ResolversTypes['CrmSystemType']>, "crmSystemType", ParentType, ContextType, Partial<subscription_rootcrmSystemTypeArgs>>;
  crmSystemTypeAggregate?: SubscriptionResolver<ResolversTypes['CrmSystemTypeAggregate'], "crmSystemTypeAggregate", ParentType, ContextType, Partial<subscription_rootcrmSystemTypeAggregateArgs>>;
  crmSystemTypeByPk?: SubscriptionResolver<Maybe<ResolversTypes['CrmSystemType']>, "crmSystemTypeByPk", ParentType, ContextType, RequireFields<subscription_rootcrmSystemTypeByPkArgs, 'value'>>;
  crmSystemTypeStream?: SubscriptionResolver<Array<ResolversTypes['CrmSystemType']>, "crmSystemTypeStream", ParentType, ContextType, RequireFields<subscription_rootcrmSystemTypeStreamArgs, 'batchSize' | 'cursor'>>;
  crmTraceContext?: SubscriptionResolver<Array<ResolversTypes['CrmTraceContext']>, "crmTraceContext", ParentType, ContextType, Partial<subscription_rootcrmTraceContextArgs>>;
  crmTraceContextAggregate?: SubscriptionResolver<ResolversTypes['CrmTraceContextAggregate'], "crmTraceContextAggregate", ParentType, ContextType, Partial<subscription_rootcrmTraceContextAggregateArgs>>;
  crmTraceContextByPk?: SubscriptionResolver<Maybe<ResolversTypes['CrmTraceContext']>, "crmTraceContextByPk", ParentType, ContextType, RequireFields<subscription_rootcrmTraceContextByPkArgs, 'id'>>;
  crmTraceContextStream?: SubscriptionResolver<Array<ResolversTypes['CrmTraceContext']>, "crmTraceContextStream", ParentType, ContextType, RequireFields<subscription_rootcrmTraceContextStreamArgs, 'batchSize' | 'cursor'>>;
  crmUnifiedEntityType?: SubscriptionResolver<Array<ResolversTypes['CrmUnifiedEntityType']>, "crmUnifiedEntityType", ParentType, ContextType, Partial<subscription_rootcrmUnifiedEntityTypeArgs>>;
  crmUnifiedEntityTypeAggregate?: SubscriptionResolver<ResolversTypes['CrmUnifiedEntityTypeAggregate'], "crmUnifiedEntityTypeAggregate", ParentType, ContextType, Partial<subscription_rootcrmUnifiedEntityTypeAggregateArgs>>;
  crmUnifiedEntityTypeByPk?: SubscriptionResolver<Maybe<ResolversTypes['CrmUnifiedEntityType']>, "crmUnifiedEntityTypeByPk", ParentType, ContextType, RequireFields<subscription_rootcrmUnifiedEntityTypeByPkArgs, 'value'>>;
  crmUnifiedEntityTypeStream?: SubscriptionResolver<Array<ResolversTypes['CrmUnifiedEntityType']>, "crmUnifiedEntityTypeStream", ParentType, ContextType, RequireFields<subscription_rootcrmUnifiedEntityTypeStreamArgs, 'batchSize' | 'cursor'>>;
  crmYoutelloCatalystIdMapping?: SubscriptionResolver<Maybe<ResolversTypes['crmYoutelloCatalystIdMapping']>, "crmYoutelloCatalystIdMapping", ParentType, ContextType, RequireFields<subscription_rootcrmYoutelloCatalystIdMappingArgs, 'catalystId' | 'youtelloId'>>;
  crmYoutelloCatalystIdMappingAggregate?: SubscriptionResolver<ResolversTypes['crmYoutelloCatalystIdMappingAggregate'], "crmYoutelloCatalystIdMappingAggregate", ParentType, ContextType, Partial<subscription_rootcrmYoutelloCatalystIdMappingAggregateArgs>>;
  crmYoutelloCatalystIdMappingStream?: SubscriptionResolver<Array<ResolversTypes['crmYoutelloCatalystIdMapping']>, "crmYoutelloCatalystIdMappingStream", ParentType, ContextType, RequireFields<subscription_rootcrmYoutelloCatalystIdMappingStreamArgs, 'batchSize' | 'cursor'>>;
  crmYoutelloCatalystIdMappings?: SubscriptionResolver<Array<ResolversTypes['crmYoutelloCatalystIdMapping']>, "crmYoutelloCatalystIdMappings", ParentType, ContextType, Partial<subscription_rootcrmYoutelloCatalystIdMappingsArgs>>;
  domainActivities?: SubscriptionResolver<Array<ResolversTypes['domainActivity']>, "domainActivities", ParentType, ContextType, Partial<subscription_rootdomainActivitiesArgs>>;
  domainActivitiesAggregate?: SubscriptionResolver<ResolversTypes['domainActivityAggregate'], "domainActivitiesAggregate", ParentType, ContextType, Partial<subscription_rootdomainActivitiesAggregateArgs>>;
  domainActivitiesStream?: SubscriptionResolver<Array<ResolversTypes['domainActivity']>, "domainActivitiesStream", ParentType, ContextType, RequireFields<subscription_rootdomainActivitiesStreamArgs, 'batchSize' | 'cursor'>>;
  domainActivity?: SubscriptionResolver<Maybe<ResolversTypes['domainActivity']>, "domainActivity", ParentType, ContextType, RequireFields<subscription_rootdomainActivityArgs, 'id'>>;
  domainOrganization?: SubscriptionResolver<Maybe<ResolversTypes['domainOrganization']>, "domainOrganization", ParentType, ContextType, RequireFields<subscription_rootdomainOrganizationArgs, 'id'>>;
  domainOrganizations?: SubscriptionResolver<Array<ResolversTypes['domainOrganization']>, "domainOrganizations", ParentType, ContextType, Partial<subscription_rootdomainOrganizationsArgs>>;
  domainOrganizationsAggregate?: SubscriptionResolver<ResolversTypes['domainOrganizationAggregate'], "domainOrganizationsAggregate", ParentType, ContextType, Partial<subscription_rootdomainOrganizationsAggregateArgs>>;
  domainOrganizationsStream?: SubscriptionResolver<Array<ResolversTypes['domainOrganization']>, "domainOrganizationsStream", ParentType, ContextType, RequireFields<subscription_rootdomainOrganizationsStreamArgs, 'batchSize' | 'cursor'>>;
  domainParticipant?: SubscriptionResolver<Maybe<ResolversTypes['domainParticipant']>, "domainParticipant", ParentType, ContextType, RequireFields<subscription_rootdomainParticipantArgs, 'id'>>;
  domainParticipants?: SubscriptionResolver<Array<ResolversTypes['domainParticipant']>, "domainParticipants", ParentType, ContextType, Partial<subscription_rootdomainParticipantsArgs>>;
  domainParticipantsAggregate?: SubscriptionResolver<ResolversTypes['domainParticipantAggregate'], "domainParticipantsAggregate", ParentType, ContextType, Partial<subscription_rootdomainParticipantsAggregateArgs>>;
  domainParticipantsStream?: SubscriptionResolver<Array<ResolversTypes['domainParticipant']>, "domainParticipantsStream", ParentType, ContextType, RequireFields<subscription_rootdomainParticipantsStreamArgs, 'batchSize' | 'cursor'>>;
  domainType?: SubscriptionResolver<Maybe<ResolversTypes['domainType']>, "domainType", ParentType, ContextType, RequireFields<subscription_rootdomainTypeArgs, 'value'>>;
  domainTypes?: SubscriptionResolver<Array<ResolversTypes['domainType']>, "domainTypes", ParentType, ContextType, Partial<subscription_rootdomainTypesArgs>>;
  domainTypesAggregate?: SubscriptionResolver<ResolversTypes['domainTypeAggregate'], "domainTypesAggregate", ParentType, ContextType, Partial<subscription_rootdomainTypesAggregateArgs>>;
  domainTypesStream?: SubscriptionResolver<Array<ResolversTypes['domainType']>, "domainTypesStream", ParentType, ContextType, RequireFields<subscription_rootdomainTypesStreamArgs, 'batchSize' | 'cursor'>>;
  domainUser?: SubscriptionResolver<Maybe<ResolversTypes['domainUser']>, "domainUser", ParentType, ContextType, RequireFields<subscription_rootdomainUserArgs, 'id'>>;
  domainUserCategories?: SubscriptionResolver<Array<ResolversTypes['domainUserCategory']>, "domainUserCategories", ParentType, ContextType, Partial<subscription_rootdomainUserCategoriesArgs>>;
  domainUserCategoriesAggregate?: SubscriptionResolver<ResolversTypes['domainUserCategoryAggregate'], "domainUserCategoriesAggregate", ParentType, ContextType, Partial<subscription_rootdomainUserCategoriesAggregateArgs>>;
  domainUserCategoriesStream?: SubscriptionResolver<Array<ResolversTypes['domainUserCategory']>, "domainUserCategoriesStream", ParentType, ContextType, RequireFields<subscription_rootdomainUserCategoriesStreamArgs, 'batchSize' | 'cursor'>>;
  domainUserCategory?: SubscriptionResolver<Maybe<ResolversTypes['domainUserCategory']>, "domainUserCategory", ParentType, ContextType, RequireFields<subscription_rootdomainUserCategoryArgs, 'value'>>;
  domainUsers?: SubscriptionResolver<Array<ResolversTypes['domainUser']>, "domainUsers", ParentType, ContextType, Partial<subscription_rootdomainUsersArgs>>;
  domainUsersAggregate?: SubscriptionResolver<ResolversTypes['domainUserAggregate'], "domainUsersAggregate", ParentType, ContextType, Partial<subscription_rootdomainUsersAggregateArgs>>;
  domainUsersStream?: SubscriptionResolver<Array<ResolversTypes['domainUser']>, "domainUsersStream", ParentType, ContextType, RequireFields<subscription_rootdomainUsersStreamArgs, 'batchSize' | 'cursor'>>;
  emailing?: SubscriptionResolver<Maybe<ResolversTypes['emailingsubscription_root']>, "emailing", ParentType, ContextType>;
  geodata?: SubscriptionResolver<Maybe<ResolversTypes['geodatasubscription_root']>, "geodata", ParentType, ContextType>;
  incomingSms?: SubscriptionResolver<Maybe<ResolversTypes['incomingSms']>, "incomingSms", ParentType, ContextType, RequireFields<subscription_rootincomingSmsArgs, 'id'>>;
  language?: SubscriptionResolver<Maybe<ResolversTypes['languages']>, "language", ParentType, ContextType, RequireFields<subscription_rootlanguageArgs, 'value'>>;
  languageAggregate?: SubscriptionResolver<ResolversTypes['languagesAggregate'], "languageAggregate", ParentType, ContextType, Partial<subscription_rootlanguageAggregateArgs>>;
  languageStream?: SubscriptionResolver<Array<ResolversTypes['languages']>, "languageStream", ParentType, ContextType, RequireFields<subscription_rootlanguageStreamArgs, 'batchSize' | 'cursor'>>;
  languages?: SubscriptionResolver<Array<ResolversTypes['languages']>, "languages", ParentType, ContextType, Partial<subscription_rootlanguagesArgs>>;
  message?: SubscriptionResolver<Maybe<ResolversTypes['message']>, "message", ParentType, ContextType, RequireFields<subscription_rootmessageArgs, 'id'>>;
  messageType?: SubscriptionResolver<Maybe<ResolversTypes['messageType']>, "messageType", ParentType, ContextType, RequireFields<subscription_rootmessageTypeArgs, 'value'>>;
  messageTypes?: SubscriptionResolver<Array<ResolversTypes['messageType']>, "messageTypes", ParentType, ContextType, Partial<subscription_rootmessageTypesArgs>>;
  messageTypesAggregate?: SubscriptionResolver<ResolversTypes['messageTypeAggregate'], "messageTypesAggregate", ParentType, ContextType, Partial<subscription_rootmessageTypesAggregateArgs>>;
  messageTypesStream?: SubscriptionResolver<Array<ResolversTypes['messageType']>, "messageTypesStream", ParentType, ContextType, RequireFields<subscription_rootmessageTypesStreamArgs, 'batchSize' | 'cursor'>>;
  messages?: SubscriptionResolver<Array<ResolversTypes['message']>, "messages", ParentType, ContextType, Partial<subscription_rootmessagesArgs>>;
  messagesAggregate?: SubscriptionResolver<ResolversTypes['messageAggregate'], "messagesAggregate", ParentType, ContextType, Partial<subscription_rootmessagesAggregateArgs>>;
  messagesStream?: SubscriptionResolver<Array<ResolversTypes['message']>, "messagesStream", ParentType, ContextType, RequireFields<subscription_rootmessagesStreamArgs, 'batchSize' | 'cursor'>>;
  messagingActivities?: SubscriptionResolver<Array<ResolversTypes['messagingActivity']>, "messagingActivities", ParentType, ContextType, Partial<subscription_rootmessagingActivitiesArgs>>;
  messagingActivity?: SubscriptionResolver<Maybe<ResolversTypes['messagingActivity']>, "messagingActivity", ParentType, ContextType, RequireFields<subscription_rootmessagingActivityArgs, 'id'>>;
  messagingActivityOrganization?: SubscriptionResolver<Maybe<ResolversTypes['messagingActivityOrganization']>, "messagingActivityOrganization", ParentType, ContextType, RequireFields<subscription_rootmessagingActivityOrganizationArgs, 'id'>>;
  messagingActivityOrganizationAggregate?: SubscriptionResolver<ResolversTypes['messagingActivityOrganizationAggregate'], "messagingActivityOrganizationAggregate", ParentType, ContextType, Partial<subscription_rootmessagingActivityOrganizationAggregateArgs>>;
  messagingActivityOrganizationStream?: SubscriptionResolver<Array<ResolversTypes['messagingActivityOrganization']>, "messagingActivityOrganizationStream", ParentType, ContextType, RequireFields<subscription_rootmessagingActivityOrganizationStreamArgs, 'batchSize' | 'cursor'>>;
  messagingActivityOrganizations?: SubscriptionResolver<Array<ResolversTypes['messagingActivityOrganization']>, "messagingActivityOrganizations", ParentType, ContextType, Partial<subscription_rootmessagingActivityOrganizationsArgs>>;
  messagingActivitySettings?: SubscriptionResolver<Array<ResolversTypes['MessagingActivitySettings']>, "messagingActivitySettings", ParentType, ContextType, Partial<subscription_rootmessagingActivitySettingsArgs>>;
  messagingActivitySettingsAggregate?: SubscriptionResolver<ResolversTypes['MessagingActivitySettingsAggregate'], "messagingActivitySettingsAggregate", ParentType, ContextType, Partial<subscription_rootmessagingActivitySettingsAggregateArgs>>;
  messagingActivitySettingsByPk?: SubscriptionResolver<Maybe<ResolversTypes['MessagingActivitySettings']>, "messagingActivitySettingsByPk", ParentType, ContextType, RequireFields<subscription_rootmessagingActivitySettingsByPkArgs, 'id'>>;
  messagingActivitySettingsNotificationSettingType?: SubscriptionResolver<Array<ResolversTypes['MessagingActivitySettingsNotificationSettingType']>, "messagingActivitySettingsNotificationSettingType", ParentType, ContextType, Partial<subscription_rootmessagingActivitySettingsNotificationSettingTypeArgs>>;
  messagingActivitySettingsNotificationSettingTypeAggregate?: SubscriptionResolver<ResolversTypes['MessagingActivitySettingsNotificationSettingTypeAggregate'], "messagingActivitySettingsNotificationSettingTypeAggregate", ParentType, ContextType, Partial<subscription_rootmessagingActivitySettingsNotificationSettingTypeAggregateArgs>>;
  messagingActivitySettingsNotificationSettingTypeByPk?: SubscriptionResolver<Maybe<ResolversTypes['MessagingActivitySettingsNotificationSettingType']>, "messagingActivitySettingsNotificationSettingTypeByPk", ParentType, ContextType, RequireFields<subscription_rootmessagingActivitySettingsNotificationSettingTypeByPkArgs, 'value'>>;
  messagingActivitySettingsNotificationSettingTypeStream?: SubscriptionResolver<Array<ResolversTypes['MessagingActivitySettingsNotificationSettingType']>, "messagingActivitySettingsNotificationSettingTypeStream", ParentType, ContextType, RequireFields<subscription_rootmessagingActivitySettingsNotificationSettingTypeStreamArgs, 'batchSize' | 'cursor'>>;
  messagingActivitySettingsStream?: SubscriptionResolver<Array<ResolversTypes['MessagingActivitySettings']>, "messagingActivitySettingsStream", ParentType, ContextType, RequireFields<subscription_rootmessagingActivitySettingsStreamArgs, 'batchSize' | 'cursor'>>;
  messagingActivityStream?: SubscriptionResolver<Array<ResolversTypes['messagingActivity']>, "messagingActivityStream", ParentType, ContextType, RequireFields<subscription_rootmessagingActivityStreamArgs, 'batchSize' | 'cursor'>>;
  messagingActivityType?: SubscriptionResolver<Maybe<ResolversTypes['messagingActivityType']>, "messagingActivityType", ParentType, ContextType, RequireFields<subscription_rootmessagingActivityTypeArgs, 'value'>>;
  messagingActivityTypeStream?: SubscriptionResolver<Array<ResolversTypes['messagingActivityType']>, "messagingActivityTypeStream", ParentType, ContextType, RequireFields<subscription_rootmessagingActivityTypeStreamArgs, 'batchSize' | 'cursor'>>;
  messagingActivityTypes?: SubscriptionResolver<Array<ResolversTypes['messagingActivityType']>, "messagingActivityTypes", ParentType, ContextType, Partial<subscription_rootmessagingActivityTypesArgs>>;
  messagingActivityUser?: SubscriptionResolver<Maybe<ResolversTypes['messagingActivityUser']>, "messagingActivityUser", ParentType, ContextType, RequireFields<subscription_rootmessagingActivityUserArgs, 'id'>>;
  messagingActivityUserStream?: SubscriptionResolver<Array<ResolversTypes['messagingActivityUser']>, "messagingActivityUserStream", ParentType, ContextType, RequireFields<subscription_rootmessagingActivityUserStreamArgs, 'batchSize' | 'cursor'>>;
  messagingActivityUsers?: SubscriptionResolver<Array<ResolversTypes['messagingActivityUser']>, "messagingActivityUsers", ParentType, ContextType, Partial<subscription_rootmessagingActivityUsersArgs>>;
  messagingInvitation?: SubscriptionResolver<Array<ResolversTypes['MessagingInvitation']>, "messagingInvitation", ParentType, ContextType, Partial<subscription_rootmessagingInvitationArgs>>;
  messagingInvitationAggregate?: SubscriptionResolver<ResolversTypes['MessagingInvitationAggregate'], "messagingInvitationAggregate", ParentType, ContextType, Partial<subscription_rootmessagingInvitationAggregateArgs>>;
  messagingInvitationByPk?: SubscriptionResolver<Maybe<ResolversTypes['MessagingInvitation']>, "messagingInvitationByPk", ParentType, ContextType, RequireFields<subscription_rootmessagingInvitationByPkArgs, 'id'>>;
  messagingInvitationStream?: SubscriptionResolver<Array<ResolversTypes['MessagingInvitation']>, "messagingInvitationStream", ParentType, ContextType, RequireFields<subscription_rootmessagingInvitationStreamArgs, 'batchSize' | 'cursor'>>;
  messagingMentions?: SubscriptionResolver<Array<ResolversTypes['MessagingMentions']>, "messagingMentions", ParentType, ContextType, Partial<subscription_rootmessagingMentionsArgs>>;
  messagingMentionsAggregate?: SubscriptionResolver<ResolversTypes['MessagingMentionsAggregate'], "messagingMentionsAggregate", ParentType, ContextType, Partial<subscription_rootmessagingMentionsAggregateArgs>>;
  messagingMentionsByPk?: SubscriptionResolver<Maybe<ResolversTypes['MessagingMentions']>, "messagingMentionsByPk", ParentType, ContextType, RequireFields<subscription_rootmessagingMentionsByPkArgs, 'id'>>;
  messagingMentionsStream?: SubscriptionResolver<Array<ResolversTypes['MessagingMentions']>, "messagingMentionsStream", ParentType, ContextType, RequireFields<subscription_rootmessagingMentionsStreamArgs, 'batchSize' | 'cursor'>>;
  messagingMessage?: SubscriptionResolver<Maybe<ResolversTypes['messagingMessage']>, "messagingMessage", ParentType, ContextType, RequireFields<subscription_rootmessagingMessageArgs, 'id'>>;
  messagingMessageAttachment?: SubscriptionResolver<Array<ResolversTypes['MessagingMessageAttachment']>, "messagingMessageAttachment", ParentType, ContextType, Partial<subscription_rootmessagingMessageAttachmentArgs>>;
  messagingMessageAttachmentAggregate?: SubscriptionResolver<ResolversTypes['MessagingMessageAttachmentAggregate'], "messagingMessageAttachmentAggregate", ParentType, ContextType, Partial<subscription_rootmessagingMessageAttachmentAggregateArgs>>;
  messagingMessageAttachmentByPk?: SubscriptionResolver<Maybe<ResolversTypes['MessagingMessageAttachment']>, "messagingMessageAttachmentByPk", ParentType, ContextType, RequireFields<subscription_rootmessagingMessageAttachmentByPkArgs, 'id'>>;
  messagingMessageAttachmentStream?: SubscriptionResolver<Array<ResolversTypes['MessagingMessageAttachment']>, "messagingMessageAttachmentStream", ParentType, ContextType, RequireFields<subscription_rootmessagingMessageAttachmentStreamArgs, 'batchSize' | 'cursor'>>;
  messagingMessageAttachmentType?: SubscriptionResolver<Array<ResolversTypes['MessagingMessageAttachmentType']>, "messagingMessageAttachmentType", ParentType, ContextType, Partial<subscription_rootmessagingMessageAttachmentTypeArgs>>;
  messagingMessageAttachmentTypeAggregate?: SubscriptionResolver<ResolversTypes['MessagingMessageAttachmentTypeAggregate'], "messagingMessageAttachmentTypeAggregate", ParentType, ContextType, Partial<subscription_rootmessagingMessageAttachmentTypeAggregateArgs>>;
  messagingMessageAttachmentTypeByPk?: SubscriptionResolver<Maybe<ResolversTypes['MessagingMessageAttachmentType']>, "messagingMessageAttachmentTypeByPk", ParentType, ContextType, RequireFields<subscription_rootmessagingMessageAttachmentTypeByPkArgs, 'value'>>;
  messagingMessageAttachmentTypeStream?: SubscriptionResolver<Array<ResolversTypes['MessagingMessageAttachmentType']>, "messagingMessageAttachmentTypeStream", ParentType, ContextType, RequireFields<subscription_rootmessagingMessageAttachmentTypeStreamArgs, 'batchSize' | 'cursor'>>;
  messagingMessageEmoji?: SubscriptionResolver<Maybe<ResolversTypes['messagingMessageEmoji']>, "messagingMessageEmoji", ParentType, ContextType, RequireFields<subscription_rootmessagingMessageEmojiArgs, 'id'>>;
  messagingMessageEmojiStream?: SubscriptionResolver<Array<ResolversTypes['messagingMessageEmoji']>, "messagingMessageEmojiStream", ParentType, ContextType, RequireFields<subscription_rootmessagingMessageEmojiStreamArgs, 'batchSize' | 'cursor'>>;
  messagingMessageEmojis?: SubscriptionResolver<Array<ResolversTypes['messagingMessageEmoji']>, "messagingMessageEmojis", ParentType, ContextType, Partial<subscription_rootmessagingMessageEmojisArgs>>;
  messagingMessagePriority?: SubscriptionResolver<Array<ResolversTypes['MessagingMessagePriority']>, "messagingMessagePriority", ParentType, ContextType, Partial<subscription_rootmessagingMessagePriorityArgs>>;
  messagingMessagePriorityAggregate?: SubscriptionResolver<ResolversTypes['MessagingMessagePriorityAggregate'], "messagingMessagePriorityAggregate", ParentType, ContextType, Partial<subscription_rootmessagingMessagePriorityAggregateArgs>>;
  messagingMessagePriorityByPk?: SubscriptionResolver<Maybe<ResolversTypes['MessagingMessagePriority']>, "messagingMessagePriorityByPk", ParentType, ContextType, RequireFields<subscription_rootmessagingMessagePriorityByPkArgs, 'value'>>;
  messagingMessagePriorityStream?: SubscriptionResolver<Array<ResolversTypes['MessagingMessagePriority']>, "messagingMessagePriorityStream", ParentType, ContextType, RequireFields<subscription_rootmessagingMessagePriorityStreamArgs, 'batchSize' | 'cursor'>>;
  messagingMessageRead?: SubscriptionResolver<Maybe<ResolversTypes['messagingMessageRead']>, "messagingMessageRead", ParentType, ContextType, RequireFields<subscription_rootmessagingMessageReadArgs, 'id'>>;
  messagingMessageReadStream?: SubscriptionResolver<Array<ResolversTypes['messagingMessageRead']>, "messagingMessageReadStream", ParentType, ContextType, RequireFields<subscription_rootmessagingMessageReadStreamArgs, 'batchSize' | 'cursor'>>;
  messagingMessageReads?: SubscriptionResolver<Array<ResolversTypes['messagingMessageRead']>, "messagingMessageReads", ParentType, ContextType, Partial<subscription_rootmessagingMessageReadsArgs>>;
  messagingMessageStream?: SubscriptionResolver<Array<ResolversTypes['messagingMessage']>, "messagingMessageStream", ParentType, ContextType, RequireFields<subscription_rootmessagingMessageStreamArgs, 'batchSize' | 'cursor'>>;
  messagingMessageType?: SubscriptionResolver<Maybe<ResolversTypes['messagingMessageType']>, "messagingMessageType", ParentType, ContextType, RequireFields<subscription_rootmessagingMessageTypeArgs, 'value'>>;
  messagingMessageTypeStream?: SubscriptionResolver<Array<ResolversTypes['messagingMessageType']>, "messagingMessageTypeStream", ParentType, ContextType, RequireFields<subscription_rootmessagingMessageTypeStreamArgs, 'batchSize' | 'cursor'>>;
  messagingMessageTypes?: SubscriptionResolver<Array<ResolversTypes['messagingMessageType']>, "messagingMessageTypes", ParentType, ContextType, Partial<subscription_rootmessagingMessageTypesArgs>>;
  messagingMessages?: SubscriptionResolver<Array<ResolversTypes['messagingMessage']>, "messagingMessages", ParentType, ContextType, Partial<subscription_rootmessagingMessagesArgs>>;
  notification?: SubscriptionResolver<Maybe<ResolversTypes['notification']>, "notification", ParentType, ContextType, RequireFields<subscription_rootnotificationArgs, 'id'>>;
  notificationNotificationDeviceSent?: SubscriptionResolver<Array<ResolversTypes['NotificationNotificationDeviceSent']>, "notificationNotificationDeviceSent", ParentType, ContextType, Partial<subscription_rootnotificationNotificationDeviceSentArgs>>;
  notificationNotificationDeviceSentAggregate?: SubscriptionResolver<ResolversTypes['NotificationNotificationDeviceSentAggregate'], "notificationNotificationDeviceSentAggregate", ParentType, ContextType, Partial<subscription_rootnotificationNotificationDeviceSentAggregateArgs>>;
  notificationNotificationDeviceSentByPk?: SubscriptionResolver<Maybe<ResolversTypes['NotificationNotificationDeviceSent']>, "notificationNotificationDeviceSentByPk", ParentType, ContextType, RequireFields<subscription_rootnotificationNotificationDeviceSentByPkArgs, 'id'>>;
  notificationNotificationDeviceSentStream?: SubscriptionResolver<Array<ResolversTypes['NotificationNotificationDeviceSent']>, "notificationNotificationDeviceSentStream", ParentType, ContextType, RequireFields<subscription_rootnotificationNotificationDeviceSentStreamArgs, 'batchSize' | 'cursor'>>;
  notificationNotificationSettingActivityPrimaryEnum?: SubscriptionResolver<Array<ResolversTypes['NotificationNotificationSettingActivityPrimaryEnum']>, "notificationNotificationSettingActivityPrimaryEnum", ParentType, ContextType, Partial<subscription_rootnotificationNotificationSettingActivityPrimaryEnumArgs>>;
  notificationNotificationSettingActivityPrimaryEnumAggregate?: SubscriptionResolver<ResolversTypes['NotificationNotificationSettingActivityPrimaryEnumAggregate'], "notificationNotificationSettingActivityPrimaryEnumAggregate", ParentType, ContextType, Partial<subscription_rootnotificationNotificationSettingActivityPrimaryEnumAggregateArgs>>;
  notificationNotificationSettingActivityPrimaryEnumByPk?: SubscriptionResolver<Maybe<ResolversTypes['NotificationNotificationSettingActivityPrimaryEnum']>, "notificationNotificationSettingActivityPrimaryEnumByPk", ParentType, ContextType, RequireFields<subscription_rootnotificationNotificationSettingActivityPrimaryEnumByPkArgs, 'value'>>;
  notificationNotificationSettingActivityPrimaryEnumStream?: SubscriptionResolver<Array<ResolversTypes['NotificationNotificationSettingActivityPrimaryEnum']>, "notificationNotificationSettingActivityPrimaryEnumStream", ParentType, ContextType, RequireFields<subscription_rootnotificationNotificationSettingActivityPrimaryEnumStreamArgs, 'batchSize' | 'cursor'>>;
  notificationSend?: SubscriptionResolver<Maybe<ResolversTypes['notificationSend']>, "notificationSend", ParentType, ContextType, RequireFields<subscription_rootnotificationSendArgs, 'id'>>;
  notificationSends?: SubscriptionResolver<Array<ResolversTypes['notificationSend']>, "notificationSends", ParentType, ContextType, Partial<subscription_rootnotificationSendsArgs>>;
  notificationSendsAggregate?: SubscriptionResolver<ResolversTypes['notificationSendAggregate'], "notificationSendsAggregate", ParentType, ContextType, Partial<subscription_rootnotificationSendsAggregateArgs>>;
  notificationSendsStream?: SubscriptionResolver<Array<ResolversTypes['notificationSend']>, "notificationSendsStream", ParentType, ContextType, RequireFields<subscription_rootnotificationSendsStreamArgs, 'batchSize' | 'cursor'>>;
  notificationSettingActivities?: SubscriptionResolver<Array<ResolversTypes['notificationSettingActivity']>, "notificationSettingActivities", ParentType, ContextType, Partial<subscription_rootnotificationSettingActivitiesArgs>>;
  notificationSettingActivitiesAggregate?: SubscriptionResolver<ResolversTypes['notificationSettingActivityAggregate'], "notificationSettingActivitiesAggregate", ParentType, ContextType, Partial<subscription_rootnotificationSettingActivitiesAggregateArgs>>;
  notificationSettingActivitiesStream?: SubscriptionResolver<Array<ResolversTypes['notificationSettingActivity']>, "notificationSettingActivitiesStream", ParentType, ContextType, RequireFields<subscription_rootnotificationSettingActivitiesStreamArgs, 'batchSize' | 'cursor'>>;
  notificationSettingActivity?: SubscriptionResolver<Maybe<ResolversTypes['notificationSettingActivity']>, "notificationSettingActivity", ParentType, ContextType, RequireFields<subscription_rootnotificationSettingActivityArgs, 'id'>>;
  notificationUser?: SubscriptionResolver<Maybe<ResolversTypes['notificationUser']>, "notificationUser", ParentType, ContextType, RequireFields<subscription_rootnotificationUserArgs, 'id'>>;
  notificationUserDevice?: SubscriptionResolver<Maybe<ResolversTypes['notificationUserDevice']>, "notificationUserDevice", ParentType, ContextType, RequireFields<subscription_rootnotificationUserDeviceArgs, 'id'>>;
  notificationUserDevices?: SubscriptionResolver<Array<ResolversTypes['notificationUserDevice']>, "notificationUserDevices", ParentType, ContextType, Partial<subscription_rootnotificationUserDevicesArgs>>;
  notificationUserDevicesAggregate?: SubscriptionResolver<ResolversTypes['notificationUserDeviceAggregate'], "notificationUserDevicesAggregate", ParentType, ContextType, Partial<subscription_rootnotificationUserDevicesAggregateArgs>>;
  notificationUserDevicesStream?: SubscriptionResolver<Array<ResolversTypes['notificationUserDevice']>, "notificationUserDevicesStream", ParentType, ContextType, RequireFields<subscription_rootnotificationUserDevicesStreamArgs, 'batchSize' | 'cursor'>>;
  notificationUsers?: SubscriptionResolver<Array<ResolversTypes['notificationUser']>, "notificationUsers", ParentType, ContextType, Partial<subscription_rootnotificationUsersArgs>>;
  notificationUsersAggregate?: SubscriptionResolver<ResolversTypes['notificationUserAggregate'], "notificationUsersAggregate", ParentType, ContextType, Partial<subscription_rootnotificationUsersAggregateArgs>>;
  notificationUsersStream?: SubscriptionResolver<Array<ResolversTypes['notificationUser']>, "notificationUsersStream", ParentType, ContextType, RequireFields<subscription_rootnotificationUsersStreamArgs, 'batchSize' | 'cursor'>>;
  notifications?: SubscriptionResolver<Array<ResolversTypes['notification']>, "notifications", ParentType, ContextType, Partial<subscription_rootnotificationsArgs>>;
  notificationsAggregate?: SubscriptionResolver<ResolversTypes['notificationAggregate'], "notificationsAggregate", ParentType, ContextType, Partial<subscription_rootnotificationsAggregateArgs>>;
  notificationsStream?: SubscriptionResolver<Array<ResolversTypes['notification']>, "notificationsStream", ParentType, ContextType, RequireFields<subscription_rootnotificationsStreamArgs, 'batchSize' | 'cursor'>>;
  ordersIntegration?: SubscriptionResolver<Maybe<ResolversTypes['ordersIntegrations']>, "ordersIntegration", ParentType, ContextType, RequireFields<subscription_rootordersIntegrationArgs, 'id'>>;
  ordersIntegrations?: SubscriptionResolver<Array<ResolversTypes['ordersIntegrations']>, "ordersIntegrations", ParentType, ContextType, Partial<subscription_rootordersIntegrationsArgs>>;
  ordersIntegrationsAggregate?: SubscriptionResolver<ResolversTypes['ordersIntegrationsAggregate'], "ordersIntegrationsAggregate", ParentType, ContextType, Partial<subscription_rootordersIntegrationsAggregateArgs>>;
  ordersIntegrationsStream?: SubscriptionResolver<Array<ResolversTypes['ordersIntegrations']>, "ordersIntegrationsStream", ParentType, ContextType, RequireFields<subscription_rootordersIntegrationsStreamArgs, 'batchSize' | 'cursor'>>;
  ordersOrganizations?: SubscriptionResolver<Array<ResolversTypes['OrdersOrganizations']>, "ordersOrganizations", ParentType, ContextType, Partial<subscription_rootordersOrganizationsArgs>>;
  ordersOrganizationsAggregate?: SubscriptionResolver<ResolversTypes['OrdersOrganizationsAggregate'], "ordersOrganizationsAggregate", ParentType, ContextType, Partial<subscription_rootordersOrganizationsAggregateArgs>>;
  ordersOrganizationsByPk?: SubscriptionResolver<Maybe<ResolversTypes['OrdersOrganizations']>, "ordersOrganizationsByPk", ParentType, ContextType, RequireFields<subscription_rootordersOrganizationsByPkArgs, 'id'>>;
  ordersOrganizationsStream?: SubscriptionResolver<Array<ResolversTypes['OrdersOrganizations']>, "ordersOrganizationsStream", ParentType, ContextType, RequireFields<subscription_rootordersOrganizationsStreamArgs, 'batchSize' | 'cursor'>>;
  ordersRequest?: SubscriptionResolver<Array<ResolversTypes['OrdersRequest']>, "ordersRequest", ParentType, ContextType, Partial<subscription_rootordersRequestArgs>>;
  ordersRequestAggregate?: SubscriptionResolver<ResolversTypes['OrdersRequestAggregate'], "ordersRequestAggregate", ParentType, ContextType, Partial<subscription_rootordersRequestAggregateArgs>>;
  ordersRequestByPk?: SubscriptionResolver<Maybe<ResolversTypes['OrdersRequest']>, "ordersRequestByPk", ParentType, ContextType, RequireFields<subscription_rootordersRequestByPkArgs, 'value'>>;
  ordersRequestStream?: SubscriptionResolver<Array<ResolversTypes['OrdersRequest']>, "ordersRequestStream", ParentType, ContextType, RequireFields<subscription_rootordersRequestStreamArgs, 'batchSize' | 'cursor'>>;
  ordersStatus?: SubscriptionResolver<Array<ResolversTypes['OrdersStatus']>, "ordersStatus", ParentType, ContextType, Partial<subscription_rootordersStatusArgs>>;
  ordersStatusAggregate?: SubscriptionResolver<ResolversTypes['OrdersStatusAggregate'], "ordersStatusAggregate", ParentType, ContextType, Partial<subscription_rootordersStatusAggregateArgs>>;
  ordersStatusByPk?: SubscriptionResolver<Maybe<ResolversTypes['OrdersStatus']>, "ordersStatusByPk", ParentType, ContextType, RequireFields<subscription_rootordersStatusByPkArgs, 'value'>>;
  ordersStatusStream?: SubscriptionResolver<Array<ResolversTypes['OrdersStatus']>, "ordersStatusStream", ParentType, ContextType, RequireFields<subscription_rootordersStatusStreamArgs, 'batchSize' | 'cursor'>>;
  ordersType?: SubscriptionResolver<Array<ResolversTypes['OrdersType']>, "ordersType", ParentType, ContextType, Partial<subscription_rootordersTypeArgs>>;
  ordersTypeAggregate?: SubscriptionResolver<ResolversTypes['OrdersTypeAggregate'], "ordersTypeAggregate", ParentType, ContextType, Partial<subscription_rootordersTypeAggregateArgs>>;
  ordersTypeByPk?: SubscriptionResolver<Maybe<ResolversTypes['OrdersType']>, "ordersTypeByPk", ParentType, ContextType, RequireFields<subscription_rootordersTypeByPkArgs, 'value'>>;
  ordersTypeStream?: SubscriptionResolver<Array<ResolversTypes['OrdersType']>, "ordersTypeStream", ParentType, ContextType, RequireFields<subscription_rootordersTypeStreamArgs, 'batchSize' | 'cursor'>>;
  organization?: SubscriptionResolver<Maybe<ResolversTypes['organization']>, "organization", ParentType, ContextType, RequireFields<subscription_rootorganizationArgs, 'id'>>;
  organizationAuthorizationEnumGroup?: SubscriptionResolver<Maybe<ResolversTypes['organizationAuthorizationEnumGroup']>, "organizationAuthorizationEnumGroup", ParentType, ContextType, RequireFields<subscription_rootorganizationAuthorizationEnumGroupArgs, 'id'>>;
  organizationAuthorizationEnumGroupStream?: SubscriptionResolver<Array<ResolversTypes['organizationAuthorizationEnumGroup']>, "organizationAuthorizationEnumGroupStream", ParentType, ContextType, RequireFields<subscription_rootorganizationAuthorizationEnumGroupStreamArgs, 'batchSize' | 'cursor'>>;
  organizationAuthorizationEnumGroups?: SubscriptionResolver<Array<ResolversTypes['organizationAuthorizationEnumGroup']>, "organizationAuthorizationEnumGroups", ParentType, ContextType, Partial<subscription_rootorganizationAuthorizationEnumGroupsArgs>>;
  organizationAuthorizationGroup?: SubscriptionResolver<Maybe<ResolversTypes['organizationAuthorizationGroup']>, "organizationAuthorizationGroup", ParentType, ContextType, RequireFields<subscription_rootorganizationAuthorizationGroupArgs, 'id'>>;
  organizationAuthorizationGroupStream?: SubscriptionResolver<Array<ResolversTypes['organizationAuthorizationGroup']>, "organizationAuthorizationGroupStream", ParentType, ContextType, RequireFields<subscription_rootorganizationAuthorizationGroupStreamArgs, 'batchSize' | 'cursor'>>;
  organizationAuthorizationGroups?: SubscriptionResolver<Array<ResolversTypes['organizationAuthorizationGroup']>, "organizationAuthorizationGroups", ParentType, ContextType, Partial<subscription_rootorganizationAuthorizationGroupsArgs>>;
  organizationOrganizationRelationship?: SubscriptionResolver<Maybe<ResolversTypes['organizationOrganizationRelationship']>, "organizationOrganizationRelationship", ParentType, ContextType, RequireFields<subscription_rootorganizationOrganizationRelationshipArgs, 'id'>>;
  organizationOrganizationRelationshipCategories?: SubscriptionResolver<Array<ResolversTypes['organizationOrganizationRelationshipCategory']>, "organizationOrganizationRelationshipCategories", ParentType, ContextType, Partial<subscription_rootorganizationOrganizationRelationshipCategoriesArgs>>;
  organizationOrganizationRelationshipCategory?: SubscriptionResolver<Maybe<ResolversTypes['organizationOrganizationRelationshipCategory']>, "organizationOrganizationRelationshipCategory", ParentType, ContextType, RequireFields<subscription_rootorganizationOrganizationRelationshipCategoryArgs, 'value'>>;
  organizationOrganizationRelationshipCategoryStream?: SubscriptionResolver<Array<ResolversTypes['organizationOrganizationRelationshipCategory']>, "organizationOrganizationRelationshipCategoryStream", ParentType, ContextType, RequireFields<subscription_rootorganizationOrganizationRelationshipCategoryStreamArgs, 'batchSize' | 'cursor'>>;
  organizationOrganizationRelationshipStream?: SubscriptionResolver<Array<ResolversTypes['organizationOrganizationRelationship']>, "organizationOrganizationRelationshipStream", ParentType, ContextType, RequireFields<subscription_rootorganizationOrganizationRelationshipStreamArgs, 'batchSize' | 'cursor'>>;
  organizationOrganizationRelationships?: SubscriptionResolver<Array<ResolversTypes['organizationOrganizationRelationship']>, "organizationOrganizationRelationships", ParentType, ContextType, Partial<subscription_rootorganizationOrganizationRelationshipsArgs>>;
  organizationOrganizationUserAuthorization?: SubscriptionResolver<Maybe<ResolversTypes['organizationOrganizationUserAuthorization']>, "organizationOrganizationUserAuthorization", ParentType, ContextType, RequireFields<subscription_rootorganizationOrganizationUserAuthorizationArgs, 'id'>>;
  organizationOrganizationUserAuthorizationStream?: SubscriptionResolver<Array<ResolversTypes['organizationOrganizationUserAuthorization']>, "organizationOrganizationUserAuthorizationStream", ParentType, ContextType, RequireFields<subscription_rootorganizationOrganizationUserAuthorizationStreamArgs, 'batchSize' | 'cursor'>>;
  organizationOrganizationUserAuthorizations?: SubscriptionResolver<Array<ResolversTypes['organizationOrganizationUserAuthorization']>, "organizationOrganizationUserAuthorizations", ParentType, ContextType, Partial<subscription_rootorganizationOrganizationUserAuthorizationsArgs>>;
  organizationOrganizationUserOrganizationsViewStream?: SubscriptionResolver<Array<ResolversTypes['organizationOrganizationUserOrganizationsView']>, "organizationOrganizationUserOrganizationsViewStream", ParentType, ContextType, RequireFields<subscription_rootorganizationOrganizationUserOrganizationsViewStreamArgs, 'batchSize' | 'cursor'>>;
  organizationOrganizationUserOrganizationsViews?: SubscriptionResolver<Array<ResolversTypes['organizationOrganizationUserOrganizationsView']>, "organizationOrganizationUserOrganizationsViews", ParentType, ContextType, Partial<subscription_rootorganizationOrganizationUserOrganizationsViewsArgs>>;
  organizationOrganizationUserUsersViewStream?: SubscriptionResolver<Array<ResolversTypes['organizationOrganizationUserUsersView']>, "organizationOrganizationUserUsersViewStream", ParentType, ContextType, RequireFields<subscription_rootorganizationOrganizationUserUsersViewStreamArgs, 'batchSize' | 'cursor'>>;
  organizationOrganizationUserUsersViews?: SubscriptionResolver<Array<ResolversTypes['organizationOrganizationUserUsersView']>, "organizationOrganizationUserUsersViews", ParentType, ContextType, Partial<subscription_rootorganizationOrganizationUserUsersViewsArgs>>;
  organizationUser?: SubscriptionResolver<Maybe<ResolversTypes['organizationUser']>, "organizationUser", ParentType, ContextType, RequireFields<subscription_rootorganizationUserArgs, 'id'>>;
  organizationUserAttachment?: SubscriptionResolver<Maybe<ResolversTypes['organizationUserAttachments']>, "organizationUserAttachment", ParentType, ContextType, RequireFields<subscription_rootorganizationUserAttachmentArgs, 'id'>>;
  organizationUserAttachments?: SubscriptionResolver<Array<ResolversTypes['organizationUserAttachments']>, "organizationUserAttachments", ParentType, ContextType, Partial<subscription_rootorganizationUserAttachmentsArgs>>;
  organizationUserAttachmentsAggregate?: SubscriptionResolver<ResolversTypes['organizationUserAttachmentsAggregate'], "organizationUserAttachmentsAggregate", ParentType, ContextType, Partial<subscription_rootorganizationUserAttachmentsAggregateArgs>>;
  organizationUserAttachmentsStream?: SubscriptionResolver<Array<ResolversTypes['organizationUserAttachments']>, "organizationUserAttachmentsStream", ParentType, ContextType, RequireFields<subscription_rootorganizationUserAttachmentsStreamArgs, 'batchSize' | 'cursor'>>;
  organizationUserAttentionNote?: SubscriptionResolver<Maybe<ResolversTypes['OrganizationUserAttentionNote']>, "organizationUserAttentionNote", ParentType, ContextType, RequireFields<subscription_rootorganizationUserAttentionNoteArgs, 'id'>>;
  organizationUserAttentionNoteAggregate?: SubscriptionResolver<ResolversTypes['OrganizationUserAttentionNoteAggregate'], "organizationUserAttentionNoteAggregate", ParentType, ContextType, Partial<subscription_rootorganizationUserAttentionNoteAggregateArgs>>;
  organizationUserAttentionNoteStream?: SubscriptionResolver<Array<ResolversTypes['OrganizationUserAttentionNote']>, "organizationUserAttentionNoteStream", ParentType, ContextType, RequireFields<subscription_rootorganizationUserAttentionNoteStreamArgs, 'batchSize' | 'cursor'>>;
  organizationUserAttentionNotes?: SubscriptionResolver<Array<ResolversTypes['OrganizationUserAttentionNote']>, "organizationUserAttentionNotes", ParentType, ContextType, Partial<subscription_rootorganizationUserAttentionNotesArgs>>;
  organizationUserAuthorization?: SubscriptionResolver<Maybe<ResolversTypes['organizationUserAuthorization']>, "organizationUserAuthorization", ParentType, ContextType, RequireFields<subscription_rootorganizationUserAuthorizationArgs, 'value'>>;
  organizationUserAuthorizationStream?: SubscriptionResolver<Array<ResolversTypes['organizationUserAuthorization']>, "organizationUserAuthorizationStream", ParentType, ContextType, RequireFields<subscription_rootorganizationUserAuthorizationStreamArgs, 'batchSize' | 'cursor'>>;
  organizationUserAuthorizations?: SubscriptionResolver<Array<ResolversTypes['organizationUserAuthorization']>, "organizationUserAuthorizations", ParentType, ContextType, Partial<subscription_rootorganizationUserAuthorizationsArgs>>;
  organizationUserDetail?: SubscriptionResolver<Maybe<ResolversTypes['organizationUserDetail']>, "organizationUserDetail", ParentType, ContextType, RequireFields<subscription_rootorganizationUserDetailArgs, 'id'>>;
  organizationUserDetailType?: SubscriptionResolver<Maybe<ResolversTypes['organizationUserDetailType']>, "organizationUserDetailType", ParentType, ContextType, RequireFields<subscription_rootorganizationUserDetailTypeArgs, 'value'>>;
  organizationUserDetailTypes?: SubscriptionResolver<Array<ResolversTypes['organizationUserDetailType']>, "organizationUserDetailTypes", ParentType, ContextType, Partial<subscription_rootorganizationUserDetailTypesArgs>>;
  organizationUserDetailTypesAggregate?: SubscriptionResolver<ResolversTypes['organizationUserDetailTypeAggregate'], "organizationUserDetailTypesAggregate", ParentType, ContextType, Partial<subscription_rootorganizationUserDetailTypesAggregateArgs>>;
  organizationUserDetailTypesStream?: SubscriptionResolver<Array<ResolversTypes['organizationUserDetailType']>, "organizationUserDetailTypesStream", ParentType, ContextType, RequireFields<subscription_rootorganizationUserDetailTypesStreamArgs, 'batchSize' | 'cursor'>>;
  organizationUserDetails?: SubscriptionResolver<Array<ResolversTypes['organizationUserDetail']>, "organizationUserDetails", ParentType, ContextType, Partial<subscription_rootorganizationUserDetailsArgs>>;
  organizationUserDetailsAggregate?: SubscriptionResolver<ResolversTypes['organizationUserDetailAggregate'], "organizationUserDetailsAggregate", ParentType, ContextType, Partial<subscription_rootorganizationUserDetailsAggregateArgs>>;
  organizationUserDetailsStream?: SubscriptionResolver<Array<ResolversTypes['organizationUserDetail']>, "organizationUserDetailsStream", ParentType, ContextType, RequireFields<subscription_rootorganizationUserDetailsStreamArgs, 'batchSize' | 'cursor'>>;
  organizationUserInvite?: SubscriptionResolver<Maybe<ResolversTypes['organizationUserInvite']>, "organizationUserInvite", ParentType, ContextType, RequireFields<subscription_rootorganizationUserInviteArgs, 'id'>>;
  organizationUserInviteStream?: SubscriptionResolver<Array<ResolversTypes['organizationUserInvite']>, "organizationUserInviteStream", ParentType, ContextType, RequireFields<subscription_rootorganizationUserInviteStreamArgs, 'batchSize' | 'cursor'>>;
  organizationUserInvites?: SubscriptionResolver<Array<ResolversTypes['organizationUserInvite']>, "organizationUserInvites", ParentType, ContextType, Partial<subscription_rootorganizationUserInvitesArgs>>;
  organizationUserInvitesAggregate?: SubscriptionResolver<ResolversTypes['organizationUserInviteAggregate'], "organizationUserInvitesAggregate", ParentType, ContextType, Partial<subscription_rootorganizationUserInvitesAggregateArgs>>;
  organizationUserRequest?: SubscriptionResolver<Maybe<ResolversTypes['BusinessOrganizationUserRequest']>, "organizationUserRequest", ParentType, ContextType, RequireFields<subscription_rootorganizationUserRequestArgs, 'id'>>;
  organizationUserRequests?: SubscriptionResolver<Array<ResolversTypes['BusinessOrganizationUserRequest']>, "organizationUserRequests", ParentType, ContextType, Partial<subscription_rootorganizationUserRequestsArgs>>;
  organizationUserStatus?: SubscriptionResolver<Maybe<ResolversTypes['organizationUserStatus']>, "organizationUserStatus", ParentType, ContextType, RequireFields<subscription_rootorganizationUserStatusArgs, 'value'>>;
  organizationUserStatuses?: SubscriptionResolver<Array<ResolversTypes['organizationUserStatus']>, "organizationUserStatuses", ParentType, ContextType, Partial<subscription_rootorganizationUserStatusesArgs>>;
  organizationUserStatusesAggregate?: SubscriptionResolver<ResolversTypes['organizationUserStatusAggregate'], "organizationUserStatusesAggregate", ParentType, ContextType, Partial<subscription_rootorganizationUserStatusesAggregateArgs>>;
  organizationUserStatusesStream?: SubscriptionResolver<Array<ResolversTypes['organizationUserStatus']>, "organizationUserStatusesStream", ParentType, ContextType, RequireFields<subscription_rootorganizationUserStatusesStreamArgs, 'batchSize' | 'cursor'>>;
  organizationUsers?: SubscriptionResolver<Array<ResolversTypes['organizationUser']>, "organizationUsers", ParentType, ContextType, Partial<subscription_rootorganizationUsersArgs>>;
  organizationUsersAggregate?: SubscriptionResolver<ResolversTypes['organizationUserAggregate'], "organizationUsersAggregate", ParentType, ContextType, Partial<subscription_rootorganizationUsersAggregateArgs>>;
  organizationUsersStream?: SubscriptionResolver<Array<ResolversTypes['organizationUser']>, "organizationUsersStream", ParentType, ContextType, RequireFields<subscription_rootorganizationUsersStreamArgs, 'batchSize' | 'cursor'>>;
  organizations?: SubscriptionResolver<Array<ResolversTypes['organization']>, "organizations", ParentType, ContextType, Partial<subscription_rootorganizationsArgs>>;
  organizationsAggregate?: SubscriptionResolver<ResolversTypes['organizationAggregate'], "organizationsAggregate", ParentType, ContextType, Partial<subscription_rootorganizationsAggregateArgs>>;
  organizationsStream?: SubscriptionResolver<Array<ResolversTypes['organization']>, "organizationsStream", ParentType, ContextType, RequireFields<subscription_rootorganizationsStreamArgs, 'batchSize' | 'cursor'>>;
  phoneNumberVerificationStatus?: SubscriptionResolver<Maybe<ResolversTypes['phoneNumberVerificationStatus']>, "phoneNumberVerificationStatus", ParentType, ContextType, RequireFields<subscription_rootphoneNumberVerificationStatusArgs, 'value'>>;
  phoneNumberVerificationStatusStream?: SubscriptionResolver<Array<ResolversTypes['phoneNumberVerificationStatus']>, "phoneNumberVerificationStatusStream", ParentType, ContextType, RequireFields<subscription_rootphoneNumberVerificationStatusStreamArgs, 'batchSize' | 'cursor'>>;
  phoneNumberVerificationStatuses?: SubscriptionResolver<Array<ResolversTypes['phoneNumberVerificationStatus']>, "phoneNumberVerificationStatuses", ParentType, ContextType, Partial<subscription_rootphoneNumberVerificationStatusesArgs>>;
  phoneNumberVerificationStatusesAggregate?: SubscriptionResolver<ResolversTypes['phoneNumberVerificationStatusAggregate'], "phoneNumberVerificationStatusesAggregate", ParentType, ContextType, Partial<subscription_rootphoneNumberVerificationStatusesAggregateArgs>>;
  prompt?: SubscriptionResolver<Array<ResolversTypes['Prompt']>, "prompt", ParentType, ContextType, Partial<subscription_rootpromptArgs>>;
  promptAggregate?: SubscriptionResolver<ResolversTypes['PromptAggregate'], "promptAggregate", ParentType, ContextType, Partial<subscription_rootpromptAggregateArgs>>;
  promptByPk?: SubscriptionResolver<Maybe<ResolversTypes['Prompt']>, "promptByPk", ParentType, ContextType, RequireFields<subscription_rootpromptByPkArgs, 'id'>>;
  promptStream?: SubscriptionResolver<Array<ResolversTypes['Prompt']>, "promptStream", ParentType, ContextType, RequireFields<subscription_rootpromptStreamArgs, 'batchSize' | 'cursor'>>;
  publicDevice?: SubscriptionResolver<Maybe<ResolversTypes['publicDevice']>, "publicDevice", ParentType, ContextType, RequireFields<subscription_rootpublicDeviceArgs, 'id'>>;
  publicDeviceStream?: SubscriptionResolver<Array<ResolversTypes['publicDevice']>, "publicDeviceStream", ParentType, ContextType, RequireFields<subscription_rootpublicDeviceStreamArgs, 'batchSize' | 'cursor'>>;
  publicDevices?: SubscriptionResolver<Array<ResolversTypes['publicDevice']>, "publicDevices", ParentType, ContextType, Partial<subscription_rootpublicDevicesArgs>>;
  publicExternalRequest?: SubscriptionResolver<Maybe<ResolversTypes['publicExternalRequest']>, "publicExternalRequest", ParentType, ContextType, RequireFields<subscription_rootpublicExternalRequestArgs, 'id'>>;
  publicExternalRequestStream?: SubscriptionResolver<Array<ResolversTypes['publicExternalRequest']>, "publicExternalRequestStream", ParentType, ContextType, RequireFields<subscription_rootpublicExternalRequestStreamArgs, 'batchSize' | 'cursor'>>;
  publicExternalRequests?: SubscriptionResolver<Array<ResolversTypes['publicExternalRequest']>, "publicExternalRequests", ParentType, ContextType, Partial<subscription_rootpublicExternalRequestsArgs>>;
  publicFile?: SubscriptionResolver<Maybe<ResolversTypes['publicFile']>, "publicFile", ParentType, ContextType, RequireFields<subscription_rootpublicFileArgs, 'id'>>;
  publicFileStream?: SubscriptionResolver<Array<ResolversTypes['publicFile']>, "publicFileStream", ParentType, ContextType, RequireFields<subscription_rootpublicFileStreamArgs, 'batchSize' | 'cursor'>>;
  publicFiles?: SubscriptionResolver<Array<ResolversTypes['publicFile']>, "publicFiles", ParentType, ContextType, Partial<subscription_rootpublicFilesArgs>>;
  publicNotification?: SubscriptionResolver<Maybe<ResolversTypes['publicNotification']>, "publicNotification", ParentType, ContextType, RequireFields<subscription_rootpublicNotificationArgs, 'id'>>;
  publicNotificationStream?: SubscriptionResolver<Array<ResolversTypes['publicNotification']>, "publicNotificationStream", ParentType, ContextType, RequireFields<subscription_rootpublicNotificationStreamArgs, 'batchSize' | 'cursor'>>;
  publicNotifications?: SubscriptionResolver<Array<ResolversTypes['publicNotification']>, "publicNotifications", ParentType, ContextType, Partial<subscription_rootpublicNotificationsArgs>>;
  queueItem?: SubscriptionResolver<Maybe<ResolversTypes['queueItem']>, "queueItem", ParentType, ContextType, RequireFields<subscription_rootqueueItemArgs, 'id'>>;
  queueItems?: SubscriptionResolver<Array<ResolversTypes['queueItem']>, "queueItems", ParentType, ContextType, Partial<subscription_rootqueueItemsArgs>>;
  queueItemsAggregate?: SubscriptionResolver<ResolversTypes['queueItemAggregate'], "queueItemsAggregate", ParentType, ContextType, Partial<subscription_rootqueueItemsAggregateArgs>>;
  queueItemsStream?: SubscriptionResolver<Array<ResolversTypes['queueItem']>, "queueItemsStream", ParentType, ContextType, RequireFields<subscription_rootqueueItemsStreamArgs, 'batchSize' | 'cursor'>>;
  relOrganizationUserDomainUser?: SubscriptionResolver<Maybe<ResolversTypes['relOrganizationUserDomainUser']>, "relOrganizationUserDomainUser", ParentType, ContextType, RequireFields<subscription_rootrelOrganizationUserDomainUserArgs, 'id'>>;
  relOrganizationUserDomainUsers?: SubscriptionResolver<Array<ResolversTypes['relOrganizationUserDomainUser']>, "relOrganizationUserDomainUsers", ParentType, ContextType, Partial<subscription_rootrelOrganizationUserDomainUsersArgs>>;
  relOrganizationUserDomainUsersAggregate?: SubscriptionResolver<ResolversTypes['relOrganizationUserDomainUserAggregate'], "relOrganizationUserDomainUsersAggregate", ParentType, ContextType, Partial<subscription_rootrelOrganizationUserDomainUsersAggregateArgs>>;
  relOrganizationUserDomainUsersStream?: SubscriptionResolver<Array<ResolversTypes['relOrganizationUserDomainUser']>, "relOrganizationUserDomainUsersStream", ParentType, ContextType, RequireFields<subscription_rootrelOrganizationUserDomainUsersStreamArgs, 'batchSize' | 'cursor'>>;
  smsConnector?: SubscriptionResolver<Maybe<ResolversTypes['smsConnector']>, "smsConnector", ParentType, ContextType, RequireFields<subscription_rootsmsConnectorArgs, 'id'>>;
  smsConnectorStream?: SubscriptionResolver<Array<ResolversTypes['smsConnector']>, "smsConnectorStream", ParentType, ContextType, RequireFields<subscription_rootsmsConnectorStreamArgs, 'batchSize' | 'cursor'>>;
  smsConnectors?: SubscriptionResolver<Array<ResolversTypes['smsConnector']>, "smsConnectors", ParentType, ContextType, Partial<subscription_rootsmsConnectorsArgs>>;
  smsGate?: SubscriptionResolver<Maybe<ResolversTypes['smsGate']>, "smsGate", ParentType, ContextType, RequireFields<subscription_rootsmsGateArgs, 'id'>>;
  smsGateStream?: SubscriptionResolver<Array<ResolversTypes['smsGate']>, "smsGateStream", ParentType, ContextType, RequireFields<subscription_rootsmsGateStreamArgs, 'batchSize' | 'cursor'>>;
  smsGates?: SubscriptionResolver<Array<ResolversTypes['smsGate']>, "smsGates", ParentType, ContextType, Partial<subscription_rootsmsGatesArgs>>;
  smsLinkMobilitySmsContent?: SubscriptionResolver<Maybe<ResolversTypes['smsLinkMobilitySmsContent']>, "smsLinkMobilitySmsContent", ParentType, ContextType, RequireFields<subscription_rootsmsLinkMobilitySmsContentArgs, 'uuid'>>;
  smsLinkMobilitySmsContentStream?: SubscriptionResolver<Array<ResolversTypes['smsLinkMobilitySmsContent']>, "smsLinkMobilitySmsContentStream", ParentType, ContextType, RequireFields<subscription_rootsmsLinkMobilitySmsContentStreamArgs, 'batchSize' | 'cursor'>>;
  smsLinkMobilitySmsContents?: SubscriptionResolver<Array<ResolversTypes['smsLinkMobilitySmsContent']>, "smsLinkMobilitySmsContents", ParentType, ContextType, Partial<subscription_rootsmsLinkMobilitySmsContentsArgs>>;
  smsLinkMobilitySmsMessage?: SubscriptionResolver<Maybe<ResolversTypes['smsLinkMobilitySmsMessage']>, "smsLinkMobilitySmsMessage", ParentType, ContextType, RequireFields<subscription_rootsmsLinkMobilitySmsMessageArgs, 'uuid'>>;
  smsLinkMobilitySmsMessageStream?: SubscriptionResolver<Array<ResolversTypes['smsLinkMobilitySmsMessage']>, "smsLinkMobilitySmsMessageStream", ParentType, ContextType, RequireFields<subscription_rootsmsLinkMobilitySmsMessageStreamArgs, 'batchSize' | 'cursor'>>;
  smsLinkMobilitySmsMessages?: SubscriptionResolver<Array<ResolversTypes['smsLinkMobilitySmsMessage']>, "smsLinkMobilitySmsMessages", ParentType, ContextType, Partial<subscription_rootsmsLinkMobilitySmsMessagesArgs>>;
  smsLinkMobilitySmsRoute?: SubscriptionResolver<Maybe<ResolversTypes['smsLinkMobilitySmsRoute']>, "smsLinkMobilitySmsRoute", ParentType, ContextType, RequireFields<subscription_rootsmsLinkMobilitySmsRouteArgs, 'uuid'>>;
  smsLinkMobilitySmsRouteStream?: SubscriptionResolver<Array<ResolversTypes['smsLinkMobilitySmsRoute']>, "smsLinkMobilitySmsRouteStream", ParentType, ContextType, RequireFields<subscription_rootsmsLinkMobilitySmsRouteStreamArgs, 'batchSize' | 'cursor'>>;
  smsLinkMobilitySmsRoutes?: SubscriptionResolver<Array<ResolversTypes['smsLinkMobilitySmsRoute']>, "smsLinkMobilitySmsRoutes", ParentType, ContextType, Partial<subscription_rootsmsLinkMobilitySmsRoutesArgs>>;
  smsProvider?: SubscriptionResolver<Maybe<ResolversTypes['smsProvider']>, "smsProvider", ParentType, ContextType, RequireFields<subscription_rootsmsProviderArgs, 'id'>>;
  smsProviderStream?: SubscriptionResolver<Array<ResolversTypes['smsProvider']>, "smsProviderStream", ParentType, ContextType, RequireFields<subscription_rootsmsProviderStreamArgs, 'batchSize' | 'cursor'>>;
  smsProviders?: SubscriptionResolver<Array<ResolversTypes['smsProvider']>, "smsProviders", ParentType, ContextType, Partial<subscription_rootsmsProvidersArgs>>;
  smsSm?: SubscriptionResolver<Maybe<ResolversTypes['smsSm']>, "smsSm", ParentType, ContextType, RequireFields<subscription_rootsmsSmArgs, 'id'>>;
  smsSmStream?: SubscriptionResolver<Array<ResolversTypes['smsSm']>, "smsSmStream", ParentType, ContextType, RequireFields<subscription_rootsmsSmStreamArgs, 'batchSize' | 'cursor'>>;
  smsSms?: SubscriptionResolver<Array<ResolversTypes['smsSm']>, "smsSms", ParentType, ContextType, Partial<subscription_rootsmsSmsArgs>>;
  smsSmsExternalIncomingLinkMobilities?: SubscriptionResolver<Array<ResolversTypes['smsSmsExternalIncomingLinkMobility']>, "smsSmsExternalIncomingLinkMobilities", ParentType, ContextType, Partial<subscription_rootsmsSmsExternalIncomingLinkMobilitiesArgs>>;
  smsSmsExternalIncomingLinkMobility?: SubscriptionResolver<Maybe<ResolversTypes['smsSmsExternalIncomingLinkMobility']>, "smsSmsExternalIncomingLinkMobility", ParentType, ContextType, RequireFields<subscription_rootsmsSmsExternalIncomingLinkMobilityArgs, 'uuid'>>;
  smsSmsExternalIncomingLinkMobilityStream?: SubscriptionResolver<Array<ResolversTypes['smsSmsExternalIncomingLinkMobility']>, "smsSmsExternalIncomingLinkMobilityStream", ParentType, ContextType, RequireFields<subscription_rootsmsSmsExternalIncomingLinkMobilityStreamArgs, 'batchSize' | 'cursor'>>;
  streamBusinessUserContacts?: SubscriptionResolver<Array<ResolversTypes['businessUserContacts']>, "streamBusinessUserContacts", ParentType, ContextType, RequireFields<subscription_rootstreamBusinessUserContactsArgs, 'batchSize' | 'cursor'>>;
  streamBusinessUserSettings?: SubscriptionResolver<Array<ResolversTypes['businessUserSettings']>, "streamBusinessUserSettings", ParentType, ContextType, RequireFields<subscription_rootstreamBusinessUserSettingsArgs, 'batchSize' | 'cursor'>>;
  task?: SubscriptionResolver<Maybe<ResolversTypes['tasksubscription_root']>, "task", ParentType, ContextType>;
  telephony?: SubscriptionResolver<Maybe<ResolversTypes['telephonysubscription_root']>, "telephony", ParentType, ContextType>;
  user?: SubscriptionResolver<Maybe<ResolversTypes['user']>, "user", ParentType, ContextType, RequireFields<subscription_rootuserArgs, 'id'>>;
  userDetail?: SubscriptionResolver<Maybe<ResolversTypes['userDetail']>, "userDetail", ParentType, ContextType, RequireFields<subscription_rootuserDetailArgs, 'id'>>;
  userDetailStream?: SubscriptionResolver<Array<ResolversTypes['userDetail']>, "userDetailStream", ParentType, ContextType, RequireFields<subscription_rootuserDetailStreamArgs, 'batchSize' | 'cursor'>>;
  userDetails?: SubscriptionResolver<Array<ResolversTypes['userDetail']>, "userDetails", ParentType, ContextType, Partial<subscription_rootuserDetailsArgs>>;
  userDetailsAggregate?: SubscriptionResolver<ResolversTypes['userDetailAggregate'], "userDetailsAggregate", ParentType, ContextType, Partial<subscription_rootuserDetailsAggregateArgs>>;
  userDetailsType?: SubscriptionResolver<Maybe<ResolversTypes['userDetailsType']>, "userDetailsType", ParentType, ContextType, RequireFields<subscription_rootuserDetailsTypeArgs, 'value'>>;
  userDetailsTypes?: SubscriptionResolver<Array<ResolversTypes['userDetailsType']>, "userDetailsTypes", ParentType, ContextType, Partial<subscription_rootuserDetailsTypesArgs>>;
  userDetailsTypesAggregate?: SubscriptionResolver<ResolversTypes['userDetailsTypeAggregate'], "userDetailsTypesAggregate", ParentType, ContextType, Partial<subscription_rootuserDetailsTypesAggregateArgs>>;
  userDetailsTypesStream?: SubscriptionResolver<Array<ResolversTypes['userDetailsType']>, "userDetailsTypesStream", ParentType, ContextType, RequireFields<subscription_rootuserDetailsTypesStreamArgs, 'batchSize' | 'cursor'>>;
  userDevice?: SubscriptionResolver<Maybe<ResolversTypes['userDevice']>, "userDevice", ParentType, ContextType, RequireFields<subscription_rootuserDeviceArgs, 'id'>>;
  userDevices?: SubscriptionResolver<Array<ResolversTypes['userDevice']>, "userDevices", ParentType, ContextType, Partial<subscription_rootuserDevicesArgs>>;
  userDevicesAggregate?: SubscriptionResolver<ResolversTypes['userDeviceAggregate'], "userDevicesAggregate", ParentType, ContextType, Partial<subscription_rootuserDevicesAggregateArgs>>;
  userDevicesStream?: SubscriptionResolver<Array<ResolversTypes['userDevice']>, "userDevicesStream", ParentType, ContextType, RequireFields<subscription_rootuserDevicesStreamArgs, 'batchSize' | 'cursor'>>;
  userPhoneNumber?: SubscriptionResolver<Maybe<ResolversTypes['userPhoneNumber']>, "userPhoneNumber", ParentType, ContextType, RequireFields<subscription_rootuserPhoneNumberArgs, 'id'>>;
  userPhoneNumbers?: SubscriptionResolver<Array<ResolversTypes['userPhoneNumber']>, "userPhoneNumbers", ParentType, ContextType, Partial<subscription_rootuserPhoneNumbersArgs>>;
  userPhoneNumbersAggregate?: SubscriptionResolver<ResolversTypes['userPhoneNumberAggregate'], "userPhoneNumbersAggregate", ParentType, ContextType, Partial<subscription_rootuserPhoneNumbersAggregateArgs>>;
  userPhoneNumbersStream?: SubscriptionResolver<Array<ResolversTypes['userPhoneNumber']>, "userPhoneNumbersStream", ParentType, ContextType, RequireFields<subscription_rootuserPhoneNumbersStreamArgs, 'batchSize' | 'cursor'>>;
  userRole?: SubscriptionResolver<Maybe<ResolversTypes['userRole']>, "userRole", ParentType, ContextType, RequireFields<subscription_rootuserRoleArgs, 'value'>>;
  userRoles?: SubscriptionResolver<Array<ResolversTypes['userRole']>, "userRoles", ParentType, ContextType, Partial<subscription_rootuserRolesArgs>>;
  userRolesAggregate?: SubscriptionResolver<ResolversTypes['userRoleAggregate'], "userRolesAggregate", ParentType, ContextType, Partial<subscription_rootuserRolesAggregateArgs>>;
  userRolesStream?: SubscriptionResolver<Array<ResolversTypes['userRole']>, "userRolesStream", ParentType, ContextType, RequireFields<subscription_rootuserRolesStreamArgs, 'batchSize' | 'cursor'>>;
  users?: SubscriptionResolver<Array<ResolversTypes['user']>, "users", ParentType, ContextType, Partial<subscription_rootusersArgs>>;
  usersAggregate?: SubscriptionResolver<ResolversTypes['userAggregate'], "usersAggregate", ParentType, ContextType, Partial<subscription_rootusersAggregateArgs>>;
  usersStream?: SubscriptionResolver<Array<ResolversTypes['user']>, "usersStream", ParentType, ContextType, RequireFields<subscription_rootusersStreamArgs, 'batchSize' | 'cursor'>>;
  validationValidation?: SubscriptionResolver<Maybe<ResolversTypes['validationValidation']>, "validationValidation", ParentType, ContextType, RequireFields<subscription_rootvalidationValidationArgs, 'id'>>;
  validationValidationStream?: SubscriptionResolver<Array<ResolversTypes['validationValidation']>, "validationValidationStream", ParentType, ContextType, RequireFields<subscription_rootvalidationValidationStreamArgs, 'batchSize' | 'cursor'>>;
  validationValidations?: SubscriptionResolver<Array<ResolversTypes['validationValidation']>, "validationValidations", ParentType, ContextType, Partial<subscription_rootvalidationValidationsArgs>>;
  voiceTypes?: SubscriptionResolver<Array<ResolversTypes['VoiceTypes']>, "voiceTypes", ParentType, ContextType, Partial<subscription_rootvoiceTypesArgs>>;
  voiceTypesAggregate?: SubscriptionResolver<ResolversTypes['VoiceTypesAggregate'], "voiceTypesAggregate", ParentType, ContextType, Partial<subscription_rootvoiceTypesAggregateArgs>>;
  voiceTypesByPk?: SubscriptionResolver<Maybe<ResolversTypes['VoiceTypes']>, "voiceTypesByPk", ParentType, ContextType, RequireFields<subscription_rootvoiceTypesByPkArgs, 'value'>>;
  voiceTypesStream?: SubscriptionResolver<Array<ResolversTypes['VoiceTypes']>, "voiceTypesStream", ParentType, ContextType, RequireFields<subscription_rootvoiceTypesStreamArgs, 'batchSize' | 'cursor'>>;
};

export type taskmutation_rootResolvers<ContextType = any, ParentType extends ResolversParentTypes['taskmutation_root'] = ResolversParentTypes['taskmutation_root']> = {
  createActivity?: Resolver<Maybe<ResolversTypes['TasktaskActivityOutput']>, ParentType, ContextType, RequireFields<taskmutation_rootcreateActivityArgs, 'input'>>;
  deleteActivities?: Resolver<Maybe<ResolversTypes['TaskActivityMutationResponse']>, ParentType, ContextType, RequireFields<taskmutation_rootdeleteActivitiesArgs, 'where'>>;
  deleteActivity?: Resolver<Maybe<ResolversTypes['TaskActivity']>, ParentType, ContextType, RequireFields<taskmutation_rootdeleteActivityArgs, 'id'>>;
  deleteActivityParticipant?: Resolver<Maybe<ResolversTypes['TaskActivityParticipantMutationResponse']>, ParentType, ContextType, RequireFields<taskmutation_rootdeleteActivityParticipantArgs, 'where'>>;
  deleteActivityParticipantByPk?: Resolver<Maybe<ResolversTypes['TaskActivityParticipant']>, ParentType, ContextType, RequireFields<taskmutation_rootdeleteActivityParticipantByPkArgs, 'id'>>;
  deleteActivityType?: Resolver<Maybe<ResolversTypes['TaskActivityTypeMutationResponse']>, ParentType, ContextType, RequireFields<taskmutation_rootdeleteActivityTypeArgs, 'where'>>;
  deleteActivityTypeByPk?: Resolver<Maybe<ResolversTypes['TaskActivityType']>, ParentType, ContextType, RequireFields<taskmutation_rootdeleteActivityTypeByPkArgs, 'value'>>;
  deleteDomainOrganizationByPk?: Resolver<Maybe<ResolversTypes['TaskDomainOrganization']>, ParentType, ContextType, RequireFields<taskmutation_rootdeleteDomainOrganizationByPkArgs, 'id'>>;
  deleteDomainOrganizations?: Resolver<Maybe<ResolversTypes['TaskDomainOrganizationMutationResponse']>, ParentType, ContextType, RequireFields<taskmutation_rootdeleteDomainOrganizationsArgs, 'where'>>;
  deleteDomainUser?: Resolver<Maybe<ResolversTypes['TaskDomainUserMutationResponse']>, ParentType, ContextType, RequireFields<taskmutation_rootdeleteDomainUserArgs, 'where'>>;
  deleteDomainUserByPk?: Resolver<Maybe<ResolversTypes['TaskDomainUser']>, ParentType, ContextType, RequireFields<taskmutation_rootdeleteDomainUserByPkArgs, 'id'>>;
  deleteDomainUserCategory?: Resolver<Maybe<ResolversTypes['TaskDomainUserCategoryMutationResponse']>, ParentType, ContextType, RequireFields<taskmutation_rootdeleteDomainUserCategoryArgs, 'where'>>;
  deleteDomainUserCategoryByPk?: Resolver<Maybe<ResolversTypes['TaskDomainUserCategory']>, ParentType, ContextType, RequireFields<taskmutation_rootdeleteDomainUserCategoryByPkArgs, 'value'>>;
  insertActivity?: Resolver<Maybe<ResolversTypes['TaskActivityMutationResponse']>, ParentType, ContextType, RequireFields<taskmutation_rootinsertActivityArgs, 'objects'>>;
  insertActivityOne?: Resolver<Maybe<ResolversTypes['TaskActivity']>, ParentType, ContextType, RequireFields<taskmutation_rootinsertActivityOneArgs, 'object'>>;
  insertActivityParticipant?: Resolver<Maybe<ResolversTypes['TaskActivityParticipantMutationResponse']>, ParentType, ContextType, RequireFields<taskmutation_rootinsertActivityParticipantArgs, 'objects'>>;
  insertActivityParticipantOne?: Resolver<Maybe<ResolversTypes['TaskActivityParticipant']>, ParentType, ContextType, RequireFields<taskmutation_rootinsertActivityParticipantOneArgs, 'object'>>;
  insertActivityType?: Resolver<Maybe<ResolversTypes['TaskActivityTypeMutationResponse']>, ParentType, ContextType, RequireFields<taskmutation_rootinsertActivityTypeArgs, 'objects'>>;
  insertActivityTypeOne?: Resolver<Maybe<ResolversTypes['TaskActivityType']>, ParentType, ContextType, RequireFields<taskmutation_rootinsertActivityTypeOneArgs, 'object'>>;
  insertDomainOrganization?: Resolver<Maybe<ResolversTypes['TaskDomainOrganizationMutationResponse']>, ParentType, ContextType, RequireFields<taskmutation_rootinsertDomainOrganizationArgs, 'objects'>>;
  insertDomainOrganizationOne?: Resolver<Maybe<ResolversTypes['TaskDomainOrganization']>, ParentType, ContextType, RequireFields<taskmutation_rootinsertDomainOrganizationOneArgs, 'object'>>;
  insertDomainUser?: Resolver<Maybe<ResolversTypes['TaskDomainUserMutationResponse']>, ParentType, ContextType, RequireFields<taskmutation_rootinsertDomainUserArgs, 'objects'>>;
  insertDomainUserCategory?: Resolver<Maybe<ResolversTypes['TaskDomainUserCategoryMutationResponse']>, ParentType, ContextType, RequireFields<taskmutation_rootinsertDomainUserCategoryArgs, 'objects'>>;
  insertDomainUserCategoryOne?: Resolver<Maybe<ResolversTypes['TaskDomainUserCategory']>, ParentType, ContextType, RequireFields<taskmutation_rootinsertDomainUserCategoryOneArgs, 'object'>>;
  insertDomainUserOne?: Resolver<Maybe<ResolversTypes['TaskDomainUser']>, ParentType, ContextType, RequireFields<taskmutation_rootinsertDomainUserOneArgs, 'object'>>;
  updateActivity?: Resolver<Maybe<ResolversTypes['TaskActivityMutationResponse']>, ParentType, ContextType, RequireFields<taskmutation_rootupdateActivityArgs, 'where'>>;
  updateActivityByPk?: Resolver<Maybe<ResolversTypes['TaskActivity']>, ParentType, ContextType, RequireFields<taskmutation_rootupdateActivityByPkArgs, 'pkColumns'>>;
  updateActivityMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['TaskActivityMutationResponse']>>>, ParentType, ContextType, RequireFields<taskmutation_rootupdateActivityManyArgs, 'updates'>>;
  updateActivityParticipant?: Resolver<Maybe<ResolversTypes['TaskActivityParticipantMutationResponse']>, ParentType, ContextType, RequireFields<taskmutation_rootupdateActivityParticipantArgs, 'where'>>;
  updateActivityParticipantByPk?: Resolver<Maybe<ResolversTypes['TaskActivityParticipant']>, ParentType, ContextType, RequireFields<taskmutation_rootupdateActivityParticipantByPkArgs, 'pkColumns'>>;
  updateActivityParticipantMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['TaskActivityParticipantMutationResponse']>>>, ParentType, ContextType, RequireFields<taskmutation_rootupdateActivityParticipantManyArgs, 'updates'>>;
  updateActivityType?: Resolver<Maybe<ResolversTypes['TaskActivityTypeMutationResponse']>, ParentType, ContextType, RequireFields<taskmutation_rootupdateActivityTypeArgs, 'where'>>;
  updateActivityTypeByPk?: Resolver<Maybe<ResolversTypes['TaskActivityType']>, ParentType, ContextType, RequireFields<taskmutation_rootupdateActivityTypeByPkArgs, 'pkColumns'>>;
  updateActivityTypeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['TaskActivityTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<taskmutation_rootupdateActivityTypeManyArgs, 'updates'>>;
  updateDomainOrganization?: Resolver<Maybe<ResolversTypes['TaskDomainOrganizationMutationResponse']>, ParentType, ContextType, RequireFields<taskmutation_rootupdateDomainOrganizationArgs, 'where'>>;
  updateDomainOrganizationByPk?: Resolver<Maybe<ResolversTypes['TaskDomainOrganization']>, ParentType, ContextType, RequireFields<taskmutation_rootupdateDomainOrganizationByPkArgs, 'pkColumns'>>;
  updateDomainOrganizationMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['TaskDomainOrganizationMutationResponse']>>>, ParentType, ContextType, RequireFields<taskmutation_rootupdateDomainOrganizationManyArgs, 'updates'>>;
  updateDomainUser?: Resolver<Maybe<ResolversTypes['TaskDomainUserMutationResponse']>, ParentType, ContextType, RequireFields<taskmutation_rootupdateDomainUserArgs, 'where'>>;
  updateDomainUserByPk?: Resolver<Maybe<ResolversTypes['TaskDomainUser']>, ParentType, ContextType, RequireFields<taskmutation_rootupdateDomainUserByPkArgs, 'pkColumns'>>;
  updateDomainUserCategory?: Resolver<Maybe<ResolversTypes['TaskDomainUserCategoryMutationResponse']>, ParentType, ContextType, RequireFields<taskmutation_rootupdateDomainUserCategoryArgs, 'where'>>;
  updateDomainUserCategoryByPk?: Resolver<Maybe<ResolversTypes['TaskDomainUserCategory']>, ParentType, ContextType, RequireFields<taskmutation_rootupdateDomainUserCategoryByPkArgs, 'pkColumns'>>;
  updateDomainUserCategoryMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['TaskDomainUserCategoryMutationResponse']>>>, ParentType, ContextType, RequireFields<taskmutation_rootupdateDomainUserCategoryManyArgs, 'updates'>>;
  updateDomainUserMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['TaskDomainUserMutationResponse']>>>, ParentType, ContextType, RequireFields<taskmutation_rootupdateDomainUserManyArgs, 'updates'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type taskquery_rootResolvers<ContextType = any, ParentType extends ResolversParentTypes['taskquery_root'] = ResolversParentTypes['taskquery_root']> = {
  activity?: Resolver<Array<ResolversTypes['TaskActivity']>, ParentType, ContextType, Partial<taskquery_rootactivityArgs>>;
  activityAggregate?: Resolver<ResolversTypes['TaskActivityAggregate'], ParentType, ContextType, Partial<taskquery_rootactivityAggregateArgs>>;
  activityByPk?: Resolver<Maybe<ResolversTypes['TaskActivity']>, ParentType, ContextType, RequireFields<taskquery_rootactivityByPkArgs, 'id'>>;
  activityParticipant?: Resolver<Array<ResolversTypes['TaskActivityParticipant']>, ParentType, ContextType, Partial<taskquery_rootactivityParticipantArgs>>;
  activityParticipantAggregate?: Resolver<ResolversTypes['TaskActivityParticipantAggregate'], ParentType, ContextType, Partial<taskquery_rootactivityParticipantAggregateArgs>>;
  activityParticipantByPk?: Resolver<Maybe<ResolversTypes['TaskActivityParticipant']>, ParentType, ContextType, RequireFields<taskquery_rootactivityParticipantByPkArgs, 'id'>>;
  activityType?: Resolver<Array<ResolversTypes['TaskActivityType']>, ParentType, ContextType, Partial<taskquery_rootactivityTypeArgs>>;
  activityTypeAggregate?: Resolver<ResolversTypes['TaskActivityTypeAggregate'], ParentType, ContextType, Partial<taskquery_rootactivityTypeAggregateArgs>>;
  activityTypeByPk?: Resolver<Maybe<ResolversTypes['TaskActivityType']>, ParentType, ContextType, RequireFields<taskquery_rootactivityTypeByPkArgs, 'value'>>;
  domainOrganization?: Resolver<Array<ResolversTypes['TaskDomainOrganization']>, ParentType, ContextType, Partial<taskquery_rootdomainOrganizationArgs>>;
  domainOrganizationAggregate?: Resolver<ResolversTypes['TaskDomainOrganizationAggregate'], ParentType, ContextType, Partial<taskquery_rootdomainOrganizationAggregateArgs>>;
  domainOrganizationByPk?: Resolver<Maybe<ResolversTypes['TaskDomainOrganization']>, ParentType, ContextType, RequireFields<taskquery_rootdomainOrganizationByPkArgs, 'id'>>;
  domainUser?: Resolver<Array<ResolversTypes['TaskDomainUser']>, ParentType, ContextType, Partial<taskquery_rootdomainUserArgs>>;
  domainUserAggregate?: Resolver<ResolversTypes['TaskDomainUserAggregate'], ParentType, ContextType, Partial<taskquery_rootdomainUserAggregateArgs>>;
  domainUserByPk?: Resolver<Maybe<ResolversTypes['TaskDomainUser']>, ParentType, ContextType, RequireFields<taskquery_rootdomainUserByPkArgs, 'id'>>;
  domainUserCategory?: Resolver<Array<ResolversTypes['TaskDomainUserCategory']>, ParentType, ContextType, Partial<taskquery_rootdomainUserCategoryArgs>>;
  domainUserCategoryAggregate?: Resolver<ResolversTypes['TaskDomainUserCategoryAggregate'], ParentType, ContextType, Partial<taskquery_rootdomainUserCategoryAggregateArgs>>;
  domainUserCategoryByPk?: Resolver<Maybe<ResolversTypes['TaskDomainUserCategory']>, ParentType, ContextType, RequireFields<taskquery_rootdomainUserCategoryByPkArgs, 'value'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type tasksubscription_rootResolvers<ContextType = any, ParentType extends ResolversParentTypes['tasksubscription_root'] = ResolversParentTypes['tasksubscription_root']> = {
  activity?: Resolver<Array<ResolversTypes['TaskActivity']>, ParentType, ContextType, Partial<tasksubscription_rootactivityArgs>>;
  activityAggregate?: Resolver<ResolversTypes['TaskActivityAggregate'], ParentType, ContextType, Partial<tasksubscription_rootactivityAggregateArgs>>;
  activityByPk?: Resolver<Maybe<ResolversTypes['TaskActivity']>, ParentType, ContextType, RequireFields<tasksubscription_rootactivityByPkArgs, 'id'>>;
  activityParticipant?: Resolver<Array<ResolversTypes['TaskActivityParticipant']>, ParentType, ContextType, Partial<tasksubscription_rootactivityParticipantArgs>>;
  activityParticipantAggregate?: Resolver<ResolversTypes['TaskActivityParticipantAggregate'], ParentType, ContextType, Partial<tasksubscription_rootactivityParticipantAggregateArgs>>;
  activityParticipantByPk?: Resolver<Maybe<ResolversTypes['TaskActivityParticipant']>, ParentType, ContextType, RequireFields<tasksubscription_rootactivityParticipantByPkArgs, 'id'>>;
  activityParticipantStream?: Resolver<Array<ResolversTypes['TaskActivityParticipant']>, ParentType, ContextType, RequireFields<tasksubscription_rootactivityParticipantStreamArgs, 'batchSize' | 'cursor'>>;
  activityStream?: Resolver<Array<ResolversTypes['TaskActivity']>, ParentType, ContextType, RequireFields<tasksubscription_rootactivityStreamArgs, 'batchSize' | 'cursor'>>;
  activityType?: Resolver<Array<ResolversTypes['TaskActivityType']>, ParentType, ContextType, Partial<tasksubscription_rootactivityTypeArgs>>;
  activityTypeAggregate?: Resolver<ResolversTypes['TaskActivityTypeAggregate'], ParentType, ContextType, Partial<tasksubscription_rootactivityTypeAggregateArgs>>;
  activityTypeByPk?: Resolver<Maybe<ResolversTypes['TaskActivityType']>, ParentType, ContextType, RequireFields<tasksubscription_rootactivityTypeByPkArgs, 'value'>>;
  activityTypeStream?: Resolver<Array<ResolversTypes['TaskActivityType']>, ParentType, ContextType, RequireFields<tasksubscription_rootactivityTypeStreamArgs, 'batchSize' | 'cursor'>>;
  domainOrganization?: Resolver<Array<ResolversTypes['TaskDomainOrganization']>, ParentType, ContextType, Partial<tasksubscription_rootdomainOrganizationArgs>>;
  domainOrganizationAggregate?: Resolver<ResolversTypes['TaskDomainOrganizationAggregate'], ParentType, ContextType, Partial<tasksubscription_rootdomainOrganizationAggregateArgs>>;
  domainOrganizationByPk?: Resolver<Maybe<ResolversTypes['TaskDomainOrganization']>, ParentType, ContextType, RequireFields<tasksubscription_rootdomainOrganizationByPkArgs, 'id'>>;
  domainOrganizationStream?: Resolver<Array<ResolversTypes['TaskDomainOrganization']>, ParentType, ContextType, RequireFields<tasksubscription_rootdomainOrganizationStreamArgs, 'batchSize' | 'cursor'>>;
  domainUser?: Resolver<Array<ResolversTypes['TaskDomainUser']>, ParentType, ContextType, Partial<tasksubscription_rootdomainUserArgs>>;
  domainUserAggregate?: Resolver<ResolversTypes['TaskDomainUserAggregate'], ParentType, ContextType, Partial<tasksubscription_rootdomainUserAggregateArgs>>;
  domainUserByPk?: Resolver<Maybe<ResolversTypes['TaskDomainUser']>, ParentType, ContextType, RequireFields<tasksubscription_rootdomainUserByPkArgs, 'id'>>;
  domainUserCategory?: Resolver<Array<ResolversTypes['TaskDomainUserCategory']>, ParentType, ContextType, Partial<tasksubscription_rootdomainUserCategoryArgs>>;
  domainUserCategoryAggregate?: Resolver<ResolversTypes['TaskDomainUserCategoryAggregate'], ParentType, ContextType, Partial<tasksubscription_rootdomainUserCategoryAggregateArgs>>;
  domainUserCategoryByPk?: Resolver<Maybe<ResolversTypes['TaskDomainUserCategory']>, ParentType, ContextType, RequireFields<tasksubscription_rootdomainUserCategoryByPkArgs, 'value'>>;
  domainUserCategoryStream?: Resolver<Array<ResolversTypes['TaskDomainUserCategory']>, ParentType, ContextType, RequireFields<tasksubscription_rootdomainUserCategoryStreamArgs, 'batchSize' | 'cursor'>>;
  domainUserStream?: Resolver<Array<ResolversTypes['TaskDomainUser']>, ParentType, ContextType, RequireFields<tasksubscription_rootdomainUserStreamArgs, 'batchSize' | 'cursor'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type telephonyDomainUserOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['telephonyDomainUserOutput'] = ResolversParentTypes['telephonyDomainUserOutput']> = {
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  department?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  domainOrganizationId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  function?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numberType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationUserId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  personId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type telephonymutation_rootResolvers<ContextType = any, ParentType extends ResolversParentTypes['telephonymutation_root'] = ResolversParentTypes['telephonymutation_root']> = {
  clickToCall?: Resolver<Maybe<ResolversTypes['TelephonyClickToCallOutput']>, ParentType, ContextType, RequireFields<telephonymutation_rootclickToCallArgs, 'clickToCall'>>;
  createActiveNumber?: Resolver<Maybe<ResolversTypes['TelephonyactiveNumbers']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateActiveNumberArgs, 'object'>>;
  createActiveNumbers?: Resolver<Maybe<ResolversTypes['TelephonyactiveNumbersMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateActiveNumbersArgs, 'objects'>>;
  createActivities?: Resolver<Maybe<ResolversTypes['TelephonyactivityMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateActivitiesArgs, 'objects'>>;
  createActivity?: Resolver<Maybe<ResolversTypes['Telephonyactivity']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateActivityArgs, 'object'>>;
  createActivityParticipant?: Resolver<Maybe<ResolversTypes['TelephonyactivityParticipant']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateActivityParticipantArgs, 'object'>>;
  createActivityParticipantRole?: Resolver<Maybe<ResolversTypes['TelephonyActivityParticipantRole']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateActivityParticipantRoleArgs, 'object'>>;
  createActivityParticipantRoles?: Resolver<Maybe<ResolversTypes['TelephonyActivityParticipantRoleMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateActivityParticipantRolesArgs, 'objects'>>;
  createActivityParticipants?: Resolver<Maybe<ResolversTypes['TelephonyactivityParticipantMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateActivityParticipantsArgs, 'objects'>>;
  createActivityType?: Resolver<Maybe<ResolversTypes['TelephonyActivityType']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateActivityTypeArgs, 'object'>>;
  createActivityTypes?: Resolver<Maybe<ResolversTypes['TelephonyActivityTypeMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateActivityTypesArgs, 'objects'>>;
  createCallDirection?: Resolver<Maybe<ResolversTypes['TelephonyCallDirection']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateCallDirectionArgs, 'object'>>;
  createCallDirections?: Resolver<Maybe<ResolversTypes['TelephonyCallDirectionMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateCallDirectionsArgs, 'objects'>>;
  createComment?: Resolver<Maybe<ResolversTypes['Telephonycomment']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateCommentArgs, 'object'>>;
  createComments?: Resolver<Maybe<ResolversTypes['TelephonycommentMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateCommentsArgs, 'objects'>>;
  createDomainOrganization?: Resolver<Maybe<ResolversTypes['TelephonydomainOrganization']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateDomainOrganizationArgs, 'object'>>;
  createDomainOrganizations?: Resolver<Maybe<ResolversTypes['TelephonydomainOrganizationMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateDomainOrganizationsArgs, 'objects'>>;
  createDomainUser?: Resolver<Maybe<ResolversTypes['TelephonydomainUser']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateDomainUserArgs, 'object'>>;
  createDomainUserCategories?: Resolver<Maybe<ResolversTypes['TelephonyDomainUserCategoryMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateDomainUserCategoriesArgs, 'objects'>>;
  createDomainUserCategory?: Resolver<Maybe<ResolversTypes['TelephonyDomainUserCategory']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateDomainUserCategoryArgs, 'object'>>;
  createDomainUsers?: Resolver<Maybe<ResolversTypes['TelephonydomainUserMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateDomainUsersArgs, 'objects'>>;
  createEvent?: Resolver<Maybe<ResolversTypes['Telephonyevent']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateEventArgs, 'object'>>;
  createEventAction?: Resolver<Maybe<ResolversTypes['TelephonyeventAction']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateEventActionArgs, 'object'>>;
  createEventActions?: Resolver<Maybe<ResolversTypes['TelephonyeventActionMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateEventActionsArgs, 'objects'>>;
  createEvents?: Resolver<Maybe<ResolversTypes['TelephonyeventMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateEventsArgs, 'objects'>>;
  createNumberState?: Resolver<Maybe<ResolversTypes['TelephonyNumberState']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateNumberStateArgs, 'object'>>;
  createNumberStates?: Resolver<Maybe<ResolversTypes['TelephonyNumberStateMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateNumberStatesArgs, 'objects'>>;
  createProvider?: Resolver<Maybe<ResolversTypes['Telephonyprovider']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateProviderArgs, 'object'>>;
  createProviderAccount?: Resolver<Maybe<ResolversTypes['TelephonyproviderAccount']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateProviderAccountArgs, 'object'>>;
  createProviderAccounts?: Resolver<Maybe<ResolversTypes['TelephonyproviderAccountMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateProviderAccountsArgs, 'objects'>>;
  createProviderIntegration?: Resolver<Maybe<Array<Maybe<ResolversTypes['TelephonyDomainUserOutput']>>>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateProviderIntegrationArgs, 'integration'>>;
  createProviderRequestTerm?: Resolver<Maybe<ResolversTypes['TelephonyproviderRequestTerm']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateProviderRequestTermArgs, 'object'>>;
  createProviderRequestTerms?: Resolver<Maybe<ResolversTypes['TelephonyproviderRequestTermMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateProviderRequestTermsArgs, 'objects'>>;
  createProviderType?: Resolver<Maybe<ResolversTypes['TelephonyProviderType']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateProviderTypeArgs, 'object'>>;
  createProviderTypes?: Resolver<Maybe<ResolversTypes['TelephonyProviderTypeMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateProviderTypesArgs, 'objects'>>;
  createProviders?: Resolver<Maybe<ResolversTypes['TelephonyproviderMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootcreateProvidersArgs, 'objects'>>;
  deleteActiveNumber?: Resolver<Maybe<ResolversTypes['TelephonyactiveNumbers']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteActiveNumberArgs, 'phoneNumber'>>;
  deleteActiveNumbers?: Resolver<Maybe<ResolversTypes['TelephonyactiveNumbersMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteActiveNumbersArgs, 'where'>>;
  deleteActivities?: Resolver<Maybe<ResolversTypes['TelephonyactivityMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteActivitiesArgs, 'where'>>;
  deleteActivity?: Resolver<Maybe<ResolversTypes['Telephonyactivity']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteActivityArgs, 'id'>>;
  deleteActivityParticipant?: Resolver<Maybe<ResolversTypes['TelephonyactivityParticipant']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteActivityParticipantArgs, 'id'>>;
  deleteActivityParticipantRole?: Resolver<Maybe<ResolversTypes['TelephonyActivityParticipantRole']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteActivityParticipantRoleArgs, 'value'>>;
  deleteActivityParticipantRoles?: Resolver<Maybe<ResolversTypes['TelephonyActivityParticipantRoleMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteActivityParticipantRolesArgs, 'where'>>;
  deleteActivityParticipants?: Resolver<Maybe<ResolversTypes['TelephonyactivityParticipantMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteActivityParticipantsArgs, 'where'>>;
  deleteActivityType?: Resolver<Maybe<ResolversTypes['TelephonyActivityType']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteActivityTypeArgs, 'value'>>;
  deleteActivityTypes?: Resolver<Maybe<ResolversTypes['TelephonyActivityTypeMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteActivityTypesArgs, 'where'>>;
  deleteCallDirection?: Resolver<Maybe<ResolversTypes['TelephonyCallDirection']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteCallDirectionArgs, 'value'>>;
  deleteCallDirections?: Resolver<Maybe<ResolversTypes['TelephonyCallDirectionMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteCallDirectionsArgs, 'where'>>;
  deleteComment?: Resolver<Maybe<ResolversTypes['Telephonycomment']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteCommentArgs, 'id'>>;
  deleteComments?: Resolver<Maybe<ResolversTypes['TelephonycommentMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteCommentsArgs, 'where'>>;
  deleteDomainOrganization?: Resolver<Maybe<ResolversTypes['TelephonydomainOrganization']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteDomainOrganizationArgs, 'id'>>;
  deleteDomainOrganizations?: Resolver<Maybe<ResolversTypes['TelephonydomainOrganizationMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteDomainOrganizationsArgs, 'where'>>;
  deleteDomainUser?: Resolver<Maybe<ResolversTypes['TelephonydomainUser']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteDomainUserArgs, 'id'>>;
  deleteDomainUserCategories?: Resolver<Maybe<ResolversTypes['TelephonyDomainUserCategoryMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteDomainUserCategoriesArgs, 'where'>>;
  deleteDomainUserCategory?: Resolver<Maybe<ResolversTypes['TelephonyDomainUserCategory']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteDomainUserCategoryArgs, 'value'>>;
  deleteDomainUsers?: Resolver<Maybe<ResolversTypes['TelephonydomainUserMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteDomainUsersArgs, 'where'>>;
  deleteEvent?: Resolver<Maybe<ResolversTypes['Telephonyevent']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteEventArgs, 'id'>>;
  deleteEventAction?: Resolver<Maybe<ResolversTypes['TelephonyeventAction']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteEventActionArgs, 'id'>>;
  deleteEventActions?: Resolver<Maybe<ResolversTypes['TelephonyeventActionMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteEventActionsArgs, 'where'>>;
  deleteEvents?: Resolver<Maybe<ResolversTypes['TelephonyeventMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteEventsArgs, 'where'>>;
  deleteNumberState?: Resolver<Maybe<ResolversTypes['TelephonyNumberState']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteNumberStateArgs, 'value'>>;
  deleteNumberStates?: Resolver<Maybe<ResolversTypes['TelephonyNumberStateMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteNumberStatesArgs, 'where'>>;
  deleteProvider?: Resolver<Maybe<ResolversTypes['Telephonyprovider']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteProviderArgs, 'id'>>;
  deleteProviderAccount?: Resolver<Maybe<ResolversTypes['TelephonyproviderAccount']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteProviderAccountArgs, 'id'>>;
  deleteProviderAccounts?: Resolver<Maybe<ResolversTypes['TelephonyproviderAccountMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteProviderAccountsArgs, 'where'>>;
  deleteProviderRequestTerm?: Resolver<Maybe<ResolversTypes['TelephonyproviderRequestTerm']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteProviderRequestTermArgs, 'id'>>;
  deleteProviderRequestTerms?: Resolver<Maybe<ResolversTypes['TelephonyproviderRequestTermMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteProviderRequestTermsArgs, 'where'>>;
  deleteProviderType?: Resolver<Maybe<ResolversTypes['TelephonyProviderType']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteProviderTypeArgs, 'value'>>;
  deleteProviderTypes?: Resolver<Maybe<ResolversTypes['TelephonyProviderTypeMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteProviderTypesArgs, 'where'>>;
  deleteProviders?: Resolver<Maybe<ResolversTypes['TelephonyproviderMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteProvidersArgs, 'where'>>;
  deleteTelephonyActionEventType?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyActionEventTypeMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteTelephonyActionEventTypeArgs, 'where'>>;
  deleteTelephonyActionEventTypeByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyActionEventType']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteTelephonyActionEventTypeByPkArgs, 'value'>>;
  deleteTelephonyActionType?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyActionTypeMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteTelephonyActionTypeArgs, 'where'>>;
  deleteTelephonyActionTypeByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyActionType']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteTelephonyActionTypeByPkArgs, 'value'>>;
  deleteTelephonyBlockedDomainUser?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyBlockedDomainUserMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteTelephonyBlockedDomainUserArgs, 'where'>>;
  deleteTelephonyBlockedDomainUserByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyBlockedDomainUser']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteTelephonyBlockedDomainUserByPkArgs, 'id'>>;
  deleteTelephonyCiscoSubscriberProduct?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyCiscoSubscriberProductMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteTelephonyCiscoSubscriberProductArgs, 'where'>>;
  deleteTelephonyCiscoSubscriberProductByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyCiscoSubscriberProduct']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteTelephonyCiscoSubscriberProductByPkArgs, 'id'>>;
  deleteTelephonyEvents?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyEventsMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteTelephonyEventsArgs, 'where'>>;
  deleteTelephonyEventsByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyEvents']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteTelephonyEventsByPkArgs, 'id'>>;
  deleteTelephonyLookupCallerApi?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupCallerApiMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteTelephonyLookupCallerApiArgs, 'where'>>;
  deleteTelephonyLookupCallerApiByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupCallerApi']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteTelephonyLookupCallerApiByPkArgs, 'id'>>;
  deleteTelephonyLookupRefresh?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupRefreshMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteTelephonyLookupRefreshArgs, 'where'>>;
  deleteTelephonyLookupRefreshByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupRefresh']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteTelephonyLookupRefreshByPkArgs, 'type'>>;
  deleteTelephonyLookupTypes?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupTypesMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteTelephonyLookupTypesArgs, 'where'>>;
  deleteTelephonyLookupTypesByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupTypes']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteTelephonyLookupTypesByPkArgs, 'value'>>;
  deleteTelephonyPods?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyPodsMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteTelephonyPodsArgs, 'where'>>;
  deleteTelephonyPodsByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyPods']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteTelephonyPodsByPkArgs, 'id'>>;
  deleteTelephonyProviderAccess?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyProviderAccessMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteTelephonyProviderAccessArgs, 'where'>>;
  deleteTelephonyProviderAccessByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyProviderAccess']>, ParentType, ContextType, RequireFields<telephonymutation_rootdeleteTelephonyProviderAccessByPkArgs, 'value'>>;
  hangUpCall?: Resolver<Maybe<ResolversTypes['TelephonyhangUpCallOutput']>, ParentType, ContextType, RequireFields<telephonymutation_roothangUpCallArgs, 'callId' | 'providerClientId'>>;
  insertTelephonyActionEventType?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyActionEventTypeMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootinsertTelephonyActionEventTypeArgs, 'objects'>>;
  insertTelephonyActionEventTypeOne?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyActionEventType']>, ParentType, ContextType, RequireFields<telephonymutation_rootinsertTelephonyActionEventTypeOneArgs, 'object'>>;
  insertTelephonyActionType?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyActionTypeMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootinsertTelephonyActionTypeArgs, 'objects'>>;
  insertTelephonyActionTypeOne?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyActionType']>, ParentType, ContextType, RequireFields<telephonymutation_rootinsertTelephonyActionTypeOneArgs, 'object'>>;
  insertTelephonyBlockedDomainUser?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyBlockedDomainUserMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootinsertTelephonyBlockedDomainUserArgs, 'objects'>>;
  insertTelephonyBlockedDomainUserOne?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyBlockedDomainUser']>, ParentType, ContextType, RequireFields<telephonymutation_rootinsertTelephonyBlockedDomainUserOneArgs, 'object'>>;
  insertTelephonyCiscoSubscriberProduct?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyCiscoSubscriberProductMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootinsertTelephonyCiscoSubscriberProductArgs, 'objects'>>;
  insertTelephonyCiscoSubscriberProductOne?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyCiscoSubscriberProduct']>, ParentType, ContextType, RequireFields<telephonymutation_rootinsertTelephonyCiscoSubscriberProductOneArgs, 'object'>>;
  insertTelephonyEvents?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyEventsMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootinsertTelephonyEventsArgs, 'objects'>>;
  insertTelephonyEventsOne?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyEvents']>, ParentType, ContextType, RequireFields<telephonymutation_rootinsertTelephonyEventsOneArgs, 'object'>>;
  insertTelephonyLookupCallerApi?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupCallerApiMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootinsertTelephonyLookupCallerApiArgs, 'objects'>>;
  insertTelephonyLookupCallerApiOne?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupCallerApi']>, ParentType, ContextType, RequireFields<telephonymutation_rootinsertTelephonyLookupCallerApiOneArgs, 'object'>>;
  insertTelephonyLookupRefresh?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupRefreshMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootinsertTelephonyLookupRefreshArgs, 'objects'>>;
  insertTelephonyLookupRefreshOne?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupRefresh']>, ParentType, ContextType, RequireFields<telephonymutation_rootinsertTelephonyLookupRefreshOneArgs, 'object'>>;
  insertTelephonyLookupTypes?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupTypesMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootinsertTelephonyLookupTypesArgs, 'objects'>>;
  insertTelephonyLookupTypesOne?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupTypes']>, ParentType, ContextType, RequireFields<telephonymutation_rootinsertTelephonyLookupTypesOneArgs, 'object'>>;
  insertTelephonyPods?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyPodsMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootinsertTelephonyPodsArgs, 'objects'>>;
  insertTelephonyPodsOne?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyPods']>, ParentType, ContextType, RequireFields<telephonymutation_rootinsertTelephonyPodsOneArgs, 'object'>>;
  insertTelephonyProviderAccess?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyProviderAccessMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootinsertTelephonyProviderAccessArgs, 'objects'>>;
  insertTelephonyProviderAccessOne?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyProviderAccess']>, ParentType, ContextType, RequireFields<telephonymutation_rootinsertTelephonyProviderAccessOneArgs, 'object'>>;
  makePhoneRequest?: Resolver<Maybe<ResolversTypes['TelephonyPhoneRequestOutput']>, ParentType, ContextType, RequireFields<telephonymutation_rootmakePhoneRequestArgs, 'request'>>;
  sendSMS?: Resolver<Maybe<ResolversTypes['TelephonySendSMSOutput']>, ParentType, ContextType, Partial<telephonymutation_rootsendSMSArgs>>;
  synchronizeDomainUsers?: Resolver<Maybe<ResolversTypes['TelephonySynchronizeDomainUsersOutput']>, ParentType, ContextType, RequireFields<telephonymutation_rootsynchronizeDomainUsersArgs, 'params'>>;
  triggerTestCall?: Resolver<Maybe<ResolversTypes['TelephonytriggerTestCallOutput']>, ParentType, ContextType, RequireFields<telephonymutation_roottriggerTestCallArgs, 'organizationId' | 'receiverId' | 'receiverNr' | 'senderId' | 'senderNr'>>;
  updateActiveNumber?: Resolver<Maybe<ResolversTypes['TelephonyactiveNumbers']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateActiveNumberArgs, 'pkColumns'>>;
  updateActiveNumbers?: Resolver<Maybe<ResolversTypes['TelephonyactiveNumbersMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateActiveNumbersArgs, 'where'>>;
  updateActivities?: Resolver<Maybe<ResolversTypes['TelephonyactivityMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateActivitiesArgs, 'where'>>;
  updateActivity?: Resolver<Maybe<ResolversTypes['Telephonyactivity']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateActivityArgs, 'pkColumns'>>;
  updateActivityParticipant?: Resolver<Maybe<ResolversTypes['TelephonyactivityParticipant']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateActivityParticipantArgs, 'pkColumns'>>;
  updateActivityParticipantRole?: Resolver<Maybe<ResolversTypes['TelephonyActivityParticipantRole']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateActivityParticipantRoleArgs, 'pkColumns'>>;
  updateActivityParticipantRoles?: Resolver<Maybe<ResolversTypes['TelephonyActivityParticipantRoleMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateActivityParticipantRolesArgs, 'where'>>;
  updateActivityParticipants?: Resolver<Maybe<ResolversTypes['TelephonyactivityParticipantMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateActivityParticipantsArgs, 'where'>>;
  updateActivityType?: Resolver<Maybe<ResolversTypes['TelephonyActivityType']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateActivityTypeArgs, 'pkColumns'>>;
  updateActivityTypes?: Resolver<Maybe<ResolversTypes['TelephonyActivityTypeMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateActivityTypesArgs, 'where'>>;
  updateCallDirection?: Resolver<Maybe<ResolversTypes['TelephonyCallDirection']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateCallDirectionArgs, 'pkColumns'>>;
  updateCallDirections?: Resolver<Maybe<ResolversTypes['TelephonyCallDirectionMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateCallDirectionsArgs, 'where'>>;
  updateComment?: Resolver<Maybe<ResolversTypes['Telephonycomment']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateCommentArgs, 'pkColumns'>>;
  updateComments?: Resolver<Maybe<ResolversTypes['TelephonycommentMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateCommentsArgs, 'where'>>;
  updateDomainOrganization?: Resolver<Maybe<ResolversTypes['TelephonydomainOrganization']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateDomainOrganizationArgs, 'pkColumns'>>;
  updateDomainOrganizations?: Resolver<Maybe<ResolversTypes['TelephonydomainOrganizationMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateDomainOrganizationsArgs, 'where'>>;
  updateDomainUser?: Resolver<Maybe<ResolversTypes['TelephonydomainUser']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateDomainUserArgs, 'pkColumns'>>;
  updateDomainUserCategories?: Resolver<Maybe<ResolversTypes['TelephonyDomainUserCategoryMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateDomainUserCategoriesArgs, 'where'>>;
  updateDomainUserCategory?: Resolver<Maybe<ResolversTypes['TelephonyDomainUserCategory']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateDomainUserCategoryArgs, 'pkColumns'>>;
  updateDomainUsers?: Resolver<Maybe<ResolversTypes['TelephonydomainUserMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateDomainUsersArgs, 'where'>>;
  updateEvent?: Resolver<Maybe<ResolversTypes['Telephonyevent']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateEventArgs, 'pkColumns'>>;
  updateEventAction?: Resolver<Maybe<ResolversTypes['TelephonyeventAction']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateEventActionArgs, 'pkColumns'>>;
  updateEventActionMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['TelephonyeventActionMutationResponse']>>>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateEventActionManyArgs, 'updates'>>;
  updateEventActions?: Resolver<Maybe<ResolversTypes['TelephonyeventActionMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateEventActionsArgs, 'where'>>;
  updateEvents?: Resolver<Maybe<ResolversTypes['TelephonyeventMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateEventsArgs, 'where'>>;
  updateManyActiveNumbers?: Resolver<Maybe<Array<Maybe<ResolversTypes['TelephonyactiveNumbersMutationResponse']>>>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateManyActiveNumbersArgs, 'updates'>>;
  updateManyActivities?: Resolver<Maybe<Array<Maybe<ResolversTypes['TelephonyactivityMutationResponse']>>>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateManyActivitiesArgs, 'updates'>>;
  updateManyActivityParticipantRoles?: Resolver<Maybe<Array<Maybe<ResolversTypes['TelephonyActivityParticipantRoleMutationResponse']>>>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateManyActivityParticipantRolesArgs, 'updates'>>;
  updateManyActivityParticipants?: Resolver<Maybe<Array<Maybe<ResolversTypes['TelephonyactivityParticipantMutationResponse']>>>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateManyActivityParticipantsArgs, 'updates'>>;
  updateManyActivityTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['TelephonyActivityTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateManyActivityTypesArgs, 'updates'>>;
  updateManyCallDirections?: Resolver<Maybe<Array<Maybe<ResolversTypes['TelephonyCallDirectionMutationResponse']>>>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateManyCallDirectionsArgs, 'updates'>>;
  updateManyComments?: Resolver<Maybe<Array<Maybe<ResolversTypes['TelephonycommentMutationResponse']>>>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateManyCommentsArgs, 'updates'>>;
  updateManyDomainOrganizations?: Resolver<Maybe<Array<Maybe<ResolversTypes['TelephonydomainOrganizationMutationResponse']>>>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateManyDomainOrganizationsArgs, 'updates'>>;
  updateManyDomainUserCategories?: Resolver<Maybe<Array<Maybe<ResolversTypes['TelephonyDomainUserCategoryMutationResponse']>>>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateManyDomainUserCategoriesArgs, 'updates'>>;
  updateManyDomainUsers?: Resolver<Maybe<Array<Maybe<ResolversTypes['TelephonydomainUserMutationResponse']>>>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateManyDomainUsersArgs, 'updates'>>;
  updateManyEvents?: Resolver<Maybe<Array<Maybe<ResolversTypes['TelephonyeventMutationResponse']>>>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateManyEventsArgs, 'updates'>>;
  updateManyNumberStates?: Resolver<Maybe<Array<Maybe<ResolversTypes['TelephonyNumberStateMutationResponse']>>>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateManyNumberStatesArgs, 'updates'>>;
  updateManyProviderAccount?: Resolver<Maybe<Array<Maybe<ResolversTypes['TelephonyproviderAccountMutationResponse']>>>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateManyProviderAccountArgs, 'updates'>>;
  updateManyProviderRequestTerms?: Resolver<Maybe<Array<Maybe<ResolversTypes['TelephonyproviderRequestTermMutationResponse']>>>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateManyProviderRequestTermsArgs, 'updates'>>;
  updateManyProviderTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['TelephonyProviderTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateManyProviderTypesArgs, 'updates'>>;
  updateNumberState?: Resolver<Maybe<ResolversTypes['TelephonyNumberState']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateNumberStateArgs, 'pkColumns'>>;
  updateNumberStates?: Resolver<Maybe<ResolversTypes['TelephonyNumberStateMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateNumberStatesArgs, 'where'>>;
  updateProvider?: Resolver<Maybe<ResolversTypes['Telephonyprovider']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateProviderArgs, 'pkColumns'>>;
  updateProviderAccount?: Resolver<Maybe<ResolversTypes['TelephonyproviderAccount']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateProviderAccountArgs, 'pkColumns'>>;
  updateProviderAccounts?: Resolver<Maybe<ResolversTypes['TelephonyproviderAccountMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateProviderAccountsArgs, 'where'>>;
  updateProviderMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['TelephonyproviderMutationResponse']>>>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateProviderManyArgs, 'updates'>>;
  updateProviderRequestTerm?: Resolver<Maybe<ResolversTypes['TelephonyproviderRequestTerm']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateProviderRequestTermArgs, 'pkColumns'>>;
  updateProviderRequestTerms?: Resolver<Maybe<ResolversTypes['TelephonyproviderRequestTermMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateProviderRequestTermsArgs, 'where'>>;
  updateProviderType?: Resolver<Maybe<ResolversTypes['TelephonyProviderType']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateProviderTypeArgs, 'pkColumns'>>;
  updateProviderTypes?: Resolver<Maybe<ResolversTypes['TelephonyProviderTypeMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateProviderTypesArgs, 'where'>>;
  updateProviders?: Resolver<Maybe<ResolversTypes['TelephonyproviderMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateProvidersArgs, 'where'>>;
  updateTelephonyActionEventType?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyActionEventTypeMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyActionEventTypeArgs, 'where'>>;
  updateTelephonyActionEventTypeByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyActionEventType']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyActionEventTypeByPkArgs, 'pkColumns'>>;
  updateTelephonyActionEventTypeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['TelephonyTelephonyActionEventTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyActionEventTypeManyArgs, 'updates'>>;
  updateTelephonyActionType?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyActionTypeMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyActionTypeArgs, 'where'>>;
  updateTelephonyActionTypeByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyActionType']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyActionTypeByPkArgs, 'pkColumns'>>;
  updateTelephonyActionTypeMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['TelephonyTelephonyActionTypeMutationResponse']>>>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyActionTypeManyArgs, 'updates'>>;
  updateTelephonyBlockedDomainUser?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyBlockedDomainUserMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyBlockedDomainUserArgs, 'where'>>;
  updateTelephonyBlockedDomainUserByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyBlockedDomainUser']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyBlockedDomainUserByPkArgs, 'pkColumns'>>;
  updateTelephonyBlockedDomainUserMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['TelephonyTelephonyBlockedDomainUserMutationResponse']>>>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyBlockedDomainUserManyArgs, 'updates'>>;
  updateTelephonyCiscoSubscriberProduct?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyCiscoSubscriberProductMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyCiscoSubscriberProductArgs, 'where'>>;
  updateTelephonyCiscoSubscriberProductByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyCiscoSubscriberProduct']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyCiscoSubscriberProductByPkArgs, 'pkColumns'>>;
  updateTelephonyCiscoSubscriberProductMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['TelephonyTelephonyCiscoSubscriberProductMutationResponse']>>>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyCiscoSubscriberProductManyArgs, 'updates'>>;
  updateTelephonyEvents?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyEventsMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyEventsArgs, 'where'>>;
  updateTelephonyEventsByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyEvents']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyEventsByPkArgs, 'pkColumns'>>;
  updateTelephonyEventsMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['TelephonyTelephonyEventsMutationResponse']>>>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyEventsManyArgs, 'updates'>>;
  updateTelephonyLookupCallerApi?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupCallerApiMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyLookupCallerApiArgs, 'where'>>;
  updateTelephonyLookupCallerApiByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupCallerApi']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyLookupCallerApiByPkArgs, 'pkColumns'>>;
  updateTelephonyLookupCallerApiMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['TelephonyTelephonyLookupCallerApiMutationResponse']>>>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyLookupCallerApiManyArgs, 'updates'>>;
  updateTelephonyLookupRefresh?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupRefreshMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyLookupRefreshArgs, 'where'>>;
  updateTelephonyLookupRefreshByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupRefresh']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyLookupRefreshByPkArgs, 'pkColumns'>>;
  updateTelephonyLookupRefreshMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['TelephonyTelephonyLookupRefreshMutationResponse']>>>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyLookupRefreshManyArgs, 'updates'>>;
  updateTelephonyLookupTypes?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupTypesMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyLookupTypesArgs, 'where'>>;
  updateTelephonyLookupTypesByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupTypes']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyLookupTypesByPkArgs, 'pkColumns'>>;
  updateTelephonyLookupTypesMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['TelephonyTelephonyLookupTypesMutationResponse']>>>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyLookupTypesManyArgs, 'updates'>>;
  updateTelephonyPods?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyPodsMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyPodsArgs, 'where'>>;
  updateTelephonyPodsByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyPods']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyPodsByPkArgs, 'pkColumns'>>;
  updateTelephonyPodsMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['TelephonyTelephonyPodsMutationResponse']>>>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyPodsManyArgs, 'updates'>>;
  updateTelephonyProviderAccess?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyProviderAccessMutationResponse']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyProviderAccessArgs, 'where'>>;
  updateTelephonyProviderAccessByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyProviderAccess']>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyProviderAccessByPkArgs, 'pkColumns'>>;
  updateTelephonyProviderAccessMany?: Resolver<Maybe<Array<Maybe<ResolversTypes['TelephonyTelephonyProviderAccessMutationResponse']>>>, ParentType, ContextType, RequireFields<telephonymutation_rootupdateTelephonyProviderAccessManyArgs, 'updates'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type telephonyquery_rootResolvers<ContextType = any, ParentType extends ResolversParentTypes['telephonyquery_root'] = ResolversParentTypes['telephonyquery_root']> = {
  activeNumber?: Resolver<Maybe<ResolversTypes['TelephonyactiveNumbers']>, ParentType, ContextType, RequireFields<telephonyquery_rootactiveNumberArgs, 'phoneNumber'>>;
  activeNumbers?: Resolver<Array<ResolversTypes['TelephonyactiveNumbers']>, ParentType, ContextType, Partial<telephonyquery_rootactiveNumbersArgs>>;
  activeNumbersAggregate?: Resolver<ResolversTypes['TelephonyactiveNumbersAggregate'], ParentType, ContextType, Partial<telephonyquery_rootactiveNumbersAggregateArgs>>;
  activities?: Resolver<Array<ResolversTypes['Telephonyactivity']>, ParentType, ContextType, Partial<telephonyquery_rootactivitiesArgs>>;
  activitiesAggregate?: Resolver<ResolversTypes['TelephonyactivityAggregate'], ParentType, ContextType, Partial<telephonyquery_rootactivitiesAggregateArgs>>;
  activity?: Resolver<Maybe<ResolversTypes['Telephonyactivity']>, ParentType, ContextType, RequireFields<telephonyquery_rootactivityArgs, 'id'>>;
  activityParticipant?: Resolver<Maybe<ResolversTypes['TelephonyactivityParticipant']>, ParentType, ContextType, RequireFields<telephonyquery_rootactivityParticipantArgs, 'id'>>;
  activityParticipantRole?: Resolver<Maybe<ResolversTypes['TelephonyActivityParticipantRole']>, ParentType, ContextType, RequireFields<telephonyquery_rootactivityParticipantRoleArgs, 'value'>>;
  activityParticipantRoles?: Resolver<Array<ResolversTypes['TelephonyActivityParticipantRole']>, ParentType, ContextType, Partial<telephonyquery_rootactivityParticipantRolesArgs>>;
  activityParticipantRolesAggregate?: Resolver<ResolversTypes['TelephonyActivityParticipantRoleAggregate'], ParentType, ContextType, Partial<telephonyquery_rootactivityParticipantRolesAggregateArgs>>;
  activityParticipants?: Resolver<Array<ResolversTypes['TelephonyactivityParticipant']>, ParentType, ContextType, Partial<telephonyquery_rootactivityParticipantsArgs>>;
  activityParticipantsAggregate?: Resolver<ResolversTypes['TelephonyactivityParticipantAggregate'], ParentType, ContextType, Partial<telephonyquery_rootactivityParticipantsAggregateArgs>>;
  activityType?: Resolver<Maybe<ResolversTypes['TelephonyActivityType']>, ParentType, ContextType, RequireFields<telephonyquery_rootactivityTypeArgs, 'value'>>;
  activityTypes?: Resolver<Array<ResolversTypes['TelephonyActivityType']>, ParentType, ContextType, Partial<telephonyquery_rootactivityTypesArgs>>;
  activityTypesAggregate?: Resolver<ResolversTypes['TelephonyActivityTypeAggregate'], ParentType, ContextType, Partial<telephonyquery_rootactivityTypesAggregateArgs>>;
  callDirection?: Resolver<Maybe<ResolversTypes['TelephonyCallDirection']>, ParentType, ContextType, RequireFields<telephonyquery_rootcallDirectionArgs, 'value'>>;
  callDirections?: Resolver<Array<ResolversTypes['TelephonyCallDirection']>, ParentType, ContextType, Partial<telephonyquery_rootcallDirectionsArgs>>;
  callDirectionsAggregate?: Resolver<ResolversTypes['TelephonyCallDirectionAggregate'], ParentType, ContextType, Partial<telephonyquery_rootcallDirectionsAggregateArgs>>;
  callResult?: Resolver<Maybe<ResolversTypes['TelephonyCallResultOutput']>, ParentType, ContextType, RequireFields<telephonyquery_rootcallResultArgs, 'call'>>;
  comment?: Resolver<Maybe<ResolversTypes['Telephonycomment']>, ParentType, ContextType, RequireFields<telephonyquery_rootcommentArgs, 'id'>>;
  comments?: Resolver<Array<ResolversTypes['Telephonycomment']>, ParentType, ContextType, Partial<telephonyquery_rootcommentsArgs>>;
  commentsAggregate?: Resolver<ResolversTypes['TelephonycommentAggregate'], ParentType, ContextType, Partial<telephonyquery_rootcommentsAggregateArgs>>;
  domainOrganization?: Resolver<Maybe<ResolversTypes['TelephonydomainOrganization']>, ParentType, ContextType, RequireFields<telephonyquery_rootdomainOrganizationArgs, 'id'>>;
  domainOrganizations?: Resolver<Array<ResolversTypes['TelephonydomainOrganization']>, ParentType, ContextType, Partial<telephonyquery_rootdomainOrganizationsArgs>>;
  domainOrganizationsAggregate?: Resolver<ResolversTypes['TelephonydomainOrganizationAggregate'], ParentType, ContextType, Partial<telephonyquery_rootdomainOrganizationsAggregateArgs>>;
  domainUser?: Resolver<Maybe<ResolversTypes['TelephonydomainUser']>, ParentType, ContextType, RequireFields<telephonyquery_rootdomainUserArgs, 'id'>>;
  domainUserCategories?: Resolver<Array<ResolversTypes['TelephonyDomainUserCategory']>, ParentType, ContextType, Partial<telephonyquery_rootdomainUserCategoriesArgs>>;
  domainUserCategoriesAggregate?: Resolver<ResolversTypes['TelephonyDomainUserCategoryAggregate'], ParentType, ContextType, Partial<telephonyquery_rootdomainUserCategoriesAggregateArgs>>;
  domainUserCategory?: Resolver<Maybe<ResolversTypes['TelephonyDomainUserCategory']>, ParentType, ContextType, RequireFields<telephonyquery_rootdomainUserCategoryArgs, 'value'>>;
  domainUsers?: Resolver<Array<ResolversTypes['TelephonydomainUser']>, ParentType, ContextType, Partial<telephonyquery_rootdomainUsersArgs>>;
  domainUsersAggregate?: Resolver<ResolversTypes['TelephonydomainUserAggregate'], ParentType, ContextType, Partial<telephonyquery_rootdomainUsersAggregateArgs>>;
  event?: Resolver<Maybe<ResolversTypes['Telephonyevent']>, ParentType, ContextType, RequireFields<telephonyquery_rooteventArgs, 'id'>>;
  eventActionAggregate?: Resolver<ResolversTypes['TelephonyeventActionAggregate'], ParentType, ContextType, Partial<telephonyquery_rooteventActionAggregateArgs>>;
  eventActionByPk?: Resolver<Maybe<ResolversTypes['TelephonyeventAction']>, ParentType, ContextType, RequireFields<telephonyquery_rooteventActionByPkArgs, 'id'>>;
  eventActions?: Resolver<Array<ResolversTypes['TelephonyeventAction']>, ParentType, ContextType, Partial<telephonyquery_rooteventActionsArgs>>;
  events?: Resolver<Array<ResolversTypes['Telephonyevent']>, ParentType, ContextType, Partial<telephonyquery_rooteventsArgs>>;
  eventsAggregate?: Resolver<ResolversTypes['TelephonyeventAggregate'], ParentType, ContextType, Partial<telephonyquery_rooteventsAggregateArgs>>;
  lookupPhoneNumber?: Resolver<Maybe<ResolversTypes['TelephonyLookupPhoneNumberOutput']>, ParentType, ContextType, Partial<telephonyquery_rootlookupPhoneNumberArgs>>;
  numberState?: Resolver<Maybe<ResolversTypes['TelephonyNumberState']>, ParentType, ContextType, RequireFields<telephonyquery_rootnumberStateArgs, 'value'>>;
  numberStates?: Resolver<Array<ResolversTypes['TelephonyNumberState']>, ParentType, ContextType, Partial<telephonyquery_rootnumberStatesArgs>>;
  numberStatesAggregate?: Resolver<ResolversTypes['TelephonyNumberStateAggregate'], ParentType, ContextType, Partial<telephonyquery_rootnumberStatesAggregateArgs>>;
  provider?: Resolver<Maybe<ResolversTypes['Telephonyprovider']>, ParentType, ContextType, RequireFields<telephonyquery_rootproviderArgs, 'id'>>;
  providerAccount?: Resolver<Maybe<ResolversTypes['TelephonyproviderAccount']>, ParentType, ContextType, RequireFields<telephonyquery_rootproviderAccountArgs, 'id'>>;
  providerAccounts?: Resolver<Array<ResolversTypes['TelephonyproviderAccount']>, ParentType, ContextType, Partial<telephonyquery_rootproviderAccountsArgs>>;
  providerAccountsAggregate?: Resolver<ResolversTypes['TelephonyproviderAccountAggregate'], ParentType, ContextType, Partial<telephonyquery_rootproviderAccountsAggregateArgs>>;
  providerAggregate?: Resolver<ResolversTypes['TelephonyproviderAggregate'], ParentType, ContextType, Partial<telephonyquery_rootproviderAggregateArgs>>;
  providerRequestTerm?: Resolver<Maybe<ResolversTypes['TelephonyproviderRequestTerm']>, ParentType, ContextType, RequireFields<telephonyquery_rootproviderRequestTermArgs, 'id'>>;
  providerRequestTerms?: Resolver<Array<ResolversTypes['TelephonyproviderRequestTerm']>, ParentType, ContextType, Partial<telephonyquery_rootproviderRequestTermsArgs>>;
  providerRequestTermsAggregate?: Resolver<ResolversTypes['TelephonyproviderRequestTermAggregate'], ParentType, ContextType, Partial<telephonyquery_rootproviderRequestTermsAggregateArgs>>;
  providerType?: Resolver<Maybe<ResolversTypes['TelephonyProviderType']>, ParentType, ContextType, RequireFields<telephonyquery_rootproviderTypeArgs, 'value'>>;
  providerTypes?: Resolver<Array<ResolversTypes['TelephonyProviderType']>, ParentType, ContextType, Partial<telephonyquery_rootproviderTypesArgs>>;
  providerTypesAggregate?: Resolver<ResolversTypes['TelephonyProviderTypeAggregate'], ParentType, ContextType, Partial<telephonyquery_rootproviderTypesAggregateArgs>>;
  providers?: Resolver<Array<ResolversTypes['Telephonyprovider']>, ParentType, ContextType, Partial<telephonyquery_rootprovidersArgs>>;
  telephonyActionEventType?: Resolver<Array<ResolversTypes['TelephonyTelephonyActionEventType']>, ParentType, ContextType, Partial<telephonyquery_roottelephonyActionEventTypeArgs>>;
  telephonyActionEventTypeAggregate?: Resolver<ResolversTypes['TelephonyTelephonyActionEventTypeAggregate'], ParentType, ContextType, Partial<telephonyquery_roottelephonyActionEventTypeAggregateArgs>>;
  telephonyActionEventTypeByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyActionEventType']>, ParentType, ContextType, RequireFields<telephonyquery_roottelephonyActionEventTypeByPkArgs, 'value'>>;
  telephonyActionType?: Resolver<Array<ResolversTypes['TelephonyTelephonyActionType']>, ParentType, ContextType, Partial<telephonyquery_roottelephonyActionTypeArgs>>;
  telephonyActionTypeAggregate?: Resolver<ResolversTypes['TelephonyTelephonyActionTypeAggregate'], ParentType, ContextType, Partial<telephonyquery_roottelephonyActionTypeAggregateArgs>>;
  telephonyActionTypeByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyActionType']>, ParentType, ContextType, RequireFields<telephonyquery_roottelephonyActionTypeByPkArgs, 'value'>>;
  telephonyBlockedDomainUser?: Resolver<Array<ResolversTypes['TelephonyTelephonyBlockedDomainUser']>, ParentType, ContextType, Partial<telephonyquery_roottelephonyBlockedDomainUserArgs>>;
  telephonyBlockedDomainUserAggregate?: Resolver<ResolversTypes['TelephonyTelephonyBlockedDomainUserAggregate'], ParentType, ContextType, Partial<telephonyquery_roottelephonyBlockedDomainUserAggregateArgs>>;
  telephonyBlockedDomainUserByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyBlockedDomainUser']>, ParentType, ContextType, RequireFields<telephonyquery_roottelephonyBlockedDomainUserByPkArgs, 'id'>>;
  telephonyCiscoSubscriberProduct?: Resolver<Array<ResolversTypes['TelephonyTelephonyCiscoSubscriberProduct']>, ParentType, ContextType, Partial<telephonyquery_roottelephonyCiscoSubscriberProductArgs>>;
  telephonyCiscoSubscriberProductAggregate?: Resolver<ResolversTypes['TelephonyTelephonyCiscoSubscriberProductAggregate'], ParentType, ContextType, Partial<telephonyquery_roottelephonyCiscoSubscriberProductAggregateArgs>>;
  telephonyCiscoSubscriberProductByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyCiscoSubscriberProduct']>, ParentType, ContextType, RequireFields<telephonyquery_roottelephonyCiscoSubscriberProductByPkArgs, 'id'>>;
  telephonyEvents?: Resolver<Array<ResolversTypes['TelephonyTelephonyEvents']>, ParentType, ContextType, Partial<telephonyquery_roottelephonyEventsArgs>>;
  telephonyEventsAggregate?: Resolver<ResolversTypes['TelephonyTelephonyEventsAggregate'], ParentType, ContextType, Partial<telephonyquery_roottelephonyEventsAggregateArgs>>;
  telephonyEventsByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyEvents']>, ParentType, ContextType, RequireFields<telephonyquery_roottelephonyEventsByPkArgs, 'id'>>;
  telephonyLookupCallerApi?: Resolver<Array<ResolversTypes['TelephonyTelephonyLookupCallerApi']>, ParentType, ContextType, Partial<telephonyquery_roottelephonyLookupCallerApiArgs>>;
  telephonyLookupCallerApiAggregate?: Resolver<ResolversTypes['TelephonyTelephonyLookupCallerApiAggregate'], ParentType, ContextType, Partial<telephonyquery_roottelephonyLookupCallerApiAggregateArgs>>;
  telephonyLookupCallerApiByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupCallerApi']>, ParentType, ContextType, RequireFields<telephonyquery_roottelephonyLookupCallerApiByPkArgs, 'id'>>;
  telephonyLookupRefresh?: Resolver<Array<ResolversTypes['TelephonyTelephonyLookupRefresh']>, ParentType, ContextType, Partial<telephonyquery_roottelephonyLookupRefreshArgs>>;
  telephonyLookupRefreshAggregate?: Resolver<ResolversTypes['TelephonyTelephonyLookupRefreshAggregate'], ParentType, ContextType, Partial<telephonyquery_roottelephonyLookupRefreshAggregateArgs>>;
  telephonyLookupRefreshByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupRefresh']>, ParentType, ContextType, RequireFields<telephonyquery_roottelephonyLookupRefreshByPkArgs, 'type'>>;
  telephonyLookupTypes?: Resolver<Array<ResolversTypes['TelephonyTelephonyLookupTypes']>, ParentType, ContextType, Partial<telephonyquery_roottelephonyLookupTypesArgs>>;
  telephonyLookupTypesAggregate?: Resolver<ResolversTypes['TelephonyTelephonyLookupTypesAggregate'], ParentType, ContextType, Partial<telephonyquery_roottelephonyLookupTypesAggregateArgs>>;
  telephonyLookupTypesByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupTypes']>, ParentType, ContextType, RequireFields<telephonyquery_roottelephonyLookupTypesByPkArgs, 'value'>>;
  telephonyPods?: Resolver<Array<ResolversTypes['TelephonyTelephonyPods']>, ParentType, ContextType, Partial<telephonyquery_roottelephonyPodsArgs>>;
  telephonyPodsAggregate?: Resolver<ResolversTypes['TelephonyTelephonyPodsAggregate'], ParentType, ContextType, Partial<telephonyquery_roottelephonyPodsAggregateArgs>>;
  telephonyPodsByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyPods']>, ParentType, ContextType, RequireFields<telephonyquery_roottelephonyPodsByPkArgs, 'id'>>;
  telephonyProviderAccess?: Resolver<Array<ResolversTypes['TelephonyTelephonyProviderAccess']>, ParentType, ContextType, Partial<telephonyquery_roottelephonyProviderAccessArgs>>;
  telephonyProviderAccessAggregate?: Resolver<ResolversTypes['TelephonyTelephonyProviderAccessAggregate'], ParentType, ContextType, Partial<telephonyquery_roottelephonyProviderAccessAggregateArgs>>;
  telephonyProviderAccessByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyProviderAccess']>, ParentType, ContextType, RequireFields<telephonyquery_roottelephonyProviderAccessByPkArgs, 'value'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type telephonysubscription_rootResolvers<ContextType = any, ParentType extends ResolversParentTypes['telephonysubscription_root'] = ResolversParentTypes['telephonysubscription_root']> = {
  activeNumber?: Resolver<Maybe<ResolversTypes['TelephonyactiveNumbers']>, ParentType, ContextType, RequireFields<telephonysubscription_rootactiveNumberArgs, 'phoneNumber'>>;
  activeNumbers?: Resolver<Array<ResolversTypes['TelephonyactiveNumbers']>, ParentType, ContextType, Partial<telephonysubscription_rootactiveNumbersArgs>>;
  activeNumbersAggregate?: Resolver<ResolversTypes['TelephonyactiveNumbersAggregate'], ParentType, ContextType, Partial<telephonysubscription_rootactiveNumbersAggregateArgs>>;
  activeNumbersStream?: Resolver<Array<ResolversTypes['TelephonyactiveNumbers']>, ParentType, ContextType, RequireFields<telephonysubscription_rootactiveNumbersStreamArgs, 'batchSize' | 'cursor'>>;
  activities?: Resolver<Array<ResolversTypes['Telephonyactivity']>, ParentType, ContextType, Partial<telephonysubscription_rootactivitiesArgs>>;
  activitiesAggregate?: Resolver<ResolversTypes['TelephonyactivityAggregate'], ParentType, ContextType, Partial<telephonysubscription_rootactivitiesAggregateArgs>>;
  activitiesStream?: Resolver<Array<ResolversTypes['Telephonyactivity']>, ParentType, ContextType, RequireFields<telephonysubscription_rootactivitiesStreamArgs, 'batchSize' | 'cursor'>>;
  activity?: Resolver<Maybe<ResolversTypes['Telephonyactivity']>, ParentType, ContextType, RequireFields<telephonysubscription_rootactivityArgs, 'id'>>;
  activityParticipant?: Resolver<Maybe<ResolversTypes['TelephonyactivityParticipant']>, ParentType, ContextType, RequireFields<telephonysubscription_rootactivityParticipantArgs, 'id'>>;
  activityParticipantRole?: Resolver<Maybe<ResolversTypes['TelephonyActivityParticipantRole']>, ParentType, ContextType, RequireFields<telephonysubscription_rootactivityParticipantRoleArgs, 'value'>>;
  activityParticipantRoles?: Resolver<Array<ResolversTypes['TelephonyActivityParticipantRole']>, ParentType, ContextType, Partial<telephonysubscription_rootactivityParticipantRolesArgs>>;
  activityParticipantRolesAggregate?: Resolver<ResolversTypes['TelephonyActivityParticipantRoleAggregate'], ParentType, ContextType, Partial<telephonysubscription_rootactivityParticipantRolesAggregateArgs>>;
  activityParticipantRolesStream?: Resolver<Array<ResolversTypes['TelephonyActivityParticipantRole']>, ParentType, ContextType, RequireFields<telephonysubscription_rootactivityParticipantRolesStreamArgs, 'batchSize' | 'cursor'>>;
  activityParticipants?: Resolver<Array<ResolversTypes['TelephonyactivityParticipant']>, ParentType, ContextType, Partial<telephonysubscription_rootactivityParticipantsArgs>>;
  activityParticipantsAggregate?: Resolver<ResolversTypes['TelephonyactivityParticipantAggregate'], ParentType, ContextType, Partial<telephonysubscription_rootactivityParticipantsAggregateArgs>>;
  activityParticipantsStream?: Resolver<Array<ResolversTypes['TelephonyactivityParticipant']>, ParentType, ContextType, RequireFields<telephonysubscription_rootactivityParticipantsStreamArgs, 'batchSize' | 'cursor'>>;
  activityType?: Resolver<Maybe<ResolversTypes['TelephonyActivityType']>, ParentType, ContextType, RequireFields<telephonysubscription_rootactivityTypeArgs, 'value'>>;
  activityTypes?: Resolver<Array<ResolversTypes['TelephonyActivityType']>, ParentType, ContextType, Partial<telephonysubscription_rootactivityTypesArgs>>;
  activityTypesAggregate?: Resolver<ResolversTypes['TelephonyActivityTypeAggregate'], ParentType, ContextType, Partial<telephonysubscription_rootactivityTypesAggregateArgs>>;
  activityTypesStream?: Resolver<Array<ResolversTypes['TelephonyActivityType']>, ParentType, ContextType, RequireFields<telephonysubscription_rootactivityTypesStreamArgs, 'batchSize' | 'cursor'>>;
  callDirection?: Resolver<Maybe<ResolversTypes['TelephonyCallDirection']>, ParentType, ContextType, RequireFields<telephonysubscription_rootcallDirectionArgs, 'value'>>;
  callDirections?: Resolver<Array<ResolversTypes['TelephonyCallDirection']>, ParentType, ContextType, Partial<telephonysubscription_rootcallDirectionsArgs>>;
  callDirectionsAggregate?: Resolver<ResolversTypes['TelephonyCallDirectionAggregate'], ParentType, ContextType, Partial<telephonysubscription_rootcallDirectionsAggregateArgs>>;
  callDirectionsStream?: Resolver<Array<ResolversTypes['TelephonyCallDirection']>, ParentType, ContextType, RequireFields<telephonysubscription_rootcallDirectionsStreamArgs, 'batchSize' | 'cursor'>>;
  comment?: Resolver<Maybe<ResolversTypes['Telephonycomment']>, ParentType, ContextType, RequireFields<telephonysubscription_rootcommentArgs, 'id'>>;
  comments?: Resolver<Array<ResolversTypes['Telephonycomment']>, ParentType, ContextType, Partial<telephonysubscription_rootcommentsArgs>>;
  commentsAggregate?: Resolver<ResolversTypes['TelephonycommentAggregate'], ParentType, ContextType, Partial<telephonysubscription_rootcommentsAggregateArgs>>;
  commentsStream?: Resolver<Array<ResolversTypes['Telephonycomment']>, ParentType, ContextType, RequireFields<telephonysubscription_rootcommentsStreamArgs, 'batchSize' | 'cursor'>>;
  domainOrganization?: Resolver<Maybe<ResolversTypes['TelephonydomainOrganization']>, ParentType, ContextType, RequireFields<telephonysubscription_rootdomainOrganizationArgs, 'id'>>;
  domainOrganizations?: Resolver<Array<ResolversTypes['TelephonydomainOrganization']>, ParentType, ContextType, Partial<telephonysubscription_rootdomainOrganizationsArgs>>;
  domainOrganizationsAggregate?: Resolver<ResolversTypes['TelephonydomainOrganizationAggregate'], ParentType, ContextType, Partial<telephonysubscription_rootdomainOrganizationsAggregateArgs>>;
  domainOrganizationsStream?: Resolver<Array<ResolversTypes['TelephonydomainOrganization']>, ParentType, ContextType, RequireFields<telephonysubscription_rootdomainOrganizationsStreamArgs, 'batchSize' | 'cursor'>>;
  domainUser?: Resolver<Maybe<ResolversTypes['TelephonydomainUser']>, ParentType, ContextType, RequireFields<telephonysubscription_rootdomainUserArgs, 'id'>>;
  domainUserCategories?: Resolver<Array<ResolversTypes['TelephonyDomainUserCategory']>, ParentType, ContextType, Partial<telephonysubscription_rootdomainUserCategoriesArgs>>;
  domainUserCategoriesAggregate?: Resolver<ResolversTypes['TelephonyDomainUserCategoryAggregate'], ParentType, ContextType, Partial<telephonysubscription_rootdomainUserCategoriesAggregateArgs>>;
  domainUserCategoriesStream?: Resolver<Array<ResolversTypes['TelephonyDomainUserCategory']>, ParentType, ContextType, RequireFields<telephonysubscription_rootdomainUserCategoriesStreamArgs, 'batchSize' | 'cursor'>>;
  domainUserCategory?: Resolver<Maybe<ResolversTypes['TelephonyDomainUserCategory']>, ParentType, ContextType, RequireFields<telephonysubscription_rootdomainUserCategoryArgs, 'value'>>;
  domainUsers?: Resolver<Array<ResolversTypes['TelephonydomainUser']>, ParentType, ContextType, Partial<telephonysubscription_rootdomainUsersArgs>>;
  domainUsersAggregate?: Resolver<ResolversTypes['TelephonydomainUserAggregate'], ParentType, ContextType, Partial<telephonysubscription_rootdomainUsersAggregateArgs>>;
  domainUsersStream?: Resolver<Array<ResolversTypes['TelephonydomainUser']>, ParentType, ContextType, RequireFields<telephonysubscription_rootdomainUsersStreamArgs, 'batchSize' | 'cursor'>>;
  event?: Resolver<Maybe<ResolversTypes['Telephonyevent']>, ParentType, ContextType, RequireFields<telephonysubscription_rooteventArgs, 'id'>>;
  eventActionAggregate?: Resolver<ResolversTypes['TelephonyeventActionAggregate'], ParentType, ContextType, Partial<telephonysubscription_rooteventActionAggregateArgs>>;
  eventActionByPk?: Resolver<Maybe<ResolversTypes['TelephonyeventAction']>, ParentType, ContextType, RequireFields<telephonysubscription_rooteventActionByPkArgs, 'id'>>;
  eventActionStream?: Resolver<Array<ResolversTypes['TelephonyeventAction']>, ParentType, ContextType, RequireFields<telephonysubscription_rooteventActionStreamArgs, 'batchSize' | 'cursor'>>;
  eventActions?: Resolver<Array<ResolversTypes['TelephonyeventAction']>, ParentType, ContextType, Partial<telephonysubscription_rooteventActionsArgs>>;
  events?: Resolver<Array<ResolversTypes['Telephonyevent']>, ParentType, ContextType, Partial<telephonysubscription_rooteventsArgs>>;
  eventsAggregate?: Resolver<ResolversTypes['TelephonyeventAggregate'], ParentType, ContextType, Partial<telephonysubscription_rooteventsAggregateArgs>>;
  eventsStream?: Resolver<Array<ResolversTypes['Telephonyevent']>, ParentType, ContextType, RequireFields<telephonysubscription_rooteventsStreamArgs, 'batchSize' | 'cursor'>>;
  numberState?: Resolver<Maybe<ResolversTypes['TelephonyNumberState']>, ParentType, ContextType, RequireFields<telephonysubscription_rootnumberStateArgs, 'value'>>;
  numberStates?: Resolver<Array<ResolversTypes['TelephonyNumberState']>, ParentType, ContextType, Partial<telephonysubscription_rootnumberStatesArgs>>;
  numberStatesAggregate?: Resolver<ResolversTypes['TelephonyNumberStateAggregate'], ParentType, ContextType, Partial<telephonysubscription_rootnumberStatesAggregateArgs>>;
  numberStatesStream?: Resolver<Array<ResolversTypes['TelephonyNumberState']>, ParentType, ContextType, RequireFields<telephonysubscription_rootnumberStatesStreamArgs, 'batchSize' | 'cursor'>>;
  provider?: Resolver<Maybe<ResolversTypes['Telephonyprovider']>, ParentType, ContextType, RequireFields<telephonysubscription_rootproviderArgs, 'id'>>;
  providerAccount?: Resolver<Maybe<ResolversTypes['TelephonyproviderAccount']>, ParentType, ContextType, RequireFields<telephonysubscription_rootproviderAccountArgs, 'id'>>;
  providerAccounts?: Resolver<Array<ResolversTypes['TelephonyproviderAccount']>, ParentType, ContextType, Partial<telephonysubscription_rootproviderAccountsArgs>>;
  providerAccountsAggregate?: Resolver<ResolversTypes['TelephonyproviderAccountAggregate'], ParentType, ContextType, Partial<telephonysubscription_rootproviderAccountsAggregateArgs>>;
  providerAccountsStream?: Resolver<Array<ResolversTypes['TelephonyproviderAccount']>, ParentType, ContextType, RequireFields<telephonysubscription_rootproviderAccountsStreamArgs, 'batchSize' | 'cursor'>>;
  providerAggregate?: Resolver<ResolversTypes['TelephonyproviderAggregate'], ParentType, ContextType, Partial<telephonysubscription_rootproviderAggregateArgs>>;
  providerRequestTerm?: Resolver<Maybe<ResolversTypes['TelephonyproviderRequestTerm']>, ParentType, ContextType, RequireFields<telephonysubscription_rootproviderRequestTermArgs, 'id'>>;
  providerRequestTerms?: Resolver<Array<ResolversTypes['TelephonyproviderRequestTerm']>, ParentType, ContextType, Partial<telephonysubscription_rootproviderRequestTermsArgs>>;
  providerRequestTermsAggregate?: Resolver<ResolversTypes['TelephonyproviderRequestTermAggregate'], ParentType, ContextType, Partial<telephonysubscription_rootproviderRequestTermsAggregateArgs>>;
  providerRequestTermsStream?: Resolver<Array<ResolversTypes['TelephonyproviderRequestTerm']>, ParentType, ContextType, RequireFields<telephonysubscription_rootproviderRequestTermsStreamArgs, 'batchSize' | 'cursor'>>;
  providerStream?: Resolver<Array<ResolversTypes['Telephonyprovider']>, ParentType, ContextType, RequireFields<telephonysubscription_rootproviderStreamArgs, 'batchSize' | 'cursor'>>;
  providerType?: Resolver<Maybe<ResolversTypes['TelephonyProviderType']>, ParentType, ContextType, RequireFields<telephonysubscription_rootproviderTypeArgs, 'value'>>;
  providerTypes?: Resolver<Array<ResolversTypes['TelephonyProviderType']>, ParentType, ContextType, Partial<telephonysubscription_rootproviderTypesArgs>>;
  providerTypesAggregate?: Resolver<ResolversTypes['TelephonyProviderTypeAggregate'], ParentType, ContextType, Partial<telephonysubscription_rootproviderTypesAggregateArgs>>;
  providerTypesStream?: Resolver<Array<ResolversTypes['TelephonyProviderType']>, ParentType, ContextType, RequireFields<telephonysubscription_rootproviderTypesStreamArgs, 'batchSize' | 'cursor'>>;
  providers?: Resolver<Array<ResolversTypes['Telephonyprovider']>, ParentType, ContextType, Partial<telephonysubscription_rootprovidersArgs>>;
  telephonyActionEventType?: Resolver<Array<ResolversTypes['TelephonyTelephonyActionEventType']>, ParentType, ContextType, Partial<telephonysubscription_roottelephonyActionEventTypeArgs>>;
  telephonyActionEventTypeAggregate?: Resolver<ResolversTypes['TelephonyTelephonyActionEventTypeAggregate'], ParentType, ContextType, Partial<telephonysubscription_roottelephonyActionEventTypeAggregateArgs>>;
  telephonyActionEventTypeByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyActionEventType']>, ParentType, ContextType, RequireFields<telephonysubscription_roottelephonyActionEventTypeByPkArgs, 'value'>>;
  telephonyActionEventTypeStream?: Resolver<Array<ResolversTypes['TelephonyTelephonyActionEventType']>, ParentType, ContextType, RequireFields<telephonysubscription_roottelephonyActionEventTypeStreamArgs, 'batchSize' | 'cursor'>>;
  telephonyActionType?: Resolver<Array<ResolversTypes['TelephonyTelephonyActionType']>, ParentType, ContextType, Partial<telephonysubscription_roottelephonyActionTypeArgs>>;
  telephonyActionTypeAggregate?: Resolver<ResolversTypes['TelephonyTelephonyActionTypeAggregate'], ParentType, ContextType, Partial<telephonysubscription_roottelephonyActionTypeAggregateArgs>>;
  telephonyActionTypeByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyActionType']>, ParentType, ContextType, RequireFields<telephonysubscription_roottelephonyActionTypeByPkArgs, 'value'>>;
  telephonyActionTypeStream?: Resolver<Array<ResolversTypes['TelephonyTelephonyActionType']>, ParentType, ContextType, RequireFields<telephonysubscription_roottelephonyActionTypeStreamArgs, 'batchSize' | 'cursor'>>;
  telephonyBlockedDomainUser?: Resolver<Array<ResolversTypes['TelephonyTelephonyBlockedDomainUser']>, ParentType, ContextType, Partial<telephonysubscription_roottelephonyBlockedDomainUserArgs>>;
  telephonyBlockedDomainUserAggregate?: Resolver<ResolversTypes['TelephonyTelephonyBlockedDomainUserAggregate'], ParentType, ContextType, Partial<telephonysubscription_roottelephonyBlockedDomainUserAggregateArgs>>;
  telephonyBlockedDomainUserByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyBlockedDomainUser']>, ParentType, ContextType, RequireFields<telephonysubscription_roottelephonyBlockedDomainUserByPkArgs, 'id'>>;
  telephonyBlockedDomainUserStream?: Resolver<Array<ResolversTypes['TelephonyTelephonyBlockedDomainUser']>, ParentType, ContextType, RequireFields<telephonysubscription_roottelephonyBlockedDomainUserStreamArgs, 'batchSize' | 'cursor'>>;
  telephonyCiscoSubscriberProduct?: Resolver<Array<ResolversTypes['TelephonyTelephonyCiscoSubscriberProduct']>, ParentType, ContextType, Partial<telephonysubscription_roottelephonyCiscoSubscriberProductArgs>>;
  telephonyCiscoSubscriberProductAggregate?: Resolver<ResolversTypes['TelephonyTelephonyCiscoSubscriberProductAggregate'], ParentType, ContextType, Partial<telephonysubscription_roottelephonyCiscoSubscriberProductAggregateArgs>>;
  telephonyCiscoSubscriberProductByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyCiscoSubscriberProduct']>, ParentType, ContextType, RequireFields<telephonysubscription_roottelephonyCiscoSubscriberProductByPkArgs, 'id'>>;
  telephonyCiscoSubscriberProductStream?: Resolver<Array<ResolversTypes['TelephonyTelephonyCiscoSubscriberProduct']>, ParentType, ContextType, RequireFields<telephonysubscription_roottelephonyCiscoSubscriberProductStreamArgs, 'batchSize' | 'cursor'>>;
  telephonyEvents?: Resolver<Array<ResolversTypes['TelephonyTelephonyEvents']>, ParentType, ContextType, Partial<telephonysubscription_roottelephonyEventsArgs>>;
  telephonyEventsAggregate?: Resolver<ResolversTypes['TelephonyTelephonyEventsAggregate'], ParentType, ContextType, Partial<telephonysubscription_roottelephonyEventsAggregateArgs>>;
  telephonyEventsByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyEvents']>, ParentType, ContextType, RequireFields<telephonysubscription_roottelephonyEventsByPkArgs, 'id'>>;
  telephonyEventsStream?: Resolver<Array<ResolversTypes['TelephonyTelephonyEvents']>, ParentType, ContextType, RequireFields<telephonysubscription_roottelephonyEventsStreamArgs, 'batchSize' | 'cursor'>>;
  telephonyLookupCallerApi?: Resolver<Array<ResolversTypes['TelephonyTelephonyLookupCallerApi']>, ParentType, ContextType, Partial<telephonysubscription_roottelephonyLookupCallerApiArgs>>;
  telephonyLookupCallerApiAggregate?: Resolver<ResolversTypes['TelephonyTelephonyLookupCallerApiAggregate'], ParentType, ContextType, Partial<telephonysubscription_roottelephonyLookupCallerApiAggregateArgs>>;
  telephonyLookupCallerApiByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupCallerApi']>, ParentType, ContextType, RequireFields<telephonysubscription_roottelephonyLookupCallerApiByPkArgs, 'id'>>;
  telephonyLookupCallerApiStream?: Resolver<Array<ResolversTypes['TelephonyTelephonyLookupCallerApi']>, ParentType, ContextType, RequireFields<telephonysubscription_roottelephonyLookupCallerApiStreamArgs, 'batchSize' | 'cursor'>>;
  telephonyLookupRefresh?: Resolver<Array<ResolversTypes['TelephonyTelephonyLookupRefresh']>, ParentType, ContextType, Partial<telephonysubscription_roottelephonyLookupRefreshArgs>>;
  telephonyLookupRefreshAggregate?: Resolver<ResolversTypes['TelephonyTelephonyLookupRefreshAggregate'], ParentType, ContextType, Partial<telephonysubscription_roottelephonyLookupRefreshAggregateArgs>>;
  telephonyLookupRefreshByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupRefresh']>, ParentType, ContextType, RequireFields<telephonysubscription_roottelephonyLookupRefreshByPkArgs, 'type'>>;
  telephonyLookupRefreshStream?: Resolver<Array<ResolversTypes['TelephonyTelephonyLookupRefresh']>, ParentType, ContextType, RequireFields<telephonysubscription_roottelephonyLookupRefreshStreamArgs, 'batchSize' | 'cursor'>>;
  telephonyLookupTypes?: Resolver<Array<ResolversTypes['TelephonyTelephonyLookupTypes']>, ParentType, ContextType, Partial<telephonysubscription_roottelephonyLookupTypesArgs>>;
  telephonyLookupTypesAggregate?: Resolver<ResolversTypes['TelephonyTelephonyLookupTypesAggregate'], ParentType, ContextType, Partial<telephonysubscription_roottelephonyLookupTypesAggregateArgs>>;
  telephonyLookupTypesByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyLookupTypes']>, ParentType, ContextType, RequireFields<telephonysubscription_roottelephonyLookupTypesByPkArgs, 'value'>>;
  telephonyLookupTypesStream?: Resolver<Array<ResolversTypes['TelephonyTelephonyLookupTypes']>, ParentType, ContextType, RequireFields<telephonysubscription_roottelephonyLookupTypesStreamArgs, 'batchSize' | 'cursor'>>;
  telephonyPods?: Resolver<Array<ResolversTypes['TelephonyTelephonyPods']>, ParentType, ContextType, Partial<telephonysubscription_roottelephonyPodsArgs>>;
  telephonyPodsAggregate?: Resolver<ResolversTypes['TelephonyTelephonyPodsAggregate'], ParentType, ContextType, Partial<telephonysubscription_roottelephonyPodsAggregateArgs>>;
  telephonyPodsByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyPods']>, ParentType, ContextType, RequireFields<telephonysubscription_roottelephonyPodsByPkArgs, 'id'>>;
  telephonyPodsStream?: Resolver<Array<ResolversTypes['TelephonyTelephonyPods']>, ParentType, ContextType, RequireFields<telephonysubscription_roottelephonyPodsStreamArgs, 'batchSize' | 'cursor'>>;
  telephonyProviderAccess?: Resolver<Array<ResolversTypes['TelephonyTelephonyProviderAccess']>, ParentType, ContextType, Partial<telephonysubscription_roottelephonyProviderAccessArgs>>;
  telephonyProviderAccessAggregate?: Resolver<ResolversTypes['TelephonyTelephonyProviderAccessAggregate'], ParentType, ContextType, Partial<telephonysubscription_roottelephonyProviderAccessAggregateArgs>>;
  telephonyProviderAccessByPk?: Resolver<Maybe<ResolversTypes['TelephonyTelephonyProviderAccess']>, ParentType, ContextType, RequireFields<telephonysubscription_roottelephonyProviderAccessByPkArgs, 'value'>>;
  telephonyProviderAccessStream?: Resolver<Array<ResolversTypes['TelephonyTelephonyProviderAccess']>, ParentType, ContextType, RequireFields<telephonysubscription_roottelephonyProviderAccessStreamArgs, 'batchSize' | 'cursor'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type testNotificationSettingsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['testNotificationSettingsResult'] = ResolversParentTypes['testNotificationSettingsResult']> = {
  result?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface timestampScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['timestamp'], any> {
  name: 'timestamp';
}

export interface timestamptzScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['timestamptz'], any> {
  name: 'timestamptz';
}

export interface timetzScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['timetz'], any> {
  name: 'timetz';
}

export type updateDashboardDataOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['updateDashboardDataOutput'] = ResolversParentTypes['updateDashboardDataOutput']> = {
  json?: Resolver<Maybe<ResolversTypes['json']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userResolvers<ContextType = any, ParentType extends ResolversParentTypes['user'] = ResolversParentTypes['user']> = {
  authId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chosenLanguage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  completedFirstTimeUser?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  customerCards?: Resolver<Array<ResolversTypes['organizationUser']>, ParentType, ContextType, Partial<usercustomerCardsArgs>>;
  customerCardsAggregate?: Resolver<ResolversTypes['organizationUserAggregate'], ParentType, ContextType, Partial<usercustomerCardsAggregateArgs>>;
  domainActivities?: Resolver<Array<ResolversTypes['domainActivity']>, ParentType, ContextType, Partial<userdomainActivitiesArgs>>;
  domainActivitiesAggregate?: Resolver<ResolversTypes['domainActivityAggregate'], ParentType, ContextType, Partial<userdomainActivitiesAggregateArgs>>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastSeen?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['messagingMessage']>, ParentType, ContextType, Partial<usermessagesArgs>>;
  messagesAggregate?: Resolver<ResolversTypes['messagingMessageAggregate'], ParentType, ContextType, Partial<usermessagesAggregateArgs>>;
  notes?: Resolver<Array<ResolversTypes['message']>, ParentType, ContextType, Partial<usernotesArgs>>;
  notesAggregate?: Resolver<ResolversTypes['messageAggregate'], ParentType, ContextType, Partial<usernotesAggregateArgs>>;
  notificationUserDevices?: Resolver<Array<ResolversTypes['notificationUserDevice']>, ParentType, ContextType, Partial<usernotificationUserDevicesArgs>>;
  notificationUserDevicesAggregate?: Resolver<ResolversTypes['notificationUserDeviceAggregate'], ParentType, ContextType, Partial<usernotificationUserDevicesAggregateArgs>>;
  orderIntegrations?: Resolver<Maybe<ResolversTypes['ordersIntegrations']>, ParentType, ContextType>;
  organizationRequests?: Resolver<Array<ResolversTypes['BusinessOrganizationUserRequest']>, ParentType, ContextType, Partial<userorganizationRequestsArgs>>;
  organizationRequestsAggregate?: Resolver<ResolversTypes['BusinessOrganizationUserRequestAggregate'], ParentType, ContextType, Partial<userorganizationRequestsAggregateArgs>>;
  organizationUserInvitations?: Resolver<Array<ResolversTypes['organizationUserInvite']>, ParentType, ContextType, Partial<userorganizationUserInvitationsArgs>>;
  organizationUserInvitationsAggregate?: Resolver<ResolversTypes['organizationUserInviteAggregate'], ParentType, ContextType, Partial<userorganizationUserInvitationsAggregateArgs>>;
  organizationUsers?: Resolver<Array<ResolversTypes['organizationUser']>, ParentType, ContextType, Partial<userorganizationUsersArgs>>;
  organizationUsersAggregate?: Resolver<ResolversTypes['organizationUserAggregate'], ParentType, ContextType, Partial<userorganizationUsersAggregateArgs>>;
  organizations?: Resolver<Array<ResolversTypes['organizationOrganizationUserOrganizationsView']>, ParentType, ContextType, Partial<userorganizationsArgs>>;
  organizationsAggregate?: Resolver<ResolversTypes['organizationOrganizationUserOrganizationsViewAggregate'], ParentType, ContextType, Partial<userorganizationsAggregateArgs>>;
  organizationsByOwnerId?: Resolver<Array<ResolversTypes['organization']>, ParentType, ContextType, Partial<userorganizationsByOwnerIdArgs>>;
  organizationsByOwnerIdAggregate?: Resolver<ResolversTypes['organizationAggregate'], ParentType, ContextType, Partial<userorganizationsByOwnerIdAggregateArgs>>;
  organizations_object?: Resolver<Maybe<ResolversTypes['organizationOrganizationUserUsersView']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumberIsVerified?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  phoneState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  states?: Resolver<Array<ResolversTypes['BusinessUserStates']>, ParentType, ContextType, Partial<userstatesArgs>>;
  statesAggregate?: Resolver<ResolversTypes['BusinessUserStatesAggregate'], ParentType, ContextType, Partial<userstatesAggregateArgs>>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  userFeed?: Resolver<Array<ResolversTypes['BusinessUserFeed']>, ParentType, ContextType, Partial<useruserFeedArgs>>;
  userFeedAggregate?: Resolver<ResolversTypes['BusinessUserFeedAggregate'], ParentType, ContextType, Partial<useruserFeedAggregateArgs>>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['userAggregate'] = ResolversParentTypes['userAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['userAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['user']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['userAggregateFields'] = ResolversParentTypes['userAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<userAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['userMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['userMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userDeleteOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['userDeleteOutput'] = ResolversParentTypes['userDeleteOutput']> = {
  result?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['userDetail'] = ResolversParentTypes['userDetail']> = {
  createdAt?: Resolver<ResolversTypes['timestamp'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  modifiedBy?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['userDetailsTypeEnum'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamp'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userDetailAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['userDetailAggregate'] = ResolversParentTypes['userDetailAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['userDetailAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['userDetail']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userDetailAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['userDetailAggregateFields'] = ResolversParentTypes['userDetailAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<userDetailAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['userDetailMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['userDetailMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userDetailMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['userDetailMaxFields'] = ResolversParentTypes['userDetailMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  modifiedBy?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userDetailMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['userDetailMinFields'] = ResolversParentTypes['userDetailMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  modifiedBy?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userDetailMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['userDetailMutationResponse'] = ResolversParentTypes['userDetailMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['userDetail']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userDetailsTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['userDetailsType'] = ResolversParentTypes['userDetailsType']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userDetailsAggregate?: Resolver<ResolversTypes['userDetailAggregate'], ParentType, ContextType, Partial<userDetailsTypeuserDetailsAggregateArgs>>;
  user_details?: Resolver<Array<ResolversTypes['userDetail']>, ParentType, ContextType, Partial<userDetailsTypeuser_detailsArgs>>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userDetailsTypeAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['userDetailsTypeAggregate'] = ResolversParentTypes['userDetailsTypeAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['userDetailsTypeAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['userDetailsType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userDetailsTypeAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['userDetailsTypeAggregateFields'] = ResolversParentTypes['userDetailsTypeAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<userDetailsTypeAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['userDetailsTypeMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['userDetailsTypeMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userDetailsTypeMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['userDetailsTypeMaxFields'] = ResolversParentTypes['userDetailsTypeMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userDetailsTypeMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['userDetailsTypeMinFields'] = ResolversParentTypes['userDetailsTypeMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userDetailsTypeMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['userDetailsTypeMutationResponse'] = ResolversParentTypes['userDetailsTypeMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['userDetailsType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userDeviceResolvers<ContextType = any, ParentType extends ResolversParentTypes['userDevice'] = ResolversParentTypes['userDevice']> = {
  deviceBrand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceIsDevice?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  deviceModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceOs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceOsVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  devicePushToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceYear?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userDeviceAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['userDeviceAggregate'] = ResolversParentTypes['userDeviceAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['userDeviceAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['userDevice']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userDeviceAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['userDeviceAggregateFields'] = ResolversParentTypes['userDeviceAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<userDeviceAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['userDeviceMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['userDeviceMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userDeviceMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['userDeviceMaxFields'] = ResolversParentTypes['userDeviceMaxFields']> = {
  deviceBrand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceOs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceOsVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  devicePushToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceYear?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userDeviceMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['userDeviceMinFields'] = ResolversParentTypes['userDeviceMinFields']> = {
  deviceBrand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceOs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceOsVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  devicePushToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceYear?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userDeviceMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['userDeviceMutationResponse'] = ResolversParentTypes['userDeviceMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['userDevice']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['userMaxFields'] = ResolversParentTypes['userMaxFields']> = {
  authId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chosenLanguage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastSeen?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['userMinFields'] = ResolversParentTypes['userMinFields']> = {
  authId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chosenLanguage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastSeen?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['userMutationResponse'] = ResolversParentTypes['userMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['user']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userPhoneNumberResolvers<ContextType = any, ParentType extends ResolversParentTypes['userPhoneNumber'] = ResolversParentTypes['userPhoneNumber']> = {
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  mobileNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  verificationStatus?: Resolver<Maybe<ResolversTypes['phoneNumberVerificationStatusEnum']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userPhoneNumberAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['userPhoneNumberAggregate'] = ResolversParentTypes['userPhoneNumberAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['userPhoneNumberAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['userPhoneNumber']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userPhoneNumberAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['userPhoneNumberAggregateFields'] = ResolversParentTypes['userPhoneNumberAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<userPhoneNumberAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['userPhoneNumberMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['userPhoneNumberMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userPhoneNumberMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['userPhoneNumberMaxFields'] = ResolversParentTypes['userPhoneNumberMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  mobileNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userPhoneNumberMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['userPhoneNumberMinFields'] = ResolversParentTypes['userPhoneNumberMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  mobileNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userPhoneNumberMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['userPhoneNumberMutationResponse'] = ResolversParentTypes['userPhoneNumberMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['userPhoneNumber']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userRoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['userRole'] = ResolversParentTypes['userRole']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userRoleAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['userRoleAggregate'] = ResolversParentTypes['userRoleAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['userRoleAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['userRole']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userRoleAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['userRoleAggregateFields'] = ResolversParentTypes['userRoleAggregateFields']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<userRoleAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['userRoleMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['userRoleMinFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userRoleMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['userRoleMaxFields'] = ResolversParentTypes['userRoleMaxFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userRoleMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['userRoleMinFields'] = ResolversParentTypes['userRoleMinFields']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type userRoleMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['userRoleMutationResponse'] = ResolversParentTypes['userRoleMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['userRole']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface uuidScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['uuid'], any> {
  name: 'uuid';
}

export type validationValidationResolvers<ContextType = any, ParentType extends ResolversParentTypes['validationValidation'] = ResolversParentTypes['validationValidation']> = {
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  expireTime?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  used?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['uuid'], ParentType, ContextType>;
  validateItem?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  verificationCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type validationValidationAggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['validationValidationAggregate'] = ResolversParentTypes['validationValidationAggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['validationValidationAggregateFields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['validationValidation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type validationValidationAggregateFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['validationValidationAggregateFields'] = ResolversParentTypes['validationValidationAggregateFields']> = {
  avg?: Resolver<Maybe<ResolversTypes['validationValidationAvgFields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<validationValidationAggregateFieldscountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['validationValidationMaxFields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['validationValidationMinFields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['validationValidationStddevFields']>, ParentType, ContextType>;
  stddevPop?: Resolver<Maybe<ResolversTypes['validationValidationStddevPopFields']>, ParentType, ContextType>;
  stddevSamp?: Resolver<Maybe<ResolversTypes['validationValidationStddevSampFields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['validationValidationSumFields']>, ParentType, ContextType>;
  varPop?: Resolver<Maybe<ResolversTypes['validationValidationVarPopFields']>, ParentType, ContextType>;
  varSamp?: Resolver<Maybe<ResolversTypes['validationValidationVarSampFields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['validationValidationVarianceFields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type validationValidationAvgFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['validationValidationAvgFields'] = ResolversParentTypes['validationValidationAvgFields']> = {
  expireTime?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type validationValidationMaxFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['validationValidationMaxFields'] = ResolversParentTypes['validationValidationMaxFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  expireTime?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  validateItem?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  verificationCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type validationValidationMinFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['validationValidationMinFields'] = ResolversParentTypes['validationValidationMinFields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  expireTime?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['uuid']>, ParentType, ContextType>;
  validateItem?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  verificationCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type validationValidationMutationResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['validationValidationMutationResponse'] = ResolversParentTypes['validationValidationMutationResponse']> = {
  affectedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['validationValidation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type validationValidationStddevFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['validationValidationStddevFields'] = ResolversParentTypes['validationValidationStddevFields']> = {
  expireTime?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type validationValidationStddevPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['validationValidationStddevPopFields'] = ResolversParentTypes['validationValidationStddevPopFields']> = {
  expireTime?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type validationValidationStddevSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['validationValidationStddevSampFields'] = ResolversParentTypes['validationValidationStddevSampFields']> = {
  expireTime?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type validationValidationSumFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['validationValidationSumFields'] = ResolversParentTypes['validationValidationSumFields']> = {
  expireTime?: Resolver<Maybe<ResolversTypes['numeric']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type validationValidationVarPopFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['validationValidationVarPopFields'] = ResolversParentTypes['validationValidationVarPopFields']> = {
  expireTime?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type validationValidationVarSampFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['validationValidationVarSampFields'] = ResolversParentTypes['validationValidationVarSampFields']> = {
  expireTime?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type validationValidationVarianceFieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['validationValidationVarianceFields'] = ResolversParentTypes['validationValidationVarianceFields']> = {
  expireTime?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type verifyOrganizationUserPhoneNumberOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['verifyOrganizationUserPhoneNumberOutput'] = ResolversParentTypes['verifyOrganizationUserPhoneNumberOutput']> = {
  verificationStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type videoInviteOrgUserOutputResolvers<ContextType = any, ParentType extends ResolversParentTypes['videoInviteOrgUserOutput'] = ResolversParentTypes['videoInviteOrgUserOutput']> = {
  result?: Resolver<ResolversTypes['json'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  ActivityDirection?: ActivityDirectionResolvers<ContextType>;
  ActivityDirectionAggregate?: ActivityDirectionAggregateResolvers<ContextType>;
  ActivityDirectionAggregateFields?: ActivityDirectionAggregateFieldsResolvers<ContextType>;
  ActivityDirectionMaxFields?: ActivityDirectionMaxFieldsResolvers<ContextType>;
  ActivityDirectionMinFields?: ActivityDirectionMinFieldsResolvers<ContextType>;
  ActivityDirectionMutationResponse?: ActivityDirectionMutationResponseResolvers<ContextType>;
  ActivityProvider?: ActivityProviderResolvers<ContextType>;
  ActivityProviderAggregate?: ActivityProviderAggregateResolvers<ContextType>;
  ActivityProviderAggregateFields?: ActivityProviderAggregateFieldsResolvers<ContextType>;
  ActivityProviderMaxFields?: ActivityProviderMaxFieldsResolvers<ContextType>;
  ActivityProviderMinFields?: ActivityProviderMinFieldsResolvers<ContextType>;
  ActivityProviderMutationResponse?: ActivityProviderMutationResponseResolvers<ContextType>;
  ActivityStatus?: ActivityStatusResolvers<ContextType>;
  ActivityStatusAggregate?: ActivityStatusAggregateResolvers<ContextType>;
  ActivityStatusAggregateFields?: ActivityStatusAggregateFieldsResolvers<ContextType>;
  ActivityStatusMaxFields?: ActivityStatusMaxFieldsResolvers<ContextType>;
  ActivityStatusMinFields?: ActivityStatusMinFieldsResolvers<ContextType>;
  ActivityStatusMutationResponse?: ActivityStatusMutationResponseResolvers<ContextType>;
  ActivityType?: ActivityTypeResolvers<ContextType>;
  ActivityTypeAggregate?: ActivityTypeAggregateResolvers<ContextType>;
  ActivityTypeAggregateFields?: ActivityTypeAggregateFieldsResolvers<ContextType>;
  ActivityTypeMaxFields?: ActivityTypeMaxFieldsResolvers<ContextType>;
  ActivityTypeMinFields?: ActivityTypeMinFieldsResolvers<ContextType>;
  ActivityTypeMutationResponse?: ActivityTypeMutationResponseResolvers<ContextType>;
  AddDomainUserToOrganizationOutput?: AddDomainUserToOrganizationOutputResolvers<ContextType>;
  BlockUserOutput?: BlockUserOutputResolvers<ContextType>;
  BusinessAddress?: BusinessAddressResolvers<ContextType>;
  BusinessDomainActivityType?: BusinessDomainActivityTypeResolvers<ContextType>;
  BusinessDomainActivityTypeAggregate?: BusinessDomainActivityTypeAggregateResolvers<ContextType>;
  BusinessDomainActivityTypeAggregateFields?: BusinessDomainActivityTypeAggregateFieldsResolvers<ContextType>;
  BusinessDomainActivityTypeMaxFields?: BusinessDomainActivityTypeMaxFieldsResolvers<ContextType>;
  BusinessDomainActivityTypeMinFields?: BusinessDomainActivityTypeMinFieldsResolvers<ContextType>;
  BusinessDomainActivityTypeMutationResponse?: BusinessDomainActivityTypeMutationResponseResolvers<ContextType>;
  BusinessFeedType?: BusinessFeedTypeResolvers<ContextType>;
  BusinessFeedTypeAggregate?: BusinessFeedTypeAggregateResolvers<ContextType>;
  BusinessFeedTypeAggregateFields?: BusinessFeedTypeAggregateFieldsResolvers<ContextType>;
  BusinessFeedTypeMaxFields?: BusinessFeedTypeMaxFieldsResolvers<ContextType>;
  BusinessFeedTypeMinFields?: BusinessFeedTypeMinFieldsResolvers<ContextType>;
  BusinessFeedTypeMutationResponse?: BusinessFeedTypeMutationResponseResolvers<ContextType>;
  BusinessMessageAttachments?: BusinessMessageAttachmentsResolvers<ContextType>;
  BusinessMessageAttachmentsAggregate?: BusinessMessageAttachmentsAggregateResolvers<ContextType>;
  BusinessMessageAttachmentsAggregateFields?: BusinessMessageAttachmentsAggregateFieldsResolvers<ContextType>;
  BusinessMessageAttachmentsMaxFields?: BusinessMessageAttachmentsMaxFieldsResolvers<ContextType>;
  BusinessMessageAttachmentsMinFields?: BusinessMessageAttachmentsMinFieldsResolvers<ContextType>;
  BusinessMessageAttachmentsMutationResponse?: BusinessMessageAttachmentsMutationResponseResolvers<ContextType>;
  BusinessOrganizationUserCallbackAnswer?: BusinessOrganizationUserCallbackAnswerResolvers<ContextType>;
  BusinessOrganizationUserCallbackAnswerAggregate?: BusinessOrganizationUserCallbackAnswerAggregateResolvers<ContextType>;
  BusinessOrganizationUserCallbackAnswerAggregateFields?: BusinessOrganizationUserCallbackAnswerAggregateFieldsResolvers<ContextType>;
  BusinessOrganizationUserCallbackAnswerMaxFields?: BusinessOrganizationUserCallbackAnswerMaxFieldsResolvers<ContextType>;
  BusinessOrganizationUserCallbackAnswerMinFields?: BusinessOrganizationUserCallbackAnswerMinFieldsResolvers<ContextType>;
  BusinessOrganizationUserCallbackAnswerMutationResponse?: BusinessOrganizationUserCallbackAnswerMutationResponseResolvers<ContextType>;
  BusinessOrganizationUserEmail?: BusinessOrganizationUserEmailResolvers<ContextType>;
  BusinessOrganizationUserEmailAggregate?: BusinessOrganizationUserEmailAggregateResolvers<ContextType>;
  BusinessOrganizationUserEmailAggregateFields?: BusinessOrganizationUserEmailAggregateFieldsResolvers<ContextType>;
  BusinessOrganizationUserEmailMaxFields?: BusinessOrganizationUserEmailMaxFieldsResolvers<ContextType>;
  BusinessOrganizationUserEmailMinFields?: BusinessOrganizationUserEmailMinFieldsResolvers<ContextType>;
  BusinessOrganizationUserEmailMutationResponse?: BusinessOrganizationUserEmailMutationResponseResolvers<ContextType>;
  BusinessOrganizationUserEmailType?: BusinessOrganizationUserEmailTypeResolvers<ContextType>;
  BusinessOrganizationUserEmailTypeAggregate?: BusinessOrganizationUserEmailTypeAggregateResolvers<ContextType>;
  BusinessOrganizationUserEmailTypeAggregateFields?: BusinessOrganizationUserEmailTypeAggregateFieldsResolvers<ContextType>;
  BusinessOrganizationUserEmailTypeMaxFields?: BusinessOrganizationUserEmailTypeMaxFieldsResolvers<ContextType>;
  BusinessOrganizationUserEmailTypeMinFields?: BusinessOrganizationUserEmailTypeMinFieldsResolvers<ContextType>;
  BusinessOrganizationUserEmailTypeMutationResponse?: BusinessOrganizationUserEmailTypeMutationResponseResolvers<ContextType>;
  BusinessOrganizationUserRequest?: BusinessOrganizationUserRequestResolvers<ContextType>;
  BusinessOrganizationUserRequestAggregate?: BusinessOrganizationUserRequestAggregateResolvers<ContextType>;
  BusinessOrganizationUserRequestAggregateFields?: BusinessOrganizationUserRequestAggregateFieldsResolvers<ContextType>;
  BusinessOrganizationUserRequestMaxFields?: BusinessOrganizationUserRequestMaxFieldsResolvers<ContextType>;
  BusinessOrganizationUserRequestMinFields?: BusinessOrganizationUserRequestMinFieldsResolvers<ContextType>;
  BusinessOrganizationUserRequestMutationResponse?: BusinessOrganizationUserRequestMutationResponseResolvers<ContextType>;
  BusinessOrganizationUserRequestType?: BusinessOrganizationUserRequestTypeResolvers<ContextType>;
  BusinessOrganizationUserRequestTypeAggregate?: BusinessOrganizationUserRequestTypeAggregateResolvers<ContextType>;
  BusinessOrganizationUserRequestTypeAggregateFields?: BusinessOrganizationUserRequestTypeAggregateFieldsResolvers<ContextType>;
  BusinessOrganizationUserRequestTypeMaxFields?: BusinessOrganizationUserRequestTypeMaxFieldsResolvers<ContextType>;
  BusinessOrganizationUserRequestTypeMinFields?: BusinessOrganizationUserRequestTypeMinFieldsResolvers<ContextType>;
  BusinessOrganizationUserRequestTypeMutationResponse?: BusinessOrganizationUserRequestTypeMutationResponseResolvers<ContextType>;
  BusinessOrganizationUserSuggestionType?: BusinessOrganizationUserSuggestionTypeResolvers<ContextType>;
  BusinessOrganizationUserSuggestionTypeAggregate?: BusinessOrganizationUserSuggestionTypeAggregateResolvers<ContextType>;
  BusinessOrganizationUserSuggestionTypeAggregateFields?: BusinessOrganizationUserSuggestionTypeAggregateFieldsResolvers<ContextType>;
  BusinessOrganizationUserSuggestionTypeMaxFields?: BusinessOrganizationUserSuggestionTypeMaxFieldsResolvers<ContextType>;
  BusinessOrganizationUserSuggestionTypeMinFields?: BusinessOrganizationUserSuggestionTypeMinFieldsResolvers<ContextType>;
  BusinessOrganizationUserSuggestionTypeMutationResponse?: BusinessOrganizationUserSuggestionTypeMutationResponseResolvers<ContextType>;
  BusinessOrganizationUserSuggestions?: BusinessOrganizationUserSuggestionsResolvers<ContextType>;
  BusinessOrganizationUserSuggestionsAggregate?: BusinessOrganizationUserSuggestionsAggregateResolvers<ContextType>;
  BusinessOrganizationUserSuggestionsAggregateFields?: BusinessOrganizationUserSuggestionsAggregateFieldsResolvers<ContextType>;
  BusinessOrganizationUserSuggestionsMaxFields?: BusinessOrganizationUserSuggestionsMaxFieldsResolvers<ContextType>;
  BusinessOrganizationUserSuggestionsMinFields?: BusinessOrganizationUserSuggestionsMinFieldsResolvers<ContextType>;
  BusinessOrganizationUserSuggestionsMutationResponse?: BusinessOrganizationUserSuggestionsMutationResponseResolvers<ContextType>;
  BusinessOrganizationUserUrlAddress?: BusinessOrganizationUserUrlAddressResolvers<ContextType>;
  BusinessOrganizationUserUrlAddressAggregate?: BusinessOrganizationUserUrlAddressAggregateResolvers<ContextType>;
  BusinessOrganizationUserUrlAddressAggregateFields?: BusinessOrganizationUserUrlAddressAggregateFieldsResolvers<ContextType>;
  BusinessOrganizationUserUrlAddressMaxFields?: BusinessOrganizationUserUrlAddressMaxFieldsResolvers<ContextType>;
  BusinessOrganizationUserUrlAddressMinFields?: BusinessOrganizationUserUrlAddressMinFieldsResolvers<ContextType>;
  BusinessOrganizationUserUrlAddressMutationResponse?: BusinessOrganizationUserUrlAddressMutationResponseResolvers<ContextType>;
  BusinessOrganizationUserUrlAddressType?: BusinessOrganizationUserUrlAddressTypeResolvers<ContextType>;
  BusinessOrganizationUserUrlAddressTypeAggregate?: BusinessOrganizationUserUrlAddressTypeAggregateResolvers<ContextType>;
  BusinessOrganizationUserUrlAddressTypeAggregateFields?: BusinessOrganizationUserUrlAddressTypeAggregateFieldsResolvers<ContextType>;
  BusinessOrganizationUserUrlAddressTypeMaxFields?: BusinessOrganizationUserUrlAddressTypeMaxFieldsResolvers<ContextType>;
  BusinessOrganizationUserUrlAddressTypeMinFields?: BusinessOrganizationUserUrlAddressTypeMinFieldsResolvers<ContextType>;
  BusinessOrganizationUserUrlAddressTypeMutationResponse?: BusinessOrganizationUserUrlAddressTypeMutationResponseResolvers<ContextType>;
  BusinessQueueItemAlarmType?: BusinessQueueItemAlarmTypeResolvers<ContextType>;
  BusinessQueueItemAlarmTypeAggregate?: BusinessQueueItemAlarmTypeAggregateResolvers<ContextType>;
  BusinessQueueItemAlarmTypeAggregateFields?: BusinessQueueItemAlarmTypeAggregateFieldsResolvers<ContextType>;
  BusinessQueueItemAlarmTypeMaxFields?: BusinessQueueItemAlarmTypeMaxFieldsResolvers<ContextType>;
  BusinessQueueItemAlarmTypeMinFields?: BusinessQueueItemAlarmTypeMinFieldsResolvers<ContextType>;
  BusinessQueueItemAlarmTypeMutationResponse?: BusinessQueueItemAlarmTypeMutationResponseResolvers<ContextType>;
  BusinessQueueItemAlarms?: BusinessQueueItemAlarmsResolvers<ContextType>;
  BusinessQueueItemAlarmsAggregate?: BusinessQueueItemAlarmsAggregateResolvers<ContextType>;
  BusinessQueueItemAlarmsAggregateFields?: BusinessQueueItemAlarmsAggregateFieldsResolvers<ContextType>;
  BusinessQueueItemAlarmsAvgFields?: BusinessQueueItemAlarmsAvgFieldsResolvers<ContextType>;
  BusinessQueueItemAlarmsMaxFields?: BusinessQueueItemAlarmsMaxFieldsResolvers<ContextType>;
  BusinessQueueItemAlarmsMinFields?: BusinessQueueItemAlarmsMinFieldsResolvers<ContextType>;
  BusinessQueueItemAlarmsMutationResponse?: BusinessQueueItemAlarmsMutationResponseResolvers<ContextType>;
  BusinessQueueItemAlarmsStddevFields?: BusinessQueueItemAlarmsStddevFieldsResolvers<ContextType>;
  BusinessQueueItemAlarmsStddevPopFields?: BusinessQueueItemAlarmsStddevPopFieldsResolvers<ContextType>;
  BusinessQueueItemAlarmsStddevSampFields?: BusinessQueueItemAlarmsStddevSampFieldsResolvers<ContextType>;
  BusinessQueueItemAlarmsSumFields?: BusinessQueueItemAlarmsSumFieldsResolvers<ContextType>;
  BusinessQueueItemAlarmsVarPopFields?: BusinessQueueItemAlarmsVarPopFieldsResolvers<ContextType>;
  BusinessQueueItemAlarmsVarSampFields?: BusinessQueueItemAlarmsVarSampFieldsResolvers<ContextType>;
  BusinessQueueItemAlarmsVarianceFields?: BusinessQueueItemAlarmsVarianceFieldsResolvers<ContextType>;
  BusinessQueueItemDomainUsersView?: BusinessQueueItemDomainUsersViewResolvers<ContextType>;
  BusinessQueueItemDomainUsersViewAggregate?: BusinessQueueItemDomainUsersViewAggregateResolvers<ContextType>;
  BusinessQueueItemDomainUsersViewAggregateFields?: BusinessQueueItemDomainUsersViewAggregateFieldsResolvers<ContextType>;
  BusinessQueueItemDomainUsersViewAvgFields?: BusinessQueueItemDomainUsersViewAvgFieldsResolvers<ContextType>;
  BusinessQueueItemDomainUsersViewMaxFields?: BusinessQueueItemDomainUsersViewMaxFieldsResolvers<ContextType>;
  BusinessQueueItemDomainUsersViewMinFields?: BusinessQueueItemDomainUsersViewMinFieldsResolvers<ContextType>;
  BusinessQueueItemDomainUsersViewStddevFields?: BusinessQueueItemDomainUsersViewStddevFieldsResolvers<ContextType>;
  BusinessQueueItemDomainUsersViewStddevPopFields?: BusinessQueueItemDomainUsersViewStddevPopFieldsResolvers<ContextType>;
  BusinessQueueItemDomainUsersViewStddevSampFields?: BusinessQueueItemDomainUsersViewStddevSampFieldsResolvers<ContextType>;
  BusinessQueueItemDomainUsersViewSumFields?: BusinessQueueItemDomainUsersViewSumFieldsResolvers<ContextType>;
  BusinessQueueItemDomainUsersViewVarPopFields?: BusinessQueueItemDomainUsersViewVarPopFieldsResolvers<ContextType>;
  BusinessQueueItemDomainUsersViewVarSampFields?: BusinessQueueItemDomainUsersViewVarSampFieldsResolvers<ContextType>;
  BusinessQueueItemDomainUsersViewVarianceFields?: BusinessQueueItemDomainUsersViewVarianceFieldsResolvers<ContextType>;
  BusinessQueueItemOrganizationUsersView?: BusinessQueueItemOrganizationUsersViewResolvers<ContextType>;
  BusinessQueueItemOrganizationUsersViewAggregate?: BusinessQueueItemOrganizationUsersViewAggregateResolvers<ContextType>;
  BusinessQueueItemOrganizationUsersViewAggregateFields?: BusinessQueueItemOrganizationUsersViewAggregateFieldsResolvers<ContextType>;
  BusinessQueueItemOrganizationUsersViewMaxFields?: BusinessQueueItemOrganizationUsersViewMaxFieldsResolvers<ContextType>;
  BusinessQueueItemOrganizationUsersViewMinFields?: BusinessQueueItemOrganizationUsersViewMinFieldsResolvers<ContextType>;
  BusinessQueueItemParticipantChannelType?: BusinessQueueItemParticipantChannelTypeResolvers<ContextType>;
  BusinessQueueItemParticipantChannelTypeAggregate?: BusinessQueueItemParticipantChannelTypeAggregateResolvers<ContextType>;
  BusinessQueueItemParticipantChannelTypeAggregateFields?: BusinessQueueItemParticipantChannelTypeAggregateFieldsResolvers<ContextType>;
  BusinessQueueItemParticipantChannelTypeMaxFields?: BusinessQueueItemParticipantChannelTypeMaxFieldsResolvers<ContextType>;
  BusinessQueueItemParticipantChannelTypeMinFields?: BusinessQueueItemParticipantChannelTypeMinFieldsResolvers<ContextType>;
  BusinessQueueItemParticipantChannelTypeMutationResponse?: BusinessQueueItemParticipantChannelTypeMutationResponseResolvers<ContextType>;
  BusinessQueueItemParticipantsView?: BusinessQueueItemParticipantsViewResolvers<ContextType>;
  BusinessQueueItemParticipantsViewAggregate?: BusinessQueueItemParticipantsViewAggregateResolvers<ContextType>;
  BusinessQueueItemParticipantsViewAggregateFields?: BusinessQueueItemParticipantsViewAggregateFieldsResolvers<ContextType>;
  BusinessQueueItemParticipantsViewMaxFields?: BusinessQueueItemParticipantsViewMaxFieldsResolvers<ContextType>;
  BusinessQueueItemParticipantsViewMinFields?: BusinessQueueItemParticipantsViewMinFieldsResolvers<ContextType>;
  BusinessQueueItemSubType?: BusinessQueueItemSubTypeResolvers<ContextType>;
  BusinessQueueItemSubTypeAggregate?: BusinessQueueItemSubTypeAggregateResolvers<ContextType>;
  BusinessQueueItemSubTypeAggregateFields?: BusinessQueueItemSubTypeAggregateFieldsResolvers<ContextType>;
  BusinessQueueItemSubTypeMaxFields?: BusinessQueueItemSubTypeMaxFieldsResolvers<ContextType>;
  BusinessQueueItemSubTypeMinFields?: BusinessQueueItemSubTypeMinFieldsResolvers<ContextType>;
  BusinessQueueItemSubTypeMutationResponse?: BusinessQueueItemSubTypeMutationResponseResolvers<ContextType>;
  BusinessUserContactNumbers?: BusinessUserContactNumbersResolvers<ContextType>;
  BusinessUserContactNumbersAggregate?: BusinessUserContactNumbersAggregateResolvers<ContextType>;
  BusinessUserContactNumbersAggregateFields?: BusinessUserContactNumbersAggregateFieldsResolvers<ContextType>;
  BusinessUserContactNumbersMaxFields?: BusinessUserContactNumbersMaxFieldsResolvers<ContextType>;
  BusinessUserContactNumbersMinFields?: BusinessUserContactNumbersMinFieldsResolvers<ContextType>;
  BusinessUserContactNumbersMutationResponse?: BusinessUserContactNumbersMutationResponseResolvers<ContextType>;
  BusinessUserFeed?: BusinessUserFeedResolvers<ContextType>;
  BusinessUserFeedAggregate?: BusinessUserFeedAggregateResolvers<ContextType>;
  BusinessUserFeedAggregateFields?: BusinessUserFeedAggregateFieldsResolvers<ContextType>;
  BusinessUserFeedMaxFields?: BusinessUserFeedMaxFieldsResolvers<ContextType>;
  BusinessUserFeedMinFields?: BusinessUserFeedMinFieldsResolvers<ContextType>;
  BusinessUserFeedMutationResponse?: BusinessUserFeedMutationResponseResolvers<ContextType>;
  BusinessUserRequestStatus?: BusinessUserRequestStatusResolvers<ContextType>;
  BusinessUserRequestStatusAggregate?: BusinessUserRequestStatusAggregateResolvers<ContextType>;
  BusinessUserRequestStatusAggregateFields?: BusinessUserRequestStatusAggregateFieldsResolvers<ContextType>;
  BusinessUserRequestStatusMaxFields?: BusinessUserRequestStatusMaxFieldsResolvers<ContextType>;
  BusinessUserRequestStatusMinFields?: BusinessUserRequestStatusMinFieldsResolvers<ContextType>;
  BusinessUserRequestStatusMutationResponse?: BusinessUserRequestStatusMutationResponseResolvers<ContextType>;
  BusinessUserStates?: BusinessUserStatesResolvers<ContextType>;
  BusinessUserStatesAggregate?: BusinessUserStatesAggregateResolvers<ContextType>;
  BusinessUserStatesAggregateFields?: BusinessUserStatesAggregateFieldsResolvers<ContextType>;
  BusinessUserStatesMaxFields?: BusinessUserStatesMaxFieldsResolvers<ContextType>;
  BusinessUserStatesMinFields?: BusinessUserStatesMinFieldsResolvers<ContextType>;
  BusinessUserStatesMutationResponse?: BusinessUserStatesMutationResponseResolvers<ContextType>;
  ChangeOrganizationNameOutput?: ChangeOrganizationNameOutputResolvers<ContextType>;
  CheckOnetimeCodeOutput?: CheckOnetimeCodeOutputResolvers<ContextType>;
  CheckPhoneNumberOutput?: CheckPhoneNumberOutputResolvers<ContextType>;
  CreateSMSOutput?: CreateSMSOutputResolvers<ContextType>;
  CrmContext?: CrmContextResolvers<ContextType>;
  CrmContextAggregate?: CrmContextAggregateResolvers<ContextType>;
  CrmContextAggregateFields?: CrmContextAggregateFieldsResolvers<ContextType>;
  CrmContextMaxFields?: CrmContextMaxFieldsResolvers<ContextType>;
  CrmContextMinFields?: CrmContextMinFieldsResolvers<ContextType>;
  CrmContextMutationResponse?: CrmContextMutationResponseResolvers<ContextType>;
  CrmContextType?: CrmContextTypeResolvers<ContextType>;
  CrmContextTypeAggregate?: CrmContextTypeAggregateResolvers<ContextType>;
  CrmContextTypeAggregateFields?: CrmContextTypeAggregateFieldsResolvers<ContextType>;
  CrmContextTypeMaxFields?: CrmContextTypeMaxFieldsResolvers<ContextType>;
  CrmContextTypeMinFields?: CrmContextTypeMinFieldsResolvers<ContextType>;
  CrmContextTypeMutationResponse?: CrmContextTypeMutationResponseResolvers<ContextType>;
  CrmCreatorType?: CrmCreatorTypeResolvers<ContextType>;
  CrmCreatorTypeAggregate?: CrmCreatorTypeAggregateResolvers<ContextType>;
  CrmCreatorTypeAggregateFields?: CrmCreatorTypeAggregateFieldsResolvers<ContextType>;
  CrmCreatorTypeMaxFields?: CrmCreatorTypeMaxFieldsResolvers<ContextType>;
  CrmCreatorTypeMinFields?: CrmCreatorTypeMinFieldsResolvers<ContextType>;
  CrmCreatorTypeMutationResponse?: CrmCreatorTypeMutationResponseResolvers<ContextType>;
  CrmCrmType?: CrmCrmTypeResolvers<ContextType>;
  CrmCrmTypeAggregate?: CrmCrmTypeAggregateResolvers<ContextType>;
  CrmCrmTypeAggregateFields?: CrmCrmTypeAggregateFieldsResolvers<ContextType>;
  CrmCrmTypeMaxFields?: CrmCrmTypeMaxFieldsResolvers<ContextType>;
  CrmCrmTypeMinFields?: CrmCrmTypeMinFieldsResolvers<ContextType>;
  CrmCrmTypeMutationResponse?: CrmCrmTypeMutationResponseResolvers<ContextType>;
  CrmDirectionType?: CrmDirectionTypeResolvers<ContextType>;
  CrmDirectionTypeAggregate?: CrmDirectionTypeAggregateResolvers<ContextType>;
  CrmDirectionTypeAggregateFields?: CrmDirectionTypeAggregateFieldsResolvers<ContextType>;
  CrmDirectionTypeMaxFields?: CrmDirectionTypeMaxFieldsResolvers<ContextType>;
  CrmDirectionTypeMinFields?: CrmDirectionTypeMinFieldsResolvers<ContextType>;
  CrmDirectionTypeMutationResponse?: CrmDirectionTypeMutationResponseResolvers<ContextType>;
  CrmEntity?: CrmEntityResolvers<ContextType>;
  CrmEntityAggregate?: CrmEntityAggregateResolvers<ContextType>;
  CrmEntityAggregateFields?: CrmEntityAggregateFieldsResolvers<ContextType>;
  CrmEntityMaxFields?: CrmEntityMaxFieldsResolvers<ContextType>;
  CrmEntityMinFields?: CrmEntityMinFieldsResolvers<ContextType>;
  CrmEntityMutationResponse?: CrmEntityMutationResponseResolvers<ContextType>;
  CrmEvent?: CrmEventResolvers<ContextType>;
  CrmEventAggregate?: CrmEventAggregateResolvers<ContextType>;
  CrmEventAggregateFields?: CrmEventAggregateFieldsResolvers<ContextType>;
  CrmEventMaxFields?: CrmEventMaxFieldsResolvers<ContextType>;
  CrmEventMinFields?: CrmEventMinFieldsResolvers<ContextType>;
  CrmEventMutationResponse?: CrmEventMutationResponseResolvers<ContextType>;
  CrmEventType?: CrmEventTypeResolvers<ContextType>;
  CrmEventTypeAggregate?: CrmEventTypeAggregateResolvers<ContextType>;
  CrmEventTypeAggregateFields?: CrmEventTypeAggregateFieldsResolvers<ContextType>;
  CrmEventTypeMaxFields?: CrmEventTypeMaxFieldsResolvers<ContextType>;
  CrmEventTypeMinFields?: CrmEventTypeMinFieldsResolvers<ContextType>;
  CrmEventTypeMutationResponse?: CrmEventTypeMutationResponseResolvers<ContextType>;
  CrmStatusCode?: CrmStatusCodeResolvers<ContextType>;
  CrmStatusCodeAggregate?: CrmStatusCodeAggregateResolvers<ContextType>;
  CrmStatusCodeAggregateFields?: CrmStatusCodeAggregateFieldsResolvers<ContextType>;
  CrmStatusCodeMaxFields?: CrmStatusCodeMaxFieldsResolvers<ContextType>;
  CrmStatusCodeMinFields?: CrmStatusCodeMinFieldsResolvers<ContextType>;
  CrmStatusCodeMutationResponse?: CrmStatusCodeMutationResponseResolvers<ContextType>;
  CrmSystemType?: CrmSystemTypeResolvers<ContextType>;
  CrmSystemTypeAggregate?: CrmSystemTypeAggregateResolvers<ContextType>;
  CrmSystemTypeAggregateFields?: CrmSystemTypeAggregateFieldsResolvers<ContextType>;
  CrmSystemTypeMaxFields?: CrmSystemTypeMaxFieldsResolvers<ContextType>;
  CrmSystemTypeMinFields?: CrmSystemTypeMinFieldsResolvers<ContextType>;
  CrmSystemTypeMutationResponse?: CrmSystemTypeMutationResponseResolvers<ContextType>;
  CrmTraceContext?: CrmTraceContextResolvers<ContextType>;
  CrmTraceContextAggregate?: CrmTraceContextAggregateResolvers<ContextType>;
  CrmTraceContextAggregateFields?: CrmTraceContextAggregateFieldsResolvers<ContextType>;
  CrmTraceContextMaxFields?: CrmTraceContextMaxFieldsResolvers<ContextType>;
  CrmTraceContextMinFields?: CrmTraceContextMinFieldsResolvers<ContextType>;
  CrmTraceContextMutationResponse?: CrmTraceContextMutationResponseResolvers<ContextType>;
  CrmUnifiedEntityType?: CrmUnifiedEntityTypeResolvers<ContextType>;
  CrmUnifiedEntityTypeAggregate?: CrmUnifiedEntityTypeAggregateResolvers<ContextType>;
  CrmUnifiedEntityTypeAggregateFields?: CrmUnifiedEntityTypeAggregateFieldsResolvers<ContextType>;
  CrmUnifiedEntityTypeMaxFields?: CrmUnifiedEntityTypeMaxFieldsResolvers<ContextType>;
  CrmUnifiedEntityTypeMinFields?: CrmUnifiedEntityTypeMinFieldsResolvers<ContextType>;
  CrmUnifiedEntityTypeMutationResponse?: CrmUnifiedEntityTypeMutationResponseResolvers<ContextType>;
  DeleteRequestUserOutput?: DeleteRequestUserOutputResolvers<ContextType>;
  DeleteUserOutput?: DeleteUserOutputResolvers<ContextType>;
  EmailingEmailAccountSubscribers?: EmailingEmailAccountSubscribersResolvers<ContextType>;
  EmailingEmailAccountSubscribersAggregate?: EmailingEmailAccountSubscribersAggregateResolvers<ContextType>;
  EmailingEmailAccountSubscribersAggregateFields?: EmailingEmailAccountSubscribersAggregateFieldsResolvers<ContextType>;
  EmailingEmailAccountSubscribersMaxFields?: EmailingEmailAccountSubscribersMaxFieldsResolvers<ContextType>;
  EmailingEmailAccountSubscribersMinFields?: EmailingEmailAccountSubscribersMinFieldsResolvers<ContextType>;
  EmailingEmailAccountSubscribersMutationResponse?: EmailingEmailAccountSubscribersMutationResponseResolvers<ContextType>;
  EmailingEmailActivityType?: EmailingEmailActivityTypeResolvers<ContextType>;
  EmailingEmailActivityTypeAggregate?: EmailingEmailActivityTypeAggregateResolvers<ContextType>;
  EmailingEmailActivityTypeAggregateFields?: EmailingEmailActivityTypeAggregateFieldsResolvers<ContextType>;
  EmailingEmailActivityTypeMaxFields?: EmailingEmailActivityTypeMaxFieldsResolvers<ContextType>;
  EmailingEmailActivityTypeMinFields?: EmailingEmailActivityTypeMinFieldsResolvers<ContextType>;
  EmailingEmailActivityTypeMutationResponse?: EmailingEmailActivityTypeMutationResponseResolvers<ContextType>;
  EmailingEmailComment?: EmailingEmailCommentResolvers<ContextType>;
  EmailingEmailCommentAggregate?: EmailingEmailCommentAggregateResolvers<ContextType>;
  EmailingEmailCommentAggregateFields?: EmailingEmailCommentAggregateFieldsResolvers<ContextType>;
  EmailingEmailCommentMaxFields?: EmailingEmailCommentMaxFieldsResolvers<ContextType>;
  EmailingEmailCommentMinFields?: EmailingEmailCommentMinFieldsResolvers<ContextType>;
  EmailingEmailCommentMutationResponse?: EmailingEmailCommentMutationResponseResolvers<ContextType>;
  Emailingactivity?: EmailingactivityResolvers<ContextType>;
  EmailingactivityAggregate?: EmailingactivityAggregateResolvers<ContextType>;
  EmailingactivityAggregateFields?: EmailingactivityAggregateFieldsResolvers<ContextType>;
  EmailingactivityAvgFields?: EmailingactivityAvgFieldsResolvers<ContextType>;
  EmailingactivityMaxFields?: EmailingactivityMaxFieldsResolvers<ContextType>;
  EmailingactivityMinFields?: EmailingactivityMinFieldsResolvers<ContextType>;
  EmailingactivityMutationResponse?: EmailingactivityMutationResponseResolvers<ContextType>;
  EmailingactivityParticipant?: EmailingactivityParticipantResolvers<ContextType>;
  EmailingactivityParticipantAggregate?: EmailingactivityParticipantAggregateResolvers<ContextType>;
  EmailingactivityParticipantAggregateFields?: EmailingactivityParticipantAggregateFieldsResolvers<ContextType>;
  EmailingactivityParticipantMaxFields?: EmailingactivityParticipantMaxFieldsResolvers<ContextType>;
  EmailingactivityParticipantMinFields?: EmailingactivityParticipantMinFieldsResolvers<ContextType>;
  EmailingactivityParticipantMutationResponse?: EmailingactivityParticipantMutationResponseResolvers<ContextType>;
  EmailingactivityParticipantRole?: EmailingactivityParticipantRoleResolvers<ContextType>;
  EmailingactivityParticipantRoleAggregate?: EmailingactivityParticipantRoleAggregateResolvers<ContextType>;
  EmailingactivityParticipantRoleAggregateFields?: EmailingactivityParticipantRoleAggregateFieldsResolvers<ContextType>;
  EmailingactivityParticipantRoleMaxFields?: EmailingactivityParticipantRoleMaxFieldsResolvers<ContextType>;
  EmailingactivityParticipantRoleMinFields?: EmailingactivityParticipantRoleMinFieldsResolvers<ContextType>;
  EmailingactivityParticipantRoleMutationResponse?: EmailingactivityParticipantRoleMutationResponseResolvers<ContextType>;
  EmailingactivityStddevFields?: EmailingactivityStddevFieldsResolvers<ContextType>;
  EmailingactivityStddevPopFields?: EmailingactivityStddevPopFieldsResolvers<ContextType>;
  EmailingactivityStddevSampFields?: EmailingactivityStddevSampFieldsResolvers<ContextType>;
  EmailingactivitySumFields?: EmailingactivitySumFieldsResolvers<ContextType>;
  EmailingactivityVarPopFields?: EmailingactivityVarPopFieldsResolvers<ContextType>;
  EmailingactivityVarSampFields?: EmailingactivityVarSampFieldsResolvers<ContextType>;
  EmailingactivityVarianceFields?: EmailingactivityVarianceFieldsResolvers<ContextType>;
  EmailingdomainOrganization?: EmailingdomainOrganizationResolvers<ContextType>;
  EmailingdomainOrganizationAggregate?: EmailingdomainOrganizationAggregateResolvers<ContextType>;
  EmailingdomainOrganizationAggregateFields?: EmailingdomainOrganizationAggregateFieldsResolvers<ContextType>;
  EmailingdomainOrganizationMaxFields?: EmailingdomainOrganizationMaxFieldsResolvers<ContextType>;
  EmailingdomainOrganizationMinFields?: EmailingdomainOrganizationMinFieldsResolvers<ContextType>;
  EmailingdomainOrganizationMutationResponse?: EmailingdomainOrganizationMutationResponseResolvers<ContextType>;
  EmailingdomainUser?: EmailingdomainUserResolvers<ContextType>;
  EmailingdomainUserAggregate?: EmailingdomainUserAggregateResolvers<ContextType>;
  EmailingdomainUserAggregateFields?: EmailingdomainUserAggregateFieldsResolvers<ContextType>;
  EmailingdomainUserCategory?: EmailingdomainUserCategoryResolvers<ContextType>;
  EmailingdomainUserCategoryAggregate?: EmailingdomainUserCategoryAggregateResolvers<ContextType>;
  EmailingdomainUserCategoryAggregateFields?: EmailingdomainUserCategoryAggregateFieldsResolvers<ContextType>;
  EmailingdomainUserCategoryMaxFields?: EmailingdomainUserCategoryMaxFieldsResolvers<ContextType>;
  EmailingdomainUserCategoryMinFields?: EmailingdomainUserCategoryMinFieldsResolvers<ContextType>;
  EmailingdomainUserCategoryMutationResponse?: EmailingdomainUserCategoryMutationResponseResolvers<ContextType>;
  EmailingdomainUserMaxFields?: EmailingdomainUserMaxFieldsResolvers<ContextType>;
  EmailingdomainUserMinFields?: EmailingdomainUserMinFieldsResolvers<ContextType>;
  EmailingdomainUserMutationResponse?: EmailingdomainUserMutationResponseResolvers<ContextType>;
  Emailingevent?: EmailingeventResolvers<ContextType>;
  EmailingeventAggregate?: EmailingeventAggregateResolvers<ContextType>;
  EmailingeventAggregateFields?: EmailingeventAggregateFieldsResolvers<ContextType>;
  EmailingeventMaxFields?: EmailingeventMaxFieldsResolvers<ContextType>;
  EmailingeventMinFields?: EmailingeventMinFieldsResolvers<ContextType>;
  EmailingeventMutationResponse?: EmailingeventMutationResponseResolvers<ContextType>;
  Emailingnumeric?: GraphQLScalarType;
  EmailingproviderAccount?: EmailingproviderAccountResolvers<ContextType>;
  EmailingproviderAccountAggregate?: EmailingproviderAccountAggregateResolvers<ContextType>;
  EmailingproviderAccountAggregateFields?: EmailingproviderAccountAggregateFieldsResolvers<ContextType>;
  EmailingproviderAccountAvgFields?: EmailingproviderAccountAvgFieldsResolvers<ContextType>;
  EmailingproviderAccountMaxFields?: EmailingproviderAccountMaxFieldsResolvers<ContextType>;
  EmailingproviderAccountMinFields?: EmailingproviderAccountMinFieldsResolvers<ContextType>;
  EmailingproviderAccountMutationResponse?: EmailingproviderAccountMutationResponseResolvers<ContextType>;
  EmailingproviderAccountStddevFields?: EmailingproviderAccountStddevFieldsResolvers<ContextType>;
  EmailingproviderAccountStddevPopFields?: EmailingproviderAccountStddevPopFieldsResolvers<ContextType>;
  EmailingproviderAccountStddevSampFields?: EmailingproviderAccountStddevSampFieldsResolvers<ContextType>;
  EmailingproviderAccountSumFields?: EmailingproviderAccountSumFieldsResolvers<ContextType>;
  EmailingproviderAccountVarPopFields?: EmailingproviderAccountVarPopFieldsResolvers<ContextType>;
  EmailingproviderAccountVarSampFields?: EmailingproviderAccountVarSampFieldsResolvers<ContextType>;
  EmailingproviderAccountVarianceFields?: EmailingproviderAccountVarianceFieldsResolvers<ContextType>;
  EmailingproviderType?: EmailingproviderTypeResolvers<ContextType>;
  EmailingproviderTypeAggregate?: EmailingproviderTypeAggregateResolvers<ContextType>;
  EmailingproviderTypeAggregateFields?: EmailingproviderTypeAggregateFieldsResolvers<ContextType>;
  EmailingproviderTypeMaxFields?: EmailingproviderTypeMaxFieldsResolvers<ContextType>;
  EmailingproviderTypeMinFields?: EmailingproviderTypeMinFieldsResolvers<ContextType>;
  EmailingproviderTypeMutationResponse?: EmailingproviderTypeMutationResponseResolvers<ContextType>;
  Emailingtimestamptz?: GraphQLScalarType;
  GeodataAddress?: GeodataAddressResolvers<ContextType>;
  GeodataAddressAggregate?: GeodataAddressAggregateResolvers<ContextType>;
  GeodataAddressAggregateFields?: GeodataAddressAggregateFieldsResolvers<ContextType>;
  GeodataAddressMaxFields?: GeodataAddressMaxFieldsResolvers<ContextType>;
  GeodataAddressMinFields?: GeodataAddressMinFieldsResolvers<ContextType>;
  GeodataAddressMutationResponse?: GeodataAddressMutationResponseResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekode?: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregate?: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregateResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregateFields?: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeAggregateFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMaxFields?: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMaxFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMinFields?: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMinFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMutationResponse?: GeodataMatrikkelenadresseleilighetsnivaAdressetilleggsnavnkildekodeMutationResponseResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaAtkomst?: GeodataMatrikkelenadresseleilighetsnivaAtkomstResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregate?: GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregateResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregateFields?: GeodataMatrikkelenadresseleilighetsnivaAtkomstAggregateFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstAvgFields?: GeodataMatrikkelenadresseleilighetsnivaAtkomstAvgFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstMaxFields?: GeodataMatrikkelenadresseleilighetsnivaAtkomstMaxFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstMinFields?: GeodataMatrikkelenadresseleilighetsnivaAtkomstMinFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstMutationResponse?: GeodataMatrikkelenadresseleilighetsnivaAtkomstMutationResponseResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevFields?: GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevPopFields?: GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevPopFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevSampFields?: GeodataMatrikkelenadresseleilighetsnivaAtkomstStddevSampFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstSumFields?: GeodataMatrikkelenadresseleilighetsnivaAtkomstSumFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstVarPopFields?: GeodataMatrikkelenadresseleilighetsnivaAtkomstVarPopFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstVarSampFields?: GeodataMatrikkelenadresseleilighetsnivaAtkomstVarSampFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaAtkomstVarianceFields?: GeodataMatrikkelenadresseleilighetsnivaAtkomstVarianceFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummer?: GeodataMatrikkelenadresseleilighetsnivaKommunenummerResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregate?: GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregateResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregateFields?: GeodataMatrikkelenadresseleilighetsnivaKommunenummerAggregateFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerMaxFields?: GeodataMatrikkelenadresseleilighetsnivaKommunenummerMaxFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerMinFields?: GeodataMatrikkelenadresseleilighetsnivaKommunenummerMinFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaKommunenummerMutationResponse?: GeodataMatrikkelenadresseleilighetsnivaKommunenummerMutationResponseResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhet?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregate?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregateResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregateFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAggregateFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstid?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregate?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregateResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregateFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAggregateFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAvgFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidAvgFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMaxFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMaxFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMinFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMinFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMutationResponse?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidMutationResponseResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevPopFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevPopFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevSampFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidStddevSampFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidSumFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidSumFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarPopFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarPopFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarSampFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarSampFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarianceFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAtkomstidVarianceFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAvgFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetAvgFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMaxFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMaxFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMinFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMinFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMutationResponse?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetMutationResponseResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevPopFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevPopFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevSampFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetStddevSampFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetSumFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetSumFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomst?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregate?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregateResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregateFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAggregateFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAvgFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstAvgFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMaxFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMaxFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMinFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMinFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMutationResponse?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstMutationResponseResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevPopFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevPopFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevSampFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstStddevSampFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstSumFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstSumFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarPopFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarPopFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarSampFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarSampFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarianceFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetUuidatkomstVarianceFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarPopFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarPopFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarSampFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarSampFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarianceFields?: GeodataMatrikkelenadresseleilighetsnivaMatrikkeladressebruksenhetVarianceFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomst?: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregate?: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregateResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregateFields?: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstAggregateFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMaxFields?: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMaxFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMinFields?: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMinFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMutationResponse?: GeodataMatrikkelenadresseleilighetsnivaTypeatkomstMutationResponseResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhet?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregate?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregateResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregateFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAggregateFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstid?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregate?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregateResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregateFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAggregateFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAvgFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidAvgFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMaxFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMaxFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMinFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMinFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMutationResponse?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidMutationResponseResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevPopFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevPopFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevSampFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidStddevSampFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidSumFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidSumFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarPopFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarPopFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarSampFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarSampFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarianceFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAtkomstidVarianceFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAvgFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetAvgFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMaxFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMaxFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMinFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMinFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMutationResponse?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetMutationResponseResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevPopFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevPopFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevSampFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetStddevSampFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetSumFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetSumFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomst?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregate?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregateResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregateFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAggregateFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAvgFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstAvgFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMaxFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMaxFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMinFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMinFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMutationResponse?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstMutationResponseResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevPopFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevPopFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevSampFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstStddevSampFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstSumFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstSumFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarPopFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarPopFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarSampFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarSampFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarianceFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetUuidatkomstVarianceFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarPopFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarPopFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarSampFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarSampFieldsResolvers<ContextType>;
  GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarianceFields?: GeodataMatrikkelenadresseleilighetsnivaVegadressebruksenhetVarianceFieldsResolvers<ContextType>;
  GeodataSpatialRefSys?: GeodataSpatialRefSysResolvers<ContextType>;
  GeodataSpatialRefSysAggregate?: GeodataSpatialRefSysAggregateResolvers<ContextType>;
  GeodataSpatialRefSysAggregateFields?: GeodataSpatialRefSysAggregateFieldsResolvers<ContextType>;
  GeodataSpatialRefSysAvgFields?: GeodataSpatialRefSysAvgFieldsResolvers<ContextType>;
  GeodataSpatialRefSysMaxFields?: GeodataSpatialRefSysMaxFieldsResolvers<ContextType>;
  GeodataSpatialRefSysMinFields?: GeodataSpatialRefSysMinFieldsResolvers<ContextType>;
  GeodataSpatialRefSysMutationResponse?: GeodataSpatialRefSysMutationResponseResolvers<ContextType>;
  GeodataSpatialRefSysStddevFields?: GeodataSpatialRefSysStddevFieldsResolvers<ContextType>;
  GeodataSpatialRefSysStddevPopFields?: GeodataSpatialRefSysStddevPopFieldsResolvers<ContextType>;
  GeodataSpatialRefSysStddevSampFields?: GeodataSpatialRefSysStddevSampFieldsResolvers<ContextType>;
  GeodataSpatialRefSysSumFields?: GeodataSpatialRefSysSumFieldsResolvers<ContextType>;
  GeodataSpatialRefSysVarPopFields?: GeodataSpatialRefSysVarPopFieldsResolvers<ContextType>;
  GeodataSpatialRefSysVarSampFields?: GeodataSpatialRefSysVarSampFieldsResolvers<ContextType>;
  GeodataSpatialRefSysVarianceFields?: GeodataSpatialRefSysVarianceFieldsResolvers<ContextType>;
  GeodataZip?: GeodataZipResolvers<ContextType>;
  GeodataZipAggregate?: GeodataZipAggregateResolvers<ContextType>;
  GeodataZipAggregateFields?: GeodataZipAggregateFieldsResolvers<ContextType>;
  GeodataZipMaxFields?: GeodataZipMaxFieldsResolvers<ContextType>;
  GeodataZipMinFields?: GeodataZipMinFieldsResolvers<ContextType>;
  GeodataZipMutationResponse?: GeodataZipMutationResponseResolvers<ContextType>;
  Geodatabigint?: GraphQLScalarType;
  Geodatageography?: GraphQLScalarType;
  Geodatageometry?: GraphQLScalarType;
  Geodatatimestamptz?: GraphQLScalarType;
  Geodatauuid?: GraphQLScalarType;
  IncomingSMSOutput?: IncomingSMSOutputResolvers<ContextType>;
  LinkMobilitySMSOutput?: LinkMobilitySMSOutputResolvers<ContextType>;
  LookupPhoneNumberOutput?: LookupPhoneNumberOutputResolvers<ContextType>;
  MessagingActivitySettings?: MessagingActivitySettingsResolvers<ContextType>;
  MessagingActivitySettingsAggregate?: MessagingActivitySettingsAggregateResolvers<ContextType>;
  MessagingActivitySettingsAggregateFields?: MessagingActivitySettingsAggregateFieldsResolvers<ContextType>;
  MessagingActivitySettingsMaxFields?: MessagingActivitySettingsMaxFieldsResolvers<ContextType>;
  MessagingActivitySettingsMinFields?: MessagingActivitySettingsMinFieldsResolvers<ContextType>;
  MessagingActivitySettingsMutationResponse?: MessagingActivitySettingsMutationResponseResolvers<ContextType>;
  MessagingActivitySettingsNotificationSettingType?: MessagingActivitySettingsNotificationSettingTypeResolvers<ContextType>;
  MessagingActivitySettingsNotificationSettingTypeAggregate?: MessagingActivitySettingsNotificationSettingTypeAggregateResolvers<ContextType>;
  MessagingActivitySettingsNotificationSettingTypeAggregateFields?: MessagingActivitySettingsNotificationSettingTypeAggregateFieldsResolvers<ContextType>;
  MessagingActivitySettingsNotificationSettingTypeMaxFields?: MessagingActivitySettingsNotificationSettingTypeMaxFieldsResolvers<ContextType>;
  MessagingActivitySettingsNotificationSettingTypeMinFields?: MessagingActivitySettingsNotificationSettingTypeMinFieldsResolvers<ContextType>;
  MessagingActivitySettingsNotificationSettingTypeMutationResponse?: MessagingActivitySettingsNotificationSettingTypeMutationResponseResolvers<ContextType>;
  MessagingInvitation?: MessagingInvitationResolvers<ContextType>;
  MessagingInvitationAggregate?: MessagingInvitationAggregateResolvers<ContextType>;
  MessagingInvitationAggregateFields?: MessagingInvitationAggregateFieldsResolvers<ContextType>;
  MessagingInvitationMaxFields?: MessagingInvitationMaxFieldsResolvers<ContextType>;
  MessagingInvitationMinFields?: MessagingInvitationMinFieldsResolvers<ContextType>;
  MessagingInvitationMutationResponse?: MessagingInvitationMutationResponseResolvers<ContextType>;
  MessagingMentions?: MessagingMentionsResolvers<ContextType>;
  MessagingMentionsAggregate?: MessagingMentionsAggregateResolvers<ContextType>;
  MessagingMentionsAggregateFields?: MessagingMentionsAggregateFieldsResolvers<ContextType>;
  MessagingMentionsMaxFields?: MessagingMentionsMaxFieldsResolvers<ContextType>;
  MessagingMentionsMinFields?: MessagingMentionsMinFieldsResolvers<ContextType>;
  MessagingMentionsMutationResponse?: MessagingMentionsMutationResponseResolvers<ContextType>;
  MessagingMessageAttachment?: MessagingMessageAttachmentResolvers<ContextType>;
  MessagingMessageAttachmentAggregate?: MessagingMessageAttachmentAggregateResolvers<ContextType>;
  MessagingMessageAttachmentAggregateFields?: MessagingMessageAttachmentAggregateFieldsResolvers<ContextType>;
  MessagingMessageAttachmentMaxFields?: MessagingMessageAttachmentMaxFieldsResolvers<ContextType>;
  MessagingMessageAttachmentMinFields?: MessagingMessageAttachmentMinFieldsResolvers<ContextType>;
  MessagingMessageAttachmentMutationResponse?: MessagingMessageAttachmentMutationResponseResolvers<ContextType>;
  MessagingMessageAttachmentType?: MessagingMessageAttachmentTypeResolvers<ContextType>;
  MessagingMessageAttachmentTypeAggregate?: MessagingMessageAttachmentTypeAggregateResolvers<ContextType>;
  MessagingMessageAttachmentTypeAggregateFields?: MessagingMessageAttachmentTypeAggregateFieldsResolvers<ContextType>;
  MessagingMessageAttachmentTypeMaxFields?: MessagingMessageAttachmentTypeMaxFieldsResolvers<ContextType>;
  MessagingMessageAttachmentTypeMinFields?: MessagingMessageAttachmentTypeMinFieldsResolvers<ContextType>;
  MessagingMessageAttachmentTypeMutationResponse?: MessagingMessageAttachmentTypeMutationResponseResolvers<ContextType>;
  MessagingMessagePriority?: MessagingMessagePriorityResolvers<ContextType>;
  MessagingMessagePriorityAggregate?: MessagingMessagePriorityAggregateResolvers<ContextType>;
  MessagingMessagePriorityAggregateFields?: MessagingMessagePriorityAggregateFieldsResolvers<ContextType>;
  MessagingMessagePriorityMaxFields?: MessagingMessagePriorityMaxFieldsResolvers<ContextType>;
  MessagingMessagePriorityMinFields?: MessagingMessagePriorityMinFieldsResolvers<ContextType>;
  MessagingMessagePriorityMutationResponse?: MessagingMessagePriorityMutationResponseResolvers<ContextType>;
  NewActivityOutput?: NewActivityOutputResolvers<ContextType>;
  NotificationNotificationDeviceSent?: NotificationNotificationDeviceSentResolvers<ContextType>;
  NotificationNotificationDeviceSentAggregate?: NotificationNotificationDeviceSentAggregateResolvers<ContextType>;
  NotificationNotificationDeviceSentAggregateFields?: NotificationNotificationDeviceSentAggregateFieldsResolvers<ContextType>;
  NotificationNotificationDeviceSentMaxFields?: NotificationNotificationDeviceSentMaxFieldsResolvers<ContextType>;
  NotificationNotificationDeviceSentMinFields?: NotificationNotificationDeviceSentMinFieldsResolvers<ContextType>;
  NotificationNotificationDeviceSentMutationResponse?: NotificationNotificationDeviceSentMutationResponseResolvers<ContextType>;
  NotificationNotificationSettingActivityPrimaryEnum?: NotificationNotificationSettingActivityPrimaryEnumResolvers<ContextType>;
  NotificationNotificationSettingActivityPrimaryEnumAggregate?: NotificationNotificationSettingActivityPrimaryEnumAggregateResolvers<ContextType>;
  NotificationNotificationSettingActivityPrimaryEnumAggregateFields?: NotificationNotificationSettingActivityPrimaryEnumAggregateFieldsResolvers<ContextType>;
  NotificationNotificationSettingActivityPrimaryEnumMaxFields?: NotificationNotificationSettingActivityPrimaryEnumMaxFieldsResolvers<ContextType>;
  NotificationNotificationSettingActivityPrimaryEnumMinFields?: NotificationNotificationSettingActivityPrimaryEnumMinFieldsResolvers<ContextType>;
  NotificationNotificationSettingActivityPrimaryEnumMutationResponse?: NotificationNotificationSettingActivityPrimaryEnumMutationResponseResolvers<ContextType>;
  NotificationOutput?: NotificationOutputResolvers<ContextType>;
  OrderUpdateOutput?: OrderUpdateOutputResolvers<ContextType>;
  OrdersOrganizations?: OrdersOrganizationsResolvers<ContextType>;
  OrdersOrganizationsAggregate?: OrdersOrganizationsAggregateResolvers<ContextType>;
  OrdersOrganizationsAggregateFields?: OrdersOrganizationsAggregateFieldsResolvers<ContextType>;
  OrdersOrganizationsAvgFields?: OrdersOrganizationsAvgFieldsResolvers<ContextType>;
  OrdersOrganizationsMaxFields?: OrdersOrganizationsMaxFieldsResolvers<ContextType>;
  OrdersOrganizationsMinFields?: OrdersOrganizationsMinFieldsResolvers<ContextType>;
  OrdersOrganizationsMutationResponse?: OrdersOrganizationsMutationResponseResolvers<ContextType>;
  OrdersOrganizationsStddevFields?: OrdersOrganizationsStddevFieldsResolvers<ContextType>;
  OrdersOrganizationsStddevPopFields?: OrdersOrganizationsStddevPopFieldsResolvers<ContextType>;
  OrdersOrganizationsStddevSampFields?: OrdersOrganizationsStddevSampFieldsResolvers<ContextType>;
  OrdersOrganizationsSumFields?: OrdersOrganizationsSumFieldsResolvers<ContextType>;
  OrdersOrganizationsVarPopFields?: OrdersOrganizationsVarPopFieldsResolvers<ContextType>;
  OrdersOrganizationsVarSampFields?: OrdersOrganizationsVarSampFieldsResolvers<ContextType>;
  OrdersOrganizationsVarianceFields?: OrdersOrganizationsVarianceFieldsResolvers<ContextType>;
  OrdersRequest?: OrdersRequestResolvers<ContextType>;
  OrdersRequestAggregate?: OrdersRequestAggregateResolvers<ContextType>;
  OrdersRequestAggregateFields?: OrdersRequestAggregateFieldsResolvers<ContextType>;
  OrdersRequestMaxFields?: OrdersRequestMaxFieldsResolvers<ContextType>;
  OrdersRequestMinFields?: OrdersRequestMinFieldsResolvers<ContextType>;
  OrdersRequestMutationResponse?: OrdersRequestMutationResponseResolvers<ContextType>;
  OrdersStatus?: OrdersStatusResolvers<ContextType>;
  OrdersStatusAggregate?: OrdersStatusAggregateResolvers<ContextType>;
  OrdersStatusAggregateFields?: OrdersStatusAggregateFieldsResolvers<ContextType>;
  OrdersStatusMaxFields?: OrdersStatusMaxFieldsResolvers<ContextType>;
  OrdersStatusMinFields?: OrdersStatusMinFieldsResolvers<ContextType>;
  OrdersStatusMutationResponse?: OrdersStatusMutationResponseResolvers<ContextType>;
  OrdersType?: OrdersTypeResolvers<ContextType>;
  OrdersTypeAggregate?: OrdersTypeAggregateResolvers<ContextType>;
  OrdersTypeAggregateFields?: OrdersTypeAggregateFieldsResolvers<ContextType>;
  OrdersTypeMaxFields?: OrdersTypeMaxFieldsResolvers<ContextType>;
  OrdersTypeMinFields?: OrdersTypeMinFieldsResolvers<ContextType>;
  OrdersTypeMutationResponse?: OrdersTypeMutationResponseResolvers<ContextType>;
  OrganizationOutput?: OrganizationOutputResolvers<ContextType>;
  OrganizationUserAttentionNote?: OrganizationUserAttentionNoteResolvers<ContextType>;
  OrganizationUserAttentionNoteAggregate?: OrganizationUserAttentionNoteAggregateResolvers<ContextType>;
  OrganizationUserAttentionNoteAggregateFields?: OrganizationUserAttentionNoteAggregateFieldsResolvers<ContextType>;
  OrganizationUserAttentionNoteMaxFields?: OrganizationUserAttentionNoteMaxFieldsResolvers<ContextType>;
  OrganizationUserAttentionNoteMinFields?: OrganizationUserAttentionNoteMinFieldsResolvers<ContextType>;
  OrganizationUserAttentionNoteMutationResponse?: OrganizationUserAttentionNoteMutationResponseResolvers<ContextType>;
  OrganizationsOutput?: OrganizationsOutputResolvers<ContextType>;
  PhoneRequestOutput?: PhoneRequestOutputResolvers<ContextType>;
  Prompt?: PromptResolvers<ContextType>;
  PromptAggregate?: PromptAggregateResolvers<ContextType>;
  PromptAggregateFields?: PromptAggregateFieldsResolvers<ContextType>;
  PromptMaxFields?: PromptMaxFieldsResolvers<ContextType>;
  PromptMinFields?: PromptMinFieldsResolvers<ContextType>;
  PromptMutationResponse?: PromptMutationResponseResolvers<ContextType>;
  QueueItemFlexibilityType?: QueueItemFlexibilityTypeResolvers<ContextType>;
  QueueItemFlexibilityTypeAggregate?: QueueItemFlexibilityTypeAggregateResolvers<ContextType>;
  QueueItemFlexibilityTypeAggregateFields?: QueueItemFlexibilityTypeAggregateFieldsResolvers<ContextType>;
  QueueItemFlexibilityTypeMaxFields?: QueueItemFlexibilityTypeMaxFieldsResolvers<ContextType>;
  QueueItemFlexibilityTypeMinFields?: QueueItemFlexibilityTypeMinFieldsResolvers<ContextType>;
  QueueItemFlexibilityTypeMutationResponse?: QueueItemFlexibilityTypeMutationResponseResolvers<ContextType>;
  QueueItemParticipantResponsibilityType?: QueueItemParticipantResponsibilityTypeResolvers<ContextType>;
  QueueItemParticipantResponsibilityTypeAggregate?: QueueItemParticipantResponsibilityTypeAggregateResolvers<ContextType>;
  QueueItemParticipantResponsibilityTypeAggregateFields?: QueueItemParticipantResponsibilityTypeAggregateFieldsResolvers<ContextType>;
  QueueItemParticipantResponsibilityTypeMaxFields?: QueueItemParticipantResponsibilityTypeMaxFieldsResolvers<ContextType>;
  QueueItemParticipantResponsibilityTypeMinFields?: QueueItemParticipantResponsibilityTypeMinFieldsResolvers<ContextType>;
  QueueItemParticipantResponsibilityTypeMutationResponse?: QueueItemParticipantResponsibilityTypeMutationResponseResolvers<ContextType>;
  RegistryCode?: RegistryCodeResolvers<ContextType>;
  RegistryCodeAggregate?: RegistryCodeAggregateResolvers<ContextType>;
  RegistryCodeAggregateFields?: RegistryCodeAggregateFieldsResolvers<ContextType>;
  RegistryCodeMaxFields?: RegistryCodeMaxFieldsResolvers<ContextType>;
  RegistryCodeMinFields?: RegistryCodeMinFieldsResolvers<ContextType>;
  RegistryCodeMutationResponse?: RegistryCodeMutationResponseResolvers<ContextType>;
  RegistryInfo?: RegistryInfoResolvers<ContextType>;
  RegistryInfoAggregate?: RegistryInfoAggregateResolvers<ContextType>;
  RegistryInfoAggregateFields?: RegistryInfoAggregateFieldsResolvers<ContextType>;
  RegistryInfoMaxFields?: RegistryInfoMaxFieldsResolvers<ContextType>;
  RegistryInfoMinFields?: RegistryInfoMinFieldsResolvers<ContextType>;
  RegistryInfoMutationResponse?: RegistryInfoMutationResponseResolvers<ContextType>;
  RegistryOrganisasjonsform?: RegistryOrganisasjonsformResolvers<ContextType>;
  RegistryOrganisasjonsformAggregate?: RegistryOrganisasjonsformAggregateResolvers<ContextType>;
  RegistryOrganisasjonsformAggregateFields?: RegistryOrganisasjonsformAggregateFieldsResolvers<ContextType>;
  RegistryOrganisasjonsformMaxFields?: RegistryOrganisasjonsformMaxFieldsResolvers<ContextType>;
  RegistryOrganisasjonsformMinFields?: RegistryOrganisasjonsformMinFieldsResolvers<ContextType>;
  RegistryOrganisasjonsformMutationResponse?: RegistryOrganisasjonsformMutationResponseResolvers<ContextType>;
  RegistryOrganization?: RegistryOrganizationResolvers<ContextType>;
  RegistryOrganizationAggregate?: RegistryOrganizationAggregateResolvers<ContextType>;
  RegistryOrganizationAggregateFields?: RegistryOrganizationAggregateFieldsResolvers<ContextType>;
  RegistryOrganizationAvgFields?: RegistryOrganizationAvgFieldsResolvers<ContextType>;
  RegistryOrganizationMaxFields?: RegistryOrganizationMaxFieldsResolvers<ContextType>;
  RegistryOrganizationMinFields?: RegistryOrganizationMinFieldsResolvers<ContextType>;
  RegistryOrganizationMutationResponse?: RegistryOrganizationMutationResponseResolvers<ContextType>;
  RegistryOrganizationStddevFields?: RegistryOrganizationStddevFieldsResolvers<ContextType>;
  RegistryOrganizationStddevPopFields?: RegistryOrganizationStddevPopFieldsResolvers<ContextType>;
  RegistryOrganizationStddevSampFields?: RegistryOrganizationStddevSampFieldsResolvers<ContextType>;
  RegistryOrganizationSumFields?: RegistryOrganizationSumFieldsResolvers<ContextType>;
  RegistryOrganizationVarPopFields?: RegistryOrganizationVarPopFieldsResolvers<ContextType>;
  RegistryOrganizationVarSampFields?: RegistryOrganizationVarSampFieldsResolvers<ContextType>;
  RegistryOrganizationVarianceFields?: RegistryOrganizationVarianceFieldsResolvers<ContextType>;
  RegistryPostadresse?: RegistryPostadresseResolvers<ContextType>;
  RegistryPostadresseAggregate?: RegistryPostadresseAggregateResolvers<ContextType>;
  RegistryPostadresseAggregateFields?: RegistryPostadresseAggregateFieldsResolvers<ContextType>;
  RegistryPostadresseMaxFields?: RegistryPostadresseMaxFieldsResolvers<ContextType>;
  RegistryPostadresseMinFields?: RegistryPostadresseMinFieldsResolvers<ContextType>;
  RegistryPostadresseMutationResponse?: RegistryPostadresseMutationResponseResolvers<ContextType>;
  Registrydate?: GraphQLScalarType;
  Registryjsonb?: GraphQLScalarType;
  Registrynumeric?: GraphQLScalarType;
  Registrytimestamptz?: GraphQLScalarType;
  Registryuuid?: GraphQLScalarType;
  RelationType?: RelationTypeResolvers<ContextType>;
  RelationTypeAggregate?: RelationTypeAggregateResolvers<ContextType>;
  RelationTypeAggregateFields?: RelationTypeAggregateFieldsResolvers<ContextType>;
  RelationTypeMaxFields?: RelationTypeMaxFieldsResolvers<ContextType>;
  RelationTypeMinFields?: RelationTypeMinFieldsResolvers<ContextType>;
  RelationTypeMutationResponse?: RelationTypeMutationResponseResolvers<ContextType>;
  RemoveCustomerOutput?: RemoveCustomerOutputResolvers<ContextType>;
  RequestIntegrationsOutput?: RequestIntegrationsOutputResolvers<ContextType>;
  SearchPhoneOutput?: SearchPhoneOutputResolvers<ContextType>;
  SendSMSOutput?: SendSMSOutputResolvers<ContextType>;
  SendSMSTokenOutput?: SendSMSTokenOutputResolvers<ContextType>;
  StatusOutput?: StatusOutputResolvers<ContextType>;
  TaskActivity?: TaskActivityResolvers<ContextType>;
  TaskActivityAggregate?: TaskActivityAggregateResolvers<ContextType>;
  TaskActivityAggregateFields?: TaskActivityAggregateFieldsResolvers<ContextType>;
  TaskActivityMaxFields?: TaskActivityMaxFieldsResolvers<ContextType>;
  TaskActivityMinFields?: TaskActivityMinFieldsResolvers<ContextType>;
  TaskActivityMutationResponse?: TaskActivityMutationResponseResolvers<ContextType>;
  TaskActivityParticipant?: TaskActivityParticipantResolvers<ContextType>;
  TaskActivityParticipantAggregate?: TaskActivityParticipantAggregateResolvers<ContextType>;
  TaskActivityParticipantAggregateFields?: TaskActivityParticipantAggregateFieldsResolvers<ContextType>;
  TaskActivityParticipantMaxFields?: TaskActivityParticipantMaxFieldsResolvers<ContextType>;
  TaskActivityParticipantMinFields?: TaskActivityParticipantMinFieldsResolvers<ContextType>;
  TaskActivityParticipantMutationResponse?: TaskActivityParticipantMutationResponseResolvers<ContextType>;
  TaskActivityType?: TaskActivityTypeResolvers<ContextType>;
  TaskActivityTypeAggregate?: TaskActivityTypeAggregateResolvers<ContextType>;
  TaskActivityTypeAggregateFields?: TaskActivityTypeAggregateFieldsResolvers<ContextType>;
  TaskActivityTypeMaxFields?: TaskActivityTypeMaxFieldsResolvers<ContextType>;
  TaskActivityTypeMinFields?: TaskActivityTypeMinFieldsResolvers<ContextType>;
  TaskActivityTypeMutationResponse?: TaskActivityTypeMutationResponseResolvers<ContextType>;
  TaskDomainOrganization?: TaskDomainOrganizationResolvers<ContextType>;
  TaskDomainOrganizationAggregate?: TaskDomainOrganizationAggregateResolvers<ContextType>;
  TaskDomainOrganizationAggregateFields?: TaskDomainOrganizationAggregateFieldsResolvers<ContextType>;
  TaskDomainOrganizationMaxFields?: TaskDomainOrganizationMaxFieldsResolvers<ContextType>;
  TaskDomainOrganizationMinFields?: TaskDomainOrganizationMinFieldsResolvers<ContextType>;
  TaskDomainOrganizationMutationResponse?: TaskDomainOrganizationMutationResponseResolvers<ContextType>;
  TaskDomainUser?: TaskDomainUserResolvers<ContextType>;
  TaskDomainUserAggregate?: TaskDomainUserAggregateResolvers<ContextType>;
  TaskDomainUserAggregateFields?: TaskDomainUserAggregateFieldsResolvers<ContextType>;
  TaskDomainUserCategory?: TaskDomainUserCategoryResolvers<ContextType>;
  TaskDomainUserCategoryAggregate?: TaskDomainUserCategoryAggregateResolvers<ContextType>;
  TaskDomainUserCategoryAggregateFields?: TaskDomainUserCategoryAggregateFieldsResolvers<ContextType>;
  TaskDomainUserCategoryMaxFields?: TaskDomainUserCategoryMaxFieldsResolvers<ContextType>;
  TaskDomainUserCategoryMinFields?: TaskDomainUserCategoryMinFieldsResolvers<ContextType>;
  TaskDomainUserCategoryMutationResponse?: TaskDomainUserCategoryMutationResponseResolvers<ContextType>;
  TaskDomainUserMaxFields?: TaskDomainUserMaxFieldsResolvers<ContextType>;
  TaskDomainUserMinFields?: TaskDomainUserMinFieldsResolvers<ContextType>;
  TaskDomainUserMutationResponse?: TaskDomainUserMutationResponseResolvers<ContextType>;
  Taskjson?: GraphQLScalarType;
  Taskjsonb?: GraphQLScalarType;
  TasktaskActivityOutput?: TasktaskActivityOutputResolvers<ContextType>;
  Tasktimestamptz?: GraphQLScalarType;
  TelephonyActivityParticipantRole?: TelephonyActivityParticipantRoleResolvers<ContextType>;
  TelephonyActivityParticipantRoleAggregate?: TelephonyActivityParticipantRoleAggregateResolvers<ContextType>;
  TelephonyActivityParticipantRoleAggregateFields?: TelephonyActivityParticipantRoleAggregateFieldsResolvers<ContextType>;
  TelephonyActivityParticipantRoleMaxFields?: TelephonyActivityParticipantRoleMaxFieldsResolvers<ContextType>;
  TelephonyActivityParticipantRoleMinFields?: TelephonyActivityParticipantRoleMinFieldsResolvers<ContextType>;
  TelephonyActivityParticipantRoleMutationResponse?: TelephonyActivityParticipantRoleMutationResponseResolvers<ContextType>;
  TelephonyActivityType?: TelephonyActivityTypeResolvers<ContextType>;
  TelephonyActivityTypeAggregate?: TelephonyActivityTypeAggregateResolvers<ContextType>;
  TelephonyActivityTypeAggregateFields?: TelephonyActivityTypeAggregateFieldsResolvers<ContextType>;
  TelephonyActivityTypeMutationResponse?: TelephonyActivityTypeMutationResponseResolvers<ContextType>;
  TelephonyCallDirection?: TelephonyCallDirectionResolvers<ContextType>;
  TelephonyCallDirectionAggregate?: TelephonyCallDirectionAggregateResolvers<ContextType>;
  TelephonyCallDirectionAggregateFields?: TelephonyCallDirectionAggregateFieldsResolvers<ContextType>;
  TelephonyCallDirectionMaxFields?: TelephonyCallDirectionMaxFieldsResolvers<ContextType>;
  TelephonyCallDirectionMinFields?: TelephonyCallDirectionMinFieldsResolvers<ContextType>;
  TelephonyCallDirectionMutationResponse?: TelephonyCallDirectionMutationResponseResolvers<ContextType>;
  TelephonyCallResultOutput?: TelephonyCallResultOutputResolvers<ContextType>;
  TelephonyClickToCallOutput?: TelephonyClickToCallOutputResolvers<ContextType>;
  TelephonyCredentialsOutput?: TelephonyCredentialsOutputResolvers<ContextType>;
  TelephonyDomainUserCategory?: TelephonyDomainUserCategoryResolvers<ContextType>;
  TelephonyDomainUserCategoryAggregate?: TelephonyDomainUserCategoryAggregateResolvers<ContextType>;
  TelephonyDomainUserCategoryAggregateFields?: TelephonyDomainUserCategoryAggregateFieldsResolvers<ContextType>;
  TelephonyDomainUserCategoryMutationResponse?: TelephonyDomainUserCategoryMutationResponseResolvers<ContextType>;
  TelephonyDomainUserOutput?: TelephonyDomainUserOutputResolvers<ContextType>;
  TelephonyLookupPhoneNumberOutput?: TelephonyLookupPhoneNumberOutputResolvers<ContextType>;
  TelephonyNumberState?: TelephonyNumberStateResolvers<ContextType>;
  TelephonyNumberStateAggregate?: TelephonyNumberStateAggregateResolvers<ContextType>;
  TelephonyNumberStateAggregateFields?: TelephonyNumberStateAggregateFieldsResolvers<ContextType>;
  TelephonyNumberStateMaxFields?: TelephonyNumberStateMaxFieldsResolvers<ContextType>;
  TelephonyNumberStateMinFields?: TelephonyNumberStateMinFieldsResolvers<ContextType>;
  TelephonyNumberStateMutationResponse?: TelephonyNumberStateMutationResponseResolvers<ContextType>;
  TelephonyPhoneRequestOutput?: TelephonyPhoneRequestOutputResolvers<ContextType>;
  TelephonyProviderType?: TelephonyProviderTypeResolvers<ContextType>;
  TelephonyProviderTypeAggregate?: TelephonyProviderTypeAggregateResolvers<ContextType>;
  TelephonyProviderTypeAggregateFields?: TelephonyProviderTypeAggregateFieldsResolvers<ContextType>;
  TelephonyProviderTypeMaxFields?: TelephonyProviderTypeMaxFieldsResolvers<ContextType>;
  TelephonyProviderTypeMinFields?: TelephonyProviderTypeMinFieldsResolvers<ContextType>;
  TelephonyProviderTypeMutationResponse?: TelephonyProviderTypeMutationResponseResolvers<ContextType>;
  TelephonySendSMSOutput?: TelephonySendSMSOutputResolvers<ContextType>;
  TelephonySynchronizeDomainUsersOutput?: TelephonySynchronizeDomainUsersOutputResolvers<ContextType>;
  TelephonyTelephonyActionEventType?: TelephonyTelephonyActionEventTypeResolvers<ContextType>;
  TelephonyTelephonyActionEventTypeAggregate?: TelephonyTelephonyActionEventTypeAggregateResolvers<ContextType>;
  TelephonyTelephonyActionEventTypeAggregateFields?: TelephonyTelephonyActionEventTypeAggregateFieldsResolvers<ContextType>;
  TelephonyTelephonyActionEventTypeMaxFields?: TelephonyTelephonyActionEventTypeMaxFieldsResolvers<ContextType>;
  TelephonyTelephonyActionEventTypeMinFields?: TelephonyTelephonyActionEventTypeMinFieldsResolvers<ContextType>;
  TelephonyTelephonyActionEventTypeMutationResponse?: TelephonyTelephonyActionEventTypeMutationResponseResolvers<ContextType>;
  TelephonyTelephonyActionType?: TelephonyTelephonyActionTypeResolvers<ContextType>;
  TelephonyTelephonyActionTypeAggregate?: TelephonyTelephonyActionTypeAggregateResolvers<ContextType>;
  TelephonyTelephonyActionTypeAggregateFields?: TelephonyTelephonyActionTypeAggregateFieldsResolvers<ContextType>;
  TelephonyTelephonyActionTypeMaxFields?: TelephonyTelephonyActionTypeMaxFieldsResolvers<ContextType>;
  TelephonyTelephonyActionTypeMinFields?: TelephonyTelephonyActionTypeMinFieldsResolvers<ContextType>;
  TelephonyTelephonyActionTypeMutationResponse?: TelephonyTelephonyActionTypeMutationResponseResolvers<ContextType>;
  TelephonyTelephonyBlockedDomainUser?: TelephonyTelephonyBlockedDomainUserResolvers<ContextType>;
  TelephonyTelephonyBlockedDomainUserAggregate?: TelephonyTelephonyBlockedDomainUserAggregateResolvers<ContextType>;
  TelephonyTelephonyBlockedDomainUserAggregateFields?: TelephonyTelephonyBlockedDomainUserAggregateFieldsResolvers<ContextType>;
  TelephonyTelephonyBlockedDomainUserMaxFields?: TelephonyTelephonyBlockedDomainUserMaxFieldsResolvers<ContextType>;
  TelephonyTelephonyBlockedDomainUserMinFields?: TelephonyTelephonyBlockedDomainUserMinFieldsResolvers<ContextType>;
  TelephonyTelephonyBlockedDomainUserMutationResponse?: TelephonyTelephonyBlockedDomainUserMutationResponseResolvers<ContextType>;
  TelephonyTelephonyCiscoSubscriberProduct?: TelephonyTelephonyCiscoSubscriberProductResolvers<ContextType>;
  TelephonyTelephonyCiscoSubscriberProductAggregate?: TelephonyTelephonyCiscoSubscriberProductAggregateResolvers<ContextType>;
  TelephonyTelephonyCiscoSubscriberProductAggregateFields?: TelephonyTelephonyCiscoSubscriberProductAggregateFieldsResolvers<ContextType>;
  TelephonyTelephonyCiscoSubscriberProductMaxFields?: TelephonyTelephonyCiscoSubscriberProductMaxFieldsResolvers<ContextType>;
  TelephonyTelephonyCiscoSubscriberProductMinFields?: TelephonyTelephonyCiscoSubscriberProductMinFieldsResolvers<ContextType>;
  TelephonyTelephonyCiscoSubscriberProductMutationResponse?: TelephonyTelephonyCiscoSubscriberProductMutationResponseResolvers<ContextType>;
  TelephonyTelephonyEvents?: TelephonyTelephonyEventsResolvers<ContextType>;
  TelephonyTelephonyEventsAggregate?: TelephonyTelephonyEventsAggregateResolvers<ContextType>;
  TelephonyTelephonyEventsAggregateFields?: TelephonyTelephonyEventsAggregateFieldsResolvers<ContextType>;
  TelephonyTelephonyEventsMaxFields?: TelephonyTelephonyEventsMaxFieldsResolvers<ContextType>;
  TelephonyTelephonyEventsMinFields?: TelephonyTelephonyEventsMinFieldsResolvers<ContextType>;
  TelephonyTelephonyEventsMutationResponse?: TelephonyTelephonyEventsMutationResponseResolvers<ContextType>;
  TelephonyTelephonyLookupCallerApi?: TelephonyTelephonyLookupCallerApiResolvers<ContextType>;
  TelephonyTelephonyLookupCallerApiAggregate?: TelephonyTelephonyLookupCallerApiAggregateResolvers<ContextType>;
  TelephonyTelephonyLookupCallerApiAggregateFields?: TelephonyTelephonyLookupCallerApiAggregateFieldsResolvers<ContextType>;
  TelephonyTelephonyLookupCallerApiMaxFields?: TelephonyTelephonyLookupCallerApiMaxFieldsResolvers<ContextType>;
  TelephonyTelephonyLookupCallerApiMinFields?: TelephonyTelephonyLookupCallerApiMinFieldsResolvers<ContextType>;
  TelephonyTelephonyLookupCallerApiMutationResponse?: TelephonyTelephonyLookupCallerApiMutationResponseResolvers<ContextType>;
  TelephonyTelephonyLookupRefresh?: TelephonyTelephonyLookupRefreshResolvers<ContextType>;
  TelephonyTelephonyLookupRefreshAggregate?: TelephonyTelephonyLookupRefreshAggregateResolvers<ContextType>;
  TelephonyTelephonyLookupRefreshAggregateFields?: TelephonyTelephonyLookupRefreshAggregateFieldsResolvers<ContextType>;
  TelephonyTelephonyLookupRefreshAvgFields?: TelephonyTelephonyLookupRefreshAvgFieldsResolvers<ContextType>;
  TelephonyTelephonyLookupRefreshMaxFields?: TelephonyTelephonyLookupRefreshMaxFieldsResolvers<ContextType>;
  TelephonyTelephonyLookupRefreshMinFields?: TelephonyTelephonyLookupRefreshMinFieldsResolvers<ContextType>;
  TelephonyTelephonyLookupRefreshMutationResponse?: TelephonyTelephonyLookupRefreshMutationResponseResolvers<ContextType>;
  TelephonyTelephonyLookupRefreshStddevFields?: TelephonyTelephonyLookupRefreshStddevFieldsResolvers<ContextType>;
  TelephonyTelephonyLookupRefreshStddevPopFields?: TelephonyTelephonyLookupRefreshStddevPopFieldsResolvers<ContextType>;
  TelephonyTelephonyLookupRefreshStddevSampFields?: TelephonyTelephonyLookupRefreshStddevSampFieldsResolvers<ContextType>;
  TelephonyTelephonyLookupRefreshSumFields?: TelephonyTelephonyLookupRefreshSumFieldsResolvers<ContextType>;
  TelephonyTelephonyLookupRefreshVarPopFields?: TelephonyTelephonyLookupRefreshVarPopFieldsResolvers<ContextType>;
  TelephonyTelephonyLookupRefreshVarSampFields?: TelephonyTelephonyLookupRefreshVarSampFieldsResolvers<ContextType>;
  TelephonyTelephonyLookupRefreshVarianceFields?: TelephonyTelephonyLookupRefreshVarianceFieldsResolvers<ContextType>;
  TelephonyTelephonyLookupTypes?: TelephonyTelephonyLookupTypesResolvers<ContextType>;
  TelephonyTelephonyLookupTypesAggregate?: TelephonyTelephonyLookupTypesAggregateResolvers<ContextType>;
  TelephonyTelephonyLookupTypesAggregateFields?: TelephonyTelephonyLookupTypesAggregateFieldsResolvers<ContextType>;
  TelephonyTelephonyLookupTypesMaxFields?: TelephonyTelephonyLookupTypesMaxFieldsResolvers<ContextType>;
  TelephonyTelephonyLookupTypesMinFields?: TelephonyTelephonyLookupTypesMinFieldsResolvers<ContextType>;
  TelephonyTelephonyLookupTypesMutationResponse?: TelephonyTelephonyLookupTypesMutationResponseResolvers<ContextType>;
  TelephonyTelephonyPods?: TelephonyTelephonyPodsResolvers<ContextType>;
  TelephonyTelephonyPodsAggregate?: TelephonyTelephonyPodsAggregateResolvers<ContextType>;
  TelephonyTelephonyPodsAggregateFields?: TelephonyTelephonyPodsAggregateFieldsResolvers<ContextType>;
  TelephonyTelephonyPodsMaxFields?: TelephonyTelephonyPodsMaxFieldsResolvers<ContextType>;
  TelephonyTelephonyPodsMinFields?: TelephonyTelephonyPodsMinFieldsResolvers<ContextType>;
  TelephonyTelephonyPodsMutationResponse?: TelephonyTelephonyPodsMutationResponseResolvers<ContextType>;
  TelephonyTelephonyProviderAccess?: TelephonyTelephonyProviderAccessResolvers<ContextType>;
  TelephonyTelephonyProviderAccessAggregate?: TelephonyTelephonyProviderAccessAggregateResolvers<ContextType>;
  TelephonyTelephonyProviderAccessAggregateFields?: TelephonyTelephonyProviderAccessAggregateFieldsResolvers<ContextType>;
  TelephonyTelephonyProviderAccessMaxFields?: TelephonyTelephonyProviderAccessMaxFieldsResolvers<ContextType>;
  TelephonyTelephonyProviderAccessMinFields?: TelephonyTelephonyProviderAccessMinFieldsResolvers<ContextType>;
  TelephonyTelephonyProviderAccessMutationResponse?: TelephonyTelephonyProviderAccessMutationResponseResolvers<ContextType>;
  TelephonyactiveNumbers?: TelephonyactiveNumbersResolvers<ContextType>;
  TelephonyactiveNumbersAggregate?: TelephonyactiveNumbersAggregateResolvers<ContextType>;
  TelephonyactiveNumbersAggregateFields?: TelephonyactiveNumbersAggregateFieldsResolvers<ContextType>;
  TelephonyactiveNumbersMaxFields?: TelephonyactiveNumbersMaxFieldsResolvers<ContextType>;
  TelephonyactiveNumbersMinFields?: TelephonyactiveNumbersMinFieldsResolvers<ContextType>;
  TelephonyactiveNumbersMutationResponse?: TelephonyactiveNumbersMutationResponseResolvers<ContextType>;
  Telephonyactivity?: TelephonyactivityResolvers<ContextType>;
  TelephonyactivityAggregate?: TelephonyactivityAggregateResolvers<ContextType>;
  TelephonyactivityAggregateFields?: TelephonyactivityAggregateFieldsResolvers<ContextType>;
  TelephonyactivityAvgFields?: TelephonyactivityAvgFieldsResolvers<ContextType>;
  TelephonyactivityMaxFields?: TelephonyactivityMaxFieldsResolvers<ContextType>;
  TelephonyactivityMinFields?: TelephonyactivityMinFieldsResolvers<ContextType>;
  TelephonyactivityMutationResponse?: TelephonyactivityMutationResponseResolvers<ContextType>;
  TelephonyactivityParticipant?: TelephonyactivityParticipantResolvers<ContextType>;
  TelephonyactivityParticipantAggregate?: TelephonyactivityParticipantAggregateResolvers<ContextType>;
  TelephonyactivityParticipantAggregateFields?: TelephonyactivityParticipantAggregateFieldsResolvers<ContextType>;
  TelephonyactivityParticipantMaxFields?: TelephonyactivityParticipantMaxFieldsResolvers<ContextType>;
  TelephonyactivityParticipantMinFields?: TelephonyactivityParticipantMinFieldsResolvers<ContextType>;
  TelephonyactivityParticipantMutationResponse?: TelephonyactivityParticipantMutationResponseResolvers<ContextType>;
  TelephonyactivityStddevFields?: TelephonyactivityStddevFieldsResolvers<ContextType>;
  TelephonyactivityStddevPopFields?: TelephonyactivityStddevPopFieldsResolvers<ContextType>;
  TelephonyactivityStddevSampFields?: TelephonyactivityStddevSampFieldsResolvers<ContextType>;
  TelephonyactivitySumFields?: TelephonyactivitySumFieldsResolvers<ContextType>;
  TelephonyactivityVarPopFields?: TelephonyactivityVarPopFieldsResolvers<ContextType>;
  TelephonyactivityVarSampFields?: TelephonyactivityVarSampFieldsResolvers<ContextType>;
  TelephonyactivityVarianceFields?: TelephonyactivityVarianceFieldsResolvers<ContextType>;
  Telephonycomment?: TelephonycommentResolvers<ContextType>;
  TelephonycommentAggregate?: TelephonycommentAggregateResolvers<ContextType>;
  TelephonycommentAggregateFields?: TelephonycommentAggregateFieldsResolvers<ContextType>;
  TelephonycommentMaxFields?: TelephonycommentMaxFieldsResolvers<ContextType>;
  TelephonycommentMinFields?: TelephonycommentMinFieldsResolvers<ContextType>;
  TelephonycommentMutationResponse?: TelephonycommentMutationResponseResolvers<ContextType>;
  TelephonydomainOrganization?: TelephonydomainOrganizationResolvers<ContextType>;
  TelephonydomainOrganizationAggregate?: TelephonydomainOrganizationAggregateResolvers<ContextType>;
  TelephonydomainOrganizationAggregateFields?: TelephonydomainOrganizationAggregateFieldsResolvers<ContextType>;
  TelephonydomainOrganizationMaxFields?: TelephonydomainOrganizationMaxFieldsResolvers<ContextType>;
  TelephonydomainOrganizationMinFields?: TelephonydomainOrganizationMinFieldsResolvers<ContextType>;
  TelephonydomainOrganizationMutationResponse?: TelephonydomainOrganizationMutationResponseResolvers<ContextType>;
  TelephonydomainUser?: TelephonydomainUserResolvers<ContextType>;
  TelephonydomainUserAggregate?: TelephonydomainUserAggregateResolvers<ContextType>;
  TelephonydomainUserAggregateFields?: TelephonydomainUserAggregateFieldsResolvers<ContextType>;
  TelephonydomainUserAvgFields?: TelephonydomainUserAvgFieldsResolvers<ContextType>;
  TelephonydomainUserMaxFields?: TelephonydomainUserMaxFieldsResolvers<ContextType>;
  TelephonydomainUserMinFields?: TelephonydomainUserMinFieldsResolvers<ContextType>;
  TelephonydomainUserMutationResponse?: TelephonydomainUserMutationResponseResolvers<ContextType>;
  TelephonydomainUserStddevFields?: TelephonydomainUserStddevFieldsResolvers<ContextType>;
  TelephonydomainUserStddevPopFields?: TelephonydomainUserStddevPopFieldsResolvers<ContextType>;
  TelephonydomainUserStddevSampFields?: TelephonydomainUserStddevSampFieldsResolvers<ContextType>;
  TelephonydomainUserSumFields?: TelephonydomainUserSumFieldsResolvers<ContextType>;
  TelephonydomainUserVarPopFields?: TelephonydomainUserVarPopFieldsResolvers<ContextType>;
  TelephonydomainUserVarSampFields?: TelephonydomainUserVarSampFieldsResolvers<ContextType>;
  TelephonydomainUserVarianceFields?: TelephonydomainUserVarianceFieldsResolvers<ContextType>;
  Telephonyevent?: TelephonyeventResolvers<ContextType>;
  TelephonyeventAction?: TelephonyeventActionResolvers<ContextType>;
  TelephonyeventActionAggregate?: TelephonyeventActionAggregateResolvers<ContextType>;
  TelephonyeventActionAggregateFields?: TelephonyeventActionAggregateFieldsResolvers<ContextType>;
  TelephonyeventActionMaxFields?: TelephonyeventActionMaxFieldsResolvers<ContextType>;
  TelephonyeventActionMinFields?: TelephonyeventActionMinFieldsResolvers<ContextType>;
  TelephonyeventActionMutationResponse?: TelephonyeventActionMutationResponseResolvers<ContextType>;
  TelephonyeventAggregate?: TelephonyeventAggregateResolvers<ContextType>;
  TelephonyeventAggregateFields?: TelephonyeventAggregateFieldsResolvers<ContextType>;
  TelephonyeventAvgFields?: TelephonyeventAvgFieldsResolvers<ContextType>;
  TelephonyeventMaxFields?: TelephonyeventMaxFieldsResolvers<ContextType>;
  TelephonyeventMinFields?: TelephonyeventMinFieldsResolvers<ContextType>;
  TelephonyeventMutationResponse?: TelephonyeventMutationResponseResolvers<ContextType>;
  TelephonyeventStddevFields?: TelephonyeventStddevFieldsResolvers<ContextType>;
  TelephonyeventStddevPopFields?: TelephonyeventStddevPopFieldsResolvers<ContextType>;
  TelephonyeventStddevSampFields?: TelephonyeventStddevSampFieldsResolvers<ContextType>;
  TelephonyeventSumFields?: TelephonyeventSumFieldsResolvers<ContextType>;
  TelephonyeventVarPopFields?: TelephonyeventVarPopFieldsResolvers<ContextType>;
  TelephonyeventVarSampFields?: TelephonyeventVarSampFieldsResolvers<ContextType>;
  TelephonyeventVarianceFields?: TelephonyeventVarianceFieldsResolvers<ContextType>;
  TelephonyhangUpCallOutput?: TelephonyhangUpCallOutputResolvers<ContextType>;
  Telephonyjsonb?: GraphQLScalarType;
  Telephonyprovider?: TelephonyproviderResolvers<ContextType>;
  TelephonyproviderAccount?: TelephonyproviderAccountResolvers<ContextType>;
  TelephonyproviderAccountAggregate?: TelephonyproviderAccountAggregateResolvers<ContextType>;
  TelephonyproviderAccountAggregateFields?: TelephonyproviderAccountAggregateFieldsResolvers<ContextType>;
  TelephonyproviderAccountMaxFields?: TelephonyproviderAccountMaxFieldsResolvers<ContextType>;
  TelephonyproviderAccountMinFields?: TelephonyproviderAccountMinFieldsResolvers<ContextType>;
  TelephonyproviderAccountMutationResponse?: TelephonyproviderAccountMutationResponseResolvers<ContextType>;
  TelephonyproviderAggregate?: TelephonyproviderAggregateResolvers<ContextType>;
  TelephonyproviderAggregateFields?: TelephonyproviderAggregateFieldsResolvers<ContextType>;
  TelephonyproviderMaxFields?: TelephonyproviderMaxFieldsResolvers<ContextType>;
  TelephonyproviderMinFields?: TelephonyproviderMinFieldsResolvers<ContextType>;
  TelephonyproviderMutationResponse?: TelephonyproviderMutationResponseResolvers<ContextType>;
  TelephonyproviderRequestTerm?: TelephonyproviderRequestTermResolvers<ContextType>;
  TelephonyproviderRequestTermAggregate?: TelephonyproviderRequestTermAggregateResolvers<ContextType>;
  TelephonyproviderRequestTermAggregateFields?: TelephonyproviderRequestTermAggregateFieldsResolvers<ContextType>;
  TelephonyproviderRequestTermAvgFields?: TelephonyproviderRequestTermAvgFieldsResolvers<ContextType>;
  TelephonyproviderRequestTermMaxFields?: TelephonyproviderRequestTermMaxFieldsResolvers<ContextType>;
  TelephonyproviderRequestTermMinFields?: TelephonyproviderRequestTermMinFieldsResolvers<ContextType>;
  TelephonyproviderRequestTermMutationResponse?: TelephonyproviderRequestTermMutationResponseResolvers<ContextType>;
  TelephonyproviderRequestTermStddevFields?: TelephonyproviderRequestTermStddevFieldsResolvers<ContextType>;
  TelephonyproviderRequestTermStddevPopFields?: TelephonyproviderRequestTermStddevPopFieldsResolvers<ContextType>;
  TelephonyproviderRequestTermStddevSampFields?: TelephonyproviderRequestTermStddevSampFieldsResolvers<ContextType>;
  TelephonyproviderRequestTermSumFields?: TelephonyproviderRequestTermSumFieldsResolvers<ContextType>;
  TelephonyproviderRequestTermVarPopFields?: TelephonyproviderRequestTermVarPopFieldsResolvers<ContextType>;
  TelephonyproviderRequestTermVarSampFields?: TelephonyproviderRequestTermVarSampFieldsResolvers<ContextType>;
  TelephonyproviderRequestTermVarianceFields?: TelephonyproviderRequestTermVarianceFieldsResolvers<ContextType>;
  Telephonytimestamptz?: GraphQLScalarType;
  TelephonytriggerTestCallOutput?: TelephonytriggerTestCallOutputResolvers<ContextType>;
  UserOrgOutput?: UserOrgOutputResolvers<ContextType>;
  UserUpdateOutput?: UserUpdateOutputResolvers<ContextType>;
  VerificationOutput?: VerificationOutputResolvers<ContextType>;
  VoiceTypes?: VoiceTypesResolvers<ContextType>;
  VoiceTypesAggregate?: VoiceTypesAggregateResolvers<ContextType>;
  VoiceTypesAggregateFields?: VoiceTypesAggregateFieldsResolvers<ContextType>;
  VoiceTypesMaxFields?: VoiceTypesMaxFieldsResolvers<ContextType>;
  VoiceTypesMinFields?: VoiceTypesMinFieldsResolvers<ContextType>;
  VoiceTypesMutationResponse?: VoiceTypesMutationResponseResolvers<ContextType>;
  acceptInviteOutput?: acceptInviteOutputResolvers<ContextType>;
  acceptRequestsOutput?: acceptRequestsOutputResolvers<ContextType>;
  activityParticipant?: activityParticipantResolvers<ContextType>;
  activityParticipantAggregate?: activityParticipantAggregateResolvers<ContextType>;
  activityParticipantAggregateFields?: activityParticipantAggregateFieldsResolvers<ContextType>;
  activityParticipantMaxFields?: activityParticipantMaxFieldsResolvers<ContextType>;
  activityParticipantMinFields?: activityParticipantMinFieldsResolvers<ContextType>;
  activityParticipantMutationResponse?: activityParticipantMutationResponseResolvers<ContextType>;
  activityTaskOutput?: activityTaskOutputResolvers<ContextType>;
  address?: addressResolvers<ContextType>;
  addressAggregate?: addressAggregateResolvers<ContextType>;
  addressAggregateFields?: addressAggregateFieldsResolvers<ContextType>;
  addressMaxFields?: addressMaxFieldsResolvers<ContextType>;
  addressMinFields?: addressMinFieldsResolvers<ContextType>;
  addressMutationResponse?: addressMutationResponseResolvers<ContextType>;
  blockedDomainUser?: blockedDomainUserResolvers<ContextType>;
  blockedDomainUserAggregate?: blockedDomainUserAggregateResolvers<ContextType>;
  blockedDomainUserAggregateFields?: blockedDomainUserAggregateFieldsResolvers<ContextType>;
  blockedDomainUserMaxFields?: blockedDomainUserMaxFieldsResolvers<ContextType>;
  blockedDomainUserMinFields?: blockedDomainUserMinFieldsResolvers<ContextType>;
  blockedDomainUserMutationResponse?: blockedDomainUserMutationResponseResolvers<ContextType>;
  bregmutation_root?: bregmutation_rootResolvers<ContextType>;
  bregquery_root?: bregquery_rootResolvers<ContextType>;
  bregsubscription_root?: bregsubscription_rootResolvers<ContextType>;
  businessQueueItemCollaboration?: businessQueueItemCollaborationResolvers<ContextType>;
  businessQueueItemCollaborationAggregate?: businessQueueItemCollaborationAggregateResolvers<ContextType>;
  businessQueueItemCollaborationAggregateFields?: businessQueueItemCollaborationAggregateFieldsResolvers<ContextType>;
  businessQueueItemCollaborationAvgFields?: businessQueueItemCollaborationAvgFieldsResolvers<ContextType>;
  businessQueueItemCollaborationMaxFields?: businessQueueItemCollaborationMaxFieldsResolvers<ContextType>;
  businessQueueItemCollaborationMinFields?: businessQueueItemCollaborationMinFieldsResolvers<ContextType>;
  businessQueueItemCollaborationMutationResponse?: businessQueueItemCollaborationMutationResponseResolvers<ContextType>;
  businessQueueItemCollaborationStddevFields?: businessQueueItemCollaborationStddevFieldsResolvers<ContextType>;
  businessQueueItemCollaborationStddevPopFields?: businessQueueItemCollaborationStddevPopFieldsResolvers<ContextType>;
  businessQueueItemCollaborationStddevSampFields?: businessQueueItemCollaborationStddevSampFieldsResolvers<ContextType>;
  businessQueueItemCollaborationSumFields?: businessQueueItemCollaborationSumFieldsResolvers<ContextType>;
  businessQueueItemCollaborationVarPopFields?: businessQueueItemCollaborationVarPopFieldsResolvers<ContextType>;
  businessQueueItemCollaborationVarSampFields?: businessQueueItemCollaborationVarSampFieldsResolvers<ContextType>;
  businessQueueItemCollaborationVarianceFields?: businessQueueItemCollaborationVarianceFieldsResolvers<ContextType>;
  businessUserContacts?: businessUserContactsResolvers<ContextType>;
  businessUserContactsAggregate?: businessUserContactsAggregateResolvers<ContextType>;
  businessUserContactsAggregateFields?: businessUserContactsAggregateFieldsResolvers<ContextType>;
  businessUserContactsMaxFields?: businessUserContactsMaxFieldsResolvers<ContextType>;
  businessUserContactsMinFields?: businessUserContactsMinFieldsResolvers<ContextType>;
  businessUserContactsMutationResponse?: businessUserContactsMutationResponseResolvers<ContextType>;
  businessUserSettings?: businessUserSettingsResolvers<ContextType>;
  businessUserSettingsAggregate?: businessUserSettingsAggregateResolvers<ContextType>;
  businessUserSettingsAggregateFields?: businessUserSettingsAggregateFieldsResolvers<ContextType>;
  businessUserSettingsAvgFields?: businessUserSettingsAvgFieldsResolvers<ContextType>;
  businessUserSettingsMaxFields?: businessUserSettingsMaxFieldsResolvers<ContextType>;
  businessUserSettingsMinFields?: businessUserSettingsMinFieldsResolvers<ContextType>;
  businessUserSettingsMutationResponse?: businessUserSettingsMutationResponseResolvers<ContextType>;
  businessUserSettingsStddevFields?: businessUserSettingsStddevFieldsResolvers<ContextType>;
  businessUserSettingsStddevPopFields?: businessUserSettingsStddevPopFieldsResolvers<ContextType>;
  businessUserSettingsStddevSampFields?: businessUserSettingsStddevSampFieldsResolvers<ContextType>;
  businessUserSettingsSumFields?: businessUserSettingsSumFieldsResolvers<ContextType>;
  businessUserSettingsVarPopFields?: businessUserSettingsVarPopFieldsResolvers<ContextType>;
  businessUserSettingsVarSampFields?: businessUserSettingsVarSampFieldsResolvers<ContextType>;
  businessUserSettingsVarianceFields?: businessUserSettingsVarianceFieldsResolvers<ContextType>;
  callBackLaterResult?: callBackLaterResultResolvers<ContextType>;
  checkTelephonyIdOutput?: checkTelephonyIdOutputResolvers<ContextType>;
  createEmailProviderSubscriptionOutput?: createEmailProviderSubscriptionOutputResolvers<ContextType>;
  createMessagingGroupOutput?: createMessagingGroupOutputResolvers<ContextType>;
  createPhoneroOrgUsersOutput?: createPhoneroOrgUsersOutputResolvers<ContextType>;
  createRoomOutput?: createRoomOutputResolvers<ContextType>;
  crmStatusMessage?: crmStatusMessageResolvers<ContextType>;
  crmStatusMessageAggregate?: crmStatusMessageAggregateResolvers<ContextType>;
  crmStatusMessageAggregateFields?: crmStatusMessageAggregateFieldsResolvers<ContextType>;
  crmStatusMessageAvgFields?: crmStatusMessageAvgFieldsResolvers<ContextType>;
  crmStatusMessageMaxFields?: crmStatusMessageMaxFieldsResolvers<ContextType>;
  crmStatusMessageMinFields?: crmStatusMessageMinFieldsResolvers<ContextType>;
  crmStatusMessageMutationResponse?: crmStatusMessageMutationResponseResolvers<ContextType>;
  crmStatusMessageStddevFields?: crmStatusMessageStddevFieldsResolvers<ContextType>;
  crmStatusMessageStddevPopFields?: crmStatusMessageStddevPopFieldsResolvers<ContextType>;
  crmStatusMessageStddevSampFields?: crmStatusMessageStddevSampFieldsResolvers<ContextType>;
  crmStatusMessageSumFields?: crmStatusMessageSumFieldsResolvers<ContextType>;
  crmStatusMessageVarPopFields?: crmStatusMessageVarPopFieldsResolvers<ContextType>;
  crmStatusMessageVarSampFields?: crmStatusMessageVarSampFieldsResolvers<ContextType>;
  crmStatusMessageVarianceFields?: crmStatusMessageVarianceFieldsResolvers<ContextType>;
  crmYoutelloCatalystIdMapping?: crmYoutelloCatalystIdMappingResolvers<ContextType>;
  crmYoutelloCatalystIdMappingAggregate?: crmYoutelloCatalystIdMappingAggregateResolvers<ContextType>;
  crmYoutelloCatalystIdMappingAggregateFields?: crmYoutelloCatalystIdMappingAggregateFieldsResolvers<ContextType>;
  crmYoutelloCatalystIdMappingAvgFields?: crmYoutelloCatalystIdMappingAvgFieldsResolvers<ContextType>;
  crmYoutelloCatalystIdMappingMaxFields?: crmYoutelloCatalystIdMappingMaxFieldsResolvers<ContextType>;
  crmYoutelloCatalystIdMappingMinFields?: crmYoutelloCatalystIdMappingMinFieldsResolvers<ContextType>;
  crmYoutelloCatalystIdMappingMutationResponse?: crmYoutelloCatalystIdMappingMutationResponseResolvers<ContextType>;
  crmYoutelloCatalystIdMappingStddevFields?: crmYoutelloCatalystIdMappingStddevFieldsResolvers<ContextType>;
  crmYoutelloCatalystIdMappingStddevPopFields?: crmYoutelloCatalystIdMappingStddevPopFieldsResolvers<ContextType>;
  crmYoutelloCatalystIdMappingStddevSampFields?: crmYoutelloCatalystIdMappingStddevSampFieldsResolvers<ContextType>;
  crmYoutelloCatalystIdMappingSumFields?: crmYoutelloCatalystIdMappingSumFieldsResolvers<ContextType>;
  crmYoutelloCatalystIdMappingVarPopFields?: crmYoutelloCatalystIdMappingVarPopFieldsResolvers<ContextType>;
  crmYoutelloCatalystIdMappingVarSampFields?: crmYoutelloCatalystIdMappingVarSampFieldsResolvers<ContextType>;
  crmYoutelloCatalystIdMappingVarianceFields?: crmYoutelloCatalystIdMappingVarianceFieldsResolvers<ContextType>;
  dashboardDataOutput?: dashboardDataOutputResolvers<ContextType>;
  deleteEmailProviderSubscriptionOutput?: deleteEmailProviderSubscriptionOutputResolvers<ContextType>;
  domainActivity?: domainActivityResolvers<ContextType>;
  domainActivityAggregate?: domainActivityAggregateResolvers<ContextType>;
  domainActivityAggregateFields?: domainActivityAggregateFieldsResolvers<ContextType>;
  domainActivityAvgFields?: domainActivityAvgFieldsResolvers<ContextType>;
  domainActivityMaxFields?: domainActivityMaxFieldsResolvers<ContextType>;
  domainActivityMinFields?: domainActivityMinFieldsResolvers<ContextType>;
  domainActivityMutationResponse?: domainActivityMutationResponseResolvers<ContextType>;
  domainActivityStddevFields?: domainActivityStddevFieldsResolvers<ContextType>;
  domainActivityStddevPopFields?: domainActivityStddevPopFieldsResolvers<ContextType>;
  domainActivityStddevSampFields?: domainActivityStddevSampFieldsResolvers<ContextType>;
  domainActivitySumFields?: domainActivitySumFieldsResolvers<ContextType>;
  domainActivityVarPopFields?: domainActivityVarPopFieldsResolvers<ContextType>;
  domainActivityVarSampFields?: domainActivityVarSampFieldsResolvers<ContextType>;
  domainActivityVarianceFields?: domainActivityVarianceFieldsResolvers<ContextType>;
  domainOrganization?: domainOrganizationResolvers<ContextType>;
  domainOrganizationAggregate?: domainOrganizationAggregateResolvers<ContextType>;
  domainOrganizationAggregateFields?: domainOrganizationAggregateFieldsResolvers<ContextType>;
  domainOrganizationMaxFields?: domainOrganizationMaxFieldsResolvers<ContextType>;
  domainOrganizationMinFields?: domainOrganizationMinFieldsResolvers<ContextType>;
  domainOrganizationMutationResponse?: domainOrganizationMutationResponseResolvers<ContextType>;
  domainParticipant?: domainParticipantResolvers<ContextType>;
  domainParticipantAggregate?: domainParticipantAggregateResolvers<ContextType>;
  domainParticipantAggregateFields?: domainParticipantAggregateFieldsResolvers<ContextType>;
  domainParticipantMaxFields?: domainParticipantMaxFieldsResolvers<ContextType>;
  domainParticipantMinFields?: domainParticipantMinFieldsResolvers<ContextType>;
  domainParticipantMutationResponse?: domainParticipantMutationResponseResolvers<ContextType>;
  domainType?: domainTypeResolvers<ContextType>;
  domainTypeAggregate?: domainTypeAggregateResolvers<ContextType>;
  domainTypeAggregateFields?: domainTypeAggregateFieldsResolvers<ContextType>;
  domainTypeMaxFields?: domainTypeMaxFieldsResolvers<ContextType>;
  domainTypeMinFields?: domainTypeMinFieldsResolvers<ContextType>;
  domainTypeMutationResponse?: domainTypeMutationResponseResolvers<ContextType>;
  domainUser?: domainUserResolvers<ContextType>;
  domainUserAggregate?: domainUserAggregateResolvers<ContextType>;
  domainUserAggregateFields?: domainUserAggregateFieldsResolvers<ContextType>;
  domainUserAvgFields?: domainUserAvgFieldsResolvers<ContextType>;
  domainUserCategory?: domainUserCategoryResolvers<ContextType>;
  domainUserCategoryAggregate?: domainUserCategoryAggregateResolvers<ContextType>;
  domainUserCategoryAggregateFields?: domainUserCategoryAggregateFieldsResolvers<ContextType>;
  domainUserCategoryMaxFields?: domainUserCategoryMaxFieldsResolvers<ContextType>;
  domainUserCategoryMinFields?: domainUserCategoryMinFieldsResolvers<ContextType>;
  domainUserCategoryMutationResponse?: domainUserCategoryMutationResponseResolvers<ContextType>;
  domainUserMaxFields?: domainUserMaxFieldsResolvers<ContextType>;
  domainUserMinFields?: domainUserMinFieldsResolvers<ContextType>;
  domainUserMutationResponse?: domainUserMutationResponseResolvers<ContextType>;
  domainUserStddevFields?: domainUserStddevFieldsResolvers<ContextType>;
  domainUserStddevPopFields?: domainUserStddevPopFieldsResolvers<ContextType>;
  domainUserStddevSampFields?: domainUserStddevSampFieldsResolvers<ContextType>;
  domainUserSumFields?: domainUserSumFieldsResolvers<ContextType>;
  domainUserVarPopFields?: domainUserVarPopFieldsResolvers<ContextType>;
  domainUserVarSampFields?: domainUserVarSampFieldsResolvers<ContextType>;
  domainUserVarianceFields?: domainUserVarianceFieldsResolvers<ContextType>;
  emailDomainUserOutput?: emailDomainUserOutputResolvers<ContextType>;
  emailingmutation_root?: emailingmutation_rootResolvers<ContextType>;
  emailingquery_root?: emailingquery_rootResolvers<ContextType>;
  emailingsubscription_root?: emailingsubscription_rootResolvers<ContextType>;
  fileOutput?: fileOutputResolvers<ContextType>;
  geodatamutation_root?: geodatamutation_rootResolvers<ContextType>;
  geodataquery_root?: geodataquery_rootResolvers<ContextType>;
  geodatasubscription_root?: geodatasubscription_rootResolvers<ContextType>;
  getEmailAccountOutput?: getEmailAccountOutputResolvers<ContextType>;
  incomingSms?: incomingSmsResolvers<ContextType>;
  inviteOutput?: inviteOutputResolvers<ContextType>;
  json?: GraphQLScalarType;
  jsonb?: GraphQLScalarType;
  languages?: languagesResolvers<ContextType>;
  languagesAggregate?: languagesAggregateResolvers<ContextType>;
  languagesAggregateFields?: languagesAggregateFieldsResolvers<ContextType>;
  languagesMaxFields?: languagesMaxFieldsResolvers<ContextType>;
  languagesMinFields?: languagesMinFieldsResolvers<ContextType>;
  languagesMutationResponse?: languagesMutationResponseResolvers<ContextType>;
  leaveOrganizationOutput?: leaveOrganizationOutputResolvers<ContextType>;
  message?: messageResolvers<ContextType>;
  messageAggregate?: messageAggregateResolvers<ContextType>;
  messageAggregateFields?: messageAggregateFieldsResolvers<ContextType>;
  messageMaxFields?: messageMaxFieldsResolvers<ContextType>;
  messageMinFields?: messageMinFieldsResolvers<ContextType>;
  messageMutationResponse?: messageMutationResponseResolvers<ContextType>;
  messageType?: messageTypeResolvers<ContextType>;
  messageTypeAggregate?: messageTypeAggregateResolvers<ContextType>;
  messageTypeAggregateFields?: messageTypeAggregateFieldsResolvers<ContextType>;
  messageTypeMaxFields?: messageTypeMaxFieldsResolvers<ContextType>;
  messageTypeMinFields?: messageTypeMinFieldsResolvers<ContextType>;
  messageTypeMutationResponse?: messageTypeMutationResponseResolvers<ContextType>;
  messagingActivity?: messagingActivityResolvers<ContextType>;
  messagingActivityAggregate?: messagingActivityAggregateResolvers<ContextType>;
  messagingActivityAggregateFields?: messagingActivityAggregateFieldsResolvers<ContextType>;
  messagingActivityMaxFields?: messagingActivityMaxFieldsResolvers<ContextType>;
  messagingActivityMinFields?: messagingActivityMinFieldsResolvers<ContextType>;
  messagingActivityMutationResponse?: messagingActivityMutationResponseResolvers<ContextType>;
  messagingActivityOrganization?: messagingActivityOrganizationResolvers<ContextType>;
  messagingActivityOrganizationAggregate?: messagingActivityOrganizationAggregateResolvers<ContextType>;
  messagingActivityOrganizationAggregateFields?: messagingActivityOrganizationAggregateFieldsResolvers<ContextType>;
  messagingActivityOrganizationMaxFields?: messagingActivityOrganizationMaxFieldsResolvers<ContextType>;
  messagingActivityOrganizationMinFields?: messagingActivityOrganizationMinFieldsResolvers<ContextType>;
  messagingActivityOrganizationMutationResponse?: messagingActivityOrganizationMutationResponseResolvers<ContextType>;
  messagingActivityType?: messagingActivityTypeResolvers<ContextType>;
  messagingActivityTypeAggregate?: messagingActivityTypeAggregateResolvers<ContextType>;
  messagingActivityTypeAggregateFields?: messagingActivityTypeAggregateFieldsResolvers<ContextType>;
  messagingActivityTypeMaxFields?: messagingActivityTypeMaxFieldsResolvers<ContextType>;
  messagingActivityTypeMinFields?: messagingActivityTypeMinFieldsResolvers<ContextType>;
  messagingActivityTypeMutationResponse?: messagingActivityTypeMutationResponseResolvers<ContextType>;
  messagingActivityUser?: messagingActivityUserResolvers<ContextType>;
  messagingActivityUserAggregate?: messagingActivityUserAggregateResolvers<ContextType>;
  messagingActivityUserAggregateFields?: messagingActivityUserAggregateFieldsResolvers<ContextType>;
  messagingActivityUserAvgFields?: messagingActivityUserAvgFieldsResolvers<ContextType>;
  messagingActivityUserMaxFields?: messagingActivityUserMaxFieldsResolvers<ContextType>;
  messagingActivityUserMinFields?: messagingActivityUserMinFieldsResolvers<ContextType>;
  messagingActivityUserMutationResponse?: messagingActivityUserMutationResponseResolvers<ContextType>;
  messagingActivityUserStddevFields?: messagingActivityUserStddevFieldsResolvers<ContextType>;
  messagingActivityUserStddevPopFields?: messagingActivityUserStddevPopFieldsResolvers<ContextType>;
  messagingActivityUserStddevSampFields?: messagingActivityUserStddevSampFieldsResolvers<ContextType>;
  messagingActivityUserSumFields?: messagingActivityUserSumFieldsResolvers<ContextType>;
  messagingActivityUserVarPopFields?: messagingActivityUserVarPopFieldsResolvers<ContextType>;
  messagingActivityUserVarSampFields?: messagingActivityUserVarSampFieldsResolvers<ContextType>;
  messagingActivityUserVarianceFields?: messagingActivityUserVarianceFieldsResolvers<ContextType>;
  messagingMessage?: messagingMessageResolvers<ContextType>;
  messagingMessageAggregate?: messagingMessageAggregateResolvers<ContextType>;
  messagingMessageAggregateFields?: messagingMessageAggregateFieldsResolvers<ContextType>;
  messagingMessageEmoji?: messagingMessageEmojiResolvers<ContextType>;
  messagingMessageEmojiAggregate?: messagingMessageEmojiAggregateResolvers<ContextType>;
  messagingMessageEmojiAggregateFields?: messagingMessageEmojiAggregateFieldsResolvers<ContextType>;
  messagingMessageEmojiMaxFields?: messagingMessageEmojiMaxFieldsResolvers<ContextType>;
  messagingMessageEmojiMinFields?: messagingMessageEmojiMinFieldsResolvers<ContextType>;
  messagingMessageEmojiMutationResponse?: messagingMessageEmojiMutationResponseResolvers<ContextType>;
  messagingMessageMaxFields?: messagingMessageMaxFieldsResolvers<ContextType>;
  messagingMessageMinFields?: messagingMessageMinFieldsResolvers<ContextType>;
  messagingMessageMutationResponse?: messagingMessageMutationResponseResolvers<ContextType>;
  messagingMessageRead?: messagingMessageReadResolvers<ContextType>;
  messagingMessageReadAggregate?: messagingMessageReadAggregateResolvers<ContextType>;
  messagingMessageReadAggregateFields?: messagingMessageReadAggregateFieldsResolvers<ContextType>;
  messagingMessageReadMaxFields?: messagingMessageReadMaxFieldsResolvers<ContextType>;
  messagingMessageReadMinFields?: messagingMessageReadMinFieldsResolvers<ContextType>;
  messagingMessageReadMutationResponse?: messagingMessageReadMutationResponseResolvers<ContextType>;
  messagingMessageType?: messagingMessageTypeResolvers<ContextType>;
  messagingMessageTypeAggregate?: messagingMessageTypeAggregateResolvers<ContextType>;
  messagingMessageTypeAggregateFields?: messagingMessageTypeAggregateFieldsResolvers<ContextType>;
  messagingMessageTypeMaxFields?: messagingMessageTypeMaxFieldsResolvers<ContextType>;
  messagingMessageTypeMinFields?: messagingMessageTypeMinFieldsResolvers<ContextType>;
  messagingMessageTypeMutationResponse?: messagingMessageTypeMutationResponseResolvers<ContextType>;
  mutation_root?: mutation_rootResolvers<ContextType>;
  notification?: notificationResolvers<ContextType>;
  notificationAggregate?: notificationAggregateResolvers<ContextType>;
  notificationAggregateFields?: notificationAggregateFieldsResolvers<ContextType>;
  notificationMaxFields?: notificationMaxFieldsResolvers<ContextType>;
  notificationMinFields?: notificationMinFieldsResolvers<ContextType>;
  notificationMutationResponse?: notificationMutationResponseResolvers<ContextType>;
  notificationSend?: notificationSendResolvers<ContextType>;
  notificationSendAggregate?: notificationSendAggregateResolvers<ContextType>;
  notificationSendAggregateFields?: notificationSendAggregateFieldsResolvers<ContextType>;
  notificationSendMaxFields?: notificationSendMaxFieldsResolvers<ContextType>;
  notificationSendMinFields?: notificationSendMinFieldsResolvers<ContextType>;
  notificationSendMutationResponse?: notificationSendMutationResponseResolvers<ContextType>;
  notificationSettingActivity?: notificationSettingActivityResolvers<ContextType>;
  notificationSettingActivityAggregate?: notificationSettingActivityAggregateResolvers<ContextType>;
  notificationSettingActivityAggregateFields?: notificationSettingActivityAggregateFieldsResolvers<ContextType>;
  notificationSettingActivityMaxFields?: notificationSettingActivityMaxFieldsResolvers<ContextType>;
  notificationSettingActivityMinFields?: notificationSettingActivityMinFieldsResolvers<ContextType>;
  notificationSettingActivityMutationResponse?: notificationSettingActivityMutationResponseResolvers<ContextType>;
  notificationUser?: notificationUserResolvers<ContextType>;
  notificationUserAggregate?: notificationUserAggregateResolvers<ContextType>;
  notificationUserAggregateFields?: notificationUserAggregateFieldsResolvers<ContextType>;
  notificationUserDevice?: notificationUserDeviceResolvers<ContextType>;
  notificationUserDeviceAggregate?: notificationUserDeviceAggregateResolvers<ContextType>;
  notificationUserDeviceAggregateFields?: notificationUserDeviceAggregateFieldsResolvers<ContextType>;
  notificationUserDeviceAvgFields?: notificationUserDeviceAvgFieldsResolvers<ContextType>;
  notificationUserDeviceMaxFields?: notificationUserDeviceMaxFieldsResolvers<ContextType>;
  notificationUserDeviceMinFields?: notificationUserDeviceMinFieldsResolvers<ContextType>;
  notificationUserDeviceMutationResponse?: notificationUserDeviceMutationResponseResolvers<ContextType>;
  notificationUserDeviceStddevFields?: notificationUserDeviceStddevFieldsResolvers<ContextType>;
  notificationUserDeviceStddevPopFields?: notificationUserDeviceStddevPopFieldsResolvers<ContextType>;
  notificationUserDeviceStddevSampFields?: notificationUserDeviceStddevSampFieldsResolvers<ContextType>;
  notificationUserDeviceSumFields?: notificationUserDeviceSumFieldsResolvers<ContextType>;
  notificationUserDeviceVarPopFields?: notificationUserDeviceVarPopFieldsResolvers<ContextType>;
  notificationUserDeviceVarSampFields?: notificationUserDeviceVarSampFieldsResolvers<ContextType>;
  notificationUserDeviceVarianceFields?: notificationUserDeviceVarianceFieldsResolvers<ContextType>;
  notificationUserMaxFields?: notificationUserMaxFieldsResolvers<ContextType>;
  notificationUserMinFields?: notificationUserMinFieldsResolvers<ContextType>;
  notificationUserMutationResponse?: notificationUserMutationResponseResolvers<ContextType>;
  numeric?: GraphQLScalarType;
  ordersIntegrations?: ordersIntegrationsResolvers<ContextType>;
  ordersIntegrationsAggregate?: ordersIntegrationsAggregateResolvers<ContextType>;
  ordersIntegrationsAggregateFields?: ordersIntegrationsAggregateFieldsResolvers<ContextType>;
  ordersIntegrationsAvgFields?: ordersIntegrationsAvgFieldsResolvers<ContextType>;
  ordersIntegrationsMaxFields?: ordersIntegrationsMaxFieldsResolvers<ContextType>;
  ordersIntegrationsMinFields?: ordersIntegrationsMinFieldsResolvers<ContextType>;
  ordersIntegrationsMutationResponse?: ordersIntegrationsMutationResponseResolvers<ContextType>;
  ordersIntegrationsStddevFields?: ordersIntegrationsStddevFieldsResolvers<ContextType>;
  ordersIntegrationsStddevPopFields?: ordersIntegrationsStddevPopFieldsResolvers<ContextType>;
  ordersIntegrationsStddevSampFields?: ordersIntegrationsStddevSampFieldsResolvers<ContextType>;
  ordersIntegrationsSumFields?: ordersIntegrationsSumFieldsResolvers<ContextType>;
  ordersIntegrationsVarPopFields?: ordersIntegrationsVarPopFieldsResolvers<ContextType>;
  ordersIntegrationsVarSampFields?: ordersIntegrationsVarSampFieldsResolvers<ContextType>;
  ordersIntegrationsVarianceFields?: ordersIntegrationsVarianceFieldsResolvers<ContextType>;
  orgAccessRequestOutput?: orgAccessRequestOutputResolvers<ContextType>;
  organization?: organizationResolvers<ContextType>;
  organizationAggregate?: organizationAggregateResolvers<ContextType>;
  organizationAggregateFields?: organizationAggregateFieldsResolvers<ContextType>;
  organizationAuthorizationEnumGroup?: organizationAuthorizationEnumGroupResolvers<ContextType>;
  organizationAuthorizationEnumGroupAggregate?: organizationAuthorizationEnumGroupAggregateResolvers<ContextType>;
  organizationAuthorizationEnumGroupAggregateFields?: organizationAuthorizationEnumGroupAggregateFieldsResolvers<ContextType>;
  organizationAuthorizationEnumGroupMaxFields?: organizationAuthorizationEnumGroupMaxFieldsResolvers<ContextType>;
  organizationAuthorizationEnumGroupMinFields?: organizationAuthorizationEnumGroupMinFieldsResolvers<ContextType>;
  organizationAuthorizationEnumGroupMutationResponse?: organizationAuthorizationEnumGroupMutationResponseResolvers<ContextType>;
  organizationAuthorizationGroup?: organizationAuthorizationGroupResolvers<ContextType>;
  organizationAuthorizationGroupAggregate?: organizationAuthorizationGroupAggregateResolvers<ContextType>;
  organizationAuthorizationGroupAggregateFields?: organizationAuthorizationGroupAggregateFieldsResolvers<ContextType>;
  organizationAuthorizationGroupMaxFields?: organizationAuthorizationGroupMaxFieldsResolvers<ContextType>;
  organizationAuthorizationGroupMinFields?: organizationAuthorizationGroupMinFieldsResolvers<ContextType>;
  organizationAuthorizationGroupMutationResponse?: organizationAuthorizationGroupMutationResponseResolvers<ContextType>;
  organizationAvgFields?: organizationAvgFieldsResolvers<ContextType>;
  organizationMaxFields?: organizationMaxFieldsResolvers<ContextType>;
  organizationMinFields?: organizationMinFieldsResolvers<ContextType>;
  organizationMutationResponse?: organizationMutationResponseResolvers<ContextType>;
  organizationOrganizationRelationship?: organizationOrganizationRelationshipResolvers<ContextType>;
  organizationOrganizationRelationshipAggregate?: organizationOrganizationRelationshipAggregateResolvers<ContextType>;
  organizationOrganizationRelationshipAggregateFields?: organizationOrganizationRelationshipAggregateFieldsResolvers<ContextType>;
  organizationOrganizationRelationshipCategory?: organizationOrganizationRelationshipCategoryResolvers<ContextType>;
  organizationOrganizationRelationshipCategoryAggregate?: organizationOrganizationRelationshipCategoryAggregateResolvers<ContextType>;
  organizationOrganizationRelationshipCategoryAggregateFields?: organizationOrganizationRelationshipCategoryAggregateFieldsResolvers<ContextType>;
  organizationOrganizationRelationshipCategoryMaxFields?: organizationOrganizationRelationshipCategoryMaxFieldsResolvers<ContextType>;
  organizationOrganizationRelationshipCategoryMinFields?: organizationOrganizationRelationshipCategoryMinFieldsResolvers<ContextType>;
  organizationOrganizationRelationshipCategoryMutationResponse?: organizationOrganizationRelationshipCategoryMutationResponseResolvers<ContextType>;
  organizationOrganizationRelationshipMaxFields?: organizationOrganizationRelationshipMaxFieldsResolvers<ContextType>;
  organizationOrganizationRelationshipMinFields?: organizationOrganizationRelationshipMinFieldsResolvers<ContextType>;
  organizationOrganizationRelationshipMutationResponse?: organizationOrganizationRelationshipMutationResponseResolvers<ContextType>;
  organizationOrganizationUserAuthorization?: organizationOrganizationUserAuthorizationResolvers<ContextType>;
  organizationOrganizationUserAuthorizationAggregate?: organizationOrganizationUserAuthorizationAggregateResolvers<ContextType>;
  organizationOrganizationUserAuthorizationAggregateFields?: organizationOrganizationUserAuthorizationAggregateFieldsResolvers<ContextType>;
  organizationOrganizationUserAuthorizationMaxFields?: organizationOrganizationUserAuthorizationMaxFieldsResolvers<ContextType>;
  organizationOrganizationUserAuthorizationMinFields?: organizationOrganizationUserAuthorizationMinFieldsResolvers<ContextType>;
  organizationOrganizationUserAuthorizationMutationResponse?: organizationOrganizationUserAuthorizationMutationResponseResolvers<ContextType>;
  organizationOrganizationUserOrganizationsView?: organizationOrganizationUserOrganizationsViewResolvers<ContextType>;
  organizationOrganizationUserOrganizationsViewAggregate?: organizationOrganizationUserOrganizationsViewAggregateResolvers<ContextType>;
  organizationOrganizationUserOrganizationsViewAggregateFields?: organizationOrganizationUserOrganizationsViewAggregateFieldsResolvers<ContextType>;
  organizationOrganizationUserOrganizationsViewMaxFields?: organizationOrganizationUserOrganizationsViewMaxFieldsResolvers<ContextType>;
  organizationOrganizationUserOrganizationsViewMinFields?: organizationOrganizationUserOrganizationsViewMinFieldsResolvers<ContextType>;
  organizationOrganizationUserUsersView?: organizationOrganizationUserUsersViewResolvers<ContextType>;
  organizationOrganizationUserUsersViewAggregate?: organizationOrganizationUserUsersViewAggregateResolvers<ContextType>;
  organizationOrganizationUserUsersViewAggregateFields?: organizationOrganizationUserUsersViewAggregateFieldsResolvers<ContextType>;
  organizationOrganizationUserUsersViewMaxFields?: organizationOrganizationUserUsersViewMaxFieldsResolvers<ContextType>;
  organizationOrganizationUserUsersViewMinFields?: organizationOrganizationUserUsersViewMinFieldsResolvers<ContextType>;
  organizationStddevFields?: organizationStddevFieldsResolvers<ContextType>;
  organizationStddevPopFields?: organizationStddevPopFieldsResolvers<ContextType>;
  organizationStddevSampFields?: organizationStddevSampFieldsResolvers<ContextType>;
  organizationSumFields?: organizationSumFieldsResolvers<ContextType>;
  organizationUser?: organizationUserResolvers<ContextType>;
  organizationUserAggregate?: organizationUserAggregateResolvers<ContextType>;
  organizationUserAggregateFields?: organizationUserAggregateFieldsResolvers<ContextType>;
  organizationUserAttachments?: organizationUserAttachmentsResolvers<ContextType>;
  organizationUserAttachmentsAggregate?: organizationUserAttachmentsAggregateResolvers<ContextType>;
  organizationUserAttachmentsAggregateFields?: organizationUserAttachmentsAggregateFieldsResolvers<ContextType>;
  organizationUserAttachmentsMaxFields?: organizationUserAttachmentsMaxFieldsResolvers<ContextType>;
  organizationUserAttachmentsMinFields?: organizationUserAttachmentsMinFieldsResolvers<ContextType>;
  organizationUserAttachmentsMutationResponse?: organizationUserAttachmentsMutationResponseResolvers<ContextType>;
  organizationUserAuthorization?: organizationUserAuthorizationResolvers<ContextType>;
  organizationUserAuthorizationAggregate?: organizationUserAuthorizationAggregateResolvers<ContextType>;
  organizationUserAuthorizationAggregateFields?: organizationUserAuthorizationAggregateFieldsResolvers<ContextType>;
  organizationUserAuthorizationMaxFields?: organizationUserAuthorizationMaxFieldsResolvers<ContextType>;
  organizationUserAuthorizationMinFields?: organizationUserAuthorizationMinFieldsResolvers<ContextType>;
  organizationUserAuthorizationMutationResponse?: organizationUserAuthorizationMutationResponseResolvers<ContextType>;
  organizationUserDetail?: organizationUserDetailResolvers<ContextType>;
  organizationUserDetailAggregate?: organizationUserDetailAggregateResolvers<ContextType>;
  organizationUserDetailAggregateFields?: organizationUserDetailAggregateFieldsResolvers<ContextType>;
  organizationUserDetailMaxFields?: organizationUserDetailMaxFieldsResolvers<ContextType>;
  organizationUserDetailMinFields?: organizationUserDetailMinFieldsResolvers<ContextType>;
  organizationUserDetailMutationResponse?: organizationUserDetailMutationResponseResolvers<ContextType>;
  organizationUserDetailType?: organizationUserDetailTypeResolvers<ContextType>;
  organizationUserDetailTypeAggregate?: organizationUserDetailTypeAggregateResolvers<ContextType>;
  organizationUserDetailTypeAggregateFields?: organizationUserDetailTypeAggregateFieldsResolvers<ContextType>;
  organizationUserDetailTypeMaxFields?: organizationUserDetailTypeMaxFieldsResolvers<ContextType>;
  organizationUserDetailTypeMinFields?: organizationUserDetailTypeMinFieldsResolvers<ContextType>;
  organizationUserDetailTypeMutationResponse?: organizationUserDetailTypeMutationResponseResolvers<ContextType>;
  organizationUserInvite?: organizationUserInviteResolvers<ContextType>;
  organizationUserInviteAggregate?: organizationUserInviteAggregateResolvers<ContextType>;
  organizationUserInviteAggregateFields?: organizationUserInviteAggregateFieldsResolvers<ContextType>;
  organizationUserInviteMaxFields?: organizationUserInviteMaxFieldsResolvers<ContextType>;
  organizationUserInviteMinFields?: organizationUserInviteMinFieldsResolvers<ContextType>;
  organizationUserInviteMutationResponse?: organizationUserInviteMutationResponseResolvers<ContextType>;
  organizationUserMaxFields?: organizationUserMaxFieldsResolvers<ContextType>;
  organizationUserMinFields?: organizationUserMinFieldsResolvers<ContextType>;
  organizationUserMutationResponse?: organizationUserMutationResponseResolvers<ContextType>;
  organizationUserOutput?: organizationUserOutputResolvers<ContextType>;
  organizationUserStatus?: organizationUserStatusResolvers<ContextType>;
  organizationUserStatusAggregate?: organizationUserStatusAggregateResolvers<ContextType>;
  organizationUserStatusAggregateFields?: organizationUserStatusAggregateFieldsResolvers<ContextType>;
  organizationUserStatusMaxFields?: organizationUserStatusMaxFieldsResolvers<ContextType>;
  organizationUserStatusMinFields?: organizationUserStatusMinFieldsResolvers<ContextType>;
  organizationUserStatusMutationResponse?: organizationUserStatusMutationResponseResolvers<ContextType>;
  organizationUsers?: organizationUsersResolvers<ContextType>;
  organizationVarPopFields?: organizationVarPopFieldsResolvers<ContextType>;
  organizationVarSampFields?: organizationVarSampFieldsResolvers<ContextType>;
  organizationVarianceFields?: organizationVarianceFieldsResolvers<ContextType>;
  phoneNumberVerificationStatus?: phoneNumberVerificationStatusResolvers<ContextType>;
  phoneNumberVerificationStatusAggregate?: phoneNumberVerificationStatusAggregateResolvers<ContextType>;
  phoneNumberVerificationStatusAggregateFields?: phoneNumberVerificationStatusAggregateFieldsResolvers<ContextType>;
  phoneNumberVerificationStatusMaxFields?: phoneNumberVerificationStatusMaxFieldsResolvers<ContextType>;
  phoneNumberVerificationStatusMinFields?: phoneNumberVerificationStatusMinFieldsResolvers<ContextType>;
  phoneNumberVerificationStatusMutationResponse?: phoneNumberVerificationStatusMutationResponseResolvers<ContextType>;
  phoneUserOutput?: phoneUserOutputResolvers<ContextType>;
  privatizeUserResult?: privatizeUserResultResolvers<ContextType>;
  publicDevice?: publicDeviceResolvers<ContextType>;
  publicDeviceAggregate?: publicDeviceAggregateResolvers<ContextType>;
  publicDeviceAggregateFields?: publicDeviceAggregateFieldsResolvers<ContextType>;
  publicDeviceMaxFields?: publicDeviceMaxFieldsResolvers<ContextType>;
  publicDeviceMinFields?: publicDeviceMinFieldsResolvers<ContextType>;
  publicDeviceMutationResponse?: publicDeviceMutationResponseResolvers<ContextType>;
  publicExternalRequest?: publicExternalRequestResolvers<ContextType>;
  publicExternalRequestAggregate?: publicExternalRequestAggregateResolvers<ContextType>;
  publicExternalRequestAggregateFields?: publicExternalRequestAggregateFieldsResolvers<ContextType>;
  publicExternalRequestMaxFields?: publicExternalRequestMaxFieldsResolvers<ContextType>;
  publicExternalRequestMinFields?: publicExternalRequestMinFieldsResolvers<ContextType>;
  publicExternalRequestMutationResponse?: publicExternalRequestMutationResponseResolvers<ContextType>;
  publicFile?: publicFileResolvers<ContextType>;
  publicFileAggregate?: publicFileAggregateResolvers<ContextType>;
  publicFileAggregateFields?: publicFileAggregateFieldsResolvers<ContextType>;
  publicFileMaxFields?: publicFileMaxFieldsResolvers<ContextType>;
  publicFileMinFields?: publicFileMinFieldsResolvers<ContextType>;
  publicFileMutationResponse?: publicFileMutationResponseResolvers<ContextType>;
  publicNotification?: publicNotificationResolvers<ContextType>;
  publicNotificationAggregate?: publicNotificationAggregateResolvers<ContextType>;
  publicNotificationAggregateFields?: publicNotificationAggregateFieldsResolvers<ContextType>;
  publicNotificationAvgFields?: publicNotificationAvgFieldsResolvers<ContextType>;
  publicNotificationMaxFields?: publicNotificationMaxFieldsResolvers<ContextType>;
  publicNotificationMinFields?: publicNotificationMinFieldsResolvers<ContextType>;
  publicNotificationMutationResponse?: publicNotificationMutationResponseResolvers<ContextType>;
  publicNotificationStddevFields?: publicNotificationStddevFieldsResolvers<ContextType>;
  publicNotificationStddevPopFields?: publicNotificationStddevPopFieldsResolvers<ContextType>;
  publicNotificationStddevSampFields?: publicNotificationStddevSampFieldsResolvers<ContextType>;
  publicNotificationSumFields?: publicNotificationSumFieldsResolvers<ContextType>;
  publicNotificationVarPopFields?: publicNotificationVarPopFieldsResolvers<ContextType>;
  publicNotificationVarSampFields?: publicNotificationVarSampFieldsResolvers<ContextType>;
  publicNotificationVarianceFields?: publicNotificationVarianceFieldsResolvers<ContextType>;
  query_root?: query_rootResolvers<ContextType>;
  queueItem?: queueItemResolvers<ContextType>;
  queueItemAggregate?: queueItemAggregateResolvers<ContextType>;
  queueItemAggregateFields?: queueItemAggregateFieldsResolvers<ContextType>;
  queueItemMaxFields?: queueItemMaxFieldsResolvers<ContextType>;
  queueItemMinFields?: queueItemMinFieldsResolvers<ContextType>;
  queueItemMutationResponse?: queueItemMutationResponseResolvers<ContextType>;
  relOrganizationUserDomainUser?: relOrganizationUserDomainUserResolvers<ContextType>;
  relOrganizationUserDomainUserAggregate?: relOrganizationUserDomainUserAggregateResolvers<ContextType>;
  relOrganizationUserDomainUserAggregateFields?: relOrganizationUserDomainUserAggregateFieldsResolvers<ContextType>;
  relOrganizationUserDomainUserMaxFields?: relOrganizationUserDomainUserMaxFieldsResolvers<ContextType>;
  relOrganizationUserDomainUserMinFields?: relOrganizationUserDomainUserMinFieldsResolvers<ContextType>;
  relOrganizationUserDomainUserMutationResponse?: relOrganizationUserDomainUserMutationResponseResolvers<ContextType>;
  removeEmailDomainUserOutput?: removeEmailDomainUserOutputResolvers<ContextType>;
  removeOrganizationOutput?: removeOrganizationOutputResolvers<ContextType>;
  renewEmailProviderSubscriptionOutput?: renewEmailProviderSubscriptionOutputResolvers<ContextType>;
  setUpOrganizationOutput?: setUpOrganizationOutputResolvers<ContextType>;
  smsConnector?: smsConnectorResolvers<ContextType>;
  smsConnectorAggregate?: smsConnectorAggregateResolvers<ContextType>;
  smsConnectorAggregateFields?: smsConnectorAggregateFieldsResolvers<ContextType>;
  smsConnectorAvgFields?: smsConnectorAvgFieldsResolvers<ContextType>;
  smsConnectorMaxFields?: smsConnectorMaxFieldsResolvers<ContextType>;
  smsConnectorMinFields?: smsConnectorMinFieldsResolvers<ContextType>;
  smsConnectorMutationResponse?: smsConnectorMutationResponseResolvers<ContextType>;
  smsConnectorStddevFields?: smsConnectorStddevFieldsResolvers<ContextType>;
  smsConnectorStddevPopFields?: smsConnectorStddevPopFieldsResolvers<ContextType>;
  smsConnectorStddevSampFields?: smsConnectorStddevSampFieldsResolvers<ContextType>;
  smsConnectorSumFields?: smsConnectorSumFieldsResolvers<ContextType>;
  smsConnectorVarPopFields?: smsConnectorVarPopFieldsResolvers<ContextType>;
  smsConnectorVarSampFields?: smsConnectorVarSampFieldsResolvers<ContextType>;
  smsConnectorVarianceFields?: smsConnectorVarianceFieldsResolvers<ContextType>;
  smsGate?: smsGateResolvers<ContextType>;
  smsGateAggregate?: smsGateAggregateResolvers<ContextType>;
  smsGateAggregateFields?: smsGateAggregateFieldsResolvers<ContextType>;
  smsGateAvgFields?: smsGateAvgFieldsResolvers<ContextType>;
  smsGateMaxFields?: smsGateMaxFieldsResolvers<ContextType>;
  smsGateMinFields?: smsGateMinFieldsResolvers<ContextType>;
  smsGateMutationResponse?: smsGateMutationResponseResolvers<ContextType>;
  smsGateStddevFields?: smsGateStddevFieldsResolvers<ContextType>;
  smsGateStddevPopFields?: smsGateStddevPopFieldsResolvers<ContextType>;
  smsGateStddevSampFields?: smsGateStddevSampFieldsResolvers<ContextType>;
  smsGateSumFields?: smsGateSumFieldsResolvers<ContextType>;
  smsGateVarPopFields?: smsGateVarPopFieldsResolvers<ContextType>;
  smsGateVarSampFields?: smsGateVarSampFieldsResolvers<ContextType>;
  smsGateVarianceFields?: smsGateVarianceFieldsResolvers<ContextType>;
  smsLinkMobilitySmsContent?: smsLinkMobilitySmsContentResolvers<ContextType>;
  smsLinkMobilitySmsContentAggregate?: smsLinkMobilitySmsContentAggregateResolvers<ContextType>;
  smsLinkMobilitySmsContentAggregateFields?: smsLinkMobilitySmsContentAggregateFieldsResolvers<ContextType>;
  smsLinkMobilitySmsContentMaxFields?: smsLinkMobilitySmsContentMaxFieldsResolvers<ContextType>;
  smsLinkMobilitySmsContentMinFields?: smsLinkMobilitySmsContentMinFieldsResolvers<ContextType>;
  smsLinkMobilitySmsContentMutationResponse?: smsLinkMobilitySmsContentMutationResponseResolvers<ContextType>;
  smsLinkMobilitySmsMessage?: smsLinkMobilitySmsMessageResolvers<ContextType>;
  smsLinkMobilitySmsMessageAggregate?: smsLinkMobilitySmsMessageAggregateResolvers<ContextType>;
  smsLinkMobilitySmsMessageAggregateFields?: smsLinkMobilitySmsMessageAggregateFieldsResolvers<ContextType>;
  smsLinkMobilitySmsMessageAvgFields?: smsLinkMobilitySmsMessageAvgFieldsResolvers<ContextType>;
  smsLinkMobilitySmsMessageMaxFields?: smsLinkMobilitySmsMessageMaxFieldsResolvers<ContextType>;
  smsLinkMobilitySmsMessageMinFields?: smsLinkMobilitySmsMessageMinFieldsResolvers<ContextType>;
  smsLinkMobilitySmsMessageMutationResponse?: smsLinkMobilitySmsMessageMutationResponseResolvers<ContextType>;
  smsLinkMobilitySmsMessageStddevFields?: smsLinkMobilitySmsMessageStddevFieldsResolvers<ContextType>;
  smsLinkMobilitySmsMessageStddevPopFields?: smsLinkMobilitySmsMessageStddevPopFieldsResolvers<ContextType>;
  smsLinkMobilitySmsMessageStddevSampFields?: smsLinkMobilitySmsMessageStddevSampFieldsResolvers<ContextType>;
  smsLinkMobilitySmsMessageSumFields?: smsLinkMobilitySmsMessageSumFieldsResolvers<ContextType>;
  smsLinkMobilitySmsMessageVarPopFields?: smsLinkMobilitySmsMessageVarPopFieldsResolvers<ContextType>;
  smsLinkMobilitySmsMessageVarSampFields?: smsLinkMobilitySmsMessageVarSampFieldsResolvers<ContextType>;
  smsLinkMobilitySmsMessageVarianceFields?: smsLinkMobilitySmsMessageVarianceFieldsResolvers<ContextType>;
  smsLinkMobilitySmsRoute?: smsLinkMobilitySmsRouteResolvers<ContextType>;
  smsLinkMobilitySmsRouteAggregate?: smsLinkMobilitySmsRouteAggregateResolvers<ContextType>;
  smsLinkMobilitySmsRouteAggregateFields?: smsLinkMobilitySmsRouteAggregateFieldsResolvers<ContextType>;
  smsLinkMobilitySmsRouteMaxFields?: smsLinkMobilitySmsRouteMaxFieldsResolvers<ContextType>;
  smsLinkMobilitySmsRouteMinFields?: smsLinkMobilitySmsRouteMinFieldsResolvers<ContextType>;
  smsLinkMobilitySmsRouteMutationResponse?: smsLinkMobilitySmsRouteMutationResponseResolvers<ContextType>;
  smsProvider?: smsProviderResolvers<ContextType>;
  smsProviderAggregate?: smsProviderAggregateResolvers<ContextType>;
  smsProviderAggregateFields?: smsProviderAggregateFieldsResolvers<ContextType>;
  smsProviderAvgFields?: smsProviderAvgFieldsResolvers<ContextType>;
  smsProviderMaxFields?: smsProviderMaxFieldsResolvers<ContextType>;
  smsProviderMinFields?: smsProviderMinFieldsResolvers<ContextType>;
  smsProviderMutationResponse?: smsProviderMutationResponseResolvers<ContextType>;
  smsProviderStddevFields?: smsProviderStddevFieldsResolvers<ContextType>;
  smsProviderStddevPopFields?: smsProviderStddevPopFieldsResolvers<ContextType>;
  smsProviderStddevSampFields?: smsProviderStddevSampFieldsResolvers<ContextType>;
  smsProviderSumFields?: smsProviderSumFieldsResolvers<ContextType>;
  smsProviderVarPopFields?: smsProviderVarPopFieldsResolvers<ContextType>;
  smsProviderVarSampFields?: smsProviderVarSampFieldsResolvers<ContextType>;
  smsProviderVarianceFields?: smsProviderVarianceFieldsResolvers<ContextType>;
  smsSm?: smsSmResolvers<ContextType>;
  smsSmAggregate?: smsSmAggregateResolvers<ContextType>;
  smsSmAggregateFields?: smsSmAggregateFieldsResolvers<ContextType>;
  smsSmAvgFields?: smsSmAvgFieldsResolvers<ContextType>;
  smsSmMaxFields?: smsSmMaxFieldsResolvers<ContextType>;
  smsSmMinFields?: smsSmMinFieldsResolvers<ContextType>;
  smsSmMutationResponse?: smsSmMutationResponseResolvers<ContextType>;
  smsSmStddevFields?: smsSmStddevFieldsResolvers<ContextType>;
  smsSmStddevPopFields?: smsSmStddevPopFieldsResolvers<ContextType>;
  smsSmStddevSampFields?: smsSmStddevSampFieldsResolvers<ContextType>;
  smsSmSumFields?: smsSmSumFieldsResolvers<ContextType>;
  smsSmVarPopFields?: smsSmVarPopFieldsResolvers<ContextType>;
  smsSmVarSampFields?: smsSmVarSampFieldsResolvers<ContextType>;
  smsSmVarianceFields?: smsSmVarianceFieldsResolvers<ContextType>;
  smsSmsExternalIncomingLinkMobility?: smsSmsExternalIncomingLinkMobilityResolvers<ContextType>;
  smsSmsExternalIncomingLinkMobilityAggregate?: smsSmsExternalIncomingLinkMobilityAggregateResolvers<ContextType>;
  smsSmsExternalIncomingLinkMobilityAggregateFields?: smsSmsExternalIncomingLinkMobilityAggregateFieldsResolvers<ContextType>;
  smsSmsExternalIncomingLinkMobilityMaxFields?: smsSmsExternalIncomingLinkMobilityMaxFieldsResolvers<ContextType>;
  smsSmsExternalIncomingLinkMobilityMinFields?: smsSmsExternalIncomingLinkMobilityMinFieldsResolvers<ContextType>;
  smsSmsExternalIncomingLinkMobilityMutationResponse?: smsSmsExternalIncomingLinkMobilityMutationResponseResolvers<ContextType>;
  subscription_root?: subscription_rootResolvers<ContextType>;
  taskmutation_root?: taskmutation_rootResolvers<ContextType>;
  taskquery_root?: taskquery_rootResolvers<ContextType>;
  tasksubscription_root?: tasksubscription_rootResolvers<ContextType>;
  telephonyDomainUserOutput?: telephonyDomainUserOutputResolvers<ContextType>;
  telephonymutation_root?: telephonymutation_rootResolvers<ContextType>;
  telephonyquery_root?: telephonyquery_rootResolvers<ContextType>;
  telephonysubscription_root?: telephonysubscription_rootResolvers<ContextType>;
  testNotificationSettingsResult?: testNotificationSettingsResultResolvers<ContextType>;
  timestamp?: GraphQLScalarType;
  timestamptz?: GraphQLScalarType;
  timetz?: GraphQLScalarType;
  updateDashboardDataOutput?: updateDashboardDataOutputResolvers<ContextType>;
  user?: userResolvers<ContextType>;
  userAggregate?: userAggregateResolvers<ContextType>;
  userAggregateFields?: userAggregateFieldsResolvers<ContextType>;
  userDeleteOutput?: userDeleteOutputResolvers<ContextType>;
  userDetail?: userDetailResolvers<ContextType>;
  userDetailAggregate?: userDetailAggregateResolvers<ContextType>;
  userDetailAggregateFields?: userDetailAggregateFieldsResolvers<ContextType>;
  userDetailMaxFields?: userDetailMaxFieldsResolvers<ContextType>;
  userDetailMinFields?: userDetailMinFieldsResolvers<ContextType>;
  userDetailMutationResponse?: userDetailMutationResponseResolvers<ContextType>;
  userDetailsType?: userDetailsTypeResolvers<ContextType>;
  userDetailsTypeAggregate?: userDetailsTypeAggregateResolvers<ContextType>;
  userDetailsTypeAggregateFields?: userDetailsTypeAggregateFieldsResolvers<ContextType>;
  userDetailsTypeMaxFields?: userDetailsTypeMaxFieldsResolvers<ContextType>;
  userDetailsTypeMinFields?: userDetailsTypeMinFieldsResolvers<ContextType>;
  userDetailsTypeMutationResponse?: userDetailsTypeMutationResponseResolvers<ContextType>;
  userDevice?: userDeviceResolvers<ContextType>;
  userDeviceAggregate?: userDeviceAggregateResolvers<ContextType>;
  userDeviceAggregateFields?: userDeviceAggregateFieldsResolvers<ContextType>;
  userDeviceMaxFields?: userDeviceMaxFieldsResolvers<ContextType>;
  userDeviceMinFields?: userDeviceMinFieldsResolvers<ContextType>;
  userDeviceMutationResponse?: userDeviceMutationResponseResolvers<ContextType>;
  userMaxFields?: userMaxFieldsResolvers<ContextType>;
  userMinFields?: userMinFieldsResolvers<ContextType>;
  userMutationResponse?: userMutationResponseResolvers<ContextType>;
  userPhoneNumber?: userPhoneNumberResolvers<ContextType>;
  userPhoneNumberAggregate?: userPhoneNumberAggregateResolvers<ContextType>;
  userPhoneNumberAggregateFields?: userPhoneNumberAggregateFieldsResolvers<ContextType>;
  userPhoneNumberMaxFields?: userPhoneNumberMaxFieldsResolvers<ContextType>;
  userPhoneNumberMinFields?: userPhoneNumberMinFieldsResolvers<ContextType>;
  userPhoneNumberMutationResponse?: userPhoneNumberMutationResponseResolvers<ContextType>;
  userRole?: userRoleResolvers<ContextType>;
  userRoleAggregate?: userRoleAggregateResolvers<ContextType>;
  userRoleAggregateFields?: userRoleAggregateFieldsResolvers<ContextType>;
  userRoleMaxFields?: userRoleMaxFieldsResolvers<ContextType>;
  userRoleMinFields?: userRoleMinFieldsResolvers<ContextType>;
  userRoleMutationResponse?: userRoleMutationResponseResolvers<ContextType>;
  uuid?: GraphQLScalarType;
  validationValidation?: validationValidationResolvers<ContextType>;
  validationValidationAggregate?: validationValidationAggregateResolvers<ContextType>;
  validationValidationAggregateFields?: validationValidationAggregateFieldsResolvers<ContextType>;
  validationValidationAvgFields?: validationValidationAvgFieldsResolvers<ContextType>;
  validationValidationMaxFields?: validationValidationMaxFieldsResolvers<ContextType>;
  validationValidationMinFields?: validationValidationMinFieldsResolvers<ContextType>;
  validationValidationMutationResponse?: validationValidationMutationResponseResolvers<ContextType>;
  validationValidationStddevFields?: validationValidationStddevFieldsResolvers<ContextType>;
  validationValidationStddevPopFields?: validationValidationStddevPopFieldsResolvers<ContextType>;
  validationValidationStddevSampFields?: validationValidationStddevSampFieldsResolvers<ContextType>;
  validationValidationSumFields?: validationValidationSumFieldsResolvers<ContextType>;
  validationValidationVarPopFields?: validationValidationVarPopFieldsResolvers<ContextType>;
  validationValidationVarSampFields?: validationValidationVarSampFieldsResolvers<ContextType>;
  validationValidationVarianceFields?: validationValidationVarianceFieldsResolvers<ContextType>;
  verifyOrganizationUserPhoneNumberOutput?: verifyOrganizationUserPhoneNumberOutputResolvers<ContextType>;
  videoInviteOrgUserOutput?: videoInviteOrgUserOutputResolvers<ContextType>;
};

export type DirectiveResolvers<ContextType = any> = {
  cached?: cachedDirectiveResolver<any, any, ContextType>;
};

export type CreateQueueItemParticipantMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  queueItemId?: InputMaybe<Scalars['uuid']['input']>;
  responsible?: InputMaybe<Scalars['Boolean']['input']>;
  responsibility?: InputMaybe<QueueItemParticipantResponsibilityTypeEnum>;
  channel?: InputMaybe<BusinessQueueItemParticipantChannelTypeEnum>;
  contact?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateQueueItemParticipantMutation = { __typename?: 'mutation_root', createActivityParticipant?: { __typename?: 'activityParticipant', id: string, queueItemId?: string | null, organizationUserId?: string | null, responsible?: boolean | null, channel?: BusinessQueueItemParticipantChannelTypeEnum | null, contact?: boolean | null } | null };

export type SetActivityStatusDoneMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<ActivityStatusEnum>;
}>;


export type SetActivityStatusDoneMutation = { __typename?: 'mutation_root', updateQueueItem?: { __typename?: 'queueItem', id: string } | null };

export type SetActivityStatusUndoneMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<ActivityStatusEnum>;
}>;


export type SetActivityStatusUndoneMutation = { __typename?: 'mutation_root', updateQueueItems?: { __typename?: 'queueItemMutationResponse', affectedRows: number } | null };

export type UpdateAlarmMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
  absoluteDate?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type UpdateAlarmMutation = { __typename?: 'mutation_root', updateBusinessQueueItemAlarmsByPk?: { __typename?: 'BusinessQueueItemAlarms', id: string, absoluteDate?: string | null } | null };

export type UpdateParticipantChannelMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
  channel?: InputMaybe<BusinessQueueItemParticipantChannelTypeEnum>;
}>;


export type UpdateParticipantChannelMutation = { __typename?: 'mutation_root', updateActivityParticipant?: { __typename?: 'activityParticipant', id: string, channel?: BusinessQueueItemParticipantChannelTypeEnum | null } | null };

export type UpdateQueueItemDueDateMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
  dueDate?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type UpdateQueueItemDueDateMutation = { __typename?: 'mutation_root', updateQueueItem?: { __typename?: 'queueItem', id: string, dueDate?: string | null } | null };

export type UpdateQueueItemStartDateMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type UpdateQueueItemStartDateMutation = { __typename?: 'mutation_root', updateQueueItem?: { __typename?: 'queueItem', id: string, startDate?: string | null } | null };

export type UpdateTitleSubtitleMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  flexibilityType?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type UpdateTitleSubtitleMutation = { __typename?: 'mutation_root', updateQueueItem?: { __typename?: 'queueItem', id: string, title?: string | null, subTitle?: string | null, dueDate?: string | null, flexibilityType?: string | null } | null };

export type DeleteQueueItemParticipantMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type DeleteQueueItemParticipantMutation = { __typename?: 'mutation_root', deleteActivityParticipant?: { __typename?: 'activityParticipant', id: string } | null };

export type CreateQueueItemMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<ActivityStatusEnum>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  queueParticipants?: InputMaybe<activityParticipantArrRelInsertInput>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  alarms?: InputMaybe<Array<BusinessQueueItemAlarmsInsertInput> | BusinessQueueItemAlarmsInsertInput>;
  dueDate?: InputMaybe<Scalars['timestamptz']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  type?: InputMaybe<ActivityTypeEnum>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  additionalData?: InputMaybe<Scalars['jsonb']['input']>;
  ownerOrganizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  subType?: InputMaybe<Scalars['String']['input']>;
  flexibilityType?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateQueueItemMutation = { __typename?: 'mutation_root', createQueueItem?: { __typename?: 'queueItem', id: string, title?: string | null, subTitle?: string | null, status?: ActivityStatusEnum | null, queueParticipants: Array<{ __typename?: 'activityParticipant', id: string, organizationUserId?: string | null, responsibility?: QueueItemParticipantResponsibilityTypeEnum | null, owner?: boolean | null, channel?: BusinessQueueItemParticipantChannelTypeEnum | null }> } | null };

export type UpsertAlarmMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
  absoluteDate?: InputMaybe<Scalars['timestamptz']['input']>;
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
  queueItemId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type UpsertAlarmMutation = { __typename?: 'mutation_root', insertBusinessQueueItemAlarmsOne?: { __typename?: 'BusinessQueueItemAlarms', id: string } | null };

export type CreateIntegrationOrderMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  type: OrdersTypeEnum;
  termsversion?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  authLevel?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  organizationNumber?: InputMaybe<Scalars['String']['input']>;
  licenses?: InputMaybe<Scalars['Int']['input']>;
  deliveryDate?: InputMaybe<Scalars['timestamptz']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateIntegrationOrderMutation = { __typename?: 'mutation_root', createOrdersIntegrations?: { __typename?: 'ordersIntegrationsMutationResponse', affectedRows: number, returning: Array<{ __typename?: 'ordersIntegrations', id: string }> } | null };

export type UpdateOrderMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateOrderMutation = { __typename?: 'mutation_root', updateOrdersIntegration?: { __typename?: 'ordersIntegrations', active: boolean, id: string } | null };

export type DeleteOrderMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type DeleteOrderMutation = { __typename?: 'mutation_root', deleteOrdersIntegration?: { __typename?: 'ordersIntegrations', id: string } | null };

export type UpdateNoteMutationVariables = Exact<{
  note?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  createdByUser?: InputMaybe<Scalars['uuid']['input']>;
  createdOnUser?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type UpdateNoteMutation = { __typename?: 'mutation_root', createOrganizationUserAttentionNote?: { __typename?: 'OrganizationUserAttentionNote', id: string } | null };

export type GetTaskQueryVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetTaskQuery = { __typename?: 'query_root', queueItem?: { __typename?: 'queueItem', id: string, dueDate?: string | null, startDate?: string | null, title?: string | null, subTitle?: string | null, additionalData?: { [key: string]: any } | null, status?: ActivityStatusEnum | null, type?: ActivityTypeEnum | null, updatedAt: string, createdAt: string, location?: string | null, flexibilityType?: string | null, alarms: Array<{ __typename?: 'BusinessQueueItemAlarms', id: string, organizationUserId: string, alarmSelectionType: BusinessQueueItemAlarmTypeEnum, absoluteDate?: string | null }>, queueParticipants: Array<{ __typename?: 'activityParticipant', id: string, responsibility?: QueueItemParticipantResponsibilityTypeEnum | null, organizationUserId?: string | null, responsible?: boolean | null, contact?: boolean | null, channel?: BusinessQueueItemParticipantChannelTypeEnum | null, owner?: boolean | null, organizationUser?: { __typename?: 'organizationUser', id: string, firstName?: string | null, lastName?: string | null, userId?: string | null, phoneNumber?: string | null } | null }> } | null };

export type GetOrganizationUserQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetOrganizationUserQuery = { __typename?: 'query_root', organizationUsers: Array<{ __typename?: 'organizationUser', id: string }> };

export type GetTaskUserQueryVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetTaskUserQuery = { __typename?: 'query_root', organizationUsers: Array<{ __typename?: 'organizationUser', id: string, userId?: string | null, firstName?: string | null, phoneNumber?: string | null, emailAddress?: string | null, role?: userRoleEnum | null, lastName?: string | null, organization?: { __typename?: 'organization', id: string, name: string } | null }> };

export type SearchCustomersOrCompaniesQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Array<userRoleEnum> | userRoleEnum>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  companyExp?: InputMaybe<UuidComparisonExp>;
}>;


export type SearchCustomersOrCompaniesQuery = { __typename?: 'query_root', organizationUsers: Array<{ __typename?: 'organizationUser', id: string, firstName?: string | null, lastName?: string | null, organizationId?: string | null, emailAddress?: string | null, phoneNumber?: string | null, userId?: string | null, image?: string | null, department?: string | null, position?: string | null, status?: organizationUserStatusEnum | null, role?: userRoleEnum | null, companyId?: string | null, createdByUserId?: string | null, organization?: { __typename?: 'organization', id: string, name: string, ownerId?: string | null } | null }> };

export type GetOrganizationUsersQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<userRoleEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetOrganizationUsersQuery = { __typename?: 'query_root', organizationUsers: Array<{ __typename?: 'organizationUser', id: string, firstName?: string | null, lastName?: string | null, organizationId?: string | null, emailAddress?: string | null, phoneNumber?: string | null, userId?: string | null, role?: userRoleEnum | null, organization?: { __typename?: 'organization', id: string, name: string } | null, user?: { __typename?: 'user', id: string, firstName: string, lastName: string, lastSeen?: string | null, image?: string | null, phoneState?: string | null, updatedAt: string } | null }> };

export type findOrganizatationUserQueryVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type findOrganizatationUserQuery = { __typename?: 'query_root', organizationUser?: { __typename?: 'organizationUser', id: string, firstName?: string | null, lastName?: string | null, role?: userRoleEnum | null, userId?: string | null, phoneNumber?: string | null, emailAddress?: string | null, companyId?: string | null, department?: string | null } | null };

export type findDomainUserQueryVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type findDomainUserQuery = { __typename?: 'query_root', domainUser?: { __typename?: 'domainUser', id: string, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, street?: string | null, zip?: string | null, emailAddress?: string | null, city?: string | null } | null };

export type GetMyPersonalDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetMyPersonalDataQuery = { __typename?: 'query_root', user?: { __typename?: 'user', id: string, firstName: string, lastName: string, organizationUsers: Array<{ __typename?: 'organizationUser', id: string, organizationId?: string | null }>, organizations: Array<{ __typename?: 'organizationOrganizationUserOrganizationsView', id?: string | null, name?: string | null, ownerId?: string | null }> } | null };

export type GetQueueItemsForHomeScreenButtonsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['uuid']['input']>;
  in: Array<ActivityStatusEnum> | ActivityStatusEnum;
  inType?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  includeConvos?: InputMaybe<Scalars['Boolean']['input']>;
  isMine?: InputMaybe<Scalars['Boolean']['input']>;
  meResponsible?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  someoneResponsible?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetQueueItemsForHomeScreenButtonsQuery = { __typename?: 'query_root', queueItems: Array<{ __typename?: 'queueItem', status?: ActivityStatusEnum | null, type?: ActivityTypeEnum | null, flexibilityType?: string | null, subType?: string | null, dueDate?: string | null, createdByUserId?: string | null, private: boolean, id: string, title?: string | null, additionalData?: { [key: string]: any } | null, subTitle?: string | null, createdAt: string, updatedAt: string, alarms: Array<{ __typename?: 'BusinessQueueItemAlarms', absoluteDate?: string | null, alarmSelectionType: BusinessQueueItemAlarmTypeEnum }>, domainUsers: Array<{ __typename?: 'BusinessQueueItemDomainUsersView', id?: string | null, firstName?: string | null, lastName?: string | null, category?: string | null, phoneNumber?: string | null, updatedAt?: string | null, emailAddress?: string | null, organizationUser?: { __typename?: 'organizationUser', id: string, firstName?: string | null, lastName?: string | null, status?: organizationUserStatusEnum | null, organizationId?: string | null } | null }>, queueParticipants: Array<{ __typename?: 'activityParticipant', id: string, responsibility?: QueueItemParticipantResponsibilityTypeEnum | null, responsible?: boolean | null, owner?: boolean | null, contact?: boolean | null, organizationUser?: { __typename?: 'organizationUser', id: string, userId?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, role?: userRoleEnum | null, company?: { __typename?: 'organizationUser', firstName?: string | null, id: string, lastName?: string | null } | null, collaborations: Array<{ __typename?: 'businessQueueItemCollaboration', from: string, private: boolean }> } | null }>, domainActivity?: { __typename?: 'domainActivity', domain?: string | null, id: string, provider?: ActivityProviderEnum | null, direction?: ActivityDirectionEnum | null, startedAt?: string | null, additionalData?: { [key: string]: any } | null, type?: ActivityTypeEnum | null } | null, messages: Array<{ __typename?: 'message', id: string, userId?: string | null, type?: messageTypeEnum | null, content?: string | null, updatedAt: string, user?: { __typename?: 'user', id: string, firstName: string } | null }>, organizationUsers: Array<{ __typename?: 'BusinessQueueItemOrganizationUsersView', id?: string | null, role?: string | null, userId?: string | null, status?: string | null, organizationId?: string | null }> }> };

export type CountTasksQueryVariables = Exact<{
  in: Array<ActivityTypeEnum> | ActivityTypeEnum;
  status: Array<ActivityStatusEnum> | ActivityStatusEnum;
  userId: Scalars['uuid']['input'];
  inType?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  meResponsible?: InputMaybe<Scalars['Boolean']['input']>;
  someoneResponsible?: InputMaybe<Scalars['Boolean']['input']>;
  includeConvos?: InputMaybe<Scalars['Boolean']['input']>;
  inDirection?: InputMaybe<Array<ActivityDirectionEnum> | ActivityDirectionEnum>;
  onlyUnanswered?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CountTasksQuery = { __typename?: 'query_root', queueItemsAggregate: { __typename?: 'queueItemAggregate', aggregate?: { __typename?: 'queueItemAggregateFields', count: number } | null } };

export type GetQueueItemsActivityQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['uuid']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  in: Array<ActivityStatusEnum> | ActivityStatusEnum;
  inType?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  oldTypes?: InputMaybe<Array<ActivityTypeEnum> | ActivityTypeEnum>;
  inDirection?: InputMaybe<Array<ActivityDirectionEnum> | ActivityDirectionEnum>;
  includeConvos?: InputMaybe<Scalars['Boolean']['input']>;
  addDelegated?: InputMaybe<Scalars['Boolean']['input']>;
  meResponsible?: InputMaybe<Scalars['Boolean']['input']>;
  includeOldSchool?: InputMaybe<Scalars['Boolean']['input']>;
  someoneResponsible?: InputMaybe<Scalars['Boolean']['input']>;
  onlyUnanswered?: InputMaybe<Scalars['Boolean']['input']>;
  countUnanswered?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<queueItemOrderBy> | queueItemOrderBy>;
}>;


export type GetQueueItemsActivityQuery = { __typename?: 'query_root', queueItems: Array<{ __typename?: 'queueItem', status?: ActivityStatusEnum | null, type?: ActivityTypeEnum | null, flexibilityType?: string | null, subType?: string | null, dueDate?: string | null, createdByUserId?: string | null, private: boolean, id: string, title?: string | null, additionalData?: { [key: string]: any } | null, subTitle?: string | null, createdAt: string, updatedAt: string, alarms: Array<{ __typename?: 'BusinessQueueItemAlarms', absoluteDate?: string | null, alarmSelectionType: BusinessQueueItemAlarmTypeEnum }>, domainUsers: Array<{ __typename?: 'BusinessQueueItemDomainUsersView', id?: string | null, firstName?: string | null, lastName?: string | null, category?: string | null, phoneNumber?: string | null, updatedAt?: string | null, emailAddress?: string | null, spamScore?: number | null, organizationUser?: { __typename?: 'organizationUser', id: string, firstName?: string | null, lastName?: string | null, status?: organizationUserStatusEnum | null, organizationId?: string | null, userId?: string | null, company?: { __typename?: 'organizationUser', firstName?: string | null, id: string, lastName?: string | null } | null, collaborations: Array<{ __typename?: 'businessQueueItemCollaboration', from: string, private: boolean }> } | null }>, queueParticipants: Array<{ __typename?: 'activityParticipant', id: string, responsibility?: QueueItemParticipantResponsibilityTypeEnum | null, responsible?: boolean | null, owner?: boolean | null, contact?: boolean | null, organizationUser?: { __typename?: 'organizationUser', id: string, userId?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, role?: userRoleEnum | null, company?: { __typename?: 'organizationUser', firstName?: string | null, id: string, lastName?: string | null } | null, collaborations: Array<{ __typename?: 'businessQueueItemCollaboration', from: string, private: boolean }> } | null }>, domainActivity?: { __typename?: 'domainActivity', domain?: string | null, id: string, provider?: ActivityProviderEnum | null, direction?: ActivityDirectionEnum | null, startedAt?: string | null, additionalData?: { [key: string]: any } | null, type?: ActivityTypeEnum | null } | null, messages: Array<{ __typename?: 'message', id: string, userId?: string | null, type?: messageTypeEnum | null, content?: string | null, updatedAt: string, user?: { __typename?: 'user', id: string, firstName: string } | null }>, organizationUsers: Array<{ __typename?: 'BusinessQueueItemOrganizationUsersView', id?: string | null, role?: string | null, userId?: string | null, status?: string | null, organizationId?: string | null, company?: { __typename?: 'organizationUser', firstName?: string | null, id: string, lastName?: string | null } | null }> }> };

export type MyLastMessageQueryVariables = Exact<{
  organizationUserId?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type MyLastMessageQuery = { __typename?: 'query_root', messages: Array<{ __typename?: 'message', id: string, content?: string | null, createdAt: string, updatedAt: string, userId?: string | null, user?: { __typename?: 'user', id: string, firstName: string, phoneState?: string | null, lastName: string } | null, activity?: { __typename?: 'domainActivity', queueItem?: { __typename?: 'queueItem', id: string, createdAt: string, updatedAt: string, type?: ActivityTypeEnum | null, subType?: string | null, flexibilityType?: string | null, title?: string | null, subTitle?: string | null, status?: ActivityStatusEnum | null, owner_organization_user?: { __typename?: 'organizationUser', id: string, firstName?: string | null, lastName?: string | null, role?: userRoleEnum | null, userId?: string | null, phoneNumber?: string | null, user?: { __typename?: 'user', id: string, phoneState?: string | null } | null, organization?: { __typename?: 'organization', id: string } | null, company?: { __typename?: 'organizationUser', id: string, firstName?: string | null } | null } | null, participants: Array<{ __typename?: 'BusinessQueueItemParticipantsView', id?: string | null, phoneNumber?: string | null, firstName?: string | null, lastName?: string | null, role?: string | null }>, domainUsers: Array<{ __typename?: 'BusinessQueueItemDomainUsersView', id?: string | null, phoneNumber?: string | null, firstName?: string | null, lastName?: string | null }>, organizationUsers: Array<{ __typename?: 'BusinessQueueItemOrganizationUsersView', id?: string | null, firstName?: string | null, lastName?: string | null, role?: string | null, userId?: string | null, phoneNumber?: string | null, user?: { __typename?: 'user', id: string, phoneState?: string | null } | null, organization?: { __typename?: 'organization', id: string } | null, company?: { __typename?: 'organizationUser', id: string, firstName?: string | null } | null }>, domainActivity?: { __typename?: 'domainActivity', id: string, domain?: string | null, direction?: ActivityDirectionEnum | null, provider?: ActivityProviderEnum | null, startedAt?: string | null, owner?: { __typename?: 'domainUser', relOrganizationUser: Array<{ __typename?: 'relOrganizationUserDomainUser', organizationUserId: string }> } | null, domainParticipants: Array<{ __typename?: 'domainParticipant', domainUser?: { __typename?: 'domainUser', id: string, phoneNumber?: string | null, firstName?: string | null } | null }> } | null } | null } | null }> };

export type FetchContactQueueItemsQueryVariables = Exact<{
  organizationUserId?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ActivityStatusEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FetchContactQueueItemsQuery = { __typename?: 'query_root', queueItems: Array<{ __typename?: 'queueItem', id: string, createdAt: string, updatedAt: string, type?: ActivityTypeEnum | null, subType?: string | null, flexibilityType?: string | null, title?: string | null, subTitle?: string | null, status?: ActivityStatusEnum | null, owner_organization_user?: { __typename?: 'organizationUser', id: string, firstName?: string | null, lastName?: string | null, role?: userRoleEnum | null, userId?: string | null, phoneNumber?: string | null, user?: { __typename?: 'user', id: string, phoneState?: string | null } | null, organization?: { __typename?: 'organization', id: string } | null, company?: { __typename?: 'organizationUser', id: string, firstName?: string | null } | null } | null, participants: Array<{ __typename?: 'BusinessQueueItemParticipantsView', id?: string | null, phoneNumber?: string | null, firstName?: string | null, lastName?: string | null, role?: string | null }>, domainUsers: Array<{ __typename?: 'BusinessQueueItemDomainUsersView', id?: string | null, phoneNumber?: string | null, firstName?: string | null, lastName?: string | null }>, domainActivity?: { __typename?: 'domainActivity', id: string, domain?: string | null, direction?: ActivityDirectionEnum | null, provider?: ActivityProviderEnum | null, startedAt?: string | null, owner?: { __typename?: 'domainUser', relOrganizationUser: Array<{ __typename?: 'relOrganizationUserDomainUser', organizationUserId: string }> } | null, domainParticipants: Array<{ __typename?: 'domainParticipant', domainUser?: { __typename?: 'domainUser', id: string, phoneNumber?: string | null, firstName?: string | null } | null }> } | null, organizationUsers: Array<{ __typename?: 'BusinessQueueItemOrganizationUsersView', id?: string | null, firstName?: string | null, lastName?: string | null, role?: string | null, userId?: string | null, phoneNumber?: string | null, user?: { __typename?: 'user', id: string, phoneState?: string | null } | null, organization?: { __typename?: 'organization', id: string } | null, company?: { __typename?: 'organizationUser', id: string, firstName?: string | null } | null }>, messages: Array<{ __typename?: 'message', id: string, content?: string | null, createdAt: string, updatedAt: string, userId?: string | null, user?: { __typename?: 'user', id: string, firstName: string, phoneState?: string | null, lastName: string } | null }> }> };

export type FetchContactTaskQueueItemsQueryVariables = Exact<{
  organizationUserId?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ActivityStatusEnum>;
}>;


export type FetchContactTaskQueueItemsQuery = { __typename?: 'query_root', queueItems: Array<{ __typename?: 'queueItem', id: string, createdAt: string, updatedAt: string, type?: ActivityTypeEnum | null, subType?: string | null, flexibilityType?: string | null, title?: string | null, subTitle?: string | null, status?: ActivityStatusEnum | null, owner_organization_user?: { __typename?: 'organizationUser', id: string, firstName?: string | null, lastName?: string | null, role?: userRoleEnum | null, userId?: string | null, phoneNumber?: string | null, user?: { __typename?: 'user', id: string, phoneState?: string | null } | null, organization?: { __typename?: 'organization', id: string } | null, company?: { __typename?: 'organizationUser', id: string, firstName?: string | null } | null } | null, participants: Array<{ __typename?: 'BusinessQueueItemParticipantsView', id?: string | null, phoneNumber?: string | null, firstName?: string | null, lastName?: string | null, role?: string | null }>, domainActivity?: { __typename?: 'domainActivity', id: string, domain?: string | null, direction?: ActivityDirectionEnum | null, provider?: ActivityProviderEnum | null, startedAt?: string | null, owner?: { __typename?: 'domainUser', relOrganizationUser: Array<{ __typename?: 'relOrganizationUserDomainUser', organizationUserId: string }> } | null, domainParticipants: Array<{ __typename?: 'domainParticipant', domainUser?: { __typename?: 'domainUser', id: string, phoneNumber?: string | null, firstName?: string | null } | null }> } | null, organizationUsers: Array<{ __typename?: 'BusinessQueueItemOrganizationUsersView', id?: string | null, firstName?: string | null, lastName?: string | null, role?: string | null, userId?: string | null, phoneNumber?: string | null, user?: { __typename?: 'user', id: string, phoneState?: string | null } | null, organization?: { __typename?: 'organization', id: string } | null, company?: { __typename?: 'organizationUser', id: string, firstName?: string | null } | null }>, messages: Array<{ __typename?: 'message', id: string, content?: string | null, createdAt: string, updatedAt: string, userId?: string | null, user?: { __typename?: 'user', id: string, firstName: string, phoneState?: string | null, lastName: string } | null }> }> };

export type GetAttentionNoteQueryVariables = Exact<{
  organizationUserId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetAttentionNoteQuery = { __typename?: 'query_root', organizationUserAttentionNotes: Array<{ __typename?: 'OrganizationUserAttentionNote', id: string, note: string, createdAt: string, updatedAt: string, creator?: { __typename?: 'organizationUser', id: string, userId?: string | null, firstName?: string | null, lastName?: string | null } | null, subjectUser?: { __typename?: 'organizationUser', id: string, firstName?: string | null, lastName?: string | null } | null }> };

export type GetQueueItemCollaborationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQueueItemCollaborationQuery = { __typename?: 'query_root', businessQueueItemCollaborations: Array<{ __typename?: 'businessQueueItemCollaboration', updatedAt: string, customerUserId: string, id: number }> };

export type ActivitiesSubscriptionVariables = Exact<{
  userId?: InputMaybe<Scalars['uuid']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<ActivityStatusEnum> | ActivityStatusEnum>;
}>;


export type ActivitiesSubscription = { __typename?: 'subscription_root', queueItems: Array<{ __typename?: 'queueItem', id: string, status?: ActivityStatusEnum | null, createdAt: string, updatedAt: string, domainUsers: Array<{ __typename?: 'BusinessQueueItemDomainUsersView', id?: string | null, firstName?: string | null, lastName?: string | null, category?: string | null, phoneNumber?: string | null, emailAddress?: string | null, organizationUser?: { __typename?: 'organizationUser', id: string, firstName?: string | null, lastName?: string | null } | null }>, domainActivity?: { __typename?: 'domainActivity', id: string } | null }> };

export type GetNewActivityQueueItemsSubscriptionVariables = Exact<{
  userId?: InputMaybe<Scalars['uuid']['input']>;
  date: Scalars['timestamptz']['input'];
}>;


export type GetNewActivityQueueItemsSubscription = { __typename?: 'subscription_root', queueItems: Array<{ __typename?: 'queueItem', status?: ActivityStatusEnum | null, type?: ActivityTypeEnum | null, flexibilityType?: string | null, subType?: string | null, dueDate?: string | null, createdByUserId?: string | null, private: boolean, id: string, title?: string | null, additionalData?: { [key: string]: any } | null, subTitle?: string | null, createdAt: string, updatedAt: string, alarms: Array<{ __typename?: 'BusinessQueueItemAlarms', absoluteDate?: string | null, alarmSelectionType: BusinessQueueItemAlarmTypeEnum }>, domainUsers: Array<{ __typename?: 'BusinessQueueItemDomainUsersView', id?: string | null, firstName?: string | null, lastName?: string | null, category?: string | null, phoneNumber?: string | null, updatedAt?: string | null, emailAddress?: string | null, organizationUser?: { __typename?: 'organizationUser', id: string, firstName?: string | null, lastName?: string | null, status?: organizationUserStatusEnum | null, organizationId?: string | null } | null }>, queueParticipants: Array<{ __typename?: 'activityParticipant', id: string, responsibility?: QueueItemParticipantResponsibilityTypeEnum | null, responsible?: boolean | null, owner?: boolean | null, contact?: boolean | null, organizationUser?: { __typename?: 'organizationUser', id: string, userId?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, role?: userRoleEnum | null, company?: { __typename?: 'organizationUser', firstName?: string | null, id: string, lastName?: string | null } | null, collaborations: Array<{ __typename?: 'businessQueueItemCollaboration', from: string, private: boolean }> } | null }>, domainActivity?: { __typename?: 'domainActivity', domain?: string | null, id: string, provider?: ActivityProviderEnum | null, direction?: ActivityDirectionEnum | null, startedAt?: string | null, additionalData?: { [key: string]: any } | null, type?: ActivityTypeEnum | null } | null, messages: Array<{ __typename?: 'message', id: string, userId?: string | null, type?: messageTypeEnum | null, content?: string | null, updatedAt: string, user?: { __typename?: 'user', id: string, firstName: string } | null }>, organizationUsers: Array<{ __typename?: 'BusinessQueueItemOrganizationUsersView', id?: string | null, role?: string | null, userId?: string | null, status?: string | null, organizationId?: string | null }> }> };


export const CreateQueueItemParticipantDocument = gql`
    mutation CreateQueueItemParticipant($id: uuid = "", $organizationUserId: uuid = "", $queueItemId: uuid = "", $responsible: Boolean = false, $responsibility: QueueItemParticipantResponsibilityTypeEnum, $channel: BusinessQueueItemParticipantChannelTypeEnum = PHONENUMBER, $contact: Boolean = false) {
  createActivityParticipant(
    object: {id: $id, organizationUserId: $organizationUserId, queueItemId: $queueItemId, responsible: $responsible, responsibility: $responsibility, channel: $channel, contact: $contact}
  ) {
    id
    queueItemId
    organizationUserId
    responsible
    channel
    contact
  }
}
    `;
export type CreateQueueItemParticipantMutationFn = Apollo.MutationFunction<CreateQueueItemParticipantMutation, CreateQueueItemParticipantMutationVariables>;

/**
 * __useCreateQueueItemParticipantMutation__
 *
 * To run a mutation, you first call `useCreateQueueItemParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQueueItemParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQueueItemParticipantMutation, { data, loading, error }] = useCreateQueueItemParticipantMutation({
 *   variables: {
 *      id: // value for 'id'
 *      organizationUserId: // value for 'organizationUserId'
 *      queueItemId: // value for 'queueItemId'
 *      responsible: // value for 'responsible'
 *      responsibility: // value for 'responsibility'
 *      channel: // value for 'channel'
 *      contact: // value for 'contact'
 *   },
 * });
 */
export function useCreateQueueItemParticipantMutation(baseOptions?: Apollo.MutationHookOptions<CreateQueueItemParticipantMutation, CreateQueueItemParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQueueItemParticipantMutation, CreateQueueItemParticipantMutationVariables>(CreateQueueItemParticipantDocument, options);
      }
export type CreateQueueItemParticipantMutationHookResult = ReturnType<typeof useCreateQueueItemParticipantMutation>;
export type CreateQueueItemParticipantMutationResult = Apollo.MutationResult<CreateQueueItemParticipantMutation>;
export type CreateQueueItemParticipantMutationOptions = Apollo.BaseMutationOptions<CreateQueueItemParticipantMutation, CreateQueueItemParticipantMutationVariables>;
export const SetActivityStatusDoneDocument = gql`
    mutation SetActivityStatusDone($id: uuid = "", $status: ActivityStatusEnum = DONE) {
  updateQueueItem(pkColumns: {id: $id}, _set: {status: $status}) {
    id
  }
}
    `;
export type SetActivityStatusDoneMutationFn = Apollo.MutationFunction<SetActivityStatusDoneMutation, SetActivityStatusDoneMutationVariables>;

/**
 * __useSetActivityStatusDoneMutation__
 *
 * To run a mutation, you first call `useSetActivityStatusDoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetActivityStatusDoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setActivityStatusDoneMutation, { data, loading, error }] = useSetActivityStatusDoneMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetActivityStatusDoneMutation(baseOptions?: Apollo.MutationHookOptions<SetActivityStatusDoneMutation, SetActivityStatusDoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetActivityStatusDoneMutation, SetActivityStatusDoneMutationVariables>(SetActivityStatusDoneDocument, options);
      }
export type SetActivityStatusDoneMutationHookResult = ReturnType<typeof useSetActivityStatusDoneMutation>;
export type SetActivityStatusDoneMutationResult = Apollo.MutationResult<SetActivityStatusDoneMutation>;
export type SetActivityStatusDoneMutationOptions = Apollo.BaseMutationOptions<SetActivityStatusDoneMutation, SetActivityStatusDoneMutationVariables>;
export const SetActivityStatusUndoneDocument = gql`
    mutation SetActivityStatusUndone($userId: uuid = "", $status: ActivityStatusEnum = ASSIGNED) {
  updateQueueItems(
    where: {status: {_in: [ASSIGNED, DONE]}, createdByUserId: {_eq: $userId}, additionalData: {_cast: {String: {_regex: "SETTINGS_REMINDER"}}}}
    _set: {status: $status}
  ) {
    affectedRows
  }
}
    `;
export type SetActivityStatusUndoneMutationFn = Apollo.MutationFunction<SetActivityStatusUndoneMutation, SetActivityStatusUndoneMutationVariables>;

/**
 * __useSetActivityStatusUndoneMutation__
 *
 * To run a mutation, you first call `useSetActivityStatusUndoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetActivityStatusUndoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setActivityStatusUndoneMutation, { data, loading, error }] = useSetActivityStatusUndoneMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetActivityStatusUndoneMutation(baseOptions?: Apollo.MutationHookOptions<SetActivityStatusUndoneMutation, SetActivityStatusUndoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetActivityStatusUndoneMutation, SetActivityStatusUndoneMutationVariables>(SetActivityStatusUndoneDocument, options);
      }
export type SetActivityStatusUndoneMutationHookResult = ReturnType<typeof useSetActivityStatusUndoneMutation>;
export type SetActivityStatusUndoneMutationResult = Apollo.MutationResult<SetActivityStatusUndoneMutation>;
export type SetActivityStatusUndoneMutationOptions = Apollo.BaseMutationOptions<SetActivityStatusUndoneMutation, SetActivityStatusUndoneMutationVariables>;
export const UpdateAlarmDocument = gql`
    mutation UpdateAlarm($id: uuid = "", $absoluteDate: timestamptz = "") {
  updateBusinessQueueItemAlarmsByPk(
    pkColumns: {id: $id}
    _set: {absoluteDate: $absoluteDate}
  ) {
    id
    absoluteDate
  }
}
    `;
export type UpdateAlarmMutationFn = Apollo.MutationFunction<UpdateAlarmMutation, UpdateAlarmMutationVariables>;

/**
 * __useUpdateAlarmMutation__
 *
 * To run a mutation, you first call `useUpdateAlarmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlarmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAlarmMutation, { data, loading, error }] = useUpdateAlarmMutation({
 *   variables: {
 *      id: // value for 'id'
 *      absoluteDate: // value for 'absoluteDate'
 *   },
 * });
 */
export function useUpdateAlarmMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAlarmMutation, UpdateAlarmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAlarmMutation, UpdateAlarmMutationVariables>(UpdateAlarmDocument, options);
      }
export type UpdateAlarmMutationHookResult = ReturnType<typeof useUpdateAlarmMutation>;
export type UpdateAlarmMutationResult = Apollo.MutationResult<UpdateAlarmMutation>;
export type UpdateAlarmMutationOptions = Apollo.BaseMutationOptions<UpdateAlarmMutation, UpdateAlarmMutationVariables>;
export const UpdateParticipantChannelDocument = gql`
    mutation UpdateParticipantChannel($id: uuid = "", $channel: BusinessQueueItemParticipantChannelTypeEnum = PHONENUMBER) {
  updateActivityParticipant(pkColumns: {id: $id}, _set: {channel: $channel}) {
    id
    channel
  }
}
    `;
export type UpdateParticipantChannelMutationFn = Apollo.MutationFunction<UpdateParticipantChannelMutation, UpdateParticipantChannelMutationVariables>;

/**
 * __useUpdateParticipantChannelMutation__
 *
 * To run a mutation, you first call `useUpdateParticipantChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateParticipantChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateParticipantChannelMutation, { data, loading, error }] = useUpdateParticipantChannelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useUpdateParticipantChannelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateParticipantChannelMutation, UpdateParticipantChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateParticipantChannelMutation, UpdateParticipantChannelMutationVariables>(UpdateParticipantChannelDocument, options);
      }
export type UpdateParticipantChannelMutationHookResult = ReturnType<typeof useUpdateParticipantChannelMutation>;
export type UpdateParticipantChannelMutationResult = Apollo.MutationResult<UpdateParticipantChannelMutation>;
export type UpdateParticipantChannelMutationOptions = Apollo.BaseMutationOptions<UpdateParticipantChannelMutation, UpdateParticipantChannelMutationVariables>;
export const UpdateQueueItemDueDateDocument = gql`
    mutation UpdateQueueItemDueDate($id: uuid = "", $dueDate: timestamptz = "") {
  updateQueueItem(pkColumns: {id: $id}, _set: {dueDate: $dueDate}) {
    id
    dueDate
  }
}
    `;
export type UpdateQueueItemDueDateMutationFn = Apollo.MutationFunction<UpdateQueueItemDueDateMutation, UpdateQueueItemDueDateMutationVariables>;

/**
 * __useUpdateQueueItemDueDateMutation__
 *
 * To run a mutation, you first call `useUpdateQueueItemDueDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQueueItemDueDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQueueItemDueDateMutation, { data, loading, error }] = useUpdateQueueItemDueDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      dueDate: // value for 'dueDate'
 *   },
 * });
 */
export function useUpdateQueueItemDueDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQueueItemDueDateMutation, UpdateQueueItemDueDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQueueItemDueDateMutation, UpdateQueueItemDueDateMutationVariables>(UpdateQueueItemDueDateDocument, options);
      }
export type UpdateQueueItemDueDateMutationHookResult = ReturnType<typeof useUpdateQueueItemDueDateMutation>;
export type UpdateQueueItemDueDateMutationResult = Apollo.MutationResult<UpdateQueueItemDueDateMutation>;
export type UpdateQueueItemDueDateMutationOptions = Apollo.BaseMutationOptions<UpdateQueueItemDueDateMutation, UpdateQueueItemDueDateMutationVariables>;
export const UpdateQueueItemStartDateDocument = gql`
    mutation UpdateQueueItemStartDate($id: uuid = "", $startDate: timestamptz = "") {
  updateQueueItem(pkColumns: {id: $id}, _set: {startDate: $startDate}) {
    id
    startDate
  }
}
    `;
export type UpdateQueueItemStartDateMutationFn = Apollo.MutationFunction<UpdateQueueItemStartDateMutation, UpdateQueueItemStartDateMutationVariables>;

/**
 * __useUpdateQueueItemStartDateMutation__
 *
 * To run a mutation, you first call `useUpdateQueueItemStartDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQueueItemStartDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQueueItemStartDateMutation, { data, loading, error }] = useUpdateQueueItemStartDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useUpdateQueueItemStartDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQueueItemStartDateMutation, UpdateQueueItemStartDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQueueItemStartDateMutation, UpdateQueueItemStartDateMutationVariables>(UpdateQueueItemStartDateDocument, options);
      }
export type UpdateQueueItemStartDateMutationHookResult = ReturnType<typeof useUpdateQueueItemStartDateMutation>;
export type UpdateQueueItemStartDateMutationResult = Apollo.MutationResult<UpdateQueueItemStartDateMutation>;
export type UpdateQueueItemStartDateMutationOptions = Apollo.BaseMutationOptions<UpdateQueueItemStartDateMutation, UpdateQueueItemStartDateMutationVariables>;
export const UpdateTitleSubtitleDocument = gql`
    mutation UpdateTitleSubtitle($id: uuid = "", $title: String = "", $subTitle: String = "", $flexibilityType: String = "", $dueDate: timestamptz = "") {
  updateQueueItem(
    pkColumns: {id: $id}
    _set: {title: $title, subTitle: $subTitle, flexibilityType: $flexibilityType, dueDate: $dueDate}
  ) {
    id
    title
    subTitle
    dueDate
    flexibilityType
  }
}
    `;
export type UpdateTitleSubtitleMutationFn = Apollo.MutationFunction<UpdateTitleSubtitleMutation, UpdateTitleSubtitleMutationVariables>;

/**
 * __useUpdateTitleSubtitleMutation__
 *
 * To run a mutation, you first call `useUpdateTitleSubtitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTitleSubtitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTitleSubtitleMutation, { data, loading, error }] = useUpdateTitleSubtitleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      subTitle: // value for 'subTitle'
 *      flexibilityType: // value for 'flexibilityType'
 *      dueDate: // value for 'dueDate'
 *   },
 * });
 */
export function useUpdateTitleSubtitleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTitleSubtitleMutation, UpdateTitleSubtitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTitleSubtitleMutation, UpdateTitleSubtitleMutationVariables>(UpdateTitleSubtitleDocument, options);
      }
export type UpdateTitleSubtitleMutationHookResult = ReturnType<typeof useUpdateTitleSubtitleMutation>;
export type UpdateTitleSubtitleMutationResult = Apollo.MutationResult<UpdateTitleSubtitleMutation>;
export type UpdateTitleSubtitleMutationOptions = Apollo.BaseMutationOptions<UpdateTitleSubtitleMutation, UpdateTitleSubtitleMutationVariables>;
export const DeleteQueueItemParticipantDocument = gql`
    mutation DeleteQueueItemParticipant($id: uuid = "") {
  deleteActivityParticipant(id: $id) {
    id
  }
}
    `;
export type DeleteQueueItemParticipantMutationFn = Apollo.MutationFunction<DeleteQueueItemParticipantMutation, DeleteQueueItemParticipantMutationVariables>;

/**
 * __useDeleteQueueItemParticipantMutation__
 *
 * To run a mutation, you first call `useDeleteQueueItemParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQueueItemParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQueueItemParticipantMutation, { data, loading, error }] = useDeleteQueueItemParticipantMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteQueueItemParticipantMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQueueItemParticipantMutation, DeleteQueueItemParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQueueItemParticipantMutation, DeleteQueueItemParticipantMutationVariables>(DeleteQueueItemParticipantDocument, options);
      }
export type DeleteQueueItemParticipantMutationHookResult = ReturnType<typeof useDeleteQueueItemParticipantMutation>;
export type DeleteQueueItemParticipantMutationResult = Apollo.MutationResult<DeleteQueueItemParticipantMutation>;
export type DeleteQueueItemParticipantMutationOptions = Apollo.BaseMutationOptions<DeleteQueueItemParticipantMutation, DeleteQueueItemParticipantMutationVariables>;
export const CreateQueueItemDocument = gql`
    mutation CreateQueueItem($id: uuid = "", $status: ActivityStatusEnum = ASSIGNED, $subTitle: String = "", $title: String = "", $queueParticipants: activityParticipantArrRelInsertInput, $private: Boolean = false, $alarms: [BusinessQueueItemAlarmsInsertInput!] = {}, $dueDate: timestamptz = "", $location: String = "", $startDate: timestamptz = "", $type: ActivityTypeEnum = ACTION, $organizationId: uuid = "", $additionalData: jsonb = "", $ownerOrganizationUserId: uuid = "", $subType: String = "", $flexibilityType: String = "") {
  createQueueItem(
    object: {id: $id, status: $status, title: $title, subTitle: $subTitle, queueParticipants: $queueParticipants, private: $private, alarms: {data: $alarms}, dueDate: $dueDate, location: $location, startDate: $startDate, type: $type, organizationId: $organizationId, additionalData: $additionalData, ownerOrganizationUserId: $ownerOrganizationUserId, subType: $subType, flexibilityType: $flexibilityType}
  ) {
    id
    title
    subTitle
    status
    queueParticipants {
      id
      organizationUserId
      responsibility
      owner
      channel
    }
  }
}
    `;
export type CreateQueueItemMutationFn = Apollo.MutationFunction<CreateQueueItemMutation, CreateQueueItemMutationVariables>;

/**
 * __useCreateQueueItemMutation__
 *
 * To run a mutation, you first call `useCreateQueueItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQueueItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQueueItemMutation, { data, loading, error }] = useCreateQueueItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      subTitle: // value for 'subTitle'
 *      title: // value for 'title'
 *      queueParticipants: // value for 'queueParticipants'
 *      private: // value for 'private'
 *      alarms: // value for 'alarms'
 *      dueDate: // value for 'dueDate'
 *      location: // value for 'location'
 *      startDate: // value for 'startDate'
 *      type: // value for 'type'
 *      organizationId: // value for 'organizationId'
 *      additionalData: // value for 'additionalData'
 *      ownerOrganizationUserId: // value for 'ownerOrganizationUserId'
 *      subType: // value for 'subType'
 *      flexibilityType: // value for 'flexibilityType'
 *   },
 * });
 */
export function useCreateQueueItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateQueueItemMutation, CreateQueueItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQueueItemMutation, CreateQueueItemMutationVariables>(CreateQueueItemDocument, options);
      }
export type CreateQueueItemMutationHookResult = ReturnType<typeof useCreateQueueItemMutation>;
export type CreateQueueItemMutationResult = Apollo.MutationResult<CreateQueueItemMutation>;
export type CreateQueueItemMutationOptions = Apollo.BaseMutationOptions<CreateQueueItemMutation, CreateQueueItemMutationVariables>;
export const UpsertAlarmDocument = gql`
    mutation UpsertAlarm($id: uuid = "", $absoluteDate: timestamptz = "", $organizationUserId: uuid = "", $queueItemId: uuid = "") {
  insertBusinessQueueItemAlarmsOne(
    object: {id: $id, alarmSelectionType: REMINDER, absoluteDate: $absoluteDate, organizationUserId: $organizationUserId, queueItemId: $queueItemId}
    onConflict: {constraint: queue_item_alarms_alarmSelectionType_queueItemId_organizationUs, updateColumns: absoluteDate}
  ) {
    id
  }
}
    `;
export type UpsertAlarmMutationFn = Apollo.MutationFunction<UpsertAlarmMutation, UpsertAlarmMutationVariables>;

/**
 * __useUpsertAlarmMutation__
 *
 * To run a mutation, you first call `useUpsertAlarmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAlarmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAlarmMutation, { data, loading, error }] = useUpsertAlarmMutation({
 *   variables: {
 *      id: // value for 'id'
 *      absoluteDate: // value for 'absoluteDate'
 *      organizationUserId: // value for 'organizationUserId'
 *      queueItemId: // value for 'queueItemId'
 *   },
 * });
 */
export function useUpsertAlarmMutation(baseOptions?: Apollo.MutationHookOptions<UpsertAlarmMutation, UpsertAlarmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertAlarmMutation, UpsertAlarmMutationVariables>(UpsertAlarmDocument, options);
      }
export type UpsertAlarmMutationHookResult = ReturnType<typeof useUpsertAlarmMutation>;
export type UpsertAlarmMutationResult = Apollo.MutationResult<UpsertAlarmMutation>;
export type UpsertAlarmMutationOptions = Apollo.BaseMutationOptions<UpsertAlarmMutation, UpsertAlarmMutationVariables>;
export const CreateIntegrationOrderDocument = gql`
    mutation CreateIntegrationOrder($userId: uuid!, $type: OrdersTypeEnum!, $termsversion: String = "", $terms: String = "", $organizationId: uuid = "", $authLevel: String = "", $firstName: String = "", $lastName: String = "", $organizationName: String = "", $phoneNumber: String = "", $organizationNumber: String = "", $licenses: Int, $deliveryDate: timestamptz, $price: String = "") {
  createOrdersIntegrations(
    objects: {userId: $userId, organizationId: $organizationId, terms: $terms, termsversion: $termsversion, type: $type, authLevel: $authLevel, firstName: $firstName, lastName: $lastName, organizationName: $organizationName, phoneNumber: $phoneNumber, organizationNumber: $organizationNumber, request: TELEPHONY, licenses: $licenses, deliveryDate: $deliveryDate, price: $price}
  ) {
    affectedRows
    returning {
      id
    }
  }
}
    `;
export type CreateIntegrationOrderMutationFn = Apollo.MutationFunction<CreateIntegrationOrderMutation, CreateIntegrationOrderMutationVariables>;

/**
 * __useCreateIntegrationOrderMutation__
 *
 * To run a mutation, you first call `useCreateIntegrationOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIntegrationOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIntegrationOrderMutation, { data, loading, error }] = useCreateIntegrationOrderMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      type: // value for 'type'
 *      termsversion: // value for 'termsversion'
 *      terms: // value for 'terms'
 *      organizationId: // value for 'organizationId'
 *      authLevel: // value for 'authLevel'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      organizationName: // value for 'organizationName'
 *      phoneNumber: // value for 'phoneNumber'
 *      organizationNumber: // value for 'organizationNumber'
 *      licenses: // value for 'licenses'
 *      deliveryDate: // value for 'deliveryDate'
 *      price: // value for 'price'
 *   },
 * });
 */
export function useCreateIntegrationOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateIntegrationOrderMutation, CreateIntegrationOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIntegrationOrderMutation, CreateIntegrationOrderMutationVariables>(CreateIntegrationOrderDocument, options);
      }
export type CreateIntegrationOrderMutationHookResult = ReturnType<typeof useCreateIntegrationOrderMutation>;
export type CreateIntegrationOrderMutationResult = Apollo.MutationResult<CreateIntegrationOrderMutation>;
export type CreateIntegrationOrderMutationOptions = Apollo.BaseMutationOptions<CreateIntegrationOrderMutation, CreateIntegrationOrderMutationVariables>;
export const UpdateOrderDocument = gql`
    mutation UpdateOrder($id: uuid = "", $active: Boolean = false) {
  updateOrdersIntegration(pkColumns: {id: $id}, _set: {active: $active}) {
    active
    id
  }
}
    `;
export type UpdateOrderMutationFn = Apollo.MutationFunction<UpdateOrderMutation, UpdateOrderMutationVariables>;

/**
 * __useUpdateOrderMutation__
 *
 * To run a mutation, you first call `useUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutation, { data, loading, error }] = useUpdateOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useUpdateOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderMutation, UpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderMutation, UpdateOrderMutationVariables>(UpdateOrderDocument, options);
      }
export type UpdateOrderMutationHookResult = ReturnType<typeof useUpdateOrderMutation>;
export type UpdateOrderMutationResult = Apollo.MutationResult<UpdateOrderMutation>;
export type UpdateOrderMutationOptions = Apollo.BaseMutationOptions<UpdateOrderMutation, UpdateOrderMutationVariables>;
export const DeleteOrderDocument = gql`
    mutation DeleteOrder($id: uuid = "") {
  deleteOrdersIntegration(id: $id) {
    id
  }
}
    `;
export type DeleteOrderMutationFn = Apollo.MutationFunction<DeleteOrderMutation, DeleteOrderMutationVariables>;

/**
 * __useDeleteOrderMutation__
 *
 * To run a mutation, you first call `useDeleteOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderMutation, { data, loading, error }] = useDeleteOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrderMutation, DeleteOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrderMutation, DeleteOrderMutationVariables>(DeleteOrderDocument, options);
      }
export type DeleteOrderMutationHookResult = ReturnType<typeof useDeleteOrderMutation>;
export type DeleteOrderMutationResult = Apollo.MutationResult<DeleteOrderMutation>;
export type DeleteOrderMutationOptions = Apollo.BaseMutationOptions<DeleteOrderMutation, DeleteOrderMutationVariables>;
export const UpdateNoteDocument = gql`
    mutation UpdateNote($note: String = "", $id: uuid = "", $createdByUser: uuid = "", $createdOnUser: uuid = "") {
  createOrganizationUserAttentionNote(
    object: {id: $id, note: $note, createdByUser: $createdByUser, createdOnUser: $createdOnUser}
    onConflict: {constraint: organization_user_attention_note_pkey, updateColumns: [note]}
  ) {
    id
  }
}
    `;
export type UpdateNoteMutationFn = Apollo.MutationFunction<UpdateNoteMutation, UpdateNoteMutationVariables>;

/**
 * __useUpdateNoteMutation__
 *
 * To run a mutation, you first call `useUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteMutation, { data, loading, error }] = useUpdateNoteMutation({
 *   variables: {
 *      note: // value for 'note'
 *      id: // value for 'id'
 *      createdByUser: // value for 'createdByUser'
 *      createdOnUser: // value for 'createdOnUser'
 *   },
 * });
 */
export function useUpdateNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNoteMutation, UpdateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNoteMutation, UpdateNoteMutationVariables>(UpdateNoteDocument, options);
      }
export type UpdateNoteMutationHookResult = ReturnType<typeof useUpdateNoteMutation>;
export type UpdateNoteMutationResult = Apollo.MutationResult<UpdateNoteMutation>;
export type UpdateNoteMutationOptions = Apollo.BaseMutationOptions<UpdateNoteMutation, UpdateNoteMutationVariables>;
export const GetTaskDocument = gql`
    query GetTask($id: uuid = "") {
  queueItem(id: $id) {
    id
    dueDate
    startDate
    title
    subTitle
    additionalData
    status
    type
    updatedAt
    createdAt
    location
    flexibilityType
    alarms {
      id
      organizationUserId
      alarmSelectionType
      absoluteDate
    }
    queueParticipants {
      id
      responsibility
      organizationUserId
      responsible
      contact
      channel
      owner
      organizationUser {
        id
        firstName
        lastName
        userId
        phoneNumber
      }
    }
  }
}
    `;

/**
 * __useGetTaskQuery__
 *
 * To run a query within a React component, call `useGetTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskQuery(baseOptions?: Apollo.QueryHookOptions<GetTaskQuery, GetTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
      }
export function useGetTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskQuery, GetTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
        }
export function useGetTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskQuery, GetTaskQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
        }
export type GetTaskQueryHookResult = ReturnType<typeof useGetTaskQuery>;
export type GetTaskLazyQueryHookResult = ReturnType<typeof useGetTaskLazyQuery>;
export type GetTaskSuspenseQueryHookResult = ReturnType<typeof useGetTaskSuspenseQuery>;
export type GetTaskQueryResult = Apollo.QueryResult<GetTaskQuery, GetTaskQueryVariables>;
export const GetOrganizationUserDocument = gql`
    query GetOrganizationUser($userId: uuid = "") {
  organizationUsers(where: {userId: {_eq: $userId}}) {
    id
  }
}
    `;

/**
 * __useGetOrganizationUserQuery__
 *
 * To run a query within a React component, call `useGetOrganizationUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetOrganizationUserQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationUserQuery, GetOrganizationUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationUserQuery, GetOrganizationUserQueryVariables>(GetOrganizationUserDocument, options);
      }
export function useGetOrganizationUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationUserQuery, GetOrganizationUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationUserQuery, GetOrganizationUserQueryVariables>(GetOrganizationUserDocument, options);
        }
export function useGetOrganizationUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationUserQuery, GetOrganizationUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationUserQuery, GetOrganizationUserQueryVariables>(GetOrganizationUserDocument, options);
        }
export type GetOrganizationUserQueryHookResult = ReturnType<typeof useGetOrganizationUserQuery>;
export type GetOrganizationUserLazyQueryHookResult = ReturnType<typeof useGetOrganizationUserLazyQuery>;
export type GetOrganizationUserSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationUserSuspenseQuery>;
export type GetOrganizationUserQueryResult = Apollo.QueryResult<GetOrganizationUserQuery, GetOrganizationUserQueryVariables>;
export const GetTaskUserDocument = gql`
    query GetTaskUser($id: uuid = "") {
  organizationUsers(where: {userId: {_eq: $id}}) {
    id
    userId
    firstName
    phoneNumber
    emailAddress
    role
    lastName
    organization {
      id
      name
    }
  }
}
    `;

/**
 * __useGetTaskUserQuery__
 *
 * To run a query within a React component, call `useGetTaskUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskUserQuery(baseOptions?: Apollo.QueryHookOptions<GetTaskUserQuery, GetTaskUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskUserQuery, GetTaskUserQueryVariables>(GetTaskUserDocument, options);
      }
export function useGetTaskUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskUserQuery, GetTaskUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskUserQuery, GetTaskUserQueryVariables>(GetTaskUserDocument, options);
        }
export function useGetTaskUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskUserQuery, GetTaskUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskUserQuery, GetTaskUserQueryVariables>(GetTaskUserDocument, options);
        }
export type GetTaskUserQueryHookResult = ReturnType<typeof useGetTaskUserQuery>;
export type GetTaskUserLazyQueryHookResult = ReturnType<typeof useGetTaskUserLazyQuery>;
export type GetTaskUserSuspenseQueryHookResult = ReturnType<typeof useGetTaskUserSuspenseQuery>;
export type GetTaskUserQueryResult = Apollo.QueryResult<GetTaskUserQuery, GetTaskUserQueryVariables>;
export const SearchCustomersOrCompaniesDocument = gql`
    query SearchCustomersOrCompanies($searchTerm: String = "", $role: [userRoleEnum!], $offset: Int, $limit: Int, $companyExp: UuidComparisonExp = {}) {
  organizationUsers(
    where: {_or: [{firstName: {_iregex: $searchTerm}}, {lastName: {_iregex: $searchTerm}}], status: {_nin: [SCHEDULED_FOR_DELETION, REMOVED]}, role: {_in: $role}, companyId: $companyExp}
    offset: $offset
    limit: $limit
    orderBy: {firstName: ASC_NULLS_FIRST, id: ASC}
  ) {
    id
    firstName
    lastName
    organizationId
    emailAddress
    phoneNumber
    userId
    image
    department
    position
    status
    role
    companyId
    createdByUserId
    organization {
      id
      name
      ownerId
    }
  }
}
    `;

/**
 * __useSearchCustomersOrCompaniesQuery__
 *
 * To run a query within a React component, call `useSearchCustomersOrCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCustomersOrCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCustomersOrCompaniesQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      role: // value for 'role'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      companyExp: // value for 'companyExp'
 *   },
 * });
 */
export function useSearchCustomersOrCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<SearchCustomersOrCompaniesQuery, SearchCustomersOrCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCustomersOrCompaniesQuery, SearchCustomersOrCompaniesQueryVariables>(SearchCustomersOrCompaniesDocument, options);
      }
export function useSearchCustomersOrCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCustomersOrCompaniesQuery, SearchCustomersOrCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCustomersOrCompaniesQuery, SearchCustomersOrCompaniesQueryVariables>(SearchCustomersOrCompaniesDocument, options);
        }
export function useSearchCustomersOrCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCustomersOrCompaniesQuery, SearchCustomersOrCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchCustomersOrCompaniesQuery, SearchCustomersOrCompaniesQueryVariables>(SearchCustomersOrCompaniesDocument, options);
        }
export type SearchCustomersOrCompaniesQueryHookResult = ReturnType<typeof useSearchCustomersOrCompaniesQuery>;
export type SearchCustomersOrCompaniesLazyQueryHookResult = ReturnType<typeof useSearchCustomersOrCompaniesLazyQuery>;
export type SearchCustomersOrCompaniesSuspenseQueryHookResult = ReturnType<typeof useSearchCustomersOrCompaniesSuspenseQuery>;
export type SearchCustomersOrCompaniesQueryResult = Apollo.QueryResult<SearchCustomersOrCompaniesQuery, SearchCustomersOrCompaniesQueryVariables>;
export const GetOrganizationUsersDocument = gql`
    query GetOrganizationUsers($searchTerm: String = "", $role: userRoleEnum = CUSTOMER, $limit: Int, $offset: Int) {
  organizationUsers(
    where: {_or: [{firstName: {_iregex: $searchTerm}}, {lastName: {_iregex: $searchTerm}}, {phoneNumber: {_iregex: $searchTerm}}], _and: {role: {_eq: $role}, status: {_neq: SCHEDULED_FOR_DELETION}}}
    orderBy: {lastName: ASC, firstName: ASC}
    limit: $limit
    offset: $offset
  ) {
    id
    firstName
    lastName
    organizationId
    emailAddress
    phoneNumber
    userId
    role
    organization {
      id
      name
    }
    user {
      id
      firstName
      lastName
      lastSeen
      image
      phoneState
      updatedAt
    }
  }
}
    `;

/**
 * __useGetOrganizationUsersQuery__
 *
 * To run a query within a React component, call `useGetOrganizationUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationUsersQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      role: // value for 'role'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetOrganizationUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>(GetOrganizationUsersDocument, options);
      }
export function useGetOrganizationUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>(GetOrganizationUsersDocument, options);
        }
export function useGetOrganizationUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>(GetOrganizationUsersDocument, options);
        }
export type GetOrganizationUsersQueryHookResult = ReturnType<typeof useGetOrganizationUsersQuery>;
export type GetOrganizationUsersLazyQueryHookResult = ReturnType<typeof useGetOrganizationUsersLazyQuery>;
export type GetOrganizationUsersSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationUsersSuspenseQuery>;
export type GetOrganizationUsersQueryResult = Apollo.QueryResult<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>;
export const findOrganizatationUserDocument = gql`
    query findOrganizatationUser($id: uuid = "") {
  organizationUser(id: $id) {
    id
    firstName
    lastName
    role
    userId
    phoneNumber
    emailAddress
    companyId
    department
  }
}
    `;

/**
 * __usefindOrganizatationUserQuery__
 *
 * To run a query within a React component, call `usefindOrganizatationUserQuery` and pass it any options that fit your needs.
 * When your component renders, `usefindOrganizatationUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usefindOrganizatationUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usefindOrganizatationUserQuery(baseOptions?: Apollo.QueryHookOptions<findOrganizatationUserQuery, findOrganizatationUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<findOrganizatationUserQuery, findOrganizatationUserQueryVariables>(findOrganizatationUserDocument, options);
      }
export function usefindOrganizatationUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<findOrganizatationUserQuery, findOrganizatationUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<findOrganizatationUserQuery, findOrganizatationUserQueryVariables>(findOrganizatationUserDocument, options);
        }
export function usefindOrganizatationUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<findOrganizatationUserQuery, findOrganizatationUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<findOrganizatationUserQuery, findOrganizatationUserQueryVariables>(findOrganizatationUserDocument, options);
        }
export type findOrganizatationUserQueryHookResult = ReturnType<typeof usefindOrganizatationUserQuery>;
export type findOrganizatationUserLazyQueryHookResult = ReturnType<typeof usefindOrganizatationUserLazyQuery>;
export type findOrganizatationUserSuspenseQueryHookResult = ReturnType<typeof usefindOrganizatationUserSuspenseQuery>;
export type findOrganizatationUserQueryResult = Apollo.QueryResult<findOrganizatationUserQuery, findOrganizatationUserQueryVariables>;
export const findDomainUserDocument = gql`
    query findDomainUser($id: uuid = "") {
  domainUser(id: $id) {
    id
    firstName
    lastName
    phoneNumber
    street
    zip
    emailAddress
    city
  }
}
    `;

/**
 * __usefindDomainUserQuery__
 *
 * To run a query within a React component, call `usefindDomainUserQuery` and pass it any options that fit your needs.
 * When your component renders, `usefindDomainUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usefindDomainUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usefindDomainUserQuery(baseOptions?: Apollo.QueryHookOptions<findDomainUserQuery, findDomainUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<findDomainUserQuery, findDomainUserQueryVariables>(findDomainUserDocument, options);
      }
export function usefindDomainUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<findDomainUserQuery, findDomainUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<findDomainUserQuery, findDomainUserQueryVariables>(findDomainUserDocument, options);
        }
export function usefindDomainUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<findDomainUserQuery, findDomainUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<findDomainUserQuery, findDomainUserQueryVariables>(findDomainUserDocument, options);
        }
export type findDomainUserQueryHookResult = ReturnType<typeof usefindDomainUserQuery>;
export type findDomainUserLazyQueryHookResult = ReturnType<typeof usefindDomainUserLazyQuery>;
export type findDomainUserSuspenseQueryHookResult = ReturnType<typeof usefindDomainUserSuspenseQuery>;
export type findDomainUserQueryResult = Apollo.QueryResult<findDomainUserQuery, findDomainUserQueryVariables>;
export const GetMyPersonalDataDocument = gql`
    query GetMyPersonalData($id: uuid = "") {
  user(id: $id) {
    id
    firstName
    lastName
    organizationUsers {
      id
      organizationId
    }
    organizations {
      id
      name
      ownerId
    }
  }
}
    `;

/**
 * __useGetMyPersonalDataQuery__
 *
 * To run a query within a React component, call `useGetMyPersonalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyPersonalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyPersonalDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMyPersonalDataQuery(baseOptions?: Apollo.QueryHookOptions<GetMyPersonalDataQuery, GetMyPersonalDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyPersonalDataQuery, GetMyPersonalDataQueryVariables>(GetMyPersonalDataDocument, options);
      }
export function useGetMyPersonalDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyPersonalDataQuery, GetMyPersonalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyPersonalDataQuery, GetMyPersonalDataQueryVariables>(GetMyPersonalDataDocument, options);
        }
export function useGetMyPersonalDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyPersonalDataQuery, GetMyPersonalDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyPersonalDataQuery, GetMyPersonalDataQueryVariables>(GetMyPersonalDataDocument, options);
        }
export type GetMyPersonalDataQueryHookResult = ReturnType<typeof useGetMyPersonalDataQuery>;
export type GetMyPersonalDataLazyQueryHookResult = ReturnType<typeof useGetMyPersonalDataLazyQuery>;
export type GetMyPersonalDataSuspenseQueryHookResult = ReturnType<typeof useGetMyPersonalDataSuspenseQuery>;
export type GetMyPersonalDataQueryResult = Apollo.QueryResult<GetMyPersonalDataQuery, GetMyPersonalDataQueryVariables>;
export const GetQueueItemsForHomeScreenButtonsDocument = gql`
    query GetQueueItemsForHomeScreenButtons($userId: uuid = "", $in: [ActivityStatusEnum!]!, $inType: [String!], $limit: Int, $includeConvos: Boolean = true, $isMine: Boolean = true, $meResponsible: Boolean = true, $offset: Int = 0, $someoneResponsible: Boolean = false) {
  queueItems(
    limit: $limit
    offset: $offset
    where: {status: {_in: $in}, participants: {userId: {_eq: $userId}}, _and: [{_or: [{flexibilityType: {_isNull: $includeConvos}}, {flexibilityType: {_eq: "AGREED"}}, {flexibilityType: {_eq: "OTHER"}}]}, {_or: [{queueParticipants: {organizationUser: {userId: {_eq: $userId}}, _and: [{responsible: {_eq: $meResponsible}}, {owner: {_eq: $isMine}}, {_or: [{owner: {_eq: true}}, {owner: {_eq: false}, responsible: {_eq: true}}, {owner: {_isNull: true}, responsible: {_isNull: true}}]}]}}, {flexibilityType: {_isNull: true}}]}, {_or: [{flexibilityType: {_in: $inType}}, {_and: [{flexibilityType: {_isNull: true}}, {_not: {flexibilityType: {_in: $inType}}}]}, {_and: [{flexibilityType: {_isNull: true}}, {flexibilityType: {_isNull: $includeConvos}}]}]}, {_or: [{queueParticipants: {responsible: {_eq: $someoneResponsible}}}, {_and: [{flexibilityType: {_isNull: true}}, {flexibilityType: {_isNull: $includeConvos}}]}]}]}
    orderBy: {createdAt: DESC}
  ) {
    status
    type
    flexibilityType
    subType
    dueDate
    createdByUserId
    private
    id
    title
    additionalData
    createdByUserId
    subTitle
    createdAt
    updatedAt
    alarms {
      absoluteDate
      alarmSelectionType
    }
    domainUsers {
      id
      firstName
      lastName
      category
      phoneNumber
      updatedAt
      emailAddress
      organizationUser {
        id
        firstName
        lastName
        status
        organizationId
      }
    }
    queueParticipants {
      id
      responsibility
      responsible
      owner
      contact
      organizationUser {
        id
        userId
        firstName
        lastName
        phoneNumber
        role
        company {
          firstName
          id
          lastName
        }
        collaborations {
          from
          private
        }
      }
    }
    domainActivity {
      domain
      id
      provider
      direction
      startedAt
      additionalData
      type
    }
    messages {
      id
      userId
      type
      content
      updatedAt
      user {
        id
        firstName
      }
    }
    organizationUsers {
      id
      role
      userId
      status
      organizationId
    }
  }
}
    `;

/**
 * __useGetQueueItemsForHomeScreenButtonsQuery__
 *
 * To run a query within a React component, call `useGetQueueItemsForHomeScreenButtonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueueItemsForHomeScreenButtonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueueItemsForHomeScreenButtonsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      in: // value for 'in'
 *      inType: // value for 'inType'
 *      limit: // value for 'limit'
 *      includeConvos: // value for 'includeConvos'
 *      isMine: // value for 'isMine'
 *      meResponsible: // value for 'meResponsible'
 *      offset: // value for 'offset'
 *      someoneResponsible: // value for 'someoneResponsible'
 *   },
 * });
 */
export function useGetQueueItemsForHomeScreenButtonsQuery(baseOptions: Apollo.QueryHookOptions<GetQueueItemsForHomeScreenButtonsQuery, GetQueueItemsForHomeScreenButtonsQueryVariables> & ({ variables: GetQueueItemsForHomeScreenButtonsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQueueItemsForHomeScreenButtonsQuery, GetQueueItemsForHomeScreenButtonsQueryVariables>(GetQueueItemsForHomeScreenButtonsDocument, options);
      }
export function useGetQueueItemsForHomeScreenButtonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQueueItemsForHomeScreenButtonsQuery, GetQueueItemsForHomeScreenButtonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQueueItemsForHomeScreenButtonsQuery, GetQueueItemsForHomeScreenButtonsQueryVariables>(GetQueueItemsForHomeScreenButtonsDocument, options);
        }
export function useGetQueueItemsForHomeScreenButtonsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQueueItemsForHomeScreenButtonsQuery, GetQueueItemsForHomeScreenButtonsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQueueItemsForHomeScreenButtonsQuery, GetQueueItemsForHomeScreenButtonsQueryVariables>(GetQueueItemsForHomeScreenButtonsDocument, options);
        }
export type GetQueueItemsForHomeScreenButtonsQueryHookResult = ReturnType<typeof useGetQueueItemsForHomeScreenButtonsQuery>;
export type GetQueueItemsForHomeScreenButtonsLazyQueryHookResult = ReturnType<typeof useGetQueueItemsForHomeScreenButtonsLazyQuery>;
export type GetQueueItemsForHomeScreenButtonsSuspenseQueryHookResult = ReturnType<typeof useGetQueueItemsForHomeScreenButtonsSuspenseQuery>;
export type GetQueueItemsForHomeScreenButtonsQueryResult = Apollo.QueryResult<GetQueueItemsForHomeScreenButtonsQuery, GetQueueItemsForHomeScreenButtonsQueryVariables>;
export const CountTasksDocument = gql`
    query CountTasks($in: [ActivityTypeEnum!]!, $status: [ActivityStatusEnum!]!, $userId: uuid!, $inType: [String!], $meResponsible: Boolean = true, $someoneResponsible: Boolean = true, $includeConvos: Boolean = true, $inDirection: [ActivityDirectionEnum!] = [UNDEFINED], $onlyUnanswered: Boolean = false) {
  queueItemsAggregate(
    where: {status: {_in: $status}, participants: {userId: {_eq: $userId}}, _and: [{_or: [{type: {_in: TASK}}, {domainActivity: {type: {_in: $in}}}]}, {_or: [{flexibilityType: {_isNull: $includeConvos}}, {flexibilityType: {_eq: "AGREED"}}, {flexibilityType: {_eq: "OTHER"}}]}, {_or: [{queueParticipants: {organizationUser: {userId: {_eq: $userId}}, _and: [{responsible: {_eq: $meResponsible}}, {_or: [{owner: {_eq: true}}, {owner: {_eq: false}, responsible: {_eq: true}}, {responsible: {_eq: true}, owner: {_eq: false}}, {responsible: {_eq: true}, owner: {_isNull: true}}]}]}}, {flexibilityType: {_isNull: true}}]}, {_or: [{flexibilityType: {_in: $inType}}, {_and: [{flexibilityType: {_isNull: true}}, {_not: {flexibilityType: {_in: $inType}}}]}, {_and: [{flexibilityType: {_isNull: true}}, {flexibilityType: {_isNull: $includeConvos}}]}]}, {_or: [{queueParticipants: {responsible: {_eq: $someoneResponsible}}}, {_and: [{flexibilityType: {_isNull: true}}, {flexibilityType: {_isNull: $includeConvos}}]}]}, {_or: [{type: {_in: TASK}}, {domainActivity: {direction: {_isNull: true}}}, {_and: [{domainActivity: {direction: {_in: $inDirection}}}, {domainActivity: {startedAt: {_isNull: $onlyUnanswered}}}]}]}]}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useCountTasksQuery__
 *
 * To run a query within a React component, call `useCountTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountTasksQuery({
 *   variables: {
 *      in: // value for 'in'
 *      status: // value for 'status'
 *      userId: // value for 'userId'
 *      inType: // value for 'inType'
 *      meResponsible: // value for 'meResponsible'
 *      someoneResponsible: // value for 'someoneResponsible'
 *      includeConvos: // value for 'includeConvos'
 *      inDirection: // value for 'inDirection'
 *      onlyUnanswered: // value for 'onlyUnanswered'
 *   },
 * });
 */
export function useCountTasksQuery(baseOptions: Apollo.QueryHookOptions<CountTasksQuery, CountTasksQueryVariables> & ({ variables: CountTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountTasksQuery, CountTasksQueryVariables>(CountTasksDocument, options);
      }
export function useCountTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountTasksQuery, CountTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountTasksQuery, CountTasksQueryVariables>(CountTasksDocument, options);
        }
export function useCountTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountTasksQuery, CountTasksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountTasksQuery, CountTasksQueryVariables>(CountTasksDocument, options);
        }
export type CountTasksQueryHookResult = ReturnType<typeof useCountTasksQuery>;
export type CountTasksLazyQueryHookResult = ReturnType<typeof useCountTasksLazyQuery>;
export type CountTasksSuspenseQueryHookResult = ReturnType<typeof useCountTasksSuspenseQuery>;
export type CountTasksQueryResult = Apollo.QueryResult<CountTasksQuery, CountTasksQueryVariables>;
export const GetQueueItemsActivityDocument = gql`
    query GetQueueItemsActivity($userId: uuid = "", $limit: Int, $offset: Int = 0, $in: [ActivityStatusEnum!]!, $inType: [String!], $oldTypes: [ActivityTypeEnum!], $inDirection: [ActivityDirectionEnum!], $includeConvos: Boolean = true, $addDelegated: Boolean = true, $meResponsible: Boolean = true, $includeOldSchool: Boolean = true, $someoneResponsible: Boolean = false, $onlyUnanswered: Boolean = false, $countUnanswered: Boolean = true, $order: [queueItemOrderBy!]) {
  queueItems(
    limit: $limit
    offset: $offset
    where: {status: {_in: $in}, participants: {userId: {_eq: $userId}}, _and: [{_or: [{flexibilityType: {_isNull: $includeConvos}}, {flexibilityType: {_isNull: $includeOldSchool}}, {flexibilityType: {_eq: "AGREED"}}, {flexibilityType: {_eq: "OTHER"}}]}, {_or: [{queueParticipants: {organizationUser: {userId: {_eq: $userId}}, _and: [{_or: [{responsible: {_eq: $meResponsible}}, {responsible: {_eq: $addDelegated}}]}, {_or: [{owner: {_eq: true}}, {owner: {_eq: false}, responsible: {_eq: true}}, {responsible: {_eq: true}, owner: {_eq: false}}, {responsible: {_eq: true}, owner: {_isNull: true}}]}]}}, {flexibilityType: {_isNull: true}}]}, {_or: [{flexibilityType: {_in: $inType}}, {_and: [{flexibilityType: {_isNull: true}}, {_not: {flexibilityType: {_in: $inType}}}]}, {_and: [{flexibilityType: {_isNull: true}}, {flexibilityType: {_isNull: $includeConvos}}]}, {_and: [{flexibilityType: {_isNull: true}}, {flexibilityType: {_isNull: $includeOldSchool}}, {domainActivity: {type: {_in: $oldTypes}}}]}]}, {_or: [{queueParticipants: {responsible: {_eq: $someoneResponsible}}}, {_and: [{flexibilityType: {_isNull: true}}, {flexibilityType: {_isNull: $includeConvos}}]}, {_and: [{flexibilityType: {_isNull: true}}, {flexibilityType: {_isNull: $includeOldSchool}}, {domainActivity: {type: {_in: $oldTypes}}}]}]}, {_or: [{domainActivity: {direction: {_eq: OUTGOING}, startedAt: {_isNull: false}}}, {domainActivity: {direction: {_eq: INCOMING}, startedAt: {_isNull: false}}}, {_and: [{domainActivity: {direction: {_eq: INCOMING}}}, {domainActivity: {startedAt: {_isNull: true}}}, {domainActivity: {startedAt: {_isNull: $countUnanswered}}}]}, {_and: [{flexibilityType: {_in: $inType}}, {flexibilityType: {_isNull: $includeConvos}}]}]}, {_or: [{domainActivity: {direction: {_in: $inDirection}}}, {domainActivity: {direction: {_isNull: true}}}, {_and: [{flexibilityType: {_in: $inType}}, {flexibilityType: {_isNull: $includeConvos}}]}, {_and: [{flexibilityType: {_isNull: true}}, {flexibilityType: {_isNull: $includeOldSchool}}, {domainActivity: {type: {_in: $oldTypes}}}]}]}, {_or: [{_and: [{flexibilityType: {_in: $inType}}, {flexibilityType: {_isNull: $includeConvos}}]}, {_and: [{domainActivity: {direction: {_eq: INCOMING}}}, {domainActivity: {startedAt: {_isNull: $onlyUnanswered}}}]}, {domainActivity: {direction: {_in: $inDirection}}}, {_and: [{flexibilityType: {_isNull: true}}, {flexibilityType: {_isNull: $includeOldSchool}}, {domainActivity: {type: {_in: $oldTypes}}}]}]}]}
    orderBy: $order
  ) {
    status
    type
    flexibilityType
    subType
    dueDate
    createdByUserId
    private
    id
    title
    additionalData
    createdByUserId
    subTitle
    createdAt
    updatedAt
    alarms {
      absoluteDate
      alarmSelectionType
    }
    domainUsers {
      id
      firstName
      lastName
      category
      phoneNumber
      updatedAt
      emailAddress
      spamScore
      organizationUser {
        id
        firstName
        lastName
        status
        organizationId
        userId
        company {
          firstName
          id
          lastName
        }
        collaborations {
          from
          private
        }
      }
    }
    queueParticipants {
      id
      responsibility
      responsible
      owner
      contact
      organizationUser {
        id
        userId
        firstName
        lastName
        phoneNumber
        role
        company {
          firstName
          id
          lastName
        }
        collaborations {
          from
          private
        }
      }
    }
    domainActivity {
      domain
      id
      provider
      direction
      startedAt
      additionalData
      type
    }
    messages {
      id
      userId
      type
      content
      updatedAt
      user {
        id
        firstName
      }
    }
    organizationUsers {
      company {
        firstName
        id
        lastName
      }
      id
      role
      userId
      status
      organizationId
    }
  }
}
    `;

/**
 * __useGetQueueItemsActivityQuery__
 *
 * To run a query within a React component, call `useGetQueueItemsActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueueItemsActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueueItemsActivityQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      in: // value for 'in'
 *      inType: // value for 'inType'
 *      oldTypes: // value for 'oldTypes'
 *      inDirection: // value for 'inDirection'
 *      includeConvos: // value for 'includeConvos'
 *      addDelegated: // value for 'addDelegated'
 *      meResponsible: // value for 'meResponsible'
 *      includeOldSchool: // value for 'includeOldSchool'
 *      someoneResponsible: // value for 'someoneResponsible'
 *      onlyUnanswered: // value for 'onlyUnanswered'
 *      countUnanswered: // value for 'countUnanswered'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetQueueItemsActivityQuery(baseOptions: Apollo.QueryHookOptions<GetQueueItemsActivityQuery, GetQueueItemsActivityQueryVariables> & ({ variables: GetQueueItemsActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQueueItemsActivityQuery, GetQueueItemsActivityQueryVariables>(GetQueueItemsActivityDocument, options);
      }
export function useGetQueueItemsActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQueueItemsActivityQuery, GetQueueItemsActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQueueItemsActivityQuery, GetQueueItemsActivityQueryVariables>(GetQueueItemsActivityDocument, options);
        }
export function useGetQueueItemsActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQueueItemsActivityQuery, GetQueueItemsActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQueueItemsActivityQuery, GetQueueItemsActivityQueryVariables>(GetQueueItemsActivityDocument, options);
        }
export type GetQueueItemsActivityQueryHookResult = ReturnType<typeof useGetQueueItemsActivityQuery>;
export type GetQueueItemsActivityLazyQueryHookResult = ReturnType<typeof useGetQueueItemsActivityLazyQuery>;
export type GetQueueItemsActivitySuspenseQueryHookResult = ReturnType<typeof useGetQueueItemsActivitySuspenseQuery>;
export type GetQueueItemsActivityQueryResult = Apollo.QueryResult<GetQueueItemsActivityQuery, GetQueueItemsActivityQueryVariables>;
export const MyLastMessageDocument = gql`
    query MyLastMessage($organizationUserId: [uuid!] = "") {
  messages(
    where: {activity: {queueItem: {organizationUsers: {id: {_in: $organizationUserId}}, private: {_eq: false}}}}
    limit: 1
    orderBy: {createdAt: DESC}
  ) {
    id
    content
    createdAt
    updatedAt
    userId
    user {
      id
      firstName
      phoneState
      lastName
    }
    activity {
      queueItem {
        id
        createdAt
        updatedAt
        type
        subType
        flexibilityType
        title
        subTitle
        status
        owner_organization_user {
          id
          firstName
          lastName
          role
          userId
          phoneNumber
          user {
            id
            phoneState
          }
          organization {
            id
          }
          company {
            id
            firstName
          }
        }
        participants {
          id
          phoneNumber
          firstName
          lastName
          role
        }
        domainUsers {
          id
          phoneNumber
          firstName
          lastName
        }
        organizationUsers {
          id
          firstName
          lastName
          role
          userId
          phoneNumber
          user {
            id
            phoneState
          }
          organization {
            id
          }
          company {
            id
            firstName
          }
        }
        domainActivity {
          id
          domain
          direction
          provider
          startedAt
          owner {
            relOrganizationUser {
              organizationUserId
            }
          }
          domainParticipants {
            domainUser {
              id
              phoneNumber
              firstName
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMyLastMessageQuery__
 *
 * To run a query within a React component, call `useMyLastMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyLastMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyLastMessageQuery({
 *   variables: {
 *      organizationUserId: // value for 'organizationUserId'
 *   },
 * });
 */
export function useMyLastMessageQuery(baseOptions?: Apollo.QueryHookOptions<MyLastMessageQuery, MyLastMessageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyLastMessageQuery, MyLastMessageQueryVariables>(MyLastMessageDocument, options);
      }
export function useMyLastMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyLastMessageQuery, MyLastMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyLastMessageQuery, MyLastMessageQueryVariables>(MyLastMessageDocument, options);
        }
export function useMyLastMessageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyLastMessageQuery, MyLastMessageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyLastMessageQuery, MyLastMessageQueryVariables>(MyLastMessageDocument, options);
        }
export type MyLastMessageQueryHookResult = ReturnType<typeof useMyLastMessageQuery>;
export type MyLastMessageLazyQueryHookResult = ReturnType<typeof useMyLastMessageLazyQuery>;
export type MyLastMessageSuspenseQueryHookResult = ReturnType<typeof useMyLastMessageSuspenseQuery>;
export type MyLastMessageQueryResult = Apollo.QueryResult<MyLastMessageQuery, MyLastMessageQueryVariables>;
export const FetchContactQueueItemsDocument = gql`
    query FetchContactQueueItems($organizationUserId: [uuid!] = "", $offset: Int = 0, $status: ActivityStatusEnum, $limit: Int = 1) {
  queueItems(
    limit: $limit
    offset: $offset
    where: {private: {_eq: false}, domainUsers: {organizationUser: {id: {_in: $organizationUserId}}}, status: {_eq: $status}}
    orderBy: {createdAt: DESC}
  ) {
    id
    createdAt
    updatedAt
    type
    subType
    flexibilityType
    title
    subTitle
    status
    owner_organization_user {
      id
      firstName
      lastName
      role
      userId
      phoneNumber
      user {
        id
        phoneState
      }
      organization {
        id
      }
      company {
        id
        firstName
      }
    }
    participants {
      id
      phoneNumber
      firstName
      lastName
      role
    }
    domainUsers {
      id
      phoneNumber
      firstName
      lastName
    }
    domainActivity {
      id
      domain
      direction
      provider
      startedAt
      owner {
        relOrganizationUser {
          organizationUserId
        }
      }
      domainParticipants {
        domainUser {
          id
          phoneNumber
          firstName
        }
      }
    }
    organizationUsers {
      id
      firstName
      lastName
      role
      userId
      phoneNumber
      user {
        id
        phoneState
      }
      organization {
        id
      }
      company {
        id
        firstName
      }
    }
    messages {
      id
      content
      createdAt
      updatedAt
      userId
      user {
        id
        firstName
        phoneState
        lastName
      }
    }
  }
}
    `;

/**
 * __useFetchContactQueueItemsQuery__
 *
 * To run a query within a React component, call `useFetchContactQueueItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchContactQueueItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchContactQueueItemsQuery({
 *   variables: {
 *      organizationUserId: // value for 'organizationUserId'
 *      offset: // value for 'offset'
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFetchContactQueueItemsQuery(baseOptions?: Apollo.QueryHookOptions<FetchContactQueueItemsQuery, FetchContactQueueItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchContactQueueItemsQuery, FetchContactQueueItemsQueryVariables>(FetchContactQueueItemsDocument, options);
      }
export function useFetchContactQueueItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchContactQueueItemsQuery, FetchContactQueueItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchContactQueueItemsQuery, FetchContactQueueItemsQueryVariables>(FetchContactQueueItemsDocument, options);
        }
export function useFetchContactQueueItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchContactQueueItemsQuery, FetchContactQueueItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchContactQueueItemsQuery, FetchContactQueueItemsQueryVariables>(FetchContactQueueItemsDocument, options);
        }
export type FetchContactQueueItemsQueryHookResult = ReturnType<typeof useFetchContactQueueItemsQuery>;
export type FetchContactQueueItemsLazyQueryHookResult = ReturnType<typeof useFetchContactQueueItemsLazyQuery>;
export type FetchContactQueueItemsSuspenseQueryHookResult = ReturnType<typeof useFetchContactQueueItemsSuspenseQuery>;
export type FetchContactQueueItemsQueryResult = Apollo.QueryResult<FetchContactQueueItemsQuery, FetchContactQueueItemsQueryVariables>;
export const FetchContactTaskQueueItemsDocument = gql`
    query FetchContactTaskQueueItems($organizationUserId: [uuid!] = "", $offset: Int = 0, $limit: Int = 1, $status: ActivityStatusEnum = ASSIGNED) {
  queueItems(
    limit: $limit
    offset: $offset
    where: {private: {_eq: false}, participants: {id: {_in: $organizationUserId}}, status: {_eq: $status}}
    orderBy: {createdAt: DESC}
  ) {
    id
    createdAt
    updatedAt
    type
    subType
    flexibilityType
    title
    subTitle
    status
    owner_organization_user {
      id
      firstName
      lastName
      role
      userId
      phoneNumber
      user {
        id
        phoneState
      }
      organization {
        id
      }
      company {
        id
        firstName
      }
    }
    participants {
      id
      phoneNumber
      firstName
      lastName
      role
    }
    domainActivity {
      id
      domain
      direction
      provider
      startedAt
      owner {
        relOrganizationUser {
          organizationUserId
        }
      }
      domainParticipants {
        domainUser {
          id
          phoneNumber
          firstName
        }
      }
    }
    organizationUsers {
      id
      firstName
      lastName
      role
      userId
      phoneNumber
      user {
        id
        phoneState
      }
      organization {
        id
      }
      company {
        id
        firstName
      }
    }
    messages {
      id
      content
      createdAt
      updatedAt
      userId
      user {
        id
        firstName
        phoneState
        lastName
      }
    }
  }
}
    `;

/**
 * __useFetchContactTaskQueueItemsQuery__
 *
 * To run a query within a React component, call `useFetchContactTaskQueueItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchContactTaskQueueItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchContactTaskQueueItemsQuery({
 *   variables: {
 *      organizationUserId: // value for 'organizationUserId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useFetchContactTaskQueueItemsQuery(baseOptions?: Apollo.QueryHookOptions<FetchContactTaskQueueItemsQuery, FetchContactTaskQueueItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchContactTaskQueueItemsQuery, FetchContactTaskQueueItemsQueryVariables>(FetchContactTaskQueueItemsDocument, options);
      }
export function useFetchContactTaskQueueItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchContactTaskQueueItemsQuery, FetchContactTaskQueueItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchContactTaskQueueItemsQuery, FetchContactTaskQueueItemsQueryVariables>(FetchContactTaskQueueItemsDocument, options);
        }
export function useFetchContactTaskQueueItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchContactTaskQueueItemsQuery, FetchContactTaskQueueItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchContactTaskQueueItemsQuery, FetchContactTaskQueueItemsQueryVariables>(FetchContactTaskQueueItemsDocument, options);
        }
export type FetchContactTaskQueueItemsQueryHookResult = ReturnType<typeof useFetchContactTaskQueueItemsQuery>;
export type FetchContactTaskQueueItemsLazyQueryHookResult = ReturnType<typeof useFetchContactTaskQueueItemsLazyQuery>;
export type FetchContactTaskQueueItemsSuspenseQueryHookResult = ReturnType<typeof useFetchContactTaskQueueItemsSuspenseQuery>;
export type FetchContactTaskQueueItemsQueryResult = Apollo.QueryResult<FetchContactTaskQueueItemsQuery, FetchContactTaskQueueItemsQueryVariables>;
export const GetAttentionNoteDocument = gql`
    query GetAttentionNote($organizationUserId: uuid = "") {
  organizationUserAttentionNotes(
    where: {createdOnUser: {_eq: $organizationUserId}}
  ) {
    id
    note
    createdAt
    updatedAt
    creator {
      id
      userId
      firstName
      lastName
    }
    subjectUser {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useGetAttentionNoteQuery__
 *
 * To run a query within a React component, call `useGetAttentionNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttentionNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttentionNoteQuery({
 *   variables: {
 *      organizationUserId: // value for 'organizationUserId'
 *   },
 * });
 */
export function useGetAttentionNoteQuery(baseOptions?: Apollo.QueryHookOptions<GetAttentionNoteQuery, GetAttentionNoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttentionNoteQuery, GetAttentionNoteQueryVariables>(GetAttentionNoteDocument, options);
      }
export function useGetAttentionNoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttentionNoteQuery, GetAttentionNoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttentionNoteQuery, GetAttentionNoteQueryVariables>(GetAttentionNoteDocument, options);
        }
export function useGetAttentionNoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAttentionNoteQuery, GetAttentionNoteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAttentionNoteQuery, GetAttentionNoteQueryVariables>(GetAttentionNoteDocument, options);
        }
export type GetAttentionNoteQueryHookResult = ReturnType<typeof useGetAttentionNoteQuery>;
export type GetAttentionNoteLazyQueryHookResult = ReturnType<typeof useGetAttentionNoteLazyQuery>;
export type GetAttentionNoteSuspenseQueryHookResult = ReturnType<typeof useGetAttentionNoteSuspenseQuery>;
export type GetAttentionNoteQueryResult = Apollo.QueryResult<GetAttentionNoteQuery, GetAttentionNoteQueryVariables>;
export const GetQueueItemCollaborationDocument = gql`
    query GetQueueItemCollaboration {
  businessQueueItemCollaborations(orderBy: {updatedAt: DESC}, limit: 1) {
    updatedAt
    customerUserId
    id
  }
}
    `;

/**
 * __useGetQueueItemCollaborationQuery__
 *
 * To run a query within a React component, call `useGetQueueItemCollaborationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueueItemCollaborationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueueItemCollaborationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQueueItemCollaborationQuery(baseOptions?: Apollo.QueryHookOptions<GetQueueItemCollaborationQuery, GetQueueItemCollaborationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQueueItemCollaborationQuery, GetQueueItemCollaborationQueryVariables>(GetQueueItemCollaborationDocument, options);
      }
export function useGetQueueItemCollaborationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQueueItemCollaborationQuery, GetQueueItemCollaborationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQueueItemCollaborationQuery, GetQueueItemCollaborationQueryVariables>(GetQueueItemCollaborationDocument, options);
        }
export function useGetQueueItemCollaborationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQueueItemCollaborationQuery, GetQueueItemCollaborationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQueueItemCollaborationQuery, GetQueueItemCollaborationQueryVariables>(GetQueueItemCollaborationDocument, options);
        }
export type GetQueueItemCollaborationQueryHookResult = ReturnType<typeof useGetQueueItemCollaborationQuery>;
export type GetQueueItemCollaborationLazyQueryHookResult = ReturnType<typeof useGetQueueItemCollaborationLazyQuery>;
export type GetQueueItemCollaborationSuspenseQueryHookResult = ReturnType<typeof useGetQueueItemCollaborationSuspenseQuery>;
export type GetQueueItemCollaborationQueryResult = Apollo.QueryResult<GetQueueItemCollaborationQuery, GetQueueItemCollaborationQueryVariables>;
export const ActivitiesDocument = gql`
    subscription Activities($userId: uuid = "", $limit: Int = 10, $_in: [ActivityStatusEnum!] = ASSIGNED) {
  queueItems(
    where: {participants: {userId: {_eq: $userId}}, _and: {status: {_in: $_in}}}
    limit: $limit
    orderBy: {createdAt: DESC}
  ) {
    id
    status
    createdAt
    updatedAt
    domainUsers {
      id
      firstName
      lastName
      category
      phoneNumber
      emailAddress
      organizationUser {
        id
        firstName
        lastName
      }
    }
    domainActivity {
      id
    }
  }
}
    `;

/**
 * __useActivitiesSubscription__
 *
 * To run a query within a React component, call `useActivitiesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useActivitiesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivitiesSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *      limit: // value for 'limit'
 *      _in: // value for '_in'
 *   },
 * });
 */
export function useActivitiesSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ActivitiesSubscription, ActivitiesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ActivitiesSubscription, ActivitiesSubscriptionVariables>(ActivitiesDocument, options);
      }
export type ActivitiesSubscriptionHookResult = ReturnType<typeof useActivitiesSubscription>;
export type ActivitiesSubscriptionResult = Apollo.SubscriptionResult<ActivitiesSubscription>;
export const GetNewActivityQueueItemsDocument = gql`
    subscription GetNewActivityQueueItems($userId: uuid = "", $date: timestamptz!) {
  queueItems(
    where: {_or: [{messages: {updatedAt: {_gt: $date}}}, {updatedAt: {_gt: $date}}, {domainUsers: {updatedAt: {_gt: $date}}}], participants: {userId: {_eq: $userId}}}
    orderBy: {dueDate: ASC_NULLS_LAST, createdAt: DESC}
  ) {
    status
    type
    flexibilityType
    subType
    dueDate
    createdByUserId
    private
    id
    title
    additionalData
    createdByUserId
    subTitle
    createdAt
    updatedAt
    alarms {
      absoluteDate
      alarmSelectionType
    }
    domainUsers {
      id
      firstName
      lastName
      category
      phoneNumber
      updatedAt
      emailAddress
      organizationUser {
        id
        firstName
        lastName
        status
        organizationId
      }
    }
    queueParticipants {
      id
      responsibility
      responsible
      owner
      contact
      organizationUser {
        id
        userId
        firstName
        lastName
        phoneNumber
        role
        company {
          firstName
          id
          lastName
        }
        collaborations {
          from
          private
        }
      }
    }
    domainActivity {
      domain
      id
      provider
      direction
      startedAt
      additionalData
      type
    }
    messages {
      id
      userId
      type
      content
      updatedAt
      user {
        id
        firstName
      }
    }
    organizationUsers {
      id
      role
      userId
      status
      organizationId
    }
  }
}
    `;

/**
 * __useGetNewActivityQueueItemsSubscription__
 *
 * To run a query within a React component, call `useGetNewActivityQueueItemsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetNewActivityQueueItemsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewActivityQueueItemsSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetNewActivityQueueItemsSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetNewActivityQueueItemsSubscription, GetNewActivityQueueItemsSubscriptionVariables> & ({ variables: GetNewActivityQueueItemsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetNewActivityQueueItemsSubscription, GetNewActivityQueueItemsSubscriptionVariables>(GetNewActivityQueueItemsDocument, options);
      }
export type GetNewActivityQueueItemsSubscriptionHookResult = ReturnType<typeof useGetNewActivityQueueItemsSubscription>;
export type GetNewActivityQueueItemsSubscriptionResult = Apollo.SubscriptionResult<GetNewActivityQueueItemsSubscription>;